(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.THREE = global.THREE || {})));
}(this, (function (exports) { 'use strict';

	// Polyfills

	if ( Number.EPSILON === undefined ) {

		Number.EPSILON = Math.pow( 2, - 52 );

	}

	if ( Number.isInteger === undefined ) {

		// Missing in IE
		// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger

		Number.isInteger = function ( value ) {

			return typeof value === 'number' && isFinite( value ) && Math.floor( value ) === value;

		};

	}

	//

	if ( Math.sign === undefined ) {

		// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign

		Math.sign = function ( x ) {

			return ( x < 0 ) ? - 1 : ( x > 0 ) ? 1 : + x;

		};

	}

	if ( Function.prototype.name === undefined ) {

		// Missing in IE
		// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/name

		Object.defineProperty( Function.prototype, 'name', {

			get: function () {

				return this.toString().match( /^\s*function\s*([^\(\s]*)/ )[ 1 ];

			}

		} );

	}

	if ( Object.assign === undefined ) {

		// Missing in IE
		// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign

		( function () {

			Object.assign = function ( target ) {

				'use strict';

				if ( target === undefined || target === null ) {

					throw new TypeError( 'Cannot convert undefined or null to object' );

				}

				var output = Object( target );

				for ( var index = 1; index < arguments.length; index ++ ) {

					var source = arguments[ index ];

					if ( source !== undefined && source !== null ) {

						for ( var nextKey in source ) {

							if ( Object.prototype.hasOwnProperty.call( source, nextKey ) ) {

								output[ nextKey ] = source[ nextKey ];

							}

						}

					}

				}

				return output;

			};

		} )();

	}

	/**
	 * https://github.com/mrdoob/eventdispatcher.js/
	 */

	function EventDispatcher() {}

	Object.assign( EventDispatcher.prototype, {

		addEventListener: function ( type, listener ) {

			if ( this._listeners === undefined ) this._listeners = {};

			var listeners = this._listeners;

			if ( listeners[ type ] === undefined ) {

				listeners[ type ] = [];

			}

			if ( listeners[ type ].indexOf( listener ) === - 1 ) {

				listeners[ type ].push( listener );

			}

		},

		hasEventListener: function ( type, listener ) {

			if ( this._listeners === undefined ) return false;

			var listeners = this._listeners;

			return listeners[ type ] !== undefined && listeners[ type ].indexOf( listener ) !== - 1;

		},

		removeEventListener: function ( type, listener ) {

			if ( this._listeners === undefined ) return;

			var listeners = this._listeners;
			var listenerArray = listeners[ type ];

			if ( listenerArray !== undefined ) {

				var index = listenerArray.indexOf( listener );

				if ( index !== - 1 ) {

					listenerArray.splice( index, 1 );

				}

			}

		},

		dispatchEvent: function ( event ) {

			if ( this._listeners === undefined ) return;

			var listeners = this._listeners;
			var listenerArray = listeners[ event.type ];

			if ( listenerArray !== undefined ) {

				event.target = this;

				var array = listenerArray.slice( 0 );

				for ( var i = 0, l = array.length; i < l; i ++ ) {

					array[ i ].call( this, event );

				}

			}

		}

	} );

	var REVISION = '87';
	var MOUSE = { LEFT: 0, MIDDLE: 1, RIGHT: 2 };
	var CullFaceNone = 0;
	var CullFaceBack = 1;
	var CullFaceFront = 2;
	var CullFaceFrontBack = 3;
	var FrontFaceDirectionCW = 0;
	var FrontFaceDirectionCCW = 1;
	var BasicShadowMap = 0;
	var PCFShadowMap = 1;
	var PCFSoftShadowMap = 2;
	var FrontSide = 0;
	var BackSide = 1;
	var DoubleSide = 2;
	var FlatShading = 1;
	var SmoothShading = 2;
	var NoColors = 0;
	var FaceColors = 1;
	var VertexColors = 2;
	var NoBlending = 0;
	var NormalBlending = 1;
	var AdditiveBlending = 2;
	var SubtractiveBlending = 3;
	var MultiplyBlending = 4;
	var CustomBlending = 5;
	var AddEquation = 100;
	var SubtractEquation = 101;
	var ReverseSubtractEquation = 102;
	var MinEquation = 103;
	var MaxEquation = 104;
	var ZeroFactor = 200;
	var OneFactor = 201;
	var SrcColorFactor = 202;
	var OneMinusSrcColorFactor = 203;
	var SrcAlphaFactor = 204;
	var OneMinusSrcAlphaFactor = 205;
	var DstAlphaFactor = 206;
	var OneMinusDstAlphaFactor = 207;
	var DstColorFactor = 208;
	var OneMinusDstColorFactor = 209;
	var SrcAlphaSaturateFactor = 210;
	var NeverDepth = 0;
	var AlwaysDepth = 1;
	var LessDepth = 2;
	var LessEqualDepth = 3;
	var EqualDepth = 4;
	var GreaterEqualDepth = 5;
	var GreaterDepth = 6;
	var NotEqualDepth = 7;
	var MultiplyOperation = 0;
	var MixOperation = 1;
	var AddOperation = 2;
	var NoToneMapping = 0;
	var LinearToneMapping = 1;
	var ReinhardToneMapping = 2;
	var Uncharted2ToneMapping = 3;
	var CineonToneMapping = 4;
	var UVMapping = 300;
	var CubeReflectionMapping = 301;
	var CubeRefractionMapping = 302;
	var EquirectangularReflectionMapping = 303;
	var EquirectangularRefractionMapping = 304;
	var SphericalReflectionMapping = 305;
	var CubeUVReflectionMapping = 306;
	var CubeUVRefractionMapping = 307;
	var RepeatWrapping = 1000;
	var ClampToEdgeWrapping = 1001;
	var MirroredRepeatWrapping = 1002;
	var NearestFilter = 1003;
	var NearestMipMapNearestFilter = 1004;
	var NearestMipMapLinearFilter = 1005;
	var LinearFilter = 1006;
	var LinearMipMapNearestFilter = 1007;
	var LinearMipMapLinearFilter = 1008;
	var UnsignedByteType = 1009;
	var ByteType = 1010;
	var ShortType = 1011;
	var UnsignedShortType = 1012;
	var IntType = 1013;
	var UnsignedIntType = 1014;
	var FloatType = 1015;
	var HalfFloatType = 1016;
	var UnsignedShort4444Type = 1017;
	var UnsignedShort5551Type = 1018;
	var UnsignedShort565Type = 1019;
	var UnsignedInt248Type = 1020;
	var AlphaFormat = 1021;
	var RGBFormat = 1022;
	var RGBAFormat = 1023;
	var LuminanceFormat = 1024;
	var LuminanceAlphaFormat = 1025;
	var RGBEFormat = RGBAFormat;
	var DepthFormat = 1026;
	var DepthStencilFormat = 1027;
	var RGB_S3TC_DXT1_Format = 2001;
	var RGBA_S3TC_DXT1_Format = 2002;
	var RGBA_S3TC_DXT3_Format = 2003;
	var RGBA_S3TC_DXT5_Format = 2004;
	var RGB_PVRTC_4BPPV1_Format = 2100;
	var RGB_PVRTC_2BPPV1_Format = 2101;
	var RGBA_PVRTC_4BPPV1_Format = 2102;
	var RGBA_PVRTC_2BPPV1_Format = 2103;
	var RGB_ETC1_Format = 2151;
	var LoopOnce = 2200;
	var LoopRepeat = 2201;
	var LoopPingPong = 2202;
	var InterpolateDiscrete = 2300;
	var InterpolateLinear = 2301;
	var InterpolateSmooth = 2302;
	var ZeroCurvatureEnding = 2400;
	var ZeroSlopeEnding = 2401;
	var WrapAroundEnding = 2402;
	var TrianglesDrawMode = 0;
	var TriangleStripDrawMode = 1;
	var TriangleFanDrawMode = 2;
	var LinearEncoding = 3000;
	var sRGBEncoding = 3001;
	var GammaEncoding = 3007;
	var RGBEEncoding = 3002;
	var LogLuvEncoding = 3003;
	var RGBM7Encoding = 3004;
	var RGBM16Encoding = 3005;
	var RGBDEncoding = 3006;
	var BasicDepthPacking = 3200;
	var RGBADepthPacking = 3201;

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author mrdoob / http://mrdoob.com/
	 */

	var _Math = {

		DEG2RAD: Math.PI / 180,
		RAD2DEG: 180 / Math.PI,

		generateUUID: function () {

			// http://www.broofa.com/Tools/Math.uuid.htm

			var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split( '' );
			var uuid = new Array( 36 );
			var rnd = 0, r;

			return function generateUUID() {

				for ( var i = 0; i < 36; i ++ ) {

					if ( i === 8 || i === 13 || i === 18 || i === 23 ) {

						uuid[ i ] = '-';

					} else if ( i === 14 ) {

						uuid[ i ] = '4';

					} else {

						if ( rnd <= 0x02 ) rnd = 0x2000000 + ( Math.random() * 0x1000000 ) | 0;
						r = rnd & 0xf;
						rnd = rnd >> 4;
						uuid[ i ] = chars[ ( i === 19 ) ? ( r & 0x3 ) | 0x8 : r ];

					}

				}

				return uuid.join( '' );

			};

		}(),

		clamp: function ( value, min, max ) {

			return Math.max( min, Math.min( max, value ) );

		},

		// compute euclidian modulo of m % n
		// https://en.wikipedia.org/wiki/Modulo_operation

		euclideanModulo: function ( n, m ) {

			return ( ( n % m ) + m ) % m;

		},

		// Linear mapping from range <a1, a2> to range <b1, b2>

		mapLinear: function ( x, a1, a2, b1, b2 ) {

			return b1 + ( x - a1 ) * ( b2 - b1 ) / ( a2 - a1 );

		},

		// https://en.wikipedia.org/wiki/Linear_interpolation

		lerp: function ( x, y, t ) {

			return ( 1 - t ) * x + t * y;

		},

		// http://en.wikipedia.org/wiki/Smoothstep

		smoothstep: function ( x, min, max ) {

			if ( x <= min ) return 0;
			if ( x >= max ) return 1;

			x = ( x - min ) / ( max - min );

			return x * x * ( 3 - 2 * x );

		},

		smootherstep: function ( x, min, max ) {

			if ( x <= min ) return 0;
			if ( x >= max ) return 1;

			x = ( x - min ) / ( max - min );

			return x * x * x * ( x * ( x * 6 - 15 ) + 10 );

		},

		// Random integer from <low, high> interval

		randInt: function ( low, high ) {

			return low + Math.floor( Math.random() * ( high - low + 1 ) );

		},

		// Random float from <low, high> interval

		randFloat: function ( low, high ) {

			return low + Math.random() * ( high - low );

		},

		// Random float from <-range/2, range/2> interval

		randFloatSpread: function ( range ) {

			return range * ( 0.5 - Math.random() );

		},

		degToRad: function ( degrees ) {

			return degrees * _Math.DEG2RAD;

		},

		radToDeg: function ( radians ) {

			return radians * _Math.RAD2DEG;

		},

		isPowerOfTwo: function ( value ) {

			return ( value & ( value - 1 ) ) === 0 && value !== 0;

		},

		nearestPowerOfTwo: function ( value ) {

			return Math.pow( 2, Math.round( Math.log( value ) / Math.LN2 ) );

		},

		nextPowerOfTwo: function ( value ) {

			value --;
			value |= value >> 1;
			value |= value >> 2;
			value |= value >> 4;
			value |= value >> 8;
			value |= value >> 16;
			value ++;

			return value;

		}

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author philogb / http://blog.thejit.org/
	 * @author egraether / http://egraether.com/
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 */

	function Vector2( x, y ) {

		this.x = x || 0;
		this.y = y || 0;

	}

	Object.defineProperties( Vector2.prototype, {

		"width" : {

			get: function () {

				return this.x;

			},

			set: function ( value ) {

				this.x = value;

			}

		},

		"height" : {

			get: function () {

				return this.y;

			},

			set: function ( value ) {

				this.y = value;

			}

		}

	} );

	Object.assign( Vector2.prototype, {

		isVector2: true,

		set: function ( x, y ) {

			this.x = x;
			this.y = y;

			return this;

		},

		setScalar: function ( scalar ) {

			this.x = scalar;
			this.y = scalar;

			return this;

		},

		setX: function ( x ) {

			this.x = x;

			return this;

		},

		setY: function ( y ) {

			this.y = y;

			return this;

		},

		setComponent: function ( index, value ) {

			switch ( index ) {

				case 0: this.x = value; break;
				case 1: this.y = value; break;
				default: throw new Error( 'index is out of range: ' + index );

			}

			return this;

		},

		getComponent: function ( index ) {

			switch ( index ) {

				case 0: return this.x;
				case 1: return this.y;
				default: throw new Error( 'index is out of range: ' + index );

			}

		},

		clone: function () {

			return new this.constructor( this.x, this.y );

		},

		copy: function ( v ) {

			this.x = v.x;
			this.y = v.y;

			return this;

		},

		add: function ( v, w ) {

			if ( w !== undefined ) {

				console.warn( 'THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
				return this.addVectors( v, w );

			}

			this.x += v.x;
			this.y += v.y;

			return this;

		},

		addScalar: function ( s ) {

			this.x += s;
			this.y += s;

			return this;

		},

		addVectors: function ( a, b ) {

			this.x = a.x + b.x;
			this.y = a.y + b.y;

			return this;

		},

		addScaledVector: function ( v, s ) {

			this.x += v.x * s;
			this.y += v.y * s;

			return this;

		},

		sub: function ( v, w ) {

			if ( w !== undefined ) {

				console.warn( 'THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.' );
				return this.subVectors( v, w );

			}

			this.x -= v.x;
			this.y -= v.y;

			return this;

		},

		subScalar: function ( s ) {

			this.x -= s;
			this.y -= s;

			return this;

		},

		subVectors: function ( a, b ) {

			this.x = a.x - b.x;
			this.y = a.y - b.y;

			return this;

		},

		multiply: function ( v ) {

			this.x *= v.x;
			this.y *= v.y;

			return this;

		},

		multiplyScalar: function ( scalar ) {

			this.x *= scalar;
			this.y *= scalar;

			return this;

		},

		divide: function ( v ) {

			this.x /= v.x;
			this.y /= v.y;

			return this;

		},

		divideScalar: function ( scalar ) {

			return this.multiplyScalar( 1 / scalar );

		},

		min: function ( v ) {

			this.x = Math.min( this.x, v.x );
			this.y = Math.min( this.y, v.y );

			return this;

		},

		max: function ( v ) {

			this.x = Math.max( this.x, v.x );
			this.y = Math.max( this.y, v.y );

			return this;

		},

		clamp: function ( min, max ) {

			// assumes min < max, componentwise

			this.x = Math.max( min.x, Math.min( max.x, this.x ) );
			this.y = Math.max( min.y, Math.min( max.y, this.y ) );

			return this;

		},

		clampScalar: function () {

			var min = new Vector2();
			var max = new Vector2();

			return function clampScalar( minVal, maxVal ) {

				min.set( minVal, minVal );
				max.set( maxVal, maxVal );

				return this.clamp( min, max );

			};

		}(),

		clampLength: function ( min, max ) {

			var length = this.length();

			return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );

		},

		floor: function () {

			this.x = Math.floor( this.x );
			this.y = Math.floor( this.y );

			return this;

		},

		ceil: function () {

			this.x = Math.ceil( this.x );
			this.y = Math.ceil( this.y );

			return this;

		},

		round: function () {

			this.x = Math.round( this.x );
			this.y = Math.round( this.y );

			return this;

		},

		roundToZero: function () {

			this.x = ( this.x < 0 ) ? Math.ceil( this.x ) : Math.floor( this.x );
			this.y = ( this.y < 0 ) ? Math.ceil( this.y ) : Math.floor( this.y );

			return this;

		},

		negate: function () {

			this.x = - this.x;
			this.y = - this.y;

			return this;

		},

		dot: function ( v ) {

			return this.x * v.x + this.y * v.y;

		},

		lengthSq: function () {

			return this.x * this.x + this.y * this.y;

		},

		length: function () {

			return Math.sqrt( this.x * this.x + this.y * this.y );

		},

		lengthManhattan: function() {

			return Math.abs( this.x ) + Math.abs( this.y );

		},

		normalize: function () {

			return this.divideScalar( this.length() || 1 );

		},

		angle: function () {

			// computes the angle in radians with respect to the positive x-axis

			var angle = Math.atan2( this.y, this.x );

			if ( angle < 0 ) angle += 2 * Math.PI;

			return angle;

		},

		distanceTo: function ( v ) {

			return Math.sqrt( this.distanceToSquared( v ) );

		},

		distanceToSquared: function ( v ) {

			var dx = this.x - v.x, dy = this.y - v.y;
			return dx * dx + dy * dy;

		},

		distanceToManhattan: function ( v ) {

			return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y );

		},

		setLength: function ( length ) {

			return this.normalize().multiplyScalar( length );

		},

		lerp: function ( v, alpha ) {

			this.x += ( v.x - this.x ) * alpha;
			this.y += ( v.y - this.y ) * alpha;

			return this;

		},

		lerpVectors: function ( v1, v2, alpha ) {

			return this.subVectors( v2, v1 ).multiplyScalar( alpha ).add( v1 );

		},

		equals: function ( v ) {

			return ( ( v.x === this.x ) && ( v.y === this.y ) );

		},

		fromArray: function ( array, offset ) {

			if ( offset === undefined ) offset = 0;

			this.x = array[ offset ];
			this.y = array[ offset + 1 ];

			return this;

		},

		toArray: function ( array, offset ) {

			if ( array === undefined ) array = [];
			if ( offset === undefined ) offset = 0;

			array[ offset ] = this.x;
			array[ offset + 1 ] = this.y;

			return array;

		},

		fromBufferAttribute: function ( attribute, index, offset ) {

			if ( offset !== undefined ) {

				console.warn( 'THREE.Vector2: offset has been removed from .fromBufferAttribute().' );

			}

			this.x = attribute.getX( index );
			this.y = attribute.getY( index );

			return this;

		},

		rotateAround: function ( center, angle ) {

			var c = Math.cos( angle ), s = Math.sin( angle );

			var x = this.x - center.x;
			var y = this.y - center.y;

			this.x = x * c - y * s + center.x;
			this.y = x * s + y * c + center.y;

			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 * @author szimek / https://github.com/szimek/
	 */

	var textureId = 0;

	function Texture( image, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding ) {

		Object.defineProperty( this, 'id', { value: textureId ++ } );

		this.uuid = _Math.generateUUID();

		this.name = '';

		this.image = image !== undefined ? image : Texture.DEFAULT_IMAGE;
		this.mipmaps = [];

		this.mapping = mapping !== undefined ? mapping : Texture.DEFAULT_MAPPING;

		this.wrapS = wrapS !== undefined ? wrapS : ClampToEdgeWrapping;
		this.wrapT = wrapT !== undefined ? wrapT : ClampToEdgeWrapping;

		this.magFilter = magFilter !== undefined ? magFilter : LinearFilter;
		this.minFilter = minFilter !== undefined ? minFilter : LinearMipMapLinearFilter;

		this.anisotropy = anisotropy !== undefined ? anisotropy : 1;

		this.format = format !== undefined ? format : RGBAFormat;
		this.type = type !== undefined ? type : UnsignedByteType;

		this.offset = new Vector2( 0, 0 );
		this.repeat = new Vector2( 1, 1 );

		this.generateMipmaps = true;
		this.premultiplyAlpha = false;
		this.flipY = true;
		this.unpackAlignment = 4;	// valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)

		// Values of encoding !== THREE.LinearEncoding only supported on map, envMap and emissiveMap.
		//
		// Also changing the encoding after already used by a Material will not automatically make the Material
		// update.  You need to explicitly call Material.needsUpdate to trigger it to recompile.
		this.encoding = encoding !== undefined ? encoding : LinearEncoding;

		this.version = 0;
		this.onUpdate = null;

	}

	Texture.DEFAULT_IMAGE = undefined;
	Texture.DEFAULT_MAPPING = UVMapping;

	Object.defineProperty( Texture.prototype, "needsUpdate", {

		set: function ( value ) {

			if ( value === true ) this.version ++;

		}

	} );

	Object.assign( Texture.prototype, EventDispatcher.prototype, {

		constructor: Texture,

		isTexture: true,

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( source ) {

			this.name = source.name;

			this.image = source.image;
			this.mipmaps = source.mipmaps.slice( 0 );

			this.mapping = source.mapping;

			this.wrapS = source.wrapS;
			this.wrapT = source.wrapT;

			this.magFilter = source.magFilter;
			this.minFilter = source.minFilter;

			this.anisotropy = source.anisotropy;

			this.format = source.format;
			this.type = source.type;

			this.offset.copy( source.offset );
			this.repeat.copy( source.repeat );

			this.generateMipmaps = source.generateMipmaps;
			this.premultiplyAlpha = source.premultiplyAlpha;
			this.flipY = source.flipY;
			this.unpackAlignment = source.unpackAlignment;
			this.encoding = source.encoding;

			return this;

		},

		toJSON: function ( meta ) {

			if ( meta.textures[ this.uuid ] !== undefined ) {

				return meta.textures[ this.uuid ];

			}

			function getDataURL( image ) {

				var canvas;

				if ( image instanceof HTMLCanvasElement ) {

					canvas = image;

				} else {

					canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
					canvas.width = image.width;
					canvas.height = image.height;

					var context = canvas.getContext( '2d' );

					if ( image instanceof ImageData ) {

						context.putImageData( image, 0, 0 );

					} else {

						context.drawImage( image, 0, 0, image.width, image.height );

					}

				}

				if ( canvas.width > 2048 || canvas.height > 2048 ) {

					return canvas.toDataURL( 'image/jpeg', 0.6 );

				} else {

					return canvas.toDataURL( 'image/png' );

				}

			}

			var output = {
				metadata: {
					version: 4.5,
					type: 'Texture',
					generator: 'Texture.toJSON'
				},

				uuid: this.uuid,
				name: this.name,

				mapping: this.mapping,

				repeat: [ this.repeat.x, this.repeat.y ],
				offset: [ this.offset.x, this.offset.y ],
				wrap: [ this.wrapS, this.wrapT ],

				minFilter: this.minFilter,
				magFilter: this.magFilter,
				anisotropy: this.anisotropy,

				flipY: this.flipY
			};

			if ( this.image !== undefined ) {

				// TODO: Move to THREE.Image

				var image = this.image;

				if ( image.uuid === undefined ) {

					image.uuid = _Math.generateUUID(); // UGH

				}

				if ( meta.images[ image.uuid ] === undefined ) {

					meta.images[ image.uuid ] = {
						uuid: image.uuid,
						url: getDataURL( image )
					};

				}

				output.image = image.uuid;

			}

			meta.textures[ this.uuid ] = output;

			return output;

		},

		dispose: function () {

			this.dispatchEvent( { type: 'dispose' } );

		},

		transformUv: function ( uv ) {

			if ( this.mapping !== UVMapping ) return;

			uv.multiply( this.repeat );
			uv.add( this.offset );

			if ( uv.x < 0 || uv.x > 1 ) {

				switch ( this.wrapS ) {

					case RepeatWrapping:

						uv.x = uv.x - Math.floor( uv.x );
						break;

					case ClampToEdgeWrapping:

						uv.x = uv.x < 0 ? 0 : 1;
						break;

					case MirroredRepeatWrapping:

						if ( Math.abs( Math.floor( uv.x ) % 2 ) === 1 ) {

							uv.x = Math.ceil( uv.x ) - uv.x;

						} else {

							uv.x = uv.x - Math.floor( uv.x );

						}
						break;

				}

			}

			if ( uv.y < 0 || uv.y > 1 ) {

				switch ( this.wrapT ) {

					case RepeatWrapping:

						uv.y = uv.y - Math.floor( uv.y );
						break;

					case ClampToEdgeWrapping:

						uv.y = uv.y < 0 ? 0 : 1;
						break;

					case MirroredRepeatWrapping:

						if ( Math.abs( Math.floor( uv.y ) % 2 ) === 1 ) {

							uv.y = Math.ceil( uv.y ) - uv.y;

						} else {

							uv.y = uv.y - Math.floor( uv.y );

						}
						break;

				}

			}

			if ( this.flipY ) {

				uv.y = 1 - uv.y;

			}

		}

	} );

	/**
	 * @author supereggbert / http://www.paulbrunt.co.uk/
	 * @author philogb / http://blog.thejit.org/
	 * @author mikael emtinger / http://gomo.se/
	 * @author egraether / http://egraether.com/
	 * @author WestLangley / http://github.com/WestLangley
	 */

	function Vector4( x, y, z, w ) {

		this.x = x || 0;
		this.y = y || 0;
		this.z = z || 0;
		this.w = ( w !== undefined ) ? w : 1;

	}

	Object.assign( Vector4.prototype, {

		isVector4: true,

		set: function ( x, y, z, w ) {

			this.x = x;
			this.y = y;
			this.z = z;
			this.w = w;

			return this;

		},

		setScalar: function ( scalar ) {

			this.x = scalar;
			this.y = scalar;
			this.z = scalar;
			this.w = scalar;

			return this;

		},

		setX: function ( x ) {

			this.x = x;

			return this;

		},

		setY: function ( y ) {

			this.y = y;

			return this;

		},

		setZ: function ( z ) {

			this.z = z;

			return this;

		},

		setW: function ( w ) {

			this.w = w;

			return this;

		},

		setComponent: function ( index, value ) {

			switch ( index ) {

				case 0: this.x = value; break;
				case 1: this.y = value; break;
				case 2: this.z = value; break;
				case 3: this.w = value; break;
				default: throw new Error( 'index is out of range: ' + index );

			}

			return this;

		},

		getComponent: function ( index ) {

			switch ( index ) {

				case 0: return this.x;
				case 1: return this.y;
				case 2: return this.z;
				case 3: return this.w;
				default: throw new Error( 'index is out of range: ' + index );

			}

		},

		clone: function () {

			return new this.constructor( this.x, this.y, this.z, this.w );

		},

		copy: function ( v ) {

			this.x = v.x;
			this.y = v.y;
			this.z = v.z;
			this.w = ( v.w !== undefined ) ? v.w : 1;

			return this;

		},

		add: function ( v, w ) {

			if ( w !== undefined ) {

				console.warn( 'THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
				return this.addVectors( v, w );

			}

			this.x += v.x;
			this.y += v.y;
			this.z += v.z;
			this.w += v.w;

			return this;

		},

		addScalar: function ( s ) {

			this.x += s;
			this.y += s;
			this.z += s;
			this.w += s;

			return this;

		},

		addVectors: function ( a, b ) {

			this.x = a.x + b.x;
			this.y = a.y + b.y;
			this.z = a.z + b.z;
			this.w = a.w + b.w;

			return this;

		},

		addScaledVector: function ( v, s ) {

			this.x += v.x * s;
			this.y += v.y * s;
			this.z += v.z * s;
			this.w += v.w * s;

			return this;

		},

		sub: function ( v, w ) {

			if ( w !== undefined ) {

				console.warn( 'THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.' );
				return this.subVectors( v, w );

			}

			this.x -= v.x;
			this.y -= v.y;
			this.z -= v.z;
			this.w -= v.w;

			return this;

		},

		subScalar: function ( s ) {

			this.x -= s;
			this.y -= s;
			this.z -= s;
			this.w -= s;

			return this;

		},

		subVectors: function ( a, b ) {

			this.x = a.x - b.x;
			this.y = a.y - b.y;
			this.z = a.z - b.z;
			this.w = a.w - b.w;

			return this;

		},

		multiplyScalar: function ( scalar ) {

			this.x *= scalar;
			this.y *= scalar;
			this.z *= scalar;
			this.w *= scalar;

			return this;

		},

		applyMatrix4: function ( m ) {

			var x = this.x, y = this.y, z = this.z, w = this.w;
			var e = m.elements;

			this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z + e[ 12 ] * w;
			this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z + e[ 13 ] * w;
			this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ] * w;
			this.w = e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ] * w;

			return this;

		},

		divideScalar: function ( scalar ) {

			return this.multiplyScalar( 1 / scalar );

		},

		setAxisAngleFromQuaternion: function ( q ) {

			// http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm

			// q is assumed to be normalized

			this.w = 2 * Math.acos( q.w );

			var s = Math.sqrt( 1 - q.w * q.w );

			if ( s < 0.0001 ) {

				 this.x = 1;
				 this.y = 0;
				 this.z = 0;

			} else {

				 this.x = q.x / s;
				 this.y = q.y / s;
				 this.z = q.z / s;

			}

			return this;

		},

		setAxisAngleFromRotationMatrix: function ( m ) {

			// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm

			// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

			var angle, x, y, z,		// variables for result
				epsilon = 0.01,		// margin to allow for rounding errors
				epsilon2 = 0.1,		// margin to distinguish between 0 and 180 degrees

				te = m.elements,

				m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ],
				m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ],
				m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ];

			if ( ( Math.abs( m12 - m21 ) < epsilon ) &&
			     ( Math.abs( m13 - m31 ) < epsilon ) &&
			     ( Math.abs( m23 - m32 ) < epsilon ) ) {

				// singularity found
				// first check for identity matrix which must have +1 for all terms
				// in leading diagonal and zero in other terms

				if ( ( Math.abs( m12 + m21 ) < epsilon2 ) &&
				     ( Math.abs( m13 + m31 ) < epsilon2 ) &&
				     ( Math.abs( m23 + m32 ) < epsilon2 ) &&
				     ( Math.abs( m11 + m22 + m33 - 3 ) < epsilon2 ) ) {

					// this singularity is identity matrix so angle = 0

					this.set( 1, 0, 0, 0 );

					return this; // zero angle, arbitrary axis

				}

				// otherwise this singularity is angle = 180

				angle = Math.PI;

				var xx = ( m11 + 1 ) / 2;
				var yy = ( m22 + 1 ) / 2;
				var zz = ( m33 + 1 ) / 2;
				var xy = ( m12 + m21 ) / 4;
				var xz = ( m13 + m31 ) / 4;
				var yz = ( m23 + m32 ) / 4;

				if ( ( xx > yy ) && ( xx > zz ) ) {

					// m11 is the largest diagonal term

					if ( xx < epsilon ) {

						x = 0;
						y = 0.707106781;
						z = 0.707106781;

					} else {

						x = Math.sqrt( xx );
						y = xy / x;
						z = xz / x;

					}

				} else if ( yy > zz ) {

					// m22 is the largest diagonal term

					if ( yy < epsilon ) {

						x = 0.707106781;
						y = 0;
						z = 0.707106781;

					} else {

						y = Math.sqrt( yy );
						x = xy / y;
						z = yz / y;

					}

				} else {

					// m33 is the largest diagonal term so base result on this

					if ( zz < epsilon ) {

						x = 0.707106781;
						y = 0.707106781;
						z = 0;

					} else {

						z = Math.sqrt( zz );
						x = xz / z;
						y = yz / z;

					}

				}

				this.set( x, y, z, angle );

				return this; // return 180 deg rotation

			}

			// as we have reached here there are no singularities so we can handle normally

			var s = Math.sqrt( ( m32 - m23 ) * ( m32 - m23 ) +
			                   ( m13 - m31 ) * ( m13 - m31 ) +
			                   ( m21 - m12 ) * ( m21 - m12 ) ); // used to normalize

			if ( Math.abs( s ) < 0.001 ) s = 1;

			// prevent divide by zero, should not happen if matrix is orthogonal and should be
			// caught by singularity test above, but I've left it in just in case

			this.x = ( m32 - m23 ) / s;
			this.y = ( m13 - m31 ) / s;
			this.z = ( m21 - m12 ) / s;
			this.w = Math.acos( ( m11 + m22 + m33 - 1 ) / 2 );

			return this;

		},

		min: function ( v ) {

			this.x = Math.min( this.x, v.x );
			this.y = Math.min( this.y, v.y );
			this.z = Math.min( this.z, v.z );
			this.w = Math.min( this.w, v.w );

			return this;

		},

		max: function ( v ) {

			this.x = Math.max( this.x, v.x );
			this.y = Math.max( this.y, v.y );
			this.z = Math.max( this.z, v.z );
			this.w = Math.max( this.w, v.w );

			return this;

		},

		clamp: function ( min, max ) {

			// assumes min < max, componentwise

			this.x = Math.max( min.x, Math.min( max.x, this.x ) );
			this.y = Math.max( min.y, Math.min( max.y, this.y ) );
			this.z = Math.max( min.z, Math.min( max.z, this.z ) );
			this.w = Math.max( min.w, Math.min( max.w, this.w ) );

			return this;

		},

		clampScalar: function () {

			var min, max;

			return function clampScalar( minVal, maxVal ) {

				if ( min === undefined ) {

					min = new Vector4();
					max = new Vector4();

				}

				min.set( minVal, minVal, minVal, minVal );
				max.set( maxVal, maxVal, maxVal, maxVal );

				return this.clamp( min, max );

			};

		}(),

		clampLength: function ( min, max ) {

			var length = this.length();

			return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );

		},

		floor: function () {

			this.x = Math.floor( this.x );
			this.y = Math.floor( this.y );
			this.z = Math.floor( this.z );
			this.w = Math.floor( this.w );

			return this;

		},

		ceil: function () {

			this.x = Math.ceil( this.x );
			this.y = Math.ceil( this.y );
			this.z = Math.ceil( this.z );
			this.w = Math.ceil( this.w );

			return this;

		},

		round: function () {

			this.x = Math.round( this.x );
			this.y = Math.round( this.y );
			this.z = Math.round( this.z );
			this.w = Math.round( this.w );

			return this;

		},

		roundToZero: function () {

			this.x = ( this.x < 0 ) ? Math.ceil( this.x ) : Math.floor( this.x );
			this.y = ( this.y < 0 ) ? Math.ceil( this.y ) : Math.floor( this.y );
			this.z = ( this.z < 0 ) ? Math.ceil( this.z ) : Math.floor( this.z );
			this.w = ( this.w < 0 ) ? Math.ceil( this.w ) : Math.floor( this.w );

			return this;

		},

		negate: function () {

			this.x = - this.x;
			this.y = - this.y;
			this.z = - this.z;
			this.w = - this.w;

			return this;

		},

		dot: function ( v ) {

			return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;

		},

		lengthSq: function () {

			return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;

		},

		length: function () {

			return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w );

		},

		lengthManhattan: function () {

			return Math.abs( this.x ) + Math.abs( this.y ) + Math.abs( this.z ) + Math.abs( this.w );

		},

		normalize: function () {

			return this.divideScalar( this.length() || 1 );

		},

		setLength: function ( length ) {

			return this.normalize().multiplyScalar( length );

		},

		lerp: function ( v, alpha ) {

			this.x += ( v.x - this.x ) * alpha;
			this.y += ( v.y - this.y ) * alpha;
			this.z += ( v.z - this.z ) * alpha;
			this.w += ( v.w - this.w ) * alpha;

			return this;

		},

		lerpVectors: function ( v1, v2, alpha ) {

			return this.subVectors( v2, v1 ).multiplyScalar( alpha ).add( v1 );

		},

		equals: function ( v ) {

			return ( ( v.x === this.x ) && ( v.y === this.y ) && ( v.z === this.z ) && ( v.w === this.w ) );

		},

		fromArray: function ( array, offset ) {

			if ( offset === undefined ) offset = 0;

			this.x = array[ offset ];
			this.y = array[ offset + 1 ];
			this.z = array[ offset + 2 ];
			this.w = array[ offset + 3 ];

			return this;

		},

		toArray: function ( array, offset ) {

			if ( array === undefined ) array = [];
			if ( offset === undefined ) offset = 0;

			array[ offset ] = this.x;
			array[ offset + 1 ] = this.y;
			array[ offset + 2 ] = this.z;
			array[ offset + 3 ] = this.w;

			return array;

		},

		fromBufferAttribute: function ( attribute, index, offset ) {

			if ( offset !== undefined ) {

				console.warn( 'THREE.Vector4: offset has been removed from .fromBufferAttribute().' );

			}

			this.x = attribute.getX( index );
			this.y = attribute.getY( index );
			this.z = attribute.getZ( index );
			this.w = attribute.getW( index );

			return this;

		}

	} );

	/**
	 * @author szimek / https://github.com/szimek/
	 * @author alteredq / http://alteredqualia.com/
	 * @author Marius Kintel / https://github.com/kintel
	 */

	/*
	 In options, we can specify:
	 * Texture parameters for an auto-generated target texture
	 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
	*/
	function WebGLRenderTarget( width, height, options ) {

		this.uuid = _Math.generateUUID();

		this.width = width;
		this.height = height;

		this.scissor = new Vector4( 0, 0, width, height );
		this.scissorTest = false;

		this.viewport = new Vector4( 0, 0, width, height );

		options = options || {};

		if ( options.minFilter === undefined ) options.minFilter = LinearFilter;

		this.texture = new Texture( undefined, undefined, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding );

		this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
		this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : true;
		this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;

	}

	Object.assign( WebGLRenderTarget.prototype, EventDispatcher.prototype, {

		isWebGLRenderTarget: true,

		setSize: function ( width, height ) {

			if ( this.width !== width || this.height !== height ) {

				this.width = width;
				this.height = height;

				this.dispose();

			}

			this.viewport.set( 0, 0, width, height );
			this.scissor.set( 0, 0, width, height );

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( source ) {

			this.width = source.width;
			this.height = source.height;

			this.viewport.copy( source.viewport );

			this.texture = source.texture.clone();

			this.depthBuffer = source.depthBuffer;
			this.stencilBuffer = source.stencilBuffer;
			this.depthTexture = source.depthTexture;

			return this;

		},

		dispose: function () {

			this.dispatchEvent( { type: 'dispose' } );

		}

	} );

	/**
	 * @author alteredq / http://alteredqualia.com
	 */

	function WebGLRenderTargetCube( width, height, options ) {

		WebGLRenderTarget.call( this, width, height, options );

		this.activeCubeFace = 0; // PX 0, NX 1, PY 2, NY 3, PZ 4, NZ 5
		this.activeMipMapLevel = 0;

	}

	WebGLRenderTargetCube.prototype = Object.create( WebGLRenderTarget.prototype );
	WebGLRenderTargetCube.prototype.constructor = WebGLRenderTargetCube;

	WebGLRenderTargetCube.prototype.isWebGLRenderTargetCube = true;

	/**
	 * @author mikael emtinger / http://gomo.se/
	 * @author alteredq / http://alteredqualia.com/
	 * @author WestLangley / http://github.com/WestLangley
	 * @author bhouston / http://clara.io
	 */

	function Quaternion( x, y, z, w ) {

		this._x = x || 0;
		this._y = y || 0;
		this._z = z || 0;
		this._w = ( w !== undefined ) ? w : 1;

	}

	Object.assign( Quaternion, {

		slerp: function ( qa, qb, qm, t ) {

			return qm.copy( qa ).slerp( qb, t );

		},

		slerpFlat: function ( dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t ) {

			// fuzz-free, array-based Quaternion SLERP operation

			var x0 = src0[ srcOffset0 + 0 ],
				y0 = src0[ srcOffset0 + 1 ],
				z0 = src0[ srcOffset0 + 2 ],
				w0 = src0[ srcOffset0 + 3 ],

				x1 = src1[ srcOffset1 + 0 ],
				y1 = src1[ srcOffset1 + 1 ],
				z1 = src1[ srcOffset1 + 2 ],
				w1 = src1[ srcOffset1 + 3 ];

			if ( w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1 ) {

				var s = 1 - t,

					cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1,

					dir = ( cos >= 0 ? 1 : - 1 ),
					sqrSin = 1 - cos * cos;

				// Skip the Slerp for tiny steps to avoid numeric problems:
				if ( sqrSin > Number.EPSILON ) {

					var sin = Math.sqrt( sqrSin ),
						len = Math.atan2( sin, cos * dir );

					s = Math.sin( s * len ) / sin;
					t = Math.sin( t * len ) / sin;

				}

				var tDir = t * dir;

				x0 = x0 * s + x1 * tDir;
				y0 = y0 * s + y1 * tDir;
				z0 = z0 * s + z1 * tDir;
				w0 = w0 * s + w1 * tDir;

				// Normalize in case we just did a lerp:
				if ( s === 1 - t ) {

					var f = 1 / Math.sqrt( x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0 );

					x0 *= f;
					y0 *= f;
					z0 *= f;
					w0 *= f;

				}

			}

			dst[ dstOffset ] = x0;
			dst[ dstOffset + 1 ] = y0;
			dst[ dstOffset + 2 ] = z0;
			dst[ dstOffset + 3 ] = w0;

		}

	} );

	Object.defineProperties( Quaternion.prototype, {

		x: {

			get: function () {

				return this._x;

			},

			set: function ( value ) {

				this._x = value;
				this.onChangeCallback();

			}

		},

		y: {

			get: function () {

				return this._y;

			},

			set: function ( value ) {

				this._y = value;
				this.onChangeCallback();

			}

		},

		z: {

			get: function () {

				return this._z;

			},

			set: function ( value ) {

				this._z = value;
				this.onChangeCallback();

			}

		},

		w: {

			get: function () {

				return this._w;

			},

			set: function ( value ) {

				this._w = value;
				this.onChangeCallback();

			}

		}

	} );

	Object.assign( Quaternion.prototype, {

		set: function ( x, y, z, w ) {

			this._x = x;
			this._y = y;
			this._z = z;
			this._w = w;

			this.onChangeCallback();

			return this;

		},

		clone: function () {

			return new this.constructor( this._x, this._y, this._z, this._w );

		},

		copy: function ( quaternion ) {

			this._x = quaternion.x;
			this._y = quaternion.y;
			this._z = quaternion.z;
			this._w = quaternion.w;

			this.onChangeCallback();

			return this;

		},

		setFromEuler: function ( euler, update ) {

			if ( ! ( euler && euler.isEuler ) ) {

				throw new Error( 'THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.' );

			}

			var x = euler._x, y = euler._y, z = euler._z, order = euler.order;

			// http://www.mathworks.com/matlabcentral/fileexchange/
			// 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
			//	content/SpinCalc.m

			var cos = Math.cos;
			var sin = Math.sin;

			var c1 = cos( x / 2 );
			var c2 = cos( y / 2 );
			var c3 = cos( z / 2 );

			var s1 = sin( x / 2 );
			var s2 = sin( y / 2 );
			var s3 = sin( z / 2 );

			if ( order === 'XYZ' ) {

				this._x = s1 * c2 * c3 + c1 * s2 * s3;
				this._y = c1 * s2 * c3 - s1 * c2 * s3;
				this._z = c1 * c2 * s3 + s1 * s2 * c3;
				this._w = c1 * c2 * c3 - s1 * s2 * s3;

			} else if ( order === 'YXZ' ) {

				this._x = s1 * c2 * c3 + c1 * s2 * s3;
				this._y = c1 * s2 * c3 - s1 * c2 * s3;
				this._z = c1 * c2 * s3 - s1 * s2 * c3;
				this._w = c1 * c2 * c3 + s1 * s2 * s3;

			} else if ( order === 'ZXY' ) {

				this._x = s1 * c2 * c3 - c1 * s2 * s3;
				this._y = c1 * s2 * c3 + s1 * c2 * s3;
				this._z = c1 * c2 * s3 + s1 * s2 * c3;
				this._w = c1 * c2 * c3 - s1 * s2 * s3;

			} else if ( order === 'ZYX' ) {

				this._x = s1 * c2 * c3 - c1 * s2 * s3;
				this._y = c1 * s2 * c3 + s1 * c2 * s3;
				this._z = c1 * c2 * s3 - s1 * s2 * c3;
				this._w = c1 * c2 * c3 + s1 * s2 * s3;

			} else if ( order === 'YZX' ) {

				this._x = s1 * c2 * c3 + c1 * s2 * s3;
				this._y = c1 * s2 * c3 + s1 * c2 * s3;
				this._z = c1 * c2 * s3 - s1 * s2 * c3;
				this._w = c1 * c2 * c3 - s1 * s2 * s3;

			} else if ( order === 'XZY' ) {

				this._x = s1 * c2 * c3 - c1 * s2 * s3;
				this._y = c1 * s2 * c3 - s1 * c2 * s3;
				this._z = c1 * c2 * s3 + s1 * s2 * c3;
				this._w = c1 * c2 * c3 + s1 * s2 * s3;

			}

			if ( update !== false ) this.onChangeCallback();

			return this;

		},

		setFromAxisAngle: function ( axis, angle ) {

			// http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm

			// assumes axis is normalized

			var halfAngle = angle / 2, s = Math.sin( halfAngle );

			this._x = axis.x * s;
			this._y = axis.y * s;
			this._z = axis.z * s;
			this._w = Math.cos( halfAngle );

			this.onChangeCallback();

			return this;

		},

		setFromRotationMatrix: function ( m ) {

			// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm

			// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

			var te = m.elements,

				m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ],
				m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ],
				m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ],

				trace = m11 + m22 + m33,
				s;

			if ( trace > 0 ) {

				s = 0.5 / Math.sqrt( trace + 1.0 );

				this._w = 0.25 / s;
				this._x = ( m32 - m23 ) * s;
				this._y = ( m13 - m31 ) * s;
				this._z = ( m21 - m12 ) * s;

			} else if ( m11 > m22 && m11 > m33 ) {

				s = 2.0 * Math.sqrt( 1.0 + m11 - m22 - m33 );

				this._w = ( m32 - m23 ) / s;
				this._x = 0.25 * s;
				this._y = ( m12 + m21 ) / s;
				this._z = ( m13 + m31 ) / s;

			} else if ( m22 > m33 ) {

				s = 2.0 * Math.sqrt( 1.0 + m22 - m11 - m33 );

				this._w = ( m13 - m31 ) / s;
				this._x = ( m12 + m21 ) / s;
				this._y = 0.25 * s;
				this._z = ( m23 + m32 ) / s;

			} else {

				s = 2.0 * Math.sqrt( 1.0 + m33 - m11 - m22 );

				this._w = ( m21 - m12 ) / s;
				this._x = ( m13 + m31 ) / s;
				this._y = ( m23 + m32 ) / s;
				this._z = 0.25 * s;

			}

			this.onChangeCallback();

			return this;

		},

		setFromUnitVectors: function () {

			// assumes direction vectors vFrom and vTo are normalized

			var v1 = new Vector3();
			var r;

			var EPS = 0.000001;

			return function setFromUnitVectors( vFrom, vTo ) {

				if ( v1 === undefined ) v1 = new Vector3();

				r = vFrom.dot( vTo ) + 1;

				if ( r < EPS ) {

					r = 0;

					if ( Math.abs( vFrom.x ) > Math.abs( vFrom.z ) ) {

						v1.set( - vFrom.y, vFrom.x, 0 );

					} else {

						v1.set( 0, - vFrom.z, vFrom.y );

					}

				} else {

					v1.crossVectors( vFrom, vTo );

				}

				this._x = v1.x;
				this._y = v1.y;
				this._z = v1.z;
				this._w = r;

				return this.normalize();

			};

		}(),

		inverse: function () {

			return this.conjugate().normalize();

		},

		conjugate: function () {

			this._x *= - 1;
			this._y *= - 1;
			this._z *= - 1;

			this.onChangeCallback();

			return this;

		},

		dot: function ( v ) {

			return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;

		},

		lengthSq: function () {

			return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;

		},

		length: function () {

			return Math.sqrt( this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w );

		},

		normalize: function () {

			var l = this.length();

			if ( l === 0 ) {

				this._x = 0;
				this._y = 0;
				this._z = 0;
				this._w = 1;

			} else {

				l = 1 / l;

				this._x = this._x * l;
				this._y = this._y * l;
				this._z = this._z * l;
				this._w = this._w * l;

			}

			this.onChangeCallback();

			return this;

		},

		multiply: function ( q, p ) {

			if ( p !== undefined ) {

				console.warn( 'THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.' );
				return this.multiplyQuaternions( q, p );

			}

			return this.multiplyQuaternions( this, q );

		},

		premultiply: function ( q ) {

			return this.multiplyQuaternions( q, this );

		},

		multiplyQuaternions: function ( a, b ) {

			// from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm

			var qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
			var qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;

			this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
			this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
			this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
			this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;

			this.onChangeCallback();

			return this;

		},

		slerp: function ( qb, t ) {

			if ( t === 0 ) return this;
			if ( t === 1 ) return this.copy( qb );

			var x = this._x, y = this._y, z = this._z, w = this._w;

			// http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/

			var cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;

			if ( cosHalfTheta < 0 ) {

				this._w = - qb._w;
				this._x = - qb._x;
				this._y = - qb._y;
				this._z = - qb._z;

				cosHalfTheta = - cosHalfTheta;

			} else {

				this.copy( qb );

			}

			if ( cosHalfTheta >= 1.0 ) {

				this._w = w;
				this._x = x;
				this._y = y;
				this._z = z;

				return this;

			}

			var sinHalfTheta = Math.sqrt( 1.0 - cosHalfTheta * cosHalfTheta );

			if ( Math.abs( sinHalfTheta ) < 0.001 ) {

				this._w = 0.5 * ( w + this._w );
				this._x = 0.5 * ( x + this._x );
				this._y = 0.5 * ( y + this._y );
				this._z = 0.5 * ( z + this._z );

				return this;

			}

			var halfTheta = Math.atan2( sinHalfTheta, cosHalfTheta );
			var ratioA = Math.sin( ( 1 - t ) * halfTheta ) / sinHalfTheta,
				ratioB = Math.sin( t * halfTheta ) / sinHalfTheta;

			this._w = ( w * ratioA + this._w * ratioB );
			this._x = ( x * ratioA + this._x * ratioB );
			this._y = ( y * ratioA + this._y * ratioB );
			this._z = ( z * ratioA + this._z * ratioB );

			this.onChangeCallback();

			return this;

		},

		equals: function ( quaternion ) {

			return ( quaternion._x === this._x ) && ( quaternion._y === this._y ) && ( quaternion._z === this._z ) && ( quaternion._w === this._w );

		},

		fromArray: function ( array, offset ) {

			if ( offset === undefined ) offset = 0;

			this._x = array[ offset ];
			this._y = array[ offset + 1 ];
			this._z = array[ offset + 2 ];
			this._w = array[ offset + 3 ];

			this.onChangeCallback();

			return this;

		},

		toArray: function ( array, offset ) {

			if ( array === undefined ) array = [];
			if ( offset === undefined ) offset = 0;

			array[ offset ] = this._x;
			array[ offset + 1 ] = this._y;
			array[ offset + 2 ] = this._z;
			array[ offset + 3 ] = this._w;

			return array;

		},

		onChange: function ( callback ) {

			this.onChangeCallback = callback;

			return this;

		},

		onChangeCallback: function () {}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author kile / http://kile.stravaganza.org/
	 * @author philogb / http://blog.thejit.org/
	 * @author mikael emtinger / http://gomo.se/
	 * @author egraether / http://egraether.com/
	 * @author WestLangley / http://github.com/WestLangley
	 */

	function Vector3( x, y, z ) {

		this.x = x || 0;
		this.y = y || 0;
		this.z = z || 0;

	}

	Object.assign( Vector3.prototype, {

		isVector3: true,

		set: function ( x, y, z ) {

			this.x = x;
			this.y = y;
			this.z = z;

			return this;

		},

		setScalar: function ( scalar ) {

			this.x = scalar;
			this.y = scalar;
			this.z = scalar;

			return this;

		},

		setX: function ( x ) {

			this.x = x;

			return this;

		},

		setY: function ( y ) {

			this.y = y;

			return this;

		},

		setZ: function ( z ) {

			this.z = z;

			return this;

		},

		setComponent: function ( index, value ) {

			switch ( index ) {

				case 0: this.x = value; break;
				case 1: this.y = value; break;
				case 2: this.z = value; break;
				default: throw new Error( 'index is out of range: ' + index );

			}

			return this;

		},

		getComponent: function ( index ) {

			switch ( index ) {

				case 0: return this.x;
				case 1: return this.y;
				case 2: return this.z;
				default: throw new Error( 'index is out of range: ' + index );

			}

		},

		clone: function () {

			return new this.constructor( this.x, this.y, this.z );

		},

		copy: function ( v ) {

			this.x = v.x;
			this.y = v.y;
			this.z = v.z;

			return this;

		},

		add: function ( v, w ) {

			if ( w !== undefined ) {

				console.warn( 'THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
				return this.addVectors( v, w );

			}

			this.x += v.x;
			this.y += v.y;
			this.z += v.z;

			return this;

		},

		addScalar: function ( s ) {

			this.x += s;
			this.y += s;
			this.z += s;

			return this;

		},

		addVectors: function ( a, b ) {

			this.x = a.x + b.x;
			this.y = a.y + b.y;
			this.z = a.z + b.z;

			return this;

		},

		addScaledVector: function ( v, s ) {

			this.x += v.x * s;
			this.y += v.y * s;
			this.z += v.z * s;

			return this;

		},

		sub: function ( v, w ) {

			if ( w !== undefined ) {

				console.warn( 'THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.' );
				return this.subVectors( v, w );

			}

			this.x -= v.x;
			this.y -= v.y;
			this.z -= v.z;

			return this;

		},

		subScalar: function ( s ) {

			this.x -= s;
			this.y -= s;
			this.z -= s;

			return this;

		},

		subVectors: function ( a, b ) {

			this.x = a.x - b.x;
			this.y = a.y - b.y;
			this.z = a.z - b.z;

			return this;

		},

		multiply: function ( v, w ) {

			if ( w !== undefined ) {

				console.warn( 'THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.' );
				return this.multiplyVectors( v, w );

			}

			this.x *= v.x;
			this.y *= v.y;
			this.z *= v.z;

			return this;

		},

		multiplyScalar: function ( scalar ) {

			this.x *= scalar;
			this.y *= scalar;
			this.z *= scalar;

			return this;

		},

		multiplyVectors: function ( a, b ) {

			this.x = a.x * b.x;
			this.y = a.y * b.y;
			this.z = a.z * b.z;

			return this;

		},

		applyEuler: function () {

			var quaternion = new Quaternion();

			return function applyEuler( euler ) {

				if ( ! ( euler && euler.isEuler ) ) {

					console.error( 'THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.' );

				}

				return this.applyQuaternion( quaternion.setFromEuler( euler ) );

			};

		}(),

		applyAxisAngle: function () {

			var quaternion = new Quaternion();

			return function applyAxisAngle( axis, angle ) {

				return this.applyQuaternion( quaternion.setFromAxisAngle( axis, angle ) );

			};

		}(),

		applyMatrix3: function ( m ) {

			var x = this.x, y = this.y, z = this.z;
			var e = m.elements;

			this.x = e[ 0 ] * x + e[ 3 ] * y + e[ 6 ] * z;
			this.y = e[ 1 ] * x + e[ 4 ] * y + e[ 7 ] * z;
			this.z = e[ 2 ] * x + e[ 5 ] * y + e[ 8 ] * z;

			return this;

		},

		applyMatrix4: function ( m ) {

			var x = this.x, y = this.y, z = this.z;
			var e = m.elements;

			var w = 1 / ( e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ] );

			this.x = ( e[ 0 ] * x + e[ 4 ] * y + e[ 8 ]  * z + e[ 12 ] ) * w;
			this.y = ( e[ 1 ] * x + e[ 5 ] * y + e[ 9 ]  * z + e[ 13 ] ) * w;
			this.z = ( e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ] ) * w;

			return this;

		},

		applyQuaternion: function ( q ) {

			var x = this.x, y = this.y, z = this.z;
			var qx = q.x, qy = q.y, qz = q.z, qw = q.w;

			// calculate quat * vector

			var ix =  qw * x + qy * z - qz * y;
			var iy =  qw * y + qz * x - qx * z;
			var iz =  qw * z + qx * y - qy * x;
			var iw = - qx * x - qy * y - qz * z;

			// calculate result * inverse quat

			this.x = ix * qw + iw * - qx + iy * - qz - iz * - qy;
			this.y = iy * qw + iw * - qy + iz * - qx - ix * - qz;
			this.z = iz * qw + iw * - qz + ix * - qy - iy * - qx;

			return this;

		},

		project: function () {

			var matrix = new Matrix4();

			return function project( camera ) {

				matrix.multiplyMatrices( camera.projectionMatrix, matrix.getInverse( camera.matrixWorld ) );
				return this.applyMatrix4( matrix );

			};

		}(),

		unproject: function () {

			var matrix = new Matrix4();

			return function unproject( camera ) {

				matrix.multiplyMatrices( camera.matrixWorld, matrix.getInverse( camera.projectionMatrix ) );
				return this.applyMatrix4( matrix );

			};

		}(),

		transformDirection: function ( m ) {

			// input: THREE.Matrix4 affine matrix
			// vector interpreted as a direction

			var x = this.x, y = this.y, z = this.z;
			var e = m.elements;

			this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ]  * z;
			this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ]  * z;
			this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z;

			return this.normalize();

		},

		divide: function ( v ) {

			this.x /= v.x;
			this.y /= v.y;
			this.z /= v.z;

			return this;

		},

		divideScalar: function ( scalar ) {

			return this.multiplyScalar( 1 / scalar );

		},

		min: function ( v ) {

			this.x = Math.min( this.x, v.x );
			this.y = Math.min( this.y, v.y );
			this.z = Math.min( this.z, v.z );

			return this;

		},

		max: function ( v ) {

			this.x = Math.max( this.x, v.x );
			this.y = Math.max( this.y, v.y );
			this.z = Math.max( this.z, v.z );

			return this;

		},

		clamp: function ( min, max ) {

			// assumes min < max, componentwise

			this.x = Math.max( min.x, Math.min( max.x, this.x ) );
			this.y = Math.max( min.y, Math.min( max.y, this.y ) );
			this.z = Math.max( min.z, Math.min( max.z, this.z ) );

			return this;

		},

		clampScalar: function () {

			var min = new Vector3();
			var max = new Vector3();

			return function clampScalar( minVal, maxVal ) {

				min.set( minVal, minVal, minVal );
				max.set( maxVal, maxVal, maxVal );

				return this.clamp( min, max );

			};

		}(),

		clampLength: function ( min, max ) {

			var length = this.length();

			return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );

		},

		floor: function () {

			this.x = Math.floor( this.x );
			this.y = Math.floor( this.y );
			this.z = Math.floor( this.z );

			return this;

		},

		ceil: function () {

			this.x = Math.ceil( this.x );
			this.y = Math.ceil( this.y );
			this.z = Math.ceil( this.z );

			return this;

		},

		round: function () {

			this.x = Math.round( this.x );
			this.y = Math.round( this.y );
			this.z = Math.round( this.z );

			return this;

		},

		roundToZero: function () {

			this.x = ( this.x < 0 ) ? Math.ceil( this.x ) : Math.floor( this.x );
			this.y = ( this.y < 0 ) ? Math.ceil( this.y ) : Math.floor( this.y );
			this.z = ( this.z < 0 ) ? Math.ceil( this.z ) : Math.floor( this.z );

			return this;

		},

		negate: function () {

			this.x = - this.x;
			this.y = - this.y;
			this.z = - this.z;

			return this;

		},

		dot: function ( v ) {

			return this.x * v.x + this.y * v.y + this.z * v.z;

		},

		// TODO lengthSquared?

		lengthSq: function () {

			return this.x * this.x + this.y * this.y + this.z * this.z;

		},

		length: function () {

			return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z );

		},

		lengthManhattan: function () {

			return Math.abs( this.x ) + Math.abs( this.y ) + Math.abs( this.z );

		},

		normalize: function () {

			return this.divideScalar( this.length() || 1 );

		},

		setLength: function ( length ) {

			return this.normalize().multiplyScalar( length );

		},

		lerp: function ( v, alpha ) {

			this.x += ( v.x - this.x ) * alpha;
			this.y += ( v.y - this.y ) * alpha;
			this.z += ( v.z - this.z ) * alpha;

			return this;

		},

		lerpVectors: function ( v1, v2, alpha ) {

			return this.subVectors( v2, v1 ).multiplyScalar( alpha ).add( v1 );

		},

		cross: function ( v, w ) {

			if ( w !== undefined ) {

				console.warn( 'THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.' );
				return this.crossVectors( v, w );

			}

			var x = this.x, y = this.y, z = this.z;

			this.x = y * v.z - z * v.y;
			this.y = z * v.x - x * v.z;
			this.z = x * v.y - y * v.x;

			return this;

		},

		crossVectors: function ( a, b ) {

			var ax = a.x, ay = a.y, az = a.z;
			var bx = b.x, by = b.y, bz = b.z;

			this.x = ay * bz - az * by;
			this.y = az * bx - ax * bz;
			this.z = ax * by - ay * bx;

			return this;

		},

		projectOnVector: function ( vector ) {

			var scalar = vector.dot( this ) / vector.lengthSq();

			return this.copy( vector ).multiplyScalar( scalar );

		},

		projectOnPlane: function () {

			var v1 = new Vector3();

			return function projectOnPlane( planeNormal ) {

				v1.copy( this ).projectOnVector( planeNormal );

				return this.sub( v1 );

			};

		}(),

		reflect: function () {

			// reflect incident vector off plane orthogonal to normal
			// normal is assumed to have unit length

			var v1 = new Vector3();

			return function reflect( normal ) {

				return this.sub( v1.copy( normal ).multiplyScalar( 2 * this.dot( normal ) ) );

			};

		}(),

		angleTo: function ( v ) {

			var theta = this.dot( v ) / ( Math.sqrt( this.lengthSq() * v.lengthSq() ) );

			// clamp, to handle numerical problems

			return Math.acos( _Math.clamp( theta, - 1, 1 ) );

		},

		distanceTo: function ( v ) {

			return Math.sqrt( this.distanceToSquared( v ) );

		},

		distanceToSquared: function ( v ) {

			var dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;

			return dx * dx + dy * dy + dz * dz;

		},

		distanceToManhattan: function ( v ) {

			return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y ) + Math.abs( this.z - v.z );

		},

		setFromSpherical: function ( s ) {

			var sinPhiRadius = Math.sin( s.phi ) * s.radius;

			this.x = sinPhiRadius * Math.sin( s.theta );
			this.y = Math.cos( s.phi ) * s.radius;
			this.z = sinPhiRadius * Math.cos( s.theta );

			return this;

		},

		setFromCylindrical: function ( c ) {

			this.x = c.radius * Math.sin( c.theta );
			this.y = c.y;
			this.z = c.radius * Math.cos( c.theta );

			return this;

		},

		setFromMatrixPosition: function ( m ) {

			var e = m.elements;

			this.x = e[ 12 ];
			this.y = e[ 13 ];
			this.z = e[ 14 ];

			return this;

		},

		setFromMatrixScale: function ( m ) {

			var sx = this.setFromMatrixColumn( m, 0 ).length();
			var sy = this.setFromMatrixColumn( m, 1 ).length();
			var sz = this.setFromMatrixColumn( m, 2 ).length();

			this.x = sx;
			this.y = sy;
			this.z = sz;

			return this;

		},

		setFromMatrixColumn: function ( m, index ) {

			return this.fromArray( m.elements, index * 4 );

		},

		equals: function ( v ) {

			return ( ( v.x === this.x ) && ( v.y === this.y ) && ( v.z === this.z ) );

		},

		fromArray: function ( array, offset ) {

			if ( offset === undefined ) offset = 0;

			this.x = array[ offset ];
			this.y = array[ offset + 1 ];
			this.z = array[ offset + 2 ];

			return this;

		},

		toArray: function ( array, offset ) {

			if ( array === undefined ) array = [];
			if ( offset === undefined ) offset = 0;

			array[ offset ] = this.x;
			array[ offset + 1 ] = this.y;
			array[ offset + 2 ] = this.z;

			return array;

		},

		fromBufferAttribute: function ( attribute, index, offset ) {

			if ( offset !== undefined ) {

				console.warn( 'THREE.Vector3: offset has been removed from .fromBufferAttribute().' );

			}

			this.x = attribute.getX( index );
			this.y = attribute.getY( index );
			this.z = attribute.getZ( index );

			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author supereggbert / http://www.paulbrunt.co.uk/
	 * @author philogb / http://blog.thejit.org/
	 * @author jordi_ros / http://plattsoft.com
	 * @author D1plo1d / http://github.com/D1plo1d
	 * @author alteredq / http://alteredqualia.com/
	 * @author mikael emtinger / http://gomo.se/
	 * @author timknip / http://www.floorplanner.com/
	 * @author bhouston / http://clara.io
	 * @author WestLangley / http://github.com/WestLangley
	 */

	function Matrix4() {

		this.elements = [

			1, 0, 0, 0,
			0, 1, 0, 0,
			0, 0, 1, 0,
			0, 0, 0, 1

		];

		if ( arguments.length > 0 ) {

			console.error( 'THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.' );

		}

	}

	Object.assign( Matrix4.prototype, {

		isMatrix4: true,

		set: function ( n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44 ) {

			var te = this.elements;

			te[ 0 ] = n11; te[ 4 ] = n12; te[ 8 ] = n13; te[ 12 ] = n14;
			te[ 1 ] = n21; te[ 5 ] = n22; te[ 9 ] = n23; te[ 13 ] = n24;
			te[ 2 ] = n31; te[ 6 ] = n32; te[ 10 ] = n33; te[ 14 ] = n34;
			te[ 3 ] = n41; te[ 7 ] = n42; te[ 11 ] = n43; te[ 15 ] = n44;

			return this;

		},

		identity: function () {

			this.set(

				1, 0, 0, 0,
				0, 1, 0, 0,
				0, 0, 1, 0,
				0, 0, 0, 1

			);

			return this;

		},

		clone: function () {

			return new Matrix4().fromArray( this.elements );

		},

		copy: function ( m ) {

			var te = this.elements;
			var me = m.elements;

			te[ 0 ] = me[ 0 ]; te[ 1 ] = me[ 1 ]; te[ 2 ] = me[ 2 ]; te[ 3 ] = me[ 3 ];
			te[ 4 ] = me[ 4 ]; te[ 5 ] = me[ 5 ]; te[ 6 ] = me[ 6 ]; te[ 7 ] = me[ 7 ];
			te[ 8 ] = me[ 8 ]; te[ 9 ] = me[ 9 ]; te[ 10 ] = me[ 10 ]; te[ 11 ] = me[ 11 ];
			te[ 12 ] = me[ 12 ]; te[ 13 ] = me[ 13 ]; te[ 14 ] = me[ 14 ]; te[ 15 ] = me[ 15 ];

			return this;

		},

		copyPosition: function ( m ) {

			var te = this.elements, me = m.elements;

			te[ 12 ] = me[ 12 ];
			te[ 13 ] = me[ 13 ];
			te[ 14 ] = me[ 14 ];

			return this;

		},

		extractBasis: function ( xAxis, yAxis, zAxis ) {

			xAxis.setFromMatrixColumn( this, 0 );
			yAxis.setFromMatrixColumn( this, 1 );
			zAxis.setFromMatrixColumn( this, 2 );

			return this;

		},

		makeBasis: function ( xAxis, yAxis, zAxis ) {

			this.set(
				xAxis.x, yAxis.x, zAxis.x, 0,
				xAxis.y, yAxis.y, zAxis.y, 0,
				xAxis.z, yAxis.z, zAxis.z, 0,
				0,       0,       0,       1
			);

			return this;

		},

		extractRotation: function () {

			var v1 = new Vector3();

			return function extractRotation( m ) {

				var te = this.elements;
				var me = m.elements;

				var scaleX = 1 / v1.setFromMatrixColumn( m, 0 ).length();
				var scaleY = 1 / v1.setFromMatrixColumn( m, 1 ).length();
				var scaleZ = 1 / v1.setFromMatrixColumn( m, 2 ).length();

				te[ 0 ] = me[ 0 ] * scaleX;
				te[ 1 ] = me[ 1 ] * scaleX;
				te[ 2 ] = me[ 2 ] * scaleX;

				te[ 4 ] = me[ 4 ] * scaleY;
				te[ 5 ] = me[ 5 ] * scaleY;
				te[ 6 ] = me[ 6 ] * scaleY;

				te[ 8 ] = me[ 8 ] * scaleZ;
				te[ 9 ] = me[ 9 ] * scaleZ;
				te[ 10 ] = me[ 10 ] * scaleZ;

				return this;

			};

		}(),

		makeRotationFromEuler: function ( euler ) {

			if ( ! ( euler && euler.isEuler ) ) {

				console.error( 'THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.' );

			}

			var te = this.elements;

			var x = euler.x, y = euler.y, z = euler.z;
			var a = Math.cos( x ), b = Math.sin( x );
			var c = Math.cos( y ), d = Math.sin( y );
			var e = Math.cos( z ), f = Math.sin( z );

			if ( euler.order === 'XYZ' ) {

				var ae = a * e, af = a * f, be = b * e, bf = b * f;

				te[ 0 ] = c * e;
				te[ 4 ] = - c * f;
				te[ 8 ] = d;

				te[ 1 ] = af + be * d;
				te[ 5 ] = ae - bf * d;
				te[ 9 ] = - b * c;

				te[ 2 ] = bf - ae * d;
				te[ 6 ] = be + af * d;
				te[ 10 ] = a * c;

			} else if ( euler.order === 'YXZ' ) {

				var ce = c * e, cf = c * f, de = d * e, df = d * f;

				te[ 0 ] = ce + df * b;
				te[ 4 ] = de * b - cf;
				te[ 8 ] = a * d;

				te[ 1 ] = a * f;
				te[ 5 ] = a * e;
				te[ 9 ] = - b;

				te[ 2 ] = cf * b - de;
				te[ 6 ] = df + ce * b;
				te[ 10 ] = a * c;

			} else if ( euler.order === 'ZXY' ) {

				var ce = c * e, cf = c * f, de = d * e, df = d * f;

				te[ 0 ] = ce - df * b;
				te[ 4 ] = - a * f;
				te[ 8 ] = de + cf * b;

				te[ 1 ] = cf + de * b;
				te[ 5 ] = a * e;
				te[ 9 ] = df - ce * b;

				te[ 2 ] = - a * d;
				te[ 6 ] = b;
				te[ 10 ] = a * c;

			} else if ( euler.order === 'ZYX' ) {

				var ae = a * e, af = a * f, be = b * e, bf = b * f;

				te[ 0 ] = c * e;
				te[ 4 ] = be * d - af;
				te[ 8 ] = ae * d + bf;

				te[ 1 ] = c * f;
				te[ 5 ] = bf * d + ae;
				te[ 9 ] = af * d - be;

				te[ 2 ] = - d;
				te[ 6 ] = b * c;
				te[ 10 ] = a * c;

			} else if ( euler.order === 'YZX' ) {

				var ac = a * c, ad = a * d, bc = b * c, bd = b * d;

				te[ 0 ] = c * e;
				te[ 4 ] = bd - ac * f;
				te[ 8 ] = bc * f + ad;

				te[ 1 ] = f;
				te[ 5 ] = a * e;
				te[ 9 ] = - b * e;

				te[ 2 ] = - d * e;
				te[ 6 ] = ad * f + bc;
				te[ 10 ] = ac - bd * f;

			} else if ( euler.order === 'XZY' ) {

				var ac = a * c, ad = a * d, bc = b * c, bd = b * d;

				te[ 0 ] = c * e;
				te[ 4 ] = - f;
				te[ 8 ] = d * e;

				te[ 1 ] = ac * f + bd;
				te[ 5 ] = a * e;
				te[ 9 ] = ad * f - bc;

				te[ 2 ] = bc * f - ad;
				te[ 6 ] = b * e;
				te[ 10 ] = bd * f + ac;

			}

			// last column
			te[ 3 ] = 0;
			te[ 7 ] = 0;
			te[ 11 ] = 0;

			// bottom row
			te[ 12 ] = 0;
			te[ 13 ] = 0;
			te[ 14 ] = 0;
			te[ 15 ] = 1;

			return this;

		},

		makeRotationFromQuaternion: function ( q ) {

			var te = this.elements;

			var x = q._x, y = q._y, z = q._z, w = q._w;
			var x2 = x + x, y2 = y + y, z2 = z + z;
			var xx = x * x2, xy = x * y2, xz = x * z2;
			var yy = y * y2, yz = y * z2, zz = z * z2;
			var wx = w * x2, wy = w * y2, wz = w * z2;

			te[ 0 ] = 1 - ( yy + zz );
			te[ 4 ] = xy - wz;
			te[ 8 ] = xz + wy;

			te[ 1 ] = xy + wz;
			te[ 5 ] = 1 - ( xx + zz );
			te[ 9 ] = yz - wx;

			te[ 2 ] = xz - wy;
			te[ 6 ] = yz + wx;
			te[ 10 ] = 1 - ( xx + yy );

			// last column
			te[ 3 ] = 0;
			te[ 7 ] = 0;
			te[ 11 ] = 0;

			// bottom row
			te[ 12 ] = 0;
			te[ 13 ] = 0;
			te[ 14 ] = 0;
			te[ 15 ] = 1;

			return this;

		},

		lookAt: function () {

			var x = new Vector3();
			var y = new Vector3();
			var z = new Vector3();

			return function lookAt( eye, target, up ) {

				var te = this.elements;

				z.subVectors( eye, target );

				if ( z.lengthSq() === 0 ) {

					// eye and target are in the same position

					z.z = 1;

				}

				z.normalize();
				x.crossVectors( up, z );

				if ( x.lengthSq() === 0 ) {

					// up and z are parallel

					if ( Math.abs( up.z ) === 1 ) {

						z.x += 0.0001;

					} else {

						z.z += 0.0001;

					}

					z.normalize();
					x.crossVectors( up, z );

				}

				x.normalize();
				y.crossVectors( z, x );

				te[ 0 ] = x.x; te[ 4 ] = y.x; te[ 8 ] = z.x;
				te[ 1 ] = x.y; te[ 5 ] = y.y; te[ 9 ] = z.y;
				te[ 2 ] = x.z; te[ 6 ] = y.z; te[ 10 ] = z.z;

				return this;

			};

		}(),

		multiply: function ( m, n ) {

			if ( n !== undefined ) {

				console.warn( 'THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.' );
				return this.multiplyMatrices( m, n );

			}

			return this.multiplyMatrices( this, m );

		},

		premultiply: function ( m ) {

			return this.multiplyMatrices( m, this );

		},

		multiplyMatrices: function ( a, b ) {

			var ae = a.elements;
			var be = b.elements;
			var te = this.elements;

			var a11 = ae[ 0 ], a12 = ae[ 4 ], a13 = ae[ 8 ], a14 = ae[ 12 ];
			var a21 = ae[ 1 ], a22 = ae[ 5 ], a23 = ae[ 9 ], a24 = ae[ 13 ];
			var a31 = ae[ 2 ], a32 = ae[ 6 ], a33 = ae[ 10 ], a34 = ae[ 14 ];
			var a41 = ae[ 3 ], a42 = ae[ 7 ], a43 = ae[ 11 ], a44 = ae[ 15 ];

			var b11 = be[ 0 ], b12 = be[ 4 ], b13 = be[ 8 ], b14 = be[ 12 ];
			var b21 = be[ 1 ], b22 = be[ 5 ], b23 = be[ 9 ], b24 = be[ 13 ];
			var b31 = be[ 2 ], b32 = be[ 6 ], b33 = be[ 10 ], b34 = be[ 14 ];
			var b41 = be[ 3 ], b42 = be[ 7 ], b43 = be[ 11 ], b44 = be[ 15 ];

			te[ 0 ] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
			te[ 4 ] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
			te[ 8 ] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
			te[ 12 ] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;

			te[ 1 ] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
			te[ 5 ] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
			te[ 9 ] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
			te[ 13 ] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;

			te[ 2 ] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
			te[ 6 ] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
			te[ 10 ] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
			te[ 14 ] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;

			te[ 3 ] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
			te[ 7 ] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
			te[ 11 ] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
			te[ 15 ] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;

			return this;

		},

		multiplyScalar: function ( s ) {

			var te = this.elements;

			te[ 0 ] *= s; te[ 4 ] *= s; te[ 8 ] *= s; te[ 12 ] *= s;
			te[ 1 ] *= s; te[ 5 ] *= s; te[ 9 ] *= s; te[ 13 ] *= s;
			te[ 2 ] *= s; te[ 6 ] *= s; te[ 10 ] *= s; te[ 14 ] *= s;
			te[ 3 ] *= s; te[ 7 ] *= s; te[ 11 ] *= s; te[ 15 ] *= s;

			return this;

		},

		applyToBufferAttribute: function () {

			var v1 = new Vector3();

			return function applyToBufferAttribute( attribute ) {

				for ( var i = 0, l = attribute.count; i < l; i ++ ) {

					v1.x = attribute.getX( i );
					v1.y = attribute.getY( i );
					v1.z = attribute.getZ( i );

					v1.applyMatrix4( this );

					attribute.setXYZ( i, v1.x, v1.y, v1.z );

				}

				return attribute;

			};

		}(),

		determinant: function () {

			var te = this.elements;

			var n11 = te[ 0 ], n12 = te[ 4 ], n13 = te[ 8 ], n14 = te[ 12 ];
			var n21 = te[ 1 ], n22 = te[ 5 ], n23 = te[ 9 ], n24 = te[ 13 ];
			var n31 = te[ 2 ], n32 = te[ 6 ], n33 = te[ 10 ], n34 = te[ 14 ];
			var n41 = te[ 3 ], n42 = te[ 7 ], n43 = te[ 11 ], n44 = te[ 15 ];

			//TODO: make this more efficient
			//( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )

			return (
				n41 * (
					+ n14 * n23 * n32
					 - n13 * n24 * n32
					 - n14 * n22 * n33
					 + n12 * n24 * n33
					 + n13 * n22 * n34
					 - n12 * n23 * n34
				) +
				n42 * (
					+ n11 * n23 * n34
					 - n11 * n24 * n33
					 + n14 * n21 * n33
					 - n13 * n21 * n34
					 + n13 * n24 * n31
					 - n14 * n23 * n31
				) +
				n43 * (
					+ n11 * n24 * n32
					 - n11 * n22 * n34
					 - n14 * n21 * n32
					 + n12 * n21 * n34
					 + n14 * n22 * n31
					 - n12 * n24 * n31
				) +
				n44 * (
					- n13 * n22 * n31
					 - n11 * n23 * n32
					 + n11 * n22 * n33
					 + n13 * n21 * n32
					 - n12 * n21 * n33
					 + n12 * n23 * n31
				)

			);

		},

		transpose: function () {

			var te = this.elements;
			var tmp;

			tmp = te[ 1 ]; te[ 1 ] = te[ 4 ]; te[ 4 ] = tmp;
			tmp = te[ 2 ]; te[ 2 ] = te[ 8 ]; te[ 8 ] = tmp;
			tmp = te[ 6 ]; te[ 6 ] = te[ 9 ]; te[ 9 ] = tmp;

			tmp = te[ 3 ]; te[ 3 ] = te[ 12 ]; te[ 12 ] = tmp;
			tmp = te[ 7 ]; te[ 7 ] = te[ 13 ]; te[ 13 ] = tmp;
			tmp = te[ 11 ]; te[ 11 ] = te[ 14 ]; te[ 14 ] = tmp;

			return this;

		},

		setPosition: function ( v ) {

			var te = this.elements;

			te[ 12 ] = v.x;
			te[ 13 ] = v.y;
			te[ 14 ] = v.z;

			return this;

		},

		getInverse: function ( m, throwOnDegenerate ) {

			// based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
			var te = this.elements,
				me = m.elements,

				n11 = me[ 0 ], n21 = me[ 1 ], n31 = me[ 2 ], n41 = me[ 3 ],
				n12 = me[ 4 ], n22 = me[ 5 ], n32 = me[ 6 ], n42 = me[ 7 ],
				n13 = me[ 8 ], n23 = me[ 9 ], n33 = me[ 10 ], n43 = me[ 11 ],
				n14 = me[ 12 ], n24 = me[ 13 ], n34 = me[ 14 ], n44 = me[ 15 ],

				t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44,
				t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44,
				t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44,
				t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;

			var det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;

			if ( det === 0 ) {

				var msg = "THREE.Matrix4: .getInverse() can't invert matrix, determinant is 0";

				if ( throwOnDegenerate === true ) {

					throw new Error( msg );

				} else {

					console.warn( msg );

				}

				return this.identity();

			}

			var detInv = 1 / det;

			te[ 0 ] = t11 * detInv;
			te[ 1 ] = ( n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44 ) * detInv;
			te[ 2 ] = ( n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44 ) * detInv;
			te[ 3 ] = ( n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43 ) * detInv;

			te[ 4 ] = t12 * detInv;
			te[ 5 ] = ( n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44 ) * detInv;
			te[ 6 ] = ( n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44 ) * detInv;
			te[ 7 ] = ( n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43 ) * detInv;

			te[ 8 ] = t13 * detInv;
			te[ 9 ] = ( n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44 ) * detInv;
			te[ 10 ] = ( n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44 ) * detInv;
			te[ 11 ] = ( n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43 ) * detInv;

			te[ 12 ] = t14 * detInv;
			te[ 13 ] = ( n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34 ) * detInv;
			te[ 14 ] = ( n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34 ) * detInv;
			te[ 15 ] = ( n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33 ) * detInv;

			return this;

		},

		scale: function ( v ) {

			var te = this.elements;
			var x = v.x, y = v.y, z = v.z;

			te[ 0 ] *= x; te[ 4 ] *= y; te[ 8 ] *= z;
			te[ 1 ] *= x; te[ 5 ] *= y; te[ 9 ] *= z;
			te[ 2 ] *= x; te[ 6 ] *= y; te[ 10 ] *= z;
			te[ 3 ] *= x; te[ 7 ] *= y; te[ 11 ] *= z;

			return this;

		},

		getMaxScaleOnAxis: function () {

			var te = this.elements;

			var scaleXSq = te[ 0 ] * te[ 0 ] + te[ 1 ] * te[ 1 ] + te[ 2 ] * te[ 2 ];
			var scaleYSq = te[ 4 ] * te[ 4 ] + te[ 5 ] * te[ 5 ] + te[ 6 ] * te[ 6 ];
			var scaleZSq = te[ 8 ] * te[ 8 ] + te[ 9 ] * te[ 9 ] + te[ 10 ] * te[ 10 ];

			return Math.sqrt( Math.max( scaleXSq, scaleYSq, scaleZSq ) );

		},

		makeTranslation: function ( x, y, z ) {

			this.set(

				1, 0, 0, x,
				0, 1, 0, y,
				0, 0, 1, z,
				0, 0, 0, 1

			);

			return this;

		},

		makeRotationX: function ( theta ) {

			var c = Math.cos( theta ), s = Math.sin( theta );

			this.set(

				1, 0,  0, 0,
				0, c, - s, 0,
				0, s,  c, 0,
				0, 0,  0, 1

			);

			return this;

		},

		makeRotationY: function ( theta ) {

			var c = Math.cos( theta ), s = Math.sin( theta );

			this.set(

				 c, 0, s, 0,
				 0, 1, 0, 0,
				- s, 0, c, 0,
				 0, 0, 0, 1

			);

			return this;

		},

		makeRotationZ: function ( theta ) {

			var c = Math.cos( theta ), s = Math.sin( theta );

			this.set(

				c, - s, 0, 0,
				s,  c, 0, 0,
				0,  0, 1, 0,
				0,  0, 0, 1

			);

			return this;

		},

		makeRotationAxis: function ( axis, angle ) {

			// Based on http://www.gamedev.net/reference/articles/article1199.asp

			var c = Math.cos( angle );
			var s = Math.sin( angle );
			var t = 1 - c;
			var x = axis.x, y = axis.y, z = axis.z;
			var tx = t * x, ty = t * y;

			this.set(

				tx * x + c, tx * y - s * z, tx * z + s * y, 0,
				tx * y + s * z, ty * y + c, ty * z - s * x, 0,
				tx * z - s * y, ty * z + s * x, t * z * z + c, 0,
				0, 0, 0, 1

			);

			 return this;

		},

		makeScale: function ( x, y, z ) {

			this.set(

				x, 0, 0, 0,
				0, y, 0, 0,
				0, 0, z, 0,
				0, 0, 0, 1

			);

			return this;

		},

		makeShear: function ( x, y, z ) {

			this.set(

				1, y, z, 0,
				x, 1, z, 0,
				x, y, 1, 0,
				0, 0, 0, 1

			);

			return this;

		},

		compose: function ( position, quaternion, scale ) {

			this.makeRotationFromQuaternion( quaternion );
			this.scale( scale );
			this.setPosition( position );

			return this;

		},

		decompose: function () {

			var vector = new Vector3();
			var matrix = new Matrix4();

			return function decompose( position, quaternion, scale ) {

				var te = this.elements;

				var sx = vector.set( te[ 0 ], te[ 1 ], te[ 2 ] ).length();
				var sy = vector.set( te[ 4 ], te[ 5 ], te[ 6 ] ).length();
				var sz = vector.set( te[ 8 ], te[ 9 ], te[ 10 ] ).length();

				// if determine is negative, we need to invert one scale
				var det = this.determinant();
				if ( det < 0 ) sx = - sx;

				position.x = te[ 12 ];
				position.y = te[ 13 ];
				position.z = te[ 14 ];

				// scale the rotation part
				matrix.copy( this );

				var invSX = 1 / sx;
				var invSY = 1 / sy;
				var invSZ = 1 / sz;

				matrix.elements[ 0 ] *= invSX;
				matrix.elements[ 1 ] *= invSX;
				matrix.elements[ 2 ] *= invSX;

				matrix.elements[ 4 ] *= invSY;
				matrix.elements[ 5 ] *= invSY;
				matrix.elements[ 6 ] *= invSY;

				matrix.elements[ 8 ] *= invSZ;
				matrix.elements[ 9 ] *= invSZ;
				matrix.elements[ 10 ] *= invSZ;

				quaternion.setFromRotationMatrix( matrix );

				scale.x = sx;
				scale.y = sy;
				scale.z = sz;

				return this;

			};

		}(),

		makePerspective: function ( left, right, top, bottom, near, far ) {

			if ( far === undefined ) {

				console.warn( 'THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.' );

			}

			var te = this.elements;
			var x = 2 * near / ( right - left );
			var y = 2 * near / ( top - bottom );

			var a = ( right + left ) / ( right - left );
			var b = ( top + bottom ) / ( top - bottom );
			var c = - ( far + near ) / ( far - near );
			var d = - 2 * far * near / ( far - near );

			te[ 0 ] = x;	te[ 4 ] = 0;	te[ 8 ] = a;	te[ 12 ] = 0;
			te[ 1 ] = 0;	te[ 5 ] = y;	te[ 9 ] = b;	te[ 13 ] = 0;
			te[ 2 ] = 0;	te[ 6 ] = 0;	te[ 10 ] = c;	te[ 14 ] = d;
			te[ 3 ] = 0;	te[ 7 ] = 0;	te[ 11 ] = - 1;	te[ 15 ] = 0;

			return this;

		},

		makeOrthographic: function ( left, right, top, bottom, near, far ) {

			var te = this.elements;
			var w = 1.0 / ( right - left );
			var h = 1.0 / ( top - bottom );
			var p = 1.0 / ( far - near );

			var x = ( right + left ) * w;
			var y = ( top + bottom ) * h;
			var z = ( far + near ) * p;

			te[ 0 ] = 2 * w;	te[ 4 ] = 0;	te[ 8 ] = 0;	te[ 12 ] = - x;
			te[ 1 ] = 0;	te[ 5 ] = 2 * h;	te[ 9 ] = 0;	te[ 13 ] = - y;
			te[ 2 ] = 0;	te[ 6 ] = 0;	te[ 10 ] = - 2 * p;	te[ 14 ] = - z;
			te[ 3 ] = 0;	te[ 7 ] = 0;	te[ 11 ] = 0;	te[ 15 ] = 1;

			return this;

		},

		equals: function ( matrix ) {

			var te = this.elements;
			var me = matrix.elements;

			for ( var i = 0; i < 16; i ++ ) {

				if ( te[ i ] !== me[ i ] ) return false;

			}

			return true;

		},

		fromArray: function ( array, offset ) {

			if ( offset === undefined ) offset = 0;

			for ( var i = 0; i < 16; i ++ ) {

				this.elements[ i ] = array[ i + offset ];

			}

			return this;

		},

		toArray: function ( array, offset ) {

			if ( array === undefined ) array = [];
			if ( offset === undefined ) offset = 0;

			var te = this.elements;

			array[ offset ] = te[ 0 ];
			array[ offset + 1 ] = te[ 1 ];
			array[ offset + 2 ] = te[ 2 ];
			array[ offset + 3 ] = te[ 3 ];

			array[ offset + 4 ] = te[ 4 ];
			array[ offset + 5 ] = te[ 5 ];
			array[ offset + 6 ] = te[ 6 ];
			array[ offset + 7 ] = te[ 7 ];

			array[ offset + 8 ] = te[ 8 ];
			array[ offset + 9 ] = te[ 9 ];
			array[ offset + 10 ] = te[ 10 ];
			array[ offset + 11 ] = te[ 11 ];

			array[ offset + 12 ] = te[ 12 ];
			array[ offset + 13 ] = te[ 13 ];
			array[ offset + 14 ] = te[ 14 ];
			array[ offset + 15 ] = te[ 15 ];

			return array;

		}

	} );

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	function DataTexture( data, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding ) {

		Texture.call( this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding );

		this.image = { data: data, width: width, height: height };

		this.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
		this.minFilter = minFilter !== undefined ? minFilter : NearestFilter;

		this.generateMipmaps = false;
		this.flipY = false;
		this.unpackAlignment = 1;

	}

	DataTexture.prototype = Object.create( Texture.prototype );
	DataTexture.prototype.constructor = DataTexture;

	DataTexture.prototype.isDataTexture = true;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function CubeTexture( images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding ) {

		images = images !== undefined ? images : [];
		mapping = mapping !== undefined ? mapping : CubeReflectionMapping;

		Texture.call( this, images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding );

		this.flipY = false;

	}

	CubeTexture.prototype = Object.create( Texture.prototype );
	CubeTexture.prototype.constructor = CubeTexture;

	CubeTexture.prototype.isCubeTexture = true;

	Object.defineProperty( CubeTexture.prototype, 'images', {

		get: function () {

			return this.image;

		},

		set: function ( value ) {

			this.image = value;

		}

	} );

	/**
	 * @author tschw
	 *
	 * Uniforms of a program.
	 * Those form a tree structure with a special top-level container for the root,
	 * which you get by calling 'new WebGLUniforms( gl, program, renderer )'.
	 *
	 *
	 * Properties of inner nodes including the top-level container:
	 *
	 * .seq - array of nested uniforms
	 * .map - nested uniforms by name
	 *
	 *
	 * Methods of all nodes except the top-level container:
	 *
	 * .setValue( gl, value, [renderer] )
	 *
	 * 		uploads a uniform value(s)
	 *  	the 'renderer' parameter is needed for sampler uniforms
	 *
	 *
	 * Static methods of the top-level container (renderer factorizations):
	 *
	 * .upload( gl, seq, values, renderer )
	 *
	 * 		sets uniforms in 'seq' to 'values[id].value'
	 *
	 * .seqWithValue( seq, values ) : filteredSeq
	 *
	 * 		filters 'seq' entries with corresponding entry in values
	 *
	 *
	 * Methods of the top-level container (renderer factorizations):
	 *
	 * .setValue( gl, name, value )
	 *
	 * 		sets uniform with  name 'name' to 'value'
	 *
	 * .set( gl, obj, prop )
	 *
	 * 		sets uniform from object and property with same name than uniform
	 *
	 * .setOptional( gl, obj, prop )
	 *
	 * 		like .set for an optional property of the object
	 *
	 */

	var emptyTexture = new Texture();
	var emptyCubeTexture = new CubeTexture();

	// --- Base for inner nodes (including the root) ---

	function UniformContainer() {

		this.seq = [];
		this.map = {};

	}

	// --- Utilities ---

	// Array Caches (provide typed arrays for temporary by size)

	var arrayCacheF32 = [];
	var arrayCacheI32 = [];

	// Float32Array caches used for uploading Matrix uniforms

	var mat4array = new Float32Array( 16 );
	var mat3array = new Float32Array( 9 );

	// Flattening for arrays of vectors and matrices

	function flatten( array, nBlocks, blockSize ) {

		var firstElem = array[ 0 ];

		if ( firstElem <= 0 || firstElem > 0 ) return array;
		// unoptimized: ! isNaN( firstElem )
		// see http://jacksondunstan.com/articles/983

		var n = nBlocks * blockSize,
			r = arrayCacheF32[ n ];

		if ( r === undefined ) {

			r = new Float32Array( n );
			arrayCacheF32[ n ] = r;

		}

		if ( nBlocks !== 0 ) {

			firstElem.toArray( r, 0 );

			for ( var i = 1, offset = 0; i !== nBlocks; ++ i ) {

				offset += blockSize;
				array[ i ].toArray( r, offset );

			}

		}

		return r;

	}

	// Texture unit allocation

	function allocTexUnits( renderer, n ) {

		var r = arrayCacheI32[ n ];

		if ( r === undefined ) {

			r = new Int32Array( n );
			arrayCacheI32[ n ] = r;

		}

		for ( var i = 0; i !== n; ++ i )
			r[ i ] = renderer.allocTextureUnit();

		return r;

	}

	// --- Setters ---

	// Note: Defining these methods externally, because they come in a bunch
	// and this way their names minify.

	// Single scalar

	function setValue1f( gl, v ) { gl.uniform1f( this.addr, v ); }
	function setValue1i( gl, v ) { gl.uniform1i( this.addr, v ); }

	// Single float vector (from flat array or THREE.VectorN)

	function setValue2fv( gl, v ) {

		if ( v.x === undefined ) gl.uniform2fv( this.addr, v );
		else gl.uniform2f( this.addr, v.x, v.y );

	}

	function setValue3fv( gl, v ) {

		if ( v.x !== undefined )
			gl.uniform3f( this.addr, v.x, v.y, v.z );
		else if ( v.r !== undefined )
			gl.uniform3f( this.addr, v.r, v.g, v.b );
		else
			gl.uniform3fv( this.addr, v );

	}

	function setValue4fv( gl, v ) {

		if ( v.x === undefined ) gl.uniform4fv( this.addr, v );
		else gl.uniform4f( this.addr, v.x, v.y, v.z, v.w );

	}

	// Single matrix (from flat array or MatrixN)

	function setValue2fm( gl, v ) {

		gl.uniformMatrix2fv( this.addr, false, v.elements || v );

	}

	function setValue3fm( gl, v ) {

		if ( v.elements === undefined ) {

			gl.uniformMatrix3fv( this.addr, false, v );

		} else {

			mat3array.set( v.elements );
			gl.uniformMatrix3fv( this.addr, false, mat3array );

		}

	}

	function setValue4fm( gl, v ) {

		if ( v.elements === undefined ) {

			gl.uniformMatrix4fv( this.addr, false, v );

		} else {

			mat4array.set( v.elements );
			gl.uniformMatrix4fv( this.addr, false, mat4array );

		}

	}

	// Single texture (2D / Cube)

	function setValueT1( gl, v, renderer ) {

		var unit = renderer.allocTextureUnit();
		gl.uniform1i( this.addr, unit );
		renderer.setTexture2D( v || emptyTexture, unit );

	}

	function setValueT6( gl, v, renderer ) {

		var unit = renderer.allocTextureUnit();
		gl.uniform1i( this.addr, unit );
		renderer.setTextureCube( v || emptyCubeTexture, unit );

	}

	// Integer / Boolean vectors or arrays thereof (always flat arrays)

	function setValue2iv( gl, v ) { gl.uniform2iv( this.addr, v ); }
	function setValue3iv( gl, v ) { gl.uniform3iv( this.addr, v ); }
	function setValue4iv( gl, v ) { gl.uniform4iv( this.addr, v ); }

	// Helper to pick the right setter for the singular case

	function getSingularSetter( type ) {

		switch ( type ) {

			case 0x1406: return setValue1f; // FLOAT
			case 0x8b50: return setValue2fv; // _VEC2
			case 0x8b51: return setValue3fv; // _VEC3
			case 0x8b52: return setValue4fv; // _VEC4

			case 0x8b5a: return setValue2fm; // _MAT2
			case 0x8b5b: return setValue3fm; // _MAT3
			case 0x8b5c: return setValue4fm; // _MAT4

			case 0x8b5e: case 0x8d66: return setValueT1; // SAMPLER_2D, SAMPLER_EXTERNAL_OES
			case 0x8b60: return setValueT6; // SAMPLER_CUBE

			case 0x1404: case 0x8b56: return setValue1i; // INT, BOOL
			case 0x8b53: case 0x8b57: return setValue2iv; // _VEC2
			case 0x8b54: case 0x8b58: return setValue3iv; // _VEC3
			case 0x8b55: case 0x8b59: return setValue4iv; // _VEC4

		}

	}

	// Array of scalars

	function setValue1fv( gl, v ) { gl.uniform1fv( this.addr, v ); }
	function setValue1iv( gl, v ) { gl.uniform1iv( this.addr, v ); }

	// Array of vectors (flat or from THREE classes)

	function setValueV2a( gl, v ) {

		gl.uniform2fv( this.addr, flatten( v, this.size, 2 ) );

	}

	function setValueV3a( gl, v ) {

		gl.uniform3fv( this.addr, flatten( v, this.size, 3 ) );

	}

	function setValueV4a( gl, v ) {

		gl.uniform4fv( this.addr, flatten( v, this.size, 4 ) );

	}

	// Array of matrices (flat or from THREE clases)

	function setValueM2a( gl, v ) {

		gl.uniformMatrix2fv( this.addr, false, flatten( v, this.size, 4 ) );

	}

	function setValueM3a( gl, v ) {

		gl.uniformMatrix3fv( this.addr, false, flatten( v, this.size, 9 ) );

	}

	function setValueM4a( gl, v ) {

		gl.uniformMatrix4fv( this.addr, false, flatten( v, this.size, 16 ) );

	}

	// Array of textures (2D / Cube)

	function setValueT1a( gl, v, renderer ) {

		var n = v.length,
			units = allocTexUnits( renderer, n );

		gl.uniform1iv( this.addr, units );

		for ( var i = 0; i !== n; ++ i ) {

			renderer.setTexture2D( v[ i ] || emptyTexture, units[ i ] );

		}

	}

	function setValueT6a( gl, v, renderer ) {

		var n = v.length,
			units = allocTexUnits( renderer, n );

		gl.uniform1iv( this.addr, units );

		for ( var i = 0; i !== n; ++ i ) {

			renderer.setTextureCube( v[ i ] || emptyCubeTexture, units[ i ] );

		}

	}

	// Helper to pick the right setter for a pure (bottom-level) array

	function getPureArraySetter( type ) {

		switch ( type ) {

			case 0x1406: return setValue1fv; // FLOAT
			case 0x8b50: return setValueV2a; // _VEC2
			case 0x8b51: return setValueV3a; // _VEC3
			case 0x8b52: return setValueV4a; // _VEC4

			case 0x8b5a: return setValueM2a; // _MAT2
			case 0x8b5b: return setValueM3a; // _MAT3
			case 0x8b5c: return setValueM4a; // _MAT4

			case 0x8b5e: return setValueT1a; // SAMPLER_2D
			case 0x8b60: return setValueT6a; // SAMPLER_CUBE

			case 0x1404: case 0x8b56: return setValue1iv; // INT, BOOL
			case 0x8b53: case 0x8b57: return setValue2iv; // _VEC2
			case 0x8b54: case 0x8b58: return setValue3iv; // _VEC3
			case 0x8b55: case 0x8b59: return setValue4iv; // _VEC4

		}

	}

	// --- Uniform Classes ---

	function SingleUniform( id, activeInfo, addr ) {

		this.id = id;
		this.addr = addr;
		this.setValue = getSingularSetter( activeInfo.type );

		// this.path = activeInfo.name; // DEBUG

	}

	function PureArrayUniform( id, activeInfo, addr ) {

		this.id = id;
		this.addr = addr;
		this.size = activeInfo.size;
		this.setValue = getPureArraySetter( activeInfo.type );

		// this.path = activeInfo.name; // DEBUG

	}

	function StructuredUniform( id ) {

		this.id = id;

		UniformContainer.call( this ); // mix-in

	}

	StructuredUniform.prototype.setValue = function ( gl, value ) {

		// Note: Don't need an extra 'renderer' parameter, since samplers
		// are not allowed in structured uniforms.

		var seq = this.seq;

		for ( var i = 0, n = seq.length; i !== n; ++ i ) {

			var u = seq[ i ];
			u.setValue( gl, value[ u.id ] );

		}

	};

	// --- Top-level ---

	// Parser - builds up the property tree from the path strings

	var RePathPart = /([\w\d_]+)(\])?(\[|\.)?/g;

	// extracts
	// 	- the identifier (member name or array index)
	//  - followed by an optional right bracket (found when array index)
	//  - followed by an optional left bracket or dot (type of subscript)
	//
	// Note: These portions can be read in a non-overlapping fashion and
	// allow straightforward parsing of the hierarchy that WebGL encodes
	// in the uniform names.

	function addUniform( container, uniformObject ) {

		container.seq.push( uniformObject );
		container.map[ uniformObject.id ] = uniformObject;

	}

	function parseUniform( activeInfo, addr, container ) {

		var path = activeInfo.name,
			pathLength = path.length;

		// reset RegExp object, because of the early exit of a previous run
		RePathPart.lastIndex = 0;

		for ( ; ; ) {

			var match = RePathPart.exec( path ),
				matchEnd = RePathPart.lastIndex,

				id = match[ 1 ],
				idIsIndex = match[ 2 ] === ']',
				subscript = match[ 3 ];

			if ( idIsIndex ) id = id | 0; // convert to integer

			if ( subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength ) {

				// bare name or "pure" bottom-level array "[0]" suffix

				addUniform( container, subscript === undefined ?
						new SingleUniform( id, activeInfo, addr ) :
						new PureArrayUniform( id, activeInfo, addr ) );

				break;

			} else {

				// step into inner node / create it in case it doesn't exist

				var map = container.map, next = map[ id ];

				if ( next === undefined ) {

					next = new StructuredUniform( id );
					addUniform( container, next );

				}

				container = next;

			}

		}

	}

	// Root Container

	function WebGLUniforms( gl, program, renderer ) {

		UniformContainer.call( this );

		this.renderer = renderer;

		var n = gl.getProgramParameter( program, gl.ACTIVE_UNIFORMS );

		for ( var i = 0; i < n; ++ i ) {

			var info = gl.getActiveUniform( program, i ),
				path = info.name,
				addr = gl.getUniformLocation( program, path );

			parseUniform( info, addr, this );

		}

	}

	WebGLUniforms.prototype.setValue = function ( gl, name, value ) {

		var u = this.map[ name ];

		if ( u !== undefined ) u.setValue( gl, value, this.renderer );

	};

	WebGLUniforms.prototype.setOptional = function ( gl, object, name ) {

		var v = object[ name ];

		if ( v !== undefined ) this.setValue( gl, name, v );

	};


	// Static interface

	WebGLUniforms.upload = function ( gl, seq, values, renderer ) {

		for ( var i = 0, n = seq.length; i !== n; ++ i ) {

			var u = seq[ i ],
				v = values[ u.id ];

			if ( v.needsUpdate !== false ) {

				// note: always updating when .needsUpdate is undefined
				u.setValue( gl, v.value, renderer );

			}

		}

	};

	WebGLUniforms.seqWithValue = function ( seq, values ) {

		var r = [];

		for ( var i = 0, n = seq.length; i !== n; ++ i ) {

			var u = seq[ i ];
			if ( u.id in values ) r.push( u );

		}

		return r;

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	var ColorKeywords = { 'aliceblue': 0xF0F8FF, 'antiquewhite': 0xFAEBD7, 'aqua': 0x00FFFF, 'aquamarine': 0x7FFFD4, 'azure': 0xF0FFFF,
		'beige': 0xF5F5DC, 'bisque': 0xFFE4C4, 'black': 0x000000, 'blanchedalmond': 0xFFEBCD, 'blue': 0x0000FF, 'blueviolet': 0x8A2BE2,
		'brown': 0xA52A2A, 'burlywood': 0xDEB887, 'cadetblue': 0x5F9EA0, 'chartreuse': 0x7FFF00, 'chocolate': 0xD2691E, 'coral': 0xFF7F50,
		'cornflowerblue': 0x6495ED, 'cornsilk': 0xFFF8DC, 'crimson': 0xDC143C, 'cyan': 0x00FFFF, 'darkblue': 0x00008B, 'darkcyan': 0x008B8B,
		'darkgoldenrod': 0xB8860B, 'darkgray': 0xA9A9A9, 'darkgreen': 0x006400, 'darkgrey': 0xA9A9A9, 'darkkhaki': 0xBDB76B, 'darkmagenta': 0x8B008B,
		'darkolivegreen': 0x556B2F, 'darkorange': 0xFF8C00, 'darkorchid': 0x9932CC, 'darkred': 0x8B0000, 'darksalmon': 0xE9967A, 'darkseagreen': 0x8FBC8F,
		'darkslateblue': 0x483D8B, 'darkslategray': 0x2F4F4F, 'darkslategrey': 0x2F4F4F, 'darkturquoise': 0x00CED1, 'darkviolet': 0x9400D3,
		'deeppink': 0xFF1493, 'deepskyblue': 0x00BFFF, 'dimgray': 0x696969, 'dimgrey': 0x696969, 'dodgerblue': 0x1E90FF, 'firebrick': 0xB22222,
		'floralwhite': 0xFFFAF0, 'forestgreen': 0x228B22, 'fuchsia': 0xFF00FF, 'gainsboro': 0xDCDCDC, 'ghostwhite': 0xF8F8FF, 'gold': 0xFFD700,
		'goldenrod': 0xDAA520, 'gray': 0x808080, 'green': 0x008000, 'greenyellow': 0xADFF2F, 'grey': 0x808080, 'honeydew': 0xF0FFF0, 'hotpink': 0xFF69B4,
		'indianred': 0xCD5C5C, 'indigo': 0x4B0082, 'ivory': 0xFFFFF0, 'khaki': 0xF0E68C, 'lavender': 0xE6E6FA, 'lavenderblush': 0xFFF0F5, 'lawngreen': 0x7CFC00,
		'lemonchiffon': 0xFFFACD, 'lightblue': 0xADD8E6, 'lightcoral': 0xF08080, 'lightcyan': 0xE0FFFF, 'lightgoldenrodyellow': 0xFAFAD2, 'lightgray': 0xD3D3D3,
		'lightgreen': 0x90EE90, 'lightgrey': 0xD3D3D3, 'lightpink': 0xFFB6C1, 'lightsalmon': 0xFFA07A, 'lightseagreen': 0x20B2AA, 'lightskyblue': 0x87CEFA,
		'lightslategray': 0x778899, 'lightslategrey': 0x778899, 'lightsteelblue': 0xB0C4DE, 'lightyellow': 0xFFFFE0, 'lime': 0x00FF00, 'limegreen': 0x32CD32,
		'linen': 0xFAF0E6, 'magenta': 0xFF00FF, 'maroon': 0x800000, 'mediumaquamarine': 0x66CDAA, 'mediumblue': 0x0000CD, 'mediumorchid': 0xBA55D3,
		'mediumpurple': 0x9370DB, 'mediumseagreen': 0x3CB371, 'mediumslateblue': 0x7B68EE, 'mediumspringgreen': 0x00FA9A, 'mediumturquoise': 0x48D1CC,
		'mediumvioletred': 0xC71585, 'midnightblue': 0x191970, 'mintcream': 0xF5FFFA, 'mistyrose': 0xFFE4E1, 'moccasin': 0xFFE4B5, 'navajowhite': 0xFFDEAD,
		'navy': 0x000080, 'oldlace': 0xFDF5E6, 'olive': 0x808000, 'olivedrab': 0x6B8E23, 'orange': 0xFFA500, 'orangered': 0xFF4500, 'orchid': 0xDA70D6,
		'palegoldenrod': 0xEEE8AA, 'palegreen': 0x98FB98, 'paleturquoise': 0xAFEEEE, 'palevioletred': 0xDB7093, 'papayawhip': 0xFFEFD5, 'peachpuff': 0xFFDAB9,
		'peru': 0xCD853F, 'pink': 0xFFC0CB, 'plum': 0xDDA0DD, 'powderblue': 0xB0E0E6, 'purple': 0x800080, 'rebeccapurple': 0x663399, 'red': 0xFF0000, 'rosybrown': 0xBC8F8F,
		'royalblue': 0x4169E1, 'saddlebrown': 0x8B4513, 'salmon': 0xFA8072, 'sandybrown': 0xF4A460, 'seagreen': 0x2E8B57, 'seashell': 0xFFF5EE,
		'sienna': 0xA0522D, 'silver': 0xC0C0C0, 'skyblue': 0x87CEEB, 'slateblue': 0x6A5ACD, 'slategray': 0x708090, 'slategrey': 0x708090, 'snow': 0xFFFAFA,
		'springgreen': 0x00FF7F, 'steelblue': 0x4682B4, 'tan': 0xD2B48C, 'teal': 0x008080, 'thistle': 0xD8BFD8, 'tomato': 0xFF6347, 'turquoise': 0x40E0D0,
		'violet': 0xEE82EE, 'wheat': 0xF5DEB3, 'white': 0xFFFFFF, 'whitesmoke': 0xF5F5F5, 'yellow': 0xFFFF00, 'yellowgreen': 0x9ACD32 };

	function Color( r, g, b ) {

		if ( g === undefined && b === undefined ) {

			// r is THREE.Color, hex or string
			return this.set( r );

		}

		return this.setRGB( r, g, b );

	}

	Object.assign( Color.prototype, {

		isColor: true,

		r: 1, g: 1, b: 1,

		set: function ( value ) {

			if ( value && value.isColor ) {

				this.copy( value );

			} else if ( typeof value === 'number' ) {

				this.setHex( value );

			} else if ( typeof value === 'string' ) {

				this.setStyle( value );

			}

			return this;

		},

		setScalar: function ( scalar ) {

			this.r = scalar;
			this.g = scalar;
			this.b = scalar;

			return this;

		},

		setHex: function ( hex ) {

			hex = Math.floor( hex );

			this.r = ( hex >> 16 & 255 ) / 255;
			this.g = ( hex >> 8 & 255 ) / 255;
			this.b = ( hex & 255 ) / 255;

			return this;

		},

		setRGB: function ( r, g, b ) {

			this.r = r;
			this.g = g;
			this.b = b;

			return this;

		},

		setHSL: function () {

			function hue2rgb( p, q, t ) {

				if ( t < 0 ) t += 1;
				if ( t > 1 ) t -= 1;
				if ( t < 1 / 6 ) return p + ( q - p ) * 6 * t;
				if ( t < 1 / 2 ) return q;
				if ( t < 2 / 3 ) return p + ( q - p ) * 6 * ( 2 / 3 - t );
				return p;

			}

			return function setHSL( h, s, l ) {

				// h,s,l ranges are in 0.0 - 1.0
				h = _Math.euclideanModulo( h, 1 );
				s = _Math.clamp( s, 0, 1 );
				l = _Math.clamp( l, 0, 1 );

				if ( s === 0 ) {

					this.r = this.g = this.b = l;

				} else {

					var p = l <= 0.5 ? l * ( 1 + s ) : l + s - ( l * s );
					var q = ( 2 * l ) - p;

					this.r = hue2rgb( q, p, h + 1 / 3 );
					this.g = hue2rgb( q, p, h );
					this.b = hue2rgb( q, p, h - 1 / 3 );

				}

				return this;

			};

		}(),

		setStyle: function ( style ) {

			function handleAlpha( string ) {

				if ( string === undefined ) return;

				if ( parseFloat( string ) < 1 ) {

					console.warn( 'THREE.Color: Alpha component of ' + style + ' will be ignored.' );

				}

			}


			var m;

			if ( m = /^((?:rgb|hsl)a?)\(\s*([^\)]*)\)/.exec( style ) ) {

				// rgb / hsl

				var color;
				var name = m[ 1 ];
				var components = m[ 2 ];

				switch ( name ) {

					case 'rgb':
					case 'rgba':

						if ( color = /^(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec( components ) ) {

							// rgb(255,0,0) rgba(255,0,0,0.5)
							this.r = Math.min( 255, parseInt( color[ 1 ], 10 ) ) / 255;
							this.g = Math.min( 255, parseInt( color[ 2 ], 10 ) ) / 255;
							this.b = Math.min( 255, parseInt( color[ 3 ], 10 ) ) / 255;

							handleAlpha( color[ 5 ] );

							return this;

						}

						if ( color = /^(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec( components ) ) {

							// rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
							this.r = Math.min( 100, parseInt( color[ 1 ], 10 ) ) / 100;
							this.g = Math.min( 100, parseInt( color[ 2 ], 10 ) ) / 100;
							this.b = Math.min( 100, parseInt( color[ 3 ], 10 ) ) / 100;

							handleAlpha( color[ 5 ] );

							return this;

						}

						break;

					case 'hsl':
					case 'hsla':

						if ( color = /^([0-9]*\.?[0-9]+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec( components ) ) {

							// hsl(120,50%,50%) hsla(120,50%,50%,0.5)
							var h = parseFloat( color[ 1 ] ) / 360;
							var s = parseInt( color[ 2 ], 10 ) / 100;
							var l = parseInt( color[ 3 ], 10 ) / 100;

							handleAlpha( color[ 5 ] );

							return this.setHSL( h, s, l );

						}

						break;

				}

			} else if ( m = /^\#([A-Fa-f0-9]+)$/.exec( style ) ) {

				// hex color

				var hex = m[ 1 ];
				var size = hex.length;

				if ( size === 3 ) {

					// #ff0
					this.r = parseInt( hex.charAt( 0 ) + hex.charAt( 0 ), 16 ) / 255;
					this.g = parseInt( hex.charAt( 1 ) + hex.charAt( 1 ), 16 ) / 255;
					this.b = parseInt( hex.charAt( 2 ) + hex.charAt( 2 ), 16 ) / 255;

					return this;

				} else if ( size === 6 ) {

					// #ff0000
					this.r = parseInt( hex.charAt( 0 ) + hex.charAt( 1 ), 16 ) / 255;
					this.g = parseInt( hex.charAt( 2 ) + hex.charAt( 3 ), 16 ) / 255;
					this.b = parseInt( hex.charAt( 4 ) + hex.charAt( 5 ), 16 ) / 255;

					return this;

				}

			}

			if ( style && style.length > 0 ) {

				// color keywords
				var hex = ColorKeywords[ style ];

				if ( hex !== undefined ) {

					// red
					this.setHex( hex );

				} else {

					// unknown color
					console.warn( 'THREE.Color: Unknown color ' + style );

				}

			}

			return this;

		},

		clone: function () {

			return new this.constructor( this.r, this.g, this.b );

		},

		copy: function ( color ) {

			this.r = color.r;
			this.g = color.g;
			this.b = color.b;

			return this;

		},

		copyGammaToLinear: function ( color, gammaFactor ) {

			if ( gammaFactor === undefined ) gammaFactor = 2.0;

			this.r = Math.pow( color.r, gammaFactor );
			this.g = Math.pow( color.g, gammaFactor );
			this.b = Math.pow( color.b, gammaFactor );

			return this;

		},

		copyLinearToGamma: function ( color, gammaFactor ) {

			if ( gammaFactor === undefined ) gammaFactor = 2.0;

			var safeInverse = ( gammaFactor > 0 ) ? ( 1.0 / gammaFactor ) : 1.0;

			this.r = Math.pow( color.r, safeInverse );
			this.g = Math.pow( color.g, safeInverse );
			this.b = Math.pow( color.b, safeInverse );

			return this;

		},

		convertGammaToLinear: function () {

			var r = this.r, g = this.g, b = this.b;

			this.r = r * r;
			this.g = g * g;
			this.b = b * b;

			return this;

		},

		convertLinearToGamma: function () {

			this.r = Math.sqrt( this.r );
			this.g = Math.sqrt( this.g );
			this.b = Math.sqrt( this.b );

			return this;

		},

		getHex: function () {

			return ( this.r * 255 ) << 16 ^ ( this.g * 255 ) << 8 ^ ( this.b * 255 ) << 0;

		},

		getHexString: function () {

			return ( '000000' + this.getHex().toString( 16 ) ).slice( - 6 );

		},

		getHSL: function ( optionalTarget ) {

			// h,s,l ranges are in 0.0 - 1.0

			var hsl = optionalTarget || { h: 0, s: 0, l: 0 };

			var r = this.r, g = this.g, b = this.b;

			var max = Math.max( r, g, b );
			var min = Math.min( r, g, b );

			var hue, saturation;
			var lightness = ( min + max ) / 2.0;

			if ( min === max ) {

				hue = 0;
				saturation = 0;

			} else {

				var delta = max - min;

				saturation = lightness <= 0.5 ? delta / ( max + min ) : delta / ( 2 - max - min );

				switch ( max ) {

					case r: hue = ( g - b ) / delta + ( g < b ? 6 : 0 ); break;
					case g: hue = ( b - r ) / delta + 2; break;
					case b: hue = ( r - g ) / delta + 4; break;

				}

				hue /= 6;

			}

			hsl.h = hue;
			hsl.s = saturation;
			hsl.l = lightness;

			return hsl;

		},

		getStyle: function () {

			return 'rgb(' + ( ( this.r * 255 ) | 0 ) + ',' + ( ( this.g * 255 ) | 0 ) + ',' + ( ( this.b * 255 ) | 0 ) + ')';

		},

		offsetHSL: function ( h, s, l ) {

			var hsl = this.getHSL();

			hsl.h += h; hsl.s += s; hsl.l += l;

			this.setHSL( hsl.h, hsl.s, hsl.l );

			return this;

		},

		add: function ( color ) {

			this.r += color.r;
			this.g += color.g;
			this.b += color.b;

			return this;

		},

		addColors: function ( color1, color2 ) {

			this.r = color1.r + color2.r;
			this.g = color1.g + color2.g;
			this.b = color1.b + color2.b;

			return this;

		},

		addScalar: function ( s ) {

			this.r += s;
			this.g += s;
			this.b += s;

			return this;

		},

		sub: function( color ) {

			this.r = Math.max( 0, this.r - color.r );
			this.g = Math.max( 0, this.g - color.g );
			this.b = Math.max( 0, this.b - color.b );

			return this;

		},

		multiply: function ( color ) {

			this.r *= color.r;
			this.g *= color.g;
			this.b *= color.b;

			return this;

		},

		multiplyScalar: function ( s ) {

			this.r *= s;
			this.g *= s;
			this.b *= s;

			return this;

		},

		lerp: function ( color, alpha ) {

			this.r += ( color.r - this.r ) * alpha;
			this.g += ( color.g - this.g ) * alpha;
			this.b += ( color.b - this.b ) * alpha;

			return this;

		},

		equals: function ( c ) {

			return ( c.r === this.r ) && ( c.g === this.g ) && ( c.b === this.b );

		},

		fromArray: function ( array, offset ) {

			if ( offset === undefined ) offset = 0;

			this.r = array[ offset ];
			this.g = array[ offset + 1 ];
			this.b = array[ offset + 2 ];

			return this;

		},

		toArray: function ( array, offset ) {

			if ( array === undefined ) array = [];
			if ( offset === undefined ) offset = 0;

			array[ offset ] = this.r;
			array[ offset + 1 ] = this.g;
			array[ offset + 2 ] = this.b;

			return array;

		},

		toJSON: function () {

			return this.getHex();

		}

	} );

	/**
	 * Uniforms library for shared webgl shaders
	 */

	var UniformsLib = {

		common: {

			diffuse: { value: new Color( 0xeeeeee ) },
			opacity: { value: 1.0 },

			map: { value: null },
			offsetRepeat: { value: new Vector4( 0, 0, 1, 1 ) },

			alphaMap: { value: null },

		},

		specularmap: {

			specularMap: { value: null },

		},

		envmap: {

			envMap: { value: null },
			flipEnvMap: { value: - 1 },
			reflectivity: { value: 1.0 },
			refractionRatio: { value: 0.98 }

		},

		aomap: {

			aoMap: { value: null },
			aoMapIntensity: { value: 1 }

		},

		lightmap: {

			lightMap: { value: null },
			lightMapIntensity: { value: 1 }

		},

		emissivemap: {

			emissiveMap: { value: null }

		},

		bumpmap: {

			bumpMap: { value: null },
			bumpScale: { value: 1 }

		},

		normalmap: {

			normalMap: { value: null },
			normalScale: { value: new Vector2( 1, 1 ) }

		},

		displacementmap: {

			displacementMap: { value: null },
			displacementScale: { value: 1 },
			displacementBias: { value: 0 }

		},

		roughnessmap: {

			roughnessMap: { value: null }

		},

		metalnessmap: {

			metalnessMap: { value: null }

		},

		gradientmap: {

			gradientMap: { value: null }

		},

		fog: {

			fogDensity: { value: 0.00025 },
			fogNear: { value: 1 },
			fogFar: { value: 2000 },
			fogColor: { value: new Color( 0xffffff ) }

		},

		lights: {

			ambientLightColor: { value: [] },

			directionalLights: { value: [], properties: {
				direction: {},
				color: {},

				shadow: {},
				shadowBias: {},
				shadowRadius: {},
				shadowMapSize: {}
			} },

			directionalShadowMap: { value: [] },
			directionalShadowMatrix: { value: [] },

			spotLights: { value: [], properties: {
				color: {},
				position: {},
				direction: {},
				distance: {},
				coneCos: {},
				penumbraCos: {},
				decay: {},

				shadow: {},
				shadowBias: {},
				shadowRadius: {},
				shadowMapSize: {}
			} },

			spotShadowMap: { value: [] },
			spotShadowMatrix: { value: [] },

			pointLights: { value: [], properties: {
				color: {},
				position: {},
				decay: {},
				distance: {},

				shadow: {},
				shadowBias: {},
				shadowRadius: {},
				shadowMapSize: {},
				shadowCameraNear: {},
				shadowCameraFar: {}
			} },

			pointShadowMap: { value: [] },
			pointShadowMatrix: { value: [] },

			hemisphereLights: { value: [], properties: {
				direction: {},
				skyColor: {},
				groundColor: {}
			} },

			// TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
			rectAreaLights: { value: [], properties: {
				color: {},
				position: {},
				width: {},
				height: {}
			} }

		},

		points: {

			diffuse: { value: new Color( 0xeeeeee ) },
			opacity: { value: 1.0 },
			size: { value: 1.0 },
			scale: { value: 1.0 },
			map: { value: null },
			offsetRepeat: { value: new Vector4( 0, 0, 1, 1 ) }

		}

	};

	/**
	 * Uniform Utilities
	 */

	var UniformsUtils = {

		merge: function ( uniforms ) {

			var merged = {};

			for ( var u = 0; u < uniforms.length; u ++ ) {

				var tmp = this.clone( uniforms[ u ] );

				for ( var p in tmp ) {

					merged[ p ] = tmp[ p ];

				}

			}

			return merged;

		},

		clone: function ( uniforms_src ) {

			var uniforms_dst = {};

			for ( var u in uniforms_src ) {

				uniforms_dst[ u ] = {};

				for ( var p in uniforms_src[ u ] ) {

					var parameter_src = uniforms_src[ u ][ p ];

					if ( parameter_src && ( parameter_src.isColor ||
						parameter_src.isMatrix3 || parameter_src.isMatrix4 ||
						parameter_src.isVector2 || parameter_src.isVector3 || parameter_src.isVector4 ||
						parameter_src.isTexture ) ) {

						uniforms_dst[ u ][ p ] = parameter_src.clone();

					} else if ( Array.isArray( parameter_src ) ) {

						uniforms_dst[ u ][ p ] = parameter_src.slice();

					} else {

						uniforms_dst[ u ][ p ] = parameter_src;

					}

				}

			}

			return uniforms_dst;

		}

	};

	var alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif\n";

	var alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif\n";

	var alphatest_fragment = "#ifdef ALPHATEST\n\tif ( diffuseColor.a < ALPHATEST ) discard;\n#endif\n";

	var aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.specularRoughness );\n\t#endif\n#endif\n";

	var aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";

	var begin_vertex = "\nvec3 transformed = vec3( position );\n";

	var beginnormal_vertex = "\nvec3 objectNormal = vec3( normal );\n";

	var bsdfs = "float punctualLightIntensityToIrradianceFactor( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tif( decayExponent > 0.0 ) {\n#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tfloat maxDistanceCutoffFactor = pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\treturn distanceFalloff * maxDistanceCutoffFactor;\n#else\n\t\treturn pow( saturate( -lightDistance / cutoffDistance + 1.0 ), decayExponent );\n#endif\n\t}\n\treturn 1.0;\n}\nvec3 BRDF_Diffuse_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 specularColor, const in float dotLH ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotLH - 6.98316 ) * dotLH );\n\treturn ( 1.0 - specularColor ) * fresnel + specularColor;\n}\nfloat G_GGX_Smith( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gl = dotNL + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\tfloat gv = dotNV + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\treturn 1.0 / ( gl * gv );\n}\nfloat G_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_Specular_GGX( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNL = saturate( dot( geometry.normal, incidentLight.direction ) );\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( G * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE  = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS  = 0.5 / LUT_SIZE;\n\tfloat theta = acos( dot( N, V ) );\n\tvec2 uv = vec2(\n\t\tsqrt( saturate( roughness ) ),\n\t\tsaturate( theta / ( 0.5 * PI ) ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.86267 + (0.49788 + 0.01436 * y ) * y;\n\tfloat b = 3.45068 + (4.18814 + y) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = (x > 0.0) ? v : 0.5 * inversesqrt( 1.0 - x * x ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transpose( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tvec3 result = vec3( LTC_ClippedSphereFormFactor( vectorFormFactor ) );\n\treturn result;\n}\nvec3 BRDF_Specular_GGX_Environment( const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 AB = vec2( -1.04, 1.04 ) * a004 + r.zw;\n\treturn specularColor * AB.x + AB.y;\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_Specular_BlinnPhong( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\nfloat GGXRoughnessToBlinnExponent( const in float ggxRoughness ) {\n\treturn ( 2.0 / pow2( ggxRoughness + 0.0001 ) - 2.0 );\n}\nfloat BlinnExponentToGGXRoughness( const in float blinnExponent ) {\n\treturn sqrt( 2.0 / ( blinnExponent + 2.0 ) );\n}\n";

	var bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy ) {\n\t\tvec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n\t\tvec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 );\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif\n";

	var clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; ++ i ) {\n\t\tvec4 plane = clippingPlanes[ i ];\n\t\tif ( dot( vViewPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t\t\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; ++ i ) {\n\t\t\tvec4 plane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vViewPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\tif ( clipped ) discard;\n\t\n\t#endif\n#endif\n";

	var clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\t#if ! defined( PHYSICAL ) && ! defined( PHONG )\n\t\tvarying vec3 vViewPosition;\n\t#endif\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif\n";

	var clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvarying vec3 vViewPosition;\n#endif\n";

	var clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n";

	var color_fragment = "#ifdef USE_COLOR\n\tdiffuseColor.rgb *= vColor;\n#endif";

	var color_pars_fragment = "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif\n";

	var color_pars_vertex = "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif";

	var color_vertex = "#ifdef USE_COLOR\n\tvColor.xyz = color.xyz;\n#endif";

	var common = "#define PI 3.14159265359\n#define PI2 6.28318530718\n#define PI_HALF 1.5707963267949\n#define RECIPROCAL_PI 0.31830988618\n#define RECIPROCAL_PI2 0.15915494\n#define LOG2 1.442695\n#define EPSILON 1e-6\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#define whiteCompliment(a) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract(sin(sn) * c);\n}\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nvec3 projectOnPlane(in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\tfloat distance = dot( planeNormal, point - pointOnPlane );\n\treturn - distance * planeNormal + point;\n}\nfloat sideOfPlane( in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn sign( dot( point - pointOnPlane, planeNormal ) );\n}\nvec3 linePlaneIntersect( in vec3 pointOnLine, in vec3 lineDirection, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn lineDirection * ( dot( planeNormal, pointOnPlane - pointOnLine ) / dot( planeNormal, lineDirection ) ) + pointOnLine;\n}\nmat3 transpose( const in mat3 v ) {\n\tmat3 tmp;\n\ttmp[0] = vec3(v[0].x, v[1].x, v[2].x);\n\ttmp[1] = vec3(v[0].y, v[1].y, v[2].y);\n\ttmp[2] = vec3(v[0].z, v[1].z, v[2].z);\n\treturn tmp;\n}\n";

	var cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n#define cubeUV_textureSize (1024.0)\nint getFaceFromDirection(vec3 direction) {\n\tvec3 absDirection = abs(direction);\n\tint face = -1;\n\tif( absDirection.x > absDirection.z ) {\n\t\tif(absDirection.x > absDirection.y )\n\t\t\tface = direction.x > 0.0 ? 0 : 3;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\telse {\n\t\tif(absDirection.z > absDirection.y )\n\t\t\tface = direction.z > 0.0 ? 2 : 5;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\treturn face;\n}\n#define cubeUV_maxLods1  (log2(cubeUV_textureSize*0.25) - 1.0)\n#define cubeUV_rangeClamp (exp2((6.0 - 1.0) * 2.0))\nvec2 MipLevelInfo( vec3 vec, float roughnessLevel, float roughness ) {\n\tfloat scale = exp2(cubeUV_maxLods1 - roughnessLevel);\n\tfloat dxRoughness = dFdx(roughness);\n\tfloat dyRoughness = dFdy(roughness);\n\tvec3 dx = dFdx( vec * scale * dxRoughness );\n\tvec3 dy = dFdy( vec * scale * dyRoughness );\n\tfloat d = max( dot( dx, dx ), dot( dy, dy ) );\n\td = clamp(d, 1.0, cubeUV_rangeClamp);\n\tfloat mipLevel = 0.5 * log2(d);\n\treturn vec2(floor(mipLevel), fract(mipLevel));\n}\n#define cubeUV_maxLods2 (log2(cubeUV_textureSize*0.25) - 2.0)\n#define cubeUV_rcpTextureSize (1.0 / cubeUV_textureSize)\nvec2 getCubeUV(vec3 direction, float roughnessLevel, float mipLevel) {\n\tmipLevel = roughnessLevel > cubeUV_maxLods2 - 3.0 ? 0.0 : mipLevel;\n\tfloat a = 16.0 * cubeUV_rcpTextureSize;\n\tvec2 exp2_packed = exp2( vec2( roughnessLevel, mipLevel ) );\n\tvec2 rcp_exp2_packed = vec2( 1.0 ) / exp2_packed;\n\tfloat powScale = exp2_packed.x * exp2_packed.y;\n\tfloat scale = rcp_exp2_packed.x * rcp_exp2_packed.y * 0.25;\n\tfloat mipOffset = 0.75*(1.0 - rcp_exp2_packed.y) * rcp_exp2_packed.x;\n\tbool bRes = mipLevel == 0.0;\n\tscale =  bRes && (scale < a) ? a : scale;\n\tvec3 r;\n\tvec2 offset;\n\tint face = getFaceFromDirection(direction);\n\tfloat rcpPowScale = 1.0 / powScale;\n\tif( face == 0) {\n\t\tr = vec3(direction.x, -direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 1) {\n\t\tr = vec3(direction.y, direction.x, direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 2) {\n\t\tr = vec3(direction.z, direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 3) {\n\t\tr = vec3(direction.x, direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\telse if( face == 4) {\n\t\tr = vec3(direction.y, direction.x, -direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\telse {\n\t\tr = vec3(direction.z, -direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\tr = normalize(r);\n\tfloat texelOffset = 0.5 * cubeUV_rcpTextureSize;\n\tvec2 s = ( r.yz / abs( r.x ) + vec2( 1.0 ) ) * 0.5;\n\tvec2 base = offset + vec2( texelOffset );\n\treturn base + s * ( scale - 2.0 * texelOffset );\n}\n#define cubeUV_maxLods3 (log2(cubeUV_textureSize*0.25) - 3.0)\nvec4 textureCubeUV(vec3 reflectedDirection, float roughness ) {\n\tfloat roughnessVal = roughness* cubeUV_maxLods3;\n\tfloat r1 = floor(roughnessVal);\n\tfloat r2 = r1 + 1.0;\n\tfloat t = fract(roughnessVal);\n\tvec2 mipInfo = MipLevelInfo(reflectedDirection, r1, roughness);\n\tfloat s = mipInfo.y;\n\tfloat level0 = mipInfo.x;\n\tfloat level1 = level0 + 1.0;\n\tlevel1 = level1 > 5.0 ? 5.0 : level1;\n\tlevel0 += min( floor( s + 0.5 ), 5.0 );\n\tvec2 uv_10 = getCubeUV(reflectedDirection, r1, level0);\n\tvec4 color10 = envMapTexelToLinear(texture2D(envMap, uv_10));\n\tvec2 uv_20 = getCubeUV(reflectedDirection, r2, level0);\n\tvec4 color20 = envMapTexelToLinear(texture2D(envMap, uv_20));\n\tvec4 result = mix(color10, color20, t);\n\treturn vec4(result.rgb, 1.0);\n}\n#endif\n";

	var defaultnormal_vertex = "vec3 transformedNormal = normalMatrix * objectNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n";

	var displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif\n";

	var displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, uv ).x * displacementScale + displacementBias );\n#endif\n";

	var emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\temissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif\n";

	var emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif\n";

	var encodings_fragment = "  gl_FragColor = linearToOutputTexel( gl_FragColor );\n";

	var encodings_pars_fragment = "\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 GammaToLinear( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.xyz, vec3( gammaFactor ) ), value.w );\n}\nvec4 LinearToGamma( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.xyz, vec3( 1.0 / gammaFactor ) ), value.w );\n}\nvec4 sRGBToLinear( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.w );\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.w );\n}\nvec4 RGBEToLinear( in vec4 value ) {\n\treturn vec4( value.rgb * exp2( value.a * 255.0 - 128.0 ), 1.0 );\n}\nvec4 LinearToRGBE( in vec4 value ) {\n\tfloat maxComponent = max( max( value.r, value.g ), value.b );\n\tfloat fExp = clamp( ceil( log2( maxComponent ) ), -128.0, 127.0 );\n\treturn vec4( value.rgb / exp2( fExp ), ( fExp + 128.0 ) / 255.0 );\n}\nvec4 RGBMToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.xyz * value.w * maxRange, 1.0 );\n}\nvec4 LinearToRGBM( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.x, max( value.g, value.b ) );\n\tfloat M      = clamp( maxRGB / maxRange, 0.0, 1.0 );\n\tM            = ceil( M * 255.0 ) / 255.0;\n\treturn vec4( value.rgb / ( M * maxRange ), M );\n}\nvec4 RGBDToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * ( ( maxRange / 255.0 ) / value.a ), 1.0 );\n}\nvec4 LinearToRGBD( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.x, max( value.g, value.b ) );\n\tfloat D      = max( maxRange / maxRGB, 1.0 );\n\tD            = min( floor( D ) / 255.0, 1.0 );\n\treturn vec4( value.rgb * ( D * ( 255.0 / maxRange ) ), D );\n}\nconst mat3 cLogLuvM = mat3( 0.2209, 0.3390, 0.4184, 0.1138, 0.6780, 0.7319, 0.0102, 0.1130, 0.2969 );\nvec4 LinearToLogLuv( in vec4 value )  {\n\tvec3 Xp_Y_XYZp = value.rgb * cLogLuvM;\n\tXp_Y_XYZp = max(Xp_Y_XYZp, vec3(1e-6, 1e-6, 1e-6));\n\tvec4 vResult;\n\tvResult.xy = Xp_Y_XYZp.xy / Xp_Y_XYZp.z;\n\tfloat Le = 2.0 * log2(Xp_Y_XYZp.y) + 127.0;\n\tvResult.w = fract(Le);\n\tvResult.z = (Le - (floor(vResult.w*255.0))/255.0)/255.0;\n\treturn vResult;\n}\nconst mat3 cLogLuvInverseM = mat3( 6.0014, -2.7008, -1.7996, -1.3320, 3.1029, -5.7721, 0.3008, -1.0882, 5.6268 );\nvec4 LogLuvToLinear( in vec4 value ) {\n\tfloat Le = value.z * 255.0 + value.w;\n\tvec3 Xp_Y_XYZp;\n\tXp_Y_XYZp.y = exp2((Le - 127.0) / 2.0);\n\tXp_Y_XYZp.z = Xp_Y_XYZp.y / value.y;\n\tXp_Y_XYZp.x = value.x * Xp_Y_XYZp.z;\n\tvec3 vRGB = Xp_Y_XYZp.rgb * cLogLuvInverseM;\n\treturn vec4( max(vRGB, 0.0), 1.0 );\n}\n";

	var envmap_fragment = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvec3 cameraToVertex = normalize( vWorldPosition - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\tvec2 sampleUV;\n\t\treflectVec = normalize( reflectVec );\n\t\tsampleUV.y = asin( clamp( reflectVec.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\t\tsampleUV.x = atan( reflectVec.z, reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\tvec4 envColor = texture2D( envMap, sampleUV );\n\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\treflectVec = normalize( reflectVec );\n\t\tvec3 reflectView = normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0, 0.0, 1.0 ) );\n\t\tvec4 envColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\tenvColor = envMapTexelToLinear( envColor );\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif\n";

	var envmap_pars_fragment = "#if defined( USE_ENVMAP ) || defined( PHYSICAL )\n\tuniform float reflectivity;\n\tuniform float envMapIntensity;\n#endif\n#ifdef USE_ENVMAP\n\t#if ! defined( PHYSICAL ) && ( defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) )\n\t\tvarying vec3 vWorldPosition;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\tuniform float flipEnvMap;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( PHYSICAL )\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif\n";

	var envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif\n";

	var envmap_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif\n";

	var fog_vertex = "\n#ifdef USE_FOG\nfogDepth = -mvPosition.z;\n#endif";

	var fog_pars_vertex = "#ifdef USE_FOG\n  varying float fogDepth;\n#endif\n";

	var fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = whiteCompliment( exp2( - fogDensity * fogDensity * fogDepth * fogDepth * LOG2 ) );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif\n";

	var fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float fogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif\n";

	var gradientmap_pars_fragment = "#ifdef TOON\n\tuniform sampler2D gradientMap;\n\tvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\t\tfloat dotNL = dot( normal, lightDirection );\n\t\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t\t#ifdef USE_GRADIENTMAP\n\t\t\treturn texture2D( gradientMap, coord ).rgb;\n\t\t#else\n\t\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t\t#endif\n\t}\n#endif\n";

	var lightmap_fragment = "#ifdef USE_LIGHTMAP\n\treflectedLight.indirectDiffuse += PI * texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n#endif\n";

	var lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";

	var lights_lambert_vertex = "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\n#if NUM_POINT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointDirectLightIrradiance( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotDirectLightIrradiance( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_DIR_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalDirectLightIrradiance( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvLightFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry );\n\t\t#endif\n\t}\n#endif\n";

	var lights_pars = "uniform vec3 ambientLightColor;\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treturn irradiance;\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalDirectLightIrradiance( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tdirectLight.color = directionalLight.color;\n\t\tdirectLight.direction = directionalLight.direction;\n\t\tdirectLight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t\tfloat shadowCameraNear;\n\t\tfloat shadowCameraFar;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointDirectLightIrradiance( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tdirectLight.color = pointLight.color;\n\t\tdirectLight.color *= punctualLightIntensityToIrradianceFactor( lightDistance, pointLight.distance, pointLight.decay );\n\t\tdirectLight.visible = ( directLight.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotDirectLightIrradiance( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight directLight  ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tfloat angleCos = dot( directLight.direction, spotLight.direction );\n\t\tif ( angleCos > spotLight.coneCos ) {\n\t\t\tfloat spotEffect = smoothstep( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\t\tdirectLight.color = spotLight.color;\n\t\t\tdirectLight.color *= spotEffect * punctualLightIntensityToIrradianceFactor( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tdirectLight.visible = true;\n\t\t} else {\n\t\t\tdirectLight.color = vec3( 0.0 );\n\t\t\tdirectLight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltcMat;\tuniform sampler2D ltcMag;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in GeometricContext geometry ) {\n\t\tfloat dotNL = dot( geometry.normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tirradiance *= PI;\n\t\t#endif\n\t\treturn irradiance;\n\t}\n#endif\n#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\tvec3 getLightProbeIndirectIrradiance( const in GeometricContext geometry, const in int maxMIPLevel ) {\n\t\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\tvec4 envMapColor = textureCubeUV( queryVec, 1.0 );\n\t\t#else\n\t\t\tvec4 envMapColor = vec4( 0.0 );\n\t\t#endif\n\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t}\n\tfloat getSpecularMIPLevel( const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\tfloat maxMIPLevelScalar = float( maxMIPLevel );\n\t\tfloat desiredMIPLevel = maxMIPLevelScalar - 0.79248 - 0.5 * log2( pow2( blinnShininessExponent ) + 1.0 );\n\t\treturn clamp( desiredMIPLevel, 0.0, maxMIPLevelScalar );\n\t}\n\tvec3 getLightProbeIndirectRadiance( const in GeometricContext geometry, const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( -geometry.viewDir, geometry.normal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( -geometry.viewDir, geometry.normal, refractionRatio );\n\t\t#endif\n\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\tfloat specularMIPLevel = getSpecularMIPLevel( blinnShininessExponent, maxMIPLevel );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\tvec4 envMapColor = textureCubeUV(queryReflectVec, BlinnExponentToGGXRoughness(blinnShininessExponent));\n\t\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\t\tvec2 sampleUV;\n\t\t\tsampleUV.y = asin( clamp( reflectVec.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\t\t\tsampleUV.x = atan( reflectVec.z, reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, sampleUV, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, sampleUV, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\t\tvec3 reflectView = normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0,0.0,1.0 ) );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#endif\n\t\treturn envMapColor.rgb * envMapIntensity;\n\t}\n#endif\n";

	var lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;\n";

	var lights_phong_pars_fragment = "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct BlinnPhongMaterial {\n\tvec3\tdiffuseColor;\n\tvec3\tspecularColor;\n\tfloat\tspecularShininess;\n\tfloat\tspecularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifdef TOON\n\t\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\t#else\n\t\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\t\tvec3 irradiance = dotNL * directLight.color;\n\t#endif\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_Specular_BlinnPhong( directLight, geometry, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)\n";

	var lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nmaterial.specularRoughness = clamp( roughnessFactor, 0.04, 1.0 );\n#ifdef STANDARD\n\tmaterial.specularColor = mix( vec3( DEFAULT_SPECULAR_COEFFICIENT ), diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( MAXIMUM_SPECULAR_COEFFICIENT * pow2( reflectivity ) ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.clearCoat = saturate( clearCoat );\tmaterial.clearCoatRoughness = clamp( clearCoatRoughness, 0.04, 1.0 );\n#endif\n";

	var lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3\tdiffuseColor;\n\tfloat\tspecularRoughness;\n\tvec3\tspecularColor;\n\t#ifndef STANDARD\n\t\tfloat clearCoat;\n\t\tfloat clearCoatRoughness;\n\t#endif\n};\n#define MAXIMUM_SPECULAR_COEFFICIENT 0.16\n#define DEFAULT_SPECULAR_COEFFICIENT 0.04\nfloat clearCoatDHRApprox( const in float roughness, const in float dotNL ) {\n\treturn DEFAULT_SPECULAR_COEFFICIENT + ( 1.0 - DEFAULT_SPECULAR_COEFFICIENT ) * ( pow( 1.0 - dotNL, 5.0 ) * pow( 1.0 - roughness, 2.0 ) );\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.specularRoughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos - halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos + halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos + halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos - halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tfloat norm = texture2D( ltcMag, uv ).a;\n\t\tvec4 t = texture2D( ltcMat, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3(   1,   0, t.y ),\n\t\t\tvec3(   0, t.z,   0 ),\n\t\t\tvec3( t.w,   0, t.x )\n\t\t);\n\t\treflectedLight.directSpecular += lightColor * material.specularColor * norm * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\t#ifndef STANDARD\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.directSpecular += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Specular_GGX( directLight, geometry, material.specularColor, material.specularRoughness );\n\treflectedLight.directDiffuse += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\t#ifndef STANDARD\n\t\treflectedLight.directSpecular += irradiance * material.clearCoat * BRDF_Specular_GGX( directLight, geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 clearCoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifndef STANDARD\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\tfloat dotNL = dotNV;\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.indirectSpecular += ( 1.0 - clearCoatDHR ) * radiance * BRDF_Specular_GGX_Environment( geometry, material.specularColor, material.specularRoughness );\n\t#ifndef STANDARD\n\t\treflectedLight.indirectSpecular += clearCoatRadiance * material.clearCoat * BRDF_Specular_GGX_Environment( geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\n#define Material_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.specularRoughness )\n#define Material_ClearCoat_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.clearCoatRoughness )\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}\n";

	var lights_template = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = normalize( vViewPosition );\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointDirectLightIrradiance( pointLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( pointLight.shadow, directLight.visible ) ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotDirectLightIrradiance( spotLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( spotLight.shadow, directLight.visible ) ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalDirectLightIrradiance( directionalLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( directionalLight.shadow, directLight.visible ) ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#ifdef USE_LIGHTMAP\n\t\tvec3 lightMapIrradiance = texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tlightMapIrradiance *= PI;\n\t\t#endif\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t}\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tirradiance += getLightProbeIndirectIrradiance( geometry, 8 );\n\t#endif\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tvec3 radiance = getLightProbeIndirectRadiance( geometry, Material_BlinnShininessExponent( material ), 8 );\n\t#ifndef STANDARD\n\t\tvec3 clearCoatRadiance = getLightProbeIndirectRadiance( geometry, Material_ClearCoat_BlinnShininessExponent( material ), 8 );\n\t#else\n\t\tvec3 clearCoatRadiance = vec3( 0.0 );\n\t#endif\n\tRE_IndirectSpecular( radiance, clearCoatRadiance, geometry, material, reflectedLight );\n#endif\n";

	var logdepthbuf_fragment = "#if defined(USE_LOGDEPTHBUF) && defined(USE_LOGDEPTHBUF_EXT)\n\tgl_FragDepthEXT = log2(vFragDepth) * logDepthBufFC * 0.5;\n#endif";

	var logdepthbuf_pars_fragment = "#ifdef USE_LOGDEPTHBUF\n\tuniform float logDepthBufFC;\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n#endif\n";

	var logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n\tuniform float logDepthBufFC;\n#endif";

	var logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\tgl_Position.z = log2(max( EPSILON, gl_Position.w + 1.0 )) * logDepthBufFC;\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t#else\n\t\tgl_Position.z = (gl_Position.z - 1.0) * gl_Position.w;\n\t#endif\n#endif\n";

	var map_fragment = "#ifdef USE_MAP\n\tvec4 texelColor = texture2D( map, vUv );\n\ttexelColor = mapTexelToLinear( texelColor );\n\tdiffuseColor *= texelColor;\n#endif\n";

	var map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n";

	var map_particle_fragment = "#ifdef USE_MAP\n\tvec4 mapTexel = texture2D( map, vec2( gl_PointCoord.x, 1.0 - gl_PointCoord.y ) * offsetRepeat.zw + offsetRepeat.xy );\n\tdiffuseColor *= mapTexelToLinear( mapTexel );\n#endif\n";

	var map_particle_pars_fragment = "#ifdef USE_MAP\n\tuniform vec4 offsetRepeat;\n\tuniform sampler2D map;\n#endif\n";

	var metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif\n";

	var metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";

	var morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal += ( morphNormal0 - normal ) * morphTargetInfluences[ 0 ];\n\tobjectNormal += ( morphNormal1 - normal ) * morphTargetInfluences[ 1 ];\n\tobjectNormal += ( morphNormal2 - normal ) * morphTargetInfluences[ 2 ];\n\tobjectNormal += ( morphNormal3 - normal ) * morphTargetInfluences[ 3 ];\n#endif\n";

	var morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_MORPHNORMALS\n\tuniform float morphTargetInfluences[ 8 ];\n\t#else\n\tuniform float morphTargetInfluences[ 4 ];\n\t#endif\n#endif";

	var morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed += ( morphTarget0 - position ) * morphTargetInfluences[ 0 ];\n\ttransformed += ( morphTarget1 - position ) * morphTargetInfluences[ 1 ];\n\ttransformed += ( morphTarget2 - position ) * morphTargetInfluences[ 2 ];\n\ttransformed += ( morphTarget3 - position ) * morphTargetInfluences[ 3 ];\n\t#ifndef USE_MORPHNORMALS\n\ttransformed += ( morphTarget4 - position ) * morphTargetInfluences[ 4 ];\n\ttransformed += ( morphTarget5 - position ) * morphTargetInfluences[ 5 ];\n\ttransformed += ( morphTarget6 - position ) * morphTargetInfluences[ 6 ];\n\ttransformed += ( morphTarget7 - position ) * morphTargetInfluences[ 7 ];\n\t#endif\n#endif\n";

	var normal_fragment = "#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t#endif\n#endif\n#ifdef USE_NORMALMAP\n\tnormal = perturbNormal2Arb( -vViewPosition, normal );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd() );\n#endif\n";

	var normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm ) {\n\t\tvec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n\t\tvec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tvec3 S = normalize( q0 * st1.t - q1 * st0.t );\n\t\tvec3 T = normalize( -q0 * st1.s + q1 * st0.s );\n\t\tvec3 N = normalize( surf_norm );\n\t\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t\tmapN.xy = normalScale * mapN.xy;\n\t\tmat3 tsn = mat3( S, T, N );\n\t\treturn normalize( tsn * mapN );\n\t}\n#endif\n";

	var packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 1.0 - 2.0 * rgb.xyz;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256.,  256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn (( near + viewZ ) * far ) / (( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}\n";

	var premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif\n";

	var project_vertex = "vec4 mvPosition = modelViewMatrix * vec4( transformed, 1.0 );\ngl_Position = projectionMatrix * mvPosition;\n";

	var dithering_fragment = "#if defined( DITHERING )\n  gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif\n";

	var dithering_pars_fragment = "#if defined( DITHERING )\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif\n";

	var roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif\n";

	var roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";

	var shadowmap_pars_fragment = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tfloat texture2DShadowLerp( sampler2D depths, vec2 size, vec2 uv, float compare ) {\n\t\tconst vec2 offset = vec2( 0.0, 1.0 );\n\t\tvec2 texelSize = vec2( 1.0 ) / size;\n\t\tvec2 centroidUV = floor( uv * size + 0.5 ) / size;\n\t\tfloat lb = texture2DCompare( depths, centroidUV + texelSize * offset.xx, compare );\n\t\tfloat lt = texture2DCompare( depths, centroidUV + texelSize * offset.xy, compare );\n\t\tfloat rb = texture2DCompare( depths, centroidUV + texelSize * offset.yx, compare );\n\t\tfloat rt = texture2DCompare( depths, centroidUV + texelSize * offset.yy, compare );\n\t\tvec2 f = fract( uv * size + 0.5 );\n\t\tfloat a = mix( lb, lt, f.y );\n\t\tfloat b = mix( rb, rt, f.y );\n\t\tfloat c = mix( a, b, f.x );\n\t\treturn c;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tshadow = (\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif\n";

	var shadowmap_pars_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n#endif\n";

	var shadowmap_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n#endif\n";

	var shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\tDirectionalLight directionalLight;\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tshadow *= bool( directionalLight.shadow ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\tSpotLight spotLight;\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tshadow *= bool( spotLight.shadow ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\tPointLight pointLight;\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tshadow *= bool( pointLight.shadow ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#endif\n\t#endif\n\treturn shadow;\n}\n";

	var skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";

	var skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\t#ifdef BONE_TEXTURE\n\t\tuniform sampler2D boneTexture;\n\t\tuniform int boneTextureSize;\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\t\ty = dy * ( y + 0.5 );\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\t\treturn bone;\n\t\t}\n\t#else\n\t\tuniform mat4 boneMatrices[ MAX_BONES ];\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tmat4 bone = boneMatrices[ int(i) ];\n\t\t\treturn bone;\n\t\t}\n\t#endif\n#endif\n";

	var skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif\n";

	var skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix  = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n#endif\n";

	var specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";

	var specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";

	var tonemapping_fragment = "#if defined( TONE_MAPPING )\n  gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif\n";

	var tonemapping_pars_fragment = "#define saturate(a) clamp( a, 0.0, 1.0 )\nuniform float toneMappingExposure;\nuniform float toneMappingWhitePoint;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\n#define Uncharted2Helper( x ) max( ( ( x * ( 0.15 * x + 0.10 * 0.50 ) + 0.20 * 0.02 ) / ( x * ( 0.15 * x + 0.50 ) + 0.20 * 0.30 ) ) - 0.02 / 0.30, vec3( 0.0 ) )\nvec3 Uncharted2ToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( Uncharted2Helper( color ) / Uncharted2Helper( vec3( toneMappingWhitePoint ) ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\n";

	var uv_pars_fragment = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n#endif";

	var uv_pars_vertex = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n\tuniform vec4 offsetRepeat;\n#endif\n";

	var uv_vertex = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvUv = uv * offsetRepeat.zw + offsetRepeat.xy;\n#endif";

	var uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif";

	var uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n#endif";

	var uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = uv2;\n#endif";

	var worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( PHONG ) || defined( PHYSICAL ) || defined( LAMBERT ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP )\n\tvec4 worldPosition = modelMatrix * vec4( transformed, 1.0 );\n#endif\n";

	var cube_frag = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldPosition;\nvoid main() {\n\tgl_FragColor = textureCube( tCube, vec3( tFlip * vWorldPosition.x, vWorldPosition.yz ) );\n\tgl_FragColor.a *= opacity;\n}\n";

	var cube_vert = "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}\n";

	var depth_frag = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( gl_FragCoord.z ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( gl_FragCoord.z );\n\t#endif\n}\n";

	var depth_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n}\n";

	var distanceRGBA_frag = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}\n";

	var distanceRGBA_vert = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}\n";

	var equirect_frag = "uniform sampler2D tEquirect;\nvarying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldPosition );\n\tvec2 sampleUV;\n\tsampleUV.y = asin( clamp( direction.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\tsampleUV.x = atan( direction.z, direction.x ) * RECIPROCAL_PI2 + 0.5;\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n}\n";

	var equirect_vert = "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}\n";

	var linedashed_frag = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";

	var linedashed_vert = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\tvLineDistance = scale * lineDistance;\n\tvec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}\n";

	var meshbasic_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\treflectedLight.indirectDiffuse += texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";

	var meshbasic_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_ENVMAP\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}\n";

	var meshlambert_frag = "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <bsdfs>\n#include <lights_pars>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\treflectedLight.indirectDiffuse = getAmbientLightIrradiance( ambientLightColor );\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n";

	var meshlambert_vert = "#define LAMBERT\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";

	var meshphong_frag = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_template>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n";

	var meshphong_vert = "#define PHONG\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";

	var meshphysical_frag = "#define PHYSICAL\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifndef STANDARD\n\tuniform float clearCoat;\n\tuniform float clearCoatRoughness;\n#endif\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <lights_pars>\n#include <lights_physical_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_template>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n";

	var meshphysical_vert = "#define PHYSICAL\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";

	var normal_frag = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n}\n";

	var normal_vert = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}\n";

	var points_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";

	var points_vert = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#ifdef USE_SIZEATTENUATION\n\t\tgl_PointSize = size * ( scale / - mvPosition.z );\n\t#else\n\t\tgl_PointSize = size;\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";

	var shadow_frag = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <bsdfs>\n#include <lights_pars>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n}\n";

	var shadow_vert = "#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n}\n";

	var ShaderChunk = {
		alphamap_fragment: alphamap_fragment,
		alphamap_pars_fragment: alphamap_pars_fragment,
		alphatest_fragment: alphatest_fragment,
		aomap_fragment: aomap_fragment,
		aomap_pars_fragment: aomap_pars_fragment,
		begin_vertex: begin_vertex,
		beginnormal_vertex: beginnormal_vertex,
		bsdfs: bsdfs,
		bumpmap_pars_fragment: bumpmap_pars_fragment,
		clipping_planes_fragment: clipping_planes_fragment,
		clipping_planes_pars_fragment: clipping_planes_pars_fragment,
		clipping_planes_pars_vertex: clipping_planes_pars_vertex,
		clipping_planes_vertex: clipping_planes_vertex,
		color_fragment: color_fragment,
		color_pars_fragment: color_pars_fragment,
		color_pars_vertex: color_pars_vertex,
		color_vertex: color_vertex,
		common: common,
		cube_uv_reflection_fragment: cube_uv_reflection_fragment,
		defaultnormal_vertex: defaultnormal_vertex,
		displacementmap_pars_vertex: displacementmap_pars_vertex,
		displacementmap_vertex: displacementmap_vertex,
		emissivemap_fragment: emissivemap_fragment,
		emissivemap_pars_fragment: emissivemap_pars_fragment,
		encodings_fragment: encodings_fragment,
		encodings_pars_fragment: encodings_pars_fragment,
		envmap_fragment: envmap_fragment,
		envmap_pars_fragment: envmap_pars_fragment,
		envmap_pars_vertex: envmap_pars_vertex,
		envmap_vertex: envmap_vertex,
		fog_vertex: fog_vertex,
		fog_pars_vertex: fog_pars_vertex,
		fog_fragment: fog_fragment,
		fog_pars_fragment: fog_pars_fragment,
		gradientmap_pars_fragment: gradientmap_pars_fragment,
		lightmap_fragment: lightmap_fragment,
		lightmap_pars_fragment: lightmap_pars_fragment,
		lights_lambert_vertex: lights_lambert_vertex,
		lights_pars: lights_pars,
		lights_phong_fragment: lights_phong_fragment,
		lights_phong_pars_fragment: lights_phong_pars_fragment,
		lights_physical_fragment: lights_physical_fragment,
		lights_physical_pars_fragment: lights_physical_pars_fragment,
		lights_template: lights_template,
		logdepthbuf_fragment: logdepthbuf_fragment,
		logdepthbuf_pars_fragment: logdepthbuf_pars_fragment,
		logdepthbuf_pars_vertex: logdepthbuf_pars_vertex,
		logdepthbuf_vertex: logdepthbuf_vertex,
		map_fragment: map_fragment,
		map_pars_fragment: map_pars_fragment,
		map_particle_fragment: map_particle_fragment,
		map_particle_pars_fragment: map_particle_pars_fragment,
		metalnessmap_fragment: metalnessmap_fragment,
		metalnessmap_pars_fragment: metalnessmap_pars_fragment,
		morphnormal_vertex: morphnormal_vertex,
		morphtarget_pars_vertex: morphtarget_pars_vertex,
		morphtarget_vertex: morphtarget_vertex,
		normal_fragment: normal_fragment,
		normalmap_pars_fragment: normalmap_pars_fragment,
		packing: packing,
		premultiplied_alpha_fragment: premultiplied_alpha_fragment,
		project_vertex: project_vertex,
		dithering_fragment: dithering_fragment,
		dithering_pars_fragment: dithering_pars_fragment,
		roughnessmap_fragment: roughnessmap_fragment,
		roughnessmap_pars_fragment: roughnessmap_pars_fragment,
		shadowmap_pars_fragment: shadowmap_pars_fragment,
		shadowmap_pars_vertex: shadowmap_pars_vertex,
		shadowmap_vertex: shadowmap_vertex,
		shadowmask_pars_fragment: shadowmask_pars_fragment,
		skinbase_vertex: skinbase_vertex,
		skinning_pars_vertex: skinning_pars_vertex,
		skinning_vertex: skinning_vertex,
		skinnormal_vertex: skinnormal_vertex,
		specularmap_fragment: specularmap_fragment,
		specularmap_pars_fragment: specularmap_pars_fragment,
		tonemapping_fragment: tonemapping_fragment,
		tonemapping_pars_fragment: tonemapping_pars_fragment,
		uv_pars_fragment: uv_pars_fragment,
		uv_pars_vertex: uv_pars_vertex,
		uv_vertex: uv_vertex,
		uv2_pars_fragment: uv2_pars_fragment,
		uv2_pars_vertex: uv2_pars_vertex,
		uv2_vertex: uv2_vertex,
		worldpos_vertex: worldpos_vertex,

		cube_frag: cube_frag,
		cube_vert: cube_vert,
		depth_frag: depth_frag,
		depth_vert: depth_vert,
		distanceRGBA_frag: distanceRGBA_frag,
		distanceRGBA_vert: distanceRGBA_vert,
		equirect_frag: equirect_frag,
		equirect_vert: equirect_vert,
		linedashed_frag: linedashed_frag,
		linedashed_vert: linedashed_vert,
		meshbasic_frag: meshbasic_frag,
		meshbasic_vert: meshbasic_vert,
		meshlambert_frag: meshlambert_frag,
		meshlambert_vert: meshlambert_vert,
		meshphong_frag: meshphong_frag,
		meshphong_vert: meshphong_vert,
		meshphysical_frag: meshphysical_frag,
		meshphysical_vert: meshphysical_vert,
		normal_frag: normal_frag,
		normal_vert: normal_vert,
		points_frag: points_frag,
		points_vert: points_vert,
		shadow_frag: shadow_frag,
		shadow_vert: shadow_vert
	};

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author mrdoob / http://mrdoob.com/
	 * @author mikael emtinger / http://gomo.se/
	 */

	var ShaderLib = {

		basic: {

			uniforms: UniformsUtils.merge( [
				UniformsLib.common,
				UniformsLib.specularmap,
				UniformsLib.envmap,
				UniformsLib.aomap,
				UniformsLib.lightmap,
				UniformsLib.fog
			] ),

			vertexShader: ShaderChunk.meshbasic_vert,
			fragmentShader: ShaderChunk.meshbasic_frag

		},

		lambert: {

			uniforms: UniformsUtils.merge( [
				UniformsLib.common,
				UniformsLib.specularmap,
				UniformsLib.envmap,
				UniformsLib.aomap,
				UniformsLib.lightmap,
				UniformsLib.emissivemap,
				UniformsLib.fog,
				UniformsLib.lights,
				{
					emissive: { value: new Color( 0x000000 ) }
				}
			] ),

			vertexShader: ShaderChunk.meshlambert_vert,
			fragmentShader: ShaderChunk.meshlambert_frag

		},

		phong: {

			uniforms: UniformsUtils.merge( [
				UniformsLib.common,
				UniformsLib.specularmap,
				UniformsLib.envmap,
				UniformsLib.aomap,
				UniformsLib.lightmap,
				UniformsLib.emissivemap,
				UniformsLib.bumpmap,
				UniformsLib.normalmap,
				UniformsLib.displacementmap,
				UniformsLib.gradientmap,
				UniformsLib.fog,
				UniformsLib.lights,
				{
					emissive: { value: new Color( 0x000000 ) },
					specular: { value: new Color( 0x111111 ) },
					shininess: { value: 30 }
				}
			] ),

			vertexShader: ShaderChunk.meshphong_vert,
			fragmentShader: ShaderChunk.meshphong_frag

		},

		standard: {

			uniforms: UniformsUtils.merge( [
				UniformsLib.common,
				UniformsLib.envmap,
				UniformsLib.aomap,
				UniformsLib.lightmap,
				UniformsLib.emissivemap,
				UniformsLib.bumpmap,
				UniformsLib.normalmap,
				UniformsLib.displacementmap,
				UniformsLib.roughnessmap,
				UniformsLib.metalnessmap,
				UniformsLib.fog,
				UniformsLib.lights,
				{
					emissive: { value: new Color( 0x000000 ) },
					roughness: { value: 0.5 },
					metalness: { value: 0.5 },
					envMapIntensity: { value: 1 } // temporary
				}
			] ),

			vertexShader: ShaderChunk.meshphysical_vert,
			fragmentShader: ShaderChunk.meshphysical_frag

		},

		points: {

			uniforms: UniformsUtils.merge( [
				UniformsLib.points,
				UniformsLib.fog
			] ),

			vertexShader: ShaderChunk.points_vert,
			fragmentShader: ShaderChunk.points_frag

		},

		dashed: {

			uniforms: UniformsUtils.merge( [
				UniformsLib.common,
				UniformsLib.fog,
				{
					scale: { value: 1 },
					dashSize: { value: 1 },
					totalSize: { value: 2 }
				}
			] ),

			vertexShader: ShaderChunk.linedashed_vert,
			fragmentShader: ShaderChunk.linedashed_frag

		},

		depth: {

			uniforms: UniformsUtils.merge( [
				UniformsLib.common,
				UniformsLib.displacementmap
			] ),

			vertexShader: ShaderChunk.depth_vert,
			fragmentShader: ShaderChunk.depth_frag

		},

		normal: {

			uniforms: UniformsUtils.merge( [
				UniformsLib.common,
				UniformsLib.bumpmap,
				UniformsLib.normalmap,
				UniformsLib.displacementmap,
				{
					opacity: { value: 1.0 }
				}
			] ),

			vertexShader: ShaderChunk.normal_vert,
			fragmentShader: ShaderChunk.normal_frag

		},

		/* -------------------------------------------------------------------------
		//	Cube map shader
		 ------------------------------------------------------------------------- */

		cube: {

			uniforms: {
				tCube: { value: null },
				tFlip: { value: - 1 },
				opacity: { value: 1.0 }
			},

			vertexShader: ShaderChunk.cube_vert,
			fragmentShader: ShaderChunk.cube_frag

		},

		equirect: {

			uniforms: {
				tEquirect: { value: null },
			},

			vertexShader: ShaderChunk.equirect_vert,
			fragmentShader: ShaderChunk.equirect_frag

		},

		distanceRGBA: {

			uniforms: UniformsUtils.merge( [
				UniformsLib.common,
				UniformsLib.displacementmap,
				{
					referencePosition: { value: new Vector3() },
					nearDistance: { value: 1 },
					farDistance: { value: 1000 }
				}
			] ),

			vertexShader: ShaderChunk.distanceRGBA_vert,
			fragmentShader: ShaderChunk.distanceRGBA_frag

		},

		shadow: {

			uniforms: UniformsUtils.merge( [
				UniformsLib.lights,
				{
					color: { value: new Color( 0x00000 ) },
					opacity: { value: 1.0 }
				},
			] ),

			vertexShader: ShaderChunk.shadow_vert,
			fragmentShader: ShaderChunk.shadow_frag

		}

	};

	ShaderLib.physical = {

		uniforms: UniformsUtils.merge( [
			ShaderLib.standard.uniforms,
			{
				clearCoat: { value: 0 },
				clearCoatRoughness: { value: 0 }
			}
		] ),

		vertexShader: ShaderChunk.meshphysical_vert,
		fragmentShader: ShaderChunk.meshphysical_frag

	};

	/**
	 * @author bhouston / http://clara.io
	 */

	function Box2( min, max ) {

		this.min = ( min !== undefined ) ? min : new Vector2( + Infinity, + Infinity );
		this.max = ( max !== undefined ) ? max : new Vector2( - Infinity, - Infinity );

	}

	Object.assign( Box2.prototype, {

		set: function ( min, max ) {

			this.min.copy( min );
			this.max.copy( max );

			return this;

		},

		setFromPoints: function ( points ) {

			this.makeEmpty();

			for ( var i = 0, il = points.length; i < il; i ++ ) {

				this.expandByPoint( points[ i ] );

			}

			return this;

		},

		setFromCenterAndSize: function () {

			var v1 = new Vector2();

			return function setFromCenterAndSize( center, size ) {

				var halfSize = v1.copy( size ).multiplyScalar( 0.5 );
				this.min.copy( center ).sub( halfSize );
				this.max.copy( center ).add( halfSize );

				return this;

			};

		}(),

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( box ) {

			this.min.copy( box.min );
			this.max.copy( box.max );

			return this;

		},

		makeEmpty: function () {

			this.min.x = this.min.y = + Infinity;
			this.max.x = this.max.y = - Infinity;

			return this;

		},

		isEmpty: function () {

			// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes

			return ( this.max.x < this.min.x ) || ( this.max.y < this.min.y );

		},

		getCenter: function ( optionalTarget ) {

			var result = optionalTarget || new Vector2();
			return this.isEmpty() ? result.set( 0, 0 ) : result.addVectors( this.min, this.max ).multiplyScalar( 0.5 );

		},

		getSize: function ( optionalTarget ) {

			var result = optionalTarget || new Vector2();
			return this.isEmpty() ? result.set( 0, 0 ) : result.subVectors( this.max, this.min );

		},

		expandByPoint: function ( point ) {

			this.min.min( point );
			this.max.max( point );

			return this;

		},

		expandByVector: function ( vector ) {

			this.min.sub( vector );
			this.max.add( vector );

			return this;

		},

		expandByScalar: function ( scalar ) {

			this.min.addScalar( - scalar );
			this.max.addScalar( scalar );

			return this;

		},

		containsPoint: function ( point ) {

			return point.x < this.min.x || point.x > this.max.x ||
				point.y < this.min.y || point.y > this.max.y ? false : true;

		},

		containsBox: function ( box ) {

			return this.min.x <= box.min.x && box.max.x <= this.max.x &&
				this.min.y <= box.min.y && box.max.y <= this.max.y;

		},

		getParameter: function ( point, optionalTarget ) {

			// This can potentially have a divide by zero if the box
			// has a size dimension of 0.

			var result = optionalTarget || new Vector2();

			return result.set(
				( point.x - this.min.x ) / ( this.max.x - this.min.x ),
				( point.y - this.min.y ) / ( this.max.y - this.min.y )
			);

		},

		intersectsBox: function ( box ) {

			// using 4 splitting planes to rule out intersections

			return box.max.x < this.min.x || box.min.x > this.max.x ||
				box.max.y < this.min.y || box.min.y > this.max.y ? false : true;

		},

		clampPoint: function ( point, optionalTarget ) {

			var result = optionalTarget || new Vector2();
			return result.copy( point ).clamp( this.min, this.max );

		},

		distanceToPoint: function () {

			var v1 = new Vector2();

			return function distanceToPoint( point ) {

				var clampedPoint = v1.copy( point ).clamp( this.min, this.max );
				return clampedPoint.sub( point ).length();

			};

		}(),

		intersect: function ( box ) {

			this.min.max( box.min );
			this.max.min( box.max );

			return this;

		},

		union: function ( box ) {

			this.min.min( box.min );
			this.max.max( box.max );

			return this;

		},

		translate: function ( offset ) {

			this.min.add( offset );
			this.max.add( offset );

			return this;

		},

		equals: function ( box ) {

			return box.min.equals( this.min ) && box.max.equals( this.max );

		}

	} );

	/**
	 * @author mikael emtinger / http://gomo.se/
	 * @author alteredq / http://alteredqualia.com/
	 */

	function WebGLFlareRenderer( renderer, gl, state, textures, capabilities ) {

		var vertexBuffer, elementBuffer;
		var shader, program, attributes, uniforms;

		var tempTexture, occlusionTexture;

		function init() {

			var vertices = new Float32Array( [
				- 1, - 1,  0, 0,
				 1, - 1,  1, 0,
				 1,  1,  1, 1,
				- 1,  1,  0, 1
			] );

			var faces = new Uint16Array( [
				0, 1, 2,
				0, 2, 3
			] );

			// buffers

			vertexBuffer     = gl.createBuffer();
			elementBuffer    = gl.createBuffer();

			gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
			gl.bufferData( gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW );

			gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );
			gl.bufferData( gl.ELEMENT_ARRAY_BUFFER, faces, gl.STATIC_DRAW );

			// textures

			tempTexture      = gl.createTexture();
			occlusionTexture = gl.createTexture();

			state.bindTexture( gl.TEXTURE_2D, tempTexture );
			gl.texImage2D( gl.TEXTURE_2D, 0, gl.RGB, 16, 16, 0, gl.RGB, gl.UNSIGNED_BYTE, null );
			gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE );
			gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE );
			gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST );
			gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST );

			state.bindTexture( gl.TEXTURE_2D, occlusionTexture );
			gl.texImage2D( gl.TEXTURE_2D, 0, gl.RGBA, 16, 16, 0, gl.RGBA, gl.UNSIGNED_BYTE, null );
			gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE );
			gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE );
			gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST );
			gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST );

			shader = {

				vertexShader: [

					"uniform lowp int renderType;",

					"uniform vec3 screenPosition;",
					"uniform vec2 scale;",
					"uniform float rotation;",

					"uniform sampler2D occlusionMap;",

					"attribute vec2 position;",
					"attribute vec2 uv;",

					"varying vec2 vUV;",
					"varying float vVisibility;",

					"void main() {",

						"vUV = uv;",

						"vec2 pos = position;",

						"if ( renderType == 2 ) {",

							"vec4 visibility = texture2D( occlusionMap, vec2( 0.1, 0.1 ) );",
							"visibility += texture2D( occlusionMap, vec2( 0.5, 0.1 ) );",
							"visibility += texture2D( occlusionMap, vec2( 0.9, 0.1 ) );",
							"visibility += texture2D( occlusionMap, vec2( 0.9, 0.5 ) );",
							"visibility += texture2D( occlusionMap, vec2( 0.9, 0.9 ) );",
							"visibility += texture2D( occlusionMap, vec2( 0.5, 0.9 ) );",
							"visibility += texture2D( occlusionMap, vec2( 0.1, 0.9 ) );",
							"visibility += texture2D( occlusionMap, vec2( 0.1, 0.5 ) );",
							"visibility += texture2D( occlusionMap, vec2( 0.5, 0.5 ) );",

							"vVisibility =        visibility.r / 9.0;",
							"vVisibility *= 1.0 - visibility.g / 9.0;",
							"vVisibility *=       visibility.b / 9.0;",
							"vVisibility *= 1.0 - visibility.a / 9.0;",

							"pos.x = cos( rotation ) * position.x - sin( rotation ) * position.y;",
							"pos.y = sin( rotation ) * position.x + cos( rotation ) * position.y;",

						"}",

						"gl_Position = vec4( ( pos * scale + screenPosition.xy ).xy, screenPosition.z, 1.0 );",

					"}"

				].join( "\n" ),

				fragmentShader: [

					"uniform lowp int renderType;",

					"uniform sampler2D map;",
					"uniform float opacity;",
					"uniform vec3 color;",

					"varying vec2 vUV;",
					"varying float vVisibility;",

					"void main() {",

						// pink square

						"if ( renderType == 0 ) {",

							"gl_FragColor = vec4( 1.0, 0.0, 1.0, 0.0 );",

						// restore

						"} else if ( renderType == 1 ) {",

							"gl_FragColor = texture2D( map, vUV );",

						// flare

						"} else {",

							"vec4 texture = texture2D( map, vUV );",
							"texture.a *= opacity * vVisibility;",
							"gl_FragColor = texture;",
							"gl_FragColor.rgb *= color;",

						"}",

					"}"

				].join( "\n" )

			};

			program = createProgram( shader );

			attributes = {
				vertex: gl.getAttribLocation ( program, "position" ),
				uv:     gl.getAttribLocation ( program, "uv" )
			};

			uniforms = {
				renderType:     gl.getUniformLocation( program, "renderType" ),
				map:            gl.getUniformLocation( program, "map" ),
				occlusionMap:   gl.getUniformLocation( program, "occlusionMap" ),
				opacity:        gl.getUniformLocation( program, "opacity" ),
				color:          gl.getUniformLocation( program, "color" ),
				scale:          gl.getUniformLocation( program, "scale" ),
				rotation:       gl.getUniformLocation( program, "rotation" ),
				screenPosition: gl.getUniformLocation( program, "screenPosition" )
			};

		}

		/*
		 * Render lens flares
		 * Method: renders 16x16 0xff00ff-colored points scattered over the light source area,
		 *         reads these back and calculates occlusion.
		 */

		this.render = function ( flares, scene, camera, viewport ) {

			if ( flares.length === 0 ) return;

			var tempPosition = new Vector3();

			var invAspect = viewport.w / viewport.z,
				halfViewportWidth = viewport.z * 0.5,
				halfViewportHeight = viewport.w * 0.5;

			var size = 16 / viewport.w,
				scale = new Vector2( size * invAspect, size );

			var screenPosition = new Vector3( 1, 1, 0 ),
				screenPositionPixels = new Vector2( 1, 1 );

			var validArea = new Box2();

			validArea.min.set( viewport.x, viewport.y );
			validArea.max.set( viewport.x + ( viewport.z - 16 ), viewport.y + ( viewport.w - 16 ) );

			if ( program === undefined ) {

				init();

			}

			state.useProgram( program );

			state.initAttributes();
			state.enableAttribute( attributes.vertex );
			state.enableAttribute( attributes.uv );
			state.disableUnusedAttributes();

			// loop through all lens flares to update their occlusion and positions
			// setup gl and common used attribs/uniforms

			gl.uniform1i( uniforms.occlusionMap, 0 );
			gl.uniform1i( uniforms.map, 1 );

			gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
			gl.vertexAttribPointer( attributes.vertex, 2, gl.FLOAT, false, 2 * 8, 0 );
			gl.vertexAttribPointer( attributes.uv, 2, gl.FLOAT, false, 2 * 8, 8 );

			gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );

			state.disable( gl.CULL_FACE );
			state.buffers.depth.setMask( false );

			for ( var i = 0, l = flares.length; i < l; i ++ ) {

				size = 16 / viewport.w;
				scale.set( size * invAspect, size );

				// calc object screen position

				var flare = flares[ i ];

				tempPosition.set( flare.matrixWorld.elements[ 12 ], flare.matrixWorld.elements[ 13 ], flare.matrixWorld.elements[ 14 ] );

				tempPosition.applyMatrix4( camera.matrixWorldInverse );
				tempPosition.applyMatrix4( camera.projectionMatrix );

				// setup arrays for gl programs

				screenPosition.copy( tempPosition );

				// horizontal and vertical coordinate of the lower left corner of the pixels to copy

				screenPositionPixels.x = viewport.x + ( screenPosition.x * halfViewportWidth ) + halfViewportWidth - 8;
				screenPositionPixels.y = viewport.y + ( screenPosition.y * halfViewportHeight ) + halfViewportHeight - 8;

				// screen cull

				if ( validArea.containsPoint( screenPositionPixels ) === true ) {

					// save current RGB to temp texture

					state.activeTexture( gl.TEXTURE0 );
					state.bindTexture( gl.TEXTURE_2D, null );
					state.activeTexture( gl.TEXTURE1 );
					state.bindTexture( gl.TEXTURE_2D, tempTexture );
					gl.copyTexImage2D( gl.TEXTURE_2D, 0, gl.RGB, screenPositionPixels.x, screenPositionPixels.y, 16, 16, 0 );


					// render pink quad

					gl.uniform1i( uniforms.renderType, 0 );
					gl.uniform2f( uniforms.scale, scale.x, scale.y );
					gl.uniform3f( uniforms.screenPosition, screenPosition.x, screenPosition.y, screenPosition.z );

					state.disable( gl.BLEND );
					state.enable( gl.DEPTH_TEST );

					gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );


					// copy result to occlusionMap

					state.activeTexture( gl.TEXTURE0 );
					state.bindTexture( gl.TEXTURE_2D, occlusionTexture );
					gl.copyTexImage2D( gl.TEXTURE_2D, 0, gl.RGBA, screenPositionPixels.x, screenPositionPixels.y, 16, 16, 0 );


					// restore graphics

					gl.uniform1i( uniforms.renderType, 1 );
					state.disable( gl.DEPTH_TEST );

					state.activeTexture( gl.TEXTURE1 );
					state.bindTexture( gl.TEXTURE_2D, tempTexture );
					gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );


					// update object positions

					flare.positionScreen.copy( screenPosition );

					if ( flare.customUpdateCallback ) {

						flare.customUpdateCallback( flare );

					} else {

						flare.updateLensFlares();

					}

					// render flares

					gl.uniform1i( uniforms.renderType, 2 );
					state.enable( gl.BLEND );

					for ( var j = 0, jl = flare.lensFlares.length; j < jl; j ++ ) {

						var sprite = flare.lensFlares[ j ];

						if ( sprite.opacity > 0.001 && sprite.scale > 0.001 ) {

							screenPosition.x = sprite.x;
							screenPosition.y = sprite.y;
							screenPosition.z = sprite.z;

							size = sprite.size * sprite.scale / viewport.w;

							scale.x = size * invAspect;
							scale.y = size;

							gl.uniform3f( uniforms.screenPosition, screenPosition.x, screenPosition.y, screenPosition.z );
							gl.uniform2f( uniforms.scale, scale.x, scale.y );
							gl.uniform1f( uniforms.rotation, sprite.rotation );

							gl.uniform1f( uniforms.opacity, sprite.opacity );
							gl.uniform3f( uniforms.color, sprite.color.r, sprite.color.g, sprite.color.b );

							state.setBlending( sprite.blending, sprite.blendEquation, sprite.blendSrc, sprite.blendDst );

							textures.setTexture2D( sprite.texture, 1 );

							gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );

						}

					}

				}

			}

			// restore gl

			state.enable( gl.CULL_FACE );
			state.enable( gl.DEPTH_TEST );
			state.buffers.depth.setMask( true );

			state.reset();

		};

		function createProgram( shader ) {

			var program = gl.createProgram();

			var fragmentShader = gl.createShader( gl.FRAGMENT_SHADER );
			var vertexShader = gl.createShader( gl.VERTEX_SHADER );

			var prefix = "precision " + capabilities.precision + " float;\n";

			gl.shaderSource( fragmentShader, prefix + shader.fragmentShader );
			gl.shaderSource( vertexShader, prefix + shader.vertexShader );

			gl.compileShader( fragmentShader );
			gl.compileShader( vertexShader );

			gl.attachShader( program, fragmentShader );
			gl.attachShader( program, vertexShader );

			gl.linkProgram( program );

			return program;

		}

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function CanvasTexture( canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy ) {

		Texture.call( this, canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );

		this.needsUpdate = true;

	}

	CanvasTexture.prototype = Object.create( Texture.prototype );
	CanvasTexture.prototype.constructor = CanvasTexture;

	/**
	 * @author mikael emtinger / http://gomo.se/
	 * @author alteredq / http://alteredqualia.com/
	 */

	function WebGLSpriteRenderer( renderer, gl, state, textures, capabilities ) {

		var vertexBuffer, elementBuffer;
		var program, attributes, uniforms;

		var texture;

		// decompose matrixWorld

		var spritePosition = new Vector3();
		var spriteRotation = new Quaternion();
		var spriteScale = new Vector3();

		function init() {

			var vertices = new Float32Array( [
				- 0.5, - 0.5,  0, 0,
				  0.5, - 0.5,  1, 0,
				  0.5,   0.5,  1, 1,
				- 0.5,   0.5,  0, 1
			] );

			var faces = new Uint16Array( [
				0, 1, 2,
				0, 2, 3
			] );

			vertexBuffer  = gl.createBuffer();
			elementBuffer = gl.createBuffer();

			gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
			gl.bufferData( gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW );

			gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );
			gl.bufferData( gl.ELEMENT_ARRAY_BUFFER, faces, gl.STATIC_DRAW );

			program = createProgram();

			attributes = {
				position:			gl.getAttribLocation ( program, 'position' ),
				uv:					gl.getAttribLocation ( program, 'uv' )
			};

			uniforms = {
				uvOffset:			gl.getUniformLocation( program, 'uvOffset' ),
				uvScale:			gl.getUniformLocation( program, 'uvScale' ),

				rotation:			gl.getUniformLocation( program, 'rotation' ),
				scale:				gl.getUniformLocation( program, 'scale' ),

				color:				gl.getUniformLocation( program, 'color' ),
				map:				gl.getUniformLocation( program, 'map' ),
				opacity:			gl.getUniformLocation( program, 'opacity' ),

				modelViewMatrix: 	gl.getUniformLocation( program, 'modelViewMatrix' ),
				projectionMatrix:	gl.getUniformLocation( program, 'projectionMatrix' ),

				fogType:			gl.getUniformLocation( program, 'fogType' ),
				fogDensity:			gl.getUniformLocation( program, 'fogDensity' ),
				fogNear:			gl.getUniformLocation( program, 'fogNear' ),
				fogFar:				gl.getUniformLocation( program, 'fogFar' ),
				fogColor:			gl.getUniformLocation( program, 'fogColor' ),

				alphaTest:			gl.getUniformLocation( program, 'alphaTest' )
			};

			var canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
			canvas.width = 8;
			canvas.height = 8;

			var context = canvas.getContext( '2d' );
			context.fillStyle = 'white';
			context.fillRect( 0, 0, 8, 8 );

			texture = new CanvasTexture( canvas );

		}

		this.render = function ( sprites, scene, camera ) {

			if ( sprites.length === 0 ) return;

			// setup gl

			if ( program === undefined ) {

				init();

			}

			state.useProgram( program );

			state.initAttributes();
			state.enableAttribute( attributes.position );
			state.enableAttribute( attributes.uv );
			state.disableUnusedAttributes();

			state.disable( gl.CULL_FACE );
			state.enable( gl.BLEND );

			gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
			gl.vertexAttribPointer( attributes.position, 2, gl.FLOAT, false, 2 * 8, 0 );
			gl.vertexAttribPointer( attributes.uv, 2, gl.FLOAT, false, 2 * 8, 8 );

			gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );

			gl.uniformMatrix4fv( uniforms.projectionMatrix, false, camera.projectionMatrix.elements );

			state.activeTexture( gl.TEXTURE0 );
			gl.uniform1i( uniforms.map, 0 );

			var oldFogType = 0;
			var sceneFogType = 0;
			var fog = scene.fog;

			if ( fog ) {

				gl.uniform3f( uniforms.fogColor, fog.color.r, fog.color.g, fog.color.b );

				if ( fog.isFog ) {

					gl.uniform1f( uniforms.fogNear, fog.near );
					gl.uniform1f( uniforms.fogFar, fog.far );

					gl.uniform1i( uniforms.fogType, 1 );
					oldFogType = 1;
					sceneFogType = 1;

				} else if ( fog.isFogExp2 ) {

					gl.uniform1f( uniforms.fogDensity, fog.density );

					gl.uniform1i( uniforms.fogType, 2 );
					oldFogType = 2;
					sceneFogType = 2;

				}

			} else {

				gl.uniform1i( uniforms.fogType, 0 );
				oldFogType = 0;
				sceneFogType = 0;

			}


			// update positions and sort

			for ( var i = 0, l = sprites.length; i < l; i ++ ) {

				var sprite = sprites[ i ];

				sprite.modelViewMatrix.multiplyMatrices( camera.matrixWorldInverse, sprite.matrixWorld );
				sprite.z = - sprite.modelViewMatrix.elements[ 14 ];

			}

			sprites.sort( painterSortStable );

			// render all sprites

			var scale = [];

			for ( var i = 0, l = sprites.length; i < l; i ++ ) {

				var sprite = sprites[ i ];
				var material = sprite.material;

				if ( material.visible === false ) continue;

				sprite.onBeforeRender( renderer, scene, camera, undefined, material, undefined );

				gl.uniform1f( uniforms.alphaTest, material.alphaTest );
				gl.uniformMatrix4fv( uniforms.modelViewMatrix, false, sprite.modelViewMatrix.elements );

				sprite.matrixWorld.decompose( spritePosition, spriteRotation, spriteScale );

				scale[ 0 ] = spriteScale.x;
				scale[ 1 ] = spriteScale.y;

				var fogType = 0;

				if ( scene.fog && material.fog ) {

					fogType = sceneFogType;

				}

				if ( oldFogType !== fogType ) {

					gl.uniform1i( uniforms.fogType, fogType );
					oldFogType = fogType;

				}

				if ( material.map !== null ) {

					gl.uniform2f( uniforms.uvOffset, material.map.offset.x, material.map.offset.y );
					gl.uniform2f( uniforms.uvScale, material.map.repeat.x, material.map.repeat.y );

				} else {

					gl.uniform2f( uniforms.uvOffset, 0, 0 );
					gl.uniform2f( uniforms.uvScale, 1, 1 );

				}

				gl.uniform1f( uniforms.opacity, material.opacity );
				gl.uniform3f( uniforms.color, material.color.r, material.color.g, material.color.b );

				gl.uniform1f( uniforms.rotation, material.rotation );
				gl.uniform2fv( uniforms.scale, scale );

				state.setBlending( material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha );
				state.buffers.depth.setTest( material.depthTest );
				state.buffers.depth.setMask( material.depthWrite );

				textures.setTexture2D( material.map || texture, 0 );

				gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );

				sprite.onAfterRender( renderer, scene, camera, undefined, material, undefined );

			}

			// restore gl

			state.enable( gl.CULL_FACE );

			state.reset();

		};

		function createProgram() {

			var program = gl.createProgram();

			var vertexShader = gl.createShader( gl.VERTEX_SHADER );
			var fragmentShader = gl.createShader( gl.FRAGMENT_SHADER );

			gl.shaderSource( vertexShader, [

				'precision ' + capabilities.precision + ' float;',

				'#define SHADER_NAME ' + 'SpriteMaterial',

				'uniform mat4 modelViewMatrix;',
				'uniform mat4 projectionMatrix;',
				'uniform float rotation;',
				'uniform vec2 scale;',
				'uniform vec2 uvOffset;',
				'uniform vec2 uvScale;',

				'attribute vec2 position;',
				'attribute vec2 uv;',

				'varying vec2 vUV;',

				'void main() {',

					'vUV = uvOffset + uv * uvScale;',

					'vec2 alignedPosition = position * scale;',

					'vec2 rotatedPosition;',
					'rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;',
					'rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;',

					'vec4 finalPosition;',

					'finalPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );',
					'finalPosition.xy += rotatedPosition;',
					'finalPosition = projectionMatrix * finalPosition;',

					'gl_Position = finalPosition;',

				'}'

			].join( '\n' ) );

			gl.shaderSource( fragmentShader, [

				'precision ' + capabilities.precision + ' float;',

				'#define SHADER_NAME ' + 'SpriteMaterial',

				'uniform vec3 color;',
				'uniform sampler2D map;',
				'uniform float opacity;',

				'uniform int fogType;',
				'uniform vec3 fogColor;',
				'uniform float fogDensity;',
				'uniform float fogNear;',
				'uniform float fogFar;',
				'uniform float alphaTest;',

				'varying vec2 vUV;',

				'void main() {',

					'vec4 texture = texture2D( map, vUV );',

					'if ( texture.a < alphaTest ) discard;',

					'gl_FragColor = vec4( color * texture.xyz, texture.a * opacity );',

					'if ( fogType > 0 ) {',

						'float depth = gl_FragCoord.z / gl_FragCoord.w;',
						'float fogFactor = 0.0;',

						'if ( fogType == 1 ) {',

							'fogFactor = smoothstep( fogNear, fogFar, depth );',

						'} else {',

							'const float LOG2 = 1.442695;',
							'fogFactor = exp2( - fogDensity * fogDensity * depth * depth * LOG2 );',
							'fogFactor = 1.0 - clamp( fogFactor, 0.0, 1.0 );',

						'}',

						'gl_FragColor = mix( gl_FragColor, vec4( fogColor, gl_FragColor.w ), fogFactor );',

					'}',

				'}'

			].join( '\n' ) );

			gl.compileShader( vertexShader );
			gl.compileShader( fragmentShader );

			gl.attachShader( program, vertexShader );
			gl.attachShader( program, fragmentShader );

			gl.linkProgram( program );

			return program;

		}

		function painterSortStable( a, b ) {

			if ( a.renderOrder !== b.renderOrder ) {

				return a.renderOrder - b.renderOrder;

			} else if ( a.z !== b.z ) {

				return b.z - a.z;

			} else {

				return b.id - a.id;

			}

		}

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 */

	var materialId = 0;

	function Material() {

		Object.defineProperty( this, 'id', { value: materialId ++ } );

		this.uuid = _Math.generateUUID();

		this.name = '';
		this.type = 'Material';

		this.fog = true;
		this.lights = true;

		this.blending = NormalBlending;
		this.side = FrontSide;
		this.flatShading = false;
		this.vertexColors = NoColors; // THREE.NoColors, THREE.VertexColors, THREE.FaceColors

		this.opacity = 1;
		this.transparent = false;

		this.blendSrc = SrcAlphaFactor;
		this.blendDst = OneMinusSrcAlphaFactor;
		this.blendEquation = AddEquation;
		this.blendSrcAlpha = null;
		this.blendDstAlpha = null;
		this.blendEquationAlpha = null;

		this.depthFunc = LessEqualDepth;
		this.depthTest = true;
		this.depthWrite = true;

		this.clippingPlanes = null;
		this.clipIntersection = false;
		this.clipShadows = false;

		this.colorWrite = true;

		this.precision = null; // override the renderer's default precision for this material

		this.polygonOffset = false;
		this.polygonOffsetFactor = 0;
		this.polygonOffsetUnits = 0;

		this.dithering = false;

		this.alphaTest = 0;
		this.premultipliedAlpha = false;

		this.overdraw = 0; // Overdrawn pixels (typically between 0 and 1) for fixing antialiasing gaps in CanvasRenderer

		this.visible = true;

		this.userData = {};

		this.needsUpdate = true;

	}

	Object.assign( Material.prototype, EventDispatcher.prototype, {

		isMaterial: true,

		onBeforeCompile: function () {},

		setValues: function ( values ) {

			if ( values === undefined ) return;

			for ( var key in values ) {

				var newValue = values[ key ];

				if ( newValue === undefined ) {

					console.warn( "THREE.Material: '" + key + "' parameter is undefined." );
					continue;

				}

				// for backward compatability if shading is set in the constructor
				if ( key === 'shading' ) {

					console.warn( 'THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.' );
					this.flatShading = ( newValue === FlatShading ) ? true : false;
					continue;

				}

				var currentValue = this[ key ];

				if ( currentValue === undefined ) {

					console.warn( "THREE." + this.type + ": '" + key + "' is not a property of this material." );
					continue;

				}

				if ( currentValue && currentValue.isColor ) {

					currentValue.set( newValue );

				} else if ( ( currentValue && currentValue.isVector3 ) && ( newValue && newValue.isVector3 ) ) {

					currentValue.copy( newValue );

				} else if ( key === 'overdraw' ) {

					// ensure overdraw is backwards-compatible with legacy boolean type
					this[ key ] = Number( newValue );

				} else {

					this[ key ] = newValue;

				}

			}

		},

		toJSON: function ( meta ) {

			var isRoot = meta === undefined;

			if ( isRoot ) {

				meta = {
					textures: {},
					images: {}
				};

			}

			var data = {
				metadata: {
					version: 4.5,
					type: 'Material',
					generator: 'Material.toJSON'
				}
			};

			// standard Material serialization
			data.uuid = this.uuid;
			data.type = this.type;

			if ( this.name !== '' ) data.name = this.name;

			if ( this.color && this.color.isColor ) data.color = this.color.getHex();

			if ( this.roughness !== undefined ) data.roughness = this.roughness;
			if ( this.metalness !== undefined ) data.metalness = this.metalness;

			if ( this.emissive && this.emissive.isColor ) data.emissive = this.emissive.getHex();
			if ( this.specular && this.specular.isColor ) data.specular = this.specular.getHex();
			if ( this.shininess !== undefined ) data.shininess = this.shininess;
			if ( this.clearCoat !== undefined ) data.clearCoat = this.clearCoat;
			if ( this.clearCoatRoughness !== undefined ) data.clearCoatRoughness = this.clearCoatRoughness;

			if ( this.map && this.map.isTexture ) data.map = this.map.toJSON( meta ).uuid;
			if ( this.alphaMap && this.alphaMap.isTexture ) data.alphaMap = this.alphaMap.toJSON( meta ).uuid;
			if ( this.lightMap && this.lightMap.isTexture ) data.lightMap = this.lightMap.toJSON( meta ).uuid;
			if ( this.bumpMap && this.bumpMap.isTexture ) {

				data.bumpMap = this.bumpMap.toJSON( meta ).uuid;
				data.bumpScale = this.bumpScale;

			}
			if ( this.normalMap && this.normalMap.isTexture ) {

				data.normalMap = this.normalMap.toJSON( meta ).uuid;
				data.normalScale = this.normalScale.toArray();

			}
			if ( this.displacementMap && this.displacementMap.isTexture ) {

				data.displacementMap = this.displacementMap.toJSON( meta ).uuid;
				data.displacementScale = this.displacementScale;
				data.displacementBias = this.displacementBias;

			}
			if ( this.roughnessMap && this.roughnessMap.isTexture ) data.roughnessMap = this.roughnessMap.toJSON( meta ).uuid;
			if ( this.metalnessMap && this.metalnessMap.isTexture ) data.metalnessMap = this.metalnessMap.toJSON( meta ).uuid;

			if ( this.emissiveMap && this.emissiveMap.isTexture ) data.emissiveMap = this.emissiveMap.toJSON( meta ).uuid;
			if ( this.specularMap && this.specularMap.isTexture ) data.specularMap = this.specularMap.toJSON( meta ).uuid;

			if ( this.envMap && this.envMap.isTexture ) {

				data.envMap = this.envMap.toJSON( meta ).uuid;
				data.reflectivity = this.reflectivity; // Scale behind envMap

			}

			if ( this.gradientMap && this.gradientMap.isTexture ) {

				data.gradientMap = this.gradientMap.toJSON( meta ).uuid;

			}

			if ( this.size !== undefined ) data.size = this.size;
			if ( this.sizeAttenuation !== undefined ) data.sizeAttenuation = this.sizeAttenuation;

			if ( this.blending !== NormalBlending ) data.blending = this.blending;
			if ( this.flatShading === true ) data.flatShading = this.flatShading;
			if ( this.side !== FrontSide ) data.side = this.side;
			if ( this.vertexColors !== NoColors ) data.vertexColors = this.vertexColors;

			if ( this.opacity < 1 ) data.opacity = this.opacity;
			if ( this.transparent === true ) data.transparent = this.transparent;

			data.depthFunc = this.depthFunc;
			data.depthTest = this.depthTest;
			data.depthWrite = this.depthWrite;

			if ( this.dithering === true ) data.dithering = true;

			if ( this.alphaTest > 0 ) data.alphaTest = this.alphaTest;
			if ( this.premultipliedAlpha === true ) data.premultipliedAlpha = this.premultipliedAlpha;

			if ( this.wireframe === true ) data.wireframe = this.wireframe;
			if ( this.wireframeLinewidth > 1 ) data.wireframeLinewidth = this.wireframeLinewidth;
			if ( this.wireframeLinecap !== 'round' ) data.wireframeLinecap = this.wireframeLinecap;
			if ( this.wireframeLinejoin !== 'round' ) data.wireframeLinejoin = this.wireframeLinejoin;

			if ( this.morphTargets === true ) data.morphTargets = true;
			if ( this.skinning === true ) data.skinning = true;

			if ( this.visible === false ) data.visible = false;
			if ( JSON.stringify( this.userData ) !== '{}' ) data.userData = this.userData;

			// TODO: Copied from Object3D.toJSON

			function extractFromCache( cache ) {

				var values = [];

				for ( var key in cache ) {

					var data = cache[ key ];
					delete data.metadata;
					values.push( data );

				}

				return values;

			}

			if ( isRoot ) {

				var textures = extractFromCache( meta.textures );
				var images = extractFromCache( meta.images );

				if ( textures.length > 0 ) data.textures = textures;
				if ( images.length > 0 ) data.images = images;

			}

			return data;

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( source ) {

			this.name = source.name;

			this.fog = source.fog;
			this.lights = source.lights;

			this.blending = source.blending;
			this.side = source.side;
			this.flatShading = source.flatShading;
			this.vertexColors = source.vertexColors;

			this.opacity = source.opacity;
			this.transparent = source.transparent;

			this.blendSrc = source.blendSrc;
			this.blendDst = source.blendDst;
			this.blendEquation = source.blendEquation;
			this.blendSrcAlpha = source.blendSrcAlpha;
			this.blendDstAlpha = source.blendDstAlpha;
			this.blendEquationAlpha = source.blendEquationAlpha;

			this.depthFunc = source.depthFunc;
			this.depthTest = source.depthTest;
			this.depthWrite = source.depthWrite;

			this.colorWrite = source.colorWrite;

			this.precision = source.precision;

			this.polygonOffset = source.polygonOffset;
			this.polygonOffsetFactor = source.polygonOffsetFactor;
			this.polygonOffsetUnits = source.polygonOffsetUnits;

			this.dithering = source.dithering;

			this.alphaTest = source.alphaTest;
			this.premultipliedAlpha = source.premultipliedAlpha;

			this.overdraw = source.overdraw;

			this.visible = source.visible;
			this.userData = JSON.parse( JSON.stringify( source.userData ) );

			this.clipShadows = source.clipShadows;
			this.clipIntersection = source.clipIntersection;

			var srcPlanes = source.clippingPlanes,
				dstPlanes = null;

			if ( srcPlanes !== null ) {

				var n = srcPlanes.length;
				dstPlanes = new Array( n );

				for ( var i = 0; i !== n; ++ i )
					dstPlanes[ i ] = srcPlanes[ i ].clone();

			}

			this.clippingPlanes = dstPlanes;

			return this;

		},

		dispose: function () {

			this.dispatchEvent( { type: 'dispose' } );

		}

	} );

	/**
	 * @author alteredq / http://alteredqualia.com/
	 *
	 * parameters = {
	 *  defines: { "label" : "value" },
	 *  uniforms: { "parameter1": { value: 1.0 }, "parameter2": { value2: 2 } },
	 *
	 *  fragmentShader: <string>,
	 *  vertexShader: <string>,
	 *
	 *  wireframe: <boolean>,
	 *  wireframeLinewidth: <float>,
	 *
	 *  lights: <bool>,
	 *
	 *  skinning: <bool>,
	 *  morphTargets: <bool>,
	 *  morphNormals: <bool>
	 * }
	 */

	function ShaderMaterial( parameters ) {

		Material.call( this );

		this.type = 'ShaderMaterial';

		this.defines = {};
		this.uniforms = {};

		this.vertexShader = 'void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}';
		this.fragmentShader = 'void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}';

		this.linewidth = 1;

		this.wireframe = false;
		this.wireframeLinewidth = 1;

		this.fog = false; // set to use scene fog
		this.lights = false; // set to use scene lights
		this.clipping = false; // set to use user-defined clipping planes

		this.skinning = false; // set to use skinning attribute streams
		this.morphTargets = false; // set to use morph targets
		this.morphNormals = false; // set to use morph normals

		this.extensions = {
			derivatives: false, // set to use derivatives
			fragDepth: false, // set to use fragment depth values
			drawBuffers: false, // set to use draw buffers
			shaderTextureLOD: false // set to use shader texture LOD
		};

		// When rendered geometry doesn't include these attributes but the material does,
		// use these default values in WebGL. This avoids errors when buffer data is missing.
		this.defaultAttributeValues = {
			'color': [ 1, 1, 1 ],
			'uv': [ 0, 0 ],
			'uv2': [ 0, 0 ]
		};

		this.index0AttributeName = undefined;

		if ( parameters !== undefined ) {

			if ( parameters.attributes !== undefined ) {

				console.error( 'THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead.' );

			}

			this.setValues( parameters );

		}

	}

	ShaderMaterial.prototype = Object.create( Material.prototype );
	ShaderMaterial.prototype.constructor = ShaderMaterial;

	ShaderMaterial.prototype.isShaderMaterial = true;

	ShaderMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.fragmentShader = source.fragmentShader;
		this.vertexShader = source.vertexShader;

		this.uniforms = UniformsUtils.clone( source.uniforms );

		this.defines = source.defines;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;

		this.lights = source.lights;
		this.clipping = source.clipping;

		this.skinning = source.skinning;

		this.morphTargets = source.morphTargets;
		this.morphNormals = source.morphNormals;

		this.extensions = source.extensions;

		return this;

	};

	ShaderMaterial.prototype.toJSON = function ( meta ) {

		var data = Material.prototype.toJSON.call( this, meta );

		data.uniforms = this.uniforms;
		data.vertexShader = this.vertexShader;
		data.fragmentShader = this.fragmentShader;

		return data;

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 * @author bhouston / https://clara.io
	 * @author WestLangley / http://github.com/WestLangley
	 *
	 * parameters = {
	 *
	 *  opacity: <float>,
	 *
	 *  map: new THREE.Texture( <Image> ),
	 *
	 *  alphaMap: new THREE.Texture( <Image> ),
	 *
	 *  displacementMap: new THREE.Texture( <Image> ),
	 *  displacementScale: <float>,
	 *  displacementBias: <float>,
	 *
	 *  wireframe: <boolean>,
	 *  wireframeLinewidth: <float>
	 * }
	 */

	function MeshDepthMaterial( parameters ) {

		Material.call( this );

		this.type = 'MeshDepthMaterial';

		this.depthPacking = BasicDepthPacking;

		this.skinning = false;
		this.morphTargets = false;

		this.map = null;

		this.alphaMap = null;

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.wireframe = false;
		this.wireframeLinewidth = 1;

		this.fog = false;
		this.lights = false;

		this.setValues( parameters );

	}

	MeshDepthMaterial.prototype = Object.create( Material.prototype );
	MeshDepthMaterial.prototype.constructor = MeshDepthMaterial;

	MeshDepthMaterial.prototype.isMeshDepthMaterial = true;

	MeshDepthMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.depthPacking = source.depthPacking;

		this.skinning = source.skinning;
		this.morphTargets = source.morphTargets;

		this.map = source.map;

		this.alphaMap = source.alphaMap;

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;

		return this;

	};

	/**
	 * @author WestLangley / http://github.com/WestLangley
	 *
	 * parameters = {
	 *
	 *  referencePosition: <float>,
	 *  nearDistance: <float>,
	 *  farDistance: <float>,
	 *
	 *  skinning: <bool>,
	 *  morphTargets: <bool>,
	 *
	 *  map: new THREE.Texture( <Image> ),
	 *
	 *  alphaMap: new THREE.Texture( <Image> ),
	 *
	 *  displacementMap: new THREE.Texture( <Image> ),
	 *  displacementScale: <float>,
	 *  displacementBias: <float>
	 *
	 * }
	 */

	function MeshDistanceMaterial( parameters ) {

		Material.call( this );

		this.type = 'MeshDistanceMaterial';

		this.referencePosition = new Vector3();
		this.nearDistance = 1;
		this.farDistance = 1000;

		this.skinning = false;
		this.morphTargets = false;

		this.map = null;

		this.alphaMap = null;

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.fog = false;
		this.lights = false;

		this.setValues( parameters );

	}

	MeshDistanceMaterial.prototype = Object.create( Material.prototype );
	MeshDistanceMaterial.prototype.constructor = MeshDistanceMaterial;

	MeshDistanceMaterial.prototype.isMeshDistanceMaterial = true;

	MeshDistanceMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.referencePosition.copy( source.referencePosition );
		this.nearDistance = source.nearDistance;
		this.farDistance = source.farDistance;

		this.skinning = source.skinning;
		this.morphTargets = source.morphTargets;

		this.map = source.map;

		this.alphaMap = source.alphaMap;

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		return this;

	};

	/**
	 * @author bhouston / http://clara.io
	 * @author WestLangley / http://github.com/WestLangley
	 */

	function Box3( min, max ) {

		this.min = ( min !== undefined ) ? min : new Vector3( + Infinity, + Infinity, + Infinity );
		this.max = ( max !== undefined ) ? max : new Vector3( - Infinity, - Infinity, - Infinity );

	}

	Object.assign( Box3.prototype, {

		isBox3: true,

		set: function ( min, max ) {

			this.min.copy( min );
			this.max.copy( max );

			return this;

		},

		setFromArray: function ( array ) {

			var minX = + Infinity;
			var minY = + Infinity;
			var minZ = + Infinity;

			var maxX = - Infinity;
			var maxY = - Infinity;
			var maxZ = - Infinity;

			for ( var i = 0, l = array.length; i < l; i += 3 ) {

				var x = array[ i ];
				var y = array[ i + 1 ];
				var z = array[ i + 2 ];

				if ( x < minX ) minX = x;
				if ( y < minY ) minY = y;
				if ( z < minZ ) minZ = z;

				if ( x > maxX ) maxX = x;
				if ( y > maxY ) maxY = y;
				if ( z > maxZ ) maxZ = z;

			}

			this.min.set( minX, minY, minZ );
			this.max.set( maxX, maxY, maxZ );

			return this;

		},

		setFromBufferAttribute: function ( attribute ) {

			var minX = + Infinity;
			var minY = + Infinity;
			var minZ = + Infinity;

			var maxX = - Infinity;
			var maxY = - Infinity;
			var maxZ = - Infinity;

			for ( var i = 0, l = attribute.count; i < l; i ++ ) {

				var x = attribute.getX( i );
				var y = attribute.getY( i );
				var z = attribute.getZ( i );

				if ( x < minX ) minX = x;
				if ( y < minY ) minY = y;
				if ( z < minZ ) minZ = z;

				if ( x > maxX ) maxX = x;
				if ( y > maxY ) maxY = y;
				if ( z > maxZ ) maxZ = z;

			}

			this.min.set( minX, minY, minZ );
			this.max.set( maxX, maxY, maxZ );

			return this;

		},

		setFromPoints: function ( points ) {

			this.makeEmpty();

			for ( var i = 0, il = points.length; i < il; i ++ ) {

				this.expandByPoint( points[ i ] );

			}

			return this;

		},

		setFromCenterAndSize: function () {

			var v1 = new Vector3();

			return function setFromCenterAndSize( center, size ) {

				var halfSize = v1.copy( size ).multiplyScalar( 0.5 );

				this.min.copy( center ).sub( halfSize );
				this.max.copy( center ).add( halfSize );

				return this;

			};

		}(),

		setFromObject: function ( object ) {

			this.makeEmpty();

			return this.expandByObject( object );

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( box ) {

			this.min.copy( box.min );
			this.max.copy( box.max );

			return this;

		},

		makeEmpty: function () {

			this.min.x = this.min.y = this.min.z = + Infinity;
			this.max.x = this.max.y = this.max.z = - Infinity;

			return this;

		},

		isEmpty: function () {

			// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes

			return ( this.max.x < this.min.x ) || ( this.max.y < this.min.y ) || ( this.max.z < this.min.z );

		},

		getCenter: function ( optionalTarget ) {

			var result = optionalTarget || new Vector3();
			return this.isEmpty() ? result.set( 0, 0, 0 ) : result.addVectors( this.min, this.max ).multiplyScalar( 0.5 );

		},

		getSize: function ( optionalTarget ) {

			var result = optionalTarget || new Vector3();
			return this.isEmpty() ? result.set( 0, 0, 0 ) : result.subVectors( this.max, this.min );

		},

		expandByPoint: function ( point ) {

			this.min.min( point );
			this.max.max( point );

			return this;

		},

		expandByVector: function ( vector ) {

			this.min.sub( vector );
			this.max.add( vector );

			return this;

		},

		expandByScalar: function ( scalar ) {

			this.min.addScalar( - scalar );
			this.max.addScalar( scalar );

			return this;

		},

		expandByObject: function () {

			// Computes the world-axis-aligned bounding box of an object (including its children),
			// accounting for both the object's, and children's, world transforms

			var v1 = new Vector3();

			return function expandByObject( object ) {

				var scope = this;

				object.updateMatrixWorld( true );

				object.traverse( function ( node ) {

					var i, l;

					var geometry = node.geometry;

					if ( geometry !== undefined ) {

						if ( geometry.isGeometry ) {

							var vertices = geometry.vertices;

							for ( i = 0, l = vertices.length; i < l; i ++ ) {

								v1.copy( vertices[ i ] );
								v1.applyMatrix4( node.matrixWorld );

								scope.expandByPoint( v1 );

							}

						} else if ( geometry.isBufferGeometry ) {

							var attribute = geometry.attributes.position;

							if ( attribute !== undefined ) {

								for ( i = 0, l = attribute.count; i < l; i ++ ) {

									v1.fromBufferAttribute( attribute, i ).applyMatrix4( node.matrixWorld );

									scope.expandByPoint( v1 );

								}

							}

						}

					}

				} );

				return this;

			};

		}(),

		containsPoint: function ( point ) {

			return point.x < this.min.x || point.x > this.max.x ||
				point.y < this.min.y || point.y > this.max.y ||
				point.z < this.min.z || point.z > this.max.z ? false : true;

		},

		containsBox: function ( box ) {

			return this.min.x <= box.min.x && box.max.x <= this.max.x &&
				this.min.y <= box.min.y && box.max.y <= this.max.y &&
				this.min.z <= box.min.z && box.max.z <= this.max.z;

		},

		getParameter: function ( point, optionalTarget ) {

			// This can potentially have a divide by zero if the box
			// has a size dimension of 0.

			var result = optionalTarget || new Vector3();

			return result.set(
				( point.x - this.min.x ) / ( this.max.x - this.min.x ),
				( point.y - this.min.y ) / ( this.max.y - this.min.y ),
				( point.z - this.min.z ) / ( this.max.z - this.min.z )
			);

		},

		intersectsBox: function ( box ) {

			// using 6 splitting planes to rule out intersections.
			return box.max.x < this.min.x || box.min.x > this.max.x ||
				box.max.y < this.min.y || box.min.y > this.max.y ||
				box.max.z < this.min.z || box.min.z > this.max.z ? false : true;

		},

		intersectsSphere: ( function () {

			var closestPoint = new Vector3();

			return function intersectsSphere( sphere ) {

				// Find the point on the AABB closest to the sphere center.
				this.clampPoint( sphere.center, closestPoint );

				// If that point is inside the sphere, the AABB and sphere intersect.
				return closestPoint.distanceToSquared( sphere.center ) <= ( sphere.radius * sphere.radius );

			};

		} )(),

		intersectsPlane: function ( plane ) {

			// We compute the minimum and maximum dot product values. If those values
			// are on the same side (back or front) of the plane, then there is no intersection.

			var min, max;

			if ( plane.normal.x > 0 ) {

				min = plane.normal.x * this.min.x;
				max = plane.normal.x * this.max.x;

			} else {

				min = plane.normal.x * this.max.x;
				max = plane.normal.x * this.min.x;

			}

			if ( plane.normal.y > 0 ) {

				min += plane.normal.y * this.min.y;
				max += plane.normal.y * this.max.y;

			} else {

				min += plane.normal.y * this.max.y;
				max += plane.normal.y * this.min.y;

			}

			if ( plane.normal.z > 0 ) {

				min += plane.normal.z * this.min.z;
				max += plane.normal.z * this.max.z;

			} else {

				min += plane.normal.z * this.max.z;
				max += plane.normal.z * this.min.z;

			}

			return ( min <= plane.constant && max >= plane.constant );

		},

		clampPoint: function ( point, optionalTarget ) {

			var result = optionalTarget || new Vector3();
			return result.copy( point ).clamp( this.min, this.max );

		},

		distanceToPoint: function () {

			var v1 = new Vector3();

			return function distanceToPoint( point ) {

				var clampedPoint = v1.copy( point ).clamp( this.min, this.max );
				return clampedPoint.sub( point ).length();

			};

		}(),

		getBoundingSphere: function () {

			var v1 = new Vector3();

			return function getBoundingSphere( optionalTarget ) {

				var result = optionalTarget || new Sphere();

				this.getCenter( result.center );

				result.radius = this.getSize( v1 ).length() * 0.5;

				return result;

			};

		}(),

		intersect: function ( box ) {

			this.min.max( box.min );
			this.max.min( box.max );

			// ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
			if( this.isEmpty() ) this.makeEmpty();

			return this;

		},

		union: function ( box ) {

			this.min.min( box.min );
			this.max.max( box.max );

			return this;

		},

		applyMatrix4: function () {

			var points = [
				new Vector3(),
				new Vector3(),
				new Vector3(),
				new Vector3(),
				new Vector3(),
				new Vector3(),
				new Vector3(),
				new Vector3()
			];

			return function applyMatrix4( matrix ) {

				// transform of empty box is an empty box.
				if( this.isEmpty() ) return this;

				// NOTE: I am using a binary pattern to specify all 2^3 combinations below
				points[ 0 ].set( this.min.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 000
				points[ 1 ].set( this.min.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 001
				points[ 2 ].set( this.min.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 010
				points[ 3 ].set( this.min.x, this.max.y, this.max.z ).applyMatrix4( matrix ); // 011
				points[ 4 ].set( this.max.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 100
				points[ 5 ].set( this.max.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 101
				points[ 6 ].set( this.max.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 110
				points[ 7 ].set( this.max.x, this.max.y, this.max.z ).applyMatrix4( matrix );	// 111

				this.setFromPoints( points );

				return this;

			};

		}(),

		translate: function ( offset ) {

			this.min.add( offset );
			this.max.add( offset );

			return this;

		},

		equals: function ( box ) {

			return box.min.equals( this.min ) && box.max.equals( this.max );

		}

	} );

	/**
	 * @author bhouston / http://clara.io
	 * @author mrdoob / http://mrdoob.com/
	 */

	function Sphere( center, radius ) {

		this.center = ( center !== undefined ) ? center : new Vector3();
		this.radius = ( radius !== undefined ) ? radius : 0;

	}

	Object.assign( Sphere.prototype, {

		set: function ( center, radius ) {

			this.center.copy( center );
			this.radius = radius;

			return this;

		},

		setFromPoints: function () {

			var box = new Box3();

			return function setFromPoints( points, optionalCenter ) {

				var center = this.center;

				if ( optionalCenter !== undefined ) {

					center.copy( optionalCenter );

				} else {

					box.setFromPoints( points ).getCenter( center );

				}

				var maxRadiusSq = 0;

				for ( var i = 0, il = points.length; i < il; i ++ ) {

					maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( points[ i ] ) );

				}

				this.radius = Math.sqrt( maxRadiusSq );

				return this;

			};

		}(),

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( sphere ) {

			this.center.copy( sphere.center );
			this.radius = sphere.radius;

			return this;

		},

		empty: function () {

			return ( this.radius <= 0 );

		},

		containsPoint: function ( point ) {

			return ( point.distanceToSquared( this.center ) <= ( this.radius * this.radius ) );

		},

		distanceToPoint: function ( point ) {

			return ( point.distanceTo( this.center ) - this.radius );

		},

		intersectsSphere: function ( sphere ) {

			var radiusSum = this.radius + sphere.radius;

			return sphere.center.distanceToSquared( this.center ) <= ( radiusSum * radiusSum );

		},

		intersectsBox: function ( box ) {

			return box.intersectsSphere( this );

		},

		intersectsPlane: function ( plane ) {

			return Math.abs( plane.distanceToPoint( this.center ) ) <= this.radius;

		},

		clampPoint: function ( point, optionalTarget ) {

			var deltaLengthSq = this.center.distanceToSquared( point );

			var result = optionalTarget || new Vector3();

			result.copy( point );

			if ( deltaLengthSq > ( this.radius * this.radius ) ) {

				result.sub( this.center ).normalize();
				result.multiplyScalar( this.radius ).add( this.center );

			}

			return result;

		},

		getBoundingBox: function ( optionalTarget ) {

			var box = optionalTarget || new Box3();

			box.set( this.center, this.center );
			box.expandByScalar( this.radius );

			return box;

		},

		applyMatrix4: function ( matrix ) {

			this.center.applyMatrix4( matrix );
			this.radius = this.radius * matrix.getMaxScaleOnAxis();

			return this;

		},

		translate: function ( offset ) {

			this.center.add( offset );

			return this;

		},

		equals: function ( sphere ) {

			return sphere.center.equals( this.center ) && ( sphere.radius === this.radius );

		}

	} );

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author WestLangley / http://github.com/WestLangley
	 * @author bhouston / http://clara.io
	 * @author tschw
	 */

	function Matrix3() {

		this.elements = [

			1, 0, 0,
			0, 1, 0,
			0, 0, 1

		];

		if ( arguments.length > 0 ) {

			console.error( 'THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.' );

		}

	}

	Object.assign( Matrix3.prototype, {

		isMatrix3: true,

		set: function ( n11, n12, n13, n21, n22, n23, n31, n32, n33 ) {

			var te = this.elements;

			te[ 0 ] = n11; te[ 1 ] = n21; te[ 2 ] = n31;
			te[ 3 ] = n12; te[ 4 ] = n22; te[ 5 ] = n32;
			te[ 6 ] = n13; te[ 7 ] = n23; te[ 8 ] = n33;

			return this;

		},

		identity: function () {

			this.set(

				1, 0, 0,
				0, 1, 0,
				0, 0, 1

			);

			return this;

		},

		clone: function () {

			return new this.constructor().fromArray( this.elements );

		},

		copy: function ( m ) {

			var te = this.elements;
			var me = m.elements;

			te[ 0 ] = me[ 0 ]; te[ 1 ] = me[ 1 ]; te[ 2 ] = me[ 2 ];
			te[ 3 ] = me[ 3 ]; te[ 4 ] = me[ 4 ]; te[ 5 ] = me[ 5 ];
			te[ 6 ] = me[ 6 ]; te[ 7 ] = me[ 7 ]; te[ 8 ] = me[ 8 ];

			return this;

		},

		setFromMatrix4: function ( m ) {

			var me = m.elements;

			this.set(

				me[ 0 ], me[ 4 ], me[  8 ],
				me[ 1 ], me[ 5 ], me[  9 ],
				me[ 2 ], me[ 6 ], me[ 10 ]

			);

			return this;

		},

		applyToBufferAttribute: function () {

			var v1 = new Vector3();

			return function applyToBufferAttribute( attribute ) {

				for ( var i = 0, l = attribute.count; i < l; i ++ ) {

					v1.x = attribute.getX( i );
					v1.y = attribute.getY( i );
					v1.z = attribute.getZ( i );

					v1.applyMatrix3( this );

					attribute.setXYZ( i, v1.x, v1.y, v1.z );

				}

				return attribute;

			};

		}(),

		multiply: function ( m ) {

			return this.multiplyMatrices( this, m );

		},

		premultiply: function ( m ) {

			return this.multiplyMatrices( m, this );

		},

		multiplyMatrices: function ( a, b ) {

			var ae = a.elements;
			var be = b.elements;
			var te = this.elements;

			var a11 = ae[ 0 ], a12 = ae[ 3 ], a13 = ae[ 6 ];
			var a21 = ae[ 1 ], a22 = ae[ 4 ], a23 = ae[ 7 ];
			var a31 = ae[ 2 ], a32 = ae[ 5 ], a33 = ae[ 8 ];

			var b11 = be[ 0 ], b12 = be[ 3 ], b13 = be[ 6 ];
			var b21 = be[ 1 ], b22 = be[ 4 ], b23 = be[ 7 ];
			var b31 = be[ 2 ], b32 = be[ 5 ], b33 = be[ 8 ];

			te[ 0 ] = a11 * b11 + a12 * b21 + a13 * b31;
			te[ 3 ] = a11 * b12 + a12 * b22 + a13 * b32;
			te[ 6 ] = a11 * b13 + a12 * b23 + a13 * b33;

			te[ 1 ] = a21 * b11 + a22 * b21 + a23 * b31;
			te[ 4 ] = a21 * b12 + a22 * b22 + a23 * b32;
			te[ 7 ] = a21 * b13 + a22 * b23 + a23 * b33;

			te[ 2 ] = a31 * b11 + a32 * b21 + a33 * b31;
			te[ 5 ] = a31 * b12 + a32 * b22 + a33 * b32;
			te[ 8 ] = a31 * b13 + a32 * b23 + a33 * b33;

			return this;

		},

		multiplyScalar: function ( s ) {

			var te = this.elements;

			te[ 0 ] *= s; te[ 3 ] *= s; te[ 6 ] *= s;
			te[ 1 ] *= s; te[ 4 ] *= s; te[ 7 ] *= s;
			te[ 2 ] *= s; te[ 5 ] *= s; te[ 8 ] *= s;

			return this;

		},

		determinant: function () {

			var te = this.elements;

			var a = te[ 0 ], b = te[ 1 ], c = te[ 2 ],
				d = te[ 3 ], e = te[ 4 ], f = te[ 5 ],
				g = te[ 6 ], h = te[ 7 ], i = te[ 8 ];

			return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;

		},

		getInverse: function ( matrix, throwOnDegenerate ) {

			if ( matrix && matrix.isMatrix4 ) {

				console.error( "THREE.Matrix3: .getInverse() no longer takes a Matrix4 argument." );

			}

			var me = matrix.elements,
				te = this.elements,

				n11 = me[ 0 ], n21 = me[ 1 ], n31 = me[ 2 ],
				n12 = me[ 3 ], n22 = me[ 4 ], n32 = me[ 5 ],
				n13 = me[ 6 ], n23 = me[ 7 ], n33 = me[ 8 ],

				t11 = n33 * n22 - n32 * n23,
				t12 = n32 * n13 - n33 * n12,
				t13 = n23 * n12 - n22 * n13,

				det = n11 * t11 + n21 * t12 + n31 * t13;

			if ( det === 0 ) {

				var msg = "THREE.Matrix3: .getInverse() can't invert matrix, determinant is 0";

				if ( throwOnDegenerate === true ) {

					throw new Error( msg );

				} else {

					console.warn( msg );

				}

				return this.identity();

			}

			var detInv = 1 / det;

			te[ 0 ] = t11 * detInv;
			te[ 1 ] = ( n31 * n23 - n33 * n21 ) * detInv;
			te[ 2 ] = ( n32 * n21 - n31 * n22 ) * detInv;

			te[ 3 ] = t12 * detInv;
			te[ 4 ] = ( n33 * n11 - n31 * n13 ) * detInv;
			te[ 5 ] = ( n31 * n12 - n32 * n11 ) * detInv;

			te[ 6 ] = t13 * detInv;
			te[ 7 ] = ( n21 * n13 - n23 * n11 ) * detInv;
			te[ 8 ] = ( n22 * n11 - n21 * n12 ) * detInv;

			return this;

		},

		transpose: function () {

			var tmp, m = this.elements;

			tmp = m[ 1 ]; m[ 1 ] = m[ 3 ]; m[ 3 ] = tmp;
			tmp = m[ 2 ]; m[ 2 ] = m[ 6 ]; m[ 6 ] = tmp;
			tmp = m[ 5 ]; m[ 5 ] = m[ 7 ]; m[ 7 ] = tmp;

			return this;

		},

		getNormalMatrix: function ( matrix4 ) {

			return this.setFromMatrix4( matrix4 ).getInverse( this ).transpose();

		},

		transposeIntoArray: function ( r ) {

			var m = this.elements;

			r[ 0 ] = m[ 0 ];
			r[ 1 ] = m[ 3 ];
			r[ 2 ] = m[ 6 ];
			r[ 3 ] = m[ 1 ];
			r[ 4 ] = m[ 4 ];
			r[ 5 ] = m[ 7 ];
			r[ 6 ] = m[ 2 ];
			r[ 7 ] = m[ 5 ];
			r[ 8 ] = m[ 8 ];

			return this;

		},

		equals: function ( matrix ) {

			var te = this.elements;
			var me = matrix.elements;

			for ( var i = 0; i < 9; i ++ ) {

				if ( te[ i ] !== me[ i ] ) return false;

			}

			return true;

		},

		fromArray: function ( array, offset ) {

			if ( offset === undefined ) offset = 0;

			for ( var i = 0; i < 9; i ++ ) {

				this.elements[ i ] = array[ i + offset ];

			}

			return this;

		},

		toArray: function ( array, offset ) {

			if ( array === undefined ) array = [];
			if ( offset === undefined ) offset = 0;

			var te = this.elements;

			array[ offset ] = te[ 0 ];
			array[ offset + 1 ] = te[ 1 ];
			array[ offset + 2 ] = te[ 2 ];

			array[ offset + 3 ] = te[ 3 ];
			array[ offset + 4 ] = te[ 4 ];
			array[ offset + 5 ] = te[ 5 ];

			array[ offset + 6 ] = te[ 6 ];
			array[ offset + 7 ] = te[ 7 ];
			array[ offset + 8 ] = te[ 8 ];

			return array;

		}

	} );

	/**
	 * @author bhouston / http://clara.io
	 */

	function Plane( normal, constant ) {

		// normal is assumed to be normalized

		this.normal = ( normal !== undefined ) ? normal : new Vector3( 1, 0, 0 );
		this.constant = ( constant !== undefined ) ? constant : 0;

	}

	Object.assign( Plane.prototype, {

		set: function ( normal, constant ) {

			this.normal.copy( normal );
			this.constant = constant;

			return this;

		},

		setComponents: function ( x, y, z, w ) {

			this.normal.set( x, y, z );
			this.constant = w;

			return this;

		},

		setFromNormalAndCoplanarPoint: function ( normal, point ) {

			this.normal.copy( normal );
			this.constant = - point.dot( this.normal );

			return this;

		},

		setFromCoplanarPoints: function () {

			var v1 = new Vector3();
			var v2 = new Vector3();

			return function setFromCoplanarPoints( a, b, c ) {

				var normal = v1.subVectors( c, b ).cross( v2.subVectors( a, b ) ).normalize();

				// Q: should an error be thrown if normal is zero (e.g. degenerate plane)?

				this.setFromNormalAndCoplanarPoint( normal, a );

				return this;

			};

		}(),

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( plane ) {

			this.normal.copy( plane.normal );
			this.constant = plane.constant;

			return this;

		},

		normalize: function () {

			// Note: will lead to a divide by zero if the plane is invalid.

			var inverseNormalLength = 1.0 / this.normal.length();
			this.normal.multiplyScalar( inverseNormalLength );
			this.constant *= inverseNormalLength;

			return this;

		},

		negate: function () {

			this.constant *= - 1;
			this.normal.negate();

			return this;

		},

		distanceToPoint: function ( point ) {

			return this.normal.dot( point ) + this.constant;

		},

		distanceToSphere: function ( sphere ) {

			return this.distanceToPoint( sphere.center ) - sphere.radius;

		},

		projectPoint: function ( point, optionalTarget ) {

			var result = optionalTarget || new Vector3();

			return result.copy( this.normal ).multiplyScalar( - this.distanceToPoint( point ) ).add( point );

		},

		intersectLine: function () {

			var v1 = new Vector3();

			return function intersectLine( line, optionalTarget ) {

				var result = optionalTarget || new Vector3();

				var direction = line.delta( v1 );

				var denominator = this.normal.dot( direction );

				if ( denominator === 0 ) {

					// line is coplanar, return origin
					if ( this.distanceToPoint( line.start ) === 0 ) {

						return result.copy( line.start );

					}

					// Unsure if this is the correct method to handle this case.
					return undefined;

				}

				var t = - ( line.start.dot( this.normal ) + this.constant ) / denominator;

				if ( t < 0 || t > 1 ) {

					return undefined;

				}

				return result.copy( direction ).multiplyScalar( t ).add( line.start );

			};

		}(),

		intersectsLine: function ( line ) {

			// Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.

			var startSign = this.distanceToPoint( line.start );
			var endSign = this.distanceToPoint( line.end );

			return ( startSign < 0 && endSign > 0 ) || ( endSign < 0 && startSign > 0 );

		},

		intersectsBox: function ( box ) {

			return box.intersectsPlane( this );

		},

		intersectsSphere: function ( sphere ) {

			return sphere.intersectsPlane( this );

		},

		coplanarPoint: function ( optionalTarget ) {

			var result = optionalTarget || new Vector3();

			return result.copy( this.normal ).multiplyScalar( - this.constant );

		},

		applyMatrix4: function () {

			var v1 = new Vector3();
			var m1 = new Matrix3();

			return function applyMatrix4( matrix, optionalNormalMatrix ) {

				var normalMatrix = optionalNormalMatrix || m1.getNormalMatrix( matrix );

				var referencePoint = this.coplanarPoint( v1 ).applyMatrix4( matrix );

				var normal = this.normal.applyMatrix3( normalMatrix ).normalize();

				this.constant = - referencePoint.dot( normal );

				return this;

			};

		}(),

		translate: function ( offset ) {

			this.constant -= offset.dot( this.normal );

			return this;

		},

		equals: function ( plane ) {

			return plane.normal.equals( this.normal ) && ( plane.constant === this.constant );

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 * @author bhouston / http://clara.io
	 */

	function Frustum( p0, p1, p2, p3, p4, p5 ) {

		this.planes = [

			( p0 !== undefined ) ? p0 : new Plane(),
			( p1 !== undefined ) ? p1 : new Plane(),
			( p2 !== undefined ) ? p2 : new Plane(),
			( p3 !== undefined ) ? p3 : new Plane(),
			( p4 !== undefined ) ? p4 : new Plane(),
			( p5 !== undefined ) ? p5 : new Plane()

		];

	}

	Object.assign( Frustum.prototype, {

		set: function ( p0, p1, p2, p3, p4, p5 ) {

			var planes = this.planes;

			planes[ 0 ].copy( p0 );
			planes[ 1 ].copy( p1 );
			planes[ 2 ].copy( p2 );
			planes[ 3 ].copy( p3 );
			planes[ 4 ].copy( p4 );
			planes[ 5 ].copy( p5 );

			return this;

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( frustum ) {

			var planes = this.planes;

			for ( var i = 0; i < 6; i ++ ) {

				planes[ i ].copy( frustum.planes[ i ] );

			}

			return this;

		},

		setFromMatrix: function ( m ) {

			var planes = this.planes;
			var me = m.elements;
			var me0 = me[ 0 ], me1 = me[ 1 ], me2 = me[ 2 ], me3 = me[ 3 ];
			var me4 = me[ 4 ], me5 = me[ 5 ], me6 = me[ 6 ], me7 = me[ 7 ];
			var me8 = me[ 8 ], me9 = me[ 9 ], me10 = me[ 10 ], me11 = me[ 11 ];
			var me12 = me[ 12 ], me13 = me[ 13 ], me14 = me[ 14 ], me15 = me[ 15 ];

			planes[ 0 ].setComponents( me3 - me0, me7 - me4, me11 - me8, me15 - me12 ).normalize();
			planes[ 1 ].setComponents( me3 + me0, me7 + me4, me11 + me8, me15 + me12 ).normalize();
			planes[ 2 ].setComponents( me3 + me1, me7 + me5, me11 + me9, me15 + me13 ).normalize();
			planes[ 3 ].setComponents( me3 - me1, me7 - me5, me11 - me9, me15 - me13 ).normalize();
			planes[ 4 ].setComponents( me3 - me2, me7 - me6, me11 - me10, me15 - me14 ).normalize();
			planes[ 5 ].setComponents( me3 + me2, me7 + me6, me11 + me10, me15 + me14 ).normalize();

			return this;

		},

		intersectsObject: function () {

			var sphere = new Sphere();

			return function intersectsObject( object ) {

				var geometry = object.geometry;

				if ( geometry.boundingSphere === null )
					geometry.computeBoundingSphere();

				sphere.copy( geometry.boundingSphere )
					.applyMatrix4( object.matrixWorld );

				return this.intersectsSphere( sphere );

			};

		}(),

		intersectsSprite: function () {

			var sphere = new Sphere();

			return function intersectsSprite( sprite ) {

				sphere.center.set( 0, 0, 0 );
				sphere.radius = 0.7071067811865476;
				sphere.applyMatrix4( sprite.matrixWorld );

				return this.intersectsSphere( sphere );

			};

		}(),

		intersectsSphere: function ( sphere ) {

			var planes = this.planes;
			var center = sphere.center;
			var negRadius = - sphere.radius;

			for ( var i = 0; i < 6; i ++ ) {

				var distance = planes[ i ].distanceToPoint( center );

				if ( distance < negRadius ) {

					return false;

				}

			}

			return true;

		},

		intersectsBox: function () {

			var p1 = new Vector3(),
				p2 = new Vector3();

			return function intersectsBox( box ) {

				var planes = this.planes;

				for ( var i = 0; i < 6; i ++ ) {

					var plane = planes[ i ];

					p1.x = plane.normal.x > 0 ? box.min.x : box.max.x;
					p2.x = plane.normal.x > 0 ? box.max.x : box.min.x;
					p1.y = plane.normal.y > 0 ? box.min.y : box.max.y;
					p2.y = plane.normal.y > 0 ? box.max.y : box.min.y;
					p1.z = plane.normal.z > 0 ? box.min.z : box.max.z;
					p2.z = plane.normal.z > 0 ? box.max.z : box.min.z;

					var d1 = plane.distanceToPoint( p1 );
					var d2 = plane.distanceToPoint( p2 );

					// if both outside plane, no intersection

					if ( d1 < 0 && d2 < 0 ) {

						return false;

					}

				}

				return true;

			};

		}(),

		containsPoint: function ( point ) {

			var planes = this.planes;

			for ( var i = 0; i < 6; i ++ ) {

				if ( planes[ i ].distanceToPoint( point ) < 0 ) {

					return false;

				}

			}

			return true;

		}

	} );

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLShadowMap( _renderer, _objects, maxTextureSize ) {

		var _frustum = new Frustum(),
			_projScreenMatrix = new Matrix4(),

			_shadowMapSize = new Vector2(),
			_maxShadowMapSize = new Vector2( maxTextureSize, maxTextureSize ),

			_lookTarget = new Vector3(),
			_lightPositionWorld = new Vector3(),

			_MorphingFlag = 1,
			_SkinningFlag = 2,

			_NumberOfMaterialVariants = ( _MorphingFlag | _SkinningFlag ) + 1,

			_depthMaterials = new Array( _NumberOfMaterialVariants ),
			_distanceMaterials = new Array( _NumberOfMaterialVariants ),

			_materialCache = {};

		var cubeDirections = [
			new Vector3( 1, 0, 0 ), new Vector3( - 1, 0, 0 ), new Vector3( 0, 0, 1 ),
			new Vector3( 0, 0, - 1 ), new Vector3( 0, 1, 0 ), new Vector3( 0, - 1, 0 )
		];

		var cubeUps = [
			new Vector3( 0, 1, 0 ), new Vector3( 0, 1, 0 ), new Vector3( 0, 1, 0 ),
			new Vector3( 0, 1, 0 ), new Vector3( 0, 0, 1 ),	new Vector3( 0, 0, - 1 )
		];

		var cube2DViewPorts = [
			new Vector4(), new Vector4(), new Vector4(),
			new Vector4(), new Vector4(), new Vector4()
		];

		// init

		for ( var i = 0; i !== _NumberOfMaterialVariants; ++ i ) {

			var useMorphing = ( i & _MorphingFlag ) !== 0;
			var useSkinning = ( i & _SkinningFlag ) !== 0;

			var depthMaterial = new MeshDepthMaterial( {

				depthPacking: RGBADepthPacking,

				morphTargets: useMorphing,
				skinning: useSkinning

			} );

			_depthMaterials[ i ] = depthMaterial;

			//

			var distanceMaterial = new MeshDistanceMaterial( {

				morphTargets: useMorphing,
				skinning: useSkinning

			} );

			_distanceMaterials[ i ] = distanceMaterial;

		}

		//

		var scope = this;

		this.enabled = false;

		this.autoUpdate = true;
		this.needsUpdate = false;

		this.type = PCFShadowMap;

		this.renderReverseSided = true;
		this.renderSingleSided = true;

		this.render = function ( lights, scene, camera ) {

			if ( scope.enabled === false ) return;
			if ( scope.autoUpdate === false && scope.needsUpdate === false ) return;

			if ( lights.length === 0 ) return;

			// TODO Clean up (needed in case of contextlost)
			var _gl = _renderer.context;
			var _state = _renderer.state;

			// Set GL state for depth map.
			_state.disable( _gl.BLEND );
			_state.buffers.color.setClear( 1, 1, 1, 1 );
			_state.buffers.depth.setTest( true );
			_state.setScissorTest( false );

			// render depth map

			var faceCount;

			for ( var i = 0, il = lights.length; i < il; i ++ ) {

				var light = lights[ i ];
				var shadow = light.shadow;
				var isPointLight = light && light.isPointLight;

				if ( shadow === undefined ) {

					console.warn( 'THREE.WebGLShadowMap:', light, 'has no shadow.' );
					continue;

				}

				var shadowCamera = shadow.camera;

				_shadowMapSize.copy( shadow.mapSize );
				_shadowMapSize.min( _maxShadowMapSize );

				if ( isPointLight ) {

					var vpWidth = _shadowMapSize.x;
					var vpHeight = _shadowMapSize.y;

					// These viewports map a cube-map onto a 2D texture with the
					// following orientation:
					//
					//  xzXZ
					//   y Y
					//
					// X - Positive x direction
					// x - Negative x direction
					// Y - Positive y direction
					// y - Negative y direction
					// Z - Positive z direction
					// z - Negative z direction

					// positive X
					cube2DViewPorts[ 0 ].set( vpWidth * 2, vpHeight, vpWidth, vpHeight );
					// negative X
					cube2DViewPorts[ 1 ].set( 0, vpHeight, vpWidth, vpHeight );
					// positive Z
					cube2DViewPorts[ 2 ].set( vpWidth * 3, vpHeight, vpWidth, vpHeight );
					// negative Z
					cube2DViewPorts[ 3 ].set( vpWidth, vpHeight, vpWidth, vpHeight );
					// positive Y
					cube2DViewPorts[ 4 ].set( vpWidth * 3, 0, vpWidth, vpHeight );
					// negative Y
					cube2DViewPorts[ 5 ].set( vpWidth, 0, vpWidth, vpHeight );

					_shadowMapSize.x *= 4.0;
					_shadowMapSize.y *= 2.0;

				}

				if ( shadow.map === null ) {

					var pars = { minFilter: NearestFilter, magFilter: NearestFilter, format: RGBAFormat };

					shadow.map = new WebGLRenderTarget( _shadowMapSize.x, _shadowMapSize.y, pars );
					shadow.map.texture.name = light.name + ".shadowMap";

					shadowCamera.updateProjectionMatrix();

				}

				if ( shadow.isSpotLightShadow ) {

					shadow.update( light );

				}

				var shadowMap = shadow.map;
				var shadowMatrix = shadow.matrix;

				_lightPositionWorld.setFromMatrixPosition( light.matrixWorld );
				shadowCamera.position.copy( _lightPositionWorld );

				if ( isPointLight ) {

					faceCount = 6;

					// for point lights we set the shadow matrix to be a translation-only matrix
					// equal to inverse of the light's position

					shadowMatrix.makeTranslation( - _lightPositionWorld.x, - _lightPositionWorld.y, - _lightPositionWorld.z );

				} else {

					faceCount = 1;

					_lookTarget.setFromMatrixPosition( light.target.matrixWorld );
					shadowCamera.lookAt( _lookTarget );
					shadowCamera.updateMatrixWorld();

					// compute shadow matrix

					shadowMatrix.set(
						0.5, 0.0, 0.0, 0.5,
						0.0, 0.5, 0.0, 0.5,
						0.0, 0.0, 0.5, 0.5,
						0.0, 0.0, 0.0, 1.0
					);

					shadowMatrix.multiply( shadowCamera.projectionMatrix );
					shadowMatrix.multiply( shadowCamera.matrixWorldInverse );

				}

				_renderer.setRenderTarget( shadowMap );
				_renderer.clear();

				// render shadow map for each cube face (if omni-directional) or
				// run a single pass if not

				for ( var face = 0; face < faceCount; face ++ ) {

					if ( isPointLight ) {

						_lookTarget.copy( shadowCamera.position );
						_lookTarget.add( cubeDirections[ face ] );
						shadowCamera.up.copy( cubeUps[ face ] );
						shadowCamera.lookAt( _lookTarget );
						shadowCamera.updateMatrixWorld();

						var vpDimensions = cube2DViewPorts[ face ];
						_state.viewport( vpDimensions );

					}

					// update camera matrices and frustum

					_projScreenMatrix.multiplyMatrices( shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse );
					_frustum.setFromMatrix( _projScreenMatrix );

					// set object matrices & frustum culling

					renderObject( scene, camera, shadowCamera, isPointLight );

				}

			}

			scope.needsUpdate = false;

		};

		function getDepthMaterial( object, material, isPointLight, lightPositionWorld, shadowCameraNear, shadowCameraFar ) {

			var geometry = object.geometry;

			var result = null;

			var materialVariants = _depthMaterials;
			var customMaterial = object.customDepthMaterial;

			if ( isPointLight ) {

				materialVariants = _distanceMaterials;
				customMaterial = object.customDistanceMaterial;

			}

			if ( ! customMaterial ) {

				var useMorphing = false;

				if ( material.morphTargets ) {

					if ( geometry && geometry.isBufferGeometry ) {

						useMorphing = geometry.morphAttributes && geometry.morphAttributes.position && geometry.morphAttributes.position.length > 0;

					} else if ( geometry && geometry.isGeometry ) {

						useMorphing = geometry.morphTargets && geometry.morphTargets.length > 0;

					}

				}

				if ( object.isSkinnedMesh && material.skinning === false ) {

					console.warn( 'THREE.WebGLShadowMap: THREE.SkinnedMesh with material.skinning set to false:', object );

				}

				var useSkinning = object.isSkinnedMesh && material.skinning;

				var variantIndex = 0;

				if ( useMorphing ) variantIndex |= _MorphingFlag;
				if ( useSkinning ) variantIndex |= _SkinningFlag;

				result = materialVariants[ variantIndex ];

			} else {

				result = customMaterial;

			}

			if ( _renderer.localClippingEnabled &&
					material.clipShadows === true &&
					material.clippingPlanes.length !== 0 ) {

				// in this case we need a unique material instance reflecting the
				// appropriate state

				var keyA = result.uuid, keyB = material.uuid;

				var materialsForVariant = _materialCache[ keyA ];

				if ( materialsForVariant === undefined ) {

					materialsForVariant = {};
					_materialCache[ keyA ] = materialsForVariant;

				}

				var cachedMaterial = materialsForVariant[ keyB ];

				if ( cachedMaterial === undefined ) {

					cachedMaterial = result.clone();
					materialsForVariant[ keyB ] = cachedMaterial;

				}

				result = cachedMaterial;

			}

			result.visible = material.visible;
			result.wireframe = material.wireframe;

			var side = material.side;

			if ( scope.renderSingleSided && side == DoubleSide ) {

				side = FrontSide;

			}

			if ( scope.renderReverseSided ) {

				if ( side === FrontSide ) side = BackSide;
				else if ( side === BackSide ) side = FrontSide;

			}

			result.side = side;

			result.clipShadows = material.clipShadows;
			result.clippingPlanes = material.clippingPlanes;
			result.clipIntersection = material.clipIntersection;

			result.wireframeLinewidth = material.wireframeLinewidth;
			result.linewidth = material.linewidth;

			if ( isPointLight && result.isMeshDistanceMaterial ) {

				result.referencePosition.copy( lightPositionWorld );
				result.nearDistance = shadowCameraNear;
				result.farDistance = shadowCameraFar;

			}

			return result;

		}

		function renderObject( object, camera, shadowCamera, isPointLight ) {

			if ( object.visible === false ) return;

			var visible = object.layers.test( camera.layers );

			if ( visible && ( object.isMesh || object.isLine || object.isPoints ) ) {

				if ( object.castShadow && ( ! object.frustumCulled || _frustum.intersectsObject( object ) ) ) {

					object.modelViewMatrix.multiplyMatrices( shadowCamera.matrixWorldInverse, object.matrixWorld );

					var geometry = _objects.update( object );
					var material = object.material;

					if ( Array.isArray( material ) ) {

						var groups = geometry.groups;

						for ( var k = 0, kl = groups.length; k < kl; k ++ ) {

							var group = groups[ k ];
							var groupMaterial = material[ group.materialIndex ];

							if ( groupMaterial && groupMaterial.visible ) {

								var depthMaterial = getDepthMaterial( object, groupMaterial, isPointLight, _lightPositionWorld, shadowCamera.near, shadowCamera.far );
								_renderer.renderBufferDirect( shadowCamera, null, geometry, depthMaterial, object, group );

							}

						}

					} else if ( material.visible ) {

						var depthMaterial = getDepthMaterial( object, material, isPointLight, _lightPositionWorld, shadowCamera.near, shadowCamera.far );
						_renderer.renderBufferDirect( shadowCamera, null, geometry, depthMaterial, object, null );

					}

				}

			}

			var children = object.children;

			for ( var i = 0, l = children.length; i < l; i ++ ) {

				renderObject( children[ i ], camera, shadowCamera, isPointLight );

			}

		}

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLAttributes( gl ) {

		var buffers = {};

		function createBuffer( attribute, bufferType ) {

			var array = attribute.array;
			var usage = attribute.dynamic ? gl.DYNAMIC_DRAW : gl.STATIC_DRAW;

			var buffer = gl.createBuffer();

			gl.bindBuffer( bufferType, buffer );
			gl.bufferData( bufferType, array, usage );

			attribute.onUploadCallback();

			var type = gl.FLOAT;

			if ( array instanceof Float32Array ) {

				type = gl.FLOAT;

			} else if ( array instanceof Float64Array ) {

				console.warn( 'THREE.WebGLAttributes: Unsupported data buffer format: Float64Array.' );

			} else if ( array instanceof Uint16Array ) {

				type = gl.UNSIGNED_SHORT;

			} else if ( array instanceof Int16Array ) {

				type = gl.SHORT;

			} else if ( array instanceof Uint32Array ) {

				type = gl.UNSIGNED_INT;

			} else if ( array instanceof Int32Array ) {

				type = gl.INT;

			} else if ( array instanceof Int8Array ) {

				type = gl.BYTE;

			} else if ( array instanceof Uint8Array ) {

				type = gl.UNSIGNED_BYTE;

			}

			return {
				buffer: buffer,
				type: type,
				bytesPerElement: array.BYTES_PER_ELEMENT,
				version: attribute.version
			};

		}

		function updateBuffer( buffer, attribute, bufferType ) {

			var array = attribute.array;
			var updateRange = attribute.updateRange;

			gl.bindBuffer( bufferType, buffer );

			if ( attribute.dynamic === false ) {

				gl.bufferData( bufferType, array, gl.STATIC_DRAW );

			} else if ( updateRange.count === - 1 ) {

				// Not using update ranges

				gl.bufferSubData( bufferType, 0, array );

			} else if ( updateRange.count === 0 ) {

				console.error( 'THREE.WebGLObjects.updateBuffer: dynamic THREE.BufferAttribute marked as needsUpdate but updateRange.count is 0, ensure you are using set methods or updating manually.' );

			} else {

				gl.bufferSubData( bufferType, updateRange.offset * array.BYTES_PER_ELEMENT,
					array.subarray( updateRange.offset, updateRange.offset + updateRange.count ) );

				updateRange.count = -1; // reset range

			}

		}

		//

		function get( attribute ) {

			if ( attribute.isInterleavedBufferAttribute ) attribute = attribute.data;

			return buffers[ attribute.uuid ];

		}

		function remove( attribute ) {

			if ( attribute.isInterleavedBufferAttribute ) attribute = attribute.data;
			
			var data = buffers[ attribute.uuid ];

			if ( data ) {

				gl.deleteBuffer( data.buffer );

				delete buffers[ attribute.uuid ];

			}

		}

		function update( attribute, bufferType ) {

			if ( attribute.isInterleavedBufferAttribute ) attribute = attribute.data;

			var data = buffers[ attribute.uuid ];

			if ( data === undefined ) {

				buffers[ attribute.uuid ] = createBuffer( attribute, bufferType );

			} else if ( data.version < attribute.version ) {

				updateBuffer( data.buffer, attribute, bufferType );

				data.version = attribute.version;

			}

		}

		return {

			get: get,
			remove: remove,
			update: update

		};

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author WestLangley / http://github.com/WestLangley
	 * @author bhouston / http://clara.io
	 */

	function Euler( x, y, z, order ) {

		this._x = x || 0;
		this._y = y || 0;
		this._z = z || 0;
		this._order = order || Euler.DefaultOrder;

	}

	Euler.RotationOrders = [ 'XYZ', 'YZX', 'ZXY', 'XZY', 'YXZ', 'ZYX' ];

	Euler.DefaultOrder = 'XYZ';

	Object.defineProperties( Euler.prototype, {

		x: {

			get: function () {

				return this._x;

			},

			set: function ( value ) {

				this._x = value;
				this.onChangeCallback();

			}

		},

		y: {

			get: function () {

				return this._y;

			},

			set: function ( value ) {

				this._y = value;
				this.onChangeCallback();

			}

		},

		z: {

			get: function () {

				return this._z;

			},

			set: function ( value ) {

				this._z = value;
				this.onChangeCallback();

			}

		},

		order: {

			get: function () {

				return this._order;

			},

			set: function ( value ) {

				this._order = value;
				this.onChangeCallback();

			}

		}

	} );

	Object.assign( Euler.prototype, {

		isEuler: true,

		set: function ( x, y, z, order ) {

			this._x = x;
			this._y = y;
			this._z = z;
			this._order = order || this._order;

			this.onChangeCallback();

			return this;

		},

		clone: function () {

			return new this.constructor( this._x, this._y, this._z, this._order );

		},

		copy: function ( euler ) {

			this._x = euler._x;
			this._y = euler._y;
			this._z = euler._z;
			this._order = euler._order;

			this.onChangeCallback();

			return this;

		},

		setFromRotationMatrix: function ( m, order, update ) {

			var clamp = _Math.clamp;

			// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

			var te = m.elements;
			var m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ];
			var m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ];
			var m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ];

			order = order || this._order;

			if ( order === 'XYZ' ) {

				this._y = Math.asin( clamp( m13, - 1, 1 ) );

				if ( Math.abs( m13 ) < 0.99999 ) {

					this._x = Math.atan2( - m23, m33 );
					this._z = Math.atan2( - m12, m11 );

				} else {

					this._x = Math.atan2( m32, m22 );
					this._z = 0;

				}

			} else if ( order === 'YXZ' ) {

				this._x = Math.asin( - clamp( m23, - 1, 1 ) );

				if ( Math.abs( m23 ) < 0.99999 ) {

					this._y = Math.atan2( m13, m33 );
					this._z = Math.atan2( m21, m22 );

				} else {

					this._y = Math.atan2( - m31, m11 );
					this._z = 0;

				}

			} else if ( order === 'ZXY' ) {

				this._x = Math.asin( clamp( m32, - 1, 1 ) );

				if ( Math.abs( m32 ) < 0.99999 ) {

					this._y = Math.atan2( - m31, m33 );
					this._z = Math.atan2( - m12, m22 );

				} else {

					this._y = 0;
					this._z = Math.atan2( m21, m11 );

				}

			} else if ( order === 'ZYX' ) {

				this._y = Math.asin( - clamp( m31, - 1, 1 ) );

				if ( Math.abs( m31 ) < 0.99999 ) {

					this._x = Math.atan2( m32, m33 );
					this._z = Math.atan2( m21, m11 );

				} else {

					this._x = 0;
					this._z = Math.atan2( - m12, m22 );

				}

			} else if ( order === 'YZX' ) {

				this._z = Math.asin( clamp( m21, - 1, 1 ) );

				if ( Math.abs( m21 ) < 0.99999 ) {

					this._x = Math.atan2( - m23, m22 );
					this._y = Math.atan2( - m31, m11 );

				} else {

					this._x = 0;
					this._y = Math.atan2( m13, m33 );

				}

			} else if ( order === 'XZY' ) {

				this._z = Math.asin( - clamp( m12, - 1, 1 ) );

				if ( Math.abs( m12 ) < 0.99999 ) {

					this._x = Math.atan2( m32, m22 );
					this._y = Math.atan2( m13, m11 );

				} else {

					this._x = Math.atan2( - m23, m33 );
					this._y = 0;

				}

			} else {

				console.warn( 'THREE.Euler: .setFromRotationMatrix() given unsupported order: ' + order );

			}

			this._order = order;

			if ( update !== false ) this.onChangeCallback();

			return this;

		},

		setFromQuaternion: function () {

			var matrix = new Matrix4();

			return function setFromQuaternion( q, order, update ) {

				matrix.makeRotationFromQuaternion( q );

				return this.setFromRotationMatrix( matrix, order, update );

			};

		}(),

		setFromVector3: function ( v, order ) {

			return this.set( v.x, v.y, v.z, order || this._order );

		},

		reorder: function () {

			// WARNING: this discards revolution information -bhouston

			var q = new Quaternion();

			return function reorder( newOrder ) {

				q.setFromEuler( this );

				return this.setFromQuaternion( q, newOrder );

			};

		}(),

		equals: function ( euler ) {

			return ( euler._x === this._x ) && ( euler._y === this._y ) && ( euler._z === this._z ) && ( euler._order === this._order );

		},

		fromArray: function ( array ) {

			this._x = array[ 0 ];
			this._y = array[ 1 ];
			this._z = array[ 2 ];
			if ( array[ 3 ] !== undefined ) this._order = array[ 3 ];

			this.onChangeCallback();

			return this;

		},

		toArray: function ( array, offset ) {

			if ( array === undefined ) array = [];
			if ( offset === undefined ) offset = 0;

			array[ offset ] = this._x;
			array[ offset + 1 ] = this._y;
			array[ offset + 2 ] = this._z;
			array[ offset + 3 ] = this._order;

			return array;

		},

		toVector3: function ( optionalResult ) {

			if ( optionalResult ) {

				return optionalResult.set( this._x, this._y, this._z );

			} else {

				return new Vector3( this._x, this._y, this._z );

			}

		},

		onChange: function ( callback ) {

			this.onChangeCallback = callback;

			return this;

		},

		onChangeCallback: function () {}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function Layers() {

		this.mask = 1 | 0;

	}

	Object.assign( Layers.prototype, {

		set: function ( channel ) {

			this.mask = 1 << channel | 0;

		},

		enable: function ( channel ) {

			this.mask |= 1 << channel | 0;

		},

		toggle: function ( channel ) {

			this.mask ^= 1 << channel | 0;

		},

		disable: function ( channel ) {

			this.mask &= ~ ( 1 << channel | 0 );

		},

		test: function ( layers ) {

			return ( this.mask & layers.mask ) !== 0;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author mikael emtinger / http://gomo.se/
	 * @author alteredq / http://alteredqualia.com/
	 * @author WestLangley / http://github.com/WestLangley
	 * @author elephantatwork / www.elephantatwork.ch
	 */

	var object3DId = 0;

	function Object3D() {

		Object.defineProperty( this, 'id', { value: object3DId ++ } );

		this.uuid = _Math.generateUUID();

		this.name = '';
		this.type = 'Object3D';

		this.parent = null;
		this.children = [];

		this.up = Object3D.DefaultUp.clone();

		var position = new Vector3();
		var rotation = new Euler();
		var quaternion = new Quaternion();
		var scale = new Vector3( 1, 1, 1 );

		function onRotationChange() {

			quaternion.setFromEuler( rotation, false );

		}

		function onQuaternionChange() {

			rotation.setFromQuaternion( quaternion, undefined, false );

		}

		rotation.onChange( onRotationChange );
		quaternion.onChange( onQuaternionChange );

		Object.defineProperties( this, {
			position: {
				enumerable: true,
				value: position
			},
			rotation: {
				enumerable: true,
				value: rotation
			},
			quaternion: {
				enumerable: true,
				value: quaternion
			},
			scale: {
				enumerable: true,
				value: scale
			},
			modelViewMatrix: {
				value: new Matrix4()
			},
			normalMatrix: {
				value: new Matrix3()
			}
		} );

		this.matrix = new Matrix4();
		this.matrixWorld = new Matrix4();

		this.matrixAutoUpdate = Object3D.DefaultMatrixAutoUpdate;
		this.matrixWorldNeedsUpdate = false;

		this.layers = new Layers();
		this.visible = true;

		this.castShadow = false;
		this.receiveShadow = false;

		this.frustumCulled = true;
		this.renderOrder = 0;

		this.userData = {};
	}

	Object3D.DefaultUp = new Vector3( 0, 1, 0 );
	Object3D.DefaultMatrixAutoUpdate = true;

	Object.assign( Object3D.prototype, EventDispatcher.prototype, {

		isObject3D: true,

		onBeforeRender: function () {},
		onAfterRender: function () {},

		applyMatrix: function ( matrix ) {

			this.matrix.multiplyMatrices( matrix, this.matrix );

			this.matrix.decompose( this.position, this.quaternion, this.scale );

		},

		applyQuaternion: function ( q ) {

			this.quaternion.premultiply( q );

			return this;

		},

		setRotationFromAxisAngle: function ( axis, angle ) {

			// assumes axis is normalized

			this.quaternion.setFromAxisAngle( axis, angle );

		},

		setRotationFromEuler: function ( euler ) {

			this.quaternion.setFromEuler( euler, true );

		},

		setRotationFromMatrix: function ( m ) {

			// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

			this.quaternion.setFromRotationMatrix( m );

		},

		setRotationFromQuaternion: function ( q ) {

			// assumes q is normalized

			this.quaternion.copy( q );

		},

		rotateOnAxis: function () {

			// rotate object on axis in object space
			// axis is assumed to be normalized

			var q1 = new Quaternion();

			return function rotateOnAxis( axis, angle ) {

				q1.setFromAxisAngle( axis, angle );

				this.quaternion.multiply( q1 );

				return this;

			};

		}(),

		rotateX: function () {

			var v1 = new Vector3( 1, 0, 0 );

			return function rotateX( angle ) {

				return this.rotateOnAxis( v1, angle );

			};

		}(),

		rotateY: function () {

			var v1 = new Vector3( 0, 1, 0 );

			return function rotateY( angle ) {

				return this.rotateOnAxis( v1, angle );

			};

		}(),

		rotateZ: function () {

			var v1 = new Vector3( 0, 0, 1 );

			return function rotateZ( angle ) {

				return this.rotateOnAxis( v1, angle );

			};

		}(),

		translateOnAxis: function () {

			// translate object by distance along axis in object space
			// axis is assumed to be normalized

			var v1 = new Vector3();

			return function translateOnAxis( axis, distance ) {

				v1.copy( axis ).applyQuaternion( this.quaternion );

				this.position.add( v1.multiplyScalar( distance ) );

				return this;

			};

		}(),

		translateX: function () {

			var v1 = new Vector3( 1, 0, 0 );

			return function translateX( distance ) {

				return this.translateOnAxis( v1, distance );

			};

		}(),

		translateY: function () {

			var v1 = new Vector3( 0, 1, 0 );

			return function translateY( distance ) {

				return this.translateOnAxis( v1, distance );

			};

		}(),

		translateZ: function () {

			var v1 = new Vector3( 0, 0, 1 );

			return function translateZ( distance ) {

				return this.translateOnAxis( v1, distance );

			};

		}(),

		localToWorld: function ( vector ) {

			return vector.applyMatrix4( this.matrixWorld );

		},

		worldToLocal: function () {

			var m1 = new Matrix4();

			return function worldToLocal( vector ) {

				return vector.applyMatrix4( m1.getInverse( this.matrixWorld ) );

			};

		}(),

		lookAt: function () {

			// This method does not support objects with rotated and/or translated parent(s)

			var m1 = new Matrix4();

			return function lookAt( vector ) {

				if ( this.isCamera ) {

					m1.lookAt( this.position, vector, this.up );

				} else {

					m1.lookAt( vector, this.position, this.up );

				}

				this.quaternion.setFromRotationMatrix( m1 );

			};

		}(),

		add: function ( object ) {

			if ( arguments.length > 1 ) {

				for ( var i = 0; i < arguments.length; i ++ ) {

					this.add( arguments[ i ] );

				}

				return this;

			}

			if ( object === this ) {

				console.error( "THREE.Object3D.add: object can't be added as a child of itself.", object );
				return this;

			}

			if ( ( object && object.isObject3D ) ) {

				if ( object.parent !== null ) {

					object.parent.remove( object );

				}

				object.parent = this;
				object.dispatchEvent( { type: 'added' } );

				this.children.push( object );

			} else {

				console.error( "THREE.Object3D.add: object not an instance of THREE.Object3D.", object );

			}

			return this;

		},

		remove: function ( object ) {

			if ( arguments.length > 1 ) {

				for ( var i = 0; i < arguments.length; i ++ ) {

					this.remove( arguments[ i ] );

				}

				return this;

			}

			var index = this.children.indexOf( object );

			if ( index !== - 1 ) {

				object.parent = null;

				object.dispatchEvent( { type: 'removed' } );

				this.children.splice( index, 1 );

			}

			return this;

		},

		getObjectById: function ( id ) {

			return this.getObjectByProperty( 'id', id );

		},

		getObjectByName: function ( name ) {

			return this.getObjectByProperty( 'name', name );

		},

		getObjectByProperty: function ( name, value ) {

			if ( this[ name ] === value ) return this;

			for ( var i = 0, l = this.children.length; i < l; i ++ ) {

				var child = this.children[ i ];
				var object = child.getObjectByProperty( name, value );

				if ( object !== undefined ) {

					return object;

				}

			}

			return undefined;

		},

		getWorldPosition: function ( optionalTarget ) {

			var result = optionalTarget || new Vector3();

			this.updateMatrixWorld( true );

			return result.setFromMatrixPosition( this.matrixWorld );

		},

		getWorldQuaternion: function () {

			var position = new Vector3();
			var scale = new Vector3();

			return function getWorldQuaternion( optionalTarget ) {

				var result = optionalTarget || new Quaternion();

				this.updateMatrixWorld( true );

				this.matrixWorld.decompose( position, result, scale );

				return result;

			};

		}(),

		getWorldRotation: function () {

			var quaternion = new Quaternion();

			return function getWorldRotation( optionalTarget ) {

				var result = optionalTarget || new Euler();

				this.getWorldQuaternion( quaternion );

				return result.setFromQuaternion( quaternion, this.rotation.order, false );

			};

		}(),

		getWorldScale: function () {

			var position = new Vector3();
			var quaternion = new Quaternion();

			return function getWorldScale( optionalTarget ) {

				var result = optionalTarget || new Vector3();

				this.updateMatrixWorld( true );

				this.matrixWorld.decompose( position, quaternion, result );

				return result;

			};

		}(),

		getWorldDirection: function () {

			var quaternion = new Quaternion();

			return function getWorldDirection( optionalTarget ) {

				var result = optionalTarget || new Vector3();

				this.getWorldQuaternion( quaternion );

				return result.set( 0, 0, 1 ).applyQuaternion( quaternion );

			};

		}(),

		raycast: function () {},

		traverse: function ( callback ) {

			callback( this );

			var children = this.children;

			for ( var i = 0, l = children.length; i < l; i ++ ) {

				children[ i ].traverse( callback );

			}

		},

		traverseVisible: function ( callback ) {

			if ( this.visible === false ) return;

			callback( this );

			var children = this.children;

			for ( var i = 0, l = children.length; i < l; i ++ ) {

				children[ i ].traverseVisible( callback );

			}

		},

		traverseAncestors: function ( callback ) {

			var parent = this.parent;

			if ( parent !== null ) {

				callback( parent );

				parent.traverseAncestors( callback );

			}

		},

		updateMatrix: function () {

			this.matrix.compose( this.position, this.quaternion, this.scale );

			this.matrixWorldNeedsUpdate = true;

		},

		updateMatrixWorld: function ( force ) {

			if ( this.matrixAutoUpdate ) this.updateMatrix();

			if ( this.matrixWorldNeedsUpdate || force ) {

				if ( this.parent === null ) {

					this.matrixWorld.copy( this.matrix );

				} else {

					this.matrixWorld.multiplyMatrices( this.parent.matrixWorld, this.matrix );

				}

				this.matrixWorldNeedsUpdate = false;

				force = true;

			}

			// update children

			var children = this.children;

			for ( var i = 0, l = children.length; i < l; i ++ ) {

				children[ i ].updateMatrixWorld( force );

			}

		},

		toJSON: function ( meta ) {

			// meta is '' when called from JSON.stringify
			var isRootObject = ( meta === undefined || meta === '' );

			var output = {};

			// meta is a hash used to collect geometries, materials.
			// not providing it implies that this is the root object
			// being serialized.
			if ( isRootObject ) {

				// initialize meta obj
				meta = {
					geometries: {},
					materials: {},
					textures: {},
					images: {}
				};

				output.metadata = {
					version: 4.5,
					type: 'Object',
					generator: 'Object3D.toJSON'
				};

			}

			// standard Object3D serialization

			var object = {};

			object.uuid = this.uuid;
			object.type = this.type;

			if ( this.name !== '' ) object.name = this.name;
			if ( this.castShadow === true ) object.castShadow = true;
			if ( this.receiveShadow === true ) object.receiveShadow = true;
			if ( this.visible === false ) object.visible = false;
			if ( JSON.stringify( this.userData ) !== '{}' ) object.userData = this.userData;

			object.matrix = this.matrix.toArray();

			//

			function serialize( library, element ) {

				if ( library[ element.uuid ] === undefined ) {

					library[ element.uuid ] = element.toJSON( meta );

				}

				return element.uuid;

			}

			if ( this.geometry !== undefined ) {

				object.geometry = serialize( meta.geometries, this.geometry );

			}

			if ( this.material !== undefined ) {

				if ( Array.isArray( this.material ) ) {

					var uuids = [];

					for ( var i = 0, l = this.material.length; i < l; i ++ ) {

						uuids.push( serialize( meta.materials, this.material[ i ] ) );

					}

					object.material = uuids;

				} else {

					object.material = serialize( meta.materials, this.material );

				}

			}

			//

			if ( this.children.length > 0 ) {

				object.children = [];

				for ( var i = 0; i < this.children.length; i ++ ) {

					object.children.push( this.children[ i ].toJSON( meta ).object );

				}

			}

			if ( isRootObject ) {

				var geometries = extractFromCache( meta.geometries );
				var materials = extractFromCache( meta.materials );
				var textures = extractFromCache( meta.textures );
				var images = extractFromCache( meta.images );

				if ( geometries.length > 0 ) output.geometries = geometries;
				if ( materials.length > 0 ) output.materials = materials;
				if ( textures.length > 0 ) output.textures = textures;
				if ( images.length > 0 ) output.images = images;

			}

			output.object = object;

			return output;

			// extract data from the cache hash
			// remove metadata on each item
			// and return as array
			function extractFromCache( cache ) {

				var values = [];
				for ( var key in cache ) {

					var data = cache[ key ];
					delete data.metadata;
					values.push( data );

				}
				return values;

			}

		},

		clone: function ( recursive ) {

			return new this.constructor().copy( this, recursive );

		},

		copy: function ( source, recursive ) {

			if ( recursive === undefined ) recursive = true;

			this.name = source.name;

			this.up.copy( source.up );

			this.position.copy( source.position );
			this.quaternion.copy( source.quaternion );
			this.scale.copy( source.scale );

			this.matrix.copy( source.matrix );
			this.matrixWorld.copy( source.matrixWorld );

			this.matrixAutoUpdate = source.matrixAutoUpdate;
			this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;

			this.layers.mask = source.layers.mask;
			this.visible = source.visible;

			this.castShadow = source.castShadow;
			this.receiveShadow = source.receiveShadow;

			this.frustumCulled = source.frustumCulled;
			this.renderOrder = source.renderOrder;

			this.userData = JSON.parse( JSON.stringify( source.userData ) );

			if ( recursive === true ) {

				for ( var i = 0; i < source.children.length; i ++ ) {

					var child = source.children[ i ];
					this.add( child.clone() );

				}

			}

			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author mikael emtinger / http://gomo.se/
	 * @author WestLangley / http://github.com/WestLangley
	*/

	function Camera() {

		Object3D.call( this );

		this.type = 'Camera';

		this.matrixWorldInverse = new Matrix4();
		this.projectionMatrix = new Matrix4();

	}

	Camera.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: Camera,

		isCamera: true,

		copy: function ( source, recursive ) {

			Object3D.prototype.copy.call( this, source, recursive );

			this.matrixWorldInverse.copy( source.matrixWorldInverse );
			this.projectionMatrix.copy( source.projectionMatrix );

			return this;

		},

		getWorldDirection: function () {

			var quaternion = new Quaternion();

			return function getWorldDirection( optionalTarget ) {

				var result = optionalTarget || new Vector3();

				this.getWorldQuaternion( quaternion );

				return result.set( 0, 0, - 1 ).applyQuaternion( quaternion );

			};

		}(),

		updateMatrixWorld: function ( force ) {

			Object3D.prototype.updateMatrixWorld.call( this, force );

			this.matrixWorldInverse.getInverse( this.matrixWorld );

		},

		clone: function () {

			return new this.constructor().copy( this );

		}

	} );

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author arose / http://github.com/arose
	 */

	function OrthographicCamera( left, right, top, bottom, near, far ) {

		Camera.call( this );

		this.type = 'OrthographicCamera';

		this.zoom = 1;
		this.view = null;

		this.left = left;
		this.right = right;
		this.top = top;
		this.bottom = bottom;

		this.near = ( near !== undefined ) ? near : 0.1;
		this.far = ( far !== undefined ) ? far : 2000;

		this.updateProjectionMatrix();

	}

	OrthographicCamera.prototype = Object.assign( Object.create( Camera.prototype ), {

		constructor: OrthographicCamera,

		isOrthographicCamera: true,

		copy: function ( source, recursive ) {

			Camera.prototype.copy.call( this, source, recursive );

			this.left = source.left;
			this.right = source.right;
			this.top = source.top;
			this.bottom = source.bottom;
			this.near = source.near;
			this.far = source.far;

			this.zoom = source.zoom;
			this.view = source.view === null ? null : Object.assign( {}, source.view );

			return this;

		},

		setViewOffset: function( fullWidth, fullHeight, x, y, width, height ) {

			this.view = {
				fullWidth: fullWidth,
				fullHeight: fullHeight,
				offsetX: x,
				offsetY: y,
				width: width,
				height: height
			};

			this.updateProjectionMatrix();

		},

		clearViewOffset: function() {

			this.view = null;
			this.updateProjectionMatrix();

		},

		updateProjectionMatrix: function () {

			var dx = ( this.right - this.left ) / ( 2 * this.zoom );
			var dy = ( this.top - this.bottom ) / ( 2 * this.zoom );
			var cx = ( this.right + this.left ) / 2;
			var cy = ( this.top + this.bottom ) / 2;

			var left = cx - dx;
			var right = cx + dx;
			var top = cy + dy;
			var bottom = cy - dy;

			if ( this.view !== null ) {

				var zoomW = this.zoom / ( this.view.width / this.view.fullWidth );
				var zoomH = this.zoom / ( this.view.height / this.view.fullHeight );
				var scaleW = ( this.right - this.left ) / this.view.width;
				var scaleH = ( this.top - this.bottom ) / this.view.height;

				left += scaleW * ( this.view.offsetX / zoomW );
				right = left + scaleW * ( this.view.width / zoomW );
				top -= scaleH * ( this.view.offsetY / zoomH );
				bottom = top - scaleH * ( this.view.height / zoomH );

			}

			this.projectionMatrix.makeOrthographic( left, right, top, bottom, this.near, this.far );

		},

		toJSON: function ( meta ) {

			var data = Object3D.prototype.toJSON.call( this, meta );

			data.object.zoom = this.zoom;
			data.object.left = this.left;
			data.object.right = this.right;
			data.object.top = this.top;
			data.object.bottom = this.bottom;
			data.object.near = this.near;
			data.object.far = this.far;

			if ( this.view !== null ) data.object.view = Object.assign( {}, this.view );

			return data;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author greggman / http://games.greggman.com/
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 * @author tschw
	 */

	function PerspectiveCamera( fov, aspect, near, far ) {

		Camera.call( this );

		this.type = 'PerspectiveCamera';

		this.fov = fov !== undefined ? fov : 50;
		this.zoom = 1;

		this.near = near !== undefined ? near : 0.1;
		this.far = far !== undefined ? far : 2000;
		this.focus = 10;

		this.aspect = aspect !== undefined ? aspect : 1;
		this.view = null;

		this.filmGauge = 35;	// width of the film (default in millimeters)
		this.filmOffset = 0;	// horizontal film offset (same unit as gauge)

		this.updateProjectionMatrix();

	}

	PerspectiveCamera.prototype = Object.assign( Object.create( Camera.prototype ), {

		constructor: PerspectiveCamera,

		isPerspectiveCamera: true,

		copy: function ( source, recursive ) {

			Camera.prototype.copy.call( this, source, recursive );

			this.fov = source.fov;
			this.zoom = source.zoom;

			this.near = source.near;
			this.far = source.far;
			this.focus = source.focus;

			this.aspect = source.aspect;
			this.view = source.view === null ? null : Object.assign( {}, source.view );

			this.filmGauge = source.filmGauge;
			this.filmOffset = source.filmOffset;

			return this;

		},

		/**
		 * Sets the FOV by focal length in respect to the current .filmGauge.
		 *
		 * The default film gauge is 35, so that the focal length can be specified for
		 * a 35mm (full frame) camera.
		 *
		 * Values for focal length and film gauge must have the same unit.
		 */
		setFocalLength: function ( focalLength ) {

			// see http://www.bobatkins.com/photography/technical/field_of_view.html
			var vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;

			this.fov = _Math.RAD2DEG * 2 * Math.atan( vExtentSlope );
			this.updateProjectionMatrix();

		},

		/**
		 * Calculates the focal length from the current .fov and .filmGauge.
		 */
		getFocalLength: function () {

			var vExtentSlope = Math.tan( _Math.DEG2RAD * 0.5 * this.fov );

			return 0.5 * this.getFilmHeight() / vExtentSlope;

		},

		getEffectiveFOV: function () {

			return _Math.RAD2DEG * 2 * Math.atan(
					Math.tan( _Math.DEG2RAD * 0.5 * this.fov ) / this.zoom );

		},

		getFilmWidth: function () {

			// film not completely covered in portrait format (aspect < 1)
			return this.filmGauge * Math.min( this.aspect, 1 );

		},

		getFilmHeight: function () {

			// film not completely covered in landscape format (aspect > 1)
			return this.filmGauge / Math.max( this.aspect, 1 );

		},

		/**
		 * Sets an offset in a larger frustum. This is useful for multi-window or
		 * multi-monitor/multi-machine setups.
		 *
		 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
		 * the monitors are in grid like this
		 *
		 *   +---+---+---+
		 *   | A | B | C |
		 *   +---+---+---+
		 *   | D | E | F |
		 *   +---+---+---+
		 *
		 * then for each monitor you would call it like this
		 *
		 *   var w = 1920;
		 *   var h = 1080;
		 *   var fullWidth = w * 3;
		 *   var fullHeight = h * 2;
		 *
		 *   --A--
		 *   camera.setOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
		 *   --B--
		 *   camera.setOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
		 *   --C--
		 *   camera.setOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
		 *   --D--
		 *   camera.setOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
		 *   --E--
		 *   camera.setOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
		 *   --F--
		 *   camera.setOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
		 *
		 *   Note there is no reason monitors have to be the same size or in a grid.
		 */
		setViewOffset: function ( fullWidth, fullHeight, x, y, width, height ) {

			this.aspect = fullWidth / fullHeight;

			this.view = {
				fullWidth: fullWidth,
				fullHeight: fullHeight,
				offsetX: x,
				offsetY: y,
				width: width,
				height: height
			};

			this.updateProjectionMatrix();

		},

		clearViewOffset: function () {

			this.view = null;
			this.updateProjectionMatrix();

		},

		updateProjectionMatrix: function () {

			var near = this.near,
				top = near * Math.tan(
						_Math.DEG2RAD * 0.5 * this.fov ) / this.zoom,
				height = 2 * top,
				width = this.aspect * height,
				left = - 0.5 * width,
				view = this.view;

			if ( view !== null ) {

				var fullWidth = view.fullWidth,
					fullHeight = view.fullHeight;

				left += view.offsetX * width / fullWidth;
				top -= view.offsetY * height / fullHeight;
				width *= view.width / fullWidth;
				height *= view.height / fullHeight;

			}

			var skew = this.filmOffset;
			if ( skew !== 0 ) left += near * skew / this.getFilmWidth();

			this.projectionMatrix.makePerspective( left, left + width, top, top - height, near, this.far );

		},

		toJSON: function ( meta ) {

			var data = Object3D.prototype.toJSON.call( this, meta );

			data.object.fov = this.fov;
			data.object.zoom = this.zoom;

			data.object.near = this.near;
			data.object.far = this.far;
			data.object.focus = this.focus;

			data.object.aspect = this.aspect;

			if ( this.view !== null ) data.object.view = Object.assign( {}, this.view );

			data.object.filmGauge = this.filmGauge;
			data.object.filmOffset = this.filmOffset;

			return data;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 */

	function Face3( a, b, c, normal, color, materialIndex ) {

		this.a = a;
		this.b = b;
		this.c = c;

		this.normal = ( normal && normal.isVector3 ) ? normal : new Vector3();
		this.vertexNormals = Array.isArray( normal ) ? normal : [];

		this.color = ( color && color.isColor ) ? color : new Color();
		this.vertexColors = Array.isArray( color ) ? color : [];

		this.materialIndex = materialIndex !== undefined ? materialIndex : 0;

	}

	Object.assign( Face3.prototype, {

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( source ) {

			this.a = source.a;
			this.b = source.b;
			this.c = source.c;

			this.normal.copy( source.normal );
			this.color.copy( source.color );

			this.materialIndex = source.materialIndex;

			for ( var i = 0, il = source.vertexNormals.length; i < il; i ++ ) {

				this.vertexNormals[ i ] = source.vertexNormals[ i ].clone();

			}

			for ( var i = 0, il = source.vertexColors.length; i < il; i ++ ) {

				this.vertexColors[ i ] = source.vertexColors[ i ].clone();

			}

			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author kile / http://kile.stravaganza.org/
	 * @author alteredq / http://alteredqualia.com/
	 * @author mikael emtinger / http://gomo.se/
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 * @author bhouston / http://clara.io
	 */

	var count = 0;
	function GeometryIdCount() { return count++; }

	function Geometry() {

		Object.defineProperty( this, 'id', { value: GeometryIdCount() } );

		this.uuid = _Math.generateUUID();

		this.name = '';
		this.type = 'Geometry';

		this.vertices = [];
		this.colors = [];
		this.faces = [];
		this.faceVertexUvs = [[]];

		this.morphTargets = [];
		this.morphNormals = [];

		this.skinWeights = [];
		this.skinIndices = [];

		this.lineDistances = [];

		this.boundingBox = null;
		this.boundingSphere = null;

		// update flags

		this.elementsNeedUpdate = false;
		this.verticesNeedUpdate = false;
		this.uvsNeedUpdate = false;
		this.normalsNeedUpdate = false;
		this.colorsNeedUpdate = false;
		this.lineDistancesNeedUpdate = false;
		this.groupsNeedUpdate = false;

	}

	Object.assign( Geometry.prototype, EventDispatcher.prototype, {

		isGeometry: true,

		applyMatrix: function ( matrix ) {

			var normalMatrix = new Matrix3().getNormalMatrix( matrix );

			for ( var i = 0, il = this.vertices.length; i < il; i ++ ) {

				var vertex = this.vertices[ i ];
				vertex.applyMatrix4( matrix );

			}

			for ( var i = 0, il = this.faces.length; i < il; i ++ ) {

				var face = this.faces[ i ];
				face.normal.applyMatrix3( normalMatrix ).normalize();

				for ( var j = 0, jl = face.vertexNormals.length; j < jl; j ++ ) {

					face.vertexNormals[ j ].applyMatrix3( normalMatrix ).normalize();

				}

			}

			if ( this.boundingBox !== null ) {

				this.computeBoundingBox();

			}

			if ( this.boundingSphere !== null ) {

				this.computeBoundingSphere();

			}

			this.verticesNeedUpdate = true;
			this.normalsNeedUpdate = true;

			return this;

		},

		rotateX: function () {

			// rotate geometry around world x-axis

			var m1 = new Matrix4();

			return function rotateX( angle ) {

				m1.makeRotationX( angle );

				this.applyMatrix( m1 );

				return this;

			};

		}(),

		rotateY: function () {

			// rotate geometry around world y-axis

			var m1 = new Matrix4();

			return function rotateY( angle ) {

				m1.makeRotationY( angle );

				this.applyMatrix( m1 );

				return this;

			};

		}(),

		rotateZ: function () {

			// rotate geometry around world z-axis

			var m1 = new Matrix4();

			return function rotateZ( angle ) {

				m1.makeRotationZ( angle );

				this.applyMatrix( m1 );

				return this;

			};

		}(),

		translate: function () {

			// translate geometry

			var m1 = new Matrix4();

			return function translate( x, y, z ) {

				m1.makeTranslation( x, y, z );

				this.applyMatrix( m1 );

				return this;

			};

		}(),

		scale: function () {

			// scale geometry

			var m1 = new Matrix4();

			return function scale( x, y, z ) {

				m1.makeScale( x, y, z );

				this.applyMatrix( m1 );

				return this;

			};

		}(),

		lookAt: function () {

			var obj = new Object3D();

			return function lookAt( vector ) {

				obj.lookAt( vector );

				obj.updateMatrix();

				this.applyMatrix( obj.matrix );

			};

		}(),

		fromBufferGeometry: function ( geometry ) {

			var scope = this;

			var indices = geometry.index !== null ? geometry.index.array : undefined;
			var attributes = geometry.attributes;

			var positions = attributes.position.array;
			var normals = attributes.normal !== undefined ? attributes.normal.array : undefined;
			var colors = attributes.color !== undefined ? attributes.color.array : undefined;
			var uvs = attributes.uv !== undefined ? attributes.uv.array : undefined;
			var uvs2 = attributes.uv2 !== undefined ? attributes.uv2.array : undefined;

			if ( uvs2 !== undefined ) this.faceVertexUvs[ 1 ] = [];

			var tempNormals = [];
			var tempUVs = [];
			var tempUVs2 = [];

			for ( var i = 0, j = 0; i < positions.length; i += 3, j += 2 ) {

				scope.vertices.push( new Vector3( positions[ i ], positions[ i + 1 ], positions[ i + 2 ] ) );

				if ( normals !== undefined ) {

					tempNormals.push( new Vector3( normals[ i ], normals[ i + 1 ], normals[ i + 2 ] ) );

				}

				if ( colors !== undefined ) {

					scope.colors.push( new Color( colors[ i ], colors[ i + 1 ], colors[ i + 2 ] ) );

				}

				if ( uvs !== undefined ) {

					tempUVs.push( new Vector2( uvs[ j ], uvs[ j + 1 ] ) );

				}

				if ( uvs2 !== undefined ) {

					tempUVs2.push( new Vector2( uvs2[ j ], uvs2[ j + 1 ] ) );

				}

			}

			function addFace( a, b, c, materialIndex ) {

				var vertexNormals = normals !== undefined ? [ tempNormals[ a ].clone(), tempNormals[ b ].clone(), tempNormals[ c ].clone() ] : [];
				var vertexColors = colors !== undefined ? [ scope.colors[ a ].clone(), scope.colors[ b ].clone(), scope.colors[ c ].clone() ] : [];

				var face = new Face3( a, b, c, vertexNormals, vertexColors, materialIndex );

				scope.faces.push( face );

				if ( uvs !== undefined ) {

					scope.faceVertexUvs[ 0 ].push( [ tempUVs[ a ].clone(), tempUVs[ b ].clone(), tempUVs[ c ].clone() ] );

				}

				if ( uvs2 !== undefined ) {

					scope.faceVertexUvs[ 1 ].push( [ tempUVs2[ a ].clone(), tempUVs2[ b ].clone(), tempUVs2[ c ].clone() ] );

				}

			}

			var groups = geometry.groups;

			if ( groups.length > 0 ) {

				for ( var i = 0; i < groups.length; i ++ ) {

					var group = groups[ i ];

					var start = group.start;
					var count = group.count;

					for ( var j = start, jl = start + count; j < jl; j += 3 ) {

						if ( indices !== undefined ) {

							addFace( indices[ j ], indices[ j + 1 ], indices[ j + 2 ], group.materialIndex );

						} else {

							addFace( j, j + 1, j + 2, group.materialIndex );

						}

					}

				}

			} else {

				if ( indices !== undefined ) {

					for ( var i = 0; i < indices.length; i += 3 ) {

						addFace( indices[ i ], indices[ i + 1 ], indices[ i + 2 ] );

					}

				} else {

					for ( var i = 0; i < positions.length / 3; i += 3 ) {

						addFace( i, i + 1, i + 2 );

					}

				}

			}

			this.computeFaceNormals();

			if ( geometry.boundingBox !== null ) {

				this.boundingBox = geometry.boundingBox.clone();

			}

			if ( geometry.boundingSphere !== null ) {

				this.boundingSphere = geometry.boundingSphere.clone();

			}

			return this;

		},

		center: function () {

			this.computeBoundingBox();

			var offset = this.boundingBox.getCenter().negate();

			this.translate( offset.x, offset.y, offset.z );

			return offset;

		},

		normalize: function () {

			this.computeBoundingSphere();

			var center = this.boundingSphere.center;
			var radius = this.boundingSphere.radius;

			var s = radius === 0 ? 1 : 1.0 / radius;

			var matrix = new Matrix4();
			matrix.set(
				s, 0, 0, - s * center.x,
				0, s, 0, - s * center.y,
				0, 0, s, - s * center.z,
				0, 0, 0, 1
			);

			this.applyMatrix( matrix );

			return this;

		},

		computeFaceNormals: function () {

			var cb = new Vector3(), ab = new Vector3();

			for ( var f = 0, fl = this.faces.length; f < fl; f ++ ) {

				var face = this.faces[ f ];

				var vA = this.vertices[ face.a ];
				var vB = this.vertices[ face.b ];
				var vC = this.vertices[ face.c ];

				cb.subVectors( vC, vB );
				ab.subVectors( vA, vB );
				cb.cross( ab );

				cb.normalize();

				face.normal.copy( cb );

			}

		},

		computeVertexNormals: function ( areaWeighted ) {

			if ( areaWeighted === undefined ) areaWeighted = true;

			var v, vl, f, fl, face, vertices;

			vertices = new Array( this.vertices.length );

			for ( v = 0, vl = this.vertices.length; v < vl; v ++ ) {

				vertices[ v ] = new Vector3();

			}

			if ( areaWeighted ) {

				// vertex normals weighted by triangle areas
				// http://www.iquilezles.org/www/articles/normals/normals.htm

				var vA, vB, vC;
				var cb = new Vector3(), ab = new Vector3();

				for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

					face = this.faces[ f ];

					vA = this.vertices[ face.a ];
					vB = this.vertices[ face.b ];
					vC = this.vertices[ face.c ];

					cb.subVectors( vC, vB );
					ab.subVectors( vA, vB );
					cb.cross( ab );

					vertices[ face.a ].add( cb );
					vertices[ face.b ].add( cb );
					vertices[ face.c ].add( cb );

				}

			} else {

				this.computeFaceNormals();

				for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

					face = this.faces[ f ];

					vertices[ face.a ].add( face.normal );
					vertices[ face.b ].add( face.normal );
					vertices[ face.c ].add( face.normal );

				}

			}

			for ( v = 0, vl = this.vertices.length; v < vl; v ++ ) {

				vertices[ v ].normalize();

			}

			for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

				face = this.faces[ f ];

				var vertexNormals = face.vertexNormals;

				if ( vertexNormals.length === 3 ) {

					vertexNormals[ 0 ].copy( vertices[ face.a ] );
					vertexNormals[ 1 ].copy( vertices[ face.b ] );
					vertexNormals[ 2 ].copy( vertices[ face.c ] );

				} else {

					vertexNormals[ 0 ] = vertices[ face.a ].clone();
					vertexNormals[ 1 ] = vertices[ face.b ].clone();
					vertexNormals[ 2 ] = vertices[ face.c ].clone();

				}

			}

			if ( this.faces.length > 0 ) {

				this.normalsNeedUpdate = true;

			}

		},

		computeFlatVertexNormals: function () {

			var f, fl, face;

			this.computeFaceNormals();

			for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

				face = this.faces[ f ];

				var vertexNormals = face.vertexNormals;

				if ( vertexNormals.length === 3 ) {

					vertexNormals[ 0 ].copy( face.normal );
					vertexNormals[ 1 ].copy( face.normal );
					vertexNormals[ 2 ].copy( face.normal );

				} else {

					vertexNormals[ 0 ] = face.normal.clone();
					vertexNormals[ 1 ] = face.normal.clone();
					vertexNormals[ 2 ] = face.normal.clone();

				}

			}

			if ( this.faces.length > 0 ) {

				this.normalsNeedUpdate = true;

			}

		},

		computeMorphNormals: function () {

			var i, il, f, fl, face;

			// save original normals
			// - create temp variables on first access
			//   otherwise just copy (for faster repeated calls)

			for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

				face = this.faces[ f ];

				if ( ! face.__originalFaceNormal ) {

					face.__originalFaceNormal = face.normal.clone();

				} else {

					face.__originalFaceNormal.copy( face.normal );

				}

				if ( ! face.__originalVertexNormals ) face.__originalVertexNormals = [];

				for ( i = 0, il = face.vertexNormals.length; i < il; i ++ ) {

					if ( ! face.__originalVertexNormals[ i ] ) {

						face.__originalVertexNormals[ i ] = face.vertexNormals[ i ].clone();

					} else {

						face.__originalVertexNormals[ i ].copy( face.vertexNormals[ i ] );

					}

				}

			}

			// use temp geometry to compute face and vertex normals for each morph

			var tmpGeo = new Geometry();
			tmpGeo.faces = this.faces;

			for ( i = 0, il = this.morphTargets.length; i < il; i ++ ) {

				// create on first access

				if ( ! this.morphNormals[ i ] ) {

					this.morphNormals[ i ] = {};
					this.morphNormals[ i ].faceNormals = [];
					this.morphNormals[ i ].vertexNormals = [];

					var dstNormalsFace = this.morphNormals[ i ].faceNormals;
					var dstNormalsVertex = this.morphNormals[ i ].vertexNormals;

					var faceNormal, vertexNormals;

					for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

						faceNormal = new Vector3();
						vertexNormals = { a: new Vector3(), b: new Vector3(), c: new Vector3() };

						dstNormalsFace.push( faceNormal );
						dstNormalsVertex.push( vertexNormals );

					}

				}

				var morphNormals = this.morphNormals[ i ];

				// set vertices to morph target

				tmpGeo.vertices = this.morphTargets[ i ].vertices;

				// compute morph normals

				tmpGeo.computeFaceNormals();
				tmpGeo.computeVertexNormals();

				// store morph normals

				var faceNormal, vertexNormals;

				for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

					face = this.faces[ f ];

					faceNormal = morphNormals.faceNormals[ f ];
					vertexNormals = morphNormals.vertexNormals[ f ];

					faceNormal.copy( face.normal );

					vertexNormals.a.copy( face.vertexNormals[ 0 ] );
					vertexNormals.b.copy( face.vertexNormals[ 1 ] );
					vertexNormals.c.copy( face.vertexNormals[ 2 ] );

				}

			}

			// restore original normals

			for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {

				face = this.faces[ f ];

				face.normal = face.__originalFaceNormal;
				face.vertexNormals = face.__originalVertexNormals;

			}

		},

		computeLineDistances: function () {

			var d = 0;
			var vertices = this.vertices;

			for ( var i = 0, il = vertices.length; i < il; i ++ ) {

				if ( i > 0 ) {

					d += vertices[ i ].distanceTo( vertices[ i - 1 ] );

				}

				this.lineDistances[ i ] = d;

			}

		},

		computeBoundingBox: function () {

			if ( this.boundingBox === null ) {

				this.boundingBox = new Box3();

			}

			this.boundingBox.setFromPoints( this.vertices );

		},

		computeBoundingSphere: function () {

			if ( this.boundingSphere === null ) {

				this.boundingSphere = new Sphere();

			}

			this.boundingSphere.setFromPoints( this.vertices );

		},

		merge: function ( geometry, matrix, materialIndexOffset ) {

			if ( ! ( geometry && geometry.isGeometry ) ) {

				console.error( 'THREE.Geometry.merge(): geometry not an instance of THREE.Geometry.', geometry );
				return;

			}

			var normalMatrix,
				vertexOffset = this.vertices.length,
				vertices1 = this.vertices,
				vertices2 = geometry.vertices,
				faces1 = this.faces,
				faces2 = geometry.faces,
				uvs1 = this.faceVertexUvs[ 0 ],
				uvs2 = geometry.faceVertexUvs[ 0 ],
				colors1 = this.colors,
				colors2 = geometry.colors;

			if ( materialIndexOffset === undefined ) materialIndexOffset = 0;

			if ( matrix !== undefined ) {

				normalMatrix = new Matrix3().getNormalMatrix( matrix );

			}

			// vertices

			for ( var i = 0, il = vertices2.length; i < il; i ++ ) {

				var vertex = vertices2[ i ];

				var vertexCopy = vertex.clone();

				if ( matrix !== undefined ) vertexCopy.applyMatrix4( matrix );

				vertices1.push( vertexCopy );

			}

			// colors

			for ( var i = 0, il = colors2.length; i < il; i ++ ) {

				colors1.push( colors2[ i ].clone() );

			}

			// faces

			for ( i = 0, il = faces2.length; i < il; i ++ ) {

				var face = faces2[ i ], faceCopy, normal, color,
					faceVertexNormals = face.vertexNormals,
					faceVertexColors = face.vertexColors;

				faceCopy = new Face3( face.a + vertexOffset, face.b + vertexOffset, face.c + vertexOffset );
				faceCopy.normal.copy( face.normal );

				if ( normalMatrix !== undefined ) {

					faceCopy.normal.applyMatrix3( normalMatrix ).normalize();

				}

				for ( var j = 0, jl = faceVertexNormals.length; j < jl; j ++ ) {

					normal = faceVertexNormals[ j ].clone();

					if ( normalMatrix !== undefined ) {

						normal.applyMatrix3( normalMatrix ).normalize();

					}

					faceCopy.vertexNormals.push( normal );

				}

				faceCopy.color.copy( face.color );

				for ( var j = 0, jl = faceVertexColors.length; j < jl; j ++ ) {

					color = faceVertexColors[ j ];
					faceCopy.vertexColors.push( color.clone() );

				}

				faceCopy.materialIndex = face.materialIndex + materialIndexOffset;

				faces1.push( faceCopy );

			}

			// uvs

			for ( i = 0, il = uvs2.length; i < il; i ++ ) {

				var uv = uvs2[ i ], uvCopy = [];

				if ( uv === undefined ) {

					continue;

				}

				for ( var j = 0, jl = uv.length; j < jl; j ++ ) {

					uvCopy.push( uv[ j ].clone() );

				}

				uvs1.push( uvCopy );

			}

		},

		mergeMesh: function ( mesh ) {

			if ( ! ( mesh && mesh.isMesh ) ) {

				console.error( 'THREE.Geometry.mergeMesh(): mesh not an instance of THREE.Mesh.', mesh );
				return;

			}

			mesh.matrixAutoUpdate && mesh.updateMatrix();

			this.merge( mesh.geometry, mesh.matrix );

		},

		/*
		 * Checks for duplicate vertices with hashmap.
		 * Duplicated vertices are removed
		 * and faces' vertices are updated.
		 */

		mergeVertices: function () {

			var verticesMap = {}; // Hashmap for looking up vertices by position coordinates (and making sure they are unique)
			var unique = [], changes = [];

			var v, key;
			var precisionPoints = 4; // number of decimal points, e.g. 4 for epsilon of 0.0001
			var precision = Math.pow( 10, precisionPoints );
			var i, il, face;
			var indices, j, jl;

			for ( i = 0, il = this.vertices.length; i < il; i ++ ) {

				v = this.vertices[ i ];
				key = Math.round( v.x * precision ) + '_' + Math.round( v.y * precision ) + '_' + Math.round( v.z * precision );

				if ( verticesMap[ key ] === undefined ) {

					verticesMap[ key ] = i;
					unique.push( this.vertices[ i ] );
					changes[ i ] = unique.length - 1;

				} else {

					//console.log('Duplicate vertex found. ', i, ' could be using ', verticesMap[key]);
					changes[ i ] = changes[ verticesMap[ key ] ];

				}

			}


			// if faces are completely degenerate after merging vertices, we
			// have to remove them from the geometry.
			var faceIndicesToRemove = [];

			for ( i = 0, il = this.faces.length; i < il; i ++ ) {

				face = this.faces[ i ];

				face.a = changes[ face.a ];
				face.b = changes[ face.b ];
				face.c = changes[ face.c ];

				indices = [ face.a, face.b, face.c ];

				// if any duplicate vertices are found in a Face3
				// we have to remove the face as nothing can be saved
				for ( var n = 0; n < 3; n ++ ) {

					if ( indices[ n ] === indices[ ( n + 1 ) % 3 ] ) {

						faceIndicesToRemove.push( i );
						break;

					}

				}

			}

			for ( i = faceIndicesToRemove.length - 1; i >= 0; i -- ) {

				var idx = faceIndicesToRemove[ i ];

				this.faces.splice( idx, 1 );

				for ( j = 0, jl = this.faceVertexUvs.length; j < jl; j ++ ) {

					this.faceVertexUvs[ j ].splice( idx, 1 );

				}

			}

			// Use unique set of vertices

			var diff = this.vertices.length - unique.length;
			this.vertices = unique;
			return diff;

		},

		sortFacesByMaterialIndex: function () {

			var faces = this.faces;
			var length = faces.length;

			// tag faces

			for ( var i = 0; i < length; i ++ ) {

				faces[ i ]._id = i;

			}

			// sort faces

			function materialIndexSort( a, b ) {

				return a.materialIndex - b.materialIndex;

			}

			faces.sort( materialIndexSort );

			// sort uvs

			var uvs1 = this.faceVertexUvs[ 0 ];
			var uvs2 = this.faceVertexUvs[ 1 ];

			var newUvs1, newUvs2;

			if ( uvs1 && uvs1.length === length ) newUvs1 = [];
			if ( uvs2 && uvs2.length === length ) newUvs2 = [];

			for ( var i = 0; i < length; i ++ ) {

				var id = faces[ i ]._id;

				if ( newUvs1 ) newUvs1.push( uvs1[ id ] );
				if ( newUvs2 ) newUvs2.push( uvs2[ id ] );

			}

			if ( newUvs1 ) this.faceVertexUvs[ 0 ] = newUvs1;
			if ( newUvs2 ) this.faceVertexUvs[ 1 ] = newUvs2;

		},

		toJSON: function () {

			var data = {
				metadata: {
					version: 4.5,
					type: 'Geometry',
					generator: 'Geometry.toJSON'
				}
			};

			// standard Geometry serialization

			data.uuid = this.uuid;
			data.type = this.type;
			if ( this.name !== '' ) data.name = this.name;

			if ( this.parameters !== undefined ) {

				var parameters = this.parameters;

				for ( var key in parameters ) {

					if ( parameters[ key ] !== undefined ) data[ key ] = parameters[ key ];

				}

				return data;

			}

			var vertices = [];

			for ( var i = 0; i < this.vertices.length; i ++ ) {

				var vertex = this.vertices[ i ];
				vertices.push( vertex.x, vertex.y, vertex.z );

			}

			var faces = [];
			var normals = [];
			var normalsHash = {};
			var colors = [];
			var colorsHash = {};
			var uvs = [];
			var uvsHash = {};

			for ( var i = 0; i < this.faces.length; i ++ ) {

				var face = this.faces[ i ];

				var hasMaterial = true;
				var hasFaceUv = false; // deprecated
				var hasFaceVertexUv = this.faceVertexUvs[ 0 ][ i ] !== undefined;
				var hasFaceNormal = face.normal.length() > 0;
				var hasFaceVertexNormal = face.vertexNormals.length > 0;
				var hasFaceColor = face.color.r !== 1 || face.color.g !== 1 || face.color.b !== 1;
				var hasFaceVertexColor = face.vertexColors.length > 0;

				var faceType = 0;

				faceType = setBit( faceType, 0, 0 ); // isQuad
				faceType = setBit( faceType, 1, hasMaterial );
				faceType = setBit( faceType, 2, hasFaceUv );
				faceType = setBit( faceType, 3, hasFaceVertexUv );
				faceType = setBit( faceType, 4, hasFaceNormal );
				faceType = setBit( faceType, 5, hasFaceVertexNormal );
				faceType = setBit( faceType, 6, hasFaceColor );
				faceType = setBit( faceType, 7, hasFaceVertexColor );

				faces.push( faceType );
				faces.push( face.a, face.b, face.c );
				faces.push( face.materialIndex );

				if ( hasFaceVertexUv ) {

					var faceVertexUvs = this.faceVertexUvs[ 0 ][ i ];

					faces.push(
						getUvIndex( faceVertexUvs[ 0 ] ),
						getUvIndex( faceVertexUvs[ 1 ] ),
						getUvIndex( faceVertexUvs[ 2 ] )
					);

				}

				if ( hasFaceNormal ) {

					faces.push( getNormalIndex( face.normal ) );

				}

				if ( hasFaceVertexNormal ) {

					var vertexNormals = face.vertexNormals;

					faces.push(
						getNormalIndex( vertexNormals[ 0 ] ),
						getNormalIndex( vertexNormals[ 1 ] ),
						getNormalIndex( vertexNormals[ 2 ] )
					);

				}

				if ( hasFaceColor ) {

					faces.push( getColorIndex( face.color ) );

				}

				if ( hasFaceVertexColor ) {

					var vertexColors = face.vertexColors;

					faces.push(
						getColorIndex( vertexColors[ 0 ] ),
						getColorIndex( vertexColors[ 1 ] ),
						getColorIndex( vertexColors[ 2 ] )
					);

				}

			}

			function setBit( value, position, enabled ) {

				return enabled ? value | ( 1 << position ) : value & ( ~ ( 1 << position ) );

			}

			function getNormalIndex( normal ) {

				var hash = normal.x.toString() + normal.y.toString() + normal.z.toString();

				if ( normalsHash[ hash ] !== undefined ) {

					return normalsHash[ hash ];

				}

				normalsHash[ hash ] = normals.length / 3;
				normals.push( normal.x, normal.y, normal.z );

				return normalsHash[ hash ];

			}

			function getColorIndex( color ) {

				var hash = color.r.toString() + color.g.toString() + color.b.toString();

				if ( colorsHash[ hash ] !== undefined ) {

					return colorsHash[ hash ];

				}

				colorsHash[ hash ] = colors.length;
				colors.push( color.getHex() );

				return colorsHash[ hash ];

			}

			function getUvIndex( uv ) {

				var hash = uv.x.toString() + uv.y.toString();

				if ( uvsHash[ hash ] !== undefined ) {

					return uvsHash[ hash ];

				}

				uvsHash[ hash ] = uvs.length / 2;
				uvs.push( uv.x, uv.y );

				return uvsHash[ hash ];

			}

			data.data = {};

			data.data.vertices = vertices;
			data.data.normals = normals;
			if ( colors.length > 0 ) data.data.colors = colors;
			if ( uvs.length > 0 ) data.data.uvs = [ uvs ]; // temporal backward compatibility
			data.data.faces = faces;

			return data;

		},

		clone: function () {

			/*
			 // Handle primitives

			 var parameters = this.parameters;

			 if ( parameters !== undefined ) {

			 var values = [];

			 for ( var key in parameters ) {

			 values.push( parameters[ key ] );

			 }

			 var geometry = Object.create( this.constructor.prototype );
			 this.constructor.apply( geometry, values );
			 return geometry;

			 }

			 return new this.constructor().copy( this );
			 */

			return new Geometry().copy( this );

		},

		copy: function ( source ) {

			var i, il, j, jl, k, kl;

			// reset

			this.vertices = [];
			this.colors = [];
			this.faces = [];
			this.faceVertexUvs = [[]];
			this.morphTargets = [];
			this.morphNormals = [];
			this.skinWeights = [];
			this.skinIndices = [];
			this.lineDistances = [];
			this.boundingBox = null;
			this.boundingSphere = null;

			// name

			this.name = source.name;

			// vertices

			var vertices = source.vertices;

			for ( i = 0, il = vertices.length; i < il; i ++ ) {

				this.vertices.push( vertices[ i ].clone() );

			}

			// colors

			var colors = source.colors;

			for ( i = 0, il = colors.length; i < il; i ++ ) {

				this.colors.push( colors[ i ].clone() );

			}

			// faces

			var faces = source.faces;

			for ( i = 0, il = faces.length; i < il; i ++ ) {

				this.faces.push( faces[ i ].clone() );

			}

			// face vertex uvs

			for ( i = 0, il = source.faceVertexUvs.length; i < il; i ++ ) {

				var faceVertexUvs = source.faceVertexUvs[ i ];

				if ( this.faceVertexUvs[ i ] === undefined ) {

					this.faceVertexUvs[ i ] = [];

				}

				for ( j = 0, jl = faceVertexUvs.length; j < jl; j ++ ) {

					var uvs = faceVertexUvs[ j ], uvsCopy = [];

					for ( k = 0, kl = uvs.length; k < kl; k ++ ) {

						var uv = uvs[ k ];

						uvsCopy.push( uv.clone() );

					}

					this.faceVertexUvs[ i ].push( uvsCopy );

				}

			}

			// morph targets

			var morphTargets = source.morphTargets;

			for ( i = 0, il = morphTargets.length; i < il; i ++ ) {

				var morphTarget = {};
				morphTarget.name = morphTargets[ i ].name;

				// vertices

				if ( morphTargets[ i ].vertices !== undefined ) {

					morphTarget.vertices = [];

					for ( j = 0, jl = morphTargets[ i ].vertices.length; j < jl; j ++ ) {

						morphTarget.vertices.push( morphTargets[ i ].vertices[ j ].clone() );

					}

				}

				// normals

				if ( morphTargets[ i ].normals !== undefined ) {

					morphTarget.normals = [];

					for ( j = 0, jl = morphTargets[ i ].normals.length; j < jl; j ++ ) {

						morphTarget.normals.push( morphTargets[ i ].normals[ j ].clone() );

					}

				}

				this.morphTargets.push( morphTarget );

			}

			// morph normals

			var morphNormals = source.morphNormals;

			for ( i = 0, il = morphNormals.length; i < il; i ++ ) {

				var morphNormal = {};

				// vertex normals

				if ( morphNormals[ i ].vertexNormals !== undefined ) {

					morphNormal.vertexNormals = [];

					for ( j = 0, jl = morphNormals[ i ].vertexNormals.length; j < jl; j ++ ) {

						var srcVertexNormal = morphNormals[ i ].vertexNormals[ j ];
						var destVertexNormal = {};

						destVertexNormal.a = srcVertexNormal.a.clone();
						destVertexNormal.b = srcVertexNormal.b.clone();
						destVertexNormal.c = srcVertexNormal.c.clone();

						morphNormal.vertexNormals.push( destVertexNormal );

					}

				}

				// face normals

				if ( morphNormals[ i ].faceNormals !== undefined ) {

					morphNormal.faceNormals = [];

					for ( j = 0, jl = morphNormals[ i ].faceNormals.length; j < jl; j ++ ) {

						morphNormal.faceNormals.push( morphNormals[ i ].faceNormals[ j ].clone() );

					}

				}

				this.morphNormals.push( morphNormal );

			}

			// skin weights

			var skinWeights = source.skinWeights;

			for ( i = 0, il = skinWeights.length; i < il; i ++ ) {

				this.skinWeights.push( skinWeights[ i ].clone() );

			}

			// skin indices

			var skinIndices = source.skinIndices;

			for ( i = 0, il = skinIndices.length; i < il; i ++ ) {

				this.skinIndices.push( skinIndices[ i ].clone() );

			}

			// line distances

			var lineDistances = source.lineDistances;

			for ( i = 0, il = lineDistances.length; i < il; i ++ ) {

				this.lineDistances.push( lineDistances[ i ] );

			}

			// bounding box

			var boundingBox = source.boundingBox;

			if ( boundingBox !== null ) {

				this.boundingBox = boundingBox.clone();

			}

			// bounding sphere

			var boundingSphere = source.boundingSphere;

			if ( boundingSphere !== null ) {

				this.boundingSphere = boundingSphere.clone();

			}

			// update flags

			this.elementsNeedUpdate = source.elementsNeedUpdate;
			this.verticesNeedUpdate = source.verticesNeedUpdate;
			this.uvsNeedUpdate = source.uvsNeedUpdate;
			this.normalsNeedUpdate = source.normalsNeedUpdate;
			this.colorsNeedUpdate = source.colorsNeedUpdate;
			this.lineDistancesNeedUpdate = source.lineDistancesNeedUpdate;
			this.groupsNeedUpdate = source.groupsNeedUpdate;

			return this;

		},

		dispose: function () {

			this.dispatchEvent( { type: 'dispose' } );

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function BufferAttribute( array, itemSize, normalized ) {

		if ( Array.isArray( array ) ) {

			throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );

		}

		this.uuid = _Math.generateUUID();
		this.name = '';

		this.array = array;
		this.itemSize = itemSize;
		this.count = array !== undefined ? array.length / itemSize : 0;
		this.normalized = normalized === true;

		this.dynamic = false;
		this.updateRange = { offset: 0, count: - 1 };

		this.onUploadCallback = function () {};

		this.version = 0;

	}

	Object.defineProperty( BufferAttribute.prototype, 'needsUpdate', {

		set: function ( value ) {

			if ( value === true ) this.version ++;

		}

	} );

	Object.assign( BufferAttribute.prototype, {

		isBufferAttribute: true,

		setArray: function ( array ) {

			if ( Array.isArray( array ) ) {

				throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );

			}

			this.count = array !== undefined ? array.length / this.itemSize : 0;
			this.array = array;

		},

		setDynamic: function ( value ) {

			this.dynamic = value;

			return this;

		},

		copy: function ( source ) {

			this.array = new source.array.constructor( source.array );
			this.itemSize = source.itemSize;
			this.count = source.count;
			this.normalized = source.normalized;

			this.dynamic = source.dynamic;

			return this;

		},

		copyAt: function ( index1, attribute, index2 ) {

			index1 *= this.itemSize;
			index2 *= attribute.itemSize;

			for ( var i = 0, l = this.itemSize; i < l; i ++ ) {

				this.array[ index1 + i ] = attribute.array[ index2 + i ];

			}

			return this;

		},

		copyArray: function ( array ) {

			this.array.set( array );

			return this;

		},

		copyColorsArray: function ( colors ) {

			var array = this.array, offset = 0;

			for ( var i = 0, l = colors.length; i < l; i ++ ) {

				var color = colors[ i ];

				if ( color === undefined ) {

					console.warn( 'THREE.BufferAttribute.copyColorsArray(): color is undefined', i );
					color = new Color();

				}

				array[ offset ++ ] = color.r;
				array[ offset ++ ] = color.g;
				array[ offset ++ ] = color.b;

			}

			return this;

		},

		copyIndicesArray: function ( indices ) {

			var array = this.array, offset = 0;

			for ( var i = 0, l = indices.length; i < l; i ++ ) {

				var index = indices[ i ];

				array[ offset ++ ] = index.a;
				array[ offset ++ ] = index.b;
				array[ offset ++ ] = index.c;

			}

			return this;

		},

		copyVector2sArray: function ( vectors ) {

			var array = this.array, offset = 0;

			for ( var i = 0, l = vectors.length; i < l; i ++ ) {

				var vector = vectors[ i ];

				if ( vector === undefined ) {

					console.warn( 'THREE.BufferAttribute.copyVector2sArray(): vector is undefined', i );
					vector = new Vector2();

				}

				array[ offset ++ ] = vector.x;
				array[ offset ++ ] = vector.y;

			}

			return this;

		},

		copyVector3sArray: function ( vectors ) {

			var array = this.array, offset = 0;

			for ( var i = 0, l = vectors.length; i < l; i ++ ) {

				var vector = vectors[ i ];

				if ( vector === undefined ) {

					console.warn( 'THREE.BufferAttribute.copyVector3sArray(): vector is undefined', i );
					vector = new Vector3();

				}

				array[ offset ++ ] = vector.x;
				array[ offset ++ ] = vector.y;
				array[ offset ++ ] = vector.z;

			}

			return this;

		},

		copyVector4sArray: function ( vectors ) {

			var array = this.array, offset = 0;

			for ( var i = 0, l = vectors.length; i < l; i ++ ) {

				var vector = vectors[ i ];

				if ( vector === undefined ) {

					console.warn( 'THREE.BufferAttribute.copyVector4sArray(): vector is undefined', i );
					vector = new Vector4();

				}

				array[ offset ++ ] = vector.x;
				array[ offset ++ ] = vector.y;
				array[ offset ++ ] = vector.z;
				array[ offset ++ ] = vector.w;

			}

			return this;

		},

		set: function ( value, offset ) {

			if ( offset === undefined ) offset = 0;

			this.array.set( value, offset );

			return this;

		},

		getX: function ( index ) {

			return this.array[ index * this.itemSize ];

		},

		setX: function ( index, x ) {

			this.array[ index * this.itemSize ] = x;

			return this;

		},

		getY: function ( index ) {

			return this.array[ index * this.itemSize + 1 ];

		},

		setY: function ( index, y ) {

			this.array[ index * this.itemSize + 1 ] = y;

			return this;

		},

		getZ: function ( index ) {

			return this.array[ index * this.itemSize + 2 ];

		},

		setZ: function ( index, z ) {

			this.array[ index * this.itemSize + 2 ] = z;

			return this;

		},

		getW: function ( index ) {

			return this.array[ index * this.itemSize + 3 ];

		},

		setW: function ( index, w ) {

			this.array[ index * this.itemSize + 3 ] = w;

			return this;

		},

		setXY: function ( index, x, y ) {

			index *= this.itemSize;

			this.array[ index + 0 ] = x;
			this.array[ index + 1 ] = y;

			return this;

		},

		setXYZ: function ( index, x, y, z ) {

			index *= this.itemSize;

			this.array[ index + 0 ] = x;
			this.array[ index + 1 ] = y;
			this.array[ index + 2 ] = z;

			return this;

		},

		setXYZW: function ( index, x, y, z, w ) {

			index *= this.itemSize;

			this.array[ index + 0 ] = x;
			this.array[ index + 1 ] = y;
			this.array[ index + 2 ] = z;
			this.array[ index + 3 ] = w;

			return this;

		},

		onUpload: function ( callback ) {

			this.onUploadCallback = callback;

			return this;

		},

		clone: function () {

			return new this.constructor( this.array, this.itemSize ).copy( this );

		}

	} );

	//

	function Int8BufferAttribute( array, itemSize ) {

		BufferAttribute.call( this, new Int8Array( array ), itemSize );

	}

	Int8BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
	Int8BufferAttribute.prototype.constructor = Int8BufferAttribute;


	function Uint8BufferAttribute( array, itemSize ) {

		BufferAttribute.call( this, new Uint8Array( array ), itemSize );

	}

	Uint8BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
	Uint8BufferAttribute.prototype.constructor = Uint8BufferAttribute;


	function Uint8ClampedBufferAttribute( array, itemSize ) {

		BufferAttribute.call( this, new Uint8ClampedArray( array ), itemSize );

	}

	Uint8ClampedBufferAttribute.prototype = Object.create( BufferAttribute.prototype );
	Uint8ClampedBufferAttribute.prototype.constructor = Uint8ClampedBufferAttribute;


	function Int16BufferAttribute( array, itemSize ) {

		BufferAttribute.call( this, new Int16Array( array ), itemSize );

	}

	Int16BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
	Int16BufferAttribute.prototype.constructor = Int16BufferAttribute;


	function Uint16BufferAttribute( array, itemSize ) {

		BufferAttribute.call( this, new Uint16Array( array ), itemSize );

	}

	Uint16BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
	Uint16BufferAttribute.prototype.constructor = Uint16BufferAttribute;


	function Int32BufferAttribute( array, itemSize ) {

		BufferAttribute.call( this, new Int32Array( array ), itemSize );

	}

	Int32BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
	Int32BufferAttribute.prototype.constructor = Int32BufferAttribute;


	function Uint32BufferAttribute( array, itemSize ) {

		BufferAttribute.call( this, new Uint32Array( array ), itemSize );

	}

	Uint32BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
	Uint32BufferAttribute.prototype.constructor = Uint32BufferAttribute;


	function Float32BufferAttribute( array, itemSize ) {

		BufferAttribute.call( this, new Float32Array( array ), itemSize );

	}

	Float32BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
	Float32BufferAttribute.prototype.constructor = Float32BufferAttribute;


	function Float64BufferAttribute( array, itemSize ) {

		BufferAttribute.call( this, new Float64Array( array ), itemSize );

	}

	Float64BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
	Float64BufferAttribute.prototype.constructor = Float64BufferAttribute;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function DirectGeometry() {

		this.indices = [];
		this.vertices = [];
		this.normals = [];
		this.colors = [];
		this.uvs = [];
		this.uvs2 = [];

		this.groups = [];

		this.morphTargets = {};

		this.skinWeights = [];
		this.skinIndices = [];

		// this.lineDistances = [];

		this.boundingBox = null;
		this.boundingSphere = null;

		// update flags

		this.verticesNeedUpdate = false;
		this.normalsNeedUpdate = false;
		this.colorsNeedUpdate = false;
		this.uvsNeedUpdate = false;
		this.groupsNeedUpdate = false;

	}

	Object.assign( DirectGeometry.prototype, {

		computeGroups: function ( geometry ) {

			var group;
			var groups = [];
			var materialIndex = undefined;

			var faces = geometry.faces;

			for ( var i = 0; i < faces.length; i ++ ) {

				var face = faces[ i ];

				// materials

				if ( face.materialIndex !== materialIndex ) {

					materialIndex = face.materialIndex;

					if ( group !== undefined ) {

						group.count = ( i * 3 ) - group.start;
						groups.push( group );

					}

					group = {
						start: i * 3,
						materialIndex: materialIndex
					};

				}

			}

			if ( group !== undefined ) {

				group.count = ( i * 3 ) - group.start;
				groups.push( group );

			}

			this.groups = groups;

		},

		fromGeometry: function ( geometry ) {

			var faces = geometry.faces;
			var vertices = geometry.vertices;
			var faceVertexUvs = geometry.faceVertexUvs;

			var hasFaceVertexUv = faceVertexUvs[ 0 ] && faceVertexUvs[ 0 ].length > 0;
			var hasFaceVertexUv2 = faceVertexUvs[ 1 ] && faceVertexUvs[ 1 ].length > 0;

			// morphs

			var morphTargets = geometry.morphTargets;
			var morphTargetsLength = morphTargets.length;

			var morphTargetsPosition;

			if ( morphTargetsLength > 0 ) {

				morphTargetsPosition = [];

				for ( var i = 0; i < morphTargetsLength; i ++ ) {

					morphTargetsPosition[ i ] = [];

				}

				this.morphTargets.position = morphTargetsPosition;

			}

			var morphNormals = geometry.morphNormals;
			var morphNormalsLength = morphNormals.length;

			var morphTargetsNormal;

			if ( morphNormalsLength > 0 ) {

				morphTargetsNormal = [];

				for ( var i = 0; i < morphNormalsLength; i ++ ) {

					morphTargetsNormal[ i ] = [];

				}

				this.morphTargets.normal = morphTargetsNormal;

			}

			// skins

			var skinIndices = geometry.skinIndices;
			var skinWeights = geometry.skinWeights;

			var hasSkinIndices = skinIndices.length === vertices.length;
			var hasSkinWeights = skinWeights.length === vertices.length;

			//

			for ( var i = 0; i < faces.length; i ++ ) {

				var face = faces[ i ];

				this.vertices.push( vertices[ face.a ], vertices[ face.b ], vertices[ face.c ] );

				var vertexNormals = face.vertexNormals;

				if ( vertexNormals.length === 3 ) {

					this.normals.push( vertexNormals[ 0 ], vertexNormals[ 1 ], vertexNormals[ 2 ] );

				} else {

					var normal = face.normal;

					this.normals.push( normal, normal, normal );

				}

				var vertexColors = face.vertexColors;

				if ( vertexColors.length === 3 ) {

					this.colors.push( vertexColors[ 0 ], vertexColors[ 1 ], vertexColors[ 2 ] );

				} else {

					var color = face.color;

					this.colors.push( color, color, color );

				}

				if ( hasFaceVertexUv === true ) {

					var vertexUvs = faceVertexUvs[ 0 ][ i ];

					if ( vertexUvs !== undefined ) {

						this.uvs.push( vertexUvs[ 0 ], vertexUvs[ 1 ], vertexUvs[ 2 ] );

					} else {

						console.warn( 'THREE.DirectGeometry.fromGeometry(): Undefined vertexUv ', i );

						this.uvs.push( new Vector2(), new Vector2(), new Vector2() );

					}

				}

				if ( hasFaceVertexUv2 === true ) {

					var vertexUvs = faceVertexUvs[ 1 ][ i ];

					if ( vertexUvs !== undefined ) {

						this.uvs2.push( vertexUvs[ 0 ], vertexUvs[ 1 ], vertexUvs[ 2 ] );

					} else {

						console.warn( 'THREE.DirectGeometry.fromGeometry(): Undefined vertexUv2 ', i );

						this.uvs2.push( new Vector2(), new Vector2(), new Vector2() );

					}

				}

				// morphs

				for ( var j = 0; j < morphTargetsLength; j ++ ) {

					var morphTarget = morphTargets[ j ].vertices;

					morphTargetsPosition[ j ].push( morphTarget[ face.a ], morphTarget[ face.b ], morphTarget[ face.c ] );

				}

				for ( var j = 0; j < morphNormalsLength; j ++ ) {

					var morphNormal = morphNormals[ j ].vertexNormals[ i ];

					morphTargetsNormal[ j ].push( morphNormal.a, morphNormal.b, morphNormal.c );

				}

				// skins

				if ( hasSkinIndices ) {

					this.skinIndices.push( skinIndices[ face.a ], skinIndices[ face.b ], skinIndices[ face.c ] );

				}

				if ( hasSkinWeights ) {

					this.skinWeights.push( skinWeights[ face.a ], skinWeights[ face.b ], skinWeights[ face.c ] );

				}

			}

			this.computeGroups( geometry );

			this.verticesNeedUpdate = geometry.verticesNeedUpdate;
			this.normalsNeedUpdate = geometry.normalsNeedUpdate;
			this.colorsNeedUpdate = geometry.colorsNeedUpdate;
			this.uvsNeedUpdate = geometry.uvsNeedUpdate;
			this.groupsNeedUpdate = geometry.groupsNeedUpdate;

			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function arrayMax( array ) {

		if ( array.length === 0 ) return - Infinity;

		var max = array[ 0 ];

		for ( var i = 1, l = array.length; i < l; ++ i ) {

			if ( array[ i ] > max ) max = array[ i ];

		}

		return max;

	}

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author mrdoob / http://mrdoob.com/
	 */

	function BufferGeometry() {

		Object.defineProperty( this, 'id', { value: GeometryIdCount() } );

		this.uuid = _Math.generateUUID();

		this.name = '';
		this.type = 'BufferGeometry';

		this.index = null;
		this.attributes = {};

		this.morphAttributes = {};

		this.groups = [];

		this.boundingBox = null;
		this.boundingSphere = null;

		this.drawRange = { start: 0, count: Infinity };

	}

	BufferGeometry.MaxIndex = 65535;

	Object.assign( BufferGeometry.prototype, EventDispatcher.prototype, {

		isBufferGeometry: true,

		getIndex: function () {

			return this.index;

		},

		setIndex: function ( index ) {

			if ( Array.isArray( index ) ) {

				this.index = new ( arrayMax( index ) > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute )( index, 1 );

			} else {

				this.index = index;

			}

		},

		addAttribute: function ( name, attribute ) {

			if ( ! ( attribute && attribute.isBufferAttribute ) && ! ( attribute && attribute.isInterleavedBufferAttribute ) ) {

				console.warn( 'THREE.BufferGeometry: .addAttribute() now expects ( name, attribute ).' );

				this.addAttribute( name, new BufferAttribute( arguments[ 1 ], arguments[ 2 ] ) );

				return;

			}

			if ( name === 'index' ) {

				console.warn( 'THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute.' );
				this.setIndex( attribute );

				return;

			}

			this.attributes[ name ] = attribute;

			return this;

		},

		getAttribute: function ( name ) {

			return this.attributes[ name ];

		},

		removeAttribute: function ( name ) {

			delete this.attributes[ name ];

			return this;

		},

		addGroup: function ( start, count, materialIndex ) {

			this.groups.push( {

				start: start,
				count: count,
				materialIndex: materialIndex !== undefined ? materialIndex : 0

			} );

		},

		clearGroups: function () {

			this.groups = [];

		},

		setDrawRange: function ( start, count ) {

			this.drawRange.start = start;
			this.drawRange.count = count;

		},

		applyMatrix: function ( matrix ) {

			var position = this.attributes.position;

			if ( position !== undefined ) {

				matrix.applyToBufferAttribute( position );
				position.needsUpdate = true;

			}

			var normal = this.attributes.normal;

			if ( normal !== undefined ) {

				var normalMatrix = new Matrix3().getNormalMatrix( matrix );

				normalMatrix.applyToBufferAttribute( normal );
				normal.needsUpdate = true;

			}

			if ( this.boundingBox !== null ) {

				this.computeBoundingBox();

			}

			if ( this.boundingSphere !== null ) {

				this.computeBoundingSphere();

			}

			return this;

		},

		rotateX: function () {

			// rotate geometry around world x-axis

			var m1 = new Matrix4();

			return function rotateX( angle ) {

				m1.makeRotationX( angle );

				this.applyMatrix( m1 );

				return this;

			};

		}(),

		rotateY: function () {

			// rotate geometry around world y-axis

			var m1 = new Matrix4();

			return function rotateY( angle ) {

				m1.makeRotationY( angle );

				this.applyMatrix( m1 );

				return this;

			};

		}(),

		rotateZ: function () {

			// rotate geometry around world z-axis

			var m1 = new Matrix4();

			return function rotateZ( angle ) {

				m1.makeRotationZ( angle );

				this.applyMatrix( m1 );

				return this;

			};

		}(),

		translate: function () {

			// translate geometry

			var m1 = new Matrix4();

			return function translate( x, y, z ) {

				m1.makeTranslation( x, y, z );

				this.applyMatrix( m1 );

				return this;

			};

		}(),

		scale: function () {

			// scale geometry

			var m1 = new Matrix4();

			return function scale( x, y, z ) {

				m1.makeScale( x, y, z );

				this.applyMatrix( m1 );

				return this;

			};

		}(),

		lookAt: function () {

			var obj = new Object3D();

			return function lookAt( vector ) {

				obj.lookAt( vector );

				obj.updateMatrix();

				this.applyMatrix( obj.matrix );

			};

		}(),

		center: function () {

			this.computeBoundingBox();

			var offset = this.boundingBox.getCenter().negate();

			this.translate( offset.x, offset.y, offset.z );

			return offset;

		},

		setFromObject: function ( object ) {

			// console.log( 'THREE.BufferGeometry.setFromObject(). Converting', object, this );

			var geometry = object.geometry;

			if ( object.isPoints || object.isLine ) {

				var positions = new Float32BufferAttribute( geometry.vertices.length * 3, 3 );
				var colors = new Float32BufferAttribute( geometry.colors.length * 3, 3 );

				this.addAttribute( 'position', positions.copyVector3sArray( geometry.vertices ) );
				this.addAttribute( 'color', colors.copyColorsArray( geometry.colors ) );

				if ( geometry.lineDistances && geometry.lineDistances.length === geometry.vertices.length ) {

					var lineDistances = new Float32BufferAttribute( geometry.lineDistances.length, 1 );

					this.addAttribute( 'lineDistance', lineDistances.copyArray( geometry.lineDistances ) );

				}

				if ( geometry.boundingSphere !== null ) {

					this.boundingSphere = geometry.boundingSphere.clone();

				}

				if ( geometry.boundingBox !== null ) {

					this.boundingBox = geometry.boundingBox.clone();

				}

			} else if ( object.isMesh ) {

				if ( geometry && geometry.isGeometry ) {

					this.fromGeometry( geometry );

				}

			}

			return this;

		},

		updateFromObject: function ( object ) {

			var geometry = object.geometry;

			if ( object.isMesh ) {

				var direct = geometry.__directGeometry;

				if ( geometry.elementsNeedUpdate === true ) {

					direct = undefined;
					geometry.elementsNeedUpdate = false;

				}

				if ( direct === undefined ) {

					return this.fromGeometry( geometry );

				}

				direct.verticesNeedUpdate = geometry.verticesNeedUpdate;
				direct.normalsNeedUpdate = geometry.normalsNeedUpdate;
				direct.colorsNeedUpdate = geometry.colorsNeedUpdate;
				direct.uvsNeedUpdate = geometry.uvsNeedUpdate;
				direct.groupsNeedUpdate = geometry.groupsNeedUpdate;

				geometry.verticesNeedUpdate = false;
				geometry.normalsNeedUpdate = false;
				geometry.colorsNeedUpdate = false;
				geometry.uvsNeedUpdate = false;
				geometry.groupsNeedUpdate = false;

				geometry = direct;

			}

			var attribute;

			if ( geometry.verticesNeedUpdate === true ) {

				attribute = this.attributes.position;

				if ( attribute !== undefined ) {

					attribute.copyVector3sArray( geometry.vertices );
					attribute.needsUpdate = true;

				}

				geometry.verticesNeedUpdate = false;

			}

			if ( geometry.normalsNeedUpdate === true ) {

				attribute = this.attributes.normal;

				if ( attribute !== undefined ) {

					attribute.copyVector3sArray( geometry.normals );
					attribute.needsUpdate = true;

				}

				geometry.normalsNeedUpdate = false;

			}

			if ( geometry.colorsNeedUpdate === true ) {

				attribute = this.attributes.color;

				if ( attribute !== undefined ) {

					attribute.copyColorsArray( geometry.colors );
					attribute.needsUpdate = true;

				}

				geometry.colorsNeedUpdate = false;

			}

			if ( geometry.uvsNeedUpdate ) {

				attribute = this.attributes.uv;

				if ( attribute !== undefined ) {

					attribute.copyVector2sArray( geometry.uvs );
					attribute.needsUpdate = true;

				}

				geometry.uvsNeedUpdate = false;

			}

			if ( geometry.lineDistancesNeedUpdate ) {

				attribute = this.attributes.lineDistance;

				if ( attribute !== undefined ) {

					attribute.copyArray( geometry.lineDistances );
					attribute.needsUpdate = true;

				}

				geometry.lineDistancesNeedUpdate = false;

			}

			if ( geometry.groupsNeedUpdate ) {

				geometry.computeGroups( object.geometry );
				this.groups = geometry.groups;

				geometry.groupsNeedUpdate = false;

			}

			return this;

		},

		fromGeometry: function ( geometry ) {

			geometry.__directGeometry = new DirectGeometry().fromGeometry( geometry );

			return this.fromDirectGeometry( geometry.__directGeometry );

		},

		fromDirectGeometry: function ( geometry ) {

			var positions = new Float32Array( geometry.vertices.length * 3 );
			this.addAttribute( 'position', new BufferAttribute( positions, 3 ).copyVector3sArray( geometry.vertices ) );

			if ( geometry.normals.length > 0 ) {

				var normals = new Float32Array( geometry.normals.length * 3 );
				this.addAttribute( 'normal', new BufferAttribute( normals, 3 ).copyVector3sArray( geometry.normals ) );

			}

			if ( geometry.colors.length > 0 ) {

				var colors = new Float32Array( geometry.colors.length * 3 );
				this.addAttribute( 'color', new BufferAttribute( colors, 3 ).copyColorsArray( geometry.colors ) );

			}

			if ( geometry.uvs.length > 0 ) {

				var uvs = new Float32Array( geometry.uvs.length * 2 );
				this.addAttribute( 'uv', new BufferAttribute( uvs, 2 ).copyVector2sArray( geometry.uvs ) );

			}

			if ( geometry.uvs2.length > 0 ) {

				var uvs2 = new Float32Array( geometry.uvs2.length * 2 );
				this.addAttribute( 'uv2', new BufferAttribute( uvs2, 2 ).copyVector2sArray( geometry.uvs2 ) );

			}

			if ( geometry.indices.length > 0 ) {

				var TypeArray = arrayMax( geometry.indices ) > 65535 ? Uint32Array : Uint16Array;
				var indices = new TypeArray( geometry.indices.length * 3 );
				this.setIndex( new BufferAttribute( indices, 1 ).copyIndicesArray( geometry.indices ) );

			}

			// groups

			this.groups = geometry.groups;

			// morphs

			for ( var name in geometry.morphTargets ) {

				var array = [];
				var morphTargets = geometry.morphTargets[ name ];

				for ( var i = 0, l = morphTargets.length; i < l; i ++ ) {

					var morphTarget = morphTargets[ i ];

					var attribute = new Float32BufferAttribute( morphTarget.length * 3, 3 );

					array.push( attribute.copyVector3sArray( morphTarget ) );

				}

				this.morphAttributes[ name ] = array;

			}

			// skinning

			if ( geometry.skinIndices.length > 0 ) {

				var skinIndices = new Float32BufferAttribute( geometry.skinIndices.length * 4, 4 );
				this.addAttribute( 'skinIndex', skinIndices.copyVector4sArray( geometry.skinIndices ) );

			}

			if ( geometry.skinWeights.length > 0 ) {

				var skinWeights = new Float32BufferAttribute( geometry.skinWeights.length * 4, 4 );
				this.addAttribute( 'skinWeight', skinWeights.copyVector4sArray( geometry.skinWeights ) );

			}

			//

			if ( geometry.boundingSphere !== null ) {

				this.boundingSphere = geometry.boundingSphere.clone();

			}

			if ( geometry.boundingBox !== null ) {

				this.boundingBox = geometry.boundingBox.clone();

			}

			return this;

		},

		computeBoundingBox: function () {

			if ( this.boundingBox === null ) {

				this.boundingBox = new Box3();

			}

			var position = this.attributes.position;

			if ( position !== undefined ) {

				this.boundingBox.setFromBufferAttribute( position );

			} else {

				this.boundingBox.makeEmpty();

			}

			if ( isNaN( this.boundingBox.min.x ) || isNaN( this.boundingBox.min.y ) || isNaN( this.boundingBox.min.z ) ) {

				console.error( 'THREE.BufferGeometry.computeBoundingBox: Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this );

			}

		},

		computeBoundingSphere: function () {

			var box = new Box3();
			var vector = new Vector3();

			return function computeBoundingSphere() {

				if ( this.boundingSphere === null ) {

					this.boundingSphere = new Sphere();

				}

				var position = this.attributes.position;

				if ( position ) {

					var center = this.boundingSphere.center;

					box.setFromBufferAttribute( position );
					box.getCenter( center );

					// hoping to find a boundingSphere with a radius smaller than the
					// boundingSphere of the boundingBox: sqrt(3) smaller in the best case

					var maxRadiusSq = 0;

					for ( var i = 0, il = position.count; i < il; i ++ ) {

						vector.x = position.getX( i );
						vector.y = position.getY( i );
						vector.z = position.getZ( i );
						maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( vector ) );

					}

					this.boundingSphere.radius = Math.sqrt( maxRadiusSq );

					if ( isNaN( this.boundingSphere.radius ) ) {

						console.error( 'THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this );

					}

				}

			};

		}(),

		computeFaceNormals: function () {

			// backwards compatibility

		},

		computeVertexNormals: function () {

			var index = this.index;
			var attributes = this.attributes;
			var groups = this.groups;

			if ( attributes.position ) {

				var positions = attributes.position.array;

				if ( attributes.normal === undefined ) {

					this.addAttribute( 'normal', new BufferAttribute( new Float32Array( positions.length ), 3 ) );

				} else {

					// reset existing normals to zero

					var array = attributes.normal.array;

					for ( var i = 0, il = array.length; i < il; i ++ ) {

						array[ i ] = 0;

					}

				}

				var normals = attributes.normal.array;

				var vA, vB, vC;
				var pA = new Vector3(), pB = new Vector3(), pC = new Vector3();
				var cb = new Vector3(), ab = new Vector3();

				// indexed elements

				if ( index ) {

					var indices = index.array;

					if ( groups.length === 0 ) {

						this.addGroup( 0, indices.length );

					}

					for ( var j = 0, jl = groups.length; j < jl; ++ j ) {

						var group = groups[ j ];

						var start = group.start;
						var count = group.count;

						for ( var i = start, il = start + count; i < il; i += 3 ) {

							vA = indices[ i + 0 ] * 3;
							vB = indices[ i + 1 ] * 3;
							vC = indices[ i + 2 ] * 3;

							pA.fromArray( positions, vA );
							pB.fromArray( positions, vB );
							pC.fromArray( positions, vC );

							cb.subVectors( pC, pB );
							ab.subVectors( pA, pB );
							cb.cross( ab );

							normals[ vA ] += cb.x;
							normals[ vA + 1 ] += cb.y;
							normals[ vA + 2 ] += cb.z;

							normals[ vB ] += cb.x;
							normals[ vB + 1 ] += cb.y;
							normals[ vB + 2 ] += cb.z;

							normals[ vC ] += cb.x;
							normals[ vC + 1 ] += cb.y;
							normals[ vC + 2 ] += cb.z;

						}

					}

				} else {

					// non-indexed elements (unconnected triangle soup)

					for ( var i = 0, il = positions.length; i < il; i += 9 ) {

						pA.fromArray( positions, i );
						pB.fromArray( positions, i + 3 );
						pC.fromArray( positions, i + 6 );

						cb.subVectors( pC, pB );
						ab.subVectors( pA, pB );
						cb.cross( ab );

						normals[ i ] = cb.x;
						normals[ i + 1 ] = cb.y;
						normals[ i + 2 ] = cb.z;

						normals[ i + 3 ] = cb.x;
						normals[ i + 4 ] = cb.y;
						normals[ i + 5 ] = cb.z;

						normals[ i + 6 ] = cb.x;
						normals[ i + 7 ] = cb.y;
						normals[ i + 8 ] = cb.z;

					}

				}

				this.normalizeNormals();

				attributes.normal.needsUpdate = true;

			}

		},

		merge: function ( geometry, offset ) {

			if ( ! ( geometry && geometry.isBufferGeometry ) ) {

				console.error( 'THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.', geometry );
				return;

			}

			if ( offset === undefined ) offset = 0;

			var attributes = this.attributes;

			for ( var key in attributes ) {

				if ( geometry.attributes[ key ] === undefined ) continue;

				var attribute1 = attributes[ key ];
				var attributeArray1 = attribute1.array;

				var attribute2 = geometry.attributes[ key ];
				var attributeArray2 = attribute2.array;

				var attributeSize = attribute2.itemSize;

				for ( var i = 0, j = attributeSize * offset; i < attributeArray2.length; i ++, j ++ ) {

					attributeArray1[ j ] = attributeArray2[ i ];

				}

			}

			return this;

		},

		normalizeNormals: function () {

			var vector = new Vector3();

			return function normalizeNormals() {

				var normals = this.attributes.normal;

				for ( var i = 0, il = normals.count; i < il; i ++ ) {

					vector.x = normals.getX( i );
					vector.y = normals.getY( i );
					vector.z = normals.getZ( i );

					vector.normalize();

					normals.setXYZ( i, vector.x, vector.y, vector.z );

				}

			};

		}(),

		toNonIndexed: function () {

			if ( this.index === null ) {

				console.warn( 'THREE.BufferGeometry.toNonIndexed(): Geometry is already non-indexed.' );
				return this;

			}

			var geometry2 = new BufferGeometry();

			var indices = this.index.array;
			var attributes = this.attributes;

			for ( var name in attributes ) {

				var attribute = attributes[ name ];

				var array = attribute.array;
				var itemSize = attribute.itemSize;

				var array2 = new array.constructor( indices.length * itemSize );

				var index = 0, index2 = 0;

				for ( var i = 0, l = indices.length; i < l; i ++ ) {

					index = indices[ i ] * itemSize;

					for ( var j = 0; j < itemSize; j ++ ) {

						array2[ index2 ++ ] = array[ index ++ ];

					}

				}

				geometry2.addAttribute( name, new BufferAttribute( array2, itemSize ) );

			}

			return geometry2;

		},

		toJSON: function () {

			var data = {
				metadata: {
					version: 4.5,
					type: 'BufferGeometry',
					generator: 'BufferGeometry.toJSON'
				}
			};

			// standard BufferGeometry serialization

			data.uuid = this.uuid;
			data.type = this.type;
			if ( this.name !== '' ) data.name = this.name;

			if ( this.parameters !== undefined ) {

				var parameters = this.parameters;

				for ( var key in parameters ) {

					if ( parameters[ key ] !== undefined ) data[ key ] = parameters[ key ];

				}

				return data;

			}

			data.data = { attributes: {} };

			var index = this.index;

			if ( index !== null ) {

				var array = Array.prototype.slice.call( index.array );

				data.data.index = {
					type: index.array.constructor.name,
					array: array
				};

			}

			var attributes = this.attributes;

			for ( var key in attributes ) {

				var attribute = attributes[ key ];

				var array = Array.prototype.slice.call( attribute.array );

				data.data.attributes[ key ] = {
					itemSize: attribute.itemSize,
					type: attribute.array.constructor.name,
					array: array,
					normalized: attribute.normalized
				};

			}

			var groups = this.groups;

			if ( groups.length > 0 ) {

				data.data.groups = JSON.parse( JSON.stringify( groups ) );

			}

			var boundingSphere = this.boundingSphere;

			if ( boundingSphere !== null ) {

				data.data.boundingSphere = {
					center: boundingSphere.center.toArray(),
					radius: boundingSphere.radius
				};

			}

			return data;

		},

		clone: function () {

			/*
			 // Handle primitives

			 var parameters = this.parameters;

			 if ( parameters !== undefined ) {

			 var values = [];

			 for ( var key in parameters ) {

			 values.push( parameters[ key ] );

			 }

			 var geometry = Object.create( this.constructor.prototype );
			 this.constructor.apply( geometry, values );
			 return geometry;

			 }

			 return new this.constructor().copy( this );
			 */

			return new BufferGeometry().copy( this );

		},

		copy: function ( source ) {

			var name, i, l;

			// reset

			this.index = null;
			this.attributes = {};
			this.morphAttributes = {};
			this.groups = [];
			this.boundingBox = null;
			this.boundingSphere = null;

			// name

			this.name = source.name;

			// index

			var index = source.index;

			if ( index !== null ) {

				this.setIndex( index.clone() );

			}

			// attributes

			var attributes = source.attributes;

			for ( name in attributes ) {

				var attribute = attributes[ name ];
				this.addAttribute( name, attribute.clone() );

			}

			// morph attributes

			var morphAttributes = source.morphAttributes;

			for ( name in morphAttributes ) {

				var array = [];
				var morphAttribute = morphAttributes[ name ]; // morphAttribute: array of Float32BufferAttributes

				for ( i = 0, l = morphAttribute.length; i < l; i ++ ) {

					array.push( morphAttribute[ i ].clone() );

				}

				this.morphAttributes[ name ] = array;

			}

			// groups

			var groups = source.groups;

			for ( i = 0, l = groups.length; i < l; i ++ ) {

				var group = groups[ i ];
				this.addGroup( group.start, group.count, group.materialIndex );

			}

			// bounding box

			var boundingBox = source.boundingBox;

			if ( boundingBox !== null ) {

				this.boundingBox = boundingBox.clone();

			}

			// bounding sphere

			var boundingSphere = source.boundingSphere;

			if ( boundingSphere !== null ) {

				this.boundingSphere = boundingSphere.clone();

			}

			// draw range

			this.drawRange.start = source.drawRange.start;
			this.drawRange.count = source.drawRange.count;

			return this;

		},

		dispose: function () {

			this.dispatchEvent( { type: 'dispose' } );

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	// BoxGeometry

	function BoxGeometry( width, height, depth, widthSegments, heightSegments, depthSegments ) {

		Geometry.call( this );

		this.type = 'BoxGeometry';

		this.parameters = {
			width: width,
			height: height,
			depth: depth,
			widthSegments: widthSegments,
			heightSegments: heightSegments,
			depthSegments: depthSegments
		};

		this.fromBufferGeometry( new BoxBufferGeometry( width, height, depth, widthSegments, heightSegments, depthSegments ) );
		this.mergeVertices();

	}

	BoxGeometry.prototype = Object.create( Geometry.prototype );
	BoxGeometry.prototype.constructor = BoxGeometry;

	// BoxBufferGeometry

	function BoxBufferGeometry( width, height, depth, widthSegments, heightSegments, depthSegments ) {

		BufferGeometry.call( this );

		this.type = 'BoxBufferGeometry';

		this.parameters = {
			width: width,
			height: height,
			depth: depth,
			widthSegments: widthSegments,
			heightSegments: heightSegments,
			depthSegments: depthSegments
		};

		var scope = this;

		// segments

		widthSegments = Math.floor( widthSegments ) || 1;
		heightSegments = Math.floor( heightSegments ) || 1;
		depthSegments = Math.floor( depthSegments ) || 1;

		// buffers

		var indices = [];
		var vertices = [];
		var normals = [];
		var uvs = [];

		// helper variables

		var numberOfVertices = 0;
		var groupStart = 0;

		// build each side of the box geometry

		buildPlane( 'z', 'y', 'x', - 1, - 1, depth, height,   width,  depthSegments, heightSegments, 0 ); // px
		buildPlane( 'z', 'y', 'x',   1, - 1, depth, height, - width,  depthSegments, heightSegments, 1 ); // nx
		buildPlane( 'x', 'z', 'y',   1,   1, width, depth,    height, widthSegments, depthSegments,  2 ); // py
		buildPlane( 'x', 'z', 'y',   1, - 1, width, depth,  - height, widthSegments, depthSegments,  3 ); // ny
		buildPlane( 'x', 'y', 'z',   1, - 1, width, height,   depth,  widthSegments, heightSegments, 4 ); // pz
		buildPlane( 'x', 'y', 'z', - 1, - 1, width, height, - depth,  widthSegments, heightSegments, 5 ); // nz

		// build geometry

		this.setIndex( indices );
		this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

		function buildPlane( u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex ) {

			var segmentWidth = width / gridX;
			var segmentHeight = height / gridY;

			var widthHalf = width / 2;
			var heightHalf = height / 2;
			var depthHalf = depth / 2;

			var gridX1 = gridX + 1;
			var gridY1 = gridY + 1;

			var vertexCounter = 0;
			var groupCount = 0;

			var ix, iy;

			var vector = new Vector3();

			// generate vertices, normals and uvs

			for ( iy = 0; iy < gridY1; iy ++ ) {

				var y = iy * segmentHeight - heightHalf;

				for ( ix = 0; ix < gridX1; ix ++ ) {

					var x = ix * segmentWidth - widthHalf;

					// set values to correct vector component

					vector[ u ] = x * udir;
					vector[ v ] = y * vdir;
					vector[ w ] = depthHalf;

					// now apply vector to vertex buffer

					vertices.push( vector.x, vector.y, vector.z );

					// set values to correct vector component

					vector[ u ] = 0;
					vector[ v ] = 0;
					vector[ w ] = depth > 0 ? 1 : - 1;

					// now apply vector to normal buffer

					normals.push( vector.x, vector.y, vector.z );

					// uvs

					uvs.push( ix / gridX );
					uvs.push( 1 - ( iy / gridY ) );

					// counters

					vertexCounter += 1;

				}

			}

			// indices

			// 1. you need three indices to draw a single face
			// 2. a single segment consists of two faces
			// 3. so we need to generate six (2*3) indices per segment

			for ( iy = 0; iy < gridY; iy ++ ) {

				for ( ix = 0; ix < gridX; ix ++ ) {

					var a = numberOfVertices + ix + gridX1 * iy;
					var b = numberOfVertices + ix + gridX1 * ( iy + 1 );
					var c = numberOfVertices + ( ix + 1 ) + gridX1 * ( iy + 1 );
					var d = numberOfVertices + ( ix + 1 ) + gridX1 * iy;

					// faces

					indices.push( a, b, d );
					indices.push( b, c, d );

					// increase counter

					groupCount += 6;

				}

			}

			// add a group to the geometry. this will ensure multi material support

			scope.addGroup( groupStart, groupCount, materialIndex );

			// calculate new start value for groups

			groupStart += groupCount;

			// update total number of vertices

			numberOfVertices += vertexCounter;

		}

	}

	BoxBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	BoxBufferGeometry.prototype.constructor = BoxBufferGeometry;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	// PlaneGeometry

	function PlaneGeometry( width, height, widthSegments, heightSegments ) {

		Geometry.call( this );

		this.type = 'PlaneGeometry';

		this.parameters = {
			width: width,
			height: height,
			widthSegments: widthSegments,
			heightSegments: heightSegments
		};

		this.fromBufferGeometry( new PlaneBufferGeometry( width, height, widthSegments, heightSegments ) );
		this.mergeVertices();

	}

	PlaneGeometry.prototype = Object.create( Geometry.prototype );
	PlaneGeometry.prototype.constructor = PlaneGeometry;

	// PlaneBufferGeometry

	function PlaneBufferGeometry( width, height, widthSegments, heightSegments ) {

		BufferGeometry.call( this );

		this.type = 'PlaneBufferGeometry';

		this.parameters = {
			width: width,
			height: height,
			widthSegments: widthSegments,
			heightSegments: heightSegments
		};

		var width_half = width / 2;
		var height_half = height / 2;

		var gridX = Math.floor( widthSegments ) || 1;
		var gridY = Math.floor( heightSegments ) || 1;

		var gridX1 = gridX + 1;
		var gridY1 = gridY + 1;

		var segment_width = width / gridX;
		var segment_height = height / gridY;

		var ix, iy;

		// buffers

		var indices = [];
		var vertices = [];
		var normals = [];
		var uvs = [];

		// generate vertices, normals and uvs

		for ( iy = 0; iy < gridY1; iy ++ ) {

			var y = iy * segment_height - height_half;

			for ( ix = 0; ix < gridX1; ix ++ ) {

				var x = ix * segment_width - width_half;

				vertices.push( x, - y, 0 );

				normals.push( 0, 0, 1 );

				uvs.push( ix / gridX );
				uvs.push( 1 - ( iy / gridY ) );

			}

		}

		// indices

		for ( iy = 0; iy < gridY; iy ++ ) {

			for ( ix = 0; ix < gridX; ix ++ ) {

				var a = ix + gridX1 * iy;
				var b = ix + gridX1 * ( iy + 1 );
				var c = ( ix + 1 ) + gridX1 * ( iy + 1 );
				var d = ( ix + 1 ) + gridX1 * iy;

				// faces

				indices.push( a, b, d );
				indices.push( b, c, d );

			}

		}

		// build geometry

		this.setIndex( indices );
		this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	}

	PlaneBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	PlaneBufferGeometry.prototype.constructor = PlaneBufferGeometry;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 *
	 * parameters = {
	 *  color: <hex>,
	 *  opacity: <float>,
	 *  map: new THREE.Texture( <Image> ),
	 *
	 *  lightMap: new THREE.Texture( <Image> ),
	 *  lightMapIntensity: <float>
	 *
	 *  aoMap: new THREE.Texture( <Image> ),
	 *  aoMapIntensity: <float>
	 *
	 *  specularMap: new THREE.Texture( <Image> ),
	 *
	 *  alphaMap: new THREE.Texture( <Image> ),
	 *
	 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
	 *  combine: THREE.Multiply,
	 *  reflectivity: <float>,
	 *  refractionRatio: <float>,
	 *
	 *  depthTest: <bool>,
	 *  depthWrite: <bool>,
	 *
	 *  wireframe: <boolean>,
	 *  wireframeLinewidth: <float>,
	 *
	 *  skinning: <bool>,
	 *  morphTargets: <bool>
	 * }
	 */

	function MeshBasicMaterial( parameters ) {

		Material.call( this );

		this.type = 'MeshBasicMaterial';

		this.color = new Color( 0xffffff ); // emissive

		this.map = null;

		this.lightMap = null;
		this.lightMapIntensity = 1.0;

		this.aoMap = null;
		this.aoMapIntensity = 1.0;

		this.specularMap = null;

		this.alphaMap = null;

		this.envMap = null;
		this.combine = MultiplyOperation;
		this.reflectivity = 1;
		this.refractionRatio = 0.98;

		this.wireframe = false;
		this.wireframeLinewidth = 1;
		this.wireframeLinecap = 'round';
		this.wireframeLinejoin = 'round';

		this.skinning = false;
		this.morphTargets = false;

		this.lights = false;

		this.setValues( parameters );

	}

	MeshBasicMaterial.prototype = Object.create( Material.prototype );
	MeshBasicMaterial.prototype.constructor = MeshBasicMaterial;

	MeshBasicMaterial.prototype.isMeshBasicMaterial = true;

	MeshBasicMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.color.copy( source.color );

		this.map = source.map;

		this.lightMap = source.lightMap;
		this.lightMapIntensity = source.lightMapIntensity;

		this.aoMap = source.aoMap;
		this.aoMapIntensity = source.aoMapIntensity;

		this.specularMap = source.specularMap;

		this.alphaMap = source.alphaMap;

		this.envMap = source.envMap;
		this.combine = source.combine;
		this.reflectivity = source.reflectivity;
		this.refractionRatio = source.refractionRatio;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;
		this.wireframeLinecap = source.wireframeLinecap;
		this.wireframeLinejoin = source.wireframeLinejoin;

		this.skinning = source.skinning;
		this.morphTargets = source.morphTargets;

		return this;

	};

	/**
	 * @author bhouston / http://clara.io
	 */

	function Ray( origin, direction ) {

		this.origin = ( origin !== undefined ) ? origin : new Vector3();
		this.direction = ( direction !== undefined ) ? direction : new Vector3();

	}

	Object.assign( Ray.prototype, {

		set: function ( origin, direction ) {

			this.origin.copy( origin );
			this.direction.copy( direction );

			return this;

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( ray ) {

			this.origin.copy( ray.origin );
			this.direction.copy( ray.direction );

			return this;

		},

		at: function ( t, optionalTarget ) {

			var result = optionalTarget || new Vector3();

			return result.copy( this.direction ).multiplyScalar( t ).add( this.origin );

		},

		lookAt: function ( v ) {

			this.direction.copy( v ).sub( this.origin ).normalize();

			return this;

		},

		recast: function () {

			var v1 = new Vector3();

			return function recast( t ) {

				this.origin.copy( this.at( t, v1 ) );

				return this;

			};

		}(),

		closestPointToPoint: function ( point, optionalTarget ) {

			var result = optionalTarget || new Vector3();
			result.subVectors( point, this.origin );
			var directionDistance = result.dot( this.direction );

			if ( directionDistance < 0 ) {

				return result.copy( this.origin );

			}

			return result.copy( this.direction ).multiplyScalar( directionDistance ).add( this.origin );

		},

		distanceToPoint: function ( point ) {

			return Math.sqrt( this.distanceSqToPoint( point ) );

		},

		distanceSqToPoint: function () {

			var v1 = new Vector3();

			return function distanceSqToPoint( point ) {

				var directionDistance = v1.subVectors( point, this.origin ).dot( this.direction );

				// point behind the ray

				if ( directionDistance < 0 ) {

					return this.origin.distanceToSquared( point );

				}

				v1.copy( this.direction ).multiplyScalar( directionDistance ).add( this.origin );

				return v1.distanceToSquared( point );

			};

		}(),

		distanceSqToSegment: function () {

			var segCenter = new Vector3();
			var segDir = new Vector3();
			var diff = new Vector3();

			return function distanceSqToSegment( v0, v1, optionalPointOnRay, optionalPointOnSegment ) {

				// from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteDistRaySegment.h
				// It returns the min distance between the ray and the segment
				// defined by v0 and v1
				// It can also set two optional targets :
				// - The closest point on the ray
				// - The closest point on the segment

				segCenter.copy( v0 ).add( v1 ).multiplyScalar( 0.5 );
				segDir.copy( v1 ).sub( v0 ).normalize();
				diff.copy( this.origin ).sub( segCenter );

				var segExtent = v0.distanceTo( v1 ) * 0.5;
				var a01 = - this.direction.dot( segDir );
				var b0 = diff.dot( this.direction );
				var b1 = - diff.dot( segDir );
				var c = diff.lengthSq();
				var det = Math.abs( 1 - a01 * a01 );
				var s0, s1, sqrDist, extDet;

				if ( det > 0 ) {

					// The ray and segment are not parallel.

					s0 = a01 * b1 - b0;
					s1 = a01 * b0 - b1;
					extDet = segExtent * det;

					if ( s0 >= 0 ) {

						if ( s1 >= - extDet ) {

							if ( s1 <= extDet ) {

								// region 0
								// Minimum at interior points of ray and segment.

								var invDet = 1 / det;
								s0 *= invDet;
								s1 *= invDet;
								sqrDist = s0 * ( s0 + a01 * s1 + 2 * b0 ) + s1 * ( a01 * s0 + s1 + 2 * b1 ) + c;

							} else {

								// region 1

								s1 = segExtent;
								s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
								sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

							}

						} else {

							// region 5

							s1 = - segExtent;
							s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
							sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

						}

					} else {

						if ( s1 <= - extDet ) {

							// region 4

							s0 = Math.max( 0, - ( - a01 * segExtent + b0 ) );
							s1 = ( s0 > 0 ) ? - segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
							sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

						} else if ( s1 <= extDet ) {

							// region 3

							s0 = 0;
							s1 = Math.min( Math.max( - segExtent, - b1 ), segExtent );
							sqrDist = s1 * ( s1 + 2 * b1 ) + c;

						} else {

							// region 2

							s0 = Math.max( 0, - ( a01 * segExtent + b0 ) );
							s1 = ( s0 > 0 ) ? segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
							sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

						}

					}

				} else {

					// Ray and segment are parallel.

					s1 = ( a01 > 0 ) ? - segExtent : segExtent;
					s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
					sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

				}

				if ( optionalPointOnRay ) {

					optionalPointOnRay.copy( this.direction ).multiplyScalar( s0 ).add( this.origin );

				}

				if ( optionalPointOnSegment ) {

					optionalPointOnSegment.copy( segDir ).multiplyScalar( s1 ).add( segCenter );

				}

				return sqrDist;

			};

		}(),

		intersectSphere: function () {

			var v1 = new Vector3();

			return function intersectSphere( sphere, optionalTarget ) {

				v1.subVectors( sphere.center, this.origin );
				var tca = v1.dot( this.direction );
				var d2 = v1.dot( v1 ) - tca * tca;
				var radius2 = sphere.radius * sphere.radius;

				if ( d2 > radius2 ) return null;

				var thc = Math.sqrt( radius2 - d2 );

				// t0 = first intersect point - entrance on front of sphere
				var t0 = tca - thc;

				// t1 = second intersect point - exit point on back of sphere
				var t1 = tca + thc;

				// test to see if both t0 and t1 are behind the ray - if so, return null
				if ( t0 < 0 && t1 < 0 ) return null;

				// test to see if t0 is behind the ray:
				// if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
				// in order to always return an intersect point that is in front of the ray.
				if ( t0 < 0 ) return this.at( t1, optionalTarget );

				// else t0 is in front of the ray, so return the first collision point scaled by t0
				return this.at( t0, optionalTarget );

			};

		}(),

		intersectsSphere: function ( sphere ) {

			return this.distanceToPoint( sphere.center ) <= sphere.radius;

		},

		distanceToPlane: function ( plane ) {

			var denominator = plane.normal.dot( this.direction );

			if ( denominator === 0 ) {

				// line is coplanar, return origin
				if ( plane.distanceToPoint( this.origin ) === 0 ) {

					return 0;

				}

				// Null is preferable to undefined since undefined means.... it is undefined

				return null;

			}

			var t = - ( this.origin.dot( plane.normal ) + plane.constant ) / denominator;

			// Return if the ray never intersects the plane

			return t >= 0 ? t :  null;

		},

		intersectPlane: function ( plane, optionalTarget ) {

			var t = this.distanceToPlane( plane );

			if ( t === null ) {

				return null;

			}

			return this.at( t, optionalTarget );

		},

		intersectsPlane: function ( plane ) {

			// check if the ray lies on the plane first

			var distToPoint = plane.distanceToPoint( this.origin );

			if ( distToPoint === 0 ) {

				return true;

			}

			var denominator = plane.normal.dot( this.direction );

			if ( denominator * distToPoint < 0 ) {

				return true;

			}

			// ray origin is behind the plane (and is pointing behind it)

			return false;

		},

		intersectBox: function ( box, optionalTarget ) {

			var tmin, tmax, tymin, tymax, tzmin, tzmax;

			var invdirx = 1 / this.direction.x,
				invdiry = 1 / this.direction.y,
				invdirz = 1 / this.direction.z;

			var origin = this.origin;

			if ( invdirx >= 0 ) {

				tmin = ( box.min.x - origin.x ) * invdirx;
				tmax = ( box.max.x - origin.x ) * invdirx;

			} else {

				tmin = ( box.max.x - origin.x ) * invdirx;
				tmax = ( box.min.x - origin.x ) * invdirx;

			}

			if ( invdiry >= 0 ) {

				tymin = ( box.min.y - origin.y ) * invdiry;
				tymax = ( box.max.y - origin.y ) * invdiry;

			} else {

				tymin = ( box.max.y - origin.y ) * invdiry;
				tymax = ( box.min.y - origin.y ) * invdiry;

			}

			if ( ( tmin > tymax ) || ( tymin > tmax ) ) return null;

			// These lines also handle the case where tmin or tmax is NaN
			// (result of 0 * Infinity). x !== x returns true if x is NaN

			if ( tymin > tmin || tmin !== tmin ) tmin = tymin;

			if ( tymax < tmax || tmax !== tmax ) tmax = tymax;

			if ( invdirz >= 0 ) {

				tzmin = ( box.min.z - origin.z ) * invdirz;
				tzmax = ( box.max.z - origin.z ) * invdirz;

			} else {

				tzmin = ( box.max.z - origin.z ) * invdirz;
				tzmax = ( box.min.z - origin.z ) * invdirz;

			}

			if ( ( tmin > tzmax ) || ( tzmin > tmax ) ) return null;

			if ( tzmin > tmin || tmin !== tmin ) tmin = tzmin;

			if ( tzmax < tmax || tmax !== tmax ) tmax = tzmax;

			//return point closest to the ray (positive side)

			if ( tmax < 0 ) return null;

			return this.at( tmin >= 0 ? tmin : tmax, optionalTarget );

		},

		intersectsBox: ( function () {

			var v = new Vector3();

			return function intersectsBox( box ) {

				return this.intersectBox( box, v ) !== null;

			};

		} )(),

		intersectTriangle: function () {

			// Compute the offset origin, edges, and normal.
			var diff = new Vector3();
			var edge1 = new Vector3();
			var edge2 = new Vector3();
			var normal = new Vector3();

			return function intersectTriangle( a, b, c, backfaceCulling, optionalTarget ) {

				// from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h

				edge1.subVectors( b, a );
				edge2.subVectors( c, a );
				normal.crossVectors( edge1, edge2 );

				// Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
				// E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
				//   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
				//   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
				//   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
				var DdN = this.direction.dot( normal );
				var sign;

				if ( DdN > 0 ) {

					if ( backfaceCulling ) return null;
					sign = 1;

				} else if ( DdN < 0 ) {

					sign = - 1;
					DdN = - DdN;

				} else {

					return null;

				}

				diff.subVectors( this.origin, a );
				var DdQxE2 = sign * this.direction.dot( edge2.crossVectors( diff, edge2 ) );

				// b1 < 0, no intersection
				if ( DdQxE2 < 0 ) {

					return null;

				}

				var DdE1xQ = sign * this.direction.dot( edge1.cross( diff ) );

				// b2 < 0, no intersection
				if ( DdE1xQ < 0 ) {

					return null;

				}

				// b1+b2 > 1, no intersection
				if ( DdQxE2 + DdE1xQ > DdN ) {

					return null;

				}

				// Line intersects triangle, check if ray does.
				var QdN = - sign * diff.dot( normal );

				// t < 0, no intersection
				if ( QdN < 0 ) {

					return null;

				}

				// Ray intersects triangle.
				return this.at( QdN / DdN, optionalTarget );

			};

		}(),

		applyMatrix4: function ( matrix4 ) {

			this.origin.applyMatrix4( matrix4 );
			this.direction.transformDirection( matrix4 );

			return this;

		},

		equals: function ( ray ) {

			return ray.origin.equals( this.origin ) && ray.direction.equals( this.direction );

		}

	} );

	/**
	 * @author bhouston / http://clara.io
	 */

	function Line3( start, end ) {

		this.start = ( start !== undefined ) ? start : new Vector3();
		this.end = ( end !== undefined ) ? end : new Vector3();

	}

	Object.assign( Line3.prototype, {

		set: function ( start, end ) {

			this.start.copy( start );
			this.end.copy( end );

			return this;

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( line ) {

			this.start.copy( line.start );
			this.end.copy( line.end );

			return this;

		},

		getCenter: function ( optionalTarget ) {

			var result = optionalTarget || new Vector3();
			return result.addVectors( this.start, this.end ).multiplyScalar( 0.5 );

		},

		delta: function ( optionalTarget ) {

			var result = optionalTarget || new Vector3();
			return result.subVectors( this.end, this.start );

		},

		distanceSq: function () {

			return this.start.distanceToSquared( this.end );

		},

		distance: function () {

			return this.start.distanceTo( this.end );

		},

		at: function ( t, optionalTarget ) {

			var result = optionalTarget || new Vector3();

			return this.delta( result ).multiplyScalar( t ).add( this.start );

		},

		closestPointToPointParameter: function () {

			var startP = new Vector3();
			var startEnd = new Vector3();

			return function closestPointToPointParameter( point, clampToLine ) {

				startP.subVectors( point, this.start );
				startEnd.subVectors( this.end, this.start );

				var startEnd2 = startEnd.dot( startEnd );
				var startEnd_startP = startEnd.dot( startP );

				var t = startEnd_startP / startEnd2;

				if ( clampToLine ) {

					t = _Math.clamp( t, 0, 1 );

				}

				return t;

			};

		}(),

		closestPointToPoint: function ( point, clampToLine, optionalTarget ) {

			var t = this.closestPointToPointParameter( point, clampToLine );

			var result = optionalTarget || new Vector3();

			return this.delta( result ).multiplyScalar( t ).add( this.start );

		},

		applyMatrix4: function ( matrix ) {

			this.start.applyMatrix4( matrix );
			this.end.applyMatrix4( matrix );

			return this;

		},

		equals: function ( line ) {

			return line.start.equals( this.start ) && line.end.equals( this.end );

		}

	} );

	/**
	 * @author bhouston / http://clara.io
	 * @author mrdoob / http://mrdoob.com/
	 */

	function Triangle( a, b, c ) {

		this.a = ( a !== undefined ) ? a : new Vector3();
		this.b = ( b !== undefined ) ? b : new Vector3();
		this.c = ( c !== undefined ) ? c : new Vector3();

	}

	Object.assign( Triangle, {

		normal: function () {

			var v0 = new Vector3();

			return function normal( a, b, c, optionalTarget ) {

				var result = optionalTarget || new Vector3();

				result.subVectors( c, b );
				v0.subVectors( a, b );
				result.cross( v0 );

				var resultLengthSq = result.lengthSq();
				if ( resultLengthSq > 0 ) {

					return result.multiplyScalar( 1 / Math.sqrt( resultLengthSq ) );

				}

				return result.set( 0, 0, 0 );

			};

		}(),

		// static/instance method to calculate barycentric coordinates
		// based on: http://www.blackpawn.com/texts/pointinpoly/default.html
		barycoordFromPoint: function () {

			var v0 = new Vector3();
			var v1 = new Vector3();
			var v2 = new Vector3();

			return function barycoordFromPoint( point, a, b, c, optionalTarget ) {

				v0.subVectors( c, a );
				v1.subVectors( b, a );
				v2.subVectors( point, a );

				var dot00 = v0.dot( v0 );
				var dot01 = v0.dot( v1 );
				var dot02 = v0.dot( v2 );
				var dot11 = v1.dot( v1 );
				var dot12 = v1.dot( v2 );

				var denom = ( dot00 * dot11 - dot01 * dot01 );

				var result = optionalTarget || new Vector3();

				// collinear or singular triangle
				if ( denom === 0 ) {

					// arbitrary location outside of triangle?
					// not sure if this is the best idea, maybe should be returning undefined
					return result.set( - 2, - 1, - 1 );

				}

				var invDenom = 1 / denom;
				var u = ( dot11 * dot02 - dot01 * dot12 ) * invDenom;
				var v = ( dot00 * dot12 - dot01 * dot02 ) * invDenom;

				// barycentric coordinates must always sum to 1
				return result.set( 1 - u - v, v, u );

			};

		}(),

		containsPoint: function () {

			var v1 = new Vector3();

			return function containsPoint( point, a, b, c ) {

				var result = Triangle.barycoordFromPoint( point, a, b, c, v1 );

				return ( result.x >= 0 ) && ( result.y >= 0 ) && ( ( result.x + result.y ) <= 1 );

			};

		}()

	} );

	Object.assign( Triangle.prototype, {

		set: function ( a, b, c ) {

			this.a.copy( a );
			this.b.copy( b );
			this.c.copy( c );

			return this;

		},

		setFromPointsAndIndices: function ( points, i0, i1, i2 ) {

			this.a.copy( points[ i0 ] );
			this.b.copy( points[ i1 ] );
			this.c.copy( points[ i2 ] );

			return this;

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( triangle ) {

			this.a.copy( triangle.a );
			this.b.copy( triangle.b );
			this.c.copy( triangle.c );

			return this;

		},

		area: function () {

			var v0 = new Vector3();
			var v1 = new Vector3();

			return function area() {

				v0.subVectors( this.c, this.b );
				v1.subVectors( this.a, this.b );

				return v0.cross( v1 ).length() * 0.5;

			};

		}(),

		midpoint: function ( optionalTarget ) {

			var result = optionalTarget || new Vector3();
			return result.addVectors( this.a, this.b ).add( this.c ).multiplyScalar( 1 / 3 );

		},

		normal: function ( optionalTarget ) {

			return Triangle.normal( this.a, this.b, this.c, optionalTarget );

		},

		plane: function ( optionalTarget ) {

			var result = optionalTarget || new Plane();

			return result.setFromCoplanarPoints( this.a, this.b, this.c );

		},

		barycoordFromPoint: function ( point, optionalTarget ) {

			return Triangle.barycoordFromPoint( point, this.a, this.b, this.c, optionalTarget );

		},

		containsPoint: function ( point ) {

			return Triangle.containsPoint( point, this.a, this.b, this.c );

		},

		closestPointToPoint: function () {

			var plane = new Plane();
			var edgeList = [ new Line3(), new Line3(), new Line3() ];
			var projectedPoint = new Vector3();
			var closestPoint = new Vector3();

			return function closestPointToPoint( point, optionalTarget ) {

				var result = optionalTarget || new Vector3();
				var minDistance = Infinity;

				// project the point onto the plane of the triangle

				plane.setFromCoplanarPoints( this.a, this.b, this.c );
				plane.projectPoint( point, projectedPoint );

				// check if the projection lies within the triangle

				if( this.containsPoint( projectedPoint ) === true ) {

					// if so, this is the closest point

					result.copy( projectedPoint );

				} else {

					// if not, the point falls outside the triangle. the result is the closest point to the triangle's edges or vertices

					edgeList[ 0 ].set( this.a, this.b );
					edgeList[ 1 ].set( this.b, this.c );
					edgeList[ 2 ].set( this.c, this.a );

					for( var i = 0; i < edgeList.length; i ++ ) {

						edgeList[ i ].closestPointToPoint( projectedPoint, true, closestPoint );

						var distance = projectedPoint.distanceToSquared( closestPoint );

						if( distance < minDistance ) {

							minDistance = distance;

							result.copy( closestPoint );

						}

					}

				}

				return result;

			};

		}(),

		equals: function ( triangle ) {

			return triangle.a.equals( this.a ) && triangle.b.equals( this.b ) && triangle.c.equals( this.c );

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 * @author mikael emtinger / http://gomo.se/
	 * @author jonobr1 / http://jonobr1.com/
	 */

	function Mesh( geometry, material ) {

		Object3D.call( this );

		this.type = 'Mesh';

		this.geometry = geometry !== undefined ? geometry : new BufferGeometry();
		this.material = material !== undefined ? material : new MeshBasicMaterial( { color: Math.random() * 0xffffff } );

		this.drawMode = TrianglesDrawMode;

		this.updateMorphTargets();

	}

	Mesh.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: Mesh,

		isMesh: true,

		setDrawMode: function ( value ) {

			this.drawMode = value;

		},

		copy: function ( source ) {

			Object3D.prototype.copy.call( this, source );

			this.drawMode = source.drawMode;

			return this;

		},

		updateMorphTargets: function () {

			var geometry = this.geometry;
			var m, ml, name;

			if ( geometry.isBufferGeometry ) {

				var morphAttributes = geometry.morphAttributes;
				var keys = Object.keys( morphAttributes );

				if ( keys.length > 0 ) {

					var morphAttribute = morphAttributes[ keys[ 0 ] ];

					if ( morphAttribute !== undefined ) {

						this.morphTargetInfluences = [];
						this.morphTargetDictionary = {};

						for ( m = 0, ml = morphAttribute.length; m < ml; m ++ ) {

							name = morphAttribute[ m ].name || String( m );

							this.morphTargetInfluences.push( 0 );
							this.morphTargetDictionary[ name ] = m;

						}

					}

				}

			} else {

				var morphTargets = geometry.morphTargets;

				if ( morphTargets !== undefined && morphTargets.length > 0 ) {

					this.morphTargetInfluences = [];
					this.morphTargetDictionary = {};

					for ( m = 0, ml = morphTargets.length; m < ml; m ++ ) {

						name = morphTargets[ m ].name || String( m );

						this.morphTargetInfluences.push( 0 );
						this.morphTargetDictionary[ name ] = m;

					}

				}

			}

		},

		raycast: ( function () {

			var inverseMatrix = new Matrix4();
			var ray = new Ray();
			var sphere = new Sphere();

			var vA = new Vector3();
			var vB = new Vector3();
			var vC = new Vector3();

			var tempA = new Vector3();
			var tempB = new Vector3();
			var tempC = new Vector3();

			var uvA = new Vector2();
			var uvB = new Vector2();
			var uvC = new Vector2();

			var barycoord = new Vector3();

			var intersectionPoint = new Vector3();
			var intersectionPointWorld = new Vector3();

			function uvIntersection( point, p1, p2, p3, uv1, uv2, uv3 ) {

				Triangle.barycoordFromPoint( point, p1, p2, p3, barycoord );

				uv1.multiplyScalar( barycoord.x );
				uv2.multiplyScalar( barycoord.y );
				uv3.multiplyScalar( barycoord.z );

				uv1.add( uv2 ).add( uv3 );

				return uv1.clone();

			}

			function checkIntersection( object, material, raycaster, ray, pA, pB, pC, point ) {

				var intersect;

				if ( material.side === BackSide ) {

					intersect = ray.intersectTriangle( pC, pB, pA, true, point );

				} else {

					intersect = ray.intersectTriangle( pA, pB, pC, material.side !== DoubleSide, point );

				}

				if ( intersect === null ) return null;

				intersectionPointWorld.copy( point );
				intersectionPointWorld.applyMatrix4( object.matrixWorld );

				var distance = raycaster.ray.origin.distanceTo( intersectionPointWorld );

				if ( distance < raycaster.near || distance > raycaster.far ) return null;

				return {
					distance: distance,
					point: intersectionPointWorld.clone(),
					object: object
				};

			}

			function checkBufferGeometryIntersection( object, raycaster, ray, position, uv, a, b, c ) {

				vA.fromBufferAttribute( position, a );
				vB.fromBufferAttribute( position, b );
				vC.fromBufferAttribute( position, c );

				var intersection = checkIntersection( object, object.material, raycaster, ray, vA, vB, vC, intersectionPoint );

				if ( intersection ) {

					if ( uv ) {

						uvA.fromBufferAttribute( uv, a );
						uvB.fromBufferAttribute( uv, b );
						uvC.fromBufferAttribute( uv, c );

						intersection.uv = uvIntersection( intersectionPoint, vA, vB, vC, uvA, uvB, uvC );

					}

					intersection.face = new Face3( a, b, c, Triangle.normal( vA, vB, vC ) );
					intersection.faceIndex = a;

				}

				return intersection;

			}

			return function raycast( raycaster, intersects ) {

				var geometry = this.geometry;
				var material = this.material;
				var matrixWorld = this.matrixWorld;

				if ( material === undefined ) return;

				// Checking boundingSphere distance to ray

				if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

				sphere.copy( geometry.boundingSphere );
				sphere.applyMatrix4( matrixWorld );

				if ( raycaster.ray.intersectsSphere( sphere ) === false ) return;

				//

				inverseMatrix.getInverse( matrixWorld );
				ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );

				// Check boundingBox before continuing

				if ( geometry.boundingBox !== null ) {

					if ( ray.intersectsBox( geometry.boundingBox ) === false ) return;

				}

				var intersection;

				if ( geometry.isBufferGeometry ) {

					var a, b, c;
					var index = geometry.index;
					var position = geometry.attributes.position;
					var uv = geometry.attributes.uv;
					var i, l;

					if ( index !== null ) {

						// indexed buffer geometry

						for ( i = 0, l = index.count; i < l; i += 3 ) {

							a = index.getX( i );
							b = index.getX( i + 1 );
							c = index.getX( i + 2 );

							intersection = checkBufferGeometryIntersection( this, raycaster, ray, position, uv, a, b, c );

							if ( intersection ) {

								intersection.faceIndex = Math.floor( i / 3 ); // triangle number in indices buffer semantics
								intersects.push( intersection );

							}

						}

					} else {

						// non-indexed buffer geometry

						for ( i = 0, l = position.count; i < l; i += 3 ) {

							a = i;
							b = i + 1;
							c = i + 2;

							intersection = checkBufferGeometryIntersection( this, raycaster, ray, position, uv, a, b, c );

							if ( intersection ) {

								intersection.index = a; // triangle number in positions buffer semantics
								intersects.push( intersection );

							}

						}

					}

				} else if ( geometry.isGeometry ) {

					var fvA, fvB, fvC;
					var isMultiMaterial = Array.isArray( material );

					var vertices = geometry.vertices;
					var faces = geometry.faces;
					var uvs;

					var faceVertexUvs = geometry.faceVertexUvs[ 0 ];
					if ( faceVertexUvs.length > 0 ) uvs = faceVertexUvs;

					for ( var f = 0, fl = faces.length; f < fl; f ++ ) {

						var face = faces[ f ];
						var faceMaterial = isMultiMaterial ? material[ face.materialIndex ] : material;

						if ( faceMaterial === undefined ) continue;

						fvA = vertices[ face.a ];
						fvB = vertices[ face.b ];
						fvC = vertices[ face.c ];

						if ( faceMaterial.morphTargets === true ) {

							var morphTargets = geometry.morphTargets;
							var morphInfluences = this.morphTargetInfluences;

							vA.set( 0, 0, 0 );
							vB.set( 0, 0, 0 );
							vC.set( 0, 0, 0 );

							for ( var t = 0, tl = morphTargets.length; t < tl; t ++ ) {

								var influence = morphInfluences[ t ];

								if ( influence === 0 ) continue;

								var targets = morphTargets[ t ].vertices;

								vA.addScaledVector( tempA.subVectors( targets[ face.a ], fvA ), influence );
								vB.addScaledVector( tempB.subVectors( targets[ face.b ], fvB ), influence );
								vC.addScaledVector( tempC.subVectors( targets[ face.c ], fvC ), influence );

							}

							vA.add( fvA );
							vB.add( fvB );
							vC.add( fvC );

							fvA = vA;
							fvB = vB;
							fvC = vC;

						}

						intersection = checkIntersection( this, faceMaterial, raycaster, ray, fvA, fvB, fvC, intersectionPoint );

						if ( intersection ) {

							if ( uvs && uvs[ f ] ) {

								var uvs_f = uvs[ f ];
								uvA.copy( uvs_f[ 0 ] );
								uvB.copy( uvs_f[ 1 ] );
								uvC.copy( uvs_f[ 2 ] );

								intersection.uv = uvIntersection( intersectionPoint, fvA, fvB, fvC, uvA, uvB, uvC );

							}

							intersection.face = face;
							intersection.faceIndex = f;
							intersects.push( intersection );

						}

					}

				}

			};

		}() ),

		clone: function () {

			return new this.constructor( this.geometry, this.material ).copy( this );

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLBackground( renderer, state, geometries, premultipliedAlpha ) {

		var clearColor = new Color( 0x000000 );
		var clearAlpha = 0;

		var planeCamera, planeMesh;
		var boxMesh;

		function render( renderList, scene, camera, forceClear ) {

			var background = scene.background;

			if ( background === null ) {

				setClear( clearColor, clearAlpha );

			} else if ( background && background.isColor ) {

				setClear( background, 1 );
				forceClear = true;

			}

			if ( renderer.autoClear || forceClear ) {

				renderer.clear( renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil );

			}

			if ( background && background.isCubeTexture ) {

				if ( boxMesh === undefined ) {

					boxMesh = new Mesh(
						new BoxBufferGeometry( 1, 1, 1 ),
						new ShaderMaterial( {
							uniforms: ShaderLib.cube.uniforms,
							vertexShader: ShaderLib.cube.vertexShader,
							fragmentShader: ShaderLib.cube.fragmentShader,
							side: BackSide,
							depthTest: true,
							depthWrite: false,
							polygonOffset: true,
							fog: false
						} )
					);

					boxMesh.geometry.removeAttribute( 'normal' );
					boxMesh.geometry.removeAttribute( 'uv' );

					boxMesh.onBeforeRender = function ( renderer, scene, camera ) {

						var scale = camera.far;

						this.matrixWorld.makeScale( scale, scale, scale );
						this.matrixWorld.copyPosition( camera.matrixWorld );

						this.material.polygonOffsetUnits = scale * 10;

					};

					geometries.update( boxMesh.geometry );

				}

				boxMesh.material.uniforms.tCube.value = background;

				renderList.push( boxMesh, boxMesh.geometry, boxMesh.material, 0, null );

			} else if ( background && background.isTexture ) {

				if ( planeCamera === undefined ) {

					planeCamera = new OrthographicCamera( - 1, 1, 1, - 1, 0, 1 );

					planeMesh = new Mesh(
						new PlaneBufferGeometry( 2, 2 ),
						new MeshBasicMaterial( { depthTest: false, depthWrite: false, fog: false } )
					);

					geometries.update( planeMesh.geometry );

				}

				planeMesh.material.map = background;

				// TODO Push this to renderList

				renderer.renderBufferDirect( planeCamera, null, planeMesh.geometry, planeMesh.material, planeMesh, null );

			}

		}

		function setClear( color, alpha ) {

			state.buffers.color.setClear( color.r, color.g, color.b, alpha, premultipliedAlpha );

		}

		return {

			getClearColor: function () {

				return clearColor;

			},
			setClearColor: function ( color, alpha ) {

				clearColor.set( color );
				clearAlpha = alpha !== undefined ? alpha : 1;
				setClear( clearColor, clearAlpha );

			},
			getClearAlpha: function () {

				return clearAlpha;

			},
			setClearAlpha: function ( alpha ) {

				clearAlpha = alpha;
				setClear( clearColor, clearAlpha );

			},
			render: render

		};

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function painterSortStable( a, b ) {

		if ( a.renderOrder !== b.renderOrder ) {

			return a.renderOrder - b.renderOrder;

		} else if ( a.program && b.program && a.program !== b.program ) {

			return a.program.id - b.program.id;

		} else if ( a.material.id !== b.material.id ) {

			return a.material.id - b.material.id;

		} else if ( a.z !== b.z ) {

			return a.z - b.z;

		} else {

			return a.id - b.id;

		}

	}

	function reversePainterSortStable( a, b ) {

		if ( a.renderOrder !== b.renderOrder ) {

			return a.renderOrder - b.renderOrder;

		} if ( a.z !== b.z ) {

			return b.z - a.z;

		} else {

			return a.id - b.id;

		}

	}

	function WebGLRenderList() {

		var renderItems = [];
		var renderItemsIndex = 0;

		var opaque = [];
		var transparent = [];

		function init() {

			renderItemsIndex = 0;

			opaque.length = 0;
			transparent.length = 0;

		}

		function push( object, geometry, material, z, group ) {

			var renderItem = renderItems[ renderItemsIndex ];

			if ( renderItem === undefined ) {

				renderItem = {
					id: object.id,
					object: object,
					geometry: geometry,
					material: material,
					program: material.program,
					renderOrder: object.renderOrder,
					z: z,
					group: group
				};

				renderItems[ renderItemsIndex ] = renderItem;

			} else {

				renderItem.id = object.id;
				renderItem.object = object;
				renderItem.geometry = geometry;
				renderItem.material = material;
				renderItem.program = material.program;
				renderItem.renderOrder = object.renderOrder;
				renderItem.z = z;
				renderItem.group = group;

			}

			( material.transparent === true ? transparent : opaque ).push( renderItem );

			renderItemsIndex ++;

		}

		function sort() {

			if ( opaque.length > 1 ) opaque.sort( painterSortStable );
			if ( transparent.length > 1 ) transparent.sort( reversePainterSortStable );

		}

		return {
			opaque: opaque,
			transparent: transparent,

			init: init,
			push: push,

			sort: sort
		};

	}

	function WebGLRenderLists() {

		var lists = {};

		function get( scene, camera ) {

			var hash = scene.id + ',' + camera.id;
			var list = lists[ hash ];

			if ( list === undefined ) {

				// console.log( 'THREE.WebGLRenderLists:', hash );

				list = new WebGLRenderList();
				lists[ hash ] = list;

			}

			return list;

		}

		function dispose() {

			lists = {};

		}

		return {
			get: get,
			dispose: dispose
		};

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function absNumericalSort( a, b ) {

		return Math.abs( b[ 1 ] ) - Math.abs( a[ 1 ] );

	}

	function WebGLMorphtargets( gl ) {

		var influencesList = {};
		var morphInfluences = new Float32Array( 8 );

		function update( object, geometry, material, program ) {

			var objectInfluences = object.morphTargetInfluences;

			var length = objectInfluences.length;

			var influences = influencesList[ geometry.id ];

			if ( influences === undefined ) {

				// initialise list

				influences = [];

				for ( var i = 0; i < length; i ++ ) {

					influences[ i ] = [ i, 0 ];

				}

				influencesList[ geometry.id ] = influences;

			}

			var morphTargets = material.morphTargets && geometry.morphAttributes.position;
			var morphNormals = material.morphNormals && geometry.morphAttributes.normal;

			// Remove current morphAttributes

			for ( var i = 0; i < length; i ++ ) {

				var influence = influences[ i ];

				if ( influence[ 1 ] !== 0 ) {

					if ( morphTargets ) geometry.removeAttribute( 'morphTarget' + i );
					if ( morphNormals ) geometry.removeAttribute( 'morphNormal' + i );

				}

			}

			// Collect influences

			for ( var i = 0; i < length; i ++ ) {

				var influence = influences[ i ];

				influence[ 0 ] = i;
				influence[ 1 ] = objectInfluences[ i ];

			}

			influences.sort( absNumericalSort );

			// Add morphAttributes

			for ( var i = 0; i < 8; i ++ ) {

				var influence = influences[ i ];

				if ( influence ) {

					var index = influence[ 0 ];
					var value = influence[ 1 ];

					if ( value ) {

						if ( morphTargets ) geometry.addAttribute( 'morphTarget' + i, morphTargets[ index ] );
						if ( morphNormals ) geometry.addAttribute( 'morphNormal' + i, morphNormals[ index ] );

						morphInfluences[ i ] = value;
						continue;

					}

				}

				morphInfluences[ i ] = 0;

			}

			program.getUniforms().setValue( gl, 'morphTargetInfluences', morphInfluences );

		}

		return {

			update: update

		}

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLIndexedBufferRenderer( gl, extensions, infoRender ) {

		var mode;

		function setMode( value ) {

			mode = value;

		}

		var type, bytesPerElement;

		function setIndex( value ) {

			type = value.type;
			bytesPerElement = value.bytesPerElement;

		}

		function render( start, count ) {

			gl.drawElements( mode, count, type, start * bytesPerElement );

			infoRender.calls ++;
			infoRender.vertices += count;

			if ( mode === gl.TRIANGLES ) infoRender.faces += count / 3;
			else if ( mode === gl.POINTS ) infoRender.points += count;

		}

		function renderInstances( geometry, start, count ) {

			var extension = extensions.get( 'ANGLE_instanced_arrays' );

			if ( extension === null ) {

				console.error( 'THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.' );
				return;

			}

			extension.drawElementsInstancedANGLE( mode, count, type, start * bytesPerElement, geometry.maxInstancedCount );

			infoRender.calls ++;
			infoRender.vertices += count * geometry.maxInstancedCount;

			if ( mode === gl.TRIANGLES ) infoRender.faces += geometry.maxInstancedCount * count / 3;
			else if ( mode === gl.POINTS ) infoRender.points += geometry.maxInstancedCount * count;

		}

		//

		this.setMode = setMode;
		this.setIndex = setIndex;
		this.render = render;
		this.renderInstances = renderInstances;

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLBufferRenderer( gl, extensions, infoRender ) {

		var mode;

		function setMode( value ) {

			mode = value;

		}

		function render( start, count ) {

			gl.drawArrays( mode, start, count );

			infoRender.calls ++;
			infoRender.vertices += count;

			if ( mode === gl.TRIANGLES ) infoRender.faces += count / 3;
			else if ( mode === gl.POINTS ) infoRender.points += count;

		}

		function renderInstances( geometry, start, count ) {

			var extension = extensions.get( 'ANGLE_instanced_arrays' );

			if ( extension === null ) {

				console.error( 'THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.' );
				return;

			}

			var position = geometry.attributes.position;

			if ( position.isInterleavedBufferAttribute ) {

				count = position.data.count;

				extension.drawArraysInstancedANGLE( mode, 0, count, geometry.maxInstancedCount );

			} else {

				extension.drawArraysInstancedANGLE( mode, start, count, geometry.maxInstancedCount );

			}

			infoRender.calls ++;
			infoRender.vertices += count * geometry.maxInstancedCount;

			if ( mode === gl.TRIANGLES ) infoRender.faces += geometry.maxInstancedCount * count / 3;
			else if ( mode === gl.POINTS ) infoRender.points += geometry.maxInstancedCount * count;

		}

		//

		this.setMode = setMode;
		this.render = render;
		this.renderInstances = renderInstances;

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLGeometries( gl, attributes, infoMemory ) {

		var geometries = {};
		var wireframeAttributes = {};

		function onGeometryDispose( event ) {

			var geometry = event.target;
			var buffergeometry = geometries[ geometry.id ];

			if ( buffergeometry.index !== null ) {

				attributes.remove( buffergeometry.index );

			}

			for ( var name in buffergeometry.attributes ) {

				attributes.remove( buffergeometry.attributes[ name ] );

			}

			geometry.removeEventListener( 'dispose', onGeometryDispose );

			delete geometries[ geometry.id ];

			// TODO Remove duplicate code

			var attribute = wireframeAttributes[ geometry.id ];

			if ( attribute ) {

				attributes.remove( attribute );
				delete wireframeAttributes[ geometry.id ];

			}

			attribute = wireframeAttributes[ buffergeometry.id ];

			if ( attribute ) {

				attributes.remove( attribute );
				delete wireframeAttributes[ buffergeometry.id ];

			}

			//

			infoMemory.geometries --;

		}

		function get( object, geometry ) {

			var buffergeometry = geometries[ geometry.id ];

			if ( buffergeometry ) return buffergeometry;

			geometry.addEventListener( 'dispose', onGeometryDispose );

			if ( geometry.isBufferGeometry ) {

				buffergeometry = geometry;

			} else if ( geometry.isGeometry ) {

				if ( geometry._bufferGeometry === undefined ) {

					geometry._bufferGeometry = new BufferGeometry().setFromObject( object );

				}

				buffergeometry = geometry._bufferGeometry;

			}

			geometries[ geometry.id ] = buffergeometry;

			infoMemory.geometries ++;

			return buffergeometry;

		}

		function update( geometry ) {

			var index = geometry.index;
			var geometryAttributes = geometry.attributes;

			if ( index !== null ) {

				attributes.update( index, gl.ELEMENT_ARRAY_BUFFER );

			}

			for ( var name in geometryAttributes ) {

				attributes.update( geometryAttributes[ name ], gl.ARRAY_BUFFER );

			}

			// morph targets

			var morphAttributes = geometry.morphAttributes;

			for ( var name in morphAttributes ) {

				var array = morphAttributes[ name ];

				for ( var i = 0, l = array.length; i < l; i ++ ) {

					attributes.update( array[ i ], gl.ARRAY_BUFFER );

				}

			}

		}

		function getWireframeAttribute( geometry ) {

			var attribute = wireframeAttributes[ geometry.id ];

			if ( attribute ) return attribute;

			var indices = [];

			var geometryIndex = geometry.index;
			var geometryAttributes = geometry.attributes;

			// console.time( 'wireframe' );

			if ( geometryIndex !== null ) {

				var array = geometryIndex.array;

				for ( var i = 0, l = array.length; i < l; i += 3 ) {

					var a = array[ i + 0 ];
					var b = array[ i + 1 ];
					var c = array[ i + 2 ];

					indices.push( a, b, b, c, c, a );

				}

			} else {

				var array = geometryAttributes.position.array;

				for ( var i = 0, l = ( array.length / 3 ) - 1; i < l; i += 3 ) {

					var a = i + 0;
					var b = i + 1;
					var c = i + 2;

					indices.push( a, b, b, c, c, a );

				}

			}

			// console.timeEnd( 'wireframe' );

			attribute = new ( arrayMax( indices ) > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute )( indices, 1 );

			attributes.update( attribute, gl.ELEMENT_ARRAY_BUFFER );

			wireframeAttributes[ geometry.id ] = attribute;

			return attribute;

		}

		return {

			get: get,
			update: update,

			getWireframeAttribute: getWireframeAttribute

		};

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function UniformsCache() {

		var lights = {};

		return {

			get: function ( light ) {

				if ( lights[ light.id ] !== undefined ) {

					return lights[ light.id ];

				}

				var uniforms;

				switch ( light.type ) {

					case 'DirectionalLight':
						uniforms = {
							direction: new Vector3(),
							color: new Color(),

							shadow: false,
							shadowBias: 0,
							shadowRadius: 1,
							shadowMapSize: new Vector2()
						};
						break;

					case 'SpotLight':
						uniforms = {
							position: new Vector3(),
							direction: new Vector3(),
							color: new Color(),
							distance: 0,
							coneCos: 0,
							penumbraCos: 0,
							decay: 0,

							shadow: false,
							shadowBias: 0,
							shadowRadius: 1,
							shadowMapSize: new Vector2()
						};
						break;

					case 'PointLight':
						uniforms = {
							position: new Vector3(),
							color: new Color(),
							distance: 0,
							decay: 0,

							shadow: false,
							shadowBias: 0,
							shadowRadius: 1,
							shadowMapSize: new Vector2(),
							shadowCameraNear: 1,
							shadowCameraFar: 1000
						};
						break;

					case 'HemisphereLight':
						uniforms = {
							direction: new Vector3(),
							skyColor: new Color(),
							groundColor: new Color()
						};
						break;

					case 'RectAreaLight':
						uniforms = {
							color: new Color(),
							position: new Vector3(),
							halfWidth: new Vector3(),
							halfHeight: new Vector3()
							// TODO (abelnation): set RectAreaLight shadow uniforms
						};
						break;

				}

				lights[ light.id ] = uniforms;

				return uniforms;

			}

		};

	}

	function WebGLLights() {

		var cache = new UniformsCache();

		var state = {

			hash: '',

			ambient: [ 0, 0, 0 ],
			directional: [],
			directionalShadowMap: [],
			directionalShadowMatrix: [],
			spot: [],
			spotShadowMap: [],
			spotShadowMatrix: [],
			rectArea: [],
			point: [],
			pointShadowMap: [],
			pointShadowMatrix: [],
			hemi: []

		};

		var vector3 = new Vector3();
		var matrix4 = new Matrix4();
		var matrix42 = new Matrix4();

		function setup( lights, shadows, camera ) {

			var r = 0, g = 0, b = 0;

			var directionalLength = 0;
			var pointLength = 0;
			var spotLength = 0;
			var rectAreaLength = 0;
			var hemiLength = 0;

			var viewMatrix = camera.matrixWorldInverse;

			for ( var i = 0, l = lights.length; i < l; i ++ ) {

				var light = lights[ i ];

				var color = light.color;
				var intensity = light.intensity;
				var distance = light.distance;

				var shadowMap = ( light.shadow && light.shadow.map ) ? light.shadow.map.texture : null;

				if ( light.isAmbientLight ) {

					r += color.r * intensity;
					g += color.g * intensity;
					b += color.b * intensity;

				} else if ( light.isDirectionalLight ) {

					var uniforms = cache.get( light );

					uniforms.color.copy( light.color ).multiplyScalar( light.intensity );
					uniforms.direction.setFromMatrixPosition( light.matrixWorld );
					vector3.setFromMatrixPosition( light.target.matrixWorld );
					uniforms.direction.sub( vector3 );
					uniforms.direction.transformDirection( viewMatrix );

					uniforms.shadow = light.castShadow;

					if ( light.castShadow ) {

						var shadow = light.shadow;

						uniforms.shadowBias = shadow.bias;
						uniforms.shadowRadius = shadow.radius;
						uniforms.shadowMapSize = shadow.mapSize;

					}

					state.directionalShadowMap[ directionalLength ] = shadowMap;
					state.directionalShadowMatrix[ directionalLength ] = light.shadow.matrix;
					state.directional[ directionalLength ] = uniforms;

					directionalLength ++;

				} else if ( light.isSpotLight ) {

					var uniforms = cache.get( light );

					uniforms.position.setFromMatrixPosition( light.matrixWorld );
					uniforms.position.applyMatrix4( viewMatrix );

					uniforms.color.copy( color ).multiplyScalar( intensity );
					uniforms.distance = distance;

					uniforms.direction.setFromMatrixPosition( light.matrixWorld );
					vector3.setFromMatrixPosition( light.target.matrixWorld );
					uniforms.direction.sub( vector3 );
					uniforms.direction.transformDirection( viewMatrix );

					uniforms.coneCos = Math.cos( light.angle );
					uniforms.penumbraCos = Math.cos( light.angle * ( 1 - light.penumbra ) );
					uniforms.decay = ( light.distance === 0 ) ? 0.0 : light.decay;

					uniforms.shadow = light.castShadow;

					if ( light.castShadow ) {

						var shadow = light.shadow;

						uniforms.shadowBias = shadow.bias;
						uniforms.shadowRadius = shadow.radius;
						uniforms.shadowMapSize = shadow.mapSize;

					}

					state.spotShadowMap[ spotLength ] = shadowMap;
					state.spotShadowMatrix[ spotLength ] = light.shadow.matrix;
					state.spot[ spotLength ] = uniforms;

					spotLength ++;

				} else if ( light.isRectAreaLight ) {

					var uniforms = cache.get( light );

					// (a) intensity controls irradiance of entire light
					uniforms.color
						.copy( color )
						.multiplyScalar( intensity / ( light.width * light.height ) );

					// (b) intensity controls the radiance per light area
					// uniforms.color.copy( color ).multiplyScalar( intensity );

					uniforms.position.setFromMatrixPosition( light.matrixWorld );
					uniforms.position.applyMatrix4( viewMatrix );

					// extract local rotation of light to derive width/height half vectors
					matrix42.identity();
					matrix4.copy( light.matrixWorld );
					matrix4.premultiply( viewMatrix );
					matrix42.extractRotation( matrix4 );

					uniforms.halfWidth.set( light.width * 0.5,                0.0, 0.0 );
					uniforms.halfHeight.set(              0.0, light.height * 0.5, 0.0 );

					uniforms.halfWidth.applyMatrix4( matrix42 );
					uniforms.halfHeight.applyMatrix4( matrix42 );

					// TODO (abelnation): RectAreaLight distance?
					// uniforms.distance = distance;

					state.rectArea[ rectAreaLength ] = uniforms;

					rectAreaLength ++;

				} else if ( light.isPointLight ) {

					var uniforms = cache.get( light );

					uniforms.position.setFromMatrixPosition( light.matrixWorld );
					uniforms.position.applyMatrix4( viewMatrix );

					uniforms.color.copy( light.color ).multiplyScalar( light.intensity );
					uniforms.distance = light.distance;
					uniforms.decay = ( light.distance === 0 ) ? 0.0 : light.decay;

					uniforms.shadow = light.castShadow;

					if ( light.castShadow ) {

						var shadow = light.shadow;

						uniforms.shadowBias = shadow.bias;
						uniforms.shadowRadius = shadow.radius;
						uniforms.shadowMapSize = shadow.mapSize;
						uniforms.shadowCameraNear = shadow.camera.near;
						uniforms.shadowCameraFar = shadow.camera.far;

					}

					state.pointShadowMap[ pointLength ] = shadowMap;
					state.pointShadowMatrix[ pointLength ] = light.shadow.matrix;
					state.point[ pointLength ] = uniforms;

					pointLength ++;

				} else if ( light.isHemisphereLight ) {

					var uniforms = cache.get( light );

					uniforms.direction.setFromMatrixPosition( light.matrixWorld );
					uniforms.direction.transformDirection( viewMatrix );
					uniforms.direction.normalize();

					uniforms.skyColor.copy( light.color ).multiplyScalar( intensity );
					uniforms.groundColor.copy( light.groundColor ).multiplyScalar( intensity );

					state.hemi[ hemiLength ] = uniforms;

					hemiLength ++;

				}

			}

			state.ambient[ 0 ] = r;
			state.ambient[ 1 ] = g;
			state.ambient[ 2 ] = b;

			state.directional.length = directionalLength;
			state.spot.length = spotLength;
			state.rectArea.length = rectAreaLength;
			state.point.length = pointLength;
			state.hemi.length = hemiLength;

			// TODO (sam-g-steel) why aren't we using join
			state.hash = directionalLength + ',' + pointLength + ',' + spotLength + ',' + rectAreaLength + ',' + hemiLength + ',' + shadows.length;

		}

		return {
			setup: setup,
			state: state
		}

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLObjects( geometries, infoRender ) {

		var updateList = {};

		function update( object ) {

			var frame = infoRender.frame;

			var geometry = object.geometry;
			var buffergeometry = geometries.get( object, geometry );

			// Update once per frame

			if ( updateList[ buffergeometry.id ] !== frame ) {

				if ( geometry.isGeometry ) {

					buffergeometry.updateFromObject( object );

				}

				geometries.update( buffergeometry );

				updateList[ buffergeometry.id ] = frame;

			}

			return buffergeometry;

		}

		function clear() {

			updateList = {};

		}

		return {

			update: update,
			clear: clear

		};

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function addLineNumbers( string ) {

		var lines = string.split( '\n' );

		for ( var i = 0; i < lines.length; i ++ ) {

			lines[ i ] = ( i + 1 ) + ': ' + lines[ i ];

		}

		return lines.join( '\n' );

	}

	function WebGLShader( gl, type, string ) {

		var shader = gl.createShader( type );

		gl.shaderSource( shader, string );
		gl.compileShader( shader );

		if ( gl.getShaderParameter( shader, gl.COMPILE_STATUS ) === false ) {

			console.error( 'THREE.WebGLShader: Shader couldn\'t compile.' );

		}

		if ( gl.getShaderInfoLog( shader ) !== '' ) {

			console.warn( 'THREE.WebGLShader: gl.getShaderInfoLog()', type === gl.VERTEX_SHADER ? 'vertex' : 'fragment', gl.getShaderInfoLog( shader ), addLineNumbers( string ) );

		}

		// --enable-privileged-webgl-extension
		// console.log( type, gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );

		return shader;

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	var programIdCount = 0;

	function getEncodingComponents( encoding ) {

		switch ( encoding ) {

			case LinearEncoding:
				return [ 'Linear','( value )' ];
			case sRGBEncoding:
				return [ 'sRGB','( value )' ];
			case RGBEEncoding:
				return [ 'RGBE','( value )' ];
			case RGBM7Encoding:
				return [ 'RGBM','( value, 7.0 )' ];
			case RGBM16Encoding:
				return [ 'RGBM','( value, 16.0 )' ];
			case RGBDEncoding:
				return [ 'RGBD','( value, 256.0 )' ];
			case GammaEncoding:
				return [ 'Gamma','( value, float( GAMMA_FACTOR ) )' ];
			default:
				throw new Error( 'unsupported encoding: ' + encoding );

		}

	}

	function getTexelDecodingFunction( functionName, encoding ) {

		var components = getEncodingComponents( encoding );
		return "vec4 " + functionName + "( vec4 value ) { return " + components[ 0 ] + "ToLinear" + components[ 1 ] + "; }";

	}

	function getTexelEncodingFunction( functionName, encoding ) {

		var components = getEncodingComponents( encoding );
		return "vec4 " + functionName + "( vec4 value ) { return LinearTo" + components[ 0 ] + components[ 1 ] + "; }";

	}

	function getToneMappingFunction( functionName, toneMapping ) {

		var toneMappingName;

		switch ( toneMapping ) {

			case LinearToneMapping:
				toneMappingName = "Linear";
				break;

			case ReinhardToneMapping:
				toneMappingName = "Reinhard";
				break;

			case Uncharted2ToneMapping:
				toneMappingName = "Uncharted2";
				break;

			case CineonToneMapping:
				toneMappingName = "OptimizedCineon";
				break;

			default:
				throw new Error( 'unsupported toneMapping: ' + toneMapping );

		}

		return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";

	}

	function generateExtensions( extensions, parameters, rendererExtensions ) {

		extensions = extensions || {};

		var chunks = [
			( extensions.derivatives || parameters.envMapCubeUV || parameters.bumpMap || parameters.normalMap || parameters.flatShading ) ? '#extension GL_OES_standard_derivatives : enable' : '',
			( extensions.fragDepth || parameters.logarithmicDepthBuffer ) && rendererExtensions.get( 'EXT_frag_depth' ) ? '#extension GL_EXT_frag_depth : enable' : '',
			( extensions.drawBuffers ) && rendererExtensions.get( 'WEBGL_draw_buffers' ) ? '#extension GL_EXT_draw_buffers : require' : '',
			( extensions.shaderTextureLOD || parameters.envMap ) && rendererExtensions.get( 'EXT_shader_texture_lod' ) ? '#extension GL_EXT_shader_texture_lod : enable' : ''
		];

		return chunks.filter( filterEmptyLine ).join( '\n' );

	}

	function generateDefines( defines ) {

		var chunks = [];

		for ( var name in defines ) {

			var value = defines[ name ];

			if ( value === false ) continue;

			chunks.push( '#define ' + name + ' ' + value );

		}

		return chunks.join( '\n' );

	}

	function fetchAttributeLocations( gl, program, identifiers ) {

		var attributes = {};

		var n = gl.getProgramParameter( program, gl.ACTIVE_ATTRIBUTES );

		for ( var i = 0; i < n; i ++ ) {

			var info = gl.getActiveAttrib( program, i );
			var name = info.name;

			// console.log("THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:", name, i );

			attributes[ name ] = gl.getAttribLocation( program, name );

		}

		return attributes;

	}

	function filterEmptyLine( string ) {

		return string !== '';

	}

	function replaceLightNums( string, parameters ) {

		return string
			.replace( /NUM_DIR_LIGHTS/g, parameters.numDirLights )
			.replace( /NUM_SPOT_LIGHTS/g, parameters.numSpotLights )
			.replace( /NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights )
			.replace( /NUM_POINT_LIGHTS/g, parameters.numPointLights )
			.replace( /NUM_HEMI_LIGHTS/g, parameters.numHemiLights );

	}

	function parseIncludes( string ) {

		var pattern = /^[ \t]*#include +<([\w\d.]+)>/gm;

		function replace( match, include ) {

			var replace = ShaderChunk[ include ];

			if ( replace === undefined ) {

				throw new Error( 'Can not resolve #include <' + include + '>' );

			}

			return parseIncludes( replace );

		}

		return string.replace( pattern, replace );

	}

	function unrollLoops( string ) {

		var pattern = /for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;

		function replace( match, start, end, snippet ) {

			var unroll = '';

			for ( var i = parseInt( start ); i < parseInt( end ); i ++ ) {

				unroll += snippet.replace( /\[ i \]/g, '[ ' + i + ' ]' );

			}

			return unroll;

		}

		return string.replace( pattern, replace );

	}

	function WebGLProgram( renderer, extensions, code, material, shader, parameters ) {

		var gl = renderer.context;

		var defines = material.defines;

		var vertexShader = shader.vertexShader;
		var fragmentShader = shader.fragmentShader;

		var shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';

		if ( parameters.shadowMapType === PCFShadowMap ) {

			shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';

		} else if ( parameters.shadowMapType === PCFSoftShadowMap ) {

			shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';

		}

		var envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
		var envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
		var envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';

		if ( parameters.envMap ) {

			switch ( material.envMap.mapping ) {

				case CubeReflectionMapping:
				case CubeRefractionMapping:
					envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
					break;

				case CubeUVReflectionMapping:
				case CubeUVRefractionMapping:
					envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
					break;

				case EquirectangularReflectionMapping:
				case EquirectangularRefractionMapping:
					envMapTypeDefine = 'ENVMAP_TYPE_EQUIREC';
					break;

				case SphericalReflectionMapping:
					envMapTypeDefine = 'ENVMAP_TYPE_SPHERE';
					break;

			}

			switch ( material.envMap.mapping ) {

				case CubeRefractionMapping:
				case EquirectangularRefractionMapping:
					envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
					break;

			}

			switch ( material.combine ) {

				case MultiplyOperation:
					envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
					break;

				case MixOperation:
					envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
					break;

				case AddOperation:
					envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
					break;

			}

		}

		var gammaFactorDefine = ( renderer.gammaFactor > 0 ) ? renderer.gammaFactor : 1.0;

		// console.log( 'building new program ' );

		//

		var customExtensions = generateExtensions( material.extensions, parameters, extensions );

		var customDefines = generateDefines( defines );

		//

		var program = gl.createProgram();

		var prefixVertex, prefixFragment;

		if ( material.isRawShaderMaterial ) {

			prefixVertex = [

				customDefines,

				'\n'

			].filter( filterEmptyLine ).join( '\n' );

			prefixFragment = [

				customExtensions,
				customDefines,

				'\n'

			].filter( filterEmptyLine ).join( '\n' );

		} else {

			prefixVertex = [

				'precision ' + parameters.precision + ' float;',
				'precision ' + parameters.precision + ' int;',

				'#define SHADER_NAME ' + shader.name,

				customDefines,

				parameters.supportsVertexTextures ? '#define VERTEX_TEXTURES' : '',

				'#define GAMMA_FACTOR ' + gammaFactorDefine,

				'#define MAX_BONES ' + parameters.maxBones,
				( parameters.useFog && parameters.fog ) ? '#define USE_FOG' : '',
				( parameters.useFog && parameters.fogExp ) ? '#define FOG_EXP2' : '',

				parameters.map ? '#define USE_MAP' : '',
				parameters.envMap ? '#define USE_ENVMAP' : '',
				parameters.envMap ? '#define ' + envMapModeDefine : '',
				parameters.lightMap ? '#define USE_LIGHTMAP' : '',
				parameters.aoMap ? '#define USE_AOMAP' : '',
				parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
				parameters.bumpMap ? '#define USE_BUMPMAP' : '',
				parameters.normalMap ? '#define USE_NORMALMAP' : '',
				parameters.displacementMap && parameters.supportsVertexTextures ? '#define USE_DISPLACEMENTMAP' : '',
				parameters.specularMap ? '#define USE_SPECULARMAP' : '',
				parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
				parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
				parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
				parameters.vertexColors ? '#define USE_COLOR' : '',

				parameters.flatShading ? '#define FLAT_SHADED' : '',

				parameters.skinning ? '#define USE_SKINNING' : '',
				parameters.useVertexTexture ? '#define BONE_TEXTURE' : '',

				parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
				parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
				parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
				parameters.flipSided ? '#define FLIP_SIDED' : '',

				'#define NUM_CLIPPING_PLANES ' + parameters.numClippingPlanes,

				parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
				parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',

				parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',

				parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
				parameters.logarithmicDepthBuffer && extensions.get( 'EXT_frag_depth' ) ? '#define USE_LOGDEPTHBUF_EXT' : '',

				'uniform mat4 modelMatrix;',
				'uniform mat4 modelViewMatrix;',
				'uniform mat4 projectionMatrix;',
				'uniform mat4 viewMatrix;',
				'uniform mat3 normalMatrix;',
				'uniform vec3 cameraPosition;',

				'attribute vec3 position;',
				'attribute vec3 normal;',
				'attribute vec2 uv;',

				'#ifdef USE_COLOR',

				'	attribute vec3 color;',

				'#endif',

				'#ifdef USE_MORPHTARGETS',

				'	attribute vec3 morphTarget0;',
				'	attribute vec3 morphTarget1;',
				'	attribute vec3 morphTarget2;',
				'	attribute vec3 morphTarget3;',

				'	#ifdef USE_MORPHNORMALS',

				'		attribute vec3 morphNormal0;',
				'		attribute vec3 morphNormal1;',
				'		attribute vec3 morphNormal2;',
				'		attribute vec3 morphNormal3;',

				'	#else',

				'		attribute vec3 morphTarget4;',
				'		attribute vec3 morphTarget5;',
				'		attribute vec3 morphTarget6;',
				'		attribute vec3 morphTarget7;',

				'	#endif',

				'#endif',

				'#ifdef USE_SKINNING',

				'	attribute vec4 skinIndex;',
				'	attribute vec4 skinWeight;',

				'#endif',

				'\n'

			].filter( filterEmptyLine ).join( '\n' );

			prefixFragment = [

				customExtensions,

				'precision ' + parameters.precision + ' float;',
				'precision ' + parameters.precision + ' int;',

				'#define SHADER_NAME ' + shader.name,

				customDefines,

				parameters.alphaTest ? '#define ALPHATEST ' + parameters.alphaTest : '',

				'#define GAMMA_FACTOR ' + gammaFactorDefine,

				( parameters.useFog && parameters.fog ) ? '#define USE_FOG' : '',
				( parameters.useFog && parameters.fogExp ) ? '#define FOG_EXP2' : '',

				parameters.map ? '#define USE_MAP' : '',
				parameters.envMap ? '#define USE_ENVMAP' : '',
				parameters.envMap ? '#define ' + envMapTypeDefine : '',
				parameters.envMap ? '#define ' + envMapModeDefine : '',
				parameters.envMap ? '#define ' + envMapBlendingDefine : '',
				parameters.lightMap ? '#define USE_LIGHTMAP' : '',
				parameters.aoMap ? '#define USE_AOMAP' : '',
				parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
				parameters.bumpMap ? '#define USE_BUMPMAP' : '',
				parameters.normalMap ? '#define USE_NORMALMAP' : '',
				parameters.specularMap ? '#define USE_SPECULARMAP' : '',
				parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
				parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
				parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
				parameters.vertexColors ? '#define USE_COLOR' : '',

				parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',

				parameters.flatShading ? '#define FLAT_SHADED' : '',

				parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
				parameters.flipSided ? '#define FLIP_SIDED' : '',

				'#define NUM_CLIPPING_PLANES ' + parameters.numClippingPlanes,
				'#define UNION_CLIPPING_PLANES ' + (parameters.numClippingPlanes - parameters.numClipIntersection),

				parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
				parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',

				parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : '',

				parameters.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : '',

				parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
				parameters.logarithmicDepthBuffer && extensions.get( 'EXT_frag_depth' ) ? '#define USE_LOGDEPTHBUF_EXT' : '',

				parameters.envMap && extensions.get( 'EXT_shader_texture_lod' ) ? '#define TEXTURE_LOD_EXT' : '',

				'uniform mat4 viewMatrix;',
				'uniform vec3 cameraPosition;',

				( parameters.toneMapping !== NoToneMapping ) ? "#define TONE_MAPPING" : '',
				( parameters.toneMapping !== NoToneMapping ) ? ShaderChunk[ 'tonemapping_pars_fragment' ] : '',  // this code is required here because it is used by the toneMapping() function defined below
				( parameters.toneMapping !== NoToneMapping ) ? getToneMappingFunction( "toneMapping", parameters.toneMapping ) : '',

				parameters.dithering ? '#define DITHERING' : '',

				( parameters.outputEncoding || parameters.mapEncoding || parameters.envMapEncoding || parameters.emissiveMapEncoding ) ? ShaderChunk[ 'encodings_pars_fragment' ] : '', // this code is required here because it is used by the various encoding/decoding function defined below
				parameters.mapEncoding ? getTexelDecodingFunction( 'mapTexelToLinear', parameters.mapEncoding ) : '',
				parameters.envMapEncoding ? getTexelDecodingFunction( 'envMapTexelToLinear', parameters.envMapEncoding ) : '',
				parameters.emissiveMapEncoding ? getTexelDecodingFunction( 'emissiveMapTexelToLinear', parameters.emissiveMapEncoding ) : '',
				parameters.outputEncoding ? getTexelEncodingFunction( "linearToOutputTexel", parameters.outputEncoding ) : '',

				parameters.depthPacking ? "#define DEPTH_PACKING " + material.depthPacking : '',

				'\n'

			].filter( filterEmptyLine ).join( '\n' );

		}

		vertexShader = parseIncludes( vertexShader );
		vertexShader = replaceLightNums( vertexShader, parameters );

		fragmentShader = parseIncludes( fragmentShader );
		fragmentShader = replaceLightNums( fragmentShader, parameters );

		if ( ! material.isShaderMaterial ) {

			vertexShader = unrollLoops( vertexShader );
			fragmentShader = unrollLoops( fragmentShader );

		}

		var vertexGlsl = prefixVertex + vertexShader;
		var fragmentGlsl = prefixFragment + fragmentShader;

		// console.log( '*VERTEX*', vertexGlsl );
		// console.log( '*FRAGMENT*', fragmentGlsl );

		var glVertexShader = WebGLShader( gl, gl.VERTEX_SHADER, vertexGlsl );
		var glFragmentShader = WebGLShader( gl, gl.FRAGMENT_SHADER, fragmentGlsl );

		gl.attachShader( program, glVertexShader );
		gl.attachShader( program, glFragmentShader );

		// Force a particular attribute to index 0.

		if ( material.index0AttributeName !== undefined ) {

			gl.bindAttribLocation( program, 0, material.index0AttributeName );

		} else if ( parameters.morphTargets === true ) {

			// programs with morphTargets displace position out of attribute 0
			gl.bindAttribLocation( program, 0, 'position' );

		}

		gl.linkProgram( program );

		var programLog = gl.getProgramInfoLog( program );
		var vertexLog = gl.getShaderInfoLog( glVertexShader );
		var fragmentLog = gl.getShaderInfoLog( glFragmentShader );

		var runnable = true;
		var haveDiagnostics = true;

		// console.log( '**VERTEX**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( glVertexShader ) );
		// console.log( '**FRAGMENT**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( glFragmentShader ) );

		if ( gl.getProgramParameter( program, gl.LINK_STATUS ) === false ) {

			runnable = false;

			console.error( 'THREE.WebGLProgram: shader error: ', gl.getError(), 'gl.VALIDATE_STATUS', gl.getProgramParameter( program, gl.VALIDATE_STATUS ), 'gl.getProgramInfoLog', programLog, vertexLog, fragmentLog );

		} else if ( programLog !== '' ) {

			console.warn( 'THREE.WebGLProgram: gl.getProgramInfoLog()', programLog );

		} else if ( vertexLog === '' || fragmentLog === '' ) {

			haveDiagnostics = false;

		}

		if ( haveDiagnostics ) {

			this.diagnostics = {

				runnable: runnable,
				material: material,

				programLog: programLog,

				vertexShader: {

					log: vertexLog,
					prefix: prefixVertex

				},

				fragmentShader: {

					log: fragmentLog,
					prefix: prefixFragment

				}

			};

		}

		// clean up

		gl.deleteShader( glVertexShader );
		gl.deleteShader( glFragmentShader );

		// set up caching for uniform locations

		var cachedUniforms;

		this.getUniforms = function () {

			if ( cachedUniforms === undefined ) {

				cachedUniforms = new WebGLUniforms( gl, program, renderer );

			}

			return cachedUniforms;

		};

		// set up caching for attribute locations

		var cachedAttributes;

		this.getAttributes = function () {

			if ( cachedAttributes === undefined ) {

				cachedAttributes = fetchAttributeLocations( gl, program );

			}

			return cachedAttributes;

		};

		// free resource

		this.destroy = function() {

			gl.deleteProgram( program );
			this.program = undefined;

		};

		// DEPRECATED

		Object.defineProperties( this, {

			uniforms: {
				get: function() {

					console.warn( 'THREE.WebGLProgram: .uniforms is now .getUniforms().' );
					return this.getUniforms();

				}
			},

			attributes: {
				get: function() {

					console.warn( 'THREE.WebGLProgram: .attributes is now .getAttributes().' );
					return this.getAttributes();

				}
			}

		} );


		//

		this.id = programIdCount ++;
		this.code = code;
		this.usedTimes = 1;
		this.program = program;
		this.vertexShader = glVertexShader;
		this.fragmentShader = glFragmentShader;

		return this;

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLPrograms( renderer, extensions, capabilities ) {

		var programs = [];

		var shaderIDs = {
			MeshDepthMaterial: 'depth',
			MeshDistanceMaterial: 'distanceRGBA',
			MeshNormalMaterial: 'normal',
			MeshBasicMaterial: 'basic',
			MeshLambertMaterial: 'lambert',
			MeshPhongMaterial: 'phong',
			MeshToonMaterial: 'phong',
			MeshStandardMaterial: 'physical',
			MeshPhysicalMaterial: 'physical',
			LineBasicMaterial: 'basic',
			LineDashedMaterial: 'dashed',
			PointsMaterial: 'points',
			ShadowMaterial: 'shadow'
		};

		var parameterNames = [
			"precision", "supportsVertexTextures", "map", "mapEncoding", "envMap", "envMapMode", "envMapEncoding",
			"lightMap", "aoMap", "emissiveMap", "emissiveMapEncoding", "bumpMap", "normalMap", "displacementMap", "specularMap",
			"roughnessMap", "metalnessMap", "gradientMap",
			"alphaMap", "combine", "vertexColors", "fog", "useFog", "fogExp",
			"flatShading", "sizeAttenuation", "logarithmicDepthBuffer", "skinning",
			"maxBones", "useVertexTexture", "morphTargets", "morphNormals",
			"maxMorphTargets", "maxMorphNormals", "premultipliedAlpha",
			"numDirLights", "numPointLights", "numSpotLights", "numHemiLights", "numRectAreaLights",
			"shadowMapEnabled", "shadowMapType", "toneMapping", 'physicallyCorrectLights',
			"alphaTest", "doubleSided", "flipSided", "numClippingPlanes", "numClipIntersection", "depthPacking", "dithering"
		];


		function allocateBones( object ) {

			var skeleton = object.skeleton;
			var bones = skeleton.bones;

			if ( capabilities.floatVertexTextures ) {

				return 1024;

			} else {

				// default for when object is not specified
				// ( for example when prebuilding shader to be used with multiple objects )
				//
				//  - leave some extra space for other uniforms
				//  - limit here is ANGLE's 254 max uniform vectors
				//    (up to 54 should be safe)

				var nVertexUniforms = capabilities.maxVertexUniforms;
				var nVertexMatrices = Math.floor( ( nVertexUniforms - 20 ) / 4 );

				var maxBones = Math.min( nVertexMatrices, bones.length );

				if ( maxBones < bones.length ) {

					console.warn( 'THREE.WebGLRenderer: Skeleton has ' + bones.length + ' bones. This GPU supports ' + maxBones + '.' );
					return 0;

				}

				return maxBones;

			}

		}

		function getTextureEncodingFromMap( map, gammaOverrideLinear ) {

			var encoding;

			if ( ! map ) {

				encoding = LinearEncoding;

			} else if ( map.isTexture ) {

				encoding = map.encoding;

			} else if ( map.isWebGLRenderTarget ) {

				console.warn( "THREE.WebGLPrograms.getTextureEncodingFromMap: don't use render targets as textures. Use their .texture property instead." );
				encoding = map.texture.encoding;

			}

			// add backwards compatibility for WebGLRenderer.gammaInput/gammaOutput parameter, should probably be removed at some point.
			if ( encoding === LinearEncoding && gammaOverrideLinear ) {

				encoding = GammaEncoding;

			}

			return encoding;

		}

		this.getParameters = function ( material, lights, shadows, fog, nClipPlanes, nClipIntersection, object ) {

			var shaderID = shaderIDs[ material.type ];

			// heuristics to create shader parameters according to lights in the scene
			// (not to blow over maxLights budget)

			var maxBones = object.isSkinnedMesh ? allocateBones( object ) : 0;
			var precision = capabilities.precision;

			if ( material.precision !== null ) {

				precision = capabilities.getMaxPrecision( material.precision );

				if ( precision !== material.precision ) {

					console.warn( 'THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.' );

				}

			}

			var currentRenderTarget = renderer.getRenderTarget();

			var parameters = {

				shaderID: shaderID,

				precision: precision,
				supportsVertexTextures: capabilities.vertexTextures,
				outputEncoding: getTextureEncodingFromMap( ( ! currentRenderTarget ) ? null : currentRenderTarget.texture, renderer.gammaOutput ),
				map: !! material.map,
				mapEncoding: getTextureEncodingFromMap( material.map, renderer.gammaInput ),
				envMap: !! material.envMap,
				envMapMode: material.envMap && material.envMap.mapping,
				envMapEncoding: getTextureEncodingFromMap( material.envMap, renderer.gammaInput ),
				envMapCubeUV: ( !! material.envMap ) && ( ( material.envMap.mapping === CubeUVReflectionMapping ) || ( material.envMap.mapping === CubeUVRefractionMapping ) ),
				lightMap: !! material.lightMap,
				aoMap: !! material.aoMap,
				emissiveMap: !! material.emissiveMap,
				emissiveMapEncoding: getTextureEncodingFromMap( material.emissiveMap, renderer.gammaInput ),
				bumpMap: !! material.bumpMap,
				normalMap: !! material.normalMap,
				displacementMap: !! material.displacementMap,
				roughnessMap: !! material.roughnessMap,
				metalnessMap: !! material.metalnessMap,
				specularMap: !! material.specularMap,
				alphaMap: !! material.alphaMap,

				gradientMap: !! material.gradientMap,

				combine: material.combine,

				vertexColors: material.vertexColors,

				fog: !! fog,
				useFog: material.fog,
				fogExp: ( fog && fog.isFogExp2 ),

				flatShading: material.flatShading,

				sizeAttenuation: material.sizeAttenuation,
				logarithmicDepthBuffer: capabilities.logarithmicDepthBuffer,

				skinning: material.skinning && maxBones > 0,
				maxBones: maxBones,
				useVertexTexture: capabilities.floatVertexTextures,

				morphTargets: material.morphTargets,
				morphNormals: material.morphNormals,
				maxMorphTargets: renderer.maxMorphTargets,
				maxMorphNormals: renderer.maxMorphNormals,

				numDirLights: lights.directional.length,
				numPointLights: lights.point.length,
				numSpotLights: lights.spot.length,
				numRectAreaLights: lights.rectArea.length,
				numHemiLights: lights.hemi.length,

				numClippingPlanes: nClipPlanes,
				numClipIntersection: nClipIntersection,

				dithering: material.dithering,

				shadowMapEnabled: renderer.shadowMap.enabled && object.receiveShadow && shadows.length > 0,
				shadowMapType: renderer.shadowMap.type,

				toneMapping: renderer.toneMapping,
				physicallyCorrectLights: renderer.physicallyCorrectLights,

				premultipliedAlpha: material.premultipliedAlpha,

				alphaTest: material.alphaTest,
				doubleSided: material.side === DoubleSide,
				flipSided: material.side === BackSide,

				depthPacking: ( material.depthPacking !== undefined ) ? material.depthPacking : false

			};

			return parameters;

		};

		this.getProgramCode = function ( material, parameters ) {

			var array = [];

			if ( parameters.shaderID ) {

				array.push( parameters.shaderID );

			} else {

				array.push( material.fragmentShader );
				array.push( material.vertexShader );

			}

			if ( material.defines !== undefined ) {

				for ( var name in material.defines ) {

					array.push( name );
					array.push( material.defines[ name ] );

				}

			}

			for ( var i = 0; i < parameterNames.length; i ++ ) {

				array.push( parameters[ parameterNames[ i ] ] );

			}

			array.push( material.onBeforeCompile.toString() );

			array.push( renderer.gammaOutput );

			return array.join();

		};

		this.acquireProgram = function ( material, shader, parameters, code ) {

			var program;

			// Check if code has been already compiled
			for ( var p = 0, pl = programs.length; p < pl; p ++ ) {

				var programInfo = programs[ p ];

				if ( programInfo.code === code ) {

					program = programInfo;
					++ program.usedTimes;

					break;

				}

			}

			if ( program === undefined ) {

				program = new WebGLProgram( renderer, extensions, code, material, shader, parameters );
				programs.push( program );

			}

			return program;

		};

		this.releaseProgram = function ( program ) {

			if ( -- program.usedTimes === 0 ) {

				// Remove from unordered set
				var i = programs.indexOf( program );
				programs[ i ] = programs[ programs.length - 1 ];
				programs.pop();

				// Free WebGL resources
				program.destroy();

			}

		};

		// Exposed for resource monitoring & error feedback via renderer.info:
		this.programs = programs;

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLTextures( _gl, extensions, state, properties, capabilities, utils, infoMemory ) {

		var _isWebGL2 = ( typeof WebGL2RenderingContext !== 'undefined' && _gl instanceof WebGL2RenderingContext );

		//

		function clampToMaxSize( image, maxSize ) {

			if ( image.width > maxSize || image.height > maxSize ) {

				// Warning: Scaling through the canvas will only work with images that use
				// premultiplied alpha.

				var scale = maxSize / Math.max( image.width, image.height );

				var canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
				canvas.width = Math.floor( image.width * scale );
				canvas.height = Math.floor( image.height * scale );

				var context = canvas.getContext( '2d' );
				context.drawImage( image, 0, 0, image.width, image.height, 0, 0, canvas.width, canvas.height );

				console.warn( 'THREE.WebGLRenderer: image is too big (' + image.width + 'x' + image.height + '). Resized to ' + canvas.width + 'x' + canvas.height, image );

				return canvas;

			}

			return image;

		}

		function isPowerOfTwo( image ) {

			return _Math.isPowerOfTwo( image.width ) && _Math.isPowerOfTwo( image.height );

		}

		function makePowerOfTwo( image ) {

			if ( image instanceof HTMLImageElement || image instanceof HTMLCanvasElement ) {

				var canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
				canvas.width = _Math.nearestPowerOfTwo( image.width );
				canvas.height = _Math.nearestPowerOfTwo( image.height );

				var context = canvas.getContext( '2d' );
				context.drawImage( image, 0, 0, canvas.width, canvas.height );

				console.warn( 'THREE.WebGLRenderer: image is not power of two (' + image.width + 'x' + image.height + '). Resized to ' + canvas.width + 'x' + canvas.height, image );

				return canvas;

			}

			return image;

		}

		function textureNeedsPowerOfTwo( texture ) {

			return ( texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping ) ||
				( texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter );

		}

		function textureNeedsGenerateMipmaps( texture, isPowerOfTwo ) {

			return texture.generateMipmaps && isPowerOfTwo &&
				texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter;

		}

		// Fallback filters for non-power-of-2 textures

		function filterFallback( f ) {

			if ( f === NearestFilter || f === NearestMipMapNearestFilter || f === NearestMipMapLinearFilter ) {

				return _gl.NEAREST;

			}

			return _gl.LINEAR;

		}

		//

		function onTextureDispose( event ) {

			var texture = event.target;

			texture.removeEventListener( 'dispose', onTextureDispose );

			deallocateTexture( texture );

			infoMemory.textures --;


		}

		function onRenderTargetDispose( event ) {

			var renderTarget = event.target;

			renderTarget.removeEventListener( 'dispose', onRenderTargetDispose );

			deallocateRenderTarget( renderTarget );

			infoMemory.textures --;

		}

		//

		function deallocateTexture( texture ) {

			var textureProperties = properties.get( texture );

			if ( texture.image && textureProperties.__image__webglTextureCube ) {

				// cube texture

				_gl.deleteTexture( textureProperties.__image__webglTextureCube );

			} else {

				// 2D texture

				if ( textureProperties.__webglInit === undefined ) return;

				_gl.deleteTexture( textureProperties.__webglTexture );

			}

			// remove all webgl properties
			properties.remove( texture );

		}

		function deallocateRenderTarget( renderTarget ) {

			var renderTargetProperties = properties.get( renderTarget );
			var textureProperties = properties.get( renderTarget.texture );

			if ( ! renderTarget ) return;

			if ( textureProperties.__webglTexture !== undefined ) {

				_gl.deleteTexture( textureProperties.__webglTexture );

			}

			if ( renderTarget.depthTexture ) {

				renderTarget.depthTexture.dispose();

			}

			if ( renderTarget.isWebGLRenderTargetCube ) {

				for ( var i = 0; i < 6; i ++ ) {

					_gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer[ i ] );
					if ( renderTargetProperties.__webglDepthbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthbuffer[ i ] );

				}

			} else {

				_gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer );
				if ( renderTargetProperties.__webglDepthbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthbuffer );

			}

			properties.remove( renderTarget.texture );
			properties.remove( renderTarget );

		}

		//



		function setTexture2D( texture, slot ) {

			var textureProperties = properties.get( texture );

			if ( texture.version > 0 && textureProperties.__version !== texture.version ) {

				var image = texture.image;

				if ( image === undefined ) {

					console.warn( 'THREE.WebGLRenderer: Texture marked for update but image is undefined', texture );

				} else if ( image.complete === false ) {

					console.warn( 'THREE.WebGLRenderer: Texture marked for update but image is incomplete', texture );

				} else {

					uploadTexture( textureProperties, texture, slot );
					return;

				}

			}

			state.activeTexture( _gl.TEXTURE0 + slot );
			state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture );

		}

		function setTextureCube( texture, slot ) {

			var textureProperties = properties.get( texture );

			if ( texture.image.length === 6 ) {

				if ( texture.version > 0 && textureProperties.__version !== texture.version ) {

					if ( ! textureProperties.__image__webglTextureCube ) {

						texture.addEventListener( 'dispose', onTextureDispose );

						textureProperties.__image__webglTextureCube = _gl.createTexture();

						infoMemory.textures ++;

					}

					state.activeTexture( _gl.TEXTURE0 + slot );
					state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__image__webglTextureCube );

					_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, texture.flipY );

					var isCompressed = ( texture && texture.isCompressedTexture );
					var isDataTexture = ( texture.image[ 0 ] && texture.image[ 0 ].isDataTexture );

					var cubeImage = [];

					for ( var i = 0; i < 6; i ++ ) {

						if ( ! isCompressed && ! isDataTexture ) {

							cubeImage[ i ] = clampToMaxSize( texture.image[ i ], capabilities.maxCubemapSize );

						} else {

							cubeImage[ i ] = isDataTexture ? texture.image[ i ].image : texture.image[ i ];

						}

					}

					var image = cubeImage[ 0 ],
					isPowerOfTwoImage = isPowerOfTwo( image ),
					glFormat = utils.convert( texture.format ),
					glType = utils.convert( texture.type );

					setTextureParameters( _gl.TEXTURE_CUBE_MAP, texture, isPowerOfTwoImage );

					for ( var i = 0; i < 6; i ++ ) {

						if ( ! isCompressed ) {

							if ( isDataTexture ) {

								state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glFormat, cubeImage[ i ].width, cubeImage[ i ].height, 0, glFormat, glType, cubeImage[ i ].data );

							} else {

								state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glFormat, glFormat, glType, cubeImage[ i ] );

							}

						} else {

							var mipmap, mipmaps = cubeImage[ i ].mipmaps;

							for ( var j = 0, jl = mipmaps.length; j < jl; j ++ ) {

								mipmap = mipmaps[ j ];

								if ( texture.format !== RGBAFormat && texture.format !== RGBFormat ) {

									if ( state.getCompressedTextureFormats().indexOf( glFormat ) > - 1 ) {

										state.compressedTexImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glFormat, mipmap.width, mipmap.height, 0, mipmap.data );

									} else {

										console.warn( 'THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()' );

									}

								} else {

									state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );

								}

							}

						}

					}

					if ( textureNeedsGenerateMipmaps( texture, isPowerOfTwoImage ) ) {

						_gl.generateMipmap( _gl.TEXTURE_CUBE_MAP );

					}

					textureProperties.__version = texture.version;

					if ( texture.onUpdate ) texture.onUpdate( texture );

				} else {

					state.activeTexture( _gl.TEXTURE0 + slot );
					state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__image__webglTextureCube );

				}

			}

		}

		function setTextureCubeDynamic( texture, slot ) {

			state.activeTexture( _gl.TEXTURE0 + slot );
			state.bindTexture( _gl.TEXTURE_CUBE_MAP, properties.get( texture ).__webglTexture );

		}

		function setTextureParameters( textureType, texture, isPowerOfTwoImage ) {

			var extension;

			if ( isPowerOfTwoImage ) {

				_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_S, utils.convert( texture.wrapS ) );
				_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_T, utils.convert( texture.wrapT ) );

				_gl.texParameteri( textureType, _gl.TEXTURE_MAG_FILTER, utils.convert( texture.magFilter ) );
				_gl.texParameteri( textureType, _gl.TEXTURE_MIN_FILTER, utils.convert( texture.minFilter ) );

			} else {

				_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_S, _gl.CLAMP_TO_EDGE );
				_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_T, _gl.CLAMP_TO_EDGE );

				if ( texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping ) {

					console.warn( 'THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.', texture );

				}

				_gl.texParameteri( textureType, _gl.TEXTURE_MAG_FILTER, filterFallback( texture.magFilter ) );
				_gl.texParameteri( textureType, _gl.TEXTURE_MIN_FILTER, filterFallback( texture.minFilter ) );

				if ( texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter ) {

					console.warn( 'THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.', texture );

				}

			}

			extension = extensions.get( 'EXT_texture_filter_anisotropic' );

			if ( extension ) {

				if ( texture.type === FloatType && extensions.get( 'OES_texture_float_linear' ) === null ) return;
				if ( texture.type === HalfFloatType && extensions.get( 'OES_texture_half_float_linear' ) === null ) return;

				if ( texture.anisotropy > 1 || properties.get( texture ).__currentAnisotropy ) {

					_gl.texParameterf( textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min( texture.anisotropy, capabilities.getMaxAnisotropy() ) );
					properties.get( texture ).__currentAnisotropy = texture.anisotropy;

				}

			}

		}

		function uploadTexture( textureProperties, texture, slot ) {

			if ( textureProperties.__webglInit === undefined ) {

				textureProperties.__webglInit = true;

				texture.addEventListener( 'dispose', onTextureDispose );

				textureProperties.__webglTexture = _gl.createTexture();

				infoMemory.textures ++;

			}

			state.activeTexture( _gl.TEXTURE0 + slot );
			state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture );

			_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, texture.flipY );
			_gl.pixelStorei( _gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha );
			_gl.pixelStorei( _gl.UNPACK_ALIGNMENT, texture.unpackAlignment );

			var image = clampToMaxSize( texture.image, capabilities.maxTextureSize );

			if ( textureNeedsPowerOfTwo( texture ) && isPowerOfTwo( image ) === false ) {

				image = makePowerOfTwo( image );

			}

			var isPowerOfTwoImage = isPowerOfTwo( image ),
			glFormat = utils.convert( texture.format ),
			glType = utils.convert( texture.type );

			setTextureParameters( _gl.TEXTURE_2D, texture, isPowerOfTwoImage );

			var mipmap, mipmaps = texture.mipmaps;

			if ( texture.isDepthTexture ) {

				// populate depth texture with dummy data

				var internalFormat = _gl.DEPTH_COMPONENT;

				if ( texture.type === FloatType ) {

					if ( !_isWebGL2 ) throw new Error('Float Depth Texture only supported in WebGL2.0');
					internalFormat = _gl.DEPTH_COMPONENT32F;

				} else if ( _isWebGL2 ) {

					// WebGL 2.0 requires signed internalformat for glTexImage2D
					internalFormat = _gl.DEPTH_COMPONENT16;

				}

				if ( texture.format === DepthFormat && internalFormat === _gl.DEPTH_COMPONENT ) {

					// The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
					// DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
					// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
					if ( texture.type !== UnsignedShortType && texture.type !== UnsignedIntType ) {

					        console.warn( 'THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.' );

						texture.type = UnsignedShortType;
						glType = utils.convert( texture.type );

					}

				}

				// Depth stencil textures need the DEPTH_STENCIL internal format
				// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
				if ( texture.format === DepthStencilFormat ) {

					internalFormat = _gl.DEPTH_STENCIL;

					// The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
					// DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
					// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
					if ( texture.type !== UnsignedInt248Type ) {

						console.warn( 'THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.' );

						texture.type = UnsignedInt248Type;
						glType = utils.convert( texture.type );

					}

				}

				state.texImage2D( _gl.TEXTURE_2D, 0, internalFormat, image.width, image.height, 0, glFormat, glType, null );

			} else if ( texture.isDataTexture ) {

				// use manually created mipmaps if available
				// if there are no manual mipmaps
				// set 0 level mipmap and then use GL to generate other mipmap levels

				if ( mipmaps.length > 0 && isPowerOfTwoImage ) {

					for ( var i = 0, il = mipmaps.length; i < il; i ++ ) {

						mipmap = mipmaps[ i ];
						state.texImage2D( _gl.TEXTURE_2D, i, glFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );

					}

					texture.generateMipmaps = false;

				} else {

					state.texImage2D( _gl.TEXTURE_2D, 0, glFormat, image.width, image.height, 0, glFormat, glType, image.data );

				}

			} else if ( texture.isCompressedTexture ) {

				for ( var i = 0, il = mipmaps.length; i < il; i ++ ) {

					mipmap = mipmaps[ i ];

					if ( texture.format !== RGBAFormat && texture.format !== RGBFormat ) {

						if ( state.getCompressedTextureFormats().indexOf( glFormat ) > - 1 ) {

							state.compressedTexImage2D( _gl.TEXTURE_2D, i, glFormat, mipmap.width, mipmap.height, 0, mipmap.data );

						} else {

							console.warn( 'THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()' );

						}

					} else {

						state.texImage2D( _gl.TEXTURE_2D, i, glFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );

					}

				}

			} else {

				// regular Texture (image, video, canvas)

				// use manually created mipmaps if available
				// if there are no manual mipmaps
				// set 0 level mipmap and then use GL to generate other mipmap levels

				if ( mipmaps.length > 0 && isPowerOfTwoImage ) {

					for ( var i = 0, il = mipmaps.length; i < il; i ++ ) {

						mipmap = mipmaps[ i ];
						state.texImage2D( _gl.TEXTURE_2D, i, glFormat, glFormat, glType, mipmap );

					}

					texture.generateMipmaps = false;

				} else {

					state.texImage2D( _gl.TEXTURE_2D, 0, glFormat, glFormat, glType, image );

				}

			}

			if ( textureNeedsGenerateMipmaps( texture, isPowerOfTwoImage ) ) _gl.generateMipmap( _gl.TEXTURE_2D );

			textureProperties.__version = texture.version;

			if ( texture.onUpdate ) texture.onUpdate( texture );

		}

		// Render targets

		// Setup storage for target texture and bind it to correct framebuffer
		function setupFrameBufferTexture( framebuffer, renderTarget, attachment, textureTarget ) {

			var glFormat = utils.convert( renderTarget.texture.format );
			var glType = utils.convert( renderTarget.texture.type );
			state.texImage2D( textureTarget, 0, glFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null );
			_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );
			_gl.framebufferTexture2D( _gl.FRAMEBUFFER, attachment, textureTarget, properties.get( renderTarget.texture ).__webglTexture, 0 );
			_gl.bindFramebuffer( _gl.FRAMEBUFFER, null );

		}

		// Setup storage for internal depth/stencil buffers and bind to correct framebuffer
		function setupRenderBufferStorage( renderbuffer, renderTarget ) {

			_gl.bindRenderbuffer( _gl.RENDERBUFFER, renderbuffer );

			if ( renderTarget.depthBuffer && ! renderTarget.stencilBuffer ) {

				_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.DEPTH_COMPONENT16, renderTarget.width, renderTarget.height );
				_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer );

			} else if ( renderTarget.depthBuffer && renderTarget.stencilBuffer ) {

				_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.DEPTH_STENCIL, renderTarget.width, renderTarget.height );
				_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer );

			} else {

				// FIXME: We don't support !depth !stencil
				_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.RGBA4, renderTarget.width, renderTarget.height );

			}

			_gl.bindRenderbuffer( _gl.RENDERBUFFER, null );

		}

		// Setup resources for a Depth Texture for a FBO (needs an extension)
		function setupDepthTexture( framebuffer, renderTarget ) {

			var isCube = ( renderTarget && renderTarget.isWebGLRenderTargetCube );
			if ( isCube ) throw new Error( 'Depth Texture with cube render targets is not supported' );

			_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

			if ( !( renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture ) ) {

				throw new Error( 'renderTarget.depthTexture must be an instance of THREE.DepthTexture' );

			}

			// upload an empty depth texture with framebuffer size
			if ( !properties.get( renderTarget.depthTexture ).__webglTexture ||
					renderTarget.depthTexture.image.width !== renderTarget.width ||
					renderTarget.depthTexture.image.height !== renderTarget.height ) {
				renderTarget.depthTexture.image.width = renderTarget.width;
				renderTarget.depthTexture.image.height = renderTarget.height;
				renderTarget.depthTexture.needsUpdate = true;
			}

			setTexture2D( renderTarget.depthTexture, 0 );

			var webglDepthTexture = properties.get( renderTarget.depthTexture ).__webglTexture;

			if ( renderTarget.depthTexture.format === DepthFormat ) {

				_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0 );

			} else if ( renderTarget.depthTexture.format === DepthStencilFormat ) {

				_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0 );

			} else {

				throw new Error( 'Unknown depthTexture format' );

			}

		}

		// Setup GL resources for a non-texture depth buffer
		function setupDepthRenderbuffer( renderTarget ) {

			var renderTargetProperties = properties.get( renderTarget );

			var isCube = ( renderTarget.isWebGLRenderTargetCube === true );

			if ( renderTarget.depthTexture ) {

				if ( isCube ) throw new Error( 'target.depthTexture not supported in Cube render targets' );

				setupDepthTexture( renderTargetProperties.__webglFramebuffer, renderTarget );

			} else {

				if ( isCube ) {

					renderTargetProperties.__webglDepthbuffer = [];

					for ( var i = 0; i < 6; i ++ ) {

						_gl.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[ i ] );
						renderTargetProperties.__webglDepthbuffer[ i ] = _gl.createRenderbuffer();
						setupRenderBufferStorage( renderTargetProperties.__webglDepthbuffer[ i ], renderTarget );

					}

				} else {

					_gl.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer );
					renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
					setupRenderBufferStorage( renderTargetProperties.__webglDepthbuffer, renderTarget );

				}

			}

			_gl.bindFramebuffer( _gl.FRAMEBUFFER, null );

		}

		// Set up GL resources for the render target
		function setupRenderTarget( renderTarget ) {

			var renderTargetProperties = properties.get( renderTarget );
			var textureProperties = properties.get( renderTarget.texture );

			renderTarget.addEventListener( 'dispose', onRenderTargetDispose );

			textureProperties.__webglTexture = _gl.createTexture();

			infoMemory.textures ++;

			var isCube = ( renderTarget.isWebGLRenderTargetCube === true );
			var isTargetPowerOfTwo = isPowerOfTwo( renderTarget );

			// Setup framebuffer

			if ( isCube ) {

				renderTargetProperties.__webglFramebuffer = [];

				for ( var i = 0; i < 6; i ++ ) {

					renderTargetProperties.__webglFramebuffer[ i ] = _gl.createFramebuffer();

				}

			} else {

				renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();

			}

			// Setup color buffer

			if ( isCube ) {

				state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture );
				setTextureParameters( _gl.TEXTURE_CUBE_MAP, renderTarget.texture, isTargetPowerOfTwo );

				for ( var i = 0; i < 6; i ++ ) {

					setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer[ i ], renderTarget, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i );

				}

				if ( textureNeedsGenerateMipmaps( renderTarget.texture, isTargetPowerOfTwo ) ) _gl.generateMipmap( _gl.TEXTURE_CUBE_MAP );
				state.bindTexture( _gl.TEXTURE_CUBE_MAP, null );

			} else {

				state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture );
				setTextureParameters( _gl.TEXTURE_2D, renderTarget.texture, isTargetPowerOfTwo );
				setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer, renderTarget, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D );

				if ( textureNeedsGenerateMipmaps( renderTarget.texture, isTargetPowerOfTwo ) ) _gl.generateMipmap( _gl.TEXTURE_2D );
				state.bindTexture( _gl.TEXTURE_2D, null );

			}

			// Setup depth and stencil buffers

			if ( renderTarget.depthBuffer ) {

				setupDepthRenderbuffer( renderTarget );

			}

		}

		function updateRenderTargetMipmap( renderTarget ) {

			var texture = renderTarget.texture;
			var isTargetPowerOfTwo = isPowerOfTwo( renderTarget );

			if ( textureNeedsGenerateMipmaps( texture, isTargetPowerOfTwo ) ) {

				var target = renderTarget.isWebGLRenderTargetCube ? _gl.TEXTURE_CUBE_MAP : _gl.TEXTURE_2D;
				var webglTexture = properties.get( texture ).__webglTexture;

				state.bindTexture( target, webglTexture );
				_gl.generateMipmap( target );
				state.bindTexture( target, null );

			}

		}

		this.setTexture2D = setTexture2D;
		this.setTextureCube = setTextureCube;
		this.setTextureCubeDynamic = setTextureCubeDynamic;
		this.setupRenderTarget = setupRenderTarget;
		this.updateRenderTargetMipmap = updateRenderTargetMipmap;

	}

	/**
	 * @author fordacious / fordacious.github.io
	 */

	function WebGLProperties() {

		var properties = {};

		function get( object ) {

			var uuid = object.uuid;
			var map = properties[ uuid ];

			if ( map === undefined ) {

				map = {};
				properties[ uuid ] = map;

			}

			return map;

		}

		function remove( object ) {

			delete properties[ object.uuid ];

		}

		function clear() {

			properties = {};

		}

		return {
			get: get,
			remove: remove,
			clear: clear
		};

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLState( gl, extensions, utils ) {

		function ColorBuffer() {

			var locked = false;

			var color = new Vector4();
			var currentColorMask = null;
			var currentColorClear = new Vector4( 0, 0, 0, 0 );

			return {

				setMask: function ( colorMask ) {

					if ( currentColorMask !== colorMask && ! locked ) {

						gl.colorMask( colorMask, colorMask, colorMask, colorMask );
						currentColorMask = colorMask;

					}

				},

				setLocked: function ( lock ) {

					locked = lock;

				},

				setClear: function ( r, g, b, a, premultipliedAlpha ) {

					if ( premultipliedAlpha === true ) {

						r *= a; g *= a; b *= a;

					}

					color.set( r, g, b, a );

					if ( currentColorClear.equals( color ) === false ) {

						gl.clearColor( r, g, b, a );
						currentColorClear.copy( color );

					}

				},

				reset: function () {

					locked = false;

					currentColorMask = null;
					currentColorClear.set( - 1, 0, 0, 0 ); // set to invalid state

				}

			};

		}

		function DepthBuffer() {

			var locked = false;

			var currentDepthMask = null;
			var currentDepthFunc = null;
			var currentDepthClear = null;

			return {

				setTest: function ( depthTest ) {

					if ( depthTest ) {

						enable( gl.DEPTH_TEST );

					} else {

						disable( gl.DEPTH_TEST );

					}

				},

				setMask: function ( depthMask ) {

					if ( currentDepthMask !== depthMask && ! locked ) {

						gl.depthMask( depthMask );
						currentDepthMask = depthMask;

					}

				},

				setFunc: function ( depthFunc ) {

					if ( currentDepthFunc !== depthFunc ) {

						if ( depthFunc ) {

							switch ( depthFunc ) {

								case NeverDepth:

									gl.depthFunc( gl.NEVER );
									break;

								case AlwaysDepth:

									gl.depthFunc( gl.ALWAYS );
									break;

								case LessDepth:

									gl.depthFunc( gl.LESS );
									break;

								case LessEqualDepth:

									gl.depthFunc( gl.LEQUAL );
									break;

								case EqualDepth:

									gl.depthFunc( gl.EQUAL );
									break;

								case GreaterEqualDepth:

									gl.depthFunc( gl.GEQUAL );
									break;

								case GreaterDepth:

									gl.depthFunc( gl.GREATER );
									break;

								case NotEqualDepth:

									gl.depthFunc( gl.NOTEQUAL );
									break;

								default:

									gl.depthFunc( gl.LEQUAL );

							}

						} else {

							gl.depthFunc( gl.LEQUAL );

						}

						currentDepthFunc = depthFunc;

					}

				},

				setLocked: function ( lock ) {

					locked = lock;

				},

				setClear: function ( depth ) {

					if ( currentDepthClear !== depth ) {

						gl.clearDepth( depth );
						currentDepthClear = depth;

					}

				},

				reset: function () {

					locked = false;

					currentDepthMask = null;
					currentDepthFunc = null;
					currentDepthClear = null;

				}

			};

		}

		function StencilBuffer() {

			var locked = false;

			var currentStencilMask = null;
			var currentStencilFunc = null;
			var currentStencilRef = null;
			var currentStencilFuncMask = null;
			var currentStencilFail = null;
			var currentStencilZFail = null;
			var currentStencilZPass = null;
			var currentStencilClear = null;

			return {

				setTest: function ( stencilTest ) {

					if ( stencilTest ) {

						enable( gl.STENCIL_TEST );

					} else {

						disable( gl.STENCIL_TEST );

					}

				},

				setMask: function ( stencilMask ) {

					if ( currentStencilMask !== stencilMask && ! locked ) {

						gl.stencilMask( stencilMask );
						currentStencilMask = stencilMask;

					}

				},

				setFunc: function ( stencilFunc, stencilRef, stencilMask ) {

					if ( currentStencilFunc !== stencilFunc ||
					     currentStencilRef 	!== stencilRef 	||
					     currentStencilFuncMask !== stencilMask ) {

						gl.stencilFunc( stencilFunc, stencilRef, stencilMask );

						currentStencilFunc = stencilFunc;
						currentStencilRef = stencilRef;
						currentStencilFuncMask = stencilMask;

					}

				},

				setOp: function ( stencilFail, stencilZFail, stencilZPass ) {

					if ( currentStencilFail	 !== stencilFail 	||
					     currentStencilZFail !== stencilZFail ||
					     currentStencilZPass !== stencilZPass ) {

						gl.stencilOp( stencilFail, stencilZFail, stencilZPass );

						currentStencilFail = stencilFail;
						currentStencilZFail = stencilZFail;
						currentStencilZPass = stencilZPass;

					}

				},

				setLocked: function ( lock ) {

					locked = lock;

				},

				setClear: function ( stencil ) {

					if ( currentStencilClear !== stencil ) {

						gl.clearStencil( stencil );
						currentStencilClear = stencil;

					}

				},

				reset: function () {

					locked = false;

					currentStencilMask = null;
					currentStencilFunc = null;
					currentStencilRef = null;
					currentStencilFuncMask = null;
					currentStencilFail = null;
					currentStencilZFail = null;
					currentStencilZPass = null;
					currentStencilClear = null;

				}

			};

		}

		//

		var colorBuffer = new ColorBuffer();
		var depthBuffer = new DepthBuffer();
		var stencilBuffer = new StencilBuffer();

		var maxVertexAttributes = gl.getParameter( gl.MAX_VERTEX_ATTRIBS );
		var newAttributes = new Uint8Array( maxVertexAttributes );
		var enabledAttributes = new Uint8Array( maxVertexAttributes );
		var attributeDivisors = new Uint8Array( maxVertexAttributes );

		var capabilities = {};

		var compressedTextureFormats = null;

		var currentProgram = null;

		var currentBlending = null;
		var currentBlendEquation = null;
		var currentBlendSrc = null;
		var currentBlendDst = null;
		var currentBlendEquationAlpha = null;
		var currentBlendSrcAlpha = null;
		var currentBlendDstAlpha = null;
		var currentPremultipledAlpha = false;

		var currentFlipSided = null;
		var currentCullFace = null;

		var currentLineWidth = null;

		var currentPolygonOffsetFactor = null;
		var currentPolygonOffsetUnits = null;

		var maxTextures = gl.getParameter( gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS );

		var version = parseFloat( /^WebGL\ ([0-9])/.exec( gl.getParameter( gl.VERSION ) )[ 1 ] );
		var lineWidthAvailable = parseFloat( version ) >= 1.0;

		var currentTextureSlot = null;
		var currentBoundTextures = {};

		var currentScissor = new Vector4();
		var currentViewport = new Vector4();

		function createTexture( type, target, count ) {

			var data = new Uint8Array( 4 ); // 4 is required to match default unpack alignment of 4.
			var texture = gl.createTexture();

			gl.bindTexture( type, texture );
			gl.texParameteri( type, gl.TEXTURE_MIN_FILTER, gl.NEAREST );
			gl.texParameteri( type, gl.TEXTURE_MAG_FILTER, gl.NEAREST );

			for ( var i = 0; i < count; i ++ ) {

				gl.texImage2D( target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data );

			}

			return texture;

		}

		var emptyTextures = {};
		emptyTextures[ gl.TEXTURE_2D ] = createTexture( gl.TEXTURE_2D, gl.TEXTURE_2D, 1 );
		emptyTextures[ gl.TEXTURE_CUBE_MAP ] = createTexture( gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6 );

		// init

		colorBuffer.setClear( 0, 0, 0, 1 );
		depthBuffer.setClear( 1 );
		stencilBuffer.setClear( 0 );

		enable( gl.DEPTH_TEST );
		depthBuffer.setFunc( LessEqualDepth );

		setFlipSided( false );
		setCullFace( CullFaceBack );
		enable( gl.CULL_FACE );

		enable( gl.BLEND );
		setBlending( NormalBlending );

		//

		function initAttributes() {

			for ( var i = 0, l = newAttributes.length; i < l; i ++ ) {

				newAttributes[ i ] = 0;

			}

		}

		function enableAttribute( attribute ) {

			newAttributes[ attribute ] = 1;

			if ( enabledAttributes[ attribute ] === 0 ) {

				gl.enableVertexAttribArray( attribute );
				enabledAttributes[ attribute ] = 1;

			}

			if ( attributeDivisors[ attribute ] !== 0 ) {

				var extension = extensions.get( 'ANGLE_instanced_arrays' );

				extension.vertexAttribDivisorANGLE( attribute, 0 );
				attributeDivisors[ attribute ] = 0;

			}

		}

		function enableAttributeAndDivisor( attribute, meshPerAttribute ) {

			newAttributes[ attribute ] = 1;

			if ( enabledAttributes[ attribute ] === 0 ) {

				gl.enableVertexAttribArray( attribute );
				enabledAttributes[ attribute ] = 1;

			}

			if ( attributeDivisors[ attribute ] !== meshPerAttribute ) {

				var extension = extensions.get( 'ANGLE_instanced_arrays' );

				extension.vertexAttribDivisorANGLE( attribute, meshPerAttribute );
				attributeDivisors[ attribute ] = meshPerAttribute;

			}

		}

		function disableUnusedAttributes() {

			for ( var i = 0, l = enabledAttributes.length; i !== l; ++ i ) {

				if ( enabledAttributes[ i ] !== newAttributes[ i ] ) {

					gl.disableVertexAttribArray( i );
					enabledAttributes[ i ] = 0;

				}

			}

		}

		function enable( id ) {

			if ( capabilities[ id ] !== true ) {

				gl.enable( id );
				capabilities[ id ] = true;

			}

		}

		function disable( id ) {

			if ( capabilities[ id ] !== false ) {

				gl.disable( id );
				capabilities[ id ] = false;

			}

		}

		function getCompressedTextureFormats() {

			if ( compressedTextureFormats === null ) {

				compressedTextureFormats = [];

				if ( extensions.get( 'WEBGL_compressed_texture_pvrtc' ) ||
				     extensions.get( 'WEBGL_compressed_texture_s3tc' ) ||
				     extensions.get( 'WEBGL_compressed_texture_etc1' ) ) {

					var formats = gl.getParameter( gl.COMPRESSED_TEXTURE_FORMATS );

					for ( var i = 0; i < formats.length; i ++ ) {

						compressedTextureFormats.push( formats[ i ] );

					}

				}

			}

			return compressedTextureFormats;

		}

		function useProgram( program ) {

			if ( currentProgram !== program ) {

				gl.useProgram( program );

				currentProgram = program;

				return true;

			}

			return false;

		}

		function setBlending( blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha ) {

			if ( blending !== NoBlending ) {

				enable( gl.BLEND );

			} else {

				disable( gl.BLEND );

			}

			if ( blending !== CustomBlending ) {

				if ( blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha ) {

					switch ( blending ) {

						case AdditiveBlending:

							if ( premultipliedAlpha ) {

								gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
								gl.blendFuncSeparate( gl.ONE, gl.ONE, gl.ONE, gl.ONE );

							} else {

								gl.blendEquation( gl.FUNC_ADD );
								gl.blendFunc( gl.SRC_ALPHA, gl.ONE );

							}
							break;

						case SubtractiveBlending:

							if ( premultipliedAlpha ) {

								gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
								gl.blendFuncSeparate( gl.ZERO, gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ONE_MINUS_SRC_ALPHA );

							} else {

								gl.blendEquation( gl.FUNC_ADD );
								gl.blendFunc( gl.ZERO, gl.ONE_MINUS_SRC_COLOR );

							}
							break;

						case MultiplyBlending:

							if ( premultipliedAlpha ) {

								gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
								gl.blendFuncSeparate( gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA );

							} else {

								gl.blendEquation( gl.FUNC_ADD );
								gl.blendFunc( gl.ZERO, gl.SRC_COLOR );

							}
							break;

						default:

							if ( premultipliedAlpha ) {

								gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
								gl.blendFuncSeparate( gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA );

							} else {

								gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
								gl.blendFuncSeparate( gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA );

							}

					}

				}

				currentBlendEquation = null;
				currentBlendSrc = null;
				currentBlendDst = null;
				currentBlendEquationAlpha = null;
				currentBlendSrcAlpha = null;
				currentBlendDstAlpha = null;

			} else {

				blendEquationAlpha = blendEquationAlpha || blendEquation;
				blendSrcAlpha = blendSrcAlpha || blendSrc;
				blendDstAlpha = blendDstAlpha || blendDst;

				if ( blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha ) {

					gl.blendEquationSeparate( utils.convert( blendEquation ), utils.convert( blendEquationAlpha ) );

					currentBlendEquation = blendEquation;
					currentBlendEquationAlpha = blendEquationAlpha;

				}

				if ( blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha ) {

					gl.blendFuncSeparate( utils.convert( blendSrc ), utils.convert( blendDst ), utils.convert( blendSrcAlpha ), utils.convert( blendDstAlpha ) );

					currentBlendSrc = blendSrc;
					currentBlendDst = blendDst;
					currentBlendSrcAlpha = blendSrcAlpha;
					currentBlendDstAlpha = blendDstAlpha;

				}

			}

			currentBlending = blending;
			currentPremultipledAlpha = premultipliedAlpha;

		}

		function setMaterial( material ) {

			material.side === DoubleSide
				? disable( gl.CULL_FACE )
				: enable( gl.CULL_FACE );

			setFlipSided( material.side === BackSide );

			material.transparent === true
				? setBlending( material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha )
				: setBlending( NoBlending );

			depthBuffer.setFunc( material.depthFunc );
			depthBuffer.setTest( material.depthTest );
			depthBuffer.setMask( material.depthWrite );
			colorBuffer.setMask( material.colorWrite );

			setPolygonOffset( material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits );

		}

		//

		function setFlipSided( flipSided ) {

			if ( currentFlipSided !== flipSided ) {

				if ( flipSided ) {

					gl.frontFace( gl.CW );

				} else {

					gl.frontFace( gl.CCW );

				}

				currentFlipSided = flipSided;

			}

		}

		function setCullFace( cullFace ) {

			if ( cullFace !== CullFaceNone ) {

				enable( gl.CULL_FACE );

				if ( cullFace !== currentCullFace ) {

					if ( cullFace === CullFaceBack ) {

						gl.cullFace( gl.BACK );

					} else if ( cullFace === CullFaceFront ) {

						gl.cullFace( gl.FRONT );

					} else {

						gl.cullFace( gl.FRONT_AND_BACK );

					}

				}

			} else {

				disable( gl.CULL_FACE );

			}

			currentCullFace = cullFace;

		}

		function setLineWidth( width ) {

			if ( width !== currentLineWidth ) {

				if ( lineWidthAvailable ) gl.lineWidth( width );

				currentLineWidth = width;

			}

		}

		function setPolygonOffset( polygonOffset, factor, units ) {

			if ( polygonOffset ) {

				enable( gl.POLYGON_OFFSET_FILL );

				if ( currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units ) {

					gl.polygonOffset( factor, units );

					currentPolygonOffsetFactor = factor;
					currentPolygonOffsetUnits = units;

				}

			} else {

				disable( gl.POLYGON_OFFSET_FILL );

			}

		}

		function setScissorTest( scissorTest ) {

			if ( scissorTest ) {

				enable( gl.SCISSOR_TEST );

			} else {

				disable( gl.SCISSOR_TEST );

			}

		}

		// texture

		function activeTexture( webglSlot ) {

			if ( webglSlot === undefined ) webglSlot = gl.TEXTURE0 + maxTextures - 1;

			if ( currentTextureSlot !== webglSlot ) {

				gl.activeTexture( webglSlot );
				currentTextureSlot = webglSlot;

			}

		}

		function bindTexture( webglType, webglTexture ) {

			if ( currentTextureSlot === null ) {

				activeTexture();

			}

			var boundTexture = currentBoundTextures[ currentTextureSlot ];

			if ( boundTexture === undefined ) {

				boundTexture = { type: undefined, texture: undefined };
				currentBoundTextures[ currentTextureSlot ] = boundTexture;

			}

			if ( boundTexture.type !== webglType || boundTexture.texture !== webglTexture ) {

				gl.bindTexture( webglType, webglTexture || emptyTextures[ webglType ] );

				boundTexture.type = webglType;
				boundTexture.texture = webglTexture;

			}

		}

		function compressedTexImage2D() {

			try {

				gl.compressedTexImage2D.apply( gl, arguments );

			} catch ( error ) {

				console.error( 'THREE.WebGLState:', error );

			}

		}

		function texImage2D() {

			try {

				gl.texImage2D.apply( gl, arguments );

			} catch ( error ) {

				console.error( 'THREE.WebGLState:', error );

			}

		}

		//

		function scissor( scissor ) {

			if ( currentScissor.equals( scissor ) === false ) {

				gl.scissor( scissor.x, scissor.y, scissor.z, scissor.w );
				currentScissor.copy( scissor );

			}

		}

		function viewport( viewport ) {

			if ( currentViewport.equals( viewport ) === false ) {

				gl.viewport( viewport.x, viewport.y, viewport.z, viewport.w );
				currentViewport.copy( viewport );

			}

		}

		//

		function reset() {

			for ( var i = 0; i < enabledAttributes.length; i ++ ) {

				if ( enabledAttributes[ i ] === 1 ) {

					gl.disableVertexAttribArray( i );
					enabledAttributes[ i ] = 0;

				}

			}

			capabilities = {};

			compressedTextureFormats = null;

			currentTextureSlot = null;
			currentBoundTextures = {};

			currentProgram = null;

			currentBlending = null;

			currentFlipSided = null;
			currentCullFace = null;

			colorBuffer.reset();
			depthBuffer.reset();
			stencilBuffer.reset();

		}

		return {

			buffers: {
				color: colorBuffer,
				depth: depthBuffer,
				stencil: stencilBuffer
			},

			initAttributes: initAttributes,
			enableAttribute: enableAttribute,
			enableAttributeAndDivisor: enableAttributeAndDivisor,
			disableUnusedAttributes: disableUnusedAttributes,
			enable: enable,
			disable: disable,
			getCompressedTextureFormats: getCompressedTextureFormats,

			useProgram: useProgram,

			setBlending: setBlending,
			setMaterial: setMaterial,

			setFlipSided: setFlipSided,
			setCullFace: setCullFace,

			setLineWidth: setLineWidth,
			setPolygonOffset: setPolygonOffset,

			setScissorTest: setScissorTest,

			activeTexture: activeTexture,
			bindTexture: bindTexture,
			compressedTexImage2D: compressedTexImage2D,
			texImage2D: texImage2D,

			scissor: scissor,
			viewport: viewport,

			reset: reset

		};

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLCapabilities( gl, extensions, parameters ) {

		var maxAnisotropy;

		function getMaxAnisotropy() {

			if ( maxAnisotropy !== undefined ) return maxAnisotropy;

			var extension = extensions.get( 'EXT_texture_filter_anisotropic' );

			if ( extension !== null ) {

				maxAnisotropy = gl.getParameter( extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT );

			} else {

				maxAnisotropy = 0;

			}

			return maxAnisotropy;

		}

		function getMaxPrecision( precision ) {

			if ( precision === 'highp' ) {

				if ( gl.getShaderPrecisionFormat( gl.VERTEX_SHADER, gl.HIGH_FLOAT ).precision > 0 &&
				     gl.getShaderPrecisionFormat( gl.FRAGMENT_SHADER, gl.HIGH_FLOAT ).precision > 0 ) {

					return 'highp';

				}

				precision = 'mediump';

			}

			if ( precision === 'mediump' ) {

				if ( gl.getShaderPrecisionFormat( gl.VERTEX_SHADER, gl.MEDIUM_FLOAT ).precision > 0 &&
				     gl.getShaderPrecisionFormat( gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT ).precision > 0 ) {

					return 'mediump';

				}

			}

			return 'lowp';

		}

		var precision = parameters.precision !== undefined ? parameters.precision : 'highp';
		var maxPrecision = getMaxPrecision( precision );

		if ( maxPrecision !== precision ) {

			console.warn( 'THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.' );
			precision = maxPrecision;

		}

		var logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true && !! extensions.get( 'EXT_frag_depth' );

		var maxTextures = gl.getParameter( gl.MAX_TEXTURE_IMAGE_UNITS );
		var maxVertexTextures = gl.getParameter( gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS );
		var maxTextureSize = gl.getParameter( gl.MAX_TEXTURE_SIZE );
		var maxCubemapSize = gl.getParameter( gl.MAX_CUBE_MAP_TEXTURE_SIZE );

		var maxAttributes = gl.getParameter( gl.MAX_VERTEX_ATTRIBS );
		var maxVertexUniforms = gl.getParameter( gl.MAX_VERTEX_UNIFORM_VECTORS );
		var maxVaryings = gl.getParameter( gl.MAX_VARYING_VECTORS );
		var maxFragmentUniforms = gl.getParameter( gl.MAX_FRAGMENT_UNIFORM_VECTORS );

		var vertexTextures = maxVertexTextures > 0;
		var floatFragmentTextures = !! extensions.get( 'OES_texture_float' );
		var floatVertexTextures = vertexTextures && floatFragmentTextures;

		return {

			getMaxAnisotropy: getMaxAnisotropy,
			getMaxPrecision: getMaxPrecision,

			precision: precision,
			logarithmicDepthBuffer: logarithmicDepthBuffer,

			maxTextures: maxTextures,
			maxVertexTextures: maxVertexTextures,
			maxTextureSize: maxTextureSize,
			maxCubemapSize: maxCubemapSize,

			maxAttributes: maxAttributes,
			maxVertexUniforms: maxVertexUniforms,
			maxVaryings: maxVaryings,
			maxFragmentUniforms: maxFragmentUniforms,

			vertexTextures: vertexTextures,
			floatFragmentTextures: floatFragmentTextures,
			floatVertexTextures: floatVertexTextures

		};

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function ArrayCamera( array ) {

		PerspectiveCamera.call( this );

		this.cameras = array || [];

	}

	ArrayCamera.prototype = Object.assign( Object.create( PerspectiveCamera.prototype ), {

		constructor: ArrayCamera,

		isArrayCamera: true

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebVRManager( renderer ) {

		var scope = this;

		var device = null;
		var frameData = null;

		if ( 'VRFrameData' in window ) {

			frameData = new window.VRFrameData();

		}

		var matrixWorldInverse = new Matrix4();

		var standingMatrix = new Matrix4();
		var standingMatrixInverse = new Matrix4();

		var cameraL = new PerspectiveCamera();
		cameraL.bounds = new Vector4( 0.0, 0.0, 0.5, 1.0 );
		cameraL.layers.enable( 1 );

		var cameraR = new PerspectiveCamera();
		cameraR.bounds = new Vector4( 0.5, 0.0, 0.5, 1.0 );
		cameraR.layers.enable( 2 );

		var cameraVR = new ArrayCamera( [ cameraL, cameraR ] );
		cameraVR.layers.enable( 1 );
		cameraVR.layers.enable( 2 );

		//

		var currentSize, currentPixelRatio;

		function onVRDisplayPresentChange() {

			if ( device !== null && device.isPresenting ) {

				var eyeParameters = device.getEyeParameters( 'left' );
				var renderWidth = eyeParameters.renderWidth;
				var renderHeight = eyeParameters.renderHeight;

				currentPixelRatio = renderer.getPixelRatio();
				currentSize = renderer.getSize();

				renderer.setDrawingBufferSize( renderWidth * 2, renderHeight, 1 );

			} else if ( scope.enabled ) {

				renderer.setDrawingBufferSize( currentSize.width, currentSize.height, currentPixelRatio );

			}

		}

		window.addEventListener( 'vrdisplaypresentchange', onVRDisplayPresentChange, false );

		//

		this.enabled = false;
		this.standing = false;

		this.getDevice = function () {

			return device;

		};

		this.setDevice = function ( value ) {

			if ( value !== undefined ) device = value;

		};

		this.getCamera = function ( camera ) {

			if ( device === null ) return camera;

			device.depthNear = camera.near;
			device.depthFar = camera.far;

			device.getFrameData( frameData );

			//

			var pose = frameData.pose;

			if ( pose.position !== null ) {

				camera.position.fromArray( pose.position );

			} else {

				camera.position.set( 0, 0, 0 );

			}

			if ( pose.orientation !== null ) {

				camera.quaternion.fromArray( pose.orientation );

			}

			camera.updateMatrixWorld();

			var stageParameters = device.stageParameters;

			if ( this.standing && stageParameters ) {

				standingMatrix.fromArray( stageParameters.sittingToStandingTransform );
				standingMatrixInverse.getInverse( standingMatrix );

				camera.matrixWorld.multiply( standingMatrix );
				camera.matrixWorldInverse.multiply( standingMatrixInverse );

			}

			if ( device.isPresenting === false ) return camera;

			//

			cameraL.near = camera.near;
			cameraR.near = camera.near;

			cameraL.far = camera.far;
			cameraR.far = camera.far;

			cameraVR.matrixWorld.copy( camera.matrixWorld );
			cameraVR.matrixWorldInverse.copy( camera.matrixWorldInverse );

			cameraL.matrixWorldInverse.fromArray( frameData.leftViewMatrix );
			cameraR.matrixWorldInverse.fromArray( frameData.rightViewMatrix );

			if ( this.standing && stageParameters ) {

				cameraL.matrixWorldInverse.multiply( standingMatrixInverse );
				cameraR.matrixWorldInverse.multiply( standingMatrixInverse );

			}

			var parent = camera.parent;

			if ( parent !== null ) {

				matrixWorldInverse.getInverse( parent.matrixWorld );

				cameraL.matrixWorldInverse.multiply( matrixWorldInverse );
				cameraR.matrixWorldInverse.multiply( matrixWorldInverse );

			}

			// envMap and Mirror needs camera.matrixWorld

			cameraL.matrixWorld.getInverse( cameraL.matrixWorldInverse );
			cameraR.matrixWorld.getInverse( cameraR.matrixWorldInverse );

			cameraL.projectionMatrix.fromArray( frameData.leftProjectionMatrix );
			cameraR.projectionMatrix.fromArray( frameData.rightProjectionMatrix );

			// HACK @mrdoob
			// https://github.com/w3c/webvr/issues/203

			cameraVR.projectionMatrix.copy( cameraL.projectionMatrix );

			//

			var layers = device.getLayers();

			if ( layers.length ) {

				var layer = layers[ 0 ];

				if ( layer.leftBounds !== null && layer.leftBounds.length === 4 ) {

					cameraL.bounds.fromArray( layer.leftBounds );

				}

				if ( layer.rightBounds !== null && layer.rightBounds.length === 4 ) {

					cameraR.bounds.fromArray( layer.rightBounds );

				}

			}

			return cameraVR;

		};

		this.getStandingMatrix = function () {

			return standingMatrix;

		};

		this.submitFrame = function () {

			if ( device && device.isPresenting ) device.submitFrame();

		};

		this.dispose = function() {

			window.removeEventListener( 'vrdisplaypresentchange', onVRDisplayPresentChange );

		};

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function WebGLExtensions( gl ) {

		var extensions = {};

		return {

			get: function ( name ) {

				if ( extensions[ name ] !== undefined ) {

					return extensions[ name ];

				}

				var extension;

				switch ( name ) {

					case 'WEBGL_depth_texture':
						extension = gl.getExtension( 'WEBGL_depth_texture' ) || gl.getExtension( 'MOZ_WEBGL_depth_texture' ) || gl.getExtension( 'WEBKIT_WEBGL_depth_texture' );
						break;

					case 'EXT_texture_filter_anisotropic':
						extension = gl.getExtension( 'EXT_texture_filter_anisotropic' ) || gl.getExtension( 'MOZ_EXT_texture_filter_anisotropic' ) || gl.getExtension( 'WEBKIT_EXT_texture_filter_anisotropic' );
						break;

					case 'WEBGL_compressed_texture_s3tc':
						extension = gl.getExtension( 'WEBGL_compressed_texture_s3tc' ) || gl.getExtension( 'MOZ_WEBGL_compressed_texture_s3tc' ) || gl.getExtension( 'WEBKIT_WEBGL_compressed_texture_s3tc' );
						break;

					case 'WEBGL_compressed_texture_pvrtc':
						extension = gl.getExtension( 'WEBGL_compressed_texture_pvrtc' ) || gl.getExtension( 'WEBKIT_WEBGL_compressed_texture_pvrtc' );
						break;

					case 'WEBGL_compressed_texture_etc1':
						extension = gl.getExtension( 'WEBGL_compressed_texture_etc1' );
						break;

					default:
						extension = gl.getExtension( name );

				}

				if ( extension === null ) {

					console.warn( 'THREE.WebGLRenderer: ' + name + ' extension not supported.' );

				}

				extensions[ name ] = extension;

				return extension;

			}

		};

	}

	/**
	 * @author tschw
	 */

	function WebGLClipping() {

		var scope = this,

			globalState = null,
			numGlobalPlanes = 0,
			localClippingEnabled = false,
			renderingShadows = false,

			plane = new Plane(),
			viewNormalMatrix = new Matrix3(),

			uniform = { value: null, needsUpdate: false };

		this.uniform = uniform;
		this.numPlanes = 0;
		this.numIntersection = 0;

		this.init = function( planes, enableLocalClipping, camera ) {

			var enabled =
				planes.length !== 0 ||
				enableLocalClipping ||
				// enable state of previous frame - the clipping code has to
				// run another frame in order to reset the state:
				numGlobalPlanes !== 0 ||
				localClippingEnabled;

			localClippingEnabled = enableLocalClipping;

			globalState = projectPlanes( planes, camera, 0 );
			numGlobalPlanes = planes.length;

			return enabled;

		};

		this.beginShadows = function() {

			renderingShadows = true;
			projectPlanes( null );

		};

		this.endShadows = function() {

			renderingShadows = false;
			resetGlobalState();

		};

		this.setState = function( planes, clipIntersection, clipShadows, camera, cache, fromCache ) {

			if ( ! localClippingEnabled ||
					planes === null || planes.length === 0 ||
					renderingShadows && ! clipShadows ) {
				// there's no local clipping

				if ( renderingShadows ) {
					// there's no global clipping

					projectPlanes( null );

				} else {

					resetGlobalState();
				}

			} else {

				var nGlobal = renderingShadows ? 0 : numGlobalPlanes,
					lGlobal = nGlobal * 4,

					dstArray = cache.clippingState || null;

				uniform.value = dstArray; // ensure unique state

				dstArray = projectPlanes( planes, camera, lGlobal, fromCache );

				for ( var i = 0; i !== lGlobal; ++ i ) {

					dstArray[ i ] = globalState[ i ];

				}

				cache.clippingState = dstArray;
				this.numIntersection = clipIntersection ? this.numPlanes : 0;
				this.numPlanes += nGlobal;

			}


		};

		function resetGlobalState() {

			if ( uniform.value !== globalState ) {

				uniform.value = globalState;
				uniform.needsUpdate = numGlobalPlanes > 0;

			}

			scope.numPlanes = numGlobalPlanes;
			scope.numIntersection = 0;

		}

		function projectPlanes( planes, camera, dstOffset, skipTransform ) {

			var nPlanes = planes !== null ? planes.length : 0,
				dstArray = null;

			if ( nPlanes !== 0 ) {

				dstArray = uniform.value;

				if ( skipTransform !== true || dstArray === null ) {

					var flatSize = dstOffset + nPlanes * 4,
						viewMatrix = camera.matrixWorldInverse;

					viewNormalMatrix.getNormalMatrix( viewMatrix );

					if ( dstArray === null || dstArray.length < flatSize ) {

						dstArray = new Float32Array( flatSize );

					}

					for ( var i = 0, i4 = dstOffset;
										i !== nPlanes; ++ i, i4 += 4 ) {

						plane.copy( planes[ i ] ).
								applyMatrix4( viewMatrix, viewNormalMatrix );

						plane.normal.toArray( dstArray, i4 );
						dstArray[ i4 + 3 ] = plane.constant;

					}

				}

				uniform.value = dstArray;
				uniform.needsUpdate = true;

			}

			scope.numPlanes = nPlanes;
			
			return dstArray;

		}

	}

	/**
	 * @author thespite / http://www.twitter.com/thespite
	 */

	function WebGLUtils ( gl, extensions ) {

		function convert ( p ) {

			var extension;

			if ( p === RepeatWrapping ) return gl.REPEAT;
			if ( p === ClampToEdgeWrapping ) return gl.CLAMP_TO_EDGE;
			if ( p === MirroredRepeatWrapping ) return gl.MIRRORED_REPEAT;

			if ( p === NearestFilter ) return gl.NEAREST;
			if ( p === NearestMipMapNearestFilter ) return gl.NEAREST_MIPMAP_NEAREST;
			if ( p === NearestMipMapLinearFilter ) return gl.NEAREST_MIPMAP_LINEAR;

			if ( p === LinearFilter ) return gl.LINEAR;
			if ( p === LinearMipMapNearestFilter ) return gl.LINEAR_MIPMAP_NEAREST;
			if ( p === LinearMipMapLinearFilter ) return gl.LINEAR_MIPMAP_LINEAR;

			if ( p === UnsignedByteType ) return gl.UNSIGNED_BYTE;
			if ( p === UnsignedShort4444Type ) return gl.UNSIGNED_SHORT_4_4_4_4;
			if ( p === UnsignedShort5551Type ) return gl.UNSIGNED_SHORT_5_5_5_1;
			if ( p === UnsignedShort565Type ) return gl.UNSIGNED_SHORT_5_6_5;

			if ( p === ByteType ) return gl.BYTE;
			if ( p === ShortType ) return gl.SHORT;
			if ( p === UnsignedShortType ) return gl.UNSIGNED_SHORT;
			if ( p === IntType ) return gl.INT;
			if ( p === UnsignedIntType ) return gl.UNSIGNED_INT;
			if ( p === FloatType ) return gl.FLOAT;

			if ( p === HalfFloatType ) {

				extension = extensions.get( 'OES_texture_half_float' );

				if ( extension !== null ) return extension.HALF_FLOAT_OES;

			}

			if ( p === AlphaFormat ) return gl.ALPHA;
			if ( p === RGBFormat ) return gl.RGB;
			if ( p === RGBAFormat ) return gl.RGBA;
			if ( p === LuminanceFormat ) return gl.LUMINANCE;
			if ( p === LuminanceAlphaFormat ) return gl.LUMINANCE_ALPHA;
			if ( p === DepthFormat ) return gl.DEPTH_COMPONENT;
			if ( p === DepthStencilFormat ) return gl.DEPTH_STENCIL;

			if ( p === AddEquation ) return gl.FUNC_ADD;
			if ( p === SubtractEquation ) return gl.FUNC_SUBTRACT;
			if ( p === ReverseSubtractEquation ) return gl.FUNC_REVERSE_SUBTRACT;

			if ( p === ZeroFactor ) return gl.ZERO;
			if ( p === OneFactor ) return gl.ONE;
			if ( p === SrcColorFactor ) return gl.SRC_COLOR;
			if ( p === OneMinusSrcColorFactor ) return gl.ONE_MINUS_SRC_COLOR;
			if ( p === SrcAlphaFactor ) return gl.SRC_ALPHA;
			if ( p === OneMinusSrcAlphaFactor ) return gl.ONE_MINUS_SRC_ALPHA;
			if ( p === DstAlphaFactor ) return gl.DST_ALPHA;
			if ( p === OneMinusDstAlphaFactor ) return gl.ONE_MINUS_DST_ALPHA;

			if ( p === DstColorFactor ) return gl.DST_COLOR;
			if ( p === OneMinusDstColorFactor ) return gl.ONE_MINUS_DST_COLOR;
			if ( p === SrcAlphaSaturateFactor ) return gl.SRC_ALPHA_SATURATE;

			if ( p === RGB_S3TC_DXT1_Format || p === RGBA_S3TC_DXT1_Format ||
				p === RGBA_S3TC_DXT3_Format || p === RGBA_S3TC_DXT5_Format ) {

				extension = extensions.get( 'WEBGL_compressed_texture_s3tc' );

				if ( extension !== null ) {

					if ( p === RGB_S3TC_DXT1_Format ) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
					if ( p === RGBA_S3TC_DXT1_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
					if ( p === RGBA_S3TC_DXT3_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
					if ( p === RGBA_S3TC_DXT5_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;

				}

			}

			if ( p === RGB_PVRTC_4BPPV1_Format || p === RGB_PVRTC_2BPPV1_Format ||
				p === RGBA_PVRTC_4BPPV1_Format || p === RGBA_PVRTC_2BPPV1_Format ) {

				extension = extensions.get( 'WEBGL_compressed_texture_pvrtc' );

				if ( extension !== null ) {

					if ( p === RGB_PVRTC_4BPPV1_Format ) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
					if ( p === RGB_PVRTC_2BPPV1_Format ) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
					if ( p === RGBA_PVRTC_4BPPV1_Format ) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
					if ( p === RGBA_PVRTC_2BPPV1_Format ) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;

				}

			}

			if ( p === RGB_ETC1_Format ) {

				extension = extensions.get( 'WEBGL_compressed_texture_etc1' );

				if ( extension !== null ) return extension.COMPRESSED_RGB_ETC1_WEBGL;

			}

			if ( p === MinEquation || p === MaxEquation ) {

				extension = extensions.get( 'EXT_blend_minmax' );

				if ( extension !== null ) {

					if ( p === MinEquation ) return extension.MIN_EXT;
					if ( p === MaxEquation ) return extension.MAX_EXT;

				}

			}

			if ( p === UnsignedInt248Type ) {

				extension = extensions.get( 'WEBGL_depth_texture' );

				if ( extension !== null ) return extension.UNSIGNED_INT_24_8_WEBGL;

			}

			return 0;

		}

		return { convert: convert }

	}

	// import { Sphere } from '../math/Sphere';
	/**
	 * @author supereggbert / http://www.paulbrunt.co.uk/
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 * @author szimek / https://github.com/szimek/
	 * @author tschw
	 */

	function WebGLRenderer( parameters ) {

		console.log( 'THREE.WebGLRenderer', REVISION );

		parameters = parameters || {};

		var _canvas = parameters.canvas !== undefined ? parameters.canvas : document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' ),
			_context = parameters.context !== undefined ? parameters.context : null,

			_alpha = parameters.alpha !== undefined ? parameters.alpha : false,
			_depth = parameters.depth !== undefined ? parameters.depth : true,
			_stencil = parameters.stencil !== undefined ? parameters.stencil : true,
			_antialias = parameters.antialias !== undefined ? parameters.antialias : false,
			_premultipliedAlpha = parameters.premultipliedAlpha !== undefined ? parameters.premultipliedAlpha : true,
			_preserveDrawingBuffer = parameters.preserveDrawingBuffer !== undefined ? parameters.preserveDrawingBuffer : false;

		var lightsArray = [];
		var shadowsArray = [];

		var currentRenderList = null;

		var spritesArray = [];
		var flaresArray = [];

		// public properties

		this.domElement = _canvas;
		this.context = null;

		// clearing

		this.autoClear = true;
		this.autoClearColor = true;
		this.autoClearDepth = true;
		this.autoClearStencil = true;

		// scene graph

		this.sortObjects = true;

		// user-defined clipping

		this.clippingPlanes = [];
		this.localClippingEnabled = false;

		// physically based shading

		this.gammaFactor = 2.0;	// for backwards compatibility
		this.gammaInput = false;
		this.gammaOutput = false;

		// physical lights

		this.physicallyCorrectLights = false;

		// tone mapping

		this.toneMapping = LinearToneMapping;
		this.toneMappingExposure = 1.0;
		this.toneMappingWhitePoint = 1.0;

		// morphs

		this.maxMorphTargets = 8;
		this.maxMorphNormals = 4;

		// internal properties

		var _this = this,

			_isContextLost = false,

			// internal state cache

			_currentRenderTarget = null,
			_currentFramebuffer = null,
			_currentMaterialId = - 1,
			_currentGeometryProgram = '',

			_currentCamera = null,
			_currentArrayCamera = null,

			_currentViewport = new Vector4(),
			_currentScissor = new Vector4(),
			_currentScissorTest = null,

			//

			_usedTextureUnits = 0,

			//

			_width = _canvas.width,
			_height = _canvas.height,

			_pixelRatio = 1,

			_viewport = new Vector4( 0, 0, _width, _height ),
			_scissor = new Vector4( 0, 0, _width, _height ),
			_scissorTest = false,

			// frustum

			_frustum = new Frustum(),

			// clipping

			_clipping = new WebGLClipping(),
			_clippingEnabled = false,
			_localClippingEnabled = false,

			// camera matrices cache

			_projScreenMatrix = new Matrix4(),

			_vector3 = new Vector3(),

			// info

			_infoMemory = {
				geometries: 0,
				textures: 0
			},

			_infoRender = {

				frame: 0,
				calls: 0,
				vertices: 0,
				faces: 0,
				points: 0

			};

		this.info = {

			render: _infoRender,
			memory: _infoMemory,
			programs: null

		};

		function getTargetPixelRatio() {

			return _currentRenderTarget === null ? _pixelRatio : 1;

		}

		// initialize

		var _gl;

		try {

			var contextAttributes = {
				alpha: _alpha,
				depth: _depth,
				stencil: _stencil,
				antialias: _antialias,
				premultipliedAlpha: _premultipliedAlpha,
				preserveDrawingBuffer: _preserveDrawingBuffer
			};

			_gl = _context || _canvas.getContext( 'webgl', contextAttributes ) || _canvas.getContext( 'experimental-webgl', contextAttributes );

			if ( _gl === null ) {

				if ( _canvas.getContext( 'webgl' ) !== null ) {

					throw 'Error creating WebGL context with your selected attributes.';

				} else {

					throw 'Error creating WebGL context.';

				}

			}

			// Some experimental-webgl implementations do not have getShaderPrecisionFormat

			if ( _gl.getShaderPrecisionFormat === undefined ) {

				_gl.getShaderPrecisionFormat = function () {

					return { 'rangeMin': 1, 'rangeMax': 1, 'precision': 1 };

				};

			}

			_canvas.addEventListener( 'webglcontextlost', onContextLost, false );
			_canvas.addEventListener( 'webglcontextrestored', onContextRestore, false );

		} catch ( error ) {

			console.error( 'THREE.WebGLRenderer: ' + error );

		}

		var extensions, capabilities, state;
		var properties, textures, attributes, geometries, objects, lights;
		var programCache, renderLists;

		var background, morphtargets, bufferRenderer, indexedBufferRenderer;
		var flareRenderer, spriteRenderer;

		var utils;

		function initGLContext() {

			extensions = new WebGLExtensions( _gl );
			extensions.get( 'WEBGL_depth_texture' );
			extensions.get( 'OES_texture_float' );
			extensions.get( 'OES_texture_float_linear' );
			extensions.get( 'OES_texture_half_float' );
			extensions.get( 'OES_texture_half_float_linear' );
			extensions.get( 'OES_standard_derivatives' );
			extensions.get( 'ANGLE_instanced_arrays' );

			if ( extensions.get( 'OES_element_index_uint' ) ) {

				BufferGeometry.MaxIndex = 4294967296;

			}

			utils = new WebGLUtils( _gl, extensions );

			capabilities = new WebGLCapabilities( _gl, extensions, parameters );

			state = new WebGLState( _gl, extensions, utils );
			state.scissor( _currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio ) );
			state.viewport( _currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio ) );

			properties = new WebGLProperties();
			textures = new WebGLTextures( _gl, extensions, state, properties, capabilities, utils, _infoMemory );
			attributes = new WebGLAttributes( _gl );
			geometries = new WebGLGeometries( _gl, attributes, _infoMemory );
			objects = new WebGLObjects( geometries, _infoRender );
			morphtargets = new WebGLMorphtargets( _gl );
			programCache = new WebGLPrograms( _this, extensions, capabilities );
			lights = new WebGLLights();
			renderLists = new WebGLRenderLists();

			background = new WebGLBackground( _this, state, geometries, _premultipliedAlpha );

			bufferRenderer = new WebGLBufferRenderer( _gl, extensions, _infoRender );
			indexedBufferRenderer = new WebGLIndexedBufferRenderer( _gl, extensions, _infoRender );

			flareRenderer = new WebGLFlareRenderer( _this, _gl, state, textures, capabilities );
			spriteRenderer = new WebGLSpriteRenderer( _this, _gl, state, textures, capabilities );

			_this.info.programs = programCache.programs;

			_this.context = _gl;
			_this.capabilities = capabilities;
			_this.extensions = extensions;
			_this.properties = properties;
			_this.renderLists = renderLists;
			_this.state = state;

		}

		initGLContext();

		// vr

		var vr = new WebVRManager( _this );

		this.vr = vr;

		// shadow map

		var shadowMap = new WebGLShadowMap( _this, objects, capabilities.maxTextureSize );

		this.shadowMap = shadowMap;

		// API

		this.getContext = function () {

			return _gl;

		};

		this.getContextAttributes = function () {

			return _gl.getContextAttributes();

		};

		this.forceContextLoss = function () {

			var extension = extensions.get( 'WEBGL_lose_context' );
			if ( extension ) extension.loseContext();

		};

		this.forceContextRestore = function () {

			var extension = extensions.get( 'WEBGL_lose_context' );
			if ( extension ) extension.restoreContext();

		};

		this.getPixelRatio = function () {

			return _pixelRatio;

		};

		this.setPixelRatio = function ( value ) {

			if ( value === undefined ) return;

			_pixelRatio = value;

			this.setSize( _width, _height, false );

		};

		this.getSize = function () {

			return {
				width: _width,
				height: _height
			};

		};

		this.setSize = function ( width, height, updateStyle ) {

			var device = vr.getDevice();

			if ( device && device.isPresenting ) {

				console.warn( 'THREE.WebGLRenderer: Can\'t change size while VR device is presenting.' );
				return;

			}

			_width = width;
			_height = height;

			_canvas.width = width * _pixelRatio;
			_canvas.height = height * _pixelRatio;

			if ( updateStyle !== false ) {

				_canvas.style.width = width + 'px';
				_canvas.style.height = height + 'px';

			}

			this.setViewport( 0, 0, width, height );

		};

		this.getDrawingBufferSize = function () {

			return {
				width: _width * _pixelRatio,
				height: _height * _pixelRatio
			};

		};

		this.setDrawingBufferSize = function ( width, height, pixelRatio ) {

			_width = width;
			_height = height;

			_pixelRatio = pixelRatio;

			_canvas.width = width * pixelRatio;
			_canvas.height = height * pixelRatio;

			this.setViewport( 0, 0, width, height );

		};

		this.setViewport = function ( x, y, width, height ) {

			_viewport.set( x, _height - y - height, width, height );
			state.viewport( _currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio ) );

		};

		this.setScissor = function ( x, y, width, height ) {

			_scissor.set( x, _height - y - height, width, height );
			state.scissor( _currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio ) );

		};

		this.setScissorTest = function ( boolean ) {

			state.setScissorTest( _scissorTest = boolean );

		};

		// Clearing

		this.getClearColor = background.getClearColor;
		this.setClearColor = background.setClearColor;
		this.getClearAlpha = background.getClearAlpha;
		this.setClearAlpha = background.setClearAlpha;

		this.clear = function ( color, depth, stencil ) {

			var bits = 0;

			if ( color === undefined || color ) bits |= _gl.COLOR_BUFFER_BIT;
			if ( depth === undefined || depth ) bits |= _gl.DEPTH_BUFFER_BIT;
			if ( stencil === undefined || stencil ) bits |= _gl.STENCIL_BUFFER_BIT;

			_gl.clear( bits );

		};

		this.clearColor = function () {

			this.clear( true, false, false );

		};

		this.clearDepth = function () {

			this.clear( false, true, false );

		};

		this.clearStencil = function () {

			this.clear( false, false, true );

		};

		this.clearTarget = function ( renderTarget, color, depth, stencil ) {

			this.setRenderTarget( renderTarget );
			this.clear( color, depth, stencil );

		};

		//

		this.dispose = function () {

			_canvas.removeEventListener( 'webglcontextlost', onContextLost, false );
			_canvas.removeEventListener( 'webglcontextrestored', onContextRestore, false );

			renderLists.dispose();

			vr.dispose();

		};

		// Events

		function onContextLost( event ) {

			event.preventDefault();

			console.log( 'THREE.WebGLRenderer: Context Lost.' );

			_isContextLost = true;

		}

		function onContextRestore( event ) {

			console.log( 'THREE.WebGLRenderer: Context Restored.' );

			_isContextLost = false;

			initGLContext();

		}

		function onMaterialDispose( event ) {

			var material = event.target;

			material.removeEventListener( 'dispose', onMaterialDispose );

			deallocateMaterial( material );

		}

		// Buffer deallocation

		function deallocateMaterial( material ) {

			releaseMaterialProgramReference( material );

			properties.remove( material );

		}


		function releaseMaterialProgramReference( material ) {

			var programInfo = properties.get( material ).program;

			material.program = undefined;

			if ( programInfo !== undefined ) {

				programCache.releaseProgram( programInfo );

			}

		}

		// Buffer rendering

		function renderObjectImmediate( object, program, material ) {

			object.render( function ( object ) {

				_this.renderBufferImmediate( object, program, material );

			} );

		}

		this.renderBufferImmediate = function ( object, program, material ) {

			state.initAttributes();

			var buffers = properties.get( object );

			if ( object.hasPositions && ! buffers.position ) buffers.position = _gl.createBuffer();
			if ( object.hasNormals && ! buffers.normal ) buffers.normal = _gl.createBuffer();
			if ( object.hasUvs && ! buffers.uv ) buffers.uv = _gl.createBuffer();
			if ( object.hasColors && ! buffers.color ) buffers.color = _gl.createBuffer();

			var programAttributes = program.getAttributes();

			if ( object.hasPositions ) {

				_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.position );
				_gl.bufferData( _gl.ARRAY_BUFFER, object.positionArray, _gl.DYNAMIC_DRAW );

				state.enableAttribute( programAttributes.position );
				_gl.vertexAttribPointer( programAttributes.position, 3, _gl.FLOAT, false, 0, 0 );

			}

			if ( object.hasNormals ) {

				_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.normal );

				if ( ! material.isMeshPhongMaterial &&
					! material.isMeshStandardMaterial &&
					! material.isMeshNormalMaterial &&
					material.flatShading === true ) {

					for ( var i = 0, l = object.count * 3; i < l; i += 9 ) {

						var array = object.normalArray;

						var nx = ( array[ i + 0 ] + array[ i + 3 ] + array[ i + 6 ] ) / 3;
						var ny = ( array[ i + 1 ] + array[ i + 4 ] + array[ i + 7 ] ) / 3;
						var nz = ( array[ i + 2 ] + array[ i + 5 ] + array[ i + 8 ] ) / 3;

						array[ i + 0 ] = nx;
						array[ i + 1 ] = ny;
						array[ i + 2 ] = nz;

						array[ i + 3 ] = nx;
						array[ i + 4 ] = ny;
						array[ i + 5 ] = nz;

						array[ i + 6 ] = nx;
						array[ i + 7 ] = ny;
						array[ i + 8 ] = nz;

					}

				}

				_gl.bufferData( _gl.ARRAY_BUFFER, object.normalArray, _gl.DYNAMIC_DRAW );

				state.enableAttribute( programAttributes.normal );

				_gl.vertexAttribPointer( programAttributes.normal, 3, _gl.FLOAT, false, 0, 0 );

			}

			if ( object.hasUvs && material.map ) {

				_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.uv );
				_gl.bufferData( _gl.ARRAY_BUFFER, object.uvArray, _gl.DYNAMIC_DRAW );

				state.enableAttribute( programAttributes.uv );

				_gl.vertexAttribPointer( programAttributes.uv, 2, _gl.FLOAT, false, 0, 0 );

			}

			if ( object.hasColors && material.vertexColors !== NoColors ) {

				_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.color );
				_gl.bufferData( _gl.ARRAY_BUFFER, object.colorArray, _gl.DYNAMIC_DRAW );

				state.enableAttribute( programAttributes.color );

				_gl.vertexAttribPointer( programAttributes.color, 3, _gl.FLOAT, false, 0, 0 );

			}

			state.disableUnusedAttributes();

			_gl.drawArrays( _gl.TRIANGLES, 0, object.count );

			object.count = 0;

		};

		this.renderBufferDirect = function ( camera, fog, geometry, material, object, group ) {

			state.setMaterial( material );

			var program = setProgram( camera, fog, material, object );
			var geometryProgram = geometry.id + '_' + program.id + '_' + ( material.wireframe === true );

			var updateBuffers = false;

			if ( geometryProgram !== _currentGeometryProgram ) {

				_currentGeometryProgram = geometryProgram;
				updateBuffers = true;

			}

			if ( object.morphTargetInfluences ) {

				morphtargets.update( object, geometry, material, program );

				updateBuffers = true;

			}

			//

			var index = geometry.index;
			var position = geometry.attributes.position;
			var rangeFactor = 1;

			if ( material.wireframe === true ) {

				index = geometries.getWireframeAttribute( geometry );
				rangeFactor = 2;

			}

			var attribute;
			var renderer = bufferRenderer;

			if ( index !== null ) {

				attribute = attributes.get( index );

				renderer = indexedBufferRenderer;
				renderer.setIndex( attribute );

			}

			if ( updateBuffers ) {

				setupVertexAttributes( material, program, geometry );

				if ( index !== null ) {

					_gl.bindBuffer( _gl.ELEMENT_ARRAY_BUFFER, attribute.buffer );

				}

			}

			//

			var dataCount = 0;

			if ( index !== null ) {

				dataCount = index.count;

			} else if ( position !== undefined ) {

				dataCount = position.count;

			}

			var rangeStart = geometry.drawRange.start * rangeFactor;
			var rangeCount = geometry.drawRange.count * rangeFactor;

			var groupStart = group !== null ? group.start * rangeFactor : 0;
			var groupCount = group !== null ? group.count * rangeFactor : Infinity;

			var drawStart = Math.max( rangeStart, groupStart );
			var drawEnd = Math.min( dataCount, rangeStart + rangeCount, groupStart + groupCount ) - 1;

			var drawCount = Math.max( 0, drawEnd - drawStart + 1 );

			if ( drawCount === 0 ) return;

			//

			if ( object.isMesh ) {

				if ( material.wireframe === true ) {

					state.setLineWidth( material.wireframeLinewidth * getTargetPixelRatio() );
					renderer.setMode( _gl.LINES );

				} else {

					switch ( object.drawMode ) {

						case TrianglesDrawMode:
							renderer.setMode( _gl.TRIANGLES );
							break;

						case TriangleStripDrawMode:
							renderer.setMode( _gl.TRIANGLE_STRIP );
							break;

						case TriangleFanDrawMode:
							renderer.setMode( _gl.TRIANGLE_FAN );
							break;

					}

				}


			} else if ( object.isLine ) {

				var lineWidth = material.linewidth;

				if ( lineWidth === undefined ) lineWidth = 1; // Not using Line*Material

				state.setLineWidth( lineWidth * getTargetPixelRatio() );

				if ( object.isLineSegments ) {

					renderer.setMode( _gl.LINES );

				} else if ( object.isLineLoop ) {

					renderer.setMode( _gl.LINE_LOOP );

				} else {

					renderer.setMode( _gl.LINE_STRIP );

				}

			} else if ( object.isPoints ) {

				renderer.setMode( _gl.POINTS );

			}

			if ( geometry && geometry.isInstancedBufferGeometry ) {

				if ( geometry.maxInstancedCount > 0 ) {

					renderer.renderInstances( geometry, drawStart, drawCount );

				}

			} else {

				renderer.render( drawStart, drawCount );

			}

		};

		function setupVertexAttributes( material, program, geometry, startIndex ) {

			if ( geometry && geometry.isInstancedBufferGeometry ) {

				if ( extensions.get( 'ANGLE_instanced_arrays' ) === null ) {

					console.error( 'THREE.WebGLRenderer.setupVertexAttributes: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.' );
					return;

				}

			}

			if ( startIndex === undefined ) startIndex = 0;

			state.initAttributes();

			var geometryAttributes = geometry.attributes;

			var programAttributes = program.getAttributes();

			var materialDefaultAttributeValues = material.defaultAttributeValues;

			for ( var name in programAttributes ) {

				var programAttribute = programAttributes[ name ];

				if ( programAttribute >= 0 ) {

					var geometryAttribute = geometryAttributes[ name ];

					if ( geometryAttribute !== undefined ) {

						var normalized = geometryAttribute.normalized;
						var size = geometryAttribute.itemSize;

						var attribute = attributes.get( geometryAttribute );

						// TODO Attribute may not be available on context restore

						if ( attribute === undefined ) continue;

						var buffer = attribute.buffer;
						var type = attribute.type;
						var bytesPerElement = attribute.bytesPerElement;

						if ( geometryAttribute.isInterleavedBufferAttribute ) {

							var data = geometryAttribute.data;
							var stride = data.stride;
							var offset = geometryAttribute.offset;

							if ( data && data.isInstancedInterleavedBuffer ) {

								state.enableAttributeAndDivisor( programAttribute, data.meshPerAttribute );

								if ( geometry.maxInstancedCount === undefined ) {

									geometry.maxInstancedCount = data.meshPerAttribute * data.count;

								}

							} else {

								state.enableAttribute( programAttribute );

							}

							_gl.bindBuffer( _gl.ARRAY_BUFFER, buffer );
							_gl.vertexAttribPointer( programAttribute, size, type, normalized, stride * bytesPerElement, ( startIndex * stride + offset ) * bytesPerElement );

						} else {

							if ( geometryAttribute.isInstancedBufferAttribute ) {

								state.enableAttributeAndDivisor( programAttribute, geometryAttribute.meshPerAttribute );

								if ( geometry.maxInstancedCount === undefined ) {

									geometry.maxInstancedCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;

								}

							} else {

								state.enableAttribute( programAttribute );

							}

							_gl.bindBuffer( _gl.ARRAY_BUFFER, buffer );
							_gl.vertexAttribPointer( programAttribute, size, type, normalized, 0, startIndex * size * bytesPerElement );

						}

					} else if ( materialDefaultAttributeValues !== undefined ) {

						var value = materialDefaultAttributeValues[ name ];

						if ( value !== undefined ) {

							switch ( value.length ) {

								case 2:
									_gl.vertexAttrib2fv( programAttribute, value );
									break;

								case 3:
									_gl.vertexAttrib3fv( programAttribute, value );
									break;

								case 4:
									_gl.vertexAttrib4fv( programAttribute, value );
									break;

								default:
									_gl.vertexAttrib1fv( programAttribute, value );

							}

						}

					}

				}

			}

			state.disableUnusedAttributes();

		}

		// Compile

		this.compile = function ( scene, camera ) {

			lightsArray.length = 0;
			shadowsArray.length = 0;

			scene.traverse( function ( object ) {

				if ( object.isLight ) {

					lightsArray.push( object );

					if ( object.castShadow ) {

						shadowsArray.push( object );

					}

				}

			} );

			lights.setup( lightsArray, shadowsArray, camera );

			scene.traverse( function ( object ) {

				if ( object.material ) {

					if ( Array.isArray( object.material ) ) {

						for ( var i = 0; i < object.material.length; i ++ ) {

							initMaterial( object.material[ i ], scene.fog, object );

						}

					} else {

						initMaterial( object.material, scene.fog, object );

					}

				}

			} );

		};

		// Animation Loop

		var isAnimating = false;
		var onAnimationFrame = null;

		function start() {

			if ( isAnimating ) return;
			( vr.getDevice() || window ).requestAnimationFrame( loop );
			isAnimating = true;

		}

		function loop( time ) {

			if ( onAnimationFrame !== null ) onAnimationFrame( time );
			( vr.getDevice() || window ).requestAnimationFrame( loop );

		}

		this.animate = function ( callback ) {

			onAnimationFrame = callback;
			start();

		};

		// Rendering

		this.render = function ( scene, camera, renderTarget, forceClear ) {

			if ( ! ( camera && camera.isCamera ) ) {

				console.error( 'THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.' );
				return;

			}

			if ( _isContextLost ) return;

			// reset caching for this frame

			_currentGeometryProgram = '';
			_currentMaterialId = - 1;
			_currentCamera = null;

			// update scene graph

			if ( scene.autoUpdate === true ) scene.updateMatrixWorld();

			// update camera matrices and frustum

			if ( camera.parent === null ) camera.updateMatrixWorld();

			if ( vr.enabled ) {

				camera = vr.getCamera( camera );

			}

			_projScreenMatrix.multiplyMatrices( camera.projectionMatrix, camera.matrixWorldInverse );
			_frustum.setFromMatrix( _projScreenMatrix );

			lightsArray.length = 0;
			shadowsArray.length = 0;

			spritesArray.length = 0;
			flaresArray.length = 0;

			_localClippingEnabled = this.localClippingEnabled;
			_clippingEnabled = _clipping.init( this.clippingPlanes, _localClippingEnabled, camera );

			currentRenderList = renderLists.get( scene, camera );
			currentRenderList.init();

			projectObject( scene, camera, _this.sortObjects );

			if ( _this.sortObjects === true ) {

				currentRenderList.sort();

			}

			//

			if ( _clippingEnabled ) _clipping.beginShadows();

			shadowMap.render( shadowsArray, scene, camera );

			lights.setup( lightsArray, shadowsArray, camera );

			if ( _clippingEnabled ) _clipping.endShadows();

			//

			_infoRender.frame ++;
			_infoRender.calls = 0;
			_infoRender.vertices = 0;
			_infoRender.faces = 0;
			_infoRender.points = 0;

			if ( renderTarget === undefined ) {

				renderTarget = null;

			}

			this.setRenderTarget( renderTarget );

			//

			background.render( currentRenderList, scene, camera, forceClear );

			// render scene

			var opaqueObjects = currentRenderList.opaque;
			var transparentObjects = currentRenderList.transparent;

			if ( scene.overrideMaterial ) {

				var overrideMaterial = scene.overrideMaterial;

				if ( opaqueObjects.length ) renderObjects( opaqueObjects, scene, camera, overrideMaterial );
				if ( transparentObjects.length ) renderObjects( transparentObjects, scene, camera, overrideMaterial );

			} else {

				// opaque pass (front-to-back order)

				if ( opaqueObjects.length ) renderObjects( opaqueObjects, scene, camera );

				// transparent pass (back-to-front order)

				if ( transparentObjects.length ) renderObjects( transparentObjects, scene, camera );

			}

			// custom renderers

			spriteRenderer.render( spritesArray, scene, camera );
			flareRenderer.render( flaresArray, scene, camera, _currentViewport );

			// Generate mipmap if we're using any kind of mipmap filtering

			if ( renderTarget ) {

				textures.updateRenderTargetMipmap( renderTarget );

			}

			// Ensure depth buffer writing is enabled so it can be cleared on next render

			state.buffers.depth.setTest( true );
			state.buffers.depth.setMask( true );
			state.buffers.color.setMask( true );

			state.setPolygonOffset( false );

			if ( vr.enabled ) {

				vr.submitFrame();

			}

			// _gl.finish();

		};

		/*
		// TODO Duplicated code (Frustum)

		var _sphere = new Sphere();

		function isObjectViewable( object ) {

			var geometry = object.geometry;

			if ( geometry.boundingSphere === null )
				geometry.computeBoundingSphere();

			_sphere.copy( geometry.boundingSphere ).
			applyMatrix4( object.matrixWorld );

			return isSphereViewable( _sphere );

		}

		function isSpriteViewable( sprite ) {

			_sphere.center.set( 0, 0, 0 );
			_sphere.radius = 0.7071067811865476;
			_sphere.applyMatrix4( sprite.matrixWorld );

			return isSphereViewable( _sphere );

		}

		function isSphereViewable( sphere ) {

			if ( ! _frustum.intersectsSphere( sphere ) ) return false;

			var numPlanes = _clipping.numPlanes;

			if ( numPlanes === 0 ) return true;

			var planes = _this.clippingPlanes,

				center = sphere.center,
				negRad = - sphere.radius,
				i = 0;

			do {

				// out when deeper than radius in the negative halfspace
				if ( planes[ i ].distanceToPoint( center ) < negRad ) return false;

			} while ( ++ i !== numPlanes );

			return true;

		}
		*/

		function projectObject( object, camera, sortObjects ) {

			if ( ! object.visible ) return;

			var visible = object.layers.test( camera.layers );

			if ( visible ) {

				if ( object.isLight ) {

					lightsArray.push( object );

					if ( object.castShadow ) {

						shadowsArray.push( object );

					}

				} else if ( object.isSprite ) {

					if ( ! object.frustumCulled || _frustum.intersectsSprite( object ) ) {

						spritesArray.push( object );

					}

				} else if ( object.isLensFlare ) {

					flaresArray.push( object );

				} else if ( object.isImmediateRenderObject ) {

					if ( sortObjects ) {

						_vector3.setFromMatrixPosition( object.matrixWorld )
							.applyMatrix4( _projScreenMatrix );

					}

					currentRenderList.push( object, null, object.material, _vector3.z, null );

				} else if ( object.isMesh || object.isLine || object.isPoints ) {

					if ( object.isSkinnedMesh ) {

						object.skeleton.update();

					}

					if ( ! object.frustumCulled || _frustum.intersectsObject( object ) ) {

						if ( sortObjects ) {

							_vector3.setFromMatrixPosition( object.matrixWorld )
								.applyMatrix4( _projScreenMatrix );

						}

						var geometry = objects.update( object );
						var material = object.material;

						if ( Array.isArray( material ) ) {

							var groups = geometry.groups;

							for ( var i = 0, l = groups.length; i < l; i ++ ) {

								var group = groups[ i ];
								var groupMaterial = material[ group.materialIndex ];

								if ( groupMaterial && groupMaterial.visible ) {

									currentRenderList.push( object, geometry, groupMaterial, _vector3.z, group );

								}

							}

						} else if ( material.visible ) {

							currentRenderList.push( object, geometry, material, _vector3.z, null );

						}

					}

				}

			}

			var children = object.children;

			for ( var i = 0, l = children.length; i < l; i ++ ) {

				projectObject( children[ i ], camera, sortObjects );

			}

		}

		function renderObjects( renderList, scene, camera, overrideMaterial ) {

			for ( var i = 0, l = renderList.length; i < l; i ++ ) {

				var renderItem = renderList[ i ];

				var object = renderItem.object;
				var geometry = renderItem.geometry;
				var material = overrideMaterial === undefined ? renderItem.material : overrideMaterial;
				var group = renderItem.group;

				if ( camera.isArrayCamera ) {

					_currentArrayCamera = camera;

					var cameras = camera.cameras;

					for ( var j = 0, jl = cameras.length; j < jl; j ++ ) {

						var camera2 = cameras[ j ];

						if ( object.layers.test( camera2.layers ) ) {

							var bounds = camera2.bounds;

							var x = bounds.x * _width;
							var y = bounds.y * _height;
							var width = bounds.z * _width;
							var height = bounds.w * _height;

							state.viewport( _currentViewport.set( x, y, width, height ).multiplyScalar( _pixelRatio ) );

							renderObject( object, scene, camera2, geometry, material, group );

						}

					}

				} else {

					_currentArrayCamera = null;

					renderObject( object, scene, camera, geometry, material, group );

				}

			}

		}

		function renderObject( object, scene, camera, geometry, material, group ) {

			object.onBeforeRender( _this, scene, camera, geometry, material, group );

			object.modelViewMatrix.multiplyMatrices( camera.matrixWorldInverse, object.matrixWorld );
			object.normalMatrix.getNormalMatrix( object.modelViewMatrix );

			if ( object.isImmediateRenderObject ) {

				state.setMaterial( material );

				var program = setProgram( camera, scene.fog, material, object );

				_currentGeometryProgram = '';

				renderObjectImmediate( object, program, material );

			} else {

				_this.renderBufferDirect( camera, scene.fog, geometry, material, object, group );

			}

			object.onAfterRender( _this, scene, camera, geometry, material, group );

		}

		function initMaterial( material, fog, object ) {

			var materialProperties = properties.get( material );

			var parameters = programCache.getParameters(
				material, lights.state, shadowsArray, fog, _clipping.numPlanes, _clipping.numIntersection, object );

			var code = programCache.getProgramCode( material, parameters );

			var program = materialProperties.program;
			var programChange = true;

			if ( program === undefined ) {

				// new material
				material.addEventListener( 'dispose', onMaterialDispose );

			} else if ( program.code !== code ) {

				// changed glsl or parameters
				releaseMaterialProgramReference( material );

			} else if ( parameters.shaderID !== undefined ) {

				// same glsl and uniform list
				return;

			} else {

				// only rebuild uniform list
				programChange = false;

			}

			if ( programChange ) {

				if ( parameters.shaderID ) {

					var shader = ShaderLib[ parameters.shaderID ];

					materialProperties.shader = {
						name: material.type,
						uniforms: UniformsUtils.clone( shader.uniforms ),
						vertexShader: shader.vertexShader,
						fragmentShader: shader.fragmentShader
					};

				} else {

					materialProperties.shader = {
						name: material.type,
						uniforms: material.uniforms,
						vertexShader: material.vertexShader,
						fragmentShader: material.fragmentShader
					};

				}

				material.onBeforeCompile( materialProperties.shader );

				program = programCache.acquireProgram( material, materialProperties.shader, parameters, code );

				materialProperties.program = program;
				material.program = program;

			}

			var programAttributes = program.getAttributes();

			if ( material.morphTargets ) {

				material.numSupportedMorphTargets = 0;

				for ( var i = 0; i < _this.maxMorphTargets; i ++ ) {

					if ( programAttributes[ 'morphTarget' + i ] >= 0 ) {

						material.numSupportedMorphTargets ++;

					}

				}

			}

			if ( material.morphNormals ) {

				material.numSupportedMorphNormals = 0;

				for ( var i = 0; i < _this.maxMorphNormals; i ++ ) {

					if ( programAttributes[ 'morphNormal' + i ] >= 0 ) {

						material.numSupportedMorphNormals ++;

					}

				}

			}

			var uniforms = materialProperties.shader.uniforms;

			if ( ! material.isShaderMaterial &&
				! material.isRawShaderMaterial ||
				material.clipping === true ) {

				materialProperties.numClippingPlanes = _clipping.numPlanes;
				materialProperties.numIntersection = _clipping.numIntersection;
				uniforms.clippingPlanes = _clipping.uniform;

			}

			materialProperties.fog = fog;

			// store the light setup it was created for

			materialProperties.lightsHash = lights.state.hash;

			if ( material.lights ) {

				// wire up the material to this renderer's lighting state

				uniforms.ambientLightColor.value = lights.state.ambient;
				uniforms.directionalLights.value = lights.state.directional;
				uniforms.spotLights.value = lights.state.spot;
				uniforms.rectAreaLights.value = lights.state.rectArea;
				uniforms.pointLights.value = lights.state.point;
				uniforms.hemisphereLights.value = lights.state.hemi;

				uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
				uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
				uniforms.spotShadowMap.value = lights.state.spotShadowMap;
				uniforms.spotShadowMatrix.value = lights.state.spotShadowMatrix;
				uniforms.pointShadowMap.value = lights.state.pointShadowMap;
				uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
				// TODO (abelnation): add area lights shadow info to uniforms

			}

			var progUniforms = materialProperties.program.getUniforms(),
				uniformsList =
					WebGLUniforms.seqWithValue( progUniforms.seq, uniforms );

			materialProperties.uniformsList = uniformsList;

		}

		function setProgram( camera, fog, material, object ) {

			_usedTextureUnits = 0;

			var materialProperties = properties.get( material );

			if ( _clippingEnabled ) {

				if ( _localClippingEnabled || camera !== _currentCamera ) {

					var useCache =
						camera === _currentCamera &&
						material.id === _currentMaterialId;

					// we might want to call this function with some ClippingGroup
					// object instead of the material, once it becomes feasible
					// (#8465, #8379)
					_clipping.setState(
						material.clippingPlanes, material.clipIntersection, material.clipShadows,
						camera, materialProperties, useCache );

				}

			}

			if ( material.needsUpdate === false ) {

				if ( materialProperties.program === undefined ) {

					material.needsUpdate = true;

				} else if ( material.fog && materialProperties.fog !== fog ) {

					material.needsUpdate = true;

				} else if ( material.lights && materialProperties.lightsHash !== lights.state.hash ) {

					material.needsUpdate = true;

				} else if ( materialProperties.numClippingPlanes !== undefined &&
					( materialProperties.numClippingPlanes !== _clipping.numPlanes ||
					materialProperties.numIntersection !== _clipping.numIntersection ) ) {

					material.needsUpdate = true;

				}

			}

			if ( material.needsUpdate ) {

				initMaterial( material, fog, object );
				material.needsUpdate = false;

			}

			var refreshProgram = false;
			var refreshMaterial = false;
			var refreshLights = false;

			var program = materialProperties.program,
				p_uniforms = program.getUniforms(),
				m_uniforms = materialProperties.shader.uniforms;

			if ( state.useProgram( program.program ) ) {

				refreshProgram = true;
				refreshMaterial = true;
				refreshLights = true;

			}

			if ( material.id !== _currentMaterialId ) {

				_currentMaterialId = material.id;

				refreshMaterial = true;

			}

			if ( refreshProgram || camera !== _currentCamera ) {

				p_uniforms.setValue( _gl, 'projectionMatrix', camera.projectionMatrix );

				if ( capabilities.logarithmicDepthBuffer ) {

					p_uniforms.setValue( _gl, 'logDepthBufFC',
						2.0 / ( Math.log( camera.far + 1.0 ) / Math.LN2 ) );

				}

				// Avoid unneeded uniform updates per ArrayCamera's sub-camera

				if ( _currentCamera !== ( _currentArrayCamera || camera ) ) {

					_currentCamera = ( _currentArrayCamera || camera );

					// lighting uniforms depend on the camera so enforce an update
					// now, in case this material supports lights - or later, when
					// the next material that does gets activated:

					refreshMaterial = true;		// set to true on material change
					refreshLights = true;		// remains set until update done

				}

				// load material specific uniforms
				// (shader material also gets them for the sake of genericity)

				if ( material.isShaderMaterial ||
					material.isMeshPhongMaterial ||
					material.isMeshStandardMaterial ||
					material.envMap ) {

					var uCamPos = p_uniforms.map.cameraPosition;

					if ( uCamPos !== undefined ) {

						uCamPos.setValue( _gl,
							_vector3.setFromMatrixPosition( camera.matrixWorld ) );

					}

				}

				if ( material.isMeshPhongMaterial ||
					material.isMeshLambertMaterial ||
					material.isMeshBasicMaterial ||
					material.isMeshStandardMaterial ||
					material.isShaderMaterial ||
					material.skinning ) {

					p_uniforms.setValue( _gl, 'viewMatrix', camera.matrixWorldInverse );

				}

			}

			// skinning uniforms must be set even if material didn't change
			// auto-setting of texture unit for bone texture must go before other textures
			// not sure why, but otherwise weird things happen

			if ( material.skinning ) {

				p_uniforms.setOptional( _gl, object, 'bindMatrix' );
				p_uniforms.setOptional( _gl, object, 'bindMatrixInverse' );

				var skeleton = object.skeleton;

				if ( skeleton ) {

					var bones = skeleton.bones;

					if ( capabilities.floatVertexTextures ) {

						if ( skeleton.boneTexture === undefined ) {

							// layout (1 matrix = 4 pixels)
							//      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
							//  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
							//       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
							//       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
							//       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)


							var size = Math.sqrt( bones.length * 4 ); // 4 pixels needed for 1 matrix
							size = _Math.nextPowerOfTwo( Math.ceil( size ) );
							size = Math.max( size, 4 );

							var boneMatrices = new Float32Array( size * size * 4 ); // 4 floats per RGBA pixel
							boneMatrices.set( skeleton.boneMatrices ); // copy current values

							var boneTexture = new DataTexture( boneMatrices, size, size, RGBAFormat, FloatType );

							skeleton.boneMatrices = boneMatrices;
							skeleton.boneTexture = boneTexture;
							skeleton.boneTextureSize = size;

						}

						p_uniforms.setValue( _gl, 'boneTexture', skeleton.boneTexture );
						p_uniforms.setValue( _gl, 'boneTextureSize', skeleton.boneTextureSize );

					} else {

						p_uniforms.setOptional( _gl, skeleton, 'boneMatrices' );

					}

				}

			}

			if ( refreshMaterial ) {

				p_uniforms.setValue( _gl, 'toneMappingExposure', _this.toneMappingExposure );
				p_uniforms.setValue( _gl, 'toneMappingWhitePoint', _this.toneMappingWhitePoint );

				if ( material.lights ) {

					// the current material requires lighting info

					// note: all lighting uniforms are always set correctly
					// they simply reference the renderer's state for their
					// values
					//
					// use the current material's .needsUpdate flags to set
					// the GL state when required

					markUniformsLightsNeedsUpdate( m_uniforms, refreshLights );

				}

				// refresh uniforms common to several materials

				if ( fog && material.fog ) {

					refreshUniformsFog( m_uniforms, fog );

				}

				if ( material.isMeshBasicMaterial ) {

					refreshUniformsCommon( m_uniforms, material );

				} else if ( material.isMeshLambertMaterial ) {

					refreshUniformsCommon( m_uniforms, material );
					refreshUniformsLambert( m_uniforms, material );

				} else if ( material.isMeshPhongMaterial ) {

					refreshUniformsCommon( m_uniforms, material );

					if ( material.isMeshToonMaterial ) {

						refreshUniformsToon( m_uniforms, material );

					} else {

						refreshUniformsPhong( m_uniforms, material );

					}

				} else if ( material.isMeshStandardMaterial ) {

					refreshUniformsCommon( m_uniforms, material );

					if ( material.isMeshPhysicalMaterial ) {

						refreshUniformsPhysical( m_uniforms, material );

					} else {

						refreshUniformsStandard( m_uniforms, material );

					}

				} else if ( material.isMeshDepthMaterial ) {

					refreshUniformsCommon( m_uniforms, material );
					refreshUniformsDepth( m_uniforms, material );

				} else if ( material.isMeshDistanceMaterial ) {

					refreshUniformsCommon( m_uniforms, material );
					refreshUniformsDistance( m_uniforms, material );

				} else if ( material.isMeshNormalMaterial ) {

					refreshUniformsCommon( m_uniforms, material );
					refreshUniformsNormal( m_uniforms, material );

				} else if ( material.isLineBasicMaterial ) {

					refreshUniformsLine( m_uniforms, material );

					if ( material.isLineDashedMaterial ) {

						refreshUniformsDash( m_uniforms, material );

					}

				} else if ( material.isPointsMaterial ) {

					refreshUniformsPoints( m_uniforms, material );

				} else if ( material.isShadowMaterial ) {

					m_uniforms.color.value = material.color;
					m_uniforms.opacity.value = material.opacity;

				}

				// RectAreaLight Texture
				// TODO (mrdoob): Find a nicer implementation

				if ( m_uniforms.ltcMat !== undefined ) m_uniforms.ltcMat.value = UniformsLib.LTC_MAT_TEXTURE;
				if ( m_uniforms.ltcMag !== undefined ) m_uniforms.ltcMag.value = UniformsLib.LTC_MAG_TEXTURE;

				WebGLUniforms.upload(
					_gl, materialProperties.uniformsList, m_uniforms, _this );

			}


			// common matrices

			p_uniforms.setValue( _gl, 'modelViewMatrix', object.modelViewMatrix );
			p_uniforms.setValue( _gl, 'normalMatrix', object.normalMatrix );
			p_uniforms.setValue( _gl, 'modelMatrix', object.matrixWorld );

			return program;

		}

		// Uniforms (refresh uniforms objects)

		function refreshUniformsCommon( uniforms, material ) {

			uniforms.opacity.value = material.opacity;

			if ( material.color ) {

				uniforms.diffuse.value = material.color;

			}

			if ( material.emissive ) {

				uniforms.emissive.value.copy( material.emissive ).multiplyScalar( material.emissiveIntensity );

			}

			if ( material.map ) {

				uniforms.map.value = material.map;

			}

			if ( material.alphaMap ) {

				uniforms.alphaMap.value = material.alphaMap;

			}

			if ( material.specularMap ) {

				uniforms.specularMap.value = material.specularMap;

			}

			if ( material.envMap ) {

				uniforms.envMap.value = material.envMap;

				// don't flip CubeTexture envMaps, flip everything else:
				//  WebGLRenderTargetCube will be flipped for backwards compatibility
				//  WebGLRenderTargetCube.texture will be flipped because it's a Texture and NOT a CubeTexture
				// this check must be handled differently, or removed entirely, if WebGLRenderTargetCube uses a CubeTexture in the future
				uniforms.flipEnvMap.value = ( ! ( material.envMap && material.envMap.isCubeTexture ) ) ? 1 : - 1;

				uniforms.reflectivity.value = material.reflectivity;
				uniforms.refractionRatio.value = material.refractionRatio;

			}

			if ( material.lightMap ) {

				uniforms.lightMap.value = material.lightMap;
				uniforms.lightMapIntensity.value = material.lightMapIntensity;

			}

			if ( material.aoMap ) {

				uniforms.aoMap.value = material.aoMap;
				uniforms.aoMapIntensity.value = material.aoMapIntensity;

			}

			// uv repeat and offset setting priorities
			// 1. color map
			// 2. specular map
			// 3. normal map
			// 4. bump map
			// 5. alpha map
			// 6. emissive map

			var uvScaleMap;

			if ( material.map ) {

				uvScaleMap = material.map;

			} else if ( material.specularMap ) {

				uvScaleMap = material.specularMap;

			} else if ( material.displacementMap ) {

				uvScaleMap = material.displacementMap;

			} else if ( material.normalMap ) {

				uvScaleMap = material.normalMap;

			} else if ( material.bumpMap ) {

				uvScaleMap = material.bumpMap;

			} else if ( material.roughnessMap ) {

				uvScaleMap = material.roughnessMap;

			} else if ( material.metalnessMap ) {

				uvScaleMap = material.metalnessMap;

			} else if ( material.alphaMap ) {

				uvScaleMap = material.alphaMap;

			} else if ( material.emissiveMap ) {

				uvScaleMap = material.emissiveMap;

			}

			if ( uvScaleMap !== undefined ) {

				// backwards compatibility
				if ( uvScaleMap.isWebGLRenderTarget ) {

					uvScaleMap = uvScaleMap.texture;

				}

				var offset = uvScaleMap.offset;
				var repeat = uvScaleMap.repeat;

				uniforms.offsetRepeat.value.set( offset.x, offset.y, repeat.x, repeat.y );

			}

		}

		function refreshUniformsLine( uniforms, material ) {

			uniforms.diffuse.value = material.color;
			uniforms.opacity.value = material.opacity;

		}

		function refreshUniformsDash( uniforms, material ) {

			uniforms.dashSize.value = material.dashSize;
			uniforms.totalSize.value = material.dashSize + material.gapSize;
			uniforms.scale.value = material.scale;

		}

		function refreshUniformsPoints( uniforms, material ) {

			uniforms.diffuse.value = material.color;
			uniforms.opacity.value = material.opacity;
			uniforms.size.value = material.size * _pixelRatio;
			uniforms.scale.value = _height * 0.5;

			uniforms.map.value = material.map;

			if ( material.map !== null ) {

				var offset = material.map.offset;
				var repeat = material.map.repeat;

				uniforms.offsetRepeat.value.set( offset.x, offset.y, repeat.x, repeat.y );

			}

		}

		function refreshUniformsFog( uniforms, fog ) {

			uniforms.fogColor.value = fog.color;

			if ( fog.isFog ) {

				uniforms.fogNear.value = fog.near;
				uniforms.fogFar.value = fog.far;

			} else if ( fog.isFogExp2 ) {

				uniforms.fogDensity.value = fog.density;

			}

		}

		function refreshUniformsLambert( uniforms, material ) {

			if ( material.emissiveMap ) {

				uniforms.emissiveMap.value = material.emissiveMap;

			}

		}

		function refreshUniformsPhong( uniforms, material ) {

			uniforms.specular.value = material.specular;
			uniforms.shininess.value = Math.max( material.shininess, 1e-4 ); // to prevent pow( 0.0, 0.0 )

			if ( material.emissiveMap ) {

				uniforms.emissiveMap.value = material.emissiveMap;

			}

			if ( material.bumpMap ) {

				uniforms.bumpMap.value = material.bumpMap;
				uniforms.bumpScale.value = material.bumpScale;

			}

			if ( material.normalMap ) {

				uniforms.normalMap.value = material.normalMap;
				uniforms.normalScale.value.copy( material.normalScale );

			}

			if ( material.displacementMap ) {

				uniforms.displacementMap.value = material.displacementMap;
				uniforms.displacementScale.value = material.displacementScale;
				uniforms.displacementBias.value = material.displacementBias;

			}

		}

		function refreshUniformsToon( uniforms, material ) {

			refreshUniformsPhong( uniforms, material );

			if ( material.gradientMap ) {

				uniforms.gradientMap.value = material.gradientMap;

			}

		}

		function refreshUniformsStandard( uniforms, material ) {

			uniforms.roughness.value = material.roughness;
			uniforms.metalness.value = material.metalness;

			if ( material.roughnessMap ) {

				uniforms.roughnessMap.value = material.roughnessMap;

			}

			if ( material.metalnessMap ) {

				uniforms.metalnessMap.value = material.metalnessMap;

			}

			if ( material.emissiveMap ) {

				uniforms.emissiveMap.value = material.emissiveMap;

			}

			if ( material.bumpMap ) {

				uniforms.bumpMap.value = material.bumpMap;
				uniforms.bumpScale.value = material.bumpScale;

			}

			if ( material.normalMap ) {

				uniforms.normalMap.value = material.normalMap;
				uniforms.normalScale.value.copy( material.normalScale );

			}

			if ( material.displacementMap ) {

				uniforms.displacementMap.value = material.displacementMap;
				uniforms.displacementScale.value = material.displacementScale;
				uniforms.displacementBias.value = material.displacementBias;

			}

			if ( material.envMap ) {

				//uniforms.envMap.value = material.envMap; // part of uniforms common
				uniforms.envMapIntensity.value = material.envMapIntensity;

			}

		}

		function refreshUniformsPhysical( uniforms, material ) {

			uniforms.clearCoat.value = material.clearCoat;
			uniforms.clearCoatRoughness.value = material.clearCoatRoughness;

			refreshUniformsStandard( uniforms, material );

		}

		function refreshUniformsDepth( uniforms, material ) {

			if ( material.displacementMap ) {

				uniforms.displacementMap.value = material.displacementMap;
				uniforms.displacementScale.value = material.displacementScale;
				uniforms.displacementBias.value = material.displacementBias;

			}

		}

		function refreshUniformsDistance( uniforms, material ) {

			if ( material.displacementMap ) {

				uniforms.displacementMap.value = material.displacementMap;
				uniforms.displacementScale.value = material.displacementScale;
				uniforms.displacementBias.value = material.displacementBias;

			}

			uniforms.referencePosition.value.copy( material.referencePosition );
			uniforms.nearDistance.value = material.nearDistance;
			uniforms.farDistance.value = material.farDistance;

		}

		function refreshUniformsNormal( uniforms, material ) {

			if ( material.bumpMap ) {

				uniforms.bumpMap.value = material.bumpMap;
				uniforms.bumpScale.value = material.bumpScale;

			}

			if ( material.normalMap ) {

				uniforms.normalMap.value = material.normalMap;
				uniforms.normalScale.value.copy( material.normalScale );

			}

			if ( material.displacementMap ) {

				uniforms.displacementMap.value = material.displacementMap;
				uniforms.displacementScale.value = material.displacementScale;
				uniforms.displacementBias.value = material.displacementBias;

			}

		}

		// If uniforms are marked as clean, they don't need to be loaded to the GPU.

		function markUniformsLightsNeedsUpdate( uniforms, value ) {

			uniforms.ambientLightColor.needsUpdate = value;

			uniforms.directionalLights.needsUpdate = value;
			uniforms.pointLights.needsUpdate = value;
			uniforms.spotLights.needsUpdate = value;
			uniforms.rectAreaLights.needsUpdate = value;
			uniforms.hemisphereLights.needsUpdate = value;

		}

		// GL state setting

		this.setFaceCulling = function ( cullFace, frontFaceDirection ) {

			state.setCullFace( cullFace );
			state.setFlipSided( frontFaceDirection === FrontFaceDirectionCW );

		};

		// Textures

		function allocTextureUnit() {

			var textureUnit = _usedTextureUnits;

			if ( textureUnit >= capabilities.maxTextures ) {

				console.warn( 'THREE.WebGLRenderer: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures );

			}

			_usedTextureUnits += 1;

			return textureUnit;

		}

		this.allocTextureUnit = allocTextureUnit;

		// this.setTexture2D = setTexture2D;
		this.setTexture2D = ( function () {

			var warned = false;

			// backwards compatibility: peel texture.texture
			return function setTexture2D( texture, slot ) {

				if ( texture && texture.isWebGLRenderTarget ) {

					if ( ! warned ) {

						console.warn( "THREE.WebGLRenderer.setTexture2D: don't use render targets as textures. Use their .texture property instead." );
						warned = true;

					}

					texture = texture.texture;

				}

				textures.setTexture2D( texture, slot );

			};

		}() );

		this.setTexture = ( function () {

			var warned = false;

			return function setTexture( texture, slot ) {

				if ( ! warned ) {

					console.warn( "THREE.WebGLRenderer: .setTexture is deprecated, use setTexture2D instead." );
					warned = true;

				}

				textures.setTexture2D( texture, slot );

			};

		}() );

		this.setTextureCube = ( function () {

			var warned = false;

			return function setTextureCube( texture, slot ) {

				// backwards compatibility: peel texture.texture
				if ( texture && texture.isWebGLRenderTargetCube ) {

					if ( ! warned ) {

						console.warn( "THREE.WebGLRenderer.setTextureCube: don't use cube render targets as textures. Use their .texture property instead." );
						warned = true;

					}

					texture = texture.texture;

				}

				// currently relying on the fact that WebGLRenderTargetCube.texture is a Texture and NOT a CubeTexture
				// TODO: unify these code paths
				if ( ( texture && texture.isCubeTexture ) ||
					( Array.isArray( texture.image ) && texture.image.length === 6 ) ) {

					// CompressedTexture can have Array in image :/

					// this function alone should take care of cube textures
					textures.setTextureCube( texture, slot );

				} else {

					// assumed: texture property of THREE.WebGLRenderTargetCube

					textures.setTextureCubeDynamic( texture, slot );

				}

			};

		}() );

		this.getRenderTarget = function () {

			return _currentRenderTarget;

		};

		this.setRenderTarget = function ( renderTarget ) {

			_currentRenderTarget = renderTarget;

			if ( renderTarget && properties.get( renderTarget ).__webglFramebuffer === undefined ) {

				textures.setupRenderTarget( renderTarget );

			}

			var framebuffer = null;
			var isCube = false;

			if ( renderTarget ) {

				var __webglFramebuffer = properties.get( renderTarget ).__webglFramebuffer;

				if ( renderTarget.isWebGLRenderTargetCube ) {

					framebuffer = __webglFramebuffer[ renderTarget.activeCubeFace ];
					isCube = true;

				} else {

					framebuffer = __webglFramebuffer;

				}

				_currentViewport.copy( renderTarget.viewport );
				_currentScissor.copy( renderTarget.scissor );
				_currentScissorTest = renderTarget.scissorTest;

			} else {

				_currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio );
				_currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio );
				_currentScissorTest = _scissorTest;

			}

			if ( _currentFramebuffer !== framebuffer ) {

				_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );
				_currentFramebuffer = framebuffer;

			}

			state.viewport( _currentViewport );
			state.scissor( _currentScissor );
			state.setScissorTest( _currentScissorTest );

			if ( isCube ) {

				var textureProperties = properties.get( renderTarget.texture );
				_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + renderTarget.activeCubeFace, textureProperties.__webglTexture, renderTarget.activeMipMapLevel );

			}

		};

		this.readRenderTargetPixels = function ( renderTarget, x, y, width, height, buffer ) {

			if ( ! ( renderTarget && renderTarget.isWebGLRenderTarget ) ) {

				console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.' );
				return;

			}

			var framebuffer = properties.get( renderTarget ).__webglFramebuffer;

			if ( framebuffer ) {

				var restore = false;

				if ( framebuffer !== _currentFramebuffer ) {

					_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

					restore = true;

				}

				try {

					var texture = renderTarget.texture;
					var textureFormat = texture.format;
					var textureType = texture.type;

					if ( textureFormat !== RGBAFormat && utils.convert( textureFormat ) !== _gl.getParameter( _gl.IMPLEMENTATION_COLOR_READ_FORMAT ) ) {

						console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.' );
						return;

					}

					if ( textureType !== UnsignedByteType && utils.convert( textureType ) !== _gl.getParameter( _gl.IMPLEMENTATION_COLOR_READ_TYPE ) && // IE11, Edge and Chrome Mac < 52 (#9513)
						! ( textureType === FloatType && ( extensions.get( 'OES_texture_float' ) || extensions.get( 'WEBGL_color_buffer_float' ) ) ) && // Chrome Mac >= 52 and Firefox
						! ( textureType === HalfFloatType && extensions.get( 'EXT_color_buffer_half_float' ) ) ) {

						console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.' );
						return;

					}

					if ( _gl.checkFramebufferStatus( _gl.FRAMEBUFFER ) === _gl.FRAMEBUFFER_COMPLETE ) {

						// the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)

						if ( ( x >= 0 && x <= ( renderTarget.width - width ) ) && ( y >= 0 && y <= ( renderTarget.height - height ) ) ) {

							_gl.readPixels( x, y, width, height, utils.convert( textureFormat ), utils.convert( textureType ), buffer );

						}

					} else {

						console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.' );

					}

				} finally {

					if ( restore ) {

						_gl.bindFramebuffer( _gl.FRAMEBUFFER, _currentFramebuffer );

					}

				}

			}

		};

	}

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 */

	function FogExp2 ( color, density ) {

		this.name = '';

		this.color = new Color( color );
		this.density = ( density !== undefined ) ? density : 0.00025;

	}

	FogExp2.prototype.isFogExp2 = true;

	FogExp2.prototype.clone = function () {

		return new FogExp2( this.color.getHex(), this.density );

	};

	FogExp2.prototype.toJSON = function ( meta ) {

		return {
			type: 'FogExp2',
			color: this.color.getHex(),
			density: this.density
		};

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 */

	function Fog ( color, near, far ) {

		this.name = '';

		this.color = new Color( color );

		this.near = ( near !== undefined ) ? near : 1;
		this.far = ( far !== undefined ) ? far : 1000;

	}

	Fog.prototype.isFog = true;

	Fog.prototype.clone = function () {

		return new Fog( this.color.getHex(), this.near, this.far );

	};

	Fog.prototype.toJSON = function ( meta ) {

		return {
			type: 'Fog',
			color: this.color.getHex(),
			near: this.near,
			far: this.far
		};

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function Scene () {

		Object3D.call( this );

		this.type = 'Scene';

		this.background = null;
		this.fog = null;
		this.overrideMaterial = null;

		this.autoUpdate = true; // checked by the renderer

	}

	Scene.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: Scene,

		copy: function ( source, recursive ) {

			Object3D.prototype.copy.call( this, source, recursive );

			if ( source.background !== null ) this.background = source.background.clone();
			if ( source.fog !== null ) this.fog = source.fog.clone();
			if ( source.overrideMaterial !== null ) this.overrideMaterial = source.overrideMaterial.clone();

			this.autoUpdate = source.autoUpdate;
			this.matrixAutoUpdate = source.matrixAutoUpdate;

			return this;

		},

		toJSON: function ( meta ) {

			var data = Object3D.prototype.toJSON.call( this, meta );

			if ( this.background !== null ) data.object.background = this.background.toJSON( meta );
			if ( this.fog !== null ) data.object.fog = this.fog.toJSON();

			return data;

		}

	} );

	/**
	 * @author mikael emtinger / http://gomo.se/
	 * @author alteredq / http://alteredqualia.com/
	 */

	function LensFlare( texture, size, distance, blending, color ) {

		Object3D.call( this );

		this.lensFlares = [];

		this.positionScreen = new Vector3();
		this.customUpdateCallback = undefined;

		if ( texture !== undefined ) {

			this.add( texture, size, distance, blending, color );

		}

	}

	LensFlare.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: LensFlare,

		isLensFlare: true,

		copy: function ( source ) {

			Object3D.prototype.copy.call( this, source );

			this.positionScreen.copy( source.positionScreen );
			this.customUpdateCallback = source.customUpdateCallback;

			for ( var i = 0, l = source.lensFlares.length; i < l; i ++ ) {

				this.lensFlares.push( source.lensFlares[ i ] );

			}

			return this;

		},

		add: function ( texture, size, distance, blending, color, opacity ) {

			if ( size === undefined ) size = - 1;
			if ( distance === undefined ) distance = 0;
			if ( opacity === undefined ) opacity = 1;
			if ( color === undefined ) color = new Color( 0xffffff );
			if ( blending === undefined ) blending = NormalBlending;

			distance = Math.min( distance, Math.max( 0, distance ) );

			this.lensFlares.push( {
				texture: texture,	// THREE.Texture
				size: size, 		// size in pixels (-1 = use texture.width)
				distance: distance, 	// distance (0-1) from light source (0=at light source)
				x: 0, y: 0, z: 0,	// screen position (-1 => 1) z = 0 is in front z = 1 is back
				scale: 1, 		// scale
				rotation: 0, 		// rotation
				opacity: opacity,	// opacity
				color: color,		// color
				blending: blending	// blending
			} );

		},

		/*
		 * Update lens flares update positions on all flares based on the screen position
		 * Set myLensFlare.customUpdateCallback to alter the flares in your project specific way.
		 */

		updateLensFlares: function () {

			var f, fl = this.lensFlares.length;
			var flare;
			var vecX = - this.positionScreen.x * 2;
			var vecY = - this.positionScreen.y * 2;

			for ( f = 0; f < fl; f ++ ) {

				flare = this.lensFlares[ f ];

				flare.x = this.positionScreen.x + vecX * flare.distance;
				flare.y = this.positionScreen.y + vecY * flare.distance;

				flare.wantedRotation = flare.x * Math.PI * 0.25;
				flare.rotation += ( flare.wantedRotation - flare.rotation ) * 0.25;

			}

		}

	} );

	/**
	 * @author alteredq / http://alteredqualia.com/
	 *
	 * parameters = {
	 *  color: <hex>,
	 *  opacity: <float>,
	 *  map: new THREE.Texture( <Image> ),
	 *
	 *	uvOffset: new THREE.Vector2(),
	 *	uvScale: new THREE.Vector2()
	 * }
	 */

	function SpriteMaterial( parameters ) {

		Material.call( this );

		this.type = 'SpriteMaterial';

		this.color = new Color( 0xffffff );
		this.map = null;

		this.rotation = 0;

		this.fog = false;
		this.lights = false;

		this.setValues( parameters );

	}

	SpriteMaterial.prototype = Object.create( Material.prototype );
	SpriteMaterial.prototype.constructor = SpriteMaterial;
	SpriteMaterial.prototype.isSpriteMaterial = true;

	SpriteMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.color.copy( source.color );
		this.map = source.map;

		this.rotation = source.rotation;

		return this;

	};

	/**
	 * @author mikael emtinger / http://gomo.se/
	 * @author alteredq / http://alteredqualia.com/
	 */

	function Sprite( material ) {

		Object3D.call( this );

		this.type = 'Sprite';

		this.material = ( material !== undefined ) ? material : new SpriteMaterial();

	}

	Sprite.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: Sprite,

		isSprite: true,

		raycast: ( function () {

			var intersectPoint = new Vector3();
			var worldPosition = new Vector3();
			var worldScale = new Vector3();

			return function raycast( raycaster, intersects ) {

				worldPosition.setFromMatrixPosition( this.matrixWorld );
				raycaster.ray.closestPointToPoint( worldPosition, intersectPoint );

				worldScale.setFromMatrixScale( this.matrixWorld );
				var guessSizeSq = worldScale.x * worldScale.y / 4;

				if ( worldPosition.distanceToSquared( intersectPoint ) > guessSizeSq ) return;

				var distance = raycaster.ray.origin.distanceTo( intersectPoint );

				if ( distance < raycaster.near || distance > raycaster.far ) return;

				intersects.push( {

					distance: distance,
					point: intersectPoint.clone(),
					face: null,
					object: this

				} );

			};

		}() ),

		clone: function () {

			return new this.constructor( this.material ).copy( this );

		}

	} );

	/**
	 * @author mikael emtinger / http://gomo.se/
	 * @author alteredq / http://alteredqualia.com/
	 * @author mrdoob / http://mrdoob.com/
	 */

	function LOD() {

		Object3D.call( this );

		this.type = 'LOD';

		Object.defineProperties( this, {
			levels: {
				enumerable: true,
				value: []
			}
		} );

	}

	LOD.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: LOD,

		copy: function ( source ) {

			Object3D.prototype.copy.call( this, source, false );

			var levels = source.levels;

			for ( var i = 0, l = levels.length; i < l; i ++ ) {

				var level = levels[ i ];

				this.addLevel( level.object.clone(), level.distance );

			}

			return this;

		},

		addLevel: function ( object, distance ) {

			if ( distance === undefined ) distance = 0;

			distance = Math.abs( distance );

			var levels = this.levels;

			for ( var l = 0; l < levels.length; l ++ ) {

				if ( distance < levels[ l ].distance ) {

					break;

				}

			}

			levels.splice( l, 0, { distance: distance, object: object } );

			this.add( object );

		},

		getObjectForDistance: function ( distance ) {

			var levels = this.levels;

			for ( var i = 1, l = levels.length; i < l; i ++ ) {

				if ( distance < levels[ i ].distance ) {

					break;

				}

			}

			return levels[ i - 1 ].object;

		},

		raycast: ( function () {

			var matrixPosition = new Vector3();

			return function raycast( raycaster, intersects ) {

				matrixPosition.setFromMatrixPosition( this.matrixWorld );

				var distance = raycaster.ray.origin.distanceTo( matrixPosition );

				this.getObjectForDistance( distance ).raycast( raycaster, intersects );

			};

		}() ),

		update: function () {

			var v1 = new Vector3();
			var v2 = new Vector3();

			return function update( camera ) {

				var levels = this.levels;

				if ( levels.length > 1 ) {

					v1.setFromMatrixPosition( camera.matrixWorld );
					v2.setFromMatrixPosition( this.matrixWorld );

					var distance = v1.distanceTo( v2 );

					levels[ 0 ].object.visible = true;

					for ( var i = 1, l = levels.length; i < l; i ++ ) {

						if ( distance >= levels[ i ].distance ) {

							levels[ i - 1 ].object.visible = false;
							levels[ i ].object.visible = true;

						} else {

							break;

						}

					}

					for ( ; i < l; i ++ ) {

						levels[ i ].object.visible = false;

					}

				}

			};

		}(),

		toJSON: function ( meta ) {

			var data = Object3D.prototype.toJSON.call( this, meta );

			data.object.levels = [];

			var levels = this.levels;

			for ( var i = 0, l = levels.length; i < l; i ++ ) {

				var level = levels[ i ];

				data.object.levels.push( {
					object: level.object.uuid,
					distance: level.distance
				} );

			}

			return data;

		}

	} );

	/**
	 * @author mikael emtinger / http://gomo.se/
	 * @author alteredq / http://alteredqualia.com/
	 * @author michael guerrero / http://realitymeltdown.com
	 * @author ikerr / http://verold.com
	 */

	function Skeleton( bones, boneInverses ) {

		// copy the bone array

		bones = bones || [];

		this.bones = bones.slice( 0 );
		this.boneMatrices = new Float32Array( this.bones.length * 16 );

		// use the supplied bone inverses or calculate the inverses

		if ( boneInverses === undefined ) {

			this.calculateInverses();

		} else {

			if ( this.bones.length === boneInverses.length ) {

				this.boneInverses = boneInverses.slice( 0 );

			} else {

				console.warn( 'THREE.Skeleton boneInverses is the wrong length.' );

				this.boneInverses = [];

				for ( var i = 0, il = this.bones.length; i < il; i ++ ) {

					this.boneInverses.push( new Matrix4() );

				}

			}

		}

	}

	Object.assign( Skeleton.prototype, {

		calculateInverses: function () {

			this.boneInverses = [];

			for ( var i = 0, il = this.bones.length; i < il; i ++ ) {

				var inverse = new Matrix4();

				if ( this.bones[ i ] ) {

					inverse.getInverse( this.bones[ i ].matrixWorld );

				}

				this.boneInverses.push( inverse );

			}

		},

		pose: function () {

			var bone, i, il;

			// recover the bind-time world matrices

			for ( i = 0, il = this.bones.length; i < il; i ++ ) {

				bone = this.bones[ i ];

				if ( bone ) {

					bone.matrixWorld.getInverse( this.boneInverses[ i ] );

				}

			}

			// compute the local matrices, positions, rotations and scales

			for ( i = 0, il = this.bones.length; i < il; i ++ ) {

				bone = this.bones[ i ];

				if ( bone ) {

					if ( bone.parent && bone.parent.isBone ) {

						bone.matrix.getInverse( bone.parent.matrixWorld );
						bone.matrix.multiply( bone.matrixWorld );

					} else {

						bone.matrix.copy( bone.matrixWorld );

					}

					bone.matrix.decompose( bone.position, bone.quaternion, bone.scale );

				}

			}

		},

		update: ( function () {

			var offsetMatrix = new Matrix4();
			var identityMatrix = new Matrix4();

			return function update() {

				var bones = this.bones;
				var boneInverses = this.boneInverses;
				var boneMatrices = this.boneMatrices;
				var boneTexture = this.boneTexture;

				// flatten bone matrices to array

				for ( var i = 0, il = bones.length; i < il; i ++ ) {

					// compute the offset between the current and the original transform

					var matrix = bones[ i ] ? bones[ i ].matrixWorld : identityMatrix;

					offsetMatrix.multiplyMatrices( matrix, boneInverses[ i ] );
					offsetMatrix.toArray( boneMatrices, i * 16 );

				}

				if ( boneTexture !== undefined ) {

					boneTexture.needsUpdate = true;

				}

			};

		} )(),

		clone: function () {

			return new Skeleton( this.bones, this.boneInverses );

		}

	} );

	/**
	 * @author mikael emtinger / http://gomo.se/
	 * @author alteredq / http://alteredqualia.com/
	 * @author ikerr / http://verold.com
	 */

	function Bone() {

		Object3D.call( this );

		this.type = 'Bone';

	}

	Bone.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: Bone,

		isBone: true

	} );

	/**
	 * @author mikael emtinger / http://gomo.se/
	 * @author alteredq / http://alteredqualia.com/
	 * @author ikerr / http://verold.com
	 */

	function SkinnedMesh( geometry, material ) {

		Mesh.call( this, geometry, material );

		this.type = 'SkinnedMesh';

		this.bindMode = 'attached';
		this.bindMatrix = new Matrix4();
		this.bindMatrixInverse = new Matrix4();

		var bones = this.initBones();
		var skeleton = new Skeleton( bones );

		this.bind( skeleton, this.matrixWorld );

		this.normalizeSkinWeights();

	}

	SkinnedMesh.prototype = Object.assign( Object.create( Mesh.prototype ), {

		constructor: SkinnedMesh,

		isSkinnedMesh: true,

		initBones: function () {

			var bones = [], bone, gbone;
			var i, il;

			if ( this.geometry && this.geometry.bones !== undefined ) {

				// first, create array of 'Bone' objects from geometry data

				for ( i = 0, il = this.geometry.bones.length; i < il; i ++ ) {

					gbone = this.geometry.bones[ i ];

					// create new 'Bone' object

					bone = new Bone();
					bones.push( bone );

					// apply values

					bone.name = gbone.name;
					bone.position.fromArray( gbone.pos );
					bone.quaternion.fromArray( gbone.rotq );
					if ( gbone.scl !== undefined ) bone.scale.fromArray( gbone.scl );

				}

				// second, create bone hierarchy

				for ( i = 0, il = this.geometry.bones.length; i < il; i ++ ) {

					gbone = this.geometry.bones[ i ];

					if ( ( gbone.parent !== - 1 ) && ( gbone.parent !== null ) && ( bones[ gbone.parent ] !== undefined ) ) {

						// subsequent bones in the hierarchy

						bones[ gbone.parent ].add( bones[ i ] );

					} else {

						// topmost bone, immediate child of the skinned mesh

						this.add( bones[ i ] );

					}

				}

			}

			// now the bones are part of the scene graph and children of the skinned mesh.
			// let's update the corresponding matrices

			this.updateMatrixWorld( true );

			return bones;

		},

		bind: function ( skeleton, bindMatrix ) {

			this.skeleton = skeleton;

			if ( bindMatrix === undefined ) {

				this.updateMatrixWorld( true );

				this.skeleton.calculateInverses();

				bindMatrix = this.matrixWorld;

			}

			this.bindMatrix.copy( bindMatrix );
			this.bindMatrixInverse.getInverse( bindMatrix );

		},

		pose: function () {

			this.skeleton.pose();

		},

		normalizeSkinWeights: function () {

			var scale, i;

			if ( this.geometry && this.geometry.isGeometry ) {

				for ( i = 0; i < this.geometry.skinWeights.length; i ++ ) {

					var sw = this.geometry.skinWeights[ i ];

					scale = 1.0 / sw.lengthManhattan();

					if ( scale !== Infinity ) {

						sw.multiplyScalar( scale );

					} else {

						sw.set( 1, 0, 0, 0 ); // do something reasonable

					}

				}

			} else if ( this.geometry && this.geometry.isBufferGeometry ) {

				var vec = new Vector4();

				var skinWeight = this.geometry.attributes.skinWeight;

				for ( i = 0; i < skinWeight.count; i ++ ) {

					vec.x = skinWeight.getX( i );
					vec.y = skinWeight.getY( i );
					vec.z = skinWeight.getZ( i );
					vec.w = skinWeight.getW( i );

					scale = 1.0 / vec.lengthManhattan();

					if ( scale !== Infinity ) {

						vec.multiplyScalar( scale );

					} else {

						vec.set( 1, 0, 0, 0 ); // do something reasonable

					}

					skinWeight.setXYZW( i, vec.x, vec.y, vec.z, vec.w );

				}

			}

		},

		updateMatrixWorld: function ( force ) {

			Mesh.prototype.updateMatrixWorld.call( this, force );

			if ( this.bindMode === 'attached' ) {

				this.bindMatrixInverse.getInverse( this.matrixWorld );

			} else if ( this.bindMode === 'detached' ) {

				this.bindMatrixInverse.getInverse( this.bindMatrix );

			} else {

				console.warn( 'THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode );

			}

		},

		clone: function () {

			return new this.constructor( this.geometry, this.material ).copy( this );

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 *
	 * parameters = {
	 *  color: <hex>,
	 *  opacity: <float>,
	 *
	 *  linewidth: <float>,
	 *  linecap: "round",
	 *  linejoin: "round"
	 * }
	 */

	function LineBasicMaterial( parameters ) {

		Material.call( this );

		this.type = 'LineBasicMaterial';

		this.color = new Color( 0xffffff );

		this.linewidth = 1;
		this.linecap = 'round';
		this.linejoin = 'round';

		this.lights = false;

		this.setValues( parameters );

	}

	LineBasicMaterial.prototype = Object.create( Material.prototype );
	LineBasicMaterial.prototype.constructor = LineBasicMaterial;

	LineBasicMaterial.prototype.isLineBasicMaterial = true;

	LineBasicMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.color.copy( source.color );

		this.linewidth = source.linewidth;
		this.linecap = source.linecap;
		this.linejoin = source.linejoin;

		return this;

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function Line( geometry, material, mode ) {

		if ( mode === 1 ) {

			console.warn( 'THREE.Line: parameter THREE.LinePieces no longer supported. Created THREE.LineSegments instead.' );
			return new LineSegments( geometry, material );

		}

		Object3D.call( this );

		this.type = 'Line';

		this.geometry = geometry !== undefined ? geometry : new BufferGeometry();
		this.material = material !== undefined ? material : new LineBasicMaterial( { color: Math.random() * 0xffffff } );

	}

	Line.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: Line,

		isLine: true,

		raycast: ( function () {

			var inverseMatrix = new Matrix4();
			var ray = new Ray();
			var sphere = new Sphere();

			return function raycast( raycaster, intersects ) {

				var precision = raycaster.linePrecision;
				var precisionSq = precision * precision;

				var geometry = this.geometry;
				var matrixWorld = this.matrixWorld;

				// Checking boundingSphere distance to ray

				if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

				sphere.copy( geometry.boundingSphere );
				sphere.applyMatrix4( matrixWorld );

				if ( raycaster.ray.intersectsSphere( sphere ) === false ) return;

				//

				inverseMatrix.getInverse( matrixWorld );
				ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );

				var vStart = new Vector3();
				var vEnd = new Vector3();
				var interSegment = new Vector3();
				var interRay = new Vector3();
				var step = (this && this.isLineSegments) ? 2 : 1;

				if ( geometry.isBufferGeometry ) {

					var index = geometry.index;
					var attributes = geometry.attributes;
					var positions = attributes.position.array;

					if ( index !== null ) {

						var indices = index.array;

						for ( var i = 0, l = indices.length - 1; i < l; i += step ) {

							var a = indices[ i ];
							var b = indices[ i + 1 ];

							vStart.fromArray( positions, a * 3 );
							vEnd.fromArray( positions, b * 3 );

							var distSq = ray.distanceSqToSegment( vStart, vEnd, interRay, interSegment );

							if ( distSq > precisionSq ) continue;

							interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation

							var distance = raycaster.ray.origin.distanceTo( interRay );

							if ( distance < raycaster.near || distance > raycaster.far ) continue;

							intersects.push( {

								distance: distance,
								// What do we want? intersection point on the ray or on the segment??
								// point: raycaster.ray.at( distance ),
								point: interSegment.clone().applyMatrix4( this.matrixWorld ),
								index: i,
								face: null,
								faceIndex: null,
								object: this

							} );

						}

					} else {

						for ( var i = 0, l = positions.length / 3 - 1; i < l; i += step ) {

							vStart.fromArray( positions, 3 * i );
							vEnd.fromArray( positions, 3 * i + 3 );

							var distSq = ray.distanceSqToSegment( vStart, vEnd, interRay, interSegment );

							if ( distSq > precisionSq ) continue;

							interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation

							var distance = raycaster.ray.origin.distanceTo( interRay );

							if ( distance < raycaster.near || distance > raycaster.far ) continue;

							intersects.push( {

								distance: distance,
								// What do we want? intersection point on the ray or on the segment??
								// point: raycaster.ray.at( distance ),
								point: interSegment.clone().applyMatrix4( this.matrixWorld ),
								index: i,
								face: null,
								faceIndex: null,
								object: this

							} );

						}

					}

				} else if ( geometry.isGeometry ) {

					var vertices = geometry.vertices;
					var nbVertices = vertices.length;

					for ( var i = 0; i < nbVertices - 1; i += step ) {

						var distSq = ray.distanceSqToSegment( vertices[ i ], vertices[ i + 1 ], interRay, interSegment );

						if ( distSq > precisionSq ) continue;

						interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation

						var distance = raycaster.ray.origin.distanceTo( interRay );

						if ( distance < raycaster.near || distance > raycaster.far ) continue;

						intersects.push( {

							distance: distance,
							// What do we want? intersection point on the ray or on the segment??
							// point: raycaster.ray.at( distance ),
							point: interSegment.clone().applyMatrix4( this.matrixWorld ),
							index: i,
							face: null,
							faceIndex: null,
							object: this

						} );

					}

				}

			};

		}() ),

		clone: function () {

			return new this.constructor( this.geometry, this.material ).copy( this );

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function LineSegments( geometry, material ) {

		Line.call( this, geometry, material );

		this.type = 'LineSegments';

	}

	LineSegments.prototype = Object.assign( Object.create( Line.prototype ), {

		constructor: LineSegments,

		isLineSegments: true

	} );

	/**
	 * @author mgreter / http://github.com/mgreter
	 */

	function LineLoop( geometry, material ) {

		Line.call( this, geometry, material );

		this.type = 'LineLoop';

	}

	LineLoop.prototype = Object.assign( Object.create( Line.prototype ), {

		constructor: LineLoop,

		isLineLoop: true,

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 *
	 * parameters = {
	 *  color: <hex>,
	 *  opacity: <float>,
	 *  map: new THREE.Texture( <Image> ),
	 *
	 *  size: <float>,
	 *  sizeAttenuation: <bool>
	 * }
	 */

	function PointsMaterial( parameters ) {

		Material.call( this );

		this.type = 'PointsMaterial';

		this.color = new Color( 0xffffff );

		this.map = null;

		this.size = 1;
		this.sizeAttenuation = true;

		this.lights = false;

		this.setValues( parameters );

	}

	PointsMaterial.prototype = Object.create( Material.prototype );
	PointsMaterial.prototype.constructor = PointsMaterial;

	PointsMaterial.prototype.isPointsMaterial = true;

	PointsMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.color.copy( source.color );

		this.map = source.map;

		this.size = source.size;
		this.sizeAttenuation = source.sizeAttenuation;

		return this;

	};

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	function Points( geometry, material ) {

		Object3D.call( this );

		this.type = 'Points';

		this.geometry = geometry !== undefined ? geometry : new BufferGeometry();
		this.material = material !== undefined ? material : new PointsMaterial( { color: Math.random() * 0xffffff } );

	}

	Points.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: Points,

		isPoints: true,

		raycast: ( function () {

			var inverseMatrix = new Matrix4();
			var ray = new Ray();
			var sphere = new Sphere();

			return function raycast( raycaster, intersects ) {

				var object = this;
				var geometry = this.geometry;
				var matrixWorld = this.matrixWorld;
				var threshold = raycaster.params.Points.threshold;

				// Checking boundingSphere distance to ray

				if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

				sphere.copy( geometry.boundingSphere );
				sphere.applyMatrix4( matrixWorld );
				sphere.radius += threshold;

				if ( raycaster.ray.intersectsSphere( sphere ) === false ) return;

				//

				inverseMatrix.getInverse( matrixWorld );
				ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );

				var localThreshold = threshold / ( ( this.scale.x + this.scale.y + this.scale.z ) / 3 );
				var localThresholdSq = localThreshold * localThreshold;
				var position = new Vector3();

				function testPoint( point, index ) {

					var rayPointDistanceSq = ray.distanceSqToPoint( point );

					if ( rayPointDistanceSq < localThresholdSq ) {

						var intersectPoint = ray.closestPointToPoint( point );
						intersectPoint.applyMatrix4( matrixWorld );

						var distance = raycaster.ray.origin.distanceTo( intersectPoint );

						if ( distance < raycaster.near || distance > raycaster.far ) return;

						intersects.push( {

							distance: distance,
							distanceToRay: Math.sqrt( rayPointDistanceSq ),
							point: intersectPoint.clone(),
							index: index,
							face: null,
							object: object

						} );

					}

				}

				if ( geometry.isBufferGeometry ) {

					var index = geometry.index;
					var attributes = geometry.attributes;
					var positions = attributes.position.array;

					if ( index !== null ) {

						var indices = index.array;

						for ( var i = 0, il = indices.length; i < il; i ++ ) {

							var a = indices[ i ];

							position.fromArray( positions, a * 3 );

							testPoint( position, a );

						}

					} else {

						for ( var i = 0, l = positions.length / 3; i < l; i ++ ) {

							position.fromArray( positions, i * 3 );

							testPoint( position, i );

						}

					}

				} else {

					var vertices = geometry.vertices;

					for ( var i = 0, l = vertices.length; i < l; i ++ ) {

						testPoint( vertices[ i ], i );

					}

				}

			};

		}() ),

		clone: function () {

			return new this.constructor( this.geometry, this.material ).copy( this );

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function Group() {

		Object3D.call( this );

		this.type = 'Group';

	}

	Group.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: Group

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function VideoTexture( video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy ) {

		Texture.call( this, video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );

		this.generateMipmaps = false;

		var scope = this;

		function update() {

			requestAnimationFrame( update );

			if ( video.readyState >= video.HAVE_CURRENT_DATA ) {

				scope.needsUpdate = true;

			}

		}

		update();

	}

	VideoTexture.prototype = Object.create( Texture.prototype );
	VideoTexture.prototype.constructor = VideoTexture;

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	function CompressedTexture( mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding ) {

		Texture.call( this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding );

		this.image = { width: width, height: height };
		this.mipmaps = mipmaps;

		// no flipping for cube textures
		// (also flipping doesn't work for compressed textures )

		this.flipY = false;

		// can't generate mipmaps for compressed textures
		// mips must be embedded in DDS files

		this.generateMipmaps = false;

	}

	CompressedTexture.prototype = Object.create( Texture.prototype );
	CompressedTexture.prototype.constructor = CompressedTexture;

	CompressedTexture.prototype.isCompressedTexture = true;

	/**
	 * @author Matt DesLauriers / @mattdesl
	 * @author atix / arthursilber.de
	 */

	function DepthTexture( width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format ) {

		format = format !== undefined ? format : DepthFormat;

		if ( format !== DepthFormat && format !== DepthStencilFormat ) {

			throw new Error( 'DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat' );

		}

		if ( type === undefined && format === DepthFormat ) type = UnsignedShortType;
		if ( type === undefined && format === DepthStencilFormat ) type = UnsignedInt248Type;

		Texture.call( this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );

		this.image = { width: width, height: height };

		this.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
		this.minFilter = minFilter !== undefined ? minFilter : NearestFilter;

		this.flipY = false;
		this.generateMipmaps	= false;

	}

	DepthTexture.prototype = Object.create( Texture.prototype );
	DepthTexture.prototype.constructor = DepthTexture;
	DepthTexture.prototype.isDepthTexture = true;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	function WireframeGeometry( geometry ) {

		BufferGeometry.call( this );

		this.type = 'WireframeGeometry';

		// buffer

		var vertices = [];

		// helper variables

		var i, j, l, o, ol;
		var edge = [ 0, 0 ], edges = {}, e, edge1, edge2;
		var key, keys = [ 'a', 'b', 'c' ];
		var vertex;

		// different logic for Geometry and BufferGeometry

		if ( geometry && geometry.isGeometry ) {

			// create a data structure that contains all edges without duplicates

			var faces = geometry.faces;

			for ( i = 0, l = faces.length; i < l; i ++ ) {

				var face = faces[ i ];

				for ( j = 0; j < 3; j ++ ) {

					edge1 = face[ keys[ j ] ];
					edge2 = face[ keys[ ( j + 1 ) % 3 ] ];
					edge[ 0 ] = Math.min( edge1, edge2 ); // sorting prevents duplicates
					edge[ 1 ] = Math.max( edge1, edge2 );

					key = edge[ 0 ] + ',' + edge[ 1 ];

					if ( edges[ key ] === undefined ) {

						edges[ key ] = { index1: edge[ 0 ], index2: edge[ 1 ] };

					}

				}

			}

			// generate vertices

			for ( key in edges ) {

				e = edges[ key ];

				vertex = geometry.vertices[ e.index1 ];
				vertices.push( vertex.x, vertex.y, vertex.z );

				vertex = geometry.vertices[ e.index2 ];
				vertices.push( vertex.x, vertex.y, vertex.z );

			}

		} else if ( geometry && geometry.isBufferGeometry ) {

			var position, indices, groups;
			var group, start, count;
			var index1, index2;

			vertex = new Vector3();

			if ( geometry.index !== null ) {

				// indexed BufferGeometry

				position = geometry.attributes.position;
				indices = geometry.index;
				groups = geometry.groups;

				if ( groups.length === 0 ) {

					groups = [ { start: 0, count: indices.count, materialIndex: 0 } ];

				}

				// create a data structure that contains all eges without duplicates

				for ( o = 0, ol = groups.length; o < ol; ++ o ) {

					group = groups[ o ];

					start = group.start;
					count = group.count;

					for ( i = start, l = ( start + count ); i < l; i += 3 ) {

						for ( j = 0; j < 3; j ++ ) {

							edge1 = indices.getX( i + j );
							edge2 = indices.getX( i + ( j + 1 ) % 3 );
							edge[ 0 ] = Math.min( edge1, edge2 ); // sorting prevents duplicates
							edge[ 1 ] = Math.max( edge1, edge2 );

							key = edge[ 0 ] + ',' + edge[ 1 ];

							if ( edges[ key ] === undefined ) {

								edges[ key ] = { index1: edge[ 0 ], index2: edge[ 1 ] };

							}

						}

					}

				}

				// generate vertices

				for ( key in edges ) {

					e = edges[ key ];

					vertex.fromBufferAttribute( position, e.index1 );
					vertices.push( vertex.x, vertex.y, vertex.z );

					vertex.fromBufferAttribute( position, e.index2 );
					vertices.push( vertex.x, vertex.y, vertex.z );

				}

			} else {

				// non-indexed BufferGeometry

				position = geometry.attributes.position;

				for ( i = 0, l = ( position.count / 3 ); i < l; i ++ ) {

					for ( j = 0; j < 3; j ++ ) {

						// three edges per triangle, an edge is represented as (index1, index2)
						// e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)

						index1 = 3 * i + j;
						vertex.fromBufferAttribute( position, index1 );
						vertices.push( vertex.x, vertex.y, vertex.z );

						index2 = 3 * i + ( ( j + 1 ) % 3 );
						vertex.fromBufferAttribute( position, index2 );
						vertices.push( vertex.x, vertex.y, vertex.z );

					}

				}

			}

		}

		// build geometry

		this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );

	}

	WireframeGeometry.prototype = Object.create( BufferGeometry.prototype );
	WireframeGeometry.prototype.constructor = WireframeGeometry;

	/**
	 * @author zz85 / https://github.com/zz85
	 * @author Mugen87 / https://github.com/Mugen87
	 *
	 * Parametric Surfaces Geometry
	 * based on the brilliant article by @prideout http://prideout.net/blog/?p=44
	 */

	// ParametricGeometry

	function ParametricGeometry( func, slices, stacks ) {

		Geometry.call( this );

		this.type = 'ParametricGeometry';

		this.parameters = {
			func: func,
			slices: slices,
			stacks: stacks
		};

		this.fromBufferGeometry( new ParametricBufferGeometry( func, slices, stacks ) );
		this.mergeVertices();

	}

	ParametricGeometry.prototype = Object.create( Geometry.prototype );
	ParametricGeometry.prototype.constructor = ParametricGeometry;

	// ParametricBufferGeometry

	function ParametricBufferGeometry( func, slices, stacks ) {

		BufferGeometry.call( this );

		this.type = 'ParametricBufferGeometry';

		this.parameters = {
			func: func,
			slices: slices,
			stacks: stacks
		};

		// buffers

		var indices = [];
		var vertices = [];
		var normals = [];
		var uvs = [];

		var EPS = 0.00001;

		var normal = new Vector3();

		var p0 = new Vector3(), p1 = new Vector3();
		var pu = new Vector3(), pv = new Vector3();

		var i, j;

		// generate vertices, normals and uvs

		var sliceCount = slices + 1;

		for ( i = 0; i <= stacks; i ++ ) {

			var v = i / stacks;

			for ( j = 0; j <= slices; j ++ ) {

				var u = j / slices;

				// vertex

				p0 = func( u, v, p0 );
				vertices.push( p0.x, p0.y, p0.z );

				// normal

				// approximate tangent vectors via finite differences

				if ( u - EPS >= 0 ) {

					p1 = func( u - EPS, v, p1 );
					pu.subVectors( p0, p1 );

				} else {

					p1 = func( u + EPS, v, p1 );
					pu.subVectors( p1, p0 );

				}

				if ( v - EPS >= 0 ) {

					p1 = func( u, v - EPS, p1 );
					pv.subVectors( p0, p1 );

				} else {

					p1 = func( u, v + EPS, p1 );
					pv.subVectors( p1, p0 );

				}

				// cross product of tangent vectors returns surface normal

				normal.crossVectors( pu, pv ).normalize();
				normals.push( normal.x, normal.y, normal.z );

				// uv

				uvs.push( u, v );

			}

		}

		// generate indices

		for ( i = 0; i < stacks; i ++ ) {

			for ( j = 0; j < slices; j ++ ) {

				var a = i * sliceCount + j;
				var b = i * sliceCount + j + 1;
				var c = ( i + 1 ) * sliceCount + j + 1;
				var d = ( i + 1 ) * sliceCount + j;

				// faces one and two

				indices.push( a, b, d );
				indices.push( b, c, d );

			}

		}

		// build geometry

		this.setIndex( indices );
		this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	}

	ParametricBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	ParametricBufferGeometry.prototype.constructor = ParametricBufferGeometry;

	/**
	 * @author clockworkgeek / https://github.com/clockworkgeek
	 * @author timothypratley / https://github.com/timothypratley
	 * @author WestLangley / http://github.com/WestLangley
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	// PolyhedronGeometry

	function PolyhedronGeometry( vertices, indices, radius, detail ) {

		Geometry.call( this );

		this.type = 'PolyhedronGeometry';

		this.parameters = {
			vertices: vertices,
			indices: indices,
			radius: radius,
			detail: detail
		};

		this.fromBufferGeometry( new PolyhedronBufferGeometry( vertices, indices, radius, detail ) );
		this.mergeVertices();

	}

	PolyhedronGeometry.prototype = Object.create( Geometry.prototype );
	PolyhedronGeometry.prototype.constructor = PolyhedronGeometry;

	// PolyhedronBufferGeometry

	function PolyhedronBufferGeometry( vertices, indices, radius, detail ) {

		BufferGeometry.call( this );

		this.type = 'PolyhedronBufferGeometry';

		this.parameters = {
			vertices: vertices,
			indices: indices,
			radius: radius,
			detail: detail
		};

		radius = radius || 1;
		detail = detail || 0;

		// default buffer data

		var vertexBuffer = [];
		var uvBuffer = [];

		// the subdivision creates the vertex buffer data

		subdivide( detail );

		// all vertices should lie on a conceptual sphere with a given radius

		appplyRadius( radius );

		// finally, create the uv data

		generateUVs();

		// build non-indexed geometry

		this.addAttribute( 'position', new Float32BufferAttribute( vertexBuffer, 3 ) );
		this.addAttribute( 'normal', new Float32BufferAttribute( vertexBuffer.slice(), 3 ) );
		this.addAttribute( 'uv', new Float32BufferAttribute( uvBuffer, 2 ) );

		if ( detail === 0 ) {

			this.computeVertexNormals(); // flat normals

		} else {

			this.normalizeNormals(); // smooth normals

		}

		// helper functions

		function subdivide( detail ) {

			var a = new Vector3();
			var b = new Vector3();
			var c = new Vector3();

			// iterate over all faces and apply a subdivison with the given detail value

			for ( var i = 0; i < indices.length; i += 3 ) {

				// get the vertices of the face

				getVertexByIndex( indices[ i + 0 ], a );
				getVertexByIndex( indices[ i + 1 ], b );
				getVertexByIndex( indices[ i + 2 ], c );

				// perform subdivision

				subdivideFace( a, b, c, detail );

			}

		}

		function subdivideFace( a, b, c, detail ) {

			var cols = Math.pow( 2, detail );

			// we use this multidimensional array as a data structure for creating the subdivision

			var v = [];

			var i, j;

			// construct all of the vertices for this subdivision

			for ( i = 0; i <= cols; i ++ ) {

				v[ i ] = [];

				var aj = a.clone().lerp( c, i / cols );
				var bj = b.clone().lerp( c, i / cols );

				var rows = cols - i;

				for ( j = 0; j <= rows; j ++ ) {

					if ( j === 0 && i === cols ) {

						v[ i ][ j ] = aj;

					} else {

						v[ i ][ j ] = aj.clone().lerp( bj, j / rows );

					}

				}

			}

			// construct all of the faces

			for ( i = 0; i < cols; i ++ ) {

				for ( j = 0; j < 2 * ( cols - i ) - 1; j ++ ) {

					var k = Math.floor( j / 2 );

					if ( j % 2 === 0 ) {

						pushVertex( v[ i ][ k + 1 ] );
						pushVertex( v[ i + 1 ][ k ] );
						pushVertex( v[ i ][ k ] );

					} else {

						pushVertex( v[ i ][ k + 1 ] );
						pushVertex( v[ i + 1 ][ k + 1 ] );
						pushVertex( v[ i + 1 ][ k ] );

					}

				}

			}

		}

		function appplyRadius( radius ) {

			var vertex = new Vector3();

			// iterate over the entire buffer and apply the radius to each vertex

			for ( var i = 0; i < vertexBuffer.length; i += 3 ) {

				vertex.x = vertexBuffer[ i + 0 ];
				vertex.y = vertexBuffer[ i + 1 ];
				vertex.z = vertexBuffer[ i + 2 ];

				vertex.normalize().multiplyScalar( radius );

				vertexBuffer[ i + 0 ] = vertex.x;
				vertexBuffer[ i + 1 ] = vertex.y;
				vertexBuffer[ i + 2 ] = vertex.z;

			}

		}

		function generateUVs() {

			var vertex = new Vector3();

			for ( var i = 0; i < vertexBuffer.length; i += 3 ) {

				vertex.x = vertexBuffer[ i + 0 ];
				vertex.y = vertexBuffer[ i + 1 ];
				vertex.z = vertexBuffer[ i + 2 ];

				var u = azimuth( vertex ) / 2 / Math.PI + 0.5;
				var v = inclination( vertex ) / Math.PI + 0.5;
				uvBuffer.push( u, 1 - v );

			}

			correctUVs();

			correctSeam();

		}

		function correctSeam() {

			// handle case when face straddles the seam, see #3269

			for ( var i = 0; i < uvBuffer.length; i += 6 ) {

				// uv data of a single face

				var x0 = uvBuffer[ i + 0 ];
				var x1 = uvBuffer[ i + 2 ];
				var x2 = uvBuffer[ i + 4 ];

				var max = Math.max( x0, x1, x2 );
				var min = Math.min( x0, x1, x2 );

				// 0.9 is somewhat arbitrary

				if ( max > 0.9 && min < 0.1 ) {

					if ( x0 < 0.2 ) uvBuffer[ i + 0 ] += 1;
					if ( x1 < 0.2 ) uvBuffer[ i + 2 ] += 1;
					if ( x2 < 0.2 ) uvBuffer[ i + 4 ] += 1;

				}

			}

		}

		function pushVertex( vertex ) {

			vertexBuffer.push( vertex.x, vertex.y, vertex.z );

		}

		function getVertexByIndex( index, vertex ) {

			var stride = index * 3;

			vertex.x = vertices[ stride + 0 ];
			vertex.y = vertices[ stride + 1 ];
			vertex.z = vertices[ stride + 2 ];

		}

		function correctUVs() {

			var a = new Vector3();
			var b = new Vector3();
			var c = new Vector3();

			var centroid = new Vector3();

			var uvA = new Vector2();
			var uvB = new Vector2();
			var uvC = new Vector2();

			for ( var i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6 ) {

				a.set( vertexBuffer[ i + 0 ], vertexBuffer[ i + 1 ], vertexBuffer[ i + 2 ] );
				b.set( vertexBuffer[ i + 3 ], vertexBuffer[ i + 4 ], vertexBuffer[ i + 5 ] );
				c.set( vertexBuffer[ i + 6 ], vertexBuffer[ i + 7 ], vertexBuffer[ i + 8 ] );

				uvA.set( uvBuffer[ j + 0 ], uvBuffer[ j + 1 ] );
				uvB.set( uvBuffer[ j + 2 ], uvBuffer[ j + 3 ] );
				uvC.set( uvBuffer[ j + 4 ], uvBuffer[ j + 5 ] );

				centroid.copy( a ).add( b ).add( c ).divideScalar( 3 );

				var azi = azimuth( centroid );

				correctUV( uvA, j + 0, a, azi );
				correctUV( uvB, j + 2, b, azi );
				correctUV( uvC, j + 4, c, azi );

			}

		}

		function correctUV( uv, stride, vector, azimuth ) {

			if ( ( azimuth < 0 ) && ( uv.x === 1 ) ) {

				uvBuffer[ stride ] = uv.x - 1;

			}

			if ( ( vector.x === 0 ) && ( vector.z === 0 ) ) {

				uvBuffer[ stride ] = azimuth / 2 / Math.PI + 0.5;

			}

		}

		// Angle around the Y axis, counter-clockwise when looking from above.

		function azimuth( vector ) {

			return Math.atan2( vector.z, - vector.x );

		}


		// Angle above the XZ plane.

		function inclination( vector ) {

			return Math.atan2( - vector.y, Math.sqrt( ( vector.x * vector.x ) + ( vector.z * vector.z ) ) );

		}

	}

	PolyhedronBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	PolyhedronBufferGeometry.prototype.constructor = PolyhedronBufferGeometry;

	/**
	 * @author timothypratley / https://github.com/timothypratley
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	// TetrahedronGeometry

	function TetrahedronGeometry( radius, detail ) {

		Geometry.call( this );

		this.type = 'TetrahedronGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

		this.fromBufferGeometry( new TetrahedronBufferGeometry( radius, detail ) );
		this.mergeVertices();

	}

	TetrahedronGeometry.prototype = Object.create( Geometry.prototype );
	TetrahedronGeometry.prototype.constructor = TetrahedronGeometry;

	// TetrahedronBufferGeometry

	function TetrahedronBufferGeometry( radius, detail ) {

		var vertices = [
			1,  1,  1,   - 1, - 1,  1,   - 1,  1, - 1,    1, - 1, - 1
		];

		var indices = [
			2,  1,  0,    0,  3,  2,    1,  3,  0,    2,  3,  1
		];

		PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );

		this.type = 'TetrahedronBufferGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

	}

	TetrahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
	TetrahedronBufferGeometry.prototype.constructor = TetrahedronBufferGeometry;

	/**
	 * @author timothypratley / https://github.com/timothypratley
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	// OctahedronGeometry

	function OctahedronGeometry( radius, detail ) {

		Geometry.call( this );

		this.type = 'OctahedronGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

		this.fromBufferGeometry( new OctahedronBufferGeometry( radius, detail ) );
		this.mergeVertices();

	}

	OctahedronGeometry.prototype = Object.create( Geometry.prototype );
	OctahedronGeometry.prototype.constructor = OctahedronGeometry;

	// OctahedronBufferGeometry

	function OctahedronBufferGeometry( radius, detail ) {

		var vertices = [
			1, 0, 0,   - 1, 0, 0,    0, 1, 0,    0, - 1, 0,    0, 0, 1,    0, 0, - 1
		];

		var indices = [
			0, 2, 4,    0, 4, 3,    0, 3, 5,    0, 5, 2,    1, 2, 5,    1, 5, 3,    1, 3, 4,    1, 4, 2
		];

		PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );

		this.type = 'OctahedronBufferGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

	}

	OctahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
	OctahedronBufferGeometry.prototype.constructor = OctahedronBufferGeometry;

	/**
	 * @author timothypratley / https://github.com/timothypratley
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	// IcosahedronGeometry

	function IcosahedronGeometry( radius, detail ) {

	 	Geometry.call( this );

		this.type = 'IcosahedronGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

		this.fromBufferGeometry( new IcosahedronBufferGeometry( radius, detail ) );
		this.mergeVertices();

	}

	IcosahedronGeometry.prototype = Object.create( Geometry.prototype );
	IcosahedronGeometry.prototype.constructor = IcosahedronGeometry;

	// IcosahedronBufferGeometry

	function IcosahedronBufferGeometry( radius, detail ) {

		var t = ( 1 + Math.sqrt( 5 ) ) / 2;

		var vertices = [
			- 1,  t,  0,    1,  t,  0,   - 1, - t,  0,    1, - t,  0,
			 0, - 1,  t,    0,  1,  t,    0, - 1, - t,    0,  1, - t,
			 t,  0, - 1,    t,  0,  1,   - t,  0, - 1,   - t,  0,  1
		];

		var indices = [
			 0, 11,  5,    0,  5,  1,    0,  1,  7,    0,  7, 10,    0, 10, 11,
			 1,  5,  9,    5, 11,  4,   11, 10,  2,   10,  7,  6,    7,  1,  8,
			 3,  9,  4,    3,  4,  2,    3,  2,  6,    3,  6,  8,    3,  8,  9,
			 4,  9,  5,    2,  4, 11,    6,  2, 10,    8,  6,  7,    9,  8,  1
		];

		PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );

		this.type = 'IcosahedronBufferGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

	}

	IcosahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
	IcosahedronBufferGeometry.prototype.constructor = IcosahedronBufferGeometry;

	/**
	 * @author Abe Pazos / https://hamoid.com
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	// DodecahedronGeometry

	function DodecahedronGeometry( radius, detail ) {

		Geometry.call( this );

		this.type = 'DodecahedronGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

		this.fromBufferGeometry( new DodecahedronBufferGeometry( radius, detail ) );
		this.mergeVertices();

	}

	DodecahedronGeometry.prototype = Object.create( Geometry.prototype );
	DodecahedronGeometry.prototype.constructor = DodecahedronGeometry;

	// DodecahedronBufferGeometry

	function DodecahedronBufferGeometry( radius, detail ) {

		var t = ( 1 + Math.sqrt( 5 ) ) / 2;
		var r = 1 / t;

		var vertices = [

			// (±1, ±1, ±1)
			- 1, - 1, - 1,    - 1, - 1,  1,
			- 1,  1, - 1,    - 1,  1,  1,
			  1, - 1, - 1,     1, - 1,  1,
			  1,  1, - 1,     1,  1,  1,

			// (0, ±1/φ, ±φ)
			 0, - r, - t,     0, - r,  t,
			 0,  r, - t,     0,  r,  t,

			// (±1/φ, ±φ, 0)
			- r, - t,  0,    - r,  t,  0,
			 r, - t,  0,     r,  t,  0,

			// (±φ, 0, ±1/φ)
			- t,  0, - r,     t,  0, - r,
			- t,  0,  r,     t,  0,  r
		];

		var indices = [
			 3, 11,  7,      3,  7, 15,      3, 15, 13,
			 7, 19, 17,      7, 17,  6,      7,  6, 15,
			17,  4,  8,     17,  8, 10,     17, 10,  6,
			 8,  0, 16,      8, 16,  2,      8,  2, 10,
			 0, 12,  1,      0,  1, 18,      0, 18, 16,
			 6, 10,  2,      6,  2, 13,      6, 13, 15,
			 2, 16, 18,      2, 18,  3,      2,  3, 13,
			18,  1,  9,     18,  9, 11,     18, 11,  3,
			 4, 14, 12,      4, 12,  0,      4,  0,  8,
			11,  9,  5,     11,  5, 19,     11, 19,  7,
			19,  5, 14,     19, 14,  4,     19,  4, 17,
			 1, 12, 14,      1, 14,  5,      1,  5,  9
		];

		PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );

		this.type = 'DodecahedronBufferGeometry';

		this.parameters = {
			radius: radius,
			detail: detail
		};

	}

	DodecahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
	DodecahedronBufferGeometry.prototype.constructor = DodecahedronBufferGeometry;

	/**
	 * @author oosmoxiecode / https://github.com/oosmoxiecode
	 * @author WestLangley / https://github.com/WestLangley
	 * @author zz85 / https://github.com/zz85
	 * @author miningold / https://github.com/miningold
	 * @author jonobr1 / https://github.com/jonobr1
	 * @author Mugen87 / https://github.com/Mugen87
	 *
	 */

	// TubeGeometry

	function TubeGeometry( path, tubularSegments, radius, radialSegments, closed, taper ) {

		Geometry.call( this );

		this.type = 'TubeGeometry';

		this.parameters = {
			path: path,
			tubularSegments: tubularSegments,
			radius: radius,
			radialSegments: radialSegments,
			closed: closed
		};

		if ( taper !== undefined ) console.warn( 'THREE.TubeGeometry: taper has been removed.' );

		var bufferGeometry = new TubeBufferGeometry( path, tubularSegments, radius, radialSegments, closed );

		// expose internals

		this.tangents = bufferGeometry.tangents;
		this.normals = bufferGeometry.normals;
		this.binormals = bufferGeometry.binormals;

		// create geometry

		this.fromBufferGeometry( bufferGeometry );
		this.mergeVertices();

	}

	TubeGeometry.prototype = Object.create( Geometry.prototype );
	TubeGeometry.prototype.constructor = TubeGeometry;

	// TubeBufferGeometry

	function TubeBufferGeometry( path, tubularSegments, radius, radialSegments, closed ) {

		BufferGeometry.call( this );

		this.type = 'TubeBufferGeometry';

		this.parameters = {
			path: path,
			tubularSegments: tubularSegments,
			radius: radius,
			radialSegments: radialSegments,
			closed: closed
		};

		tubularSegments = tubularSegments || 64;
		radius = radius || 1;
		radialSegments = radialSegments || 8;
		closed = closed || false;

		var frames = path.computeFrenetFrames( tubularSegments, closed );

		// expose internals

		this.tangents = frames.tangents;
		this.normals = frames.normals;
		this.binormals = frames.binormals;

		// helper variables

		var vertex = new Vector3();
		var normal = new Vector3();
		var uv = new Vector2();

		var i, j;

		// buffer

		var vertices = [];
		var normals = [];
		var uvs = [];
		var indices = [];

		// create buffer data

		generateBufferData();

		// build geometry

		this.setIndex( indices );
		this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

		// functions

		function generateBufferData() {

			for ( i = 0; i < tubularSegments; i ++ ) {

				generateSegment( i );

			}

			// if the geometry is not closed, generate the last row of vertices and normals
			// at the regular position on the given path
			//
			// if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)

			generateSegment( ( closed === false ) ? tubularSegments : 0 );

			// uvs are generated in a separate function.
			// this makes it easy compute correct values for closed geometries

			generateUVs();

			// finally create faces

			generateIndices();

		}

		function generateSegment( i ) {

			// we use getPointAt to sample evenly distributed points from the given path

			var P = path.getPointAt( i / tubularSegments );

			// retrieve corresponding normal and binormal

			var N = frames.normals[ i ];
			var B = frames.binormals[ i ];

			// generate normals and vertices for the current segment

			for ( j = 0; j <= radialSegments; j ++ ) {

				var v = j / radialSegments * Math.PI * 2;

				var sin =   Math.sin( v );
				var cos = - Math.cos( v );

				// normal

				normal.x = ( cos * N.x + sin * B.x );
				normal.y = ( cos * N.y + sin * B.y );
				normal.z = ( cos * N.z + sin * B.z );
				normal.normalize();

				normals.push( normal.x, normal.y, normal.z );

				// vertex

				vertex.x = P.x + radius * normal.x;
				vertex.y = P.y + radius * normal.y;
				vertex.z = P.z + radius * normal.z;

				vertices.push( vertex.x, vertex.y, vertex.z );

			}

		}

		function generateIndices() {

			for ( j = 1; j <= tubularSegments; j ++ ) {

				for ( i = 1; i <= radialSegments; i ++ ) {

					var a = ( radialSegments + 1 ) * ( j - 1 ) + ( i - 1 );
					var b = ( radialSegments + 1 ) * j + ( i - 1 );
					var c = ( radialSegments + 1 ) * j + i;
					var d = ( radialSegments + 1 ) * ( j - 1 ) + i;

					// faces

					indices.push( a, b, d );
					indices.push( b, c, d );

				}

			}

		}

		function generateUVs() {

			for ( i = 0; i <= tubularSegments; i ++ ) {

				for ( j = 0; j <= radialSegments; j ++ ) {

					uv.x = i / tubularSegments;
					uv.y = j / radialSegments;

					uvs.push( uv.x, uv.y );

				}

			}

		}

	}

	TubeBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	TubeBufferGeometry.prototype.constructor = TubeBufferGeometry;

	/**
	 * @author oosmoxiecode
	 * @author Mugen87 / https://github.com/Mugen87
	 *
	 * based on http://www.blackpawn.com/texts/pqtorus/
	 */

	// TorusKnotGeometry

	function TorusKnotGeometry( radius, tube, tubularSegments, radialSegments, p, q, heightScale ) {

		Geometry.call( this );

		this.type = 'TorusKnotGeometry';

		this.parameters = {
			radius: radius,
			tube: tube,
			tubularSegments: tubularSegments,
			radialSegments: radialSegments,
			p: p,
			q: q
		};

		if ( heightScale !== undefined ) console.warn( 'THREE.TorusKnotGeometry: heightScale has been deprecated. Use .scale( x, y, z ) instead.' );

		this.fromBufferGeometry( new TorusKnotBufferGeometry( radius, tube, tubularSegments, radialSegments, p, q ) );
		this.mergeVertices();

	}

	TorusKnotGeometry.prototype = Object.create( Geometry.prototype );
	TorusKnotGeometry.prototype.constructor = TorusKnotGeometry;

	// TorusKnotBufferGeometry

	function TorusKnotBufferGeometry( radius, tube, tubularSegments, radialSegments, p, q ) {

		BufferGeometry.call( this );

		this.type = 'TorusKnotBufferGeometry';

		this.parameters = {
			radius: radius,
			tube: tube,
			tubularSegments: tubularSegments,
			radialSegments: radialSegments,
			p: p,
			q: q
		};

		radius = radius || 100;
		tube = tube || 40;
		tubularSegments = Math.floor( tubularSegments ) || 64;
		radialSegments = Math.floor( radialSegments ) || 8;
		p = p || 2;
		q = q || 3;

		// buffers

		var indices = [];
		var vertices = [];
		var normals = [];
		var uvs = [];

		// helper variables

		var i, j;

		var vertex = new Vector3();
		var normal = new Vector3();

		var P1 = new Vector3();
		var P2 = new Vector3();

		var B = new Vector3();
		var T = new Vector3();
		var N = new Vector3();

		// generate vertices, normals and uvs

		for ( i = 0; i <= tubularSegments; ++ i ) {

			// the radian "u" is used to calculate the position on the torus curve of the current tubular segement

			var u = i / tubularSegments * p * Math.PI * 2;

			// now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
			// these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions

			calculatePositionOnCurve( u, p, q, radius, P1 );
			calculatePositionOnCurve( u + 0.01, p, q, radius, P2 );

			// calculate orthonormal basis

			T.subVectors( P2, P1 );
			N.addVectors( P2, P1 );
			B.crossVectors( T, N );
			N.crossVectors( B, T );

			// normalize B, N. T can be ignored, we don't use it

			B.normalize();
			N.normalize();

			for ( j = 0; j <= radialSegments; ++ j ) {

				// now calculate the vertices. they are nothing more than an extrusion of the torus curve.
				// because we extrude a shape in the xy-plane, there is no need to calculate a z-value.

				var v = j / radialSegments * Math.PI * 2;
				var cx = - tube * Math.cos( v );
				var cy = tube * Math.sin( v );

				// now calculate the final vertex position.
				// first we orient the extrusion with our basis vectos, then we add it to the current position on the curve

				vertex.x = P1.x + ( cx * N.x + cy * B.x );
				vertex.y = P1.y + ( cx * N.y + cy * B.y );
				vertex.z = P1.z + ( cx * N.z + cy * B.z );

				vertices.push( vertex.x, vertex.y, vertex.z );

				// normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)

				normal.subVectors( vertex, P1 ).normalize();

				normals.push( normal.x, normal.y, normal.z );

				// uv

				uvs.push( i / tubularSegments );
				uvs.push( j / radialSegments );

			}

		}

		// generate indices

		for ( j = 1; j <= tubularSegments; j ++ ) {

			for ( i = 1; i <= radialSegments; i ++ ) {

				// indices

				var a = ( radialSegments + 1 ) * ( j - 1 ) + ( i - 1 );
				var b = ( radialSegments + 1 ) * j + ( i - 1 );
				var c = ( radialSegments + 1 ) * j + i;
				var d = ( radialSegments + 1 ) * ( j - 1 ) + i;

				// faces

				indices.push( a, b, d );
				indices.push( b, c, d );

			}

		}

		// build geometry

		this.setIndex( indices );
		this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

		// this function calculates the current position on the torus curve

		function calculatePositionOnCurve( u, p, q, radius, position ) {

			var cu = Math.cos( u );
			var su = Math.sin( u );
			var quOverP = q / p * u;
			var cs = Math.cos( quOverP );

			position.x = radius * ( 2 + cs ) * 0.5 * cu;
			position.y = radius * ( 2 + cs ) * su * 0.5;
			position.z = radius * Math.sin( quOverP ) * 0.5;

		}

	}

	TorusKnotBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	TorusKnotBufferGeometry.prototype.constructor = TorusKnotBufferGeometry;

	/**
	 * @author oosmoxiecode
	 * @author mrdoob / http://mrdoob.com/
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	// TorusGeometry

	function TorusGeometry( radius, tube, radialSegments, tubularSegments, arc ) {

		Geometry.call( this );

		this.type = 'TorusGeometry';

		this.parameters = {
			radius: radius,
			tube: tube,
			radialSegments: radialSegments,
			tubularSegments: tubularSegments,
			arc: arc
		};

		this.fromBufferGeometry( new TorusBufferGeometry( radius, tube, radialSegments, tubularSegments, arc ) );
		this.mergeVertices();

	}

	TorusGeometry.prototype = Object.create( Geometry.prototype );
	TorusGeometry.prototype.constructor = TorusGeometry;

	// TorusBufferGeometry

	function TorusBufferGeometry( radius, tube, radialSegments, tubularSegments, arc ) {

		BufferGeometry.call( this );

		this.type = 'TorusBufferGeometry';

		this.parameters = {
			radius: radius,
			tube: tube,
			radialSegments: radialSegments,
			tubularSegments: tubularSegments,
			arc: arc
		};

		radius = radius || 100;
		tube = tube || 40;
		radialSegments = Math.floor( radialSegments ) || 8;
		tubularSegments = Math.floor( tubularSegments ) || 6;
		arc = arc || Math.PI * 2;

		// buffers

		var indices = [];
		var vertices = [];
		var normals = [];
		var uvs = [];

		// helper variables

		var center = new Vector3();
		var vertex = new Vector3();
		var normal = new Vector3();

		var j, i;

		// generate vertices, normals and uvs

		for ( j = 0; j <= radialSegments; j ++ ) {

			for ( i = 0; i <= tubularSegments; i ++ ) {

				var u = i / tubularSegments * arc;
				var v = j / radialSegments * Math.PI * 2;

				// vertex

				vertex.x = ( radius + tube * Math.cos( v ) ) * Math.cos( u );
				vertex.y = ( radius + tube * Math.cos( v ) ) * Math.sin( u );
				vertex.z = tube * Math.sin( v );

				vertices.push( vertex.x, vertex.y, vertex.z );

				// normal

				center.x = radius * Math.cos( u );
				center.y = radius * Math.sin( u );
				normal.subVectors( vertex, center ).normalize();

				normals.push( normal.x, normal.y, normal.z );

				// uv

				uvs.push( i / tubularSegments );
				uvs.push( j / radialSegments );

			}

		}

		// generate indices

		for ( j = 1; j <= radialSegments; j ++ ) {

			for ( i = 1; i <= tubularSegments; i ++ ) {

				// indices

				var a = ( tubularSegments + 1 ) * j + i - 1;
				var b = ( tubularSegments + 1 ) * ( j - 1 ) + i - 1;
				var c = ( tubularSegments + 1 ) * ( j - 1 ) + i;
				var d = ( tubularSegments + 1 ) * j + i;

				// faces

				indices.push( a, b, d );
				indices.push( b, c, d );

			}

		}

		// build geometry

		this.setIndex( indices );
		this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	}

	TorusBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	TorusBufferGeometry.prototype.constructor = TorusBufferGeometry;

	/**
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 */

	var ShapeUtils = {

		// calculate area of the contour polygon

		area: function ( contour ) {

			var n = contour.length;
			var a = 0.0;

			for ( var p = n - 1, q = 0; q < n; p = q ++ ) {

				a += contour[ p ].x * contour[ q ].y - contour[ q ].x * contour[ p ].y;

			}

			return a * 0.5;

		},

		triangulate: ( function () {

			/**
			 * This code is a quick port of code written in C++ which was submitted to
			 * flipcode.com by John W. Ratcliff  // July 22, 2000
			 * See original code and more information here:
			 * http://www.flipcode.com/archives/Efficient_Polygon_Triangulation.shtml
			 *
			 * ported to actionscript by Zevan Rosser
			 * www.actionsnippet.com
			 *
			 * ported to javascript by Joshua Koo
			 * http://www.lab4games.net/zz85/blog
			 *
			 */

			function snip( contour, u, v, w, n, verts ) {

				var p;
				var ax, ay, bx, by;
				var cx, cy, px, py;

				ax = contour[ verts[ u ] ].x;
				ay = contour[ verts[ u ] ].y;

				bx = contour[ verts[ v ] ].x;
				by = contour[ verts[ v ] ].y;

				cx = contour[ verts[ w ] ].x;
				cy = contour[ verts[ w ] ].y;

				if ( ( bx - ax ) * ( cy - ay ) - ( by - ay ) * ( cx - ax ) <= 0 ) return false;

				var aX, aY, bX, bY, cX, cY;
				var apx, apy, bpx, bpy, cpx, cpy;
				var cCROSSap, bCROSScp, aCROSSbp;

				aX = cx - bx;  aY = cy - by;
				bX = ax - cx;  bY = ay - cy;
				cX = bx - ax;  cY = by - ay;

				for ( p = 0; p < n; p ++ ) {

					px = contour[ verts[ p ] ].x;
					py = contour[ verts[ p ] ].y;

					if ( ( ( px === ax ) && ( py === ay ) ) ||
						 ( ( px === bx ) && ( py === by ) ) ||
						 ( ( px === cx ) && ( py === cy ) ) )	continue;

					apx = px - ax;  apy = py - ay;
					bpx = px - bx;  bpy = py - by;
					cpx = px - cx;  cpy = py - cy;

					// see if p is inside triangle abc

					aCROSSbp = aX * bpy - aY * bpx;
					cCROSSap = cX * apy - cY * apx;
					bCROSScp = bX * cpy - bY * cpx;

					if ( ( aCROSSbp >= - Number.EPSILON ) && ( bCROSScp >= - Number.EPSILON ) && ( cCROSSap >= - Number.EPSILON ) ) return false;

				}

				return true;

			}

			// takes in an contour array and returns

			return function triangulate( contour, indices ) {

				var n = contour.length;

				if ( n < 3 ) return null;

				var result = [],
					verts = [],
					vertIndices = [];

				/* we want a counter-clockwise polygon in verts */

				var u, v, w;

				if ( ShapeUtils.area( contour ) > 0.0 ) {

					for ( v = 0; v < n; v ++ ) verts[ v ] = v;

				} else {

					for ( v = 0; v < n; v ++ ) verts[ v ] = ( n - 1 ) - v;

				}

				var nv = n;

				/*  remove nv - 2 vertices, creating 1 triangle every time */

				var count = 2 * nv;   /* error detection */

				for ( v = nv - 1; nv > 2; ) {

					/* if we loop, it is probably a non-simple polygon */

					if ( ( count -- ) <= 0 ) {

						//** Triangulate: ERROR - probable bad polygon!

						//throw ( "Warning, unable to triangulate polygon!" );
						//return null;
						// Sometimes warning is fine, especially polygons are triangulated in reverse.
						console.warn( 'THREE.ShapeUtils: Unable to triangulate polygon! in triangulate()' );

						if ( indices ) return vertIndices;
						return result;

					}

					/* three consecutive vertices in current polygon, <u,v,w> */

					u = v; 	 	if ( nv <= u ) u = 0;     /* previous */
					v = u + 1;  if ( nv <= v ) v = 0;     /* new v    */
					w = v + 1;  if ( nv <= w ) w = 0;     /* next     */

					if ( snip( contour, u, v, w, nv, verts ) ) {

						var a, b, c, s, t;

						/* true names of the vertices */

						a = verts[ u ];
						b = verts[ v ];
						c = verts[ w ];

						/* output Triangle */

						result.push( [ contour[ a ],
							contour[ b ],
							contour[ c ] ] );


						vertIndices.push( [ verts[ u ], verts[ v ], verts[ w ] ] );

						/* remove v from the remaining polygon */

						for ( s = v, t = v + 1; t < nv; s ++, t ++ ) {

							verts[ s ] = verts[ t ];

						}

						nv --;

						/* reset error detection counter */

						count = 2 * nv;

					}

				}

				if ( indices ) return vertIndices;
				return result;

			};

		} )(),

		triangulateShape: function ( contour, holes ) {

			function removeDupEndPts(points) {

				var l = points.length;

				if ( l > 2 && points[ l - 1 ].equals( points[ 0 ] ) ) {

					points.pop();

				}

			}

			removeDupEndPts( contour );
			holes.forEach( removeDupEndPts );

			function point_in_segment_2D_colin( inSegPt1, inSegPt2, inOtherPt ) {

				// inOtherPt needs to be collinear to the inSegment
				if ( inSegPt1.x !== inSegPt2.x ) {

					if ( inSegPt1.x < inSegPt2.x ) {

						return	( ( inSegPt1.x <= inOtherPt.x ) && ( inOtherPt.x <= inSegPt2.x ) );

					} else {

						return	( ( inSegPt2.x <= inOtherPt.x ) && ( inOtherPt.x <= inSegPt1.x ) );

					}

				} else {

					if ( inSegPt1.y < inSegPt2.y ) {

						return	( ( inSegPt1.y <= inOtherPt.y ) && ( inOtherPt.y <= inSegPt2.y ) );

					} else {

						return	( ( inSegPt2.y <= inOtherPt.y ) && ( inOtherPt.y <= inSegPt1.y ) );

					}

				}

			}

			function intersect_segments_2D( inSeg1Pt1, inSeg1Pt2, inSeg2Pt1, inSeg2Pt2, inExcludeAdjacentSegs ) {

				var seg1dx = inSeg1Pt2.x - inSeg1Pt1.x,   seg1dy = inSeg1Pt2.y - inSeg1Pt1.y;
				var seg2dx = inSeg2Pt2.x - inSeg2Pt1.x,   seg2dy = inSeg2Pt2.y - inSeg2Pt1.y;

				var seg1seg2dx = inSeg1Pt1.x - inSeg2Pt1.x;
				var seg1seg2dy = inSeg1Pt1.y - inSeg2Pt1.y;

				var limit		= seg1dy * seg2dx - seg1dx * seg2dy;
				var perpSeg1	= seg1dy * seg1seg2dx - seg1dx * seg1seg2dy;

				if ( Math.abs( limit ) > Number.EPSILON ) {

					// not parallel

					var perpSeg2;
					if ( limit > 0 ) {

						if ( ( perpSeg1 < 0 ) || ( perpSeg1 > limit ) ) 		return [];
						perpSeg2 = seg2dy * seg1seg2dx - seg2dx * seg1seg2dy;
						if ( ( perpSeg2 < 0 ) || ( perpSeg2 > limit ) ) 		return [];

					} else {

						if ( ( perpSeg1 > 0 ) || ( perpSeg1 < limit ) ) 		return [];
						perpSeg2 = seg2dy * seg1seg2dx - seg2dx * seg1seg2dy;
						if ( ( perpSeg2 > 0 ) || ( perpSeg2 < limit ) ) 		return [];

					}

					// i.e. to reduce rounding errors
					// intersection at endpoint of segment#1?
					if ( perpSeg2 === 0 ) {

						if ( ( inExcludeAdjacentSegs ) &&
							 ( ( perpSeg1 === 0 ) || ( perpSeg1 === limit ) ) )		return [];
						return [ inSeg1Pt1 ];

					}
					if ( perpSeg2 === limit ) {

						if ( ( inExcludeAdjacentSegs ) &&
							 ( ( perpSeg1 === 0 ) || ( perpSeg1 === limit ) ) )		return [];
						return [ inSeg1Pt2 ];

					}
					// intersection at endpoint of segment#2?
					if ( perpSeg1 === 0 )		return [ inSeg2Pt1 ];
					if ( perpSeg1 === limit )	return [ inSeg2Pt2 ];

					// return real intersection point
					var factorSeg1 = perpSeg2 / limit;
					return	[ { x: inSeg1Pt1.x + factorSeg1 * seg1dx,
								y: inSeg1Pt1.y + factorSeg1 * seg1dy } ];

				} else {

					// parallel or collinear
					if ( ( perpSeg1 !== 0 ) ||
						 ( seg2dy * seg1seg2dx !== seg2dx * seg1seg2dy ) ) 			return [];

					// they are collinear or degenerate
					var seg1Pt = ( ( seg1dx === 0 ) && ( seg1dy === 0 ) );	// segment1 is just a point?
					var seg2Pt = ( ( seg2dx === 0 ) && ( seg2dy === 0 ) );	// segment2 is just a point?
					// both segments are points
					if ( seg1Pt && seg2Pt ) {

						if ( ( inSeg1Pt1.x !== inSeg2Pt1.x ) ||
							 ( inSeg1Pt1.y !== inSeg2Pt1.y ) )		return [];	// they are distinct  points
						return [ inSeg1Pt1 ];                 						// they are the same point

					}
					// segment#1  is a single point
					if ( seg1Pt ) {

						if ( ! point_in_segment_2D_colin( inSeg2Pt1, inSeg2Pt2, inSeg1Pt1 ) )		return [];		// but not in segment#2
						return [ inSeg1Pt1 ];

					}
					// segment#2  is a single point
					if ( seg2Pt ) {

						if ( ! point_in_segment_2D_colin( inSeg1Pt1, inSeg1Pt2, inSeg2Pt1 ) )		return [];		// but not in segment#1
						return [ inSeg2Pt1 ];

					}

					// they are collinear segments, which might overlap
					var seg1min, seg1max, seg1minVal, seg1maxVal;
					var seg2min, seg2max, seg2minVal, seg2maxVal;
					if ( seg1dx !== 0 ) {

						// the segments are NOT on a vertical line
						if ( inSeg1Pt1.x < inSeg1Pt2.x ) {

							seg1min = inSeg1Pt1; seg1minVal = inSeg1Pt1.x;
							seg1max = inSeg1Pt2; seg1maxVal = inSeg1Pt2.x;

						} else {

							seg1min = inSeg1Pt2; seg1minVal = inSeg1Pt2.x;
							seg1max = inSeg1Pt1; seg1maxVal = inSeg1Pt1.x;

						}
						if ( inSeg2Pt1.x < inSeg2Pt2.x ) {

							seg2min = inSeg2Pt1; seg2minVal = inSeg2Pt1.x;
							seg2max = inSeg2Pt2; seg2maxVal = inSeg2Pt2.x;

						} else {

							seg2min = inSeg2Pt2; seg2minVal = inSeg2Pt2.x;
							seg2max = inSeg2Pt1; seg2maxVal = inSeg2Pt1.x;

						}

					} else {

						// the segments are on a vertical line
						if ( inSeg1Pt1.y < inSeg1Pt2.y ) {

							seg1min = inSeg1Pt1; seg1minVal = inSeg1Pt1.y;
							seg1max = inSeg1Pt2; seg1maxVal = inSeg1Pt2.y;

						} else {

							seg1min = inSeg1Pt2; seg1minVal = inSeg1Pt2.y;
							seg1max = inSeg1Pt1; seg1maxVal = inSeg1Pt1.y;

						}
						if ( inSeg2Pt1.y < inSeg2Pt2.y ) {

							seg2min = inSeg2Pt1; seg2minVal = inSeg2Pt1.y;
							seg2max = inSeg2Pt2; seg2maxVal = inSeg2Pt2.y;

						} else {

							seg2min = inSeg2Pt2; seg2minVal = inSeg2Pt2.y;
							seg2max = inSeg2Pt1; seg2maxVal = inSeg2Pt1.y;

						}

					}
					if ( seg1minVal <= seg2minVal ) {

						if ( seg1maxVal <  seg2minVal )	return [];
						if ( seg1maxVal === seg2minVal )	{

							if ( inExcludeAdjacentSegs )		return [];
							return [ seg2min ];

						}
						if ( seg1maxVal <= seg2maxVal )	return [ seg2min, seg1max ];
						return	[ seg2min, seg2max ];

					} else {

						if ( seg1minVal >  seg2maxVal )	return [];
						if ( seg1minVal === seg2maxVal )	{

							if ( inExcludeAdjacentSegs )		return [];
							return [ seg1min ];

						}
						if ( seg1maxVal <= seg2maxVal )	return [ seg1min, seg1max ];
						return	[ seg1min, seg2max ];

					}

				}

			}

			function isPointInsideAngle( inVertex, inLegFromPt, inLegToPt, inOtherPt ) {

				// The order of legs is important

				// translation of all points, so that Vertex is at (0,0)
				var legFromPtX	= inLegFromPt.x - inVertex.x,  legFromPtY	= inLegFromPt.y - inVertex.y;
				var legToPtX	= inLegToPt.x	- inVertex.x,  legToPtY		= inLegToPt.y	- inVertex.y;
				var otherPtX	= inOtherPt.x	- inVertex.x,  otherPtY		= inOtherPt.y	- inVertex.y;

				// main angle >0: < 180 deg.; 0: 180 deg.; <0: > 180 deg.
				var from2toAngle	= legFromPtX * legToPtY - legFromPtY * legToPtX;
				var from2otherAngle	= legFromPtX * otherPtY - legFromPtY * otherPtX;

				if ( Math.abs( from2toAngle ) > Number.EPSILON ) {

					// angle != 180 deg.

					var other2toAngle		= otherPtX * legToPtY - otherPtY * legToPtX;
					// console.log( "from2to: " + from2toAngle + ", from2other: " + from2otherAngle + ", other2to: " + other2toAngle );

					if ( from2toAngle > 0 ) {

						// main angle < 180 deg.
						return	( ( from2otherAngle >= 0 ) && ( other2toAngle >= 0 ) );

					} else {

						// main angle > 180 deg.
						return	( ( from2otherAngle >= 0 ) || ( other2toAngle >= 0 ) );

					}

				} else {

					// angle == 180 deg.
					// console.log( "from2to: 180 deg., from2other: " + from2otherAngle  );
					return	( from2otherAngle > 0 );

				}

			}


			function removeHoles( contour, holes ) {

				var shape = contour.concat(); // work on this shape
				var hole;

				function isCutLineInsideAngles( inShapeIdx, inHoleIdx ) {

					// Check if hole point lies within angle around shape point
					var lastShapeIdx = shape.length - 1;

					var prevShapeIdx = inShapeIdx - 1;
					if ( prevShapeIdx < 0 )			prevShapeIdx = lastShapeIdx;

					var nextShapeIdx = inShapeIdx + 1;
					if ( nextShapeIdx > lastShapeIdx )	nextShapeIdx = 0;

					var insideAngle = isPointInsideAngle( shape[ inShapeIdx ], shape[ prevShapeIdx ], shape[ nextShapeIdx ], hole[ inHoleIdx ] );
					if ( ! insideAngle ) {

						// console.log( "Vertex (Shape): " + inShapeIdx + ", Point: " + hole[inHoleIdx].x + "/" + hole[inHoleIdx].y );
						return	false;

					}

					// Check if shape point lies within angle around hole point
					var lastHoleIdx = hole.length - 1;

					var prevHoleIdx = inHoleIdx - 1;
					if ( prevHoleIdx < 0 )			prevHoleIdx = lastHoleIdx;

					var nextHoleIdx = inHoleIdx + 1;
					if ( nextHoleIdx > lastHoleIdx )	nextHoleIdx = 0;

					insideAngle = isPointInsideAngle( hole[ inHoleIdx ], hole[ prevHoleIdx ], hole[ nextHoleIdx ], shape[ inShapeIdx ] );
					if ( ! insideAngle ) {

						// console.log( "Vertex (Hole): " + inHoleIdx + ", Point: " + shape[inShapeIdx].x + "/" + shape[inShapeIdx].y );
						return	false;

					}

					return	true;

				}

				function intersectsShapeEdge( inShapePt, inHolePt ) {

					// checks for intersections with shape edges
					var sIdx, nextIdx, intersection;
					for ( sIdx = 0; sIdx < shape.length; sIdx ++ ) {

						nextIdx = sIdx + 1; nextIdx %= shape.length;
						intersection = intersect_segments_2D( inShapePt, inHolePt, shape[ sIdx ], shape[ nextIdx ], true );
						if ( intersection.length > 0 )		return	true;

					}

					return	false;

				}

				var indepHoles = [];

				function intersectsHoleEdge( inShapePt, inHolePt ) {

					// checks for intersections with hole edges
					var ihIdx, chkHole,
						hIdx, nextIdx, intersection;
					for ( ihIdx = 0; ihIdx < indepHoles.length; ihIdx ++ ) {

						chkHole = holes[ indepHoles[ ihIdx ] ];
						for ( hIdx = 0; hIdx < chkHole.length; hIdx ++ ) {

							nextIdx = hIdx + 1; nextIdx %= chkHole.length;
							intersection = intersect_segments_2D( inShapePt, inHolePt, chkHole[ hIdx ], chkHole[ nextIdx ], true );
							if ( intersection.length > 0 )		return	true;

						}

					}
					return	false;

				}

				var holeIndex, shapeIndex,
					shapePt, holePt,
					holeIdx, cutKey, failedCuts = [],
					tmpShape1, tmpShape2,
					tmpHole1, tmpHole2;

				for ( var h = 0, hl = holes.length; h < hl; h ++ ) {

					indepHoles.push( h );

				}

				var minShapeIndex = 0;
				var counter = indepHoles.length * 2;
				while ( indepHoles.length > 0 ) {

					counter --;
					if ( counter < 0 ) {

						console.log( 'THREE.ShapeUtils: Infinite Loop! Holes left:" + indepHoles.length + ", Probably Hole outside Shape!' );
						break;

					}

					// search for shape-vertex and hole-vertex,
					// which can be connected without intersections
					for ( shapeIndex = minShapeIndex; shapeIndex < shape.length; shapeIndex ++ ) {

						shapePt = shape[ shapeIndex ];
						holeIndex	= - 1;

						// search for hole which can be reached without intersections
						for ( var h = 0; h < indepHoles.length; h ++ ) {

							holeIdx = indepHoles[ h ];

							// prevent multiple checks
							cutKey = shapePt.x + ':' + shapePt.y + ':' + holeIdx;
							if ( failedCuts[ cutKey ] !== undefined )			continue;

							hole = holes[ holeIdx ];
							for ( var h2 = 0; h2 < hole.length; h2 ++ ) {

								holePt = hole[ h2 ];
								if ( ! isCutLineInsideAngles( shapeIndex, h2 ) )		continue;
								if ( intersectsShapeEdge( shapePt, holePt ) )		continue;
								if ( intersectsHoleEdge( shapePt, holePt ) )		continue;

								holeIndex = h2;
								indepHoles.splice( h, 1 );

								tmpShape1 = shape.slice( 0, shapeIndex + 1 );
								tmpShape2 = shape.slice( shapeIndex );
								tmpHole1 = hole.slice( holeIndex );
								tmpHole2 = hole.slice( 0, holeIndex + 1 );

								shape = tmpShape1.concat( tmpHole1 ).concat( tmpHole2 ).concat( tmpShape2 );

								minShapeIndex = shapeIndex;

								// Debug only, to show the selected cuts
								// glob_CutLines.push( [ shapePt, holePt ] );

								break;

							}
							if ( holeIndex >= 0 )	break;		// hole-vertex found

							failedCuts[ cutKey ] = true;			// remember failure

						}
						if ( holeIndex >= 0 )	break;		// hole-vertex found

					}

				}

				return shape; 			/* shape with no holes */

			}


			var i, il, f, face,
				key, index,
				allPointsMap = {};

			// To maintain reference to old shape, one must match coordinates, or offset the indices from original arrays. It's probably easier to do the first.

			var allpoints = contour.concat();

			for ( var h = 0, hl = holes.length; h < hl; h ++ ) {

				Array.prototype.push.apply( allpoints, holes[ h ] );

			}

			//console.log( "allpoints",allpoints, allpoints.length );

			// prepare all points map

			for ( i = 0, il = allpoints.length; i < il; i ++ ) {

				key = allpoints[ i ].x + ':' + allpoints[ i ].y;

				if ( allPointsMap[ key ] !== undefined ) {

					console.warn( 'THREE.ShapeUtils: Duplicate point', key, i );

				}

				allPointsMap[ key ] = i;

			}

			// remove holes by cutting paths to holes and adding them to the shape
			var shapeWithoutHoles = removeHoles( contour, holes );

			var triangles = ShapeUtils.triangulate( shapeWithoutHoles, false ); // True returns indices for points of spooled shape
			//console.log( "triangles",triangles, triangles.length );

			// check all face vertices against all points map

			for ( i = 0, il = triangles.length; i < il; i ++ ) {

				face = triangles[ i ];

				for ( f = 0; f < 3; f ++ ) {

					key = face[ f ].x + ':' + face[ f ].y;

					index = allPointsMap[ key ];

					if ( index !== undefined ) {

						face[ f ] = index;

					}

				}

			}

			return triangles.concat();

		},

		isClockWise: function ( pts ) {

			return ShapeUtils.area( pts ) < 0;

		}

	};

	/**
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 *
	 * Creates extruded geometry from a path shape.
	 *
	 * parameters = {
	 *
	 *  curveSegments: <int>, // number of points on the curves
	 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
	 *  amount: <int>, // Depth to extrude the shape
	 *
	 *  bevelEnabled: <bool>, // turn on bevel
	 *  bevelThickness: <float>, // how deep into the original shape bevel goes
	 *  bevelSize: <float>, // how far from shape outline is bevel
	 *  bevelSegments: <int>, // number of bevel layers
	 *
	 *  extrudePath: <THREE.Curve> // curve to extrude shape along
	 *  frames: <Object> // containing arrays of tangents, normals, binormals
	 *
	 *  UVGenerator: <Object> // object that provides UV generator functions
	 *
	 * }
	 */

	// ExtrudeGeometry

	function ExtrudeGeometry( shapes, options ) {

		Geometry.call( this );

		this.type = 'ExtrudeGeometry';

		this.parameters = {
			shapes: shapes,
			options: options
		};

		this.fromBufferGeometry( new ExtrudeBufferGeometry( shapes, options ) );
		this.mergeVertices();

	}

	ExtrudeGeometry.prototype = Object.create( Geometry.prototype );
	ExtrudeGeometry.prototype.constructor = ExtrudeGeometry;

	// ExtrudeBufferGeometry

	function ExtrudeBufferGeometry( shapes, options ) {

		if ( typeof ( shapes ) === "undefined" ) {

			return;

		}

		BufferGeometry.call( this );

		this.type = 'ExtrudeBufferGeometry';

		shapes = Array.isArray( shapes ) ? shapes : [ shapes ];

		this.addShapeList( shapes, options );

		this.computeVertexNormals();

		// can't really use automatic vertex normals
		// as then front and back sides get smoothed too
		// should do separate smoothing just for sides

		//this.computeVertexNormals();

		//console.log( "took", ( Date.now() - startTime ) );

	}

	ExtrudeBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	ExtrudeBufferGeometry.prototype.constructor = ExtrudeBufferGeometry;

	ExtrudeBufferGeometry.prototype.getArrays = function () {

		var positionAttribute = this.getAttribute( "position" );
		var verticesArray = positionAttribute ? Array.prototype.slice.call( positionAttribute.array ) : [];

		var uvAttribute = this.getAttribute( "uv" );
		var uvArray = uvAttribute ? Array.prototype.slice.call( uvAttribute.array ) : [];

		var IndexAttribute = this.index;
		var indicesArray = IndexAttribute ? Array.prototype.slice.call( IndexAttribute.array ) : [];

		return {
			position: verticesArray,
			uv: uvArray,
			index: indicesArray
		};

	};

	ExtrudeBufferGeometry.prototype.addShapeList = function ( shapes, options ) {

		var sl = shapes.length;
		options.arrays = this.getArrays();

		for ( var s = 0; s < sl; s ++ ) {

			var shape = shapes[ s ];
			this.addShape( shape, options );

		}

		this.setIndex( options.arrays.index );
		this.addAttribute( 'position', new Float32BufferAttribute( options.arrays.position, 3 ) );
		this.addAttribute( 'uv', new Float32BufferAttribute( options.arrays.uv, 2 ) );

	};

	ExtrudeBufferGeometry.prototype.addShape = function ( shape, options ) {

		var arrays = options.arrays ? options.arrays : this.getArrays();
		var verticesArray = arrays.position;
		var indicesArray = arrays.index;
		var uvArray = arrays.uv;

		var placeholder = [];


		var amount = options.amount !== undefined ? options.amount : 100;

		var bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 6; // 10
		var bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 2; // 8
		var bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;

		var bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true; // false

		var curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;

		var steps = options.steps !== undefined ? options.steps : 1;

		var extrudePath = options.extrudePath;
		var extrudePts, extrudeByPath = false;

		// Use default WorldUVGenerator if no UV generators are specified.
		var uvgen = options.UVGenerator !== undefined ? options.UVGenerator : ExtrudeGeometry.WorldUVGenerator;

		var splineTube, binormal, normal, position2;
		if ( extrudePath ) {

			extrudePts = extrudePath.getSpacedPoints( steps );

			extrudeByPath = true;
			bevelEnabled = false; // bevels not supported for path extrusion

			// SETUP TNB variables

			// TODO1 - have a .isClosed in spline?

			splineTube = options.frames !== undefined ? options.frames : extrudePath.computeFrenetFrames( steps, false );

			// console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);

			binormal = new Vector3();
			normal = new Vector3();
			position2 = new Vector3();

		}

		// Safeguards if bevels are not enabled

		if ( ! bevelEnabled ) {

			bevelSegments = 0;
			bevelThickness = 0;
			bevelSize = 0;

		}

		// Variables initialization

		var ahole, h, hl; // looping of holes
		var scope = this;

		var shapePoints = shape.extractPoints( curveSegments );

		var vertices = shapePoints.shape;
		var holes = shapePoints.holes;

		var reverse = ! ShapeUtils.isClockWise( vertices );

		if ( reverse ) {

			vertices = vertices.reverse();

			// Maybe we should also check if holes are in the opposite direction, just to be safe ...

			for ( h = 0, hl = holes.length; h < hl; h ++ ) {

				ahole = holes[ h ];

				if ( ShapeUtils.isClockWise( ahole ) ) {

					holes[ h ] = ahole.reverse();

				}

			}

		}


		var faces = ShapeUtils.triangulateShape( vertices, holes );

		/* Vertices */

		var contour = vertices; // vertices has all points but contour has only points of circumference

		for ( h = 0, hl = holes.length; h < hl; h ++ ) {

			ahole = holes[ h ];

			vertices = vertices.concat( ahole );

		}


		function scalePt2( pt, vec, size ) {

			if ( ! vec ) console.error( "THREE.ExtrudeGeometry: vec does not exist" );

			return vec.clone().multiplyScalar( size ).add( pt );

		}

		var b, bs, t, z,
			vert, vlen = vertices.length,
			face, flen = faces.length;


		// Find directions for point movement


		function getBevelVec( inPt, inPrev, inNext ) {

			// computes for inPt the corresponding point inPt' on a new contour
			//   shifted by 1 unit (length of normalized vector) to the left
			// if we walk along contour clockwise, this new contour is outside the old one
			//
			// inPt' is the intersection of the two lines parallel to the two
			//  adjacent edges of inPt at a distance of 1 unit on the left side.

			var v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt

			// good reading for geometry algorithms (here: line-line intersection)
			// http://geomalgorithms.com/a05-_intersect-1.html

			var v_prev_x = inPt.x - inPrev.x,
				v_prev_y = inPt.y - inPrev.y;
			var v_next_x = inNext.x - inPt.x,
				v_next_y = inNext.y - inPt.y;

			var v_prev_lensq = ( v_prev_x * v_prev_x + v_prev_y * v_prev_y );

			// check for collinear edges
			var collinear0 = ( v_prev_x * v_next_y - v_prev_y * v_next_x );

			if ( Math.abs( collinear0 ) > Number.EPSILON ) {

				// not collinear

				// length of vectors for normalizing

				var v_prev_len = Math.sqrt( v_prev_lensq );
				var v_next_len = Math.sqrt( v_next_x * v_next_x + v_next_y * v_next_y );

				// shift adjacent points by unit vectors to the left

				var ptPrevShift_x = ( inPrev.x - v_prev_y / v_prev_len );
				var ptPrevShift_y = ( inPrev.y + v_prev_x / v_prev_len );

				var ptNextShift_x = ( inNext.x - v_next_y / v_next_len );
				var ptNextShift_y = ( inNext.y + v_next_x / v_next_len );

				// scaling factor for v_prev to intersection point

				var sf = ( ( ptNextShift_x - ptPrevShift_x ) * v_next_y -
						( ptNextShift_y - ptPrevShift_y ) * v_next_x ) /
					( v_prev_x * v_next_y - v_prev_y * v_next_x );

				// vector from inPt to intersection point

				v_trans_x = ( ptPrevShift_x + v_prev_x * sf - inPt.x );
				v_trans_y = ( ptPrevShift_y + v_prev_y * sf - inPt.y );

				// Don't normalize!, otherwise sharp corners become ugly
				//  but prevent crazy spikes
				var v_trans_lensq = ( v_trans_x * v_trans_x + v_trans_y * v_trans_y );
				if ( v_trans_lensq <= 2 ) {

					return new Vector2( v_trans_x, v_trans_y );

				} else {

					shrink_by = Math.sqrt( v_trans_lensq / 2 );

				}

			} else {

				// handle special case of collinear edges

				var direction_eq = false; // assumes: opposite
				if ( v_prev_x > Number.EPSILON ) {

					if ( v_next_x > Number.EPSILON ) {

						direction_eq = true;

					}

				} else {

					if ( v_prev_x < - Number.EPSILON ) {

						if ( v_next_x < - Number.EPSILON ) {

							direction_eq = true;

						}

					} else {

						if ( Math.sign( v_prev_y ) === Math.sign( v_next_y ) ) {

							direction_eq = true;

						}

					}

				}

				if ( direction_eq ) {

					// console.log("Warning: lines are a straight sequence");
					v_trans_x = - v_prev_y;
					v_trans_y = v_prev_x;
					shrink_by = Math.sqrt( v_prev_lensq );

				} else {

					// console.log("Warning: lines are a straight spike");
					v_trans_x = v_prev_x;
					v_trans_y = v_prev_y;
					shrink_by = Math.sqrt( v_prev_lensq / 2 );

				}

			}

			return new Vector2( v_trans_x / shrink_by, v_trans_y / shrink_by );

		}


		var contourMovements = [];

		for ( var i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i ++, j ++, k ++ ) {

			if ( j === il ) j = 0;
			if ( k === il ) k = 0;

			//  (j)---(i)---(k)
			// console.log('i,j,k', i, j , k)

			contourMovements[ i ] = getBevelVec( contour[ i ], contour[ j ], contour[ k ] );

		}

		var holesMovements = [],
			oneHoleMovements, verticesMovements = contourMovements.concat();

		for ( h = 0, hl = holes.length; h < hl; h ++ ) {

			ahole = holes[ h ];

			oneHoleMovements = [];

			for ( i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i ++, j ++, k ++ ) {

				if ( j === il ) j = 0;
				if ( k === il ) k = 0;

				//  (j)---(i)---(k)
				oneHoleMovements[ i ] = getBevelVec( ahole[ i ], ahole[ j ], ahole[ k ] );

			}

			holesMovements.push( oneHoleMovements );
			verticesMovements = verticesMovements.concat( oneHoleMovements );

		}


		// Loop bevelSegments, 1 for the front, 1 for the back

		for ( b = 0; b < bevelSegments; b ++ ) {

			//for ( b = bevelSegments; b > 0; b -- ) {

			t = b / bevelSegments;
			z = bevelThickness * Math.cos( t * Math.PI / 2 );
			bs = bevelSize * Math.sin( t * Math.PI / 2 );

			// contract shape

			for ( i = 0, il = contour.length; i < il; i ++ ) {

				vert = scalePt2( contour[ i ], contourMovements[ i ], bs );

				v( vert.x, vert.y, - z );

			}

			// expand holes

			for ( h = 0, hl = holes.length; h < hl; h ++ ) {

				ahole = holes[ h ];
				oneHoleMovements = holesMovements[ h ];

				for ( i = 0, il = ahole.length; i < il; i ++ ) {

					vert = scalePt2( ahole[ i ], oneHoleMovements[ i ], bs );

					v( vert.x, vert.y, - z );

				}

			}

		}

		bs = bevelSize;

		// Back facing vertices

		for ( i = 0; i < vlen; i ++ ) {

			vert = bevelEnabled ? scalePt2( vertices[ i ], verticesMovements[ i ], bs ) : vertices[ i ];

			if ( ! extrudeByPath ) {

				v( vert.x, vert.y, 0 );

			} else {

				// v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );

				normal.copy( splineTube.normals[ 0 ] ).multiplyScalar( vert.x );
				binormal.copy( splineTube.binormals[ 0 ] ).multiplyScalar( vert.y );

				position2.copy( extrudePts[ 0 ] ).add( normal ).add( binormal );

				v( position2.x, position2.y, position2.z );

			}

		}

		// Add stepped vertices...
		// Including front facing vertices

		var s;

		for ( s = 1; s <= steps; s ++ ) {

			for ( i = 0; i < vlen; i ++ ) {

				vert = bevelEnabled ? scalePt2( vertices[ i ], verticesMovements[ i ], bs ) : vertices[ i ];

				if ( ! extrudeByPath ) {

					v( vert.x, vert.y, amount / steps * s );

				} else {

					// v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );

					normal.copy( splineTube.normals[ s ] ).multiplyScalar( vert.x );
					binormal.copy( splineTube.binormals[ s ] ).multiplyScalar( vert.y );

					position2.copy( extrudePts[ s ] ).add( normal ).add( binormal );

					v( position2.x, position2.y, position2.z );

				}

			}

		}


		// Add bevel segments planes

		//for ( b = 1; b <= bevelSegments; b ++ ) {
		for ( b = bevelSegments - 1; b >= 0; b -- ) {

			t = b / bevelSegments;
			z = bevelThickness * Math.cos( t * Math.PI / 2 );
			bs = bevelSize * Math.sin( t * Math.PI / 2 );

			// contract shape

			for ( i = 0, il = contour.length; i < il; i ++ ) {

				vert = scalePt2( contour[ i ], contourMovements[ i ], bs );
				v( vert.x, vert.y, amount + z );

			}

			// expand holes

			for ( h = 0, hl = holes.length; h < hl; h ++ ) {

				ahole = holes[ h ];
				oneHoleMovements = holesMovements[ h ];

				for ( i = 0, il = ahole.length; i < il; i ++ ) {

					vert = scalePt2( ahole[ i ], oneHoleMovements[ i ], bs );

					if ( ! extrudeByPath ) {

						v( vert.x, vert.y, amount + z );

					} else {

						v( vert.x, vert.y + extrudePts[ steps - 1 ].y, extrudePts[ steps - 1 ].x + z );

					}

				}

			}

		}

		/* Faces */

		// Top and bottom faces

		buildLidFaces();

		// Sides faces

		buildSideFaces();


		/////  Internal functions

		function buildLidFaces() {

			var start = verticesArray.length/3;

			if ( bevelEnabled ) {

				var layer = 0; // steps + 1
				var offset = vlen * layer;

				// Bottom faces

				for ( i = 0; i < flen; i ++ ) {

					face = faces[ i ];
					f3( face[ 2 ] + offset, face[ 1 ] + offset, face[ 0 ] + offset );

				}

				layer = steps + bevelSegments * 2;
				offset = vlen * layer;

				// Top faces

				for ( i = 0; i < flen; i ++ ) {

					face = faces[ i ];
					f3( face[ 0 ] + offset, face[ 1 ] + offset, face[ 2 ] + offset );

				}

			} else {

				// Bottom faces

				for ( i = 0; i < flen; i ++ ) {

					face = faces[ i ];
					f3( face[ 2 ], face[ 1 ], face[ 0 ] );

				}

				// Top faces

				for ( i = 0; i < flen; i ++ ) {

					face = faces[ i ];
					f3( face[ 0 ] + vlen * steps, face[ 1 ] + vlen * steps, face[ 2 ] + vlen * steps );

				}

			}

			scope.addGroup( start, verticesArray.length/3 -start, options.material !== undefined ? options.material : 0);

		}

		// Create faces for the z-sides of the shape

		function buildSideFaces() {

			var start = verticesArray.length/3;
			var layeroffset = 0;
			sidewalls( contour, layeroffset );
			layeroffset += contour.length;

			for ( h = 0, hl = holes.length; h < hl; h ++ ) {

				ahole = holes[ h ];
				sidewalls( ahole, layeroffset );

				//, true
				layeroffset += ahole.length;

			}


			scope.addGroup( start, verticesArray.length/3 -start, options.extrudeMaterial !== undefined ? options.extrudeMaterial : 1);


		}

		function sidewalls( contour, layeroffset ) {

			var j, k;
			i = contour.length;

			while ( -- i >= 0 ) {

				j = i;
				k = i - 1;
				if ( k < 0 ) k = contour.length - 1;

				//console.log('b', i,j, i-1, k,vertices.length);

				var s = 0,
					sl = steps + bevelSegments * 2;

				for ( s = 0; s < sl; s ++ ) {

					var slen1 = vlen * s;
					var slen2 = vlen * ( s + 1 );

					var a = layeroffset + j + slen1,
						b = layeroffset + k + slen1,
						c = layeroffset + k + slen2,
						d = layeroffset + j + slen2;

					f4( a, b, c, d, contour, s, sl, j, k );

				}

			}

		}

		function v( x, y, z ) {

			placeholder.push( x );
			placeholder.push( y );
			placeholder.push( z );

		}


		function f3( a, b, c ) {

			addVertex( a );
			addVertex( b );
			addVertex( c );

			var nextIndex = verticesArray.length / 3;
			var uvs = uvgen.generateTopUV( scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1 );

			addUV( uvs[ 0 ] );
			addUV( uvs[ 1 ] );
			addUV( uvs[ 2 ] );

		}

		function f4( a, b, c, d, wallContour, stepIndex, stepsLength, contourIndex1, contourIndex2 ) {

			addVertex( a );
			addVertex( b );
			addVertex( d );

			addVertex( b );
			addVertex( c );
			addVertex( d );


			var nextIndex = verticesArray.length / 3;
			var uvs = uvgen.generateSideWallUV( scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1 );

			addUV( uvs[ 0 ] );
			addUV( uvs[ 1 ] );
			addUV( uvs[ 3 ] );

			addUV( uvs[ 1 ] );
			addUV( uvs[ 2 ] );
			addUV( uvs[ 3 ] );

		}

		function addVertex( index ) {

			indicesArray.push( verticesArray.length / 3 );
			verticesArray.push( placeholder[ index * 3 + 0 ] );
			verticesArray.push( placeholder[ index * 3 + 1 ] );
			verticesArray.push( placeholder[ index * 3 + 2 ] );

		}


		function addUV( vector2 ) {

			uvArray.push( vector2.x );
			uvArray.push( vector2.y );

		}

		if ( ! options.arrays ) {

			this.setIndex( indicesArray );
			this.addAttribute( 'position', new Float32BufferAttribute( verticesArray, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( options.arrays.uv, 2 ) );

		}

	};

	ExtrudeGeometry.WorldUVGenerator = {

		generateTopUV: function ( geometry, vertices, indexA, indexB, indexC ) {

			var a_x = vertices[ indexA * 3 ];
			var a_y = vertices[ indexA * 3 + 1 ];
			var b_x = vertices[ indexB * 3 ];
			var b_y = vertices[ indexB * 3 + 1 ];
			var c_x = vertices[ indexC * 3 ];
			var c_y = vertices[ indexC * 3 + 1 ];

			return [
				new Vector2( a_x, a_y ),
				new Vector2( b_x, b_y ),
				new Vector2( c_x, c_y )
			];

		},

		generateSideWallUV: function ( geometry, vertices, indexA, indexB, indexC, indexD ) {

			var a_x = vertices[ indexA * 3 ];
			var a_y = vertices[ indexA * 3 + 1 ];
			var a_z = vertices[ indexA * 3 + 2 ];
			var b_x = vertices[ indexB * 3 ];
			var b_y = vertices[ indexB * 3 + 1 ];
			var b_z = vertices[ indexB * 3 + 2 ];
			var c_x = vertices[ indexC * 3 ];
			var c_y = vertices[ indexC * 3 + 1 ];
			var c_z = vertices[ indexC * 3 + 2 ];
			var d_x = vertices[ indexD * 3 ];
			var d_y = vertices[ indexD * 3 + 1 ];
			var d_z = vertices[ indexD * 3 + 2 ];

			if ( Math.abs( a_y - b_y ) < 0.01 ) {

				return [
					new Vector2( a_x, 1 - a_z ),
					new Vector2( b_x, 1 - b_z ),
					new Vector2( c_x, 1 - c_z ),
					new Vector2( d_x, 1 - d_z )
				];

			} else {

				return [
					new Vector2( a_y, 1 - a_z ),
					new Vector2( b_y, 1 - b_z ),
					new Vector2( c_y, 1 - c_z ),
					new Vector2( d_y, 1 - d_z )
				];

			}

		}
	};

	/**
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 * @author alteredq / http://alteredqualia.com/
	 *
	 * Text = 3D Text
	 *
	 * parameters = {
	 *  font: <THREE.Font>, // font
	 *
	 *  size: <float>, // size of the text
	 *  height: <float>, // thickness to extrude text
	 *  curveSegments: <int>, // number of points on the curves
	 *
	 *  bevelEnabled: <bool>, // turn on bevel
	 *  bevelThickness: <float>, // how deep into text bevel goes
	 *  bevelSize: <float> // how far from text outline is bevel
	 * }
	 */

	// TextGeometry

	function TextGeometry(  text, parameters ) {

		Geometry.call( this );

		this.type = 'TextGeometry';

		this.parameters = {
			text: text,
			parameters: parameters
		};

		this.fromBufferGeometry( new TextBufferGeometry( text, parameters ) );
		this.mergeVertices();

	}

	TextGeometry.prototype = Object.create( Geometry.prototype );
	TextGeometry.prototype.constructor = TextGeometry;

	// TextBufferGeometry

	function TextBufferGeometry( text, parameters ) {

		parameters = parameters || {};

		var font = parameters.font;

		if ( ! ( font && font.isFont ) ) {

			console.error( 'THREE.TextGeometry: font parameter is not an instance of THREE.Font.' );
			return new Geometry();

		}

		var shapes = font.generateShapes( text, parameters.size, parameters.curveSegments );

		// translate parameters to ExtrudeGeometry API

		parameters.amount = parameters.height !== undefined ? parameters.height : 50;

		// defaults

		if ( parameters.bevelThickness === undefined ) parameters.bevelThickness = 10;
		if ( parameters.bevelSize === undefined ) parameters.bevelSize = 8;
		if ( parameters.bevelEnabled === undefined ) parameters.bevelEnabled = false;

		ExtrudeBufferGeometry.call( this, shapes, parameters );

		this.type = 'TextBufferGeometry';

	}

	TextBufferGeometry.prototype = Object.create( ExtrudeBufferGeometry.prototype );
	TextBufferGeometry.prototype.constructor = TextBufferGeometry;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author benaadams / https://twitter.com/ben_a_adams
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	// SphereGeometry

	function SphereGeometry( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) {

		Geometry.call( this );

		this.type = 'SphereGeometry';

		this.parameters = {
			radius: radius,
			widthSegments: widthSegments,
			heightSegments: heightSegments,
			phiStart: phiStart,
			phiLength: phiLength,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		this.fromBufferGeometry( new SphereBufferGeometry( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) );
		this.mergeVertices();

	}

	SphereGeometry.prototype = Object.create( Geometry.prototype );
	SphereGeometry.prototype.constructor = SphereGeometry;

	// SphereBufferGeometry

	function SphereBufferGeometry( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) {

		BufferGeometry.call( this );

		this.type = 'SphereBufferGeometry';

		this.parameters = {
			radius: radius,
			widthSegments: widthSegments,
			heightSegments: heightSegments,
			phiStart: phiStart,
			phiLength: phiLength,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		radius = radius || 50;

		widthSegments = Math.max( 3, Math.floor( widthSegments ) || 8 );
		heightSegments = Math.max( 2, Math.floor( heightSegments ) || 6 );

		phiStart = phiStart !== undefined ? phiStart : 0;
		phiLength = phiLength !== undefined ? phiLength : Math.PI * 2;

		thetaStart = thetaStart !== undefined ? thetaStart : 0;
		thetaLength = thetaLength !== undefined ? thetaLength : Math.PI;

		var thetaEnd = thetaStart + thetaLength;

		var ix, iy;

		var index = 0;
		var grid = [];

		var vertex = new Vector3();
		var normal = new Vector3();

		// buffers

		var indices = [];
		var vertices = [];
		var normals = [];
		var uvs = [];

		// generate vertices, normals and uvs

		for ( iy = 0; iy <= heightSegments; iy ++ ) {

			var verticesRow = [];

			var v = iy / heightSegments;

			for ( ix = 0; ix <= widthSegments; ix ++ ) {

				var u = ix / widthSegments;

				// vertex

				vertex.x = - radius * Math.cos( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );
				vertex.y = radius * Math.cos( thetaStart + v * thetaLength );
				vertex.z = radius * Math.sin( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );

				vertices.push( vertex.x, vertex.y, vertex.z );

				// normal

				normal.set( vertex.x, vertex.y, vertex.z ).normalize();
				normals.push( normal.x, normal.y, normal.z );

				// uv

				uvs.push( u, 1 - v );

				verticesRow.push( index ++ );

			}

			grid.push( verticesRow );

		}

		// indices

		for ( iy = 0; iy < heightSegments; iy ++ ) {

			for ( ix = 0; ix < widthSegments; ix ++ ) {

				var a = grid[ iy ][ ix + 1 ];
				var b = grid[ iy ][ ix ];
				var c = grid[ iy + 1 ][ ix ];
				var d = grid[ iy + 1 ][ ix + 1 ];

				if ( iy !== 0 || thetaStart > 0 ) indices.push( a, b, d );
				if ( iy !== heightSegments - 1 || thetaEnd < Math.PI ) indices.push( b, c, d );

			}

		}

		// build geometry

		this.setIndex( indices );
		this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	}

	SphereBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	SphereBufferGeometry.prototype.constructor = SphereBufferGeometry;

	/**
	 * @author Kaleb Murphy
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	// RingGeometry

	function RingGeometry( innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength ) {

		Geometry.call( this );

		this.type = 'RingGeometry';

		this.parameters = {
			innerRadius: innerRadius,
			outerRadius: outerRadius,
			thetaSegments: thetaSegments,
			phiSegments: phiSegments,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		this.fromBufferGeometry( new RingBufferGeometry( innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength ) );
		this.mergeVertices();

	}

	RingGeometry.prototype = Object.create( Geometry.prototype );
	RingGeometry.prototype.constructor = RingGeometry;

	// RingBufferGeometry

	function RingBufferGeometry( innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength ) {

		BufferGeometry.call( this );

		this.type = 'RingBufferGeometry';

		this.parameters = {
			innerRadius: innerRadius,
			outerRadius: outerRadius,
			thetaSegments: thetaSegments,
			phiSegments: phiSegments,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		innerRadius = innerRadius || 20;
		outerRadius = outerRadius || 50;

		thetaStart = thetaStart !== undefined ? thetaStart : 0;
		thetaLength = thetaLength !== undefined ? thetaLength : Math.PI * 2;

		thetaSegments = thetaSegments !== undefined ? Math.max( 3, thetaSegments ) : 8;
		phiSegments = phiSegments !== undefined ? Math.max( 1, phiSegments ) : 1;

		// buffers

		var indices = [];
		var vertices = [];
		var normals = [];
		var uvs = [];

		// some helper variables

		var segment;
		var radius = innerRadius;
		var radiusStep = ( ( outerRadius - innerRadius ) / phiSegments );
		var vertex = new Vector3();
		var uv = new Vector2();
		var j, i;

		// generate vertices, normals and uvs

		for ( j = 0; j <= phiSegments; j ++ ) {

			for ( i = 0; i <= thetaSegments; i ++ ) {

				// values are generate from the inside of the ring to the outside

				segment = thetaStart + i / thetaSegments * thetaLength;

				// vertex

				vertex.x = radius * Math.cos( segment );
				vertex.y = radius * Math.sin( segment );

				vertices.push( vertex.x, vertex.y, vertex.z );

				// normal

				normals.push( 0, 0, 1 );

				// uv

				uv.x = ( vertex.x / outerRadius + 1 ) / 2;
				uv.y = ( vertex.y / outerRadius + 1 ) / 2;

				uvs.push( uv.x, uv.y );

			}

			// increase the radius for next row of vertices

			radius += radiusStep;

		}

		// indices

		for ( j = 0; j < phiSegments; j ++ ) {

			var thetaSegmentLevel = j * ( thetaSegments + 1 );

			for ( i = 0; i < thetaSegments; i ++ ) {

				segment = i + thetaSegmentLevel;

				var a = segment;
				var b = segment + thetaSegments + 1;
				var c = segment + thetaSegments + 2;
				var d = segment + 1;

				// faces

				indices.push( a, b, d );
				indices.push( b, c, d );

			}

		}

		// build geometry

		this.setIndex( indices );
		this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	}

	RingBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	RingBufferGeometry.prototype.constructor = RingBufferGeometry;

	/**
	 * @author astrodud / http://astrodud.isgreat.org/
	 * @author zz85 / https://github.com/zz85
	 * @author bhouston / http://clara.io
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	// LatheGeometry

	function LatheGeometry( points, segments, phiStart, phiLength ) {

		Geometry.call( this );

		this.type = 'LatheGeometry';

		this.parameters = {
			points: points,
			segments: segments,
			phiStart: phiStart,
			phiLength: phiLength
		};

		this.fromBufferGeometry( new LatheBufferGeometry( points, segments, phiStart, phiLength ) );
		this.mergeVertices();

	}

	LatheGeometry.prototype = Object.create( Geometry.prototype );
	LatheGeometry.prototype.constructor = LatheGeometry;

	// LatheBufferGeometry

	function LatheBufferGeometry( points, segments, phiStart, phiLength ) {

		BufferGeometry.call( this );

		this.type = 'LatheBufferGeometry';

		this.parameters = {
			points: points,
			segments: segments,
			phiStart: phiStart,
			phiLength: phiLength
		};

		segments = Math.floor( segments ) || 12;
		phiStart = phiStart || 0;
		phiLength = phiLength || Math.PI * 2;

		// clamp phiLength so it's in range of [ 0, 2PI ]

		phiLength = _Math.clamp( phiLength, 0, Math.PI * 2 );


		// buffers

		var indices = [];
		var vertices = [];
		var uvs = [];

		// helper variables

		var base;
		var inverseSegments = 1.0 / segments;
		var vertex = new Vector3();
		var uv = new Vector2();
		var i, j;

		// generate vertices and uvs

		for ( i = 0; i <= segments; i ++ ) {

			var phi = phiStart + i * inverseSegments * phiLength;

			var sin = Math.sin( phi );
			var cos = Math.cos( phi );

			for ( j = 0; j <= ( points.length - 1 ); j ++ ) {

				// vertex

				vertex.x = points[ j ].x * sin;
				vertex.y = points[ j ].y;
				vertex.z = points[ j ].x * cos;

				vertices.push( vertex.x, vertex.y, vertex.z );

				// uv

				uv.x = i / segments;
				uv.y = j / ( points.length - 1 );

				uvs.push( uv.x, uv.y );


			}

		}

		// indices

		for ( i = 0; i < segments; i ++ ) {

			for ( j = 0; j < ( points.length - 1 ); j ++ ) {

				base = j + i * points.length;

				var a = base;
				var b = base + points.length;
				var c = base + points.length + 1;
				var d = base + 1;

				// faces

				indices.push( a, b, d );
				indices.push( b, c, d );

			}

		}

		// build geometry

		this.setIndex( indices );
		this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

		// generate normals

		this.computeVertexNormals();

		// if the geometry is closed, we need to average the normals along the seam.
		// because the corresponding vertices are identical (but still have different UVs).

		if ( phiLength === Math.PI * 2 ) {

			var normals = this.attributes.normal.array;
			var n1 = new Vector3();
			var n2 = new Vector3();
			var n = new Vector3();

			// this is the buffer offset for the last line of vertices

			base = segments * points.length * 3;

			for ( i = 0, j = 0; i < points.length; i ++, j += 3 ) {

				// select the normal of the vertex in the first line

				n1.x = normals[ j + 0 ];
				n1.y = normals[ j + 1 ];
				n1.z = normals[ j + 2 ];

				// select the normal of the vertex in the last line

				n2.x = normals[ base + j + 0 ];
				n2.y = normals[ base + j + 1 ];
				n2.z = normals[ base + j + 2 ];

				// average normals

				n.addVectors( n1, n2 ).normalize();

				// assign the new values to both normals

				normals[ j + 0 ] = normals[ base + j + 0 ] = n.x;
				normals[ j + 1 ] = normals[ base + j + 1 ] = n.y;
				normals[ j + 2 ] = normals[ base + j + 2 ] = n.z;

			}

		}

	}

	LatheBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	LatheBufferGeometry.prototype.constructor = LatheBufferGeometry;

	/**
	 * @author jonobr1 / http://jonobr1.com
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	// ShapeGeometry

	function ShapeGeometry( shapes, curveSegments ) {

		Geometry.call( this );

		this.type = 'ShapeGeometry';

		if ( typeof curveSegments === 'object' ) {

			console.warn( 'THREE.ShapeGeometry: Options parameter has been removed.' );

			curveSegments = curveSegments.curveSegments;

		}

		this.parameters = {
			shapes: shapes,
			curveSegments: curveSegments
		};

		this.fromBufferGeometry( new ShapeBufferGeometry( shapes, curveSegments ) );
		this.mergeVertices();

	}

	ShapeGeometry.prototype = Object.create( Geometry.prototype );
	ShapeGeometry.prototype.constructor = ShapeGeometry;

	// ShapeBufferGeometry

	function ShapeBufferGeometry( shapes, curveSegments ) {

		BufferGeometry.call( this );

		this.type = 'ShapeBufferGeometry';

		this.parameters = {
			shapes: shapes,
			curveSegments: curveSegments
		};

		curveSegments = curveSegments || 12;

		// buffers

		var indices = [];
		var vertices = [];
		var normals = [];
		var uvs = [];

		// helper variables

		var groupStart = 0;
		var groupCount = 0;

		// allow single and array values for "shapes" parameter

		if ( Array.isArray( shapes ) === false ) {

			addShape( shapes );

		} else {

			for ( var i = 0; i < shapes.length; i ++ ) {

				addShape( shapes[ i ] );

				this.addGroup( groupStart, groupCount, i ); // enables MultiMaterial support

				groupStart += groupCount;
				groupCount = 0;

			}

		}

		// build geometry

		this.setIndex( indices );
		this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );


		// helper functions

		function addShape( shape ) {

			var i, l, shapeHole;

			var indexOffset = vertices.length / 3;
			var points = shape.extractPoints( curveSegments );

			var shapeVertices = points.shape;
			var shapeHoles = points.holes;

			// check direction of vertices

			if ( ShapeUtils.isClockWise( shapeVertices ) === false ) {

				shapeVertices = shapeVertices.reverse();

				// also check if holes are in the opposite direction

				for ( i = 0, l = shapeHoles.length; i < l; i ++ ) {

					shapeHole = shapeHoles[ i ];

					if ( ShapeUtils.isClockWise( shapeHole ) === true ) {

						shapeHoles[ i ] = shapeHole.reverse();

					}

				}

			}

			var faces = ShapeUtils.triangulateShape( shapeVertices, shapeHoles );

			// join vertices of inner and outer paths to a single array

			for ( i = 0, l = shapeHoles.length; i < l; i ++ ) {

				shapeHole = shapeHoles[ i ];
				shapeVertices = shapeVertices.concat( shapeHole );

			}

			// vertices, normals, uvs

			for ( i = 0, l = shapeVertices.length; i < l; i ++ ) {

				var vertex = shapeVertices[ i ];

				vertices.push( vertex.x, vertex.y, 0 );
				normals.push( 0, 0, 1 );
				uvs.push( vertex.x, vertex.y ); // world uvs

			}

			// incides

			for ( i = 0, l = faces.length; i < l; i ++ ) {

				var face = faces[ i ];

				var a = face[ 0 ] + indexOffset;
				var b = face[ 1 ] + indexOffset;
				var c = face[ 2 ] + indexOffset;

				indices.push( a, b, c );
				groupCount += 3;

			}

		}

	}

	ShapeBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	ShapeBufferGeometry.prototype.constructor = ShapeBufferGeometry;

	/**
	 * @author WestLangley / http://github.com/WestLangley
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	function EdgesGeometry( geometry, thresholdAngle ) {

		BufferGeometry.call( this );

		this.type = 'EdgesGeometry';

		this.parameters = {
			thresholdAngle: thresholdAngle
		};

		thresholdAngle = ( thresholdAngle !== undefined ) ? thresholdAngle : 1;

		// buffer

		var vertices = [];

		// helper variables

		var thresholdDot = Math.cos( _Math.DEG2RAD * thresholdAngle );
		var edge = [ 0, 0 ], edges = {}, edge1, edge2;
		var key, keys = [ 'a', 'b', 'c' ];

		// prepare source geometry

		var geometry2;

		if ( geometry.isBufferGeometry ) {

			geometry2 = new Geometry();
			geometry2.fromBufferGeometry( geometry );

		} else {

			geometry2 = geometry.clone();

		}

		geometry2.mergeVertices();
		geometry2.computeFaceNormals();

		var sourceVertices = geometry2.vertices;
		var faces = geometry2.faces;

		// now create a data structure where each entry represents an edge with its adjoining faces

		for ( var i = 0, l = faces.length; i < l; i ++ ) {

			var face = faces[ i ];

			for ( var j = 0; j < 3; j ++ ) {

				edge1 = face[ keys[ j ] ];
				edge2 = face[ keys[ ( j + 1 ) % 3 ] ];
				edge[ 0 ] = Math.min( edge1, edge2 );
				edge[ 1 ] = Math.max( edge1, edge2 );

				key = edge[ 0 ] + ',' + edge[ 1 ];

				if ( edges[ key ] === undefined ) {

					edges[ key ] = { index1: edge[ 0 ], index2: edge[ 1 ], face1: i, face2: undefined };

				} else {

					edges[ key ].face2 = i;

				}

			}

		}

		// generate vertices

		for ( key in edges ) {

			var e = edges[ key ];

			// an edge is only rendered if the angle (in degrees) between the face normals of the adjoining faces exceeds this value. default = 1 degree.

			if ( e.face2 === undefined || faces[ e.face1 ].normal.dot( faces[ e.face2 ].normal ) <= thresholdDot ) {

				var vertex = sourceVertices[ e.index1 ];
				vertices.push( vertex.x, vertex.y, vertex.z );

				vertex = sourceVertices[ e.index2 ];
				vertices.push( vertex.x, vertex.y, vertex.z );

			}

		}

		// build geometry

		this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );

	}

	EdgesGeometry.prototype = Object.create( BufferGeometry.prototype );
	EdgesGeometry.prototype.constructor = EdgesGeometry;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	// CylinderGeometry

	function CylinderGeometry( radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {

		Geometry.call( this );

		this.type = 'CylinderGeometry';

		this.parameters = {
			radiusTop: radiusTop,
			radiusBottom: radiusBottom,
			height: height,
			radialSegments: radialSegments,
			heightSegments: heightSegments,
			openEnded: openEnded,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		this.fromBufferGeometry( new CylinderBufferGeometry( radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) );
		this.mergeVertices();

	}

	CylinderGeometry.prototype = Object.create( Geometry.prototype );
	CylinderGeometry.prototype.constructor = CylinderGeometry;

	// CylinderBufferGeometry

	function CylinderBufferGeometry( radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {

		BufferGeometry.call( this );

		this.type = 'CylinderBufferGeometry';

		this.parameters = {
			radiusTop: radiusTop,
			radiusBottom: radiusBottom,
			height: height,
			radialSegments: radialSegments,
			heightSegments: heightSegments,
			openEnded: openEnded,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		var scope = this;

		radiusTop = radiusTop !== undefined ? radiusTop : 20;
		radiusBottom = radiusBottom !== undefined ? radiusBottom : 20;
		height = height !== undefined ? height : 100;

		radialSegments = Math.floor( radialSegments ) || 8;
		heightSegments = Math.floor( heightSegments ) || 1;

		openEnded = openEnded !== undefined ? openEnded : false;
		thetaStart = thetaStart !== undefined ? thetaStart : 0.0;
		thetaLength = thetaLength !== undefined ? thetaLength : 2.0 * Math.PI;

		// buffers

		var indices = [];
		var vertices = [];
		var normals = [];
		var uvs = [];

		// helper variables

		var index = 0;
		var indexArray = [];
		var halfHeight = height / 2;
		var groupStart = 0;

		// generate geometry

		generateTorso();

		if ( openEnded === false ) {

			if ( radiusTop > 0 ) generateCap( true );
			if ( radiusBottom > 0 ) generateCap( false );

		}

		// build geometry

		this.setIndex( indices );
		this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

		function generateTorso() {

			var x, y;
			var normal = new Vector3();
			var vertex = new Vector3();

			var groupCount = 0;

			// this will be used to calculate the normal
			var slope = ( radiusBottom - radiusTop ) / height;

			// generate vertices, normals and uvs

			for ( y = 0; y <= heightSegments; y ++ ) {

				var indexRow = [];

				var v = y / heightSegments;

				// calculate the radius of the current row

				var radius = v * ( radiusBottom - radiusTop ) + radiusTop;

				for ( x = 0; x <= radialSegments; x ++ ) {

					var u = x / radialSegments;

					var theta = u * thetaLength + thetaStart;

					var sinTheta = Math.sin( theta );
					var cosTheta = Math.cos( theta );

					// vertex

					vertex.x = radius * sinTheta;
					vertex.y = - v * height + halfHeight;
					vertex.z = radius * cosTheta;
					vertices.push( vertex.x, vertex.y, vertex.z );

					// normal

					normal.set( sinTheta, slope, cosTheta ).normalize();
					normals.push( normal.x, normal.y, normal.z );

					// uv

					uvs.push( u, 1 - v );

					// save index of vertex in respective row

					indexRow.push( index ++ );

				}

				// now save vertices of the row in our index array

				indexArray.push( indexRow );

			}

			// generate indices

			for ( x = 0; x < radialSegments; x ++ ) {

				for ( y = 0; y < heightSegments; y ++ ) {

					// we use the index array to access the correct indices

					var a = indexArray[ y ][ x ];
					var b = indexArray[ y + 1 ][ x ];
					var c = indexArray[ y + 1 ][ x + 1 ];
					var d = indexArray[ y ][ x + 1 ];

					// faces

					indices.push( a, b, d );
					indices.push( b, c, d );

					// update group counter

					groupCount += 6;

				}

			}

			// add a group to the geometry. this will ensure multi material support

			scope.addGroup( groupStart, groupCount, 0 );

			// calculate new start value for groups

			groupStart += groupCount;

		}

		function generateCap( top ) {

			var x, centerIndexStart, centerIndexEnd;

			var uv = new Vector2();
			var vertex = new Vector3();

			var groupCount = 0;

			var radius = ( top === true ) ? radiusTop : radiusBottom;
			var sign = ( top === true ) ? 1 : - 1;

			// save the index of the first center vertex
			centerIndexStart = index;

			// first we generate the center vertex data of the cap.
			// because the geometry needs one set of uvs per face,
			// we must generate a center vertex per face/segment

			for ( x = 1; x <= radialSegments; x ++ ) {

				// vertex

				vertices.push( 0, halfHeight * sign, 0 );

				// normal

				normals.push( 0, sign, 0 );

				// uv

				uvs.push( 0.5, 0.5 );

				// increase index

				index ++;

			}

			// save the index of the last center vertex

			centerIndexEnd = index;

			// now we generate the surrounding vertices, normals and uvs

			for ( x = 0; x <= radialSegments; x ++ ) {

				var u = x / radialSegments;
				var theta = u * thetaLength + thetaStart;

				var cosTheta = Math.cos( theta );
				var sinTheta = Math.sin( theta );

				// vertex

				vertex.x = radius * sinTheta;
				vertex.y = halfHeight * sign;
				vertex.z = radius * cosTheta;
				vertices.push( vertex.x, vertex.y, vertex.z );

				// normal

				normals.push( 0, sign, 0 );

				// uv

				uv.x = ( cosTheta * 0.5 ) + 0.5;
				uv.y = ( sinTheta * 0.5 * sign ) + 0.5;
				uvs.push( uv.x, uv.y );

				// increase index

				index ++;

			}

			// generate indices

			for ( x = 0; x < radialSegments; x ++ ) {

				var c = centerIndexStart + x;
				var i = centerIndexEnd + x;

				if ( top === true ) {

					// face top

					indices.push( i, i + 1, c );

				} else {

					// face bottom

					indices.push( i + 1, i, c );

				}

				groupCount += 3;

			}

			// add a group to the geometry. this will ensure multi material support

			scope.addGroup( groupStart, groupCount, top === true ? 1 : 2 );

			// calculate new start value for groups

			groupStart += groupCount;

		}

	}

	CylinderBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	CylinderBufferGeometry.prototype.constructor = CylinderBufferGeometry;

	/**
	 * @author abelnation / http://github.com/abelnation
	 */

	// ConeGeometry

	function ConeGeometry( radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {

		CylinderGeometry.call( this, 0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength );

		this.type = 'ConeGeometry';

		this.parameters = {
			radius: radius,
			height: height,
			radialSegments: radialSegments,
			heightSegments: heightSegments,
			openEnded: openEnded,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

	}

	ConeGeometry.prototype = Object.create( CylinderGeometry.prototype );
	ConeGeometry.prototype.constructor = ConeGeometry;

	// ConeBufferGeometry

	function ConeBufferGeometry( radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {

		CylinderBufferGeometry.call( this, 0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength );

		this.type = 'ConeBufferGeometry';

		this.parameters = {
			radius: radius,
			height: height,
			radialSegments: radialSegments,
			heightSegments: heightSegments,
			openEnded: openEnded,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

	}

	ConeBufferGeometry.prototype = Object.create( CylinderBufferGeometry.prototype );
	ConeBufferGeometry.prototype.constructor = ConeBufferGeometry;

	/**
	 * @author benaadams / https://twitter.com/ben_a_adams
	 * @author Mugen87 / https://github.com/Mugen87
	 * @author hughes
	 */

	// CircleGeometry

	function CircleGeometry( radius, segments, thetaStart, thetaLength ) {

		Geometry.call( this );

		this.type = 'CircleGeometry';

		this.parameters = {
			radius: radius,
			segments: segments,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		this.fromBufferGeometry( new CircleBufferGeometry( radius, segments, thetaStart, thetaLength ) );
		this.mergeVertices();

	}

	CircleGeometry.prototype = Object.create( Geometry.prototype );
	CircleGeometry.prototype.constructor = CircleGeometry;

	// CircleBufferGeometry

	function CircleBufferGeometry( radius, segments, thetaStart, thetaLength ) {

		BufferGeometry.call( this );

		this.type = 'CircleBufferGeometry';

		this.parameters = {
			radius: radius,
			segments: segments,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		radius = radius || 50;
		segments = segments !== undefined ? Math.max( 3, segments ) : 8;

		thetaStart = thetaStart !== undefined ? thetaStart : 0;
		thetaLength = thetaLength !== undefined ? thetaLength : Math.PI * 2;

		// buffers

		var indices = [];
		var vertices = [];
		var normals = [];
		var uvs = [];

		// helper variables

		var i, s;
		var vertex = new Vector3();
		var uv = new Vector2();

		// center point

		vertices.push( 0, 0, 0 );
		normals.push( 0, 0, 1 );
		uvs.push( 0.5, 0.5 );

		for ( s = 0, i = 3; s <= segments; s ++, i += 3 ) {

			var segment = thetaStart + s / segments * thetaLength;

			// vertex

			vertex.x = radius * Math.cos( segment );
			vertex.y = radius * Math.sin( segment );

			vertices.push( vertex.x, vertex.y, vertex.z );

			// normal

			normals.push( 0, 0, 1 );

			// uvs

			uv.x = ( vertices[ i ] / radius + 1 ) / 2;
			uv.y = ( vertices[ i + 1 ] / radius + 1 ) / 2;

			uvs.push( uv.x, uv.y );

		}

		// indices

		for ( i = 1; i <= segments; i ++ ) {

			indices.push( i, i + 1, 0 );

		}

		// build geometry

		this.setIndex( indices );
		this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	}

	CircleBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
	CircleBufferGeometry.prototype.constructor = CircleBufferGeometry;



	var Geometries = Object.freeze({
		WireframeGeometry: WireframeGeometry,
		ParametricGeometry: ParametricGeometry,
		ParametricBufferGeometry: ParametricBufferGeometry,
		TetrahedronGeometry: TetrahedronGeometry,
		TetrahedronBufferGeometry: TetrahedronBufferGeometry,
		OctahedronGeometry: OctahedronGeometry,
		OctahedronBufferGeometry: OctahedronBufferGeometry,
		IcosahedronGeometry: IcosahedronGeometry,
		IcosahedronBufferGeometry: IcosahedronBufferGeometry,
		DodecahedronGeometry: DodecahedronGeometry,
		DodecahedronBufferGeometry: DodecahedronBufferGeometry,
		PolyhedronGeometry: PolyhedronGeometry,
		PolyhedronBufferGeometry: PolyhedronBufferGeometry,
		TubeGeometry: TubeGeometry,
		TubeBufferGeometry: TubeBufferGeometry,
		TorusKnotGeometry: TorusKnotGeometry,
		TorusKnotBufferGeometry: TorusKnotBufferGeometry,
		TorusGeometry: TorusGeometry,
		TorusBufferGeometry: TorusBufferGeometry,
		TextGeometry: TextGeometry,
		TextBufferGeometry: TextBufferGeometry,
		SphereGeometry: SphereGeometry,
		SphereBufferGeometry: SphereBufferGeometry,
		RingGeometry: RingGeometry,
		RingBufferGeometry: RingBufferGeometry,
		PlaneGeometry: PlaneGeometry,
		PlaneBufferGeometry: PlaneBufferGeometry,
		LatheGeometry: LatheGeometry,
		LatheBufferGeometry: LatheBufferGeometry,
		ShapeGeometry: ShapeGeometry,
		ShapeBufferGeometry: ShapeBufferGeometry,
		ExtrudeGeometry: ExtrudeGeometry,
		ExtrudeBufferGeometry: ExtrudeBufferGeometry,
		EdgesGeometry: EdgesGeometry,
		ConeGeometry: ConeGeometry,
		ConeBufferGeometry: ConeBufferGeometry,
		CylinderGeometry: CylinderGeometry,
		CylinderBufferGeometry: CylinderBufferGeometry,
		CircleGeometry: CircleGeometry,
		CircleBufferGeometry: CircleBufferGeometry,
		BoxGeometry: BoxGeometry,
		BoxBufferGeometry: BoxBufferGeometry
	});

	/**
	 * @author mrdoob / http://mrdoob.com/
	 *
	 * parameters = {
	 *  color: <THREE.Color>,
	 *  opacity: <float>
	 * }
	 */

	function ShadowMaterial( parameters ) {

		Material.call( this );

		this.type = 'ShadowMaterial';

		this.color = new Color( 0x000000 );
		this.opacity = 1.0;

		this.lights = true;
		this.transparent = true;

		this.setValues( parameters );

	}

	ShadowMaterial.prototype = Object.create( Material.prototype );
	ShadowMaterial.prototype.constructor = ShadowMaterial;

	ShadowMaterial.prototype.isShadowMaterial = true;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function RawShaderMaterial( parameters ) {

		ShaderMaterial.call( this, parameters );

		this.type = 'RawShaderMaterial';

	}

	RawShaderMaterial.prototype = Object.create( ShaderMaterial.prototype );
	RawShaderMaterial.prototype.constructor = RawShaderMaterial;

	RawShaderMaterial.prototype.isRawShaderMaterial = true;

	/**
	 * @author WestLangley / http://github.com/WestLangley
	 *
	 * parameters = {
	 *  color: <hex>,
	 *  roughness: <float>,
	 *  metalness: <float>,
	 *  opacity: <float>,
	 *
	 *  map: new THREE.Texture( <Image> ),
	 *
	 *  lightMap: new THREE.Texture( <Image> ),
	 *  lightMapIntensity: <float>
	 *
	 *  aoMap: new THREE.Texture( <Image> ),
	 *  aoMapIntensity: <float>
	 *
	 *  emissive: <hex>,
	 *  emissiveIntensity: <float>
	 *  emissiveMap: new THREE.Texture( <Image> ),
	 *
	 *  bumpMap: new THREE.Texture( <Image> ),
	 *  bumpScale: <float>,
	 *
	 *  normalMap: new THREE.Texture( <Image> ),
	 *  normalScale: <Vector2>,
	 *
	 *  displacementMap: new THREE.Texture( <Image> ),
	 *  displacementScale: <float>,
	 *  displacementBias: <float>,
	 *
	 *  roughnessMap: new THREE.Texture( <Image> ),
	 *
	 *  metalnessMap: new THREE.Texture( <Image> ),
	 *
	 *  alphaMap: new THREE.Texture( <Image> ),
	 *
	 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
	 *  envMapIntensity: <float>
	 *
	 *  refractionRatio: <float>,
	 *
	 *  wireframe: <boolean>,
	 *  wireframeLinewidth: <float>,
	 *
	 *  skinning: <bool>,
	 *  morphTargets: <bool>,
	 *  morphNormals: <bool>
	 * }
	 */

	function MeshStandardMaterial( parameters ) {

		Material.call( this );

		this.defines = { 'STANDARD': '' };

		this.type = 'MeshStandardMaterial';

		this.color = new Color( 0xffffff ); // diffuse
		this.roughness = 0.5;
		this.metalness = 0.5;

		this.map = null;

		this.lightMap = null;
		this.lightMapIntensity = 1.0;

		this.aoMap = null;
		this.aoMapIntensity = 1.0;

		this.emissive = new Color( 0x000000 );
		this.emissiveIntensity = 1.0;
		this.emissiveMap = null;

		this.bumpMap = null;
		this.bumpScale = 1;

		this.normalMap = null;
		this.normalScale = new Vector2( 1, 1 );

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.roughnessMap = null;

		this.metalnessMap = null;

		this.alphaMap = null;

		this.envMap = null;
		this.envMapIntensity = 1.0;

		this.refractionRatio = 0.98;

		this.wireframe = false;
		this.wireframeLinewidth = 1;
		this.wireframeLinecap = 'round';
		this.wireframeLinejoin = 'round';

		this.skinning = false;
		this.morphTargets = false;
		this.morphNormals = false;

		this.setValues( parameters );

	}

	MeshStandardMaterial.prototype = Object.create( Material.prototype );
	MeshStandardMaterial.prototype.constructor = MeshStandardMaterial;

	MeshStandardMaterial.prototype.isMeshStandardMaterial = true;

	MeshStandardMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.defines = { 'STANDARD': '' };

		this.color.copy( source.color );
		this.roughness = source.roughness;
		this.metalness = source.metalness;

		this.map = source.map;

		this.lightMap = source.lightMap;
		this.lightMapIntensity = source.lightMapIntensity;

		this.aoMap = source.aoMap;
		this.aoMapIntensity = source.aoMapIntensity;

		this.emissive.copy( source.emissive );
		this.emissiveMap = source.emissiveMap;
		this.emissiveIntensity = source.emissiveIntensity;

		this.bumpMap = source.bumpMap;
		this.bumpScale = source.bumpScale;

		this.normalMap = source.normalMap;
		this.normalScale.copy( source.normalScale );

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.roughnessMap = source.roughnessMap;

		this.metalnessMap = source.metalnessMap;

		this.alphaMap = source.alphaMap;

		this.envMap = source.envMap;
		this.envMapIntensity = source.envMapIntensity;

		this.refractionRatio = source.refractionRatio;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;
		this.wireframeLinecap = source.wireframeLinecap;
		this.wireframeLinejoin = source.wireframeLinejoin;

		this.skinning = source.skinning;
		this.morphTargets = source.morphTargets;
		this.morphNormals = source.morphNormals;

		return this;

	};

	/**
	 * @author WestLangley / http://github.com/WestLangley
	 *
	 * parameters = {
	 *  reflectivity: <float>
	 * }
	 */

	function MeshPhysicalMaterial( parameters ) {

		MeshStandardMaterial.call( this );

		this.defines = { 'PHYSICAL': '' };

		this.type = 'MeshPhysicalMaterial';

		this.reflectivity = 0.5; // maps to F0 = 0.04

		this.clearCoat = 0.0;
		this.clearCoatRoughness = 0.0;

		this.setValues( parameters );

	}

	MeshPhysicalMaterial.prototype = Object.create( MeshStandardMaterial.prototype );
	MeshPhysicalMaterial.prototype.constructor = MeshPhysicalMaterial;

	MeshPhysicalMaterial.prototype.isMeshPhysicalMaterial = true;

	MeshPhysicalMaterial.prototype.copy = function ( source ) {

		MeshStandardMaterial.prototype.copy.call( this, source );

		this.defines = { 'PHYSICAL': '' };

		this.reflectivity = source.reflectivity;

		this.clearCoat = source.clearCoat;
		this.clearCoatRoughness = source.clearCoatRoughness;

		return this;

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 *
	 * parameters = {
	 *  color: <hex>,
	 *  specular: <hex>,
	 *  shininess: <float>,
	 *  opacity: <float>,
	 *
	 *  map: new THREE.Texture( <Image> ),
	 *
	 *  lightMap: new THREE.Texture( <Image> ),
	 *  lightMapIntensity: <float>
	 *
	 *  aoMap: new THREE.Texture( <Image> ),
	 *  aoMapIntensity: <float>
	 *
	 *  emissive: <hex>,
	 *  emissiveIntensity: <float>
	 *  emissiveMap: new THREE.Texture( <Image> ),
	 *
	 *  bumpMap: new THREE.Texture( <Image> ),
	 *  bumpScale: <float>,
	 *
	 *  normalMap: new THREE.Texture( <Image> ),
	 *  normalScale: <Vector2>,
	 *
	 *  displacementMap: new THREE.Texture( <Image> ),
	 *  displacementScale: <float>,
	 *  displacementBias: <float>,
	 *
	 *  specularMap: new THREE.Texture( <Image> ),
	 *
	 *  alphaMap: new THREE.Texture( <Image> ),
	 *
	 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
	 *  combine: THREE.Multiply,
	 *  reflectivity: <float>,
	 *  refractionRatio: <float>,
	 *
	 *  wireframe: <boolean>,
	 *  wireframeLinewidth: <float>,
	 *
	 *  skinning: <bool>,
	 *  morphTargets: <bool>,
	 *  morphNormals: <bool>
	 * }
	 */

	function MeshPhongMaterial( parameters ) {

		Material.call( this );

		this.type = 'MeshPhongMaterial';

		this.color = new Color( 0xffffff ); // diffuse
		this.specular = new Color( 0x111111 );
		this.shininess = 30;

		this.map = null;

		this.lightMap = null;
		this.lightMapIntensity = 1.0;

		this.aoMap = null;
		this.aoMapIntensity = 1.0;

		this.emissive = new Color( 0x000000 );
		this.emissiveIntensity = 1.0;
		this.emissiveMap = null;

		this.bumpMap = null;
		this.bumpScale = 1;

		this.normalMap = null;
		this.normalScale = new Vector2( 1, 1 );

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.specularMap = null;

		this.alphaMap = null;

		this.envMap = null;
		this.combine = MultiplyOperation;
		this.reflectivity = 1;
		this.refractionRatio = 0.98;

		this.wireframe = false;
		this.wireframeLinewidth = 1;
		this.wireframeLinecap = 'round';
		this.wireframeLinejoin = 'round';

		this.skinning = false;
		this.morphTargets = false;
		this.morphNormals = false;

		this.setValues( parameters );

	}

	MeshPhongMaterial.prototype = Object.create( Material.prototype );
	MeshPhongMaterial.prototype.constructor = MeshPhongMaterial;

	MeshPhongMaterial.prototype.isMeshPhongMaterial = true;

	MeshPhongMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.color.copy( source.color );
		this.specular.copy( source.specular );
		this.shininess = source.shininess;

		this.map = source.map;

		this.lightMap = source.lightMap;
		this.lightMapIntensity = source.lightMapIntensity;

		this.aoMap = source.aoMap;
		this.aoMapIntensity = source.aoMapIntensity;

		this.emissive.copy( source.emissive );
		this.emissiveMap = source.emissiveMap;
		this.emissiveIntensity = source.emissiveIntensity;

		this.bumpMap = source.bumpMap;
		this.bumpScale = source.bumpScale;

		this.normalMap = source.normalMap;
		this.normalScale.copy( source.normalScale );

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.specularMap = source.specularMap;

		this.alphaMap = source.alphaMap;

		this.envMap = source.envMap;
		this.combine = source.combine;
		this.reflectivity = source.reflectivity;
		this.refractionRatio = source.refractionRatio;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;
		this.wireframeLinecap = source.wireframeLinecap;
		this.wireframeLinejoin = source.wireframeLinejoin;

		this.skinning = source.skinning;
		this.morphTargets = source.morphTargets;
		this.morphNormals = source.morphNormals;

		return this;

	};

	/**
	 * @author takahirox / http://github.com/takahirox
	 *
	 * parameters = {
	 *  gradientMap: new THREE.Texture( <Image> )
	 * }
	 */

	function MeshToonMaterial( parameters ) {

		MeshPhongMaterial.call( this );

		this.defines = { 'TOON': '' };

		this.type = 'MeshToonMaterial';

		this.gradientMap = null;

		this.setValues( parameters );

	}

	MeshToonMaterial.prototype = Object.create( MeshPhongMaterial.prototype );
	MeshToonMaterial.prototype.constructor = MeshToonMaterial;

	MeshToonMaterial.prototype.isMeshToonMaterial = true;

	MeshToonMaterial.prototype.copy = function ( source ) {

		MeshPhongMaterial.prototype.copy.call( this, source );

		this.gradientMap = source.gradientMap;

		return this;

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author WestLangley / http://github.com/WestLangley
	 *
	 * parameters = {
	 *  opacity: <float>,
	 *
	 *  bumpMap: new THREE.Texture( <Image> ),
	 *  bumpScale: <float>,
	 *
	 *  normalMap: new THREE.Texture( <Image> ),
	 *  normalScale: <Vector2>,
	 *
	 *  displacementMap: new THREE.Texture( <Image> ),
	 *  displacementScale: <float>,
	 *  displacementBias: <float>,
	 *
	 *  wireframe: <boolean>,
	 *  wireframeLinewidth: <float>
	 *
	 *  skinning: <bool>,
	 *  morphTargets: <bool>,
	 *  morphNormals: <bool>
	 * }
	 */

	function MeshNormalMaterial( parameters ) {

		Material.call( this );

		this.type = 'MeshNormalMaterial';

		this.bumpMap = null;
		this.bumpScale = 1;

		this.normalMap = null;
		this.normalScale = new Vector2( 1, 1 );

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.wireframe = false;
		this.wireframeLinewidth = 1;

		this.fog = false;
		this.lights = false;

		this.skinning = false;
		this.morphTargets = false;
		this.morphNormals = false;

		this.setValues( parameters );

	}

	MeshNormalMaterial.prototype = Object.create( Material.prototype );
	MeshNormalMaterial.prototype.constructor = MeshNormalMaterial;

	MeshNormalMaterial.prototype.isMeshNormalMaterial = true;

	MeshNormalMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.bumpMap = source.bumpMap;
		this.bumpScale = source.bumpScale;

		this.normalMap = source.normalMap;
		this.normalScale.copy( source.normalScale );

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;

		this.skinning = source.skinning;
		this.morphTargets = source.morphTargets;
		this.morphNormals = source.morphNormals;

		return this;

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 *
	 * parameters = {
	 *  color: <hex>,
	 *  opacity: <float>,
	 *
	 *  map: new THREE.Texture( <Image> ),
	 *
	 *  lightMap: new THREE.Texture( <Image> ),
	 *  lightMapIntensity: <float>
	 *
	 *  aoMap: new THREE.Texture( <Image> ),
	 *  aoMapIntensity: <float>
	 *
	 *  emissive: <hex>,
	 *  emissiveIntensity: <float>
	 *  emissiveMap: new THREE.Texture( <Image> ),
	 *
	 *  specularMap: new THREE.Texture( <Image> ),
	 *
	 *  alphaMap: new THREE.Texture( <Image> ),
	 *
	 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
	 *  combine: THREE.Multiply,
	 *  reflectivity: <float>,
	 *  refractionRatio: <float>,
	 *
	 *  wireframe: <boolean>,
	 *  wireframeLinewidth: <float>,
	 *
	 *  skinning: <bool>,
	 *  morphTargets: <bool>,
	 *  morphNormals: <bool>
	 * }
	 */

	function MeshLambertMaterial( parameters ) {

		Material.call( this );

		this.type = 'MeshLambertMaterial';

		this.color = new Color( 0xffffff ); // diffuse

		this.map = null;

		this.lightMap = null;
		this.lightMapIntensity = 1.0;

		this.aoMap = null;
		this.aoMapIntensity = 1.0;

		this.emissive = new Color( 0x000000 );
		this.emissiveIntensity = 1.0;
		this.emissiveMap = null;

		this.specularMap = null;

		this.alphaMap = null;

		this.envMap = null;
		this.combine = MultiplyOperation;
		this.reflectivity = 1;
		this.refractionRatio = 0.98;

		this.wireframe = false;
		this.wireframeLinewidth = 1;
		this.wireframeLinecap = 'round';
		this.wireframeLinejoin = 'round';

		this.skinning = false;
		this.morphTargets = false;
		this.morphNormals = false;

		this.setValues( parameters );

	}

	MeshLambertMaterial.prototype = Object.create( Material.prototype );
	MeshLambertMaterial.prototype.constructor = MeshLambertMaterial;

	MeshLambertMaterial.prototype.isMeshLambertMaterial = true;

	MeshLambertMaterial.prototype.copy = function ( source ) {

		Material.prototype.copy.call( this, source );

		this.color.copy( source.color );

		this.map = source.map;

		this.lightMap = source.lightMap;
		this.lightMapIntensity = source.lightMapIntensity;

		this.aoMap = source.aoMap;
		this.aoMapIntensity = source.aoMapIntensity;

		this.emissive.copy( source.emissive );
		this.emissiveMap = source.emissiveMap;
		this.emissiveIntensity = source.emissiveIntensity;

		this.specularMap = source.specularMap;

		this.alphaMap = source.alphaMap;

		this.envMap = source.envMap;
		this.combine = source.combine;
		this.reflectivity = source.reflectivity;
		this.refractionRatio = source.refractionRatio;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;
		this.wireframeLinecap = source.wireframeLinecap;
		this.wireframeLinejoin = source.wireframeLinejoin;

		this.skinning = source.skinning;
		this.morphTargets = source.morphTargets;
		this.morphNormals = source.morphNormals;

		return this;

	};

	/**
	 * @author alteredq / http://alteredqualia.com/
	 *
	 * parameters = {
	 *  color: <hex>,
	 *  opacity: <float>,
	 *
	 *  linewidth: <float>,
	 *
	 *  scale: <float>,
	 *  dashSize: <float>,
	 *  gapSize: <float>
	 * }
	 */

	function LineDashedMaterial( parameters ) {

		LineBasicMaterial.call( this );

		this.type = 'LineDashedMaterial';

		this.scale = 1;
		this.dashSize = 3;
		this.gapSize = 1;

		this.setValues( parameters );

	}

	LineDashedMaterial.prototype = Object.create( LineBasicMaterial.prototype );
	LineDashedMaterial.prototype.constructor = LineDashedMaterial;

	LineDashedMaterial.prototype.isLineDashedMaterial = true;

	LineDashedMaterial.prototype.copy = function ( source ) {

		LineBasicMaterial.prototype.copy.call( this, source );

		this.scale = source.scale;
		this.dashSize = source.dashSize;
		this.gapSize = source.gapSize;

		return this;

	};



	var Materials = Object.freeze({
		ShadowMaterial: ShadowMaterial,
		SpriteMaterial: SpriteMaterial,
		RawShaderMaterial: RawShaderMaterial,
		ShaderMaterial: ShaderMaterial,
		PointsMaterial: PointsMaterial,
		MeshPhysicalMaterial: MeshPhysicalMaterial,
		MeshStandardMaterial: MeshStandardMaterial,
		MeshPhongMaterial: MeshPhongMaterial,
		MeshToonMaterial: MeshToonMaterial,
		MeshNormalMaterial: MeshNormalMaterial,
		MeshLambertMaterial: MeshLambertMaterial,
		MeshDepthMaterial: MeshDepthMaterial,
		MeshDistanceMaterial: MeshDistanceMaterial,
		MeshBasicMaterial: MeshBasicMaterial,
		LineDashedMaterial: LineDashedMaterial,
		LineBasicMaterial: LineBasicMaterial,
		Material: Material
	});

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	var Cache = {

		enabled: false,

		files: {},

		add: function ( key, file ) {

			if ( this.enabled === false ) return;

			// console.log( 'THREE.Cache', 'Adding key:', key );

			this.files[ key ] = file;

		},

		get: function ( key ) {

			if ( this.enabled === false ) return;

			// console.log( 'THREE.Cache', 'Checking key:', key );

			return this.files[ key ];

		},

		remove: function ( key ) {

			delete this.files[ key ];

		},

		clear: function () {

			this.files = {};

		}

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function LoadingManager( onLoad, onProgress, onError ) {

		var scope = this;

		var isLoading = false, itemsLoaded = 0, itemsTotal = 0;

		this.onStart = undefined;
		this.onLoad = onLoad;
		this.onProgress = onProgress;
		this.onError = onError;

		this.itemStart = function ( url ) {

			itemsTotal ++;

			if ( isLoading === false ) {

				if ( scope.onStart !== undefined ) {

					scope.onStart( url, itemsLoaded, itemsTotal );

				}

			}

			isLoading = true;

		};

		this.itemEnd = function ( url ) {

			itemsLoaded ++;

			if ( scope.onProgress !== undefined ) {

				scope.onProgress( url, itemsLoaded, itemsTotal );

			}

			if ( itemsLoaded === itemsTotal ) {

				isLoading = false;

				if ( scope.onLoad !== undefined ) {

					scope.onLoad();

				}

			}

		};

		this.itemError = function ( url ) {

			if ( scope.onError !== undefined ) {

				scope.onError( url );

			}

		};

	}

	var DefaultLoadingManager = new LoadingManager();

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function FileLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

	}

	Object.assign( FileLoader.prototype, {

		load: function ( url, onLoad, onProgress, onError ) {

			if ( url === undefined ) url = '';

			if ( this.path !== undefined ) url = this.path + url;

			var scope = this;

			var cached = Cache.get( url );

			if ( cached !== undefined ) {

				scope.manager.itemStart( url );

				setTimeout( function () {

					if ( onLoad ) onLoad( cached );

					scope.manager.itemEnd( url );

				}, 0 );

				return cached;

			}

			// Check for data: URI
			var dataUriRegex = /^data:(.*?)(;base64)?,(.*)$/;
			var dataUriRegexResult = url.match( dataUriRegex );

			// Safari can not handle Data URIs through XMLHttpRequest so process manually
			if ( dataUriRegexResult ) {

				var mimeType = dataUriRegexResult[ 1 ];
				var isBase64 = !! dataUriRegexResult[ 2 ];
				var data = dataUriRegexResult[ 3 ];

				data = window.decodeURIComponent( data );

				if ( isBase64 ) data = window.atob( data );

				try {

					var response;
					var responseType = ( this.responseType || '' ).toLowerCase();

					switch ( responseType ) {

						case 'arraybuffer':
						case 'blob':

						 	response = new ArrayBuffer( data.length );

							var view = new Uint8Array( response );

							for ( var i = 0; i < data.length; i ++ ) {

								view[ i ] = data.charCodeAt( i );

							}

							if ( responseType === 'blob' ) {

								response = new Blob( [ response ], { type: mimeType } );

							}

							break;

						case 'document':

							var parser = new DOMParser();
							response = parser.parseFromString( data, mimeType );

							break;

						case 'json':

							response = JSON.parse( data );

							break;

						default: // 'text' or other

							response = data;

							break;

					}

					// Wait for next browser tick
					window.setTimeout( function () {

						if ( onLoad ) onLoad( response );

						scope.manager.itemEnd( url );

					}, 0 );

				} catch ( error ) {

					// Wait for next browser tick
					window.setTimeout( function () {

						if ( onError ) onError( error );

						scope.manager.itemEnd( url );
						scope.manager.itemError( url );

					}, 0 );

				}

			} else {

				var request = new XMLHttpRequest();
				request.open( 'GET', url, true );

				request.addEventListener( 'load', function ( event ) {

					var response = event.target.response;

					Cache.add( url, response );

					if ( this.status === 200 ) {

						if ( onLoad ) onLoad( response );

						scope.manager.itemEnd( url );

					} else if ( this.status === 0 ) {

						// Some browsers return HTTP Status 0 when using non-http protocol
						// e.g. 'file://' or 'data://'. Handle as success.

						console.warn( 'THREE.FileLoader: HTTP Status 0 received.' );

						if ( onLoad ) onLoad( response );

						scope.manager.itemEnd( url );

					} else {

						if ( onError ) onError( event );

						scope.manager.itemEnd( url );
						scope.manager.itemError( url );

					}

				}, false );

				if ( onProgress !== undefined ) {

					request.addEventListener( 'progress', function ( event ) {

						onProgress( event );

					}, false );

				}

				request.addEventListener( 'error', function ( event ) {

					if ( onError ) onError( event );

					scope.manager.itemEnd( url );
					scope.manager.itemError( url );

				}, false );

				if ( this.responseType !== undefined ) request.responseType = this.responseType;
				if ( this.withCredentials !== undefined ) request.withCredentials = this.withCredentials;

				if ( request.overrideMimeType ) request.overrideMimeType( this.mimeType !== undefined ? this.mimeType : 'text/plain' );

				for ( var header in this.requestHeader ) {

					request.setRequestHeader( header, this.requestHeader[ header ] );

				}

				request.send( null );

			}

			scope.manager.itemStart( url );

			return request;

		},

		setPath: function ( value ) {

			this.path = value;
			return this;

		},

		setResponseType: function ( value ) {

			this.responseType = value;
			return this;

		},

		setWithCredentials: function ( value ) {

			this.withCredentials = value;
			return this;

		},

		setMimeType: function ( value ) {

			this.mimeType = value;
			return this;

		},

		setRequestHeader: function ( value ) {

			this.requestHeader = value;
			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 *
	 * Abstract Base class to block based textures loader (dds, pvr, ...)
	 */

	function CompressedTextureLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

		// override in sub classes
		this._parser = null;

	}

	Object.assign( CompressedTextureLoader.prototype, {

		load: function ( url, onLoad, onProgress, onError ) {

			var scope = this;

			var images = [];

			var texture = new CompressedTexture();
			texture.image = images;

			var loader = new FileLoader( this.manager );
			loader.setPath( this.path );
			loader.setResponseType( 'arraybuffer' );

			function loadTexture( i ) {

				loader.load( url[ i ], function ( buffer ) {

					var texDatas = scope._parser( buffer, true );

					images[ i ] = {
						width: texDatas.width,
						height: texDatas.height,
						format: texDatas.format,
						mipmaps: texDatas.mipmaps
					};

					loaded += 1;

					if ( loaded === 6 ) {

						if ( texDatas.mipmapCount === 1 )
							texture.minFilter = LinearFilter;

						texture.format = texDatas.format;
						texture.needsUpdate = true;

						if ( onLoad ) onLoad( texture );

					}

				}, onProgress, onError );

			}

			if ( Array.isArray( url ) ) {

				var loaded = 0;

				for ( var i = 0, il = url.length; i < il; ++ i ) {

					loadTexture( i );

				}

			} else {

				// compressed cubemap texture stored in a single DDS file

				loader.load( url, function ( buffer ) {

					var texDatas = scope._parser( buffer, true );

					if ( texDatas.isCubemap ) {

						var faces = texDatas.mipmaps.length / texDatas.mipmapCount;

						for ( var f = 0; f < faces; f ++ ) {

							images[ f ] = { mipmaps : [] };

							for ( var i = 0; i < texDatas.mipmapCount; i ++ ) {

								images[ f ].mipmaps.push( texDatas.mipmaps[ f * texDatas.mipmapCount + i ] );
								images[ f ].format = texDatas.format;
								images[ f ].width = texDatas.width;
								images[ f ].height = texDatas.height;

							}

						}

					} else {

						texture.image.width = texDatas.width;
						texture.image.height = texDatas.height;
						texture.mipmaps = texDatas.mipmaps;

					}

					if ( texDatas.mipmapCount === 1 ) {

						texture.minFilter = LinearFilter;

					}

					texture.format = texDatas.format;
					texture.needsUpdate = true;

					if ( onLoad ) onLoad( texture );

				}, onProgress, onError );

			}

			return texture;

		},

		setPath: function ( value ) {

			this.path = value;
			return this;

		}

	} );

	/**
	 * @author Nikos M. / https://github.com/foo123/
	 *
	 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
	 */

	function DataTextureLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

		// override in sub classes
		this._parser = null;

	}

	Object.assign( DataTextureLoader.prototype, {

		load: function ( url, onLoad, onProgress, onError ) {

			var scope = this;

			var texture = new DataTexture();

			var loader = new FileLoader( this.manager );
			loader.setResponseType( 'arraybuffer' );

			loader.load( url, function ( buffer ) {

				var texData = scope._parser( buffer );

				if ( ! texData ) return;

				if ( undefined !== texData.image ) {

					texture.image = texData.image;

				} else if ( undefined !== texData.data ) {

					texture.image.width = texData.width;
					texture.image.height = texData.height;
					texture.image.data = texData.data;

				}

				texture.wrapS = undefined !== texData.wrapS ? texData.wrapS : ClampToEdgeWrapping;
				texture.wrapT = undefined !== texData.wrapT ? texData.wrapT : ClampToEdgeWrapping;

				texture.magFilter = undefined !== texData.magFilter ? texData.magFilter : LinearFilter;
				texture.minFilter = undefined !== texData.minFilter ? texData.minFilter : LinearMipMapLinearFilter;

				texture.anisotropy = undefined !== texData.anisotropy ? texData.anisotropy : 1;

				if ( undefined !== texData.format ) {

					texture.format = texData.format;

				}
				if ( undefined !== texData.type ) {

					texture.type = texData.type;

				}

				if ( undefined !== texData.mipmaps ) {

					texture.mipmaps = texData.mipmaps;

				}

				if ( 1 === texData.mipmapCount ) {

					texture.minFilter = LinearFilter;

				}

				texture.needsUpdate = true;

				if ( onLoad ) onLoad( texture, texData );

			}, onProgress, onError );


			return texture;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function ImageLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

	}

	Object.assign( ImageLoader.prototype, {

		crossOrigin: 'Anonymous',

		load: function ( url, onLoad, onProgress, onError ) {

			if ( url === undefined ) url = '';

			if ( this.path !== undefined ) url = this.path + url;

			var scope = this;

			var cached = Cache.get( url );

			if ( cached !== undefined ) {

				scope.manager.itemStart( url );

				setTimeout( function () {

					if ( onLoad ) onLoad( cached );

					scope.manager.itemEnd( url );

				}, 0 );

				return cached;

			}

			var image = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'img' );

			image.addEventListener( 'load', function () {

				Cache.add( url, this );

				if ( onLoad ) onLoad( this );

				scope.manager.itemEnd( url );

			}, false );

			/*
			image.addEventListener( 'progress', function ( event ) {

				if ( onProgress ) onProgress( event );

			}, false );
			*/

			image.addEventListener( 'error', function ( event ) {

				if ( onError ) onError( event );

				scope.manager.itemEnd( url );
				scope.manager.itemError( url );

			}, false );

			if ( url.substr( 0, 5 ) !== 'data:' ) {

				if ( this.crossOrigin !== undefined ) image.crossOrigin = this.crossOrigin;

			}

			scope.manager.itemStart( url );

			image.src = url;

			return image;

		},

		setCrossOrigin: function ( value ) {

			this.crossOrigin = value;
			return this;

		},

		setPath: function ( value ) {

			this.path = value;
			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function CubeTextureLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

	}

	Object.assign( CubeTextureLoader.prototype, {

		crossOrigin: 'Anonymous',

		load: function ( urls, onLoad, onProgress, onError ) {

			var texture = new CubeTexture();

			var loader = new ImageLoader( this.manager );
			loader.setCrossOrigin( this.crossOrigin );
			loader.setPath( this.path );

			var loaded = 0;

			function loadTexture( i ) {

				loader.load( urls[ i ], function ( image ) {

					texture.images[ i ] = image;

					loaded ++;

					if ( loaded === 6 ) {

						texture.needsUpdate = true;

						if ( onLoad ) onLoad( texture );

					}

				}, undefined, onError );

			}

			for ( var i = 0; i < urls.length; ++ i ) {

				loadTexture( i );

			}

			return texture;

		},

		setCrossOrigin: function ( value ) {

			this.crossOrigin = value;
			return this;

		},

		setPath: function ( value ) {

			this.path = value;
			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function TextureLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

	}

	Object.assign( TextureLoader.prototype, {

		crossOrigin: 'Anonymous',

		load: function ( url, onLoad, onProgress, onError ) {

			var loader = new ImageLoader( this.manager );
			loader.setCrossOrigin( this.crossOrigin );
			loader.setPath( this.path );

			var texture = new Texture();
			texture.image = loader.load( url, function () {

				// JPEGs can't have an alpha channel, so memory can be saved by storing them as RGB.
				var isJPEG = url.search( /\.(jpg|jpeg)$/ ) > 0 || url.search( /^data\:image\/jpeg/ ) === 0;

				texture.format = isJPEG ? RGBFormat : RGBAFormat;
				texture.needsUpdate = true;

				if ( onLoad !== undefined ) {

					onLoad( texture );

				}

			}, onProgress, onError );

			return texture;

		},

		setCrossOrigin: function ( value ) {

			this.crossOrigin = value;
			return this;

		},

		setPath: function ( value ) {

			this.path = value;
			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 */

	function Light( color, intensity ) {

		Object3D.call( this );

		this.type = 'Light';

		this.color = new Color( color );
		this.intensity = intensity !== undefined ? intensity : 1;

		this.receiveShadow = undefined;

	}

	Light.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: Light,

		isLight: true,

		copy: function ( source ) {

			Object3D.prototype.copy.call( this, source );

			this.color.copy( source.color );
			this.intensity = source.intensity;

			return this;

		},

		toJSON: function ( meta ) {

			var data = Object3D.prototype.toJSON.call( this, meta );

			data.object.color = this.color.getHex();
			data.object.intensity = this.intensity;

			if ( this.groundColor !== undefined ) data.object.groundColor = this.groundColor.getHex();

			if ( this.distance !== undefined ) data.object.distance = this.distance;
			if ( this.angle !== undefined ) data.object.angle = this.angle;
			if ( this.decay !== undefined ) data.object.decay = this.decay;
			if ( this.penumbra !== undefined ) data.object.penumbra = this.penumbra;

			if ( this.shadow !== undefined ) data.object.shadow = this.shadow.toJSON();

			return data;

		}

	} );

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	function HemisphereLight( skyColor, groundColor, intensity ) {

		Light.call( this, skyColor, intensity );

		this.type = 'HemisphereLight';

		this.castShadow = undefined;

		this.position.copy( Object3D.DefaultUp );
		this.updateMatrix();

		this.groundColor = new Color( groundColor );

	}

	HemisphereLight.prototype = Object.assign( Object.create( Light.prototype ), {

		constructor: HemisphereLight,

		isHemisphereLight: true,

		copy: function ( source ) {

			Light.prototype.copy.call( this, source );

			this.groundColor.copy( source.groundColor );

			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function LightShadow( camera ) {

		this.camera = camera;

		this.bias = 0;
		this.radius = 1;

		this.mapSize = new Vector2( 512, 512 );

		this.map = null;
		this.matrix = new Matrix4();

	}

	Object.assign( LightShadow.prototype, {

		copy: function ( source ) {

			this.camera = source.camera.clone();

			this.bias = source.bias;
			this.radius = source.radius;

			this.mapSize.copy( source.mapSize );

			return this;

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		toJSON: function () {

			var object = {};

			if ( this.bias !== 0 ) object.bias = this.bias;
			if ( this.radius !== 1 ) object.radius = this.radius;
			if ( this.mapSize.x !== 512 || this.mapSize.y !== 512 ) object.mapSize = this.mapSize.toArray();

			object.camera = this.camera.toJSON( false ).object;
			delete object.camera.matrix;

			return object;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function SpotLightShadow() {

		LightShadow.call( this, new PerspectiveCamera( 50, 1, 0.5, 500 ) );

	}

	SpotLightShadow.prototype = Object.assign( Object.create( LightShadow.prototype ), {

		constructor: SpotLightShadow,

		isSpotLightShadow: true,

		update: function ( light ) {

			var camera = this.camera;

			var fov = _Math.RAD2DEG * 2 * light.angle;
			var aspect = this.mapSize.width / this.mapSize.height;
			var far = light.distance || camera.far;

			if ( fov !== camera.fov || aspect !== camera.aspect || far !== camera.far ) {

				camera.fov = fov;
				camera.aspect = aspect;
				camera.far = far;
				camera.updateProjectionMatrix();

			}

		}

	} );

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	function SpotLight( color, intensity, distance, angle, penumbra, decay ) {

		Light.call( this, color, intensity );

		this.type = 'SpotLight';

		this.position.copy( Object3D.DefaultUp );
		this.updateMatrix();

		this.target = new Object3D();

		Object.defineProperty( this, 'power', {
			get: function () {
				// intensity = power per solid angle.
				// ref: equation (17) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
				return this.intensity * Math.PI;
			},
			set: function ( power ) {
				// intensity = power per solid angle.
				// ref: equation (17) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
				this.intensity = power / Math.PI;
			}
		} );

		this.distance = ( distance !== undefined ) ? distance : 0;
		this.angle = ( angle !== undefined ) ? angle : Math.PI / 3;
		this.penumbra = ( penumbra !== undefined ) ? penumbra : 0;
		this.decay = ( decay !== undefined ) ? decay : 1;	// for physically correct lights, should be 2.

		this.shadow = new SpotLightShadow();

	}

	SpotLight.prototype = Object.assign( Object.create( Light.prototype ), {

		constructor: SpotLight,

		isSpotLight: true,

		copy: function ( source ) {

			Light.prototype.copy.call( this, source );

			this.distance = source.distance;
			this.angle = source.angle;
			this.penumbra = source.penumbra;
			this.decay = source.decay;

			this.target = source.target.clone();

			this.shadow = source.shadow.clone();

			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */


	function PointLight( color, intensity, distance, decay ) {

		Light.call( this, color, intensity );

		this.type = 'PointLight';

		Object.defineProperty( this, 'power', {
			get: function () {
				// intensity = power per solid angle.
				// ref: equation (15) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
				return this.intensity * 4 * Math.PI;

			},
			set: function ( power ) {
				// intensity = power per solid angle.
				// ref: equation (15) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
				this.intensity = power / ( 4 * Math.PI );
			}
		} );

		this.distance = ( distance !== undefined ) ? distance : 0;
		this.decay = ( decay !== undefined ) ? decay : 1;	// for physically correct lights, should be 2.

		this.shadow = new LightShadow( new PerspectiveCamera( 90, 1, 0.5, 500 ) );

	}

	PointLight.prototype = Object.assign( Object.create( Light.prototype ), {

		constructor: PointLight,

		isPointLight: true,

		copy: function ( source ) {

			Light.prototype.copy.call( this, source );

			this.distance = source.distance;
			this.decay = source.decay;

			this.shadow = source.shadow.clone();

			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function DirectionalLightShadow( ) {

		LightShadow.call( this, new OrthographicCamera( - 5, 5, 5, - 5, 0.5, 500 ) );

	}

	DirectionalLightShadow.prototype = Object.assign( Object.create( LightShadow.prototype ), {

		constructor: DirectionalLightShadow

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 */

	function DirectionalLight( color, intensity ) {

		Light.call( this, color, intensity );

		this.type = 'DirectionalLight';

		this.position.copy( Object3D.DefaultUp );
		this.updateMatrix();

		this.target = new Object3D();

		this.shadow = new DirectionalLightShadow();

	}

	DirectionalLight.prototype = Object.assign( Object.create( Light.prototype ), {

		constructor: DirectionalLight,

		isDirectionalLight: true,

		copy: function ( source ) {

			Light.prototype.copy.call( this, source );

			this.target = source.target.clone();

			this.shadow = source.shadow.clone();

			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function AmbientLight( color, intensity ) {

		Light.call( this, color, intensity );

		this.type = 'AmbientLight';

		this.castShadow = undefined;

	}

	AmbientLight.prototype = Object.assign( Object.create( Light.prototype ), {

		constructor: AmbientLight,

		isAmbientLight: true

	} );

	/**
	 * @author abelnation / http://github.com/abelnation
	 */

	function RectAreaLight( color, intensity, width, height ) {

		Light.call( this, color, intensity );

		this.type = 'RectAreaLight';

		this.position.set( 0, 1, 0 );
		this.updateMatrix();

		this.width = ( width !== undefined ) ? width : 10;
		this.height = ( height !== undefined ) ? height : 10;

		// TODO (abelnation): distance/decay

		// TODO (abelnation): update method for RectAreaLight to update transform to lookat target

		// TODO (abelnation): shadows

	}

	// TODO (abelnation): RectAreaLight update when light shape is changed
	RectAreaLight.prototype = Object.assign( Object.create( Light.prototype ), {

		constructor: RectAreaLight,

		isRectAreaLight: true,

		copy: function ( source ) {

			Light.prototype.copy.call( this, source );

			this.width = source.width;
			this.height = source.height;

			return this;

		},

		toJSON: function ( meta ) {

			var data = Light.prototype.toJSON.call( this, meta );

			data.object.width = this.width;
			data.object.height = this.height;

			return data;

		}

	} );

	/**
	 * @author tschw
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 */

	var AnimationUtils = {

		// same as Array.prototype.slice, but also works on typed arrays
		arraySlice: function ( array, from, to ) {

			if ( AnimationUtils.isTypedArray( array ) ) {

				// in ios9 array.subarray(from, undefined) will return empty array
				// but array.subarray(from) or array.subarray(from, len) is correct
				return new array.constructor( array.subarray( from, to !== undefined ? to : array.length ) );

			}

			return array.slice( from, to );

		},

		// converts an array to a specific type
		convertArray: function ( array, type, forceClone ) {

			if ( ! array || // let 'undefined' and 'null' pass
					! forceClone && array.constructor === type ) return array;

			if ( typeof type.BYTES_PER_ELEMENT === 'number' ) {

				return new type( array ); // create typed array

			}

			return Array.prototype.slice.call( array ); // create Array

		},

		isTypedArray: function ( object ) {

			return ArrayBuffer.isView( object ) &&
					! ( object instanceof DataView );

		},

		// returns an array by which times and values can be sorted
		getKeyframeOrder: function ( times ) {

			function compareTime( i, j ) {

				return times[ i ] - times[ j ];

			}

			var n = times.length;
			var result = new Array( n );
			for ( var i = 0; i !== n; ++ i ) result[ i ] = i;

			result.sort( compareTime );

			return result;

		},

		// uses the array previously returned by 'getKeyframeOrder' to sort data
		sortedArray: function ( values, stride, order ) {

			var nValues = values.length;
			var result = new values.constructor( nValues );

			for ( var i = 0, dstOffset = 0; dstOffset !== nValues; ++ i ) {

				var srcOffset = order[ i ] * stride;

				for ( var j = 0; j !== stride; ++ j ) {

					result[ dstOffset ++ ] = values[ srcOffset + j ];

				}

			}

			return result;

		},

		// function for parsing AOS keyframe formats
		flattenJSON: function ( jsonKeys, times, values, valuePropertyName ) {

			var i = 1, key = jsonKeys[ 0 ];

			while ( key !== undefined && key[ valuePropertyName ] === undefined ) {

				key = jsonKeys[ i ++ ];

			}

			if ( key === undefined ) return; // no data

			var value = key[ valuePropertyName ];
			if ( value === undefined ) return; // no data

			if ( Array.isArray( value ) ) {

				do {

					value = key[ valuePropertyName ];

					if ( value !== undefined ) {

						times.push( key.time );
						values.push.apply( values, value ); // push all elements

					}

					key = jsonKeys[ i ++ ];

				} while ( key !== undefined );

			} else if ( value.toArray !== undefined ) {

				// ...assume THREE.Math-ish

				do {

					value = key[ valuePropertyName ];

					if ( value !== undefined ) {

						times.push( key.time );
						value.toArray( values, values.length );

					}

					key = jsonKeys[ i ++ ];

				} while ( key !== undefined );

			} else {

				// otherwise push as-is

				do {

					value = key[ valuePropertyName ];

					if ( value !== undefined ) {

						times.push( key.time );
						values.push( value );

					}

					key = jsonKeys[ i ++ ];

				} while ( key !== undefined );

			}

		}

	};

	/**
	 * Abstract base class of interpolants over parametric samples.
	 *
	 * The parameter domain is one dimensional, typically the time or a path
	 * along a curve defined by the data.
	 *
	 * The sample values can have any dimensionality and derived classes may
	 * apply special interpretations to the data.
	 *
	 * This class provides the interval seek in a Template Method, deferring
	 * the actual interpolation to derived classes.
	 *
	 * Time complexity is O(1) for linear access crossing at most two points
	 * and O(log N) for random access, where N is the number of positions.
	 *
	 * References:
	 *
	 * 		http://www.oodesign.com/template-method-pattern.html
	 *
	 * @author tschw
	 */

	function Interpolant( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		this.parameterPositions = parameterPositions;
		this._cachedIndex = 0;

		this.resultBuffer = resultBuffer !== undefined ?
				resultBuffer : new sampleValues.constructor( sampleSize );
		this.sampleValues = sampleValues;
		this.valueSize = sampleSize;

	}

	Object.assign( Interpolant.prototype, {

		evaluate: function( t ) {

			var pp = this.parameterPositions,
				i1 = this._cachedIndex,

				t1 = pp[   i1   ],
				t0 = pp[ i1 - 1 ];

			validate_interval: {

				seek: {

					var right;

					linear_scan: {
						//- See http://jsperf.com/comparison-to-undefined/3
						//- slower code:
						//-
						//- 				if ( t >= t1 || t1 === undefined ) {
						forward_scan: if ( ! ( t < t1 ) ) {

							for ( var giveUpAt = i1 + 2; ;) {

								if ( t1 === undefined ) {

									if ( t < t0 ) break forward_scan;

									// after end

									i1 = pp.length;
									this._cachedIndex = i1;
									return this.afterEnd_( i1 - 1, t, t0 );

								}

								if ( i1 === giveUpAt ) break; // this loop

								t0 = t1;
								t1 = pp[ ++ i1 ];

								if ( t < t1 ) {

									// we have arrived at the sought interval
									break seek;

								}

							}

							// prepare binary search on the right side of the index
							right = pp.length;
							break linear_scan;

						}

						//- slower code:
						//-					if ( t < t0 || t0 === undefined ) {
						if ( ! ( t >= t0 ) ) {

							// looping?

							var t1global = pp[ 1 ];

							if ( t < t1global ) {

								i1 = 2; // + 1, using the scan for the details
								t0 = t1global;

							}

							// linear reverse scan

							for ( var giveUpAt = i1 - 2; ;) {

								if ( t0 === undefined ) {

									// before start

									this._cachedIndex = 0;
									return this.beforeStart_( 0, t, t1 );

								}

								if ( i1 === giveUpAt ) break; // this loop

								t1 = t0;
								t0 = pp[ -- i1 - 1 ];

								if ( t >= t0 ) {

									// we have arrived at the sought interval
									break seek;

								}

							}

							// prepare binary search on the left side of the index
							right = i1;
							i1 = 0;
							break linear_scan;

						}

						// the interval is valid

						break validate_interval;

					} // linear scan

					// binary search

					while ( i1 < right ) {

						var mid = ( i1 + right ) >>> 1;

						if ( t < pp[ mid ] ) {

							right = mid;

						} else {

							i1 = mid + 1;

						}

					}

					t1 = pp[   i1   ];
					t0 = pp[ i1 - 1 ];

					// check boundary cases, again

					if ( t0 === undefined ) {

						this._cachedIndex = 0;
						return this.beforeStart_( 0, t, t1 );

					}

					if ( t1 === undefined ) {

						i1 = pp.length;
						this._cachedIndex = i1;
						return this.afterEnd_( i1 - 1, t0, t );

					}

				} // seek

				this._cachedIndex = i1;

				this.intervalChanged_( i1, t0, t1 );

			} // validate_interval

			return this.interpolate_( i1, t0, t, t1 );

		},

		settings: null, // optional, subclass-specific settings structure
		// Note: The indirection allows central control of many interpolants.

		// --- Protected interface

		DefaultSettings_: {},

		getSettings_: function() {

			return this.settings || this.DefaultSettings_;

		},

		copySampleValue_: function( index ) {

			// copies a sample value to the result buffer

			var result = this.resultBuffer,
				values = this.sampleValues,
				stride = this.valueSize,
				offset = index * stride;

			for ( var i = 0; i !== stride; ++ i ) {

				result[ i ] = values[ offset + i ];

			}

			return result;

		},

		// Template methods for derived classes:

		interpolate_: function( i1, t0, t, t1 ) {

			throw new Error( "call to abstract method" );
			// implementations shall return this.resultBuffer

		},

		intervalChanged_: function( i1, t0, t1 ) {

			// empty

		}

	} );

	//!\ DECLARE ALIAS AFTER assign prototype !
	Object.assign( Interpolant.prototype, {

		//( 0, t, t0 ), returns this.resultBuffer
		beforeStart_: Interpolant.prototype.copySampleValue_,

		//( N-1, tN-1, t ), returns this.resultBuffer
		afterEnd_: Interpolant.prototype.copySampleValue_,

	} );

	/**
	 * Fast and simple cubic spline interpolant.
	 *
	 * It was derived from a Hermitian construction setting the first derivative
	 * at each sample position to the linear slope between neighboring positions
	 * over their parameter interval.
	 *
	 * @author tschw
	 */

	function CubicInterpolant( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		Interpolant.call(
				this, parameterPositions, sampleValues, sampleSize, resultBuffer );

		this._weightPrev = -0;
		this._offsetPrev = -0;
		this._weightNext = -0;
		this._offsetNext = -0;

	}

	CubicInterpolant.prototype = Object.assign( Object.create( Interpolant.prototype ), {

		constructor: CubicInterpolant,

		DefaultSettings_: {

			endingStart: 	ZeroCurvatureEnding,
			endingEnd:		ZeroCurvatureEnding

		},

		intervalChanged_: function( i1, t0, t1 ) {

			var pp = this.parameterPositions,
				iPrev = i1 - 2,
				iNext = i1 + 1,

				tPrev = pp[ iPrev ],
				tNext = pp[ iNext ];

			if ( tPrev === undefined ) {

				switch ( this.getSettings_().endingStart ) {

					case ZeroSlopeEnding:

						// f'(t0) = 0
						iPrev = i1;
						tPrev = 2 * t0 - t1;

						break;

					case WrapAroundEnding:

						// use the other end of the curve
						iPrev = pp.length - 2;
						tPrev = t0 + pp[ iPrev ] - pp[ iPrev + 1 ];

						break;

					default: // ZeroCurvatureEnding

						// f''(t0) = 0 a.k.a. Natural Spline
						iPrev = i1;
						tPrev = t1;

				}

			}

			if ( tNext === undefined ) {

				switch ( this.getSettings_().endingEnd ) {

					case ZeroSlopeEnding:

						// f'(tN) = 0
						iNext = i1;
						tNext = 2 * t1 - t0;

						break;

					case WrapAroundEnding:

						// use the other end of the curve
						iNext = 1;
						tNext = t1 + pp[ 1 ] - pp[ 0 ];

						break;

					default: // ZeroCurvatureEnding

						// f''(tN) = 0, a.k.a. Natural Spline
						iNext = i1 - 1;
						tNext = t0;

				}

			}

			var halfDt = ( t1 - t0 ) * 0.5,
				stride = this.valueSize;

			this._weightPrev = halfDt / ( t0 - tPrev );
			this._weightNext = halfDt / ( tNext - t1 );
			this._offsetPrev = iPrev * stride;
			this._offsetNext = iNext * stride;

		},

		interpolate_: function( i1, t0, t, t1 ) {

			var result = this.resultBuffer,
				values = this.sampleValues,
				stride = this.valueSize,

				o1 = i1 * stride,		o0 = o1 - stride,
				oP = this._offsetPrev, 	oN = this._offsetNext,
				wP = this._weightPrev,	wN = this._weightNext,

				p = ( t - t0 ) / ( t1 - t0 ),
				pp = p * p,
				ppp = pp * p;

			// evaluate polynomials

			var sP =     - wP   * ppp   +         2 * wP    * pp    -          wP   * p;
			var s0 = ( 1 + wP ) * ppp   + (-1.5 - 2 * wP )  * pp    + ( -0.5 + wP ) * p     + 1;
			var s1 = (-1 - wN ) * ppp   + ( 1.5 +   wN   )  * pp    +    0.5        * p;
			var sN =       wN   * ppp   -           wN      * pp;

			// combine data linearly

			for ( var i = 0; i !== stride; ++ i ) {

				result[ i ] =
						sP * values[ oP + i ] +
						s0 * values[ o0 + i ] +
						s1 * values[ o1 + i ] +
						sN * values[ oN + i ];

			}

			return result;

		}

	} );

	/**
	 * @author tschw
	 */

	function LinearInterpolant( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		Interpolant.call( this, parameterPositions, sampleValues, sampleSize, resultBuffer );

	}

	LinearInterpolant.prototype = Object.assign( Object.create( Interpolant.prototype ), {

		constructor: LinearInterpolant,

		interpolate_: function( i1, t0, t, t1 ) {

			var result = this.resultBuffer,
				values = this.sampleValues,
				stride = this.valueSize,

				offset1 = i1 * stride,
				offset0 = offset1 - stride,

				weight1 = ( t - t0 ) / ( t1 - t0 ),
				weight0 = 1 - weight1;

			for ( var i = 0; i !== stride; ++ i ) {

				result[ i ] =
						values[ offset0 + i ] * weight0 +
						values[ offset1 + i ] * weight1;

			}

			return result;

		}

	} );

	/**
	 *
	 * Interpolant that evaluates to the sample value at the position preceeding
	 * the parameter.
	 *
	 * @author tschw
	 */

	function DiscreteInterpolant( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		Interpolant.call( this, parameterPositions, sampleValues, sampleSize, resultBuffer );

	}

	DiscreteInterpolant.prototype = Object.assign( Object.create( Interpolant.prototype ), {

		constructor: DiscreteInterpolant,

		interpolate_: function( i1, t0, t, t1 ) {

			return this.copySampleValue_( i1 - 1 );

		}

	} );

	var KeyframeTrackPrototype;

	KeyframeTrackPrototype = {

		TimeBufferType: Float32Array,
		ValueBufferType: Float32Array,

		DefaultInterpolation: InterpolateLinear,

		InterpolantFactoryMethodDiscrete: function ( result ) {

			return new DiscreteInterpolant(
					this.times, this.values, this.getValueSize(), result );

		},

		InterpolantFactoryMethodLinear: function ( result ) {

			return new LinearInterpolant(
					this.times, this.values, this.getValueSize(), result );

		},

		InterpolantFactoryMethodSmooth: function ( result ) {

			return new CubicInterpolant(
					this.times, this.values, this.getValueSize(), result );

		},

		setInterpolation: function ( interpolation ) {

			var factoryMethod;

			switch ( interpolation ) {

				case InterpolateDiscrete:

					factoryMethod = this.InterpolantFactoryMethodDiscrete;

					break;

				case InterpolateLinear:

					factoryMethod = this.InterpolantFactoryMethodLinear;

					break;

				case InterpolateSmooth:

					factoryMethod = this.InterpolantFactoryMethodSmooth;

					break;

			}

			if ( factoryMethod === undefined ) {

				var message = "unsupported interpolation for " +
						this.ValueTypeName + " keyframe track named " + this.name;

				if ( this.createInterpolant === undefined ) {

					// fall back to default, unless the default itself is messed up
					if ( interpolation !== this.DefaultInterpolation ) {

						this.setInterpolation( this.DefaultInterpolation );

					} else {

						throw new Error( message ); // fatal, in this case

					}

				}

				console.warn( 'THREE.KeyframeTrackPrototype:', message );
				return;

			}

			this.createInterpolant = factoryMethod;

		},

		getInterpolation: function () {

			switch ( this.createInterpolant ) {

				case this.InterpolantFactoryMethodDiscrete:

					return InterpolateDiscrete;

				case this.InterpolantFactoryMethodLinear:

					return InterpolateLinear;

				case this.InterpolantFactoryMethodSmooth:

					return InterpolateSmooth;

			}

		},

		getValueSize: function () {

			return this.values.length / this.times.length;

		},

		// move all keyframes either forwards or backwards in time
		shift: function ( timeOffset ) {

			if ( timeOffset !== 0.0 ) {

				var times = this.times;

				for ( var i = 0, n = times.length; i !== n; ++ i ) {

					times[ i ] += timeOffset;

				}

			}

			return this;

		},

		// scale all keyframe times by a factor (useful for frame <-> seconds conversions)
		scale: function ( timeScale ) {

			if ( timeScale !== 1.0 ) {

				var times = this.times;

				for ( var i = 0, n = times.length; i !== n; ++ i ) {

					times[ i ] *= timeScale;

				}

			}

			return this;

		},

		// removes keyframes before and after animation without changing any values within the range [startTime, endTime].
		// IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
		trim: function ( startTime, endTime ) {

			var times = this.times,
				nKeys = times.length,
				from = 0,
				to = nKeys - 1;

			while ( from !== nKeys && times[ from ] < startTime ) ++ from;
			while ( to !== - 1 && times[ to ] > endTime ) -- to;

			++ to; // inclusive -> exclusive bound

			if ( from !== 0 || to !== nKeys ) {

				// empty tracks are forbidden, so keep at least one keyframe
				if ( from >= to ) to = Math.max( to, 1 ), from = to - 1;

				var stride = this.getValueSize();
				this.times = AnimationUtils.arraySlice( times, from, to );
				this.values = AnimationUtils.
						arraySlice( this.values, from * stride, to * stride );

			}

			return this;

		},

		// ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
		validate: function () {

			var valid = true;

			var valueSize = this.getValueSize();
			if ( valueSize - Math.floor( valueSize ) !== 0 ) {

				console.error( 'THREE.KeyframeTrackPrototype: Invalid value size in track.', this );
				valid = false;

			}

			var times = this.times,
				values = this.values,

				nKeys = times.length;

			if ( nKeys === 0 ) {

				console.error( 'THREE.KeyframeTrackPrototype: Track is empty.', this );
				valid = false;

			}

			var prevTime = null;

			for ( var i = 0; i !== nKeys; i ++ ) {

				var currTime = times[ i ];

				if ( typeof currTime === 'number' && isNaN( currTime ) ) {

					console.error( 'THREE.KeyframeTrackPrototype: Time is not a valid number.', this, i, currTime );
					valid = false;
					break;

				}

				if ( prevTime !== null && prevTime > currTime ) {

					console.error( 'THREE.KeyframeTrackPrototype: Out of order keys.', this, i, currTime, prevTime );
					valid = false;
					break;

				}

				prevTime = currTime;

			}

			if ( values !== undefined ) {

				if ( AnimationUtils.isTypedArray( values ) ) {

					for ( var i = 0, n = values.length; i !== n; ++ i ) {

						var value = values[ i ];

						if ( isNaN( value ) ) {

							console.error( 'THREE.KeyframeTrackPrototype: Value is not a valid number.', this, i, value );
							valid = false;
							break;

						}

					}

				}

			}

			return valid;

		},

		// removes equivalent sequential keys as common in morph target sequences
		// (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
		optimize: function () {

			var times = this.times,
				values = this.values,
				stride = this.getValueSize(),

				smoothInterpolation = this.getInterpolation() === InterpolateSmooth,

				writeIndex = 1,
				lastIndex = times.length - 1;

			for ( var i = 1; i < lastIndex; ++ i ) {

				var keep = false;

				var time = times[ i ];
				var timeNext = times[ i + 1 ];

				// remove adjacent keyframes scheduled at the same time

				if ( time !== timeNext && ( i !== 1 || time !== time[ 0 ] ) ) {

					if ( ! smoothInterpolation ) {

						// remove unnecessary keyframes same as their neighbors

						var offset = i * stride,
							offsetP = offset - stride,
							offsetN = offset + stride;

						for ( var j = 0; j !== stride; ++ j ) {

							var value = values[ offset + j ];

							if ( value !== values[ offsetP + j ] ||
									value !== values[ offsetN + j ] ) {

								keep = true;
								break;

							}

						}

					} else keep = true;

				}

				// in-place compaction

				if ( keep ) {

					if ( i !== writeIndex ) {

						times[ writeIndex ] = times[ i ];

						var readOffset = i * stride,
							writeOffset = writeIndex * stride;

						for ( var j = 0; j !== stride; ++ j )

							values[ writeOffset + j ] = values[ readOffset + j ];

					}

					++ writeIndex;

				}

			}

			// flush last keyframe (compaction looks ahead)

			if ( lastIndex > 0 ) {

				times[ writeIndex ] = times[ lastIndex ];

				for ( var readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++ j )

					values[ writeOffset + j ] = values[ readOffset + j ];

				++ writeIndex;

			}

			if ( writeIndex !== times.length ) {

				this.times = AnimationUtils.arraySlice( times, 0, writeIndex );
				this.values = AnimationUtils.arraySlice( values, 0, writeIndex * stride );

			}

			return this;

		}

	};

	function KeyframeTrackConstructor( name, times, values, interpolation ) {

		if ( name === undefined ) throw new Error( "track name is undefined" );

		if ( times === undefined || times.length === 0 ) {

			throw new Error( "no keyframes in track named " + name );

		}

		this.name = name;

		this.times = AnimationUtils.convertArray( times, this.TimeBufferType );
		this.values = AnimationUtils.convertArray( values, this.ValueBufferType );

		this.setInterpolation( interpolation || this.DefaultInterpolation );

		this.validate();
		this.optimize();

	}

	/**
	 *
	 * A Track of vectored keyframe values.
	 *
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 */

	function VectorKeyframeTrack( name, times, values, interpolation ) {

		KeyframeTrackConstructor.call( this, name, times, values, interpolation );

	}

	VectorKeyframeTrack.prototype =
			Object.assign( Object.create( KeyframeTrackPrototype ), {

		constructor: VectorKeyframeTrack,

		ValueTypeName: 'vector'

		// ValueBufferType is inherited

		// DefaultInterpolation is inherited

	} );

	/**
	 * Spherical linear unit quaternion interpolant.
	 *
	 * @author tschw
	 */

	function QuaternionLinearInterpolant( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		Interpolant.call( this, parameterPositions, sampleValues, sampleSize, resultBuffer );

	}

	QuaternionLinearInterpolant.prototype = Object.assign( Object.create( Interpolant.prototype ), {

		constructor: QuaternionLinearInterpolant,

		interpolate_: function( i1, t0, t, t1 ) {

			var result = this.resultBuffer,
				values = this.sampleValues,
				stride = this.valueSize,

				offset = i1 * stride,

				alpha = ( t - t0 ) / ( t1 - t0 );

			for ( var end = offset + stride; offset !== end; offset += 4 ) {

				Quaternion.slerpFlat( result, 0,
						values, offset - stride, values, offset, alpha );

			}

			return result;

		}

	} );

	/**
	 *
	 * A Track of quaternion keyframe values.
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 */

	function QuaternionKeyframeTrack( name, times, values, interpolation ) {

		KeyframeTrackConstructor.call( this, name, times, values, interpolation );

	}

	QuaternionKeyframeTrack.prototype =
			Object.assign( Object.create( KeyframeTrackPrototype ), {

		constructor: QuaternionKeyframeTrack,

		ValueTypeName: 'quaternion',

		// ValueBufferType is inherited

		DefaultInterpolation: InterpolateLinear,

		InterpolantFactoryMethodLinear: function( result ) {

			return new QuaternionLinearInterpolant(
					this.times, this.values, this.getValueSize(), result );

		},

		InterpolantFactoryMethodSmooth: undefined // not yet implemented

	} );

	/**
	 *
	 * A Track of numeric keyframe values.
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 */

	function NumberKeyframeTrack( name, times, values, interpolation ) {

		KeyframeTrackConstructor.call( this, name, times, values, interpolation );

	}

	NumberKeyframeTrack.prototype =
			Object.assign( Object.create( KeyframeTrackPrototype ), {

		constructor: NumberKeyframeTrack,

		ValueTypeName: 'number'

		// ValueBufferType is inherited

		// DefaultInterpolation is inherited

	} );

	/**
	 *
	 * A Track that interpolates Strings
	 *
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 */

	function StringKeyframeTrack( name, times, values, interpolation ) {

		KeyframeTrackConstructor.call( this, name, times, values, interpolation );

	}

	StringKeyframeTrack.prototype =
			Object.assign( Object.create( KeyframeTrackPrototype ), {

		constructor: StringKeyframeTrack,

		ValueTypeName: 'string',
		ValueBufferType: Array,

		DefaultInterpolation: InterpolateDiscrete,

		InterpolantFactoryMethodLinear: undefined,

		InterpolantFactoryMethodSmooth: undefined

	} );

	/**
	 *
	 * A Track of Boolean keyframe values.
	 *
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 */

	function BooleanKeyframeTrack( name, times, values ) {

		KeyframeTrackConstructor.call( this, name, times, values );

	}

	BooleanKeyframeTrack.prototype =
			Object.assign( Object.create( KeyframeTrackPrototype ), {

		constructor: BooleanKeyframeTrack,

		ValueTypeName: 'bool',
		ValueBufferType: Array,

		DefaultInterpolation: InterpolateDiscrete,

		InterpolantFactoryMethodLinear: undefined,
		InterpolantFactoryMethodSmooth: undefined

		// Note: Actually this track could have a optimized / compressed
		// representation of a single value and a custom interpolant that
		// computes "firstValue ^ isOdd( index )".

	} );

	/**
	 *
	 * A Track of keyframe values that represent color.
	 *
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 */

	function ColorKeyframeTrack( name, times, values, interpolation ) {

		KeyframeTrackConstructor.call( this, name, times, values, interpolation );

	}

	ColorKeyframeTrack.prototype =
			Object.assign( Object.create( KeyframeTrackPrototype ), {

		constructor: ColorKeyframeTrack,

		ValueTypeName: 'color'

		// ValueBufferType is inherited

		// DefaultInterpolation is inherited


		// Note: Very basic implementation and nothing special yet.
		// However, this is the place for color space parameterization.

	} );

	/**
	 *
	 * A timed sequence of keyframes for a specific property.
	 *
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 */

	function KeyframeTrack( name, times, values, interpolation ) {

		KeyframeTrackConstructor.apply( this, arguments );

	}

	KeyframeTrack.prototype = KeyframeTrackPrototype;
	KeyframeTrackPrototype.constructor = KeyframeTrack;

	// Static methods:

	Object.assign( KeyframeTrack, {

		// Serialization (in static context, because of constructor invocation
		// and automatic invocation of .toJSON):

		parse: function( json ) {

			if( json.type === undefined ) {

				throw new Error( "track type undefined, can not parse" );

			}

			var trackType = KeyframeTrack._getTrackTypeForValueTypeName( json.type );

			if ( json.times === undefined ) {

				var times = [], values = [];

				AnimationUtils.flattenJSON( json.keys, times, values, 'value' );

				json.times = times;
				json.values = values;

			}

			// derived classes can define a static parse method
			if ( trackType.parse !== undefined ) {

				return trackType.parse( json );

			} else {

				// by default, we assume a constructor compatible with the base
				return new trackType(
						json.name, json.times, json.values, json.interpolation );

			}

		},

		toJSON: function( track ) {

			var trackType = track.constructor;

			var json;

			// derived classes can define a static toJSON method
			if ( trackType.toJSON !== undefined ) {

				json = trackType.toJSON( track );

			} else {

				// by default, we assume the data can be serialized as-is
				json = {

					'name': track.name,
					'times': AnimationUtils.convertArray( track.times, Array ),
					'values': AnimationUtils.convertArray( track.values, Array )

				};

				var interpolation = track.getInterpolation();

				if ( interpolation !== track.DefaultInterpolation ) {

					json.interpolation = interpolation;

				}

			}

			json.type = track.ValueTypeName; // mandatory

			return json;

		},

		_getTrackTypeForValueTypeName: function( typeName ) {

			switch( typeName.toLowerCase() ) {

				case "scalar":
				case "double":
				case "float":
				case "number":
				case "integer":

					return NumberKeyframeTrack;

				case "vector":
				case "vector2":
				case "vector3":
				case "vector4":

					return VectorKeyframeTrack;

				case "color":

					return ColorKeyframeTrack;

				case "quaternion":

					return QuaternionKeyframeTrack;

				case "bool":
				case "boolean":

					return BooleanKeyframeTrack;

				case "string":

					return StringKeyframeTrack;

			}

			throw new Error( "Unsupported typeName: " + typeName );

		}

	} );

	/**
	 *
	 * Reusable set of Tracks that represent an animation.
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 */

	function AnimationClip( name, duration, tracks ) {

		this.name = name;
		this.tracks = tracks;
		this.duration = ( duration !== undefined ) ? duration : - 1;

		this.uuid = _Math.generateUUID();

		// this means it should figure out its duration by scanning the tracks
		if ( this.duration < 0 ) {

			this.resetDuration();

		}

		this.optimize();

	}

	Object.assign( AnimationClip, {

		parse: function ( json ) {

			var tracks = [],
				jsonTracks = json.tracks,
				frameTime = 1.0 / ( json.fps || 1.0 );

			for ( var i = 0, n = jsonTracks.length; i !== n; ++ i ) {

				tracks.push( KeyframeTrack.parse( jsonTracks[ i ] ).scale( frameTime ) );

			}

			return new AnimationClip( json.name, json.duration, tracks );

		},

		toJSON: function ( clip ) {

			var tracks = [],
				clipTracks = clip.tracks;

			var json = {

				'name': clip.name,
				'duration': clip.duration,
				'tracks': tracks

			};

			for ( var i = 0, n = clipTracks.length; i !== n; ++ i ) {

				tracks.push( KeyframeTrack.toJSON( clipTracks[ i ] ) );

			}

			return json;

		},

		CreateFromMorphTargetSequence: function ( name, morphTargetSequence, fps, noLoop ) {

			var numMorphTargets = morphTargetSequence.length;
			var tracks = [];

			for ( var i = 0; i < numMorphTargets; i ++ ) {

				var times = [];
				var values = [];

				times.push(
						( i + numMorphTargets - 1 ) % numMorphTargets,
						i,
						( i + 1 ) % numMorphTargets );

				values.push( 0, 1, 0 );

				var order = AnimationUtils.getKeyframeOrder( times );
				times = AnimationUtils.sortedArray( times, 1, order );
				values = AnimationUtils.sortedArray( values, 1, order );

				// if there is a key at the first frame, duplicate it as the
				// last frame as well for perfect loop.
				if ( ! noLoop && times[ 0 ] === 0 ) {

					times.push( numMorphTargets );
					values.push( values[ 0 ] );

				}

				tracks.push(
						new NumberKeyframeTrack(
							'.morphTargetInfluences[' + morphTargetSequence[ i ].name + ']',
							times, values
						).scale( 1.0 / fps ) );

			}

			return new AnimationClip( name, - 1, tracks );

		},

		findByName: function ( objectOrClipArray, name ) {

			var clipArray = objectOrClipArray;

			if ( ! Array.isArray( objectOrClipArray ) ) {

				var o = objectOrClipArray;
				clipArray = o.geometry && o.geometry.animations || o.animations;

			}

			for ( var i = 0; i < clipArray.length; i ++ ) {

				if ( clipArray[ i ].name === name ) {

					return clipArray[ i ];

				}

			}

			return null;

		},

		CreateClipsFromMorphTargetSequences: function ( morphTargets, fps, noLoop ) {

			var animationToMorphTargets = {};

			// tested with https://regex101.com/ on trick sequences
			// such flamingo_flyA_003, flamingo_run1_003, crdeath0059
			var pattern = /^([\w-]*?)([\d]+)$/;

			// sort morph target names into animation groups based
			// patterns like Walk_001, Walk_002, Run_001, Run_002
			for ( var i = 0, il = morphTargets.length; i < il; i ++ ) {

				var morphTarget = morphTargets[ i ];
				var parts = morphTarget.name.match( pattern );

				if ( parts && parts.length > 1 ) {

					var name = parts[ 1 ];

					var animationMorphTargets = animationToMorphTargets[ name ];
					if ( ! animationMorphTargets ) {

						animationToMorphTargets[ name ] = animationMorphTargets = [];

					}

					animationMorphTargets.push( morphTarget );

				}

			}

			var clips = [];

			for ( var name in animationToMorphTargets ) {

				clips.push( AnimationClip.CreateFromMorphTargetSequence( name, animationToMorphTargets[ name ], fps, noLoop ) );

			}

			return clips;

		},

		// parse the animation.hierarchy format
		parseAnimation: function ( animation, bones ) {

			if ( ! animation ) {

				console.error( 'THREE.AnimationClip: No animation in JSONLoader data.' );
				return null;

			}

			var addNonemptyTrack = function ( trackType, trackName, animationKeys, propertyName, destTracks ) {

				// only return track if there are actually keys.
				if ( animationKeys.length !== 0 ) {

					var times = [];
					var values = [];

					AnimationUtils.flattenJSON( animationKeys, times, values, propertyName );

					// empty keys are filtered out, so check again
					if ( times.length !== 0 ) {

						destTracks.push( new trackType( trackName, times, values ) );

					}

				}

			};

			var tracks = [];

			var clipName = animation.name || 'default';
			// automatic length determination in AnimationClip.
			var duration = animation.length || - 1;
			var fps = animation.fps || 30;

			var hierarchyTracks = animation.hierarchy || [];

			for ( var h = 0; h < hierarchyTracks.length; h ++ ) {

				var animationKeys = hierarchyTracks[ h ].keys;

				// skip empty tracks
				if ( ! animationKeys || animationKeys.length === 0 ) continue;

				// process morph targets
				if ( animationKeys[ 0 ].morphTargets ) {

					// figure out all morph targets used in this track
					var morphTargetNames = {};

					for ( var k = 0; k < animationKeys.length; k ++ ) {

						if ( animationKeys[ k ].morphTargets ) {

							for ( var m = 0; m < animationKeys[ k ].morphTargets.length; m ++ ) {

								morphTargetNames[ animationKeys[ k ].morphTargets[ m ] ] = - 1;

							}

						}

					}

					// create a track for each morph target with all zero
					// morphTargetInfluences except for the keys in which
					// the morphTarget is named.
					for ( var morphTargetName in morphTargetNames ) {

						var times = [];
						var values = [];

						for ( var m = 0; m !== animationKeys[ k ].morphTargets.length; ++ m ) {

							var animationKey = animationKeys[ k ];

							times.push( animationKey.time );
							values.push( ( animationKey.morphTarget === morphTargetName ) ? 1 : 0 );

						}

						tracks.push( new NumberKeyframeTrack( '.morphTargetInfluence[' + morphTargetName + ']', times, values ) );

					}

					duration = morphTargetNames.length * ( fps || 1.0 );

				} else {

					// ...assume skeletal animation

					var boneName = '.bones[' + bones[ h ].name + ']';

					addNonemptyTrack(
							VectorKeyframeTrack, boneName + '.position',
							animationKeys, 'pos', tracks );

					addNonemptyTrack(
							QuaternionKeyframeTrack, boneName + '.quaternion',
							animationKeys, 'rot', tracks );

					addNonemptyTrack(
							VectorKeyframeTrack, boneName + '.scale',
							animationKeys, 'scl', tracks );

				}

			}

			if ( tracks.length === 0 ) {

				return null;

			}

			var clip = new AnimationClip( clipName, duration, tracks );

			return clip;

		}

	} );

	Object.assign( AnimationClip.prototype, {

		resetDuration: function () {

			var tracks = this.tracks, duration = 0;

			for ( var i = 0, n = tracks.length; i !== n; ++ i ) {

				var track = this.tracks[ i ];

				duration = Math.max( duration, track.times[ track.times.length - 1 ] );

			}

			this.duration = duration;

		},

		trim: function () {

			for ( var i = 0; i < this.tracks.length; i ++ ) {

				this.tracks[ i ].trim( 0, this.duration );

			}

			return this;

		},

		optimize: function () {

			for ( var i = 0; i < this.tracks.length; i ++ ) {

				this.tracks[ i ].optimize();

			}

			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function MaterialLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
		this.textures = {};

	}

	Object.assign( MaterialLoader.prototype, {

		load: function ( url, onLoad, onProgress, onError ) {

			var scope = this;

			var loader = new FileLoader( scope.manager );
			loader.load( url, function ( text ) {

				onLoad( scope.parse( JSON.parse( text ) ) );

			}, onProgress, onError );

		},

		setTextures: function ( value ) {

			this.textures = value;

		},

		parse: function ( json ) {

			var textures = this.textures;

			function getTexture( name ) {

				if ( textures[ name ] === undefined ) {

					console.warn( 'THREE.MaterialLoader: Undefined texture', name );

				}

				return textures[ name ];

			}

			var material = new Materials[ json.type ]();

			if ( json.uuid !== undefined ) material.uuid = json.uuid;
			if ( json.name !== undefined ) material.name = json.name;
			if ( json.color !== undefined ) material.color.setHex( json.color );
			if ( json.roughness !== undefined ) material.roughness = json.roughness;
			if ( json.metalness !== undefined ) material.metalness = json.metalness;
			if ( json.emissive !== undefined ) material.emissive.setHex( json.emissive );
			if ( json.specular !== undefined ) material.specular.setHex( json.specular );
			if ( json.shininess !== undefined ) material.shininess = json.shininess;
			if ( json.clearCoat !== undefined ) material.clearCoat = json.clearCoat;
			if ( json.clearCoatRoughness !== undefined ) material.clearCoatRoughness = json.clearCoatRoughness;
			if ( json.uniforms !== undefined ) material.uniforms = json.uniforms;
			if ( json.vertexShader !== undefined ) material.vertexShader = json.vertexShader;
			if ( json.fragmentShader !== undefined ) material.fragmentShader = json.fragmentShader;
			if ( json.vertexColors !== undefined ) material.vertexColors = json.vertexColors;
			if ( json.fog !== undefined ) material.fog = json.fog;
			if ( json.flatShading !== undefined ) material.flatShading = json.flatShading;
			if ( json.blending !== undefined ) material.blending = json.blending;
			if ( json.side !== undefined ) material.side = json.side;
			if ( json.opacity !== undefined ) material.opacity = json.opacity;
			if ( json.transparent !== undefined ) material.transparent = json.transparent;
			if ( json.alphaTest !== undefined ) material.alphaTest = json.alphaTest;
			if ( json.depthTest !== undefined ) material.depthTest = json.depthTest;
			if ( json.depthWrite !== undefined ) material.depthWrite = json.depthWrite;
			if ( json.colorWrite !== undefined ) material.colorWrite = json.colorWrite;
			if ( json.wireframe !== undefined ) material.wireframe = json.wireframe;
			if ( json.wireframeLinewidth !== undefined ) material.wireframeLinewidth = json.wireframeLinewidth;
			if ( json.wireframeLinecap !== undefined ) material.wireframeLinecap = json.wireframeLinecap;
			if ( json.wireframeLinejoin !== undefined ) material.wireframeLinejoin = json.wireframeLinejoin;

			if ( json.skinning !== undefined ) material.skinning = json.skinning;
			if ( json.morphTargets !== undefined ) material.morphTargets = json.morphTargets;
			if ( json.dithering !== undefined ) material.dithering = json.dithering;

			if ( json.visible !== undefined ) material.visible = json.visible;
			if ( json.userData !== undefined ) material.userData = json.userData;

			// Deprecated

			if ( json.shading !== undefined ) material.flatShading = json.shading === 1; // THREE.FlatShading

			// for PointsMaterial

			if ( json.size !== undefined ) material.size = json.size;
			if ( json.sizeAttenuation !== undefined ) material.sizeAttenuation = json.sizeAttenuation;

			// maps

			if ( json.map !== undefined ) material.map = getTexture( json.map );

			if ( json.alphaMap !== undefined ) {

				material.alphaMap = getTexture( json.alphaMap );
				material.transparent = true;

			}

			if ( json.bumpMap !== undefined ) material.bumpMap = getTexture( json.bumpMap );
			if ( json.bumpScale !== undefined ) material.bumpScale = json.bumpScale;

			if ( json.normalMap !== undefined ) material.normalMap = getTexture( json.normalMap );
			if ( json.normalScale !== undefined ) {

				var normalScale = json.normalScale;

				if ( Array.isArray( normalScale ) === false ) {

					// Blender exporter used to export a scalar. See #7459

					normalScale = [ normalScale, normalScale ];

				}

				material.normalScale = new Vector2().fromArray( normalScale );

			}

			if ( json.displacementMap !== undefined ) material.displacementMap = getTexture( json.displacementMap );
			if ( json.displacementScale !== undefined ) material.displacementScale = json.displacementScale;
			if ( json.displacementBias !== undefined ) material.displacementBias = json.displacementBias;

			if ( json.roughnessMap !== undefined ) material.roughnessMap = getTexture( json.roughnessMap );
			if ( json.metalnessMap !== undefined ) material.metalnessMap = getTexture( json.metalnessMap );

			if ( json.emissiveMap !== undefined ) material.emissiveMap = getTexture( json.emissiveMap );
			if ( json.emissiveIntensity !== undefined ) material.emissiveIntensity = json.emissiveIntensity;

			if ( json.specularMap !== undefined ) material.specularMap = getTexture( json.specularMap );

			if ( json.envMap !== undefined ) material.envMap = getTexture( json.envMap );

			if ( json.reflectivity !== undefined ) material.reflectivity = json.reflectivity;

			if ( json.lightMap !== undefined ) material.lightMap = getTexture( json.lightMap );
			if ( json.lightMapIntensity !== undefined ) material.lightMapIntensity = json.lightMapIntensity;

			if ( json.aoMap !== undefined ) material.aoMap = getTexture( json.aoMap );
			if ( json.aoMapIntensity !== undefined ) material.aoMapIntensity = json.aoMapIntensity;

			if ( json.gradientMap !== undefined ) material.gradientMap = getTexture( json.gradientMap );

			return material;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function BufferGeometryLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

	}

	Object.assign( BufferGeometryLoader.prototype, {

		load: function ( url, onLoad, onProgress, onError ) {

			var scope = this;

			var loader = new FileLoader( scope.manager );
			loader.load( url, function ( text ) {

				onLoad( scope.parse( JSON.parse( text ) ) );

			}, onProgress, onError );

		},

		parse: function ( json ) {

			var geometry = new BufferGeometry();

			var index = json.data.index;

			if ( index !== undefined ) {

				var typedArray = new TYPED_ARRAYS[ index.type ]( index.array );
				geometry.setIndex( new BufferAttribute( typedArray, 1 ) );

			}

			var attributes = json.data.attributes;

			for ( var key in attributes ) {

				var attribute = attributes[ key ];
				var typedArray = new TYPED_ARRAYS[ attribute.type ]( attribute.array );

				geometry.addAttribute( key, new BufferAttribute( typedArray, attribute.itemSize, attribute.normalized ) );

			}

			var groups = json.data.groups || json.data.drawcalls || json.data.offsets;

			if ( groups !== undefined ) {

				for ( var i = 0, n = groups.length; i !== n; ++ i ) {

					var group = groups[ i ];

					geometry.addGroup( group.start, group.count, group.materialIndex );

				}

			}

			var boundingSphere = json.data.boundingSphere;

			if ( boundingSphere !== undefined ) {

				var center = new Vector3();

				if ( boundingSphere.center !== undefined ) {

					center.fromArray( boundingSphere.center );

				}

				geometry.boundingSphere = new Sphere( center, boundingSphere.radius );

			}

			return geometry;

		}

	} );

	var TYPED_ARRAYS = {
		Int8Array: Int8Array,
		Uint8Array: Uint8Array,
		// Workaround for IE11 pre KB2929437. See #11440
		Uint8ClampedArray: typeof Uint8ClampedArray !== 'undefined' ? Uint8ClampedArray : Uint8Array,
		Int16Array: Int16Array,
		Uint16Array: Uint16Array,
		Int32Array: Int32Array,
		Uint32Array: Uint32Array,
		Float32Array: Float32Array,
		Float64Array: Float64Array
	};

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	function Loader() {

		this.onLoadStart = function () {};
		this.onLoadProgress = function () {};
		this.onLoadComplete = function () {};

	}

	Loader.Handlers = {

		handlers: [],

		add: function ( regex, loader ) {

			this.handlers.push( regex, loader );

		},

		get: function ( file ) {

			var handlers = this.handlers;

			for ( var i = 0, l = handlers.length; i < l; i += 2 ) {

				var regex = handlers[ i ];
				var loader = handlers[ i + 1 ];

				if ( regex.test( file ) ) {

					return loader;

				}

			}

			return null;

		}

	};

	Object.assign( Loader.prototype, {

		crossOrigin: undefined,

		extractUrlBase: function ( url ) {

			var parts = url.split( '/' );

			if ( parts.length === 1 ) return './';

			parts.pop();

			return parts.join( '/' ) + '/';

		},

		initMaterials: function ( materials, texturePath, crossOrigin ) {

			var array = [];

			for ( var i = 0; i < materials.length; ++ i ) {

				array[ i ] = this.createMaterial( materials[ i ], texturePath, crossOrigin );

			}

			return array;

		},

		createMaterial: ( function () {

			var BlendingMode = {
				NoBlending: NoBlending,
				NormalBlending: NormalBlending,
				AdditiveBlending: AdditiveBlending,
				SubtractiveBlending: SubtractiveBlending,
				MultiplyBlending: MultiplyBlending,
				CustomBlending: CustomBlending
			};

			var color = new Color();
			var textureLoader = new TextureLoader();
			var materialLoader = new MaterialLoader();

			return function createMaterial( m, texturePath, crossOrigin ) {

				// convert from old material format

				var textures = {};

				function loadTexture( path, repeat, offset, wrap, anisotropy ) {

					var fullPath = texturePath + path;
					var loader = Loader.Handlers.get( fullPath );

					var texture;

					if ( loader !== null ) {

						texture = loader.load( fullPath );

					} else {

						textureLoader.setCrossOrigin( crossOrigin );
						texture = textureLoader.load( fullPath );

					}

					if ( repeat !== undefined ) {

						texture.repeat.fromArray( repeat );

						if ( repeat[ 0 ] !== 1 ) texture.wrapS = RepeatWrapping;
						if ( repeat[ 1 ] !== 1 ) texture.wrapT = RepeatWrapping;

					}

					if ( offset !== undefined ) {

						texture.offset.fromArray( offset );

					}

					if ( wrap !== undefined ) {

						if ( wrap[ 0 ] === 'repeat' ) texture.wrapS = RepeatWrapping;
						if ( wrap[ 0 ] === 'mirror' ) texture.wrapS = MirroredRepeatWrapping;

						if ( wrap[ 1 ] === 'repeat' ) texture.wrapT = RepeatWrapping;
						if ( wrap[ 1 ] === 'mirror' ) texture.wrapT = MirroredRepeatWrapping;

					}

					if ( anisotropy !== undefined ) {

						texture.anisotropy = anisotropy;

					}

					var uuid = _Math.generateUUID();

					textures[ uuid ] = texture;

					return uuid;

				}

				//

				var json = {
					uuid: _Math.generateUUID(),
					type: 'MeshLambertMaterial'
				};

				for ( var name in m ) {

					var value = m[ name ];

					switch ( name ) {

						case 'DbgColor':
						case 'DbgIndex':
						case 'opticalDensity':
						case 'illumination':
							break;
						case 'DbgName':
							json.name = value;
							break;
						case 'blending':
							json.blending = BlendingMode[ value ];
							break;
						case 'colorAmbient':
						case 'mapAmbient':
							console.warn( 'THREE.Loader.createMaterial:', name, 'is no longer supported.' );
							break;
						case 'colorDiffuse':
							json.color = color.fromArray( value ).getHex();
							break;
						case 'colorSpecular':
							json.specular = color.fromArray( value ).getHex();
							break;
						case 'colorEmissive':
							json.emissive = color.fromArray( value ).getHex();
							break;
						case 'specularCoef':
							json.shininess = value;
							break;
						case 'shading':
							if ( value.toLowerCase() === 'basic' ) json.type = 'MeshBasicMaterial';
							if ( value.toLowerCase() === 'phong' ) json.type = 'MeshPhongMaterial';
							if ( value.toLowerCase() === 'standard' ) json.type = 'MeshStandardMaterial';
							break;
						case 'mapDiffuse':
							json.map = loadTexture( value, m.mapDiffuseRepeat, m.mapDiffuseOffset, m.mapDiffuseWrap, m.mapDiffuseAnisotropy );
							break;
						case 'mapDiffuseRepeat':
						case 'mapDiffuseOffset':
						case 'mapDiffuseWrap':
						case 'mapDiffuseAnisotropy':
							break;
						case 'mapEmissive':
							json.emissiveMap = loadTexture( value, m.mapEmissiveRepeat, m.mapEmissiveOffset, m.mapEmissiveWrap, m.mapEmissiveAnisotropy );
							break;
						case 'mapEmissiveRepeat':
						case 'mapEmissiveOffset':
						case 'mapEmissiveWrap':
						case 'mapEmissiveAnisotropy':
							break;
						case 'mapLight':
							json.lightMap = loadTexture( value, m.mapLightRepeat, m.mapLightOffset, m.mapLightWrap, m.mapLightAnisotropy );
							break;
						case 'mapLightRepeat':
						case 'mapLightOffset':
						case 'mapLightWrap':
						case 'mapLightAnisotropy':
							break;
						case 'mapAO':
							json.aoMap = loadTexture( value, m.mapAORepeat, m.mapAOOffset, m.mapAOWrap, m.mapAOAnisotropy );
							break;
						case 'mapAORepeat':
						case 'mapAOOffset':
						case 'mapAOWrap':
						case 'mapAOAnisotropy':
							break;
						case 'mapBump':
							json.bumpMap = loadTexture( value, m.mapBumpRepeat, m.mapBumpOffset, m.mapBumpWrap, m.mapBumpAnisotropy );
							break;
						case 'mapBumpScale':
							json.bumpScale = value;
							break;
						case 'mapBumpRepeat':
						case 'mapBumpOffset':
						case 'mapBumpWrap':
						case 'mapBumpAnisotropy':
							break;
						case 'mapNormal':
							json.normalMap = loadTexture( value, m.mapNormalRepeat, m.mapNormalOffset, m.mapNormalWrap, m.mapNormalAnisotropy );
							break;
						case 'mapNormalFactor':
							json.normalScale = [ value, value ];
							break;
						case 'mapNormalRepeat':
						case 'mapNormalOffset':
						case 'mapNormalWrap':
						case 'mapNormalAnisotropy':
							break;
						case 'mapSpecular':
							json.specularMap = loadTexture( value, m.mapSpecularRepeat, m.mapSpecularOffset, m.mapSpecularWrap, m.mapSpecularAnisotropy );
							break;
						case 'mapSpecularRepeat':
						case 'mapSpecularOffset':
						case 'mapSpecularWrap':
						case 'mapSpecularAnisotropy':
							break;
						case 'mapMetalness':
							json.metalnessMap = loadTexture( value, m.mapMetalnessRepeat, m.mapMetalnessOffset, m.mapMetalnessWrap, m.mapMetalnessAnisotropy );
							break;
						case 'mapMetalnessRepeat':
						case 'mapMetalnessOffset':
						case 'mapMetalnessWrap':
						case 'mapMetalnessAnisotropy':
							break;
						case 'mapRoughness':
							json.roughnessMap = loadTexture( value, m.mapRoughnessRepeat, m.mapRoughnessOffset, m.mapRoughnessWrap, m.mapRoughnessAnisotropy );
							break;
						case 'mapRoughnessRepeat':
						case 'mapRoughnessOffset':
						case 'mapRoughnessWrap':
						case 'mapRoughnessAnisotropy':
							break;
						case 'mapAlpha':
							json.alphaMap = loadTexture( value, m.mapAlphaRepeat, m.mapAlphaOffset, m.mapAlphaWrap, m.mapAlphaAnisotropy );
							break;
						case 'mapAlphaRepeat':
						case 'mapAlphaOffset':
						case 'mapAlphaWrap':
						case 'mapAlphaAnisotropy':
							break;
						case 'flipSided':
							json.side = BackSide;
							break;
						case 'doubleSided':
							json.side = DoubleSide;
							break;
						case 'transparency':
							console.warn( 'THREE.Loader.createMaterial: transparency has been renamed to opacity' );
							json.opacity = value;
							break;
						case 'depthTest':
						case 'depthWrite':
						case 'colorWrite':
						case 'opacity':
						case 'reflectivity':
						case 'transparent':
						case 'visible':
						case 'wireframe':
							json[ name ] = value;
							break;
						case 'vertexColors':
							if ( value === true ) json.vertexColors = VertexColors;
							if ( value === 'face' ) json.vertexColors = FaceColors;
							break;
						default:
							console.error( 'THREE.Loader.createMaterial: Unsupported', name, value );
							break;

					}

				}

				if ( json.type === 'MeshBasicMaterial' ) delete json.emissive;
				if ( json.type !== 'MeshPhongMaterial' ) delete json.specular;

				if ( json.opacity < 1 ) json.transparent = true;

				materialLoader.setTextures( textures );

				return materialLoader.parse( json );

			};

		} )()

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author alteredq / http://alteredqualia.com/
	 */

	function JSONLoader( manager ) {

		if ( typeof manager === 'boolean' ) {

			console.warn( 'THREE.JSONLoader: showStatus parameter has been removed from constructor.' );
			manager = undefined;

		}

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

		this.withCredentials = false;

	}

	Object.assign( JSONLoader.prototype, {

		load: function ( url, onLoad, onProgress, onError ) {

			var scope = this;

			var texturePath = this.texturePath && ( typeof this.texturePath === "string" ) ? this.texturePath : Loader.prototype.extractUrlBase( url );

			var loader = new FileLoader( this.manager );
			loader.setWithCredentials( this.withCredentials );
			loader.load( url, function ( text ) {

				var json = JSON.parse( text );
				var metadata = json.metadata;

				if ( metadata !== undefined ) {

					var type = metadata.type;

					if ( type !== undefined ) {

						if ( type.toLowerCase() === 'object' ) {

							console.error( 'THREE.JSONLoader: ' + url + ' should be loaded with THREE.ObjectLoader instead.' );
							return;

						}

						if ( type.toLowerCase() === 'scene' ) {

							console.error( 'THREE.JSONLoader: ' + url + ' should be loaded with THREE.SceneLoader instead.' );
							return;

						}

					}

				}

				var object = scope.parse( json, texturePath );
				onLoad( object.geometry, object.materials );

			}, onProgress, onError );

		},

		setTexturePath: function ( value ) {

			this.texturePath = value;

		},

		parse: ( function () {

			function parseModel( json, geometry ) {

				function isBitSet( value, position ) {

					return value & ( 1 << position );

				}

				var i, j, fi,

					offset, zLength,

					colorIndex, normalIndex, uvIndex, materialIndex,

					type,
					isQuad,
					hasMaterial,
					hasFaceVertexUv,
					hasFaceNormal, hasFaceVertexNormal,
					hasFaceColor, hasFaceVertexColor,

					vertex, face, faceA, faceB, hex, normal,

					uvLayer, uv, u, v,

					faces = json.faces,
					vertices = json.vertices,
					normals = json.normals,
					colors = json.colors,

					scale = json.scale,

					nUvLayers = 0;


				if ( json.uvs !== undefined ) {

					// disregard empty arrays

					for ( i = 0; i < json.uvs.length; i ++ ) {

						if ( json.uvs[ i ].length ) nUvLayers ++;

					}

					for ( i = 0; i < nUvLayers; i ++ ) {

						geometry.faceVertexUvs[ i ] = [];

					}

				}

				offset = 0;
				zLength = vertices.length;

				while ( offset < zLength ) {

					vertex = new Vector3();

					vertex.x = vertices[ offset ++ ] * scale;
					vertex.y = vertices[ offset ++ ] * scale;
					vertex.z = vertices[ offset ++ ] * scale;

					geometry.vertices.push( vertex );

				}

				offset = 0;
				zLength = faces.length;

				while ( offset < zLength ) {

					type = faces[ offset ++ ];

					isQuad = isBitSet( type, 0 );
					hasMaterial = isBitSet( type, 1 );
					hasFaceVertexUv = isBitSet( type, 3 );
					hasFaceNormal = isBitSet( type, 4 );
					hasFaceVertexNormal = isBitSet( type, 5 );
					hasFaceColor = isBitSet( type, 6 );
					hasFaceVertexColor = isBitSet( type, 7 );

					// console.log("type", type, "bits", isQuad, hasMaterial, hasFaceVertexUv, hasFaceNormal, hasFaceVertexNormal, hasFaceColor, hasFaceVertexColor);

					if ( isQuad ) {

						faceA = new Face3();
						faceA.a = faces[ offset ];
						faceA.b = faces[ offset + 1 ];
						faceA.c = faces[ offset + 3 ];

						faceB = new Face3();
						faceB.a = faces[ offset + 1 ];
						faceB.b = faces[ offset + 2 ];
						faceB.c = faces[ offset + 3 ];

						offset += 4;

						if ( hasMaterial ) {

							materialIndex = faces[ offset ++ ];
							faceA.materialIndex = materialIndex;
							faceB.materialIndex = materialIndex;

						}

						// to get face <=> uv index correspondence

						fi = geometry.faces.length;

						if ( hasFaceVertexUv ) {

							for ( i = 0; i < nUvLayers; i ++ ) {

								uvLayer = json.uvs[ i ];

								geometry.faceVertexUvs[ i ][ fi ] = [];
								geometry.faceVertexUvs[ i ][ fi + 1 ] = [];

								for ( j = 0; j < 4; j ++ ) {

									uvIndex = faces[ offset ++ ];

									u = uvLayer[ uvIndex * 2 ];
									v = uvLayer[ uvIndex * 2 + 1 ];

									uv = new Vector2( u, v );

									if ( j !== 2 ) geometry.faceVertexUvs[ i ][ fi ].push( uv );
									if ( j !== 0 ) geometry.faceVertexUvs[ i ][ fi + 1 ].push( uv );

								}

							}

						}

						if ( hasFaceNormal ) {

							normalIndex = faces[ offset ++ ] * 3;

							faceA.normal.set(
								normals[ normalIndex ++ ],
								normals[ normalIndex ++ ],
								normals[ normalIndex ]
							);

							faceB.normal.copy( faceA.normal );

						}

						if ( hasFaceVertexNormal ) {

							for ( i = 0; i < 4; i ++ ) {

								normalIndex = faces[ offset ++ ] * 3;

								normal = new Vector3(
									normals[ normalIndex ++ ],
									normals[ normalIndex ++ ],
									normals[ normalIndex ]
								);


								if ( i !== 2 ) faceA.vertexNormals.push( normal );
								if ( i !== 0 ) faceB.vertexNormals.push( normal );

							}

						}


						if ( hasFaceColor ) {

							colorIndex = faces[ offset ++ ];
							hex = colors[ colorIndex ];

							faceA.color.setHex( hex );
							faceB.color.setHex( hex );

						}


						if ( hasFaceVertexColor ) {

							for ( i = 0; i < 4; i ++ ) {

								colorIndex = faces[ offset ++ ];
								hex = colors[ colorIndex ];

								if ( i !== 2 ) faceA.vertexColors.push( new Color( hex ) );
								if ( i !== 0 ) faceB.vertexColors.push( new Color( hex ) );

							}

						}

						geometry.faces.push( faceA );
						geometry.faces.push( faceB );

					} else {

						face = new Face3();
						face.a = faces[ offset ++ ];
						face.b = faces[ offset ++ ];
						face.c = faces[ offset ++ ];

						if ( hasMaterial ) {

							materialIndex = faces[ offset ++ ];
							face.materialIndex = materialIndex;

						}

						// to get face <=> uv index correspondence

						fi = geometry.faces.length;

						if ( hasFaceVertexUv ) {

							for ( i = 0; i < nUvLayers; i ++ ) {

								uvLayer = json.uvs[ i ];

								geometry.faceVertexUvs[ i ][ fi ] = [];

								for ( j = 0; j < 3; j ++ ) {

									uvIndex = faces[ offset ++ ];

									u = uvLayer[ uvIndex * 2 ];
									v = uvLayer[ uvIndex * 2 + 1 ];

									uv = new Vector2( u, v );

									geometry.faceVertexUvs[ i ][ fi ].push( uv );

								}

							}

						}

						if ( hasFaceNormal ) {

							normalIndex = faces[ offset ++ ] * 3;

							face.normal.set(
								normals[ normalIndex ++ ],
								normals[ normalIndex ++ ],
								normals[ normalIndex ]
							);

						}

						if ( hasFaceVertexNormal ) {

							for ( i = 0; i < 3; i ++ ) {

								normalIndex = faces[ offset ++ ] * 3;

								normal = new Vector3(
									normals[ normalIndex ++ ],
									normals[ normalIndex ++ ],
									normals[ normalIndex ]
								);

								face.vertexNormals.push( normal );

							}

						}


						if ( hasFaceColor ) {

							colorIndex = faces[ offset ++ ];
							face.color.setHex( colors[ colorIndex ] );

						}


						if ( hasFaceVertexColor ) {

							for ( i = 0; i < 3; i ++ ) {

								colorIndex = faces[ offset ++ ];
								face.vertexColors.push( new Color( colors[ colorIndex ] ) );

							}

						}

						geometry.faces.push( face );

					}

				}

			}

			function parseSkin( json, geometry ) {

				var influencesPerVertex = ( json.influencesPerVertex !== undefined ) ? json.influencesPerVertex : 2;

				if ( json.skinWeights ) {

					for ( var i = 0, l = json.skinWeights.length; i < l; i += influencesPerVertex ) {

						var x = json.skinWeights[ i ];
						var y = ( influencesPerVertex > 1 ) ? json.skinWeights[ i + 1 ] : 0;
						var z = ( influencesPerVertex > 2 ) ? json.skinWeights[ i + 2 ] : 0;
						var w = ( influencesPerVertex > 3 ) ? json.skinWeights[ i + 3 ] : 0;

						geometry.skinWeights.push( new Vector4( x, y, z, w ) );

					}

				}

				if ( json.skinIndices ) {

					for ( var i = 0, l = json.skinIndices.length; i < l; i += influencesPerVertex ) {

						var a = json.skinIndices[ i ];
						var b = ( influencesPerVertex > 1 ) ? json.skinIndices[ i + 1 ] : 0;
						var c = ( influencesPerVertex > 2 ) ? json.skinIndices[ i + 2 ] : 0;
						var d = ( influencesPerVertex > 3 ) ? json.skinIndices[ i + 3 ] : 0;

						geometry.skinIndices.push( new Vector4( a, b, c, d ) );

					}

				}

				geometry.bones = json.bones;

				if ( geometry.bones && geometry.bones.length > 0 && ( geometry.skinWeights.length !== geometry.skinIndices.length || geometry.skinIndices.length !== geometry.vertices.length ) ) {

					console.warn( 'When skinning, number of vertices (' + geometry.vertices.length + '), skinIndices (' +
						geometry.skinIndices.length + '), and skinWeights (' + geometry.skinWeights.length + ') should match.' );

				}

			}

			function parseMorphing( json, geometry ) {

				var scale = json.scale;

				if ( json.morphTargets !== undefined ) {

					for ( var i = 0, l = json.morphTargets.length; i < l; i ++ ) {

						geometry.morphTargets[ i ] = {};
						geometry.morphTargets[ i ].name = json.morphTargets[ i ].name;
						geometry.morphTargets[ i ].vertices = [];

						var dstVertices = geometry.morphTargets[ i ].vertices;
						var srcVertices = json.morphTargets[ i ].vertices;

						for ( var v = 0, vl = srcVertices.length; v < vl; v += 3 ) {

							var vertex = new Vector3();
							vertex.x = srcVertices[ v ] * scale;
							vertex.y = srcVertices[ v + 1 ] * scale;
							vertex.z = srcVertices[ v + 2 ] * scale;

							dstVertices.push( vertex );

						}

					}

				}

				if ( json.morphColors !== undefined && json.morphColors.length > 0 ) {

					console.warn( 'THREE.JSONLoader: "morphColors" no longer supported. Using them as face colors.' );

					var faces = geometry.faces;
					var morphColors = json.morphColors[ 0 ].colors;

					for ( var i = 0, l = faces.length; i < l; i ++ ) {

						faces[ i ].color.fromArray( morphColors, i * 3 );

					}

				}

			}

			function parseAnimations( json, geometry ) {

				var outputAnimations = [];

				// parse old style Bone/Hierarchy animations
				var animations = [];

				if ( json.animation !== undefined ) {

					animations.push( json.animation );

				}

				if ( json.animations !== undefined ) {

					if ( json.animations.length ) {

						animations = animations.concat( json.animations );

					} else {

						animations.push( json.animations );

					}

				}

				for ( var i = 0; i < animations.length; i ++ ) {

					var clip = AnimationClip.parseAnimation( animations[ i ], geometry.bones );
					if ( clip ) outputAnimations.push( clip );

				}

				// parse implicit morph animations
				if ( geometry.morphTargets ) {

					// TODO: Figure out what an appropraite FPS is for morph target animations -- defaulting to 10, but really it is completely arbitrary.
					var morphAnimationClips = AnimationClip.CreateClipsFromMorphTargetSequences( geometry.morphTargets, 10 );
					outputAnimations = outputAnimations.concat( morphAnimationClips );

				}

				if ( outputAnimations.length > 0 ) geometry.animations = outputAnimations;

			}

			return function ( json, texturePath ) {

				if ( json.data !== undefined ) {

					// Geometry 4.0 spec
					json = json.data;

				}

				if ( json.scale !== undefined ) {

					json.scale = 1.0 / json.scale;

				} else {

					json.scale = 1.0;

				}

				var geometry = new Geometry();

				parseModel( json, geometry );
				parseSkin( json, geometry );
				parseMorphing( json, geometry );
				parseAnimations( json, geometry );

				geometry.computeFaceNormals();
				geometry.computeBoundingSphere();

				if ( json.materials === undefined || json.materials.length === 0 ) {

					return { geometry: geometry };

				} else {

					var materials = Loader.prototype.initMaterials( json.materials, texturePath, this.crossOrigin );

					return { geometry: geometry, materials: materials };

				}

			};

		} )()

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function ObjectLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
		this.texturePath = '';

	}

	Object.assign( ObjectLoader.prototype, {

		load: function ( url, onLoad, onProgress, onError ) {

			if ( this.texturePath === '' ) {

				this.texturePath = url.substring( 0, url.lastIndexOf( '/' ) + 1 );

			}

			var scope = this;

			var loader = new FileLoader( scope.manager );
			loader.load( url, function ( text ) {

				var json = null;

				try {

					json = JSON.parse( text );

				} catch ( error ) {

					if ( onError !== undefined ) onError( error );

					console.error( 'THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message );

					return;

				}

				var metadata = json.metadata;

				if ( metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry' ) {

					console.error( 'THREE.ObjectLoader: Can\'t load ' + url + '. Use THREE.JSONLoader instead.' );
					return;

				}

				scope.parse( json, onLoad );

			}, onProgress, onError );

		},

		setTexturePath: function ( value ) {

			this.texturePath = value;

		},

		setCrossOrigin: function ( value ) {

			this.crossOrigin = value;

		},

		parse: function ( json, onLoad ) {

			var geometries = this.parseGeometries( json.geometries );

			var images = this.parseImages( json.images, function () {

				if ( onLoad !== undefined ) onLoad( object );

			} );

			var textures = this.parseTextures( json.textures, images );
			var materials = this.parseMaterials( json.materials, textures );

			var object = this.parseObject( json.object, geometries, materials );

			if ( json.animations ) {

				object.animations = this.parseAnimations( json.animations );

			}

			if ( json.images === undefined || json.images.length === 0 ) {

				if ( onLoad !== undefined ) onLoad( object );

			}

			return object;

		},

		parseGeometries: function ( json ) {

			var geometries = {};

			if ( json !== undefined ) {

				var geometryLoader = new JSONLoader();
				var bufferGeometryLoader = new BufferGeometryLoader();

				for ( var i = 0, l = json.length; i < l; i ++ ) {

					var geometry;
					var data = json[ i ];

					switch ( data.type ) {

						case 'PlaneGeometry':
						case 'PlaneBufferGeometry':

							geometry = new Geometries[ data.type ](
								data.width,
								data.height,
								data.widthSegments,
								data.heightSegments
							);

							break;

						case 'BoxGeometry':
						case 'BoxBufferGeometry':
						case 'CubeGeometry': // backwards compatible

							geometry = new Geometries[ data.type ](
								data.width,
								data.height,
								data.depth,
								data.widthSegments,
								data.heightSegments,
								data.depthSegments
							);

							break;

						case 'CircleGeometry':
						case 'CircleBufferGeometry':

							geometry = new Geometries[ data.type ](
								data.radius,
								data.segments,
								data.thetaStart,
								data.thetaLength
							);

							break;

						case 'CylinderGeometry':
						case 'CylinderBufferGeometry':

							geometry = new Geometries[ data.type ](
								data.radiusTop,
								data.radiusBottom,
								data.height,
								data.radialSegments,
								data.heightSegments,
								data.openEnded,
								data.thetaStart,
								data.thetaLength
							);

							break;

						case 'ConeGeometry':
						case 'ConeBufferGeometry':

							geometry = new Geometries[ data.type ](
								data.radius,
								data.height,
								data.radialSegments,
								data.heightSegments,
								data.openEnded,
								data.thetaStart,
								data.thetaLength
							);

							break;

						case 'SphereGeometry':
						case 'SphereBufferGeometry':

							geometry = new Geometries[ data.type ](
								data.radius,
								data.widthSegments,
								data.heightSegments,
								data.phiStart,
								data.phiLength,
								data.thetaStart,
								data.thetaLength
							);

							break;

						case 'DodecahedronGeometry':
						case 'IcosahedronGeometry':
						case 'OctahedronGeometry':
						case 'TetrahedronGeometry':

							geometry = new Geometries[ data.type ](
								data.radius,
								data.detail
							);

							break;

						case 'RingGeometry':
						case 'RingBufferGeometry':

							geometry = new Geometries[ data.type ](
								data.innerRadius,
								data.outerRadius,
								data.thetaSegments,
								data.phiSegments,
								data.thetaStart,
								data.thetaLength
							);

							break;

						case 'TorusGeometry':
						case 'TorusBufferGeometry':

							geometry = new Geometries[ data.type ](
								data.radius,
								data.tube,
								data.radialSegments,
								data.tubularSegments,
								data.arc
							);

							break;

						case 'TorusKnotGeometry':
						case 'TorusKnotBufferGeometry':

							geometry = new Geometries[ data.type ](
								data.radius,
								data.tube,
								data.tubularSegments,
								data.radialSegments,
								data.p,
								data.q
							);

							break;

						case 'LatheGeometry':
						case 'LatheBufferGeometry':

							geometry = new Geometries[ data.type ](
								data.points,
								data.segments,
								data.phiStart,
								data.phiLength
							);

							break;

						case 'BufferGeometry':

							geometry = bufferGeometryLoader.parse( data );

							break;

						case 'Geometry':

							geometry = geometryLoader.parse( data, this.texturePath ).geometry;

							break;

						default:

							console.warn( 'THREE.ObjectLoader: Unsupported geometry type "' + data.type + '"' );

							continue;

					}

					geometry.uuid = data.uuid;

					if ( data.name !== undefined ) geometry.name = data.name;

					geometries[ data.uuid ] = geometry;

				}

			}

			return geometries;

		},

		parseMaterials: function ( json, textures ) {

			var materials = {};

			if ( json !== undefined ) {

				var loader = new MaterialLoader();
				loader.setTextures( textures );

				for ( var i = 0, l = json.length; i < l; i ++ ) {

					var data = json[ i ];

					if ( data.type === 'MultiMaterial' ) {

						// Deprecated

						var array = [];

						for ( var j = 0; j < data.materials.length; j ++ ) {

							array.push( loader.parse( data.materials[ j ] ) );

						}

						materials[ data.uuid ] = array;

					} else {

						materials[ data.uuid ] = loader.parse( data );

					}

				}

			}

			return materials;

		},

		parseAnimations: function ( json ) {

			var animations = [];

			for ( var i = 0; i < json.length; i ++ ) {

				var clip = AnimationClip.parse( json[ i ] );

				animations.push( clip );

			}

			return animations;

		},

		parseImages: function ( json, onLoad ) {

			var scope = this;
			var images = {};

			function loadImage( url ) {

				scope.manager.itemStart( url );

				return loader.load( url, function () {

					scope.manager.itemEnd( url );

				}, undefined, function () {

					scope.manager.itemEnd( url );
					scope.manager.itemError( url );

				} );

			}

			if ( json !== undefined && json.length > 0 ) {

				var manager = new LoadingManager( onLoad );

				var loader = new ImageLoader( manager );
				loader.setCrossOrigin( this.crossOrigin );

				for ( var i = 0, l = json.length; i < l; i ++ ) {

					var image = json[ i ];
					var path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test( image.url ) ? image.url : scope.texturePath + image.url;

					images[ image.uuid ] = loadImage( path );

				}

			}

			return images;

		},

		parseTextures: function ( json, images ) {

			function parseConstant( value, type ) {

				if ( typeof( value ) === 'number' ) return value;

				console.warn( 'THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value );

				return type[ value ];

			}

			var textures = {};

			if ( json !== undefined ) {

				for ( var i = 0, l = json.length; i < l; i ++ ) {

					var data = json[ i ];

					if ( data.image === undefined ) {

						console.warn( 'THREE.ObjectLoader: No "image" specified for', data.uuid );

					}

					if ( images[ data.image ] === undefined ) {

						console.warn( 'THREE.ObjectLoader: Undefined image', data.image );

					}

					var texture = new Texture( images[ data.image ] );
					texture.needsUpdate = true;

					texture.uuid = data.uuid;

					if ( data.name !== undefined ) texture.name = data.name;

					if ( data.mapping !== undefined ) texture.mapping = parseConstant( data.mapping, TEXTURE_MAPPING );

					if ( data.offset !== undefined ) texture.offset.fromArray( data.offset );
					if ( data.repeat !== undefined ) texture.repeat.fromArray( data.repeat );
					if ( data.wrap !== undefined ) {

						texture.wrapS = parseConstant( data.wrap[ 0 ], TEXTURE_WRAPPING );
						texture.wrapT = parseConstant( data.wrap[ 1 ], TEXTURE_WRAPPING );

					}

					if ( data.minFilter !== undefined ) texture.minFilter = parseConstant( data.minFilter, TEXTURE_FILTER );
					if ( data.magFilter !== undefined ) texture.magFilter = parseConstant( data.magFilter, TEXTURE_FILTER );
					if ( data.anisotropy !== undefined ) texture.anisotropy = data.anisotropy;

					if ( data.flipY !== undefined ) texture.flipY = data.flipY;

					textures[ data.uuid ] = texture;

				}

			}

			return textures;

		},

		parseObject: function () {

			var matrix = new Matrix4();

			return function parseObject( data, geometries, materials ) {

				var object;

				function getGeometry( name ) {

					if ( geometries[ name ] === undefined ) {

						console.warn( 'THREE.ObjectLoader: Undefined geometry', name );

					}

					return geometries[ name ];

				}

				function getMaterial( name ) {

					if ( name === undefined ) return undefined;

					if ( Array.isArray( name ) ) {

						var array = [];

						for ( var i = 0, l = name.length; i < l; i ++ ) {

							var uuid = name[ i ];

							if ( materials[ uuid ] === undefined ) {

								console.warn( 'THREE.ObjectLoader: Undefined material', uuid );

							}

							array.push( materials[ uuid ] );

						}

						return array;

					}

					if ( materials[ name ] === undefined ) {

						console.warn( 'THREE.ObjectLoader: Undefined material', name );

					}

					return materials[ name ];

				}

				switch ( data.type ) {

					case 'Scene':

						object = new Scene();

						if ( data.background !== undefined ) {

							if ( Number.isInteger( data.background ) ) {

								object.background = new Color( data.background );

							}

						}

						if ( data.fog !== undefined ) {

							if ( data.fog.type === 'Fog' ) {

								object.fog = new Fog( data.fog.color, data.fog.near, data.fog.far );

							} else if ( data.fog.type === 'FogExp2' ) {

								object.fog = new FogExp2( data.fog.color, data.fog.density );

							}

						}

						break;

					case 'PerspectiveCamera':

						object = new PerspectiveCamera( data.fov, data.aspect, data.near, data.far );

						if ( data.focus !== undefined ) object.focus = data.focus;
						if ( data.zoom !== undefined ) object.zoom = data.zoom;
						if ( data.filmGauge !== undefined ) object.filmGauge = data.filmGauge;
						if ( data.filmOffset !== undefined ) object.filmOffset = data.filmOffset;
						if ( data.view !== undefined ) object.view = Object.assign( {}, data.view );

						break;

					case 'OrthographicCamera':

						object = new OrthographicCamera( data.left, data.right, data.top, data.bottom, data.near, data.far );

						break;

					case 'AmbientLight':

						object = new AmbientLight( data.color, data.intensity );

						break;

					case 'DirectionalLight':

						object = new DirectionalLight( data.color, data.intensity );

						break;

					case 'PointLight':

						object = new PointLight( data.color, data.intensity, data.distance, data.decay );

						break;

					case 'RectAreaLight':

						object = new RectAreaLight( data.color, data.intensity, data.width, data.height );

						break;

					case 'SpotLight':

						object = new SpotLight( data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay );

						break;

					case 'HemisphereLight':

						object = new HemisphereLight( data.color, data.groundColor, data.intensity );

						break;

					case 'SkinnedMesh':

						console.warn( 'THREE.ObjectLoader.parseObject() does not support SkinnedMesh yet.' );

					case 'Mesh':

						var geometry = getGeometry( data.geometry );
						var material = getMaterial( data.material );

						if ( geometry.bones && geometry.bones.length > 0 ) {

							object = new SkinnedMesh( geometry, material );

						} else {

							object = new Mesh( geometry, material );

						}

						break;

					case 'LOD':

						object = new LOD();

						break;

					case 'Line':

						object = new Line( getGeometry( data.geometry ), getMaterial( data.material ), data.mode );

						break;

					case 'LineLoop':

						object = new LineLoop( getGeometry( data.geometry ), getMaterial( data.material ) );

						break;

					case 'LineSegments':

						object = new LineSegments( getGeometry( data.geometry ), getMaterial( data.material ) );

						break;

					case 'PointCloud':
					case 'Points':

						object = new Points( getGeometry( data.geometry ), getMaterial( data.material ) );

						break;

					case 'Sprite':

						object = new Sprite( getMaterial( data.material ) );

						break;

					case 'Group':

						object = new Group();

						break;

					default:

						object = new Object3D();

				}

				object.uuid = data.uuid;

				if ( data.name !== undefined ) object.name = data.name;
				if ( data.matrix !== undefined ) {

					matrix.fromArray( data.matrix );
					matrix.decompose( object.position, object.quaternion, object.scale );

				} else {

					if ( data.position !== undefined ) object.position.fromArray( data.position );
					if ( data.rotation !== undefined ) object.rotation.fromArray( data.rotation );
					if ( data.quaternion !== undefined ) object.quaternion.fromArray( data.quaternion );
					if ( data.scale !== undefined ) object.scale.fromArray( data.scale );

				}

				if ( data.castShadow !== undefined ) object.castShadow = data.castShadow;
				if ( data.receiveShadow !== undefined ) object.receiveShadow = data.receiveShadow;

				if ( data.shadow ) {

					if ( data.shadow.bias !== undefined ) object.shadow.bias = data.shadow.bias;
					if ( data.shadow.radius !== undefined ) object.shadow.radius = data.shadow.radius;
					if ( data.shadow.mapSize !== undefined ) object.shadow.mapSize.fromArray( data.shadow.mapSize );
					if ( data.shadow.camera !== undefined ) object.shadow.camera = this.parseObject( data.shadow.camera );

				}

				if ( data.visible !== undefined ) object.visible = data.visible;
				if ( data.userData !== undefined ) object.userData = data.userData;

				if ( data.children !== undefined ) {

					var children = data.children;

					for ( var  i = 0; i < children.length; i ++ ) {

						object.add( this.parseObject( children[ i ], geometries, materials ) );

					}

				}

				if ( data.type === 'LOD' ) {

					var levels = data.levels;

					for ( var l = 0; l < levels.length; l ++ ) {

						var level = levels[ l ];
						var child = object.getObjectByProperty( 'uuid', level.object );

						if ( child !== undefined ) {

							object.addLevel( child, level.distance );

						}

					}

				}

				return object;

			};

		}()

	} );

	var TEXTURE_MAPPING = {
		UVMapping: UVMapping,
		CubeReflectionMapping: CubeReflectionMapping,
		CubeRefractionMapping: CubeRefractionMapping,
		EquirectangularReflectionMapping: EquirectangularReflectionMapping,
		EquirectangularRefractionMapping: EquirectangularRefractionMapping,
		SphericalReflectionMapping: SphericalReflectionMapping,
		CubeUVReflectionMapping: CubeUVReflectionMapping,
		CubeUVRefractionMapping: CubeUVRefractionMapping
	};

	var TEXTURE_WRAPPING = {
		RepeatWrapping: RepeatWrapping,
		ClampToEdgeWrapping: ClampToEdgeWrapping,
		MirroredRepeatWrapping: MirroredRepeatWrapping
	};

	var TEXTURE_FILTER = {
		NearestFilter: NearestFilter,
		NearestMipMapNearestFilter: NearestMipMapNearestFilter,
		NearestMipMapLinearFilter: NearestMipMapLinearFilter,
		LinearFilter: LinearFilter,
		LinearMipMapNearestFilter: LinearMipMapNearestFilter,
		LinearMipMapLinearFilter: LinearMipMapLinearFilter
	};

	/**
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 *
	 * Bezier Curves formulas obtained from
	 * http://en.wikipedia.org/wiki/Bézier_curve
	 */

	function CatmullRom( t, p0, p1, p2, p3 ) {

		var v0 = ( p2 - p0 ) * 0.5;
		var v1 = ( p3 - p1 ) * 0.5;
		var t2 = t * t;
		var t3 = t * t2;
		return ( 2 * p1 - 2 * p2 + v0 + v1 ) * t3 + ( - 3 * p1 + 3 * p2 - 2 * v0 - v1 ) * t2 + v0 * t + p1;

	}

	//

	function QuadraticBezierP0( t, p ) {

		var k = 1 - t;
		return k * k * p;

	}

	function QuadraticBezierP1( t, p ) {

		return 2 * ( 1 - t ) * t * p;

	}

	function QuadraticBezierP2( t, p ) {

		return t * t * p;

	}

	function QuadraticBezier( t, p0, p1, p2 ) {

		return QuadraticBezierP0( t, p0 ) + QuadraticBezierP1( t, p1 ) +
			QuadraticBezierP2( t, p2 );

	}

	//

	function CubicBezierP0( t, p ) {

		var k = 1 - t;
		return k * k * k * p;

	}

	function CubicBezierP1( t, p ) {

		var k = 1 - t;
		return 3 * k * k * t * p;

	}

	function CubicBezierP2( t, p ) {

		return 3 * ( 1 - t ) * t * t * p;

	}

	function CubicBezierP3( t, p ) {

		return t * t * t * p;

	}

	function CubicBezier( t, p0, p1, p2, p3 ) {

		return CubicBezierP0( t, p0 ) + CubicBezierP1( t, p1 ) + CubicBezierP2( t, p2 ) +
			CubicBezierP3( t, p3 );

	}

	/**
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 * Extensible curve object
	 *
	 * Some common of curve methods:
	 * .getPoint(t), getTangent(t)
	 * .getPointAt(u), getTangentAt(u)
	 * .getPoints(), .getSpacedPoints()
	 * .getLength()
	 * .updateArcLengths()
	 *
	 * This following curves inherit from THREE.Curve:
	 *
	 * -- 2D curves --
	 * THREE.ArcCurve
	 * THREE.CubicBezierCurve
	 * THREE.EllipseCurve
	 * THREE.LineCurve
	 * THREE.QuadraticBezierCurve
	 * THREE.SplineCurve
	 *
	 * -- 3D curves --
	 * THREE.CatmullRomCurve3
	 * THREE.CubicBezierCurve3
	 * THREE.LineCurve3
	 * THREE.QuadraticBezierCurve3
	 *
	 * A series of curves can be represented as a THREE.CurvePath.
	 *
	 **/

	/**************************************************************
	 *	Abstract Curve base class
	 **************************************************************/

	function Curve() {

		this.arcLengthDivisions = 200;

	}

	Object.assign( Curve.prototype, {

		// Virtual base class method to overwrite and implement in subclasses
		//	- t [0 .. 1]

		getPoint: function () {

			console.warn( 'THREE.Curve: .getPoint() not implemented.' );
			return null;

		},

		// Get point at relative position in curve according to arc length
		// - u [0 .. 1]

		getPointAt: function ( u ) {

			var t = this.getUtoTmapping( u );
			return this.getPoint( t );

		},

		// Get sequence of points using getPoint( t )

		getPoints: function ( divisions ) {

			if ( divisions === undefined ) divisions = 5;

			var points = [];

			for ( var d = 0; d <= divisions; d ++ ) {

				points.push( this.getPoint( d / divisions ) );

			}

			return points;

		},

		// Get sequence of points using getPointAt( u )

		getSpacedPoints: function ( divisions ) {

			if ( divisions === undefined ) divisions = 5;

			var points = [];

			for ( var d = 0; d <= divisions; d ++ ) {

				points.push( this.getPointAt( d / divisions ) );

			}

			return points;

		},

		// Get total curve arc length

		getLength: function () {

			var lengths = this.getLengths();
			return lengths[ lengths.length - 1 ];

		},

		// Get list of cumulative segment lengths

		getLengths: function ( divisions ) {

			if ( divisions === undefined ) divisions = this.arcLengthDivisions;

			if ( this.cacheArcLengths &&
				( this.cacheArcLengths.length === divisions + 1 ) &&
				! this.needsUpdate ) {

				return this.cacheArcLengths;

			}

			this.needsUpdate = false;

			var cache = [];
			var current, last = this.getPoint( 0 );
			var p, sum = 0;

			cache.push( 0 );

			for ( p = 1; p <= divisions; p ++ ) {

				current = this.getPoint( p / divisions );
				sum += current.distanceTo( last );
				cache.push( sum );
				last = current;

			}

			this.cacheArcLengths = cache;

			return cache; // { sums: cache, sum: sum }; Sum is in the last element.

		},

		updateArcLengths: function () {

			this.needsUpdate = true;
			this.getLengths();

		},

		// Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant

		getUtoTmapping: function ( u, distance ) {

			var arcLengths = this.getLengths();

			var i = 0, il = arcLengths.length;

			var targetArcLength; // The targeted u distance value to get

			if ( distance ) {

				targetArcLength = distance;

			} else {

				targetArcLength = u * arcLengths[ il - 1 ];

			}

			// binary search for the index with largest value smaller than target u distance

			var low = 0, high = il - 1, comparison;

			while ( low <= high ) {

				i = Math.floor( low + ( high - low ) / 2 ); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats

				comparison = arcLengths[ i ] - targetArcLength;

				if ( comparison < 0 ) {

					low = i + 1;

				} else if ( comparison > 0 ) {

					high = i - 1;

				} else {

					high = i;
					break;

					// DONE

				}

			}

			i = high;

			if ( arcLengths[ i ] === targetArcLength ) {

				return i / ( il - 1 );

			}

			// we could get finer grain at lengths, or use simple interpolation between two points

			var lengthBefore = arcLengths[ i ];
			var lengthAfter = arcLengths[ i + 1 ];

			var segmentLength = lengthAfter - lengthBefore;

			// determine where we are between the 'before' and 'after' points

			var segmentFraction = ( targetArcLength - lengthBefore ) / segmentLength;

			// add that fractional amount to t

			var t = ( i + segmentFraction ) / ( il - 1 );

			return t;

		},

		// Returns a unit vector tangent at t
		// In case any sub curve does not implement its tangent derivation,
		// 2 points a small delta apart will be used to find its gradient
		// which seems to give a reasonable approximation

		getTangent: function ( t ) {

			var delta = 0.0001;
			var t1 = t - delta;
			var t2 = t + delta;

			// Capping in case of danger

			if ( t1 < 0 ) t1 = 0;
			if ( t2 > 1 ) t2 = 1;

			var pt1 = this.getPoint( t1 );
			var pt2 = this.getPoint( t2 );

			var vec = pt2.clone().sub( pt1 );
			return vec.normalize();

		},

		getTangentAt: function ( u ) {

			var t = this.getUtoTmapping( u );
			return this.getTangent( t );

		},

		computeFrenetFrames: function ( segments, closed ) {

			// see http://www.cs.indiana.edu/pub/techreports/TR425.pdf

			var normal = new Vector3();

			var tangents = [];
			var normals = [];
			var binormals = [];

			var vec = new Vector3();
			var mat = new Matrix4();

			var i, u, theta;

			// compute the tangent vectors for each segment on the curve

			for ( i = 0; i <= segments; i ++ ) {

				u = i / segments;

				tangents[ i ] = this.getTangentAt( u );
				tangents[ i ].normalize();

			}

			// select an initial normal vector perpendicular to the first tangent vector,
			// and in the direction of the minimum tangent xyz component

			normals[ 0 ] = new Vector3();
			binormals[ 0 ] = new Vector3();
			var min = Number.MAX_VALUE;
			var tx = Math.abs( tangents[ 0 ].x );
			var ty = Math.abs( tangents[ 0 ].y );
			var tz = Math.abs( tangents[ 0 ].z );

			if ( tx <= min ) {

				min = tx;
				normal.set( 1, 0, 0 );

			}

			if ( ty <= min ) {

				min = ty;
				normal.set( 0, 1, 0 );

			}

			if ( tz <= min ) {

				normal.set( 0, 0, 1 );

			}

			vec.crossVectors( tangents[ 0 ], normal ).normalize();

			normals[ 0 ].crossVectors( tangents[ 0 ], vec );
			binormals[ 0 ].crossVectors( tangents[ 0 ], normals[ 0 ] );


			// compute the slowly-varying normal and binormal vectors for each segment on the curve

			for ( i = 1; i <= segments; i ++ ) {

				normals[ i ] = normals[ i - 1 ].clone();

				binormals[ i ] = binormals[ i - 1 ].clone();

				vec.crossVectors( tangents[ i - 1 ], tangents[ i ] );

				if ( vec.length() > Number.EPSILON ) {

					vec.normalize();

					theta = Math.acos( _Math.clamp( tangents[ i - 1 ].dot( tangents[ i ] ), - 1, 1 ) ); // clamp for floating pt errors

					normals[ i ].applyMatrix4( mat.makeRotationAxis( vec, theta ) );

				}

				binormals[ i ].crossVectors( tangents[ i ], normals[ i ] );

			}

			// if the curve is closed, postprocess the vectors so the first and last normal vectors are the same

			if ( closed === true ) {

				theta = Math.acos( _Math.clamp( normals[ 0 ].dot( normals[ segments ] ), - 1, 1 ) );
				theta /= segments;

				if ( tangents[ 0 ].dot( vec.crossVectors( normals[ 0 ], normals[ segments ] ) ) > 0 ) {

					theta = - theta;

				}

				for ( i = 1; i <= segments; i ++ ) {

					// twist a little...
					normals[ i ].applyMatrix4( mat.makeRotationAxis( tangents[ i ], theta * i ) );
					binormals[ i ].crossVectors( tangents[ i ], normals[ i ] );

				}

			}

			return {
				tangents: tangents,
				normals: normals,
				binormals: binormals
			};

		}

	} );

	function LineCurve( v1, v2 ) {

		Curve.call( this );

		this.v1 = v1;
		this.v2 = v2;

	}

	LineCurve.prototype = Object.create( Curve.prototype );
	LineCurve.prototype.constructor = LineCurve;

	LineCurve.prototype.isLineCurve = true;

	LineCurve.prototype.getPoint = function ( t ) {

		if ( t === 1 ) {

			return this.v2.clone();

		}

		var point = this.v2.clone().sub( this.v1 );
		point.multiplyScalar( t ).add( this.v1 );

		return point;

	};

	// Line curve is linear, so we can overwrite default getPointAt

	LineCurve.prototype.getPointAt = function ( u ) {

		return this.getPoint( u );

	};

	LineCurve.prototype.getTangent = function ( t ) {

		var tangent = this.v2.clone().sub( this.v1 );

		return tangent.normalize();

	};

	/**
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 *
	 **/

	/**************************************************************
	 *	Curved Path - a curve path is simply a array of connected
	 *  curves, but retains the api of a curve
	 **************************************************************/

	function CurvePath() {

		Curve.call( this );

		this.curves = [];

		this.autoClose = false; // Automatically closes the path

	}

	CurvePath.prototype = Object.assign( Object.create( Curve.prototype ), {

		constructor: CurvePath,

		add: function ( curve ) {

			this.curves.push( curve );

		},

		closePath: function () {

			// Add a line curve if start and end of lines are not connected
			var startPoint = this.curves[ 0 ].getPoint( 0 );
			var endPoint = this.curves[ this.curves.length - 1 ].getPoint( 1 );

			if ( ! startPoint.equals( endPoint ) ) {

				this.curves.push( new LineCurve( endPoint, startPoint ) );

			}

		},

		// To get accurate point with reference to
		// entire path distance at time t,
		// following has to be done:

		// 1. Length of each sub path have to be known
		// 2. Locate and identify type of curve
		// 3. Get t for the curve
		// 4. Return curve.getPointAt(t')

		getPoint: function ( t ) {

			var d = t * this.getLength();
			var curveLengths = this.getCurveLengths();
			var i = 0;

			// To think about boundaries points.

			while ( i < curveLengths.length ) {

				if ( curveLengths[ i ] >= d ) {

					var diff = curveLengths[ i ] - d;
					var curve = this.curves[ i ];

					var segmentLength = curve.getLength();
					var u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;

					return curve.getPointAt( u );

				}

				i ++;

			}

			return null;

			// loop where sum != 0, sum > d , sum+1 <d

		},

		// We cannot use the default THREE.Curve getPoint() with getLength() because in
		// THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
		// getPoint() depends on getLength

		getLength: function () {

			var lens = this.getCurveLengths();
			return lens[ lens.length - 1 ];

		},

		// cacheLengths must be recalculated.
		updateArcLengths: function () {

			this.needsUpdate = true;
			this.cacheLengths = null;
			this.getCurveLengths();

		},

		// Compute lengths and cache them
		// We cannot overwrite getLengths() because UtoT mapping uses it.

		getCurveLengths: function () {

			// We use cache values if curves and cache array are same length

			if ( this.cacheLengths && this.cacheLengths.length === this.curves.length ) {

				return this.cacheLengths;

			}

			// Get length of sub-curve
			// Push sums into cached array

			var lengths = [], sums = 0;

			for ( var i = 0, l = this.curves.length; i < l; i ++ ) {

				sums += this.curves[ i ].getLength();
				lengths.push( sums );

			}

			this.cacheLengths = lengths;

			return lengths;

		},

		getSpacedPoints: function ( divisions ) {

			if ( divisions === undefined ) divisions = 40;

			var points = [];

			for ( var i = 0; i <= divisions; i ++ ) {

				points.push( this.getPoint( i / divisions ) );

			}

			if ( this.autoClose ) {

				points.push( points[ 0 ] );

			}

			return points;

		},

		getPoints: function ( divisions ) {

			divisions = divisions || 12;

			var points = [], last;

			for ( var i = 0, curves = this.curves; i < curves.length; i ++ ) {

				var curve = curves[ i ];
				var resolution = (curve && curve.isEllipseCurve) ? divisions * 2
					: (curve && curve.isLineCurve) ? 1
					: (curve && curve.isSplineCurve) ? divisions * curve.points.length
					: divisions;

				var pts = curve.getPoints( resolution );

				for ( var j = 0; j < pts.length; j++ ) {

					var point = pts[ j ];

					if ( last && last.equals( point ) ) continue; // ensures no consecutive points are duplicates

					points.push( point );
					last = point;

				}

			}

			if ( this.autoClose && points.length > 1 && !points[ points.length - 1 ].equals( points[ 0 ] ) ) {

				points.push( points[ 0 ] );

			}

			return points;

		},

		/**************************************************************
		 *	Create Geometries Helpers
		 **************************************************************/

		/// Generate geometry from path points (for Line or Points objects)

		createPointsGeometry: function ( divisions ) {

			var pts = this.getPoints( divisions );
			return this.createGeometry( pts );

		},

		// Generate geometry from equidistant sampling along the path

		createSpacedPointsGeometry: function ( divisions ) {

			var pts = this.getSpacedPoints( divisions );
			return this.createGeometry( pts );

		},

		createGeometry: function ( points ) {

			var geometry = new Geometry();

			for ( var i = 0, l = points.length; i < l; i ++ ) {

				var point = points[ i ];
				geometry.vertices.push( new Vector3( point.x, point.y, point.z || 0 ) );

			}

			return geometry;

		}

	} );

	function EllipseCurve( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {

		Curve.call( this );

		this.aX = aX;
		this.aY = aY;

		this.xRadius = xRadius;
		this.yRadius = yRadius;

		this.aStartAngle = aStartAngle;
		this.aEndAngle = aEndAngle;

		this.aClockwise = aClockwise;

		this.aRotation = aRotation || 0;

	}

	EllipseCurve.prototype = Object.create( Curve.prototype );
	EllipseCurve.prototype.constructor = EllipseCurve;

	EllipseCurve.prototype.isEllipseCurve = true;

	EllipseCurve.prototype.getPoint = function ( t ) {

		var twoPi = Math.PI * 2;
		var deltaAngle = this.aEndAngle - this.aStartAngle;
		var samePoints = Math.abs( deltaAngle ) < Number.EPSILON;

		// ensures that deltaAngle is 0 .. 2 PI
		while ( deltaAngle < 0 ) deltaAngle += twoPi;
		while ( deltaAngle > twoPi ) deltaAngle -= twoPi;

		if ( deltaAngle < Number.EPSILON ) {

			if ( samePoints ) {

				deltaAngle = 0;

			} else {

				deltaAngle = twoPi;

			}

		}

		if ( this.aClockwise === true && ! samePoints ) {

			if ( deltaAngle === twoPi ) {

				deltaAngle = - twoPi;

			} else {

				deltaAngle = deltaAngle - twoPi;

			}

		}

		var angle = this.aStartAngle + t * deltaAngle;
		var x = this.aX + this.xRadius * Math.cos( angle );
		var y = this.aY + this.yRadius * Math.sin( angle );

		if ( this.aRotation !== 0 ) {

			var cos = Math.cos( this.aRotation );
			var sin = Math.sin( this.aRotation );

			var tx = x - this.aX;
			var ty = y - this.aY;

			// Rotate the point about the center of the ellipse.
			x = tx * cos - ty * sin + this.aX;
			y = tx * sin + ty * cos + this.aY;

		}

		return new Vector2( x, y );

	};

	function SplineCurve( points /* array of Vector2 */ ) {

		Curve.call( this );

		this.points = ( points === undefined ) ? [] : points;

	}

	SplineCurve.prototype = Object.create( Curve.prototype );
	SplineCurve.prototype.constructor = SplineCurve;

	SplineCurve.prototype.isSplineCurve = true;

	SplineCurve.prototype.getPoint = function ( t ) {

		var points = this.points;
		var point = ( points.length - 1 ) * t;

		var intPoint = Math.floor( point );
		var weight = point - intPoint;

		var point0 = points[ intPoint === 0 ? intPoint : intPoint - 1 ];
		var point1 = points[ intPoint ];
		var point2 = points[ intPoint > points.length - 2 ? points.length - 1 : intPoint + 1 ];
		var point3 = points[ intPoint > points.length - 3 ? points.length - 1 : intPoint + 2 ];

		return new Vector2(
			CatmullRom( weight, point0.x, point1.x, point2.x, point3.x ),
			CatmullRom( weight, point0.y, point1.y, point2.y, point3.y )
		);

	};

	function CubicBezierCurve( v0, v1, v2, v3 ) {

		Curve.call( this );

		this.v0 = v0;
		this.v1 = v1;
		this.v2 = v2;
		this.v3 = v3;

	}

	CubicBezierCurve.prototype = Object.create( Curve.prototype );
	CubicBezierCurve.prototype.constructor = CubicBezierCurve;

	CubicBezierCurve.prototype.getPoint = function ( t ) {

		var v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;

		return new Vector2(
			CubicBezier( t, v0.x, v1.x, v2.x, v3.x ),
			CubicBezier( t, v0.y, v1.y, v2.y, v3.y )
		);

	};

	function QuadraticBezierCurve( v0, v1, v2 ) {

		Curve.call( this );

		this.v0 = v0;
		this.v1 = v1;
		this.v2 = v2;

	}

	QuadraticBezierCurve.prototype = Object.create( Curve.prototype );
	QuadraticBezierCurve.prototype.constructor = QuadraticBezierCurve;

	QuadraticBezierCurve.prototype.getPoint = function ( t ) {

		var v0 = this.v0, v1 = this.v1, v2 = this.v2;

		return new Vector2(
			QuadraticBezier( t, v0.x, v1.x, v2.x ),
			QuadraticBezier( t, v0.y, v1.y, v2.y )
		);

	};

	var PathPrototype = Object.assign( Object.create( CurvePath.prototype ), {

		fromPoints: function ( vectors ) {

			this.moveTo( vectors[ 0 ].x, vectors[ 0 ].y );

			for ( var i = 1, l = vectors.length; i < l; i ++ ) {

				this.lineTo( vectors[ i ].x, vectors[ i ].y );

			}

		},

		moveTo: function ( x, y ) {

			this.currentPoint.set( x, y ); // TODO consider referencing vectors instead of copying?

		},

		lineTo: function ( x, y ) {

			var curve = new LineCurve( this.currentPoint.clone(), new Vector2( x, y ) );
			this.curves.push( curve );

			this.currentPoint.set( x, y );

		},

		quadraticCurveTo: function ( aCPx, aCPy, aX, aY ) {

			var curve = new QuadraticBezierCurve(
				this.currentPoint.clone(),
				new Vector2( aCPx, aCPy ),
				new Vector2( aX, aY )
			);

			this.curves.push( curve );

			this.currentPoint.set( aX, aY );

		},

		bezierCurveTo: function ( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY ) {

			var curve = new CubicBezierCurve(
				this.currentPoint.clone(),
				new Vector2( aCP1x, aCP1y ),
				new Vector2( aCP2x, aCP2y ),
				new Vector2( aX, aY )
			);

			this.curves.push( curve );

			this.currentPoint.set( aX, aY );

		},

		splineThru: function ( pts /*Array of Vector*/ ) {

			var npts = [ this.currentPoint.clone() ].concat( pts );

			var curve = new SplineCurve( npts );
			this.curves.push( curve );

			this.currentPoint.copy( pts[ pts.length - 1 ] );

		},

		arc: function ( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {

			var x0 = this.currentPoint.x;
			var y0 = this.currentPoint.y;

			this.absarc( aX + x0, aY + y0, aRadius,
				aStartAngle, aEndAngle, aClockwise );

		},

		absarc: function ( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {

			this.absellipse( aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise );

		},

		ellipse: function ( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {

			var x0 = this.currentPoint.x;
			var y0 = this.currentPoint.y;

			this.absellipse( aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation );

		},

		absellipse: function ( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {

			var curve = new EllipseCurve( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation );

			if ( this.curves.length > 0 ) {

				// if a previous curve is present, attempt to join
				var firstPoint = curve.getPoint( 0 );

				if ( ! firstPoint.equals( this.currentPoint ) ) {

					this.lineTo( firstPoint.x, firstPoint.y );

				}

			}

			this.curves.push( curve );

			var lastPoint = curve.getPoint( 1 );
			this.currentPoint.copy( lastPoint );

		}

	} );

	/**
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 * Creates free form 2d path using series of points, lines or curves.
	 **/

	function Path( points ) {

		CurvePath.call( this );
		this.currentPoint = new Vector2();

		if ( points ) {

			this.fromPoints( points );

		}

	}

	Path.prototype = PathPrototype;
	PathPrototype.constructor = Path;

	/**
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 * Defines a 2d shape plane using paths.
	 **/

	// STEP 1 Create a path.
	// STEP 2 Turn path into shape.
	// STEP 3 ExtrudeGeometry takes in Shape/Shapes
	// STEP 3a - Extract points from each shape, turn to vertices
	// STEP 3b - Triangulate each shape, add faces.

	function Shape() {

		Path.apply( this, arguments );

		this.holes = [];

	}

	Shape.prototype = Object.assign( Object.create( PathPrototype ), {

		constructor: Shape,

		getPointsHoles: function ( divisions ) {

			var holesPts = [];

			for ( var i = 0, l = this.holes.length; i < l; i ++ ) {

				holesPts[ i ] = this.holes[ i ].getPoints( divisions );

			}

			return holesPts;

		},

		// Get points of shape and holes (keypoints based on segments parameter)

		extractAllPoints: function ( divisions ) {

			return {

				shape: this.getPoints( divisions ),
				holes: this.getPointsHoles( divisions )

			};

		},

		extractPoints: function ( divisions ) {

			return this.extractAllPoints( divisions );

		}

	} );

	/**
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 * minimal class for proxing functions to Path. Replaces old "extractSubpaths()"
	 **/

	function ShapePath() {

		this.subPaths = [];
		this.currentPath = null;

	}

	Object.assign( ShapePath.prototype, {

		moveTo: function ( x, y ) {

			this.currentPath = new Path();
			this.subPaths.push( this.currentPath );
			this.currentPath.moveTo( x, y );

		},

		lineTo: function ( x, y ) {

			this.currentPath.lineTo( x, y );

		},

		quadraticCurveTo: function ( aCPx, aCPy, aX, aY ) {

			this.currentPath.quadraticCurveTo( aCPx, aCPy, aX, aY );

		},

		bezierCurveTo: function ( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY ) {

			this.currentPath.bezierCurveTo( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY );

		},

		splineThru: function ( pts ) {

			this.currentPath.splineThru( pts );

		},

		toShapes: function ( isCCW, noHoles ) {

			function toShapesNoHoles( inSubpaths ) {

				var shapes = [];

				for ( var i = 0, l = inSubpaths.length; i < l; i ++ ) {

					var tmpPath = inSubpaths[ i ];

					var tmpShape = new Shape();
					tmpShape.curves = tmpPath.curves;

					shapes.push( tmpShape );

				}

				return shapes;

			}

			function isPointInsidePolygon( inPt, inPolygon ) {

				var polyLen = inPolygon.length;

				// inPt on polygon contour => immediate success    or
				// toggling of inside/outside at every single! intersection point of an edge
				//  with the horizontal line through inPt, left of inPt
				//  not counting lowerY endpoints of edges and whole edges on that line
				var inside = false;
				for ( var p = polyLen - 1, q = 0; q < polyLen; p = q ++ ) {

					var edgeLowPt  = inPolygon[ p ];
					var edgeHighPt = inPolygon[ q ];

					var edgeDx = edgeHighPt.x - edgeLowPt.x;
					var edgeDy = edgeHighPt.y - edgeLowPt.y;

					if ( Math.abs( edgeDy ) > Number.EPSILON ) {

						// not parallel
						if ( edgeDy < 0 ) {

							edgeLowPt  = inPolygon[ q ]; edgeDx = - edgeDx;
							edgeHighPt = inPolygon[ p ]; edgeDy = - edgeDy;

						}
						if ( ( inPt.y < edgeLowPt.y ) || ( inPt.y > edgeHighPt.y ) ) 		continue;

						if ( inPt.y === edgeLowPt.y ) {

							if ( inPt.x === edgeLowPt.x )		return	true;		// inPt is on contour ?
							// continue;				// no intersection or edgeLowPt => doesn't count !!!

						} else {

							var perpEdge = edgeDy * ( inPt.x - edgeLowPt.x ) - edgeDx * ( inPt.y - edgeLowPt.y );
							if ( perpEdge === 0 )				return	true;		// inPt is on contour ?
							if ( perpEdge < 0 ) 				continue;
							inside = ! inside;		// true intersection left of inPt

						}

					} else {

						// parallel or collinear
						if ( inPt.y !== edgeLowPt.y ) 		continue;			// parallel
						// edge lies on the same horizontal line as inPt
						if ( ( ( edgeHighPt.x <= inPt.x ) && ( inPt.x <= edgeLowPt.x ) ) ||
							 ( ( edgeLowPt.x <= inPt.x ) && ( inPt.x <= edgeHighPt.x ) ) )		return	true;	// inPt: Point on contour !
						// continue;

					}

				}

				return	inside;

			}

			var isClockWise = ShapeUtils.isClockWise;

			var subPaths = this.subPaths;
			if ( subPaths.length === 0 ) return [];

			if ( noHoles === true )	return	toShapesNoHoles( subPaths );


			var solid, tmpPath, tmpShape, shapes = [];

			if ( subPaths.length === 1 ) {

				tmpPath = subPaths[ 0 ];
				tmpShape = new Shape();
				tmpShape.curves = tmpPath.curves;
				shapes.push( tmpShape );
				return shapes;

			}

			var holesFirst = ! isClockWise( subPaths[ 0 ].getPoints() );
			holesFirst = isCCW ? ! holesFirst : holesFirst;

			// console.log("Holes first", holesFirst);

			var betterShapeHoles = [];
			var newShapes = [];
			var newShapeHoles = [];
			var mainIdx = 0;
			var tmpPoints;

			newShapes[ mainIdx ] = undefined;
			newShapeHoles[ mainIdx ] = [];

			for ( var i = 0, l = subPaths.length; i < l; i ++ ) {

				tmpPath = subPaths[ i ];
				tmpPoints = tmpPath.getPoints();
				solid = isClockWise( tmpPoints );
				solid = isCCW ? ! solid : solid;

				if ( solid ) {

					if ( ( ! holesFirst ) && ( newShapes[ mainIdx ] ) )	mainIdx ++;

					newShapes[ mainIdx ] = { s: new Shape(), p: tmpPoints };
					newShapes[ mainIdx ].s.curves = tmpPath.curves;

					if ( holesFirst )	mainIdx ++;
					newShapeHoles[ mainIdx ] = [];

					//console.log('cw', i);

				} else {

					newShapeHoles[ mainIdx ].push( { h: tmpPath, p: tmpPoints[ 0 ] } );

					//console.log('ccw', i);

				}

			}

			// only Holes? -> probably all Shapes with wrong orientation
			if ( ! newShapes[ 0 ] )	return	toShapesNoHoles( subPaths );


			if ( newShapes.length > 1 ) {

				var ambiguous = false;
				var toChange = [];

				for ( var sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx ++ ) {

					betterShapeHoles[ sIdx ] = [];

				}

				for ( var sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx ++ ) {

					var sho = newShapeHoles[ sIdx ];

					for ( var hIdx = 0; hIdx < sho.length; hIdx ++ ) {

						var ho = sho[ hIdx ];
						var hole_unassigned = true;

						for ( var s2Idx = 0; s2Idx < newShapes.length; s2Idx ++ ) {

							if ( isPointInsidePolygon( ho.p, newShapes[ s2Idx ].p ) ) {

								if ( sIdx !== s2Idx )	toChange.push( { froms: sIdx, tos: s2Idx, hole: hIdx } );
								if ( hole_unassigned ) {

									hole_unassigned = false;
									betterShapeHoles[ s2Idx ].push( ho );

								} else {

									ambiguous = true;

								}

							}

						}
						if ( hole_unassigned ) {

							betterShapeHoles[ sIdx ].push( ho );

						}

					}

				}
				// console.log("ambiguous: ", ambiguous);
				if ( toChange.length > 0 ) {

					// console.log("to change: ", toChange);
					if ( ! ambiguous )	newShapeHoles = betterShapeHoles;

				}

			}

			var tmpHoles;

			for ( var i = 0, il = newShapes.length; i < il; i ++ ) {

				tmpShape = newShapes[ i ].s;
				shapes.push( tmpShape );
				tmpHoles = newShapeHoles[ i ];

				for ( var j = 0, jl = tmpHoles.length; j < jl; j ++ ) {

					tmpShape.holes.push( tmpHoles[ j ].h );

				}

			}

			//console.log("shape", shapes);

			return shapes;

		}

	} );

	/**
	 * @author zz85 / http://www.lab4games.net/zz85/blog
	 * @author mrdoob / http://mrdoob.com/
	 */

	function Font( data ) {

		this.data = data;

	}

	Object.assign( Font.prototype, {

		isFont: true,

		generateShapes: function ( text, size, divisions ) {

			function createPaths( text ) {

				var chars = String( text ).split( '' );
				var scale = size / data.resolution;
				var line_height = ( data.boundingBox.yMax - data.boundingBox.yMin + data.underlineThickness ) * scale;

				var offsetX = 0, offsetY = 0;

				var paths = [];

				for ( var i = 0; i < chars.length; i ++ ) {

					var char = chars[ i ];

					if ( char === '\n' ) {

						offsetX = 0;
						offsetY -= line_height;

					} else {

						var ret = createPath( char, scale, offsetX, offsetY );
						offsetX += ret.offsetX;
						paths.push( ret.path );

					}

				}

				return paths;

			}

			function createPath( c, scale, offsetX, offsetY ) {

				var glyph = data.glyphs[ c ] || data.glyphs[ '?' ];

				if ( ! glyph ) return;

				var path = new ShapePath();

				var pts = [];
				var x, y, cpx, cpy, cpx0, cpy0, cpx1, cpy1, cpx2, cpy2, laste;

				if ( glyph.o ) {

					var outline = glyph._cachedOutline || ( glyph._cachedOutline = glyph.o.split( ' ' ) );

					for ( var i = 0, l = outline.length; i < l; ) {

						var action = outline[ i ++ ];

						switch ( action ) {

							case 'm': // moveTo

								x = outline[ i ++ ] * scale + offsetX;
								y = outline[ i ++ ] * scale + offsetY;

								path.moveTo( x, y );

								break;

							case 'l': // lineTo

								x = outline[ i ++ ] * scale + offsetX;
								y = outline[ i ++ ] * scale + offsetY;

								path.lineTo( x, y );

								break;

							case 'q': // quadraticCurveTo

								cpx  = outline[ i ++ ] * scale + offsetX;
								cpy  = outline[ i ++ ] * scale + offsetY;
								cpx1 = outline[ i ++ ] * scale + offsetX;
								cpy1 = outline[ i ++ ] * scale + offsetY;

								path.quadraticCurveTo( cpx1, cpy1, cpx, cpy );

								laste = pts[ pts.length - 1 ];

								if ( laste ) {

									cpx0 = laste.x;
									cpy0 = laste.y;

									for ( var i2 = 1; i2 <= divisions; i2 ++ ) {

										var t = i2 / divisions;
										QuadraticBezier( t, cpx0, cpx1, cpx );
										QuadraticBezier( t, cpy0, cpy1, cpy );

									}

								}

								break;

							case 'b': // bezierCurveTo

								cpx  = outline[ i ++ ] * scale + offsetX;
								cpy  = outline[ i ++ ] * scale + offsetY;
								cpx1 = outline[ i ++ ] * scale + offsetX;
								cpy1 = outline[ i ++ ] * scale + offsetY;
								cpx2 = outline[ i ++ ] * scale + offsetX;
								cpy2 = outline[ i ++ ] * scale + offsetY;

								path.bezierCurveTo( cpx1, cpy1, cpx2, cpy2, cpx, cpy );

								laste = pts[ pts.length - 1 ];

								if ( laste ) {

									cpx0 = laste.x;
									cpy0 = laste.y;

									for ( var i2 = 1; i2 <= divisions; i2 ++ ) {

										var t = i2 / divisions;
										CubicBezier( t, cpx0, cpx1, cpx2, cpx );
										CubicBezier( t, cpy0, cpy1, cpy2, cpy );

									}

								}

								break;

						}

					}

				}

				return { offsetX: glyph.ha * scale, path: path };

			}

			//

			if ( size === undefined ) size = 100;
			if ( divisions === undefined ) divisions = 4;

			var data = this.data;

			var paths = createPaths( text );
			var shapes = [];

			for ( var p = 0, pl = paths.length; p < pl; p ++ ) {

				Array.prototype.push.apply( shapes, paths[ p ].toShapes() );

			}

			return shapes;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function FontLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

	}

	Object.assign( FontLoader.prototype, {

		load: function ( url, onLoad, onProgress, onError ) {

			var scope = this;

			var loader = new FileLoader( this.manager );
			loader.load( url, function ( text ) {

				var json;

				try {

					json = JSON.parse( text );

				} catch ( e ) {

					console.warn( 'THREE.FontLoader: typeface.js support is being deprecated. Use typeface.json instead.' );
					json = JSON.parse( text.substring( 65, text.length - 2 ) );

				}

				var font = scope.parse( json );

				if ( onLoad ) onLoad( font );

			}, onProgress, onError );

		},

		parse: function ( json ) {

			return new Font( json );

		}

	} );

	var context;

	var AudioContext = {

		getContext: function () {

			if ( context === undefined ) {

				context = new ( window.AudioContext || window.webkitAudioContext )();

			}

			return context;

		},

		setContext: function ( value ) {

			context = value;

		}

	};

	/**
	 * @author Reece Aaron Lecrivain / http://reecenotes.com/
	 */

	function AudioLoader( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

	}

	Object.assign( AudioLoader.prototype, {

		load: function ( url, onLoad, onProgress, onError ) {

			var loader = new FileLoader( this.manager );
			loader.setResponseType( 'arraybuffer' );
			loader.load( url, function ( buffer ) {

				var context = AudioContext.getContext();

				context.decodeAudioData( buffer, function ( audioBuffer ) {

					onLoad( audioBuffer );

				} );

			}, onProgress, onError );

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function StereoCamera() {

		this.type = 'StereoCamera';

		this.aspect = 1;

		this.eyeSep = 0.064;

		this.cameraL = new PerspectiveCamera();
		this.cameraL.layers.enable( 1 );
		this.cameraL.matrixAutoUpdate = false;

		this.cameraR = new PerspectiveCamera();
		this.cameraR.layers.enable( 2 );
		this.cameraR.matrixAutoUpdate = false;

	}

	Object.assign( StereoCamera.prototype, {

		update: ( function () {

			var instance, focus, fov, aspect, near, far, zoom, eyeSep;

			var eyeRight = new Matrix4();
			var eyeLeft = new Matrix4();

			return function update( camera ) {

				var needsUpdate = instance !== this || focus !== camera.focus || fov !== camera.fov ||
													aspect !== camera.aspect * this.aspect || near !== camera.near ||
													far !== camera.far || zoom !== camera.zoom || eyeSep !== this.eyeSep;

				if ( needsUpdate ) {

					instance = this;
					focus = camera.focus;
					fov = camera.fov;
					aspect = camera.aspect * this.aspect;
					near = camera.near;
					far = camera.far;
					zoom = camera.zoom;

					// Off-axis stereoscopic effect based on
					// http://paulbourke.net/stereographics/stereorender/

					var projectionMatrix = camera.projectionMatrix.clone();
					eyeSep = this.eyeSep / 2;
					var eyeSepOnProjection = eyeSep * near / focus;
					var ymax = ( near * Math.tan( _Math.DEG2RAD * fov * 0.5 ) ) / zoom;
					var xmin, xmax;

					// translate xOffset

					eyeLeft.elements[ 12 ] = - eyeSep;
					eyeRight.elements[ 12 ] = eyeSep;

					// for left eye

					xmin = - ymax * aspect + eyeSepOnProjection;
					xmax = ymax * aspect + eyeSepOnProjection;

					projectionMatrix.elements[ 0 ] = 2 * near / ( xmax - xmin );
					projectionMatrix.elements[ 8 ] = ( xmax + xmin ) / ( xmax - xmin );

					this.cameraL.projectionMatrix.copy( projectionMatrix );

					// for right eye

					xmin = - ymax * aspect - eyeSepOnProjection;
					xmax = ymax * aspect - eyeSepOnProjection;

					projectionMatrix.elements[ 0 ] = 2 * near / ( xmax - xmin );
					projectionMatrix.elements[ 8 ] = ( xmax + xmin ) / ( xmax - xmin );

					this.cameraR.projectionMatrix.copy( projectionMatrix );

				}

				this.cameraL.matrixWorld.copy( camera.matrixWorld ).multiply( eyeLeft );
				this.cameraR.matrixWorld.copy( camera.matrixWorld ).multiply( eyeRight );

			};

		} )()

	} );

	/**
	 * Camera for rendering cube maps
	 *	- renders scene into axis-aligned cube
	 *
	 * @author alteredq / http://alteredqualia.com/
	 */

	function CubeCamera( near, far, cubeResolution ) {

		Object3D.call( this );

		this.type = 'CubeCamera';

		var fov = 90, aspect = 1;

		var cameraPX = new PerspectiveCamera( fov, aspect, near, far );
		cameraPX.up.set( 0, - 1, 0 );
		cameraPX.lookAt( new Vector3( 1, 0, 0 ) );
		this.add( cameraPX );

		var cameraNX = new PerspectiveCamera( fov, aspect, near, far );
		cameraNX.up.set( 0, - 1, 0 );
		cameraNX.lookAt( new Vector3( - 1, 0, 0 ) );
		this.add( cameraNX );

		var cameraPY = new PerspectiveCamera( fov, aspect, near, far );
		cameraPY.up.set( 0, 0, 1 );
		cameraPY.lookAt( new Vector3( 0, 1, 0 ) );
		this.add( cameraPY );

		var cameraNY = new PerspectiveCamera( fov, aspect, near, far );
		cameraNY.up.set( 0, 0, - 1 );
		cameraNY.lookAt( new Vector3( 0, - 1, 0 ) );
		this.add( cameraNY );

		var cameraPZ = new PerspectiveCamera( fov, aspect, near, far );
		cameraPZ.up.set( 0, - 1, 0 );
		cameraPZ.lookAt( new Vector3( 0, 0, 1 ) );
		this.add( cameraPZ );

		var cameraNZ = new PerspectiveCamera( fov, aspect, near, far );
		cameraNZ.up.set( 0, - 1, 0 );
		cameraNZ.lookAt( new Vector3( 0, 0, - 1 ) );
		this.add( cameraNZ );

		var options = { format: RGBFormat, magFilter: LinearFilter, minFilter: LinearFilter };

		this.renderTarget = new WebGLRenderTargetCube( cubeResolution, cubeResolution, options );
		this.renderTarget.texture.name = "CubeCamera";

		this.update = function ( renderer, scene ) {

			if ( this.parent === null ) this.updateMatrixWorld();

			var renderTarget = this.renderTarget;
			var generateMipmaps = renderTarget.texture.generateMipmaps;

			renderTarget.texture.generateMipmaps = false;

			renderTarget.activeCubeFace = 0;
			renderer.render( scene, cameraPX, renderTarget );

			renderTarget.activeCubeFace = 1;
			renderer.render( scene, cameraNX, renderTarget );

			renderTarget.activeCubeFace = 2;
			renderer.render( scene, cameraPY, renderTarget );

			renderTarget.activeCubeFace = 3;
			renderer.render( scene, cameraNY, renderTarget );

			renderTarget.activeCubeFace = 4;
			renderer.render( scene, cameraPZ, renderTarget );

			renderTarget.texture.generateMipmaps = generateMipmaps;

			renderTarget.activeCubeFace = 5;
			renderer.render( scene, cameraNZ, renderTarget );

			renderer.setRenderTarget( null );

		};

		this.clear = function ( renderer, color, depth, stencil ) {

			var renderTarget = this.renderTarget;

			for ( var i = 0; i < 6; i ++ ) {

				renderTarget.activeCubeFace = i;
				renderer.setRenderTarget( renderTarget );

				renderer.clear( color, depth, stencil );

			}

			renderer.setRenderTarget( null );

		};

	}

	CubeCamera.prototype = Object.create( Object3D.prototype );
	CubeCamera.prototype.constructor = CubeCamera;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function AudioListener() {

		Object3D.call( this );

		this.type = 'AudioListener';

		this.context = AudioContext.getContext();

		this.gain = this.context.createGain();
		this.gain.connect( this.context.destination );

		this.filter = null;

	}

	AudioListener.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: AudioListener,

		getInput: function () {

			return this.gain;

		},

		removeFilter: function ( ) {

			if ( this.filter !== null ) {

				this.gain.disconnect( this.filter );
				this.filter.disconnect( this.context.destination );
				this.gain.connect( this.context.destination );
				this.filter = null;

			}

		},

		getFilter: function () {

			return this.filter;

		},

		setFilter: function ( value ) {

			if ( this.filter !== null ) {

				this.gain.disconnect( this.filter );
				this.filter.disconnect( this.context.destination );

			} else {

				this.gain.disconnect( this.context.destination );

			}

			this.filter = value;
			this.gain.connect( this.filter );
			this.filter.connect( this.context.destination );

		},

		getMasterVolume: function () {

			return this.gain.gain.value;

		},

		setMasterVolume: function ( value ) {

			this.gain.gain.value = value;

		},

		updateMatrixWorld: ( function () {

			var position = new Vector3();
			var quaternion = new Quaternion();
			var scale = new Vector3();

			var orientation = new Vector3();

			return function updateMatrixWorld( force ) {

				Object3D.prototype.updateMatrixWorld.call( this, force );

				var listener = this.context.listener;
				var up = this.up;

				this.matrixWorld.decompose( position, quaternion, scale );

				orientation.set( 0, 0, - 1 ).applyQuaternion( quaternion );

				if ( listener.positionX ) {

					listener.positionX.setValueAtTime( position.x, this.context.currentTime );
					listener.positionY.setValueAtTime( position.y, this.context.currentTime );
					listener.positionZ.setValueAtTime( position.z, this.context.currentTime );
					listener.forwardX.setValueAtTime( orientation.x, this.context.currentTime );
					listener.forwardY.setValueAtTime( orientation.y, this.context.currentTime );
					listener.forwardZ.setValueAtTime( orientation.z, this.context.currentTime );
					listener.upX.setValueAtTime( up.x, this.context.currentTime );
					listener.upY.setValueAtTime( up.y, this.context.currentTime );
					listener.upZ.setValueAtTime( up.z, this.context.currentTime );

				} else {

					listener.setPosition( position.x, position.y, position.z );
					listener.setOrientation( orientation.x, orientation.y, orientation.z, up.x, up.y, up.z );

				}

			};

		} )()

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author Reece Aaron Lecrivain / http://reecenotes.com/
	 */

	function Audio( listener ) {

		Object3D.call( this );

		this.type = 'Audio';

		this.context = listener.context;

		this.gain = this.context.createGain();
		this.gain.connect( listener.getInput() );

		this.autoplay = false;

		this.buffer = null;
		this.loop = false;
		this.startTime = 0;
		this.playbackRate = 1;
		this.isPlaying = false;
		this.hasPlaybackControl = true;
		this.sourceType = 'empty';

		this.filters = [];

	}

	Audio.prototype = Object.assign( Object.create( Object3D.prototype ), {

		constructor: Audio,

		getOutput: function () {

			return this.gain;

		},

		setNodeSource: function ( audioNode ) {

			this.hasPlaybackControl = false;
			this.sourceType = 'audioNode';
			this.source = audioNode;
			this.connect();

			return this;

		},

		setBuffer: function ( audioBuffer ) {

			this.buffer = audioBuffer;
			this.sourceType = 'buffer';

			if ( this.autoplay ) this.play();

			return this;

		},

		play: function () {

			if ( this.isPlaying === true ) {

				console.warn( 'THREE.Audio: Audio is already playing.' );
				return;

			}

			if ( this.hasPlaybackControl === false ) {

				console.warn( 'THREE.Audio: this Audio has no playback control.' );
				return;

			}

			var source = this.context.createBufferSource();

			source.buffer = this.buffer;
			source.loop = this.loop;
			source.onended = this.onEnded.bind( this );
			source.playbackRate.setValueAtTime( this.playbackRate, this.startTime );
			source.start( 0, this.startTime );

			this.isPlaying = true;

			this.source = source;

			return this.connect();

		},

		pause: function () {

			if ( this.hasPlaybackControl === false ) {

				console.warn( 'THREE.Audio: this Audio has no playback control.' );
				return;

			}

			this.source.stop();
			this.startTime = this.context.currentTime;
			this.isPlaying = false;

			return this;

		},

		stop: function () {

			if ( this.hasPlaybackControl === false ) {

				console.warn( 'THREE.Audio: this Audio has no playback control.' );
				return;

			}

			this.source.stop();
			this.startTime = 0;
			this.isPlaying = false;

			return this;

		},

		connect: function () {

			if ( this.filters.length > 0 ) {

				this.source.connect( this.filters[ 0 ] );

				for ( var i = 1, l = this.filters.length; i < l; i ++ ) {

					this.filters[ i - 1 ].connect( this.filters[ i ] );

				}

				this.filters[ this.filters.length - 1 ].connect( this.getOutput() );

			} else {

				this.source.connect( this.getOutput() );

			}

			return this;

		},

		disconnect: function () {

			if ( this.filters.length > 0 ) {

				this.source.disconnect( this.filters[ 0 ] );

				for ( var i = 1, l = this.filters.length; i < l; i ++ ) {

					this.filters[ i - 1 ].disconnect( this.filters[ i ] );

				}

				this.filters[ this.filters.length - 1 ].disconnect( this.getOutput() );

			} else {

				this.source.disconnect( this.getOutput() );

			}

			return this;

		},

		getFilters: function () {

			return this.filters;

		},

		setFilters: function ( value ) {

			if ( ! value ) value = [];

			if ( this.isPlaying === true ) {

				this.disconnect();
				this.filters = value;
				this.connect();

			} else {

				this.filters = value;

			}

			return this;

		},

		getFilter: function () {

			return this.getFilters()[ 0 ];

		},

		setFilter: function ( filter ) {

			return this.setFilters( filter ? [ filter ] : [] );

		},

		setPlaybackRate: function ( value ) {

			if ( this.hasPlaybackControl === false ) {

				console.warn( 'THREE.Audio: this Audio has no playback control.' );
				return;

			}

			this.playbackRate = value;

			if ( this.isPlaying === true ) {

				this.source.playbackRate.setValueAtTime( this.playbackRate, this.context.currentTime );

			}

			return this;

		},

		getPlaybackRate: function () {

			return this.playbackRate;

		},

		onEnded: function () {

			this.isPlaying = false;

		},

		getLoop: function () {

			if ( this.hasPlaybackControl === false ) {

				console.warn( 'THREE.Audio: this Audio has no playback control.' );
				return false;

			}

			return this.loop;

		},

		setLoop: function ( value ) {

			if ( this.hasPlaybackControl === false ) {

				console.warn( 'THREE.Audio: this Audio has no playback control.' );
				return;

			}

			this.loop = value;

			if ( this.isPlaying === true ) {

				this.source.loop = this.loop;

			}

			return this;

		},

		getVolume: function () {

			return this.gain.gain.value;

		},

		setVolume: function ( value ) {

			this.gain.gain.value = value;

			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function PositionalAudio( listener ) {

		Audio.call( this, listener );

		this.panner = this.context.createPanner();
		this.panner.connect( this.gain );

	}

	PositionalAudio.prototype = Object.assign( Object.create( Audio.prototype ), {

		constructor: PositionalAudio,

		getOutput: function () {

			return this.panner;

		},

		getRefDistance: function () {

			return this.panner.refDistance;

		},

		setRefDistance: function ( value ) {

			this.panner.refDistance = value;

		},

		getRolloffFactor: function () {

			return this.panner.rolloffFactor;

		},

		setRolloffFactor: function ( value ) {

			this.panner.rolloffFactor = value;

		},

		getDistanceModel: function () {

			return this.panner.distanceModel;

		},

		setDistanceModel: function ( value ) {

			this.panner.distanceModel = value;

		},

		getMaxDistance: function () {

			return this.panner.maxDistance;

		},

		setMaxDistance: function ( value ) {

			this.panner.maxDistance = value;

		},

		updateMatrixWorld: ( function () {

			var position = new Vector3();

			return function updateMatrixWorld( force ) {

				Object3D.prototype.updateMatrixWorld.call( this, force );

				position.setFromMatrixPosition( this.matrixWorld );

				this.panner.setPosition( position.x, position.y, position.z );

			};

		} )()


	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function AudioAnalyser( audio, fftSize ) {

		this.analyser = audio.context.createAnalyser();
		this.analyser.fftSize = fftSize !== undefined ? fftSize : 2048;

		this.data = new Uint8Array( this.analyser.frequencyBinCount );

		audio.getOutput().connect( this.analyser );

	}

	Object.assign( AudioAnalyser.prototype, {

		getFrequencyData: function () {

			this.analyser.getByteFrequencyData( this.data );

			return this.data;

		},

		getAverageFrequency: function () {

			var value = 0, data = this.getFrequencyData();

			for ( var i = 0; i < data.length; i ++ ) {

				value += data[ i ];

			}

			return value / data.length;

		}

	} );

	/**
	 *
	 * Buffered scene graph property that allows weighted accumulation.
	 *
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 */

	function PropertyMixer( binding, typeName, valueSize ) {

		this.binding = binding;
		this.valueSize = valueSize;

		var bufferType = Float64Array,
			mixFunction;

		switch ( typeName ) {

			case 'quaternion':
				mixFunction = this._slerp;
				break;

			case 'string':
			case 'bool':
				bufferType = Array;
				mixFunction = this._select;
				break;

			default:
				mixFunction = this._lerp;

		}

		this.buffer = new bufferType( valueSize * 4 );
		// layout: [ incoming | accu0 | accu1 | orig ]
		//
		// interpolators can use .buffer as their .result
		// the data then goes to 'incoming'
		//
		// 'accu0' and 'accu1' are used frame-interleaved for
		// the cumulative result and are compared to detect
		// changes
		//
		// 'orig' stores the original state of the property

		this._mixBufferRegion = mixFunction;

		this.cumulativeWeight = 0;

		this.useCount = 0;
		this.referenceCount = 0;

	}

	Object.assign( PropertyMixer.prototype, {

		// accumulate data in the 'incoming' region into 'accu<i>'
		accumulate: function ( accuIndex, weight ) {

			// note: happily accumulating nothing when weight = 0, the caller knows
			// the weight and shouldn't have made the call in the first place

			var buffer = this.buffer,
				stride = this.valueSize,
				offset = accuIndex * stride + stride,

				currentWeight = this.cumulativeWeight;

			if ( currentWeight === 0 ) {

				// accuN := incoming * weight

				for ( var i = 0; i !== stride; ++ i ) {

					buffer[ offset + i ] = buffer[ i ];

				}

				currentWeight = weight;

			} else {

				// accuN := accuN + incoming * weight

				currentWeight += weight;
				var mix = weight / currentWeight;
				this._mixBufferRegion( buffer, offset, 0, mix, stride );

			}

			this.cumulativeWeight = currentWeight;

		},

		// apply the state of 'accu<i>' to the binding when accus differ
		apply: function ( accuIndex ) {

			var stride = this.valueSize,
				buffer = this.buffer,
				offset = accuIndex * stride + stride,

				weight = this.cumulativeWeight,

				binding = this.binding;

			this.cumulativeWeight = 0;

			if ( weight < 1 ) {

				// accuN := accuN + original * ( 1 - cumulativeWeight )

				var originalValueOffset = stride * 3;

				this._mixBufferRegion(
					buffer, offset, originalValueOffset, 1 - weight, stride );

			}

			for ( var i = stride, e = stride + stride; i !== e; ++ i ) {

				if ( buffer[ i ] !== buffer[ i + stride ] ) {

					// value has changed -> update scene graph

					binding.setValue( buffer, offset );
					break;

				}

			}

		},

		// remember the state of the bound property and copy it to both accus
		saveOriginalState: function () {

			var binding = this.binding;

			var buffer = this.buffer,
				stride = this.valueSize,

				originalValueOffset = stride * 3;

			binding.getValue( buffer, originalValueOffset );

			// accu[0..1] := orig -- initially detect changes against the original
			for ( var i = stride, e = originalValueOffset; i !== e; ++ i ) {

				buffer[ i ] = buffer[ originalValueOffset + ( i % stride ) ];

			}

			this.cumulativeWeight = 0;

		},

		// apply the state previously taken via 'saveOriginalState' to the binding
		restoreOriginalState: function () {

			var originalValueOffset = this.valueSize * 3;
			this.binding.setValue( this.buffer, originalValueOffset );

		},


		// mix functions

		_select: function ( buffer, dstOffset, srcOffset, t, stride ) {

			if ( t >= 0.5 ) {

				for ( var i = 0; i !== stride; ++ i ) {

					buffer[ dstOffset + i ] = buffer[ srcOffset + i ];

				}

			}

		},

		_slerp: function ( buffer, dstOffset, srcOffset, t ) {

			Quaternion.slerpFlat( buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t );

		},

		_lerp: function ( buffer, dstOffset, srcOffset, t, stride ) {

			var s = 1 - t;

			for ( var i = 0; i !== stride; ++ i ) {

				var j = dstOffset + i;

				buffer[ j ] = buffer[ j ] * s + buffer[ srcOffset + i ] * t;

			}

		}

	} );

	/**
	 *
	 * A reference to a real property in the scene graph.
	 *
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 */

	function Composite( targetGroup, path, optionalParsedPath ) {

		var parsedPath = optionalParsedPath || PropertyBinding.parseTrackName( path );

		this._targetGroup = targetGroup;
		this._bindings = targetGroup.subscribe_( path, parsedPath );

	}

	Object.assign( Composite.prototype, {

		getValue: function ( array, offset ) {

			this.bind(); // bind all binding

			var firstValidIndex = this._targetGroup.nCachedObjects_,
				binding = this._bindings[ firstValidIndex ];

			// and only call .getValue on the first
			if ( binding !== undefined ) binding.getValue( array, offset );

		},

		setValue: function ( array, offset ) {

			var bindings = this._bindings;

			for ( var i = this._targetGroup.nCachedObjects_,
					  n = bindings.length; i !== n; ++ i ) {

				bindings[ i ].setValue( array, offset );

			}

		},

		bind: function () {

			var bindings = this._bindings;

			for ( var i = this._targetGroup.nCachedObjects_,
					  n = bindings.length; i !== n; ++ i ) {

				bindings[ i ].bind();

			}

		},

		unbind: function () {

			var bindings = this._bindings;

			for ( var i = this._targetGroup.nCachedObjects_,
					  n = bindings.length; i !== n; ++ i ) {

				bindings[ i ].unbind();

			}

		}

	} );


	function PropertyBinding( rootNode, path, parsedPath ) {

		this.path = path;
		this.parsedPath = parsedPath || PropertyBinding.parseTrackName( path );

		this.node = PropertyBinding.findNode( rootNode, this.parsedPath.nodeName ) || rootNode;

		this.rootNode = rootNode;

	}

	Object.assign( PropertyBinding, {

		Composite: Composite,

		create: function ( root, path, parsedPath ) {

			if ( ! ( root && root.isAnimationObjectGroup ) ) {

				return new PropertyBinding( root, path, parsedPath );

			} else {

				return new PropertyBinding.Composite( root, path, parsedPath );

			}

		},

		/**
		 * Replaces spaces with underscores and removes unsupported characters from
		 * node names, to ensure compatibility with parseTrackName().
		 *
		 * @param  {string} name Node name to be sanitized.
		 * @return {string}
		 */
		sanitizeNodeName: function ( name ) {

			return name.replace( /\s/g, '_' ).replace( /[^\w-]/g, '' );

		},

		parseTrackName: function () {

			// Parent directories, delimited by '/' or ':'. Currently unused, but must
			// be matched to parse the rest of the track name.
			var directoryRe = /((?:[\w-]+[\/:])*)/;

			// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
			var nodeRe = /([\w-\.]+)?/;

			// Object on target node, and accessor. Name may contain only word
			// characters. Accessor may contain any character except closing bracket.
			var objectRe = /(?:\.([\w-]+)(?:\[(.+)\])?)?/;

			// Property and accessor. May contain only word characters. Accessor may
			// contain any non-bracket characters.
			var propertyRe = /\.([\w-]+)(?:\[(.+)\])?/;

			var trackRe = new RegExp(''
				+ '^'
				+ directoryRe.source
				+ nodeRe.source
				+ objectRe.source
				+ propertyRe.source
				+ '$'
			);

			var supportedObjectNames = [ 'material', 'materials', 'bones' ];

			return function ( trackName ) {

					var matches = trackRe.exec( trackName );

					if ( ! matches ) {

						throw new Error( 'PropertyBinding: Cannot parse trackName: ' + trackName );

					}

					var results = {
						// directoryName: matches[ 1 ], // (tschw) currently unused
						nodeName: matches[ 2 ],
						objectName: matches[ 3 ],
						objectIndex: matches[ 4 ],
						propertyName: matches[ 5 ],     // required
						propertyIndex: matches[ 6 ]
					};

					var lastDot = results.nodeName && results.nodeName.lastIndexOf( '.' );

					if ( lastDot !== undefined && lastDot !== -1 ) {

						var objectName = results.nodeName.substring( lastDot + 1 );

						// Object names must be checked against a whitelist. Otherwise, there
						// is no way to parse 'foo.bar.baz': 'baz' must be a property, but
						// 'bar' could be the objectName, or part of a nodeName (which can
						// include '.' characters).
						if ( supportedObjectNames.indexOf( objectName ) !== -1 ) {

							results.nodeName = results.nodeName.substring( 0, lastDot );
							results.objectName = objectName;

						}

					}

					if ( results.propertyName === null || results.propertyName.length === 0 ) {

						throw new Error( 'PropertyBinding: can not parse propertyName from trackName: ' + trackName );

					}

					return results;

				};

		}(),

		findNode: function ( root, nodeName ) {

			if ( ! nodeName || nodeName === "" || nodeName === "root" || nodeName === "." || nodeName === - 1 || nodeName === root.name || nodeName === root.uuid ) {

				return root;

			}

			// search into skeleton bones.
			if ( root.skeleton ) {

				var searchSkeleton = function ( skeleton ) {

					for ( var i = 0; i < skeleton.bones.length; i ++ ) {

						var bone = skeleton.bones[ i ];

						if ( bone.name === nodeName ) {

							return bone;

						}

					}

					return null;

				};

				var bone = searchSkeleton( root.skeleton );

				if ( bone ) {

					return bone;

				}

			}

			// search into node subtree.
			if ( root.children ) {

				var searchNodeSubtree = function ( children ) {

					for ( var i = 0; i < children.length; i ++ ) {

						var childNode = children[ i ];

						if ( childNode.name === nodeName || childNode.uuid === nodeName ) {

							return childNode;

						}

						var result = searchNodeSubtree( childNode.children );

						if ( result ) return result;

					}

					return null;

				};

				var subTreeNode = searchNodeSubtree( root.children );

				if ( subTreeNode ) {

					return subTreeNode;

				}

			}

			return null;

		}

	} );

	Object.assign( PropertyBinding.prototype, { // prototype, continued

		// these are used to "bind" a nonexistent property
		_getValue_unavailable: function () {},
		_setValue_unavailable: function () {},

		BindingType: {
			Direct: 0,
			EntireArray: 1,
			ArrayElement: 2,
			HasFromToArray: 3
		},

		Versioning: {
			None: 0,
			NeedsUpdate: 1,
			MatrixWorldNeedsUpdate: 2
		},

		GetterByBindingType: [

			function getValue_direct( buffer, offset ) {

				buffer[ offset ] = this.node[ this.propertyName ];

			},

			function getValue_array( buffer, offset ) {

				var source = this.resolvedProperty;

				for ( var i = 0, n = source.length; i !== n; ++ i ) {

					buffer[ offset ++ ] = source[ i ];

				}

			},

			function getValue_arrayElement( buffer, offset ) {

				buffer[ offset ] = this.resolvedProperty[ this.propertyIndex ];

			},

			function getValue_toArray( buffer, offset ) {

				this.resolvedProperty.toArray( buffer, offset );

			}

		],

		SetterByBindingTypeAndVersioning: [

			[
				// Direct

				function setValue_direct( buffer, offset ) {

					this.node[ this.propertyName ] = buffer[ offset ];

				},

				function setValue_direct_setNeedsUpdate( buffer, offset ) {

					this.node[ this.propertyName ] = buffer[ offset ];
					this.targetObject.needsUpdate = true;

				},

				function setValue_direct_setMatrixWorldNeedsUpdate( buffer, offset ) {

					this.node[ this.propertyName ] = buffer[ offset ];
					this.targetObject.matrixWorldNeedsUpdate = true;

				}

			], [

				// EntireArray

				function setValue_array( buffer, offset ) {

					var dest = this.resolvedProperty;

					for ( var i = 0, n = dest.length; i !== n; ++ i ) {

						dest[ i ] = buffer[ offset ++ ];

					}

				},

				function setValue_array_setNeedsUpdate( buffer, offset ) {

					var dest = this.resolvedProperty;

					for ( var i = 0, n = dest.length; i !== n; ++ i ) {

						dest[ i ] = buffer[ offset ++ ];

					}

					this.targetObject.needsUpdate = true;

				},

				function setValue_array_setMatrixWorldNeedsUpdate( buffer, offset ) {

					var dest = this.resolvedProperty;

					for ( var i = 0, n = dest.length; i !== n; ++ i ) {

						dest[ i ] = buffer[ offset ++ ];

					}

					this.targetObject.matrixWorldNeedsUpdate = true;

				}

			], [

				// ArrayElement

				function setValue_arrayElement( buffer, offset ) {

					this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];

				},

				function setValue_arrayElement_setNeedsUpdate( buffer, offset ) {

					this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];
					this.targetObject.needsUpdate = true;

				},

				function setValue_arrayElement_setMatrixWorldNeedsUpdate( buffer, offset ) {

					this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];
					this.targetObject.matrixWorldNeedsUpdate = true;

				}

			], [

				// HasToFromArray

				function setValue_fromArray( buffer, offset ) {

					this.resolvedProperty.fromArray( buffer, offset );

				},

				function setValue_fromArray_setNeedsUpdate( buffer, offset ) {

					this.resolvedProperty.fromArray( buffer, offset );
					this.targetObject.needsUpdate = true;

				},

				function setValue_fromArray_setMatrixWorldNeedsUpdate( buffer, offset ) {

					this.resolvedProperty.fromArray( buffer, offset );
					this.targetObject.matrixWorldNeedsUpdate = true;

				}

			]

		],

		getValue: function getValue_unbound( targetArray, offset ) {

			this.bind();
			this.getValue( targetArray, offset );

			// Note: This class uses a State pattern on a per-method basis:
			// 'bind' sets 'this.getValue' / 'setValue' and shadows the
			// prototype version of these methods with one that represents
			// the bound state. When the property is not found, the methods
			// become no-ops.

		},

		setValue: function getValue_unbound( sourceArray, offset ) {

			this.bind();
			this.setValue( sourceArray, offset );

		},

		// create getter / setter pair for a property in the scene graph
		bind: function () {

			var targetObject = this.node,
				parsedPath = this.parsedPath,

				objectName = parsedPath.objectName,
				propertyName = parsedPath.propertyName,
				propertyIndex = parsedPath.propertyIndex;

			if ( ! targetObject ) {

				targetObject = PropertyBinding.findNode(
						this.rootNode, parsedPath.nodeName ) || this.rootNode;

				this.node = targetObject;

			}

			// set fail state so we can just 'return' on error
			this.getValue = this._getValue_unavailable;
			this.setValue = this._setValue_unavailable;

			// ensure there is a value node
			if ( ! targetObject ) {

				console.error( 'THREE.PropertyBinding: Trying to update node for track: ' + this.path + ' but it wasn\'t found.' );
				return;

			}

			if ( objectName ) {

				var objectIndex = parsedPath.objectIndex;

				// special cases were we need to reach deeper into the hierarchy to get the face materials....
				switch ( objectName ) {

					case 'materials':

						if ( ! targetObject.material ) {

							console.error( 'THREE.PropertyBinding: Can not bind to material as node does not have a material.', this );
							return;

						}

						if ( ! targetObject.material.materials ) {

							console.error( 'THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this );
							return;

						}

						targetObject = targetObject.material.materials;

						break;

					case 'bones':

						if ( ! targetObject.skeleton ) {

							console.error( 'THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this );
							return;

						}

						// potential future optimization: skip this if propertyIndex is already an integer
						// and convert the integer string to a true integer.

						targetObject = targetObject.skeleton.bones;

						// support resolving morphTarget names into indices.
						for ( var i = 0; i < targetObject.length; i ++ ) {

							if ( targetObject[ i ].name === objectIndex ) {

								objectIndex = i;
								break;

							}

						}

						break;

					default:

						if ( targetObject[ objectName ] === undefined ) {

							console.error( 'THREE.PropertyBinding: Can not bind to objectName of node undefined.', this );
							return;

						}

						targetObject = targetObject[ objectName ];

				}


				if ( objectIndex !== undefined ) {

					if ( targetObject[ objectIndex ] === undefined ) {

						console.error( 'THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject );
						return;

					}

					targetObject = targetObject[ objectIndex ];

				}

			}

			// resolve property
			var nodeProperty = targetObject[ propertyName ];

			if ( nodeProperty === undefined ) {

				var nodeName = parsedPath.nodeName;

				console.error( 'THREE.PropertyBinding: Trying to update property for track: ' + nodeName +
					'.' + propertyName + ' but it wasn\'t found.', targetObject );
				return;

			}

			// determine versioning scheme
			var versioning = this.Versioning.None;

			if ( targetObject.needsUpdate !== undefined ) { // material

				versioning = this.Versioning.NeedsUpdate;
				this.targetObject = targetObject;

			} else if ( targetObject.matrixWorldNeedsUpdate !== undefined ) { // node transform

				versioning = this.Versioning.MatrixWorldNeedsUpdate;
				this.targetObject = targetObject;

			}

			// determine how the property gets bound
			var bindingType = this.BindingType.Direct;

			if ( propertyIndex !== undefined ) {

				// access a sub element of the property array (only primitives are supported right now)

				if ( propertyName === "morphTargetInfluences" ) {

					// potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.

					// support resolving morphTarget names into indices.
					if ( ! targetObject.geometry ) {

						console.error( 'THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this );
						return;

					}

					if ( targetObject.geometry.isBufferGeometry ) {

						if ( ! targetObject.geometry.morphAttributes ) {

							console.error( 'THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this );
							return;

						}

						for ( var i = 0; i < this.node.geometry.morphAttributes.position.length; i ++ ) {

							if ( targetObject.geometry.morphAttributes.position[ i ].name === propertyIndex ) {

								propertyIndex = i;
								break;

							}

						}


					} else {

						if ( ! targetObject.geometry.morphTargets ) {

							console.error( 'THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphTargets.', this );
							return;

						}

						for ( var i = 0; i < this.node.geometry.morphTargets.length; i ++ ) {

							if ( targetObject.geometry.morphTargets[ i ].name === propertyIndex ) {

								propertyIndex = i;
								break;

							}

						}

					}

				}

				bindingType = this.BindingType.ArrayElement;

				this.resolvedProperty = nodeProperty;
				this.propertyIndex = propertyIndex;

			} else if ( nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined ) {

				// must use copy for Object3D.Euler/Quaternion

				bindingType = this.BindingType.HasFromToArray;

				this.resolvedProperty = nodeProperty;

			} else if ( Array.isArray( nodeProperty ) ) {

				bindingType = this.BindingType.EntireArray;

				this.resolvedProperty = nodeProperty;

			} else {

				this.propertyName = propertyName;

			}

			// select getter / setter
			this.getValue = this.GetterByBindingType[ bindingType ];
			this.setValue = this.SetterByBindingTypeAndVersioning[ bindingType ][ versioning ];

		},

		unbind: function () {

			this.node = null;

			// back to the prototype version of getValue / setValue
			// note: avoiding to mutate the shape of 'this' via 'delete'
			this.getValue = this._getValue_unbound;
			this.setValue = this._setValue_unbound;

		}

	} );

	//!\ DECLARE ALIAS AFTER assign prototype !
	Object.assign( PropertyBinding.prototype, {

		// initial state of these methods that calls 'bind'
		_getValue_unbound: PropertyBinding.prototype.getValue,
		_setValue_unbound: PropertyBinding.prototype.setValue,

	} );

	/**
	 *
	 * A group of objects that receives a shared animation state.
	 *
	 * Usage:
	 *
	 * 	-	Add objects you would otherwise pass as 'root' to the
	 * 		constructor or the .clipAction method of AnimationMixer.
	 *
	 * 	-	Instead pass this object as 'root'.
	 *
	 * 	-	You can also add and remove objects later when the mixer
	 * 		is running.
	 *
	 * Note:
	 *
	 *  	Objects of this class appear as one object to the mixer,
	 *  	so cache control of the individual objects must be done
	 *  	on the group.
	 *
	 * Limitation:
	 *
	 * 	- 	The animated properties must be compatible among the
	 * 		all objects in the group.
	 *
	 *  -	A single property can either be controlled through a
	 *  	target group or directly, but not both.
	 *
	 * @author tschw
	 */

	function AnimationObjectGroup( var_args ) {

		this.uuid = _Math.generateUUID();

		// cached objects followed by the active ones
		this._objects = Array.prototype.slice.call( arguments );

		this.nCachedObjects_ = 0;			// threshold
		// note: read by PropertyBinding.Composite

		var indices = {};
		this._indicesByUUID = indices;		// for bookkeeping

		for ( var i = 0, n = arguments.length; i !== n; ++ i ) {

			indices[ arguments[ i ].uuid ] = i;

		}

		this._paths = [];					// inside: string
		this._parsedPaths = [];				// inside: { we don't care, here }
		this._bindings = []; 				// inside: Array< PropertyBinding >
		this._bindingsIndicesByPath = {}; 	// inside: indices in these arrays

		var scope = this;

		this.stats = {

			objects: {
				get total() { return scope._objects.length; },
				get inUse() { return this.total - scope.nCachedObjects_; }
			},

			get bindingsPerObject() { return scope._bindings.length; }

		};

	}

	Object.assign( AnimationObjectGroup.prototype, {

		isAnimationObjectGroup: true,

		add: function( var_args ) {

			var objects = this._objects,
				nObjects = objects.length,
				nCachedObjects = this.nCachedObjects_,
				indicesByUUID = this._indicesByUUID,
				paths = this._paths,
				parsedPaths = this._parsedPaths,
				bindings = this._bindings,
				nBindings = bindings.length;

			for ( var i = 0, n = arguments.length; i !== n; ++ i ) {

				var object = arguments[ i ],
					uuid = object.uuid,
					index = indicesByUUID[ uuid ],
					knownObject = undefined;

				if ( index === undefined ) {

					// unknown object -> add it to the ACTIVE region

					index = nObjects ++;
					indicesByUUID[ uuid ] = index;
					objects.push( object );

					// accounting is done, now do the same for all bindings

					for ( var j = 0, m = nBindings; j !== m; ++ j ) {

						bindings[ j ].push(
								new PropertyBinding(
									object, paths[ j ], parsedPaths[ j ] ) );

					}

				} else if ( index < nCachedObjects ) {

					knownObject = objects[ index ];

					// move existing object to the ACTIVE region

					var firstActiveIndex = -- nCachedObjects,
						lastCachedObject = objects[ firstActiveIndex ];

					indicesByUUID[ lastCachedObject.uuid ] = index;
					objects[ index ] = lastCachedObject;

					indicesByUUID[ uuid ] = firstActiveIndex;
					objects[ firstActiveIndex ] = object;

					// accounting is done, now do the same for all bindings

					for ( var j = 0, m = nBindings; j !== m; ++ j ) {

						var bindingsForPath = bindings[ j ],
							lastCached = bindingsForPath[ firstActiveIndex ],
							binding = bindingsForPath[ index ];

						bindingsForPath[ index ] = lastCached;

						if ( binding === undefined ) {

							// since we do not bother to create new bindings
							// for objects that are cached, the binding may
							// or may not exist

							binding = new PropertyBinding(
									object, paths[ j ], parsedPaths[ j ] );

						}

						bindingsForPath[ firstActiveIndex ] = binding;

					}

				} else if ( objects[ index ] !== knownObject ) {

					console.error( 'THREE.AnimationObjectGroup: Different objects with the same UUID ' +
							'detected. Clean the caches or recreate your infrastructure when reloading scenes.' );

				} // else the object is already where we want it to be

			} // for arguments

			this.nCachedObjects_ = nCachedObjects;

		},

		remove: function( var_args ) {

			var objects = this._objects,
				nCachedObjects = this.nCachedObjects_,
				indicesByUUID = this._indicesByUUID,
				bindings = this._bindings,
				nBindings = bindings.length;

			for ( var i = 0, n = arguments.length; i !== n; ++ i ) {

				var object = arguments[ i ],
					uuid = object.uuid,
					index = indicesByUUID[ uuid ];

				if ( index !== undefined && index >= nCachedObjects ) {

					// move existing object into the CACHED region

					var lastCachedIndex = nCachedObjects ++,
						firstActiveObject = objects[ lastCachedIndex ];

					indicesByUUID[ firstActiveObject.uuid ] = index;
					objects[ index ] = firstActiveObject;

					indicesByUUID[ uuid ] = lastCachedIndex;
					objects[ lastCachedIndex ] = object;

					// accounting is done, now do the same for all bindings

					for ( var j = 0, m = nBindings; j !== m; ++ j ) {

						var bindingsForPath = bindings[ j ],
							firstActive = bindingsForPath[ lastCachedIndex ],
							binding = bindingsForPath[ index ];

						bindingsForPath[ index ] = firstActive;
						bindingsForPath[ lastCachedIndex ] = binding;

					}

				}

			} // for arguments

			this.nCachedObjects_ = nCachedObjects;

		},

		// remove & forget
		uncache: function( var_args ) {

			var objects = this._objects,
				nObjects = objects.length,
				nCachedObjects = this.nCachedObjects_,
				indicesByUUID = this._indicesByUUID,
				bindings = this._bindings,
				nBindings = bindings.length;

			for ( var i = 0, n = arguments.length; i !== n; ++ i ) {

				var object = arguments[ i ],
					uuid = object.uuid,
					index = indicesByUUID[ uuid ];

				if ( index !== undefined ) {

					delete indicesByUUID[ uuid ];

					if ( index < nCachedObjects ) {

						// object is cached, shrink the CACHED region

						var firstActiveIndex = -- nCachedObjects,
							lastCachedObject = objects[ firstActiveIndex ],
							lastIndex = -- nObjects,
							lastObject = objects[ lastIndex ];

						// last cached object takes this object's place
						indicesByUUID[ lastCachedObject.uuid ] = index;
						objects[ index ] = lastCachedObject;

						// last object goes to the activated slot and pop
						indicesByUUID[ lastObject.uuid ] = firstActiveIndex;
						objects[ firstActiveIndex ] = lastObject;
						objects.pop();

						// accounting is done, now do the same for all bindings

						for ( var j = 0, m = nBindings; j !== m; ++ j ) {

							var bindingsForPath = bindings[ j ],
								lastCached = bindingsForPath[ firstActiveIndex ],
								last = bindingsForPath[ lastIndex ];

							bindingsForPath[ index ] = lastCached;
							bindingsForPath[ firstActiveIndex ] = last;
							bindingsForPath.pop();

						}

					} else {

						// object is active, just swap with the last and pop

						var lastIndex = -- nObjects,
							lastObject = objects[ lastIndex ];

						indicesByUUID[ lastObject.uuid ] = index;
						objects[ index ] = lastObject;
						objects.pop();

						// accounting is done, now do the same for all bindings

						for ( var j = 0, m = nBindings; j !== m; ++ j ) {

							var bindingsForPath = bindings[ j ];

							bindingsForPath[ index ] = bindingsForPath[ lastIndex ];
							bindingsForPath.pop();

						}

					} // cached or active

				} // if object is known

			} // for arguments

			this.nCachedObjects_ = nCachedObjects;

		},

		// Internal interface used by befriended PropertyBinding.Composite:

		subscribe_: function ( path, parsedPath ) {

			// returns an array of bindings for the given path that is changed
			// according to the contained objects in the group

			var indicesByPath = this._bindingsIndicesByPath,
				index = indicesByPath[ path ],
				bindings = this._bindings;

			if ( index !== undefined ) return bindings[ index ];

			var paths = this._paths,
				parsedPaths = this._parsedPaths,
				objects = this._objects,
				nObjects = objects.length,
				nCachedObjects = this.nCachedObjects_,
				bindingsForPath = new Array( nObjects );

			index = bindings.length;

			indicesByPath[ path ] = index;

			paths.push( path );
			parsedPaths.push( parsedPath );
			bindings.push( bindingsForPath );

			for ( var i = nCachedObjects, n = objects.length; i !== n; ++ i ) {

				var object = objects[ i ];
				bindingsForPath[ i ] = new PropertyBinding( object, path, parsedPath );

			}

			return bindingsForPath;

		},

		unsubscribe_: function ( path ) {

			// tells the group to forget about a property path and no longer
			// update the array previously obtained with 'subscribe_'

			var indicesByPath = this._bindingsIndicesByPath,
				index = indicesByPath[ path ];

			if ( index !== undefined ) {

				var paths = this._paths,
					parsedPaths = this._parsedPaths,
					bindings = this._bindings,
					lastBindingsIndex = bindings.length - 1,
					lastBindings = bindings[ lastBindingsIndex ],
					lastBindingsPath = path[ lastBindingsIndex ];

				indicesByPath[ lastBindingsPath ] = index;

				bindings[ index ] = lastBindings;
				bindings.pop();

				parsedPaths[ index ] = parsedPaths[ lastBindingsIndex ];
				parsedPaths.pop();

				paths[ index ] = paths[ lastBindingsIndex ];
				paths.pop();

			}

		}

	} );

	/**
	 *
	 * Action provided by AnimationMixer for scheduling clip playback on specific
	 * objects.
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 *
	 */

	function AnimationAction( mixer, clip, localRoot ) {

		this._mixer = mixer;
		this._clip = clip;
		this._localRoot = localRoot || null;

		var tracks = clip.tracks,
			nTracks = tracks.length,
			interpolants = new Array( nTracks );

		var interpolantSettings = {
				endingStart: 	ZeroCurvatureEnding,
				endingEnd:		ZeroCurvatureEnding
		};

		for ( var i = 0; i !== nTracks; ++ i ) {

			var interpolant = tracks[ i ].createInterpolant( null );
			interpolants[ i ] = interpolant;
			interpolant.settings = interpolantSettings;

		}

		this._interpolantSettings = interpolantSettings;

		this._interpolants = interpolants;	// bound by the mixer

		// inside: PropertyMixer (managed by the mixer)
		this._propertyBindings = new Array( nTracks );

		this._cacheIndex = null;			// for the memory manager
		this._byClipCacheIndex = null;		// for the memory manager

		this._timeScaleInterpolant = null;
		this._weightInterpolant = null;

		this.loop = LoopRepeat;
		this._loopCount = -1;

		// global mixer time when the action is to be started
		// it's set back to 'null' upon start of the action
		this._startTime = null;

		// scaled local time of the action
		// gets clamped or wrapped to 0..clip.duration according to loop
		this.time = 0;

		this.timeScale = 1;
		this._effectiveTimeScale = 1;

		this.weight = 1;
		this._effectiveWeight = 1;

		this.repetitions = Infinity; 		// no. of repetitions when looping

		this.paused = false;				// true -> zero effective time scale
		this.enabled = true;				// false -> zero effective weight

		this.clampWhenFinished 	= false;	// keep feeding the last frame?

		this.zeroSlopeAtStart 	= true;		// for smooth interpolation w/o separate
		this.zeroSlopeAtEnd		= true;		// clips for start, loop and end

	}

	Object.assign( AnimationAction.prototype, {

		// State & Scheduling

		play: function() {

			this._mixer._activateAction( this );

			return this;

		},

		stop: function() {

			this._mixer._deactivateAction( this );

			return this.reset();

		},

		reset: function() {

			this.paused = false;
			this.enabled = true;

			this.time = 0;			// restart clip
			this._loopCount = -1;	// forget previous loops
			this._startTime = null;	// forget scheduling

			return this.stopFading().stopWarping();

		},

		isRunning: function() {

			return this.enabled && ! this.paused && this.timeScale !== 0 &&
					this._startTime === null && this._mixer._isActiveAction( this );

		},

		// return true when play has been called
		isScheduled: function() {

			return this._mixer._isActiveAction( this );

		},

		startAt: function( time ) {

			this._startTime = time;

			return this;

		},

		setLoop: function( mode, repetitions ) {

			this.loop = mode;
			this.repetitions = repetitions;

			return this;

		},

		// Weight

		// set the weight stopping any scheduled fading
		// although .enabled = false yields an effective weight of zero, this
		// method does *not* change .enabled, because it would be confusing
		setEffectiveWeight: function( weight ) {

			this.weight = weight;

			// note: same logic as when updated at runtime
			this._effectiveWeight = this.enabled ? weight : 0;

			return this.stopFading();

		},

		// return the weight considering fading and .enabled
		getEffectiveWeight: function() {

			return this._effectiveWeight;

		},

		fadeIn: function( duration ) {

			return this._scheduleFading( duration, 0, 1 );

		},

		fadeOut: function( duration ) {

			return this._scheduleFading( duration, 1, 0 );

		},

		crossFadeFrom: function( fadeOutAction, duration, warp ) {

			fadeOutAction.fadeOut( duration );
			this.fadeIn( duration );

			if( warp ) {

				var fadeInDuration = this._clip.duration,
					fadeOutDuration = fadeOutAction._clip.duration,

					startEndRatio = fadeOutDuration / fadeInDuration,
					endStartRatio = fadeInDuration / fadeOutDuration;

				fadeOutAction.warp( 1.0, startEndRatio, duration );
				this.warp( endStartRatio, 1.0, duration );

			}

			return this;

		},

		crossFadeTo: function( fadeInAction, duration, warp ) {

			return fadeInAction.crossFadeFrom( this, duration, warp );

		},

		stopFading: function() {

			var weightInterpolant = this._weightInterpolant;

			if ( weightInterpolant !== null ) {

				this._weightInterpolant = null;
				this._mixer._takeBackControlInterpolant( weightInterpolant );

			}

			return this;

		},

		// Time Scale Control

		// set the time scale stopping any scheduled warping
		// although .paused = true yields an effective time scale of zero, this
		// method does *not* change .paused, because it would be confusing
		setEffectiveTimeScale: function( timeScale ) {

			this.timeScale = timeScale;
			this._effectiveTimeScale = this.paused ? 0 :timeScale;

			return this.stopWarping();

		},

		// return the time scale considering warping and .paused
		getEffectiveTimeScale: function() {

			return this._effectiveTimeScale;

		},

		setDuration: function( duration ) {

			this.timeScale = this._clip.duration / duration;

			return this.stopWarping();

		},

		syncWith: function( action ) {

			this.time = action.time;
			this.timeScale = action.timeScale;

			return this.stopWarping();

		},

		halt: function( duration ) {

			return this.warp( this._effectiveTimeScale, 0, duration );

		},

		warp: function( startTimeScale, endTimeScale, duration ) {

			var mixer = this._mixer, now = mixer.time,
				interpolant = this._timeScaleInterpolant,

				timeScale = this.timeScale;

			if ( interpolant === null ) {

				interpolant = mixer._lendControlInterpolant();
				this._timeScaleInterpolant = interpolant;

			}

			var times = interpolant.parameterPositions,
				values = interpolant.sampleValues;

			times[ 0 ] = now;
			times[ 1 ] = now + duration;

			values[ 0 ] = startTimeScale / timeScale;
			values[ 1 ] = endTimeScale / timeScale;

			return this;

		},

		stopWarping: function() {

			var timeScaleInterpolant = this._timeScaleInterpolant;

			if ( timeScaleInterpolant !== null ) {

				this._timeScaleInterpolant = null;
				this._mixer._takeBackControlInterpolant( timeScaleInterpolant );

			}

			return this;

		},

		// Object Accessors

		getMixer: function() {

			return this._mixer;

		},

		getClip: function() {

			return this._clip;

		},

		getRoot: function() {

			return this._localRoot || this._mixer._root;

		},

		// Interna

		_update: function( time, deltaTime, timeDirection, accuIndex ) {

			// called by the mixer

			if ( ! this.enabled ) {

				// call ._updateWeight() to update ._effectiveWeight

				this._updateWeight( time );
				return;

			}

			var startTime = this._startTime;

			if ( startTime !== null ) {

				// check for scheduled start of action

				var timeRunning = ( time - startTime ) * timeDirection;
				if ( timeRunning < 0 || timeDirection === 0 ) {

					return; // yet to come / don't decide when delta = 0

				}

				// start

				this._startTime = null; // unschedule
				deltaTime = timeDirection * timeRunning;

			}

			// apply time scale and advance time

			deltaTime *= this._updateTimeScale( time );
			var clipTime = this._updateTime( deltaTime );

			// note: _updateTime may disable the action resulting in
			// an effective weight of 0

			var weight = this._updateWeight( time );

			if ( weight > 0 ) {

				var interpolants = this._interpolants;
				var propertyMixers = this._propertyBindings;

				for ( var j = 0, m = interpolants.length; j !== m; ++ j ) {

					interpolants[ j ].evaluate( clipTime );
					propertyMixers[ j ].accumulate( accuIndex, weight );

				}

			}

		},

		_updateWeight: function( time ) {

			var weight = 0;

			if ( this.enabled ) {

				weight = this.weight;
				var interpolant = this._weightInterpolant;

				if ( interpolant !== null ) {

					var interpolantValue = interpolant.evaluate( time )[ 0 ];

					weight *= interpolantValue;

					if ( time > interpolant.parameterPositions[ 1 ] ) {

						this.stopFading();

						if ( interpolantValue === 0 ) {

							// faded out, disable
							this.enabled = false;

						}

					}

				}

			}

			this._effectiveWeight = weight;
			return weight;

		},

		_updateTimeScale: function( time ) {

			var timeScale = 0;

			if ( ! this.paused ) {

				timeScale = this.timeScale;

				var interpolant = this._timeScaleInterpolant;

				if ( interpolant !== null ) {

					var interpolantValue = interpolant.evaluate( time )[ 0 ];

					timeScale *= interpolantValue;

					if ( time > interpolant.parameterPositions[ 1 ] ) {

						this.stopWarping();

						if ( timeScale === 0 ) {

							// motion has halted, pause
							this.paused = true;

						} else {

							// warp done - apply final time scale
							this.timeScale = timeScale;

						}

					}

				}

			}

			this._effectiveTimeScale = timeScale;
			return timeScale;

		},

		_updateTime: function( deltaTime ) {

			var time = this.time + deltaTime;

			if ( deltaTime === 0 ) return time;

			var duration = this._clip.duration,

				loop = this.loop,
				loopCount = this._loopCount;

			if ( loop === LoopOnce ) {

				if ( loopCount === -1 ) {
					// just started

					this._loopCount = 0;
					this._setEndings( true, true, false );

				}

				handle_stop: {

					if ( time >= duration ) {

						time = duration;

					} else if ( time < 0 ) {

						time = 0;

					} else break handle_stop;

					if ( this.clampWhenFinished ) this.paused = true;
					else this.enabled = false;

					this._mixer.dispatchEvent( {
						type: 'finished', action: this,
						direction: deltaTime < 0 ? -1 : 1
					} );

				}

			} else { // repetitive Repeat or PingPong

				var pingPong = ( loop === LoopPingPong );

				if ( loopCount === -1 ) {
					// just started

					if ( deltaTime >= 0 ) {

						loopCount = 0;

						this._setEndings(
								true, this.repetitions === 0, pingPong );

					} else {

						// when looping in reverse direction, the initial
						// transition through zero counts as a repetition,
						// so leave loopCount at -1

						this._setEndings(
								this.repetitions === 0, true, pingPong );

					}

				}

				if ( time >= duration || time < 0 ) {
					// wrap around

					var loopDelta = Math.floor( time / duration ); // signed
					time -= duration * loopDelta;

					loopCount += Math.abs( loopDelta );

					var pending = this.repetitions - loopCount;

					if ( pending < 0 ) {
						// have to stop (switch state, clamp time, fire event)

						if ( this.clampWhenFinished ) this.paused = true;
						else this.enabled = false;

						time = deltaTime > 0 ? duration : 0;

						this._mixer.dispatchEvent( {
							type: 'finished', action: this,
							direction: deltaTime > 0 ? 1 : -1
						} );

					} else {
						// keep running

						if ( pending === 0 ) {
							// entering the last round

							var atStart = deltaTime < 0;
							this._setEndings( atStart, ! atStart, pingPong );

						} else {

							this._setEndings( false, false, pingPong );

						}

						this._loopCount = loopCount;

						this._mixer.dispatchEvent( {
							type: 'loop', action: this, loopDelta: loopDelta
						} );

					}

				}

				if ( pingPong && ( loopCount & 1 ) === 1 ) {
					// invert time for the "pong round"

					this.time = time;
					return duration - time;

				}

			}

			this.time = time;
			return time;

		},

		_setEndings: function( atStart, atEnd, pingPong ) {

			var settings = this._interpolantSettings;

			if ( pingPong ) {

				settings.endingStart 	= ZeroSlopeEnding;
				settings.endingEnd		= ZeroSlopeEnding;

			} else {

				// assuming for LoopOnce atStart == atEnd == true

				if ( atStart ) {

					settings.endingStart = this.zeroSlopeAtStart ?
							ZeroSlopeEnding : ZeroCurvatureEnding;

				} else {

					settings.endingStart = WrapAroundEnding;

				}

				if ( atEnd ) {

					settings.endingEnd = this.zeroSlopeAtEnd ?
							ZeroSlopeEnding : ZeroCurvatureEnding;

				} else {

					settings.endingEnd 	 = WrapAroundEnding;

				}

			}

		},

		_scheduleFading: function( duration, weightNow, weightThen ) {

			var mixer = this._mixer, now = mixer.time,
				interpolant = this._weightInterpolant;

			if ( interpolant === null ) {

				interpolant = mixer._lendControlInterpolant();
				this._weightInterpolant = interpolant;

			}

			var times = interpolant.parameterPositions,
				values = interpolant.sampleValues;

			times[ 0 ] = now; 				values[ 0 ] = weightNow;
			times[ 1 ] = now + duration;	values[ 1 ] = weightThen;

			return this;

		}

	} );

	/**
	 *
	 * Player for AnimationClips.
	 *
	 *
	 * @author Ben Houston / http://clara.io/
	 * @author David Sarno / http://lighthaus.us/
	 * @author tschw
	 */

	function AnimationMixer( root ) {

		this._root = root;
		this._initMemoryManager();
		this._accuIndex = 0;

		this.time = 0;

		this.timeScale = 1.0;

	}

	Object.assign( AnimationMixer.prototype, EventDispatcher.prototype, {

		_bindAction: function ( action, prototypeAction ) {

			var root = action._localRoot || this._root,
				tracks = action._clip.tracks,
				nTracks = tracks.length,
				bindings = action._propertyBindings,
				interpolants = action._interpolants,
				rootUuid = root.uuid,
				bindingsByRoot = this._bindingsByRootAndName,
				bindingsByName = bindingsByRoot[ rootUuid ];

			if ( bindingsByName === undefined ) {

				bindingsByName = {};
				bindingsByRoot[ rootUuid ] = bindingsByName;

			}

			for ( var i = 0; i !== nTracks; ++ i ) {

				var track = tracks[ i ],
					trackName = track.name,
					binding = bindingsByName[ trackName ];

				if ( binding !== undefined ) {

					bindings[ i ] = binding;

				} else {

					binding = bindings[ i ];

					if ( binding !== undefined ) {

						// existing binding, make sure the cache knows

						if ( binding._cacheIndex === null ) {

							++ binding.referenceCount;
							this._addInactiveBinding( binding, rootUuid, trackName );

						}

						continue;

					}

					var path = prototypeAction && prototypeAction.
							_propertyBindings[ i ].binding.parsedPath;

					binding = new PropertyMixer(
						PropertyBinding.create( root, trackName, path ),
						track.ValueTypeName, track.getValueSize() );

					++ binding.referenceCount;
					this._addInactiveBinding( binding, rootUuid, trackName );

					bindings[ i ] = binding;

				}

				interpolants[ i ].resultBuffer = binding.buffer;

			}

		},

		_activateAction: function ( action ) {

			if ( ! this._isActiveAction( action ) ) {

				if ( action._cacheIndex === null ) {

					// this action has been forgotten by the cache, but the user
					// appears to be still using it -> rebind

					var rootUuid = ( action._localRoot || this._root ).uuid,
						clipUuid = action._clip.uuid,
						actionsForClip = this._actionsByClip[ clipUuid ];

					this._bindAction( action,
						actionsForClip && actionsForClip.knownActions[ 0 ] );

					this._addInactiveAction( action, clipUuid, rootUuid );

				}

				var bindings = action._propertyBindings;

				// increment reference counts / sort out state
				for ( var i = 0, n = bindings.length; i !== n; ++ i ) {

					var binding = bindings[ i ];

					if ( binding.useCount ++ === 0 ) {

						this._lendBinding( binding );
						binding.saveOriginalState();

					}

				}

				this._lendAction( action );

			}

		},

		_deactivateAction: function ( action ) {

			if ( this._isActiveAction( action ) ) {

				var bindings = action._propertyBindings;

				// decrement reference counts / sort out state
				for ( var i = 0, n = bindings.length; i !== n; ++ i ) {

					var binding = bindings[ i ];

					if ( -- binding.useCount === 0 ) {

						binding.restoreOriginalState();
						this._takeBackBinding( binding );

					}

				}

				this._takeBackAction( action );

			}

		},

		// Memory manager

		_initMemoryManager: function () {

			this._actions = []; // 'nActiveActions' followed by inactive ones
			this._nActiveActions = 0;

			this._actionsByClip = {};
			// inside:
			// {
			// 		knownActions: Array< AnimationAction >	- used as prototypes
			// 		actionByRoot: AnimationAction			- lookup
			// }


			this._bindings = []; // 'nActiveBindings' followed by inactive ones
			this._nActiveBindings = 0;

			this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >


			this._controlInterpolants = []; // same game as above
			this._nActiveControlInterpolants = 0;

			var scope = this;

			this.stats = {

				actions: {
					get total() { return scope._actions.length; },
					get inUse() { return scope._nActiveActions; }
				},
				bindings: {
					get total() { return scope._bindings.length; },
					get inUse() { return scope._nActiveBindings; }
				},
				controlInterpolants: {
					get total() { return scope._controlInterpolants.length; },
					get inUse() { return scope._nActiveControlInterpolants; }
				}

			};

		},

		// Memory management for AnimationAction objects

		_isActiveAction: function ( action ) {

			var index = action._cacheIndex;
			return index !== null && index < this._nActiveActions;

		},

		_addInactiveAction: function ( action, clipUuid, rootUuid ) {

			var actions = this._actions,
				actionsByClip = this._actionsByClip,
				actionsForClip = actionsByClip[ clipUuid ];

			if ( actionsForClip === undefined ) {

				actionsForClip = {

					knownActions: [ action ],
					actionByRoot: {}

				};

				action._byClipCacheIndex = 0;

				actionsByClip[ clipUuid ] = actionsForClip;

			} else {

				var knownActions = actionsForClip.knownActions;

				action._byClipCacheIndex = knownActions.length;
				knownActions.push( action );

			}

			action._cacheIndex = actions.length;
			actions.push( action );

			actionsForClip.actionByRoot[ rootUuid ] = action;

		},

		_removeInactiveAction: function ( action ) {

			var actions = this._actions,
				lastInactiveAction = actions[ actions.length - 1 ],
				cacheIndex = action._cacheIndex;

			lastInactiveAction._cacheIndex = cacheIndex;
			actions[ cacheIndex ] = lastInactiveAction;
			actions.pop();

			action._cacheIndex = null;


			var clipUuid = action._clip.uuid,
				actionsByClip = this._actionsByClip,
				actionsForClip = actionsByClip[ clipUuid ],
				knownActionsForClip = actionsForClip.knownActions,

				lastKnownAction =
					knownActionsForClip[ knownActionsForClip.length - 1 ],

				byClipCacheIndex = action._byClipCacheIndex;

			lastKnownAction._byClipCacheIndex = byClipCacheIndex;
			knownActionsForClip[ byClipCacheIndex ] = lastKnownAction;
			knownActionsForClip.pop();

			action._byClipCacheIndex = null;


			var actionByRoot = actionsForClip.actionByRoot,
				rootUuid = ( action._localRoot || this._root ).uuid;

			delete actionByRoot[ rootUuid ];

			if ( knownActionsForClip.length === 0 ) {

				delete actionsByClip[ clipUuid ];

			}

			this._removeInactiveBindingsForAction( action );

		},

		_removeInactiveBindingsForAction: function ( action ) {

			var bindings = action._propertyBindings;
			for ( var i = 0, n = bindings.length; i !== n; ++ i ) {

				var binding = bindings[ i ];

				if ( -- binding.referenceCount === 0 ) {

					this._removeInactiveBinding( binding );

				}

			}

		},

		_lendAction: function ( action ) {

			// [ active actions |  inactive actions  ]
			// [  active actions >| inactive actions ]
			//                 s        a
			//                  <-swap->
			//                 a        s

			var actions = this._actions,
				prevIndex = action._cacheIndex,

				lastActiveIndex = this._nActiveActions ++,

				firstInactiveAction = actions[ lastActiveIndex ];

			action._cacheIndex = lastActiveIndex;
			actions[ lastActiveIndex ] = action;

			firstInactiveAction._cacheIndex = prevIndex;
			actions[ prevIndex ] = firstInactiveAction;

		},

		_takeBackAction: function ( action ) {

			// [  active actions  | inactive actions ]
			// [ active actions |< inactive actions  ]
			//        a        s
			//         <-swap->
			//        s        a

			var actions = this._actions,
				prevIndex = action._cacheIndex,

				firstInactiveIndex = -- this._nActiveActions,

				lastActiveAction = actions[ firstInactiveIndex ];

			action._cacheIndex = firstInactiveIndex;
			actions[ firstInactiveIndex ] = action;

			lastActiveAction._cacheIndex = prevIndex;
			actions[ prevIndex ] = lastActiveAction;

		},

		// Memory management for PropertyMixer objects

		_addInactiveBinding: function ( binding, rootUuid, trackName ) {

			var bindingsByRoot = this._bindingsByRootAndName,
				bindingByName = bindingsByRoot[ rootUuid ],

				bindings = this._bindings;

			if ( bindingByName === undefined ) {

				bindingByName = {};
				bindingsByRoot[ rootUuid ] = bindingByName;

			}

			bindingByName[ trackName ] = binding;

			binding._cacheIndex = bindings.length;
			bindings.push( binding );

		},

		_removeInactiveBinding: function ( binding ) {

			var bindings = this._bindings,
				propBinding = binding.binding,
				rootUuid = propBinding.rootNode.uuid,
				trackName = propBinding.path,
				bindingsByRoot = this._bindingsByRootAndName,
				bindingByName = bindingsByRoot[ rootUuid ],

				lastInactiveBinding = bindings[ bindings.length - 1 ],
				cacheIndex = binding._cacheIndex;

			lastInactiveBinding._cacheIndex = cacheIndex;
			bindings[ cacheIndex ] = lastInactiveBinding;
			bindings.pop();

			delete bindingByName[ trackName ];

			remove_empty_map: {

				for ( var _ in bindingByName ) break remove_empty_map;

				delete bindingsByRoot[ rootUuid ];

			}

		},

		_lendBinding: function ( binding ) {

			var bindings = this._bindings,
				prevIndex = binding._cacheIndex,

				lastActiveIndex = this._nActiveBindings ++,

				firstInactiveBinding = bindings[ lastActiveIndex ];

			binding._cacheIndex = lastActiveIndex;
			bindings[ lastActiveIndex ] = binding;

			firstInactiveBinding._cacheIndex = prevIndex;
			bindings[ prevIndex ] = firstInactiveBinding;

		},

		_takeBackBinding: function ( binding ) {

			var bindings = this._bindings,
				prevIndex = binding._cacheIndex,

				firstInactiveIndex = -- this._nActiveBindings,

				lastActiveBinding = bindings[ firstInactiveIndex ];

			binding._cacheIndex = firstInactiveIndex;
			bindings[ firstInactiveIndex ] = binding;

			lastActiveBinding._cacheIndex = prevIndex;
			bindings[ prevIndex ] = lastActiveBinding;

		},


		// Memory management of Interpolants for weight and time scale

		_lendControlInterpolant: function () {

			var interpolants = this._controlInterpolants,
				lastActiveIndex = this._nActiveControlInterpolants ++,
				interpolant = interpolants[ lastActiveIndex ];

			if ( interpolant === undefined ) {

				interpolant = new LinearInterpolant(
					new Float32Array( 2 ), new Float32Array( 2 ),
					1, this._controlInterpolantsResultBuffer );

				interpolant.__cacheIndex = lastActiveIndex;
				interpolants[ lastActiveIndex ] = interpolant;

			}

			return interpolant;

		},

		_takeBackControlInterpolant: function ( interpolant ) {

			var interpolants = this._controlInterpolants,
				prevIndex = interpolant.__cacheIndex,

				firstInactiveIndex = -- this._nActiveControlInterpolants,

				lastActiveInterpolant = interpolants[ firstInactiveIndex ];

			interpolant.__cacheIndex = firstInactiveIndex;
			interpolants[ firstInactiveIndex ] = interpolant;

			lastActiveInterpolant.__cacheIndex = prevIndex;
			interpolants[ prevIndex ] = lastActiveInterpolant;

		},

		_controlInterpolantsResultBuffer: new Float32Array( 1 ),

		// return an action for a clip optionally using a custom root target
		// object (this method allocates a lot of dynamic memory in case a
		// previously unknown clip/root combination is specified)
		clipAction: function ( clip, optionalRoot ) {

			var root = optionalRoot || this._root,
				rootUuid = root.uuid,

				clipObject = typeof clip === 'string' ?
					AnimationClip.findByName( root, clip ) : clip,

				clipUuid = clipObject !== null ? clipObject.uuid : clip,

				actionsForClip = this._actionsByClip[ clipUuid ],
				prototypeAction = null;

			if ( actionsForClip !== undefined ) {

				var existingAction =
						actionsForClip.actionByRoot[ rootUuid ];

				if ( existingAction !== undefined ) {

					return existingAction;

				}

				// we know the clip, so we don't have to parse all
				// the bindings again but can just copy
				prototypeAction = actionsForClip.knownActions[ 0 ];

				// also, take the clip from the prototype action
				if ( clipObject === null )
					clipObject = prototypeAction._clip;

			}

			// clip must be known when specified via string
			if ( clipObject === null ) return null;

			// allocate all resources required to run it
			var newAction = new AnimationAction( this, clipObject, optionalRoot );

			this._bindAction( newAction, prototypeAction );

			// and make the action known to the memory manager
			this._addInactiveAction( newAction, clipUuid, rootUuid );

			return newAction;

		},

		// get an existing action
		existingAction: function ( clip, optionalRoot ) {

			var root = optionalRoot || this._root,
				rootUuid = root.uuid,

				clipObject = typeof clip === 'string' ?
					AnimationClip.findByName( root, clip ) : clip,

				clipUuid = clipObject ? clipObject.uuid : clip,

				actionsForClip = this._actionsByClip[ clipUuid ];

			if ( actionsForClip !== undefined ) {

				return actionsForClip.actionByRoot[ rootUuid ] || null;

			}

			return null;

		},

		// deactivates all previously scheduled actions
		stopAllAction: function () {

			var actions = this._actions,
				nActions = this._nActiveActions,
				bindings = this._bindings,
				nBindings = this._nActiveBindings;

			this._nActiveActions = 0;
			this._nActiveBindings = 0;

			for ( var i = 0; i !== nActions; ++ i ) {

				actions[ i ].reset();

			}

			for ( var i = 0; i !== nBindings; ++ i ) {

				bindings[ i ].useCount = 0;

			}

			return this;

		},

		// advance the time and update apply the animation
		update: function ( deltaTime ) {

			deltaTime *= this.timeScale;

			var actions = this._actions,
				nActions = this._nActiveActions,

				time = this.time += deltaTime,
				timeDirection = Math.sign( deltaTime ),

				accuIndex = this._accuIndex ^= 1;

			// run active actions

			for ( var i = 0; i !== nActions; ++ i ) {

				var action = actions[ i ];

				action._update( time, deltaTime, timeDirection, accuIndex );

			}

			// update scene graph

			var bindings = this._bindings,
				nBindings = this._nActiveBindings;

			for ( var i = 0; i !== nBindings; ++ i ) {

				bindings[ i ].apply( accuIndex );

			}

			return this;

		},

		// return this mixer's root target object
		getRoot: function () {

			return this._root;

		},

		// free all resources specific to a particular clip
		uncacheClip: function ( clip ) {

			var actions = this._actions,
				clipUuid = clip.uuid,
				actionsByClip = this._actionsByClip,
				actionsForClip = actionsByClip[ clipUuid ];

			if ( actionsForClip !== undefined ) {

				// note: just calling _removeInactiveAction would mess up the
				// iteration state and also require updating the state we can
				// just throw away

				var actionsToRemove = actionsForClip.knownActions;

				for ( var i = 0, n = actionsToRemove.length; i !== n; ++ i ) {

					var action = actionsToRemove[ i ];

					this._deactivateAction( action );

					var cacheIndex = action._cacheIndex,
						lastInactiveAction = actions[ actions.length - 1 ];

					action._cacheIndex = null;
					action._byClipCacheIndex = null;

					lastInactiveAction._cacheIndex = cacheIndex;
					actions[ cacheIndex ] = lastInactiveAction;
					actions.pop();

					this._removeInactiveBindingsForAction( action );

				}

				delete actionsByClip[ clipUuid ];

			}

		},

		// free all resources specific to a particular root target object
		uncacheRoot: function ( root ) {

			var rootUuid = root.uuid,
				actionsByClip = this._actionsByClip;

			for ( var clipUuid in actionsByClip ) {

				var actionByRoot = actionsByClip[ clipUuid ].actionByRoot,
					action = actionByRoot[ rootUuid ];

				if ( action !== undefined ) {

					this._deactivateAction( action );
					this._removeInactiveAction( action );

				}

			}

			var bindingsByRoot = this._bindingsByRootAndName,
				bindingByName = bindingsByRoot[ rootUuid ];

			if ( bindingByName !== undefined ) {

				for ( var trackName in bindingByName ) {

					var binding = bindingByName[ trackName ];
					binding.restoreOriginalState();
					this._removeInactiveBinding( binding );

				}

			}

		},

		// remove a targeted clip from the cache
		uncacheAction: function ( clip, optionalRoot ) {

			var action = this.existingAction( clip, optionalRoot );

			if ( action !== null ) {

				this._deactivateAction( action );
				this._removeInactiveAction( action );

			}

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function Uniform( value ) {

		if ( typeof value === 'string' ) {

			console.warn( 'THREE.Uniform: Type parameter is no longer needed.' );
			value = arguments[ 1 ];

		}

		this.value = value;

	}

	Uniform.prototype.clone = function () {

		return new Uniform( this.value.clone === undefined ? this.value : this.value.clone() );

	};

	/**
	 * @author benaadams / https://twitter.com/ben_a_adams
	 */

	function InstancedBufferGeometry() {

		BufferGeometry.call( this );

		this.type = 'InstancedBufferGeometry';
		this.maxInstancedCount = undefined;

	}

	InstancedBufferGeometry.prototype = Object.assign( Object.create( BufferGeometry.prototype ), {

		constructor: InstancedBufferGeometry,

		isInstancedBufferGeometry: true,

		addGroup: function ( start, count, materialIndex ) {

			this.groups.push( {

				start: start,
				count: count,
				materialIndex: materialIndex

			} );

		},

		copy: function ( source ) {

			var index = source.index;

			if ( index !== null ) {

				this.setIndex( index.clone() );

			}

			var attributes = source.attributes;

			for ( var name in attributes ) {

				var attribute = attributes[ name ];
				this.addAttribute( name, attribute.clone() );

			}

			var groups = source.groups;

			for ( var i = 0, l = groups.length; i < l; i ++ ) {

				var group = groups[ i ];
				this.addGroup( group.start, group.count, group.materialIndex );

			}

			return this;

		}

	} );

	/**
	 * @author benaadams / https://twitter.com/ben_a_adams
	 */

	function InterleavedBufferAttribute( interleavedBuffer, itemSize, offset, normalized ) {

		this.uuid = _Math.generateUUID();

		this.data = interleavedBuffer;
		this.itemSize = itemSize;
		this.offset = offset;

		this.normalized = normalized === true;

	}

	Object.defineProperties( InterleavedBufferAttribute.prototype, {

		count: {

			get: function () {

				return this.data.count;

			}

		},

		array: {

			get: function () {

				return this.data.array;

			}

		}

	} );

	Object.assign( InterleavedBufferAttribute.prototype, {

		isInterleavedBufferAttribute: true,

		setX: function ( index, x ) {

			this.data.array[ index * this.data.stride + this.offset ] = x;

			return this;

		},

		setY: function ( index, y ) {

			this.data.array[ index * this.data.stride + this.offset + 1 ] = y;

			return this;

		},

		setZ: function ( index, z ) {

			this.data.array[ index * this.data.stride + this.offset + 2 ] = z;

			return this;

		},

		setW: function ( index, w ) {

			this.data.array[ index * this.data.stride + this.offset + 3 ] = w;

			return this;

		},

		getX: function ( index ) {

			return this.data.array[ index * this.data.stride + this.offset ];

		},

		getY: function ( index ) {

			return this.data.array[ index * this.data.stride + this.offset + 1 ];

		},

		getZ: function ( index ) {

			return this.data.array[ index * this.data.stride + this.offset + 2 ];

		},

		getW: function ( index ) {

			return this.data.array[ index * this.data.stride + this.offset + 3 ];

		},

		setXY: function ( index, x, y ) {

			index = index * this.data.stride + this.offset;

			this.data.array[ index + 0 ] = x;
			this.data.array[ index + 1 ] = y;

			return this;

		},

		setXYZ: function ( index, x, y, z ) {

			index = index * this.data.stride + this.offset;

			this.data.array[ index + 0 ] = x;
			this.data.array[ index + 1 ] = y;
			this.data.array[ index + 2 ] = z;

			return this;

		},

		setXYZW: function ( index, x, y, z, w ) {

			index = index * this.data.stride + this.offset;

			this.data.array[ index + 0 ] = x;
			this.data.array[ index + 1 ] = y;
			this.data.array[ index + 2 ] = z;
			this.data.array[ index + 3 ] = w;

			return this;

		}

	} );

	/**
	 * @author benaadams / https://twitter.com/ben_a_adams
	 */

	function InterleavedBuffer( array, stride ) {

		this.uuid = _Math.generateUUID();

		this.array = array;
		this.stride = stride;
		this.count = array !== undefined ? array.length / stride : 0;

		this.dynamic = false;
		this.updateRange = { offset: 0, count: - 1 };

		this.onUploadCallback = function () {};

		this.version = 0;

	}

	Object.defineProperty( InterleavedBuffer.prototype, 'needsUpdate', {

		set: function ( value ) {

			if ( value === true ) this.version ++;

		}

	} );

	Object.assign( InterleavedBuffer.prototype, {

		isInterleavedBuffer: true,

		setArray: function ( array ) {

			if ( Array.isArray( array ) ) {

				throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );

			}

			this.count = array !== undefined ? array.length / this.stride : 0;
			this.array = array;

		},

		setDynamic: function ( value ) {

			this.dynamic = value;

			return this;

		},

		copy: function ( source ) {

			this.array = new source.array.constructor( source.array );
			this.count = source.count;
			this.stride = source.stride;
			this.dynamic = source.dynamic;

			return this;

		},

		copyAt: function ( index1, attribute, index2 ) {

			index1 *= this.stride;
			index2 *= attribute.stride;

			for ( var i = 0, l = this.stride; i < l; i ++ ) {

				this.array[ index1 + i ] = attribute.array[ index2 + i ];

			}

			return this;

		},

		set: function ( value, offset ) {

			if ( offset === undefined ) offset = 0;

			this.array.set( value, offset );

			return this;

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		onUpload: function ( callback ) {

			this.onUploadCallback = callback;

			return this;

		}

	} );

	/**
	 * @author benaadams / https://twitter.com/ben_a_adams
	 */

	function InstancedInterleavedBuffer( array, stride, meshPerAttribute ) {

		InterleavedBuffer.call( this, array, stride );

		this.meshPerAttribute = meshPerAttribute || 1;

	}

	InstancedInterleavedBuffer.prototype = Object.assign( Object.create( InterleavedBuffer.prototype ), {

		constructor: InstancedInterleavedBuffer,

		isInstancedInterleavedBuffer: true,

		copy: function ( source ) {

			InterleavedBuffer.prototype.copy.call( this, source );

			this.meshPerAttribute = source.meshPerAttribute;

			return this;

		}

	} );

	/**
	 * @author benaadams / https://twitter.com/ben_a_adams
	 */

	function InstancedBufferAttribute( array, itemSize, meshPerAttribute ) {

		BufferAttribute.call( this, array, itemSize );

		this.meshPerAttribute = meshPerAttribute || 1;

	}

	InstancedBufferAttribute.prototype = Object.assign( Object.create( BufferAttribute.prototype ), {

		constructor: InstancedBufferAttribute,

		isInstancedBufferAttribute: true,

		copy: function ( source ) {

			BufferAttribute.prototype.copy.call( this, source );

			this.meshPerAttribute = source.meshPerAttribute;

			return this;

		}

	} );

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author bhouston / http://clara.io/
	 * @author stephomi / http://stephaneginier.com/
	 */

	function Raycaster( origin, direction, near, far ) {

		this.ray = new Ray( origin, direction );
		// direction is assumed to be normalized (for accurate distance calculations)

		this.near = near || 0;
		this.far = far || Infinity;

		this.params = {
			Mesh: {},
			Line: {},
			LOD: {},
			Points: { threshold: 1 },
			Sprite: {}
		};

		Object.defineProperties( this.params, {
			PointCloud: {
				get: function () {
					console.warn( 'THREE.Raycaster: params.PointCloud has been renamed to params.Points.' );
					return this.Points;
				}
			}
		} );

	}

	function ascSort( a, b ) {

		return a.distance - b.distance;

	}

	function intersectObject( object, raycaster, intersects, recursive ) {

		if ( object.visible === false ) return;

		object.raycast( raycaster, intersects );

		if ( recursive === true ) {

			var children = object.children;

			for ( var i = 0, l = children.length; i < l; i ++ ) {

				intersectObject( children[ i ], raycaster, intersects, true );

			}

		}

	}

	Object.assign( Raycaster.prototype, {

		linePrecision: 1,

		set: function ( origin, direction ) {

			// direction is assumed to be normalized (for accurate distance calculations)

			this.ray.set( origin, direction );

		},

		setFromCamera: function ( coords, camera ) {

			if ( ( camera && camera.isPerspectiveCamera ) ) {

				this.ray.origin.setFromMatrixPosition( camera.matrixWorld );
				this.ray.direction.set( coords.x, coords.y, 0.5 ).unproject( camera ).sub( this.ray.origin ).normalize();

			} else if ( ( camera && camera.isOrthographicCamera ) ) {

				this.ray.origin.set( coords.x, coords.y, ( camera.near + camera.far ) / ( camera.near - camera.far ) ).unproject( camera ); // set origin in plane of camera
				this.ray.direction.set( 0, 0, - 1 ).transformDirection( camera.matrixWorld );

			} else {

				console.error( 'THREE.Raycaster: Unsupported camera type.' );

			}

		},

		intersectObject: function ( object, recursive ) {

			var intersects = [];

			intersectObject( object, this, intersects, recursive );

			intersects.sort( ascSort );

			return intersects;

		},

		intersectObjects: function ( objects, recursive ) {

			var intersects = [];

			if ( Array.isArray( objects ) === false ) {

				console.warn( 'THREE.Raycaster.intersectObjects: objects is not an Array.' );
				return intersects;

			}

			for ( var i = 0, l = objects.length; i < l; i ++ ) {

				intersectObject( objects[ i ], this, intersects, recursive );

			}

			intersects.sort( ascSort );

			return intersects;

		}

	} );

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	function Clock( autoStart ) {

		this.autoStart = ( autoStart !== undefined ) ? autoStart : true;

		this.startTime = 0;
		this.oldTime = 0;
		this.elapsedTime = 0;

		this.running = false;

	}

	Object.assign( Clock.prototype, {

		start: function () {

			this.startTime = ( typeof performance === 'undefined' ? Date : performance ).now(); // see #10732

			this.oldTime = this.startTime;
			this.elapsedTime = 0;
			this.running = true;

		},

		stop: function () {

			this.getElapsedTime();
			this.running = false;
			this.autoStart = false;

		},

		getElapsedTime: function () {

			this.getDelta();
			return this.elapsedTime;

		},

		getDelta: function () {

			var diff = 0;

			if ( this.autoStart && ! this.running ) {

				this.start();
				return 0;

			}

			if ( this.running ) {

				var newTime = ( typeof performance === 'undefined' ? Date : performance ).now();

				diff = ( newTime - this.oldTime ) / 1000;
				this.oldTime = newTime;

				this.elapsedTime += diff;

			}

			return diff;

		}

	} );

	/**
	 * @author bhouston / http://clara.io
	 * @author WestLangley / http://github.com/WestLangley
	 *
	 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
	 *
	 * The poles (phi) are at the positive and negative y axis.
	 * The equator starts at positive z.
	 */

	function Spherical( radius, phi, theta ) {

		this.radius = ( radius !== undefined ) ? radius : 1.0;
		this.phi = ( phi !== undefined ) ? phi : 0; // up / down towards top and bottom pole
		this.theta = ( theta !== undefined ) ? theta : 0; // around the equator of the sphere

		return this;

	}

	Object.assign( Spherical.prototype, {

		set: function ( radius, phi, theta ) {

			this.radius = radius;
			this.phi = phi;
			this.theta = theta;

			return this;

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( other ) {

			this.radius = other.radius;
			this.phi = other.phi;
			this.theta = other.theta;

			return this;

		},

		// restrict phi to be betwee EPS and PI-EPS
		makeSafe: function() {

			var EPS = 0.000001;
			this.phi = Math.max( EPS, Math.min( Math.PI - EPS, this.phi ) );

			return this;

		},

		setFromVector3: function( vec3 ) {

			this.radius = vec3.length();

			if ( this.radius === 0 ) {

				this.theta = 0;
				this.phi = 0;

			} else {

				this.theta = Math.atan2( vec3.x, vec3.z ); // equator angle around y-up axis
				this.phi = Math.acos( _Math.clamp( vec3.y / this.radius, - 1, 1 ) ); // polar angle

			}

			return this;

		}

	} );

	/**
	 * @author Mugen87 / https://github.com/Mugen87
	 *
	 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
	 *
	 */

	function Cylindrical( radius, theta, y ) {

		this.radius = ( radius !== undefined ) ? radius : 1.0; // distance from the origin to a point in the x-z plane
		this.theta = ( theta !== undefined ) ? theta : 0; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
		this.y = ( y !== undefined ) ? y : 0; // height above the x-z plane

		return this;

	}

	Object.assign( Cylindrical.prototype, {

		set: function ( radius, theta, y ) {

			this.radius = radius;
			this.theta = theta;
			this.y = y;

			return this;

		},

		clone: function () {

			return new this.constructor().copy( this );

		},

		copy: function ( other ) {

			this.radius = other.radius;
			this.theta = other.theta;
			this.y = other.y;

			return this;

		},

		setFromVector3: function( vec3 ) {

			this.radius = Math.sqrt( vec3.x * vec3.x + vec3.z * vec3.z );
			this.theta = Math.atan2( vec3.x, vec3.z );
			this.y = vec3.y;

			return this;

		}

	} );

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	function ImmediateRenderObject( material ) {

		Object3D.call( this );

		this.material = material;
		this.render = function ( renderCallback ) {};

	}

	ImmediateRenderObject.prototype = Object.create( Object3D.prototype );
	ImmediateRenderObject.prototype.constructor = ImmediateRenderObject;

	ImmediateRenderObject.prototype.isImmediateRenderObject = true;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author WestLangley / http://github.com/WestLangley
	 */

	function VertexNormalsHelper( object, size, hex, linewidth ) {

		this.object = object;

		this.size = ( size !== undefined ) ? size : 1;

		var color = ( hex !== undefined ) ? hex : 0xff0000;

		var width = ( linewidth !== undefined ) ? linewidth : 1;

		//

		var nNormals = 0;

		var objGeometry = this.object.geometry;

		if ( objGeometry && objGeometry.isGeometry ) {

			nNormals = objGeometry.faces.length * 3;

		} else if ( objGeometry && objGeometry.isBufferGeometry ) {

			nNormals = objGeometry.attributes.normal.count;

		}

		//

		var geometry = new BufferGeometry();

		var positions = new Float32BufferAttribute( nNormals * 2 * 3, 3 );

		geometry.addAttribute( 'position', positions );

		LineSegments.call( this, geometry, new LineBasicMaterial( { color: color, linewidth: width } ) );

		//

		this.matrixAutoUpdate = false;

		this.update();

	}

	VertexNormalsHelper.prototype = Object.create( LineSegments.prototype );
	VertexNormalsHelper.prototype.constructor = VertexNormalsHelper;

	VertexNormalsHelper.prototype.update = ( function () {

		var v1 = new Vector3();
		var v2 = new Vector3();
		var normalMatrix = new Matrix3();

		return function update() {

			var keys = [ 'a', 'b', 'c' ];

			this.object.updateMatrixWorld( true );

			normalMatrix.getNormalMatrix( this.object.matrixWorld );

			var matrixWorld = this.object.matrixWorld;

			var position = this.geometry.attributes.position;

			//

			var objGeometry = this.object.geometry;

			if ( objGeometry && objGeometry.isGeometry ) {

				var vertices = objGeometry.vertices;

				var faces = objGeometry.faces;

				var idx = 0;

				for ( var i = 0, l = faces.length; i < l; i ++ ) {

					var face = faces[ i ];

					for ( var j = 0, jl = face.vertexNormals.length; j < jl; j ++ ) {

						var vertex = vertices[ face[ keys[ j ] ] ];

						var normal = face.vertexNormals[ j ];

						v1.copy( vertex ).applyMatrix4( matrixWorld );

						v2.copy( normal ).applyMatrix3( normalMatrix ).normalize().multiplyScalar( this.size ).add( v1 );

						position.setXYZ( idx, v1.x, v1.y, v1.z );

						idx = idx + 1;

						position.setXYZ( idx, v2.x, v2.y, v2.z );

						idx = idx + 1;

					}

				}

			} else if ( objGeometry && objGeometry.isBufferGeometry ) {

				var objPos = objGeometry.attributes.position;

				var objNorm = objGeometry.attributes.normal;

				var idx = 0;

				// for simplicity, ignore index and drawcalls, and render every normal

				for ( var j = 0, jl = objPos.count; j < jl; j ++ ) {

					v1.set( objPos.getX( j ), objPos.getY( j ), objPos.getZ( j ) ).applyMatrix4( matrixWorld );

					v2.set( objNorm.getX( j ), objNorm.getY( j ), objNorm.getZ( j ) );

					v2.applyMatrix3( normalMatrix ).normalize().multiplyScalar( this.size ).add( v1 );

					position.setXYZ( idx, v1.x, v1.y, v1.z );

					idx = idx + 1;

					position.setXYZ( idx, v2.x, v2.y, v2.z );

					idx = idx + 1;

				}

			}

			position.needsUpdate = true;

		};

	}() );

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author mrdoob / http://mrdoob.com/
	 * @author WestLangley / http://github.com/WestLangley
	 */

	function SpotLightHelper( light, color ) {

		Object3D.call( this );

		this.light = light;
		this.light.updateMatrixWorld();

		this.matrix = light.matrixWorld;
		this.matrixAutoUpdate = false;

		this.color = color;

		var geometry = new BufferGeometry();

		var positions = [
			0, 0, 0,   0,   0,   1,
			0, 0, 0,   1,   0,   1,
			0, 0, 0, - 1,   0,   1,
			0, 0, 0,   0,   1,   1,
			0, 0, 0,   0, - 1,   1
		];

		for ( var i = 0, j = 1, l = 32; i < l; i ++, j ++ ) {

			var p1 = ( i / l ) * Math.PI * 2;
			var p2 = ( j / l ) * Math.PI * 2;

			positions.push(
				Math.cos( p1 ), Math.sin( p1 ), 1,
				Math.cos( p2 ), Math.sin( p2 ), 1
			);

		}

		geometry.addAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );

		var material = new LineBasicMaterial( { fog: false } );

		this.cone = new LineSegments( geometry, material );
		this.add( this.cone );

		this.update();

	}

	SpotLightHelper.prototype = Object.create( Object3D.prototype );
	SpotLightHelper.prototype.constructor = SpotLightHelper;

	SpotLightHelper.prototype.dispose = function () {

		this.cone.geometry.dispose();
		this.cone.material.dispose();

	};

	SpotLightHelper.prototype.update = function () {

		var vector = new Vector3();
		var vector2 = new Vector3();

		return function update() {

			this.light.updateMatrixWorld();

			var coneLength = this.light.distance ? this.light.distance : 1000;
			var coneWidth = coneLength * Math.tan( this.light.angle );

			this.cone.scale.set( coneWidth, coneWidth, coneLength );

			vector.setFromMatrixPosition( this.light.matrixWorld );
			vector2.setFromMatrixPosition( this.light.target.matrixWorld );

			this.cone.lookAt( vector2.sub( vector ) );

			if ( this.color !== undefined ) {

				this.cone.material.color.set( this.color );

			} else {

				this.cone.material.color.copy( this.light.color );

			}

		};

	}();

	/**
	 * @author Sean Griffin / http://twitter.com/sgrif
	 * @author Michael Guerrero / http://realitymeltdown.com
	 * @author mrdoob / http://mrdoob.com/
	 * @author ikerr / http://verold.com
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	function getBoneList( object ) {

		var boneList = [];

		if ( object && object.isBone ) {

			boneList.push( object );

		}

		for ( var i = 0; i < object.children.length; i ++ ) {

			boneList.push.apply( boneList, getBoneList( object.children[ i ] ) );

		}

		return boneList;

	}

	function SkeletonHelper( object ) {

		var bones = getBoneList( object );

		var geometry = new BufferGeometry();

		var vertices = [];
		var colors = [];

		var color1 = new Color( 0, 0, 1 );
		var color2 = new Color( 0, 1, 0 );

		for ( var i = 0; i < bones.length; i ++ ) {

			var bone = bones[ i ];

			if ( bone.parent && bone.parent.isBone ) {

				vertices.push( 0, 0, 0 );
				vertices.push( 0, 0, 0 );
				colors.push( color1.r, color1.g, color1.b );
				colors.push( color2.r, color2.g, color2.b );

			}

		}

		geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

		var material = new LineBasicMaterial( { vertexColors: VertexColors, depthTest: false, depthWrite: false, transparent: true } );

		LineSegments.call( this, geometry, material );

		this.root = object;
		this.bones = bones;

		this.matrix = object.matrixWorld;
		this.matrixAutoUpdate = false;

		this.onBeforeRender();

	}

	SkeletonHelper.prototype = Object.create( LineSegments.prototype );
	SkeletonHelper.prototype.constructor = SkeletonHelper;

	SkeletonHelper.prototype.onBeforeRender = function () {

		var vector = new Vector3();

		var boneMatrix = new Matrix4();
		var matrixWorldInv = new Matrix4();

		return function onBeforeRender() {

			var bones = this.bones;

			var geometry = this.geometry;
			var position = geometry.getAttribute( 'position' );

			matrixWorldInv.getInverse( this.root.matrixWorld );

			for ( var i = 0, j = 0; i < bones.length; i ++ ) {

				var bone = bones[ i ];

				if ( bone.parent && bone.parent.isBone ) {

					boneMatrix.multiplyMatrices( matrixWorldInv, bone.matrixWorld );
					vector.setFromMatrixPosition( boneMatrix );
					position.setXYZ( j, vector.x, vector.y, vector.z );

					boneMatrix.multiplyMatrices( matrixWorldInv, bone.parent.matrixWorld );
					vector.setFromMatrixPosition( boneMatrix );
					position.setXYZ( j + 1, vector.x, vector.y, vector.z );

					j += 2;

				}

			}

			geometry.getAttribute( 'position' ).needsUpdate = true;

		};

	}();

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author mrdoob / http://mrdoob.com/
	 */

	function PointLightHelper( light, sphereSize, color ) {

		this.light = light;
		this.light.updateMatrixWorld();

		this.color = color;

		var geometry = new SphereBufferGeometry( sphereSize, 4, 2 );
		var material = new MeshBasicMaterial( { wireframe: true, fog: false } );

		Mesh.call( this, geometry, material );

		this.matrix = this.light.matrixWorld;
		this.matrixAutoUpdate = false;

		this.update();


		/*
		var distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
		var distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

		this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
		this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

		var d = light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.scale.set( d, d, d );

		}

		this.add( this.lightDistance );
		*/

	}

	PointLightHelper.prototype = Object.create( Mesh.prototype );
	PointLightHelper.prototype.constructor = PointLightHelper;

	PointLightHelper.prototype.dispose = function () {

		this.geometry.dispose();
		this.material.dispose();

	};

	PointLightHelper.prototype.update = function () {

		if ( this.color !== undefined ) {

			this.material.color.set( this.color );

		} else {

			this.material.color.copy( this.light.color );

		}

		/*
		var d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/

	};

	/**
	 * @author abelnation / http://github.com/abelnation
	 * @author Mugen87 / http://github.com/Mugen87
	 * @author WestLangley / http://github.com/WestLangley
	 */

	function RectAreaLightHelper( light, color ) {

		Object3D.call( this );

		this.light = light;
		this.light.updateMatrixWorld();

		this.matrix = light.matrixWorld;
		this.matrixAutoUpdate = false;

		this.color = color;

		var material = new LineBasicMaterial( { fog: false } );

		var geometry = new BufferGeometry();

		geometry.addAttribute( 'position', new BufferAttribute( new Float32Array( 5 * 3 ), 3 ) );

		this.line = new Line( geometry, material );
		this.add( this.line );


		this.update();

	}

	RectAreaLightHelper.prototype = Object.create( Object3D.prototype );
	RectAreaLightHelper.prototype.constructor = RectAreaLightHelper;

	RectAreaLightHelper.prototype.dispose = function () {

		this.children[ 0 ].geometry.dispose();
		this.children[ 0 ].material.dispose();

	};

	RectAreaLightHelper.prototype.update = function () {

		// calculate new dimensions of the helper

		var hx = this.light.width * 0.5;
		var hy = this.light.height * 0.5;

		var position = this.line.geometry.attributes.position;
		var array = position.array;

		// update vertices

		array[  0 ] =   hx; array[  1 ] = - hy; array[  2 ] = 0;
		array[  3 ] =   hx; array[  4 ] =   hy; array[  5 ] = 0;
		array[  6 ] = - hx; array[  7 ] =   hy; array[  8 ] = 0;
		array[  9 ] = - hx; array[ 10 ] = - hy; array[ 11 ] = 0;
		array[ 12 ] =   hx; array[ 13 ] = - hy; array[ 14 ] = 0;

		position.needsUpdate = true;

		if ( this.color !== undefined ) {

			this.line.material.color.set( this.color );

		} else {

			this.line.material.color.copy( this.light.color );

		}

	};

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author mrdoob / http://mrdoob.com/
	 * @author Mugen87 / https://github.com/Mugen87
	 */

	function HemisphereLightHelper( light, size, color ) {

		Object3D.call( this );

		this.light = light;
		this.light.updateMatrixWorld();

		this.matrix = light.matrixWorld;
		this.matrixAutoUpdate = false;

		this.color = color;

		var geometry = new OctahedronBufferGeometry( size );
		geometry.rotateY( Math.PI * 0.5 );

		this.material = new MeshBasicMaterial( { wireframe: true, fog: false } );
		if ( this.color === undefined ) this.material.vertexColors = VertexColors;

		var position = geometry.getAttribute( 'position' );
		var colors = new Float32Array( position.count * 3 );

		geometry.addAttribute( 'color', new BufferAttribute( colors, 3 ) );

		this.add( new Mesh( geometry, this.material ) );

		this.update();

	}

	HemisphereLightHelper.prototype = Object.create( Object3D.prototype );
	HemisphereLightHelper.prototype.constructor = HemisphereLightHelper;

	HemisphereLightHelper.prototype.dispose = function () {

		this.children[ 0 ].geometry.dispose();
		this.children[ 0 ].material.dispose();

	};

	HemisphereLightHelper.prototype.update = function () {

		var vector = new Vector3();

		var color1 = new Color();
		var color2 = new Color();

		return function update() {

			var mesh = this.children[ 0 ];

			if ( this.color !== undefined ) {

				this.material.color.set( this.color );

			} else {

				var colors = mesh.geometry.getAttribute( 'color' );

				color1.copy( this.light.color );
				color2.copy( this.light.groundColor );

				for ( var i = 0, l = colors.count; i < l; i ++ ) {

					var color = ( i < ( l / 2 ) ) ? color1 : color2;

					colors.setXYZ( i, color.r, color.g, color.b );

				}

				colors.needsUpdate = true;

			}

			mesh.lookAt( vector.setFromMatrixPosition( this.light.matrixWorld ).negate() );

		};

	}();

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function GridHelper( size, divisions, color1, color2 ) {

		size = size || 10;
		divisions = divisions || 10;
		color1 = new Color( color1 !== undefined ? color1 : 0x444444 );
		color2 = new Color( color2 !== undefined ? color2 : 0x888888 );

		var center = divisions / 2;
		var step = size / divisions;
		var halfSize = size / 2;

		var vertices = [], colors = [];

		for ( var i = 0, j = 0, k = - halfSize; i <= divisions; i ++, k += step ) {

			vertices.push( - halfSize, 0, k, halfSize, 0, k );
			vertices.push( k, 0, - halfSize, k, 0, halfSize );

			var color = i === center ? color1 : color2;

			color.toArray( colors, j ); j += 3;
			color.toArray( colors, j ); j += 3;
			color.toArray( colors, j ); j += 3;
			color.toArray( colors, j ); j += 3;

		}

		var geometry = new BufferGeometry();
		geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

		var material = new LineBasicMaterial( { vertexColors: VertexColors } );

		LineSegments.call( this, geometry, material );

	}

	GridHelper.prototype = Object.create( LineSegments.prototype );
	GridHelper.prototype.constructor = GridHelper;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author Mugen87 / http://github.com/Mugen87
	 * @author Hectate / http://www.github.com/Hectate
	 */

	function PolarGridHelper( radius, radials, circles, divisions, color1, color2 ) {

		radius = radius || 10;
		radials = radials || 16;
		circles = circles || 8;
		divisions = divisions || 64;
		color1 = new Color( color1 !== undefined ? color1 : 0x444444 );
		color2 = new Color( color2 !== undefined ? color2 : 0x888888 );

		var vertices = [];
		var colors = [];

		var x, z;
		var v, i, j, r, color;

		// create the radials

		for ( i = 0; i <= radials; i ++ ) {

			v = ( i / radials ) * ( Math.PI * 2 );

			x = Math.sin( v ) * radius;
			z = Math.cos( v ) * radius;

			vertices.push( 0, 0, 0 );
			vertices.push( x, 0, z );

			color = ( i & 1 ) ? color1 : color2;

			colors.push( color.r, color.g, color.b );
			colors.push( color.r, color.g, color.b );

		}

		// create the circles

		for ( i = 0; i <= circles; i ++ ) {

			color = ( i & 1 ) ? color1 : color2;

			r = radius - ( radius / circles * i );

			for ( j = 0; j < divisions; j ++ ) {

				// first vertex

				v = ( j / divisions ) * ( Math.PI * 2 );

				x = Math.sin( v ) * r;
				z = Math.cos( v ) * r;

				vertices.push( x, 0, z );
				colors.push( color.r, color.g, color.b );

				// second vertex

				v = ( ( j + 1 ) / divisions ) * ( Math.PI * 2 );

				x = Math.sin( v ) * r;
				z = Math.cos( v ) * r;

				vertices.push( x, 0, z );
				colors.push( color.r, color.g, color.b );

			}

		}

		var geometry = new BufferGeometry();
		geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

		var material = new LineBasicMaterial( { vertexColors: VertexColors } );

		LineSegments.call( this, geometry, material );

	}

	PolarGridHelper.prototype = Object.create( LineSegments.prototype );
	PolarGridHelper.prototype.constructor = PolarGridHelper;

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author WestLangley / http://github.com/WestLangley
	 */

	function FaceNormalsHelper( object, size, hex, linewidth ) {

		// FaceNormalsHelper only supports THREE.Geometry

		this.object = object;

		this.size = ( size !== undefined ) ? size : 1;

		var color = ( hex !== undefined ) ? hex : 0xffff00;

		var width = ( linewidth !== undefined ) ? linewidth : 1;

		//

		var nNormals = 0;

		var objGeometry = this.object.geometry;

		if ( objGeometry && objGeometry.isGeometry ) {

			nNormals = objGeometry.faces.length;

		} else {

			console.warn( 'THREE.FaceNormalsHelper: only THREE.Geometry is supported. Use THREE.VertexNormalsHelper, instead.' );

		}

		//

		var geometry = new BufferGeometry();

		var positions = new Float32BufferAttribute( nNormals * 2 * 3, 3 );

		geometry.addAttribute( 'position', positions );

		LineSegments.call( this, geometry, new LineBasicMaterial( { color: color, linewidth: width } ) );

		//

		this.matrixAutoUpdate = false;
		this.update();

	}

	FaceNormalsHelper.prototype = Object.create( LineSegments.prototype );
	FaceNormalsHelper.prototype.constructor = FaceNormalsHelper;

	FaceNormalsHelper.prototype.update = ( function () {

		var v1 = new Vector3();
		var v2 = new Vector3();
		var normalMatrix = new Matrix3();

		return function update() {

			this.object.updateMatrixWorld( true );

			normalMatrix.getNormalMatrix( this.object.matrixWorld );

			var matrixWorld = this.object.matrixWorld;

			var position = this.geometry.attributes.position;

			//

			var objGeometry = this.object.geometry;

			var vertices = objGeometry.vertices;

			var faces = objGeometry.faces;

			var idx = 0;

			for ( var i = 0, l = faces.length; i < l; i ++ ) {

				var face = faces[ i ];

				var normal = face.normal;

				v1.copy( vertices[ face.a ] )
					.add( vertices[ face.b ] )
					.add( vertices[ face.c ] )
					.divideScalar( 3 )
					.applyMatrix4( matrixWorld );

				v2.copy( normal ).applyMatrix3( normalMatrix ).normalize().multiplyScalar( this.size ).add( v1 );

				position.setXYZ( idx, v1.x, v1.y, v1.z );

				idx = idx + 1;

				position.setXYZ( idx, v2.x, v2.y, v2.z );

				idx = idx + 1;

			}

			position.needsUpdate = true;

		};

	}() );

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author mrdoob / http://mrdoob.com/
	 * @author WestLangley / http://github.com/WestLangley
	 */

	function DirectionalLightHelper( light, size, color ) {

		Object3D.call( this );

		this.light = light;
		this.light.updateMatrixWorld();

		this.matrix = light.matrixWorld;
		this.matrixAutoUpdate = false;

		this.color = color;

		if ( size === undefined ) size = 1;

		var geometry = new BufferGeometry();
		geometry.addAttribute( 'position', new Float32BufferAttribute( [
			- size,   size, 0,
			  size,   size, 0,
			  size, - size, 0,
			- size, - size, 0,
			- size,   size, 0
		], 3 ) );

		var material = new LineBasicMaterial( { fog: false } );

		this.lightPlane = new Line( geometry, material );
		this.add( this.lightPlane );

		geometry = new BufferGeometry();
		geometry.addAttribute( 'position', new Float32BufferAttribute( [ 0, 0, 0, 0, 0, 1 ], 3 ) );

		this.targetLine = new Line( geometry, material );
		this.add( this.targetLine );

		this.update();

	}

	DirectionalLightHelper.prototype = Object.create( Object3D.prototype );
	DirectionalLightHelper.prototype.constructor = DirectionalLightHelper;

	DirectionalLightHelper.prototype.dispose = function () {

		this.lightPlane.geometry.dispose();
		this.lightPlane.material.dispose();
		this.targetLine.geometry.dispose();
		this.targetLine.material.dispose();

	};

	DirectionalLightHelper.prototype.update = function () {

		var v1 = new Vector3();
		var v2 = new Vector3();
		var v3 = new Vector3();

		return function update() {

			v1.setFromMatrixPosition( this.light.matrixWorld );
			v2.setFromMatrixPosition( this.light.target.matrixWorld );
			v3.subVectors( v2, v1 );

			this.lightPlane.lookAt( v3 );

			if ( this.color !== undefined ) {

				this.lightPlane.material.color.set( this.color );
				this.targetLine.material.color.set( this.color );

			} else {

				this.lightPlane.material.color.copy( this.light.color );
				this.targetLine.material.color.copy( this.light.color );

			}

			this.targetLine.lookAt( v3 );
			this.targetLine.scale.z = v3.length();

		};

	}();

	/**
	 * @author alteredq / http://alteredqualia.com/
	 * @author Mugen87 / https://github.com/Mugen87
	 *
	 *	- shows frustum, line of sight and up of the camera
	 *	- suitable for fast updates
	 * 	- based on frustum visualization in lightgl.js shadowmap example
	 *		http://evanw.github.com/lightgl.js/tests/shadowmap.html
	 */

	function CameraHelper( camera ) {

		var geometry = new BufferGeometry();
		var material = new LineBasicMaterial( { color: 0xffffff, vertexColors: FaceColors } );

		var vertices = [];
		var colors = [];

		var pointMap = {};

		// colors

		var colorFrustum = new Color( 0xffaa00 );
		var colorCone = new Color( 0xff0000 );
		var colorUp = new Color( 0x00aaff );
		var colorTarget = new Color( 0xffffff );
		var colorCross = new Color( 0x333333 );

		// near

		addLine( "n1", "n2", colorFrustum );
		addLine( "n2", "n4", colorFrustum );
		addLine( "n4", "n3", colorFrustum );
		addLine( "n3", "n1", colorFrustum );

		// far

		addLine( "f1", "f2", colorFrustum );
		addLine( "f2", "f4", colorFrustum );
		addLine( "f4", "f3", colorFrustum );
		addLine( "f3", "f1", colorFrustum );

		// sides

		addLine( "n1", "f1", colorFrustum );
		addLine( "n2", "f2", colorFrustum );
		addLine( "n3", "f3", colorFrustum );
		addLine( "n4", "f4", colorFrustum );

		// cone

		addLine( "p", "n1", colorCone );
		addLine( "p", "n2", colorCone );
		addLine( "p", "n3", colorCone );
		addLine( "p", "n4", colorCone );

		// up

		addLine( "u1", "u2", colorUp );
		addLine( "u2", "u3", colorUp );
		addLine( "u3", "u1", colorUp );

		// target

		addLine( "c", "t", colorTarget );
		addLine( "p", "c", colorCross );

		// cross

		addLine( "cn1", "cn2", colorCross );
		addLine( "cn3", "cn4", colorCross );

		addLine( "cf1", "cf2", colorCross );
		addLine( "cf3", "cf4", colorCross );

		function addLine( a, b, color ) {

			addPoint( a, color );
			addPoint( b, color );

		}

		function addPoint( id, color ) {

			vertices.push( 0, 0, 0 );
			colors.push( color.r, color.g, color.b );

			if ( pointMap[ id ] === undefined ) {

				pointMap[ id ] = [];

			}

			pointMap[ id ].push( ( vertices.length / 3 ) - 1 );

		}

		geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

		LineSegments.call( this, geometry, material );

		this.camera = camera;
		if ( this.camera.updateProjectionMatrix ) this.camera.updateProjectionMatrix();

		this.matrix = camera.matrixWorld;
		this.matrixAutoUpdate = false;

		this.pointMap = pointMap;

		this.update();

	}

	CameraHelper.prototype = Object.create( LineSegments.prototype );
	CameraHelper.prototype.constructor = CameraHelper;

	CameraHelper.prototype.update = function () {

		var geometry, pointMap;

		var vector = new Vector3();
		var camera = new Camera();

		function setPoint( point, x, y, z ) {

			vector.set( x, y, z ).unproject( camera );

			var points = pointMap[ point ];

			if ( points !== undefined ) {

				var position = geometry.getAttribute( 'position' );

				for ( var i = 0, l = points.length; i < l; i ++ ) {

					position.setXYZ( points[ i ], vector.x, vector.y, vector.z );

				}

			}

		}

		return function update() {

			geometry = this.geometry;
			pointMap = this.pointMap;

			var w = 1, h = 1;

			// we need just camera projection matrix
			// world matrix must be identity

			camera.projectionMatrix.copy( this.camera.projectionMatrix );

			// center / target

			setPoint( "c", 0, 0, - 1 );
			setPoint( "t", 0, 0,  1 );

			// near

			setPoint( "n1", - w, - h, - 1 );
			setPoint( "n2",   w, - h, - 1 );
			setPoint( "n3", - w,   h, - 1 );
			setPoint( "n4",   w,   h, - 1 );

			// far

			setPoint( "f1", - w, - h, 1 );
			setPoint( "f2",   w, - h, 1 );
			setPoint( "f3", - w,   h, 1 );
			setPoint( "f4",   w,   h, 1 );

			// up

			setPoint( "u1",   w * 0.7, h * 1.1, - 1 );
			setPoint( "u2", - w * 0.7, h * 1.1, - 1 );
			setPoint( "u3",         0, h * 2,   - 1 );

			// cross

			setPoint( "cf1", - w,   0, 1 );
			setPoint( "cf2",   w,   0, 1 );
			setPoint( "cf3",   0, - h, 1 );
			setPoint( "cf4",   0,   h, 1 );

			setPoint( "cn1", - w,   0, - 1 );
			setPoint( "cn2",   w,   0, - 1 );
			setPoint( "cn3",   0, - h, - 1 );
			setPoint( "cn4",   0,   h, - 1 );

			geometry.getAttribute( 'position' ).needsUpdate = true;

		};

	}();

	/**
	 * @author mrdoob / http://mrdoob.com/
	 * @author Mugen87 / http://github.com/Mugen87
	 */

	function BoxHelper( object, color ) {

		this.object = object;

		if ( color === undefined ) color = 0xffff00;

		var indices = new Uint16Array( [ 0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7 ] );
		var positions = new Float32Array( 8 * 3 );

		var geometry = new BufferGeometry();
		geometry.setIndex( new BufferAttribute( indices, 1 ) );
		geometry.addAttribute( 'position', new BufferAttribute( positions, 3 ) );

		LineSegments.call( this, geometry, new LineBasicMaterial( { color: color } ) );

		this.matrixAutoUpdate = false;

		this.update();

	}

	BoxHelper.prototype = Object.create( LineSegments.prototype );
	BoxHelper.prototype.constructor = BoxHelper;

	BoxHelper.prototype.update = ( function () {

		var box = new Box3();

		return function update( object ) {

			if ( object !== undefined ) {

				console.warn( 'THREE.BoxHelper: .update() has no longer arguments.' );

			}

			if ( this.object !== undefined ) {

				box.setFromObject( this.object );

			}

			if ( box.isEmpty() ) return;

			var min = box.min;
			var max = box.max;

			/*
			  5____4
			1/___0/|
			| 6__|_7
			2/___3/

			0: max.x, max.y, max.z
			1: min.x, max.y, max.z
			2: min.x, min.y, max.z
			3: max.x, min.y, max.z
			4: max.x, max.y, min.z
			5: min.x, max.y, min.z
			6: min.x, min.y, min.z
			7: max.x, min.y, min.z
			*/

			var position = this.geometry.attributes.position;
			var array = position.array;

			array[  0 ] = max.x; array[  1 ] = max.y; array[  2 ] = max.z;
			array[  3 ] = min.x; array[  4 ] = max.y; array[  5 ] = max.z;
			array[  6 ] = min.x; array[  7 ] = min.y; array[  8 ] = max.z;
			array[  9 ] = max.x; array[ 10 ] = min.y; array[ 11 ] = max.z;
			array[ 12 ] = max.x; array[ 13 ] = max.y; array[ 14 ] = min.z;
			array[ 15 ] = min.x; array[ 16 ] = max.y; array[ 17 ] = min.z;
			array[ 18 ] = min.x; array[ 19 ] = min.y; array[ 20 ] = min.z;
			array[ 21 ] = max.x; array[ 22 ] = min.y; array[ 23 ] = min.z;

			position.needsUpdate = true;

			this.geometry.computeBoundingSphere();

		};

	} )();

	BoxHelper.prototype.setFromObject = function ( object ) {

		this.object = object;
		this.update();

		return this;

	};

	/**
	 * @author WestLangley / http://github.com/WestLangley
	 */

	function Box3Helper( box, hex ) {

		this.type = 'Box3Helper';

		this.box = box;

		var color = ( hex !== undefined ) ? hex : 0xffff00;

		var indices = new Uint16Array( [ 0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7 ] );

		var positions = [ 1, 1, 1, - 1, 1, 1, - 1, - 1, 1, 1, - 1, 1, 1, 1, - 1, - 1, 1, - 1, - 1, - 1, - 1, 1, - 1, - 1 ];

		var geometry = new BufferGeometry();

		geometry.setIndex( new BufferAttribute( indices, 1 ) );

		geometry.addAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );

		LineSegments.call( this, geometry, new LineBasicMaterial( { color: color } ) );

		this.geometry.computeBoundingSphere();

		this.onBeforeRender();

	}

	Box3Helper.prototype = Object.create( LineSegments.prototype );
	Box3Helper.prototype.constructor = Box3Helper;

	Box3Helper.prototype.onBeforeRender = function () {

		var box = this.box;

		if ( box.isEmpty() ) return;

		box.getCenter( this.position );

		box.getSize( this.scale );

		this.scale.multiplyScalar( 0.5 );

	};

	/**
	 * @author WestLangley / http://github.com/WestLangley
	 */

	function PlaneHelper( plane, size, hex ) {

		this.type = 'PlaneHelper';

		this.plane = plane;

		this.size = ( size === undefined ) ? 1 : size;

		var color = ( hex !== undefined ) ? hex : 0xffff00;

		var positions = [ 1, - 1, 1, - 1, 1, 1, - 1, - 1, 1, 1, 1, 1, - 1, 1, 1, - 1, - 1, 1, 1, - 1, 1, 1, 1, 1, 0, 0, 1, 0, 0, 0 ];

		var geometry = new BufferGeometry();
		geometry.addAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );
		geometry.computeBoundingSphere();

		Line.call( this, geometry, new LineBasicMaterial( { color: color } ) );

		//

		var positions2 = [ 1, 1, 1, - 1, 1, 1, - 1, - 1, 1, 1, 1, 1, - 1, - 1, 1, 1, - 1, 1 ];

		var geometry2 = new BufferGeometry();
		geometry2.addAttribute( 'position', new Float32BufferAttribute( positions2, 3 ) );
		geometry2.computeBoundingSphere();

		this.add( new Mesh( geometry2, new MeshBasicMaterial( { color: color, opacity: 0.2, transparent: true, depthWrite: false } ) ) );

		//

		this.onBeforeRender();

	}

	PlaneHelper.prototype = Object.create( Line.prototype );
	PlaneHelper.prototype.constructor = PlaneHelper;

	PlaneHelper.prototype.onBeforeRender = function () {

		var scale = - this.plane.constant;

		if ( Math.abs( scale ) < 1e-8 ) scale = 1e-8; // sign does not matter

		this.scale.set( 0.5 * this.size, 0.5 * this.size, scale );

		this.lookAt( this.plane.normal );

		this.updateMatrixWorld();

	};

	/**
	 * @author WestLangley / http://github.com/WestLangley
	 * @author zz85 / http://github.com/zz85
	 * @author bhouston / http://clara.io
	 *
	 * Creates an arrow for visualizing directions
	 *
	 * Parameters:
	 *  dir - Vector3
	 *  origin - Vector3
	 *  length - Number
	 *  color - color in hex value
	 *  headLength - Number
	 *  headWidth - Number
	 */

	var lineGeometry;
	var coneGeometry;

	function ArrowHelper( dir, origin, length, color, headLength, headWidth ) {

		// dir is assumed to be normalized

		Object3D.call( this );

		if ( color === undefined ) color = 0xffff00;
		if ( length === undefined ) length = 1;
		if ( headLength === undefined ) headLength = 0.2 * length;
		if ( headWidth === undefined ) headWidth = 0.2 * headLength;

		if ( lineGeometry === undefined ) {

			lineGeometry = new BufferGeometry();
			lineGeometry.addAttribute( 'position', new Float32BufferAttribute( [ 0, 0, 0, 0, 1, 0 ], 3 ) );

			coneGeometry = new CylinderBufferGeometry( 0, 0.5, 1, 5, 1 );
			coneGeometry.translate( 0, - 0.5, 0 );

		}

		this.position.copy( origin );

		this.line = new Line( lineGeometry, new LineBasicMaterial( { color: color } ) );
		this.line.matrixAutoUpdate = false;
		this.add( this.line );

		this.cone = new Mesh( coneGeometry, new MeshBasicMaterial( { color: color } ) );
		this.cone.matrixAutoUpdate = false;
		this.add( this.cone );

		this.setDirection( dir );
		this.setLength( length, headLength, headWidth );

	}

	ArrowHelper.prototype = Object.create( Object3D.prototype );
	ArrowHelper.prototype.constructor = ArrowHelper;

	ArrowHelper.prototype.setDirection = ( function () {

		var axis = new Vector3();
		var radians;

		return function setDirection( dir ) {

			// dir is assumed to be normalized

			if ( dir.y > 0.99999 ) {

				this.quaternion.set( 0, 0, 0, 1 );

			} else if ( dir.y < - 0.99999 ) {

				this.quaternion.set( 1, 0, 0, 0 );

			} else {

				axis.set( dir.z, 0, - dir.x ).normalize();

				radians = Math.acos( dir.y );

				this.quaternion.setFromAxisAngle( axis, radians );

			}

		};

	}() );

	ArrowHelper.prototype.setLength = function ( length, headLength, headWidth ) {

		if ( headLength === undefined ) headLength = 0.2 * length;
		if ( headWidth === undefined ) headWidth = 0.2 * headLength;

		this.line.scale.set( 1, Math.max( 0, length - headLength ), 1 );
		this.line.updateMatrix();

		this.cone.scale.set( headWidth, headLength, headWidth );
		this.cone.position.y = length;
		this.cone.updateMatrix();

	};

	ArrowHelper.prototype.setColor = function ( color ) {

		this.line.material.color.copy( color );
		this.cone.material.color.copy( color );

	};

	/**
	 * @author sroucheray / http://sroucheray.org/
	 * @author mrdoob / http://mrdoob.com/
	 */

	function AxisHelper( size ) {

		size = size || 1;

		var vertices = [
			0, 0, 0,  size, 0, 0,
			0, 0, 0,  0, size, 0,
			0, 0, 0,  0, 0, size
		];

		var colors = [
			1, 0, 0,  1, 0.6, 0,
			0, 1, 0,  0.6, 1, 0,
			0, 0, 1,  0, 0.6, 1
		];

		var geometry = new BufferGeometry();
		geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

		var material = new LineBasicMaterial( { vertexColors: VertexColors } );

		LineSegments.call( this, geometry, material );

	}

	AxisHelper.prototype = Object.create( LineSegments.prototype );
	AxisHelper.prototype.constructor = AxisHelper;

	/**
	 * @author zz85 https://github.com/zz85
	 *
	 * Centripetal CatmullRom Curve - which is useful for avoiding
	 * cusps and self-intersections in non-uniform catmull rom curves.
	 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
	 *
	 * curve.type accepts centripetal(default), chordal and catmullrom
	 * curve.tension is used for catmullrom which defaults to 0.5
	 */


	/*
	Based on an optimized c++ solution in
	 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
	 - http://ideone.com/NoEbVM

	This CubicPoly class could be used for reusing some variables and calculations,
	but for three.js curve use, it could be possible inlined and flatten into a single function call
	which can be placed in CurveUtils.
	*/

	function CubicPoly() {

		var c0 = 0, c1 = 0, c2 = 0, c3 = 0;

		/*
		 * Compute coefficients for a cubic polynomial
		 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
		 * such that
		 *   p(0) = x0, p(1) = x1
		 *  and
		 *   p'(0) = t0, p'(1) = t1.
		 */
		function init( x0, x1, t0, t1 ) {

			c0 = x0;
			c1 = t0;
			c2 = - 3 * x0 + 3 * x1 - 2 * t0 - t1;
			c3 = 2 * x0 - 2 * x1 + t0 + t1;

		}

		return {

			initCatmullRom: function ( x0, x1, x2, x3, tension ) {

				init( x1, x2, tension * ( x2 - x0 ), tension * ( x3 - x1 ) );

			},

			initNonuniformCatmullRom: function ( x0, x1, x2, x3, dt0, dt1, dt2 ) {

				// compute tangents when parameterized in [t1,t2]
				var t1 = ( x1 - x0 ) / dt0 - ( x2 - x0 ) / ( dt0 + dt1 ) + ( x2 - x1 ) / dt1;
				var t2 = ( x2 - x1 ) / dt1 - ( x3 - x1 ) / ( dt1 + dt2 ) + ( x3 - x2 ) / dt2;

				// rescale tangents for parametrization in [0,1]
				t1 *= dt1;
				t2 *= dt1;

				init( x1, x2, t1, t2 );

			},

			calc: function ( t ) {

				var t2 = t * t;
				var t3 = t2 * t;
				return c0 + c1 * t + c2 * t2 + c3 * t3;

			}

		};

	}

	//

	var tmp = new Vector3();
	var px = new CubicPoly();
	var py = new CubicPoly();
	var pz = new CubicPoly();

	function CatmullRomCurve3( points ) {

		Curve.call( this );

		if ( points.length < 2 ) console.warn( 'THREE.CatmullRomCurve3: Points array needs at least two entries.' );

		this.points = points || [];
		this.closed = false;

	}

	CatmullRomCurve3.prototype = Object.create( Curve.prototype );
	CatmullRomCurve3.prototype.constructor = CatmullRomCurve3;

	CatmullRomCurve3.prototype.getPoint = function ( t ) {

		var points = this.points;
		var l = points.length;

		var point = ( l - ( this.closed ? 0 : 1 ) ) * t;
		var intPoint = Math.floor( point );
		var weight = point - intPoint;

		if ( this.closed ) {

			intPoint += intPoint > 0 ? 0 : ( Math.floor( Math.abs( intPoint ) / points.length ) + 1 ) * points.length;

		} else if ( weight === 0 && intPoint === l - 1 ) {

			intPoint = l - 2;
			weight = 1;

		}

		var p0, p1, p2, p3; // 4 points

		if ( this.closed || intPoint > 0 ) {

			p0 = points[ ( intPoint - 1 ) % l ];

		} else {

			// extrapolate first point
			tmp.subVectors( points[ 0 ], points[ 1 ] ).add( points[ 0 ] );
			p0 = tmp;

		}

		p1 = points[ intPoint % l ];
		p2 = points[ ( intPoint + 1 ) % l ];

		if ( this.closed || intPoint + 2 < l ) {

			p3 = points[ ( intPoint + 2 ) % l ];

		} else {

			// extrapolate last point
			tmp.subVectors( points[ l - 1 ], points[ l - 2 ] ).add( points[ l - 1 ] );
			p3 = tmp;

		}

		if ( this.type === undefined || this.type === 'centripetal' || this.type === 'chordal' ) {

			// init Centripetal / Chordal Catmull-Rom
			var pow = this.type === 'chordal' ? 0.5 : 0.25;
			var dt0 = Math.pow( p0.distanceToSquared( p1 ), pow );
			var dt1 = Math.pow( p1.distanceToSquared( p2 ), pow );
			var dt2 = Math.pow( p2.distanceToSquared( p3 ), pow );

			// safety check for repeated points
			if ( dt1 < 1e-4 ) dt1 = 1.0;
			if ( dt0 < 1e-4 ) dt0 = dt1;
			if ( dt2 < 1e-4 ) dt2 = dt1;

			px.initNonuniformCatmullRom( p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2 );
			py.initNonuniformCatmullRom( p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2 );
			pz.initNonuniformCatmullRom( p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2 );

		} else if ( this.type === 'catmullrom' ) {

			var tension = this.tension !== undefined ? this.tension : 0.5;
			px.initCatmullRom( p0.x, p1.x, p2.x, p3.x, tension );
			py.initCatmullRom( p0.y, p1.y, p2.y, p3.y, tension );
			pz.initCatmullRom( p0.z, p1.z, p2.z, p3.z, tension );

		}

		return new Vector3( px.calc( weight ), py.calc( weight ), pz.calc( weight ) );

	};

	function CubicBezierCurve3( v0, v1, v2, v3 ) {

		Curve.call( this );

		this.v0 = v0;
		this.v1 = v1;
		this.v2 = v2;
		this.v3 = v3;

	}

	CubicBezierCurve3.prototype = Object.create( Curve.prototype );
	CubicBezierCurve3.prototype.constructor = CubicBezierCurve3;

	CubicBezierCurve3.prototype.getPoint = function ( t ) {

		var v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;

		return new Vector3(
			CubicBezier( t, v0.x, v1.x, v2.x, v3.x ),
			CubicBezier( t, v0.y, v1.y, v2.y, v3.y ),
			CubicBezier( t, v0.z, v1.z, v2.z, v3.z )
		);

	};

	function QuadraticBezierCurve3( v0, v1, v2 ) {

		Curve.call( this );

		this.v0 = v0;
		this.v1 = v1;
		this.v2 = v2;

	}

	QuadraticBezierCurve3.prototype = Object.create( Curve.prototype );
	QuadraticBezierCurve3.prototype.constructor = QuadraticBezierCurve3;

	QuadraticBezierCurve3.prototype.getPoint = function ( t ) {

		var v0 = this.v0, v1 = this.v1, v2 = this.v2;

		return new Vector3(
			QuadraticBezier( t, v0.x, v1.x, v2.x ),
			QuadraticBezier( t, v0.y, v1.y, v2.y ),
			QuadraticBezier( t, v0.z, v1.z, v2.z )
		);

	};

	function LineCurve3( v1, v2 ) {

		Curve.call( this );

		this.v1 = v1;
		this.v2 = v2;

	}

	LineCurve3.prototype = Object.create( Curve.prototype );
	LineCurve3.prototype.constructor = LineCurve3;

	LineCurve3.prototype.getPoint = function ( t ) {

		if ( t === 1 ) {

			return this.v2.clone();

		}

		var vector = new Vector3();

		vector.subVectors( this.v2, this.v1 ); // diff
		vector.multiplyScalar( t );
		vector.add( this.v1 );

		return vector;

	};

	function ArcCurve( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {

		EllipseCurve.call( this, aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise );

	}

	ArcCurve.prototype = Object.create( EllipseCurve.prototype );
	ArcCurve.prototype.constructor = ArcCurve;

	/**
	 * @author alteredq / http://alteredqualia.com/
	 */

	var SceneUtils = {

		createMultiMaterialObject: function ( geometry, materials ) {

			var group = new Group();

			for ( var i = 0, l = materials.length; i < l; i ++ ) {

				group.add( new Mesh( geometry, materials[ i ] ) );

			}

			return group;

		},

		detach: function ( child, parent, scene ) {

			child.applyMatrix( parent.matrixWorld );
			parent.remove( child );
			scene.add( child );

		},

		attach: function ( child, scene, parent ) {

			child.applyMatrix( new Matrix4().getInverse( parent.matrixWorld ) );

			scene.remove( child );
			parent.add( child );

		}

	};

	/**
	 * @author mrdoob / http://mrdoob.com/
	 */

	function Face4( a, b, c, d, normal, color, materialIndex ) {

		console.warn( 'THREE.Face4 has been removed. A THREE.Face3 will be created instead.' );
		return new Face3( a, b, c, normal, color, materialIndex );

	}

	var LineStrip = 0;

	var LinePieces = 1;

	function MeshFaceMaterial( materials ) {

		console.warn( 'THREE.MeshFaceMaterial has been removed. Use an Array instead.' );
		return materials;

	}

	function MultiMaterial( materials ) {

		if ( materials === undefined ) materials = [];

		console.warn( 'THREE.MultiMaterial has been removed. Use an Array instead.' );
		materials.isMultiMaterial = true;
		materials.materials = materials;
		materials.clone = function () {

			return materials.slice();

		};
		return materials;

	}

	function PointCloud( geometry, material ) {

		console.warn( 'THREE.PointCloud has been renamed to THREE.Points.' );
		return new Points( geometry, material );

	}

	function Particle( material ) {

		console.warn( 'THREE.Particle has been renamed to THREE.Sprite.' );
		return new Sprite( material );

	}

	function ParticleSystem( geometry, material ) {

		console.warn( 'THREE.ParticleSystem has been renamed to THREE.Points.' );
		return new Points( geometry, material );

	}

	function PointCloudMaterial( parameters ) {

		console.warn( 'THREE.PointCloudMaterial has been renamed to THREE.PointsMaterial.' );
		return new PointsMaterial( parameters );

	}

	function ParticleBasicMaterial( parameters ) {

		console.warn( 'THREE.ParticleBasicMaterial has been renamed to THREE.PointsMaterial.' );
		return new PointsMaterial( parameters );

	}

	function ParticleSystemMaterial( parameters ) {

		console.warn( 'THREE.ParticleSystemMaterial has been renamed to THREE.PointsMaterial.' );
		return new PointsMaterial( parameters );

	}

	function Vertex( x, y, z ) {

		console.warn( 'THREE.Vertex has been removed. Use THREE.Vector3 instead.' );
		return new Vector3( x, y, z );

	}

	//

	function DynamicBufferAttribute( array, itemSize ) {

		console.warn( 'THREE.DynamicBufferAttribute has been removed. Use new THREE.BufferAttribute().setDynamic( true ) instead.' );
		return new BufferAttribute( array, itemSize ).setDynamic( true );

	}

	function Int8Attribute( array, itemSize ) {

		console.warn( 'THREE.Int8Attribute has been removed. Use new THREE.Int8BufferAttribute() instead.' );
		return new Int8BufferAttribute( array, itemSize );

	}

	function Uint8Attribute( array, itemSize ) {

		console.warn( 'THREE.Uint8Attribute has been removed. Use new THREE.Uint8BufferAttribute() instead.' );
		return new Uint8BufferAttribute( array, itemSize );

	}

	function Uint8ClampedAttribute( array, itemSize ) {

		console.warn( 'THREE.Uint8ClampedAttribute has been removed. Use new THREE.Uint8ClampedBufferAttribute() instead.' );
		return new Uint8ClampedBufferAttribute( array, itemSize );

	}

	function Int16Attribute( array, itemSize ) {

		console.warn( 'THREE.Int16Attribute has been removed. Use new THREE.Int16BufferAttribute() instead.' );
		return new Int16BufferAttribute( array, itemSize );

	}

	function Uint16Attribute( array, itemSize ) {

		console.warn( 'THREE.Uint16Attribute has been removed. Use new THREE.Uint16BufferAttribute() instead.' );
		return new Uint16BufferAttribute( array, itemSize );

	}

	function Int32Attribute( array, itemSize ) {

		console.warn( 'THREE.Int32Attribute has been removed. Use new THREE.Int32BufferAttribute() instead.' );
		return new Int32BufferAttribute( array, itemSize );

	}

	function Uint32Attribute( array, itemSize ) {

		console.warn( 'THREE.Uint32Attribute has been removed. Use new THREE.Uint32BufferAttribute() instead.' );
		return new Uint32BufferAttribute( array, itemSize );

	}

	function Float32Attribute( array, itemSize ) {

		console.warn( 'THREE.Float32Attribute has been removed. Use new THREE.Float32BufferAttribute() instead.' );
		return new Float32BufferAttribute( array, itemSize );

	}

	function Float64Attribute( array, itemSize ) {

		console.warn( 'THREE.Float64Attribute has been removed. Use new THREE.Float64BufferAttribute() instead.' );
		return new Float64BufferAttribute( array, itemSize );

	}

	//

	Curve.create = function ( construct, getPoint ) {

		console.log( 'THREE.Curve.create() has been deprecated' );

		construct.prototype = Object.create( Curve.prototype );
		construct.prototype.constructor = construct;
		construct.prototype.getPoint = getPoint;

		return construct;

	};

	//

	function ClosedSplineCurve3( points ) {

		console.warn( 'THREE.ClosedSplineCurve3 has been deprecated. Use THREE.CatmullRomCurve3 instead.' );

		CatmullRomCurve3.call( this, points );
		this.type = 'catmullrom';
		this.closed = true;

	}

	ClosedSplineCurve3.prototype = Object.create( CatmullRomCurve3.prototype );

	//

	function SplineCurve3( points ) {

		console.warn( 'THREE.SplineCurve3 has been deprecated. Use THREE.CatmullRomCurve3 instead.' );

		CatmullRomCurve3.call( this, points );
		this.type = 'catmullrom';

	}

	SplineCurve3.prototype = Object.create( CatmullRomCurve3.prototype );

	//

	function Spline( points ) {

		console.warn( 'THREE.Spline has been removed. Use THREE.CatmullRomCurve3 instead.' );

		CatmullRomCurve3.call( this, points );
		this.type = 'catmullrom';

	}

	Spline.prototype = Object.create( CatmullRomCurve3.prototype );

	Object.assign( Spline.prototype, {

		initFromArray: function ( a ) {

			console.error( 'THREE.Spline: .initFromArray() has been removed.' );

		},
		getControlPointsArray: function ( optionalTarget ) {

			console.error( 'THREE.Spline: .getControlPointsArray() has been removed.' );

		},
		reparametrizeByArcLength: function ( samplingCoef ) {

			console.error( 'THREE.Spline: .reparametrizeByArcLength() has been removed.' );

		}

	} );

	//
	function BoundingBoxHelper( object, color ) {

		console.warn( 'THREE.BoundingBoxHelper has been deprecated. Creating a THREE.BoxHelper instead.' );
		return new BoxHelper( object, color );

	}

	function EdgesHelper( object, hex ) {

		console.warn( 'THREE.EdgesHelper has been removed. Use THREE.EdgesGeometry instead.' );
		return new LineSegments( new EdgesGeometry( object.geometry ), new LineBasicMaterial( { color: hex !== undefined ? hex : 0xffffff } ) );

	}

	GridHelper.prototype.setColors = function () {

		console.error( 'THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.' );

	};

	SkeletonHelper.prototype.update = function () {

		console.error( 'THREE.SkeletonHelper: update() no longer needs to be called.' );

	};

	function WireframeHelper( object, hex ) {

		console.warn( 'THREE.WireframeHelper has been removed. Use THREE.WireframeGeometry instead.' );
		return new LineSegments( new WireframeGeometry( object.geometry ), new LineBasicMaterial( { color: hex !== undefined ? hex : 0xffffff } ) );

	}

	//

	function XHRLoader( manager ) {

		console.warn( 'THREE.XHRLoader has been renamed to THREE.FileLoader.' );
		return new FileLoader( manager );

	}

	function BinaryTextureLoader( manager ) {

		console.warn( 'THREE.BinaryTextureLoader has been renamed to THREE.DataTextureLoader.' );
		return new DataTextureLoader( manager );

	}

	//

	Object.assign( Box2.prototype, {

		center: function ( optionalTarget ) {

			console.warn( 'THREE.Box2: .center() has been renamed to .getCenter().' );
			return this.getCenter( optionalTarget );

		},
		empty: function () {

			console.warn( 'THREE.Box2: .empty() has been renamed to .isEmpty().' );
			return this.isEmpty();

		},
		isIntersectionBox: function ( box ) {

			console.warn( 'THREE.Box2: .isIntersectionBox() has been renamed to .intersectsBox().' );
			return this.intersectsBox( box );

		},
		size: function ( optionalTarget ) {

			console.warn( 'THREE.Box2: .size() has been renamed to .getSize().' );
			return this.getSize( optionalTarget );

		}
	} );

	Object.assign( Box3.prototype, {

		center: function ( optionalTarget ) {

			console.warn( 'THREE.Box3: .center() has been renamed to .getCenter().' );
			return this.getCenter( optionalTarget );

		},
		empty: function () {

			console.warn( 'THREE.Box3: .empty() has been renamed to .isEmpty().' );
			return this.isEmpty();

		},
		isIntersectionBox: function ( box ) {

			console.warn( 'THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox().' );
			return this.intersectsBox( box );

		},
		isIntersectionSphere: function ( sphere ) {

			console.warn( 'THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere().' );
			return this.intersectsSphere( sphere );

		},
		size: function ( optionalTarget ) {

			console.warn( 'THREE.Box3: .size() has been renamed to .getSize().' );
			return this.getSize( optionalTarget );

		}
	} );

	Line3.prototype.center = function ( optionalTarget ) {

		console.warn( 'THREE.Line3: .center() has been renamed to .getCenter().' );
		return this.getCenter( optionalTarget );

	};

	_Math.random16 = function () {

		console.warn( 'THREE.Math.random16() has been deprecated. Use Math.random() instead.' );
		return Math.random();

	};

	Object.assign( Matrix3.prototype, {

		flattenToArrayOffset: function ( array, offset ) {

			console.warn( "THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead." );
			return this.toArray( array, offset );

		},
		multiplyVector3: function ( vector ) {

			console.warn( 'THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.' );
			return vector.applyMatrix3( this );

		},
		multiplyVector3Array: function ( a ) {

			console.error( 'THREE.Matrix3: .multiplyVector3Array() has been removed.'  );

		},
		applyToBuffer: function( buffer, offset, length ) {

			console.warn( 'THREE.Matrix3: .applyToBuffer() has been removed. Use matrix.applyToBufferAttribute( attribute ) instead.' );
			return this.applyToBufferAttribute( buffer );

		},
		applyToVector3Array: function( array, offset, length ) {

			console.error( 'THREE.Matrix3: .applyToVector3Array() has been removed.' );

		}

	} );

	Object.assign( Matrix4.prototype, {

		extractPosition: function ( m ) {

			console.warn( 'THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().' );
			return this.copyPosition( m );

		},
		flattenToArrayOffset: function ( array, offset ) {

			console.warn( "THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead." );
			return this.toArray( array, offset );

		},
		getPosition: function () {

			var v1;

			return function getPosition() {

				if ( v1 === undefined ) v1 = new Vector3();
				console.warn( 'THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.' );
				return v1.setFromMatrixColumn( this, 3 );

			};

		}(),
		setRotationFromQuaternion: function ( q ) {

			console.warn( 'THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().' );
			return this.makeRotationFromQuaternion( q );

		},
		multiplyToArray: function () {

			console.warn( 'THREE.Matrix4: .multiplyToArray() has been removed.' );

		},
		multiplyVector3: function ( vector ) {

			console.warn( 'THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead.' );
			return vector.applyMatrix4( this );

		},
		multiplyVector4: function ( vector ) {

			console.warn( 'THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.' );
			return vector.applyMatrix4( this );

		},
		multiplyVector3Array: function ( a ) {

			console.error( 'THREE.Matrix4: .multiplyVector3Array() has been removed.'  );

		},
		rotateAxis: function ( v ) {

			console.warn( 'THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.' );
			v.transformDirection( this );

		},
		crossVector: function ( vector ) {

			console.warn( 'THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.' );
			return vector.applyMatrix4( this );

		},
		translate: function () {

			console.error( 'THREE.Matrix4: .translate() has been removed.' );

		},
		rotateX: function () {

			console.error( 'THREE.Matrix4: .rotateX() has been removed.' );

		},
		rotateY: function () {

			console.error( 'THREE.Matrix4: .rotateY() has been removed.' );

		},
		rotateZ: function () {

			console.error( 'THREE.Matrix4: .rotateZ() has been removed.' );

		},
		rotateByAxis: function () {

			console.error( 'THREE.Matrix4: .rotateByAxis() has been removed.' );

		},
		applyToBuffer: function( buffer, offset, length ) {

			console.warn( 'THREE.Matrix4: .applyToBuffer() has been removed. Use matrix.applyToBufferAttribute( attribute ) instead.' );
			return this.applyToBufferAttribute( buffer );

		},
		applyToVector3Array: function( array, offset, length ) {

			console.error( 'THREE.Matrix4: .applyToVector3Array() has been removed.' );

		},
		makeFrustum: function( left, right, bottom, top, near, far ) {

			console.warn( 'THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead.' );
			return this.makePerspective( left, right, top, bottom, near, far );

		}

	} );

	Plane.prototype.isIntersectionLine = function ( line ) {

		console.warn( 'THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine().' );
		return this.intersectsLine( line );

	};

	Quaternion.prototype.multiplyVector3 = function ( vector ) {

		console.warn( 'THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.' );
		return vector.applyQuaternion( this );

	};

	Object.assign( Ray.prototype, {

		isIntersectionBox: function ( box ) {

			console.warn( 'THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox().' );
			return this.intersectsBox( box );

		},
		isIntersectionPlane: function ( plane ) {

			console.warn( 'THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane().' );
			return this.intersectsPlane( plane );

		},
		isIntersectionSphere: function ( sphere ) {

			console.warn( 'THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere().' );
			return this.intersectsSphere( sphere );

		}

	} );

	Object.assign( Shape.prototype, {

		extrude: function ( options ) {

			console.warn( 'THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead.' );
			return new ExtrudeGeometry( this, options );

		},
		makeGeometry: function ( options ) {

			console.warn( 'THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead.' );
			return new ShapeGeometry( this, options );

		}

	} );

	Object.assign( Vector2.prototype, {

		fromAttribute: function ( attribute, index, offset ) {

			console.error( 'THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute().' );
			return this.fromBufferAttribute( attribute, index, offset );

		}

	} );

	Object.assign( Vector3.prototype, {

		setEulerFromRotationMatrix: function () {

			console.error( 'THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.' );

		},
		setEulerFromQuaternion: function () {

			console.error( 'THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.' );

		},
		getPositionFromMatrix: function ( m ) {

			console.warn( 'THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().' );
			return this.setFromMatrixPosition( m );

		},
		getScaleFromMatrix: function ( m ) {

			console.warn( 'THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().' );
			return this.setFromMatrixScale( m );

		},
		getColumnFromMatrix: function ( index, matrix ) {

			console.warn( 'THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().' );
			return this.setFromMatrixColumn( matrix, index );

		},
		applyProjection: function ( m ) {

			console.warn( 'THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead.' );
			return this.applyMatrix4( m );

		},
		fromAttribute: function ( attribute, index, offset ) {

			console.error( 'THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute().' );
			return this.fromBufferAttribute( attribute, index, offset );

		}

	} );

	Object.assign( Vector4.prototype, {

		fromAttribute: function ( attribute, index, offset ) {

			console.error( 'THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute().' );
			return this.fromBufferAttribute( attribute, index, offset );

		}

	} );

	//

	Geometry.prototype.computeTangents = function () {

		console.warn( 'THREE.Geometry: .computeTangents() has been removed.' );

	};

	Object.assign( Object3D.prototype, {

		getChildByName: function ( name ) {

			console.warn( 'THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().' );
			return this.getObjectByName( name );

		},
		renderDepth: function () {

			console.warn( 'THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.' );

		},
		translate: function ( distance, axis ) {

			console.warn( 'THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.' );
			return this.translateOnAxis( axis, distance );

		}

	} );

	Object.defineProperties( Object3D.prototype, {

		eulerOrder: {
			get: function () {

				console.warn( 'THREE.Object3D: .eulerOrder is now .rotation.order.' );
				return this.rotation.order;

			},
			set: function ( value ) {

				console.warn( 'THREE.Object3D: .eulerOrder is now .rotation.order.' );
				this.rotation.order = value;

			}
		},
		useQuaternion: {
			get: function () {

				console.warn( 'THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.' );

			},
			set: function () {

				console.warn( 'THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.' );

			}
		}

	} );

	Object.defineProperties( LOD.prototype, {

		objects: {
			get: function () {

				console.warn( 'THREE.LOD: .objects has been renamed to .levels.' );
				return this.levels;

			}
		}

	} );

	Object.defineProperty( Skeleton.prototype, 'useVertexTexture', {

		get: function () {

			console.warn( 'THREE.Skeleton: useVertexTexture has been removed.' );

		},
		set: function () {

			console.warn( 'THREE.Skeleton: useVertexTexture has been removed.' );

		}

	} );

	Object.defineProperty( Curve.prototype, '__arcLengthDivisions', {

		get: function () {

			console.warn( 'THREE.Curve: .__arcLengthDivisions is now .arcLengthDivisions.' );
			return this.arcLengthDivisions;

		},
		set: function ( value ) {

			console.warn( 'THREE.Curve: .__arcLengthDivisions is now .arcLengthDivisions.' );
			this.arcLengthDivisions = value;

		}

	} );

	//

	PerspectiveCamera.prototype.setLens = function ( focalLength, filmGauge ) {

		console.warn( "THREE.PerspectiveCamera.setLens is deprecated. " +
				"Use .setFocalLength and .filmGauge for a photographic setup." );

		if ( filmGauge !== undefined ) this.filmGauge = filmGauge;
		this.setFocalLength( focalLength );

	};

	//

	Object.defineProperties( Light.prototype, {
		onlyShadow: {
			set: function () {

				console.warn( 'THREE.Light: .onlyShadow has been removed.' );

			}
		},
		shadowCameraFov: {
			set: function ( value ) {

				console.warn( 'THREE.Light: .shadowCameraFov is now .shadow.camera.fov.' );
				this.shadow.camera.fov = value;

			}
		},
		shadowCameraLeft: {
			set: function ( value ) {

				console.warn( 'THREE.Light: .shadowCameraLeft is now .shadow.camera.left.' );
				this.shadow.camera.left = value;

			}
		},
		shadowCameraRight: {
			set: function ( value ) {

				console.warn( 'THREE.Light: .shadowCameraRight is now .shadow.camera.right.' );
				this.shadow.camera.right = value;

			}
		},
		shadowCameraTop: {
			set: function ( value ) {

				console.warn( 'THREE.Light: .shadowCameraTop is now .shadow.camera.top.' );
				this.shadow.camera.top = value;

			}
		},
		shadowCameraBottom: {
			set: function ( value ) {

				console.warn( 'THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom.' );
				this.shadow.camera.bottom = value;

			}
		},
		shadowCameraNear: {
			set: function ( value ) {

				console.warn( 'THREE.Light: .shadowCameraNear is now .shadow.camera.near.' );
				this.shadow.camera.near = value;

			}
		},
		shadowCameraFar: {
			set: function ( value ) {

				console.warn( 'THREE.Light: .shadowCameraFar is now .shadow.camera.far.' );
				this.shadow.camera.far = value;

			}
		},
		shadowCameraVisible: {
			set: function () {

				console.warn( 'THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.' );

			}
		},
		shadowBias: {
			set: function ( value ) {

				console.warn( 'THREE.Light: .shadowBias is now .shadow.bias.' );
				this.shadow.bias = value;

			}
		},
		shadowDarkness: {
			set: function () {

				console.warn( 'THREE.Light: .shadowDarkness has been removed.' );

			}
		},
		shadowMapWidth: {
			set: function ( value ) {

				console.warn( 'THREE.Light: .shadowMapWidth is now .shadow.mapSize.width.' );
				this.shadow.mapSize.width = value;

			}
		},
		shadowMapHeight: {
			set: function ( value ) {

				console.warn( 'THREE.Light: .shadowMapHeight is now .shadow.mapSize.height.' );
				this.shadow.mapSize.height = value;

			}
		}
	} );

	//

	Object.defineProperties( BufferAttribute.prototype, {

		length: {
			get: function () {

				console.warn( 'THREE.BufferAttribute: .length has been deprecated. Use .count instead.' );
				return this.array.length;

			}
		}

	} );

	Object.assign( BufferGeometry.prototype, {

		addIndex: function ( index ) {

			console.warn( 'THREE.BufferGeometry: .addIndex() has been renamed to .setIndex().' );
			this.setIndex( index );

		},
		addDrawCall: function ( start, count, indexOffset ) {

			if ( indexOffset !== undefined ) {

				console.warn( 'THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset.' );

			}
			console.warn( 'THREE.BufferGeometry: .addDrawCall() is now .addGroup().' );
			this.addGroup( start, count );

		},
		clearDrawCalls: function () {

			console.warn( 'THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups().' );
			this.clearGroups();

		},
		computeTangents: function () {

			console.warn( 'THREE.BufferGeometry: .computeTangents() has been removed.' );

		},
		computeOffsets: function () {

			console.warn( 'THREE.BufferGeometry: .computeOffsets() has been removed.' );

		}

	} );

	Object.defineProperties( BufferGeometry.prototype, {

		drawcalls: {
			get: function () {

				console.error( 'THREE.BufferGeometry: .drawcalls has been renamed to .groups.' );
				return this.groups;

			}
		},
		offsets: {
			get: function () {

				console.warn( 'THREE.BufferGeometry: .offsets has been renamed to .groups.' );
				return this.groups;

			}
		}

	} );

	//

	Object.defineProperties( Uniform.prototype, {

		dynamic: {
			set: function () {

				console.warn( 'THREE.Uniform: .dynamic has been removed. Use object.onBeforeRender() instead.' );

			}
		},
		onUpdate: {
			value: function () {

				console.warn( 'THREE.Uniform: .onUpdate() has been removed. Use object.onBeforeRender() instead.' );
				return this;

			}
		}

	} );

	//

	Object.defineProperties( Material.prototype, {

		wrapAround: {
			get: function () {

				console.warn( 'THREE.Material: .wrapAround has been removed.' );

			},
			set: function () {

				console.warn( 'THREE.Material: .wrapAround has been removed.' );

			}
		},
		wrapRGB: {
			get: function () {

				console.warn( 'THREE.Material: .wrapRGB has been removed.' );
				return new Color();

			}
		},

		shading: {
			get: function () {

				console.error( 'THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.' );

			},
			set: function ( value ) {

				console.warn( 'THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.' );
				this.flatShading = ( value === FlatShading );

			}
		}

	} );

	Object.defineProperties( MeshPhongMaterial.prototype, {

		metal: {
			get: function () {

				console.warn( 'THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead.' );
				return false;

			},
			set: function () {

				console.warn( 'THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead' );

			}
		}

	} );

	Object.defineProperties( ShaderMaterial.prototype, {

		derivatives: {
			get: function () {

				console.warn( 'THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives.' );
				return this.extensions.derivatives;

			},
			set: function ( value ) {

				console.warn( 'THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives.' );
				this.extensions.derivatives = value;

			}
		}

	} );

	//

	Object.assign( WebGLRenderer.prototype, {

		getCurrentRenderTarget: function () {

			console.warn( 'THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget().' );
			return this.getRenderTarget();

		},

		getMaxAnisotropy: function () {

			console.warn( 'THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy().' );
			return this.capabilities.getMaxAnisotropy();

		},

		getPrecision: function () {

			console.warn( 'THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision.' );
			return this.capabilities.precision;

		},

		supportsFloatTextures: function () {

			console.warn( 'THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( \'OES_texture_float\' ).' );
			return this.extensions.get( 'OES_texture_float' );

		},
		supportsHalfFloatTextures: function () {

			console.warn( 'THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( \'OES_texture_half_float\' ).' );
			return this.extensions.get( 'OES_texture_half_float' );

		},
		supportsStandardDerivatives: function () {

			console.warn( 'THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( \'OES_standard_derivatives\' ).' );
			return this.extensions.get( 'OES_standard_derivatives' );

		},
		supportsCompressedTextureS3TC: function () {

			console.warn( 'THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( \'WEBGL_compressed_texture_s3tc\' ).' );
			return this.extensions.get( 'WEBGL_compressed_texture_s3tc' );

		},
		supportsCompressedTexturePVRTC: function () {

			console.warn( 'THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( \'WEBGL_compressed_texture_pvrtc\' ).' );
			return this.extensions.get( 'WEBGL_compressed_texture_pvrtc' );

		},
		supportsBlendMinMax: function () {

			console.warn( 'THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( \'EXT_blend_minmax\' ).' );
			return this.extensions.get( 'EXT_blend_minmax' );

		},
		supportsVertexTextures: function () {

			console.warn( 'THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures.' );
			return this.capabilities.vertexTextures;

		},
		supportsInstancedArrays: function () {

			console.warn( 'THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( \'ANGLE_instanced_arrays\' ).' );
			return this.extensions.get( 'ANGLE_instanced_arrays' );

		},
		enableScissorTest: function ( boolean ) {

			console.warn( 'THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest().' );
			this.setScissorTest( boolean );

		},
		initMaterial: function () {

			console.warn( 'THREE.WebGLRenderer: .initMaterial() has been removed.' );

		},
		addPrePlugin: function () {

			console.warn( 'THREE.WebGLRenderer: .addPrePlugin() has been removed.' );

		},
		addPostPlugin: function () {

			console.warn( 'THREE.WebGLRenderer: .addPostPlugin() has been removed.' );

		},
		updateShadowMap: function () {

			console.warn( 'THREE.WebGLRenderer: .updateShadowMap() has been removed.' );

		}

	} );

	Object.defineProperties( WebGLRenderer.prototype, {

		shadowMapEnabled: {
			get: function () {

				return this.shadowMap.enabled;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled.' );
				this.shadowMap.enabled = value;

			}
		},
		shadowMapType: {
			get: function () {

				return this.shadowMap.type;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type.' );
				this.shadowMap.type = value;

			}
		},
		shadowMapCullFace: {
			get: function () {

				return this.shadowMap.cullFace;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderer: .shadowMapCullFace is now .shadowMap.cullFace.' );
				this.shadowMap.cullFace = value;

			}
		}
	} );

	Object.defineProperties( WebGLShadowMap.prototype, {

		cullFace: {
			get: function () {

				return this.renderReverseSided ? CullFaceFront : CullFaceBack;

			},
			set: function ( cullFace ) {

				var value = ( cullFace !== CullFaceBack );
				console.warn( "WebGLRenderer: .shadowMap.cullFace is deprecated. Set .shadowMap.renderReverseSided to " + value + "." );
				this.renderReverseSided = value;

			}
		}

	} );

	//

	Object.defineProperties( WebGLRenderTarget.prototype, {

		wrapS: {
			get: function () {

				console.warn( 'THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.' );
				return this.texture.wrapS;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.' );
				this.texture.wrapS = value;

			}
		},
		wrapT: {
			get: function () {

				console.warn( 'THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.' );
				return this.texture.wrapT;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.' );
				this.texture.wrapT = value;

			}
		},
		magFilter: {
			get: function () {

				console.warn( 'THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.' );
				return this.texture.magFilter;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.' );
				this.texture.magFilter = value;

			}
		},
		minFilter: {
			get: function () {

				console.warn( 'THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.' );
				return this.texture.minFilter;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.' );
				this.texture.minFilter = value;

			}
		},
		anisotropy: {
			get: function () {

				console.warn( 'THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.' );
				return this.texture.anisotropy;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.' );
				this.texture.anisotropy = value;

			}
		},
		offset: {
			get: function () {

				console.warn( 'THREE.WebGLRenderTarget: .offset is now .texture.offset.' );
				return this.texture.offset;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderTarget: .offset is now .texture.offset.' );
				this.texture.offset = value;

			}
		},
		repeat: {
			get: function () {

				console.warn( 'THREE.WebGLRenderTarget: .repeat is now .texture.repeat.' );
				return this.texture.repeat;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderTarget: .repeat is now .texture.repeat.' );
				this.texture.repeat = value;

			}
		},
		format: {
			get: function () {

				console.warn( 'THREE.WebGLRenderTarget: .format is now .texture.format.' );
				return this.texture.format;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderTarget: .format is now .texture.format.' );
				this.texture.format = value;

			}
		},
		type: {
			get: function () {

				console.warn( 'THREE.WebGLRenderTarget: .type is now .texture.type.' );
				return this.texture.type;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderTarget: .type is now .texture.type.' );
				this.texture.type = value;

			}
		},
		generateMipmaps: {
			get: function () {

				console.warn( 'THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.' );
				return this.texture.generateMipmaps;

			},
			set: function ( value ) {

				console.warn( 'THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.' );
				this.texture.generateMipmaps = value;

			}
		}

	} );

	//

	Audio.prototype.load = function ( file ) {

		console.warn( 'THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.' );
		var scope = this;
		var audioLoader = new AudioLoader();
		audioLoader.load( file, function ( buffer ) {

			scope.setBuffer( buffer );

		} );
		return this;

	};

	AudioAnalyser.prototype.getData = function () {

		console.warn( 'THREE.AudioAnalyser: .getData() is now .getFrequencyData().' );
		return this.getFrequencyData();

	};

	//

	CubeCamera.prototype.updateCubeMap = function ( renderer, scene ) {

		console.warn( 'THREE.CubeCamera: .updateCubeMap() is now .update().' );
		return this.update( renderer, scene );

	};

	//

	var GeometryUtils = {

		merge: function ( geometry1, geometry2, materialIndexOffset ) {

			console.warn( 'THREE.GeometryUtils: .merge() has been moved to Geometry. Use geometry.merge( geometry2, matrix, materialIndexOffset ) instead.' );
			var matrix;

			if ( geometry2.isMesh ) {

				geometry2.matrixAutoUpdate && geometry2.updateMatrix();

				matrix = geometry2.matrix;
				geometry2 = geometry2.geometry;

			}

			geometry1.merge( geometry2, matrix, materialIndexOffset );

		},

		center: function ( geometry ) {

			console.warn( 'THREE.GeometryUtils: .center() has been moved to Geometry. Use geometry.center() instead.' );
			return geometry.center();

		}

	};

	var ImageUtils = {

		crossOrigin: undefined,

		loadTexture: function ( url, mapping, onLoad, onError ) {

			console.warn( 'THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.' );

			var loader = new TextureLoader();
			loader.setCrossOrigin( this.crossOrigin );

			var texture = loader.load( url, onLoad, undefined, onError );

			if ( mapping ) texture.mapping = mapping;

			return texture;

		},

		loadTextureCube: function ( urls, mapping, onLoad, onError ) {

			console.warn( 'THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.' );

			var loader = new CubeTextureLoader();
			loader.setCrossOrigin( this.crossOrigin );

			var texture = loader.load( urls, onLoad, undefined, onError );

			if ( mapping ) texture.mapping = mapping;

			return texture;

		},

		loadCompressedTexture: function () {

			console.error( 'THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.' );

		},

		loadCompressedTextureCube: function () {

			console.error( 'THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.' );

		}

	};

	//

	function Projector() {

		console.error( 'THREE.Projector has been moved to /examples/js/renderers/Projector.js.' );

		this.projectVector = function ( vector, camera ) {

			console.warn( 'THREE.Projector: .projectVector() is now vector.project().' );
			vector.project( camera );

		};

		this.unprojectVector = function ( vector, camera ) {

			console.warn( 'THREE.Projector: .unprojectVector() is now vector.unproject().' );
			vector.unproject( camera );

		};

		this.pickingRay = function () {

			console.error( 'THREE.Projector: .pickingRay() is now raycaster.setFromCamera().' );

		};

	}

	//

	function CanvasRenderer() {

		console.error( 'THREE.CanvasRenderer has been moved to /examples/js/renderers/CanvasRenderer.js' );

		this.domElement = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
		this.clear = function () {};
		this.render = function () {};
		this.setClearColor = function () {};
		this.setSize = function () {};

	}

	exports.WebGLRenderTargetCube = WebGLRenderTargetCube;
	exports.WebGLRenderTarget = WebGLRenderTarget;
	exports.WebGLRenderer = WebGLRenderer;
	exports.ShaderLib = ShaderLib;
	exports.UniformsLib = UniformsLib;
	exports.UniformsUtils = UniformsUtils;
	exports.ShaderChunk = ShaderChunk;
	exports.FogExp2 = FogExp2;
	exports.Fog = Fog;
	exports.Scene = Scene;
	exports.LensFlare = LensFlare;
	exports.Sprite = Sprite;
	exports.LOD = LOD;
	exports.SkinnedMesh = SkinnedMesh;
	exports.Skeleton = Skeleton;
	exports.Bone = Bone;
	exports.Mesh = Mesh;
	exports.LineSegments = LineSegments;
	exports.LineLoop = LineLoop;
	exports.Line = Line;
	exports.Points = Points;
	exports.Group = Group;
	exports.VideoTexture = VideoTexture;
	exports.DataTexture = DataTexture;
	exports.CompressedTexture = CompressedTexture;
	exports.CubeTexture = CubeTexture;
	exports.CanvasTexture = CanvasTexture;
	exports.DepthTexture = DepthTexture;
	exports.Texture = Texture;
	exports.CompressedTextureLoader = CompressedTextureLoader;
	exports.DataTextureLoader = DataTextureLoader;
	exports.CubeTextureLoader = CubeTextureLoader;
	exports.TextureLoader = TextureLoader;
	exports.ObjectLoader = ObjectLoader;
	exports.MaterialLoader = MaterialLoader;
	exports.BufferGeometryLoader = BufferGeometryLoader;
	exports.DefaultLoadingManager = DefaultLoadingManager;
	exports.LoadingManager = LoadingManager;
	exports.JSONLoader = JSONLoader;
	exports.ImageLoader = ImageLoader;
	exports.FontLoader = FontLoader;
	exports.FileLoader = FileLoader;
	exports.Loader = Loader;
	exports.Cache = Cache;
	exports.AudioLoader = AudioLoader;
	exports.SpotLightShadow = SpotLightShadow;
	exports.SpotLight = SpotLight;
	exports.PointLight = PointLight;
	exports.RectAreaLight = RectAreaLight;
	exports.HemisphereLight = HemisphereLight;
	exports.DirectionalLightShadow = DirectionalLightShadow;
	exports.DirectionalLight = DirectionalLight;
	exports.AmbientLight = AmbientLight;
	exports.LightShadow = LightShadow;
	exports.Light = Light;
	exports.StereoCamera = StereoCamera;
	exports.PerspectiveCamera = PerspectiveCamera;
	exports.OrthographicCamera = OrthographicCamera;
	exports.CubeCamera = CubeCamera;
	exports.ArrayCamera = ArrayCamera;
	exports.Camera = Camera;
	exports.AudioListener = AudioListener;
	exports.PositionalAudio = PositionalAudio;
	exports.AudioContext = AudioContext;
	exports.AudioAnalyser = AudioAnalyser;
	exports.Audio = Audio;
	exports.VectorKeyframeTrack = VectorKeyframeTrack;
	exports.StringKeyframeTrack = StringKeyframeTrack;
	exports.QuaternionKeyframeTrack = QuaternionKeyframeTrack;
	exports.NumberKeyframeTrack = NumberKeyframeTrack;
	exports.ColorKeyframeTrack = ColorKeyframeTrack;
	exports.BooleanKeyframeTrack = BooleanKeyframeTrack;
	exports.PropertyMixer = PropertyMixer;
	exports.PropertyBinding = PropertyBinding;
	exports.KeyframeTrack = KeyframeTrack;
	exports.AnimationUtils = AnimationUtils;
	exports.AnimationObjectGroup = AnimationObjectGroup;
	exports.AnimationMixer = AnimationMixer;
	exports.AnimationClip = AnimationClip;
	exports.Uniform = Uniform;
	exports.InstancedBufferGeometry = InstancedBufferGeometry;
	exports.BufferGeometry = BufferGeometry;
	exports.GeometryIdCount = GeometryIdCount;
	exports.Geometry = Geometry;
	exports.InterleavedBufferAttribute = InterleavedBufferAttribute;
	exports.InstancedInterleavedBuffer = InstancedInterleavedBuffer;
	exports.InterleavedBuffer = InterleavedBuffer;
	exports.InstancedBufferAttribute = InstancedBufferAttribute;
	exports.Face3 = Face3;
	exports.Object3D = Object3D;
	exports.Raycaster = Raycaster;
	exports.Layers = Layers;
	exports.EventDispatcher = EventDispatcher;
	exports.Clock = Clock;
	exports.QuaternionLinearInterpolant = QuaternionLinearInterpolant;
	exports.LinearInterpolant = LinearInterpolant;
	exports.DiscreteInterpolant = DiscreteInterpolant;
	exports.CubicInterpolant = CubicInterpolant;
	exports.Interpolant = Interpolant;
	exports.Triangle = Triangle;
	exports.Math = _Math;
	exports.Spherical = Spherical;
	exports.Cylindrical = Cylindrical;
	exports.Plane = Plane;
	exports.Frustum = Frustum;
	exports.Sphere = Sphere;
	exports.Ray = Ray;
	exports.Matrix4 = Matrix4;
	exports.Matrix3 = Matrix3;
	exports.Box3 = Box3;
	exports.Box2 = Box2;
	exports.Line3 = Line3;
	exports.Euler = Euler;
	exports.Vector4 = Vector4;
	exports.Vector3 = Vector3;
	exports.Vector2 = Vector2;
	exports.Quaternion = Quaternion;
	exports.Color = Color;
	exports.ImmediateRenderObject = ImmediateRenderObject;
	exports.VertexNormalsHelper = VertexNormalsHelper;
	exports.SpotLightHelper = SpotLightHelper;
	exports.SkeletonHelper = SkeletonHelper;
	exports.PointLightHelper = PointLightHelper;
	exports.RectAreaLightHelper = RectAreaLightHelper;
	exports.HemisphereLightHelper = HemisphereLightHelper;
	exports.GridHelper = GridHelper;
	exports.PolarGridHelper = PolarGridHelper;
	exports.FaceNormalsHelper = FaceNormalsHelper;
	exports.DirectionalLightHelper = DirectionalLightHelper;
	exports.CameraHelper = CameraHelper;
	exports.BoxHelper = BoxHelper;
	exports.Box3Helper = Box3Helper;
	exports.PlaneHelper = PlaneHelper;
	exports.ArrowHelper = ArrowHelper;
	exports.AxisHelper = AxisHelper;
	exports.CatmullRomCurve3 = CatmullRomCurve3;
	exports.CubicBezierCurve3 = CubicBezierCurve3;
	exports.QuadraticBezierCurve3 = QuadraticBezierCurve3;
	exports.LineCurve3 = LineCurve3;
	exports.ArcCurve = ArcCurve;
	exports.EllipseCurve = EllipseCurve;
	exports.SplineCurve = SplineCurve;
	exports.CubicBezierCurve = CubicBezierCurve;
	exports.QuadraticBezierCurve = QuadraticBezierCurve;
	exports.LineCurve = LineCurve;
	exports.Shape = Shape;
	exports.Path = Path;
	exports.ShapePath = ShapePath;
	exports.Font = Font;
	exports.CurvePath = CurvePath;
	exports.Curve = Curve;
	exports.ShapeUtils = ShapeUtils;
	exports.SceneUtils = SceneUtils;
	exports.WebGLUtils = WebGLUtils;
	exports.WireframeGeometry = WireframeGeometry;
	exports.ParametricGeometry = ParametricGeometry;
	exports.ParametricBufferGeometry = ParametricBufferGeometry;
	exports.TetrahedronGeometry = TetrahedronGeometry;
	exports.TetrahedronBufferGeometry = TetrahedronBufferGeometry;
	exports.OctahedronGeometry = OctahedronGeometry;
	exports.OctahedronBufferGeometry = OctahedronBufferGeometry;
	exports.IcosahedronGeometry = IcosahedronGeometry;
	exports.IcosahedronBufferGeometry = IcosahedronBufferGeometry;
	exports.DodecahedronGeometry = DodecahedronGeometry;
	exports.DodecahedronBufferGeometry = DodecahedronBufferGeometry;
	exports.PolyhedronGeometry = PolyhedronGeometry;
	exports.PolyhedronBufferGeometry = PolyhedronBufferGeometry;
	exports.TubeGeometry = TubeGeometry;
	exports.TubeBufferGeometry = TubeBufferGeometry;
	exports.TorusKnotGeometry = TorusKnotGeometry;
	exports.TorusKnotBufferGeometry = TorusKnotBufferGeometry;
	exports.TorusGeometry = TorusGeometry;
	exports.TorusBufferGeometry = TorusBufferGeometry;
	exports.TextGeometry = TextGeometry;
	exports.TextBufferGeometry = TextBufferGeometry;
	exports.SphereGeometry = SphereGeometry;
	exports.SphereBufferGeometry = SphereBufferGeometry;
	exports.RingGeometry = RingGeometry;
	exports.RingBufferGeometry = RingBufferGeometry;
	exports.PlaneGeometry = PlaneGeometry;
	exports.PlaneBufferGeometry = PlaneBufferGeometry;
	exports.LatheGeometry = LatheGeometry;
	exports.LatheBufferGeometry = LatheBufferGeometry;
	exports.ShapeGeometry = ShapeGeometry;
	exports.ShapeBufferGeometry = ShapeBufferGeometry;
	exports.ExtrudeGeometry = ExtrudeGeometry;
	exports.ExtrudeBufferGeometry = ExtrudeBufferGeometry;
	exports.EdgesGeometry = EdgesGeometry;
	exports.ConeGeometry = ConeGeometry;
	exports.ConeBufferGeometry = ConeBufferGeometry;
	exports.CylinderGeometry = CylinderGeometry;
	exports.CylinderBufferGeometry = CylinderBufferGeometry;
	exports.CircleGeometry = CircleGeometry;
	exports.CircleBufferGeometry = CircleBufferGeometry;
	exports.BoxGeometry = BoxGeometry;
	exports.BoxBufferGeometry = BoxBufferGeometry;
	exports.ShadowMaterial = ShadowMaterial;
	exports.SpriteMaterial = SpriteMaterial;
	exports.RawShaderMaterial = RawShaderMaterial;
	exports.ShaderMaterial = ShaderMaterial;
	exports.PointsMaterial = PointsMaterial;
	exports.MeshPhysicalMaterial = MeshPhysicalMaterial;
	exports.MeshStandardMaterial = MeshStandardMaterial;
	exports.MeshPhongMaterial = MeshPhongMaterial;
	exports.MeshToonMaterial = MeshToonMaterial;
	exports.MeshNormalMaterial = MeshNormalMaterial;
	exports.MeshLambertMaterial = MeshLambertMaterial;
	exports.MeshDepthMaterial = MeshDepthMaterial;
	exports.MeshDistanceMaterial = MeshDistanceMaterial;
	exports.MeshBasicMaterial = MeshBasicMaterial;
	exports.LineDashedMaterial = LineDashedMaterial;
	exports.LineBasicMaterial = LineBasicMaterial;
	exports.Material = Material;
	exports.Float64BufferAttribute = Float64BufferAttribute;
	exports.Float32BufferAttribute = Float32BufferAttribute;
	exports.Uint32BufferAttribute = Uint32BufferAttribute;
	exports.Int32BufferAttribute = Int32BufferAttribute;
	exports.Uint16BufferAttribute = Uint16BufferAttribute;
	exports.Int16BufferAttribute = Int16BufferAttribute;
	exports.Uint8ClampedBufferAttribute = Uint8ClampedBufferAttribute;
	exports.Uint8BufferAttribute = Uint8BufferAttribute;
	exports.Int8BufferAttribute = Int8BufferAttribute;
	exports.BufferAttribute = BufferAttribute;
	exports.REVISION = REVISION;
	exports.MOUSE = MOUSE;
	exports.CullFaceNone = CullFaceNone;
	exports.CullFaceBack = CullFaceBack;
	exports.CullFaceFront = CullFaceFront;
	exports.CullFaceFrontBack = CullFaceFrontBack;
	exports.FrontFaceDirectionCW = FrontFaceDirectionCW;
	exports.FrontFaceDirectionCCW = FrontFaceDirectionCCW;
	exports.BasicShadowMap = BasicShadowMap;
	exports.PCFShadowMap = PCFShadowMap;
	exports.PCFSoftShadowMap = PCFSoftShadowMap;
	exports.FrontSide = FrontSide;
	exports.BackSide = BackSide;
	exports.DoubleSide = DoubleSide;
	exports.FlatShading = FlatShading;
	exports.SmoothShading = SmoothShading;
	exports.NoColors = NoColors;
	exports.FaceColors = FaceColors;
	exports.VertexColors = VertexColors;
	exports.NoBlending = NoBlending;
	exports.NormalBlending = NormalBlending;
	exports.AdditiveBlending = AdditiveBlending;
	exports.SubtractiveBlending = SubtractiveBlending;
	exports.MultiplyBlending = MultiplyBlending;
	exports.CustomBlending = CustomBlending;
	exports.AddEquation = AddEquation;
	exports.SubtractEquation = SubtractEquation;
	exports.ReverseSubtractEquation = ReverseSubtractEquation;
	exports.MinEquation = MinEquation;
	exports.MaxEquation = MaxEquation;
	exports.ZeroFactor = ZeroFactor;
	exports.OneFactor = OneFactor;
	exports.SrcColorFactor = SrcColorFactor;
	exports.OneMinusSrcColorFactor = OneMinusSrcColorFactor;
	exports.SrcAlphaFactor = SrcAlphaFactor;
	exports.OneMinusSrcAlphaFactor = OneMinusSrcAlphaFactor;
	exports.DstAlphaFactor = DstAlphaFactor;
	exports.OneMinusDstAlphaFactor = OneMinusDstAlphaFactor;
	exports.DstColorFactor = DstColorFactor;
	exports.OneMinusDstColorFactor = OneMinusDstColorFactor;
	exports.SrcAlphaSaturateFactor = SrcAlphaSaturateFactor;
	exports.NeverDepth = NeverDepth;
	exports.AlwaysDepth = AlwaysDepth;
	exports.LessDepth = LessDepth;
	exports.LessEqualDepth = LessEqualDepth;
	exports.EqualDepth = EqualDepth;
	exports.GreaterEqualDepth = GreaterEqualDepth;
	exports.GreaterDepth = GreaterDepth;
	exports.NotEqualDepth = NotEqualDepth;
	exports.MultiplyOperation = MultiplyOperation;
	exports.MixOperation = MixOperation;
	exports.AddOperation = AddOperation;
	exports.NoToneMapping = NoToneMapping;
	exports.LinearToneMapping = LinearToneMapping;
	exports.ReinhardToneMapping = ReinhardToneMapping;
	exports.Uncharted2ToneMapping = Uncharted2ToneMapping;
	exports.CineonToneMapping = CineonToneMapping;
	exports.UVMapping = UVMapping;
	exports.CubeReflectionMapping = CubeReflectionMapping;
	exports.CubeRefractionMapping = CubeRefractionMapping;
	exports.EquirectangularReflectionMapping = EquirectangularReflectionMapping;
	exports.EquirectangularRefractionMapping = EquirectangularRefractionMapping;
	exports.SphericalReflectionMapping = SphericalReflectionMapping;
	exports.CubeUVReflectionMapping = CubeUVReflectionMapping;
	exports.CubeUVRefractionMapping = CubeUVRefractionMapping;
	exports.RepeatWrapping = RepeatWrapping;
	exports.ClampToEdgeWrapping = ClampToEdgeWrapping;
	exports.MirroredRepeatWrapping = MirroredRepeatWrapping;
	exports.NearestFilter = NearestFilter;
	exports.NearestMipMapNearestFilter = NearestMipMapNearestFilter;
	exports.NearestMipMapLinearFilter = NearestMipMapLinearFilter;
	exports.LinearFilter = LinearFilter;
	exports.LinearMipMapNearestFilter = LinearMipMapNearestFilter;
	exports.LinearMipMapLinearFilter = LinearMipMapLinearFilter;
	exports.UnsignedByteType = UnsignedByteType;
	exports.ByteType = ByteType;
	exports.ShortType = ShortType;
	exports.UnsignedShortType = UnsignedShortType;
	exports.IntType = IntType;
	exports.UnsignedIntType = UnsignedIntType;
	exports.FloatType = FloatType;
	exports.HalfFloatType = HalfFloatType;
	exports.UnsignedShort4444Type = UnsignedShort4444Type;
	exports.UnsignedShort5551Type = UnsignedShort5551Type;
	exports.UnsignedShort565Type = UnsignedShort565Type;
	exports.UnsignedInt248Type = UnsignedInt248Type;
	exports.AlphaFormat = AlphaFormat;
	exports.RGBFormat = RGBFormat;
	exports.RGBAFormat = RGBAFormat;
	exports.LuminanceFormat = LuminanceFormat;
	exports.LuminanceAlphaFormat = LuminanceAlphaFormat;
	exports.RGBEFormat = RGBEFormat;
	exports.DepthFormat = DepthFormat;
	exports.DepthStencilFormat = DepthStencilFormat;
	exports.RGB_S3TC_DXT1_Format = RGB_S3TC_DXT1_Format;
	exports.RGBA_S3TC_DXT1_Format = RGBA_S3TC_DXT1_Format;
	exports.RGBA_S3TC_DXT3_Format = RGBA_S3TC_DXT3_Format;
	exports.RGBA_S3TC_DXT5_Format = RGBA_S3TC_DXT5_Format;
	exports.RGB_PVRTC_4BPPV1_Format = RGB_PVRTC_4BPPV1_Format;
	exports.RGB_PVRTC_2BPPV1_Format = RGB_PVRTC_2BPPV1_Format;
	exports.RGBA_PVRTC_4BPPV1_Format = RGBA_PVRTC_4BPPV1_Format;
	exports.RGBA_PVRTC_2BPPV1_Format = RGBA_PVRTC_2BPPV1_Format;
	exports.RGB_ETC1_Format = RGB_ETC1_Format;
	exports.LoopOnce = LoopOnce;
	exports.LoopRepeat = LoopRepeat;
	exports.LoopPingPong = LoopPingPong;
	exports.InterpolateDiscrete = InterpolateDiscrete;
	exports.InterpolateLinear = InterpolateLinear;
	exports.InterpolateSmooth = InterpolateSmooth;
	exports.ZeroCurvatureEnding = ZeroCurvatureEnding;
	exports.ZeroSlopeEnding = ZeroSlopeEnding;
	exports.WrapAroundEnding = WrapAroundEnding;
	exports.TrianglesDrawMode = TrianglesDrawMode;
	exports.TriangleStripDrawMode = TriangleStripDrawMode;
	exports.TriangleFanDrawMode = TriangleFanDrawMode;
	exports.LinearEncoding = LinearEncoding;
	exports.sRGBEncoding = sRGBEncoding;
	exports.GammaEncoding = GammaEncoding;
	exports.RGBEEncoding = RGBEEncoding;
	exports.LogLuvEncoding = LogLuvEncoding;
	exports.RGBM7Encoding = RGBM7Encoding;
	exports.RGBM16Encoding = RGBM16Encoding;
	exports.RGBDEncoding = RGBDEncoding;
	exports.BasicDepthPacking = BasicDepthPacking;
	exports.RGBADepthPacking = RGBADepthPacking;
	exports.CubeGeometry = BoxGeometry;
	exports.Face4 = Face4;
	exports.LineStrip = LineStrip;
	exports.LinePieces = LinePieces;
	exports.MeshFaceMaterial = MeshFaceMaterial;
	exports.MultiMaterial = MultiMaterial;
	exports.PointCloud = PointCloud;
	exports.Particle = Particle;
	exports.ParticleSystem = ParticleSystem;
	exports.PointCloudMaterial = PointCloudMaterial;
	exports.ParticleBasicMaterial = ParticleBasicMaterial;
	exports.ParticleSystemMaterial = ParticleSystemMaterial;
	exports.Vertex = Vertex;
	exports.DynamicBufferAttribute = DynamicBufferAttribute;
	exports.Int8Attribute = Int8Attribute;
	exports.Uint8Attribute = Uint8Attribute;
	exports.Uint8ClampedAttribute = Uint8ClampedAttribute;
	exports.Int16Attribute = Int16Attribute;
	exports.Uint16Attribute = Uint16Attribute;
	exports.Int32Attribute = Int32Attribute;
	exports.Uint32Attribute = Uint32Attribute;
	exports.Float32Attribute = Float32Attribute;
	exports.Float64Attribute = Float64Attribute;
	exports.ClosedSplineCurve3 = ClosedSplineCurve3;
	exports.SplineCurve3 = SplineCurve3;
	exports.Spline = Spline;
	exports.BoundingBoxHelper = BoundingBoxHelper;
	exports.EdgesHelper = EdgesHelper;
	exports.WireframeHelper = WireframeHelper;
	exports.XHRLoader = XHRLoader;
	exports.BinaryTextureLoader = BinaryTextureLoader;
	exports.GeometryUtils = GeometryUtils;
	exports.ImageUtils = ImageUtils;
	exports.Projector = Projector;
	exports.CanvasRenderer = CanvasRenderer;

	Object.defineProperty(exports, '__esModule', { value: true });

})));

/**
 * @author mrdoob / http://mrdoob.com/
 */

THREE.SpriteCanvasMaterial = function ( parameters ) {

	THREE.Material.call( this );

	this.type = 'SpriteCanvasMaterial';

	this.color = new THREE.Color( 0xffffff );
	this.program = function () {};

	this.setValues( parameters );

};

THREE.SpriteCanvasMaterial.prototype = Object.create( THREE.Material.prototype );
THREE.SpriteCanvasMaterial.prototype.constructor = THREE.SpriteCanvasMaterial;
THREE.SpriteCanvasMaterial.prototype.isSpriteCanvasMaterial = true;

THREE.SpriteCanvasMaterial.prototype.clone = function () {

	var material = new THREE.SpriteCanvasMaterial();

	material.copy( this );
	material.color.copy( this.color );
	material.program = this.program;

	return material;

};

//

THREE.CanvasRenderer = function ( parameters ) {

	console.log( 'THREE.CanvasRenderer', THREE.REVISION );

	parameters = parameters || {};

	var _this = this,
		_renderData, _elements, _lights,
		_projector = new THREE.Projector(),

		_canvas = parameters.canvas !== undefined
				 ? parameters.canvas
				 : document.createElement( 'canvas' ),

		_canvasWidth = _canvas.width,
		_canvasHeight = _canvas.height,
		_canvasWidthHalf = Math.floor( _canvasWidth / 2 ),
		_canvasHeightHalf = Math.floor( _canvasHeight / 2 ),

		_viewportX = 0,
		_viewportY = 0,
		_viewportWidth = _canvasWidth,
		_viewportHeight = _canvasHeight,

		_pixelRatio = 1,

		_context = _canvas.getContext( '2d', {
			alpha: parameters.alpha === true
		} ),

		_clearColor = new THREE.Color( 0x000000 ),
		_clearAlpha = parameters.alpha === true ? 0 : 1,

		_contextGlobalAlpha = 1,
		_contextGlobalCompositeOperation = 0,
		_contextStrokeStyle = null,
		_contextFillStyle = null,
		_contextLineWidth = null,
		_contextLineCap = null,
		_contextLineJoin = null,
		_contextLineDash = [],

		_v1, _v2, _v3,

		_v1x, _v1y, _v2x, _v2y, _v3x, _v3y,

		_color = new THREE.Color(),

		_diffuseColor = new THREE.Color(),
		_emissiveColor = new THREE.Color(),

		_lightColor = new THREE.Color(),

		_patterns = {},

		_uvs,
		_uv1x, _uv1y, _uv2x, _uv2y, _uv3x, _uv3y,

		_clipBox = new THREE.Box2(),
		_clearBox = new THREE.Box2(),
		_elemBox = new THREE.Box2(),

		_ambientLight = new THREE.Color(),
		_directionalLights = new THREE.Color(),
		_pointLights = new THREE.Color(),

		_vector3 = new THREE.Vector3(), // Needed for PointLight
		_centroid = new THREE.Vector3(),
		_normal = new THREE.Vector3(),
		_normalViewMatrix = new THREE.Matrix3();

	/* TODO
	_canvas.mozImageSmoothingEnabled = false;
	_canvas.webkitImageSmoothingEnabled = false;
	_canvas.msImageSmoothingEnabled = false;
	_canvas.imageSmoothingEnabled = false;
	*/

	// dash+gap fallbacks for Firefox and everything else

	if ( _context.setLineDash === undefined ) {

		_context.setLineDash = function () {};

	}

	this.domElement = _canvas;

	this.autoClear = true;
	this.sortObjects = true;
	this.sortElements = true;

	this.info = {

		render: {

			vertices: 0,
			faces: 0

		}

	};

	// WebGLRenderer compatibility

	this.supportsVertexTextures = function () {};
	this.setFaceCulling = function () {};

	// API

	this.getContext = function () {

		return _context;

	};

	this.getContextAttributes = function () {

		return _context.getContextAttributes();

	};

	this.getPixelRatio = function () {

		return _pixelRatio;

	};

	this.setPixelRatio = function ( value ) {

		if ( value !== undefined ) _pixelRatio = value;

	};

	this.setSize = function ( width, height, updateStyle ) {

		_canvasWidth = width * _pixelRatio;
		_canvasHeight = height * _pixelRatio;

		_canvas.width = _canvasWidth;
		_canvas.height = _canvasHeight;

		_canvasWidthHalf = Math.floor( _canvasWidth / 2 );
		_canvasHeightHalf = Math.floor( _canvasHeight / 2 );

		if ( updateStyle !== false ) {

			_canvas.style.width = width + 'px';
			_canvas.style.height = height + 'px';

		}

		_clipBox.min.set( - _canvasWidthHalf, - _canvasHeightHalf );
		_clipBox.max.set(   _canvasWidthHalf,   _canvasHeightHalf );

		_clearBox.min.set( - _canvasWidthHalf, - _canvasHeightHalf );
		_clearBox.max.set(   _canvasWidthHalf,   _canvasHeightHalf );

		_contextGlobalAlpha = 1;
		_contextGlobalCompositeOperation = 0;
		_contextStrokeStyle = null;
		_contextFillStyle = null;
		_contextLineWidth = null;
		_contextLineCap = null;
		_contextLineJoin = null;

		this.setViewport( 0, 0, width, height );

	};

	this.setViewport = function ( x, y, width, height ) {

		_viewportX = x * _pixelRatio;
		_viewportY = y * _pixelRatio;

		_viewportWidth = width * _pixelRatio;
		_viewportHeight = height * _pixelRatio;

	};

	this.setScissor = function () {};
	this.setScissorTest = function () {};

	this.setClearColor = function ( color, alpha ) {

		_clearColor.set( color );
		_clearAlpha = alpha !== undefined ? alpha : 1;

		_clearBox.min.set( - _canvasWidthHalf, - _canvasHeightHalf );
		_clearBox.max.set(   _canvasWidthHalf,   _canvasHeightHalf );

	};

	this.setClearColorHex = function ( hex, alpha ) {

		console.warn( 'THREE.CanvasRenderer: .setClearColorHex() is being removed. Use .setClearColor() instead.' );
		this.setClearColor( hex, alpha );

	};

	this.getClearColor = function () {

		return _clearColor;

	};

	this.getClearAlpha = function () {

		return _clearAlpha;

	};

	this.getMaxAnisotropy = function () {

		return 0;

	};

	this.clear = function () {

		if ( _clearBox.isEmpty() === false ) {

			_clearBox.intersect( _clipBox );
			_clearBox.expandByScalar( 2 );

			_clearBox.min.x =   _clearBox.min.x + _canvasWidthHalf;
			_clearBox.min.y = - _clearBox.min.y + _canvasHeightHalf;		// higher y value !
			_clearBox.max.x =   _clearBox.max.x + _canvasWidthHalf;
			_clearBox.max.y = - _clearBox.max.y + _canvasHeightHalf;		// lower y value !

			if ( _clearAlpha < 1 ) {

				_context.clearRect(
					_clearBox.min.x | 0,
					_clearBox.max.y | 0,
					( _clearBox.max.x - _clearBox.min.x ) | 0,
					( _clearBox.min.y - _clearBox.max.y ) | 0
				);

			}

			if ( _clearAlpha > 0 ) {

				setOpacity( 1 );
				setBlending( THREE.NormalBlending );

				setFillStyle( 'rgba(' + Math.floor( _clearColor.r * 255 ) + ',' + Math.floor( _clearColor.g * 255 ) + ',' + Math.floor( _clearColor.b * 255 ) + ',' + _clearAlpha + ')' );

				_context.fillRect(
					_clearBox.min.x | 0,
					_clearBox.max.y | 0,
					( _clearBox.max.x - _clearBox.min.x ) | 0,
					( _clearBox.min.y - _clearBox.max.y ) | 0
				);

			}

			_clearBox.makeEmpty();

		}

	};

	// compatibility

	this.clearColor = function () {};
	this.clearDepth = function () {};
	this.clearStencil = function () {};

	this.render = function ( scene, camera ) {

		if ( camera.isCamera === undefined ) {

			console.error( 'THREE.CanvasRenderer.render: camera is not an instance of THREE.Camera.' );
			return;

		}

		var background = scene.background;

		if ( background && background.isColor ) {

			setOpacity( 1 );
			setBlending( THREE.NormalBlending );

			setFillStyle( background.getStyle() );
			_context.fillRect( 0, 0, _canvasWidth, _canvasHeight );

		} else if ( this.autoClear === true ) {

			this.clear();

		}

		_this.info.render.vertices = 0;
		_this.info.render.faces = 0;

		_context.setTransform( _viewportWidth / _canvasWidth, 0, 0, - _viewportHeight / _canvasHeight, _viewportX, _canvasHeight - _viewportY );
		_context.translate( _canvasWidthHalf, _canvasHeightHalf );

		_renderData = _projector.projectScene( scene, camera, this.sortObjects, this.sortElements );
		_elements = _renderData.elements;
		_lights = _renderData.lights;

		_normalViewMatrix.getNormalMatrix( camera.matrixWorldInverse );

		/* DEBUG
		setFillStyle( 'rgba( 0, 255, 255, 0.5 )' );
		_context.fillRect( _clipBox.min.x, _clipBox.min.y, _clipBox.max.x - _clipBox.min.x, _clipBox.max.y - _clipBox.min.y );
		*/

		calculateLights();

		for ( var e = 0, el = _elements.length; e < el; e ++ ) {

			var element = _elements[ e ];

			var material = element.material;

			if ( material === undefined || material.opacity === 0 ) continue;

			_elemBox.makeEmpty();

			if ( element instanceof THREE.RenderableSprite ) {

				_v1 = element;
				_v1.x *= _canvasWidthHalf; _v1.y *= _canvasHeightHalf;

				renderSprite( _v1, element, material );

			} else if ( element instanceof THREE.RenderableLine ) {

				_v1 = element.v1; _v2 = element.v2;

				_v1.positionScreen.x *= _canvasWidthHalf; _v1.positionScreen.y *= _canvasHeightHalf;
				_v2.positionScreen.x *= _canvasWidthHalf; _v2.positionScreen.y *= _canvasHeightHalf;

				_elemBox.setFromPoints( [
					_v1.positionScreen,
					_v2.positionScreen
				] );

				if ( _clipBox.intersectsBox( _elemBox ) === true ) {

					renderLine( _v1, _v2, element, material );

				}

			} else if ( element instanceof THREE.RenderableFace ) {

				_v1 = element.v1; _v2 = element.v2; _v3 = element.v3;

				if ( _v1.positionScreen.z < - 1 || _v1.positionScreen.z > 1 ) continue;
				if ( _v2.positionScreen.z < - 1 || _v2.positionScreen.z > 1 ) continue;
				if ( _v3.positionScreen.z < - 1 || _v3.positionScreen.z > 1 ) continue;

				_v1.positionScreen.x *= _canvasWidthHalf; _v1.positionScreen.y *= _canvasHeightHalf;
				_v2.positionScreen.x *= _canvasWidthHalf; _v2.positionScreen.y *= _canvasHeightHalf;
				_v3.positionScreen.x *= _canvasWidthHalf; _v3.positionScreen.y *= _canvasHeightHalf;

				if ( material.overdraw > 0 ) {

					expand( _v1.positionScreen, _v2.positionScreen, material.overdraw );
					expand( _v2.positionScreen, _v3.positionScreen, material.overdraw );
					expand( _v3.positionScreen, _v1.positionScreen, material.overdraw );

				}

				_elemBox.setFromPoints( [
					_v1.positionScreen,
					_v2.positionScreen,
					_v3.positionScreen
				] );

				if ( _clipBox.intersectsBox( _elemBox ) === true ) {

					renderFace3( _v1, _v2, _v3, 0, 1, 2, element, material );

				}

			}

			/* DEBUG
			setLineWidth( 1 );
			setStrokeStyle( 'rgba( 0, 255, 0, 0.5 )' );
			_context.strokeRect( _elemBox.min.x, _elemBox.min.y, _elemBox.max.x - _elemBox.min.x, _elemBox.max.y - _elemBox.min.y );
			*/

			_clearBox.union( _elemBox );

		}

		/* DEBUG
		setLineWidth( 1 );
		setStrokeStyle( 'rgba( 255, 0, 0, 0.5 )' );
		_context.strokeRect( _clearBox.min.x, _clearBox.min.y, _clearBox.max.x - _clearBox.min.x, _clearBox.max.y - _clearBox.min.y );
		*/

		_context.setTransform( 1, 0, 0, 1, 0, 0 );

	};

	//

	function calculateLights() {

		_ambientLight.setRGB( 0, 0, 0 );
		_directionalLights.setRGB( 0, 0, 0 );
		_pointLights.setRGB( 0, 0, 0 );

		for ( var l = 0, ll = _lights.length; l < ll; l ++ ) {

			var light = _lights[ l ];
			var lightColor = light.color;

			if ( light.isAmbientLight ) {

				_ambientLight.add( lightColor );

			} else if ( light.isDirectionalLight ) {

				// for sprites

				_directionalLights.add( lightColor );

			} else if ( light.isPointLight ) {

				// for sprites

				_pointLights.add( lightColor );

			}

		}

	}

	function calculateLight( position, normal, color ) {

		for ( var l = 0, ll = _lights.length; l < ll; l ++ ) {

			var light = _lights[ l ];

			_lightColor.copy( light.color );

			if ( light.isDirectionalLight ) {

				var lightPosition = _vector3.setFromMatrixPosition( light.matrixWorld ).normalize();

				var amount = normal.dot( lightPosition );

				if ( amount <= 0 ) continue;

				amount *= light.intensity;

				color.add( _lightColor.multiplyScalar( amount ) );

			} else if ( light.isPointLight ) {

				var lightPosition = _vector3.setFromMatrixPosition( light.matrixWorld );

				var amount = normal.dot( _vector3.subVectors( lightPosition, position ).normalize() );

				if ( amount <= 0 ) continue;

				amount *= light.distance == 0 ? 1 : 1 - Math.min( position.distanceTo( lightPosition ) / light.distance, 1 );

				if ( amount == 0 ) continue;

				amount *= light.intensity;

				color.add( _lightColor.multiplyScalar( amount ) );

			}

		}

	}

	function renderSprite( v1, element, material ) {

		setOpacity( material.opacity );
		setBlending( material.blending );

		var scaleX = element.scale.x * _canvasWidthHalf;
		var scaleY = element.scale.y * _canvasHeightHalf;

		var dist = Math.sqrt( scaleX * scaleX + scaleY * scaleY ); // allow for rotated sprite
		_elemBox.min.set( v1.x - dist, v1.y - dist );
		_elemBox.max.set( v1.x + dist, v1.y + dist );

		if ( material.isSpriteMaterial ) {

			var texture = material.map;

			if ( texture !== null ) {

				var pattern = _patterns[ texture.id ];

				if ( pattern === undefined || pattern.version !== texture.version ) {

					pattern = textureToPattern( texture );
					_patterns[ texture.id ] = pattern;

				}

				if ( pattern.canvas !== undefined ) {

					setFillStyle( pattern.canvas );

					var bitmap = texture.image;

					var ox = bitmap.width * texture.offset.x;
					var oy = bitmap.height * texture.offset.y;

					var sx = bitmap.width * texture.repeat.x;
					var sy = bitmap.height * texture.repeat.y;

					var cx = scaleX / sx;
					var cy = scaleY / sy;

					_context.save();
					_context.translate( v1.x, v1.y );
					if ( material.rotation !== 0 ) _context.rotate( material.rotation );
					_context.translate( - scaleX / 2, - scaleY / 2 );
					_context.scale( cx, cy );
					_context.translate( - ox, - oy );
					_context.fillRect( ox, oy, sx, sy );
					_context.restore();

				}

			} else {

				// no texture

				setFillStyle( material.color.getStyle() );

				_context.save();
				_context.translate( v1.x, v1.y );
				if ( material.rotation !== 0 ) _context.rotate( material.rotation );
				_context.scale( scaleX, - scaleY );
				_context.fillRect( - 0.5, - 0.5, 1, 1 );
				_context.restore();

			}

		} else if ( material.isSpriteCanvasMaterial ) {

			setStrokeStyle( material.color.getStyle() );
			setFillStyle( material.color.getStyle() );

			_context.save();
			_context.translate( v1.x, v1.y );
			if ( material.rotation !== 0 ) _context.rotate( material.rotation );
			_context.scale( scaleX, scaleY );

			material.program( _context );

			_context.restore();

		} else if ( material.isPointsMaterial ) {

			setFillStyle( material.color.getStyle() );

			_context.save();
			_context.translate( v1.x, v1.y );
			if ( material.rotation !== 0 ) _context.rotate( material.rotation );
			_context.scale( scaleX * material.size, - scaleY * material.size );
			_context.fillRect( - 0.5, - 0.5, 1, 1 );
			_context.restore();

		}

		/* DEBUG
		setStrokeStyle( 'rgb(255,255,0)' );
		_context.beginPath();
		_context.moveTo( v1.x - 10, v1.y );
		_context.lineTo( v1.x + 10, v1.y );
		_context.moveTo( v1.x, v1.y - 10 );
		_context.lineTo( v1.x, v1.y + 10 );
		_context.stroke();
		*/

	}

	function renderLine( v1, v2, element, material ) {

		setOpacity( material.opacity );
		setBlending( material.blending );

		_context.beginPath();
		_context.moveTo( v1.positionScreen.x, v1.positionScreen.y );
		_context.lineTo( v2.positionScreen.x, v2.positionScreen.y );

		if ( material.isLineBasicMaterial ) {

			setLineWidth( material.linewidth );
			setLineCap( material.linecap );
			setLineJoin( material.linejoin );

			if ( material.vertexColors !== THREE.VertexColors ) {

				setStrokeStyle( material.color.getStyle() );

			} else {

				var colorStyle1 = element.vertexColors[ 0 ].getStyle();
				var colorStyle2 = element.vertexColors[ 1 ].getStyle();

				if ( colorStyle1 === colorStyle2 ) {

					setStrokeStyle( colorStyle1 );

				} else {

					try {

						var grad = _context.createLinearGradient(
							v1.positionScreen.x,
							v1.positionScreen.y,
							v2.positionScreen.x,
							v2.positionScreen.y
						);
						grad.addColorStop( 0, colorStyle1 );
						grad.addColorStop( 1, colorStyle2 );

					} catch ( exception ) {

						grad = colorStyle1;

					}

					setStrokeStyle( grad );

				}

			}

			if ( material.isLineDashedMaterial ) {

				setLineDash( [ material.dashSize, material.gapSize ] );

			}

			_context.stroke();
			_elemBox.expandByScalar( material.linewidth * 2 );

			if ( material.isLineDashedMaterial ) {

				setLineDash( [] );

			}

		}

	}

	function renderFace3( v1, v2, v3, uv1, uv2, uv3, element, material ) {

		_this.info.render.vertices += 3;
		_this.info.render.faces ++;

		setOpacity( material.opacity );
		setBlending( material.blending );

		_v1x = v1.positionScreen.x; _v1y = v1.positionScreen.y;
		_v2x = v2.positionScreen.x; _v2y = v2.positionScreen.y;
		_v3x = v3.positionScreen.x; _v3y = v3.positionScreen.y;

		drawTriangle( _v1x, _v1y, _v2x, _v2y, _v3x, _v3y );

		if ( ( material.isMeshLambertMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial ) && material.map === null ) {

			_diffuseColor.copy( material.color );
			_emissiveColor.copy( material.emissive );

			if ( material.vertexColors === THREE.FaceColors ) {

				_diffuseColor.multiply( element.color );

			}

			_color.copy( _ambientLight );

			_centroid.copy( v1.positionWorld ).add( v2.positionWorld ).add( v3.positionWorld ).divideScalar( 3 );

			calculateLight( _centroid, element.normalModel, _color );

			_color.multiply( _diffuseColor ).add( _emissiveColor );

			material.wireframe === true
				 ? strokePath( _color, material.wireframeLinewidth, material.wireframeLinecap, material.wireframeLinejoin )
				 : fillPath( _color );

		} else if ( material.isMeshBasicMaterial || material.isMeshLambertMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial ) {

			if ( material.map !== null ) {

				var mapping = material.map.mapping;

				if ( mapping === THREE.UVMapping ) {

					_uvs = element.uvs;
					patternPath( _v1x, _v1y, _v2x, _v2y, _v3x, _v3y, _uvs[ uv1 ].x, _uvs[ uv1 ].y, _uvs[ uv2 ].x, _uvs[ uv2 ].y, _uvs[ uv3 ].x, _uvs[ uv3 ].y, material.map );

				}

			} else if ( material.envMap !== null ) {

				if ( material.envMap.mapping === THREE.SphericalReflectionMapping ) {

					_normal.copy( element.vertexNormalsModel[ uv1 ] ).applyMatrix3( _normalViewMatrix );
					_uv1x = 0.5 * _normal.x + 0.5;
					_uv1y = 0.5 * _normal.y + 0.5;

					_normal.copy( element.vertexNormalsModel[ uv2 ] ).applyMatrix3( _normalViewMatrix );
					_uv2x = 0.5 * _normal.x + 0.5;
					_uv2y = 0.5 * _normal.y + 0.5;

					_normal.copy( element.vertexNormalsModel[ uv3 ] ).applyMatrix3( _normalViewMatrix );
					_uv3x = 0.5 * _normal.x + 0.5;
					_uv3y = 0.5 * _normal.y + 0.5;

					patternPath( _v1x, _v1y, _v2x, _v2y, _v3x, _v3y, _uv1x, _uv1y, _uv2x, _uv2y, _uv3x, _uv3y, material.envMap );

				}

			} else {

				_color.copy( material.color );

				if ( material.vertexColors === THREE.FaceColors ) {

					_color.multiply( element.color );

				}

				material.wireframe === true
					 ? strokePath( _color, material.wireframeLinewidth, material.wireframeLinecap, material.wireframeLinejoin )
					 : fillPath( _color );

			}

		} else if ( material.isMeshNormalMaterial ) {

			_normal.copy( element.normalModel ).applyMatrix3( _normalViewMatrix );

			_color.setRGB( _normal.x, _normal.y, _normal.z ).multiplyScalar( 0.5 ).addScalar( 0.5 );

			material.wireframe === true
				 ? strokePath( _color, material.wireframeLinewidth, material.wireframeLinecap, material.wireframeLinejoin )
				 : fillPath( _color );

		} else {

			_color.setRGB( 1, 1, 1 );

			material.wireframe === true
				 ? strokePath( _color, material.wireframeLinewidth, material.wireframeLinecap, material.wireframeLinejoin )
				 : fillPath( _color );

		}

	}

	//

	function drawTriangle( x0, y0, x1, y1, x2, y2 ) {

		_context.beginPath();
		_context.moveTo( x0, y0 );
		_context.lineTo( x1, y1 );
		_context.lineTo( x2, y2 );
		_context.closePath();

	}

	function strokePath( color, linewidth, linecap, linejoin ) {

		setLineWidth( linewidth );
		setLineCap( linecap );
		setLineJoin( linejoin );
		setStrokeStyle( color.getStyle() );

		_context.stroke();

		_elemBox.expandByScalar( linewidth * 2 );

	}

	function fillPath( color ) {

		setFillStyle( color.getStyle() );
		_context.fill();

	}

	function textureToPattern( texture ) {

		if ( texture.version === 0 ||
			texture instanceof THREE.CompressedTexture ||
			texture instanceof THREE.DataTexture ) {

			return {
				canvas: undefined,
				version: texture.version
			};

		}

		var image = texture.image;

		if ( image.complete === false ) {

			return {
				canvas: undefined,
				version: 0
			};

		}

		var repeatX = texture.wrapS === THREE.RepeatWrapping || texture.wrapS === THREE.MirroredRepeatWrapping;
		var repeatY = texture.wrapT === THREE.RepeatWrapping || texture.wrapT === THREE.MirroredRepeatWrapping;

		var mirrorX = texture.wrapS === THREE.MirroredRepeatWrapping;
		var mirrorY = texture.wrapT === THREE.MirroredRepeatWrapping;

		//

		var canvas = document.createElement( 'canvas' );
		canvas.width = image.width * ( mirrorX ? 2 : 1 );
		canvas.height = image.height * ( mirrorY ? 2 : 1 );

		var context = canvas.getContext( '2d' );
		context.setTransform( 1, 0, 0, - 1, 0, image.height );
		context.drawImage( image, 0, 0 );

		if ( mirrorX === true ) {

			context.setTransform( - 1, 0, 0, - 1, image.width, image.height );
			context.drawImage( image, - image.width, 0 );

		}

		if ( mirrorY === true ) {

			context.setTransform( 1, 0, 0, 1, 0, 0 );
			context.drawImage( image, 0, image.height );

		}

		if ( mirrorX === true && mirrorY === true ) {

			context.setTransform( - 1, 0, 0, 1, image.width, 0 );
			context.drawImage( image, - image.width, image.height );

		}

		var repeat = 'no-repeat';

		if ( repeatX === true && repeatY === true ) {

			repeat = 'repeat';

		} else if ( repeatX === true ) {

			repeat = 'repeat-x';

		} else if ( repeatY === true ) {

			repeat = 'repeat-y';

		}

		var pattern = _context.createPattern( canvas, repeat );

		if ( texture.onUpdate ) texture.onUpdate( texture );

		return {
			canvas: pattern,
			version: texture.version
		};

	}

	function patternPath( x0, y0, x1, y1, x2, y2, u0, v0, u1, v1, u2, v2, texture ) {

		var pattern = _patterns[ texture.id ];

		if ( pattern === undefined || pattern.version !== texture.version ) {

			pattern = textureToPattern( texture );
			_patterns[ texture.id ] = pattern;

		}

		if ( pattern.canvas !== undefined ) {

			setFillStyle( pattern.canvas );

		} else {

			setFillStyle( 'rgba( 0, 0, 0, 1)' );
			_context.fill();
			return;

		}

		// http://extremelysatisfactorytotalitarianism.com/blog/?p=2120

		var a, b, c, d, e, f, det, idet,
			offsetX = texture.offset.x / texture.repeat.x,
			offsetY = texture.offset.y / texture.repeat.y,
			width = texture.image.width * texture.repeat.x,
			height = texture.image.height * texture.repeat.y;

		u0 = ( u0 + offsetX ) * width;
		v0 = ( v0 + offsetY ) * height;

		u1 = ( u1 + offsetX ) * width;
		v1 = ( v1 + offsetY ) * height;

		u2 = ( u2 + offsetX ) * width;
		v2 = ( v2 + offsetY ) * height;

		x1 -= x0; y1 -= y0;
		x2 -= x0; y2 -= y0;

		u1 -= u0; v1 -= v0;
		u2 -= u0; v2 -= v0;

		det = u1 * v2 - u2 * v1;

		if ( det === 0 ) return;

		idet = 1 / det;

		a = ( v2 * x1 - v1 * x2 ) * idet;
		b = ( v2 * y1 - v1 * y2 ) * idet;
		c = ( u1 * x2 - u2 * x1 ) * idet;
		d = ( u1 * y2 - u2 * y1 ) * idet;

		e = x0 - a * u0 - c * v0;
		f = y0 - b * u0 - d * v0;

		_context.save();
		_context.transform( a, b, c, d, e, f );
		_context.fill();
		_context.restore();

	}

	/*
	function clipImage( x0, y0, x1, y1, x2, y2, u0, v0, u1, v1, u2, v2, image ) {

		// http://extremelysatisfactorytotalitarianism.com/blog/?p=2120

		var a, b, c, d, e, f, det, idet,
		width = image.width - 1,
		height = image.height - 1;

		u0 *= width; v0 *= height;
		u1 *= width; v1 *= height;
		u2 *= width; v2 *= height;

		x1 -= x0; y1 -= y0;
		x2 -= x0; y2 -= y0;

		u1 -= u0; v1 -= v0;
		u2 -= u0; v2 -= v0;

		det = u1 * v2 - u2 * v1;

		idet = 1 / det;

		a = ( v2 * x1 - v1 * x2 ) * idet;
		b = ( v2 * y1 - v1 * y2 ) * idet;
		c = ( u1 * x2 - u2 * x1 ) * idet;
		d = ( u1 * y2 - u2 * y1 ) * idet;

		e = x0 - a * u0 - c * v0;
		f = y0 - b * u0 - d * v0;

		_context.save();
		_context.transform( a, b, c, d, e, f );
		_context.clip();
		_context.drawImage( image, 0, 0 );
		_context.restore();

	}
	*/

	// Hide anti-alias gaps

	function expand( v1, v2, pixels ) {

		var x = v2.x - v1.x, y = v2.y - v1.y,
			det = x * x + y * y, idet;

		if ( det === 0 ) return;

		idet = pixels / Math.sqrt( det );

		x *= idet; y *= idet;

		v2.x += x; v2.y += y;
		v1.x -= x; v1.y -= y;

	}

	// Context cached methods.

	function setOpacity( value ) {

		if ( _contextGlobalAlpha !== value ) {

			_context.globalAlpha = value;
			_contextGlobalAlpha = value;

		}

	}

	function setBlending( value ) {

		if ( _contextGlobalCompositeOperation !== value ) {

			if ( value === THREE.NormalBlending ) {

				_context.globalCompositeOperation = 'source-over';

			} else if ( value === THREE.AdditiveBlending ) {

				_context.globalCompositeOperation = 'lighter';

			} else if ( value === THREE.SubtractiveBlending ) {

				_context.globalCompositeOperation = 'darker';

			} else if ( value === THREE.MultiplyBlending ) {

				_context.globalCompositeOperation = 'multiply';

			}

			_contextGlobalCompositeOperation = value;

		}

	}

	function setLineWidth( value ) {

		if ( _contextLineWidth !== value ) {

			_context.lineWidth = value;
			_contextLineWidth = value;

		}

	}

	function setLineCap( value ) {

		// "butt", "round", "square"

		if ( _contextLineCap !== value ) {

			_context.lineCap = value;
			_contextLineCap = value;

		}

	}

	function setLineJoin( value ) {

		// "round", "bevel", "miter"

		if ( _contextLineJoin !== value ) {

			_context.lineJoin = value;
			_contextLineJoin = value;

		}

	}

	function setStrokeStyle( value ) {

		if ( _contextStrokeStyle !== value ) {

			_context.strokeStyle = value;
			_contextStrokeStyle = value;

		}

	}

	function setFillStyle( value ) {

		if ( _contextFillStyle !== value ) {

			_context.fillStyle = value;
			_contextFillStyle = value;

		}

	}

	function setLineDash( value ) {

		if ( _contextLineDash.length !== value.length ) {

			_context.setLineDash( value );
			_contextLineDash = value;

		}

	}

};

/**
 * @author mrdoob / http://mrdoob.com/
 * @author supereggbert / http://www.paulbrunt.co.uk/
 * @author julianwa / https://github.com/julianwa
 */

THREE.RenderableObject = function () {

	this.id = 0;

	this.object = null;
	this.z = 0;
	this.renderOrder = 0;

};

//

THREE.RenderableFace = function () {

	this.id = 0;

	this.v1 = new THREE.RenderableVertex();
	this.v2 = new THREE.RenderableVertex();
	this.v3 = new THREE.RenderableVertex();

	this.normalModel = new THREE.Vector3();

	this.vertexNormalsModel = [ new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3() ];
	this.vertexNormalsLength = 0;

	this.color = new THREE.Color();
	this.material = null;
	this.uvs = [ new THREE.Vector2(), new THREE.Vector2(), new THREE.Vector2() ];

	this.z = 0;
	this.renderOrder = 0;

};

//

THREE.RenderableVertex = function () {

	this.position = new THREE.Vector3();
	this.positionWorld = new THREE.Vector3();
	this.positionScreen = new THREE.Vector4();

	this.visible = true;

};

THREE.RenderableVertex.prototype.copy = function ( vertex ) {

	this.positionWorld.copy( vertex.positionWorld );
	this.positionScreen.copy( vertex.positionScreen );

};

//

THREE.RenderableLine = function () {

	this.id = 0;

	this.v1 = new THREE.RenderableVertex();
	this.v2 = new THREE.RenderableVertex();

	this.vertexColors = [ new THREE.Color(), new THREE.Color() ];
	this.material = null;

	this.z = 0;
	this.renderOrder = 0;

};

//

THREE.RenderableSprite = function () {

	this.id = 0;

	this.object = null;

	this.x = 0;
	this.y = 0;
	this.z = 0;

	this.rotation = 0;
	this.scale = new THREE.Vector2();

	this.material = null;
	this.renderOrder = 0;

};

//

THREE.Projector = function () {

	var _object, _objectCount, _objectPool = [], _objectPoolLength = 0,
		_vertex, _vertexCount, _vertexPool = [], _vertexPoolLength = 0,
		_face, _faceCount, _facePool = [], _facePoolLength = 0,
		_line, _lineCount, _linePool = [], _linePoolLength = 0,
		_sprite, _spriteCount, _spritePool = [], _spritePoolLength = 0,

		_renderData = { objects: [], lights: [], elements: [] },

		_vector3 = new THREE.Vector3(),
		_vector4 = new THREE.Vector4(),

		_clipBox = new THREE.Box3( new THREE.Vector3( - 1, - 1, - 1 ), new THREE.Vector3( 1, 1, 1 ) ),
		_boundingBox = new THREE.Box3(),
		_points3 = new Array( 3 ),

		_viewMatrix = new THREE.Matrix4(),
		_viewProjectionMatrix = new THREE.Matrix4(),

		_modelMatrix,
		_modelViewProjectionMatrix = new THREE.Matrix4(),

		_normalMatrix = new THREE.Matrix3(),

		_frustum = new THREE.Frustum(),

		_clippedVertex1PositionScreen = new THREE.Vector4(),
		_clippedVertex2PositionScreen = new THREE.Vector4();

	//

	this.projectVector = function ( vector, camera ) {

		console.warn( 'THREE.Projector: .projectVector() is now vector.project().' );
		vector.project( camera );

	};

	this.unprojectVector = function ( vector, camera ) {

		console.warn( 'THREE.Projector: .unprojectVector() is now vector.unproject().' );
		vector.unproject( camera );

	};

	this.pickingRay = function () {

		console.error( 'THREE.Projector: .pickingRay() is now raycaster.setFromCamera().' );

	};

	//

	var RenderList = function () {

		var normals = [];
		var colors = [];
		var uvs = [];

		var object = null;
		var material = null;

		var normalMatrix = new THREE.Matrix3();

		function setObject( value ) {

			object = value;
			material = object.material;

			normalMatrix.getNormalMatrix( object.matrixWorld );

			normals.length = 0;
			colors.length = 0;
			uvs.length = 0;

		}

		function projectVertex( vertex ) {

			var position = vertex.position;
			var positionWorld = vertex.positionWorld;
			var positionScreen = vertex.positionScreen;

			positionWorld.copy( position ).applyMatrix4( _modelMatrix );
			positionScreen.copy( positionWorld ).applyMatrix4( _viewProjectionMatrix );

			var invW = 1 / positionScreen.w;

			positionScreen.x *= invW;
			positionScreen.y *= invW;
			positionScreen.z *= invW;

			vertex.visible = positionScreen.x >= - 1 && positionScreen.x <= 1 &&
					 positionScreen.y >= - 1 && positionScreen.y <= 1 &&
					 positionScreen.z >= - 1 && positionScreen.z <= 1;

		}

		function pushVertex( x, y, z ) {

			_vertex = getNextVertexInPool();
			_vertex.position.set( x, y, z );

			projectVertex( _vertex );

		}

		function pushNormal( x, y, z ) {

			normals.push( x, y, z );

		}

		function pushColor( r, g, b ) {

			colors.push( r, g, b );

		}

		function pushUv( x, y ) {

			uvs.push( x, y );

		}

		function checkTriangleVisibility( v1, v2, v3 ) {

			if ( v1.visible === true || v2.visible === true || v3.visible === true ) return true;

			_points3[ 0 ] = v1.positionScreen;
			_points3[ 1 ] = v2.positionScreen;
			_points3[ 2 ] = v3.positionScreen;

			return _clipBox.intersectsBox( _boundingBox.setFromPoints( _points3 ) );

		}

		function checkBackfaceCulling( v1, v2, v3 ) {

			return ( ( v3.positionScreen.x - v1.positionScreen.x ) *
				    ( v2.positionScreen.y - v1.positionScreen.y ) -
				    ( v3.positionScreen.y - v1.positionScreen.y ) *
				    ( v2.positionScreen.x - v1.positionScreen.x ) ) < 0;

		}

		function pushLine( a, b ) {

			var v1 = _vertexPool[ a ];
			var v2 = _vertexPool[ b ];

			// Clip

			v1.positionScreen.copy( v1.position ).applyMatrix4( _modelViewProjectionMatrix );
			v2.positionScreen.copy( v2.position ).applyMatrix4( _modelViewProjectionMatrix );

			if ( clipLine( v1.positionScreen, v2.positionScreen ) === true ) {

				// Perform the perspective divide
				v1.positionScreen.multiplyScalar( 1 / v1.positionScreen.w );
				v2.positionScreen.multiplyScalar( 1 / v2.positionScreen.w );

				_line = getNextLineInPool();
				_line.id = object.id;
				_line.v1.copy( v1 );
				_line.v2.copy( v2 );
				_line.z = Math.max( v1.positionScreen.z, v2.positionScreen.z );
				_line.renderOrder = object.renderOrder;

				_line.material = object.material;

				if ( object.material.vertexColors === THREE.VertexColors ) {

					_line.vertexColors[ 0 ].fromArray( colors, a * 3 );
					_line.vertexColors[ 1 ].fromArray( colors, b * 3 );

				}

				_renderData.elements.push( _line );

			}

		}

		function pushTriangle( a, b, c ) {

			var v1 = _vertexPool[ a ];
			var v2 = _vertexPool[ b ];
			var v3 = _vertexPool[ c ];

			if ( checkTriangleVisibility( v1, v2, v3 ) === false ) return;

			if ( material.side === THREE.DoubleSide || checkBackfaceCulling( v1, v2, v3 ) === true ) {

				_face = getNextFaceInPool();

				_face.id = object.id;
				_face.v1.copy( v1 );
				_face.v2.copy( v2 );
				_face.v3.copy( v3 );
				_face.z = ( v1.positionScreen.z + v2.positionScreen.z + v3.positionScreen.z ) / 3;
				_face.renderOrder = object.renderOrder;

				// use first vertex normal as face normal

				_face.normalModel.fromArray( normals, a * 3 );
				_face.normalModel.applyMatrix3( normalMatrix ).normalize();

				for ( var i = 0; i < 3; i ++ ) {

					var normal = _face.vertexNormalsModel[ i ];
					normal.fromArray( normals, arguments[ i ] * 3 );
					normal.applyMatrix3( normalMatrix ).normalize();

					var uv = _face.uvs[ i ];
					uv.fromArray( uvs, arguments[ i ] * 2 );

				}

				_face.vertexNormalsLength = 3;

				_face.material = object.material;

				_renderData.elements.push( _face );

			}

		}

		return {
			setObject: setObject,
			projectVertex: projectVertex,
			checkTriangleVisibility: checkTriangleVisibility,
			checkBackfaceCulling: checkBackfaceCulling,
			pushVertex: pushVertex,
			pushNormal: pushNormal,
			pushColor: pushColor,
			pushUv: pushUv,
			pushLine: pushLine,
			pushTriangle: pushTriangle
		};

	};

	var renderList = new RenderList();

	function projectObject( object ) {

		if ( object.visible === false ) return;

		if ( object instanceof THREE.Light ) {

			_renderData.lights.push( object );

		} else if ( object instanceof THREE.Mesh || object instanceof THREE.Line || object instanceof THREE.Points ) {

			if ( object.material.visible === false ) return;
			if ( object.frustumCulled === true && _frustum.intersectsObject( object ) === false ) return;

			addObject( object );

		} else if ( object instanceof THREE.Sprite ) {

			if ( object.material.visible === false ) return;
			if ( object.frustumCulled === true && _frustum.intersectsSprite( object ) === false ) return;

			addObject( object );

		}

		var children = object.children;

		for ( var i = 0, l = children.length; i < l; i ++ ) {

			projectObject( children[ i ] );

		}

	}

	function addObject( object ) {

		_object = getNextObjectInPool();
		_object.id = object.id;
		_object.object = object;

		_vector3.setFromMatrixPosition( object.matrixWorld );
		_vector3.applyMatrix4( _viewProjectionMatrix );
		_object.z = _vector3.z;
		_object.renderOrder = object.renderOrder;

		_renderData.objects.push( _object );

	}

	this.projectScene = function ( scene, camera, sortObjects, sortElements ) {

		_faceCount = 0;
		_lineCount = 0;
		_spriteCount = 0;

		_renderData.elements.length = 0;

		if ( scene.autoUpdate === true ) scene.updateMatrixWorld();
		if ( camera.parent === null ) camera.updateMatrixWorld();

		_viewMatrix.copy( camera.matrixWorldInverse );
		_viewProjectionMatrix.multiplyMatrices( camera.projectionMatrix, _viewMatrix );

		_frustum.setFromMatrix( _viewProjectionMatrix );

		//

		_objectCount = 0;

		_renderData.objects.length = 0;
		_renderData.lights.length = 0;

		projectObject( scene );

		if ( sortObjects === true ) {

			_renderData.objects.sort( painterSort );

		}

		//

		var objects = _renderData.objects;

		for ( var o = 0, ol = objects.length; o < ol; o ++ ) {

			var object = objects[ o ].object;
			var geometry = object.geometry;

			renderList.setObject( object );

			_modelMatrix = object.matrixWorld;

			_vertexCount = 0;

			if ( object instanceof THREE.Mesh ) {

				if ( geometry instanceof THREE.BufferGeometry ) {

					var attributes = geometry.attributes;
					var groups = geometry.groups;

					if ( attributes.position === undefined ) continue;

					var positions = attributes.position.array;

					for ( var i = 0, l = positions.length; i < l; i += 3 ) {

						renderList.pushVertex( positions[ i ], positions[ i + 1 ], positions[ i + 2 ] );

					}

					if ( attributes.normal !== undefined ) {

						var normals = attributes.normal.array;

						for ( var i = 0, l = normals.length; i < l; i += 3 ) {

							renderList.pushNormal( normals[ i ], normals[ i + 1 ], normals[ i + 2 ] );

						}

					}

					if ( attributes.uv !== undefined ) {

						var uvs = attributes.uv.array;

						for ( var i = 0, l = uvs.length; i < l; i += 2 ) {

							renderList.pushUv( uvs[ i ], uvs[ i + 1 ] );

						}

					}

					if ( geometry.index !== null ) {

						var indices = geometry.index.array;

						if ( groups.length > 0 ) {

							for ( var g = 0; g < groups.length; g ++ ) {

								var group = groups[ g ];

								for ( var i = group.start, l = group.start + group.count; i < l; i += 3 ) {

									renderList.pushTriangle( indices[ i ], indices[ i + 1 ], indices[ i + 2 ] );

								}

							}

						} else {

							for ( var i = 0, l = indices.length; i < l; i += 3 ) {

								renderList.pushTriangle( indices[ i ], indices[ i + 1 ], indices[ i + 2 ] );

							}

						}

					} else {

						for ( var i = 0, l = positions.length / 3; i < l; i += 3 ) {

							renderList.pushTriangle( i, i + 1, i + 2 );

						}

					}

				} else if ( geometry instanceof THREE.Geometry ) {

					var vertices = geometry.vertices;
					var faces = geometry.faces;
					var faceVertexUvs = geometry.faceVertexUvs[ 0 ];

					_normalMatrix.getNormalMatrix( _modelMatrix );

					var material = object.material;

					var isMultiMaterial = Array.isArray( material );

					for ( var v = 0, vl = vertices.length; v < vl; v ++ ) {

						var vertex = vertices[ v ];

						_vector3.copy( vertex );

						if ( material.morphTargets === true ) {

							var morphTargets = geometry.morphTargets;
							var morphInfluences = object.morphTargetInfluences;

							for ( var t = 0, tl = morphTargets.length; t < tl; t ++ ) {

								var influence = morphInfluences[ t ];

								if ( influence === 0 ) continue;

								var target = morphTargets[ t ];
								var targetVertex = target.vertices[ v ];

								_vector3.x += ( targetVertex.x - vertex.x ) * influence;
								_vector3.y += ( targetVertex.y - vertex.y ) * influence;
								_vector3.z += ( targetVertex.z - vertex.z ) * influence;

							}

						}

						renderList.pushVertex( _vector3.x, _vector3.y, _vector3.z );

					}

					for ( var f = 0, fl = faces.length; f < fl; f ++ ) {

						var face = faces[ f ];

						material = isMultiMaterial === true
							 ? object.material[ face.materialIndex ]
							 : object.material;

						if ( material === undefined ) continue;

						var side = material.side;

						var v1 = _vertexPool[ face.a ];
						var v2 = _vertexPool[ face.b ];
						var v3 = _vertexPool[ face.c ];

						if ( renderList.checkTriangleVisibility( v1, v2, v3 ) === false ) continue;

						var visible = renderList.checkBackfaceCulling( v1, v2, v3 );

						if ( side !== THREE.DoubleSide ) {

							if ( side === THREE.FrontSide && visible === false ) continue;
							if ( side === THREE.BackSide && visible === true ) continue;

						}

						_face = getNextFaceInPool();

						_face.id = object.id;
						_face.v1.copy( v1 );
						_face.v2.copy( v2 );
						_face.v3.copy( v3 );

						_face.normalModel.copy( face.normal );

						if ( visible === false && ( side === THREE.BackSide || side === THREE.DoubleSide ) ) {

							_face.normalModel.negate();

						}

						_face.normalModel.applyMatrix3( _normalMatrix ).normalize();

						var faceVertexNormals = face.vertexNormals;

						for ( var n = 0, nl = Math.min( faceVertexNormals.length, 3 ); n < nl; n ++ ) {

							var normalModel = _face.vertexNormalsModel[ n ];
							normalModel.copy( faceVertexNormals[ n ] );

							if ( visible === false && ( side === THREE.BackSide || side === THREE.DoubleSide ) ) {

								normalModel.negate();

							}

							normalModel.applyMatrix3( _normalMatrix ).normalize();

						}

						_face.vertexNormalsLength = faceVertexNormals.length;

						var vertexUvs = faceVertexUvs[ f ];

						if ( vertexUvs !== undefined ) {

							for ( var u = 0; u < 3; u ++ ) {

								_face.uvs[ u ].copy( vertexUvs[ u ] );

							}

						}

						_face.color = face.color;
						_face.material = material;

						_face.z = ( v1.positionScreen.z + v2.positionScreen.z + v3.positionScreen.z ) / 3;
						_face.renderOrder = object.renderOrder;

						_renderData.elements.push( _face );

					}

				}

			} else if ( object instanceof THREE.Line ) {

				_modelViewProjectionMatrix.multiplyMatrices( _viewProjectionMatrix, _modelMatrix );

				if ( geometry instanceof THREE.BufferGeometry ) {

					var attributes = geometry.attributes;

					if ( attributes.position !== undefined ) {

						var positions = attributes.position.array;

						for ( var i = 0, l = positions.length; i < l; i += 3 ) {

							renderList.pushVertex( positions[ i ], positions[ i + 1 ], positions[ i + 2 ] );

						}

						if ( attributes.color !== undefined ) {

							var colors = attributes.color.array;

							for ( var i = 0, l = colors.length; i < l; i += 3 ) {

								renderList.pushColor( colors[ i ], colors[ i + 1 ], colors[ i + 2 ] );

							}

						}

						if ( geometry.index !== null ) {

							var indices = geometry.index.array;

							for ( var i = 0, l = indices.length; i < l; i += 2 ) {

								renderList.pushLine( indices[ i ], indices[ i + 1 ] );

							}

						} else {

							var step = object instanceof THREE.LineSegments ? 2 : 1;

							for ( var i = 0, l = ( positions.length / 3 ) - 1; i < l; i += step ) {

								renderList.pushLine( i, i + 1 );

							}

						}

					}

				} else if ( geometry instanceof THREE.Geometry ) {

					var vertices = object.geometry.vertices;

					if ( vertices.length === 0 ) continue;

					v1 = getNextVertexInPool();
					v1.positionScreen.copy( vertices[ 0 ] ).applyMatrix4( _modelViewProjectionMatrix );

					var step = object instanceof THREE.LineSegments ? 2 : 1;

					for ( var v = 1, vl = vertices.length; v < vl; v ++ ) {

						v1 = getNextVertexInPool();
						v1.positionScreen.copy( vertices[ v ] ).applyMatrix4( _modelViewProjectionMatrix );

						if ( ( v + 1 ) % step > 0 ) continue;

						v2 = _vertexPool[ _vertexCount - 2 ];

						_clippedVertex1PositionScreen.copy( v1.positionScreen );
						_clippedVertex2PositionScreen.copy( v2.positionScreen );

						if ( clipLine( _clippedVertex1PositionScreen, _clippedVertex2PositionScreen ) === true ) {

							// Perform the perspective divide
							_clippedVertex1PositionScreen.multiplyScalar( 1 / _clippedVertex1PositionScreen.w );
							_clippedVertex2PositionScreen.multiplyScalar( 1 / _clippedVertex2PositionScreen.w );

							_line = getNextLineInPool();

							_line.id = object.id;
							_line.v1.positionScreen.copy( _clippedVertex1PositionScreen );
							_line.v2.positionScreen.copy( _clippedVertex2PositionScreen );

							_line.z = Math.max( _clippedVertex1PositionScreen.z, _clippedVertex2PositionScreen.z );
							_line.renderOrder = object.renderOrder;

							_line.material = object.material;

							if ( object.material.vertexColors === THREE.VertexColors ) {

								_line.vertexColors[ 0 ].copy( object.geometry.colors[ v ] );
								_line.vertexColors[ 1 ].copy( object.geometry.colors[ v - 1 ] );

							}

							_renderData.elements.push( _line );

						}

					}

				}

			} else if ( object instanceof THREE.Points ) {

				_modelViewProjectionMatrix.multiplyMatrices( _viewProjectionMatrix, _modelMatrix );

				if ( geometry instanceof THREE.Geometry ) {

					var vertices = object.geometry.vertices;

					for ( var v = 0, vl = vertices.length; v < vl; v ++ ) {

						var vertex = vertices[ v ];

						_vector4.set( vertex.x, vertex.y, vertex.z, 1 );
						_vector4.applyMatrix4( _modelViewProjectionMatrix );

						pushPoint( _vector4, object, camera );

					}

				} else if ( geometry instanceof THREE.BufferGeometry ) {

					var attributes = geometry.attributes;

					if ( attributes.position !== undefined ) {

						var positions = attributes.position.array;

						for ( var i = 0, l = positions.length; i < l; i += 3 ) {

							_vector4.set( positions[ i ], positions[ i + 1 ], positions[ i + 2 ], 1 );
							_vector4.applyMatrix4( _modelViewProjectionMatrix );

							pushPoint( _vector4, object, camera );

						}

					}

				}

			} else if ( object instanceof THREE.Sprite ) {

				_vector4.set( _modelMatrix.elements[ 12 ], _modelMatrix.elements[ 13 ], _modelMatrix.elements[ 14 ], 1 );
				_vector4.applyMatrix4( _viewProjectionMatrix );

				pushPoint( _vector4, object, camera );

			}

		}

		if ( sortElements === true ) {

			_renderData.elements.sort( painterSort );

		}

		return _renderData;

	};

	function pushPoint( _vector4, object, camera ) {

		var invW = 1 / _vector4.w;

		_vector4.z *= invW;

		if ( _vector4.z >= - 1 && _vector4.z <= 1 ) {

			_sprite = getNextSpriteInPool();
			_sprite.id = object.id;
			_sprite.x = _vector4.x * invW;
			_sprite.y = _vector4.y * invW;
			_sprite.z = _vector4.z;
			_sprite.renderOrder = object.renderOrder;
			_sprite.object = object;

			_sprite.rotation = object.rotation;

			_sprite.scale.x = object.scale.x * Math.abs( _sprite.x - ( _vector4.x + camera.projectionMatrix.elements[ 0 ] ) / ( _vector4.w + camera.projectionMatrix.elements[ 12 ] ) );
			_sprite.scale.y = object.scale.y * Math.abs( _sprite.y - ( _vector4.y + camera.projectionMatrix.elements[ 5 ] ) / ( _vector4.w + camera.projectionMatrix.elements[ 13 ] ) );

			_sprite.material = object.material;

			_renderData.elements.push( _sprite );

		}

	}

	// Pools

	function getNextObjectInPool() {

		if ( _objectCount === _objectPoolLength ) {

			var object = new THREE.RenderableObject();
			_objectPool.push( object );
			_objectPoolLength ++;
			_objectCount ++;
			return object;

		}

		return _objectPool[ _objectCount ++ ];

	}

	function getNextVertexInPool() {

		if ( _vertexCount === _vertexPoolLength ) {

			var vertex = new THREE.RenderableVertex();
			_vertexPool.push( vertex );
			_vertexPoolLength ++;
			_vertexCount ++;
			return vertex;

		}

		return _vertexPool[ _vertexCount ++ ];

	}

	function getNextFaceInPool() {

		if ( _faceCount === _facePoolLength ) {

			var face = new THREE.RenderableFace();
			_facePool.push( face );
			_facePoolLength ++;
			_faceCount ++;
			return face;

		}

		return _facePool[ _faceCount ++ ];


	}

	function getNextLineInPool() {

		if ( _lineCount === _linePoolLength ) {

			var line = new THREE.RenderableLine();
			_linePool.push( line );
			_linePoolLength ++;
			_lineCount ++;
			return line;

		}

		return _linePool[ _lineCount ++ ];

	}

	function getNextSpriteInPool() {

		if ( _spriteCount === _spritePoolLength ) {

			var sprite = new THREE.RenderableSprite();
			_spritePool.push( sprite );
			_spritePoolLength ++;
			_spriteCount ++;
			return sprite;

		}

		return _spritePool[ _spriteCount ++ ];

	}

	//

	function painterSort( a, b ) {

		if ( a.renderOrder !== b.renderOrder ) {

			return a.renderOrder - b.renderOrder;

		} else if ( a.z !== b.z ) {

			return b.z - a.z;

		} else if ( a.id !== b.id ) {

			return a.id - b.id;

		} else {

			return 0;

		}

	}

	function clipLine( s1, s2 ) {

		var alpha1 = 0, alpha2 = 1,

		// Calculate the boundary coordinate of each vertex for the near and far clip planes,
		// Z = -1 and Z = +1, respectively.

			bc1near = s1.z + s1.w,
			bc2near = s2.z + s2.w,
			bc1far = - s1.z + s1.w,
			bc2far = - s2.z + s2.w;

		if ( bc1near >= 0 && bc2near >= 0 && bc1far >= 0 && bc2far >= 0 ) {

			// Both vertices lie entirely within all clip planes.
			return true;

		} else if ( ( bc1near < 0 && bc2near < 0 ) || ( bc1far < 0 && bc2far < 0 ) ) {

			// Both vertices lie entirely outside one of the clip planes.
			return false;

		} else {

			// The line segment spans at least one clip plane.

			if ( bc1near < 0 ) {

				// v1 lies outside the near plane, v2 inside
				alpha1 = Math.max( alpha1, bc1near / ( bc1near - bc2near ) );

			} else if ( bc2near < 0 ) {

				// v2 lies outside the near plane, v1 inside
				alpha2 = Math.min( alpha2, bc1near / ( bc1near - bc2near ) );

			}

			if ( bc1far < 0 ) {

				// v1 lies outside the far plane, v2 inside
				alpha1 = Math.max( alpha1, bc1far / ( bc1far - bc2far ) );

			} else if ( bc2far < 0 ) {

				// v2 lies outside the far plane, v2 inside
				alpha2 = Math.min( alpha2, bc1far / ( bc1far - bc2far ) );

			}

			if ( alpha2 < alpha1 ) {

				// The line segment spans two boundaries, but is outside both of them.
				// (This can't happen when we're only clipping against just near/far but good
				//  to leave the check here for future usage if other clip planes are added.)
				return false;

			} else {

				// Update the s1 and s2 vertices to match the clipped line segment.
				s1.lerp( s2, alpha1 );
				s2.lerp( s1, 1 - alpha2 );

				return true;

			}

		}

	}

};

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mr.doob / http://mrdoob.com/
 */

var Detector = {

	canvas: !! window.CanvasRenderingContext2D,
	webgl: ( function () {

		try {

			var canvas = document.createElement( 'canvas' ); return !! ( window.WebGLRenderingContext && ( canvas.getContext( 'webgl' ) || canvas.getContext( 'experimental-webgl' ) ) );

		} catch ( e ) {

			return false;

		}

	} )(),
	workers: !! window.Worker,
	fileapi: window.File && window.FileReader && window.FileList && window.Blob,

	getWebGLErrorMessage: function () {

		var element = document.createElement( 'div' );
		element.id = 'webgl-error-message';
		element.style.fontFamily = 'monospace';
		element.style.fontSize = '13px';
		element.style.fontWeight = 'normal';
		element.style.textAlign = 'center';
		element.style.background = '#fff';
		element.style.color = '#000';
		element.style.padding = '1.5em';
		element.style.width = '400px';
		element.style.margin = '5em auto 0';

		if ( ! this.webgl ) {

			element.innerHTML = window.WebGLRenderingContext ? [
				'Your graphics card does not seem to support <a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" style="color:#000">WebGL</a>.<br />',
				'Find out how to get it <a href="http://get.webgl.org/" style="color:#000">here</a>.'
			].join( '\n' ) : [
				'Your browser does not seem to support <a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" style="color:#000">WebGL</a>.<br/>',
				'Find out how to get it <a href="http://get.webgl.org/" style="color:#000">here</a>.'
			].join( '\n' );

		}

		return element;

	},

	addGetWebGLMessage: function ( parameters ) {

		var parent, id, element;

		parameters = parameters || {};

		parent = parameters.parent !== undefined ? parameters.parent : document.body;
		id = parameters.id !== undefined ? parameters.id : 'oldie';

		element = Detector.getWebGLErrorMessage();
		element.id = id;

		parent.appendChild( element );

	}

};

// browserify support
if ( typeof module === 'object' ) {

	module.exports = Detector;

}
/**
 * @author daron1337 / http://daron1337.github.io/
 */

THREE.Lut = function ( colormap, numberofcolors ) {

	this.lut = [];
	this.map = THREE.ColorMapKeywords[ colormap ];
	this.n = numberofcolors;
	this.mapname = colormap;

	var step = 1.0 / this.n;

	for ( var i = 0; i <= 1; i += step ) {

		for ( var j = 0; j < this.map.length - 1; j ++ ) {

			if ( i >= this.map[ j ][ 0 ] && i < this.map[ j + 1 ][ 0 ] ) {

				var min = this.map[ j ][ 0 ];
				var max = this.map[ j + 1 ][ 0 ];

				var color = new THREE.Color( 0xffffff );
				var minColor = new THREE.Color( 0xffffff ).setHex( this.map[ j ][ 1 ] );
				var maxColor = new THREE.Color( 0xffffff ).setHex( this.map[ j + 1 ][ 1 ] );

				color = minColor.lerp( maxColor, ( i - min ) / ( max - min ) );

				this.lut.push( color );

			}

		}

	}

	return this.set( this );

};

THREE.Lut.prototype = {

	constructor: THREE.Lut,

	lut: [], map: [], mapname: 'rainbow', n: 256, minV: 0, maxV: 1, legend: null,

	set: function ( value ) {

		if ( value instanceof THREE.Lut ) {

			this.copy( value );

		}

		return this;

	},

	setMin: function ( min ) {

		this.minV = min;

		return this;

	},

	setMax: function ( max ) {

		this.maxV = max;

		return this;

	},

	changeNumberOfColors: function ( numberofcolors ) {

		this.n = numberofcolors;

		return new THREE.Lut( this.mapname, this.n );

	},

	changeColorMap: function ( colormap ) {

		this.mapname = colormap;

		return new THREE.Lut( this.mapname, this.n );

	},

	copy: function ( lut ) {

		this.lut = lut.lut;
		this.mapname = lut.mapname;
		this.map = lut.map;
		this.n = lut.n;
		this.minV = lut.minV;
		this.maxV = lut.maxV;

		return this;

	},

	getColor: function ( alpha ) {

		if ( alpha <= this.minV ) {

			alpha = this.minV;

		} else if ( alpha >= this.maxV ) {

			alpha = this.maxV;

		}

		alpha = ( alpha - this.minV ) / ( this.maxV - this.minV );

		var colorPosition = Math.round ( alpha * this.n );
		colorPosition == this.n ? colorPosition -= 1 : colorPosition;

		return this.lut[ colorPosition ];

	},

	addColorMap: function ( colormapName, arrayOfColors ) {

		THREE.ColorMapKeywords[ colormapName ] = arrayOfColors;

	},

	setLegendOn: function ( parameters ) {

		if ( parameters === undefined ) {

			parameters = {};

		}

		this.legend = {};

		this.legend.layout = parameters.hasOwnProperty( 'layout' ) ? parameters[ 'layout' ] : 'vertical';

		this.legend.position = parameters.hasOwnProperty( 'position' ) ? parameters[ 'position' ] : { 'x': 21.5, 'y': 8, 'z': 5 };

		this.legend.dimensions = parameters.hasOwnProperty( 'dimensions' ) ? parameters[ 'dimensions' ] : { 'width': 0.5, 'height': 3 };

		this.legend.canvas = document.createElement( 'canvas' );

		this.legend.canvas.setAttribute( 'id', 'legend' );
		this.legend.canvas.setAttribute( 'hidden', true );

		document.body.appendChild( this.legend.canvas );

		this.legend.ctx = this.legend.canvas.getContext( '2d' );

		this.legend.canvas.setAttribute( 'width',  1 );
		this.legend.canvas.setAttribute( 'height', this.n );

		this.legend.texture = new THREE.Texture( this.legend.canvas );

		imageData = this.legend.ctx.getImageData( 0, 0, 1, this.n );

		data = imageData.data;
		len = data.length;

		this.map = THREE.ColorMapKeywords[ this.mapname ];

		var k = 0;

		var step = 1.0 / this.n;

		for ( var i = 1; i >= 0; i -= step ) {

			for ( var j = this.map.length - 1; j >= 0; j -- ) {

				if ( i < this.map[ j ][ 0 ] && i >= this.map[ j - 1 ][ 0 ]  ) {

					var min = this.map[ j - 1 ][ 0 ];
					var max = this.map[ j ][ 0 ];
					var color = new THREE.Color( 0xffffff );
					var minColor = new THREE.Color( 0xffffff ).setHex( this.map[ j - 1 ][ 1 ] );
					var maxColor = new THREE.Color( 0xffffff ).setHex( this.map[ j ][ 1 ] );
					color = minColor.lerp( maxColor, ( i - min ) / ( max - min ) );

					data[ k * 4 ] = Math.round( color.r * 255 );
					data[ k * 4 + 1 ] = Math.round( color.g * 255 );
					data[ k * 4 + 2 ] = Math.round( color.b * 255 );
					data[ k * 4 + 3 ] = 255;

					k += 1;

				}

			}

		}

		this.legend.ctx.putImageData( imageData, 0, 0 );
		this.legend.texture.needsUpdate = true;

		this.legend.legendGeometry = new THREE.PlaneBufferGeometry( this.legend.dimensions.width, this.legend.dimensions.height );
		this.legend.legendMaterial = new THREE.MeshBasicMaterial( { map : this.legend.texture, side : THREE.DoubleSide } );

		this.legend.mesh = new THREE.Mesh( this.legend.legendGeometry, this.legend.legendMaterial );

		if ( this.legend.layout == 'horizontal' ) {

			this.legend.mesh.rotation.z = - 90 * ( Math.PI / 180 );

		}

		this.legend.mesh.position.copy( this.legend.position );

		return this.legend.mesh;

	},

	setLegendOff: function () {

		this.legend = null;

		return this.legend;

	},

	setLegendLayout: function ( layout ) {

		if ( ! this.legend ) {

			return false;

		}

		if ( this.legend.layout == layout ) {

			return false;

		}

		if ( layout != 'horizontal' && layout != 'vertical' ) {

			return false;

		}

		this.layout = layout;

		if ( layout == 'horizontal' ) {

			this.legend.mesh.rotation.z = 90 * ( Math.PI / 180 );

		}

		if ( layout == 'vertical' ) {

			this.legend.mesh.rotation.z = - 90 * ( Math.PI / 180 );

		}

		return this.legend.mesh;

	},

	setLegendPosition: function ( position ) {

		this.legend.position = new THREE.Vector3( position.x, position.y, position.z );

		return this.legend;

	},

	setLegendLabels: function ( parameters, callback ) {

		if ( ! this.legend ) {

			return false;

		}

		if ( typeof parameters === 'function' ) {

			callback = parameters;

		}

		if ( parameters === undefined ) {

			parameters = {};

		}

		this.legend.labels = {};

		this.legend.labels.fontsize = parameters.hasOwnProperty( 'fontsize' ) ? parameters[ 'fontsize' ] : 24;

		this.legend.labels.fontface = parameters.hasOwnProperty( 'fontface' ) ? parameters[ 'fontface' ] : 'Arial';

		this.legend.labels.title = parameters.hasOwnProperty( 'title' ) ? parameters[ 'title' ] : '';

		this.legend.labels.um = parameters.hasOwnProperty( 'um' ) ? ' [ ' + parameters[ 'um' ] + ' ]' : '';

		this.legend.labels.ticks = parameters.hasOwnProperty( 'ticks' ) ? parameters[ 'ticks' ] : 0;

		this.legend.labels.decimal = parameters.hasOwnProperty( 'decimal' ) ? parameters[ 'decimal' ] : 2;

		this.legend.labels.notation = parameters.hasOwnProperty( 'notation' ) ? parameters[ 'notation' ] : 'standard';

		var backgroundColor = { r: 255, g: 100, b: 100, a: 0.8 };
		var borderColor =  { r: 255, g: 0, b: 0, a: 1.0 };
		var borderThickness = 4;

		var canvasTitle = document.createElement( 'canvas' );
		var contextTitle = canvasTitle.getContext( '2d' );

		contextTitle.font = 'Normal ' + this.legend.labels.fontsize * 1.2 + 'px ' + this.legend.labels.fontface;

		var metrics = contextTitle.measureText( this.legend.labels.title.toString() + this.legend.labels.um.toString() );
		var textWidth = metrics.width;

		contextTitle.fillStyle   = 'rgba(' + backgroundColor.r + ',' + backgroundColor.g + ',' + backgroundColor.b + ',' + backgroundColor.a + ')';

		contextTitle.strokeStyle = 'rgba(' + borderColor.r + ',' + borderColor.g + ',' + borderColor.b + ',' + borderColor.a + ')';

		contextTitle.lineWidth = borderThickness;

		contextTitle.fillStyle = 'rgba( 0, 0, 0, 1.0 )';

		contextTitle.fillText( this.legend.labels.title.toString() + this.legend.labels.um.toString(), borderThickness, this.legend.labels.fontsize + borderThickness );

		var txtTitle = new THREE.CanvasTexture( canvasTitle );
		txtTitle.minFilter = THREE.LinearFilter;

		var spriteMaterialTitle = new THREE.SpriteMaterial( { map: txtTitle } );

		var spriteTitle = new THREE.Sprite( spriteMaterialTitle );

		spriteTitle.scale.set( 2, 1, 1.0 );

		if ( this.legend.layout == 'vertical' ) {

			spriteTitle.position.set( this.legend.position.x + this.legend.dimensions.width, this.legend.position.y + ( this.legend.dimensions.height * 0.45 ), this.legend.position.z );

		}

		if ( this.legend.layout == 'horizontal' ) {

			spriteTitle.position.set( this.legend.position.x * 1.015, this.legend.position.y + ( this.legend.dimensions.height * 0.03 ), this.legend.position.z );

		}

		if ( this.legend.labels.ticks > 0 ) {

			var ticks = {};
			var lines = {};

			if ( this.legend.layout == 'vertical' ) {

				var topPositionY = this.legend.position.y + ( this.legend.dimensions.height * 0.36 );
				var bottomPositionY = this.legend.position.y - ( this.legend.dimensions.height * 0.61 );

			}

			if ( this.legend.layout == 'horizontal' ) {

				var topPositionX = this.legend.position.x + ( this.legend.dimensions.height * 0.75 );
				var bottomPositionX = this.legend.position.x - ( this.legend.dimensions.width * 1.2  ) ;

			}

			for ( var i = 0; i < this.legend.labels.ticks; i ++ ) {

				var value = ( this.maxV - this.minV ) / ( this.legend.labels.ticks - 1  ) * i + this.minV;

				if ( callback ) {

					value = callback ( value );

				} else {

					if ( this.legend.labels.notation == 'scientific' ) {

						value = value.toExponential( this.legend.labels.decimal );

					} else {

						value = value.toFixed( this.legend.labels.decimal );

					}

				}

				var canvasTick = document.createElement( 'canvas' );
				var contextTick = canvasTick.getContext( '2d' );

				contextTick.font = 'Normal ' + this.legend.labels.fontsize + 'px ' + this.legend.labels.fontface;

				var metrics = contextTick.measureText( value.toString() );
				var textWidth = metrics.width;

				contextTick.fillStyle   = 'rgba(' + backgroundColor.r + ',' + backgroundColor.g + ',' + backgroundColor.b + ',' + backgroundColor.a + ')';

				contextTick.strokeStyle = 'rgba(' + borderColor.r + ',' + borderColor.g + ',' + borderColor.b + ',' + borderColor.a + ')';

				contextTick.lineWidth = borderThickness;

				contextTick.fillStyle = 'rgba( 0, 0, 0, 1.0 )';

				contextTick.fillText( value.toString(), borderThickness, this.legend.labels.fontsize + borderThickness );

				var txtTick = new THREE.CanvasTexture( canvasTick );
				txtTick.minFilter = THREE.LinearFilter;

				var spriteMaterialTick = new THREE.SpriteMaterial( { map: txtTick } );

				var spriteTick = new THREE.Sprite( spriteMaterialTick );

				spriteTick.scale.set( 2, 1, 1.0 );

				if ( this.legend.layout == 'vertical' ) {

					var position = bottomPositionY + ( topPositionY - bottomPositionY ) * ( ( value - this.minV ) / ( this.maxV - this.minV ) );

					spriteTick.position.set( this.legend.position.x + ( this.legend.dimensions.width * 2.7 ), position, this.legend.position.z );

				}

				if ( this.legend.layout == 'horizontal' ) {

					var position = bottomPositionX + ( topPositionX - bottomPositionX ) * ( ( value - this.minV ) / ( this.maxV - this.minV ) );

					if ( this.legend.labels.ticks > 5 ) {

						if ( i % 2 === 0 ) {

							var offset = 1.7;

						} else {

							var offset = 2.1;

						}

					} else {

						var offset = 1.7;

					}

					spriteTick.position.set( position, this.legend.position.y - this.legend.dimensions.width * offset, this.legend.position.z );

				}

				var material = new THREE.LineBasicMaterial( { color: 0x000000, linewidth: 2 } );

				var geometry = new THREE.Geometry();


				if ( this.legend.layout == 'vertical' ) {

					var linePosition = ( this.legend.position.y - ( this.legend.dimensions.height * 0.5 ) + 0.01 ) + ( this.legend.dimensions.height ) * ( ( value - this.minV ) / ( this.maxV - this.minV ) * 0.99 );

					geometry.vertices.push( new THREE.Vector3( this.legend.position.x + this.legend.dimensions.width * 0.55, linePosition, this.legend.position.z  ) );

					geometry.vertices.push( new THREE.Vector3( this.legend.position.x + this.legend.dimensions.width * 0.7, linePosition, this.legend.position.z  ) );

				}

				if ( this.legend.layout == 'horizontal' ) {

					var linePosition = ( this.legend.position.x - ( this.legend.dimensions.height * 0.5 ) + 0.01 ) + ( this.legend.dimensions.height ) * ( ( value - this.minV ) / ( this.maxV - this.minV ) * 0.99 );

					geometry.vertices.push( new THREE.Vector3( linePosition, this.legend.position.y - this.legend.dimensions.width * 0.55, this.legend.position.z  ) );

					geometry.vertices.push( new THREE.Vector3( linePosition, this.legend.position.y - this.legend.dimensions.width * 0.7, this.legend.position.z  ) );

				}

				var line = new THREE.Line( geometry, material );

				lines[ i ] = line;
				ticks[ i ] = spriteTick;

			}

		}

		return { 'title': spriteTitle,  'ticks': ticks, 'lines': lines };

	}

};


THREE.ColorMapKeywords = {

	"rainbow":    [ [ 0.0, '0x0000FF' ], [ 0.2, '0x00FFFF' ], [ 0.5, '0x00FF00' ], [ 0.8, '0xFFFF00' ],  [ 1.0, '0xFF0000' ] ],
	"cooltowarm": [ [ 0.0, '0x3C4EC2' ], [ 0.2, '0x9BBCFF' ], [ 0.5, '0xDCDCDC' ], [ 0.8, '0xF6A385' ],  [ 1.0, '0xB40426' ] ],
	"blackbody" : [ [ 0.0, '0x000000' ], [ 0.2, '0x780000' ], [ 0.5, '0xE63200' ], [ 0.8, '0xFFFF00' ],  [ 1.0, '0xFFFFFF' ] ],
	"grayscale" : [ [ 0.0, '0x000000' ], [ 0.2, '0x404040' ], [ 0.5, '0x7F7F80' ], [ 0.8, '0xBFBFBF' ],  [ 1.0, '0xFFFFFF' ] ]

};
/**
 * @author Eberhard Graether / http://egraether.com/
 * @author Mark Lundin 	/ http://mark-lundin.com
 * @author Simone Manini / http://daron1337.github.io
 * @author Luca Antiga 	/ http://lantiga.github.io
 */

THREE.TrackballControls = function ( object, domElement ) {

	var _this = this;
	var STATE = { NONE: - 1, ROTATE: 0, ZOOM: 1, PAN: 2, TOUCH_ROTATE: 3, TOUCH_ZOOM_PAN: 4 };

	this.object = object;
	this.domElement = ( domElement !== undefined ) ? domElement : document;

	// API

	this.enabled = true;

	this.screen = { left: 0, top: 0, width: 0, height: 0 };

	this.rotateSpeed = 1.0;
	this.zoomSpeed = 1.2;
	this.panSpeed = 0.3;

	this.noRotate = false;
	this.noZoom = false;
	this.noPan = false;

	this.staticMoving = false;
	this.dynamicDampingFactor = 0.2;

	this.minDistance = 0;
	this.maxDistance = Infinity;

	this.keys = [ 65 /*A*/, 83 /*S*/, 68 /*D*/ ];

	// internals

	this.target = new THREE.Vector3();

	var EPS = 0.000001;

	var lastPosition = new THREE.Vector3();

	var _state = STATE.NONE,
	_prevState = STATE.NONE,

	_eye = new THREE.Vector3(),

	_movePrev = new THREE.Vector2(),
	_moveCurr = new THREE.Vector2(),

	_lastAxis = new THREE.Vector3(),
	_lastAngle = 0,

	_zoomStart = new THREE.Vector2(),
	_zoomEnd = new THREE.Vector2(),

	_touchZoomDistanceStart = 0,
	_touchZoomDistanceEnd = 0,

	_panStart = new THREE.Vector2(),
	_panEnd = new THREE.Vector2();

	// for reset

	this.target0 = this.target.clone();
	this.position0 = this.object.position.clone();
	this.up0 = this.object.up.clone();

	// events

	var changeEvent = { type: 'change' };
	var startEvent = { type: 'start' };
	var endEvent = { type: 'end' };


	// methods

	this.handleResize = function () {

		if ( this.domElement === document ) {

			this.screen.left = 0;
			this.screen.top = 0;
			this.screen.width = window.innerWidth;
			this.screen.height = window.innerHeight;

		} else {

			var box = this.domElement.getBoundingClientRect();
			// adjustments come from similar code in the jquery offset() function
			var d = this.domElement.ownerDocument.documentElement;
			this.screen.left = box.left + window.pageXOffset - d.clientLeft;
			this.screen.top = box.top + window.pageYOffset - d.clientTop;
			this.screen.width = box.width;
			this.screen.height = box.height;

		}

	};

	this.handleEvent = function ( event ) {

		if ( typeof this[ event.type ] == 'function' ) {

			this[ event.type ]( event );

		}

	};

	var getMouseOnScreen = ( function () {

		var vector = new THREE.Vector2();

		return function getMouseOnScreen( pageX, pageY ) {

			vector.set(
				( pageX - _this.screen.left ) / _this.screen.width,
				( pageY - _this.screen.top ) / _this.screen.height
			);

			return vector;

		};

	}() );

	var getMouseOnCircle = ( function () {

		var vector = new THREE.Vector2();

		return function getMouseOnCircle( pageX, pageY ) {

			vector.set(
				( ( pageX - _this.screen.width * 0.5 - _this.screen.left ) / ( _this.screen.width * 0.5 ) ),
				( ( _this.screen.height + 2 * ( _this.screen.top - pageY ) ) / _this.screen.width ) // screen.width intentional
			);

			return vector;

		};

	}() );

	this.rotateCamera = ( function() {

		var axis = new THREE.Vector3(),
			quaternion = new THREE.Quaternion(),
			eyeDirection = new THREE.Vector3(),
			objectUpDirection = new THREE.Vector3(),
			objectSidewaysDirection = new THREE.Vector3(),
			moveDirection = new THREE.Vector3(),
			angle;

		return function rotateCamera() {

			moveDirection.set( _moveCurr.x - _movePrev.x, _moveCurr.y - _movePrev.y, 0 );
			angle = moveDirection.length();

			if ( angle ) {

				_eye.copy( _this.object.position ).sub( _this.target );

				eyeDirection.copy( _eye ).normalize();
				objectUpDirection.copy( _this.object.up ).normalize();
				objectSidewaysDirection.crossVectors( objectUpDirection, eyeDirection ).normalize();

				objectUpDirection.setLength( _moveCurr.y - _movePrev.y );
				objectSidewaysDirection.setLength( _moveCurr.x - _movePrev.x );

				moveDirection.copy( objectUpDirection.add( objectSidewaysDirection ) );

				axis.crossVectors( moveDirection, _eye ).normalize();

				angle *= _this.rotateSpeed;
				quaternion.setFromAxisAngle( axis, angle );

				_eye.applyQuaternion( quaternion );
				_this.object.up.applyQuaternion( quaternion );

				_lastAxis.copy( axis );
				_lastAngle = angle;

			} else if ( ! _this.staticMoving && _lastAngle ) {

				_lastAngle *= Math.sqrt( 1.0 - _this.dynamicDampingFactor );
				_eye.copy( _this.object.position ).sub( _this.target );
				quaternion.setFromAxisAngle( _lastAxis, _lastAngle );
				_eye.applyQuaternion( quaternion );
				_this.object.up.applyQuaternion( quaternion );

			}

			_movePrev.copy( _moveCurr );

		};

	}() );


	this.zoomCamera = function () {

		var factor;

		if ( _state === STATE.TOUCH_ZOOM_PAN ) {

			factor = _touchZoomDistanceStart / _touchZoomDistanceEnd;
			_touchZoomDistanceStart = _touchZoomDistanceEnd;
			_eye.multiplyScalar( factor );

		} else {

			factor = 1.0 + ( _zoomEnd.y - _zoomStart.y ) * _this.zoomSpeed;

			if ( factor !== 1.0 && factor > 0.0 ) {

				_eye.multiplyScalar( factor );

				if ( _this.staticMoving ) {

					_zoomStart.copy( _zoomEnd );

				} else {

					_zoomStart.y += ( _zoomEnd.y - _zoomStart.y ) * this.dynamicDampingFactor;

				}

			}

		}

	};

	this.panCamera = ( function() {

		var mouseChange = new THREE.Vector2(),
			objectUp = new THREE.Vector3(),
			pan = new THREE.Vector3();

		return function panCamera() {

			mouseChange.copy( _panEnd ).sub( _panStart );

			if ( mouseChange.lengthSq() ) {

				mouseChange.multiplyScalar( _eye.length() * _this.panSpeed );

				pan.copy( _eye ).cross( _this.object.up ).setLength( mouseChange.x );
				pan.add( objectUp.copy( _this.object.up ).setLength( mouseChange.y ) );

				_this.object.position.add( pan );
				_this.target.add( pan );

				if ( _this.staticMoving ) {

					_panStart.copy( _panEnd );

				} else {

					_panStart.add( mouseChange.subVectors( _panEnd, _panStart ).multiplyScalar( _this.dynamicDampingFactor ) );

				}

			}

		};

	}() );

	this.checkDistances = function () {

		if ( ! _this.noZoom || ! _this.noPan ) {

			if ( _eye.lengthSq() > _this.maxDistance * _this.maxDistance ) {

				_this.object.position.addVectors( _this.target, _eye.setLength( _this.maxDistance ) );
				_zoomStart.copy( _zoomEnd );

			}

			if ( _eye.lengthSq() < _this.minDistance * _this.minDistance ) {

				_this.object.position.addVectors( _this.target, _eye.setLength( _this.minDistance ) );
				_zoomStart.copy( _zoomEnd );

			}

		}

	};

	this.update = function () {

		_eye.subVectors( _this.object.position, _this.target );

		if ( ! _this.noRotate ) {

			_this.rotateCamera();

		}

		if ( ! _this.noZoom ) {

			_this.zoomCamera();

		}

		if ( ! _this.noPan ) {

			_this.panCamera();

		}

		_this.object.position.addVectors( _this.target, _eye );

		_this.checkDistances();

		_this.object.lookAt( _this.target );

		if ( lastPosition.distanceToSquared( _this.object.position ) > EPS ) {

			_this.dispatchEvent( changeEvent );

			lastPosition.copy( _this.object.position );

		}

	};

	this.reset = function () {

		_state = STATE.NONE;
		_prevState = STATE.NONE;

		_this.target.copy( _this.target0 );
		_this.object.position.copy( _this.position0 );
		_this.object.up.copy( _this.up0 );

		_eye.subVectors( _this.object.position, _this.target );

		_this.object.lookAt( _this.target );

		_this.dispatchEvent( changeEvent );

		lastPosition.copy( _this.object.position );

	};

	// listeners

	function keydown( event ) {

		if ( _this.enabled === false ) return;

		window.removeEventListener( 'keydown', keydown );

		_prevState = _state;

		if ( _state !== STATE.NONE ) {

			return;

		} else if ( event.keyCode === _this.keys[ STATE.ROTATE ] && ! _this.noRotate ) {

			_state = STATE.ROTATE;

		} else if ( event.keyCode === _this.keys[ STATE.ZOOM ] && ! _this.noZoom ) {

			_state = STATE.ZOOM;

		} else if ( event.keyCode === _this.keys[ STATE.PAN ] && ! _this.noPan ) {

			_state = STATE.PAN;

		}

	}

	function keyup( event ) {

		if ( _this.enabled === false ) return;

		_state = _prevState;

		window.addEventListener( 'keydown', keydown, false );

	}

	function mousedown( event ) {

		if ( _this.enabled === false ) return;

		event.preventDefault();
		event.stopPropagation();

		if ( _state === STATE.NONE ) {

			_state = event.button;

		}

		if ( _state === STATE.ROTATE && ! _this.noRotate ) {

			_moveCurr.copy( getMouseOnCircle( event.pageX, event.pageY ) );
			_movePrev.copy( _moveCurr );

		} else if ( _state === STATE.ZOOM && ! _this.noZoom ) {

			_zoomStart.copy( getMouseOnScreen( event.pageX, event.pageY ) );
			_zoomEnd.copy( _zoomStart );

		} else if ( _state === STATE.PAN && ! _this.noPan ) {

			_panStart.copy( getMouseOnScreen( event.pageX, event.pageY ) );
			_panEnd.copy( _panStart );

		}

		document.addEventListener( 'mousemove', mousemove, false );
		document.addEventListener( 'mouseup', mouseup, false );

		_this.dispatchEvent( startEvent );

	}

	function mousemove( event ) {

		if ( _this.enabled === false ) return;

		event.preventDefault();
		event.stopPropagation();

		if ( _state === STATE.ROTATE && ! _this.noRotate ) {

			_movePrev.copy( _moveCurr );
			_moveCurr.copy( getMouseOnCircle( event.pageX, event.pageY ) );

		} else if ( _state === STATE.ZOOM && ! _this.noZoom ) {

			_zoomEnd.copy( getMouseOnScreen( event.pageX, event.pageY ) );

		} else if ( _state === STATE.PAN && ! _this.noPan ) {

			_panEnd.copy( getMouseOnScreen( event.pageX, event.pageY ) );

		}

	}

	function mouseup( event ) {

		if ( _this.enabled === false ) return;

		event.preventDefault();
		event.stopPropagation();

		_state = STATE.NONE;

		document.removeEventListener( 'mousemove', mousemove );
		document.removeEventListener( 'mouseup', mouseup );
		_this.dispatchEvent( endEvent );

	}

	function mousewheel( event ) {

		if ( _this.enabled === false ) return;

		event.preventDefault();
		event.stopPropagation();

		_zoomStart.y -= event.deltaY * 0.01;

		_this.dispatchEvent( startEvent );
		_this.dispatchEvent( endEvent );

	}

	function touchstart( event ) {

		if ( _this.enabled === false ) return;

		switch ( event.touches.length ) {

			case 1:
				_state = STATE.TOUCH_ROTATE;
				_moveCurr.copy( getMouseOnCircle( event.touches[ 0 ].pageX, event.touches[ 0 ].pageY ) );
				_movePrev.copy( _moveCurr );
				break;

			default: // 2 or more
				_state = STATE.TOUCH_ZOOM_PAN;
				var dx = event.touches[ 0 ].pageX - event.touches[ 1 ].pageX;
				var dy = event.touches[ 0 ].pageY - event.touches[ 1 ].pageY;
				_touchZoomDistanceEnd = _touchZoomDistanceStart = Math.sqrt( dx * dx + dy * dy );

				var x = ( event.touches[ 0 ].pageX + event.touches[ 1 ].pageX ) / 2;
				var y = ( event.touches[ 0 ].pageY + event.touches[ 1 ].pageY ) / 2;
				_panStart.copy( getMouseOnScreen( x, y ) );
				_panEnd.copy( _panStart );
				break;

		}

		_this.dispatchEvent( startEvent );

	}

	function touchmove( event ) {

		if ( _this.enabled === false ) return;

		event.preventDefault();
		event.stopPropagation();

		switch ( event.touches.length ) {

			case 1:
				_movePrev.copy( _moveCurr );
				_moveCurr.copy( getMouseOnCircle( event.touches[ 0 ].pageX, event.touches[ 0 ].pageY ) );
				break;

			default: // 2 or more
				var dx = event.touches[ 0 ].pageX - event.touches[ 1 ].pageX;
				var dy = event.touches[ 0 ].pageY - event.touches[ 1 ].pageY;
				_touchZoomDistanceEnd = Math.sqrt( dx * dx + dy * dy );

				var x = ( event.touches[ 0 ].pageX + event.touches[ 1 ].pageX ) / 2;
				var y = ( event.touches[ 0 ].pageY + event.touches[ 1 ].pageY ) / 2;
				_panEnd.copy( getMouseOnScreen( x, y ) );
				break;

		}

	}

	function touchend( event ) {

		if ( _this.enabled === false ) return;

		switch ( event.touches.length ) {

			case 0:
				_state = STATE.NONE;
				break;

			case 1:
				_state = STATE.TOUCH_ROTATE;
				_moveCurr.copy( getMouseOnCircle( event.touches[ 0 ].pageX, event.touches[ 0 ].pageY ) );
				_movePrev.copy( _moveCurr );
				break;

		}

		_this.dispatchEvent( endEvent );

	}

	function contextmenu( event ) {

		event.preventDefault();

	}

	this.dispose = function() {

		this.domElement.removeEventListener( 'contextmenu', contextmenu, false );
		this.domElement.removeEventListener( 'mousedown', mousedown, false );
		this.domElement.removeEventListener( 'wheel', mousewheel, false );

		this.domElement.removeEventListener( 'touchstart', touchstart, false );
		this.domElement.removeEventListener( 'touchend', touchend, false );
		this.domElement.removeEventListener( 'touchmove', touchmove, false );

		document.removeEventListener( 'mousemove', mousemove, false );
		document.removeEventListener( 'mouseup', mouseup, false );

		window.removeEventListener( 'keydown', keydown, false );
		window.removeEventListener( 'keyup', keyup, false );

	};

	this.domElement.addEventListener( 'contextmenu', contextmenu, false );
	this.domElement.addEventListener( 'mousedown', mousedown, false );
	this.domElement.addEventListener( 'wheel', mousewheel, false );

	this.domElement.addEventListener( 'touchstart', touchstart, false );
	this.domElement.addEventListener( 'touchend', touchend, false );
	this.domElement.addEventListener( 'touchmove', touchmove, false );

	window.addEventListener( 'keydown', keydown, false );
	window.addEventListener( 'keyup', keyup, false );

	this.handleResize();

	// force an update at start
	this.update();

};

THREE.TrackballControls.prototype = Object.create( THREE.EventDispatcher.prototype );
THREE.TrackballControls.prototype.constructor = THREE.TrackballControls;
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*--------------------------------------------------------------- Creating Error Messages -----------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

// This function is called whenever the code comes across an error. It clears the appropriate items so that equation cannot be continued. It sets the error flag as well.
// The function takes in the id number of the overall equation, and the two id numbers for any subequations that math is being performed on.
function Set_Error(thisid, Error_Num, id1, id2)
{	console.log('The error for '+thisid+' was set - '+Error_Num);
	if (DOM_Object[thisid].Errors_errors===undefined) { DOM_Object[thisid].Errors_errors=[]; }
	DOM_Object[thisid].Errors_flag=1;
	if (self[thisid].Errors_errors===undefined) { self[thisid].Errors_errors=[]; }
	self[thisid].Errors_flag=1;
	if (self[self[thisid]['Original_id']]===undefined){ self[thisid]['Original_id']=thisid; }
	self[self[thisid]['Original_id']].Errors_flag=1;

	if (Error_Num=="NoEntry") { self[thisid].Errors_errors.push("The function "+id1+" did not receive an input as expected."); }

	if (Error_Num=="Math1") { self[thisid].Errors_errors.push("You have attempted to add a "+self[id1].Units_quantity+" to a "+self[id2].Units_quantity+" by adding "+self[id1].Format_showequation+" to "+self[id2].Format_showequation); }
	if (Error_Num=="Math2") { self[thisid].Errors_errors.push("You have attempted to subtract a "+self[id1].Units_quantity+" and a "+self[id2].Units_quantity+" by subtracting "+self[id2].Format_showequation+" from "+self[id1].Format_showequation); }
	if (Error_Num=="Math3") { self[thisid].Errors_errors.push("You are attempting to add a "+self[id1].Format_size+" matrix to one that is "+self[id2].Format_size); }
	if (Error_Num=="Math4") { self[thisid].Errors_errors.push("You are attempting to subtract a "+self[id1].Format_size+" matrix to one that is "+self[id2].Format_size); }

	if (Error_Num=="Format1") { self[thisid].Errors_errors.push("The name '"+DOM_Object[thisid].Format_name+"' is the name of a constant and cannot be reset.");}
	if (Error_Num=="Format2") { self[thisid].Errors_errors.push('The item "'+id1+'" was not identified as a variable, input, constant, or mathematics item. Check the spelling of the item if it was intended to be a variable.'); }
	if (Error_Num=="Format3") { self[thisid].Errors_errors.push("The units entered \""+self[id1].Units_units+"\" do match any current units."); }
	if (Error_Num=="Format4") { self[thisid].Errors_errors.push("The equation has an unmatched closing or opening parenthesis."); }
	if (Error_Num=="Format5") { self[thisid].Errors_errors.push("The equation has an unmatched closing or opening square bracket."); }
	if (Error_Num=="Format6") { self[thisid].Errors_errors.push("The name of an equation cannot be TempEq as this is a reserved phrase."); }
	if (Error_Num=="Format7") { self[thisid].Errors_errors.push("No equation was found. Check to ensure that the equation has a name=equation format."); }
	if (Error_Num=="Format8") { self[thisid].Errors_errors.push("No name was found. Check to ensure that the equation has the format name=equation."); }
	if (Error_Num=="Format9") { self[thisid].Errors_errors.push("There was no matching equation found for the one you are trying to display - "+DOM_Object[thisid].Format_name+"."); }
	if (Error_Num=="Format10") { self[thisid].Errors_errors.push("You are attempting to set the indices of a matrix that does not exist. - "+DOM_Object[thisid].Format_name+"."); }
	if (Error_Num=="Format11") { self[thisid].Errors_errors.push("You are attempting to take a temperature to a power - something that should not happen. - "+DOM_Object[thisid].Format_name+"."); }
	if (Error_Num=="Format12") { self[thisid].Errors_errors.push("The name of an equation matched a unit, which is illegal."); }
	if (Error_Num=="Format13") { self[thisid].Errors_errors.push("The name of an equation must contain at least one letter."); }
	if (Error_Num=="Format14") { self[thisid].Errors_errors.push("The name of the equation entered contained something other than a letter, number, _, ^, { or }."); }
	if (Error_Num=="Format15") { self[thisid].Errors_errors.push("The equation must contain an equal sign."); }

	if (Error_Num=="ForLoop1") { self[thisid].Errors_errors.push("The parameters entered will not generate any iterations of this loop."); }
	if (Error_Num=="ForLoop2") { self[thisid].Errors_errors.push("One of the loop counters - a, b, c, etc - is reset within the loop. This is not allowed."); }
	if (Error_Num=="ForLoop3") { self[thisid].Errors_errors.push("The equation entered for the start value resulted in an error. Make sure that all variables and constants are spelled correctly and have been properly declared."); }
	if (Error_Num=="ForLoop4") { self[thisid].Errors_errors.push("The equation entered for the stop value resulted in an error. Make sure that all variables and constants are spelled correctly and have been properly declared."); }
	if (Error_Num=="ForLoop5") { self[thisid].Errors_errors.push("The equation entered for the increment value resulted in an error. Make sure that all variables and constants are spelled correctly and have been properly declared."); }

	if (Error_Num=="WhileLoop1") { self[thisid].Errors_errors.push("The flag is not reset within the while loop, leading to an infinite loop."); }
	if (Error_Num=="WhileLoop2") { self[thisid].Errors_errors.push("The equation entered for the flag value produced an error. Check to make sure that any variables were spelled correctly and declared properly."); }
	if (Error_Num=="WhileLoop3") { self[thisid].Errors_errors.push("The equation entered for the dependent value produced an error. Check to make sure that any variables were spelled correctly and declared properly."); }

	if (Error_Num=="Flag") 		{ self[thisid].Errors_errors.push("The equation entered for the flag value produced an error. Check to make sure that any variables were spelled correctly and declared properly."); }
	if (Error_Num=="Dependent") { self[thisid].Errors_errors.push("The equation entered for the dependent value produced an error. Check to make sure that any variables were spelled correctly and declared properly."); }

	if (Error_Num=="Transpose1") { self[thisid].Errors_errors.push("The Transpose function received more than one input."); }
	if (Error_Num=="Transpose2") { self[thisid].Errors_errors.push("You are transposing a matrix that is not two-dimensional."); }
	if (Error_Num=="DotProduct1") { self[thisid].Errors_errors.push("You are attempting to perform component multiplication of two matrices of unequal size."); }

	if (Error_Num=="FAF1") { self[thisid].Errors_errors.push("The function called returns multiple values, but the results are used in an equation."); }

	if (Error_Num=="Indices1") { self[thisid].Errors_errors.push("You are attempting to set an index that is outside of the size of the matrix."); }
	
	if (Error_Num=="NC1") { self[thisid].Errors_errors.push("The total number of points is not correct for a second order equation of Newton-Cotes."); }
	if (Error_Num=="NC2") { self[thisid].Errors_errors.push("The total number of points is not correct for a third order equation of Newton-Cotes."); }
	if (Error_Num=="NC3") { self[thisid].Errors_errors.push("The total number of points is not correct for a fourth order equation of Newton-Cotes."); }
	if (Error_Num=="NC4") { self[thisid].Errors_errors.push("The Newton-Cotes method expects to receive 3 inputs."); }
	if (Error_Num=="NC5") { self[thisid].Errors_errors.push("The Newton-Cotes method expects to receive 3 inputs."); }
	if (Error_Num=="NC6") { self[thisid].Errors_errors.push("The X and Y data for the Newton Cotes method must be the same length."); }
	if (Error_Num=="NC7") { self[thisid].Errors_errors.push("The order must be a single number."); }
	if (Error_Num=="NC8") { self[thisid].Errors_errors.push("The x and y vectors were not long enough for the NC calculations."); }

	if (Error_Num=="Integrate1") { self[thisid].Errors_errors.push("The integration algorithm expects 2 inputs."); }
	if (Error_Num=="Integrate2") { self[thisid].Errors_errors.push("The integration algorithm expects 2 inputs."); }
	if (Error_Num=="Integrate3") { self[thisid].Errors_errors.push("The length of the x and y vectors must match for the integration function."); }
	if (Error_Num=="Integrate4") { self[thisid].Errors_errors.push("The vector was not long enough for the integration algorithm."); }

	if (Error_Num=="Root1") { self[thisid].Errors_errors.push("This equation resulted in units that were not whole numbers."); }

	if (Error_Num=="Trig1") { self[thisid].Errors_errors.push("Trig functions expect to see one number or variable. You entered "+id1+" variables into a "+id2+" function."); }
	if (Error_Num=="Trig2") { self[thisid].Errors_errors.push("The function "+id1+" received units of "+id2+" and it should receive either degrees, radians, or no units."); }

	if (Error_Num=="Min1") { self[thisid].Errors_errors.push("You called the min function with no inputs."); }
	if (Error_Num=="Max1") { self[thisid].Errors_errors.push("You called the max function with no inputs."); }

	if (Error_Num=="Min2") { self[thisid].Errors_errors.push("You are comparing inconsistent units within a min function."); }
	if (Error_Num=="Max2") { self[thisid].Errors_errors.push("You are comparing inconsistent units within a max function."); }

	if (Error_Num=="Abs1") { self[thisid].Errors_errors.push("The absolute value function received more than one input."); }

	if (Error_Num=="Floor1") { self[thisid].Errors_errors.push("You called the floor function with no inputs."); }
	if (Error_Num=="Floor2") { self[thisid].Errors_errors.push("You called the floor function with more than 2 inputs. If you are trying to enter units, the second entry must be an array as in [ft, s, kg]"); }

	if (Error_Num=="Ceil1") { self[thisid].Errors_errors.push("You called the ceil function with no inputs."); }
	if (Error_Num=="Ceil2") { self[thisid].Errors_errors.push("You called the ceil function with more than 2 inputs. If you are trying to enter units, the second entry must be an array as in [ft, s, kg]"); }

	if (Error_Num=="Round1") { self[thisid].Errors_errors.push("You entered more than 2 entries into the round function."); }
	if (Error_Num=="Round2") { self[thisid].Errors_errors.push("The precision given for the round function must be an integer."); }

	if (Error_Num=="log1") { self[thisid].Errors_errors.push("The log function expects at least 2 entries."); }
	if (Error_Num=="log2") { self[thisid].Errors_errors.push("The log function cannot take more than 2 entries."); }
	if (Error_Num=="log3") { self[thisid].Errors_errors.push("You attempted to take the logarithm of 0."); }

	if (Error_Num=="Power1") { self[thisid].Errors_errors.push("The power function expects to receive 2 entries."); }
	if (Error_Num=="Power2") { self[thisid].Errors_errors.push("The power function cannot handle more than 2 entries."); }
	if (Error_Num=="Power3") { self[thisid].Errors_errors.push("You attempted to use an exponent that had units."); }
	if (Error_Num=="Power4") { self[thisid].Errors_errors.push("The exponent entered was not a single number nor equal in size to the base."); }
	if (Error_Num=="Power5") { self[thisid].Errors_errors.push("The resulting power function had units of "+id1+" which was not a whole number."); }

	if (Error_Num=="Root1") { self[thisid].Errors_errors.push("The root function expects to receive 2 entries."); }
	if (Error_Num=="Root2") { self[thisid].Errors_errors.push("The root function cannot handle more than 2 entries."); }
	if (Error_Num=="Root3") { self[thisid].Errors_errors.push("You attempted to use a root that has units."); }
	if (Error_Num=="Root4") { self[thisid].Errors_errors.push("The root number entered was not a single number nor equal in size to the equation."); }
	if (Error_Num=="Root5") { self[thisid].Errors_errors.push("The resulting root function had units of "+id1+" which was not a whole number."); }

	if (Error_Num=="Derivative1") { self[thisid].Errors_errors.push("The derivative function expects to receive 4 entries."); }
	if (Error_Num=="Derivative2") { self[thisid].Errors_errors.push("The derivative function expects to receive 4 entries."); }
	if (Error_Num=="Derivative3") { self[thisid].Errors_errors.push("The order must be a 1, 2, 3, or 4."); }
	if (Error_Num=="Derivative4") { self[thisid].Errors_errors.push("The accuracy must be a 1 or a 2."); }
	if (Error_Num=="Derivative5") { self[thisid].Errors_errors.push("The vectors were not long enough to perform the derivative calculation."); }

	if (Error_Num=="DerivativeUn1") { self[thisid].Errors_errors.push("The derivative function expects to receive 3 entries."); }
	if (Error_Num=="DerivativeUn2") { self[thisid].Errors_errors.push("The derivative function expects to receive 3 entries."); }
	if (Error_Num=="DerivativeUn3") { self[thisid].Errors_errors.push("The x location asked for in DerivativeUn - "+id1+" - is not within the original x vector."); }
	if (Error_Num=="DerivativeUn4") { self[thisid].Errors_errors.push("The sampled x locations and the y data must be the same length for DerivativeUn."); }
	if (Error_Num=="DerivativeUn5") { self[thisid].Errors_errors.push("The vectors were not long enough to perform the derivative calculation."); }

	if (Error_Num=="Vector1") { self[thisid].Errors_errors.push("To make a vector from a table, either the columns or the rows of the two table elements must be equal."); }
	if (Error_Num=="Vector2") { self[thisid].Errors_errors.push("To make a vector from a table, the second row entered must be a greater number than the first."); }

	if (Error_Num=="Identity1") { self[thisid].Errors_errors.push("The Identity function expects to take in a single number as its input."); }

	if (Error_Num=="CreateMatrix1") { self[thisid].Errors_errors.push("The CreateMatrix function expects to take in 4 arguments - the real default, the imaginary default, and the number of rows and columns.."); }

	if (Error_Num=="Size1") { self[thisid].Errors_errors.push("The size function expects to receive 2 inputs, but recieved more."); }
	if (Error_Num=="Size2") { self[thisid].Errors_errors.push("The size function expects to receive 2 inputs, but received only 1."); }

	if (Error_Num=="Real1") { self[thisid].Errors_errors.push("The Real function expects to receive 1 input, but recieved more."); }
	if (Error_Num=="Imag1") { self[thisid].Errors_errors.push("The Imag function expects to receive 1 input, but received more."); }

	if (Error_Num=="rand1") { self[thisid].Errors_errors.push("The rand function did not receive the correct number of inputs - 3."); }
	if (Error_Num=="rand2") { self[thisid].Errors_errors.push("The lower limit of the random number was higher than the higher limit entered."); }
	if (Error_Num=="rand3") { self[thisid].Errors_errors.push("The precision entered for the random number generator was less than 0."); }
	if (Error_Num=="randMat1") { self[thisid].Errors_errors.push("The randMat function did not receive the correct number of inputs - 5."); }
	if (Error_Num=="randMat2") { self[thisid].Errors_errors.push("The lower limit of the random number was higher than the higher limit entered."); }
	if (Error_Num=="randMat3") { self[thisid].Errors_errors.push("The precision entered for the random number generator was less than 0."); }

	if (Error_Num=="GaussE1") { self[thisid].Errors_errors.push("The GaussE function expects to receive 2 inputs and received more than that."); }
	if (Error_Num=="GaussE2") { self[thisid].Errors_errors.push("The coefficient matrix received by the GaussE function was not square."); }
	if (Error_Num=="GaussE3") { self[thisid].Errors_errors.push("The size of the coefficient matrix must match the number of rows in the results vector."); }
	if (Error_Num=="GaussE4") { self[thisid].Errors_errors.push("The results vector was not in the form of a column vector."); }

	if (Error_Num=="Mean1") { self[thisid].Errors_errors.push("The mean function failed to receive an input."); }
	if (Error_Num=="Mean2") { self[thisid].Errors_errors.push("The mean function received units that were of different quantities."); }
	if (Error_Num=="Median1") { self[thisid].Errors_errors.push("The median function failed to receive an input."); }
	if (Error_Num=="Median2") { self[thisid].Errors_errors.push("The median function received units that were of different quantities."); }
	if (Error_Num=="Mode1") { self[thisid].Errors_errors.push("The mode function failed to receive an input."); }
	if (Error_Num=="Mode2") { self[thisid].Errors_errors.push("The mode function received units that were of different quantities."); }
	if (Error_Num=="Range1") { self[thisid].Errors_errors.push("The range function failed to receive an input."); }
	if (Error_Num=="Range2") { self[thisid].Errors_errors.push("The range function received units that were of different quantities."); }

	if (Error_Num=="StdDev1") { self[thisid].Errors_errors.push("The standard deviation function failed to receive an input."); }
	if (Error_Num=="Variance1") { self[thisid].Errors_errors.push("The variance function failed to receive an input."); }
	if (Error_Num=="CV1") { self[thisid].Errors_errors.push("The coefficient of variation function failed to receive an input."); }

	if (Error_Num=="Polyfit1") { self[thisid].Errors_errors.push("The polyfit function expects 3 inputs and recieved less than that."); }
	if (Error_Num=="Polyfit2") { self[thisid].Errors_errors.push("The polyfit function expects 3 inputs and recieved more than that."); }
	if (Error_Num=="Polyfit3") { self[thisid].Errors_errors.push("The polyfit function can output a coefficient vector and a coefficients of determination. It cannot output more than two items."); }
	if (Error_Num=="Polyfit4") { self[thisid].Errors_errors.push("The polynomial type entered into polyfit must be a single integer. Its size was "+self[id1].Format_size+" and its value was "+self[id1].Solution_real['0-0']); }
	if (Error_Num=="Polyfit5") { self[thisid].Errors_errors.push("The x and y vectores entered into polyfit were not the same size. The x vector was "+self[id1].Format_size+" and the y vector was "+self[id2].Format_size); }

	if (Error_Num=="Logfit1") { self[thisid].Errors_errors.push("The logfit function expects 2 inputs"); }
	if (Error_Num=="Logfit2") { self[thisid].Errors_errors.push("The x and y vectors sent to logfit were not of equal size."); }
	if (Error_Num=="Logfit3") { self[thisid].Errors_errors.push("The logfit function can only output 2 arguments. More than that number was requested."); }

	if (Error_Num=="Expfit1") { self[thisid].Errors_errors.push("The expfit function expects 2 inputs"); }
	if (Error_Num=="Expfit2") { self[thisid].Errors_errors.push("The x and y vectors sent to expfit were not of equal size."); }
	if (Error_Num=="Expfit3") { self[thisid].Errors_errors.push("The logfit function can only output 2 arguments. More than that number was requested."); }

	if (Error_Num=="Powerfit1") { self[thisid].Errors_errors.push("The powerfit function expects 2 inputs"); }
	if (Error_Num=="Powerfit2") { self[thisid].Errors_errors.push("The x and y vectors sent to powerfit were not of equal size."); }
	if (Error_Num=="Powerfit3") { self[thisid].Errors_errors.push("The powerfit function can only output 2 arguments. More than that number was requested."); }

	if (Error_Num=="Histogram1") { self[thisid].Errors_errors.push("The Histogram function expects 2 inputs"); }
	if (Error_Num=="Histogram3") { self[thisid].Errors_errors.push("The histogram function can only output 2 items."); }

	if (Error_Num=="numinds1") { self[thisid].Errors_errors.push("The numinds function received more than one input."); }

	if (Error_Num=="Cholesky1") { self[thisid].Errors_errors.push("You entered more than 1 entry into the Cholesky function."); }
	if (Error_Num=="Cholesky2") { self[thisid].Errors_errors.push("The matrix entered into the Cholesky function was not square."); }
	if (Error_Num=="Cholesky3") { self[thisid].Errors_errors.push("The matrix entered into the Cholesky function was not symmetric."); }

	if (Error_Num=="Norm1") { self[thisid].Errors_errors.push("The Norm function did not receive two inputs as needed."); }
	if (Error_Num=="Norm2") { self[thisid].Errors_errors.push("The number entered for the norm - "+id2+" was not an integer."); }

	if (Error_Num=="RSNorm1") { self[thisid].Errors_errors.push("The RSNorm function received more than one input."); }
	if (Error_Num=="CSNorm1") { self[thisid].Errors_errors.push("The CSNorm function received more than one input."); }

	if (Error_Num=="Trace1") { self[thisid].Errors_errors.push("The Trace function received more than 1 input."); }
	if (Error_Num=="Trace2") { self[thisid].Errors_errors.push("The matrix entered into the Trace function was not square."); }

	if (Error_Num=="Conj1") { self[thisid].Errors_errors.push("The Trace function did not receive one input as needed."); }

    if (Error_Num=="DotMult1") { self[thisid].Errors_errors.push("The DotMult function needs to inputs."); }
	if (Error_Num=="DotMult2") { self[thisid].Errors_errors.push("The two matrices given to the DotMult program must be the same size."); }
    if (Error_Num=="DotDiv1") { self[thisid].Errors_errors.push("The DotDiv function needs to inputs."); }
	if (Error_Num=="DotDiv2") { self[thisid].Errors_errors.push("The two matrices given to the DotDiv program must be the same size."); }

	if (Error_Num=="Threshold1") { self[thisid].Errors_errors.push("The Threshold function did not receive three inputs as needed."); }
	if (Error_Num=="Threshold2") { self[thisid].Errors_errors.push("The lower limit was higher than the high limit for the Threshold function."); }

	if (Error_Num=="Cross1") { self[thisid].Errors_errors.push("The Cross function did not receive two inputs as needed."); }
	if (Error_Num=="Cross2") { self[thisid].Errors_errors.push("The vectors for the Cross function must be 1x3 row vectors."); }

	if (Error_Num=="isRow1") { self[thisid].Errors_errors.push("The isRow function received more than 1 input."); }
	if (Error_Num=="isColumn1") { self[thisid].Errors_errors.push("The isColumn function received more than 1 input."); }
	if (Error_Num=="isMatrix1") { self[thisid].Errors_errors.push("The isMatrix function received more than 1 input."); }
	if (Error_Num=="length1") { self[thisid].Errors_errors.push("The length function received more than 1 input."); }
	if (Error_Num=="NumEl1") { self[thisid].Errors_errors.push("The NumEl function received more than 1 input."); }

	if (Error_Num=="fliplr1") { self[thisid].Errors_errors.push("The fliplr function received too many inputs."); }
	if (Error_Num=="fliplr2") { self[thisid].Errors_errors.push("The fliplr function received a matrix more than two dimensions."); }
	if (Error_Num=="flipud1") { self[thisid].Errors_errors.push("The flipud function received too many inputs."); }
	if (Error_Num=="flipud2") { self[thisid].Errors_errors.push("The flipud function received a matrix more than two dimensions."); }

	if (Error_Num=="diag1") { self[thisid].Errors_errors.push("The diag function received more than two inputs."); }
	if (Error_Num=="diag2") { self[thisid].Errors_errors.push("The matrix sent to the diag function had more than two dimensions."); }
	if (Error_Num=="diag3") { self[thisid].Errors_errors.push("The vector sent to the diag function was not a row vector."); }
	if (Error_Num=="diag4") { self[thisid].Errors_errors.push("The offset to the diag function must be an integer."); }
	if (Error_Num=="diag5") { self[thisid].Errors_errors.push("The matrix sent to the diag function must be square."); }

	if (Error_Num=="matur1") { self[thisid].Errors_errors.push("The matur function received more than two inputs."); }
	if (Error_Num=="matur2") { self[thisid].Errors_errors.push("The offset given to the matur function must be an integer."); }
	if (Error_Num=="matur3") { self[thisid].Errors_errors.push("The matrix given to matur must be two dimensional."); }
	if (Error_Num=="matur4") { self[thisid].Errors_errors.push("The matrix given to matur must be square."); }

	if (Error_Num=="matll1") { self[thisid].Errors_errors.push("The matll function received more than two inputs."); }
	if (Error_Num=="matll2") { self[thisid].Errors_errors.push("The offset given to the matll function must be an integer."); }
	if (Error_Num=="matll3") { self[thisid].Errors_errors.push("The matrix given to matll must be two dimensional."); }
	if (Error_Num=="matll4") { self[thisid].Errors_errors.push("The matrix given to matll must be square."); }

	if (Error_Num=="Dot1") { self[thisid].Errors_errors.push("The Dot function did not receive the expected 2 inputs."); }
	if (Error_Num=="Dot2") { self[thisid].Errors_errors.push("The input vectors to the Dot function were not the same size."); }
	if (Error_Num=="Dot3") { self[thisid].Errors_errors.push("The dimension into the dot product must be a 0 or 1."); }

	if (Error_Num=="incSearch1") { self[thisid].Errors_errors.push("The incSearch function must receive at least 3 inputs."); }
	if (Error_Num=="incSearch2") { self[thisid].Errors_errors.push("The incSearch function can receive no more than 5 inputs."); }
	if (Error_Num=="incSearch3") { self[thisid].Errors_errors.push("The min entered for the incSearch function was greater than the max."); }

	if (Error_Num=="Bisect1") { self[thisid].Errors_errors.push("The Bisect function must receive at least 3 inputs."); }
	if (Error_Num=="Bisect2") { self[thisid].Errors_errors.push("The Bisect function can receive no more than 5 inputs."); }
	if (Error_Num=="Bisect3") { self[thisid].Errors_errors.push("The min entered for the Bisect function was greater than the max."); }
	if (Error_Num=="Bisect4") { self[thisid].Errors_errors.push("The upper and lower limits for the Bisect function did not produce opposing signs."); }

	if (Error_Num=="FalsePos1") { self[thisid].Errors_errors.push("The FalsePos function must receive at least 3 inputs."); }
	if (Error_Num=="FalsePos2") { self[thisid].Errors_errors.push("The FalsePos function can receive no more than 5 inputs."); }
	if (Error_Num=="FalsePos3") { self[thisid].Errors_errors.push("The min entered for the FalsePos function was greater than the max."); }
	if (Error_Num=="FalsePos4") { self[thisid].Errors_errors.push("The upper and lower limits for the FalsePos function did not produce opposing signs."); }

	if (Error_Num=="Secant1") { self[thisid].Errors_errors.push("The Secant function must receive at least 3 inputs."); }
	if (Error_Num=="Secant2") { self[thisid].Errors_errors.push("The Secant function can receive no more than 4 inputs."); }

	if (Error_Num=="MultMat1") { self[thisid].Errors_errors.push("When multiplying matrices, the rows in matrix 1 must match the number of columns in matrix 2 and the number of columns in matrix 1 must match the number of rows in matrix 2. You are multuplying matrices of "+id1+" and "+id2+"."); }

	if (Error_Num=="ODE41") { self[thisid].Errors_errors.push("The ODE4 function did not receive the required number of inputs (3)."); }
	if (Error_Num=="ODE42") { self[thisid].Errors_errors.push("The number of initial values did not match the number of functions in the ODE4 function."); }

	if (Error_Num=="Row2Mat1") { self[thisid].Errors_errors.push("The Row2Mat function did not receive 2 inputs - a row and a number."); }
	if (Error_Num=="Row2Mat2") { self[thisid].Errors_errors.push("The Row2Mat received more than 2 inputs - a row and a number."); }
	if (Error_Num=="Row2Mat3") { self[thisid].Errors_errors.push("The first entry in the Row2Mat function must be a row."); }
	if (Error_Num=="Col2Mat1") { self[thisid].Errors_errors.push("The Col2Mat function did not receive 2 inputs - a column and a number."); }
	if (Error_Num=="Col2Mat2") { self[thisid].Errors_errors.push("The Col2Mat received more than 2 inputs - a column and a number."); }
	if (Error_Num=="Col2Mat3") { self[thisid].Errors_errors.push("The first entry in the Col2Mat function must be a column."); }

	if (Error_Num=="LUDecomp1") { self[thisid].Errors_errors.push("The LUDecomp function received more than 1 input"); }
	if (Error_Num=="LUDecomp2") { self[thisid].Errors_errors.push("The LUDecomp function must have two outputs"); }
	if (Error_Num=="LUDecomp3") { self[thisid].Errors_errors.push("The LUDecomp received a number and it should receive a matrix"); }
	if (Error_Num=="LUDecomp4") { self[thisid].Errors_errors.push("The LUDecomp function received a matrix that was not square"); }

	if (Error_Num=="Det1") { self[thisid].Errors_errors.push("The Det function received more than 1 input"); }
	if (Error_Num=="Det2") { self[thisid].Errors_errors.push("The Det received a number and it should receive a matrix"); }
	if (Error_Num=="Det3") { self[thisid].Errors_errors.push("The Det function received a matrix that was not square"); }

	if (Error_Num=="MatPow1") { self[thisid].Errors_errors.push("The MatPow function received less than 2 inputs"); }
	if (Error_Num=="MatPow2") { self[thisid].Errors_errors.push("The MatPow function received more than 2 inputs"); }
	if (Error_Num=="MatPow3") { self[thisid].Errors_errors.push("The matrix sent to MatPow is not square"); }
	if (Error_Num=="MatPow4") { self[thisid].Errors_errors.push("The exponent sent to MatPow was a matrix and should be a single number"); }
	if (Error_Num=="MatPow5") { self[thisid].Errors_errors.push("The exponent sent to MatPow was less than 1"); }

	if (Error_Num=="IntVec1") { self[thisid].Errors_errors.push("The IntVec function received less than 2 inputs"); }
	if (Error_Num=="IntVec2") { self[thisid].Errors_errors.push("The IntVec function received more than 2 inputs"); }
	if (Error_Num=="IntVec3") { self[thisid].Errors_errors.push("The vectors sent to the IntVec function must be longer"); }
	if (Error_Num=="IntVec4") { self[thisid].Errors_errors.push("The x and y vectors sent to the IntVec function were not the same size"); }

	if (Error_Num=="sign1") { self[thisid].Errors_errors.push("The sign function can only have a maximum of 4 total inputs"); }

	if (Error_Num=="rotate1") { self[thisid].Errors_errors.push("The rotate function should not receive more than 1 input"); }
	if (Error_Num=="rotate2") { self[thisid].Errors_errors.push("The matrix sent to the rotate function should be two dimensional"); }

	if (Error_Num=="isPosDef1") { self[thisid].Errors_errors.push("The isPosDef function can only take in 1 input"); }
	if (Error_Num=="isPosDef2") { self[thisid].Errors_errors.push("The matrix sent to the isPosDef function should not be a number"); }
	if (Error_Num=="isPosDef3") { self[thisid].Errors_errors.push("The matrix sent to the isPosDef function must be square"); }

	if (Error_Num=="IfElse1") { self[thisid].Errors_errors.push("The IfElse function cannot receive more than 5 inputs"); }
	if (Error_Num=="IfElse2") { self[thisid].Errors_errors.push("The IfElse function cannot receive less than 4 inputs"); }
	if (Error_Num=="IfElse3") { self[thisid].Errors_errors.push("The test string in the IfElse function must be ==, !=, >=, <=, >, or <"); }

	if (Error_Num=="Indices1") { self[thisid].Errors_errors.push("You sent "+id2+" numbers to index "+id1+" of a matrix. There must be only 1 number or three entries of [number:number]"); }
	if (Error_Num=="Indices2") { self[thisid].Errors_errors.push("You are attempting to set "+id1+" dimensions on a variable that has "+id2+" dimensions. "); }
	if (Error_Num=="Indices3") { self[thisid].Errors_errors.push("You are attempting to set "+id1+" numbers to a matrix that has only "+id2+" numbers on the left side."); }
	if (Error_Num=="Indices4") { self[thisid].Errors_errors.push("You are attempting to set a matrix with a size of "+id1+" to a matrix the size of "+id2+"."); }

}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------------------------------------ EQUATIONS ----------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/


/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------------------------- THE ON MESSAGE FUNCTION -------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/* 	This is the functiont that is invoked whenever the EquationSolver algorithm is called. The JSON object sent to the function expects to receive 3 different items.	\
	The first item is the id of the equation in question. The second item is the text of the equation in question. The third item is a JSON object containing the 		\
	DOM Object that has all the needed items. This includes both equations and tables.																					\
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
	showDebug=false;
    

    onmessage = function (Event) 
	{	
		console.log('In the web worker with a type of '+Event.data['cadwolfType']);
		console.log('The eqObj is ...');
		console.log(Event.data['eqObj']);

		// Import the sent items into the web worker
		var equation='', eqID='', eqObj={};
		Build_FunctionList();
		DOM_Object=JSON.parse(JSON.stringify(Event.data['eqObj']));
		console.log(DOM_Object);
		if (DOM_Object===undefined){    DOM_Object={};  }             
        ImportedFunctions=Event.data['importedFunctions'];
		FileID=Event.data['FileID'];
		unitList=Event.data['unitList'];		        
		UnitList=new Array('A', 'K', 's', 'm', 'kg', 'cd', 'mol', 'molecules', 'rad');											                             
        scaleUnits=formatScaleUnits(Event.data['scaleUnits']);		    
		parseUnits=formatParseUnits(Event.data['parseUnits']);																													      
        Constants=formatConstants(Event.data['Constants']);
        cadParts=Event.data['cadParts'];
		eventType=Event.data['cadwolfType'];
		eventErrorFlag=0;
		eventError='';

		// Call the appropriate action for the type of item being solved
        if (Event.data['cadwolfType']=="SolveEquation")
		{	self[Event.data['eqID']]=new Equation(Event.data['eqID']);
			self[Event.data['eqID']]['Format_showvalue']=Event.data['showValue'];				            
			self[Event.data['eqID']].fileid=Event.data['FileID'];
			self[Event.data['eqID']].Original_id=Event.data['eqID'];
			self[Event.data['eqID']].Page_position=Event.data['order'];
			console.log('In the solver for equation '+Event.data['eqID']+' - '+Event.data['Equation']);
			self[Event.data['eqID']].Solve_Equation(Event.data['Equation']);
		}
		if (Event.data['cadwolfType']=="SolveTableCell")
		{	console.log('The table ID, row, and column are '+Event.data['tableID']+' - '+Event.data['tableRow']+' - '+Event.data['tableCol']);
			eqobj={	Page_position:Event.data['order'], 
					equation:"myTableCell"+Event.data['Equation'],
					tableID:Event.data['tableID'],
					tableRow:Event.data['tableRow'],
					tableCol:Event.data['tableCol']
			};
			eqID=CreateEq(Event.data['FileID'], 1, eqobj);
		}
		if (Event.data['cadwolfType']=="SolveTableFill")
		{	solveTableFill( Event.data['FileID'],
							Event.data['tableID'], 
							Event.data['order'], 
							Event.data['fillType'], 
							Event.data['tableRow'], 
							Event.data['tableCol'], 
							Event.data['numRows'], 
							Event.data['numCols'],
							1  );
		}
		if (Event.data['cadwolfType']=="solvePlotData")
		{	console.log('In solve plot data function with a className of '+Event.data['className']);
            plotObject=Event.data['plotObject'];
			PlotID=Event.data['plotID'];
			DataID=Event.data['dataID'];
			className=Event.data['className'];
			FileID=Event.data['FileID'];
            thisEqx='', thisEqy='', thisEqz='', thisEqc='';           
            if (className=="all")
			{	var dataIndex=0;
                for (var dataIndex=0; dataIndex<plotObject['Chart_dataobj'].length; dataIndex++) 
                {   if (plotObject['Chart_dataobj'][dataIndex]['Format_id']==DataID)       
                    {   thisEqx=plotObject['Chart_dataobj'][dataIndex]['xdata_name'];
                        thisEqy=plotObject['Chart_dataobj'][dataIndex]['ydata_name'];
				        thisEqz=plotObject['Chart_dataobj'][dataIndex]['zdata_name'];
				        thisEqc=plotObject['Chart_dataobj'][dataIndex]['cdata_name'];
                }   }                                                 
                console.log('The plot and data IDs are '+PlotID+' and '+DataID+' while the x and y equations are '+thisEqx+' and '+thisEqy);
                if ((thisEqx!='')&&(thisEqy!='')&&(thisEqz!='')&&(thisEqc!=''))
                {
                	PassPlotData(plotObject, PlotID, DataID, 'all');
                } 
                if (thisEqx!='') 
				{	eqobj={Page_position:DOM_Object[PlotID]['order'], equation:"PlotEq="+thisEqx};
					eqID=CreateEq(FileID, 0, eqobj);
					if ((((thisEqy=='')||(thisEqy===undefined)))&&(((thisEqz=='')||(thisEqz===undefined))))
					{	self[eqID].Solve_Equation("PlotEq="+thisEqx, function() { PrepPlotData(eqID, plotObject, PlotID, DataID, 'plot_xdatainput', function() {
							PassPlotData(plotObject, PlotID, DataID, 'all'); }); }); 
					}else{self[eqID].Solve_Equation("PlotEq="+thisEqx, function() { PrepPlotData(eqID, plotObject, PlotID, DataID, 'plot_xdatainput'); }); 	}
				}
				if (thisEqy!='')
				{	eqobj={Page_position:DOM_Object[PlotID]['order'], equation:"PlotEq="+thisEqy};
					eqID=CreateEq(FileID, 0, eqobj);
					if (((thisEqz=='')||(thisEqz===undefined)))
					{	self[eqID].Solve_Equation("PlotEq="+thisEqy, function() { PrepPlotData(eqID, plotObject, PlotID, DataID, 'plot_ydatainput', function() {
							PassPlotData(plotObject, PlotID, DataID, 'all'); }); }); 
					}else{self[eqID].Solve_Equation("PlotEq="+thisEqy, function() { PrepPlotData(eqID, plotObject, PlotID, DataID, 'plot_ydatainput'); }); 	}
				}
				if ((thisEqz!='')&&(thisEqz!==undefined)) 			       
				{	eqobj={Page_position:DOM_Object[PlotID]['order'], equation:"PlotEq="+thisEqz};
					eqID=CreateEq(FileID, 0, eqobj);
					self[eqID].Solve_Equation("PlotEq="+thisEqz, function() { PrepPlotData(eqID, plotObject, PlotID, DataID, 'plot_zdatainput', function() { 
						PassPlotData(plotObject, PlotID, DataID, 'all'); }); }); 
				}
				if ((thisEqc!='')&&(thisEqc!=undefined)) 
				{	eqobj={Page_position:DOM_Object[PlotID]['order'], equation:"PlotEq="+thisEqc};
					eqID=CreateEq(FileID, 0, eqobj);
					self[eqID].Solve_Equation("PlotEq="+thisEqc, function() { PrepPlotData(eqID, plotObject, PlotID, DataID, 'plot_cdatainput', function() { 
						PassPlotData(plotObject, PlotID, DataID, 'all'); }); }); 
				}
			}else if (className=="Lathe")
			{	thisEq=plotObject['Chart_dataobj'][dataIndex]['curvetext']; 
				eqobj={Page_position:DOM_Object[PlotID]['order'], Format_showtype:"InnerFunction", equation:"PlotEq="+thisEq};
				eqID=CreateEq(FileID, 0, eqobj);
				self[eqID].Solve_Equation("PlotEq="+thisEq, function() { 
					PrepPlotData(eqID, plotObject, PlotID, DataID, className, function() { 
					PassPlotData(plotObject, PlotID, DataID, className);	});		});
			}else
			{	for (var thisData=0; thisData<plotObject['Chart_dataobj'].length; thisData++)   
                {   if (plotObject['Chart_dataobj'][thisData]['Format_id']==DataID)                             
                    {   console.log('For data id '+DataID+', the name is '+plotObject['Chart_dataobj'][thisData]['ydata_name']);
                        var thisEq='';
                        if (className=="plot_xdatainput"){ thisEq=plotObject['Chart_dataobj'][thisData]['xdata_name']; }
                        if (className=="plot_ydatainput"){ thisEq=plotObject['Chart_dataobj'][thisData]['ydata_name']; }
				        if (className=="plot_zdatainput"){ thisEq=plotObject['Chart_dataobj'][thisData]['zdata_name']; }
				        if (className=="plot_cdatainput"){ thisEq=plotObject['Chart_dataobj'][thisData]['cdata_name']; }
				        if (className=="xLathe"){ thisEq=plotObject['Chart_dataobj'][thisData]['xdata_name']; }
				        if (className=="yLathe"){ thisEq=plotObject['Chart_dataobj'][thisData]['ydata_name']; }
				        if (thisEq=='')	{ thisEq="[0:1:"+Object.keys(plotObject['Chart_dataobj'][thisData]['PointData']).length-1+"]"; } 
                    }                                                 
                }                                                     
                eqobj={Page_position:DOM_Object[PlotID]['order'], Format_showtype:"InnerFunction", equation:"PlotEq="+thisEq};
				eqID=CreateEq(FileID, 0, eqobj);
				self[eqID].Solve_Equation("PlotEq="+thisEq, function() { 
					PrepPlotData(eqID, plotObject, PlotID, DataID, className, function() { 
					PassPlotData(plotObject, PlotID, DataID, className);	});		});
			}
		}
		if (Event.data['cadwolfType']=="FormatSolution")
		{	eqObj=Event.data['eqObject'];
			eqID=Event.data['eqID'];
			self[eqID]=new Equation(eqID);
			for (var objProp in eqObj) { self[eqID][objProp]=eqObj[objProp]; }
			self[eqID].Show_Solution(function() { passSolutionResults(eqID);	});
		}
		if (Event.data['cadwolfType']=="SolveStructure")
		{	for (var itemID in DOM_Object) 
			{	console.log('Creating a new item for '+itemID);
				if (DOM_Object[itemID]['component_type_id']=="8")		{ self[itemID]=new IfElse(DOM_Object[itemID]);			}									    
				if (DOM_Object[itemID]['component_type_id']=="6")		{ self[itemID]=new ForLoop(DOM_Object[itemID]);	        }								       
				if (DOM_Object[itemID]['component_type_id']=="7")		{ self[itemID]=new WhileLoop(DOM_Object[itemID]);		}									    
				if (DOM_Object[itemID]['component_type_id']=="3")	          
                {   
			        self[itemID]=new Equation( itemID, DOM_Object[itemID]['name'], DOM_Object[itemID]['fileid'] );	   
                    self[itemID].fileid=DOM_Object[itemID]['fileid'];																							    
                    self[itemID].Original_id=itemID;																					            
                    self[itemID].Page_position=DOM_Object[itemID]['order'];																					    
                    self[itemID].order=DOM_Object[itemID]['order'];																							    
                    self[itemID].Format_id=itemID;	       																			            
					for (var objProp in DOM_Object[itemID]) 
					{  
						self[itemID][objProp]=DOM_Object[itemID][objProp]; 	
					}	
					console.log('I just created '+itemID+' with the name '+DOM_Object[itemID]['name']+' and fileid of '+DOM_Object[itemID]['fileid']);											    
                }                                                                                                         
			}
			DoStructures(Event.data['ID'], 0, 1, function () { Return_Structure(Event.data['ID']); } );  
        }

		// Actually solves each of the three parameters for a for loop 
		if (Event.data['cadwolfType']=="SolveLoopParameters")    
		{	
			self[Event.data['LoopID']]=Event.data['loopObject'];
			self[Event.data['LoopID']].fileid=Event.data['FileID'];
			DOM_Object[Event.data['LoopID']]=Event.data['loopObject'];
			DOM_Object[Event.data['LoopID']].fileid=Event.data['FileID'];
			DOM_Object[Event.data['LoopID']]['order']=Event.data['order'];
			SolveLoopParameters(Event.data['LoopID'], function() { PassForLoopParameters(Event.data['LoopID']); });
		}

		// Solves the equations within a while loop statement (not the structure) 
		if (Event.data['cadwolfType']=="SolveWhileLoopParameters") 
		{	
			// self[Event.data['ID']]=new WhileLoop(Event.data['loopObject']);
			self[Event.data['LoopID']]=Event.data['loopObject'];
			self[Event.data['LoopID']].fileid=Event.data['FileID'];
			DOM_Object[Event.data['LoopID']]=Event.data['loopObject'];
			DOM_Object[Event.data['LoopID']].fileid=Event.data['FileID'];
			DOM_Object[Event.data['LoopID']]['order']=Event.data['order'];
			SolveWhileLoopParameters(Event.data['ID'], 1, function () {	 																    
				CheckWhileLoop(Event.data['ID'], function () { 																									    
				PassWhileParameters(Event.data['ID']); }); });																									    
		}

		// Solves the equations within an if/else statement (not the structure)
		if (Event.data['cadwolfType']=="SolveIfElseParameters")                  
		{	
			// self[Event.data['ID']]=new IfElse(Event.data['loopObject']);
			self[Event.data['LoopID']]=Event.data['loopObject'];
			self[Event.data['LoopID']].fileid=Event.data['FileID'];
			DOM_Object[Event.data['LoopID']]=Event.data['loopObject'];
			DOM_Object[Event.data['LoopID']]['order']=Event.data['order'];
			DOM_Object[Event.data['LoopID']].fileid=Event.data['FileID'];
			SolveIfElseParameters(Event.data['ID'], function() { 																			         
				CheckStatement(Event.data['ID'], function () { 											              
				PassIfElseParameters(Event.data['ID']); }); });														               
		}
		if (Event.data['cadwolfType']=="SolveSurfaceData")
		{	
			solveSurfaceData(Event.data['PlotID'], Event.data['DataID'], Event.data['dataObject'], Event.data['axis'], Event.data['type'], Event.data['Props']); 	                
		}
	}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/


/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function formatScaleUnits(thisUnits)
{
	var newUnits=[];
	for (var a=0; a<thisUnits.length; a++)
	{
		newUnits[thisUnits[a]['unit']]=thisUnits[a];
	}
	return newUnits
}

function formatConstants(thisConstants)
{
	var newItem=[];
	for (var a=0; a<thisConstants.length; a++)
	{
		newItem[thisConstants[a]['name']]=thisConstants[a];
	}
	return newItem
}

function formatParseUnits(thisUnits)
{
	var newUnits=[];
	for (var a=0; a<thisUnits.length; a++)
	{
		newUnits[thisUnits[a]['name']]=thisUnits[a];
	}
	return newUnits
}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/


/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*----------------------------------------------------------- SOLVE THE ELEMENTS OF A TABLE ---------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	This is the function that solves for all the cells that are being solved for when a table is filled left, right, up, or down. There are 8 inputs that help guide	|
	the function to its solution. Overall, the code is exactly what you would expect. That is, it simply solves one table cell and then moves on to the next cell and   |
    solves it until it reaches the end of the table.                                                                                                                    |
    The code has X parts :                                                                                                                                              |
        1.  The first time through, the code creates an equation to use to solve the cell and it creates the variables needed                                           |
        2.  Based upon the direction that the fill is moving, the code will change the cell indices in question to be the next one in the table. It also sets the       |
            indices of the previously solved table cell to the value of the solution from the previous solve.                                                           |
        3.  
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function solveTableFill(fileID, tableID, Location, fillType, tableRow, tableCol, numRows, numCols, firstRun, thisID) 
{	var thisEquation='', tableMatch=[], tableMatchNo=[], rowNum=0, colNum=0, colNumArr=[], rowNumArr=[], replacement='', newIndex='', newCol='';                    //  |
    if (firstRun=='1') 
	{	tableCells={};                                    
		var eqobj={ Page_position:Location, Format_showtype:"InnerFunction" };
		var thisID=CreateEq(fileID, 0, eqobj);
		self[thisID]['Format_left']="mytablefill";																												    
        thisEquation=DOM_Object[tableID]['data'][tableRow][tableCol]['equation'];																				    
	}else
	{	console.log('The ID for the table fill is '+thisID);
		console.log('Setting the values for row '+tableRow+' and column '+tableCol+' to '+DOM_Object[thisID]['real']['0-0']);
        DOM_Object[tableID]['data'][tableRow][tableCol]['equation']=DOM_Object[thisID]['equation'].replace(/^mytablefill/,'');
        DOM_Object[tableID]['data'][tableRow][tableCol]['real']=DOM_Object[thisID]['real']['0-0'];		     									          
        DOM_Object[tableID]['data'][tableRow][tableCol]['imag']=DOM_Object[thisID]['imag']['0-0'];		     											        
        DOM_Object[tableID]['data'][tableRow][tableCol]['units']=DOM_Object[thisID]['units'];		     														    
        thisEquation=DOM_Object[tableID]['data'][tableRow][tableCol]['equation'];																				    
        tableMatch=thisEquation.match(/\#File[0-9]+Table[0-9]+\.[A-Z]+\.[0-9+]/g);                                                                                  //  |
        tableMatchNo=thisEquation.match(/\#File[0-9]+Table[0-9]+\.[A-Z]+\.\$[0-9+]/g);                                                                              //  |
        if (tableMatchNo!=null) { for (var a=0; a<tableMatchNo.length; a++){ tableMatch.push(tableMatchNo[a]); }   }                                                //  |
        tableMatchNo=thisEquation.match(/\#File[0-9]+Table[0-9]+\.\$[A-Z]+\.[0-9+]/g);                                                                              //  |
        if (tableMatchNo!=null) { for (var a=0; a<tableMatchNo.length; a++){ tableMatch.push(tableMatchNo[a]); }   }                                                //  |
        if (fillType=="right")	{ var tableCol=tableCol+1; }			                                															//	|
		if (fillType=="left")	{ var tableCol=tableCol-1; }		                          				          												//	|
		if (fillType=="down")	{ var tableRow=tableRow+1; }		                                  				        										//	|
		if (fillType=="up")		{ var tableRow=tableRow-1; }							                                  	           								//	|
    }																																								//	|
	if ((fillType=="left")||(fillType=="right"))       																												//	|
	{	if (((fillType=="left")&&(tableCol>=0))||((fillType=="right")&&(tableCol<numCols)))																		    //	|
		{	if (firstRun==0)    																																    //	|
            {   for (var a=0; a<tableMatch.length; a++)                                                                                                             //  |
                {   colNumArr=tableMatch[a].match(/\.[A-Z]+\.[0-9]+$/);                                                                                             //  |
                    if (colNumArr!=null)                                                                                                                            //  |
                    {   colNum=colNumArr[0].replace(/^\./,'').replace(/\.[0-9]+$/,'').replace(/\.\$[0-9]+$/,'');                                                    //  | 
                        rowNum=colNumArr[0].replace(/^\.[A-Z]+\./,'').replace(/^\.\$[A-Z]+\./,'');                                                                  //  |
                        if (fillType=="left") { newIndex=String.fromCharCode(colNum.charCodeAt()-1);	}	       													//	|
                        if (fillType=="right") { newIndex=String.fromCharCode(colNum.charCodeAt()+1);	}	       													//	|
                        replacement=tableMatch[a].replace(/\.[A-Z]+\.[0-9]+$/,'.'+newIndex+'.'+rowNum);	    														//	|
                        thisEquation=thisEquation.replace(tableMatch[a], replacement);																				//	|
                    }                                                                                                                                               //  |
                    colNumArr=tableMatch[a].match(/\.[A-Z]+\.\$[0-9]+$/);                                                                                           //  |
                    if (colNumArr!=null)                                                                                                                            //  |
                    {   colNum=colNumArr[0].replace(/^\./,'').replace(/\.[0-9]+$/,'').replace(/\.\$[0-9]+$/,'');                                                    //  | 
                        rowNum=colNumArr[0].replace(/^\.[A-Z]+\./,'').replace(/^\.\$[A-Z]+\./,'');                                                                  //  |
                        if (fillType=="left") { newIndex=String.fromCharCode(colNum.charCodeAt()-1);	}	       													//	|
                        if (fillType=="right") { newIndex=String.fromCharCode(colNum.charCodeAt()+1);	}	       													//	|
                        replacement=tableMatch[a].replace(/\.[A-Z]+\.\$[0-9]+$/,'.'+newIndex+'.$'+rowNum);		    												//	|
                        thisEquation=thisEquation.replace(tableMatch[a], replacement);																				//	|
                    }                                                                                                                                               //  |
                }																			    																	//	|
            }																																					    //	|
            DOM_Object[tableID]['data'][tableRow][tableCol]['equation']=thisEquation;																			    //	|
            DOM_Object[tableID]['data'][tableRow][tableCol]['needsUpdateFlag']=1;				       															    //	|
            self[thisID]['Format_right']=thisEquation;	                 																						    //	|
            DOM_Object[thisID]['equation']="mytablefill"+thisEquation;		                                        											    //	|
            eqPromise(thisID).then(solveTableFill(fileID, tableID, Location, fillType, parseInt(tableRow), parseInt(tableCol), numRows, numCols, 0, thisID) );	    //	|
		}else																																						//	|
		{	postMessage({ "messageType":"FullTable", "tableID":tableID, "tableData":DOM_Object[tableID]['data'] }); }		                                        //	|
	}																																								//	|
	if ((fillType=="down")||(fillType=="up"))																														//	|
	{	if (((fillType=="down")&&(tableRow<numRows))||((fillType=="up")&&(tableRow>=0)))																			//	|
		{	if (firstRun==0)    																																    //	|
            {   for (var a=0; a<tableMatch.length; a++)                                                                                                             //  |
                {   rowNumArr=tableMatch[a].match(/\.[A-Z]+\.[0-9]+$/);                                                                                             //  |
                    if (rowNumArr!=null)                                                                                                                            //  |
                    {   rowNum=rowNumArr[0].replace(/^\.[A-Z]+\./,'').replace(/^\.\$[A-Z]+\./,'');                                                                  //  | 
                        colNum=rowNumArr[0].replace(/^\./,'').replace(/\.[0-9]+$/,'').replace(/\.\$[0-9]+$/,'');                                                    //  | 
                        if (fillType=="up"){ newIndex=parseInt(rowNum)-1; }		       														                        //	|
                        if (fillType=="down"){ newIndex=parseInt(rowNum)+1; }		       														                    //	|
                        replacement=tableMatch[a].replace(/\.[A-Z]+\.[0-9]+$/,'.'+colNum+'.'+newIndex);																//	|
                        thisEquation=thisEquation.replace(tableMatch[a], replacement);																				//	|
                    }                                                                                                                                               //  |
                    rowNumArr=tableMatch[a].match(/\.\$[A-Z]+\.[0-9]+$/);                                                                                           //  |
                    if (rowNumArr!=null)                                                                                                                            //  |
                    {   rowNum=rowNumArr[0].replace(/^\.[A-Z]\./,'').replace(/^\.\$[A-Z]\./,'');                                                                    //  | 
                        colNum=rowNumArr[0].replace(/^\./,'').replace(/\.[0-9]+$/,'').replace(/\.\$[0-9]+$/,'');                                                    //  | 
                        if (fillType=="up"){ newIndex=parseInt(rowNum)-1; }		       														                        //	|
                        if (fillType=="down"){ newIndex=parseInt(rowNum)+1; }		       														                    //	|
                        replacement=tableMatch[a].replace(/\.\$[A-Z]+\.[0-9]+$/,'.$'+colNum+'.'+newIndex);													        //	|
                        thisEquation=thisEquation.replace(tableMatch[a], replacement);																				//	|
                    }																			    																//	|
                }																			    																	//	|
            }																																					    //	|
            DOM_Object[tableID]['data'][tableRow][tableCol]['equation']=thisEquation;																			    //	|
            DOM_Object[tableID]['data'][tableRow][tableCol]['needsUpdateFlag']=1;				       															    //	|
            self[thisID]['Format_right']=thisEquation;	                 																						    //	|
            DOM_Object[thisID]['equation']="mytablefill"+thisEquation;		                                        											    //	|
            console.log('The ID for the table fill is '+thisID);
            eqPromise(thisID).then(solveTableFill(fileID, tableID, Location, fillType, parseInt(tableRow), parseInt(tableCol), numRows, numCols, 0, thisID) );	    //	|
		}else																																						//	|
		{	postMessage({ "messageType":"FullTable", "tableID":tableID, "tableData":DOM_Object[tableID]['data'] }); }		                                        //	|
	}																																								//	|
}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/


/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------------------------------------ GET ID -------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function Get_ID(type, file)  
{	var flag=0, id='', testflag=0, PlotID='', DataID='', AxisID='', RID='', LineID='', BandID='', RefID='';
	file="File"+file;  
	if (type=="Equation") 				{ while (flag===0)	{ id=file+'var'+Math.floor((Math.random()*100000)+1); 		if (DOM_Object[id]===undefined){ flag=1; } }
	}else if (type=="ForLoop") 			{ while (flag===0)	{ id=file+'forLoop'+Math.floor((Math.random()*10000)+1); 	if (DOM_Object[id]===undefined){ flag=1; } } 
	}else if (type=="WhileLoop") 		{ while (flag===0)	{ id=file+'whileLoop'+Math.floor((Math.random()*10000)+1);	if (DOM_Object[id]===undefined){ flag=1; } }
	}else if (type=="IfElseStatement")	{ while (flag===0)	{ id=file+'IfElse'+Math.floor((Math.random()*10000)+1); 	if (DOM_Object[id]===undefined){ flag=1; } }
	}else if (type=="Table") 			{ while (flag===0) 	{ id=file+'Table'+Math.floor((Math.random()*10000)+1); 		if (DOM_Object[id]===undefined){ flag=1; } }}
	return id;
}
//---------------------------------------------------------------------------------------------------------------------------------------------------------------------//

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*--------------------------------------------------------- Functions to Parse Equations ------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

//-------------------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------------- THE EQUATION OBJECT --------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------//
function Equation(id, name, fileid) 
{	UnitList=new Array('A', 'K', 's', 'm', 'kg', 'cd', 'mol', 'molecules', 'rad');
	this.Format_id=id;																												// 	\
	this.itemid=id;																													// 	\
	this.Original_id=id;																											// 	\
	if (name) { this.Format_name=name;	}else { this.Format_name="TempEq"; }														// 	\
	this.Format_equation='';																										// 	\
	this.Format_showequation='';																									// 	\
	this.Format_showsolution='';																									// 	\
	this.Format_equationinuse='';																									// 	\
	this.Format_right='';																											// 	\
	this.Format_left='';
	this.Format_size='1x1';																											// 	\
	this.Format_numinds='';																											// 	\
	this.Format_type=1;																												// 	\
	this.Format_haschanged=1;																										// 	\
	this.Format_showtype="top";																										// 	\
	this.Format_showvalue="default";																								// 	\
	this.Format_showcomponent='';																									// 	\
	this.Format_editinuse=1;																										// 	\
	this.Solving=1;
	this.Solution_convsol='';																										// 	\
	this.Solution_real={};																											// 	\
	this.Solution_imag={};																											// 	\
	this.Solution_input_array=new Array();																							// 	\
	this.Solution_inputs=new Array();																								// 	\
	this.Solution_variable_array=new Array();																						// 	\
	this.Solution_key_array=new Array();																							// 	\
	this.Solution_unit_array=new Array();																							// 	\
	this.Solution_object_array=new Array();																							// 	\
	this.Solution_temps=new Array();																								// 	\
	this.Solution_PostFix=new Array();																								// 	\
	this.Solution_Post_Units=new Array();																							// 	\
	this.Solution_realdefault=0;
	this.Solution_imagdefault=0;
	this.Page_parentid='none';																										// 	\
	this.Page_topparentid='none';																									// 	\
	this.Page_position=0;																											// 	\
	this.Units_units='';																											// 	\
	this.Units_showunits='';																										// 	\
	this.Units_conv_units='';																										// 	\
	this.Units_unit_array=new Array();																								// 	\
	this.Units_conv_array=new Array();																								// 	\
	this.Units_scaled_array=new Array();																							// 	\
	this.Units_base_array={};																										// 	\
	this.Units_base_string='00000000';																								// 	\
	this.Units_multiplier=1;																										// 	\
	this.Units_quantity='';																											// 	\
	this.Models_numerical='';																										// 	\
	this.Models_units='';																											// 	\
	this.Models_dimensions='';																										// 	\
	this.Models_quantities='';																										// 	\
	this.Errors_flag=0;																												// 	\
	this.Errors_errors=new Array();																									// 	\
	this.FaF={};	this.fileid=fileid;	this.connected_ids={};
	for (var unitindex = 0; unitindex < UnitList.length; ++unitindex) { this.Units_base_array[UnitList[unitindex]]=0;	}
}
//-------------------------------------------------------------------------------------------------------------------------------------//


//-------------------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------- MAIN SOLVE EQUATION FUNCTION ----------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.Solve_Equation = function(equation, callback)
{	console.log('The equation being solved is '+equation+' and it is a '+this.Format_showtype+' on '+this.Format_id);
	var thisfile=this.Format_id.replace(/^File/,'').match(/^[0-9]+/);
	DOM_Object[this.Format_id]['Dependents']={};
	if (this.Page_parentid=='none') { this.Solution_real={}; this.Solution_imag={}; }
	var id=this.Format_id;
	if (typeof(equation)!="undefined") { this.Populate_Equation(equation); }else { this.Populate_Equation(this.Format_equation);}
	if (this.Errors_flag==0)
	{	
		self[id].Get_Variables(function() { 
			self[id].Check_String( function(){ 
			self[id].Recombine_Units( function(){ 
			self[id].Parse_Inputs(function() { 
			self[id].Replace_Inputs(function(){ 
			self[id].Flag_BuiltInEquations( function(){
			self[id].Remove_BuiltInEquations( 0, function(){
			self[id].Remove_SubEquations( function(){ 
			self[id].Remove_FilesAsFunctions(function(){ 
			self[id].Replace_Variables( function(){
			self[id].Replace_CAD( function(){
			self[id].Replace_Constants( function(){
			self[id].Replace_Matrix_Pieces( function(){
			self[id].Replace_Vectors( function(){
			self[id].Replace_Matrices( function(){
			self[id].Replace_Numbers( function(){
			self[id].Replace_Tables( function(){
			self[id].Check_Imaginary( function(){
			self[id].Check_Negatives( function(){
			self[id].Check_Equation( function(){
			self[id].Unit_Array( function(){
			self[id].Scale_Units( function(){
			self[id].Decompose_Units( function(){
			self[id].Get_BaseString( function(){
			self[id].Convert_to_Post( function(){
            self[id].SolvePostFix( function(){
			self[id].Recompose_Units( function(){
			self[id].Format_Fractions( function(){
			self[id].Matrix_SubComp( function(){
			self[id].Get_My_BaseString( function(){
			self[id].Show_Equation( function(){
			self[id].Get_Size( function(){
			self[id].Show_Solution( function(){
			self[id].Models( function(){
			self[id].Equation_Cleanup( function(){
			self[id].Return_Equation( function(){
				if (typeof(callback)=="function") { callback();
				}else if (typeof(callback)=="string") { var func = new Function(callback); func(); }
			}); }); }); }); }); }); }); }); }); }); }); }); }); }); }); }); }); }); }); }); }); }); }); }); }); }); 
			}); }); }); }); }); }); }); }); }); });
	}
};
//-------------------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------------------//
//---------------------------------------------------- POPULATE EQUATION --------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------//
/*	This function takes the equation and populates the components of the equation object necessary to solve the equations.				|
	Case 1 - the equation starts with an equal sign this is usually in a table element													|
	Case 2 - a show equation																											|
	Case 3 - a matrix component																											|
	Case 4 - A standard equation with no inputs																							|
	Case 5 - The case where the user is calling  [a, b] = Function(inputs)																|
//-------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Populate_Equation = function(equation)
{	
	var temp='', split_eq='', re='', num=0;	
	
	// Prep for the solution - reset errors and remove blank spaces at the beginning and end
	this.Format_equation=equation.replace(/^\s+|\s+$/g, '');
	this.Format_showequation="Error";
	this.Errors_errors=new Array();	
	this.Errors_flag=0;
	if (this.Page_parentid===undefined) { this.Page_parentid='none'; }	
	if (this.Page_topparentid===undefined) { this.Page_topparentid='none'; }

	// If this is a special case of a subequation, it will have inputs that need to be removed
	if (this.Format_showtype=="subequation")
	{	
		this.Parse_Inputs();

	// If this equation ends with a "=" it is a display equation
	}else if (this.Format_equation.match(/\=$/)	)	
	{	temp=this.Format_equation.replace(/\=$/, '');
		temp=temp.toString().replace(/^\s+|\s+$/g, '');	
		this.Format_left=temp;	
		this.Format_right=temp;	
		this.Format_name=temp;
		this.Format_equation=temp;
		this.Format_equationinuse=temp;	
		this.Format_type='5';

	// If the equation has a "]=" then it is setting a portion of an array
	}else if (this.Format_equation.match(/\]=/))
	{
		split_eq=equation.split('=');
		this.Format_left=split_eq[0].replace(/^\s+|\s+$/g, '');
		this.Format_right=split_eq[1];
		this.Format_equationinuse=split_eq[1];
		this.Format_name=this.Format_left.replace(/\[[\:\+\-\*\\0-9,a-z,A-Z]+\]/g,'');
		this.Format_type='3';

	// We are left with a hopefully normal equation
	}else
	{	this.Format_type='1';
		
		// If this equation has no "=" then throw an error
		if (!this.Format_equation.match(/\=/)) 
		{
			Set_Error(this.Original_id, "Format7");
			this.Return_Equation(); 

		// Now, we separate out the parts of the equation
		}else
		{	temp=equation.match(/([^=]*)=(.*)/);
			this.Format_left=temp[1].replace(/^\s+|\s+$/g, '');	
			this.Format_right=temp[2].replace(/^\s+|\s+$/g, '');
			this.Format_name=temp[1].replace(/\[[0-9,a-z,A-Z]+\]/g,'').replace(/^\s+|\s+$/g, '');
			this.Format_equation=temp[2].replace(/^\s+|\s+$/g, '');
			this.Format_equationinuse=this.Format_right;
			
			// Check again to ensure that there is an "=" in the equation
			re=/\=/;	
			num=equation.match(re); 
			if (num.length===0) { Set_Error(this.Original_id, "Format15"); }
		}
		if (this.Format_equation.match(/^\[/)) { this.Format_type='6';	}
	}
	
	// Set up the units and models
	this.Units_showunits='';
	this.Models_numerical='';
	this.Models_units='';
	this.Models_dimensions='';
	this.Models_quantities='';
	
	if (DOM_Object[this.Format_id]!==undefined) { DOM_Object[this.Format_id]['name']=this.Format_name;	}
};
//-------------------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------------------//
//---------------------------------------------- GET VARIABLES ------------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------//
/*	This function takes the equation and parses out the individual variables within it. It records the unit array and the variable 		\
	array for the equation as part of the object.  													 									\
//-------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Get_Variables = function(callback)
{	
	this.Solution_variable_array=SplitText(this.Format_right);

	for (var a=0; a<this.Solution_variable_array.length; a++)
	{	var test=this.Solution_variable_array[a];
		if (test.match(/^[0-9,\.]+[a-z,A-Z,\/,\*,\-]+$/)) 
		{	var number=test.match(/^[0-9,\.]+/);
			var unit=test.match(/[a-z,A-Z,\/,\*,\-]+$/);
			this.Solution_variable_array[a]=number.toString();
			this.Solution_variable_array.splice(a+1, 0, unit.toString());
	}	}

	if (typeof(callback)=="function") { callback();	}
};
function SplitText(temp)
{	
	temp=temp.toString().replace(/^\s+|\s+$/g, '');	
	temp=temp.toString().replace(/\s+[+]\s+/g,"?+?");
	temp=temp.toString().replace(/\s+[-]\s+/g,"?-?");
	temp=temp.toString().replace(/\s+[*]\s+/g,"?*?");
	temp=temp.toString().replace(/\.\*/g,"?#?");
	temp=temp.toString().replace(/\+/g,"?+?");
	temp=temp.toString().replace(/\-/g,"?-?");
	temp=temp.toString().replace(/\*/g,"?*?");
	temp=temp.toString().replace(/\,/g,"?,?");
	temp=temp.toString().replace(/\;/g,"?;?");
	temp=temp.toString().replace(/\:/g,"?:?");
	temp=temp.toString().replace(/\s/g,"?");
	//temp=temp.toString().replace(/{/g,"?{?");     
	//temp=temp.toString().replace(/}/g,"?}?");
	temp=temp.toString().replace(/\]/g,"?]?");
	temp=temp.toString().replace(/\[/g,"?[?");	    
	temp=temp.toString().replace(/\(/g,"?(?"); 	   													 
	temp=temp.toString().replace(/\)/g,"?)?");     
	temp=temp.toString().replace(/\\/g,"? \\?");
	temp=temp.toString().replace(/\//g,"?/?");
	temp=temp.toString().replace(/,+$/,"");
	temp=temp.toString().replace(/\^/g,"?^?");
	temp=temp.toString().replace(/\?{2,100}/g,"?");
	temp=temp.toString().replace(/^\?\-\?/,"-?");
	temp=temp.toString().replace(/\s+$/,'');
	temp=temp.toString().replace(/^\s+/,'');
	temp=temp.toString().replace(/^\s+|\s+$/g, '');
	temp=temp.toString().replace(/^\?+|\?+$/g, '');
	splittext=temp.split("?");
	return splittext;
}
//-------------------------------------------------------------------------------------------------------------------------------------//


//-------------------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------------------- CHECK STRING ----------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------//
/*	This function checks to make sure that the equation entered makes sense. 															\
	These checks include :																												\
	making sure that the equation has matching parenthesis																				\
	making sure that the equation has matching square brackets																			\
	making sure that the name doesn't conflict with constants																			\
	making sure that the equation has a name																							\
	making sure that there is an equation																								\
//-------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Check_String = function(callback)  
{	var pcounter=0, bcounter=0, index=0, test='', unit='', myRe='', testRe=''; 
	
	// Are there equal parenthesis
	for (index = 0; index < this.Solution_variable_array.length; ++index) 
	{	test=this.Solution_variable_array[index];
		if (test=="(") { pcounter=parseInt(pcounter, 10)+1;	}
		if (test==")") { pcounter=parseInt(pcounter, 10)-1;	}
		if (test=="[") { bcounter=parseInt(bcounter, 10)+1;	}
		if (test=="]") { bcounter=parseInt(bcounter, 10)-1;	}
	}
	if ((pcounter>0)||(pcounter<0)) { Set_Error(this.Original_id, "Format4", pcounter, "NA"); 	}
	if ((bcounter>0)||(bcounter<0)) { Set_Error(this.Original_id, "Format5", pcounter, "NA"); 	}

	// Check the reserved names
	if ((this.Format_name=="TempEq")&&(this.Format_showtype=="top")) { Set_Error(this.Original_id, "Format6");}
	for (var ConstantName in Constants)
	{
		if (ConstantName==this.Format_name)	
		{
			Set_Error(this.Original_id, "Format1", "NA", "NA");
		}
	}

	// Check the scaled units
	for (unit in scaleUnits) 
	{
		if (this.Format_name==unit) { Set_Error(this.Original_id, "Format12"); }
	}
	
	// Check the length
	if (this.Format_name.length<1) { Set_Error(this.Original_id, "Format13");}

	// Make sure that the name has some letters
	myRe=/[a-zA-Z]+/g;
	testRe=myRe.exec(this.Format_name);
	if (testRe==-1) { Set_Error(this.Original_id, "Format13"); }

	// Make sure that the equation has a name and an equation
	if ((this.Format_name==="")||(this.Format_name===" ")) { Set_Error(this.Original_id, "Format7");}
	if ((this.Format_equation==="")||(this.Format_equation===" ")) { Set_Error(this.Original_id, "Format6");}


	if (typeof(callback)=="function") { callback();	}
};
//-------------------------------------------------------------------------------------------------------------------------------------//


//-------------------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------------------- RECOMBINE UNITS--------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------//
/*	The process of splitting an equation into its variables also splits units from numbers and splits units at division, multiple, 		\
	and power signs. This function looks at those split items and determines whether or not they were meant to be combined. If so, 		\
	they are placed together.																											\
	Step 1 : For each item in the array, if it matches any of the base units, then set the key array for that entry to one.				\
	Step 2 : If the item is a division or multiply or power, turn it on																	\
	Step 3 : Look for parenthesis surrounding the units																					\
	Step 4 : Repeat step 2 now that the parenthesis have been set																		\
	Step 5 : Combine units adjacent to each other and deletes the old spots. 															\
//-------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Recombine_Units = function(callback) 
{	var index=0, flag=0, a=0, test=''; 
	var id=this.Format_id;

	// Initiate the key array to 0 at each point
	this.Solution_key_array=new Array(parseInt(this.Solution_variable_array.length, 10));
	for (index = 0; index < this.Solution_variable_array.length; ++index) 
	{ this.Solution_key_array[index]=0; }			
	

	// Check each index and if it matches a unit, mark it as 1
	for (index = 0; index < this.Solution_variable_array.length; index++)		
	{	
		if (scaleUnits[self[id].Solution_variable_array[index]]!==undefined) 
		{ 
			self[id].Solution_key_array[index]=1;
		} 
	}

	// If a *, *, or ^ is surrounded by units, mark it as a unit
	for (index = 0; index < this.Solution_variable_array.length; index++)
	{	if ((this.Solution_variable_array[index]=="*")||(this.Solution_variable_array[index]=="/"))	
		{	
			if ((this.Solution_key_array[index-1]==1)&&(this.Solution_key_array[index+1]==1)){ this.Solution_key_array[index]=1; }
		}
		if ((this.Solution_variable_array[index]=="^"))
		{	
			if ((isNumber(this.Solution_variable_array[index+1]))&&(this.Solution_key_array[index-1]==1))
			{	
				this.Solution_key_array[index]=1; this.Solution_key_array[index+1]=1;	
			}
		}	
	}

	// If parenthesis surround units, mark the parenthesis as units too
	for (index = 0; index < this.Solution_variable_array.length; index++)
	{	if ((this.Solution_variable_array[index]=="(")&&(this.Solution_key_array[index+1]==1)&&(this.Solution_key_array[index]===0))
		{	flag=1;
			for (a=index; a>0; a--)
			{	if ((this.Solution_variable_array[a]=="(")&&(flag==1)) { this.Solution_key_array[a]=1; }else { flag=0; } }
		}
		if ((this.Solution_variable_array[index]==")")&&(this.Solution_key_array[index-1]==1)&&(this.Solution_key_array[index]===0))
		{	flag=1;
			for (a=index; a<this.Solution_variable_array.length; a++)
			{	if ((this.Solution_variable_array[a]=="(")&&(flag==1)) { this.Solution_key_array[a]=1; }else { flag=0; } }
		}
	}

	// Go back through the array again and check to see if *, /, and ^ are surrounded by units
	for (index = 0; index < this.Solution_variable_array.length; index++)
	{	if ((this.Solution_variable_array[index]=="*")||(this.Solution_variable_array[index]=="/"))	
		{	if ((this.Solution_key_array[index-1]==1)&&(this.Solution_key_array[index+1]==1)){ this.Solution_key_array[index]=1; }
		}
		if ((this.Solution_variable_array[index]=="^"))	
		{	if ((isNumber(this.Solution_variable_array[index+1]))&&(this.Solution_key_array[index-1]==1))
			{	this.Solution_key_array[index]=1; this.Solution_key_array[index+1]=1;	}
	}	}


	// If this item is a number followed by
	for (index = 0; index < this.Solution_variable_array.length; index++)
	{	test=this.Solution_variable_array[index].match(/^[0-9,.]+\s+[0-9,a-z,A-Z,.,\^,\\,\/,{,},\*]+/); 
		if (test) { this.Solution_key_array[index-1]=0; }
	}
	for (index = 0; index < this.Solution_variable_array.length; index++)
	{	if ((this.Solution_variable_array[index]=="/")&&(this.Solution_key_array[index-1]==1)&&(this.Solution_key_array[index+1]==1))
		{	this.Solution_key_array[index]=1;  }
	}
	for (index = 0; index < this.Solution_variable_array.length; index++)
	{	if ((this.Solution_variable_array[index]=="/")&&(this.Solution_variable_array[index-1]=="1")&&(this.Solution_key_array[index+1]==1))
		{	this.Solution_key_array[index]=1; this.Solution_key_array[index-1]=1;  }
	}
	for (index = this.Solution_variable_array.length-1; index >0; --index)
	{	if ((this.Solution_key_array[index]==1)&&(this.Solution_key_array[index-1]==1)) 
		{	this.Solution_variable_array[index-1]=this.Solution_variable_array[index-1]+""+this.Solution_variable_array[index];
			this.Solution_variable_array.splice(index, 1);
			this.Solution_key_array.splice(index, 1);
		}
	}

	if (typeof(callback)=="function") { callback();	}
};
//-------------------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------------- PREP BUILT IN EQUATIONS ----------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------//
/*	This function steps through the variable array and denotes any built-in functions. A built-in function is one that is downloaded	\
	as part of the CADWOLF software. When an entry in the variable array matches the text of a built-in function and there is a 		\
	parenthesis after that word, then the algorithm steps through and merges all of the inputs between the parenthesis.					\
//-------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Flag_BuiltInEquations = function(callback) 
{	this.inline=1; var varlength=0, index=0, i=0, sum=0, index2=0, testflag=0; 
	varlength=this.Solution_variable_array.length; 


	for (index=0; index<this.Solution_variable_array.length; index++)
	{	for (i in Functions) 
		{	if (this.Solution_variable_array[index]==Functions[i])
			{	functionfound=i;
				sum=0; thistext=Functions[i];
				index2=index+1; testflag=0;
				while ((testflag===0)&&(index2<varlength))
				{	thistext=thistext+this.Solution_variable_array[index2];
					if (this.Solution_variable_array[index2]=="(") {	sum=sum+1; }
					if (this.Solution_variable_array[index2]==")") 
					{	sum=sum-1;	
						if (sum===0)	{ testflag=1; } 
					}
					if (index2>=varlength+1) { 	testflag=1;	}
					this.Solution_variable_array[index2]='deleteme';
					index2=index2+1;
				}	
				this.Solution_variable_array[index]=i;
				this.Solution_variable_array[parseInt(index, 10)+1]=thistext;
			}
		} 
	}
	for (i = 0; i < this.Solution_variable_array.length; i++)  
	{ 	if ((this.Solution_variable_array[i] == 'deleteme')||(this.Solution_variable_array[i]==='')||(this.Solution_variable_array[i]===undefined))  
		{ 	this.Solution_variable_array.splice(i, 1); 	this.Solution_key_array.splice(i,1); i--;	}
	} 	


	if (typeof(callback)=="function") { callback();	}
}; 
//-------------------------------------------------------------------------------------------------------------------------------------//


//-------------------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------ REMOVE BUILT IN EQUATIONS ----------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------//
/*	Now that the variable array has been merged so that all the inputs to a built-in function are set in the entry just after the 		\
	name of the function, this algorithm calls each of those functions one by one and sends them the inputs.							\
//-------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Remove_BuiltInEquations = function(pos, callback) 
{	var flag=0, varlength=0, i='', func=''; 
	varlength=this.Solution_variable_array.length; 
	if (pos<varlength)
	{	for (i in Functions) 
		{	if (this.Solution_variable_array[pos]==Functions[i])
			{	functionfound=i;	flag=1;
				if (i=="parseDate") 
				{	self[this.Format_id][functionfound](this.Format_right, this.Format_id, pos, callback);	 				
				}else
				{	self[this.Format_id][functionfound](this.Solution_variable_array[parseInt(pos, 10)+1], this.Format_id, pos, callback);} 				
			}
		} 
		if (flag===0) { self[this.Format_id].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback); }
	}else { if (typeof(callback)=="function") { callback();
			}else if (typeof(callback)=="string") { func = new Function(callback); func(); } }
}; 
//-------------------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------//
/*	The user can enter Force=ma for an equation. Later, they can call that result by entering "Force" into another equation or they 	\
	can enter "Force2=Force(a=9.81m/s^2)+10" and call for the result of the force equation with the acceleration set to the entered 	\
	value plus some additional math. This function looks for any of those subequations. When those functions are found, a separate 		\
	function is called to solve that equation with the substituted value. The text of the subequation is then replaced with the 		\
	equation object that contains the result of that equation with the inputs in question.												\
//-------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Remove_SubEquations = function(callback)
{	var salength=this.Solution_variable_array.length, index=0, i='', sum=0, thistest='', index2=0, testflag='', thistext='', id='';
	for (index=0; index<this.Solution_variable_array.length; index++)
	{	for (i in DOM_Object)
		{	
			// console.log('Comparing '+this.Solution_variable_array[index]+' to '+DOM_Object[i]['name']+' with the next index of '+this.Solution_variable_array[index+1]);
			if ((this.Solution_variable_array[index]==DOM_Object[i]['name'])&&(this.Solution_variable_array[index+1]=="("))
			{	sum=0; thistext=DOM_Object[i]['name'];
				index2=index+1; testflag=0; 
				while ((testflag===0)&&(index2<=salength)) 
				{	thistext=thistext+this.Solution_variable_array[index2];
					if (this.Solution_variable_array[index2]=="(") { 
						sum=sum+1; 
					}else if (this.Solution_variable_array[index2]==")") 
					{	sum=sum-1;
						if (sum===0) { testflag=1; } 
					}
					this.Solution_variable_array[index2]='deleteme';
					index2=index2+1;
				}
				var eqobj={Page_position:DOM_Object[this.Format_id]['order'], Format_showtype:"subequation",  
						Page_parentid:this.Page_parentid, Page_topparentid:this.Page_topparentid, Original_id:this.Format_id, 
						equation:thistext};
				var newid=CreateEq(this.fileid, 1, eqobj);
				this.Solution_variable_array[index]=newid;
				this.Solution_temps.push(newid);
	}	}	}
	for (i = 0; i < this.Solution_variable_array.length; i++)  
	{ 	if (this.Solution_variable_array[i] == 'deleteme')  
		{	this.Solution_variable_array.splice(i, 1); 
			this.Solution_key_array.splice(i,1);
			i--;
	}	} 	
	if (typeof(callback)=="function") { callback();	}
};
//-------------------------------------------------------------------------------------------------------------------------------------//


/*-------------------------------------------------------------------------------------------------------------------------------------//
//--------------------------------- CALLING A FILE AS A FUNCTION WITHIN THE DOCUMENT --------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------//
	This is the function called to find any Files used as functions. It goes through the solution array and compares each remaining 	\
	item to the list of files as functions on this page. If it finds one, it then steps through the solution array and pulls in any    	\
    items that were intended to be inputs to the function into a string. The string is then parsed and the space occupied by the        \
    function call is replaced with the ID of the item created by solving the function.                                                  \
//-------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Remove_FilesAsFunctions = function(callback)
{	var thisid=this.Format_id, index=0, flag=0, thisEntry='', inputText='', sum=0, fafFlag=0;        
    var saLength=this.Solution_variable_array.length;      
    for (index=0; index<this.Solution_variable_array.length; index++)
	{  	if (this.Solution_variable_array[index]=="(") 
		{ 	for (var a=0; a<ImportedFunctions.length; a++)
			{	if (ImportedFunctions[a]['functionName']==this.Solution_variable_array[parseInt(index, 10)-1]) 
				{	fafFlag=1;    thisText='';  index2=index+1; flag=0; sum=1;	   												     
                    this.Solution_variable_array[index]='deleteme';								         
                    while ((flag==0)&&(index2<saLength)) 
				    {	if (this.Solution_variable_array[index2]=="(") {    sum=sum+1; 
                        }else if (this.Solution_variable_array[index2]==")")   
                        {	sum=sum-1;
                            if (sum==0){   testflag=1;     
                        	}else { inputText=inputText+this.Solution_variable_array[index2]; }	                                    
                        }else { inputText=inputText+this.Solution_variable_array[index2]; }   
                        this.Solution_variable_array[index2]='deleteme';
                        index2=index2+1;
                    }
                    inputs=InputArray(inputText);
                    for (i = 0; i < this.Solution_variable_array.length; i++)  
                    { 	if (this.Solution_variable_array[i] == 'deleteme')  
                        {	this.Solution_variable_array.splice(i, 1); 
                            this.Solution_key_array.splice(i,1);
                            i--;
                    }	} 	
                    this.solveFAF(ImportedFunctions[a]['functionName'], inputs, index-1, callback);
                }                     	
    }	}	}																													    
    if (fafFlag==0)	{  if (typeof(callback)=="function") { callback();	}	}
};
//-------------------------------------------------------------------------------------------------------------------------------------//


/*-------------------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------ SOLVING THE INPUTS FOR A FILE AS A FUNCTION ----------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------//
	This function solves for the inputs to the function. It does this by looping through the input array from the previous function,   	\
    solving each of those equations, and then placing the final values into the array slot. It then calls the solve function.           \
//-------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.solveFAF = function(functionName, inputs, solVarIndex, callback)       
{	for (var a=0; a<ImportedFunctions.length; a++)																		          
    {	if (ImportedFunctions[a]['functionName']==functionName) 
        {   for (b=0; b<inputs.length; b++)
			{	eqobj={Page_position:DOM_Object[this.Format_id]['order'], Format_showtype:"InnerFunction", 
					Original_id:this.Original_id, equation:"Temp="+inputs[b]};
				var id1=CreateEq(this.fileid, 1, eqobj);
				ImportedFunctions[a]['functionInputs'][b]['real']=JSON.parse(JSON.stringify(self[id1].Solution_real)); 
				ImportedFunctions[a]['functionInputs'][b]['imag']=JSON.parse(JSON.stringify(self[id1].Solution_imag)); 
				ImportedFunctions[a]['functionInputs'][b]['size']=JSON.parse(JSON.stringify(self[id1].Format_size));   
				ImportedFunctions[a]['functionInputs'][b]['units']=JSON.parse(JSON.stringify(self[id1].Units_units));  
				ImportedFunctions[a]['functionInputs'][b]['showEq']=JSON.parse(JSON.stringify(self[id1].Format_showequation));  
				ImportedFunctions[a]['functionInputs'][b]['dimModel']=JSON.parse(JSON.stringify(self[id1].Models_dimensions));  
				ImportedFunctions[a]['functionInputs'][b]['unitModel']=JSON.parse(JSON.stringify(self[id1].Models_units));  
				ImportedFunctions[a]['functionInputs'][b]['numModel']=JSON.parse(JSON.stringify(self[id1].Models_numerical));   
				ImportedFunctions[a]['functionInputs'][b]['quanModel']=JSON.parse(JSON.stringify(self[id1].Models_quantities)); 
				ImportedFunctions[a]['functionInputs'][b]['showEq']=JSON.parse(JSON.stringify(self[id1].Format_showequation));  
                for (var thisID in DOM_Object[id1]['Dependents']){ DOM_Object[this.Original_id]['Dependents'][thisID]='1'; 
                	console.log('setting id '+thisID+' - '+self[thisID]['Format_name']+' as a dependent');}
console.log('For input '+b+'-'+ImportedFunctions[a]['functionInputs'][b]['name']+', the answer is '+self[id1].Solution_real['0-0']);			

            }
			this.solveFafItems(functionName, 0, solVarIndex, callback);                                            
	}	}
};
//-------------------------------------------------------------------------------------------------------------------------------------//

/*-------------------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------- FUNCTION TO SOLVE EQUATIONS, LOOPS, AND STATEMENTS ------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------//
/*  This function steps through each item in the file being used as a function. If that item is an equation, it is tested to see if     |
    the name matches an input. A new equation is created and if the item name matches an input, then its value is set. If not, then     |
    the equation is solved. If the item is a loop or a statement then the block is run.                                                 | 
//-------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.solveFafItems = function (functionName, pos, solVarIndex, callback)  
{	var maxPos=0, inputFlag=0;        
    for (var a=0; a<ImportedFunctions.length; a++)																		          
    {	if (ImportedFunctions[a]['functionName']==functionName) 
        {   if (pos<ImportedFunctions[a]['fileItems'].length)
            {	if (ImportedFunctions[a]['fileItems'][pos]['component_type_id']=='3')    
                {   inputFlag=0;      
                    var tempData=ImportedFunctions[a]['fileItems'][pos]['content']['Equation'];    
                    tempData['Format_equation']=tempData['newEquation'];   
                    tempData['Page_position']=ImportedFunctions[a]['fileItems'][pos]['order'];   
                    tempData['id']=ImportedFunctions[a]['fileItems'][pos]['itemid'];
                    delete tempData['Format_id'];          
                    // tempData['Original_id']=this.Original_id;   
                    tempData['Original_id']=ImportedFunctions[a]['fileItems'][pos]['itemid'];
                    // var tempID=CreateEq(ImportedFunctions[a]['fileID'], 0, tempData);    
                    var tempID=CreateEq(this.fileid, 0, tempData);    
                    console.log('The ID that was created for the associated ID is '+tempID);
                    ImportedFunctions[a]['fileItems'][pos]['assocID']=tempID;  
                    for (var inputIndex=0; inputIndex<ImportedFunctions[a]['functionInputs'].length; inputIndex++)
                    {   if (ImportedFunctions[a]['fileItems'][pos]['content']['Equation']['Format_name']==ImportedFunctions[a]['functionInputs'][inputIndex]['name'])
                        {   self[tempID]['Solution_real']=ImportedFunctions[a]['functionInputs'][inputIndex]['real'];  
                            self[tempID]['Solution_imag']=ImportedFunctions[a]['functionInputs'][inputIndex]['imag'];  
                            self[tempID]['Units_units']=ImportedFunctions[a]['functionInputs'][inputIndex]['units'];   
                            self[tempID]['Format_size']=ImportedFunctions[a]['functionInputs'][inputIndex]['size'];    
                            self[tempID]['fileid']=ImportedFunctions[a]['fileID'];  
                            DOM_Object[tempID]['real']=ImportedFunctions[a]['functionInputs'][inputIndex]['real'];
                            DOM_Object[tempID]['imag']=ImportedFunctions[a]['functionInputs'][inputIndex]['imag'];
                            DOM_Object[tempID]['units']=ImportedFunctions[a]['functionInputs'][inputIndex]['units'];   
                            DOM_Object[tempID]['size']=ImportedFunctions[a]['functionInputs'][inputIndex]['size'];
                            DOM_Object[tempID]['fileid']=ImportedFunctions[a]['fileID']; 
                            inputFlag=1;                   
                            console.log('The value that was set for '+tempID+' was '+self[tempID]['Solution_real']['0-0']+' on file '+ImportedFunctions[a]['fileID']);
                        }             
                    }                  
                    if (inputFlag==0) 
                    {   eqPromise(tempID).then( this.solveFafItems(functionName, parseInt(pos,10)+1, solVarIndex, callback) );      
                    }else{  this.solveFafItems(functionName, parseInt(pos,10)+1, solVarIndex, callback); }   
                }else if (ImportedFunctions[a]['fileItems'][pos]['component_type_id']=='6')
                {	self[ImportedFunctions[SVA]['items'][thispos]['id']]={};
                    self[ImportedFunctions[SVA]['items'][thispos]['id']]['type']='forLoop';
                    for (var objProp in ImportedFunctions[SVA]['items'][thispos]) 
                    {	self[ImportedFunctions[SVA]['items'][thispos]['id']][objProp]=ImportedFunctions[SVA]['items'][thispos][objProp];}
                    DoStructures(ImportedFunctions[SVA]['items'][thispos]['id'], 0, 1, SolveFAFs(parseInt(pos,10)+1, thisinputs, SVA, callback))
                }else if (ImportedFunctions[a]['fileItems'][pos]['component_type_id']=='7')											    
                {	self[ImportedFunctions[SVA]['items'][thispos]['id']]={};
                    self[ImportedFunctions[SVA]['items'][thispos]['id']]['type']='whileLoop';
                    for (var objProp in ImportedFunctions[SVA]['items'][thispos]) 
                    {	self[ImportedFunctions[SVA]['items'][thispos]['id']][objProp]=ImportedFunctions[SVA]['items'][thispos][objProp];}
                    DoStructures(ImportedFunctions[SVA]['items'][thispos]['id'], 0, 1, SolveFAFs(parseInt(pos,10)+1, thisinputs, SVA, callback))
                }else if (ImportedFunctions[a]['fileItems'][pos]['component_type_id']=='8')
                {	self[ImportedFunctions[SVA]['items'][thispos]['id']]={};
                    self[ImportedFunctions[SVA]['items'][thispos]['id']]['type']='ifelse';
                    for (var objProp in ImportedFunctions[SVA]['items'][thispos]) 
                    {	self[ImportedFunctions[SVA]['items'][thispos]['id']][objProp]=ImportedFunctions[SVA]['items'][thispos][objProp];}
                    DoStructures(ImportedFunctions[SVA]['items'][thispos]['id'], 0, 1, SolveFAFs(parseInt(pos,10)+1, thisinputs, SVA, callback))
                }
            }else { this.returnFAF(functionName, solVarIndex, callback);  }                                    
//		else if ((DOM_Object[myid]['type']=="ifelse")||(DOM_Object[myid]['type']=="elseif")||(DOM_Object[myid]['type']=="else")||(DOM_Object[myid]['type']=="forLoop")||(DOM_Object[myid]['type']=="whileLoop"))
//		{	DoStructures(myid, 0, 1, function() { SolveFAFs(parseInt(pos,10)+1, SVA); } );	}
	   }                                                       
    }                                                       
}
//-------------------------------------------------------------------------------------------------------------------------------------*/


/*-------------------------------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------------- THIS REPLACES FAF EQUATIONS WITHIN THE VARIABLE ARRAY ---------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------------------//
	This is the final code called when dealing with files used as functions. The code simply goes through the outputs and then finds the            |
    corresponding item with that name and returns that ID. If there are multiple returns, the connected IDs are set.                                |
//-------------------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.returnFAF = function(functionName, solVarIndex, callback)    													            
{	var name_array=[], flag=0, returnID='';       
    this.connected_ids={};																	                                                    
    for (var a=0; a<ImportedFunctions.length; a++)																		          	            
    {	if (ImportedFunctions[a]['functionName']==functionName)        
        {	if (ImportedFunctions[a]['functionOutputs'].length==1)     
			{	for(var b=0; b<ImportedFunctions[a]['fileItems'].length; b++) 		 														    
				{	if (ImportedFunctions[a]['functionOutputs'][0]['name']==ImportedFunctions[a]['fileItems'][b]['content']['Equation']['Format_name'])
					{	returnID=ImportedFunctions[a]['fileItems'][b]['assocID'];    }      
			    }        
            }else                                 
            {                                     
                name_array=this.Format_left.replace(/[\[]/,'').replace(/[\]]/,'').split(',');
				for (var b=0; b<name_array.length; b++){ name_array[b]=name_array[b].replace(/\s/g,''); }
                for (var b=0; b<ImportedFunctions[a]['functionOutputs'].length; b++) 		 					      					        
                {	for (var c=0; c<ImportedFunctions[a]['fileItems'].length; c++)    
                    {   if (ImportedFunctions[a]['functionOutputs'][b]['name']==ImportedFunctions[a]['fileItems'][c]['content']['Equation']['Format_name'])
                        {   console.log('The value of '+ImportedFunctions[a]['fileItems'][c]['assocID']+' - '+self[ImportedFunctions[a]['fileItems'][c]['assocID']]['Format_name']+' should be '+self[ImportedFunctions[a]['fileItems'][c]['assocID']]['Solution_real']['0-0']+' - '+DOM_Object[ImportedFunctions[a]['fileItems'][c]['assocID']]['real']['0-0']);
                            this.connected_ids[ImportedFunctions[a]['fileItems'][c]['assocID']]=1;
      						if (flag==0){   flag=1; returnID=ImportedFunctions[a]['fileItems'][c]['assocID']; }	        
                        }        
                    }        
                }											            
            }                                         
            self[returnID]['Format_showequation']=functionName+'\\left(';   
            for (var b=0; b<ImportedFunctions[a]['functionInputs'].length; b++)  
            {   if (b>0){ self[returnID]['Format_showequation']=self[returnID]['Format_showequation']+', '+ImportedFunctions[a]['functionInputs'][b]['showEq'];// \
                }else{ self[returnID]['Format_showequation']=self[returnID]['Format_showequation']+ImportedFunctions[a]['functionInputs'][b]['showEq']; } }
            self[returnID]['Format_showequation']=self[returnID]['Format_showequation']+'\\right)';  
            console.log('The value of the return ID should be '+DOM_Object[returnID]['real']['0-0']+'-'+self[returnID]['Solution_real']['0-0']+' with a show equation and solution of '+self[returnID]['Format_showequation']+' and '+self[returnID]['Format_showsolution']);
            this.Solution_variable_array[parseInt(solVarIndex)]=returnID;   
            this.Remove_FilesAsFunctions(callback);
        }                                         
    }                                             
};
//-------------------------------------------------------------------------------------------------------------------------------------------------//


//-------------------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------------- PARSE INPUTS ---------------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------//
/*	This function goes through the variable array and finds entries where the user is calling a previous function with inputs. Once 	\
	found, it pulls out the string containing the variables and sends them to a function that returns an object with the name - value 	\
	pairs of the inputs for that string. The code then calls the solver for that equation with those inputs. Finally, the function 		\
	call is replaced with the result of the equation. The other parts of the input string are deleted from the parent equation.			\
	Along with this function is one that it uses which creates the objects for the inputs.												\
//-------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Parse_Inputs = function(callback)
{	var salength=this.Solution_variable_array.length, a=0, thisloc=0, i='', flag=0, op=0, inner_text='', thisindex=0, Inputs={};
	var eqobj={}, tempid='';
	for (a=0; a<this.Solution_variable_array.length; a++)
	{	thisloc=0;
		for (i in DOM_Object) 
		{	if ((this.Solution_variable_array[a]==DOM_Object[i]['name'])&&(this.Solution_variable_array[a+1]=="(")) 
			{	if ((DOM_Object[i]['order']>thisloc)&&(DOM_Object[i]['order']<DOM_Object[this.Format_id]['order']))
				{	flag=0;	op=0; inner_text=''; thisindex=parseInt(a, 10)+1; 
					Inputs={}; thisloc=DOM_Object[this.Format_id]['order'];
					while ((flag===0)&&(thisindex<=salength))
					{	inner_text=inner_text+this.Solution_variable_array[thisindex]; 
						temptext=inner_text; 
						if (this.Solution_variable_array[thisindex]=="(") { 
							op=op+1; }
						if (this.Solution_variable_array[thisindex]==")") 	 
						{	op=op-1; 
							if (op===0) 
							{	flag=1;		inner_text=inner_text.replace(/^\(/,'');	inner_text=inner_text.replace(/\)$/,'');
								Inputs=Input_Object(inner_text);
								eqobj={Page_position:DOM_Object[this.Format_id]['order'], Format_showtype:"InnerFunction",	 
								Solution_Inputs:Inputs, Original_id:this.Original_id, equation:"tempEq="+DOM_Object[i]['equation']};
								tempid=CreateEq(this.fileid, 1, eqobj);
								self[tempid].Format_showequation=this.Solution_variable_array[a]+'('+inner_text+')';
								this.Solution_variable_array[a]=tempid;
							}
						}
						this.Solution_variable_array[thisindex]="deleteme";
						thisindex=parseInt(thisindex, 10)+1;
					}
					for (i = 0; i < this.Solution_variable_array.length; i++)  
					{	if (this.Solution_variable_array[i] == 'deleteme')  
						{	this.Solution_variable_array.splice(i, 1);  
							this.Solution_key_array.splice(i,1);
							i=i-1;
					}	} 		
				}
			}
		}
	}
	if (typeof(callback)=="function") { callback();	}
};
function Input_Object(input_string)
{	var Inputs={}, input_array=input_string.split(';'), b=0, spliteq='', varname='', number='';
	for (b=0; b<input_array.length; b++)
	{	if (input_array[b]!=" ")
		{	spliteq=input_array[b].replace(/^\s+|\s+$/g, '').split('=');
			varname=spliteq[0].replace(/^\s+|\s+$/g, '');
			number=spliteq[1].replace(/^\s+|\s+$/g, '');
			Inputs[varname]=number;
		}
	}
	return Inputs; 
}

//-------------------------------------------------------------------------------------------------------------------------------------//


//-------------------------------------------------------------------------------------------------------------------------------------//
//---------------------------------------------------- REPLACE INPUTS -----------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------//
/*	This function looks to see if there is a list of inputs for the equation and if there is, it replaces those values. This only 		\
	happens when the equation in question was originally called as a subequation and is now being solved already properly formatted.	\
//-------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Replace_Inputs = function(callback)
{	var keyes='', index=0, eqobj='', tempid2='';
	for (keyes in this.Solution_Inputs)
	{	for (index=0; index<this.Solution_variable_array.length; index++)
		{	if ((this.Solution_variable_array[index]==keyes)||(this.Solution_variable_array[index].replace(/^\-/,'')==keyes))
			{	if (typeof(self[this.Solution_Inputs[keyes]])=="object")  
				{		this.Solution_variable_array[index]=this.Solution_Inputs[keyes];			
				}else { eqobj={Page_position:DOM_Object[this.Format_id]['order'], Format_showtype:"InnerFunction", 
						Original_id:this.Original_id, equation:"TempEq="+this.Solution_Inputs[keyes]};
						tempid2=CreateEq(this.fileid, 1, eqobj);
						this.Solution_variable_array[index]=tempid2; }
	}	}	}
	if (typeof(callback)=="function") { callback();	}
}; 
//-------------------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------------- REPLACE VECTORS -------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------//
/*	This function looks at the variable array and replaces any vectors with an object that contains the appropriate numbers. A vector	\
	is entered through the use of two or three numbers along with semicolons such as 0:10 or 0:1:10. The first number is the beginning	\
	the second is the increment value and the third is the final value.	
//-------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Replace_Vectors = function(callback)
{	var a='', i='', startindex=0, stopindex, sum=0, params=[], temp='', vectortext='', parameters=[], eqobj={}, id1='', id2='';
	var id3='', id='', counter=0, key='', tempdata='', tablename='', c1='', r1='', c2='', r2='', flag=0, vector='';
	
	for (index=0; index<this.Solution_variable_array.length; index++)
	{	
		if (this.Solution_variable_array[index]==":")
		{	
			startindex=0; 
			stopindex=this.Solution_variable_array.length-1; 
			sum=0;	
			params=new Array();
			
			// Step back through the equation until we find the opening bracket
			for (a=index-1; a>=0; --a)
			{	
				temp=this.Solution_variable_array[a];
				if (temp=="[") { startindex=a; break; } 
			}
			// Step forward until we find the ending bracket for the vector
			for (a=index+1; a<this.Solution_variable_array.length; ++a)
			{	temp=this.Solution_variable_array[a];
				if (temp=="]"){ stopindex=a; break; } 
			}

			// Grab the text containing the vector and then pull off the brackets and split using the ":""
			vectortext='';
			for (a=startindex; a<=stopindex; a++) 
			{ 
				vectortext=vectortext+this.Solution_variable_array[a]; 
			}
			vector=vectortext.replace("[","");
			vector=vector.replace("]","");  
			parameters=vector.split(':');
			

			// For each entered parameter in the vector, solve it for the value
			for (a=0; a<parameters.length; a++)
			{ 
				parameters[a].replace(/^\s+|\s+$/g, ''); 
			}
			eqobj={Page_position:DOM_Object[this.Format_id]['order'], Format_showtype:"InnerFunction", 
				Original_id:this.Original_id, equation:"TempEq="+parameters[0]};
			id1=CreateEq(this.fileid, 1, eqobj);	params[0]=self[id1].Solution_real['0-0'];
		
			eqobj={Page_position:DOM_Object[this.Format_id]['order'], Format_showtype:"InnerFunction", 
				Original_id:this.Original_id, equation:"TempEq="+parameters[1]};
			id2=CreateEq(this.fileid, 1, eqobj);	params[1]=self[id2].Solution_real['0-0'];
		
			if (parameters.length==3) 
			{ 
				eqobj={Page_position:DOM_Object[this.Format_id]['order'], Format_showtype:"InnerFunction", 
					Original_id:this.Original_id, equation:"TempEq="+parameters[2]};
				id3=CreateEq(this.fileid, 1, eqobj);		params[2]=self[id3].Solution_real['0-0']; 
			}

			// The return equation object
			eqobj={Page_position:DOM_Object[this.Format_id]['order'], Format_showtype:"vector", 
				Original_id:this.Original_id, equation:"TempEq=0"};
			id=CreateEq(this.fileid, 0, eqobj);

			// Set the show equations
			if (parameters.length==3) {	self[id].Format_showequation="["+self[id1].Format_showequation+":"+self[id2].Format_showequation+":"+self[id3].Format_showequation+"]";	}
			if (parameters.length==2) {	self[id].Format_showequation="["+self[id1].Format_showequation+":"+self[id2].Format_showequation+"]";	}	

			// Set the units
			if ( self[id1].Units_units != '' )
			{
				self[id].Units_units = self[id1].Units_units
				self[id].Units_base_array = self[id1].Units_base_array	
				self[id].Units_base_string = self[id1].Units_base_string
			}
			if ( self[id2].Units_units != '' )
			{
				self[id].Units_units = self[id2].Units_units
				self[id].Units_base_array = self[id2].Units_base_array	
				self[id].Units_base_string = self[id2].Units_base_string
			}
			if ( parameters.length==3 )
			{
				if ( self[id3].Units_units != '' )
				{
					self[id].Units_units = self[id3].Units_units
					self[id].Units_base_array = self[id3].Units_base_array	
					self[id].Units_base_string = self[id3].Units_base_string
				}
			}

			// Check to ensure that there weren't issues with the units
			if ( ( parameters.length==2 ) || ( parameters.length==3 ) )
			{
				if ( ( self[id1].Units_units != self[id2].Units_units ) && ( ( self[id1].Units_units != '' ) && ( self[id2].Units_units != '' ) ) )
				{
					Set_Error(this.Format_id, "Vector3");
				}
			}

			if ( parameters.length==3 )
			{
				if ( ( self[id3].Units_units != self[id2].Units_units ) && ( ( self[id2].Units_units != '' ) && ( self[id3].Units_units != '' ) ) )
				{
					Set_Error(this.Format_id, "Vector3");
				}
				if ( ( self[id3].Units_units != self[id1].Units_units ) && ( ( self[id1].Units_units != '' ) && ( self[id3].Units_units != '' ) ) )
				{
					Set_Error(this.Format_id, "Vector3");
				}
			}

			if (params.length==3)
			{	counter=0;
				for (a=parseFloat(params[0]); a<=parseFloat(params[2]); a=parseFloat(Big(a).plus(Big(params[1]))))
				{	key='0-'+counter;
					self[id].Solution_real[key]=parseFloat(Big(params[0]).plus(Big(params[1]).times(Big(counter))));
					counter++;
				} 
				DOM_Object[id]['real']=self[id].Solution_real;
			}else if (params.length==2)
			{	if (parameters[0].match(/^#Table/))
				{	var temp=parameters[0].replace(/^#/,'');
					parameters[0]="#File"+this.fileid+temp;	}
				if (parameters[1].match(/^#Table/))
				{	var temp=parameters[1].replace(/^#/,'');
					parameters[1]="#File"+this.fileid+temp;	}
				if ((parameters[0].match(/^#File[0-9]+Table/))&&(parameters[1].match(/^#File[0-9]+Table/)))
				{	counter=0;
					tempdata=parameters[0].split(".");
					tablename=tempdata[0].replace(/^#/,'');
					c1=(tempdata[1].replace("$",""));
					c1=parseInt(c1.charCodeAt(), 10)-62;
					r1=parseInt(tempdata[2].replace("$",""), 10)+3;
					tempdata=parameters[1].split(".");
					c2=(tempdata[1].replace("$",""));
					c2=parseInt(c2.charCodeAt(), 10)-62;
					r2=parseInt(tempdata[2].replace("$",""), 10)+3;
					c1=c1-3; r1=r1-3; c2=c2-3; r2=r2-3;
					flag=0;
					if ((c1!==c2)&&(r1!==r2)) {flag=1; Set_Error(this.Format_id, "Vector1");	}
					if ((c1==c2)&&(parseInt(r1, 10)>parseInt(r2, 10))) {flag=1; Set_Error(this.Format_id, "Vector2");	}
					if ((r1==r2)&&(parseInt(c1, 10)>parseInt(c2, 10))) {flag=1; Set_Error(this.Format_id, "Vector2");	}
					if (c1==c2)
					{	for (a=r1; a<=r2; a=a+1)
						{	key='0-'+counter;
							self[id].Solution_real[key]=DOM_Object[tablename]['data'][a][c1]['real'];					       	
                            // if (DOM_Object[PlotID]['Dependents'][DataID]===undefined){ DOM_Object[PlotID]['Dependents'][DataID]={}; } 
                            DOM_Object[this.Original_id]['Dependents'][tablename+'.'+tempdata[1]+'.'+a]='1';
                            counter=counter+1;
						}
						DOM_Object[id]['real']=self[id].Solution_real;
					}else
					{	for (a=c1; a<=c2; a=a+1)
						{	key='0-'+counter;
							self[id].Solution_real[key]=DOM_Object[tablename]['data'][r1][a]['real'];				    
							counter=counter+1;
                            DOM_Object[this.Original_id]['Dependents'][tablename+'.'+String.fromCharCode(65+a)+'.'+r1]='1'; 
						}
						DOM_Object[id]['real']=self[id].Solution_real;
					}
					DOM_Object[this.Format_id]['Dependents'][tempdata[0].replace('#','')]='1';
				}else 
				{	counter=0;
					for (a=parseFloat(params[0]); a<=parseFloat(params[1]); a=ToNum(parseInt(a, 10)+1))
					{	key='0-'+counter;
						self[id].Solution_real[key]=parseFloat(Big(params[0]).plus(Big(1).times(Big(counter))));
						counter++;
					}	DOM_Object[id]['real']=self[id].Solution_real;
			}	} 
			self[id].Format_size="1x"+counter;
			DOM_Object[id]['size']="1x"+counter;
			this.Solution_variable_array[stopindex]=id;
			if (this.Solution_key_array[stopindex+1] == '1') 
			{  
				self[id].Units_units=this.Solution_variable_array[stopindex+1]; 
				DOM_Object[id]['units']=this.Solution_variable_array[stopindex+1]; 
				self[id].Format_showequation=self[id].Format_showequation+" "+self[id].Units_units;
				this.Solution_variable_array.splice(parseInt(stopindex, 10)+1, 1);   
				this.Solution_key_array.splice(parseInt(stopindex, 10)+1,1);
			}
			for (i = stopindex-1; i >= startindex; i--)  
			{	this.Solution_variable_array.splice(i, 1); 
				this.Solution_key_array.splice(i,1);
			}  	
			delete self[id1];		delete self[id2];		delete self[id3];
			delete DOM_Object[id1];	delete DOM_Object[id2];	delete DOM_Object[id3];
	}	}
	if (typeof(callback)=="function") { callback();	}
};
//-------------------------------------------------------------------------------------------------------------------------------------//

//-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------------------------------------- REPLACE MATRICES ---------------------------------------------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------//
/*	Users are allowed to enter a matrix by hand. This function replaces those hand entered variables with temporary names and stores the values in temporary equation objects. 	\
	The token for the equation is put in its place. This is done so that when the PostFix is created, the token can be handled and not the input item.							\
//-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Replace_Matrices = function(callback)
{	var index=0, matrixtext='', flag=0, index2=0, sum=0, length1=0, id='', Temp1='', rows=0, Temp2=[], columns=0, ArrayText=[];
	var index3=0, test=[], index4=0, key='', eqobj='', id1='', i='', thisUnits='', baseUnits=[], unitFlag=0, thisQuantity='', thisBase=[];
	for (index=0; index<this.Solution_variable_array.length; index++)
	{	
		// Look at every index in the split array until we find the opening bracket
		if (this.Solution_variable_array[index]=="[")
		{	var matrixtext='', flag=0, index2=index, sum=0, showequation='[';
			length1=this.Solution_variable_array.length;
			
			// Grab all of the text that is included in the matrix
			while ( ( flag === 0 ) && ( index2 <= length1 ) )
			{	
				matrixtext=matrixtext+this.Solution_variable_array[index2];
				if (this.Solution_variable_array[index2]=="[") { 
					sum=sum+1; 
				}else if (this.Solution_variable_array[index2]=="]") 
				{	sum=sum-1;
					if (sum<1) { flag=1;}
				}
				this.Solution_variable_array[index2]='deleteme';
				index2=index2+1;
			}

			// Clean up the text so that there are no duplicates and no trailing commas or semicolons
			matrixtext=matrixtext.replace(/;;/g,';');
			matrixtext=matrixtext.replace(',,',',');
			matrixtext=matrixtext.replace(',;,',';');
			matrixtext=matrixtext.replace(/\;]$/,']');
			matrixtext=matrixtext.replace(/\,]$/,']');


			eqobj={Page_position:DOM_Object[this.Format_id]['order'], Format_showtype:"InnerFunction", Original_id:this.Original_id, equation:"TempEq="+matrixtext,
						Format_name:"Matrix", Format_showequation:matrixtext, Format_showtype:'matrix'}; 
			id=CreateEq(this.fileid, 0, eqobj);
			this.Solution_temps.push(id);
			matrixtext=matrixtext.replace(']','');
			matrixtext=matrixtext.replace('[','');
			if (matrixtext.match(";"))
			{	Temp1=matrixtext.split(';');
				rows=Temp1.length;
				Temp2=Temp1[0].split(',');
				columns=Temp2.length;
				ArrayText=matrixtext.split(';');
				for (index3 = 0; index3 < ArrayText.length; ++index3)  
				{	test=ArrayText[index3].split(','); 
					for (index4=0; index4<test.length; index4++)
					{	key=index3+'-'+index4;
						if (typeof(self[test[index4]])=="object")
						{	self[id].Solution_real[key]=self[test[index4]].Solution_real['0-0']; 
							self[id].Solution_imag[key]=self[test[index4]].Solution_imag['0-0']; 
							if(index4==test.length-1) { showequation=showequation+''+self[test[index4]].Format_showequation+';'; 
							}else{ 						showequation=showequation+''+self[test[index4]].Format_showequation+','; }

							if (self[test[index4]].Units_units != '')
								if (((unitFlag == 1) || (unitFlag == "1")) && (thisUnits != self[test[index4]].Units_units))
									{
										Set_Error(this.Original_id, "Math5", thisUnits, self[test[index4]].Units_units);
									}
								thisUnits=self[test[index4]].Units_units;
								thisBase=self[test[index4]].Units_base_array;
								thisString=self[test[index4]].Units_base_string;
								thisQuantity=self[test[index4]].Units_quantity;
								unitFlag = 1;

						}else if (isNumber(test[index4]))
						{	self[id].Solution_real[key]=parseFloat(test[index4]); 
							self[id].Solution_imag[key]=0; 
							if(index4==test.length-1) 
							{		showequation=showequation+''+parseFloat(test[index4])+';';
							}else{	showequation=showequation+''+parseFloat(test[index4])+',';	}
						}else
						{	eqobj={Page_position:DOM_Object[this.Format_id]['order'], Format_showtype:"InnerFunction", Original_id:this.Original_id, 
									equation:"TempEq="+test[index4]};
							id1=CreateEq(this.fileid, 1, eqobj);
							self[id].Solution_real[key]=self[id1].Solution_real['0-0']; 
							self[id].Solution_imag[key]=self[id1].Solution_imag['0-0']; 
							self[this.Original_id].Solution_temps.push(id1);
							if(index4==test.length-1) 
							{		showequation=showequation+''+self[id1].Format_showequation+';';
							}else{	showequation=showequation+''+self[id1].Format_showequation+',';		}

							if (self[id1].Units_units != '')
								if (((unitFlag == 1) || (unitFlag == "1")) && (thisUnits != self[id1].Units_units))
									{
										Set_Error(this.Original_id, "Math5", thisUnits, self[test[index4]].Units_units);
									}
								thisUnits=self[id1].Units_units;
								thisBase=self[id1].Units_base_array;
								thisString=self[id1].Units_base_string;
								thisQuantity=self[id1].Units_quantity;
								unitFlag = 1
				}	}	} 
				self[id].Format_size=rows+"x"+columns;
				self[id].Format_numinds=2;
			}else
			{	ArrayText=matrixtext.split(',');
				for (index3=0; index3<ArrayText.length; index3++) 
				{	key='0-'+index3;
					if (typeof(self[ArrayText[index3]])=="object")
					{	self[id].Solution_real[key]=self[ArrayText[index3]].Solution_real['0-0']; 
						self[id].Solution_imag[key]=self[ArrayText[index3]].Solution_imag['0-0']; 
						showequation=showequation+''+self[ArrayText[index3]].Format_showequation+',';

						if (self[ArrayText[index3]].Units_units != '')
							if (((unitFlag == 1) || (unitFlag == "1")) && (thisUnits != self[ArrayText[index3]].Units_units))
							{
								Set_Error(this.Original_id, "Math5", thisUnits, self[ArrayText[index3]].Units_units);
							}
							thisUnits=self[ArrayText[index3]].Units_units;
							thisBase=self[ArrayText[index3]].Units_base_array;
							thisString=self[ArrayText[index3]].Units_base_string;
							thisQuantity=self[ArrayText[index3]].Units_quantity;
							unitFlag = 1

					}else if (isNumber(ArrayText[index3]))
					{	self[id].Solution_real[key]=parseFloat(ArrayText[index3]); 
						self[id].Solution_imag[key]=0; 
						showequation=showequation+''+parseFloat(ArrayText[index3])+',';
					}else
					{	eqobj={Page_position:DOM_Object[this.Format_id]['order'], Format_showtype:"InnerFunction", Original_id:this.Original_id, 
							equation:"TempEq="+ArrayText[index3]};
						id1=CreateEq(this.fileid, 1, eqobj);
						self[id].Solution_real[key]=self[id1].Solution_real['0-0']; 
						self[id].Solution_imag[key]=self[id1].Solution_imag['0-0']; 
						self[this.Original_id].Solution_temps.push(id1);
						showequation=showequation+''+self[id1].Format_showequation+',';

						if (self[id1].Units_units != '')
							if (((unitFlag == 1) || (unitFlag == "1")) && (thisUnits != self[id1].Units_units))
							{
								Set_Error(this.Original_id, "Math5", thisUnits, self[id1].Units_units)
							}
							thisUnits=self[id1].Units_units;
							thisBase=self[id1].Units_base_array;
							thisString=self[id1].Units_base_string;
							thisQuantity=self[id1].Units_quantity;
							unitFlag = 1
					} 
				} 
				self[id].Format_size='1x'+ArrayText.length;
				self[id].Format_numinds=1;
			}
			self[id].Format_showequation=showequation+']';
			self[id].Show_Array();
			self[id].Units_units=thisUnits; 
			self[id].Units_quantity=thisQuantity; 
			self[id].Units_base_array=thisBase; 
			DOM_Object[id]['real']=self[id]['Solution_real'];
			DOM_Object[id]['imag']=self[id]['Solution_imag'];
			DOM_Object[id]['size']=self[id]['Format_size'];
			DOM_Object[id]['units']=self[id]['Units_units'];
			this.Solution_variable_array[index]=id;
			for (i = 0; i < this.Solution_variable_array.length; i++)										  
			{	if (this.Solution_variable_array[i] == 'deleteme')										  
				{	this.Solution_variable_array.splice(i, 1); 
					this.Solution_key_array.splice(i,1);
					i--;
			}	} 		
	
			if (this.Solution_key_array[index+1] == '1')		  
			{	self[id].Units_units=this.Solution_variable_array[index+1]; 
				self[id].Format_showequation=self[id].Format_showequation+" "+self[id].Units_units;
				this.Solution_variable_array.splice(index+1, 1); 
				this.Solution_key_array.splice(index+1,1);
	}	}	}
	if (typeof(callback)=="function") { callback();	}
};	
//-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------//

//-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------------------------------------- MATCH CLOSEST EQUATION --------------------------------------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------//
/*	This function is called several times throughout the equation process. It takes in the name of an equation and its location on the page. It then goes through the 			\
	DOM_Object object and matches the name. If it finds a match, it looks for the latest match prior to the equation in question. If no match is found, the entered				\
//-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function MatchClosestEquation(thisname, thislocation, thisid, index, insert)
{	
	//console.log('In the match closest equation function looking to match '+thisname+' at '+thislocation+' with a file id of '+DOM_Object[thisid].fileid);
    var file=DOM_Object[thisid].fileid, iname='', iloc=0, active='', parenttype='', lastpos=0, parent='none', dirmatch=0;
	var thisfile=parseInt(thisid.replace(/^File/,'').match(/^[0-9]+/), 10);
	var answer=thisname, position=-1, rating=0, i=0, ifile='', itemid='', type='', ploc=0, newid='', breakflag=0;
	if (!isNumber(thisname)&&(thisname!=="*")&&(thisname!=="/")&&(thisname!=="+")&&(thisname!=="*")&&(thisname!=="-"))
	{	if ((DOM_Object[thisid]['parentid']=="none")||(DOM_Object[thisid]['parentid']===undefined)) 
		{	 parenttype="none";	}else { parenttype=DOM_Object[DOM_Object[thisid]['parentid']]['content']['type']; parent=DOM_Object[thisid]['parentid']; }
		for (i in DOM_Object) 
		{	
//console.log('Comparing '+DOM_Object[i]['name']+' to '+thisname+' with names of '+self[thisid].Format_id+' and '+i);			
			if ((i!==undefined)&&(i.length>0))
			{	file=self[thisid].Format_id.match(/^File[0-9]+/); var test=new RegExp("^"+file,"g");
				if (i.match(test))
				{	iname=DOM_Object[i]['name'];		iloc=parseInt(DOM_Object[i]['order'], 10);	thislocation=DOM_Object[self[thisid].Original_id]['order'];
					active=DOM_Object[i]['active'];		ifile=parseInt(i.replace(/^File/,'').match(/^[0-9]+/), 10);
//console.log('The ifile and thisfile are '+ifile+' - '+thisfile+', the names are '+iname+' - '+thisname+', and the lower and upper locations are '+iloc+' - '+thislocation+', the active is '+active+', and the parent is '+parenttype);					
					if ((iname==thisname)&&(DOM_Object[i]['DatasetID']!==undefined))
					{	answer=i;	console.log('Matched Dataset');
					}else if ((parenttype=="none")||(parenttype=="ifelse")||(parenttype=="elseif")||(parenttype=="else")&&(thisfile==ifile))
					{	
//console.log('The position and active status are '+position+' : '+active);
						if ((iname==thisname)&&(iloc>position)&&(iloc<parseInt(thislocation, 10))&&(active==1)) 
						{ 	answer=i; position=DOM_Object[i]['order'];  console.log('Matched - '+i+' - '+DOM_Object[i]['real']['0-0']); }
					}else 
					{	var count=self[DOM_Object[thisid]['parentid']].Loop_countervalue;
						if ((thisfile==ifile)&&(iname==thisname)&&(iloc>position)&&(active==1)&&(count===0)&&(iloc<parseInt(thislocation, 10)))
						{	answer=i; position=DOM_Object[i]['order']; console.log('Matched '+i);  
						}else if ((thisfile==ifile)&&(iname==thisname)&&(iloc>parseInt(position, 10))&&(active==1)&&(count!==0)&&(iloc<=parseInt(thislocation, 10)))
						{	answer=i; position=DOM_Object[i]['order']; if (iloc==thislocation) { dirmatch=1; }	console.log('Matched - '+i+' - '+DOM_Object[i]['real']['0-0']); } 
					}
		}	}	}
		if (((parenttype=="forLoop")||(parenttype=="whileLoop"))&&(self[DOM_Object[thisid]['parentid']].Loop_countervalue!==0)&&(dirmatch===0)) 
		{	if (position>DOM_Object[parent]['order']) { breakflag=1; }else { breakflag=0; }
			while (((parenttype=="forLoop")||(parenttype=="whileLoop")||(parenttype=="ifelse"))&&(breakflag===0))
			{	for (itemid in DOM_Object[parent]['children'])
				{	type=DOM_Object[itemid]['type'];	iname=DOM_Object[itemid]['name'];	iloc=DOM_Object[itemid]['order'];
					ploc=DOM_Object[parent]['order'];
					if ((type=="equation")&&(DOM_Object[itemid]['active']==1)&&(iname==thisname)&&(iloc>thislocation)&&(iloc>cpos))
					{ 	answer=itemid; cpos=DOM_Object[i]['order']; breakflag=1; console.log('Matched '+DOM_Object[i]['name']+' at '+cpos); }
				}
				 parent=DOM_Object[parent]['content']['parentid'];	
				 if (parent=="none") 
				 { 
				 	parenttype="none"; 
				 }else 
				 { 
				 	parenttype=DOM_Object[parent]['content']['type'];	
				 }
			}
		}
		if ((parseInt(insert)==1)&&(DOM_Object[answer]!==undefined))
		{	if ((DOM_Object[answer]['type']=="equation")&&(answer!=thisname))
			{	
				eqobj={Page_position:DOM_Object[thisid]['order'], equation:"MyEq=0", Format_showtype:"variable", Format_name:"MyEq"};
				newid=CreateEq(DOM_Object[thisid]['fileid'], 0, eqobj);	
				self[newid].Format_showequation=self[thisid].Solution_variable_array[index];
				self[thisid].Solution_variable_array[index]=newid; 	
				self[thisid].Solution_temps.push(newid);
				self[newid]['Format_size']=DOM_Object[answer]['size'];
				self[newid]['Solution_real']=DOM_Object[answer]['real'];	self[newid]['Solution_imag']=DOM_Object[answer]['imag'];
				self[newid]['Units_units']=DOM_Object[answer]['units'];		self[newid]['Units_base_array']=DOM_Object[answer]['basearray'];
                DOM_Object[newid]={};	DOM_Object[newid]['ID']=newid;		DOM_Object[newid]['size']=DOM_Object[answer]['size'];
				DOM_Object[newid]['real']=DOM_Object[answer]['real'];		DOM_Object[newid]['imag']=DOM_Object[answer]['imag'];
				DOM_Object[newid]['units']=DOM_Object[answer]['units'];		DOM_Object[newid]['basearray']=DOM_Object[answer]['basearray'];
				DOM_Object[newid]['name']="MyEq";

				if ((self[thisid].Format_showtype=="top")&&(self[thisid].Format_name!="TempEq")&&(self[thisid].Format_name!==undefined)) 
				{ DOM_Object[self[thisid].Format_id]['Dependents'][answer]='1';
				}else if (self[thisid].Format_showtype=="InnerFunction") 
				{ 	DOM_Object[self[thisid].Original_id]['Dependents'][answer]='1'; 
				}else if (self[thisid].Format_name!="TempEq") { DOM_Object[self[thisid].Original_id]['Dependents'][answer]='1'; }
				if (answer==self[thisid].Original_id) { delete DOM_Object[self[thisid].Original_id]['Dependents'][answer]; }
			} 
		}
	}
	return answer;
}	
//-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------//

//-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------//
//---------------------------------------------------------------------- REPLACE MATRIX PIECES --------------------------------------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------//
/*	This function replaces any array pieces such as variable[0][0]
//-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Replace_Matrix_Pieces = function(callback) 
{	var index=0, thiseq='', indobj={}, ansobj={}, matrixtext='', flag=0, index2=0, ends=new Array(), matsize=1, mult=1, range={}, key='', indices='', sizes=[];	
	var a=0, b=0, thisindex='', eqobj={}, id='', newid='', i=0, showtext='';
	
	for (index=0; index<this.Solution_variable_array.length; index++)
	{	
		if ( ( this.Solution_variable_array[index] =='[' ) && ( index > 0 ) )	
		{	

			// If you have encounred an opening parenthesis with a variable name
			thiseq=MatchClosestEquation(this.Solution_variable_array[index-1], DOM_Object[this.Format_id]['order'], this.Format_id);

			if ( typeof( self[thiseq] ) == "object" )
			{	
				indobj={};	ansobj={};	matrixtext=''; flag=0;	 index2=index; 
				

				// Go through the variable array and group together all of the text that represents the variable 
				// and the input indices. This includes the name of the variable and any text within the brackets
				// This is done by creating a bracket index and ensuring that there aren't any more brackets past
				// the index being analyzed
				var bracketIndex = 0;
				var indices = [];
				var indIndex = 0;
				var indexText = '';
				while ( ( flag === 0 ) && ( index2 <= this.Solution_variable_array.length ) )
				{	
					if ( this.Solution_variable_array[index2] == '[' ){	bracketIndex = bracketIndex + 1; }
					if ( this.Solution_variable_array[index2] == ']' ){ bracketIndex = bracketIndex - 1; }

					if ( self[this.Solution_variable_array[index2]] !== undefined )
					{
						if ( self[this.Solution_variable_array[index2]].Format_showequation !== undefined )
						{
							showtext=showtext+self[this.Solution_variable_array[index2]].Format_showequation;
						}
						matrixtext=matrixtext+this.Solution_variable_array[index2];
						indexText=indexText+this.Solution_variable_array[index2];
					}else
					{
						if ( this.Solution_variable_array[index2] !== undefined )
						{
							showtext=showtext+this.Solution_variable_array[index2];
						}
						matrixtext=matrixtext+this.Solution_variable_array[index2];
						indexText=indexText+this.Solution_variable_array[index2];
					}
					if ( ( bracketIndex == 0 ) && 
						 ( ( this.Solution_variable_array[index2] == "]" ) && 
						   ( this.Solution_variable_array[index2+1] != "[" ) ) || 
						 ( index2 >= this.Solution_variable_array.length ) )
					{ 
						flag=1; 
					}
					if ( bracketIndex == 0 )
					{ 
						indices[indIndex] = indexText;
						indIndex = indIndex + 1; 
						indexText = '';
					}
					this.Solution_variable_array[index2]='deleteme';
					index2=index2+1;
				}

				// For each bracket [], check to see if it is a :, a number, input, etc
				//indices=matrixtext.match(/\[[0-9,a-z,A-Z,\:,\.,\-]+\]/g, '');
				sizes=self[thiseq].Format_size.split('x');	
				for (a=0; a<indices.length; a=a+1)
				{	
					indobj[a]={};	
					ansobj[a]={};
					thisindex=indices[a].replace(/^\[/,'').replace(/\]$/,'');;
					if ( ( thisindex.match(":") ) && ( thisindex.length == 1 ) ) 
					{  
						indobj[a]['0']=":"; 
						indobj[a]['1']=":";
					
					}else if ( thisindex.match(":") )	
					{	
						ends=thisindex.split(":"); 
						indobj[a]['0']=ends[0]; 
						indobj[a]['1']=ends[1];
					
					}else 
					{ 
						indobj[a]['0']=thisindex
						indobj[a]['1']='&'; 
					}	
				}

				// For each of those brackets that we have created, set the start and stop indices based
				// upon what the user entered
				for (a in indobj)
				{	
					// If both entries are colons, take full size for this index
					if ( ( indobj[a]['0'] == ':' ) && ( indobj[a]['1']==':' ) )
					{ 
						ansobj[a]['0']=0;	
						ansobj[a]['1']=parseInt(sizes[parseInt(a, 10)], 10)-1;
					

					// If the index is a bracket, it is a single number
					}else if ( indobj[a]['1'] == '&' )
					{	
						eqobj={Page_position:DOM_Object[this.Format_id]['order'], Format_showtype:"InnerFunction", Page_parentid:this.Page_parentid, 
						Page_topparentid:this.Page_topparentid, Original_id:this.Format_id, equation:"TempEq="+indobj[a]['0']};	
						id=CreateEq(this.fileid, 1, eqobj);	
						ansobj[a]['0']=self[id].Solution_real['0-0'];		
						ansobj[a]['1']=self[id].Solution_real['0-0'];
						delete DOM_Object[id];	
						delete self[id];


					// If the index has a start and stop point, solve the entries for each
					// of these items
					}else	
					{	eqobj={Page_position:DOM_Object[this.Format_id]['order'], Format_showtype:"InnerFunction", Page_parentid:this.Page_parentid, 
						Page_topparentid:this.Page_topparentid, Original_id:this.Format_id, equation:"TempEq="+indobj[a]['0']};	
						id=CreateEq(this.fileid, 1, eqobj);	
						this.Solution_temps.push(id);	
						ansobj[a]['0']=self[id].Solution_real['0-0'];
						delete DOM_Object[id];	
						delete self[id];	
						eqobj={Page_position:DOM_Object[this.Format_id]['order'], Format_showtype:"InnerFunction", Page_parentid:this.Page_parentid, 
						Page_topparentid:this.Page_topparentid, Original_id:this.Format_id, equation:"TempEq="+indobj[a]['1']};	
						id=CreateEq(this.fileid, 1, eqobj);	
						self[id].Format_showequation=indobj[a]['1'];
						this.Solution_temps.push(id);
						ansobj[a]['1']=self[id].Solution_real['0-0'];
						delete DOM_Object[id];	
						delete self[id];
					}
				}


				// Now that we have solved the start and stop points for each index (bracket), we go through 
				// and get the values for those indices
				eqobj={Page_position:DOM_Object[this.Format_id]['order'], Format_showtype:"matrixcomponent", Page_parentid:this.Page_parentid,
				Page_topparentid:this.Page_topparentid, Original_id:this.Format_id, equation:"TempEq=0"};
				id=CreateEq(this.fileid, 0, eqobj);	
				this.Solution_temps.push(id);	
				for ( a in self[thiseq].Solution_real )
				{	
					flag=0; 	
					key='';	
					splitkey=a.split('-');
					for ( b=0; b<splitkey.length; b++ ) 
					{ 
						if ( ( splitkey[b] >= ansobj[b]['0'] ) && ( splitkey[b]<=ansobj[b]['1'] ) )
						{ 
						}else 
						{ 
							flag=1; 
						} 
					}	
					if ( flag === 0 ) 
					{	
						for ( b=0; b<splitkey.length; b++ ) 
						{ 
							key=key+'-'+parseInt(parseInt(splitkey[b], 10)-parseInt(ansobj[b]['0'], 10), 10); 
						} 
						key=key.replace(/^\-/,''); 	
						self[id].Solution_real[key]=self[thiseq].Solution_real[a];
						self[id].Solution_imag[key]=self[thiseq].Solution_imag[a];
					}
				}

				self[id].Get_Size();
				newid=SquashMatrix(id);	

				self[newid].Format_showequation=self[this.Solution_variable_array[index-1]].Format_showequation+''+showtext;	
				self[id].Format_showequation=self[this.Solution_variable_array[index-1]].Format_showequation+''+showtext;	
				DOM_Object[newid]['real']=self[newid].Solution_real;		
				DOM_Object[newid]['imag']=self[newid].Solution_imag;
				this.Solution_temps.push(newid);
				self[newid].Units_units=self[thiseq].Units_units;
				self[newid].Units_base_string=self[thiseq].Units_base_string;
				self[newid].Units_base_array=self[thiseq].Units_base_array;
				DOM_Object[newid]['units'] = self[thiseq].Units_units;
				this.Solution_variable_array[index-1]=newid;
			}
		}
	}


	// Clean up the variable array by deleting the indexes that we declared to be deleted	
	for (i = 0; i < this.Solution_variable_array.length; i++) 
	{ 	if (this.Solution_variable_array[i] == 'deleteme') 
		{	this.Solution_variable_array.splice(i, 1);
			this.Solution_key_array.splice(i,1);
			i--;
	}	}	
	if (typeof(callback)=="function") { callback();	}
};	
//-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------//


//-----------------------------------------------------------------------------------------------------------------------------//
//------------------------------------ REPLACE NUMBERS ------------------------------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------------//
/*	This function replaces numbers in the variable array with objects. If the items after the numbers are units, then they		\
	are set as the units for that number and deleted from the array.															\
//-----------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Replace_Numbers = function(callback)
{	

	var index=0, number=0, eqobj={}, id='';

	for (index=0; index<this.Solution_variable_array.length; index++)
	{		
		if ((isNumber(this.Solution_variable_array[index]))&&(this.Solution_variable_array[index].length>0))
		{	number=parseFloat(Big(this.Solution_variable_array[index]));
			eqobj={Page_position:DOM_Object[this.Original_id]['order'], Format_showtype:"number",
			Original_id:this.Format_id, equation:"TempEq="+this.Solution_variable_array[index]};
			id=CreateEq(this.fileid, 0, eqobj);
			this.Solution_temps.push(id);
			self[id].Solution_real['0-0']=number;
			self[id].Format_showequation=this.Solution_variable_array[index];
			this.Solution_variable_array[index]=id; 
			self[id].Models_units='NA';
			self[id].Models_quantities='NA';
			self[id].Models_dimensions="1x1";

            if ( ( this.Solution_key_array[index+1] == '1' ) || (this.Solution_key_array[index+1] == 1 ) )
			{	self[id].Units_units=this.Solution_variable_array[index+1];
				self[id].Format_showequation=self[id].Format_showequation+" "+Show_Fraction(self[id].Units_units);
				this.Solution_variable_array.splice(index+1, 1); 
				this.Solution_key_array.splice(index+1,1);
				self[id].Models_units=self[id].Units_units;
				console.log('Number had trailing units');
			}

			DOM_Object[id]['real']={};
			DOM_Object[id]['real']['0-0']=number;		DOM_Object[id]['imag']={};		DOM_Object[id]['size']="1x1";
			DOM_Object[id]['units']=self[id].Units_units;
	}	}

	if (typeof(callback)=="function") { callback();	}
}; 
//-----------------------------------------------------------------------------------------------------------------------------//

//-----------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------- IS NUMBER -----------------------------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------------//
function isNumber (o) {  return ! isNaN (o-0); }
//-----------------------------------------------------------------------------------------------------------------------------//


//-----------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------------------- REPLACE TABLES ----------------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------------//
/*	This function replaces all table entries with the appropriate value. The tables are sent to this solver as an object 		\
	with indices that match their row and column index. This function merely pulls that number out and sets it as the 			\
	value of the object that is replaced in the variable array.																	\
//-----------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Replace_Tables = function(callback)
{	var index=0, tempdata='', tablename='', colnumber='', rownumber=0, id='', number='', units='', row=0, col=0;
	var va=this.Solution_variable_array;
	for (index=0; index<this.Solution_variable_array.length; index+=1)
	{	if (this.Solution_variable_array[index].match(/^#Table/))
		{	tempdata=this.Solution_variable_array[index].split(".");
//			tablename="File"+FileID+"Table"+tempdata[0].replace('#Table','');
			var temp=tempdata[0].replace(/#/,'');
			this.Solution_variable_array[index]="#File"+FileID+temp+'.'+tempdata[1]+'.'+tempdata[2];
		}
		if (this.Solution_variable_array[index].match(/^#File[0-9]+Table/))
		{	tempdata=this.Solution_variable_array[index].split(".");
			var tablename=this.Solution_variable_array[index].replace(/^#/,'');
			tablename=tablename.match(/^File[0-9]+Table[0-9]+/,'');
			colnumber=(tempdata[1].replace("$",""));
			colnumber=parseInt(colnumber.charCodeAt(), 10)-65;														        
			rownumber=parseInt(tempdata[2].replace("$",""), 10);
            eqobj={Page_position:DOM_Object[this.Format_id]['order'],Format_showtype:"InnerFunction",equation:"Temp=0"};
			id=CreateEq(this.fileid, 0, eqobj);
			self[id].Solution_real['0-0']=DOM_Object[tablename]['data'][rownumber][colnumber]['real'];
			self[id].Solution_imag['0-0']=DOM_Object[tablename]['data'][rownumber][colnumber]['imag'];
			self[id].Units_units=DOM_Object[tablename]['data'][row][col]['units'];		         
			self[id].Format_name=this.Solution_variable_array[index].replace('#','');
			self[id].Format_showtype="table";
			self[id].Format_showequation=this.Solution_variable_array[index].replace('#','');
			DOM_Object[id]['real']={};
			DOM_Object[id]['real']['0-0']=DOM_Object[tablename]['data'][rownumber][colnumber]['real'];
			DOM_Object[id]['imag']['0-0']=DOM_Object[tablename]['data'][rownumber][colnumber]['imag'];
			DOM_Object[id]['units']=DOM_Object[tablename]['data'][rownumber][colnumber]['units'];
			DOM_Object[id]['size']="1x1";
			DOM_Object[id]['ID']=id;
            DOM_Object[this.Original_id]['Dependents'][this.Solution_variable_array[index].replace('#','')]='1';    
//            DOM_Object[this.Original_id]['Dependents'][tablename]={};
//            DOM_Object[this.Original_id]['Dependents'][tablename]['col']=colnumber;// \
//            DOM_Object[this.Original_id]['Dependents'][tablename]['row']=rownumber;// \
			this.Solution_temps.push(self[id].Format_id);
			this.Solution_variable_array[index]=id;
//			if ((this.Format_showtype=="top")&&(this.Format_name!="TempEq")&&(this.Format_name!==undefined))
//			{ DOM_Object[this.Format_id]['Dependents'][this.Solution_variable_array[index]]='1';
//			}else if ((this.Format_showtype=="InnerFunction")&&(DOM_Object[this.Original_id]['type']!="plot")) 
//			{ 	DOM_Object[this.Original_id]['Dependents'][this.Solution_variable_array[index]]='1'; 
//			}else if ((this.Format_name!="TempEq")&&(DOM_Object[this.Original_id]['type']!="plot"))
//			{ DOM_Object[this.Original_id]['Dependents'][this.Solution_variable_array[index]]='1'; }
	}	} 
	if (typeof(callback)=="function") { callback();	}
}; 
//-----------------------------------------------------------------------------------------------------------------------------//

//-----------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------------------- REPLACE CONSTANTS -------------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------------//
/*	This function replaces any items that match a constant. This is done by looping through the constants object and 			\
	comparing the name of each item to all items in the variable array.	When there is a match, a new object is set in			\
	in place of the constant within the array. The values of that object are set to the values of the constant.					\
//-----------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Replace_Constants = function(callback)
{	var var_array=this.Solution_variable_array, index=0, eqobj={}, id='';
	var thisid=this.Format_id;
    for (index = 0; index < this.Solution_variable_array.length; ++index) 
	{	for (var Constant in Constants)
		{	if (Constants[Constant]['name']==var_array[index])
			{	eqobj={Page_position:DOM_Object[thisid]['order'],Format_showtype:"InnerFunction",equation:"Temp=0"};
				id=CreateEq(this.fileid, 0, eqobj);
				self[id].Format_showequation=Constants[Constant]['showvalue']; 
				self[id].Solution_real['0-0']=Constants[Constant]['value'];
				self[id].Units_units=Constants[Constant]['units']; 
				self[id].Units_multiplier=1;							 
				self[id].Format_showtype="constant";
				self[thisid].Solution_temps.push(id);
				self[thisid].Solution_variable_array[index]=id;
				DOM_Object[id]['real']={};
				DOM_Object[id]['real']['0-0']=Constants[Constant]['value'];
				DOM_Object[id]['size']="1x1";
				DOM_Object[id]['units']=Constants[Constant]['units']; 
				DOM_Object[id]['imag']={};
	}	}	} 
	if (typeof(callback)=="function") { callback();	}
}; 
//-----------------------------------------------------------------------------------------------------------------------------//

				
//-----------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------------------- REPLACE VARIABLES -------------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------------//
/*	This function replaces any items in the variable array that match previously declared variables. This is done by 			\
	scrolling through the DOM Object that was sent to the solver and finding the name that matches. The DOM object sent			\
	will only contain the last occurence of the variable name.																	\
//-----------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Replace_Variables = function(callback)
{	var var_array=this.Solution_variable_array, index=0, eqobj={}, id='';
	var thisid=this.Format_id;
	for (index = 0; index < this.Solution_variable_array.length; ++index) 
	{	thistext=this.Solution_variable_array[index].replace(/^\-/,'');
		thiseqid=MatchClosestEquation(thistext, DOM_Object[this.Format_id]['order'], this.Format_id, index, 1);
	} 
	if (typeof(callback)=="function") { callback();	}
};
//-----------------------------------------------------------------------------------------------------------------------------//


//-----------------------------------------------------------------------------------------------------------------------------//
//---------------------------------------------------- REPLACE CAD ------------------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------------//
/*	Replace any imported cad parts. This is done by matching the name given to each part to the user input.	It then parses		\
	text entered by the user to see which property the user wants. Only specific options are allowed.							\
//-----------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Replace_CAD = function(callback)
{	
	var var_array=this.Solution_variable_array, index=0, eqobj={}, id='', nameArray = [], num=0, units='', partId='';
	var thisid=this.Format_id;
    for (index = 0; index < this.Solution_variable_array.length; ++index) 
	{	
		nameArray = var_array[index].split('.');
		if ( nameArray.length > 1 )
		{
			for ( var a=0; a < cadParts.length; a++ )
			{	
				if (cadParts[a]['eqname'] == nameArray[0])
				{	
					if ( ( cadParts[a]['type'] == "onshape" ) || ( cadParts[a]['type'] === undefined ) )
					{
						eqobj={Page_position:DOM_Object[thisid]['order'],Format_showtype:"InnerFunction",equation:"Temp=0"};
						id=CreateEq(this.fileid, 0, eqobj);
						self[id].Format_showequation=var_array[index]; 
						DOM_Object[id]['real']={};
						partId = cadParts[a]['part_data']['partId'];
						if (nameArray[1] == "mass" )
						{	
							console.log('Setting the mass to '+cadParts[a]['mass_data']['bodies'][partId]['mass'][1]);
							self[id].Solution_real['0-0'] = cadParts[a]['mass_data']['bodies'][partId]['mass'][1]; 
							DOM_Object[id]['real']['0-0'] = cadParts[a]['mass_data']['bodies'][partId]['mass'][1]; 
							self[id].Units_units = 'kg'; 
							self[id].Units_quantity = 'mass'; 
							DOM_Object[id]['units'] = 'kg'; 
							DOM_Object[id]['size']="1x1";
						}
						if (nameArray[1] == "volume" )
						{
							console.log('Setting the volume to '+cadParts[a]['mass_data']['bodies'][partId]['volume'][1]);
							self[id].Solution_real['0-0'] = cadParts[a]['mass_data']['bodies'][partId]['volume'][1]; 
							DOM_Object[id]['real']['0-0'] = cadParts[a]['mass_data']['bodies'][partId]['volume'][1]; 
							self[id].Units_units = 'm^3'; 
							self[id].Units_quantity = 'volume'; 
							DOM_Object[id]['units'] = 'm^3'; 
						}
						if (nameArray[1] == "surface" )
						{ 
							self[id].Solution_real['0-0'] = cadParts[a]['mass_data']['bodies'][partId]['periphery'][1]; 
							DOM_Object[id]['real']['0-0'] = cadParts[a]['mass_data']['bodies'][partId]['periphery'][1]; 
							self[id].Units_units = 'm^2'; 
							self[id].Units_quantity = 'area'; 
							DOM_Object[id]['units'] = 'm^2'; 
							DOM_Object[id]['size']="1x1";
						}
						if (nameArray[1] == "weight" )
						{
							console.log('Setting the weight to '+cadParts[a]['mass_data']['bodies'][partId]['weight_N']);
							self[id].Solution_real['0-0'] = cadParts[a]['mass_data']['bodies'][partId]['weight_N']; 
							DOM_Object[id]['real']['0-0'] = cadParts[a]['mass_data']['bodies'][partId]['weight_N']; 
							self[id].Units_units = 'N'; 
							self[id].Units_quantity = 'force'; 
							DOM_Object[id]['units'] = 'N'; 
							DOM_Object[id]['size']="1x1";
						}
						if (nameArray[1] == "inertia" )
						{
							console.log('Setting the inertia');
							self[id].Solution_real['0-0'] = cadParts[a]['mass_data']['bodies'][partId]['inertia'][0]; 
							self[id].Solution_real['0-1'] = cadParts[a]['mass_data']['bodies'][partId]['inertia'][1]; 
							self[id].Solution_real['0-2'] = cadParts[a]['mass_data']['bodies'][partId]['inertia'][2]; 
							self[id].Solution_real['0-3'] = cadParts[a]['mass_data']['bodies'][partId]['inertia'][3]; 
							self[id].Solution_real['0-4'] = cadParts[a]['mass_data']['bodies'][partId]['inertia'][4]; 
							self[id].Solution_real['0-5'] = cadParts[a]['mass_data']['bodies'][partId]['inertia'][5]; 
							self[id].Solution_real['0-6'] = cadParts[a]['mass_data']['bodies'][partId]['inertia'][6]; 
							self[id].Solution_real['0-7'] = cadParts[a]['mass_data']['bodies'][partId]['inertia'][7]; 
							self[id].Solution_real['0-8'] = cadParts[a]['mass_data']['bodies'][partId]['inertia'][8]; 
							DOM_Object[id]['real']['0-0'] = cadParts[a]['mass_data']['bodies'][partId]['inertia'][0]; 
							DOM_Object[id]['real']['0-1'] = cadParts[a]['mass_data']['bodies'][partId]['inertia'][1]; 
							DOM_Object[id]['real']['0-2'] = cadParts[a]['mass_data']['bodies'][partId]['inertia'][2]; 
							DOM_Object[id]['real']['0-3'] = cadParts[a]['mass_data']['bodies'][partId]['inertia'][3]; 
							DOM_Object[id]['real']['0-4'] = cadParts[a]['mass_data']['bodies'][partId]['inertia'][4]; 
							DOM_Object[id]['real']['0-5'] = cadParts[a]['mass_data']['bodies'][partId]['inertia'][5]; 
							DOM_Object[id]['real']['0-6'] = cadParts[a]['mass_data']['bodies'][partId]['inertia'][6]; 
							DOM_Object[id]['real']['0-7'] = cadParts[a]['mass_data']['bodies'][partId]['inertia'][7]; 
							DOM_Object[id]['real']['0-8'] = cadParts[a]['mass_data']['bodies'][partId]['inertia'][8]; 
							self[id].Units_units = 'kg*m^2'; 
							self[id].Units_quantity = 'inertia'; 
							DOM_Object[id]['units'] = 'kg*m^2'; 
							DOM_Object[id]['size']="1x9";
						}
						if ( ( nameArray[1] == "principalInertia" ) || (nameArray[1] == "principalinertia" ) )
						{
							console.log('Setting the principal inertia');
							self[id].Solution_real['0-0'] = cadParts[a]['mass_data']['bodies'][partId]['principalInertia'][0]; 
							self[id].Solution_real['0-1'] = cadParts[a]['mass_data']['bodies'][partId]['principalInertia'][1]; 
							self[id].Solution_real['0-2'] = cadParts[a]['mass_data']['bodies'][partId]['principalInertia'][2]; 
							self[id].Units_units = 'kg*m^2'; 
							self[id].Units_quantity = 'inertia'; 
							DOM_Object[id]['units'] = 'kg*m^2'; 
							DOM_Object[id]['size']="1x3";
						}
						if (nameArray[1] == "centroid" )
						{
							console.log('Setting the centroid');
							self[id].Solution_real['0-0'] = cadParts[a]['mass_data']['bodies'][partId]['centroid'][0]; 
							self[id].Solution_real['0-1'] = cadParts[a]['mass_data']['bodies'][partId]['centroid'][1]; 
							self[id].Solution_real['0-2'] = cadParts[a]['mass_data']['bodies'][partId]['centroid'][2]; 
							self[id].Units_units = 'm'; 
							self[id].Units_quantity = 'm'; 
							DOM_Object[id]['units'] = 'm'; 
							DOM_Object[id]['size']="1x3";
						}
						if ( ( nameArray[1] == "principalAxes" ) || ( nameArray[1] == "principalaxes" ) )
						{
							console.log('Setting the principal axes');
							self[id].Solution_real['0-0'] = cadParts[a]['mass_data']['bodies'][partId]['principalAxes'][0]['x']; 
							self[id].Solution_real['0-1'] = cadParts[a]['mass_data']['bodies'][partId]['principalAxes'][0]['y']; 
							self[id].Solution_real['0-2'] = cadParts[a]['mass_data']['bodies'][partId]['principalAxes'][0]['z']; 
							self[id].Solution_real['0-3'] = cadParts[a]['mass_data']['bodies'][partId]['principalAxes'][1]['x']; 
							self[id].Solution_real['0-4'] = cadParts[a]['mass_data']['bodies'][partId]['principalAxes'][1]['y']; 
							self[id].Solution_real['0-5'] = cadParts[a]['mass_data']['bodies'][partId]['principalAxes'][1]['z']; 
							self[id].Solution_real['0-6'] = cadParts[a]['mass_data']['bodies'][partId]['principalAxes'][2]['x']; 
							self[id].Solution_real['0-7'] = cadParts[a]['mass_data']['bodies'][partId]['principalAxes'][2]['y']; 
							self[id].Solution_real['0-8'] = cadParts[a]['mass_data']['bodies'][partId]['principalAxes'][2]['z']; 
							DOM_Object[id]['real']['0-0'] = cadParts[a]['mass_data']['bodies'][partId]['principalAxes'][0]['x']; 
							DOM_Object[id]['real']['0-1'] = cadParts[a]['mass_data']['bodies'][partId]['principalAxes'][0]['y']; 
							DOM_Object[id]['real']['0-2'] = cadParts[a]['mass_data']['bodies'][partId]['principalAxes'][0]['z']; 
							DOM_Object[id]['real']['0-3'] = cadParts[a]['mass_data']['bodies'][partId]['principalAxes'][1]['x']; 
							DOM_Object[id]['real']['0-4'] = cadParts[a]['mass_data']['bodies'][partId]['principalAxes'][1]['y']; 
							DOM_Object[id]['real']['0-5'] = cadParts[a]['mass_data']['bodies'][partId]['principalAxes'][1]['z']; 
							DOM_Object[id]['real']['0-6'] = cadParts[a]['mass_data']['bodies'][partId]['principalAxes'][2]['x']; 
							DOM_Object[id]['real']['0-7'] = cadParts[a]['mass_data']['bodies'][partId]['principalAxes'][2]['y']; 
							DOM_Object[id]['real']['0-8'] = cadParts[a]['mass_data']['bodies'][partId]['principalAxes'][2]['z']; 
							self[id].Units_units = 'kg*m^2'; 
							self[id].Units_quantity = 'inertia'; 
							DOM_Object[id]['units'] = 'kg*m^2'; 
							DOM_Object[id]['size']="1x9";
						}
						if (nameArray[1] == "density" )
						{
							console.log('Setting the density to '+cadParts[a]['material_data']['material']['properties'][0]['value']);
							self[id].Solution_real['0-0'] = cadParts[a]['material_data']['material']['properties'][0]['value']; 
							DOM_Object[id]['real']['0-0'] = cadParts[a]['material_data']['material']['properties'][0]['value']; 
							self[id].Units_units = cadParts[a]['material_data']['material']['properties'][0]['units']; 
							self[id].Units_quantity = 'density'; 
							DOM_Object[id]['units'] = cadParts[a]['material_data']['material']['properties'][0]['units']; 
							DOM_Object[id]['size']="1x1";
						}
					}

					if ( cadParts[a]['type'] == "fusion" )
					{

						eqobj={Page_position:DOM_Object[thisid]['order'],Format_showtype:"InnerFunction",equation:"Temp=0"};
						id=CreateEq(this.fileid, 0, eqobj);
						self[id].Format_showequation=var_array[index]; 
						DOM_Object[id]['real']={};

						if ( ( nameArray[1] == "mass" ) || ( nameArray[1] == "Mass" ) ) 
						{
							console.log('Setting the mass to '+cadParts[a]['properties']['Mass']);
							self[id].Solution_real['0-0'] = parseFloat(cadParts[a]['properties']['Mass'].replace(/\s+[a-z]+/,''))/1000;
							DOM_Object[id]['real']['0-0'] = parseFloat(cadParts[a]['properties']['Mass'].replace(/\s+[a-z]+/,''))/1000;
							self[id].Units_units = "kg"; 
							self[id].Units_quantity = 'mass'; 
							DOM_Object[id]['units'] = 'kg'; 
							DOM_Object[id]['size']="1x1";
						}


						if ( ( nameArray[1] == "density" ) || ( nameArray[1] == "Density" ) )
						{
							console.log('Setting the mass to '+cadParts[a]['properties']['Density']);
							self[id].Solution_real['0-0'] = parseFloat(cadParts[a]['properties']['Density'].replace(/\s+/g,'').replace(/g\/mm\^3/,''))*1000000;
							DOM_Object[id]['real']['0-0'] = parseFloat(cadParts[a]['properties']['Density'].replace(/\s+/g,'').replace(/g\/mm\^3/,''))*1000000;
							self[id].Units_units = "kg/m^3"; 
							self[id].Units_quantity = 'density'; 
							DOM_Object[id]['units'] = 'kg/m^3'; 
							DOM_Object[id]['size']="1x1";
						}

						if ( ( nameArray[1] == "area" ) || ( nameArray[1] == "Area" ) )
						{
							console.log('Setting the mass to '+cadParts[a]['properties']['Area']);
							self[id].Solution_real['0-0'] = parseFloat(cadParts[a]['properties']['Area'].replace(/\s+/g,'').replace(/mm\^2/,''))/1000000;
							DOM_Object[id]['real']['0-0'] = parseFloat(cadParts[a]['properties']['Area'].replace(/\s+/g,'').replace(/mm\^2/,''))/1000000;
							self[id].Units_units = "m^2"; 
							self[id].Units_quantity = 'area'; 
							DOM_Object[id]['units'] = 'm^2'; 
							DOM_Object[id]['size']="1x1";
						}

						if ( ( nameArray[1] == "volume" ) || ( nameArray[1] == "Volume" ) )
						{
							console.log('Setting the mass to '+cadParts[a]['properties']['Volume']);
							self[id].Solution_real['0-0'] = parseFloat(cadParts[a]['properties']['Volume'].replace(/\s+/g,'').replace(/mm\^3/,''))/1000000000;
							DOM_Object[id]['real']['0-0'] = parseFloat(cadParts[a]['properties']['Volume'].replace(/\s+/g,'').replace(/mm\^3/,''))/1000000000;
							self[id].Units_units = "m^3"; 
							self[id].Units_quantity = 'volume'; 
							DOM_Object[id]['units'] = 'm^3'; 
							DOM_Object[id]['size']="1x1";
						}


					}

					self[id].Units_multiplier=1;	 
					self[thisid].Solution_temps.push(id);
					self[thisid].Solution_variable_array[index]=id;
					DOM_Object[id]['imag']={};
	}	}	}	} 
	if (typeof(callback)=="function") { callback();	}
};
//-----------------------------------------------------------------------------------------------------------------------------//


//-----------------------------------------------------------------------------------------------------------------------------//
//----------------------------------------------------- CHECK NEGATIVES -------------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------------//
/*
This function looks for any independent negative signs and accounts for them. This is done for four cases - a negative at the 
beginning, a negative beforea variable or number, plus a negative, and a negative before a parenthesis.

*/
Equation.prototype.Check_Negatives = function(callback)
{	var index=0, v1='', v2='', v3='', newid='';
	for (index = 0; index < this.Solution_variable_array.length; ++index) 
	{	v1=this.Solution_variable_array[index];
		v2=this.Solution_variable_array[index+1];
		if (index>0) { 	v3=this.Solution_variable_array[index-1]; }else { v3='#';}
		
		// If the negative occurs at the beginning
		if ((v1=="-")&&(typeof(self[v2]=="object"))&&(index===0))
		{	
			var eqobj={Page_position:DOM_Object[this.Format_id]['order'], Format_showtype:"FirstNeg",  
			Page_parentid:this.Page_parentid, Page_topparentid:this.Page_topparentid, Original_id:this.Format_id, 
			equation:"TempEq=-1", Format_showequation:"-", Format_size:"1x1", Format_name:"TempEq", 
			Format_showvalue:"FirstNeg"};
			var newid=CreateEq(this.fileid, 0, eqobj);
			
			self[newid].Solution_real['0-0']=-1;
			DOM_Object[newid]['real']['0-0']=-1;
			this.Solution_variable_array[index]=newid;
			this.Solution_variable_array.splice(index+1,0,"*"); 
			this.Solution_key_array.splice(index+1,0,"*"); 
		
		}else if ((v1=="-")&&(typeof(self[v2])=="object")&&((v3=="+")||(v3=="-")||(v3=="//")||(v3=="*")||(v3=="(")||(v3=="[")||(v3=="#")))
		{	var eqobj={Page_position:DOM_Object[this.Format_id]['order'], Format_showtype:"FirstNeg",  
			Page_parentid:this.Page_parentid, Page_topparentid:this.Page_topparentid, Original_id:this.Format_id, 
			equation:"TempEq=-1", Format_showequation:"-", Format_size:"1x1", Format_name:"TempEq",
			Format_showvalue:"Negative"};
			var newid=CreateEq(this.fileid, 0, eqobj);
			self[newid].Solution_real['0-0']=-1;
			DOM_Object[newid]['real']['0-0']=-1;
			this.Solution_variable_array[index]=newid;
			this.Solution_variable_array.splice(index+1,0,"*"); 
			this.Solution_key_array.splice(index+1,0,"*"); 
		}else if ((v1=="-")&&(v3=="+"))
		{	this.Solution_variable_array.splice([index-1],1); 
			this.Solution_key_array.splice([index-1],1); 
		
		}else if (((v1=="-")&&(v2=="(")&&(index===0))||(((v1=="-")&&(v2=="(")&&(v3=="("))))
		{	var eqobj={Page_position:DOM_Object[this.Format_id]['order'], Format_showtype:"FirstNeg",  
			Page_parentid:this.Page_parentid, Page_topparentid:this.Page_topparentid, Original_id:this.Format_id, 
			equation:"TempEq=-1", Format_showequation:"-", Format_size:"1x1", Format_name:"TempEq",
			Format_showvalue:"Negative"};
			var newid=CreateEq(this.fileid, 0, eqobj);
			self[newid].Solution_real['0-0']=-1;
			DOM_Object[newid]['real']['0-0']=-1;
			this.Solution_variable_array[index]=newid;
			this.Solution_variable_array.splice(index+1,0,"*"); 
			this.Solution_key_array.splice(index+1,0,"*"); 
		}
	} 
	if (typeof(callback)=="function") { callback();	}
};
//-----------------------------------------------------------------------------------------------------------------------------//

//-----------------------------------------------------------------------------------------------------------------------------//
//----------------------------------------------------- CHECK IMAGINARY -------------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.Check_Imaginary = function(callback)
{	var index=0, thiseq='', min2='', min3='';
	for (index = 0; index < this.Solution_variable_array.length; ++index) 
	{	if (this.Solution_variable_array[index]=="i") 
		{	thiseq=this.Solution_variable_array[index-1];
			self[thiseq].Solution_imag['0-0']=self[thiseq].Solution_real['0-0'];
			self[thiseq].Solution_real['0-0']=0;
			DOM_Object[thiseq]['real']['0-0']=0;
			self[thiseq].Format_showequation=self[thiseq].Solution_imag['0-0']+" i";
			if (((this.Solution_variable_array[index-2]=="+")||(this.Solution_variable_array[index-2]=="-"))&&(typeof(self[this.Solution_variable_array[index-3]])=="object"))
			{	min2=this.Solution_variable_array[index-2];
				min3=this.Solution_variable_array[index-3];
				self[min3].Solution_imag['0-0']=self[thiseq].Solution_imag['0-0'];
				self[min3].Format_showequation=self[min3].Solution_real['0-0']+''+min2+''+self[thiseq].Solution_imag['0-0']+" i";
				if (min2=="-") {self[min3].Solution_imag['0-0']="-"+self[min3].Solution_imag['0-0']; }
				this.Solution_variable_array.splice(index,1);
				this.Solution_variable_array.splice(index-1,1);
				this.Solution_variable_array.splice(index-2,1);
				this.Solution_key_array.splice(index,1);
				this.Solution_key_array.splice(index-1,1);
				this.Solution_key_array.splice(index-2,1);
			}else {	this.Solution_variable_array.splice(index,1); this.Solution_key_array.splice(index,1);	}
		}	
	} 
	if (typeof(callback)=="function") { callback();	}
};
//-----------------------------------------------------------------------------------------------------------------------------//

//-----------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------------------- CHECK EQUATION ----------------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------------//
/*	This function checks to make sure that all the items in the variable array have either been replaced by an object or 		\
	are mathematical operations or parenthesis. If that is not the case, then the equation is flagged as an error.				\
//-----------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Check_Equation = function(callback)
{	for (var index = 0; index < this.Solution_variable_array.length; ++index) 
	{	var test=this.Solution_variable_array[index];
		if ((typeof(self[test])!="object")&&(test!="+")&&(test!="-")&&(test!="*")&&(test!="/")&&(test!=="")&&(test!="(")&&(test!=")")&&(test!=""))
		{	console.log('Set error for '+test); Set_Error(this.Original_id, "Format2", test, "NA");	}
	}
	if ((this.Errors_flag==1)||(self[this.Original_id]['Errors_flag']==1)) 
	{ 
		if (eventType=="solvePlotData")
		{	eventErrorFlag=1; 
			eventError=self[this.Original_id]['Errors_errors'];
        	PassPlotData(plotObject, PlotID, DataID, 'all');
		}else
		{	this.Format_showequation="Error";
			this.Show_Equation(); 
			this.Return_Equation(); 
			if (typeof(callback)=="function") { callback();	} 
		}
	}else 
	{ 
		if (typeof(callback)=="function") { callback();	} 
	}
};
//-----------------------------------------------------------------------------------------------------------------------------//



//-----------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------------------- UNIT ARRAY ----------------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------------//
/*	This function looks at the units for each equation object in an equation. It parses out the units in question and 			\
	converts the entered units into an array that holds the base units. These base units are later used in multiplication 		\
	and division of complex objects.																							\
	The overall process used to handle units starts with this function and follows the following process.						\
	1. The units are parsed out into an array which holds each unit and math symbol independently								\
	2. Each part of the unit array is changed into its metric, unscaled, base unit.												\
	3. These units are then further decomposed. This is done by taking complex units such as Newtons and breaking them 			\
	down into base units such as kg*m/s^2. This creates the base array and string.												\
	4. The base array and string are used in mathematical operations to manipulate the units									\
	5. After all the math has been performed on the equation, the base units are recomposed into any more complex units 		\
	that they may represent.																									\
//-----------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Unit_Array = function(callback)
{
	var id=this.Format_id; 
	for (var index = 0; index < this.Solution_variable_array.length; ++index) 
	{
		if (typeof(self[this.Solution_variable_array[index]])=="object")
		{	if (self[this.Solution_variable_array[index]].Units_units===undefined) 
			{	self[this.Solution_variable_array[index]].Units_units=''; }
			var temp=self[this.Solution_variable_array[index]].Units_units; 
			if ((temp===undefined)||(typeof(temp)=='object')) { temp=''; }
			temp=temp.toString().replace(/{/g,"?{?");     
			temp=temp.toString().replace(/}/g,"?}?");
			temp=temp.toString().replace(/\(/g,"?(?");     
			temp=temp.toString().replace(/\)/g,"?)?");     
			temp=temp.toString().replace(/\*/g,"?*?");
			temp=temp.toString().replace(/\^/g,"?^?");
			temp=temp.toString().replace(/\//g,"?/?");
			temp=temp.toString().replace(/\?+$/,"");
			var unit_array=temp.split("?");
			self[this.Solution_variable_array[index]].Units_unit_array=unit_array;
		}
	}
	if (typeof(callback)=="function") { callback();	}
};
//-----------------------------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------------------------------- SCALE UNITS -----------------------------------------------------------------//
//---------------------------------------------------------------------------------------------------------------------------------------------//
/*
This function finds the metric equivalent of the units entered for each individual component of the equation. It then converts the number for 
that component accordingly. It then looks to see if there are any powers and records that information to be used in the creation of the base array.

Step 1: Creating the power array 
For each of the items in the unit array, if you come across a division sign, flip the sign for each unit beneath the sign. This is needed 
for manually entered units such as kg*m/s^2 instead of N.

Step 2: Converting the numbers and units to their metric equivalents 
Look at each item in the units array and see if it is a known unit. If it is, pull the scaled and converted numbers. If the item that 
follows the unit is a power sign, then increase the power array by the appropriate amount.

Step 3: Taking care of powers
This takes care of the case where there is a (m^2)^3

*/
Equation.prototype.Scale_Units = function(callback)
{	                                                  
	// Create the variables that will be needed
	var id=this.Format_id, TempFlag=0, index=0, thisid='', unit_array=[], scaled_array=[], sign_array='', unitindex=0, thisindex=0;
	var conv_array=[], power_array=[], status=1, flag=0, i=0, conv_unit='', a=0, x='', y='', replace='', number=0, temp='';			
	var temp1='', temp2='';


	for (index = 0; index < this.Solution_variable_array.length; ++index) 
	{
		if (typeof(self[this.Solution_variable_array[index]])=="object")
		{	
			// Grab the unit array and create some corresponding arrays to work with
			thisid=self[this.Solution_variable_array[index]].Format_id;
			unit_array=self[this.Solution_variable_array[index]].Units_unit_array;
			scaled_array=unit_array.slice(0);	
			conv_array=unit_array.slice(0);		
			power_array=unit_array.slice(0);
			sign_array=unit_array.slice(0);		
			status=1;
			

			// Make sure that the power array has the appropriate sign
			for (unitindex = 0; unitindex < unit_array.length; ++unitindex) 
			{	
				power_array[unitindex]=status;
				if (unit_array[unitindex]=="/")
				{	
					status=status*-1;
					thisindex=unitindex+1;
					flag=0;
					while ((thisindex<=unit_array.length)&&(flag===0))
					{
						power_array[thisindex]=status;
						if (unit_array[thisindex]==")") { flag=1; }
						thisindex++;
					}	
				}	
			}
			self[this.Solution_variable_array[index]].Units_power_array=power_array;
			

			// Check each entry in the array and see if it matches a scaled item. If so,
			// check to see if it is a temperature and if it is, set a flag. If not, store
			// the scaled factor. Store the units it is converted to, the quantiry, and multiplier
			for (unitindex = 0; unitindex < unit_array.length; ++unitindex) 
			{	flag=0;
				for (i in scaleUnits)
				{
					if (unit_array[unitindex]==i)
					{
						if ((i=="C")||(i=="F")||(i=="R"))
						{ 		
							scaled_array[unitindex]=i;
							TempFlag=1;
						}else 
						{
							scaled_array[unitindex]=scaleUnits[i]['conv_factor'];	
						}
						conv_array[unitindex]=scaleUnits[i]['conv_unit'];
						conv_unit=scaleUnits[i]['conv_unit'];
						self[self[id].Solution_variable_array[index]].Units_units=conv_unit;
						self[self[id].Solution_variable_array[index]].Units_conv_units=i;
						self[self[id].Solution_variable_array[index]].Units_quantity=scaleUnits[i]['quantity'];
						self[self[id].Solution_variable_array[index]].Units_multiplier=scaleUnits[i]['conv_factor'];
						if (unit_array[unitindex+1]=="^") 
						{
							power_array[unitindex]=unit_array[unitindex+2]*power_array[unitindex]; 
						}
						sign_array[unitindex]=power_array[unitindex];
					}
				}	
			}
			

			// Build the equation to scale the item according to each of the conversion factors found so far.
			// Disallow for temperatures, but scale for powers for everything else
			var equation='NA=';
			for (a=0; a<scaled_array.length; ++a) 
			{	
				if (scaled_array[a+1]=="^")
				{
					x = scaled_array[a];	
					y = scaled_array[a+2];
					if ((x=="C")||(x=="F")||(x=="K")||(x=="R")) 
					{ 
						Set_Error(this.Original_id, "Format11");
					}else 
					{ 
						replace=Math.pow(x,y);	
					}
					scaled_array[a]=replace;  
					scaled_array[a+1]='';		
					scaled_array[a+2]='';
				}
				equation=equation+scaled_array[a];
			}
			if (equation=="NA=") { equation="NA=1"; }



			// Solve this equation using the eval function to give us the total mutiplier
			if ((equation!="NA=C")&&(equation!="NA=F")&&(equation!="NA=K")&&(equation!="NA=R")&&(TempFlag===0)) 
			{ 
				self[this.Solution_variable_array[index]].Units_multiplier=eval(equation);
			}
			//else if (TempFlag==1) { Set_Error(this.Original_id, "Format11"); }

			// Store these values so that I can debug them
			self[this.Solution_variable_array[index]].Units_scaled_array=scaled_array;
			self[this.Solution_variable_array[index]].Units_conv_array=conv_array;


			// Now step through the solution and scale each entry
			if ( self[this.Solution_variable_array[index]].Units_multiplier != 1 )
			{
				for (i in self[this.Solution_variable_array[index]].Solution_real)
				{
					// Pull out the real and imaginary and make sure they exist
				 	temp1=self[this.Solution_variable_array[index]].Solution_real[i];
				 	if ( temp1 === undefined )
				 	{
				 		temp1=0;
				 	}
					temp2=self[this.Solution_variable_array[index]].Units_multiplier;
					if (self[this.Solution_variable_array[index]].Solution_imag[i]===undefined) 
					{ 
						self[this.Solution_variable_array[index]].Solution_imag[i]=0;
						temp3=0;
					}else
					{
					 	temp3=self[this.Solution_variable_array[index]].Solution_imag[i];
					}

					// Scale each number. If it is a temperature, handle that in its own way
					if (equation=="NA=C"||equation=="C") 
					{		
						self[this.Solution_variable_array[index]].Solution_real[i]=parseFloat(Big(temp1).plus(Big(273.15)));
						self[this.Solution_variable_array[index]].Solution_imag[i]=0;
					}else if (equation=="NA=F"||equation=="F")
					{	
						self[this.Solution_variable_array[index]].Solution_real[i]=parseFloat(Big(temp1).plus(Big(459.67)).times(Big(5).div(Big(9))));
						self[this.Solution_variable_array[index]].Solution_imag[i]=0;
					}else if (equation=="NA=R"||equation=="NA=R")
					{		
						self[this.Solution_variable_array[index]].Solution_real[i]=parseFloat(Big(temp1).times(0.555555555555));
						self[this.Solution_variable_array[index]].Solution_imag[i]=0;
					}else if (equation=="NA=K"||equation=="NA=K")			 
					{		
						self[this.Solution_variable_array[index]].Solution_real[i]=parseFloat(temp1);
						self[this.Solution_variable_array[index]].Solution_imag[i]=0
					}else 
					{	
						self[this.Solution_variable_array[index]].Solution_real[i]=parseFloat(Big(temp1).times(temp2));	
						self[this.Solution_variable_array[index]].Solution_imag[i]=parseFloat(Big(temp3).times(temp2));	
					}

				}
			}


			/*
			number=DOM_Object[this.Solution_variable_array[index]]['real']['0-0'];
			if (number===undefined) { number=1; }
			if (equation=="NA=C"||equation=="C") 
			{		temp=parseFloat(Big(number).plus(Big(273.15)));
			}else if (equation=="NA=F"||equation=="F")
			{		temp=parseFloat(Big(number).plus(Big(459.67)).times(Big(5).div(Big(9))));
			}else if (equation=="NA=R"||equation=="NA=R")
			{		temp=parseFloat(Big(number).times(0.555555555555));
			}else if (equation=="NA=K"||equation=="NA=K")			 
			{		temp=parseFloat(number);
			}else {	temp=parseFloat(Big(number).times(Big(self[this.Solution_variable_array[index]].Units_multiplier)));	}
			self[this.Solution_variable_array[index]].Solution_real['0-0']=temp;
			if ((self[this.Solution_variable_array[index]].Format_size!="1x1")&&(self[this.Solution_variable_array[index]].Units_multiplier!=1))
			{
				for (i in self[this.Solution_variable_array[index]].Solution_real)
				{ 	temp1=self[this.Solution_variable_array[index]].Solution_real[i];//--- This addresses the case where the item is an array and all components are scaled.
					temp2=self[this.Solution_variable_array[index]].Units_multiplier;
					self[this.Solution_variable_array[index]].Solution_real[i]=parseFloat(Big(temp1).times(temp2));
				 	temp1=self[this.Solution_variable_array[index]].Solution_imag[i];
					if (temp1===undefined) { self[this.Solution_variable_array[index]].Solution_imag[i]=0;
					}else { self[this.Solution_variable_array[index]].Solution_imag[i]=parseFloat(Big(temp1).times(Big(temp2))); }
				}

			}

			*/


	}	}
	if (typeof(callback)=="function") { callback();	}
};
//---------------------------------------------------------------------------------------------------------------------------------------------//


//-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------------------------------------- DECOMPOSE UNITS -----------------------------------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------//
/*
This function looks at the units for an object and looks for complex units in the base array. For example, a N would be decomposed in 1 kg, 
1 m, and -2 s.This is done so that if the user enters "kg*m/s^2" for units instead of "N", then the code will still know that those are the 
same units. It then creates the base array.

Step 1: Initiate the new base array to zero everywhere

Step 2: For each individual unit in the unit array, compare it to the complex units in the parseUnits object. If it matches, then increase
the base units for the corresponding complex unit by an amount equal to those base units by the power of the complex unit.

For example, if you come across N^2, then the units added to the base array are 2 kg, 2 m, and -4 s.

Step 3 : For each individual unit in the unit array, compare it to the units in the scaled array.
*/
Equation.prototype.Decompose_Units = function(callback)
{	
	// Declare the variables
	var id=this.Format_id, matchFlag=0, index=0, unit_array='', power_array='', new_array=[], unitindex=0, i='', ui=0, cu='';


	for (index = 0; index < this.Solution_variable_array.length; ++index) 
	{
		if (typeof(self[this.Solution_variable_array[index]])=="object")
		{ 
			
			// Take the converted units and power array created in the scale units function
			unit_array=self[this.Solution_variable_array[index]].Units_conv_array;
			power_array=self[this.Solution_variable_array[index]].Units_power_array;
			new_array=[];
			for (unitindex = 0; unitindex < UnitList.length; unitindex++) 
			{
				new_array[UnitList[unitindex]]=0; 
			} 

			// Match the scaled units to the parse equivalent and then increment the base units array accordingly
			for (unitindex = 0; unitindex < unit_array.length; ++unitindex)  
			{	
				for (i in parseUnits) 
				{
					if (unit_array[unitindex]==parseUnits[i]['base_unit'])
					{
						for (ui = 0; ui < UnitList.length; ui++) 
						{
							cu=UnitList[ui];
							new_array[cu]=parseFloat(Big(parseUnits[i][cu]).times(Big(power_array[unitindex])).plus(Big(new_array[cu])));
						}
					}	
				}	
			}
			self[this.Solution_variable_array[index]].Units_base_array=new_array;
	}	}
	if (typeof(callback)=="function") { callback();	}
};
//-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------//


//-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------------------------------------- GET BASE STRING -----------------------------------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------//
/*
This function looks at the base array object for each equation item and creates units when adding and subtracting numbers.
*/
Equation.prototype.Get_BaseString = function(callback)
{	
	// Create the variables needed here
	var id=this.Format_id, thismodel='', testmodel='', index=0, ui=0;


	for (index = 0; index < this.Solution_variable_array.length; ++index) 
	{	
		thismodel='';
		if (typeof(self[this.Solution_variable_array[index]])=="object")
		{	
			for (ui=0; ui < UnitList.length-1; ui++)  
			{ 	
				if ((self[this.Solution_variable_array[index]].Units_base_array[UnitList[ui]]==NaN) ||
					(self[this.Solution_variable_array[index]].Units_base_array[UnitList[ui]]=="NaN"))
				{ 
					thismodel=thismodel+'0'; 
				
				}else
				{
					thismodel=thismodel+self[this.Solution_variable_array[index]].Units_base_array[UnitList[ui]]; 
				}
			}
			self[this.Solution_variable_array[index]].Units_base_string=thismodel;
		}	 
	}		 
	if (typeof(callback)=="function") { callback();	}
};			 
//-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------//



//-------------------------------------------------------------------------------------------------------------------------------------//
//----------------------------------------------- RECOMPOSE UNITS ---------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------//
/*
	This function takes the base array and determines the units from that. This is necessary because users may add Newtons to
	kg * meters per seconds squared. Users may also multiply kg by meters by seconds square.  Before that happens, the units 
	are decomposed into the base units, the math is done, and then the base array is looked at here to determine the final units.

	Step 1: Create a string from the current base array

	Step 2: Go through the parse array of complex units and create a string from those base units as well. Compare that
	string to the base string of the final equation. Note that regular units like s for seconds are included in the parse
	object. That means that normal units are indeed found here.

	Step 3: If the base string did not match any of the known complex units, an algorithm builds the display units from the 
	remaining base array. This should be updated to allow for complex units to be pulled out and still build the remaining
	items. Perhaps creating a base array and then subtracting the known complex units?
*/
Equation.prototype.Recompose_Units = function(callback)
{	var ui=0, flag=0, i='', testmodel='', basemodel='', thismodel='', units='', flag0=0, flag1=0, flag2=0; 
	

	// Go through the base array and build a model for the base string
	for (ui=0; ui < UnitList.length; ui++) 
	{ 	
		if ((this.Units_base_array[UnitList[ui]]==NaN)||(this.Units_base_array[UnitList[ui]]=="NaN"))
		{	thismodel=thismodel+'0';
			basemodel=basemodel+UnitList[ui];
		}else
		{	thismodel=thismodel+this.Units_base_array[UnitList[ui]]; 
			basemodel=basemodel+UnitList[ui];
		}
	}


	// Test if the units base string matches any of the known complex units like Newtons, etc
	flag=0;
	for (i in parseUnits)								 
	{	testmodel='';
		for (ui=0; ui < UnitList.length; ui++)   
		{
			if (parseUnits[i][UnitList[ui]]) 
			{
				testmodel=testmodel+parseUnits[i][UnitList[ui]];
			}else 
			{	
				testmodel=testmodel+'0'; 
			}
		}
		if ( (thismodel == testmodel ) && ( parseUnits[i]['default']=="1" ) ) 
		{	
			flag=1;	
			this.Units_units=parseUnits[i]['base_unit'];
			this.Units_quantity=parseUnits[i]['quantity'];
		} 
	} 


	// If the units do not match a known complex item
	if (flag==0)
	{	units='(';	flag0=0; flag1=0;	flag2=0;
		
		// Loop through the unit list and build the units
		for (ui=0; ui < UnitList.length; ui++)
		{	
			if (this.Units_base_array[UnitList[ui]]==1) 
			{ 
				if (flag0==0) 
				{ 
					units=units+''+UnitList[ui]; 
					flag0=1; 
				}else 
				{ 
					units=units+'*'+UnitList[ui]; 
			}	}
			
			if (this.Units_base_array[UnitList[ui]]>1)  
			{ 
				if (flag0==0) 
				{ 
					units=units+''+UnitList[ui]+'^'+this.Units_base_array[UnitList[ui]]; 
					flag0=1;
				}else 
				{ 
					units=units+'*'+UnitList[ui]+'^'+this.Units_base_array[UnitList[ui]];  
			}	}
			flag1=1;
		}
		if (units=="(") { units=''; }else { units=units+')'; }

		for (ui=0; ui < UnitList.length; ui++)
		{	
			// Place negative units on the lower end of the divide
			if (this.Units_base_array[UnitList[ui]]==-1)								 
			{ 
				if (flag0===0) 
				{
					units='1/('+UnitList[ui]; flag2=1; 
				}else 
				{ 
					if (flag2==1) 
					{
						units=units+'*'+UnitList[ui]; 
					}else 
					{
						units=units+'/('+UnitList[ui]; flag2=1; 
			} 	}	}
			
			// Place multiple lowered units
			if (this.Units_base_array[UnitList[ui]]<-1) 
			{ 
				if (flag0===0) 
				{
					units='1/('+UnitList[ui]+'^'+this.Units_base_array[UnitList[ui]].toString().replace('-','');	 
					flag2=1;
				}else 
				{
					if (flag2==1) 
					{ 
						units=units+'*'+UnitList[ui]+'^'+this.Units_base_array[UnitList[ui]].toString().replace('-','');
					}else 
					{
						units=units+'/('+UnitList[ui]+'^'+this.Units_base_array[UnitList[ui]].toString().replace('-',''); flag2=1; 
			}	}	}
		}
		if ((units!=='')&&(flag2==1)) { units=units+')';	}
		units=units.replace(/^\*/,'');
		units=units.replace(/^\//,'');
		this.Units_units=units;
    }
	this.Models_quantities=this.Units_quantity;
	if (typeof(callback)=="function") { callback();	}
}; 
//-------------------------------------------------------------------------------------------------------------------------------------//


//-------------------------------------------------------------------------------------------------------------------------------------//
//---------------------------------------------------- GET SIZE -----------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.Get_Size = function(callback)
{	var i='', temp='', a='', size_array={}, numinds=1, size="", flag=0, cflag=0, newkey='', newsol={};
	for (i in this.Solution_real)
	{	temp=i.split('-');
		for (a=0; a<temp.length; a=a+1)
		{
			if (parseInt(temp[a], 10)>=(parseInt(size_array[a], 10)||0)) { size_array[a]=parseInt(temp[a], 10); }
		} 
		if ((temp.length!=numinds)&&(cflag===0)) { flag=1; }
		if (temp.length>numinds) { numinds=temp.length; }
		cflag=1;
	}
	if (flag==1)
	{	for (i in this.Solution_real)
		{	newkey=''; temp=i.split('-');
			for (a=0; a<numinds; a=a+1)	{ if (temp[a]!==undefined) { newkey=newkey+'-'+temp[a]; }else { newkey=newkey+'-0'; } }
			newkey=newkey.replace(/^\-/,'');
			newsol[newkey]=this.Solution_real[i];
		}
		this.Solution_real=newsol;
	}
	for (i in size_array){ size_array[i]=parseInt(size_array[i], 10)+1; }
	for (i in size_array){if (size==="") { size=size_array[i]; }else { size=size+"x"+size_array[i]; } }
	this.Format_numinds=numinds;
	if (this.Format_numinds<2) { this.Format_numinds=2; }
	this.Format_size=size;
	if (String(this.Format_size).indexOf('x')=="-1") { this.Format_size=this.Format_size+"x1"; }
	if (this.Format_size=="x1") { this.Format_size="1x1"; }
	if (typeof(callback)=="function") { callback();	}
}; 
//-------------------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------------------- GET BASE STRING ------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.Get_My_BaseString = function(callback)
{	var basestring='';
	for (var i in this.Units_base_array) 
	{	
		// We don't include radians in the base string
		if ( i != 'rad' )
		{
			basestring=basestring+this.Units_base_array[i]; 
		}
	}
	this.Units_base_string=basestring;
	if (typeof(callback)=="function") { callback();	}
}; 
//-------------------------------------------------------------------------------------------------------------------------------------//


//-------------------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------------------ MODELS -----------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.Models = function(callback)
{	var id=this.Format_id;	self[id].Models_numerical="";	self[id].Models_units="";	self[id].Models_dimensions="";
	self[id].Models_quantities="";		var num=''; 		var dim='';			var units='';	var quan='';
	for (var index = 0; index < self[id].Solution_variable_array.length; ++index)  
	{	if (typeof(self[self[id].Solution_variable_array[index]])=="object")  
		{	if (self[self[id].Solution_variable_array[index]].Models_numerical==='') 
			{	if (self[self[id].Solution_variable_array[index]].Format_size=="1x1") 
				{		num=num+''+self[self[id].Solution_variable_array[index]].Solution_real['0-0'];  
				}else {	num=num+''+self[self[id].Solution_variable_array[index]].Format_size;	}
			}else {	num=num+''+self[self[id].Solution_variable_array[index]].Models_numerical;	}
			if (self[self[id].Solution_variable_array[index]].Models_units==='') 
			{	if (self[self[id].Solution_variable_array[index]].Units_units==='') 
				{		units=units+' NA';
				}else { units=units+''+self[self[id].Solution_variable_array[index]].Units_units;  	}
			}else {	units=units+''+self[self[id].Solution_variable_array[index]].Models_units;	}
			if (self[self[id].Solution_variable_array[index]].Models_dimensions==='') 
			{	dim=dim+''+self[self[id].Solution_variable_array[index]].Format_size;  
			}else {	dim=dim+''+self[self[id].Solution_variable_array[index]].Models_dimensions;	}
			if (self[self[id].Solution_variable_array[index]].Models_quantities==='') 
			{	if (self[self[id].Solution_variable_array[index]].Units_quantity==='') 
				{ 		quan=quan+' NA';
				}else { quan=quan+''+self[self[id].Solution_variable_array[index]].Units_quantity;  }
			}else 
			{	if (self[self[id].Solution_variable_array[index]].Models_quantities=='NA') 
				{	if ((self[self[id].Solution_variable_array[index]].Units_quantity=="NA")||(self[self[id].Solution_variable_array[index]].Units_quantity==""))
					{	quan=quan+''+self[self[id].Solution_variable_array[index]].Models_quantities;		
					}else {	quan=quan+''+self[self[id].Solution_variable_array[index]].Units_quantity;	}
			}	}
		}else
		{	num=num+''+self[id].Solution_variable_array[index];
			units=units+''+self[id].Solution_variable_array[index];
			dim=dim+''+self[id].Solution_variable_array[index];
			quan=quan+''+self[id].Solution_variable_array[index];
		}
	}
	self[id].Models_numerical=self[id].Models_numerical+num+''; 
	self[id].Models_units=self[id].Models_units+units+'';
	self[id].Models_dimensions=self[id].Models_dimensions+dim+'';
	self[id].Models_quantities=self[id].Models_quantities+quan+'';	
	if (typeof(callback)=="function") { callback();	}
};	
//-------------------------------------------------------------------------------------------------------------------------------------//


/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*--------------------------------------------------------- Functions to Solve Equations ------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

//-------------------------------------------------------------------------------------------------------------------------//
//----------------------------------------- CONVERT EQUATION TO POSTFIX ---------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
/*
Solving an equation involves the five functions below. The primary function is the UpdateEquation one, which is called 
anytime an equation is changed or a variable is changed that the equation uses. This function calls the function above 
to parse the equation by separating the variables within the equation, obtaining their values and units from the variable 
table, and then creating the numerical, unit, and full model by calling those functions.

Once those functions are called, these functions are called to solve the equation. First, the ConvertToPost function is 
called to take the infix notation of the equation and make the postfix style equation. This function creates both a 
numerical postfix and a postfix with units. The function holding the precedence of the operators is called from this 
function. Then the function to solve the postfix equation is used. This function simply performs the numerical operations 
that is defined by the symbol or words like sin or cos. 

This function is one of the primary ones used to solve equations. It converts the entered equation from an infix 
notation to an postfix one. This is a common tactic used in solving this sort of problem. This is accomplished by parsing 
the equation into an array with each element contaning a variable, an operator, or a parenthesis. Once this is done, 
the algorithm simply goes through each item in the array and places it into the proper postfix format.
*/
Equation.prototype.Convert_to_Post = function(callback)
{	                                              
	var var_array=this.Solution_variable_array;
	Stack=new Array();
	Stack_Units=new Array();
	PostFix=new Array();
	PostFix_Units=new Array();
	var stackpop='';
	var stackpop_units='';
	for (var index = 0; index < var_array.length; ++index) 
	{	if ((var_array[index]=='+')||(var_array[index]=='-')||(var_array[index]=='*')||(var_array[index]=='/')||(var_array[index]=='//')||(var_array[index]=='^')||(var_array[index]=='#'))
		{	stackpop=Stack.pop(); 
			Stack.push(stackpop); 
			while ((Stack.length!==0)&&((ThisOperatorPrecedence(stackpop))>=(ThisOperatorPrecedence(var_array[index]))))
			{	PostFix[PostFix.length]=Stack.pop();
				stackpop=Stack.pop(); 
				Stack.push(stackpop); 
			} 
			Stack.push(var_array[index]); 
		}else if (var_array[index]=='(')
		{ 
			Stack.push(var_array[index]); 
		}else if (var_array[index]==')')
		{ 
			stackpop=Stack.pop(); 
			while (stackpop!='(')
			{	PostFix[PostFix.length]=stackpop; 
				stackpop=Stack.pop();
			} 
		}else 
		{	PostFix[PostFix.length]=var_array[index];  } 
	} 
	stackpop=Stack.pop(); 
	while (stackpop)
	{	PostFix[PostFix.length]=stackpop;  
		stackpop=Stack.pop(); 
	} 
	this.Solution_PostFix=PostFix; 
	for (var i = 0; i < this.Solution_PostFix.length; i++)  
	{	if (this.Solution_PostFix[i]==='') { this.Solution_PostFix.splice(i, 1); } } 	
	if (typeof(callback)=="function") { callback();	}
}; 
//-------------------------------------------------------------------------------------------------------------------------//


//-------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------- OPERATOR PRECEDENCE ---------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
/*
This function is used by the above function in altering the entered equation from infix to postfix. It takes in an 
operator and returns the precedence of that operator. The precedence is simply a method of ensuring that multiplication 
and division occur before addition and subtraction. This is also true for trig functions, powers, and others.
*/
function ThisOperatorPrecedence(operator)
{
	if ((operator=="*")||(operator=='/')||(operator=='#')||(operator=='.*')||(operator=='//'))
	{	var precedence=2;
	}else if ((operator=="+")||(operator=="-"))
	{	var precedence=1;
	}else if (operator=="^")
	{	var precedence=3;
	}else
	{	var precedence=0;
	}
	return precedence;
}
//-------------------------------------------------------------------------------------------------------------------------//


//-----------------------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------- SOLVE THE POST FIX EQUATION ---------------------------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------------------------//
/*	This function solves the post fix string created above from the infix equation. This is done by pulling numbers from the string until 	\
	an operator is reached. At that time the most recent two numbers are pulled and the operator in question is performed for functions 	\
	in which one parameter is required, only one is pulled.																					\
//-----------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.SolvePostFix = function(callback)
{	var PostFix=this.Solution_PostFix;
	Stack=new Array();
	var stackpop1=''; var stackpop2=''; solution='';
	if (PostFix.length<2)
	{	if (typeof(self[PostFix[0]])=="object")
		{	var object=self[PostFix[0]].Format_id;
			if ((typeof(self[PostFix[0]].Solution_real['0-0'])=="object"))
			{	var object=self[self[PostFix[0]].Solution_real['0-0']].Format_id; }
			this.Solution_real=self[object].Solution_real;
			this.Solution_imag=self[object].Solution_imag;
			this.Solution_convsol=self[object].Solution_convsol;
			this.Solution_realdefault=self[object].Solution_realdefault;
			this.Solution_imagdefault=self[object].Solution_imagdefault;
			this.Format_numinds=self[object].Format_numinds;
			this.Format_size=self[object].Format_size;
			this.Units_units=self[object].Units_units;
			this.Units_conv_units=self[object].Units_conv_units;
			this.Units_multiplier=self[object].Units_multiplier;
			this.Units_quantity=self[object].Units_quantity;
			this.Units_base_array=self[object].Units_base_array;
        }
	}else
	{	for (var index = 0; index < PostFix.length; ++index) 
		{	if (this.Errors_flag===0)
			{	if ((PostFix[index]=="-")||(PostFix[index]=="+")||(PostFix[index]=="*")||(PostFix[index]=="#")||(PostFix[index]=="/")||(PostFix[index]=="//"))
				{	stackpop1=Stack.pop();
					if (!isNaN(stackpop1)) { stackpop1=stackpop1; }
					stackpop2=Stack.pop();
					if (!isNaN(stackpop2)) { stackpop2=stackpop2; }
					var temp=PostFix[index];
					solution=SolveMath(temp, stackpop1, stackpop2, this.Format_id);
					Stack.push(solution);
					if (solution=="Error") { break; }
				}else
				{	Stack.push(PostFix[index]);}
			}
		}
		if ((typeof(self[solution])=="object")&&(this.Format_type!=3)&&(this.Errors_flag===0))
		{	var object=self[solution].Format_id;
			if ((typeof(self[solution].Solution_real['0-0'])=="object"))
            {	var object=self[self[PostFix[0]].Solution_real['0-0']].Format_id; }													    
			this.Units_units=self[object].Units_units;
			this.Units_base_array=self[object].Units_base_array;
			this.Units_quantity=self[object].Units_quantity;
			this.Format_size=self[object].Format_size;
			this.Format_numinds=self[object].Format_numinds;
			this.Solution_real=self[object].Solution_real;
			this.Solution_imag=self[object].Solution_imag;
			this.Solution_realdefault=self[object].Solution_realdefault;
			this.Solution_imagdefault=self[object].Solution_imagdefault;
		}else if ((typeof(self[solution])=="object")&&(this.Format_type==3)&&(this.Errors_flag===0))
		{	var object=self[solution].Format_id;
			
            if ((typeof(self[solution].Solution_real['0-0'])=="object"))
				{	var object=self[self[PostFix[0]].Solution_real['0-0']].Format_id; }
			this.Solution_real=self[object].Solution_real;
			this.Solution_imag=self[object].Solution_imag;
		}
	}
	if (this.Errors_flag===0)
	{	for (var i in this.Solution_real)
		{	if (typeof(self[this.Solution_real[i]])==="object")
			{	if (self[this.Solution_real[i]].Format_showtype=="number")
				{	this.Solution_real[i]=self[this.Solution_real[i]].Solution_real['0-0'];
					this.Solution_imag[i]=self[this.Solution_imag[i]].Solution_imag['0-0'];
	}	}	}	}
	if (typeof(callback)=="function") { callback();	}
};
//-----------------------------------------------------------------------------------------------------------------------------------------//


/*-----------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------- SOLVE MATH -------------------------------------------------------------------------------------*/
/*-----------------------------------------------------------------------------------------------------------------------------------------*/
/*	This is the primary function that actually does the math. It is sent an operator and one or two numbers. It looks at the operator 		\
	and performs the appropriate math on the appropriate numbers. First, it looks at the two numbers sent to the solver and tests if 		\
	either is an array. If neither of the numbers is an array, the simple math is performed on the numbers. However, if one of the 			\
	numbers is an array, the proper function is performed.																					\
/*-----------------------------------------------------------------------------------------------------------------------------------------*/
function SolveMath (operator, pop1, pop2, id)
{	if (DOM_Object[pop1]['size']==='') {DOM_Object[pop1]['size']='1x1'; }
	if (DOM_Object[pop2]['size']==='') {DOM_Object[pop2]['size']='1x1'; }
	var solution=''; var type1=1; var type2=1;
	if (self[pop1]) { if ((self[pop1].Format_size=="1x1")) { type1=1; }else { type1=3; } }
	if (self[pop2]) { if ((self[pop2].Format_size=="1x1")) { type2=1; }else { type2=3; } }
	switch (operator)
	{	case "+":
		if ((type1==1)&&(type2==1)) { solution=AddSubNumbers(pop2, pop1, "+", id); }
		if ((type1==3)&&(type2==3)) { solution=AddSubMatrices(pop2, pop1, "+", id); }
		if (((type1==1)&&(type2==3))||((type1==3)&&(type2==1))) { solution=ScalarOperation("+", pop1, pop2); }
		break;
		case "-":
		if ((type1==1)&&(type2==1)) { solution=AddSubNumbers(pop2, pop1, "-", id); }
		if ((type1==3)&&(type2==3)) { solution=AddSubMatrices(pop2, pop1, "-", id); }
		if (((type1==1)&&(type2==3))||((type1==3)&&(type2==1))) { solution=ScalarOperation("-", pop2, pop1); }
		break;
		case "*":
		if ((type1==1)&&(type2==1)) { solution=MultDivNumbers(pop2, pop1, "*", id); }
		if ((type1==3)&&(type2==3)) { solution=MultMatrices(pop2, pop1, "*",  id); }
		if (((type1==1)&&(type2==3))||((type1==3)&&(type2==1))) { solution=ScalarOperation("*", pop1, pop2); }
		break;
		case "/":
		if ((type1==1)&&(type2==1)) { solution=MultDivNumbers(pop2, pop1, "/", id); }
		if (((type1==1)&&(type2==3))||((type1==3)&&(type2==1))) { solution=ScalarOperation("/", pop1, pop2); }
		if ((type1==3)&&(type2==3)) { solution=MultMatrices(pop2, pop1, "/", id); }
		break;
		case "#":
		if ((type1==3)&&(type2==3)&&(self[pop1].Format_size==self[pop2].Format_size)) 
			{ solution=DotProduct(pop1,pop2); }else { Set_Error(id, "DotProduct1", pop1, pop2); }
		break;
	}
	return solution;
}
//-----------------------------------------------------------------------------------------------------------------------------------------//


/*-----------------------------------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------ SOLVE MATRIX SUBCOMPONENTS -------------------------------------------------------------------*/
/*-----------------------------------------------------------------------------------------------------------------------------------------*/
/*	This function is called to solve the case where a certain index of matrix is solved for. This is the case where the equation is 	    |
	Matrix1[1][2]=5. It is not the case where the equation is test=Matrix1[1][2]. To accomplish the task, the program has three steps.      |
    1.  Find the most recent incarnation of the matrix in question and set this Solution array equal to that. 		       					|    
    2.  Split the indices sent to be set up into the individual brackets in an array. i.e. "[1][2][3]" becomes "[1], [2], [3]"              |
    3.  For each of these indices:                                                                                                          |
            a. Split the text up by the colons to see of it is a span i.e. 3:8 becomes [3], [8]                                             |
            b. If the span has a length of 1                                                                                                |
                I.  If it is a number, set the key to that and the size of that index to 1                                                  |
                II. If it is not a number, solve the equation and set the key to that value and the size to 1                               |
            c. If the span is not 3, set an error it should be a "[something]" "[:]" "[something]"                                          |
            d. If the span is indeed 3                                                                                                      |
                I.   If the first item is a number, set the first part of the key                                                           |
                II.  If it is not a number, solve the equation and set the key                                                              |
                III. If the third part is a number, set the second part of the key                                                          |
                IV.  If the third part is not a number, solve and set the key                                                               |
                V.   Set the length for the segment by subtracting the first key from the second                                            |
    4.  Check the indexes for the solution and for the indices that the solution is to be assigned to.                                      |
            a. Check each index to see if the size at that index is the same for both sides                                                 |
                I. One additional index is allowed on the left side, but it must have a size of 1. This is the case where the user is       |
                   growing the matrix by one dimension. For an already 2 D matrix, a third dimension could be added.                        |
            b. Check again to ensure that the number of indices being assingned on the left is equal to the size of the right               |
            C. Check again to ensure that the same number of indices exist on both sides of the equation                                    |
    5.  				|
/*-----------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Matrix_SubComp = function(callback)																					//	|
{	var key={}, index=0, thisNumInd=1, newNumInd=1, theseIndexes=[], thisIndex='', sizeIndex={}, splitIndex=[], leftSizes=[];           //  |
    var stepFlag=0, thisKey='', readKey={}, indexFlag=0, newSizes=[], newKeySize='', newIndexFlag=0, bigMatrixFlag=0, solSizes=[];      //  |
    if (!this.Format_left.match(/^\[/))																									//	|
	{	if (this.Format_type=="3")																										//	|
		{	this.Get_Size();
			if (this.Page_parentid=="none")																								//	|
			{	var thiseq=MatchClosestEquation(this.Format_name, DOM_Object[this.Format_id]['order'], this.Format_id);					//	|
				if (DOM_Object[thiseq]!==undefined) 																					//	|
				{	DOM_Object[this.Format_id]['numinds']=JSON.parse(JSON.stringify(DOM_Object[thiseq]['numinds']));					//	|
					DOM_Object[this.Format_id]['size']=JSON.parse(JSON.stringify(DOM_Object[thiseq]['size']));							//	|(1)
					DOM_Object[this.Format_id]['real']=JSON.parse(JSON.stringify(DOM_Object[thiseq]['real']));							//	|
					DOM_Object[this.Format_id]['imag']=JSON.parse(JSON.stringify(DOM_Object[thiseq]['imag']));							//	|
					this.tempsolr=JSON.parse(JSON.stringify(DOM_Object[thiseq]['real']));												//	|
					this.tempsoli=JSON.parse(JSON.stringify(DOM_Object[thiseq]['imag']));												//	|
				}else	{ 	Set_Error(this.Format_id, "Format10"); }																	//  |
			}																															//  |
            theseIndexes=splitBrackets(this.Format_left);                                                                               //  |(2)
            solSizes=this.Format_size.split('x');                                                                                		//  |
            leftSizes=DOM_Object[thiseq]['size'].split('x');                                                                            //  |
            for (var index=0; index<theseIndexes.length; index++)																		//  |
			{	key[index]={};                                                                                                          //  |
                thisIndex=splitColons(theseIndexes[index]);			                                    								//  |(3a)
                if (thisIndex.length==1)                                                                                                //  |
                {   if (isNumber(thisIndex[0]))	 																				     	//  |(3bI)
                    {	key[index]['a']=parseInt(thisIndex[0]);                                                                         //  |
                        key[index]['b']=parseInt(thisIndex[0]);                                                                         //  |
                        key[index]['length']=1;                                                                                        	//  |
                    }else if(thisIndex[0]==":")                                                                                         //  |
                    {   key[index]['a']=0;                                                                                              //  |
                        key[index]['b']=leftSizes[index]-1;                                                                             //  |
                        key[index]['length']=leftSizes[index];                                                                          //  |
                    }else																							   	       			//  |
                    {	var eqobj={Page_position:DOM_Object[this.Format_id]['order'], Format_showtype:"InnerFunction",     				//  |
                        Page_parentid:DOM_Object[this.Format_id]['parentid'], Page_topparentid:DOM_Object[this.Format_id]['topparentid'],// |
                        Original_id:this.Format_id,	equation:"NewEq="+thisIndex[0]};			    									//  |
                        var id=CreateEq(DOM_Object[this.Format_id]['fileid'], 1, eqobj);		      									//  |
                        this.Solution_temps.push(id);													     							//  |
                        key[index]['a']=DOM_Object[id]['real']['0-0'];                                                                  //  |
                        key[index]['b']=DOM_Object[id]['real']['0-0'];                                                                  //  |
                        key[index]['length']=1;                                                                                         //  |
                        delete DOM_Object[id];	delete self[id];											     						//  |	
                        sizeIndex[index]=1;                                                                            					//  |
                    }																									     			//  |
                }else if (thisIndex.length!=3)																							//  |(3c)
			    {    Set_Error(this.Format_id, "Indices1", index, thisIndex.length);                                                    //  |
                }else if (thisIndex.length==3)                                                                                          //  |
                {   if (isNumber(thisIndex[0])) {	key[index]['a']=parseInt(thisIndex[0]);                                 			//  |(3dI)
                    }else                                                                                                               //  |
                    {	var eqobj={Page_position:DOM_Object[this.Format_id]['order'], Format_showtype:"InnerFunction",     			//  |
                        Page_parentid:DOM_Object[this.Format_id]['parentid'], Page_topparentid:DOM_Object[this.Format_id]['topparentid'],   //  |
                        Original_id:this.Format_id,	equation:"NewEq="+thisindex[0]};			    									//  |(3DII)
                        var id=CreateEq(DOM_Object[this.Format_id]['fileid'], 1, eqobj);		      									//  |
                        this.Solution_temps.push(id);													     							//  |
                        key[index]['a']=DOM_Object[id]['real']['0-0'];                                                                  //  |
                        delete DOM_Object[id];	delete self[id];											     						//  |	
                    }                                                                                                                   //  |
                    if (isNumber(thisIndex[2]))                                                                                         //  |(3dIII)
                    {	key[index]['b']=parseInt(thisIndex[2]);                                                                         //  |
                        key[index]['length']=key[index]['b']-key[index]['a']+1;                           	                       		//  |
                    }else                                                                                                               //  |
                    {	var eqobj={Page_position:DOM_Object[this.Format_id]['order'], Format_showtype:"InnerFunction",     			//  |
                        Page_parentid:DOM_Object[this.Format_id]['parentid'], Page_topparentid:DOM_Object[this.Format_id]['topparentid'],   //  |
                        Original_id:this.Format_id,	equation:"NewEq="+thisindex[2]};			    									//  |
                        var id=CreateEq(DOM_Object[this.Format_id]['fileid'], 1, eqobj);		      									//  |(3dIV)
                        this.Solution_temps.push(id);													     							//  |
                        key[index]['b']=DOM_Object[id]['real']['0-0'];                                                                  //  |
                        key[index]['length']=key[index]['b']-key[index]['a']+1;                                                         //  |
                        delete DOM_Object[id];	delete self[id];											     						//  |	
                    }                                                                                                                   //  |(3dV)
                }                                                                                                                       //  |
            }                                                                                                                           //  |
            for (var index=0; index<theseIndexes.length; index++){   console.log('Multiplying '+newNumInd+' times '+parseInt(key[index]['length'])); newNumInd=newNumInd*parseInt(key[index]['length']); }              //  |(4)
            for (var index=0; index<solSizes.length; index++) {   console.log('Multiplying '+thisNumInd+' times '+parseInt(solSizes[index]));thisNumInd=thisNumInd*parseInt(solSizes[index]);     }              //  | 
            for (var index=0; index<Object.keys(key).length; index++){ newKeySize=newKeySize+'x'+key[index]['length']; }                //  |
            newKeySize=newKeySize.replace(/^x/,'');                                                                                     //  |
console.log('The numbers of indices are newNumInd - '+newNumInd+' and thisNumInd - '+thisNumInd);
console.log('The sizes are newKeySize - '+newKeySize+' and this.Format_size - '+this.Format_size);
            for (var index=0; index<theseIndexes.length; index++)                                                                       //  |
            {   if (key[index]['b']>=leftSizes[index])                                                                                  //  |
                {   bigMatrixFlag=1; }                                                                                                  //  |
            }                                                                                                                           //  |
            for (var index=0; index<theseIndexes.length; index++)                                                                       //  |
            {   if (key[index]['length']!=solSizes[index])                                                                              //  |
                {   if (Object.keys(key).length==leftSizes.length){ indexFlag=1;     }                                                  //  |
                    if ((key[index]['length']==1)&&(index==theseIndexes.length-1)&&(theseIndexes.length==leftSizes.length+1))           //  |
                    {  newIndexFlag=1; }else { indexFlag=1; }                                                                           //  |
                }                                                                                                                       //  |(4A)
            }                                                                                                                           //  |
            if ((theseIndexes.length!=leftSizes.length)&&(theseIndexes.length!=leftSizes.length+1))                                     //  |
            {   Set_Error(this.Format_id, "Indices2", theseIndexes.length, leftSizes.length);                                           //  |
            }else if (indexFlag==1)                                                                                                     //  |(4B)
            {   
            	Set_Error(this.Format_id, "Indices4", newKeySize, this.Format_size);                                                    //  |
            }else if (newNumInd!=thisNumInd)                                                                                            //  |(4C)
            {   Set_Error(this.Format_id, "Indices3", thisNumInd, newNumInd);                                                           //  |
            }else                                                                                                                       //  |(4D)
            {   var numKeys=1;                                                                                                          //  |
                for (a=0; a<Object.keys(key).length; a++)                                                                               //  |
                {   key[a]['count']=key[a]['a'];                                                                                        //  |
                    numKeys=numKeys*(parseInt(key[a]['b'])-parseInt(key[a]['a'])+1);                                                    //  |
                }                                                                                                                       //  |   
                for (a=0; a<solSizes.length; a++)                                                                                      //  |
                {   readKey[a]={};                                                                                                      //  |
                    readKey[a]['a']=0;                                                                                                  //  |
                    readKey[a]['b']=solSizes[a]-1;                                                                                     //  |
                    readKey[a]['count']=0;                                                                                              //  |
                }                                                                                                                       //  |   
console.log('The number of keys is '+numKeys);
                for (index=0; index<numKeys; index++)                                                                                   //  |
                {   thisKey='';     showKey='';                                                                                         //  |
                    stepFlag=0;                                                                                                         //  |
                    for (a=Object.keys(key).length-1; a>=0; a--)                                                                        //  |
                    {   if (a==Object.keys(key).length-1)                                                                               //  |
                        {  thisKey=key[a]['count']; }else{ thisKey=key[a]['count']+'-'+thisKey; }                                       //  |
                    }                                                                                                                   //  |
                    for (a=Object.keys(readKey).length-1; a>=0; a--)                                                                    //  |
                    {   if (a==Object.keys(readKey).length-1)                                                                           //  |
                        {  showKey=readKey[a]['count']; }else{ showKey=readKey[a]['count']+'-'+showKey; }                               //  |
                    }                                                                                                                   //  |
                    showKey=showKey.replace(/\-$/,'');                                                                                  //  |
console.log('Setting the key '+thisKey+' to the value at '+showKey+' of '+this.Solution_real[showKey]);                    
                    for (a=Object.keys(key).length-1; a>=0; a--)                                                                        //  |
                    {   if (a==Object.keys(key).length-1)                                                                               //  |
                        {   key[a]['count']=parseInt(key[a]['count'])+1;                                                                //  |
                            if (key[a]['count']>parseInt(key[a]['b']))                                                                  //  |
                            {   stepFlag=1;                                                                                             //  |
                                key[a]['count']=parseInt(key[a]['a']);                                                                  //  |
                            }                                                                                                           //  |
                        }else                                                                                                           //  |
                        {   if (stepFlag==1)                                                                                            //  |
                            {   key[a]['count']=parseInt(key[a]['count'])+1;                                                            //  |
                                if (key[a]['count']>parseInt(key[a]['b']))                                                              //  |
                                {   stepFlag=1;                                                                                         //  |
                                    key[a]['count']=parseInt(key[a]['a']);                                                              //  |
                                }else{ stepFlag=0; }                                                                                    //  |
                            }                                                                                                           //  |
                        }                                                                                                               //  | 
                    }                                                                                                                   //  |
                    for (a=Object.keys(readKey).length-1; a>=0; a--)                                                                    //  |
                    {   if (a==Object.keys(readKey).length-1)                                                                           //  |
                        {   readKey[a]['count']=parseInt(readKey[a]['count'])+1;                                                        //  |(5)
                            if (readKey[a]['count']>parseInt(readKey[a]['b']))                                                          //  |
                            {   stepFlag=1;                                                                                             //  |
                                readKey[a]['count']=0;                                                                                  //  |
                            }                                                                                                           //  |
                        }else                                                                                                           //  |
                        {   if (stepFlag==1)                                                                                            //  |
                            {   readKey[a]['count']=parseInt(readKey[a]['count'])+1;                                                    //  |
                                if (readKey[a]['count']>parseInt(readKey[a]['b']))                                                      //  |
                                {   stepFlag=1;                                                                                         //  |
                                    readKey[a]['count']=0;                                                                              //  |
                                }else{ stepFlag=0; }                                                                                    //  |
                            }                                                                                                           //  |
                        }                                                                                                               //  | 
                    }                                                                                                                   //  |
                    this.tempsolr[thisKey]=this.Solution_real[showKey];                                                                 //  |
                    this.tempsoli[thisKey]=this.Solution_imag[showKey];                                                                 //  |
                }                                                                                                                       //  |
            }                                                                                                                           //  |
            DOM_Object[this.Format_id]['real']=JSON.parse(JSON.stringify(this.tempsolr));												//  |
			DOM_Object[this.Format_id]['imag']=JSON.parse(JSON.stringify(this.tempsoli));												//  |
            this.Solution_real=JSON.parse(JSON.stringify(this.tempsolr));																//  |
			this.Solution_imag=JSON.parse(JSON.stringify(this.tempsoli));																//  |
			console.log('I just set the new matrix to ...');
			console.log(this.Solution_real);
			if ((newIndexFlag==1)||(bigMatrixFlag==1)){  resolveMatrix(this.Format_id);  }                                              //  |
		}																																//  |
	}																																	//  |
	if (typeof(callback)=="function") { callback();	}																					//  |
};																																		//  |
/*-----------------------------------------------------------------------------------------------------------------------------------------*/

/*-----------------------------------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------ SPLIT THE INDEXES UP BY THEIR BRACKETS -------------------------------------------------------*/
/*-----------------------------------------------------------------------------------------------------------------------------------------*/
/*  This function takes in the string that is sent as the series of indexes in the above function and then returns the contents of each     |
    bracket as an array. This is done by simply breaking up the text and then recombining the parts inside the brackets.                    |
/*-----------------------------------------------------------------------------------------------------------------------------------------*/
function splitBrackets(text)																											//	|
{	var inputArray=new Array(), numArray=new Array(), flip=0, bcount=0, pcount=0;		                   								//	|
    text=text.replace(/^[a-zA-Z0-9\_]+/,'');                                                                                            //  |
    inputArray=SplitText(text)																											//	|
	for (var a=0; a<inputArray.length; a++)																								//	|
	{	if (inputArray[a]=="(") { flip=1; bcount=parseInt(bcount, 10)+1; }																//	| 
		if (inputArray[a]=="[") { flip=1; pcount=parseInt(pcount, 10)+1; }																//	|
		if (inputArray[a]==")") { bcount=bcount-1; }																					//	|
		if (inputArray[a]=="]") { pcount=pcount-1; }																					//	|
		if (((inputArray[a]==")")||(inputArray[a]=="]"))&&((bcount===0)&&(pcount===0))) { flip=0; }								       	//	|
		if (flip==1) { numArray[a]=1; }else{ numArray[a]=0; }																		    //	|
	}																																	//	|
	for (var i = inputArray.length; i >0; i--) 																							//	| 
	{	if (((numArray[i] == '1')&&(numArray[parseInt(i, 10)-1] == '1'))||((numArray[parseInt(i, 10)-1] == '1')&&(inputArray[i]=="]"))||((numArray[parseInt(i, 10)-1] == '1')&&(inputArray[i]==")")))
		{	inputArray[i-1]=inputArray[i-1]+inputArray[i];																				//	|
			inputArray.splice(i, 1); 																									//	|
			numArray.splice(i, 1); 																										//	| 
	}	}																																//	| 	
	for (var i = inputArray.length; i >=0; i--)                                                                                         //  |
    {   if ((inputArray[i]==',')||(inputArray[i]==' ')||(inputArray[i]===''))                                                           //  |
        {   inputArray.splice(i, 1);                                                                                                    //  |
    }	}	                                                                                                                            //	| 	
	return inputArray;																													//	|
}																																		//	|
/*-----------------------------------------------------------------------------------------------------------------------------------------*/

/*-----------------------------------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------ CHECK INPUT FOR MULTIPLE ENTRIES -------------------------------------------------------------*/
/*-----------------------------------------------------------------------------------------------------------------------------------------*/
/*  This function takes in the string that is sent as an index to the function above. The function takes the string and splits it at the    |
    semicolons. It then recombines the string to ensure that an entry is not parsed at an inappropriate part.                               |
/*-----------------------------------------------------------------------------------------------------------------------------------------*/
function splitColons(text)																												//	|
{	text=text.replace(/^\[/,'').replace(/\]$/,'');                                                                                      //  |
    var inputArray=new Array(), numArray=new Array(), flip=0, bcount=0, pcount=0;		                   								//	|
    inputArray=SplitText(text)																											//	|
	for (var a=0; a<inputArray.length; a++)																								//	|
	{	if (inputArray[a]=="(") { flip=1; bcount=parseInt(bcount, 10)+1; }																//	| 
		if (inputArray[a]=="[") { flip=1; pcount=parseInt(pcount, 10)+1; }																//	|
		if (inputArray[a-1]==")") { bcount=bcount-1; }																					//	|
		if (inputArray[a-1]=="]") { pcount=pcount-1; }																					//	|
		if (((inputArray[a-1]==")")||(inputArray[a-1]=="]"))&&((bcount===0)&&(pcount===0))) { flip=0; }									//	|
		if (flip==1) { numArray[a]=1; }																									//	|
	}																																	//	|
	for (var i = inputArray.length; i >0; i--) 																							//	| 
	{	if ((numArray[i] == '1')&&(numArray[parseInt(i, 10)-1] == '1'))																	//	|
		{	inputArray[i-1]=inputArray[i-1]+inputArray[i];																				//	|
			inputArray.splice(i, 1); 																									//	|
			numArray.splice(i, 1); 																										//	| 
	}	}																																//	| 	
	for (var i = inputArray.length; i >=0; i--)                                                                                         //  |
    {   if ((inputArray[i]==',')||(inputArray[i]==' ')||(inputArray[i]===''))                                                           //  |
        {   inputArray.splice(i, 1);                                                                                                    //  |
    }	}	                                                                                                                            //	| 	
	for (var i = inputArray.length-1; i >0; i--)                                                                                        //  |
    {   if ((inputArray[i]!=':')&&(inputArray[i-1]!=':'))                                                                               //  |
        {   inputArray[i-1]=inputArray[i-1]+''+inputArray[i];                                                                           //  |
            inputArray.splice(i, 1);                                                                                                    //  |
    }	}	                                                                                                                            //	| 	
	return inputArray;																													//	|
}																																		//	|
/*-----------------------------------------------------------------------------------------------------------------------------------------*/

/*-----------------------------------------------------------------------------------------------------------------------------------------*/
/*----------------------------------------------------------- RESOLVE MATRIX --------------------------------------------------------------*/
/*-----------------------------------------------------------------------------------------------------------------------------------------*/
/*	This function takes in an equation id and looks at the matrix to see if its size is correct and that every index has an entry.			|
	This is done by looping through each index and finding the highest value for each index. Once that is done, the matrix is looped 		|
	through again and any unset indices are set. The size is also reset. This function is called whenever a matrices indices are changed.   |
/*-----------------------------------------------------------------------------------------------------------------------------------------*/
function resolveMatrix(id, callback)	           	               																		//	| 
{	var thisIndex='', sizeObj={}, newSize='', numIndices=1, thisKey='', stepFlag=0, numIndices=1, tempKey='', tempIndex=0;              //  |
    for (var realNum in self[id]['Solution_real'])	     	       																		//	| 
	{   thisIndex=realNum.split('-');                                                                                                   //  |
        for (var a in thisIndex)                                                                                                        //  |
        {   if (sizeObj[a]===undefined)     { sizeObj[a]={};          sizeObj[a]['count']=0;         sizeObj[a]['size']=0; }            //  |
            if (thisIndex[a]>sizeObj[a]['size'])    { sizeObj[a]['size']=thisIndex[a]; }                                                //  |
        }                                                                                                                               //  |
    }                                                                                                                                   //  |
    for (var a=0; a<Object.keys(sizeObj).length; a++)                                                                                   //  |
    {   if (a==0){ newSize=parseInt(sizeObj[a]['size'])+1; }else{ newSize=newSize+'x'+(parseInt(sizeObj[a]['size'])+1); }  }            //  |
    for (var a=0; a<Object.keys(sizeObj).length; a++){ numIndices=numIndices*(parseInt(parseInt(sizeObj[a]['size'])+1));  }             //  |
    for (index=0; index<numIndices; index++)                                                                                            //  |
    {   thisKey='';                                                                                                                     //  |
        stepFlag=0;                                                                                                                     //  |
        for (a=Object.keys(sizeObj).length-1; a>=0; a--)                                                                                //  |
        {   if (a==Object.keys(sizeObj).length-1){thisKey=sizeObj[a]['count']; }else{ thisKey=sizeObj[a]['count']+'-'+thisKey; }  }     //  |
        if (self[id]['Solution_real'][thisKey]===undefined)                                                                             //  |
        {   tempKey=thisKey.replace(/\-[0-9]+$/,'');                                                                                    //  |
            if (self[id]['Solution_real'][tempKey]===undefined)                                                                         //  |
            {       self[id]['Solution_real'][thisKey]=self[id]['Solution_realdefault'];                                                //  |
            }else                                                                                                                       //  |
            {   tempIndex=thisKey.match(/[0-9]+$/);                                                                                     //  |
                if (tempIndex[0]==0)                                                                                                    //  |
                {       self[id]['Solution_real'][thisKey]=self[id]['Solution_real'][tempKey];                                          //  |
                }else { self[id]['Solution_real'][thisKey]=self[id]['Solution_realdefault'];      }                                     //  |
            }                                                                                                                           //  |
        }else { self[id]['Solution_real'][thisKey]=self[id]['Solution_real'][thisKey];        }                                         //  |
        if (self[id]['Solution_imag'][thisKey]===undefined)                                                                             //  |
        {   tempKey=thisKey.replace(/\-[0-9]+$/,'');                                                                                    //  |
            if (self[id]['Solution_imag'][tempKey]===undefined)                                                                         //  |
            {       self[id]['Solution_imag'][thisKey]=self[id]['Solution_imagdefault'];                                                //  |
            }else                                                                                                                       //  |
            {   tempIndex=thisKey.match(/[0-9]+$/);                                                                                     //  |
                if (tempIndex[0]==0)                                                                                                    //  |
                {       self[id]['Solution_imag'][thisKey]=self[id]['Solution_imag'][tempKey];                                          //  |
                }else { self[id]['Solution_imag'][thisKey]=self[id]['Solution_imagdefault'];      }                                     //  |
            }                                                                                                                           //  |
        }else { self[id]['Solution_imag'][thisKey]=self[id]['Solution_imag'][thisKey];        }                                         //  |
        for (a=Object.keys(sizeObj).length-1; a>=0; a--)                                                                                //  |
        {   if (a==Object.keys(sizeObj).length-1)                                                                                       //  |
            {   sizeObj[a]['count']=parseInt(sizeObj[a]['count'])+1;                                                                    //  |
                if (sizeObj[a]['count']>parseInt(sizeObj[a]['size']))                                                                   //  |
                {   stepFlag=1;                                                                                                         //  |
                    sizeObj[a]['count']=0;                                                                                              //  |
                }                                                                                                                       //  |
            }else                                                                                                                       //  |
            {   if (stepFlag==1)                                                                                                        //  |
                {   sizeObj[a]['count']=parseInt(sizeObj[a]['count'])+1;                                                                //  |
                    if (sizeObj[a]['count']>parseInt(sizeObj[a]['size']))                                                               //  |
                    {   stepFlag=1;                                                                                                     //  |
                        sizeObj[a]['count']=0;                                                                                          //  |
                    }else{ stepFlag=0; }                                                                                                //  |
                }                                                                                                                       //  |
            }                                                                                                                           //  | 
        }                                                                                                                               //  |
    }                                                                                                                                   //  |
    DOM_Object[id]['real']=JSON.parse(JSON.stringify(self[id]['Solution_real']));						         						//  |
	DOM_Object[id]['imag']=JSON.parse(JSON.stringify(self[id]['Solution_imag']));				          								//  |
    self[id]['Format_size']=newSize;                                                                                                    //  |
    DOM_Object[id]['size']=newSize;                                                                                                     //  |
 if (typeof(callback)=="function") { callback();	}																					//	|
}																																		//	| 
/*-----------------------------------------------------------------------------------------------------------------------------------------*/
/*-----------------------------------------------------------------------------------------------------------------------------------------*/
/*-----------------------------------------------------------------------------------------------------------------------------------------*/


/*-----------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------- FORMAT FRACTIONS -------------------------------------------------------------------------*/
/*-----------------------------------------------------------------------------------------------------------------------------------------*/
/*	This program looks at the object array and formats the fractions to be shown in MathJax. This is done by stepping through the 			\
	object array and finding any division signs. For the ones found, it looks for any parenthesis on either side and matches those. 		\
	It then inserts the formatting for MathJax																								\
/*-----------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Format_Fractions = function(callback) 
{ 
	for (a=0; a<this.Solution_variable_array.length; a++)
	{
		var opencount=0; var closecount=0; 
		if (this.Solution_variable_array[a]=="/")
		{ 
			this.Solution_variable_array[a]="}{";
			if (this.Solution_variable_array[a-1]==")")
			{ 
				this.Solution_variable_array[a]=this.Solution_variable_array[a].replace("}","");
				this.Solution_variable_array[a-1]="}";
				var closepar=0; var flag=0; var index=a-2;
				while ((flag===0)&&(index>=0))
				{ 
					if ((this.Solution_variable_array[index]=="(")&&(closepar===0)) 
					{  
						flag=1;
						this.Solution_variable_array[index]="\\frac{"; 
					}else if (this.Solution_variable_array[index]=="(") { closepar=closepar-1;
					}else if (this.Solution_variable_array[index]==")") { closepar=closepar+1; }
					index=index-1;
				} 
			}else
			{	if (a<2) 
				{	this.Solution_variable_array.splice(0, 0, "\\frac{"); 
					this.Solution_key_array.splice(0, 0, "\\frac{"); 
					a=a+1;
				}else 
				{	this.Solution_variable_array.splice(a-1, 0, "\\frac{"); 
					this.Solution_key_array.splice(a-1, 0, "\\frac{"); 
					a=a+1;
				} 
			} 
			if (this.Solution_variable_array[a+1]=="(")
			{	var closepar=0; var flag=0; var index=a+2;
				this.Solution_variable_array[a]=this.Solution_variable_array[a].replace('{',''); 
				this.Solution_variable_array[a+1]="{";
				while ((flag===0)&&(index<=this.Solution_variable_array.length-1))
				{	if ((this.Solution_variable_array[index]==")")&&(closepar===0)) 
					{	flag=1;
						this.Solution_variable_array[index]="}"; 
					}else if (this.Solution_variable_array[index]==")") { closepar=closepar-1;
					}else if (this.Solution_variable_array[index]=="(") { closepar=closepar+1; }
					index=index+1;
				} 
			}else
			{	this.Solution_variable_array.splice(a+2, 0, "}"); 
	}	}	} 
	if (typeof(callback)=="function") { callback();	}
};
//-----------------------------------------------------------------------------------------------------------------------------------------//

//-----------------------------------------------------------------------------------------------------------------------------------------//
//---------------------------------------- SHOW FRACTION ----------------------------------------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------------------------//
/*
This function takes in a string that is either the units or an equation. It then goes through the string and formats any divisions to 
be shown in MathJax. The proper MathJax syntax is \frac{x}{y} where the user simply enters x/y
*/
function Show_Fraction(string)
{
	if (string)
	{	var test=string.match(/[0-9,a-z,A-Z,\.,\^,\-,\*,\s,\(,\)]+\/[0-9,a-z,A-Z,\.,\^,\-,\*,\s,\(,\)]+/);
		while (test)
		{	var spliteq=test[0].split("/");
			var num=spliteq[0];
			var den=spliteq[1];
			var newstring="\\frac{"+num+"}{"+den+"}";
			string=string.replace(test,newstring);
			test=string.match(/[0-9,a-z,A-Z,\.,\^,\-,\*,\s]+\/[0-9,a-z,A-Z,\.,\^,\-,\*,\s]+/);
		}
		test=string.match(/\//);
		while (test)
		{	var index=string.indexOf("/");
			if (string.charAt(index-1)==")")
			{	var closecount=0; 
				var startindex=0;
				for (a=index-2; a>=0; a--)
				{	if (string.indexOf(a)==")") { closecount=closecount+1; }
					if (string.indexOf(a)=="(") { closecount=closecount-1; if (closecount===0) { startindex=a; break; } }
				}
				var num=string.substr(startindex, index-startindex);
			}
			if (string.charAt(index+1)=="(")
			{	var opencount=0; 
				var endindex=string.length-1;
				for (a=index+2; a<=endindex; a++)
				{	if (string.indexOf(a)=="(") { opencount=opencount+1; }
					if (string.indexOf(a)==")") { opencount=opencount-1; if (opencount===0) { endindex=a; break; } }
				}
				var den=string.substr(index+1, endindex-index);
			}
			string=string.replace(num,'');
			string=string.replace(den, "\\frac{"+num+"}{"+den+"}");
			test=string.match(/\//);
		}
	}
	return string;
}
//-----------------------------------------------------------------------------------------------------------------------------------------//


//-----------------------------------------------------------------------------------------------------------------------------------------//
//---------------------------------------------- SHOW EQUATION ----------------------------------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------------------------//
/*
The last function called in the formatting of the equation, this function looks at each object in the equation's array and displays the 
proper item. If the object was originally a number, then it display's a number. If it was a subequation or built in, then the proper 
text is shown. If it is a matrix, then the matrix is shown and if it was a vector then the vector text is shown.  If this is the top 
equation, then the result is also shown.
*/
Equation.prototype.Show_Equation = function(callback)
{
	if ((this.Format_showtype=="top")||(this.Format_showtype=="builtin")||(this.Format_showtype=="InnerFunction"))
	{
		var equation=""; 
		for (var a=0; a<this.Solution_variable_array.length; a++)
		{
			if (typeof(self[this.Solution_variable_array[a]])=="object")
			{	if ((self[this.Solution_variable_array[a]].Format_showvalue=="Negative")||(self[this.Solution_variable_array[a]].Format_showvalue=="FirstNeg")) 		
				{ self[this.Solution_variable_array[a]].Format_showvalue=="default"; this.Solution_variable_array.splice(a+1,1); }
//console.log('The variable array is '+this.Solution_variable_array[a]+' and the show equation is '+self[this.Solution_variable_array[a]].Format_showequation);
				equation=equation+self[this.Solution_variable_array[a]].Format_showequation;										 
			}else { equation=equation+this.Solution_variable_array[a]; } 
		} 
		if (this.Errors_flag==1) 
		{		this.Format_showequation="\\text{"+this.Errors_errors[0]+"}";
		}else { this.Format_showequation=equation; }
	}
	if (this.Format_type=="5") { this.Format_left+""; }
	if (typeof(callback)=="function") { callback();	}
};
//-----------------------------------------------------------------------------------------------------------------------------------------//

/*-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*--------------------------------------------------------------- SHOW SOLUTION -----------------------------------------------------------------------------------------------*/
/*-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	This function displays the solution only after the show equation has been formatted in the above function. This function is called whenever the user changes how the 		\
	solution is to be displayed. This could be changing the display from the solution to the size or vice versa. As of now, the name, equation, and solution are held is 		\
	separate properties of the equation object and brought together when being displayed.																						\
/*-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Show_Solution = function(callback)
{	var solution='';	var isol='';	var real=0; var imag=0;		var addon='';	var showu='';
	if (this.Format_showtype=="top")
	{	if (this.Units_showunits==='') { this.Units_showunits=this.Units_units; }
		if (this.Format_size=="1x1")
		{	real=this.Solution_real['0-0'];		imag=this.Solution_imag['0-0']; 
			if (this.Units_units==='') 
			{	if ((imag===0)||(imag==='')||(imag===NaN)||(isNaN(imag)))
					{ solution=real+"\\hspace{1mm}"; 																												 
				}else if (imag>0) { solution=real+"+"+imag+"i\\hspace{1mm}";
				}else if (imag<0) { solution=real+""+imag+"i\\hspace{1mm}";	}
				solution=solution+Show_Fraction(this.Units_units); 
			}else
			{	if (scaleUnits[this.Units_showunits]) 
				{	var cv=Big(scaleUnits[this.Units_showunits]['conv_factor']);	showu=this.Units_showunits;
					if (this.Units_showunits=="C"){ solution=Big(real).minus(Big(273.15)); 			showu="^{\\circ} C";
					}else if (this.Units_showunits=="F"){ solution=parseFloat(Big(real).times(Big(9).div(Big(5))).minus(459.67));	showu="^{\\circ} F";	
					}else if (this.Units_showunits=="R"){ solution=parseFloat(Big(real).div(Big(0.555555555555))); 	showu="^{\\circ} R";
					}else if (this.Units_showunits=="K"){ solution=real;						 	showu="K";
					}else{	solution=Big(real).div(cv);	 }
					if ((imag===0)||(imag==='')||(imag===NaN)||(isNaN(imag)))	{	addon='';	isol='';															 
					}else 
					{	if (this.Units_showunits=="C"){ isol=parseFloat(Big(imag).minus(Big(273.15))); 
						}else if (this.Units_showunits=="F"){ isol=parseFloat(Big(imag).times(Big(9)).div(Big(5)).minus(459.67));
						}else if (this.Units_showunits=="R"){ isol=parseFloat(Big(imag).div(Big(0.555555555555)));
						}else if (this.Units_showunits=="K"){ isol=imag;						 
						}else{	isol=parseFloat(Big(imag).div(cv));	}
					}
					if (imag>0) { addon="+";	}else if (imag<0) { addon="-"; }		
					solution=solution+addon+isol+"\\hspace{1mm}"+Show_Fraction(showu);
				}else
				{	if (this.Solution_convsol==='')
					{	if ((imag===0)||(imag==='')||(imag===NaN)||(isNaN(imag)))
						{	solution=real+"\\hspace{1mm}"; 																											 
						}else if (imag>0) { solution=real+"+"+imag+"i";
						}else if (imag<0) { solution=real+""+imag+"i";	}																						
						if (this.Units_showunits==='') { solution=solution+"\\hspace{1mm}"+Show_Fraction(this.Units_units);
						}else { solution=solution+"\\hspace{1mm}"+Show_Fraction(this.Units_showunits);	}
					}else
					{	if ((imag===0)||(imag==='')||(imag===NaN)||(isNaN(imag)))
						{	solution=ToNum(real/this.Solution_convsol)+"\\hspace{1mm}"; 																			 
						}else if (imag>0) { solution=parseFloat(Big(real).div(Big(this.Solution_convsol)))+"+"+parseFloat(Big(imag).div(Big(this.Solution_convsol)))+"i";
						}else if (imag<0) { solution=parseFloat(Big(real).div(Big(this.Solution_convsol)))+""+parseFloat(Big(imag).div(Big(this.Solution_convsol)))+"i"; }	
						solution=solution+"\\hspace{1mm}"+Show_Fraction(this.Units_showunits);
					}
				}
			}
		}else																																								//	
		{
			if ((this.Format_showvalue=="default")||(this.Format_showvalue=="size")||(ToNum(this.Format_numinds)>2))
			{
				solution=this.Format_size; 
			}else if (this.Format_showvalue=="value")
			{	this.Solution_showarray={};
				if (this.Units_showunits==='')
				{	for (var i in this.Solution_real)	 
					{ 	if (this.Solution_real[i]!=undefined)
						{	if (this.Solution_imag[i]!==undefined)
							{	if (parseFloat(this.Solution_imag[i])>0){ 
									this.Solution_showarray[i]=this.Solution_real[i]+' + '+this.Solution_imag[i]+'i'; 
								}else if (parseFloat(this.Solution_imag[i])<0) {
									this.Solution_showarray[i]=this.Solution_real[i]+''+this.Solution_imag[i]+'i'; 
								}else {	if(typeof(self[this.Solution_real[i]])=="object"){ 
													this.Solution_showarray[i]=self[this.Solution_real[i]]['Format_showequation'];
											}else { this.Solution_showarray[i]=this.Solution_real[i]; 	}	}
							}else {	if (this.Solution_imagdefault===0) { if(typeof(self[this.Solution_real[i]])=="object"){ 
																						this.Solution_showarray[i]=self[this.Solution_real[i]]['Format_showequation']; 
																					}else { this.Solution_showarray[i]=this.Solution_real[i];}
									}else { 	this.Solution_showarray[i]=this.Solution_real[i]+'+'+this.Solution_imagdefault+'i'; }
							}
						}else
						{	if (this.Solution_imag[i]!==undefined)
							{ 		this.Solution_showarray[i]=this.Solution_realdefault+'+'+this.Solution_imag[i];
							}else {	this.Solution_showarray[i]=this.Solution_realdefault+' '+this.Solution_imagdefault;	}
						}
					}
					solution=ShowMatrix(this.Format_id); 
					solution=solution+"\\hspace{1mm}"+Show_Fraction(this.Units_units); 
				}else
				{	if (scaleUnits[this.Units_showunits]!==undefined) 
					{	var cv=scaleUnits[this.Units_showunits]['conv_factor'];		solution='';	showu=this.Units_showunits;
						for (var i in this.Solution_real)	 
						{ 	if (this.Solution_real[i]!=undefined)
							{	real=this.Solution_real[i];		imag=this.Solution_imag[i];
								if (parseFloat(this.Solution_imag[i])>0){ addon="+"; 
								}else if (parseFloat(this.Solution_imag[i])<0) { addon=""; }else {addon=''; }
								if (this.Units_showunits=="C"){ this.Solution_showarray[i]=Big(real).minus(Big(273.15)); 	showu="^{\\circ} C";
								}else if (this.Units_showunits=="F"){ this.Solution_showarray[i]=parseFloat(Big(real).times(Big(9).div(Big(5))).minus(459.67));	showu="^{\\circ} F";
								}else if (this.Units_showunits=="R"){ this.Solution_showarray[i]=parseFloat(Big(real).div(Big(0.555555555555))); showu="^{\\circ} R";
								}else if (this.Units_showunits=="K"){ this.Solution_showarray[i]=real;		showu="K";
								}else{	this.Solution_showarray[i]=parseFloat(Big(real).div(cv));	 }
								if ((imag===0)||(imag==='')||(imag===NaN)||(isNaN(imag)))	{	addon='';	isol='';													 
								}else 
								{	if (this.Units_showunits=="C"){ isol=Big(imag).minus(Big(273.15));
									}else if (this.Units_showunits=="F"){ isol=parseFloat(Big(imag).times(Big(9).div(Big(5))).minus(459.67));
									}else if (this.Units_showunits=="R"){ isol=parseFloat(Big(imag).div(Big(0.555555555555))); 
									}else if (this.Units_showunits=="K"){ isol=imag;						 
									}else{	isol=parseFloat(Big(imag).div(cv));	}
									this.Solution_showarray[i]=this.Solution_showarray[i]+''+addon+''+isol;
								}
							}else
							{	if (this.Solution_imag[i]!=undefined)
								{ 		this.Solution_showarray[i]=parseFloat(Big(this.Solution_realdefault).div(Big(cv)))+' '+parseFloat(Big(this.Solution_imag[i]).div(Big(cv)));			
								}else {	this.Solution_showarray[i]=parseFloat(Big(this.Solution_realdefault).div(Big(cv)))+' '+parseFloat(Big(this.Solution_imagdefault).div(Big(cv)));	}	
							}
						}
						solution=ShowMatrix(this.Format_id); 
						solution=solution+"\\hspace{1mm}"+Show_Fraction(showu); 
					}else
					{	for (var i in this.Solution_real)	 
						{ 	if (this.Solution_real[i]!=undefined)
							{	real=this.Solution_real[i];		imag=this.Solution_imag[i];
								if (this.Solution_imag[i]>0){ addon="+"; }else if (this.Solution_imag[i]<0) { addon="-"; }else {addon=''; }
								if ((imag===0)||(imag==='')||(imag===NaN)||(isNaN(imag)))
								{	addon='';	isol='';					 
									this.Solution_showarray[i]=real;
								}else 
								{	this.Solution_showarray[i]=this.Solution_showarray[i]+''+addon+''+isol;		}
							}else
							{	if (this.Solution_imag[i]!=undefined)
								{ 		this.Solution_showarray[i]=parseFloat(Big(this.Solution_realdefault).div(Big(cv)))+' '+parseFloat(Big(this.Solution_imag[i]).div(Big(cv)));		
								}else {	this.Solution_showarray[i]=parseFloat(Big(this.Solution_realdefault).div(Big(cv)))+' '+parseFloat(Big(this.Solution_imagdefault).div(Big(cv)));	}
							}
						}
						solution=ShowMatrix(this.Format_id); 
						if (this.Units_showunits==='') { solution=solution+"\\hspace{1mm}"+Show_Fraction(this.Units_units); 
						}else { solution=solution+"\\hspace{1mm}"+Show_Fraction(this.Units_units); }
					}
				}
			} 
		} 
		this.Format_showsolution=solution;
	this.Solving=0;
	} 
	if (typeof(callback)=="function") { callback();	}
};	
/*-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/


//-----------------------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------- SHOW ARRAY ---------------------------------------------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------------------------//
/*
	This function looks at the equation and formats any arrays in it for MathJax. 
*/
Equation.prototype.Show_Array = function(callback)
{	var variable='', temp='';
//	var splittext=this.Format_showequation.split(';');
//	for (var a=0; a<splittext.length; a++) 
//	{	if (typeof(self[splittext[a].replace(/\[|\]/,'')])=="object") { temp=self[splittext[a].replace(/\[|\]/,'')].Format_showequation;
//		}else { temp=splittext[a]; }
//		variable=variable+''+temp; }
	variable=this.Format_showequation.replace(/\[/g,"\\begin{bmatrix}");
	variable=variable.replace(/\]/g,"\\end{bmatrix}");
	variable=variable.replace(/,/g,"&");
	variable=variable.replace(/;/g,";;");
	variable=variable.replace(/;/g,"\\");
	this.Format_showequation=variable;
	if (typeof(callback)=="function") { callback();	}
};
//-----------------------------------------------------------------------------------------------------------------------------------------//


//-----------------------------------------------------------------------------------------------------------------------------------------//
//----------------------------------------------------- SHOW MATRIX -----------------------------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------------------------//
/*
This function is called in the Show_Equation method. It simply returns the formatted matrix solution of an equation. If subcomponents 
are given, it only returns those. Note that you cannot show more than two dimensions at a time, so the code limits the user to that amount.
*/
function ShowMatrix(id)
{
	var splitinds=self[id].Format_size.split('x');
	if ((splitinds.length>2)&&(this.Format_showvalue=="value")) 
	{  
		// This should produce an error and the entire algorithm needs to be updated later to account for components removing an index. The purpose here is to ensure that
		// the user isn't trying to show more than two dimensions. If he knocks down some dimensions, then the code needs to account for this.
	}else							
	{ 
		var matrixtext="\\begin{bmatrix}";
		for (var a=0; a<splitinds[0]; a=a+1)
		{ 
			for (var b=0; b<splitinds[1]; b=b+1)
			{ 
				key=a+'-'+b;
				if (self[id].Solution_showarray[key]!==undefined)
				{ 	matrixtext=matrixtext+self[id].Solution_showarray[key];
				}else 
				{	if (self[id].Solution_imagdefault===0)
					{ 		matrixtext=matrixtext+self[id].Solution_realdefault;
					}else 
					{	if (self[id].Solution_imagdefault>0) 
						{ 		matrixtext=matrixtext+self[id].Solution_realdefault+'+'+self[id].Solution_imagdefault+'i';
						}else { matrixtext=matrixtext+self[id].Solution_realdefault+''+self[id].Solution_imagdefault+'i';}
					}
				}
				if (b<(splitinds[1]-1)) { matrixtext=matrixtext+"&"; }
			} 
			matrixtext=matrixtext+"\\";
			matrixtext=matrixtext+"\\";
		}
		matrixtext=matrixtext+"\\end{bmatrix}";
	} 
	return matrixtext;
} 
//-----------------------------------------------------------------------------------------------------------------------------------------//

//-----------------------------------------------------------------------------------------------------------------------------------------//
//---------------------------------------------------- EQUATION CLEANUP -------------------------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------------------------//
/*
This function goes through and cleans up after the equation has been completed. It deletes any temporary equations that were created 
during the solution process andremoves them from both the window memory and the DOM_Object array.
*/
Equation.prototype.Equation_Cleanup = function(callback)
{	//console.log('In the equation cleanup for '+this.Format_id+' - '+this.Format_equation);
	if (this.Format_showtype=="top")
	{
		for (var a=0; a<this.Solution_temps.length; a++)
		{	delete DOM_Object[this.Solution_temps[a]];
			delete self[this.Solution_temps[a]];
		}
		this.Solution_temps=new Array();
		if ((DOM_Object[this.Format_id]!==undefined)&&(DOM_Object[this.Format_id]['name']!="TempEq"))
		{	for (var i in DOM_Object) 
			{	if ((DOM_Object[i]['type']=="equation")||(DOM_Object[i]['type']===undefined))
				{	if ((DOM_Object[i]['name']=="undefined")||(DOM_Object[i]['name']===undefined)||(DOM_Object[i]['name']=="TempEq")||(DOM_Object[i]['name']=="Temp")||(DOM_Object[i]['name']=="NA"))
					{	
						console.log('I came in like a wrecking ball and deleted '+i+'-'+DOM_Object[i]['name']+' in the cleanup');
                        delete DOM_Object[i];
						delete self[i]; 
	}	}	}	}	}
	if (typeof(callback)=="function") { callback();	}
};
//-----------------------------------------------------------------------------------------------------------------------------------------//

//-----------------------------------------------------------------------------------------------------------------------------------------//
//---------------------------------------------------- RETURN EQUATION --------------------------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------------------------//
/*	
//-----------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Return_Equation = function(callback) 
{	console.log('In the return equation function with ids of '+this.Original_id+' and '+this.Format_id+', the parent is '+DOM_Object[this.Format_id]['parentid']+', the type is '+self[this.Format_id]['Format_showtype']+' the equation is '+DOM_Object[this.Format_id]['equation']+' and the solution is '+self[this.Format_id]['Solution_real']['0-0']+'-'+DOM_Object[this.Format_id]['Format_showequation']+'-'+DOM_Object[this.Format_id]['Format_showsolution']);
	
	var connected={};
	DOM_Object[this.Format_id]['real']=this['Solution_real'];
	DOM_Object[this.Format_id]['imag']=this['Solution_imag'];
	DOM_Object[this.Format_id]['size']=this['Format_size'];
	DOM_Object[this.Format_id]['name']=this['Format_name'];

	if ((this.Original_id==this.Format_id)&&(DOM_Object[this.Format_id]['parentid']=="none")&&(self[this.Format_id]['Format_showtype']=="top"))
	{	console.log('Hey, I just met you, and this is crazy, but I finished equation '+self[this.Original_id]['Format_equation']);
		if (eventType=="SolveTableCell")
		{	postMessage(
			{	"messageType":"TableCellResult",
				"Equation":this,
				"Deps":DOM_Object[this.Format_id]['Dependents'],
			});
		}else
		{	this.Dependents=DOM_Object[this.Format_id]['Dependents'];    
            if (Object.keys(self[this.Original_id]['connected_ids']).length>0) 
			{	for (var id in self[this.Original_id]['connected_ids']) { connected[id]=self[id]; } } 
			postMessage(
			{	"messageType":"EquationResult", 
				"id":this.Format_id, 
				"equation":this, 
				"Deps":DOM_Object[this.Format_id]['Dependents'],
				"connected":connected
			}); 
		}
	}else{	console.log('Hey, I just finished but didn\'t return '+self[this.Original_id]['Format_equation']+' because it had and original id of '+this.Original_id+' vs '+this.Format_id+', and parent id of '+DOM_Object[this.Format_id]['parentid']+' and showtype of '+self[this.Format_id]['Format_showtype']);	}
	if (typeof(callback)=="function") { callback();	}
};
//-----------------------------------------------------------------------------------------------------------------------------------------//

//-----------------------------------------------------------------------------------------------------------------------------------------//
//---------------------------------------------------- RETURN STRUCTURE -------------------------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------------------------//
/*	This is the function called when a loop or statement has ended and the results are to be sent back to the main program. The function	\
	builds an object containing the results, size, and show equation for each equation in the structure and sends a message containing that	\
	object to the main program.																												\
//-----------------------------------------------------------------------------------------------------------------------------------------*/
function Return_Structure(ID) 
{	console.log('The ID is '+ID);
	console.log('At the beginning of Return_Structure, the DOM_Object of the loop is ...');
	console.log(DOM_Object);
	console.log(DOM_Object[ID]);
	var returnObj={}, item='';
	for (var itemID in DOM_Object)
	{	
		console.log('For '+itemID+', the location is '+DOM_Object[itemID]['order']+', the location and lastpos are '+DOM_Object[ID]['order']+' - '+DOM_Object[ID]['Page_lastposition']);
        if ((DOM_Object[itemID]['order']>=DOM_Object[ID]['order'])&&(DOM_Object[itemID]['order']<=DOM_Object[ID]['Page_lastposition']))
		{	if (DOM_Object[itemID]['type']=="equation") 
			{	returnObj[itemID]={};
				returnObj[itemID]['type']="equation";
				returnObj[itemID]['Deps']=DOM_Object[itemID]['Dependents'];
				returnObj[itemID]['equationObj']=self[itemID];
			}
			if (DOM_Object[itemID]['type']=="ifelse") 
			{	returnObj[itemID]={};
				returnObj[itemID]['type']="ifelse";
				returnObj[itemID]['ifelseObj']=self[itemID];
			}
			if (DOM_Object[itemID]['type']=="forLoop") 
			{	returnObj[itemID]={};
				returnObj[itemID]['type']="forLoop";
				returnObj[itemID]['forloopObj']=self[itemID];
			}
			if (DOM_Object[itemID]['type']=="whileLoop") 
			{	returnObj[itemID]={};
				returnObj[itemID]['type']="whileLoop";
				returnObj[itemID]['whileLoopObj']=self[itemID];
			}
		}
	}
	postMessage({"messageType":"StructureResult", "ID":ID, "structure":returnObj});
};
//-----------------------------------------------------------------------------------------------------------------------------------------//


/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*-------------------------------------------------------------------------- Math Functions  --------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

//---------------------------------------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------------------------------ TO NUMBERS ---------------------------------------------------------------------------//
//---------------------------------------------------------------------------------------------------------------------------------------------------------//
function ToNum (num)	{	return parseFloat(parseFloat(num).toFixed(12));	}

//---------------------------------------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------------------- ADDING AND SUBTRACTING NUMBERS ------------------------------------------------------------------//
//---------------------------------------------------------------------------------------------------------------------------------------------------------//
/*
This is the function that is called whenever two objects are added to each other. It checks the quantities to ensure that they are the same. If they are 
the same, the two are added or subtracted. If not, the error system is kicked in.

For complex numbers, the algorithm follows the pattern: (a+bi)+(c+di) = a+c+(b+d)i
*/
function AddSubNumbers (id1, id2, operator, thisid)
{	
	console.log('In add sub numbers, the operator is '+operator+' and the values are ...');
	console.log(self[id1].Solution_real['0-0']+' - '+self[id1].Solution_imag['0-0']+' - '+self[id2].Solution_real['0-0']+' '+self[id2].Solution_imag['0-0']);

	if ((isNaN(self[id1].Solution_real['0-0']))||(self[id1].Solution_real['0-0']=='')) { self[id1].Solution_real['0-0']=0; } 
	if ((isNaN(self[id1].Solution_imag['0-0']))||(self[id1].Solution_imag['0-0']=='')) { self[id1].Solution_imag['0-0']=0; }
	if ((isNaN(self[id2].Solution_real['0-0']))||(self[id2].Solution_real['0-0']=='')) { self[id2].Solution_real['0-0']=0; } 
	if ((isNaN(self[id2].Solution_imag['0-0']))||(self[id2].Solution_imag['0-0']=='')) { self[id2].Solution_imag['0-0']=0; }
    if (self[id1].Units_base_string!=self[id2].Units_base_string)
	{
		if (operator=="+") { Set_Error(thisid, "Math1", id1, id2); }
		if (operator=="-") { Set_Error(thisid, "Math2", id1, id2); }
		return "Error";
	}else
	{	if (operator=="+") { 	var real=Big(self[id1].Solution_real['0-0']).plus(Big(self[id2].Solution_real['0-0']));
								var imag=Big(self[id1].Solution_imag['0-0']).plus(Big(self[id2].Solution_imag['0-0']));		}
		if (operator=="-") { 	var real=Big(self[id1].Solution_real['0-0']).minus(Big(self[id2].Solution_real['0-0']));
								var imag=Big(self[id1].Solution_imag['0-0']).minus(Big(self[id2].Solution_imag['0-0']));	}
		var units=self[id1].Units_units;
		var quantity=self[id1].Units_quantity;
	}
	var eqobj={Page_position:parseInt(self[id1].Page_position, 10), Format_showtype:"InnerFunction", equation:"TempEq=0"};
	var id=CreateEq(self[thisid]['fileid'], 0, eqobj);

    self[id].Format_showequation='('+self[id1].Format_showequation+operator+self[id2].Format_showequation+')';
	self[id].Solution_real['0-0']=parseFloat(real);
	self[id].Solution_imag['0-0']=parseFloat(imag);
	self[id].Units_base_array=self[id1].Units_base_array;
	self[id].Units_base_string=self[id1].Units_base_string;
	self[id].Units_units=self[id1].Units_units;
	self[id].Units_quantity=self[id1].Units_quantity; 
	self[id].Format_size="1x1";
	self[thisid].Solution_temps.push(id);
	return id;
}
//---------------------------------------------------------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------------------- MULTIPLYING AND DIVIDING NUMBERS ----------------------------------------------------------------//
//---------------------------------------------------------------------------------------------------------------------------------------------------------//
/*
	This function multiplies or divides two numbers with or without units. This is done by performing the math on the number for each item as it should 
	already be converted to the normalized SI units and then adding the units if it is multiplication or subtracting if it is division.
	For complex numbers, the multiplication algorithm follows the pattern: (a+bi)*(c+di)=ac+adi+bci+bdi^2=ac-bd+(ad+bc)i
	For division, the algorithm for complex numbers uses the complex conjugate : (a+bi)/(c+di)=((a+bi)*(c-di))/((c+di)*(c-di)) and is then divided out.
*/
function MultDivNumbers (id1, id2, operator, thisid)
{	
	console.log('In mult div numbers, the operator is '+operator+' and the values are ...');
	console.log(self[id1].Solution_real['0-0']+' - '+self[id1].Solution_imag['0-0']+' - '+self[id2].Solution_real['0-0']+' '+self[id2].Solution_imag['0-0']);
	var real1=0; var real2=0; var imag1=0; var imag2=0;	var real=0; var imag=0;
	if (self[id1].Solution_real['0-0']=='') { self[id1].Solution_real['0-0']=0; } 	                                                          
	if (self[id1].Solution_imag['0-0']=='') { self[id1].Solution_imag['0-0']=0; }				                                                        
	if (self[id2].Solution_real['0-0']=='') { self[id2].Solution_real['0-0']=0; } 			                                                            
	if (self[id2].Solution_imag['0-0']=='') { self[id2].Solution_imag['0-0']=0; }				                                                        
	if (self[id1].Solution_real['0-0']===undefined) { real1=self[id1].Solution_realdefault; }else { real1=self[id1].Solution_real['0-0'];} 
	if (self[id1].Solution_imag['0-0']===undefined) { imag1=self[id1].Solution_imagdefault; }else { imag1=self[id1].Solution_imag['0-0']; }
	if (self[id2].Solution_real['0-0']===undefined) { real2=self[id2].Solution_realdefault; }else { real2=self[id2].Solution_real['0-0']; } 
	if (self[id2].Solution_imag['0-0']===undefined) { imag2=self[id2].Solution_imagdefault; }else {imag2=self[id2].Solution_imag['0-0'];}
    if (operator=="*") { 	var r1=parseFloat(Big(real1).times(Big(real2))); 												 
							var r2=parseFloat(Big(imag1).times(Big(imag2))); 												 	
							var i1=parseFloat(Big(real1).times(Big(imag2))); 												 	
							var i2=parseFloat(Big(imag1).times(Big(real2)));														 
							if (isNaN(r1)) { real=r2; 	}else if (isNaN(r2)) { real=r1; }else { real=parseFloat(Big(r1).minus(Big(r2))); }
							if (isNaN(i1)) { imag=i2; 	}else if (isNaN(i2)) { imag=i1; }else { imag=parseFloat(Big(i1).minus(Big(i2))); }
							if (self[id1].Format_showvalue=="FirstNeg"){ imag=imag*-1 }												}	
	if (operator=="/") 
	{	
		console.log('');
		if (((imag1===0)&&(imag2===0))||((imag1===0)&&(isNaN(imag2)))||((isNaN(imag1))&&(imag2===0))||((isNaN(imag1))&&(isNaN(imag2))))
		{ 	real=parseFloat(Big(real1).div(Big(real2))); 
		 	imag=0;																										 
		}else
		{	
			var c=parseFloat(real2);
			var d=-1*parseFloat(imag2);
			var a1=real1;
			var b1=imag1;
			var a2=real2;
			var b2=imag2;
			var nr=parseFloat(Big(a1).times(Big(c)).minus(Big(b1).times(Big(d)))); 
			var ni=parseFloat(Big(a1).times(Big(d)).plus(Big(b1).times(Big(c)))); 
			var dr=parseFloat(Big(a2).times(Big(c)).minus(Big(b2).times(Big(d)))); 
			var di=parseFloat(Big(a2).times(Big(d)).minus(Big(b2).times(Big(c)))); 
		  	var real=parseFloat(Big(nr).div(Big(dr)));
		  	var imag=parseFloat(Big(ni).div(Big(dr)));
		}
	}
	var baseunits=new Array();
	for(var index in self[id1].Units_base_array) 
	{	if (operator=="*") { baseunits[index]=self[id1].Units_base_array[index]+self[id2].Units_base_array[index]; }
		if (operator=="/") { baseunits[index]=self[id1].Units_base_array[index]-self[id2].Units_base_array[index]; }
	}
	var eqobj={Page_position:DOM_Object[self[thisid].Format_id]['order'], Format_showtype:"InnerFunction", Original_id:thisid, equation:"TempEq=0"};
	var id=CreateEq(self[thisid]['fileid'], 0, eqobj);

	self[id].Solution_real['0-0']=real;
	self[id].Solution_imag['0-0']=imag;
	self[id].Units_base_array=baseunits;
	self[id].Solution_variable_array[0]=id;
	self[id].Get_My_BaseString();
	self[id].Format_size="1x1";
	return id;
}
//---------------------------------------------------------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------------------------- ADDING AND SUBTRACTING MATRICES ---------------------------------------------------------------//
//---------------------------------------------------------------------------------------------------------------------------------------------------------//
/*
This function is called whenever the user adds or subtracts matrices. It does the same as adding or subtracting two matrices with the addition of 
checking size issues. First, it checks to make sure that the base arrays match to ensure that the items being added make sense. Then it adds component
by component to each other and inserts the results to the proper component in the new equation item.
*/
function AddSubMatrices (id1, id2, operator, thisid)
{	
	self[id1].Get_My_BaseString();
	self[id2].Get_My_BaseString();
	console.log('In add sub matrices, the operator is '+operator+' and the values are ...');
	console.log(self[id1].Solution_real['0-0']+' - '+self[id1].Solution_imag['0-0']+' - '+self[id2].Solution_real['0-0']+' '+self[id2].Solution_imag['0-0']);
	console.log(self[id1].Units_base_string+' - '+self[id2].Units_base_string);

	var real1=0;	var imag1=0;	var real2=0;	var imag2=0;
	var realArray={};	var imagArray={};	var key='';
	if (self[id1].Units_base_string!=self[id2].Units_base_string)
	{
		if (operator=="+") { Set_Error(thisid, "Math1", id1, id2); }
		if (operator=="-") { Set_Error(thisid, "Math2", id1, id2); }
		return "Error";
	}else if (self[id1].Format_size!=self[id2].Format_size) 
	{ 
		if (operator=="+") { Set_Error(thisid, "Math3", id1, id2); }
		if (operator=="-") { Set_Error(thisid, "Math4", id1, id2); }
		return "Error";
	}else 
	{	var realkeys1=self[id1].Solution_real;
		var realkeys2=self[id2].Solution_real;
		var imagkeys1=self[id1].Solution_imag;
		var imagkeys2=self[id2].Solution_imag;
		for (var i in realkeys1)
		{	if ((realkeys1[i]===undefined)||(isNaN(realkeys1[i]))) { real1=self[id1].Solution_realdefault; }else { real1=realkeys1[i]; }
			if ((imagkeys1[i]===undefined)||(isNaN(imagkeys1[i]))) { imag1=self[id1].Solution_imagdefault; }else { imag1=imagkeys1[i]; }
			if ((realkeys2[i]===undefined)||(isNaN(realkeys2[i]))) { real2=self[id2].Solution_realdefault; }else { real2=realkeys2[i]; }
			if ((imagkeys2[i]===undefined)||(isNaN(imagkeys2[i]))) { imag2=self[id2].Solution_imagdefault; }else { imag2=imagkeys2[i]; }
			if (operator=="+") { realArray[i]=parseFloat(Big(real1).plus(Big(real2))); imagArray[i]=parseFloat(Big(imag1).plus(Big(imag2))); }
			if (operator=="-") { realArray[i]=parseFloat(Big(real1).minus(Big(real2))); imagArray[i]=parseFloat(Big(imag1).minus(Big(imag2))); }
			delete realkeys1[i];	delete realkeys2[i];	delete imagkeys1[i];	delete imagkeys2[i];
		}
		for (var i in realkeys2)
		{	if ((realkeys1[i]===undefined)||(isNaN(realkeys1[i]))) { real1=self[id1].Solution_realdefault; }else { real1=realkeys1[i]; }
			if ((imagkeys1[i]===undefined)||(isNaN(imagkeys1[i]))) { imag1=self[id1].Solution_imagdefault; }else { imag1=imagkeys1[i]; }
			if ((realkeys2[i]===undefined)||(isNaN(realkeys2[i]))) { real2=self[id2].Solution_realdefault; }else { real2=realkeys2[i]; }
			if ((imagkeys2[i]===undefined)||(isNaN(imagkeys2[i]))) { imag2=self[id2].Solution_imagdefault; }else { imag2=imagkeys2[i]; }
			if (operator=="+") { realArray[i]=parseFloat(Big(real1).plus(Big(real2))); imagArray[i]=parseFloat(Big(imag1).plus(Big(imag2))); }
			if (operator=="-") { realArray[i]=parseFloat(Big(real1).minus(Big(real2))); imagArray[i]=parseFloat(Big(imag1).minus(Big(imag2))); }
			delete realkeys1[i];	delete realkeys2[i];	delete imagkeys1[i];	delete imagkeys2[i];
		}
		for (var i in imagkeys1)
		{	if ((realkeys1[i]===undefined)||(isNaN(realkeys1[i]))) { real1=self[id1].Solution_realdefault; }else { real1=realkeys1[i]; }
			if ((imagkeys1[i]===undefined)||(isNaN(imagkeys1[i]))) { imag1=self[id1].Solution_imagdefault; }else { imag1=imagkeys1[i]; }
			if ((realkeys2[i]===undefined)||(isNaN(realkeys2[i]))) { real2=self[id2].Solution_realdefault; }else { real2=realkeys2[i]; }
			if ((imagkeys2[i]===undefined)||(isNaN(imagkeys2[i]))) { imag2=self[id2].Solution_imagdefault; }else { imag2=imagkeys2[i]; }
			if (operator=="+") { realArray[i]=parseFloat(Big(real1).plus(Big(real2))); imagArray[i]=parseFloat(Big(imag1).plus(Big(imag2))); }
			if (operator=="-") { realArray[i]=parseFloat(Big(real1).minus(Big(real2))); imagArray[i]=parseFloat(Big(imag1).minus(Big(imag2))); }
			delete realkeys1[i];	delete realkeys2[i];	delete imagkeys1[i];	delete imagkeys2[i];
		}
		for (var i in imagkeys2)
		{	if ((realkeys1[i]===undefined)||(isNaN(realkeys1[i]))) { real1=self[id1].Solution_realdefault; }else { real1=realkeys1[i]; }
			if ((imagkeys1[i]===undefined)||(isNaN(imagkeys1[i]))) { imag1=self[id1].Solution_imagdefault; }else { imag1=imagkeys1[i]; }
			if ((realkeys2[i]===undefined)||(isNaN(realkeys2[i]))) { real2=self[id2].Solution_realdefault; }else { real2=realkeys2[i]; }
			if ((imagkeys2[i]===undefined)||(isNaN(imagkeys2[i]))) { imag2=self[id2].Solution_imagdefault; }else { imag2=imagkeys2[i]; }
			if (operator=="+") { realArray[i]=parseFloat(Big(real1).plus(Big(real2))); imagArray[i]=parseFloat(Big(imag1).plus(Big(imag2))); }
			if (operator=="-") { realArray[i]=parseFloat(Big(real1).minus(Big(real2))); imagArray[i]=parseFloat(Big(imag1).minus(Big(imag2))); }
			delete realkeys1[i];	delete realkeys2[i];	delete imagkeys1[i];	delete imagkeys2[i];
		}
	} 

	var eqobj={Page_position:DOM_Object[thisid]['order'], Format_showtype:"InnerFunction", equation:"TempEq=0"};
	var id=CreateEq(this.fileid, 0, eqobj);
	self[id].Solution_real=realArray;
	self[id].Solution_imag=imagArray;
	self[id].Solution_realdefault=self[id1].Solution_realdefault+self[id2].Solution_realdefault;
	self[id].Solution_imagdefault=self[id1].Solution_imagdefault+self[id2].Solution_imagdefault;
	self[id].Units_units=self[id1].Units_units;
	self[id].Units_quantity=self[id1].Units_quantity;
	self[id].Units_base_array=self[id1].Units_base_array;
	self[id].Units_base_string=self[id1].Units_base_string;
	self[id].Format_size=self[id1].Format_size;
	self[id].Format_numinds=self[id1].Format_numinds;
	self[id].Get_My_BaseString();
	console.log('At the end of add sub matrices, the base array is ... ');
	console.log(self[id].Units_base_array);
	return id;
}
//---------------------------------------------------------------------------------------------------------------------------------------------------------//


//---------------------------------------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------------------------- MULTIPLY TWO MATRICES -------------------------------------------------------------------------//
//---------------------------------------------------------------------------------------------------------------------------------------------------------//
function MultMatrices (id1, id2, operator, thisid)
{	
	console.log('In mult matrices, the operator is '+operator+' and the values are ...');
	console.log(operator+' - '+self[id1].Solution_real['0-0']+' - '+self[id1].Solution_imag['0-0']+' - '+self[id2].Solution_real['0-0']+' - '+self[id2].Solution_imag['0-0']);

	if (self[id1].Solution_realdefault==undefined) { self[id1].Solution_realdefault=0; }
	if (self[id2].Solution_realdefault==undefined) { self[id2].Solution_realdefault=0; }
	if (self[id1].Solution_imagdefault==undefined) { self[id1].Solution_imagdefault=0; }
	if (self[id2].Solution_imagdefault==undefined) { self[id2].Solution_imagdefault=0; }
	var solution_realarray=new Array(); var solution_imagarray=new Array();		var flag=0;
	var sizes=self[id1].Format_size.split('x');
	var rows1=sizes[0]; 
	var cols1=sizes[1]; 
	var sizes=self[id2].Format_size.split('x');
	var rows2=sizes[0]; 
	var cols2=sizes[1]; 
	if ( ( cols1 != rows2 ) && ( ( rows1 != rows2 ) || ( cols1 != cols2 ) ) ) 
	{ 
		Set_Error(self[thisid].Original_id, "MultMat1", self[id1].Format_size, self[id2].Format_size); flag=1 
	}


	if (operator=="*")
	{
		// If the cols and rows are transposed of each other, do traditional matrix math
		if ( cols1 == rows2 )
		{	for (var index1 = 0; index1 < parseInt(rows1, 10); index1++) 
			{	for (var index2 = 0; index2 < parseFloat(cols2); index2++) 
				{	var key1=index1+"-"+index2;
					solution_realarray[key1]=0;		solution_imagarray[key1]=0;
					for (var index3 = 0; index3 < parseFloat(cols1); index3++) 
					{
						var key2=index2+"-"+index1;
						var key3=index1+"-"+index3;
						var key4=index3+"-"+index2;
						if (self[id1].Solution_real[key3]===undefined) { var real1=self[id1].Solution_realdefault; }else { var real1=self[id1].Solution_real[key3];}
						if (self[id1].Solution_imag[key3]===undefined) { var imag1=self[id1].Solution_imagdefault; }else { var imag1=self[id1].Solution_imag[key3];}
						if (self[id2].Solution_real[key4]===undefined) { var real2=self[id2].Solution_realdefault; }else { var real2=self[id2].Solution_real[key4];}
						if (self[id2].Solution_imag[key4]===undefined) { var imag2=self[id2].Solution_imagdefault; }else { var imag2=self[id2].Solution_imag[key4];}
						real1 = real1 || 0;
						imag1 = imag1 || 0;
						real2 = real2 || 0;
						imag2 = imag2 || 0;
						var r1=parseFloat(Big(real1).times(Big(real2)));
						var r2=parseFloat(Big(imag1).times(Big(imag2)));
						var i1=parseFloat(Big(real1).times(Big(imag2)));
						var i2=parseFloat(Big(imag1).times(Big(real2)));
						var real=parseFloat(Big(r1).minus(Big(r2))); 
						var imag=parseFloat(Big(i1).plus(Big(i2)));
						solution_realarray[key1]=parseFloat(Big(solution_realarray[key1]).plus(Big(real)));
						solution_imagarray[key1]=parseFloat(Big(solution_imagarray[key1]).plus(Big(imag)));
			}	}	}
		}

		// If the cols and rows match, multiply the matrices piece by piece
		if ( ( rows1 == rows2 ) && ( cols1 == cols2 ) )
		{	for (var index1 = 0; index1 < parseInt(rows1, 10); index1++) 
			{	for (var index2 = 0; index2 < parseFloat(cols2); index2++) 
				{	var key=index1+"-"+index2;
					solution_realarray[key]=0;		solution_imagarray[key]=0;
					if (self[id1].Solution_real[key]===undefined) { var real1=0; }else { var real1=self[id1].Solution_real[key];}
					if (self[id1].Solution_imag[key]===undefined) { var imag1=0; }else { var imag1=self[id1].Solution_imag[key];}
					if (self[id2].Solution_real[key]===undefined) { var real2=0; }else { var real2=self[id2].Solution_real[key];}
					if (self[id2].Solution_imag[key]===undefined) { var imag2=0; }else { var imag2=self[id2].Solution_imag[key];}
					real1 = real1 || 0;
					imag1 = imag1 || 0;
					real2 = real2 || 0;
					imag2 = imag2 || 0;
					var r1=parseFloat(Big(real1).times(Big(real2)));
					var r2=parseFloat(Big(imag1).times(Big(imag2)));
					var i1=parseFloat(Big(real1).times(Big(imag2)));
					var i2=parseFloat(Big(imag1).times(Big(real2)));
					var real=parseFloat(Big(r1).minus(Big(r2))); 
					var imag=parseFloat(Big(i1).plus(Big(i2)));
					solution_realarray[key]=real;
					solution_imagarray[key]=imag;
				}
			}
		}

		var baseunits=new Array();
		for(var index in self[id1].Units_base_array) { baseunits[index]=self[id1].Units_base_array[index]+self[id2].Units_base_array[index]; 	}

	}

	if (operator=="/")
	{
		// If the cols and rows match, divide the matrices piece by piece
		if ( ( rows1 == rows2 ) && ( cols1 == cols2 ) )
		{	for (var index1 = 0; index1 < parseInt(rows1, 10); index1++) 
			{	for (var index2 = 0; index2 < parseFloat(cols2); index2++) 
				{	var key=index1+"-"+index2;
					solution_realarray[key]=0;		solution_imagarray[key]=0;
					if (self[id1].Solution_real[key]===undefined) { var real1=self[id1].Solution_realdefault; }else { var real1=self[id1].Solution_real[key];}
					if (self[id1].Solution_imag[key]===undefined) { var imag1=self[id1].Solution_imagdefault; }else { var imag1=self[id1].Solution_imag[key];}
					if (self[id2].Solution_real[key]===undefined) { var real2=self[id2].Solution_realdefault; }else { var real2=self[id2].Solution_real[key];}
					if (self[id2].Solution_imag[key]===undefined) { var imag2=self[id2].Solution_imagdefault; }else { var imag2=self[id2].Solution_imag[key];}

					real1 = real1 || 0;
					imag1 = imag1 || 0;
					real2 = real2 || 0;
					imag2 = imag2 || 0;

					if (((imag1===0)&&(imag2===0))||((imag1===0)&&(isNaN(imag2)))||((isNaN(imag1))&&(imag2===0))||((isNaN(imag1))&&(isNaN(imag2))))
					{ 	
						if ( real1 == 0 )
						{
							real = 0;
						}else
						{
							real=parseFloat(Big(real1).div(Big(real2))); 
						}
					 	imag=0;																										 
					}else
					{	
						var c=parseFloat(real2);
						var d=-1*parseFloat(imag2);
						var a1=real1;
						var b1=imag1;
						var a2=real2;
						var b2=imag2;
						var nr=parseFloat(Big(a1).times(Big(c)).minus(Big(b1).times(Big(d)))); 
						var ni=parseFloat(Big(a1).times(Big(d)).plus(Big(b1).times(Big(c)))); 
						var dr=parseFloat(Big(a2).times(Big(c)).minus(Big(b2).times(Big(d)))); 
						var di=parseFloat(Big(a2).times(Big(d)).minus(Big(b2).times(Big(c)))); 
						if ( dr == 0 )
						{
							real = 0;
							imag = 0;
						}else
						{
						  	var real=parseFloat(Big(nr).div(Big(dr)));
						  	var imag=parseFloat(Big(ni).div(Big(dr)));
						}
					}

					// Prevent NaNs from being returned
					real = real || 0;
					imag = imag || 0;

					solution_realarray[key]=real;
					solution_imagarray[key]=imag;						
	
					var baseunits=new Array();
					for(var index in self[id1].Units_base_array) { baseunits[index]=self[id1].Units_base_array[index]-self[id2].Units_base_array[index]; 	}

				}
			}
		}
	}

	size=index1+"x"+index2;
	var eqobj={Page_position:DOM_Object[thisid]['order'], Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"MyEq="+0, Solution_real:solution_realarray, Solution_imag:solution_imagarray, Format_size:size,
    Format_numinds:self[id1].Format_numinds, Units_base_array:baseunits       };				                                        
	var id=CreateEq(this.fileid, 0, eqobj);													      
//    var id=Get_ID("Equation");
//	self[id]=new Equation(id);
//	self[id].Solution_real=solution_realarray;
//	self[id].Solution_imag=solution_imagarray;
//	self[id].Format_size=size;
//	self[id].Format_numinds=self[id1].Format_numinds;
//	self[id].Units_base_array=baseunits;
	self[id].Recompose_Units(); 
	self[id].Get_My_BaseString();
	return id;
}
//---------------------------------------------------------------------------------------------------------------------------------------------------------//

/*---------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------------------- Convert input string to array -------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*  This function is used on built-in functions. It is given the string which is sent to the functions. It takes this string and splits it view commas.     |
    It then recombines the matrices, other built in functions, other item that also uses commas.                                                            |
/*---------------------------------------------------------------------------------------------------------------------------------------------------------*/
function InputArray(text)
{	var inputarray=new Array();	var numarray=new Array();	var flip=0;	var bcount=0; var pcount=0;
	inputarray=SplitText(text);
	for (var a=0; a<inputarray.length; a++)	{ if (inputarray[a]!=",") { numarray[a]=1;}else { numarray[a]=0; } }
	for (var a=0; a<inputarray.length; a++)
	{	if (inputarray[a]=="(") { flip=1; bcount=parseInt(bcount, 10)+1; } 
		if (inputarray[a]=="[") { flip=1; pcount=parseInt(pcount, 10)+1; }
		if (inputarray[a-1]==")") { bcount=bcount-1; }
		if (inputarray[a-1]=="]") { pcount=pcount-1; }
		if (((inputarray[a-1]==")")||(inputarray[a-1]=="]"))&&((bcount===0)&&(pcount===0))) { flip=0; }
		if (flip==1) { numarray[a]=1; }
	}
	for (var i = inputarray.length; i >0; i--)  
	{	if ((numarray[i] == '1')&&(numarray[parseInt(i, 10)-1] == '1'))
		{	inputarray[i-1]=inputarray[i-1]+inputarray[i];
			inputarray.splice(i, 1); 
			numarray.splice(i, 1);  
	}	} 	
	for (var i = inputarray.length; i >=0; i--) { if ((inputarray[i]==',')||(inputarray[i]==' ')||(inputarray[i]==='')){ inputarray.splice(i, 1); }	} 	
	return inputarray;
}
//---------------------------------------------------------------------------------------------------------------------------------------------------------//

/*---------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------------------ SET THE MODELS FOR ALL EQUATIONS -----------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------*/
function SetModels(fname, id, id1, id2, id3, id4, id5, id6)
{	var num1='';	var num2='';	var num3='';	var num4='';	var num5='';	var num6='';
	if (fname=="power") 
	{	self[id].Models_dimensions="\\left("+self[id2].Format_size+"\\right)^{"+self[id1].Format_size+"}";
		if (self[id1].Units_units==="") { num1="NA"; }else { num1='{'+self[id1].Units_units+'}'; }
		if (self[id2].Units_units==="") { num2="NA"; }else { num2='{'+self[id2].Units_units+'}'; }
		self[id].Models_units="\\left("+num2+"\\right)^{"+num1+"}"; 
		if (self[id1].Units_quantity==="") { num1="NA"; }else { num1='{'+self[id1].Units_quantity+'}'; }
		if (self[id2].Units_quantity==="") { num2="NA"; }else { num2='{'+self[id2].Units_quantity+'}'; }
		self[id].Models_quantities="\\left("+num2+"\\right)^{"+num1+"}"; 
		if (self[id1].Format_size=="1x1") { num1=self[id1].Solution_real['0-0']; }else { num1='{'+self[id1].Format_size+'}'; }
		if (self[id2].Format_size=="1x1") { num2=self[id2].Solution_real['0-0']; }else { num2='{'+self[id2].Format_size+'}'; }
		self[id].Models_numerical="\\left("+num2+"\\right)^{"+num1+"}"; 	
	}else if (fname=="abs")
	{	self[id].Models_dimensions=fname+"\\left|"+self[id1].Format_size+"\\right|";
		if (self[id1].Units_units==="") { num1="NA"; }else { num1='{'+self[id1].Units_units+'}'; }
		self[id].Models_units=fname+"\\left|"+num1+"\\right|"; 
		if (self[id1].Units_quantity==="") { num1="NA"; }else { num1='{'+self[id1].Units_quantity+'}'; }
		self[id].Models_quantities=fname+"\\left|"+num1+"\\right|"; 
		if (self[id1].Format_size=="1x1") { num1=self[id1].Solution_real['0-0']; 
		}else { num1='{'+self[id1].Format_size+'}'; }
		self[id].Models_numerical=fname+"\\left|"+num1+"\\right|"; 
	}else if ((fname=="Integrate")||(fname=="NewtonCotes"))
	{	self[id].Models_dimensions="\\int_{1x1}^{1x1}"+self[id2].Format_size+"\\hspace{1mm}\\mathrm{d}\\hspace{1mm}"+self[id1].Format_size;
		if (self[id1].Units_units==="") { num1="NA"; }else { num1='{'+self[id1].Units_units+'}'; }
		if (self[id2].Units_units==="") { num2="NA"; }else { num2='{'+self[id2].Units_units+'}'; }
		self[id].Models_units="\\int_{NA}^{NA}"+num2+"\\hspace{1mm}\\mathrm{d}\\hspace{1mm}"+num1;
		if (self[id1].Units_quantity==="") { num1="NA"; }else { num1='{'+self[id1].Units_quantity+'}'; }
		if (self[id2].Units_quantity==="") { num2="NA"; }else { num2='{'+self[id2].Units_quantity+'}'; }
		self[id].Models_quantities="\\int_{NA}^{NA}"+num2+"\\hspace{1mm}\\hspace{1mm}\\mathrm{d}\\hspace{1mm}"+num1;
		self[id].Models_numerical="\\int_{"+id3+"}^{"+id4+"}"+self[id2].Format_size+"\\hspace{1mm}\\mathrm{d}\\hspace{1mm}"+self[id1].Format_size;
	}else if ((fname=="bisect")||(fname=="falsepos")||(fname=="secant"))
	{	if ((id5!==undefined)||(id6!==undefined))
		{	if (id6!==undefined) { self[id].Models_dimensions=fname+"\\left("+id1+", "+self[id2].Format_size+", "+self[id3].Format_size+", "+self[id4].Format_size+", "+self[id5].Format_size+", "+self[id6].Format_size+"\\right)";
			}else if (id5!==undefined) { self[id].Models_dimensions=fname+"\\left("+id1+", "+self[id2].Format_size+", "+self[id3].Format_size+", "+self[id4].Format_size+", "+self[id5].Format_size+"\\right)";}
			if (self[id2].Units_units==="") { num2="NA"; }else { num2='{'+self[id2].Units_units+'}';}
			if (self[id3].Units_units==="") { num3="NA"; }else { num3='{'+self[id3].Units_units+'}';}
			if (self[id4].Units_units==="") { num4="NA"; }else { num4='{'+self[id4].Units_units+'}';}
			if (self[id5].Units_units==="") { num5="NA"; }else { num5='{'+self[id5].Units_units+'}';}
			if (id6!==undefined) { 	self[id].Models_units=fname+"\\left("+id1+", "+num2+", "+num3+", "+num4+", "+num5+", "+id6+"\\right)";
			}else {					self[id].Models_units=fname+"\\left("+id1+", "+num2+", "+num3+", "+num4+", "+num5+"\\right)";	}
			if (self[id2].Units_quantity==="") { num2="NA"; }else { num2='{'+self[id2].Units_quantity+'}';}
			if (self[id3].Units_quantity==="") { num3="NA"; }else { num3='{'+self[id3].Units_quantity+'}';}
			if (self[id4].Units_quantity==="") { num4="NA"; }else { num4='{'+self[id4].Units_quantity+'}';}
			if (self[id5].Units_quantity==="") { num5="NA"; }else { num5='{'+self[id5].Units_quantity+'}';}
			if (id6!==undefined) { 	self[id].Models_quantities=fname+"\\left("+id1+", "+num2+", "+num3+", "+num4+", "+num5+", "+id6+"\\right)";
			}else {					self[id].Models_quantities=fname+"\\left("+id1+", "+num2+", "+num3+", "+num4+", "+num5+"\\right)";}
			self[id].Models_quantities=fname+"\\left("+num1+", "+num2+", "+num3+", "+num4+"\\right)"; 
			if (self[id2].Format_size=="1x1") { num2=self[id2].Solution_real['0-0']; }else { num2='{'+self[id2].Format_size+'}';}
			if (self[id3].Format_size=="1x1") { num3=self[id3].Solution_real['0-0']; }else { num3='{'+self[id3].Format_size+'}';}
			if (self[id4].Format_size=="1x1") { num4=self[id4].Solution_real['0-0']; }else { num4='{'+self[id4].Format_size+'}';}
			if (self[id5].Format_size=="1x1") { num5=self[id5].Solution_real['0-0']; }else { num5='{'+self[id5].Format_size+'}';}
			if (id6!==undefined) { 	self[id].Models_numerical=fname+"\\left("+id1+", "+num2+", "+num3+", "+num4+", "+num5+", "+id6+"\\right)";
			}else {					self[id].Models_numerical=fname+"\\left("+id1+", "+num2+", "+num3+", "+num4+", "+num5+"\\right)";	}
		}else if (id4!==undefined)
		{	self[id].Models_dimensions=fname+"\\left("+id1+", "+self[id2].Format_size+", "+self[id3].Format_size+", "+self[id4].Format_size+"\\right)";
			if (self[id2].Units_units==="") { num2="NA"; }else { num2='{'+self[id2].Units_units+'}';}
			if (self[id3].Units_units==="") { num3="NA"; }else { num3='{'+self[id3].Units_units+'}';}
			if (self[id4].Units_units==="") { num4="NA"; }else { num4='{'+self[id4].Units_units+'}';}
			self[id].Models_units=fname+"\\left("+id1+", "+num2+", "+num3+", "+num4+"\\right)";
			if (self[id2].Units_quantity==="") { num2="NA"; }else { num2='{'+self[id2].Units_quantity+'}';}
			if (self[id3].Units_quantity==="") { num3="NA"; }else { num3='{'+self[id3].Units_quantity+'}';}
			if (self[id4].Units_quantity==="") { num4="NA"; }else { num4='{'+self[id4].Units_quantity+'}';}
			self[id].Models_quantities=fname+"\\left("+id1+", "+num2+", "+num3+", "+num4+"\\right)";
			if (self[id2].Format_size=="1x1") { num2=self[id2].Solution_real['0-0']; }else { num2='{'+self[id2].Format_size+'}';}
			if (self[id3].Format_size=="1x1") { num3=self[id3].Solution_real['0-0']; }else { num3='{'+self[id3].Format_size+'}';}
			if (self[id4].Format_size=="1x1") { num4=self[id4].Solution_real['0-0']; }else { num4='{'+self[id4].Format_size+'}';}
			self[id].Models_numerical=fname+"\\left("+id1+", "+num2+", "+num3+", "+num4+"\\right)";
		}else if (id3!==undefined)
		{	self[id].Models_dimensions=fname+"\\left("+id1+", "+self[id2].Format_size+", "+self[id3].Format_size+"\\right)";
			if (self[id2].Units_units==="") { num2="NA"; }else { num2='{'+self[id2].Units_units+'}';}
			if (self[id3].Units_units==="") { num3="NA"; }else { num3='{'+self[id3].Units_units+'}';}
			self[id].Models_units=fname+"\\left("+id1+", "+num2+", "+num3+"\\right)";
			if (self[id2].Units_quantity==="") { num2="NA"; }else { num2='{'+self[id2].Units_quantity+'}';}
			if (self[id3].Units_quantity==="") { num3="NA"; }else { num3='{'+self[id3].Units_quantity+'}';}
			self[id].Models_quantities=fname+"\\left("+id1+", "+num2+", "+num3+"\\right)";
			if (self[id2].Format_size=="1x1") { num2=self[id2].Solution_real['0-0']; }else { num2='{'+self[id2].Format_size+'}';}
			if (self[id3].Format_size=="1x1") { num3=self[id3].Solution_real['0-0']; }else { num3='{'+self[id3].Format_size+'}';}
			self[id].Models_numerical=fname+"\\left("+id1+", "+num2+", "+num3+"\\right)";
		}
	}else if (fname=="Conj")
	{	self[id].Models_dimensions="\\overline{\\left("+self[id1].Format_size+"\\right)}";
		if (self[id1].Units_units==="") { num1="NA"; }else { num1='{'+self[id1].Units_units+'}'; }
		self[id].Models_units="\\overline{\\left("+num1+"\\right)}";
		if (self[id1].Units_quantity==="") { num1="NA"; }else { num1='{'+self[id1].Units_quantity+'}'; }
		self[id].Models_quantities="\\overline{\\left("+num1+"\\right)}";
		if (self[id1].Format_size=="1x1") { num1=self[id1].Solution_real['0-0']; }else { num1='{'+self[id1].Format_size+'}';}
		self[id].Models_numerical="\\overline{\\left("+num1+"\\right)}";
	}else if (fname=="Norm")
	{	self[id].Models_dimensions="\\left|\\left|\\hspace{0.5em}"+self[id1].Format_size+"\\hspace{0.5em}\\right|\\right|_{"+self[id2].Format_size+"}";
		if (self[id1].Units_units==="") { num1="NA"; }else { num1='{'+self[id1].Units_units+'}'; }
		if (self[id2].Units_units==="") { num2="NA"; }else { num2='{'+self[id2].Units_units+'}'; }
		self[id].Models_units="\\left|\\left|\\hspace{0.5em}"+num1+"\\hspace{0.5em}\\right|\\right|_{"+num2+"}";
		if (self[id1].Units_quantity==="") { num1="NA"; }else { num1='{'+self[id1].Units_quantity+'}'; }
		if (self[id2].Units_quantity==="") { num2="NA"; }else { num2='{'+self[id2].Units_quantity+'}'; }
		self[id].Models_quantities="\\left|\\left|\\hspace{0.5em}"+num1+"\\hspace{0.5em}\\right|\\right|_{"+num2+"}";
		if (self[id1].Format_size=="1x1") { num1=self[id1].Solution_real['0-0']; }else { num1='{'+self[id1].Format_size+'}';}
		if (self[id2].Format_size=="1x1") { num2=self[id2].Solution_real['0-0']; }else { num2='{'+self[id2].Format_size+'}';}
		self[id].Models_numerical="\\left|\\left|\\hspace{0.5em}"+num1+"\\hspace{0.5em}\\right|\\right|_{"+num2+"}";
	}else if (fname=="RSNorm")
	{	self[id].Models_dimensions="\\left|\\left|\\hspace{0.5em}"+self[id1].Format_size+"\\hspace{0.5em}\\right|\\right|_R";	
		if (self[id1].Units_units==="") { num1="NA"; }else { num1='{'+self[id1].Units_units+'}'; }
		self[id].Models_units="\\left|\\left|\\hspace{0.5em}"+num1+"\\hspace{0.5em}\\right|\\right|_R";
		if (self[id1].Units_quantity==="") { num1="NA"; }else { num1='{'+self[id1].Units_quantity+'}'; }
		self[id].Models_quantities="\\left|\\left|\\hspace{0.5em}"+num1+"\\hspace{0.5em}\\right|\\right|_R";
		if (self[id1].Format_size=="1x1") { num1=self[id1].Solution_real['0-0']; }else { num1='{'+self[id1].Format_size+'}';}
		self[id].Models_numerical="\\left|\\left|\\hspace{0.5em}"+num1+"\\hspace{0.5em}\\right|\\right|_R";
	}else if (fname=="CSNorm")
	{	self[id].Models_dimensions="\\left|\\left|\\hspace{0.5em}"+self[id1].Format_size+"\\hspace{0.5em}\\right|\\right|_C";	
		if (self[id1].Units_units==="") { num1="NA"; }else { num1='{'+self[id1].Units_units+'}'; }
		self[id].Models_units="\\left|\\left|\\hspace{0.5em}"+num1+"\\hspace{0.5em}\\right|\\right|_C";
		if (self[id1].Units_quantity==="") { num1="NA"; }else { num1='{'+self[id1].Units_quantity+'}'; }
		self[id].Models_quantities="\\left|\\left|\\hspace{0.5em}"+num1+"\\hspace{0.5em}\\right|\\right|_C";
		if (self[id1].Format_size=="1x1") { num1=self[id1].Solution_real['0-0']; }else { num1='{'+self[id1].Format_size+'}';}
		self[id].Models_numerical="\\left|\\left|\\hspace{0.5em}"+num1+"\\hspace{0.5em}\\right|\\right|_C";
	}else if ((fname=="incSearch")||(fname=="FalsePos")||(fname=="Secant")||(fname=="Bisect"))
	{	if (id6>=3)
		{	if (self[id2].Format_size=="1x1") { num2=self[id2].Solution_real['0-0']; }else { num2='{'+self[id2].Format_size+'}';}
			if (self[id3].Format_size=="1x1") { num3=self[id3].Solution_real['0-0']; }else { num3='{'+self[id3].Format_size+'}';}
		}
		if (id6>=4)	{	if (self[id4].Format_size=="1x1") { num4=self[id4].Solution_real['0-0']; }else { num4='{'+self[id4].Format_size+'}';}	}
		if (id6==3) { self[id].Models_numerical=fname+"  \\hspace{0.1em} \\left( \\hspace{0.2em}"+id1+", "+num2+", "+num3+"\\hspace{0.2em}\\right)";	}
		if (id6==4) { self[id].Models_numerical=fname+"  \\hspace{0.1em} \\left( \\hspace{0.2em}"+id1+", "+num2+", "+num3+", "+num4+"\\hspace{0.2em}\\right)";	}
		if (id6==5) { self[id].Models_numerical=fname+"  \\hspace{0.1em} \\left( \\hspace{0.2em}"+id1+", "+num2+", "+num3+", "+num4+", "+id5+"\\hspace{0.2em}\\right)";	}
		if (id6>=3)
		{	if (self[id2].Units_units==="") { num2="NA"; }else { num2='{'+self[id2].Units_units+'}';}
			if (self[id3].Units_units==="") { num3="NA"; }else { num3='{'+self[id3].Units_units+'}';}
		}
		if (id6>=4){	if (self[id4].Units_units==="") { num4="NA"; }else { num4='{'+self[id4].Units_units+'}';} }
		if (id6==3) { self[id].Models_units=fname+"  \\hspace{0.1em} \\left( \\hspace{0.2em}"+id1+", "+num2+", "+num3+"\\hspace{0.2em}\\right)";	}
		if (id6==4) { self[id].Models_units=fname+"  \\hspace{0.1em} \\left( \\hspace{0.2em}"+id1+", "+num2+", "+num3+", "+num4+"\\hspace{0.2em}\\right)";	}
		if (id6==5) { self[id].Models_units=fname+"  \\hspace{0.1em} \\left( \\hspace{0.2em}"+id1+", "+num2+", "+num3+", "+num4+", "+id5+"\\hspace{0.2em}\\right)";	}
		if (id6>=3)
		{	if (self[id2].Units_quantity==="") { num2="NA"; }else { num2='{'+self[id2].Units_quantity+'}';}
			if (self[id3].Units_quantity==="") { num3="NA"; }else { num3='{'+self[id3].Units_quantity+'}';}
		}
		if (id6>=4){	if (self[id4].Units_quantity==="") { num4="NA"; }else { num4='{'+self[id4].Units_quantity+'}';}		}
		if (id6==3) { self[id].Models_quantities=fname+"  \\hspace{0.1em} \\left( \\hspace{0.2em}"+id1+", "+num2+", "+num3+"\\hspace{0.2em}\\right)";}
		if (id6==4) { self[id].Models_quantities=fname+"  \\hspace{0.1em} \\left( \\hspace{0.2em}"+id1+", "+num2+", "+num3+", "+num4+"\\hspace{0.2em}\\right)";	}
		if (id6==5) { self[id].Models_quantities=fname+"  \\hspace{0.1em} \\left( \\hspace{0.2em}"+id1+", "+num2+", "+num3+", "+num4+", "+id5+"\\hspace{0.2em}\\right)";	}
		if (id6>=3)	{	num2='{'+self[id2].Format_size+'}'; num3='{'+self[id3].Format_size+'}'; } 											 
		if (id6>=4)	{	num4='{'+self[id4].Format_size+'}';}
		if (id6==3) { self[id].Models_dimensions=fname+"  \\hspace{0.1em} \\left( \\hspace{0.2em}"+id1+", "+num2+", "+num3+"\\hspace{0.2em}\\right)";}
		if (id6==4) { self[id].Models_dimensions=fname+"  \\hspace{0.1em} \\left( \\hspace{0.2em}"+id1+", "+num2+", "+num3+", "+num4+"\\hspace{0.2em}\\right)";	}
		if (id6==5) { self[id].Models_dimensions=fname+"  \\hspace{0.1em} \\left( \\hspace{0.2em}"+id1+", "+num2+", "+num3+", "+num4+", "+id5+"\\hspace{0.2em}\\right)";	}
	}else if (fname=="ODE4")
	{	if (self[id1].Format_size=="1x1") { num1=self[id1].Solution_real['0-0']; }else { num1='{'+self[id1].Format_size+'}';}
		if (self[id3].Format_size=="1x1") { num3=self[id3].Solution_real['0-0']; }else { num3='{'+self[id3].Format_size+'}';}
		self[id].Models_numerical=fname+"  \\hspace{0.1em} \\left( \\hspace{0.2em}"+num1+", "+id2+", "+num3+"\\hspace{0.2em}\\right)";
		if (self[id1].Units_units==="") { num1="NA"; }else { num1='{'+self[id1].Units_units+'}';}
		if (self[id3].Units_units==="") { num3="NA"; }else { num3='{'+self[id3].Units_units+'}';}
		self[id].Models_units=fname+"  \\hspace{0.1em} \\left( \\hspace{0.2em}"+num1+", "+id2+", "+num3+"\\hspace{0.2em}\\right)";
		if (self[id1].Units_quantity==="") { num1="NA"; }else { num1='{'+self[id1].Units_quantity+'}';}
		if (self[id3].Units_quantity==="") { num3="NA"; }else { num3='{'+self[id3].Units_quantity+'}';}
		self[id].Models_quantities=fname+"  \\hspace{0.1em} \\left( \\hspace{0.2em}"+num1+", "+id2+", "+num3+"\\hspace{0.2em}\\right)";
		num1='{'+self[id1].Format_size+'}';
		num3='{'+self[id3].Format_size+'}';
		self[id].Models_dimensions=fname+"  \\hspace{0.1em} \\left( \\hspace{0.2em}"+num1+", "+id2+", "+num3+"\\hspace{0.2em}\\right)";
	}else	
	{
		if (id4!==undefined)
		{	self[id].Models_dimensions=fname+"\\left("+self[id1].Format_size+", "+self[id2].Format_size+", "+self[id3].Format_size+", "+self[id4].Format_size+"\\right)";	
			if (self[id1].Units_units==="") { num1="NA"; }else { num1='{'+self[id1].Units_units+'}';}
			if (self[id2].Units_units==="") { num2="NA"; }else { num2='{'+self[id2].Units_units+'}';}
			if (self[id3].Units_units==="") { num3="NA"; }else { num3='{'+self[id3].Units_units+'}';}
			if (self[id4].Units_units==="") { num4="NA"; }else { num4='{'+self[id4].Units_units+'}';}
			self[id].Models_units=fname+"\\left("+num1+", "+num2+", "+num3+", "+num4+"\\right)"; 
			if (self[id1].Units_quantity==="") { num1="NA"; }else { num1='{'+self[id1].Units_quantity+'}';}
			if (self[id2].Units_quantity==="") { num2="NA"; }else { num2='{'+self[id2].Units_quantity+'}';}
			if (self[id3].Units_quantity==="") { num3="NA"; }else { num3='{'+self[id3].Units_quantity+'}';}
			if (self[id4].Units_quantity==="") { num4="NA"; }else { num4='{'+self[id4].Units_quantity+'}';}
			self[id].Models_quantities=fname+"\\left("+num1+", "+num2+", "+num3+", "+num4+"\\right)"; 
			if (self[id1].Format_size=="1x1") { num1=self[id1].Solution_real['0-0']; }else { num1='{'+self[id1].Format_size+'}';}
			if (self[id2].Format_size=="1x1") { num2=self[id2].Solution_real['0-0']; }else { num2='{'+self[id2].Format_size+'}';}
			if (self[id3].Format_size=="1x1") { num3=self[id3].Solution_real['0-0']; }else { num3='{'+self[id3].Format_size+'}';}
			if (self[id4].Format_size=="1x1") { num4=self[id4].Solution_real['0-0']; }else { num4='{'+self[id4].Format_size+'}';}
			self[id].Models_numerical=fname+"\\left("+num1+", "+num2+", "+num3+", "+num4+"\\right)"; 
		}else if (id3!==undefined) 
		{	self[id].Models_dimensions=fname+"\\left("+self[id1].Format_size+", "+self[id2].Format_size+", "+self[id3].Format_size+"\\right)";
			if (self[id1].Units_units==="") { num1="NA"; }else { num1='{'+self[id1].Units_units+'}';}
			if (self[id2].Units_units==="") { num2="NA"; }else { num2='{'+self[id2].Units_units+'}';}
			if (self[id3].Units_units==="") { num3="NA"; }else { num3='{'+self[id3].Units_units+'}';}
			self[id].Models_units=fname+"\\left("+num1+", "+num2+", "+num3+"\\right)"; 
			if (self[id1].Units_quantity==="") { num1="NA"; }else { num1='{'+self[id1].Units_quantity+'}';}
			if (self[id2].Units_quantity==="") { num2="NA"; }else { num2='{'+self[id2].Units_quantity+'}';}
			if (self[id3].Units_quantity==="") { num3="NA"; }else { num3='{'+self[id3].Units_quantity+'}';}
			self[id].Models_quantities=fname+"\\left("+num1+", "+num2+", "+num3+"\\right)"; 
			if (self[id1].Format_size=="1x1") { num1=self[id1].Solution_real['0-0']; }else { num1='{'+self[id1].Format_size+'}';}
			if (self[id2].Format_size=="1x1") { num2=self[id2].Solution_real['0-0']; }else { num2='{'+self[id2].Format_size+'}';}
			if (self[id3].Format_size=="1x1") { num3=self[id3].Solution_real['0-0']; }else { num3='{'+self[id3].Format_size+'}';}
			self[id].Models_numerical=fname+"\\left("+num1+", "+num2+", "+num3+"\\right)"; 
		}else if (id2!==undefined) 
		{	self[id].Models_dimensions=fname+"\\left("+self[id1].Format_size+", "+self[id2].Format_size+"\\right)";
			if (self[id1].Units_units==="") { num1="NA"; }else { num1='{'+self[id1].Units_units+'}';}
			if (self[id2].Units_units==="") { num2="NA"; }else { num2='{'+self[id2].Units_units+'}';}
			self[id].Models_units=fname+"\\left("+num1+", "+num2+"\\right)"; 
			if (self[id1].Units_quantity==="") { num1="NA"; }else { num1='{'+self[id1].Units_quantity+'}';}
			if (self[id2].Units_quantity==="") { num2="NA"; }else { num2='{'+self[id2].Units_quantity+'}';}
			self[id].Models_quantities=fname+"\\left("+num1+", "+num2+"\\right)"; 
			if (self[id1].Format_size=="1x1") { num1=self[id1].Solution_real['0-0']; }else { num1='{'+self[id1].Format_size+'}';}
			if (self[id2].Format_size=="1x1") { num2=self[id2].Solution_real['0-0']; }else { num2='{'+self[id2].Format_size+'}';}
			self[id].Models_numerical=fname+"\\left("+num1+", "+num2+"\\right)"; 
		}else if (id1!==undefined) 
		{	self[id].Models_dimensions=fname+"\\left("+self[id1].Format_size+"\\right)";
			if (self[id1].Units_units==="") { num1="NA"; }else { num1='{'+self[id1].Units_units+'}'; }
			self[id].Models_units=fname+"\\left("+num1+"\\right)"; 
			if (self[id1].Units_quantity==="") { num1="NA"; }else { num1='{'+self[id1].Units_quantity+'}'; }
			self[id].Models_quantities=fname+"\\left("+num1+"\\right)"; 
			if (self[id1].Format_size=="1x1") { num1=self[id1].Solution_real['0-0']; }else { num1='{'+self[id1].Format_size+'}'; }
			self[id].Models_numerical=fname+"\\left("+num1+"\\right)"; 
		}
	}
}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------*/



/*-------------------------------------------------------------------------------------------------------------------------*/
/*--------------------------------------- ADD A CONNECTED EQUATION TO THE DATABASES ---------------------------------------*/
/*-------------------------------------------------------------------------------------------------------------------------*\
	This function is used to add equations to the database that are created as the result of a function that has multiple	\
	outputs. The equations are added to the database so that they can be reloaded, but they do not cause an increase in 	\
	the locations of the other equations.																					\
/*-------------------------------------------------------------------------------------------------------------------------*/
function AddConnectedEqs(id)
{	for (var thisid in self[id].connected_ids) 
	{	var textstring=thisid+'::'+DOM_Object[id]['order']+'::'+3;
		textstring=textstring+'::'+self[id].Page_parentid+'::'+self[id].Page_topparentid;
	}
}
/*-------------------------------------------------------------------------------------------------------------------------*/



//---------------------------------------------------------------------------------------------------------//
//------------------------------ DELETE A CONNECTED EQUATION TO THE DATABASES -----------------------------//
/*
 This function is used to delete equations that were created in a function with multiple outputs. The 
 equations are deleted but there is no effect on the locations of the remaining equations.
*/
//---------------------------------------------------------------------------------------------------------//
function DeleteConnectedEqs(id)
{	var fileid=self[id].fileid;
	for (var thisid in self[id].connected_ids)  
	{	var textstring=thisid+'::'+DOM_Object[id]['order']+'::'+3;
		textstring=textstring+'::'+self[id].Page_parentid+'::'+self[id].Page_topparentid;
		if (DOM_Object[thisid]!==undefined)
		{	$.ajax ({ type:"POST", url:"/Documents/DeleteItem",
			data: { fileid:fileid, type:"equation", id:thisid, thisloc:DOM_Object[thisid]['order']}, 
			insert:0, error: function () { alert('There was an error deleting this item');}, 
			}); 
		}
		if (DOM_Object[thisid]!==undefined) { delete DOM_Object[thisid];	} 
	}
	self[id].connected_ids={};
}
//---------------------------------------------------------------------------------------------------------//











//-------------------------------------------------------------------------------------------------------------------------//
//---------------------------------- CREATE AND POSSIBLY SOLVE NEW EQUATION OBJECT ----------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
/*
This function is called to create and possibly solve new equation objects. The need for the function arose out of repeated 
need to create temporary equations and the absurd use of space that this created.
*/
function CreateEq(fileid, solve, eqobj)
{	if (eqobj['id']!==undefined) { id=eqobj['id']; }else { var id=Get_ID("Equation", fileid);	}
	self[id]=new Equation(id);
	DOM_Object[id]={};	DOM_Object[id]['Dependents']={};	DOM_Object[id]['children']={};
	DOM_Object[id]['active']=1;				DOM_Object[id]['Descendents']={};		DOM_Object[id]['name']="TempEq";
	DOM_Object[id]['parentid']="none";		DOM_Object[id]['topparentid']="none";	DOM_Object[id]['type']="equation";
	DOM_Object[id]['real']={};				DOM_Object[id]['imag']={};				DOM_Object[id]['fileid']=fileid;
	DOM_Object[id]['units']={};				DOM_Object[id]['numinds']=2;			DOM_Object[id]['itemid']=id;
	var filename=fileid+'';
//	DOM_Object[id]['fileid']=filename.replace(/^File/,'').match(/^[0-9]+/);
	DOM_Object[id]['ID']=id;
	if (eqobj['Page_position']!==undefined) {	DOM_Object[id]['order']=eqobj['Page_position']; 	}else{ DOM_Object[id]['order']=0; }
	if (eqobj['Page_position']!==undefined) {	self[id].Page_position=eqobj['Page_position'];			}
	if (eqobj['Original_id']!==undefined) 	{	self[id]['Original_id']=eqobj['Original_id'];			}
	if (eqobj['Page_parentid']!==undefined) {	DOM_Object[id]['parentid']=eqobj['Page_parentid'];		}
	if (eqobj['Page_topparentid']!==undefined) {DOM_Object[id]['topparentid']=eqobj['Page_topparentid'];	}
	if (eqobj['Format_name']!==undefined) 	{	DOM_Object[id]['name']=eqobj['Format_name'];			}
	if (eqobj['Solution_real']!==undefined) {	DOM_Object[id]['real']=eqobj['Solution_real'];			}
	if (eqobj['Solution_imag']!==undefined) {	DOM_Object[id]['imag']=eqobj['Solution_imag'];			}
	if (eqobj['Format_size']!==undefined) 	{	DOM_Object[id]['size']=eqobj['Format_size'];			}
	if (eqobj['type']!==undefined) 	{	DOM_Object[id]['type']=eqobj['type'];							}
	if (eqobj['Format_equation']!==undefined) 	{	DOM_Object[id]['equation']=eqobj['Format_equation'];}
	if (eqobj['equation']!==undefined) 	{	DOM_Object[id]['equation']=eqobj['equation'];	}
	if (eqobj['equation']!==undefined) 	{	self[id].Format_equation=eqobj['equation'];	}
	self[id].fileid=fileid;
	for (var prop in eqobj)	{	self[id][prop]=eqobj[prop];	} 
	if (solve) { self[id].Solve_Equation(eqobj['equation']);	}
	return id;
}
//-------------------------------------------------------------------------------------------------------------------------//


      
/*-------------------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------ GET TABLE ELEMENTS -----------------------------------------------------------*/
/*-------------------------------------------------------------------------------------------------------------------------*/
/*	This function takes in text which is in the form of #Table85.A.1:#Table85.C.9.  The user can opt to get the values 		\
	of those table elements returned in an array of numbers or in text separated by commas. 								\
/*-------------------------------------------------------------------------------------------------------------------------*/
function Get_Table_Elements(text, option)
{
	var tableblocks=text.split(':');
	if (tableblocks.length==1) 
	{	var tempdata=tableblocks[0].split(".");
		var columnnumber=(tempdata[1].replace("$",""));
		columnnumber=parseInt(columnnumber.charCodeAt())-62;
		var rownumber=parseInt(tempdata[2].replace("$",""))+2;
		var numbers=DOM_Object[tempdata[0]]['real'][rownumber+'-'+columnnumber];
		var units=DOM_Object[tempdata[0]]['units'][rownumber+'-'+columnnumber];
		if (typeof(units)=="undefined") { units=""; }
	}else
	{	var tempdata1=tableblocks[0].split(".");
		var columnnumber1=(tempdata1[1].replace("$",""));
		columnnumber1=parseInt(columnnumber1.charCodeAt())-62;
		var rownumber1=parseInt(tempdata1[2].replace("$",""))+2;
		var tempdata2=tableblocks[1].split(".");
		var columnnumber2=(tempdata2[1].replace("$",""));
		columnnumber2=parseInt(columnnumber2.charCodeAt())-62;
		var rownumber2=parseInt(tempdata2[2].replace("$",""))+2;
		var numbers=''
		var numberarray=new Array();
		var counter=0;
		for (var a=rownumber1; a<=rownumber1+(rownumber2-rownumber1); a++)
		{	for (var b=columnnumber1; b<=columnnumber1+(columnnumber2-columnnumber1); b++)
			{	numberarray[counter]=DOM_Object[tempdata1[0]]['real'][a+'-'+b];
				counter=counter+1;
				numbers=numbers+", "+DOM_Object[tempdata1[0]]['real'][a+'-'+b];
	}	}	}
	if (option===0) { return numbers; }else if (option==1) { return numberarray; }
}
//-------------------------------------------------------------------------------------------------------------------------//


//-------------------------------------------------------------------------------------------------------------------------------------------------------------//
//----------------------------------------------------------- MATH BETWEEN NUMBERS AND MATRICES ---------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------------------------------//
	function ScalarOperation(operation, id1, id2)
	{	console.log('I am in the scalar operation function');
		if ((self[id1].Format_size=="1x1")||(self[id1].Format_size=="1 x 1")) { var numid=id1; var matrixid=id2; var order="1"; }
		if ((self[id2].Format_size=="1x1")||(self[id2].Format_size=="1 x 1")) { var numid=id2; var matrixid=id1; var order="2"; }
        var eqobj={Page_position:DOM_Object[id1]['order'], equation:"TempEq=0", Format_size:self[matrixid].Format_size};	                                
		var id=CreateEq("Equation", 0, eqobj);
		self[id]=new Equation(id);
		self[id].Format_name="TempEq";
		self[id].Format_size=self[matrixid].Format_size;
		switch (operation)
		{	case "*":
				for (var i in self[matrixid].Solution_real) 
				{ 	if (isNaN(parseFloat(self[matrixid].Solution_real[i]))) { self[matrixid].Solution_real[i]=0; }
					if (isNaN(parseFloat(self[matrixid].Solution_imag[i]))) { self[matrixid].Solution_imag[i]=0; }
					if (self[numid].Solution_real[i]==undefined) { self[numid].Solution_real[i]=0; }
					if (self[numid].Solution_imag[i]==undefined) { self[numid].Solution_imag[i]=0; }
					var r1=ToNum(self[matrixid].Solution_real[i]*self[numid].Solution_real['0-0']);												 
					var r2=ToNum(self[matrixid].Solution_imag[i]*self[numid].Solution_imag['0-0']); 											 		
					var i1=ToNum(self[matrixid].Solution_real[i]*self[numid].Solution_imag['0-0']); 											 	
					var i2=ToNum(self[matrixid].Solution_imag[i]*self[numid].Solution_real['0-0']); 										 
					self[id].Solution_real[i]=ToNum(r1-r2); 
					self[id].Solution_imag[i]=ToNum(i1+i2);									 
				 	var r1=ToNum(self[matrixid].Solution_realdefault*self[numid].Solution_real['0-0']); 
					var r2=ToNum(self[matrixid].Solution_imagdefault*self[numid].Solution_imag['0-0']); 		
					var i1=ToNum(self[matrixid].Solution_realdefault*self[numid].Solution_imag['0-0']); 	
					var i2=ToNum(self[matrixid].Solution_imagdefault*self[numid].Solution_real['0-0']);											 
					self[id].Solution_realdefault=ToNum(r1-r2); 
					self[id].Solution_imagdefault=ToNum(i1+i2); 
				}
				var baseunits=new Array();
				for(var index in self[id1].Units_base_array) 
				{	baseunits[index]=self[id1].Units_base_array[index]+self[id2].Units_base_array[index]; 
				}
				self[id]['Units_base_array']=baseunits;
				self[id]['Units_base_string']='';

				for(var index in self[id].Units_base_array) { self[id]['Units_base_string']=self[id]['Units_base_string']+''+self[id].Units_base_array[index] }

			break;
			case "+":
				for (var i in self[matrixid].Solution_real) 
				{ 	if (isNaN(parseFloat(self[matrixid].Solution_real[i]))) { self[matrixid].Solution_real[i]=0; }
					if (isNaN(parseFloat(self[matrixid].Solution_imag[i]))) { self[matrixid].Solution_imag[i]=0; }
					if (isNaN(parseFloat(self[numid].Solution_real['0-0']))) { self[numid].Solution_real['0-0']=0; }
					if (isNaN(parseFloat(self[numid].Solution_imag['0-0']))) { self[numid].Solution_imag['0-0']=0; }
					self[id].Solution_real[i]=ToNum(self[matrixid].Solution_real[i]+self[numid].Solution_real['0-0']);
					self[id].Solution_imag[i]=ToNum(self[matrixid].Solution_imag[i]+self[numid].Solution_imag['0-0']); }
					self[id].Solution_realdefault=ToNum(self[matrixid].Solution_realdefault+self[numid].Solution_real['0-0']); 
					self[id].Solution_imagdefault=ToNum(self[matrixid].Solution_imagdefault+self[numid].Solution_imag['0-0']); 
					var baseunits=new Array();
					for(var index in self[id1].Units_base_array) { baseunits[index]=self[id1].Units_base_array[index]; }
					self[id]['Units_base_array']=baseunits;
					self[id].Get_My_BaseString();
			break;
			case "-":
				if (order=="1")
				{	for (var i in self[matrixid].Solution_real) 
						{ 	if (isNaN(parseFloat(self[matrixid].Solution_real[i]))) { self[matrixid].Solution_real[i]=0; }
							if (isNaN(parseFloat(self[matrixid].Solution_imag[i]))) { self[matrixid].Solution_imag[i]=0; }
							if (isNaN(parseFloat(self[numid].Solution_real['0-0']))) { self[numid].Solution_real['0-0']=0; }
							if (isNaN(parseFloat(self[numid].Solution_imag['0-0']))) { self[numid].Solution_imag['0-0']=0; }
							self[id].Solution_real[i]=ToNum(self[numid].Solution_real['0-0']-self[matrixid].Solution_real[i]);
							self[id].Solution_imag[i]=ToNum(self[numid].Solution_imag['0-0']-self[matrixid].Solution_imag[i]);}
							self[id].Solution_realdefault=ToNum(self[numid].Solution_real['0-0']-self[matrixid].Solution_realdefault); 
							self[id].Solution_imagdefault=ToNum(self[numid].Solution_imag['0-0']-self[matrixid].Solution_imagdefault); 
				}else {	for (var i in self[matrixid].Solution_real) 
						{ 	if (self[matrixid].Solution_real[i]==='') { self[matrixid].Solution_real[i]=0; }
							if (self[matrixid].Solution_imag[i]==='') { self[matrixid].Solution_imag[i]=0; }
							if (self[numid].Solution_real['0-0']==='') { self[numid].Solution_real['0-0']=0; }
							if (self[numid].Solution_imag['0-0']==='') { self[numid].Solution_imag['0-0']=0; }
							self[id].Solution_real[i]=ToNum(self[matrixid].Solution_real[i]-self[numid].Solution_real['0-0']); 
							self[id].Solution_imag[i]=ToNum(self[matrixid].Solution_imag[i]-self[numid].Solution_imag['0-0']);	}
					self[id].Solution_realdefault=ToNum(self[matrixid].Solution_realdefault-self[numid].Solution_real['0-0']); 
					self[id].Solution_imagdefault=ToNum(self[matrixid].Solution_imagdefault-self[numid].Solution_imag['0-0']); 	}
				var baseunits=new Array();
				for(var index in self[id1].Units_base_array) { baseunits[index]=self[id1].Units_base_array[index]; }
				self[id]['Units_base_array']=baseunits;
				self[id].Get_My_BaseString();
			break; 
			case "/":
				if (order=="1")
				{	for (var i in self[matrixid].Solution_real) 
					{ 	if (isNaN(parseFloat(self[matrixid].Solution_real[i]))) { self[matrixid].Solution_real[i]=0; }
						if (isNaN(parseFloat(self[matrixid].Solution_imag[i]))) { self[matrixid].Solution_imag[i]=0; }
						if (isNaN(parseFloat(self[numid].Solution_real['0-0']))) { self[numid].Solution_real['0-0']=0; }
						if (isNaN(parseFloat(self[numid].Solution_imag['0-0']))) { self[numid].Solution_imag['0-0']=0; }
						var c=parseFloat(self[numid].Solution_real['0-0']);
						var d=-1*parseFloat(self[numid].Solution_imag['0-0']);
						var a1=parseFloat(self[matrixid].Solution_real[i]);
						var b1=parseFloat(self[matrixid].Solution_imag[i]);
						var a2=parseFloat(self[numid].Solution_real['0-0']);
						var b2=parseFloat(self[numid].Solution_imag['0-0']);
						var nr=ToNum(a1*c-b1*d); 
						var ni=ToNum(a1*d+b1*c); 
						var dr=ToNum(a2*c-b2*d); 
						var di=ToNum(a2*d+b2*c); 
					  	self[id].Solution_real[i]=ToNum(nr/dr);
					  	self[id].Solution_imag[i]=ToNum(ni/dr);
					}
					var a1=self[matrixid].Solution_realdefault;
					var b1=self[matrixid].Solution_imagdefault;
					var nr=ToNum(a1*c-b1*d);							 
					var ni=ToNum(a1*d+b1*c); 
					var dr=ToNum(a2*c-b2*d); 
					var di=ToNum(a2*d+b2*c); 
				  	self[id].Solution_realdefault=ToNum(nr/dr);
				  	self[id].Solution_imagdefault=ToNum(ni/dr);
					var baseunits=new Array();
					for(var index in self[id1].Units_base_array) { baseunits[index]=self[id2].Units_base_array[index]-self[id1].Units_base_array[index]; }
					self[id]['Units_base_array']=baseunits;
					self[id].Get_My_BaseString();
				}else
				{	for (var i in self[matrixid].Solution_real) 
					{ 	if (isNaN(parseFloat(self[matrixid].Solution_real[i]))) { self[matrixid].Solution_real[i]=0; }
						if (isNaN(parseFloat(self[matrixid].Solution_imag[i]))) { self[matrixid].Solution_imag[i]=0; }
						if (isNaN(parseFloat(self[numid].Solution_real['0-0']))) { self[numid].Solution_real['0-0']=0; }
						if (isNaN(parseFloat(self[numid].Solution_imag['0-0']))) { self[numid].Solution_imag['0-0']=0; }
						var c=parseFloat(self[matrixid].Solution_real[i]);
						var d=-1*parseFloat(self[matrixid].Solution_imag[i]);
						var a1=parseFloat(self[numid].Solution_real['0-0']);
						var b1=parseFloat(self[numid].Solution_imag['0-0']);
						var a2=parseFloat(self[matrixid].Solution_real[i]);
						var b2=parseFloat(self[matrixid].Solution_imag[i]);
						var nr=ToNum(a1*c-b1*d); 
						var ni=ToNum(a1*d+b1*c); 
						var dr=ToNum(a2*c-b2*d); 
						var di=ToNum(a2*d+b2*c);							 
					  	self[id].Solution_real[i]=ToNum(nr/dr);
					  	self[id].Solution_imag[i]=ToNum(ni/dr);
					}
					var a2=parseFloat(self[matrixid].Solution_real[i]);
					var b2=parseFloat(self[matrixid].Solution_imag[i]);
					var nr=ToNum(a1*c-b1*d); 
					var ni=ToNum(a1*d+b1*c); 
					var dr=ToNum(a2*c-b2*d); 
					var di=ToNum(a2*d+b2*c);							 
				  	self[id].Solution_realdefault=ToNum(nr/dr);
				  	self[id].Solution_imagdefault=ToNum(ni/dr);
					var baseunits=new Array();
					for(var index in self[id1].Units_base_array) { baseunits[index]=self[id2].Units_base_array[index]-self[id1].Units_base_array[index]; }
					self[id]['Units_base_array']=baseunits;
					self[id].Get_My_BaseString();
				}
			break;
		}

		console.log('At the end of the scalar operations, the base array is ...');
		console.log(self[id1].Units_base_array);
		console.log(self[id2].Units_base_array);
		console.log(self[id].Units_base_array);

		return id;
	}
//-------------------------------------------------------------------------------------------------------------------------------------------------------------//
	
//-------------------------------------------------------------------------------------------------------------------------------------------------//
//----------------------------------------------------- BUILD FUNCTION LIST -----------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------------------------------//
/*
This function is called on page load. It creates an object named "Functions." This object is later looped through to determine if there is any 
built in function in the equation. If the text on the right side of the equal signs below is present, the function in the brackets is called.

*/
function Build_FunctionList() {
	Functions={};
	Functions['sin']="sin";
	Functions['cos']="cos";
	Functions['tan']="tan";    
	Functions['asin']="asin";
	Functions['acos']="acos";
	Functions['atan']="atan";
	Functions['atan2']="atan2";
	Functions['sinh']="sinh";
	Functions['cosh']="cosh";
	Functions['tanh']="tanh";
	Functions['asinh']="asinh";
	Functions['acosh']="acosh";
	Functions['atanh']="atanh";
	Functions['sec']="sec";
	Functions['csc']="csc";
	Functions['cot']="cot";
	Functions['asec']="asec";
	Functions['acsc']="acsc";
	Functions['acot']="acot";
	Functions['asech']="asech";
	Functions['acsch']="acsch";
	Functions['acoth']="acoth";
	Functions['root']="root";
	Functions['power']="power";
	Functions['ln']="ln";
	Functions['log10']="log10";
	Functions['log']="log";
	Functions['abs']="abs";
	Functions['floor']="floor";
	Functions['ceil']="ceil";
	Functions['round']="round";
	Functions['max']="max";
	Functions['min']="min";
	Functions['maxu']="maxu";
	Functions['minu']="minu";
	Functions['maxInd']="maxInd";
	Functions['minInd']="minInd";
	Functions['Transpose']="Transpose";
	Functions['Size']="Size";
	Functions['CreateMatrix']="CreateMatrix"; // Needs to be fixed to allow higher dimensions
	Functions['Identity']="Identity";
	Functions['NewtonCotes']="NewtonCotes";
	Functions['Integrate']="Integrate";
	Functions['DerivativeFun']="DerivativeFun";
	Functions['Derivative']="Derivative";
	Functions['DerivativeUn']="DerivativeUn";
	Functions['Real']="Real";
	Functions['Imag']="Imag";
	Functions['Append']="Append";
	Functions['rand']="rand";
	Functions['randMat']="randMat";
	Functions['squash']="squash"; // Not Working
	Functions['GaussE']="GaussE";
	Functions['LUDecomp']="LUDecomp";
	Functions['InverseLU']="InverseLU";
	Functions['sum']="sum";
	Functions['mean']="mean";
	Functions['median']="median";
	Functions['mode']="mode";
	Functions['range']="range";
	Functions['stdev']="stdev";
	Functions['variance']="variance";
	Functions['cv']="cv";
	Functions['polyfit']="polyfit";
	Functions['powerfit']="powerfit";
	Functions['logfit']="logfit";
	Functions['expfit']="expfit";
	Functions['histogram']="histogram";
	Functions['numinds']="numinds";
	Functions['Cholesky']="Cholesky";
	Functions['Norm']="Norm";
	Functions['CSNorm']="CSNorm";
	Functions['RSNorm']="RSNorm";
	Functions['Trace']="Trace";
	Functions['Conj']="Conj";
	Functions['DotMult']="DotMult";
	Functions['DotDiv']="DotDiv";
	Functions['Dot']="Dot";
	Functions['Cross']="Cross";
	Functions['Threshold']="Threshold";
	Functions['isColumn']="isColumn";
	Functions['isRow']="isRow";
	Functions['isMatrix']="isMatrix";
	Functions['NumEl']="NumEl";
	Functions['length']="length";
	Functions['fliplr']="fliplr";
	Functions['flipud']="flipud";
	Functions['diag']="diag";
	Functions['matur']="matur";
	Functions['matll']="matll";
	Functions['incSearch']="incSearch";
	Functions['Bisect']="Bisect";
	Functions['FalsePos']="FalsePos";
	Functions['Secant']="Secant";
	Functions['FFT']="FFT";
	Functions['Fourier']="Fourier";
	Functions['Row2Mat']="Row2Mat";
	Functions['Col2Mat']="Col2Mat";
	Functions['ODE4']="ODE4";
	Functions['Det']="Det";
	Functions['MatPow']="MatPow";
	Functions['IntVec']="IntVec";
	Functions['sign']="sign";
	Functions['rotate']="rotate";
	Functions['parseDate']="parseDate";
	Functions['isPosDef']="isPosDef";
	Functions['Interpolate']="Interpolate";
	Functions['IfElse']="IfElse";
	Functions['firstPos']="firstPos";
}																																				//	|
//-------------------------------------------------------------------------------------------------------------------------------------------------//


/*
	Handles the sin function for numbers and matrices
	For complex numbers, the algorithm follows the following:
	sin(a+bi)=sina * coshb + i(cosa * sinhb)
*/

Equation.prototype.sin = function(replacetext, pid, pos, callback)
{	var real=0, imag=0, num1='', flag=0;
	replacetext=replacetext.replace(/^sin\(/,"");	
	replacetext=replacetext.replace(/\)$/,"");	
	var inputarray=InputArray(replacetext);	
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "sin"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "sin"); flag=1; }
	if (flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'],Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"SinEq="+inputarray[0]};	
		var tempid=CreateEq(this.fileid, 1, eqobj);	
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad')) 
		{ Set_Error(this.Original_id, "Trig2", "sin", self[tempid]['Units_units']); flag=1; }	
		if (flag==0)	
		{	var id=CreateEq(this.fileid, 0, eqobj);	
			for (var index in self[tempid].Solution_real)	
			{	if (self[tempid].Solution_real[index]!==undefined) 
				{			real=self[tempid].Solution_real[index];	
				}else {		real=self[tempid].Solution_realdefault;}
				if (self[tempid].Solution_imag[index]!==undefined) 	
				{			imag=self[tempid].Solution_imag[index];	
				}else {		imag=self[tempid].Solution_imagdefault;}
				self[id].Solution_real[index]=ToNum(Math.sin(real)*0.5*(Math.exp(imag)+Math.exp(-imag)));
				self[id].Solution_imag[index]=ToNum(Math.cos(real)*0.5*(Math.exp(imag)-Math.exp(-imag)));
			}	
			self[id].Format_size=self[tempid].Format_size;
			self[id].Format_showequation="sin \\left("+self[tempid].Format_showequation+" \\right)";
			//this.Solution_temps.push(self[id].Format_id);
			//this.Solution_temps.push(self[tempid].Format_id);
			SetModels("sin", id, tempid);
			self[pid].Solution_variable_array[pos]=id;
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
			DOM_Object[id]['real']=self[id].Solution_real;	
			DOM_Object[id]['size']=self[id]['Format_size'];	
			DOM_Object[id]['imag']['0-0']=0;
		}	
	}	
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}

/*
	This function adds the cosine ability to the equation prototype

	For complex numbers, the algorithm follows the following:
	cos(a+bi)=cosa * coshb + i(sina*sinhb)
*/


Equation.prototype.cos = function(replacetext, pid, pos, callback)	
{	var real=0, imag=0, flag=0;	
	replacetext=replacetext.replace(/^cos\(/,"");
	replacetext=replacetext.replace(/\)$/,"");	
	var inputarray=InputArray(replacetext);	
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "cos"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "cos"); flag=1;}
	if (flag==0)	
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'],Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);	
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad')) 
		{	Set_Error(this.Original_id, "Trig2", "cos", self[tempid]['Units_units']); flag=1; }	
		if (flag==0)
		{	var id=CreateEq(this.fileid, 0, eqobj);	
			for (var index in self[tempid].Solution_real)
			{	if (self[tempid].Solution_real[index]!==undefined)
				{			real=self[tempid].Solution_real[index];	
				}else {		real=self[tempid].Solution_realdefault;}
				if (self[tempid].Solution_imag[index]!==undefined)
				{			imag=self[tempid].Solution_imag[index];
				}else {		imag=self[tempid].Solution_imagdefault;}
				self[id].Solution_real[index]=ToNum(Math.cos(real)*0.5*(Math.exp(imag)+Math.exp(-imag)));
				self[id].Solution_imag[index]=-ToNum(Math.sin(real)*0.5*(Math.exp(imag)-Math.exp(-imag)));
			}	
			self[id].Format_size=self[tempid].Format_size;
			SetModels("cos", id, tempid);
			self[id].Format_showequation="cos \\left("+self[tempid].Format_showequation+" \\right)";
			self[pid].Solution_variable_array[pos]=id;
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
			DOM_Object[id]['real']=self[id].Solution_real;
			DOM_Object[id]['size']=self[id]['Format_size'];	
			DOM_Object[id]['imag']['0-0']=0;
		}
	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}

/*
	This function adds the tangent function to the equation prototype
*/
Equation.prototype.tan = function(replacetext, pid, pos, callback)
{	var flag=0;		
	replacetext=replacetext.replace(/^tan\(/,"");
	replacetext=replacetext.replace(/\)$/,"");	
	var inputarray=InputArray(replacetext);	
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "tan"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "tan"); flag=1; }
	if (flag==0)	
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'],Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad')) 
		{ Set_Error(this.Original_id, "Trig2", "tan", self[tempid]['Units_units']); flag=1; }
		if (flag==0)
		{	var tanid=CreateEq(this.fileid, 0, eqobj);
			var tanobj = { tempid: tempid, tanid: tanid, tanind: 0, parentid:this.Format_id };
			for (var tanind in self[tempid].Solution_real)
			{	tanobj['tanind']=tanind;
				Tangent1(tanobj, function() { 
				Tangent2(tanobj, function() {
				DivideComplex(tanobj, function(){
				Tangent3(tanobj) }) }) });
				console.log('Div - '+tanobj['real']+' '+tanobj['imag'])

			}		
			self[tanid].Format_showequation="tan \\left("+self[tempid].Format_showequation+" \\right)";
			this.Solution_temps.push(self[tanid].Format_id);
			self[tanid].Format_size=self[tempid].Format_size;
			SetModels("tan", tanid, tempid);
			DOM_Object[tanid]['real']=self[tanid].Solution_real;
			DOM_Object[tanid]['size']=self[tanid]['Format_size'];
			DOM_Object[tanid]['imag']['0-0']=0;
			self[pid].Solution_variable_array[pos]=tanid;
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
		}			
	}				
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}					
function Tangent1(tanobj, callback)	
{	if (self[tanobj['tempid']].Solution_real[tanobj['tanind']]!==undefined) 
	{		tanobj['real']=self[tanobj['tempid']].Solution_real[tanobj['tanind']];
	}else {	tanobj['real']=self[tanobj['tempid']].Solution_realdefault; }
	if (self[tanobj['tempid']].Solution_imag[tanobj['tanind']]!==undefined) 
	{		tanobj['imag']=self[tanobj['tempid']].Solution_imag[tanobj['tanind']];
	}else {	tanobj['imag']=self[tanobj['tempid']].Solution_imagdefault; } 
	callback();		
}					
function Tangent2(tanobj, callback)	
{	tanobj['numreal']=ToNum(Math.sin(tanobj['real'])*0.5*(Math.exp(tanobj['imag'])+Math.exp(-tanobj['imag']))); 
	tanobj['numimag']=ToNum(Math.cos(tanobj['real'])*0.5*(Math.exp(tanobj['imag'])-Math.exp(-tanobj['imag']))); 
	tanobj['denreal']=ToNum(Math.cos(tanobj['real'])*0.5*(Math.exp(tanobj['imag'])+Math.exp(-tanobj['imag'])));	
	tanobj['denimag']=-ToNum(Math.sin(tanobj['real'])*0.5*(Math.exp(tanobj['imag'])-Math.exp(-tanobj['imag'])));

	console.log('Sin - '+tanobj['numreal']+' '+tanobj['numimag'])
	console.log('Cos - '+tanobj['denreal']+' '+tanobj['denimag'])
	callback();		

}					
function Tangent3(tanobj)
{		self[tanobj['tanid']].Solution_real[tanobj['tanind']]=tanobj['real'];
		self[tanobj['tanid']].Solution_imag[tanobj['tanind']]=tanobj['imag'];
}					
/*
	This function performs the asin math for an equation object. This is done by 
	the formula -iln[ix + sqrt(1-x^2)]
*/
Equation.prototype.asin = function(replacetext, pid, pos, callback)
{	var flag=0;
	replacetext=replacetext.replace(/^asin\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "asin"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "asin"); flag=1;}
	if (flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'],Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad')) 
		{ Set_Error(this.Original_id, "Trig2", "asin", self[tempid]['Units_units']); flag=1; }
		if (flag==0)
		{	var asinid=CreateEq(this.fileid, 0, eqobj);
			var asinobj = { tempid: tempid, asinid: asinid, asinind: 0, parentid:this.Format_id };
			for (var asinind in self[tempid].Solution_real)
			{	asinobj['asinind']=asinind;
				Asin1(asinobj, function() { 
				SquareComplex(asinobj, function() { 
				Asin2(asinobj, function(){
				SquareRoot(asinobj, function() { 
				Asin3(asinobj, function(){ 
				NatLog(asinobj, function(){ 
				Asin4(asinobj, function(){ }) }) }) }) }) }) });
			}
			self[asinid].Format_showequation="asin \\left("+self[tempid].Format_showequation+" \\right)";
			self[asinid].Format_showtype="builtin";
			this.Solution_temps.push(self[asinid].Format_id);
			self[asinid].Format_size=self[tempid].Format_size;
			DOM_Object[asinid]['real']=self[asinid].Solution_real;
			DOM_Object[asinid]['size']=self[asinid]['Format_size'];
			DOM_Object[asinid]['imag']['0-0']=0;
			SetModels("asin", asinid, tempid);
			self[pid].Solution_variable_array[pos]=asinid;
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}		
function Asin1(asinobj, callback)
{	if (self[asinobj['tempid']].Solution_real[asinobj['asinind']]!==undefined) 
	{		asinobj['real']=self[asinobj['tempid']].Solution_real[asinobj['asinind']];
			asinobj['orig_real']=self[asinobj['tempid']].Solution_real[asinobj['asinind']];
	}else {	asinobj['real']=self[asinobj['tempid']].Solution_realdefault; 
			asinobj['orig_real']=self[asinobj['tempid']].Solution_realdefault;	} 
	if (self[asinobj['tempid']].Solution_imag[asinobj['asinind']]!==undefined) 
	{		asinobj['imag']=self[asinobj['tempid']].Solution_imag[asinobj['asinind']];
			asinobj['orig_imag']=self[asinobj['tempid']].Solution_imag[asinobj['asinind']];
	}else {	asinobj['imag']=self[asinobj['tempid']].Solution_imagdefault; 
			asinobj['orig_imag']=self[asinobj['tempid']].Solution_imagdefault;	} 
	callback();
}    	
function Asin2(asinobj, callback)
{	asinobj['real']=1-asinobj['real'];
	asinobj['imag']=-asinobj['imag'];
	callback();
}		
function Asin3(asinobj, callback)
{	var real=-asinobj['orig_imag']+asinobj['real'];
	var imag=asinobj['orig_real']+asinobj['imag'];
	asinobj['real']=real;
	asinobj['imag']=imag;
	callback();
}		
function Asin4(asinobj, callback)
{	self[asinobj['asinid']].Solution_real[asinobj['asinind']]=asinobj['imag'];
	self[asinobj['asinid']].Solution_imag[asinobj['asinind']]=-asinobj['real'];
}		
//---------------------------------------------------------------------------------------------------------//
/*
	This is the acos function. It is formulated by pi/2+iln[ix + sqrt(1-x^2)]
*/
Equation.prototype.acos = function(replacetext, pid, pos, callback)
{	var flag=0;
	replacetext=replacetext.replace(/^acos\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "acos"); flag=1;}
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "acos"); flag=1; }
	if (flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'],Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad')) 
		{ Set_Error(this.Original_id, "Trig2", "cot", self[tempid]['Units_units']); flag=1; }
		if (flag==0)
		{	var acosid=CreateEq(this.fileid, 0, eqobj);
			var acosobj = { tempid: tempid, acosid: acosid, acosind: 0, parentid:this.Format_id };
			for (var acosind in self[tempid].Solution_real)
			{	acosobj['acosind']=acosind;
				Acos1(acosobj, function() { 
				SquareComplex(acosobj, function() { 
				Acos2(acosobj, function(){
				SquareRoot(acosobj, function() { 
				Acos3(acosobj, function(){ 
				NatLog(acosobj, function(){ 
				Acos4(acosobj) }) }) }) }) }) });
			}
			self[acosid].Format_showequation="acos \\left("+self[tempid].Format_showequation+" \\right)";
			self[acosid].Format_showtype="builtin";
			this.Solution_temps.push(self[acosid].Format_id);
			self[acosid].Format_size=self[tempid].Format_size;
			DOM_Object[acosid]['real']=self[acosid].Solution_real;
			DOM_Object[acosid]['size']=self[acosid]['Format_size'];
			DOM_Object[acosid]['imag']['0-0']=0;
			SetModels("acos", acosid, tempid);
			self[pid].Solution_variable_array[pos]=acosid;
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function Acos1(acosobj, callback)
{	if (self[acosobj['tempid']].Solution_real[acosobj['acosind']]!==undefined) 
	{		acosobj['real']=self[acosobj['tempid']].Solution_real[acosobj['acosind']];
			acosobj['orig_real']=self[acosobj['tempid']].Solution_real[acosobj['acosind']];
	}else {	acosobj['real']=self[acosobj['tempid']].Solution_realdefault; 
			acosobj['orig_real']=self[acosobj['tempid']].Solution_realdefault;	} 
	if (self[acosobj['tempid']].Solution_imag[acosobj['acosind']]!==undefined) 
	{		acosobj['imag']=self[acosobj['tempid']].Solution_imag[acosobj['acosind']];
			acosobj['orig_imag']=self[acosobj['tempid']].Solution_imag[acosobj['acosind']];
	}else {	acosobj['imag']=self[acosobj['tempid']].Solution_imagdefault; 
			acosobj['orig_imag']=self[acosobj['tempid']].Solution_imagdefault;	} 
	callback();
}    
function Acos2(acosobj, callback){ acosobj['real']=1-acosobj['real']; 
	acosobj['imag']=-acosobj['imag'];
	callback(); 
}															
function Acos3(acosobj, callback){	var real=-acosobj['orig_imag']+acosobj['real'];
	var imag=acosobj['orig_real']+acosobj['imag'];
	acosobj['real']=real; acosobj['imag']=imag; 
	callback();	 
}
function Acos4(acosobj, callback){
	self[acosobj['acosid']].Solution_real[acosobj['acosind']]=Math.PI/2-acosobj['imag'];	
	self[acosobj['acosid']].Solution_imag[acosobj['acosind']]=acosobj['real'];}

/*
	0.5*i*[ ln(1-iz) - ln(1+iz) ]
*/
Equation.prototype.atan = function(replacetext, pid, pos, callback)
{	var flag=0;
	replacetext=replacetext.replace(/^atan\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "atan"); flag=1;}
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "atan"); flag=1; }
	if (flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'],Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad')) 
		{ Set_Error(this.Original_id, "Trig2", "cot", self[tempid]['Units_units']); flag=1; }
		if (flag==0)
		{	var atanid=CreateEq(this.fileid, 0, eqobj);
			var atanobj = { tempid: tempid, atanid: atanid, atanind: 0, parentid:this.Format_id };
			for (var atanind in self[tempid].Solution_real)
			{	atanobj['atanind']=atanind;
				Atan1(atanobj, function() { 
				NatLog(atanobj, function() { 
				Atan3(atanobj, function(){
				NatLog(atanobj, function() { 
				Atan4(atanobj) }) }) }) });
			}
			self[atanid].Format_showequation="atan \\left("+self[tempid].Format_showequation+" \\right)";
			self[atanid].Format_showtype="builtin";
			//this.Solution_temps.push(self[atanid].Format_id);
			self[atanid].Format_size=self[tempid].Format_size;
			DOM_Object[atanid]['real']=self[atanid].Solution_real;
			DOM_Object[atanid]['size']=self[atanid]['Format_size'];
			DOM_Object[atanid]['imag']['0-0']=0;
			SetModels("atan", atanid, tempid);
			self[pid].Solution_variable_array[pos]=atanid;
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function Atan1(atanobj, callback)
{	if (self[atanobj['tempid']].Solution_real[atanobj['atanind']]!==undefined) 
	{		atanobj['orig_real']=self[atanobj['tempid']].Solution_real[atanobj['atanind']];
	}else {	atanobj['orig_real']=self[atanobj['tempid']].Solution_realdefault;	} 
	if (self[atanobj['tempid']].Solution_imag[atanobj['atanind']]!==undefined) 
	{		atanobj['orig_imag']=self[atanobj['tempid']].Solution_imag[atanobj['atanind']];
	}else {	atanobj['orig_imag']=self[atanobj['tempid']].Solution_imagdefault;	} 
	atanobj['real']=1+parseFloat(atanobj['orig_imag']);
	atanobj['imag']=parseFloat(-atanobj['orig_real']);
	callback();
}    
function Atan3(atanobj, callback)
{	atanobj['log1_real']=atanobj['real'];
	atanobj['log1_imag']=atanobj['imag'];
	atanobj['real']=ToNum(1-atanobj['orig_imag']);
	atanobj['imag']=ToNum(atanobj['orig_real']);
	callback();
}
function Atan4(atanobj, callback)
{	var imag=0.5*ToNum(atanobj['log1_real']-atanobj['real']);
	var real=-0.5*ToNum(atanobj['log1_imag']-atanobj['imag']);
	self[atanobj['atanid']].Solution_real[atanobj['atanind']]=real;
	self[atanobj['atanid']].Solution_imag[atanobj['atanind']]=imag;
}
//---------------------------------------------------------------------------------------------------------//

/*
	arctan2(y,x)=...from wiki atan2
*/
Equation.prototype.atan2 = function(replacetext, pid, pos, callback)
{
	replacetext=replacetext.replace(/^atan2\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length>2) { Set_Error(this.Original_id, "Trig2", inputarray.length, "atan2");  }
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "atan2"); }
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
	var id2=CreateEq(this.fileid, 1, eqobj);
	var id=CreateEq(this.fileid, 0, eqobj);
	for (var index in self[id1].Solution_real)
	{	if (self[id1].Solution_real[index]!==undefined) {real1=self[id1].Solution_real[index];
		}else {												real1=self[id1].Solution_realdefault; }
		if (self[id1].Solution_imag[index]!==undefined) {imag1=self[id1].Solution_imag[index];
		}else {												imag1=self[id1].Solution_imagdefault; } 
		if (self[id2].Solution_real[index]!==undefined) {real2=self[id2].Solution_real[index];
		}else {												real2=self[id2].Solution_realdefault; }
		if (self[id2].Solution_imag[index]!==undefined) {imag2=self[id2].Solution_imag[index];
		}else {												imag2=self[id2].Solution_imagdefault; } 
		var x=real2;
		var y=real1;
		if (x>0) 					{ self[id].Solution_real[index]=Math.atan(y/x);  
		}else if ((x<0)&&(y>=0))	{ self[id].Solution_real[index]=Math.atan(y/x)+Math.PI;  
		}else if ((x<0)&&(y<0)) 	{ self[id].Solution_real[index]=Math.atan(y/x)-Math.PI;  
		}else if ((x===0)&&(y>0)) 	{ self[id].Solution_real[index]=Math.PI/2;			  
		}else if ((x===0)&&(y<0)) 	{ self[id].Solution_real[index]=-Math.PI/2; 
		}else if ((x===0)&&(y===0)) 	{ self[id].Solution_real[index]=undefined;	} 
	}
	self[id].Format_showequation="atan2 \\left("+self[id1].Format_showequation+","+self[id2].Format_showequation+" \\right)";
	self[id].Format_showtype="builtin";
	this.Solution_temps.push(self[id].Format_id);
	DOM_Object[id]['real']=self[id].Solution_real;
	DOM_Object[id]['size']=self[id]['Format_size'];
	DOM_Object[id]['imag']['0-0']=0;
	DOM_Object[id]['units']=self[id].Units_units;
	self[pid].Solution_variable_array[pos]=id;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------- sinh(a+bi) = sinha * cosb + i(cosha * sinb) -------------------------------------------------------------------------------------//
Equation.prototype.sinh = function(replacetext, pid, pos, callback)
{	var flag=0;
	replacetext=replacetext.replace(/^sinh\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "sinh"); flag=1;}
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "sinh"); flag=1; }
	if (flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad')) 
		{ Set_Error(this.Original_id, "Trig2", "acot", self[tempid]['Units_units']); flag=1; }
		if (flag==0)
		{	var id=CreateEq(this.fileid, 0, eqobj);
			var obj = { tempid: tempid, id: id, ind: 0, parentid:this.Format_id };
			for (var ind in self[tempid].Solution_real)
			{	if (self[obj['tempid']].Solution_real[ind]!==undefined) 
				{		obj['real']=self[obj['tempid']].Solution_real[ind];
				}else {	obj['real']=self[obj['tempid']].Solution_realdefault;	} 
				if (self[obj['tempid']].Solution_imag[ind]!==undefined) 
				{		obj['imag']=self[obj['tempid']].Solution_imag[ind];
				}else {	obj['imag']=self[obj['tempid']].Solution_imagdefault;	} 
				self[id].Solution_real[ind]=ToNum(((Math.exp(parseFloat(obj['real']))-Math.exp(-parseFloat(obj['real'])))/2)*Math.cos(obj['imag'])); 
				self[id].Solution_imag[ind]=ToNum(((Math.exp(parseFloat(obj['real']))+Math.exp(-parseFloat(obj['real'])))/2)*Math.sin(obj['imag'])); 
			}
			self[id].Format_showequation="sinh \\left("+self[tempid].Format_showequation+" \\right)";
			this.Solution_temps.push(self[id].Format_id);
			self[id].Format_size=self[tempid].Format_size;
			DOM_Object[id]['real']=self[id].Solution_real;
			DOM_Object[id]['size']=self[id]['Format_size'];
			DOM_Object[id]['imag']['0-0']=0;
			SetModels("sinh", id, tempid);
			self[pid].Solution_variable_array[pos]=id;
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//--------------------------- cosh(a+bi) = cosha * cosb + i(sinha * sinb) ------------------------------------------------------------------------------//
Equation.prototype.cosh = function(replacetext, pid, pos, callback)
{	var flag=0;
	replacetext=replacetext.replace(/^cosh\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "cosh"); flag=1;}
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "cosh"); flag=1; }
	if (flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad')) 
		{ Set_Error(this.Original_id, "Trig2", "cosh", self[tempid]['Units_units']); flag=1; }
		if (flag==0)
		{	var id=CreateEq(this.fileid, 0, eqobj);
			var obj = { tempid: tempid, id: id, ind: 0, parentid:this.Format_id };
			for (var ind in self[tempid].Solution_real)
			{	if (self[obj['tempid']].Solution_real[ind]!==undefined) 
				{		obj['real']=self[obj['tempid']].Solution_real[ind];
				}else {	obj['real']=self[obj['tempid']].Solution_realdefault;	} 
				if (self[obj['tempid']].Solution_imag[ind]!==undefined) 
				{		obj['imag']=self[obj['tempid']].Solution_imag[ind];
				}else {	obj['imag']=self[obj['tempid']].Solution_imagdefault;	} 
				self[id].Solution_real[ind]=ToNum(((Math.exp(obj['real'])+Math.exp(-obj['real']))/2)*Math.cos(obj['imag']));	 
				self[id].Solution_imag[ind]=ToNum(((Math.exp(obj['real'])-Math.exp(-obj['real']))/2)*Math.sin(obj['imag'])); 
			}
			self[id].Format_showequation="cosh \\left("+self[tempid].Format_showequation+" \\right)";
			this.Solution_temps.push(self[id].Format_id);
			self[id].Format_size=self[tempid].Format_size;
			DOM_Object[id]['real']=self[id].Solution_real;
			DOM_Object[id]['size']=self[id]['Format_size'];
			DOM_Object[id]['imag']['0-0']=0;
			SetModels("cosh", id, tempid);
			self[pid].Solution_variable_array[pos]=id;
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//------------------------------- tanh(a+bi) = sinh(a+bi)/cosh(a+bi) --------------------------------------------------------------------------//
Equation.prototype.tanh = function(replacetext, pid, pos, callback)
{	var flag=0;
	replacetext=replacetext.replace(/^tanh\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "tanh"); flag=1;}
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "tanh"); flag=1; }
	if (flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad')) 
		{ Set_Error(this.Original_id, "Trig2", "tanh", self[tempid]['Units_units']); flag=1; }
		if (flag==0)
		{	var tanhid=CreateEq(this.fileid, 0, eqobj);
			var tanhobj = { tempid: tempid, tanhid: tanhid, tanhind: 0, parentid:this.Format_id };
			for (var tanhind in self[tempid].Solution_real)
			{	tanhobj['tanhind']=tanhind;
				Tanh1(tanhobj, function(){ DivideComplex(tanhobj, function() { Tanh2(tanhobj)	}) });
			}
			self[tanhid].Format_showequation="tanh \\left("+self[tempid].Format_showequation+" \\right)";
			self[tanhid].Format_showtype="builtin";
			this.Solution_temps.push(self[tanhid].Format_id);
			self[tanhid].Format_size=self[tempid].Format_size;
			DOM_Object[tanhid]['real']=self[tanhid].Solution_real;
			DOM_Object[tanhid]['size']=self[tanhid]['Format_size'];
			DOM_Object[tanhid]['imag']['0-0']=0;
			SetModels("tanh", tanhid, tempid);
			self[pid].Solution_variable_array[pos]=tanhid;
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function Tanh1(tanhobj, callback)
{	if (self[tanhobj['tempid']].Solution_real[tanhobj['tanhind']]!==undefined) 
	{		tanhobj['real']=self[tanhobj['tempid']].Solution_real[tanhobj['tanhind']];
	}else {	tanhobj['real']=self[tanhobj['tempid']].Solution_realdefault;	} 
	if (self[tanhobj['tempid']].Solution_imag[tanhobj['tanhind']]!==undefined) 
	{		tanhobj['imag']=self[tanhobj['tempid']].Solution_imag[tanhobj['tanhind']];
	}else {	tanhobj['imag']=self[tanhobj['tempid']].Solution_imagdefault;	} 
	tanhobj['numreal']=ToNum(((Math.exp(parseFloat(tanhobj['real']))-Math.exp(-parseFloat(tanhobj['real'])))/2)*Math.cos(tanhobj['imag']));	
	tanhobj['numimag']=ToNum(((Math.exp(parseFloat(tanhobj['real']))+Math.exp(-parseFloat(tanhobj['real'])))/2)*Math.sin(tanhobj['imag']));	
	tanhobj['denreal']=ToNum(((Math.exp(tanhobj['real'])+Math.exp(-tanhobj['real']))/2)*Math.cos(tanhobj['imag'])); 
	tanhobj['denimag']=ToNum(((Math.exp(tanhobj['real'])-Math.exp(-tanhobj['real']))/2)*Math.sin(tanhobj['imag'])); 
	callback();
}    
function Tanh2(tanhobj, callback)
{	self[tanhobj['tanhid']].Solution_real[tanhobj['tanhind']]=tanhobj['real'];
	self[tanhobj['tanhid']].Solution_imag[tanhobj['tanhind']]=tanhobj['imag'];
}
//---------------------------------------------------------------------------------------------------------//

//------------------------------ asinh(z) = ln[ z+ sqrt(z^2+1) ] ---------------------------------------------------------------------------//
Equation.prototype.asinh = function(replacetext, pid, pos, callback)
{	var flag=0;
	replacetext=replacetext.replace(/^asinh\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "asinh"); flag=1;}
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "asinh"); flag=1; }
	if (flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad')) 
		{ Set_Error(this.Original_id, "Trig2", "asinh", self[tempid]['Units_units']); flag=1; }
		if (flag==0)
		{	var asinhid=CreateEq(this.fileid, 0, eqobj);
			var asinhobj = { tempid: tempid, asinhid: asinhid, asinhind: 0, parentid:this.Format_id };
			for (var asinhind in self[tempid].Solution_real)
			{	asinhobj['asinhind']=asinhind;
				Asinh1(asinhobj, function(){ 
				SquareComplex(asinhobj, function() { 
				Asinh2(asinhobj, function(){ 
				SquareRoot(asinhobj, function(){ 
				Asinh3(asinhobj, function(){ 
				NatLog(asinhobj, function(){ 
				Asinh4(asinhobj) }) }) }) }) }) });
			}
			self[asinhid].Format_showequation="asinh \\left("+self[tempid].Format_showequation+" \\right)";//\
			self[asinhid].Format_showtype="builtin";
			self[asinhid].Format_size=self[tempid].Format_size;
			this.Solution_temps.push(self[asinhid].Format_id);
			DOM_Object[asinhid]['real']=self[asinhid].Solution_real;
			DOM_Object[asinhid]['size']=self[asinhid]['Format_size'];
			DOM_Object[asinhid]['imag']['0-0']=0;
			SetModels("asinh", asinhid, tempid);
			self[pid].Solution_variable_array[pos]=asinhid;
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function Asinh1(asinhobj, callback)
{	if (self[asinhobj['tempid']].Solution_real[asinhobj['asinhind']]!==undefined) 
	{		asinhobj['real']=self[asinhobj['tempid']].Solution_real[asinhobj['asinhind']];
	}else {	asinhobj['real']=self[asinhobj['tempid']].Solution_realdefault;	} 
	if (self[asinhobj['tempid']].Solution_imag[asinhobj['asinhind']]!==undefined) 
	{		asinhobj['imag']=self[asinhobj['tempid']].Solution_imag[asinhobj['asinhind']];
	}else {	asinhobj['imag']=self[asinhobj['tempid']].Solution_imagdefault;	} 
	asinhobj['orig_real']=asinhobj['real'];		asinhobj['orig_imag']=asinhobj['imag'];
	callback();
}    
function Asinh2(asinhobj, callback)
{	asinhobj['real']=ToNum(parseFloat(asinhobj['real'])+1);		callback();
}    
function Asinh3(asinhobj, callback)
{	asinhobj['real']=asinhobj['real']+asinhobj['orig_real'];
	asinhobj['imag']=asinhobj['imag']+asinhobj['orig_imag'];
	callback();
}    
function Asinh4(asinhobj, callback)
{	self[asinhobj['asinhid']].Solution_real[asinhobj['asinhind']]=asinhobj['real'];
	self[asinhobj['asinhid']].Solution_imag[asinhobj['asinhind']]=asinhobj['imag'];
}
//---------------------------------------------------------------------------------------------------------//

//----------------------------- acosh(z) = ln[ z + sqrt(z-1) * sqrt(z+1) ] ----------------------------------------------------------------------------//
Equation.prototype.acosh = function(replacetext, pid, pos, callback)
{	var flag=0;
	replacetext=replacetext.replace(/^acosh\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "acosh"); flag=1;}
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "acosh"); flag=1; }
	if (flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad')) 
		{ Set_Error(this.Original_id, "Trig2", "acosh", self[tempid]['Units_units']); flag=1; }
		if (flag==0)
		{	var acoshid=CreateEq(this.fileid, 0, eqobj);
			var acoshobj = { tempid: tempid, acoshid: acoshid, acoshind: 0, parentid:this.Format_id };
			for (var acoshind in self[tempid].Solution_real)
			{	acoshobj['acoshind']=acoshind;
				Acosh1(acoshobj, function(){ 
				SquareRoot(acoshobj, function() { 
				Acosh2(acoshobj, function(){ 
				SquareRoot(acoshobj, function(){ 
				Acosh3(acoshobj, function(){ 
				NatLog(acoshobj, function(){ 
				Acosh4(acoshobj) }) }) }) }) }) });
			}
			self[acoshid].Format_showequation="acosh \\left("+self[tempid].Format_showequation+" \\right)";//\
			self[acoshid].Format_showtype="builtin";
			this.Solution_temps.push(self[acoshid].Format_id);
			self[acoshid].Format_size=self[tempid].Format_size;
			DOM_Object[acoshid]['real']=self[acoshid].Solution_real;
			DOM_Object[acoshid]['size']=self[acoshid]['Format_size'];
			DOM_Object[acoshid]['imag']['0-0']=0;
			SetModels("acos", acoshid, tempid);
			self[pid].Solution_variable_array[pos]=acoshid;
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function Acosh1(acoshobj, callback)
{	if (self[acoshobj['tempid']].Solution_real[acoshobj['acoshind']]!==undefined) 
	{		acoshobj['real']=self[acoshobj['tempid']].Solution_real[acoshobj['acoshind']];
	}else {	acoshobj['real']=self[acoshobj['tempid']].Solution_realdefault;	} 
	if (self[acoshobj['tempid']].Solution_imag[acoshobj['acoshind']]!==undefined) 
	{		acoshobj['imag']=self[acoshobj['tempid']].Solution_imag[acoshobj['acoshind']];
	}else {	acoshobj['imag']=self[acoshobj['tempid']].Solution_imagdefault;	} 
	acoshobj['orig_real']=acoshobj['real'];		acoshobj['orig_imag']=acoshobj['imag'];
	acoshobj['real']=ToNum(parseFloat(acoshobj['real'])-1);
	callback();
}    
function Acosh2(acoshobj, callback)
{	acoshobj['sq1_real']=acoshobj['real']; acoshobj['sq1_imag']=acoshobj['imag'];
	acoshobj['real']=ToNum(parseFloat(acoshobj['orig_real'])+1); acoshobj['imag']=acoshobj['orig_imag'];
	callback();
}    
function Acosh3(acoshobj, callback)
{	
	acoshobj['sq2_real']=acoshobj['real'];
	acoshobj['sq2_imag']=acoshobj['imag'];
	acoshobj['real']=ToNum(acoshobj['sq1_real']*acoshobj['sq2_real'])-ToNum(acoshobj['sq1_imag']*acoshobj['sq2_imag'])+ToNum(acoshobj['orig_real']);
	acoshobj['imag']=ToNum(acoshobj['sq1_real']*acoshobj['sq2_imag'])+ToNum(acoshobj['sq1_imag']*acoshobj['sq2_real'])+ToNum(acoshobj['orig_imag']);
	callback();}    
function Acosh4(acoshobj, callback)
{	self[acoshobj['acoshid']].Solution_real[acoshobj['acoshind']]=acoshobj['real'];
	self[acoshobj['acoshid']].Solution_imag[acoshobj['acoshind']]=acoshobj['imag'];
}
//---------------------------------------------------------------------------------------------------------//

//--------------------- atanh(z) = 0.5 * [ ln(1+z) - ln(1-z) ] ------------------------------------------------------------------------------------//
Equation.prototype.atanh = function(replacetext, pid, pos, callback)
{	var flag=0;
	replacetext=replacetext.replace(/^atanh\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "atanh"); flag=1;}
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "atanh"); flag=1; }
	if (flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad')) 
		{ Set_Error(this.Original_id, "Trig2", "acosh", self[tempid]['Units_units']); flag=1; }
		if (flag==0)
		{	var atanhid=CreateEq(this.fileid, 0, eqobj);
			var atanhobj = { tempid: tempid, atanhid: atanhid, atanhind: 0, parentid:this.Format_id };
			for (var atanhind in self[tempid].Solution_real)
			{	atanhobj['atanhind']=atanhind;
				Atanh1(atanhobj, function(){ 
				NatLog(atanhobj, function() { 
				Atanh2(atanhobj, function(){  
				NatLog(atanhobj, function(){ 
				Atanh3(atanhobj)	}) }) }) });
			}
			self[atanhid].Format_showequation="atanh\\left("+self[tempid].Format_showequation+"\\right)";
			self[atanhid].Format_showtype="builtin";
			this.Solution_temps.push(self[atanhid].Format_id);
			self[atanhid].Format_size=self[tempid].Format_size;
			DOM_Object[atanhid]['real']=self[atanhid].Solution_real;
			DOM_Object[atanhid]['size']=self[atanhid]['Format_size'];
			DOM_Object[atanhid]['imag']['0-0']=0;
			SetModels("atanh", atanhid, tempid);
			self[pid].Solution_variable_array[pos]=atanhid;
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function Atanh1(atanhobj, callback)
{	if (self[atanhobj['tempid']].Solution_real[atanhobj['atanhind']]!==undefined) 
	{		atanhobj['real']=self[atanhobj['tempid']].Solution_real[atanhobj['atanhind']];
	}else {	atanhobj['real']=self[atanhobj['tempid']].Solution_realdefault;	} 
	if (self[atanhobj['tempid']].Solution_imag[atanhobj['atanhind']]!==undefined) 
	{		atanhobj['imag']=self[atanhobj['tempid']].Solution_imag[atanhobj['atanhind']];
	}else {	atanhobj['imag']=self[atanhobj['tempid']].Solution_imagdefault;	} 
	atanhobj['orig_real']=atanhobj['real'];		atanhobj['orig_imag']=atanhobj['imag'];
	atanhobj['real']=ToNum(parseFloat(atanhobj['real'])+1);
	atanhobj['imag']=ToNum(parseFloat(atanhobj['imag']));
	callback();
}    
function Atanh2(atanhobj, callback)
{	atanhobj['nl1_real']=atanhobj['real']; atanhobj['nl1_imag']=atanhobj['imag'];
	atanhobj['real']=ToNum(parseFloat(1-atanhobj['orig_real'])); atanhobj['imag']=-atanhobj['orig_imag'];
	callback();
}    
function Atanh3(atanhobj, callback)
{	atanhobj['real']=0.5*ToNum(atanhobj['nl1_real']-atanhobj['real']);
	atanhobj['imag']=0.5*ToNum(atanhobj['nl1_imag']-atanhobj['imag']);
	self[atanhobj['atanhid']].Solution_real[atanhobj['atanhind']]=atanhobj['real'];
	self[atanhobj['atanhid']].Solution_imag[atanhobj['atanhind']]=atanhobj['imag'];
}
//---------------------------------------------------------------------------------------------------------//

/*
	This function is the secant function. It is defined as 1/cos
*/
Equation.prototype.sec = function(replacetext, pid, pos, callback)	
{	var real=0, imag=0, cos_real=0, cos_imag=0, thisid='', flag=0;
	replacetext=replacetext.replace(/^sec\(/,"");
	replacetext=replacetext.replace(/\)$/,"");	
	var inputarray=InputArray(replacetext);	
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "sec"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "sec"); flag=1; }
	if (flag==0)	
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'],Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);	
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad')) 
		{ Set_Error(this.Original_id, "Trig2", "sec", self[tempid]['Units_units']); flag=1; }
		if (flag==0)
		{	var secid=CreateEq(this.fileid, 0, eqobj);	
			var secobj = { tempid: tempid, secid: secid, secind: 0, parentid:this.Format_id };	
			for (var secind in self[tempid].Solution_real)	
			{	secobj['secind']=secind;
				Secant1(secobj, function() {
				Secant2(secobj, function() {
				DivideComplex(secobj, function(){
				Secant3(secobj); }) }) });
		    }		
			self[secid].Format_showequation="sec \\left("+self[tempid].Format_showequation+" \\right)";
			this.Solution_temps.push(self[secid].Format_id);
			self[secid].Format_size=self[tempid].Format_size;
			DOM_Object[secid]['real']=self[secid].Solution_real;
			DOM_Object[secid]['size']=self[secid]['Format_size'];
			DOM_Object[secid]['imag']['0-0']=0;	
			SetModels("sec", secid, tempid);
			self[pid].Solution_variable_array[pos]=secid;
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}	}			
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}					
function Secant1(secobj, callback)	
{	if (self[secobj['tempid']].Solution_real[secobj['secind']]!==undefined) 
	{		secobj['real']=self[secobj['tempid']].Solution_real[secobj['secind']];
	}else {	secobj['real']=self[secobj['tempid']].Solution_realdefault; } 
	if (self[secobj['tempid']].Solution_imag[secobj['secind']]!==undefined)
	{		secobj['imag']=self[secobj['tempid']].Solution_imag[secobj['secind']];
	}else {	secobj['imag']=self[secobj['tempid']].Solution_imagdefault; }
	callback();		
}					
function Secant2(secobj, callback)	
{	secobj['denreal']=ToNum(Math.cos(secobj['real'])*0.5*(Math.exp(secobj['imag'])+Math.exp(-secobj['imag']))); 
	secobj['denimag']=ToNum(Math.sin(secobj['real'])*0.5*(Math.exp(secobj['imag'])-Math.exp(-secobj['imag']))); 
	secobj['numreal']=1;	secobj['numimag']=0;
	callback();		
}					
function Secant3(secobj)
{		self[secobj['secid']].Solution_real[secobj['secind']]=secobj['real'];
		self[secobj['secid']].Solution_imag[secobj['secind']]=-secobj['imag'];
}
/*
	This is the cosecant function. It is csc=1/sin
*/
Equation.prototype.csc = function(replacetext, pid, pos, callback)	
{	var flag=0;		
	replacetext=replacetext.replace(/^csc\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);	
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "csc"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "csc"); flag=1;}
	if (flag==0)	
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'],Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);	
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad'))
		{ Set_Error(this.Original_id, "Trig2", "csc", self[tempid]['Units_units']); flag=1; }	
		if (flag==0)
		{	var cscid=CreateEq(this.fileid, 0, eqobj);
			var cscobj = { tempid: tempid, cscid: cscid, cscind: 0, parentid:this.Format_id };
			for (var cscind in self[tempid].Solution_real)	
			{	cscobj['cscind']=cscind;
				Cosecant1(cscobj, function() { 
				Cosecant2(cscobj, function() { 
				DivideComplex(cscobj, function(){
				Cosecant3(cscobj); }) }) });
			}		
			self[cscid].Format_showequation="csc \\left("+self[tempid].Format_showequation+" \\right)";
			this.Solution_temps.push(self[cscid].Format_id);
			self[cscid].Format_size=self[tempid].Format_size;
			DOM_Object[cscid]['real']=self[cscid].Solution_real;
			DOM_Object[cscid]['size']=self[cscid]['Format_size'];
			DOM_Object[cscid]['imag']['0-0']=0;	
			SetModels("csc", cscid, tempid);
			self[pid].Solution_variable_array[pos]=cscid;	
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
		}			
	}				
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}					
function Cosecant1(cscobj, callback)	
{	if (self[cscobj['tempid']].Solution_real[cscobj['cscind']]!==undefined)
	{		cscobj['real']=self[cscobj['tempid']].Solution_real[cscobj['cscind']];
	}else {	cscobj['real']=self[cscobj['tempid']].Solution_realdefault; }
	if (self[cscobj['tempid']].Solution_imag[cscobj['cscind']]!==undefined) 
	{		cscobj['imag']=self[cscobj['tempid']].Solution_imag[cscobj['cscind']];
	}else {	cscobj['imag']=self[cscobj['tempid']].Solution_imagdefault; } 
	callback();		
}					
function Cosecant2(cscobj, callback)
{	cscobj['denreal']=ToNum(Math.sin(cscobj['real'])*0.5*(Math.exp(cscobj['imag'])+Math.exp(-cscobj['imag']))); 
	cscobj['denimag']=ToNum(-Math.cos(cscobj['real'])*0.5*(Math.exp(cscobj['imag'])-Math.exp(-cscobj['imag']))); 
	cscobj['numreal']=1;	cscobj['numimag']=0;
	callback();		
}					
function Cosecant3(cscobj)	
{		self[cscobj['cscid']].Solution_real[cscobj['cscind']]=cscobj['real'];
		self[cscobj['cscid']].Solution_imag[cscobj['cscind']]=-cscobj['imag'];
}					

/*
	This is the cotangent function. It is defined as 1/tan
*/
Equation.prototype.cot = function(replacetext, pid, pos, callback)	
{	var flag=0;	
	replacetext=replacetext.replace(/^cot\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);	
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "cot"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "cot"); flag=1;}
	if (flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'],Format_showtype:"InnerFunction",
		Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);	
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad')) 
		{ Set_Error(this.Original_id, "Trig2", "cot", self[tempid]['Units_units']); flag=1; }
		if (flag==0)
		{	var cotid=CreateEq(this.fileid, 0, eqobj);	
			var cotobj = { tempid: tempid, cotid: cotid, cotind: 0, parentid:this.Format_id };	
			for (var cotind in self[tempid].Solution_real)
			{	cotobj['cotind']=cotind;
				Cotangent1(cotobj, function() { 
				Cotangent2(cotobj, function() { 
				DivideComplex(cotobj, function(){
				Cotangent3(cotobj, function() { 
				DivideComplex(cotobj, function(){ 
				Cotangent4(cotobj, function() { }) }) }) }) }) });
			}	
			self[cotid].Format_showequation="cot \\left("+self[tempid].Format_showequation+" \\right)";
			this.Solution_temps.push(self[cotid].Format_id);
			self[cotid].Format_size=self[tempid].Format_size;
			DOM_Object[cotid]['real']=self[cotid].Solution_real;
			DOM_Object[cotid]['size']=self[cotid]['Format_size'];
			DOM_Object[cotid]['imag']['0-0']=0;	
			SetModels("cot", cotid, tempid);
			self[pid].Solution_variable_array[pos]=cotid;
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}	}	
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}	
function Cotangent1(cotobj, callback)
{	if (self[cotobj['tempid']].Solution_real[cotobj['cotind']]!==undefined) 
	{		cotobj['real']=self[cotobj['tempid']].Solution_real[cotobj['cotind']];	
	}else {	cotobj['real']=self[cotobj['tempid']].Solution_realdefault; } 
	if (self[cotobj['tempid']].Solution_imag[cotobj['cotind']]!==undefined) 
	{		cotobj['imag']=self[cotobj['tempid']].Solution_imag[cotobj['cotind']];
	}else {	cotobj['imag']=self[cotobj['tempid']].Solution_imagdefault; } 
	callback();	
}				
function Cotangent2(cotobj, callback)
{	cotobj['numreal']=ToNum(Math.sin(cotobj['real'])*0.5*(Math.exp(cotobj['imag'])+Math.exp(-cotobj['imag']))); 
	cotobj['numimag']=ToNum(Math.cos(cotobj['real'])*0.5*(Math.exp(cotobj['imag'])-Math.exp(-cotobj['imag']))); 
	cotobj['denreal']=ToNum(Math.cos(cotobj['real'])*0.5*(Math.exp(cotobj['imag'])+Math.exp(-cotobj['imag'])));	
	cotobj['denimag']=ToNum(-Math.sin(cotobj['real'])*0.5*(Math.exp(cotobj['imag'])-Math.exp(-cotobj['imag'])));	
	callback();	
}				
function Cotangent3(cotobj, callback)
{	cotobj['numreal']=1 
	cotobj['numimag']=0; 
	cotobj['denreal']=cotobj['real'];
	cotobj['denimag']=cotobj['imag'];
	callback();						
}									
function Cotangent4(cotobj)			
{		self[cotobj['cotid']].Solution_real[cotobj['cotind']]=cotobj['real'];
		self[cotobj['cotid']].Solution_imag[cotobj['cotind']]=cotobj['imag'];
}									
/*
	This is the asec function which is pi/2 + i * ln[ sqrt(1-1/z^2) + i/z ]
*/
Equation.prototype.asec = function(replacetext, pid, pos, callback)
{	var real=0, imag=0, real1=0, imag1=0, real2=0, imag2=0, real3=0, tempid='', imag3=''; 
	var id1='', id2='', id3='', id4='', id5='', baseid='', finalid='', flag=0;
	replacetext=replacetext.replace(/^asec\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "asec"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "asec"); flag=1;}
	if (flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'],Format_showtype:"InnerFunction",
				Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad')) 
		{ Set_Error(this.Original_id, "Trig2", "asec", self[tempid]['Units_units']); flag=1; }
		if (flag==0)
		{	var asecid=CreateEq(this.fileid, 0, eqobj);
			var asecobj = { tempid: tempid, asecid: asecid, asecind: 0, parentid:this.Format_id };
			for (var asecind in self[tempid].Solution_real)
			{	asecobj['asecind']=asecind;
				Asec1(asecobj, function() { 
				DivideComplex(asecobj, function() { 
				Asec2(asecobj, function(){
				DivideComplex(asecobj, function() { 
				Asec3(asecobj, function(){ 
				SquareRoot(asecobj, function(){ 
				Asec4(asecobj, function(){ 
				NatLog(asecobj, function(){ 
				Asec5(asecobj) }) }) }) }) }) }) }) });
			}
			self[asecid].Format_showequation="asec \\left("+self[tempid].Format_showequation+" \\right)";
			self[asecid].Format_showtype="builtin";
			this.Solution_temps.push(self[asecid].Format_id);
			self[asecid].Format_size=self[tempid].Format_size;
			DOM_Object[asecid]['real']=self[asecid].Solution_real;
			DOM_Object[asecid]['size']=self[asecid]['Format_size'];
			DOM_Object[asecid]['imag']['0-0']=0;
			SetModels("asec", asecid, tempid);
			self[pid].Solution_variable_array[pos]=asecid;
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function Asec1(asecobj, callback)
{	if (self[asecobj['tempid']].Solution_real[asecobj['asecind']]!==undefined) 
	{		asecobj['orig_real']=self[asecobj['tempid']].Solution_real[asecobj['asecind']];
	}else {	asecobj['orig_real']=self[asecobj['tempid']].Solution_realdefault;	} 
	if (self[asecobj['tempid']].Solution_imag[asecobj['asecind']]!==undefined) 
	{		asecobj['orig_imag']=self[asecobj['tempid']].Solution_imag[asecobj['asecind']];
	}else {	asecobj['orig_imag']=self[asecobj['tempid']].Solution_imagdefault;	} 
	asecobj['real']=asecobj['orig_real'];
	asecobj['imag']=asecobj['orig_imag'];
	asecobj['denreal']=asecobj['orig_real'];	asecobj['denimag']=asecobj['orig_imag'];
	asecobj['numreal']=0;	asecobj['numimag']=1;;
	callback();
}    
function Asec2(asecobj, callback)
{	asecobj['div1_real']=asecobj['real'];
	asecobj['div1_imag']=asecobj['imag'];
	asecobj['denreal']=asecobj['orig_real']*asecobj['orig_real']-asecobj['orig_imag']*asecobj['orig_imag']; 
	asecobj['denimag']=asecobj['orig_real']*asecobj['orig_imag']+asecobj['orig_imag']*asecobj['orig_real']; 
	asecobj['numreal']=1;	asecobj['numimag']=0;;
	callback();
}
function Asec3(asecobj, callback)
{	asecobj['real']=1-asecobj['real'];
	asecobj['imag']=-asecobj['imag'];
	callback();
}
function Asec4(asecobj, callback)
{	asecobj['real']=ToNum(parseFloat(asecobj['real'])+parseFloat(asecobj['div1_real']));
	asecobj['imag']=ToNum(parseFloat(asecobj['imag'])+parseFloat(asecobj['div1_imag']));
	callback();
}
function Asec5(asecobj, callback)
{
	self[asecobj['asecid']].Solution_real[asecobj['asecind']]=Math.PI/2-asecobj['imag'];
	self[asecobj['asecid']].Solution_imag[asecobj['asecind']]=asecobj['real'];
}
//---------------------------------------------------------------------------------------------------------//
//-------------------------------acsc=-i * log[ sqrt( 1 - 1/z^2) + i/z ]--------------------------------------------------------------------------//
Equation.prototype.acsc = function(replacetext, pid, pos, callback)
{	var flag=0;
	replacetext=replacetext.replace(/^acsc\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "acsc"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "acsc"); flag=1;}
	if (flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad')) 
		{ Set_Error(this.Original_id, "Trig2", "acsc", self[tempid]['Units_units']); flag=1; }
		if (flag==0)
		{	var acscid=CreateEq(this.fileid, 0, eqobj);
			var acscobj = { tempid: tempid, acscid: acscid, acscind: 0, parentid:this.Format_id };
			for (var acscind in self[tempid].Solution_real)
			{	acscobj['acscind']=acscind;
				Acsc1(acscobj, function() { 
				DivideComplex(acscobj, function() { 
				Acsc2(acscobj, function(){
				DivideComplex(acscobj, function() { 
				Acsc3(acscobj, function(){ 
				SquareRoot(acscobj, function(){ 
				Acsc4(acscobj, function(){ 
				NatLog(acscobj, function(){ 
				Acsc5(acscobj) }) }) }) }) }) }) }) });
			}
			self[acscid].Format_showequation="acsc \\left("+self[tempid].Format_showequation+" \\right)";
			self[acscid].Format_showtype="builtin";
			this.Solution_temps.push(self[acscid].Format_id);
			self[acscid].Format_size=self[tempid].Format_size;
			DOM_Object[acscid]['real']=self[acscid].Solution_real;
			DOM_Object[acscid]['size']=self[acscid]['Format_size'];
			DOM_Object[acscid]['imag']['0-0']=0;
			SetModels("acsc", acscid, tempid);
			self[pid].Solution_variable_array[pos]=acscid;
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function Acsc1(acscobj, callback)
{	if (self[acscobj['tempid']].Solution_real[acscobj['acscind']]!==undefined) 
	{		acscobj['orig_real']=self[acscobj['tempid']].Solution_real[acscobj['acscind']];
	}else {	acscobj['orig_real']=self[acscobj['tempid']].Solution_realdefault;	} 
	if (self[acscobj['tempid']].Solution_imag[acscobj['acscind']]!==undefined) 
	{		acscobj['orig_imag']=self[acscobj['tempid']].Solution_imag[acscobj['acscind']];
	}else {	acscobj['orig_imag']=self[acscobj['tempid']].Solution_imagdefault;	} 
	acscobj['real']=acscobj['orig_real'];
	acscobj['imag']=acscobj['orig_imag'];
	acscobj['denreal']=acscobj['orig_real'];	acscobj['denimag']=acscobj['orig_imag'];
	acscobj['numreal']=0;	acscobj['numimag']=1;;
	callback();
}    
function Acsc2(acscobj, callback)
{	acscobj['div1_real']=acscobj['real'];
	acscobj['div1_imag']=acscobj['imag'];
	acscobj['denreal']=acscobj['orig_real']*acscobj['orig_real']-acscobj['orig_imag']*acscobj['orig_imag']; 
	acscobj['denimag']=acscobj['orig_real']*acscobj['orig_imag']+acscobj['orig_imag']*acscobj['orig_real']; 
	acscobj['numreal']=1;	acscobj['numimag']=0;;
	callback();
}
function Acsc3(acscobj, callback)
{	var real=1-acscobj['real'];
	var imag=-acscobj['imag'];
	acscobj['real']=real;
	acscobj['imag']=imag;
	callback();
}
function Acsc4(acscobj, callback)
{	var real=acscobj['real']+acscobj['div1_real'];
	var imag=acscobj['imag']+acscobj['div1_imag'];
	acscobj['real']=real;
	acscobj['imag']=imag;
	callback();
}
function Acsc5(acscobj, callback)
{	self[acscobj['acscid']].Solution_real[acscobj['acscind']]=acscobj['imag'];
	self[acscobj['acscid']].Solution_imag[acscobj['acscind']]=-acscobj['real'];
}
//---------------------------------------------------------------------------------------------------------//

//-------------------------------acot=0.5 * i * [ log[(1-i/z)] - log[(1+i/z)] ]--------------------------------------------------------------------------//
Equation.prototype.acot = function(replacetext, pid, pos, callback)
{	var flag=0;
	replacetext=replacetext.replace(/^acot\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "acot"); flag=1;}
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "acot"); flag=1; }
	if (flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad')) 
		{ Set_Error(this.Original_id, "Trig2", "acot", self[tempid]['Units_units']); flag=1; }
		if (flag==0)
		{	var acotid=CreateEq(this.fileid, 0, eqobj);
			self[acotid]=new Equation(acotid);
			var acotobj = { tempid: tempid, acotid: acotid, acotind: 0, parentid:this.Format_id };
			for (var acotind in self[tempid].Solution_real)
			{	acotobj['acotind']=acotind;
				Acot1(acotobj, function() { 
				DivideComplex(acotobj, function() { 
				Acot2(acotobj, function(){
				NatLog(acotobj, function(){ 
				Acot3(acotobj, function(){ 
				NatLog(acotobj, function(){ 
				Acot4(acotobj) }) }) }) }) }) });
			}
			self[acotid].Format_showequation="acot \\left("+self[tempid].Format_showequation+" \\right)";
			self[acotid].Format_showtype="builtin";
			this.Solution_temps.push(self[acotid].Format_id);
			self[acotid].Format_size=self[tempid].Format_size;
			DOM_Object[acotid]['real']=self[acotid].Solution_real;
			DOM_Object[acotid]['imag']=self[acotid].Solution_imag;
			DOM_Object[acotid]['size']=self[acotid]['Format_size'];
			SetModels("acot", acotid, tempid);
			self[pid].Solution_variable_array[pos]=acotid;
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function Acot1(acotobj, callback)
{	if (self[acotobj['tempid']].Solution_real[acotobj['acotind']]!==undefined) 
	{		acotobj['orig_real']=self[acotobj['tempid']].Solution_real[acotobj['acotind']];
	}else {	acotobj['orig_real']=self[acotobj['tempid']].Solution_realdefault;	} 
	if (self[acotobj['tempid']].Solution_imag[acotobj['acotind']]!==undefined) 
	{		acotobj['orig_imag']=self[acotobj['tempid']].Solution_imag[acotobj['acotind']];
	}else {	acotobj['orig_imag']=self[acotobj['tempid']].Solution_imagdefault;	} 
	acotobj['real']=acotobj['orig_real'];
	acotobj['imag']=acotobj['orig_imag'];
	acotobj['denreal']=acotobj['orig_real'];	acotobj['denimag']=acotobj['orig_imag'];
	acotobj['numreal']=0;	acotobj['numimag']=1;;
	callback();
}    
function Acot2(acotobj, callback)
{	acotobj['div1_real']=acotobj['real'];
	acotobj['div1_imag']=acotobj['imag'];
	acotobj['real']=1-acotobj['div1_real']; 
	acotobj['imag']=-acotobj['div1_imag']; 
	callback();
}
function Acot3(acotobj, callback)
{	acotobj['log1_real']=acotobj['real'];
	acotobj['log1_imag']=acotobj['imag'];
	acotobj['real']=1+acotobj['div1_real']; 
	acotobj['imag']=acotobj['div1_imag']; 
	callback();
}
function Acot4(acotobj, callback)
{	var real=acotobj['log1_real']-acotobj['real'];
	var imag=acotobj['log1_imag']-acotobj['imag'];
	self[acotobj['acotid']].Solution_real[acotobj['acotind']]=-0.5*imag;
	self[acotobj['acotid']].Solution_imag[acotobj['acotind']]=0.5*real;
}
//---------------------------------------------------------------------------------------------------------//

//--------------------------------- asech(z) = ln[ sqrt(1/z-1) * sqrt(1/z+1) + 1/z ] ------------------------------------------------------------------------//
Equation.prototype.asech = function(replacetext, pid, pos, callback)
{	var flag=0;
	replacetext=replacetext.replace(/^asech\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "asech"); flag=1;}
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "asech"); flag=1; }
	if (flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad')) 
		{ Set_Error(this.Original_id, "Trig2", "acosh", self[tempid]['Units_units']); flag=1; }
		if (flag==0)
		{	var asechid=CreateEq(this.fileid, 0, eqobj);
			var asechobj = { tempid: tempid, asechid: asechid, asechind: 0, parentid:this.Format_id };
			for (var asechind in self[tempid].Solution_real)
			{	asechobj['asechind']=asechind;
				Asech1(asechobj, function(){ 
				DivideComplex(asechobj, function() { 
				Asech2(asechobj, function(){ 
				SquareRoot(asechobj, function(){ 
				Asech3(asechobj, function(){ 
				SquareRoot(asechobj, function(){ 
				Asech4(asechobj, function(){ 
				NatLog(asechobj, function(){
				Asech5(asechobj) }) }) }) }) }) }) }) });
			}
			self[asechid].Format_showequation="asech\\left("+self[tempid].Format_showequation+"\\right)";
			self[asechid].Format_showtype="builtin";
			this.Solution_temps.push(self[asechid].Format_id);
			self[asechid].Format_size=self[tempid].Format_size;
			DOM_Object[asechid]['real']=self[asechid].Solution_real;
			DOM_Object[asechid]['size']=self[asechid]['Format_size'];
			DOM_Object[asechid]['imag']=self[asechid].Solution_imag;
			SetModels("asech", asechid, tempid);
			self[pid].Solution_variable_array[pos]=asechid;
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function Asech1(asechobj, callback)
{	if (self[asechobj['tempid']].Solution_real[asechobj['asechind']]!==undefined) 
	{		asechobj['real']=self[asechobj['tempid']].Solution_real[asechobj['asechind']];
	}else {	asechobj['real']=self[asechobj['tempid']].Solution_realdefault;	} 
	if (self[asechobj['tempid']].Solution_imag[asechobj['asechind']]!==undefined) 
	{		asechobj['imag']=self[asechobj['tempid']].Solution_imag[asechobj['asechind']];
	}else {	asechobj['imag']=self[asechobj['tempid']].Solution_imagdefault;	} 
	asechobj['orig_real']=asechobj['real'];		asechobj['orig_imag']=asechobj['imag'];
	asechobj['numreal']=1; asechobj['numimag']=0; 
	asechobj['denreal']=asechobj['real'];	asechobj['denimag']=asechobj['imag'];
	callback();
}    
function Asech2(asechobj, callback)
{	asechobj['div_real']=asechobj['real']; asechobj['div_imag']=asechobj['imag'];
	asechobj['real']=ToNum(parseFloat(asechobj['real'])-1); 
	callback();
}    
function Asech3(asechobj, callback)
{	asechobj['sq1_real']=asechobj['real']; asechobj['sq1_imag']=asechobj['imag'];
	asechobj['real']=ToNum(parseFloat(asechobj['div_real'])+1); 
	asechobj['imag']=ToNum(parseFloat(asechobj['div_imag'])); 
	callback();
}    
function Asech4(asechobj, callback)
{	var real=asechobj['real']; var imag=asechobj['imag'];
	asechobj['real']=ToNum(asechobj['sq1_real']*real)-ToNum(asechobj['sq1_imag']*imag)+ToNum(asechobj['div_real']);
	asechobj['imag']=ToNum(asechobj['sq1_real']*imag)+ToNum(asechobj['sq1_imag']*real)+ToNum(asechobj['div_imag']);
	callback();
}    
function Asech5(asechobj, callback)
{	self[asechobj['asechid']].Solution_real[asechobj['asechind']]=asechobj['real'];
	self[asechobj['asechid']].Solution_imag[asechobj['asechind']]=asechobj['imag'];
}
//---------------------------------------------------------------------------------------------------------//

//--------------------------- acsch(z) = ln[ sqrt(1+1/z^2) + 1/z] ------------------------------------------------------------------------------//
Equation.prototype.acsch = function(replacetext, pid, pos, callback)
{	var flag=0;
	replacetext=replacetext.replace(/^acsch\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "acsch"); flag=1;}
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "acsch"); flag=1; }
	if (flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad')) 
		{ Set_Error(this.Original_id, "Trig2", "acosh", self[tempid]['Units_units']); flag=1; }
		if (flag==0)
		{	var acschid=CreateEq(this.fileid, 0, eqobj);
			var acschobj = { tempid: tempid, acschid: acschid, acschind: 0, parentid:this.Format_id };
			for (var acschind in self[tempid].Solution_real)
			{	acschobj['acschind']=acschind;
				Acsch1(acschobj, function(){ 
				SquareComplex(acschobj, function() { 
				Acsch2(acschobj, function(){ 
				DivideComplex(acschobj, function(){ 
				Acsch3(acschobj, function(){ 
				SquareRoot(acschobj, function(){ 
				Acsch4(acschobj, function(){ 
				DivideComplex(acschobj, function(){ 
				Acsch5(acschobj, function(){ 
				NatLog(acschobj, function(){ 
				Acsch6(acschobj) }) }) }) }) }) }) }) }) }) });
			}
			self[acschid].Format_showequation="acsch\\left("+self[tempid].Format_showequation+"\\right)";
			self[acschid].Format_showtype="builtin";
			this.Solution_temps.push(self[acschid].Format_id);
			self[acschid].Format_size=self[tempid].Format_size;
			DOM_Object[acschid]['real']=self[acschid].Solution_real;
			DOM_Object[acschid]['size']=self[acschid]['Format_size'];
			DOM_Object[acschid]['imag']['0-0']=0;
			SetModels("acsch", acschid, tempid);
			self[pid].Solution_variable_array[pos]=acschid;
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function Acsch1(acschobj, callback)
{	if (self[acschobj['tempid']].Solution_real[acschobj['acschind']]!==undefined) 
	{		acschobj['real']=self[acschobj['tempid']].Solution_real[acschobj['acschind']];
	}else {	acschobj['real']=self[acschobj['tempid']].Solution_realdefault;	} 
	if (self[acschobj['tempid']].Solution_imag[acschobj['acschind']]!==undefined)	 
	{		acschobj['imag']=self[acschobj['tempid']].Solution_imag[acschobj['acschind']];
	}else {	acschobj['imag']=self[acschobj['tempid']].Solution_imagdefault;	} 
	acschobj['orig_real']=acschobj['real'];		acschobj['orig_imag']=acschobj['imag'];
	callback();
}    
function Acsch2(acschobj, callback)
{	acschobj['numreal']=1; 		acschobj['numimag']=0;
	acschobj['denreal']=acschobj['real']; 		acschobj['denimag']=acschobj['imag'];
	callback();
}    
function Acsch3(acschobj, callback)
{	acschobj['real']=acschobj['real']+1; 
	callback();
}    
function Acsch4(acschobj, callback)
{	acschobj['sqrtreal']=acschobj['real']; acschobj['sqrtimag']=acschobj['imag'];
	acschobj['numreal']=1; 		acschobj['numimag']=0;
	acschobj['denreal']=acschobj['orig_real']; 		acschobj['denimag']=acschobj['orig_imag'];
	callback();
}    
function Acsch5(acschobj, callback)
{	acschobj['real']=acschobj['sqrtreal']+acschobj['real'];
	acschobj['imag']=acschobj['sqrtimag']+acschobj['imag'];
	callback();
}    
function Acsch6(acschobj, callback)
{	self[acschobj['acschid']].Solution_real[acschobj['acschind']]=acschobj['real'];
	self[acschobj['acschid']].Solution_imag[acschobj['acschind']]=acschobj['imag'];
}
//---------------------------------------------------------------------------------------------------------//

//------------------------------- acoth(z) = 0.5 * [ ln(1+1/z) - ln(1-1/z)] --------------------------------------------------------------------------//
//------------------------------- acoth(z) = 0.5 * [ ln((z+1)/(z-1))] --------------------------------------------------------------------------//
Equation.prototype.acoth = function(replacetext, pid, pos, callback)
{	var flag=0;
	replacetext=replacetext.replace(/^acoth\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "acoth"); flag=1;}
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "acoth"); flag=1; }
	if (flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad')) 
		{ Set_Error(this.Original_id, "Trig2", "acosh", self[tempid]['Units_units']); flag=1; }
		if (flag==0)
		{	var acothid=CreateEq(this.fileid, 0, eqobj);
			var acothobj = { tempid: tempid, acothid: acothid, acothind: 0, parentid:this.Format_id };
			for (var acothind in self[tempid].Solution_real)
			{	acothobj['acothind']=acothind;
				Acoth1(acothobj, function(){ 
				DivideComplex(acothobj, function() { 
				NatLog(acothobj, function(){ 
				Acoth2(acothobj) }) }) });
			}
			self[acothid].Format_showequation="acoth\\left("+self[tempid].Format_showequation+"\\right)";
			self[acothid].Format_showtype="builtin";
			this.Solution_temps.push(self[acothid].Format_id);
			self[acothid].Format_size=self[tempid].Format_size;
			DOM_Object[acothid]['real']=self[acothid].Solution_real;
			DOM_Object[acothid]['imag']=self[acothid].Solution_imag;
			DOM_Object[acothid]['size']=self[acothid]['Format_size'];
			SetModels("acoth", acothid, tempid);
			self[pid].Solution_variable_array[pos]=acothid;
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function Acoth1(acothobj, callback)
{	if (self[acothobj['tempid']].Solution_real[acothobj['acothind']]!==undefined) 
	{		acothobj['real']=self[acothobj['tempid']].Solution_real[acothobj['acothind']];
	}else {	acothobj['real']=self[acothobj['tempid']].Solution_realdefault;	} 
	if (self[acothobj['tempid']].Solution_imag[acothobj['acothind']]!==undefined) 
	{		acothobj['imag']=self[acothobj['tempid']].Solution_imag[acothobj['acothind']];
	}else {	acothobj['imag']=self[acothobj['tempid']].Solution_imagdefault;	} 
	acothobj['orig_real']=acothobj['real'];		acothobj['orig_imag']=acothobj['imag'];
	acothobj['numreal']=parseFloat(acothobj['real'])+1;		acothobj['numimag']=acothobj['imag'];
	acothobj['denreal']=parseFloat(acothobj['real'])-1;		acothobj['denimag']=acothobj['imag'];
	callback();
}    

function Acoth2(acothobj)
{	var real=0.5*acothobj['real']; 
	var imag=0.5*acothobj['imag'];
	self[acothobj['acothid']].Solution_real[acothobj['acothind']]=real;
	self[acothobj['acothid']].Solution_imag[acothobj['acothind']]=imag;
}
//---------------------------------------------------------------------------------------------------------//



/*
//------------------------------- acoth(z) = 0.5 * [ ln(1+1/z) - ln(1-1/z)] --------------------------------------------------------------------------//
Equation.prototype.acoth = function(replacetext, pid, pos, callback)
{	var flag=0;
	replacetext=replacetext.replace(/^acoth\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "acoth"); flag=1;}
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "acoth"); flag=1; }
	if (flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);
		if ((self[tempid]['Units_units']!=='')&&(self[tempid]['Units_units']!=='rad')) 
		{ Set_Error(this.Original_id, "Trig2", "acosh", self[tempid]['Units_units']); flag=1; }
		if (flag==0)
		{	var acothid=CreateEq(this.fileid, 0, eqobj);
			var acothobj = { tempid: tempid, acothid: acothid, acothind: 0, parentid:this.Format_id };
			for (var acothind in self[tempid].Solution_real)
			{	acothobj['acothind']=acothind;
				Acoth1(acothobj, function(){ 
				DivideComplex(acothobj, function() { 
				Acoth2(acothobj, function(){ 
				NatLog(acothobj, function(){ 
				Acoth3(acothobj, function(){ 
				NatLog(acothobj, function(){ 
				Acoth4(acothobj) })})})})})});
			}
			self[acothid].Format_showequation="acoth\\left("+self[tempid].Format_showequation+"\\right)";
			self[acothid].Format_showtype="builtin";
			this.Solution_temps.push(self[acothid].Format_id);
			self[acothid].Format_size=self[tempid].Format_size;
			DOM_Object[acothid]['real']=self[acothid].Solution_real;
			DOM_Object[acothid]['size']=self[acothid]['Format_size'];
			DOM_Object[acothid]['imag']['0-0']=0;
			SetModels("acoth", acothid, tempid);
			self[pid].Solution_variable_array[pos]=acothid;
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	}	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function Acoth1(acothobj, callback)
{	if (self[acothobj['tempid']].Solution_real[acothobj['acothind']]!==undefined) 
	{		acothobj['real']=self[acothobj['tempid']].Solution_real[acothobj['acothind']];
	}else {	acothobj['real']=self[acothobj['tempid']].Solution_realdefault;	} 
	if (self[acothobj['tempid']].Solution_imag[acothobj['acothind']]!==undefined) 
	{		acothobj['imag']=self[acothobj['tempid']].Solution_imag[acothobj['acothind']];
	}else {	acothobj['imag']=self[acothobj['tempid']].Solution_imagdefault;	} 
	acothobj['orig_real']=acothobj['real'];		acothobj['orig_imag']=acothobj['imag'];
	acothobj['numreal']=1;						acothobj['numimag']=0;
	acothobj['denreal']=acothobj['real'];		acothobj['denimag']=acothobj['imag'];
	callback();
}    
function Acoth2(acothobj, callback)
{	
	acothobj['divreal']=acothobj['real']; acothobj['divimag']=acothobj['imag'];
	acothobj['real']=ToNum(parseFloat(acothobj['real'])+1); 
	callback();
}    
function Acoth3(acothobj, callback)
{	acothobj['nlreal']=acothobj['real']; acothobj['nlimag']=acothobj['imag'];
	acothobj['real']=1-acothobj['divreal'];	acothobj['imag']=acothobj['divimag'];
	callback();
}    
function Acoth4(acothobj, callback)
{	var real=0.5*acothobj['nlreal']-acothobj['real']; 
	var imag=0.5*acothobj['nlimag']-acothobj['imag'];
	self[acothobj['acothid']].Solution_real[acothobj['acothind']]=real;
	self[acothobj['acothid']].Solution_imag[acothobj['acothind']]=imag;
}
//---------------------------------------------------------------------------------------------------------//
*/

//-------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------------- MATH FUNCTION - ROOT --------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.root = function(text, pid, pos, callback)
{	var base_real=0; var base_imag=0; var exp_real=0; var exp_imag=0;
	var replacetext=text.replace(/^\s+|\s+$/g, '');
	replacetext=replacetext.replace(/^root\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "root"); }
	if (inputarray.length<2) { Set_Error(this.Original_id, "Root1"); }
	if (inputarray.length>2) { Set_Error(this.Original_id, "Root2"); }
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	if (self[id1].Units_units!=="") { Set_Error(this.Original_id, "Root3"); }
	
	if (self[id1].Format_size=="1x1") 
	{	if (self[id1].Solution_real['0-0']===undefined) 	{ 		exp_real=0;
															}else { exp_real=self[id1].Solution_real['0-0']; 	}
		if (self[id1].Solution_imag['0-0']===undefined) 	{ 		exp_imag=0;
															}else { exp_imag=self[id1].Solution_imag['0-0']; 	}
															var eflag=0;
	}else{ 									var eflag=1;		}
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
						Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
	var id2=CreateEq(this.fileid, 1, eqobj);
	if ((self[id1].Format_size!=self[id2].Format_size)&&(self[id1].Format_size!="1x1")) 
									{ Set_Error(this.Original_id, "Power4"); }
	if ((self[id1].Solution_imag['0-0']!==undefined) && (self[id1].Solution_imag['0-0']!=0))
									{ Set_Error(this.Original_id, "Power6"); }
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
						Original_id:this.Original_id, equation:"TempEq=0"};
	var id=CreateEq(this.fileid, 0, eqobj);
	
	for (var i in self[id2].Solution_real) 
	{ 	if (self[id2].Solution_real[i]===undefined) { 	base_real=self[id2].Solution_realdefault; 
		}else { 											base_real=parseFloat(self[id2].Solution_real[i]);	}
		if (self[id2].Solution_imag[i]===undefined) { 	base_imag=self[id2].Solution_imagdefault; 
		}else { 											base_imag=parseFloat(self[id2].Solution_imag[i]);	}
		if (eflag==1)
		{	if (self[id1].Solution_real[i]===undefined) { exp_real=self[id1].Solution_realdefault; 
			}else { 										exp_real=parseFloat(self[id1].Solution_real[i]);	}
			if (self[id1].Solution_imag[i]===undefined) { exp_imag=self[id1].Solution_imagdefault; 
			}else { 										exp_imag=parseFloat(self[id1].Solution_imag[i]);	}
		}
		var r=ToNum(Math.pow(Math.pow(base_real,2)+Math.pow(base_imag,2),0.5));
		if 			((base_real===0)&&(base_imag>0)) { 	var theta=Math.PI/2;
		}else if 	((base_real===0)&&(base_imag<0)) { 	var theta=-Math.PI/2;
		}else if 	((base_imag===0)&&(base_real>0)) { 	var theta=0;
		}else if 	((base_imag===0)&&(base_real<0)) { 	var theta=Math.PI;
		}else {											var theta=Math.atan2(base_imag, base_real);}
		var num=ToNum(Math.pow(r,exp_real)*Math.exp(-exp_imag*theta));
		if (r===0) { self[id].Solution_real[i]=0; self[id].Solution_imag[i]=0;
		}else {	self[id].Solution_real[i]=ToNum(Math.pow(r,parseFloat(1/exp_real))*Math.cos(theta/exp_real));
				self[id].Solution_imag[i]=ToNum(Math.pow(r,parseFloat(1/exp_real))*Math.sin(theta/exp_real)); }
	}

	// Solve for the default
	var base_real=parseFloat(self[id2].Solution_realdefault);
	var base_imag=parseFloat(self[id2].Solution_imagdefault);
	var r=ToNum(Math.pow(Math.pow(base_real,2)+Math.pow(base_imag,2),0.5));
	if 			((base_real===0)&&(base_imag>0)) { 	var theta=Math.PI/2;
	}else if 	((base_real===0)&&(base_imag<0)) { 	var theta=-Math.PI/2;
	}else if 	((base_imag===0)&&(base_real>0)) { 	var theta=0;
	}else if 	((base_imag===0)&&(base_real<0)) { 	var theta=Math.PI;
	}else {											var theta=Math.atan2(base_imag, base_real);}
	self[id].Solution_realdefault=ToNum(num*ToNum(Math.cos(exp_imag*Math.log(r)+exp_real*theta)));
	self[id].Solution_imagdefault=ToNum(num*ToNum(Math.sin(exp_imag*Math.log(r)+exp_real*theta)));
	self[id].Format_size=self[id2].Format_size;
	if (self[id1].Units_units!=="") { Set_Error(this.Original_id, "Root3"); }
	for (var i in self[id2].Units_base_array)
	{	self[id].Units_base_array[i]=self[id2].Units_base_array[i]*1/exp_real;	}
	
	// Make sure that the units are a solid value
	for (var i in self[id].Units_base_array)
	{	
		if ( (self[id].Units_base_array[i]%1!==0) && (i!="rad"))
		{ 
			Set_Error(this.Original_id, "Root5", i);  
		}
		if ( (self[id].Units_base_array[i]%1!==0) && (i=="rad"))
		{ 
			self[id].Units_base_array[i]=0;
		}
	}
	
	self[id].Recompose_Units(); 
	self[id].Get_My_BaseString();
	self[id].Format_showtype="builtin"; 
	self[id].Format_showequation="\\sqrt["+self[id1].Format_showequation+"]{"+self[id2].Format_showequation+"}";
	DOM_Object[id]['real']=self[id].Solution_real;
	DOM_Object[id]['size']=self[id]['Format_size'];
	DOM_Object[id]['imag']['0-0']=0;
	DOM_Object[id]['units']=self[id].Units_units;
	SetModels("root", id, id1, id2);
	self[pid].Solution_variable_array[pos]=id;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------- TAKING A NUMBER TO THE NTH POWER --------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.power = function(text, pid, pos, callback) 
{	
	// Establish the variables
	var base_real=0; var base_imag=0; var exp_real=0; var exp_imag=0; 
	
	// Pull out the text sent to the function and create the input array
	//var replacetext=text.replace(/^\s+|\s+$/g, ''); 
	var replacetext=text.replace(/^power\(/,""); 
	replacetext=replacetext.replace(/\)$/,"");  
	var inputarray=InputArray(replacetext);


	// If there aren't the right number of inputs, set an error
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "power"); }
	if (inputarray.length<2) { Set_Error(this.Original_id, "Power1"); }
	if (inputarray.length>2) { Set_Error(this.Original_id, "Power2"); }


	// Solve the exponential input and if there are units, set an error
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	if (self[id1].Units_units!=="") { Set_Error(this.Original_id, "Power3"); }


	// Solve the base input
	var eflag=1;
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
	var id2=CreateEq(this.fileid, 1, eqobj);


	// The inputs must either be two matrices of equal size or a matrix raised to a single number
	if ((self[id1].Format_size!=self[id2].Format_size)&&(self[id1].Format_size!="1x1")&&(self[id2].Format_size!="1x1")) 
	{ Set_Error(this.Original_id, "Power4"); }

	
	// Create the equation to be returned
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq=0"};
	var id=CreateEq(this.fileid, 0, eqobj);


	// The case where the exponent is a single number
	if (self[id1].Format_size=="1x1")
	{	
		for (var i in self[id2].Solution_real) 
		{ 	
			// If there is not base at this index, use the default
			if (self[id2].Solution_real[i]===undefined) 
			{
				base_real=self[id2].Solution_realdefault; 
			}else 
			{
				base_real=parseFloat(self[id2].Solution_real[i]);
			}
			if (self[id2].Solution_imag[i]===undefined) 
			{
				base_imag=self[id2].Solution_imagdefault; 
			}else 
			{
				base_imag=parseFloat(self[id2].Solution_imag[i]);
			}
			if (isNaN(base_imag)) { base_imag=0; }


			if (eflag==1)
			{	
				if (self[id1].Solution_real['0-0']===undefined) 
				{
					exp_real=self[id1].Solution_realdefault; 
				}else 
				{
					exp_real=parseFloat(self[id1].Solution_real['0-0']);
				}
				if (self[id1].Solution_imag['0-0']===undefined) 
				{ 
					exp_imag=self[id1].Solution_imagdefault; 
				}else 
				{
					exp_imag=parseFloat(self[id1].Solution_imag['0-0']);
				}
			}

			// Set the base number to the sum of the squares of the real and imag
			var r=ToNum(Math.pow(Math.pow(base_real,2)+Math.pow(base_imag,2),0.5));

			// Calculate theta
			if 			((base_real===0)&&(base_imag>0)) { 	var theta=Math.PI/2;
			}else if 	((base_real===0)&&(base_imag<0)) { 	var theta=-Math.PI/2;
			}else if 	((base_imag===0)&&(base_real>0)) { 	var theta=0;
			}else if 	((base_imag===0)&&(base_real<0)) { 	var theta=Math.PI;
			}else {											var theta=Math.atan2(base_imag, base_real);}
			var num=ToNum(Math.pow(r,exp_real)*Math.exp(-exp_imag*theta));

			// If r ended up being 0, set the return to zero
			if (r===0) 
			{ 
				self[id].Solution_real[i]=0; self[id].Solution_imag[i]=0;

			// calculate the final number for the power
			}else 
			{
				self[id].Solution_real[i]=ToNum(num*ToNum(Math.cos(exp_imag*Math.log(r)+exp_real*theta)));
				self[id].Solution_imag[i]=ToNum(num*ToNum(Math.sin(exp_imag*Math.log(r)+exp_real*theta))); 
			}
		
		}
		self[id].Format_size=self[id2].Format_size;
	}else if (self[id2].Format_size=="1x1")
	{	for (var i in self[id1].Solution_real) 
		{ 	if (self[id2].Solution_real['0-0']===undefined) { base_real=self[id2].Solution_realdefault; 
			}else { 											base_real=parseFloat(self[id2].Solution_real['0-0']);}
			if (self[id2].Solution_imag['0-0']===undefined) { base_imag=self[id2].Solution_imagdefault; 
			}else { 											base_imag=parseFloat(self[id2].Solution_imag['0-0']);}
			if (eflag==1)
			{	if (self[id1].Solution_real[i]===undefined) { exp_real=self[id1].Solution_realdefault; 
				}else { 										exp_real=parseFloat(self[id1].Solution_real[i]);	}
				if (self[id1].Solution_imag[i]===undefined) { exp_imag=self[id1].Solution_imagdefault; 
				}else { 										exp_imag=parseFloat(self[id1].Solution_imag[i]);	}
			}
			var r=ToNum(Math.pow(Math.pow(base_real,2)+Math.pow(base_imag,2),0.5));
			if 			((base_real===0)&&(base_imag>0)) { 	var theta=Math.PI/2;
			}else if 	((base_real===0)&&(base_imag<0)) { 	var theta=-Math.PI/2;
			}else if 	((base_imag===0)&&(base_real>0)) { 	var theta=0;
			}else if 	((base_imag===0)&&(base_real<0)) { 	var theta=Math.PI;
			}else {											var theta=Math.atan2(base_imag, base_real);}
			var num=ToNum(Math.pow(r,exp_real)*Math.exp(-exp_imag*theta));
			if (r===0) { self[id].Solution_real[i]=0; self[id].Solution_imag[i]=0;
			}else {	self[id].Solution_real[i]=ToNum(num*ToNum(Math.cos(exp_imag*Math.log(r)+exp_real*theta)));
					self[id].Solution_imag[i]=ToNum(num*ToNum(Math.sin(exp_imag*Math.log(r)+exp_real*theta))); }
		}
		self[id].Format_size=self[id1].Format_size;
	}else 
	{	for (var i in self[id1].Solution_real) 
		{ 	if (self[id2].Solution_real[i]===undefined) { 	base_real=self[id2].Solution_realdefault; 
			}else { 											base_real=parseFloat(self[id2].Solution_real[i]);}
			if (self[id2].Solution_imag[i]===undefined) {		base_imag=self[id2].Solution_imagdefault; 
			}else { 											base_imag=parseFloat(self[id2].Solution_imag[i]);}
			if (eflag==1)
			{	if (self[id1].Solution_real[i]===undefined) { exp_real=self[id1].Solution_realdefault; 
				}else { 										exp_real=parseFloat(self[id1].Solution_real[i]);	}
				if (self[id1].Solution_imag[i]===undefined) { exp_imag=self[id1].Solution_imagdefault; 
				}else { 										exp_imag=parseFloat(self[id1].Solution_imag[i]);	}
			}
			var r=ToNum(Math.pow(Math.pow(base_real,2)+Math.pow(base_imag,2),0.5));
			if 			((base_real===0)&&(base_imag>0)) { 	var theta=Math.PI/2;
			}else if 	((base_real===0)&&(base_imag<0)) { 	var theta=-Math.PI/2;
			}else if 	((base_imag===0)&&(base_real>0)) { 	var theta=0;
			}else if 	((base_imag===0)&&(base_real<0)) { 	var theta=Math.PI;
			}else {											var theta=Math.atan2(base_imag, base_real);}
			var num=ToNum(Math.pow(r,exp_real)*Math.exp(-exp_imag*theta));
			if (r===0) { self[id].Solution_real[i]=0; self[id].Solution_imag[i]=0;
			}else {	self[id].Solution_real[i]=ToNum(num*ToNum(Math.cos(exp_imag*Math.log(r)+exp_real*theta)));
					self[id].Solution_imag[i]=ToNum(num*ToNum(Math.sin(exp_imag*Math.log(r)+exp_real*theta))); }
		}
		self[id].Format_size=self[id1].Format_size;
	}
	var base_real=parseFloat(self[id1].Solution_realdefault);
	var base_imag=parseFloat(self[id1].Solution_imagdefault);
	var r=ToNum(Math.pow(Math.pow(base_real,2)+Math.pow(base_imag,2),0.5));
	if 			((base_real===0)&&(base_imag>0)) { 	var theta=Math.PI/2;
	}else if 	((base_real===0)&&(base_imag<0)) { 	var theta=-Math.PI/2;
	}else if 	((base_imag===0)&&(base_real>0)) { 	var theta=0;
	}else if 	((base_imag===0)&&(base_real<0)) { 	var theta=Math.PI;
	}else {											var theta=Math.atan2(base_imag, base_real);}
	self[id].Solution_realdefault=ToNum(num*ToNum(Math.cos(exp_imag*Math.log(r)+exp_real*theta)));
	self[id].Solution_imagdefault=ToNum(num*ToNum(Math.sin(exp_imag*Math.log(r)+exp_real*theta)));
	if (self[id1].Units_units!=="") { Set_Error(this.Original_id, "Power3"); }
	for (var i in self[id2].Units_base_array)
	{	self[id].Units_base_array[i]=self[id2].Units_base_array[i]*exp_real;	}

	console.log('The base arrays for the three items are ...');
	console.log(self[id1].Units_base_array);
	console.log(self[id2].Units_base_array);
	console.log(self[id].Units_base_array);

	for (var i in self[id].Units_base_array)
	{	if (self[id].Units_base_array[i]%1!==0) { Set_Error(this.Original_id, "Power5", i);  }	}
	self[id].Recompose_Units(); 
	self[id].Get_BaseString();
	self[id].Format_showtype="builtin"; 
	self[id].Format_showequation="\\left("+self[id2].Format_showequation+"\\right)^{"+self[id1].Format_showequation+"}";
	DOM_Object[id]['real']=self[id].Solution_real;
	DOM_Object[id]['size']=self[id]['Format_size'];
	DOM_Object[id]['imag']['0-0']=0;
	DOM_Object[id]['units']=self[id].Units_units;
	SetModels("power", id, id1, id2);
	self[pid].Solution_variable_array[pos]=id;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//----------------------------------- NATURAL LOGARITHM ---------------------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.ln = function(replacetext, pid, pos, callback)
{
	replacetext=replacetext.replace(/^ln\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "ln");  }
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "ln");  }
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var tempid=CreateEq(this.fileid, 1, eqobj);
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq=0"};
	var lnid=CreateEq(this.fileid, 0, eqobj);
	var lnobj = { tempid: tempid, lnid: lnid, lnind: 0, parentid:this.Original_id };
	for (var lnind in self[tempid].Solution_real)
	{	lnobj['lnind']=lnind;
		NL1(lnobj, function() { NatLog(lnobj, function() { NL2(lnobj, function(){ }) }) });
	}
	self[lnid].Format_showequation="ln \\left("+self[tempid].Format_showequation+" \\right)";
	this.Solution_temps.push(self[lnid].Format_id);
	self[lnid].Format_size=self[tempid].Format_size;
	self[lnid].Units_base_array=self[tempid].Units_base_array;
	self[lnid].Units_units=self[tempid].Units_units;
	self[lnid].Units_quantity=self[tempid].Units_quantity;
	DOM_Object[lnid]['real']=self[lnid].Solution_real;
	DOM_Object[lnid]['size']=self[lnid]['Format_size'];
	DOM_Object[lnid]['imag']['0-0']=0;
	DOM_Object[lnid]['units']=self[lnid].Units_units;
	SetModels("ln", lnid, tempid);
	self[pid].Solution_variable_array[pos]=lnid;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function NL1(lnobj, callback)
{	if (self[lnobj['tempid']].Solution_real[lnobj['lnind']]!==undefined) 
	{		lnobj['real']=self[lnobj['tempid']].Solution_real[lnobj['lnind']];
	}else {	lnobj['real']=self[lnobj['tempid']].Solution_realdefault; } 
	if (self[lnobj['tempid']].Solution_imag[lnobj['lnind']]!==undefined) 
	{		lnobj['imag']=self[lnobj['tempid']].Solution_imag[lnobj['lnind']];
	}else {	lnobj['imag']=self[lnobj['tempid']].Solution_imagdefault; } 
	if ((lnobj['real']===0)&&(lnobj['imag']===0)) { Set_Error(lnobj['parentid'], "Log3");  }
	callback();
}
function NL2(lnobj)
{		self[lnobj['lnid']].Solution_real[lnobj['lnind']]=lnobj['real'];
		self[lnobj['lnid']].Solution_imag[lnobj['lnind']]=lnobj['imag'];
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//--------------------------------------- Base 10 LOGARITHM -----------------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.log10 = function(replacetext, pid, pos, callback)
{
	replacetext=replacetext.replace(/^log10\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trig1", inputarray.length, "log10");  }
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "log10"); }
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var tempid=CreateEq(this.fileid, 1, eqobj);
	// var logid=Get_ID("Equation");
	// self[logid]=new Equation(logid);
	var logid=CreateEq(this.fileid, 0, eqobj);
	var logobj = { tempid: tempid, logid: logid, logind: 0, parentid:this.Format_id };
	for (var logind in self[tempid].Solution_real)
	{	logobj['logind']=logind;
		TenLog1(logobj, function() { 
		NatLog(logobj, function() { 
		TenLog2(logobj, function(){ 
		NatLog(logobj, function(){ 
		TenLog3(logobj, function(){ 
		DivideComplex(logobj, function(){ 
		TenLog4(logobj) }) }) }) }) }) });
	}
	self[logid].Format_showequation="Log10 \\left("+self[tempid].Format_showequation+" \\right)";
	this.Solution_temps.push(self[logid].Format_id);
	self[logid].Format_size=self[tempid].Format_size;
	self[logid].Units_base_array=self[tempid].Units_base_array;
	self[logid].Units_units=self[tempid].Units_units;
	self[logid].Units_quantity=self[tempid].Units_quantity;
	DOM_Object[logid]['real']=self[logid].Solution_real;
	DOM_Object[logid]['size']=self[logid]['Format_size'];
	DOM_Object[logid]['imag']['0-0']=0;
	DOM_Object[logid]['units']=self[logid].Units_units;
	SetModels("log10", logid, tempid);
	self[pid].Solution_variable_array[pos]=logid;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function TenLog1(logobj, callback)
{	if (self[logobj['tempid']].Solution_real[logobj['logind']]!==undefined) 
	{		logobj['orig_real']=self[logobj['tempid']].Solution_real[logobj['logind']];
	}else {	logobj['orig_real']=self[logobj['tempid']].Solution_realdefault; } 
	if (self[logobj['tempid']].Solution_imag[logobj['logind']]!==undefined) 
	{		logobj['orig_imag']=self[logobj['tempid']].Solution_imag[logobj['logind']];
	}else {	logobj['orig_imag']=self[logobj['tempid']].Solution_imagdefault; } 
	logobj['real']=10;		logobj['imag']=0;
	if ((logobj['orig_real']===0)&&(logobj['orig_imag']===0)) { Set_Error(logobj['parentid'], "Log3"); }
	callback();
}
function TenLog2(logobj, callback)
{	logobj['logreal']=logobj['real'];		logobj['logimag']=logobj['imag'];	
	logobj['real']=logobj['orig_real'];		logobj['imag']=logobj['orig_imag'];
	callback();		}
function TenLog3(logobj, callback)
{	logobj['numreal']=logobj['real'];		logobj['numimag']=logobj['imag'];	
	logobj['denreal']=logobj['logreal'];	logobj['denimag']=logobj['logimag'];
	callback();
}
function TenLog4(logobj)
{		self[logobj['logid']].Solution_real[logobj['logind']]=logobj['real'];
		self[logobj['logid']].Solution_imag[logobj['logind']]=logobj['imag'];
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//-------------------------------------------- LOGARITHM --------------------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.log = function(replacetext, pid, pos, callback)
{
	replacetext=replacetext.replace(/^log\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length<2) { Set_Error(this.Original_id, "Log1");  }
	if (inputarray.length>2) { Set_Error(this.Original_id, "Log2");  }
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "log"); }
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var logid=CreateEq(this.fileid, 1, eqobj);
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
	var baseid=CreateEq(this.fileid, 1, eqobj);
	var logobj = { logid: logid, baseid: baseid, logind: 0, parentid:this.Format_id };
	for (var logind in self[logid].Solution_real)
	{	logobj['logind']=logind;
		Log1(logobj, function() { 
		NatLog(logobj, function() { 
		Log2(logobj, function(){ 
		NatLog(logobj, function(){ 
		Log3(logobj, function(){ 
		DivideComplex(logobj, function(){ 
		Log4(logobj) }) }) }) }) }) });
	}
	self[logid].Format_showequation="log \\left("+self[logid].Format_showequation+" "+self[logid].Units_units+","+self[baseid].Format_showequation+" "+self[baseid].Units_units+" \\right)";
	this.Solution_temps.push(self[logid].Format_id);
	// self[logid].Format_size=self[tempid].Format_size;
	// self[logid].Units_base_array=self[tempid].Units_base_array;
	// self[logid].Units_units=self[tempid].Units_units;
	// self[logid].Units_quantity=self[tempid].Units_quantity;
	DOM_Object[logid]['real']=self[logid].Solution_real;
	DOM_Object[logid]['size']=self[logid]['Format_size'];
	DOM_Object[logid]['imag']=self[logid].Solution_imag;
	DOM_Object[logid]['units']=self[logid].Units_units;
	SetModels("log", logid, logid);
	self[pid].Solution_variable_array[pos]=logid;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function Log1(logobj, callback)
{	var index='';
	if (self[logobj['logid']].Solution_real[logobj['logind']]!==undefined) 
	{		logobj['orig_real']=self[logobj['logid']].Solution_real[logobj['logind']];
	}else {	logobj['orig_real']=self[logobj['logid']].Solution_realdefault; } 
	if (self[logobj['logid']].Solution_imag[logobj['logind']]!==undefined) 
	{		logobj['orig_imag']=self[logobj['logid']].Solution_imag[logobj['logind']];
	}else {	logobj['orig_imag']=self[logobj['logid']].Solution_imagdefault; } 
	if (self[logobj['baseid']].Format_size=="1x1") { 	index='0-0'; }else { index=logobj['logind']; }
	if (self[logobj['baseid']].Solution_real[index]!==undefined) 
	{	logobj['real']=self[logobj['baseid']].Solution_real[index];
	}else {	logobj['real']=self[logobj['baseid']].Solution_realdefault; } 
	if (self[logobj['baseid']].Solution_imag[index]!==undefined) 
	{		logobj['imag']=self[logobj['baseid']].Solution_imag[index];
	}else {	logobj['imag']=self[logobj['baseid']].Solution_imagdefault; } 
	if ((logobj['orig_real']===0)&&(logobj['orig_imag']===0)) { Set_Error(logobj['parentid'], "Log3"); }
	callback();
}
function Log2(logobj, callback)
{	logobj['logreal']=logobj['real'];		logobj['logimag']=logobj['imag'];	
	logobj['real']=logobj['orig_real'];		logobj['imag']=logobj['orig_imag'];
	callback();		}
function Log3(logobj, callback)
{	logobj['numreal']=logobj['real'];		logobj['numimag']=logobj['imag'];	
	logobj['denreal']=logobj['logreal'];	logobj['denimag']=logobj['logimag'];
	callback();
}
function Log4(logobj)
{		self[logobj['logid']].Solution_real[logobj['logind']]=logobj['real'];
		self[logobj['logid']].Solution_imag[logobj['logind']]=logobj['imag'];
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//--------------------------------------- MATH FUNCTION ABSOLUTE VALUE ------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.abs = function(replacetext, pid, pos, callback)
{	replacetext=replacetext.replace(/^abs\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length>1) { Set_Error(this.Original_id, "Abs1");  }
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "abs"); }
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id};
	var id=CreateEq(this.fileid, 0, eqobj);
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var tempid=CreateEq(this.fileid, 1, eqobj);
	for (var i in self[tempid].Solution_real)
	{	if ((self[tempid].Solution_real[i]!=='')||(self[tempid].Solution_real[i]!==undefined))
		{	if ((self[tempid].Solution_imag[i]==='')||(self[tempid].Solution_imag[i]===undefined)||(!isNumber(self[tempid].Solution_imag[i])))
			{	self[id].Solution_real[i]=Math.abs(self[tempid].Solution_real[i]); 
				self[id].Solution_imag[i]=0; 
			}else
			{	self[id].Solution_real[i]=ToNum(Math.sqrt(ToNum(Math.pow(self[tempid].Solution_real[i],2))+ToNum(Math.pow(self[tempid].Solution_imag[i],2))));
				self[id].Solution_imag[i]=0; 
	}	}	}
	self[id].Format_showequation="|"+self[tempid].Format_showequation+"|";
	self[id].Format_size=self[tempid].Format_size;
	self[id].Units_base_array=self[tempid].Units_base_array;
	self[id].Units_base_string=self[tempid].Units_base_string;
	self[id].Units_units=self[tempid].Units_units;
	self[id].Solution_realdefault=Math.sqrt(Math.pow(self[tempid].Solution_realdefault,2)+Math.pow(self[tempid].Solution_imagdefault,2));
	self[id].Solution_imagdefault=0;
	this.Solution_temps.push(self[id].Format_id);
	SetModels("abs", id, tempid);
	DOM_Object[id]['real']=self[id].Solution_real;
	DOM_Object[id]['size']=self[id]['Format_size'];
	DOM_Object[id]['imag']['0-0']=0;
	DOM_Object[id]['units']=self[id].Units_units;
	self[pid].Solution_variable_array[pos]=id;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

/*---------------------------------------------------------------------------------------------------------*/
/*-------------------------------------- MATH FUNCTION FLOOR ----------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------*/
/*	This function takes the floor of the result of any entry. When that entry has units, the algorithm		\
	automatically rounds the number after it has been converted to metric. The user has the option to enter	\
	a unit which the algorithm then matches and rounds to. Note that this rounding is done after any math	\
	within the floor function is solved.																	\
/*---------------------------------------------------------------------------------------------------------*/
Equation.prototype.floor = function(replacetext, pid, pos, callback)
{	replacetext=replacetext.replace(/^floor\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "Floor1"); }
	if (inputarray.length>2) { Set_Error(this.Original_id, "Floor2"); }
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
				Original_id:this.Original_id};
	var id=CreateEq(this.fileid, 0, eqobj);
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
				Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var tempid=CreateEq(this.fileid, 1, eqobj);
	var flag=0;
	if (inputarray.length==2)
	{	flag=1;
		var this_unit=inputarray[1].replace(/^\s+|\s+$/g, '');
		if (scaleUnits[this_unit]!==undefined)
		{	if (self[tempid].Units_quantity==scaleUnits[this_unit]['quantity'])
			{	var mult=scaleUnits[this_unit]['conv_factor'];
				for (var i in self[tempid].Solution_real)
				{ self[id].Solution_real[i]=ToNum(mult*Math.floor(self[tempid].Solution_real[i]/mult));}
				for (var i in self[tempid].Solution_imag)
				{ self[id].Solution_imag[i]=ToNum(mult*Math.floor(self[tempid].Solution_imag[i]/mult));}
			}else{ flag=0;	}
		}else 
		{	
			flag=0;
			Set_Error(this.Original_id, "Floor3");
		}
	}
	if (flag==0)
	{	for (var i in self[tempid].Solution_real)
		{	self[id].Solution_real[i]=Math.floor(self[tempid].Solution_real[i]);}
		for (var i in self[tempid].Solution_imag)
		{	self[id].Solution_imag[i]=Math.floor(self[tempid].Solution_imag[i]);}
	}
	if (inputarray.length==2) 
	{ self[id].Format_showequation="floor\\left("+self[tempid].Format_showequation+", \\hspace{1mm}"+inputarray[1]+"\\right)";
	}else 
	{ self[id].Format_showequation="floor\\left("+self[tempid].Format_showequation+"\\right)";	}
	self[id].Units_base_array=self[tempid].Units_base_array;
	self[id].Units_base_string=self[tempid].Units_base_string;
	self[id].Units_units=self[tempid].Units_units;
	self[id].Solution_realdefault=Math.floor(parseFloat(self[tempid].Solution_realdefault));
	self[id].Solution_imagdefault=Math.floor(parseFloat(self[tempid].Solution_imagdefault));
	DOM_Object[id]['real']=self[id].Solution_real;
	DOM_Object[id]['size']=self[id]['Format_size'];
	DOM_Object[id]['imag']['0-0']=0;
	DOM_Object[id]['units']=self[id].Units_units;
	this.Solution_temps.push(self[id].Format_id);
	SetModels("floor", id, tempid);
	self[pid].Solution_variable_array[pos]=id;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//------------------------------------- MATH FUNCTION CEILING ---------------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.ceil = function(replacetext, pid, pos, callback)
{	replacetext=replacetext.replace(/^ceil\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "Ceil1"); }
	if (inputarray.length>2) { Set_Error(this.Original_id, "Ceil2"); }
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
				Original_id:this.Original_id};
	var id=CreateEq(this.fileid, 0, eqobj);
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
				Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var tempid=CreateEq(this.fileid, 1, eqobj);
	var flag=0;
	if (inputarray.length==2)
	{	flag=1;
		var this_unit=inputarray[1].replace(/^\s+|\s+$/g, '');
		if (scaleUnits[this_unit]!==undefined)
		{	if (self[tempid].Units_quantity==scaleUnits[this_unit]['quantity'])
			{	var mult=scaleUnits[this_unit]['conv_factor'];
				for (var i in self[tempid].Solution_real)
				{ self[id].Solution_real[i]=ToNum(mult*Math.ceil(self[tempid].Solution_real[i]/mult));}
				for (var i in self[tempid].Solution_imag)
				{ self[id].Solution_imag[i]=ToNum(mult*Math.ceil(self[tempid].Solution_imag[i]/mult));}
			}else{ flag=0;	}
		}else 
		{	
			flag=0;
			Set_Error(this.Original_id, "Ceil3");
		}
	}
	if (flag==0)
	{	for (var i in self[tempid].Solution_real)
		{	self[id].Solution_real[i]=Math.ceil(self[tempid].Solution_real[i]);}
		for (var i in self[tempid].Solution_imag)
		{	self[id].Solution_imag[i]=Math.ceil(self[tempid].Solution_imag[i]);}
	}
	if (inputarray.length==2) 
	{ self[id].Format_showequation="ceil\\left("+self[tempid].Format_showequation+",\\hspace{1mm} "+inputarray[1]+"\\right)";
	}else 
	{ self[id].Format_showequation="ceil\\left("+self[tempid].Format_showequation+"\\right)";	}
	self[id].Units_base_array=self[tempid].Units_base_array;
	self[id].Units_base_string=self[tempid].Units_base_string;
	self[id].Units_units=self[tempid].Units_units;
	self[id].Solution_realdefault=Math.ceil(parseFloat(self[tempid].Solution_realdefault));
	self[id].Solution_imagdefault=Math.ceil(parseFloat(self[tempid].Solution_imagdefault));
	DOM_Object[id]['real']=self[id].Solution_real;
	DOM_Object[id]['size']=self[id]['Format_size'];
	DOM_Object[id]['imag']['0-0']=0;
	DOM_Object[id]['units']=self[id].Units_units;
	this.Solution_temps.push(self[id].Format_id);
	SetModels("ceil", id, tempid);
	self[pid].Solution_variable_array[pos]=id;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//--------------------------------------- MATH FUNCTION ROUND ---------------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.round = function(replacetext, pid, pos, callback)
{	var multiplier=0, umult=1, temp=0;
	replacetext=replacetext.replace(/^round\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "round"); }
	if (inputarray.length>3) { Set_Error(this.Original_id, "Round1"); }
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
				Original_id:this.Original_id};
	var id=CreateEq(this.fileid, 0, eqobj);
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
				Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var tempid=CreateEq(this.fileid, 1, eqobj);
	var flag=0;
	if (inputarray.length==3)
	{	flag=1;
		var this_unit=inputarray[2].replace(/^\s+|\s+$/g, '');
		if (scaleUnits[this_unit]!==undefined)
		{	if (self[tempid].Units_quantity==scaleUnits[this_unit]['quantity'])
			{	umult=scaleUnits[this_unit]['conv_factor'];
			}else{ flag=0;	}
		}else { flag=0; }
	}
	if ((inputarray.length==2)||(inputarray.length==3)) 
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
				Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
		var multid=CreateEq(this.fileid, 1, eqobj);
		multiplier=self[multid].Solution_real['0-0'];
		if ((multiplier % 1 != 0)||(multiplier % 1 != -0)) { Set_Error(this.Original_id, "Round2"); }
	}else { multiplier=0; }
	for (var i in self[tempid].Solution_real)
	{	if ((self[tempid].Solution_real[i]!=='')&&(self[tempid].Solution_real[i]!==undefined))
		{	temp=Math.round(parseFloat(Big(self[tempid].Solution_real[i]).div(Big(umult)).times(Big(Math.pow(10,multiplier)))));
			self[id].Solution_real[i]=parseFloat(Big(umult).times(Big(temp).div(Big(Math.pow(10,multiplier))))); }
		if ((self[tempid].Solution_imag[i]!=='')&&(self[tempid].Solution_imag[i]!==undefined))
		{	temp=Math.round(parseFloat(Big(self[tempid].Solution_imag[i]).div(Big(umult)).times(Big(Math.pow(10,multiplier)))));
			self[id].Solution_imag[i]=parseFloat(Big(umult).times(Big(temp).div(Big(Math.pow(10,multiplier))))); }
	}
	if (inputarray.length===1) 
	{ self[id].Format_showequation="round\\left("+self[tempid].Format_showequation+"\\right)"; }
	if (inputarray.length===2) 
	{ self[id].Format_showequation="round\\left("+self[tempid].Format_showequation+", \\hspace{1mm}"+inputarray[1]+"\\right)"; }
	if (inputarray.length===3) 
	{ self[id].Format_showequation="round\\left("+self[tempid].Format_showequation+", \\hspace{1mm}"+inputarray[1]+", \\hspace{1mm}"+inputarray[2]+"\\right)"; }
	self[id].Units_base_array=self[tempid].Units_base_array;
	self[id].Units_base_string=self[tempid].Units_base_string;
	self[id].Units_units=self[tempid].Units_units;
	self[id].Solution_realdefault=Math.round(parseFloat(Math.round(self[tempid].Solution_realdefault*Math.pow(10,multiplier))/Math.pow(10,multiplier)));
	self[id].Solution_imagdefault=Math.round(parseFloat(Math.round(self[tempid].Solution_imagdefault*Math.pow(10,multiplier))/Math.pow(10,multiplier)));
	DOM_Object[id]['real']=self[id].Solution_real;
	DOM_Object[id]['size']=self[id]['Format_size'];
	DOM_Object[id]['imag']['0-0']=0;
	DOM_Object[id]['units']=self[id].Units_units;
	this.Solution_temps.push(self[id].Format_id);
	SetModels("round", id, tempid);
	self[pid].Solution_variable_array[pos]=id;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//-------------------------------- MATH FUNCTION MAX ------------------------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.max = function(replacetext, pid, pos, callback)
{	replacetext=replacetext.replace(/^max\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var showeq='';	var num=''; var dim=''; var units=''; var quan='';
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "Max1"); }
	var nums=new Array(); var thistext=''; 
	for (var a=0; a<inputarray.length; a=a+1)
	{	inputarray[a]=inputarray[a].replace(/^\s+|\s+$/g, '');
		if (isNumber(inputarray[a])) 
		{	nums.push(parseFloat(inputarray[a]));	showeq=showeq+", "+inputarray[a];
			num=num+", "+inputarray[a];		dim=dim+", 1x1";
			units=units+", NA";				quan=quan+", NA";
		}else if (inputarray[a].match('#Table')) 
		{	var numberarray = Get_Table_Elements (inputarray[a], 1);
			for (var b=0; b<numberarray.length; b=b+1)
			{	nums.push(numberarray[b]);	showeq=showeq+", "+inputarray[a];  
				num=num+", "+inputarray[a];		dim=dim+", 1x1";
				units=units+", NA";				quan=quan+", NA";	}
		}else 
		{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
				Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 1, eqobj);
			if (self[tempid].Format_size=="1x1") 
			{ nums.push(ToNum(self[tempid].Solution_real['0-0']));
			}else 
			{ for (var i in self[tempid].Solution_real) 
			{ nums.push(ToNum(self[tempid].Solution_real[i]));}	}
				num=num+", "+self[tempid].Format_showequation;
				dim=dim+", "+self[tempid].Format_size;
				units=units+", "+self[tempid].Units_units;
				quan=quan+", "+self[tempid].Units_quantity;
				showeq=showeq+", "+self[tempid].Format_showequation;	
	}	}
	showeq=showeq.replace(/^\,/,'');	num=num.replace(/^\,/,'');	dim=dim.replace(/^\,/,'');
	units=units.replace(/^\,/,'');		quan=quan.replace(/^\,/,'');
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq=0"};
	var id=CreateEq(this.fileid, 0, eqobj);
	self[id].Solution_real['0-0']=Math.max.apply(null, nums); 
	self[id].Format_showequation="max\\left("+showeq+"\\right)";
	this.Solution_temps.push(self[id].Format_id);
	self[id].Models_numerical="max\\left("+num+"\\right)";
	self[id].Models_dimensions="max\\left("+dim+"\\right)";
	self[id].Models_quantities="max\\left("+quan+"\\right)";
	self[id].Models_units="max\\left("+units+"\\right)";
	DOM_Object[id]['real']=self[id].Solution_real;
	DOM_Object[id]['size']=self[id]['Format_size'];
	DOM_Object[id]['imag']['0-0']=0;
	DOM_Object[id]['units']=self[id].Units_units;
	self[pid].Solution_variable_array[pos]=id;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//


/*---------------------------------------------------------------------------------------------------------*/
/*---------------------------------- MATH FUNCTION MIN ----------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------*/
/*	This function looks for the minimum number in the set of numbers given. The function does not care 		\
	about units or comparing quantities. It passes through the units of any number.							\
/*---------------------------------------------------------------------------------------------------------*/
Equation.prototype.min = function(replacetext, pid, pos, callback)
{	replacetext=replacetext.replace(/^min\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var showeq='';	var num=''; var dim=''; var units=''; var quan='';
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "Min1"); }
	var nums=new Array(); var thistext=''; 
	for (var a=0; a<inputarray.length; a=a+1)
	{	inputarray[a]=inputarray[a].replace(/^\s+|\s+$/g, '');
		if (isNumber(inputarray[a])) 
		{	nums.push(parseFloat(inputarray[a]));	showeq=showeq+", "+inputarray[a];
			num=num+", "+inputarray[a];		dim=dim+", 1x1";
			units=units+", NA";				quan=quan+", NA";
		}else if (inputarray[a].match('#Table')) 
		{	var numberarray = Get_Table_Elements (inputarray[a], 1);
			for (var b=0; b<numberarray.length; b=b+1)
			{	nums.push(numberarray[b]);	showeq=showeq+", "+inputarray[a];  
				num=num+", "+inputarray[a];		dim=dim+", 1x1";
				units=units+", NA";				quan=quan+", NA";	}
		}else 
		{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
				Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var id=CreateEq(this.fileid, 1, eqobj);
			if (self[id].Format_size=="1x1") 
			{	nums.push(ToNum(self[id].Solution_real['0-0'])); 
				showeq=showeq+", "+self[id].Format_showequation;
				num=num+", "+self[id].Solution_real['0-0'];		dim=dim+", 1x1";
				units=units+", "+self[id].Units_units;	quan=quan+", "+self[id].Units_quantity;
			}else 
			{ 	for (var i in self[id].Solution_real) 
				{	nums.push(ToNum(self[id].Solution_real[i])); 	}
				num=num+", "+self[id].Format_showequation;	dim=dim+", "+self[id].Format_size;
				units=units+", "+self[id].Units_units;	quan=quan+", "+self[id].Units_quantity;
				showeq=showeq+", "+self[id].Format_showequation;	
			}
		}
	}
	showeq=showeq.replace(/^\,/,'');	num=num.replace(/^\,/,'');	dim=dim.replace(/^\,/,'');
	units=units.replace(/^\,/,'');		quan=quan.replace(/^\,/,'');
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq=0"};
	var id=CreateEq(this.fileid, 0, eqobj);
	self[id].Solution_real['0-0']=Math.min.apply(null, nums); 
	self[id].Format_showequation="min\\left("+showeq+"\\right)";
	self[id].Models_numerical="min\\left("+num+"\\right)";
	self[id].Models_dimensions="min\\left("+dim+"\\right)";
	self[id].Models_quantities="min\\left("+quan+"\\right)";
	self[id].Models_units="min\\left("+units+"\\right)";
	DOM_Object[id]['real']=self[id].Solution_real;
	DOM_Object[id]['size']=self[id]['Format_size'];
	DOM_Object[id]['imag']['0-0']=0;
	DOM_Object[id]['units']=self[id].Units_units;
	this.Solution_temps.push(self[id].Format_id);
	self[pid].Solution_variable_array[pos]=id;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//-------------------------------- MATH FUNCTION MAX - with units -----------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.maxu = function(replacetext, pid, pos, callback)
{	var basestring=''; var tempbasestring='';
	replacetext=replacetext.replace(/^maxu\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var showeq='';	var num=''; var dim=''; var units=''; var quan='';
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "Max1"); }
	var nums=new Array(); var thistext=''; 
	for (var a=0; a<inputarray.length; a=a+1)
	{	inputarray[a]=inputarray[a].replace(/^\s+|\s+$/g, '');
		var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
					Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
		var tempid=CreateEq(this.fileid, 1, eqobj);
		if (basestring==='') { basestring=self[tempid].Units_base_string; 
		}else 
		{	if (basestring!=self[tempid].Units_base_string) { Set_Error(this.Original_id, "Max2");} }
		if (self[tempid].Format_size=="1x1") { nums.push(self[tempid].Solution_real['0-0']);
				showeq=showeq+", "+self[tempid].Format_showequation;
				num=num+", "+self[tempid].Solution_real['0-0'];		dim=dim+", 1x1";
				units=units+", "+self[tempid].Units_units;
				quan=quan+", "+self[tempid].Units_quantity;
		}else 
		{ 	for (var i in self[tempid].Solution_real) { nums.push(self[tempid].Solution_real[i]);}
				showeq=showeq+", "+self[tempid].Format_showequation;
				num=num+", "+self[tempid].Solution_real['0-0'];
				dim=dim+", "+self[tempid].Format_size;
				units=units+", "+self[tempid].Units_units;
				quan=quan+", "+self[tempid].Units_quantity;
		}
		showeq=showeq.replace(/^\,/,'');	num=num.replace(/^\,/,''); dim=dim.replace(/^\,/,'');
		units=units.replace(/^\,/,'');		quan=quan.replace(/^\,/,''); 
	}
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq=0"};
	var id=CreateEq(this.fileid, 0, eqobj);
	self[id].Units_units=self[tempid].Units_units; 
	self[id].Units_base_array=self[tempid].Units_base_array; 
	self[id].Units_base_string=self[tempid].Units_base_string; 
	self[id].Solution_real['0-0']=Math.max.apply(null, nums); 
	self[id].Format_showequation="maxu\\left("+replacetext+"\\right)";
	this.Solution_temps.push(self[id].Format_id, tempid);
	self[id].Models_numerical="maxu\\left("+num+"\\right)";
	self[id].Models_dimensions="maxu\\left("+dim+"\\right)";
	self[id].Models_quantities="maxu\\left("+quan+"\\right)";
	self[id].Models_units="maxu\\left("+units+"\\right)";
	DOM_Object[id]['real']=self[id].Solution_real;
	DOM_Object[id]['size']=self[id]['Format_size'];
	DOM_Object[id]['imag']['0-0']=0;
	DOM_Object[id]['units']=self[id].Units_units;
	self[pid].Solution_variable_array[pos]=id;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//-------------------------------- MATH FUNCTION MIN - with units -----------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.minu = function(replacetext, pid, pos, callback)
{	var basestring=''; var tempbasestring='';
	replacetext=replacetext.replace(/^minu\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var showeq='';	var num=''; var dim=''; var units=''; var quan='';
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "Min2"); }
	var nums=new Array(); var thistext=''; 
	for (var a=0; a<inputarray.length; a=a+1)
	{	inputarray[a]=inputarray[a].replace(/^\s+|\s+$/g, '');
		var eqobj={Page_position:DOM_Object[this.Format_id]['location'],Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
		var tempid=CreateEq(this.fileid, 1, eqobj);
		if (basestring==='') { basestring=self[tempid].Units_base_string; 
		}else 
		{	if (basestring!=self[tempid].Units_base_string) { Set_Error(this.Original_id, "Min2");} }
		if (self[tempid].Format_size=="1x1") { nums.push(self[tempid].Solution_real['0-0']);
				showeq=showeq+", "+self[tempid].Format_showequation;
				num=num+", "+self[tempid].Solution_real['0-0'];		dim=dim+", 1x1";
				units=units+", "+self[tempid].Units_units;
				quan=quan+", "+self[tempid].Units_quantity;
		}else 
		{ for (var i in self[tempid].Solution_real) { nums.push(self[tempid].Solution_real[i]); } 
				showeq=showeq+", "+self[tempid].Format_showequation;
				num=num+", "+self[tempid].Solution_real['0-0'];
				dim=dim+", "+self[tempid].Format_size;
				units=units+", "+self[tempid].Units_units;
				quan=quan+", "+self[tempid].Units_quantity;
		}
		showeq=showeq.replace(/^\,/,'');	num=num.replace(/^\,/,''); dim=dim.replace(/^\,/,'');
		units=units.replace(/^\,/,'');		quan=quan.replace(/^\,/,''); 
	}
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq=0"};
	var id=CreateEq(this.fileid, 0, eqobj);
	self[id].Units_units=self[tempid].Units_units; 
	self[id].Units_base_array=self[tempid].Units_base_array; 
	self[id].Units_base_string=self[tempid].Units_base_string; 
	self[id].Solution_real['0-0']=Math.min.apply(null, nums); 
	self[id].Format_showequation="minu\\left("+showeq+"\\right)";
	this.Solution_temps.push(self[id].Format_id);
	self[id].Models_numerical="minu\\left("+num+"\\right)";
	self[id].Models_dimensions="minu\\left("+dim+"\\right)";
	self[id].Models_quantities="minu\\left("+quan+"\\right)";
	self[id].Models_units="minu\\left("+units+"\\right)";
	DOM_Object[id]['real']=self[id].Solution_real;
	DOM_Object[id]['size']=self[id]['Format_size'];
	DOM_Object[id]['imag']['0-0']=0;
	DOM_Object[id]['units']=self[id].Units_units;
	self[pid].Solution_variable_array[pos]=id;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//-------------------------------- MATH FUNCTION MAX INDEX ------------------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.maxInd = function(replacetext, pid, pos, callback)
{	replacetext=replacetext.replace(/^maxInd\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var showeq='';	var num=''; var dim=''; var units=''; var quan='';
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "Max1"); }
	var nums=new Array(); var thistext=''; 
	for (var a=0; a<inputarray.length; a=a+1)
	{	inputarray[a]=inputarray[a].replace(/^\s+|\s+$/g, '');
		if (isNumber(inputarray[a])) 
		{	nums.push(parseFloat(inputarray[a]));	showeq=showeq+", "+inputarray[a];
			num=num+", "+inputarray[a];		dim=dim+", 1x1";
			units=units+", NA";				quan=quan+", NA";
		}else if (inputarray[a].match('#Table')) 
		{	var numberarray = Get_Table_Elements (inputarray[a], 1);
			for (var b=0; b<numberarray.length; b=b+1)
			{	nums.push(numberarray[b]);	showeq=showeq+", "+inputarray[a];  
				num=num+", "+inputarray[a];		dim=dim+", 1x1";
				units=units+", NA";				quan=quan+", NA";	}
		}else 
		{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
				Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 1, eqobj);
			if (self[tempid].Format_size=="1x1") 
			{ nums.push(ToNum(self[tempid].Solution_real['0-0']));
			}else 
			{ 
				for (var i in self[tempid].Solution_real) 
				{ 
					nums.push(ToNum(self[tempid].Solution_real[i]));}	
				}
				num=num+", "+self[tempid].Format_showequation;
				dim=dim+", "+self[tempid].Format_size;
				units=units+", "+self[tempid].Units_units;
				quan=quan+", "+self[tempid].Units_quantity;
				showeq=showeq+", "+self[tempid].Format_showequation;	
	}	}

	// Find the max index
	var max = nums[0];
	var maxIndex = 0;
	for (var i = 1; i < nums.length; i++) 
	{
        if (nums[i] > max) {
            maxIndex = i;
            max = nums[i];
        }
    }

   	showeq=showeq.replace(/^\,/,'');	num=num.replace(/^\,/,'');	dim=dim.replace(/^\,/,'');
	units=units.replace(/^\,/,'');		quan=quan.replace(/^\,/,'');
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq=0"};
	var id=CreateEq(this.fileid, 0, eqobj);
	self[id].Solution_real['0-0']=maxIndex; 
	self[id].Format_showequation="maxInd\\left("+showeq+"\\right)";
	this.Solution_temps.push(self[id].Format_id);
	self[id].Models_numerical="maxInd\\left("+num+"\\right)";
	self[id].Models_dimensions="maxInd\\left("+dim+"\\right)";
	self[id].Models_quantities="maxInd\\left("+quan+"\\right)";
	self[id].Models_units="maxInd\\left("+units+"\\right)";
	DOM_Object[id]['real']=self[id].Solution_real;
	DOM_Object[id]['size']=self[id]['Format_size'];
	DOM_Object[id]['imag']['0-0']=0;
	DOM_Object[id]['units']='';
	self[pid].Solution_variable_array[pos]=id;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//


//---------------------------------------------------------------------------------------------------------//
//-------------------------------- MATH FUNCTION MAX INDEX ------------------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.minInd = function(replacetext, pid, pos, callback)
{	replacetext=replacetext.replace(/^minInd\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var showeq='';	var num=''; var dim=''; var units=''; var quan='';
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "Min1"); }
	var nums=new Array(); var thistext=''; 
	for (var a=0; a<inputarray.length; a=a+1)
	{	inputarray[a]=inputarray[a].replace(/^\s+|\s+$/g, '');
		if (isNumber(inputarray[a])) 
		{	nums.push(parseFloat(inputarray[a]));	showeq=showeq+", "+inputarray[a];
			num=num+", "+inputarray[a];		dim=dim+", 1x1";
			units=units+", NA";				quan=quan+", NA";
		}else if (inputarray[a].match('#Table')) 
		{	var numberarray = Get_Table_Elements (inputarray[a], 1);
			for (var b=0; b<numberarray.length; b=b+1)
			{	nums.push(numberarray[b]);	showeq=showeq+", "+inputarray[a];  
				num=num+", "+inputarray[a];		dim=dim+", 1x1";
				units=units+", NA";				quan=quan+", NA";	}
		}else 
		{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
				Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 1, eqobj);
			if (self[tempid].Format_size=="1x1") 
			{ nums.push(ToNum(self[tempid].Solution_real['0-0']));
			}else 
			{ 
				for (var i in self[tempid].Solution_real) 
				{ 
					nums.push(ToNum(self[tempid].Solution_real[i]));}	
				}
				num=num+", "+self[tempid].Format_showequation;
				dim=dim+", "+self[tempid].Format_size;
				units=units+", "+self[tempid].Units_units;
				quan=quan+", "+self[tempid].Units_quantity;
				showeq=showeq+", "+self[tempid].Format_showequation;	
	}	}

	// Find the min index
	var min = nums[0];
	var minIndex = 0;
	for (var i = 1; i < nums.length; i++) 
	{
        if (nums[i] < min) {
            minIndex = i;
            min = nums[i];
        }
    }

   	showeq=showeq.replace(/^\,/,'');	num=num.replace(/^\,/,'');	dim=dim.replace(/^\,/,'');
	units=units.replace(/^\,/,'');		quan=quan.replace(/^\,/,'');
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq=0"};
	var id=CreateEq(this.fileid, 0, eqobj);
	self[id].Solution_real['0-0']=minIndex; 
	self[id].Format_showequation="minInd\\left("+showeq+"\\right)";
	this.Solution_temps.push(self[id].Format_id);
	self[id].Models_numerical="minInd\\left("+num+"\\right)";
	self[id].Models_dimensions="minInd\\left("+dim+"\\right)";
	self[id].Models_quantities="minInd\\left("+quan+"\\right)";
	self[id].Models_units="minInd\\left("+units+"\\right)";
	DOM_Object[id]['real']=self[id].Solution_real;
	DOM_Object[id]['size']=self[id]['Format_size'];
	DOM_Object[id]['imag']['0-0']=0;
	DOM_Object[id]['units']='';
	self[pid].Solution_variable_array[pos]=id;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//


//---------------------------------------------------------------------------------------------------------//
//------------------------------------- FUNCTION TO FIND NATURAL LOG --------------------------------------//
//---------------------------------------------------------------------------------------------------------//
function NatLog (obj, callback)
{	if (obj['real']==='') {var real=0;}else { var real=obj['real']; }
	if (obj['imag']==='') {var imag=0;}else { var imag=obj['imag']; }
//	var modulus=ToNum(Math.sqrt(Math.pow(real,2)+Math.pow(imag,2)));
	var modulus=Math.sqrt(parseFloat(Big(real).pow(2).plus(Big(imag).pow(2))));
	var argument=ToNum(Math.atan2(imag,real));
	obj['real']=Math.log(modulus);
	obj['imag']=argument;
	callback();
}
//---------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------------------ TRANSPOSING A MATRIX ---------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
/*
This function handles transposing a matrix. This can be done by calling Transpose(X) where X  is text or an equation ID. It can also be done by calling []^T
*/
Equation.prototype.Transpose = function(text, pid, pos, callback) 
{	var flag=0;
	replacetext=text.replace(/^Transpose\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length==0) { Set_Error(this.Original_id, "NoEntry", "Transpose"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "Transpose1"); flag=1; }
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var id1=CreateEq(this.fileid, 1, eqobj);
		var newid=MatrixTranspose(id1);
		self[newid].Format_showequation=self[id1].Format_showequation+"^T";
		this.Solution_temps.push(newid);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['imag']=self[newid].Solution_imag;
		DOM_Object[newid]['units']=self[newid].Units_units;
		SetModels("Transpose", newid, id1);
		self[pid].Solution_variable_array[pos]=newid;
	}else { var newid='';}
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function MatrixTranspose(oldid)
{
	var sizes=self[oldid].Format_size.split("x");
	var size1=sizes[0];
	var size2=sizes[1];
	var realarray=new Array();
	var imagarray=new Array();
	for (var index1 = 0; index1 < size2; ++index1) 
	{	for (var index2 = 0; index2 < size1; ++index2) 
		{	var key1=index1+"-"+index2;
			var key2=index2+"-"+index1;
			realarray[key1]=self[oldid].Solution_real[key2];
			imagarray[key1]=self[oldid].Solution_imag[key2];
	}	}
	var eqobj={Page_position:DOM_Object[oldid]['location'], Format_showtype:"InnerFunction", 
		Original_id:self[oldid].Original_id, equation:"Temp=0"};
	var id=CreateEq(this.fileid, 0, eqobj);
	self[id].Solution_real=realarray;
	self[id].Solution_imag=imagarray;
	self[id].Format_size=size2+"x"+size1;
	self[id].Format_numinds=self[oldid].Format_numinds;
	self[id].Format_showtype='builtin';
	self[id].Units_base_string=self[oldid].Units_base_string;
	self[id].Units_units=self[oldid].Units_units;
	self[id].Units_base_array=self[oldid].Units_base_array;
	DOM_Object[id]['real']=self[id].Solution_real;
	DOM_Object[id]['imag']=self[id].Solution_imag;
	DOM_Object[id]['size']=self[id]['Format_size'];
	DOM_Object[id]['imag']['0-0']=0;
	DOM_Object[id]['units']=self[id].Units_units;
	return id;
}

//---------------------------------------------------------------------------------------------------------//
//-------------------------------- GET THE SIZE OF THE MATRIX ---------------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.Size = function(replacetext, pid, pos, callback)
{	var flag=1;
	replacetext=replacetext.replace(/^Size\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Size"); flag=0; }
	if (inputarray.length>2) { Set_Error(this.Original_id, "Size1"); flag=0; }
	if (inputarray.length<2) { Set_Error(this.Original_id, "Size2"); flag=0; }
	if (flag==1)
	{	
		var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
					Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var eqid=CreateEq(this.fileid, 1, eqobj);
		
		var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
					Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
		var numid=CreateEq(this.fileid, 1, eqobj);	
		//if (self[numid].Solution_real['0-0']===0) { Set_Error(this.Original_id, "Size3"); flag=0; }
		

		var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
					Original_id:this.Original_id, Format_size:"1x1"};
		var id=CreateEq(this.fileid, 0, eqobj);
		

		var temp=self[eqid].Format_size.split('x');
		if ((parseInt(self[numid].Solution_real['0-0'], 10)>(temp.length))) 
		{	self[id].Solution_real['0-0']=0;
		}else { self[id].Solution_real['0-0']=temp[parseInt(self[numid].Solution_real['0-0'])]; }

		console.log('I set the size to '+self[id].Solution_real['0-0'])		

		self[id].Solution_imag['0-0']=0;
		DOM_Object[id]['real']=self[id].Solution_real;
		DOM_Object[id]['size']=self[id]['Format_size'];
		DOM_Object[id]['imag']['0-0']=0;
		self[id].Format_showequation="Size\\left("+self[eqid].Format_showequation+","+self[numid].Format_showequation+"\\right)";	
		this.Solution_temps.push(self[id].Format_id);
		this.Solution_temps.push(self[eqid].Format_id);
		this.Solution_temps.push(self[numid].Format_id);
		SetModels("Size", id, eqid, numid);
		self[pid].Solution_variable_array[pos]=id;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
		DOM_Object[id]['real']=self[id].Solution_real;
		DOM_Object[id]['size']=self[id]['Format_size'];
		DOM_Object[id]['imag']['0-0']=0;
		DOM_Object[id]['units']=self[id].Units_units;
	}	 
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------ CREATE NEW MATRIX WITH GIVEN DEFAULT -----------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.CreateMatrix = function(replacetext, pid, pos, callback)
{	var maxes=new Array();	var current=new Array();	var total=1; var flag=0;	var key='';		var size='';
	var showeq='';	var num=''; var dim=''; var units=''; var quan='';
	replacetext=replacetext.replace(/^CreateMatrix\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) 	{ Set_Error(this.Original_id, "NoEntry", "CreateMatrix"); flag=1; 
	}else if (inputarray.length<4) { Set_Error(this.Original_id, "CreateMatrix1"); flag=1; }
	var realdefault=0;	var imagdefault=0;
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location'], 10), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var rdid=CreateEq(this.fileid, 1, eqobj);
		showeq=showeq+', '+self[rdid].Format_showequation;
		num=num+', '+self[rdid].Solution_real['0-0'];	dim=dim+', '+self[rdid].Format_size;
		
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location'], 10), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
		var idid=CreateEq(this.fileid, 1, eqobj);
		showeq=showeq+', '+self[idid].Format_showequation;
		num=num+', '+self[idid].Solution_real['0-0'];	dim=dim+', '+self[idid].Format_size;
		
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location'], 10), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq=0"};
		var id=CreateEq(this.fileid, 0, eqobj);

		for (var a=2; a<inputarray.length; a++)
		{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location'], 10), Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 1, eqobj);
			maxes[a-2]=self[tempid].Solution_real['0-0'];
			this.Solution_temps.push(tempid);
			showeq=showeq+', '+self[tempid].Format_showequation;
			num=num+', '+self[tempid].Solution_real['0-0'];	dim=dim+', '+self[tempid].Format_size;
		}
		for (var a=0; a<maxes.length; a++){	total=total*maxes[a];	current[a]=0;	size=size+'x'+maxes[a];	}		
		size=size.replace(/^\x/,'');			num=num.replace(/^\,/,'');
		showeq=showeq.replace(/^\,/,''); 		dim=dim.replace(/^\,/,'');
		for (var a=0; a<total; a++)
		{	current[maxes.length-1]=parseInt(current[maxes.length-1], 10)+1;
			for (var b=maxes.length-1; b>=0; b--)		
			{	if (current[b]==maxes[b])
				{	current[b-1]=parseInt(current[b-1], 10)+1;
					current[b]=0;
				}
			}
			key='';
			for (var b=0; b<maxes.length; b++)	{ key=key+'-'+current[b]; }		
			key=key.replace(/^\-/,'');
			self[id].Solution_real[key]=self[rdid].Solution_real['0-0'];
			self[id].Solution_imag[key]=self[idid].Solution_real['0-0'];
		}
		self[id].Solution_realdefault=self[rdid].Solution_real['0-0'];
		self[id].Solution_imagdefault=self[idid].Solution_real['0-0'];
		self[id].Format_size=size;
		this.Solution_temps.push(self[id].Format_id, rdid, idid);
		self[id].Format_showequation="CreateMatrix\\left("+showeq+"\\right)";
		self[id].Models_numerical="CreateMatrix\\left("+num+"\\right)";
		self[id].Models_dimensions="CreateMatrix\\left("+dim+"\\right)";
		self[id].Models_quantities="CreateMatrix\\left("+quan+"\\right)";
		self[id].Models_units="CreateMatrix\\left("+units+"\\right)";
		DOM_Object[id]['real']=self[id].Solution_real;
		DOM_Object[id]['size']=self[id]['Format_size'];
		DOM_Object[id]['imag']['0-0']=0;
		DOM_Object[id]['units']=self[id].Units_units;
		self[pid].Solution_variable_array[pos]=id;
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//---------------------------------------------- CREATE AN IDENTITY MATRIX ------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.Identity = function(replacetext, pid, pos, callback)
{	var flag=0;
	replacetext=replacetext.replace(/^Identity\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) 	{ Set_Error(this.Original_id, "NoEntry", "Identity"); flag=1; }
	if (inputarray.length>1) 	{ Set_Error(this.Original_id, "Identity1"); flag=1; }
	if (flag===0)
	{	var key='';
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location'],10),Format_showtype:"InnerFunction",
		Original_id:this.Original_id, equation:"IdentEq="+inputarray[0]};
		var tempid=CreateEq(this.fileid, 1, eqobj);
		var size=self[tempid].Solution_real['0-0'];
				for (var a=0; a<size; a++)
		{	for (var b=0; b<size; b++)
			{	key=a+'-'+b;
				if (a==b)
				{	self[tempid].Solution_real[key]=1;
				}else
				{
					self[tempid].Solution_real[key]=0;
				}
			}
		}
		self[tempid].Format_showequation="Identity\\left("+self[tempid].Format_showequation+"\\right)";
		self[tempid].Format_size=size+'x'+size;
		this.Solution_temps.push(tempid);
		SetModels("Identity", tempid, tempid);
		DOM_Object[tempid]['real']=self[tempid].Solution_real;
		DOM_Object[tempid]['size']=self[tempid]['Format_size'];
		DOM_Object[tempid]['imag']['0-0']=0;
		DOM_Object[tempid]['units']=self[tempid].Units_units;
		self[pid].Solution_variable_array[pos]=tempid;
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
	}else
	{
		self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
	}
}
//-------------------------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------------------------------------------//
//----------------------------------------------- MATH FUNCTION - Integrate with Newton-Cotes -------------------------------------------------//
//---------------------------------------------------------------------------------------------------------------------------------------------//
/*
This is the function to integrate functions using the Newton-Cotes methods. It takes in a string that is comma separated to give 5 inputs.
 0 	- The vector holding the x data
1	- The vector holding the y data
2 	- The order of the integral - 1 for trapezoid, 2 Simpsons 1/3, 3 for 3/8, 4 for Booles
http://www.stanford.edu/~fringer/teaching/numerical_methods_02/handouts/lecture5.pdf
*/
Equation.prototype.NewtonCotes = function(text, pid, pos, callback)		 
{	var flag=0;	var I=Big(0);
	var replacetext=text.replace(/^\s+|\s+$/g, '');
	replacetext=replacetext.replace(/^[NewtonCotes(]+/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "NewtonCotes"); }
	if (inputarray.length<3) { Set_Error(this.Original_id, "NC4"); }
	if (inputarray.length>3) { Set_Error(this.Original_id, "NC5"); }
	var xdata=inputarray[0]; var ydata=inputarray[1]; 														 
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+inputarray[2]};
	var id1=CreateEq(this.fileid, 1, eqobj);		var order=self[id1].Solution_real['0-0'];
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+xdata};
	var xid=CreateEq(this.fileid, 1, eqobj);
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+ydata};
	var yid=CreateEq(this.fileid, 1, eqobj);
	var size=self[xid].Format_size.split('x'); var size1=size[1];
	var lower=self[xid].Solution_real['0-0'];
	var upper=0;
	var upper=0;
	if (order==2) { if ((size1-1)%2!==0) { Set_Error(this.Original_id, "NC1"); flag=1; } }
	if (order==3) { if ((size1-1)%3!==0) { Set_Error(this.Original_id, "NC2"); flag=1; } }
	if (order==4) { if ((size1-1)%4!==0) { Set_Error(this.Original_id, "NC3"); flag=1; } }
	if (parseInt(size1, 10)<5) 				{ Set_Error(this.Original_id, "NC8"); flag=1;  }
	if (self[xid].Format_size!=self[yid].Format_size) { Set_Error(this.Original_id, "NC6"); flag=1;  }
	if (!isNumber(order)) { Set_Error(this.Original_id, "NC7"); flag=1; } 
	if (!flag)
	{	if (order==1)
		{	for (var i=0; i<size1-1; i=i+1)
			{	x1=self[xid].Solution_real['0-'+parseInt(parseInt(i, 10), 10)];	x2=self[xid].Solution_real['0-'+parseInt(parseInt(i, 10)+1, 10)];
				y1=self[yid].Solution_real['0-'+parseInt(parseInt(i, 10), 10)];	y2=self[yid].Solution_real['0-'+parseInt(parseInt(i, 10)+1, 10)];
				I=I.plus(Big(0.5).times(Big(x2).minus(Big(x1))).times(Big(y2).plus(Big(y1))));
				if (ToNum(x2)>ToNum(upper)) { upper=x2; 	}	}	}
		if (order==2)
		{	for (var i=0; i<size1-2; i=i+2)
			{	x1=self[xid].Solution_real['0-'+parseInt(parseInt(i, 10), 10)];	x2=self[xid].Solution_real['0-'+parseInt(parseInt(i, 10)+1, 10)];
				x3=self[xid].Solution_real['0-'+parseInt(parseInt(i, 10)+2, 10)];
				y1=self[yid].Solution_real['0-'+parseInt(parseInt(i, 10), 10)];	y2=self[yid].Solution_real['0-'+parseInt(parseInt(i, 10)+1, 10)];
				y3=self[yid].Solution_real['0-'+parseInt(parseInt(i, 10)+2, 10)];
				I=I.plus(Big(1).div(Big(6)).times(Big(x3).minus(Big(x1))).times(Big(y1).plus(Big(4).times(Big(y2))).plus(Big(y3))));
				if (ToNum(x3)>ToNum(upper)) { upper=x3; 	}	}	}
		if (order==3)
		{	for (var i=0; i<size1-4; i=i+3)
			{	x1=self[xid].Solution_real['0-'+parseInt(parseInt(i, 10), 10)];	x2=self[xid].Solution_real['0-'+parseInt(parseInt(i, 10)+1, 10)];
				x3=self[xid].Solution_real['0-'+parseInt(parseInt(i, 10)+2, 10)];	x4=self[xid].Solution_real['0-'+parseInt(parseInt(i, 10)+3, 10)];
				y1=self[yid].Solution_real['0-'+parseInt(parseInt(i, 10), 10)];	y2=self[yid].Solution_real['0-'+parseInt(parseInt(i, 10)+1, 10)];
				y3=self[yid].Solution_real['0-'+parseInt(parseInt(i, 10)+2, 10)];	y4=self[yid].Solution_real['0-'+parseInt(parseInt(i, 10)+3, 10)];
				I=I.plus(Big(1).div(Big(8)).times(Big(x4).minus(Big(x1))).times(Big(y1).plus(Big(3).times(Big(y2))).plus(Big(3).times(Big(y3))).plus(Big(y4))));
				if (ToNum(x4)>ToNum(upper)) { upper=x4; 	}	}	}
		if (order==4)
		{	for (var i=0; i<=size1-5; i=i+4)
			{	x1=self[xid].Solution_real['0-'+parseInt(parseInt(i, 10), 10)];	x2=self[xid].Solution_real['0-'+parseInt(parseInt(i, 10)+1, 10)];
				x3=self[xid].Solution_real['0-'+parseInt(parseInt(i, 10)+2, 10)];	x4=self[xid].Solution_real['0-'+parseInt(parseInt(i, 10)+3, 10)];
				x5=self[xid].Solution_real['0-'+parseInt(parseInt(i, 10)+4, 10)];
				y1=self[yid].Solution_real['0-'+parseInt(parseInt(i, 10), 10)];	y2=self[yid].Solution_real['0-'+parseInt(parseInt(i, 10)+1, 10)];
				y3=self[yid].Solution_real['0-'+parseInt(parseInt(i, 10)+2, 10)];	y4=self[yid].Solution_real['0-'+parseInt(parseInt(i, 10)+3, 10)];
				y5=self[yid].Solution_real['0-'+parseInt(parseInt(i, 10)+4, 10)];
				I=I.plus(Big(1).div(Big(90)).times(Big(x5).minus(Big(x1))).times(Big(7).times(Big(y1)).plus(Big(32).times(Big(y2))).plus(Big(12).times(Big(y3))).plus(Big(32).times(Big(y4))).plus(Big(7).times(Big(y5)))));
				if (ToNum(x5)>ToNum(upper)) { upper=x5; 	}	}	}
	}
	var baseunits={};
	for (var i in self[xid].Units_base_array) { baseunits[i]=self[xid].Units_base_array[i]+self[yid].Units_base_array[i]; }
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq=0"};
	var id=CreateEq(this.fileid, 0, eqobj);
	self[id].Page_position=DOM_Object[this.Format_id]['location'];
	self[id].Solution_real['0-0']=parseFloat(I);
	self[id].Solution_imag['0-0']=0;
	self[id].Format_showtype="builtin"; 
	var xunits=self[xid].Units_units;
	self[id].Format_showequation="\\int_{"+lower+" "+xunits+"}^{"+upper+" "+xunits+"}"+self[yid].Format_showequation+"\\hspace{1mm}\\mathrm{dx}";
	self[id].Units_base_array=baseunits;
	self[id].Recompose_Units(); 
	DOM_Object[id]['real']=self[id].Solution_real;
	DOM_Object[id]['size']=self[id]['Format_size'];
	DOM_Object[id]['imag']['0-0']=0;
	DOM_Object[id]['units']=self[id].Units_units;
	this.Solution_temps.push(self[id].Format_id);
	SetModels("NewtonCotes", id, xid, yid, lower, upper);
	self[pid].Solution_variable_array[pos]=id;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------------------------------------------//
//------------------------------------ MATH FUNCTION - Integrate x and y data with unequally spaced x data ------------------------------------//
//---------------------------------------------------------------------------------------------------------------------------------------------//
/*
This is the function to integrate functions using the Newton-Cotes methods. It takes in a string that is comma separated to give 5 inputs.
1 		- The x variable 
2	 	- The y variable

*/
Equation.prototype.Integrate = function(text, pid, pos, callback)
{
	var replacetext=text.replace(/^\s+|\s+$/g, '');
	replacetext=replacetext.replace(/^Integrate\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Integrate"); }
	if (inputarray.length<2) { Set_Error(this.Original_id, "Integrate1"); }
	if (inputarray.length>2) { Set_Error(this.Original_id, "Integrate2"); }
	var xvar=inputarray[0];	var yvar=inputarray[1]; 
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+xvar};
	var xid=CreateEq(this.fileid, 1, eqobj);
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+yvar};
	var yid=CreateEq(this.fileid, 1, eqobj);
	var sizes=self[xid].Format_size.split('x');	var size1=sizes[1];
	var xlow=self[xid].Solution_real['0-0'];
	if (self[xid].Format_size!=self[yid].Format_size) { Set_Error(this.Original_id, "Integrate3"); flag=1;  }
	if (parseInt(size1, 10)<5) { Set_Error(this.Original_id, "Integrate4"); flag=1;  }
	var xhigh=0;
	var Integral=Big(0);
	for (var index=0; index<sizes[1]-1; index++)
	{	var xdist=Big(self[xid].Solution_real['0-'+parseInt(index+1, 10)]).minus(Big(self[xid].Solution_real['0-'+index]));
		var ydiff=Big(self[yid].Solution_real['0-'+index]).plus(Big(self[yid].Solution_real['0-'+parseInt(index+1, 10)]));
		Integral=Integral.plus(Big(xdist).times(Big(ydiff)).times(Big(0.5)));
		if (ToNum(self[xid].Solution_real['0-'+parseInt(index+1, 10)])>xhigh){xhigh=ToNum(self[xid].Solution_real['0-'+parseInt(index+1, 10)]);}
	}
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq=0"};
	var id=CreateEq(this.fileid, 0, eqobj);
	var baseunits=new Array();
	for(var index in self[xid].Units_base_array) 
	{ 	self[id].Units_base_array[index]=parseInt(self[xid].Units_base_array[index], 10)+parseInt(self[yid].Units_base_array[index], 10); }
	self[id].Solution_real['0-0']=Integral;
	self[id].Solution_imag['0-0']=0;
	self[id].Recompose_Units(); 
	self[id].Format_name="\\int_{"+xlow+"}^{"+xhigh+"}"+yvar+"\\mathrm{d}"+xvar;
	self[id].Solution_toreplace="Integrate("+xvar+","+yvar+")";
	self[id].Format_showtype="builtin"; 
	self[id].Format_showequation="\\int_{"+xlow+"}^{"+xhigh+"}"+yvar+"\\mathrm{d}\\hspace{1mm}"+xvar;
	DOM_Object[id]['real']=self[id].Solution_real;
	DOM_Object[id]['size']=self[id]['Format_size'];
	DOM_Object[id]['imag']['0-0']=0;
	DOM_Object[id]['units']=self[id].Units_units;
	SetModels("Integrate", id, xid, yid, xlow, xhigh, xvar, yvar);
	this.Solution_temps.push(self[id].Format_id);
	self[pid].Solution_variable_array[pos]=id;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------- MATH FUNCTION - Differentiate data using the centered finite difference function ---------------------------------//
//---------------------------------------------------------------------------------------------------------------------------------------------------------//
/*
This function takes the derivative of a given function using the centered finite difference method. The user is allowed to select a number of settings.
0	the vector or variable name of the data
1	the space between each item - with units
2	the order of the derivative - 1, 2, 3, 4
3 	the accuracy level - 1 or 2
*/
Equation.prototype.Derivative = function(text, pid, pos, callback)	 
{	var index=0; 	var f_x={};	var Diff={};	var flag=0;
	var replacetext=text.replace(/^\s+|\s+$/g, '');
	replacetext=replacetext.replace(/^[Derivative(]+/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Derivative"); flag=1; }
	if (inputarray.length<4) { Set_Error(this.Original_id, "Derivative1");  flag=1; }
	if (inputarray.length>4) { Set_Error(this.Original_id, "Derivative2");  flag=1; }
	var ydata=inputarray[0];	var x_space=inputarray[1]; 	var order=inputarray[2];		var accuracy=inputarray[3];
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location'], 10), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+ydata};
	var yid=CreateEq(this.fileid, 1, eqobj);
	var f_x=self[yid].Solution_real;
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location'], 10), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+x_space};
	var x_space=CreateEq(this.fileid, 1, eqobj);
	var xspace=self[x_space].Solution_real['0-0'];
	if ((order!=1)&&(order!=2)&&(order!=3)&&(order!=4)) { Set_Error(this.Original_id, "Derivative3");  flag=1; }
	if ((accuracy!=1)&&(accuracy!=2)) { Set_Error(this.Original_id, "Derivative4"); flag=1;  }
	var sizes=self[yid].Format_size.split('x');	var size1=sizes[1];
	if (parseInt(size1, 10)<5) { Set_Error(this.Original_id, "Derivative5"); flag=1;  }
	if (flag===0)
	{	if (order=="1")
		{	if (accuracy=="1")
			{	for (var i=1; i<Object.keys(f_x).length-1; i++)
				{	if (i>0) {	var ind1='0-'+parseInt(parseInt(i, 10)+1, 10);	var ind2='0-'+parseInt(parseInt(i, 10)-1, 10);
								Diff[ind2]=ToNum((f_x[ind1]-f_x[ind2])/(2*xspace)); }	}
			}else if (accuracy=="2")
			{	for (var i=2; i<Object.keys(f_x).length-2; i++)
				{	if (i>1) {	var ind1='0-'+parseInt(parseInt(i, 10)+1, 10);	var ind2='0-'+parseInt(parseInt(i, 10)-1, 10);
								var ind3='0-'+parseInt(parseInt(i, 10)+2, 10);	var ind4='0-'+parseInt(parseInt(i, 10)-2, 10);
								Diff[ind4]=ToNum((-f_x[ind3]+8*f_x[ind1]-8*f_x[ind2]-f_x[ind4])/(12*xspace)); }
		}	}	}
		if (order=="2")
		{	if (accuracy=="1")
			{	for (var i=1; i<Object.keys(f_x).length-1; i++)
				{	if (i>0) {	var ind1='0-'+parseInt(parseInt(i, 10)+1, 10);	var ind2='0-'+parseInt(parseInt(i, 10)-1, 10);
								Diff[ind2]=ToNum((f_x[ind1]-2*f_x['0-'+i]+f_x[ind2])/(Math.pow(xspace,2))); }	}
			}else if (accuracy=="2")
			{	for (var i=2; i<Object.keys(f_x).length-2; i++)
				{	if (i>1) {	var ind1='0-'+parseInt(parseInt(i, 10)+1, 10);	var ind2='0-'+parseInt(parseInt(i, 10)-1, 10);
								var ind3='0-'+parseInt(parseInt(i, 10)+2, 10);	var ind4='0-'+parseInt(parseInt(i, 10)-2, 10);
								Diff[ind4]=ToNum((-f_x[ind3]+16*f_x[ind1]-30*f_x['0-'+i]+16*f_x[ind2]-f_x[ind4])/(12*Math.pow(xspace,2))); }
		}	}	}
		if (order=="3")
		{	if (accuracy=="1")
			{	for (var i=2; i<Object.keys(f_x).length-2; i++)
				{	if (i>1) {	var ind1='0-'+parseInt(parseInt(i, 10)+1, 10);	var ind2='0-'+parseInt(parseInt(i, 10)-1, 10);
								var ind3='0-'+parseInt(parseInt(i, 10)+2, 10);	var ind4='0-'+parseInt(parseInt(i, 10)-2, 10);
								Diff[ind2]=ToNum((f_x[ind3]-2*f_x[ind1]+2*f_x[ind2]-f_x[ind4])/(2*Math.pow(xspace,3))); }	}
			}else if (accuracy=="2")
			{	for (var i=3; i<Object.keys(f_x).length-3; i++)
				{	if (i>2) {	var ind1='0-'+parseInt(parseInt(i, 10)+1, 10);	var ind2='0-'+parseInt(parseInt(i, 10)-1, 10);
								var ind3='0-'+parseInt(parseInt(i, 10)+2, 10);	var ind4='0-'+parseInt(parseInt(i, 10)-2, 10);
								var ind5='0-'+parseInt(parseInt(i, 10)+3, 10);	var ind6='0-'+parseInt(parseInt(i, 10)-3, 10);
								Diff[ind4]=ToNum((-f_x[ind5]+8*f_x[ind3]-13*f_x[ind1]+13*f_x[ind2]-8*f_x[ind4]+f_x[ind6])/(8*Math.pow(xspace,3))); }
		}	}	}
		if (order=="4")
		{	if (accuracy=="1")
			{	for (var i=2; i<Object.keys(f_x).length-2; i++)
				{	if (i>1) {	var ind1='0-'+parseInt(parseInt(i, 10)+1, 10);	var ind2='0-'+parseInt(parseInt(i, 10)-1, 10);
								var ind3='0-'+parseInt(parseInt(i, 10)+2, 10);	var ind4='0-'+parseInt(parseInt(i, 10)-2, 10);
								Diff[ind2]=ToNum((f_x[ind3]-4*f_x[ind1]+6*f_x['0-'+i]-4*f_x[ind2]+f_x[ind4])/(xspace^4)); }	}
			}else if (accuracy=="2")
			{	for (var i=3; i<Object.keys(f_x).length-3; i++)
				{	if (i>2) {	var ind1='0-'+parseInt(parseInt(i, 10)+1, 10);	var ind2='0-'+parseInt(parseInt(i, 10)-1, 10);
								var ind3='0-'+parseInt(parseInt(i, 10)+2, 10);	var ind4='0-'+parseInt(parseInt(i, 10)-2, 10);
								var ind5='0-'+parseInt(parseInt(i, 10)+3, 10);	var ind6='0-'+parseInt(parseInt(i, 10)-3, 10);
								Diff[ind4]=ToNum((-f_x[ind5]+12*f_x[ind3]+39*f_x[ind1]+56*f_x['0-'+i]-39*f_x[ind2]+12*f_x[ind4]+f_x[ind6])/(6*Math.pow(xspace,4))); }
		}	}	}

		var baseunits={};
		for (var i in self[yid].Units_base_array) { baseunits[i]=self[yid].Units_base_array[i]-order*self[x_space].Units_base_array[i]; }
		var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
				Original_id:this.Original_id, equation:"TempEq=0"};
		var id=CreateEq(this.fileid, 0, eqobj);
		if (flag==1) { self[id].Solution_real['0-0']="Error";	}else { self[id].Solution_real=Diff; }
		self[id].Solution_imag['0-0']=0;
		self[id].Format_showequation="\\frac{d^"+order+"}{dx}"+self[yid].Format_showequation;
		self[id].Units_base_array=baseunits;
		self[id].Recompose_Units(); 
		DOM_Object[id]['real']=self[id].Solution_real;
		DOM_Object[id]['size']=self[id]['Format_size'];
		DOM_Object[id]['imag']['0-0']=0;
		DOM_Object[id]['units']=self[id].Units_units;
		this.Solution_temps.push(self[id].Format_id);
		SetModels("Derivative", id, yid, x_space);
		self[pid].Solution_variable_array[pos]=id;
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------- MATH FUNCTION - Differentiate data using the centered finite difference function ---------------------------------//
//---------------------------------------------------------------------------------------------------------------------------------------------------------//
/*
This function takes the derivative of a given data set where the x spacing was not done at even intervals. It uses the lagrange technique in Chapra 457
0	the vector or variable name of the data for x data as taken
1	the vector or variable name of the data for the y data
2	the vector or variable name of the data for x data derivative locations
*/
Equation.prototype.DerivativeUn = function(text, pid, pos, callback)	 
{	var index=0; 	var f_x={};	var Diff={};	var eflag=0;
	var replacetext=text.replace(/^\s+|\s+$/g, '');
	replacetext=replacetext.replace(/^[DerivativeUn(]+/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "DerivativeUn"); eflag=1; }
	if (inputarray.length<3) { Set_Error(this.Original_id, "DerivativeUn1");  eflag=1; }
	if (inputarray.length>3) { Set_Error(this.Original_id, "DerivativeUn2");  eflag=1; }
	var xdata=inputarray[0];	var ydata=inputarray[1]; 	var newxdata=inputarray[2];
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location'], 10), Format_showtype:"InnerFunction", Original_id:this.Original_id, equation:"TempEq="+xdata};
	var xid=CreateEq(this.fileid, 1, eqobj);
	var xlocs=self[xid].Solution_real;
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location'], 10), Format_showtype:"InnerFunction", Original_id:this.Original_id, equation:"TempEq="+ydata};
	var yid=CreateEq(this.fileid, 1, eqobj);
	var f_x=self[yid].Solution_real;
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location'], 10), Format_showtype:"InnerFunction", Original_id:this.Original_id, equation:"TempEq="+newxdata};
	var newxid=CreateEq(this.fileid, 1, eqobj);
	var newx=self[newxid].Solution_real;
	if (self[xid].Format_size!=self[yid].Format_size) { Set_Error(this.Original_id, "DerivativeUn4"); flag=1;  }
	var sizes=self[xid].Format_size.split('x');	var size1=sizes[1];
	if (parseInt(size1, 10)<5) { Set_Error(this.Original_id, "DerivativeUn5"); flag=1;  }

	if (eflag===0)
	{	i=1;	var flag=0;
		for (var newi=0; newi<Object.keys(newx).length; newi++)
		{	flag=0;
			while ((flag===0)&&(i<Object.keys(xlocs).length-1))
			{	var diff0=Math.abs(newx['0-'+newi]-xlocs['0-'+parseInt(i-1, 10)]);
				var diff1=Math.abs(newx['0-'+newi]-xlocs['0-'+parseInt(i, 10)]);
				var diff2=Math.abs(newx['0-'+newi]-xlocs['0-'+parseInt(parseInt(i, 10)+1, 10)]);
				if (((diff1<diff0)&&(diff1<diff2))||((diff1<diff0)&&(diff1==diff2))||((diff1==diff0)&&(diff1<diff2))||((diff1<diff2)&&(i==1))||((diff1<diff0)&&(i==Object.keys(xlocs).length-2))) {	flag=1;
				}else { i=parseInt(i, 10)+1; }
				if (flag==1)
				{	var f0=f_x['0-'+parseInt(i-1, 10)];	var f1=f_x['0-'+i];		var f2=f_x['0-'+parseInt(parseInt(i, 10)+1, 10)];
					var x0=xlocs['0-'+parseInt(i-1, 10)];	var x1=xlocs['0-'+parseInt(i, 10)];		var x2=xlocs['0-'+parseInt(parseInt(i, 10)+1, 10)];
					var x=newx['0-'+newi];
					Diff['0-'+newi]=ToNum(ToNum(f0*((2*x-x1-x2)/((x0-x1)*(x0-x2))))+ToNum(f1*((2*x-x0-x2)/((x1-x0)*(x1-x2))))+ToNum(f2*((2*x-x0-x1)/((x2-x0)*(x2-x1)))));
				}
			}
			if (flag===0) { Set_Error(this.Original_id, "DerivativeUn3", newx['0-'+newi]); eflag=1; }
		}
		var baseunits={};
		for (var i in self[yid].Units_base_array) { baseunits[i]=self[yid].Units_base_array[i]-self[xid].Units_base_array[i]; }
		var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
				Original_id:this.Original_id, equation:"TempEq=0"};
		var id=CreateEq(this.fileid, 0, eqobj);
		if (eflag===0) { self[id].Solution_real=Diff;	}else { self[id].Solution_real['0-0']="Error"; }
		self[id].Solution_imag=0;
		if (eflag===0) { self[id].Format_showequation="\\frac{d}{dx}"+self[yid].Format_showequation;	}else { self[id].Format_showequation="Error"; }
		self[id].Units_base_array=baseunits;
		self[id].Recompose_Units(); 
		this.Solution_temps.push(self[id].Format_id);
		DOM_Object[id]['real']=self[id].Solution_real;
		DOM_Object[id]['size']=self[id]['Format_size'];
		DOM_Object[id]['imag']['0-0']=0;
		DOM_Object[id]['units']=self[id].Units_units;
		SetModels("DerivativeUn", id, xid, yid, newxid);
		self[pid].Solution_variable_array[pos]=id;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//------------------------------- GET THE REAL PORTION OF THE MATRIX --------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.Real = function(replacetext, pid, pos, callback)
{	var flag=1;
	replacetext=replacetext.replace(/^Real\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Real"); flag=0;}
	if (inputarray.length>1) { Set_Error(this.Original_id, "Real1"); flag=0; }
	if (flag==1)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
		Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var id=CreateEq(this.fileid, 1, eqobj);
		console.log(self[id]);
		self[id].Format_showequation="Real\\left("+replacetext+"\\right)";
		self[id].Solution_imag={};
		self[id].Solution_imagdefault=0;
		this.Solution_temps.push(self[id].Format_id);
		SetModels("Real", id, id);
		DOM_Object[id]['real']=self[id].Solution_real;
		DOM_Object[id]['size']=self[id]['Format_size'];
		DOM_Object[id]['imag']['0-0']=0;
		DOM_Object[id]['units']=self[id].Units_units;
		self[pid].Solution_variable_array[pos]=id;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}	 
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//----------------------------- GET THE IMAGINARY PORTION OF THE MATRIX -----------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.Imag = function(replacetext, pid, pos, callback)
{	var flag=1;
	replacetext=replacetext.replace(/^Imag\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Imag"); flag=0; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "Imag1"); flag=0; }
	if (flag==1)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
		Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var id=CreateEq(this.fileid, 1, eqobj);
		self[id].Format_showequation="Imag\\left("+replacetext+"\\right)";
		self[id].Solution_realdefault=self[id].Solution_imagdefault;
		self[id].Solution_imagdefault=0;
		this.Solution_temps.push(self[id].Format_id);
		self[id].Solution_real=JSON.parse(JSON.stringify(self[id].Solution_imag));
		self[id].Solution_imag={};
		SetModels("Imag", id, id);
		self[pid].Solution_variable_array[pos]=id;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	}
	DOM_Object[id]['real']=self[id].Solution_real;
	DOM_Object[id]['size']=self[id]['Format_size'];
	DOM_Object[id]['imag']['0-0']=0;
	DOM_Object[id]['units']=self[id].Units_units;
	self[pid].Solution_variable_array[pos]=id;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//


//---------------------------------------------------------------------------------------------------------//
//----------------------------------- APPEND ONE MATRIX TO ANOTHER ----------------------------------------//
//---------------------------------------------------------------------------------------------------------//
/*
	This function takes in two matrixes and a number. The code then appends the  second matrix to the first along the index specified.
*/
Equation.prototype.Append = function(replacetext, pid, pos, callback)
{	var splitkey='', key='', num='', flag=0, testflag=0;; 
	replacetext=replacetext.replace(/^Append\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Append"); testflag=1; }
	if (inputarray.length>3) { Set_Error(this.Original_id, "Append1"); testflag=1; }
	if (inputarray.length<3) { Set_Error(this.Original_id, "Append2"); testflag=1; }
	if (testflag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'],Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var eqid1=CreateEq(this.fileid, 1, eqobj);
		var eqobj={Page_position:DOM_Object[this.Format_id]['location'],Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
		var eqid2=CreateEq(this.fileid, 1, eqobj);
		var eqobj={Page_position:DOM_Object[this.Format_id]['location'],Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[2]};
		var indid=CreateEq(this.fileid, 1, eqobj);
		var index=self[indid].Solution_real['0-0'];
		var ind1=self[eqid1].Format_size.split('x');
		var ind2=self[eqid2].Format_size.split('x');
		var maxindex=Math.max(parseInt(index, 10)+1, ind1.length, ind2.length);
		var eqobj={Page_position:DOM_Object[this.Format_id]['location'],Format_showtype:"builtin", 
			Original_id:this.Original_id, equation:"TempEq=0"};
		var id=CreateEq(this.fileid, 0, eqobj);
		if (index>ind1.length-1) 
		{	flag=1;
			for (var a in self[eqid1].Solution_real)
			{	key='';	splitkey=a.split('-');
				for (var b=0; b<maxindex; b++) {  if (splitkey[b]===undefined) { splitkey[b]=0; } }
				for (var b=0; b<splitkey.length; b++) { key=key+'-'+splitkey[b]; }
				key=key.replace(/^\-/,'');
				self[id].Solution_real[key]=self[eqid1].Solution_real[a];
				self[id].Solution_imag[key]=self[eqid1].Solution_imag[a];
				delete self[id].Solution_imag[key];
			}
		}else
		{	self[id].Solution_real=self[eqid1].Solution_real;
			self[id].Solution_imag=self[eqid1].Solution_imag; 		}
		for (var a in self[eqid2].Solution_real)
		{	key='';
			splitkey=a.split('-');
			for (var b=0; b<maxindex; b++) { if (splitkey[b]===undefined) {	splitkey[b]=0;	}	}
			if (flag==1) { 	splitkey[index]=parseInt(splitkey[index], 10)+parseInt(ind1[index], 10)+parseInt(1, 10);
			}else { 		splitkey[index]=parseInt(splitkey[index], 10)+parseInt(ind1[index], 10); }
			for (var b=0; b<splitkey.length; b++) { key=key+'-'+splitkey[b]; }
			key=key.replace(/^\-/,'');
			self[id].Solution_real[key]=self[eqid2].Solution_real[a];
			self[id].Solution_imag[key]=self[eqid2].Solution_imag[a];
		}
		self[id].Format_showequation="Append\\left("+replacetext+"\\right)";
		self[id].Units_units = self[eqid1].Units_units;
		this.Solution_temps.push(self[eqid1].Format_id);
		this.Solution_temps.push(self[eqid2].Format_id);
		this.Solution_temps.push(self[indid].Format_id);
		this.Solution_temps.push(self[id].Format_id);
		DOM_Object[id]['real']=self[id].Solution_real;
		DOM_Object[id]['size']=self[id]['Format_size'];
		DOM_Object[id]['imag']['0-0']=0;
		DOM_Object[id]['units']=self[id].Units_units;
		SetModels("Append", id, eqid1, eqid2, indid);
		self[pid].Solution_variable_array[pos]=id;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//---------------------------------------------- GENERATE A RANDOM NUMBER -------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.rand = function(replacetext, pid, pos, callback)
{	var flag=0;		var result=0;
	replacetext=replacetext.replace(/^rand\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "rand"); flag=1; }
	if (inputarray.length<2) { Set_Error(this.Original_id, "rand1"); flag=1; }
	if (inputarray.length>3) { Set_Error(this.Original_id, "rand1"); flag=1; }
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var id1=CreateEq(this.fileid, 1, eqobj);
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
		var id2=CreateEq(this.fileid, 1, eqobj);
		var lower=self[id1].Solution_real['0-0'];
		var upper=self[id2].Solution_real['0-0'];
		var multiplier=1;
		if (lower>upper) { Set_Error(this.Original_id, "rand2");  }
		if (inputarray.length>2) { 
			var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+inputarray[2]};
			var preid=CreateEq(this.fileid, 1, eqobj);
			var precision=parseInt(self[preid].Solution_real['0-0']);
			var mult=Math.pow(10, precision);
			if (precision<0) { Set_Error(this.Original_id, "rand3");  }
		 }
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq=0"};
		var newid=CreateEq(this.fileid, 0, eqobj);
		var ran=Math.random();
		if (lower>=0){	result=lower+(Math.floor(Math.random()*(upper*mult-lower*mult)))/mult;
		}else if ((lower<0)&&(upper>0)) {result=(Math.floor(ran*(upper*mult-lower*mult+1))+lower*mult)/mult;
		}else if ((lower<0)&&(upper<0)) {result=(Math.floor(ran*(upper*mult-lower*mult+1))+lower*mult)/mult; }
		self[newid].Solution_real['0-0']=result;
		self[newid].Format_showequation="rand \\left("+self[id1].Format_showequation+", "+self[id2].Format_showequation+", "+self[preid].Format_showequation+"\\right)";	
	}else { var newid='';}
	DOM_Object[newid]['real']=self[newid].Solution_real;
	DOM_Object[newid]['size']=self[newid]['Format_size'];
	DOM_Object[newid]['imag']['0-0']=0;
	DOM_Object[newid]['units']=self[newid].Units_units;
	this.Solution_temps.push(newid, id1, id2, preid);
	SetModels("rand", newid, id1, id2, preid);
	self[pid].Solution_variable_array[pos]=newid;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//---------------------------------------- GENERATE A MATRIX OF RANDOM NUMBERS --------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.randMat = function(replacetext, pid, pos, callback)
{	var flag=0;		var result={};		var key='';
	replacetext=replacetext.replace(/^randMat\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "randMat"); flag=1; }
	if (inputarray.length<5) { Set_Error(this.Original_id, "randMat1"); flag=1; }
	if (inputarray.length>5) { Set_Error(this.Original_id, "randMat1"); flag=1; }
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var id1=CreateEq(this.fileid, 1, eqobj);
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
		var id2=CreateEq(this.fileid, 1, eqobj);
		var lower=self[id1].Solution_real['0-0'];
		var upper=self[id2].Solution_real['0-0'];
		var multiplier=1;
		if (lower>upper) { Set_Error(this.Original_id, "randMat2");  }
		if (inputarray.length>2) { 
			var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+inputarray[2]};
			var preid=CreateEq(this.fileid, 1, eqobj);
			var precision=self[preid].Solution_real['0-0'];
			mult=Math.pow(10, precision);
			if (precision<0) { Set_Error(this.Original_id, "randMat3");  }
		 }
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[3]};
		var d1id=CreateEq(this.fileid, 1, eqobj);
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[4]};
		var d2id=CreateEq(this.fileid, 1, eqobj);
		for (var a=0; a<self[d1id].Solution_real['0-0']; a++)
		{	for (var b=0; b<self[d2id].Solution_real['0-0']; b++)
			{	var ran=Math.random();		key=a+'-'+b;
				if (lower>=0){	result[key]=lower+(Math.floor(Math.random()*(upper*mult-lower*mult)))/mult;
				}else if ((lower<0)&&(upper>0)) {result[key]=(Math.floor(ran*(upper*mult-lower*mult+1))+lower*mult)/mult;
				}else if ((lower<0)&&(upper<0)) {result[key]=(Math.floor(ran*(upper*mult-lower*mult+1))+lower*mult)/mult;}//\
			}
		}
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq=0"};
		var newid=CreateEq(this.fileid, 0, eqobj);
		self[newid].Solution_real=result;
		self[newid].Format_size=self[d1id].Solution_real['0-0']+'x'+self[d2id].Solution_real['0-0'];
		self[newid].Format_showequation="randMat \\left("+self[id1].Format_showequation+", "+self[id2].Format_showequation+", "+self[preid].Format_showequation+", "+self[d1id].Format_showequation+", "+self[d2id].Format_showequation+"\\right)";	
	}else { var newid='';}
	this.Solution_temps.push(newid, id1, id2, preid);
	DOM_Object[newid]['real']=self[newid].Solution_real;
	DOM_Object[newid]['size']=self[newid]['Format_size'];
	DOM_Object[newid]['imag']['0-0']=0;
	DOM_Object[newid]['units']=self[newid].Units_units;
	SetModels("randMat", newid, id1, id2, preid);
	self[pid].Solution_variable_array[pos]=newid;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}

//-------------------------------------------------------------------------------------------------------------------------//
//---------------------------------------------------- SQUASH A MATRIX ----------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.Squash = function(replacetext, pid, pos, callback)
{	var flag=0;
	replacetext=replacetext.replace(/^Squash\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Squash"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "Squash"); flag=1; }
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location'], 10), Format_showtype:"InnerFunction",
		Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var id1=CreateEq(this.fileid, 1, eqobj);
		var newid=SquashMatrix(id1);
		self[newid].Format_showequation="Squash("+self[id1].Format_showequation+")";
	}else { var newid='';}
	this.Solution_temps.push(newid);
	SetModels("Squash", newid, id1);
	self[pid].Solution_variable_array[pos]=newid;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	DOM_Object[newid]['real']=self[newid].Solution_real;
	DOM_Object[newid]['size']=self[newid]['Format_size'];
	DOM_Object[newid]['imag']['0-0']=0;
	DOM_Object[newid]['units']=self[newid].Units_units;
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//---------------------------------------------- Gauss Elimination Routine ------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
/*
This is a gauss elimination routine with partial pivoting. First, checks are done to ensure that this is a matrix and that 
it is square. Second, if the equation being solved is Ax=b where A is the coefficient matrix, x is the displacement, and 
b is the solution, then b is augmented onto the end of the A matrix to make the forward elimination easier. Third, a simple 
row pivoting algorithm is implemented to ensure that the largest number for that column is used. Fourth, the forward 
substitution is carried out. Once complete, the back substitution algorithm is performed.
*/

Equation.prototype.GaussE = function(replacetext, pid, pos, callback)
{	var flag=0;	var newmat={};	var newsize=0;	var size=0; var key='';	var factor=0;
	replacetext=replacetext.replace(/^GaussE\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "GaussE"); flag=1; }
	if (inputarray.length>2) { Set_Error(this.Original_id, "GaussE1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
	var id2=CreateEq(this.fileid, 1, eqobj);
	var sizes1=self[id1].Format_size.split('x');
	var sizes2=self[id2].Format_size.split('x');
	if (sizes1[0]!=sizes1[1]) 	{ Set_Error(this.Original_id, "GaussE2"); flag=1; }
	if (sizes1[0]!=sizes2[0]) 	{ Set_Error(this.Original_id, "GaussE3"); flag=1; }
	if (sizes2[1]!="1") 		{ Set_Error(this.Original_id, "GaussE4"); flag=1; }
	if (flag===0)
	{	var finalid=Gauss_Elimination(id1, id2, this.Original_id); 
		this.Solution_temps.push(finalid);
		SetModels("GaussE", finalid, id1, id2);
		DOM_Object[finalid]['real']=self[finalid].Solution_real;
		DOM_Object[finalid]['size']=self[finalid]['Format_size'];
		DOM_Object[finalid]['imag']['0-0']=0;
		DOM_Object[finalid]['units']=self[finalid].Units_units;
		self[pid].Solution_variable_array[pos]=finalid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}else { var finalid='';}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function Gauss_Elimination(id1, id2, Original_id)
{	var x={};	var index=0;
	if (self[id1].Format_size=="1x1") { Set_Error(Original_id, "Gauss2", id1);  }
	var sizes=self[id1].Format_size.split('x');
	if (sizes[0]!==sizes[1]) { Set_Error(Original_id, "Gauss2", id1); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[Original_id]['location']), Format_showtype:"InnerFunction",	 
	Original_id:this.Original_id, equation:"TempEq=0"};
	var newid=CreateEq(this.fileid, 0, eqobj);
	newmat=self[id1].Solution_real;
	// Append the b matrix onto the coefficient matrix
	for (var a=0; a<sizes[0]; a++) { key=a+'-'+sizes[0];	newmat[key]=self[id2].Solution_real[a+'-0']; }
	self[newid].Solution_real=newmat;
	newsize=parseInt(sizes[0])+1;
	size=parseInt(sizes[0]);
	index=0; 
	for (var a=0; a<size-1; a++)
	{	var max=0;	var tempobj={};
		for (var b=a; b<size; b++){ if(Math.abs(newmat[b+'-'+a])>max) { max=Math.abs(newmat[b+'-'+a]); index=b; } }
		// This is the row pivoting.
		if (index!==a)
			{ 	for (var b=0; b<newsize; b++){tempobj[b]=newmat[a+'-'+b]; 
				newmat[a+'-'+b]=newmat[index+'-'+b];	newmat[index+'-'+b]=tempobj[b];	}	}
		// This is the forward elimination
		for (var b=a+1; b<size; b++)
		{	factor=parseFloat(Big(newmat[b+'-'+a]).div(Big(newmat[a+'-'+a])));
			for (var c=a; c<newsize; c++) { newmat[b+'-'+c]=parseFloat(Big(newmat[b+'-'+c]).minus(Big(factor).times(Big(newmat[a+'-'+c])))); }
		}
	}
	for (var a=0; a<size; a++) { x[a+'-0']=0; }
	x[size-1+'-0']=ToNum(newmat[parseInt(size-1)+'-'+size]/newmat[parseInt(size-1)+'-'+parseInt(size-1)]);
	// The is the back substitution
	for (var a=size-2; a>=0; a--)
	{	var temp=0;
		for (var b=a+1; b<size; b++)
		{	temp=parseFloat(Big(temp).plus(Big(newmat[a+'-'+b]).times(Big(x[parseInt(b)+'-0'])))); }
		x[a+'-0']=parseFloat(Big(newmat[a+'-'+size]).minus(Big(temp)).div(Big(newmat[a+'-'+a])));
//		x[a+'-0']=ToNum(ToNum((newmat[a+'-'+size]-ToNum(temp)))/ToNum(newmat[a+'-'+a]));
	}
	self[newid].Solution_real=x;
	self[newid].Format_showequation="GaussE \\left("+self[id1].Format_showequation+", "+self[id2].Format_showequation+"\\right)";	
	for (var i in self[newid].Units_base_array)
	{	self[newid].Units_base_array[i]=self[id2].Units_base_array[i]-self[id1].Units_base_array[i];	}
	self[newid].Recompose_Units(); 
	self[newid].Get_BaseString();
	return newid;
}
//-------------------------------------------------------------------------------------------------------------------------//

/*-------------------------------------------------------------------------------------------------------------------------*/
/*--------------------------------------------- LU DECOMPOSITION ALGORITHM ------------------------------------------------*/
/*-------------------------------------------------------------------------------------------------------------------------*\
	This algorithm decomposes a matrix into upper and lower matrices through LU decomposition. It returns two 				\
	two-dimensional matrices. It expects that the user called the function using [a, b]=LUDecomp(Matrix) and the code 		\
	prevents the use of the function inline with other items as you cannot determine which returned value will be used.		\
/*-------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.LUDecomp = function(replacetext, pid, pos, callback)
{	this.inline=0; var flag=0;	var newmat={};	var newsize=0;	var size=0; var key='';	var factor=0;	var lower={};
	replacetext=replacetext.replace(/^LUDecomp\(/,""); 
	replacetext=replacetext.replace(/\)$/,"");
	var left=this.Format_left.replace(/^\s+|\s+$|^\[|\]$/g, ''); 
	var outputarray=InputArray(left);
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "LUDecomp"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "LUDecomp1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	if (self[id1].Format_size=="1x1") { Set_Error(this.Original_id, "LUDecomp3", id1); flag=1; }
	var sizes=self[id1].Format_size.split('x');
	if (sizes[0]!==sizes[1]) { Set_Error(this.Original_id, "LUDecomp4", id1); flag=1; }
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq=0"};
		var newid=CreateEq(this.fileid, 0, eqobj);
		newmat=self[id1].Solution_real;
		size=parseInt(sizes[0]);
		index=0; 
		for (var a=0; a<size-1; a++)
		{	for (var b=a+1; b<size; b++)
			{	factor=parseFloat(Big(newmat[b+'-'+a]).div(Big(newmat[a+'-'+a])));
				for (var c=a; c<size; c++) { newmat[b+'-'+c]=parseFloat(Big(newmat[b+'-'+c]).minus(Big(factor).times(Big(newmat[a+'-'+c])))); }
				lower[b+'-'+a]=factor;
			}
		}
		for (var a=0; a<size; a++){	 for (var b=0; b<size; b++){ if (a<b) { newmat[b+'-'+a]=0; } } }
		for (var a=0; a<size; a++){	 
		for (var b=0; b<size; b++){ if (a<b) { lower[a+'-'+b]=0; }else if (a==b){ lower[a+'-'+b]=1; } } }
		self[newid].Solution_real=newmat;
		self[newid].Format_showequation="LUDecomp \\left("+self[id1].Format_showequation+"\\right)";
		SetModels("LUDecomp", newid, id1);
		this.Format_type=6;
		this.Solution_temps.push(newid);
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_name:outputarray[0],	 
		equation:outputarray[0]+"="+this.Format_right};
		var upid=CreateEq(this.fileid, 0, eqobj);
		self[upid].Solution_real=newmat;
		self[upid].Format_showequation="LUDecomp \\left("+self[id1].Format_showequation+"\\right)";
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_name:outputarray[1],	 
		equation:outputarray[1]+"="+this.Format_right};
		var downid=CreateEq(this.fileid, 0, eqobj);
		self[downid].Solution_real=lower;
		self[downid].Format_showequation="LUDecomp \\left("+self[id1].Format_showequation+"\\right)";
		this.connected_ids={};	this.connected_ids[upid]=1;	this.connected_ids[downid]=1;
		DOM_Object[upid]['real']=self[upid].Solution_real;
		DOM_Object[upid]['size']=self[upid]['Format_size'];
		DOM_Object[upid]['imag']['0-0']=0;
		DOM_Object[upid]['units']=self[upid].Units_units;
		DOM_Object[downid]['real']=self[downid].Solution_real;
		DOM_Object[downid]['size']=self[downid]['Format_size'];
		DOM_Object[downid]['imag']['0-0']=0;
		DOM_Object[downid]['units']=self[downid].Units_units;
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		self[pid].Solution_variable_array[pos]=newid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}else { var newid='';}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//---------------------------------------------- LU MATRIX INVERSE Routine ------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
/*
This is the algorithm to compute the inverse of a matrix using the LU decomposition scheme.
*/
Equation.prototype.InverseLU = function(replacetext, pid, pos, callback)
{	var flag=0;	var upper={};	var newsize=0;	var size=0; var key='';	var factor=0;	var lower={};	var index=0;
	replacetext=replacetext.replace(/^InverseLU\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "InverseLU"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "InverseLU"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	if (self[id1].Format_size=="1x1") { Set_Error(this.Original_id, "InverseLU2", id1); flag=1; }
	var sizes=self[id1].Format_size.split('x');
	if (sizes[0]!==sizes[1]) { Set_Error(this.Original_id, "InverseLU2", id1); flag=1; }
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq=0"};
		var newid=CreateEq(this.fileid, 0, eqobj);
		upper=self[id1].Solution_real;
		size=parseInt(sizes[0]);
		for (var a=0; a<size-1; a++)
		{	for (var b=a+1; b<size; b++)
			{	factor=parseFloat(Big(upper[b+'-'+a]).div(Big(upper[a+'-'+a])));
				for (var c=a; c<size; c++) 
				{	upper[b+'-'+c]=parseFloat(Big(upper[b+'-'+c]).minus(Big(factor).times(upper[a+'-'+c]))); }
				lower[b+'-'+a]=factor;
			}
		}
		var Matrix={};
		for (var a=0; a<size; a++){	 for (var b=0; b<size; b++){ if (a<b) { upper[b+'-'+a]=0; } } }
		for (var a=0; a<size; a++){	 for (var b=0; b<size; b++){ if (a<b) { lower[a+'-'+b]=0; }else if (a==b){ lower[a+'-'+b]=1; } } }	


		for (var row=0; row<size; row++)
		{	var D={};	var B={};
			for (var c=0; c<size; c++) { if (c==row) { B[c]=1; }else { B[c]=0; } }
			for (var a=0; a<size; a++)
			{	var temp=B[a];
				// The is the forward substitution on the lower
				for (var b=0; b<a; b++)
				{	temp=parseFloat(Big(temp).minus(Big(Big(lower[a+'-'+b]).times(Big(D[b]))))); }
				D[a]=parseFloat(Big(temp).div(Big(lower[a+'-'+a])));
			}
			vect={};
			for (var a=0; a<size; a++) { vect[a]=0; }
			for (var a=size-1; a>=0; a--)
			{	var temp=D[a];
				// The is the back substitution
				for (var b=a+1; b<size; b++)
				{	temp=parseFloat(Big(temp).minus(Big(upper[a+'-'+b]).times(Big(vect[b])))); }
				vect[a]=parseFloat(Big(temp).div(Big(upper[a+'-'+a])));
			}			
			for (var a=0; a<size; a++)	{ Matrix[a+'-'+row]=vect[a]; }
		}
		self[newid].Solution_real=Matrix;
		self[newid].Format_showequation=self[id1].Format_showequation+"^{-1}";
		this.Solution_temps.push(newid);
		SetModels("InverseLU", newid, id1);
		self[newid].Units_base_array=self[id1].Units_base_array;
		self[newid].Units_base_string=self[id1].Units_base_string;
		self[newid].Units_units=self[id1].Units_units;
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		self[pid].Solution_variable_array[pos]=newid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}else { var newid='';}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//-------------------------------- MATH FUNCTION MEAN (Average) -------------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.mean = function(replacetext, pid, pos, callback)
{	var basestring=''; var tempbasestring='';
	var average=0;  var avgImag=0; var count=0;		var temp=''; 	var matsize=0;		var matcount=0;  
	replacetext=replacetext.replace(/^mean\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var showeq='';	var num=''; var dim=''; var units=''; var quan='';
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "Mean1"); }
	var nums=new Array(); var thistext=''; 
	for (var a=0; a<inputarray.length; a=a+1)
	{	inputarray[a]=inputarray[a].replace(/^\s+|\s+$/g, '');
		if (isNumber(inputarray[a])) 
		{	average=parseFloat(average)+parseFloat(inputarray[a]); 
			count=parseInt(count, 10)+1;
			num=num+", "+inputarray[a];		dim=dim+", 1x1";
			units=units+", NA";				quan=quan+", NA";
			showeq=showeq+", "+inputarray[a];
			var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
							Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 0, eqobj);
		}else if (inputarray[a].match('#Table')) 
		{	var numberarray = Get_Table_Elements (inputarray[a], 1);
			for (var b=0; b<numberarray.length; b=b+1)
			{	average=parseFloat(average)+parseFloat(numberarray[b]); count=parseInt(count, 10)+1; 
				num=num+", "+numberarray[b];		dim=dim+", 1x1";
				units=units+", NA";				quan=quan+", NA";	}
				showeq=showeq+", "+inputarray[a];
			var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
							Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 0, eqobj);
		}else 
		{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
							Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 1, eqobj);
			if (a===0) { basestring=self[tempid].Units_base_string; 
			}else 
			{ if (basestring!=self[tempid].Units_base_string){Set_Error(this.Original_id,"Mean2");} }
			if (self[tempid].Format_size=="1x1") 
			{ 	average=parseFloat(average)+ToNum(self[tempid].Solution_real['0-0']); 
				avgImag=parseFloat(avgImag)+ToNum(self[tempid].Solution_imag['0-0']); 
				count=parseInt(count, 10)+1; 
			}else 
			{ 	temp=self[tempid].Format_size.split('x');	matsize=temp[0];	matcount=0;
				for (var mat=1; mat<temp.length; mat++) { matsize=matsize*temp[mat]; }
				for (var i in self[tempid].Solution_real) 
				{ 	average=ToNum(average)+ToNum(self[tempid].Solution_real[i]);
					if (self[tempid].Solution_imag[i]!==undefined)
					{	avgImag=parseFloat(avgImag)+ToNum(self[tempid].Solution_imag[i]); 
					}else{ avgImag=parseFloat(avgImag)+ToNum(self[tempid].Solution_imagdefault); }
					count=parseInt(count, 10)+1; 	matcount=parseInt(matcount, 10)+1;	} 
				for (var mat=matcount; mat<matsize; mat++) 
				{	average=ToNum(average)+ToNum(self[tempid].Solution_realdefault); 
					avgImag=parseFloat(avgImag)+ToNum(self[tempid].Solution_imagdefault); 
					count=parseInt(count, 10)+1;
				}
			}
				num=num+", "+self[tempid].Format_showequation;
				dim=dim+", "+self[tempid].Format_size;
				if (self[tempid].Units_units==='') { units=units+", NA" 
				}else { units=units+", "+self[tempid].Units_units;	}
				if (self[tempid].Units_quantity==='') { quan=quan+", NA" 
				}else { quan=quan+", "+self[tempid].Units_quantity;	}
				showeq=showeq+", "+self[tempid].Format_showequation;	
		}
	}	
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
					Original_id:this.Original_id, equation:"TempEq=0"};
	var eqid=CreateEq(this.fileid, 0, eqobj);
	self[eqid].Solution_real['0-0']=ToNum(average/count); 
	self[eqid].Solution_imag['0-0']=ToNum(avgImag/count); 
	showeq=showeq.replace(/^,/,'');		num=num.replace(/^,/,'');	dim=dim.replace(/^,/,'');
	quan=quan.replace(/^,/,'');			units=units.replace(/^,/,'');
	self[eqid].Format_showequation="mean\\left("+showeq+"\\right)";
	this.Solution_temps.push(eqid);
	DOM_Object[eqid]['real']=self[eqid].Solution_real;
	DOM_Object[eqid]['size']=self[eqid]['Format_size'];
	DOM_Object[eqid]['imag']=self[eqid].Solution_imag;
	DOM_Object[eqid]['units']=self[eqid].Units_units;
	self[eqid].Units_base_array=self[tempid].Units_base_array;
	self[eqid].Units_base_string=self[tempid].Units_base_string;
	self[eqid].Units_units=self[tempid].Units_units;
	self[eqid].Models_numerical="mean\\left("+num+"\\right)";
	self[eqid].Models_dimensions="mean\\left("+dim+"\\right)";
	self[eqid].Models_quantities="mean\\left("+quan+"\\right)";
	self[eqid].Models_units="mean\\left("+units+"\\right)";
	self[pid].Solution_variable_array[pos]=eqid;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//-------------------------------- MATH FUNCTION SUM -------------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.sum = function(replacetext, pid, pos, callback)
{	var basestring='', tempbasestring='', sum=0, temp='', matsize=0, matcount=0, showeq='', num='', imagSum=0;
	var dim='', units='', quan='', nums=new Array(), thistext='';
	replacetext=replacetext.replace(/^sum\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "Sum1"); }

	// Loop through the inputs and add them together
	for (var a=0; a<inputarray.length; a=a+1)
	{	
		inputarray[a]=inputarray[a].replace(/^\s+|\s+$/g, '');
		
		// If its a number, add it to the sum
		if (isNumber(inputarray[a])) 
		{	
			sum=parseFloat(sum)+parseFloat(inputarray[a]);
			num=num+", "+inputarray[a];
			dim=dim+", 1x1";
			units=units+", NA";	
			quan=quan+", NA";
			showeq=showeq+", "+inputarray[a];

			var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
							Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 0, eqobj);

		// If it's a table, add the cells
		}else if (inputarray[a].match('#Table')) 
		{	
			var numberarray = Get_Table_Elements(inputarray[a], 1);
			for (var b=0; b<numberarray.length; b=b+1)
			{	
				sum=parseFloat(sum)+parseFloat(numberarray[b]); 
				num=num+", "+numberarray[b];
				dim=dim+", 1x1";
				units=units+", NA";
				quan=quan+", NA";	
			}
			showeq=showeq+", "+inputarray[a];
			
			var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
							Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 0, eqobj);

		// If it needs to be solved, do that
		}else
		{	
			var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
							Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 1, eqobj);
			if (a===0) 
			{ 
				basestring=self[tempid].Units_base_string; 
			}else 
			{ 
				if (basestring!=self[tempid].Units_base_string){Set_Error(this.Original_id,"Sum2");} 
			}
			if (self[tempid].Format_size=="1x1") 
			{ 	
				sum=parseFloat(sum)+ToNum(self[tempid].Solution_real['0-0']); 
				imagSum=parseFloat(imagSum)+ToNum(self[tempid].Solution_imag['0-0']); 

			}else 
			{ 	
				temp=self[tempid].Format_size.split('x');	
				matsize=temp[0];	
				matcount=0;
				for (var mat=1; mat<temp.length; mat++) { matsize=matsize*temp[mat]; }
				for (var i in self[tempid].Solution_real) 
				{ 	
					sum=ToNum(sum)+ToNum(self[tempid].Solution_real[i]);
					if (self[tempid].Solution_imag[i]!==undefined)
					{	imagSum=ToNum(imagSum)+ToNum(self[tempid].Solution_imag[i]); }
					matcount=parseInt(matcount, 10)+1;	
				} 
				for (var mat=matcount; mat<matsize; mat++) 
				{	
					sum=ToNum(sum)+ToNum(self[tempid].Solution_realdefault); 
					imagSum=ToNum(imagSum)+ToNum(self[tempid].Solution_imagdefault); 
				}
			}
			
			// Create the display items
			num=num+", "+self[tempid].Format_showequation;
			dim=dim+", "+self[tempid].Format_size;
			if (self[tempid].Units_units==='') 
			{ 
				units=units+", NA" 
			}else 
			{
				units=units+", "+self[tempid].Units_units;	
			}
			if (self[tempid].Units_quantity==='') 
			{ 
				quan=quan+", NA" 
			}else 
			{
				quan=quan+", "+self[tempid].Units_quantity;	
			}
			showeq=showeq+", "+self[tempid].Format_showequation;	
		}
	}	

	// Place the results variable object into the variable in place of the text
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
					Original_id:this.Original_id, equation:"TempEq=0"};
	var eqid=CreateEq(this.fileid, 0, eqobj);
	self[eqid].Solution_real['0-0']=sum; 
	self[eqid].Solution_imag['0-0']=imagSum; 
	self[eqid].Format_showtype="builtin"; 

	showeq=showeq.replace(/^,/,'');		
	num=num.replace(/^,/,'');	
	dim=dim.replace(/^,/,'');
	quan=quan.replace(/^,/,'');			
	units=units.replace(/^,/,'');
	
	self[eqid].Format_showequation="sum\\left("+showeq+"\\right)";
	this.Solution_temps.push(eqid);
	DOM_Object[eqid]['real']=self[eqid].Solution_real;
	DOM_Object[eqid]['imag']=self[eqid].Solution_imag;
	DOM_Object[eqid]['size']=self[eqid]['Format_size'];
	DOM_Object[eqid]['units']=self[eqid].Units_units;
	self[eqid].Units_base_array=self[tempid].Units_base_array;
	self[eqid].Units_base_string=self[tempid].Units_base_string;
	self[eqid].Units_units=self[tempid].Units_units;
	self[eqid].Models_numerical="sum\\left("+num+"\\right)";
	self[eqid].Models_dimensions="sum\\left("+dim+"\\right)";
	self[eqid].Models_quantities="sum\\left("+quan+"\\right)";
	self[eqid].Models_units="sum\\left("+units+"\\right)";
	self[pid].Solution_variable_array[pos]=eqid;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//------------------------------------------ MATH FUNCTION MEDIAN -----------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.median = function(replacetext, pid, pos, callback)
{	var showeq='';	var num=''; var dim=''; var units=''; var quan=''; var matsize=0;
	var basestring=''; var tempbasestring='';	var answer=0;	var quantity=''; var matcount=0;
	replacetext=replacetext.replace(/^median\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "Median1"); }
	var nums=new Array(); var thistext=''; 
	for (var a=0; a<inputarray.length; a=a+1)
	{	inputarray[a]=inputarray[a].replace(/^\s+|\s+$/g, '');
		if (isNumber(inputarray[a])) 
		{	nums.push(parseFloat(inputarray[a]));
			if (quantity!=='') { Set_Error(this.Original_id, "Median1"); }
			num=num+", "+inputarray[a];		dim=dim+", 1x1";
			units=units+", NA";				quan=quan+", NA";
			showeq=showeq+", "+inputarray[a];
			var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
							Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 0, eqobj);
		}else if (inputarray[a].match('#Table')) 
		{	var numberarray = Get_Table_Elements (inputarray[a], 1);
			for (var b=0; b<numberarray.length; b++){	nums.push(numberarray[b]);
			num=num+", "+numberarray[b];		dim=dim+", 1x1";
			units=units+", NA";				quan=quan+", NA";	}
			showeq=showeq+", "+inputarray[a];
			if (quantity!=='') { Set_Error(this.Original_id, "Median1"); }
			var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
							Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 0, eqobj);
		}else 
		{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 1, eqobj);
			if (self[tempid].Format_size=="1x1") 
			{	nums.push(ToNum(self[tempid].Solution_real['0-0']));
				if (quantity!=='') { Set_Error(this.Original_id, "Median1"); }
			}else 
			{ 	temp=self[tempid].Format_size.split('x');	matsize=temp[0];	matcount=0;
				for (var mat=1; mat<temp.length; mat++) { matsize=matsize*temp[mat]; }
				for (var i in self[tempid].Solution_real) 
				{ 	nums.push(ToNum(self[tempid].Solution_real[i]));
					matcount=parseInt(matcount, 10)+1;	} 
			}
			for (var mat=matcount; mat<matsize; mat++) {nums.push(self[tempid].Solution_realdefault);}
			num=num+", "+self[tempid].Format_showequation;
			dim=dim+", "+self[tempid].Format_size;
			if (self[tempid].Units_units==='') { units=units+", NA" 
			}else { units=units+", "+self[tempid].Units_units;	}
			if (self[tempid].Units_quantity==='') { quan=quan+", NA" 
			}else { quan=quan+", "+self[tempid].Units_quantity;	}
			showeq=showeq+", "+self[tempid].Format_showequation;	
	}	}
	nums.sort(function(y, z){return y-z});
	if (nums.length%2==1) { answer=nums[Math.floor(nums.length/2)]; 
	}else { answer=ToNum((nums[Math.floor(nums.length/2)]+nums[Math.ceil(nums.length/2)])/2); }
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq=0"};
	var eqid=CreateEq(this.fileid, 0, eqobj);
	self[eqid].Solution_real['0-0']=answer;
	showeq=showeq.replace(/^,/,'');		num=num.replace(/^,/,'');	dim=dim.replace(/^,/,'');
	quan=quan.replace(/^,/,'');			units=units.replace(/^,/,'');
	self[eqid].Format_showequation="median\\left("+replacetext+"\\right)";
	this.Solution_temps.push(eqid);
	self[eqid].Units_base_array=self[tempid].Units_base_array;
	self[eqid].Units_base_string=self[tempid].Units_base_string;
	self[eqid].Units_units=self[tempid].Units_units;
	self[eqid].Models_numerical="median\\left("+num+"\\right)";
	self[eqid].Models_dimensions="median\\left("+dim+"\\right)";
	self[eqid].Models_quantities="median\\left("+quan+"\\right)";
	self[eqid].Models_units="median\\left("+units+"\\right)";
	DOM_Object[eqid]['real']=self[eqid].Solution_real;
	DOM_Object[eqid]['size']=self[eqid]['Format_size'];
	DOM_Object[eqid]['imag']['0-0']=0;
	DOM_Object[eqid]['units']=self[eqid].Units_units;
	self[pid].Solution_variable_array[pos]=eqid;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//------------------------------------------ MATH FUNCTION MODE -------------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.mode = function(replacetext, pid, pos, callback)
{	var showeq='';	var num=''; var dim=''; var units=''; var quan='';
	var basestring=''; var tempbasestring='';	var answer=0;	var modeobj={};	var sol=0; var matcount=0;
	var modenum=0; 	var modearray=new Array(); var matsize=0;
	replacetext=replacetext.replace(/^mode\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "Mode1"); }
	var nums=new Array(); var thistext=''; 
	for (var a=0; a<inputarray.length; a=a+1)
	{	inputarray[a]=inputarray[a].replace(/^\s+|\s+$/g, '');
		if (isNumber(inputarray[a])) 
		{	if (modeobj[inputarray[a]]===undefined) { modeobj[inputarray[a]]=1; 
			}else{ modeobj[inputarray[a]]=parseInt(modeobj[inputarray[a]],10)+1; }
			num=num+", "+inputarray[a];		dim=dim+", 1x1";
			units=units+", NA";				quan=quan+", NA";
			showeq=showeq+", "+inputarray[a];
		}else if (inputarray[a].match('#Table')) 
		{	var numberarray = Get_Table_Elements (inputarray[a], 1);
			for (var b=0; b<numberarray.length; b=b+1)
			{	if (modeobj[numberarray[b]]===undefined) { modeobj[numberarray[b]]=1; 
				}else{ modeobj[numberarray[b]]=parseInt(modeobj[numberarray[b]],10)+1; }
				num=num+", "+numberarray[b];		dim=dim+", 1x1";
				units=units+", NA";				quan=quan+", NA";	}
			showeq=showeq+", "+inputarray[a];
		}else 
		{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 1, eqobj);
			if (self[tempid].Format_size=="1x1") 
			{ 	sol=ToNum(self[tempid].Solution_real['0-0']);
				if (modeobj[sol]===undefined) { modeobj[sol]=1; 
				}else{ modeobj[sol]=parseInt(modeobj[sol],10)+1; }
			}else 
			{ 	temp=self[tempid].Format_size.split('x');	matsize=temp[0];
				for (var i in self[tempid].Solution_real) 
				{ 	sol=ToNum(self[tempid].Solution_real[i]);
					if (modeobj[sol]===undefined) { modeobj[sol]=1; 
					}else{ modeobj[sol]=parseInt(modeobj[sol], 10)+1; }
					matcount=parseInt(matcount, 10)+1;	} 
			}
			num=num+", "+self[tempid].Format_showequation;
			dim=dim+", "+self[tempid].Format_size;
			if (self[tempid].Units_units==='') { units=units+", NA" 
			}else { units=units+", "+self[tempid].Units_units;	}
			if (self[tempid].Units_quantity==='') { quan=quan+", NA" 
			}else { quan=quan+", "+self[tempid].Units_quantity;	}
			showeq=showeq+", "+self[tempid].Format_showequation;	
	}	}
	for (var a in modeobj)
	{	if (modeobj[a]>modenum){ modenum=modeobj[a]; } }

	for (var a in modeobj) 
	{	if (modeobj[a]==modenum){	modearray.push(a); } }


	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq=0"};
	var eqid=CreateEq(this.fileid, 0, eqobj);
	for (var a=0; a<modearray.length; a++) { self[eqid].Solution_real['0-'+a]=modearray[a]; }
	this.Solution_temps.push(eqid);
	showeq=showeq.replace(/^,/,'');		num=num.replace(/^,/,'');	dim=dim.replace(/^,/,'');
	quan=quan.replace(/^,/,'');		units=units.replace(/^,/,'');
	self[eqid].Format_showequation="mode\\left("+showeq+"\\right)";
	DOM_Object[eqid]['real']=self[eqid].Solution_real;
	DOM_Object[eqid]['size']=self[eqid]['Format_size'];
	DOM_Object[eqid]['imag']['0-0']=0;
	DOM_Object[eqid]['units']=self[eqid].Units_units;
	self[eqid].Models_numerical="mode\\left("+num+"\\right)";
	self[eqid].Models_dimensions="mode\\left("+dim+"\\right)";
	self[eqid].Models_quantities="mode\\left("+quan+"\\right)";
	self[eqid].Models_units="mode\\left("+units+"\\right)";
	self[pid].Solution_variable_array[pos]=eqid;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//------------------------------------------ MATH FUNCTION RANGE ------------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.range = function(replacetext, pid, pos, callback)
{	var max=0;	var min=9999999999999999999999999999;	var sol=0;	var matcount=0; 	var matsize=0;
	var startflag=0; var showeq='';	var num=''; var dim=''; var units=''; var quan='';
	replacetext=replacetext.replace(/^range\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "Range1"); }
	var nums=new Array(); var thistext=''; 
	for (var a=0; a<inputarray.length; a=a+1)
	{	inputarray[a]=inputarray[a].replace(/^\s+|\s+$/g, '');
		if (isNumber(inputarray[a])) 
		{	if (a===0) { max=inputarray[a]; min=inputarray[a]; }
			if (ToNum(inputarray[a])>max) { max=ToNum(inputarray[a]); 
			}else if (ToNum(inputarray[a])<min) { min=ToNum(inputarray[a]);  }
			num=num+", "+inputarray[a];		dim=dim+", 1x1";
			units=units+", NA";				quan=quan+", NA";
			showeq=showeq+", "+inputarray[a];
			var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
							Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 0, eqobj);
		}else if (inputarray[a].match('#Table')) 
		{	var numberarray = Get_Table_Elements (inputarray[a], 1);
			if (a===0) { max=ToNum(numberarray[0]); min=ToNum(numberarray[a]); }
			for (var b=0; b<numberarray.length; b=b+1)
			{	if (ToNum(numberarray[b])>max) { max=ToNum(numberarray[b]); 
				}else if (ToNum(numberarray[b])<min) { min=ToNum(numberarray[b]); } 
				num=num+", "+numberarray[b];		dim=dim+", 1x1";
				units=units+", NA";				quan=quan+", NA";	}
			showeq=showeq+", "+inputarray[a];
			var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
							Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 0, eqobj);
		}else 
		{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 1, eqobj);
			if (self[tempid].Format_size=="1x1") 
			{ 	sol=(ToNum(self[tempid].Solution_real['0-0']));
			  	if (a===0) { max=sol; min=sol; }
				if (sol>max) { max=sol; }; if (sol<min) { min=sol; }
			}else 
			{ 	temp=self[tempid].Format_size.split('x');	matsize=temp[0];	matcount=0;
				for (var mat=1; mat<temp.length; mat++) { matsize=matsize*temp[mat]; }
				if (a===0) { startflag=0; }
				for (var i in self[tempid].Solution_real) 
				{ 	sol=ToNum(self[tempid].Solution_real[i]);
			  		if (startflag===0) { max=sol; min=sol; startflag=1; }
					if (ToNum(sol)>max) { max=sol; }; if (ToNum(sol)<min) { min=sol; }
					matcount=parseInt(matcount, 10)+1;	}
			}
			if (matcount<matsize-1)
			{	if (self[tempid].Solution_realdefault>max) { max=self[tempid].Solution_realdefault;}
				if (self[tempid].Solution_realdefault<min) { min=self[tempid].Solution_realdefault;}
			}
			num=num+", "+self[tempid].Format_showequation;
			dim=dim+", "+self[tempid].Format_size;
			if (self[tempid].Units_units==='') { units=units+", NA" 
			}else { units=units+", "+self[tempid].Units_units;	}
			if (self[tempid].Units_quantity==='') { quan=quan+", NA" 
			}else { quan=quan+", "+self[tempid].Units_quantity;	}
			showeq=showeq+", "+self[tempid].Format_showequation;	
	}	}
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq=0"};
	var eqid=CreateEq(this.fileid, 0, eqobj);
	showeq=showeq.replace(/^,/,'');		num=num.replace(/^,/,'');	dim=dim.replace(/^,/,'');
	quan=quan.replace(/^,/,'');			units=units.replace(/^,/,'');
	self[eqid].Solution_real['0-0']=ToNum(max-min); 
	self[eqid].Format_showequation="range\\left("+showeq+"\\right)";
	self[eqid].Units_base_array=self[tempid].Units_base_array;
	self[eqid].Units_base_string=self[tempid].Units_base_string;
	self[eqid].Units_units=self[tempid].Units_units;
	self[eqid].Models_numerical="range\\left("+num+"\\right)";
	self[eqid].Models_dimensions="range\\left("+dim+"\\right)";
	self[eqid].Models_quantities="range\\left("+quan+"\\right)";
	self[eqid].Models_units="range\\left("+units+"\\right)";
	DOM_Object[eqid]['real']=self[eqid].Solution_real;
	DOM_Object[eqid]['size']=self[eqid]['Format_size'];
	DOM_Object[eqid]['imag']['0-0']=0;
	DOM_Object[eqid]['units']=self[eqid].Units_units;
	this.Solution_temps.push(eqid);
	self[pid].Solution_variable_array[pos]=eqid;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//-------------------------------- MATH FUNCTION STANDARD DEVIATION ---------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.stdev = function(replacetext, pid, pos, callback)
{	var average=0; var count=0;		var temp=''; 	var matsize=0;		var matcount=0;		inobj={};  
	var thisavg=0;	var minsum=0;	var sol=0;
	var showeq='';	var num=''; var dim=''; var units=''; var quan='';
	replacetext=replacetext.replace(/^stdev\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "StdDev1"); }
	var nums=new Array(); var thistext=''; 
	for (var a=0; a<inputarray.length; a++)
	{	inputarray[a]=inputarray[a].replace(/^\s+|\s+$/g, '');
		if (isNumber(inputarray[a])) 
		{	average=parseFloat(average)+parseFloat(inputarray[a]); count=parseInt(count, 10)+1;
			num=num+", "+inputarray[a];		dim=dim+", 1x1";
			units=units+", NA";				quan=quan+", NA";
			showeq=showeq+", "+inputarray[a];
			var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
							Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 0, eqobj);
		}else if (inputarray[a].match('#Table')) 
		{	var numberarray = Get_Table_Elements (inputarray[a], 1);
			for (var b=0; b<numberarray.length; b=b+1)
			{	average=parseFloat(average)+parseFloat(numberarray[b]); count=parseInt(count, 10)+1; 
				num=num+", "+numberarray[b];		dim=dim+", 1x1";
				units=units+", NA";				quan=quan+", NA";	}
			showeq=showeq+", "+inputarray[a];
			var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
							Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 0, eqobj);
		}else 
		{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 1, eqobj);
			if (self[tempid].Format_size=="1x1") 
			{ 	average=parseFloat(average)+ToNum(self[tempid].Solution_real['0-0']/self[tempid].Units_multiplier); 
				count=parseInt(count, 10)+1; 	
				inobj[a]=tempid;
			}else 
			{ 	temp=self[tempid].Format_size.split('x');	matsize=temp[0];	matcount=0;
				inobj[a]=tempid;
				for (var mat=1; mat<parseInt(temp.length, 10); mat++) { matsize=matsize*temp[mat]; }
				for (var i in self[tempid].Solution_real) 
				{ 	average=ToNum(average)+ToNum(self[tempid].Solution_real[i]/self[tempid].Units_multiplier);
					count=parseInt(count, 10)+1; 	matcount++;  } }
			for (var mat=matcount; mat<matsize; mat++) 
			{	average=ToNum(average)+ToNum(self[tempid].Solution_realdefault); 
				count=parseInt(count, 10)+1;
			}
			num=num+", "+self[tempid].Format_showequation;
			dim=dim+", "+self[tempid].Format_size;
			if (self[tempid].Units_units==='') { units=units+", NA" 
			}else { units=units+", "+self[tempid].Units_units;	}
			if (self[tempid].Units_quantity==='') { quan=quan+", NA" 
			}else { quan=quan+", "+self[tempid].Units_quantity;	}
			showeq=showeq+", "+self[tempid].Format_showequation;	
	}	}
	thisavg=ToNum(average/count);
	for (var a=0; a<inputarray.length; a++)
	{	inputarray[a]=inputarray[a].replace(/^\s+|\s+$/g, '');
		if (isNumber(inputarray[a])) 
		{	minsum=minsum+ToNum(Math.pow(inputarray[a]-thisavg,2));
		}else if (inputarray[a].match('#Table')) 
		{	var numberarray = Get_Table_Elements (inputarray[a], 1);
			for (var b=0; b<numberarray.length; b++)
			{	minsum=minsum+ToNum(Math.pow(numberarray[b]-thisavg,2));	}
		}else 
		{	if (self[inobj[a]].Format_size=="1x1") 
			{ 	sol=ToNum(self[tempid].Solution_real['0-0']/self[tempid].Units_multiplier);
				minsum=minsum+ToNum(Math.pow(sol-thisavg,2));
			}else 
			{ 	temp=self[inobj[a]].Format_size.split('x');
				for (var i in self[tempid].Solution_real) 
				{ 	sol=ToNum(self[tempid].Solution_real[i]/self[tempid].Units_multiplier);
					minsum=ToNum(minsum)+ToNum(Math.pow(sol-thisavg,2));	}  }
			for (var mat=matcount; mat<matsize; mat++) 
			{	minsum=minsum+ToNum(Math.pow(self[tempid].Solution_realdefault-thisavg,2));	}
	}	}
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq=0"};
	var eqid=CreateEq(this.fileid, 0, eqobj);
	showeq=showeq.replace(/^,/,'');		num=num.replace(/^,/,'');	dim=dim.replace(/^,/,'');
	quan=quan.replace(/^,/,'');			units=units.replace(/^,/,'');
	self[eqid].Solution_real['0-0']=ToNum(Math.pow(ToNum(minsum/(count-1)),0.5));
	self[eqid].Format_showequation="stdev\\left("+showeq+"\\right)";
	this.Solution_temps.push(eqid);
	DOM_Object[eqid]['real']=self[eqid].Solution_real;
	DOM_Object[eqid]['size']=self[eqid]['Format_size'];
	DOM_Object[eqid]['imag']['0-0']=0;
	DOM_Object[eqid]['units']=self[eqid].Units_units;
	self[eqid].Format_showequation="stdev\\left("+showeq+"\\right)";
	if(tempid!==undefined)
	{	self[eqid].Units_base_array=self[tempid].Units_base_array;
		self[eqid].Units_base_string=self[tempid].Units_base_string;
		self[eqid].Units_units=self[tempid].Units_units;
	}
	self[eqid].Models_numerical="stdev\\left("+num+"\\right)";
	self[eqid].Models_dimensions="stdev\\left("+dim+"\\right)";
	self[eqid].Models_quantities="stdev\\left("+quan+"\\right)";
	self[eqid].Models_units="stdev\\left("+units+"\\right)";
	self[pid].Solution_variable_array[pos]=eqid;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//----------------------------------------- MATH FUNCTION VARIANCE ----------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.variance = function(replacetext, pid, pos, callback)
{	var sum1=0; 	var count=0;		var temp=''; 	var matsize=0;		var matcount=0;  
	var sum2=0;		var sol=0;
	var showeq='';	var num=''; var dim=''; var units=''; var quan='';
	replacetext=replacetext.toString().replace(/^variance\(/,"");
	replacetext=replacetext.toString().replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "Variance1"); }
	for (var a=0; a<inputarray.length; a++)
	{	inputarray[a]=inputarray[a].replace(/^\s+|\s+$/g, '');
		if (isNumber(inputarray[a])) 
		{	sum1=sum1+parseFloat(inputarray[a]); sum2=sum2+Math.pow(parseFloat(inputarray[a]),2); 
			count++;
			num=num+", "+inputarray[a];		dim=dim+", 1x1";
			units=units+", NA";				quan=quan+", NA";
			showeq=showeq+", "+inputarray[a];
			var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
							Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 0, eqobj);
		}else if (inputarray[a].match('#Table')) 
		{	var numberarray = Get_Table_Elements (inputarray[a], 1);
			for (var b=0; b<numberarray.length; b++)
			{	sum1=sum1+parseFloat(numberarray[b]); sum2=sum2+Math.pow(parseFloat(numberarray[b]),2);
				count++; 
				num=num+", "+numberarray[b];		dim=dim+", 1x1";
				units=units+", NA";				quan=quan+", NA";	}
			showeq=showeq+", "+inputarray[a];
			var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
							Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 0, eqobj);
		}else 
		{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 1, eqobj);
			if (self[tempid].Format_size=="1x1") 
			{ 	sol=ToNum(self[tempid].Solution_real['0-0']/self[tempid].Units_multiplier);
				sum1=sum1+parseFloat(sol); sum2=sum2+Math.pow(parseFloat(sol),2);
				count++; 
			}else 
			{ 	temp=self[tempid].Format_size.split('x');	matsize=temp[0];	matcount=0;
				for (var mat=1; mat<temp.length; mat++) { matsize=matsize*temp[mat]; }
				for (var i in self[tempid].Solution_real) 
				{ 	sol=ToNum(self[tempid].Solution_real[i]/self[tempid].Units_multiplier);
					sum1=sum1+parseFloat(sol); sum2=sum2+Math.pow(parseFloat(sol),2);
					count++; 	matcount++;	} }
			for (var mat=matcount; mat<matsize; mat++) 
			{	sum1=sum1+parseFloat(self[tempid].Solution_realdefault); 
				sum2=sum2+Math.pow(parseFloat(self[tempid].Solution_realdefault),2);
				count++;
			}
			num=num+", "+self[tempid].Format_showequation;
			dim=dim+", "+self[tempid].Format_size;
			if (self[tempid].Units_units==='') { units=units+", NA" 
			}else { units=units+", "+self[tempid].Units_units;	}
			if (self[tempid].Units_quantity==='') { quan=quan+", NA" 
			}else { quan=quan+", "+self[tempid].Units_quantity;	}
			showeq=showeq+", "+self[tempid].Format_showequation;	
	}	}
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq=0"};
	var eqid=CreateEq(this.fileid, 0, eqobj);
	self[eqid].Solution_real['0-0']=ToNum((ToNum(sum2)-ToNum(Math.pow(sum1,2)/count))/(count-1));
	this.Solution_temps.push(eqid);
	showeq=showeq.replace(/^,/,'');		num=num.replace(/^,/,'');	dim=dim.replace(/^,/,'');
	quan=quan.replace(/^,/,'');			units=units.replace(/^,/,'');
	self[eqid].Format_showequation="variance\\left("+showeq+"\\right)";
	if(tempid!==undefined)
	{	self[eqid].Units_base_array=self[tempid].Units_base_array;
		self[eqid].Units_base_string=self[tempid].Units_base_string;
		self[eqid].Units_units=self[tempid].Units_units;
	}
	self[eqid].Models_numerical="variance\\left("+num+"\\right)";
	self[eqid].Models_dimensions="variance\\left("+dim+"\\right)";
	self[eqid].Models_quantities="variance\\left("+quan+"\\right)";
	self[eqid].Models_units="variance\\left("+units+"\\right)";
	DOM_Object[eqid]['real']=self[eqid].Solution_real;
	DOM_Object[eqid]['size']=self[eqid]['Format_size'];
	DOM_Object[eqid]['imag']['0-0']=0;
	DOM_Object[eqid]['units']=self[eqid].Units_units;
	self[pid].Solution_variable_array[pos]=eqid;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//-------------------------------- MATH FUNCTION COEFFICIENT OF VARIANCE ----------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.cv = function(replacetext, pid, pos, callback)
{	var average=0; var count=0;		var temp=''; 	var matsize=0;		var matcount=0;  
	var thisavg=0;	var minsum=0;	var sol=0;
	replacetext=replacetext.replace(/^cv\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var showeq='';	var num=''; var dim=''; var units=''; var quan='';
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "CV1"); }
	var nums=new Array(); var thistext=''; 
	for (var a=0; a<inputarray.length; a++)
	{	inputarray[a]=inputarray[a].replace(/^\s+|\s+$/g, '');
		if (isNumber(inputarray[a])) 
		{	average=parseFloat(average)+parseFloat(inputarray[a]); count=parseInt(count, 10)+1;
			num=num+", "+inputarray[a];		dim=dim+", 1x1";
			units=units+", NA";				quan=quan+", NA";
			showeq=showeq+", "+inputarray[a];
			var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
							Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 0, eqobj);
		}else if (inputarray[a].match('#Table')) 
		{	var numberarray = Get_Table_Elements (inputarray[a], 1);
			for (var b=0; b<numberarray.length; b++)
			{	average=parseFloat(average)+parseFloat(numberarray[b]); count=parseInt(count, 10)+1; 
				num=num+", "+numberarray[b];		dim=dim+", 1x1";
				units=units+", NA";				quan=quan+", NA";	}
			showeq=showeq+", "+inputarray[a];
			var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
							Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 0, eqobj);
		}else 
		{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 1, eqobj);
			if (self[tempid].Format_size=="1x1") 
			{ 	average=parseFloat(average)+ToNum(self[tempid].Solution_real['0-0']/self[tempid].Units_multiplier); count++; 
			}else 
			{ 	temp=self[tempid].Format_size.split('x');	matsize=temp[0];	matcount=0;
				for (var mat=1; mat<temp.length; mat++) { matsize=matsize*temp[mat]; }
				for (var i in self[tempid].Solution_real) 
				{ 	average=ToNum(average)+ToNum(self[tempid].Solution_real[i]/self[tempid].Units_multiplier);
					count++; 	matcount++;	} }
			for (var mat=matcount; mat<matsize; mat++) 
			{	average=ToNum(average)+ToNum(self[tempid].Solution_realdefault); 
				count++;
			}
			num=num+", "+self[tempid].Format_showequation;
			dim=dim+", "+self[tempid].Format_size;
			if (self[tempid].Units_units==='') { units=units+", NA" 
			}else { units=units+", "+self[tempid].Units_units;	}
			if (self[tempid].Units_quantity==='') { quan=quan+", NA" 
			}else { quan=quan+", "+self[tempid].Units_quantity;	}
			showeq=showeq+", "+self[tempid].Format_showequation;	
	}	}
	thisavg=ToNum(average/count);
	for (var a=0; a<inputarray.length; a++)
	{	inputarray[a]=inputarray[a].replace(/^\s+|\s+$/g, '');
		if (isNumber(inputarray[a])) 
		{	minsum=minsum+ToNum(Math.pow(inputarray[a]-thisavg,2));
		}else if (inputarray[a].match('#Table')) 
		{	var numberarray = Get_Table_Elements (inputarray[a], 1);
			for (var b=0; b<numberarray.length; b=b+1)
			{	minsum=minsum+ToNum(Math.pow(numberarray[b]-thisavg,2));	}
		}else 
		{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+inputarray[a]};
			var tempid=CreateEq(this.fileid, 1, eqobj);
			if (self[tempid].Format_size=="1x1") 
			{ 	sol=ToNum(self[tempid].Solution_real['0-0']/self[tempid].Units_multiplier);
				minsum=minsum+ToNum(Math.pow(sol-thisavg,2));
			}else 
			{ 	temp=self[tempid].Format_size.split('x');
				for (var i in self[tempid].Solution_real) 
				{ 	sol=ToNum(self[tempid].Solution_real[i]/self[tempid].Units_multiplier);
					minsum=minsum+ToNum(Math.pow(sol-thisavg,2));	}  }
			for (var mat=matcount; mat<matsize; mat++) 
			{	minsum=minsum+ToNum(Math.pow(self[tempid].Solution_realdefault-thisavg,2));	}
	}	}
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq=0"};
	var eqid=CreateEq(this.fileid, 0, eqobj);
	self[eqid].Solution_real['0-0']=ToNum(100*Math.pow(ToNum(minsum/(count-1)),0.5))/thisavg;
	this.Solution_temps.push(eqid);
	showeq=showeq.replace(/^,/,'');		num=num.replace(/^,/,'');	dim=dim.replace(/^,/,'');
	quan=quan.replace(/^,/,'');			units=units.replace(/^,/,'');
	self[eqid].Format_showequation="cv\\left("+showeq+"\\right)";
	if(tempid!==undefined)
	{	self[eqid].Units_base_array=self[tempid].Units_base_array;
		self[eqid].Units_base_string=self[tempid].Units_base_string;
		self[eqid].Units_units=self[tempid].Units_units;
	}
	self[eqid].Models_numerical="cv\\left("+num+"\\right)";
	self[eqid].Models_dimensions="cv\\left("+dim+"\\right)";
	self[eqid].Models_quantities="cv\\left("+quan+"\\right)";
	self[eqid].Models_units="cv\\left("+units+"\\right)";
	DOM_Object[eqid]['real']=self[eqid].Solution_real;
	DOM_Object[eqid]['size']=self[eqid]['Format_size'];
	DOM_Object[eqid]['imag']['0-0']=0;
	DOM_Object[eqid]['units']=self[eqid].Units_units;
	self[pid].Solution_variable_array[pos]=eqid;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//------------------------------------ MATH FUNCTION POLYFIT  ---------------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.polyfit = function(replacetext, pid, pos, callback)
{	DeleteConnectedEqs(this.Format_id);
	var average=0, key='', sumkey='', meanx=0, meany=0, flag=0;
	replacetext=replacetext.replace(/^polyfit\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Polyfit"); flag=1; }
	if (inputarray.length<3) { Set_Error(this.Original_id, "Polyfit1"); flag=1; }
	if (inputarray.length>3) { Set_Error(this.Original_id, "Polyfit2"); flag=1; }
	if (flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq=0"};
		var matid=CreateEq(this.fileid, 0, eqobj);
		var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq=0"};
		var vecid=CreateEq(this.fileid, 0, eqobj);
		var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var typeid=CreateEq(this.fileid, 1, eqobj);
		var type=self[typeid].Solution_real['0-0'];
		if ((type%1!==0)||(self[typeid].Format_size!="1x1")){Set_Error(this.Original_id,"Polyfit4",typeid);}
		var xsum=new Array(ToNum(ToNum(type)*2)+1);	var ysum=new Array(parseInt(type, 10)+1);
		for (var a=0; a<xsum.length; a++) { xsum[a]=0;	ysum[a]=0; }
		var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
		var xid=CreateEq(this.fileid, 1, eqobj);
		var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[2]};
		var yid=CreateEq(this.fileid, 1, eqobj);
		var sizes=self[xid].Format_size.split('x');
		if (self[xid].Format_size!=self[yid].Format_size){Set_Error(this.Original_id,"Polyfit5",xid,yid);}//\
		if (sizes[0]>sizes[1]) { var thislength=sizes[0]; }else { var thislength=ToNum(sizes[1]); }
		var count=ToNum(sizes[0]*sizes[1]);
		for (var a=0; a<sizes[0]; a++)
		{	for (var b=0; b<sizes[1]; b++)
			{	key=a+'-'+b;
				for (var power=0; power<=parseInt(type, 10)*2; power++) 
				{	xsum[power]=xsum[power]+Math.pow(self[xid].Solution_real[key],power);
					ysum[power]=ysum[power]+self[yid].Solution_real[key]*Math.pow(self[xid].Solution_real[key],power);	}	
			}
		}
		for (var a=0; a<=type; a++)
		{	for (var b=0; b<=type; b++)
			{	key=a+'-'+b;	sumkey=parseInt(a, 10)+parseInt(b, 10);
				self[matid].Solution_real[a+'-'+b]=xsum[sumkey];
			}
			self[vecid].Solution_real[a+'-0']=ysum[a];
		}
		var avg=ysum[0]/(sizes[0]*sizes[1]);
		this.Format_type=6;
		self[matid].Solution_real['0-0']=thislength; 
		self[matid].Format_size=ToNum(ToNum(type)+ToNum(1))+'x'+ToNum(ToNum(type)+ToNum(1));
		self[vecid].Format_size=ToNum(type)+1+'x1';
		var eqid=Gauss_Elimination(matid, vecid, this.Original_id);
		self[eqid].Format_showequation="polyfit\\left("+replacetext+"\\right)";
		this.Solution_temps.push(eqid, matid, vecid);
		var left=this.Format_left.replace(/^\s+|\s+$|^\[|\]$/g, ''); 
		var outputarray=InputArray(left);
		if (outputarray.length>2) { Set_Error(this.Original_id, "Polyfit3"); }
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location'], 10),
			Format_name:outputarray[0], equation:outputarray[0]+"="+this.Format_right};
		var coid=CreateEq(this.fileid, 0, eqobj);
		self[coid].Solution_real=JSON.parse(JSON.stringify(self[eqid].Solution_real));
		self[coid].Format_size=ToNum(parseInt(type, 10)+1)+'x1';
		self[coid].Format_showequation="polyfit \\left("+replacetext+"\\right)";
		this.connected_ids={};		this.connected_ids[coid]=1;
		var pre=0;	var diffsum=0; var avgsum=0;
		if (outputarray.length==2)
		{	for (var a=0; a<sizes[0]; a++)
			{	for (var b=0; b<sizes[1]; b++)
				{	key=a+'-'+b; pre=0;
					for (var c=0; c<Object.keys(self[coid].Solution_real).length; c++)
					{	pre=pre+ToNum(self[coid].Solution_real[c+'-0']*Math.pow(self[xid].Solution_real[key], c));}
					diffsum=diffsum+Math.pow(self[yid].Solution_real[key]-pre,2);
					avgsum=avgsum+Math.pow(self[yid].Solution_real[key]-avg,2);
			}	}
			var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location'], 10), 
			Format_name:outputarray[1], equation:outputarray[1]+"="+this.Format_right};
			var rid=CreateEq(this.fileid, 0, eqobj);
			self[rid].Solution_real['0-0']=1-(diffsum/avgsum);
			self[rid].Format_showequation="polyfit \\left("+replacetext+"\\right)";
			DOM_Object[rid]['type']="equation";
		}
		DOM_Object[coid][type]="equation";
		this.connected_ids[coid]=1;	this.connected_ids[rid]=1;
		AddConnectedEqs(this.Format_id);
		DOM_Object[eqid]['real']=self[eqid].Solution_real;
		DOM_Object[eqid]['size']=self[eqid]['Format_size'];
		DOM_Object[eqid]['imag']['0-0']=0;
		DOM_Object[eqid]['units']=self[eqid].Units_units;
		DOM_Object[coid]['real']=self[coid].Solution_real;
		DOM_Object[coid]['size']=self[coid]['Format_size'];
		DOM_Object[coid]['imag']['0-0']=0;
		DOM_Object[coid]['units']=self[coid].Units_units;
		if (outputarray.length==2)
		{
			DOM_Object[rid]['real']=self[rid].Solution_real;
			DOM_Object[rid]['size']=self[rid]['Format_size'];
			DOM_Object[rid]['imag']['0-0']=0;
			DOM_Object[rid]['units']=self[rid].Units_units;
		}
		SetModels("polyfit", eqid, typeid, xid, yid);
		self[pid].Solution_variable_array[pos]=eqid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//------------------------------------ MATH FUNCTION POWERFIT  --------------------------------------------//
/*
This is a function to fit data to a curve of the form y=Ax^B. It returns a and b where A is e^a and b is B.
Source - http://mathworld.wolfram.com/LeastSquaresFittingPowerLaw.html
*/
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.powerfit = function(replacetext, pid, pos, callback)
{	DeleteConnectedEqs(this.Format_id);
	var xsum=0, ysum=0, xysum=0, x2sum=0, sum=0, avg=0, key='', flag=0;
	replacetext=replacetext.replace(/^powerfit\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	this.Format_type=6;
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "Powerfit"); flag=1; }
	if (inputarray.length<2) { Set_Error(this.Original_id, "Powerfit1"); flag=1;  }
	if (inputarray.length>2) { Set_Error(this.Original_id, "Powerfit1"); flag=1;  }
	if(flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
		Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var xid=CreateEq(this.fileid, 1, eqobj);
		var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
		Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
		var yid=CreateEq(this.fileid, 1, eqobj);
		if (self[xid].Format_size!=self[yid].Format_size) { Set_Error(this.Original_id, "Powerfit2"); }
		var sizes=self[xid].Format_size.split('x');	var type=0;
		if (sizes[0]>sizes[1]){var thislength=sizes[0];}else{var thislength=ToNum(sizes[1]); type=1;}
		var count=ToNum(sizes[0]*sizes[1]);
		for (var a=0; a<thislength; a++)
		{	if (type==1) { key='0-'+a; }else { key=a+'-0'; }
			xsum=ToNum(xsum)+Math.log(self[xid].Solution_real[key]);
			x2sum=ToNum(x2sum)+Math.pow(Math.log(self[xid].Solution_real[key]),2);
			ysum=ToNum(ysum)+Math.log(self[yid].Solution_real[key]);
			xysum=ToNum(xysum)+ToNum(Math.log(self[xid].Solution_real[key])*Math.log(self[yid].Solution_real[key]));	
			sum=sum+ToNum(self[yid].Solution_real[key]);
		}
		var B=((thislength*xysum)-(xsum*ysum))/((thislength*x2sum)-Math.pow(xsum,2))
		var A=Math.pow(Math.E,(ysum-B*xsum)/thislength);
		avg=ToNum(sum/count);
		var eqobj={Page_position:DOM_Object[this.Format_id]['location'],Format_showtype:"InnerFunction",
		Original_id:this.Original_id, equation:"TempEq=0"};
		var eqid=CreateEq(this.fileid, 0, eqobj);
		self[eqid].Solution_real['0-0']=A;	self[eqid].Solution_real['1-0']=B;
		self[eqid].Format_showequation="powerfit\\left("+replacetext+"\\right)";
		var left=this.Format_left.replace(/^\s+|\s+$|^\[|\]$/g, ''); 
		var outputarray=InputArray(left);
		if (outputarray.length>2) { Set_Error(this.Original_id, "Powerfit3"); }
		var pre=0;	var diffsum=0; var avgsum=0;
		if (outputarray.length==2)
		{	for (var a=0; a<sizes[0]; a++)
			{	for (var b=0; b<sizes[1]; b++)
				{	key=a+'-'+b; pre=0;
					pre=pre+ToNum(A*Math.pow(self[xid].Solution_real[key],B));
					diffsum=diffsum+Math.pow(self[yid].Solution_real[key]-pre,2);
					avgsum=avgsum+Math.pow(self[yid].Solution_real[key]-avg,2);
			}	}
			var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location'], 10), 
			Format_name:outputarray[1], equation:outputarray[1]+"="+this.Format_right};
			var rid=CreateEq(this.fileid, 0, eqobj);
			self[rid].Solution_real['0-0']=1-(diffsum/avgsum);
			self[rid].Format_showequation="powerfit \\left("+replacetext+"\\right)";
			DOM_Object[rid]['type']="equation";
		}
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location'], 10), 
		Format_name:outputarray[0], equation:outputarray[0]+"="+this.Format_right};
		var coid=CreateEq(this.fileid, 0, eqobj);
		self[coid].Solution_real=JSON.parse(JSON.stringify(self[eqid].Solution_real));
		self[coid].Format_size='2x1';
		self[coid].Format_showequation="powerfit \\left("+replacetext+"\\right)";
		this.connected_ids={};		this.connected_ids[coid]=1;		this.connected_ids[rid]=1;
		this.Solution_temps.push(eqid);
		AddConnectedEqs(this.Format_id);
		SetModels("powerfit", eqid, xid, yid);
		DOM_Object[eqid]['real']=self[eqid].Solution_real;
		DOM_Object[eqid]['size']=self[eqid]['Format_size'];
		DOM_Object[eqid]['imag']['0-0']=0;
		DOM_Object[eqid]['units']=self[eqid].Units_units;
		DOM_Object[coid]['real']=self[coid].Solution_real;
		DOM_Object[coid]['size']=self[coid]['Format_size'];
		DOM_Object[coid]['imag']['0-0']=0;
		DOM_Object[coid]['units']=self[coid].Units_units;
		DOM_Object[rid]['real']=self[rid].Solution_real;
		DOM_Object[rid]['size']=self[rid]['Format_size'];
		DOM_Object[rid]['imag']['0-0']=0;
		DOM_Object[rid]['units']=self[rid].Units_units;
		self[pid].Solution_variable_array[pos]=eqid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//


//---------------------------------------------------------------------------------------------------------//
//-------------------------------------- MATH FUNCTION LOGFIT  --------------------------------------------//
//---------------------------------------------------------------------------------------------------------//
/* This is a function to fit data to a curve of the form y=a+b * ln x. It returns a and b. 
Source - http://mathworld.wolfram.com/LeastSquaresFittingLogarithmic.html
*/
Equation.prototype.logfit = function(replacetext, pid, pos, callback)
{	DeleteConnectedEqs(this.Format_id);
	var xsum=0, ysum=0, xysum=0, x2sum=0, flag=0;
	replacetext=replacetext.replace(/^logfit\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	this.Format_type=6;
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "Logfit"); flag=1;}
	if (inputarray.length<2) { Set_Error(this.Original_id, "Logfit1"); flag=1; }
	if (inputarray.length>2) { Set_Error(this.Original_id, "Logfit1"); flag=1; }
	if (flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'],Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var xid=CreateEq(this.fileid, 1, eqobj);
		var eqobj={Page_position:DOM_Object[this.Format_id]['location'],Format_showtype:"InnerFunction",
		Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
		var yid=CreateEq(this.fileid, 1, eqobj);
		if (self[xid].Format_size!=self[yid].Format_size) { Set_Error(this.Original_id, "Logfit2"); }
		var sizes=self[xid].Format_size.split('x');
		if (sizes[0]>sizes[1]) { var thislength=sizes[0]; }else{var thislength=ToNum(sizes[1]); type=1;}
		var count=ToNum(sizes[0]*sizes[1]);
		for (var a=0; a<thislength; a++)
		{	if (type==1) { key='0-'+a; }else { key=a+'-0'; }
			xsum=xsum+Math.log(self[xid].Solution_real[key])/Math.log(Math.E);
			x2sum=x2sum+Math.pow(Math.log(self[xid].Solution_real[key])/Math.log(Math.E),2);
			ysum=ysum+ToNum(self[yid].Solution_real[key]);
			xysum=xysum+self[yid].Solution_real[key]*(Math.log(self[xid].Solution_real[key])/Math.log(Math.E));	
		}
		var B=(thislength*xysum-xsum*ysum)/(thislength*x2sum-Math.pow(xsum,2));
		var A=(ysum-B*xsum)/thislength;
		var avg=ysum/thislength;
		var eqobj={Page_position:DOM_Object[this.Format_id]['location'],Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq=0"};
		var eqid=CreateEq(this.fileid, 0, eqobj);
		self[eqid].Solution_real['0-0']=A;	self[eqid].Solution_real['1-0']=B;
		self[eqid].Format_showequation="logfit\\left("+replacetext+"\\right)";
		self[eqid].Format_size='2x1';
		var left=this.Format_left.replace(/^\s+|\s+$|^\[|\]$/g, ''); 
		var outputarray=InputArray(left);
		if (outputarray.length>2) { Set_Error(this.Original_id, "Logfit3"); }
		var pre=0;	var diffsum=0; var avgsum=0;
		if (outputarray.length==2)
		{	for (var a=0; a<sizes[0]; a++)
			{	for (var b=0; b<sizes[1]; b++)
				{	key=a+'-'+b; pre=0;
					pre=pre+ToNum(A)+B*Math.log(self[xid].Solution_real[key]);
					diffsum=diffsum+ToNum(Math.pow(self[yid].Solution_real[key]-pre,2));
					avgsum=avgsum+ToNum(Math.pow(self[yid].Solution_real[key]-avg,2));
			}	}
			var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location'], 10), 
				Format_name:outputarray[1], equation:outputarray[1]+"="+this.Format_right};
			var rid=CreateEq(this.fileid, 0, eqobj);
			self[rid].Solution_real['0-0']=1-(diffsum/avgsum);
			self[rid].Format_showequation="logfit \\left("+replacetext+"\\right)";
			DOM_Object[rid]['type']="equation";
		}
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location'], 10),
			equation:outputarray[0]+"="+this.Format_right, Format_name:outputarray[0]};
		var coid=CreateEq(this.fileid, 0, eqobj);
		self[coid].Solution_real=JSON.parse(JSON.stringify(self[eqid].Solution_real));
		self[coid].Format_size='2x1';
		self[coid].Format_showequation="logfit \\left("+replacetext+"\\right)";
		this.connected_ids={};		this.connected_ids[coid]=1;		this.connected_ids[rid]=1;
		this.Solution_temps.push(eqid);
		AddConnectedEqs(this.Format_id);
		DOM_Object[eqid]['real']=self[eqid].Solution_real;
		DOM_Object[eqid]['size']=self[eqid]['Format_size'];
		DOM_Object[eqid]['imag']['0-0']=0;
		DOM_Object[eqid]['units']=self[eqid].Units_units;
		DOM_Object[coid]['real']=self[coid].Solution_real;
		DOM_Object[coid]['size']=self[coid]['Format_size'];
		DOM_Object[coid]['imag']['0-0']=0;
		DOM_Object[coid]['units']=self[coid].Units_units;
		DOM_Object[rid]['real']=self[rid].Solution_real;
		DOM_Object[rid]['size']=self[rid]['Format_size'];
		DOM_Object[rid]['imag']['0-0']=0;
		DOM_Object[rid]['units']=self[rid].Units_units;
		SetModels("logfit", eqid, xid, yid);
		self[pid].Solution_variable_array[pos]=eqid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//-------------------------------------- MATH FUNCTION EXPFIT  --------------------------------------------//
//---------------------------------------------------------------------------------------------------------//
/*  This is a function to fit data to a curve of the form y=Ae^Bx. It returns a and b where A=exp(a) and B=b
http://mathworld.wolfram.com/LeastSquaresFittingExponential.html
*/
Equation.prototype.expfit = function(replacetext, pid, pos, callback)
{	DeleteConnectedEqs(this.Format_id);
	var x2ysum=0, ylnysum=0, xysum=0, xylnysum=0, ysum=0, x2ysum, avg=0, type=0, flag=0;
	replacetext=replacetext.replace(/^expfit\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	this.Format_type=6;
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "Expfit"); flag=1; }
	if (inputarray.length<2) { Set_Error(this.Original_id, "Expfit1"); flag=1; }
	if (inputarray.length>2) { Set_Error(this.Original_id, "Expfit1"); flag=1; }
	if (flag==0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var xid=CreateEq(this.fileid, 1, eqobj);
		var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
		var yid=CreateEq(this.fileid, 1, eqobj);
		if (self[xid].Format_size!=self[yid].Format_size) { Set_Error(this.Original_id, "Expfit2"); }
		var sizes=self[xid].Format_size.split('x');
		if (sizes[0]>sizes[1]) { var thislength=sizes[0]; }else{var thislength=ToNum(sizes[1]);type=1;}
		var count=ToNum(sizes[0]*sizes[1]);
		for (var a=0; a<thislength; a++)
		{	if (type==1) { key='0-'+a; }else { key=a+'-0'; }
			x2ysum=x2ysum+Math.pow(self[xid].Solution_real[key],2)*self[yid].Solution_real[key];
			ylnysum=ylnysum+self[yid].Solution_real[key]*Math.log(self[yid].Solution_real[key]);		
			xysum=xysum+ToNum(self[xid].Solution_real[key]*self[yid].Solution_real[key]);
			xylnysum=xylnysum+ToNum(self[xid].Solution_real[key]*self[yid].Solution_real[key]*Math.log(self[yid].Solution_real[key]));		
			ysum=ysum+ToNum(self[yid].Solution_real[key]);
			avg=avg+self[yid].Solution_real[key];
		}
		avg=avg/count;
		var A=ToNum((x2ysum*ylnysum-xysum*xylnysum)/(ysum*x2ysum-Math.pow(xysum,2)));
		var B=ToNum((ysum*xylnysum-xysum*ylnysum)/(ysum*x2ysum-Math.pow(xysum,2)));
		var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction",
			Original_id:this.Original_id, equation:"TempEq=0"};
		var eqid=CreateEq(this.fileid, 0, eqobj);
		self[eqid].Solution_real['0-0']=ToNum(Math.pow(Math.E,A)); self[eqid].Solution_real['1-0']=B;
		self[eqid].Format_size='2x1';
		self[eqid].Format_size='2x1';
		self[eqid].Format_showequation="expfit \\left("+replacetext+"\\right)";
		var left=this.Format_left.replace(/^\s+|\s+$|^\[|\]$/g, ''); 
		var outputarray=InputArray(left);
		if (outputarray.length>2) { Set_Error(this.Original_id, "Expfit3"); }
		var pre=0;	var diffsum=0; var avgsum=0;
		if (outputarray.length==2)
		{	for (var a=0; a<sizes[0]; a++)
			{	for (var b=0; b<sizes[1]; b++)
				{	key=a+'-'+b; pre=0;
					pre=pre+Math.pow(Math.E,A)*Math.pow(Math.E, B*self[xid].Solution_real[key]);
					diffsum=diffsum+ToNum(Math.pow(self[yid].Solution_real[key]-pre,2));
					avgsum=avgsum+ToNum(Math.pow(self[yid].Solution_real[key]-avg,2));
			}	}
			var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location'], 10), 
			Format_name:outputarray[1], equation:outputarray[1]+"="+this.Format_right};
			var rid=CreateEq(this.fileid, 0, eqobj);
			self[rid].Solution_real['0-0']=1-(diffsum/avgsum);
			self[rid].Format_showequation="expfit \\left("+replacetext+"\\right)";
			DOM_Object[rid]['type']="equation";
		}
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location'], 10), Format_name:outputarray[0],//\
		equation:outputarray[0]+"="+this.Format_right};
		var coid=CreateEq(this.fileid, 0, eqobj);
		self[coid].Solution_real=JSON.parse(JSON.stringify(self[eqid].Solution_real));
		self[coid].Format_size='2x1';
		self[coid].Format_showequation="expfit \\left("+replacetext+"\\right)";
		this.connected_ids={};		this.connected_ids[coid]=1;		this.connected_ids[rid]=1;
		this.Solution_temps.push(eqid);
		AddConnectedEqs(this.Format_id);
		DOM_Object[eqid]['real']=self[eqid].Solution_real;
		DOM_Object[eqid]['size']=self[eqid]['Format_size'];
		DOM_Object[eqid]['imag']['0-0']=0;
		DOM_Object[eqid]['units']=self[eqid].Units_units;
		DOM_Object[coid]['real']=self[coid].Solution_real;
		DOM_Object[coid]['size']=self[coid]['Format_size'];
		DOM_Object[coid]['imag']['0-0']=0;
		DOM_Object[coid]['units']=self[coid].Units_units;
		DOM_Object[rid]['real']=self[rid].Solution_real;
		DOM_Object[rid]['size']=self[rid]['Format_size'];
		DOM_Object[rid]['imag']['0-0']=0;
		DOM_Object[rid]['units']=self[rid].Units_units;
		SetModels("expfit", eqid, xid, yid);
		self[pid].Solution_variable_array[pos]=eqid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//------------------------------------ MATH FUNCTION HISTOGRAM --------------------------------------------//
//---------------------------------------------------------------------------------------------------------//
/*
This function takes in a set of data in the form of a vector or matrix along with a second parameter. If 
the second parameter is a number then it creates an x and y vector of equally spaced numbers between the 
lowest and highest numbers in y. It then loops through the data and adds 1 to each "bin" where the number should fall.

If the second parameter is a vector, it uses each number in that vector as the center value of the bin 
and the ends of the bin are equally spaced on either end. If the vector is equally spaced, then bins will be as well.
*/
Equation.prototype.histogram = function(replacetext, pid, pos, callback)
{	DeleteConnectedEqs(this.Format_id);
	 nums=Array();	 mins=new Array();  maxes=new Array();	 binsize=0;	var count=0;
	 bins=Array();	 hist={};	 binobj={};
	replacetext=replacetext.replace(/^histogram\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	this.Format_type=6;
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "Histogram"); }
	if (inputarray.length!=2) { Set_Error(this.Original_id, "Histogram1"); }
	
	var eqobj={Page_position:parseInt(DOM_Object[this.Original_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"histEq="+inputarray[0]};
	var dataid=CreateEq(this.fileid, 1, eqobj);

	var eqobj={Page_position:parseInt(DOM_Object[this.Original_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"histEq2="+inputarray[1]};
	var binid=CreateEq(this.fileid, 1, eqobj);
	
	console.log('The solution for the dataid is ...');
	console.log(self[dataid]);
	console.log('The solution for the binid is ...');
	console.log(self[binid]);
	
	for (var i in self[dataid].Solution_real)	{	nums.push(self[dataid].Solution_real[i]); }
	nums=nums.sort(function(y, z){return y-z});
	var min=nums[0]; 	var max=nums[nums.length-1];
	if (self[binid].Format_size=="1x1") 
	{	console.log('The max, min, and the numbins are '+min+', '+max+' and '+numbins);
		var numbins=parseFloat(Big(self[binid].Solution_real['0-0']));
		binsize=parseFloat(Big(max).minus(Big(min)).div(numbins)); 
		for (var a=min; a<max; a=parseFloat(Big(a).plus(Big(binsize))))
		{	mins[count]=a;	maxes[count]=parseFloat(Big(a).plus(Big(binsize)));
			binobj['0-'+count]=ToNum((maxes[count]-mins[count])/2)+ToNum(mins[count]);	count++;}
	}else
	{	for (var i in self[binid].Solution_real) { bins.push(ToNum(self[binid].Solution_real[i]));} 
		bins=bins.sort(function(y, z){return y-z});
		if (min<bins[0]) { bins[0]=min; }
		if (max>bins[bins.length-1]) { bins[bins.length-1]=max; }
		for (var a=0; a<bins.length-1; a++)
		{	mins[a]=bins[a]; 	maxes[a]=bins[a+1];
			binobj['0-'+a]=ToNum((maxes[a]-mins[a])/2)+ToNum(mins[a]);	}
	}
	for (var i in self[dataid].Solution_real)
	{	for (var a=0; a<mins.length; a++) 
		{	if (hist['0-'+a]===undefined){ hist['0-'+a]=0; }
			if ((self[dataid].Solution_real[i]>=mins[a])&&(self[dataid].Solution_real[i]<maxes[a]))
			{	hist['0-'+a]=hist['0-'+a]+(1/(maxes[a]-mins[a]));  }
			if ((self[dataid].Solution_real[i]==maxes[a])&&(a==mins.length-1))
			{	hist['0-'+a]=hist['0-'+a]+(1/(maxes[a]-mins[a])); }
		}
	}
	var left=this.Format_left.replace(/^\s+|\s+$|^\[|\]$/g, ''); 
	var outputarray=InputArray(left);
	if (outputarray.length>2) { Set_Error(this.Original_id, "Histogram3"); }
	var eqobj={Page_position:parseInt(DOM_Object[this.Original_id]['location'], 10), Format_name:outputarray[0],//\
	equation:outputarray[0]+"="+this.Format_right};
	var xid=CreateEq(this.fileid, 0, eqobj);
	self[xid].Solution_real=binobj;
	self[xid].Format_size='1x'+count++;
	self[xid].Format_showequation="histogram\\left("+self[dataid].Format_showequation+", "+self[binid].Format_showequation+"\\right)";
	var eqobj={Page_position:DOM_Object[this.Original_id]['location'], Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq=0"};
	var eqid=CreateEq(this.fileid, 0, eqobj);
	self[eqid].Solution_real=hist;
	self[eqid].Format_size='1x'+mins.length;
	self[eqid].Format_showequation="histogram\\left("+self[dataid].Format_showequation+", "+self[binid].Format_showequation+"\\right)";
	var eqobj={Page_position:parseInt(DOM_Object[this.Original_id]['location'], 10), Format_name:outputarray[1],//\
	equation:outputarray[1]+"="+this.Format_right};
	var yid=CreateEq(this.fileid, 0, eqobj);
	self[yid].Solution_real=hist;
	self[yid].Format_size='1x'+mins.length;
	self[yid].Format_showequation="histogram\\left("+self[dataid].Format_showequation+", "+self[binid].Format_showequation+"\\right)";
	this.connected_ids={};		this.connected_ids[xid]=1;		this.connected_ids[yid]=1;
	this.Solution_temps.push(eqid);
	AddConnectedEqs(this.Format_id);
	SetModels("histogram", eqid, dataid, binid);
	self[pid].Solution_variable_array[pos]=eqid;
	DOM_Object[eqid]['real']=self[eqid].Solution_real;
	DOM_Object[eqid]['size']=self[eqid]['Format_size'];
	DOM_Object[eqid]['imag']['0-0']=0;
	DOM_Object[eqid]['units']=self[eqid].Units_units;
	DOM_Object[xid]['real']=self[xid].Solution_real;
	DOM_Object[xid]['size']=self[xid]['Format_size'];
	DOM_Object[xid]['imag']['0-0']=0;
	DOM_Object[xid]['units']=self[xid].Units_units;
	DOM_Object[yid]['real']=self[yid].Solution_real;
	DOM_Object[yid]['size']=self[yid]['Format_size'];
	DOM_Object[yid]['imag']['0-0']=0;
	DOM_Object[yid]['units']=self[yid].Units_units;
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//------------------------------------ GET THE NUMBER OF INDICES ------------------------------------------//
//---------------------------------------------------------------------------------------------------------//
Equation.prototype.numinds = function(replacetext, pid, pos, callback)
{	var flag=1;		var indexes=0;	var ilength=0;	var numind=0;
	replacetext=replacetext.replace(/^numinds\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "numinds"); flag=0; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "numinds1"); flag=0; }
	if (flag==1)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'],Format_showtype:"InnerFunction",
		Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};	
		var id=CreateEq(this.fileid, 1, eqobj);
		indexes=self[id].Format_size.split('x');
		ilength=indexes.length;
		if (self[id].Format_size=="1x1") { numinds=1; 
		}else {	numinds=ilength;	}
		self[id].Solution_imag['0-0']=0;
		self[id].Solution_real={};		self[id].Solution_imag={};
		self[id].Solution_real['0-0']=numinds;
		self[id].Format_size="1x1";
		self[id].Format_showequation="numinds\\left("+self[id].Format_showequation+"\\right)";
		this.Solution_temps.push(id);
		SetModels("numinds", id, id);
		self[pid].Solution_variable_array[pos]=id;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
		DOM_Object[id]['real']=self[id].Solution_real;
		DOM_Object[id]['size']=self[id]['Format_size'];
		DOM_Object[id]['imag']['0-0']=0;
		DOM_Object[id]['units']=self[id].Units_units;
	}	 
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//---------------------------------------------- CHOLESKY FACTORIZATION ---------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
/*
This function performs the Cholesky decomposition for a symetric matrix. That is a matrix that is symetric about the diagonal. Page 244.
*/
Equation.prototype.Cholesky = function(replacetext, pid, pos, callback)
{	var flag=0;		var sum1=0;		var sum2=0;		var U={};
	replacetext=replacetext.replace(/^Cholesky\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Cholesky"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "Cholesky1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	var sizes=self[id1].Format_size.split('x');
	if (sizes[0]!==sizes[1]) { Set_Error(this.Original_id, "Cholesky2", id1); flag=1; }
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq=0"};
		var newid=CreateEq(this.fileid, 0, eqobj);
		size=parseInt(sizes[0]);
		for (var a=0; a<parseInt(sizes[0]); a++)
		{	sum1=self[id1].Solution_real[a+'-'+a];
			for (var b=0; b<a; b++)	{	sum1=sum1-Math.pow(U[b+'-'+a], 2); 	}
			U[a+'-'+a]=Math.pow(sum1, 0.5);
			for (var b=a+1; b<parseInt(sizes[0]); b++)
			{	sum2=self[id1].Solution_real[a+'-'+b];
				for (var c=0; c<a; c++)	{	sum2=sum2-(U[c+'-'+a]*U[c+'-'+b]);	}
				U[a+'-'+b]=sum2/U[a+'-'+a];
				if (self[id1].Solution_real[a+'-'+b]!=self[id1].Solution_real[b+'-'+a]) { Set_Error(this.Original_id, "Cholesky3"); }
			}
		}
		// Fill out the bottom with zeros
		for (var a=0; a<parseInt(sizes[0]); a++)
		{
			for (var b=a-1; b>=0; b--)
			{
				U[a+'-'+b] = 0;
			}
		}
		tempMat={};
		for (var a=0; a<parseInt(sizes[0]); a++)
		{
			for (var b=0; b<parseInt(sizes[0]); b++)
			{
				tempMat[a+'-'+b]=U[b+'-'+a]
			}
		}
		self[newid].Solution_real=tempMat;
		self[newid].Format_size=self[id1].Format_size;

		self[newid].Format_showequation="Cholesky\\left("+self[id1].Format_showequation+"\\right)";
		this.Solution_temps.push(newid);
		self[newid].Units_base_array=self[id1].Units_base_array;
		self[newid].Units_units=self[id1].Units_units;
		self[newid].Units_quantity=self[id1].Units_quantity;
		self[newid].Units_showunits=self[id1].Units_showunits;
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		SetModels("Cholesky", newid, id1);
		self[pid].Solution_variable_array[pos]=newid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}else { var newid='';}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------------- MATRIX NORM CALCULATION ---------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
/*
	The Norm function calculates the norm of the vector or matrix 
*/
Equation.prototype.Norm = function(replacetext, pid, pos, callback)
{	var flag=0;		var norm=1;		var Sol=0;
	replacetext=replacetext.replace(/^Norm\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Norm"); flag=1; }
	if ((inputarray.length>2)||(inputarray.length==1)) { Set_Error(this.Original_id, "Norm1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var matid=CreateEq(this.fileid, 1, eqobj);
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
	var normid=CreateEq(this.fileid, 1, eqobj);
	norm=self[normid].Solution_real['0-0'];
	if ((norm!==parseInt(norm))&&(flag===0)) { Set_Error(this.Original_id, "Norm2", norm); flag=1; }
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);
		for (var index in self[matid].Solution_real)
		{	
			if (self[matid].Solution_imag[index]===undefined)
			{
				Sol=Sol+Math.pow(Math.abs(self[matid].Solution_real[index]), norm);	
			}else
			{
				Sol=Sol+Math.pow(Math.abs(Math.sqrt(Math.pow(self[matid].Solution_real[index],2)+Math.pow(self[matid].Solution_imag[index],2))), norm);	
			}
		}
		self[newid].Solution_real['0-0']=Math.pow(Sol, 1/norm);
		self[newid].Format_showequation="\\left|\\left|\\hspace{0.5em}"+self[matid].Format_showequation+"\\hspace{0.5em}\\right|\\right|_"+norm;
		self[newid].Units_base_array=self[matid].Units_base_array;
		self[newid].Units_units=self[matid].Units_units;
		self[newid].Units_quantity=self[matid].Units_quantity;
		this.Solution_temps.push(newid);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		SetModels("Norm", newid, matid, normid);
		self[pid].Solution_variable_array[pos]=newid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}else { var newid='';}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------------- COLUMN NORM CALCULATION ---------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.CSNorm = function(replacetext, pid, pos, callback)
{	var flag=0;		var sums=new Array();		var thissum=0; 
	replacetext=replacetext.replace(/^CSNorm\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "CSNorm"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "CSNorm1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var matid=CreateEq(this.fileid, 1, eqobj);
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);
		var sizes=self[matid].Format_size.split('x');
		for (var b=0; b<parseInt(sizes[1]); b++)
		{	thissum=0;
			for (var a=0; a<parseInt(sizes[0]); a++)
			{ 
				if (self[matid].Solution_imag[a+'-'+b]===undefined)
				{
					thissum=ToNum(thissum)+Math.abs(self[matid].Solution_real[a+'-'+b]);
				}else
				{
					thissum=ToNum(thissum)+Math.abs(Math.sqrt(Math.pow(self[matid].Solution_real[a+'-'+b],2)+Math.pow(self[matid].Solution_imag[a+'-'+b],2))); 
				}
			}
			sums.push(thissum);
		}
		self[newid].Solution_real['0-0']=Math.max.apply(null, sums);
		self[newid].Format_showequation="\\left|\\left|\\hspace{0.5em} "+self[matid].Format_showequation+"\\hspace{0.5em} \\right|\\right|_C";
		self[newid].Units_base_array=self[matid].Units_base_array;
		self[newid].Units_units=self[matid].Units_units;
		self[newid].Units_quantity=self[matid].Units_quantity;
		this.Solution_temps.push(newid);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		SetModels("CSNorm", newid, matid);
		self[pid].Solution_variable_array[pos]=newid;
	}else { var newid='';}
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------------- ROW NORM CALCULATION ------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.RSNorm = function(replacetext, pid, pos, callback)
{	var flag=0;		var sums=new Array();		var thissum=0; 
	replacetext=replacetext.replace(/^RSNorm\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "RSNorm"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "RSNorm1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var matid=CreateEq(this.fileid, 1, eqobj);
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);
		var sizes=self[matid].Format_size.split('x');
		for (var a=0; a<parseInt(sizes[0]); a++)
		{	thissum=0;
			for (var b=0; b<parseInt(sizes[1]); b++)
			{	
				if (self[matid].Solution_imag[a+'-'+b]===undefined)
				{
					thissum=ToNum(thissum)+Math.abs(self[matid].Solution_real[a+'-'+b]);
				}else
				{
					thissum=ToNum(thissum)+Math.abs(Math.sqrt(Math.pow(self[matid].Solution_real[a+'-'+b],2)+Math.pow(self[matid].Solution_imag[a+'-'+b],2))); 
				}
			}
			sums.push(thissum);
		}
		self[newid].Solution_real['0-0']=Math.max.apply(null, sums);
		self[newid].Format_showequation="\\left|\\left|\\hspace{0.5em} "+self[matid].Format_showequation+"\\hspace{0.5em} \\right|\\right|_R";
		self[newid].Units_base_array=self[matid].Units_base_array;
		self[newid].Units_units=self[matid].Units_units;
		self[newid].Units_quantity=self[matid].Units_quantity;
		this.Solution_temps.push(newid);
		SetModels("RSNorm", newid, matid);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		self[pid].Solution_variable_array[pos]=newid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}else { var newid='';}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------------- TRACE OF A MATRIX ---------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.Trace = function(replacetext, pid, pos, callback)
{	var flag=0;		var sum=0; 
	replacetext=replacetext.replace(/^Trace\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Trace"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "Trace1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var matid=CreateEq(this.fileid, 1, eqobj);
	var sizes=self[matid].Format_size.split('x');
	if (sizes[0]!=sizes[1]){ Set_Error(this.Original_id, "Trace2"); }
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);
		for (var a=0; a<parseInt(sizes[0]); a++)	{	sum=ToNum(sum)+self[matid].Solution_real[a+'-'+a]; }
		self[newid].Solution_real['0-0']=sum;
		self[newid].Format_showequation="Trace \\left("+self[matid].Format_showequation+"\\right)";
		self[newid].Units_base_array=self[matid].Units_base_array;
		self[newid].Units_units=self[matid].Units_units;
		self[newid].Units_quantity=self[matid].Units_quantity;
		this.Solution_temps.push(newid);
		SetModels("Trace", newid, matid);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		self[pid].Solution_variable_array[pos]=newid;
	}else { var newid='';}
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------------- COMPLEX CONJUGATE ---------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.Conj = function(replacetext, pid, pos, callback)
{	var flag=0;		var real={};	var imag={}; 
	replacetext=replacetext.replace(/^Conj\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Conj"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "Conj1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var matid=CreateEq(this.fileid, 1, eqobj);
	if (flag===0)
	{	var sizes=self[matid].Format_size.split('x');
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);
		for (var a=0; a<parseInt(sizes[0]); a++)
		{	for (var b=0; b<parseInt(sizes[0]); b++)
			{	real[a+'-'+b]=self[matid].Solution_real[a+'-'+b];
				imag[a+'-'+b]=-self[matid].Solution_imag[a+'-'+b];
			}
		}
		self[newid].Solution_real=real;
		self[newid].Solution_imag=imag;
		self[newid].Format_size=self[matid].Format_size;
		self[newid].Format_showequation="\\overline{\\left("+self[matid].Format_showequation+"\\right)}";
		self[newid].Units_base_array=self[matid].Units_base_array;
		self[newid].Units_units=self[matid].Units_units;
		self[newid].Units_quantity=self[matid].Units_quantity;
		this.Solution_temps.push(newid);
		SetModels("Conj", newid, matid);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		self[pid].Solution_variable_array[pos]=newid;
	}else { var newid='';}
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------- DOT MULTIPLICATION ----------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.DotMult = function(replacetext, pid, pos, callback)													//	|
{	var flag=0, key='', tempr={};	        																			//	| 
	replacetext=replacetext.replace(/^DotMult\(/,"");																	//	|
	replacetext=replacetext.replace(/\)$/,"");																			//	|
	var inputarray=InputArray(replacetext);																				//	|
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "DotMult"); flag=1; }							//	|
	if ((inputarray.length==1)||(inputarray.length>2)) { Set_Error(this.Original_id, "DotMult"); flag=1; }				//	|
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 		//	|
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};													//	|
	var id1=CreateEq(this.fileid, 1, eqobj);																			//	|
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 		//	|
	Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};													//	|
	var id2=CreateEq(this.fileid, 1, eqobj);																			//	|
	var sizes1=self[id1].Format_size.split('x');																		//	|
	var sizes2=self[id2].Format_size.split('x');																		//	|
	if ((sizes1[0]!=sizes2[0])||(sizes1[1]!=sizes2[1])){ Set_Error(this.Original_id, "DotMult2"); flag=1; }		        //	|
	if (flag===0)																										//	|
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 	//	|
		Original_id:this.Original_id, equation:"TempEq="+replacetext};													//	|
		var newid=CreateEq(this.fileid, 0, eqobj);																		//	|
		for (var a=0; a<sizes1[0]; a++)                                                                                 //  |
        {   for (var b=0; b<sizes1[1]; b++)                                                                             //  |
            {   key=a+'-'+b;                                                                                            //  |
                tempr=MultComplex(self[id1].Solution_real[key], self[id1].Solution_imag[key], self[id2].Solution_real[key], self[id2].Solution_imag[key]);                
                self[newid].Solution_real[key]=tempr.real;                                                              //  |
                self[newid].Solution_imag[key]=tempr.imag;                                                              //  |
            }                                                                                                           //  |
        }                                                                                                               //  |
		self[newid].Format_size=self[id1].Format_size;																	//	|
		self[newid].Format_showequation=self[id1].Format_showequation+" \\odot "+self[id2].Format_showequation;	      	//	|
		var baseunits=new Array();																						//	|
		for(var index in self[id1].Units_base_array) 																	//	|
		{ 	self[newid].Units_base_array[index]=parseInt(self[id1].Units_base_array[index])+parseInt(self[id2].Units_base_array[index]); }	
		this.Solution_temps.push(newid);																				//	|
		DOM_Object[newid]['real']=self[newid].Solution_real;															//	|
		DOM_Object[newid]['imag']=self[newid].Solution_imag;															//	|
		DOM_Object[newid]['size']=self[id1]['Format_size'];				       											//	|
		DOM_Object[newid]['units']=self[newid].Units_units;																//	|
		SetModels("DotMult", newid, id1, id2);																			//	|
		self[pid].Solution_variable_array[pos]=newid;																	//	|
	}else { var newid='';}																								//	|
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);													//	|
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);															//	|
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);													//	|
}																														//	|
//-------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------------- DOT DIVISION ----------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.DotDiv = function(replacetext, pid, pos, callback)													//	|
{	var flag=0, key='', tempr=0, tempi=0;	   																			//	| 
	replacetext=replacetext.replace(/^DotDiv\(/,"");																	//	|
	replacetext=replacetext.replace(/\)$/,"");																			//	|
	var inputarray=InputArray(replacetext);																				//	|
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "DotDiv"); flag=1; }							//	|
	if ((inputarray.length==1)||(inputarray.length>2)) { Set_Error(this.Original_id, "DotDiv"); flag=1; }				//	|
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 		//	|
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};													//	|
	var id1=CreateEq(this.fileid, 1, eqobj);																			//	|
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 		//	|
	Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};													//	|
	var id2=CreateEq(this.fileid, 1, eqobj);																			//	|
	var sizes1=self[id1].Format_size.split('x');																		//	|
	var sizes2=self[id2].Format_size.split('x');																		//	|
	if ((sizes1[0]!=sizes2[0])||(sizes1[1]!=sizes2[1])){ Set_Error(this.Original_id, "DotDiv2"); flag=1; }		        //	|
	if (flag===0)																										//	|
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 	//	|
		Original_id:this.Original_id, equation:"TempEq="+replacetext};													//	|
		var newid=CreateEq(this.fileid, 0, eqobj);																		//	|
		for (var a=0; a<sizes1[0]; a++)                                                                                 //  |
        {   for (var b=0; b<sizes1[1]; b++)                                                                             //  |
            {   key=a+'-'+b;                                                                                            //  |
                tempr=DivComplex(self[id1].Solution_real[key], self[id1].Solution_imag[key], self[id2].Solution_real[key], self[id2].Solution_imag[key]);                
                self[newid].Solution_real[key]=tempr.real;                                                              //  |
                self[newid].Solution_imag[key]=tempr.imag;                                                              //  |
            }                                                                                                           //  |
        }                                                                                                               //  |
		self[newid].Format_size=self[id1].Format_size;																	//	|
		self[newid].Format_showequation="\\frac{"+self[id1].Format_showequation+"}{"+self[id2].Format_showequation+"}"; //	|
		var baseunits=new Array();																						//	|
		for(var index in self[id1].Units_base_array) 																	//	|
		{ 	self[newid].Units_base_array[index]=parseInt(self[id1].Units_base_array[index])-parseInt(self[id2].Units_base_array[index]); }	
		this.Solution_temps.push(newid);																				//	|
		DOM_Object[newid]['real']=self[newid].Solution_real;															//	|
		DOM_Object[newid]['imag']=self[newid].Solution_imag;															//	|
		DOM_Object[newid]['size']=self[id1]['Format_size'];				       											//	|
		DOM_Object[newid]['units']=self[newid].Units_units;																//	|
		SetModels("DotMult", newid, id1, id2);																			//	|
		self[pid].Solution_variable_array[pos]=newid;																	//	|
	}else { var newid='';}																								//	|
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);													//	|
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);															//	|
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);													//	|
}																														//	|
//-------------------------------------------------------------------------------------------------------------------------//


//-------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------------- DOT PRODUCT -----------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.Dot = function(replacetext, pid, pos, callback)
{	var flag=0;	var num={};	var ranswer={};	var ianswer={};	var sumr=0;	var sumi=0;	var key='';	var dim=0; 
	replacetext=replacetext.replace(/^Dot\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Dot"); flag=1; }
	if (inputarray.length>3) { Set_Error(this.Original_id, "Dot1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
	var id2=CreateEq(this.fileid, 1, eqobj);
	if (inputarray.length==3) 
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[2]};
		var id3=CreateEq(this.fileid, 1, eqobj);
		dim=self[id3].Solution_real['0-0'];
		if ((dim!==0)&&(dim!=1)) { Set_Error(this.Original_id, "Dot3"); flag=1; }
	}
	var sizes1=self[id1].Format_size.split('x');		var sizes2=self[id2].Format_size.split('x');
	if ((sizes1[0]!=sizes2[0])||(sizes1[1]!=sizes2[1])) { Set_Error(this.Original_id, "Dot2"); flag=1; }
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);
		if (dim=="0")
		{	for (var a=0; a<sizes1[0]; a++)
			{	sumr=0; sumi=0;
				for (var b=0; b<sizes1[1]; b++)
				{	key=a+'-'+b;
					var itemp=-1*self[id1].Solution_imag[key];
					num=MultComplex(self[id1].Solution_real[key], self[id1].Solution_imag[key], self[id2].Solution_real[key], self[id2].Solution_imag[key]);
					sumr=sumr+num['real'];		sumi=sumi+num['imag'];	}
				self[newid].Solution_real[a+'-0']=sumr;
				self[newid].Solution_imag[a+'-0']=sumi;
			}
			self[newid].Format_size=(sizes1[1]-1)+'x1';
		}else if (dim=="1")
		{	for (var b=0; b<sizes1[1]; b++)
			{	sumr=0; sumi=0;
				for (var a=0; a<sizes1[0]; a++)
				{	key=a+'-'+b;
					var itemp=-1*self[id1].Solution_imag[key];
					num=MultComplex(self[id1].Solution_real[key], self[id1].Solution_imag[key], self[id2].Solution_real[key], self[id2].Solution_imag[key]);
					sumr=sumr+num['real'];		sumi=sumi+num['imag'];	}
				self[newid].Solution_real['0-'+b]=sumr;
				self[newid].Solution_imag['0-'+b]=sumi;
			}
			self[newid].Format_size='1x'+(sizes1[0]-1);
		}
		if (dim===0) 
		{	self[newid].Format_showequation="\\overrightarrow{"+self[id1].Format_showequation+" \\circ "+self[id2].Format_showequation+"}";
		}else{ 
			self[newid].Format_showequation=self[id1].Format_showequation+" \\downarrow \\circ "+self[id2].Format_showequation;	}
		var baseunits=new Array();
		for(var index in self[id1].Units_base_array) 
		{ 	self[newid].Units_base_array[index]=parseInt(self[id1].Units_base_array[index])+parseInt(self[id2].Units_base_array[index]); }
		self[newid].Recompose_Units(); 
		this.Solution_temps.push(newid);
		SetModels("Dot", newid, id1, id2);
		self[pid].Solution_variable_array[pos]=newid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
	}else { var newid='';}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//----------------------------------------------- CROSS PRODUCT -----------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.Cross = function(replacetext, pid, pos, callback)
{	var flag=0; 
	replacetext=replacetext.replace(/^Cross\(/,"");
	replacetext=replacetext.replace(/^cross\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Cross"); flag=1; }
	if ((inputarray.length==1)||(inputarray.length>2)) { Set_Error(this.Original_id, "Cross1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
	var id2=CreateEq(this.fileid, 1, eqobj);
	var sizes1=self[id1].Format_size.split('x');
	var sizes2=self[id2].Format_size.split('x');
	if ((sizes1[0]!=sizes2[0])||(sizes1[1]!=3)||(sizes1[0]!=1)){ Set_Error(this.Original_id, "Cross2"); flag=1; }
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);

		self[newid].Solution_real['0-0']=parseFloat(Big(self[id1].Solution_real['0-1']).times(Big(self[id2].Solution_real['0-2'])).minus(Big(self[id1].Solution_real['0-2']).times(Big(self[id2].Solution_real['0-1']))));
		self[newid].Solution_real['0-1']=parseFloat(Big(-1).times(Big(self[id1].Solution_real['0-0']).times(Big(self[id2].Solution_real['0-2'])).minus(Big(self[id1].Solution_real['0-2']).times(Big(self[id2].Solution_real['0-0'])))));
		self[newid].Solution_real['0-2']=parseFloat(Big(self[id1].Solution_real['0-0']).times(Big(self[id2].Solution_real['0-1'])).minus(Big(self[id1].Solution_real['0-1']).times(Big(self[id2].Solution_real['0-0']))))
		

//		self[newid].Solution_real['0-0']=self[id1].Solution_real['0-1']*self[id2].Solution_real['0-2']-self[id1].Solution_real['0-2']*self[id2].Solution_real['0-1'];
//		self[newid].Solution_real['0-1']=-(self[id1].Solution_real['0-0']*self[id2].Solution_real['0-2']-self[id1].Solution_real['0-2']*self[id2].Solution_real['0-0']);
//		self[newid].Solution_real['0-2']=self[id1].Solution_real['0-0']*self[id2].Solution_real['0-1']-self[id1].Solution_real['0-1']*self[id2].Solution_real['0-0']


		self[newid].Format_size="1x3";
		self[newid].Format_showequation="\\left("+self[id1].Format_showequation+" \\times "+self[id2].Format_showequation+"\\right)";
		var baseunits=new Array();
		for(var index in self[id1].Units_base_array) 
		{ 	self[newid].Units_base_array[index]=parseInt(self[id1].Units_base_array[index])+parseInt(self[id2].Units_base_array[index]); }
		self[newid].Recompose_Units(); 

		this.Solution_temps.push(newid);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['units']=self[newid].Units_units;
		SetModels("Cross", newid, id1, id2);
		self[pid].Solution_variable_array[pos]=newid;
	}else { var newid='';}
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------- THRESHOLD FOR MATRICES ------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.Threshold = function(replacetext, pid, pos, callback)
{	var flag=0; 
	replacetext=replacetext.replace(/^Threshold\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Threshold"); flag=1; }
	if ((inputarray.length==1)||(inputarray.length==2)||(inputarray.length>3)) 
	{ Set_Error(this.Original_id, "Threshold1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var matid=CreateEq(this.fileid, 1, eqobj);
	if (inputarray[1]=="Null") { var low="Null";
	}else { 
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
		var lowid=CreateEq(this.fileid, 1, eqobj);
		var low=self[lowid].Solution_real['0-0'];
	}
	if (inputarray[2]=="Null") { var high="Null";
	}else { 
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[2]};
		var highid=CreateEq(this.fileid, 1, eqobj);
		var high=self[highid].Solution_real['0-0'];
	}
	if ((low!="Null")&&(high!="Null")) { if (low>high) { Set_Error(this.Original_id, "Threshold2"); flag=1; }	}
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);
		for (var i in self[matid].Solution_real)
		{	if ((self[matid].Solution_real[i]!="Null")&&(self[matid].Solution_real[i]>high)) { self[newid].Solution_real[i]=high; 
			}else if ((self[matid].Solution_real[i]!="Null")&&(self[matid].Solution_real[i]<low)) { self[newid].Solution_real[i]=low;
			}else { self[newid].Solution_real[i]=self[matid].Solution_real[i]; }
		}
		self[newid].Format_size=self[matid].Format_size;
		if ((inputarray[1]=="Null")&&(inputarray[2]=="Null"))
		{	self[newid].Format_showequation="\\left("+self[matid].Format_showequation+"\\right)^{Null}_{Null}";
		}else if (inputarray[1]=="Null")
		{	self[newid].Format_showequation="\\left("+self[matid].Format_showequation+"\\right)^{"+self[highid].Format_showequation+"}_{Null}";
		}else if (inputarray[2]=="Null")
		{	self[newid].Format_showequation="\\left("+self[matid].Format_showequation+"\\right)^{Null}_{"+self[lowid].Format_showequation+"}";
		}else
		{	self[newid].Format_showequation="\\left("+self[matid].Format_showequation+"\\right)^{"+self[highid].Format_showequation+"}_{"+self[lowid].Format_showequation+"}";}
		self[newid].Units_base_array=self[matid].Units_base_array;
		self[newid].Units_units=self[matid].Units_units;
		self[newid].Units_quantity=self[matid].Units_quantity;
		this.Solution_temps.push(newid);
		SetModels("Threshold", newid, matid, lowid, highid);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		self[pid].Solution_variable_array[pos]=newid;
	}else { var newid='';}
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------------- IS THE ITEM A COLUMN -------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.isColumn = function(replacetext, pid, pos, callback)
{	var flag=0;		var answer=0; 
	replacetext=replacetext.replace(/^isColumn\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "isColumn"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "isColumn1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);
		var sizes=self[id1].Format_size.split('x');
		if ((parseInt(sizes[0])>1)&&(parseInt(sizes[1])==1)) { answer=1; }
		if (sizes.length>2) { answer=0; }
		self[newid].Solution_real['0-0']=answer;
		self[newid].Format_showequation="isColumn \\hspace{0.1em} \\left( \\hspace{0.2em}"+self[id1].Format_showequation+"\\hspace{0.2em}\\right)";	
		this.Solution_temps.push(newid);
		SetModels("isColumn", newid, id1);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		self[pid].Solution_variable_array[pos]=newid;
	}else { var newid='';}
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//---------------------------------------------- IS THE ITEM A ROW --------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.isRow = function(replacetext, pid, pos, callback)
{	var flag=0;		var answer=0; 
	replacetext=replacetext.replace(/^isRow\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "isRow"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "isRow1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);
		var sizes=self[id1].Format_size.split('x');
		if ((parseInt(sizes[0])==1)&&(parseInt(sizes[1])>1)) { answer=1; }
		if (sizes.length>2) { answer=0; }
		self[newid].Solution_real['0-0']=answer;
		self[newid].Format_showequation="isRow \\hspace{0.1em} \\left( \\hspace{0.2em}"+self[id1].Format_showequation+"\\hspace{0.2em}\\right)";	
		this.Solution_temps.push(newid);
		SetModels("isRow", newid, id1);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		self[pid].Solution_variable_array[pos]=newid;
	}else { var newid='';}
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------------- IS THE ITEM A MATRIX -------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.isMatrix = function(replacetext, pid, pos, callback)
{	var flag=0;		var answer=0; 
	replacetext=replacetext.replace(/^isMatrix\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "isMatrix"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "isMatrix1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);
		var sizes=self[id1].Format_size.split('x');
		if ((parseInt(sizes[0])>1)&&(parseInt(sizes[1])>1)) { answer=1; }
		if (sizes.length>2) { answer=0; }
		self[newid].Solution_real['0-0']=answer;
		self[newid].Format_showequation="isMatrix  \\hspace{0.1em} \\left( \\hspace{0.2em}"+self[id1].Format_showequation+"\\hspace{0.2em}\\right)";	
		this.Solution_temps.push(newid);
		SetModels("isMatrix", newid, id1);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		self[pid].Solution_variable_array[pos]=newid;
	}else { var newid='';}
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------------- NUMBER OF ARRAY ELEMENTS ---------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.NumEl = function(replacetext, pid, pos, callback)
{	var flag=0;		var answer=1; 
	replacetext=replacetext.replace(/^NumEl\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "NumEl"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "NumEl1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);
		var sizes=self[id1].Format_size.split('x');
		for (var a=0; a<sizes.length; a++) { answer=answer*sizes[a]; }
		self[newid].Solution_real['0-0']=answer;
		self[newid].Format_showequation="NumEl  \\hspace{0.1em} \\left( \\hspace{0.2em}"+self[id1].Format_showequation+"\\hspace{0.2em}\\right)";	
		this.Solution_temps.push(newid);
		SetModels("NumEl", newid, id1);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		self[pid].Solution_variable_array[pos]=newid;
	}else { var newid='';}
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------------- NUMBER OF ARRAY ELEMENTS ---------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.length = function(replacetext, pid, pos, callback)
{	var flag=0;		var answer=1; 
	replacetext=replacetext.replace(/^length\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "length"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "length1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);
		var sizes=self[id1].Format_size.split('x');
		for (var a=0; a<sizes.length; a++) { if (parseInt(sizes[a])>answer) { answer=parseInt(sizes[a]); } }
		self[newid].Solution_real['0-0']=answer;
		self[newid].Format_showequation="length  \\hspace{0.1em} \\left( \\hspace{0.2em}"+self[id1].Format_showequation+"\\hspace{0.2em}\\right)";	
		this.Solution_temps.push(newid);
		SetModels("length", newid, id1);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		self[pid].Solution_variable_array[pos]=newid;
	}else { var newid='';}
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//----------------------------------------- FLIP A MATRIX LEFT TO RIGHT ---------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.fliplr = function(replacetext, pid, pos, callback)
{	var flag=0;		var ranswer={};		var ianswer={};		var key=''; 
	replacetext=replacetext.replace(/^fliplr\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "fliplr"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "fliplr1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	var sizes=self[id1].Format_size.split('x');
	if (sizes.length>3) { Set_Error(this.Original_id, "fliplr2"); flag=1; }
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);
		for (var a=0; a<sizes[0]; a++) 
		{	 for (var b=0; b<sizes[1]; b++)
			{	key=a+'-'+parseInt(sizes[1]-b-1);
				if (self[id1].Solution_real[key]===undefined)
				{		ranswer[a+'-'+b]=self[id1].Solution_realdefault;
				}else { ranswer[a+'-'+b]=self[id1].Solution_real[key];		}
				if (self[id1].Solution_imag[key]===undefined)
				{		ianswer[a+'-'+b]=self[id1].Solution_imagdefault;
				}else { ianswer[a+'-'+b]=self[id1].Solution_imag[key];		}
		}	}
		self[newid].Solution_real=ranswer;
		self[newid].Solution_imag=ianswer;
		self[newid].Format_size=self[id1].Format_size;
		self[newid].Format_showequation="fliplr  \\hspace{0.1em} \\left( \\hspace{0.2em}"+self[id1].Format_showequation+"\\hspace{0.2em}\\right)";	
		self[newid].Units_base_array=self[id1].Units_base_array;
		self[newid].Units_units=self[id1].Units_units;
		self[newid].Units_quantity=self[id1].Units_quantity;
		this.Solution_temps.push(newid);
		SetModels("fliplr", newid, id1);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		self[pid].Solution_variable_array[pos]=newid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}else { var newid='';}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//----------------------------------------- FLIP A MATRIX UP / DOWN -------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.flipud = function(replacetext, pid, pos, callback)
{	var flag=0;		var ranswer={};		var ianswer={};		var key=''; 
	replacetext=replacetext.replace(/^flipud\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "flipud"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "flipud1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	var sizes=self[id1].Format_size.split('x');
	if (sizes.length>3) { Set_Error(this.Original_id, "flipud2"); flag=1; }
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);
		for (var a=0; a<sizes[0]; a++) 
		{	 for (var b=0; b<sizes[1]; b++)
			{	key=parseInt(sizes[0]-a-1)+'-'+b;
				if (self[id1].Solution_real[key]===undefined)
				{		ranswer[a+'-'+b]=self[id1].Solution_realdefault;
				}else{ 	ranswer[a+'-'+b]=self[id1].Solution_real[key];	}
				if (self[id1].Solution_imag[key]===undefined)
				{		ianswer[a+'-'+b]=self[id1].Solution_imagdefault;
				}else{ 	ianswer[a+'-'+b]=self[id1].Solution_imag[key];	}
		}	}
		self[newid].Solution_real=ranswer;
		self[newid].Solution_imag=ianswer;
		self[newid].Format_size=self[id1].Format_size;
		self[newid].Format_showequation="flipud  \\hspace{0.1em} \\left( \\hspace{0.2em}"+self[id1].Format_showequation+"\\hspace{0.2em}\\right)";	
		self[newid].Units_base_array=self[id1].Units_base_array;
		self[newid].Units_units=self[id1].Units_units;
		self[newid].Units_quantity=self[id1].Units_quantity;
		this.Solution_temps.push(newid);
		SetModels("flipud", newid, id1);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		self[pid].Solution_variable_array[pos]=newid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}else { var newid='';}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------- GET / SET THE DIAGONAL OF A MATRIX ----------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.diag = function(replacetext, pid, pos, callback)
{	var flag=0;		var offset=0;		var size=0;		var ranswer={};		var key='';		var ianswer={};	var num=0; 
	replacetext=replacetext.replace(/^diag\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "diag"); flag=1; }
	if (inputarray.length>2) { Set_Error(this.Original_id, "diag1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	if (inputarray.length==2) 
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
		var id2=CreateEq(this.fileid, 1, eqobj);
		offset=self[id2].Solution_real['0-0'];
		var sizes=self[id2].Format_size.split('x');
		if ((sizes[0]!="1")||(sizes[1]!="1")) 	{ Set_Error(this.Original_id, "diag4"); flag=1; }
	}
	var sizes=self[id1].Format_size.split('x');
	if (sizes.length>2) { Set_Error(this.Original_id, "diag2"); flag=1; }
	if (sizes[1]=="1") 	{ Set_Error(this.Original_id, "diag3"); flag=1; }
//	if ((inputarray.length==2)&&(sizes[0]!=sizes[1])) { Set_Error(this.Original_id, "diag5"); flag=1; }
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);
		if (sizes[0]=="1")
		{	if (parseInt(sizes[0])>parseInt(sizes[1])) 
			{	size=parseInt(sizes[0])+Math.abs(offset); }else { size=parseInt(sizes[1])+Math.abs(offset); }
				if (parseInt(offset)<0)
				{	for (var a=0; a<size; a++)
					{	for (var b=0; b<size; b++) 
						{	ranswer[a+'-'+b]=0;	ianswer[a+'-'+b]=0;
							num=parseInt(a)+parseInt(offset); key='0-'+num;
							if (a+parseInt(offset)==b) { 	ranswer[a+'-'+b]=self[id1].Solution_real[key];
															ianswer[a+'-'+b]=self[id1].Solution_imag[key]; } } } 
				}else
				{	for (var a=0; a<size; a++)
					{	for (var b=0; b<size; b++) 
						{	ranswer[a+'-'+b]=0;	ianswer[a+'-'+b]=0;
							if (a==(b-parseInt(offset))) { 	ranswer[a+'-'+b]=self[id1].Solution_real['0-'+a]; 
															ianswer[a+'-'+b]=self[id1].Solution_imag['0-'+a]; } } } }
			self[newid].Format_size=a+'x'+a;
		}else
		{	for (var a=0; a<(sizes[0]-Math.abs(offset)); a++)
			{	if (offset<0)
				{	num=parseInt(Math.abs(offset))+a; key=num+'-'+a;
					ranswer['0-'+a]=self[id1].Solution_real[key];
					ianswer['0-'+a]=self[id1].Solution_imag[key]; 	  
				}else
				{	num=parseInt(offset)+a; key=a+'-'+num;
					ranswer['0-'+a]=self[id1].Solution_real[key];
					ianswer['0-'+a]=self[id1].Solution_imag[key];  
			}	}
			num=sizes[0]-Math.abs(offset);
			self[newid].Format_size='1x'+num;
		}
		self[newid].Solution_real=ranswer;
		self[newid].Solution_imag=ianswer;
		if (inputarray.length==1){ self[newid].Format_showequation="diag  \\hspace{0.1em} \\left( \\hspace{0.2em}"+self[id1].Format_showequation+"\\hspace{0.2em}\\right)";	
		}else { self[newid].Format_showequation="diag  \\hspace{0.1em} \\left( \\hspace{0.2em}"+self[id1].Format_showequation+", "+self[id2].Format_showequation+"\\hspace{0.2em}\\right)";}
		self[newid].Units_base_array=self[id1].Units_base_array;
		self[newid].Units_units=self[id1].Units_units;
		self[newid].Units_quantity=self[id1].Units_quantity;
		this.Solution_temps.push(newid);
		SetModels("Diag", newid, id1, id2);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		self[pid].Solution_variable_array[pos]=newid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}else { var newid='';}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//--------------------------------- GET / SET THE UPPER RIGHT PORTION OF A MATRIX -----------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.matur = function(replacetext, pid, pos, callback)
{	var flag=0;		var offset=0;		var size=0;		var ranswer={};		var key='';		var ianswer={};	var num=0; 
	replacetext=replacetext.replace(/^matur\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "matur"); flag=1; }
	if (inputarray.length>2) { Set_Error(this.Original_id, "matur1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	if (inputarray.length==2) 
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
		var id2=CreateEq(this.fileid, 1, eqobj);
		offset=self[id2].Solution_real['0-0'];
		var sizes=self[id2].Format_size.split('x');
		if ((sizes[0]!="1")||(sizes[1]!="1")) 	{ Set_Error(this.Original_id, "matur2"); flag=1; }
	}
	var sizes=self[id1].Format_size.split('x');
	if (sizes.length>2) { Set_Error(this.Original_id, "matur3"); flag=1; }
	if (sizes[0]!=sizes[1]) { Set_Error(this.Original_id, "matur4"); flag=1; }
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);
		for (var a=0; a<sizes[0]; a++)
		{	for (var b=0; b<sizes[1]; b++) 
			{	ranswer[a+'-'+b]=0;	ianswer[a+'-'+b]=0;	key=a+'-'+b;
				if (b>=parseInt(a)+parseInt(offset)) { 	ranswer[key]=self[id1].Solution_real[key]; 
														ianswer[key]=self[id1].Solution_imag[key]; } } } 
		self[newid].Format_size=a+'x'+a;
		self[newid].Solution_real=ranswer;
		self[newid].Solution_imag=ianswer;
		if (inputarray.length==1){ self[newid].Format_showequation="matur  \\hspace{0.1em} \\left( \\hspace{0.2em}"+self[id1].Format_showequation+"\\hspace{0.2em}\\right)";	
		}else { self[newid].Format_showequation="matur  \\hspace{0.1em} \\left( \\hspace{0.2em}"+self[id1].Format_showequation+", "+self[id2].Format_showequation+"\\hspace{0.2em}\\right)";}
		self[newid].Units_base_array=self[id1].Units_base_array;
		self[newid].Units_units=self[id1].Units_units;
		self[newid].Units_quantity=self[id1].Units_quantity;
		this.Solution_temps.push(newid);
		SetModels("matur", newid, id1, id2);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		self[pid].Solution_variable_array[pos]=newid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}else { var newid='';}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//--------------------------------- GET / SET THE LOWER LEFT PORTION OF A MATRIX ------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.matll = function(replacetext, pid, pos, callback)
{	var flag=0;		var offset=0;		var size=0;		var ranswer={};		var key='';		var ianswer={};	var num=0; 
	replacetext=replacetext.replace(/^matll\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "matll"); flag=1; }
	if (inputarray.length>2) { Set_Error(this.Original_id, "matll1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	if (inputarray.length==2) 
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
		var id2=CreateEq(this.fileid, 1, eqobj);
		offset=self[id2].Solution_real['0-0'];
		var sizes=self[id2].Format_size.split('x');
		if ((sizes[0]!="1")||(sizes[1]!="1")) 	{ Set_Error(this.Original_id, "matll2"); flag=1; }
	}
	var sizes=self[id1].Format_size.split('x');
	if (sizes.length>2) { Set_Error(this.Original_id, "matll3"); flag=1; }
	if (sizes[0]!=sizes[1]) { Set_Error(this.Original_id, "matll4"); flag=1; }
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);
		for (var a=0; a<sizes[0]; a++)
		{	for (var b=0; b<sizes[1]; b++) 
			{	ranswer[a+'-'+b]=0;	ianswer[a+'-'+b]=0;	key=a+'-'+b;
				if (b<=parseInt(a)+parseInt(offset)) { 	ranswer[key]=self[id1].Solution_real[key]; 
														ianswer[key]=self[id1].Solution_imag[key]; } } } 
		self[newid].Format_size=a+'x'+a;
		self[newid].Solution_real=ranswer;
		self[newid].Solution_imag=ianswer;
		if (inputarray.length==1){ self[newid].Format_showequation="matll  \\hspace{0.1em} \\left( \\hspace{0.2em}"+self[id1].Format_showequation+"\\hspace{0.2em}\\right)";	
		}else { self[newid].Format_showequation="matll  \\hspace{0.1em} \\left( \\hspace{0.2em}"+self[id1].Format_showequation+", "+self[id2].Format_showequation+"\\hspace{0.2em}\\right)";}
		self[newid].Units_base_array=self[id1].Units_base_array;
		self[newid].Units_units=self[id1].Units_units;
		self[newid].Units_quantity=self[id1].Units_quantity;
		this.Solution_temps.push(newid);
		SetModels("matll", newid, id1, id2);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		self[pid].Solution_variable_array[pos]=newid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}else { var newid='';}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//------------------------------- FIND POSSIBLE ROOT BRACKETS THROUGH INCREMENTAL SEARCH ----------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.incSearch = function(replacetext, pid, pos, callback)
{	var flag=0;		 var variable="x";	var xdiff=1; var xs={};	var index=0;	var ns=50;	var oid=this.Original_id;
	replacetext=replacetext.replace(/^incSearch\(/,""); replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "incSearch"); flag=1; }
	if (inputarray.length<3) { Set_Error(this.Original_id, "incSearch1"); flag=1; }
	if (inputarray.length>5) { Set_Error(this.Original_id, "incSearch2"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
	var minid=CreateEq(this.fileid, 1, eqobj);
	var min=self[minid].Solution_real['0-0'];
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[2]};
	var maxid=CreateEq(this.fileid, 1, eqobj);
	var max=self[maxid].Solution_real['0-0'];
	if (min>max) { Set_Error(this.Original_id, "incSearch3"); flag=1; }
	if (inputarray.length>3) { 
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[3]};
		var nsid=CreateEq(this.fileid, 1, eqobj);
		var ns=self[nsid].Solution_real['0-0'];		}
	if (inputarray.length==5) { variable=inputarray[4]; }
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);
		xdiff=(max-min)/ns;
		Solve_Function(min, xdiff, max, variable, inputarray[0], newid, oid, function(){
		Find_Increments(min, xdiff, max, newid, oid, function (){}); }); 
		this.Solution_temps.push(newid);
		if (inputarray.length==3) { self[newid].Format_showequation="incSearch  \\hspace{0.1em} \\left( \\hspace{0.2em}"+inputarray[0]+", "+self[minid].Format_showequation+", "+self[maxid].Format_showequation+"\\hspace{0.2em}\\right)";	}
		if (inputarray.length==4) { self[newid].Format_showequation="incSearch  \\hspace{0.1em} \\left( \\hspace{0.2em}"+inputarray[0]+", "+self[minid].Format_showequation+", "+self[maxid].Format_showequation+", "+self[nsid].Format_showequation+"\\hspace{0.2em}\\right)";	}
		if (inputarray.length==5) { self[newid].Format_showequation="incSearch  \\hspace{0.1em} \\left( \\hspace{0.2em}"+inputarray[0]+", "+self[minid].Format_showequation+", "+self[maxid].Format_showequation+", "+self[nsid].Format_showequation+", "+variable+"\\hspace{0.2em}\\right)";	}
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		SetModels("incSearch", newid, inputarray[0], minid, maxid, nsid, variable, inputarray.length);
		self[pid].Solution_variable_array[pos]=newid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}else { var newid='';}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function Solve_Function(min, xdiff, max, variable, text, newid, oid, callback)
{	var Inputs={}; Inputs[variable]="["+min+":"+xdiff+":"+max+"]";
	var eqobj={Page_position:DOM_Object[self[oid].Format_id]['location'], Solution_Inputs:Inputs, Format_showtype:"InnerFunction", Original_id:self[oid].Original_id, equation:"NewEq="+text};
	var tempid=CreateEq(this.fileid, 1, eqobj);
	self[newid].Solution_real=self[tempid].Solution_real;
	self[newid].Format_size=self[tempid].Format_size;
	self[oid].Solution_temps.push(tempid);
	if (typeof(callback)=="function") { callback();	}
}
function Find_Increments(min, xdiff, max, newid, oid)
{	var answer={};		var count=0;
	var size=self[newid].Format_size.split('x');
	for (var a=0; a<size[1]-1; a++) 
	{	k1='0-'+a;	k2='0-'+parseInt(a+1);
		if (((self[newid].Solution_real[k1]>0)&&(self[newid].Solution_real[k2]<0))||((self[newid].Solution_real[k1]<0)&&(self[newid].Solution_real[k2]>0))) 
		{	var low=ToNum(ToNum(min)+ToNum(xdiff*a));	var high=ToNum(ToNum(min)+ToNum(xdiff*(a+1)));
			answer[count+'-0']=low;	answer[count+'-1']=high;	count++; } }
	self[newid].Solution_real=answer;
	self[newid].Format_size=count+'-2';
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------- BISECTION METHOD OF FINDING ROOTS -------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.Bisect = function(replacetext, pid, pos, callback)
{	var flag=0;	var variable="x";	var oid=this.Original_id;	var iter=0;	var es=0.001; 
	var xr=0;	var xrold=0;	var maxit=50;
	replacetext=replacetext.replace(/^Bisect\(/,""); replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Bisect"); flag=1; }
	if (inputarray.length<3) { Set_Error(this.Original_id, "Bisect1"); flag=1; }
	if (inputarray.length>5) { Set_Error(this.Original_id, "Bisect2"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
	var xlid=CreateEq(this.fileid, 1, eqobj);
	var xl=self[xlid].Solution_real['0-0'];
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[2]};
	var xuid=CreateEq(this.fileid, 1, eqobj);
	var xu=self[xuid].Solution_real['0-0'];
	xr=xu;
	if (xl>xu) { Set_Error(this.Original_id, "Bisect3"); flag=1; }
	if (inputarray.length>3) { 
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[3]};
		var esid=CreateEq(this.fileid, 1, eqobj);
		es=self[esid].Solution_real['0-0'];		}
	if (inputarray.length>4) {
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[4]};
		var itid=CreateEq(this.fileid, 1, eqobj);
		maxit=self[itid].Solution_real['0-0'];	}
	if (inputarray.length>5) {	variable=inputarray[5];	}
	var Inputs={}; Inputs[variable]="["+xl+", "+xu+"]";
	var eqobj={Page_position:DOM_Object[self[oid].Format_id]['location'], Solution_Inputs:Inputs,	 
	Format_showtype:"InnerFunction", Original_id:self[oid].Original_id, equation:"NewEq="+inputarray[0]};
	var tempid=CreateEq(this.fileid, 1, eqobj);
	if ((self[tempid].Solution_real['0-0']*self[tempid].Solution_real['0-1'])>0) 
	{ Set_Error(this.Original_id, "Bisect4"); flag=1; }
	delete self[tempid]; delete DOM_Object[tempid];
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);
		self[newid].xl=xl;	self[newid].xu=xu;	self[newid].xr=xr;			self[newid].xrold=xr;
		self[newid].es=es;	self[newid].maxit=maxit;	self[newid].iter=iter;	self[newid].tf=0;
		while (self[newid].tf===0)
		{	Solve_BFunction(inputarray[0], newid, oid, variable, function(){
			Find_BValues(newid, oid, function (){ }); }); 
		}
		self[newid].Solution_real['0-0']=self[newid].xr;
		self[newid].Solution_real['0-1']=self[newid].ea;
		self[newid].Solution_real['0-2']=self[newid].iter;
		if (inputarray.length==3) { self[newid].Format_showequation="Bisect  \\hspace{0.1em} \\left( \\hspace{0.2em}"+inputarray[0]+", "+self[xlid].Format_showequation+", "+self[xuid].Format_showequation+"\\hspace{0.2em}\\right)";	}
		if (inputarray.length==4) { self[newid].Format_showequation="Bisect  \\hspace{0.1em} \\left( \\hspace{0.2em}"+inputarray[0]+", "+self[xlid].Format_showequation+", "+self[xuid].Format_showequation+", "+self[esid].Format_showequation+"\\hspace{0.2em}\\right)";	}
		if (inputarray.length==5) { self[newid].Format_showequation="Bisect  \\hspace{0.1em} \\left( \\hspace{0.2em}"+inputarray[0]+", "+self[xlid].Format_showequation+", "+self[xuid].Format_showequation+", "+self[esid].Format_showequation+", "+self[itid].Format_showequation+"\\hspace{0.2em}\\right)";	}
		this.Solution_temps.push(newid);
		self[pid].Solution_variable_array[pos]=newid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
		SetModels("Bisect", newid, inputarray[0], xlid, xuid, esid, itid, inputarray.length);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
	}else { var newid='';}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function Solve_BFunction(text, newid, oid, variable, callback)
{	self[newid].xrold=self[newid].xr;
	if (ToNum(self[newid].xl)+ToNum(self[newid].xu)===0) { self[newid].xr=0;
	}else{	self[newid].xr=ToNum((ToNum(self[newid].xl)+ToNum(self[newid].xu))/2); }
	var Inputs={}; Inputs[variable]="["+self[newid].xl+", "+self[newid].xr+"]";
	var eqobj={Page_position:DOM_Object[self[oid].Format_id]['location'], Solution_Inputs:Inputs, 
	Format_showtype:"InnerFunction", Original_id:self[oid].Original_id, equation:"NewEq="+text};
	var tempid=CreateEq(this.fileid, 1, eqobj);
	self[newid].Solution_real=self[tempid].Solution_real;
	self[newid].Format_size=self[tempid].Format_size;
	self[oid].Solution_temps.push(tempid);
	if (typeof(callback)=="function") { callback();	}
}
function Find_BValues(newid, oid)
{	self[newid].ea=Math.abs((self[newid].xr-self[newid].xrold)/self[newid].xr)*100;
	if (((self[newid].Solution_real['0-0']<0)&&(self[newid].Solution_real['0-1']>0))||((self[newid].Solution_real['0-0']>0)&&(self[newid].Solution_real['0-1']<0)))
	{	self[newid].xu=self[newid].xr;
	}else if (self[newid].Solution_real['0-0']*self[newid].Solution_real['0-1']===0)
	{	self[newid].ea=0;
	}else { self[newid].xl=self[newid].xr; }
	self[newid].iter++;
	if ((self[newid].iter>self[newid].maxit)||(self[newid].ea<self[newid].es)) {self[newid].tf=1; } 
	delete DOM_Object[self[newid].deleteid];
	delete self[newid].deleteid;
}
//-------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------- FALSE POSITION METHOD OF FINDING ROOTS -------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.FalsePos = function(replacetext, pid, pos, callback)
{	var flag=0;	var variable="x";	var oid=this.Original_id;	var iter=0;	var es=0.001; 
	var xr=0;	var xrold=0;	var maxit=50;		var fl=0;	var fu=0;
	replacetext=replacetext.replace(/^FalsePos\(/,""); replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "FalsePos"); flag=1; }
	if (inputarray.length<3) { Set_Error(this.Original_id, "FalsePos1"); flag=1; }
	if (inputarray.length>5) { Set_Error(this.Original_id, "FalsePos2"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
	var xlid=CreateEq(this.fileid, 1, eqobj);
	var xl=self[xlid].Solution_real['0-0'];
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[2]};
	var xuid=CreateEq(this.fileid, 1, eqobj);
	var xu=self[xuid].Solution_real['0-0'];
	xr=xu;
	if (xl>xu) { Set_Error(this.Original_id, "FalsePos3"); flag=1; }
	if (inputarray.length>3) { 
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[3]};
		var esid=CreateEq(this.fileid, 1, eqobj);
		es=self[esid].Solution_real['0-0'];		}
	if (inputarray.length>4) {
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[4]};
		var itid=CreateEq(this.fileid, 1, eqobj);
		maxit=self[itid].Solution_real['0-0'];	}
	if (inputarray.length>5) {	variable=inputarray[5];	}
	var Inputs={}; Inputs[variable]="["+xl+", "+xu+"]";
	var eqobj={Page_position:DOM_Object[self[oid].Format_id]['location'], Solution_Inputs:Inputs, 
	Format_showtype:"InnerFunction", Original_id:self[oid].Original_id, equation:"NewEq="+inputarray[0]};
	var tempid=CreateEq(this.fileid, 1, eqobj);
	if ((self[tempid].Solution_real['0-0']*self[tempid].Solution_real['0-1'])>0) 
	{ Set_Error(this.Original_id, "FalsePos4"); flag=1; }
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);
		self[newid].xl=xl;	self[newid].xu=xu;	self[newid].xr=xr;			self[newid].xrold=xr;
		self[newid].es=es;	self[newid].maxit=maxit;	self[newid].iter=iter;	self[newid].tf=0;
		self[newid].Solution_real['0-0']=self[tempid].Solution_real['0-0'];
		self[newid].Solution_real['0-1']=self[tempid].Solution_real['0-1'];
		delete self[tempid]; delete DOM_Object[tempid];
		while (self[newid].tf===0)
		{	Solve_FPFunction(inputarray[0], newid, oid, variable, function(){
			Find_FPValues(newid, oid, function (){ }); }); 
		}
		self[newid].Solution_real['0-0']=self[newid].xr;
		self[newid].Solution_real['0-1']=self[newid].ea;
		self[newid].Solution_real['0-2']=self[newid].iter;
		if (inputarray.length==3) { self[newid].Format_showequation="FalsePos  \\hspace{0.1em} \\left( \\hspace{0.2em}"+inputarray[0]+", "+self[xlid].Format_showequation+", "+self[xuid].Format_showequation+"\\hspace{0.2em}\\right)";	}
		if (inputarray.length==4) { self[newid].Format_showequation="FalsePos  \\hspace{0.1em} \\left( \\hspace{0.2em}"+inputarray[0]+", "+self[xlid].Format_showequation+", "+self[xuid].Format_showequation+", "+self[esid].Format_showequation+"\\hspace{0.2em}\\right)";	}
		if (inputarray.length==5) { self[newid].Format_showequation="FalsePos  \\hspace{0.1em} \\left( \\hspace{0.2em}"+inputarray[0]+", "+self[xlid].Format_showequation+", "+self[xuid].Format_showequation+", "+self[esid].Format_showequation+", "+self[itid].Format_showequation+"\\hspace{0.2em}\\right)";	}
		this.Solution_temps.push(newid);
		SetModels("FalsePos", newid, inputarray[0], xlid, xuid, esid, itid, inputarray.length);
		self[pid].Solution_variable_array[pos]=newid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
	}else { var newid='';}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function Solve_FPFunction(text, newid, oid, variable, callback)
{	fl=ToNum(self[newid].Solution_real['0-0']);	fu=ToNum(self[newid].Solution_real['0-1']);
	var sub=self[newid].xl-self[newid].xu;
	self[newid].xrold=self[newid].xr;
	if (ToNum(self[newid].xl)-ToNum(self[newid].xu)===0) { self[newid].xr=0;
	}else{	self[newid].xr=ToNum(self[newid].xu)-(ToNum(fu)*sub)/ToNum(fl-fu);}
	var Inputs={}; Inputs[variable]="["+self[newid].xl+", "+self[newid].xr+"]";
	var eqobj={Page_position:DOM_Object[self[oid].Format_id]['location'], Solution_Inputs:Inputs, 
	Format_showtype:"InnerFunction", Original_id:self[oid].Original_id, equation:"NewEq="+text};
	var tempid=CreateEq(this.fileid, 1, eqobj);
	self[newid].Solution_real=self[tempid].Solution_real;
	self[newid].Format_size=self[tempid].Format_size;
	self[oid].Solution_temps.push(tempid);
	if (typeof(callback)=="function") { callback();	}
}
function Find_FPValues(newid, oid)
{	self[newid].ea=Math.abs((self[newid].xr-self[newid].xrold)/self[newid].xr)*100;
	if (((self[newid].Solution_real['0-0']<0)&&(self[newid].Solution_real['0-1']>0))||((self[newid].Solution_real['0-0']>0)&&(self[newid].Solution_real['0-1']<0)))
	{	self[newid].xu=self[newid].xr;
	}else if (self[newid].Solution_real['0-0']*self[newid].Solution_real['0-1']===0)
	{	self[newid].ea=0;
	}else { self[newid].xl=self[newid].xr; }
	self[newid].iter++;
	if ((self[newid].iter>self[newid].maxit)||(self[newid].ea<self[newid].es)) {self[newid].tf=1; } 
	delete DOM_Object[self[newid].deleteid];
	delete self[newid].deleteid;
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//---------------------------------------- SECANT METHOD OF FINDING ROOTS -------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.Secant = function(replacetext, pid, pos, callback)
{	var flag=0;	var variable="x";	var oid=this.Original_id;	var iter=0;	var es=0.0001; 
	var xr=0;	var xrold=0;	var maxit=50;		var fl=0;	var fu=0;
	replacetext=replacetext.replace(/^Secant\(/,""); replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Secant"); flag=1; }
	if (inputarray.length<3) { Set_Error(this.Original_id, "Secant1"); flag=1; }
	if (inputarray.length>5) { Set_Error(this.Original_id, "Secant2"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
	var x1id=CreateEq(this.fileid, 1, eqobj);
	var x1=self[x1id].Solution_real['0-0'];
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[2]};
	var x2id=CreateEq(this.fileid, 1, eqobj);
	var x2=self[x2id].Solution_real['0-0'];
	if (inputarray.length>3) { 
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[3]};
		var esid=CreateEq(this.fileid, 1, eqobj);
		es=self[esid].Solution_real['0-0'];		}
	if (inputarray.length>4) {
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[4]};
		var itid=CreateEq(this.fileid, 1, eqobj);
		maxit=self[itid].Solution_real['0-0'];	}
	if (inputarray.length>5) {	variable=inputarray[5];	}
	var Inputs={}; Inputs[variable]=x1;
	var eqobj={Page_position:DOM_Object[self[oid].Format_id]['location'], Solution_Inputs:Inputs,	 
	Format_showtype:"InnerFunction", Original_id:self[oid].Original_id, equation:"NewEq="+inputarray[0]};
	var tempid1=CreateEq(this.fileid, 1, eqobj);
	var y1=self[tempid1].Solution_real['0-0'];
	this.Solution_temps.push(tempid1);
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);
		self[newid].x1=x1;	self[newid].x2=x2;		self[newid].y1=y1;
		self[newid].es=es;	self[newid].maxit=maxit;	self[newid].iter=iter;	self[newid].tf=0;
		while (self[newid].tf===0)
		{	Solve_SFunction(inputarray[0], newid, oid, variable, function(){
			Find_SValues(newid, oid, function (){ }); }); 
		}
		self[newid].Solution_real['0-0']=self[newid].x2;
		self[newid].Solution_real['0-1']=self[newid].ea;
		self[newid].Solution_real['0-2']=self[newid].iter;
		if (inputarray.length==3) { self[newid].Format_showequation="Secant  \\hspace{0.1em} \\left( \\hspace{0.2em}"+self[tempid1].Format_showequation+", "+self[x1id].Format_showequation+", "+self[x2id].Format_showequation+"\\hspace{0.2em}\\right)";	}
		if (inputarray.length==4) { self[newid].Format_showequation="Secant  \\hspace{0.1em} \\left( \\hspace{0.2em}"+self[tempid1].Format_showequation+", "+self[x1id].Format_showequation+", "+self[x2id].Format_showequation+", "+self[esid].Format_showequation+"\\hspace{0.2em}\\right)";	}
		if (inputarray.length==5) { self[newid].Format_showequation="Secant  \\hspace{0.1em} \\left( \\hspace{0.2em}"+self[tempid1].Format_showequation+", "+self[x1id].Format_showequation+", "+self[x2id].Format_showequation+", "+self[esid].Format_showequation+", "+self[itid].Format_showequation+"\\hspace{0.2em}\\right)";	}
		SetModels("Secant", newid, inputarray[0], x1id, x2id, esid, itid, inputarray.length);
		this.Solution_temps.push(newid);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		self[pid].Solution_variable_array[pos]=newid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}else { var newid='';}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
function Solve_SFunction(text, newid, oid, variable, callback)
{	var Inputs={}; Inputs[variable]=self[newid].x2;
	var eqobj={Page_position:DOM_Object[self[oid].Format_id]['location'], Solution_Inputs:Inputs, 
	Format_showtype:"InnerFunction", Original_id:self[oid].Original_id, equation:"NewEq="+text};
	var tempid=CreateEq(this.fileid, 1, eqobj);
	self[newid].y2=JSON.parse(JSON.stringify(self[tempid].Solution_real['0-0']));
	self[oid].Solution_temps.push(tempid);
	if (typeof(callback)=="function") { callback();	}
}
function Find_SValues(newid, oid)
{	var top=self[newid].y2*(self[newid].x1-self[newid].x2);
	var bot=self[newid].y1-self[newid].y2;
	var temp=self[newid].x2-ToNum(top/bot);
	self[newid].x1=JSON.parse(JSON.stringify(self[newid].x2));
	self[newid].x2=temp;
	self[newid].y1=JSON.parse(JSON.stringify(self[newid].y2));
	self[newid].ea=Math.abs(self[newid].x1-self[newid].x2);
	self[newid].iter++;
	if ((self[newid].iter>self[newid].maxit)||(self[newid].ea<self[newid].es)) {self[newid].tf=1; } 
	delete DOM_Object[self[newid].deleteid];
	delete self[newid].deleteid;
}
//-------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------- FIND THE FFT OF A DATASET ---------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.FFT = function(replacetext, pid, pos, callback)
{ var fileid=this.fileid, signal=[], a=0; 
  var flag=0; 
  replacetext=replacetext.replace(/^FFT\(/,"");
  replacetext=replacetext.replace(/\)$/,"");
  var inputarray=InputArray(replacetext);
  if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "FFT"); flag=1; }
  if (inputarray.length>2) { Set_Error(this.Original_id, "FFT2"); flag=1; }
  var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
  Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
  var dataid=CreateEq(this.fileid, 1, eqobj);
  var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
  Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
  var srid=CreateEq(this.fileid, 1, eqobj);
  var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
  Original_id:this.Original_id, equation:"FFTEq=0"};
  var retid=CreateEq(this.fileid, 1, eqobj);
  if (flag===0)
  { var Num=Object.keys(self[dataid].Solution_real).length;
    var twopow=Math.pow(2,Math.ceil(Math.log2(Num)));
    for (a=Num; a<twopow; a++) {self[dataid].Solution_real['0-'+a]=0; self[dataid].Solution_imag['0-'+a]=0; }
    var fft = new FFT(twopow, self[srid]['Solution_real']['0-0']);
    for (a=0; a<Object.keys(self[dataid]['Solution_real']).length; a++)
    { signal.push(self[dataid]['Solution_real']['0-'+a]); }
    fft.forward(signal);
    spectrum = fft.spectrum;
    for (var a=0; a<twopow/2; a++) {self[retid].Solution_real['0-'+a]=spectrum[a]; }
    self[retid].Format_size="1x"+parseInt(a);
    self[retid].Format_showequation="FFT  \\left( \\hspace{0.2em}"+self[dataid].Format_showequation+", "+self[srid].Format_showequation+"\\hspace{0.2em}\\right)";  
    SetModels("FFT", retid, dataid);
    self[pid].Solution_variable_array[pos]=retid;
    self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
    self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
    self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
    SetModels("FFT", retid, dataid, srid);
  }else 
  { self[pid].Solution_variable_array[pos]=retid;
    self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
    self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
    self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
  }
}
//-------------------------------------------------------------------------------------------------------------------------//

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------------------ FUNCTIONS FOR THE FFT ALGORITHM ------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*
	This class was taken from a github account here: https://github.com/corbanbrook/dsp.js/. The functions show good agreement with the fourier transform.
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
// Fourier Transform Module used by DFT, FFT, RFFT
function FourierTransform(bufferSize, sampleRate) {
  this.bufferSize = bufferSize;
  this.sampleRate = sampleRate;
  this.bandwidth  = 2 / bufferSize * sampleRate / 2;

  this.spectrum   = new Float32Array(bufferSize/2);
  this.real       = new Float32Array(bufferSize);
  this.imag       = new Float32Array(bufferSize);

  this.peakBand   = 0;
  this.peak       = 0;

  /**
   * Calculates the *middle* frequency of an FFT band.
   *
   * @param {Number} index The index of the FFT band.
   *
   * @returns The middle frequency in Hz.
   */
  this.getBandFrequency = function(index) {
    return this.bandwidth * index + this.bandwidth / 2;
  };

  this.calculateSpectrum = function() {
    var spectrum  = this.spectrum,
        real      = this.real,
        imag      = this.imag,
        bSi       = 2 / this.bufferSize,
        sqrt      = Math.sqrt,
        rval, 
        ival,
        mag;

    for (var i = 0, N = bufferSize/2; i < N; i++) {
      rval = real[i];
      ival = imag[i];
      mag = bSi * sqrt(rval * rval + ival * ival);

      if (mag > this.peak) {
        this.peakBand = i;
        this.peak = mag;
      }

      spectrum[i] = mag;
    }
  };
}


/**
 * FFT is a class for calculating the Discrete Fourier Transform of a signal
 * with the Fast Fourier Transform algorithm.
 *
 * @param {Number} bufferSize The size of the sample buffer to be computed. Must be power of 2
 * @param {Number} sampleRate The sampleRate of the buffer (eg. 44100)
 *
 * @constructor
 */
function FFT(bufferSize, sampleRate) {
  FourierTransform.call(this, bufferSize, sampleRate);
   
  this.reverseTable = new Uint32Array(bufferSize);

  var limit = 1;
  var bit = bufferSize >> 1;

  var i;

  while (limit < bufferSize) {
    for (i = 0; i < limit; i++) {
      this.reverseTable[i + limit] = this.reverseTable[i] + bit;
    }

    limit = limit << 1;
    bit = bit >> 1;
  }

  this.sinTable = new Float32Array(bufferSize);
  this.cosTable = new Float32Array(bufferSize);

  for (i = 0; i < bufferSize; i++) {
    this.sinTable[i] = Math.sin(-Math.PI/i);
    this.cosTable[i] = Math.cos(-Math.PI/i);
  }
}

/**
 * Performs a forward transform on the sample buffer.
 * Converts a time domain signal to frequency domain spectra.
 *
 * @param {Array} buffer The sample buffer. Buffer Length must be power of 2
 *
 * @returns The frequency spectrum array
 */
FFT.prototype.forward = function(buffer) {
  // Locally scope variables for speed up
  var bufferSize      = this.bufferSize,
      cosTable        = this.cosTable,
      sinTable        = this.sinTable,
      reverseTable    = this.reverseTable,
      real            = this.real,
      imag            = this.imag,
      spectrum        = this.spectrum;

  var k = Math.floor(Math.log(bufferSize) / Math.LN2);

  if (Math.pow(2, k) !== bufferSize) { throw "Invalid buffer size, must be a power of 2."; }
  if (bufferSize !== buffer.length)  { throw "Supplied buffer is not the same size as defined FFT. FFT Size: " + bufferSize + " Buffer Size: " + buffer.length; }

  var halfSize = 1,
      phaseShiftStepReal,
      phaseShiftStepImag,
      currentPhaseShiftReal,
      currentPhaseShiftImag,
      off,
      tr,
      ti,
      tmpReal,
      i;

  for (i = 0; i < bufferSize; i++) {
    real[i] = buffer[reverseTable[i]];
    imag[i] = 0;
  }

  while (halfSize < bufferSize) {
    //phaseShiftStepReal = Math.cos(-Math.PI/halfSize);
    //phaseShiftStepImag = Math.sin(-Math.PI/halfSize);
    phaseShiftStepReal = cosTable[halfSize];
    phaseShiftStepImag = sinTable[halfSize];
    
    currentPhaseShiftReal = 1;
    currentPhaseShiftImag = 0;

    for (var fftStep = 0; fftStep < halfSize; fftStep++) {
      i = fftStep;

      while (i < bufferSize) {
        off = i + halfSize;
        tr = (currentPhaseShiftReal * real[off]) - (currentPhaseShiftImag * imag[off]);
        ti = (currentPhaseShiftReal * imag[off]) + (currentPhaseShiftImag * real[off]);

        real[off] = real[i] - tr;
        imag[off] = imag[i] - ti;
        real[i] += tr;
        imag[i] += ti;

        i += halfSize << 1;
      }

      tmpReal = currentPhaseShiftReal;
      currentPhaseShiftReal = (tmpReal * phaseShiftStepReal) - (currentPhaseShiftImag * phaseShiftStepImag);
      currentPhaseShiftImag = (tmpReal * phaseShiftStepImag) + (currentPhaseShiftImag * phaseShiftStepReal);
    }

    halfSize = halfSize << 1;
  }

  return this.calculateSpectrum();
};


//-------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------- FIND THE FOURIER TRANSFORM OF A DATASET -----------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.Fourier = function(replacetext, pid, pos, callback)
{	var flag=0; 
	replacetext=replacetext.replace(/^Fourier\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Fourier"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var dataid=CreateEq(this.fileid, 1, eqobj);
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq=0"};
	var retid=CreateEq(this.fileid, 0, eqobj);
	if (inputarray.length>1) 	{	Set_Error(this.Original_id, "Fourier"); flag=1; }
	if (flag===0)
	{	var Num=Object.keys(self[dataid].Solution_real).length;
		for (var a=0; a<Num; a++)
		{	var real=0; var imag=0;
			for (var b=0; b<Num; b++)
			{	real=real+self[dataid].Solution_real['0-'+b]*Math.cos(-2*Math.PI*a*b/Num);
				imag=imag+self[dataid].Solution_real['0-'+b]*Math.sin(-2*Math.PI*a*b/Num);
			}
			self[retid].Solution_real['0-'+a]=real;		self[retid].Solution_imag['0-'+a]=imag;
		}
		self[retid].Format_size='1-'+Object.keys(self[retid].Solution_real).length;
		self[retid].Units_units='';
		self[retid].Units_quantity='';
		this.Solution_temps.push(retid);
		self[retid].Format_showequation="Fourier  \\left( \\hspace{0.2em}"+self[dataid].Format_showequation+"\\hspace{0.2em}\\right)";	
		DOM_Object[retid]['real']=self[retid].Solution_real;
		DOM_Object[retid]['size']=self[retid]['Format_size'];
		DOM_Object[retid]['imag']['0-0']=0;
		DOM_Object[retid]['units']=self[retid].Units_units;
		SetModels("Fourier", retid, dataid);
		self[pid].Solution_variable_array[pos]=retid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
//----------------------------------- DUPLICATE A ROW INTO A MATRIX OF SPECIFIED SIZE -------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.Row2Mat = function(replacetext, pid, pos, callback)
{	var flag=0;		var key1='';	var key2=''; 
	replacetext=replacetext.replace(/^Row2Mat\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Row2Mat"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	var Cols=Object.keys(self[id1].Solution_real).length;
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
	var id2=CreateEq(this.fileid, 1, eqobj);
	var Rows=self[id2].Solution_real['0-0'];
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq=0"};
	var retid=CreateEq(this.fileid, 0, eqobj);
	if ((inputarray.length>0)&&(inputarray.length<2)) 	{	Set_Error(this.Original_id, "Row2Mat1"); flag=1; }
	if (inputarray.length>2) 	{	Set_Error(this.Original_id, "Row2Mat2"); flag=1; }
	var size=self[id1].Format_size.split('x');
	if (size[0]!='1') 	{	Set_Error(this.Original_id, "Row2Mat3"); flag=1; }
	if (flag===0)
	{	for (var a=0; a<Rows; a++)
		{	for (var b=0; b<Cols; b++)
			{	key1=a+'-'+b;		key2='0-'+b;
				self[retid].Solution_real[key1]=self[id1].Solution_real[key2];
			}
		}
		self[retid].Format_size=Rows+'-'+Cols;
		self[retid].Units_units=self[id1].Units_units;
		self[retid].Units_quantity=self[id1].Units_quantity;
		this.Solution_temps.push(retid);
		self[retid].Format_showequation="Row2Mat  \\left( \\hspace{0.2em}"+self[id1].Format_showequation+", "+self[id2].Format_showequation+"\\hspace{0.2em}\\right)";	
		SetModels("Row2Mat", retid, id1, id2);
		DOM_Object[retid]['real']=self[retid].Solution_real;
		DOM_Object[retid]['size']=self[retid]['Format_size'];
		DOM_Object[retid]['imag']['0-0']=0;
		DOM_Object[retid]['units']=self[retid].Units_units;
		self[pid].Solution_variable_array[pos]=retid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//----------------------------------- DUPLICATE A COLUMN INTO A MATRIX OF SPECIFIED SIZE ----------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.Col2Mat = function(replacetext, pid, pos, callback)
{	var flag=0;		var key1='';	var key2=''; 
	replacetext=replacetext.replace(/^Col2Mat\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Col2Mat"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	var Cols=Object.keys(self[id1].Solution_real).length;
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
	var id2=CreateEq(this.fileid, 1, eqobj);
	var Rows=self[id2].Solution_real['0-0'];
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq=0"};
	var retid=CreateEq(this.fileid, 0, eqobj);
	if ((inputarray.length>0)&&(inputarray.length<2)) 	{	Set_Error(this.Original_id, "Col2Mat1"); flag=1; }
	if (inputarray.length>2) 	{	Set_Error(this.Original_id, "Col2Mat2"); flag=1; }
	var size=self[id1].Format_size.split('x');
	if (size[1]!='1') 	{	Set_Error(this.Original_id, "Col2Mat3"); flag=1; }
	if (flag===0)
	{	for (var a=0; a<Rows; a++)
		{	for (var b=0; b<Cols; b++)
			{	key1=b+'-'+a;		key2=b+'-0';
				self[retid].Solution_real[key1]=self[id1].Solution_real[key2];
			}
		}
		self[retid].Format_size=Rows+'-'+Cols;
		self[retid].Units_units=self[id1].Units_units;
		self[retid].Units_quantity=self[id1].Units_quantity;
		this.Solution_temps.push(retid);
		self[retid].Format_showequation="Col2Mat  \\left( \\hspace{0.2em}"+self[id1].Format_showequation+", "+self[id2].Format_showequation+"\\hspace{0.2em}\\right)";	
		SetModels("Col2Mat", retid, id1, id2);
		DOM_Object[retid]['real']=self[retid].Solution_real;
		DOM_Object[retid]['size']=self[retid]['Format_size'];
		DOM_Object[retid]['imag']['0-0']=0;
		DOM_Object[retid]['units']=self[retid].Units_units;
		self[pid].Solution_variable_array[pos]=retid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
/*
This is the function that solves simple ODEs. It is a straight Runge-Kutta 4 with no step size adjustment or stiffness.
The code takes in three inputs: a vector X for the steps, a single input representing the initial value of "y" and the 
function being integrated.
*/
Equation.prototype.ODE4 = function(replacetext, pid, pos, callback)
{	var flag=0, key1='', key2='', key3='', key4='', key5='', key6='', mult=1;
	var yshowtext='\\begin{bmatrix} ';		var showtext='\\begin{bmatrix} ';
	replacetext=replacetext.replace(/^ODE4\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "ODE4"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"xid="+inputarray[0]};
	var xid=CreateEq(this.fileid, 1, eqobj);
	var ytext=inputarray[2];
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"newyid=0"};
	var newyid=CreateEq(this.fileid, 0, eqobj);
	if (inputarray.length<3) 	{	Set_Error(this.Original_id, "ODE41"); flag=1; }
	if (inputarray.length>3) 	{	Set_Error(this.Original_id, "ODE41"); flag=1; }
	ODE={};			ODE.k1={};		ODE.k2={};		ODE.k3={};				ODE.k4={};
	ODE.phi={};		ODE.x=xid;		ODE.y=newyid;	ODE.yval=new Array();	ODE.yt=inputarray[2];
	ODE.yraw=inputarray[1];		ODE.raw=inputarray[2];						ODE.yshow={};		ODE.show={};
	ODE.fileid=this.fileid;		ODE.loc=DOM_Object[this.Format_id]['location'];		ODE.oid=this.Original_id;
	ODE.newtext='';		ODE.yunits={};
	if (flag==0)
	{	var regexp=new RegExp("^[\[]");	ODE.yraw=ODE.yraw.replace(regexp,''); ODE.raw=ODE.raw.replace(regexp,'');
		var regexp=new RegExp("\]$");	ODE.yraw=ODE.yraw.replace(regexp,''); ODE.raw=ODE.raw.replace(regexp,'');
		ODE.ytext=new Array();	ODE.text=new Array();
		ODE.ytext=InputArray(ODE.yraw);		ODE.text=InputArray(ODE.raw);	ODE.stext=new Array();
		ODE.showtext='\\begin{bmatrix} ';	ODE.rt={};
		if (ODE.text.length!=ODE.ytext.length) 	{	Set_Error(this.Original_id, "ODE42"); flag=1; }	
		if (flag===0)	{	for (var a=0; a<Object.keys(self[xid].Solution_real).length-1; a++) 
		{	if (a===0) { Solve_ODE4(a, 0, 1, 0); }else { Solve_ODE4(a, 0, 0, 0); } } }
		this.Solution_temps.push(xid);		this.Solution_temps.push(newyid);
		for (var a=0; a<Object.keys(ODE.yshow).length; a++) { yshowtext=yshowtext+''+ODE.yshow[a]+'\\\\'; }
		yshowtext=yshowtext+' \\end{bmatrix}';
		self[newyid].Format_showequation="ODE4  \\left( \\hspace{0.2em}"+self[xid].Format_showequation+", "+yshowtext+", "+ODE.newtext+"\\hspace{0.2em}\\right)";	
//		SetModels("ODE4", newyid, xid, ODE.y0id, );
		DOM_Object[newyid]['real']=self[newyid].Solution_real;
		DOM_Object[newyid]['size']=self[newyid]['Format_size'];
		DOM_Object[newyid]['imag']['0-0']=0;
		DOM_Object[newyid]['units']=self[newyid].Units_units;
		self[pid].Solution_variable_array[pos]=newyid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
/*
This is step 1 and it happens for each x. The separated text is stepped through and if the text matches "x" or with 
any "y" which is y0, y1, y2, etc then it is replaced with that current value.
This equation is then solved and the Solve_ODE function is recalled with an incremented ypos. At the beginning of the 
if statement, if the ypos is being solved then it is stored.
*/
function Solve_ODE4(xpos, kpos, init, ypos)
{	
	console.log('In the solve ODE4 function with xpos, kpos, and ypos of '+xpos+' - '+kpos+' - '+ypos)

	if (init==1)
	{	for (var b=0; b<ODE.text.length; b++) { ODE.stext[b]=SplitText(ODE.text[b]); }
		var b=0;
		while (b<ODE.text.length)
		{	var eqobj={Page_position:parseInt(ODE.loc),						 
			Format_showtype:"InnerFunction", Original_id:ODE.oid, equation:"ThisEq="+ODE.ytext[b]}; 
			console.log('--- 1. About to solve '+ODE.ytext[b])
			var y0id=CreateEq(ODE.fileid, 1, eqobj);
			ODE.yval[b]=self[y0id].Solution_real['0-0'];	ODE.yunits[b]=self[y0id].Units_units;
			self[ODE.y].Solution_real[b+'-0']=self[y0id].Solution_real['0-0'];
			ODE.yshow[b]=self[y0id].Format_showequation;
			ODE.y0id=y0id;
			ODE.y0nummodel=self[y0id].Models_numerical;
			ODE.y0unitmodel=self[y0id].Models_units;
			ODE.y0dimmodel=self[y0id].Models_dimensions;
			ODE.y0quanmodel=self[y0id].Models_quantities;
			self[ODE.oid].Solution_temps.push(y0id);	b++;	}
	}
	if (kpos===0)
	{	if (ypos===0)
		{	ODE.xval=self[ODE.x].Solution_real['0-'+xpos];
			var val1=self[ODE.x].Solution_real['0-'+xpos];
			var val2=self[ODE.x].Solution_real['0-'+parseInt(parseInt(xpos)+1)];
			ODE.xval2=parseFloat(Big(val2).minus(Big(val1)).div(Big(2)));
			ODE.xval3=val2;
			ODE.xdist=parseFloat(Big(val2).minus(Big(val1)));
		}
		if (ypos<ODE.text.length)
		{	if (ypos>0) 
			{ 	var ytemp=ypos-1;
				ODE.k1[ytemp]={}; 
				ODE.k1[ytemp]['slope']=self[ODE.tempid].Solution_real['0-0'];  
				ODE.k1[ytemp]['y']=parseFloat(Big(ODE.yval[ytemp]).plus(Big(ODE.k1[ytemp]['slope']).times(Big(ODE.xval2)))); }
			ODE.ytext='';
			for (var index=0; index<ODE['stext'][ypos].length; index++)
			{	var flag=0;
				for (var c=0; c<ODE.yval.length; c++)
				{	var ytemp="y"+c;
					if 	(ODE.stext[ypos][index]==ytemp){ ODE.ytext=ODE.ytext+''+ODE.yval[c]+' '+ODE.yunits[c]; flag=1; }
				}
				if 	(ODE.stext[ypos][index]=='x') 	{ ODE.ytext=ODE.ytext+''+ODE.xval; 	flag=1;	}
				if 	(flag===0) 	{ ODE.ytext=ODE.ytext+''+ODE['stext'][ypos][index];	}
			}
			var eqobj={Page_position:parseInt(ODE.loc), Format_showtype:"InnerFunction", 
			Original_id:ODE.oid, equation:"Temp1="+ODE.ytext};
			var tempid=CreateEq(ODE.fileid, 0, eqobj);
			ODE.tempid=tempid;
			self[ODE.oid].Solution_temps.push(tempid);
			console.log('--- 2. About to solve '+ODE.ytext)
			eqPromise(tempid).then( Solve_ODE4(xpos, 0, 0, ++ypos) );
		}else 
		{ 	var ytemp=ypos-1;
			ODE.k1[ytemp]={}; 
			ODE.k1[ytemp]['slope']=self[ODE.tempid].Solution_real['0-0'];  
			ODE.k1[ytemp]['y']=parseFloat(Big(ODE.yval[ytemp]).plus(Big(ODE.k1[ytemp]['slope']).times(Big(ODE.xval2))));
			Solve_ODE4(xpos, 1, 0, 0); 
		}
	}
	if (kpos==1)
	{	if (ypos<ODE.text.length) 
		{	if (ypos>0) 
			{ 	var ytemp=ypos-1;
				ODE.k2[ytemp]={}; 
				ODE.k2[ytemp]['slope']=self[ODE.tempid].Solution_real['0-0'];  
				ODE.k2[ytemp]['y']=parseFloat(Big(ODE.yval[ytemp]).plus(Big(ODE.k2[ytemp]['slope']).times(Big(ODE.xval2)))); }
			ODE.ytext='';
			for (var index=0; index<ODE['stext'][ypos].length; index++)
			{	var flag=0;
				for (var c=0; c<ODE.yval.length; c++)
				{	var ytemp="y"+c;
					if 	(ODE.stext[ypos][index]==ytemp){ODE.ytext=ODE.ytext+''+ODE.k1[c]['y']+' '+ODE.yunits[c];flag=1;}
				}
				if 	(ODE.stext[ypos][index]=='x') 	{ ODE.ytext=ODE.ytext+''+parseFloat(ODE.xval+ODE.xval2); flag=1; }
				if 	(flag===0) 	{ ODE.ytext=ODE.ytext+''+ODE['stext'][ypos][index];	}
			}
			var eqobj={Page_position:parseInt(ODE.loc), Format_showtype:"InnerFunction", 
			Original_id:ODE.oid, equation:"Temp2="+ODE.ytext};
			var tempid=CreateEq(ODE.fileid, 0, eqobj);
			ODE.tempid=tempid;
			self[ODE.oid].Solution_temps.push(tempid);
			console.log('--- 3. About to solve '+ODE.ytext)
			eqPromise(tempid).then( Solve_ODE4(xpos, 1, 0, ++ypos) );
		}else
		{ 	var ytemp=ypos-1;
			ODE.k2[ytemp]={}; 
			ODE.k2[ytemp]['slope']=self[ODE.tempid].Solution_real['0-0'];  
			ODE.k2[ytemp]['y']=parseFloat(Big(ODE.yval[ytemp]).plus(Big(ODE.k2[ytemp]['slope']).times(Big(ODE.xval2))));
			Solve_ODE4(xpos, 2, 0, 0); 
		}
	}
	if (kpos==2)
	{	if (ypos<ODE.text.length) 
		{	if (ypos>0) 
			{ 	var ytemp=ypos-1;
				ODE.k3[ytemp]={}; 
				ODE.k3[ytemp]['slope']=self[ODE.tempid].Solution_real['0-0'];  
				ODE.k3[ytemp]['y']=parseFloat(Big(ODE.yval[ytemp]).plus(Big(ODE.k3[ytemp]['slope']).times(Big(ODE.xdist)))); }
			ODE.ytext='';
			for (var index=0; index<ODE['stext'][ypos].length; index++)
			{	var flag=0;
				for (var c=0; c<ODE.yval.length; c++)
				{	var ytemp="y"+c;
					if 	(ODE.stext[ypos][index]==ytemp){ ODE.ytext=ODE.ytext+''+ODE.k2[c]['y']+' '+ODE.yunits[c];flag=1;}
				}
				if 	(ODE.stext[ypos][index]=='x') 	{ ODE.ytext=ODE.ytext+''+parseFloat(ODE.xval+ODE.xval2); flag=1; }
				if 	(flag===0) 	{ ODE.ytext=ODE.ytext+''+ODE['stext'][ypos][index];	}
			}
			var eqobj={Page_position:parseInt(ODE.loc), Format_showtype:"InnerFunction", 
			Original_id:ODE.oid, equation:"Temp3="+ODE.ytext};
			var tempid=CreateEq(ODE.fileid, 0, eqobj);
			ODE.tempid=tempid;
			self[ODE.oid].Solution_temps.push(tempid);
			console.log('--- 4. About to solve '+ODE.ytext)
			eqPromise(tempid).then( Solve_ODE4(xpos, 2, 0, ++ypos) );
		}else
		{ 	var ytemp=ypos-1;
			ODE.k3[ytemp]={}; 
			ODE.k3[ytemp]['slope']=self[ODE.tempid].Solution_real['0-0'];  
			ODE.k3[ytemp]['y']=parseFloat(Big(ODE.yval[ytemp]).plus(Big(ODE.k3[ytemp]['slope']).times(Big(ODE.xdist))));
			Solve_ODE4(xpos, 3, 0, 0); 
		}
	}
	if (kpos==3)
	{	if (ypos<ODE.text.length) 
		{	if (ypos>0) 
			{ 	var ytemp=ypos-1;
				ODE.k4[ytemp]={}; 
				ODE.k4[ytemp]['slope']=self[ODE.tempid].Solution_real['0-0'];  
				if (xpos===0) { ODE.show[ytemp]=self[ODE.tempid].Format_showequation;	}
				ODE.k4[ytemp]['y']=parseFloat(Big(ODE.yval[ytemp]).plus(Big(ODE.k4[ytemp]['slope']).times(Big(ODE.xdist)))); }
			ODE.ytext='';
			for (var index=0; index<ODE['stext'][ypos].length; index++)
			{	var flag=0;
				for (var c=0; c<ODE.yval.length; c++)
				{	var ytemp="y"+c;
					if 	(ODE.stext[ypos][index]==ytemp) 
					{	ODE.ytext=ODE.ytext+''+ODE.k3[c]['y']+' '+ODE.yunits[c]; 
						flag=1; 
						if(xpos===0) { ODE.rt[ODE.k3[c]['y']]=ytemp; } 	}
				}
				if 	(ODE.stext[ypos][index]=='x') 
				{	if(xpos===0) { ODE.rt[ODE.xval3]='x'; }
					ODE.ytext=ODE.ytext+''+ODE.xval3; 	flag=1;	}
				if 	(flag===0) 	{ ODE.ytext=ODE.ytext+''+ODE['stext'][ypos][index];	}
			}
			var eqobj={Page_position:parseInt(ODE.loc), Format_showtype:"InnerFunction", 
			Original_id:ODE.oid, equation:"Temp4="+ODE.ytext};
			var tempid=CreateEq(ODE.fileid, 0, eqobj);
			ODE.tempid=tempid;
			self[ODE.oid].Solution_temps.push(tempid);
			console.log('--- 5. About to solve '+ODE.ytext)
			eqPromise(tempid).then( Solve_ODE4(xpos, 3, 0, ++ypos) );
		}else
		{ 	var ytemp=ypos-1;
			ODE.k4[ytemp]={}; 
			ODE.k4[ytemp]['slope']=self[ODE.tempid].Solution_real['0-0'];  
			ODE.k4[ytemp]['y']=parseFloat(Big(ODE.yval[ytemp]).plus(Big(ODE.k4[ytemp]['slope']).times(Big(ODE.xdist))));
			if (xpos===0) 	{	ODE.show[ytemp]=self[ODE.tempid].Format_showequation;	}
			for (var c=0; c<ODE.yval.length; c++)
			{	ODE.phi[c]=1/6*(ODE.k1[c]['slope']+2*ODE.k2[c]['slope']+2*ODE.k3[c]['slope']+ODE.k4[c]['slope']);
				self[ODE.y].Solution_real[c+'-'+parseInt(xpos+1)]=parseFloat(Big(ODE.yval[c]).plus(Big(ODE.phi[c]).times(Big(ODE.xdist))));
				ODE.yval[c]=parseFloat(Big(ODE.yval[c]).plus(Big(ODE.phi[c]).times(Big(ODE.xdist))));
			}
			ODE.newtext=' \\begin{bmatrix}';
			for (var a=0; a<Object.keys(ODE.show).length; a++) 
			{	var temparr=SplitText(ODE.show[a]);
				for (var t in ODE.rt){	for (var b=0; b<temparr.length; b++) 
				{	if (t==temparr[b]){  temparr[b]=ODE.rt[t]; } } }
				for (var b=0; b<temparr.length; b++) {	ODE.newtext=ODE.newtext+''+temparr[b]; }
				ODE.newtext=ODE.newtext+"\\\\";
			}
			ODE.newtext=ODE.newtext+' \\end{bmatrix}';
		}
	}
}
//-------------------------------------------------------------------------------------------------------------------------//

/*-------------------------------------------------------------------------------------------------------------------------*/
/*----------------------------------------------- DETERMINANT ALGORITHM ---------------------------------------------------*/
/*-------------------------------------------------------------------------------------------------------------------------*\
	This algorithm decomposes a matrix into upper and lower matrices through LU decomposition. It then multiplies the		\
	diagonals of the two matrices to get the determinant.																	\
/*-------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Det = function(replacetext, pid, pos, callback)
{	this.inline=0, flag=0, newmat={}, newsize=0, size=0, key='', factor=0, lower={}, det=0, det1=1, det2=1;
	replacetext=replacetext.replace(/^Det\(/,""); 
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Det"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "Det1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	if (self[id1].Format_size=="1x1") { Set_Error(this.Original_id, "Det2", id1); flag=1; }
	var sizes=self[id1].Format_size.split('x');
	if (sizes[0]!==sizes[1]) { Set_Error(this.Original_id, "Det3", id1); flag=1; }
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq=0"};
		var newid=CreateEq(this.fileid, 0, eqobj);
		newmat=self[id1].Solution_real;
		size=parseInt(sizes[0]);
		index=0; 
		for (var a=0; a<size-1; a++)
		{	for (var b=a+1; b<size; b++)
			{	factor=parseFloat(Big(newmat[b+'-'+a]).div(Big(newmat[a+'-'+a])));
				for (var c=a; c<size; c++) { 
					newmat[b+'-'+c]=parseFloat(Big(newmat[b+'-'+c]).minus(Big(factor).times(Big(newmat[a+'-'+c])))); }
				lower[b+'-'+a]=factor;
			}
		}
		for (var a=0; a<size; a++){	 for (var b=0; b<size; b++){ if (a<b) { newmat[b+'-'+a]=0; } } }
		for (var a=0; a<size; a++){	 
		for (var b=0; b<size; b++){ if (a<b) { lower[a+'-'+b]=0; }else if (a==b){ lower[a+'-'+b]=1; } } }
		self[newid].Format_showequation="Det \\left("+self[id1].Format_showequation+"\\right)";
		SetModels("Det", newid, id1);
		this.Solution_temps.push(newid);
		for (var a=0; a<size; a++){ det1=det1*newmat[a+'-'+a];	}
		for (var a=0; a<size; a++){ det2=det2*lower[a+'-'+a]; }
		self[newid]['Format_size']="1x1";
		self[newid]['Solution_real']['0-0']=det1*det2;
		self[newid]['Solution_imag']['0-0']=0;
		self[newid]['Units_units']='';
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		SetModels("Det", newid, id1);
		self[pid].Solution_variable_array[pos]=newid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}else { var newid='';}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

/*---------------------------------------------------------------------------------------------------------------------------------------------*/
/*----------------------------------------------------- TAKE A MATRIX TO AN EXPONENT ----------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------*\

/*---------------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.MatPow = function(text, pid, pos, callback)		 
{	var flag=0, solution_realarray={}, solution_imagarray={}, index1=0, index2=0, index3=0, key1='', key2='', key3='', key4='';
	var replacetext=text.replace(/^\s+|\s+$/g, '');
	replacetext=replacetext.replace(/^[MatPow(]+/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "MatPow"); flag=1; }
	if (inputarray.length<2) { Set_Error(this.Original_id, "MatPow1"); flag=1; }
	if (inputarray.length>2) { Set_Error(this.Original_id, "MatPow2"); flag=1; }
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var expid=CreateEq(this.fileid, 1, eqobj);
	var num=self[expid]['Solution_real']['0-0'];
	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
	var baseid=CreateEq(this.fileid, 1, eqobj);
	var sizes=self[baseid]['Format_size'].split('x');
	if (sizes[0]!=sizes[1]) { Set_Error(this.Original_id, "MatPow3"); flag=1; }
	var dim=sizes[0];
	var multid=CreateEq(this.fileid, 1, eqobj);
	if (self[expid]['Format_size']!="1x1") { Set_Error(this.Original_id, "MatPow4"); flag=1; }
	if (self[expid]['Solution_real']<0) { Set_Error(this.Original_id, "MatPow5"); flag=1; }
	if (flag==0)
	{	for (var a=0; a<num-1; a++) 
		{	for (index1 = 0; index1 < dim; index1++) 
			{	for (index2 = 0; index2 < dim; index2++) 
				{	key1=index1+"-"+index2;
					solution_realarray[key1]=0;		solution_imagarray[key1]=0;
					for (index3 = 0; index3 < dim; index3++) 
					{	key2=index2+"-"+index1;
						key3=index1+"-"+index3;
						key4=index3+"-"+index2;
						real1=self[baseid].Solution_real[key3];
						imag1=self[baseid].Solution_imag[key3];
						real2=self[multid].Solution_real[key4];
						imag2=self[multid].Solution_imag[key4];
						if (real1===undefined) { real1=0; }
						if (imag1===undefined) { imag1=0; }
						if (real2===undefined) { real2=0; }
						if (imag2===undefined) { imag2=0; }
						var r1=parseFloat(Big(real1).times(Big(real2)));
						var r2=parseFloat(Big(imag1).times(Big(imag2)));
						var i1=parseFloat(Big(real1).times(Big(imag2)));
						var i2=parseFloat(Big(imag1).times(Big(real2)));
						var real=parseFloat(Big(r1).minus(Big(r2))); 
						var imag=parseFloat(Big(i1).plus(Big(i2)));
						solution_realarray[key1]=parseFloat(Big(solution_realarray[key1]).plus(Big(real)));
						solution_imagarray[key1]=parseFloat(Big(solution_imagarray[key1]).plus(Big(imag)))
			}	}	}
			self[multid].Solution_real=JSON.parse(JSON.stringify(solution_realarray));
			self[multid].Solution_imag=JSON.parse(JSON.stringify(solution_imagarray));
		}	
		var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
		var id=CreateEq(this.fileid, 0, eqobj);
		for (var i in self[baseid].Units_base_array){	self[id].Units_base_array[i]=self[baseid].Units_base_array[i]*num;	}
		self[id].Recompose_Units(); 
		self[id].Get_BaseString();
		self[id]['Solution_real']=self[multid].Solution_real;
		self[id]['Solution_imag']=self[multid].Solution_imag;
		self[id]['Format_size']=self[baseid].Format_size;
		DOM_Object[id]['real']=self[multid].Solution_real;
		DOM_Object[id]['imag']=self[multid].Solution_imag;
		DOM_Object[id]['size']=self[multid]['Format_size'];
		DOM_Object[id]['units']=self[multid].Units_units;
		this.Solution_temps.push(self[id].Format_id);
		SetModels("MatPow", baseid, expid);
		self[id].Format_showequation="\\left["+self[baseid]['Format_showequation']+'\\right]^{'+self[expid]['Format_showequation']+'}';
		self[id].Show_Solution();
		self[pid].Solution_variable_array[pos]=id;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------------------------------------------//

/*---------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------- MATH FUNCTION - Integrate a vector point by point to return a vector  ------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------*\
/*---------------------------------------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.IntVec = function(text, pid, pos, callback)		 
{	var temp1=0, temp2=0, previous=0, key1='', key2='', key3='', flag=0;
	var replacetext=text.replace(/^\s+|\s+$/g, '');
	replacetext=replacetext.replace(/^IntVec\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "IntVec"); flag=1; }
	if (inputarray.length<2) { Set_Error(this.Original_id, "IntVec1");  flag=1; }
	if (inputarray.length>2) { Set_Error(this.Original_id, "IntVec2");  flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location'], 10), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
	var yid=CreateEq(this.fileid, 1, eqobj);
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location'], 10), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var xid=CreateEq(this.fileid, 1, eqobj);
	var sizes=self[yid].Format_size.split('x');	var size=sizes[1];
	var sizes2=self[xid].Format_size.split('x');
	if (parseInt(size, 10)<3) { Set_Error(this.Original_id, "IntVec3"); flag=1;  }
	if (parseInt(sizes2[1], 10)!=parseInt(sizes[1])) { Set_Error(this.Original_id, "IntVec4"); flag=1;  }
	if (flag===0)
	{	var eqobj={Page_position:DOM_Object[this.Format_id]['location'], Format_showtype:"InnerFunction", 
				Original_id:this.Original_id, equation:"TempEq=0"};
		var id=CreateEq(this.fileid, 0, eqobj);
		self[id]['Solution_real']['0-0']=0;
		for (var a=1; a<size; a++)
		{	key1="0-"+a;
			key2="0-"+parseInt(a+1,10);
			key3="0-"+parseInt(a-1,10);
			temp1=(self[yid]['Solution_real'][key3]+self[yid]['Solution_real'][key1])/2;
			temp2=self[xid]['Solution_real'][key1]-self[xid]['Solution_real'][key3];
			self[id]['Solution_real'][key1]=self[id]['Solution_real'][key3]+(temp1*temp2);
		}
		for (var a=0; a<size-1; a++){ self[id]['Solution_real']["0-"+a]=self[id]['Solution_real']["0-"+parseInt(a+1,10)]; }
		delete self[id]['Solution_real']["0-"+parseInt(a,10)];

		for(var index in self[xid].Units_base_array) 
		{ 	self[id].Units_base_array[index]=parseInt(self[xid].Units_base_array[index], 10)+parseInt(self[yid].Units_base_array[index], 10); }

		DOM_Object[id]['real']=self[id].Solution_real;
		DOM_Object[id]['size']=self[id]['Format_size'];
		DOM_Object[id]['imag']['0-0']=0;
		DOM_Object[id]['units']=self[id].Units_units;
		this.Solution_temps.push(self[id].Format_id);
//		SetModels("Derivative", id, yid, x_space);
		self[id].Format_showequation="IntVec \\left("+self[xid].Format_showequation+", "+self[yid].Format_showequation+"  \\right)";
		self[pid].Solution_variable_array[pos]=id;
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//---------------------------------------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//-------------------------------- RETURN A NUMBER THAT DEPENDS ON THE SIGN OF THE ENTRY ----------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.sign = function(replacetext, pid, pos, callback)
{	var flag=0, negid='', retid='', posid='', zeroid='', posnum=1, neg=-1, zero=0, eqobj={}; 
	replacetext=replacetext.replace(/^sign\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "sign"); flag=1; }
	if (inputarray.length>4) 	{	Set_Error(this.Original_id, "sign1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var itemid=CreateEq(this.fileid, 1, eqobj);
	if (inputarray[1]!==undefined)
	{	eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
		posid=CreateEq(this.fileid, 1, eqobj);
		posnum=self[posid]['Solution_real']['0-0'];
	}
	if (inputarray[2]!==undefined)
	{	eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[2]};
		negid=CreateEq(this.fileid, 1, eqobj);
		neg=self[negid]['Solution_real']['0-0'];
	}
	if (inputarray[3]!==undefined)
	{	eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[3]};
		zeroid=CreateEq(this.fileid, 1, eqobj);
		zero=self[zeroid]['Solution_real']['0-0'];
	}
	if (flag===0)
	{	eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq=0"};
		retid=CreateEq(this.fileid, 0, eqobj);
		for (var key in self[itemid]['Solution_real'])
		{	if (self[itemid]['Solution_real'][key]>0) { 	self[retid]['Solution_real'][key]=posnum; }
			if (self[itemid]['Solution_real'][key]<0) { 	self[retid]['Solution_real'][key]=neg; }
			if (self[itemid]['Solution_real'][key]===0) { self[retid]['Solution_real'][key]=zero; }
		}
		this.Solution_temps.push(retid);
		if (inputarray[3]!==undefined)
		{	self[retid].Format_showequation="sign \\left( \\hspace{0.2em}"+self[itemid].Format_showequation+", "+self[posid].Format_showequation+", "+self[negid].Format_showequation+", "+self[zeroid].Format_showequation+"\\hspace{0.2em}\\right)";	
		}else if (inputarray[2]!==undefined)
		{	self[retid].Format_showequation="sign \\left( \\hspace{0.2em}"+self[itemid].Format_showequation+", "+self[posid].Format_showequation+", "+self[negid].Format_showequation+"\\hspace{0.2em}\\right)";	
		}else if (inputarray[1]!==undefined)
		{	self[retid].Format_showequation="sign \\left( \\hspace{0.2em}"+self[itemid].Format_showequation+", "+self[posid].Format_showequation+"\\hspace{0.2em}\\right)";	
		}else 
		{	self[retid].Format_showequation="sign \\left( \\hspace{0.2em}"+self[itemid].Format_showequation+"\\hspace{0.2em}\\right)";	}
		if (inputarray.length>=4)	{ SetModels("sign", retid, itemid, posid, negid, zeroid); 	 
		}else if (inputarray.length>=3){ SetModels("sign", retid, itemid, posid, negid); 
		}else if (inputarray.length>=2){ SetModels("sign", retid, itemid, posid); 
		}else { SetModels("sign", retid, itemid); 		}
		DOM_Object[retid]['real']=self[retid].Solution_real;
		DOM_Object[retid]['size']='1x1';
		DOM_Object[retid]['imag']['0-0']=0;
		self[pid].Solution_variable_array[pos]=retid;
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//
/*-------------------------------------------------------------------------------------------------------------------------*/
/*-------------------------------------- SQUASH A MATRIX WITH SINGLE INDICES ----------------------------------------------*/
/*-------------------------------------------------------------------------------------------------------------------------*/
/*  This function is called whenever a new matrix has been created and it may have more indexes than necessary. For         |
    instance, if a matrix must be at least 2 dimensions, but if it is 1x1x1x1, this is meaningless. The code removes the    |
    excess ones.                                                                                                            |
/*-------------------------------------------------------------------------------------------------------------------------*/
function SquashMatrix (thisid)																							//	|
{	var eqobj={Original_id:self[thisid].Format_id, equation:"TempEq=0"};												//	|
	var id=CreateEq(self[thisid].fileid, 0, eqobj);																		//	|	
	var count=0, splitkey=new Array(), key='', newsize='';			                   									//	|
	var splitsize=self[thisid]['Format_size'].split('x');		       													//	|
	for (var a=0; a<splitsize.length; a++) { if (splitsize[a]>1) { newsize=newsize+'x'+splitsize[a]; } }				//	|
	newsize=newsize.replace(/^x/,'');																					//	|
	for (var a=0; a<splitsize.length; a++) { if (splitsize[a]>1) { count=parseInt(count, 10)+1; } }		              	//	|
console.log('The count and size are '+count+' -'+self[thisid]['Format_size']+' - '+newsize);
    if (count==0)                                                                                                       //  |
    {   for ( var a in self[thisid].Solution_real) 									                					//	|
        {  self[id].Solution_real['0-0']=self[thisid].Solution_real[a]; newsize='1x1' } 		   						//	|
    }else																												//	|
	{	if (count==1) {   newsize="1x"+newsize;      }                                  								//	|
        for (var a in self[thisid].Solution_real)																		//	|
		{	key='';		splitkey=a.split('-');																			//	|
			if (count==1) { key='0';	}																				//	|
			for (var b=0; b<splitkey.length; b++) { if (splitsize[b]>1) { key=key+'-'+splitkey[b]; } }					//	|
			key=key.replace(/^\-/,'');																					//	|
			self[id].Solution_real[key]=self[thisid].Solution_real[a];													//	|
		}																												//	|
	}																													//	|
	self[id].Format_showequation=self[thisid].Format_showequation;														//	|
	self[id].Format_size=newsize;																						//	|
	DOM_Object[id]['size']=newsize;																						//	|
console.log('The count and size are '+count+' - '+newsize);
	return id;																											//	|
}																														//	|
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//------------------------------------------------ ROTATE A 2 D MATRIX ----------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.rotate = function(replacetext, pid, pos, callback)
{	var flag=0, retid='', eqobj={}, nums=[], newkey='', sizes=[], newrow=0, newcol=0; 
	replacetext=replacetext.replace(/^rotate\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "rotate"); flag=1; }
	if (inputarray.length>1) 	{	Set_Error(this.Original_id, "rotate1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id=CreateEq(this.fileid, 1, eqobj);
	if (flag===0)
	{	eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq=0"};
		retid=CreateEq(this.fileid, 0, eqobj);
		var sizes=self[id]['Format_size'].split('x');
		if (sizes.length>2)	{ Set_Error(this.Original_id, "rotate2"); flag=1; }
		if (flag===0)
		{	for (var col=sizes[1]-1; col>=0; col--)
			{	newcol=0;
				for (var row=0; row<sizes[0]; row++)
				{	self[retid]['Solution_real'][newrow+'-'+newcol]=self[id]['Solution_real'][row+'-'+col];
					newcol=newcol+1;
				}
				newrow=newrow+1;
			}
			this.Solution_temps.push(retid);
			self[retid].Format_showequation="rotate \\left( \\hspace{0.2em}"+self[id].Format_showequation+"\\hspace{0.2em}\\right)";	
	//		SetModels("size", retid, itemid, posid, negid, zeroid);
			DOM_Object[retid]['real']=self[retid].Solution_real;
			DOM_Object[retid]['size']='1x1';
			DOM_Object[retid]['imag']['0-0']=0;
			self[pid].Solution_variable_array[pos]=retid;
			self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
			self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		}
	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//
/*-------------------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------- CHANGE A DATE AND TIME TO UTC FORMAT ----------------------------------------*/
/*-------------------------------------------------------------------------------------------------------------------------*
	This function takes in dates of several formats and changes them to the integer representing UTC. This is needed to 	\
	plot dates on the X axis. This function is very different from others. It must protect for the case where a user is 	\
	changing a column or row of table text to a UTC number, it must protect for the case where the user is entering a 		\
	single snippet of text to be transformed, and it must protect for the case where the user has a column or row of a 		\
	variable that needs to be changed. This last case could happen if a database is read into the memory.					\
/*-------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.parseDate = function(replacetext, pid, pos, callback)
{	var flag=0, retid='', eqobj={}, textstring='', text=[]; 
	replacetext=replacetext.replace(/^parseDate\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
//	var inputarray=InputArray(replacetext);
//	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "parseDate"); flag=1; }
//	if (inputarray.length>1) 	{	Set_Error(this.Original_id, "parseDate1"); flag=1; }
	if (flag===0)
	{	eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq=0"};
		retid=CreateEq(this.fileid, 0, eqobj);
		textstring=replacetext.split(';');
		for (var a=0; a<textstring.length; a++)	{ 	self[retid]['Solution_real']['0-'+a]=Date.parse(textstring[a]);
													self[retid]['Solution_imag']['0-'+a]=0; }
		this.Solution_temps.push(retid);
		self[retid].Format_showequation="parseDate \\left( \\hspace{0.2em} \\text{"+replacetext+"}\\hspace{0.2em}\\right)";
//		SetModels("size", retid, itemid, posid, negid, zeroid);
		DOM_Object[retid]['real']=self[retid].Solution_real;
		DOM_Object[retid]['size']='1x1';
		DOM_Object[retid]['imag']['0-0']=0;
		self[pid].Solution_variable_array[pos]=retid;
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

/*-------------------------------------------------------------------------------------------------------------------------*/
/*----------------------------------------------- POSITIVE DEFINITE -------------------------------------------------------*/
/*-------------------------------------------------------------------------------------------------------------------------*\
	This algorithm determines whether or not a matrix is positive definite. It uses Sylvester's criterion which asserts		\
	that a a Hermitian matrix is positive definite if and only if each matrix from the top left corner out in steps of 2x2	\
	to 3x3 to NxN are positive. The algorithm does this by decomposing the matrices into upper and lower matrices through 	\
	LU decomposition. It then multiplies the diagonals of the two matrices to get the determinant.							\
/*-------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.isPosDef = function(replacetext, pid, pos, callback)
{	this.inline=0, flag=0, newmat={}, newsize=0, size=0, key='', factor=0, lower={}, det=0, det1=1, det2=1, fin=1, tmp=0;
	replacetext=replacetext.replace(/^isPosDef\(/,""); 
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "isPosDef"); flag=1; }
	if (inputarray.length>1) { Set_Error(this.Original_id, "isPosDef1"); flag=1; }
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);
	if (self[id1].Format_size=="1x1") { Set_Error(this.Original_id, "isPosDef2", id1); flag=1; }
	var sizes=self[id1].Format_size.split('x');
	if (sizes[0]!==sizes[1]) { Set_Error(this.Original_id, "isPosDef3", id1); flag=1; }
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq=0"};
		var newid=CreateEq(this.fileid, 0, eqobj);
		size=parseInt(sizes[0]);
		index=0; 
		for (var ind=1; ind<=size; ind++)
		{	det1=1; det2=1;
			newmat=JSON.parse(JSON.stringify(self[id1].Solution_real));
			for (var a=0; a<ind-1; a++)
			{	for (var b=a+1; b<ind; b++)
				{	factor=parseFloat(Big(newmat[b+'-'+a]).div(Big(newmat[a+'-'+a])));
					for (var c=a; c<ind; c++) { 
						newmat[b+'-'+c]=parseFloat(Big(newmat[b+'-'+c]).minus(Big(factor).times(Big(newmat[a+'-'+c]))));}
					lower[b+'-'+a]=factor;
				}
			}
			for (var a=0; a<ind; a++){	 for (var b=0; b<ind; b++){ if (a<b) { newmat[b+'-'+a]=0; } } }
			for (var a=0; a<ind; a++){	 
			for (var b=0; b<ind; b++){ if (a<b) { lower[a+'-'+b]=0; }else if (a==b){ lower[a+'-'+b]=1; } } }
			for (var a=0; a<ind; a++){ det1=det1*newmat[a+'-'+a];  }
			for (var a=0; a<ind; a++){ det2=det2*lower[a+'-'+a]; }
			tmp=det1*det2;
			if (tmp<=0) { fin=0; break }
		}
		self[newid].Format_showequation="isPosDef \\left("+self[id1].Format_showequation+"\\right)";
		SetModels("isPosDef", newid, id1);
		this.Solution_temps.push(newid);
		self[newid]['Format_size']="1x1";
		self[newid]['Solution_real']['0-0']=fin;
		self[newid]['Solution_imag']['0-0']=0;
		self[newid]['Units_units']='';
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		SetModels("isPosDef", newid, id1);
		self[pid].Solution_variable_array[pos]=newid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}else { var newid='';}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

/*-------------------------------------------------------------------------------------------------------------------------*/
/*--------------------------------------------------- INTERPOLATE ---------------------------------------------------------*/
/*-------------------------------------------------------------------------------------------------------------------------*\
	This algorithm takes in a vector and creates a new one. The new vector has a number of points interpolated between 		\
	each point. That number of points is taken in as an input.																\
/*-------------------------------------------------------------------------------------------------------------------------*/
Equation.prototype.Interpolate = function(replacetext, pid, pos, callback)
{	var flag=0, size=0, index1=0, index2=0, key='', newnum=0, number=0;
	replacetext=replacetext.replace(/^Interpolate\(/,""); 
	replacetext=replacetext.replace(/\)$/,"");
	var inputarray=InputArray(replacetext);
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "Interpolate"); flag=1; }
	if (inputarray.length>2) { Set_Error(this.Original_id, "Interpolate1"); flag=1; }
	if (flag===0)
	{	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq=0"};
		var newid=CreateEq(this.fileid, 0, eqobj);
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
		var vecid=CreateEq(this.fileid, 1, eqobj);
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
		var numid=CreateEq(this.fileid, 1, eqobj);
		number=self[numid].Solution_real['0-0'];
		var sizes=self[vecid].Format_size.split('x');
		size=parseInt(sizes[1]);
		for (var ind1=0; ind1<size-1; ind1++)
		{	self[newid]['Solution_real']['0-'+index2]=self[vecid]['Solution_real']['0-'+index1];
			for (var ind2=0; ind2<self[numid]['Solution_real']['0-0']; ind2++)
			{	newnum=parseFloat(Big(self[vecid]['Solution_real']['0-'+parseInt(index1+1)]).minus(Big(self[vecid]['Solution_real']['0-'+index1])).div(Big(number)));
				self[newid]['Solution_real']['0-'+index2]=parseFloat(Big(self[vecid]['Solution_real']['0-'+index1]).plus(Big(newnum).times(Big(ind2))));
				index2=index2+1;
			}
			index1=index1+1;
		}
		index1=index1-1;
		newnum=parseFloat(Big(self[vecid]['Solution_real']['0-'+parseInt(index1+1)]).minus(Big(self[vecid]['Solution_real']['0-'+index1])).div(Big(number)));
		self[newid]['Solution_real']['0-'+index2]=parseFloat(Big(self[vecid]['Solution_real']['0-'+index1]).plus(Big(newnum).times(Big(ind2))));
		self[newid].Format_showequation="Interpolate \\left("+self[vecid].Format_showequation+", "+self[numid].Format_showequation+"\\right)";	
		SetModels("Interpolate", newid, vecid, numid);
		this.Solution_temps.push(newid);
		self[newid]['Format_size']="1x"+index2;
		self[newid]['Units_units']=self[vecid]['Units_units'];
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['units']=self[newid].Units_units;
		self[pid].Solution_variable_array[pos]=newid;
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	}else { var newid='';}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//------------------------------------- TEST AN IF STATEMENT AND RETURN RESULTS -------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.IfElse = function(replacetext, pid, pos, callback)
{	var flag=0, testflag=1, eqobj={}; 
	replacetext=replacetext.replace(/^IfElse\(/,"");
	replacetext=replacetext.replace(/\)$/,"");
	this.inputarray=InputArray(replacetext);
	if (this.inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "IfElse"); flag=1; }
	if (this.inputarray[1]=="&lt;") {	this.inputarray[1]="<"; }
	if (this.inputarray[1]=="&lt=;") {	this.inputarray[1]="<="; }
	if (this.inputarray[1]=="&gt;") {	this.inputarray[1]=">"; }
	if (this.inputarray[1]=="&gt=;") {	this.inputarray[1]=">="; }
	if (this.inputarray.length>5) 	{	Set_Error(this.Original_id, "IfElse1"); flag=1; }
	if (this.inputarray.length<4) 	{	Set_Error(this.Original_id, "IfElse2"); flag=1; }
	if ((this.inputarray[1]!="==")&&(this.inputarray[1]!="!=")&&(this.inputarray[1]!=">")&&(this.inputarray[1]!="<")&&(this.inputarray[1]!=">=")&&(this.inputarray[1]!="<=")) 	
	{	Set_Error(this.Original_id, "IfElse3"); flag=1; }
	if (flag===0)
	{	eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+this.inputarray[0]};
		this.id1=CreateEq(this.fileid, 1, eqobj);
		eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+this.inputarray[2]};
		this.id2=CreateEq(this.fileid, 1, eqobj);
		eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+this.inputarray[3]};
		this.id3=CreateEq(this.fileid, 1, eqobj);
		if (this.inputarray[4]!==undefined)
		{	eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
			Original_id:this.Original_id, equation:"TempEq="+this.inputarray[4]};
			this.id4=CreateEq(this.fileid, 1, eqobj);
		}
		if (this.inputarray[1]=="==")
		{	if (self[this.id1]['Format_size']==self[this.id2]['Format_size']) 
			{	testflag=1;
				for (var index in self[this.id1]['Solution_real'])
				{	if(self[this.id1]['Solution_real'][index]!=self[this.id2]['Solution_real'][index]){testflag=0;break}}
			}else { testflag=0; }
		}else if (this.inputarray[1]=="!=")
		{	if (self[this.id1]['Format_size']==self[this.id2]['Format_size']) 
			{	testflag=0;
			}else
			{	for (var index in self[this.id1]['Solution_real'])
				{	if(self[this.id1]['Solution_real'][index]==self[this.id2]['Solution_real'][index]){testflag=0;break}}
			}
		}else if (this.inputarray[1]==">")
		{	testflag=1;
			for (var index in self[this.id1]['Solution_real'])
			{	if(self[this.id1]['Solution_real'][index]<=self[this.id2]['Solution_real'][index]){ testflag=0; break }}
		}else if (this.inputarray[1]=="<")
		{	testflag=1;
			for (var index in self[this.id1]['Solution_real'])
			{	if(self[this.id1]['Solution_real'][index]>=self[this.id2]['Solution_real'][index]){ testflag=0; break }}
		}else if (this.inputarray[1]==">=")
		{	testflag=1;
			for (var index in self[this.id1]['Solution_real'])
			{	if(self[this.id1]['Solution_real'][index]<self[this.id2]['Solution_real'][index]){ testflag=0; break } }
		}else if (this.inputarray[1]=="<=")
		{	testflag=1;
			for (var index in self[this.id1]['Solution_real'])
			{	if(self[this.id1]['Solution_real'][index]>self[this.id2]['Solution_real'][index]){ testflag=0; break } }
		}
		eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq=0"};
		this.retid=CreateEq(this.fileid, 0, eqobj);
		if (testflag==1)
		{	self[this.retid]['Solution_real']=self[this.id3]['Solution_real'];
			self[this.retid]['Solution_imag']=self[this.id3]['Solution_imag'];
			self[this.retid]['Units_units']=self[this.id3]['Units_units'];
		}else if (this.inputarray[4]!==undefined)
		{	self[this.retid]['Solution_real']=self[this.id4]['Solution_real'];
			self[this.retid]['Solution_imag']=self[this.id4]['Solution_imag'];
			self[this.retid]['Units_units']=self[this.id4]['Units_units'];
		}else 
		{	self[this.retid]['Solution_real']['0-0']=0;
			self[this.retid]['Solution_imag']['0-0']=0;
			self[this.retid]['Units_units']='';
		}
		if (this.inputarray[4]!==undefined)
		{	self[this.retid].Format_showequation="\\left( \\text{if} \\left( \\hspace{0.2em}"+self[this.id1].Format_showequation+""+this.inputarray[1]+""+self[this.id2].Format_showequation+"\\right) \\left("+self[this.id3].Format_showequation+"\\right) \\text{else} \\left( "+self[this.id4].Format_showequation+"\\right)\\hspace{0.2em}\\right)";	
			SetModels("IfElse", this.retid, this.id1, this.id2, this.id3, this.id4);
		}else if (this.inputarray[3]!==undefined)
		{	self[this.retid].Format_showequation="\\left( \\text{if} \\left( \\hspace{0.2em}"+self[this.id1].Format_showequation+""+this.inputarray[1]+""+self[this.id2].Format_showequation+"\\right) \\left("+self[this.id3].Format_showequation+"\\right) \\hspace{0.2em}\\right)";	
			SetModels("IfElse", this.retid, this.id1, this.id2, this.id3);
		}
		DOM_Object[this.retid]['real']=self[this.retid].Solution_real;
		DOM_Object[this.retid]['size']=self[this.retid].Format_size;
		DOM_Object[this.retid]['imag']=self[this.retid].Solution_imag;
		DOM_Object[this.retid]['units']=self[this.retid].Units_units;
		self[pid].Solution_variable_array[pos]=this.retid;
		self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
		self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	}
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//------------------------------------- DIVIDE A COMPLEX NUMBER -------------------------------------------//
//---------------------------------------------------------------------------------------------------------//
function DivideComplex (obj, callback)
{	var numreal=obj['numreal']; var numimag=obj['numimag']; 
	var denreal=obj['denreal']; var denimag=obj['denimag'];
	if (obj['numreal']==='') {numreal=0;}	if (obj['numimag']==='') {numimag=0;}
	if (obj['denreal']==='') {denreal=0;}	if (obj['denimag']==='') {denimag=0;}
	var a=Big(numreal)
	var b=Big(numimag)
	var c=Big(denreal);
	var d=Big(denimag);
	var nr=Big(a).times(Big(c)).plus(Big(b).times(Big(d)))
	var ni=Big(b).times(Big(c)).minus(Big(a).times(Big(d)))
	var den=Big(c).times(Big(c)).plus(Big(d).times(Big(d))); 

	if (((nr==1)&&(den==0))||((nr==0)&&(den==0))){ obj['real']==0; 
	}else{ obj['real']=parseFloat(Big(nr).div(Big(den)));	}
	if (((ni==1)&&(den==0))||((ni==0)&&(den==0))){ obj['imag']==0; 
	}else{ obj['imag']=parseFloat(Big(ni).div(Big(den)));	}
	if (((numreal===0)&&(numimag===0))||((denreal===0)&&(denimag===0))){obj['real']=0;	obj['imag']=0;}
	callback();
}
//---------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//----------------------------------------- DIVIDE COMPLEX NUMBERS --------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
/*
For division, the algorithm for complex numbers uses the complex conjugate :
(a+bi)/(c+di)=((a+bi)*(c-di))/((c+di)*(c-di)) and is then divided out.
*/
function DivComplex (r1, i1, r2, i2)																					//	|
{	if (r1===undefined){r1=0;}	if (i1===undefined){i1=0;}	if (r2===undefined){r2=0;}	if (i2===undefined){i2=0;}		//	|
	if (r1===NaN){r1=0;}	if (i1===NaN){i1=0;}	if (r2===NaN){r2=0;}	if (i2===NaN){i2=0;}						//	|
	var number={};		                                                                                               	//	|
	if (((i1===0)&&(i2===0))||((i1===0)&&(isNaN(i2)))||((isNaN(i1))&&(i2===0))||((isNaN(i1))&&(isNaN(i2))))				//	|
	{ 	number.real=parseFloat(Big(r1).div(Big(r2))); 	     															//	|
        number.imag=0;					     				    						 								//	|
    }else														 												       	//	|
    {	var c=parseFloat(r2);									    													//	|
        var d=-1*parseFloat(i2);									   									       			//	|
        var a1=r1;														    											//	|
        var b1=i1;															   					       					//	|
        var a2=r2;										     					  			     						//	|
        var b2=i2;																  	       								//	|
        var nr=parseFloat(Big(a1).times(Big(c)).minus(Big(b1).times(Big(d)))); 	    								    //	|
        var ni=parseFloat(Big(a1).times(Big(d)).plus(Big(b1).times(Big(c)))); 		    								//	|
        var dr=parseFloat(Big(a2).times(Big(c)).minus(Big(b2).times(Big(d)))); 			  					       		//	|
        var di=parseFloat(Big(a2).times(Big(d)).minus(Big(b2).times(Big(c)))); 			  				    			//	|
        number.real=parseFloat(Big(nr).div(Big(dr)));			       					    							//	|
        number.imag=parseFloat(Big(ni).div(Big(dr)));					     				 	       					//	|
    }																						     						//	|
	return number;																										//	|
}								       																					//	|
//-------------------------------------------------------------------------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------- MULTIPLY COMPLEX NUMBERS --------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
function MultComplex (r1, i1, r2, i2)
{	if (r1===undefined){r1=0;}	
	if (i1===undefined){i1=0;}	
	if (r2===undefined){r2=0;}	
	if (i2===undefined){i2=0;}
	if (r1===NaN){r1=0;}	
	if (i1===NaN){i1=0;}	
	if (r2===NaN){r2=0;}	
	if (i2===NaN){i2=0;}
	var number={};		
	number.real=(r1*r2)-(-1*i1*i2);	
	number.imag=ToNum(r1*i2)+ToNum(i1*r2);	
	return number;	
}
//-------------------------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//------------------------------------ ROOT OF A COMPLEX NUMBER -------------------------------------------//
//---------------------------------------------------------------------------------------------------------//
function SquareRoot (obj, callback)
{	if (obj['real']==='') {var real=0;}else { var real=obj['real']; }
	if (obj['imag']==='') {var imag=0;}else { var imag=obj['imag']; }
	var r=ToNum(Math.pow(Math.pow(real,2)+Math.pow(imag,2),0.5));
	var theta=Math.atan2(imag, real);
	obj['real']=ToNum(Math.pow(r,parseFloat(1/2))*Math.cos(theta/2));
	obj['imag']=ToNum(Math.pow(r,parseFloat(1/2))*Math.sin(theta/2));	
	if ((real===0)&&(imag===0)) {	obj['real']=0;	obj['imag']=0;	}
	callback();
}
//---------------------------------------------------------------------------------------------------------//

//---------------------------------------------------------------------------------------------------------//
//------------------------------------ SQUARING A COMPLEX NUMBER ------------------------------------------//
//---------------------------------------------------------------------------------------------------------//
function SquareComplex (obj, callback)
{	if (obj['real']==='') {var real=0;}else { var real=obj['real']; }
	if (obj['imag']==='') {var imag=0;}else { var imag=obj['imag']; }
	obj['real']=parseFloat(Big(real).times(Big(real)).minus(Big(imag).times(Big(imag)))); 
	obj['imag']=parseFloat(Big(real).times(Big(imag)).times(Big(2))); 
	callback();
}
//---------------------------------------------------------------------------------------------------------//

//-------------------------------------------------------------------------------------------------------------------------//
//----------------------------------------------- FIRST POSITIVES ---------------------------------------------------------//
//-------------------------------------------------------------------------------------------------------------------------//
Equation.prototype.firstPos = function(replacetext, pid, pos, callback)
{	var flag=0; 

	// Clean around the input text
	replacetext=replacetext.replace(/^firstPos\(/,"");
	replacetext=replacetext.replace(/^firstPos\(/,"");
	replacetext=replacetext.replace(/\)$/,"");

	// Parse out the input array into it components
	var inputarray=InputArray(replacetext);


	// Make sure that there is the proper number of inputs
	if (inputarray.length===0) { Set_Error(this.Original_id, "NoEntry", "firstPos"); flag=1; }
	if (inputarray.length>2) { Set_Error(this.Original_id, "firstPos"); flag=1; }


	// Solve for the input array
	var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
	Original_id:this.Original_id, equation:"TempEq="+inputarray[0]};
	var id1=CreateEq(this.fileid, 1, eqobj);


	// Set an initial default for the second input
	var zeroIndex = 0;

	// Solve for the dimension if entered
	if ( inputarray.length == 2 ) 
	{ 
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+inputarray[1]};
		var id2=CreateEq(this.fileid, 1, eqobj);

		zeroIndex = self[id2].Solution_real['0-0'];
	}

	// Get the dimensions of the input array
	var sizes1=self[id1].Format_size.split('x');


	if (flag===0)
	{	

		var ind1 = 0;
		var ind2 = 0;
		var ansObj = {};
		var thisKey = '';

		// Create an empty equation to hold the solution
		var eqobj={Page_position:parseInt(DOM_Object[this.Format_id]['location']), Format_showtype:"InnerFunction", 
		Original_id:this.Original_id, equation:"TempEq="+replacetext};
		var newid=CreateEq(this.fileid, 0, eqobj);


		// Loop through the array and find the first case where the number passes from negative to positive.
		if ( ( sizes1[0] == 1 ) || ( sizes1[0] == '1' ) || ( zeroIndex == 0 ) )
		{
			var prevValue = 0;
			var prevKey = '';
			for ( var thisInd1=0; thisInd1 < sizes1[0]; thisInd1++ )
			{
				var thisFlag = 0;
				for ( var thisInd2=0; thisInd2 < sizes1[1]; thisInd2++ )
				{
					if ( thisFlag == 0 )
					{
						thisKey = thisInd1+'-'+thisInd2;
						if ( thisInd2 != 0 )
						{
							prevKey = thisInd1+'-'+parseInt(thisInd2-1);
							if ( ( self[id1].Solution_real[prevKey] <= 0 ) &&
								 ( self[id1].Solution_real[thisKey] > 0 ) )
							{
								self[newid].Solution_real[ind1+'-'+ind2] = JSON.parse(JSON.stringify(thisInd2));
								ind2 = ind2+1;
								if ( ( sizes1[0] > 1 ) && ( sizes1[1] > 1 ) )
								{
									thisFlag = 1;
								}
							}
						}
					}
				}
				if ( ( sizes1[0] > 1 ) && ( sizes1[1] > 1 ) && ( thisFlag == 0 ) )
				{
					self[newid].Solution_real[ind1+'-'+ind2] = 0;
					ind2 = ind2+1;
				}

			}
		}


		// Loop through the array and find the first case where the number passes from negative to positive.
		if ( ( sizes1[1] == 1 ) || ( sizes1[1] == '1' ) || ( zeroIndex == 1 ) )
		{
			var prevValue = 0;
			var prevKey = '';
			for ( var thisInd2=0; thisInd2 < sizes1[1]; thisInd2++ )
			{
				var thisFlag = 0;
				for ( var thisInd1=0; thisInd1 < sizes1[0]; thisInd1++ )
				{
					thisKey = parseInt(thisInd1)+'-'+thisInd2;
					if ( thisInd1 != 0 )
					{
						prevKey = parseInt(thisInd1-1)+'-'+thisInd2;
						if ( ( self[id1].Solution_real[prevKey] <= 0 ) &&
							 ( self[id1].Solution_real[thisKey] > 0 ) )
						{
							thisFlag = 1;
							self[newid].Solution_real[ind1+'-'+ind2] = JSON.parse(JSON.stringify(thisInd1));
							ind2 = ind2+1;
						}
					}
				}
				if ( ( sizes1[0] > 1 ) && ( sizes1[1] > 1 ) && ( thisFlag == 0 ) )
				{
					self[newid].Solution_real[ind1+'-'+ind2] = 0;
					ind2 = ind2+1;
				}
			}
		}

		// If no crossing point was found, set the solution to zero
		if ( ind2 == 0 )
		{
			self[newid].Solution_real['0-0'] = 0;
		}


	
		if ( inputarray.length == 2 ) 
		{
			self[newid].Format_showequation="firstPos \\left("+self[id1].Format_showequation+", "+self[id2].Format_showequation+"\\right)";
		}else
		{
			self[newid].Format_showequation="firstPos \\left("+self[id1].Format_showequation+"\\right)";
		}

		// Pass the units to the solution equation
		self[newid].Units_base_array[index]=self[id1].Units_base_array[index];
		self[newid].Recompose_Units(); 

		// Push the solution numbers to the DOM Object
		this.Solution_temps.push(newid);
		DOM_Object[newid]['real']=self[newid].Solution_real;
		DOM_Object[newid]['imag']['0-0']=0;
		DOM_Object[newid]['size']=self[newid]['Format_size'];
		DOM_Object[newid]['units']=self[newid].Units_units;
		SetModels("firstPos", newid, id1, id2);
		self[pid].Solution_variable_array[pos]=newid;
	}else 
	{ 
		var newid='';
	}


	// Place the new equation into the solution array in placed of the function call
	self[pid].Solution_variable_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Solution_key_array.splice(parseInt(pos, 10)+1,1);
	self[pid].Remove_BuiltInEquations(parseInt(pos, 10)+1, callback);
}
//-------------------------------------------------------------------------------------------------------------------------//



/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------- FUNCTIONS TO HANDLE LOOPS AND STATEMENTS -----------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------------------------ THE EQUATION PROMISE -----------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	This function is a constructor that lets the user create a promise for an equation. In essence, the function lets the user ensure that the equation is solved 		\
	before moving on. This is used in conjunction with the "then" method.																								\
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function eqPromise(eqid){
  return new Promise(function (fulfill, reject){
    self[eqid].Solve_Equation(DOM_Object[eqid]['equation'],0);
    });
  }
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------------------------ THE STRUCTURE PROMISE ----------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	This function is a constructor that lets the user create a promise for a structure. In essence, the function lets the user ensure that the structure is solved 		\
	before moving on. This is used in conjunction with the "then" method.																								\
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function StrucPromise(structID, pos, flag){
  return new Promise(function (fulfill, reject){
    	DoStructures(structID, pos, flag);
    });
  }
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------------------------ THE DO STRUCTURES FUNCTION -----------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	This function is called for every for loop, while loop, or if statement. There are three inputs, the id, the position, and the flag. 								\
		id   - the id of the item being ran																																\
		pos  - the position within the perform loop																														\
		flag - sets whether the loop is being run for the first time. 																									\
	When the function starts, if the id in question is a loop, the flag is checked. If the flag is 1, then the prep functions are called with the DoStructures function \
	set as the callback with the flag set to 0. If the flag is zero, then the function solves whatever lies at the position of the perform loop given by the pos input. \
	If this is an equation, it is solved, if this is a loop, the DoStructures function is run for that loop.															\
	The perform array is created in the loop and statement prep functions and is an ordered array of the id of the item in question and its order within the 			\
	structure. The pos is incremented after each run and if it is greater than the perform array, then the counters are incremented. For a while loop, the conditions 	\
	are checked to see if it will run again. For a for loop, the counters are checked. Note that for if else statements, the prep functions must ensure that the 		\
	peform array contains only the block that is to be run. 																											\
	Case 1 - First run through - values are calculatted, function is recalled																							\
	Case 2 - Function run with counter at 0 - test is performed and if true, the first item is solved and the program is recalled										\
	Case 3 - Function is called with number higher than array count - recalculate conditions, recall with pos at 0														\
	Case 4 - Normal run - the code pulls the item in question, runs it, and then recalls the function with the next number												\
SolveWhileLoopParameters(loopid, firstrun, callback)
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function DoStructures(id, pos, flag, callback)
{	//console.log('In DoStructures with an ID of '+id+', the pos is '+pos+', the size of the perform array is '+DOM_Object[id].Loop_Perform.length+' the flag is '+flag+', the type is '+DOM_Object[id]['type']+', the truefalse is '+DOM_Object[id].Loop_truefalse+', and the counter is '+DOM_Object[id].Loop_countervalue);
	console.log('In Do structures with id, pos, and flag of '+id+', '+pos+', '+flag+' and a type of '+DOM_Object[id]['content']['type']);
	
	if (DOM_Object[id]['component_type_id']==7)
	{	if ((flag==1)&&(self[id]['content']['whileLoop'].Loop_counterValue==0)) 
		{ 	PrepLoopEquations(id);				 
			Populate_Item(id);				 
			SolveWhileLoopParameters(id, 1);			 
			CheckWhileLoop(id);				 
			DoStructures(id, 0, 0);
		}else if (pos>=DOM_Object[id]['content']['whileLoop'].Loop_Perform.length) { console.log('pos>psize'); self[id]['content']['whileLoop'].Loop_counterValue++;   DoStructures(id, 0, 1);
		}else if (flag==1){ 	SolveWhileLoopParameters( id, 0, function() { CheckWhileLoop(id, function () { DoStructures(id, 0, 0); }); });
		}else 
		{	console.log('Solving '+DOM_Object[id]['content']['whileLoop'].Loop_Perform[0]+' with the true false and step limits set to '+self[id]['content']['whileLoop'].Loop_truefalse+' and '+self[id]['content']['whileLoop'].Loop_stepLimit);
			if ((self[id]['content']['whileLoop'].Loop_truefalse)&&(self[id]['content']['whileLoop'].Loop_countervalue<self[id]['content']['whileLoop'].Loop_stepLimit))
			{	var thisid=DOM_Object[id]['content']['whileLoop'].Loop_Perform[pos];
				pos=pos+1;
				if ((DOM_Object[thisid]['type']=="equation")&&(DOM_Object[thisid]['active']==1)) 
				{	console.log('Solving '+DOM_Object[thisid]['equation']);
					eqPromise(thisid).then( DoStructures(id,pos,0) );
				}else if (DOM_Object[thisid]['type']=="forloop"){	DoStructures(thisid,0,1,function(){ DoStructures(id,pos,0);	});
				}else if (DOM_Object[thisid]['type']=="whileloop"){	DoStructures(thisid,0,1,function(){ DoStructures(id,pos,0);	});
				}else if (DOM_Object[thisid]['type']=="ifelse")	{	DoStructures(thisid,0,1,function(){ DoStructures(id,pos,0);	});  
				}else { DoStructures(id,pos,0); }
			}
		}
	}
	if (DOM_Object[id]['component_type_id']==6)
	{	if (flag==1)
		{	PrepLoopEquations(id);
			Populate_Item(id);
			var counterid='';	var newid='';
			var eqobj={Page_position:DOM_Object[id]['order'], Format_name:DOM_Object[id]['content']['forLoop']['counter'], equation:DOM_Object[id].counter+"=0"};
			var counterid=CreateEq(DOM_Object[id]['fileid'], 0, eqobj);
			DOM_Object[counterid]={};		
			DOM_Object[counterid]['real']={};	
			DOM_Object[counterid]['imag']={};	
			DOM_Object[counterid]['active']=1;
			DOM_Object[counterid]['name']=DOM_Object[id]['content']['forLoop']['counter'];	
			DOM_Object[counterid]['type']="equation";
			DOM_Object[counterid]['ID']=self[counterid]['Format_id'];
			DOM_Object[counterid]['order']=DOM_Object[id]['order'];
			DOM_Object[counterid]['real']['0-0']=DOM_Object[id].start;	
			DOM_Object[counterid]['imag']['0-0']=0; 	
			DOM_Object[counterid]['size']="1x1";
			DOM_Object[id]['content']['forLoop'].valueid=counterid;		
			self[id]['content']['forLoop'].Loop_counterValue=0; 
            console.log('For the for loop '+id+', i just created the counter '+DOM_Object[id]['content']['forLoop']['counter']+' at position '+DOM_Object[id]['order']);
            switch (DOM_Object[id]['content']['forLoop'].limitFactor)				       
			{	case "<":
					for (var a=DOM_Object[id]['content']['forLoop'].start; a<DOM_Object[id]['content']['forLoop'].stop; a=parseFloat(Big(a).plus(Big(DOM_Object[id]['content']['forLoop'].increment))))//\
					{	console.log('The id is '+id+', the counter is '+a+', the valueid is '+DOM_Object[id]['content']['forLoop'].valueid+' - '+DOM_Object[DOM_Object[id]['content']['forLoop']['valueid']]['real']['0-0']+' and in DOM Object it is '+Object.keys(DOM_Object[DOM_Object[id]['content']['forLoop'].valueid]));
						DOM_Object[DOM_Object[id]['content']['forLoop'].valueid]['real']['0-0']=a;	self[id]['content']['forLoop'].Loop_counterValue++; 
						DoStructures(id, 0, 0);		 }
				break;
				case "<=":
					for (var a=parseFloat(DOM_Object[id]['content']['forLoop'].start); a<=parseFloat(DOM_Object[id]['content']['forLoop'].stop); a=parseFloat(Big(a).plus(Big(DOM_Object[id]['content']['forLoop'].increment))))
					{	DOM_Object[DOM_Object[id]['content']['forLoop'].valueid]['real']['0-0']=a;	self[id]['content']['forLoop'].Loop_counterValue++; 
						DoStructures(id, 0, 0);			}
				break;
				case ">":
					for (var a=parseFloat(DOM_Object[id]['content']['forLoop'].start); a>parseFloat(DOM_Object[id]['content']['forLoop'].stop); a=parseFloat(Big(a).plus(Big(DOM_Object[id]['content']['forLoop'].increment))))
					{	DOM_Object[DOM_Object[id]['content']['forLoop'].valueid]['real']['0-0']=a;	self[id]['content']['forLoop'].Loop_counterValue++; 
						DoStructures(id, 0, 0);			}
				break;
				case ">=":
					for (var a=parseFloat(DOM_Object[id]['content']['forLoop'].start); a>=parseFloat(DOM_Object[id]['content']['forLoop'].stop); a=parseFloat(Big(a).plus(Big(DOM_Object[id]['content']['forLoop'].increment))))
					{	DOM_Object[DOM_Object[id]['content']['forLoop'].valueid]['real']['0-0']=a;	self[id]['content']['forLoop'].Loop_counterValue++; 
						DoStructures(id, 0, 0);			}
				break;
			}
			for (var i in DOM_Object) { if (DOM_Object[i]['Dependents']!==undefined) { delete DOM_Object[i]['Dependents'][counterid]; } }
			delete DOM_Object[counterid];	delete DOM_Object[counterid];		DOM_Object[id].status='1';
		}else if (DOM_Object[id].Errors_flag!='1')
		{	if (pos<DOM_Object[id]['content']['forLoop'].Loop_Perform.length) 
			{	var thisid=DOM_Object[id]['content']['forLoop'].Loop_Perform[pos];
				console.log('The position is '+pos+' and the item is '+thisid+' and the type is '+DOM_Object[thisid]['type']+' - '+DOM_Object[thisid]['active']);
				pos=pos+1;
				if ((DOM_Object[thisid]['type']=="equation")&&(DOM_Object[thisid]['active']==1)) 
				{	self[thisid].Solve_Equation(DOM_Object[thisid]['equation'],0,function(){DoStructures(id,pos,0)});
				}else if (DOM_Object[thisid]['component_type_id']==6){	DoStructures(thisid,0,1,function(){ DoStructures(id,pos,0)	});
				}else if (DOM_Object[thisid]['component_type_id']==7){	DoStructures(thisid,0,1,function(){ DoStructures(id,pos,0)	});
				}else if (DOM_Object[thisid]['component_type_id']==8){	DoStructures(thisid,0,1,function(){ DoStructures(id,pos,0 ) }); } 
			}
		}
	}
	if (DOM_Object[id]['component_type_id']==8)
	{	console.log('I am in the if else part of the do structures ');
		if (flag==1)
		{	
			SolveIfElseParameters(id, function() { 
			PrepStatementEquations(id, function() { 
			CheckStatement(id, function() { 
			SetActive(id, function() {
			Populate_Item(id, function() {
			DoStructures(id, 0, 0); }); }); }); });	});		 
		}else 
		{	
			console.log('The length and pos are '+DOM_Object[id]['content']['ifelse']['Loop_Perform'].length+' - '+pos);
			
			console.log('With the flag set to 0 in the if/else of do structures, the DOM_Object of the loop is ...');
			console.log(DOM_Object);
			console.log(DOM_Object[id]);

			if (pos<DOM_Object[id]['content']['ifelse'].Loop_Perform.length) 
			{	var thisid=DOM_Object[id]['content']['ifelse'].Loop_Perform[pos];
				pos=pos+1;
				console.log('I am looking at the equation '+thisid+' - '+DOM_Object[thisid]['equation']+' and it is active - '+DOM_Object[thisid]['active']);
				if ((DOM_Object[thisid]['type']=="equation")&&(DOM_Object[thisid]['active']==1)) 
				{	self[thisid].Solve_Equation(DOM_Object[thisid]['equation'],0,function(){DoStructures(id,pos,0)});
				}else if (DOM_Object[thisid]['type']=="forLoop"){	DoStructures(thisid,0,1,function(){ DoStructures(id,pos,0)	});
				}else if (DOM_Object[thisid]['type']=="whileLoop"){	DoStructures(thisid,0,1,function(){ DoStructures(id,pos,0)	});
				}else if (DOM_Object[thisid]['type']=="ifelse")	{	DoStructures(thisid,0,1,function(){ DoStructures(id,pos,0 ) }); } 
			}
			console.log('Pos is too big and I am done with the structure');
		}
	}
	if (typeof(callback)=="function") { callback();	}  
}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/


/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*--------------------------------------------------------- CREATE A NEW FOR LOOP -------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function ForLoop (loopObj) 
{ 	this.Name='';
    this.fileid=loopObj['fileid'];
    this.inputFile='';
    this.inputID='';
    this.itemid=loopObj['itemid'];
    this.Format_id=loopObj['itemid'];
    this.id=loopObj['itemid'];
    this.location=0;
	this.Page_position=0;
	this.topparentid='none';						     
	this.parentid='none';								      
	this.Page_lastposition=0;
    this.component_type_id=6;
    this.content={};
    this.content.forLoop={};
	this.content.forLoop.counter='a';
	this.content.forLoop.Loop_counterValue=0;
	this.content.forLoop.valueid='';
	this.content.forLoop.startText='0';
	this.content.forLoop.start=0;
	this.content.forLoop.stopText='1';
	this.content.forLoop.stop=1;
	this.content.forLoop.increment=1;
	this.content.forLoop.incrementText='1';
	this.content.forLoop.numSteps=1;
	this.content.forLoop.status=0;
	this.content.forLoop.Format_haschanged=1;																																// 	\
	this.content.forLoop.firstRun=0;																																	    
	this.content.forLoop.limitFactor='<';
	this.content.forLoop.Errors_flag=0;
	this.content.forLoop.Errors_errors=new Array();																																	// 	\
	this.content['type']='forLoop';																																	    
	for (var item in loopObj)
	{   
		this['content']['forLoop'][item]=loopObj['content']['forLoop'][item];  
	}      
}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*-------------------------------------------------------------- SOLVE FOR LOOP PARAMETERS ----------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	This function looks at a for loop and solves the three parameters for that loop - the start number, the stop number, and the increment number.						\
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function SolveLoopParameters(loopid, callback)
{	var eqobj={Page_position:DOM_Object[loopid]['order'], Page_parentid:DOM_Object[loopid]['content']['parentid'], Page_topparentid:DOM_Object[loopid]['content']['topparentid'],
	Format_showtype:"InnerFunction", equation:"myeq="+self[loopid]['content']['forLoop'].startText };			                
	var id1=CreateEq(self[loopid]['content'].fileid, 0, eqobj);
	var eqobj={Page_position:DOM_Object[loopid]['order'], Page_parentid:DOM_Object[loopid]['content']['parentid'], Page_topparentid:DOM_Object[loopid]['content']['topparentid'],
	Format_showtype:"InnerFunction", equation:"myeq="+self[loopid]['content']['forLoop'].stopText };
	var id2=CreateEq(self[loopid]['content'].fileid, 0, eqobj);
	var eqobj={Page_position:DOM_Object[loopid]['order'], Page_parentid:DOM_Object[loopid]['content']['parentid'], Page_topparentid:DOM_Object[loopid]['content']['topparentid'],
	Format_showtype:"InnerFunction", equation:"myeq="+self[loopid]['content']['forLoop'].incrementText };
	var id3=CreateEq(self[loopid]['content'].fileid, 0, eqobj);
	eqPromise(id1).then( eqPromise(id2).then( eqPromise(id3).then( SetLoopParameters(loopid, id1, id2, id3, callback) ) ) );
}
function SetLoopParameters(loopid, id1, id2, id3, callback)
{	
	// Set the parameter values from the equation results
	self[loopid]['content']['forLoop'].start=self[id1]['Solution_real']['0-0'];
	self[loopid]['content']['forLoop'].stop=self[id2]['Solution_real']['0-0'];
	self[loopid]['content']['forLoop'].increment=self[id3]['Solution_real']['0-0'];
	
	// Calculate the number of steps to be taken
	if (self[loopid].limitFactor=="<=")	
	{ 
		self[loopid]['content']['forLoop'].numSteps=parseInt(Math.floor((self[loopid]['content']['forLoop'].stop-self[loopid]['content']['forLoop'].start)/self[loopid]['content']['forLoop'].increment), 10);
		if ((self[loopid]['content']['forLoop'].stop<self[loopid]['content']['forLoop'].start)||(self[loopid]['content']['forLoop'].increment<0)) 
		{ 
			self[loopid]['content']['forLoop'].numSteps=0; 
		} 
	}
	if (self[loopid]['content']['forLoop'].limitFactor=="<")
	{ 
		self[loopid]['content']['forLoop'].numSteps=parseInt(Math.floor((self[loopid]['content']['forLoop'].stop-(self[loopid]['content']['forLoop'].start-self[loopid]['content']['forLoop'].increment/2))/self[loopid]['content']['forLoop'].increment), 10);
		if ((self[loopid]['content']['forLoop'].stop<self[loopid]['content']['forLoop'].start)||(self[loopid]['content']['forLoop'].increment<0)) 
		{ 
			self[loopid]['content']['forLoop'].numSteps=0; 
		} 
	}
	if (self[loopid]['content']['forLoop'].limitFactor==">=")	
	{ 
		self[loopid]['content']['forLoop'].numSteps=parseInt(Math.floor(self[loopid]['content']['forLoop'].start-self[loopid]['content']['forLoop'].stop)/(-1*self[loopid]['content']['forLoop'].increment), 10);
		if ((self[loopid]['content']['forLoop'].start<self[loopid]['content']['forLoop'].stop)||(self[loopid]['content']['forLoop'].increment>0)) 
		{ 
			self[loopid]['content']['forLoop'].numSteps=0; 
		} 
	}
	if (self[loopid]['content']['forLoop'].limitFactor==">")
	{ 
		self[loopid]['content']['forLoop'].numSteps=parseInt(Math.floor((self[loopid]['content']['forLoop'].start-(self[loopid]['content']['forLoop'].stop-self[loopid]['content']['forLoop'].increment/2))/(-1*self[loopid]['content']['forLoop'].increment)), 10);
		if ((self[loopid]['content']['forLoop'].start<self[loopid]['content']['forLoop'].stop)||(self[loopid]['content']['forLoop'].increment>0)) 
		{ 
			self[loopid]['content']['forLoop'].numSteps=0; 
		} 
	}
	if (self[loopid]['content']['forLoop'].numSteps<0) { self[loopid]['content']['forLoop'].numSteps=0; }
	if (self[loopid]['content']['forLoop'].numSteps===0) 	{	Set_Error(loopid, "ForLoop1"); }
	self[loopid]['Dependents']={};
	DOM_Object[loopid]['Dependents']={};
	console.log('The start, stop, increment, and numSteps are '+self[loopid]['content']['forLoop'].start+'-'+self[loopid]['content']['forLoop'].stop+'-'+self[loopid]['content']['forLoop'].increment+'-'+self[loopid]['content']['forLoop'].numSteps);	
    for (var a in DOM_Object[id1]['Dependents']) { self[loopid]['Dependents'][a]=1; DOM_Object[loopid]['Dependents'][a]=1; }
	for (var a in DOM_Object[id2]['Dependents']) { self[loopid]['Dependents'][a]=1; DOM_Object[loopid]['Dependents'][a]=1; }
	for (var a in DOM_Object[id3]['Dependents']) { self[loopid]['Dependents'][a]=1; DOM_Object[loopid]['Dependents'][a]=1; }
	if (typeof(callback)=="function") { callback();	}
} 
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*-------------------------------------------------------------- RETURN FOR LOOP PARAMETERS ---------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function PassForLoopParameters(ID)	{ postMessage({"messageType":"LoopParametersResult", "ID":ID, "loopObject":self[ID] });	}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*-------------------------------------------------------------- PREP LOOP EQUATIONS ----------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	This is the first function called when a loop is updated and solved. It sets all the equation solutions back to zero. It then looks to see if a previous version 	\
	of the matrix exists. If it does, then the current matrix is set to retaining the values of the previous loop update. 												\
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function PrepLoopEquations(loopid, callback)
{	var type=DOM_Object[loopid]['content']['type'];                              
    console.log('In Prep Loop Equations for '+type+'-'+loopid+' with a first run of '+DOM_Object[loopid]['content'][type]['firstRun']);
	if (DOM_Object[loopid]['content'][type]['firstRun']==1)
	{	
		self[loopid]['content'][type].Loop_countervalue=0;																		        
		if (self[loopid]===undefined)
		{ 
			self[loopid]={}; 
			for (var objProp in DOM_Object[loopid]) { self[loopid][objProp]=DOM_Object[loopid][objProp]; }		
		}
		for (var objid in DOM_Object)	                    
		{	if (DOM_Object[objid]['component_type_id']=="7"){    self[objid]['content']['whileLoop']['firstRun']=0;		}			                                            
			if (DOM_Object[objid]['component_type_id']=="6"){	 self[objid]['content']['forLoop']['firstRun']=0;		}			                                            
			if (DOM_Object[objid]['component_type_id']=="3") 
			{	DOM_Object[objid]['real']={};			DOM_Object[objid]['imag']={}; 
				DOM_Object[objid].tempsolr={};			DOM_Object[objid].tempsoli={}; 
				self[objid]=new Equation(objid);
				self[objid].Populate_Equation(DOM_Object[objid]['newEquation']);
				DOM_Object[objid]['name']=self[objid]['Format_name'];
				var thiseq=MatchClosestEquation(DOM_Object[objid]['name'], DOM_Object[loopid]['order'], objid, 0, 0); 
				if (typeof(DOM_Object[thiseq])=="object")  
				{ 	DOM_Object[objid]['real']=JSON.parse(JSON.stringify(DOM_Object[thiseq]['real'])); 
					DOM_Object[objid]['imag']=JSON.parse(JSON.stringify(DOM_Object[thiseq]['imag']));
					DOM_Object[objid]['numinds']=JSON.parse(JSON.stringify(DOM_Object[thiseq]['numinds']));
					DOM_Object[objid]['tempsolr']=JSON.parse(JSON.stringify(DOM_Object[thiseq]['real'])); 
					DOM_Object[objid]['tempsoli']=JSON.parse(JSON.stringify(DOM_Object[thiseq]['imag'])); 
					DOM_Object[objid]['size']=JSON.parse(JSON.stringify(DOM_Object[thiseq]['size'])); 
				 	DOM_Object[objid]['units']=JSON.parse(JSON.stringify(DOM_Object[thiseq]['units'])); 
					DOM_Object[objid]['basearray']=JSON.parse(JSON.stringify(DOM_Object[thiseq]['basearray']));
					DOM_Object[objid]['equation']=JSON.parse(JSON.stringify(DOM_Object[thiseq]['newEquation']));
                    DOM_Object[objid]['fileid']=JSON.parse(JSON.stringify(DOM_Object[thiseq]['fileid']));
                    console.log('In the prep loop equations, the real matrix has been set to ...');
                    console.log(DOM_Object[objid]['real']);
                    console.log(self[thiseq]);
	}	}	}	}
	self[loopid]['content'][type]['firstRun']=0;
	DOM_Object[loopid]['content'][type].firstRun=0;			                                                             	            
	if (DOM_Object[loopid]['content'][type].limitfactor=="&lt;") { DOM_Object[loopid]['content'][type].limitfactor="<"; }
	if (DOM_Object[loopid]['content'][type].limitfactor=="&gt;") { DOM_Object[loopid]['content'][type].limitfactor=">"; }
	if (DOM_Object[loopid]['content'][type].limitfactor=="&lt=;") { DOM_Object[loopid]['content'][type].limitfactor="<="; }
	if (DOM_Object[loopid]['content'][type].limitfactor=="&gt=;") { DOM_Object[loopid]['content'][type].limitfactor=">="; }
	if (typeof(callback)=="function") { callback();	}
} 
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------- PREP STATEMENT EQUATIONS ---------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	This is the first function called when a loop is updated and solved. It sets all the equation solutions back to zero. It then looks to see if a previous version 	\
	of the matrix exists. If it does, then the current matrix is set to retaining the values of the previous loop update. 												\
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function PrepStatementEquations(loopid, callback)
{	console.log('In Prep Statement Equations');
	for (var stind in DOM_Object[loopid]['content']['ifelse']['Statement_Order'])
	{	var stID=DOM_Object[loopid]['content']['ifelse']['Statement_Order'][stind];
		for (var eqID in DOM_Object[stID]['children'])
		{	if (DOM_Object[eqID]['type']=="equation") 
			{	var eqobj={Page_position:DOM_Object[eqID]['order'], Page_parentid:DOM_Object[eqID]['parentid'], Page_topparentid:DOM_Object[eqID]['topparentid'],
				equation:DOM_Object[eqID]['equation'], id:eqID };
				var newid=CreateEq(this.fileid, 0, eqobj);
	}	}	}
	if (typeof(callback)=="function") { callback();	}
} 
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------- POPULATE THE ARRAY OF ITEMS TO BE PERFORMED IN THE STRUCTURES --------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	This function populates an array for each loop or if else statement. The array holds the equations, loops and statements embedded within the structure. During		\
	the DoStructures algorithm, it is this array that the code steps through, executing each item in order. To create this array, this algorithm appends each item		\
	in the loop or structure's children object to the array and appends the position of that item to a mirrored array. Once all the items have been added, a simple		\
	bubble sort algorithm is used to ensure that they are in order.																										\
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function Populate_Item(loopid, callback)
{	console.log('In Populate Items');

	console.log('At the beginning of Populate_Item, the DOM_Object of the loop is ...');
	console.log(DOM_Object[loopid]);

	var itemID='', a=0, swapped=false, temp='', stID='', stind='', type='';
	type=DOM_Object[loopid]['content']['type'];  
	console.log('The loop id is '+loopid+' and the type is '+type);                       
    if (DOM_Object[loopid]['content'][type]!==undefined)
    {
    	DOM_Object[loopid]['content'][type]['Loop_Perform']=new Array();		
	    DOM_Object[loopid]['content'][type]['Loop_Pos']=new Array();
		for (itemID in DOM_Object)                   																										    
	    {	
	    	if ( (DOM_Object[itemID]['component_type_id'] == 6) || 
	    		 (DOM_Object[itemID]['component_type_id'] == 7) || 
	    		 (DOM_Object[itemID]['component_type_id'] == 8) )
			{
		    	if (DOM_Object[itemID]['content']['parentid']==loopid) 
		        {   
		        	DOM_Object[loopid]['content'][type].Loop_Perform.push(itemID); 	
		        	DOM_Object[loopid]['content'][type].Loop_Pos.push(DOM_Object[itemID]['order']); 
		        }
		    }else
		    {
		    	if (DOM_Object[itemID]['parentid']==loopid) 
		        {   
		        	DOM_Object[loopid]['content'][type].Loop_Perform.push(itemID); 	
		        	DOM_Object[loopid]['content'][type].Loop_Pos.push(DOM_Object[itemID]['order']); 
		        }
		    }
		}
		do 
		{	swapped = false;
	    	for (var i=0; i < DOM_Object[loopid]['content'][type].Loop_Pos.length-1; i++) 
			{	
		    	if (DOM_Object[itemID]['content']!==undefined)
	    		{
					if (DOM_Object[loopid]['content'][type].Loop_Pos[i] > DOM_Object[loopid]['content'][type].Loop_Pos[i+1]) 
					{	temp = DOM_Object[loopid]['content'][type].Loop_Pos[i];
						DOM_Object[loopid]['content'][type].Loop_Pos[i] = DOM_Object[loopid]['content'][type].Loop_Pos[i+1];
						DOM_Object[loopid]['content'][type].Loop_Pos[i+1] = temp;
						temp = DOM_Object[loopid]['content'][type].Loop_Perform[i];
						DOM_Object[loopid]['content'][type].Loop_Perform[i] = DOM_Object[loopid]['content'][type].Loop_Perform[i+1];
						DOM_Object[loopid]['content'][type].Loop_Perform[i+1] = temp;
						swapped = true;
					}
				}
			}
		} while (swapped);


	console.log('At the end of Populate_Item, the DOM_Object is ...');
	console.log(DOM_Object);

	}
	if (typeof(callback)=="function") { callback();	} 
}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------------------------ PREP PLOT DATA TO BE RETURNED --------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	This function called when a user has entered data for a plot and the entered equation has been solved. This function takes that solution and then formats the 		\
	data to be passed back to the main function in the proper format.																									\
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function PrepPlotData(eqID, plotObj, PlotID, DataID, className, callback)
{	console.log('In Prep Plot Data Function with plot ID of '+PlotID+', a data ID of '+DataID+', andd a className '+className);
	var Data='', oldlength=0, dataIndex=0;                            
    for (var thisData=0; thisData<plotObject['Chart_dataobj'].length; thisData++)          
    {   if (plotObject['Chart_dataobj'][thisData]['Format_id']==DataID) {   Data=plotObj['Chart_dataobj'][thisData]; dataIndex=thisData;    }      }  
	DOM_Object[PlotID]['Dependents'][DataID]={}; 
	for (var dep in DOM_Object[eqID]['Dependents'])
	{	DOM_Object[PlotID]['Dependents'][DataID][dep]={};
		DOM_Object[PlotID]['Dependents'][DataID][dep]['axis']=className;
		DOM_Object[PlotID]['Dependents'][DataID][dep]['active']=1;
	}

	if (!parseInt(plotObj.Errors_flag)) 
	{	console.log('The format type is '+Data.Format_type);

		// if ((Data.Format_type=="bar")||(Data.Format_type=="column"))
		// {	plotObj['Chart_dataobj'][dataIndex]['PointData']={};
		// 	for (var index=0; index<Object.keys(DOM_Object[eqID].real).length; index++)
		// 	{	plotObj['Chart_dataobj'][dataIndex]['PointData'][index]={y:DOM_Object[eqID].real['0-'+index]};		}
		// }else if (Data.Format_type=="heatmap")
		
		if (Data.Format_type=="heatmap")
		{	var count=0;
			for (index in DOM_Object[eqID].real)
			{	var key=index.split('-');
				if (plotObj['Chart_dataobj'][dataIndex]['PointData'][count]===undefined) { plotObj['Chart_dataobj'][dataIndex]['PointData'][count]={};}
				plotObj['Chart_dataobj'][dataIndex]['PointData'][count]['x']=parseInt(key[0], 10);
				plotObj['Chart_dataobj'][dataIndex]['PointData'][count]['y']=parseInt(key[1], 10);
				plotObj['Chart_dataobj'][dataIndex]['PointData'][count]['value']=DOM_Object[eqID].real[index];
				count++;
			}
		}else
		{	
			console.log('The x and y data names are '+plotObj['Chart_dataobj'][dataIndex]['xdata_name']+' - '+plotObj['Chart_dataobj'][dataIndex]['ydata_name']);
			console.log('The className is '+className);

			if (className=="plot_xdatainput") 
			{	for (var index=0; index<Object.keys(DOM_Object[eqID].real).length; index++)
				{	if (plotObj['Chart_dataobj'][dataIndex]['PointData'][index]===undefined) { plotObj['Chart_dataobj'][dataIndex]['PointData'][index]={};	}
					plotObj['Chart_dataobj'][dataIndex]['PointData'][index]['x']=DOM_Object[eqID]['real']['0-'+index];
					if ((plotObj['Chart_dataobj'][dataIndex]['PointData'][index]['y']===undefined)||(plotObj['Chart_dataobj'][dataIndex]['ydata_name']=='')) 
					{	plotObj['Chart_dataobj'][dataIndex]['PointData'][index]['y']=index;	}
				}
			}
			if (className=="plot_ydatainput") 
			{	oldlength=Object.keys(plotObj['Chart_dataobj'][dataIndex]['PointData']).length;

				for (var index=0; index<Object.keys(DOM_Object[eqID].real).length; index++)
				{	if (plotObj['Chart_dataobj'][dataIndex]['PointData'][index]===undefined) { plotObj['Chart_dataobj'][dataIndex]['PointData'][index]={};	}
					plotObj['Chart_dataobj'][dataIndex]['PointData'][index]['y']=DOM_Object[eqID]['real']['0-'+index];
					if ((plotObj['Chart_dataobj'][dataIndex]['PointData'][index]['x']===undefined)||(plotObj['Chart_dataobj'][dataIndex]['xdata_name']==''))
					{	plotObj['Chart_dataobj'][dataIndex]['PointData'][index]['x']=index;	}

				}
				for (var index2=index; index2<=oldlength; index2++)
				{	delete 	plotObj['Chart_dataobj'][dataIndex]['PointData'][index2]; }
			}
			if (className=="plot_zdatainput") 
			{	for (var index=0; index<Object.keys(DOM_Object[eqID].real).length; index++)
				{	
					if (plotObj['Chart_dataobj'][dataIndex]['PointData'][index] === undefined ){ plotObj['Chart_dataobj'][dataIndex]['PointData'][index]={}; }
					plotObj['Chart_dataobj'][dataIndex]['PointData'][index]['z']=DOM_Object[eqID]['real']['0-'+index];	
				}
			}
			if (className=="plot_cdatainput") 
			{	
				for (var index=0; index<Object.keys(DOM_Object[eqID].real).length; index++)
				{	
					if (plotObj['Chart_dataobj'][dataIndex]['PointData'][index] === undefined ){ plotObj['Chart_dataobj'][dataIndex]['PointData'][index]={}; }
					plotObj['Chart_dataobj'][dataIndex]['PointData'][index]['c']=DOM_Object[eqID]['real']['0-'+index];	}
			}
			if (className=="Lathe") 
			{	plotObj['Chart_dataobj'][dataIndex]['curve']=DOM_Object[eqID]['real'];	}
		}
	}
	if (typeof(callback)=="function") { callback();	}
}
//---------------------------------------------------------------------------------------------------------------------------------------------------------------------//

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------- PASS THE PLOT OBJECT BACK TO THE MAIN PROGRAM WITH THE NEW DATA ---------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	This function is passed the data that resulted from solving the input to an equation. It sends that data to the main program.										\
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function PassPlotData(plotObj, PlotID, DataID, className){ console.log('In Pass Plot Data Function');
	console.log('Return the data with the contents plotID - '+PlotID+', dataID - '+DataID);
	postMessage({
		"messageType":"PlotDataResults", 
		"plotID":PlotID, 
		"DataID":DataID, 
		"eventErrorFlag":eventErrorFlag, 
		"eventError":eventError, 
		"className":className, 
		"Dependents":DOM_Object[PlotID]['Dependents'],
		"plotObj":plotObj 
	}); 
}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------- PASS THE RESULTS OF FORMATTING THE SOLUTION BACK TO THE MAIN PROGRAM  ------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	This function is passed the data that resulted from formatting the solution. It sends that data to the main program.												\
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function passSolutionResults(eqID){ postMessage({
		"messageType":"SolutionResults", 
		"eqID":eqID, 
		"eqObj":self[eqID] 
	}); 
}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------------------------------- THE WHILE LOOP OBJECT ---------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function WhileLoop (loopObj) 
{ 	this.Name='';
    this.fileid=loopObj['fileid'];
    this.itemid=loopObj['itemid'];
    this.Format_id=loopObj['itemid'];
    this.id=loopObj['itemid'];
    this.location=loopObj['order'];
    this.component_type_id=7;
	this.Page_lastposition=0;				              
	this.topparentid='none';			            
	this.parentid='none';							                   
	this.content={};
	this.content.whileLoop={};                                                
	this.content['whileLoop'].Page_position=0;
	this.content['whileLoop'].Loop_status='';
	this.content['whileLoop'].Loop_numSteps='';																																// 	\
	this.content['whileLoop'].Loop_stepLimit=100;																															// 	\
	this.content['whileLoop'].Loop_countervalue=0;
	this.content['whileLoop'].firstRun='1';																															       
	this.content['whileLoop'].Loop_String='';
	this.content['whileLoop'].Loop_TFString='';
	this.content['whileLoop'].Loop_ValuesString=''; 
	this.content['whileLoop'].Loop_Perform=new Array(); 
	this.content['whileLoop'].Errors_flag=0;
	this.content['whileLoop'].Errors_errors=new Array();
	this.content['whileLoop'].Dependents={};
	this.content['whileLoop'].Loop_Values={};
	this.content['whileLoop'].statementBlock={};													               
	this.content['type']='whileLoop';																																	    
	this.content.whileLoop.Errors_flag=0;
	this.content.whileLoop.Errors_errors=new Array();																																	// 	\
	for (var item in loopObj)
	{   
		this['content']['whileLoop'][item]=loopObj['content']['whileLoop'][item];  
	}      
	// Example : While flag!=1 would be recorded as while flag condition dependent
}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*--------------------------------------------- SOLVE THE VALUES FOR THE BLOCKS WITHIN A WHILE LOOP -------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	This function is passed an id for a while loop. It then looks at the object that holds the text for the == or != conditions and solves each of those equations.		\
	This happens each time that one of those parameters is changed on the DOM when this function is called from the main program. It also happens each time through 	\
	the loop so that the algorithm can check to see the state of the conditions to check whether the loop should continue or not.										\
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function SolveWhileLoopParameters(loopid, firstrun, callback)
{	console.log('In Solve Loop Parameters');
	DOM_Object[loopid]['content']['whileLoop']['Dependents']={};
	if (firstrun==1){ var looppos=DOM_Object[loopid]['order']; }else { var looppos=parseInt(DOM_Object[loopid]['content']['Page_lastposition'], 10)+1; }
	for (var a=0; a<self[loopid]['content']['whileLoop']['statementBlock'].length; a++) 
	{	for (var b=0; b<self[loopid]['content']['whileLoop']['statementBlock'][a].length; b++) 
        {	if (self[loopid]['content']['whileLoop']['statementBlock'][a][b]['flagText']!==undefined) 										      
            {	if (self[loopid]['content']['whileLoop']['statementBlock'][a][b]['flagText'].match(/^\d+$/))									     
				{ self[loopid]['content']['whileLoop']['statementBlock'][a][b]['flagValue']=parseInt(self[loopid]['content']['whileLoop']['statementBlock'][a][b]['flagText'], 10); 	    
				}else 																										    
				{	if (firstrun==1)																							       
				    {	console.log('The position is '+looppos+' and the loopid is '+loopid);
                        var eqobj={Page_position:looppos, Format_showtype:"InnerFunction", equation:"FlagEq="+self[loopid]['content']['whileLoop']['statementBlock'][a][b]['flagText'],     
				        Page_parentid:loopid, Page_topparentid:loopid};																			      
				    }else { var eqobj={Page_position:DOM_Object[loopid]['Page_lastposition'], Format_showtype:"InnerFunction", 								       
							equation:"FlagEq="+self[loopid]['content']['whileLoop']['statementBlock'][a][b]['flagText'], Page_parentid:loopid, Page_topparentid:loopid };	}
				    var id=CreateEq(self[loopid]['fileid'], 1, eqobj);																			       
				    for (var k in DOM_Object[id]['Dependents']) 																            			      
				    {	DOM_Object[loopid]['content']['whileLoop']['Dependents'][k]=1; 																				       
				        if (self[loopid]!==undefined) 																	     
				        { 	if (self[loopid]['content']['whileLoop']['Dependents']===undefined) { self[loopid]['content']['whileLoop']['Dependents']={}; 	}
				                self[loopid]['content']['whileLoop']['Dependents'][k]=1;
				        }																										         
				    }																												       
				    self[loopid]['content']['whileLoop']['statementBlock'][a][b]['flagValue']=self[id].Solution_real['0-0'];							      
				    delete self[id]; delete DOM_Object[id];																						       	
				}																																		     
				if (self[loopid]['content']['whileLoop']['statementBlock'][a][b]['dependentText'].match(/^\d+$/))							    
				{ self[loopid]['content']['whileLoop']['statementBlock'][a][b]['dependentValue']=parseInt(self[loopid]['content']['whileLoop']['statementBlock'][a][b]['dependentText'], 10);
				}else 																									     
				{	if (firstrun==1)																						    
				    {	var eqobj={Page_position:looppos,Original_id:loopid,Format_showtype:"InnerFunction",equation:"DepEq="+self[loopid]['content']['whileLoop']['statementBlock'][a][b]['dependentText']};
				    }else { var eqobj={Page_position:looppos, equation:"DepEq="+self[loopid]['content']['whileLoop']['statementBlock'][a][b]['dependentText']}; }	   
				    var id=CreateEq(self[loopid]['fileid'], 1, eqobj);															       
				    for (var k in DOM_Object[id]['content']['whileLoop']['Dependents']) 															      	              
				    {	DOM_Object[loopid]['content']['whileLoop']['Dependents'][k]=1; 									      
				        if (self[loopid]!==undefined) 												      
				        { 	if (self[loopid]['content']['whileLoop']['Dependents']===undefined) { self[loopid]['content']['whileLoop']['Dependents']={}; 	}			     
				            self[loopid]['content']['whileLoop']['Dependents'][k]=1;											     				   
				        }																					      
				    }																							        
				    self[loopid]['content']['whileLoop']['statementBlock'][a][b]['dependentValue']=self[id].Solution_real['0-0'];				       
				    delete self[id]; delete DOM_Object[id];																			      	
				}																														     
	}	}	}																																      
	if (typeof(callback)=="function") { callback();	} 
}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*----------------------------------------------- CHECK WHILE LOOP FOR TRUE / FALSE AND FOR ERRORS OR PROBLEMS --------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	This function is called whenever the user changes something about the loop. If checks for any errors that may occur during the running of the loop and sets the 	|
	error flag if there is a problem.																																	|
	In the first step, each statement is tested depending on the values entered. If it meets those conditions, the truefalse item for the object is set to true.		|
	In the next section, the statement is recreated with the individual statements replaced with the resulting true or false. 											|
	If (((flag==1)||(flag==2))||((flag==3)&&(flag!=5))) then becomes ... (((true)||(false))||(false)&&(false)). This is then solved and the result placed in the 		|
	true false property for the IfElse Statement.                                                                                                                       |
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function CheckWhileLoop(loopid, callback)
{	var dependent='', condition='', flag='', statementstring='', tfstring='', valuestring='', temp1='', temp2='', temp3='';   
    console.log('In Check While Loop');
	for (var a=0; a<self[loopid]['content']['whileLoop']['statementBlock'].length; a++) 
	{	for (var b=0; b<self[loopid]['content']['whileLoop']['statementBlock'][a].length; b++) 
        {	flag=self[loopid]['content']['whileLoop']['statementBlock'][a][b]['flagValue'];																			        
			dependent=self[loopid]['content']['whileLoop']['statementBlock'][a][b]['dependentValue'];																		    
			condition=self[loopid]['content']['whileLoop']['statementBlock'][a][b]['conditionText'];																		    
            if ((condition=="==") && (flag==dependent)) 																										    
            {	self[loopid]['content']['whileLoop']['statementBlock'][a][b]['truefalse']=true;}else if (condition=="=="){self[loopid]['content']['whileLoop']['statementBlock'][a][b]['truefalse']=false;}
            if ((condition=="!=") && (flag!=dependent)) 																										    
            {	self[loopid]['content']['whileLoop']['statementBlock'][a][b]['truefalse']=true;}else if (condition=="!="){self[loopid]['content']['whileLoop']['statementBlock'][a][b]['truefalse']=false;}
            if ((condition==">")  && (flag>dependent)) 																											    
            {	self[loopid]['content']['whileLoop']['statementBlock'][a][b]['truefalse']=true;}else if (condition==">"){self[loopid]['content']['whileLoop']['statementBlock'][a][b]['truefalse']=false;}
            if ((condition==">=") && (flag>=dependent)) 																										    
            {	self[loopid]['content']['whileLoop']['statementBlock'][a][b]['truefalse']=true;}else if (condition==">="){self[loopid]['content']['whileLoop']['statementBlock'][a][b]['truefalse']=false;}
            if ((condition=="<")  && (flag<dependent)) 																											    
            {	self[loopid]['content']['whileLoop']['statementBlock'][a][b]['truefalse']=true;}else if (condition=="<"){self[loopid]['content']['whileLoop']['statementBlock'][a][b]['truefalse']=false;}
            if ((condition=="<=") && (flag<=dependent)) 																										    
            {	self[loopid]['content']['whileLoop']['statementBlock'][a][b]['truefalse']=true;}else if (condition=="<="){self[loopid]['content']['whileLoop']['statementBlock'][a][b]['truefalse']=false;}
	}	}

	for (var a=0; a<self[loopid]['content']['whileLoop']['statementBlock'].length; a++) 
	{	if (a!==0) { statementstring=statementstring+self[loopid]['content']['whileLoop']['statementBlock'][a][0]['blockOption']; }	                                        
        if (a!==0) { tfstring=tfstring+self[loopid]['content']['whileLoop']['statementBlock'][a][0]['blockOption']; }	                                                        
        if (a!==0) { valuestring=valuestring+self[loopid]['content']['whileLoop']['statementBlock'][a][0]['blockOption']; }	                                                
        statementstring=statementstring+'(';																											     
        tfstring=tfstring+'(';										                																	     
        valuestring=valuestring+'(';						          																					     
        for (var b=0; b<self[loopid]['content']['whileLoop']['statementBlock'][a].length; b++) 
		{	if (b!==0) { statementstring=statementstring+self[loopid]['content']['whileLoop']['statementBlock'][a][b]['blockOption']; }	                                    
            if (b!==0) { tfstring=tfstring+self[loopid]['content']['whileLoop']['statementBlock'][a][b]['blockOption']; }	                                                    
            if (b!==0) { valuestring=valuestring+self[loopid]['content']['whileLoop']['statementBlock'][a][b]['blockOption']; }	                                            
            statementstring=statementstring+'(';
			tfstring=tfstring+'(';
			valuestring=valuestring+'(';
            temp1=self[loopid]['content']['whileLoop']['statementBlock'][a][b]['truefalse'];																                    
            tfstring=tfstring+''+temp1+'';																												            
            temp1=self[loopid]['content']['whileLoop']['statementBlock'][a][b]['flagText'];																                    
            temp2=self[loopid]['content']['whileLoop']['statementBlock'][a][b]['conditionText'];															                    
            temp3=self[loopid]['content']['whileLoop']['statementBlock'][a][b]['dependentText'];															                    
            statementstring=statementstring+''+temp1+''+temp2+''+temp3+'';																				            
            temp1=self[loopid]['content']['whileLoop']['statementBlock'][a][b]['flagValue'];																                    
            temp2=self[loopid]['content']['whileLoop']['statementBlock'][a][b]['conditionText'];															                    
            temp3=self[loopid]['content']['whileLoop']['statementBlock'][a][b]['dependentValue'];															                    
            valuestring=valuestring+''+temp1+''+temp2+''+temp3+'';																						            
			statementstring=statementstring+')';
			tfstring=tfstring+')';
			valuestring=valuestring+')';
		}
        statementstring=statementstring+')';																													    
        tfstring=tfstring+')';																																	    
        valuestring=valuestring+')';																															    
	} 
	self[loopid]['content']['whileLoop']['Loop_String']=statementstring;																									    
	self[loopid]['content']['whileLoop']['Loop_TFString']=tfstring;																										    
	self[loopid]['content']['whileLoop']['Loop_ValueString']=valuestring;
console.log('At the end of check loop');
console.log('The statement string is '+self[loopid]['content']['whileLoop']['Loop_String']);
console.log('The truefalse string is '+self[loopid]['content']['whileLoop']['Loop_TFString']);
console.log('The value string is '+self[loopid]['content']['whileLoop']['Loop_ValueString']);
	self[loopid]['content']['whileLoop']['Loop_truefalse']=eval(tfstring.replace(/<div[^>]*>|<\/div>/g, ''));
	if (typeof(callback)=="function") { callback();	} 
}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/




/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*--------------------------------------------- PASS THE VALUES FOR THE BLOCKS WITHIN A WHILE LOOP BACK ---------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	This function is passed an id for a while loop. It returns the object created in the SolveWhileLoopParameters function back to the main algorithm.					\
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function PassWhileParameters(loopID){ postMessage({
		"messageType":"WhileLoopParametersResult", 
		"ID":loopID, 
		"loopObject":self[loopID] 
	}); 
}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*-------------------------------------------------- CREATE A NEW IF ELSE STATEMENT AND POPULATE IT -------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function IfElse (loopObj) 		    
{ 	
	this.fileid=loopObj['fileid'];
    this.itemid=loopObj['itemid'];
    this.id=loopObj['itemid'];
    this.location=loopObj['order'];
    this.order=loopObj['order'];
    this.component_type_id=8;
	this.Page_lastposition=loopObj['order'];																										              
	this.content={};
	this.content.topparentid='none';			            
	this.content.parentid='none';							                   
    this.content.ifelse={};                                                   
	this.content['ifelse'].Page_position=0;
	this.content['ifelse'].Statement_Type="if";
	this.content['ifelse'].Statement_String='';
	this.content['ifelse'].Statement_TFString='';
	this.content['ifelse'].StatementID=loopObj['itemid'];
	this.content['ifelse'].Statement_ValueString='';
	this.content['ifelse'].Statement_truefalse=false;																														// 	\
	this.content['ifelse'].Statement_Execute='0';																															// 	\
	this.content['ifelse'].Statement_Parent=loopObj['itemid'];
	this.content['ifelse'].Statement_Order=new Array();
	this.content['ifelse'].Errors_errors=new Array();																														// 	\
	this.content['ifelse'].Errors_flag=0;																																	// 	\
	this.content['ifelse'].Statement_Values={};												    
	this.content['ifelse'].statementBlock={};	       
	this.content['ifelse'].firstRun=1;																																	    
	this.content['type']='ifelse';			// Type as in versus for loop or while loop or equation, etc																															    
	this.content['ifelse']['type'] = 'if';  // Type as in if, ifelse, or else
	this.content.ifelse.Errors_flag=0;
	this.content.ifelse.Errors_errors=new Array();																																	// 	\
	for (var item in loopObj.content.ifelse)
	{   
		this['content']['ifelse'][item]=loopObj['content']['ifelse'][item];  
	}      
}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------- SOLVE THE VALUES FOR THE BLOCKS WITHIN A IF ELSE STATEMENT --------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	This function is passed an id for an if/else statement. It then looks at the object that holds the text for the conditions and solves each of those equations.		\
	This happens each time that one of those parameters is changed on the DOM when this function is called from the main program. It also happens each time through 	\
	the loop so that the algorithm can check to see the state of the conditions to check whether the loop should continue or not.										\
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function SolveIfElseParameters(loopid, callback)							             
{	console.log('In Solve If Else Parameters');
	DOM_Object[loopid]['content']['ifelse']['Dependents']={};
	for (var a=0; a<self[loopid]['content']['ifelse']['statementBlock'].length; a++) 
	{	for (var b=0; b<self[loopid]['content']['ifelse']['statementBlock'][a].length; b++) 
        {	if (self[loopid]['content']['ifelse']['statementBlock'][a][b]['flagText']!==undefined) 										      
            {	if (self[loopid]['content']['ifelse']['statementBlock'][a][b]['flagText'].match(/^\d+$/))									     
				{ self[loopid]['content']['ifelse']['statementBlock'][a][b]['flagValue']=parseInt(self[loopid]['content']['ifelse']['statementBlock'][a][b]['flagText'], 10);
				}else 																										    
				{	console.log('the location is '+DOM_Object[loopid]['order']);
                    var eqobj={Page_position:DOM_Object[loopid]['order'], Format_showtype:"InnerFunction",  
                        equation:"FlagEq="+self[loopid]['content']['ifelse']['statementBlock'][a][b]['flagText'], Page_parentid:loopid, Page_topparentid:loopid};		   
				    var id=CreateEq(self[loopid]['fileid'], 1, eqobj);																			       
				    for (var k in DOM_Object[id]['Dependents']) 																						      
				    {	DOM_Object[loopid]['content']['ifelse']['Dependents'][k]=1; 																					       
				        if (self[loopid]!==undefined) 																	     
				        { 	if (self[loopid]['content']['ifelse']['Dependents']===undefined) { self[loopid]['content']['ifelse']['Dependents']={}; 	}
				                self[loopid]['content']['ifelse']['Dependents'][k]=1;
				        }																										     
				    }																												       
				    self[loopid]['content']['ifelse']['statementBlock'][a][b]['flagValue']=self[id].Solution_real['0-0'];								    
console.log('--- The flag value is '+self[id].Solution_real['0-0']);
				    delete self[id]; delete DOM_Object[id];																						       	
				}																																		     
				if (self[loopid]['content']['ifelse']['statementBlock'][a][b]['dependentText'].match(/^\d+$/))							    
				{ self[loopid]['content']['ifelse']['statementBlock'][a][b]['dependentValue']=parseFloat(self[loopid]['content']['ifelse']['statementBlock'][a][b]['dependentText'], 10); 
				}else 																									     
				{	var eqobj={Page_position:DOM_Object[loopid]['order'], Original_id:loopid,Format_showtype:"InnerFunction",   
                        equation:"DepEq="+self[loopid]['content']['ifelse']['statementBlock'][a][b]['dependentText']};	                                                        
				    var id=CreateEq(self[loopid]['fileid'], 1, eqobj);															       
				    for (var k in DOM_Object[id]['Dependents']) 																		      
				    {	DOM_Object[loopid]['content']['ifelse']['Dependents'][k]=1; 									      
				        if (self[loopid]!==undefined) 												      
				        { 	if (self[loopid]['content']['ifelse']['Dependents']===undefined) { self[loopid]['content']['ifelse']['Dependents']={}; 	}	 
				            self[loopid]['content']['ifelse']['Dependents'][k]=1;											     				   
				        }																					      
				    }																							        
				    self[loopid]['content']['ifelse']['statementBlock'][a][b]['dependentValue']=self[id].Solution_real['0-0'];				       
console.log('--- The dependent value is '+self[id].Solution_real['0-0']);
				    delete self[id]; delete DOM_Object[id];																			      	
				}																														     
	}	}	}																																      
	if (typeof(callback)=="function") { callback();	} 
}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/


/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*----------------------------------------- CHECK IF/ELSE STATEMENTS FOR TRUE / FALSE AND FOR ERRROS AND EXECUTION ----------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	This function is called to check whether or not the if / else statement is true or false and to determine whether or not it is active. This is done each time the 	|
	statement is altered. There are three steps to complete the action. The code allows users to enter multiple conditions and to use the binary and / or by using 		|
	the && and || symbols. The values of the flag and dependents were established in the previous function. 															|
	1. The function first checks the status of each statement separately and sets a true or false depending on if those values meet the requirements established. 		|
	2. The function rebuilds the if statement with the statements replaced with those true/false values and solves it. 													|
	3. The third step marks whether this particulare statement should be executed. It does this by looking at previous if / else statements and executing accordingly.	|
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function CheckStatement(loopid, callback)
{	var dependent='', condition='', flag='', statementstring='', tfstring='', valuestring='', temp1='', temp2='', temp3='', parentStatement='', flag=0;
    console.log('In Check Statement');

	console.log('At the beginning of CheckStatement, the DOM_Object of the loop is ...');
	console.log(DOM_Object[loopid]);

	for (var a=0; a<self[loopid]['content']['ifelse']['statementBlock'].length; a++) 
	{	for (var b=0; b<self[loopid]['content']['ifelse']['statementBlock'][a].length; b++) 
        {	flag=self[loopid]['content']['ifelse']['statementBlock'][a][b]['flagValue'];																				        
			dependent=self[loopid]['content']['ifelse']['statementBlock'][a][b]['dependentValue'];																			    
			condition=self[loopid]['content']['ifelse']['statementBlock'][a][b]['conditionText'];																			    
            if ((condition=="==") && (flag==dependent)) 																										    
            {	self[loopid]['content']['ifelse']['statementBlock'][a][b]['truefalse']=true;}else if (condition=="=="){self[loopid]['content']['ifelse']['statementBlock'][a][b]['truefalse']=false;}
            if ((condition=="!=") && (flag!=dependent)) 																										    
            {	self[loopid]['content']['ifelse']['statementBlock'][a][b]['truefalse']=true;}else if (condition=="!="){self[loopid]['content']['ifelse']['statementBlock'][a][b]['truefalse']=false;}
            if ((condition==">")  && (flag>dependent)) 																											    
            {	self[loopid]['content']['ifelse']['statementBlock'][a][b]['truefalse']=true;}else if (condition==">"){self[loopid]['content']['ifelse']['statementBlock'][a][b]['truefalse']=false;}
            if ((condition==">=") && (flag>=dependent)) 																										    
            {	self[loopid]['content']['ifelse']['statementBlock'][a][b]['truefalse']=true;}else if (condition==">="){self[loopid]['content']['ifelse']['statementBlock'][a][b]['truefalse']=false;}
            if ((condition=="<")  && (flag<dependent)) 																											    
            {	self[loopid]['content']['ifelse']['statementBlock'][a][b]['truefalse']=true;}else if (condition=="<"){self[loopid]['content']['ifelse']['statementBlock'][a][b]['truefalse']=false;}
            if ((condition=="<=") && (flag<=dependent)) 																										    
            {	self[loopid]['content']['ifelse']['statementBlock'][a][b]['truefalse']=true;}else if (condition=="<="){self[loopid]['content']['ifelse']['statementBlock'][a][b]['truefalse']=false;}	
	}	}

	for (var a=0; a<self[loopid]['content']['ifelse']['statementBlock'].length; a++) 
	{	if (a!==0) { statementstring=statementstring+self[loopid]['content']['ifelse']['statementBlock'][a][0]['blockOption']; }	                                            
        if (a!==0) { tfstring=tfstring+self[loopid]['content']['ifelse']['statementBlock'][a][0]['blockOption']; }	                                                            
        if (a!==0) { valuestring=valuestring+self[loopid]['content']['ifelse']['statementBlock'][a][0]['blockOption']; }	                                                    
        statementstring=statementstring+'(';																											     
        tfstring=tfstring+'(';										                																	     
        valuestring=valuestring+'(';						          																					     
        for (var b=0; b<self[loopid]['content']['ifelse']['statementBlock'][a].length; b++) 																       
		{	if (b!==0) { statementstring=statementstring+self[loopid]['content']['ifelse']['statementBlock'][a][b]['blockOption']; }	                                        
            if (b!==0) { tfstring=tfstring+self[loopid]['content']['ifelse']['statementBlock'][a][b]['blockOption']; }	                                                        
            if (b!==0) { valuestring=valuestring+self[loopid]['content']['ifelse']['statementBlock'][a][b]['blockOption']; }	                                                
            statementstring=statementstring+'(';
			tfstring=tfstring+'(';
			valuestring=valuestring+'(';
            temp1=self[loopid]['content']['ifelse']['statementBlock'][a][b]['truefalse'];																                        
            tfstring=tfstring+''+temp1+'';																												            
            temp1=self[loopid]['content']['ifelse']['statementBlock'][a][b]['flagText'];																                        
            temp2=self[loopid]['content']['ifelse']['statementBlock'][a][b]['conditionText'];															                        
            temp3=self[loopid]['content']['ifelse']['statementBlock'][a][b]['dependentText'];															                        
            statementstring=statementstring+''+temp1+''+temp2+''+temp3+'';																				            
            temp1=self[loopid]['content']['ifelse']['statementBlock'][a][b]['flagValue'];																                        
            temp2=self[loopid]['content']['ifelse']['statementBlock'][a][b]['conditionText'];															                        
            temp3=self[loopid]['content']['ifelse']['statementBlock'][a][b]['dependentValue'];															                        
            valuestring=valuestring+''+temp1+''+temp2+''+temp3+'';																						            
			statementstring=statementstring+')';
			tfstring=tfstring+')';
			valuestring=valuestring+')';
		}
        statementstring=statementstring+')';																													    
        tfstring=tfstring+')';																																	    
        valuestring=valuestring+')';																															    
	} 
	self[loopid]['content']['ifelse']['Loop_String']=statementstring;
	self[loopid]['content']['ifelse']['Loop_TFString']=tfstring;
	self[loopid]['content']['ifelse']['Loop_ValueString']=valuestring;
	self[loopid]['content']['ifelse']['Statement_truefalse']=eval(tfstring.replace(/<div[^>]*>|<\/div>/g, ''));
	DOM_Object[loopid]['content']['ifelse']['Statement_String']=statementstring;
	DOM_Object[loopid]['content']['ifelse']['Statement_TFString']=tfstring;
	DOM_Object[loopid]['content']['ifelse']['Statement_ValueString']=valuestring;
	DOM_Object[loopid]['content']['ifelse']['Statement_truefalse']=eval(tfstring.replace(/<div[^>]*>|<\/div>/g, ''));
	parentStatement=DOM_Object[loopid]['content']['ifelse']['parentStatement'];  
    for (var a in DOM_Object)                                         
    {   if (DOM_Object[a]['component_type_id']==8)                              
        {   console.log('The item in question is ...');
        	console.log(DOM_Object[a]);
        	if (DOM_Object[a]['content']['ifelse']['parentStatement']==parentStatement)               
            {   DOM_Object[parentStatement]['content']['ifelse']['Statement_Order'].push({location:DOM_Object[a]['order']-DOM_Object[parentStatement]['order'], ID:a, Execute:0}); }//  \
        }                                                             
    }                                                                 
    flag=0;                                                           
    DOM_Object[parentStatement]['content']['ifelse']['Statement_Order']=DOM_Object[parentStatement]['content']['ifelse']['Statement_Order'].sort(dynamicSort("location"));   
    for (var a=0; a<DOM_Object[parentStatement]['content']['ifelse']['Statement_Order'].length; a++)
	{	var id=DOM_Object[parentStatement]['content']['ifelse']['Statement_Order'][a]['ID'];
console.log('The true false, type, and flag of the statement are '+DOM_Object[id]['content']['ifelse']['Statement_truefalse']+'-'+DOM_Object[id]['content']['ifelse']['Statement_Type']+'-'+flag);        
        if (DOM_Object[id]['content']['ifelse']['Statement_Type']!="else")
		{	if ((DOM_Object[id]['content']['ifelse']['Statement_truefalse']===true)&&(flag===0))
			{	DOM_Object[id]['content']['ifelse']['Statement_Execute']=1; flag=1;   DOM_Object[parentStatement]['content']['ifelse']['Statement_Order'][a]['Execute']=1;   
            }else { DOM_Object[id]['content']['ifelse']['Statement_Execute']=0;       DOM_Object[parentStatement]['content']['ifelse']['Statement_Order'][a]['Execute']=0;   }
		}else{	if ((DOM_Object[id]['content']['ifelse']['Statement_Type']=="else")&&(flag===0)) 
				{ DOM_Object[id]['content']['ifelse']['Statement_Execute']=1;         DOM_Object[parentStatement]['content']['ifelse']['Statement_Order'][a]['Execute']=1;   
                }else{ DOM_Object[id]['content']['ifelse']['Statement_Execute']=0;    DOM_Object[parentStatement]['content']['ifelse']['Statement_Order'][a]['Execute']=0;   } }
	}
    for (var a=0; a<DOM_Object[parentStatement]['content']['ifelse']['Statement_Order'].length; a++)
	{	var id=DOM_Object[parentStatement]['content']['ifelse']['Statement_Order'][a]['ID'];
        DOM_Object[id]['content']['ifelse']['Statement_Order']=DOM_Object[parentStatement]['content']['ifelse']['Statement_Order'];  
        self[id]['content']['ifelse']['Statement_Order']=DOM_Object[parentStatement]['content']['ifelse']['Statement_Order'];   
    }	
	console.log('At the end of CheckStatement, the DOM_Object of the loop is ...');
	console.log(DOM_Object[loopid]);

    if (typeof(callback)=="function") { callback();	} 
}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/


/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*----------------------------------------------------------------- SET ACTIVE OR INACTIVE ----------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*
    This function sets the items to active or inactive for if/else statements. To do this, the code simply looks at whether the statement execute flag is set.          |
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function SetActive(id, callback)
{	var thisID='';                                                    

	console.log('At the beginning of SetActive, the DOM_Object of the loop is ...');
	console.log(DOM_Object[id]);

    if (DOM_Object[id]!==undefined)
	{	for (var i=0; i<DOM_Object[id]['content']['ifelse']['Statement_Order'].length; i++)
		{	thisID=DOM_Object[id]['content']['ifelse']['Statement_Order'][i]['ID'];                   
            if (DOM_Object[thisID]['content']['ifelse']['Statement_Execute']==1) 			                               
			{ 	DOM_Object[thisID]['content']['ifelse']['active']=1;  		                                           
				for (var x in DOM_Object)                             
                {	if (DOM_Object[x]['content']!==undefined)
                	{
                		if (DOM_Object[x]['content']['parentid']==id) 
            			{  
            				DOM_Object[x]['content']['active']=1;	
            				self[x]['content']['active']=1;  
            			}
            		}
            	}	                                            
			}else 
			{	DOM_Object[thisID]['content']['ifelse']['active']=0;  		                                           
				for (var x in DOM_Object)            
                {	if (DOM_Object[x]['content']!==undefined)
                	{
	                	if (DOM_Object[x]['content']['parentid']==id) 
	            		{  
	            			DOM_Object[x]['content']['active']=0;	
	            			self[x]['content']['active']=0;  
	            		}		
	            	}
            	}	                                            
			}
	}	}


	console.log('At the end of SetActive, the DOM_Object of the loop is ...');
	console.log(DOM_Object[id]);

	if (typeof(callback)=="function") { callback();	}  
}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*--------------------------------------------- PASS THE VALUES FOR THE BLOCKS WITHIN A WHILE LOOP BACK ---------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	This function is passed an id for a while loop. It returns the object created in the SolveWhileLoopParameters function back to the main algorithm.					\
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function PassIfElseParameters(ID){ postMessage({"messageType":"IfElseParametersResult", "ID":ID, "loopObject":self[ID] }); }
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------------------------------ HANDLE SURFACE DATA ------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*
	solveSurfaceData	-	This is the function called when the worker is first called from the main program. It asks as a steward and calls the remaining functions.	\
							The equation solver promise is initiated from this function and the remaining functions are called from the promise.						\
	setSurfaceData		-	This function sets x, y, or z data to the solution of the equation as well as the size and length.											\
	getSurfaceExtremes	-	This function looks at the mins and maxes for each axes for all datasets and sets the overall min and max for the chart						\
	sendSurfaceData		-	This function just sends the data that was created back to the main program																	\
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------------------------- FORMAT ENTERED SURFACE DATA ---------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	These are the first two steps in taking an entry and prepraing it for a surface map. In the first function, an equation is created with the given text and solved	\
	for given the proper parameters. In the second function, the results are placed into the proper spot in the data object. Remember, only the data object is passed	\
	to this function and sent around and not the entire plot object. This was due to the original object containing DOM elements which made it unable to send.			\
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function solveSurfaceData(PlotID, DataID, dataObject, axis, type, Props) 
{	var equation='', eqobj={}, id='', dataIndex=0;
	for (var a=0; a<dataObject.length; a++){ if (dataObject[a]['Format_id']==DataID){ dataIndex=a; } }    
    console.log('in the solve surface with an axis of '+axis+' and a data index of '+dataIndex);
    if (axis=="X") { 	equation=dataObject[dataIndex]['xDataRaw'];	}
	if (axis=="Y") { 	equation=dataObject[dataIndex]['yDataRaw'];	}
	if (axis=="Z") { 	equation=dataObject[dataIndex]['zDataRaw'];	}
	if (axis=="C") { 	equation=dataObject[dataIndex]['cDataRaw'];	}
	eqobj={	Page_position:parseInt(DOM_Object[PlotID]['order'], 10), Format_showtype:"InnerFunction", equation:"Temp="+equation };
	id=CreateEq(FileID, 0, eqobj);
console.log('In solve surface data with an equation of '+equation+' and a type of '+type);
    if ((type=="surface")||(type=="pointCloud"))																											     
	{	eqPromise(id).then( setSurfaceData		(PlotID, DataID, dataObject, axis, id, function () {
							sendSurfaceData		(PlotID, dataObject, type, DataID, Props, axis) 				    
							}) );																				  
	}else if (type=="line")	
	{	eqPromise(id).then( setSurfaceData		(PlotID, DataID, dataObject, axis, id, function () {
							// setLinePoints		(PlotID, DataID, dataObject, axis, Props, function() {
							sendSurfaceData		(PlotID, dataObject, "line", DataID, Props, axis) 
							}) );
	}else if (type=="lathe")	
	{	eqPromise(id).then( setLatheData		(PlotID, DataID, dataObject, axis, id, function () {
							sendSurfaceData		(PlotID, dataObject, "lathe", DataID, Props, axis) 
							}) );
	}	
}	

function setSurfaceData(PlotID, DataID, dataObject, axis, id, callback) 
{	var cMax=-99999999999, cMin=999999999999, dataIndex=0;    
	for (var a=0; a<dataObject.length; a++){ if (dataObject[a]['Format_id']==DataID){ dataIndex=a; } }    
	if(DOM_Object[PlotID]['Dependents']===undefined){ DOM_Object[PlotID]['Dependents']={}; }
	if(DOM_Object[PlotID]['Dependents'][axis]===undefined){ DOM_Object[PlotID]['Dependents'][axis]={}; }
	for (var a in DOM_Object[id]['Dependents'])	{	DOM_Object[PlotID]['Dependents'][axis][a]=1; }  
	if (axis=="X") { 	dataObject[dataIndex].xData=self[id].Solution_real;
						var lengths=self[id].Format_size.split('x'); 	dataObject[dataIndex].xLength=lengths[1];	}
	if (axis=="Y") { 	dataObject[dataIndex].yData=self[id].Solution_real;
						var lengths=self[id].Format_size.split('x'); 	dataObject[dataIndex].yLength=lengths[1];	}
	if (axis=="Z") { 	dataObject[dataIndex].zData=self[id].Solution_real;
						var lengths=self[id].Format_size.split('x'); 
						dataObject[dataIndex].xLength=lengths[0];	dataObject[dataIndex].yLength=lengths[1]; }
	if (axis=="C") { 	dataObject[dataIndex].cData=self[id].Solution_real;
						for (var a in dataObject[dataIndex].cData) 
						{	if (dataObject[dataIndex].cData[a]<cMin) { cMin=dataObject[dataIndex].cData[a]; } 
							if (dataObject[dataIndex].cData[a]>cMax) { cMax=dataObject[dataIndex].cData[a]; } 
						}
						dataObject[dataIndex]['cMax']=cMax;	dataObject[dataIndex]['cMin']=cMin;		}
	if (typeof(callback)=="function") { callback();	}
}

function setLatheData(PlotID, DataID, dataObject, axis, id, callback) 
{	var dataIndex=0;                                                  
	for (var a=0; a<dataObject.length; a++){ if (dataObject[a]['Format_id']==DataID){ dataIndex=a; } }    
    if (axis=="X") { 	dataObject[dataIndex].xData=self[id].Solution_real;
						var lengths=self[id].Format_size.split('x'); 	dataObject[dataIndex].xLength=lengths[1];	}
	if (axis=="Y") { 	dataObject[dataIndex].yData=self[id].Solution_real;
						var lengths=self[id].Format_size.split('x'); 	dataObject[dataIndex].yLength=lengths[1];	}
	if (typeof(callback)=="function") { callback();	}
}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/


/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------- SET THE EXTREMES FOR EVERY PLOT --------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	This is the fourth step in the creation of a surface map. The code simply steps through and finds and maximum and minimum for each axis.							\
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function getSurfaceExtremes (PlotID, DataID, dataObject, Props, callback)
{	var dataIndex=0;                                                  
	for (var a=0; a<dataObject.length; a++){ if (dataObject[a]['Format_id']==DataID){ dataIndex=a; } }    
    if (dataObject[dataIndex].xMin<Props.xMin) { Props.xMin=dataObject[dataIndex].xMin;  } 
	if (dataObject[dataIndex].xMax>Props.xMax) { Props.xMax=dataObject[dataIndex].xMax;  } 
	if (dataObject[dataIndex].yMin<Props.yMin) { Props.yMin=dataObject[dataIndex].yMin;  } 
	if (dataObject[dataIndex].yMax>Props.yMax) { Props.yMax=dataObject[dataIndex].yMax;  } 
	if (dataObject[dataIndex].zMin<Props.zMin) { Props.zMin=dataObject[dataIndex].zMin; Props.flag=1; } 
	if (dataObject[dataIndex].zMax>Props.zMax) { Props.zMax=dataObject[dataIndex].zMax; Props.flag=1; } 	
	if (typeof(callback)=="function") { callback();	}
}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------- SET THE POINTS FOR A LINE --------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	This code sets the individual data points for each line. This is done by creating a spline curve and adding a vector point for each point in the users data. If		\
	either the X or Y are not populated, then the index for those points is used.																						\
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function setLinePoints(PlotID, DataID, dataObject, axis, Props, callback)
{	var xVal=0, yVal=0, zVal=0, lineData=[], xMax=-9999999999, xMin=9999999999, yMax=-9999999999, yMin=9999999999, zMax=-9999999999, zMin=9999999999, dataIndex=0;
	var cMax=-9999999999, cMin=9999999999;
	for (var a=0; a<dataObject.length; a++){ if (dataObject[a]['Format_id']==DataID){ dataIndex=a; } }    
	if (axis=="X") { var thislength=Object.keys(dataObject[dataIndex]['xData']).length; }
	if (axis=="Y") { var thislength=Object.keys(dataObject[dataIndex]['yData']).length; }
	if (axis=="Z") { var thislength=Object.keys(dataObject[dataIndex]['zData']).length; }
	if (axis=="C") { var thislength=Object.keys(dataObject[dataIndex]['cData']).length; }
console.log('The lengths of the x, y, z, and c components are '+Object.keys(dataObject[dataIndex]['xData']).length+'-'+Object.keys(dataObject[dataIndex]['yData']).length+'-'+Object.keys(dataObject[dataIndex]['zData']).length+'-'+Object.keys(dataObject[dataIndex]['cData']).length);
	for (var thisDataID in dataObject)
	{	
		if (dataObject[thisDataID]['type']=="line")
		{	
			for (var a=0; a<thislength; a++)
			{	
				if (dataObject[thisDataID].xData['0-'+a]===undefined){ xVal=a; }else { xVal=dataObject[thisDataID].xData['0-'+a]; }
				if (dataObject[thisDataID].yData['0-'+a]===undefined){ yVal=a; }else { yVal=dataObject[thisDataID].yData['0-'+a]; }
				zVal=dataObject[thisDataID].zData['0-'+a]; 
				cVal=dataObject[thisDataID].cData['0-'+a]; 
console.log('A new three vector is being pushed with values of '+xVal+'-'+yVal+'-'+zVal);
				// lineData.push(new THREE.Vector3(xVal, yVal, zVal));
				if (xVal>xMax) { dataObject[thisDataID].xMax=xVal; xMax=xVal; }
				if (xVal<xMin) { dataObject[thisDataID].xMin=xVal; xMin=xVal; }
				if (yVal>yMax) { dataObject[thisDataID].yMax=yVal; yMax=yVal; }
				if (yVal<yMin) { dataObject[thisDataID].yMin=yVal; yMin=yVal; }
				if (zVal>zMax) { dataObject[thisDataID].zMax=zVal; zMax=zVal; }
				if (zVal<zMin) { dataObject[thisDataID].zMin=zVal; zMin=zVal; }
				if (cVal>cMax) { dataObject[thisDataID].cMax=cVal; cMax=cVal; }
				if (cVal<cMin) { dataObject[thisDataID].cMin=cVal; cMin=cVal; }
	}	}	}
	Props.xMin=xMin;	Props.xMax=xMax;
	Props.yMin=yMin;	Props.yMax=yMax;
	Props.zMin=zMin;	Props.zMax=zMax;
	// dataObject[dataIndex].lineGeometry=new THREE.SplineCurve3(lineData);
	if (typeof(callback)=="function") { callback();	}
}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------- SET THE COLORS IN THE SURFACE MAP ------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	The sixth and final code involved in solving and sending surface map data, this code simply sends the data created back to the main code.
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function sendSurfaceData (PlotID, dataObject, type, DataID, Props, axis, callback)
{	postMessage(
	{	"messageType":"SurfaceData", 
		"PlotID":PlotID, 
		"DataID":DataID, 
		"Props":Props,
		"Axis":axis,
		"Deps":DOM_Object[PlotID]['Dependents'],
		"type":type,
		"dataObject":dataObject
	});
	if (typeof(callback)=="function") { callback();	}
}


/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------------- THE XML REQUEST FUNCTION ------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*	This function is used throughout the worker to make ajax calls to the document controller.
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
function loadData(url, callback) {
	var xhr;
	if(typeof XMLHttpRequest !== 'undefined') xhr = new XMLHttpRequest();
	else 
	{	var versions = ["MSXML2.XmlHttp.5.0", 
			 	"MSXML2.XmlHttp.4.0",
			 	"MSXML2.XmlHttp.3.0", 
			 	"MSXML2.XmlHttp.2.0",
			 	"Microsoft.XmlHttp"]
		for(var i = 0, len = versions.length; i < len; i++) {
			try {
				xhr = new ActiveXObject(versions[i]);
				break;
			}
			catch(e){}
		} 
	}
	xhr.onreadystatechange = ensureReadiness;
	function ensureReadiness() 
	{	if(xhr.readyState < 4) { 	return; }
		if(xhr.status !== 200) { 	return; }
		if(xhr.readyState === 4) {	callback(xhr); }
	}
	xhr.open('GET', url, true);
	xhr.send('');

}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/


/* big.js v3.2.0 https://github.com/MikeMcl/big.js/LICENCE */
!function(e){"use strict";function t(){function e(r){var i=this;return i instanceof e?(r instanceof e?(i.s=r.s,i.e=r.e,i.c=r.c.slice()):n(i,r),void(i.constructor=e)):void 0===r?t():new e(r)}return e.prototype=g,e.DP=c,e.RM=u,e.E_NEG=l,e.E_POS=a,e}function r(e,t,r){var n=e.constructor,s=t-(e=new n(e)).e,o=e.c;for(o.length>++t&&i(e,s,n.RM),o[0]?r?s=t:(o=e.c,s=e.e+s+1):++s;o.length<s;o.push(0));return s=e.e,1===r||r&&(s>=t||s<=n.E_NEG)?(e.s<0&&o[0]?"-":"")+(o.length>1?o[0]+"."+o.join("").slice(1):o[0])+(0>s?"e":"e+")+s:e.toString()}function n(e,t){var r,n,i;for(0===t&&0>1/t?t="-0":p.test(t+="")||s(NaN),e.s="-"==t.charAt(0)?(t=t.slice(1),-1):1,(r=t.indexOf("."))>-1&&(t=t.replace(".","")),(n=t.search(/e/i))>0?(0>r&&(r=n),r+=+t.slice(n+1),t=t.substring(0,n)):0>r&&(r=t.length),i=t.length,n=0;i>n&&"0"==t.charAt(n);n++);if(n==i)e.c=[e.e=0];else{for(;i>0&&"0"==t.charAt(--i););for(e.e=r-n-1,e.c=[];i>=n;e.c.push(+t.charAt(n++)));}return e}function i(e,t,r,n){var i,o=e.c,c=e.e+t+1;if(1===r?n=o[c]>=5:2===r?n=o[c]>5||5==o[c]&&(n||0>c||o[c+1]!==i||1&o[c-1]):3===r?n=n||o[c]!==i||0>c:(n=!1,0!==r&&s("!Big.RM!")),1>c||!o[0])n?(e.e=-t,e.c=[1]):e.c=[e.e=0];else{if(o.length=c--,n)for(;++o[c]>9;)o[c]=0,c--||(++e.e,o.unshift(1));for(c=o.length;!o[--c];o.pop());}return e}function s(e){var t=new Error(e);throw t.name="BigError",t}var o,c=20,u=1,f=1e6,h=1e6,l=-7,a=21,g={},p=/^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;g.abs=function(){var e=new this.constructor(this);return e.s=1,e},g.cmp=function(e){var t,r=this,n=r.c,i=(e=new r.constructor(e)).c,s=r.s,o=e.s,c=r.e,u=e.e;if(!n[0]||!i[0])return n[0]?s:i[0]?-o:0;if(s!=o)return s;if(t=0>s,c!=u)return c>u^t?1:-1;for(s=-1,o=(c=n.length)<(u=i.length)?c:u;++s<o;)if(n[s]!=i[s])return n[s]>i[s]^t?1:-1;return c==u?0:c>u^t?1:-1},g.div=function(e){var t=this,r=t.constructor,n=t.c,o=(e=new r(e)).c,c=t.s==e.s?1:-1,u=r.DP;if((u!==~~u||0>u||u>f)&&s("!Big.DP!"),!n[0]||!o[0])return n[0]==o[0]&&s(NaN),o[0]||s(c/0),new r(0*c);var h,l,a,g,p,v,d=o.slice(),w=h=o.length,m=n.length,E=n.slice(0,h),N=E.length,P=e,S=P.c=[],M=0,_=u+(P.e=t.e-e.e)+1;for(P.s=c,c=0>_?0:_,d.unshift(0);N++<h;E.push(0));do{for(a=0;10>a;a++){if(h!=(N=E.length))g=h>N?1:-1;else for(p=-1,g=0;++p<h;)if(o[p]!=E[p]){g=o[p]>E[p]?1:-1;break}if(!(0>g))break;for(l=N==h?o:d;N;){if(E[--N]<l[N]){for(p=N;p&&!E[--p];E[p]=9);--E[p],E[N]+=10}E[N]-=l[N]}for(;!E[0];E.shift());}S[M++]=g?a:++a,E[0]&&g?E[N]=n[w]||0:E=[n[w]]}while((w++<m||E[0]!==v)&&c--);return S[0]||1==M||(S.shift(),P.e--),M>_&&i(P,u,r.RM,E[0]!==v),P},g.eq=function(e){return!this.cmp(e)},g.gt=function(e){return this.cmp(e)>0},g.gte=function(e){return this.cmp(e)>-1},g.lt=function(e){return this.cmp(e)<0},g.lte=function(e){return this.cmp(e)<1},g.sub=g.minus=function(e){var t,r,n,i,s=this,o=s.constructor,c=s.s,u=(e=new o(e)).s;if(c!=u)return e.s=-u,s.plus(e);var f=s.c.slice(),h=s.e,l=e.c,a=e.e;if(!f[0]||!l[0])return l[0]?(e.s=-u,e):new o(f[0]?s:0);if(c=h-a){for((i=0>c)?(c=-c,n=f):(a=h,n=l),n.reverse(),u=c;u--;n.push(0));n.reverse()}else for(r=((i=f.length<l.length)?f:l).length,c=u=0;r>u;u++)if(f[u]!=l[u]){i=f[u]<l[u];break}if(i&&(n=f,f=l,l=n,e.s=-e.s),(u=(r=l.length)-(t=f.length))>0)for(;u--;f[t++]=0);for(u=t;r>c;){if(f[--r]<l[r]){for(t=r;t&&!f[--t];f[t]=9);--f[t],f[r]+=10}f[r]-=l[r]}for(;0===f[--u];f.pop());for(;0===f[0];)f.shift(),--a;return f[0]||(e.s=1,f=[a=0]),e.c=f,e.e=a,e},g.mod=function(e){var t,r=this,n=r.constructor,i=r.s,o=(e=new n(e)).s;return e.c[0]||s(NaN),r.s=e.s=1,t=1==e.cmp(r),r.s=i,e.s=o,t?new n(r):(i=n.DP,o=n.RM,n.DP=n.RM=0,r=r.div(e),n.DP=i,n.RM=o,this.minus(r.times(e)))},g.add=g.plus=function(e){var t,r=this,n=r.constructor,i=r.s,s=(e=new n(e)).s;if(i!=s)return e.s=-s,r.minus(e);var o=r.e,c=r.c,u=e.e,f=e.c;if(!c[0]||!f[0])return f[0]?e:new n(c[0]?r:0*i);if(c=c.slice(),i=o-u){for(i>0?(u=o,t=f):(i=-i,t=c),t.reverse();i--;t.push(0));t.reverse()}for(c.length-f.length<0&&(t=f,f=c,c=t),i=f.length,s=0;i;)s=(c[--i]=c[i]+f[i]+s)/10|0,c[i]%=10;for(s&&(c.unshift(s),++u),i=c.length;0===c[--i];c.pop());return e.c=c,e.e=u,e},g.pow=function(e){var t=this,r=new t.constructor(1),n=r,i=0>e;for((e!==~~e||-h>e||e>h)&&s("!pow!"),e=i?-e:e;1&e&&(n=n.times(t)),e>>=1,e;)t=t.times(t);return i?r.div(n):n},g.round=function(e,t){var r=this,n=r.constructor;return null==e?e=0:(e!==~~e||0>e||e>f)&&s("!round!"),i(r=new n(r),e,null==t?n.RM:t),r},g.sqrt=function(){var e,t,r,n=this,o=n.constructor,c=n.c,u=n.s,f=n.e,h=new o("0.5");if(!c[0])return new o(n);0>u&&s(NaN),u=Math.sqrt(n.toString()),0===u||u===1/0?(e=c.join(""),e.length+f&1||(e+="0"),t=new o(Math.sqrt(e).toString()),t.e=((f+1)/2|0)-(0>f||1&f)):t=new o(u.toString()),u=t.e+(o.DP+=4);do r=t,t=h.times(r.plus(n.div(r)));while(r.c.slice(0,u).join("")!==t.c.slice(0,u).join(""));return i(t,o.DP-=4,o.RM),t},g.mul=g.times=function(e){var t,r=this,n=r.constructor,i=r.c,s=(e=new n(e)).c,o=i.length,c=s.length,u=r.e,f=e.e;if(e.s=r.s==e.s?1:-1,!i[0]||!s[0])return new n(0*e.s);for(e.e=u+f,c>o&&(t=i,i=s,s=t,f=o,o=c,c=f),t=new Array(f=o+c);f--;t[f]=0);for(u=c;u--;){for(c=0,f=o+u;f>u;)c=t[f]+s[u]*i[f-u-1]+c,t[f--]=c%10,c=c/10|0;t[f]=(t[f]+c)%10}for(c&&++e.e,t[0]||t.shift(),u=t.length;!t[--u];t.pop());return e.c=t,e},g.toString=g.valueOf=g.toJSON=function(){var e=this,t=e.constructor,r=e.e,n=e.c.join(""),i=n.length;if(r<=t.E_NEG||r>=t.E_POS)n=n.charAt(0)+(i>1?"."+n.slice(1):"")+(0>r?"e":"e+")+r;else if(0>r){for(;++r;n="0"+n);n="0."+n}else if(r>0)if(++r>i)for(r-=i;r--;n+="0");else i>r&&(n=n.slice(0,r)+"."+n.slice(r));else i>1&&(n=n.charAt(0)+"."+n.slice(1));return e.s<0&&e.c[0]?"-"+n:n},g.toExponential=function(e){return null==e?e=this.c.length-1:(e!==~~e||0>e||e>f)&&s("!toExp!"),r(this,e,1)},g.toFixed=function(e){var t,n=this,i=n.constructor,o=i.E_NEG,c=i.E_POS;return i.E_NEG=-(i.E_POS=1/0),null==e?t=n.toString():e===~~e&&e>=0&&f>=e&&(t=r(n,n.e+e),n.s<0&&n.c[0]&&t.indexOf("-")<0&&(t="-"+t)),i.E_NEG=o,i.E_POS=c,t||s("!toFix!"),t},g.toPrecision=function(e){return null==e?this.toString():((e!==~~e||1>e||e>f)&&s("!toPre!"),r(this,e-1,2))},o=t(),"function"==typeof define&&define.amd?define(function(){return o}):"undefined"!=typeof module&&module.exports?(module.exports=o,module.exports.Big=o):e.Big=o}(this);
//# sourceMappingURL=doc/big.js.map

/*
	This function sorts an array based upon a property within the objects in the array
*/
function dynamicSort(property) {
    var sortOrder = 1;
    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a,b) {
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }
}

!function n(t,e,o){function i(u,f){if(!e[u]){if(!t[u]){var c="function"==typeof require&&require;if(!f&&c)return c(u,!0);if(r)return r(u,!0);var s=new Error("Cannot find module '"+u+"'");throw s.code="MODULE_NOT_FOUND",s}var a=e[u]={exports:{}};t[u][0].call(a.exports,function(n){var e=t[u][1][n];return i(e?e:n)},a,a.exports,n,t,e,o)}return e[u].exports}for(var r="function"==typeof require&&require,u=0;u<o.length;u++)i(o[u]);return i}({1:[function(n,t){function e(){}var o=t.exports={};o.nextTick=function(){var n="undefined"!=typeof window&&window.setImmediate,t="undefined"!=typeof window&&window.postMessage&&window.addEventListener;if(n)return function(n){return window.setImmediate(n)};if(t){var e=[];return window.addEventListener("message",function(n){var t=n.source;if((t===window||null===t)&&"process-tick"===n.data&&(n.stopPropagation(),e.length>0)){var o=e.shift();o()}},!0),function(n){e.push(n),window.postMessage("process-tick","*")}}return function(n){setTimeout(n,0)}}(),o.title="browser",o.browser=!0,o.env={},o.argv=[],o.on=e,o.addListener=e,o.once=e,o.off=e,o.removeListener=e,o.removeAllListeners=e,o.emit=e,o.binding=function(){throw new Error("process.binding is not supported")},o.cwd=function(){return"/"},o.chdir=function(){throw new Error("process.chdir is not supported")}},{}],2:[function(n,t){"use strict";function e(n){function t(n){return null===c?void a.push(n):void r(function(){var t=c?n.onFulfilled:n.onRejected;if(null===t)return void(c?n.resolve:n.reject)(s);var e;try{e=t(s)}catch(o){return void n.reject(o)}n.resolve(e)})}function e(n){try{if(n===l)throw new TypeError("A promise cannot be resolved with itself.");if(n&&("object"==typeof n||"function"==typeof n)){var t=n.then;if("function"==typeof t)return void i(t.bind(n),e,u)}c=!0,s=n,f()}catch(o){u(o)}}function u(n){c=!1,s=n,f()}function f(){for(var n=0,e=a.length;e>n;n++)t(a[n]);a=null}if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof n)throw new TypeError("not a function");var c=null,s=null,a=[],l=this;this.then=function(n,e){return new l.constructor(function(i,r){t(new o(n,e,i,r))})},i(n,e,u)}function o(n,t,e,o){this.onFulfilled="function"==typeof n?n:null,this.onRejected="function"==typeof t?t:null,this.resolve=e,this.reject=o}function i(n,t,e){var o=!1;try{n(function(n){o||(o=!0,t(n))},function(n){o||(o=!0,e(n))})}catch(i){if(o)return;o=!0,e(i)}}var r=n("asap");t.exports=e},{asap:4}],3:[function(n,t){"use strict";function e(n){this.then=function(t){return"function"!=typeof t?this:new o(function(e,o){i(function(){try{e(t(n))}catch(i){o(i)}})})}}var o=n("./core.js"),i=n("asap");t.exports=o,e.prototype=o.prototype;var r=new e(!0),u=new e(!1),f=new e(null),c=new e(void 0),s=new e(0),a=new e("");o.resolve=function(n){if(n instanceof o)return n;if(null===n)return f;if(void 0===n)return c;if(n===!0)return r;if(n===!1)return u;if(0===n)return s;if(""===n)return a;if("object"==typeof n||"function"==typeof n)try{var t=n.then;if("function"==typeof t)return new o(t.bind(n))}catch(i){return new o(function(n,t){t(i)})}return new e(n)},o.all=function(n){var t=Array.prototype.slice.call(n);return new o(function(n,e){function o(r,u){try{if(u&&("object"==typeof u||"function"==typeof u)){var f=u.then;if("function"==typeof f)return void f.call(u,function(n){o(r,n)},e)}t[r]=u,0===--i&&n(t)}catch(c){e(c)}}if(0===t.length)return n([]);for(var i=t.length,r=0;r<t.length;r++)o(r,t[r])})},o.reject=function(n){return new o(function(t,e){e(n)})},o.race=function(n){return new o(function(t,e){n.forEach(function(n){o.resolve(n).then(t,e)})})},o.prototype["catch"]=function(n){return this.then(null,n)}},{"./core.js":2,asap:4}],4:[function(n,t){(function(n){function e(){for(;i.next;){i=i.next;var n=i.task;i.task=void 0;var t=i.domain;t&&(i.domain=void 0,t.enter());try{n()}catch(o){if(c)throw t&&t.exit(),setTimeout(e,0),t&&t.enter(),o;setTimeout(function(){throw o},0)}t&&t.exit()}u=!1}function o(t){r=r.next={task:t,domain:c&&n.domain,next:null},u||(u=!0,f())}var i={task:void 0,next:null},r=i,u=!1,f=void 0,c=!1;if("undefined"!=typeof n&&n.nextTick)c=!0,f=function(){n.nextTick(e)};else if("function"==typeof setImmediate)f="undefined"!=typeof window?setImmediate.bind(window,e):function(){setImmediate(e)};else if("undefined"!=typeof MessageChannel){var s=new MessageChannel;s.port1.onmessage=e,f=function(){s.port2.postMessage(0)}}else f=function(){setTimeout(e,0)};t.exports=o}).call(this,n("_process"))},{_process:1}],5:[function(){"function"!=typeof Promise.prototype.done&&(Promise.prototype.done=function(){var n=arguments.length?this.then.apply(this,arguments):this;n.then(null,function(n){setTimeout(function(){throw n},0)})})},{}],6:[function(n){n("asap");"undefined"==typeof Promise&&(Promise=n("./lib/core.js"),n("./lib/es6-extensions.js")),n("./polyfill-done.js")},{"./lib/core.js":2,"./lib/es6-extensions.js":3,"./polyfill-done.js":5,asap:4}]},{},[6]);


/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*--------------------------------------------------------------- Creating Error Messages -----------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

// This function is called whenever the code comes across an error. It clears the appropriate items so that equation cannot be continued. It sets the error flag as well.
// The function takes in the id number of the overall equation, and the two id numbers for any subequations that math is being performed on.
function Set_Error(thisid, Error_Num, id1, id2)
{	console.log('The error for '+thisid+' was set - '+Error_Num);
	if (DOM_Object[thisid].Errors_errors===undefined) { DOM_Object[thisid].Errors_errors=[]; }
	DOM_Object[thisid].Errors_flag=1;
	if (self[thisid].Errors_errors===undefined) { self[thisid].Errors_errors=[]; }
	self[thisid].Errors_flag=1;
	if (self[self[thisid]['Original_id']]===undefined){ self[thisid]['Original_id']=thisid; }
	self[self[thisid]['Original_id']].Errors_flag=1;

	if (Error_Num=="NoEntry") { self[thisid].Errors_errors.push("The function "+id1+" did not receive an input as expected."); }

	if (Error_Num=="Math1") { self[thisid].Errors_errors.push("You have attempted to add a "+self[id1].Units_quantity+" to a "+self[id2].Units_quantity+" by adding "+self[id1].Format_showequation+" to "+self[id2].Format_showequation); }
	if (Error_Num=="Math2") { self[thisid].Errors_errors.push("You have attempted to subtract a "+self[id1].Units_quantity+" and a "+self[id2].Units_quantity+" by subtracting "+self[id2].Format_showequation+" from "+self[id1].Format_showequation); }
	if (Error_Num=="Math3") { self[thisid].Errors_errors.push("You are attempting to add a "+self[id1].Format_size+" matrix to one that is "+self[id2].Format_size); }
	if (Error_Num=="Math4") { self[thisid].Errors_errors.push("You are attempting to subtract a "+self[id1].Format_size+" matrix to one that is "+self[id2].Format_size); }
	if (Error_Num=="Math5") { self[thisid].Errors_errors.push("You are attempting to build a matrix with different units a - '"+id1+"' and a '"+id2+"'"); }

	if (Error_Num=="Format1") { self[thisid].Errors_errors.push("The name '"+DOM_Object[thisid].Format_name+"' is the name of a constant and cannot be reset.");}
	if (Error_Num=="Format2") { self[thisid].Errors_errors.push('The item "'+id1+'" was not identified as a variable, input, constant, or mathematics item. Check the spelling of the item if it was intended to be a variable.'); }
	if (Error_Num=="Format3") { self[thisid].Errors_errors.push("The units entered \""+self[id1].Units_units+"\" do match any current units."); }
	if (Error_Num=="Format4") { self[thisid].Errors_errors.push("The equation has an unmatched closing or opening parenthesis."); }
	if (Error_Num=="Format5") { self[thisid].Errors_errors.push("The equation has an unmatched closing or opening square bracket."); }
	if (Error_Num=="Format6") { self[thisid].Errors_errors.push("The name of an equation cannot be TempEq as this is a reserved phrase."); }
	if (Error_Num=="Format7") { self[thisid].Errors_errors.push("No equation was found. Check to ensure that the equation has a name=equation format."); }
	if (Error_Num=="Format8") { self[thisid].Errors_errors.push("No name was found. Check to ensure that the equation has the format name=equation."); }
	if (Error_Num=="Format9") { self[thisid].Errors_errors.push("There was no matching equation found for the one you are trying to display - "+DOM_Object[thisid].Format_name+"."); }
	if (Error_Num=="Format10") { self[thisid].Errors_errors.push("You are attempting to set the indices of a matrix that does not exist. - "+DOM_Object[thisid].Format_name+"."); }
	if (Error_Num=="Format11") { self[thisid].Errors_errors.push("You are attempting to take a temperature to a power - something that should not happen. - "+DOM_Object[thisid].Format_name+"."); }
	if (Error_Num=="Format12") { self[thisid].Errors_errors.push("The name of an equation matched a unit, which is illegal."); }
	if (Error_Num=="Format13") { self[thisid].Errors_errors.push("The name of an equation must contain at least one letter."); }
	if (Error_Num=="Format14") { self[thisid].Errors_errors.push("The name of the equation entered contained something other than a letter, number, _, ^, { or }."); }
	if (Error_Num=="Format15") { self[thisid].Errors_errors.push("The equation must contain an equal sign."); }

	if (Error_Num=="ForLoop1") { self[thisid].Errors_errors.push("The parameters entered will not generate any iterations of this loop."); }
	if (Error_Num=="ForLoop2") { self[thisid].Errors_errors.push("One of the loop counters - a, b, c, etc - is reset within the loop. This is not allowed."); }
	if (Error_Num=="ForLoop3") { self[thisid].Errors_errors.push("The equation entered for the start value resulted in an error. Make sure that all variables and constants are spelled correctly and have been properly declared."); }
	if (Error_Num=="ForLoop4") { self[thisid].Errors_errors.push("The equation entered for the stop value resulted in an error. Make sure that all variables and constants are spelled correctly and have been properly declared."); }
	if (Error_Num=="ForLoop5") { self[thisid].Errors_errors.push("The equation entered for the increment value resulted in an error. Make sure that all variables and constants are spelled correctly and have been properly declared."); }

	if (Error_Num=="WhileLoop1") { self[thisid].Errors_errors.push("The flag is not reset within the while loop, leading to an infinite loop."); }
	if (Error_Num=="WhileLoop2") { self[thisid].Errors_errors.push("The equation entered for the flag value produced an error. Check to make sure that any variables were spelled correctly and declared properly."); }
	if (Error_Num=="WhileLoop3") { self[thisid].Errors_errors.push("The equation entered for the dependent value produced an error. Check to make sure that any variables were spelled correctly and declared properly."); }

	if (Error_Num=="Flag") 		{ self[thisid].Errors_errors.push("The equation entered for the flag value produced an error. Check to make sure that any variables were spelled correctly and declared properly."); }
	if (Error_Num=="Dependent") { self[thisid].Errors_errors.push("The equation entered for the dependent value produced an error. Check to make sure that any variables were spelled correctly and declared properly."); }

	if (Error_Num=="Transpose1") { self[thisid].Errors_errors.push("The Transpose function received more than one input."); }
	if (Error_Num=="Transpose2") { self[thisid].Errors_errors.push("You are transposing a matrix that is not two-dimensional."); }
	if (Error_Num=="DotProduct1") { self[thisid].Errors_errors.push("You are attempting to perform component multiplication of two matrices of unequal size."); }

	if (Error_Num=="FAF1") { self[thisid].Errors_errors.push("The function called returns multiple values, but the results are used in an equation."); }

	if (Error_Num=="Indices1") { self[thisid].Errors_errors.push("You are attempting to set an index that is outside of the size of the matrix."); }
	
	if (Error_Num=="NC1") { self[thisid].Errors_errors.push("The total number of points is not correct for a second order equation of Newton-Cotes."); }
	if (Error_Num=="NC2") { self[thisid].Errors_errors.push("The total number of points is not correct for a third order equation of Newton-Cotes."); }
	if (Error_Num=="NC3") { self[thisid].Errors_errors.push("The total number of points is not correct for a fourth order equation of Newton-Cotes."); }
	if (Error_Num=="NC4") { self[thisid].Errors_errors.push("The Newton-Cotes method expects to receive 3 inputs."); }
	if (Error_Num=="NC5") { self[thisid].Errors_errors.push("The Newton-Cotes method expects to receive 3 inputs."); }
	if (Error_Num=="NC6") { self[thisid].Errors_errors.push("The X and Y data for the Newton Cotes method must be the same length."); }
	if (Error_Num=="NC7") { self[thisid].Errors_errors.push("The order must be a single number."); }
	if (Error_Num=="NC8") { self[thisid].Errors_errors.push("The x and y vectors were not long enough for the NC calculations."); }

	if (Error_Num=="Integrate1") { self[thisid].Errors_errors.push("The integration algorithm expects 2 inputs."); }
	if (Error_Num=="Integrate2") { self[thisid].Errors_errors.push("The integration algorithm expects 2 inputs."); }
	if (Error_Num=="Integrate3") { self[thisid].Errors_errors.push("The length of the x and y vectors must match for the integration function."); }
	if (Error_Num=="Integrate4") { self[thisid].Errors_errors.push("The vector was not long enough for the integration algorithm."); }

	if (Error_Num=="Root1") { self[thisid].Errors_errors.push("This equation resulted in units that were not whole numbers."); }

	if (Error_Num=="Trig1") { self[thisid].Errors_errors.push("Trig functions expect to see one number or variable. You entered "+id1+" variables into a "+id2+" function."); }
	if (Error_Num=="Trig2") { self[thisid].Errors_errors.push("The function "+id1+" received units of "+id2+" and it should receive either degrees, radians, or no units."); }

	if (Error_Num=="Min1") { self[thisid].Errors_errors.push("You called the min function with no inputs."); }
	if (Error_Num=="Max1") { self[thisid].Errors_errors.push("You called the max function with no inputs."); }

	if (Error_Num=="Min2") { self[thisid].Errors_errors.push("You are comparing inconsistent units within a min function."); }
	if (Error_Num=="Max2") { self[thisid].Errors_errors.push("You are comparing inconsistent units within a max function."); }

	if (Error_Num=="Abs1") { self[thisid].Errors_errors.push("The absolute value function received more than one input."); }

	if (Error_Num=="Floor1") { self[thisid].Errors_errors.push("You called the floor function with no inputs."); }
	if (Error_Num=="Floor2") { self[thisid].Errors_errors.push("You called the floor function with more than 2 inputs. If you are trying to enter units, the second entry must be an array as in [ft, s, kg]"); }
	if (Error_Num=="Floor3") { self[thisid].Errors_errors.push("The floor function requires that the second input be a known unit."); }

	if (Error_Num=="Ceil1") { self[thisid].Errors_errors.push("You called the ceil function with no inputs."); }
	if (Error_Num=="Ceil2") { self[thisid].Errors_errors.push("You called the ceil function with more than 2 inputs. If you are trying to enter units, the second entry must be an array as in [ft, s, kg]"); }
	if (Error_Num=="Ceil3") { self[thisid].Errors_errors.push("The ceil function requires that the second input be a known unit."); }

	if (Error_Num=="Round1") { self[thisid].Errors_errors.push("You entered more than 2 entries into the round function."); }
	if (Error_Num=="Round2") { self[thisid].Errors_errors.push("The precision given for the round function must be an integer."); }

	if (Error_Num=="log1") { self[thisid].Errors_errors.push("The log function expects at least 2 entries."); }
	if (Error_Num=="log2") { self[thisid].Errors_errors.push("The log function cannot take more than 2 entries."); }
	if (Error_Num=="log3") { self[thisid].Errors_errors.push("You attempted to take the logarithm of 0."); }

	if (Error_Num=="Power1") { self[thisid].Errors_errors.push("The power function expects to receive 2 entries."); }
	if (Error_Num=="Power2") { self[thisid].Errors_errors.push("The power function cannot handle more than 2 entries."); }
	if (Error_Num=="Power3") { self[thisid].Errors_errors.push("You attempted to use an exponent that had units."); }
	if (Error_Num=="Power4") { self[thisid].Errors_errors.push("The exponent entered was not a single number nor equal in size to the base."); }
	if (Error_Num=="Power5") { self[thisid].Errors_errors.push("The resulting power function had units of "+id1+" which was not a whole number."); }
	if (Error_Num=="Power6") { self[thisid].Errors_errors.push("The javascript power and root functions cannot handle components in the exponent."); }

	if (Error_Num=="Root1") { self[thisid].Errors_errors.push("The root function expects to receive 2 entries."); }
	if (Error_Num=="Root2") { self[thisid].Errors_errors.push("The root function cannot handle more than 2 entries."); }
	if (Error_Num=="Root3") { self[thisid].Errors_errors.push("You attempted to use a root that has units."); }
	if (Error_Num=="Root4") { self[thisid].Errors_errors.push("The root number entered was not a single number nor equal in size to the equation."); }
	if (Error_Num=="Root5") { self[thisid].Errors_errors.push("The resulting root function had units of "+id1+" which was not a whole number."); }

	if (Error_Num=="Derivative1") { self[thisid].Errors_errors.push("The derivative function expects to receive 4 entries."); }
	if (Error_Num=="Derivative2") { self[thisid].Errors_errors.push("The derivative function expects to receive 4 entries."); }
	if (Error_Num=="Derivative3") { self[thisid].Errors_errors.push("The order must be a 1, 2, 3, or 4."); }
	if (Error_Num=="Derivative4") { self[thisid].Errors_errors.push("The accuracy must be a 1 or a 2."); }
	if (Error_Num=="Derivative5") { self[thisid].Errors_errors.push("The vectors were not long enough to perform the derivative calculation."); }

	if (Error_Num=="DerivativeUn1") { self[thisid].Errors_errors.push("The derivative function expects to receive 3 entries."); }
	if (Error_Num=="DerivativeUn2") { self[thisid].Errors_errors.push("The derivative function expects to receive 3 entries."); }
	if (Error_Num=="DerivativeUn3") { self[thisid].Errors_errors.push("The x location asked for in DerivativeUn - "+id1+" - is not within the original x vector."); }
	if (Error_Num=="DerivativeUn4") { self[thisid].Errors_errors.push("The sampled x locations and the y data must be the same length for DerivativeUn."); }
	if (Error_Num=="DerivativeUn5") { self[thisid].Errors_errors.push("The vectors were not long enough to perform the derivative calculation."); }

	if (Error_Num=="Vector1") { self[thisid].Errors_errors.push("To make a vector from a table, either the columns or the rows of the two table elements must be equal."); }
	if (Error_Num=="Vector2") { self[thisid].Errors_errors.push("To make a vector from a table, the second row entered must be a greater number than the first."); }
	if (Error_Num=="Vector3") { self[thisid].Errors_errors.push("There were unmatching units used in the creation of the vector."); }

	if (Error_Num=="Identity1") { self[thisid].Errors_errors.push("The Identity function expects to take in a single number as its input."); }

	if (Error_Num=="CreateMatrix1") { self[thisid].Errors_errors.push("The CreateMatrix function expects to take in 4 arguments - the real default, the imaginary default, and the number of rows and columns.."); }

	if (Error_Num=="Size1") { self[thisid].Errors_errors.push("The size function expects to receive 2 inputs, but recieved more."); }
	if (Error_Num=="Size2") { self[thisid].Errors_errors.push("The size function expects to receive 2 inputs, but received only 1."); }

	if (Error_Num=="Real1") { self[thisid].Errors_errors.push("The Real function expects to receive 1 input, but recieved more."); }
	if (Error_Num=="Imag1") { self[thisid].Errors_errors.push("The Imag function expects to receive 1 input, but received more."); }

	if (Error_Num=="rand1") { self[thisid].Errors_errors.push("The rand function did not receive the correct number of inputs - 3."); }
	if (Error_Num=="rand2") { self[thisid].Errors_errors.push("The lower limit of the random number was higher than the higher limit entered."); }
	if (Error_Num=="rand3") { self[thisid].Errors_errors.push("The precision entered for the random number generator was less than 0."); }
	if (Error_Num=="randMat1") { self[thisid].Errors_errors.push("The randMat function did not receive the correct number of inputs - 5."); }
	if (Error_Num=="randMat2") { self[thisid].Errors_errors.push("The lower limit of the random number was higher than the higher limit entered."); }
	if (Error_Num=="randMat3") { self[thisid].Errors_errors.push("The precision entered for the random number generator was less than 0."); }

	if (Error_Num=="GaussE1") { self[thisid].Errors_errors.push("The GaussE function expects to receive 2 inputs and received more than that."); }
	if (Error_Num=="GaussE2") { self[thisid].Errors_errors.push("The coefficient matrix received by the GaussE function was not square."); }
	if (Error_Num=="GaussE3") { self[thisid].Errors_errors.push("The size of the coefficient matrix must match the number of rows in the results vector."); }
	if (Error_Num=="GaussE4") { self[thisid].Errors_errors.push("The results vector was not in the form of a column vector."); }

	if (Error_Num=="Mean1") { self[thisid].Errors_errors.push("The mean function failed to receive an input."); }
	if (Error_Num=="Mean2") { self[thisid].Errors_errors.push("The mean function received units that were of different quantities."); }
	if (Error_Num=="Median1") { self[thisid].Errors_errors.push("The median function failed to receive an input."); }
	if (Error_Num=="Median2") { self[thisid].Errors_errors.push("The median function received units that were of different quantities."); }
	if (Error_Num=="Mode1") { self[thisid].Errors_errors.push("The mode function failed to receive an input."); }
	if (Error_Num=="Mode2") { self[thisid].Errors_errors.push("The mode function received units that were of different quantities."); }
	if (Error_Num=="Range1") { self[thisid].Errors_errors.push("The range function failed to receive an input."); }
	if (Error_Num=="Range2") { self[thisid].Errors_errors.push("The range function received units that were of different quantities."); }
	if (Error_Num=="Sum1") { self[thisid].Errors_errors.push("The sum function failed to receive an input."); }
	if (Error_Num=="Sum2") { self[thisid].Errors_errors.push("The sum function received units that were of different quantities."); }

	if (Error_Num=="StdDev1") { self[thisid].Errors_errors.push("The standard deviation function failed to receive an input."); }
	if (Error_Num=="Variance1") { self[thisid].Errors_errors.push("The variance function failed to receive an input."); }
	if (Error_Num=="CV1") { self[thisid].Errors_errors.push("The coefficient of variation function failed to receive an input."); }

	if (Error_Num=="Polyfit1") { self[thisid].Errors_errors.push("The polyfit function expects 3 inputs and recieved less than that."); }
	if (Error_Num=="Polyfit2") { self[thisid].Errors_errors.push("The polyfit function expects 3 inputs and recieved more than that."); }
	if (Error_Num=="Polyfit3") { self[thisid].Errors_errors.push("The polyfit function can output a coefficient vector and a coefficients of determination. It cannot output more than two items."); }
	if (Error_Num=="Polyfit4") { self[thisid].Errors_errors.push("The polynomial type entered into polyfit must be a single integer. Its size was "+self[id1].Format_size+" and its value was "+self[id1].Solution_real['0-0']); }
	if (Error_Num=="Polyfit5") { self[thisid].Errors_errors.push("The x and y vectores entered into polyfit were not the same size. The x vector was "+self[id1].Format_size+" and the y vector was "+self[id2].Format_size); }

	if (Error_Num=="Logfit1") { self[thisid].Errors_errors.push("The logfit function expects 2 inputs"); }
	if (Error_Num=="Logfit2") { self[thisid].Errors_errors.push("The x and y vectors sent to logfit were not of equal size."); }
	if (Error_Num=="Logfit3") { self[thisid].Errors_errors.push("The logfit function can only output 2 arguments. More than that number was requested."); }

	if (Error_Num=="Expfit1") { self[thisid].Errors_errors.push("The expfit function expects 2 inputs"); }
	if (Error_Num=="Expfit2") { self[thisid].Errors_errors.push("The x and y vectors sent to expfit were not of equal size."); }
	if (Error_Num=="Expfit3") { self[thisid].Errors_errors.push("The logfit function can only output 2 arguments. More than that number was requested."); }

	if (Error_Num=="Powerfit1") { self[thisid].Errors_errors.push("The powerfit function expects 2 inputs"); }
	if (Error_Num=="Powerfit2") { self[thisid].Errors_errors.push("The x and y vectors sent to powerfit were not of equal size."); }
	if (Error_Num=="Powerfit3") { self[thisid].Errors_errors.push("The powerfit function can only output 2 arguments. More than that number was requested."); }

	if (Error_Num=="Histogram1") { self[thisid].Errors_errors.push("The Histogram function expects 2 inputs"); }
	if (Error_Num=="Histogram3") { self[thisid].Errors_errors.push("The histogram function can only output 2 items."); }

	if (Error_Num=="numinds1") { self[thisid].Errors_errors.push("The numinds function received more than one input."); }

	if (Error_Num=="Cholesky1") { self[thisid].Errors_errors.push("You entered more than 1 entry into the Cholesky function."); }
	if (Error_Num=="Cholesky2") { self[thisid].Errors_errors.push("The matrix entered into the Cholesky function was not square."); }
	if (Error_Num=="Cholesky3") { self[thisid].Errors_errors.push("The matrix entered into the Cholesky function was not symmetric."); }

	if (Error_Num=="Norm1") { self[thisid].Errors_errors.push("The Norm function did not receive two inputs as needed."); }
	if (Error_Num=="Norm2") { self[thisid].Errors_errors.push("The number entered for the norm - "+id2+" was not an integer."); }

	if (Error_Num=="RSNorm1") { self[thisid].Errors_errors.push("The RSNorm function received more than one input."); }
	if (Error_Num=="CSNorm1") { self[thisid].Errors_errors.push("The CSNorm function received more than one input."); }

	if (Error_Num=="Trace1") { self[thisid].Errors_errors.push("The Trace function received more than 1 input."); }
	if (Error_Num=="Trace2") { self[thisid].Errors_errors.push("The matrix entered into the Trace function was not square."); }

	if (Error_Num=="Conj1") { self[thisid].Errors_errors.push("The Trace function did not receive one input as needed."); }

    if (Error_Num=="DotMult1") { self[thisid].Errors_errors.push("The DotMult function needs to inputs."); }
	if (Error_Num=="DotMult2") { self[thisid].Errors_errors.push("The two matrices given to the DotMult program must be the same size."); }
    if (Error_Num=="DotDiv1") { self[thisid].Errors_errors.push("The DotDiv function needs to inputs."); }
	if (Error_Num=="DotDiv2") { self[thisid].Errors_errors.push("The two matrices given to the DotDiv program must be the same size."); }

	if (Error_Num=="Threshold1") { self[thisid].Errors_errors.push("The Threshold function did not receive three inputs as needed."); }
	if (Error_Num=="Threshold2") { self[thisid].Errors_errors.push("The lower limit was higher than the high limit for the Threshold function."); }

	if (Error_Num=="Cross1") { self[thisid].Errors_errors.push("The Cross function did not receive two inputs as needed."); }
	if (Error_Num=="Cross2") { self[thisid].Errors_errors.push("The vectors for the Cross function must be 1x3 row vectors."); }

	if (Error_Num=="isRow1") { self[thisid].Errors_errors.push("The isRow function received more than 1 input."); }
	if (Error_Num=="isColumn1") { self[thisid].Errors_errors.push("The isColumn function received more than 1 input."); }
	if (Error_Num=="isMatrix1") { self[thisid].Errors_errors.push("The isMatrix function received more than 1 input."); }
	if (Error_Num=="length1") { self[thisid].Errors_errors.push("The length function received more than 1 input."); }
	if (Error_Num=="NumEl1") { self[thisid].Errors_errors.push("The NumEl function received more than 1 input."); }

	if (Error_Num=="fliplr1") { self[thisid].Errors_errors.push("The fliplr function received too many inputs."); }
	if (Error_Num=="fliplr2") { self[thisid].Errors_errors.push("The fliplr function received a matrix more than two dimensions."); }
	if (Error_Num=="flipud1") { self[thisid].Errors_errors.push("The flipud function received too many inputs."); }
	if (Error_Num=="flipud2") { self[thisid].Errors_errors.push("The flipud function received a matrix more than two dimensions."); }

	if (Error_Num=="diag1") { self[thisid].Errors_errors.push("The diag function received more than two inputs."); }
	if (Error_Num=="diag2") { self[thisid].Errors_errors.push("The matrix sent to the diag function had more than two dimensions."); }
	if (Error_Num=="diag3") { self[thisid].Errors_errors.push("The vector sent to the diag function was not a row vector."); }
	if (Error_Num=="diag4") { self[thisid].Errors_errors.push("The offset to the diag function must be an integer."); }
	if (Error_Num=="diag5") { self[thisid].Errors_errors.push("The matrix sent to the diag function must be square."); }

	if (Error_Num=="matur1") { self[thisid].Errors_errors.push("The matur function received more than two inputs."); }
	if (Error_Num=="matur2") { self[thisid].Errors_errors.push("The offset given to the matur function must be an integer."); }
	if (Error_Num=="matur3") { self[thisid].Errors_errors.push("The matrix given to matur must be two dimensional."); }
	if (Error_Num=="matur4") { self[thisid].Errors_errors.push("The matrix given to matur must be square."); }

	if (Error_Num=="matll1") { self[thisid].Errors_errors.push("The matll function received more than two inputs."); }
	if (Error_Num=="matll2") { self[thisid].Errors_errors.push("The offset given to the matll function must be an integer."); }
	if (Error_Num=="matll3") { self[thisid].Errors_errors.push("The matrix given to matll must be two dimensional."); }
	if (Error_Num=="matll4") { self[thisid].Errors_errors.push("The matrix given to matll must be square."); }

	if (Error_Num=="Dot1") { self[thisid].Errors_errors.push("The Dot function did not receive the expected 2 inputs."); }
	if (Error_Num=="Dot2") { self[thisid].Errors_errors.push("The input vectors to the Dot function were not the same size."); }
	if (Error_Num=="Dot3") { self[thisid].Errors_errors.push("The dimension into the dot product must be a 0 or 1."); }

	if (Error_Num=="incSearch1") { self[thisid].Errors_errors.push("The incSearch function must receive at least 3 inputs."); }
	if (Error_Num=="incSearch2") { self[thisid].Errors_errors.push("The incSearch function can receive no more than 5 inputs."); }
	if (Error_Num=="incSearch3") { self[thisid].Errors_errors.push("The min entered for the incSearch function was greater than the max."); }

	if (Error_Num=="Bisect1") { self[thisid].Errors_errors.push("The Bisect function must receive at least 3 inputs."); }
	if (Error_Num=="Bisect2") { self[thisid].Errors_errors.push("The Bisect function can receive no more than 5 inputs."); }
	if (Error_Num=="Bisect3") { self[thisid].Errors_errors.push("The min entered for the Bisect function was greater than the max."); }
	if (Error_Num=="Bisect4") { self[thisid].Errors_errors.push("The upper and lower limits for the Bisect function did not produce opposing signs."); }

	if (Error_Num=="FalsePos1") { self[thisid].Errors_errors.push("The FalsePos function must receive at least 3 inputs."); }
	if (Error_Num=="FalsePos2") { self[thisid].Errors_errors.push("The FalsePos function can receive no more than 5 inputs."); }
	if (Error_Num=="FalsePos3") { self[thisid].Errors_errors.push("The min entered for the FalsePos function was greater than the max."); }
	if (Error_Num=="FalsePos4") { self[thisid].Errors_errors.push("The upper and lower limits for the FalsePos function did not produce opposing signs."); }

	if (Error_Num=="Secant1") { self[thisid].Errors_errors.push("The Secant function must receive at least 3 inputs."); }
	if (Error_Num=="Secant2") { self[thisid].Errors_errors.push("The Secant function can receive no more than 4 inputs."); }

	if (Error_Num=="MultMat1") { self[thisid].Errors_errors.push("When multiplying matrices, the rows in matrix 1 must match the number of columns in matrix 2 and the number of columns in matrix 1 must match the number of rows in matrix 2. You are multuplying matrices of "+id1+" and "+id2+"."); }

	if (Error_Num=="ODE41") { self[thisid].Errors_errors.push("The ODE4 function did not receive the required number of inputs (3)."); }
	if (Error_Num=="ODE42") { self[thisid].Errors_errors.push("The number of initial values did not match the number of functions in the ODE4 function."); }

	if (Error_Num=="Row2Mat1") { self[thisid].Errors_errors.push("The Row2Mat function did not receive 2 inputs - a row and a number."); }
	if (Error_Num=="Row2Mat2") { self[thisid].Errors_errors.push("The Row2Mat received more than 2 inputs - a row and a number."); }
	if (Error_Num=="Row2Mat3") { self[thisid].Errors_errors.push("The first entry in the Row2Mat function must be a row."); }
	if (Error_Num=="Col2Mat1") { self[thisid].Errors_errors.push("The Col2Mat function did not receive 2 inputs - a column and a number."); }
	if (Error_Num=="Col2Mat2") { self[thisid].Errors_errors.push("The Col2Mat received more than 2 inputs - a column and a number."); }
	if (Error_Num=="Col2Mat3") { self[thisid].Errors_errors.push("The first entry in the Col2Mat function must be a column."); }

	if (Error_Num=="LUDecomp1") { self[thisid].Errors_errors.push("The LUDecomp function received more than 1 input"); }
	if (Error_Num=="LUDecomp2") { self[thisid].Errors_errors.push("The LUDecomp function must have two outputs"); }
	if (Error_Num=="LUDecomp3") { self[thisid].Errors_errors.push("The LUDecomp received a number and it should receive a matrix"); }
	if (Error_Num=="LUDecomp4") { self[thisid].Errors_errors.push("The LUDecomp function received a matrix that was not square"); }

	if (Error_Num=="Det1") { self[thisid].Errors_errors.push("The Det function received more than 1 input"); }
	if (Error_Num=="Det2") { self[thisid].Errors_errors.push("The Det received a number and it should receive a matrix"); }
	if (Error_Num=="Det3") { self[thisid].Errors_errors.push("The Det function received a matrix that was not square"); }

	if (Error_Num=="MatPow1") { self[thisid].Errors_errors.push("The MatPow function received less than 2 inputs"); }
	if (Error_Num=="MatPow2") { self[thisid].Errors_errors.push("The MatPow function received more than 2 inputs"); }
	if (Error_Num=="MatPow3") { self[thisid].Errors_errors.push("The matrix sent to MatPow is not square"); }
	if (Error_Num=="MatPow4") { self[thisid].Errors_errors.push("The exponent sent to MatPow was a matrix and should be a single number"); }
	if (Error_Num=="MatPow5") { self[thisid].Errors_errors.push("The exponent sent to MatPow was less than 1"); }

	if (Error_Num=="IntVec1") { self[thisid].Errors_errors.push("The IntVec function received less than 2 inputs"); }
	if (Error_Num=="IntVec2") { self[thisid].Errors_errors.push("The IntVec function received more than 2 inputs"); }
	if (Error_Num=="IntVec3") { self[thisid].Errors_errors.push("The vectors sent to the IntVec function must be longer"); }
	if (Error_Num=="IntVec4") { self[thisid].Errors_errors.push("The x and y vectors sent to the IntVec function were not the same size"); }

	if (Error_Num=="sign1") { self[thisid].Errors_errors.push("The sign function can only have a maximum of 4 total inputs"); }

	if (Error_Num=="rotate1") { self[thisid].Errors_errors.push("The rotate function should not receive more than 1 input"); }
	if (Error_Num=="rotate2") { self[thisid].Errors_errors.push("The matrix sent to the rotate function should be two dimensional"); }

	if (Error_Num=="isPosDef1") { self[thisid].Errors_errors.push("The isPosDef function can only take in 1 input"); }
	if (Error_Num=="isPosDef2") { self[thisid].Errors_errors.push("The matrix sent to the isPosDef function should not be a number"); }
	if (Error_Num=="isPosDef3") { self[thisid].Errors_errors.push("The matrix sent to the isPosDef function must be square"); }

	if (Error_Num=="IfElse1") { self[thisid].Errors_errors.push("The IfElse function cannot receive more than 5 inputs"); }
	if (Error_Num=="IfElse2") { self[thisid].Errors_errors.push("The IfElse function cannot receive less than 4 inputs"); }
	if (Error_Num=="IfElse3") { self[thisid].Errors_errors.push("The test string in the IfElse function must be ==, !=, >=, <=, >, or <"); }

	if (Error_Num=="Indices1") { self[thisid].Errors_errors.push("You sent "+id2+" numbers to index "+id1+" of a matrix. There must be only 1 number or three entries of [number:number]"); }
	if (Error_Num=="Indices2") { self[thisid].Errors_errors.push("You are attempting to set "+id1+" dimensions on a variable that has "+id2+" dimensions. "); }
	if (Error_Num=="Indices3") { self[thisid].Errors_errors.push("You are attempting to set "+id1+" numbers to a matrix that has only "+id2+" numbers on the left side."); }
	if (Error_Num=="Indices4") { self[thisid].Errors_errors.push("You are attempting to set a matrix with a size of "+id1+" to a matrix the size of "+id2+"."); }

}
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------------------------------------------------------------------------------*/




/*
	This function sorts an array based upon a property within the objects in the array
*/
function dynamicSort(property) {
    var sortOrder = 1;
    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a,b) {
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }
}
/* big.js v3.1.3 https://github.com/MikeMcl/big.js/LICENCE */
;(function (global) {
    'use strict';

/*
  big.js v3.1.3
  A small, fast, easy-to-use library for arbitrary-precision decimal arithmetic.
  https://github.com/MikeMcl/big.js/
  Copyright (c) 2014 Michael Mclaughlin <M8ch88l@gmail.com>
  MIT Expat Licence
*/

/***************************** EDITABLE DEFAULTS ******************************/

    // The default values below must be integers within the stated ranges.

    /*
     * The maximum number of decimal places of the results of operations
     * involving division: div and sqrt, and pow with negative exponents.
     */
    var DP = 20,                           // 0 to MAX_DP

        /*
         * The rounding mode used when rounding to the above decimal places.
         *
         * 0 Towards zero (i.e. truncate, no rounding).       (ROUND_DOWN)
         * 1 To nearest neighbour. If equidistant, round up.  (ROUND_HALF_UP)
         * 2 To nearest neighbour. If equidistant, to even.   (ROUND_HALF_EVEN)
         * 3 Away from zero.                                  (ROUND_UP)
         */
        RM = 1,                            // 0, 1, 2 or 3

        // The maximum value of DP and Big.DP.
        MAX_DP = 1E6,                      // 0 to 1000000

        // The maximum magnitude of the exponent argument to the pow method.
        MAX_POWER = 1E6,                   // 1 to 1000000

        /*
         * The exponent value at and beneath which toString returns exponential
         * notation.
         * JavaScript's Number type: -7
         * -1000000 is the minimum recommended exponent value of a Big.
         */
        E_NEG = -7,                   // 0 to -1000000

        /*
         * The exponent value at and above which toString returns exponential
         * notation.
         * JavaScript's Number type: 21
         * 1000000 is the maximum recommended exponent value of a Big.
         * (This limit is not enforced or checked.)
         */
        E_POS = 21,                   // 0 to 1000000

/******************************************************************************/

        // The shared prototype object.
        P = {},
        isValid = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
        Big;


    /*
     * Create and return a Big constructor.
     *
     */
    function bigFactory() {

        /*
         * The Big constructor and exported function.
         * Create and return a new instance of a Big number object.
         *
         * n {number|string|Big} A numeric value.
         */
        function Big(n) {
            var x = this;

            // Enable constructor usage without new.
            if (!(x instanceof Big)) {
                return n === void 0 ? bigFactory() : new Big(n);
            }

            // Duplicate.
            if (n instanceof Big) {
                x.s = n.s;
                x.e = n.e;
                x.c = n.c.slice();
            } else {
                parse(x, n);
            }

            /*
             * Retain a reference to this Big constructor, and shadow
             * Big.prototype.constructor which points to Object.
             */
            x.constructor = Big;
        }

        Big.prototype = P;
        Big.DP = DP;
        Big.RM = RM;
        Big.E_NEG = E_NEG;
        Big.E_POS = E_POS;

        return Big;
    }


    // Private functions


    /*
     * Return a string representing the value of Big x in normal or exponential
     * notation to dp fixed decimal places or significant digits.
     *
     * x {Big} The Big to format.
     * dp {number} Integer, 0 to MAX_DP inclusive.
     * toE {number} 1 (toExponential), 2 (toPrecision) or undefined (toFixed).
     */
    function format(x, dp, toE) {
        var Big = x.constructor,

            // The index (normal notation) of the digit that may be rounded up.
            i = dp - (x = new Big(x)).e,
            c = x.c;

        // Round?
        if (c.length > ++dp) {
            rnd(x, i, Big.RM);
        }

        if (!c[0]) {
            ++i;
        } else if (toE) {
            i = dp;

        // toFixed
        } else {
            c = x.c;

            // Recalculate i as x.e may have changed if value rounded up.
            i = x.e + i + 1;
        }

        // Append zeros?
        for (; c.length < i; c.push(0)) {
        }
        i = x.e;

        /*
         * toPrecision returns exponential notation if the number of
         * significant digits specified is less than the number of digits
         * necessary to represent the integer part of the value in normal
         * notation.
         */
        return toE === 1 || toE && (dp <= i || i <= Big.E_NEG) ?

          // Exponential notation.
          (x.s < 0 && c[0] ? '-' : '') +
            (c.length > 1 ? c[0] + '.' + c.join('').slice(1) : c[0]) +
              (i < 0 ? 'e' : 'e+') + i

          // Normal notation.
          : x.toString();
    }


    /*
     * Parse the number or string value passed to a Big constructor.
     *
     * x {Big} A Big number instance.
     * n {number|string} A numeric value.
     */
    function parse(x, n) {
        var e, i, nL;

        // Minus zero?
        if (n === 0 && 1 / n < 0) {
            n = '-0';

        // Ensure n is string and check validity.
        } else if (!isValid.test(n += '')) {
            throwErr(NaN);
        }

        // Determine sign.
        x.s = n.charAt(0) == '-' ? (n = n.slice(1), -1) : 1;

        // Decimal point?
        if ((e = n.indexOf('.')) > -1) {
            n = n.replace('.', '');
        }

        // Exponential form?
        if ((i = n.search(/e/i)) > 0) {

            // Determine exponent.
            if (e < 0) {
                e = i;
            }
            e += +n.slice(i + 1);
            n = n.substring(0, i);

        } else if (e < 0) {

            // Integer.
            e = n.length;
        }

        // Determine leading zeros.
        for (i = 0; n.charAt(i) == '0'; i++) {
        }

        if (i == (nL = n.length)) {

            // Zero.
            x.c = [ x.e = 0 ];
        } else {

            // Determine trailing zeros.
            for (; n.charAt(--nL) == '0';) {
            }

            x.e = e - i - 1;
            x.c = [];

            // Convert string to array of digits without leading/trailing zeros.
            for (e = 0; i <= nL; x.c[e++] = +n.charAt(i++)) {
            }
        }

        return x;
    }


    /*
     * Round Big x to a maximum of dp decimal places using rounding mode rm.
     * Called by div, sqrt and round.
     *
     * x {Big} The Big to round.
     * dp {number} Integer, 0 to MAX_DP inclusive.
     * rm {number} 0, 1, 2 or 3 (DOWN, HALF_UP, HALF_EVEN, UP)
     * [more] {boolean} Whether the result of division was truncated.
     */
    function rnd(x, dp, rm, more) {
        var u,
            xc = x.c,
            i = x.e + dp + 1;

        if (rm === 1) {

            // xc[i] is the digit after the digit that may be rounded up.
            more = xc[i] >= 5;
        } else if (rm === 2) {
            more = xc[i] > 5 || xc[i] == 5 &&
              (more || i < 0 || xc[i + 1] !== u || xc[i - 1] & 1);
        } else if (rm === 3) {
            more = more || xc[i] !== u || i < 0;
        } else {
            more = false;

            if (rm !== 0) {
                throwErr('!Big.RM!');
            }
        }

        if (i < 1 || !xc[0]) {

            if (more) {

                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                x.e = -dp;
                x.c = [1];
            } else {

                // Zero.
                x.c = [x.e = 0];
            }
        } else {

            // Remove any digits after the required decimal places.
            xc.length = i--;

            // Round up?
            if (more) {

                // Rounding up may mean the previous digit has to be rounded up.
                for (; ++xc[i] > 9;) {
                    xc[i] = 0;

                    if (!i--) {
                        ++x.e;
                        xc.unshift(1);
                    }
                }
            }

            // Remove trailing zeros.
            for (i = xc.length; !xc[--i]; xc.pop()) {
            }
        }

        return x;
    }


    /*
     * Throw a BigError.
     *
     * message {string} The error message.
     */
    function throwErr(message) {
        var err = new Error(message);
        err.name = 'BigError';

        throw err;
    }


    // Prototype/instance methods


    /*
     * Return a new Big whose value is the absolute value of this Big.
     */
    P.abs = function () {
        var x = new this.constructor(this);
        x.s = 1;

        return x;
    };


    /*
     * Return
     * 1 if the value of this Big is greater than the value of Big y,
     * -1 if the value of this Big is less than the value of Big y, or
     * 0 if they have the same value.
    */
    P.cmp = function (y) {
        var xNeg,
            x = this,
            xc = x.c,
            yc = (y = new x.constructor(y)).c,
            i = x.s,
            j = y.s,
            k = x.e,
            l = y.e;

        // Either zero?
        if (!xc[0] || !yc[0]) {
            return !xc[0] ? !yc[0] ? 0 : -j : i;
        }

        // Signs differ?
        if (i != j) {
            return i;
        }
        xNeg = i < 0;

        // Compare exponents.
        if (k != l) {
            return k > l ^ xNeg ? 1 : -1;
        }

        i = -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;

        // Compare digit by digit.
        for (; ++i < j;) {

            if (xc[i] != yc[i]) {
                return xc[i] > yc[i] ^ xNeg ? 1 : -1;
            }
        }

        // Compare lengths.
        return k == l ? 0 : k > l ^ xNeg ? 1 : -1;
    };


    /*
     * Return a new Big whose value is the value of this Big divided by the
     * value of Big y, rounded, if necessary, to a maximum of Big.DP decimal
     * places using rounding mode Big.RM.
     */
    P.div = function (y) {
        var x = this,
            Big = x.constructor,
            // dividend
            dvd = x.c,
            //divisor
            dvs = (y = new Big(y)).c,
            s = x.s == y.s ? 1 : -1,
            dp = Big.DP;

        if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
            throwErr('!Big.DP!');
        }

        // Either 0?
        if (!dvd[0] || !dvs[0]) {

            // If both are 0, throw NaN
            if (dvd[0] == dvs[0]) {
                throwErr(NaN);
            }

            // If dvs is 0, throw +-Infinity.
            if (!dvs[0]) {
                throwErr(s / 0);
            }

            // dvd is 0, return +-0.
            return new Big(s * 0);
        }

        var dvsL, dvsT, next, cmp, remI, u,
            dvsZ = dvs.slice(),
            dvdI = dvsL = dvs.length,
            dvdL = dvd.length,
            // remainder
            rem = dvd.slice(0, dvsL),
            remL = rem.length,
            // quotient
            q = y,
            qc = q.c = [],
            qi = 0,
            digits = dp + (q.e = x.e - y.e) + 1;

        q.s = s;
        s = digits < 0 ? 0 : digits;

        // Create version of divisor with leading zero.
        dvsZ.unshift(0);

        // Add zeros to make remainder as long as divisor.
        for (; remL++ < dvsL; rem.push(0)) {
        }

        do {

            // 'next' is how many times the divisor goes into current remainder.
            for (next = 0; next < 10; next++) {

                // Compare divisor and remainder.
                if (dvsL != (remL = rem.length)) {
                    cmp = dvsL > remL ? 1 : -1;
                } else {

                    for (remI = -1, cmp = 0; ++remI < dvsL;) {

                        if (dvs[remI] != rem[remI]) {
                            cmp = dvs[remI] > rem[remI] ? 1 : -1;
                            break;
                        }
                    }
                }

                // If divisor < remainder, subtract divisor from remainder.
                if (cmp < 0) {

                    // Remainder can't be more than 1 digit longer than divisor.
                    // Equalise lengths using divisor with extra leading zero?
                    for (dvsT = remL == dvsL ? dvs : dvsZ; remL;) {

                        if (rem[--remL] < dvsT[remL]) {
                            remI = remL;

                            for (; remI && !rem[--remI]; rem[remI] = 9) {
                            }
                            --rem[remI];
                            rem[remL] += 10;
                        }
                        rem[remL] -= dvsT[remL];
                    }
                    for (; !rem[0]; rem.shift()) {
                    }
                } else {
                    break;
                }
            }

            // Add the 'next' digit to the result array.
            qc[qi++] = cmp ? next : ++next;

            // Update the remainder.
            if (rem[0] && cmp) {
                rem[remL] = dvd[dvdI] || 0;
            } else {
                rem = [ dvd[dvdI] ];
            }

        } while ((dvdI++ < dvdL || rem[0] !== u) && s--);

        // Leading zero? Do not remove if result is simply zero (qi == 1).
        if (!qc[0] && qi != 1) {

            // There can't be more than one zero.
            qc.shift();
            q.e--;
        }

        // Round?
        if (qi > digits) {
            rnd(q, dp, Big.RM, rem[0] !== u);
        }

        return q;
    };


    /*
     * Return true if the value of this Big is equal to the value of Big y,
     * otherwise returns false.
     */
    P.eq = function (y) {
        return !this.cmp(y);
    };


    /*
     * Return true if the value of this Big is greater than the value of Big y,
     * otherwise returns false.
     */
    P.gt = function (y) {
        return this.cmp(y) > 0;
    };


    /*
     * Return true if the value of this Big is greater than or equal to the
     * value of Big y, otherwise returns false.
     */
    P.gte = function (y) {
        return this.cmp(y) > -1;
    };


    /*
     * Return true if the value of this Big is less than the value of Big y,
     * otherwise returns false.
     */
    P.lt = function (y) {
        return this.cmp(y) < 0;
    };


    /*
     * Return true if the value of this Big is less than or equal to the value
     * of Big y, otherwise returns false.
     */
    P.lte = function (y) {
         return this.cmp(y) < 1;
    };


    /*
     * Return a new Big whose value is the value of this Big minus the value
     * of Big y.
     */
    P.sub = P.minus = function (y) {
        var i, j, t, xLTy,
            x = this,
            Big = x.constructor,
            a = x.s,
            b = (y = new Big(y)).s;

        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.plus(y);
        }

        var xc = x.c.slice(),
            xe = x.e,
            yc = y.c,
            ye = y.e;

        // Either zero?
        if (!xc[0] || !yc[0]) {

            // y is non-zero? x is non-zero? Or both are zero.
            return yc[0] ? (y.s = -b, y) : new Big(xc[0] ? x : 0);
        }

        // Determine which is the bigger number.
        // Prepend zeros to equalise exponents.
        if (a = xe - ye) {

            if (xLTy = a < 0) {
                a = -a;
                t = xc;
            } else {
                ye = xe;
                t = yc;
            }

            t.reverse();
            for (b = a; b--; t.push(0)) {
            }
            t.reverse();
        } else {

            // Exponents equal. Check digit by digit.
            j = ((xLTy = xc.length < yc.length) ? xc : yc).length;

            for (a = b = 0; b < j; b++) {

                if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
        }

        // x < y? Point xc to the array of the bigger number.
        if (xLTy) {
            t = xc;
            xc = yc;
            yc = t;
            y.s = -y.s;
        }

        /*
         * Append zeros to xc if shorter. No need to add zeros to yc if shorter
         * as subtraction only needs to start at yc.length.
         */
        if (( b = (j = yc.length) - (i = xc.length) ) > 0) {

            for (; b--; xc[i++] = 0) {
            }
        }

        // Subtract yc from xc.
        for (b = i; j > a;){

            if (xc[--j] < yc[j]) {

                for (i = j; i && !xc[--i]; xc[i] = 9) {
                }
                --xc[i];
                xc[j] += 10;
            }
            xc[j] -= yc[j];
        }

        // Remove trailing zeros.
        for (; xc[--b] === 0; xc.pop()) {
        }

        // Remove leading zeros and adjust exponent accordingly.
        for (; xc[0] === 0;) {
            xc.shift();
            --ye;
        }

        if (!xc[0]) {

            // n - n = +0
            y.s = 1;

            // Result must be zero.
            xc = [ye = 0];
        }

        y.c = xc;
        y.e = ye;

        return y;
    };


    /*
     * Return a new Big whose value is the value of this Big modulo the
     * value of Big y.
     */
    P.mod = function (y) {
        var yGTx,
            x = this,
            Big = x.constructor,
            a = x.s,
            b = (y = new Big(y)).s;

        if (!y.c[0]) {
            throwErr(NaN);
        }

        x.s = y.s = 1;
        yGTx = y.cmp(x) == 1;
        x.s = a;
        y.s = b;

        if (yGTx) {
            return new Big(x);
        }

        a = Big.DP;
        b = Big.RM;
        Big.DP = Big.RM = 0;
        x = x.div(y);
        Big.DP = a;
        Big.RM = b;

        return this.minus( x.times(y) );
    };


    /*
     * Return a new Big whose value is the value of this Big plus the value
     * of Big y.
     */
    P.add = P.plus = function (y) {
        var t,
            x = this,
            Big = x.constructor,
            a = x.s,
            b = (y = new Big(y)).s;

        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.minus(y);
        }

        var xe = x.e,
            xc = x.c,
            ye = y.e,
            yc = y.c;

        // Either zero?
        if (!xc[0] || !yc[0]) {

            // y is non-zero? x is non-zero? Or both are zero.
            return yc[0] ? y : new Big(xc[0] ? x : a * 0);
        }
        xc = xc.slice();

        // Prepend zeros to equalise exponents.
        // Note: Faster to use reverse then do unshifts.
        if (a = xe - ye) {

            if (a > 0) {
                ye = xe;
                t = yc;
            } else {
                a = -a;
                t = xc;
            }

            t.reverse();
            for (; a--; t.push(0)) {
            }
            t.reverse();
        }

        // Point xc to the longer array.
        if (xc.length - yc.length < 0) {
            t = yc;
            yc = xc;
            xc = t;
        }
        a = yc.length;

        /*
         * Only start adding at yc.length - 1 as the further digits of xc can be
         * left as they are.
         */
        for (b = 0; a;) {
            b = (xc[--a] = xc[a] + yc[a] + b) / 10 | 0;
            xc[a] %= 10;
        }

        // No need to check for zero, as +x + +y != 0 && -x + -y != 0

        if (b) {
            xc.unshift(b);
            ++ye;
        }

         // Remove trailing zeros.
        for (a = xc.length; xc[--a] === 0; xc.pop()) {
        }

        y.c = xc;
        y.e = ye;

        return y;
    };


    /*
     * Return a Big whose value is the value of this Big raised to the power n.
     * If n is negative, round, if necessary, to a maximum of Big.DP decimal
     * places using rounding mode Big.RM.
     *
     * n {number} Integer, -MAX_POWER to MAX_POWER inclusive.
     */
    P.pow = function (n) {
        var x = this,
            one = new x.constructor(1),
            y = one,
            isNeg = n < 0;

        if (n !== ~~n || n < -MAX_POWER || n > MAX_POWER) {
            throwErr('!pow!');
        }

        n = isNeg ? -n : n;

        for (;;) {

            if (n & 1) {
                y = y.times(x);
            }
            n >>= 1;

            if (!n) {
                break;
            }
            x = x.times(x);
        }

        return isNeg ? one.div(y) : y;
    };


    /*
     * Return a new Big whose value is the value of this Big rounded to a
     * maximum of dp decimal places using rounding mode rm.
     * If dp is not specified, round to 0 decimal places.
     * If rm is not specified, use Big.RM.
     *
     * [dp] {number} Integer, 0 to MAX_DP inclusive.
     * [rm] 0, 1, 2 or 3 (ROUND_DOWN, ROUND_HALF_UP, ROUND_HALF_EVEN, ROUND_UP)
     */
    P.round = function (dp, rm) {
        var x = this,
            Big = x.constructor;

        if (dp == null) {
            dp = 0;
        } else if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
            throwErr('!round!');
        }
        rnd(x = new Big(x), dp, rm == null ? Big.RM : rm);

        return x;
    };


    /*
     * Return a new Big whose value is the square root of the value of this Big,
     * rounded, if necessary, to a maximum of Big.DP decimal places using
     * rounding mode Big.RM.
     */
    P.sqrt = function () {
        var estimate, r, approx,
            x = this,
            Big = x.constructor,
            xc = x.c,
            i = x.s,
            e = x.e,
            half = new Big('0.5');

        // Zero?
        if (!xc[0]) {
            return new Big(x);
        }

        // If negative, throw NaN.
        if (i < 0) {
            throwErr(NaN);
        }

        // Estimate.
        i = Math.sqrt(x.toString());

        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the result exponent.
        if (i === 0 || i === 1 / 0) {
            estimate = xc.join('');

            if (!(estimate.length + e & 1)) {
                estimate += '0';
            }

            r = new Big( Math.sqrt(estimate).toString() );
            r.e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
        } else {
            r = new Big(i.toString());
        }

        i = r.e + (Big.DP += 4);

        // Newton-Raphson iteration.
        do {
            approx = r;
            r = half.times( approx.plus( x.div(approx) ) );
        } while ( approx.c.slice(0, i).join('') !==
                       r.c.slice(0, i).join('') );

        rnd(r, Big.DP -= 4, Big.RM);

        return r;
    };


    /*
     * Return a new Big whose value is the value of this Big times the value of
     * Big y.
     */
    P.mul = P.times = function (y) {
        var c,
            x = this,
            Big = x.constructor,
            xc = x.c,
            yc = (y = new Big(y)).c,
            a = xc.length,
            b = yc.length,
            i = x.e,
            j = y.e;

        // Determine sign of result.
        y.s = x.s == y.s ? 1 : -1;

        // Return signed 0 if either 0.
        if (!xc[0] || !yc[0]) {
            return new Big(y.s * 0);
        }

        // Initialise exponent of result as x.e + y.e.
        y.e = i + j;

        // If array xc has fewer digits than yc, swap xc and yc, and lengths.
        if (a < b) {
            c = xc;
            xc = yc;
            yc = c;
            j = a;
            a = b;
            b = j;
        }

        // Initialise coefficient array of result with zeros.
        for (c = new Array(j = a + b); j--; c[j] = 0) {
        }

        // Multiply.

        // i is initially xc.length.
        for (i = b; i--;) {
            b = 0;

            // a is yc.length.
            for (j = a + i; j > i;) {

                // Current sum of products at this digit position, plus carry.
                b = c[j] + yc[i] * xc[j - i - 1] + b;
                c[j--] = b % 10;

                // carry
                b = b / 10 | 0;
            }
            c[j] = (c[j] + b) % 10;
        }

        // Increment result exponent if there is a final carry.
        if (b) {
            ++y.e;
        }

        // Remove any leading zero.
        if (!c[0]) {
            c.shift();
        }

        // Remove trailing zeros.
        for (i = c.length; !c[--i]; c.pop()) {
        }
        y.c = c;

        return y;
    };


    /*
     * Return a string representing the value of this Big.
     * Return exponential notation if this Big has a positive exponent equal to
     * or greater than Big.E_POS, or a negative exponent equal to or less than
     * Big.E_NEG.
     */
    P.toString = P.valueOf = P.toJSON = function () {
        var x = this,
            Big = x.constructor,
            e = x.e,
            str = x.c.join(''),
            strL = str.length;

        // Exponential notation?
        if (e <= Big.E_NEG || e >= Big.E_POS) {
            str = str.charAt(0) + (strL > 1 ? '.' + str.slice(1) : '') +
              (e < 0 ? 'e' : 'e+') + e;

        // Negative exponent?
        } else if (e < 0) {

            // Prepend zeros.
            for (; ++e; str = '0' + str) {
            }
            str = '0.' + str;

        // Positive exponent?
        } else if (e > 0) {

            if (++e > strL) {

                // Append zeros.
                for (e -= strL; e-- ; str += '0') {
                }
            } else if (e < strL) {
                str = str.slice(0, e) + '.' + str.slice(e);
            }

        // Exponent zero.
        } else if (strL > 1) {
            str = str.charAt(0) + '.' + str.slice(1);
        }

        // Avoid '-0'
        return x.s < 0 && x.c[0] ? '-' + str : str;
    };


    /*
     ***************************************************************************
     * If toExponential, toFixed, toPrecision and format are not required they
     * can safely be commented-out or deleted. No redundant code will be left.
     * format is used only by toExponential, toFixed and toPrecision.
     ***************************************************************************
     */


    /*
     * Return a string representing the value of this Big in exponential
     * notation to dp fixed decimal places and rounded, if necessary, using
     * Big.RM.
     *
     * [dp] {number} Integer, 0 to MAX_DP inclusive.
     */
    P.toExponential = function (dp) {

        if (dp == null) {
            dp = this.c.length - 1;
        } else if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
            throwErr('!toExp!');
        }

        return format(this, dp, 1);
    };


    /*
     * Return a string representing the value of this Big in normal notation
     * to dp fixed decimal places and rounded, if necessary, using Big.RM.
     *
     * [dp] {number} Integer, 0 to MAX_DP inclusive.
     */
    P.toFixed = function (dp) {
        var str,
            x = this,
            Big = x.constructor,
            neg = Big.E_NEG,
            pos = Big.E_POS;

        // Prevent the possibility of exponential notation.
        Big.E_NEG = -(Big.E_POS = 1 / 0);

        if (dp == null) {
            str = x.toString();
        } else if (dp === ~~dp && dp >= 0 && dp <= MAX_DP) {
            str = format(x, x.e + dp);

            // (-0).toFixed() is '0', but (-0.1).toFixed() is '-0'.
            // (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
            if (x.s < 0 && x.c[0] && str.indexOf('-') < 0) {
        //E.g. -0.5 if rounded to -0 will cause toString to omit the minus sign.
                str = '-' + str;
            }
        }
        Big.E_NEG = neg;
        Big.E_POS = pos;

        if (!str) {
            throwErr('!toFix!');
        }

        return str;
    };


    /*
     * Return a string representing the value of this Big rounded to sd
     * significant digits using Big.RM. Use exponential notation if sd is less
     * than the number of digits necessary to represent the integer part of the
     * value in normal notation.
     *
     * sd {number} Integer, 1 to MAX_DP inclusive.
     */
    P.toPrecision = function (sd) {

        if (sd == null) {
            return this.toString();
        } else if (sd !== ~~sd || sd < 1 || sd > MAX_DP) {
            throwErr('!toPre!');
        }

        return format(this, sd - 1, 2);
    };


    // Export


    Big = bigFactory();

    //AMD.
    if (typeof define === 'function' && define.amd) {
        define(function () {
            return Big;
        });

    // Node and other CommonJS-like environments that support module.exports.
    } else if (typeof module !== 'undefined' && module.exports) {
        module.exports = Big;

    //Browser.
    } else {
        global.Big = Big;
    }
})(this);

!function n(t,e,o){function i(u,f){if(!e[u]){if(!t[u]){var c="function"==typeof require&&require;if(!f&&c)return c(u,!0);if(r)return r(u,!0);var s=new Error("Cannot find module '"+u+"'");throw s.code="MODULE_NOT_FOUND",s}var a=e[u]={exports:{}};t[u][0].call(a.exports,function(n){var e=t[u][1][n];return i(e?e:n)},a,a.exports,n,t,e,o)}return e[u].exports}for(var r="function"==typeof require&&require,u=0;u<o.length;u++)i(o[u]);return i}({1:[function(n,t){function e(){}var o=t.exports={};o.nextTick=function(){var n="undefined"!=typeof window&&window.setImmediate,t="undefined"!=typeof window&&window.postMessage&&window.addEventListener;if(n)return function(n){return window.setImmediate(n)};if(t){var e=[];return window.addEventListener("message",function(n){var t=n.source;if((t===window||null===t)&&"process-tick"===n.data&&(n.stopPropagation(),e.length>0)){var o=e.shift();o()}},!0),function(n){e.push(n),window.postMessage("process-tick","*")}}return function(n){setTimeout(n,0)}}(),o.title="browser",o.browser=!0,o.env={},o.argv=[],o.on=e,o.addListener=e,o.once=e,o.off=e,o.removeListener=e,o.removeAllListeners=e,o.emit=e,o.binding=function(){throw new Error("process.binding is not supported")},o.cwd=function(){return"/"},o.chdir=function(){throw new Error("process.chdir is not supported")}},{}],2:[function(n,t){"use strict";function e(n){function t(n){return null===c?void a.push(n):void r(function(){var t=c?n.onFulfilled:n.onRejected;if(null===t)return void(c?n.resolve:n.reject)(s);var e;try{e=t(s)}catch(o){return void n.reject(o)}n.resolve(e)})}function e(n){try{if(n===l)throw new TypeError("A promise cannot be resolved with itself.");if(n&&("object"==typeof n||"function"==typeof n)){var t=n.then;if("function"==typeof t)return void i(t.bind(n),e,u)}c=!0,s=n,f()}catch(o){u(o)}}function u(n){c=!1,s=n,f()}function f(){for(var n=0,e=a.length;e>n;n++)t(a[n]);a=null}if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof n)throw new TypeError("not a function");var c=null,s=null,a=[],l=this;this.then=function(n,e){return new l.constructor(function(i,r){t(new o(n,e,i,r))})},i(n,e,u)}function o(n,t,e,o){this.onFulfilled="function"==typeof n?n:null,this.onRejected="function"==typeof t?t:null,this.resolve=e,this.reject=o}function i(n,t,e){var o=!1;try{n(function(n){o||(o=!0,t(n))},function(n){o||(o=!0,e(n))})}catch(i){if(o)return;o=!0,e(i)}}var r=n("asap");t.exports=e},{asap:4}],3:[function(n,t){"use strict";function e(n){this.then=function(t){return"function"!=typeof t?this:new o(function(e,o){i(function(){try{e(t(n))}catch(i){o(i)}})})}}var o=n("./core.js"),i=n("asap");t.exports=o,e.prototype=o.prototype;var r=new e(!0),u=new e(!1),f=new e(null),c=new e(void 0),s=new e(0),a=new e("");o.resolve=function(n){if(n instanceof o)return n;if(null===n)return f;if(void 0===n)return c;if(n===!0)return r;if(n===!1)return u;if(0===n)return s;if(""===n)return a;if("object"==typeof n||"function"==typeof n)try{var t=n.then;if("function"==typeof t)return new o(t.bind(n))}catch(i){return new o(function(n,t){t(i)})}return new e(n)},o.all=function(n){var t=Array.prototype.slice.call(n);return new o(function(n,e){function o(r,u){try{if(u&&("object"==typeof u||"function"==typeof u)){var f=u.then;if("function"==typeof f)return void f.call(u,function(n){o(r,n)},e)}t[r]=u,0===--i&&n(t)}catch(c){e(c)}}if(0===t.length)return n([]);for(var i=t.length,r=0;r<t.length;r++)o(r,t[r])})},o.reject=function(n){return new o(function(t,e){e(n)})},o.race=function(n){return new o(function(t,e){n.forEach(function(n){o.resolve(n).then(t,e)})})},o.prototype["catch"]=function(n){return this.then(null,n)}},{"./core.js":2,asap:4}],4:[function(n,t){(function(n){function e(){for(;i.next;){i=i.next;var n=i.task;i.task=void 0;var t=i.domain;t&&(i.domain=void 0,t.enter());try{n()}catch(o){if(c)throw t&&t.exit(),setTimeout(e,0),t&&t.enter(),o;setTimeout(function(){throw o},0)}t&&t.exit()}u=!1}function o(t){r=r.next={task:t,domain:c&&n.domain,next:null},u||(u=!0,f())}var i={task:void 0,next:null},r=i,u=!1,f=void 0,c=!1;if("undefined"!=typeof n&&n.nextTick)c=!0,f=function(){n.nextTick(e)};else if("function"==typeof setImmediate)f="undefined"!=typeof window?setImmediate.bind(window,e):function(){setImmediate(e)};else if("undefined"!=typeof MessageChannel){var s=new MessageChannel;s.port1.onmessage=e,f=function(){s.port2.postMessage(0)}}else f=function(){setTimeout(e,0)};t.exports=o}).call(this,n("_process"))},{_process:1}],5:[function(){"function"!=typeof Promise.prototype.done&&(Promise.prototype.done=function(){var n=arguments.length?this.then.apply(this,arguments):this;n.then(null,function(n){setTimeout(function(){throw n},0)})})},{}],6:[function(n){n("asap");"undefined"==typeof Promise&&(Promise=n("./lib/core.js"),n("./lib/es6-extensions.js")),n("./polyfill-done.js")},{"./lib/core.js":2,"./lib/es6-extensions.js":3,"./polyfill-done.js":5,asap:4}]},{},[6]);

(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick panel
            'app.quick-panel',

            // Profile
            'app.profile',

            // Teams
            'app.teams',

            // Workspaces
            'app.workspace',

            // Documents
            'app.document',
            'app.document.worksheet',
            

            // Forum
            'app.forum',

            // Datasets
            'app.dataset',

            // Workflows
            'app.workflow',

            // Part Trees
            'app.parttree',
            'app.parttree.parttree',
            'app.parttree.setup',

            // 2D Plots
            'app.plot',

            // 3D Plots
            'app.surface',

            // Constants
            'app.constant',

            // Units
            'app.unit',

            // Connect to CAD
            'app.connect',

            // Bug Report System
            // 'app.bugReport'            
        ]);
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('DocumentDialogController', DocumentDialogController);

    /** @ngInject */
    function DocumentDialogController($sce, $mdDialog, $http, locals, utilityFactory, chartFactory, docItemFactory)
    {
        var equationWorker = new Worker("eqSolver.js");  
        var vm              = vm || this;
        vm.digestStatus     = 1;
        vm.thisItem         = locals.thisItem;
        vm.file_id          = locals.file_id;
        vm.worksheet        = locals.worksheet;
        vm.editPerm         = locals.editPerm;
        vm.viewPerm         = locals.viewPerm;
        vm.fileInfo         = locals.fileInfo;
        vm.permissions      = locals.permissions;
        vm.messageObj       = locals.messageObj;
        vm.cadwolf_worksheet= locals.worksheet;
        vm.currentItem      = vm.thisItem;
        vm.modalType        = locals.modalType;
        vm.chartFactory     = chartFactory;
        vm.docItemFactory   = docItemFactory;
        vm.currentContents  = [];
        vm.currentFile      = '';
        vm.inputEquations   = [];
        vm.inputURL         = "/Documentation";
        vm.thisCAD          = {};

        vm.thisCAD.document_data = {};
        vm.thisCAD.element_data = {};
        vm.thisCAD.part_data = {};


        // Methods
        vm.cancel               = cancel;
        vm.acceptChanges        = acceptChanges;
        vm.acceptImage          = acceptImage;
        vm.selectImage          = selectImage;
        vm.addReference         = addReference;
        vm.deleteReference      = deleteReference;
        vm.getFolderContents    = getFolderContents;
        vm.setNewURL            = setNewURL;
        vm.setDocEqs            = setDocEqs;
        vm.createComponent      = createComponent;
        vm.addFileInput         = addFileInput;
        vm.deleteInput          = deleteInput;
        vm.deleteItem           = deleteItem;
        vm.addDataset           = addDataset;
        vm.changeRef            = changeRef;
        vm.setVideoURL          = setVideoURL;
        vm.deleteFAF            = deleteFAF;
        vm.addFAF               = addFAF;
        vm.setFafItem           = setFafItem;
        vm.addFafItem           = addFafItem;
        vm.deleteFafItem        = deleteFafItem;
        vm.checkoutDocument     = checkoutDocument;
        vm.arrayFromNum         = arrayFromNum;
        vm.createShowSolution   = createShowSolution;
        vm.checkOutFile         = checkOutFile;
        vm.checkInFile          = checkInFile;
        vm.getCardValue         = getCardValue;
        vm.addConnected         = addConnected;
        vm.removeConnected      = removeConnected;
        vm.checkConnected       = checkConnected;
        vm.addConnEq            = addConnEq;
        vm.removeConnEq         = removeConnEq;
        vm.setConnEq            = setConnEq;
        vm.setConnEl            = setConnEl;
        vm.pushToOnshape        = pushToOnshape;
        vm.updateElements       = updateElements;
        vm.getOnshapeDocs       = getOnshapeDocs;
        vm.getCadElements       = getCadElements;
        vm.getCadParts          = getCadParts;
        vm.setCadProperties     = setCadProperties;
        vm.addCadImport         = addCadImport;
        vm.updateCadMaterial    = updateCadMaterial;
        vm.setThumbnail         = setThumbnail;
        vm.setCadElement        = setCadElement;

        vm.getDepFiles          = getDepFiles;
        vm.updateFile           = updateFile;

        function cancel(){
            $mdDialog.cancel();
        };

        function acceptChanges(item) {
            $mdDialog.hide(item);
        };


        function arrayFromNum(num) {
            return new Array(num);   
        }


        /*
        *
        *   FUNCTIONS RELATING TO SETTING UP THIS DOCUMENT AS A FILE AS A FUNCTION
        *
        */




        /*
         * Append new entry to the FaF inputs or outputs
         *
         */
        function addFafItem( type )
        {   
            if ( type=="input" )
            {
                var newItem={
                    'order' : vm.fileInfo.item_data.fileAsFunction.inputs.length,
                    'name' : 'equationName'
                }
                vm.fileInfo.item_data.fileAsFunction.inputs.push( newItem );
            }

            if ( type=="output" )
            {
                var newItem={
                    'order' : vm.fileInfo.item_data.fileAsFunction.outputs.length,
                    'name' : 'equationName'
                }
                vm.fileInfo.item_data.fileAsFunction.outputs.push( newItem );
            }

        }






        /*
         *
         * Set the properties of the FaF inputs or outputs
         *
         */
        function setFafItem( thisItem )
        {   
            vm.worksheet.forEach(
                function(thisEq, index){
                    if ( thisEq['itemid'] == thisItem['itemid'] ) 
                    {
                        thisItem['name'] = thisEq['content']['Equation']['Format_name'];
                        thisItem['real'] = thisEq['content']['Equation']['Solution_real'];
                        thisItem['imag'] = thisEq['content']['Equation']['Solution_imag'];
                        thisItem['units'] = thisEq['content']['Equation']['Units_units'];
                        thisItem['size'] = thisEq['content']['Equation']['Format_size'];
                    }
                }
            );

        }




        /*
         * Remove entry from the FaF inputs or outputs
         *
         */
        function deleteFafItem( type, order )
        {   
            if ( type=="input" )
            {
                vm.fileInfo.item_data.fileAsFunction.inputs.splice( order, 1 )
            }

            if ( type=="output" )
            {
                vm.fileInfo.item_data.fileAsFunction.outputs.splice( order, 1 )
            }

        }




        /*
        *
        *   FUNCTIONS RELATING TO THE BIBLIOGRAPHY DIALOG
        *
        */


        /*
        *
        *   ADD A REFERENCE TO THE BIBLIOGRAPHY
        *
        */
        function addReference() 
        {   
            var thisRefID = docItemFactory.getID('ref', vm.thisItem.fileInfo.id);
            var refNum = vm.fileInfo.item_data.references.length+1;
            vm.fileInfo.item_data.references.push(docItemFactory.newRef({refID:thisRefID, refNum:refNum})); 
            vm.fileInfo.item_data.references.sort(utilityFactory.dynamicSort("refNum"));
        }



        /*
        *
        *   DELETE A REFERENCE FROM THE BIBLIOGRAPHY
        *
        */
        function deleteReference( refID ) 
        {
            var deleteIndex=vm.fileInfo.item_data.references.length+1;
            
            // Find the index of the reference being deleted and remove reference from array
            vm.fileInfo.item_data.references.forEach(
                function(thisRef, index){
                    if ( thisRef.refID == refID )
                    {
                        vm.fileInfo.item_data.references.splice(index, 1);
                        deleteIndex = thisRef.refNum;
                    }
                }
            );  

            // Decrement the reference numbers of any reference higher than this one
            vm.fileInfo.item_data.references.forEach(
                function(thisRef, index){
                    if ( thisRef.refNum > deleteIndex )
                    {
                        thisRef.refNum = thisRef.refNum-1;
                    }
                }
            );  

            // Resort the reference array
            vm.fileInfo.item_data.references.sort(utilityFactory.dynamicSort("refNum"));
        }












        /*
         *
         * Selecting an image from the list
         *
         */
        function selectImage( currentImage, thisItem ) {

        };




        /*
         *
         * Get the contents of a workspace
         *
         */
        function getFolderContents( thisItem, thisURL )
        {   
            console.log('Getting the contents of '+thisURL);
            $http({
                method: "GET",
                url: '/files',
                params: { thisURL : thisURL.replace(/\~2F/g,'/') }
            }).then(function successCallback( returnData ) 
            {
                console.log( returnData );
                vm.currentFile = returnData['data']['fileInfo'];
                if ( typeof(vm.currentFile.item_data) == "string" )
                {
                    vm.currentFile.item_data = JSON.parse(vm.currentFile.item_data);
                }
                vm.currentContents = returnData['data']['files'];
                vm.currentContents.forEach(
                    function(thisEq, index){
                        if ( typeof(thisEq['item_data'])=="string")
                        {
                            thisEq['item_data']=JSON.parse(thisEq['item_data']);
                        }
                    }
                );
            }, function errorCallback( returnData ) {
                vm.currentContents = [];
            });
        }






        /*
        *
        *   FUNCTIONS RELATING TO THE FILE INPUTS DIALOG
        *
        */



        /*
         *
         * Get the contents of a document
         *
         */
        function setNewURL( thisName )
        {
            vm.inputURL = vm.inputURL+'/'+thisName;
            this.getFolderContents( '', vm.inputURL );
        }



        /*
         *
         * Get the contents of a document
         *
         */
        function setDocEqs( thisItem )
        {
            var thisURL = '/files/'+thisItem.id+'/components'
            $http({
                method: "GET",
                url: thisURL,
                params: { }
            }).then(function successCallback( returnData )
            {
                console.log(returnData);
                vm.inputEquations = returnData.data.components;
                vm.inputEquations.forEach(
                    function(thisEq, index){
                        thisEq['content'] = JSON.parse(thisEq['content']);
                    }
                );
            });
        }




        /*
        *
        *   ADD AN INPUT ITEM TO THE DOCUMENT
        *
        */
        function addFileInput( obj ) 
        {   

            console.log('I am in the add file input function');
            var thisID = docItemFactory.getID('Equation', vm.file_id, vm.worksheet);
            var newTemplate = docItemFactory.newItem(   'Equation', 
                                                        thisID, 
                                                        0, 
                                                        vm.file_id, 
                                                        {},
                                                        vm.worksheet);


            newTemplate['content'] = JSON.parse(JSON.stringify( obj.content ));

            newTemplate['content']['Equation']['inputType'] = 'File';
            newTemplate['content']['inputFile'] = obj['file_id'];
            newTemplate['content']['inputID'] = obj['id'];

            newTemplate['content']['id'] = thisID;
            newTemplate['content']['itemid'] = thisID;
            newTemplate['content']['Equation']['Format_id'] = thisID;

            newTemplate['dependent_id'] = obj['id'];
            newTemplate['dependent_file'] = obj['file_id'];

            var flag=0;

            vm.worksheet.forEach(
                function(thisEq, index){
                    if ( thisEq['content']['Name'] == newTemplate['content']['Name'] )
                    {
                        flag = 1;
                    }
                }
            );

            if ( flag==0 )
            {
                vm.worksheet.push( newTemplate );

                vm.createComponent( newTemplate, 1 );        
            }

        }







        /*
        *
        *   DELETE AN INPUT ITEM TO THE DOCUMENT
        *
        */
        function deleteInput( obj ) 
        {   
            console.log('You are in the delete input function for '+obj.content.Equation.Format_name);
            vm.worksheet.forEach(
                function(thisEq, index){
                    if ( thisEq['itemid'] == obj.itemid )
                    {
                        vm.worksheet.splice( index, 1 );
                        vm.deleteItem( obj );
                    }
                }
            );
        }


        /*
        *
        *   MAKE THE CALL TO DELETE AN ITEM
        *
        */
        function deleteItem( obj ) 
        {   
            console.log('I should be deleting '+obj['id']);
            $http({
                method: "DELETE",
                url: window.location.origin+'/components/'+obj['id'],
                data: { 
                            connected : 1
                      }
            }).then(function successCallback( returnData ) {

            }, function errorCallback( returnData ) {});
        }





        /*
        *
        *   FUNCTIONS RELATING TO THE DATASETS INPUT DIALOG
        *
        */


        /*
        *
        *   ADD A DATASET AS AN EQUATION
        *
        */
        function addDataset( thisDataset ) 
        {
            console.log('I am in the add dataset input function');
            var thisID = docItemFactory.getID('Equation', vm.file_id, vm.worksheet);
            var newTemplate = docItemFactory.newItem(   'Equation', 
                                                        thisID, 
                                                        0, 
                                                        vm.file_id, 
                                                        {},
                                                        vm.worksheet);

            newTemplate['content']['Equation'] = new docItemFactory.eqPro( {}, vm.file_id ); 

            newTemplate['content']['Equation']['inputType'] = 'Dataset';
            newTemplate['content']['inputFile'] = thisDataset['id'];
            newTemplate['content']['inputID'] = thisDataset['id'];
            newTemplate['content']['Equation']['Solution_real'] = thisDataset.item_data.real;
            newTemplate['content']['Equation']['Solution_imag'] = {};
            newTemplate['content']['Equation']['Format_size'] = thisDataset.item_data.size;
            newTemplate['content']['Equation']['Format_name'] = thisDataset.item_data.name;

            newTemplate['content']['id'] = thisID;
            newTemplate['id'] = thisID;
            newTemplate['content']['itemid'] = thisID;
            newTemplate['content']['Equation']['Format_id'] = thisID;
            newTemplate['dependent_id'] = thisDataset.id;
            newTemplate['dependent_file'] = thisDataset.id;
            newTemplate['content']['Name'] = thisDataset.item_data.name;

            for (var index in newTemplate['content']['Equation']['Solution_real'])
            {
                newTemplate['content']['Equation']['Solution_real'][index] = parseFloat(newTemplate['content']['Equation']['Solution_real'][index]);
            }

            var flag=0;
            vm.worksheet.forEach(
                function(thisEq, index){
                    if ( thisEq['content']['Name'] == newTemplate['content']['Name'] )
                    {
                        flag = 1;
                    }
                }
            );

            if ( flag==0 )
            {
                vm.worksheet.push( newTemplate );

                vm.createComponent( newTemplate, 1 );        
            }

        }







        /*
         * Creates a new component
         *
         */
        function createComponent( thisItem )
        {   
            $http({
                method: "POST",
                url: window.location.origin+'/components',
                data: { 
                            itemid  : thisItem['itemid'],
                            file_id : vm.file_id,
                            order   : 0,
                            name    : thisItem['Name'],
                            content : JSON.stringify(thisItem['content']),
                            component_type_id : thisItem['component_type_id'],
                            dependent_file : thisItem['dependent_file'],
                            dependent_id : thisItem['dependent_id'],
                            connected : 1               // This is used here to prevent increment of other items 
                                                        // since this is not visible on the worksheet and stored at 
                                                        // an order of 0 
                      }
            }).then(function successCallback( returnData ) {
                    thisItem.id = returnData.id;
            }, function errorCallback( returnData ) {});
        }        





        /*
        *
        *   FUNCTIONS RELATING TO ADDING OR REMOVING A REFERENCE
        *
        */


        /*
        *
        *   CHANGE WHETHER OR NOT A REFERENCE APPLIES
        *
        */
        function changeRef( refID, thisItem ) 
        {
            var flag = 0;

            // Check to see of the ID is already a reference and delete it
            for (var a=0; a<thisItem.content.references.length; a++)
            {
                if ( thisItem.content.references[a] == refID )
                {
                    thisItem.content.references.splice(a,1);
                    flag=1;
                }
            }

            // If the item is not present, add it to the list of references
            if ( flag == 0 )
            {
                thisItem.content.references.push(refID);
            }
        }




        /*
        *
        *   SET A VIDEO URL
        *
        */
        function setVideoURL( ) 
        {
            vm.thisItem.content.url=$sce.trustAsResourceUrl('https://www.youtube.com/embed/'+vm.thisItem.content.videoID);
        }





        /*
        *
        *   FUNCTIONS RELATING TO THE IMPORTED FILES AS FUNCTIONS DIALOG
        *
        */



        /*
         *
         * Add a file as a function
         *
         */
        function addFAF( thisObj )
        {
            console.log(thisObj);
            var funObj = {
                parentLocation : vm.inputURL,
                fileID : thisObj.id,
                fileName : thisObj.name,
                functionName : thisObj.item_data.fileAsFunction.fileFunName,
                functionInputs : thisObj.item_data.fileAsFunction.inputs,
                functionOutputs : thisObj.item_data.fileAsFunction.outputs,
                showContents : false,
                fileItems : []
            };
            var thisURL = window.location.origin+'/files/'+thisObj.id+'/components'
            $http({
                type: "GET",
                url: thisURL,
                params: { version : 0 }
            }).then(function successCallback( returnData ) 
            {
                console.log(returnData);
                var components = returnData.data.components.sort(utilityFactory.dynamicSort("order"));
                components.forEach(
                    function(thisItem, index){
                        thisItem['content'] = JSON.parse(thisItem['content']);
                        if ((thisItem['component_type_id']==3)||
                            (thisItem['component_type_id']==5)||
                            (thisItem['component_type_id']==6)||
                            (thisItem['component_type_id']==7)||
                            (thisItem['component_type_id']==8))
                        {
                            funObj['fileItems'].push(thisItem);
                        }
                    }
                );
                vm.fileInfo.item_data.impFunctions.push( funObj );
            }, function errorCallback( returnData ) {});
        }


        /*
         *
         * Delete a file as a function
         *
         */
        function deleteFAF( thisObj )
        {
            console.log(thisObj);
            for (var a=0; a<vm.fileInfo.item_data.impFunctions; a++)
            {
                console.log('Comparing '+vm.fileInfo.item_data.impFunctions[a]['fileID']+' with '+thisObj['fileID']);
                if (vm.fileInfo.item_data.impFunctions[a]['fileID'] == thisObj['fileID'])
                {
                    vm.fileInfo.item_data.impFunctions.splice( a, 1 );                     
                }
            }
        }


        /*
         *
         * Checkout a document
         *
         */
        function checkoutDocument( item ) 
        {   
            $http({
                method: "POST",
                url: window.location.origin+'/checkout/'+item['id'],
            }).then(function successCallback( returnData ) {
                if(returnData.data=="noPerm")
                {

                }else
                {
                    item['item_data']['checkout_id']=returnData.data['id'];
                    item['item_data']['checkout_name']=returnData.data['name'];
                }
            }, function errorCallback( returnData ) {});
            
        };



        function acceptImage(item) {
            $mdDialog.hide(item);
        };




        /*
        *
        *   CREATE THE SOLUTION MATRIX TO SHOW
        *
        */
        function createShowSolution( thisObj )
        {
            console.log('In the create show solution function');
            thisObj.content.Equation['Format_showsolution'] = docItemFactory.createShowSolution( thisObj );
        };







        /*
         *
         * Checkout a document
         *
         */
        function checkOutFile( ) 
        {   
            $http({
                method: "POST",
                url: window.location.origin+'/checkout/'+vm.fileInfo['id'],
            }).then(function successCallback( returnData ) {
                if(returnData.data=="noPerm")
                {

                }else
                {
                    vm.fileInfo['item_data']['checkout_id']=returnData.data['id'];
                    vm.fileInfo['item_data']['checkout_name']=returnData.data['name'];

                }
            }, function errorCallback( returnData ) {});
            
        };

        /*
         *
         * Checkin a document
         *
         */
        function checkInFile( ) 
        {   
            $http({
                method: "POST",
                url: window.location.origin+'/checkin/'+vm.fileInfo['id'],
            }).then(function successCallback( returnData ) {
                if(returnData.data=="noPerm")
                {

                }else
                {
                    vm.fileInfo['item_data']['checkout_id']=returnData.data;
                    vm.fileInfo['item_data']['checkout_name']='';
                }
            }, function errorCallback( returnData ) {});
            
        };




        /*
         *
         * Set the value for the card
         *
         */
        function getCardValue( thisItem )
        {   
            console.log('In the get card value function with an id of '+thisItem['content']['variableID']);
            vm.worksheet.forEach(
                function(thisEq, index)
                {
                    if ( thisEq['itemid'] == thisItem['content']['variableID'] ) 
                    {
                        thisItem['content']['value'] = thisEq['content']['Equation']['Solution_real'][thisItem['content']['index']];
                        thisItem['content']['units'] = thisEq['content']['Equation']['Units_units'];
                        thisItem['content']['variable'] = thisEq['name'];
                        thisItem['content']['variableOrder'] = thisEq['order'];
                    }
                }
            );
        }







        /*
         *
         * Get the documents for the onShape user
         *
         */
        function getOnshapeDocs( )
        {

            console.log('I am in the getOnshapeDocs function');

            $http({
                method: "GET",
                url: window.location.origin+'/files/getOnshapeDocs',
                params: { }
            }).then(function successCallback( returnData )
            {
                console.log(returnData);
                vm.cadFiles = returnData.data.items;
                vm.checkConnected();
            });
        }

        /*
         *
         * Get the elements for a given CAD document
         *
         */
        function getCadElements( )
        {
            console.log('I am in the getCadElements function');

            // Loop through the cad files and find the one selected
            for (var a=0; a<vm.cadFiles.length; a++)
            {
                if ( vm.thisCAD.document_data.id == vm.cadFiles[a]['id'] )
                {
                    vm.thisCAD['document_data'] = vm.cadFiles[a];
                    vm.thisCAD['element_data'] = {};
                    vm.thisCAD['part_data'] = {};
                }
            }

            // Call the function to pull the elements from the CAD system
            $http({
                method: "GET",
                url: '/files/getCadElements',
                params: { document_id : vm.thisCAD['document_data']['id'],
                          workspace_id : vm.thisCAD['document_data']['defaultWorkspace']['id'] }
            }).then(function successCallback( returnData ) 
            {
                console.log( returnData );
                vm.cadElements = returnData.data;

            }, function errorCallback( returnData ) { });

        }




        /*
         *
         * Get the elements for a given CAD document
         *
         */
        function getCadParts( )
        {
            console.log('I am in the getCadParts function');

            // Loop through the cad elements and find the one selected
            for (var a=0; a<vm.cadElements.length; a++)
            {
                if ( vm.thisCAD.element_data.id == vm.cadElements[a]['id'] )
                {
                    vm.thisCAD['element_data'] = vm.cadElements[a];
                    vm.thisCAD['part_data'] = {};
                }
            }

            // Assemblies do not need this step
            if ( vm.thisCAD.element_data.elementType == 'PARTSTUDIO' )
            {

                // Call the function to pull the elements from the CAD system
                $http({
                    method: "GET",
                    url: '/files/getCadParts',
                    params: { document_id : vm.thisCAD['document_data']['id'],
                              workspace_id : vm.thisCAD['document_data']['defaultWorkspace']['id'] }
                }).then(function successCallback( returnData ) 
                {
                    // This returns a list of all parts. Find one(s) that match this element
                    console.log( returnData );
                    var partList=[];
                    for (var a=0; a<returnData.data.length; a++)
                    {
                        if ( returnData.data[a]['elementId'] == vm.thisCAD['element_data']['id'] )
                        {
                            partList.push( returnData.data[a] );
                        }
                    }

                    vm.cadParts = partList;

                }, function errorCallback( returnData ) { });
            
            }else
            {
                vm.setCadProperties();
            }

        }



        /*
         *
         * Set the cad specific items for this array entry
         *
         */
        function setCadProperties( )
        {
            console.log('I am in the setCadProperties function');

            if ( vm.thisCAD.element_data.elementType == 'PARTSTUDIO' )
            {

                // Loop through the cad parts and find the one selected
                for (var a=0; a<vm.cadParts.length; a++)
                {
                    if ( vm.thisCAD.part_data.partId == vm.cadParts[a]['partId'] )
                    {
                        vm.thisCAD['part_data'] = vm.cadParts[a];
                    }
                }

                // Get the material and mass properties
                $http({
                    method: "GET",
                    url: '/files/getCadMaterial',
                    params: { document_id : vm.thisCAD['document_data']['id'],
                              workspace_id : vm.thisCAD['document_data']['defaultWorkspace']['id'],
                              element_id : vm.thisCAD['element_data']['id'],
                              part_id : vm.thisCAD['part_data']['partId'] }
                }).then(function successCallback( returnData ) 
                {
                    console.log( returnData );
                    vm.thisCAD['material_data'] = returnData.data;


                }, function errorCallback( returnData ) { });

                // Get the material and mass properties
                $http({
                    method: "GET",
                    url: '/files/getCadMass',
                    params: { document_id : vm.thisCAD['document_data']['id'],
                              workspace_id : vm.thisCAD['document_data']['defaultWorkspace']['id'],
                              element_id : vm.thisCAD['element_data']['id'],
                              part_id : vm.thisCAD['part_data']['partId'] }
                }).then(function successCallback( returnData ) 
                {
                    console.log( returnData );
                    vm.thisCAD['mass_data'] = returnData.data;

                    // Place the cad data in the part tree so that it can be used
                    vm.addCadImport();

                }, function errorCallback( returnData ) { });

            }else
            {

            }

        }






        /*
         *
         * Add an cad file to the list of imported data items
         *
         */
        function addCadImport( )
        {
            var flag=0;

            console.log('I am in the addCadImport function');

            // Makes sure that there isn't already a CAD connected
            vm.fileInfo.item_data.importedCAD.forEach(
                function(thisItem, index){
                    if ( thisItem['id'] == vm.thisCAD['id'] ) 
                    {
                        flag=1;
                    }
                }
            );

            // If there is no connected item, add this one
            if ( flag == 0 )
            {
                vm.fileInfo.item_data.importedCAD.push( vm.thisCAD );
            }


        }







        /*
         *
         * Add an onShape file as connected to this document
         *
         */
        function addConnected( )
        {
            var elName='', elThumbnail='';
            var thisID = vm.fileInfo.id;
            var cadID = vm.thisCAD.document_data.id;
            var elID = vm.thisCAD.element_data.id;
            console.log('I am in the addConnected function with '+thisID+' - '+cadID+' '+elID);

            // Grab the element data
            vm.cadElements.forEach(
                function(thisEl, index){
                    console.log('comparing '+thisEl['id']+' to '+elID);
                    if ( thisEl['id'] == elID ) 
                    {
                        console.log('Got here');
                        elName = thisEl['name'];
                        elThumbnail = thisEl['thumbnailInfo']['sizes'][0]['href'];
                    }
                }
            );

            // Send the request
            $http({
                method: "POST",
                url: window.location.origin+'/files/addConnected',
                params: { document_id : thisID, 
                          cad_id : cadID,
                          el_id : elID,
                          el_name : elName,
                          el_thumbnail : elThumbnail }
            }).then(function successCallback( returnData )
            {
                console.log(returnData);
                vm.connectedFiles = returnData.data;
                for (var a=0; a<vm.connectedFiles.length; a++)
                {
                    vm.connectedFiles[a]['info'] = JSON.parse(vm.connectedFiles[a]['info']);
                }
                vm.checkConnected();
            });
        }



        /*
         *
         * Remove an onShape file as connected to this document
         *
         */
        function removeConnected( )
        {
            var thisID = vm.fileInfo.id;
            var cadID = vm.thisCAD.document_data.id;
            var elID = vm.thisCAD.element_data.id;

            console.log('I am in the removeConnected function');

            $http({
                method: "POST",
                url: window.location.origin+'/files/removeConnected',
                params: { document_id : thisID, 
                          cad_id : cadID,
                          el_id : elID }
            }).then(function successCallback( returnData )
            {
                console.log(returnData);
                vm.connectedFiles = returnData.data;
                for (var a=0; a<vm.connectedFiles.length; a++)
                {
                    vm.connectedFiles[a]['info'] = JSON.parse(vm.connectedFiles[a]['info']);
                }
                vm.checkConnected();
            });
        }



        /*
         *
         * Get and check the onShape items to see if they are linked to this document
         *
         */
        function checkConnected( )
        {

            console.log('I am in the checkConnected function');

            $http({
                method: "GET",
                url: window.location.origin+'/getConnected/'+vm.file_id,
                params: { }
            }).then(function successCallback( returnData )
            {
                console.log(returnData);
                vm.connectedFiles = returnData.data.data;
                for (var a=0; a<vm.connectedFiles.length; a++)
                {
                    vm.connectedFiles[a]['info'] = JSON.parse(vm.connectedFiles[a]['info']);
                }
                for (var a=0; a<vm.cadFiles.length; a++)
                {
                    vm.cadFiles[a]['isConn']=0;
                    for (var b=0; b<vm.connectedFiles.length; b++)
                    {
                        if ( vm.cadFiles[a]['id'] == vm.connectedFiles[b]['info']['cad_data']['id'] )
                        {
                            vm.cadFiles[a]['isConn'] = 1;
                        }
                    }
                }

            });
        }





        /*
         *
         *  Add a connected equation to the connected document
         *
         */
        function addConnEq( connectedItem, document_id )
        {   
            var thisEq='', eqData={}, connID=0, flag=0, iflag=0;

            console.log('I am in the add connected equation function');
            console.log(connectedItem);

            // Get a unique id for the connected equation
            while (flag==0)
            {
                iflag = 0;
                connID = Math.floor(Math.random() * 10000)+1;
                for (var a=0; a<connectedItem.info.equations.length; a++)
                {
                    if ( connectedItem.info.equations[a]['conn_id'] == connID ){ iflag=1; }
                }
                if (iflag==0){ flag=1; }

            }

            // Place the new equation in the array
            eqData = {
                'eq_id' : '',
                'eq_itemid' : '',
                'eq_name' : '',
                'eq_size' : '',
                'eq_order' : '',
                'el_id' : '',
                'showVal' : 0,
                'temp_eq' : '',
                'conn_id' : connID
            };
            connectedItem.info.equations.push(eqData);


            // Call the function to enter a new and empty equation
            $http({
                method: "POST",
                url: '/files/addConnEq',
                params: { cad_id : connectedItem.info.cad_data.id, 
                          document_id : document_id, 
                          conneq_id : connID,
                          conn_id : connectedItem.id }
            }).then(function successCallback( returnData ) 
            {
                console.log( returnData );
                vm.checkConnected();

            }, function errorCallback( returnData ) { });


        }






        /*
         *
         *  Set a element for a connected equation
         *
         */
        function setConnEl( connectedItem, document_id )
        {   
            console.log('In the set connected element function');

            // Pull the name of the element
            for (var a=0; a<connectedItem.info.cad_data.elements.length; a++)
            {
                if ( connectedItem.info.cad_data.elements[a]['id'] == connectedItem.info.cad_data.element_id )
                {
                    connectedItem.info.cad_data.element_name = connectedItem.info.cad_data.elements[a]['name'];
                    connectedItem.info.cad_data.element_thumbnailImage = connectedItem.info.cad_data.elements[a]['thumbnailInfo']['sizes'][0]['href'];
                }
            }

            // Call the function to put the variable on the server side
            $http({
                method: "POST",
                url: '/files/setConnEl',
                params: { cad_id : connectedItem.info.cad_data.id, 
                          document_id : document_id, 
                          item_id : connectedItem.id,
                          el_id : connectedItem.info.cad_data.element_id,
                          el_name : connectedItem.info.cad_data.element_name,
                          el_thumbnail : connectedItem.info.cad_data.element_thumbnailImage }
            }).then(function successCallback( returnData ) 
            {
                console.log( returnData );

            }, function errorCallback( returnData ) { });


        }


        /*
         *
         *  Set a property for a connected equation - the equation
         *
         */
        function setConnEq( connectedItem, document_id, conn_id, type, thisID )
        {   
            var thisConn = '', addElName='', thisEq={}, eqData={};
            console.log('I am in the set connected equation function');

            console.log(connectedItem);

            // If the equation is being set
            if ( type == 'equation' )
            {
                // Pull the equation data and place it in the local copy
                for (var a=0; a<vm.worksheet.length; a++)
                {
                    if ( vm.worksheet[a]['id'] == thisID )
                    {
                        thisEq = vm.worksheet[a];
                    }
                }

                // Pull the existing conn eq and set parameters
                for (var a=0; a<connectedItem.info.equations.length; a++)
                {
                    if ( connectedItem.info.equations[a]['conn_id'] == conn_id )
                    {
                        thisConn = connectedItem.info.equations[a]
                        eqData = {
                            'eq_id' : thisEq.id,
                            'eq_itemid' : thisEq.itemid,
                            'eq_name' : thisEq.name,
                            'eq_size' : thisEq.content.Equation.Format_size,
                            'eq_order' : thisEq.order,
                            'el_id' : connectedItem.info.equations[a]['el_id'],
                            'el_name' : connectedItem.info.equations[a]['el_name'],
                            'conn_id' : thisConn['conn_id'],
                            'showVal' : 1,
                            'temp_eq' : thisID 
                        };
                        connectedItem.info.equations[a] = eqData;
                    }
                }


                // Call the function to put the variable on the server side
                $http({
                    method: "POST",
                    url: '/files/setConnEq',
                    params: { cad_id : connectedItem.info.cad_data.id, 
                              document_id : document_id, 
                              type : 'equation',
                              conn_id :  thisConn['conn_id'],
                              conneq_id :  thisConn['conn_id'],
                              item_id : connectedItem.id,
                              eq_id : thisID }
                }).then(function successCallback( returnData ) 
                {
                    console.log( returnData );

                }, function errorCallback( returnData ) { });

            }


        }





        /*
         *
         *  Remove a connected equation to the connected document
         *
         */
        function removeConnEq( connectedItem, document_id, cad_id, conn_id )
        {

            console.log('I am in the remove connected equation function');
            console.log(connectedItem);

            // Pull the equation from the connected equation list
            for (var a=0; a<connectedItem.info.equations.length; a++)
            {
                if ( connectedItem.info.equations[a]['id'] == conn_id )
                {
                    connectedItem.info.equations.splice( a, 1 );
                }
            }


            // Call the function to pull the variable on the server side
            $http({
                method: "POST",
                url: '/files/removeConnEq',
                params: { cad_id : connectedItem.info.cad_data.id, 
                          document_id : document_id, 
                          conneq_id : conn_id, 
                          item_id : connectedItem.id }
            }).then(function successCallback( returnData ) 
            {
                console.log( returnData );

            }, function errorCallback( returnData ) { });

        }





        /*
         *
         *  Update the element list for a document
         *
         */
        function updateElements( document_id, cad_id, connectedItem )
        {

            console.log('I am in the update elements function');
            console.log(connectedItem);

            // Call the function to pull the variable on the server side
            $http({
                method: "POST",
                url: '/files/updateElements',
                params: { cad_id : connectedItem.info.cad_data.id, 
                          document_id : document_id, 
                          item_id : connectedItem.id }
            }).then(function successCallback( returnData ) 
            {
                console.log( returnData );
                vm.checkConnected();

            }, function errorCallback( returnData ) { });

        }




        /*
         *
         * Set the cad specific items for this array entry
         *
         */
        function updateCadMaterial( thisItem )
        {
            console.log('I am in the updateCadMaterial function');
            console.log(thisItem);

            // Get the material and mass properties
            $http({
                method: "GET",
                url: '/files/getCadMaterial',
                params: { document_id : thisItem['document_data']['id'],
                          workspace_id : thisItem['document_data']['defaultWorkspace']['id'],
                          element_id : thisItem['element_data']['id'],
                          part_id : thisItem['part_data']['partId'] }
            }).then(function successCallback( returnData ) 
            {
                console.log('Returned material data');
                console.log( returnData );
                thisItem['material_data'] = returnData.data;


            }, function errorCallback( returnData ) { });

            // Get the material and mass properties
            $http({
                method: "GET",
                url: '/files/getCadMass',
                params: { document_id : thisItem['document_data']['id'],
                          workspace_id : thisItem['document_data']['defaultWorkspace']['id'],
                          element_id : thisItem['element_data']['id'],
                          part_id : thisItem['part_data']['partId'] }
            }).then(function successCallback( returnData ) 
            {
                console.log('Returned mass data');
                console.log( returnData );
                thisItem['mass_data'] = returnData.data;

            }, function errorCallback( returnData ) { });


        }




        /*
         *
         *  Set the image size array after element selection
         *
         */
        function setCadElement( )
        {
            console.log('In the set cad element function');
            for (var a=0; a<vm.cadElements.length; a++)
            {
                if ( vm.thisCAD.element_data.id == vm.cadElements[a]['id'] )
                {
                    vm.thisCAD.element_data = vm.cadElements[a];
                }
            }
        }





        /*
         *
         *  Push the equations from this document to specific onShape document
         *  When a file is saved, all variables are pushed to all connected onShape files
         *
         */
        function setThumbnail( thisItem, thisCAD )
        {
            console.log('In the set thumbnail function');
            var theseSizes=[];
            for (var a=0; a<thisCAD.element_data.thumbnailInfo.sizes.length; a++)
            {
                if (thisCAD.element_data.thumbnailInfo.sizes[a]['size'] == thisCAD.imageSize)
                {
                    thisItem.content.src = thisCAD.element_data.thumbnailInfo.sizes[a]['href'];
                    theseSizes=thisCAD.imageSize.split('x');
                    thisItem.content.height = theseSizes[1]; 
                    thisItem.content.width = theseSizes[0];
                    thisItem.content.isCAD = true;
                }
            }
        }








        /*
         *
         *  Push the equations from this document to specific onShape document
         *  When a file is saved, all variables are pushed to all connected onShape files
         *
         */
        function pushToOnshape( document_id, cad_id, conn_id )
        {
            $http({
                method: "POST",
                url: '/files/pushToOnshape',
                params: { cad_id : cad_id, document_id : document_id, conn_id : conn_id }
            }).then(function successCallback( returnData ) 
            {
                console.log( returnData );

            }, function errorCallback( returnData ) { });
        
        }




        /*
         *
         *  These functions are related to pulling and solving dependent files to update them
         *
         */



        /*
         *
         *  Pull the files that are dependent on this one and the files that this one depends upon
         *
         */
        function getDepFiles( )
        {
            console.log('In the getDepFiles function for the document '+vm.file_id);
            $http({
                method: "GET",
                url: '/files/getDepFiles/'+vm.file_id
            }).then(function successCallback( returnData ) 
            {
                console.log( returnData );
                vm.depFiles = returnData.data.depFiles;
                vm.controlFiles = returnData.data.controlFiles;

            }, function errorCallback( returnData ) { });

        }



        /*
         *
         *  This is the function called when a user clicks to update a file to be updated. It
         *  pulls all of the items for the document and then runs through them and solves the
         *  needed items.
         *
         */
        function updateFile( fileID )
        {
            console.log('In the updateFile function for the document '+fileID);
            var otherWorksheet = {};

            $http({
                method: "GET",
                url: '/files/getSolveItems/'+fileID,
            }).then(function successCallback( returnData ) 
            {
                console.log( returnData );
                var otherWorksheet = returnData.components;

            }, function errorCallback( returnData ) { });

        }






        /*
*
*   EQUATION DIGEST FOR UPDATING OTHER FILES
*
*/
function runEquationDigest ( worksheet )
{   
    console.log('In the equation digest loop with a status of '+vm.digestStatus);
    
    if ( vm.worksheet === undefined ){ vm.worksheet = vm.cadwolf_worksheet; }else{ vm.worksheet = worksheet; }

    if (vm.digestStatus==1)
    {   
        vm.worksheet=worksheet.sort(utilityFactory.dynamicSort("order"));
        
        for (var a=0; a<worksheet.length; a++)
        {   
            if ((vm.worksheet[a]['component_type_id']==3) &&
                (vm.worksheet[a]['content']['needsUpdateFlag']==1))
            {   
                console.log('Calling the solver for '+vm.worksheet[a]['itemid']);
                vm.digestStatus=0;
                vm.worksheet[a]['content']['needsUpdateFlag']=0;
                vm.worksheet[a]['content']['Equation']['inEdit']=1;
                if ((!vm.editPerm) && (vm.worksheet[a]['content']['Equation']['Format_editinuse']==1))
                {
                    vm.worksheet[a]['content']['Equation']['newEquation'] = vm.worksheet[a]['content']['Equation']['Format_left']+'='+vm.worksheet[a]['content']['Equation']['Format_right']
                }
                vm.solveEquation( vm.worksheet[a]['itemid'], 'SolveEquation' );   
                break
            }


            if (vm.worksheet[a]['component_type_id']==5)
            {   var flag=0;
                for (var b=0; b< vm.worksheet[a]['content']['data'].length; b++)
                {   for (var c=0; c< vm.worksheet[a]['content']['data'][0].length; c++)
                    {   console.log('Checking index '+b+'-'+c);
                        if (vm.worksheet[a]['content']['data'][b][c]['needsUpdateFlag']==1)
                        {   vm.worksheet[a]['solveRow']=b
                            vm.worksheet[a]['solveCol']=c
                            if (vm.worksheet[a]['content']['data'][b][c]['equation'].match(/^=/)==null)
                            {   console.log('Setting index '+b+'-'+c+' to '+vm.worksheet[a]['content']['data'][b][c]['equation']);
                                vm.worksheet[a]['content']['data'][b][c]['real']=worksheet[a]['content']['data'][b][c]['equation'];
                                vm.digestStatus=1;
                            }else
                            {   if (utilityFactory.isNumber(vm.worksheet[a]['content']['data'][b][c]['equation'].replace(/^=/,'')))
                                {   vm.worksheet[a]['content']['data'][b][c]['real']=parseFloat(vm.worksheet[a]['content']['data'][b][c]['equation'].replace(/^=/,''));
                                    vm.worksheet[a]['content']['data'][b][c]['needsUpdateFlag']=0;
                                    console.log('I am updating the dependents on '+String.fromCharCode(65+c)+' - '+b);
                                    docItemFactory.findDependents(vm.worksheet[a]['itemid']+'.'+String.fromCharCode(65+c)+'.'+b, 0, vm.worksheet);
                                    flag=1;
                                    break
                                }else
                                {   console.log('Solving for index '+b+'-'+c+' with an equation of '+vm.worksheet[a]['content']['data'][b][c]['equation']);
                                    vm.digestStatus=0;
                                    vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveTableCell'); 
                                    flag=1;
                                    break
                                }
                            }
                        }
                    } 
                    if (flag==1) { break }
                }
                if (flag==1) { break }
            }

            // Check and update the loop parameters
            if ((vm.worksheet[a]['component_type_id']==6) &&
                (vm.worksheet[a]['content']['needsBlockUpdate']==1) &&
                (vm.digestStatus==1))
            {   vm.digestStatus=0;
                vm.worksheet[a]['content']['forLoop']['firstRun']=1;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveLoopParameters');   
                break
            }

            // Check and update the loop parameters
            if ((vm.worksheet[a]['component_type_id']==7) &&
                (vm.worksheet[a]['content']['needsBlockUpdate']==1) &&
                (vm.digestStatus==1))
            {   vm.digestStatus=0;
                vm.worksheet[a]['content']['whileLoop']['firstRun']=1;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveWhileLoopParameters');  
                break
            }

            // Check and update the if/else parameters
            if ((vm.worksheet[a]['component_type_id']==8) &&
                (vm.worksheet[a]['content']['needsBlockUpdate']==1) &&
                (vm.digestStatus==1))
            {   vm.digestStatus=0;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveIfElseParameters');
                break
            }

            // Check and update the loop structure
            if ((vm.worksheet[a]['component_type_id']==6) && 
                (vm.worksheet[a]['content']['forLoop']['needsUpdateFlag']==1) &&
                (vm.digestStatus==1))
            {
                vm.digestStatus=0;
                vm.worksheet[a]['content']['forLoop']['firstRun']=1;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveStructure');   
                break
            }

            // Check and update the loop structure
            if ((vm.worksheet[a]['component_type_id']==7) && 
                (vm.worksheet[a]['content']['whileLoop']['needsUpdateFlag']==1) &&
                (vm.digestStatus==1))
            {
                vm.digestStatus=0;
                vm.worksheet[a]['content']['whileLoop']['firstRun']=1;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveStructure');   
                break
            }

            // Check and update the lif/else structure
            if ((vm.worksheet[a]['component_type_id']==8) && 
                (vm.worksheet[a]['content']['ifelse']['needsUpdateFlag']==1) &&
                (vm.digestStatus==1))
            {
                vm.digestStatus=0;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveStructure');   
                break
            }

            if ((vm.worksheet[a]['component_type_id']==9)&&(vm.digestStatus==1))
            {   var flag=0;
                for (var thisDataset in vm.worksheet[a]['content']['Plot']['Chart_dataobj'])
                {   
                    console.log('For dataset '+thisDataset+', the update flag is '+vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['needsUpdateFlag']);
                    if (vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['needsUpdateFlag']==1)
                    {   
                        console.log('I am updating dataset '+thisDataset+'-'+vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['Format_id']+' on plot '+vm.worksheet[a]['itemid']);
                        vm.digestStatus=0;
                        vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['needsUpdateFlag']=0; 
                        vm.solveEquation(vm.worksheet[a]['itemid'], 'solvePlotData', vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['Format_id']);
                        flag=1;
                        break
                    }
                } 
                if ((flag==0)&&(vm.worksheet[a]['content']['Plot']['needsUpdateFlag']==1))
                {
                    vm.worksheet[a]['content']['Plot']['needsUpdateFlag']=0;
                    chartFactory.makeChart(vm.worksheet[a], '', vm.worksheet); 
                    
                }
            }
            if (vm.worksheet[a]['component_type_id']==13)
            {   for (var dataIndex in vm.worksheet[a]['content']['Surface']['Chart_dataobj'])
                {   if (vm.worksheet[a]['content']['Surface']['Chart_dataobj'][dataIndex]['needsUpdateFlag']==1)
                    {   vm.digestStatus=0;
                        vm.worksheet[a]['content']['Surface']['Chart_dataobj'][dataIndex]['needsUpdateFlag']=0; 
                        var thisID = vm.worksheet[a]['itemid'];
                        var dataID = vm.worksheet[a]['content']['Surface']['Chart_dataobj'][dataIndex]['Format_id'];
                        vm.solveEquation( thisID, 'SolveSurfaceData', dataID );
                        break
                    }
                }  
            }

        }

        for (var a=0; a<worksheet.length; a++)
        {   
            if (vm.worksheet[a]['component_type_id']==15)
            {   
                for (var b=0; b<worksheet.length; b++)
                {   
                    if ( vm.worksheet[a]['content']['variableID'] == vm.worksheet[b]['itemid'] )
                    {
                        vm.worksheet[a]['content']['value'] = vm.worksheet[b]['content']['Equation']['Solution_real'][worksheet[a]['content']['index']];
                        vm.worksheet[a]['content']['units'] = vm.worksheet[b]['content']['Equation']['Units_units'];
                        vm.worksheet[a]['content']['variable'] = vm.worksheet[b]['content']['Equation']['Format_name'];
                    }
                }
            }
        }
        console.log('The digest loop is clean');
    }
};







/*
*
*   SOLVE EQUATION FUNCTION
*
*/
function solveEquation (eqID, eqType, dataID)   
{   
    console.log('In solve equation with an id of '+eqID+', a type of '+eqType+' and a dataID of '+dataID);
    var thisItem = docItemFactory.getByID(eqID, vm.worksheet);
    if ( vm.cadwolf_fileInfo.item_data.importedCAD === undefined ) { vm.cadwolf_fileInfo.item_data.importedCAD=[]; }
    console.log('Found');
    console.log(thisItem);
    thisItem.eqObj=docItemFactory.createEqObj(eqID, vm.worksheet);
    var solveObj = docItemFactory.createSolveObj( thisItem, eqType, dataID );
    solveObj['scaleUnits'] = vm.cadwolfScaleUnits;
    solveObj['parseUnits'] = vm.cadwolfParseUnits;
    solveObj['Constants']  = vm.cadwolfConstants;
    solveObj['cadParts']  = vm.cadwolf_fileInfo.item_data.importedCAD;
    solveObj['importedFunctions'] = vm.cadwolf_fileInfo.item_data.impFunctions;
    console.log('I am sending ...');
    console.log(solveObj);
    equationWorker.postMessage( solveObj ); 

    
    equationWorker.onerror = function(e) 
    {
        vm.digestStatus=1;
        console.log('Hey, I got an error, but thats cool. Ill just sit over here and eat a sugar packet.'); 
        vm.showMessage( '', { messageType : 'failure', 
                              messageTitle : 'Unknown Error', 
                              messageText : 'There was an error in the solver routine that caused it to fail. Please look at the format of your equations.'});

    };

    equationWorker.onmessage = function(e) {    
        console.log('The message was returned with a type of '+e.data.messageType);
        console.log(e.data);
        MY_SCOPE.eqreturndata=e;

        vm.worksheet=docItemFactory.eqReturn(e.data, vm.worksheet);    
        
        if (e.data.messageType=="EquationResult")
        {
            vm.addressConnectedEqs(e.data, vm.worksheet);
            vm.worksheet = docItemFactory.populateDeps(e.data.id, vm.worksheet);
            vm.worksheet = docItemFactory.findDependents(e.data.id, 0, vm.worksheet);
            vm.worksheet.forEach(
                function(thisObj, index){
                    if (thisObj['itemid']==e.data.id)
                    {   
                        thisObj.content.Equation['Format_showsolution'] = docItemFactory.createShowSolution( thisObj );
                        vm.updateComponent( thisObj );                            
                    }
                }
            );
        }
        
        if (e.data.messageType=="TableCellResult")
        {
            vm.worksheet = docItemFactory.findDependents(e.data.id, 0, vm.worksheet);
        }
        
        if (e.data.messageType=="PlotDataResults")
        {   
            vm.worksheet.forEach(
                function(thisObj, index){
                    if (thisObj['itemid']==e.data.plotID)
                    {   
                        if (e.data.eventErrorFlag==1)
                        {
                            thisObj['content']['Plot']['errorFlag']=1;
                            thisObj['content']['Plot']['errors']=e.data.eventError;
                        }else
                        {
                            thisObj['content']['Plot']['errorFlag']=0;
                            thisObj['content']['Plot']['errors']=[];
                            var itemArray=['Chart_dataobj', 'Chart_bandsobj', 'Chart_linesobj', 'Chart_textobj', 'Chart_xaxesobj', 'Chart_yaxesobj'];
                            for (var a=0; a<itemArray.length; a++)
                            {   
                                for (var thisData in thisObj['content']['Plot'][itemArray[a]])
                                {   
                                    if (thisObj['content']['Plot'][itemArray[a]][thisData]['Format_id']==vm.currentChartItemID)
                                    {
                                        vm.currentChartItem = thisObj['content']['Plot'][itemArray[a]][thisData];
                                        vm.currentPoint=vm.currentChartItem['PointData'][vm.pointIndex];
                                    }
                                } 
                            }
                        }
                        vm.updateComponent( thisObj );                            
                    }
                }
            );
        }

        if (e.data.messageType=="SurfaceData")
        {   
            vm.worksheet.forEach(function(item, index)
            {   
                if (item.itemid==e.data['PlotID'])
                {   
                    for (var a = 0; a < item['content']['Surface']['Chart_dataobj'].length; a++)
                    {
                        if (item['content']['Surface']['Chart_dataobj'][a]['Format_id'] == e.data['DataID'] )
                        {
                            var dataIndex = a;
                        }
                    }

                    for (var b = 0; b < e.data['dataObject'].length; b++)
                    {
                        if (e.data['dataObject'][b]['Format_id'] == e.data['DataID'] )
                        {
                            var returnIndex = b;
                        }
                    }

                    if ((e.data['type']=="surface")||(e.data['type']=="pointCloud"))
                    {    
                        item['content']['Surface']['Chart_dataobj'][dataIndex]['xLength']=e.data['dataObject'][returnIndex]['xLength'];
                        item['content']['Surface']['Chart_dataobj'][dataIndex]['yLength']=e.data['dataObject'][returnIndex]['yLength'];
                    
                    }else if (e.data['type']=="line") 
                    {   
                        // item['content']['Surface']['Chart_dataobj'][dataIndex]['lineGeometry']=JSON.parse(JSON.stringify(e.data['dataObject'][returnIndex]['lineGeometry']));
                        item = surfaceFactory.setLinePoints( item, e.data['DataID'], e.data['Axis'] );

                    }else if (e.data['type']=="lathe")
                    {   
                        item['content']['Surface']['Chart_dataobj'][dataIndex]['xLength']=e.data['dataObject'][returnIndex]['xLength'];
                        item['content']['Surface']['Chart_dataobj'][dataIndex]['yLength']=e.data['dataObject'][returnIndex]['yLength'];
                        item['content']['Surface'].formatLatheData(e.data['PlotID'], e.data['DataID']);
                    }                    
                    
                    vm.reDrawItem( item, 'all', 1 );
                    vm.updateComponent( item );                            
                }
            });
        }

        console.log('I made it to the end of the equation return');
        vm.digestStatus=1;            
        // Call to update item here      
        vm.runEquationDigest( vm.worksheet );
    }
};







/*
*
*   SEPARATE FUNCTION TO ADDRESS RETURNED CONNECTED EQUATIONS
*
*/
function addressConnectedEqs(returnObject, worksheetObj) 
{   
    MY_SCOPE.returnItem = returnObject;
    var flag=0;
    console.log('There are '+Object.keys(returnObject.connected).length+' connected items in the returned array');
    // Handle the connected equations - If the returned item has connected equations
    if (Object.keys(returnObject.connected).length>0)
    {  
        console.log('There were keys returned');
        vm.worksheetObj.forEach(function(item, index)
        {   
            console.log('I am now comparing '+returnObject.id+' to '+item['itemid']);
            if (returnObject.id==item['itemid'])
            {
                console.log('match');
                // Loop through all of the existing connected IDs for this equation. Find them in the vm.worksheet,
                // and check their names against the list of names for the newly returned connected items. If one
                // matches, update the data from the new solution.
                for (var existingConn in item['content']['Equation']['connected_ids'])
                {
                    flag=0;
                    vm.worksheetObj.forEach(function(tempItem, tempIndex)
                    {   
                        console.log('In the existing part, comparing '+tempItem['itemid']+'-'+existingConn);
                        console.log(tempItem['itemid']==existingConn);
                        if (tempItem['itemid']==existingConn) 
                        { 
                            for (var returnConn in returnObject.connected)
                            {
                                console.log('In connected ids, comparing '+returnObject.connected[returnConn]['Format_name']+' to '+tempItem['name']);
                                if (returnObject.connected[returnConn]['Format_name'] == tempItem['name'] )
                                {
                                    flag=1;
                                    for (var thisProp in returnObject.connected[returnConn])
                                    {
                                        console.log('Resetting the parameter '+thisProp);
                                        tempItem['content']['Equation'][thisProp] = returnObject.connected[returnConn][thisProp];
                                    }
                                    console.log('Deleting '+returnConn+' from the returned connected ids array');
                                    delete returnObject.connected[returnConn];

                                }
                            }
                        } 
                    }); 

                    // Delete the connected equation if it is not represented in the new result. It is a holdover
                    // from a previous solution.
                    if (flag==0)
                    {
                        vm.worksheetObj.forEach(function(tempItem, tempIndex)
                        {   
                            if (tempItem['itemid']==existingConn) 
                            { 
                                console.log('Deleting connected id '+existingConn+' - '+tempItem['name']);
                                vm.deleteItem(tempItem, 1);
                            } 
                        }); 
                    }
                }

                // Whatever items remain in the connected object are new. Add those as new items
                for (var connItem in returnObject.connected)
                {   
                    var connectedID = vm.addItem('Equation', returnObject.connected[connItem], 1, item['order']) 
                    console.log('I should have created '+returnObject.connected[connItem]['Format_name']);
                    item['content']['Equation']['connected_ids'][connectedID]=1;

                    // vm.worksheet.forEach(function(tempItem, tempIndex)
                    // {   
                    //     if (tempItem['itemid']==connectedID) 
                    //     { 
                    //         tempItem['name'] = returnObject.connected[connItem]['Format_name']; 
                    //         tempItem['inEdit'] = 1; 
                    //         tempItem['file_id'] = vm.cadwolf_fileInfo.id; 
                    //         tempItem['Original_id']=returnObject.id;
                    //         tempItem['content']['isConnectedEquation']=1;
                    //         setTimeout(function(){ vm.updateComponent( tempItem ), 3000});
                    //     }
                    // }); 

                    // console.log('Created a new connected item named '+returnObject.connected[connItem]['Format_name']+' with an id of '+connectedID);
                }   
            }
        });
    }
}






/*
 * Call to update an item and then update the service
 *
 */
function updateComponent( thisItem )
{   
    if (typeof(thisItem)=='object')
    {
        vm.worksheet = docItemFactory.getLastPos( vm.worksheet );
        console.log('Updating the component ...');
        console.log(thisItem);
        if (typeof(thisItem['content'])=='string')
        {
            thisItem['content']=JSON.parse(thisItem['content']);
            console.log('The content was stringified');
        }
        if (thisItem['component_type_id']==13)
        {
            var tempItem = vm.buildSurface( thisItem );
        }else
        {
            var tempItem = thisItem['content'];
        }
        if (thisItem['component_type_id']==3)
        {
            var name=thisItem['content']['Equation']['Format_name'];                    
        }else
        {
            var name=thisItem['name'];                     
        }
        $http({
            method: "PUT",
            url: window.location.origin+'/components',
            data: { 
                        id      : thisItem['id'],
                        itemid  : thisItem['itemid'],
                        file_id : vm.cadwolf_fileInfo['id'],
                        name    : name,
                        content : JSON.stringify(tempItem),
                        dependent_file : thisItem['dependent_file'],
                        dependent_id : thisItem['dependent_id'],
                        order : thisItem['order']
                  }
        }).then(function successCallback( returnData ) {
            console.log('Update component call completed');
            if (thisItem['component_type_id'] == 3)
            {
                for (var thisConn in thisItem['content']['Equation']['connected_ids'])
                {
                    vm.worksheet.forEach(
                        function(tempItem, index)
                        {
                            if (tempItem['itemid']==thisConn)
                            {
                                vm.updateComponent( tempItem );
                            }
                        }
                    );
                }
            
            }

            if ( (thisItem['component_type_id'] == 6) || (thisItem['component_type_id'] == 7) || (thisItem['component_type_id'] == 8) )
            {
                vm.worksheet.forEach(
                    function(sheetItem, index){
                        if ( sheetItem['content']['parentid'] == thisItem['itemid'] )
                        {
                            vm.updateComponent( sheetItem );
                        }
                    }
                );

            }

        }, function errorCallback( returnData ) {});
        // vm.updateService( );
    }
    console.log('Update component completed');

}        





        vm.getOnshapeDocs();
        vm.getDepFiles( );

    }


})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

/*
        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );
*/
        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.workspace', [])
        .config(config);


    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $locationProvider)
    {

        // State
        $stateProvider.state('app.workspace', {
            url      : '/Workspace{path:.*}',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/workspace/workspace.html',
                    controller : 'WorkspaceController as vm'
                }
            },
            bodyClass: 'workspace'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/workspace');

        // Navigation
        msNavigationServiceProvider.saveItem('workspace', {
            title : 'Workspace',
            icon  : 'icon-folder',
            state : 'app.workspace',
            weight: 3
        });
    }

})();
/*

	Remember, edit the code in hte /assets/code/digest folder. 
*/

(function ()
{
	'use strict';

	angular
		.module('app.workspace')
		.controller('WorkspaceController', WorkspaceController);

	/** @ngInject */
	function WorkspaceController($location, $mdSidenav, $mdDialog, $mdMedia, $sce, newItemFactory, userMemoryFactory, utilityFactory, $http, workspaceMemoryFactory, docItemFactory, chartFactory, surfaceFactory, unitConstantFactory)
	{
		// Default Items
		var equationWorker = new Worker("eqSolver.js");  
		var vm = this;
		vm.digestStatus = 1;
		window.MY_SCOPE=this;
		vm.showMenuTextTop = true;
		vm.showMenuTextBot = true;
		vm.currentUserInfo = userMemoryFactory.currentUserInfo;
		vm.userType = 'user';
		vm.permType = 'view';
		vm.potentialUser = '';
		vm.cadwolfScaleUnits		= vm.cadwolfScaleUnits || unitConstantFactory.unitsObj();
		vm.cadwolfParseUnits		= vm.cadwolfParseUnits || unitConstantFactory.parseObj();
		vm.cadwolfConstants		 	= vm.cadwolfConstants || unitConstantFactory.constObj();
		vm.chartFactory			 	= vm.chartFactory || chartFactory;
		vm.docItemFactory			= vm.docItemFactory || docItemFactory;
		vm.surfaceFactory			= vm.surfaceFactory || surfaceFactory;


		// Methods
		vm.init			 		= init;
		vm.getSpark 			= getSpark;
		vm.getFiles				= getFiles;
		vm.select				= select;
		vm.removeItem			= removeItem;
		vm.showDescription 		= showDescription;
		vm.addItem				= addItem;
		vm.getSelectedText 		= getSelectedText;
		vm.leftMenuCaller 		= leftMenuCaller;
		vm.navigateURL			= navigateURL;
		vm.goToURL				= goToURL;
		vm.upOne				= upOne;
		vm.updateItem			= updateItem;
		vm.checkOutFile			= checkOutFile;
		vm.checkInFile			= checkInFile;
		vm.getPermLists			= getPermLists;
		vm.handlePermissions	= handlePermissions;
		vm.changeUserPerm   	= changeUserPerm;
		vm.deletePermUser   	= deletePermUser;
		vm.addPermUser			= addPermUser;
		vm.showPermissions		= showPermissions;
		vm.cancel				= cancel;
		vm.uploadImage			= uploadImage;
		vm.showImage			= showImage;
		vm.showLogs				= showLogs;
		vm.showMessage			= showMessage;
		vm.showSmallModal 		= showSmallModal;
		vm.showMediumModal 		= showMediumModal;
		vm.showLargeModal 		= showLargeModal;
		vm.favoriteItem			= favoriteItem;
		vm.removeFavItem		= removeFavItem
		vm.updateUserInfo		= updateUserInfo;
		vm.getNumber			= getNumber;
		vm.changeOrder			= changeOrder;
		vm.setImages 			= setImages;
		vm.getCommentCount 		= getCommentCount;

		vm.updateFile			= updateFile;
		vm.lockFiles			= lockFiles;
		vm.runEquationDigest	= runEquationDigest;
		vm.solveEquation		= solveEquation;
		vm.handleSolverReturn   = handleSolverReturn;
		vm.addressConnectedEqs  = addressConnectedEqs;
		vm.updateComponent		= updateComponent;
		vm.saveFile				= saveFile;
		vm.saveComponents		= saveComponents;
		vm.sendPermMessage 		= sendPermMessage;
		//////////


		/**
		 *
		 *  Initial program - get the files
		 *
		 */
		/**
		 *
		 *  Initial program - get the files
		 *
		 */
		function init()
		{
			// Set the host for staging or production
			vm.thisHost = window.location.host;

			// Initialize the amazon s3 bucket
			if ( window.location.host == "cadwolf.com" )
			{
				var albumBucketName = 'cadwolf';
				var bucketRegion = 'Oregon';
				var IdentityPoolId = 'us-west-2_m1OJUoBKM';

			}else if ( window.location.host == "cadwolf-staging.herokuapp.com" )
			{
				var albumBucketName = 'cadwolf-staging';
				var bucketRegion = 'Oregon';
				var IdentityPoolId = 'us-west-2_m1OJUoBKM';				
			}

			AWS.config.update({
				region: bucketRegion,
				credentials: new AWS.CognitoIdentityCredentials({
					IdentityPoolId: IdentityPoolId
				})
			});

			vm.s3 = new AWS.S3({
				apiVersion: '2006-03-01',
				params: {Bucket: albumBucketName}
			});


			// Get the files for the workspce
			if ((window.location.href=="http://www.cadwolf.com/Workspace") ||
				(window.location.href=="http://www.cadwolf.com/Workspace/") ||
				(window.location.href=="https://www.cadwolf.com/Workspace") ||
				(window.location.href=="https://www.cadwolf.com/Workspace/") ||
				(window.location.href=="www.cadwolf.com/Workspace") ||
				(window.location.href=="www.cadwolf.com/Workspace/") ||
				(window.location.href=="cadwolf-staging.herokuapp.com/Workspace/") ||
				(window.location.href=="cadwolf-staging.herokuapp.com/Workspace") ||
				(window.location.href=="cadwolf-staging.herokuapp.com/Workspace/") ||
				(window.location.href=="http://cadwolf-staging.herokuapp.com/Workspace") ||
				(window.location.href=="http://cadwolf-staging.herokuapp.com/Workspace/") ||
				(window.location.href=="https://cadwolf-staging.herokuapp.com/Workspace") ||
				(window.location.href=="https://cadwolf-staging.herokuapp.com/Workspace/") ||
				(window.location.href=="www.cadwolf-staging.herokuapp.com/Workspace") ||
				(window.location.href=="www.cadwolf-staging.herokuapp.com/Workspace/") ||
				(window.location.href=="https://cadwolf-staging.herokuapp.com/Workspace/") ||
				(window.location.href=="https://cadwolf.com/Workspace/") )
			{

				
				if (Spark !== undefined)
				{

					// If the user is logged in, reroute to their workspace
					if (Spark.state!==undefined)
					{
						if (Spark.state.user!=null)
						{
							$location.path("/Workspace/"+Spark.state.user.username.replace(/\s+/,'_'));
							 // window.location.href="https://www.cadwolf.com/Workspace/"+Spark.state.user.username.replace(/\s+/,'_');
						}
					}else
					{
						vm.showType = 'WorkspaceEmpty';
					}

				}else
				{
					vm.showType = 'WorkspaceEmpty';
				}

			}else
			{
				vm.getFiles($location.absUrl());
				vm.selectedItem='Rank';
				vm.showType = 'Workspace';
			}

			
			// If we have spark data and a logged in user
			if (Spark !== undefined)
			{

				if (Spark.state !== undefined)
				{

					if (Spark.state.user!=null)
					{
						if ( Spark.state.user.user_info == null )
						{
							Spark.state.user.user_info = {};
							Spark.state.user.user_info.workspaces = [];
							Spark.state.user.user_info.documents = [];
							Spark.state.user.user_info.datasets = [];
							Spark.state.user.user_info.parttrees = [];
							Spark.state.user.user_info.plots = [];
							Spark.state.user.user_info.surfaces = [];
							Spark.state.user.user_info.favWorkspaces = [];
							Spark.state.user.user_info.favDocuments = [];
							Spark.state.user.user_info.favDatasets = [];
							Spark.state.user.user_info.favParttrees = [];
							Spark.state.user.user_info.favPlots = [];
							Spark.state.user.user_info.favSurfaces = [];

						}


						if (typeof(Spark.state.user.user_info)=='string')
						{
							Spark.state.user.user_info = JSON.parse( Spark.state.user.user_info );
							Spark.state.user.photo_url = Spark.state.user.photo_url.replace(window.location.origin+'/', '')
						}
					

					}else
					{
						vm.getSpark();
					}

				}else
				{
					vm.getSpark();
				}

			// If there is no spark data, check again
			}else{
				vm.getSpark();
			}


			vm.thisAddress='';

		}






		/*
		 *
		 * Get the spark parameters
		 *
		 */
		function getSpark( )
		{   

			$http({
				method: "GET",
				url: window.location.origin+'/user/current'

			}).then(function successCallback( returnData ) 
			{
				if ( returnData.state !== undefined )
				{
					Spark.state.user = returnData.data;
					returnData.data.user_info = JSON.parse(returnData.data.user_info);
				}

				if ((window.location.href=="http://www.cadwolf.com/Workspace") ||
					(window.location.href=="http://www.cadwolf.com/Workspace/") ||
					(window.location.href=="https://www.cadwolf.com/Workspace") ||
					(window.location.href=="https://www.cadwolf.com/Workspace/") ||
					(window.location.href=="www.cadwolf.com/Workspace") ||
					(window.location.href=="www.cadwolf.com/Workspace/") ||
					(window.location.href=="cadwolf-staging.herokuapp.com/Workspace"))
				{

					// If the user is logged in, reroute to their workspace
					if (Spark.state.user!=null)
					{
						$location.path("/Workspace/"+Spark.state.user.username.replace(/\s+/,'_'));
						 // window.location.href="https://www.cadwolf.com/Workspace/"+Spark.state.user.username.replace(/\s+/,'_');
					}else
					{
						vm.showType = 'WorkspaceEmpty';
					}

				}else
				{
					vm.getFiles($location.absUrl());
					vm.selectedItem='Rank';
					vm.showType = 'Workspace';
				}
			
			});

		}






		/**
		 *
		 *  Get the files in folder
		 *
		 */
		function getFiles( thisURL )
		{
			$http({
			  method: 'GET',
			  url: window.location.origin+'/files',
			  params:{ thisURL : thisURL }
			}).then(function successCallback( returnData ) {

					// If no file was found at the given address, but one was found at a different module, that module is returned
					if ( returnData.data.fileInfo == "noFile" )
					{
						if ( returnData.data.files == "Workspace" )
						{
							$location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Document/, '\/Workspace'));
						}
						if ( returnData.data.files == "Dataset" )
						{
							$location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Document/, '\/Dataset'));
						}
						if ( returnData.data.files == "PartTree" )
						{
							$location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Document/, '\/PartTree'));
						}
						if ( returnData.data.files == "Workflow" )
						{
							$location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Document/, '\/Workflow'));
						}
						if ( returnData.data.files == "Forum" )
						{
							$location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Document/, '\/Forum'));
						}

					}
					if ( returnData.data.fileInfo.file_type_id == 'Document' )
					{
						$location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Workspace/, '\/Document'));
					}
					if ( returnData.data.fileInfo.file_type_id == 'Dataset' )
					{
						$location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Workspace/, '\/Dataset'));
					}
					if ( returnData.data.fileInfo.file_type_id == 'PartTree' )
					{
						$location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Workspace/, '\/PartTree'));
					}
					if ( returnData.data.fileInfo.file_type_id == 'Workflow' )
					{
						$location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Workspace/, '\/Workflow'));
					}
					if ( returnData.data.fileInfo.file_type_id == 'Forum' )
					{
						$location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Workspace/, '\/Forum'));
					}

					vm.cadwolf_permissions = returnData['data']['permissions'];
					vm.cadwolf_files = returnData['data']['files'];
					vm.cadwolf_fileInfo = returnData['data']['fileInfo'];

					vm.getCommentCount( );



					// Autoset any images
					vm.setImages();


					/**
					 *
					 * This is the code that facilitates the amplitude analytics code
					 *
					 */
					if ( window.amplitude === undefined )
					{
						var e=window;
						var t=document
						var n=e.amplitude||{_q:[],_iq:{}};var r=t.createElement("script")
						  ;r.type="text/javascript";r.async=true
						  ;r.src="https://cdn.amplitude.com/libs/amplitude-4.4.0-min.gz.js"
						  ;r.onload=function(){if(e.amplitude.runQueuedFunctions){
						  e.amplitude.runQueuedFunctions()}else{
						  console.log("[Amplitude] Error: could not load SDK")}}
						  ;var i=t.getElementsByTagName("script")[0];i.parentNode.insertBefore(r,i)
						  ;function s(e,t){e.prototype[t]=function(){
						  this._q.push([t].concat(Array.prototype.slice.call(arguments,0)));return this}}
						  var o=function(){this._q=[];return this}
						  ;var a=["add","append","clearAll","prepend","set","setOnce","unset"]
						  ;for(var u=0;u<a.length;u++){s(o,a[u])}n.Identify=o;var c=function(){this._q=[]
						  ;return this}
						  ;var l=["setProductId","setQuantity","setPrice","setRevenueType","setEventProperties"]
						  ;for(var p=0;p<l.length;p++){s(c,l[p])}n.Revenue=c
						  ;var d=["init","logEvent","logRevenue","setUserId","setUserProperties","setOptOut","setVersionName","setDomain","setDeviceId","setGlobalUserProperties","identify","clearUserProperties","setGroup","logRevenueV2","regenerateDeviceId","logEventWithTimestamp","logEventWithGroups","setSessionId","resetSessionId"]
						  ;function v(e){function t(t){e[t]=function(){
						  e._q.push([t].concat(Array.prototype.slice.call(arguments,0)))}}
						  for(var n=0;n<d.length;n++){t(d[n])}}v(n);n.getInstance=function(e){
						  e=(!e||e.length===0?"$default_instance":e).toLowerCase()
						  ;if(!n._iq.hasOwnProperty(e)){n._iq[e]={_q:[]};v(n._iq[e])}return n._iq[e]}
						  ;e.amplitude=n;

						 amplitude.getInstance().init("85374354a72a1d05529735dc0be7f8d8");
					}

					if (Spark !== undefined)
					{
						// Send the amplitude data
						if ( Spark.state !== undefined )
						{
							if (Spark.state.user!=null)
							{ 
								amplitude.getInstance().setUserId( Spark.state.user.id );
							}
						}
					}

					// Send the amplitude data
					amplitude.getInstance().logEvent("Workspace View",
					    { title: vm.cadwolf_fileInfo.name,
					      id: vm.cadwolf_fileInfo.id });

					if (Spark !== undefined)
					{
						if ( Spark.state !== undefined )
						{
							if (Spark.state.user!=null)
							{ 
								Spark.state.user.user_info = utilityFactory.setRecent( 'Workspace', vm.cadwolf_fileInfo, Spark.state.user.user_info, window.location.pathname ); 
								vm.cadwolf_fileInfo.favorite = utilityFactory.checkFavorite( 'Workspace', vm.cadwolf_fileInfo, Spark.state.user.user_info, window.location.pathname );
								vm.updateUserInfo();
							}
						}
					}

					vm.selected = vm.cadwolf_files[0];
					if ( typeof(vm.cadwolf_fileInfo.item_data)=="string" )
					{
						vm.cadwolf_fileInfo.item_data = JSON.parse( vm.cadwolf_fileInfo.item_data );
					}
					if ( vm.cadwolf_fileInfo.item_data.CADFiles === undefined )
					{
						vm.cadwolf_fileInfo.item_data.CADFiles = [];
					}

					// Set the type of view
					if ( vm.cadwolf_fileInfo.item_data.viewType === undefined )
					{
						vm.cadwolf_fileInfo.item_data.viewType = 'list';
					}
					if ( vm.cadwolf_files.length > 20 )
					{
						vm.cadwolf_fileInfo.item_data.viewType = 'list';
					}else
					{
						vm.cadwolf_fileInfo.item_data.viewType = 'quilt';
					}



					document.title = "CADWOLF - Workspace - "+vm.cadwolf_fileInfo.name;

					vm.cadwolf_files.forEach(function(thisItem, index)
					{  
						var thisDate = thisItem['created_at'].split(' ');
						thisItem['created_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
						var thisDate = thisItem['updated_at'].split(' ');
						thisItem['updated_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
						//vm.getPermLists( thisItem );
					});
					if ( returnData.data.files === undefined )
					{
						vm.noWorkspace = true;
					}else
					{
						vm.noWorkspace = false;
					}
			  }, function errorCallback( returnData ) {
					vm.cadwolf_files = [];
					vm.noWorkspace = true;
			});
		}




		/**
		 *
		 *  Make sure that all items have an image
		 *
		 */
		function setImages( )
		{

			// Loop through each file and check to see if it has an image
			vm.cadwolf_files.forEach(function(thisItem, index)
			{

				if ( thisItem.file_type_id == "Image" )
				{
					thisItem.item_data.fileImage = thisItem.item_data.imageSource;

				}else if ( ( thisItem.file_type_id == "Part Tree") &&
						   ( ( thisItem.item_data.fileImage === undefined ) ||
						   	 ( thisItem.item_data.fileImage === '' ) ) )
				{
					thisItem.item_data.fileImage = "stock/parttree.png";

				}else if ( ( thisItem.file_type_id == "Dataset") &&
						   ( ( thisItem.item_data.fileImage === undefined ) ||
						   	 ( thisItem.item_data.fileImage === '' ) ) )
				{
					thisItem.item_data.fileImage = "stock/dataset.png";

				}else if ( ( thisItem.file_type_id == "Workspace") &&
						   ( ( thisItem.item_data.fileImage === undefined ) ||
						   	 ( thisItem.item_data.fileImage === '' ) ) )
				{
					thisItem.item_data.fileImage = "stock/workspace.png";

				}else if ( ( thisItem.file_type_id == "Workflow") &&
						   ( ( thisItem.item_data.fileImage === undefined ) ||
						   	 ( thisItem.item_data.fileImage === '' ) ) )
				{
					thisItem.item_data.fileImage = "stock/workflow.png";

				}else if ( ( thisItem.file_type_id == "Forum") &&
						   ( ( thisItem.item_data.fileImage === undefined ) ||
						   	 ( thisItem.item_data.fileImage === '' ) ) )
				{
					thisItem.item_data.fileImage = "stock/forum.png";

				}else if ( ( thisItem.item_data.fileImage === undefined ) ||
					 	 ( thisItem.item_data.fileImage == '' ) )
				{

					// If there is no image, get the first one
					$http({
					  method: 'GET',
					  url: window.location.origin+'/setImage/'+thisItem.id,
					  params:{ }
					}).then(function successCallback( returnData ) {

						thisItem.item_data.fileImage = returnData.data;
						vm.updateItem( thisItem );
					});

				}

			});

		}















		/*
		 *
		 * Select an item - Wait until item is selected to get permissions
		 *
		 * @param item
		 */
		function select(item)
		{
			vm.selected = item;
			vm.getPermLists( item );

		}





		/**
		 *
		 * Navigate to a new file, folder, etc
		 *
		 */
		function navigateURL( fileItem )
		{
			var newURL=utilityFactory.makeURL( fileItem, window.location.href );
			$location.path(newURL.replace(window.location.origin+'',''));
		}



		/**
		 *
		 * Navigate to a given URL
		 *
		 */
		function goToURL( thisURL )
		{
			thisURL.replace('/^\/Workspace/','');
			thisURL.replace('/^Workspace/','');
			thisURL.replace('/^\//','');
			$location.path('/Workspace/'+thisURL);
		}





		/**
		 * Handle the select sort by item
		 */
		function getSelectedText () 
		{   if (vm.selectedItem !== undefined) {
				return "You have selected: Item " + vm.selectedItem;
			} else {
				return "Please select an item";
			}
		};





		/*
		 *
		 * Add a new item
		 *
		 */
		function addItem( type ) 
		{

			var thisURL = window.location.href.replace(/\/$/, '');
			$http({
			  method: 'POST',
			  url: window.location.origin+'/files',
			  data:{ thisURL : thisURL, file_type_id : type }
			}).then(function successCallback( returnData ) {
				if (returnData.data.error==true)
				{
					if (returnData.data.errorType=="duplicate")
					{
						vm.showMessage( '', { messageType : 'failure', 
											  messageTitle : 'Name already taken', 
											  messageText : 'The name for the file, folder, or system given is already in use. Duplicate names are not allowed.'});
					}
				}else
				{
					vm.cadwolf_files.push(returnData.data);
					vm.cadwolf_files.forEach(function(thisItem, index)
					{  
						var thisDate = thisItem['created_at'].split(' ');
						thisItem['created_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
						var thisDate = thisItem['updated_at'].split(' ');
						thisItem['updated_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
					});

					vm.setImages();

				}
			  }, function errorCallback( returnData ) {

			});

			// Send the amplitude data for a new item being created
			if ( ( type == "Workspace" ) ||  ( type == "workspace" ) )
			{
				amplitude.getInstance().logEvent('New Workspace');
			}
			if ( ( type == "Document" ) ||  ( type == "document" ) )
			{
				amplitude.getInstance().logEvent('New Document');
			}
			if ( ( type == "Dataset" ) ||  ( type == "dataset" ) )
			{
				amplitude.getInstance().logEvent('Dataset');
			}
			if ( ( type == "Part Tree" ) ||  ( type == "parttree" ) )
			{
				amplitude.getInstance().logEvent('New Part Tree');
			}


		};





		/*
		 *
		 * Move up one item
		 *
		 */
		function upOne( ) 
		{
			var thisURL = window.location.href.replace(/\/$/, '');
			var thisURL = thisURL.replace(/[a-zA-Z0-9\_\-]+$/, '');
			//vm.getFiles( thisURL );
			history.pushState(null, null, thisURL);
		};





		/*
		 *
		 * Call a function from the left menu
		 *
		 */
		function leftMenuCaller( event, menuItem, flag )
		{   
			if (flag==1)
			{
				vm.addItem( menuItem );
			}else
			{
				if ((menuItem == 'Edit Title')||
					(menuItem == 'Delete Item')||
					(menuItem == 'Create New Version'))
				{
					vm.showSmallModal( event, vm.selected, menuItem, false );
				
				}else if ((menuItem == 'Edit Description') ||
						  (menuItem == 'Copy Item')||
						  (menuItem == 'Move Item')||
						  (menuItem == 'Edit Properties')||
						  (menuItem == 'Set Image'))
				{
					vm.showMediumModal( event, vm.selected, menuItem, false );
					// vm.showDescription( event, vm.selected, false );

				}else if (menuItem == 'Edit Permissions')
				{
					vm.getPermLists( vm.selected );
					vm.showLargeModal( event, vm.selected, menuItem, false );
					// vm.showPermissions( event, vm.selected, false );

				}else if (menuItem == 'View Item Log')
				{
				   vm.showLogs( event, vm.selected, menuItem );
				}
			}
		};




		/*
		 * Edit the description of an item
		 */
		function showDescription(ev, thisItem, mainFlag) 
		{
			$mdDialog.show({
				controller: 'DialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/workspace/views/list/editDescription.tmpl.html',
				locals:{
					thisItem:thisItem
				},
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
				if (mainFlag)
				{
					vm.cadwolf_fileInfo.item_data.description = $sce.trustAsHtml(data.newDesc);
					vm.updateItem( vm.cadwolf_fileInfo );
				}else
				{
					vm.selected.item_data.description = $sce.trustAsHtml(data.newDesc);
					vm.updateItem( vm.selected );
				}
			}, function() {
				
			});
		};





		/**
		 * Show the history for an item
		 */
		function showLogs(ev, thisItem, menuItem ) 
		{   
			$http({
				method: "GET",
				url: window.location.origin+'/logs/'+thisItem['id']
			}).then(function successCallback(returnData) {
				vm.logData = returnData.data;

				for (var a=0; a<vm.logData.length; a++)
				{
					if (vm.logData[a]['message_text']!='')
					{
						vm.logData[a]['message_text']=JSON.parse(vm.logData[a]['message_text']);
					}
				}
				vm.showMediumModal( ev, thisItem, menuItem, false );
			}, function errorCallback( returnData ) { });
		};



		/*
		 *
		 * Remove an item from the main array and delete it
		 *
		 */
		function removeItem(item, deleteFlag) 
		{   
			vm.cadwolf_files.forEach(function(thisItem, index)
			{   
				if (thisItem['id']==item['id'])
				{   
					vm.cadwolf_files.splice(index, 1);
					if (deleteFlag)
					{   
						$http({
							method: "DELETE",
							url: window.location.origin+'/files/'+item['id']
						}).then(function successCallback( returnData ) {
								vm.cadwolf_files=returnData.data;
								vm.cadwolf_files.forEach(function(thisItem, index)
								{  
									var thisDate = thisItem['created_at'].split(' ');
									thisItem['created_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
									var thisDate = thisItem['updated_at'].split(' ');
									thisItem['updated_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
								});

						}, function errorCallback( returnData ) {});
					}
				}
			});
		};





		/*
		 *
		 * Update the properties of an item
		 *
		 */
		function updateItem(item) 
		{   
			console.log('Updating '+item['id']+' with '+item['name']+'-'+item['parent_id']);
			$http({
				method: "PUT",
				url: window.location.origin+'/files/'+item['id'],
				data: { name : item['name'],
						parent_id : parseInt(item['parent_id'], 10),
						item_data : item['item_data']
					  }
			}).then(function successCallback( returnData ) {
			}, function errorCallback( returnData ) {});
		};









		/*
		 *
		 * Checkout a document
		 *
		 */
		function checkOutFile( item ) 
		{   
			$http({
				method: "POST",
				url: window.location.origin+'/checkout/'+item['id'],
			}).then(function successCallback( returnData ) {
				if(returnData.data=="noPerm")
				{

				}else
				{
					item['item_data']['checkout_id']=returnData.data['id'];
					item['item_data']['checkout_name']=returnData.data['name'];
					vm.getFiles($location.absUrl());
				}
			}, function errorCallback( returnData ) {});
			
		};



		/*
		 *
		 * Checkin a document
		 *
		 */
		function checkInFile( item ) 
		{   
			$http({
				method: "POST",
				url: window.location.origin+'/checkin/'+item['id'],
			}).then(function successCallback( returnData ) {
				if(returnData.data=="noPerm")
				{

				}else
				{
					item['item_data']['checkout_id']=returnData.data;
					item['item_data']['checkout_name']='';
					vm.getFiles($location.absUrl());
				}
			}, function errorCallback( returnData ) {});
			
		};










		/*
		 *
		 * Make an item a favorite
		 *
		 */
		function favoriteItem( ) 
		{   
			Spark.state.user.user_info = utilityFactory.favoriteItem( 'Workspace', 
																	  vm.cadwolf_fileInfo, 
																	  Spark.state.user.user_info, 
																	  window.location.pathname.replace(/^\/Workspace\//,'') ); 
			console.log('The item returned from the factory is '+Spark.state.user.user_info);
			vm.cadwolf_fileInfo.favorite=!vm.cadwolf_fileInfo.favorite; 
			vm.updateUserInfo();
		};






		/*
		 *
		 * Remove a favorite
		 *
		 */
		function removeFavItem( thisItem ) 
		{   
			Spark.state.user.user_info = utilityFactory.favoriteItem( 'Workspace', 
																	  thisItem, 
																	  Spark.state.user.user_info, 
																	  window.location.pathname.replace(/^\/Workspace\//,'') ); 
			vm.updateUserInfo();
		};





		/*
		 *
		 * Update User Info
		 *
		 */
		function updateUserInfo( ) 
		{   
			$http({
				method: 'PUT',
				url: window.location.origin+'/updateUserInfo',
				data:{ userID : Spark.state.user.id, thisUser : Spark.state.user.user_info }
			}).then(function successCallback( returnData ) {
			}, function errorCallback( returnData ) {});
		};










		/*
		 *
		 * Edit the permissions of an item
		 *
		 */
		function showPermissions(ev, thisItem) 
		{   
			vm.getPermLists( thisItem );
			$mdDialog.show({
				templateUrl: 'app/main/apps/workspace/views/list/editPermissions.tmpl.html',
				controller: function(){ return vm },
				controllerAs: 'vm',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
			}, function() {
				
			});
		};

		function cancel(){
			$mdDialog.cancel();
		};








		/*
		 *
		 * Show an image in a popup
		 *
		 */
		function showImage(ev, thisItem) 
		{   
			vm.currentImage = thisItem;
			$mdDialog.show({
				templateUrl: 'app/main/apps/workspace/views/list/showImage.tmpl.html',
				controller: function(){ return vm },
				controllerAs: 'vm',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
			}, function() {
				
			});
		};




		function showMessage(ev, messageObj) 
		{
			if (messageObj.messageType=="success")
			{
				var templateURL = 'app/main/apps/document/worksheet/views/templates/successMessage.tmpl.html';
			}
			if (messageObj.messageType=="failure")
			{
				var templateURL = 'app/main/apps/document/worksheet/views/templates/failureMessage.tmpl.html';
			}

			$mdDialog.show({
				templateUrl: templateURL,
				controller: function(){ return vm },
				controllerAs: 'vm',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {}, function() { });
		};









		/**
		 *
		 * SHOW THE SMALL MODAL WINDOW
		 *
		 */
		function showSmallModal( ev, thisItem, modalType, mainFlag ) 
		{
			console.log('The modal type for the small modal is '+modalType);
			$mdDialog.show({
				controller: 'DialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/workspace/views/list/smallModalTemplates.tmpl.html',
				locals:{
					thisItem:thisItem,
					modalType:modalType,
					logData : vm.logData,
					Spark : Spark,
					fileInfo : vm.cadwolf_fileInfo
				},
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
				console.log('The data from the modal window is ');
				console.log(data);
				console.log('The modal type is '+modalType);
				if ( modalType == 'Edit Title' )
				{
					if (newItemFactory.checkNewName(data))
					{   if (mainFlag)
						{
							vm.cadwolf_fileInfo.name=data;
							vm.updateItem( vm.cadwolf_fileInfo );
						}else
						{
							vm.selected.name=data;
							vm.updateItem( vm.selected );
						}
						// Call to server to change a description by the items ID
					}
				}
				if ( modalType == 'Delete Item' )
				{
					vm.removeItem(data, true);
				}
				if ( modalType == 'Create New Version' )
				{
					vm.getFiles($location.absUrl());
				}
			});
		};


		/**
		 *
		 * SHOW THE MEDIUM MODAL WINDOW
		 *
		 */
		function showMediumModal( ev, thisItem, modalType, mainFlag ) 
		{
			console.log('The modal type for the medium modal is '+modalType);
			$mdDialog.show({
				controller: 'DialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/workspace/views/list/mediumModalTemplates.tmpl.html',
				locals:{
					thisItem:thisItem,
					modalType:modalType,
					logData : vm.logData,
					fileInfo : vm.cadwolf_fileInfo,
					Spark : Spark
				},
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
				console.log('In the medium dialog edit, the data is ...');
				console.log(data);
				if ( modalType == 'Copy Item' )
				{
					console.log('The copy return data is ...');
					console.log(data);
					vm.cadwolf_files = data;
				}
				if ( modalType == 'Move Item' )
				{
					vm.getFiles($location.absUrl());
					console.log('The move return data is ...');
					console.log(data);

				}
				if (mainFlag)
				{
					if ( modalType == 'Set Image' )
					{
						vm.updateItem( vm.cadwolf_fileInfo );
					
					}else if ( modalType == 'Edit Properties' )
					{

						if (newItemFactory.checkNewName(data.name))
						{   
							vm.cadwolf_fileInfo.name=data.name;
							vm.cadwolf_fileInfo.item_data.description = data.desc;
							vm.updateItem( vm.selected );
						}

					}else
					{
						vm.cadwolf_fileInfo.item_data.description = data;
						vm.updateItem( vm.cadwolf_fileInfo );
					}
				}else
				{
					if ( modalType == 'Edit Description' )
					{
						vm.selected.item_data.description = data;

					}else if ( modalType == 'Edit Properties' )
					{

						if (newItemFactory.checkNewName(data.name))
						{   
							vm.selected.name=data.name;
							vm.selected.item_data.description = data.desc;
							vm.updateItem( vm.selected );
						}
					}else if ( modalType == 'Set Image' )
					{
						vm.updateItem( vm.selected );
					}
				}
			});
		};









		/**
		 *
		 * SHOW THE LARGE MODAL WINDOW
		 *
		 */
		function showLargeModal( ev, thisItem, modalType, mainFlag ) 
		{
			console.log('The modal type for the large modal is '+modalType);
			vm.thisItem = thisItem;
			vm.modalType = modalType;
			vm.fileInfo = vm.cadwolf_fileInfo;
			$mdDialog.show({
				controller: function(){ return vm },
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/workspace/views/list/largeModalTemplates.tmpl.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
			});
		};









		/**
		 *
		 * Items related to the permissions
		 *
		 */


		/**
		 *
		 * Handle a change in the permissions settings
		 *
		 */
		function getPermLists( fileItem )
		{
			$http({
				method: "GET",
				url: window.location.origin+'/permissions/'+fileItem['id'],
			}).then(function successCallback( returnData ) {
				fileItem['item_data']['permList'] = returnData.data;
			}, function errorCallback( returnData ) {
				fileItem['item_data']['permList'] = [];
			});
		}



		/**
		 *
		 * Handle a change in the permissions settings. 
		 *
		 */
		function handlePermissions( fileItem, changeType )
		{
			if ( changeType == 'view' )
			{
				if (fileItem['item_data']['viewPerm']=='list')
				{
					fileItem['item_data']['editPerm']='list';
					fileItem['item_data']['adminPerm']='list';
				}
				if (fileItem['item_data']['viewPerm']=='inherit')
				{
					fileItem['item_data']['editPerm']='inherit';
					fileItem['item_data']['adminPerm']='inherit';
				}
			}
			if ( changeType == 'edit' )
			{
				if (fileItem['item_data']['editPerm']=='list')
				{
					fileItem['item_data']['adminPerm']='list';
					if (fileItem['item_data']['viewPerm']=="inherit")
					{
						fileItem['item_data']['viewPerm']="list";
					}
				}
				if (fileItem['item_data']['editPerm']=='inherit')
				{
					fileItem['item_data']['viewPerm']='inherit';
					fileItem['item_data']['adminPerm']='inherit';
				}
			}
			if ( changeType == 'admin' )
			{
				if (fileItem['item_data']['adminPerm']=='inherit')
				{
					fileItem['item_data']['viewPerm']='inherit';
					fileItem['item_data']['editPerm']='inherit';
				}
				if (fileItem['item_data']['adminPerm']=='list')
				{
					if (fileItem['item_data']['viewPerm']=="inherit")
					{
						fileItem['item_data']['viewPerm']="list";
					}
					if (fileItem['item_data']['editPerm']=="inherit")
					{
						fileItem['item_data']['editPerm']="list";
					}
				}
			}
			$http({
				method: "POST",
				url: window.location.origin+'/permissions/'+fileItem['id'],
				params: { viewPerm : fileItem['item_data']['viewPerm'], editPerm : fileItem['item_data']['editPerm'], adminPerm : fileItem['item_data']['adminPerm'] }
			}).then(function successCallback( returnData ) {
			}, function errorCallback( returnData ) {});

		}


		/**
		 *
		 * Check to see if the user that was entered is valid
		 *
		 */
		function addPermUser( fileItem )
		{
			var thisUser = vm.potentialUser; 
			var userType = vm.userType; 
			var permType = vm.permType;

			vm.currentListPermError = '';
			console.log('In the add perm user code');
			$http({
				method: "POST",
				url: window.location.origin+'/addPermUser',
				params: { fileID : fileItem['id'], 
						  permType : permType, 
						  userName : thisUser, 
						  userType : userType,
						  file_type_id : fileItem['file_type_id'] }
			}).then(function successCallback( returnData ) 
			{
				if (returnData.data == 'noPerm')
				{
					vm.currentListPermError = 'You do not have permissions to add or delete users';
				
				}else if (returnData.data == 'noUser')
				{
					vm.currentListPermError = 'noUser';
				
				}else 
				{
					fileItem.item_data.permList = returnData.data;
				}
			}, function errorCallback( returnData ) {});
		}

		/**
		 *
		 * Delete a user from the list 
		 *
		 */
		function deletePermUser( fileItem, userID, userType )
		{
			$http({
				method: "POST",
				url: window.location.origin+'/deletePermUser',
				params: { fileID : fileItem['id'], userType : userType, userID : userID }
			}).then(function successCallback( returnData ) {
				if (returnData.data == 'noPerm')
				{
					vm.currentListPermError = 'You do not have permissions to add or delete users';
				
				}else if (returnData.data == 'noUser')
				{
					vm.currentListPermError = 'No user was found with that name';
				
				}else 
				{
					fileItem.item_data.permList = returnData.data;
				}
			}, function errorCallback( returnData ) {});

		}





		/**
		 *
		 * Change a users permission 
		 *
		 */
		function changeUserPerm( fileItem, userID, userType, permType )
		{
			$http({
				method: "POST",
				url: window.location.origin+'/changePermUser',
				params: { fileID : fileItem['id'], permType : permType, userType : userType, userID : userID }
			}).then(function successCallback( returnData ) {
				if (returnData.data['message']=='noPerm')
				{
					vm.currentListPermError = 'You do not have permissions to add or delete users';
				
				}else if (returnData.data['message']=='noUser')
				{
					vm.currentListPermError = 'No user was found with that name';
				
				}else
				{ 
					fileItem.item_data.permList = returnData.data;
				}
			}, function errorCallback( returnData ) {});

		}






		/**
		 *
		 * Upload an Image
		 *
		 */
		function uploadImage( file )
		{
			var fileID = file.id;
			var fd = new FormData(document.getElementById('uploadFile'+fileID).files[0]);
			var folder = window.location.pathname.replace(/ /g,'_');
			fd.append('folder', folder);
			fd.append('fileID', fileID);
			fd.append('image', document.getElementById('uploadFile'+fileID).files[0]);
			$http.post(window.location.origin+"/imageUpload", fd, {
				withCredentials: true,
				headers: {'Content-Type': undefined },
				transformRequest: angular.identity
			}).then(function successCallback(returnData) {
				console.log(returnData.data);
				file['item_data']=returnData.data;
			}, function errorCallback(returnData) {

			});

		}





		/**
		 *
		 * Change the order of an item
		 *
		 */
		function changeOrder( file )
		{
			$http({
			  method: 'POST',
			  url: window.location.origin+'/files/changeOrder/'+file.id,
			  params:{ order : file.order }
			}).then(function successCallback( returnData ) 
			{
				vm.cadwolf_files = returnData['data']['files'];

				vm.cadwolf_files.forEach(function(thisItem, index)
				{  
					var thisDate = thisItem['created_at'].split(' ');
					thisItem['created_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
					var thisDate = thisItem['updated_at'].split(' ');
					thisItem['updated_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
				});
			});
		}









		/*
		 *
		 * Send a message to a user from the workspace page
		 *
		 */
		function sendPermMessage( file, perm ) 
		{   

			console.log('In the send perm message ');
			console.log(perm);

			$mdDialog.show({
				controller: 'DialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/workspace/views/list/mediumModalTemplates.tmpl.html',
				locals:{
					modalType:'Send Message',
					fileInfo : vm.cadwolf_fileInfo,
					thisItem : vm.selected,
					messageFile : file,
					Spark : Spark
				},
				parent: angular.element(document.body),
				targetEvent: '',
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {


				$http({
				  method: 'POST',
				  url: window.location.origin+'/messages',
				  data:{ 	sender_id : Spark.state.user.id,
				  			receiver_id : perm.user_id,
				  			receiver_type : 0,
				  			message_type : 1,
				  			status : 1,
				  			content : {
				  		   		title : data.title,
				  		   		messageText : data.text,
				  		   		tags : {},
				  		   		starred : 0,
				  		   		sentDate : new Date()
				  		   },
				  		   file : file 
				  		}
				}).then(function successCallback( returnData ) {

				});

			});

		};










		/**
		 *
		 * Count the number of comments for the forums
		 *
		 */
		function getCommentCount( )
		{
			console.log('In the get comment count code');

			var fileArray = [];

			vm.cadwolf_files.forEach(function(thisFile, index)
			{  
				if ( thisFile['file_type_id'] == "Forum" )
				{
					fileArray.push(thisFile.id);
				}
			});


			if ( fileArray.length>0 )
			{

				// If forum, get the discussion data
				$http({
					method: "POST",
					url: window.location.origin+'/commentCount',
					data: { fileArray : fileArray  }
				}).then(function successCallback( returnData ) 
				{

					console.log(returnData);

					vm.cadwolf_files.forEach(function(thisFile, index)
					{
						if ( thisFile['file_type_id'] == "Forum" )
						{
							thisFile['commentCount'] = returnData.data[thisFile.id];
						}
					});

				});
			}


		}








		/**
		 *
		 * create an array for repeat purposes
		 *
		 */
		function getNumber( number )
		{
			return new Array( number ); 
		}



		/*
		*
		*   Here, the equation digest functions are injected through gulp. These functions are in 
		*   the /src/assets/code/digest folder
		*/

		/*
 *
 *  This is the function called when a user clicks to update a file to be updated. It
 *  pulls all of the items for the document and then runs through them and solves the
 *  needed items.
 *  
 *  @param - fileID - the id of the file being updated
 *  @param - thisType - a string telling this code where it is being run - 'workspace', 'parttree', or 'documentUpdate'
 *
 */
function updateFile( fileID, thisType )
{
    console.log('In the updateFile function for the document '+fileID);
    var otherWorksheet = {};

    // Pull the worksheet items from the server
    $http({
        method: "GET",
        url: '/files/getSolveItems/'+fileID,
    }).then(function successCallback( returnData ) 
    {
        var otherWorksheet = returnData.data.components;
        var fileInfo = returnData.data.fileInfo;
        vm.lockFiles( 1 );
        console.log('The new worksheet is ...');
        console.log( otherWorksheet );
        vm.runEquationDigest( otherWorksheet, fileInfo, 1, thisType );


    }, function errorCallback( returnData ) { 
            vm.showMessage( '', { messageType : 'failure', 
                                  messageTitle : 'Error Getting Solve Items', 
                                  messageText : 'There was an error getting the equations to update the file. Make sure your logins have not expired.'});
    });

}




/*
*
*   EQUATION DIGEST FOR UPDATING OTHER FILES
*   @param - worksheet - an array of the items to be solved
*   @param - fileinfo - the object holding the file data - generally the cadwolf_fileInfo variable
*   @param - savefile - if at the end of the updates, the components of the file should be saved and the status updated (1 or 0)
*
*/

function runEquationDigest ( worksheet, fileInfo, savefile, thisType )
{   
    vm.worksheet = JSON.parse(JSON.stringify(worksheet));
    if ( vm.worksheet === undefined ){ vm.worksheet = vm.cadwolf_worksheet; }

    console.log('In the equation digest loop with a status of '+vm.digestStatus+' and a type of '+thisType);
    console.log('The worksheet is ...');
    console.log(vm.worksheet);

    for (var a=0; a<vm.worksheet.length; a++)
    {   
        if (typeof(vm.worksheet[a]['content'])=="string")
        {
            vm.worksheet[a]['content'] = JSON.parse(vm.worksheet[a]['content']);
        }
    }


    if (vm.digestStatus==1)
    {   
        vm.worksheet=vm.worksheet.sort(utilityFactory.dynamicSort("order"));
        
        for (var a=0; a<vm.worksheet.length; a++)
        {   
            if (((vm.worksheet[a]['component_type_id']==3) &&
                (vm.worksheet[a]['content']['needsUpdateFlag']==1)) ||
                ((vm.worksheet[a]['component_type_id']==3) &&
                (vm.worksheet[a]['update'])))
            {   
                console.log('Calling the solver for '+vm.worksheet[a]['itemid']);
                vm.digestStatus=0;
                vm.worksheet[a]['content']['needsUpdateFlag']=0;
                vm.worksheet[a]['content']['Equation']['inEdit']=1;
                vm.worksheet[a]['update']=false;
                if ((!vm.editPerm) && (vm.worksheet[a]['content']['Equation']['Format_editinuse']==1))
                {
                    vm.worksheet[a]['content']['Equation']['newEquation'] = vm.worksheet[a]['content']['Equation']['Format_left']+'='+vm.worksheet[a]['content']['Equation']['Format_right']
                }
                if ( ( vm.worksheet[a]['content']['Equation']['inputType'] == 'File' ) || ( vm.worksheet[a]['content']['Equation']['inputType'] == 'Dataset' ))
                {
                    vm.worksheet = docItemFactory.populateDeps( vm.worksheet[a]['itemid'], vm.worksheet);
                    vm.worksheet = docItemFactory.findDependents(vm.worksheet[a]['itemid'], 0, vm.worksheet);
                    vm.digestStatus=1;
                    runEquationDigest ( vm.worksheet, fileInfo, savefile, thisType );
                    savefile=0;
                }else
                {
                    vm.solveEquation( vm.worksheet[a]['itemid'], 'SolveEquation', '', fileInfo );   
                    savefile=0;
                }
                break
            }


            if (vm.worksheet[a]['component_type_id']==5)
            {   var flag=0;
                for (var b=0; b< vm.worksheet[a]['content']['data'].length; b++)
                {   for (var c=0; c< vm.worksheet[a]['content']['data'][0].length; c++)
                    {   console.log('Checking index '+b+'-'+c);
                        if (vm.worksheet[a]['content']['data'][b][c]['needsUpdateFlag']==1)
                        {   vm.worksheet[a]['solveRow']=b
                            vm.worksheet[a]['solveCol']=c
                            if (vm.worksheet[a]['content']['data'][b][c]['equation'].match(/^=/)==null)
                            {   console.log('Setting index '+b+'-'+c+' to '+vm.worksheet[a]['content']['data'][b][c]['equation']);
                                vm.worksheet[a]['content']['data'][b][c]['real']=vm.worksheet[a]['content']['data'][b][c]['equation'];
                                vm.digestStatus=1;
                            }else
                            {   if (utilityFactory.isNumber(vm.worksheet[a]['content']['data'][b][c]['equation'].replace(/^=/,'')))
                                {   vm.worksheet[a]['content']['data'][b][c]['real']=parseFloat(vm.worksheet[a]['content']['data'][b][c]['equation'].replace(/^=/,''));
                                    vm.worksheet[a]['content']['data'][b][c]['needsUpdateFlag']=0;
                                    console.log('I am updating the dependents on '+String.fromCharCode(65+c)+' - '+b);
                                    docItemFactory.findDependents(vm.worksheet[a]['itemid']+'.'+String.fromCharCode(65+c)+'.'+b, 0, vm.worksheet);
                                    flag=1;
                                    break
                                }else
                                {   console.log('Solving for index '+b+'-'+c+' with an equation of '+vm.worksheet[a]['content']['data'][b][c]['equation']);
                                    vm.digestStatus=0;
                                    vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveTableCell', '', fileInfo); 
                                    flag=1;
                                    break
                                }
                            }
                        }
                    } 
                    if (flag==1) { break }
                }
                if (flag==1) { break }
            }

            // Check and update the loop parameters
            if ((vm.worksheet[a]['component_type_id']==6) &&
                (vm.worksheet[a]['content']['needsBlockUpdate']==1) &&
                (vm.digestStatus==1))
            {   vm.digestStatus=0;
                vm.worksheet[a]['content']['forLoop']['firstRun']=1;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveLoopParameters', '', fileInfo);   
                break
            }

            // Check and update the loop parameters
            if ((vm.worksheet[a]['component_type_id']==7) &&
                (vm.worksheet[a]['content']['needsBlockUpdate']==1) &&
                (vm.digestStatus==1))
            {   vm.digestStatus=0;
                vm.worksheet[a]['content']['whileLoop']['firstRun']=1;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveWhileLoopParameters', '', fileInfo);  
                break
            }

            // Check and update the if/else parameters
            if ((vm.worksheet[a]['component_type_id']==8) &&
                (vm.worksheet[a]['content']['needsBlockUpdate']==1) &&
                (vm.digestStatus==1))
            {   vm.digestStatus=0;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveIfElseParameters', '', fileInfo);
                break
            }

            // Check and update the loop structure
            if ((vm.worksheet[a]['component_type_id']==6) && 
                (vm.worksheet[a]['content']['forLoop']['needsUpdateFlag']==1) &&
                (vm.digestStatus==1))
            {
                vm.digestStatus=0;
                vm.worksheet[a]['content']['forLoop']['firstRun']=1;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveStructure', '', fileInfo);   
                break
            }

            // Check and update the loop structure
            if ((vm.worksheet[a]['component_type_id']==7) && 
                (vm.worksheet[a]['content']['whileLoop']['needsUpdateFlag']==1) &&
                (vm.digestStatus==1))
            {
                vm.digestStatus=0;
                vm.worksheet[a]['content']['whileLoop']['firstRun']=1;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveStructure', '', fileInfo);   
                break
            }

            // Check and update the lif/else structure
            if ((vm.worksheet[a]['component_type_id']==8) && 
                (vm.worksheet[a]['content']['ifelse']['needsUpdateFlag']==1) &&
                (vm.digestStatus==1))
            {
                vm.digestStatus=0;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveStructure', '', fileInfo);   
                break
            }

            if ((vm.worksheet[a]['component_type_id']==9)&&(vm.digestStatus==1))
            {   var flag=0;
                for (var thisDataset in vm.worksheet[a]['content']['Plot']['Chart_dataobj'])
                {   
                    console.log('For dataset '+thisDataset+', the update flag is '+vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['needsUpdateFlag']);
                    if (vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['needsUpdateFlag']==1)
                    {   
                        console.log('I am updating dataset '+thisDataset+'-'+vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['Format_id']+' on plot '+vm.worksheet[a]['itemid']);
                        vm.digestStatus=0;
                        vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['needsUpdateFlag']=0; 
                        vm.solveEquation(vm.worksheet[a]['itemid'], 'solvePlotData', vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['Format_id'], fileInfo);
                        flag=1;
                        break
                    }
                } 
                if ((flag==0)&&(vm.worksheet[a]['content']['Plot']['needsUpdateFlag']==1))
                {
                    vm.worksheet[a]['content']['Plot']['needsUpdateFlag']=0;
                    chartFactory.makeChart(vm.worksheet[a], '', vm.worksheet); 
                    
                }
            }
            if (vm.worksheet[a]['component_type_id']==13)
            {   for (var dataIndex in vm.worksheet[a]['content']['Surface']['Chart_dataobj'])
                {   if (vm.worksheet[a]['content']['Surface']['Chart_dataobj'][dataIndex]['needsUpdateFlag']==1)
                    {   vm.digestStatus=0;
                        vm.worksheet[a]['content']['Surface']['Chart_dataobj'][dataIndex]['needsUpdateFlag']=0; 
                        var thisID = vm.worksheet[a]['itemid'];
                        var dataID = vm.worksheet[a]['content']['Surface']['Chart_dataobj'][dataIndex]['Format_id'];
                        vm.solveEquation( thisID, 'SolveSurfaceData', dataID, fileInfo );
                        break
                    }
                }  
            }

        }

        for (var a=0; a<vm.worksheet.length; a++)
        {   
            if (vm.worksheet[a]['component_type_id']==15)
            {   
                for (var b=0; b<vm.worksheet.length; b++)
                {   
                    if ( vm.worksheet[a]['content']['variableID'] == vm.worksheet[b]['itemid'] )
                    {
                        vm.worksheet[a]['content']['value'] = vm.worksheet[b]['content']['Equation']['Solution_real'][vm.worksheet[a]['content']['index']];
                        vm.worksheet[a]['content']['units'] = vm.worksheet[b]['content']['Equation']['Units_units'];
                        vm.worksheet[a]['content']['variable'] = vm.worksheet[b]['content']['Equation']['Format_name'];
                    }
                }
            }
        }
        console.log('The digest loop is clean');
        if ( savefile == 1 )
        {
            console.log('The file is being saved and updated');
            vm.saveFile( 1, fileInfo, thisType );
            $http({
                method: "POST",
                url: window.location.origin+'/files/fileCurrent/'+fileInfo['id'],
            });
            if ( vm.depFiles !== undefined )
            {
                for (var b=0; b<vm.depFiles.length; b++)
                {
                    if ( vm.depFiles[a]['id'] == fileInfo['id'] )
                    {
                        vm.depFiles[a]['update'] = false;
                    }
                }
            }
        }

    }
};







/*
*
*   LOCK THE FILES IN THE PART TREE OR THE WORKSPACE WHEN ONE IS BEING UPDATED
*
*/
function lockFiles ( setting )   
{
    console.log('In the lockFiles function with a setting of '+setting);   
    vm.inSolve=parseInt(setting);
}




/*
*
*   SOLVE EQUATION FUNCTION
*
*/
function solveEquation (eqID, eqType, dataID, fileInfo, thisType)   
{   
    console.log('In solve equation with an id of '+eqID+', a type of '+eqType+' and a dataID of '+dataID);
    vm.solveFileInfo = fileInfo;
    var thisItem = docItemFactory.getByID(eqID, vm.worksheet);
    if ( fileInfo.item_data.importedCAD === undefined ) { fileInfo.item_data.importedCAD=[]; }
    console.log('Found');
    console.log(thisItem);
    thisItem.eqObj=docItemFactory.createEqObj(eqID, vm.worksheet);
    var solveObj = docItemFactory.createSolveObj( thisItem, eqType, dataID );
    solveObj['scaleUnits'] = vm.cadwolfScaleUnits;
    solveObj['parseUnits'] = vm.cadwolfParseUnits;
    solveObj['Constants']  = vm.cadwolfConstants;
    solveObj['cadParts']  = fileInfo.item_data.importedCAD;
    solveObj['importedFunctions'] = fileInfo.item_data.impFunctions;
    console.log('I am sending ...');
    console.log(solveObj);
    //equationWorker.postMessage( solveObj ); 


    // This section checks to see if there is a python server running locally
    $http({
        method: "POST",
        url: 'http://127.0.0.1:8081',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: { testMessage : "Test Message" }
    }).then(function successCallback( returnData ) {
        vm.cadwolf_usePython=true;
        vm.cadwolf_pythonVersion=returnData.data
        $http({
            method: "POST",
            url: 'http://127.0.0.1:8081',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data: { params  : solveObj }
        }).then(function successCallback( returnData ) {
                vm.pythonReturn=returnData
                vm.handleSolverReturn(returnData, thisType)
        }, 
            function errorCallback( returnData ) {
                equationWorker.postMessage( solveObj );    
        });
    }, function errorCallback( returnData ) {
        vm.cadwolf_usePython=false;
        equationWorker.postMessage( solveObj ); 
    });

    
    equationWorker.onerror = function(e) 
    {
        vm.digestStatus=1;
        console.log('Hey, I got an error, but thats cool. Ill just sit over here and eat a sugar packet.'); 
        vm.showMessage( '', { messageType : 'failure', 
                              messageTitle : 'Unknown Error', 
                              messageText : 'There was an error in the solver routine that caused it to fail. Please look at the format of your equations.'});

    };

    equationWorker.onmessage = function(e) { 
        console.log('The message was returned with a type of '+e.data.messageType);
        console.log(e.data);
        MY_SCOPE.eqreturndata=e;
        vm.handleSolverReturn(e, thisType)
    }
}


/*
*
*   HANDLE THE RETURN FROM WEB WORKER OR PYTHON
*
*/
function handleSolverReturn (e, thisType)
{   
    console.log('The message was returned with a type of '+e.data.messageType);
    console.log(e.data);
    MY_SCOPE.eqreturndata=e;

    vm.worksheet=docItemFactory.eqReturn(e.data, vm.worksheet);    
    
    if (e.data.messageType=="EquationResult")
    {
        vm.addressConnectedEqs(e.data, vm.worksheet);
        vm.worksheet = docItemFactory.populateDeps(e.data.id, vm.worksheet);
        vm.worksheet = docItemFactory.findDependents(e.data.id, 0, vm.worksheet);
        vm.worksheet.forEach(
            function(thisObj, index){
                if (thisObj['itemid']==e.data.id)
                {   
                    thisObj.content.Equation['Format_showsolution'] = docItemFactory.createShowSolution( thisObj, vm.cadwolfScaleUnits );
                    vm.updateComponent( thisObj );                            
                }
            }
        );
    }
    
    if (e.data.messageType=="TableCellResult")
    {
        vm.worksheet = docItemFactory.findDependents(e.data.id, 0, vm.worksheet);
    }
    
    if (e.data.messageType=="PlotDataResults")
    {   
        vm.worksheet.forEach(
            function(thisObj, index){
                if (thisObj['itemid']==e.data.plotID)
                {   
                    if (e.data.eventErrorFlag==1)
                    {
                        thisObj['content']['Plot']['errorFlag']=1;
                        thisObj['content']['Plot']['errors']=e.data.eventError;
                    }else
                    {
                        thisObj['content']['Plot']['errorFlag']=0;
                        thisObj['content']['Plot']['errors']=[];
                        var itemArray=['Chart_dataobj', 'Chart_bandsobj', 'Chart_linesobj', 'Chart_textobj', 'Chart_xaxesobj', 'Chart_yaxesobj'];
                        for (var a=0; a<itemArray.length; a++)
                        {   
                            for (var thisData in thisObj['content']['Plot'][itemArray[a]])
                            {   
                                if (thisObj['content']['Plot'][itemArray[a]][thisData]['Format_id']==vm.currentChartItemID)
                                {
                                    vm.currentChartItem = thisObj['content']['Plot'][itemArray[a]][thisData];
                                    vm.currentPoint=vm.currentChartItem['PointData'][vm.pointIndex];
                                }
                            } 
                        }
                    }
                    vm.updateComponent( thisObj );                            
                }
            }
        );
    }

    if (e.data.messageType=="SurfaceData")
    {   
        vm.worksheet.forEach(function(item, index)
        {   
            if (item.itemid==e.data['PlotID'])
            {   
                for (var a = 0; a < item['content']['Surface']['Chart_dataobj'].length; a++)
                {
                    if (item['content']['Surface']['Chart_dataobj'][a]['Format_id'] == e.data['DataID'] )
                    {
                        var dataIndex = a;
                    }
                }

                for (var b = 0; b < e.data['dataObject'].length; b++)
                {
                    if (e.data['dataObject'][b]['Format_id'] == e.data['DataID'] )
                    {
                        var returnIndex = b;
                    }
                }

                if ((e.data['type']=="surface")||(e.data['type']=="pointCloud"))
                {    
                    item['content']['Surface']['Chart_dataobj'][dataIndex]['xLength']=e.data['dataObject'][returnIndex]['xLength'];
                    item['content']['Surface']['Chart_dataobj'][dataIndex]['yLength']=e.data['dataObject'][returnIndex]['yLength'];
                
                }else if (e.data['type']=="line") 
                {   
                    // item['content']['Surface']['Chart_dataobj'][dataIndex]['lineGeometry']=JSON.parse(JSON.stringify(e.data['dataObject'][returnIndex]['lineGeometry']));
                    item = surfaceFactory.setLinePoints( item, e.data['DataID'], e.data['Axis'] );

                }else if (e.data['type']=="lathe")
                {   
                    item['content']['Surface']['Chart_dataobj'][dataIndex]['xLength']=e.data['dataObject'][returnIndex]['xLength'];
                    item['content']['Surface']['Chart_dataobj'][dataIndex]['yLength']=e.data['dataObject'][returnIndex]['yLength'];
                    item['content']['Surface'].formatLatheData(e.data['PlotID'], e.data['DataID']);
                }                    
                
                vm.reDrawItem( item, 'all', 1 );
                vm.updateComponent( item );                            
            }
        });
    }

    console.log('I made it to the end of the equation return');
    vm.digestStatus=1; 

    // Run through the worksheet and check to see if there are any equations or other items flagged to be solved
    // If there are, run the digest. If there aren't, run. the digest and save the file
    vm.saveThisFile = 1;

    for (var a=0; a<vm.worksheet.length; a++)
    {   
        if (((vm.worksheet[a]['component_type_id']==3) &&
            (vm.worksheet[a]['content']['needsUpdateFlag']==1)) ||
            ((vm.worksheet[a]['component_type_id']==3) &&
            (vm.worksheet[a]['update'])))
        {   
            vm.saveThisFile = 0;
        }

        if (vm.worksheet[a]['component_type_id']==5)
        {   
            for (var b=0; b< vm.worksheet[a]['content']['data'].length; b++)
            {   for (var c=0; c< vm.worksheet[a]['content']['data'][0].length; c++)
                {   
                    if (vm.worksheet[a]['content']['data'][b][c]['needsUpdateFlag']==1)
                    {   
                        vm.saveThisFile = 0;
                    }
                }
            }
        }

        // Check and update the loop parameters
        if ((vm.worksheet[a]['component_type_id']==6) &&
            (vm.worksheet[a]['content']['needsBlockUpdate']==1) )
        {   
            vm.saveThisFile = 0;
        }

        // Check and update the loop parameters
        if ((vm.worksheet[a]['component_type_id']==7) &&
            (vm.worksheet[a]['content']['needsBlockUpdate']==1) )
        {   
            vm.saveThisFile = 0;
        }

        // Check and update the if/else parameters
        if ((vm.worksheet[a]['component_type_id']==8) &&
            (vm.worksheet[a]['content']['needsBlockUpdate']==1) )
        {   
            vm.saveThisFile = 0;
        }

        // Check and update the loop structure
        if ((vm.worksheet[a]['component_type_id']==6) && 
            (vm.worksheet[a]['content']['forLoop']['needsUpdateFlag']==1) )
        {
            vm.saveThisFile = 0;
        }

        // Check and update the loop structure
        if ((vm.worksheet[a]['component_type_id']==7) && 
            (vm.worksheet[a]['content']['whileLoop']['needsUpdateFlag']==1) )
        {
            vm.saveThisFile = 0;
        }

        // Check and update the lif/else structure
        if ((vm.worksheet[a]['component_type_id']==8) && 
            (vm.worksheet[a]['content']['ifelse']['needsUpdateFlag']==1) )
        {
            vm.saveThisFile = 0;
        }

        if ((vm.worksheet[a]['component_type_id']==9))
        {   
            for (var thisDataset in vm.worksheet[a]['content']['Plot']['Chart_dataobj'])
            {   
                if (vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['needsUpdateFlag']==1)
                {   
                    vm.saveThisFile = 0;
                }
            } 
            if (vm.worksheet[a]['content']['Plot']['needsUpdateFlag']==1)
            {
                vm.saveThisFile = 0;
            }
        }
        if (vm.worksheet[a]['component_type_id']==13)
        {   
            for (var dataIndex in vm.worksheet[a]['content']['Surface']['Chart_dataobj'])
            {   
                if (vm.worksheet[a]['content']['Surface']['Chart_dataobj'][dataIndex]['needsUpdateFlag']==1)
                {   
                    vm.saveThisFile = 0;
                }
            }  
        }

    }

    vm.runEquationDigest( vm.worksheet, vm.solveFileInfo, vm.saveThisFile, thisType );

};






/*
*
*   SEPARATE FUNCTION TO ADDRESS RETURNED CONNECTED EQUATIONS
*
*/
function addressConnectedEqs(returnObject, worksheetObj) 
{   
    MY_SCOPE.returnItem = returnObject;
    var flag=0;
    console.log('There are '+Object.keys(returnObject.connected).length+' connected items in the returned array');
    // Handle the connected equations - If the returned item has connected equations
    if (Object.keys(returnObject.connected).length>0)
    {  
        console.log('There were keys returned');
        vm.worksheetObj.forEach(function(item, index)
        {   
            console.log('I am now comparing '+returnObject.id+' to '+item['itemid']);
            if (returnObject.id==item['itemid'])
            {
                console.log('match');
                // Loop through all of the existing connected IDs for this equation. Find them in the vm.worksheet,
                // and check their names against the list of names for the newly returned connected items. If one
                // matches, update the data from the new solution.
                for (var existingConn in item['content']['Equation']['connected_ids'])
                {
                    flag=0;
                    vm.worksheetObj.forEach(function(tempItem, tempIndex)
                    {   
                        console.log('In the existing part, comparing '+tempItem['itemid']+'-'+existingConn);
                        console.log(tempItem['itemid']==existingConn);
                        if (tempItem['itemid']==existingConn) 
                        { 
                            for (var returnConn in returnObject.connected)
                            {
                                console.log('In connected ids, comparing '+returnObject.connected[returnConn]['Format_name']+' to '+tempItem['name']);
                                if (returnObject.connected[returnConn]['Format_name'] == tempItem['name'] )
                                {
                                    flag=1;
                                    for (var thisProp in returnObject.connected[returnConn])
                                    {
                                        console.log('Resetting the parameter '+thisProp);
                                        tempItem['content']['Equation'][thisProp] = returnObject.connected[returnConn][thisProp];
                                    }
                                    console.log('Deleting '+returnConn+' from the returned connected ids array');
                                    delete returnObject.connected[returnConn];

                                }
                            }
                        } 
                    }); 

                    // Delete the connected equation if it is not represented in the new result. It is a holdover
                    // from a previous solution.
                    if (flag==0)
                    {
                        vm.worksheetObj.forEach(function(tempItem, tempIndex)
                        {   
                            if (tempItem['itemid']==existingConn) 
                            { 
                                console.log('Deleting connected id '+existingConn+' - '+tempItem['name']);
                                vm.deleteItem(tempItem, 1);
                            } 
                        }); 
                    }
                }

                // Whatever items remain in the connected object are new. Add those as new items
                for (var connItem in returnObject.connected)
                {   
                    var connectedID = vm.addItem('Equation', returnObject.connected[connItem], 1, item['order']) 
                    console.log('I should have created '+returnObject.connected[connItem]['Format_name']);
                    item['content']['Equation']['connected_ids'][connectedID]=1;

                    // vm.worksheet.forEach(function(tempItem, tempIndex)
                    // {   
                    //     if (tempItem['itemid']==connectedID) 
                    //     { 
                    //         tempItem['name'] = returnObject.connected[connItem]['Format_name']; 
                    //         tempItem['inEdit'] = 1; 
                    //         tempItem['file_id'] = fileInfo.id; 
                    //         tempItem['Original_id']=returnObject.id;
                    //         tempItem['content']['isConnectedEquation']=1;
                    //         setTimeout(function(){ vm.updateComponent( tempItem ), 3000});
                    //     }
                    // }); 

                    // console.log('Created a new connected item named '+returnObject.connected[connItem]['Format_name']+' with an id of '+connectedID);
                }   
            }
        });
    }
}




/*
 * Call to update an item and then update the service
 *
 */
function updateComponent( thisItem )
{   
    if (typeof(thisItem)=='object')
    {
        //vm.cadwolf_worksheet = docItemFactory.getLastPos( vm.cadwolf_worksheet );
        console.log('Updating the component ...');
        console.log(thisItem);
        if (typeof(thisItem['content'])=='string')
        {
            thisItem['content']=JSON.parse(thisItem['content']);
            console.log('The content was stringified');
        }
        if (thisItem['component_type_id']==13)
        {
            var tempItem = vm.buildSurface( thisItem );
        }else
        {
            var tempItem = thisItem['content'];
        }
        if (thisItem['component_type_id']==3)
        {
            var name=thisItem['content']['Equation']['Format_name'];                    
        }else
        {
            var name=thisItem['name'];                     
        }
        $http({
            method: "PUT",
            url: window.location.origin+'/components',
            data: { 
                        id      : thisItem['id'],
                        itemid  : thisItem['itemid'],
                        //file_id : vm.cadwolf_fileInfo['id'],
                        file_id : thisItem['file_id'],
                        name    : name,
                        content : JSON.stringify(tempItem),
                        dependent_file : thisItem['dependent_file'],
                        dependent_id : thisItem['dependent_id'],
                        order : thisItem['order']
                  }
        }).then(function successCallback( returnData ) {
            console.log('Update component call completed');
            if (thisItem['component_type_id'] == 3)
            {
                for (var thisConn in thisItem['content']['Equation']['connected_ids'])
                {
                    vm.cadwolf_worksheet.forEach(
                        function(tempItem, index)
                        {
                            if (tempItem['itemid']==thisConn)
                            {
                                vm.updateComponent( tempItem );
                            }
                        }
                    );
                }
            
            }

            if ( (thisItem['component_type_id'] == 6) || (thisItem['component_type_id'] == 7) || (thisItem['component_type_id'] == 8) )
            {
                vm.cadwolf_worksheet.forEach(
                    function(sheetItem, index){
                        if ( sheetItem['content']['parentid'] == thisItem['itemid'] )
                        {
                            vm.updateComponent( sheetItem );
                        }
                    }
                );

            }

        }, function errorCallback( returnData ) {});
        // vm.updateService( );
    }
    console.log('Update component completed');

}        





/*
 *
 * Save the file and update the components
 *
 *  @param - flag - 0 or 1 if the components should be saved
 *  @param - fileInfo - the fileinfo object for the file being saved
 *  @param - thisType - string for where this saved originated
 *
 */
function saveFile( flag, fileInfo, thisType )
{   
    console.log('In the save file program with a type of '+thisType);

    $http({
        method: "PUT",
        url: window.location.origin+'/files/'+fileInfo['id'],
        data: { name : fileInfo['name'],
                parent_id : parseInt(fileInfo['parent_id'], 10),
                item_data : fileInfo['item_data']
              }
    }).then(function successCallback( returnData ) 
    {
        if ( thisType == 'workspace' )      { vm.getFiles($location.absUrl()); }
        if ( thisType == 'documentUpdate' ) { vm.getDepFiles(); }
        if ( thisType == 'partTreeUpdate' ) { vm.lockFiles( 0 ); 
                                              vm.getTreeStatus( fileInfo ); }

        if ( flag == 1 ) { vm.saveComponents( fileInfo, thisType ); }
        vm.sendAutocadVars( fileInfo );

    }, function errorCallback( returnData ) {});
}        

function saveComponents( fileInfo, thisType )
{   
    $http({
        method: "PUT",
        url: window.location.origin+'/saveDocument/'+fileInfo['id']
    }).then(function successCallback( returnData ) {
        if ( thisType == 'partTreeUpdate' ) { vm.getTreeStatus( fileInfo ); }
    }, function errorCallback( returnData ) {});
}







/*
 *
 *  Function to send autocad variables to Fusion 360. This is done the same was as 
 *  in the document function. The only exception is that we have to download the
 *  connected items first.
 *
 * @param - fileInfo - the fileInfo object for the file being saved and sending params to Fusion
 *
 */
function sendAutocadVars( fileInfo )
{

    console.log('In the send autocad vars function with '+fileInfo.id);

    // Flag that turns on the notification that the variables are being sent to Autocad
    vm.sendingAutocad = true;


    // Prep the strings that will hold the data sent to Fusion. Data can be sent for multiplt
    // files. File data is separated by  pound signs. This is done because arrays couldn't be
    // sent, so I sent strings that are parsed with Fusion's API.
    var h = '';         // String holding the hub data
    var p = '';         // String holding the project data
    var r = '';         // String holding the root folder
    var FIDs = '';      // String holding the IDs of the files
    var folds = "";     // String holding the Folder path for each file
    var flag = 0;       // Flag for first entry
    var eqNames = '';   // Names of the equations
    var eqValues = '';  // Values of the equations
    var fusionFlag = 0; // Whether or not we got a fusion connect



    // Download the connected files as this isn't done for the fileInfo
    $http({
        method: "GET",
        url: window.location.origin+'/getConnected/'+fileInfo.id,
        params: { }
    }).then(function successCallback( returnData )
    {
        console.log(returnData);
        vm.connectedFiles = returnData.data.data;
        for (var a=0; a<vm.connectedFiles.length; a++)
        {
            vm.connectedFiles[a]['info'] = JSON.parse(vm.connectedFiles[a]['info']);
            if ( vm.connectedFiles[a]['cad_type'] == "fusion" )
            {
                if ( typeof(vm.connectedFiles[a]['info']['cad_data']) == "string" )
                {
                    vm.connectedFiles[a]['info']['cad_data'] = JSON.parse(vm.connectedFiles[a]['info']['cad_data']);
                }
            }
        }

        // First, remove any old links
        if ( document.getElementById("fusionLink") !== null )
        {
            document.getElementById("fusionLink").remove();
        }

        vm.connectedFiles.forEach(
            function(thisConn, index)
            {

                console.log('For this connection, the type is '+thisConn.cad_type);

                if ( thisConn.cad_type == 'fusion' )
                {

                    fusionFlag = 1;

                    console.log('The Fusion flag is set to '+fusionFlag);

                    // Set the file data
                    if ( flag == 0 )
                    {
                        h = thisConn.info.cad_data.hubData.attributes.name;
                        p = thisConn.info.cad_data.projectData.attributes.name;
                        r = thisConn.info.cad_data.rootFolder;
                        FIDs = thisConn.info.cad_data.file;
                        folds = "";
                    }else
                    {
                        h = h+'**'+thisConn.info.cad_data.hubData.attributes.name;
                        p = p+'**'+thisConn.info.cad_data.projectData.attributes.name;
                        r = r+'**'+thisConn.info.cad_data.rootFolder;
                        FIDs = FIDs+'**'+thisConn.info.cad_data.file;
                        folds = folds+'**';
                    }

                    for (var a=0; a<thisConn.info.cad_data.folders.length; a++)
                    {
                        if ( a == 0 )
                        {
                            if ( thisConn.info.cad_data.folders[a] !== null )
                            {
                                folds = folds+""+thisConn.info.cad_data.folders[a];
                            }

                        }else
                        {
                            if ( thisConn.info.cad_data.folders[a] !== null )
                            {
                                folds = folds+","+thisConn.info.cad_data.folders[a];
                            }
                        }
                    }


                    if ( flag == 1 )
                    {
                        eqNames = eqNames+'**';
                        eqValues = eqValues+'**';
                    }else
                    {
                        flag = 1;
                    }

                    thisConn.info.equations.forEach(
                        function(thisEq, index2){

                            if ( index2 == 0 )
                            {
                                eqNames = eqNames+''+thisEq.eq_name;
                            }else
                            {
                                eqNames = eqNames+','+thisEq.eq_name;
                            }

                            vm.worksheet.forEach(
                                function(sheetEq, index3){

                                    if ( sheetEq.component_type_id == 3)
                                    {
                                        if ( sheetEq.name == thisEq.eq_name )
                                        {
                                            if ( index2 == 0 )
                                            {
                                                eqValues = eqValues+''+sheetEq.content.Equation.Solution_real['0-0']+' '+sheetEq.content.Equation.Units_units;
                                            }else
                                            {
                                                eqValues = eqValues+','+sheetEq.content.Equation.Solution_real['0-0']+' '+sheetEq.content.Equation.Units_units;
                                            }

                                        }
                                    }
                                }
                            );

                        }
                    );                      

                }
            }
        );


        // Turn off Autocad Flag
        vm.sendingAutocad = false;


        console.log('Before the call, the fusion flag is '+fusionFlag);

        if ( fusionFlag == 1 )
        {
            var link=document.createElement("a");
            link.id = 'fusionLink'; 
            link.href='fusion360://command=open&properties={"hub":"'+h+'","project":"'+p+'","root":"'+r+'","folders":"'+folds+'","file":"'+FIDs+'","eqNames":"'+eqNames+'","eqValues":"'+eqValues+'"}';

            console.log('The anchor is ...');
            console.log(link.href);
            
            document.getElementById("fusionLinkArea").appendChild(link);

            document.getElementById('fusionLink').click();

        }

    });

}










		vm.init();


	}

})();
(function ()
{
	'use strict';

	angular
		.module('fuse')
		.controller('DialogController', DialogController);

	/** @ngInject */
	function DialogController($mdDialog, locals, $http)
	{
		console.log('In the dialog controller with locals ...');
		console.log(locals);

		if ( locals.thisItem.item_data.description === undefined )
		{
			if ( ( typeof(locals.thisItem.item_data) == "string" ) || ( typeof(locals.thisItem.item_data) != "object" ) )
			{
				locals.thisItem.item_data={};
			}
			locals.thisItem.item_data.description = 'Description Text'
		}

		var vm				= this;
		vm.files			= [];
		vm.thisItem		 	= locals.thisItem;
		vm.modalType		= locals.modalType;
		vm.thisLoc			= locals.thisLoc;
		vm.fileInfo			= locals.fileInfo;
		vm.Spark			= locals.Spark;
		vm.thisItem.newName = JSON.parse(JSON.stringify(locals.thisItem.name));
		vm.thisItem.newDesc = JSON.parse(JSON.stringify(locals.thisItem.item_data.description));
		vm.logData			= locals.logData;

		vm.cancel			= cancel;
		vm.acceptChanges	= acceptChanges;
		vm.acceptProps 		= acceptProps;
		vm.acceptMessage 	= acceptMessage;
		vm.acceptName		= acceptName;
		vm.acceptCopy		= acceptCopy;
		vm.acceptMove		= acceptMove;
		vm.acceptDelete		= acceptDelete;
		vm.acceptReference  = acceptReference;
		vm.getFiles			= getFiles;
		vm.newVersion		= newVersion;
		vm.newRevision 		= newRevision;
		vm.addCADFile		= addCADFile;
		vm.removeCADFile 	= removeCADFile;
		vm.checkWorkspace 	= checkWorkspace;
		vm.init			 	= init;

		window.MY_DIALOG 	= this;


		vm.init();



		/**
		 *
		 *  Initialize the move by getting the available folders
		 *
		 */
		function init( )
		{

			if ( ( vm.thisLoc == '' ) || ( vm.thisLoc === undefined ) )
			{
				vm.thisLoc = vm.Spark.state.user.username;

			}else
			{
				vm.getFiles( vm.thisLoc );
			
			}
			
			vm.message = {};


			// Add copy if this is a copy dialog
			if ( vm.modalType == 'Copy Item' )
			{
				vm.thisItem.newName = vm.thisItem.newName+' Copy'
			}
	
		}



		/**
		 *
		 *  Get the files in folder
		 *
		 */
		function getFiles( thisURL, addFolder )
		{
			if (thisURL !== undefined)
			{
				// Remove any trailing slashes
				thisURL = thisURL.replace(/\/$/,'');

				// If there was an additional folder path, add it on
				if ( addFolder !== undefined )
				{
					addFolder = addFolder.replace(/\/$/,'');
					addFolder = addFolder.replace(/^\//,'');
					thisURL = thisURL+'/'+addFolder;
				}

				// Reset the URL
				vm.thisLoc = thisURL;

				// Pull down the files
				$http({
					type: "GET",
					url: window.location.origin+'/files',
					params: { thisURL : thisURL },
				}).then(function successCallback( returnData ) 
				{
					vm.moveFiles = returnData['data']['files'];
					console.log('The move files are ... ');
					console.log(returnData['data']['files']);
				
				}, function errorCallback( returnData ) {});
			}
		}





		/**
		 *
		 *  Check that a workspace exists and that you have edit permissions
		 *
		 */
		function checkWorkspace( thisURL )
		{

			if (thisURL !== undefined)
			{
				// Remove any trailing slashes
				thisURL = thisURL.replace(/\/$/,'');

				// Pull down the files
				$http({
					type: "",
					url: window.location.origin+'/checkWorkspace',
					params: { workspaceURL : thisURL },
				}).then(function successCallback( returnData ) 
				{
					console.log('The workspace validation is ... ');
					console.log(returnData['data']);

					if ( returnData['data'] == 1 )
					{
						vm.validWorkspace = true;
					}else
					{
						vm.validWorkspace = false;
					}
				
				}, function errorCallback( returnData ) {});
			}
		}






		/**
		 *
		 *  Accept the movement of an item to another folder
		 *
		 */
		function acceptMove(moveData) 
		{
			$.ajax({
				type: "POST",
				url: window.location.origin+'/moveItem',
				data: { moveData : moveData },
				success: function( returnData ) {
					$mdDialog.hide(returnData);
				},
				error: function(  ) {
					$mdDialog.hide(returnData);
				}
			});
			$mdDialog.hide();
		};





		/**
		 *
		 *  Accept the copy of an item
		 *
		 */
		function acceptCopy(copyData, copyLoc)
		{
			$.ajax({
				type: "POST",
				url: window.location.origin+'/copyItem',
				data: { thisItem : copyData, copyLoc : copyLoc },
				success: function( returnData ) {
					$mdDialog.hide(returnData);
				},
				error: function(  ) {
					$mdDialog.hide(returnData);
				}
			});
		};







		/**
		 *
		 * Create a new version 
		 *
		 */
		function newVersion( thisItem )
		{
			$http({
				method: "PUT",
				url: window.location.origin+'/files/newVersion/'+thisItem.id,
			}).then(function successCallback( returnData ) {
			}, function errorCallback( returnData ) {});

		}



		/**
		 *
		 * Create a new revision 
		 *
		 */
		function newRevision( thisItem )
		{
			$http({
				method: "PUT",
				url: window.location.origin+'/files/newRevision/'+thisItem.id,
			}).then(function successCallback( returnData ) {
			}, function errorCallback( returnData ) {});

		}







		/**
		 *
		 * Add a connected CAD File 
		 *
		 */
		function addCADFile( )
		{

			var newCAD = { 	CADAddress : '', 
							CADSource : 'Onshape',
							CADName : 'Name of CAD File' };

			if ( vm.thisItem.item_data.CADFiles === undefined )
			{
				vm.thisItem.item_data.CADFiles = [];
			}

			vm.thisItem.item_data.CADFiles.push( newCAD );

		}



		/**
		 *
		 * Remove a connected CAD File 
		 *
		 */
		function removeCADFile( index )
		{

			vm.thisItem.item_data.CADFiles.splice( index, 1 );

		}






		function cancel(){
			$mdDialog.cancel();
		};

		function acceptProps(newItem) {
			$mdDialog.hide({ name: newItem.newName, 
							   desc: newItem.newDesc});
		};

		function acceptMessage(title, text) {
			$mdDialog.hide({ title: title, 
							   text: text});
		};

		function acceptChanges(desc) {
			$mdDialog.hide(desc);
		};

		function acceptName(name) {
			$mdDialog.hide(name);
		};

		function acceptDelete(name) {
			$mdDialog.hide(name);
		};

		function acceptReference(name) {
			$mdDialog.hide(name);
		};


	}
})();

(function ()
{
	'use strict';

	angular
		.module('fuse')
		.controller('WorkflowDialogController', WorkflowDialogController);

	/** @ngInject */
	function WorkflowDialogController($mdDialog, locals, $http, $sce)
	{
		var vm				= this;

		// Local Variables
		vm.thisItem			= locals.thisItem;
		vm.Spark			= locals.Spark;
		vm.cadwolf_fileInfo	= locals.cadwolf_fileInfo;
		vm.calcLogDays 		= locals.calcLogDays;
		vm.calcDaysBetween 	= locals.calcDaysBetween;
		vm.calcEventDays 	= locals.calcEventDays;
		vm.calcWidths 		= locals.calcWidths;
		vm.addUserRole 		= locals.addUserRole;
		vm.removeUserRole 	= locals.removeUserRole;
		vm.getEndDates 		= locals.getEndDates;
		vm.populateDates 	= locals.populateDates;
		vm.thisEvent 		= locals.thisEvent;
		vm.signoffs 		= locals.signoff;
		vm.editPerm 		= locals.editPerm;
		vm.conditionalEdit 	= locals.conditionalEdit;
		vm.updateItem		= locals.updateItem;
		vm.deleteItem 		= locals.deleteItem;
		vm.eventTypes 		= locals.eventTypes;
		vm.runEventDigest	= locals.runEventDigest;
		vm.getLogData 		= locals.getLogData;
		vm.getRequirements	= locals.getRequirements;
		vm.checkUpdateStatus= locals.checkUpdateStatus;
		vm.questions		= locals.questions;
		vm.tasks 			= locals.tasks;



		//Events
		vm.init 			= init;
		vm.addEvent			= addEvent;
		vm.addRole			= addRole;
		vm.addItem 			= addItem;
		vm.addSignoff 		= addSignoff;
		vm.getFiles 		= getFiles;
		vm.setEvent 		= setEvent;
		vm.checkMemberName	= checkMemberName;
		vm.setSigneeData 	= setSigneeData;
		vm.addDocEvent 		= addDocEvent;
		vm.removeDocEvent 	= removeDocEvent;
		vm.updateEvent 		= updateEvent;
		vm.updateSignoff	= updateSignoff;
		vm.deleteEvent 		= deleteEvent;
		vm.deleteSignoff 	= deleteSignoff;
		vm.addPermission 	= addPermission;
		vm.deletePermission = deletePermission;
		vm.addNote 			= addNote;
		vm.checkNoteDates 	= checkNoteDates;
		vm.addEventParticipant = addEventParticipant;
		vm.getDocContent 	= getDocContent;
		vm.addSignoffNote 	= addSignoffNote;





		// Buttons at the bottom
		vm.cancel			= cancel;
		vm.hide 			= hide;
		vm.acceptChanges	= acceptChanges;


		vm.init();




		/*
		*
		*   Initialize the dialog
		*
		*/
		function init( )
		{   
			console.log('Initializing Dialog');
		
			// Set the URL to get files
			vm.getFilesURL = "/"+Spark.state.user.username.replace(' ', '_');

			// Set the current Date
			vm.thisDate = new Date();


			// Set the blank event object
			vm.eventObject = {
				eventTitle : 'New Event',	// Name given to event
				eventDescription : '', 		// Description of event
				eventType : 'Note',			// Type of event - note, gateway, testing etc
				eventTypeAlt : '',			// Space for the user to enter event type description if type is 'other'
				eventAll : false, 			// 
				eventStart : '', 			// Start date of event
				eventEnd : '',				// End date of event
				eventProgress : 0,			// Progress of event
				eventColor : '',			// Color for event
				eventItems : [],			// Rows that the event affects -  delete me
				eventFiles : [],			// Rows that the event affects
				eventInclusive : true,		// Whether or not the event applies to all contained items - all items in a part tree if that tree is selected
				eventApplyAll : false,		// Whether or not the event applies to all items
				eventRoles : [],			// The defined roles that are used in this event (Not sold on this - may use roles object instead)
				eventDayCount : 0,			// The number of days from start of workflow time to event
				eventDayLength : 0, 		// The number of days that the event lasts
				eventWidth : 0,				// Width of the event in pixels
				eventOffset : 0,			// The offset from the left in pixels
				eventVertOffset : 0,		// The vertical offset of the event in pixels
				eventCreatorID : '',		// ID of person that created role
				eventCreatorUserName : '',	// User name of person that created role
				eventCreatorName : '',		// Name of person that created role
				eventCreatorPhoto : '', 	// Photo URL of creator
				eventCreateDate : '', 		// The date that the event was created
				eventShowTitle : true,		// Whether or not to show the title of the event in the item view
				eventStartMonth : 0, 		//
				eventEndMonth : 0, 			//
				eventStartYear : 0,			//
				eventEndYear : 0,			//
				eventStartDay : 0, 			//
				eventEndDay : 0,			//
				eventDisallowed : false,	// An event is disallowed if it is a version changer and a latter one has already occured
				eventShowDelete : false, 	//
				eventVersionChanger : false,// Whether or not the event changes the version of all items
				eventPreVersion : 0, 		// Version of documents prior to event 
				eventPostVersion : 0, 		// Version of documents after event
				eventStatus : false,		// false if the event has not been activiated, true if it has. This locks version controller after event "happens"
				eventItemsThisDay : 1, 		// Number of other events occuring this day - used to set the appearance class
				eventSignoffStatus : false, // True when all of the signoffs are true
				eventAppearanceClass : '',  // The appearance of the event to compensate for other items
				eventNotes : [],			// Array to hold note messages
				eventParticipants : [],		// Array to hold event participants
				eventSignoffNotes : [],		// Array to hold items that a signoff action wants to address
				eventShowComps : false,		// Showing or hiding the components on signoff activity page
				eventComps : [],			// Array that temporarily holds components
				eventID : 0					// The unique ID of the event
			};


			// Set the blank role object
			vm.roleObject = {
				roleTitle : 'New Role',		// Official title of role like 'Analysis Inspector' or 'Design Lead'
				roleCreatorID : '',			// ID of person that created role
				roleCreatorUserName : '',	// User name of person that created role
				roleCreatorName : '',		// Name of person that created role
				roleCreatorPhoto : '', 		// Photo URL of creator
				roleCreateDate : '',		// Date that the role was created
				roleColor : '', 			// Color for the role
				roleDescription : '', 		// Description of role
				roleID : 0					// Unique ID of the role
			};



			// Set the blank signoff object
			vm.signoffObject = {
				signoffTitle : 'New Signoff',	// Official title of signoff
				signoffAssigneeType : 'user', 	// Either 'user' or 'role' depending upon who is assigned signoff
				signoffAssigneeID : '',			// ID of person that is assigned signoff or ID of role
				signoffAssigneeRoleID : '',		// ID of the role assigned to the ask
				signoffAssigneeRoleName : '',	// ID of the role assigned to the ask
				signoffAssigneePhoto : '', 		// Photo of assignee user
				signoffAssigneeUserName : '',	// User name of person assigned signoff (if applicable)
				signoffAssigneeName : '',		// Name of person assigned signoff or name of role
				signoffCreateDate : '',			// Date that the signoff was created
				signoffCreatorID : '',			// ID of person that created role
				signoffCreatorUserName : '',	// User name of person that created signoff
				signoffCreatorName : '',		// Name of person that created signoff
				signoffCreatorPhoto : '',		//
				signoffItems : [],				// IDs of the docs used to hold signoff proposed changes
				signoffEventID : 0,				//
				signoffEventTitle : '',			//
				signoffDocID : 0,				//
				signoffDocTitle : '',			//
				signoffColor : '', 				// Color for the signoff
				signoffComments : {},			// Comments from signee 
				signoffDescription : {},		// Description of signoff 
				signoffDueDate : '',			// Date the the signoff must be completed
				signoffStatus : false, 			// false if unsigned, true when the user signs it
				signoffShowDelete : false, 		//
				signoffID : 0					// Unique ID of the role
			};




			// Set the blank permission object
			vm.permissionObject = {
				permCreatorID : '',				// ID of person that created role
				permCreatorUserName : '',		// User name of person that created role
				permCreatorName : '',			// Name of person that created role
				permCreatorPhoto : '', 			// Photo URL of creator
				permCreateDate : '',			// Date that the role was created
				permDocID : 0,					//
				permDocTitle : '',				//
				permAssigneeID : '',			// ID of person that is assigned signoff or ID of role
				permAssigneePhoto : '', 		// Photo of assignee user
				permAssigneeUserName : '',		// User name of person assigned signoff (if applicable)
				permAssigneeName : '',			// Name of person assigned signoff or name of role
				permID : 0						// Unique ID of the role
			};




		};









		/*
		*
		*   Add an Item
		*
		*/
		function addItem( addFile )
		{   
			console.log('Add an item to a workflow');

			if (vm.cadwolf_fileInfo.item_data.items === undefined)
			{
				vm.cadwolf_fileInfo.item_data.items=[];
			}


			// Make sure that the item isn't already there
			var flag = 1;
			vm.cadwolf_fileInfo.items.forEach(
				function(thisItem, itemIndex){

					if ( thisItem.item_data.fileData.id == addFile.id )
					{
						flag = 0;
					} 
				}
			);

			if ( flag == 1 )
			{

				// Create the item in the database
				$http({
					method: "POST",
					url: window.location.origin+'/items',
					data:{ workflow_id : vm.cadwolf_fileInfo.id,
						   doc_id : addFile.id,
						   item_data :  {
									fileData : addFile,
									order : vm.cadwolf_fileInfo.items.length,
									color : "#FFFFFF",
									topItem : true,
									showChildren : true
								} 
							}

				}).then(function successCallback( returnData ) 
				{

					var itemArray = returnData.data;

					// Destring the item_data
					itemArray.forEach(
						function(thisItem, itemIndex){

							if (typeof(thisItem.item_data) == "string")
							{
								thisItem.item_data = JSON.parse( thisItem.item_data );
							} 
						}
					);

					vm.cadwolf_fileInfo.items = itemArray;
					

					vm.getLogData( addFile.id );
				
				});



				// If the item added is a workspace or part tree, add all children
				if ( ( addFile.file_type_id=='Workspace' ) || ( addFile.file_type_id=='Part Tree' ) )
				{


					// Get the children and save each one
					$http({
						method: "GET",
						url: window.location.origin+'/files/'+addFile.id+'/children'
					}).then(function successCallback( returnData ) 
					{
						console.log('The children are ... ');
						console.log(returnData);


						returnData.data.forEach(function(tempItem, tempIndex){

							// Create the item in the database
							$http({
								method: "POST",
								url: window.location.origin+'/items',
								data:{ workflow_id : vm.cadwolf_fileInfo.id,
									   doc_id : tempItem.id,
									   item_data :  {
												fileData : tempItem,
												order : vm.cadwolf_fileInfo.items.length,
												color : "#FFFFFF",
												topItem : false,
												showChildren : true
											} 
										}

							}).then(function successCallback( returnData ) 
							{

								var itemArray = returnData.data;

								// Destring the item_data
								itemArray.forEach(
									function(thisItem, itemIndex){

										if (typeof(thisItem.item_data) == "string")
										{
											thisItem.item_data = JSON.parse( thisItem.item_data );
										} 

										vm.getLogData( tempItem.id );

									}
								);

								vm.cadwolf_fileInfo.items = itemArray;
								
							
							});

						});

					});

				}

			}

		};















		/*
		*
		*   Add and event to a row
		*
		*/
		function addEvent( )
		{   

			// Ensure that the event has a unique ID
			var flag = 0;
			while ( flag == 0 )
			{
				var eventID = 'Event'+Math.floor((Math.random() * 10000) + 1);
				flag = 1;
				vm.cadwolf_fileInfo.events.forEach(
					function(thisEvent, eventIndex){

						if ( thisEvent.item_data.eventID == eventID )
						{
							flag = 0;
						}
				});
			}
			var newObject = JSON.parse(JSON.stringify(vm.eventObject))
			newObject.eventID = "Workflow"+vm.cadwolf_fileInfo.id+eventID;
			newObject.eventCreatorID = Spark.state.user.id;
			newObject.eventCreatorUserName = Spark.state.user.username;
			newObject.eventCreatorName = Spark.state.user.name;
			newObject.eventCreatorPhoto = Spark.state.user.photo_url;
			newObject.eventCreateDate = new Date;



			// Create the main database object and populate it with the item data
			var newEvent = {
				'user_id' : Spark.state.user.id,
				'item_id' : newObject.eventID,
				'workflow_id' : vm.cadwolf_fileInfo.id,
				'event_type' : 'Note',
				'item_data' : newObject
			};


			// Push the current event object to the events array
			vm.cadwolf_fileInfo.events.push( newEvent );


			// Create the event in the database
			$http({
				method: "POST",
				url: window.location.origin+'/events',
				data:{ workflow_id : vm.cadwolf_fileInfo.id,
					   item_id : newObject.eventID,
					   event_type : 'Note',
					   item_data : newObject }

			}).then(function successCallback( returnData ) 
			{
				console.log('The create event return data is ...');
				console.log(returnData);

				var eventArray = returnData.data;

				// Destring the item_data
				eventArray.forEach(
					function(thisEvent, eventIndex){

						if (typeof(thisEvent.item_data) == "string")
						{
							thisEvent.item_data = JSON.parse( thisEvent.item_data );
						} 
					}
				);


				vm.cadwolf_fileInfo.events = eventArray;
			
			});


			// Calculate the event number of days offset and length
			vm.calcEventDays();


			// Set the widths and offsets of the items
			vm.calcWidths();

		};








		/*
		*
		*   Update an event in the databases
		*
		*/
		function updateEvent( eventID )
		{   

			vm.cadwolf_fileInfo.events.forEach(
				function(thisEvent, eventIndex){

					if ( thisEvent.id == eventID )
					{

						// For some reason, the date picker is a day off
						if ( thisEvent.addStartDay == true )
						{
							thisEvent.addStartDay = false;
							var thisDate = new Date( thisEvent.item_data.eventStart );
							thisEvent.item_data.eventStart = new Date(thisEvent.item_data.eventStart.setDate(thisEvent.item_data.eventStart.getDate()+1));
						}
						if ( thisEvent.addEndDay == true )
						{
							thisEvent.addEndDay = false;
							var thisDate = new Date( thisEvent.item_data.eventEnd );
							thisEvent.item_data.eventEnd = new Date(thisEvent.item_data.eventEnd.setDate(thisEvent.item_data.eventEnd.getDate()+1));
						}



						// Update the event in the database
						$http({
							method: "PUT",
							url: window.location.origin+'/events/'+eventID,
							data:{ workflow_id : thisEvent.workflow_id,
								   event_type : thisEvent.event_type,
								   item_data : thisEvent.item_data }

						}).then(function successCallback( returnData ) 
						{
							console.log(returnData);
						
						});

					}

				}
			);

		}




		/*
		*
		*   Update an event in the databases
		*
		*/
		function updateEvents( )
		{   


			vm.cadwolf_fileInfo.events.forEach(
				function(thisEvent, eventIndex){

					// Update the event in the database
					$http({
						method: "PUT",
						url: window.location.origin+'/events/'+thisEvent.id,
						data:{ workflow_id : thisEvent.workflow_id,
							   event_type : thisEvent.event_type,
							   item_data : thisEvent.item_data }

					}).then(function successCallback( returnData ) 
					{
						console.log(returnData);
					
					});

				}
			);

		}





		/*
		*
		*   Update an signoff in the databases
		*
		*/
		function updateSignoff( signoffID )
		{   


			vm.cadwolf_fileInfo.signoffs.forEach(
				function(thisSignoff, signoffIndex){

					if ( thisSignoff.id == signoffID )
					{

						// Update the event in the database
						$http({
							method: "PUT",
							url: window.location.origin+'/signoffs/'+signoffID,
							data:{ workflow_id : thisSignoff.workflow_id,
								   doc_id : thisSignoff.item_data.signoffDocID,
								   doc_version : thisSignoff.doc_version,
								   doc_revision : thisSignoff.doc_revision,
								   status : thisSignoff.status,
								   event_id : thisSignoff.item_data.signoffEventID,
								   event_item_id : thisSignoff.item_data.signoffEventID,
								   item_data : thisSignoff.item_data }

						}).then(function successCallback( returnData ) 
						{

							var tempSignoff = JSON.parse(JSON.stringify(vm.thisSignoff.id));
							vm.cadwolf_fileInfo.signoffs = returnData.data;

							vm.cadwolf_fileInfo.signoffs.forEach(
								function(thisSignoff, signoffIndex){

									if ( tempSignoff == thisSignoff.id )
									{
										vm.thisSignoff = thisSignoff;
									}
								}
							);

						});

					}

				}
			);

		}













		/*
		*
		*   Delete an event in the databases
		*
		*/
		function deleteEvent( eventID )
		{   


			vm.cadwolf_fileInfo.events.forEach(
				function(thisEvent, eventIndex){

					if ( thisEvent.id == eventID )
					{

						// Update the event in the database
						$http({
							method: "DELETE",
							url: window.location.origin+'/events/'+eventID

						}).then(function successCallback( returnData ) 
						{
						
						});

						vm.cadwolf_fileInfo.events.splice(eventIndex,1);

					}

				}
			);

		}






		/*
		*
		*   Delete an signoff in the databases
		*
		*/
		function deleteSignoff( signoffID )
		{   


			vm.cadwolf_fileInfo.signoffs.forEach(
				function(thisSignoff, signoffIndex){

					if ( thisSignoff.id == signoffID )
					{

						// Update the event in the database
						$http({
							method: "DELETE",
							url: window.location.origin+'/signoffs/'+signoffID

						}).then(function successCallback( returnData ) 
						{
						
						});

						vm.cadwolf_fileInfo.signoffs.splice(eventIndex,1);

					}

				}
			);

		}















		/*
		 *
		 * Set the event in the object
		 *
		 */
		function setEvent( eventID ) 
		{
			console.log('In the set event with an id of '+eventID);

			vm.cadwolf_fileInfo.events.forEach(
				function(thisEvent, eventIndex){

					console.log('Comparing '+eventID+' to '+thisEvent.item_data.eventID);

					if ( eventID == thisEvent.item_data.eventID )
					{
						vm.thisEvent = thisEvent
					}

			});

		}























		/*
		*
		*   Add permission to the workflow
		*
		*/
		function addPermission( user, fileID )
		{   

			if ( vm.cadwolf_fileInfo.item_data.permissions === undefined)
			{
				vm.cadwolf_fileInfo.item_data.permissions = [];
			}

			// Ensure that the role has a unique ID
			var flag = 0;
			while ( flag == 0 )
			{
				var permID = 'Perm'+Math.floor((Math.random() * 10000) + 1);
				flag = 1;
				vm.cadwolf_fileInfo.item_data.permissions.forEach(
					function(thisPerm, permIndex){

						if ( thisPerm.permID == permID )
						{
							flag = 0;
						}
				});
			}
			var newObject = JSON.parse(JSON.stringify(vm.permissionObject))
			newObject.permID = "Workflow"+vm.cadwolf_fileInfo.id+permID;


			// Populate the permission object with creator and assignee stuff
			newObject.permCreatorID = Spark.state.user.id;
			newObject.permCreatorUserName = Spark.state.user.username;
			newObject.permCreatorName = Spark.state.user.name;
			newObject.permCreatorPhoto = Spark.state.user.photo_url;
			newObject.permAssigneeID = user.id
			newObject.permAssigneePhoto = user.photo_url;
			newObject.permAssigneeUserName = user.username;
			newObject.permAssigneeName = user.name;
			newObject.permAssigneeEmail = user.email;
			newObject.permDocID = fileID;


			// Set the file information
			vm.cadwolf_fileInfo.items.forEach(
				function(thisFile, fileIndex){

					if (thisFile.item_data.fileData.id == fileID)
					{
						newObject.permDocTitle = thisFile.name;
					}

				}
			);


			// Make sure this isn't a repeat
			var flag = 0;
			vm.cadwolf_fileInfo.item_data.permissions.forEach(
				function(thisPerm, permIndex){

					if ( ( thisPerm.permDocID == fileID ) && ( thisPerm.permAssigneeID == user.id ) )
					{
						flag = 1;
					}

				}
			);


			// Push the current event object to the events array
			if ( flag == 0 )
			{
				vm.cadwolf_fileInfo.item_data.permissions.push( newObject );
			}

		};





		// Set the blank permission object
		vm.permissionObject = {
			permCreatorID : '',				// ID of person that created role
			permCreatorUserName : '',		// User name of person that created role
			permCreatorName : '',			// Name of person that created role
			permCreatorPhoto : '', 			// Photo URL of creator
			permCreateDate : '',			// Date that the role was created
			permDocID : 0,					//
			permDocTitle : '',				//
			permAssigneeID : '',			// ID of person that is assigned signoff or ID of role
			permAssigneePhoto : '', 		// Photo of assignee user
			permAssigneeUserName : '',		// User name of person assigned signoff (if applicable)
			permAssigneeName : '',			// Name of person assigned signoff or name of role
			permID : 0						// Unique ID of the role
		};



		/*
		*
		*   Delete permission to the workflow
		*
		*/
		function deletePermission( deletePerm )
		{   

			vm.cadwolf_fileInfo.item_data.permissions.forEach(
				function(thisPerm, permIndex){

					if ( ( thisPerm.permDocID == deletePerm.permDocID ) && 
						 ( thisPerm.permAssigneeID == deletePerm.permAssigneeID ) )
					{
						vm.cadwolf_fileInfo.item_data.permissions.splice( permIndex, 1 );
					}

				}
			);

		
		}











		/*
		*
		*   Add role to the workflow
		*
		*/
		function addRole( )
		{   

			// Ensure that the role has a unique ID
			var flag = 0;
			while ( flag == 0 )
			{
				var roleID = 'Role'+Math.floor((Math.random() * 10000) + 1);
				flag = 1;
				vm.cadwolf_fileInfo.item_data.roles.forEach(
					function(thisRole, roleIndex){

						if ( thisRole.roleID == roleID )
						{
							flag = 0;
						}
				});
			}
			var newObject = JSON.parse(JSON.stringify(vm.roleObject))
			newObject.roleID = "Workflow"+vm.cadwolf_fileInfo.id+roleID;

			newObject.roleCreatorID = Spark.state.user.id;
			newObject.roleCreatorUserName = Spark.state.user.username;
			newObject.roleCreatorName = Spark.state.user.name;
			newObject.roleCreatorPhoto = Spark.state.user.photo_url;

			
			if ( vm.cadwolf_fileInfo.item_data.roles === undefined )
			{
				vm.cadwolf_fileInfo.item_data.roles = [];
			}
			// Push the current event object to the events array
			vm.cadwolf_fileInfo.item_data.roles.push( newObject );

		};


























		/*
		*
		*   Add signoff to the workflow
		*
		*/
		function addSignoff( )
		{   

			if ( vm.cadwolf_fileInfo.signoffs === undefined )
			{
				vm.cadwolf_fileInfo.signoffs = [];
			}

			// Ensure that the signoff has a unique ID
			var flag = 0;
			while ( flag == 0 )
			{
				var signoffID = 'Signoff'+Math.floor((Math.random() * 10000) + 1);
				flag = 1;
				vm.cadwolf_fileInfo.signoffs.forEach(
					function(thisSignoff, signoffIndex){

						if ( thisSignoff.item_data.signoffID == signoffID )
						{
							flag = 0;
						}
				});
			}
			var newObject = JSON.parse(JSON.stringify(vm.signoffObject))
			newObject.signoffID = "Workflow"+vm.cadwolf_fileInfo.id+signoffID;
			newObject.signoffCreatorID = Spark.state.user.id;
			newObject.signoffCreatorUserName = Spark.state.user.username;
			newObject.signoffCreatorName = Spark.state.user.name;

			// Create the main database object and populate it with the item data
			var newSignoff = {
				'user_id' : Spark.state.user.id,
				'item_id' : newObject.signoffID,
				'workflow_id' : vm.cadwolf_fileInfo.id,
				'doc_id' : 0,
				'doc_version' : 0,
				'doc_revision' : 0,
				'status':false,
				'event_id' : '',
				'event_item_id' : '',
				'item_data' : newObject
			};


			if ( vm.cadwolf_fileInfo.signoffs === undefined )
			{
				vm.cadwolf_fileInfo.signoffs = [];
			}

			// Push the current event object to the events array
			vm.cadwolf_fileInfo.signoffs.push( newSignoff );


			// Create the signoff in the database
			$http({
				method: "POST",
				url: window.location.origin+'/signoffs',
				data:{ workflow_id : vm.cadwolf_fileInfo.id,
					   item_id : newObject.signoffID,
					   item_data : newObject }

			}).then(function successCallback( returnData ) 
			{
				vm.cadwolf_fileInfo.signoffs = returnData.data;
			});


		};





















		/*
		*
		*   Add note to the event
		*
		*/
		function addNote( thisEvent )
		{   


			thisEvent=vm.thisEvent;
			// Ensure that the role has a unique ID
			var flag = 0;
			while ( flag == 0 )
			{
				var noteID = 'Note'+Math.floor((Math.random() * 10000) + 1);
				flag = 1;
				thisEvent.item_data.eventNotes.forEach(
					function(thisNote, noteIndex){

						if ( thisNote.noteID == noteID )
						{
							flag = 0;
						}
				});
			}
			var newObject = {};
			newObject.noteID = "Workflow"+vm.cadwolf_fileInfo.id+noteID;

			newObject.noteCreatorID = Spark.state.user.id;
			newObject.noteCreatorUserName = Spark.state.user.username;
			newObject.noteCreatorName = Spark.state.user.name;
			newObject.noteCreatorPhoto = Spark.state.user.photo_url;

			newObject.noteDate = new Date();
			newObject.noteContent = '';
			newObject.day = newObject.noteDate.getDate();
			newObject.month = newObject.noteDate.getMonth();
			newObject.year = newObject.noteDate.getFullYear();


			if ( thisEvent.item_data.eventNotes === undefined )
			{
				thisEvent.item_data.eventNotes = [];
			}
			// Push the current event object to the events array
			thisEvent.item_data.eventNotes.push( newObject );

		};




















		/*
		*
		*   Add participant to the event
		*
		*/
		function addEventParticipant( thisUser, thisEvent )
		{   

			thisEvent=vm.thisEvent;
			// Ensure that the role has a unique ID
			var flag = 0;
			while ( flag == 0 )
			{
				var partID = 'Part'+Math.floor((Math.random() * 10000) + 1);
				flag = 1;
				thisEvent.item_data.eventParticipants.forEach(
					function(thisPart, partIndex){

						if ( thisPart.partID == partID )
						{
							flag = 0;
						}
				});
			}
			var newObject = {};
			newObject.partID = "Workflow"+vm.cadwolf_fileInfo.id+partID;

			newObject.partCreatorID = Spark.state.user.id;
			newObject.partCreatorUserName = Spark.state.user.username;
			newObject.partCreatorName = Spark.state.user.name;
			newObject.partCreatorPhoto = Spark.state.user.photo_url;
			newObject.partDate = new Date();
			newObject.partID = thisUser.id;
			newObject.partName = thisUser.name;
			newObject.partUserName = thisUser.username;
			newObject.partUserPhoto = thisUser.photo_url;


			if ( thisEvent.item_data.eventParticipants === undefined )
			{
				thisEvent.item_data.eventParticipants = [];
			}

			// Push the current event object to the events array
			thisEvent.item_data.eventParticipants.push( newObject );

		};









		/*
		 *
		 * Set data for user assigned to signoff
		 *
		 */
		function setSigneeData( signoffID, userID ) 
		{

			vm.cadwolf_fileInfo.signoffs.forEach(
				function(thisSignoff, signoffIndex){

					if ( thisSignoff.item_data.signoffID == signoffID )
					{
						vm.cadwolf_fileInfo.item_data.userRoles.forEach(
							function(thisUserRole, userRoleIndex){

								if ( thisUserRole.userID == userID )
								{
									thisSignoff.item_data.signoffAssigneeName = thisUserRole.userName;
									thisSignoff.item_data.signoffAssigneeUserName = thisUserRole.userUserName;
									thisSignoff.item_data.signoffAssigneePhoto = thisUserRole.userPhoto;
								}

							}
						);
					}
				}
			);

		}



















		/*
		 *
		 * Add a document to an event
		 *
		 */
		function addDocEvent( thisEvent, thisDoc ) 
		{

			console.log('In the add doc event function');
			
			var flag = 0;

			thisEvent.item_data.eventFiles.forEach(
				function(thisFile, fileIndex){

					if ( thisFile.eventDocID == thisDoc.item_data.fileData.id )
					{
						flag = 1;
					}

				}
			);

			if ( flag == 0 )
			{
				var newEntry = {
					eventDocID : thisDoc.item_data.fileData.id,
					eventDocName : thisDoc.item_data.fileData.name,
					eventDocCreatorID : Spark.state.user.id,
					eventDocCreatorUserName : Spark.state.user.username,
					eventDocCreatorName : Spark.state.user.name,
					eventDocCreateDate : new Date()
				};

				thisEvent.item_data.eventFiles.push( newEntry );
			}

		}



		/*
		 *
		 * Remove a document from an event
		 *
		 */
		function removeDocEvent( thisEvent, thisDocID ) 
		{

			console.log('In the remove doc event function');

			thisEvent.item_data.eventFiles.forEach(
				function(thisFile, fileIndex){

					if ( thisFile.eventDocID == thisDocID )
					{
						thisEvent.item_data.eventFiles.splice(fileIndex, 1);
					}

				}
			);
		}




















		/*
		 *
		 * Populate the item list for each event -  delete me
		 *
		 */
		function popEventItems( ) 
		{

			console.log('In the pop event items function');
			
			vm.cadwolf_fileInfo.events.forEach(
				function(thisEvent, eventIndex){

				vm.cadwolf_fileInfo.item_data.items.forEach(
					function(thisItem, itemIndex){

					var flag = 0;

					thisEvent.item_data.eventItems.forEach(
						function(eventItem, eventIndex){
					
						if ( eventItem.docID == thisItem.fileData.id )
						{
							flag = 1;
						}
					});

					if ( flag == 0 )
					{
						var newEventItem = {
							docID : thisItem.fileData.id,
							title : thisItem.fileData.name,
							eventApply : false
						}
					}

				});

			});


		}

















		/*
		 *
		 * Check to see that member name is unique
		 *
		 * @param item
		 */
		function checkMemberName( memberName )
		{
			$http({
			  method: "GET",
			  url: window.location.origin+'/checkMember',
			  params:{ memberName : memberName }
			}).then(function successCallback( returnData ) {
					console.log('Return data is ');
					console.log(returnData);
					vm.foundUser=returnData.data.member;
			  }, function errorCallback( returnData ) {
			});			
		}

















		/*
		 *
		 * Check the event note dates vs the current time
		 *
		 */
		function checkNoteDates( thisEvent ) 
		{

			
			thisEvent.item_data.eventNotes.forEach(
				function(thisNote, noteIndex){

					var thisDate = new Date( thisNote.noteDate );

					var today = new Date();

					thisNote.inTime = false;

					if ( (Math.abs(vm.thisNote.noteDate - vm.thisDate)/ 36e5) < 3 )
					{
						thisNote.inTime = true;
					}
				}
			);



			thisEvent.item_data.eventSignoffNotes.forEach(
				function(thisNote, noteIndex){

					var thisDate = new Date( thisNote.noteDate );

					var today = new Date();

					thisNote.inTime = false;

					if ( (Math.abs(vm.thisNote.noteDate - vm.thisDate)/ 36e5) < 3 )
					{
						thisNote.inTime = true;
					}
				}
			);


		}

















    	/**
         *
         *  Get the files in folder
         *
         */
        function getFiles( thisURL, addFolder )
        {
            if (thisURL !== undefined)
            {
                // Remove any trailing slashes
                thisURL = thisURL.replace(/\/$/,'');

                // If there was an additional folder path, add it on
                if ( addFolder !== undefined )
                {
                    addFolder = addFolder.replace(/\/$/,'');
                    addFolder = addFolder.replace(/^\//,'');
                    thisURL = thisURL+'/'+addFolder;
                }

                // Reset the URL
                vm.getFilesURL = thisURL;

                // Pull down the files
                $http({
                    type: "GET",
                    url: window.location.origin+'/files',
                    params: { thisURL : thisURL },
                }).then(function successCallback( returnData ) 
                {
                
					// Set the files and format their dates to be displayed
					vm.currentFiles = returnData['data']['files'];

                }, function errorCallback( returnData ) {});
            }
        };












    	/**
         *
         *  Get the content of a file
         *
         */
        function getDocContent( thisDoc )
        {


        	// Get the contents using the Doc ID
			var thisURL = window.location.origin+'/files/'+vm.cadwolf_fileInfo.id+'/components';
			$http({
				type: "GET",
				url: thisURL
			}).then(function successCallback( returnData ) 
			{

				vm.eventComponents = returnData.data.components;

			});

		};





    	/**
         *
         *  Add a signoff note
         *
         */
        function addSignoffNote( thisEvent, thisItem )
        {

			var signoffNote = {
				noteDocCreatorID : Spark.state.user.id,
				noteDocCreatorUserName : Spark.state.user.username,
				noteDocCreatorName : Spark.state.user.name,
				noteDocCreateDate : new Date(),
				noteContent : '',
				noteComponent : thisItem
			};

			thisEvent.item_data.eventSignoffNotes.push( signoffNote );


        };







		function cancel(){
			$mdDialog.cancel();
		};


		function hide(response){
			$mdDialog.hide(response);
		};


		function acceptChanges(desc) {
			$mdDialog.hide(desc);
		};


	}
})();


(function ()
{
    'use strict';

    angular
        .module('app.unit', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.unit', {
            url      : '/units/',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/unit/unit.html',
                    controller : 'UnitController as vm'
                }
            },
            bodyClass: 'unit'

        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/unit');

        // Navigation
        msNavigationServiceProvider.saveItem('unit', {
            title : 'Units',
            icon  : 'icon-pound',
            state : 'app.unit',
            weight: 11
        });
    }

})();
(function ()
{
	'use strict';

	angular
		.module('app.unit')
		.controller('WorkflowController', WorkflowController);

	/** @ngInject */
	function WorkflowController($location, $mdSidenav, $mdDialog, $mdMedia, $sce, userMemoryFactory, utilityFactory, $http)
	{

		// Default Items
		var vm = this;
		window.MY_SCOPE = vm;	   



		// Methods
		vm.getSpark			= vm.getSpark			|| getSpark;
		vm.initialize		= vm.initialize			|| initialize;
		vm.showAddModal 	= vm.showAddModal 		|| showAddModal;
		vm.showEditModal 	= vm.showEditModal 		|| showEditModal;
		vm.showEventModal 	= vm.showEventModal 	|| showEventModal;
		vm.showRoleModal 	= vm.showRoleModal 		|| showRoleModal;
		vm.showSignoffModal = vm.showSignoffModal 	|| showSignoffModal;
		vm.showEVModal 		= vm.showEVModal 		|| showEVModal;
		vm.getEndDates	 	= vm.getEndDates		|| getEndDates;
		vm.populateDates 	= vm.populateDates 		|| populateDates;
		vm.getLogData 		= vm.getLogData 		|| getLogData;
		vm.deleteItem 		= vm.deleteItem 		|| deleteItem;
		vm.checkUpdateStatus= vm.checkUpdateStatus 	|| checkUpdateStatus;
		vm.calcLogDays 		= vm.calcLogDays 		|| calcLogDays;
		vm.calcWidths 		= vm.calcWidths 		|| calcWidths;
		vm.calcEventDays 	= vm.calcEventDays 		|| calcEventDays;
		vm.calcDaysBetween 	= vm.calcDaysBetween 	|| calcDaysBetween;
		vm.checkMemberName	= vm.checkMemberName 	|| checkMemberName;
		vm.addUserRole 		= vm.addUserRole 		|| addUserRole;
		vm.updateWorkflow 	= vm.updateWorkflow 	|| updateWorkflow;
		vm.getEvents 		= vm.getEvents 			|| getEvents;
		vm.getSignoffs 		= vm.getSignoffs 		|| getSignoffs;
		vm.getRequirements  = vm.getRequirements 	|| getRequirements;
		vm.getDiscs			= vm.getDiscs 			|| getDiscs;
		vm.getItems 		= vm.getItems 			|| getItems;
		vm.deleteItem 		= vm.deleteItem 		|| deleteItem;
		vm.updateItem 		= vm.updateItem 		|| updateItem;
		vm.updateItems 		= vm.updateItems 		|| updateItems;
		vm.updateEvents 	= vm.updateEvents 		|| updateEvents;
		vm.updateSignoffs 	= vm.updateSignoffs 	|| updateSignoffs;
		vm.setPermLevels 	= vm.setPermLevels 		|| setPermLevels;
		vm.setPermissions 	= vm.setPermissions 	|| setPermissions;
		vm.runEventDigest 	= vm.runEventDigest 	|| runEventDigest;
		vm.rollVersions 	= vm.rollVersions 		|| rollVersions;

		vm.addTask 			= vm.addTask 			|| addTask;
		vm.addQuestion 		= vm.addQuestion 		|| addQuestion;
		vm.updateQuestion 	= vm.updateQuestion 	|| updateQuestion;
		vm.updateTask		= vm.updateTask 		|| updateTask;
		vm.deleteTask 		= vm.deleteTask 		|| deleteTask;
		vm.deleteQuestion 	= vm.deleteQuestion 	|| deleteQuestion;




		/*
		 * Set the initial parameters
		 *
		 */
		function initialize( thisVersion )
		{   
		
			// If no version is sent, default to 0
			if ( thisVersion === undefined )
			{ 
				thisVersion=0; 
			}



			// Set the width of the days in pixels
			vm.dayColWidth = 20;




			// The item_data for a task
			vm.taskObject = {
				taskBody : "Add task text",		// The text of the task
				taskTitle : "Task Title",		// The title fo the task
				taskDueDate : new Date(),		// The date that the task is due - if any
				taskEnds : false,				// Does the task have an answer
				taskStatus : 0,					// 0 for open, 1 for finished
				taskAssignees : [],				// Array of users assigned to this task
				editStatus : 1 					// 1 if the item is being edited, 0 if just displayed
			};



			// The item_data for a task
			vm.questionObject = {
				questionBody : "Add question text",		// The text of the task
				questionTitle : "Question Title",		// The title fo the task
				questionStatus : 0,						// 0 for open, 1 for answered
				editStatus : 1 							// 1 if the item is being edited, 0 if just displayed
			};



			// Pull down the file data
			$http({
				method: "GET",
				url: window.location.origin+'/files',
				params: { thisURL : window.location.href.replace(/\~2F/g,'/'), version : thisVersion }
			}).then(function successCallback( returnData ) 
			{
				vm.cadwolf_fileInfo = returnData.data.fileInfo;
				vm.cadwolf_fileInfo.events = [];
				vm.cadwolf_fileInfo.signoffs = [];
				vm.cadwolf_fileInfo.items = [];


				// Set the edit and view permissions
				vm.setPermLevels( returnData );

				// Find the earliest and latest dates
				vm.getEndDates();

				// Populate the arrays holding the years, months, and days
				vm.populateDates();

				// Get the items
				vm.getItems();

				// Get the events and Calculate the widths and placements of the events
				vm.getEvents();

				// Get the signoffs
				vm.getSignoffs();

				// Get the tasks and questions
				vm.getDiscs();

			});

		}


















		/*
		 *
		 * Get the spark parameters
		 *
		 */
		function getSpark( )
		{   
			$http({
				method: "GET",
				url: window.location.origin+'/user/current'

			}).then(function successCallback( returnData ) 
			{
				//console.log('The spark data is ...');
				//console.log(returnData.data);
				if ( Spark.state !== undefined )
				{
					if ( Spark.state.user !== undefined )
					{
						if ( returnData.data.user_info !== undefined )
						{
							returnData.data.user_info = JSON.parse(returnData.data.user_info);
							Spark.state.user = returnData.data;
							vm.editPerm = Spark.state.user.id == vm.cadwolf_fileInfo.item_data.checkout_id;
						}
					}
				}else
				{
					vm.editPerm = false;					
				}
			});

		}
















		/*
		 *
		 * Get the stored items
		 *
		 */
		function getItems( )
		{   
			$http({
				method: "GET",
				url: window.location.origin+'/items/'+vm.cadwolf_fileInfo.id

			}).then(function successCallback( returnData ) 
			{

				// Place the returns into the events array
				var itemArray = returnData.data;


				// Destring the item_data
				itemArray.forEach(
					function(thisItem, itemIndex){

						if (typeof(thisItem.item_data)=="string")
						{
							thisItem.item_data = JSON.parse( thisItem.item_data );
						}
					}
				);


				// Place the returns into the events array
				vm.cadwolf_fileInfo.items = itemArray;

				// Set the permissions in each item
				vm.setPermissions();

			});

		}















		/*
		 *
		 * Get the stored events
		 *
		 */
		function getEvents( )
		{   
			$http({
				method: "GET",
				url: window.location.origin+'/events/'+vm.cadwolf_fileInfo.id

			}).then(function successCallback( returnData ) 
			{

				// Place the returns into the events array
				var eventArray = returnData.data;


				// Destring the item_data
				eventArray.forEach(
					function(thisEvent, eventIndex){

						if (typeof(thisEvent.item_data) == "string")
						{
							thisEvent.item_data = JSON.parse( thisEvent.item_data );
						}
					}
				);


				// Place the returns into the events array
				vm.cadwolf_fileInfo.events = eventArray;


				// Calculate the days before and during the events
				vm.calcEventDays();


				// Set the widths of the items if needed
				vm.calcWidths();


			});

		}



















		/*
		 *
		 * Get the stored signoffs
		 *
		 */
		function getSignoffs( )
		{   
			$http({
				method: "GET",
				url: window.location.origin+'/signoffs/'+vm.cadwolf_fileInfo.id

			}).then(function successCallback( returnData ) 
			{

				// Place the returns into the signoffs array
				var signoffArray = returnData.data;

				vm.cadwolf_fileInfo.signoffs = signoffArray;

				// Destring the item_data
				signoffArray.forEach(
					function(thisSignoff, signoffIndex){

						if (typeof(thisSignoff.item_data == "string"))
						{
							thisSignoff.item_data = JSON.parse( thisSignoff.item_data );
						}
					}
				);

				// Place the returns into the signoffs array
				vm.cadwolf_fileInfo.signoffs = signoffArray;


			});

		}











		/*
		 *
		 * Update the item
		 *
		 */
		function updateItem( itemID )
		{   

			//console.log('In update item with '+itemID);

			if ( vm.editPerm )
			{
				vm.cadwolf_fileInfo.items.forEach(
					function(thisItem, itemIndex){

						if ( thisItem.id == itemID )
						{


							// Create the event in the database
							$http({
								method: "PUT",
								url: window.location.origin+'/items/'+itemID,
								data:{ workflow_id : vm.cadwolf_fileInfo.id,
									   doc_id : thisItem.item_data.fileData.id,
									   needs_update : thisItem.needs_update,
									   item_data :  thisItem.item_data }

							}).then(function successCallback( returnData ) 
							{
							
							});
						}
					}
				);

			}

		}





		/*
		 *
		 * Update the item
		 *
		 */
		function updateItems( )
		{   

			//console.log('In update items');

			if ( vm.editPerm )
			{
				vm.cadwolf_fileInfo.items.forEach(
					function(thisItem, itemIndex){

						// Create the event in the database
						$http({
							method: "PUT",
							url: window.location.origin+'/items/'+thisItem.id,
							data:{ workflow_id : vm.cadwolf_fileInfo.id,
								   doc_id : thisItem.item_data.fileData.id,
								   needs_update : thisItem.needs_update,
								   item_data :  thisItem.item_data }

						}).then(function successCallback( returnData ) 
						{
						
						});
					}
					
				);

			}

		}



















		/*
		*
		*   Update an event in the databases
		*
		*/
		function updateEvents( )
		{   


			vm.cadwolf_fileInfo.events.forEach(
				function(thisEvent, eventIndex){

					// Update the event in the database
					$http({
						method: "PUT",
						url: window.location.origin+'/events/'+thisEvent.id,
						data:{ workflow_id : thisEvent.workflow_id,
							   event_type : thisEvent.event_type,
							   item_data : thisEvent.item_data }

					}).then(function successCallback( returnData ) 
					{
						//console.log(returnData);
					
					});

				}
			);

		}






		/*
		*
		*   Update an signoff in the databases
		*
		*/
		function updateSignoffs( )
		{   


			vm.cadwolf_fileInfo.signoffs.forEach(
				function(thisSignoff, signoffIndex){

					// Update the event in the database
					$http({
						method: "PUT",
						url: window.location.origin+'/signoffs/'+thisSignoff.id,
						data:{ workflow_id : thisSignoff.workflow_id,
							   doc_id : thisSignoff.item_data.signoffDocID,
							   doc_version : thisSignoff.doc_version,
							   doc_revision : thisSignoff.doc_revision,
							   status : thisSignoff.status,
							   event_id : thisSignoff.item_data.signoffEventID,
							   event_item_id : thisSignoff.item_data.signoffEventID,
							   item_data : thisSignoff.item_data }

					}).then(function successCallback( returnData ) 
					{
						vm.cadwolf_fileInfo.signoffs = returnData.data;
					});

				}
			);

		}



















		/*
		 *
		 * Show the small modal box that lets the user add an item, event, or role
		 *
		 */
		function showAddModal(ev) 
		{
			$mdDialog.show({
				controller: 'WorkflowDialogController',
				templateUrl: 'app/main/apps/workflow/views/dialogs/item-dialog.html',
				locals:{
					Spark : Spark,
					cadwolf_fileInfo : vm.cadwolf_fileInfo,
					calcLogDays : vm.calcLogDays,
					updateItem : vm.updateItem,
					calcDaysBetween : vm.calcDaysBetween,
					calcEventDays : vm.calcEventDays,
					calcWidths : vm.calcWidths,
					getEndDates : vm.getEndDates,
					populateDates : vm.populateDates,
					checkMemberName : vm.checkMemberName,
					foundUser : vm.foundUser,
					conditionalEdit : vm.conditionalEdit,
					eventTypes : vm.eventTypes,
					runEventDigest : vm.runEventDigest,
					getLogData : vm.getLogData,
					checkUpdateStatus : vm.checkUpdateStatus,
					deleteItem : vm.deleteItem,
					editPerm : vm.editPerm
				},
				controllerAs: 'vm',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
				vm.returnData = data;

				if ( vm.editPerm )
				{
					vm.updateWorkflow();
				}

			}, function() {
				
			});
		};



		/*
		 *
		 * Show the small modal box that lets users edit properties of items, events, and roles
		 *
		 */
		function showEditModal(ev) 
		{
			$mdDialog.show({
				controller: 'WorkflowDialogController',
				templateUrl: 'app/main/apps/workflow/views/dialogs/settings-dialog.html',
				locals:{
					Spark : Spark,
					cadwolf_fileInfo : vm.cadwolf_fileInfo,
					calcLogDays : vm.calcLogDays,
					updateItem : vm.updateItem,
					calcDaysBetween : vm.calcDaysBetween,
					calcEventDays : vm.calcEventDays,
					calcWidths : vm.calcWidths,
					getEndDates : vm.getEndDates,
					populateDates : vm.populateDates,
					checkMemberName : vm.checkMemberName,
					foundUser : vm.foundUser,
					conditionalEdit : vm.conditionalEdit,
					eventTypes : vm.eventTypes,
					runEventDigest : vm.runEventDigest,
					getLogData : vm.getLogData,
					checkUpdateStatus : vm.checkUpdateStatus,
					editPerm : vm.editPerm,
					deleteItem : vm.deleteItem
				},
				controllerAs: 'vm',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
				vm.returnData = data;

				if ( vm.editPerm )
				{
					vm.updateWorkflow();
				}


			}, function() {
				
			});
		};


		/*
		 *
		 * Show the small modal box that lets users edit properties of items, events, and roles
		 *
		 */
		function showEventModal(ev) 
		{
			$mdDialog.show({
				controller: 'WorkflowDialogController',
				templateUrl: 'app/main/apps/workflow/views/dialogs/event-dialog.html',
				locals:{
					Spark : Spark,
					cadwolf_fileInfo : vm.cadwolf_fileInfo,
					calcLogDays : vm.calcLogDays,
					updateItem : vm.updateItem,
					calcDaysBetween : vm.calcDaysBetween,
					calcEventDays : vm.calcEventDays,
					calcWidths : vm.calcWidths,
					getEndDates : vm.getEndDates,
					populateDates : vm.populateDates,
					checkMemberName : vm.checkMemberName,
					foundUser : vm.foundUser,
					conditionalEdit : vm.conditionalEdit,
					eventTypes : vm.eventTypes,
					runEventDigest : vm.runEventDigest,
					getLogData : vm.getLogData,
					checkUpdateStatus : vm.checkUpdateStatus,
					deleteItem : vm.deleteItem,
					editPerm : vm.editPerm
				},
				controllerAs: 'vm',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
				vm.returnData = data;

				if ( vm.editPerm )
				{
					vm.updateWorkflow();
					vm.updateEvents();
				}


			}, function() {
				
			});
		};



		/*
		 *
		 * Show the small modal box that lets users edit properties of items, events, and roles
		 *
		 */
		function showRoleModal(ev) 
		{
			$mdDialog.show({
				controller: 'WorkflowDialogController',
				templateUrl: 'app/main/apps/workflow/views/dialogs/role-dialog.html',
				locals:{
					Spark : Spark,
					cadwolf_fileInfo : vm.cadwolf_fileInfo,
					calcLogDays : vm.calcLogDays,
					updateItem : vm.updateItem,
					calcDaysBetween : vm.calcDaysBetween,
					calcEventDays : vm.calcEventDays,
					calcWidths : vm.calcWidths,
					getEndDates : vm.getEndDates,
					populateDates : vm.populateDates,
					checkMemberName : vm.checkMemberName,
					foundUser : vm.foundUser,
					addUserRole : vm.addUserRole,
					conditionalEdit : vm.conditionalEdit,
					eventTypes : vm.eventTypes,
					runEventDigest : vm.runEventDigest,
					getLogData : vm.getLogData,
					checkUpdateStatus : vm.checkUpdateStatus,
					deleteItem : vm.deleteItem,
					editPerm : vm.editPerm
				},
				controllerAs: 'vm',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
				vm.returnData = data;

				if ( vm.editPerm )
				{
					vm.updateWorkflow();
				}


			}, function() {
				
			});
		};		



		/*
		 *
		 * Show the small modal box that lets users edit properties of items, events, and roles
		 *
		 */
		function showSignoffModal(ev) 
		{
			$mdDialog.show({
				controller: 'WorkflowDialogController',
				templateUrl: 'app/main/apps/workflow/views/dialogs/signoff-dialog.html',
				locals:{
					Spark : Spark,
					cadwolf_fileInfo : vm.cadwolf_fileInfo,
					calcLogDays : vm.calcLogDays,
					updateItem : vm.updateItem,
					calcDaysBetween : vm.calcDaysBetween,
					calcEventDays : vm.calcEventDays,
					calcWidths : vm.calcWidths,
					getEndDates : vm.getEndDates,
					populateDates : vm.populateDates,
					checkMemberName : vm.checkMemberName,
					foundUser : vm.foundUser,
					addUserRole : vm.addUserRole,
					removeUserRole : vm.removeUserRole,
					conditionalEdit : vm.conditionalEdit,
					eventTypes : vm.eventTypes,
					runEventDigest : vm.runEventDigest,
					getLogData : vm.getLogData,
					checkUpdateStatus : vm.checkUpdateStatus,
					deleteItem : vm.deleteItem,
					editPerm : vm.editPerm
				},
				controllerAs: 'vm',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
				vm.returnData = data;

				if ( vm.editPerm )
				{
					vm.updateWorkflow();
					vm.updateSignoffs();				
				}


			}, function() {
				
			});
		};		




		/*
		 *
		 * Show the modal box that displays the event properties to the unedited user
		 *
		 */
		function showEVModal(thisEvent, signoffs, ev) 
		{

			$mdDialog.show({
				controller: 'WorkflowDialogController',
				templateUrl: 'app/main/apps/workflow/views/dialogs/view-event-dialog.html',
				locals:{
					Spark : Spark,
					thisEvent : thisEvent,
					eventTypes : vm.eventTypes,
					runEventDigest : vm.runEventDigest,
					getLogData : vm.getLogData,
					checkUpdateStatus : vm.checkUpdateStatus,
					deleteItem : vm.deleteItem,
					cadwolf_fileInfo : vm.cadwolf_fileInfo
				},
				controllerAs: 'vm',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
				vm.returnData = data;
				// Call to server to update the references
			}, function() {
				
			});
		};		
























		/*
		 *
		 * Check to see that member name is unique
		 *
		 * @param item
		 */
		function checkMemberName( memberName )
		{
			$http({
			  method: "GET",
			  url: window.location.origin+'/checkMember',
			  params:{ memberName : memberName }
			}).then(function successCallback( returnData ) {
					//console.log('Return data is ');
					//console.log(returnData);
					vm.foundUser=returnData.data.member;
			  }, function errorCallback( returnData ) {
			});			
		}



















		/*
		 *
		 * Add a role to a user
		 *
		 * 
		 */
		function addUserRole( newUser, newRole )
		{

			//console.log('In add user role with user and role of ...');
			//console.log(newUser);
			//console.log(newRole);

			var newUserRole = {
				userID : newUser.id,
				userUserName : newUser.username,
				userName : newUser.name, 
				userEmail : newUser.email,
				userPhoto : newUser.photo_url,
				roleID : newRole.roleID,
				roleTitle : newRole.roleTitle,
				dateAdded : new Date,
				userThatAddedID : Spark.state.user.id,
				userThatAddedUsername : Spark.state.user.username,
				userThatAddedEmail : Spark.state.user.email,
				userThatAddedPhoto : Spark.state.user.photo_url
			};

			if ( vm.cadwolf_fileInfo.item_data.userRoles === undefined )
			{
				vm.cadwolf_fileInfo.item_data.userRoles = [];
			}
			vm.cadwolf_fileInfo.item_data.userRoles.push(newUserRole);

		}

















		/*
		 *
		 * Remove a role to a user
		 *
		 * 
		 */
		function removeUserRole( roleID )
		{


			vm.cadwolf_fileInfo.item_data.userRoles.forEach(
				function(thisRole, roleIndex){

					if ( thisRole.roleID == roleID )
					{
						vm.cadwolf_fileInfo.item_data.userRoles.splice( roleIndex , 1 );

					}

				}

			);


		}























		/*
		*
		*   Add a task or comment to a task
		*
		*/
		function addTask( taskID )
		{   

			// If the taskID is undefined, the "parent" is zero as it is a new task
			if ( taskID === undefined )
			{
				taskID = 0;
			}


			// Create the task data
			var newTaskData = JSON.parse(JSON.stringify(vm.taskObject));
			newTaskData.type = "task";
			newTaskData.order = vm.tasks.length;

			// Create the item in the database
			$http({
				method: "POST",
				url: window.location.origin+'/discussions',
				data:{ owner_id : vm.cadwolf_fileInfo.id,
					   parent_id : taskID,
					   item_data :  newTaskData
				}

			}).then(function successCallback( returnData ) 
			{

				// Push the new task to the array
				vm.tasks.push(returnData.data);

			});



		}







		/*
		*
		*   Add a question or comment to a task
		*
		*/
		function addQuestion( questionID )
		{   

			// If the taskID is undefined, the "parent" is zero as it is a new task
			if ( questionID === undefined )
			{
				questionID = 0;
			}

			// Create the task data
			var newQuestionData = JSON.parse(JSON.stringify(vm.questionObject));
			newQuestionData.type = "question";
			newQuestionData.order = vm.questions.length;

			// Create the item in the database
			$http({
				method: "POST",
				url: window.location.origin+'/discussions',
				data:{ owner_id : vm.cadwolf_fileInfo.id,
					   parent_id : questionID,
					   item_data :  newQuestionData
				}

			}).then(function successCallback( returnData ) 
			{

				// Push the new task to the array
				vm.questions.push(returnData.data);

			});



		}









		/*
		*
		*   Update a question
		*
		*/
		function updateQuestion( questionItem )
		{   

			// Update the item in the database
			$http({
				method: "PUT",
				url: window.location.origin+'/discussions/'+questionItem.id,
				data:{ item_data : questionItem.item_data }

			}).then(function successCallback( returnData ) 
			{

			});


		}











		/*
		*
		*   Update a task
		*
		*/
		function updateTask( taskItem )
		{   

			// Update the item in the database
			$http({
				method: "PUT",
				url: window.location.origin+'/discussions/'+taskItem.id,
				data:{ item_data : taskItem.item_data }

			}).then(function successCallback( returnData ) 
			{

			});


		}















		/*
		 *
		 * Get the first and last days, months, and years
		 *
		 */
		function getEndDates( ) 
		{

			//console.log('In the get end dates function');
			
			var today = new Date();

			if ( ( vm.cadwolf_fileInfo.item_data.settings.dates.startDate == "" ) ||
				 ( vm.cadwolf_fileInfo.item_data.settings.dates.startDate === undefined ) )
			{
				var d = new Date();
				var year = d.getFullYear();
				var month = d.getMonth();
				var day = d.getDate();
				vm.cadwolf_fileInfo.item_data.settings.dates.startDate = new Date( year - 1, month, day );
			}

			if ( ( vm.cadwolf_fileInfo.item_data.settings.dates.endDate == "" ) ||
				 ( vm.cadwolf_fileInfo.item_data.settings.dates.endDate == undefined ) )
			{	   
				var d = new Date();
				var year = d.getFullYear();
				var month = d.getMonth();
				var day = d.getDate();
				vm.cadwolf_fileInfo.item_data.settings.dates.endDate = new Date( year + 1, month,  day);

			}




			// These are strings when pulled from the database, so they have to be remade into date objects
			if ( typeof(vm.cadwolf_fileInfo.item_data.settings.dates.startDate) == "string" )
			{
				vm.cadwolf_fileInfo.item_data.settings.dates.startDate = new Date(vm.cadwolf_fileInfo.item_data.settings.dates.startDate);
			}

			if ( typeof(vm.cadwolf_fileInfo.item_data.settings.dates.endDate) == "string" )
			{
				vm.cadwolf_fileInfo.item_data.settings.dates.endDate = new Date(vm.cadwolf_fileInfo.item_data.settings.dates.endDate);
			}


			if ( vm.cadwolf_fileInfo.item_data.settings.dates.startMonth === undefined )
			{

				if ( today.getMonth() > 6 )
				{
					vm.cadwolf_fileInfo.item_data.settings.dates.startMonth = today.getMonth()-5;
					vm.cadwolf_fileInfo.item_data.settings.dates.startYear = today.getFullYear();
					vm.cadwolf_fileInfo.item_data.settings.dates.startDay = 1;


				}else
				{
					vm.cadwolf_fileInfo.item_data.settings.dates.startMonth = 12-today.getMonth()+1;
					vm.cadwolf_fileInfo.item_data.settings.dates.startYear = today.getFullYear()-1;
					vm.cadwolf_fileInfo.item_data.settings.dates.startDay = 1;
				}
			
	
			}else
			{

				vm.cadwolf_fileInfo.item_data.settings.dates.startMonth = vm.cadwolf_fileInfo.item_data.settings.dates.startDate.getMonth();
				vm.cadwolf_fileInfo.item_data.settings.dates.startYear = vm.cadwolf_fileInfo.item_data.settings.dates.startDate.getFullYear();
				vm.cadwolf_fileInfo.item_data.settings.dates.startDay = vm.cadwolf_fileInfo.item_data.settings.dates.startDate.getDate();

			}

			if ( vm.cadwolf_fileInfo.item_data.settings.dates.endMonth === undefined )
			{
				if ( today.getMonth() < 6 )
				{
					vm.cadwolf_fileInfo.item_data.settings.dates.endMonth = today.getMonth()+5;
					vm.cadwolf_fileInfo.item_data.settings.dates.endYear = today.getFullYear();
					vm.cadwolf_fileInfo.item_data.settings.dates.endDay = vm.days[vm.endMonth];

				}else
				{
					vm.cadwolf_fileInfo.item_data.settings.dates.endMonth = 12-today.getMonth();
					vm.cadwolf_fileInfo.item_data.settings.dates.endYear = today.getFullYear()+1;
					vm.cadwolf_fileInfo.item_data.settings.dates.endDay = vm.days[vm.endMonth];
				}

			}else
			{
				vm.cadwolf_fileInfo.item_data.settings.dates.endMonth = vm.cadwolf_fileInfo.item_data.settings.dates.endDate.getMonth();
				vm.cadwolf_fileInfo.item_data.settings.dates.endYear = vm.cadwolf_fileInfo.item_data.settings.dates.endDate.getFullYear();
				vm.cadwolf_fileInfo.item_data.settings.dates.endDay = parseInt(parseInt(vm.cadwolf_fileInfo.item_data.settings.dates.endDate.getDate())+1);

			}

			// Set the earliest time to today and give it a year's time
			vm.startYear = vm.cadwolf_fileInfo.item_data.settings.dates.startYear;
			vm.startMonth = vm.cadwolf_fileInfo.item_data.settings.dates.startMonth;
			vm.startDay = vm.cadwolf_fileInfo.item_data.settings.dates.startDay;
			vm.endYear = vm.cadwolf_fileInfo.item_data.settings.dates.endYear;
			vm.endMonth = vm.cadwolf_fileInfo.item_data.settings.dates.endMonth;
			vm.endDay = vm.cadwolf_fileInfo.item_data.settings.dates.endDay;
			

		};


















		/*
		 *
		 * Populate the arrays 
		 *
		 */
		function populateDates( ) 
		{

			// Clear the arrays
			vm.yearArray = [];
			vm.monthArray = [];
			vm.dayArray = [];


			//console.log('In populate dates with start and ends of '+vm.startDay+' - '+vm.startMonth+' - '+vm.startYear+' : '+vm.endDay+' - '+vm.endMonth+' - '+vm.endYear);


			if ( vm.startYear == vm.endYear )
			{

				var dayCount = 0;

				for (var b=vm.startMonth; b<=vm.endMonth; b++)
				{

					if ( b == vm.startMonth )
					{

						var monthObj={
							name:vm.months[b],
							width:(vm.days[b]-vm.startDay+1)*vm.dayColWidth,
							dayCount: dayCount
						}
						vm.monthArray.push(monthObj);


						var tempCount = 0;
						for (var c=vm.startDay; c<=vm.days[b]; c++)
						{
							vm.dayArray.push(c);
							tempCount=tempCount+1;
						}

						dayCount=parseInt(dayCount)+parseInt(tempCount);

					}else if ( b == vm.endMonth )
					{


						var monthObj={
							name:vm.months[b],
							width:vm.endDay*vm.dayColWidth,
							dayCount: dayCount
						}
						vm.monthArray.push(monthObj);


						var tempCount = 0;
						for (var c=1; c<=vm.endDay; c++)
						{
							vm.dayArray.push(c);
							tempCount=tempCount+1;
						}

						dayCount=parseInt(dayCount)+parseInt(tempCount);


					}else
					{

						var monthObj={
							name:vm.months[b],
							width:vm.days[b]*vm.dayColWidth,
							dayCount: dayCount
						}

						vm.monthArray.push(monthObj);

						for (var c=1; c<=vm.days[b]; c++)
						{
							vm.dayArray.push(c);
						}

						dayCount=parseInt(dayCount)+parseInt(vm.days[b]);
					}
	
				}

				var yearWidth =  parseInt(dayCount) * parseInt(vm.dayColWidth);

				var yearObj={
					name:vm.startYear,
					width: yearWidth,
					dayCount: dayCount
				}
				vm.yearArray.push(yearObj);

			}else
			{

				for (var a=vm.startYear; a<=vm.endYear; a++)
				{

					var dayCount = 0;

					if ( a == vm.startYear )
					{
						for (var b=vm.startMonth; b<12; b++)
						{

							if ( b == vm.startMonth )
							{

								var monthObj={
									name:vm.months[b],
									width:(vm.days[b]-vm.startDay+1)*vm.dayColWidth,
									dayCount: dayCount
								}
								vm.monthArray.push(monthObj);

								var tempCount = 0;
								for (var c=vm.startDay; c<=vm.days[b]; c++)
								{
									vm.dayArray.push(c);
									tempCount=tempCount+1;
								}

								dayCount=parseInt(dayCount)+parseInt(tempCount);

							}else if ( b == vm.endMonth )
							{

								var monthObj={
									name:vm.months[b],
									width:vm.endDay*vm.dayColWidth,
									dayCount: dayCount
								}
								vm.monthArray.push(monthObj);

								var tempCount = 0;
								for (var c=1; c<=vm.endDay; c++)
								{
									vm.dayArray.push(c);
									tempCount=tempCount+1;
								}

								dayCount=parseInt(dayCount)+parseInt(tempCount);

							}else
							{


								var monthObj={
									name:vm.months[b],
									width:vm.days[b]*vm.dayColWidth,
									dayCount: dayCount
								}
								vm.monthArray.push(monthObj);

								for (var c=1; c<=vm.days[b]; c++)
								{
									vm.dayArray.push(c);
								}

								dayCount=parseInt(dayCount)+parseInt(vm.days[b]);
							}
						}

					}else if ( a == vm.endYear )
					{

						for (var b=0; b<vm.endMonth; b++)
						{
							var monthObj={
								name:vm.months[b],
								width:vm.days[b]*vm.dayColWidth,
								dayCount: dayCount
							}
							vm.monthArray.push(monthObj);

							for (var c=1; c<=vm.days[b]; c++)
							{
								vm.dayArray.push(c);
							}

							dayCount=parseInt(dayCount)+parseInt(vm.days[b]);
						}


						var monthObj={
							name:vm.months[vm.endMonth],
							width:vm.endDay*vm.dayColWidth,
							dayCount: dayCount
						}
						vm.monthArray.push(monthObj);

						for (var c=1; c<=vm.endDay; c++)
						{
							vm.dayArray.push(c);
						}

						dayCount=parseInt(dayCount)+parseInt(vm.endDay);


					}else
					{

						for (var b=0; b<11; b++)
						{
							var monthObj={
								name:vm.months[b],
								width:vm.days[b]*vm.dayColWidth,
								dayCount: dayCount
							}
							vm.monthArray.push(monthObj);

							for (var c=1; c<=vm.days[b]; c++)
							{
								vm.dayArray.push(c);
							}

							dayCount=parseInt(dayCount)+parseInt(vm.days[b]);
						}

					}
	
					var yearWidth =  parseInt(dayCount) * parseInt(vm.dayColWidth);

					var yearObj={
						name:a,
						width: yearWidth,
						dayCount: dayCount
					}
					vm.yearArray.push(yearObj);

				}

			}

		};


















		/*
		 *
		 * Find the days since the beginning and width of the event
		 *
		 */
		function calcEventDays( ) 
		{
			
			vm.cadwolf_fileInfo.events.forEach(
				function(thisEvent, eventIndex){


					// For notes and signoff activity, the activity is one day
					if ( ( thisEvent.item_data.eventType == "Note" ) ||
						 ( thisEvent.item_data.eventType == "Signoff Activity" ) )
					{
						thisEvent.item_data.eventEnd = new Date( thisEvent.item_data.eventStart);
					}



					// If pulled from the database, this will be a string
					if ( typeof(thisEvent.item_data.eventStart) == "string" )
					{
						thisEvent.item_data.eventStart = new Date( thisEvent.item_data.eventStart );
					}
					if ( typeof(thisEvent.item_data.eventEnd) == "string" )
					{
						thisEvent.item_data.eventEnd = new Date( thisEvent.item_data.eventEnd );
					}

					// Get the event year, month, and day of the start date
					if ( ( thisEvent.item_data.eventStart !== undefined ) && 
						 ( thisEvent.item_data.eventStart !== '' ) &&
						 ( thisEvent.item_data.eventStart !== null ) )
					{
						var eventYear = parseInt(thisEvent.item_data.eventStart.getFullYear());
						var eventMonth = parseInt(thisEvent.item_data.eventStart.getMonth());
						var eventDay = parseInt(thisEvent.item_data.eventStart.getDate());

						thisEvent.item_data.eventStartYear = eventYear;
						thisEvent.item_data.eventStartMonth = eventMonth;
						thisEvent.item_data.eventStartDay = eventDay;

						thisEvent.item_data.eventStartShowMonth = vm.months[thisEvent.item_data.eventStartMonth];
					}



					if ( ( thisEvent.item_data.eventEnd !== undefined ) && 
						 ( thisEvent.item_data.eventEnd !== '' ) &&
						 ( thisEvent.item_data.eventEnd !== null ) )
					{
						var endYear = parseInt(thisEvent.item_data.eventEnd.getFullYear());
						var endMonth = parseInt(thisEvent.item_data.eventEnd.getMonth());
						var endDay = parseInt(thisEvent.item_data.eventEnd.getDate());



						thisEvent.item_data.eventEndYear = endYear;
						thisEvent.item_data.eventEndMonth = endMonth;
						thisEvent.item_data.eventEndDay = endDay;

						thisEvent.item_data.eventEndShowMonth = vm.months[thisEvent.item_data.eventEndMonth];
					}


					if ( ( thisEvent.item_data.eventStart !== undefined ) && 
						 ( thisEvent.item_data.eventStart !== '' ) )
					{
						thisEvent.item_data.eventDayCount = vm.calcDaysBetween(vm.startYear, vm.startMonth, vm.startDay, eventYear, eventMonth, eventDay);

						if ( ( thisEvent.item_data.eventEnd !== undefined ) && 
							 ( thisEvent.item_data.eventEnd !== '' ) )
						{
							thisEvent.item_data.eventDayLength = vm.calcDaysBetween(eventYear, eventMonth, eventDay, endYear, endMonth, endDay);
						}
					}

			});

		}















		/*
		 *
		 * Calculate the widths of all items
		 *
		 */
		function calcWidths( ) 
		{

			//console.log('In the calc width function');

			var totalWidth = 0;

			// Reset the year array
			vm.yearArray.forEach(
				function(thisYear, yearIndex){
					thisYear.width = thisYear.dayCount * vm.dayColWidth;
					totalWidth = totalWidth + thisYear.width;
				}
			);


			// Set the width of the total window
			vm.totalWidth = totalWidth;



			// Reset the logs
			vm.cadwolf_fileInfo.item_data.items.forEach(
				function(thisItem, itemIndex){

				thisItem.logData.forEach(
					function(thisLog, logIndex){

						thisLog.offset = thisLog.dayCount * vm.dayColWidth;

					}
				);

			});



			// Reset the events
			vm.cadwolf_fileInfo.events.forEach(
				function(thisEvent, eventIndex){

					thisEvent.item_data.eventOffset = (thisEvent.item_data.eventDayCount-1) * vm.dayColWidth;
					thisEvent.item_data.eventWidth = thisEvent.item_data.eventDayLength * vm.dayColWidth;

			});

		};




















		/*
		 *
		 * Get the requirements from all docs
		 *
		 */
		function getRequirements( ) 
		{

			// Create an array holding the files ids
			var fileArray = [];
			vm.cadwolf_fileInfo.items.forEach(
				function(thisItem, itemIndex){
			
					fileArray[itemIndex] = thisItem['item_data']['fileData']['id'];

				}
			);

			var arrayText = JSON.stringify( fileArray );

			$http({
				method: "GET",
				url: window.location.origin+'/requirements',
				params: { fileArray : arrayText }

			}).then(function successCallback( returnData ) 
			{

				vm.requirements = returnData.data;

				vm.requirements.forEach(
					function(thisItem, itemIndex){

						thisItem.content = JSON.parse(thisItem.content);

					}
				);


			});

		}













		/*
		 *
		 * Get the tasks and questions for this workflow
		 *
		 */
		function getDiscs( ) 
		{

			if ( vm.questions === undefined )
			{
				vm.questions = [];
			}

			if ( vm.tasks === undefined )
			{
				vm.tasks = [];
			}


			$http({
				method: "GET",
				url: window.location.origin+'/discussions/'+vm.cadwolf_fileInfo.id

			}).then(function successCallback( returnData ) 
			{
				console.log('The tasks and questions are ...');
				console.log(returnData);

				vm.tasks = [];
				vm.questions = [];

				returnData.data.forEach(
					function(thisItem, itemIndex){
				
						if ( typeof( thisItem.item_data ) == "string" )
						{
							thisItem.item_data = JSON.parse( thisItem.item_data );
						}

						if ( thisItem.item_data.type == "question" )
						{
							vm.questions.push( thisItem );
						}

						if ( thisItem.item_data.type == "task" )
						{
							vm.tasks.push( thisItem );
						}

					}
				);


			});

		}














		/*
		 *
		 * Get the log data for an item
		 *
		 */
		function getLogData( fileID ) 
		{
			
			$http({
				method: "GET",
				url: window.location.origin+'/logs/'+fileID

			}).then(function successCallback( returnData ) 
			{

				var myID=0;

				// Place the log data in the file info
				vm.cadwolf_fileInfo.items.forEach(
					function(thisItem, itemIndex){

						if ( thisItem.item_data.fileData.id == fileID )
						{
							myID = thisItem.id;
							thisItem.item_data.logData = returnData.data;
						}

				});



				// Set the locations for all log data
				vm.calcLogDays();

				// Set the widths
				vm.calcWidths( );

				
				// Update the workflow item
				vm.updateItem( myID );


				vm.updateWorkflow( );


			});

		}



		/*
		 *
		 * Check Update Status for an item
		 *
		 */
		function checkUpdateStatus( fileID ) 
		{
			console.log('In the check Update status function. with '+fileID);

		}



















		/*
		 *
		 * Set the locations of the log data
		 *
		 */
		function calcLogDays( ) 
		{
			
			// Loop through the logData and set the x location 
			// based upon the date of the event and the start date

			vm.cadwolf_fileInfo.items.forEach(
				function(thisItem, itemIndex){


				if ( thisItem.item_data.logData !== undefined )
				{
					thisItem.item_data.logData.forEach(
						function(thisLog, logIndex){

							// Get the log year, month, and day
							var logInfo = thisLog.created_at.split('-');
							var logYear = parseInt(logInfo[0]);
							var logMonth = parseInt(logInfo[1])-1;
							var logDay = parseInt(logInfo[2]);

							thisLog.dayCount = vm.calcDaysBetween(vm.startYear, vm.startMonth, vm.startDay, logYear, logMonth, logDay);


							// Place the icon at the center of appropriate day
							thisLog.offset = ( ( thisLog.dayCount-1) * vm.dayColWidth );

						}
					);
				}

			});


		}















		/*
		*
		*   Update the workflow in the databases
		*
		*/
		function updateWorkflow( )
		{   

			if (vm.editPerm)
			{

				$http({
					method: "PUT",
					url: window.location.origin+'/files/'+vm.cadwolf_fileInfo.id,
					data: { name : vm.cadwolf_fileInfo.name,
							parent_id : parseInt(vm.cadwolf_fileInfo.parent_id, 10),
							item_data : vm.cadwolf_fileInfo.item_data
						  }
				}).then(function successCallback( returnData ) 
				{

				}, function errorCallback( returnData ) {});

			}


		}













		/*
		*
		*   Delete an item in the databases
		*
		*/
		function deleteItem( itemID )
		{   


			console.log('In the delete item function with '+itemID);

			vm.cadwolf_fileInfo.items.forEach(
				function(thisItem, itemIndex){

					if ( thisItem.id == itemID )
					{

						// Update the event in the database
						$http({
							method: "DELETE",
							url: window.location.origin+'/items/'+itemID

						}).then(function successCallback( returnData ) 
						{
						
						});

						vm.cadwolf_fileInfo.items.splice(itemIndex,1);

					}

				}
			);

		}















		/*
		*
		*   Delete an item in the databases
		*
		*/
		function deleteTask( itemID )
		{   


			console.log('In the delete task function with '+itemID);

			vm.tasks.forEach(
				function(thisItem, itemIndex){

					if ( thisItem.id == itemID )
					{

						// Update the event in the database
						$http({
							method: "DELETE",
							url: window.location.origin+'/discussions/'+itemID

						}).then(function successCallback( returnData ) 
						{
						
						});

						vm.tasks.splice(itemIndex,1);

					}

				}
			);

		}




		/*
		*
		*   Delete an item in the databases
		*
		*/
		function deleteQuestion( itemID )
		{   


			console.log('In the delete question function with '+itemID);

			vm.questions.forEach(
				function(thisItem, itemIndex){

					if ( thisItem.id == itemID )
					{

						// Update the event in the database
						$http({
							method: "DELETE",
							url: window.location.origin+'/discussions/'+itemID

						}).then(function successCallback( returnData ) 
						{
						
						});

						vm.questions.splice(itemIndex,1);

					}

				}
			);

		}











		/*
		 *
		 * Worker function that takes in start and end year, month, day and finds difference in days
		 *
		 */
		function calcDaysBetween( startYear, startMonth, startDay, endYear, endMonth, endDay) 
		{

			//console.log('In calc between days with '+startYear+' - '+startMonth+' - '+startDay+' && '+endYear+' - '+endMonth+' - '+endDay);

			//Check to make sure the start date isn't before the return date
			if ( ( endYear < startYear ) || ( endYear > vm.endYear ) || ( startYear < vm.startYear ) )
			{
				return -1
			}

			if ( ( endYear == startYear ) && ( endMonth < startMonth ) )
			{
				return -1
			}

			if ( ( endYear == startYear ) && ( endMonth == startMonth ) && ( endDay < startDay ) )
			{
				return -1
			}

			if ( ( ( endYear == vm.endYear ) && ( endMonth > vm.endMonth ) ) ||
				 ( ( endYear == vm.endYear ) && ( endMonth == vm.endMonth ) && ( endDay > vm.endDay ) ) ||
				 ( ( startYear == vm.startYear ) && ( startMonth < vm.startMonth ) ) ||
				 ( ( startYear == vm.startYear ) && ( startMonth == vm.startMonth ) && ( startDay < vm.startDay ) ) )
			{
				return -1
			} 


			// If the start and end days are the same, return 1
			if ( (startYear == endYear) &&
				 (startMonth == endMonth ) &&
				 (startDay == endDay ) )
			{
				return 1
			}
			
			// Start the day count with the days in the current month
			var dayCount = parseInt(endDay);


			// If this takes place in same year, find month and day difference
			if ( startYear == endYear )
			{

				if ( startMonth == endMonth )
				{
					dayCount = dayCount - startDay + 1;
				
				}else
				{

					for (var b=startMonth; b<endMonth; b++)
					{

						dayCount=parseInt(dayCount)+parseInt(vm.days[b]);

					}

					// Subtract the initial day
					dayCount = dayCount - startDay + 1;
				}

			// If years don't match, find solution for start and between years
			}else
			{

				for (var a=startYear; a<=endYear; a++)
				{

					// In the start year, add all days between the start day and end of year
					if ( a == startYear )
					{
						for (var b=startMonth; b<12; b++)
						{
							dayCount=parseInt(dayCount)+parseInt(vm.days[b]);
						}

						// Subtract the initial day
						dayCount = dayCount - startDay+1;

					// In end year, add all days from start to current
					}else if ( a == endYear )
					{

						for (var b=0; b<endMonth; b++)
						{
							dayCount=parseInt(dayCount)+parseInt(vm.days[b]);
						}

					// In years between start and end, add all days
					}else
					{

						for (var b=0; b<11; b++)
						{
							dayCount=parseInt(dayCount)+parseInt(vm.days[b]);
						}

					}
	
				}

			}

			//console.log('Returning '+dayCount);
			return dayCount

		}










		/*
		 *
		 * Set the permissions at the onset of file
		 *
		 */
		function setPermLevels( returnData )
		{   


			// This checks to see if the user has permission
			// to edit the entire workflow
			if ( returnData.data.permissions.edit == 1 )
			{
				vm.editPerm = true;
			}else
			{
				vm.editPerm = false;
			}


			// This checks to see if the user has permissions
			// to edit any document
			vm.conditionalEdit = false;
			vm.cadwolf_fileInfo.item_data.permissions.forEach(
				function(thisPerm, permIndex){

					if ( thisPerm.permAssigneeID == Spark.state.user.id )
					{
						vm.conditionalEdit = true;
					}
				}
			);

		}
















		/*
		 *
		 * Set the permissions
		 *
		 */
		function setPermissions( )
		{   

			//console.log('In the set permissions function');

			// Align the permissions
			vm.cadwolf_fileInfo.items.forEach(
				function(thisItem, itemIndex){

					thisItem.item_data.permission = false;

					vm.cadwolf_fileInfo.item_data.permissions.forEach(
						function(thisPerm, permIndex){

							if ( thisPerm.permDocID == thisItem.doc_id )
							{
								thisItem.item_data.permission = true;
							}
						}
					);
				}
			);
		}



















		/*
		 *
		 * Roll Versions
		 *
		 */
		function rollVersions( thisEvent )
		{   
			// Double check that all signoffs have been met
			var flag = 0;
			vm.cadwolf_fileInfo.signoffs.forEach(
				function(thisSignoff, signoffIndex){

					if ( thisSignoff.signoffEventID == thisEvent.id )
					{
						if ( !thisSignoff.signoffStatus )
						{
							flag = 1;
						}
					}

				}
			);

			if ( flag == 1 )
			{
				thisEvent.item_data.signoffStatus = false;
			}



			if ( flag == 0 )
			{

				// Call the function to roll all files
				$http({
					method: "PUT",
					url: window.location.origin+'/rollVersions/'+vm.cadwolf_fileInfo.id
				}).then(function successCallback( returnData ) 
				{

				}, function errorCallback( returnData ) {});


			}

		}




























		/*
		 *
		 * The digest to keep all items in sync
		 *
		 */
		function runEventDigest( )
		{   

			//console.log('In the run event digest function');


			// Order the events by date and set any version differences
			// Get the last time diff (date) where an
			vm.versionTimeDiff = 0;
			vm.cadwolf_fileInfo.events.forEach(
				function(thisEvent, eventIndex){

					// Set timeDiff
					thisEvent.timeDiff = new Date() - new Date(thisEvent.item_data.eventStart);
					
					// If this is a version changer and it is set, see if it is latest
					if ( ( thisEvent.timeDiff > vm.versionTimeDiff ) &&
						 ( thisEvent.eventVersionChanger ) &&
						 ( thisEvent.eventStatus ) )
					{
						vm.versionTimeDiff = JSON.parse(JSON.stringify(thisEvent.timeDiff));
					}

				}
			);
			vm.cadwolf_fileInfo.events = vm.cadwolf_fileInfo.events.sort(utilityFactory.dynamicSort("timeDiff"));


			// Version setters
			var currentVersion = 1;
			vm.cadwolf_fileInfo.events.forEach(
				function(thisEvent, eventIndex){

					if ( thisEvent.item_data.eventVersionChanger )
					{
						thisEvent.item_data.eventPreVersion = parseInt( parseInt(currentVersion) + 1 - 1);
						thisEvent.item_data.eventPostVersion = parseInt( parseInt(currentVersion) + 1 );

						currentVersion = parseInt( parseInt(currentVersion) + 1 );
					}

				}
			);



			// Check the events to see if any overlap happens and then set the class appropriately
			vm.cadwolf_fileInfo.events.forEach(
				function(thisEvent, eventIndex){

					thisEvent.item_data.eventsInItems = [];		// The number of events for each event, for each item
					thisEvent.item_data.eventItemHeight = [];	// The height of each event for each item
					thisEvent.item_data.eventVertOffset = [];	// The vertical offset for each item
					thisEvent.item_data.eventConflict = [];		// The number of conflicts with this item

					// Prepopulate item and event specific heights
					vm.cadwolf_fileInfo.items.forEach(
						function(thisItem, itemIndex){

							thisEvent.item_data.eventsInItems[thisItem.doc_id] = 1;
							thisEvent.item_data.eventItemHeight[thisItem.doc_id] = 40;
							thisEvent.item_data.eventVertOffset[thisItem.doc_id] = 0;
							thisEvent.item_data.eventConflict[thisItem.doc_id] = 0;
						}
					);	
				}
			);

			vm.cadwolf_fileInfo.events.forEach(
				function(firstEvent, firstIndex){

					var conflictCount = 1;

					vm.cadwolf_fileInfo.events.forEach(
						function(secondEvent, secondIndex){
						
							// If the two events occupy the same space
							if ( ( secondEvent.item_data.eventOffset > firstEvent.item_data.eventOffset ) &&
								 ( secondEvent.item_data.eventOffset < ( firstEvent.item_data.eventOffset + firstEvent.item_data.eventWidth ) ) )
							{

								// Check to ensure that they occupy the same item
								firstEvent.item_data.eventFiles.forEach(
									function(firstFile, firstFileIndex){

										secondEvent.item_data.eventFiles.forEach(
											function(secondFile, secondFileIndex){

												if ( firstFile.eventDocID == secondFile.eventDocID )
												{
													firstEvent.item_data.eventsInItems[firstFile.eventDocID] = firstEvent.item_data.eventsInItems[firstFile.eventDocID] + 1;
													secondEvent.item_data.eventsInItems[firstFile.eventDocID] = secondEvent.item_data.eventsInItems[firstFile.eventDocID] + 1;
													secondEvent.item_data.eventConflict[firstFile.eventDocID] = conflictCount;
													conflictCount = conflictCount + 1;
												}
											}
										);
									}
								)
							}
						}
					);
				}
			);



			// Set the thickness and vertical offsets of events
			var vertOffset = 0;
			vm.cadwolf_fileInfo.events.forEach(
				function(firstEvent, firstIndex){

					var offsetIndex = 1;

					firstEvent.item_data.eventFiles.forEach(
						function(firstFile, firstFileIndex){

							firstEvent.item_data.eventItemHeight[firstFile.eventDocID] = Math.floor( 40 / firstEvent.item_data.eventsInItems[firstFile.eventDocID] );
							firstEvent.item_data.eventVertOffset[firstFile.eventDocID] = firstEvent.item_data.eventItemHeight[firstFile.eventDocID] * firstEvent.item_data.eventConflict[firstFile.eventDocID];
						}
					);
				}
			);





			// Align the permissions
			vm.cadwolf_fileInfo.items.forEach(
				function(thisItem, itemIndex){

					// Set the bit to show the title for some items and events
					if ( itemIndex % 4 == 0 )
					{
						thisItem.showLabel = true;
					}else
					{
						thisItem.showLabel = false;
					}

					thisItem.item_data.permission = false;

					vm.cadwolf_fileInfo.item_data.permissions.forEach(
						function(thisPerm, permIndex){

							if ( thisPerm.permDocID == thisItem.doc_id )
							{
								thisItem.item_data.permission = true;
							}
						}
					);
				}
			);



			// Align the names of the signoff events and docs
			vm.cadwolf_fileInfo.signoffs.forEach(
				function(thisSignoff, signoffIndex){

					if ( thisSignoff.item_data.signoffDueDate != "" )
					{
						thisSignoff.item_data.signoffDueYear = new Date(thisSignoff.item_data.signoffDueDate).getFullYear();
						thisSignoff.item_data.signoffDueMonth = new Date(thisSignoff.item_data.signoffDueDate).getMonth();
						thisSignoff.item_data.signoffDueDay = new Date(thisSignoff.item_data.signoffDueDate).getDate();
					}


					vm.cadwolf_fileInfo.events.forEach(
						function(thisEvent, eventIndex){

							if ( thisEvent.id == thisSignoff.item_data.signoffEventID )
							{
								thisSignoff.item_data.signoffEventTitle = thisEvent.item_data.eventTitle;
								thisSignoff.item_data.signoffEventColor = thisEvent.item_data.eventColor;

								// Set the event ids of the signoffs
								thisSignoff.event_id = thisEvent.id;
								thisSignoff.event_item_id = thisEvent.item_id;
								thisSignoff.item_data.signoffEventID = thisEvent.id;
								thisSignoff.item_data.signoffEventItemID = thisEvent.item_id;
							}
						}
					);

					vm.cadwolf_fileInfo.item_data.roles.forEach(
						function(thisRole, roleIndex){

							if ( thisRole.roleID == thisSignoff.item_data.signoffAssigneeRoleID )
							{
								thisSignoff.item_data.signoffAssigneeRoleTitle = thisRole.roleTitle;
							}
						}
					);


					vm.cadwolf_fileInfo.item_data.userRoles.forEach(
						function(thisUserRole, userRoleIndex){

							if ( thisUserRole.userID == thisSignoff.item_data.signoffAssigneeID )
							{
								thisSignoff.item_data.signoffAssigneeName = thisUserRole.userName;
								thisSignoff.item_data.signoffAssigneePhoto = thisUserRole.userPhoto;
								thisSignoff.item_data.signoffAssigneeUserName = thisUserRole.userUserName;
							}
						}
					);



					vm.cadwolf_fileInfo.item_data.items.forEach(
						function(thisItem, itemIndex){

							if ( thisItem.fileData.id == thisSignoff.item_data.signoffDocID )
							{
								thisSignoff.item_data.signoffDocTitle = thisItem.fileData.name;
							}
						}
					);

				}
			);



			// CHECK THE STATUS OF EACH EVENT SIGNOFF
			vm.cadwolf_fileInfo.events.forEach(
				function(thisEvent, eventIndex){

					thisEvent.item_data.signoffStatus = false;
					var signoffFlag = 0;

					vm.cadwolf_fileInfo.signoffs.forEach(
						function(thisSignoff, signoffIndex){

							if ( ( thisSignoff.item_data.signoffEventID == thisEvent.id ) &&
								 ( !thisSignoff.item_data.signoffStatus ) )
							{
								signoffFlag = 1;
							}

						}
					);

					if ( signoffFlag == 0 )
					{
						thisEvent.item_data.signoffStatus = true;
					}

				}
			);





			// If an event takes place before an event that is a version changer and that event has already
			// been locked down so that the version has already been rolled, then this event cannot be a 
			// version changer
			vm.cadwolf_fileInfo.events.forEach(
				function(thisEvent, eventIndex){

					if ( thisEvent.timeDiff < vm.versionTimeDiff )
					{
						if ( thisEvent.timeDiff > timeDiff )
						{
							thisEvent.item_data.eventDisallowed = true;
						}
					}

				}
			);


		}



















		//////////


		vm.months = [];
		vm.months[0] = "January";
		vm.months[1] = "February";
		vm.months[2] = "March";
		vm.months[3] = "April";
		vm.months[4] = "May";
		vm.months[5] = "June";
		vm.months[6] = "July";
		vm.months[7] = "August";
		vm.months[8] = "September";
		vm.months[9] = "October";
		vm.months[10] = "November";
		vm.months[11] = "December";


		vm.days = [];
		vm.days[0] = 31;
		vm.days[1] = 28;
		vm.days[2] = 31;
		vm.days[3] = 30;
		vm.days[4] = 31;
		vm.days[5] = 30;
		vm.days[6] = 31;
		vm.days[7] = 31;
		vm.days[8] = 30;
		vm.days[9] = 31;
		vm.days[10] = 30;
		vm.days[11] = 31;



		vm.monthFind = [];
		vm.monthFind['Jan'] = 0;
		vm.monthFind['Feb'] = 1;
		vm.monthFind['Mar'] = 2;
		vm.monthFind['Apr'] = 3;
		vm.monthFind['May'] = 4;
		vm.monthFind['Jun'] = 5;
		vm.monthFind['Jul'] = 6;
		vm.monthFind['Aug'] = 7;
		vm.monthFind['Sep'] = 8;
		vm.monthFind['Oct'] = 9;
		vm.monthFind['Nov'] = 10;
		vm.monthFind['Dec'] = 11;



		vm.eventTypes = [];
		vm.eventTypes[0] = 'Note';
		vm.eventTypes[1] = 'Meeting';
		vm.eventTypes[2] = 'Testing';
		vm.eventTypes[3] = 'Design Review'; 
		vm.eventTypes[4] = 'Integration Review'; 
		vm.eventTypes[5] = 'Signoff Activity';
		vm.eventTypes[6] = 'Other';



		vm.varType = [];
		vm.varType[1]="Text Block" 
		vm.varType[2]="Header" 
		vm.varType[3]="Equation" 
		vm.varType[4]="Symbolic Equation" 
		vm.varType[5]="" 
		vm.varType[6]="For Loop" 
		vm.varType[7]="While Loop" 
		vm.varType[8]="If Else Statement" 
		vm.varType[9]="Plot" 
		vm.varType[10]="Image" 
		vm.varType[11]="Line Break" 
		vm.varType[12]="Video" 
		vm.varType[13]="Three D Plot" 
		vm.varType[14]="" 
		vm.varType[15]="Card" 
		vm.varType[16]="Free Body Diagram" 



		vm.initialize();

	}

})();

(function ()
{
    'use strict';

    angular
        .module('app.unit')
        .controller('UnitController', UnitController);

    /** @ngInject */
    function UnitController(unitConstantFactory)
    {
        var vm = this;

        // Data
        vm.unitData = unitConstantFactory.unitsObj();
        MathJax.Hub.Configured();
        MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
        console.log('The number of units are '+vm.unitData.length);

        // Methods

        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.teams', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $locationProvider)
    {

        // State
        $stateProvider.state('app.teams', {
            // url      : '/Team/{path:.*}/',
            url      : '/Team{path:.*}',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/teams/teams.html',
                    controller : 'TeamsController as vm'
                }
            },
            bodyClass: 'teams'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/teams');

        // Navigation
        msNavigationServiceProvider.saveItem('teams', {
            title : 'Teams',
            icon  : 'icon-account-multiple',
            state : 'app.teams',
            weight: 7
        });
    }

})();
(function ()
{
	'use strict';

	angular
		.module('app.teams')
		.controller('TeamsController', TeamsController);

	/** @ngInject */
	function TeamsController($location, $mdSidenav, $mdDialog, $mdMedia, $sce, utilityFactory, $http)
	{
		// Default Items
		var vm = this;
		window.MY_SCOPE=this;
		vm.showMenuTextTop = true;
		vm.showMenuTextBot = true;
		vm.newMember={};
		vm.newMember.temp='';
		vm.checkStatus=false;
		
		// Methods
		vm.init			 	= init;
		vm.getMemberList	= getMemberList;
		vm.navigateURL	  	= navigateURL;
		vm.getTeamPosition  = getTeamPosition;
		vm.showSmallModal   = showSmallModal;
		vm.cancel		   	= cancel;
		vm.checkMemberName  = checkMemberName;
		vm.getInvitations   = getInvitations;
		vm.inviteUser	   	= inviteUser;
		vm.checkTeamName	= checkTeamName;
		vm.getTeamList	  	= getTeamList;
		vm.saveTeamName	 	= saveTeamName;
		vm.deleteTeam	   	= deleteTeam;
		vm.addTeam		  	= addTeam;
		vm.makeTeamCurrent  = makeTeamCurrent;
		vm.leaveTeam		= leaveTeam;
		vm.makeAdmin		= makeAdmin;
		vm.removeAdmin 		= removeAdmin;
		vm.deleteTeamMember = deleteTeamMember;
		vm.deleteInvitation = deleteInvitation;
		vm.getSparkData 	= getSparkData;
		vm.uploadTeamImage 	= uploadTeamImage;
		//////////




		vm.init();








		/**
		 *
		 *  Initial program - get the teams
		 *
		 */
		function init()
		{
            // Set the host for staging or production
            vm.thisHost = window.location.host;

			console.log('In the init function');
			vm.showType = 'teamList';
			vm.thisTeam = window.location.href.replace(window.location.origin+'/Team/', '');
			vm.thisTeam = vm.thisTeam.replace(/\/$/, '').replace(/\%20/, ' ');
			console.log('Looking for '+vm.thisTeam);
			if (vm.thisTeam != '')
			{
				vm.showType = 'memberList';
				vm.getMemberList( vm.thisTeam );
			}
			vm.getSparkData();
		}



		/**
		 * Select an item
		 *
		 * @param item
		 */
		function select(item)
		{
			vm.selected = item;
		}









		/**
		 *
		 *  Get the User Spark Data
		 *
		 */
		function getSparkData()
		{
			console.log('In the get spark data function');
			$http({
			  method: 'GET',
			  url: '/user/current'
			}).then(function successCallback( returnData ) {
					console.log('The user data is ');
					console.log(returnData.data);
					Spark.state.user = returnData.data;

			  }, function errorCallback( returnData ) {
			});

		}












		/**
		 *
		 *  Get the members of a team
		 *
		 */
		function getMemberList( thisTeam )
		{
			console.log('This team is '+thisTeam)
			thisTeam=''+thisTeam;
			console.log('This team is '+thisTeam)
			var flag=0;
			for (var a=0; a<Spark.state.user.teams.length; a++)
			{
				if ((Spark.state.user.teams[a]['name'] == thisTeam.replace(/_/g,' '))||
					(Spark.state.user.teams[a]['id'] == thisTeam))
				{
					vm.getInvitations( Spark.state.user.teams[a]['id'] )
					var teamURL =  window.location.origin+'/settings/teams/json/'+Spark.state.user.teams[a]['id'];
					$http({
					  method: 'GET',
					  url: teamURL
					}).then(function successCallback( returnData ) {
							console.log('Return data is ');
							console.log(returnData.data);
							vm.teamData = returnData.data;
					  }, function errorCallback( returnData ) {
					});
				}
			}
			if (flag==0)
			{
				vm.teamData = {};
				vm.teamData.users=[]
			}
		}












		/*
		 *
		 * Leave a team
		 *
		 */
		function leaveTeam( thisTeam ) 
		{
			$http({
				method: "DELETE",
				url: window.location.origin+'/settings/teams/'+thisTeam['id']+'/members/'+Spark.state.user.id,
			}).then(function successCallback( returnData ) {
				vm.getSparkData();
			}, function errorCallback( returnData ) {});
		};


















		/**
		 *
		 * Navigate to a new file, folder, etc
		 *
		 */
		function navigateURL( fileItem, type )
		{
			var thisURL=utilityFactory.makeURL( fileItem, type );

			if ((type=='settings') || (type=='userSettings'))
			{
				window.location.href=thisURL;
			}else
			{
				$location.path(thisURL.replace(window.location.origin+'',''));
			}
		}



















		/**
		 * Get the users position on a team
		 *
		 * @param item
		 */
		function getTeamPosition( thisTeam )
		{
			var myRole='none';
			for (var a=0; a<Spark.state.user.teams.length; a++)
			{
				if (Spark.state.user.teams[a]['id'] == thisTeam['id'] ) 
				{
					myRole = Spark.state.user.teams[a]['pivot']['role'];
				}
			}
			return myRole;
		}









		/**
		 * Check to see that member name is unique
		 *
		 * @param item
		 */
		function checkMemberName( memberName )
		{
			$http({
			  method: 'GET',
			  url: window.location.origin+'/checkMember/',
			  params:{ memberName : memberName }
			}).then(function successCallback( returnData ) {
					console.log('Return data is ');
					console.log(returnData);
					vm.checkStatus=returnData.data.checkStatus;
					vm.inviteMember=returnData.data.member;
			  }, function errorCallback( returnData ) {
			});			
		}


		/**
		 * Get the invitations for a team
		 *
		 * @param id of team
		 */
		function getInvitations( team )
		{
			$http({
			  method: 'GET',
			  url: window.location.origin+'/settings/teams/'+team+'/invitations/'
			}).then(function successCallback( returnData ) {
					console.log('Return data for getinvitations is ');
					console.log(returnData);
					vm.teamInvites=returnData.data;
					vm.teamInvites.forEach(function(thisItem, index)
					{  
						var thisDate = thisItem['created_at'].split(' ');
						thisItem['created_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
						var thisDate = thisItem['updated_at'].split(' ');
						thisItem['updated_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
					});
			  }, function errorCallback( returnData ) {
			});			
		}


		/**
		 * Get the invitations for a team a team
		 *
		 * @param item
		 */
		function inviteUser( user, team )
		{
			$http({
			  method: 'POST',
			  url: window.location.origin+'/settings/teams/'+team.id+'/invitations',
			  params:{ email : user.email, role : "member" }
			}).then(function successCallback( returnData ) {
					console.log('Return data is ');
					console.log(returnData);
					vm.invitations=returnData.data;
					vm.checkStatus='';
					vm.getInvitations( team.id );
			  }, function errorCallback( returnData ) {
			});			
		}














		/**
		 * Check to see that team name is unique
		 *
		 * @param item
		 */
		function checkTeamName( teamName )
		{
			$http({
			  method: 'GET',
			  url: window.location.origin+'/checkUnique/',
			  params:{ type : 'teamName', teamName : teamName }
			}).then(function successCallback( returnData ) {
					console.log('Return data from check team name is ');
					console.log(returnData);
					vm.checkStatus=(returnData.data=="true");
			  }, function errorCallback( returnData ) {
			});			
		}



		/**
		 * Save the new team name
		 *
		 * @param item
		 */
		function saveTeamName( team, newName )
		{
			$http({
			  method: 'PUT',
			  url: window.location.origin+'/settings/teams/'+team.id+'/name/',
			  params:{ name : newName }
			}).then(function successCallback( returnData ) {
				vm.getTeamList();
			}, function errorCallback( returnData ) {
			});			
		}

		/**
		 * Get list of teams for the user
		 *
		 * @param item
		 */
		function getTeamList( )
		{
			$http({
			  method: 'GET',
			  url: window.location.origin+'/settings/teams/'
			}).then(function successCallback( returnData ) {
				Spark.state.user.teams=returnData.data;
			}, function errorCallback( returnData ) {
			});			
		}




		/**
		 * Delete a team
		 *
		 * @param item
		 */
		function deleteTeam( thisTeam )
		{
			$http({
			  method: 'DELETE',
			  url: window.location.origin+'/settings/teams/'+thisTeam.id
			}).then(function successCallback( returnData ) {
				vm.getTeamList();
			}, function errorCallback( returnData ) {
			});			
		}



		/**
		 * Delete a user from a team
		 *
		 * @param item
		 */
		function deleteTeamMember( thisMember, thisTeam )
		{
			$http({
			  method: 'DELETE',
			  url: window.location.origin+'/settings/teams/'+thisTeam.id+'/members/'+thisMember.id
			}).then(function successCallback( returnData ) {
				vm.getMemberList( thisTeam.id );
			}, function errorCallback( returnData ) {
			});			
		}



		/*
		 *
		 * Remove Admin Permissions
		 *
		 */
		function removeAdmin( thisMember, thisTeam ) 
		{
			$http({
				method: "PUT",
				url: window.location.origin+'/settings/teams/'+thisTeam.id+'/members/'+thisMember.id,
				data:{ role : 'member' }
			}).then(function successCallback( returnData ) {
					vm.getMemberList(thisTeam.id);
			}, function errorCallback( returnData ) {
					vm.getMemberList(thisTeam.id);				
			});
		};








		/*
		 *
		 * Grant Admin Permissions
		 *
		 */
		function makeAdmin( thisMember, thisTeam ) 
		{
			$http({
				method: "PUT",
				url: window.location.origin+'/settings/teams/'+thisTeam.id+'/members/'+thisMember.id,
				data:{ role : 'owner' }
			}).then(function successCallback( returnData ) {
					vm.getMemberList(thisTeam.id);
			}, function errorCallback( returnData ) {				
					vm.getMemberList(thisTeam.id);
			});
		};










		/**
		 * Add a team
		 *
		 * @param item
		 */
		function addTeam( teamName )
		{
			$http({
			  method: 'POST',
			  url: window.location.origin+'/settings/teams',
			  params:{ name : teamName }
			}).then(function successCallback( returnData ) {
				vm.getTeamList();
			}, function errorCallback( returnData ) {
			});			
		} 







		/**
		 * Change the current team
		 *
		 * @param item
		 */
		function makeTeamCurrent( team )
		{
			$http({
			  method: 'GET',
			  url: window.location.origin+'/settings/teams/'+team.id+'/switch'
			}).then(function successCallback( returnData ) {
				console.log('The return data from the makeTeamCurrent is ...');
				console.log(returnData);
				Spark.state.user.current_team_id=team.id;
			}, function errorCallback( returnData ) {
			});			
		} 












		/**
		 * Delete a team invitation
		 *
		 * @param item
		 */
		function deleteInvitation( invite, team )
		{
			$http({
			  method: 'DELETE',
			  url: window.location.origin+'/settings/invitations/'+invite.id
			}).then(function successCallback( returnData ) {
				vm.getInvitations( team.id );
			}, function errorCallback( returnData ) {
			});			
		}












		/*
		 *
		 * Show the modal dialog
		 *
		 */
		function showSmallModal(ev, modalType, thisItem) 
		{
			vm.modalType = modalType;
			vm.thisItem = thisItem;
			vm.checkStatus='';
			vm.newMember.temp='';
			$mdDialog.show({
				controller: function(){ return vm },
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/teams/views/smallModalTemplates.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {

			}, function() {
				
			});
		};
		function cancel(){
			$mdDialog.cancel();
		};







		/**
		 *
		 * Upload a team Image
		 *
		 */
		function uploadTeamImage( )
		{
			var teamID = vm.teamData.id;
			var fd = new FormData(document.getElementById('uploadFile'+teamID).files[0]);
			var folder = window.location.pathname.replace(/ /g,'_');
			fd.append('folder', folder);
			fd.append('photo', document.getElementById('uploadFile'+teamID).files[0]);
			$http.post(window.location.origin+"/settings/teams/"+teamID+"/photo", fd, {
				withCredentials: true,
				headers: {'Content-Type': undefined },
				transformRequest: angular.identity
			}).then(function successCallback(returnData) {
				console.log(returnData.data);
				vm.getMemberList( teamID );

			}, function errorCallback(returnData) {

			});

		}




	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.surface', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.surface', {
            url      : '/Surface/{path:.*}/',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/surface/surface.html',
                    controller : 'SurfaceController as vm'
                }
            },
            resolve  : {
                Surfaces: function (msApi)
                {
                    return msApi.resolve('surface.documents@get');
                },
                emptySurfaces: function (msApi)
                {
                    return msApi.resolve('surface.emptyList@get');
                }
            },
            bodyClass: 'surface'

        }).state('app.surfaceEmpty', {
            url      : '/Surface/',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/surface/surfaceEmpty.html',
                    controller : 'SurfaceController as vm'
                }
            },
            resolve  : {
                Surfaces: function (msApi)
                {
                    return msApi.resolve('surface.documents@get');
                },
                emptySurfaces: function (msApi)
                {
                    return msApi.resolve('surface.emptyList@get');
                }
            },
            bodyClass: 'surface'
        });



        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/surface');

        // Api
        msApiProvider.register('surface.documents', ['app/data/surface/documents.json']);
        msApiProvider.register('surface.emptyList', ['app/data/surface/emptylist.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('surface', {
            title : 'Surface',
            icon  : 'icon-cube-outline',
            state : 'app.surface',
            weight: 9
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.surface')
        .controller('SurfaceController', SurfaceController);

    /** @ngInject */
    function SurfaceController($mdSidenav, docItemFactory, surfaceFactory, unitConstantFactory, utilityFactory, Surfaces, emptySurfaces)
    {
        var vm = this;

        // Data
        vm.showPlot = true;
        vm.showSpecs  ='3DchartVer';
        vm.emptySurfaces = emptySurfaces.data.previousSurfaces;
        vm.currentItem = Surfaces.data;
        vm.currentItem.Surface.Chart_width = ($(window).width()-300)+'px';
        vm.currentItem.Surface.Chart_height = ($(window).height()-100)+'px';
        vm.currentItem.Surface.needsUpdateFlag = 1;
        if (typeof(Spark.state.user.user_info)=='string')
        {
            Spark.state.user.user_info = JSON.parse( Spark.state.user.user_info );
            Spark.state.user.user_info = utilityFactory.setRecent( 'Workspace', vm.cadwolf_fileInfo, Spark.state.user.user_info, window.location.pathname ); 
            vm.cadwolf_fileInfo.favorite = utilityFactory.checkFavorite( 'Workspace', vm.cadwolf_fileInfo, Spark.state.user.user_info, window.location.pathname );
            vm.updateUserInfo();
        }

window.MY_SCOPE = vm;        

 
         // Methods
        vm.shortcutAction       = shortcutAction;
        vm.favoriteItem         = favoriteItem;
        vm.removeFavItem        = removeFavItem;
        vm.updateUserInfo       = updateUserInfo;


        /*
        *
        *   SHORTCUT FUNCTIONS
        *
        */
        function shortcutAction(actionNum)
        {   
            console.log('The action num is '+actionNum);
            if (actionNum=="1")
            {   
                if (vm.showSpecs == '')
                {
                    vm.showSpecs='chartVer';
                }

                if (vm.showSpecs == 'chartVer')
                {
                    vm.showSpecs='chartHor';
                }

                if (vm.showSpecs == 'chartHor')
                {
                    vm.showSpecs='chartVer';
                }
            }
        };




        /*
         *
         * Make an item a favorite
         *
         */
        function favoriteItem( ) 
        {   
            Spark.state.user.user_info = utilityFactory.favoriteItem( 'Surface', 
                                                                      vm.cadwolf_fileInfo, 
                                                                      Spark.state.user.user_info, 
                                                                      window.location.pathname.replace(/^\/Surface\//,'') ); 
            console.log('The item returned from the factory is '+Spark.state.user.user_info);
            vm.cadwolf_fileInfo.favorite=!vm.cadwolf_fileInfo.favorite; 
            vm.updateUserInfo();
        };





        /*
         *
         * Remove a favorite
         *
         */
        function removeFavItem( thisItem ) 
        {   
            Spark.state.user.user_info = utilityFactory.favoriteItem( 'Surface', 
                                                                      thisItem, 
                                                                      Spark.state.user.user_info, 
                                                                      window.location.pathname.replace(/^\/Surface\//,'') ); 
            vm.updateUserInfo();
        };




        /*
         *
         * Update User Info
         *
         */
        function updateUserInfo( ) 
        {   
            $http({
                method: 'PUT',
                url: window.location.origin+'/updateUserInfo',
                data:{ userID : Spark.state.user.id, thisUser : Spark.state.user.user_info }
            }).then(function successCallback( returnData ) {
            }, function errorCallback( returnData ) {});
        };





    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.profile', [])
        .config(config);


    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $locationProvider)
    {
        $stateProvider.state('app.myprofile', {
            url      : '/Profile/',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/profile/profile.html',
                    controller : 'ProfileController as vm'
                }
            },
            bodyClass: 'profile'
        
        }).state('app.profile', {
            url      : '/Profile/{path:.*}/',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/profile/profile.html',
                    controller : 'ProfileController as vm'
                }
            },
            bodyClass: 'profile'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/profile');

        // Navigation
        msNavigationServiceProvider.saveItem('profile', {
            title : 'Profile',
            icon  : 'icon-account',
            state : 'app.profile',
            weight: 2
        });
    }

})();
(function ()
{
	'use strict';

	angular
		.module('app.profile')
		.controller('ProfileController', ProfileController);

	/** @ngInject */
	function ProfileController(utilityFactory, $mdDialog, $sce, workspaceMemoryFactory, $state, $location, $http)
	{
		var vm = this;
		window.MY_SCOPE=this;
		vm.showMenuTextTop = vm.showMenuTextTop || true;
		vm.showMenuTextBot = vm.showMenuTextBot || true;
		vm.currentEditItem = {};
		vm.showType = 'profileProfile';
		vm.invitations=[];

		// Methods
		vm.init				 	= init;
		vm.select	   			= select;
		vm.getUserWorkspaces	= getUserWorkspaces;
		vm.getWorkspaceData	 	= getWorkspaceData;
		vm.addWorkspace		 	= addWorkspace;
		vm.leftMenuCaller		= leftMenuCaller;
		vm.getUserInfo			= getUserInfo;
		vm.getSparkData 		= getSparkData;
		vm.cancel			   	= cancel;
		vm.acceptChanges		= acceptChanges;
		vm.navigateURL		 	= navigateURL;
		vm.checkOutFile		 	= checkOutFile;
		vm.checkInFile		  	= checkInFile;
		vm.getInvitations	   	= getInvitations;
		vm.getAnnNots		   	= getAnnNots;
		vm.acceptInvitation	 	= acceptInvitation;
		vm.rejectInvitation	 	= rejectInvitation;
		vm.showLargeModal	   	= showLargeModal;
		vm.showSmallModal	   	= showSmallModal;
		vm.checkUsername		= checkUsername;
		vm.changeUsername		= changeUsername;
		vm.uploadImage			= uploadImage;
		vm.markNotAsRead		= markNotAsRead;
		vm.updateUserInfo 		= updateUserInfo;
		vm.getMessages 			= getMessages;
		vm.newMessage 			= newMessage;
		vm.checkMemberName 		= checkMemberName;
		vm.addRecepient 		= addRecepient;
		vm.removeRecepient 		= removeRecepient;
		vm.updateMessage 		= updateMessage;
		vm.sendMessage 			= sendMessage;

		//////////

		vm.init();



		/**
		 *
		 *  Initialization Function
		 *
		 */
		function init(  )
		{
			vm.thisHost = window.location.host;
			
			if (Spark.state.user!=null)
			{
				if (typeof(Spark.state.user.user_info)=='string')
				{
					Spark.state.user.user_info = JSON.parse( Spark.state.user.user_info );
				}
			}

			if ( (document.location.pathname=="/Profile/" ) || ( document.location.pathname=="/Profile" ) )
			{
				if ( ( Spark !== undefined) && ( Spark.state.user !== null ) )
				{
					vm.editPerm=true;
					vm.pageClass='page-layout simple left-sidenav inner-sidenav';
					vm.pageMainClass='main';
					vm.profileData = JSON.parse(JSON.stringify(Spark.state.user));
					vm.getMessages();
					vm.getUserWorkspaces();
					vm.getWorkspaceData();
					vm.getInvitations();
					vm.getAnnNots();
					vm.viewType = 'inbox';
				}
			}else
			{
				vm.editPerm=false;
				vm.pageClass='page-layout simple left-sidenav';
				vm.pageMainClass='mainView';
				vm.showType = 'profileProfile';
				vm.getUserInfo();
				vm.getSparkData();
				vm.getMessages();
				vm.viewType = 'inbox';
			}
		}












		/**
		 * Select an item
		 *
		 * @param item
		 */
		function select(item)
		{
			vm.selected = item;
		}











		/**
		 *
		 * Navigate to a new file, folder, etc
		 *
		 */
		function navigateURL( fileItem, type )
		{
			if (type=='team')
			{ 
				var newURL=utilityFactory.makeURL( fileItem, 'team' );
			
			}else if ((type=='settings') || (type=='userSettings'))
			{ 
				var newURL=utilityFactory.makeURL( fileItem, 'settings' );
			
			}else if (type=='homeSpace')
			{ 
				var newURL=window.location.origin+'/Workspace/'+Spark.state.user.username;

			}else
			{
				if ( fileItem == vm.cadwolf_fileInfo )
				{
				  var newURL=utilityFactory.makeURL( fileItem, window.location.href.replace(/\/$/,'') );
				}else
				{
				  var newURL=utilityFactory.makeURL( fileItem, window.location.href.replace(/\/$/,'')+'/'+Spark.state.user.username );
				}
			}

			if ((type=='settings') || (type=='userSettings'))
			{
				window.location.href=newURL;
			}else
			{
				$location.path(newURL.replace(window.location.origin,''));
			}
		}















		/**
		 *
		 *  Get the info for the user
		 *
		 */
		function getUserInfo(  )
		{
			var userName = document.location.pathname.replace(/^\/Profile\//,'').replace(/\//g,'').replace(/ /g,'_');
			if ( userName.length > 3 )
			{
			  $http({
				  method: "GET",
				  url: window.location.origin+'/user/'+userName,
			  }).then(function successCallback( returnData ) 
			  {
			  		if ( returnData.data.id === undefined )
			  		{
						vm.noProfile=true;
					}else
					{
						vm.noProfile=false;	
					}

			  		console.log('The profile data is ...');
					console.log(returnData);
					vm.profileData=returnData.data;
					if (vm.profileData.user_info==null)
					{
						vm.profileData.user_info={};
						vm.profileData.user_info.gender='';
						vm.profileData.user_info.age='';
						vm.profileData.user_info.address='';
						vm.profileData.user_info.telephones=[];
						vm.profileData.user_info.websites=[];
						vm.profileData.user_info.emails=[];
						vm.profileData.user_info.locations=[];
						vm.profileData.user_info.about='';
						vm.profileData.user_info.occupation='';
						vm.profileData.user_info.skills='';
						vm.profileData.user_info.jobs='';
					}
					if (typeof(vm.profileData.user_info)=='string')
					{
						vm.profileData.user_info = JSON.parse( vm.profileData.user_info );
					}

			  }, function errorCallback( returnData ) {
					vm.noProfile=true;  
			  });
			}
		}









		/**
		 *
		 *  Get the users workspaces
		 *
		 */
		function getUserWorkspaces(  )
		{
			$http({
				method: "GET",
				url: window.location.origin+'/files/'+Spark.state.user.id+'/workspaces/',
			}).then(function successCallback( returnData ) {
				console.log(returnData);
				if ( returnData.data=="noPerm" )
				{
					Spark.state.user.workspacesOwned = 'noPerm';
					Spark.state.user.workspacesEdit = 'noPerm';

				}else
				{
					Spark.state.user.workspacesEdit = returnData.data.perms;
					Spark.state.user.workspacesOwned = returnData.data.files;
					for (var a=0; a<Spark.state.user.workspacesOwned.length; a++)
					{
						if (typeof(Spark.state.user.workspacesOwned[a]['item_data'])=="string")
						{ Spark.state.user.workspacesOwned[a]['item_data'] = JSON.parse(Spark.state.user.workspacesOwned[a]['item_data']); }
					}
				}
			}, function errorCallback( returnData ) {

			});
		}








		/**
		 *
		 *  Get the data from the users workspace
		 *
		 */
		function getWorkspaceData(  )
		{
			$http({
				method: "GET",
				url: window.location.origin+'/files',
				params:{ thisURL : window.location.origin+'/Workspace/'+Spark.state.user.username }
			}).then(function successCallback( returnData ) {
				console.log('Return data is ');
				console.log(returnData.data);
				vm.cadwolf_permissions = returnData['data']['permissions'];
				vm.cadwolf_files = returnData['data']['files'];
				vm.cadwolf_fileInfo = returnData['data']['fileInfo'];
				vm.selected = vm.cadwolf_files[0];
				if ( typeof(vm.cadwolf_fileInfo.item_data)=="string" )
				{
					vm.cadwolf_fileInfo.item_data = JSON.parse( vm.cadwolf_fileInfo.item_data );
				}
			}, function errorCallback( returnData ) {

			});
		}

















		/**
		 *
		 *  Get the messages for the user
		 *
		 */
		function getMessages(  )
		{
			$http({
				method: "GET",
				url: window.location.origin+'/messages/'+Spark.state.user.id,
			}).then(function successCallback( returnData ) {
				console.log('Message data is ');
				console.log(returnData.data);

				vm.cadwolf_messages = returnData['data']['messages'];
				vm.cadwolf_sent = returnData['data']['sentList'];
				vm.cadwolf_drafts = returnData['data']['draftList'];


				// Fix the dates
				vm.cadwolf_messages.forEach(function(thisItem, index)
				{  
					var thisDate = thisItem['created_at'].split(' ');
					thisItem['created_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
					var thisDate = thisItem['updated_at'].split(' ');
					thisItem['updated_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
					thisItem.messageData.content.sentDate = new Date(thisItem.messageData.content.sentDate); 
				});

				vm.cadwolf_sent.forEach(function(thisItem, index)
				{  
					var thisDate = thisItem['created_at'].split(' ');
					thisItem['created_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
					var thisDate = thisItem['updated_at'].split(' ');
					thisItem['updated_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
					thisItem.content.sentDate = new Date(thisItem.content.sentDate); 
				});

				vm.cadwolf_drafts.forEach(function(thisItem, index)
				{  
					var thisDate = thisItem['created_at'].split(' ');
					thisItem['created_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
					var thisDate = thisItem['updated_at'].split(' ');
					thisItem['updated_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
				});

			}, function errorCallback( returnData ) {

			});
		}








		/**
		 *
		 *  Create new message and open edit window
		 *
		 */
		function newMessage(  )
		{


			$http({
				method: "GET",
				url: window.location.origin+'/messages/'+Spark.state.user.id,
			}).then(function successCallback( returnData ) {

				$http({
				  method: 'POST',
				  url: window.location.origin+'/messages',
				  data:{ sender_id : Spark.state.user.id,
				  		   receiver_id : 0,
				  		   receiver_type : 0,
				  		   message_type : 0,
				  		   status : 0,
				  		   content : {
				  		   		title : "New Message",
				  		   		messageText : "",
				  		   		tags : { },
				  		   		starred : 0,
				  		   		sentDate : 0
				  		   }
				  		}
				}).then(function successCallback( returnData ) {

					vm.cadwolf_drafts = returnData.data;

					// Fix the dates
					vm.cadwolf_messages.forEach(function(thisItem, index)
					{  
						var thisDate = thisItem['created_at'].split(' ');
						thisItem['created_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
						var thisDate = thisItem['updated_at'].split(' ');
						thisItem['updated_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 

						if (thisItem.content.sentDate != 0)
						{
							thisItem.content.sentDate = new Date(thisItem.content.sentDate); 
						}

						vm.viewType = 'drafts';
					});

				});

			}, function errorCallback( returnData ) {


			});
		}















		/*
		 *
		 * Call a function from the left menu
		 *
		 */
		function leftMenuCaller( event, menuItem, flag )
		{   
			if ( menuItem=='Files' )   { vm.showType='profileOverview';	}
			if ( menuItem=='Workspaces' ) { vm.showType='profileWorkspaces';  }
			if ( menuItem=='Teams' )	  { vm.showType='profileTeams';	   }
			if ( menuItem=='Invitations' ){ vm.showType='profileInvitations'; }
			if ( menuItem=='Announcements' ){ vm.showType='profileAnnouncements'; }
			if ( menuItem=='Notifications' ){ vm.showType='profileNotifications'; }
			if ( menuItem=='Profile' )	{ vm.showType='profileProfile';	 }
			if ( menuItem=='CAD Sync' )		{ vm.showType='profileCAD';		 }
			if ( menuItem=='Messages' )	  { vm.showType='profileMessages';	   }
		};












		/*
		 *
		 * Mark an Notification as read
		 *
		 */
		function markNotAsRead( ) 
		{
			$http({
				method: "PUT",
				url: window.location.origin+'/notifications/read',
			}).then(function successCallback( returnData ) {
				vm.nofications.forEach(
				  function(thisItem, index){
					  thisItem['read'] = true;
				  }
				);
			}, function errorCallback( returnData ) {});
		};











		/*
		 *
		 * Add a new workspace for the user
		 *
		 */
		function addWorkspace( ) 
		{
			$http({
				method: "POST",
				url: window.location.origin+'/files',
				data: { thisURL : '', file_type_id : 'Workspace' },
			}).then(function successCallback( returnData ) {
				vm.getUserWorkspaces();
			}, function errorCallback( returnData ) {});
		};








		/**
		 * Get the invitations for this user
		 *
		 * @param item
		 */
		function getInvitations( )
		{
			console.log('In the get invitations program');
			$http({
			  method: 'GET',
			  url: window.location.origin+'/settings/invitations/pending'
			}).then(function successCallback( returnData ) {
					console.log('Return data for the invitations is ');
					console.log(returnData);
					vm.invitations=returnData.data;
			  }, function errorCallback( returnData ) {
			});			
		}
















		/**
		 * Get the announcements and notifications for this user
		 *
		 * @param item
		 */
		function getAnnNots( )
		{
			console.log('In the get announcements and notifications program');
			$http({
			  method: 'GET',
			  url: window.location.origin+'/notifications/recent'
			}).then(function successCallback( returnData ) {
					console.log('Return data for the notifications and announcements is ');
					console.log(returnData);
					vm.announcements=returnData.data.announcements;
					vm.notifications=returnData.data.notifications;

					vm.announcements.forEach(function(thisItem, index)
					{  
						var thisDate = thisItem['created_at'].split(' ');
						thisItem['created_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
						var thisDate = thisItem['updated_at'].split(' ');
						thisItem['updated_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
					});

					vm.notifications.forEach(function(thisItem, index)
					{  
						var thisDate = thisItem['created_at'].split(' ');
						thisItem['created_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
						var thisDate = thisItem['updated_at'].split(' ');
						thisItem['updated_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
					});

			  }, function errorCallback( returnData ) {
			});			
		}














		/*
		 *
		 * Edit a property in a dialog
		 *
		 */
		function showLargeModal(ev, modalType) 
		{   
			if (typeof(Spark.state.user.user_info)=='string')
			{
				Spark.state.user.user_info = JSON.parse( Spark.state.user.user_info );
			}
			vm.modalType=modalType;
			$mdDialog.show({
				templateUrl: 'app/main/apps/profile/views/dialog/largeModalTemplates.tmpl.html',
				controller: function(){ return vm },
				controllerAs: 'vm',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
			}, function() {
				
			});
		};

		function cancel(){
			$mdDialog.cancel();
		};

		function acceptChanges() {
			$mdDialog.hide();

			
			for (var key in vm.profileData.user_info)
			{
				if ( ( key == 'about' ) || ( key == 'address' ) || ( key == 'age' ) || ( key == 'birthday' ) || 
					( key == 'gender' ) || ( key == 'occupation' ) || ( key == 'showEmail' ) || ( key == 'skills' ) )
				{
					Spark.state.user.user_info[key] = JSON.parse(JSON.stringify(vm.profileData.user_info[key]));		
				
				}else if ( ( key == 'email' ) || ( key == 'jobs' ) || ( key == 'locations' ) || ( key == 'websites' ) || 
						( key == 'telephones' ) || ( key == 'occupation' ) || ( key == 'showEmail' ) || ( key == 'skills' ) ) 
				{
					var temp=[];
					for (var a=0; a<vm.profileData.user_info[key].length; a++)
					{   
						var temp=[];
						if ( vm.editProp[a] !== undefined )
						{
							temp[a]=[];
							temp[a]['itemTitle'] = vm.editProp[a]['itemTitle'];
							temp[a]['itemText'] = $sce.trustAsHtml(vm.editProp[a]['itemText']);
						}
					}
					Spark.state.user.user_info[key] = temp;

				}
			}

			vm.updateUserInfo();
		};










		/**
		 * Update the user info
		 *
		 * @param item
		 */
		function updateUserInfo( )
		{
			$http({
				method: 'PUT',
				url: window.location.origin+'/updateUserInfo',
 				data:{ userID : Spark.state.user.id, thisUser : Spark.state.user.user_info }
 			}).then(function successCallback( returnData ) {
				vm.getSparkData();
			  }, function errorCallback( returnData ) {
			});			
		}







		/**
		 * User accepts an invitation
		 *
		 * @param item
		 */
		function acceptInvitation( invitation )
		{
			$http({
			  method: 'POST',
			  url: window.location.origin+'/settings/invitations/'+invitation.id+'/accept'
			}).then(function successCallback( returnData ) {
				vm.getInvitations( invitation.team );
				vm.getUserInfo();
				vm.getSparkData();
			  }, function errorCallback( returnData ) {
			});			
		}





		/**
		 *
		 *  Get the User Spark Data
		 *
		 */
		function getSparkData()
		{
			console.log('In the get spark data function');
			$http({
			  method: 'GET',
			  url: '/user/current'
			}).then(function successCallback( returnData ) {
					console.log('The user data is ');
					console.log(returnData.data);
					if (returnData.data.user_info!==undefined)
					{
						Spark.state.user = returnData.data;
						if ( typeof(Spark.state.user.user_info)=="string" )
						{
							Spark.state.user.user_info = JSON.parse(Spark.state.user.user_info);
						}
					}

			  }, function errorCallback( returnData ) {
			});

		}









		/**
		 * User declines an invitation
		 *
		 * @param item
		 */
		function rejectInvitation( invitation )
		{
			$http({
			  method: 'POST',
			  url: window.location.origin+'/settings/invitations/'+invitation.id+'/reject'
			}).then(function successCallback( returnData ) {
				vm.getInvitations( invitation.team );
				vm.getUserInfo();
				vm.getSparkData();
			  }, function errorCallback( returnData ) {
			});			
		}








		/**
		 * Check to see that member name is available
		 *
		 * @param item
		 */
		function checkUsername( memberName )
		{
			$http({
			  method: 'GET',
			  url: window.location.origin+'/checkUsername/'+memberName
			}).then(function successCallback( returnData ) {
					console.log('Return data for checkusername is ');
					console.log(returnData);
					vm.checkStatus=(returnData.data=="true");
			  }, function errorCallback( returnData ) {
			});			
		}


		/**
		 * Check to see that member name is available
		 *
		 * @param item
		 */
		function changeUsername( memberName )
		{
			$http({
			  method: 'PUT',
			  url: window.location.origin+'/changeUsername/'+memberName
			}).then(function successCallback( returnData ) {
			  }, function errorCallback( returnData ) {
			});			
		}












		/*
		 *
		 * Edit a property in a dialog
		 *
		 */
		function showSmallModal(ev, modalType, thisItem) 
		{   
			vm.modalType=modalType;
			vm.thisItem=thisItem;
			$mdDialog.show({
				templateUrl: 'app/main/apps/profile/views/dialog/smallModalTemplates.tmpl.html',
				controller: function(){ return vm },
				controllerAs: 'vm',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
			}, function() {
				
			});
		};












		/*
		 *
		 * Checkout a document
		 *
		 */
		function checkOutFile( item ) 
		{   
			$http({
				method: "POST",
				url: window.location.origin+'/checkout/'+item['id'],
			}).then(function successCallback( returnData ) {
				if(returnData.data=="noPerm")
				{

				}else
				{
					item['item_data']['checkout_id']=returnData.data['id'];
					item['item_data']['checkout_name']=returnData.data['name'];
				}
			}, function errorCallback( returnData ) {});
			
		};


		/*
		 *
		 * Checkin a document
		 *
		 */
		function checkInFile( item ) 
		{   
			$http({
				method: "POST",
				url: window.location.origin+'/checkin/'+item['id'],
			}).then(function successCallback( returnData ) {
				if(returnData.data=="noPerm")
				{

				}else
				{
					item['item_data']['checkout_id']=returnData.data;
					item['item_data']['checkout_name']='';
				}
			}, function errorCallback( returnData ) {});
			
		};















		/*
		 *
		 * Check to see that member name is valid
		 *
		 * @param item
		 */
		function checkMemberName( memberName )
		{
			$http({
			  method: "GET",
			  url: window.location.origin+'/checkMember',
			  params:{ memberName : memberName }
			}).then(function successCallback( returnData ) {
					console.log('Return data is ');
					console.log(returnData);
					vm.foundUser=returnData.data.member;
			  }, function errorCallback( returnData ) {
			});			
		}














		/*
		 *
		 * Add a user to a recepient email list
		 *
		 * @param item
		 */
		function addRecepient( thisDraft, thisRecep )
		{


			vm.cadwolf_drafts.forEach(function(thisItem, index)
			{  
				if ( thisDraft.id == thisItem.id )
				{
					var newItem = {};
					newItem.userData = thisRecep;
					thisDraft.userList.push( newItem );

					$http({
					  method: "POST",
					  url: window.location.origin+'/addRecep',
					  params:{ member : thisRecep.id, draft : thisDraft.id }
					}).then(function successCallback( returnData ) {

							console.log('Return data is ');
							console.log(returnData);
							vm.foundUser = {};

					  }, function errorCallback( returnData ) {
					});
				}
			});
		}



		/*
		 *
		 * Add a user to a recepient email list
		 *
		 * @param item
		 */
		function removeRecepient( thisDraft, thisRecep )
		{


			vm.cadwolf_drafts.forEach(function(thisItem, index)
			{  

				if ( thisDraft.id == thisItem.id )
				{

					thisItem.userList.forEach(function(thisUser, userIndex)
					{  
						if ( thisUser.id == thisRecep.id )
						{

							$http({
							  method: "POST",
							  url: window.location.origin+'/removeRecep',
							  params:{ member : thisRecep.id, draft : thisDraft.id }
							}).then(function successCallback( returnData ) {

									console.log('Return data is ');
									console.log(returnData);

							  }, function errorCallback( returnData ) {
							});

						}
					});
				}
			});
		}





		/*
		 *
		 * Update a message
		 *
		 * @param item
		 */
		function updateMessage( thisMessage )
		{

			console.log('In the update message function');

			$http({
			  method: "POST",
			  url: window.location.origin+'/updateMessage',
			  data:{ message : thisMessage }
			}).then(function successCallback( returnData ) {

					console.log('Return data is ');
					console.log(returnData);

			  }, function errorCallback( returnData ) {
			});
		}








		/*
		 *
		 * Send a draft message
		 *
		 * @param item
		 */
		function sendMessage( thisMessage )
		{

			console.log('In the send message function');

			// Change the status of the draft to that of send
			thisMessage.status = 1;

			// Set the send message date
			thisMessage.content.sentDate = new Date();

			// Save the message
			vm.updateMessage( thisMessage );

			// Move the message from the draft list to the sent list
			vm.cadwolf_sent.push(thisMessage);

			// Remove the message from the draft list
			vm.cadwolf_drafts.forEach(function(thisItem, index)
			{  

				if ( thisItem.id == thisMessage.id )
				{
					vm.cadwolf_drafts.splice( index, 1 );
				}

			});

			vm.thisMessage = {};

		}







		/**
		 *
		 * Upload an Image
		 *
		 *

		 This is the old code, before I decided to simply use the Laravel and spark
		 built in functions. It is here as a reminder to me that all things come to an end
		 
		function uploadImage( )
		{
			var userID = Spark.state.user.id;
			var fd = new FormData(document.getElementById('uploadFile'+userID).files[0]);
			var folder = window.location.pathname.replace(/ /g,'_');
			fd.append('folder', folder);
			fd.append('userID', Spark.state.user.id);
			fd.append('image', document.getElementById('uploadFile'+userID).files[0]);
			$http.post(window.location.origin+"/profileImageUpload", fd, {
				withCredentials: true,
				headers: {'Content-Type': undefined },
				transformRequest: angular.identity
			}).then(function successCallback(returnData) {
				console.log(returnData.data);
				Spark.state.user.photo_url = returnData.data.photo_url;
				vm.profileData.photo_url = returnData.data.photo_url;

			}, function errorCallback(returnData) {

			});

		}
		*/
		/**
		 *
		 * Upload an Image
		 *
		 */
		function uploadImage( )
		{
			var userID = Spark.state.user.id;
			var fd = new FormData(document.getElementById('uploadFile'+userID).files[0]);
			var folder = window.location.pathname.replace(/ /g,'_');
			fd.append('folder', folder);
			fd.append('userID', Spark.state.user.id);
			fd.append('photo', document.getElementById('uploadFile'+userID).files[0]);
			$http.post(window.location.origin+"/settings/photo", fd, {
				withCredentials: true,
				headers: {'Content-Type': undefined },
				transformRequest: angular.identity
			}).then(function successCallback(returnData) {
				console.log(returnData.data);
				vm.getSparkData();

			}, function errorCallback(returnData) {

			});

		}


	}


})();

(function ()
{
    'use strict';

    angular
        .module('app.plot', [])
        .config(config);
        

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.plot', {
            url      : '/Plot/{path:.*}/',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/plot/plot.html',
                    controller : 'PlotController as vm'
                }
            },
            resolve  : {
                Plots: function (msApi)
                {
                    return msApi.resolve('plot.documents@get');
                },
                emptyPlots: function (msApi)
                {
                    return msApi.resolve('plot.emptyList@get');
                }
            },
            bodyClass: 'plot'

        }).state('app.plotEmpty', {
            url      : '/Plot',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/plot/plotEmpty.html',
                    controller : 'PlotController as vm'
                }
            },
            resolve  : {
                Plots: function (msApi)
                {
                    return msApi.resolve('plot.documents@get');
                },
                emptyPlots: function (msApi)
                {
                    return msApi.resolve('plot.emptyList@get');
                }
            },
            bodyClass: 'plot'
        });



        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/plot');

        // Api
        msApiProvider.register('plot.documents', ['app/data/plot/documents.json']);
        msApiProvider.register('plot.emptyList', ['app/data/plot/emptylist.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('plot', {
            title : 'Plot',
            icon  : 'icon-chart-line',
            state : 'app.plot',
            weight: 8
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.plot')
        .controller('PlotController', PlotController);

    /** @ngInject */
    function PlotController($mdSidenav, docItemFactory, chartFactory, unitConstantFactory, utilityFactory, Plots, emptyPlots, $http, $location)
    {
        var vm = this;
        window.MY_SCOPE = vm;        
        console.log('I am here');

        // Data
        vm.showPlot = true;
        vm.showSpecs  ='chartVer';
        vm.emptyPlots = emptyPlots.data.previousPlots;
        vm.currentItem = {};

        
        
        // Methods
        vm.init             = init;
        vm.shortcutAction   = shortcutAction;
        vm.addChartItem     = addChartItem;
        vm.deleteChartItem  = deleteChartItem;
        vm.setMonoColor     = setMonoColor;
        vm.favoriteItem     = favoriteItem;
        vm.removeFavItem    = removeFavItem;
        vm.getPlotData      = getPlotData;
        vm.updateUserInfo   = updateUserInfo;
        vm.getCharts        = getCharts;
        vm.goToURL          = goToURL;






        /*
        *
        *   GET THE PLOT DATA
        *
        */
        function getPlotData( itemid )
        {   
            console.log('In the get plot data function');


            $http({
                method: 'GET',
                url: window.location.origin+'/files/getComponent/'+itemid,
                params:{ itemid : itemid }
            }).then(function successCallback( returnData ) {

                MY_SCOPE.returdata=returnData;
                vm.currentItem = returnData.data.data;
                vm.currentItem.content = JSON.parse(vm.currentItem.content);
                vm.currentItem.content.renderTo='edit';
                vm.currentItem.content.Plot.Chart_width = ($(window).width()-300)+'px';
                vm.currentItem.content.Plot.Chart_height = ($(window).height()-100)+'px';
                vm.currentItem.content.Plot.needsUpdateFlag = 1;

            }, function errorCallback( returnData ) {});


        }









        /*
        *
        *   SHORTCUT FUNCTIONS
        *
        */
        function shortcutAction(actionNum)
        {   
            console.log('The action num is '+actionNum);
            if (actionNum=="1")
            {   
                if (vm.showSpecs == '')
                {
                    vm.showSpecs='chartVer';
                }

                if (vm.showSpecs == 'chartVer')
                {
                    vm.showSpecs='chartHor';
                }

                if (vm.showSpecs == 'chartHor')
                {
                    vm.showSpecs='chartVer';
                }
            }
        };



        /*
        *
        *   CHART FUNCTIONS
        *
        *   There are several functions that handle actions carried out
        *   on a chart. These include adding and deleting items.
        */


        /*
        *
        *   ADD A CHART ITEM
        *
        */
        function addChartItem(thisPlot, type)
        {   
            if (type=="dataSeries")
            {   
                vm.currentItem = vm.chartFactory.addDataset( vm.currentItem, vm.cadwolf_fileInfo.id, vm.cadwolf_worksheet );

            }else
            {
                vm.currentItem = vm.chartFactory.addChartItem( vm.currentItem, type, vm.cadwolf_fileInfo.id, vm.cadwolf_worksheet ); 
            }
        };



        /*
        *
        *   DELETE A CHART ITEM
        *
        */
        function deleteChartItem( currentItem, thisItem )
        {   
            vm.currentItem = vm.chartFactory.deleteChartItem( currentItem, thisItem ); 
        };




        /*
        *
        *   SET THE MONO COLOR
        *
        */
        function setMonoColor()
        {   
            vm.currentItem = vm.chartFactory.setMonoColor( vm.currentItem, vm.currentChartItem );
        };






        /*
         *
         * Make an item a favorite
         *
         */
        function favoriteItem( ) 
        {   
            Spark.state.user.user_info = utilityFactory.favoriteItem( 'Plot', 
                                                                      vm.cadwolf_fileInfo, 
                                                                      Spark.state.user.user_info, 
                                                                      window.location.pathname.replace(/^\/Plot\//,'') ); 
            console.log('The item returned from the factory is '+Spark.state.user.user_info);
            vm.cadwolf_fileInfo.favorite=!vm.cadwolf_fileInfo.favorite; 
            vm.updateUserInfo();
        };





        /*
         *
         * Remove a favorite
         *
         */
        function removeFavItem( thisItem ) 
        {   
            Spark.state.user.user_info = utilityFactory.favoriteItem( 'Plot', 
                                                                      thisItem, 
                                                                      Spark.state.user.user_info, 
                                                                      window.location.pathname.replace(/^\/Plot\//,'') ); 
            vm.updateUserInfo();
        };





        /*
         *
         * Update User Info
         *
         */
        function updateUserInfo( ) 
        {   
            $http({
                method: 'PUT',
                url: window.location.origin+'/updateUserInfo',
                params:{ userID : Spark.state.user.id, thisUser : Spark.state.user.user_info }
            }).then(function successCallback( returnData ) {
            }, function errorCallback( returnData ) {});
        };







        /*
         *
         * PULL ALL CHARTS FOR A DOCUMENT
         *
         */
        function getCharts( fileURL ) 
        {   

            console.log('The get charts function has been called with the URL of '+fileURL);
            
            $http({
                method: 'GET',
                url: window.location.origin+'/files/getCharts',
                params:{ fileurl : fileURL.toString() }
            }).then(function successCallback( returnData ) {

                vm.fileCharts = returnData.data.data;

                vm.fileCharts.forEach(
                    function(thisItem, index){

                        thisItem.content = JSON.parse(thisItem.content);

                });

            }, function errorCallback( returnData ) {});
        };








        /**
         *
         * Navigate to a given URL
         *
         */
        function goToURL( plotID )
        {
            console.log('In the go to url function with '+plotID);
            $location.path('/Plot/'+plotID);
        }






        /*
        *
        *   INITIATION FUNCTIONS
        *
        */
        function init()
        {   
            console.log('In the initiation function');

            // vm.updateUserInfo();


            if ( Spark.state.user !== null )
            {
                if (typeof(Spark.state.user.user_info)=='string')
                {
                    Spark.state.user.user_info = JSON.parse( Spark.state.user.user_info );
                }
            }
            // Spark.state.user.user_info = utilityFactory.setRecent( 'Plot', vm.cadwolf_fileInfo, Spark.state.user.user_info, window.location.pathname ); 
            // vm.cadwolf_fileInfo.favorite = utilityFactory.checkFavorite( 'Plot', vm.cadwolf_fileInfo, Spark.state.user.user_info, window.location.pathname );


            vm.getPlotData( window.location.pathname.replace(/^\/Plot\//,'').replace('/','') );
        }


        vm.init();

    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('PartTreeDialogController', PartTreeDialogController);

    /** @ngInject */
    function PartTreeDialogController($mdDialog, locals)
    {
        var vm              = this;

        vm.thisItem         = locals.thisItem;
        vm.fileInfo         = locals.fileInfo;
        vm.cancel           = cancel;
        vm.acceptChanges    = acceptChanges;
        vm.acceptName       = acceptName;
        vm.acceptText       = acceptText;
        vm.alterStructure   = alterStructure;
        vm.addOption        = addOption;
        vm.deleteOption     = deleteOption;




        /*
        *
        *   ADD AN OPTION TO THE SYSTEM NAMES
        *
        */
        function addOption( system )
        {   
            console.log('Adding a new option to '+system.title);

            system.options.push( { "number":system.options.length, "name":"New System" } );

        };




        /*
        *
        *   DELETE AN OPTION FROM THE SYSTEM NAMES
        *
        */
        function deleteOption( system, optionNum )
        {   
            console.log('Deleting the option '+system.title+' with number '+optionNum);

        };



        /*
        *
        *   ADD OR DELETE A MAIN TREE BLOCK
        *
        */
        function alterStructure( type, index )
        {
            console.log('I am in the alter structure function');
            if (type == 'delete')
            {
                vm.thisItem.splice(index, 1);
                for ( var thisBlock in vm.thisItem )
                {
                    if (vm.thisItem[thisBlock].orderNumber > index)
                    {
                        vm.thisItem[thisBlock].orderNumber--;
                    }
                }
            }

            if (type == 'add')
            {
                for ( var thisBlock in vm.thisItem )
                {
                    if (vm.thisItem[thisBlock].orderNumber > index)
                    {
                        vm.thisItem[thisBlock].orderNumber++;
                    }
                }
                var addItem = {
                    "orderNumber":index+1,
                    "title":"Title",
                    "treeRep":"Abbreviation",
                    "active":"false",
                    "description":"This is the text that will describe the item"                    
                };
                vm.thisItem.splice( index, 0, addItem );
            }

        };






        function cancel(){
            $mdDialog.cancel();
        };

        function cancel(){
            $mdDialog.cancel();
        };

        function acceptChanges(desc) {
            $mdDialog.hide(desc);
        };

        function acceptName(name) {
            $mdDialog.hide(name);
        };

        function acceptText(name) {
            $mdDialog.hide(name);
        };

    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.parttree', [])
        .config(config);


    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        // State
        $stateProvider.state('app.parttree', {
            url      : '/PartTree{path:.*}',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/partTree/partTree.html',
                    controller : 'PartTreeController as vm'
                }
            },
            bodyClass: 'parttree'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/partTree');

        // Navigation
        msNavigationServiceProvider.saveItem('parttree', {
            title : 'Part Tree',
            icon  : 'icon-sitemap',
            state : 'app.parttree',
            weight: 6
        });
    }

})();
(function ()
{
	'use strict';

	angular
		.module('app.parttree')
		.controller('PartTreeController', PartTreeController);

	/** @ngInject */
	function PartTreeController($mdSidenav, $mdDialog, unitConstantFactory, utilityFactory, partTreeMemoryFactory, $http, $location, docItemFactory, chartFactory, surfaceFactory)
	{
		var vm = this;
		window.MY_SCOPE = vm;				
		vm.showMenuTextTop = true;
		vm.showMenuTextBot = true;
		vm.inSolve = 0;
		var equationWorker = new Worker("eqSolver.js");  
		vm.digestStatus = 1;
		vm.cadwolfScaleUnits	= vm.cadwolfScaleUnits || unitConstantFactory.unitsObj();
		vm.cadwolfParseUnits	= vm.cadwolfParseUnits || unitConstantFactory.parseObj();
		vm.cadwolfConstants		= vm.cadwolfConstants || unitConstantFactory.constObj();
		vm.chartFactory			= vm.chartFactory || chartFactory;
		vm.docItemFactory		= vm.docItemFactory || docItemFactory;
		vm.surfaceFactory		= vm.surfaceFactory || surfaceFactory;


		// Methods
		vm.init					= init;
		vm.checkInitialSegment  = checkInitialSegment;
		vm.getSpark				= getSpark;
		vm.leftMenuCaller		= leftMenuCaller;
		vm.select				= select;
		vm.showModal			= showModal;
		vm.showSmallModal		= showSmallModal;
		vm.getPartTree			= getPartTree;
		vm.createPartTreeNames  = createPartTreeNames;
		vm.getParentName		= getParentName;
		vm.getSystemInfo		= getSystemInfo;
		vm.addSegment			= addSegment;
		vm.deleteSegment		= deleteSegment;
		vm.addOption			= addOption;
		vm.deleteOption			= deleteOption;
		vm.addSystem			= addSystem;
		vm.addPart				= addPart;
		vm.deleteSystem			= deleteSystem;
		vm.cancel				= cancel;
		vm.acceptChanges		= acceptChanges;
		vm.acceptName			= acceptName;
		vm.savePartTree			= savePartTree;
		vm.favoriteItem			= favoriteItem;
		vm.removeFavItem		= removeFavItem;
		vm.showMessage			= showMessage;
		vm.navigateUrl			= navigateUrl;
		vm.updateItem			= updateItem;
		vm.checkIncluded		= checkIncluded;
		vm.includeParentSystem  = includeParentSystem;
		vm.includeChildren		= includeChildren;
		vm.excludeChildren		= excludeChildren;
		vm.getSumValues			= getSumValues;
		vm.sumPartTreeValues	= sumPartTreeValues;
		vm.updateUserInfo		= updateUserInfo;
		vm.goToURL				= goToURL;
		vm.setTreeOrder			= setTreeOrder;

		vm.getOnshapeDocs		= getOnshapeDocs;
		vm.setCurrentSystem		= setCurrentSystem;
		vm.getCadElements		= getCadElements;
		vm.getCadParts			= getCadParts;
		vm.setCadProperties		= setCadProperties;
		vm.getAssemblyMass		= getAssemblyMass;
		vm.syncCadTree			= syncCadTree;
		vm.updateMass			= updateMass;
		vm.updateAllMass		= updateAllMass;
		vm.calculateMass		= calculateMass;
		vm.updateMaterial		= updateMaterial;
		vm.removeCadConn 		= removeCadConn;

		vm.getFolderContents	= getFolderContents;
		vm.addRelatedDoc		= addRelatedDoc;
		vm.setNewURL			= setNewURL;

		vm.getTreeStatus		= getTreeStatus;
		vm.updateFile			= updateFile;
		vm.lockFiles			= lockFiles;
		vm.runEquationDigest	= runEquationDigest;
		vm.solveEquation		= solveEquation;
		vm.handleSolverReturn   = handleSolverReturn;
		vm.addressConnectedEqs  = addressConnectedEqs;
		vm.updateComponent		= updateComponent;
		vm.saveFile				= saveFile;
		vm.saveComponents		= saveComponents;

		vm.getPermLists			= getPermLists;
		vm.handlePermissions	= handlePermissions;
		vm.addPermUser			= addPermUser;
		vm.deletePermUser		= deletePermUser;
		vm.changeUserPerm		= changeUserPerm;

		vm.setImportDoc			= setImportDoc;
		vm.populateCADParent	= populateCADParent;
		vm.submitCadImport 		= submitCadImport;

		vm.checkTreeIntegrity	= checkTreeIntegrity;
		vm.changeSystemName		= changeSystemName;
		vm.moveSystem 			= moveSystem;


		vm.getAutocadHubs		= getAutocadHubs;
		vm.getAutocadProjects 	= getAutocadProjects;
		vm.getAutocadFolders 	= getAutocadFolders;
		vm.getAutocadFolderContents = getAutocadFolderContents;
		vm.getAutocadItem 		= getAutocadItem;
		vm.setAutocadItem 		= setAutocadItem;
		vm.setAutocadPullItem 	= setAutocadPullItem;
		vm.pushToFusion			= pushToFusion;
		vm.getFusionBodies 		= getFusionBodies;
		vm.setFusionProperties  = setFusionProperties;
		vm.updateFusionData		= updateFusionData;
		vm.setFusionAssemblyBodyData = setFusionAssemblyBodyData;
		vm.setFusionPartBodyData = setFusionPartBodyData;
		vm.sendAutocadVars 		= sendAutocadVars;


		vm.currentCADType 		= currentCADType;



		vm.autocadFileSelected = false;
		vm.autocadBodySelected = false;
		vm.showFusionProps = false;
		vm.autocadLinkSet = false;
		vm.newCADConnect = { 	"id":"", 
								"hub":"", 
								"hubData":{}, 
								"project":"", 
								"projectData":{}, 
								"rootFolder":"", 
								"rootData":{}, 
								"folders":[], 
								"folderData":[], 
								"file":"", 
								"fileData":{},
								"bodyData":{} };



		/*
		*
		*   INITIAL FUNCTION - GET THE INFO
		*
		*/
		function init( )
		{   
			console.log('In the init function');
			if ( Spark === undefined )
			{
				Spark={};
			}

			if ( Spark.state !== undefined )
			{
				if ( Spark.state.user !==undefined )
				{
					if ( Spark.state.user !==null )
					{
						if (typeof(Spark.state.user.user_info)=='string')
						{
							Spark.state.user.user_info = JSON.parse( Spark.state.user.user_info );
						}
					}
				}
			}
			if ((window.location.href==window.location.origin+'/PartTree') ||
				(window.location.href==window.location.origin+'/PartTree/') ||
				(window.location.href==window.location.origin+'/PartTree/'))
			{
				vm.showType = 'PartTreeEmpty';

			}else
			{				
				vm.showType = 'PartTreeSetup';
				vm.getSystemInfo( );
				vm.getSpark();
			}
		}






		/*
		 *
		 * Get the spark parameters
		 *
		 */
		function getSpark( )
		{   
			console.log('In the get spark function');

			$http({
				method: "GET",
				url: window.location.origin+'/user/current'

			}).then(function successCallback( returnData ) 
			{
				console.log('The spark data is ...');
				console.log(returnData);
				console.log('The spark data is ...');
				console.log(returnData.data);
				if ( Spark.state !== undefined )
				{
					if ( Spark.state.user !== undefined )
					{
						if ( returnData.data.user_info !== undefined )
						{
							returnData.data.user_info = JSON.parse(returnData.data.user_info);
							Spark.state.user = returnData.data;
						}
					}
				}

			
			});

		}




		/*
		*
		*   GET THE PART TREE DATA
		*
		*/
		function getSystemInfo( )
		{
			$http({
				method: "GET",
				url: window.location.origin+'/files',
				params: { thisURL : window.location.href.replace(/\~2F/g,'/') }
			}).then(function successCallback( returnData ) 
			{
				console.log('Part Tree Data');
				console.log(returnData.data);
				vm.cadwolf_fileInfo = returnData.data.fileInfo;

				if ( returnData.data.fileInfo.file_type_id == 'Workspace' )
				{
					$location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Document/, '\/Workspace'));
				}
				if ( returnData.data.fileInfo.file_type_id == 'Document' )
				{
					$location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Document/, '\/Document'));
				}
				if ( returnData.data.fileInfo.file_type_id == 'Dataset' )
				{
					$location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Document/, '\/Dataset'));
				}


                           
                /**
                 *
                 * This is the code that facilitates the amplitude analytics code
                 *
                 */
                if ( window.amplitude === undefined )
                {
                    var e=window;
                    var t=document
                    var n=e.amplitude||{_q:[],_iq:{}};var r=t.createElement("script")
                      ;r.type="text/javascript";r.async=true
                      ;r.src="https://cdn.amplitude.com/libs/amplitude-4.4.0-min.gz.js"
                      ;r.onload=function(){if(e.amplitude.runQueuedFunctions){
                      e.amplitude.runQueuedFunctions()}else{
                      console.log("[Amplitude] Error: could not load SDK")}}
                      ;var i=t.getElementsByTagName("script")[0];i.parentNode.insertBefore(r,i)
                      ;function s(e,t){e.prototype[t]=function(){
                      this._q.push([t].concat(Array.prototype.slice.call(arguments,0)));return this}}
                      var o=function(){this._q=[];return this}
                      ;var a=["add","append","clearAll","prepend","set","setOnce","unset"]
                      ;for(var u=0;u<a.length;u++){s(o,a[u])}n.Identify=o;var c=function(){this._q=[]
                      ;return this}
                      ;var l=["setProductId","setQuantity","setPrice","setRevenueType","setEventProperties"]
                      ;for(var p=0;p<l.length;p++){s(c,l[p])}n.Revenue=c
                      ;var d=["init","logEvent","logRevenue","setUserId","setUserProperties","setOptOut","setVersionName","setDomain","setDeviceId","setGlobalUserProperties","identify","clearUserProperties","setGroup","logRevenueV2","regenerateDeviceId","logEventWithTimestamp","logEventWithGroups","setSessionId","resetSessionId"]
                      ;function v(e){function t(t){e[t]=function(){
                      e._q.push([t].concat(Array.prototype.slice.call(arguments,0)))}}
                      for(var n=0;n<d.length;n++){t(d[n])}}v(n);n.getInstance=function(e){
                      e=(!e||e.length===0?"$default_instance":e).toLowerCase()
                      ;if(!n._iq.hasOwnProperty(e)){n._iq[e]={_q:[]};v(n._iq[e])}return n._iq[e]}
                      ;e.amplitude=n;

                     amplitude.getInstance().init("85374354a72a1d05529735dc0be7f8d8");
                }

                // Send the amplitude data
                if ( Spark.state !== undefined )
                {
					if (Spark.state.user!=null)
					{ 
	                    amplitude.getInstance().setUserId( Spark.state.user.id );
    				}
                }

				// Send the amplitude data
				amplitude.getInstance().logEvent("Part Tree View",
				    { title: vm.cadwolf_fileInfo.name,
				      id: vm.cadwolf_fileInfo.id });

				document.title = vm.cadwolf_fileInfo.name;
				
				// Protect for the case where this is just the /Part Tree URL
				if ( vm.cadwolf_fileInfo !== undefined )
				{
					if ( vm.cadwolf_fileInfo !== undefined )
					{
						vm.cadwolf_fileInfo.item_data.showMass=false;
						vm.cadwolf_fileInfo.item_data.showWeight=false;
						if ( vm.cadwolf_fileInfo.item_data.assFiles === undefined ){ vm.cadwolf_fileInfo.item_data.assFiles=[]; }
						vm.cadwolf_fileInfo.item_data.cadShow='none';
					}
				}
				vm.editPerm = returnData.data.permissions.edit==1;
				vm.viewPerm = returnData.data.permissions.view==1;
				vm.showProp = '';
				vm.getPartTree( );
				if ((Spark.state.user!=null) && (Spark.state.user!=undefined))
				{
					Spark.state.user.user_info = utilityFactory.setRecent( 'Part Tree', vm.cadwolf_fileInfo, Spark.state.user.user_info, window.location.pathname ); 
					vm.favorite = utilityFactory.checkFavorite( 'Part Tree', vm.cadwolf_fileInfo, Spark.state.user.user_info, window.location.pathname );
					vm.updateUserInfo();
				}
				if ( vm.cadwolf_fileInfo.item_data.segments.length == 0 )
				{
					vm.addSegment( 0 );
				}
				vm.checkInitialSegment();

			}, function errorCallback( returnData ) 
			{
				vm.cadwolf_fileInfo = [];

			});
		}









		/*
		*
		*   GET THE PART TREE DATA
		*
		*/
		function getPartTree( )
		{
			$http({
				method: "GET",
				url: window.location.origin+'/files/'+vm.cadwolf_fileInfo.id+'/children'
			}).then(function successCallback( returnData ) 
			{
				console.log('The children are ... ');
				console.log(returnData);
				if ( vm.partTree !== undefined )
				{
					for (var a = 0; a < returnData.data.length; a++)
					{
						returnData.data[a]['item_data']['systemChildren']=true;
						returnData.data[a]['isChanged']=false;
						var flag=0;
						for (var b = 0; b < vm.partTree.length; b++)
						{
							if (returnData.data[a]['id'] == vm.partTree[b]['id'])
							{
								flag=1;
							}
						}
						if ( flag == 0 )
						{
							vm.partTree.push(returnData.data[a]);
						}
					}
				}else
				{
					vm.partTree=returnData.data;
				}
				for (var a = 0; a < returnData.data.length; a++)
				{
					vm.partTree[a]['item_data']['systemChildren']=true;
					vm.partTree[a]['isChanged']=false;
				}
				vm.solveStatus=false;
				vm.checkTreeIntegrity();
				vm.syncCadTree();
				vm.setTreeOrder();
			}, function errorCallback( returnData ) { vm.partTree=[]; });
		}













		/*
		*
		*   CREATE THE ABBREVIATIONS FOR THE PART NAMES
		*
		*/
		function createPartTreeNames( )
		{
			vm.partTree.forEach(function(tempItem, tempIndex){
				tempItem['treeNameFull'] = vm.getParentName( tempItem, tempItem['name'], 0 );
				tempItem['treeNameFull']=tempItem['treeNameFull'].replace(/^\-/,'');
				tempItem['treeNameAbbr'] = vm.getParentName( tempItem, tempItem['name'], 1 );
				tempItem['treeNameAbbr']=tempItem['treeNameAbbr'].replace(/^\-/,'');
			});
		}

		function getParentName( system, currentName, type )
		{
			//console.log('The system is '+system['name']+' with an id and parent_id of '+system['id']+' - '+system['parent_id']+' and the current name is '+currentName);
			var tempName = '', flag=0, pushItem={};
			flag=0;
			vm.partTree.forEach(function(thisItem, thisIndex)
			{
				// console.log('Looking at ID '+thisItem['id']+' - '+system['parent_id']);
				if ( system['parent_id'] == thisItem['id'] )
				{
					tempName = thisItem['name'];
					for (var a=0; a<vm.cadwolf_fileInfo.item_data.segments.length; a++)
					{
						for (var b=0; b<vm.cadwolf_fileInfo.item_data.segments[a]['segmentOptions'].length; b++)
						{
							// console.log('Comparing '+thisItem['name']+' to '+vm.cadwolf_fileInfo.item_data.segments[a]['segmentOptions'][b]['optionName']);
							if ( thisItem['name'] == vm.cadwolf_fileInfo.item_data.segments[a]['segmentOptions'][b]['optionName'] )
							{
								if (type==1)
								{
									//console.log('Setting the tempName to '+vm.cadwolf_fileInfo.item_data.segments[a]['segmentOptions'][b]['optionAbbr']);
									tempName = vm.cadwolf_fileInfo.item_data.segments[a]['segmentOptions'][b]['optionAbbr'];
								}
								flag=1;
								pushItem=JSON.parse(JSON.stringify(thisItem));
							}
						}
					}
				}
			});
			if (flag==0)
			{
				//console.log('Returning '+tempName+'-'+currentName);
				return tempName+'-'+currentName;
			}else
			{
				return vm.getParentName(pushItem, tempName+'-'+currentName, type);
			}
		}










		/*
		*
		*   Set the order of the items to the number of the part. This lets the 
		*   tree be displayed in order of part id number
		*
		*/
		function setTreeOrder( )
		{   
			console.log('In the set tree order function');

			vm.partTree.forEach(function(thisItem, index)
			{   
				if ( thisItem['file_type_id'] == 'Document' )
				{
					thisItem['order'] = parseInt(thisItem['name'].replace(/^0+/,''));
				}
			});
		};












		/*
		*
		*   LEFT MENU FUNCTIONS
		*
		*/
		function leftMenuCaller( event, actionItem )
		{   
			console.log('The action is '+actionItem);

			if (( actionItem == 'Edit Title' ) || 
				( actionItem == 'Edit Description' ) ||
				( actionItem == 'Tree Structure' ))
			{
				vm.showModal( event, actionItem );
			}
			
			if ( actionItem=='Tree Setup' ){ vm.showType = 'PartTreeSetup'; }
			if ( actionItem=='Part Tree' ){ vm.showType = 'PartTree'; }
			if ( actionItem=='Documents' ){ vm.showType = 'PartTreeDocs'; }


			if ( actionItem=='Update All Status' ){ vm.getTreeStatus(); }
			if ( actionItem=='Update All Mass' ){ vm.updateAllMass( 0 ); }

		};









		/**
		 * Select an item
		 *
		 * @param item
		 */
		function select(item)
		{
			vm.selected = item;
		}





		/*
		*
		*   CHECK INITIAL SEGMENT
		*
		*/
		function checkInitialSegment( )
		{   
			console.log('In the check initial segment function');

			if ( vm.cadwolf_fileInfo.item_data.segments[0]['segmentOptions'] === undefined )
			{
				vm.cadwolf_fileInfo.item_data.segments[0]['segmentOptions'] = [];
			}

			if ( vm.cadwolf_fileInfo.item_data.segments[0]['id'] === undefined )
			{
				vm.cadwolf_fileInfo.item_data.segments[0]['id'] = 0;
			}

			if ( vm.cadwolf_fileInfo.item_data.segments[0]['parentID'] === undefined )
			{
				vm.cadwolf_fileInfo.item_data.segments[0]['parentID'] = 0;
			}

			if ( vm.cadwolf_fileInfo.item_data.segments[0]['segmentDescription'] === undefined )
			{
				vm.cadwolf_fileInfo.item_data.segments[0]['segmentDescription'] = '';
			}

		};






		/*
		*
		*   ADD A NEW SEGMENT
		*
		*/
		function addSegment( thisIndex )
		{   
			console.log('Adding a segment at '+thisIndex);
			var tempObj ={
				'segmentName':'New Segment',
				'segmentDescription':'<p>Description of this segment</p>',
				'segmentOptions':[],
				'parentID':0,
				'id':0,
				'segmentLevel':thisIndex
			}

			vm.cadwolf_fileInfo.item_data.segments.splice( parseInt(thisIndex, 10), 0, tempObj );

			// Recheck the tree and flag ones that are now out of sync
			vm.checkTreeIntegrity();

		};




		/*
		*
		*   DELETE A SEGMENT
		*
		*/
		function deleteSegment( thisIndex )
		{   
			console.log('Deleting a segment at '+thisIndex);
			vm.cadwolf_fileInfo.item_data.segments.splice( thisIndex, 1 );

			// Recheck the tree and flag ones that are now out of sync
			vm.checkTreeIntegrity();
		};











		/*
		*
		*   ADD A NEW OPTION
		*
		*/
		function addOption( segIndex )
		{   
			console.log('Adding an option to segment '+segIndex);
			var tempObj ={
				'optionName':'New Option',
				'optionAbbr':'newAbbr',
				'optionDescription':'<p>Description of this option</p>'
			}

			if ( vm.cadwolf_fileInfo.item_data.segments[segIndex]['segmentOptions'] === undefined )
			{
				vm.cadwolf_fileInfo.item_data.segments[segIndex]['segmentOptions'] = [];
			}

			if ( vm.cadwolf_fileInfo.item_data.segments[segIndex]['id'] === undefined )
			{
				vm.cadwolf_fileInfo.item_data.segments[segIndex]['id'] = 0;
			}

			if ( vm.cadwolf_fileInfo.item_data.segments[segIndex]['parentID'] === undefined )
			{
				vm.cadwolf_fileInfo.item_data.segments[segIndex]['parentID'] = 0;
			}

			var newIndex = vm.cadwolf_fileInfo.item_data.segments[segIndex]['segmentOptions'].length;
			vm.cadwolf_fileInfo.item_data.segments[segIndex]['segmentOptions'].splice( newIndex, 0, tempObj );
		};




		/*
		*
		*   DELETE AN OPTION
		*
		*/
		function deleteOption( segIndex, optionIndex )
		{   
			console.log('Deleting segment '+optionIndex+' from segment '+segIndex);
			vm.cadwolf_fileInfo.item_data.segments[segIndex].segmentOptions.splice( optionIndex, 1 );
		};










		/*
		*
		*   ADD A SYSTEM
		*
		*/
		function addSystem( systemType, parentSystem, systemName, systemLevel )
		{   
			console.log('Adding system named '+systemName+' of type '+systemType+' with parent ');
			console.log(parentSystem);

			$http({
				method: 'POST',
				url: window.location.origin+'/files',
				data:{ parent_id : parentSystem.id, file_type_id : systemType, file_name : systemName, systemLevel : systemLevel }
			}).then(function successCallback( returnData ) {
				console.log(returnData);
				if (returnData.data.error==true)
				{
					if (returnData.data.errorType=="duplicate")
					{
						vm.showMessage( '', { messageType : 'failure', 
											  messageTitle : 'Name already taken', 
											  messageText : 'The name for the file, folder, or system given is already in use. Duplicate names are not allowed.'});
					}
				}else
				{
					vm.getPartTree( );
				}

			}, function errorCallback( returnData ) {

			});

		};








		/*
		*
		*   ADD A PART
		*
		*/
		function addPart( parentSystem, systemLevel )
		{   
			console.log('Adding a Part to ');
			console.log(parentSystem);

			$http({
				method: 'POST',
				url: window.location.origin+'/files/'+parentSystem.id+'/parts',
				data:{  systemLevel : parentSystem.item_data.systemLevel, 
						parent_id : parentSystem.id }
			}).then(function successCallback( returnData ) {
				vm.getPartTree( );

			}, function errorCallback( returnData ) {

			});

		};











		/*
		*
		*   DELETE A SYSTEM
		*
		*/
		function deleteSystem( item )
		{   
			console.log('Deleting system '+item.id);

			vm.partTree.forEach(function(thisItem, index)
			{   
				if (thisItem['id']==item['id'])
				{   
					vm.partTree.splice(index, 1);

					$http({
						method: "DELETE",
						url: window.location.origin+'/files/'+item['id']
					}).then(function successCallback( returnData ) {
						vm.getPartTree( );
					}, function errorCallback( returnData ) {});
				}
			});
		};













		/*
		*
		*   CHANGE THE NAME OF A SYSTEM
		*
		*/
		function changeSystemName( thisSystem, newName )
		{   
			console.log('Changing name from '+thisSystem['name']+' to '+newName);
			$http({
				method: 'PUT',
				url: window.location.origin+'/files/'+thisSystem['id']+'/nameChange',
				data:{ new_name : newName, parent_id : thisSystem['parent_id'] }
			}).then(function successCallback( returnData ) {
				console.log(returnData);
				if (returnData.data.error==true)
				{
					if (returnData.data.errorType=="duplicate")
					{
						vm.showMessage( '', { messageType : 'failure', 
											  messageTitle : 'Name already taken', 
											  messageText : 'The name for the file, folder, or system given is already in use. Duplicate names are not allowed.'});
					}
				}else
				{
					vm.getPartTree( );
				}

			}, function errorCallback( returnData ) {

			});
		};





		/*
		*
		*   MOVE A SYSTEM
		*
		*/
		function moveSystem( thisSystem, newParentID )
		{   
			console.log('In the move system function and moving '+thisSystem['name']+' to '+newParentID);

			var moveData = { 
				item:thisSystem,
				oldParent:thisSystem['parent_id'],
				newParent:newParentID
			}


			$http({
				method: 'POST',
				url: window.location.origin+'/moveItem',
                data: { moveData : moveData },
			}).then(function successCallback( returnData ) {
				console.log(returnData);
				if (returnData.data.error==true)
				{
					if (returnData.data.errorType=="duplicate")
					{
						vm.showMessage( '', { messageType : 'failure', 
											  messageTitle : 'Move Failed', 
											  messageText : 'For whatever reason, the move failed.'});
					}
				}

				delete vm.partTree
				vm.getPartTree( );


			}, function errorCallback( returnData ) {

			});

		};






		/*
		 *
		 * SAVE THIS PART TREE - THE PROPERTIES
		 *
		 */
		function savePartTree( ) 
		{   
			console.log('Save the part tree');
			$http({
				method: "POST",
				url: window.location.origin+'/files/savePartTree',
				data: { name : vm.cadwolf_fileInfo['name'],
						id : parseInt(vm.cadwolf_fileInfo['id'], 10),
						item_data : JSON.stringify(vm.cadwolf_fileInfo['item_data'])
					  }
			}).then(function successCallback( returnData ) {
				vm.showMessage( '', { messageType : 'success', 
									  messageTitle : 'File Saved', 
									  messageText : 'The file was successfully saved. You can continue editing it or check it in.'});
			}, function errorCallback( returnData ) {});
		};













		/*
		 *
		 * The smaller modal dialogs
		 *
		 */
		function showSmallModal( ev, modalType, modalVar, segIndex ) 
		{
			vm.modalType = modalType;
			vm.modalVar = modalVar;
			vm.segIndex = segIndex;
			console.log('In the modal dialog with type of '+modalType+', an index of '+segIndex+' and the var of ...');
			console.log(modalVar);
			$mdDialog.show({
				controller: function(){ return vm },
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/partTree/views/modalSmallTemplates.tmpl.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
					// Call to server to change a description by the items ID
			}, function() {
				
			});
		};













		/*
		 *
		 * Call the server to get the value for each file for the given name and parse the results
		 *
		 */
		function getSumValues( valueName )
		{   console.log('Getting the values of each file for '+valueName );

			var sendArr=[];
			for (var a=0; a<vm.partTree.length; a++)
			{
				if ((vm.partTree[a]['item_data']['systemIncluded']==1) &&
					((vm.partTree[a]['file_type_id']=='Document')))
				{
					sendArr.push(vm.partTree[a]['id']);
				}
			}

			console.log('The send array is ...');
			console.log(sendArr);

			$http({
				method: "GET",
				url: window.location.origin+'/files/'+vm.cadwolf_fileInfo.id+'/value',
				params: { 
							value : valueName,
							sendArr : JSON.stringify(sendArr)
						}
			}).then(function successCallback( returnData ) 
			{
				for (var a=0; a<vm.partTree.length; a++)
				{
					vm.partTree[a]['real'] = 0;
					vm.partTree[a]['imag'] = 0;
					vm.partTree[a]['units'] = '';
					vm.partTree[a]['itemValue'] = '';					
				}

				for (var a=0; a<returnData.data.length; a++)
				{
					for (var b=0; b<vm.partTree.length; b++)
					{
						if ( returnData.data[a]['id'] == vm.partTree[b]['id'] )
						{
							vm.partTree[b]['real'] = returnData.data[a]['real'];
							vm.partTree[b]['imag'] = returnData.data[a]['imag'];
							vm.partTree[b]['units'] = returnData.data[a]['units'];
							vm.partTree[b]['itemValue'] = vm.partTree[b]['real']['0-0']+' '+returnData.data[a]['units'];
							console.log('Setting the value of '+returnData.data[a]['id']+' to '+vm.partTree[b]['itemValue']);
						}
					}
				}
				vm.sumPartTreeValues();
			}, function errorCallback( returnData ) {});

		}		














		/*
		 *
		 * Sum all of the components into systems
		 *
		 */
		function sumPartTreeValues( valueName )
		{   
			console.log('In the sum part tree values function');

			var systemLength = 0, currentSystem=0;
			
			for (var a=0; a<vm.partTree.length; a++)
			{
				if ( vm.partTree[a]['item_data']['systemLevel'] > systemLength )
				{
					systemLength = vm.partTree[a]['item_data']['systemLevel'];
				}
				vm.partTree[a]['cad_data']['mass_data']['mass_calc'] = 0;
				vm.partTree[a]['cad_data']['mass_data']['weight_N_calc'] = 0;
				vm.partTree[a]['cad_data']['mass_data']['weight_P_calc'] = 0;
			}
			currentSystem = systemLength;

			while ( currentSystem >= 0 )
			{
				for (var a=0; a<vm.partTree.length; a++)
				{
					if ( vm.partTree[a]['item_data']['systemLevel'] == currentSystem-1 )
					{
						if ( vm.partTree[a]['item_data']['systemIncluded'] == 1 )
						{
							vm.partTree[a]['real'] = 0;
							for (var b=0; b<vm.partTree.length; b++)
							{
								if ( ( vm.partTree[a]['id'] == vm.partTree[b]['parent_id'] ) && ( vm.partTree[b]['item_data']['systemIncluded'] == 1 ) )
								{
									if (currentSystem > systemLength-1)
									{
										if ( ( vm.partTree[a]['real'] !== undefined ) && ( vm.partTree[b]['real'] !== undefined ) )
										{
											console.log('1 - Adding the value of system '+vm.partTree[b]['name']+' - '+vm.partTree[b]['item_data']['systemCount']+' * '+vm.partTree[b]['real']['0-0']+' to '+vm.partTree[a]['name']+' - '+vm.partTree[a]['real']);
											vm.partTree[a]['real'] = parseFloat(vm.partTree[a]['real'])+(parseInt(vm.partTree[b]['item_data']['systemCount'])*vm.partTree[b]['real']['0-0']);
											console.log('The result is '+vm.partTree[a]['real']);
										}

										if ( vm.partTree[b]['cad_data']['part_data']['partId'] !== undefined )
										{
											if ( vm.partTree[b]['cad_data']['mass_data']['bodies'][vm.partTree[b]['cad_data']['part_data']['partId']]['mass'][1] !== undefined )
											{
												console.log("1. Adding "+vm.partTree[b]['cad_data']['mass_data']['bodies'][vm.partTree[b]['cad_data']['part_data']['partId']]['mass'][1]+" to "+vm.partTree[a]['cad_data']['mass_data']['mass_calc']);
												vm.partTree[a]['cad_data']['mass_data']['mass_calc'] = parseFloat(vm.partTree[a]['cad_data']['mass_data']['mass_calc'])+(parseInt(vm.partTree[b]['item_data']['systemCount'])*vm.partTree[b]['cad_data']['mass_data']['bodies'][vm.partTree[b]['cad_data']['part_data']['partId']]['mass'][1]);
											}
											if ( vm.partTree[b]['cad_data']['mass_data']['bodies'][vm.partTree[b]['cad_data']['part_data']['partId']]['weight_N'] !== undefined )
											{
												console.log("2. Adding "+vm.partTree[b]['cad_data']['mass_data']['bodies'][vm.partTree[b]['cad_data']['part_data']['partId']]['weight_N']+" to "+vm.partTree[a]['cad_data']['mass_data']['weight_N_calc']);
												vm.partTree[a]['cad_data']['mass_data']['weight_N_calc'] = parseFloat(vm.partTree[a]['cad_data']['mass_data']['weight_N_calc'])+(parseInt(vm.partTree[b]['item_data']['systemCount'])*vm.partTree[b]['cad_data']['mass_data']['bodies'][vm.partTree[b]['cad_data']['part_data']['partId']]['weight_N']);
											}
											if ( vm.partTree[b]['cad_data']['mass_data']['bodies'][vm.partTree[b]['cad_data']['part_data']['partId']]['weight_P'] !== undefined )
											{
												console.log("3. Adding "+vm.partTree[b]['cad_data']['mass_data']['bodies'][vm.partTree[b]['cad_data']['part_data']['partId']]['weight_P']+" to "+vm.partTree[a]['cad_data']['mass_data']['weight_P_calc']);
												vm.partTree[a]['cad_data']['mass_data']['weight_P_calc'] = parseFloat(vm.partTree[a]['cad_data']['mass_data']['weight_P_calc'])+(parseInt(vm.partTree[b]['item_data']['systemCount'])*vm.partTree[b]['cad_data']['mass_data']['bodies'][vm.partTree[b]['cad_data']['part_data']['partId']]['weight_P']);
											}
										}else
										{
											if ( vm.partTree[b]['cad_data']['mass_data']['mass_calc'] !== undefined )
											{
												console.log("4. Adding "+vm.partTree[b]['cad_data']['mass_data']['mass_calc']+" to "+vm.partTree[a]['cad_data']['mass_data']['mass_calc']);
												vm.partTree[a]['cad_data']['mass_data']['mass_calc'] = parseFloat(vm.partTree[a]['cad_data']['mass_data']['mass_calc'])+(parseInt(vm.partTree[b]['item_data']['systemCount'])*vm.partTree[b]['cad_data']['mass_data']['mass_calc']);
											}
											if ( vm.partTree[b]['cad_data']['mass_data']['weight_N_calc'] !== undefined )
											{
												console.log("5. Adding "+vm.partTree[b]['cad_data']['mass_data']['weight_N_calc']+" to "+vm.partTree[a]['cad_data']['mass_data']['weight_N_calc']);
												vm.partTree[a]['cad_data']['mass_data']['weight_N_calc'] = parseFloat(vm.partTree[a]['cad_data']['mass_data']['weight_N_calc'])+(parseInt(vm.partTree[b]['item_data']['systemCount'])*vm.partTree[b]['cad_data']['mass_data']['weight_N_calc']);
											}
											if ( vm.partTree[b]['cad_data']['mass_data']['weight_P_calc'] !== undefined )
											{
												console.log("6. Adding "+vm.partTree[b]['cad_data']['mass_data']['weight_P_calc']+" to "+vm.partTree[a]['cad_data']['mass_data']['weight_P_calc']);
												vm.partTree[a]['cad_data']['mass_data']['weight_P_calc'] = parseFloat(vm.partTree[a]['cad_data']['mass_data']['weight_P_calc'])+(parseInt(vm.partTree[b]['item_data']['systemCount'])*vm.partTree[b]['cad_data']['mass_data']['weight_P_calc']);
											}
										}
									}else
									{
										console.log('2 - Adding the value of system '+vm.partTree[b]['name']+' - '+vm.partTree[b]['item_data']['systemCount']+' * '+vm.partTree[b]['real']+' to '+vm.partTree[a]['name']+' - '+vm.partTree[a]['real']);
										vm.partTree[a]['real'] = parseFloat(vm.partTree[a]['real'])+(parseInt(vm.partTree[b]['item_data']['systemCount'])*vm.partTree[b]['real']);
										console.log('The result is '+vm.partTree[a]['real']);
										if ( vm.partTree[b]['cad_data']['mass_data']['mass_calc'] !== undefined )
										{
											console.log("7. Adding "+vm.partTree[b]['cad_data']['mass_data']['mass_calc']+" to "+vm.partTree[a]['cad_data']['mass_data']['mass_calc']);
											vm.partTree[a]['cad_data']['mass_data']['mass_calc'] = parseFloat(vm.partTree[a]['cad_data']['mass_data']['mass_calc'])+(parseInt(vm.partTree[b]['item_data']['systemCount'])*vm.partTree[b]['cad_data']['mass_data']['mass_calc']);
										}
										if ( vm.partTree[b]['cad_data']['mass_data']['weight_N_calc'] !== undefined )
										{
											console.log("8. Adding "+vm.partTree[b]['cad_data']['mass_data']['weight_N_calc']+" to "+vm.partTree[a]['cad_data']['mass_data']['weight_N_calc']);
											vm.partTree[a]['cad_data']['mass_data']['weight_N_calc'] = parseFloat(vm.partTree[a]['cad_data']['mass_data']['weight_N_calc'])+(parseInt(vm.partTree[b]['item_data']['systemCount'])*vm.partTree[b]['cad_data']['mass_data']['weight_N_calc']);
										}
										if ( vm.partTree[b]['cad_data']['mass_data']['weight_P_calc'] !== undefined )
										{
											console.log("9. Adding "+vm.partTree[b]['cad_data']['mass_data']['weight_P_calc']+" to "+vm.partTree[a]['cad_data']['mass_data']['weight_P_calc']);
											vm.partTree[a]['cad_data']['mass_data']['weight_P_calc'] = parseFloat(vm.partTree[a]['cad_data']['mass_data']['weight_P_calc'])+(parseInt(vm.partTree[b]['item_data']['systemCount'])*vm.partTree[b]['cad_data']['mass_data']['weight_P_calc']);
										}
									}
								}
							}
						}else
						{
							vm.partTree[a]['itemValue'] = '-';
						}
						vm.partTree[a]['itemValue'] = Math.round(vm.partTree[a]['real']*10000)/10000;
						if ( vm.partTree[a]['itemValue'] === NaN)
						{
							vm.partTree[a]['itemValue'] = '-';
						}
					}
				}

				currentSystem = currentSystem-1;
			}

		};










		/*
		 *
		 * The various modal dialogs
		 *
		 */
		function showModal( ev, modalType ) 
		{
			if ( vm.cadwolf_fileInfo.item_data.cad_data === undefined ){ vm.cadwolf_fileInfo.item_data.cad_data=[]; }
			vm.thisItem = ev;
			vm.modalType = modalType;
			vm.getOnshapeDocs();
			vm.getPermLists( vm.thisItem );
			if (modalType=='Edit Title'){ vm.newName = vm.cadwolf_fileInfo.name; }
			$mdDialog.show({
				controller: function(){ return vm },
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/partTree/views/modalTemplates.tmpl.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
					// Call to server to change a description by the items ID
			}, function() {
				
			});
		};


		function cancel(){
			$mdDialog.cancel();
		};


		function acceptChanges(desc) {
			$mdDialog.hide(desc);
		};

		function acceptName(name) {
			$mdDialog.hide(name);
		};




	


		/*
		 *
		 * Make an item a favorite
		 *
		 */
		function favoriteItem( ) 
		{   
			Spark.state.user.user_info = utilityFactory.favoriteItem( 'Part Tree', 
																	  vm.cadwolf_fileInfo, 
																	  Spark.state.user.user_info, 
																	  window.location.pathname.replace(/^\/PartTree\//,'') ); 
			console.log('The item returned from the factory is '+Spark.state.user.user_info);
			vm.cadwolf_fileInfo.favorite=!vm.cadwolf_fileInfo.favorite; 
			vm.updateUserInfo();
		};







		/*
		 *
		 * Remove a favorite
		 *
		 */
		function removeFavItem( thisItem ) 
		{   
			Spark.state.user.user_info = utilityFactory.favoriteItem( 'Part Tree', 
																	  thisItem, 
																	  Spark.state.user.user_info, 
																	  window.location.pathname.replace(/^\/PartTree\//,'') ); 
			vm.updateUserInfo();
		};




		/*
		 *
		 * Update User Info
		 *
		 */
		function updateUserInfo( ) 
		{   
			$http({
				method: 'PUT',
				url: window.location.origin+'/updateUserInfo',
				data:{ userID : Spark.state.user.id, thisUser : Spark.state.user.user_info }
			}).then(function successCallback( returnData ) {
			}, function errorCallback( returnData ) {});
		};





		/**
		 *
		 * Navigate to a given URL
		 *
		 */
		function goToURL( thisURL )
		{
			$location.path( thisURL );
		}










		/*
		 *
		 * Show a message
		 *
		 */
		function showMessage(ev, messageObj) 
		{
			if (messageObj.messageType=="success")
			{
				var templateURL = 'app/main/apps/document/worksheet/views/templates/successMessage.tmpl.html';
			}
			if (messageObj.messageType=="failure")
			{
				var templateURL = 'app/main/apps/document/worksheet/views/templates/failureMessage.tmpl.html';
			}

			$mdDialog.show({
				controller: 'DocumentDialogController',
				templateUrl: templateURL,
				locals:{
					messageObj:messageObj,
				},
				controllerAs: 'vm',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {}, function() { });
		};









		/**
		 *
		 * Navigate to a new file
		 *
		 */
		function navigateUrl( fileItem, urlString )
		{
			console.log('In the navigate URL function');
			urlString = urlString.replace(/\-/g,'/').replace('/'+fileItem.name, '');
			var newURL=utilityFactory.makeURL( fileItem, location.href+''+urlString );
			$location.path(newURL.replace(window.location.origin+'',''));
		};







		/*
		 *
		 * Update the properties of an item
		 *
		 */
		function updateItem(item) 
		{   
			console.log('Updating '+item['id']+' with '+item['name']+'-'+item['parent_id']);
			$http({
				method: "PUT",
				url: window.location.origin+'/files/'+item['id'],
				data: { name : item['name'],
						parent_id : parseInt(item['parent_id'], 10),
						item_data : item['item_data']
					  }
			}).then(function successCallback( returnData ) {
			}, function errorCallback( returnData ) {

				vm.showMessage( '', { messageType : 'failure', 
									  messageTitle : 'Error Updating Item', 
									  messageText : 'There was an error updating the item. Make sure your login hasn\'t expired'});
			});
		};







		/*
		 *
		 *  Check the parts to see which systems are included
		 *
		 */
		function checkIncluded( parttree ) 
		{   
			console.log('In the check included function');

			// Turn off all systems
			for (var a=0; a<vm.partTree.length; a++)
			{
				if (vm.partTree[a]['file_type_id']=="Workspace")
				{   
					vm.partTree[a]['item_data']['systemIncluded'] = 0;
				}
			}

			// Turn on parent systems with active components
			for (var a=0; a<vm.partTree.length; a++)
			{
				if (vm.partTree[a]['file_type_id']=="Document")
				{   
					if (vm.partTree[a]['item_data']['systemIncluded'] == 1)
					{
						vm.includeParentSystem( vm.partTree[a]['parent_id'] );
					}
				}
			}
		};




		/*
		 *
		 *  Include on all parent systems
		 *
		 */
		function includeParentSystem( thisid ) 
		{   
			console.log('In the include parent system with an id of '+thisid);
			for (var a=0; a<vm.partTree.length; a++)
			{
				if ( thisid == vm.partTree[a]['id'])
				{
					vm.partTree[a]['item_data']['systemIncluded'] = 1;
					vm.includeParentSystem( vm.partTree[a]['parent_id'] );
				}
			}
		};



		/*
		 *
		 *  Include on all children systems
		 *
		 */
		function includeChildren( thisid ) 
		{   
			console.log('In the include children system with an id of '+thisid);
			for (var a=0; a<vm.partTree.length; a++)
			{
				if ( thisid == vm.partTree[a]['parent_id'])
				{
					vm.partTree[a]['item_data']['systemIncluded'] = 1;
					vm.includeChildren( vm.partTree[a]['id'] );
				}
			}
		};




		/*
		 *
		 *  Exclude on all children systems
		 *
		 */
		function excludeChildren( thisid ) 
		{   
			console.log('In the exclude children system with an id of '+thisid);
			for (var a=0; a<vm.partTree.length; a++)
			{
				if ( thisid == vm.partTree[a]['id'] )
				{
					vm.partTree[a]['item_data']['systemIncluded'] = 0;
				}

				if ( thisid == vm.partTree[a]['parent_id'] ) 
				{
					vm.partTree[a]['item_data']['systemIncluded'] = 0;
					vm.excludeChildren( vm.partTree[a]['id'] );
				}
			}
		};





		/*
		 *
		 * Get the documents for the onShape user
		 *
		 */
		function getOnshapeDocs( )
		{

			console.log('I am in the getOnshapeDocs function');

			$http({
				method: "GET",
				url: window.location.origin+'/files/getOnshapeDocs',
				params: { }
			}).then(function successCallback( returnData )
			{
				console.log(returnData.data.items);
				vm.cadFiles = returnData.data.items;
				vm.setCurrentSystem();
			}, function errorCallback( returnData ) {

				vm.showMessage( '', { messageType : 'failure', 
									  messageTitle : 'Error Getting Onshape Docs', 
									  messageText : 'There was an error retrieving the Onshape Docs. Make sure your login hasn\'t expired'});
			});
		}





		/*
		 *
		 * Set the current cad file from the array
		 *
		 */
		function setCurrentSystem( )
		{
			console.log('I am in the setCurrentSystem function');

			var flag=0;

			// Check to see if there is an entry for this item. 
			vm.cadwolf_fileInfo.item_data.cad_data.forEach(function(tempItem, tempIndex){
				if ( tempItem['document_id'] == vm.thisItem.id ){ flag = 1; }
			});

			// If no entry, make one
			if ( flag == 0 )
			{ 
				vm.cadwolf_fileInfo.item_data.cad_data.push( { 'document_id' : vm.thisItem.id,	// CADWOLF Document ID
													 'document_data'  : {},			 // Holds onShape Doc info
													 'element_data' : {},			   // Holds onShape element info
													 'part_data' : {}				   // Holds onShape part info
													  } );
			}


			// Set this cad_data item to the live item
			for (var a=0; a<vm.cadwolf_fileInfo.item_data.cad_data.length; a++)
			{
				if ( vm.cadwolf_fileInfo.item_data.cad_data[a]['document_id'] == vm.thisItem.id )
				{ 
					vm.thisCAD =  JSON.parse(JSON.stringify(vm.cadwolf_fileInfo.item_data.cad_data[a]));
				}
			}


			// Loop through the cad files and find the one selected
			for (var a=0; a<vm.cadFiles.length; a++)
			{
				if ( vm.thisCAD.document_data.id == vm.cadFiles[a]['id'] )
				{
					vm.thisCAD['document_data'] = JSON.parse(JSON.stringify(vm.cadFiles[a]));
				}
			}

		}







		/*
		 *
		 * Get the elements for a given CAD document
		 *
		 */
		function getCadElements( )
		{

			console.log('I am in the getCadElements function and the document id is '+vm.thisCAD.document_data.id);

			// Loop through the cad files and find the one selected
			for (var a=0; a<vm.cadFiles.length; a++)
			{
				console.log('Comparing '+vm.thisCAD.document_data.id+' to '+vm.cadFiles[a]['id']);

				if ( vm.thisCAD.document_data.id == vm.cadFiles[a]['id'] )
				{
					console.log('Matched');
					vm.thisCAD['document_data'] = {};
					vm.thisCAD['document_data'] = JSON.parse(JSON.stringify(vm.cadFiles[a]));
					vm.thisCAD['element_data'] = {};
					vm.thisCAD['part_data'] = {};
				}
			}


			// Call the function to pull the elements from the CAD system
			setTimeout(function()
		    {

	   			$http({
					method: "GET",
					url: '/files/getCadElements',
					params: { document_id : vm.thisCAD['document_data']['id'],
							  workspace_id : vm.thisCAD['document_data']['defaultWorkspace']['id'] }
				}).then(function successCallback( returnData ) 
				{
					console.log('Got the return data from get CAD elements');
					console.log( returnData );
					vm.cadElements = returnData.data;

				}, function errorCallback( returnData ) {


					/*
					vm.showMessage( '', { messageType : 'failure', 
										  messageTitle : 'Error Getting the CAD Elements', 
										  messageText : 'There was an error getting the CAD elements.'});
					*/

				});

			}, 1000);

		}




		/*
		 *
		 * Get the elements for a given CAD document
		 *
		 */
		function getCadParts( )
		{
			console.log('I am in the getCadParts function');

			// Loop through the cad elements and find the one selected
			for (var a=0; a<vm.cadElements.length; a++)
			{
				if ( vm.thisCAD.element_data.id == vm.cadElements[a]['id'] )
				{
					vm.thisCAD['element_data'] = vm.cadElements[a];
					vm.thisCAD['part_data'] = {};

				}
			}

			// Assemblies do not need this step
			if ( vm.thisCAD.element_data.elementType == 'PARTSTUDIO' )
			{

				// Call the function to pull the elements from the CAD system
				$http({
					method: "GET",
					url: '/files/getCadParts',
					params: { document_id : vm.thisCAD['document_data']['id'],
							  workspace_id : vm.thisCAD['document_data']['defaultWorkspace']['id'] }
				}).then(function successCallback( returnData ) 
				{
					// This returns a list of all parts. Find one(s) that match this element
					console.log( returnData );
					var partList=[];
					for (var a=0; a<returnData.data.length; a++)
					{
						if ( returnData.data[a]['elementId'] == vm.thisCAD['element_data']['id'] )
						{
							partList.push( returnData.data[a] );
						}
					}

					vm.cadParts = partList;

				}, function errorCallback( returnData ) {

					vm.showMessage( '', { messageType : 'failure', 
										  messageTitle : 'Error Getting CAD Parts', 
										  messageText : 'There was an error getting the CAD parts. Make sure your login hasn\'t expired'});
				});
			
			}else
			{
				vm.setCadProperties();
			}

		}




		/*
		 *
		 * Set the cad specific items for this array entry for onshape
		 *
		 */
		function setCadProperties( )
		{
			console.log('I am in the setCadProperties function');

			if ( vm.thisCAD.element_data.elementType == 'PARTSTUDIO' )
			{

				// Loop through the cad parts and find the one selected
				if ( vm.cadParts === undefined ){ vm.cadParts = []; }
				if ( ( vm.cadParts.length == 0 ) || ( vm.cadParts === undefined ) )
				{
					for (var a=0; a<vm.cadParts.length; a++)
					{
						if ( vm.thisCAD.part_data.partId == vm.cadParts[a]['partId'] )
						{
							vm.thisCAD['part_data'] = vm.cadParts[a];
						}
					}
				}


				// Set the fileInfo Variable
				for (var a=0; a<vm.cadwolf_fileInfo.item_data.cad_data.length; a++)
				{
					console.log('Comparing '+vm.cadwolf_fileInfo.item_data.cad_data[a]['document_id']+' to '+vm.thisCAD.document_id);
					if ( vm.cadwolf_fileInfo.item_data.cad_data[a]['document_id'] == vm.thisCAD.document_id )
					{ 
						console.log('Setting data');
						vm.cadwolf_fileInfo.item_data.cad_data[a]['type'] = "onshape";
						vm.cadwolf_fileInfo.item_data.cad_data[a]['document_data'] = JSON.parse(JSON.stringify(vm.thisCAD.document_data))
						vm.cadwolf_fileInfo.item_data.cad_data[a]['element_data'] = JSON.parse(JSON.stringify(vm.thisCAD.element_data))
						vm.cadwolf_fileInfo.item_data.cad_data[a]['part_data'] = JSON.parse(JSON.stringify(vm.thisCAD.part_data))
						if ( vm.thisCAD.mass_data !== undefined )
						{
							vm.cadwolf_fileInfo.item_data.cad_data[a]['mass_data'] = JSON.parse(JSON.stringify(vm.thisCAD.mass_data))
						}
						if ( vm.thisCAD.material_data !== undefined )
						{
							vm.cadwolf_fileInfo.item_data.cad_data[a]['material_data'] = JSON.parse(JSON.stringify(vm.thisCAD.material_data))
						}
					}
				}


				// Get the material and mass properties
				$http({
					method: "GET",
					url: '/files/getCadMaterial',
					params: { document_id : vm.thisCAD['document_data']['id'],
							  workspace_id : vm.thisCAD['document_data']['defaultWorkspace']['id'],
							  element_id : vm.thisCAD['element_data']['id'],
							  part_id : vm.thisCAD['part_data']['partId'] }
				}).then(function successCallback( returnData ) 
				{
					console.log( returnData );
					if ( returnData.data !== undefined )
					{
						vm.thisCAD['material_data'] = returnData.data;
					}

					// Place the cad data in the part tree so that it can be used
					vm.syncCadTree();


				}, function errorCallback( returnData ) {

					vm.showMessage( '', { messageType : 'failure', 
										  messageTitle : 'Error Getting CAD Materials', 
										  messageText : 'There was an error getting the CAD materials. Make sure your login hasn\'t expired'});
				});



				// Get the material and mass properties
				$http({
					method: "GET",
					url: '/files/getCadMass',
					params: { document_id : vm.thisCAD['document_data']['id'],
							  workspace_id : vm.thisCAD['document_data']['defaultWorkspace']['id'],
							  element_id : vm.thisCAD['element_data']['id'],
							  part_id : vm.thisCAD['part_data']['partId'] }
				}).then(function successCallback( returnData ) 
				{
					console.log( returnData );
					if ( returnData.data !== undefined )
					{
						vm.thisCAD['mass_data'] = returnData.data;
					}

					// Place the cad data in the part tree so that it can be used
					vm.syncCadTree();

				}, function errorCallback( returnData ) {

					vm.showMessage( '', { messageType : 'failure', 
										  messageTitle : 'Error Getting CAD Mass', 
										  messageText : 'There was an error retrieving the CAD Mass. Make sure your login hasn\'t expired'});
				});

			}else
			{

				// Set the fileInfo Variable
				for (var a=0; a<vm.cadwolf_fileInfo.item_data.cad_data.length; a++)
				{
					console.log('Comparing '+vm.cadwolf_fileInfo.item_data.cad_data[a]['document_id']+' to '+vm.thisCAD.document_id);
					if ( vm.cadwolf_fileInfo.item_data.cad_data[a]['document_id'] == vm.thisCAD.document_id )
					{ 
						console.log('Setting data');
						vm.cadwolf_fileInfo.item_data.cad_data[a]['document_data'] = JSON.parse(JSON.stringify(vm.thisCAD.document_data))
						vm.cadwolf_fileInfo.item_data.cad_data[a]['element_data'] = JSON.parse(JSON.stringify(vm.thisCAD.element_data))
						vm.cadwolf_fileInfo.item_data.cad_data[a]['part_data'] = JSON.parse(JSON.stringify(vm.thisCAD.part_data))
						if ( vm.thisCAD.mass_data !== undefined )
						{
							vm.cadwolf_fileInfo.item_data.cad_data[a]['mass_data'] = JSON.parse(JSON.stringify(vm.thisCAD.mass_data))
						}
						if ( vm.thisCAD.material_data !== undefined )
						{
							vm.cadwolf_fileInfo.item_data.cad_data[a]['material_data'] = JSON.parse(JSON.stringify(vm.thisCAD.material_data))
						}
					}
				}

				vm.getAssemblyMass();
			}

		}





		/*
		 *
		 * Prompt the server to calculate the mass of an assembly for a given document
		 *
		 */
		function getAssemblyMass( document_id )
		{
			console.log('I am in the getAssemblyMass function');

			// Since this item is called from several places, thisCAD is linked via the document id
			for (var a=0; a<vm.cadwolf_fileInfo.item_data.cad_data.length; a++)
			{
				if ( vm.cadwolf_fileInfo.item_data.cad_data[a]['document_id'] == document_id )
				{ 
					vm.thisCAD =  vm.cadwolf_fileInfo.item_data.cad_data[a];
				}
			}

			// Get the mass properties
			$http({
				method: "GET",
				url: '/files/getCadAssMass',
				params: { document_id : vm.thisCAD['document_data']['id'],
						  workspace_id : vm.thisCAD['document_data']['defaultWorkspace']['id'],
						  element_id : vm.thisCAD['element_data']['id'] }
			}).then(function successCallback( returnData ) 
			{
				console.log( returnData );
				vm.thisCAD['mass_data'] = returnData.data;

				// Place the cad data in the part tree so that it can be used
				vm.syncCadTree();

			}, function errorCallback( returnData ) {

				vm.showMessage( '', { messageType : 'failure', 
									  messageTitle : 'Error Getting Assembly Mass', 
									  messageText : 'There was an error getting the assembly mass. Make sure your login hasn\'t expired'});
			});

		}




		/*
		 *
		 * Update the mass of a part or system
		 *
		 */
		function updateMass( thisSystem )
		{
			console.log('I am in the updateMass function');
			console.log(thisSystem);

			vm.thisCAD = {};

			// Set this cad_data item to the live item
			for (var a=0; a<vm.cadwolf_fileInfo.item_data.cad_data.length; a++)
			{
				if ( vm.cadwolf_fileInfo.item_data.cad_data[a]['document_id'] == thisSystem.id )
				{ 
					console.log(vm.cadwolf_fileInfo.item_data.cad_data[a]);
					vm.thisCAD =  vm.cadwolf_fileInfo.item_data.cad_data[a];
				}
			}

			if ( vm.thisCAD.element_data.elementType == "ASSEMBLY" )
			{
				vm.getAssemblyMass( vm.thisCAD['document_id'] );
			}

			if ( vm.thisCAD.element_data.elementType == "PARTSTUDIO" )
			{
				vm.setCadProperties( );
			}

		}




		/*
		 *
		 * Update the material of a part or system
		 *
		 */
		function updateMaterial( thisSystem )
		{
			console.log('I am in the updateMaterial function');
			console.log(thisSystem);

			vm.thisCAD = {};
			vm.thisItem = thisSystem;

			// Set this cad_data item to the live item
			for (var a=0; a<vm.cadwolf_fileInfo.item_data.cad_data.length; a++)
			{
				if ( vm.cadwolf_fileInfo.item_data.cad_data[a]['document_id'] == thisSystem.id )
				{ 
					console.log(vm.cadwolf_fileInfo.item_data.cad_data[a]);
					vm.thisCAD =  vm.cadwolf_fileInfo.item_data.cad_data[a];
				}
			}

			if ( vm.thisCAD.element_data.elementType == "PARTSTUDIO" )
			{
				// vm.getCadParts();
				vm.setCadProperties( );
			}

		}


		/*
		 *
		 * Update the mass of every part or system
		 *
		 */
		function updateAllMass( index )
		{
			console.log('I am in the updateAllMass function - '+index);

			vm.thisCAD = {};

			if ( vm.cadwolf_fileInfo.item_data.cadType == 'onshape' )
			{
				if ( index < vm.cadwolf_fileInfo.item_data.cad_data.length )
				{


					console.log(vm.cadwolf_fileInfo.item_data.cad_data[index]);
					vm.thisCAD =  vm.cadwolf_fileInfo.item_data.cad_data[index];

					if ( vm.thisCAD.element_data.elementType == "ASSEMBLY" )
					{
						// vm.getAssemblyMass( vm.thisCAD['document_id'] );

						// Get the mass properties
						$http({
							method: "GET",
							url: '/files/getCadAssMass',
							params: { document_id : vm.thisCAD['document_data']['id'],
									  workspace_id : vm.thisCAD['document_data']['defaultWorkspace']['id'],
									  element_id : vm.thisCAD['element_data']['id'] }
						}).then(function successCallback( returnData ) 
						{
							console.log( returnData );
							vm.thisCAD['mass_data'] = returnData.data;

							// Place the cad data in the part tree so that it can be used
							vm.syncCadTree();

							// Call the next component
							vm.updateAllMass( parseInt(index) + 1 );

						}, function errorCallback( returnData ) {

							vm.showMessage( '', { messageType : 'failure', 
												  messageTitle : 'Error Getting the Assembly Mass', 
												  messageText : 'There was an error getting the assembly mass. Make sure your login hasn\'t expired'});
						});

					}

					if ( vm.thisCAD.element_data.elementType == "PARTSTUDIO" )
					{
						// Get the material and mass properties
						$http({
							method: "GET",
							url: '/files/getCadMass',
							params: { document_id : vm.thisCAD['document_data']['id'],
									  workspace_id : vm.thisCAD['document_data']['defaultWorkspace']['id'],
									  element_id : vm.thisCAD['element_data']['id'],
									  part_id : vm.thisCAD['part_data']['partId'] }
						}).then(function successCallback( returnData ) 
						{
							console.log( returnData );
							vm.thisCAD['mass_data'] = returnData.data;

							// Place the cad data in the part tree so that it can be used
							vm.syncCadTree();

							// Call the next component
							vm.updateAllMass( parseInt(index) + 1 );

						}, function errorCallback( returnData ) {

							vm.showMessage( '', { messageType : 'failure', 
												  messageTitle : 'Error Getting CAD Mass', 
												  messageText : 'There was an error getting the CAD Mass. Make sure your login hasn\'t expired'});
						});

					}
				
				}

			}else if ( vm.cadwolf_fileInfo.item_data.cadType == 'fusion' )
			{

				if ( index < vm.cadwolf_fileInfo.item_data.cad_data.length )
				{

					// Call the function that prompts the Autodesk Forge system to send new data and create a new thumbnail
					vm.updateFusionData( vm.cadwolf_fileInfo.item_data.cad_data[index]['id'], vm.cadwolf_fileInfo.item_data.cad_data[index]['document_id'] );

					// Call the next component
					vm.updateAllMass( parseInt(index) + 1 );

					// Place the cad data in the part tree so that it can be used
					vm.syncCadTree();

				}

			}


		}




		/*
		 *
		 * Remove a linked CAD item
		 *
		 */
		function removeCadConn( itemID )
		{
			console.log('I am in the removeCadConnections function with an ID of '+itemID);


			// Remove that connection from the part tree file
			for (var a=0; a<vm.cadwolf_fileInfo.item_data.cad_data.length; a++)
			{
				console.log('Comparing '+vm.cadwolf_fileInfo.item_data.cad_data[a]['document_id']+' to '+itemID);
				if ( vm.cadwolf_fileInfo.item_data.cad_data[a]['document_id'] == itemID )
				{ 
					console.log('I got a match');
					vm.cadwolf_fileInfo.item_data.cad_data.splice( a , 1 );
				}
			}

			// Remove the connection from the stored data
			for ( var b=0; b<vm.partTree.length; b++ )
			{

				if ( vm.partTree[b]['id'] === itemID ) 
				{
					vm.partTree[b]['cad_data'] = {};
					vm.partTree[b]['cad_data']['takeFromCAD'] = true;  
					vm.partTree[b]['cad_data']['document_data'] = {};
					vm.partTree[b]['cad_data']['mass_data'] = {};
					vm.partTree[b]['cad_data']['element_data'] = {};
					vm.partTree[b]['cad_data']['part_data'] = {};
					vm.partTree[b]['cad_data']['material_data'] = {};
				}
			}

			//vm.setCadProperties();
			vm.syncCadTree();

		}




		/*
		 *
		 * Sync cad array with part tree data
		 *
		 */
		function syncCadTree( )
		{
			console.log('I am in the syncCadTree function');

			if ( vm.cadwolf_fileInfo.item_data.cad_data === undefined )
			{
				vm.cadwolf_fileInfo['item_data']['cad_data'] = [];
			}

			for ( var b=0; b<vm.partTree.length; b++ )
			{

				if ( vm.partTree[b]['cad_data'] === undefined ) 
				{
					vm.partTree[b]['cad_data'] = {};
					vm.partTree[b]['cad_data']['takeFromCAD'] = true;  
					vm.partTree[b]['cad_data']['document_data'] = {};
					vm.partTree[b]['cad_data']['mass_data'] = {};
					vm.partTree[b]['cad_data']['element_data'] = {};
					vm.partTree[b]['cad_data']['part_data'] = {};
					vm.partTree[b]['cad_data']['material_data'] = {};
				}

				for ( var a=0; a<vm.cadwolf_fileInfo.item_data.cad_data.length; a++ )
				{
					if ( vm.cadwolf_fileInfo.item_data.cad_data[a]['document_id'] == vm.partTree[b]['id'] )
					{
						if ( vm.cadwolf_fileInfo['item_data']['cad_data'][a]['takeFromCAD'] == undefined )
						{
							vm.cadwolf_fileInfo['item_data']['cad_data'][a]['takeFromCAD'] = true;   
						}
						vm.partTree[b]['cad_data'] = vm.cadwolf_fileInfo['item_data']['cad_data'][a];
					}
				}

			}
		}







		/*
		 *
		 * Calculate the mass of an assembly from the cad data for the subcomponents
		 *
		 */
		function calculateMass( thisSystem )
		{
			console.log('I am in the calculateMass function');
			
			vm.sumPartTreeValues();
		}






		/*
		 *
		 *  Get the status of every item in the part tree and shot it.
		 *
		 */
		function getTreeStatus( fileInfo )
		{
			console.log('I am in the getTreeStatus function');
			
			$http({
				method: "GET",
				url: '/files/'+vm.cadwolf_fileInfo.id+'/children'
			}).then(function successCallback( returnData ) 
			{
				console.log( returnData );
				vm.partTree.forEach(function(treeItem, treeIndex){
					returnData.data.forEach(function(tempItem, tempIndex){
						if ( tempItem['id'] == treeItem['id'] )
						{
							vm.partTree[treeIndex]['needs_update'] = tempItem['needs_update']
						}
					});
				});

			}, function errorCallback( returnData ) {

				vm.showMessage( '', { messageType : 'failure', 
									  messageTitle : 'Error Getting the part tree children', 
									  messageText : 'There was an error getting the part tree children. Make sure your login hasn\'t expired'});
			});

		}






		/*
		 *
		 * Items associated with adding a document to the part tree
		 *
		 */


		/*
		 *
		 * Get the contents of a workspace
		 *
		 */
		function getFolderContents( thisItem, thisURL )
		{   
			console.log('Getting the contents of '+thisURL);
			$http({
				method: "GET",
				url: '/files',
				params: { thisURL : thisURL.replace(/\~2F/g,'/') }
			}).then(function successCallback( returnData ) 
			{
				console.log( returnData );
				vm.currentFile = returnData['data']['fileInfo'];
				if ( typeof(vm.currentFile.item_data) == "string" )
				{
					vm.currentFile.item_data = JSON.parse(vm.currentFile.item_data);
				}
				vm.currentContents = returnData['data']['files'];
				vm.currentContents.forEach(
					function(thisEq, index){
						if ( typeof(thisEq['item_data'])=="string")
						{
							thisEq['item_data']=JSON.parse(thisEq['item_data']);
						}
					}
				);

			}, function errorCallback( returnData ) {

				vm.currentContents = [];

				vm.showMessage( '', { messageType : 'failure', 
									  messageTitle : 'Error getting the folder contents', 
									  messageText : 'There was an error getting the folder contents. Make sure your login hasn\'t expired'});
			});
		}


		/*
		 *
		 *  Get the status of every item in the part tree and shot it.
		 *
		 */
		function addRelatedDoc( thisItem )
		{
			console.log('I am in the addRelatedDoc function');
			console.log( thisItem );
			vm.cadwolf_fileInfo.item_data.assFiles.push( thisItem );
		}



		/*
		 *
		 * Get the contents of a document
		 *
		 */
		function setNewURL( thisName )
		{
			vm.inputURL = vm.inputURL+'/'+thisName;
			this.getFolderContents( '', vm.inputURL );
		}





		/**
		 *
		 * Items related to the permissions
		 *
		 */


		/**
		 *
		 * Handle a change in the permissions settings
		 *
		 */
		function getPermLists( fileItem )
		{
			$http({
				method: "GET",
				url: window.location.origin+'/permissions/'+fileItem['id'],
			}).then(function successCallback( returnData ) {
				fileItem['item_data']['permList'] = returnData.data;
			}, function errorCallback( returnData ) {
				fileItem['item_data']['permList'] = [];
			});
		}



		/**
		 *
		 * Handle a change in the permissions settings. 
		 *
		 */
		function handlePermissions( fileItem, changeType )
		{
			if ( changeType == 'view' )
			{
				if (fileItem['item_data']['viewPerm']=='list')
				{
					fileItem['item_data']['editPerm']='list';
					fileItem['item_data']['adminPerm']='list';
				}
				if (fileItem['item_data']['viewPerm']=='inherit')
				{
					fileItem['item_data']['editPerm']='inherit';
					fileItem['item_data']['adminPerm']='inherit';
				}
			}
			if ( changeType == 'edit' )
			{
				if (fileItem['item_data']['editPerm']=='list')
				{
					fileItem['item_data']['adminPerm']='list';
					if (fileItem['item_data']['viewPerm']=="inherit")
					{
						fileItem['item_data']['viewPerm']="list";
					}
				}
				if (fileItem['item_data']['editPerm']=='inherit')
				{
					fileItem['item_data']['viewPerm']='inherit';
					fileItem['item_data']['adminPerm']='inherit';
				}
			}
			if ( changeType == 'admin' )
			{
				if (fileItem['item_data']['adminPerm']=='inherit')
				{
					fileItem['item_data']['viewPerm']='inherit';
					fileItem['item_data']['editPerm']='inherit';
				}
				if (fileItem['item_data']['adminPerm']=='list')
				{
					if (fileItem['item_data']['viewPerm']=="inherit")
					{
						fileItem['item_data']['viewPerm']="list";
					}
					if (fileItem['item_data']['editPerm']=="inherit")
					{
						fileItem['item_data']['editPerm']="list";
					}
				}
			}
			$http({
				method: "POST",
				url: window.location.origin+'/permissions/'+fileItem['id'],
				params: { viewPerm : fileItem['item_data']['viewPerm'], editPerm : fileItem['item_data']['editPerm'], adminPerm : fileItem['item_data']['adminPerm'] }
			}).then(function successCallback( returnData ) {
			}, function errorCallback( returnData ) {});

		}




		/**
		 *
		 * Check to see if the user that was entered is valid
		 *
		 */
		function addPermUser( fileItem )
		{
			var thisUser = vm.potentialUser; 
			var userType = vm.userType; 
			var permType = vm.permType;

			console.log('In the add perm user code');
			$http({
				method: "POST",
				url: window.location.origin+'/addPermUser',
				params: { fileID : fileItem['id'], 
						  permType : permType, 
						  userName : thisUser, 
						  userType : userType,
						  file_type_id : fileItem['file_type_id'] }
			}).then(function successCallback( returnData ) 
			{
				if (returnData.data == 'noPerm')
				{
					vm.currentListPermError = 'You do not have permissions to add or delete users';
				
				}else if (returnData.data == 'noUser')
				{
					vm.currentListPermError = 'No user was found with that name';
				
				}else 
				{
					fileItem.item_data.permList = returnData.data;
				}
			}, function errorCallback( returnData ) {});
		}




		/**
		 *
		 * Delete a user from the list 
		 *
		 */
		function deletePermUser( fileItem, userID, userType )
		{
			$http({
				method: "POST",
				url: window.location.origin+'/deletePermUser',
				params: { fileID : fileItem['id'], userType : userType, userID : userID }
			}).then(function successCallback( returnData ) {
				if (returnData.data == 'noPerm')
				{
					vm.currentListPermError = 'You do not have permissions to add or delete users';
				
				}else if (returnData.data == 'noUser')
				{
					vm.currentListPermError = 'No user was found with that name';
				
				}else 
				{
					fileItem.item_data.permList = returnData.data;
				}
			}, function errorCallback( returnData ) {});

		}





		/**
		 *
		 * Change a users permission 
		 *
		 */
		function changeUserPerm( fileItem, userID, userType, permType )
		{
			$http({
				method: "POST",
				url: window.location.origin+'/changePermUser',
				params: { fileID : fileItem['id'], permType : permType, userType : userType, userID : userID }
			}).then(function successCallback( returnData ) {
				if (returnData.data['message']=='noPerm')
				{
					vm.currentListPermError = 'You do not have permissions to add or delete users';
				
				}else if (returnData.data['message']=='noUser')
				{
					vm.currentListPermError = 'No user was found with that name';
				
				}else
				{ 
					fileItem.item_data.permList = returnData.data;
				}
			}, function errorCallback( returnData ) {});

		}






		/**
		 *
		 * Get the contents of a folder from the server 
		 *
		 */
		function getFolderContents( thisItem, thisURL )
		{   
			thisURL = thisURL.replace(/\/\//g, "/");
			console.log('Getting the contents of '+thisURL);
			$http({
				method: "GET",
				url: '/files',
				params: { thisURL : thisURL.replace(/\~2F/g,'/') }
			}).then(function successCallback( returnData ) 
			{
				console.log( returnData );
				vm.currentFile = returnData['data']['fileInfo'];
				if ( typeof(vm.currentFile.item_data) == "string" )
				{
					vm.currentFile.item_data = JSON.parse(vm.currentFile.item_data);
				}
				vm.currentContents = returnData['data']['files'];
				vm.currentContents.forEach(
					function(thisEq, index){
						if ( typeof(thisEq['item_data'])=="string")
						{
							thisEq['item_data']=JSON.parse(thisEq['item_data']);
						}
					}
				);
			}, function errorCallback( returnData ) {
				vm.currentContents = [];
			});
		}







		/*
		 *
		 * Get the contents of a document
		 *
		 */
		function setNewURL( thisName )
		{
			vm.inputURL = vm.inputURL+'/'+thisName;
			this.getFolderContents( '', vm.inputURL );
		}



		/*
		 *
		 * This will list the CAD models to import and offer the 
		 *
		 */
		function setImportDoc( copiedItem, originalItem )
		{
			console.log('In the set Import Doc function');
			console.log("The IDs for the original and copied docs are "+copiedItem.id+" - "+originalItem.id);
			console.log(copiedItem);
			console.log(originalItem);

			// Set the copied and original itemss
			vm.copiedItem = copiedItem;
			vm.originalItem = originalItem;

			// Set the items to not be imported
			vm.copiedItem.item_data.importedCAD.forEach(function(thisItem, index)
			{
				thisItem.includedImport = false;
			});


			// Set the parents that the CAD can be pushed to
			vm.parentCAD = [];
			vm.populateCADParent( originalItem.parent_id );

			// Set the parent items to not be imported included
			vm.parentCAD.forEach(function(thisItem, index)
			{
				thisItem.importTo = false;
			});

			console.log('The parent system is ...');
			console.log(vm.parentCAD);
		}






		/*
		 *
		 *  Set this item as a possible parent CAD
		 *
		 */
		function populateCADParent( thisID )
		{
			vm.partTree.forEach(function(thisItem, index)
			{   
				if ( thisItem['id'] == thisID )
				{
					if ( thisItem.cad_data.element_data.id !== undefined )
					{
						vm.parentCAD.push(thisItem);
						vm.populateCADParent( thisItem.parent_id );
					}
				}
			});
		}



		/*
		 *
		 *  Kick off the process of importing the CAD item
		 *
		 */
		function submitCadImport( )
		{
			// Grab the CAD item that the part is being imported into
			var destinationCAD = {};
			vm.parentCAD.forEach(function(thisItem, index)
			{   
				if ( thisItem.importTo )
				{
					destinationCAD = thisItem;
				}
			});

			// Grab the CAD to be imported
			var copiedCAD = [];
			vm.copiedItem['item_data']['importedCAD'].forEach(function(thisItem, index)
			{   
				if ( thisItem.includedImport )
				{
					copiedCAD.push(thisItem);
				}
			});


			var thisURL = '/files/importDoc'
			$http({
				method: "POST",
				url: thisURL,
				data: { copiedID : vm.copiedItem.id,
						  originalID : vm.originalItem.id,
						  copiedCAD : copiedCAD,
						  destinationCAD : destinationCAD,
						  partTreeID : vm.cadwolf_fileInfo.id }
			}).then(function successCallback( returnData )
			{
				console.log(returnData);
			});

		}


		/*
		*
		*   Check Tree Integrity - This function traverses the tree after changes are 
		*	made to the tree struction and flags any errors that may have been created
		*	Errors could arise from tree sections being added or deleted - resulting in
		*	systems having no proper parent. Name changes could also cause issues if the
		* 	change was not caught and the system properly renamed. 
		*
		*	1. Go through tree and make sure that all names of systems have matching entries
		*	in the tree. This would result from a user changing the tree system setup after
		*	the tree has been established.
		*
		*
		*
		*	For all errors, set the bit to show that the tree has an error and then set that
		*	bit for the system and push that error to the array holding them for that system
		*
		*/
		function checkTreeIntegrity( )
		{   
			console.log('In the check tree integrity function');

			// Recreate the tree names to ensure that we have the latest data
			vm.createPartTreeNames( );

			vm.partTree.forEach(function(tempItem, tempIndex){
				
				tempItem['errorFlag'] = false;
				tempItem['errorParent'] = false;
				var splitName = tempItem['treeNameFull'].split('-');

				// If the created tree name cannot be traversed folder by folder properly
				// then there is a problem that should be flagged as a parent one
				vm.cadwolf_fileInfo.item_data.segments.forEach(function(tempSeg, segIndex){

					if ( tempItem.item_data.systemLevel == segIndex )
					{
						var flag = 0;
						tempSeg.segmentOptions.forEach(function(segOpt, optionIndex){

							if ( segOpt.optionName == splitName[segIndex] )
							{
								flag = 1;
								console.log('Match for index - '+segIndex);
							}
						});
						if ( flag == 0 )
						{
							tempItem['errorFlag'] = true;
							tempItem['errorParent'] = true;							
						}
					}
				});
					
			});

		}









		/*----------------------------------------
		 *
		 *
		 *
		 * FUSION 360 FUNCTIONS
		 *
		 *
		 *
		 -----------------------------------------*/




		/*
		 *
		 * Get the hubs for the autocad user
		 *
		 */
		function getAutocadHubs( )
		{

			console.log('I am in the getAutocadHubs function');

			vm.autocadFileSelected = false;
			vm.autocadBodySelected = false;
			vm.showFusionProps = false;
			vm.autocadLinkSet = false;
			vm.newCADConnect = { 	"id":"", 
									"hub":"", 
									"hubData":{}, 
									"project":"", 
									"projectData":{}, 
									"rootFolder":"", 
									"rootData":{}, 
									"folders":[], 
									"folderData":[], 
									"file":"", 
									"fileData":{},
									"bodyData":{} };

			$http({
				method: "GET",
				url: window.location.origin+'/files/getAutocadHubs',
				params: { }
			}).then(function successCallback( returnData )
			{
				console.log(returnData);
				vm.autocadHubs = returnData.data.data;
				console.log('The hubs are ...');
				console.log(vm.autocadhubs);


			}, function errorCallback( returnData ) 
			{ 

			});

		}





		/*
		 *
		 * Get the projects for the autocad user - after hub is selected
		 *
		 */
		function getAutocadProjects( hubID )
		{

			console.log('I am in the getAutocadProjects function with '+hubID);


			// Place the hub data in the appropriate space
			vm.autocadHubs.forEach(
				function(thisHub, index){

					if ( thisHub.id == hubID )
					{
						var tempData = thisHub;
						vm.newCADConnect.hubData = tempData;
					}

				}
			);

			$http({
				method: "GET",
				url: window.location.origin+'/files/getAutocadProjects/'+hubID,
				params: { }
			}).then(function successCallback( returnData )
			{
				console.log(returnData);
				vm.autocadProjects = returnData.data.data;
				console.log('The projects are ...');
				console.log(vm.autocadProjects);

			}, function errorCallback( returnData ) 
			{ 

			});

			vm.bodyCollection = [];
			vm.autocadContents = [];
			vm.autocadFolders = [];

		}



		/*
		 *
		 * Get the folders for the autocad user for a project - after project selected
		 *
		 */
		function getAutocadFolders( hubID, projectID )
		{

			console.log('I am in the getAutocadFolders function with '+hubID+' - '+projectID);


			// Place the project data in the appropriate space
			vm.autocadProjects.forEach(
				function(thisProject, index){

					if ( thisProject.id == projectID )
					{
						var tempData = thisProject;
						vm.newCADConnect.projectData = tempData;
					}

				}
			);


			$http({
				method: "GET",
				url: window.location.origin+'/files/getAutocadFolders/'+hubID+'/'+projectID,
				params: { }
			}).then(function successCallback( returnData )
			{
				console.log(returnData);
				vm.autocadFolders = returnData.data.data;
				console.log('The folders are ...');
				console.log(vm.autocadFolders);

				vm.bodyCollection = [];
				vm.autocadContents = [];


			}, function errorCallback( returnData ) 
			{ 

			});

		}







		/*
		 *
		 * Get the contents for a folder
		 *
		 */
		function getAutocadFolderContents( projectID, folderID )
		{

			console.log('I am in the getAutocadFolderContents function with '+projectID+' - '+folderID);


			// Place the project data in the appropriate space
			vm.autocadFolders.forEach(
				function(thisFolder, index){

					if ( thisFolder.id == folderID )
					{
						var tempData = thisFolder;
						vm.newCADConnect.rootData = tempData;
					}

				}
			);


			$http({
				method: "GET",
				url: window.location.origin+'/files/getAutocadFolderContents/'+projectID+'/'+folderID,
				params: { }
			}).then(function successCallback( returnData )
			{
				console.log(returnData);
				vm.autocadContents = returnData.data.data;
				if ( returnData.data.included !== undefined )
				{
					vm.autocadIncluded = returnData.data.included
				}
				console.log('The contents are ...');
				console.log(vm.autocadContents);

				vm.bodyCollection = [];

			}, function errorCallback( returnData ) 
			{ 

			});

		}











		/*
		 *
		 * Get the contents for a folder
		 *
		 */
		function getAutocadItem( projectID, itemID )
		{

			console.log('I am in the getAutocadItem function with '+projectID+' - '+itemID);

			$http({
				method: "GET",
				url: window.location.origin+'/files/getAutocadItem/'+projectID+'/'+itemID,
				params: { }
			}).then(function successCallback( returnData )
			{
				console.log(returnData);
				vm.autocadItem = returnData.data.data;
				console.log('The item is ...');
				console.log(vm.autocadItem);

			}, function errorCallback( returnData ) 
			{ 

			});

		}









		/*
		 *
		 * Sets a folder or file. If folder, it is placed into array and contents are called
		 *
		 */
		function setAutocadItem( autocadItem, thisIndex, projectID )
		{

			console.log('I am in the setAutocadItem function with '+thisIndex);
			console.log(autocadItem);

			if ( thisIndex == 'add' )
			{
				thisIndex = vm.newCADConnect.folders.length;
			}

			if ( autocadItem.type == "folders" )
			{

				// If this index will add a level to the folders, just add it
				if ( thisIndex >= vm.newCADConnect.folders.length )
				{

					// Add to the array holding the folder data
					vm.newCADConnect.folderData[vm.newCADConnect.folderData.length] = { "name" : autocadItem.attributes.name,
																					 "displayName" : autocadItem.attributes.displayName,
																					 "id" : autocadItem.id }

					// Add to the id array
					vm.newCADConnect.folders[vm.newCADConnect.folderData.length] = autocadItem.id;


				// If this index is inside the array, cut off the array where appropriate
				}else if ( thisIndex < vm.newCADConnect.folders.length )
				{

					// Add to the array holding the folder data
					vm.newCADConnect.folderData[thisIndex] = { "name" : autocadItem.attributes.name,
															   "displayName" : autocadItem.attributes.displayName,
															   "id" : autocadItem.id }

					// Add to the id array
					vm.newCADConnect.folders[thisIndex] = autocadItem.id;


					// Delete the rest of the array as it is insolent
					for ( var a=thisIndex+1; a<vm.newCADConnect.folders.length; a++ )
					{
						vm.newCADConnect.folderData.splice(a, 1)
						vm.newCADConnect.folders.splice(a, 1)
					}

				}

				vm.autocadFileSelected = false;
				vm.showFusionProps = false;


				$http({
					method: "GET",
					url: window.location.origin+'/files/getAutocadFolderContents/'+projectID+'/'+autocadItem.id,
					params: { }
				}).then(function successCallback( returnData )
				{
					console.log(returnData);
					vm.autocadContents = returnData.data.data;
					console.log('The contents are ...');
					console.log(vm.autocadContents);

				}, function errorCallback( returnData ) 
				{ 

				});

			}


			// If this is a file and not a folder, record it in that space and turn off the option to select a folder
			if ( autocadItem.type == "items" )
			{

				vm.autocadFileSelected = true;
				vm.showFusionProps = false;
				vm.newCADConnect.file = autocadItem.id;
				vm.newCADConnect.id = autocadItem.id;
				vm.newCADConnect.fileData = autocadItem;
				vm.newCADConnect.fileID = autocadItem.relationships.tip.data.id;
				vm.newCADConnect.cleanID = autocadItem.relationships.tip.data.id.replace("urn:adsk.wipprod:fs.file:vf.","").match(/[^?]*/)[0];
				vm.newCADConnect.picName = vm.newCADConnect.cleanID+".png";

			}

			console.log('The new cad connect item is ...');
			console.log(vm.newCADConnect);

		}




		/*
		 *
		 * Sets a folder or file. If folder, it is placed into array and contents are called
		 *
		 */
		function setAutocadPullItem( autocadItem, thisIndex, projectID )
		{

			console.log('I am in the setAutocadPullItem function with '+thisIndex);
			console.log(autocadItem);

			if ( thisIndex == 'add' )
			{
				thisIndex = vm.newCADConnect.folders.length;
			}

			if ( autocadItem.type == "folders" )
			{

				// If this index will add a level to the folders, just add it
				if ( thisIndex >= vm.newCADConnect.folders.length )
				{

					// Add to the array holding the folder data
					vm.newCADConnect.folderData[vm.newCADConnect.folderData.length] = { "name" : autocadItem.attributes.name,
																					 "displayName" : autocadItem.attributes.displayName,
																					 "id" : autocadItem.id }

					// Add to the id array
					vm.newCADConnect.folders[vm.newCADConnect.folderData.length] = autocadItem.id;


				// If this index is inside the array, cut off the array where appropriate
				}else if ( thisIndex < vm.newCADConnect.folders.length )
				{

					// Add to the array holding the folder data
					vm.newCADConnect.folderData[thisIndex] = { "name" : autocadItem.attributes.name,
															   "displayName" : autocadItem.attributes.displayName,
															   "id" : autocadItem.id }

					// Add to the id array
					vm.newCADConnect.folders[thisIndex] = autocadItem.id;


					// Delete the rest of the array as it is insolent
					for ( var a=thisIndex+1; a<vm.newCADConnect.folders.length; a++ )
					{
						vm.newCADConnect.folderData.splice(a, 1)
						vm.newCADConnect.folders.splice(a, 1)
					}

				}

				vm.autocadFileSelected = false;
				vm.showFusionProps = false;


				$http({
					method: "GET",
					url: window.location.origin+'/files/getAutocadFolderContents/'+projectID+'/'+autocadItem.id,
					params: { }
				}).then(function successCallback( returnData )
				{
					console.log(returnData);
					vm.autocadContents = returnData.data.data;
					console.log('The contents are ...');
					console.log(vm.autocadContents);

				}, function errorCallback( returnData ) 
				{ 

				});

			}


			// If this is a file and not a folder, record it in then pull the data
			if ( autocadItem.type == "items" )
			{

				vm.autocadFileSelected = true;
				vm.showFusionProps = false;
				vm.newCADConnect.file = autocadItem.id;
				vm.newCADConnect.id = autocadItem.id;
				vm.newCADConnect.fileData = autocadItem;
				vm.newCADConnect.fileID = autocadItem.relationships.tip.data.id;
				vm.newCADConnect.cleanID = autocadItem.relationships.tip.data.id.replace("urn:adsk.wipprod:fs.file:vf.","").match(/[^?]*/)[0];
				vm.newCADConnect.picName = vm.newCADConnect.cleanID+".png";

				if ( vm.currentCADType() == "Workspace" )
				{
					vm.setFusionAssemblyBodyData( vm.newCADConnect.cleanID, vm.newCADConnect.projectData.id );
				
				}else if ( vm.currentCADType() == "Document" )
				{
					vm.getFusionBodies( vm.newCADConnect.cleanID, vm.newCADConnect.projectData.id );
				}
			}

			console.log('The new cad connect item is ...');
			console.log(vm.newCADConnect);

		}





		/*
		 *
		 *  If a Fusion file has been selected for linking with an assembly, 
		 *  download and sum up all mass data and then set the flag to show
		 *  the button the link the files
		 *
		 *	@param - cleanID - the ID of the file in forge without pretext or version
		 *  @param - projectID - the ID of the project containing the file in forge
		 *
		 */
		function setFusionAssemblyBodyData( cleanID, projectID )
		{

			console.log('I am in the set Fusion Assembly Body Data function with '+urn);

			vm.autocadBodySelected = true;


			// Send the request to get the body data
			$http({
				method: "GET",
				url: '/files/getFusionData/'+cleanID+'/'+projectID
			}).then(function successCallback( returnData )
			{
				console.log('The return data for get Fusion data is ');
				console.log(returnData.data.data);

				vm.bodyCollection = returnData.data.data.collection;


				// Sum up the mass data and place it into the body object
				var assemblyMass = 0;
				vm.bodyCollection.forEach(
					function(thisBody, bodyIndex){

						if ( thisBody.properties.Mass !== undefined )
						{
							assemblyMass = assemblyMass + parseFloat(thisBody.properties.Mass.replace(/[a-z,A-Z]/,'').replace(/\s/,''));
						}

				});

				vm.newCADConnect.bodyData = { properties : { "Mass" : assemblyMass, 
															 "weightN" : assemblyMass/1000*9.81, 
															 "weightP" : assemblyMass/1000*9.81*0.224809 } }
				

				vm.autocadLinkSet = true;

			});

		}



		/*
		 *
		 *  Pull the body data for a file so that a user can select one for a part
		 *
		 *
		 *	@param - cleanID - the ID of the file in forge without pretext or version
		 *  @param - projectID - the ID of the project containing the file in forge
		 *
		 */
		function getFusionBodies( cleanID, projectID )
		{

			console.log('I am in the get Fusion bodies function with '+cleanID+' - '+projectID);

			vm.autocadBodySelected = false;

			// Send the request
			$http({
				method: "GET",
				url: '/files/getFusionData/'+cleanID+'/'+projectID
			}).then(function successCallback( returnData )
			{
				console.log('The return data for get Fusion Properties is ');
				console.log(returnData.data.data);

				vm.bodyCollection = returnData.data.data.collection;

			});



		}




		/*
		 *
		 *  If a Fusion file has been selected for linking with a part, 
		 *  set the data and prep for button clicking
		 *
		 */
		function setFusionPartBodyData( )
		{
			vm.bodyCollection.forEach(
				function(thisBody, index){

					if ( thisBody.externalId == vm.newCADConnect.bodyId )
					{
						vm.newCADConnect.bodyData = thisBody;	
					}
			});


			// Calculate the weights
			if ( vm.newCADConnect.bodyData.properties.Mass.match(/[0-9]+\.[0-9]+\sg/)[0] ==
					vm.newCADConnect.bodyData.properties.Mass )
			{
				vm.newCADConnect.bodyData.properties.weightN = parseFloat(vm.newCADConnect.bodyData.properties.Mass.replace(/[a-z,A-Z]/,'').replace(/\s/,''))/1000*9.81;
				vm.newCADConnect.bodyData.properties.weightP = vm.newCADConnect.bodyData.properties.weightN*0.224809;
			}


			vm.autocadBodySelected = true;
			vm.autocadLinkSet = true;

		}




		/*
		 *
		 * Place the fusion data into the cad array after the body is selected
		 *
		 */
		function setFusionProperties( )
		{

			console.log('I am in the set Fusion Properties function');

			var inputCAD = {};

			inputCAD.type = "fusion";
			inputCAD.id = vm.newCADConnect.fileData.relationships.tip.data.id;
			inputCAD.hubData = vm.newCADConnect.hubData;
			inputCAD.projectData = vm.newCADConnect.projectData;
			inputCAD.rootData = vm.newCADConnect.rootData;
			inputCAD.folderData = vm.newCADConnect.folderData;
			inputCAD.fileData = vm.newCADConnect.fileData;
			inputCAD.bodyData = vm.newCADConnect.bodyData;
			inputCAD.cleanID = vm.newCADConnect.fileData.relationships.tip.data.id.replace("urn:adsk.wipprod:fs.file:vf.","").match(/[^?]*/)[0];
			inputCAD.picName = inputCAD.cleanID+".png";


			// Set the cadwolf_fileInfo Variable
			var flag=0;
			for (var a=0; a<vm.cadwolf_fileInfo.item_data.cad_data.length; a++)
			{
				if ( vm.cadwolf_fileInfo.item_data.cad_data[a]['document_id'] == vm.thisCAD.document_id )
				{	
					flag=1;
				}
			}

			if ( flag == 0 )
			{
				vm.cadwolf_fileInfo.item_data.cad_data.push({"document_id":vm.cadwolf_fileInfo.id });
			}


			for (var a=0; a<vm.cadwolf_fileInfo.item_data.cad_data.length; a++)
			{
				if ( vm.cadwolf_fileInfo.item_data.cad_data[a]['document_id'] == vm.thisCAD.document_id )
				{	
					vm.cadwolf_fileInfo.item_data.cad_data[a]['type'] = "fusion";
					vm.cadwolf_fileInfo.item_data.cad_data[a]['id'] = JSON.parse(JSON.stringify(inputCAD.id));
					vm.cadwolf_fileInfo.item_data.cad_data[a]['hubData'] = JSON.parse(JSON.stringify(inputCAD.hubData));
					vm.cadwolf_fileInfo.item_data.cad_data[a]['projectData'] = JSON.parse(JSON.stringify(inputCAD.projectData));
					vm.cadwolf_fileInfo.item_data.cad_data[a]['rootData'] = JSON.parse(JSON.stringify(inputCAD.rootData));
					vm.cadwolf_fileInfo.item_data.cad_data[a]['folderData'] = JSON.parse(JSON.stringify(inputCAD.folderData));
					vm.cadwolf_fileInfo.item_data.cad_data[a]['fileData'] = JSON.parse(JSON.stringify(inputCAD.fileData));
					vm.cadwolf_fileInfo.item_data.cad_data[a]['bodyData'] = JSON.parse(JSON.stringify(inputCAD.bodyData));
					vm.cadwolf_fileInfo.item_data.cad_data[a]['picName'] = JSON.parse(JSON.stringify(inputCAD.picName));
					vm.cadwolf_fileInfo.item_data.cad_data[a]['cleanID'] = JSON.parse(JSON.stringify(inputCAD.cleanID));
				}
			}


			// Set the part tree Variable
			for (var a=0; a<vm.partTree.length; a++)
			{
				if ( vm.partTree[a]['id'] == vm.thisCAD.document_id )
				{ 
					vm.partTree[a]['cad_data']['type'] = "fusion";
					vm.partTree[a]['cad_data']['id'] = JSON.parse(JSON.stringify(inputCAD.id));
					vm.partTree[a]['cad_data']['hubData'] = JSON.parse(JSON.stringify(inputCAD.hubData));
					vm.partTree[a]['cad_data']['projectData'] = JSON.parse(JSON.stringify(inputCAD.projectData));
					vm.partTree[a]['cad_data']['rootData'] = JSON.parse(JSON.stringify(inputCAD.rootData));
					vm.partTree[a]['cad_data']['folderData'] = JSON.parse(JSON.stringify(inputCAD.folderData));
					vm.partTree[a]['cad_data']['fileData'] = JSON.parse(JSON.stringify(inputCAD.fileData));
					vm.partTree[a]['cad_data']['bodyData'] = JSON.parse(JSON.stringify(inputCAD.bodyData));
					vm.partTree[a]['cad_data']['picName'] = JSON.parse(JSON.stringify(inputCAD.picName));
					vm.partTree[a]['cad_data']['cleanID'] = JSON.parse(JSON.stringify(inputCAD.cleanID));
				}
			}


			// Reset the link data
			vm.autocadFileSelected = false;
			vm.autocadBodySelected = false;
			vm.showFusionProps = false;
			vm.autocadLinkSet = false;
			vm.bodyCollection = [];
			vm.autocadContents = [];
			vm.autocadFolders = [];
			vm.newCADConnect = { 	"id":"", 
									"hub":"", 
									"hubData":{}, 
									"project":"", 
									"projectData":{}, 
									"rootFolder":"", 
									"rootData":{}, 
									"folders":[], 
									"folderData":[], 
									"file":"", 
									"fileData":{},
									"bodyData":{} };


			// Place the cad data in the part tree so that it can be used
			vm.syncCadTree();

		}






		/*
		 *
		 *  Regenerate the thumbnail and pull down new data for a fusion file - part or assembly
		 *
		 *	@param - cleanID - the id of the forge file without the pretext or post version
		 *  @param - projectID - the id of the project holding the file
		 *	@param - fileID - the id of the cadwolf file being updated in the part tree
		 *
		 */
		function updateFusionData( cleanID, projectID, fileID )
		{

			console.log('I am in the update Fusion Data function with '+cleanID+' and a project id of '+projectID+' and a fileID of '+fileID);

			var assemblyMass = 0;

			// Send the request
			$http({
				method: "GET",
				url: '/files/getFusionData/'+cleanID+'/'+projectID
			}).then(function successCallback( returnData )
			{
				console.log('The return data for update Fusion data is ');
				console.log(returnData.data.data);


				// Determine whether this is a part or an assembly - document or workspace
				vm.bodyCollection = returnData.data.data.collection;
				for (var a=0; a<vm.partTree.length; a++)
				{
					if ( vm.partTree[a]['id'] == fileID )
					{ 
						var fileType = vm.partTree[a]['file_type_id'];
					}
				}

				// If this is an assembly, sum the mass
				if ( fileType == "Workspace")
				{

					vm.bodyCollection.forEach(
						function(thisBody, bodyIndex){

							if ( thisBody.properties.Mass !== undefined )
							{
								assemblyMass = assemblyMass + parseFloat(thisBody.properties.Mass.replace(/[a-z,A-Z]/,'').replace(/\s/,''));
							}

					});

					// Replace the body data in the fileinfo variable
					for (var a=0; a<vm.cadwolf_fileInfo.item_data.cad_data.length; a++)
					{
						if ( vm.cadwolf_fileInfo.item_data.cad_data[a]['document_id'] == fileID )
						{	
							vm.cadwolf_fileInfo.item_data.cad_data[a]['bodyData'] = { properties : { "Mass" : assemblyMass, 
																 									"weightN" : assemblyMass/1000*9.81, 
																									"weightP" : assemblyMass/1000*9.81*0.224809 } };
						}
					}


					// Replace the data in the part tree
					for (var a=0; a<vm.partTree.length; a++)
					{
						if ( vm.partTree[a]['id'] == fileID )
						{ 
							vm.partTree[a]['cad_data']['bodyData'] = { properties : { "Mass" : assemblyMass, 
																 					  "weightN" : assemblyMass/1000*9.81, 
																					  "weightP" : assemblyMass/1000*9.81*0.224809 } };
						}
					}

				}


				// If this is an Document, set the properties
				if ( fileType == "Document")
				{
					for (var a=0; a<vm.cadwolf_fileInfo.item_data.cad_data.length; a++)
					{
						if ( vm.cadwolf_fileInfo.item_data.cad_data[a]['document_id'] == fileID )
						{

							vm.bodyCollection.forEach(
								function(thisBody, index){

								if ( thisBody.externalId == vm.cadwolf_fileInfo.item_data.cad_data[a]['bodyData']['externalId'] )
								{
									vm.cadwolf_fileInfo.item_data.cad_data[a]['bodyData']['properties'] = thisBody;	
								}

							});


							// Calculate the weights
							if ( vm.cadwolf_fileInfo.item_data.cad_data[a].bodyData.properties.Mass.match(/[0-9]+\.[0-9]+\sg/)[0] ==
									vm.cadwolf_fileInfo.item_data.cad_data[a].bodyData.properties.Mass )
							{
								vm.cadwolf_fileInfo.item_data.cad_data[a].bodyData.properties.weightN = parseFloat(vm.cadwolf_fileInfo.item_data.cad_data[a].bodyData.properties.Mass.replace(/[a-z,A-Z]/,'').replace(/\s/,''))/1000*9.81;
								vm.cadwolf_fileInfo.item_data.cad_data[a].bodyData.properties.weightP = vvm.cadwolf_fileInfo.item_data.cad_data[a].bodyData.properties.weightN*0.224809;
							}
						}
					}
				}


				// Place the cad data in the part tree so that it can be used
				vm.syncCadTree();

	

			});



		}





		/*
		 *
		 *  Create and click links to send data to Fusion - different from main program
		 *
		 *  @param - fileID - the ID of the document in the part tree
		 *
		 */
		function pushToFusion( fileID )
		{

			vm.connectedFiles.forEach(
				function(thisConn, index)
				{

					if ( ( thisConn.cad_type == 'fusion' ) && ( thisConn.id == linkID ) )
					{

						// First, remove any old links
						if ( document.getElementById("fusionLink"+linkID) !== null )
						{
							document.getElementById("fusionLink"+linkID).remove();
						}

						// Prep links for shortness
						var h = thisConn.info.cad_data.hubData.attributes.name;
						var p = thisConn.info.cad_data.projectData.attributes.name;
						var r = thisConn.info.cad_data.rootFolder;
						var fid = thisConn.info.cad_data.file;
						var folds = "";
						for (var a=0; a<thisConn.info.cad_data.folders.length; a++)
						{
							if ( a == 0 )
							{
								if ( thisConn.info.cad_data.folders[a] !== null )
								{
									folds = folds+""+thisConn.info.cad_data.folders[a];
								}

							}else
							{
								if ( thisConn.info.cad_data.folders[a] !== null )
								{
									folds = folds+","+thisConn.info.cad_data.folders[a];
								}
							}
						}

						// Set the names and values in separate arrays because it wouldn't work in object
						var eqNames = '';
						var eqValues = '';

						thisConn.info.equations.forEach(
							function(thisEq, index2){

								if ( index2 == 0 )
								{
									eqNames = thisEq.eq_name;
								}else
								{
									eqNames = eqNames+', '+thisEq.eq_name;
								}

								vm.cadwolf_worksheet.forEach(
									function(sheetEq, index3){

										if ( sheetEq.component_type_id == 3)
										{
											if ( sheetEq.name == thisEq.eq_name )
											{
												if ( index2 == 0 )
												{
													eqValues = sheetEq.content.Equation.Solution_real['0-0'];
												}else
												{
													eqValues = eqValues+', '+sheetEq.content.Equation.Solution_real['0-0'];
												}

											}
										}
									}
								);

							}
						);


						var link=document.createElement("a");
						link.id = 'fusionLink'+linkID; 
						link.href='fusion360://command=open&properties={"hub":"'+h+'","project":"'+p+'","root":"'+r+'","folders":"'+folds+'","file":"'+fid+'","eqNames":"'+eqNames+'","eqValues":"'+eqValues+'"}';

						
						document.getElementById("fusion"+linkID).appendChild(link);
						document.getElementById('fusionLink'+linkID).click();

					}
				}
			);


		}







		/*
		*
		*
		*
		*	Utility Functions
		*
		*
		*
		*/


		/*
		 *
		 * Return the type of file that the current cad selected is - workspace or document
		 *
		 */
		function currentCADType( ) 
		{
			var fileType = "none";

			vm.partTree.forEach(function(treeItem, treeIndex){
				if ( treeItem.id == vm.thisCAD.document_id )
				{
					fileType = treeItem.file_type_id;
				}
			});

			return fileType;
		}




		/*
		*
		*   Here, the equation digest functions are injected through gulp. These functions are in 
		*   the /src/assets/code/digest folder
		*/

		/*
 *
 *  This is the function called when a user clicks to update a file to be updated. It
 *  pulls all of the items for the document and then runs through them and solves the
 *  needed items.
 *  
 *  @param - fileID - the id of the file being updated
 *  @param - thisType - a string telling this code where it is being run - 'workspace', 'parttree', or 'documentUpdate'
 *
 */
function updateFile( fileID, thisType )
{
    console.log('In the updateFile function for the document '+fileID);
    var otherWorksheet = {};

    // Pull the worksheet items from the server
    $http({
        method: "GET",
        url: '/files/getSolveItems/'+fileID,
    }).then(function successCallback( returnData ) 
    {
        var otherWorksheet = returnData.data.components;
        var fileInfo = returnData.data.fileInfo;
        vm.lockFiles( 1 );
        console.log('The new worksheet is ...');
        console.log( otherWorksheet );
        vm.runEquationDigest( otherWorksheet, fileInfo, 1, thisType );


    }, function errorCallback( returnData ) { 
            vm.showMessage( '', { messageType : 'failure', 
                                  messageTitle : 'Error Getting Solve Items', 
                                  messageText : 'There was an error getting the equations to update the file. Make sure your logins have not expired.'});
    });

}




/*
*
*   EQUATION DIGEST FOR UPDATING OTHER FILES
*   @param - worksheet - an array of the items to be solved
*   @param - fileinfo - the object holding the file data - generally the cadwolf_fileInfo variable
*   @param - savefile - if at the end of the updates, the components of the file should be saved and the status updated (1 or 0)
*
*/

function runEquationDigest ( worksheet, fileInfo, savefile, thisType )
{   
    vm.worksheet = JSON.parse(JSON.stringify(worksheet));
    if ( vm.worksheet === undefined ){ vm.worksheet = vm.cadwolf_worksheet; }

    console.log('In the equation digest loop with a status of '+vm.digestStatus+' and a type of '+thisType);
    console.log('The worksheet is ...');
    console.log(vm.worksheet);

    for (var a=0; a<vm.worksheet.length; a++)
    {   
        if (typeof(vm.worksheet[a]['content'])=="string")
        {
            vm.worksheet[a]['content'] = JSON.parse(vm.worksheet[a]['content']);
        }
    }


    if (vm.digestStatus==1)
    {   
        vm.worksheet=vm.worksheet.sort(utilityFactory.dynamicSort("order"));
        
        for (var a=0; a<vm.worksheet.length; a++)
        {   
            if (((vm.worksheet[a]['component_type_id']==3) &&
                (vm.worksheet[a]['content']['needsUpdateFlag']==1)) ||
                ((vm.worksheet[a]['component_type_id']==3) &&
                (vm.worksheet[a]['update'])))
            {   
                console.log('Calling the solver for '+vm.worksheet[a]['itemid']);
                vm.digestStatus=0;
                vm.worksheet[a]['content']['needsUpdateFlag']=0;
                vm.worksheet[a]['content']['Equation']['inEdit']=1;
                vm.worksheet[a]['update']=false;
                if ((!vm.editPerm) && (vm.worksheet[a]['content']['Equation']['Format_editinuse']==1))
                {
                    vm.worksheet[a]['content']['Equation']['newEquation'] = vm.worksheet[a]['content']['Equation']['Format_left']+'='+vm.worksheet[a]['content']['Equation']['Format_right']
                }
                if ( ( vm.worksheet[a]['content']['Equation']['inputType'] == 'File' ) || ( vm.worksheet[a]['content']['Equation']['inputType'] == 'Dataset' ))
                {
                    vm.worksheet = docItemFactory.populateDeps( vm.worksheet[a]['itemid'], vm.worksheet);
                    vm.worksheet = docItemFactory.findDependents(vm.worksheet[a]['itemid'], 0, vm.worksheet);
                    vm.digestStatus=1;
                    runEquationDigest ( vm.worksheet, fileInfo, savefile, thisType );
                    savefile=0;
                }else
                {
                    vm.solveEquation( vm.worksheet[a]['itemid'], 'SolveEquation', '', fileInfo );   
                    savefile=0;
                }
                break
            }


            if (vm.worksheet[a]['component_type_id']==5)
            {   var flag=0;
                for (var b=0; b< vm.worksheet[a]['content']['data'].length; b++)
                {   for (var c=0; c< vm.worksheet[a]['content']['data'][0].length; c++)
                    {   console.log('Checking index '+b+'-'+c);
                        if (vm.worksheet[a]['content']['data'][b][c]['needsUpdateFlag']==1)
                        {   vm.worksheet[a]['solveRow']=b
                            vm.worksheet[a]['solveCol']=c
                            if (vm.worksheet[a]['content']['data'][b][c]['equation'].match(/^=/)==null)
                            {   console.log('Setting index '+b+'-'+c+' to '+vm.worksheet[a]['content']['data'][b][c]['equation']);
                                vm.worksheet[a]['content']['data'][b][c]['real']=vm.worksheet[a]['content']['data'][b][c]['equation'];
                                vm.digestStatus=1;
                            }else
                            {   if (utilityFactory.isNumber(vm.worksheet[a]['content']['data'][b][c]['equation'].replace(/^=/,'')))
                                {   vm.worksheet[a]['content']['data'][b][c]['real']=parseFloat(vm.worksheet[a]['content']['data'][b][c]['equation'].replace(/^=/,''));
                                    vm.worksheet[a]['content']['data'][b][c]['needsUpdateFlag']=0;
                                    console.log('I am updating the dependents on '+String.fromCharCode(65+c)+' - '+b);
                                    docItemFactory.findDependents(vm.worksheet[a]['itemid']+'.'+String.fromCharCode(65+c)+'.'+b, 0, vm.worksheet);
                                    flag=1;
                                    break
                                }else
                                {   console.log('Solving for index '+b+'-'+c+' with an equation of '+vm.worksheet[a]['content']['data'][b][c]['equation']);
                                    vm.digestStatus=0;
                                    vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveTableCell', '', fileInfo); 
                                    flag=1;
                                    break
                                }
                            }
                        }
                    } 
                    if (flag==1) { break }
                }
                if (flag==1) { break }
            }

            // Check and update the loop parameters
            if ((vm.worksheet[a]['component_type_id']==6) &&
                (vm.worksheet[a]['content']['needsBlockUpdate']==1) &&
                (vm.digestStatus==1))
            {   vm.digestStatus=0;
                vm.worksheet[a]['content']['forLoop']['firstRun']=1;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveLoopParameters', '', fileInfo);   
                break
            }

            // Check and update the loop parameters
            if ((vm.worksheet[a]['component_type_id']==7) &&
                (vm.worksheet[a]['content']['needsBlockUpdate']==1) &&
                (vm.digestStatus==1))
            {   vm.digestStatus=0;
                vm.worksheet[a]['content']['whileLoop']['firstRun']=1;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveWhileLoopParameters', '', fileInfo);  
                break
            }

            // Check and update the if/else parameters
            if ((vm.worksheet[a]['component_type_id']==8) &&
                (vm.worksheet[a]['content']['needsBlockUpdate']==1) &&
                (vm.digestStatus==1))
            {   vm.digestStatus=0;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveIfElseParameters', '', fileInfo);
                break
            }

            // Check and update the loop structure
            if ((vm.worksheet[a]['component_type_id']==6) && 
                (vm.worksheet[a]['content']['forLoop']['needsUpdateFlag']==1) &&
                (vm.digestStatus==1))
            {
                vm.digestStatus=0;
                vm.worksheet[a]['content']['forLoop']['firstRun']=1;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveStructure', '', fileInfo);   
                break
            }

            // Check and update the loop structure
            if ((vm.worksheet[a]['component_type_id']==7) && 
                (vm.worksheet[a]['content']['whileLoop']['needsUpdateFlag']==1) &&
                (vm.digestStatus==1))
            {
                vm.digestStatus=0;
                vm.worksheet[a]['content']['whileLoop']['firstRun']=1;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveStructure', '', fileInfo);   
                break
            }

            // Check and update the lif/else structure
            if ((vm.worksheet[a]['component_type_id']==8) && 
                (vm.worksheet[a]['content']['ifelse']['needsUpdateFlag']==1) &&
                (vm.digestStatus==1))
            {
                vm.digestStatus=0;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveStructure', '', fileInfo);   
                break
            }

            if ((vm.worksheet[a]['component_type_id']==9)&&(vm.digestStatus==1))
            {   var flag=0;
                for (var thisDataset in vm.worksheet[a]['content']['Plot']['Chart_dataobj'])
                {   
                    console.log('For dataset '+thisDataset+', the update flag is '+vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['needsUpdateFlag']);
                    if (vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['needsUpdateFlag']==1)
                    {   
                        console.log('I am updating dataset '+thisDataset+'-'+vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['Format_id']+' on plot '+vm.worksheet[a]['itemid']);
                        vm.digestStatus=0;
                        vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['needsUpdateFlag']=0; 
                        vm.solveEquation(vm.worksheet[a]['itemid'], 'solvePlotData', vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['Format_id'], fileInfo);
                        flag=1;
                        break
                    }
                } 
                if ((flag==0)&&(vm.worksheet[a]['content']['Plot']['needsUpdateFlag']==1))
                {
                    vm.worksheet[a]['content']['Plot']['needsUpdateFlag']=0;
                    chartFactory.makeChart(vm.worksheet[a], '', vm.worksheet); 
                    
                }
            }
            if (vm.worksheet[a]['component_type_id']==13)
            {   for (var dataIndex in vm.worksheet[a]['content']['Surface']['Chart_dataobj'])
                {   if (vm.worksheet[a]['content']['Surface']['Chart_dataobj'][dataIndex]['needsUpdateFlag']==1)
                    {   vm.digestStatus=0;
                        vm.worksheet[a]['content']['Surface']['Chart_dataobj'][dataIndex]['needsUpdateFlag']=0; 
                        var thisID = vm.worksheet[a]['itemid'];
                        var dataID = vm.worksheet[a]['content']['Surface']['Chart_dataobj'][dataIndex]['Format_id'];
                        vm.solveEquation( thisID, 'SolveSurfaceData', dataID, fileInfo );
                        break
                    }
                }  
            }

        }

        for (var a=0; a<vm.worksheet.length; a++)
        {   
            if (vm.worksheet[a]['component_type_id']==15)
            {   
                for (var b=0; b<vm.worksheet.length; b++)
                {   
                    if ( vm.worksheet[a]['content']['variableID'] == vm.worksheet[b]['itemid'] )
                    {
                        vm.worksheet[a]['content']['value'] = vm.worksheet[b]['content']['Equation']['Solution_real'][vm.worksheet[a]['content']['index']];
                        vm.worksheet[a]['content']['units'] = vm.worksheet[b]['content']['Equation']['Units_units'];
                        vm.worksheet[a]['content']['variable'] = vm.worksheet[b]['content']['Equation']['Format_name'];
                    }
                }
            }
        }
        console.log('The digest loop is clean');
        if ( savefile == 1 )
        {
            console.log('The file is being saved and updated');
            vm.saveFile( 1, fileInfo, thisType );
            $http({
                method: "POST",
                url: window.location.origin+'/files/fileCurrent/'+fileInfo['id'],
            });
            if ( vm.depFiles !== undefined )
            {
                for (var b=0; b<vm.depFiles.length; b++)
                {
                    if ( vm.depFiles[a]['id'] == fileInfo['id'] )
                    {
                        vm.depFiles[a]['update'] = false;
                    }
                }
            }
        }

    }
};







/*
*
*   LOCK THE FILES IN THE PART TREE OR THE WORKSPACE WHEN ONE IS BEING UPDATED
*
*/
function lockFiles ( setting )   
{
    console.log('In the lockFiles function with a setting of '+setting);   
    vm.inSolve=parseInt(setting);
}




/*
*
*   SOLVE EQUATION FUNCTION
*
*/
function solveEquation (eqID, eqType, dataID, fileInfo, thisType)   
{   
    console.log('In solve equation with an id of '+eqID+', a type of '+eqType+' and a dataID of '+dataID);
    vm.solveFileInfo = fileInfo;
    var thisItem = docItemFactory.getByID(eqID, vm.worksheet);
    if ( fileInfo.item_data.importedCAD === undefined ) { fileInfo.item_data.importedCAD=[]; }
    console.log('Found');
    console.log(thisItem);
    thisItem.eqObj=docItemFactory.createEqObj(eqID, vm.worksheet);
    var solveObj = docItemFactory.createSolveObj( thisItem, eqType, dataID );
    solveObj['scaleUnits'] = vm.cadwolfScaleUnits;
    solveObj['parseUnits'] = vm.cadwolfParseUnits;
    solveObj['Constants']  = vm.cadwolfConstants;
    solveObj['cadParts']  = fileInfo.item_data.importedCAD;
    solveObj['importedFunctions'] = fileInfo.item_data.impFunctions;
    console.log('I am sending ...');
    console.log(solveObj);
    //equationWorker.postMessage( solveObj ); 


    // This section checks to see if there is a python server running locally
    $http({
        method: "POST",
        url: 'http://127.0.0.1:8081',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: { testMessage : "Test Message" }
    }).then(function successCallback( returnData ) {
        vm.cadwolf_usePython=true;
        vm.cadwolf_pythonVersion=returnData.data
        $http({
            method: "POST",
            url: 'http://127.0.0.1:8081',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data: { params  : solveObj }
        }).then(function successCallback( returnData ) {
                vm.pythonReturn=returnData
                vm.handleSolverReturn(returnData, thisType)
        }, 
            function errorCallback( returnData ) {
                equationWorker.postMessage( solveObj );    
        });
    }, function errorCallback( returnData ) {
        vm.cadwolf_usePython=false;
        equationWorker.postMessage( solveObj ); 
    });

    
    equationWorker.onerror = function(e) 
    {
        vm.digestStatus=1;
        console.log('Hey, I got an error, but thats cool. Ill just sit over here and eat a sugar packet.'); 
        vm.showMessage( '', { messageType : 'failure', 
                              messageTitle : 'Unknown Error', 
                              messageText : 'There was an error in the solver routine that caused it to fail. Please look at the format of your equations.'});

    };

    equationWorker.onmessage = function(e) { 
        console.log('The message was returned with a type of '+e.data.messageType);
        console.log(e.data);
        MY_SCOPE.eqreturndata=e;
        vm.handleSolverReturn(e, thisType)
    }
}


/*
*
*   HANDLE THE RETURN FROM WEB WORKER OR PYTHON
*
*/
function handleSolverReturn (e, thisType)
{   
    console.log('The message was returned with a type of '+e.data.messageType);
    console.log(e.data);
    MY_SCOPE.eqreturndata=e;

    vm.worksheet=docItemFactory.eqReturn(e.data, vm.worksheet);    
    
    if (e.data.messageType=="EquationResult")
    {
        vm.addressConnectedEqs(e.data, vm.worksheet);
        vm.worksheet = docItemFactory.populateDeps(e.data.id, vm.worksheet);
        vm.worksheet = docItemFactory.findDependents(e.data.id, 0, vm.worksheet);
        vm.worksheet.forEach(
            function(thisObj, index){
                if (thisObj['itemid']==e.data.id)
                {   
                    thisObj.content.Equation['Format_showsolution'] = docItemFactory.createShowSolution( thisObj, vm.cadwolfScaleUnits );
                    vm.updateComponent( thisObj );                            
                }
            }
        );
    }
    
    if (e.data.messageType=="TableCellResult")
    {
        vm.worksheet = docItemFactory.findDependents(e.data.id, 0, vm.worksheet);
    }
    
    if (e.data.messageType=="PlotDataResults")
    {   
        vm.worksheet.forEach(
            function(thisObj, index){
                if (thisObj['itemid']==e.data.plotID)
                {   
                    if (e.data.eventErrorFlag==1)
                    {
                        thisObj['content']['Plot']['errorFlag']=1;
                        thisObj['content']['Plot']['errors']=e.data.eventError;
                    }else
                    {
                        thisObj['content']['Plot']['errorFlag']=0;
                        thisObj['content']['Plot']['errors']=[];
                        var itemArray=['Chart_dataobj', 'Chart_bandsobj', 'Chart_linesobj', 'Chart_textobj', 'Chart_xaxesobj', 'Chart_yaxesobj'];
                        for (var a=0; a<itemArray.length; a++)
                        {   
                            for (var thisData in thisObj['content']['Plot'][itemArray[a]])
                            {   
                                if (thisObj['content']['Plot'][itemArray[a]][thisData]['Format_id']==vm.currentChartItemID)
                                {
                                    vm.currentChartItem = thisObj['content']['Plot'][itemArray[a]][thisData];
                                    vm.currentPoint=vm.currentChartItem['PointData'][vm.pointIndex];
                                }
                            } 
                        }
                    }
                    vm.updateComponent( thisObj );                            
                }
            }
        );
    }

    if (e.data.messageType=="SurfaceData")
    {   
        vm.worksheet.forEach(function(item, index)
        {   
            if (item.itemid==e.data['PlotID'])
            {   
                for (var a = 0; a < item['content']['Surface']['Chart_dataobj'].length; a++)
                {
                    if (item['content']['Surface']['Chart_dataobj'][a]['Format_id'] == e.data['DataID'] )
                    {
                        var dataIndex = a;
                    }
                }

                for (var b = 0; b < e.data['dataObject'].length; b++)
                {
                    if (e.data['dataObject'][b]['Format_id'] == e.data['DataID'] )
                    {
                        var returnIndex = b;
                    }
                }

                if ((e.data['type']=="surface")||(e.data['type']=="pointCloud"))
                {    
                    item['content']['Surface']['Chart_dataobj'][dataIndex]['xLength']=e.data['dataObject'][returnIndex]['xLength'];
                    item['content']['Surface']['Chart_dataobj'][dataIndex]['yLength']=e.data['dataObject'][returnIndex]['yLength'];
                
                }else if (e.data['type']=="line") 
                {   
                    // item['content']['Surface']['Chart_dataobj'][dataIndex]['lineGeometry']=JSON.parse(JSON.stringify(e.data['dataObject'][returnIndex]['lineGeometry']));
                    item = surfaceFactory.setLinePoints( item, e.data['DataID'], e.data['Axis'] );

                }else if (e.data['type']=="lathe")
                {   
                    item['content']['Surface']['Chart_dataobj'][dataIndex]['xLength']=e.data['dataObject'][returnIndex]['xLength'];
                    item['content']['Surface']['Chart_dataobj'][dataIndex]['yLength']=e.data['dataObject'][returnIndex]['yLength'];
                    item['content']['Surface'].formatLatheData(e.data['PlotID'], e.data['DataID']);
                }                    
                
                vm.reDrawItem( item, 'all', 1 );
                vm.updateComponent( item );                            
            }
        });
    }

    console.log('I made it to the end of the equation return');
    vm.digestStatus=1; 

    // Run through the worksheet and check to see if there are any equations or other items flagged to be solved
    // If there are, run the digest. If there aren't, run. the digest and save the file
    vm.saveThisFile = 1;

    for (var a=0; a<vm.worksheet.length; a++)
    {   
        if (((vm.worksheet[a]['component_type_id']==3) &&
            (vm.worksheet[a]['content']['needsUpdateFlag']==1)) ||
            ((vm.worksheet[a]['component_type_id']==3) &&
            (vm.worksheet[a]['update'])))
        {   
            vm.saveThisFile = 0;
        }

        if (vm.worksheet[a]['component_type_id']==5)
        {   
            for (var b=0; b< vm.worksheet[a]['content']['data'].length; b++)
            {   for (var c=0; c< vm.worksheet[a]['content']['data'][0].length; c++)
                {   
                    if (vm.worksheet[a]['content']['data'][b][c]['needsUpdateFlag']==1)
                    {   
                        vm.saveThisFile = 0;
                    }
                }
            }
        }

        // Check and update the loop parameters
        if ((vm.worksheet[a]['component_type_id']==6) &&
            (vm.worksheet[a]['content']['needsBlockUpdate']==1) )
        {   
            vm.saveThisFile = 0;
        }

        // Check and update the loop parameters
        if ((vm.worksheet[a]['component_type_id']==7) &&
            (vm.worksheet[a]['content']['needsBlockUpdate']==1) )
        {   
            vm.saveThisFile = 0;
        }

        // Check and update the if/else parameters
        if ((vm.worksheet[a]['component_type_id']==8) &&
            (vm.worksheet[a]['content']['needsBlockUpdate']==1) )
        {   
            vm.saveThisFile = 0;
        }

        // Check and update the loop structure
        if ((vm.worksheet[a]['component_type_id']==6) && 
            (vm.worksheet[a]['content']['forLoop']['needsUpdateFlag']==1) )
        {
            vm.saveThisFile = 0;
        }

        // Check and update the loop structure
        if ((vm.worksheet[a]['component_type_id']==7) && 
            (vm.worksheet[a]['content']['whileLoop']['needsUpdateFlag']==1) )
        {
            vm.saveThisFile = 0;
        }

        // Check and update the lif/else structure
        if ((vm.worksheet[a]['component_type_id']==8) && 
            (vm.worksheet[a]['content']['ifelse']['needsUpdateFlag']==1) )
        {
            vm.saveThisFile = 0;
        }

        if ((vm.worksheet[a]['component_type_id']==9))
        {   
            for (var thisDataset in vm.worksheet[a]['content']['Plot']['Chart_dataobj'])
            {   
                if (vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['needsUpdateFlag']==1)
                {   
                    vm.saveThisFile = 0;
                }
            } 
            if (vm.worksheet[a]['content']['Plot']['needsUpdateFlag']==1)
            {
                vm.saveThisFile = 0;
            }
        }
        if (vm.worksheet[a]['component_type_id']==13)
        {   
            for (var dataIndex in vm.worksheet[a]['content']['Surface']['Chart_dataobj'])
            {   
                if (vm.worksheet[a]['content']['Surface']['Chart_dataobj'][dataIndex]['needsUpdateFlag']==1)
                {   
                    vm.saveThisFile = 0;
                }
            }  
        }

    }

    vm.runEquationDigest( vm.worksheet, vm.solveFileInfo, vm.saveThisFile, thisType );

};






/*
*
*   SEPARATE FUNCTION TO ADDRESS RETURNED CONNECTED EQUATIONS
*
*/
function addressConnectedEqs(returnObject, worksheetObj) 
{   
    MY_SCOPE.returnItem = returnObject;
    var flag=0;
    console.log('There are '+Object.keys(returnObject.connected).length+' connected items in the returned array');
    // Handle the connected equations - If the returned item has connected equations
    if (Object.keys(returnObject.connected).length>0)
    {  
        console.log('There were keys returned');
        vm.worksheetObj.forEach(function(item, index)
        {   
            console.log('I am now comparing '+returnObject.id+' to '+item['itemid']);
            if (returnObject.id==item['itemid'])
            {
                console.log('match');
                // Loop through all of the existing connected IDs for this equation. Find them in the vm.worksheet,
                // and check their names against the list of names for the newly returned connected items. If one
                // matches, update the data from the new solution.
                for (var existingConn in item['content']['Equation']['connected_ids'])
                {
                    flag=0;
                    vm.worksheetObj.forEach(function(tempItem, tempIndex)
                    {   
                        console.log('In the existing part, comparing '+tempItem['itemid']+'-'+existingConn);
                        console.log(tempItem['itemid']==existingConn);
                        if (tempItem['itemid']==existingConn) 
                        { 
                            for (var returnConn in returnObject.connected)
                            {
                                console.log('In connected ids, comparing '+returnObject.connected[returnConn]['Format_name']+' to '+tempItem['name']);
                                if (returnObject.connected[returnConn]['Format_name'] == tempItem['name'] )
                                {
                                    flag=1;
                                    for (var thisProp in returnObject.connected[returnConn])
                                    {
                                        console.log('Resetting the parameter '+thisProp);
                                        tempItem['content']['Equation'][thisProp] = returnObject.connected[returnConn][thisProp];
                                    }
                                    console.log('Deleting '+returnConn+' from the returned connected ids array');
                                    delete returnObject.connected[returnConn];

                                }
                            }
                        } 
                    }); 

                    // Delete the connected equation if it is not represented in the new result. It is a holdover
                    // from a previous solution.
                    if (flag==0)
                    {
                        vm.worksheetObj.forEach(function(tempItem, tempIndex)
                        {   
                            if (tempItem['itemid']==existingConn) 
                            { 
                                console.log('Deleting connected id '+existingConn+' - '+tempItem['name']);
                                vm.deleteItem(tempItem, 1);
                            } 
                        }); 
                    }
                }

                // Whatever items remain in the connected object are new. Add those as new items
                for (var connItem in returnObject.connected)
                {   
                    var connectedID = vm.addItem('Equation', returnObject.connected[connItem], 1, item['order']) 
                    console.log('I should have created '+returnObject.connected[connItem]['Format_name']);
                    item['content']['Equation']['connected_ids'][connectedID]=1;

                    // vm.worksheet.forEach(function(tempItem, tempIndex)
                    // {   
                    //     if (tempItem['itemid']==connectedID) 
                    //     { 
                    //         tempItem['name'] = returnObject.connected[connItem]['Format_name']; 
                    //         tempItem['inEdit'] = 1; 
                    //         tempItem['file_id'] = fileInfo.id; 
                    //         tempItem['Original_id']=returnObject.id;
                    //         tempItem['content']['isConnectedEquation']=1;
                    //         setTimeout(function(){ vm.updateComponent( tempItem ), 3000});
                    //     }
                    // }); 

                    // console.log('Created a new connected item named '+returnObject.connected[connItem]['Format_name']+' with an id of '+connectedID);
                }   
            }
        });
    }
}




/*
 * Call to update an item and then update the service
 *
 */
function updateComponent( thisItem )
{   
    if (typeof(thisItem)=='object')
    {
        //vm.cadwolf_worksheet = docItemFactory.getLastPos( vm.cadwolf_worksheet );
        console.log('Updating the component ...');
        console.log(thisItem);
        if (typeof(thisItem['content'])=='string')
        {
            thisItem['content']=JSON.parse(thisItem['content']);
            console.log('The content was stringified');
        }
        if (thisItem['component_type_id']==13)
        {
            var tempItem = vm.buildSurface( thisItem );
        }else
        {
            var tempItem = thisItem['content'];
        }
        if (thisItem['component_type_id']==3)
        {
            var name=thisItem['content']['Equation']['Format_name'];                    
        }else
        {
            var name=thisItem['name'];                     
        }
        $http({
            method: "PUT",
            url: window.location.origin+'/components',
            data: { 
                        id      : thisItem['id'],
                        itemid  : thisItem['itemid'],
                        //file_id : vm.cadwolf_fileInfo['id'],
                        file_id : thisItem['file_id'],
                        name    : name,
                        content : JSON.stringify(tempItem),
                        dependent_file : thisItem['dependent_file'],
                        dependent_id : thisItem['dependent_id'],
                        order : thisItem['order']
                  }
        }).then(function successCallback( returnData ) {
            console.log('Update component call completed');
            if (thisItem['component_type_id'] == 3)
            {
                for (var thisConn in thisItem['content']['Equation']['connected_ids'])
                {
                    vm.cadwolf_worksheet.forEach(
                        function(tempItem, index)
                        {
                            if (tempItem['itemid']==thisConn)
                            {
                                vm.updateComponent( tempItem );
                            }
                        }
                    );
                }
            
            }

            if ( (thisItem['component_type_id'] == 6) || (thisItem['component_type_id'] == 7) || (thisItem['component_type_id'] == 8) )
            {
                vm.cadwolf_worksheet.forEach(
                    function(sheetItem, index){
                        if ( sheetItem['content']['parentid'] == thisItem['itemid'] )
                        {
                            vm.updateComponent( sheetItem );
                        }
                    }
                );

            }

        }, function errorCallback( returnData ) {});
        // vm.updateService( );
    }
    console.log('Update component completed');

}        





/*
 *
 * Save the file and update the components
 *
 *  @param - flag - 0 or 1 if the components should be saved
 *  @param - fileInfo - the fileinfo object for the file being saved
 *  @param - thisType - string for where this saved originated
 *
 */
function saveFile( flag, fileInfo, thisType )
{   
    console.log('In the save file program with a type of '+thisType);

    $http({
        method: "PUT",
        url: window.location.origin+'/files/'+fileInfo['id'],
        data: { name : fileInfo['name'],
                parent_id : parseInt(fileInfo['parent_id'], 10),
                item_data : fileInfo['item_data']
              }
    }).then(function successCallback( returnData ) 
    {
        if ( thisType == 'workspace' )      { vm.getFiles($location.absUrl()); }
        if ( thisType == 'documentUpdate' ) { vm.getDepFiles(); }
        if ( thisType == 'partTreeUpdate' ) { vm.lockFiles( 0 ); 
                                              vm.getTreeStatus( fileInfo ); }

        if ( flag == 1 ) { vm.saveComponents( fileInfo, thisType ); }
        vm.sendAutocadVars( fileInfo );

    }, function errorCallback( returnData ) {});
}        

function saveComponents( fileInfo, thisType )
{   
    $http({
        method: "PUT",
        url: window.location.origin+'/saveDocument/'+fileInfo['id']
    }).then(function successCallback( returnData ) {
        if ( thisType == 'partTreeUpdate' ) { vm.getTreeStatus( fileInfo ); }
    }, function errorCallback( returnData ) {});
}







/*
 *
 *  Function to send autocad variables to Fusion 360. This is done the same was as 
 *  in the document function. The only exception is that we have to download the
 *  connected items first.
 *
 * @param - fileInfo - the fileInfo object for the file being saved and sending params to Fusion
 *
 */
function sendAutocadVars( fileInfo )
{

    console.log('In the send autocad vars function with '+fileInfo.id);

    // Flag that turns on the notification that the variables are being sent to Autocad
    vm.sendingAutocad = true;


    // Prep the strings that will hold the data sent to Fusion. Data can be sent for multiplt
    // files. File data is separated by  pound signs. This is done because arrays couldn't be
    // sent, so I sent strings that are parsed with Fusion's API.
    var h = '';         // String holding the hub data
    var p = '';         // String holding the project data
    var r = '';         // String holding the root folder
    var FIDs = '';      // String holding the IDs of the files
    var folds = "";     // String holding the Folder path for each file
    var flag = 0;       // Flag for first entry
    var eqNames = '';   // Names of the equations
    var eqValues = '';  // Values of the equations
    var fusionFlag = 0; // Whether or not we got a fusion connect



    // Download the connected files as this isn't done for the fileInfo
    $http({
        method: "GET",
        url: window.location.origin+'/getConnected/'+fileInfo.id,
        params: { }
    }).then(function successCallback( returnData )
    {
        console.log(returnData);
        vm.connectedFiles = returnData.data.data;
        for (var a=0; a<vm.connectedFiles.length; a++)
        {
            vm.connectedFiles[a]['info'] = JSON.parse(vm.connectedFiles[a]['info']);
            if ( vm.connectedFiles[a]['cad_type'] == "fusion" )
            {
                if ( typeof(vm.connectedFiles[a]['info']['cad_data']) == "string" )
                {
                    vm.connectedFiles[a]['info']['cad_data'] = JSON.parse(vm.connectedFiles[a]['info']['cad_data']);
                }
            }
        }

        // First, remove any old links
        if ( document.getElementById("fusionLink") !== null )
        {
            document.getElementById("fusionLink").remove();
        }

        vm.connectedFiles.forEach(
            function(thisConn, index)
            {

                console.log('For this connection, the type is '+thisConn.cad_type);

                if ( thisConn.cad_type == 'fusion' )
                {

                    fusionFlag = 1;

                    console.log('The Fusion flag is set to '+fusionFlag);

                    // Set the file data
                    if ( flag == 0 )
                    {
                        h = thisConn.info.cad_data.hubData.attributes.name;
                        p = thisConn.info.cad_data.projectData.attributes.name;
                        r = thisConn.info.cad_data.rootFolder;
                        FIDs = thisConn.info.cad_data.file;
                        folds = "";
                    }else
                    {
                        h = h+'**'+thisConn.info.cad_data.hubData.attributes.name;
                        p = p+'**'+thisConn.info.cad_data.projectData.attributes.name;
                        r = r+'**'+thisConn.info.cad_data.rootFolder;
                        FIDs = FIDs+'**'+thisConn.info.cad_data.file;
                        folds = folds+'**';
                    }

                    for (var a=0; a<thisConn.info.cad_data.folders.length; a++)
                    {
                        if ( a == 0 )
                        {
                            if ( thisConn.info.cad_data.folders[a] !== null )
                            {
                                folds = folds+""+thisConn.info.cad_data.folders[a];
                            }

                        }else
                        {
                            if ( thisConn.info.cad_data.folders[a] !== null )
                            {
                                folds = folds+","+thisConn.info.cad_data.folders[a];
                            }
                        }
                    }


                    if ( flag == 1 )
                    {
                        eqNames = eqNames+'**';
                        eqValues = eqValues+'**';
                    }else
                    {
                        flag = 1;
                    }

                    thisConn.info.equations.forEach(
                        function(thisEq, index2){

                            if ( index2 == 0 )
                            {
                                eqNames = eqNames+''+thisEq.eq_name;
                            }else
                            {
                                eqNames = eqNames+','+thisEq.eq_name;
                            }

                            vm.worksheet.forEach(
                                function(sheetEq, index3){

                                    if ( sheetEq.component_type_id == 3)
                                    {
                                        if ( sheetEq.name == thisEq.eq_name )
                                        {
                                            if ( index2 == 0 )
                                            {
                                                eqValues = eqValues+''+sheetEq.content.Equation.Solution_real['0-0']+' '+sheetEq.content.Equation.Units_units;
                                            }else
                                            {
                                                eqValues = eqValues+','+sheetEq.content.Equation.Solution_real['0-0']+' '+sheetEq.content.Equation.Units_units;
                                            }

                                        }
                                    }
                                }
                            );

                        }
                    );                      

                }
            }
        );


        // Turn off Autocad Flag
        vm.sendingAutocad = false;


        console.log('Before the call, the fusion flag is '+fusionFlag);

        if ( fusionFlag == 1 )
        {
            var link=document.createElement("a");
            link.id = 'fusionLink'; 
            link.href='fusion360://command=open&properties={"hub":"'+h+'","project":"'+p+'","root":"'+r+'","folders":"'+folds+'","file":"'+FIDs+'","eqNames":"'+eqNames+'","eqValues":"'+eqValues+'"}';

            console.log('The anchor is ...');
            console.log(link.href);
            
            document.getElementById("fusionLinkArea").appendChild(link);

            document.getElementById('fusionLink').click();

        }

    });

}






		vm.init();


	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.forum', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.forum', {
            url      : '/Forum{path:.*}',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/forum/forum.html',
                    controller : 'ForumController as vm'
                }
            },
            bodyClass: 'forum'

        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/forum');

        // Navigation
        msNavigationServiceProvider.saveItem('Forum', {
            title : 'Forum',
            icon  : 'icon-forum',
            state : 'app.forum',
            weight: 4
        });
    }

})();
(function ()
{
	'use strict';

	angular
		.module('app.forum')
		.controller('ForumController', ForumController);

	/** @ngInject */
	function ForumController( $mdSidenav, $mdDialog, utilityFactory, $http, $sce, $location )
	{
		var vm = this;
		window.MY_SCOPE = vm;	  

		// Data
		MathJax.Hub.Configured();
		MathJax.Hub.Queue(["Typeset", MathJax.Hub]);

		console.log('In the forum controller');



		// Methods
		vm.initialize			= vm.initialize			|| initialize;
		vm.goToURL 				= vm.goToURL 			|| goToURL;
		vm.createForum 			= vm.createForum 		|| createForum;
		vm.showNewForumModal	= vm.showNewForumModal 	|| showNewForumModal;
		vm.updateForum 			= vm.updateForum 		|| updateForum;
		vm.createComment 		= vm.createComment 		|| createComment;
		vm.updateComment 		= vm.updateComment 		|| updateComment;
		vm.deleteComment 		= vm.deleteComment 		|| deleteComment;
		vm.hide 				= vm.hide 				|| hide;
		vm.cancel 				= vm.cancel 			|| cancel;
		vm.assignDates 			= vm.assignDates 		|| assignDates;
		vm.resetStatus 			= vm.resetStatus 		|| resetStatus;
		vm.checkTitle 			= vm.checkTitle 		|| checkTitle;
		vm.getCommentCount 		= vm.getCommentCount 	|| getCommentCount;
		//////////









		/*
		 * Set the initial parameters
		 *
		 */
		function initialize(  )
		{   

			// Default text and title for new forums
			vm.forumTitle = ""
			vm.forumText = "Enter your question here";
			vm.comments = [];

			// Set the type of page we are looking at
			if ( ( window.location.href=="https://www.cadwolf.com/Forums" ) ||
				 ( window.location.href=="https://www.cadwolf.com/Forum" ) ||
				 ( window.location.href=="https://www.cadwolf.com/Forums/" ) ||
				 ( window.location.href=="https://www.cadwolf.com/Forum/" ) ||
				 ( window.location.href=="https://cadwolf-staging.herokuapp.com/Forums/") ||
				 ( window.location.href=="https://cadwolf-staging.herokuapp.com/Forum/") )
			{
				vm.pageType = "default";
			
			}else
			{

				// If forum, get the discussion data
				$http({
					method: "GET",
					url: window.location.origin+'/files',
					params: { thisURL : window.location.href.replace(/\~2F/g,'/'), version : 0, revision : 0 }
				}).then(function successCallback( returnData ) 
				{
					
					if ( (returnData.data.fileInfo === undefined ) || ( returnData.data.fileInfo == "noFile" ) )
					{   
						vm.noForum = true;
					
					}else
					{

						vm.cadwolf_fileInfo = returnData.data.fileInfo;
						vm.cadwolf_files = returnData.data.files;
						

						// If this is a workspace
						if ( vm.cadwolf_fileInfo.file_type_id == 'Workspace' )
						{

							vm.pageType = "forumList";

							// Assign Dates
							vm.assignDates();
							vm.getCommentCount( vm.cadwolf_fileInfo.id );

						}


						// If this is a forum and not a workspace, get the comments
						if ( vm.cadwolf_fileInfo.file_type_id == 'Forum' )
						{

							vm.pageType = "forum";

							$http({
								method: "GET",
								url: window.location.origin+'/discussions/'+vm.cadwolf_fileInfo.id

							}).then(function successCallback( returnData ) 
							{
								console.log('The comments are ...');
								console.log(returnData);

								vm.comments = returnData.data
								vm.resetStatus();

								// Assign Dates
								vm.assignDates();

							});

						}

					}

				});

			}

		}











		/**
		 *
		 * Navigate to a given URL
		 *
		 */
		function goToURL( thisURL )
		{

			thisURL=window.location.href+''+thisURL.replace(/ /g,'_');
			thisURL=thisURL.replace('https://cadwolf-staging.herokuapp.com', '');
			thisURL=thisURL.replace('https://www.cadwolf.com', '');
			thisURL=thisURL.replace('www.cadwolf.com', '');
			console.log('Going here '+thisURL);
			$location.path(thisURL);

		}




		/**
		 *
		 * Assign Date objects to forums and comments
		 *
		 */
		function assignDates( )
		{


			vm.cadwolf_files.forEach(function(thisItem, index)
			{  
				var thisDate = thisItem['created_at'].split(' ');
				thisItem['created_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
			});



			vm.comments.forEach(function(thisItem, index)
			{  
				var thisDate = thisItem['created_at'].split(' ');
				thisItem['created_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
			});


			var thisDate = vm.cadwolf_fileInfo.created_at.split(' ');
			vm.cadwolf_fileInfo.created_at_date = new Date(thisDate[0]+'T'+thisDate[1]);


		}









		/**
		 *
		 * Count the number of comments for the forums
		 *
		 */
		function getCommentCount( id )
		{
			console.log('In the get comment count code');

			var fileArray = [];

			vm.cadwolf_files.forEach(function(thisFile, index)
			{  
				fileArray.push(thisFile.id);
			});


			// If forum, get the discussion data
			$http({
				method: "POST",
				url: window.location.origin+'/commentCount',
				data: { fileArray : fileArray  }
			}).then(function successCallback( returnData ) 
			{

				console.log(returnData);

				vm.cadwolf_files.forEach(function(thisFile, index)
				{
					thisFile['commentCount'] = returnData.data[thisFile.id];
				});

			});


		}







		/**
		 *
		 * Create a new forum
		 *
		 */
		function createForum( )
		{
			console.log('In the create forum code');


			// If forum, get the discussion data
			$http({
				method: "PUT",
				url: window.location.origin+'/newforum',
				data: { forumTitle : vm.forumTitle, 
						forumText : vm.forumText,
						parent : window.location.href }
			}).then(function successCallback( returnData ) 
			{

				vm.cadwolf_files = returnData.data;

			});


		}






		/**
		 *
		 * Edit a forum title or text
		 *
		 */
		function updateForum( )
		{
			console.log('In the update forum code');


			// If forum, get the discussion data
			$http({
				method: "POST",
				url: window.location.origin+'/editforum/'+vm.cadwolf_fileInfo.id,
				data: { forumTitle : vm.cadwolf_fileInfo.name, 
						forumText : vm.cadwolf_fileInfo.item_data.text }
			}).then(function successCallback( returnData ) 
			{

			});


		}






		/**
		 *
		 *	Check the format of the title
		 *
		 */
		function checkTitle( )
		{

			// Title is default as OK
			vm.titleProblem=false;

			var test = vm.forumTitle.match(/\?|\_|\*|\&|\^|\%|\$|\#|\@|\!|\,|\(|\)|\'|\"|\;|\;|\<|\>|\{|\[|\]|\}/);

			if ( test != null )
			{
				vm.titleProblem = true;
			}
		
		}







		/**
		 *
		 * Create a comment
		 *
		 */
		function createComment( parentID, editStatus )
		{
			console.log('In the create comment code');

			if ( editStatus == 0 )
			{
				var thisText = vm.newCommentText;
			}else
			{
				var thisText = '';				
			}

			// Create the item in the database
			$http({
				method: "POST",
				url: window.location.origin+'/discussions',
				data:{ owner_id : vm.cadwolf_fileInfo.id,
					   parent_id : parentID,
					   item_data :  { text: thisText,
					   				  editStatus : editStatus,
					   				  type : "comment" }
				}

			}).then(function successCallback( returnData ) 
			{

				// Push the comment to the array
				vm.comments.push(returnData.data);

				if ( editStatus == 0 )
				{
					vm.newCommentText='';
				}

			});


		}








		/**
		 *
		 * Edit a comment
		 *
		 */
		function updateComment( id )
		{

			console.log('In the update comment code with an id of '+id);

			vm.comments.forEach(function(thisComment, index)
			{  

				if ( thisComment.id == id )
				{

					$http({
						method: "PUT",
						url: window.location.origin+'/discussions/'+id,
						data: { item_data : thisComment.item_data }
					}).then(function successCallback( returnData ) 
					{

						thisComment.item_data.editStatus = 0;

					});

				}

			});


		}








		/**
		 *
		 * Delete a comment
		 *
		 */
		function deleteComment( id )
		{

			console.log('In the delete comment code with an id of '+id);

			vm.comments.forEach(function(thisComment, index)
			{  

				if ( thisComment.id == id )
				{

					$http({
						method: "DELETE",
						url: window.location.origin+'/discussions/'+id
					}).then(function successCallback( returnData ) 
					{

						vm.comments.forEach(function(thisComment, index)
						{  
							if (thisComment.id == id )
							{
								vm.comments.splice(index, 1);
							}
						});

					});

				}

			});


		}










		/*
		 *
		 * Show the small modal box that lets the user add an a new forum
		 *
		 */
		function showNewForumModal(ev) 
		{
			$mdDialog.show({
				controller: function(){ return vm },
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/forum/views/dialogs/newForum.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
				vm.returnData = data;


			}, function() {
				
			});
		};



		/*
		 *
		 * Reset the status of every comment
		 *
		 */
		function resetStatus(id) 
		{
			vm.newComment=false;
			vm.editForum=false;

			vm.comments.forEach(function(thisComment, index)
			{  
				thisComment.item_data.editStatus = 0;
				if ( thisComment.id == id )
				{
					thisComment.item_data.editStatus = 1;
				}
			})

			if ( ( id == "0" ) || ( id == 0 ) )
			{
				vm.newComment=true; 
			}


			if ( ( id == "forum" ) )
			{
				vm.editForum=true; 
			}

		}






		function cancel(){
			$mdDialog.cancel();
		};


		function hide(){
			console.log('hide function');
			$mdDialog.hide();
			vm.createForum();
		};







		// Call the initialization function
		vm.initialize();





	}

})();

(function ()
{
	'use strict';

	angular
		.module('fuse')
		.controller('DocumentDialogController', DocumentDialogController);

	/** @ngInject */
	function DocumentDialogController($sce, $mdDialog, $http, locals, utilityFactory, chartFactory, docItemFactory)
	{
		var equationWorker = new Worker("eqSolver.js");  
		var vm					= vm || this;
		vm.digestStatus 		= 1;
		vm.thisItem   			= locals.thisItem;
		vm.file_id	  			= locals.file_id;
		vm.worksheet			= locals.worksheet;
		vm.editPerm 			= locals.editPerm;
		vm.viewPerm 			= locals.viewPerm;
		vm.fileInfo 			= locals.fileInfo;
		vm.permissions			= locals.permissions;
		vm.messageObj			= locals.messageObj;
		vm.cadwolf_worksheet	= locals.worksheet;
		vm.currentItem			= vm.thisItem;
		vm.modalType			= locals.modalType;
		vm.chartFactory  		= chartFactory;
		vm.docItemFactory   	= docItemFactory;
		vm.cadwolfScaleUnits 	= locals.cadwolfScaleUnits;
		vm.cadwolfParseUnits 	= locals.cadwolfParseUnits;
		vm.cadwolfConstants  	= locals.cadwolfConstants;
		vm.cadwolf_usePython 	= locals.cadwolf_usePython;
		vm.pythonVersion		= locals.pythonVersion;
		vm.currentContents  	= [];
		vm.currentFile			= '';
		vm.inputEquations   	= [];
		vm.inputURL   			= "/Documentation";
		vm.thisCAD	  			= {};
		vm.comments				= locals.comments;
		vm.forums 				= locals.forums;
		var Spark				= locals.Spark;
		vm.Spark 				= locals.Spark;

		vm.thisCAD.document_data= {};
		vm.thisCAD.element_data	= {};
		vm.thisCAD.part_data 	= {};
		vm.autocadFileSelected  = false;
		vm.showFusionProps = false;
		vm.newCADConnect = { "id":"", "hub":"", "hubData":{}, "project":"", "projectData":{}, "rootFolder":"", "rootData":{}, "folders":[], "folderData":[], "file":"", "fileData":{} };



		// Methods
		vm.cancel				= cancel;
		vm.acceptChanges		= acceptChanges;
		vm.acceptImage			= acceptImage;
		vm.selectImage			= selectImage;
		vm.addReference 		= addReference;
		vm.deleteReference		= deleteReference;
		vm.getFolderContents	= getFolderContents;
		vm.setNewURL			= setNewURL;
		vm.setDocEqs			= setDocEqs;
		vm.createComponent		= createComponent;
		vm.addFileInput 		= addFileInput;
		vm.setReqParent 		= setReqParent;
		vm.deleteInput			= deleteInput;
		vm.deleteItem			= deleteItem;
		vm.addDataset			= addDataset;
		vm.changeRef			= changeRef;
		vm.setVideoURL			= setVideoURL;
		vm.deleteFAF			= deleteFAF;
		vm.addFAF				= addFAF;
		vm.setFafItem			= setFafItem;
		vm.addFafItem			= addFafItem;
		vm.deleteFafItem		= deleteFafItem;
		vm.checkoutDocument		= checkoutDocument;
		vm.arrayFromNum  		= arrayFromNum;
		vm.createShowSolution   = createShowSolution;
		vm.checkOutFile 		= checkOutFile;
		vm.checkInFile			= checkInFile;
		vm.getCardValue 		= getCardValue;
		vm.addConnected 		= addConnected;
		vm.addConnectedToo 		= addConnectedToo;
		vm.removeConnected 		= removeConnected;
		vm.checkConnected		= checkConnected;
		vm.addConnEq			= addConnEq;
		vm.removeConnEq 		= removeConnEq;
		vm.setConnEq			= setConnEq;
		vm.setConnEl			= setConnEl;
		vm.pushToOnshape		= pushToOnshape;
		vm.updateElements		= updateElements;
		vm.getOnshapeDocs		= getOnshapeDocs;
		vm.getCadElements		= getCadElements;
		vm.getCadParts			= getCadParts;
		vm.setCadProperties 	= setCadProperties;
		vm.setFusionProperties  = setFusionProperties;
		vm.getFusionProperties 	= getFusionProperties;
		vm.updateFusionData		= updateFusionData;
		vm.addCadImport   		= addCadImport;
		vm.updateCadMaterial	= updateCadMaterial;
		vm.setThumbnail   		= setThumbnail;
		vm.setCadElement		= setCadElement;
		vm.getAutocadHubs		= getAutocadHubs;
		vm.getAutocadProjects 	= getAutocadProjects;
		vm.getAutocadFolders 	= getAutocadFolders;
		vm.getAutocadFolderContents = getAutocadFolderContents;
		vm.getAutocadItem 		= getAutocadItem;
		vm.setAutocadItem 		= setAutocadItem;
		vm.setAutocadPullItem 	= setAutocadPullItem;
		vm.pushToFusion			= pushToFusion;

		vm.getDepFiles			= getDepFiles;
		vm.getVersions			= getVersions;
		vm.updateFile			= updateFile;
		vm.runEquationDigest	= runEquationDigest;
		vm.solveEquation		= solveEquation;
		vm.addressConnectedEqs  = addressConnectedEqs;
		vm.updateComponent		= updateComponent;
		vm.saveFile	 			= saveFile;
		vm.saveComponents		= saveComponents;

		vm.newVersion			= newVersion;
		vm.newRevision			= newRevision;

		vm.loadVersion	 		= loadVersion;

		vm.addFBDItem			= addFBDItem;
		vm.moveFBD				= moveFBD;
		vm.deleteFBD			= deleteFBD;
		vm.reDrawFBD			= reDrawFBD;

		vm.formatEqs			= formatEqs;

		vm.addForum 			= addForum;
		vm.resetStatus 			= resetStatus;
		vm.assignDates 			= assignDates;
		vm.createComment 		= createComment;
		vm.updateComment 		= updateComment;
		vm.deleteComment 		= deleteComment;
		vm.updateForum 			= updateForum;
		vm.checkTitle 			= checkTitle;

		vm.editForum=false;
		vm.newComment=false;


		function cancel(){
			$mdDialog.cancel();
		};

		function acceptChanges(item) {
			$mdDialog.hide(item);
		};


		function arrayFromNum(num) {
			return new Array(num);   
		}


		function loadVersion(verNum, refNum){
			$mdDialog.hide({'version' : verNum, 'revision' : refNum});
		};


		function formatEqs(verNum){
			MathJax.Hub.Configured();
			MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
		};

		vm.formatEqs();

		/*
		*
		*   FUNCTIONS RELATING TO SETTING UP THIS DOCUMENT AS A FILE AS A FUNCTION
		*
		*/




		/*
		 * Append new entry to the FaF inputs or outputs
		 *
		 */
		function addFafItem( type )
		{   
			if ( type=="input" )
			{
				var newItem={
					'order' : vm.fileInfo.item_data.fileAsFunction.inputs.length,
					'name' : 'equationName'
				}
				vm.fileInfo.item_data.fileAsFunction.inputs.push( newItem );
			}

			if ( type=="output" )
			{
				var newItem={
					'order' : vm.fileInfo.item_data.fileAsFunction.outputs.length,
					'name' : 'equationName'
				}
				vm.fileInfo.item_data.fileAsFunction.outputs.push( newItem );
			}

		}






		/*
		 *
		 * Set the properties of the FaF inputs or outputs
		 *
		 */
		function setFafItem( thisItem )
		{   
			vm.worksheet.forEach(
				function(thisEq, index){
					if ( thisEq['itemid'] == thisItem['itemid'] ) 
					{
						thisItem['name'] = thisEq['content']['Equation']['Format_name'];
						thisItem['real'] = thisEq['content']['Equation']['Solution_real'];
						thisItem['imag'] = thisEq['content']['Equation']['Solution_imag'];
						thisItem['units'] = thisEq['content']['Equation']['Units_units'];
						thisItem['size'] = thisEq['content']['Equation']['Format_size'];
					}
				}
			);

		}




		/*
		 * Remove entry from the FaF inputs or outputs
		 *
		 */
		function deleteFafItem( type, order )
		{   
			if ( type=="input" )
			{
				vm.fileInfo.item_data.fileAsFunction.inputs.splice( order, 1 )
			}

			if ( type=="output" )
			{
				vm.fileInfo.item_data.fileAsFunction.outputs.splice( order, 1 )
			}

		}




		/*
		*
		*   FUNCTIONS RELATING TO THE BIBLIOGRAPHY DIALOG
		*
		*/


		/*
		*
		*   ADD A REFERENCE TO THE BIBLIOGRAPHY
		*
		*/
		function addReference() 
		{   
			var thisRefID = docItemFactory.getID('ref', vm.thisItem.fileInfo.id);
			var refNum = vm.fileInfo.item_data.references.length+1;
			vm.fileInfo.item_data.references.push(docItemFactory.newRef({refID:thisRefID, refNum:refNum})); 
			vm.fileInfo.item_data.references.sort(utilityFactory.dynamicSort("refNum"));
		}



		/*
		*
		*   DELETE A REFERENCE FROM THE BIBLIOGRAPHY
		*
		*/
		function deleteReference( refID ) 
		{
			var deleteIndex=vm.fileInfo.item_data.references.length+1;
			
			// Find the index of the reference being deleted and remove reference from array
			vm.fileInfo.item_data.references.forEach(
				function(thisRef, index){
					if ( thisRef.refID == refID )
					{
						vm.fileInfo.item_data.references.splice(index, 1);
						deleteIndex = thisRef.refNum;
					}
				}
			);  

			// Decrement the reference numbers of any reference higher than this one
			vm.fileInfo.item_data.references.forEach(
				function(thisRef, index){
					if ( thisRef.refNum > deleteIndex )
					{
						thisRef.refNum = thisRef.refNum-1;
					}
				}
			);  

			// Resort the reference array
			vm.fileInfo.item_data.references.sort(utilityFactory.dynamicSort("refNum"));
		}












		/*
		 *
		 * Selecting an image from the list
		 *
		 */
		function selectImage( currentImage, thisItem ) {

		};




		/*
		 *
		 * Get the contents of a workspace
		 *
		 */
		function getFolderContents( thisItem, thisURL )
		{   
			thisURL = thisURL.replace(/\/\//g, "/");
			console.log('Getting the contents of '+thisURL);
			$http({
				method: "GET",
				url: '/files',
				params: { thisURL : thisURL.replace(/\~2F/g,'/') }
			}).then(function successCallback( returnData ) 
			{
				console.log( returnData );
				vm.currentFile = returnData['data']['fileInfo'];
				if ( typeof(vm.currentFile.item_data) == "string" )
				{
					vm.currentFile.item_data = JSON.parse(vm.currentFile.item_data);
				}
				vm.currentContents = returnData['data']['files'];
				vm.currentContents.forEach(
					function(thisEq, index){
						if ( typeof(thisEq['item_data'])=="string")
						{
							thisEq['item_data']=JSON.parse(thisEq['item_data']);
						}
					}
				);
			}, function errorCallback( returnData ) {
				vm.currentContents = [];
			});
		}






		/*
		*
		*   FUNCTIONS RELATING TO THE FILE INPUTS DIALOG
		*
		*/



		/*
		 *
		 * Get the contents of a document
		 *
		 */
		function setNewURL( thisName )
		{
			vm.inputURL = vm.inputURL+'/'+thisName;
			this.getFolderContents( '', vm.inputURL );
		}



		/*
		 *
		 * Get the contents of a document
		 *
		 */
		function setDocEqs( thisItem )
		{
			var thisURL = '/files/'+thisItem.id+'/components'
			$http({
				method: "GET",
				url: thisURL,
				params: { }
			}).then(function successCallback( returnData )
			{
				console.log(returnData);
				vm.inputEquations = returnData.data.components;
				vm.inputEquations.forEach(
					function(thisEq, index){
						thisEq['content'] = JSON.parse(thisEq['content']);
					}
				);
			});
		}




		/*
		 *
		 * Create a new version
		 *
		 */
		function newVersion( )
		{
			var thisURL = '/files/newVersion/'+vm.fileInfo.id;
			$http({
				method: "PUT",
				url: thisURL,
				params: { }
			}).then(function successCallback( returnData )
			{
				window.location.reload();
			});
		}


		/*
		 *
		 * Create a new revision
		 *
		 */
		function newRevision( )
		{
			var thisURL = '/files/newRevision/'+vm.fileInfo.id;
			$http({
				method: "PUT",
				url: thisURL,
				params: { }
			}).then(function successCallback( returnData )
			{
				window.location.reload();
			});
		}






		/*
		*
		*   ADD AN INPUT ITEM TO THE DOCUMENT
		*
		*/
		function addFileInput( obj ) 
		{   

			console.log('I am in the add file input function');
			var thisID = docItemFactory.getID('Equation', vm.file_id, vm.worksheet);
			var newTemplate = docItemFactory.newItem(   'Equation', 
														thisID, 
														0, 
														vm.file_id, 
														{},
														vm.worksheet);


			newTemplate['content'] = JSON.parse(JSON.stringify( obj.content ));

			newTemplate['content']['Equation']['inputType'] = 'File';
			newTemplate['content']['Equation']['inputFile'] = obj['file_id'];
			newTemplate['content']['Equation']['inputID'] = obj['id'];
			newTemplate['content']['inputFile'] = obj['file_id'];
			newTemplate['content']['inputID'] = obj['id'];
			newTemplate['name'] = obj['content']['Name'];

			newTemplate['content']['id'] = thisID;
			newTemplate['content']['itemid'] = thisID;
			newTemplate['content']['Equation']['Format_id'] = thisID;

			newTemplate['dependent_id'] = obj['id'];
			newTemplate['dependent_file'] = obj['file_id'];

			var flag=0;

			vm.worksheet.forEach(
				function(thisEq, index){
					if ( thisEq['content']['Name'] == newTemplate['content']['Name'] )
					{
						flag = 1;
					}
				}
			);

			if ( flag==0 )
			{
				vm.worksheet.push( newTemplate );

				vm.createComponent( newTemplate, 1 );	  
			}

		}







		/*
		*
		*   ADD AN INPUT ITEM TO THE DOCUMENT
		*
		*/
		function setReqParent( obj ) 
		{   

			console.log('I am in the set req parent function');

			// Loop through the worksheet and when you find the one that matches the current item
			vm.worksheet.forEach(
				function(thisItem, index){

					if ( thisItem['id'] == vm.currentItem['id'] )
					{

						// Set the dependent_id as the requirement selected
						thisItem['dependent_id'] = obj['itemid'];						

						// Set these things in the content of the requirement
						thisItem.content.parent = obj['itemid'];
						thisItem.content.parentFile = obj['file_id'];					

					}
				}
			);

		}












		/*
		*
		*   DELETE AN INPUT ITEM TO THE DOCUMENT
		*
		*/
		function deleteInput( obj ) 
		{   
			console.log('You are in the delete input function for '+obj.content.Equation.Format_name);
			vm.worksheet.forEach(
				function(thisEq, index){
					if ( thisEq['itemid'] == obj.itemid )
					{
						vm.worksheet.splice( index, 1 );
						vm.deleteItem( obj );
					}
				}
			);
		}


		/*
		*
		*   MAKE THE CALL TO DELETE AN ITEM
		*
		*/
		function deleteItem( obj ) 
		{   
			console.log('I should be deleting '+obj['id']);
			$http({
				method: "DELETE",
				url: window.location.origin+'/components/'+obj['id'],
				data: { 
							connected : 1
					  }
			}).then(function successCallback( returnData ) {

			}, function errorCallback( returnData ) {});
		}





		/*
		*
		*   FUNCTIONS RELATING TO THE DATASETS INPUT DIALOG
		*
		*/


		/*
		*
		*   ADD A DATASET AS AN EQUATION
		*
		*/
		function addDataset( thisDataset ) 
		{
			console.log('I am in the add dataset input function');
			var thisID = docItemFactory.getID('Equation', vm.file_id, vm.worksheet);
			var newTemplate = docItemFactory.newItem(   'Equation', 
														thisID, 
														0, 
														vm.file_id, 
														{},
														vm.worksheet);

			newTemplate['content']['Equation'] = new docItemFactory.eqPro( {}, vm.file_id ); 

			newTemplate['content']['Equation']['inputType'] = 'Dataset';
			newTemplate['content']['inputFile'] = thisDataset['id'];
			newTemplate['content']['inputID'] = thisDataset['id'];
			newTemplate['content']['Equation']['Solution_real'] = thisDataset.item_data.real;
			newTemplate['content']['Equation']['Solution_imag'] = {};
			newTemplate['content']['Equation']['Format_size'] = thisDataset.item_data.size;
			newTemplate['content']['Equation']['Format_name'] = thisDataset.item_data.name;

			newTemplate['content']['id'] = thisID;
			newTemplate['id'] = thisID;
			newTemplate['content']['itemid'] = thisID;
			newTemplate['content']['Equation']['Format_id'] = thisID;
			newTemplate['dependent_id'] = thisDataset.id;
			newTemplate['dependent_file'] = thisDataset.id;
			newTemplate['content']['Name'] = thisDataset.item_data.name;

			for (var index in newTemplate['content']['Equation']['Solution_real'])
			{
				newTemplate['content']['Equation']['Solution_real'][index] = parseFloat(newTemplate['content']['Equation']['Solution_real'][index]);
			}

			var flag=0;
			vm.worksheet.forEach(
				function(thisEq, index){
					if ( thisEq['content']['Name'] == newTemplate['content']['Name'] )
					{
						flag = 1;
					}
				}
			);

			if ( flag==0 )
			{
				vm.worksheet.push( newTemplate );

				vm.createComponent( newTemplate, 1 );	  
			}

		}







		/*
		 * Creates a new component
		 *
		 */
		function createComponent( thisItem )
		{   
			$http({
				method: "POST",
				url: window.location.origin+'/components',
				data: { 
							itemid  : thisItem['itemid'],
							file_id : vm.file_id,
							order   : 0,
							name	: thisItem['name'],
							content : JSON.stringify(thisItem['content']),
							component_type_id : thisItem['component_type_id'],
							dependent_file : thisItem['dependent_file'],
							dependent_id : thisItem['dependent_id'],
							connected : 1			// This is used here to prevent increment of other items 
														// since this is not visible on the worksheet and stored at 
														// an order of 0 
					  }
			}).then(function successCallback( returnData ) {
					thisItem.id = returnData.id;
			}, function errorCallback( returnData ) {});
		}	  





		/*
		*
		*   FUNCTIONS RELATING TO ADDING OR REMOVING A REFERENCE
		*
		*/


		/*
		*
		*   CHANGE WHETHER OR NOT A REFERENCE APPLIES
		*
		*/
		function changeRef( refID, thisItem ) 
		{
			var flag = 0;

			// Check to see of the ID is already a reference and delete it
			for (var a=0; a<thisItem.content.references.length; a++)
			{
				if ( thisItem.content.references[a] == refID )
				{
					thisItem.content.references.splice(a,1);
					flag=1;
				}
			}

			// If the item is not present, add it to the list of references
			if ( flag == 0 )
			{
				thisItem.content.references.push(refID);
			}
		}




		/*
		*
		*   SET A VIDEO URL
		*
		*/
		function setVideoURL( ) 
		{
			vm.thisItem.content.url=$sce.trustAsResourceUrl('https://www.youtube.com/embed/'+vm.thisItem.content.videoID);
		}





		/*
		*
		*   FUNCTIONS RELATING TO THE IMPORTED FILES AS FUNCTIONS DIALOG
		*
		*/



		/*
		 *
		 * Add a file as a function
		 *
		 */
		function addFAF( thisObj )
		{
			console.log(thisObj);
			var funObj = {
				parentLocation : vm.inputURL,
				fileID : thisObj.id,
				fileName : thisObj.name,
				functionName : thisObj.item_data.fileAsFunction.fileFunName,
				functionInputs : thisObj.item_data.fileAsFunction.inputs,
				functionOutputs : thisObj.item_data.fileAsFunction.outputs,
				showContents : false,
				fileItems : []
			};
			var thisURL = window.location.origin+'/files/'+thisObj.id+'/components'
			$http({
				type: "GET",
				url: thisURL,
				params: { version : 0 }
			}).then(function successCallback( returnData ) 
			{
				console.log(returnData);
				var components = returnData.data.components.sort(utilityFactory.dynamicSort("order"));
				components.forEach(
					function(thisItem, index){
						thisItem['content'] = JSON.parse(thisItem['content']);
						if ((thisItem['component_type_id']==3)||
							(thisItem['component_type_id']==5)||
							(thisItem['component_type_id']==6)||
							(thisItem['component_type_id']==7)||
							(thisItem['component_type_id']==8))
						{
							funObj['fileItems'].push(thisItem);
						}
					}
				);
				vm.fileInfo.item_data.impFunctions.push( funObj );
			}, function errorCallback( returnData ) {});
		}


		/*
		 *
		 * Delete a file as a function
		 *
		 */
		function deleteFAF( thisObj )
		{
			console.log(thisObj);
			for (var a=0; a<vm.fileInfo.item_data.impFunctions; a++)
			{
				console.log('Comparing '+vm.fileInfo.item_data.impFunctions[a]['fileID']+' with '+thisObj['fileID']);
				if (vm.fileInfo.item_data.impFunctions[a]['fileID'] == thisObj['fileID'])
				{
					vm.fileInfo.item_data.impFunctions.splice( a, 1 );		   
				}
			}
		}


		/*
		 *
		 * Checkout a document
		 *
		 */
		function checkoutDocument( item ) 
		{   
			$http({
				method: "POST",
				url: window.location.origin+'/checkout/'+item['id'],
			}).then(function successCallback( returnData ) {
				if(returnData.data=="noPerm")
				{

				}else
				{
					window.location.reload();
				}
			}, function errorCallback( returnData ) {});
			
		};



		function acceptImage(item) {
			$mdDialog.hide(item);
		};




		/*
		*
		*   CREATE THE SOLUTION MATRIX TO SHOW
		*
		*/
		function createShowSolution( thisObj )
		{
			console.log('In the create show solution function');
			thisObj.content.Equation['Format_showsolution'] = docItemFactory.createShowSolution( thisObj, vm.cadwolfScaleUnits );
		};







		/*
		 *
		 * Checkout a document
		 *
		 */
		function checkOutFile( ) 
		{   
			$http({
				method: "POST",
				url: window.location.origin+'/checkout/'+vm.fileInfo['id'],
			}).then(function successCallback( returnData ) {
				if(returnData.data=="noPerm")
				{

				}else
				{
					vm.fileInfo['item_data']['checkout_id']=returnData.data['id'];
					vm.fileInfo['item_data']['checkout_name']=returnData.data['name'];

				}
			}, function errorCallback( returnData ) {});
			
		};

		/*
		 *
		 * Checkin a document
		 *
		 */
		function checkInFile( ) 
		{   
			$http({
				method: "POST",
				url: window.location.origin+'/checkin/'+vm.fileInfo['id'],
			}).then(function successCallback( returnData ) {
				if(returnData.data=="noPerm")
				{

				}else
				{
					vm.fileInfo['item_data']['checkout_id']=returnData.data;
					vm.fileInfo['item_data']['checkout_name']='';
				}
			}, function errorCallback( returnData ) {});
			
		};




		/*
		 *
		 * Set the value for the card
		 *
		 */
		function getCardValue( thisItem )
		{   
			console.log('In the get card value function with an id of '+thisItem['content']['variableID']);
			vm.worksheet.forEach(
				function(thisEq, index)
				{
					if ( thisEq['itemid'] == thisItem['content']['variableID'] ) 
					{
						thisItem['content']['value'] = thisEq['content']['Equation']['Solution_real'][thisItem['content']['index']];
						thisItem['content']['units'] = thisEq['content']['Equation']['Units_units'];
						thisItem['content']['variable'] = thisEq['name'];
						thisItem['content']['variableOrder'] = thisEq['order'];
					}
				}
			);
		}







		/*
		 *
		 * Get the documents for the onShape user
		 *
		 */
		function getOnshapeDocs( )
		{

			console.log('I am in the getOnshapeDocs function');

			$http({
				method: "GET",
				url: window.location.origin+'/files/getOnshapeDocs',
				params: { }
			}).then(function successCallback( returnData )
			{
				console.log(returnData);
				vm.cadFiles = returnData.data.items;
				vm.checkConnected();
			}, function errorCallback( returnData ) 
			{ 
				vm.checkConnected();
			});

		}

		/*
		 *
		 * Get the elements for a given CAD document
		 *
		 */
		function getCadElements( )
		{
			console.log('I am in the getCadElements function');

			// Loop through the cad files and find the one selected
			for (var a=0; a<vm.cadFiles.length; a++)
			{
				if ( vm.thisCAD.document_data.id == vm.cadFiles[a]['id'] )
				{
					vm.thisCAD['document_data'] = vm.cadFiles[a];
					vm.thisCAD['element_data'] = {};
					vm.thisCAD['part_data'] = {};
				}
			}

			// Call the function to pull the elements from the CAD system
			$http({
				method: "GET",
				url: '/files/getCadElements',
				params: { document_id : vm.thisCAD['document_data']['id'],
						  workspace_id : vm.thisCAD['document_data']['defaultWorkspace']['id'] }
			}).then(function successCallback( returnData ) 
			{
				console.log( returnData );
				vm.cadElements = returnData.data;

			}, function errorCallback( returnData ) { });

		}




		/*
		 *
		 * Get the elements for a given CAD document
		 *
		 */
		function getCadParts( )
		{
			console.log('I am in the getCadParts function');

			// Loop through the cad elements and find the one selected
			for (var a=0; a<vm.cadElements.length; a++)
			{
				if ( vm.thisCAD.element_data.id == vm.cadElements[a]['id'] )
				{
					vm.thisCAD['element_data'] = vm.cadElements[a];
					vm.thisCAD['part_data'] = {};
				}
			}

			// Assemblies do not need this step
			if ( vm.thisCAD.element_data.elementType == 'PARTSTUDIO' )
			{

				// Call the function to pull the elements from the CAD system
				$http({
					method: "GET",
					url: '/files/getCadParts',
					params: { document_id : vm.thisCAD['document_data']['id'],
							  workspace_id : vm.thisCAD['document_data']['defaultWorkspace']['id'] }
				}).then(function successCallback( returnData ) 
				{
					// This returns a list of all parts. Find one(s) that match this element
					console.log( returnData );
					var partList=[];
					for (var a=0; a<returnData.data.length; a++)
					{
						if ( returnData.data[a]['elementId'] == vm.thisCAD['element_data']['id'] )
						{
							partList.push( returnData.data[a] );
						}
					}

					vm.cadParts = partList;

				}, function errorCallback( returnData ) { });
			
			}else
			{
				vm.setCadProperties();
			}

		}



		/*
		 *
		 * Set the cad specific items for this array entry
		 *
		 */
		function setCadProperties( )
		{
			console.log('I am in the setCadProperties function');

			if ( vm.thisCAD.element_data.elementType == 'PARTSTUDIO' )
			{

				// Loop through the cad parts and find the one selected
				for (var a=0; a<vm.cadParts.length; a++)
				{
					if ( vm.thisCAD.part_data.partId == vm.cadParts[a]['partId'] )
					{
						vm.thisCAD['part_data'] = vm.cadParts[a];
					}
				}

				// Get the material and mass properties
				$http({
					method: "GET",
					url: '/files/getCadMaterial',
					params: { document_id : vm.thisCAD['document_data']['id'],
							  workspace_id : vm.thisCAD['document_data']['defaultWorkspace']['id'],
							  element_id : vm.thisCAD['element_data']['id'],
							  part_id : vm.thisCAD['part_data']['partId'] }
				}).then(function successCallback( returnData ) 
				{
					console.log( returnData );
					vm.thisCAD['material_data'] = returnData.data;
					vm.thisCAD['type'] = "onshape";



				}, function errorCallback( returnData ) { });

				// Get the material and mass properties
				$http({
					method: "GET",
					url: '/files/getCadMass',
					params: { document_id : vm.thisCAD['document_data']['id'],
							  workspace_id : vm.thisCAD['document_data']['defaultWorkspace']['id'],
							  element_id : vm.thisCAD['element_data']['id'],
							  part_id : vm.thisCAD['part_data']['partId'] }
				}).then(function successCallback( returnData ) 
				{
					console.log( returnData );
					vm.thisCAD['mass_data'] = returnData.data;

					vm.thisCAD['type'] = "onshape";

					// Place the cad data in the part tree so that it can be used
					vm.addCadImport();

				}, function errorCallback( returnData ) { });

			}else
			{

			}

		}




		/*
		 *
		 * Add an cad file to the list of imported data items
		 *
		 */
		function addCadImport( type )
		{
			var flag=0;

			console.log('I am in the addCadImport function for '+type);

			// Makes sure that there isn't already a CAD connected
			vm.fileInfo.item_data.importedCAD.forEach(
				function(thisItem, index){

					if ( thisItem['type'] === undefined )
					{
						thisItem['type'] = "onshape";
					}

					if ( thisItem['id'] == vm.thisCAD['id'] ) 
					{
						flag=1;
					}
				}
			);

			// If there is no connected item, add this one
			if ( flag == 0 )
			{
				vm.fileInfo.item_data.importedCAD.push( vm.thisCAD );
			}


		}








		/*
		 *
		 * Place the fusion data into the cad array
		 *
		 *  @param - the bodyData object from Autodesk forge. Contains a properties parameter with mass, density, etc
		 *
		 */
		function setFusionProperties( inputCAD )
		{

			console.log('I am in the set Fusion Properties function');

			inputCAD.type = "fusion";
			inputCAD.id = vm.newCADConnect.fileData.relationships.tip.data.id;
			inputCAD.hubData = vm.newCADConnect.hubData;
			inputCAD.projectData = vm.newCADConnect.projectData;
			inputCAD.rootData = vm.newCADConnect.rootData;
			inputCAD.folderData = vm.newCADConnect.folderData;
			inputCAD.fileData = vm.newCADConnect.fileData;
			inputCAD.cleanID = vm.newCADConnect.fileData.relationships.tip.data.id.replace("urn:adsk.wipprod:fs.file:vf.","").match(/[^?]*/)[0];
			inputCAD.picName = inputCAD.cleanID+".png";

			var flag=0;

			// Makes sure that there isn't already a CAD connected
			vm.fileInfo.item_data.importedCAD.forEach(
				function(thisItem, index){

					if ( thisItem['type'] === undefined )
					{
						thisItem['type'] = "onshape";
					}

					if ( thisItem['id'] == inputCAD.id ) 
					{
						flag=1;
					}
				}
			);

			// If there is no connected item, add this one
			if ( flag == 0 )
			{
				vm.fileInfo.item_data.importedCAD.push( inputCAD );
			}

		}




		/*
		 *
		 *  Create the thumbnail and pull down the mass, volume, etc for a fusion item.
		 *
		 *  @param - cleanID - the string clean ID of the file - not the full urn
		 *  @param - projectID - the id of the project holding the file
		 *
		 */
		function getFusionProperties( cleanID, projectID )
		{
			console.log('I am in the getFusionProperties function with '+cleanID+' and project '+projectID);

			//urn = btoa(urn).replace(/\+/g, '-').replace(/\//g, '_').replace(/\=+$/, '');


			// Send the request
			$http({
				method: "GET",
				url: '/files/getFusionData/'+cleanID+'/'+projectID
			}).then(function successCallback( returnData )
			{
				console.log('The return data for get Fusion Properties is ');
				console.log(returnData.data.data);

				vm.fusionPropItems = returnData.data.data.collection;
				vm.showFusionProps = true;
			});

		}




		/*
		 *
		 *  Regenerate the thumbnail and pull down new data for a fusion file. This is
		 *  the same as the get fusion properties, but the results are placed into the
		 *  correct established imported CAD
		 *
		 *  @param - cleanID - the string clean ID of the file - not the full urn
		 *  @param - projectID - the id of the project holding the file
		 *
		 */
		function updateFusionData( cleanID, projectID )
		{

			console.log('I am in the update Fusion Data function with file '+cleanID+' and project '+projectID);

			//var baseUrn = btoa(urn).replace(/\+/g, '-').replace(/\//g, '_').replace(/\=+$/, '');
			//var id = urn.replace("urn:adsk.wipprod:fs.file:vf.","").match(/[^?]*/)[0];
			//var version = urn.match(/[0-9]+$/)[0]; 

			// Send the request
			$http({
				method: "GET",
				url: '/files/getFusionData/'+cleanID+'/'+projectID
			}).then(function successCallback( returnData )
			{
				console.log('The return data for get Fusion Properties is ');
				console.log(returnData.data.data);

				vm.fileInfo.item_data.importedCAD.forEach(
					function(thisItem, index){

						if ( thisItem['cleanID'] == id )
						{
							returnData.data.data.collection.forEach(
								function(thisProp, propIndex){
							
									if ( thisItem.externalId == thisProp.externalId )
									{
										thisItem.properties = thisProp.properties;
									}

							});
						}

				})


			});



		}








		/*
		 *
		 * Add an onShape file as connected to this document
		 *
		 */
		function addConnected( )
		{
			var elName='', elThumbnail='';
			var thisID = vm.fileInfo.id;
			var cadID = vm.thisCAD.document_data.id;
			var elID = vm.thisCAD.element_data.id;
			console.log('I am in the addConnected function with '+thisID+' - '+cadID+' '+elID);

			// Grab the element data
			vm.cadElements.forEach(
				function(thisEl, index){
					console.log('comparing '+thisEl['id']+' to '+elID);
					if ( thisEl['id'] == elID ) 
					{
						console.log('Got here');
						elName = thisEl['name'];
						elThumbnail = thisEl['thumbnailInfo']['sizes'][0]['href'];
					}
				}
			);

			// Send the request
			$http({
				method: "POST",
				url: window.location.origin+'/files/addConnected',
				params: { document_id : thisID, 
						  cad_id : cadID,
						  el_id : elID,
						  el_name : elName,
						  el_thumbnail : elThumbnail }
			}).then(function successCallback( returnData )
			{
				console.log(returnData);
				vm.connectedFiles = returnData.data;
				for (var a=0; a<vm.connectedFiles.length; a++)
				{
					vm.connectedFiles[a]['info'] = JSON.parse(vm.connectedFiles[a]['info']);
				}
				vm.checkConnected();
			});
		}







		/*
		 *
		 * Add file as connected to this document - not onshape
		 * This, and the server side need to be rewritten so that
		 * only one function is needed
		 *
		 */
		function addConnectedToo( )
		{
			console.log('I am in the addConnected function with the new CAD Connect');

			var thisID = vm.fileInfo.id;
			var cadID = vm.newCADConnect.file;

			// Send the request
			$http({
				method: "POST",
				url: window.location.origin+'/files/addConnectedToo',
				data: { document_id : thisID, 
						  cad_id : cadID,
						  cad_data : vm.newCADConnect,
						  cad_type : "fusion" }
			}).then(function successCallback( returnData )
			{
				console.log(returnData);
				vm.connectedFiles = returnData.data;
				for (var a=0; a<vm.connectedFiles.length; a++)
				{
					vm.connectedFiles[a]['info'] = JSON.parse(vm.connectedFiles[a]['info']);
				}
				vm.checkConnected();

				vm.newCADConnect = { "id":"", 
									"hub":"", 
									"hubData":{}, 
									"project":"", 
									"projectData":{}, 
									"rootFolder":"", 
									"rootData":{}, 
									"folders":[], 
									"folderData":[], 
									"file":"", 
									"fileData":{} };

				vm.autocadContents = {};
				vm.autocadIncluded = {};
				vm.autocadItem = {};
				vm.autocadFileSelected = false;
				vm.showFusionProps = false;

			});
		}






		/*
		 *
		 * Remove an onShape file as connected to this document
		 *
		 */
		function removeConnected( fileID, cadID )
		{
			if ( fileID === undefined )
			{
				var fileID = vm.fileInfo.id;
			}
			if ( cadID === undefined )
			{
				var cadID = vm.thisCAD.document_data.id;
			}
			var elID = vm.thisCAD.element_data.id;

			console.log('I am in the removeConnected function with fileID of '+fileID+' and a doc ID of '+cadID);

			$http({
				method: "POST",
				url: window.location.origin+'/files/removeConnected',
				params: { document_id : fileID, 
						  cad_id : cadID,
						  el_id : elID }
			}).then(function successCallback( returnData )
			{
				console.log(returnData);
				vm.connectedFiles = returnData.data;
				for (var a=0; a<vm.connectedFiles.length; a++)
				{
					vm.connectedFiles[a]['info'] = JSON.parse(vm.connectedFiles[a]['info']);
				}
				vm.checkConnected();
			});
		}



		/*
		 *
		 * Get and check the onShape and autocad items to see if they are linked to this document
		 *
		 */
		function checkConnected( )
		{

			console.log('I am in the checkConnected function');

			$http({
				method: "GET",
				url: window.location.origin+'/getConnected/'+vm.file_id,
				params: { }
			}).then(function successCallback( returnData )
			{
				console.log(returnData);
				vm.connectedFiles = returnData.data.data;
				for (var a=0; a<vm.connectedFiles.length; a++)
				{
					vm.connectedFiles[a]['info'] = JSON.parse(vm.connectedFiles[a]['info']);
					if ( vm.connectedFiles[a]['cad_type'] == "fusion" )
					{
						if ( typeof(vm.connectedFiles[a]['info']['cad_data']) == "string" )
						{
							vm.connectedFiles[a]['info']['cad_data'] = JSON.parse(vm.connectedFiles[a]['info']['cad_data']);
						}
					}
				}
				if ( vm.cadFiles !== undefined )
				{
					for (var a=0; a<vm.cadFiles.length; a++)
					{
						vm.cadFiles[a]['isConn']=0;
						for (var b=0; b<vm.connectedFiles.length; b++)
						{
							if ( vm.cadFiles[a]['id'] == vm.connectedFiles[b]['info']['cad_data']['id'] )
							{
								vm.cadFiles[a]['isConn'] = 1;
							}
						}
					}
				}

			});
		}





		/*
		 *
		 *  Add a connected equation to the connected document
		 *
		 */
		function addConnEq( connectedItem, document_id, cadType )
		{   
			var thisEq='', eqData={}, connID=0, flag=0, iflag=0;

			console.log('I am in the add connected equation function for a '+cadType);
			console.log(connectedItem);


			// Get a unique id for the connected equation
			while (flag==0)
			{
				iflag = 0;
				connID = Math.floor(Math.random() * 10000)+1;
				for (var a=0; a<connectedItem.info.equations.length; a++)
				{
					if ( connectedItem.info.equations[a]['conn_id'] == connID ){ iflag=1; }
				}
				if (iflag==0){ flag=1; }

			}

			// Place the new equation in the array
			eqData = {
				'eq_id' : '',
				'eq_itemid' : '',
				'eq_name' : '',
				'eq_size' : '',
				'eq_order' : '',
				'el_id' : '',
				'showVal' : 0,
				'temp_eq' : '',
				'conn_id' : connID
			};
			connectedItem.info.equations.push(eqData);


			// Set the cad id depending upon the type
			if ( cadType == "onshape" )
			{
				var cad_id = connectedItem.info.cad_data.id;
			
			}else if ( cadType == "fusion" )
			{
				cad_id = connectedItem.info.cad_data.fileData.id;
			}


			// Call the function to enter a new and empty equation
			$http({
				method: "POST",
				url: '/files/addConnEq',
				params: { cad_id : cad_id, 
						  document_id : document_id, 
						  conneq_id : connID,
						  conn_id : connectedItem.id }
			}).then(function successCallback( returnData ) 
			{
				console.log( returnData );
				vm.checkConnected();

			}, function errorCallback( returnData ) { });


		}






		/*
		 *
		 *  Set a element for a connected equation
		 *
		 */
		function setConnEl( connectedItem, document_id )
		{   
			console.log('In the set connected element function');

			// Pull the name of the element
			for (var a=0; a<connectedItem.info.cad_data.elements.length; a++)
			{
				if ( connectedItem.info.cad_data.elements[a]['id'] == connectedItem.info.cad_data.element_id )
				{
					connectedItem.info.cad_data.element_name = connectedItem.info.cad_data.elements[a]['name'];
					connectedItem.info.cad_data.element_thumbnailImage = connectedItem.info.cad_data.elements[a]['thumbnailInfo']['sizes'][0]['href'];
				}
			}

			// Call the function to put the variable on the server side
			$http({
				method: "POST",
				url: '/files/setConnEl',
				params: { cad_id : connectedItem.info.cad_data.id, 
						  document_id : document_id, 
						  item_id : connectedItem.id,
						  el_id : connectedItem.info.cad_data.element_id,
						  el_name : connectedItem.info.cad_data.element_name,
						  el_thumbnail : connectedItem.info.cad_data.element_thumbnailImage }
			}).then(function successCallback( returnData ) 
			{
				console.log( returnData );

			}, function errorCallback( returnData ) { });


		}


		/*
		 *
		 *  Set a property for a connected equation - the equation
		 *
		 */
		function setConnEq( connectedItem, document_id, conn_id, type, thisID )
		{   
			var thisConn = '', addElName='', thisEq={}, eqData={};
			console.log('I am in the set connected equation function');

			console.log(connectedItem);

			// If the equation is being set
			if ( type == 'equation' )
			{
				// Pull the equation data and place it in the local copy
				for (var a=0; a<vm.worksheet.length; a++)
				{
					if ( vm.worksheet[a]['id'] == thisID )
					{
						thisEq = vm.worksheet[a];
					}
				}

				// Pull the existing conn eq and set parameters
				for (var a=0; a<connectedItem.info.equations.length; a++)
				{
					if ( connectedItem.info.equations[a]['conn_id'] == conn_id )
					{
						thisConn = connectedItem.info.equations[a]
						eqData = {
							'eq_id' : thisEq.id,
							'eq_itemid' : thisEq.itemid,
							'eq_name' : thisEq.name,
							'eq_size' : thisEq.content.Equation.Format_size,
							'eq_order' : thisEq.order,
							'el_id' : connectedItem.info.equations[a]['el_id'],
							'el_name' : connectedItem.info.equations[a]['el_name'],
							'conn_id' : thisConn['conn_id'],
							'showVal' : 1,
							'temp_eq' : thisID 
						};
						connectedItem.info.equations[a] = eqData;
					}
				}


				// Call the function to put the variable on the server side
				$http({
					method: "POST",
					url: '/files/setConnEq',
					params: { cad_id : connectedItem.info.cad_data.id, 
							  document_id : document_id, 
							  type : 'equation',
							  conn_id :  thisConn['conn_id'],
							  conneq_id :  thisConn['conn_id'],
							  item_id : connectedItem.id,
							  eq_id : thisID }
				}).then(function successCallback( returnData ) 
				{
					console.log( returnData );

				}, function errorCallback( returnData ) { });

			}


		}





		/*
		 *
		 *  Remove a connected equation to the connected document
		 *
		 */
		function removeConnEq( connectedItem, document_id, cad_id, conn_id )
		{

			console.log('I am in the remove connected equation function');
			console.log(connectedItem);

			// Pull the equation from the connected equation list
			for (var a=0; a<connectedItem.info.equations.length; a++)
			{
				if ( connectedItem.info.equations[a]['id'] == conn_id )
				{
					connectedItem.info.equations.splice( a, 1 );
				}
			}


			// Call the function to pull the variable on the server side
			$http({
				method: "POST",
				url: '/files/removeConnEq',
				params: { cad_id : connectedItem.info.cad_data.id, 
						  document_id : document_id, 
						  conneq_id : conn_id, 
						  item_id : connectedItem.id }
			}).then(function successCallback( returnData ) 
			{
				console.log( returnData );

				returnData.data.forEach(
					function(thisItem, index){

						thisItem.info = JSON.parse(thisItem.info);

					}
				);

				vm.connectedFiles = returnData.data;


			}, function errorCallback( returnData ) { });

		}





		/*
		 *
		 *  Update the element list for a document
		 *
		 */
		function updateElements( document_id, cad_id, connectedItem )
		{

			console.log('I am in the update elements function');
			console.log(connectedItem);

			// Call the function to pull the variable on the server side
			$http({
				method: "POST",
				url: '/files/updateElements',
				params: { cad_id : connectedItem.info.cad_data.id, 
						  document_id : document_id, 
						  item_id : connectedItem.id }
			}).then(function successCallback( returnData ) 
			{
				console.log( returnData );
				vm.checkConnected();

			}, function errorCallback( returnData ) { });

		}




		/*
		 *
		 * Set the cad specific items for this array entry
		 *
		 */
		function updateCadMaterial( thisItem )
		{
			console.log('I am in the updateCadMaterial function');
			console.log(thisItem);

			// Get the material and mass properties
			$http({
				method: "GET",
				url: '/files/getCadMaterial',
				params: { document_id : thisItem['document_data']['id'],
						  workspace_id : thisItem['document_data']['defaultWorkspace']['id'],
						  element_id : thisItem['element_data']['id'],
						  part_id : thisItem['part_data']['partId'] }
			}).then(function successCallback( returnData ) 
			{
				console.log('Returned material data');
				console.log( returnData );
				thisItem['material_data'] = returnData.data;


			}, function errorCallback( returnData ) { });

			// Get the material and mass properties
			$http({
				method: "GET",
				url: '/files/getCadMass',
				params: { document_id : thisItem['document_data']['id'],
						  workspace_id : thisItem['document_data']['defaultWorkspace']['id'],
						  element_id : thisItem['element_data']['id'],
						  part_id : thisItem['part_data']['partId'] }
			}).then(function successCallback( returnData ) 
			{
				console.log('Returned mass data');
				console.log( returnData );
				thisItem['mass_data'] = returnData.data;

			}, function errorCallback( returnData ) { });


		}




		/*
		 *
		 *  Set the image size array after element selection
		 *
		 */
		function setCadElement( )
		{
			console.log('In the set cad element function');
			for (var a=0; a<vm.cadElements.length; a++)
			{
				if ( vm.thisCAD.element_data.id == vm.cadElements[a]['id'] )
				{
					vm.thisCAD.element_data = vm.cadElements[a];
				}
			}
		}





		/*
		 *
		 *  Push the equations from this document to specific onShape document
		 *  When a file is saved, all variables are pushed to all connected onShape files
		 *
		 */
		function setThumbnail( thisItem, thisCAD )
		{
			console.log('In the set thumbnail function');
			var theseSizes=[];
			for (var a=0; a<thisCAD.element_data.thumbnailInfo.sizes.length; a++)
			{
				if (thisCAD.element_data.thumbnailInfo.sizes[a]['size'] == thisCAD.imageSize)
				{
					thisItem.content.src = thisCAD.element_data.thumbnailInfo.sizes[a]['href'];
					theseSizes=thisCAD.imageSize.split('x');
					thisItem.content.height = theseSizes[1]; 
					thisItem.content.width = theseSizes[0];
					thisItem.content.isCAD = true;
				}
			}
		}








		/*
		 *
		 *  Push the equations from this document to specific onShape document
		 *  When a file is saved, all variables are pushed to all connected onShape files
		 *
		 */
		function pushToOnshape( document_id, cad_id, conn_id )
		{
			$http({
				method: "POST",
				url: '/files/pushToOnshape',
				params: { cad_id : cad_id, document_id : document_id, conn_id : conn_id }
			}).then(function successCallback( returnData ) 
			{
				console.log( returnData );

			}, function errorCallback( returnData ) { });
		
		}





		/*
		 *
		 *  These functions are related to attaching autocad equations
		 *
		 */



		/*
		 *
		 * Get the hubs for the autocad user
		 *
		 */
		function getAutocadHubs( )
		{

			console.log('I am in the getAutocadHubs function');

			$http({
				method: "GET",
				url: window.location.origin+'/files/getAutocadHubs',
				params: { }
			}).then(function successCallback( returnData )
			{
				console.log(returnData);
				vm.autocadHubs = returnData.data.data;
				console.log('The hubs are ...');
				console.log(vm.autocadhubs);

			}, function errorCallback( returnData ) 
			{ 

			});

		}





		/*
		 *
		 * Get the projects for the autocad user
		 *
		 */
		function getAutocadProjects( hubID )
		{

			console.log('I am in the getAutocadProjects function with '+hubID);

			// Place the hub data in the appropriate space
			vm.autocadHubs.forEach(
				function(thisHub, index){

					if ( thisHub.id == hubID )
					{
						var tempData = thisHub;
						vm.newCADConnect.hubData = tempData;
					}

				}
			);

			$http({
				method: "GET",
				url: window.location.origin+'/files/getAutocadProjects/'+hubID,
				params: { }
			}).then(function successCallback( returnData )
			{
				console.log(returnData);
				vm.autocadProjects = returnData.data.data;
				console.log('The projects are ...');
				console.log(vm.autocadProjects);

			}, function errorCallback( returnData ) 
			{ 

			});

		}



		/*
		 *
		 * Get the folders for the autocad user for a project
		 *
		 */
		function getAutocadFolders( hubID, projectID )
		{

			console.log('I am in the getAutocadFolders function with '+hubID+' - '+projectID);


			// Place the project data in the appropriate space
			vm.autocadProjects.forEach(
				function(thisProject, index){

					if ( thisProject.id == projectID )
					{
						var tempData = thisProject;
						vm.newCADConnect.projectData = tempData;
					}

				}
			);


			$http({
				method: "GET",
				url: window.location.origin+'/files/getAutocadFolders/'+hubID+'/'+projectID,
				params: { }
			}).then(function successCallback( returnData )
			{
				console.log(returnData);
				vm.autocadFolders = returnData.data.data;
				console.log('The folders are ...');
				console.log(vm.autocadFolders);

			}, function errorCallback( returnData ) 
			{ 

			});

		}







		/*
		 *
		 * Get the contents for a folder
		 *
		 */
		function getAutocadFolderContents( projectID, folderID )
		{

			console.log('I am in the getAutocadFolderContents function with '+projectID+' - '+folderID);


			// Place the project data in the appropriate space
			vm.autocadFolders.forEach(
				function(thisFolder, index){

					if ( thisFolder.id == folderID )
					{
						var tempData = thisFolder;
						vm.newCADConnect.rootData = tempData;
					}

				}
			);


			$http({
				method: "GET",
				url: window.location.origin+'/files/getAutocadFolderContents/'+projectID+'/'+folderID,
				params: { }
			}).then(function successCallback( returnData )
			{
				console.log(returnData);
				vm.autocadContents = returnData.data.data;
				if ( returnData.data.included !== undefined )
				{
					vm.autocadIncluded = returnData.data.included
				}
				console.log('The contents are ...');
				console.log(vm.autocadContents);

			}, function errorCallback( returnData ) 
			{ 

			});

		}











		/*
		 *
		 * Get the contents for a folder
		 *
		 */
		function getAutocadItem( projectID, itemID )
		{

			console.log('I am in the getAutocadItem function with '+projectID+' - '+itemID);

			$http({
				method: "GET",
				url: window.location.origin+'/files/getAutocadItem/'+projectID+'/'+itemID,
				params: { }
			}).then(function successCallback( returnData )
			{
				console.log(returnData);
				vm.autocadItem = returnData.data.data;
				console.log('The item is ...');
				console.log(vm.autocadItem);

			}, function errorCallback( returnData ) 
			{ 

			});

		}









		/*
		 *
		 * Sets a folder or file. If folder, it is placed into array and contents are called
		 *
		 */
		function setAutocadItem( autocadItem, thisIndex, projectID )
		{

			console.log('I am in the setAutocadItem function with '+thisIndex);
			console.log(autocadItem);

			if ( thisIndex == 'add' )
			{
				thisIndex = vm.newCADConnect.folders.length;
			}

			if ( autocadItem.type == "folders" )
			{

				// If this index will add a level to the folders, just add it
				if ( thisIndex >= vm.newCADConnect.folders.length )
				{

					// Add to the array holding the folder data
					vm.newCADConnect.folderData[vm.newCADConnect.folderData.length] = { "name" : autocadItem.attributes.name,
																					 "displayName" : autocadItem.attributes.displayName,
																					 "id" : autocadItem.id }

					// Add to the id array
					vm.newCADConnect.folders[vm.newCADConnect.folderData.length] = autocadItem.id;


				// If this index is inside the array, cut off the array where appropriate
				}else if ( thisIndex < vm.newCADConnect.folders.length )
				{

					// Add to the array holding the folder data
					vm.newCADConnect.folderData[thisIndex] = { "name" : autocadItem.attributes.name,
															   "displayName" : autocadItem.attributes.displayName,
															   "id" : autocadItem.id }

					// Add to the id array
					vm.newCADConnect.folders[thisIndex] = autocadItem.id;


					// Delete the rest of the array as it is insolent
					for ( var a=thisIndex+1; a<vm.newCADConnect.folders.length; a++ )
					{
						vm.newCADConnect.folderData.splice(a, 1)
						vm.newCADConnect.folders.splice(a, 1)
					}

				}

				vm.autocadFileSelected = false;
				vm.showFusionProps = false;


				$http({
					method: "GET",
					url: window.location.origin+'/files/getAutocadFolderContents/'+projectID+'/'+autocadItem.id,
					params: { }
				}).then(function successCallback( returnData )
				{
					console.log(returnData);
					vm.autocadContents = returnData.data.data;
					console.log('The contents are ...');
					console.log(vm.autocadContents);

				}, function errorCallback( returnData ) 
				{ 

				});

			}


			// If this is a file and not a folder, record it in that space and turn off the option to select a folder
			if ( autocadItem.type == "items" )
			{

				vm.autocadFileSelected = true;
				vm.showFusionProps = false;
				vm.newCADConnect.file = autocadItem.id;
				vm.newCADConnect.id = autocadItem.id;
				vm.newCADConnect.fileData = autocadItem;
				vm.newCADConnect.fileID = autocadItem.relationships.tip.data.id;
				vm.newCADConnect.cleanID = autocadItem.relationships.tip.data.id.replace("urn:adsk.wipprod:fs.file:vf.","").match(/[^?]*/)[0];
				vm.newCADConnect.picName = vm.newCADConnect.cleanID+".png";

			}

			console.log('The new cad connect item is ...');
			console.log(vm.newCADConnect);

		}




		/*
		 *
		 * Sets a folder or file. If folder, it is placed into array and contents are called
		 *
		 */
		function setAutocadPullItem( autocadItem, thisIndex, projectID )
		{

			console.log('I am in the setAutocadPullItem function with '+thisIndex);
			console.log(autocadItem);

			if ( thisIndex == 'add' )
			{
				thisIndex = vm.newCADConnect.folders.length;
			}

			if ( autocadItem.type == "folders" )
			{

				// If this index will add a level to the folders, just add it
				if ( thisIndex >= vm.newCADConnect.folders.length )
				{

					// Add to the array holding the folder data
					vm.newCADConnect.folderData[vm.newCADConnect.folderData.length] = { "name" : autocadItem.attributes.name,
																					 "displayName" : autocadItem.attributes.displayName,
																					 "id" : autocadItem.id }

					// Add to the id array
					vm.newCADConnect.folders[vm.newCADConnect.folderData.length] = autocadItem.id;


				// If this index is inside the array, cut off the array where appropriate
				}else if ( thisIndex < vm.newCADConnect.folders.length )
				{

					// Add to the array holding the folder data
					vm.newCADConnect.folderData[thisIndex] = { "name" : autocadItem.attributes.name,
															   "displayName" : autocadItem.attributes.displayName,
															   "id" : autocadItem.id }

					// Add to the id array
					vm.newCADConnect.folders[thisIndex] = autocadItem.id;


					// Delete the rest of the array as it is insolent
					for ( var a=thisIndex+1; a<vm.newCADConnect.folders.length; a++ )
					{
						vm.newCADConnect.folderData.splice(a, 1)
						vm.newCADConnect.folders.splice(a, 1)
					}

				}

				vm.autocadFileSelected = false;
				vm.showFusionProps = false;


				$http({
					method: "GET",
					url: window.location.origin+'/files/getAutocadFolderContents/'+projectID+'/'+autocadItem.id,
					params: { }
				}).then(function successCallback( returnData )
				{
					console.log(returnData);
					vm.autocadContents = returnData.data.data;
					console.log('The contents are ...');
					console.log(vm.autocadContents);

				}, function errorCallback( returnData ) 
				{ 

				});

			}


			// If this is a file and not a folder, record it in then pull the data
			if ( autocadItem.type == "items" )
			{

				vm.autocadFileSelected = true;
				vm.showFusionProps = false;
				vm.newCADConnect.file = autocadItem.id;
				vm.newCADConnect.id = autocadItem.id;
				vm.newCADConnect.fileData = autocadItem;
				vm.newCADConnect.fileID = autocadItem.relationships.tip.data.id;
				vm.newCADConnect.cleanID = autocadItem.relationships.tip.data.id.replace("urn:adsk.wipprod:fs.file:vf.","").match(/[^?]*/)[0];
				vm.newCADConnect.picName = vm.newCADConnect.cleanID+".png";
				vm.getFusionProperties(vm.newCADConnect.cleanID, projectID);

			}

			console.log('The new cad connect item is ...');
			console.log(vm.newCADConnect);

		}






		/*
		 *
		 *  These functions are related to pulling and solving dependent files to update them
		 *
		 */



		/*
		 *
		 *  Pull the files that are dependent on this one and the files that this one depends upon
		 *
		 */
		function getDepFiles( )
		{
			console.log('In the getDepFiles function for the document '+vm.file_id);
			$http({
				method: "GET",
				url: '/files/getDepFiles/'+vm.file_id
			}).then(function successCallback( returnData ) 
			{
				console.log( returnData );
				vm.depFiles = returnData.data.depFiles;
				vm.controlFiles = returnData.data.controlFiles;

			}, function errorCallback( returnData ) { });

		}





		/*
		 *
		 * Get the versions for the document
		 *
		 */
		function getVersions( )
		{   
			console.log('Getting the versions');
			$http({
				method: "GET",
				url: '/files/getVersions/'+vm.fileInfo.oid
			}).then(function successCallback( returnData ) 
			{
				console.log('The version data is ...');
				console.log( returnData.data );
				vm.versions = returnData.data;
			}, function errorCallback( returnData ) {
				vm.versions = [];
			});
		}







		/*
		 *
		 * Create and click links to send data to Fusion - different from main program
		 * linkID - the ID of the connection in the database
		 *
		 */
		function pushToFusion( linkID ) 
		{

			vm.connectedFiles.forEach(
				function(thisConn, index)
				{

					if ( ( thisConn.cad_type == 'fusion' ) && ( thisConn.id == linkID ) )
					{

						// First, remove any old links
						if ( document.getElementById("fusionLink"+linkID) !== null )
						{
							document.getElementById("fusionLink"+linkID).remove();
						}

						// Prep links for shortness
						var h = thisConn.info.cad_data.hubData.attributes.name;
						var p = thisConn.info.cad_data.projectData.attributes.name;
						var r = thisConn.info.cad_data.rootFolder;
						var fid = thisConn.info.cad_data.file;
						var folds = "";
						for (var a=0; a<thisConn.info.cad_data.folders.length; a++)
						{
							if ( a == 0 )
							{
								if ( thisConn.info.cad_data.folders[a] !== null )
								{
									folds = folds+""+thisConn.info.cad_data.folders[a];
								}

							}else
							{
								if ( thisConn.info.cad_data.folders[a] !== null )
								{
									folds = folds+","+thisConn.info.cad_data.folders[a];
								}
							}
						}

						// Set the names and values in separate arrays because it wouldn't work in object
						var eqNames = '';
						var eqValues = '';

						thisConn.info.equations.forEach(
							function(thisEq, index2){

								if ( index2 == 0 )
								{
									eqNames = thisEq.eq_name;
								}else
								{
									eqNames = eqNames+', '+thisEq.eq_name;
								}

								vm.cadwolf_worksheet.forEach(
									function(sheetEq, index3){

										if ( sheetEq.component_type_id == 3)
										{
											if ( sheetEq.name == thisEq.eq_name )
											{
												if ( index2 == 0 )
												{
													eqValues = sheetEq.content.Equation.Solution_real['0-0'];
												}else
												{
													eqValues = eqValues+', '+sheetEq.content.Equation.Solution_real['0-0'];
												}

											}
										}
									}
								);

							}
						);


						var link=document.createElement("a");
						link.id = 'fusionLink'+linkID; 
						link.href='fusion360://command=open&properties={"hub":"'+h+'","project":"'+p+'","root":"'+r+'","folders":"'+folds+'","file":"'+fid+'","eqNames":"'+eqNames+'","eqValues":"'+eqValues+'"}';

						
						document.getElementById("fusion"+linkID).appendChild(link);
						document.getElementById('fusionLink'+linkID).click();

					}
				}
			);


		}







		/**
		*
		* Add an Item to the FBD list
		*
		*/
		function addFBDItem( thisItem )
		{
			console.log('In the addFBDItem Function');
			var tempStruct = {  drawType:"line",
							x1:0,
							y1:0,
							x2:100,
							y2:100,
							x3:50,
							y3:50,
							x4:0,
							y4:0,
							x5:0,
							y5:0,
							x6:0,
							y6:0,
							fillColor:"#000000",
							lineWidth:1,
							filled:true,
							cleared:false,
							startAngle:0,
							endAngle:1,
							arcRadius:25,
							clockwise:true,
							transparency:1,
							dashed:false,
							lineCap:'butt',
							lineDash:'4, 2',
							dashOffset:0,
							colorStops:'0,#FF0000;0.5,#00FF00;1,#0000FF',
							fontSize:24,
							fontFamily:'serif',
							text:'Hello World',
							fontStyle:'normal',
							imageURL:"/Workspace/",
							imageScaled:false,
							imageSliced:false,
							repeat:false,
							repeatVert:5,
							repeatHor:5,
							repeatNum:0,
							src:0,			// ID for an image
							rotate:0,
							arrowHeadHeight:15,
							arrowHeadWidth:15,
							arrowType:'curved',

							x1_Formatted:0,
							y1_Formatted:0,
							x2_Formatted:100,
							y2_Formatted:100,
							x3_Formatted:50,
							y3_Formatted:50,
							x4_Formatted:0,
							y4_Formatted:0,
							x5_Formatted:0,
							y5_Formatted:0,
							x6_Formatted:0,
							y6_Formatted:0,
							colorStops_Formatted:'0,#FF0000;0.5,#00FF00;1,#0000FF',
							startAngle_Formatted:0,
							endAngle_Formatted:1,
							arcRadius_Formatted:25,
							arrowHeadHeight_Formatted:15,
							arrowHeadWidth_Formatted:15,
							text_Formatted:'Hello World'

						};
			thisItem.content.drawing.push( tempStruct );
		}

		/**
		*
		* Delete an Item from the FBD list
		*
		*/
		function deleteFBD( thisItem, index )
		{
			console.log('In the delete fbd function with index '+index);
			thisItem.content.drawing.splice(index, 1);
		}


		/**
		*
		* Move an Item in the FBD list
		*
		*/
		function moveFBD( direction, thisItem, index )
		{
			console.log('In the move fbd function with a direction of '+direction+' and an index '+index);

			// Copy the item in question one direction up and then delete it
			if ( ( ( direction == 0 ) || ( direction == "0" ) ) && ( index > 0 ) )
			{
				thisItem.content.drawing.splice(index-1, 0, thisItem.content.drawing[index] );
				thisItem.content.drawing.splice(index+1, 1 );
			}

			// Copy the item in question one direction down and then delete it
			if ( ( ( direction == 1 ) || ( direction == "1" ) ) && ( index < thisItem.content.drawing.length-1 ) )
			{
				thisItem.content.drawing.splice(index+2, 0, thisItem.content.drawing[index] );
				thisItem.content.drawing.splice(index, 1 );
			}

		}




		/**
		*
		* redraw the Free Body Diagram
		* Before each item is redrawn, the formatted text is created to replace variables with their values
		*
		*/
		function reDrawFBD( thisItem )
		{

			var myCanvas = document.getElementById( "fbdTest" );
			console.log(myCanvas);
			var ctx = myCanvas.getContext('2d');
			ctx.clearRect(0, 0, thisItem.content.width, thisItem.content.height);

			thisItem.content.drawing.forEach(
				function(thisDraw, index){

					thisDraw.x1_Formatted = thisDraw.x1+'';
					thisDraw.y1_Formatted = thisDraw.y1+'';
					thisDraw.x2_Formatted = thisDraw.x2+'';
					thisDraw.y2_Formatted = thisDraw.y2+'';
					thisDraw.x3_Formatted = thisDraw.x3+'';
					thisDraw.y3_Formatted = thisDraw.y3+'';
					thisDraw.x4_Formatted = thisDraw.x4+'';
					thisDraw.y4_Formatted = thisDraw.y4+'';
					thisDraw.x5_Formatted = thisDraw.x5+'';
					thisDraw.y5_Formatted = thisDraw.y5+'';
					thisDraw.x6_Formatted = thisDraw.x6+'';
					thisDraw.y6_Formatted = thisDraw.y6+'';
					thisDraw.colorStops_Formatted = thisDraw.colorStops;
					thisDraw.startAngle_Formatted = thisDraw.startAngle+'';
					thisDraw.endAngle_Formatted = thisDraw.endAngle+'';
					thisDraw.arcRadius_Formatted = thisDraw.arcRadius+'';
					thisDraw.arrowHeadHeight_Formatted = thisDraw.arrowHeadHeight+'';
					thisDraw.arrowHeadWidth_Formatted = thisDraw.arrowHeadWidth+'';
					thisDraw.text_Formatted = thisDraw.text;

					vm.cadwolf_worksheet.forEach(
						function(thisEq, index2){
							var re = new RegExp('#'+thisEq.name, 'g');
							if ( thisDraw.text_Formatted.match( re ) )
							{
								thisDraw.text_Formatted = thisDraw.text_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
							}
							if ( thisDraw.x1_Formatted.match( re ) )
							{
								thisDraw.x1_Formatted = thisDraw.x1_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
							}
							if ( thisDraw.y1_Formatted.match( re ) )
							{
								thisDraw.y1_Formatted = thisDraw.y1_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
							}
							if ( thisDraw.x2_Formatted.match( re ) )
							{
								thisDraw.x2_Formatted = thisDraw.x2_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
							}
							if ( thisDraw.y2_Formatted.match( re ) )
							{
								thisDraw.y2_Formatted = thisDraw.y2_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
							}
							if ( thisDraw.x3_Formatted.match( re ) )
							{
								thisDraw.x3_Formatted = thisDraw.x3_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
							}
							if ( thisDraw.y3_Formatted.match( re ) )
							{
								thisDraw.y3_Formatted = thisDraw.y3_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
							}
							if ( thisDraw.x4_Formatted.match( re ) )
							{
								thisDraw.x4_Formatted = thisDraw.x4_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
							}
							if ( thisDraw.y4_Formatted.match( re ) )
							{
								thisDraw.y4_Formatted = thisDraw.y4_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
							}
							if ( thisDraw.x5_Formatted.match( re ) )
							{
								thisDraw.x5_Formatted = thisDraw.x5_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
							}
							if ( thisDraw.y5_Formatted.match( re ) )
							{
								thisDraw.y5_Formatted = thisDraw.y5_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
							}
							if ( thisDraw.x6_Formatted.match( re ) )
							{
								thisDraw.x6_Formatted = thisDraw.x6_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
							}
							if ( thisDraw.y6_Formatted.match( re ) )
							{
								thisDraw.y6_Formatted = thisDraw.y6_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
							}
							if ( thisDraw.colorStops_Formatted.match( re ) )
							{
								thisDraw.colorStops_Formatted = thisDraw.colorStops_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
							}
							if ( thisDraw.startAngle_Formatted.match( re ) )
							{
								thisDraw.startAngle_Formatted = thisDraw.startAngle_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
							}
							if ( thisDraw.endAngle_Formatted.match( re ) )
							{
								thisDraw.endAngle_Formatted = thisDraw.endAngle_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
							}
							if ( thisDraw.arcRadius_Formatted.match( re ) )
							{
								thisDraw.arcRadius_Formatted = thisDraw.arcRadius_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
							}
							if ( thisDraw.arrowHeadHeight_Formatted.match( re ) )
							{
								thisDraw.arrowHeadHeight_Formatted = thisDraw.arrowHeadHeight_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
							}
							if ( thisDraw.arrowHeadWidth_Formatted.match( re ) )
							{
								thisDraw.arrowHeadWidth_Formatted = thisDraw.arrowHeadWidth_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
							}

						}
					);

					thisDraw.x1_Formatted = eval(thisDraw.x1_Formatted);
					thisDraw.y1_Formatted = eval(thisDraw.y1_Formatted);
					thisDraw.x2_Formatted = eval(thisDraw.x2_Formatted);
					thisDraw.y2_Formatted = eval(thisDraw.y2_Formatted);
					thisDraw.x3_Formatted = eval(thisDraw.x3_Formatted);
					thisDraw.y3_Formatted = eval(thisDraw.y3_Formatted);
					thisDraw.x4_Formatted = eval(thisDraw.x4_Formatted);
					thisDraw.y4_Formatted = eval(thisDraw.y4_Formatted);
					thisDraw.x5_Formatted = eval(thisDraw.x5_Formatted);
					thisDraw.y5_Formatted = eval(thisDraw.y5_Formatted);
					thisDraw.x6_Formatted = eval(thisDraw.x6_Formatted);
					thisDraw.y6_Formatted = eval(thisDraw.y6_Formatted);
					thisDraw.startAngle_Formatted = eval(thisDraw.startAngle_Formatted);
					thisDraw.endAngle_Formatted = eval(thisDraw.endAngle_Formatted);
					thisDraw.arcRadius_Formatted = eval(thisDraw.arcRadius_Formatted);
					thisDraw.arrowHeadHeight_Formatted = eval(thisDraw.arrowHeadHeight_Formatted);
					thisDraw.arrowHeadWidth_Formatted = eval(thisDraw.arrowHeadWidth_Formatted);


				}	
			);

			thisItem.content.drawing.forEach(
				function(thisDraw, index){

					// Set the global alpha for this drawing
					ctx.globalAlpha = thisDraw.transparency;

					// Draw the line(s)
					if ( thisDraw.drawType == 'line' )
					{
						ctx.lineWidth=thisDraw.lineWidth;
						ctx.lineCap=thisDraw.lineCap;
						if (thisDraw.dashed)
						{
							ctx.setLineDash(thisDraw.lineDash.split(','));
							ctx.lineDashOffset = thisDraw.dashOffset;
						}
						ctx.beginPath();
						ctx.moveTo(thisDraw.x1_Formatted, thisDraw.y1_Formatted);
						ctx.lineTo(thisDraw.x2_Formatted, thisDraw.y2_Formatted);
						ctx.strokeStyle=thisDraw.fillColor;
						ctx.stroke();

						ctx.setLineDash([0,0]);
						ctx.lineDashOffset = 0;

					}


					// Draw the rectangle(s)
					if ( thisDraw.drawType == 'rectangle' )
					{
						ctx.lineWidth=thisDraw.lineWidth;
						ctx.strokeStyle=thisDraw.fillColor;
						ctx.beginPath();
						if ( thisDraw.cleared )
						{
							ctx.clearRect(thisDraw.x1_Formatted, thisDraw.y1_Formatted, thisDraw.x2_Formatted, thisDraw.y2_Formatted);
						}else
						{
							if ( thisDraw.filled )
							{
								ctx.fillStyle=thisDraw.fillColor;
								ctx.fillRect(thisDraw.x1_Formatted, thisDraw.y1_Formatted, thisDraw.x2_Formatted, thisDraw.y2_Formatted);
							}else
							{
								ctx.strokeStyle=thisDraw.fillColor;
								ctx.strokeRect(thisDraw.x_Formatted, thisDraw.y1_Formatted, thisDraw.x2_Formatted, thisDraw.y2_Formatted);
							}
						}
					}

					if ( thisDraw.drawType == 'triangle' )
					{
						ctx.lineWidth=thisDraw.lineWidth;
						ctx.strokeStyle=thisDraw.fillColor;
						ctx.beginPath();
						ctx.moveTo(thisDraw.x1_Formatted, thisDraw.y1_Formatted);
						ctx.lineTo(thisDraw.x2_Formatted, thisDraw.y2_Formatted);
						ctx.lineTo(thisDraw.x3_Formatted, thisDraw.y3_Formatted);
						ctx.lineTo(thisDraw.x1_Formatted, thisDraw.y1_Formatted);
						if ( thisDraw.filled )
						{
							ctx.fillStyle=thisDraw.fillColor;
							ctx.fill();
						}else
						{
							ctx.strokeStyle=thisDraw.fillColor;
							ctx.stroke();
						}
					}


					if ( thisDraw.drawType == 'arc1' )
					{
						ctx.lineWidth=thisDraw.lineWidth;
						ctx.strokeStyle=thisDraw.fillColor;
						ctx.beginPath();
						ctx.arc(thisDraw.x1_Formatted, thisDraw.y1_Formatted, thisDraw.arcRadius_Formatted, thisDraw.startAngle_Formatted, thisDraw.endAngle_Formatted, thisDraw.clockwise);
						if ( thisDraw.filled )
						{
							ctx.fillStyle=thisDraw.fillColor;
							ctx.fill();
						}else
						{
							ctx.strokeStyle=thisDraw.fillColor;
							ctx.stroke();
						}
					}


					if ( thisDraw.drawType == 'arc2' )
					{
						ctx.lineWidth=thisDraw.lineWidth;
						ctx.strokeStyle=thisDraw.fillColor;
						ctx.beginPath(thisDraw.x1_Formatted, thisDraw.y1_Formatted);
						ctx.moveTo(thisDraw.x1_Formatted, thisDraw.y1_Formatted);
						ctx.arcTo(thisDraw.x2_Formatted, thisDraw.y2_Formatted, thisDraw.x3_Formatted, thisDraw.y3_Formatted, thisDraw.arcRadius_Formatted);
						if ( thisDraw.filled )
						{
							ctx.fillStyle=thisDraw.fillColor;
							ctx.fill();
						}else
						{
							ctx.strokeStyle=thisDraw.fillColor;
							ctx.stroke();
						}
					}


					if ( thisDraw.drawType == 'quadratic' )
					{
						ctx.lineWidth=thisDraw.lineWidth;
						ctx.strokeStyle=thisDraw.fillColor;
						ctx.beginPath();
						ctx.moveTo(thisDraw.x1_Formatted, thisDraw.y1_Formatted);
						ctx.quadraticCurveTo(thisDraw.x2_Formatted, thisDraw.y2_Formatted, thisDraw.x3_Formatted, thisDraw.y3_Formatted);
						if ( thisDraw.filled )
						{
							ctx.fillStyle=thisDraw.fillColor;
							ctx.fill();
						}else
						{
							ctx.strokeStyle=thisDraw.fillColor;
							ctx.stroke();
						}
					}


					if ( thisDraw.drawType == 'bezier' )
					{
						ctx.lineWidth=thisDraw.lineWidth;
						ctx.beginPath();
						ctx.moveTo(thisDraw.x1_Formatted, thisDraw.y1_Formatted);
						ctx.bezierCurveTo(thisDraw.x2_Formatted, thisDraw.y2_Formatted, thisDraw.x3_Formatted, thisDraw.y3_Formatted, thisDraw.x4_Formatted, thisDraw.y4_Formatted);
						if ( thisDraw.filled )
						{
							ctx.fillStyle=thisDraw.fillColor;
							ctx.fill();
						}else
						{
							ctx.strokeStyle=thisDraw.fillColor;
							ctx.stroke();
						}
					}

					if ( thisDraw.drawType == 'linearGrad' )
					{
						var linearGradient = ctx.createLinearGradient(thisDraw.x1_Formatted, thisDraw.y1_Formatted, thisDraw.x2_Formatted, thisDraw.y2_Formatted);
						var myColorStops = thisDraw.colorStops_Formatted.split(';');
						for (var a=0; a<myColorStops.length; a++)
						{
							linearGradient.addColorStop(myColorStops[a].split(/,(.+)/)[0], myColorStops[a].split(/,(.+)/)[1]);
						}
						if ( thisDraw.filled )
						{
							ctx.fillStyle=linearGradient;
							ctx.fillRect(thisDraw.x3_Formatted, thisDraw.y3_Formatted, thisDraw.x4_Formatted, thisDraw.y4_Formatted);
						}else
						{
							ctx.strokeStyle=linearGradient;
							ctx.strokeRect(thisDraw.x3_Formatted, thisDraw.y3_Formatted, thisDraw.x4_Formatted, thisDraw.y4_Formatted);
						}
					}


					if ( thisDraw.drawType == 'radialGrad' )
					{
						console.log('Here with '+thisDraw);
						var radialGradient = ctx.createRadialGradient(thisDraw.x1, thisDraw.y1, thisDraw.x3, thisDraw.x2, thisDraw.y2, thisDraw.y3);
						var myColorStops = thisDraw.colorStops_Formatted.split(';');
						for (var a=0; a<myColorStops.length; a++)
						{
							radialGradient.addColorStop(myColorStops[a].split(/,(.+)/)[0], myColorStops[a].split(/,(.+)/)[1]);
						}
						ctx.fillStyle=radialGradient;
						ctx.fillRect(0, 0, thisItem.content.width, thisItem.content.height);
					}


					if ( thisDraw.drawType == 'text' )
					{
						var newText = thisDraw.text;

						vm.cadwolf_worksheet.forEach(
							function(thisEq, index){
								var re = new RegExp('#'+thisEq.name, 'g');
								if ( thisDraw.text.match( re ) )
								{
									newText = thisDraw.text.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
								}
							}
						);

						ctx.font = thisDraw.fontStyle+' '+thisDraw.fontSize+'px '+thisDraw.fontFamily;
						if ( thisDraw.filled )
						{
							ctx.fillStyle=thisDraw.fillColor;
							ctx.fillText(thisDraw.text_Formatted, thisDraw.x1_Formatted, thisDraw.y1_Formatted);
						
						}else
						{
							ctx.strokeStyle=thisDraw.fillColor;
							ctx.strokeText(thisDraw.text_Formatted, thisDraw.x1_Formatted, thisDraw.y1_Formatted);							
						}

					}



					if ( thisDraw.drawType == 'image' )
					{
						var img = new Image();
						img.src = "https://cadwolf.s3.amazonaws.com/"+thisDraw.src;
						img.onload = function() {

							if ( thisDraw.imageScaled )
							{
								ctx.drawImage(img, thisDraw.x1_Formatted, thisDraw.y1_Formatted, thisDraw.x2_Formatted, thisDraw.y2_Formatted );
							
							}else if ( thisDraw.imageSliced )
							{
								ctx.drawImage(img, thisDraw.x3_Formatted, thisDraw.y3_Formatted, thisDraw.x4_Formatted, thisDraw.y4_Formatted, thisDraw.x1_Formatted, thisDraw.y1_Formatted, thisDraw.x2_Formatted, thisDraw.y2_Formatted )

							}else
							{
								ctx.drawImage(img, thisDraw.x1_Formatted, thisDraw.y1_Formatted);
							}

						}

					}



					if ( thisDraw.drawType == 'arrow' )
					{
						ctx.lineWidth=thisDraw.lineWidth;
						ctx.strokeStyle=thisDraw.fillColor;
						ctx.fillStyle=thisDraw.fillColor;

						// Angle of the arrow head
						var headAngle = Math.atan( thisDraw.arrowHeadWidth_Formatted / thisDraw.arrowHeadHeight_Formatted );

						// Calculate the angle of the arrow line
						var arrAngle = Math.atan( ( thisDraw.y2_Formatted - thisDraw.y1_Formatted ) / ( thisDraw.x2_Formatted - thisDraw.x1_Formatted ) );
						
						if ( thisDraw.x2_Formatted >= thisDraw.x1_Formatted )
						{
							var rootPosX = thisDraw.x2_Formatted - thisDraw.arrowHeadHeight_Formatted * Math.cos( arrAngle ); 
							var rootPosY = thisDraw.y2_Formatted - thisDraw.arrowHeadHeight_Formatted * Math.sin( arrAngle );
							var xPos1 = rootPosX - thisDraw.arrowHeadWidth_Formatted * Math.sin( arrAngle ); 
							var yPos1 = rootPosY + thisDraw.arrowHeadWidth_Formatted * Math.cos( arrAngle ); 
							var xPos2 = rootPosX + thisDraw.arrowHeadWidth_Formatted * Math.sin( arrAngle ); 
							var yPos2 = rootPosY - thisDraw.arrowHeadWidth_Formatted * Math.cos( arrAngle );
						}else
						{
							var rootPosX = thisDraw.x2_Formatted + thisDraw.arrowHeadHeight_Formatted * Math.cos( arrAngle ); 
							var rootPosY = thisDraw.y2_Formatted + thisDraw.arrowHeadHeight_Formatted * Math.sin( arrAngle );
							var xPos1 = rootPosX + thisDraw.arrowHeadWidth_Formatted * Math.sin( arrAngle ); 
							var yPos1 = rootPosY - thisDraw.arrowHeadWidth_Formatted * Math.cos( arrAngle ); 
							var xPos2 = rootPosX - thisDraw.arrowHeadWidth_Formatted * Math.sin( arrAngle ); 
							var yPos2 = rootPosY + thisDraw.arrowHeadWidth_Formatted * Math.cos( arrAngle );
						} 
						

						ctx.lineWidth=thisDraw.lineWidth;
						if (thisDraw.dashed)
						{
							ctx.setLineDash(thisDraw.lineDash.split(','));
							ctx.lineDashOffset = thisDraw.dashOffset;
						}
						
						if ( thisDraw.arrowType == 'curved' )
						{
							ctx.beginPath();
							ctx.moveTo(thisDraw.x1_Formatted, thisDraw.y1_Formatted);
							ctx.lineTo(rootPosX, rootPosY);
							ctx.stroke();
							ctx.moveTo(xPos1, yPos1);
							ctx.quadraticCurveTo(thisDraw.x2_Formatted, thisDraw.y2_Formatted, xPos2, yPos2);
							ctx.lineTo(thisDraw.x2_Formatted, thisDraw.y2_Formatted);
							//ctx.lineTo(xPos2, yPos2);
							if ( thisDraw.filled )
							{
								ctx.fill();
							}else
							{
								ctx.lineTo(xPos1, yPos1);
								ctx.stroke();								
							}
						}

						if ( thisDraw.arrowType == 'straight' )
						{
							ctx.beginPath();
							ctx.moveTo(thisDraw.x1_Formatted, thisDraw.y1_Formatted);
							ctx.lineTo(rootPosX, rootPosY);
							ctx.stroke();								
							ctx.lineTo(xPos1, yPos1);
							ctx.lineTo(thisDraw.x2_Formatted, thisDraw.y2_Formatted);
							ctx.lineTo(xPos2, yPos2);
							ctx.lineTo(rootPosX, rootPosY);
							if ( thisDraw.filled )
							{
								ctx.fill();
							}else
							{
								ctx.stroke();								
							}
						}

					}

				}
			);
		}






		/*
		 *
		 *
		 * FORUM STUFF
		 *
		 *
		 *
		 */




		/**
		 *
		 * Create a new forum
		 *
		 */
		function addForum( )
		{
			console.log('In the add forum code');

			console.log('Spark is ...');
			console.log(Spark);


			$http({
				method: "PUT",
				url: window.location.origin+'/newforum',
				data: { forumTitle : "New Forum", 
						forumText : "<p>Forum Text</p>",
						parent : window.location.href }

			}).then(function successCallback( returnData ) 
			{

				vm.forums = [];
				returnData.data.forEach(function(thisForum, index)
				{  
		
					if ( thisForum.file_type_id == "Forum" )
					{   
						vm.forums.push(thisForum);
					}

				});
				vm.assignDates();

			});


		}





		/**
		 *
		 * Edit a forum title or text
		 *
		 */
		function updateForum( )
		{
			console.log('In the update forum code');


			// If forum, get the discussion data
			$http({
				method: "POST",
				url: window.location.origin+'/editforum/'+vm.currentForum.id,
				data: { forumTitle : vm.currentForum.name, 
						forumText : vm.currentForum.item_data.text }
			}).then(function successCallback( returnData ) 
			{

			});


		}



		/*
		 *
		 * Reset the status of every comment
		 *
		 */
		function resetStatus(id) 
		{
			console.log('In the reset status function'); 

			vm.newComment=false;
			vm.editForum=false;

			vm.comments.forEach(function(thisComment, index)
			{  
				thisComment.item_data.editStatus = 0;
				if ( thisComment.id == id )
				{
					thisComment.item_data.editStatus = 1;
				}
			})

			if ( ( id == "0" ) || ( id == 0 ) )
			{
				vm.newComment=true; 
			}


			if ( ( id == "forum" ) )
			{
				vm.editForum=true; 
			}

		}





		/**
		 *
		 * Assign Date objects to forums and comments
		 *
		 */
		function assignDates( )
		{

			console.log('In the assign dates function'); 

			vm.comments.forEach(function(thisItem, index)
			{  
				var thisDate = thisItem['created_at'].split(' ');
				thisItem['created_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
			});



			vm.forums.forEach(function(thisItem, index)
			{  
				var thisDate = thisItem['created_at'].split(' ');
				thisItem['created_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
			});

		}







		/**
		 *
		 * Create a comment
		 *
		 */
		function createComment( parentID, editStatus )
		{
			console.log('In the create comment code');

			if ( editStatus == 0 )
			{
				var thisText = vm.newCommentText;
			}else
			{
				var thisText = '';				
			}

			// Create the item in the database
			$http({
				method: "POST",
				url: window.location.origin+'/discussions',
				data:{ owner_id : vm.currentForum.id,
					   parent_id : parentID,
					   item_data :  { text: thisText,
					   				  editStatus : editStatus,
					   				  type : "comment" }
				}

			}).then(function successCallback( returnData ) 
			{

				vm.comments.push( returnData.data );

				if ( editStatus == 0 )
				{
					vm.newCommentText='';
				}

			});


		}









		/**
		 *
		 * Edit a comment
		 *
		 */
		function updateComment( id )
		{

			console.log('In the update comment code with an id of '+id);

			vm.comments.forEach(function(thisComment, index)
			{  

				if ( thisComment.id == id )
				{

					$http({
						method: "PUT",
						url: window.location.origin+'/discussions/'+id,
						data: { item_data : thisComment.item_data }
					}).then(function successCallback( returnData ) 
					{

						thisComment.item_data.editStatus = 0;

					});

				}

			});


		}








		/**
		 *
		 * Delete a comment
		 *
		 */
		function deleteComment( id )
		{

			console.log('In the delete comment code with an id of '+id);

			vm.comments.forEach(function(thisComment, index)
			{  

				if ( thisComment.id == id )
				{

					$http({
						method: "DELETE",
						url: window.location.origin+'/discussions/'+id
					}).then(function successCallback( returnData ) 
					{

						vm.comments.forEach(function(thisComment, index)
						{  
							if (thisComment.id == id )
							{
								vm.comments.splice(index, 1);
							}
						});

					});

				}

			});


		}





		/**
		 *
		 *	Check the format of the title
		 *
		 */
		function checkTitle( )
		{

			// Title is default as OK
			vm.titleProblem=false;

			var test = vm.forumTitle.match(/\?|\_|\*|\&|\^|\%|\$|\#|\@|\!|\,|\(|\)|\'|\"|\;|\;|\<|\>|\{|\[|\]|\}/);

			if ( test != null )
			{
				vm.titleProblem = true;
			}
		
		}





		/*
		 *
		 *
		 * END FORUM STUFF
		 *
		 *
		 *
		 */








		/*
 *
 *  This is the function called when a user clicks to update a file to be updated. It
 *  pulls all of the items for the document and then runs through them and solves the
 *  needed items.
 *  
 *  @param - fileID - the id of the file being updated
 *  @param - thisType - a string telling this code where it is being run - 'workspace', 'parttree', or 'documentUpdate'
 *
 */
function updateFile( fileID, thisType )
{
    console.log('In the updateFile function for the document '+fileID);
    var otherWorksheet = {};

    // Pull the worksheet items from the server
    $http({
        method: "GET",
        url: '/files/getSolveItems/'+fileID,
    }).then(function successCallback( returnData ) 
    {
        var otherWorksheet = returnData.data.components;
        var fileInfo = returnData.data.fileInfo;
        vm.lockFiles( 1 );
        console.log('The new worksheet is ...');
        console.log( otherWorksheet );
        vm.runEquationDigest( otherWorksheet, fileInfo, 1, thisType );


    }, function errorCallback( returnData ) { 
            vm.showMessage( '', { messageType : 'failure', 
                                  messageTitle : 'Error Getting Solve Items', 
                                  messageText : 'There was an error getting the equations to update the file. Make sure your logins have not expired.'});
    });

}




/*
*
*   EQUATION DIGEST FOR UPDATING OTHER FILES
*   @param - worksheet - an array of the items to be solved
*   @param - fileinfo - the object holding the file data - generally the cadwolf_fileInfo variable
*   @param - savefile - if at the end of the updates, the components of the file should be saved and the status updated (1 or 0)
*
*/

function runEquationDigest ( worksheet, fileInfo, savefile, thisType )
{   
    vm.worksheet = JSON.parse(JSON.stringify(worksheet));
    if ( vm.worksheet === undefined ){ vm.worksheet = vm.cadwolf_worksheet; }

    console.log('In the equation digest loop with a status of '+vm.digestStatus+' and a type of '+thisType);
    console.log('The worksheet is ...');
    console.log(vm.worksheet);

    for (var a=0; a<vm.worksheet.length; a++)
    {   
        if (typeof(vm.worksheet[a]['content'])=="string")
        {
            vm.worksheet[a]['content'] = JSON.parse(vm.worksheet[a]['content']);
        }
    }


    if (vm.digestStatus==1)
    {   
        vm.worksheet=vm.worksheet.sort(utilityFactory.dynamicSort("order"));
        
        for (var a=0; a<vm.worksheet.length; a++)
        {   
            if (((vm.worksheet[a]['component_type_id']==3) &&
                (vm.worksheet[a]['content']['needsUpdateFlag']==1)) ||
                ((vm.worksheet[a]['component_type_id']==3) &&
                (vm.worksheet[a]['update'])))
            {   
                console.log('Calling the solver for '+vm.worksheet[a]['itemid']);
                vm.digestStatus=0;
                vm.worksheet[a]['content']['needsUpdateFlag']=0;
                vm.worksheet[a]['content']['Equation']['inEdit']=1;
                vm.worksheet[a]['update']=false;
                if ((!vm.editPerm) && (vm.worksheet[a]['content']['Equation']['Format_editinuse']==1))
                {
                    vm.worksheet[a]['content']['Equation']['newEquation'] = vm.worksheet[a]['content']['Equation']['Format_left']+'='+vm.worksheet[a]['content']['Equation']['Format_right']
                }
                if ( ( vm.worksheet[a]['content']['Equation']['inputType'] == 'File' ) || ( vm.worksheet[a]['content']['Equation']['inputType'] == 'Dataset' ))
                {
                    vm.worksheet = docItemFactory.populateDeps( vm.worksheet[a]['itemid'], vm.worksheet);
                    vm.worksheet = docItemFactory.findDependents(vm.worksheet[a]['itemid'], 0, vm.worksheet);
                    vm.digestStatus=1;
                    runEquationDigest ( vm.worksheet, fileInfo, savefile, thisType );
                    savefile=0;
                }else
                {
                    vm.solveEquation( vm.worksheet[a]['itemid'], 'SolveEquation', '', fileInfo );   
                    savefile=0;
                }
                break
            }


            if (vm.worksheet[a]['component_type_id']==5)
            {   var flag=0;
                for (var b=0; b< vm.worksheet[a]['content']['data'].length; b++)
                {   for (var c=0; c< vm.worksheet[a]['content']['data'][0].length; c++)
                    {   console.log('Checking index '+b+'-'+c);
                        if (vm.worksheet[a]['content']['data'][b][c]['needsUpdateFlag']==1)
                        {   vm.worksheet[a]['solveRow']=b
                            vm.worksheet[a]['solveCol']=c
                            if (vm.worksheet[a]['content']['data'][b][c]['equation'].match(/^=/)==null)
                            {   console.log('Setting index '+b+'-'+c+' to '+vm.worksheet[a]['content']['data'][b][c]['equation']);
                                vm.worksheet[a]['content']['data'][b][c]['real']=vm.worksheet[a]['content']['data'][b][c]['equation'];
                                vm.digestStatus=1;
                            }else
                            {   if (utilityFactory.isNumber(vm.worksheet[a]['content']['data'][b][c]['equation'].replace(/^=/,'')))
                                {   vm.worksheet[a]['content']['data'][b][c]['real']=parseFloat(vm.worksheet[a]['content']['data'][b][c]['equation'].replace(/^=/,''));
                                    vm.worksheet[a]['content']['data'][b][c]['needsUpdateFlag']=0;
                                    console.log('I am updating the dependents on '+String.fromCharCode(65+c)+' - '+b);
                                    docItemFactory.findDependents(vm.worksheet[a]['itemid']+'.'+String.fromCharCode(65+c)+'.'+b, 0, vm.worksheet);
                                    flag=1;
                                    break
                                }else
                                {   console.log('Solving for index '+b+'-'+c+' with an equation of '+vm.worksheet[a]['content']['data'][b][c]['equation']);
                                    vm.digestStatus=0;
                                    vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveTableCell', '', fileInfo); 
                                    flag=1;
                                    break
                                }
                            }
                        }
                    } 
                    if (flag==1) { break }
                }
                if (flag==1) { break }
            }

            // Check and update the loop parameters
            if ((vm.worksheet[a]['component_type_id']==6) &&
                (vm.worksheet[a]['content']['needsBlockUpdate']==1) &&
                (vm.digestStatus==1))
            {   vm.digestStatus=0;
                vm.worksheet[a]['content']['forLoop']['firstRun']=1;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveLoopParameters', '', fileInfo);   
                break
            }

            // Check and update the loop parameters
            if ((vm.worksheet[a]['component_type_id']==7) &&
                (vm.worksheet[a]['content']['needsBlockUpdate']==1) &&
                (vm.digestStatus==1))
            {   vm.digestStatus=0;
                vm.worksheet[a]['content']['whileLoop']['firstRun']=1;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveWhileLoopParameters', '', fileInfo);  
                break
            }

            // Check and update the if/else parameters
            if ((vm.worksheet[a]['component_type_id']==8) &&
                (vm.worksheet[a]['content']['needsBlockUpdate']==1) &&
                (vm.digestStatus==1))
            {   vm.digestStatus=0;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveIfElseParameters', '', fileInfo);
                break
            }

            // Check and update the loop structure
            if ((vm.worksheet[a]['component_type_id']==6) && 
                (vm.worksheet[a]['content']['forLoop']['needsUpdateFlag']==1) &&
                (vm.digestStatus==1))
            {
                vm.digestStatus=0;
                vm.worksheet[a]['content']['forLoop']['firstRun']=1;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveStructure', '', fileInfo);   
                break
            }

            // Check and update the loop structure
            if ((vm.worksheet[a]['component_type_id']==7) && 
                (vm.worksheet[a]['content']['whileLoop']['needsUpdateFlag']==1) &&
                (vm.digestStatus==1))
            {
                vm.digestStatus=0;
                vm.worksheet[a]['content']['whileLoop']['firstRun']=1;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveStructure', '', fileInfo);   
                break
            }

            // Check and update the lif/else structure
            if ((vm.worksheet[a]['component_type_id']==8) && 
                (vm.worksheet[a]['content']['ifelse']['needsUpdateFlag']==1) &&
                (vm.digestStatus==1))
            {
                vm.digestStatus=0;
                vm.solveEquation(vm.worksheet[a]['itemid'], 'SolveStructure', '', fileInfo);   
                break
            }

            if ((vm.worksheet[a]['component_type_id']==9)&&(vm.digestStatus==1))
            {   var flag=0;
                for (var thisDataset in vm.worksheet[a]['content']['Plot']['Chart_dataobj'])
                {   
                    console.log('For dataset '+thisDataset+', the update flag is '+vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['needsUpdateFlag']);
                    if (vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['needsUpdateFlag']==1)
                    {   
                        console.log('I am updating dataset '+thisDataset+'-'+vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['Format_id']+' on plot '+vm.worksheet[a]['itemid']);
                        vm.digestStatus=0;
                        vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['needsUpdateFlag']=0; 
                        vm.solveEquation(vm.worksheet[a]['itemid'], 'solvePlotData', vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['Format_id'], fileInfo);
                        flag=1;
                        break
                    }
                } 
                if ((flag==0)&&(vm.worksheet[a]['content']['Plot']['needsUpdateFlag']==1))
                {
                    vm.worksheet[a]['content']['Plot']['needsUpdateFlag']=0;
                    chartFactory.makeChart(vm.worksheet[a], '', vm.worksheet); 
                    
                }
            }
            if (vm.worksheet[a]['component_type_id']==13)
            {   for (var dataIndex in vm.worksheet[a]['content']['Surface']['Chart_dataobj'])
                {   if (vm.worksheet[a]['content']['Surface']['Chart_dataobj'][dataIndex]['needsUpdateFlag']==1)
                    {   vm.digestStatus=0;
                        vm.worksheet[a]['content']['Surface']['Chart_dataobj'][dataIndex]['needsUpdateFlag']=0; 
                        var thisID = vm.worksheet[a]['itemid'];
                        var dataID = vm.worksheet[a]['content']['Surface']['Chart_dataobj'][dataIndex]['Format_id'];
                        vm.solveEquation( thisID, 'SolveSurfaceData', dataID, fileInfo );
                        break
                    }
                }  
            }

        }

        for (var a=0; a<vm.worksheet.length; a++)
        {   
            if (vm.worksheet[a]['component_type_id']==15)
            {   
                for (var b=0; b<vm.worksheet.length; b++)
                {   
                    if ( vm.worksheet[a]['content']['variableID'] == vm.worksheet[b]['itemid'] )
                    {
                        vm.worksheet[a]['content']['value'] = vm.worksheet[b]['content']['Equation']['Solution_real'][vm.worksheet[a]['content']['index']];
                        vm.worksheet[a]['content']['units'] = vm.worksheet[b]['content']['Equation']['Units_units'];
                        vm.worksheet[a]['content']['variable'] = vm.worksheet[b]['content']['Equation']['Format_name'];
                    }
                }
            }
        }
        console.log('The digest loop is clean');
        if ( savefile == 1 )
        {
            console.log('The file is being saved and updated');
            vm.saveFile( 1, fileInfo, thisType );
            $http({
                method: "POST",
                url: window.location.origin+'/files/fileCurrent/'+fileInfo['id'],
            });
            if ( vm.depFiles !== undefined )
            {
                for (var b=0; b<vm.depFiles.length; b++)
                {
                    if ( vm.depFiles[a]['id'] == fileInfo['id'] )
                    {
                        vm.depFiles[a]['update'] = false;
                    }
                }
            }
        }

    }
};







/*
*
*   LOCK THE FILES IN THE PART TREE OR THE WORKSPACE WHEN ONE IS BEING UPDATED
*
*/
function lockFiles ( setting )   
{
    console.log('In the lockFiles function with a setting of '+setting);   
    vm.inSolve=parseInt(setting);
}




/*
*
*   SOLVE EQUATION FUNCTION
*
*/
function solveEquation (eqID, eqType, dataID, fileInfo, thisType)   
{   
    console.log('In solve equation with an id of '+eqID+', a type of '+eqType+' and a dataID of '+dataID);
    vm.solveFileInfo = fileInfo;
    var thisItem = docItemFactory.getByID(eqID, vm.worksheet);
    if ( fileInfo.item_data.importedCAD === undefined ) { fileInfo.item_data.importedCAD=[]; }
    console.log('Found');
    console.log(thisItem);
    thisItem.eqObj=docItemFactory.createEqObj(eqID, vm.worksheet);
    var solveObj = docItemFactory.createSolveObj( thisItem, eqType, dataID );
    solveObj['scaleUnits'] = vm.cadwolfScaleUnits;
    solveObj['parseUnits'] = vm.cadwolfParseUnits;
    solveObj['Constants']  = vm.cadwolfConstants;
    solveObj['cadParts']  = fileInfo.item_data.importedCAD;
    solveObj['importedFunctions'] = fileInfo.item_data.impFunctions;
    console.log('I am sending ...');
    console.log(solveObj);
    //equationWorker.postMessage( solveObj ); 


    // This section checks to see if there is a python server running locally
    $http({
        method: "POST",
        url: 'http://127.0.0.1:8081',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: { testMessage : "Test Message" }
    }).then(function successCallback( returnData ) {
        vm.cadwolf_usePython=true;
        vm.cadwolf_pythonVersion=returnData.data
        $http({
            method: "POST",
            url: 'http://127.0.0.1:8081',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data: { params  : solveObj }
        }).then(function successCallback( returnData ) {
                vm.pythonReturn=returnData
                vm.handleSolverReturn(returnData, thisType)
        }, 
            function errorCallback( returnData ) {
                equationWorker.postMessage( solveObj );    
        });
    }, function errorCallback( returnData ) {
        vm.cadwolf_usePython=false;
        equationWorker.postMessage( solveObj ); 
    });

    
    equationWorker.onerror = function(e) 
    {
        vm.digestStatus=1;
        console.log('Hey, I got an error, but thats cool. Ill just sit over here and eat a sugar packet.'); 
        vm.showMessage( '', { messageType : 'failure', 
                              messageTitle : 'Unknown Error', 
                              messageText : 'There was an error in the solver routine that caused it to fail. Please look at the format of your equations.'});

    };

    equationWorker.onmessage = function(e) { 
        console.log('The message was returned with a type of '+e.data.messageType);
        console.log(e.data);
        MY_SCOPE.eqreturndata=e;
        vm.handleSolverReturn(e, thisType)
    }
}


/*
*
*   HANDLE THE RETURN FROM WEB WORKER OR PYTHON
*
*/
function handleSolverReturn (e, thisType)
{   
    console.log('The message was returned with a type of '+e.data.messageType);
    console.log(e.data);
    MY_SCOPE.eqreturndata=e;

    vm.worksheet=docItemFactory.eqReturn(e.data, vm.worksheet);    
    
    if (e.data.messageType=="EquationResult")
    {
        vm.addressConnectedEqs(e.data, vm.worksheet);
        vm.worksheet = docItemFactory.populateDeps(e.data.id, vm.worksheet);
        vm.worksheet = docItemFactory.findDependents(e.data.id, 0, vm.worksheet);
        vm.worksheet.forEach(
            function(thisObj, index){
                if (thisObj['itemid']==e.data.id)
                {   
                    thisObj.content.Equation['Format_showsolution'] = docItemFactory.createShowSolution( thisObj, vm.cadwolfScaleUnits );
                    vm.updateComponent( thisObj );                            
                }
            }
        );
    }
    
    if (e.data.messageType=="TableCellResult")
    {
        vm.worksheet = docItemFactory.findDependents(e.data.id, 0, vm.worksheet);
    }
    
    if (e.data.messageType=="PlotDataResults")
    {   
        vm.worksheet.forEach(
            function(thisObj, index){
                if (thisObj['itemid']==e.data.plotID)
                {   
                    if (e.data.eventErrorFlag==1)
                    {
                        thisObj['content']['Plot']['errorFlag']=1;
                        thisObj['content']['Plot']['errors']=e.data.eventError;
                    }else
                    {
                        thisObj['content']['Plot']['errorFlag']=0;
                        thisObj['content']['Plot']['errors']=[];
                        var itemArray=['Chart_dataobj', 'Chart_bandsobj', 'Chart_linesobj', 'Chart_textobj', 'Chart_xaxesobj', 'Chart_yaxesobj'];
                        for (var a=0; a<itemArray.length; a++)
                        {   
                            for (var thisData in thisObj['content']['Plot'][itemArray[a]])
                            {   
                                if (thisObj['content']['Plot'][itemArray[a]][thisData]['Format_id']==vm.currentChartItemID)
                                {
                                    vm.currentChartItem = thisObj['content']['Plot'][itemArray[a]][thisData];
                                    vm.currentPoint=vm.currentChartItem['PointData'][vm.pointIndex];
                                }
                            } 
                        }
                    }
                    vm.updateComponent( thisObj );                            
                }
            }
        );
    }

    if (e.data.messageType=="SurfaceData")
    {   
        vm.worksheet.forEach(function(item, index)
        {   
            if (item.itemid==e.data['PlotID'])
            {   
                for (var a = 0; a < item['content']['Surface']['Chart_dataobj'].length; a++)
                {
                    if (item['content']['Surface']['Chart_dataobj'][a]['Format_id'] == e.data['DataID'] )
                    {
                        var dataIndex = a;
                    }
                }

                for (var b = 0; b < e.data['dataObject'].length; b++)
                {
                    if (e.data['dataObject'][b]['Format_id'] == e.data['DataID'] )
                    {
                        var returnIndex = b;
                    }
                }

                if ((e.data['type']=="surface")||(e.data['type']=="pointCloud"))
                {    
                    item['content']['Surface']['Chart_dataobj'][dataIndex]['xLength']=e.data['dataObject'][returnIndex]['xLength'];
                    item['content']['Surface']['Chart_dataobj'][dataIndex]['yLength']=e.data['dataObject'][returnIndex]['yLength'];
                
                }else if (e.data['type']=="line") 
                {   
                    // item['content']['Surface']['Chart_dataobj'][dataIndex]['lineGeometry']=JSON.parse(JSON.stringify(e.data['dataObject'][returnIndex]['lineGeometry']));
                    item = surfaceFactory.setLinePoints( item, e.data['DataID'], e.data['Axis'] );

                }else if (e.data['type']=="lathe")
                {   
                    item['content']['Surface']['Chart_dataobj'][dataIndex]['xLength']=e.data['dataObject'][returnIndex]['xLength'];
                    item['content']['Surface']['Chart_dataobj'][dataIndex]['yLength']=e.data['dataObject'][returnIndex]['yLength'];
                    item['content']['Surface'].formatLatheData(e.data['PlotID'], e.data['DataID']);
                }                    
                
                vm.reDrawItem( item, 'all', 1 );
                vm.updateComponent( item );                            
            }
        });
    }

    console.log('I made it to the end of the equation return');
    vm.digestStatus=1; 

    // Run through the worksheet and check to see if there are any equations or other items flagged to be solved
    // If there are, run the digest. If there aren't, run. the digest and save the file
    vm.saveThisFile = 1;

    for (var a=0; a<vm.worksheet.length; a++)
    {   
        if (((vm.worksheet[a]['component_type_id']==3) &&
            (vm.worksheet[a]['content']['needsUpdateFlag']==1)) ||
            ((vm.worksheet[a]['component_type_id']==3) &&
            (vm.worksheet[a]['update'])))
        {   
            vm.saveThisFile = 0;
        }

        if (vm.worksheet[a]['component_type_id']==5)
        {   
            for (var b=0; b< vm.worksheet[a]['content']['data'].length; b++)
            {   for (var c=0; c< vm.worksheet[a]['content']['data'][0].length; c++)
                {   
                    if (vm.worksheet[a]['content']['data'][b][c]['needsUpdateFlag']==1)
                    {   
                        vm.saveThisFile = 0;
                    }
                }
            }
        }

        // Check and update the loop parameters
        if ((vm.worksheet[a]['component_type_id']==6) &&
            (vm.worksheet[a]['content']['needsBlockUpdate']==1) )
        {   
            vm.saveThisFile = 0;
        }

        // Check and update the loop parameters
        if ((vm.worksheet[a]['component_type_id']==7) &&
            (vm.worksheet[a]['content']['needsBlockUpdate']==1) )
        {   
            vm.saveThisFile = 0;
        }

        // Check and update the if/else parameters
        if ((vm.worksheet[a]['component_type_id']==8) &&
            (vm.worksheet[a]['content']['needsBlockUpdate']==1) )
        {   
            vm.saveThisFile = 0;
        }

        // Check and update the loop structure
        if ((vm.worksheet[a]['component_type_id']==6) && 
            (vm.worksheet[a]['content']['forLoop']['needsUpdateFlag']==1) )
        {
            vm.saveThisFile = 0;
        }

        // Check and update the loop structure
        if ((vm.worksheet[a]['component_type_id']==7) && 
            (vm.worksheet[a]['content']['whileLoop']['needsUpdateFlag']==1) )
        {
            vm.saveThisFile = 0;
        }

        // Check and update the lif/else structure
        if ((vm.worksheet[a]['component_type_id']==8) && 
            (vm.worksheet[a]['content']['ifelse']['needsUpdateFlag']==1) )
        {
            vm.saveThisFile = 0;
        }

        if ((vm.worksheet[a]['component_type_id']==9))
        {   
            for (var thisDataset in vm.worksheet[a]['content']['Plot']['Chart_dataobj'])
            {   
                if (vm.worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['needsUpdateFlag']==1)
                {   
                    vm.saveThisFile = 0;
                }
            } 
            if (vm.worksheet[a]['content']['Plot']['needsUpdateFlag']==1)
            {
                vm.saveThisFile = 0;
            }
        }
        if (vm.worksheet[a]['component_type_id']==13)
        {   
            for (var dataIndex in vm.worksheet[a]['content']['Surface']['Chart_dataobj'])
            {   
                if (vm.worksheet[a]['content']['Surface']['Chart_dataobj'][dataIndex]['needsUpdateFlag']==1)
                {   
                    vm.saveThisFile = 0;
                }
            }  
        }

    }

    vm.runEquationDigest( vm.worksheet, vm.solveFileInfo, vm.saveThisFile, thisType );

};






/*
*
*   SEPARATE FUNCTION TO ADDRESS RETURNED CONNECTED EQUATIONS
*
*/
function addressConnectedEqs(returnObject, worksheetObj) 
{   
    MY_SCOPE.returnItem = returnObject;
    var flag=0;
    console.log('There are '+Object.keys(returnObject.connected).length+' connected items in the returned array');
    // Handle the connected equations - If the returned item has connected equations
    if (Object.keys(returnObject.connected).length>0)
    {  
        console.log('There were keys returned');
        vm.worksheetObj.forEach(function(item, index)
        {   
            console.log('I am now comparing '+returnObject.id+' to '+item['itemid']);
            if (returnObject.id==item['itemid'])
            {
                console.log('match');
                // Loop through all of the existing connected IDs for this equation. Find them in the vm.worksheet,
                // and check their names against the list of names for the newly returned connected items. If one
                // matches, update the data from the new solution.
                for (var existingConn in item['content']['Equation']['connected_ids'])
                {
                    flag=0;
                    vm.worksheetObj.forEach(function(tempItem, tempIndex)
                    {   
                        console.log('In the existing part, comparing '+tempItem['itemid']+'-'+existingConn);
                        console.log(tempItem['itemid']==existingConn);
                        if (tempItem['itemid']==existingConn) 
                        { 
                            for (var returnConn in returnObject.connected)
                            {
                                console.log('In connected ids, comparing '+returnObject.connected[returnConn]['Format_name']+' to '+tempItem['name']);
                                if (returnObject.connected[returnConn]['Format_name'] == tempItem['name'] )
                                {
                                    flag=1;
                                    for (var thisProp in returnObject.connected[returnConn])
                                    {
                                        console.log('Resetting the parameter '+thisProp);
                                        tempItem['content']['Equation'][thisProp] = returnObject.connected[returnConn][thisProp];
                                    }
                                    console.log('Deleting '+returnConn+' from the returned connected ids array');
                                    delete returnObject.connected[returnConn];

                                }
                            }
                        } 
                    }); 

                    // Delete the connected equation if it is not represented in the new result. It is a holdover
                    // from a previous solution.
                    if (flag==0)
                    {
                        vm.worksheetObj.forEach(function(tempItem, tempIndex)
                        {   
                            if (tempItem['itemid']==existingConn) 
                            { 
                                console.log('Deleting connected id '+existingConn+' - '+tempItem['name']);
                                vm.deleteItem(tempItem, 1);
                            } 
                        }); 
                    }
                }

                // Whatever items remain in the connected object are new. Add those as new items
                for (var connItem in returnObject.connected)
                {   
                    var connectedID = vm.addItem('Equation', returnObject.connected[connItem], 1, item['order']) 
                    console.log('I should have created '+returnObject.connected[connItem]['Format_name']);
                    item['content']['Equation']['connected_ids'][connectedID]=1;

                    // vm.worksheet.forEach(function(tempItem, tempIndex)
                    // {   
                    //     if (tempItem['itemid']==connectedID) 
                    //     { 
                    //         tempItem['name'] = returnObject.connected[connItem]['Format_name']; 
                    //         tempItem['inEdit'] = 1; 
                    //         tempItem['file_id'] = fileInfo.id; 
                    //         tempItem['Original_id']=returnObject.id;
                    //         tempItem['content']['isConnectedEquation']=1;
                    //         setTimeout(function(){ vm.updateComponent( tempItem ), 3000});
                    //     }
                    // }); 

                    // console.log('Created a new connected item named '+returnObject.connected[connItem]['Format_name']+' with an id of '+connectedID);
                }   
            }
        });
    }
}




/*
 * Call to update an item and then update the service
 *
 */
function updateComponent( thisItem )
{   
    if (typeof(thisItem)=='object')
    {
        //vm.cadwolf_worksheet = docItemFactory.getLastPos( vm.cadwolf_worksheet );
        console.log('Updating the component ...');
        console.log(thisItem);
        if (typeof(thisItem['content'])=='string')
        {
            thisItem['content']=JSON.parse(thisItem['content']);
            console.log('The content was stringified');
        }
        if (thisItem['component_type_id']==13)
        {
            var tempItem = vm.buildSurface( thisItem );
        }else
        {
            var tempItem = thisItem['content'];
        }
        if (thisItem['component_type_id']==3)
        {
            var name=thisItem['content']['Equation']['Format_name'];                    
        }else
        {
            var name=thisItem['name'];                     
        }
        $http({
            method: "PUT",
            url: window.location.origin+'/components',
            data: { 
                        id      : thisItem['id'],
                        itemid  : thisItem['itemid'],
                        //file_id : vm.cadwolf_fileInfo['id'],
                        file_id : thisItem['file_id'],
                        name    : name,
                        content : JSON.stringify(tempItem),
                        dependent_file : thisItem['dependent_file'],
                        dependent_id : thisItem['dependent_id'],
                        order : thisItem['order']
                  }
        }).then(function successCallback( returnData ) {
            console.log('Update component call completed');
            if (thisItem['component_type_id'] == 3)
            {
                for (var thisConn in thisItem['content']['Equation']['connected_ids'])
                {
                    vm.cadwolf_worksheet.forEach(
                        function(tempItem, index)
                        {
                            if (tempItem['itemid']==thisConn)
                            {
                                vm.updateComponent( tempItem );
                            }
                        }
                    );
                }
            
            }

            if ( (thisItem['component_type_id'] == 6) || (thisItem['component_type_id'] == 7) || (thisItem['component_type_id'] == 8) )
            {
                vm.cadwolf_worksheet.forEach(
                    function(sheetItem, index){
                        if ( sheetItem['content']['parentid'] == thisItem['itemid'] )
                        {
                            vm.updateComponent( sheetItem );
                        }
                    }
                );

            }

        }, function errorCallback( returnData ) {});
        // vm.updateService( );
    }
    console.log('Update component completed');

}        





/*
 *
 * Save the file and update the components
 *
 *  @param - flag - 0 or 1 if the components should be saved
 *  @param - fileInfo - the fileinfo object for the file being saved
 *  @param - thisType - string for where this saved originated
 *
 */
function saveFile( flag, fileInfo, thisType )
{   
    console.log('In the save file program with a type of '+thisType);

    $http({
        method: "PUT",
        url: window.location.origin+'/files/'+fileInfo['id'],
        data: { name : fileInfo['name'],
                parent_id : parseInt(fileInfo['parent_id'], 10),
                item_data : fileInfo['item_data']
              }
    }).then(function successCallback( returnData ) 
    {
        if ( thisType == 'workspace' )      { vm.getFiles($location.absUrl()); }
        if ( thisType == 'documentUpdate' ) { vm.getDepFiles(); }
        if ( thisType == 'partTreeUpdate' ) { vm.lockFiles( 0 ); 
                                              vm.getTreeStatus( fileInfo ); }

        if ( flag == 1 ) { vm.saveComponents( fileInfo, thisType ); }
        vm.sendAutocadVars( fileInfo );

    }, function errorCallback( returnData ) {});
}        

function saveComponents( fileInfo, thisType )
{   
    $http({
        method: "PUT",
        url: window.location.origin+'/saveDocument/'+fileInfo['id']
    }).then(function successCallback( returnData ) {
        if ( thisType == 'partTreeUpdate' ) { vm.getTreeStatus( fileInfo ); }
    }, function errorCallback( returnData ) {});
}







/*
 *
 *  Function to send autocad variables to Fusion 360. This is done the same was as 
 *  in the document function. The only exception is that we have to download the
 *  connected items first.
 *
 * @param - fileInfo - the fileInfo object for the file being saved and sending params to Fusion
 *
 */
function sendAutocadVars( fileInfo )
{

    console.log('In the send autocad vars function with '+fileInfo.id);

    // Flag that turns on the notification that the variables are being sent to Autocad
    vm.sendingAutocad = true;


    // Prep the strings that will hold the data sent to Fusion. Data can be sent for multiplt
    // files. File data is separated by  pound signs. This is done because arrays couldn't be
    // sent, so I sent strings that are parsed with Fusion's API.
    var h = '';         // String holding the hub data
    var p = '';         // String holding the project data
    var r = '';         // String holding the root folder
    var FIDs = '';      // String holding the IDs of the files
    var folds = "";     // String holding the Folder path for each file
    var flag = 0;       // Flag for first entry
    var eqNames = '';   // Names of the equations
    var eqValues = '';  // Values of the equations
    var fusionFlag = 0; // Whether or not we got a fusion connect



    // Download the connected files as this isn't done for the fileInfo
    $http({
        method: "GET",
        url: window.location.origin+'/getConnected/'+fileInfo.id,
        params: { }
    }).then(function successCallback( returnData )
    {
        console.log(returnData);
        vm.connectedFiles = returnData.data.data;
        for (var a=0; a<vm.connectedFiles.length; a++)
        {
            vm.connectedFiles[a]['info'] = JSON.parse(vm.connectedFiles[a]['info']);
            if ( vm.connectedFiles[a]['cad_type'] == "fusion" )
            {
                if ( typeof(vm.connectedFiles[a]['info']['cad_data']) == "string" )
                {
                    vm.connectedFiles[a]['info']['cad_data'] = JSON.parse(vm.connectedFiles[a]['info']['cad_data']);
                }
            }
        }

        // First, remove any old links
        if ( document.getElementById("fusionLink") !== null )
        {
            document.getElementById("fusionLink").remove();
        }

        vm.connectedFiles.forEach(
            function(thisConn, index)
            {

                console.log('For this connection, the type is '+thisConn.cad_type);

                if ( thisConn.cad_type == 'fusion' )
                {

                    fusionFlag = 1;

                    console.log('The Fusion flag is set to '+fusionFlag);

                    // Set the file data
                    if ( flag == 0 )
                    {
                        h = thisConn.info.cad_data.hubData.attributes.name;
                        p = thisConn.info.cad_data.projectData.attributes.name;
                        r = thisConn.info.cad_data.rootFolder;
                        FIDs = thisConn.info.cad_data.file;
                        folds = "";
                    }else
                    {
                        h = h+'**'+thisConn.info.cad_data.hubData.attributes.name;
                        p = p+'**'+thisConn.info.cad_data.projectData.attributes.name;
                        r = r+'**'+thisConn.info.cad_data.rootFolder;
                        FIDs = FIDs+'**'+thisConn.info.cad_data.file;
                        folds = folds+'**';
                    }

                    for (var a=0; a<thisConn.info.cad_data.folders.length; a++)
                    {
                        if ( a == 0 )
                        {
                            if ( thisConn.info.cad_data.folders[a] !== null )
                            {
                                folds = folds+""+thisConn.info.cad_data.folders[a];
                            }

                        }else
                        {
                            if ( thisConn.info.cad_data.folders[a] !== null )
                            {
                                folds = folds+","+thisConn.info.cad_data.folders[a];
                            }
                        }
                    }


                    if ( flag == 1 )
                    {
                        eqNames = eqNames+'**';
                        eqValues = eqValues+'**';
                    }else
                    {
                        flag = 1;
                    }

                    thisConn.info.equations.forEach(
                        function(thisEq, index2){

                            if ( index2 == 0 )
                            {
                                eqNames = eqNames+''+thisEq.eq_name;
                            }else
                            {
                                eqNames = eqNames+','+thisEq.eq_name;
                            }

                            vm.worksheet.forEach(
                                function(sheetEq, index3){

                                    if ( sheetEq.component_type_id == 3)
                                    {
                                        if ( sheetEq.name == thisEq.eq_name )
                                        {
                                            if ( index2 == 0 )
                                            {
                                                eqValues = eqValues+''+sheetEq.content.Equation.Solution_real['0-0']+' '+sheetEq.content.Equation.Units_units;
                                            }else
                                            {
                                                eqValues = eqValues+','+sheetEq.content.Equation.Solution_real['0-0']+' '+sheetEq.content.Equation.Units_units;
                                            }

                                        }
                                    }
                                }
                            );

                        }
                    );                      

                }
            }
        );


        // Turn off Autocad Flag
        vm.sendingAutocad = false;


        console.log('Before the call, the fusion flag is '+fusionFlag);

        if ( fusionFlag == 1 )
        {
            var link=document.createElement("a");
            link.id = 'fusionLink'; 
            link.href='fusion360://command=open&properties={"hub":"'+h+'","project":"'+p+'","root":"'+r+'","folders":"'+folds+'","file":"'+FIDs+'","eqNames":"'+eqNames+'","eqValues":"'+eqValues+'"}';

            console.log('The anchor is ...');
            console.log(link.href);
            
            document.getElementById("fusionLinkArea").appendChild(link);

            document.getElementById('fusionLink').click();

        }

    });

}




		/* Heatmap Functions */



		vm.getOnshapeDocs();
		vm.getAutocadHubs();

		if ( vm.file_id !== undefined ) { vm.getDepFiles( ); }
		if ( vm.fileInfo !== undefined ) { vm.getVersions(); }
		if ( vm.modalType == 'freeBodyDiagram' ) 
		{ 

			var checkExist = setInterval(function() {

				if ($('#fbdTest').length) {
					console.log("Exists!");
			      clearInterval(checkExist);
			    }

				vm.reDrawFBD( vm.thisItem ); 
			
			}, 100);

		}

	}


})();
(function ()
{
    'use strict';

    angular
        .module('app.document', [
            'app.document.worksheet'
            ])
        .config(config);



    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

       // State
        $stateProvider.state('app.document', {
            url      : '/Document{path:.*}',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/document/document.html',
                    controller : 'DocumentController as vm'
                }
            },
            bodyClass: 'worksheet'
        });



        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/document');

        // Navigation
        msNavigationServiceProvider.saveItem('document', {
            title : 'Documents',
            icon  : 'icon-file-outline',
            state : 'app.document',
            weight: 4
        });
    }

})();
(function ()
{
	'use strict';

	angular
		.module('app.document')
		.controller('DocumentController', DocumentController);

	/** @ngInject */
	function DocumentController($sce, $mdSidenav, $mdDialog, docItemFactory, chartFactory, surfaceFactory, unitConstantFactory, utilityFactory, documentMemoryFactory, userMemoryFactory, $timeout, $http, $location)
	{


		// Default Items
		var vm = vm || this;
		window.MY_SCOPE = vm;		
		vm.cadwolfScaleUnits	= vm.cadwolfScaleUnits || unitConstantFactory.unitsObj();
		vm.cadwolfParseUnits	= vm.cadwolfParseUnits || unitConstantFactory.parseObj();
		vm.cadwolfConstants		= vm.cadwolfConstants || unitConstantFactory.constObj();
		vm.chartFactory			= vm.chartFactory || chartFactory;
		vm.docItemFactory		= vm.docItemFactory || docItemFactory;
		vm.surfaceFactory		= vm.surfaceFactory || surfaceFactory;
		vm.showMenuTextTop		= vm.showMenuTextTop || false;
		vm.showMenuTextBot		= vm.showMenuTextBot || false;
		vm.digestStatus			= 1;
		vm.currentUserInfo		= userMemoryFactory.currentUserInfo;

		var equationWorker = new Worker("eqSolver.js");  
		var wireTexture = new THREE.ImageUtils.loadTexture( 'assets/images/square.png' );	



		// Methods
		vm.getSpark			 	= vm.getSpark			|| getSpark;
		vm.initialize			= vm.initialize			|| initialize;
		vm.checkPython			= vm.checkPython		|| checkPython;
		vm.addItem				= vm.addItem			|| addItem;
		vm.deleteItem			= vm.deleteItem			|| deleteItem;
		vm.setCurrent			= vm.setCurrent			|| setCurrent;
		vm.setBG				= vm.setBG				|| setBG;
		vm.setParentCurrent	 	= vm.setParentCurrent   || setParentCurrent;
		vm.solveEquation		= vm.solveEquation		|| solveEquation;
		vm.addressConnectedEqs  = vm.addressConnectedEqs|| addressConnectedEqs;
		vm.runEquationDigest	= vm.runEquationDigest  || runEquationDigest;
		vm.changeLoc			= vm.changeLoc			|| changeLoc;
		vm.addChartItem			= vm.addChartItem		|| addChartItem;
		vm.deleteChartItem		= vm.deleteChartItem	|| deleteChartItem;
		vm.setMonoColor			= vm.setMonoColor		|| setMonoColor;
		vm.addStatement			= vm.addStatement		|| addStatement;
		vm.addBlock				= vm.addBlock			|| addBlock;
		vm.deleteStatement		= vm.deleteStatement	|| deleteStatement;
		vm.fillTable			= vm.fillTable			|| fillTable;
		vm.addSurfaceItem		= vm.addSurfaceItem		|| addSurfaceItem;
		vm.buildSurface			= vm.buildSurface		|| buildSurface;
		vm.deleteSurfaceItem	= vm.deleteSurfaceItem  || deleteSurfaceItem;
		vm.reDrawItem			= vm.reDrawItem			|| reDrawItem;
		vm.animate				= vm.animate			|| animate;
		vm.cancelAnimation		= vm.cancelAnimation	|| cancelAnimation;
		vm.renderSurface		= vm.renderSurface		|| renderSurface;
		vm.handleCameraChange   = vm.handleCameraChange || handleCameraChange;
		vm.updateService		= vm.updateService		|| updateService; 
		vm.createComponent		= vm.createComponent	|| createComponent; 
		vm.updateComponent		= vm.updateComponent	|| updateComponent; 
		vm.saveFile				= vm.saveFile			|| saveFile;
		vm.saveComponents		= vm.saveComponents		|| saveComponents;
		vm.sendAutocadVars 		= vm.sendAutocadVars 	|| sendAutocadVars
		vm.resetCurrent			= vm.resetCurrent		|| resetCurrent;
		vm.checkOutFile			= vm.checkOutFile		|| checkOutFile;
		vm.checkInFile			= vm.checkInFile		|| checkInFile;
		vm.checkUpdates			= vm.checkUpdates		|| checkUpdates;
		vm.updateUserInfo		= vm.updateUserInfo		|| updateUserInfo;
		vm.goToURL				= vm.goToURL			|| goToURL;
		vm.forLoopCounters		= vm.forLoopCounters	|| forLoopCounters;
		vm.setLoopChildCounters = vm.setLoopChildCounters || setLoopChildCounters;
		vm.checkInitialData		= vm.checkInitialData	|| checkInitialData;
		vm.checkConnected		= vm.checkConnected		|| checkConnected;
		vm.downloadConnected 	= vm.downloadConnected 	|| downloadConnected;
		vm.updateCADItems		= vm.updateCADItems		|| updateCADItems;
		vm.handleSolverReturn   = vm.handleSolverReturn || handleSolverReturn;


		vm.showModal			= vm.showModal			|| showModal;
		vm.showSmallModal		= vm.showSmallModal		|| showSmallModal;
		vm.showMessage			= vm.showMessage		|| showMessage;
		vm.showStructure		= vm.showStructure		|| showStructure;
		vm.showPlotEdit			= vm.showPlotEdit		|| showPlotEdit;
		vm.showFullChart		= vm.showFullChart		|| showFullChart;
		vm.showFullSurface		= vm.showFullSurface	|| showFullSurface;
		vm.cancel				= vm.cancel				|| cancel;
		vm.cancelPlot			= vm.cancelPlot			|| cancelPlot;
		vm.cancelSurface		= vm.cancelSurface		|| cancelSurface;

		vm.addTableRow			= vm.addTableRow		|| addTableRow;
		vm.deleteTableRow		= vm.deleteTableRow		|| deleteTableRow;
		vm.addTableColumn		= vm.addTableColumn		|| addTableColumn;
		vm.deleteTableColumn	= vm.deleteTableColumn  || deleteTableColumn;
		vm.leftMenuCaller		= vm.leftMenuCaller		|| leftMenuCaller;
		vm.loadVersion			= vm.loadVersion		|| loadVersion;
		vm.favoriteItem			= vm.favoriteItem		|| favoriteItem;
		vm.doMathJax 			= vm.doMathJax 			|| doMathJax;
		vm.removeFavItem		= vm.removeFavItem		|| removeFavItem;
		vm.componentCheck		= vm.componentCheck		|| componentCheck;
		vm.makeArray			= vm.makeArray			|| makeArray;

		vm.reDrawFBD			= vm.reDrawFBD 			|| reDrawFBD;
		vm.navigateToParent 	= vm.navigateToParent 	|| navigateToParent;


		vm.getForums 			= vm.getForums 			|| getForums;
		vm.getComments 			= vm.getComments 		|| getComments;
		vm.assignDates 			= vm.assignDates 		|| assignDates;
		vm.resetStatus 			= vm.resetStatus 		|| resetStatus;
		vm.syncConnected 		= vm.syncConnected 		|| syncConnected;


		vm.initialize();




		/*
		 * Set the initial parameters
		 *
		 */
		function initialize( thisVersion, thisRevision )
		{   
			console.log('Initialization function called with '+window.location.href+' and version '+thisVersion+'.'+thisRevision);

			vm.cadwolf_useServer=false
			vm.noDocument = false;
			vm.pageClass="page-layout simple left-sidenav inner-sidenav";
			vm.mainClass="mainEdit";
			vm.checkPython();
			vm.showType = 'Document2';
			vm.showType = 'Document';
			if (Spark === undefined)
			{
				Spark={};
			}
			if (Spark.state !== undefined)
			{
				if (Spark.state.user!=null)
				{
					if (typeof(Spark.state.user.user_info)=='string')
					{
						Spark.state.user.user_info = JSON.parse( Spark.state.user.user_info );
						Spark.state.user.photo_url = Spark.state.user.photo_url.replace(window.location.origin+'/', '')
					}
				}
			}

			if ((window.location.href=="http://www.cadwolf.com/Document") ||
				(window.location.href=="http://www.cadwolf.com/Document/") ||
				(window.location.href=="https://www.cadwolf.com/Document") ||
				(window.location.href=="https://www.cadwolf.com/Document/") ||
				(window.location.href=="cadwolf-staging.herokuapp.com/Document") ||
				(window.location.href=="https://www.cadwolf-staging.herokuapp.com/Document") ||
				(window.location.href=="cadwolf-staging.herokuapp.com/Document/") ||
				(window.location.href=="https://cadwolf-staging.herokuapp.com/Document/") ||
				(window.location.href=="https://www.cadwolf-staging.herokuapp.com/Document/"))
			{
				vm.showType = 'DocumentEmpty';

			}else
			{
				if (thisVersion===undefined){ thisVersion=0; }
				if (thisRevision===undefined){ thisRevision=0; }
				console.log('Initialization function called with '+window.location.href+' and version '+thisVersion+'.'+thisRevision);

				vm.getForums();

				if (documentMemoryFactory.currentURL == window.location.href.replace(/\~2F/g,'/') &&
					(documentMemoryFactory.fileInfo!==undefined))
				{
					vm.cadwolf_fileInfo = documentMemoryFactory.fileInfo;
					vm.calcWidth = parseInt(vm.cadwolf_fileInfo.item_data.docWidth)+(2*(parseInt(vm.cadwolf_fileInfo.item_data.docMargin)+2));
					vm.cadwolf_worksheet = documentMemoryFactory.worksheet;
				}

				if (documentMemoryFactory.currentURL != window.location.href.replace(/\~2F/g,'/'))
				{
					$http({
						method: "GET",
						url: window.location.origin+'/files',
						params: { thisURL : window.location.href.replace(/\~2F/g,'/'), version : thisVersion, revision : thisRevision }
					}).then(function successCallback( returnData ) 
					{
						
						if ( (returnData.data.fileInfo === undefined ) || ( returnData.data.fileInfo == "noFile" ) )
						{   
							vm.noDocument = true;
						}else{
							vm.noDocument = false;
						}

						// If no file was found at the given address, but one was found at a different module, that module is returned
						if ( ( returnData.data.fileInfo == "noFile" ) && ( vm.showType != 'DocumentEmpty' ) )
						{
							if ( returnData.data.files == "Workspace" )
							{
								$location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Document/, '\/Workspace'));
							}
							if ( returnData.data.files == "Dataset" )
							{
								$location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Document/, '\/Dataset'));
							}
							if ( returnData.data.files == "PartTree" )
							{
								$location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Document/, '\/PartTree'));
							}
						}

						if ( ( returnData.data.fileInfo.file_type_id == 'Workspace' ) && ( vm.showType != 'DocumentEmpty' ) )
						{
							$location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Document/, '\/Workspace'));
						}
						if ( returnData.data.fileInfo.file_type_id == 'Dataset' )
						{
							$location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Document/, '\/Dataset'));
						}
						if ( returnData.data.fileInfo.file_type_id == 'PartTree' )
						{
							$location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Document/, '\/PartTree'));
						}

						// Make sure that the document has the proper updates
						vm.cadwolf_fileInfo = docItemFactory.updateDocProps( returnData['data']['fileInfo'] );
						vm.cadwolf_permissions = returnData['data']['permissions'];
						vm.calcWidth = parseInt(vm.cadwolf_fileInfo.item_data.docWidth)+(2*(parseInt(vm.cadwolf_fileInfo.item_data.docMargin)+2));
						document.title = vm.cadwolf_fileInfo.name;


						if ( window.amplitude === undefined )
						{
							var e=window;
							var t=document
							var n=e.amplitude||{_q:[],_iq:{}};var r=t.createElement("script")
							  ;r.type="text/javascript";r.async=true
							  ;r.src="https://cdn.amplitude.com/libs/amplitude-4.4.0-min.gz.js"
							  ;r.onload=function(){if(e.amplitude.runQueuedFunctions){
							  e.amplitude.runQueuedFunctions()}else{
							  console.log("[Amplitude] Error: could not load SDK")}}
							  ;var i=t.getElementsByTagName("script")[0];i.parentNode.insertBefore(r,i)
							  ;function s(e,t){e.prototype[t]=function(){
							  this._q.push([t].concat(Array.prototype.slice.call(arguments,0)));return this}}
							  var o=function(){this._q=[];return this}
							  ;var a=["add","append","clearAll","prepend","set","setOnce","unset"]
							  ;for(var u=0;u<a.length;u++){s(o,a[u])}n.Identify=o;var c=function(){this._q=[]
							  ;return this}
							  ;var l=["setProductId","setQuantity","setPrice","setRevenueType","setEventProperties"]
							  ;for(var p=0;p<l.length;p++){s(c,l[p])}n.Revenue=c
							  ;var d=["init","logEvent","logRevenue","setUserId","setUserProperties","setOptOut","setVersionName","setDomain","setDeviceId","setGlobalUserProperties","identify","clearUserProperties","setGroup","logRevenueV2","regenerateDeviceId","logEventWithTimestamp","logEventWithGroups","setSessionId","resetSessionId"]
							  ;function v(e){function t(t){e[t]=function(){
							  e._q.push([t].concat(Array.prototype.slice.call(arguments,0)))}}
							  for(var n=0;n<d.length;n++){t(d[n])}}v(n);n.getInstance=function(e){
							  e=(!e||e.length===0?"$default_instance":e).toLowerCase()
							  ;if(!n._iq.hasOwnProperty(e)){n._iq[e]={_q:[]};v(n._iq[e])}return n._iq[e]}
							  ;e.amplitude=n;

							 amplitude.getInstance().init("85374354a72a1d05529735dc0be7f8d8");
						}

						// Send the amplitude data
						if ( Spark.state !== undefined )
						{
							if (Spark.state.user!=null)
							{
								amplitude.getInstance().setUserId( Spark.state.user.id );
							}
						}

						amplitude.getInstance().logEvent("Document View",
						    { title: vm.cadwolf_fileInfo.name,
						      id: vm.cadwolf_fileInfo.id });


						vm.pageClass="page-layout simple left-sidenav inner-sidenav";
						vm.mainClass="mainEdit";

						if (Spark.state !== undefined )
						{
							if (Spark.state.user!=null)
							{
								vm.viewPerm=returnData['data']['permissions']['view']==1||false;
								vm.editPerm=(returnData['data']['permissions']['edit']==1||false) &&
															(Spark.state.user.id==vm.cadwolf_fileInfo.item_data.checkout_id);
								Spark.state.user.user_info = utilityFactory.setRecent( 'Document', vm.cadwolf_fileInfo, Spark.state.user.user_info, window.location.pathname ); 
								vm.cadwolf_fileInfo.favorite = utilityFactory.checkFavorite( 'Document', vm.cadwolf_fileInfo, Spark.state.user.user_info );
								vm.updateUserInfo();
							}else
							{
								vm.viewPerm=returnData['data']['permissions']['view']==1||false;
								vm.editPerm=false;
							}
						}else
						{
							vm.viewPerm=returnData['data']['permissions']['view']==1||false;
							vm.editPerm=false;
						}
						vm.showType = 'Document2';
						vm.showType = 'Document';
						var thisURL = window.location.origin+'/files/'+vm.cadwolf_fileInfo.id+'/components'
						$http({
							type: "GET",
							url: thisURL,
							params: { version : thisVersion }
						}).then(function successCallback( returnData ) 
						{
							vm.checkConnected();
							vm.getSpark();
							console.log('The components are ...');
							console.log(returnData);
							vm.cadwolf_worksheet = returnData.data.components;
							vm.cadwolf_fileInfo.item_data.showEndLoc = vm.cadwolf_worksheet.length;
							vm.cadwolf_worksheet.forEach(
								function(thisItem, index){
									thisItem['content'] = JSON.parse(thisItem['content']);
									if ((thisItem['component_type_id']==12)||(thisItem['component_type_id']=='Video'))
									{
										thisItem.content.url=$sce.trustAsResourceUrl('https://www.youtube.com/embed/'+thisItem.content.videoID);
									}
									if ((thisItem['component_type_id']==9)||(thisItem['component_type_id']=='Plot'))
									{
										console.log('I am flagging a plot');
										thisItem.content.renderTo = 'standard';
										thisItem.content.Plot.needsUpdateFlag=1;
									}
									if (thisItem['component_type_id']==3)
									{
										thisItem['content']['Equation']['inEdit']=0;
										if (thisItem['content']['Equation']['BaseArray']!=undefined)
										{
											thisItem['content']['Equation']['Units_base_array']['A']=thisItem['content']['Equation']['BaseArray']['A'];
											thisItem['content']['Equation']['Units_base_array']['K']=thisItem['content']['Equation']['BaseArray']['K'];
											thisItem['content']['Equation']['Units_base_array']['cd']=thisItem['content']['Equation']['BaseArray']['cd'];
											thisItem['content']['Equation']['Units_base_array']['kg']=thisItem['content']['Equation']['BaseArray']['kg'];
											thisItem['content']['Equation']['Units_base_array']['m']=thisItem['content']['Equation']['BaseArray']['m'];
											thisItem['content']['Equation']['Units_base_array']['mol']=thisItem['content']['Equation']['BaseArray']['mol'];
											thisItem['content']['Equation']['Units_base_array']['molecules']=thisItem['content']['Equation']['BaseArray']['molecules'];
											thisItem['content']['Equation']['Units_base_array']['rad']=thisItem['content']['Equation']['BaseArray']['rad'];
											thisItem['content']['Equation']['Units_base_array']['s']=thisItem['content']['Equation']['BaseArray']['s'];

										}
									}
									if (thisItem['component_type_id']==16)
									{
										vm.reDrawFBD( thisItem );
									}
								}
							);


							if (Spark.state !== undefined ) 
							{
								if (Spark.state.user!=null) 
								{
									if (Spark.state.user.id==1) 
									{ vm.checkInitialData(); } 
								}
							}
							vm.checkUpdates();
							$timeout(function () {
								vm.runEquationDigest();
								vm.cadwolf_worksheet.forEach(
									function(thisItem, index){
									if ((thisItem['component_type_id']==13)||(thisItem['component_type_id']=='Surface'))
									{
										if (typeof(thisItem['content'])=='string')
										{
											thisItem['content']=JSON.parse(thisItem['content']);
										}
										console.log('I am flagging a surface');
										thisItem.content.renderTo = 'document';
										// thisItem['content']['Surface'] = new vm.surfaceFactory.surfacePro( thisItem['content'], thisItem['itemid'], thisItem['fileid'] );
										thisItem = vm.surfaceFactory.initializeSurface( thisItem, 0 );
										console.log('Calling reDrawItem from initialization');
										vm.reDrawItem( thisItem, 'all', 1 );
									}
								});
								vm.setBG();
							});
							MathJax.Hub.Configured();
							MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
							MathJax.Hub.Register.MessageHook("Math Processing Error",function (message) {
								console.log('I got a MathJax error of '+message[2]);
							});
							vm.setCurrent("top");

							vm.cadwolf_fileInfo.showHeaders = true;
							vm.cadwolf_fileInfo.showText = true;
							vm.cadwolf_fileInfo.showEquations = true;
							vm.cadwolf_fileInfo.showSymbolics = true;
							vm.cadwolf_fileInfo.showTables = true;
							vm.cadwolf_fileInfo.showForLoops = true;
							vm.cadwolf_fileInfo.showWhileLoops = true;
							vm.cadwolf_fileInfo.showIfElses = true;
							vm.cadwolf_fileInfo.showPlots = true;
							vm.cadwolf_fileInfo.showCharts = true;
							vm.cadwolf_fileInfo.showImages = true;
							vm.cadwolf_fileInfo.showVideos = true;
							vm.cadwolf_fileInfo.showLineBreaks = true;
							vm.cadwolf_fileInfo.showFreeBodyDiagrams = true;
							vm.cadwolf_fileInfo.showRequirements = true;
							vm.updateme = { update : true };

							vm.checkConnected();
							vm.downloadConnected();

						}, function errorCallback( returnData ) { vm.noDocument = true; });

					}, function errorCallback( returnData ) { vm.noDocument = true; });
				}
			}

		}




		/*
		 *
		 * Get the spark parameters
		 *
		 */
		function getSpark( )
		{   
			console.log('In the get spark function');
			$http({
				method: "GET",
				url: window.location.origin+'/user/current'

			}).then(function successCallback( returnData ) 
			{
				console.log('The spark data is ...');
				console.log(returnData.data);
				if ( Spark.state !== undefined )
				{
					if ( Spark.state.user !== undefined )
					{
						if ( returnData.data.user_info !== undefined )
						{
							returnData.data.user_info = JSON.parse(returnData.data.user_info);
							Spark.state.user = returnData.data;
							vm.editPerm = Spark.state.user.id == vm.cadwolf_fileInfo.item_data.checkout_id;
						}else
						{
							if ( ( Spark.state.user !== undefined ) && ( Spark.state.user !== null ) )
							{
								if ( Spark.state.user.id !== undefined )
								{
									vm.editPerm = Spark.state.user.id == vm.cadwolf_fileInfo.item_data.checkout_id;
								}else
								{
									vm.editPerm = false;
								}
							}else
							{
								vm.editPerm = false;
							}
						}
					}
				}else
				{
					vm.editPerm = false;					
				}
			});

		}













		/*
		*
		*   CHECK TO SEE IF THIS DOCUMENT IS CONNECTED TO ONSHAPE. IF SO, SEND KEEP ALIVE
		*
		*/
		function checkConnected( ) 
		{   
			if ( documentMemoryFactory.connected == 1 )
			{
				console.log('Sending a keep alive message to onShape ...');
				console.log(documentMemoryFactory.onShape.documentId+' - '+documentMemoryFactory.onShape.workspaceId+' - '+documentMemoryFactory.onShape.elementId+' - '+documentMemoryFactory.onShape.server+' - '+documentMemoryFactory.onShape.userId);

				var message = { documentId: documentMemoryFactory.onShape.documentId,
								workspaceId: documentMemoryFactory.onShape.workspaceId,
								elementId: documentMemoryFactory.onShape.elementId,
								messageName: 'keepAlive'};
				window.parent.postMessage(message, '*');

				var message = { documentId: documentMemoryFactory.onShape.documentId,
								workspaceId: documentMemoryFactory.onShape.workspaceId,
								elementId: documentMemoryFactory.onShape.elementId,
								messageName: 'startWorkingSpinner'};
				
				setTimeout(function(){ window.parent.postMessage(message, '*'); }, 3000);


				var message = { documentId: documentMemoryFactory.onShape.documentId,
								workspaceId: documentMemoryFactory.onShape.workspaceId,
								elementId: documentMemoryFactory.onShape.elementId,
								messageName: 'stopWorkingSpinner'};

				setTimeout(function(){ window.parent.postMessage(message, '*'); }, 3000);
			}
		}


		/*
		*
		*   Check to see if inputs have changed. If so, update and reset dependents
		*
		*/
		function checkUpdates( ) 
		{   

			console.log('In the check updates function');

			var tempItem={};
			if ( vm.cadwolf_fileInfo['needs_update'] ) 
			{
				vm.cadwolf_worksheet.forEach(
					function(thisItem, index)
					{
						// If this equation depends upon another file
						if ( thisItem['component_type_id'] == 3 )
						{
							if ( thisItem['content']['Equation']['inputType'] == "File" )
							{
								$http({
									method: "GET",
									url: window.location.origin+'/components/retrieve/'+thisItem['dependent_id'],
								}).then(function successCallback( returnData ) {
									console.log('The return data is ...');
									console.log(returnData);
									if(returnData.data.data=="noPerm")
									{

									}else
									{
										tempItem = JSON.parse(JSON.stringify(returnData['data']['data']));
										if ( typeof(tempItem['content']) == 'string' )
										{
											tempItem['content'] = JSON.parse( tempItem['content'] );
										}

										thisItem['content']['Equation']['Solution_real'] = JSON.parse(JSON.stringify(tempItem['content']['Equation']['Solution_real']));
										thisItem['content']['Equation']['Solution_imag'] = JSON.parse(JSON.stringify(tempItem['content']['Equation']['Solution_imag']));
										thisItem['content']['Equation']['Format_size'] = JSON.parse(JSON.stringify(tempItem['content']['Equation']['Format_size']));
										thisItem['content']['Equation']['Units_units'] = JSON.parse(JSON.stringify(tempItem['content']['Equation']['Units_units']));
										thisItem['content']['Equation']['Format_size'] = JSON.parse(JSON.stringify(tempItem['content']['Equation']['Format_size']));
										thisItem['content']['Equation']['Errors_flag'] = JSON.parse(JSON.stringify(tempItem['content']['Equation']['Errors_flag']));
										thisItem['content']['Equation']['Units_units'] = JSON.parse(JSON.stringify(tempItem['content']['Equation']['Units_units']));
										thisItem['content']['Equation']['Format_showequation'] = JSON.parse(JSON.stringify(tempItem['content']['Equation']['Format_showequation']));

										vm.cadwolf_worksheet = docItemFactory.findDependents( thisItem.itemid, 0, vm.cadwolf_worksheet);
										vm.updateComponent( thisItem );
										console.log('I should be running the digest');
										vm.runEquationDigest();
									}
								}, function errorCallback( returnData ) {});

							}

							if ( thisItem['content']['Equation']['inputType'] == "Dataset" )
							{
								vm.updateDatasetInput( thisItem );
							}
						}
					}
				);


				$http({
					method: "POST",
					url: window.location.origin+'/files/fileCurrent/'+vm.cadwolf_fileInfo['id'],
				});
			}
		}






		/*
		*
		*   SET THE CURRENT ITEM
		*
		*/
		function setCurrent(thisObj) 
		{   
			if ( ( vm.editPerm ) &&
				 ( vm.currentItem != "top" ) &&
				 ( thisObj != "top" ) &&
				 ( vm.currentItem.id != thisObj.id ) &&
				 ( thisObj['content']['parentid'] == 'none' ))
			{
				console.log('Calling the updateComponent function from the setCurrent function');
				vm.updateComponent( vm.currentItem );
			}
			if ( vm.editPerm )
			{   
				if (vm.currentItem===undefined){ vm.currentItem=thisObj; }

				console.log('Calling the cancelAnimation from the setCurrent function');
				vm.cancelAnimation( vm.APLOT ); 

				console.log('In the set current function with the old current item being '+vm.currentItem.id+' and the new is '+thisObj.id);

				if ( thisObj == "top" )
				{
					vm.currentItem = "top";
					vm.cadwolf_worksheet.forEach(
						function(thisItem, index){
							thisItem['content']['showEdit']=false;
							thisItem['content']['showClass']='';
						}
					);
				}else
				{

					if ( thisObj['content']['parentid'] == 'none' )
					{
						vm.currentItem=thisObj;
						vm.setBG();

					}else{

						vm.currentSubItem = thisObj;
					}

					if ((thisObj['component_type_id']=='6')||(thisObj['component_type_id']=='7')||(thisObj['component_type_id']=='8'))
					{
						vm.currentStructure = thisObj;
					}
				}
			}
			console.log('Finished the setCurrentItem function');
		};







		/*
		*
		*   SET THE CURRENT ITEM BACKGROUND
		*
		*/
		function setBG() 
		{   

			if ( vm.currentItem !== 'top' )
			{
				if ( vm.currentItem !== undefined )
				{
					vm.cadwolf_worksheet.forEach(
						function(thisItem, index){
							if ( typeof( thisItem['content'] ) == 'string' )
							{
								thisItem['content'] = JSON.parse( thisItem['content'] );
							}
							if (thisItem['content']['itemid']==vm.currentItem['content']['itemid'])
							{   
								thisItem['content']['showClass']="selected";
							}else
							{
								thisItem['content']['showEdit']=false;
								thisItem['content']['showClass']='';
							}
						}
					);
				}else
				{
					vm.cadwolf_worksheet.forEach(
						function(thisItem, index)
						{
							if ( typeof( thisItem['content'] ) == 'string' )
							{
								thisItem['content'] = JSON.parse( thisItem['content'] );
							}
							thisItem['content']['showEdit']=false;
							thisItem['content']['showClass']='';
						}
					);
				}
			}

			if ( !vm.editPerm )
			{
				vm.cadwolf_worksheet.forEach(
					function(thisItem, index)
					{
						if ( typeof( thisItem['content'] ) == 'string' )
						{
							thisItem['content'] = JSON.parse( thisItem['content'] );
						}
						thisItem['content']['showEdit']=false;
						thisItem['content']['showClass']='';
					}
				);

			}
		}




		

		/*
		*
		*   SET THE PARENT AS THE CURRENT STRUCTURE IF NOT A STRUCTURE
		*
		*/
		function setParentCurrent( thisObj ) 
		{   if ((thisObj['component_type_id'] == 6)||(thisObj['component_type_id'] == 7)||(thisObj['component_type_id'] == 8))
			{
				vm.currentStructure = thisObj;

			}else
			{
				vm.cadwolf_worksheet.forEach(
					function(thisItem, index){
						if (thisItem['itemid'] == thisObj['parentid'])
						{   
							vm.currentStructure = thisItem;
						}
					}
				);
			}
		};








		/*
		*
		*   CALL AN ACTION FROM THE LEFT MENU CONTROLLER
		*
		*/
		function leftMenuCaller(thisEvent, actionItem, flag)
		{   
			if ( flag==1 )
			{
				vm.addItem( actionItem, {}, 0 );
			
			}else
			{
				vm.showModal(thisEvent, { 'fileInfo': vm.cadwolf_fileInfo,  
										  'worksheet':vm.cadwolf_worksheet, 
										  'inputEquations':vm.cadwolfInputEquations, 
										  'inputWorkspaces': vm.cadwolfInputWorkspaces }, 
										  actionItem);
			}
		}
		





		/*
		*
		*   MANIPULATION OF THE DOCUMENT
		*
		*   Everything in this section deals with manipulating the document
		*   by adding, deleting, or moving items.
		*
		*/





		/*
		*
		*   ADD AN ITEM TO THE DOCUMENT
		*
		*/
		function addItem(type, objProps, connFlag, sentLocation) 
		{   
			//console.log('In add item with type - '+type+', connFlag - '+connFlag+', and sentLocation - '+sentLocation);
			vm.cadwolf_worksheet = docItemFactory.getLastPos( vm.cadwolf_worksheet );
			var modalType='';
			var thisLoc = docItemFactory.getNewPos( vm.cadwolf_worksheet, 
													vm.currentItem, 
													objProps, 
													connFlag, 
													sentLocation);
			//console.log('I am adding a '+type+' to the document at location '+thisLoc+'.');


			var newTemplate = docItemFactory.newItem(   type, 
														docItemFactory.getID(type, vm.cadwolf_fileInfo.id, vm.cadwolf_worksheet), 
														thisLoc, 
														vm.cadwolf_fileInfo.id, 
														objProps,
														vm.cadwolf_worksheet);

			objProps['itemid']=newTemplate['itemid'];
			if (newTemplate.content.parentid=='None'){ newTemplate.content.parentid="none"; }
			if (newTemplate.content.parentid!='none')
			{
				vm.currentSubItem.itemid = newTemplate.itemid;
			}

			if ( ( type=="Equation" ) || ( type=="Slider" ) || ( type=="Radio" ) || ( type=="Dropdown" ) )
			{
				newTemplate['content']['Equation'] = new docItemFactory.eqPro( objProps, vm.cadwolf_fileInfo.id ); 
				newTemplate['inEdit'] = 1; 
				newTemplate['file_id'] = vm.cadwolf_fileInfo.id; 
				if ( connFlag == 1 )
				{
					newTemplate['content']['isConnectedEquation']=1;
					newTemplate['name'] = objProps['Format_name']; 
				}
			}


			if (type=="2D Plot")
			{ 
				var xAxis = new chartFactory.chartAxisPro( docItemFactory.getID( 'axis', 
																				vm.cadwolf_fileInfo.id, 
																				vm.cadwolf_worksheet), 
																				vm.currentItem.itemid, 
																				{ Axis_num:0, Axis_name:'Axis 0' } 
																			);
				
				var yAxis = new chartFactory.chartAxisPro( docItemFactory.getID( 'axis', 
																				vm.cadwolf_fileInfo.id, 
																				vm.cadwolf_worksheet), 
																				vm.currentItem.itemid, 
																				{ Axis_num:0, Axis_name:'Axis 0' } 
																			);

				newTemplate['content']['Plot'] = new chartFactory.chartPro( objProps, vm.cadwolf_fileInfo.id,  xAxis, yAxis );
				modalType='plot'; 
			}

			if (type=="3D Chart")
			{ 
				newTemplate['content']['Surface'] = new vm.surfaceFactory.surfacePro( objProps, newTemplate['itemid'], vm.cadwolf_fileInfo.id );
				newTemplate = vm.surfaceFactory.initializeSurface( newTemplate, 0 );
				modalType='Surface';
			}
			
			if (type=="Image")
			{ 
				newTemplate['content']['path'] = '/'+Spark.state.user.username;
				modalType='images';
			}
			if (type=="Video")
			{ 
				modalType='video';
			}

			if ( parseInt(connFlag) != 1 )
			{
				vm.cadwolf_worksheet = docItemFactory.incDecPos(	'increment',
																	thisLoc, 
																	vm.cadwolf_worksheet);
			}

			vm.cadwolf_worksheet.push(newTemplate);


			vm.cadwolf_worksheet = docItemFactory.getLastPos( vm.cadwolf_worksheet );
			
			vm.forLoopCounters();
			
			if (newTemplate.content.parentid=='none') { vm.setCurrent(newTemplate); }

			vm.createComponent( newTemplate, connFlag );

			vm.cadwolf_fileInfo.item_data.showEndLoc = vm.cadwolf_worksheet.length;
			vm.cadwolf_fileInfo.item_data.showStartLoc = 0;

			if ((modalType=="video")||(modalType=="Images"))
			{
				vm.showModal( '', vm.currentItem, modalType )
			}
			
			if ((modalType=="plot")||(modalType=="Surface"))
			{
				vm.showPlotEdit( '', vm.currentItem, modalType )
			}
			
			if (type=="Free Body Diagram")
			{
				vm.showModal( '', vm.currentItem, "freeBodyDiagram" )
			}

			//console.log('Added a '+type+' - '+newTemplate['component_type_id']+' with a parents '+newTemplate['content']['parentid']+' - '+newTemplate['content']['topparentid']+' and the new location is '+thisLoc);
			return newTemplate['itemid'];
		};



		/*
		*
		*   HANDLE FOR LOOP COUNTERS WHEN A NEW ONE IS ADDED
		*
		*/
		function forLoopCounters() 
		{   

			vm.cadwolf_worksheet=vm.cadwolf_worksheet.sort(utilityFactory.dynamicSort("order"));
				
			// Find top level for loops and then populate their children
			vm.cadwolf_worksheet.forEach(function(loopItem, index)
			{  
				if ( ( loopItem['component_type_id'] == 6 ) && ( loopItem['content']['parentid'] == 'none' ) )
				{
					loopItem['content']['forLoop']['counter']='a';
					vm.setLoopChildCounters( loopItem['itemid'], 'a' );
				}
			});
		};

		function setLoopChildCounters( thisID, thisCounter )
		{
			// Find children of this loop and 
			vm.cadwolf_worksheet.forEach(function(thisLoopItem, thisIndex)
			{  
				console.log('Looking at '+thisLoopItem['itemid']+' - '+thisLoopItem['component_type_id']+' - '+thisLoopItem['content']['parentid']);
				if ( ( thisLoopItem['component_type_id'] == 6 ) && ( thisLoopItem['content']['parentid'] == thisID ) )
				{
					thisCounter = String.fromCharCode(thisCounter.charCodeAt(0) + 1);
					thisLoopItem['content']['forLoop']['counter']=thisCounter;
					console.log('I set the counter for '+thisLoopItem['itemid']+' to '+thisCounter);
					vm.setLoopChildCounters( thisLoopItem['itemid'], thisCounter );
				}
			});
		};




		/*
		*
		*   REMOVE A COMPONENT FROM THE DOCUMENT
		*
		*/
		function deleteItem( thisObj, connFlag ) 
		{   
			if (connFlag != 1 )
			{   
				if ( thisObj.order != 0 )
				{
					vm.cadwolf_worksheet = docItemFactory.incDecPos(	'decrement',
																		thisObj.order, 
																		vm.cadwolf_worksheet);
				}
			}

			if (thisObj.parentID!="none") { vm.cadwolf_worksheet=docItemFactory.getLastPos(vm.cadwolf_worksheet);  }

			if (thisObj['component_type_id']==3)
			{ 
				vm.cadwolf_worksheet = docItemFactory.populateDeps( thisObj.itemid, vm.cadwolf_worksheet);
				vm.cadwolf_worksheet = docItemFactory.findDependents( thisObj.itemid, 0, vm.cadwolf_worksheet);
			}
			
			vm.cadwolf_worksheet.forEach(function(tempItem, tempIndex)
			{   
				// Delete any children
				//console.log('For item '+tempItem['itemid']+', the parent id is '+tempItem['content']['parentid']+' and the item id is '+thisObj['itemid']);
				if ( tempItem['content']['parentid'] == thisObj['itemid'] )
				{
					vm.deleteItem( tempItem, 0 );  
				}
			});


			vm.cadwolf_worksheet.forEach(function(item1, index1)
			{   
				// Delete this item
				if (item1['itemid']==thisObj['itemid'])
				{   
					if (thisObj['component_type_id']==3)
					{   
						for (var delID in item1['content']['Equation']['connected_ids'])
						{   
							vm.cadwolf_worksheet.forEach(function(item2, index2)
							{
								if (item2['itemid']==delID)
								{
									vm.deleteItem( item2, 1 );  
								} 
							}); 
						}
					}
					vm.cadwolf_worksheet.splice(index1,1); 
					$http({
						method: "DELETE",
						url: window.location.origin+'/components/'+item1['id'],
						data: { 
									connected : connFlag
							  }
					}).then(function successCallback( returnData ) {

					}, function errorCallback( returnData ) {});
				}
			});

			if ( thisObj['content']['parentid'] == 'none' )
			{
				vm.resetCurrent(thisObj['order']);				
			}
			
		};

	   /*
		*
		*   RESET THE CURRENT ITEM AFTER DELETE
		*
		*/
		function resetCurrent( thisLoc ) 
		{   
			vm.cadwolf_worksheet.forEach(function(item1, index1)
			{   
				if (thisLoc==0)
				{
						vm.setCurrent('top');
				}else
				{
					if (item1['order']==thisLoc)
					{
						vm.setCurrent(item1);
					}
				}
			});
		};




		/*
		 *
		 * Checkout a document
		 *
		 */
		function checkOutFile( ) 
		{   
			$http({
				method: "POST",
				url: window.location.origin+'/checkout/'+vm.cadwolf_fileInfo['id'],
			}).then(function successCallback( returnData ) {
				if(returnData.data=="noPerm")
				{
					vm.showMessage( '', { messageType : 'failure', 
										  messageTitle : 'No Permissions', 
										  messageText : 'You do not have permission to check out this file. Ensure that you have not been logged out.'});

				}else if(returnData.data=="noVersion")
					{
						vm.showMessage( '', { messageType : 'failure', 
											  messageTitle : 'Not Latest Version', 
											  messageText : 'This is not the latest version of this file. Only the latest version can be checked out.'});

				}else
				{
					vm.cadwolf_fileInfo['item_data']['checkout_id']=returnData.data['id'];
					vm.cadwolf_fileInfo['item_data']['checkout_name']=returnData.data['name'];
				}
			}, function errorCallback( returnData ) {});
			
		};

		/*
		 *
		 * Checkin a document
		 *
		 */
		function checkInFile( ) 
		{   
			$http({
				method: "POST",
				url: window.location.origin+'/checkin/'+vm.cadwolf_fileInfo['id'],
			}).then(function successCallback( returnData ) {
				if(returnData.data=="noPerm")
				{

				}else
				{
					vm.cadwolf_fileInfo['item_data']['checkout_id']=returnData.data;
					vm.cadwolf_fileInfo['item_data']['checkout_name']='';
				}
			}, function errorCallback( returnData ) {});
			
		};




	   /*
		*
		*   CHANGE THE LOCATION OF AN ITEM
		*
		*/
		function changeLoc( type ) 
		{   
			vm.cadwolf_worksheet=docItemFactory.changeLoc(type, vm.currentItem, vm.cadwolf_worksheet);
			$http({
				method: "POST",
				url: window.location.origin+'/moveComponent',
				data: { 
							id  : vm.currentItem['id'],
							itemid  : vm.currentItem['itemid'],
							file_id : vm.cadwolf_fileInfo['id'],
							type : type
					  }
			}).then(function successCallback( returnData ) {

			}, function errorCallback( returnData ) {});

		};







	   /*
		*
		*   FUNCTIONS RELATING TO THE STRUCTURES
		*   
		*   These functions deal with adding and deleting statement 
		*   blocks on the loops and if else statements.
		*
		*/





		/*
		*
		*   Add a statement to a block on a loop or statement
		*
		*/
		function addStatement ( itemID, type, blockIndex, statementIndex )
		{   
			vm.cadwolf_worksheet.forEach(
				function(thisObj, index)
				{
					if (thisObj['itemid']==itemID)
					{   
						var newStatement=new vm.docItemFactory.statementPro();
						thisObj['content'][type]['statementBlock'][blockIndex].splice( statementIndex+1, 0, newStatement );
					}
				}
			);
		};



		/*
		*
		*   Add a full block to the loop or statement
		*
		*/
		function addBlock ( itemID, type, blockIndex )
		{   
			vm.cadwolf_worksheet.forEach(
				function(thisObj, index)
				{
					if (thisObj['itemid']==itemID)
					{
						var statementBlock=[];
						statementBlock.push( new vm.docItemFactory.statementPro() );
						thisObj['content'][type]['statementBlock'].splice( blockIndex+1, 0, statementBlock );
						thisObj['content'][type]['statementBlock'][blockIndex+1]['blockOption']="||";
					}
				}
			);
		};
		


		/*
		*
		*   Delete a statement from a loop or statement block
		*
		*/
		function deleteStatement ( itemID, type, blockIndex, statementIndex )
		{   
			vm.cadwolf_worksheet.forEach(
				function(thisObj, index)
				{
					if (thisObj['itemid']==itemID)
					{
						thisObj['content'][type]['statementBlock'][blockIndex].splice( statementIndex, 1 );
						
						if ( thisObj['content'][type]['statementBlock'][blockIndex].length==0)
						{   
							thisObj['content'][type]['statementBlock'].splice(blockIndex, 1);	
						}
						
						if ( thisObj['content'][type]['statementBlock'].length==0 )
						{   
							thisObj['content'][type]['statementBlock'][0]=[];
							thisObj['content'][type]['statementBlock'][0].push( new vm.docItemFactory.statementPro() );	
						}
					}
				}
			);
		};






		/*
		*
		*   SOLVING AN EQUATION
		*
		*   There are two functions that handle solving an equation. The
		*   first is a digest. A flag is set for each item on the document.
		*   The digest scans the document in order of location and when it
		*   finds an item whose flag has been set, it calls the web worker
		*   to solve it. Only one item can be solved at a time. A flag
		*   prevents multiple calls to the worker.
		*
		*/






		/*
		*
		*   EQUATION DIGEST
		*
		*/
		function runEquationDigest ()  
		{   console.log('In the equation digest loop with a status of '+vm.digestStatus);
			if (vm.digestStatus==1)
			{   vm.cadwolf_worksheet=vm.cadwolf_worksheet.sort(utilityFactory.dynamicSort("order"));
				for (var a=0; a<vm.cadwolf_worksheet.length; a++)
				{   
					// console.log('For location '+a+', at order '+vm.cadwolf_worksheet[a]['order']+', the type is '+vm.cadwolf_worksheet[a]['component_type_id']+' and the flag is '+vm.cadwolf_worksheet[a]['content']['needsUpdateFlag']);

					if ((vm.cadwolf_worksheet[a]['component_type_id']==3) &&
						(vm.cadwolf_worksheet[a]['content']['needsUpdateFlag']==1))
					{   
						console.log('Calling the solver for '+vm.cadwolf_worksheet[a]['itemid']);
						vm.digestStatus=0;
						vm.cadwolf_worksheet[a]['content']['needsUpdateFlag']=0;
						vm.cadwolf_worksheet[a]['content']['Equation']['inEdit']=1;
						if ((!vm.editPerm) && (vm.cadwolf_worksheet[a]['content']['Equation']['Format_editinuse']==1))
						{
							vm.cadwolf_worksheet[a]['content']['Equation']['newEquation'] = vm.cadwolf_worksheet[a]['content']['Equation']['Format_left']+'='+vm.cadwolf_worksheet[a]['content']['Equation']['Format_right']
						}
						vm.solveEquation(vm.cadwolf_worksheet[a]['itemid'], 'SolveEquation');   
						break
					}


					if (vm.cadwolf_worksheet[a]['component_type_id']==5)
					{   var flag=0;
						for (var b=0; b<vm.cadwolf_worksheet[a]['content']['data'].length; b++)
						{   for (var c=0; c<vm.cadwolf_worksheet[a]['content']['data'][0].length; c++)
							{   console.log('Checking index '+b+'-'+c);
								if (vm.cadwolf_worksheet[a]['content']['data'][b][c]['needsUpdateFlag']==1)
								{   vm.cadwolf_worksheet[a]['solveRow']=b
									vm.cadwolf_worksheet[a]['solveCol']=c
									if (vm.cadwolf_worksheet[a]['content']['data'][b][c]['equation'].match(/^=/)==null)
									{   console.log('Setting index '+b+'-'+c+' to '+vm.cadwolf_worksheet[a]['content']['data'][b][c]['equation']);
										vm.cadwolf_worksheet[a]['content']['data'][b][c]['real']=vm.cadwolf_worksheet[a]['content']['data'][b][c]['equation'];
										vm.digestStatus=1;
									}else
									{   if (utilityFactory.isNumber(vm.cadwolf_worksheet[a]['content']['data'][b][c]['equation'].replace(/^=/,'')))
										{   vm.cadwolf_worksheet[a]['content']['data'][b][c]['real']=parseFloat(vm.cadwolf_worksheet[a]['content']['data'][b][c]['equation'].replace(/^=/,''));
											vm.cadwolf_worksheet[a]['content']['data'][b][c]['needsUpdateFlag']=0;
											console.log('I am updating the dependents on '+String.fromCharCode(65+c)+' - '+b);
											docItemFactory.findDependents(vm.cadwolf_worksheet[a]['itemid']+'.'+String.fromCharCode(65+c)+'.'+b, 0, vm.cadwolf_worksheet);
											flag=1;
											break
										}else
										{   console.log('Solving for index '+b+'-'+c+' with an equation of '+vm.cadwolf_worksheet[a]['content']['data'][b][c]['equation']);
											vm.digestStatus=0;
											vm.solveEquation(vm.cadwolf_worksheet[a]['itemid'], 'SolveTableCell'); 
											flag=1;
											break
										}
									}
								}
							} 
							if (flag==1) { break }
						}
						if (flag==1) { break }
					}

					// Check and update the loop parameters
					if ((vm.cadwolf_worksheet[a]['component_type_id']==6) &&
						(vm.cadwolf_worksheet[a]['content']['needsBlockUpdate']==1) &&
						(vm.digestStatus==1))
					{   vm.digestStatus=0;
						vm.cadwolf_worksheet[a]['content']['forLoop']['firstRun']=1;
						vm.solveEquation(vm.cadwolf_worksheet[a]['itemid'], 'SolveLoopParameters');   
						break
					}

					// Check and update the loop parameters
					if ((vm.cadwolf_worksheet[a]['component_type_id']==7) &&
						(vm.cadwolf_worksheet[a]['content']['needsBlockUpdate']==1) &&
						(vm.digestStatus==1))
					{   vm.digestStatus=0;
						vm.cadwolf_worksheet[a]['content']['whileLoop']['firstRun']=1;
						vm.solveEquation(vm.cadwolf_worksheet[a]['itemid'], 'SolveWhileLoopParameters');  
						break
					}

					// Check and update the if/else parameters
					if ((vm.cadwolf_worksheet[a]['component_type_id']==8) &&
						(vm.cadwolf_worksheet[a]['content']['needsBlockUpdate']==1) &&
						(vm.digestStatus==1))
					{   vm.digestStatus=0;
						vm.solveEquation(vm.cadwolf_worksheet[a]['itemid'], 'SolveIfElseParameters');
						break
					}

					// Check and update the loop structure
					if ((vm.cadwolf_worksheet[a]['component_type_id']==6) && 
						(vm.cadwolf_worksheet[a]['content']['forLoop']['needsUpdateFlag']==1) &&
						(vm.digestStatus==1))
					{
						vm.digestStatus=0;
						vm.cadwolf_worksheet[a]['content']['forLoop']['firstRun']=1;
						vm.solveEquation(vm.cadwolf_worksheet[a]['itemid'], 'SolveStructure');   
						break
					}

					// Check and update the loop structure
					if ((vm.cadwolf_worksheet[a]['component_type_id']==7) && 
						(vm.cadwolf_worksheet[a]['content']['whileLoop']['needsUpdateFlag']==1) &&
						(vm.digestStatus==1))
					{
						vm.digestStatus=0;
						vm.cadwolf_worksheet[a]['content']['whileLoop']['firstRun']=1;
						vm.solveEquation(vm.cadwolf_worksheet[a]['itemid'], 'SolveStructure');   
						break
					}

					// Check and update the lif/else structure
					if ((vm.cadwolf_worksheet[a]['component_type_id']==8) && 
						(vm.cadwolf_worksheet[a]['content']['ifelse']['needsUpdateFlag']==1) &&
						(vm.digestStatus==1))
					{
						vm.digestStatus=0;
						vm.solveEquation(vm.cadwolf_worksheet[a]['itemid'], 'SolveStructure');   
						break
					}

					if ((vm.cadwolf_worksheet[a]['component_type_id']==9)&&(vm.digestStatus==1))
					{   var flag=0;
						for (var thisDataset in vm.cadwolf_worksheet[a]['content']['Plot']['Chart_dataobj'])
						{   
							console.log('For dataset '+thisDataset+', the update flag is '+vm.cadwolf_worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['needsUpdateFlag']);
							if (vm.cadwolf_worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['needsUpdateFlag']==1)
							{   
								console.log('I am updating dataset '+thisDataset+'-'+vm.cadwolf_worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['Format_id']+' on plot '+vm.cadwolf_worksheet[a]['itemid']);
								vm.digestStatus=0;
								vm.cadwolf_worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['needsUpdateFlag']=0; 
								vm.solveEquation(vm.cadwolf_worksheet[a]['itemid'], 'solvePlotData', vm.cadwolf_worksheet[a]['content']['Plot']['Chart_dataobj'][thisDataset]['Format_id']);
								flag=1;
								break
							}
						} 
						if ((flag==0)&&(vm.cadwolf_worksheet[a]['content']['Plot']['needsUpdateFlag']==1))
						{
							vm.cadwolf_worksheet[a]['content']['Plot']['needsUpdateFlag']=0;
							chartFactory.makeChart(vm.cadwolf_worksheet[a], '', vm.cadwolf_worksheet); 
							vm.digestStatus=1;
							
						}
					}
					if (vm.cadwolf_worksheet[a]['component_type_id']==13)
					{   for (var dataIndex in vm.cadwolf_worksheet[a]['content']['Surface']['Chart_dataobj'])
						{   if (vm.cadwolf_worksheet[a]['content']['Surface']['Chart_dataobj'][dataIndex]['needsUpdateFlag']==1)
							{   vm.digestStatus=0;
								vm.cadwolf_worksheet[a]['content']['Surface']['Chart_dataobj'][dataIndex]['needsUpdateFlag']=0; 
								var thisID = vm.cadwolf_worksheet[a]['itemid'];
								var dataID = vm.cadwolf_worksheet[a]['content']['Surface']['Chart_dataobj'][dataIndex]['Format_id'];
								vm.solveEquation( thisID, 'SolveSurfaceData', dataID );
								break
							}
						}  
					}

					// Check the text in the FBDs and see if they need to be updated
					if ((vm.cadwolf_worksheet[a]['component_type_id']==16) &&
						(vm.cadwolf_worksheet[a]['content']['needsUpdateFlag']==1) &&
						(vm.digestStatus==1))
					{   
						vm.reDrawFBD( vm.cadwolf_worksheet[a] );
					}


				}

				for (var a=0; a<vm.cadwolf_worksheet.length; a++)
				{   
					if (vm.cadwolf_worksheet[a]['component_type_id']==15)
					{   
						for (var b=0; b<vm.cadwolf_worksheet.length; b++)
						{   
							if ( vm.cadwolf_worksheet[a]['content']['variableID'] == vm.cadwolf_worksheet[b]['itemid'] )
							{
								vm.cadwolf_worksheet[a]['content']['value'] = vm.cadwolf_worksheet[b]['content']['Equation']['Solution_real'][vm.cadwolf_worksheet[a]['content']['index']];
								vm.cadwolf_worksheet[a]['content']['units'] = vm.cadwolf_worksheet[b]['content']['Equation']['Units_units'];
								vm.cadwolf_worksheet[a]['content']['variable'] = vm.cadwolf_worksheet[b]['content']['Equation']['Format_name'];
							}
						}
					}
				}
				console.log('The digest loop is clean');
			}
		};
  

		/*
		*
		*   SOLVE EQUATION FUNCTION
		*
		*/
		function solveEquation (eqID, eqType, dataID)   
		{   
			console.log('In solve equation with an id of '+eqID+', a type of '+eqType+' and a dataID of '+dataID);
			var thisItem = docItemFactory.getByID(eqID, vm.cadwolf_worksheet);
			if ( vm.cadwolf_fileInfo.item_data.importedCAD === undefined ) { vm.cadwolf_fileInfo.item_data.importedCAD=[]; }
			thisItem.eqObj=docItemFactory.createEqObj(eqID, vm.cadwolf_worksheet);
			var solveObj = docItemFactory.createSolveObj( thisItem, eqType, dataID );
			solveObj['scaleUnits'] = vm.cadwolfScaleUnits;
			solveObj['parseUnits'] = vm.cadwolfParseUnits;
			solveObj['Constants']  = vm.cadwolfConstants;
			solveObj['cadParts']  = vm.cadwolf_fileInfo.item_data.importedCAD;
			solveObj['importedFunctions'] = vm.cadwolf_fileInfo.item_data.impFunctions;
			console.log('I am sending ...');
			console.log(solveObj);
			window.MY_SCOPE.solveObj=solveObj;

			// This section checks to see if there is a python server running locally
			$http({
				method: "POST",
				url: 'https://127.0.0.1:8081',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				data: { testMessage : "Test Message" }
			}).then(function successCallback( returnData ) {
				vm.cadwolf_usePython=true;
				vm.cadwolf_pythonVersion=returnData.data
				$http({
					method: "POST",
					url: 'https://127.0.0.1:8081',
					headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
					data: { params  : solveObj }
				}).then(function successCallback( returnData ) {
						vm.pythonReturn=returnData
						vm.handleSolverReturn(returnData)
				}, 
					function errorCallback( returnData ) {
						equationWorker.postMessage( solveObj );	
				});
			}, function errorCallback( returnData ) {
				vm.cadwolf_usePython=false;
				equationWorker.postMessage( solveObj ); 
			});


		
			
			equationWorker.onerror = function(e) 
			{
				vm.digestStatus=1;
				console.log('Hey, I got an error, but thats cool. Ill just sit over here and eat a sugar packet.'); 
				vm.cadwolf_worksheet.forEach(function(item, index)
				{   
					if (vm.cadwolf_worksheet[index]['component_type_id']==3)
					{   
						vm.cadwolf_worksheet[index]['content']['Equation']['inEdit']=0;
					}
				});

				vm.showMessage( '', { messageType : 'failure', 
									  messageTitle : 'Unknown Error', 
									  messageText : 'There was an error in the solver routine that caused it to fail. Please look at the format of your equations.'});

			};

			equationWorker.onmessage = function(e) { 
				console.log('The message was returned with a type of '+e.data.messageType);
				console.log(e.data);
				MY_SCOPE.eqreturndata=e;
				vm.handleSolverReturn(e)
			}

		}






		/*
		*
		*   HANDLE THE RETURN FROM WEB WORKER OR PYTHON
		*
		*/
		function handleSolverReturn (e)   
		{   
			console.log("In the handle solver return function with a type of "+e.data.messageType)

			vm.cadwolf_worksheet=docItemFactory.eqReturn(e.data, vm.cadwolf_worksheet);	
			
			if (e.data.messageType=="EquationResult")
			{
				vm.addressConnectedEqs(e.data, vm.cadwolf_worksheet);
				vm.cadwolf_worksheet = docItemFactory.populateDeps(e.data.id, vm.cadwolf_worksheet);
				vm.cadwolf_worksheet = docItemFactory.findDependents(e.data.id, 0, vm.cadwolf_worksheet);
				vm.cadwolf_worksheet.forEach(
					function(thisObj, index){
						if (thisObj['itemid']==e.data.id)
						{   
							thisObj.content.Equation['Format_showsolution'] = docItemFactory.createShowSolution( thisObj, vm.cadwolfScaleUnits );
							vm.updateComponent( thisObj );							
						}
					}
				);
			}
			
			if (e.data.messageType=="TableCellResult")
			{
				vm.cadwolf_worksheet = docItemFactory.findDependents(e.data.id, 0, vm.cadwolf_worksheet);
			}
			
			if (e.data.messageType=="PlotDataResults")
			{   
				vm.cadwolf_worksheet.forEach(
					function(thisObj, index){
						if (thisObj['itemid']==e.data.plotID)
						{   
							if (e.data.eventErrorFlag==1)
							{
								thisObj['content']['Plot']['errorFlag']=1;
								thisObj['content']['Plot']['errors']=e.data.eventError;
							}else
							{
								thisObj['content']['Plot']['errorFlag']=0;
								thisObj['content']['Plot']['errors']=[];
								var itemArray=['Chart_dataobj', 'Chart_bandsobj', 'Chart_linesobj', 'Chart_textobj', 'Chart_xaxesobj', 'Chart_yaxesobj'];
								for (var a=0; a<itemArray.length; a++)
								{   
									for (var thisData in thisObj['content']['Plot'][itemArray[a]])
									{   
										if (thisObj['content']['Plot'][itemArray[a]][thisData]['Format_id']==vm.currentChartItemID)
										{
											vm.currentChartItem = thisObj['content']['Plot'][itemArray[a]][thisData];
											vm.currentPoint=vm.currentChartItem['PointData'][vm.pointIndex];
										}
									} 
								}
							}
							vm.updateComponent( thisObj );							
						}
					}
				);
			}

			if (e.data.messageType=="SurfaceData")
			{   
				vm.cadwolf_worksheet.forEach(function(item, index)
				{   
					if (item.itemid==e.data['PlotID'])
					{   
						for (var a = 0; a < item['content']['Surface']['Chart_dataobj'].length; a++)
						{
							if (item['content']['Surface']['Chart_dataobj'][a]['Format_id'] == e.data['DataID'] )
							{
								var dataIndex = a;
							}
						}

						for (var b = 0; b < e.data['dataObject'].length; b++)
						{
							if (e.data['dataObject'][b]['Format_id'] == e.data['DataID'] )
							{
								var returnIndex = b;
							}
						}

						if ((e.data['type']=="surface")||(e.data['type']=="pointCloud"))
						{	
							item['content']['Surface']['Chart_dataobj'][dataIndex]['xLength']=e.data['dataObject'][returnIndex]['xLength'];
							item['content']['Surface']['Chart_dataobj'][dataIndex]['yLength']=e.data['dataObject'][returnIndex]['yLength'];
						
						}else if (e.data['type']=="line") 
						{   
							// item['content']['Surface']['Chart_dataobj'][dataIndex]['lineGeometry']=JSON.parse(JSON.stringify(e.data['dataObject'][returnIndex]['lineGeometry']));
							item = surfaceFactory.setLinePoints( item, e.data['DataID'], e.data['Axis'] );

						}else if (e.data['type']=="lathe")
						{   
							item['content']['Surface']['Chart_dataobj'][dataIndex]['xLength']=e.data['dataObject'][returnIndex]['xLength'];
							item['content']['Surface']['Chart_dataobj'][dataIndex]['yLength']=e.data['dataObject'][returnIndex]['yLength'];
							item['content']['Surface'].formatLatheData(e.data['PlotID'], e.data['DataID']);
						}					
						
						vm.reDrawItem( item, 'all', 1 );
						vm.updateComponent( item );							
					}
				});
			}

			vm.digestStatus=1;			
			// Call to update item here	  
			vm.runEquationDigest();
		};







	   /*
		*
		*   SEPARATE FUNCTION TO ADDRESS RETURNED CONNECTED EQUATIONS
		*
		*/
		function addressConnectedEqs(returnObject, worksheetObj) 
		{   
			MY_SCOPE.returnItem = returnObject;
			var flag=0;
			console.log('There are '+Object.keys(returnObject.connected).length+' connected items in the returned array');
			// Handle the connected equations - If the returned item has connected equations
			if (Object.keys(returnObject.connected).length>0)
			{  
				console.log('There were keys returned');
				worksheetObj.forEach(function(item, index)
				{   
					if (returnObject.id==item['itemid'])
					{
						console.log('match');
						// Loop through all of the existing connected IDs for this equation. Find them in the worksheet,
						// and check their names against the list of names for the newly returned connected items. If one
						// matches, update the data from the new solution.
						for (var existingConn in item['content']['Equation']['connected_ids'])
						{
							flag=0;
							worksheetObj.forEach(function( tempItem, tempIndex )
							{   
								if ( tempItem['itemid']==existingConn )
								{ 
									for ( var returnConn in returnObject.connected )
									{
										if ( returnObject.connected[returnConn] !== undefined )
										{
											if (returnObject.connected[returnConn]['Format_name'] == tempItem['name'] )
											{
												flag=1;
												for (var thisProp in returnObject.connected[returnConn])
												{
													tempItem['content']['Equation'][thisProp] = returnObject.connected[returnConn][thisProp];
												}
												delete returnObject.connected[returnConn];

											}
										}
									}
								} 
							}); 

							// Delete the connected equation if it is not represented in the new result. It is a holdover
							// from a previous solution.
							if (flag==0)
							{
								worksheetObj.forEach(function(tempItem, tempIndex)
								{   
									if (tempItem['itemid']==existingConn) 
									{ 
										vm.deleteItem(tempItem, 1);
									} 
								}); 
							}
						}

						// Whatever items remain in the connected object are new. Add those as new items
						for (var connItem in returnObject.connected)
						{   
							if ( ( returnObject.connected[connItem] !== undefined ) || ( returnObject.connected[connItem] != "undefined" ) )
							{
								var connectedID = vm.addItem('Equation', returnObject.connected[connItem], 1, item['order']) 
								console.log('I should have created '+returnObject.connected[connItem]['Format_name']);
								item['content']['Equation']['connected_ids'][connectedID]=1;

								// vm.cadwolf_worksheet.forEach(function(tempItem, tempIndex)
								// {   
								//	 if (tempItem['itemid']==connectedID) 
								//	 { 
								//		 tempItem['name'] = returnObject.connected[connItem]['Format_name']; 
								//		 tempItem['inEdit'] = 1; 
								//		 tempItem['file_id'] = vm.cadwolf_fileInfo.id; 
								//		 tempItem['Original_id']=returnObject.id;
								//		 tempItem['content']['isConnectedEquation']=1;
								//		 setTimeout(function(){ vm.updateComponent( tempItem ), 3000});
								//	 }
								// }); 

								// console.log('Created a new connected item named '+returnObject.connected[connItem]['Format_name']+' with an id of '+connectedID);
							}
						}   
					}
				});
			}
		}




	   /*
		*
		*   CHECK THE FILE INPUTS AND THE OVERALL COMPONENT NUMBERS
		*   This was done in response to some issues I had with the file inputs. I just check everything at the onset to ensure that
		*   everything is OK
		*/
		function checkInitialData( ) 
		{   
			console.log('In the check initial data function. Making sure no one fakes the funk on a nasty dunk.');
			vm.cadwolf_worksheet.forEach(function(item, index)
			{   
				var flag=0;
				if ( item['component_type_id'] == 3 )
				{
					if ( item['content']['Equation']['inputType'] == 'File' )
					{
						if ( item['dependent_file'] != item['content']['inputFile'] )
						{
							item['dependent_file'] = item['content']['inputFile'];
							flag=1;
						}
						if ( item['dependent_id'] != item['content']['inputID'] )
						{
							item['dependent_id'] = item['content']['inputID'];
							flag=1;
						}
						if ( item['order'] != 0 )
						{
							item['order'] = 0;
							flag=1;
							console.log('Fixing '+item['itemid']);
						}
						if ( flag == 1 )
						{
							vm.updateComponent( item );							
						}
					}
				}
			});

			vm.cadwolf_worksheet=vm.cadwolf_worksheet.sort(utilityFactory.dynamicSort("order"));

			var thisIndex = 0;
			vm.cadwolf_worksheet.forEach(function(item, index)
			{   
				if ( item['order'] != 0 )
				{
					thisIndex = thisIndex+1;
					if ( item['order'] != thisIndex )
					{
						console.log('Resetting the order for '+item['itemid']+' from '+item['order']+' to '+thisIndex);
						item['order'] = thisIndex;
						vm.updateComponent( item );							
					}
				}
			});
		
		}


		/*
		*
		*   Check the python server (from properties window)
		*
		*/
		function checkPython ()   
		{   

			$http({
				method: "POST",
				url: 'https://127.0.0.1:8081',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				data: { testMessage : "Test Message" }
			}).then(function successCallback( returnData ) {
				vm.cadwolf_pythonVersion=returnData.data
				vm.cadwolf_usePython=true;
			}, function errorCallback( returnData ) {
				vm.cadwolf_usePython=false;
				vm.cadwolf_pythonVersion="NA";
			});
		}







		/*
		*
		*   TABLE FUNCTIONS
		*
		*/


	   /*
		*
		*   FILL TABLE UP, DOWN, LEFT, OR RIGHT
		*
		*/
		function fillTable(thisTable, direction) 
		{   
			MY_SCOPE.tableObj=thisTable
			if (thisTable['content']['data'][parseInt(thisTable.content.currentRow)][parseInt(thisTable.content.currentCol)]['equation'].match(/^=/)==null)
			{
				thisTable=docItemFactory.fillTable(thisTable, direction);
			}else
			{   thisTable['content']['direction']=direction;
				docItemFactory.createEqObj( thisTable['itemid'], vm.cadwolf_worksheet ); 
				this.solveEquation( thisTable['itemid'], "SolveTableFill" );
			}
		};

		function addTableRow(tableObj, index)
		{
			tableObj=docItemFactory.addTableRow( tableObj, index );
		}

		function deleteTableRow(tableObj, index)
		{
			tableObj=docItemFactory.deleteTableRow( tableObj, index );
		}

		function addTableColumn(tableObj, index)
		{
			tableObj=docItemFactory.addTableColumn( tableObj, index );
		}

		function deleteTableColumn(tableObj, index)
		{
			tableObj=docItemFactory.deleteTableColumn( tableObj, index );
		}











		/*
		*
		*   CHART FUNCTIONS
		*
		*   There are several functions that handle actions carried out
		*   on a chart. These include adding and deleting items.
		*/


		/*
		*
		*   ADD A CHART ITEM
		*
		*/
		function addChartItem(thisPlot, type)
		{   
			if (type=="dataSeries")
			{   
				vm.currentItem = vm.chartFactory.addDataset( vm.currentItem, vm.cadwolf_fileInfo.id, vm.cadwolf_worksheet );

			}else
			{
				vm.currentItem = vm.chartFactory.addChartItem( vm.currentItem, type, vm.cadwolf_fileInfo.id, vm.cadwolf_worksheet ); 
			}
		};



		/*
		*
		*   DELETE A CHART ITEM
		*
		*/
		function deleteChartItem( currentItem, thisItem )
		{   
			vm.currentItem = vm.chartFactory.deleteChartItem( currentItem, thisItem ); 
		};




		/*
		*
		*   SET THE MONO COLOR
		*
		*/
		function setMonoColor()
		{   
			vm.currentChartItem.solveType='all'; 
			vm.currentItem.content.Plot.needsUpdateFlag=1;
			vm.currentChartItem.needsUpdateFlag=1;
			vm.currentItem = vm.chartFactory.setMonoColor( vm.currentItem, vm.currentChartItem );
			vm.runEquationDigest();
		};

















		/*
		*
		*   SURFACE MAP ITEMS
		*
		*/


		/*
		*
		*   RENDER A SURFACE MAP
		*
		*/
		function renderSurface ( surfaceObj )			 
		{   
			console.log('Rendering '+surfaceObj['itemid']+' to '+surfaceObj.content.renderTo);
			surfaceObj.content.Surface.axisHelper=1;
			if ( surfaceObj.content.renderTo == 'fullSurface' )
			{
				var chartHeight = $(document).height();
				var chartWidth = $(document).width();			
			}else
			{
				var chartHeight = surfaceObj.content.Surface.Props.screen_height;
				var chartWidth = surfaceObj.content.Surface.Props.screen_width;
			}
			surfaceObj.content.Surface.Renderer.setSize(chartWidth, chartHeight);
			surfaceObj.content.Surface.Renderer.setClearColor( 0xFFFFFF, 1 );			 
			surfaceObj.content.Surface.Controls.update();
 //		   surfaceObj = surfaceFactory.setLegend( surfaceObj );
			surfaceObj.content.Surface.Renderer.render( surfaceObj.content.Surface.Scene, surfaceObj.content.Surface.Camera ); 
			if ( surfaceObj.content.renderTo == 'edit' )
			{
				setTimeout(function()
				{
					var container = document.getElementById( 'chartEdit' );		  
					container.appendChild( surfaceObj.content.Surface.Renderer.domElement ); 
				}, 2000);
			
			}else if ( surfaceObj.content.renderTo == 'document' )
			{
				console.log('About to set the setTimeout function');
				setTimeout(function()
				{
					console.log('Setting the container for the ID of '+surfaceObj['itemid']);
					var container = document.getElementById( surfaceObj['itemid'] );		  
					container.appendChild( surfaceObj.content.Surface.Renderer.domElement ); 
					console.log('Finished setting the container');
				}, 2000);
			
			}else if ( surfaceObj.content.renderTo == 'fullSurface' )
			{
				setTimeout(function()
				{
					var container = document.getElementById( 'fullSurfaceBlock' );		  
					container.appendChild( surfaceObj.content.Surface.Renderer.domElement ); 
				}, 1000);
			}

			console.log('Reached the end of the render surface function.');
			return surfaceObj
		};


		/*
		*
		*   START AND STOP ANIMATION OF THE SURFACE
		*
		*/							
		function animate()
		{ 
			cancelAnimationFrame( vm.APLOT ); 
			vm.APLOT=requestAnimationFrame( vm.animate ); 
			vm.currentItem['content']['Surface'].Renderer.render( vm.currentItem['content']['Surface'].Scene, vm.currentItem['content']['Surface'].Camera ); 
			vm.currentItem['content']['Surface'].Controls.update(); 
		};
		
		function cancelAnimation() 
		{
			cancelAnimationFrame( vm.APLOT ); 
		};



		/*
		*
		*   ADD A SURFACE ITEM
		*
		*/
		function addSurfaceItem(type)
		{   
			if (type=="dataSeries")
			{   
				vm.currentItem = vm.surfaceFactory.addSurfaceDataset( vm.cadwolf_fileInfo.id, vm.currentItem, vm.cadwolf_worksheet );
			}
		};





		/*
		*
		*   DELETE A SURFACE ITEM
		*
		*/
		function deleteSurfaceItem(surfaceObj, itemID)
		{   
			console.log('The surface object is ...');
			console.log(surfaceObj);
			surfaceObj = vm.surfaceFactory.removeItem( itemID, surfaceObj );
			surfaceObj = vm.surfaceFactory.deleteSurfaceDataset( surfaceObj, itemID );
			console.log('Calling render surface from deleteSurfaceItem');
			surfaceObj = vm.renderSurface( surfaceObj ); 
			vm.animate( );

			return surfaceObj
		};





		/*
		*
		*   HANDLE A CHANGE TO THE CAMERA PROPERTIES
		*
		*/
		function handleCameraChange()
		{   
			vm.currentItem = vm.surfaceFactory.handleCameraChange( vm.currentItem );
			// vm.currentChartItem.needsUpdateFlag=1;
			// vm.runEquationDigest();
//			vm.reDrawItem( vm.currentItem, 'all', 1 )
			console.log('Calling render surface from the handle camera change function');
			vm.renderSurface( vm.currentItem ); 
		};







		/*
		*
		*   REDRAW THE SURFACE
		*
		*/
		function reDrawItem( surfaceObj, dataID, toRender )	
		{   
			var thisID='';
			if (dataID=='all')
			{   
				for (var dataIndex=0; dataIndex<surfaceObj['content']['Surface']['Chart_dataobj'].length; dataIndex++)				
				{   
					thisID = surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['Format_id'];

					if ((surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['type']=="surface")||
						(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['type']=="pointCloud"))
					{   
						surfaceObj = vm.surfaceFactory.removeItem( thisID, surfaceObj );
						surfaceObj = vm.surfaceFactory.setSurfaceVertices( thisID, surfaceObj );
						surfaceObj = vm.surfaceFactory.setPlotExtremes( surfaceObj );
						surfaceObj = vm.surfaceFactory.setSurfaceColors( thisID, surfaceObj );
						surfaceObj = vm.surfaceFactory.setMeshes( thisID, wireTexture, surfaceObj );
						surfaceObj = vm.surfaceFactory.setPositions( surfaceObj );

					}else if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['type']=="line")	   
					{   
						surfaceObj = vm.surfaceFactory.removeItem( thisID, surfaceObj );
						surfaceObj = vm.surfaceFactory.setPlotExtremes( surfaceObj );
						surfaceObj = vm.surfaceFactory.setLineColors( thisID, surfaceObj );
						surfaceObj = vm.surfaceFactory.setMeshes( thisID, wireTexture, surfaceObj );
						surfaceObj = vm.surfaceFactory.setPositions( surfaceObj );

					}else if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['type']=="lathe")
					{	   
						surfaceObj = vm.surfaceFactory.removeItem( thisID, surfaceObj );
						surfaceObj = vm.surfaceFactory.formatLatheData(thisID, surfaceObj);   
						surfaceObj = vm.surfaceFactory.createShape("Lathe", thisID, surfaceObj);   

					}else 
					{
						surfaceObj = vm.surfaceFactory.removeItem( thisID, surfaceObj );
						surfaceObj = vm.surfaceFactory.createShape(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['type'], thisID, surfaceObj); 
					}

					if (dataIndex==surfaceObj['content']['Surface']['Chart_dataobj'].length-1)
					{   
						console.log('Calling renderSurface from reDrawItem');
						surfaceObj = vm.renderSurface( surfaceObj ); 
						// vm.animate( );
					}
				}
			}else
			{   
				for (var dataIndex=0; dataIndex<surfaceObj['content']['Surface']['Chart_dataobj'].length; dataIndex++)				
				{   
					if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['Format_id']==dataID)
					{   
						if ((surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['type']=="surface")||
							(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['type']=="pointCloud"))
						{   
							surfaceObj = vm.surfaceFactory.removeItem( dataID, surfaceObj );
							surfaceObj = vm.surfaceFactory.setSurfaceVertices( dataID, surfaceObj );
							surfaceObj = vm.surfaceFactory.setPlotExtremes( surfaceObj );
							surfaceObj = vm.surfaceFactory.setSurfaceColors( dataID, surfaceObj );
							surfaceObj = vm.surfaceFactory.setMeshes( dataID, wireTexture, surfaceObj );
							surfaceObj = vm.surfaceFactory.setPositions( surfaceObj );

						}else if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['type']=="line")	   
						{   
							surfaceObj = vm.surfaceFactory.removeItem( dataID, surfaceObj );
							surfaceObj = vm.surfaceFactory.setPlotExtremes( surfaceObj );
							surfaceObj = vm.surfaceFactory.setLineColors( dataID, surfaceObj );
							surfaceObj = vm.surfaceFactory.setMeshes( dataID, wireTexture, surfaceObj );
							surfaceObj = vm.surfaceFactory.setPositions( surfaceObj );

						}else if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['type']=="lathe")
						{	   
							surfaceObj = vm.surfaceFactory.formatLatheData(dataID, surfaceObj);   
							surfaceObj = vm.surfaceFactory.createShape("Lathe", dataID, surfaceObj);   

						}else 
						{ 
							surfaceObj = vm.surfaceFactory.removeItem( dataID, surfaceObj );
							surfaceObj = vm.surfaceFactory.createShape(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['type'], dataID, surfaceObj); 
						} 

						if (toRender == '1') 
						{
							console.log('Calling renderSurface from reDrawItem');
							surfaceObj = vm.renderSurface( surfaceObj ); 
							vm.animate( );
						}
					}
				}
			}
		};








		/*
		 * Create a new component
		 *
		 */
		function createComponent( thisItem, connFlag )
		{   
			$http({
				method: "POST",
				url: window.location.origin+'/components',
				data: { 
							itemid  : thisItem['itemid'],
							file_id : vm.cadwolf_fileInfo['id'],
							order   : thisItem['order'],
							name	: thisItem['name'],
							connected : connFlag, 
							content : JSON.stringify(thisItem['content']),
							component_type_id : thisItem['component_type_id']
					  }
			}).then(function successCallback( returnData ) {


				// If you have lost permission, show a message and change setting
				if ( ( returnData.noPerm == "noPerm" ) || ( returnData.data.noPerm == "noPerm" ) )
				{
					console.log('Permissions are lost. All your base are belong to us.');
					vm.editPerm = false;
					vm.showMessage( '', { messageType : 'failure', 
										  messageTitle : 'Lost Permissions', 
										  messageText : 'It appears that you have lost permission to edit this document. It is likely that you were logged off due to inactivity. Reload the page after you login again.'});

				}



				thisItem['id'] = returnData.data.id;
				vm.cadwolf_worksheet.forEach(function(item, index)
				{  
					if ( item['itemid'] == thisItem['itemid'] )
					{
						item['id']=returnData.data.id;
					} 
				});
				vm.updateService( );
				vm.componentCheck();


			}, function errorCallback( returnData ) {});
		}		







		/*
		 * Call to update an item and then update the service
		 *
		 */
		function updateComponent( thisItem )
		{   
			if (vm.editPerm)
			{
				if (typeof(thisItem)=='object')
				{
					vm.cadwolf_worksheet = docItemFactory.getLastPos( vm.cadwolf_worksheet );
					console.log('Updating the component ...');
					console.log(thisItem);
					if (typeof(thisItem['content'])=='string')
					{
						thisItem['content']=JSON.parse(thisItem['content']);
						console.log('The content was stringified');
					}
					if (thisItem['component_type_id']==13)
					{
						var tempItem = vm.buildSurface( thisItem );
					}else
					{
						var tempItem = thisItem['content'];
					}
					if (thisItem['component_type_id']==3)
					{
						var name=thisItem['content']['Equation']['Format_name'];
						tempItem['Equation']['BaseArray']={A:tempItem['Equation']['Units_base_array']['A'], 
														   K:tempItem['Equation']['Units_base_array']['K'], 
														   cd:tempItem['Equation']['Units_base_array']['cd'], 
														   kg:tempItem['Equation']['Units_base_array']['kg'], 
														   m:tempItem['Equation']['Units_base_array']['m'], 
														   mol:tempItem['Equation']['Units_base_array']['mol'], 
														   molecules:tempItem['Equation']['Units_base_array']['molecules'], 
														   rad:tempItem['Equation']['Units_base_array']['rad'], 
														   s:tempItem['Equation']['Units_base_array']['s']};
					}else
					{
						var name=thisItem['name'];					 
					}
					$http({
						method: "PUT",
						url: window.location.origin+'/components',
						data: { 
									id	  : thisItem['id'],
									itemid  : thisItem['itemid'],
									file_id : vm.cadwolf_fileInfo['id'],
									name	: name,
									content : JSON.stringify(tempItem),
									dependent_file : thisItem['dependent_file'],
									dependent_id : thisItem['dependent_id'],
									order : thisItem['order']
							  }
					}).then(function successCallback( returnData ) {
						
						console.log('Update component call completed');
						

						// If you have lost permission, show a message and change setting
						if ( ( returnData.noPerm == "noPerm" ) || ( returnData.data.noPerm == "noPerm" ) )
						{
							console.log('Permissions are lost. All your base are belong to us.');
							vm.editPerm = false;
							vm.showMessage( '', { messageType : 'failure', 
												  messageTitle : 'Lost Permissions', 
												  messageText : 'It appears that you have lost permission to edit this document. It is likely that you were logged off due to inactivity. Reload the page after you login again.'});

						}


						if (thisItem['component_type_id'] == 3)
						{
							for (var thisConn in thisItem['content']['Equation']['connected_ids'])
							{
								vm.cadwolf_worksheet.forEach(
									function(tempItem, index)
									{
										if (tempItem['itemid']==thisConn)
										{
											vm.updateComponent( tempItem );
										}
									}
								);
							}
						
						}

						if ( (thisItem['component_type_id'] == 6) || (thisItem['component_type_id'] == 7) || (thisItem['component_type_id'] == 8) )
						{
							vm.cadwolf_worksheet.forEach(
								function(sheetItem, index){
									if ( sheetItem['content']['parentid'] == thisItem['itemid'] )
									{
										vm.updateComponent( sheetItem );
									}
								}
							);

						}

					}, function errorCallback( returnData ) {});
					// vm.updateService( );
				}
				console.log('Update component completed');
			}

		}		






		/*
		 * A check to see if the components numbers are matching
		 *
		 */
		function componentCheck( )
		{   
			$http({
				type: "GET",
				url: window.location.origin+'/files/componentCheck/'+vm.cadwolf_fileInfo['id']
			}).then(function successCallback( returnData ) 
			{
				//console.log('The components are ...');
				console.log(returnData);
				vm.cadwolf_worksheet.forEach(
					function(thisItem, index){
						returnData.data.forEach(function(returnComp, returnIndex){
							if ( returnComp['itemid'] == thisItem['itemid'] )
							{
								//console.log('ID - '+returnComp['itemid']+' with orders '+returnComp['order']+' - '+thisItem['order']);
								if ( returnComp['order'] != thisItem['order'] )
								{
									//console.log('I didn\'t match '+returnComp['itemid']+' with '+thisItem['itemid']);
									vm.showMessage( '', { messageType : 'failure', 
														  messageTitle : 'Mismatch Orders', 
														  messageText : 'There was a mismatch in the orders.'});
								}
							}
						}); 
				});
			});
		}












		/*
		 * Build the surface to be saved
		 *
		 */
		function buildSurface( thisItem )
		{   
			var returnItem = {};
			returnItem['content']={};
			returnItem['content']['itemid']=thisItem['content']['itemid'];
			returnItem['content']['id']=thisItem['content']['id'];
			returnItem['content']['Name']=thisItem['content']['Name'];
			returnItem['content']['created']=thisItem['content']['created'];
			returnItem['content']['modified']=thisItem['content']['modified'];
			returnItem['content']['fileid']=thisItem['content']['fileid'];
			returnItem['content']['inputFile']=thisItem['content']['inputFile'];
			returnItem['content']['inputID']=thisItem['content']['inputID'];
			returnItem['content']['Page_lastposition']=thisItem['content']['Page_lastposition'];
			returnItem['content']['width']=thisItem['content']['width'];
			returnItem['content']['marginbottom']=thisItem['content']['marginbottom'];
			returnItem['content']['marginleft']=thisItem['content']['marginleft'];
			returnItem['content']['marginright']=thisItem['content']['marinright'];
			returnItem['content']['margintop']=thisItem['content']['margintop'];
			returnItem['content']['alignment']=thisItem['content']['alignment'];
			returnItem['content']['parentid']=thisItem['content']['parentid'];
			returnItem['content']['topparentid']=thisItem['content']['topparentid'];
			returnItem['content']['component_type_id']=thisItem['content']['component_type_id'];
			returnItem['content']['active']=thisItem['content']['active'];
			returnItem['content']['references']=thisItem['content']['references'];
			returnItem['content']['renderTo']='document';
			returnItem['content']['Surface'] = {}; 
			returnItem['content']['Surface']['Chart_dataobj'] = thisItem['content']['Surface']['Chart_dataobj']; 
			returnItem['content']['Surface']['Chart_height'] = thisItem['content']['Surface']['Chart_height']; 
			returnItem['content']['Surface']['Chart_width'] = thisItem['content']['Surface']['Chart_width']; 
			returnItem['content']['Surface']['Chart_type'] = thisItem['content']['Surface']['Chart_type']; 
			returnItem['content']['Surface']['Planes'] = thisItem['content']['Surface']['Planes']; 
			returnItem['content']['Surface']['Props'] = thisItem['content']['Surface']['Props']; 
			returnItem['content']['Surface']['itemid'] = thisItem['content']['Surface']['itemid']; 
			return returnItem['content'];
		}		



		/*
		 * Update the service from the controller
		 *
		 */
		function updateService( )
		{   
			console.log('Updating the service' );
			documentMemoryFactory.worksheet = vm.cadwolf_worksheet;
			documentMemoryFactory.fileInfo = vm.cadwolf_fileInfo; 
			documentMemoryFactory.currentURL = window.location.href.replace(/\~2F/g,'/');
		}		



		/*
		 *
		 * Save the file and update the components
		 *
		 * @param - flag - Whether or not to save the components
		 *
		 */
		function saveFile( flag )
		{   
			console.log('In the save file function');

			if (vm.editPerm)
			{

				// Ensure that the connected items are in sync in case the names
				// of any connected variables were changed
				vm.syncConnected();


				// Update the database with the latest versions in edit
				vm.updateComponent( vm.currentItem );
				$http({
					method: "PUT",
					url: window.location.origin+'/files/'+vm.cadwolf_fileInfo['id'],
					data: { name : vm.cadwolf_fileInfo['name'],
							parent_id : parseInt(vm.cadwolf_fileInfo['parent_id'], 10),
							item_data : vm.cadwolf_fileInfo['item_data']
						  }
				}).then(function successCallback( returnData ) 
				{
					if ( flag == 1 )
					{
						vm.saveComponents( );
					}

				}, function errorCallback( returnData ) {});


				// If this file is connected to Autocad Variables, send them.
				vm.sendAutocadVars();

			}
		}

		function saveComponents( )
		{   
			console.log('In the save components function');

			$http({
				method: "PUT",
				url: window.location.origin+'/saveDocument/'+vm.cadwolf_fileInfo['id']
			}).then(function successCallback( returnData ) {
				vm.showMessage( '', { messageType : 'success', 
									  messageTitle : 'File Saved', 
									  messageText : 'The file was successfully saved. You can continue editing it or check it in.'});
			}, function errorCallback( returnData ) {});
		}









		/*
		 *
		 *  Prior to saving, ensure that connected variables are in
		 *  sync in case the name of a connected variable changed
		 *
		 *
		 */
		function syncConnected( )
		{

			vm.cadwolf_worksheet.forEach(
				function(sheetItem, sheetIndex){

					vm.connectedFiles.forEach(
						function(connItem, connIndex){

							connItem.info.equations.forEach(
								function(eqItem, eqIndex){

									if ( sheetItem.id == eqItem.eq_id )
									{
										eqItem.eq_name = sheetItem.name;
									}
								}
							);

						}
					);

				}
			);


		}






		/*
		 *
		 * Open the dialog to send autocad variables
		 *
		 */
		function sendAutocadVars( )
		{

			console.log('In the send autocad vars function');

			// Flag that turns on the notification that the variables are being sent to Autocad
			vm.sendingAutocad = true;


			// Prep the strings that will hold the data sent to Fusion. Data can be sent for multiplt
			// files. File data is separated by  pound signs. This is done because arrays couldn't be
			// sent, so I sent strings that are parsed with Fusion's API.
			var h = '';			// String holding the hub data
			var p = '';			// String holding the project data
			var r = '';			// String holding the root folder
			var FIDs = ''; 		// String holding the IDs of the files
			var folds = "";		// String holding the Folder path for each file
			var flag = 0;		// Flag for first entry
			var eqNames = '';	// Names of the equations
			var eqValues = '';	// Values of the equations
			var fusionFlag = 0; // Whether or not we got a fusion connect



			vm.connectedFiles.forEach(
				function(thisConn, index)
				{

					if ( thisConn.cad_type == 'fusion' )
					{

						fusionFlag = 1;

						// First, remove any old links
						if ( document.getElementById("fusionLink") !== null )
						{
							document.getElementById("fusionLink").remove();
						}


						// Set the file data
						if ( flag == 0 )
						{
							h = thisConn.info.cad_data.hubData.attributes.name;
							p = thisConn.info.cad_data.projectData.attributes.name;
							r = thisConn.info.cad_data.rootFolder;
							FIDs = thisConn.info.cad_data.file;
							folds = "";
						}else
						{
							h = h+'**'+thisConn.info.cad_data.hubData.attributes.name;
							p = p+'**'+thisConn.info.cad_data.projectData.attributes.name;
							r = r+'**'+thisConn.info.cad_data.rootFolder;
							FIDs = FIDs+'**'+thisConn.info.cad_data.file;
							folds = folds+'**';
						}

						for (var a=0; a<thisConn.info.cad_data.folders.length; a++)
						{
							if ( a == 0 )
							{
								if ( thisConn.info.cad_data.folders[a] !== null )
								{
									folds = folds+""+thisConn.info.cad_data.folders[a];
								}

							}else
							{
								if ( thisConn.info.cad_data.folders[a] !== null )
								{
									folds = folds+","+thisConn.info.cad_data.folders[a];
								}
							}
						}


						if ( flag == 1 )
						{
							eqNames = eqNames+'**';
							eqValues = eqValues+'**';
						}else
						{
							flag = 1;
						}

						thisConn.info.equations.forEach(
							function(thisEq, index2){

								if ( index2 == 0 )
								{
									eqNames = eqNames+''+thisEq.eq_name;
								}else
								{
									eqNames = eqNames+','+thisEq.eq_name;
								}

								vm.cadwolf_worksheet.forEach(
									function(sheetEq, index3){

										if ( sheetEq.component_type_id == 3)
										{
											if ( sheetEq.name == thisEq.eq_name )
											{
												if ( index2 == 0 )
												{
													eqValues = eqValues+''+sheetEq.content.Equation.Solution_real['0-0']+' '+sheetEq.content.Equation.Units_units;
												}else
												{
													eqValues = eqValues+','+sheetEq.content.Equation.Solution_real['0-0']+' '+sheetEq.content.Equation.Units_units;
												}

											}
										}
									}
								);

							}
						);						

					}
				}
			);


			// Turn off Autocad Flag
			vm.sendingAutocad = false;



			if ( fusionFlag == 1 )
			{
				var link=document.createElement("a");
				link.id = 'fusionLink'; 
				link.href='fusion360://command=open&properties={"hub":"'+h+'","project":"'+p+'","root":"'+r+'","folders":"'+folds+'","file":"'+FIDs+'","eqNames":"'+eqNames+'","eqValues":"'+eqValues+'"}';

				console.log(link.href);
				
				document.getElementById("fusionLinkArea").appendChild(link);

				document.getElementById('fusionLink').click();

			}
		}




		/*
		 *
		 * Get and check the onShape and autocad items to see if they are linked to this document
		 *
		 */
		function downloadConnected( )
		{

			console.log('I am in the downloadConnected function');

			$http({
				method: "GET",
				url: window.location.origin+'/getConnected/'+vm.cadwolf_fileInfo.id,
				params: { }
			}).then(function successCallback( returnData )
			{
				console.log(returnData);
				vm.connectedFiles = returnData.data.data;
				for (var a=0; a<vm.connectedFiles.length; a++)
				{
					vm.connectedFiles[a]['info'] = JSON.parse(vm.connectedFiles[a]['info']);
					if ( vm.connectedFiles[a]['cad_type'] == "fusion" )
					{
						if ( typeof(vm.connectedFiles[a]['info']['cad_data']) == "string" )
						{
							vm.connectedFiles[a]['info']['cad_data'] = JSON.parse(vm.connectedFiles[a]['info']['cad_data']);
						}
					}
				}
				if ( vm.cadFiles !== undefined )
				{
					for (var a=0; a<vm.cadFiles.length; a++)
					{
						vm.cadFiles[a]['isConn']=0;
						for (var b=0; b<vm.connectedFiles.length; b++)
						{
							if ( vm.cadFiles[a]['id'] == vm.connectedFiles[b]['info']['cad_data']['id'] )
							{
								vm.cadFiles[a]['isConn'] = 1;
							}
						}
					}
				}

			});
		}



		/*
		*
		*
		*   EVERYTHING THAT IS BELOW THIS POINT IS JUST THE VIEW POPUPS
		*
		*
		*/

		function cancel(){
			$mdDialog.cancel();
		};

		function cancelPlot(){
			$mdDialog.cancel();
			vm.currentItem.content.renderTo = 'standard';
			vm.currentItem.content.Plot.needsUpdateFlag = 1;
		};

		function cancelSurface(){
			$mdDialog.cancel();
			vm.currentItem.content.Surface.needsUpdateFlag = 1;
			vm.currentItem.content.renderTo = 'document';
			console.log('Calling renderSurface from cancelSurface');
			vm.setCurrent( vm.currentItem );
			vm.renderSurface( vm.currentItem ); 
		};



		function showPlotEdit( ev, thisType ) 
		{
			vm.currentItem['content']['renderTo']='edit';

			if (( thisType == 'Surface' ) || ( thisType == 'surface' ) || ( thisType == 'line' ))
			{
				vm.currentItem['content']['Surface']['needsUpdateFlag']=1;
				var thisTemplate = 'app/main/apps/document/worksheet/views/templates/surfaceDialog.tmpl.html';
			}else
			{
				vm.currentItem['content']['Plot']['needsUpdateFlag']=1;
				var thisTemplate = 'app/main/apps/document/worksheet/views/templates/plotDialog.tmpl.html';				
			}
			$mdDialog.show({
				templateUrl: thisTemplate,
				controller: function(){ return vm },
				controllerAs: 'vm',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
				vm.selectedRef=data;
				// Call to server to update the references
			}, function() {
				
			});
		};




		function showFullChart( ev ) 
		{
			$mdDialog.show({
				templateUrl: 'app/main/apps/document/worksheet/views/templates/fullPlotDialog.tmpl.html',
				controller: function(){ return vm },
				controllerAs: 'vm',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
				vm.selectedRef=data;
				// Call to server to update the references
			}, function() {
				
			});
		};



		function showFullSurface( ev ) 
		{
			$mdDialog.show({
				templateUrl: 'app/main/apps/document/worksheet/views/templates/fullSurfaceDialog.tmpl.html',
				controller: function(){ return vm },
				controllerAs: 'vm',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
				// Call to server to update the references
			}, function() {
				
			});
		};




		function showStructure( ev ) 
		{
			vm.forLoopCounters();

			$mdDialog.show({
				templateUrl: 'app/main/apps/document/worksheet/views/templates/structureDialogs.html',
				controller: function(){ return vm },
				controllerAs: 'vm',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
				
				// Call to server to update the references
			}, function() {
				
			});
		};



		function showModal(ev, thisItem, modalType) 
		{
			console.log('The modal type for the large modal is '+modalType);
			console.log(thisItem);
			if ( vm.cadwolf_fileInfo.item_data.importedCAD === undefined ){ vm.cadwolf_fileInfo.item_data.importedCAD = []; }
			if ((modalType=='Edit Title')&&(vm.selected.item_data.checkout_id!=Spark.state.user.id))
			{
				vm.showMessage('', {"messageType":"failure", 
									"messageText":"You must have the document checked out to change its name"}); 

			}else
			{
				$mdDialog.show({
					controller: 'DocumentDialogController',
					templateUrl: 'app/main/apps/document/worksheet/views/templates/modalTemplates.html',
					locals:{
						thisItem:thisItem,
						file_id : vm.cadwolf_fileInfo.id,
						worksheet : vm.cadwolf_worksheet,
						editPerm : vm.editPerm,
						viewPerm : vm.viewPerm,
						permissions : vm.cadwolf_permissions,
						fileInfo : vm.cadwolf_fileInfo,
						cadwolfScaleUnits : vm.cadwolfScaleUnits,
						cadwolfParseUnits : vm.cadwolfParseUnits,
						cadwolfConstants  : vm.cadwolfConstants,
						cadwolf_usePython  : vm.cadwolf_usePython,
						pythonVersion  : vm.cadwolf_pythonVersion,
						comments : vm.comments,
						forums : vm.forums,
						Spark  : Spark,
						modalType:modalType
					},
					controllerAs: 'vm',
					parent: angular.element(document.body),
					targetEvent: ev,
					clickOutsideToClose:true,
					fullscreen: true
				})
				.then(function(data) {
					console.log('The modal type is '+modalType);
					console.log('The return data is ...');
					console.log(data);

					if ( modalType == 'Link to CAD' )
					{
						console.log('I should be calling the update CAD');
						vm.updateCADItems();
						vm.downloadConnected();						
					}


					if (modalType=='images')
					{
						vm.thisItem;
					}

					if (modalType=="freeBodyDiagram")
					{
						vm.reDrawFBD( data );
						vm.updateComponent( thisItem );
					}

					// vm.viewPerm=returnData['data']['permissions']['view']==1||false;
					// vm.editPerm=(returnData['data']['permissions']['edit']==1||false) &&
					//							 (Spark.state.user.id==vm.cadwolf_fileInfo.item_data.checkout_id);

					if ((modalType=='bibEdit')||(modalType=='refEdit'))
					{
						vm.saveFile( 0 );
					}

					if ( modalType == 'Properties' )
					{
						vm.calcWidth = parseInt(vm.cadwolf_fileInfo.item_data.docWidth)+(2*(parseInt(vm.cadwolf_fileInfo.item_data.docMargin)+2));
						if ( parseInt(data['version']) > 0 )
						{
							vm.loadVersion(parseInt(data['version']), parseInt(data['revision']));
						}

						// If the file has been checked out or checked in, reload it
						if ( ( vm.cadwolf_fileInfo['item_data']['checkout_id'] == Spark.state.user.id  &&
							  vm.cadwolf_permissions.edit == 0 ) || 
							( vm.cadwolf_fileInfo['item_data']['checkout_id'] == 0  &&
							  vm.cadwolf_permissions.edit == 1 ) )
						{
							vm.initialize();
						}
					}


				}, function() {
					
				});
			}
		};


		function showSmallModal(ev, thisItem, modalType) 
		{
			console.log('The modal type for the small modal is '+modalType);
			$mdDialog.show({
				controller: 'DocumentDialogController',
				templateUrl: 'app/main/apps/document/worksheet/views/templates/smallModalTemplates.html',
				locals:{
					thisItem:thisItem,
					file_id : vm.cadwolf_fileInfo.id,
					worksheet : vm.cadwolf_worksheet,
					editPerm : vm.editPerm,
					viewPerm : vm.viewPerm,
					permissions : vm.cadwolf_permissions,
					fileInfo : vm.cadwolf_fileInfo,
					Spark : Spark,
					modalType:modalType
				},
				controllerAs: 'vm',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {
				console.log('The modal type is '+modalType);
				vm.returnData = data;
				// Call to server to update the references
			}, function() {
				
			});
		};





		function showMessage(ev, messageObj) 
		{
			console.log('In the show message function');

			if (messageObj.messageType=="success")
			{
				var templateURL = 'app/main/apps/document/worksheet/views/templates/successMessage.tmpl.html';
			}
			if (messageObj.messageType=="failure")
			{
				var templateURL = 'app/main/apps/document/worksheet/views/templates/failureMessage.tmpl.html';
			}

			$mdDialog.show({
				controller: 'DocumentDialogController',
				templateUrl: templateURL,
				locals:{
					messageObj:messageObj,
					Spark: Spark
				},
				controllerAs: 'vm',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: true
			})
			.then(function(data) {}, function() { });
		};








		/*
		 *
		 * Called from the properties window, this function loads whatever version the user wants into the browser
		 *
		 */
		function loadVersion( verNum, revNum )
		{   
			console.log('In load version with version and revision of '+verNum+'.'+revNum);
			vm.initialize( verNum, revNum );
		}		








		/*
		 *
		 * This function is called to update any item that has CAD imported
		 *
		 */
		function updateCADItems( )
		{   
			console.log('In the update CAD items function'); 

			vm.cadwolf_fileInfo.item_data.importedCAD.forEach(
				function(cadItem, cadIndex){

					vm.cadwolf_worksheet.forEach(
						function(sheetItem, sheetIndex){

							if ( sheetItem.component_type_id == 3 )
							{
								if ( sheetItem.content.Equation.Format_equation.match( cadItem.eqname+'.' ) !== null )
								{
									if ( sheetItem.content.Equation.Format_equation.match( cadItem.eqname+'.' ).length > 0 )
									{
										console.log('I should be marking ...');
										console.log(sheetItem);
										sheetItem.content.needsUpdateFlag = 1;
									}
								}
							}
						}
					);
				}
			);

			vm.runEquationDigest();

		}		






		/*
		 *
		 * Make an item a favorite
		 *
		 */
		function favoriteItem( ) 
		{   
			if (Spark.state!=undefined)
			{
				Spark.state.user.user_info = utilityFactory.favoriteItem( 'Document', 
																		  vm.cadwolf_fileInfo, 
																		  Spark.state.user.user_info, 
																		  window.location.pathname.replace(/^\/Document\//,'') ); 
				console.log('The item returned from the factory is '+Spark.state.user.user_info);
				vm.cadwolf_fileInfo.favorite=!vm.cadwolf_fileInfo.favorite; 
				vm.updateUserInfo();
			}
		};




		/*
		 *
		 * Remove a favorite
		 *
		 */
		function removeFavItem( thisItem ) 
		{   
			Spark.state.user.user_info = utilityFactory.favoriteItem( 'Document', 
																	  thisItem, 
																	  Spark.state.user.user_info, 
																	  window.location.pathname.replace(/^\/Document\//,'') ); 
			vm.updateUserInfo();
		};






		/*
		 *
		 * Re evaluate all of mathjax - not used as I found that the problem was that a file wasn't downloaded
		 *
		 */
		function doMathJax( ) 
		{   
			console.log('In the do mathjax');

			vm.cadwolf_worksheet.forEach(
				function(thisObj, index){
					if ( thisObj['component_type_id'] == 3 )
					{   
						thisObj.content.Equation['Format_showsolution'] = docItemFactory.createShowSolution( thisObj, vm.cadwolfScaleUnits );
					}
				}
			);


		};







		/*
		 *
		 * Update User Info
		 *
		 */
		function updateUserInfo( ) 
		{   
			$http({
				method: 'PUT',
				url: window.location.origin+'/updateUserInfo',
				data:{ userID : Spark.state.user.id, thisUser : Spark.state.user.user_info }
			}).then(function successCallback( returnData ) {
			}, function errorCallback( returnData ) {});
		};


		/**
		 *
		 * Navigate to a given URL
		 *
		 */
		function goToURL( thisURL )
		{
			$location.path(thisURL);
		}



		/**
		*
		* Navigate to the parent folder
		*
		*/
		function navigateToParent( )
		{
			var tempArr=window.location.href.replace(window.location.origin+'','').replace(/^\/Document/, '\/Workspace').replace(/^\//,'').replace(/\/$/,'').split('/');
			var newString='';
			for (var a=0; a<tempArr.length-1; a++)
			{
				newString=newString+tempArr[a]+"/";
			}
			newString="/"+newString;
			$location.path(newString);
		}


		/**
		*
		* Utility function for repeats
		*
		*/
		function makeArray( num )
		{
			var x=new Array(); 
			for(var i=0;i<num;i++){ x.push(i+1); } 
			return x; 
		}





		/*
		 *
		 * Draw a free body diagram
		 *
		 */
		function reDrawFBD( thisItem ) 
		{   
			console.log('In the draw fbd with ...');
			console.log(thisItem);

			var checkExist = setInterval(function() {

				if ($('#canvas'+thisItem.itemid).length) {
    				console.log("Exists!");
			      clearInterval(checkExist);
			    }

				var myCanvas = document.getElementById( "canvas"+thisItem.itemid );
				var ctx = myCanvas.getContext('2d');
				ctx.clearRect(0, 0, thisItem.content.width, thisItem.content.height);

				thisItem.content.drawing.forEach(
					function(thisDraw, index){

						thisDraw.x1_Formatted = thisDraw.x1+'';
						thisDraw.y1_Formatted = thisDraw.y1+'';
						thisDraw.x2_Formatted = thisDraw.x2+'';
						thisDraw.y2_Formatted = thisDraw.y2+'';
						thisDraw.x3_Formatted = thisDraw.x3+'';
						thisDraw.y3_Formatted = thisDraw.y3+'';
						thisDraw.x4_Formatted = thisDraw.x4+'';
						thisDraw.y4_Formatted = thisDraw.y4+'';
						thisDraw.x5_Formatted = thisDraw.x5+'';
						thisDraw.y5_Formatted = thisDraw.y5+'';
						thisDraw.x6_Formatted = thisDraw.x6+'';
						thisDraw.y6_Formatted = thisDraw.y6+'';
						thisDraw.colorStops_Formatted = thisDraw.colorStops;
						thisDraw.startAngle_Formatted = thisDraw.startAngle+'';
						thisDraw.endAngle_Formatted = thisDraw.endAngle+'';
						thisDraw.arcRadius_Formatted = thisDraw.arcRadius+'';
						thisDraw.arrowHeadHeight_Formatted = thisDraw.arrowHeadHeight+'';
						thisDraw.arrowHeadWidth_Formatted = thisDraw.arrowHeadWidth+'';
						thisDraw.text_Formatted = thisDraw.text;

						vm.cadwolf_worksheet.forEach(
							function(thisEq, index2){
								var re = new RegExp('#'+thisEq.name, 'g');
								if ( thisDraw.text_Formatted.match( re ) )
								{
									thisDraw.text_Formatted = thisDraw.text_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
								}
								if ( thisDraw.x1_Formatted.match( re ) )
								{
									thisDraw.x1_Formatted = thisDraw.x1_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
								}
								if ( thisDraw.y1_Formatted.match( re ) )
								{
									thisDraw.y1_Formatted = thisDraw.y1_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
								}
								if ( thisDraw.x2_Formatted.match( re ) )
								{
									thisDraw.x2_Formatted = thisDraw.x2_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
								}
								if ( thisDraw.y2_Formatted.match( re ) )
								{
									thisDraw.y2_Formatted = thisDraw.y2_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
								}
								if ( thisDraw.x3_Formatted.match( re ) )
								{
									thisDraw.x3_Formatted = thisDraw.x3_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
								}
								if ( thisDraw.y3_Formatted.match( re ) )
								{
									thisDraw.y3_Formatted = thisDraw.y3_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
								}
								if ( thisDraw.x4_Formatted.match( re ) )
								{
									thisDraw.x4_Formatted = thisDraw.x4_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
								}
								if ( thisDraw.y4_Formatted.match( re ) )
								{
									thisDraw.y4_Formatted = thisDraw.y4_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
								}
								if ( thisDraw.x5_Formatted.match( re ) )
								{
									thisDraw.x5_Formatted = thisDraw.x5_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
								}
								if ( thisDraw.y5_Formatted.match( re ) )
								{
									thisDraw.y5_Formatted = thisDraw.y5_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
								}
								if ( thisDraw.x6_Formatted.match( re ) )
								{
									thisDraw.x6_Formatted = thisDraw.x6_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
								}
								if ( thisDraw.y6_Formatted.match( re ) )
								{
									thisDraw.y6_Formatted = thisDraw.y6_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
								}
								if ( thisDraw.colorStops_Formatted.match( re ) )
								{
									thisDraw.colorStops_Formatted = thisDraw.colorStops_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
								}
								if ( thisDraw.startAngle_Formatted.match( re ) )
								{
									thisDraw.startAngle_Formatted = thisDraw.startAngle_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
								}
								if ( thisDraw.endAngle_Formatted.match( re ) )
								{
									thisDraw.endAngle_Formatted = thisDraw.endAngle_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
								}
								if ( thisDraw.arcRadius_Formatted.match( re ) )
								{
									thisDraw.arcRadius_Formatted = thisDraw.arcRadius_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
								}
								if ( thisDraw.arrowHeadHeight_Formatted.match( re ) )
								{
									thisDraw.arrowHeadHeight_Formatted = thisDraw.arrowHeadHeight_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
								}
								if ( thisDraw.arrowHeadWidth_Formatted.match( re ) )
								{
									thisDraw.arrowHeadWidth_Formatted = thisDraw.arrowHeadWidth_Formatted.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
								}

							}
						);

						thisDraw.x1_Formatted = eval(thisDraw.x1_Formatted);
						thisDraw.y1_Formatted = eval(thisDraw.y1_Formatted);
						thisDraw.x2_Formatted = eval(thisDraw.x2_Formatted);
						thisDraw.y2_Formatted = eval(thisDraw.y2_Formatted);
						thisDraw.x3_Formatted = eval(thisDraw.x3_Formatted);
						thisDraw.y3_Formatted = eval(thisDraw.y3_Formatted);
						thisDraw.x4_Formatted = eval(thisDraw.x4_Formatted);
						thisDraw.y4_Formatted = eval(thisDraw.y4_Formatted);
						thisDraw.x5_Formatted = eval(thisDraw.x5_Formatted);
						thisDraw.y5_Formatted = eval(thisDraw.y5_Formatted);
						thisDraw.x6_Formatted = eval(thisDraw.x6_Formatted);
						thisDraw.y6_Formatted = eval(thisDraw.y6_Formatted);
						thisDraw.startAngle_Formatted = eval(thisDraw.startAngle_Formatted);
						thisDraw.endAngle_Formatted = eval(thisDraw.endAngle_Formatted);
						thisDraw.arcRadius_Formatted = eval(thisDraw.arcRadius_Formatted);
						thisDraw.arrowHeadHeight_Formatted = eval(thisDraw.arrowHeadHeight_Formatted);
						thisDraw.arrowHeadWidth_Formatted = eval(thisDraw.arrowHeadWidth_Formatted);


					}	
				);

				thisItem.content.drawing.forEach(
					function(thisDraw, index){

						// Set the global alpha for this drawing
						ctx.globalAlpha = thisDraw.transparency;

						// Draw the line(s)
						if ( thisDraw.drawType == 'line' )
						{
							ctx.lineWidth=thisDraw.lineWidth;
							ctx.lineCap=thisDraw.lineCap;
							if (thisDraw.dashed)
							{
								ctx.setLineDash(thisDraw.lineDash.split(','));
								ctx.lineDashOffset = thisDraw.dashOffset;
							}
							ctx.beginPath();
							ctx.moveTo(thisDraw.x1_Formatted, thisDraw.y1_Formatted);
							ctx.lineTo(thisDraw.x2_Formatted, thisDraw.y2_Formatted);
							ctx.strokeStyle=thisDraw.fillColor;
							ctx.stroke();

							ctx.setLineDash([0,0]);
							ctx.lineDashOffset = 0;

						}


						// Draw the rectangle(s)
						if ( thisDraw.drawType == 'rectangle' )
						{
							ctx.lineWidth=thisDraw.lineWidth;
							ctx.strokeStyle=thisDraw.fillColor;
							ctx.beginPath();
							if ( thisDraw.cleared )
							{
								ctx.clearRect(thisDraw.x1_Formatted, thisDraw.y1_Formatted, thisDraw.x2_Formatted, thisDraw.y2_Formatted);
							}else
							{
								if ( thisDraw.filled )
								{
									ctx.fillStyle=thisDraw.fillColor;
									ctx.fillRect(thisDraw.x1_Formatted, thisDraw.y1_Formatted, thisDraw.x2_Formatted, thisDraw.y2_Formatted);
								}else
								{
									ctx.strokeStyle=thisDraw.fillColor;
									ctx.strokeRect(thisDraw.x_Formatted, thisDraw.y1_Formatted, thisDraw.x2_Formatted, thisDraw.y2_Formatted);
								}
							}
						}

						if ( thisDraw.drawType == 'triangle' )
						{
							ctx.lineWidth=thisDraw.lineWidth;
							ctx.strokeStyle=thisDraw.fillColor;
							ctx.beginPath();
							ctx.moveTo(thisDraw.x1_Formatted, thisDraw.y1_Formatted);
							ctx.lineTo(thisDraw.x2_Formatted, thisDraw.y2_Formatted);
							ctx.lineTo(thisDraw.x3_Formatted, thisDraw.y3_Formatted);
							ctx.lineTo(thisDraw.x1_Formatted, thisDraw.y1_Formatted);
							if ( thisDraw.filled )
							{
								ctx.fillStyle=thisDraw.fillColor;
								ctx.fill();
							}else
							{
								ctx.strokeStyle=thisDraw.fillColor;
								ctx.stroke();
							}
						}


						if ( thisDraw.drawType == 'arc1' )
						{
							ctx.lineWidth=thisDraw.lineWidth;
							ctx.strokeStyle=thisDraw.fillColor;
							ctx.beginPath();
							ctx.arc(thisDraw.x1_Formatted, thisDraw.y1_Formatted, thisDraw.arcRadius_Formatted, thisDraw.startAngle_Formatted, thisDraw.endAngle_Formatted, thisDraw.clockwise);
							if ( thisDraw.filled )
							{
								ctx.fillStyle=thisDraw.fillColor;
								ctx.fill();
							}else
							{
								ctx.strokeStyle=thisDraw.fillColor;
								ctx.stroke();
							}
						}


						if ( thisDraw.drawType == 'arc2' )
						{
							ctx.lineWidth=thisDraw.lineWidth;
							ctx.strokeStyle=thisDraw.fillColor;
							ctx.beginPath(thisDraw.x1_Formatted, thisDraw.y1_Formatted);
							ctx.moveTo(thisDraw.x1_Formatted, thisDraw.y1_Formatted);
							ctx.arcTo(thisDraw.x2_Formatted, thisDraw.y2_Formatted, thisDraw.x3_Formatted, thisDraw.y3_Formatted, thisDraw.arcRadius_Formatted);
							if ( thisDraw.filled )
							{
								ctx.fillStyle=thisDraw.fillColor;
								ctx.fill();
							}else
							{
								ctx.strokeStyle=thisDraw.fillColor;
								ctx.stroke();
							}
						}


						if ( thisDraw.drawType == 'quadratic' )
						{
							ctx.lineWidth=thisDraw.lineWidth;
							ctx.strokeStyle=thisDraw.fillColor;
							ctx.beginPath();
							ctx.moveTo(thisDraw.x1_Formatted, thisDraw.y1_Formatted);
							ctx.quadraticCurveTo(thisDraw.x2_Formatted, thisDraw.y2_Formatted, thisDraw.x3_Formatted, thisDraw.y3_Formatted);
							if ( thisDraw.filled )
							{
								ctx.fillStyle=thisDraw.fillColor;
								ctx.fill();
							}else
							{
								ctx.strokeStyle=thisDraw.fillColor;
								ctx.stroke();
							}
						}


						if ( thisDraw.drawType == 'bezier' )
						{
							ctx.lineWidth=thisDraw.lineWidth;
							ctx.beginPath();
							ctx.moveTo(thisDraw.x1_Formatted, thisDraw.y1_Formatted);
							ctx.bezierCurveTo(thisDraw.x2_Formatted, thisDraw.y2_Formatted, thisDraw.x3_Formatted, thisDraw.y3_Formatted, thisDraw.x4_Formatted, thisDraw.y4_Formatted);
							if ( thisDraw.filled )
							{
								ctx.fillStyle=thisDraw.fillColor;
								ctx.fill();
							}else
							{
								ctx.strokeStyle=thisDraw.fillColor;
								ctx.stroke();
							}
						}

						if ( thisDraw.drawType == 'linearGrad' )
						{
							var linearGradient = ctx.createLinearGradient(thisDraw.x1_Formatted, thisDraw.y1_Formatted, thisDraw.x2_Formatted, thisDraw.y2_Formatted);
							var myColorStops = thisDraw.colorStops_Formatted.split(';');
							for (var a=0; a<myColorStops.length; a++)
							{
								linearGradient.addColorStop(myColorStops[a].split(/,(.+)/)[0], myColorStops[a].split(/,(.+)/)[1]);
							}
							if ( thisDraw.filled )
							{
								ctx.fillStyle=linearGradient;
								ctx.fillRect(thisDraw.x3_Formatted, thisDraw.y3_Formatted, thisDraw.x4_Formatted, thisDraw.y4_Formatted);
							}else
							{
								ctx.strokeStyle=linearGradient;
								ctx.strokeRect(thisDraw.x3_Formatted, thisDraw.y3_Formatted, thisDraw.x4_Formatted, thisDraw.y4_Formatted);
							}
						}


						if ( thisDraw.drawType == 'radialGrad' )
						{
							console.log('Here with '+thisDraw);
							var radialGradient = ctx.createRadialGradient(thisDraw.x1, thisDraw.y1, thisDraw.x3, thisDraw.x2, thisDraw.y2, thisDraw.y3);
							var myColorStops = thisDraw.colorStops_Formatted.split(';');
							for (var a=0; a<myColorStops.length; a++)
							{
								radialGradient.addColorStop(myColorStops[a].split(/,(.+)/)[0], myColorStops[a].split(/,(.+)/)[1]);
							}
							ctx.fillStyle=radialGradient;
							ctx.fillRect(0, 0, thisItem.content.width, thisItem.content.height);
						}


						if ( thisDraw.drawType == 'text' )
						{
							var newText = thisDraw.text;

							vm.cadwolf_worksheet.forEach(
								function(thisEq, index){
									var re = new RegExp('#'+thisEq.name, 'g');
									if ( thisDraw.text.match( re ) )
									{
										newText = thisDraw.text.replace( re, thisEq.content.Equation.Solution_real['0-0'] );
									}
								}
							);

							ctx.font = thisDraw.fontStyle+' '+thisDraw.fontSize+'px '+thisDraw.fontFamily;
							if ( thisDraw.filled )
							{
								ctx.fillStyle=thisDraw.fillColor;
								ctx.fillText(thisDraw.text_Formatted, thisDraw.x1_Formatted, thisDraw.y1_Formatted);
							
							}else
							{
								ctx.strokeStyle=thisDraw.fillColor;
								ctx.strokeText(thisDraw.text_Formatted, thisDraw.x1_Formatted, thisDraw.y1_Formatted);							
							}

						}



						if ( thisDraw.drawType == 'image' )
						{
							var img = new Image();
							img.src = "https://cadwolf.s3.amazonaws.com/"+thisDraw.src;
							img.onload = function() {

								if ( thisDraw.imageScaled )
								{
									ctx.drawImage(img, thisDraw.x1_Formatted, thisDraw.y1_Formatted, thisDraw.x2_Formatted, thisDraw.y2_Formatted );
								
								}else if ( thisDraw.imageSliced )
								{
									ctx.drawImage(img, thisDraw.x3_Formatted, thisDraw.y3_Formatted, thisDraw.x4_Formatted, thisDraw.y4_Formatted, thisDraw.x1_Formatted, thisDraw.y1_Formatted, thisDraw.x2_Formatted, thisDraw.y2_Formatted )

								}else
								{
									ctx.drawImage(img, thisDraw.x1_Formatted, thisDraw.y1_Formatted);
								}

							}

						}



						if ( thisDraw.drawType == 'arrow' )
						{
							ctx.lineWidth=thisDraw.lineWidth;
							ctx.strokeStyle=thisDraw.fillColor;
							ctx.fillStyle=thisDraw.fillColor;

							// Angle of the arrow head
							var headAngle = Math.atan( thisDraw.arrowHeadWidth_Formatted / thisDraw.arrowHeadHeight_Formatted );

							// Calculate the angle of the arrow line
							var arrAngle = Math.atan( ( thisDraw.y2_Formatted - thisDraw.y1_Formatted ) / ( thisDraw.x2_Formatted - thisDraw.x1_Formatted ) );
							
							if ( thisDraw.x2_Formatted >= thisDraw.x1_Formatted )
							{
								var rootPosX = thisDraw.x2_Formatted - thisDraw.arrowHeadHeight_Formatted * Math.cos( arrAngle ); 
								var rootPosY = thisDraw.y2_Formatted - thisDraw.arrowHeadHeight_Formatted * Math.sin( arrAngle );
								var xPos1 = rootPosX - thisDraw.arrowHeadWidth_Formatted * Math.sin( arrAngle ); 
								var yPos1 = rootPosY + thisDraw.arrowHeadWidth_Formatted * Math.cos( arrAngle ); 
								var xPos2 = rootPosX + thisDraw.arrowHeadWidth_Formatted * Math.sin( arrAngle ); 
								var yPos2 = rootPosY - thisDraw.arrowHeadWidth_Formatted * Math.cos( arrAngle );
							}else
							{
								var rootPosX = thisDraw.x2_Formatted + thisDraw.arrowHeadHeight_Formatted * Math.cos( arrAngle ); 
								var rootPosY = thisDraw.y2_Formatted + thisDraw.arrowHeadHeight_Formatted * Math.sin( arrAngle );
								var xPos1 = rootPosX - thisDraw.arrowHeadWidth_Formatted * Math.sin( arrAngle ); 
								var yPos1 = rootPosY + thisDraw.arrowHeadWidth_Formatted * Math.cos( arrAngle ); 
								var xPos2 = rootPosX + thisDraw.arrowHeadWidth_Formatted * Math.sin( arrAngle ); 
								var yPos2 = rootPosY - thisDraw.arrowHeadWidth_Formatted * Math.cos( arrAngle );
							} 
							
							ctx.lineWidth=thisDraw.lineWidth;
							if (thisDraw.dashed)
							{
								ctx.setLineDash(thisDraw.lineDash.split(','));
								ctx.lineDashOffset = thisDraw.dashOffset;
							}
							
							if ( thisDraw.arrowType == 'curved' )
							{
								ctx.beginPath();
								ctx.moveTo(thisDraw.x1_Formatted, thisDraw.y1_Formatted);
								ctx.lineTo(rootPosX, rootPosY);
								ctx.stroke();
								ctx.moveTo(xPos1, yPos1);
								ctx.quadraticCurveTo(thisDraw.x2_Formatted, thisDraw.y2_Formatted, xPos2, yPos2);
								ctx.lineTo(thisDraw.x2_Formatted, thisDraw.y2_Formatted);
								//ctx.lineTo(xPos2, yPos2);
								if ( thisDraw.filled )
								{
									ctx.fill();
								}else
								{
									ctx.lineTo(xPos1, yPos1);
									ctx.stroke();								
								}
							}

							if ( thisDraw.arrowType == 'straight' )
							{
								ctx.beginPath();
								ctx.moveTo(thisDraw.x1_Formatted, thisDraw.y1_Formatted);
								ctx.lineTo(rootPosX, rootPosY);
								ctx.stroke();								
								ctx.lineTo(xPos1, yPos1);
								ctx.lineTo(thisDraw.x2_Formatted, thisDraw.y2_Formatted);
								ctx.lineTo(xPos2, yPos2);
								ctx.lineTo(rootPosX, rootPosY);
								if ( thisDraw.filled )
								{
									ctx.fill();
								}else
								{
									ctx.stroke();								
								}
							}

						}

					}
				);
			
			}, 100);
		};







		/*
		 *
		 * FORUM STUFF
		 *
		 */



		/*
		 *
		 * Get the Forums
		 *
		 */
		function getForums( )
		{   

			console.log('In the get forums function');
			vm.forums = [];
			vm.comments = [];

			$http({
				method: "GET",
				url: window.location.origin+'/files',
				params: { thisURL : window.location.href.replace(/\~2F/g,'/'), version : 0, revision : 0 }

			}).then(function successCallback( returnData ) 
			{
				
				console.log('The forums are ');
				console.log(returnData);

				returnData.data.files.forEach(function(thisForum, index)
				{  
		
					if ( thisForum.file_type_id == "Forum" )
					{   
						vm.forums.push(thisForum);
						vm.getComments( thisForum.id );
					}

				});

			});

		}







		/*
		 *
		 * Get the Comments
		 *
		 */
		function getComments( forumID )
		{   
			console.log('In the get comments function');

			if ( vm.comments === undefined )
			{
				vm.comments = [];
			}

			$http({
				method: "GET",
				url: window.location.origin+'/discussions/'+forumID

			}).then(function successCallback( returnData ) 
			{
				console.log('The comments are ...');
				console.log(returnData);


				returnData.data.forEach(function(thisComment, index)
				{  
					vm.comments.push( thisComment );
				});


				// Reset Status
				vm.resetStatus();

				// Assign Dates
				vm.assignDates();

			});

		}





		/*
		 *
		 * Reset the status of every comment
		 *
		 */
		function resetStatus(id) 
		{
			vm.newComment=false;
			vm.editForum=false;

			vm.comments.forEach(function(thisComment, index)
			{  
				thisComment.item_data.editStatus = 0;
				if ( thisComment.id == id )
				{
					thisComment.item_data.editStatus = 1;
				}
			})

			if ( ( id == "0" ) || ( id == 0 ) )
			{
				vm.newComment=true; 
			}


			if ( ( id == "forum" ) )
			{
				vm.editForum=true; 
			}

		}





		/**
		 *
		 * Assign Date objects to forums and comments
		 *
		 */
		function assignDates( )
		{

			vm.comments.forEach(function(thisItem, index)
			{  
				var thisDate = thisItem['created_at'].split(' ');
				thisItem['created_at_date'] = new Date(thisDate[0]+'T'+thisDate[1]); 
			});


		}


		/*
		 *
		 *
		 * END FORUM STUFF
		 *
		 *
		 *
		 */





	}
})();

(function(d){typeof module==="object"&&module.exports?module.exports=d:d(Highcharts)})(function(d){var m=d.Axis,q=d.Chart,i=d.Color,x=d.Legend,s=d.LegendSymbolMixin,t=d.Series,y=d.Point,u=d.getOptions(),h=d.each,r=d.extend,v=d.extendClass,z=d.isNumber,j=d.merge,k=d.pick,o=d.seriesTypes,w=d.wrap,n=function(){},p=d.ColorAxis=function(){this.init.apply(this,arguments)};r(p.prototype,m.prototype);r(p.prototype,{defaultColorAxisOptions:{lineWidth:0,minPadding:0,maxPadding:0,gridLineWidth:1,tickPixelInterval:72,
startOnTick:!0,endOnTick:!0,offset:0,marker:{animation:{duration:50},color:"gray",width:0.01},labels:{overflow:"justify"},minColor:"#EFEFFF",maxColor:"#003875",tickLength:5,showInLegend:!0},init:function(a,b){var c=a.options.legend.layout!=="vertical",f;this.coll="colorAxis";f=j(this.defaultColorAxisOptions,{side:c?2:1,reversed:!c},b,{opposite:!c,showEmpty:!1,title:null});m.prototype.init.call(this,a,f);b.dataClasses&&this.initDataClasses(b);this.initStops(b);this.horiz=c;this.zoomEnabled=!1;this.defaultLegendLength=
200},tweenColors:function(a,b,c){var f;!b.rgba.length||!a.rgba.length?a=b.input||"none":(a=a.rgba,b=b.rgba,f=b[3]!==1||a[3]!==1,a=(f?"rgba(":"rgb(")+Math.round(b[0]+(a[0]-b[0])*(1-c))+","+Math.round(b[1]+(a[1]-b[1])*(1-c))+","+Math.round(b[2]+(a[2]-b[2])*(1-c))+(f?","+(b[3]+(a[3]-b[3])*(1-c)):"")+")");return a},initDataClasses:function(a){var b=this,c=this.chart,f,e=0,l=this.options,g=a.dataClasses.length;this.dataClasses=f=[];this.legendItems=[];h(a.dataClasses,function(a,d){var h,a=j(a);f.push(a);
if(!a.color)l.dataClassColor==="category"?(h=c.options.colors,a.color=h[e++],e===h.length&&(e=0)):a.color=b.tweenColors(i(l.minColor),i(l.maxColor),g<2?0.5:d/(g-1))})},initStops:function(a){this.stops=a.stops||[[0,this.options.minColor],[1,this.options.maxColor]];h(this.stops,function(a){a.color=i(a[1])})},setOptions:function(a){m.prototype.setOptions.call(this,a);this.options.crosshair=this.options.marker},setAxisSize:function(){var a=this.legendSymbol,b=this.chart,c=b.options.legend||{},f,e;a?(this.left=
c=a.attr("x"),this.top=f=a.attr("y"),this.width=e=a.attr("width"),this.height=a=a.attr("height"),this.right=b.chartWidth-c-e,this.bottom=b.chartHeight-f-a,this.len=this.horiz?e:a,this.pos=this.horiz?c:f):this.len=(this.horiz?c.symbolWidth:c.symbolHeight)||this.defaultLegendLength},toColor:function(a,b){var c,f=this.stops,e,l=this.dataClasses,g,d;if(l)for(d=l.length;d--;){if(g=l[d],e=g.from,f=g.to,(e===void 0||a>=e)&&(f===void 0||a<=f)){c=g.color;if(b)b.dataClass=d;break}}else{this.isLog&&(a=this.val2lin(a));
c=1-(this.max-a)/(this.max-this.min||1);for(d=f.length;d--;)if(c>f[d][0])break;e=f[d]||f[d+1];f=f[d+1]||e;c=1-(f[0]-c)/(f[0]-e[0]||1);c=this.tweenColors(e.color,f.color,c)}return c},getOffset:function(){var a=this.legendGroup,b=this.chart.axisOffset[this.side];if(a){this.axisParent=a;m.prototype.getOffset.call(this);if(!this.added)this.added=!0,this.labelLeft=0,this.labelRight=this.width;this.chart.axisOffset[this.side]=b}},setLegendColor:function(){var a,b=this.options,c=this.reversed;a=c?1:0;c=
c?0:1;a=this.horiz?[a,0,c,0]:[0,c,0,a];this.legendColor={linearGradient:{x1:a[0],y1:a[1],x2:a[2],y2:a[3]},stops:b.stops||[[0,b.minColor],[1,b.maxColor]]}},drawLegendSymbol:function(a,b){var c=a.padding,f=a.options,e=this.horiz,d=k(f.symbolWidth,e?this.defaultLegendLength:12),g=k(f.symbolHeight,e?12:this.defaultLegendLength),h=k(f.labelPadding,e?16:30),f=k(f.itemDistance,10);this.setLegendColor();b.legendSymbol=this.chart.renderer.rect(0,a.baseline-11,d,g).attr({zIndex:1}).add(b.legendGroup);this.legendItemWidth=
d+c+(e?f:h);this.legendItemHeight=g+c+(e?h:0)},setState:n,visible:!0,setVisible:n,getSeriesExtremes:function(){var a;if(this.series.length)a=this.series[0],this.dataMin=a.valueMin,this.dataMax=a.valueMax},drawCrosshair:function(a,b){var c=b&&b.plotX,f=b&&b.plotY,e,d=this.pos,g=this.len;if(b)e=this.toPixels(b[b.series.colorKey]),e<d?e=d-2:e>d+g&&(e=d+g+2),b.plotX=e,b.plotY=this.len-e,m.prototype.drawCrosshair.call(this,a,b),b.plotX=c,b.plotY=f,this.cross&&this.cross.attr({fill:this.crosshair.color}).add(this.legendGroup)},
getPlotLinePath:function(a,b,c,f,e){return z(e)?this.horiz?["M",e-4,this.top-6,"L",e+4,this.top-6,e,this.top,"Z"]:["M",this.left,e,"L",this.left-6,e+6,this.left-6,e-6,"Z"]:m.prototype.getPlotLinePath.call(this,a,b,c,f)},update:function(a,b){var c=this.chart,f=c.legend;h(this.series,function(a){a.isDirtyData=!0});if(a.dataClasses&&f.allItems)h(f.allItems,function(a){a.isDataClass&&a.legendGroup.destroy()}),c.isDirtyLegend=!0;c.options[this.coll]=j(this.userOptions,a);m.prototype.update.call(this,a,
b);this.legendItem&&(this.setLegendColor(),f.colorizeItem(this,!0))},getDataClassLegendSymbols:function(){var a=this,b=this.chart,c=this.legendItems,f=b.options.legend,e=f.valueDecimals,l=f.valueSuffix||"",g;c.length||h(this.dataClasses,function(f,m){var i=!0,j=f.from,k=f.to;g="";j===void 0?g="< ":k===void 0&&(g="> ");j!==void 0&&(g+=d.numberFormat(j,e)+l);j!==void 0&&k!==void 0&&(g+=" - ");k!==void 0&&(g+=d.numberFormat(k,e)+l);c.push(r({chart:b,name:g,options:{},drawLegendSymbol:s.drawRectangle,
visible:!0,setState:n,isDataClass:!0,setVisible:function(){i=this.visible=!i;h(a.series,function(a){h(a.points,function(a){a.dataClass===m&&a.setVisible(i)})});b.legend.colorizeItem(this,i)}},f))});return c},name:""});h(["fill","stroke"],function(a){d.Fx.prototype[a+"Setter"]=function(){this.elem.attr(a,p.prototype.tweenColors(i(this.start),i(this.end),this.pos))}});w(q.prototype,"getAxes",function(a){var b=this.options.colorAxis;a.call(this);this.colorAxis=[];b&&new p(this,b)});w(x.prototype,"getAllItems",
function(a){var b=[],c=this.chart.colorAxis[0];c&&(c.options.showInLegend&&(c.options.dataClasses?b=b.concat(c.getDataClassLegendSymbols()):b.push(c)),h(c.series,function(a){a.options.showInLegend=!1}));return b.concat(a.call(this))});q={pointAttrToOptions:{stroke:"borderColor","stroke-width":"borderWidth",fill:"color",dashstyle:"dashStyle"},pointArrayMap:["value"],axisTypes:["xAxis","yAxis","colorAxis"],optionalAxis:"colorAxis",trackerGroups:["group","markerGroup","dataLabelsGroup"],getSymbol:n,
parallelArrays:["x","y","value"],colorKey:"value",translateColors:function(){var a=this,b=this.options.nullColor,c=this.colorAxis,f=this.colorKey;h(this.data,function(e){var d=e[f];if(d=e.options.color||(d===null?b:c&&d!==void 0?c.toColor(d,e):e.color||a.color))e.color=d})}};u.plotOptions.heatmap=j(u.plotOptions.scatter,{animation:!1,borderWidth:0,nullColor:"#F8F8F8",dataLabels:{formatter:function(){return this.point.value},inside:!0,verticalAlign:"middle",crop:!1,overflow:!1,padding:0},marker:null,
pointRange:null,tooltip:{pointFormat:"{point.x}, {point.y}: {point.value}<br/>"},states:{normal:{animation:!0},hover:{halo:!1,brightness:0.2}}});o.heatmap=v(o.scatter,j(q,{type:"heatmap",pointArrayMap:["y","value"],hasPointSpecificOptions:!0,pointClass:v(y,{setVisible:function(a){var b=this,c=a?"show":"hide";h(["graphic","dataLabel"],function(a){if(b[a])b[a][c]()})}}),supportsDrilldown:!0,getExtremesFromAll:!0,directTouch:!0,init:function(){var a;o.scatter.prototype.init.apply(this,arguments);a=this.options;
a.pointRange=k(a.pointRange,a.colsize||1);this.yAxis.axisPointRange=a.rowsize||1},translate:function(){var a=this.options,b=this.xAxis,c=this.yAxis,f=function(a,b,c){return Math.min(Math.max(b,a),c)};this.generatePoints();h(this.points,function(e){var d=(a.colsize||1)/2,g=(a.rowsize||1)/2,h=f(Math.round(b.len-b.translate(e.x-d,0,1,0,1)),-b.len,2*b.len),d=f(Math.round(b.len-b.translate(e.x+d,0,1,0,1)),-b.len,2*b.len),i=f(Math.round(c.translate(e.y-g,0,1,0,1)),-c.len,2*c.len),g=f(Math.round(c.translate(e.y+
g,0,1,0,1)),-c.len,2*c.len);e.plotX=e.clientX=(h+d)/2;e.plotY=(i+g)/2;e.shapeType="rect";e.shapeArgs={x:Math.min(h,d),y:Math.min(i,g),width:Math.abs(d-h),height:Math.abs(g-i)}});this.translateColors();this.chart.hasRendered&&h(this.points,function(a){a.shapeArgs.fill=a.options.color||a.color})},drawPoints:o.column.prototype.drawPoints,animate:n,getBox:n,drawLegendSymbol:s.drawRectangle,alignDataLabel:o.column.prototype.alignDataLabel,getExtremes:function(){t.prototype.getExtremes.call(this,this.valueData);
this.valueMin=this.dataMin;this.valueMax=this.dataMax;t.prototype.getExtremes.call(this)}}))});



(function (factory) {
	if (typeof module === 'object' && module.exports) {
		module.exports = factory;
	} else {
		factory(Highcharts);
	}
}(function (Highcharts) {


	var UNDEFINED,
		Axis = Highcharts.Axis,
		Chart = Highcharts.Chart,
		Color = Highcharts.Color,
		Legend = Highcharts.Legend,
		LegendSymbolMixin = Highcharts.LegendSymbolMixin,
		Series = Highcharts.Series,
		Point = Highcharts.Point,

		defaultOptions = Highcharts.getOptions(),
		each = Highcharts.each,
		extend = Highcharts.extend,
		extendClass = Highcharts.extendClass,
		isNumber = Highcharts.isNumber,
		merge = Highcharts.merge,
		pick = Highcharts.pick,
		seriesTypes = Highcharts.seriesTypes,
		wrap = Highcharts.wrap,
		noop = function () {};

	


	/**
	 * The ColorAxis object for inclusion in gradient legends
	 */
	var ColorAxis = Highcharts.ColorAxis = function () {
		this.init.apply(this, arguments);
	};
	extend(ColorAxis.prototype, Axis.prototype);
	extend(ColorAxis.prototype, {
		defaultColorAxisOptions: {
			lineWidth: 0,
			minPadding: 0,
			maxPadding: 0,
			gridLineWidth: 1,
			tickPixelInterval: 72,
			startOnTick: true,
			endOnTick: true,
			offset: 0,
			marker: {
				animation: {
					duration: 50
				},
				color: 'gray',
				width: 0.01
			},
			labels: {
				overflow: 'justify'
			},
			minColor: '#EFEFFF',
			maxColor: '#003875',
			tickLength: 5,
			showInLegend: true
		},
		init: function (chart, userOptions) {
			var horiz = chart.options.legend.layout !== 'vertical',
				options;

			this.coll = 'colorAxis';

			// Build the options
			options = merge(this.defaultColorAxisOptions, {
				side: horiz ? 2 : 1,
				reversed: !horiz
			}, userOptions, {
				opposite: !horiz,
				showEmpty: false,
				title: null
			});

			Axis.prototype.init.call(this, chart, options);

			// Base init() pushes it to the xAxis array, now pop it again
			//chart[this.isXAxis ? 'xAxis' : 'yAxis'].pop();

			// Prepare data classes
			if (userOptions.dataClasses) {
				this.initDataClasses(userOptions);
			}
			this.initStops(userOptions);

			// Override original axis properties
			this.horiz = horiz;
			this.zoomEnabled = false;
		
			// Add default values	
			this.defaultLegendLength = 200;
		},

		/*
		 * Return an intermediate color between two colors, according to pos where 0
		 * is the from color and 1 is the to color.
		 * NOTE: Changes here should be copied
		 * to the same function in drilldown.src.js and solid-gauge-src.js.
		 */
		tweenColors: function (from, to, pos) {
			// Check for has alpha, because rgba colors perform worse due to lack of
			// support in WebKit.
			var hasAlpha,
				ret;

			// Unsupported color, return to-color (#3920)
			if (!to.rgba.length || !from.rgba.length) {
				ret = to.input || 'none';

			// Interpolate
			} else {
				from = from.rgba;
				to = to.rgba;
				hasAlpha = (to[3] !== 1 || from[3] !== 1);
				ret = (hasAlpha ? 'rgba(' : 'rgb(') +
					Math.round(to[0] + (from[0] - to[0]) * (1 - pos)) + ',' +
					Math.round(to[1] + (from[1] - to[1]) * (1 - pos)) + ',' +
					Math.round(to[2] + (from[2] - to[2]) * (1 - pos)) +
					(hasAlpha ? (',' + (to[3] + (from[3] - to[3]) * (1 - pos))) : '') + ')';
			}
			return ret;
		},

		initDataClasses: function (userOptions) {
			var axis = this,
				chart = this.chart,
				dataClasses,
				colorCounter = 0,
				options = this.options,
				len = userOptions.dataClasses.length;
			this.dataClasses = dataClasses = [];
			this.legendItems = [];

			each(userOptions.dataClasses, function (dataClass, i) {
				var colors;

				dataClass = merge(dataClass);
				dataClasses.push(dataClass);
				if (!dataClass.color) {
					if (options.dataClassColor === 'category') {
						colors = chart.options.colors;
						dataClass.color = colors[colorCounter++];
						// loop back to zero
						if (colorCounter === colors.length) {
							colorCounter = 0;
						}
					} else {
						dataClass.color = axis.tweenColors(
							Color(options.minColor),
							Color(options.maxColor),
							len < 2 ? 0.5 : i / (len - 1) // #3219
						);
					}
				}
			});
		},

		initStops: function (userOptions) {
			this.stops = userOptions.stops || [
				[0, this.options.minColor],
				[1, this.options.maxColor]
			];
			each(this.stops, function (stop) {
				stop.color = Color(stop[1]);
			});
		},

		/**
		 * Extend the setOptions method to process extreme colors and color
		 * stops.
		 */
		setOptions: function (userOptions) {
			Axis.prototype.setOptions.call(this, userOptions);

			this.options.crosshair = this.options.marker;
		},

		setAxisSize: function () {
			var symbol = this.legendSymbol,
				chart = this.chart,
				legendOptions = chart.options.legend || {},
				x,
				y,
				width,
				height;

			if (symbol) {
				this.left = x = symbol.attr('x');
				this.top = y = symbol.attr('y');
				this.width = width = symbol.attr('width');
				this.height = height = symbol.attr('height');
				this.right = chart.chartWidth - x - width;
				this.bottom = chart.chartHeight - y - height;

				this.len = this.horiz ? width : height;
				this.pos = this.horiz ? x : y;
			} else {
				// Fake length for disabled legend to avoid tick issues and such (#5205)
				this.len = (this.horiz ? legendOptions.symbolWidth : legendOptions.symbolHeight) || this.defaultLegendLength;
			}
		},

		/**
		 * Translate from a value to a color
		 */
		toColor: function (value, point) {
			var pos,
				stops = this.stops,
				from,
				to,
				color,
				dataClasses = this.dataClasses,
				dataClass,
				i;

			if (dataClasses) {
				i = dataClasses.length;
				while (i--) {
					dataClass = dataClasses[i];
					from = dataClass.from;
					to = dataClass.to;
					if ((from === UNDEFINED || value >= from) && (to === UNDEFINED || value <= to)) {
						color = dataClass.color;
						if (point) {
							point.dataClass = i;
						}
						break;
					}
				}

			} else {

				if (this.isLog) {
					value = this.val2lin(value);
				}
				pos = 1 - ((this.max - value) / ((this.max - this.min) || 1));
				i = stops.length;
				while (i--) {
					if (pos > stops[i][0]) {
						break;
					}
				}
				from = stops[i] || stops[i + 1];
				to = stops[i + 1] || from;

				// The position within the gradient
				pos = 1 - (to[0] - pos) / ((to[0] - from[0]) || 1);

				color = this.tweenColors(
					from.color,
					to.color,
					pos
				);
			}
			return color;
		},

		/**
		 * Override the getOffset method to add the whole axis groups inside the legend.
		 */
		getOffset: function () {
			var group = this.legendGroup,
				sideOffset = this.chart.axisOffset[this.side];

			if (group) {

				// Hook for the getOffset method to add groups to this parent group
				this.axisParent = group;

				// Call the base
				Axis.prototype.getOffset.call(this);

				// First time only
				if (!this.added) {

					this.added = true;

					this.labelLeft = 0;
					this.labelRight = this.width;
				}
				// Reset it to avoid color axis reserving space
				this.chart.axisOffset[this.side] = sideOffset;
			}
		},

		/**
		 * Create the color gradient
		 */
		setLegendColor: function () {
			var grad,
				horiz = this.horiz,
				options = this.options,
				reversed = this.reversed,
				one = reversed ? 1 : 0,
				zero = reversed ? 0 : 1;

			grad = horiz ? [one, 0, zero, 0] : [0, zero, 0, one]; // #3190
			this.legendColor = {
				linearGradient: { x1: grad[0], y1: grad[1], x2: grad[2], y2: grad[3] },
				stops: options.stops || [
					[0, options.minColor],
					[1, options.maxColor]
				]
			};
		},

		/**
		 * The color axis appears inside the legend and has its own legend symbol
		 */
		drawLegendSymbol: function (legend, item) {
			var padding = legend.padding,
				legendOptions = legend.options,
				horiz = this.horiz,
				width = pick(legendOptions.symbolWidth, horiz ? this.defaultLegendLength : 12),
				height = pick(legendOptions.symbolHeight, horiz ? 12 : this.defaultLegendLength),
				labelPadding = pick(legendOptions.labelPadding, horiz ? 16 : 30),
				itemDistance = pick(legendOptions.itemDistance, 10);

			this.setLegendColor();

			// Create the gradient
			item.legendSymbol = this.chart.renderer.rect(
				0,
				legend.baseline - 11,
				width,
				height
			).attr({
				zIndex: 1
			}).add(item.legendGroup);

			// Set how much space this legend item takes up
			this.legendItemWidth = width + padding + (horiz ? itemDistance : labelPadding);
			this.legendItemHeight = height + padding + (horiz ? labelPadding : 0);
		},
		/**
		 * Fool the legend
		 */
		setState: noop,
		visible: true,
		setVisible: noop,
		getSeriesExtremes: function () {
			var series;
			if (this.series.length) {
				series = this.series[0];
				this.dataMin = series.valueMin;
				this.dataMax = series.valueMax;
			}
		},
		drawCrosshair: function (e, point) {
			var plotX = point && point.plotX,
				plotY = point && point.plotY,
				crossPos,
				axisPos = this.pos,
				axisLen = this.len;

			if (point) {
				crossPos = this.toPixels(point[point.series.colorKey]);
				if (crossPos < axisPos) {
					crossPos = axisPos - 2;
				} else if (crossPos > axisPos + axisLen) {
					crossPos = axisPos + axisLen + 2;
				}

				point.plotX = crossPos;
				point.plotY = this.len - crossPos;
				Axis.prototype.drawCrosshair.call(this, e, point);
				point.plotX = plotX;
				point.plotY = plotY;

				if (this.cross) {
					this.cross
						.attr({
							fill: this.crosshair.color
						})
						.add(this.legendGroup);
				}
			}
		},
		getPlotLinePath: function (a, b, c, d, pos) {
			return isNumber(pos) ? // crosshairs only // #3969 pos can be 0 !!
				(this.horiz ?
					['M', pos - 4, this.top - 6, 'L', pos + 4, this.top - 6, pos, this.top, 'Z'] :
					['M', this.left, pos, 'L', this.left - 6, pos + 6, this.left - 6, pos - 6, 'Z']
				) :
				Axis.prototype.getPlotLinePath.call(this, a, b, c, d);
		},

		update: function (newOptions, redraw) {
			var chart = this.chart,
				legend = chart.legend;

			each(this.series, function (series) {
				series.isDirtyData = true; // Needed for Axis.update when choropleth colors change
			});

			// When updating data classes, destroy old items and make sure new ones are created (#3207)
			if (newOptions.dataClasses && legend.allItems) {
				each(legend.allItems, function (item) {
					if (item.isDataClass) {
						item.legendGroup.destroy();
					}
				});
				chart.isDirtyLegend = true;
			}

			// Keep the options structure updated for export. Unlike xAxis and yAxis, the colorAxis is
			// not an array. (#3207)
			chart.options[this.coll] = merge(this.userOptions, newOptions);

			Axis.prototype.update.call(this, newOptions, redraw);
			if (this.legendItem) {
				this.setLegendColor();
				legend.colorizeItem(this, true);
			}
		},

		/**
		 * Get the legend item symbols for data classes
		 */
		getDataClassLegendSymbols: function () {
			var axis = this,
				chart = this.chart,
				legendItems = this.legendItems,
				legendOptions = chart.options.legend,
				valueDecimals = legendOptions.valueDecimals,
				valueSuffix = legendOptions.valueSuffix || '',
				name;

			if (!legendItems.length) {
				each(this.dataClasses, function (dataClass, i) {
					var vis = true,
						from = dataClass.from,
						to = dataClass.to;

					// Assemble the default name. This can be overridden by legend.options.labelFormatter
					name = '';
					if (from === UNDEFINED) {
						name = '< ';
					} else if (to === UNDEFINED) {
						name = '> ';
					}
					if (from !== UNDEFINED) {
						name += Highcharts.numberFormat(from, valueDecimals) + valueSuffix;
					}
					if (from !== UNDEFINED && to !== UNDEFINED) {
						name += ' - ';
					}
					if (to !== UNDEFINED) {
						name += Highcharts.numberFormat(to, valueDecimals) + valueSuffix;
					}

					// Add a mock object to the legend items
					legendItems.push(extend({
						chart: chart,
						name: name,
						options: {},
						drawLegendSymbol: LegendSymbolMixin.drawRectangle,
						visible: true,
						setState: noop,
						isDataClass: true,
						setVisible: function () {
							vis = this.visible = !vis;
							each(axis.series, function (series) {
								each(series.points, function (point) {
									if (point.dataClass === i) {
										point.setVisible(vis);
									}
								});
							});

							chart.legend.colorizeItem(this, vis);
						}
					}, dataClass));
				});
			}
			return legendItems;
		},
		name: '' // Prevents 'undefined' in legend in IE8
	});

	/**
	 * Handle animation of the color attributes directly
	 */
	each(['fill', 'stroke'], function (prop) {
		Highcharts.Fx.prototype[prop + 'Setter'] = function () {
			this.elem.attr(prop, ColorAxis.prototype.tweenColors(Color(this.start), Color(this.end), this.pos));
		};
	});

	/**
	 * Extend the chart getAxes method to also get the color axis
	 */
	wrap(Chart.prototype, 'getAxes', function (proceed) {

		var options = this.options,
			colorAxisOptions = options.colorAxis;

		proceed.call(this);

		this.colorAxis = [];
		if (colorAxisOptions) {
			new ColorAxis(this, colorAxisOptions); // eslint-disable-line no-new
		}
	});


	/**
	 * Wrap the legend getAllItems method to add the color axis. This also removes the
	 * axis' own series to prevent them from showing up individually.
	 */
	wrap(Legend.prototype, 'getAllItems', function (proceed) {
		var allItems = [],
			colorAxis = this.chart.colorAxis[0];

		if (colorAxis) {
			if (colorAxis.options.showInLegend) {
				// Data classes
				if (colorAxis.options.dataClasses) {
					allItems = allItems.concat(colorAxis.getDataClassLegendSymbols());
				// Gradient legend
				} else {
					// Add this axis on top
					allItems.push(colorAxis);
				}
			}

			// Don't add the color axis' series
			each(colorAxis.series, function (series) {
				series.options.showInLegend = false;
			});
		}

		return allItems.concat(proceed.call(this));
	});
	/**
	 * Mixin for maps and heatmaps
	 */
	var colorPointMixin = {
		/**
		 * Set the visibility of a single point
		 */
		setVisible: function (vis) {
			var point = this,
				method = vis ? 'show' : 'hide';

			// Show and hide associated elements
			each(['graphic', 'dataLabel'], function (key) {
				if (point[key]) {
					point[key][method]();
				}
			});
		}
	};
	var colorSeriesMixin = {

		pointAttrToOptions: { // mapping between SVG attributes and the corresponding options
			stroke: 'borderColor',
			'stroke-width': 'borderWidth',
			fill: 'color',
			dashstyle: 'dashStyle'
		},
		pointArrayMap: ['value'],
		axisTypes: ['xAxis', 'yAxis', 'colorAxis'],
		optionalAxis: 'colorAxis',
		trackerGroups: ['group', 'markerGroup', 'dataLabelsGroup'],
		getSymbol: noop,
		parallelArrays: ['x', 'y', 'value'],
		colorKey: 'value',

		/**
		 * In choropleth maps, the color is a result of the value, so this needs translation too
		 */
		translateColors: function () {
			var series = this,
				nullColor = this.options.nullColor,
				colorAxis = this.colorAxis,
				colorKey = this.colorKey;

			each(this.data, function (point) {
				var value = point[colorKey],
					color;

				color = point.options.color ||
					(value === null ? nullColor : (colorAxis && value !== undefined) ? colorAxis.toColor(value, point) : point.color || series.color);

				if (color) {
					point.color = color;
				}
			});
		}
	};

	/**
	 * Extend the default options with map options
	 */
	defaultOptions.plotOptions.heatmap = merge(defaultOptions.plotOptions.scatter, {
		animation: false,
		borderWidth: 0,
		nullColor: '#F8F8F8',
		dataLabels: {
			formatter: function () { // #2945
				return this.point.value;
			},
			inside: true,
			verticalAlign: 'middle',
			crop: false,
			overflow: false,
			padding: 0 // #3837
		},
		marker: null,
		pointRange: null, // dynamically set to colsize by default
		tooltip: {
			pointFormat: '{point.x}, {point.y}: {point.value}<br/>'
		},
		states: {
			normal: {
				animation: true
			},
			hover: {
				halo: false,  // #3406, halo is not required on heatmaps
				brightness: 0.2
			}
		}
	});

	// The Heatmap series type
	seriesTypes.heatmap = extendClass(seriesTypes.scatter, merge(colorSeriesMixin, {
		type: 'heatmap',
		pointArrayMap: ['y', 'value'],
		hasPointSpecificOptions: true,
		pointClass: extendClass(Point, colorPointMixin),
		supportsDrilldown: true,
		getExtremesFromAll: true,
		directTouch: true,

		/**
		 * Override the init method to add point ranges on both axes.
		 */
		init: function () {
			var options;
			seriesTypes.scatter.prototype.init.apply(this, arguments);

			options = this.options;
			options.pointRange = pick(options.pointRange, options.colsize || 1); // #3758, prevent resetting in setData
			this.yAxis.axisPointRange = options.rowsize || 1; // general point range
		},
		translate: function () {
			var series = this,
				options = series.options,
				xAxis = series.xAxis,
				yAxis = series.yAxis,
				between = function (x, a, b) {
					return Math.min(Math.max(a, x), b);
				};

			series.generatePoints();

			each(series.points, function (point) {
				var xPad = (options.colsize || 1) / 2,
					yPad = (options.rowsize || 1) / 2,
					x1 = between(Math.round(xAxis.len - xAxis.translate(point.x - xPad, 0, 1, 0, 1)), -xAxis.len, 2 * xAxis.len),
					x2 = between(Math.round(xAxis.len - xAxis.translate(point.x + xPad, 0, 1, 0, 1)), -xAxis.len, 2 * xAxis.len),
					y1 = between(Math.round(yAxis.translate(point.y - yPad, 0, 1, 0, 1)), -yAxis.len, 2 * yAxis.len),
					y2 = between(Math.round(yAxis.translate(point.y + yPad, 0, 1, 0, 1)), -yAxis.len, 2 * yAxis.len);

				// Set plotX and plotY for use in K-D-Tree and more
				point.plotX = point.clientX = (x1 + x2) / 2;
				point.plotY = (y1 + y2) / 2;

				point.shapeType = 'rect';
				point.shapeArgs = {
					x: Math.min(x1, x2),
					y: Math.min(y1, y2),
					width: Math.abs(x2 - x1),
					height: Math.abs(y2 - y1)
				};
			});

			series.translateColors();

			// Make sure colors are updated on colorAxis update (#2893)
			if (this.chart.hasRendered) {
				each(series.points, function (point) {
					point.shapeArgs.fill = point.options.color || point.color; // #3311
				});
			}
		},
		drawPoints: seriesTypes.column.prototype.drawPoints,
		animate: noop,
		getBox: noop,
		drawLegendSymbol: LegendSymbolMixin.drawRectangle,
		alignDataLabel: seriesTypes.column.prototype.alignDataLabel,
		getExtremes: function () {
			// Get the extremes from the value data
			Series.prototype.getExtremes.call(this, this.valueData);
			this.valueMin = this.dataMin;
			this.valueMax = this.dataMax;

			// Get the extremes from the y data
			Series.prototype.getExtremes.call(this);
		}

	}));


}));

(function ()
{
    'use strict';

    angular
        .module('app.document')
        .config(config);

    /** @ngInject */
    function config()
    {

    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('DatasetDialogController', DatasetDialogController);

    /** @ngInject */
    function DatasetDialogController($mdDialog, locals, $http)
    {
        var vm              = this;
        vm.thisName         = locals.name;
        vm.thisItem         = locals.thisItem;
        vm.modalType        = locals.modalType;
        vm.thisDesc         = locals.description;
        vm.availableText    = locals.availableText;

        vm.cancel           = cancel;
        vm.acceptChanges    = acceptChanges;
        vm.acceptName       = acceptName;
        vm.acceptText       = acceptText;

        function cancel(){
            $mdDialog.cancel();
        };

        function acceptChanges(desc) {
            $mdDialog.hide(desc);
        };

        function acceptName(name) {
            $mdDialog.hide(name);
        };

        function acceptText(name) {
            $mdDialog.hide(name);
        };

    }
})();


(function ()
{
    'use strict';
    
    angular
        .module('app.dataset', [
            'app.dataset.setup',
            'app.dataset.parse',
            'app.dataset.results'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.dataset', {
            url      : '/Dataset{path:.*}',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dataset/dataset.html',
                    controller : 'DatasetController as vm'
                }
            },
            bodyClass: 'dataset'
        });



        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/dataset');

        // Navigation
        msNavigationServiceProvider.saveItem('dataset', {
            title : 'Dataset',
            icon  : 'icon-data',
            state : 'app.dataset',
            weight: 5
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dataset')
        .controller('DatasetController', DatasetController);

    /** @ngInject */
    function DatasetController($mdSidenav, $mdDialog, utilityFactory, datasetMemoryFactory, $http, $sce, $location)
    {
        // Default Items
        var vm = this;
        window.MY_SCOPE=this;
        vm.showMenuTextTop = true;
        vm.showMenuTextBot = true;

        // Views
        vm.textPaste=false;
        vm.uploadText=false;
        vm.uploadExcel=false;
        vm.dataAvailable=false;
        vm.showMenuText =   true;

        // True to append data, false to overwrite it
        vm.appendOverwrite="true";

        
        // Methods
        vm.initialize               = initialize;               // Prepares data to be shown on load
        vm.getSpark                 = getSpark;
        vm.leftMenuCaller           = leftMenuCaller;           // Calls actions from the left menu
        vm.readFile                 = readFile;                 // Read in a rtf file
        vm.readExcel                = readExcel;                // Read in an excel file
        vm.applyFile                = applyFile;                // Break the file into components with proper contents
        vm.showAvailableText        = showAvailableText;        // Show those contents to user to accept/reject
        vm.compileText              = compileText;              // Add the accepted ones together
        vm.parseDatasetText         = parseDatasetText;         // Parse the text in the tet area
        vm.parseMe                  = parseMe;                  // Recursive parser
        vm.arrayToObject            = arrayToObject;            // Makes the array into an key object
        vm.updateService            = updateService;            // Update the service value after vm changes
        vm.changeResultIndex        = changeResultIndex;        // React to changing results indexes
        vm.defaultIndexes           = defaultIndexes;           // Sets up the indexes for the show array
        vm.saveFile                 = saveFile;                 // Update a dataset in the database
        vm.showSmallModal           = showSmallModal;
        vm.showMediumModal          = showMediumModal;
        vm.favoriteItem             = favoriteItem;
        vm.removeFavItem            = removeFavItem;
        vm.showMessage              = showMessage;
        vm.updateUserInfo           = updateUserInfo;
        vm.goToURL                  = goToURL;

        window.MY_SCOPE = vm;

        // Data
        if (datasetMemoryFactory.currentURL == window.location.href.replace(/\~2F/g,'/') &&
            (datasetMemoryFactory.cadwolf_fileInfo!==undefined))
        {
            console.log('Setting data from service');
            vm.cadwolf_fileInfo = datasetMemoryFactory.cadwolf_fileInfo;
        }

        vm.initialize();



        /*
         * Set the initial parameters
         *
         */
        function initialize()
        {   
            if (Spark.state.user!=null)
            {
                if (typeof(Spark.state.user.user_info)=='string')
                {
                    Spark.state.user.user_info = JSON.parse( Spark.state.user.user_info );
                    Spark.state.user.photo_url = Spark.state.user.photo_url.replace(window.location.origin+'/', '')
                }
            }
            if ((window.location.href==window.location.origin+'/Dataset') ||
                (window.location.href==window.location.origin+'/Dataset/'))
            {
                vm.showType = 'DatasetEmpty';

            }else
            {
                vm.showType = '';
                if (datasetMemoryFactory.currentURL != window.location.href.replace(/\~2F/g,'/'))
                {
                    console.log('Initialization function called with '+window.location.href);

                    $http({
                      method: 'GET',
                      url: window.location.origin+'/files',
                      params:{ thisURL : window.location.href.replace(/\~2F/g,'/') }
                    }).then(function successCallback( returnData ) {
                            console.log('Return data is ');
                            console.log(returnData.data);
                            vm.cadwolf_permissions = returnData['data']['permissions'];
                            vm.cadwolf_fileInfo = returnData['data']['fileInfo'];
                            if (Spark.state !== undefined )
                            {
                                Spark.state.user.user_info = utilityFactory.setRecent( 'Dataset', vm.cadwolf_fileInfo, Spark.state.user.user_info, window.location.pathname ); 
                                vm.cadwolf_fileInfo.favorite = utilityFactory.checkFavorite( 'Dataset', vm.cadwolf_fileInfo, Spark.state.user.user_info, window.location.pathname );
                                vm.updateUserInfo();
                            }
                            if ( typeof(vm.cadwolf_fileInfo.item_data)=="string" )
                            {
                                vm.cadwolf_fileInfo.item_data = JSON.parse( vm.cadwolf_fileInfo.item_data );
                            }


                            
                            /**
                             *
                             * This is the code that facilitates the amplitude analytics code
                             *
                             */
                            if ( window.amplitude === undefined )
                            {
                                var e=window;
                                var t=document
                                var n=e.amplitude||{_q:[],_iq:{}};var r=t.createElement("script")
                                  ;r.type="text/javascript";r.async=true
                                  ;r.src="https://cdn.amplitude.com/libs/amplitude-4.4.0-min.gz.js"
                                  ;r.onload=function(){if(e.amplitude.runQueuedFunctions){
                                  e.amplitude.runQueuedFunctions()}else{
                                  console.log("[Amplitude] Error: could not load SDK")}}
                                  ;var i=t.getElementsByTagName("script")[0];i.parentNode.insertBefore(r,i)
                                  ;function s(e,t){e.prototype[t]=function(){
                                  this._q.push([t].concat(Array.prototype.slice.call(arguments,0)));return this}}
                                  var o=function(){this._q=[];return this}
                                  ;var a=["add","append","clearAll","prepend","set","setOnce","unset"]
                                  ;for(var u=0;u<a.length;u++){s(o,a[u])}n.Identify=o;var c=function(){this._q=[]
                                  ;return this}
                                  ;var l=["setProductId","setQuantity","setPrice","setRevenueType","setEventProperties"]
                                  ;for(var p=0;p<l.length;p++){s(c,l[p])}n.Revenue=c
                                  ;var d=["init","logEvent","logRevenue","setUserId","setUserProperties","setOptOut","setVersionName","setDomain","setDeviceId","setGlobalUserProperties","identify","clearUserProperties","setGroup","logRevenueV2","regenerateDeviceId","logEventWithTimestamp","logEventWithGroups","setSessionId","resetSessionId"]
                                  ;function v(e){function t(t){e[t]=function(){
                                  e._q.push([t].concat(Array.prototype.slice.call(arguments,0)))}}
                                  for(var n=0;n<d.length;n++){t(d[n])}}v(n);n.getInstance=function(e){
                                  e=(!e||e.length===0?"$default_instance":e).toLowerCase()
                                  ;if(!n._iq.hasOwnProperty(e)){n._iq[e]={_q:[]};v(n._iq[e])}return n._iq[e]}
                                  ;e.amplitude=n;

                                 amplitude.getInstance().init("85374354a72a1d05529735dc0be7f8d8");
                            }

                            // Send the amplitude data
                            if ( Spark.state !== undefined )
                            {
                                if (Spark.state.user!=null)
                                { 
                                    amplitude.getInstance().setUserId( Spark.state.user.id );
                                }
                            }

                            // Send the amplitude data
                            amplitude.getInstance().logEvent("Dataset View",
                                { title: vm.cadwolf_fileInfo.name,
                                  id: vm.cadwolf_fileInfo.id });

                            vm.defaultIndexes();
                            vm.updateService();
                            vm.created = new Date(vm.cadwolf_fileInfo.created_at);
                            vm.modified = new Date(vm.cadwolf_fileInfo.updated_at);
                            document.title = "CADWOLF - Dataset - "+vm.cadwolf_fileInfo.item_data.name;
                            vm.viewPerm = returnData['data']['permissions']['view'] || false;
                            vm.editPerm = returnData['data']['permissions']['edit'] || false;
                            vm.showType = 'DatasetSetup';

                            if ( returnData.data.fileInfo.file_type_id == 'Workspace' )
                            {
                                $location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Document/, '\/Workspace'));
                            }
                            if ( returnData.data.fileInfo.file_type_id == 'Document' )
                            {
                                $location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Document/, '\/Document'));
                            }
                            if ( returnData.data.fileInfo.file_type_id == 'PartTree' )
                            {
                                $location.path(window.location.href.replace(window.location.origin+'','').replace(/^\/Document/, '\/PartTree'));
                            }

                      }, function errorCallback( returnData ) {
                            vm.showType = 'DatasetSetup';
                            vm.cadwolf_fileInfo = [];
                    });
                    vm.getSpark();
                }
            }
        }






        /*
         *
         * Get the spark parameters
         *
         */
        function getSpark( )
        {   
            console.log('In the get spark function');
            $http({
                method: "GET",
                url: window.location.origin+'/user/current'

            }).then(function successCallback( returnData ) 
            {
                console.log('The spark data is ...');
                console.log(returnData.data);
                returnData.data.user_info = JSON.parse(returnData.data.user_info);
                Spark.state.user = returnData.data;
                Spark.state.user.photo_url = Spark.state.user.photo_url.replace(window.location.origin+'/', '')
            });

        }






        /*
         * Set the default indexes for the show - on initialize and new data
         *
         */
        function defaultIndexes()
        {   
            console.log('Setting the default indices');
            vm.splitSizes = vm.cadwolf_fileInfo.item_data.size.split('x'); 
            vm.numIndices = vm.splitSizes.length;
            vm.cadwolf_fileInfo.item_data.indexes = [];
            for (var a=0; a<vm.numIndices; a++)
            {
                vm.cadwolf_fileInfo.item_data.indexes[a] = {};
                if ((a==0) || (a==1))
                {
                    vm.cadwolf_fileInfo.item_data.indexes[a]['start'] = 0;
                    vm.cadwolf_fileInfo.item_data.indexes[a]['end'] = vm.splitSizes[a]-1;
                    vm.cadwolf_fileInfo.item_data.indexes[a]['text'] = ':';
                    vm.cadwolf_fileInfo.item_data.indexes[a]['index'] = 0;
                    vm.cadwolf_fileInfo.item_data.indexes[a]['active'] = true;
                    vm.cadwolf_fileInfo.item_data.indexes[a]['class'] = 'activeIndex';
                }else
                {
                    vm.cadwolf_fileInfo.item_data.indexes[a]['start'] = 0;
                    vm.cadwolf_fileInfo.item_data.indexes[a]['end'] = 0;
                    vm.cadwolf_fileInfo.item_data.indexes[a]['text'] = '0';                    
                    vm.cadwolf_fileInfo.item_data.indexes[a]['index'] = 0;
                    vm.cadwolf_fileInfo.item_data.indexes[a]['active'] = false;
                    vm.cadwolf_fileInfo.item_data.indexes[a]['class'] = 'inactiveIndex';
                }
            }

            vm.cadwolf_fileInfo.item_data.showResults = utilityFactory.retrieveSubmatrix( vm.cadwolf_fileInfo.item_data.real, vm.cadwolf_fileInfo.item_data.indexes);
            vm.cadwolf_fileInfo.item_data.showArray = utilityFactory.makeArray( vm.cadwolf_fileInfo.item_data.showResults );
        }






        /*
         *
         *  Get the data for the file
         *
         */
        function getFileData( thisURL )
        {
            $http({
              method: 'GET',
              url: window.location.origin+'/files',
              params:{ thisURL : thisURL }
            }).then(function successCallback( returnData ) {
                    console.log('Return data is ');
                    console.log(returnData.data);
                    vm.cadwolf_permissions = returnData['data']['permissions'];
                    vm.cadwolf_fileInfo = returnData['data']['fileInfo'];
                    if ( typeof(vm.cadwolf_fileInfo.item_data)=="string" )
                    {
                        vm.cadwolf_fileInfo.item_data = JSON.parse( vm.cadwolf_fileInfo.item_data );
                    }
              }, function errorCallback( returnData ) {
                    vm.cadwolf_fileInfo = [];
            });

        }








        /*
         *
         * Call a function from the left menu
         *
         */
        function leftMenuCaller( event, menuItem, flag )
        {   
            console.log('In the left menu caller with '+menuItem);

            if (menuItem == 'Settings')
            {
                vm.showType='DatasetSetup';
            }
            if (menuItem == 'Input Text')
            {
                vm.showType='DatasetInput';
            }
            if (menuItem == 'Results')
            {
                vm.showType='DatasetResults';
            }
            if (menuItem == 'Edit Title')
            {
                vm.showSmallModal( event, menuItem ) 
            
            }else if (menuItem == 'Edit Description')
            {
                vm.showMediumModal( event, menuItem ) 

            }else if (menuItem == 'Parse Text')
            {
                vm.parseDatasetText();


            }else if (menuItem == 'Save File')
            {
                vm.saveFile();
            }
        }







        /*
         * read an text file
         *
         */
        function readFile(event)
        {   var myData=event;
            vm.reader = new FileReader();
            if(event.target.files && event.target.files[0]) {           
                vm.reader.onload = function (e) {
                var newString = e.target.result;
                vm.applyFile(newString);
                };//end onload()
                vm.reader.readAsText(event.target.files[0]);

                console.log('The reader is '+vm.reader);
            }//end if html5 filelist support
            else if(ActiveXObject && filePath) { //fallback to IE 6-8 support via ActiveX
                try {
                    vm.reader = new ActiveXObject("Scripting.FileSystemObject");
                    var file = reader.OpenTextFile(event.target, 1); //ActiveX File Object
                    vm.newString = file.ReadAll(); //text contents of file
                    file.Close(); //close file "input stream"
                    vm.applyFile(newString);
                } catch (e) {
                    if (e.number == -2146827859) {
                        alert('Unable to access local files due to browser security settings. ' + 
                         'To overcome this, go to Tools->Internet Options->Security->Custom Level. ' + 
                         'Find the setting for "Initialize and script ActiveX controls not marked as safe" and change it to "Enable" or "Prompt"'); 
                    }
                }       
            }
        };   






        /*
         * read an excel file
         *
         */
        function readExcel(e) 
        {   
            var newString='';
            var files = e.target.files;
            var i,f;
            for (i = 0, f = files[i]; i != files.length; ++i) 
            {   
                var reader = new FileReader();
                var name = f.name;
                reader.onload = function(e) 
                {   
                    var data = e.target.result;
                    var workbook = XLSX.read(data, {type: 'binary'});
                    var index=0;
                    for (var thisBook in workbook.Sheets)
                    {   
                        var thisText=XLSX.utils.sheet_to_csv(workbook['Sheets'][thisBook]);
                        thisText=thisText.replace(/\,\,/g,'').replace(/[\r\n\r\n]/g,'').replace(/^\,|\,$/,'').replace(/\,/,vm.cadwolf_fileInfo.item_data.parsers[0]).replace(/[\r\n]/,vm.cadwolf_fileInfo.item_data.parsers[1]);
                        if (index==0) { newString=thisText; }else { newString=newString+''+vm.cadwolf_fileInfo.item_data.parsers[2]+''+thisText; }
                        index++;
                    }
                    console.log('The append overwrite is '+vm.appendOverwrite);
                    console.log('The data is '+newString);
                    if ((vm.appendOverwrite == "false") || (!vm.appendOverwrite))   { vm.inputString=newString; }
                    if ((vm.appendOverwrite == "true") || (vm.appendOverwrite))     { vm.inputString=vm.inputString+''+newString; }
                };
                reader.readAsBinaryString(f);
            }
        };







        /*
         * Break the text file up into chunks that are offered to the user
         *
         */
        function applyFile($fileContent)
        {   
            console.log('In the apply file function with the contents of '+$fileContent);
            var reText='';
            for (var a=0; a<5; a++){ reText=reText+"\\"+vm.cadwolf_fileInfo.item_data.parsers[a]; }   
            var re=new RegExp('['+reText+'0-9\.]+','g');
            vm.availableText=[];
            var textIndex=0;
            var splitText=$fileContent.match(re);
            for (var a=0; a<splitText.length; a++)
            {   
                if((splitText[a].match(/[0-9\.]+/)!=splitText[a])&&(splitText[a].match(/[0-9\.]+/)!=null))
                {   
                    vm.availableText[textIndex]={};
                    vm.availableText[textIndex]['text']=splitText[a];
                    vm.availableText[textIndex]['id']=textIndex;
                    vm.availableText[textIndex]['status']=true;
                    vm.availableText[textIndex]['parser']=vm.cadwolf_fileInfo.item_data.parsers[0];
                    textIndex=textIndex+1;
                }  
            }  
            vm.showAvailableText(vm.availableText);
        }






        /*
         *
         * Make an item a favorite
         *
         */
        function favoriteItem( ) 
        {   
            Spark.state.user.user_info = utilityFactory.favoriteItem( 'Dataset', 
                                                                      vm.cadwolf_fileInfo, 
                                                                      Spark.state.user.user_info, 
                                                                      window.location.pathname.replace(/^\/Dataset\//,'') ); 
            console.log('The item returned from the factory is '+Spark.state.user.user_info);
            vm.cadwolf_fileInfo.favorite=!vm.cadwolf_fileInfo.favorite; 
            vm.updateUserInfo();
        };





        /*
         *
         * Remove a favorite
         *
         */
        function removeFavItem( thisItem ) 
        {   
            Spark.state.user.user_info = utilityFactory.favoriteItem( 'Dataset', 
                                                                      thisItem, 
                                                                      Spark.state.user.user_info, 
                                                                      window.location.pathname.replace(/^\/Dataset\//,'') ); 
            vm.updateUserInfo();
        };





        /**
         *
         * Navigate to a given URL
         *
         */
        function goToURL( thisURL )
        {
            $location.path(thisURL);
        }





        /*
         *
         * Update User Info
         *
         */
        function updateUserInfo( ) 
        {   
            $http({
                method: 'PUT',
                url: window.location.origin+'/updateUserInfo',
                data:{ userID : Spark.state.user.id, thisUser : Spark.state.user.user_info }
            }).then(function successCallback( returnData ) {
            }, function errorCallback( returnData ) {});
        };









        /*
         * The available text blocks after a file is parsed
         */
        function showAvailableText(availableText) 
        {
            $mdDialog.show({
                controller: 'DatasetDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/dataset/views/availableText.tmpl.html',
                locals:{
                    availableText:availableText
                },
                parent: angular.element(document.body),
                clickOutsideToClose:true,
                fullscreen: true
            })
            .then(function(data) {
                vm.availableText=data;
                vm.compileText();
            }, function() {
                
            });
        };






        /*
         * Piece the accepted chunks back together
         *
         */
        function compileText()
        {   
            console.log('In the compile text function');
            vm.dataAvailable=false;
            var thisString='';
            for (var a=0; a<Object.keys(vm.availableText).length; a++)
            {   
                if(vm.availableText[a]['status'])
                {
                    thisString=thisString+''+vm.availableText[a]['text']+''+vm.availableText[a]['parser']; 
                }
            }
            var reText='';
            for (var a=0; a<5; a++){ reText=reText+"\\"+vm.cadwolf_fileInfo.item_data.parsers[a]; }   
            var re=new RegExp('['+reText+']$');
            thisString=thisString.replace(re,'');
            console.log('The append overwrite is '+vm.appendOverwrite);
            if ((vm.appendOverwrite == "false") || (!vm.appendOverwrite)) 
            { 
                vm.cadwolf_fileInfo.item_data.inputString=thisString; 
            }
            if ((vm.appendOverwrite == "true") || (vm.appendOverwrite))
            {
                vm.cadwolf_fileInfo.item_data.inputString=vm.cadwolf_fileInfo.item_data.inputString+''+thisString; 
            }
        };

    





        /*
        * Function to actually parse text.
        *
        */
        function parseDatasetText( )
        {   
            console.log('Parsing the text');
            vm.cadwolf_fileInfo.item_data.realArray = vm.parseMe( vm.cadwolf_fileInfo.item_data.inputString, vm.cadwolf_fileInfo.item_data.parsers );
            vm.cadwolf_fileInfo.item_data.real={};
            vm.arrayToObject( vm.cadwolf_fileInfo.item_data.realArray, '' );
            vm.cadwolf_fileInfo.item_data.size = utilityFactory.getSize( vm.cadwolf_fileInfo.item_data.real );
            vm.defaultIndexes();
            vm.updateService();
        };

        function parseMe(xs, delimiters) {
          if (!delimiters.length) return xs;
            return xs.split(delimiters[0]).map(function(x){ 
                return parseMe(x, delimiters.slice(1))
            } );
        };





        /*
        * 
        *
        */
        function arrayToObject ( thisArray, key ) 
        {   
            var thisKey = JSON.parse(JSON.stringify(key));
            for (var a=0; a<thisArray.length; a++)
            {
                thisKey=a+'-'+key;
                if (typeof(thisArray[a])=='object')
                {
                    this.arrayToObject( thisArray[a], a+'-'+key  );
                }else
                {
                    var splitKey = thisKey.split('-');
                    var newKey = splitKey[1]+'-'+splitKey[0];
                    for (var b=2; b<splitKey.length; b++){ newKey = newKey+'-'+splitKey[b]; }
                    newKey=newKey.replace(/-$/,'');
                    vm.cadwolf_fileInfo.item_data.real[newKey] = thisArray[a];
                }
            }
            vm.updateService();
            
        };







        /*
         * Update the service from the controller
         *
         */
        function updateService( )
        {   
            console.log('Updating the service' );
            datasetMemoryFactory.cadwolf_fileInfo = vm.cadwolf_fileInfo;
            datasetMemoryFactory.currentURL = window.location.href.replace(/\~2F/g,'/');
        }        


        /*
         * Change the displayed data for the results page
         *
         */
        function changeResultIndex(  )
        {   
            console.log('Reacting to the changing index');

            vm.splitSizes = vm.size.split('x'); 
            vm.numIndices = vm.splitSizes.length;
            var count = 0;
            var errorFlag=false;
            vm.errorMessage='';
            
            for (var a=0; a<vm.numIndices; a++)
            {
                if (vm.indexes[a]['start']!=vm.indexes[a]['end'])
                {
                    count=count+1;
                    vm.indexes[a]['active']=true;
                }else
                {
                    vm.indexes[a]['active']=false;
                }
                vm.indexes[a]['index'] = vm.indexes[a]['start'];
            }
            if (count>2)
            {
                errorFlag=true;
                vm.errorMessage = "Too many dimensions had more than one index";
            }else
            {
                if ((count==1)&&(!vm.indexes[0]['active'])) { vm.indexes[0]['active']=true; }
                if ((count==1)&&(vm.indexes[0]['active'])) { vm.indexes[1]['active']=true; }
            }

            if (!errorFlag)
            {
                vm.showResults = utilityFactory.retrieveSubmatrix( vm.real, vm.indexes);
                vm.showArray = utilityFactory.makeArray( vm.showResults );
                datasetMemoryFactory.showResults = vm.showResults;
                datasetMemoryFactory.showArray = vm.showArray;
                datasetMemoryFactory.indexes = vm.indexes;
            }
            vm.updateService( 'errorMessage' );

        }        






        /*
         *
         * Update the dataset in the database
         *
         */
        function saveFile( ) 
        {   
            console.log('Updating '+vm.cadwolf_fileInfo['id']+' with '+vm.cadwolf_fileInfo['name']+'-'+vm.cadwolf_fileInfo['parent_id']);
            $http({
              method: 'PUT',
              url: window.location.origin+'/files/'+vm.cadwolf_fileInfo['id'],
                data: { name : vm.cadwolf_fileInfo['name'],
                        parent_id : parseInt(vm.cadwolf_fileInfo['parent_id'], 10),
                        item_data : vm.cadwolf_fileInfo['item_data']
                      }
            }).then(function successCallback( returnData ) {
                vm.showMessage( '', { messageType : 'success', 
                                      messageTitle : 'File Saved', 
                                      messageText : 'The file was successfully saved. You can continue editing it or exit.'});
              }, function errorCallback( returnData ) {
            });

        };



        /*
         *
         * Show an error or success message
         *
         */
        function showMessage(ev, messageObj) 
        {
            if (messageObj.messageType=="success")
            {
                var templateURL = 'app/main/apps/document/worksheet/views/templates/successMessage.tmpl.html';
            }
            if (messageObj.messagType=="failure")
            {
                var templateURL = 'app/main/apps/document/worksheet/views/templates/failureMessage.tmpl.html';
            }

            $mdDialog.show({
                controller: 'DocumentDialogController',
                templateUrl: templateURL,
                locals:{
                    messageObj:messageObj,
                },
                controllerAs: 'vm',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true
            })
            .then(function(data) {}, function() { });
        };







        /**
         *
         * SHOW THE SMALL MODAL WINDOW
         *
         */
        function showSmallModal( ev, modalType ) 
        {
            console.log('The modal type for the small modal is '+modalType);
            $mdDialog.show({
                controller: 'DatasetDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/dataset/views/smallModalTemplates.tmpl.html',
                locals:{
                    thisItem:vm.cadwolf_fileInfo,
                    modalType:modalType,
                    fileInfo : vm.cadwolf_fileInfo
                },
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true
            })
            .then(function(newName) {
                console.log('The data from the modal window is ');
                console.log(newName);
                if ( modalType == 'Edit Title' )
                {
                    vm.cadwolf_fileInfo.item_data.title=newName;
                }
            });
        };


        /**
         *
         * SHOW THE MEDIUM MODAL WINDOW
         *
         */
        function showMediumModal( ev, modalType ) 
        {
            console.log('The modal type for the small modal is '+modalType);
            $mdDialog.show({
                controller: 'DialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/dataset/views/mediumModalTemplates.tmpl.html',
                locals:{
                    thisItem:vm.cadwolf_fileInfo,
                    modalType:modalType,
                    fileInfo : vm.cadwolf_fileInfo
                },
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: true
            })
            .then(function(data) {
                if ( modalType == 'Edit Description' )
                {
                    vm.cadwolf_fileInfo.item_data.description = $sce.trustAsHtml(data);
                }
            });
        };




    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.constant', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.constant', {
            url      : '/constants/',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/constant/constant.html',
                    controller : 'ConstantController as vm'
                }
            },
            bodyClass: 'constant'

        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/constant');

        // Navigation
        msNavigationServiceProvider.saveItem('constant', {
            title : 'Constants',
            icon  : 'icon-scale',
            state : 'app.constant',
            weight: 10
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.constant')
        .controller('ConstantController', ConstantController);

    /** @ngInject */
    function ConstantController(unitConstantFactory)
    {
        var vm = this;

        // Data
        vm.constantData = unitConstantFactory.constObj();
        MathJax.Hub.Configured();
        MathJax.Hub.Queue(["Typeset", MathJax.Hub]);

        console.log('The number of constants are '+vm.constantData.length);

        // Methods

        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.connect', [])
        .config(config);


    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $locationProvider)
    {

        // State
        $stateProvider.state('app.connect', {
            url      : '/Connects/{path:.*}',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/connect/connect.html',
                    controller : 'ConnectController as vm'
                }
            },
            bodyClass: 'connect'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/connect');

        // Navigation
        msNavigationServiceProvider.saveItem('connect', {
            title : 'CAD Connections',
            icon  : 'icon-routes',
            state : 'app.connect',
            weight: 3
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.connect')
        .controller('ConnectController', ConnectController);

    /** @ngInject */
    function ConnectController( $location, $mdSidenav, $http, utilityFactory, documentMemoryFactory )
    {
        // Default Items
        var vm = this;
        window.MY_SCOPE=this;
        
        // Methods
        vm.init         = init;
        vm.getFiles     = getFiles;
        vm.select       = select;
        vm.navigateURL  = navigateURL;
        vm.goToURL      = goToURL;
        vm.setFactory   = setFactory;
        //////////


        /**
         *
         *  Initial program - get the files
         *
         */
        function init()
        {
            console.log('In the init function');

            vm.cadID = '';
            if (Spark.state.user!=null)
            {
                if (typeof(Spark.state.user.user_info)=='string')
                {
                    Spark.state.user.user_info = JSON.parse( Spark.state.user.user_info );
                    Spark.state.user.photo_url = Spark.state.user.photo_url.replace(window.location.origin+'/', '')
                }
            }
            
            vm.getFiles($location.absUrl());
        
        }




        /**
         *
         *  Get the files connected to this CAD ID
         *
         */
        function getFiles( )
        {
          // document.title = "CADWOLF - Files connected with CAD";
          // thisURL = thisURL.replace('https://www.cadwolf.com/Connects/onShape/','');
          // thisURL = thisURL.replace('http://www.cadwolf.com/Connects/onShape/','');
          // thisURL = thisURL.replace('www.cadwolf.com/Connects/onShape/','');
          // var urlItems = thisURL.split('/');
          // var documentID = urlItems[0];
          // var workspaceID = urlItems[1];
          // var elementID = urlItems[2];
          // var server = urlItems[3];
          // var userID = urlItems[4];
          // vm.setFactory( thisURL );
          // console.log('In the get files, the IDs are ...');
          // console.log('documentID - '+documentID+' - workspaceID - '+workspaceID+' - elementID - '+elementID+' - userID - '+userID);
          $http({
            method: 'GET',
            url: window.location.origin+'/connected/'+vm.cadID
          }).then(function successCallback( returnData ) {
                  console.log('Return data is ');
                  console.log(returnData.data);
                  vm.connectFiles = returnData.data.data.files;

            }, function errorCallback( returnData ) {
                  vm.connectFiles = [];
          });
        }




        /**
         * Select an item
         *
         * @param item
         */
        function select(item)
        {
            vm.selected = item;
        }





        /**
         *
         * Navigate to a new file, folder, etc
         *
         */
        function navigateURL( fileItem )
        {
            var newURL=utilityFactory.makeURL( fileItem, window.location.href );
            $location.path(newURL.replace(window.location.origin+'',''));
        }



        /**
         *
         * Navigate to a given URL
         *
         */
        function goToURL( thisURL )
        {
            $location.path(thisURL.replace(/ /g, '_'));
        }






        /**
         *
         *  SET FACTORY WITH ONSHAPE PARAMETERS
         *
         */
        function setFactory( thisURL )
        {
          console.log('Setting the factory');
          console.log(thisURL);
          var urlItems = thisURL.split('/');
          var documentID = urlItems[0];
          var workspaceID = urlItems[1];
          var elementID = urlItems[2];
          var server = urlItems[3];
          var userID = urlItems[4];
          documentMemoryFactory.connected = 1;
          documentMemoryFactory.onShape = {};
          documentMemoryFactory.onShape.documentId = documentID;
          documentMemoryFactory.onShape.workspaceId = workspaceID;
          documentMemoryFactory.onShape.elementId = elementID;
          documentMemoryFactory.onShape.server = server;
          documentMemoryFactory.onShape.userId = userID;
          console.log(documentMemoryFactory.onShape.documentId+' - '+documentMemoryFactory.onShape.workspaceId+' - '+documentMemoryFactory.onShape.elementId+' - '+documentMemoryFactory.onShape.server+' - '+documentMemoryFactory.onShape.userId);
        }






        vm.init();


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.bugReport', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.bugReport', {
            url      : '/bugReport/',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/bugReport/bugReport.html',
                    controller : 'BugController as vm'
                }
            },
            bodyClass: 'bugReport'

        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/bugReport');

        // Navigation
        msNavigationServiceProvider.saveItem('bugReport', {
            title : 'Bug Report',
            icon  : 'icon-bug',
            state : 'app.bugReport',
            weight: 12
        });
    }

})();


(function ()
{
    'use strict';

    angular
        .module('app.bugReport')
        .controller('BugController', BugController);

    /** @ngInject */
    function BugController()
    {
        var vm = this;

        // Data

        // Methods

        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'textAngular',
                
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('tableOfContentsController', tableOfContentsController)
        .directive('tableOfContents', tableOfContentsDirective);

    /** @ngInject */
    function tableOfContentsController($scope, $document, $q, msNavigationService)
    {


    }

    /** @ngInject */
    function tableOfContentsDirective()
    {
        return {
            restrict        : 'E',
            scope           : '=',
            require         : 'tableOfContents',
            controller      : 'tableOfContentsController as tableOfContents',
            bindToController: {},
            templateUrl     : 'app/core/directives/table-of-contents/table-of-contents.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('tableOfContents');

            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('PartTreeLimbController', PartTreeLimbController)
        .directive('partTreeLimb', partTreeLimbDirective);

    /** @ngInject */
    function PartTreeLimbController($scope, $document, $q, msNavigationService, $attrs)
    {
        var vm = this;
        vm.loadTree = loadTree;
        window.MY_VAR = $attrs;


        init();

        function init()
        {
            // Load the Tree
            vm.loadTree( $attrs['limbid'] ).then(
                // Success
                function (response)
                {
                    vm.thisLimb = response;
                }
            );

        }


        /**
         * Load part tree.
         * In the future, this should pull data from the database. Now, it is hard coded
         */
        function loadTree( limbID )
        {

            console.log('The limbid attribute is '+limbID);

            var deferred = $q.defer();

            var treeChildren = [
          {
              "id":"1111",
              "name":"Orion",
              "parentID":"31111"
          },
          {
              "id":"1112",
              "name":"Atlas",
              "parentID":"31111"
          },
          {
              "id":"1113",
              "name":"SLS",
              "parentID":"31111"
          },
          {
              "id":"1114",
              "name":"Capsule",
              "parentID":"31111"
          },
          {
              "id":"1115",
              "name":"Rocket",
              "parentID":"1113"
          },
          {
              "id":"1116",
              "name":"LAS",
              "parentID":"1113"
          },
          {
              "id":"1117",
              "name":"001",
              "parentID":"1114"
          },
          {
              "id":"1118",
              "name":"002",
              "parentID":"1114"
          },
          {
              "id":"1119",
              "name":"003",
              "parentID":"1114"
          },
          {
              "id":"1120",
              "name":"001",
              "parentID":"1115"
          },
          {
              "id":"1121",
              "name":"002",
              "parentID":"1115"
          },
          {
              "id":"1122",
              "name":"003",
              "parentID":"1115"
          }            ];


            // Resolve the promise
            deferred.resolve( treeChildren );

            return deferred.promise;

        }

    }

    /** @ngInject */
    function partTreeLimbDirective()
    {
        return {
            restrict        : 'E',
            scope           : '=',
            require         : 'partTreeLimb',
            controller      : 'PartTreeLimbController as partTreeLimb',
            bindToController: {},
            templateUrl     : 'app/core/directives/partTreeLimb/part-tree-limb.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('part-tree-limb');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element('#content');
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msStepper', msStepperDirective)
        .directive('msStepperStep', msStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            })
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            // Hide all steps
            for ( var i = 0; i < vm.steps.length; i++ )
            {
                vm.steps[i].element.hide();
            }

            // Show the current step
            vm.steps[vm.currentStepNumber - 1].element.show();
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            vm.setCurrentStep(vm.currentStepNumber - 1);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            vm.setCurrentStep(vm.currentStepNumber + 1);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msStepperDirective()
    {
        return {
            restrict        : 'A',
            require         : ['form', 'msStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        }
    }

    /** @ngInject */
    function msStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {

        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;
        vm.changeActive = changeActive;
        vm.init = init;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;


        /*
        *
        *   SHORTCUT FUNCTIONS
        *
        */
        function changeActive(activeName)
        {   
            vm.shortcuts.forEach(function(shortcutItem) 
            {
                if(activeName == shortcutItem['title'])
                {
                    shortcutItem['status'] = true;
                }else
                {
                    shortcutItem['status'] = false;
                }
            });
        };



        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            //var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            var thisPath = window.location.pathname;

            var shortcuts=[];

            if ((thisPath.match(/\/Plot\/[0-9a-zA-Z]+/)!==null) ||
                (thisPath.match(/\/plot\/[0-9a-zA-Z]+/)!==null) ||
                (thisPath.match(/\/surface\/[0-9a-zA-Z]+/)!==null) ||
                (thisPath.match(/\/Surface\/[0-9a-zA-Z]+/)!==null))
            { 

                shortcuts = [
                    {
                        'title'      : 'View Specifics',
                        'icon'       : 'icon-cog',
                        'state'      : 'app.plot',
                        'weight'     : 5,
                        'children'   : [],
                        '_id'        : 'plot',
                        '_path'      : 'apps.plot',
                        'uisref'     : 'app.plot',
                        'clickAction': true,
                        'actionNum'  : "1",
                        'status'  : true,
                        'hasShortcut': true
                    }
                ];
            }



            if ((thisPath.match(/\/Dataset\/[0-9a-zA-Z]+/)!==null) ||
                (thisPath.match(/\/dataset\/[0-9a-zA-Z]+/)!==null))
            { 

                shortcuts = [
                    {
                        'title'      : 'Setup',
                        'icon'       : 'icon-cog',
                        'state'      : 'app.dataset.setup',
                        'weight'     : 5,
                        'children'   : [],
                        '_id'        : 'setup',
                        '_path'      : 'apps.dataset.setup',
                        'uisref'     : 'app.dataset.setup',
                        'status'     : true,
                        'clickAction': false,
                        'hasShortcut': true
                    }, {
                        'title'      : 'Input Text',
                        'icon'       : 'icon-format-size',
                        'state'      : 'app.dataset.parse',
                        'weight'     : 5,
                        'children'   : [],
                        '_id'        : 'parse',
                        '_path'      : 'apps.dataset.parse',
                        'uisref'     : 'app.dataset.parse',
                        'status'     : false,
                        'clickAction': false,
                        'hasShortcut': true
                    }, {
                        'title'      : 'Results',
                        'icon'       : 'icon-grid',
                        'state'      : 'app.dataset.results',
                        'weight'     : 5,
                        'children'   : [],
                        '_id'        : 'results',
                        '_path'      : 'apps.dataset.results',
                        'uisref'     : 'app.dataset.results',
                        'status'     : false,
                        'clickAction': false,
                        'hasShortcut': true
                    }
                ];

                shortcuts = [];

            }





            if ((thisPath.match(/\/parttree\/[0-9a-zA-Z]+/)!==null) ||
                (thisPath.match(/\/partTree\/[0-9a-zA-Z]+/)!==null) ||
                (thisPath.match(/\/PartTree\/[0-9a-zA-Z]+/)!==null))
            { 

                shortcuts = [
                    {
                        'title'      : 'Setup',
                        'icon'       : 'icon-cog',
                        'state'      : 'app.parttree.setup',
                        'weight'     : 5,
                        'children'   : [],
                        '_id'        : 'setup',
                        '_path'      : 'apps.parttree.setup',
                        'uisref'     : 'app.parttree.setup',
                        'status'     : true,
                        'clickAction': false,
                        'hasShortcut': true
                    }, {
                        'title'      : 'Part Tree',
                        'icon'       : 'icon-sitemap',
                        'state'      : 'app.parttree.parttree',
                        'weight'     : 5,
                        'children'   : [],
                        '_id'        : 'tree',
                        '_path'      : 'apps.parttree.parttree',
                        'uisref'     : 'app.parttree.parttree',
                        'status'     : false,
                        'clickAction': false,
                        'hasShortcut': true
                    }
                ];
            }






            if ((thisPath.match(/\/document\/[0-9a-zA-Z]+/)!==null) ||
                (thisPath.match(/\/Document\/[0-9a-zA-Z]+/)!==null))
            { 

                shortcuts = [
                    {
                        'title'      : 'Worksheet',
                        'icon'       : 'icon-file-document-box',
                        'state'      : 'app.document.worksheet',
                        'weight'     : 5,
                        'children'   : [],
                        '_id'        : 'worksheet',
                        '_path'      : 'apps.document.worksheet',
                        'uisref'     : 'app.document.worksheet',
                        'status'     : true,
                        'clickAction': false,
                        'hasShortcut': true
                    }, {
                        'title'      : 'Properties',
                        'icon'       : 'icon-key-variant',
                        'state'      : 'app.document.properties',
                        'weight'     : 5,
                        'children'   : [],
                        '_id'        : 'properties',
                        '_path'      : 'apps.document.properties',
                        'uisref'     : 'app.document.properties',
                        'status'     : false,
                        'clickAction': false,
                        'hasShortcut': true
                    }
                ];
            }

            
            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {

                              },
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: true,
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    scope.$root.$on('$locationChangeSuccess', function(event){
                            scope.MsShortcuts.init();
                    });
                    // Data
                };
            },
            link: function($scope, $element, $attrs) {
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : true,
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem           : saveItem,
                deleteItem         : deleteItem,
                sort               : sortByWeight,
                clearNavigation    : clearNavigation,
                setActiveItem      : setActiveItem,
                getActiveItem      : getActiveItem,
                getNavigationObject: getNavigationObject,
                setNavigationScope : setNavigationScope,
                setFolded          : setFolded,
                getFolded          : getFolded,
                setFoldedOpen      : setFoldedOpen,
                getFoldedOpen      : getFoldedOpen,
                toggleFolded       : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = [];
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @param root
             * @returns {Array}
             */
            function getNavigationObject(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }
                }

                return navigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigationObject($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigationObject();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();

                        // If navigation is folded open, close it
                        if ( msNavigationService.getFolded() )
                        {
                            onFoldCollapserHover();
                        }
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states everything except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPicker($mdMenu, $mdColorPalette, fuseGenerator)
    {
        return {
            require    : 'ngModel',
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function ($scope, element, attrs, ngModel)
            {
                // Material Color Palette
                $scope.palettes = $mdColorPalette;
                $scope.selectedPalette = false;
                $scope.selectedHues = false;

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                $scope.msModelType = $scope.msModelType || 'class';

                /**
                 * Initialize / Watch model changes
                 */
                $scope.$watch('ngModel', setSelectedColor);

                /**
                 * Activate Hue Selection
                 * @param palette
                 * @param hues
                 */
                $scope.activateHueSelection = function (palette, hues)
                {
                    $scope.selectedPalette = palette;
                    $scope.selectedHues = hues;
                };

                /**
                 * Select Color
                 * @type {selectColor}
                 */
                $scope.selectColor = function (palette, hue)
                {
                    // Update Selected Color
                    updateSelectedColor(palette, hue);

                    // Update Model Value
                    updateModel();

                    // Hide The picker
                    $mdMenu.hide();
                };

                $scope.removeColor = function ()
                {

                    $scope.selectedColor = {
                        palette: '',
                        hue    : '',
                        class  : ''
                    };

                    $scope.activateHueSelection(false, false);

                    updateModel();
                };

                /**
                 * Set SelectedColor by model type
                 */
                function setSelectedColor()
                {
                    if ( !ngModel.$viewValue || ngModel.$viewValue === '' )
                    {
                        return;
                    }

                    var palette, hue;

                    // If ModelType Class
                    if ( $scope.msModelType === 'class' )
                    {
                        var color = ngModel.$viewValue.split('-');
                        if ( color.length >= 5 )
                        {
                            palette = color[1] + '-' + color[2];
                            hue = color[3];
                        }
                        else
                        {
                            palette = color[1];
                            hue = color[2];
                        }
                    }
                    // If ModelType Object
                    else if ( $scope.msModelType === 'obj' )
                    {
                        palette = ngModel.$viewValue.palette;
                        hue = ngModel.$viewValue.hue || 500;
                    }

                    // Update Selected Color
                    updateSelectedColor(palette, hue);
                }


                /**
                 * Update Selected Color
                 * @param palette
                 * @param hue
                 */
                function updateSelectedColor(palette, hue)
                {
                    $scope.selectedColor = {
                        palette     : palette,
                        hue         : hue,
                        class       : 'md-' + palette + '-' + hue + '-bg',
                        bgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].value),
                        fgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].contrast)
                    };

                    // If Model object not Equals the selectedColor update it
                    // it can be happen when the model only have pallete and hue values
                    if ( $scope.msModelType === 'obj' && !angular.equals($scope.selectedColor, ngModel.$viewValue) )
                    {
                        // Update Model Value
                        updateModel();
                    }

                    $scope.activateHueSelection(palette, $scope.palettes[palette]);
                }

                /**
                 * Update Model Value by model type
                 */
                function updateModel()
                {
                    if ( $scope.msModelType === 'class' )
                    {
                        ngModel.$setViewValue($scope.selectedColor.class);
                    }
                    else if ( $scope.msModelType === 'obj' )
                    {
                        ngModel.$setViewValue($scope.selectedColor);
                    }
                }
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
	'use strict';

	angular
		.module('app.core')
		// .controller('LeftMenuController', LeftMenuController)
		.directive('leftMenu', leftMenuDirective);


	/** @ngInject */
	function leftMenuDirective($templateRequest, $compile)
	{
		return {
			restrict		: 'E',
			scope		   : { vm : '=' },
			controller : ["$scope", "$element", "$attrs",

				function($scope, $element, $attrs) {

					$scope.$watch('vm.showType', 
						function(){

							$scope.vm.menuSet = {};
							$scope.vm.menuSet.menuItems=[];
							$scope.vm.menuSet.viewItems=[];

							//console.log('The show type is ');
							//console.log($scope.vm.showType);

							if (($scope.vm.showType=="Document")&&($scope.vm.editPerm))
							{ 

								$scope.vm.menuSet.headerOne = 'Add Item';
								$scope.vm.menuSet.headerTwo = 'Document Property';
								$scope.vm.menuSet.showSaveFile = true;
								$scope.vm.menuSet.showSaveTree = false;
								$scope.vm.menuSet.menuType = 'document';

								$scope.vm.menuSet.menuItems = [
									{
										'title'	  : 'Text',
										'icon'	   : 'icon-format-text',
										'addText'	: 'text'
									},
									{
										'title'	  : 'Header',
										'icon'	   : 'icon-format-header-1',
										'addText'	: 'header'
									},
									{
										'title'	  : 'Equation',
										'icon'	   : 'icon-sigma',
										'addText'	: 'equation'
									},
									{
										'title'	  : 'Slider',
										'icon'	   : 'icon-toggle-switch-off',
										'addText'	: 'equation'
									},
									{
										'title'	  : 'Radio',
										'icon'	   : 'icon-radiobox-marked',
										'addText'	: 'equation'
									},
									{
										'title'	  : 'Dropdown',
										'icon'	   : 'icon-cursor-pointer',
										'addText'	: 'equation'
									},
									{
										'title'	  : 'Symbolic',
										'icon'	   : 'icon-link-variant',
										'addText'	: 'symbolic'
									},
									{
										'title'	  : 'Card',
										'icon'	   : 'icon-numeric-5-box-outline',
										'addText'	: 'Card'
									},
									{
										'title'	  : 'Table',
										'icon'	   : 'icon-table',
										'addText'	: 'table'
									},
									{
										'title'	  : 'For Loop',
										'icon'	   : 'icon-redo-variant',
										'addText'	: 'forLoop'
									},
									{
										'title'	  : 'While Loop',
										'icon'	   : 'icon-refresh',
										'addText'	: 'whileLoop'
									},
									{
										'title'	  : 'If Else',
										'icon'	   : 'icon-cube-unfolded',
										'addText'	: 'ifElse'
									},
									{
										'title'	  : '2D Plot',
										'icon'	   : 'icon-chart-line',
										'addText'	: 'plot'
									},
									{
										'title'	  : '3D Chart',
										'icon'	   : 'icon-cube-outline',
										'addText'	: 'chart'
									},
									{
										'title'	  : 'Image',
										'icon'	   : 'icon-camera',
										'addText'	: 'image'
									},
									{
										'title'	  : 'Video',
										'icon'	   : 'icon-video',
										'addText'	: 'video'
									},
									{
										'title'	  : 'Line Break',
										'icon'	   : 'icon-border-horizontal',
										'addText'	: 'lineBreak'
									},
									{
										'title'	  : 'Free Body Diagram',
										'icon'	   : 'icon-presentation',
										'addText'	: 'freeBodyDiagram'
									},
									{
										'title'	  : 'Requirement',
										'icon'	   : 'icon-lightbulb-outline',
										'addText'	: 'requirement'
									}
								];

								$scope.vm.menuSet.viewItems = [
									{
										'title'	  : 'Properties',
										'icon'	   : 'icon-key',
										'status'	 : 'active'
									},
									{
										'title'	  : 'Hide/Show Items',
										'icon'	   : 'icon-eye',
										'status'	 : 'active'
									},
									{
										'title'	  : 'Link to CAD',
										'icon'	   : 'icon-group',
										'status'	 : 'active'
									},
									{
										'title'	  : 'Table of Contents',
										'icon'	   : 'icon-format-list-bulleted',
										'status'	 : 'active'
									},
									{
										'title'	  : 'Bibliography',
										'icon'	   : 'icon-school',
										'status'	 : 'active'
									},
									{
										'title'	  : 'File as a Function',
										'icon'	   : 'icon-cog',
										'status'	 : 'active'
									},
									{
										'title'	  : 'File Inputs',
										'icon'	   : 'icon-share',
										'status'	 : 'active'
									},
									{
										'title'	  : 'Dataset Inputs',
										'icon'	   : 'icon-share-variant',
										'status'	 : 'active'
									},
									{
										'title'	  : 'Imported Functions',
										'icon'	   : 'icon-function',
										'status'	 : 'active'
									},
									{
										'title'	  : 'Dependent Files',
										'icon'	   : 'icon-attachment',
										'status'	 : 'active'
									},
									{
										'title'	  : 'Forums',
										'icon'	   : 'icon-forum',
										'status'	 : 'active'
									}
								];

							}


							if (($scope.vm.showType=="Document")&&(!$scope.vm.editPerm))
							{ 

								$scope.vm.menuSet.headerOne = 'Add Item';
								$scope.vm.menuSet.headerTwo = 'Document Property';
								$scope.vm.menuSet.showSaveFile = true;
								$scope.vm.menuSet.showSaveTree = false;
								$scope.vm.menuSet.menuType = 'document';

								$scope.vm.menuSet.menuItems = []

								$scope.vm.menuSet.viewItems = [
									
									{
										'title'	  : 'Properties',
										'icon'	   : 'icon-key',
										'status'	 : 'active'
									},
									{
										'title'	  : 'Hide/Show Items',
										'icon'	   : 'icon-eye',
										'status'	 : 'active'
									},
									{
										'title'	  : 'Link to CAD',
										'icon'	   : 'icon-group',
										'status'	 : 'active'
									},
									{
										'title'	  : 'Table of Contents',
										'icon'	   : 'icon-format-list-bulleted',
										'status'	 : 'active'
									},
									{
										'title'	  : 'Bibliography',
										'icon'	   : 'icon-school',
										'status'	 : 'active'
									},
									{
										'title'	  : 'File as a Function',
										'icon'	   : 'icon-cog',
										'status'	 : 'active'
									},
									{
										'title'	  : 'File Inputs',
										'icon'	   : 'icon-share',
										'status'	 : 'active'
									},
									{
										'title'	  : 'Dataset Inputs',
										'icon'	   : 'icon-share-variant',
										'status'	 : 'active'
									},
									{
										'title'	  : 'Imported Functions',
										'icon'	   : 'icon-function',
										'status'	 : 'active'
									},
									{
										'title'	  : 'Dependent Files',
										'icon'	   : 'icon-attachment',
										'status'	 : 'active'
									},
									{
										'title'	  : 'Forums',
										'icon'	   : 'icon-forum',
										'status'	 : 'active'
									}
								];

							}

							if ((($scope.vm.showType=="DatasetSetup")||
								($scope.vm.showType=="DatasetInput")||
								($scope.vm.showType=="DatasetResults"))&&($scope.vm.editPerm))
							{ 

								$scope.vm.menuSet.headerOne = 'View';
								$scope.vm.menuSet.headerTwo = 'File Action';
								$scope.vm.menuSet.showSaveFile = true;
								$scope.vm.menuSet.showSaveTree = false;
								$scope.vm.menuSet.menuType = 'dataset';

								$scope.vm.menuSet.menuItems = [
									{
										'title'	  : 'Settings',
										'icon'	   : 'icon-cog',
										'addText'	: 'settings'
									},
									{
										'title'	  : 'Input Text',
										'icon'	   : 'icon-format-size',
										'addText'	: 'inputText'
									},
									{
										'title'	  : 'Results',
										'icon'	   : 'icon-grid',
										'addText'	: 'results'
									}
								];

								$scope.vm.menuSet.viewItems = [
									{
										'title'	  : 'Edit Title',
										'icon'	   : 'icon-format-text',
										'addText'	: 'text'
									},
									{
										'title'	  : 'Edit Description',
										'icon'	   : 'icon-label-outline',
										'addText'	: 'header'
									},
									{
										'title'	  : 'Parse Text',
										'icon'	   : 'icon-rotate-3d',
										'addText'	: 'equation'
									// },
									// {
									//	 'title'	  : 'Save File',
									//	 'icon'	   : 'icon-content-save',
									//	 'addText'	: 'symbolic'
									}
								];

							}

							if ((($scope.vm.showType=="DatasetSetup")||
								($scope.vm.showType=="DatasetInput")||
								($scope.vm.showType=="DatasetResults"))&&(!$scope.vm.editPerm))
							{ 

								$scope.vm.menuSet.headerOne = 'View';
								$scope.vm.menuSet.headerTwo = 'File Action';
								$scope.vm.menuSet.showSaveFile = false;
								$scope.vm.menuSet.showSaveTree = false;
								$scope.vm.menuSet.menuType = 'dataset';

								$scope.vm.menuSet.menuItems = [
									{
										'title'	  : 'Settings',
										'icon'	   : 'icon-cog',
										'addText'	: 'settings'
									},
									{
										'title'	  : 'Input Text',
										'icon'	   : 'icon-format-size',
										'addText'	: 'inputText'
									},
									{
										'title'	  : 'Results',
										'icon'	   : 'icon-grid',
										'addText'	: 'results'
									}
								];

							}

							if ($scope.vm.showType=="Workspace")
							{ 

								$scope.vm.menuSet.headerOne = 'Add Item';
								$scope.vm.menuSet.headerTwo = 'Action in Item';
								$scope.vm.menuSet.showSaveFile = false;
								$scope.vm.menuSet.showSaveTree = false;
								$scope.vm.menuSet.menuType = 'workspace';

								$scope.vm.menuSet.menuItems = [
									{
										'title'	  : 'Document',
										'icon'	   : 'icon-file-outline',
										'addText'	: 'document'
									},
									{
										'title'	  : 'Dataset',
										'icon'	   : 'icon-cog',
										'addText'	: 'dataset'
									},
									{
										'title'	  : 'Workspace',
										'icon'	   : 'icon-folder-outline',
										'addText'	: 'workspace'
									},
									{
										'title'	  : 'Part Tree',
										'icon'	   : 'icon-sitemap',
										'addText'	: 'parttree'
									},
									{
										'title'	  : 'Workflow',
										'icon'	   : 'icon-calendar-text',
										'addText'	: 'workflow'
									},
									{
										'title'	  : 'Forum',
										'icon'	   : 'icon-forum',
										'addText'	: 'forum'
									},
									{
										'title'	  : 'Image',
										'icon'	   : 'icon-camera',
										'addText'	: 'image'
									}
								];


								$scope.vm.menuSet.viewItems = [
									
/*
									{
										'title'	  : 'Edit Title',
										'icon'	   : 'icon-format-text'
									},
									{
										'title'	  : 'Edit Description',
										'icon'	   : 'icon-label-outline'
									},
*/

									{
										'title'	  : 'Edit Properties',
										'icon'	   : 'icon-cog'
									},
									{
										'title'	  : 'Set Image',
										'icon'	   : 'icon-camera'
									},
									{
										'title'	  : 'Edit Permissions',
										'icon'	   : 'icon-key'
									},
									{
										'title'	  : 'Move Item',
										'icon'	   : 'icon-rotate-3d'
									},
									{
										'title'	  : 'Copy Item',
										'icon'	   : 'icon-content-copy'
									},
									{
										'title'	  : 'View Item Log',
										'icon'	   : 'icon-information-outline'
									},
									{
										'title'	  : 'Create New Version',
										'icon'	   : 'icon-content-duplicate'
									},
									{
										'title'	  : 'Delete Item',
										'icon'	   : 'icon-close-circle-outline'
									}
								];

							}

							if (($scope.vm.showType=="PartTreeSetup") && ($scope.vm.editPerm))
							{ 

								//console.log($scope.vm.showType+' - '+$scope.vm.editPerm);

								$scope.vm.menuSet.headerOne = 'View';
								$scope.vm.menuSet.headerTwo = 'Action';
								$scope.vm.menuSet.showSaveFile = false;
								$scope.vm.menuSet.showSaveTree = true;
								$scope.vm.menuSet.menuType = 'partTree';

								$scope.vm.menuSet.menuItems = [
									{
										'title'	  : 'Tree Setup',
										'icon'	   : 'icon-cog'
									},
									{
										'title'	  : 'Part Tree',
										'icon'	   : 'icon-sitemap'
									},
									{
										'title'	  : 'Documents',
										'icon'	   : 'icon-file-outline'
									}
								];

								$scope.vm.menuSet.viewItems = [
									{
										'title'	  : 'Edit Title',
										'icon'	   : 'icon-format-text'
									},
									{
										'title'	  : 'Edit Description',
										'icon'	   : 'icon-label-outline'
									}
								];

							}

							if (($scope.vm.showType=="PartTreeSetup") && (!$scope.vm.editPerm))
							{ 
								//console.log($scope.vm.showType+' - '+$scope.vm.editPerm);

								$scope.vm.menuSet.headerOne = 'View';
								$scope.vm.menuSet.headerTwo = 'Action';
								$scope.vm.menuSet.showSaveFile = false;
								$scope.vm.menuSet.showSaveTree = false;
								$scope.vm.menuSet.menuType = 'partTree';

								$scope.vm.menuSet.menuItems = [
									{
										'title'	  : 'Tree Setup',
										'icon'	   : 'icon-cog'
									},
									{
										'title'	  : 'Part Tree',
										'icon'	   : 'icon-sitemap'
									},
									{
										'title'	  : 'Documents',
										'icon'	   : 'icon-file-outline'
									}
								];


								$scope.vm.menuSet.viewItems = [
								];

							}


							if (($scope.vm.showType=="PartTree") && ($scope.vm.editPerm))
							{ 
								//console.log($scope.vm.showType+' - '+$scope.vm.editPerm);
								$scope.vm.menuSet.headerOne = 'View';
								$scope.vm.menuSet.headerTwo = 'Action';
								$scope.vm.menuSet.showSaveFile = false;
								$scope.vm.menuSet.showSaveTree = true;
								$scope.vm.menuSet.menuType = 'partTree';

								$scope.vm.menuSet.menuItems = [
									{
										'title'	  : 'Tree Setup',
										'icon'	   : 'icon-cog'
									},
									{
										'title'	  : 'Part Tree',
										'icon'	   : 'icon-sitemap'
									},
									{
										'title'	  : 'Documents',
										'icon'	   : 'icon-file-outline'
									}
								];

								$scope.vm.menuSet.viewItems = [
									{
										'title'	  : 'Update All Status',
										'icon'	   : 'icon-check-all'
									},
									{
										'title'	  : 'Update All Mass',
										'icon'	   : 'icon-weight'
									}
								];


							}



							if ($scope.vm.showType=="PartTreeDocs")
							{ 
								//console.log($scope.vm.showType+' - '+$scope.vm.editPerm);
								$scope.vm.menuSet.headerOne = 'View';
								$scope.vm.menuSet.headerTwo = 'Action';
								$scope.vm.menuSet.showSaveFile = false;
								$scope.vm.menuSet.showSaveTree = true;
								$scope.vm.menuSet.menuType = 'partTree';

								$scope.vm.menuSet.menuItems = [
									{
										'title'	  : 'Tree Setup',
										'icon'	   : 'icon-cog'
									},
									{
										'title'	  : 'Part Tree',
										'icon'	   : 'icon-sitemap'
									},
									{
										'title'	  : 'Documents',
										'icon'	   : 'icon-file-outline'
									}
								];

								$scope.vm.menuSet.viewItems = [
								];


							}



							if ((($scope.vm.showType=="profileOverview")||
								 ($scope.vm.showType=="profileWorkspaces")||
								 ($scope.vm.showType=="profileTeams")||
								 ($scope.vm.showType=="profileInvitations")||
								 ($scope.vm.showType=="profileMessages")||
								 ($scope.vm.showType=="profileNotifications")||
								 ($scope.vm.showType=="profileAnnouncements")||
								 ($scope.vm.showType=="profileCAD")||
								 ($scope.vm.showType=="profileProfile"))
								&&($scope.vm.editPerm))
							{ 

								$scope.vm.menuSet.headerOne = 'View';
								$scope.vm.menuSet.headerTwo = 'Action';
								$scope.vm.menuSet.showSaveFile = false;
								$scope.vm.menuSet.showSaveTree = false;
								$scope.vm.menuSet.menuType = 'profile';

								$scope.vm.menuSet.menuItems = [
									{
										'title'	  : 'Profile',
										'icon'	   : 'icon-account-key',
										'addText'	: 'NA'
									},
									{
										'title'	  : 'Messages',
										'icon'	   : 'icon-email',
										'addText'	: 'NA'
									},
									{
										'title'	  : 'Files',
										'icon'	   : 'icon-apple-safari',
										'addText'	: 'NA'
									},
									{
										'title'	  : 'Workspaces',
										'icon'	   : 'icon-folder-outline',
										'addText'	: 'NA'
									},
									{
										'title'	  : 'Teams',
										'icon'	   : 'icon-people',
										'addText'	: 'NA'
									},
									{
										'title'	  : 'Invitations',
										'icon'	   : 'icon-email'
									},
									{
										'title'	  : 'Notifications',
										'icon'	   : 'icon-alarm'
									},
									{
										'title'	  : 'Announcements',
										'icon'	   : 'icon-bullhorn'
									},
									{
										'title'	  : 'CAD Sync',
										'icon'	   : 'icon-drawing',
										'addText'	: 'NA'
									}
								];

								$scope.vm.menuSet.viewItems = [
								];
							}


							if ((($scope.vm.showType=="profileOverview")||
								 ($scope.vm.showType=="profileWorkspaces")||
								 ($scope.vm.showType=="profileTeams")||
								 ($scope.vm.showType=="profileInvitations")||
								 ($scope.vm.showType=="profileMessages")||
								 ($scope.vm.showType=="profileNotifications")||
								 ($scope.vm.showType=="profileAnnouncements")||
								 ($scope.vm.showType=="profileCAD")||
								 ($scope.vm.showType=="profileProfile"))
								&&(!$scope.vm.editPerm))
							{ 

								$scope.vm.menuSet.headerOne = 'View';
								$scope.vm.menuSet.headerTwo = 'Action';
								$scope.vm.menuSet.showSaveFile = false;
								$scope.vm.menuSet.showSaveTree = false;
								$scope.vm.menuSet.menuType = 'profile';

								$scope.vm.menuSet.menuItems = [
									{
										'title'	  : 'Profile',
										'icon'	   : 'icon-account-key'
									},
									{
										'title'	  : 'Messages',
										'icon'	   : 'icon-email',
										'addText'	: 'NA'
									},
									{
										'title'	  : 'Files',
										'icon'	   : 'icon-apple-safari'
									},
									{
										'title'	  : 'Workspaces',
										'icon'	   : 'icon-folder-outline'
									},
									{
										'title'	  : 'Teams',
										'icon'	   : 'icon-people'
									},
									{
										'title'	  : 'Invitations',
										'icon'	   : 'icon-email'
									},
									{
										'title'	  : 'Notifications',
										'icon'	   : 'icon-alarm'
									},
									{
										'title'	  : 'Announcements',
										'icon'	   : 'icon-bullhorn'
									},
									{
										'title'	  : 'CAD Sync',
										'icon'	   : 'icon-drawing',
										'addText'	: 'CAD'
									}
								];
							}


							if ($scope.vm.showType=="teamList")
							{ 

								$scope.vm.menuSet.headerOne = 'Actions';
								$scope.vm.menuSet.headerTwo = 'Views';
								$scope.vm.menuSet.showSaveFile = false;
								$scope.vm.menuSet.showSaveTree = false;
								$scope.vm.menuSet.menuType = 'teams';

								$scope.vm.menuSet.menuItems = [
									{
										'title'	  : 'Add Team',
										'icon'	   : 'icon-account-multiple-plus',
										'addText'	: 'addteam'
									}
								];

								$scope.vm.menuSet.viewItems = [
								];
							}


							if ($scope.vm.showType=="memberList")
							{ 

								$scope.vm.menuSet.headerOne = 'Actions';
								$scope.vm.menuSet.headerTwo = 'Views';
								$scope.vm.menuSet.showSaveFile = false;
								$scope.vm.menuSet.showSaveTree = false;
								$scope.vm.menuSet.menuType = 'teams';

								$scope.vm.menuSet.menuItems = [
									{
										'title'	  : 'Team Details',
										'icon'	   : 'icon-account-box-outline'
									},
									{
										'title'	  : 'Add Member',
										'icon'	   : 'icon-account-plus'
									}
								];
							}
						}
					);
				}
			],

			link		: function(scope, element, attrs){
				$templateRequest("app/core/directives/leftMenu/left-menu.html").then(function(html){
					var template = angular.element(html);
					element.html(template);
					$compile(template)(scope);

				// $compile(tElement)(scope);

					scope.$watch('vm.showType', 
						function(){
							//console.log('Triggered through the vm.showType watch');
							$compile(template)(scope);
						}
					);

					scope.$watch('vm.editPerm', 
						function(){
							//console.log('Triggered through the editPerm watch');
							$compile(template)(scope);
						}
					);
				});
			}
		};
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('bibliographyController', bibliographyController)
        .directive('bibliography', bibliographyDirective);

    /** @ngInject */
    function bibliographyController($scope, $document, $q, msNavigationService)
    {


    }

    /** @ngInject */
    function bibliographyDirective()
    {
        return {
            restrict        : 'E',
            scope           : '=',
            require         : 'bibliography',
            controller      : 'tableOfContentsController as bibliography',
            bindToController: {},
            templateUrl     : 'app/core/directives/bibliography/bibliography.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('bibliography');

            }
        };
    }

})();
/*
*
*   This directive displays the divs for the events in a workflow.
*
*/
(function ()
{
	'use strict';

	angular
		.module('app.core')
		.directive('workflowTask', workflowTask );

	/** @ngInject **/
	function workflowTask($templateRequest, $compile)
	{   return {
			restrict: 'A',
			replace:true,

			scope:{
				id:'=',
				listItems:'=',
				spark:'='
			},


			controller : function($scope, $element, $attrs) {
					
			},


			link : function(scope, element, attrs)
			{

					scope.$watch('listItems.isChanged', 

						function(){

							console.log('Task directive triggered in the link');

							$templateRequest("app/main/apps/workflow/views/workflowTask.html").then(function(html){
								var template = angular.element(html);
								element.html(template);
								$compile(template)(scope);
							});


						}, true

					);
			}
		}
	}; 
})();



/*
*
*   This directive displays the divs for the events in a workflow.
*
*/
(function ()
{
	'use strict';

	angular
		.module('app.core')
		.directive('workflowSignoffs', workflowSignoffs );

	/** @ngInject **/
	function workflowSignoffs($templateRequest, $compile)
	{   return {
			restrict: 'A',
			replace:true,

			scope:{
				listItems:'=',
				events:'=',
				settings:'=',
				Spark:'=',
				currentSignoff : '=',
				signoffs : '=',
				thisItem : '=',
				thisEvent : '=',
				permissions:'=',
				id:'='
			},

			controller : function($scope, $element, $attrs) {
					
			},


			link : function(scope, element, attrs)
			{

					scope.$watch('signoffs.isChanged', 

						function(){

							console.log('Signoff main directive triggered in the link');

							$templateRequest("app/main/apps/workflow/views/workflowSignoffs.html").then(function(html){
								var template = angular.element(html);
								element.html(template);
								$compile(template)(scope);
							});


						}, true

					);
			}
		}
	}; 
})();



/*
*
*   This directive displays the divs for the events in a workflow.
*
*/
(function ()
{
	'use strict';

	angular
		.module('app.core')
		.directive('workflowShowSignoffs', workflowShowSignoffs );

	/** @ngInject **/
	function workflowShowSignoffs($templateRequest, $compile)
	{   return {
			restrict: 'A',
			replace:true,

			scope:{
				listItems:'=',
				events:'=',
				settings:'=',
				Spark:'=',
				currentSignoff : '=',
				signoffs : '=',
				thisItem : '=',
				thisEvent : '=',
				permissions:'=',
				id:'='
			},

			controller : function($scope, $element, $attrs) {
					
			},


			link : function(scope, element, attrs)
			{

					scope.$watch('signoffs.isChanged', 

						function(){

							console.log('Signoff directive triggered in the link');

							$templateRequest("app/main/apps/workflow/views/workflowShowSignoffs.html").then(function(html){
								var template = angular.element(html);
								element.html(template);
								$compile(template)(scope);
							});


						}, true

					);
			}
		}
	}; 
})();



/*
*
*   This directive displays the divs for the events in a workflow.
*
*/
(function ()
{
	'use strict';

	angular
		.module('app.core')
		.directive('workflowRequirement', workflowRequirement );

	/** @ngInject **/
	function workflowRequirement($templateRequest, $compile)
	{   return {
			restrict: 'A',
			replace:true,

			scope:{
				id:'=',
				listItems:'=',
				Spark:'='
			},


			controller : function($scope, $element, $attrs) {
					
			},


			link : function(scope, element, attrs)
			{

					scope.$watch('listItems.isChanged', 

						function(){

							console.log('Requirement directive triggered in the link');

							$templateRequest("app/main/apps/workflow/views/workflowRequirement.html").then(function(html){
								var template = angular.element(html);
								element.html(template);
								$compile(template)(scope);
							});


						}, true

					);
			}
		}
	}; 
})();



/*
*
*   This directive displays the divs for the events in a workflow.
*
*/
(function ()
{
	'use strict';

	angular
		.module('app.core')
		.directive('workflowQuestion', workflowQuestion );

	/** @ngInject **/
	function workflowQuestion($templateRequest, $compile)
	{   return {
			restrict: 'A',
			replace:true,

			scope:{
				id:'=',
				listItems:'=',
				spark:'='
			},


			controller : function($scope, $element, $attrs) {
					
			},


			link : function(scope, element, attrs)
			{

					scope.$watch('listItems.isChanged', 

						function(){

							console.log('Question directive triggered in the link');

							$templateRequest("app/main/apps/workflow/views/workflowQuestion.html").then(function(html){
								var template = angular.element(html);
								element.html(template);
								$compile(template)(scope);
							});


						}, true

					);
			}
		}
	}; 
})();



/*
*
*   This directive displays the divs for the events in a workflow.
*
*/
(function ()
{
	'use strict';

	angular
		.module('app.core')
		.directive('workflowLogDataStatus', workflowLogDataStatus );

	/** @ngInject **/
	function workflowLogDataStatus($templateRequest, $compile)
	{   return {
			restrict: 'A',
			replace:true,

			scope:{
				listItems:'=',
				settings:'=',
				Spark:'=',
				thisItem : '=',
				permissions:'=',
				getLogData:'&',
				checkUpdateStatus:'&',
				deleteItem:'&',
				id:'='
			},

			controller : function($scope, $element, $attrs) {
					
			},


			link : function(scope, element, attrs)
			{

					scope.$watch('signoffs.isChanged', 

						function(){

							console.log('Log Data directive triggered in the link');

							$templateRequest("app/main/apps/workflow/views/workflowLogDataStatus.html").then(function(html){
								var template = angular.element(html);
								element.html(template);
								$compile(template)(scope);
							});

							scope.callGetLogData = function( fileID ) {
								scope.callGetLogData()( fileID );
							}


							scope.callCheckUpdateStatus = function( fileID ) {
								scope.callCheckUpdateStatus()( fileID );
							}


							scope.callDeleteItem = function( fileID ) {
								scope.callDeleteItem()( fileID );
							}


						}, true

					);
			}
		}
	}; 
})();



/*
*
*   This directive houses a system contents within a part tree. If the system holds other systems, that is shown. 
*   If the system is at the lowest level and has parts, that is shown.
*
*/
(function ()
{
	'use strict';

	angular
		.module('app.core')
		.directive('workflowList', workflowList );

	/** @ngInject **/
	function workflowList($templateRequest, $compile)
	{   return {
			restrict: 'A',
			replace:true,

			scope:{
				listItems:'=',
				events:'=',
				settings:'=',
				Spark:'=',
				currentSignoff : '=',
				signoffs : '=',
				thisSystem : '=',
				permissions:'=',
				id:'=',
				showChildren:'=',
				totalWidth:'='
			},

			controller : function($scope, $element, $attrs) {
					
			},


			link : function(scope, element, attrs)
			{

					scope.$watch('listItems.isChanged', 

						function(){

							console.log('List directive triggered in the link');

							$templateRequest("app/main/apps/workflow/views/workflowItem.html").then(function(html){
								var template = angular.element(html);
								element.html(template);
								$compile(template)(scope);
							});


						}, true

					);
			}
		}
	}; 
})();




/*
*
*   This directive displays the divs for the events in a workflow.
*
*/
(function ()
{
	'use strict';

	angular
		.module('app.core')
		.directive('workflowItemSignoffs', workflowItemSignoffs );

	/** @ngInject **/
	function workflowItemSignoffs($templateRequest, $compile)
	{   return {
			restrict: 'A',
			replace:true,

			scope:{
				listItems:'=',
				events:'=',
				settings:'=',
				Spark:'=',
				currentSignoff : '=',
				signoffs : '=',
				thisItem : '=',
				thisEvent : '=',
				permissions:'=',
				id:'='
			},

			controller : function($scope, $element, $attrs) {
					
			},


			link : function(scope, element, attrs)
			{

					scope.$watch('signoffs.isChanged', 

						function(){

							console.log('Signoff directive triggered in the link');

							$templateRequest("app/main/apps/workflow/views/workflowItemSignoffs.html").then(function(html){
								var template = angular.element(html);
								element.html(template);
								$compile(template)(scope);
							});


						}, true

					);
			}
		}
	}; 
})();



/*
*
*   This directive displays the divs for the events in a workflow.
*
*/
(function ()
{
	'use strict';

	angular
		.module('app.core')
		.directive('workflowItemEvents', workflowItemEvents );

	/** @ngInject **/
	function workflowItemEvents($templateRequest, $compile)
	{   return {
			restrict: 'A',
			replace:true,

			scope:{
				listItems:'=',
				events:'=',
				settings:'=',
				Spark:'=',
				tasks:'=',
				permissions:'=',
				totalWidth:'=',
				id:'='
			},

			controller : function($scope, $element, $attrs) {
					
			},


			link : function(scope, element, attrs)
			{

					scope.$watch('events.isChanged', 

						function(){

							console.log('Event directive triggered in the link');

							$templateRequest("app/main/apps/workflow/views/workflowItemEvents.html").then(function(html){
								var template = angular.element(html);
								element.html(template);
								$compile(template)(scope);
							});


						}, true

					);
			}
		}
	}; 
})();



/*
*
*   This directive displays the divs for the events in a workflow.
*
*/
(function ()
{
	'use strict';

	angular
		.module('app.core')
		.directive('workflowEvents', workflowEvents );

	/** @ngInject **/
	function workflowEvents($templateRequest, $compile)
	{   return {
			restrict: 'A',
			replace:true,

			scope:{
				listItems:'=',
				events:'=',
				settings:'=',
				Spark:'=',
				signoffs:'=',
				showEVModal:'&',
				permissions:'=',
				id:'='
			},


	
			controller : function($scope, $element, $attrs) {
					
			},


			link : function(scope, element, attrs)
			{

					scope.$watch('events.isChanged', 

						function(){

							console.log('Triggered in the link');

							$templateRequest("app/main/apps/workflow/views/workflowEvents.html").then(function(html){
								var template = angular.element(html);
								element.html(template);
								$compile(template)(scope);
							});

							scope.callShowEVModal = function( thisEvent, signoffs ) {
								scope.showEVModal()( thisEvent, signoffs );
							}

						}, true

					);
			}
		}
	}; 
})();



/*
*
*   This is the directive for a while loop in the worksheet
*
*/
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('whileLoopObject', whileLoopObject);

    /** @ngInject **/
    function whileLoopObject($templateRequest, $compile)
    {   return {
            restrict: 'E',

            scope:{
                worksheet:'=',
                struct:'@',
                editperm:'=',
                addStatement:'&',
                addBlock:'&',
                deleteStatement:'&',
                runEquationDigest:'&',
                updateme:'='
            },

            controller : ["$scope", "$element", "$attrs",

                function($scope, $element, $attrs) {
                    

                    $scope.$watch('updateme', 

                        function(){

                            console.log('The struct is ...');
                            console.log($scope.struct);

                            $scope.worksheet.forEach(
                                function(thisItem, index){
                                    if (thisItem['itemid']==$scope.struct)
                                    {
                                        $scope.thisStruct=thisItem;
                                    }
                                }
                            );
                        }
                    );

                }
            ],

            link : function(scope, element, attrs){

                scope.$watch('updateme', 

                    function(){

                        $templateRequest("app/main/apps/document/worksheet/views/templates/whileLoopObject.html").then(function(html){
                            var template = angular.element(html);
                            element.html(template);
                            $compile(template)(scope);
                        });

                        scope.callAddStatement = function( itemID, type, blockIndex, statementIndex ) {
                            scope.addStatement()( itemID, type, blockIndex, statementIndex );
                        }

                        scope.callAddBlock = function( itemID, type, blockIndex ) {
                            scope.addBlock()( itemID, type, blockIndex );
                        }

                        scope.callDeleteStatement = function( itemID, type, blockIndex, statementIndex ) {
                            scope.deleteStatement()( itemID, type, blockIndex, statementIndex );
                        }

                        scope.callRunEquationDigest = function( ) {
                            scope.runEquationDigest()( );
                        }


                    }, true
                );
            }
        }
    }; 

})();



/*
*
*   This is the directive for a for loop in the window specifics view list
*
*/
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('whileLoopList', whileLoopList);

    /** @ngInject **/
    function whileLoopList($templateRequest, $compile)
    {   return {
            restrict: 'E',

            scope:{
                worksheet:'=',
                struct:'=',
                currentsubitem:'=',
                editperm:'=',
                updateme:'=',
                changecurrent:'&'
            },

            controller : ["$scope", "$element", "$attrs",

                function($scope, $element, $attrs) {
                    $scope.$watch('currentsubitem', 
                        function(){
                            $scope.worksheet.forEach(
                                function(thisItem, index){
                                    if (thisItem['itemid']==$scope.struct.itemid)
                                    {
                                        $scope.structObj=thisItem;
                                    }
                                }
                            );
                        }
                    );
                }
            ],


            link        : function(scope, element, attrs){

                scope.$watch('currentsubitem', 

                    function(){

                        $templateRequest("app/main/apps/document/worksheet/views/templates/multSpec/whileLoopList.html").then(function(html){
                            var template = angular.element(html);
                            element.html(template);
                            $compile(template)(scope);
                        });

                        scope.callChangeCurrent = function( thisID ) {
                            scope.changecurrent()( thisID );
                        }

                    }
                );
            }
        }
    }; 
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('toggleTableData', toggleTableData);

    /** @ngInject **/
    function toggleTableData()
    {   return {
            restrict: 'A',
            link : function(scope, element, attrs) {
                element.bind('click', function() { element.parent().parent().children('tr').children('td').removeClass('activeTD'); element.addClass('activeTD');  });
            }
        }    
    };   
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('tableShowColHeaders', tableShowColHeaders);

    /** @ngInject **/
    function tableShowColHeaders($compile)
    {   return {
            restrict: 'A',
            scope : { numcols: '=', showlabels:"=", tableid: '<' },
            // controller: ["$scope", "$element", "$attrs", function($scope, $element, $attrs) {
            link : function($scope, element, attrs){
                    console.log('I am in the show col headers directive with a numcols of '+$scope.numcols);
                $scope.$watch([attrs.showlabels, attrs.numcols], function() {
                    console.log('I am in the watch show col headers directive with a numcols of '+$scope.numcols);
                    var thisText='<th class="empty" width="15px">&nbsp</th><th class="empty" width="15px">&nbsp</th><th ng-if="'+$scope.showlabels+'" class="empty" width="25px">&nbsp</th>';
                    for (var a=0; a<=$scope.numcols; a++){ thisText=thisText+'<th>'+String.fromCharCode('A'.charCodeAt() + (a)); +'</th>'; }  
                    var template = $compile(angular.element(thisText))($scope);
                    element.children().remove();
                    element.append(template);
                });
            }
        }
    };   
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('tableObject', tableObject);

    /** @ngInject **/
    function tableObject($templateRequest, $compile)
    {   return {
            restrict: 'A',
            link: function(scope, element){
                $templateRequest("app/main/apps/document/worksheet/views/templates/tableObject.html").then(function(html){
                    var template = angular.element(html);
                    element.append(template);
                    $compile(template)(scope);
                });
            }
        }
    };   
})();


(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('tableAddDeleteCols', tableAddDeleteCols);

    /** @ngInject **/
    function tableAddDeleteCols($templateRequest, $compile)
    {   return {
            restrict: 'A',
            scope : { thisTable: '=', numcols: '=', showlabels:"=", tableid: '<' },
            link : function(scope, element, attrs){
                scope.$watch("[numcols, showlabels]", function() 
                {
                    var thisText='<td class="empty" width="15px">&nbsp</td><td class="empty" width="15px">&nbsp</td><td ng-if="'+scope.showlabels+'" class="empty" width="25px">&nbsp</td>';
                    
                    for (var a=0; a<scope.numcols; a++)
                    {
                        thisText=thisText+'<td class="empty"><div ng-click="thisTable=docItemFactory.deleteTableColumn(thisTable, '+a+')" class="tcdelete">&nbsp</div><div ng-click="thisTable=docItemFactory.addTableColumn(thisTable, '+a+')" class="tcadd"></div></td>'; 
                    }  

                    var template = $compile(angular.element(thisText))(scope);
                    element.children().remove();
                    element.append(template);
                });
            }
        }
    }; 
})();
/*
*
*   This is the directive for the small row of icons that let the user add items below the row or delete this item
*
*/
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('subItemButtons', subItemButtons);

    /** @ngInject **/
    function subItemButtons($templateRequest, $compile)
    {   return {
            restrict: 'E',

            // scope:{
            //     worksheet:'=',
            //     currentsubitem:'='
            // },

            controller : ["$scope", "$element", "$attrs",

                function($scope, $element, $attrs) {


                    $scope.$watch($attrs.currentSubItem, 
                        function(){
                        }
                    );

                }
            ],

            link        : function(scope, element, attrs){
                $templateRequest("app/main/apps/document/worksheet/views/templates/multSpec/subItemButtons.html").then(function(html){
                    var template = angular.element(html);
                    element.html(template);
                    $compile(template)(scope);
                });
            }
        }
    }; 
})();
/*
*
*   This is the directive for the specifics view structure content
*
*/
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('structureContent', structureContent);

    /** @ngInject **/
    function structureContent($templateRequest, $compile)
    {   return {
            restrict : 'E',

            scope:{
                worksheet:'=',
                struct:'@',
                currentsubitem:'=',
                editperm:'='
            },

            controller : ["$scope", "$element", "$attrs",

                function($scope, $element, $attrs) {

                }
            ],
            
            link : function(scope, element, attrs){

                scope.$watch('currentsubitem', 

                    function(){
                
                        if (typeof(scope.struct)=='string')
                        {
                            scope.struct=JSON.parse(scope.struct);
                        }

                        scope.worksheet.forEach(
                            function(thisItem, index){
                                if (scope.struct['itemid']==thisItem['itemid'])
                                {
                                    scope.structObj=thisItem;
                                }
                            }
                        );

                        console.log('The struct item is ...');
                        console.log(scope.structObj);
                        $templateRequest("app/main/apps/document/worksheet/views/templates/multSpec/structureContentSection.html").then(function(html){
                            var template = angular.element(html);
                            element.html(template);
                            $compile(template)(scope);
                        });

                    }, true 
                );
            }
        }
    }; 
})();


/*
*
*   This directive houses a system contents within a part tree. If the system holds other systems, that is shown. 
*   If the system is at the lowest level and has parts, that is shown.
*
*/
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('partTreeSystem', partTreeSystem);

    /** @ngInject **/
    function partTreeSystem($templateRequest, $compile)
    {   return {
            restrict: 'A',
            replace:true,

            scope:{
                parttree:'=',
                cadshow:'=',
                cadtype:'=',
                thissystem:'=',
                spark:'=',
                solveStatus:'=',
                insolve:'=',
                systemlevel:'@',
                segments:'=',
                showSmallModal:'&',
                showModal:'&',
                addSystem:'&',
                changeSystemName: '&',
                moveSystem:'&',
                deleteSystem:'&',
                addPart:'&',
                navigateUrl:'&',
                includeChildren:'&',
                excludeChildren:'&',
                checkIncluded:'&',
                updateMaterial:'&',
                updateMass:'&',
                calculateMass:'&',
                removeCadConn:'&',
                updateFile:'&',
                updateFusionData:'&'

            },

            controller : function($scope, $element, $attrs) {
                    
            },


            link : function(scope, element, attrs)
            {

                    scope.$watch('thissystem.isChanged', 

                        function(){

                            console.log('Triggered in the link');

                            if (typeof(scope.thissystem)=="string")
                            {
                                console.log('System was a string');
                                scope.thissystem=JSON.parse(scope.thissystem);
                            }

                            $templateRequest("app/main/apps/partTree/views/partTreeSystem.html").then(function(html){
                                var template = angular.element(html);
                                element.html(template);
                                $compile(template)(scope);
                            });

                            scope.callAddSystem = function( systemType, parentSystem, systemName, systemLevel ) {
                                scope.addSystem()( systemType, parentSystem, systemName, systemLevel );
                            }

                            scope.callAddPart = function( parentSystem, systemLevel ) {
                                scope.addPart()( parentSystem, systemLevel );
                            }

                            scope.callDeleteSystem = function( item ) {
                                scope.deleteSystem()( item );
                            }

                            scope.callChangeSystemName = function( thisSystem, newName ) {
                                scope.changeSystemName()( thisSystem, newName );
                            }

                            scope.callShowSmallModal = function( ev, modalType, modalVar, segIndex ) {
                                scope.showSmallModal()( ev, modalType, modalVar, segIndex );
                            }

                            scope.callShowModal = function( ev, modalType ) {
                                scope.showModal()( ev, modalType );
                            }

                            scope.callNavigateUrl = function( fileItem, urlString ) {
                                scope.navigateUrl()( fileItem, urlString );
                            }

                            scope.callCheckIncluded = function( parttree ) {
                                scope.checkIncluded()( parttree );
                            }

                            scope.callIncludeChildren = function( thisid, parttree ) {
                                scope.includeChildren()( thisid, parttree );
                            }

                            scope.callExcludeChildren = function( thisid, parttree ) {
                                scope.excludeChildren()( thisid, parttree );
                            }

                            scope.callUpdateMass = function( system ) {
                                scope.updateMass()( system );
                            }

                            scope.callUpdateMaterial = function( system ) {
                                scope.updateMaterial()( system );
                            }

                            scope.callCalculateMass = function( system ) {
                                scope.calculateMass()( system );
                            }

                            scope.callUpdateFile = function( fileID, thisType ) {
                                scope.updateFile()( fileID, thisType );
                            }

                            scope.callRemoveCadConn = function( itemID ) {
                                scope.removeCadConn()( itemID );
                            }

                            scope.callUpdateFusionData = function( cleanID, projectID, fileID ) {
                                scope.updateFusionData()( cleanID, projectID, fileID );
                            }

                        }, true

                    );
            }
        }
    }; 
})();




/*
*
*   This is the directive for a for loop in the window specifics view list
*
*/
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('ifElseObject', ifElseObject);

    /** @ngInject **/
    function ifElseObject($templateRequest, $compile)
    {   return {
            restrict: 'E',

            scope:{
                worksheet:'=',
                struct:'@',
                editperm:'=',
                addStatement:'&',
                addBlock:'&',
                deleteStatement:'&',
                runEquationDigest:'&',
                updateme:'='
            },

            controller : ["$scope", "$element", "$attrs",

                function($scope, $element, $attrs) {
                    
                    $scope.$watch('updateme', 

                        function(){

                            console.log('The struct is ...');
                            console.log($scope.struct);

                            $scope.worksheet.forEach(
                                function(thisItem, index){
                                    if (thisItem['itemid']==$scope.struct)
                                    {
                                        $scope.thisStruct=thisItem;
                                    }
                                }
                            );

                            // if (typeof($scope.struct)=='string')
                            // {
                            //     $scope.thisStruct = JSON.parse($scope.struct);
                            // }else
                            // {
                            //     $scope.thisStruct = $scope.struct;                                
                            // }

                            console.log('The structure is ...');
                            console.log($scope.thisStruct);
                            console.log('Update me 1 is '+$scope.updateme);
                        }
                    );

                }
            ],


            link        : function(scope, element, attrs){

                scope.$watch('updateme', 

                    function(){

                        $templateRequest("app/main/apps/document/worksheet/views/templates/ifElseObject.html").then(function(html){
                            var template = angular.element(html);
                            element.html(template);
                            $compile(template)(scope);
                        });

                        console.log('I redid the template');
                        console.log('Update me 2 is '+scope.updateme);


                    }, true 

                );

                scope.callAddStatement = function( itemID, type, blockIndex, statementIndex ) {
                    scope.addStatement()( itemID, type, blockIndex, statementIndex );
                }

                scope.callAddBlock = function( itemID, type, blockIndex ) {
                    scope.addBlock()( itemID, type, blockIndex );
                }

                scope.callDeleteStatement = function( itemID, type, blockIndex, statementIndex ) {
                    scope.deleteStatement()( itemID, type, blockIndex, statementIndex );
                }

                scope.callRunEquationDigest = function( ) {
                    scope.runEquationDigest()( );
                }

            }
        }
    }; 
})();

/*
*
*   This is the directive for an if else statement in the window specifics view list
*
*/
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('ifElseList', ifElseList);

    /** @ngInject **/
    function ifElseList($templateRequest, $compile)
    {   return {
            restrict: 'E',

            scope:{
                worksheet:'=',
                struct:'=',
                currentsubitem:'=',
                editperm:'=',
                updateme:'=',
                changecurrent:'&'
            },

            controller : ["$scope", "$element", "$attrs",

                function($scope, $element, $attrs) {
                    $scope.$watch('currentsubitem', 
                        function(){
                            $scope.worksheet.forEach(
                                function(thisItem, index){
                                    if (thisItem['itemid']==$scope.struct.itemid)
                                    {
                                        $scope.structObj=thisItem;
                                    }
                                }
                            );
                        }
                    );
                }
            ],


            link        : function(scope, element, attrs){

                scope.$watch('currentsubitem', 

                    function(){

                        $templateRequest("app/main/apps/document/worksheet/views/templates/multSpec/ifElseList.html").then(function(html){
                            var template = angular.element(html);
                            element.html(template);
                            $compile(template)(scope);
                        });

                        scope.callChangeCurrent = function( thisID ) {
                            scope.changecurrent()( thisID );
                        }

                    }
                );
            }
        }
    }; 
})();
/*
*
*   This directive displays the comments for a forum.
*
*/

(function ()
{
	'use strict';

	angular
		.module('app.core')
		.directive('forumComment', forumComment );

	/** @ngInject **/
	function forumComment($templateRequest, $compile)
	{   return {
			restrict: 'A',
			replace:true,

			scope:{
				id:'=',
				comments:'=',
				spark:'=',
				newcomment:'=',
				createComment:'&',
				updateComment:'&',
				deleteComment:'&',
				resetStatus:'&'
			},


			controller : function($scope, $element, $attrs) {
					
			},


			link : function(scope, element, attrs)
			{

					scope.$watch('comments.isChanged', 

						function(){

							console.log('Comment directive triggered in the link');

							$templateRequest("app/main/apps/forum/views/forumComment.html").then(function(html){
								var template = angular.element(html);
								element.html(template);
								$compile(template)(scope);
							});


							scope.callCreateComment = function( parentID, editStatus ) {
								scope.createComment()( parentID, editStatus );
							}


							scope.callUpdateComment = function( id ) {
								scope.updateComment()( id );
							}


							scope.callDeleteComment = function( id ) {
								scope.deleteComment()( id );
							}

							scope.callResetStatus = function( id ) {
								scope.resetStatus()( id );
							}

						}, true

					);
			}
		}
	}; 
})();



/*
*
*   This is the directive for a for loop in the worksheet
*
*/
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('forLoopObject', forLoopObject);

    /** @ngInject **/
    function forLoopObject($templateRequest, $compile)
    {   return {
            restrict: 'E',

            scope:{
                worksheet:'=',
                struct:'@',
                editperm:'=',
                addStatement:'&',
                addBlock:'&',
                deleteStatement:'&',
                runEquationDigest:'&',
                updateme:'='
            },

            controller : ["$scope", "$element", "$attrs",

                function($scope, $element, $attrs) {
                    

                    $scope.$watch('updateme', 

                        function(){

                            console.log('The struct is ...');
                            console.log($scope.struct);

                            $scope.worksheet.forEach(
                                function(thisItem, index){
                                    if (thisItem['itemid']==$scope.struct)
                                    {
                                        $scope.thisStruct=thisItem;
                                    }
                                }
                            );

                            console.log('The structure is ...');
                            console.log($scope.thisStruct);
                            console.log('Update me 1 is '+$scope.updateme);
                        }
                    );

                }
            ],

            link : function(scope, element){

                scope.$watch('updateme', 

                    function(){

                        $templateRequest("app/main/apps/document/worksheet/views/templates/forLoopObject.html").then(function(html){
                            var template = angular.element(html);
                            element.append(template);
                            $compile(template)(scope);
                        });

                        scope.callAddStatement = function( itemID, type, blockIndex, statementIndex ) {
                            scope.addStatement()( itemID, type, blockIndex, statementIndex );
                        }

                        scope.callAddBlock = function( itemID, type, blockIndex ) {
                            scope.addBlock()( itemID, type, blockIndex );
                        }

                        scope.callDeleteStatement = function( itemID, type, blockIndex, statementIndex ) {
                            scope.deleteStatement()( itemID, type, blockIndex, statementIndex );
                        }

                        scope.callRunEquationDigest = function( ) {
                            scope.runEquationDigest()( );
                        }

                    }, true

                );
            }
        }
    }; 
})();

/*
*
*   This is the directive for a for loop in the window specifics view list
*
*/
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('forLoopList', forLoopList);

    /** @ngInject **/
    function forLoopList($templateRequest, $compile)
    {   return {
            restrict: 'E',

            scope:{
                worksheet:'=',
                struct:'=',
                currentsubitem:'=',
                editperm:'=',
                updateme:'=',
                changecurrent:'&'
            },

            controller : ["$scope", "$element", "$attrs",

                function($scope, $element, $attrs) {
                    $scope.$watch('currentsubitem', 
                        function(){
                            $scope.worksheet.forEach(
                                function(thisItem, index){
                                    if (thisItem['itemid']==$scope.struct.itemid)
                                    {
                                        $scope.structObj=thisItem;
                                    }
                                }
                            );
                        }
                    );
                }
            ],

            link        : function(scope, element, attrs){

                scope.$watch('currentsubitem', 

                    function(){

                        $templateRequest("app/main/apps/document/worksheet/views/templates/multSpec/forLoopList.html").then(function(html){
                            var template = angular.element(html);
                            element.html(template);
                            $compile(template)(scope);
                        });

                        scope.callChangeCurrent = function( thisID ) {
                            scope.changecurrent()( thisID );
                        }

                    }
                );
            }
        }
    }; 
})();
/*
*
*   This is the directive for a for loop in the window specifics view list
*
*/
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('equationList', equationList);

    /** @ngInject **/
    function equationList($templateRequest, $compile)
    {   return {
            restrict: 'E',

            controller : ["$scope", "$element", "$attrs",

                function($scope, $element, $attrs) {
                    

                    $scope.$watch($attrs.eqobject, 

                        function(){

                            $scope.eqObj = $scope.$eval( $attrs.eqobject );

                        }

                    );

                }
            ],

            link : function(scope, element, attrs){
                $templateRequest("app/main/apps/document/worksheet/views/templates/multSpec/equationList.html").then(function(html){
                    var template = angular.element(html);
                    element.html(template);
                    $compile(template)(scope);
                });
            }
        }
    }; 
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        'default'  : {
            primary   : {
                name: 'fuse-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'red'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'pink': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'blue'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'teal'     : {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'deep-orange'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0, color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '=?'
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                //tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        //bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
/*
*
*   Memory storage for documents. This service retains items in memory for documents between views.
*
*/
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('workspaceMemoryFactory', workspaceMemoryFactory);

    /** @ngInject */
    function workspaceMemoryFactory()
    {
        return {

        }
    }

})();
/*
*   This factory provides a number of things needed for the items within a document. This is especially relevant to 
*   new items within a document. The prototypes are here for every item, as well as things they need like the 
*   function to get a new and unique ID. There are are also prototypes for things like references.
*   The exception to this are the two-dimensional and three-dimensional charts. These items are in their own factories
*   so that those factories can be shared with the individual pages for 2D and 3D charts.
*/
(function ()
{
	'use strict';

	angular
		.module('app.core')
		.factory('utilityFactory', utilityFactory);

	/** @ngInject */
	function utilityFactory($http)
	{
		return {
			

			/*
			*
			* Navigate to a URL
			*
			*/
			makeURL : function( fileItem, thisURL ) 
			{   
				//console.log('In the make URL function, the type is '+fileItem.file_type_id+' and the URL is '+thisURL);
				var newURL = '';
				thisURL = thisURL.replace(/\/$/, '');
				if (( thisURL == 'team' )&&( fileItem == 'team' ))
				{
					newURL = window.location.origin+'/Team/';
				}else if ( thisURL == 'team' )
				{
					newURL = window.location.origin+'/Team/'+fileItem.name.replace();
				}else if ( thisURL == 'settings' )
				{
					if ( (window.location.host == 'www.cadwolf.com') || (window.location.host == 'http://www.cadwolf.com') || (window.location.host == 'https://www.cadwolf.com') )
					{
						newURL = 'https://www.cadwolf.com/settings/teams/'+fileItem.id;
					
					}else if ( window.location.host == 'cadwolf-staging.herokuapp.com')
					{
						newURL = 'https://cadwolf-staging.herokuapp.com/settings/teams/'+fileItem.id;
					}
				}else if ( thisURL == 'userSettings' )
				{
					newURL = window.location.origin+'/settings/';
				}else
				{
					if ((fileItem.file_type_id=="Workspace")||(fileItem.file_type_id=="workspace")||(fileItem.file_type_id==0))
					{
						console.log('In the Workspace with '+thisURL);
						newURL = thisURL.replace(/\/Profile\//, '/Workspace/');
						newURL = newURL.replace(/\/Profile[\/a-zA-Z0-9\-\_]+/, '/Workspace/');
						newURL = newURL.replace(/\/Profile/, '/Workspace/');
						newURL = newURL.replace(/\/Team[\/a-zA-Z0-9\-\_]+/, '/Workspace/');
						newURL = newURL.replace('/Document/','/Workspace/');
						newURL = newURL.replace('/Dataset/','/Workspace/');
						newURL = newURL.replace('/PartTree/','/Workspace/');
						newURL = newURL+'/'+fileItem.name;
						console.log('At the end of the Workspace with '+newURL);
					}
					if ((fileItem.file_type_id=="Document")||(fileItem.file_type_id=="document")||(fileItem.file_type_id==1))
					{
						newURL = thisURL.replace(/\/Profile\//, '/Document/');
						newURL = newURL.replace(/\/Profile[\/a-zA-Z0-9\-\_]+/, '/Document/');
						newURL = newURL.replace(/\/Profile/, '/Document/');
						newURL = newURL.replace(/\/Team[\/a-zA-Z0-9\-\_]+/, '/Document/');
						newURL = newURL.replace('/Profile/','/Document/');
						newURL = newURL.replace('/Workspace/','/Document/');
						newURL = newURL.replace('/Dataset/','/Document/');
						newURL = newURL.replace('/PartTree/','/Document/');
						newURL = newURL.replace('/Workflow/','/Document/');
						newURL = newURL+'/'+fileItem.name;
					}
					if ((fileItem.file_type_id=="Dataset")||(fileItem.file_type_id=="dataset")||(fileItem.file_type_id==2))
					{
						newURL = thisURL.replace(/\/Profile\//, '/Dataset/');
						newURL = newURL.replace(/\/Profile[\/a-zA-Z0-9\-\_]+/, '/Dataset/');
						newURL = newURL.replace(/\/Profile/, '/Dataset/');
						newURL = newURL.replace(/\/Team[\/a-zA-Z0-9\-\_]+/, '/Dataset/');
						newURL = newURL.replace('/Profile/','/Dataset/');
						newURL = newURL.replace('/Workspace/','/Dataset/');
						newURL = newURL.replace('/Document/','/Dataset/');
						newURL = newURL.replace('/PartTree/','/Dataset/');
						newURL = newURL.replace('/Workflow/','/Dataset/');
						newURL = newURL+'/'+fileItem.name;
					}
					if ((fileItem.file_type_id=="Part Tree")||(fileItem.file_type_id=="PartTree")||(fileItem.file_type_id==3))
					{
						newURL = thisURL.replace(/\/Profile\//, '/PartTree/');
						newURL = newURL.replace(/\/Profile[\/a-zA-Z0-9\-\_]+/, '/PartTree/');
						newURL = newURL.replace(/\/Profile/, '/PartTree/');
						newURL = newURL.replace(/\/Team[\/a-zA-Z0-9\-\_]+/, '/PartTree/');
						newURL = newURL.replace('/Profile/','/PartTree/');
						newURL = newURL.replace('/Workspace/','/PartTree/');
						newURL = newURL.replace('/Document/','/PartTree/');
						newURL = newURL.replace('/Dataset/','/PartTree/');
						newURL = newURL.replace('/Workflow/','/PartTree/');
						newURL = newURL+'/'+fileItem.name;
					}
					if ((fileItem.file_type_id=="Workflow")||(fileItem.file_type_id=="workflow")||(fileItem.file_type_id==5))
					{
						newURL = thisURL.replace(/\/Profile\//, '/Workflow/');
						newURL = newURL.replace(/\/Profile[\/a-zA-Z0-9\-\_]+/, '/Workflow/');
						newURL = newURL.replace(/\/Profile/, '/Workflow/');
						newURL = newURL.replace(/\/Team[\/a-zA-Z0-9\-\_]+/, '/Workflow/');
						newURL = newURL.replace('/Profile/','/Workflow/');
						newURL = newURL.replace('/Workspace/','/Workflow/');
						newURL = newURL.replace('/Document/','/Workflow/');
						newURL = newURL.replace('/Dataset/','/Workflow/');
						newURL = newURL.replace('/PartTree/','/Workflow/');
						newURL = newURL+'/'+fileItem.name;
					}
					if ((fileItem.file_type_id=="Forum")||(fileItem.file_type_id=="forum")||(fileItem.file_type_id==6))
					{
						newURL = thisURL.replace(/\/Profile\//, '/Forum/');
						newURL = newURL.replace(/\/Profile[\/a-zA-Z0-9\-\_]+/, '/Forum/');
						newURL = newURL.replace(/\/Profile/, '/Forum/');
						newURL = newURL.replace(/\/Team[\/a-zA-Z0-9\-\_]+/, '/Forum/');
						newURL = newURL.replace('/Profile/','/Forum/');
						newURL = newURL.replace('/Workspace/','/Forum/');
						newURL = newURL.replace('/Document/','/Forum/');
						newURL = newURL.replace('/Dataset/','/Forum/');
						newURL = newURL.replace('/PartTree/','/Forum/');
						newURL = newURL+'/'+fileItem.name;
					}
				}
				console.log('The result prior to replace is '+newURL);
				newURL = newURL.replace(/\/\//g, '/');
				newURL = newURL.replace('http\:\/', 'http://');
				newURL = newURL.replace('https\:\/', 'https://');
				newURL = newURL.replace(/ /g,'_');
				
				return newURL;
			},










			/*
			*
			* Determine the state - defunct?
			*
			*/
			determineState : function( fileItem ) 
			{   
				if ((fileItem.file_type_id=="Workspace")||(fileItem.file_type_id=="workspace")||(fileItem.file_type_id==0))
				{
					var thisApp = 'app.workspace';
				}
				if ((fileItem.file_type_id=="Document")||(fileItem.file_type_id=="document")||(fileItem.file_type_id==1))
				{
					var thisApp = 'app.document';
				}
				if ((fileItem.file_type_id=="Dataset")||(fileItem.file_type_id=="dataset")||(fileItem.file_type_id==2))
				{
					var thisApp = 'app.dataset';
				}
				if ((fileItem.file_type_id=="Part Tree")||(fileItem.file_type_id=="partTree")||(fileItem.file_type_id==3))
				{
					var thisApp = 'app.parttree';
				}
				if ((fileItem.file_type_id=="Workflow")||(fileItem.file_type_id=="workflow")||(fileItem.file_type_id==5))
				{
					var thisApp = 'app.workflow';
				}
				if ((fileItem.file_type_id=="Forum")||(fileItem.file_type_id=="forum")||(fileItem.file_type_id==6))
				{
					var thisApp = 'app.forum';
				}

				return thisApp;
			},





			/*
			*
			* Sort the contents of an array based upon a given property
			*
			*/
			dynamicSort : function(property) 
			{   var sortOrder = 1;
				if(property[0] === "-") {
					sortOrder = -1;
					property = property.substr(1);
				}
				return function (a,b) 
				{   var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0; 
					return result * sortOrder;
				}
			},






			/*
			* Takes in the full object and an array of start and stop positions and returns a 
			* smaller array from those indexes
			*
			*/
			retrieveSubmatrix : function( fullObject, indexArray ) 
			{   

				var key='';
				var count=1;
				var newObject={};
	
				for (var a=0; a<indexArray.length; a++)
				{
					var span = indexArray[a]['end'] - indexArray[a]['start'];
					count = count * ( span + 1 );
				}

				for (var a=0; a<count; a++)
				{
					key='';
					for (var b=0; b<indexArray.length; b++)
					{
						key = key+'-'+indexArray[b]['index'];
					}
					key = key.replace(/^-/,'');

					
					var newKey='';
					for (var b=0; b<indexArray.length; b++)
					{
						if (indexArray[b]['active'])
						{
							newKey = newKey+'-'+indexArray[b]['index'];
						}
					}
					newKey = newKey.replace(/^-/,'');

					newObject[newKey] = fullObject[key];


					for (var b=indexArray.length-1; b>=0; b--)
					{
						if (indexArray[b]['active'])
						{
							indexArray[b]['index'] = parseInt(indexArray[b]['index']) + 1;
							
							if (indexArray[b]['index'] > indexArray[b]['end'])
							{
								indexArray[b-1]['index'] = parseInt(indexArray[b-1]['index'])+1;

								for (var c=b; c<indexArray.length; c++)
								{
									indexArray[c]['index'] = indexArray[c]['start'];
								}
							}
							break
						}
					}


				}

				return newObject

			},






			/*
			* Takes in an object that has two dimensions and makes it an array. Used for display loop purposes
			*
			*/
			makeArray : function( fullObject ) 
			{   

				var splitKey = '';
				var returnArray = [];
				for (var key in fullObject )
				{
					splitKey = key.split('-');
					if (returnArray[splitKey[0]] === undefined){ returnArray[splitKey[0]] = []; }
					if (returnArray[splitKey[0]][splitKey[1]] === undefined){ returnArray[splitKey[0]][splitKey[1]] = []; }
					returnArray[splitKey[0]][splitKey[1]] = fullObject[key];
				}

				return returnArray

			},







			/*
			* 
			*
			*/
			getSize : function( fullObject ) 
			{   

				var splitKey = [];
				var thisSize = [];
				for (var key in fullObject )
				{
					splitKey = key.split('-');
					for (var a=0; a<splitKey.length; a++)
					{
						if ( ( parseInt(splitKey[a]) > thisSize[a] ) || ( thisSize[a]===undefined ) )
						{
							thisSize[a] = parseInt(splitKey[a]);
						}
					}
				}

				var sizeText = '';
				for (var a=0; a<thisSize.length; a++)
				{
					sizeText = sizeText+'x'+parseInt(thisSize[a]+1);
				}
				sizeText = sizeText.replace(/^x/, '');
				return sizeText

			},






			/*
			*
			* Function to get text for drop down menu
			*
			*/
			getSelectedText : function(thisItem) 
			{
				if (thisItem !== undefined) {
					return "You have selected: " + thisItem;
				} else {
					return "Please select an item";
				}
			},



			/*
			*
			*
			*   True if the item is a number. False if not
			*
			*/
			isNumber : function (o) {  return ! isNaN (o-0); },




			/*
			*
			* Check to see if an item has been favorited
			*
			*/
			checkFavorite : function( type, item, userInfo ) 
			{   
				if (type=='Workspace'){ var thisItem = userInfo.favWorkspaces; }
				if (type=='Document'){ var thisItem = userInfo.favDocuments; }
				if (type=='Dataset'){ var thisItem = userInfo.favDatasets; }
				if (type=='Part Tree'){ var thisItem = userInfo.favParttrees; }
				if (type=='Plot'){ var thisItem = userInfo.favPlots; }
				if (type=='Surface'){ var thisItem = userInfo.favSurfaces; }

				var flag=false;
				for (var a=0; a<thisItem.length; a++)
				{
					if ( thisItem[a]['id'] == item['id'] )
					{
						flag=true;
					}
				}
				return flag;
			},






			/*
			*
			* Add or remove a favorite workspace, document, dataset, etc
			*
			*/
			favoriteItem : function( type, item, userInfo, thisURL ) 
			{   
				if (type=='Workspace'){ var thisItem = userInfo.favWorkspaces; }
				if (type=='Document'){ var thisItem = userInfo.favDocuments; }
				if (type=='Dataset'){ var thisItem = userInfo.favDatasets; }
				if (type=='Part Tree'){ var thisItem = userInfo.favParttrees; }
				if (type=='Plot'){ var thisItem = userInfo.favPlots; }
				if (type=='Surface'){ var thisItem = userInfo.favSurfaces; }

				var flag=0;
				for (var a=0; a<thisItem.length; a++)
				{
					if ( thisItem[a]['id'] == item['id'] )
					{
						flag=1;
						thisItem = thisItem.splice( a, 1 );
					}
				}
				if ( flag == 0 )
				{
					var newItem = {};
					newItem.id = item.id;
					newItem.name = item.name;
					newItem.location = thisURL;
					thisItem = thisItem.splice( 0, 0, newItem);
				}

				return userInfo;
			},








			/*
			*
			* Add a recent item to the array
			*
			*/
			setRecent : function( type, item, userInfo, thisURL ) 
			{   
				if (type=='Workspace'){ var thisItem = userInfo.workspaces; }
				if (type=='Document'){ var thisItem = userInfo.documents; }
				if (type=='Dataset'){ var thisItem = userInfo.datasets; }
				if (type=='Part Tree'){ var thisItem = userInfo.parttrees; }
				if (type=='Plot'){ var thisItem = userInfo.plots; }
				if (type=='Surface'){ var thisItem = userInfo.surfaces; }

				for (var a=0; a<thisItem.length; a++)
				{
					if ( thisItem[a]['id'] == item['id'] )
					{
						thisItem = thisItem.splice( a, 1 );
					}
				}
				thisURL = thisURL.replace(/^\/Document\//,'');
				thisURL = thisURL.replace(/^\/Workspace\//,'');
				thisURL = thisURL.replace(/^\/Dataset\//,'');
				thisURL = thisURL.replace(/^\/PartTree\//,'');
				thisURL = thisURL.replace(/^\/Plot\//,'');
				thisURL = thisURL.replace(/^\/Surface\//,'');

				if ( item !== undefined )
				{
					var newItem = {};
					newItem.id = item.id;
					newItem.name = item.name;
					newItem.location = thisURL;
					thisItem = thisItem.splice( 0, 0, newItem);
				}

				if (thisItem.length>30)
				{
					thisItem = thisItem.splice( 30, 0, newItem);					
				}

				return userInfo;
			}


		}
	}

})();
/*
*
*   Memory storage for documents. This service retains items in memory for documents between views.
*
*/
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('userMemoryFactory', userMemoryFactory);

    /** @ngInject */
    function userMemoryFactory()
    {
        return {

        }
    }

})();
/*
*   
*
*
*/
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('unitConstantFactory', unitConstantFactory);

    /** @ngInject */
    function unitConstantFactory()
    {
        return {
            
            constObj : function() 
            {

            	var returnArray =[
				 
					{
						"name":"pi",
						"value":"3.141592653589793",
						"units":"",
						"measurement":"NA",
						"showvalue":"\\pi",
						"Description":"The normal value of pi",
						"Base":"{\"A\":0,\"K\":0,\"s\":0,\"m\":0,\"kg\":0,\"cd\":0,\"mol\":0,\"rad\":0,\"molecules\":0}"
					
					},{
						
						"name":"grav",
						"value":"9.81",
						"units":"m/s^2",
						"measurement":"acceleration",
						"showvalue":"grav",
						"Description":"Gravitational constant",
						"Base":"{\"A\":0,\"K\":0,\"s\":-2,\"m\":1,\"kg\":0,\"cd\":0,\"mol\":0,\"rad\":0,\"molecules\":0}"

					},{
						"name":"N_A",
						"value":"6.0221409e23",
						"units":"molecules/mol",
						"measurement":"molecules/mol",
						"showvalue":"N_A",
						"Description":"Avogadro's Number",
						"Base":"{\"A\":0,\"K\":0,\"s\":0,\"m\":0,\"kg\":0,\"cd\":0,\"mol\":-1,\"rad\":0,\"molecules\":1}"
					},{
						"name":"c_O",
						"value":"299792458",
						"units":"m/s",
						"measurement":"velocity",
						"showvalue":"c_0",
						"Description":"Speed of Light",
						"Base":"{\"A\":0,\"K\":0,\"s\":-1,\"m\":1,\"kg\":0,\"cd\":0,\"mol\":0,\"rad\":0,\"molecules\":0}"
					},{
						"name":"atm",
						"value":"101325",
						"units":"N/m^2",
						"measurement":"pressure",
						"showvalue":"atm",
						"Description":"Atmospheric Pressure",
						"Base":"{\"A\":0,\"K\":0,\"s\":-2,\"m\":-1,\"kg\":1,\"cd\":0,\"mol\":0,\"rad\":0,\"molecules\":0}"
					},{
						"name":"e",
						"value":"2.71828",
						"units":"",
						"measurement":"",
						"showvalue":"e",
						"Description":"",
						"Base":"{\"A\":0,\"K\":0,\"s\":0,\"m\":0,\"kg\":0,\"cd\":0,\"mol\":0,\"rad\":0,\"molecules\":0}"
					},{
						"name":"R",
						"value":"8.3144621",
						"units":"J/(K*mol)",
						"measurement":"",
						"showvalue":"R",
						"Description":"The universal gas constant",
						"Base":"{\"A\":0,\"K\":0,\"s\":-2,\"m\":2,\"kg\":1,\"cd\":0,\"mol\":0,\"rad\":0,\"molecules\":0}"
					},{
						"name":"k_e",
						"value":"8987500000",
						"units":"N*m^2/Coulomb^2",
						"measurement":"",
						"showvalue":"k_e",
						"Description":"Coulombs constant",
						"Base":"{\"A\":-2,\"K\":0,\"s\":-4,\"m\":3,\"kg\":1,\"cd\":0,\"mol\":0,\"rad\":0,\"molecules\":0}"
					},{
						"name":"epsilon_0",
						"value":"0.0000000000088542",
						"units":"Coulomb^2/(N*m^2)",
						"measurement":"",
						"showvalue":"\\epsilon_0",
						"Description":"Permittivity of free space",
						"Base":"{\"A\":2,\"K\":0,\"s\":4,\"m\":-3,\"kg\":-1,\"cd\":0,\"mol\":0,\"rad\":0,\"molecules\":0}"
					}
				]; 

				return returnArray
            },


            parseObj : function()
            {
				var returnArray = [
					{
						"base_unit":"A","default":"1","name":"ampere","showunits":"1","quantity":"Electric Current","rad":"0","m":"0","kg":"0","s":"0","A":"1","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"K","default":"1","name":"kelvin","showunits":"1","quantity":"Temperature","rad":"0","m":"0","kg":"0","s":"0","A":"0","K":"1","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"s","default":"1","name":"second","showunits":"s","quantity":"time","rad":"0","m":"0","kg":"0","s":"1","A":"0","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"m","default":"1","name":"meter","showunits":"m","quantity":"length","rad":"0","m":"1","kg":"0","s":"0","A":"0","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"kg","default":"1","name":"kilogram","showunits":"kg","quantity":"mass","rad":"0","m":"0","kg":"1","s":"0","A":"0","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"cd","default":"1","name":"candela","showunits":"cd","quantity":"luminous intensity","rad":"0","m":"0","kg":"0","s":"0","A":"0","K":"0","mol":"0","cd":"1", "molecules":"0"
					},{
						"base_unit":"mol","default":"1","name":"mole","showunits":"mol","quantity":"mol","rad":"0","m":"0","kg":"0","s":"0","A":"0","K":"0","mol":"1","cd":"0", "molecules":"0"
					},{
						"base_unit":"rad","default":"1","name":"radian","showunits":"rad","quantity":"Angle","rad":"1","m":"0","kg":"0","s":"0","A":"0","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"molecules","default":"1","name":"molecules","showunits":"molecules","quantity":"molecules","rad":"0","m":"0","kg":"0","s":"0","A":"0","K":"0","mol":"0","cd":"0", "molecules":"1"
					},{

						"base_unit":"J","default":"0","name":"joule","showunits":"J","quantity":"energy","rad":"0","m":"2","kg":"1","s":"-2","A":"0","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"N*m","default":"1","name":"Newton-Meter","showunits":"N*m","quantity":"torque","rad":"0","m":"2","kg":"1","s":"-2","A":"0","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"Hz","default":"0","name":"hertz","showunits":"Hz","quantity":"frequency","rad":"1","m":"0","kg":"0","s":"-1","A":"0","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"Pa","default":"1","name":"pascal","showunits":"Pa","quantity":"pressure","rad":"0","m":"-1","kg":"1","s":"-2","A":"0","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"N","default":"1","name":"Newton","showunits":"N","quantity":"force","rad":"0","m":"1","kg":"1","s":"-2","A":"0","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"W","default":"1","name":"Watt","showunits":"W","quantity":"power","rad":"0","m":"2","kg":"1","s":"-3","A":"0","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"St","default":"1","name":"stokes","showunits":"St","quantity":"kinematic viscosity","rad":"0","m":"2","kg":"0","s":"-1","A":"0","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"Coulomb","default":"1","name":"Coulomb","showunits":"Coulomb","quantity":"Electric Charge","rad":"0","m":"0","kg":"0","s":"1","A":"1","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"V","default":"1","name":"Volt","showunits":"V","quantity":"electromotive force","rad":"0","m":"2","kg":"1","s":"-3","A":"-1","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"Ohm","default":"1","name":"Ohm","showunits":"Ohm","quantity":"electrical resistance","rad":"0","m":"2","kg":"1","s":"-3","A":"-2","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"Farad","default":"1","name":"Farad","showunits":"Farad","quantity":"Capacitance","rad":"0","m":"-2","kg":"-1","s":"4","A":"2","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"Wb","default":"1","name":"weber","showunits":"Weber","quantity":"magnetic flux","rad":"0","m":"2","kg":"1","s":"-2","A":"-1","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"T","default":"1","name":"Tesla","showunits":"T","quantity":"Magnetic Field","rad":"0","m":"0","kg":"1","s":"-2","A":"-1","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"twp","default":"0","name":"Township","showunits":"twp","quantity":"area","rad":"0","m":"2","kg":"0","s":"0","A":"0","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"acre","default":"0","name":"acre","showunits":"acre","quantity":"area","rad":"0","m":"2","kg":"0","s":"0","A":"0","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"hectare","default":"0","name":"hectare","showunits":"hectare","quantity":"area","rad":"0","m":"2","kg":"0","s":"0","A":"0","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"Pa*s","default":"0","name":"Pascal Second","showunits":"Pa*s","quantity":"dynamic viscosity","rad":"0","m":"-1","kg":"1","s":"-1","A":"0","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"hp","default":"0","name":"Horse Power","showunits":"hp","quantity":"Power","rad":"0","m":"2","kg":"1","s":"-3","A":"0","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"rpm","default":"0","name":"rpm","showunits":"rpm","quantity":"Power","rad":"1","m":"0","kg":"0","s":"-1","A":"0","K":"0","mol":"0","cd":"0", "molecules":"0"
					},{
						"base_unit":"Btu","default":"0","name":"Btu","showunits":"Btu","quantity":"torque","rad":"0","m":"2","kg":"1","s":"-2","A":"0","K":"0","mol":"0","cd":"0", "molecules":"0"
					}
				];

				return returnArray
            },


            unitsObj : function()
            {
            	var returnArray = [
            		{
            			"ID":"1",
            			"unit":"nm",
            			"conv_unit":"m",
            			"conv_factor":"0.000000001",
            			"quantity":"length",
            			"name":"nanometer",
            			"Class":"SI"
            		},{
            			"ID":"2",
            			"unit":"um",
            			"conv_unit":"m",
            			"conv_factor":"0.000001",
            			"quantity":"length",
            			"name":"micrometer",
            			"Class":"SI"
            		},{
            			"ID":"3",
            			"unit":"mm",
            			"conv_unit":"m",
            			"conv_factor":"0.001",
            			"quantity":"length","name":"millimeter","Class":"SI", "basestring":"00000000"
            		},{
            			"ID":"4","unit":"cm","conv_unit":"m","conv_factor":"0.01","quantity":"length","name":"centimeter","Class":"SI", "basestring":"00000000"
            		},{
            			"ID":"5","unit":"dm","conv_unit":"m","conv_factor":"0.1","quantity":"length","name":"decimeter","Class":"SI", "basestring":"00000000"
            		},{
            			"ID":"6","unit":"m","conv_unit":"m","conv_factor":"1","quantity":"length","name":"meter","Class":"SI", "basestring":"00000000"
            		},{
            			"ID":"7","unit":"hm","conv_unit":"m","conv_factor":"100","quantity":"length","name":"hectometer","Class":"SI", "basestring":"00000000"
            		},{
            			"ID":"8","unit":"km","conv_unit":"m","conv_factor":"1000","quantity":"length","name":"kilometer","Class":"SI", "basestring":"00000000"
        			},{
        				"ID":"9","unit":"Mm","conv_unit":"m","conv_factor":"1000000","quantity":"length","name":"megameter","Class":"SI", "basestring":"00000000"
    				},{
    					"ID":"10","unit":"Gm","conv_unit":"m","conv_factor":"1000000000","quantity":"length","name":"gigameter","Class":"SI", "basestring":"00000000"
    				},{
    					"ID":"11","unit":"Tm","conv_unit":"m","conv_factor":"1000000000000","quantity":"length","name":"terameter","Class":"SI", "basestring":"00000000"
    				},{
    					"ID":"12","unit":"s","conv_unit":"s","conv_factor":"1","quantity":"time","name":"second","Class":"SI", "basestring":"00000000"
    				},{
    					"ID":"13","unit":"minute","conv_unit":"s","conv_factor":"60","quantity":"time","name":"minute","Class":"SI", "basestring":"00000000"
    				},{
    					"ID":"14","unit":"hour","conv_unit":"s","conv_factor":"3600","quantity":"time","name":"hour","Class":"SI", "basestring":"00000000"
    				},{
    					"ID":"15","unit":"day","conv_unit":"s","conv_factor":"216000","quantity":"time","name":"days","Class":"SI", "basestring":"00000000"
    				},{
    					"ID":"16","unit":"miles","conv_unit":"m","conv_factor":"1609.3399658203125","quantity":"length","name":"miles","Class":"British", "basestring":"00000000"
    				},{
    					"ID":"17","unit":"yards","conv_unit":"m","conv_factor":"0.9143999814987183","quantity":"length","name":"yards","Class":"British", "basestring":"00000000"
    				},{
    					"ID":"18","unit":"foot","conv_unit":"m","conv_factor":"0.3048","quantity":"length","name":"foot","Class":"British", "basestring":"00000000"
    				},{
    					"ID":"19","unit":"in","conv_unit":"m","conv_factor":"0.0254","quantity":"length","name":"inch","Class":"British", "basestring":"00000000"
    				},{
    					"ID":"20","unit":"nmile","conv_unit":"m","conv_factor":"1852","quantity":"length","name":"nautical mile","Class":"British", "basestring":"00000000"
    				},{
    					"ID":"21","unit":"lb","conv_unit":"kg","conv_factor":"0.45359237","quantity":"mass","name":"pound","Class":"English", "basestring":"00000000"
    				},{
    					"ID":"22","unit":"N","conv_unit":"N","conv_factor":"1","quantity":"force","name":"Newton","Class":"SI", "basestring":"00-211000"
    				},{
    					"ID":"23","unit":"lbf","conv_unit":"N","conv_factor":"4.44822","quantity":"force","name":"Pound Force","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"24","unit":"kip","conv_unit":"N","conv_factor":"4448.2216","quantity":"force","name":"Kips","Class":"British", "basestring":"00-211000"
					},{
						"ID":"25","unit":"dyn","conv_unit":"N","conv_factor":"0.0001","quantity":"force","name":"Dyne","Class":"British", "basestring":"00-211000"
					},{
						"ID":"26","unit":"Pa","conv_unit":"Pa","conv_factor":"1","quantity":"pressure","name":"Pascal","Class":"SI", "basestring":"00-2-11000"
					},{
						"ID":"27","unit":"psi","conv_unit":"Pa","conv_factor":"6894.7568359375","quantity":"pressure","name":"Pounds per Square Inch","Class":"British", "basestring":"00-2-11000"
					},{
						"ID":"28","unit":"atm","conv_unit":"Pa","conv_factor":"101325","quantity":"pressure","name":"Atmosphere (standard)","Class":"British", "basestring":"00-2-11000"
					},{
						"ID":"29","unit":"bar","conv_unit":"Pa","conv_factor":"1000000","quantity":"pressure","name":"Bar","Class":"British", "basestring":"00-2-11000"
					},{
						"ID":"30","unit":"ksi","conv_unit":"Pa","conv_factor":"6894757.28","quantity":"pressure","name":"Kips per Square Inch","Class":"British", "basestring":"00-2-11000"
					},{
						"ID":"31","unit":"psf","conv_unit":"Pa","conv_factor":"47.8802604675293","quantity":"pressure","name":"Pounds per Square Foot","Class":"British", "basestring":"00-2-11000"
					},{
						"ID":"32","unit":"torr","conv_unit":"Pa","conv_factor":"133.32240295410156","quantity":"pressure","name":"Torr","Class":"British", "basestring":"00-2-11000"
					},{
						"ID":"33","unit":"N*m","conv_unit":"N*m","conv_factor":"1","quantity":"torque","name":"Newton-Meter","Class":"SI", "basestring":"00-221000"
					},{
						"ID":"34","unit":"ft*lbf","conv_unit":"N*m","conv_factor":"1.3558179140090942","quantity":"torque","name":"Foot-Pound Force","Class":"British", "basestring":"00-221000"
					},{
						"ID":"35","unit":"in*lbf","conv_unit":"N*m","conv_factor":"0.11298482865095139","quantity":"torque","name":"Inch-Pound Force","Class":"British", "basestring":"00-221000"
					},{
						"ID":"36","unit":"m*kg","conv_unit":"N*m","conv_factor":"0.10197161883115768","quantity":"torque","name":"Meter-Kilogram","Class":"SI", "basestring":"00-221000"
					},{
						"ID":"37","unit":"dam","conv_unit":"m","conv_factor":"10","quantity":"length","name":"decameter","Class":"SI", "basestring":"00000000"
					},{
						"ID":"38","unit":"Pm","conv_unit":"m","conv_factor":"1e15","quantity":"length","name":"petameter","Class":"SI", "basestring":"00000000"
					},{
						"ID":"39","unit":"Em","conv_unit":"m","conv_factor":"1e18","quantity":"length","name":"Exameter","Class":"SI", "basestring":"00000000"
					},{
						"ID":"40","unit":"Zm","conv_unit":"m","conv_factor":"1e21","quantity":"length","name":"Zettameter","Class":"SI", "basestring":"00000000"
					},{
						"ID":"41","unit":"Ym","conv_unit":"m","conv_factor":"1e24","quantity":"length","name":"yottameter","Class":"SI", "basestring":"00000000"
					},{
						"ID":"42","unit":"pm","conv_unit":"m","conv_factor":"1e-12","quantity":"length","name":"picometer","Class":"SI", "basestring":"00000000"
					},{
						"ID":"43","unit":"fm","conv_unit":"m","conv_factor":"1e-15","quantity":"length","name":"femtometer","Class":"SI", "basestring":"00000000"
					},{
						"ID":"44","unit":"am","conv_unit":"m","conv_factor":"1e-18","quantity":"length","name":"attometer","Class":"SI", "basestring":"00000000"
					},{
						"ID":"45","unit":"zm","conv_unit":"m","conv_factor":"1e-21","quantity":"length","name":"zeptometer","Class":"SI", "basestring":"00000000"
					},{
						"ID":"46","unit":"ym","conv_unit":"m","conv_factor":"1e-24","quantity":"length","name":"yoctometer","Class":"SI", "basestring":"00000000"
					},{
						"ID":"47","unit":"daPa","conv_unit":"Pa","conv_factor":"10","quantity":"pressure","name":"decaPascal","Class":"SI", "basestring":"00-2-11000"
					},{
						"ID":"48","unit":"hPa","conv_unit":"Pa","conv_factor":"100","quantity":"pressure","name":"hectoPascal","Class":"SI", "basestring":"00-2-11000"
					},{
						"ID":"49","unit":"kPa","conv_unit":"Pa","conv_factor":"1000","quantity":"pressure","name":"kiloPascal","Class":"SI", "basestring":"00-2-11000"
					},{
						"ID":"50","unit":"MPa","conv_unit":"Pa","conv_factor":"1000000","quantity":"pressure","name":"MegaPascal","Class":"SI", "basestring":"00-2-11000"
					},{
						"ID":"51","unit":"GPa","conv_unit":"Pa","conv_factor":"1000000000","quantity":"pressure","name":"GigaPascal","Class":"SI", "basestring":"00-2-11000"
					},{
						"ID":"52","unit":"TPa","conv_unit":"Pa","conv_factor":"1e12","quantity":"pressure","name":"TeraPascal","Class":"SI", "basestring":"00-2-11000"
					},{
						"ID":"53","unit":"PPa","conv_unit":"Pa","conv_factor":"1e15","quantity":"pressure","name":"petaPascal","Class":"SI", "basestring":"00-2-11000"
					},{
						"ID":"54","unit":"EPa","conv_unit":"Pa","conv_factor":"1e18","quantity":"pressure","name":"ExaPascal","Class":"SI", "basestring":"00-2-11000"
					},{
						"ID":"55","unit":"ZPa","conv_unit":"Pa","conv_factor":"1e21","quantity":"pressure","name":"zettaPascal","Class":"SI", "basestring":"00-2-11000"
					},{
						"ID":"56","unit":"YPa","conv_unit":"Pa","conv_factor":"1e24","quantity":"pressure","name":"yottaPascal","Class":"SI", "basestring":"00-2-11000"
					},{
						"ID":"57","unit":"dPa","conv_unit":"Pa","conv_factor":"0.1","quantity":"pressure","name":"deciPascal","Class":"SI", "basestring":"00-2-11000"
					},{
						"ID":"58","unit":"cPa","conv_unit":"Pa","conv_factor":"0.01","quantity":"pressure","name":"centiPascal","Class":"SI", "basestring":"00-2-11000"
					},{
						"ID":"59","unit":"mPa","conv_unit":"Pa","conv_factor":"0.001","quantity":"pressure","name":"milliPascal","Class":"SI", "basestring":"00-2-11000"
					},{
						"ID":"60","unit":"uPa","conv_unit":"Pa","conv_factor":"0.000001","quantity":"pressure","name":"microPascal","Class":"SI", "basestring":"00-2-11000"
					},{
						"ID":"61","unit":"nPa","conv_unit":"Pa","conv_factor":"0.00000001","quantity":"pressure","name":"nanoPascal","Class":"SI", "basestring":"00-2-11000"
					},{
						"ID":"62","unit":"pPa","conv_unit":"Pa","conv_factor":"1e-12","quantity":"pressure","name":"picoPascal","Class":"SI", "basestring":"00-2-11000"
					},{
						"ID":"63","unit":"fPa","conv_unit":"Pa","conv_factor":"1e-15","quantity":"pressure","name":"femtoPascal","Class":"SI", "basestring":"00-2-11000"
					},{
						"ID":"64","unit":"aPa","conv_unit":"Pa","conv_factor":"1e-18","quantity":"pressure","name":"attoPascal","Class":"SI", "basestring":"00-2-11000"
					},{
						"ID":"65","unit":"zPa","conv_unit":"Pa","conv_factor":"1e-21","quantity":"pressure","name":"zeptoPascal","Class":"SI", "basestring":"00-2-11000"
					},{
						"ID":"66","unit":"yPa","conv_unit":"Pa","conv_factor":"1e-24","quantity":"pressure","name":"yoctoPascal","Class":"SI", "basestring":"00-2-11000"
					},{
						"ID":"67","unit":"kg","conv_unit":"kg","conv_factor":"1","quantity":"mass","name":"kilogram","Class":"SI", "basestring":"00000000"
					},{
						"ID":"68","unit":"ft","conv_unit":"m","conv_factor":"0.3048","quantity":"length","name":"foot","Class":"SI", "basestring":"00000000"
					},{
						"ID":"69","unit":"ng","conv_unit":"kg","conv_factor":"1e-12","quantity":"mass","name":"nanogram","Class":"SI", "basestring":"00000000"
					},{
						"ID":"70","unit":"ug","conv_unit":"kg","conv_factor":"1e-9","quantity":"mass","name":"microgram","Class":"SI", "basestring":"00000000"
					},{
						"ID":"71","unit":"mg","conv_unit":"kg","conv_factor":"0.000001","quantity":"mass","name":"milligram","Class":"SI", "basestring":"00000000"
					},{
						"ID":"72","unit":"cg","conv_unit":"kg","conv_factor":"0.00001","quantity":"mass","name":"centigram","Class":"SI", "basestring":"00000000"
					},{
						"ID":"73","unit":"dg","conv_unit":"kg","conv_factor":"0.0001","quantity":"mass","name":"decigram","Class":"SI", "basestring":"00000000"
					},{
						"ID":"74","unit":"g","conv_unit":"kg","conv_factor":"0.001","quantity":"mass","name":"gram","Class":"SI", "basestring":"00000000"
					},{
						"ID":"75","unit":"hg","conv_unit":"kg","conv_factor":"10","quantity":"mass","name":"hectogram","Class":"SI", "basestring":"00000000"
					},{
						"ID":"76","unit":"Mg","conv_unit":"kg","conv_factor":"1000","quantity":"mass","name":"megagram","Class":"SI", "basestring":"00000000"
					},{
						"ID":"77","unit":"Gg","conv_unit":"kg","conv_factor":"1000000","quantity":"mass","name":"gigagram","Class":"SI", "basestring":"00000000"
					},{
						"ID":"78","unit":"Tg","conv_unit":"kg","conv_factor":"1000000000","quantity":"mass","name":"teragram","Class":"SI", "basestring":"00000000"
					},{
						"ID":"79","unit":"mph","conv_unit":"m/s","conv_factor":"0.44703999161720276","quantity":"velocity","name":"miles per hour","Class":"English"
					},{
						"ID":"80","unit":"cc","conv_unit":"m^3","conv_factor":"0.001","quantity":"volume","name":"cubic centimeter","Class":"SI", "basestring":"00000000"
					},{
						"ID":"81","unit":"cycles2","conv_unit":"cycles","conv_fac":"1","quantity":"cycles2","name":"cycles","Class":"SI", "basestring":"00000000"
					},{
						"ID":"82","unit":"V","conv_unit":"V","conv_factor":"1","quantity":"Voltage","name":"Volt","Class":"SI", "basestring":"-10-321000"
					},{
						"ID":"83","unit":"Coulomb","conv_unit":"Coulomb","conv_factor":"1","quantity":"Electric Charge","name":"Coulomb","Class":"SI", "basestring":"10100000"
					},{
						"ID":"84","unit":"Ohm","conv_unit":"Ohm","conv_factor":"1","quantity":"Resistance","name":"Ohm","Class":"SI", "basestring":"-20-321000"
					},{
						"ID":"85","unit":"W","conv_unit":"W","conv_factor":"1","quantity":"Electric Power","name":"Watt","Class":"SI", "basestring":"00-321000"
					},{
						"ID":"86","unit":"Farad","conv_unit":"Farad","conv_factor":"1","quantity":"Capacitance","name":"Farad","Class":"SI", "basestring":"204-2-1000"
					},{
						"ID":"87","unit":"H","conv_unit":"H","conv_factor":"1","quantity":"Inductance","name":"Henry","Class":"SI", "basestring":"00000000"
					},{
						"ID":"88","unit":"S","conv_unit":"S","conv_factor":"1","quantity":"Conductance","name":"Siemens","Class":"SI", "basestring":"00000000"
					},{
						"ID":"89","unit":"T","conv_unit":"T","conv_factor":"1","quantity":"Magnetic Field","name":"Tesla","Class":"SI", "basestring":"00000000"
					},{
						"ID":"90","unit":"Wb","conv_unit":"Wb","conv_factor":"1","quantity":"Magnetic Flux","name":"Weber","Class":"SI", "basestring":"-10-221000"
					},{
						"ID":"91","unit":"kWh","conv_unit":"J","conv_factor":"3600000","quantity":"energy","name":"Kilowatt Hour","Class":"SI", "basestring":"00000000"
					},{
						"ID":"92","unit":"nFarad","conv_unit":"Farad","conv_factor":"1e-9","quantity":"Capacitance","name":"nanoFarad","Class":"SI", "basestring":"204-2-1000"
					},{
						"ID":"93","unit":"uFarad","conv_unit":"Farad","conv_factor":"0.000001","quantity":"Capacitance","name":"microFarad","Class":"SI", "basestring":"204-2-1000"
					},{
						"ID":"94","unit":"mFarad","conv_unit":"Farad","conv_factor":"0.001","quantity":"Capacitance","name":"milliFarad","Class":"SI", "basestring":"204-2-1000"
					},{
						"ID":"95","unit":"cFarad","conv_unit":"Farad","conv_factor":"0.01","quantity":"Capacitance","name":"centiFarad","Class":"SI", "basestring":"204-2-1000"
					},{
						"ID":"96","unit":"dFarad","conv_unit":"Farad","conv_factor":"0.1","quantity":"Capacitance","name":"deciFarad","Class":"SI", "basestring":"204-2-1000"
					},{
						"ID":"97","unit":"hFarad","conv_unit":"Farad","conv_factor":"100","quantity":"Capacitance","name":"hectoFarad","Class":"SI", "basestring":"204-2-1000"
					},{
						"ID":"98","unit":"kFarad","conv_unit":"Farad","conv_factor":"1000","quantity":"Capacitance","name":"kiloFarad","Class":"SI", "basestring":"204-2-1000"
					},{
						"ID":"99","unit":"MFarad","conv_unit":"Farad","conv_factor":"1000000","quantity":"Capacitance","name":"MegaFarad","Class":"SI", "basestring":"204-2-1000"
					},{
						"ID":"100","unit":"GFarad","conv_unit":"Farad","conv_factor":"1000000000","quantity":"Capacitance","name":"GigaFarad","Class":"SI", "basestring":"204-2-1000"
					},{
						"ID":"101","unit":"TFarad","conv_unit":"Farad","conv_factor":"1e12","quantity":"Capacitance","name":"TeraFarad","Class":"SI", "basestring":"204-2-1000"
					},{
						"ID":"102","unit":"daFarad","conv_unit":"Farad","conv_factor":"10","quantity":"Capacitance","name":"decaFarad","Class":"SI", "basestring":"204-2-1000"
					},{
						"ID":"103","unit":"PFarad","conv_unit":"Farad","conv_factor":"1e15","quantity":"Capacitance","name":"PetaFarad","Class":"SI", "basestring":"204-2-1000"
					},{
						"ID":"104","unit":"EFarad","conv_unit":"Farad","conv_factor":"1e18","quantity":"Capacitance","name":"ExaFarad","Class":"SI", "basestring":"204-2-1000"
					},{
						"ID":"105","unit":"ZFarad","conv_unit":"Farad","conv_factor":"1e21","quantity":"Capacitance","name":"ZettaFarad","Class":"SI", "basestring":"204-2-1000"
					},{
						"ID":"106","unit":"YFarad","conv_unit":"Farad","conv_factor":"1e24","quantity":"Capacitance","name":"YottaFarad","Class":"SI", "basestring":"204-2-1000"
					},{
						"ID":"107","unit":"Ah","conv_unit":"Coulomb","conv_factor":"3600","quantity":"Electric Charge","name":"Ampere-Hour","Class":"SI", "basestring":"00000000"
					},{
						"ID":"108","unit":"nCoulomb","conv_unit":"Coulomb","conv_factor":"1e-9","quantity":"Electric Charge","name":"nanoCoulomb","Class":"SI", "basestring":"10100000"
					},{
						"ID":"109","unit":"uCoulomb","conv_unit":"Coulomb","conv_factor":"0.000001","quantity":"Electric Charge","name":"microCoulomb","Class":"SI", "basestring":"10100000"
					},{
						"ID":"110","unit":"mCoulomb","conv_unit":"Coulomb","conv_factor":"0.001","quantity":"Electric Charge","name":"milliCoulomb","Class":"SI", "basestring":"10100000"
					},{
						"ID":"111","unit":"cCoulomb","conv_unit":"Coulomb","conv_factor":"0.01","quantity":"Electric Charge","name":"centiCoulomb","Class":"SI", "basestring":"10100000"
					},{
						"ID":"112","unit":"dCoulomb","conv_unit":"Coulomb","conv_factor":"0.1","quantity":"Electric Charge","name":"deciCoulomb","Class":"SI", "basestring":"10100000"
					},{
						"ID":"113","unit":"hCoulomb","conv_unit":"Coulomb","conv_factor":"100","quantity":"Electric Charge","name":"hectoCoulomb","Class":"SI", "basestring":"10100000"
					},{
						"ID":"114","unit":"kCoulomb","conv_unit":"Coulomb","conv_factor":"1000","quantity":"Electric Charge","name":"killoCoulomb","Class":"SI", "basestring":"10100000"
					},{
						"ID":"115","unit":"GCoulomb","conv_unit":"Coulomb","conv_factor":"1000000000","quantity":"Electric Charge","name":"GigaCoulomb","Class":"SI", "basestring":"10100000"
					},{
						"ID":"116","unit":"TCoulomb","conv_unit":"Coulomb","conv_factor":"1e12","quantity":"Electric Charge","name":"TeraCoulomb","Class":"SI", "basestring":"10100000"
					},{
						"ID":"117","unit":"MCoulomb","conv_unit":"Coulomb","conv_factor":"1000000","quantity":"Electric Charge","name":"MegaCoulomb","Class":"SI", "basestring":"10100000"
					},{
						"ID":"118","unit":"daCoulomb","conv_unit":"Coulomb","conv_factor":"10","quantity":"Electric Charge","name":"decaCoulomb","Class":"SI", "basestring":"10100000"
					},{
						"ID":"119","unit":"PCoulomb","conv_unit":"Coulomb","conv_factor":"1e-12","quantity":"Electric Charge","name":"PicoCoulomb","Class":"SI", "basestring":"10100000"
					},{
						"ID":"120","unit":"ECoulomb","conv_unit":"Coulomb","conv_factor":"1e18","quantity":"Electric Charge","name":"ExaCoulomb","Class":"SI", "basestring":"10100000"
					},{
						"ID":"121","unit":"ZCoulomb","conv_unit":"Coulomb","conv_factor":"1e21","quantity":"Electric Charge","name":"ZettaCoulomb","Class":"SI", "basestring":"10100000"
					},{
						"ID":"122","unit":"YCoulomb","conv_unit":"Coulomb","conv_factor":"1e24","quantity":"Electric Charge","name":"YottaCoulomb","Class":"SI", "basestring":"10100000"
					},{
						"ID":"123","unit":"nH","conv_unit":"H","conv_factor":"1e-9","quantity":"Inductance","name":"nanoHenry","Class":"SI", "basestring":"00000000"
					},{
						"ID":"124","unit":"uH","conv_unit":"H","conv_factor":"0.000001","quantity":"Inductance","name":"microHenry","Class":"SI", "basestring":"00000000"
					},{
						"ID":"125","unit":"mH","conv_unit":"H","conv_factor":"0.001","quantity":"Inductance","name":"milliHenry","Class":"SI", "basestring":"00000000"
					},{
						"ID":"126","unit":"cH","conv_unit":"H","conv_factor":"0.01","quantity":"Inductance","name":"centiHenry","Class":"SI", "basestring":"00000000"
					},{
						"ID":"127","unit":"dH","conv_unit":"H","conv_factor":"0.1","quantity":"Inductance","name":"deciHenry","Class":"SI", "basestring":"00000000"
					},{
						"ID":"128","unit":"hH","conv_unit":"H","conv_factor":"100","quantity":"Inductance","name":"hectoHenry","Class":"SI", "basestring":"00000000"
					},{
						"ID":"129","unit":"kH","conv_unit":"H","conv_factor":"1000","quantity":"Inductance","name":"kiloHenry","Class":"SI", "basestring":"00000000"
					},{
						"ID":"130","unit":"MH","conv_unit":"H","conv_factor":"1000000","quantity":"Inductance","name":"MegaHenry","Class":"SI", "basestring":"00000000"
					},{
						"ID":"131","unit":"GH","conv_unit":"H","conv_factor":"1000000000","quantity":"Inductance","name":"GigaHenry","Class":"SI", "basestring":"00000000"
					},{
						"ID":"132","unit":"TH","conv_unit":"H","conv_factor":"1e12","quantity":"Inductance","name":"TeraHenry","Class":"SI", "basestring":"00000000"
					},{
						"ID":"133","unit":"daH","conv_unit":"H","conv_factor":"10","quantity":"Inductance","name":"decaHenry","Class":"SI", "basestring":"00000000"
					},{
						"ID":"134","unit":"PH","conv_unit":"H","conv_factor":"1e15","quantity":"Inductance","name":"PetaHenry","Class":"SI", "basestring":"00000000"
					},{
						"ID":"135","unit":"EH","conv_unit":"H","conv_factor":"1e18","quantity":"Inductance","name":"ExaHenry","Class":"SI", "basestring":"00000000"
					},{
						"ID":"136","unit":"ZH","conv_unit":"H","conv_factor":"1e21","quantity":"Inductance","name":"ZettaHenry","Class":"SI", "basestring":"00000000"
					},{
						"ID":"137","unit":"YH","conv_unit":"H","conv_factor":"1e24","quantity":"Electric Charge","name":"YottaHenry","Class":"SI", "basestring":"00000000"
					},{
						"ID":"138","unit":"nOhm","conv_unit":"Ohm","conv_factor":"1e-9","quantity":"Resistance","name":"nanoOhm","Class":"SI", "basestring":"-20-321000"
					},{
						"ID":"139","unit":"uOhm","conv_unit":"Ohm","conv_factor":"0.000001","quantity":"Resistance","name":"microOhm","Class":"SI", "basestring":"-20-321000"
					},{
						"ID":"140","unit":"mOhm","conv_unit":"Ohm","conv_factor":"0.001","quantity":"Resistance","name":"milliOhm","Class":"SI", "basestring":"-20-321000"
					},{
						"ID":"141","unit":"cOhm","conv_unit":"Ohm","conv_factor":"0.01","quantity":"Resistance","name":"centiOhm","Class":"SI", "basestring":"-20-321000"
					},{
						"ID":"142","unit":"dOhm","conv_unit":"Ohm","conv_factor":"0.1","quantity":"Resistance","name":"deciOhm","Class":"SI", "basestring":"-20-321000"
					},{
						"ID":"143","unit":"hOhm","conv_unit":"Ohm","conv_factor":"100","quantity":"Resistance","name":"hectoOhm","Class":"SI", "basestring":"-20-321000"
					},{
						"ID":"144","unit":"kOhm","conv_unit":"Ohm","conv_factor":"1000","quantity":"Resistance","name":"killoOhm","Class":"SI", "basestring":"-20-321000"
					},{
						"ID":"145","unit":"MOhm","conv_unit":"Ohm","conv_factor":"1000000","quantity":"Resistance","name":"MegaOhm","Class":"SI", "basestring":"-20-321000"
					},{
						"ID":"146","unit":"GOhm","conv_unit":"Ohm","conv_factor":"1000000000","quantity":"Resistance","name":"GigaOhm","Class":"SI", "basestring":"-20-321000"
					},{
						"ID":"147","unit":"TOhm","conv_unit":"Ohm","conv_factor":"1e12","quantity":"Resistance","name":"TeraOhm","Class":"SI", "basestring":"-20-321000"
					},{
						"ID":"148","unit":"nV","conv_unit":"V","conv_factor":"1e-9","quantity":"Voltage","name":"nanoVolt","Class":"SI", "basestring":"-10-321000"
					},{
						"ID":"149","unit":"uV","conv_unit":"V","conv_factor":"0.000001","quantity":"Voltage","name":"microVolt","Class":"SI", "basestring":"-10-321000"
					},{
						"ID":"150","unit":"mV","conv_unit":"V","conv_factor":"0.001","quantity":"Voltage","name":"milliVolt","Class":"SI", "basestring":"-10-321000"
					},{
						"ID":"151","unit":"cV","conv_unit":"V","conv_factor":"0.01","quantity":"Voltage","name":"centiVolt","Class":"SI", "basestring":"-10-321000"
					},{
						"ID":"152","unit":"dV","conv_unit":"V","conv_factor":"0.1","quantity":"Voltage","name":"deciVolt","Class":"SI", "basestring":"-10-321000"
					},{
						"ID":"153","unit":"hV","conv_unit":"V","conv_factor":"100","quantity":"Voltage","name":"hectoVolt","Class":"SI", "basestring":"-10-321000"
					},{
						"ID":"154","unit":"kV","conv_unit":"V","conv_factor":"1000","quantity":"Voltage","name":"kiloVolt","Class":"SI", "basestring":"-10-321000"
					},{
						"ID":"155","unit":"MV","conv_unit":"V","conv_factor":"1000000","quantity":"Voltage","name":"MegaVolt","Class":"SI", "basestring":"-10-321000"
					},{
						"ID":"156","unit":"GV","conv_unit":"V","conv_factor":"1000000000","quantity":"Voltage","name":"TeraVolt","Class":"SI", "basestring":"-10-321000"
					},{
						"ID":"157","unit":"TV","conv_unit":"V","conv_factor":"1e12","quantity":"Voltage","name":"TeraVolt","Class":"SI", "basestring":"-10-321000"
					},{
						"ID":"158","unit":"daV","conv_unit":"V","conv_factor":"10","quantity":"Voltage","name":"decaVolt","Class":"SI", "basestring":"-10-321000"
					},{
						"ID":"159","unit":"ZV","conv_unit":"V","conv_factor":"1e21","quantity":"Voltage","name":"ZettaVolt","Class":"SI", "basestring":"-10-321000"
					},{
						"ID":"160","unit":"YZ","conv_unit":"V","conv_factor":"1e24","quantity":"Voltage","name":"YottaVolt","Class":"SI", "basestring":"-10-321000"
					},{
						"ID":"161","unit":"nWb","conv_unit":"Wb","conv_factor":"1e-9","quantity":"Magnetic Flux","name":"nanoWeber","Class":"SI", "basestring":"-10-221000"
					},{
						"ID":"162","unit":"uWb","conv_unit":"Wb","conv_factor":"0.000001","quantity":"Magnetic Flux","name":"microWeber","Class":"SI", "basestring":"-10-221000"
					},{
						"ID":"163","unit":"mWb","conv_unit":"Wb","conv_factor":"0.001","quantity":"Magnetic Flux","name":"milliWeber","Class":"SI", "basestring":"-10-221000"
					},{
						"ID":"164","unit":"cWb","conv_unit":"Wb","conv_factor":"0.01","quantity":"Magnetic Flux","name":"centiWeber","Class":"SI", "basestring":"-10-221000"
					},{
						"ID":"165","unit":"dWb","conv_unit":"Wb","conv_factor":"0.1","quantity":"Magnetic Flux","name":"deciWeber","Class":"SI", "basestring":"-10-221000"
					},{
						"ID":"166","unit":"hWb","conv_unit":"Wb","conv_factor":"100","quantity":"Magnetic Flux","name":"hectoWeber","Class":"SI", "basestring":"-10-221000"
					},{
						"ID":"167","unit":"kWb","conv_unit":"Wb","conv_factor":"1000","quantity":"Magnetic Flux","name":"kiloWeber","Class":"SI", "basestring":"-10-221000"
					},{
						"ID":"168","unit":"MWb","conv_unit":"Wb","conv_factor":"1000000","quantity":"Magnetic Flux","name":"MegaWeber","Class":"SI", "basestring":"-10-221000"
					},{
						"ID":"169","unit":"GWb","conv_unit":"Wb","conv_factor":"1000000000","quantity":"Magnetic Flux","name":"GigaWeber","Class":"SI", "basestring":"-10-221000"
					},{
						"ID":"170","unit":"TWb","conv_unit":"Wb","conv_factor":"1e12","quantity":"Magnetic Flux","name":"TeraWeber","Class":"SI", "basestring":"-10-221000"
					},{
						"ID":"171","unit":"daWb","conv_unit":"Wb","conv_factor":"10","quantity":"Magnetic Flux","name":"decaWeber","Class":"SI", "basestring":"-10-221000"
					},{
						"ID":"172","unit":"ZWb","conv_unit":"Wb","conv_factor":"1e21","quantity":"Magnetic Flux","name":"ZettaWeber","Class":"SI", "basestring":"-10-221000"
					},{
						"ID":"173","unit":"YWb","conv_unit":"Wb","conv_factor":"1e24","quantity":"Magnetic Flux","name":"ZettaWeber","Class":"SI", "basestring":"-10-221000"
					},{
						"ID":"174","unit":"ns","conv_unit":"s","conv_factor":"1e-9","quantity":"time","name":"nanosecond","Class":"SI", "basestring":"00000000"
					},{
						"ID":"175","unit":"us","conv_unit":"s","conv_factor":"0.000001","quantity":"time","name":"microsecond","Class":"SI", "basestring":"00000000"
					},{
						"ID":"176","unit":"ms","conv_unit":"s","conv_factor":"0.001","quantity":"time","name":"millisecond","Class":"SI", "basestring":"00000000"
					},{
						"ID":"177","unit":"cs","conv_unit":"s","conv_factor":"0.01","quantity":"time","name":"centisecond","Class":"SI", "basestring":"00000000"
					},{
						"ID":"178","unit":"ds","conv_unit":"s","conv_factor":"0.1","quantity":"time","name":"decisecond","Class":"SI", "basestring":"00000000"
					},{
						"ID":"179","unit":"hs","conv_unit":"s","conv_factor":"100","quantity":"time","name":"hectosecond","Class":"SI", "basestring":"00000000"
					},{
						"ID":"180","unit":"ks","conv_unit":"s","conv_factor":"1000","quantity":"time","name":"kilosecond","Class":"SI", "basestring":"00000000"
					},{
						"ID":"181","unit":"Ms","conv_unit":"s","conv_factor":"1000000","quantity":"time","name":"Megasecond","Class":"SI", "basestring":"00000000"
					},{
						"ID":"182","unit":"Gs","conv_unit":"s","conv_factor":"1000000000","quantity":"time","name":"Gigasecond","Class":"SI", "basestring":"00000000"
					},{
						"ID":"183","unit":"Ts","conv_unit":"s","conv_factor":"1e12","quantity":"time","name":"Terasecond","Class":"SI", "basestring":"00000000"
					},{
						"ID":"184","unit":"das","conv_unit":"s","conv_factor":"10","quantity":"time","name":"decasecond","Class":"SI", "basestring":"00000000"
					},{
						"ID":"185","unit":"Zs","conv_unit":"s","conv_factor":"1e21","quantity":"time","name":"Zettasecond","Class":"SI", "basestring":"00000000"
					},{
						"ID":"186","unit":"Ys","conv_unit":"s","conv_factor":"1e24","quantity":"time","name":"Yottasecond","Class":"SI", "basestring":"00000000"
					},{
						"ID":"187","unit":"nT","conv_unit":"T","conv_factor":"1e-9","quantity":"Magnetic Field","name":"nanoTesla","Class":"SI", "basestring":"00000000"
					},{
						"ID":"188","unit":"uT","conv_unit":"T","conv_factor":"0.000001","quantity":"Magnetic Field","name":"microTesla","Class":"SI", "basestring":"00000000"
					},{
						"ID":"189","unit":"mT","conv_unit":"T","conv_factor":"0.001","quantity":"Magnetic Field","name":"milliTesla","Class":"SI", "basestring":"00000000"
					},{
						"ID":"190","unit":"cT","conv_unit":"T","conv_factor":"0.01","quantity":"Magnetic Field","name":"centiTesla","Class":"SI", "basestring":"00000000"
					},{
						"ID":"191","unit":"dT","conv_unit":"T","conv_factor":"0.1","quantity":"Magnetic Field","name":"deciTesla","Class":"SI", "basestring":"00000000"
					},{
						"ID":"192","unit":"hT","conv_unit":"T","conv_factor":"100","quantity":"Magnetic Field","name":"hectoTesla","Class":"SI", "basestring":"00000000"
					},{
						"ID":"193","unit":"kT","conv_unit":"T","conv_factor":"1000","quantity":"Magnetic Field","name":"kiloTesla","Class":"SI", "basestring":"00000000"
					},{
						"ID":"194","unit":"MT","conv_unit":"T","conv_factor":"1000000","quantity":"Magnetic Field","name":"MegaTesla","Class":"SI", "basestring":"00000000"
					},{
						"ID":"195","unit":"GT","conv_unit":"T","conv_factor":"1000000000","quantity":"Magnetic Field","name":"GigaTesla","Class":"SI", "basestring":"00000000"
					},{
						"ID":"196","unit":"TT","conv_unit":"T","conv_factor":"1e12","quantity":"Magnetic Field","name":"TeraTesla","Class":"SI", "basestring":"00000000"
					},{
						"ID":"197","unit":"daT","conv_unit":"T","conv_factor":"10","quantity":"Magnetic Field","name":"decaTesla","Class":"SI", "basestring":"00000000"
					},{
						"ID":"198","unit":"ZT","conv_unit":"T","conv_factor":"1e21","quantity":"Magnetic Field","name":"ZettaTesla","Class":"SI", "basestring":"00000000"
					},{
						"ID":"199","unit":"YT","conv_unit":"T","conv_factor":"1e24","quantity":"Magnetic Field","name":"YottaTesla","Class":"SI", "basestring":"00000000"
					},{
						"ID":"200","unit":"nW","conv_unit":"W","conv_factor":"1e-9","quantity":"Electric Power","name":"nanoWatt","Class":"SI", "basestring":"00-321000"
					},{
						"ID":"201","unit":"uW","conv_unit":"W","conv_factor":"0.000001","quantity":"Electric Power","name":"microWatt","Class":"SI", "basestring":"00-321000"
					},{
						"ID":"202","unit":"mW","conv_unit":"W","conv_factor":"0.001","quantity":"Electric Power","name":"milliWatt","Class":"SI", "basestring":"00-321000"
					},{
						"ID":"203","unit":"cW","conv_unit":"W","conv_factor":"0.01","quantity":"Electric Power","name":"centiWatt","Class":"SI", "basestring":"00-321000"
					},{
						"ID":"204","unit":"dW","conv_unit":"W","conv_factor":"0.1","quantity":"Electric Power","name":"deciWatt","Class":"SI", "basestring":"00-321000"
					},{
						"ID":"205","unit":"hW","conv_unit":"W","conv_factor":"100","quantity":"Electric Power","name":"hectoWatt","Class":"SI", "basestring":"00-321000"
					},{
						"ID":"206","unit":"kW","conv_unit":"W","conv_factor":"1000","quantity":"Electric Power","name":"kiloWatt","Class":"SI", "basestring":"00-321000"
					},{
						"ID":"207","unit":"MW","conv_unit":"W","conv_factor":"1000000","quantity":"Electric Power","name":"MegaWatt","Class":"SI", "basestring":"00-321000"
					},{
						"ID":"208","unit":"GW","conv_unit":"W","conv_factor":"1000000000","quantity":"Electric Power","name":"GigaWatt","Class":"SI", "basestring":"00-321000"
					},{
						"ID":"209","unit":"TW","conv_unit":"W","conv_factor":"1e12","quantity":"Electric Power","name":"TeraWatt","Class":"SI", "basestring":"00-321000"
					},{
						"ID":"210","unit":"daW","conv_unit":"W","conv_factor":"10","quantity":"Electric Power","name":"decaWatt","Class":"SI", "basestring":"00-321000"
					},{
						"ID":"211","unit":"ZW","conv_unit":"W","conv_factor":"1e21","quantity":"Electric Power","name":"ZettaWatt","Class":"SI", "basestring":"00-321000"
					},{
						"ID":"212","unit":"YW","conv_unit":"W","conv_factor":"1e24","quantity":"Electric Power","name":"YottaWatt","Class":"SI", "basestring":"00-321000"
					},{
						"ID":"213","unit":"nS","conv_unit":"S","conv_factor":"1e-9","quantity":"Conductance","name":"nanoSeimens","Class":"SI", "basestring":"00000000"
					},{
						"ID":"214","unit":"uS","conv_unit":"S","conv_factor":"0.000001","quantity":"Conductance","name":"microSiemens","Class":"SI", "basestring":"00000000"
					},{
						"ID":"215","unit":"mS","conv_unit":"S","conv_factor":"0.001","quantity":"Conductance","name":"milliSiemens","Class":"SI", "basestring":"00000000"
					},{
						"ID":"216","unit":"cS","conv_unit":"S","conv_factor":"0.01","quantity":"Conductance","name":"centiSiemens","Class":"SI", "basestring":"00000000"
					},{
						"ID":"217","unit":"dS","conv_unit":"S","conv_factor":"0.1","quantity":"Conductance","name":"deciSiemens","Class":"SI", "basestring":"00000000"
					},{
						"ID":"218","unit":"hS","conv_unit":"S","conv_factor":"100","quantity":"Conductance","name":"hectoSiemens","Class":"SI", "basestring":"00000000"
					},{
						"ID":"219","unit":"kS","conv_unit":"S","conv_factor":"1000","quantity":"Conductance","name":"kiloSiemens","Class":"SI", "basestring":"00000000"
					},{
						"ID":"220","unit":"MS","conv_unit":"S","conv_factor":"1000000","quantity":"Conductance","name":"MegaSiemens","Class":"SI", "basestring":"00000000"
					},{
						"ID":"221","unit":"GS","conv_unit":"S","conv_factor":"1000000000","quantity":"Conductance","name":"GigaSiemens","Class":"SI", "basestring":"00000000"
					},{
						"ID":"222","unit":"TS","conv_unit":"S","conv_factor":"1e12","quantity":"Conductance","name":"TeraSiemens","Class":"SI", "basestring":"00000000"
					},{
						"ID":"223","unit":"daS","conv_unit":"S","conv_factor":"10","quantity":"Conductance","name":"decaSiemens","Class":"SI", "basestring":"00000000"
					},{
						"ID":"224","unit":"ZS","conv_unit":"S","conv_factor":"1e21","quantity":"Conductance","name":"ZettaSiemens","Class":"SI", "basestring":"00000000"
					},{
						"ID":"225","unit":"YS","conv_unit":"S","conv_factor":"1e24","quantity":"Conductance","name":"YottaSiemens","Class":"SI", "basestring":"00000000"
					},{
						"ID":"226","unit":"revolutions","conv_unit":"rad","conv_factor":"6.28318530718","quantity":"Angle","name":"Revolutions","Class":"SI", "basestring":"00000000"
					},{
						"ID":"227","unit":"cycles","conv_unit":"rad","conv_factor":"6.28318530718","quantity":"Angle","name":"Cycles","Class":"SI", "basestring":"00000000"
					},{
						"ID":"228","unit":"degrees","conv_unit":"rad","conv_factor":"0.0174532925","quantity":"Angle","name":"degrees","Class":"SI", "basestring":"00000000"
					},{
						"ID":"229","unit":"degree","conv_unit":"rad","conv_factor":"0.0174532925","quantity":"Angle","name":"degrees","Class":"SI", "basestring":"00000000"
					},{
						"ID":"230","unit":"deg","conv_unit":"rad","conv_factor":"0.0174532925","quantity":"Angle","name":"degrees","Class":"SI", "basestring":"00000000"
					},{
						"ID":"231","unit":"rad","conv_unit":"rad","conv_factor":"1","quantity":"Angle","name":"radians","Class":"SI", "basestring":"00000000"
/*
					},{
						"ID":"232","unit":"m^2","conv_unit":"m^2","conv_factor":"1","quantity":"area","name":"meters squared","Class":"SI", "basestring":"00000000"
*/
					},{
						"ID":"233","unit":"acre","conv_unit":"acre","conv_factor":"4046.8564224","quantity":"area","name":"acre","Class":"SI", "basestring":"00000000"
					},{
						"ID":"234","unit":"hectare","conv_unit":"acre","conv_factor":"10000","quantity":"area","name":"hectare","Class":"SI", "basestring":"00000000"

/*					},{
						"ID":"235","unit":"cm^2","conv_unit":"m^2","conv_factor":"0.0001","quantity":"area","name":"square centimeter","Class":"SI", "basestring":"00000000"
					},{
						"ID":"236","unit":"ft^2","conv_unit":"m^2","conv_factor":"0.09290304","quantity":"area","name":"square foot","Class":"SI", "basestring":"00000000"
					},{
						"ID":"237","unit":"in^2","conv_unit":"m^2","conv_factor":"0.00064516","quantity":"area","name":"square inch","Class":"SI", "basestring":"00000000"
					},{
						"ID":"238","unit":"km^2","conv_unit":"m^2","conv_factor":"1000000","quantity":"area","name":"square kilometer","Class":"SI", "basestring":"00000000"
					},{
						"ID":"239","unit":"miles^2","conv_unit":"m^2","conv_factor":"2589988.110336","quantity":"area","name":"square mile","Class":"SI", "basestring":"00000000"
					},{
						"ID":"240","unit":"mm^2","conv_unit":"m^2","conv_factor":"0.000001","quantity":"area","name":"square millimeter","Class":"SI", "basestring":"00000000"
					},{
						"ID":"241","unit":"yd^2","conv_unit":"m^2","conv_factor":"0.83612736","quantity":"area","name":"square yard","Class":"SI", "basestring":"00000000"
*/
					},{
						"ID":"242","unit":"twp","conv_unit":"twp","conv_factor":"93239571.9721","quantity":"area","name":"township","Class":"SI", "basestring":"00000000"
					},{
						"ID":"243","unit":"J","conv_unit":"J","conv_factor":"1","quantity":"Moment","name":"Joule","Class":"SI", "basestring":"00-221000"
					},{
						"ID":"244","unit":"N*m","conv_unit":"J","conv_factor":"1","quantity":"energy","name":"Newton-meter","Class":"SI", "basestring":"00-221000"
					},{
						"ID":"248","unit":"mol","conv_unit":"mol","conv_factor":"1","quantity":"mol","name":"mole","Class":"SI", "basestring":"00000000"
					},{
						"ID":"246","unit":"ft-lbf","conv_unit":"J","conv_factor":"1.355817948","quantity":"energy","name":"foot-pound","Class":"SI", "basestring":"00-221000"
					},{
						"ID":"247","unit":"years","conv_unit":"s","conv_factor":"31536000","quantity":"time","name":"Year","Class":"SI", "basestring":"00000000"
					},{
						"ID":"249","unit":"AU","conv_unit":"m","conv_factor":"149597871000","quantity":"length","name":"Astronomical Unit","Class":"SI", "basestring":"00000000"
					},{
						"ID":"250","unit":"K","conv_unit":"K","conv_factor":"1","quantity":"Temperature","name":"Kelvin","Class":"SI", "basestring":"00000000"
					},{
						"ID":"251","unit":"C","conv_unit":"K","conv_factor":"X","quantity":"Temperature","name":"Degrees Celsius","Class":"SI", "basestring":"00000000"
					},{
						"ID":"252","unit":"R","conv_unit":"K","conv_factor":"X","quantity":"Temperature","name":"Rankine","Class":"SI", "basestring":"00000000"
					},{
						"ID":"253","unit":"F","conv_unit":"K","conv_factor":"X","quantity":"Temperature","name":"Degrees Fahrenheit","Class":"SI", "basestring":"00000000"
					},{
						"ID":"254","unit":"kN","conv_unit":"N","conv_factor":"1000","quantity":"Force","name":"kiloNewton","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"255","unit":"minutes","conv_unit":"s","conv_factor":"60","quantity":"time","name":"Minute","Class":"SI", "basestring":"00000000"
					},{
						"ID":"256","unit":"days","conv_unit":"s","conv_factor":"86400","quantity":"time","name":"Day","Class":"SI", "basestring":"00000000"
					},{
						"ID":"257","unit":"A","conv_unit":"A","conv_factor":"1","quantity":"Electric Current","name":"Ampere","Class":"SI", "basestring":"00000000"
					},{
						"ID":"258","unit":"nA","conv_unit":"A","conv_factor":"1e-9","quantity":"Electric Current","name":"nanoAmpere","Class":"SI", "basestring":"00000000"
					},{
						"ID":"259","unit":"uA","conv_unit":"A","conv_factor":"0.000001","quantity":"Electric Current","name":"microAmpere","Class":"SI", "basestring":"00000000"
					},{
						"ID":"260","unit":"mA","conv_unit":"A","conv_factor":"0.001","quantity":"Electric Current","name":"milliAmpere","Class":"SI", "basestring":"00000000"
					},{
						"ID":"261","unit":"cA","conv_unit":"A","conv_factor":"0.01","quantity":"Electric Current","name":"centiAmpere","Class":"SI", "basestring":"00000000"
					},{
						"ID":"262","unit":"dA","conv_unit":"A","conv_factor":"0.1","quantity":"Electric Current","name":"deciAmpere","Class":"SI", "basestring":"00000000"
					},{
						"ID":"263","unit":"hA","conv_unit":"A","conv_factor":"100","quantity":"Electric Current","name":"hectoAmpere","Class":"SI", "basestring":"00000000"
					},{
						"ID":"264","unit":"kA","conv_unit":"A","conv_factor":"1000","quantity":"Electric Current","name":"kiloAmpere","Class":"SI", "basestring":"00000000"
					},{
						"ID":"265","unit":"MA","conv_unit":"A","conv_factor":"1000000","quantity":"Electric Current","name":"MegaAmpere","Class":"SI", "basestring":"00000000"
					},{
						"ID":"266","unit":"GA","conv_unit":"A","conv_factor":"1000000000","quantity":"Electric Current","name":"GigaAmpere","Class":"SI", "basestring":"00000000"
					},{
						"ID":"267","unit":"TA","conv_unit":"A","conv_factor":"1e12","quantity":"Electric Current","name":"TeraAmpere","Class":"SI", "basestring":"00000000"
					},{
						"ID":"268","unit":"daA","conv_unit":"A","conv_factor":"10","quantity":"Electric Current","name":"decaAmpere","Class":"SI", "basestring":"00000000"
					},{
						"ID":"269","unit":"ZA","conv_unit":"A","conv_factor":"1e21","quantity":"Electric Current","name":"ZettaAmpere","Class":"SI", "basestring":"00000000"
					},{
						"ID":"270","unit":"YA","conv_unit":"A","conv_factor":"1e24","quantity":"Electric Current","name":"YottaAmpere","Class":"SI", "basestring":"00000000"
					},{
						"ID":"271","unit":"pFarad","conv_unit":"Farad","conv_factor":"1e-12","quantity":"Capacitance","name":"picoFarad","Class":"SI", "basestring":"204-2-1000"
					},{
						"ID":"272","unit":"molecules","conv_unit":"molecules","conv_factor":"1","quantity":"molecules","name":"molecules","Class":"SI", "basestring":"00000000"
					},{
						"ID":"273","unit":"Gallons","conv_unit":"Gallons","conv_factor":"0.00378541","quantity":"volume","name":"Gallons","Class":"SI", "basestring":"00000000"
					},{
						"ID":"274","unit":"UK Gallons","conv_unit":"UK Gallons","conv_factor":"0.0045","quantity":"volume","name":"UK Gallons","Class":"SI", "basestring":"00000000"
					},{
						"ID":"275","unit":"Liters","conv_unit":"Liters","conv_factor":"0.001","quantity":"volume","name":"Liters","Class":"SI", "basestring":"00000000"
					},{
						"ID":"276","unit":"Hz","conv_unit":"Hz","conv_factor":"1","quantity":"angular velocity","name":"Hertz","Class":"SI", "basestring":"00000000"
					},{
						"ID":"277","unit":"slug","conv_unit":"kg","conv_factor":"14.5939","quantity":"mass","name":"slug","Class":"SI", "basestring":"00000000"
					},{
						"ID":"278","unit":"daN","conv_unit":"N","conv_factor":"10","quantity":"force","name":"decaNewton","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"279","unit":"hN","conv_unit":"N","conv_factor":"100","quantity":"force","name":"hectoNewton","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"280","unit":"MN","conv_unit":"N","conv_factor":"1000000","quantity":"force","name":"MegaNewton","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"281","unit":"GN","conv_unit":"N","conv_factor":"1000000000","quantity":"force","name":"GigaNewton","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"282","unit":"TN","conv_unit":"N","conv_factor":"1e12","quantity":"force","name":"TeraNewton","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"283","unit":"PN","conv_unit":"N","conv_factor":"1e15","quantity":"force","name":"petaNewton","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"284","unit":"EN","conv_unit":"N","conv_factor":"1e18","quantity":"force","name":"ExaNewton","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"285","unit":"ZN","conv_unit":"N","conv_factor":"1e21","quantity":"force","name":"zettaNewton","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"286","unit":"YN","conv_unit":"N","conv_factor":"1e24","quantity":"force","name":"yottaNewton","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"287","unit":"dN","conv_unit":"N","conv_factor":"0.1","quantity":"force","name":"deciNewton","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"288","unit":"cN","conv_unit":"N","conv_factor":"0.01","quantity":"force","name":"centiNewton","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"289","unit":"mN","conv_unit":"N","conv_factor":"0.001","quantity":"force","name":"milliNewton","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"290","unit":"uN","conv_unit":"N","conv_factor":"0.000001","quantity":"force","name":"microNewton","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"291","unit":"nN","conv_unit":"N","conv_factor":"0.00000001","quantity":"force","name":"nanoNewton","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"292","unit":"pN","conv_unit":"N","conv_factor":"1e-12","quantity":"force","name":"picoNewton","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"293","unit":"fN","conv_unit":"N","conv_factor":"1e-15","quantity":"force","name":"femtoNewton","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"294","unit":"aN","conv_unit":"N","conv_factor":"1e-18","quantity":"force","name":"attoNewton","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"295","unit":"zN","conv_unit":"N","conv_factor":"1e-21","quantity":"force","name":"zeptoNewton","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"296","unit":"yN","conv_unit":"N","conv_factor":"1e-24","quantity":"force","name":"yoctoNewton","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"297","unit":"hp","conv_unit":"W","conv_factor":"745.7","quantity":"Power","name":"Horse Power","Class":"SI", "basestring":"00-321000"
					},{
						"ID":"298","unit":"rpm","conv_unit":"rpm","conv_factor":"0.104719755","quantity":"Angular Velocity","name":"Revolutions per Minute","Class":"SI", "basestring":"00-100000"
					},{
						"ID":"299","unit":"St","conv_unit":"St","conv_factor":"0.0001","quantity":"Kinematic Viscocity","name":"Stokes","Class":"SI", "basestring":"00-12000"
					},{
						"ID":"300","unit":"daSt","conv_unit":"St","conv_factor":"10","quantity":"Kinematic Viscocity","name":"decaStokes","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"301","unit":"hSt","conv_unit":"St","conv_factor":"100","quantity":"Kinematic Viscocity","name":"hectoStokes","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"302","unit":"MSt","conv_unit":"St","conv_factor":"1000000","quantity":"Kinematic Viscocity","name":"MegaStokes","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"303","unit":"GSt","conv_unit":"St","conv_factor":"1000000000","quantity":"Kinematic Viscocity","name":"GigaStokes","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"304","unit":"TSt","conv_unit":"St","conv_factor":"1e12","quantity":"Kinematic Viscocity","name":"TeraStokes","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"305","unit":"PSt","conv_unit":"St","conv_factor":"1e15","quantity":"Kinematic Viscocity","name":"petaStokes","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"306","unit":"ESt","conv_unit":"St","conv_factor":"1e18","quantity":"Kinematic Viscocity","name":"ExaStokes","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"307","unit":"ZSt","conv_unit":"St","conv_factor":"1e21","quantity":"Kinematic Viscocity","name":"zettaStokes","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"308","unit":"YSt","conv_unit":"St","conv_factor":"1e24","quantity":"Kinematic Viscocity","name":"yottaStokes","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"309","unit":"dSt","conv_unit":"St","conv_factor":"0.1","quantity":"Kinematic Viscocity","name":"deciStokes","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"310","unit":"cSt","conv_unit":"St","conv_factor":"0.01","quantity":"Kinematic Viscocity","name":"centiStokes","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"311","unit":"mSt","conv_unit":"St","conv_factor":"0.001","quantity":"Kinematic Viscocity","name":"milliStokes","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"312","unit":"uSt","conv_unit":"St","conv_factor":"0.000001","quantity":"Kinematic Viscocity","name":"microStokes","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"313","unit":"nSt","conv_unit":"St","conv_factor":"0.00000001","quantity":"Kinematic Viscocity","name":"nanoStokes","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"314","unit":"pSt","conv_unit":"St","conv_factor":"1e-12","quantity":"Kinematic Viscocity","name":"picoStokes","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"315","unit":"fSt","conv_unit":"St","conv_factor":"1e-15","quantity":"Kinematic Viscocity","name":"femtoStokes","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"316","unit":"aSt","conv_unit":"St","conv_factor":"1e-18","quantity":"Kinematic Viscocity","name":"attoStokes","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"317","unit":"zSt","conv_unit":"St","conv_factor":"1e-21","quantity":"Kinematic Viscocity","name":"zeptoStokes","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"318","unit":"ySt","conv_unit":"St","conv_factor":"1e-24","quantity":"Kinematic Viscocity","name":"yoctoStokes","Class":"SI", "basestring":"00-211000"
					},{
						"ID":"319","unit":"Btu","conv_unit":"J","conv_factor":"1055.06","quantity":"Moment","name":"Joule","Class":"SI", "basestring":"00-221000"
					}
				];

				return returnArray
            }

        }

    }

})();
/*
*
*   This factory provides the prototype for the 3D surfaces and a few other functions needed to create 
*   and maintain the surface.
*  
*/

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('surfaceFactory', surfaceFactory);

    /** @ngInject */
    function surfaceFactory(docItemFactory)
    {
        return {
            
 
            /*
            *
            *
            *   SECTION 1 - PROTOTYPES FOR THE SURFACE AND A DATASET
            *
            *
            */



            surfacePro : function(objProps, plotID, fileID) 
            {   
                var surfObj={};
                surfObj.Format_plotid=plotID;              
                surfObj.Format_haschanged=1;   
                surfObj.Chart_width="825px";                                               
                surfObj.Chart_height="500px";                                              
                surfObj.Page_position=0;       
                surfObj.Page_parentid="none";  
                surfObj.Page_topparentid="none";
                surfObj.xLength=0;                 
                surfObj.yLength=0;                 
                surfObj.zLength=0;                 
                surfObj.axisHelper=0;              
                surfObj.Props={};              
                surfObj.Props.screen_width='800';
                surfObj.Props.screen_height='600';
                surfObj.Props.view_angle=45;   
                surfObj.Props.aspect=surfObj.Props.screen_width/surfObj.Props.screen_height; 
                surfObj.Props.near=0.1;        
                surfObj.Props.far=20000;       
                surfObj.Props.xLength=0;               surfObj.Props.yLength=0;               surfObj.Props.zLength=0;       
                surfObj.Props.cMin=99999999999;        surfObj.Props.cMax=-99999999999;
                surfObj.Props.xMax=-99999999999;       surfObj.Props.yMax=-99999999999;       surfObj.Props.zMax=-99999999999;
                surfObj.Props.xMin=99999999999;        surfObj.Props.yMin=99999999999;        surfObj.Props.zMin=99999999999;
                surfObj.Props.xRot=0;                  surfObj.Props.yRot=0;                  surfObj.Props.zRot=0;
                surfObj.Props.xPos=0;                  surfObj.Props.yPos=0;                  surfObj.Props.zPos=0;
                surfObj.Props.xCamPos=0;               surfObj.Props.yCamPos=0;               surfObj.Props.zCamPos=0;
                surfObj.Props.xCamPosFlag=0;           surfObj.Props.yCamPosFlag=0;           surfObj.Props.zCamPosFlag=0;
                surfObj.Props.divideColormap=0;
                surfObj.Props.Legend={};       
                surfObj.Props.Legend.colorMap='rainbow';       
                surfObj.Props.Legend.numberOfColors=32;        
                surfObj.Props.Legend.onOff=0;  
                surfObj.Props.Legend.layout='horizontal';      
                surfObj.Props.Legend.show=0;   
                surfObj.Props.Legend.showHide="show";          
                surfObj.Props.Legend.numTicks=5;   
                surfObj.Planes=[]; 
                surfObj.Errors=[]; 
                surfObj.Chart_dataobj=[];      
                surfObj.Chart_type='Surface';
                surfObj.activeType='chartData';  
                for (var item in objProps){ surfObj[item]=JSON.parse(JSON.stringify(objProps[item])); }

                return surfObj
            },



            surfaceDataPro : function (dataID, plotID, objProps)
            {   
                var dataObj = {};
                dataObj.type="surface"         
                dataObj.Format_id=dataID;          
                dataObj.Format_plotid=plotID;      
                dataObj.series=0;
                dataObj.dataname="New Dataset";            
                dataObj.xDataRaw='';   dataObj.yDataRaw='';       dataObj.zDataRaw='';           dataObj.cDataRaw='';           
                dataObj.xData={};      dataObj.yData={};          dataObj.zData={};              dataObj.cData={};              
                dataObj.xMin=0;        dataObj.xMax=0;            dataObj.yMin=0;        dataObj.yMax=0;       dataObj.zMin=0;        dataObj.zMax=0;
                dataObj.cMin=0;        dataObj.cMax=0;            dataObj.useColorData=0;        
                dataObj.showLines=1;           
                dataObj.surfaceGeometry={};    
                dataObj.colorMap='rainbow';    
                dataObj.numberOfColors=32;     
                dataObj.legendOnOff=1;
                dataObj.legendNumTicks=5;
                dataObj.legendLayout='horizontal';
                dataObj.flat=0;                
                dataObj.xOffset=0;     dataObj.yOffset=0;         dataObj.zOffset=0; 
                dataObj.color="ffffcc";        
                dataObj.wireColor='000000';    
                dataObj.lineRadius=2;          
                dataObj.lineRadSegs=10;            
                dataObj.lineClosed=false;      
                dataObj.wireFrame="Wireframe"; 
                dataObj.sWireFrame="Solid";    
                dataObj.width=10;              
                dataObj.height=10;             
                dataObj.depth=10;              
                dataObj.widthSegs=10;          
                dataObj.heightSegs=10;         
                dataObj.depthSegs=10;          
                dataObj.radius=10;             
                dataObj.detail=1;              
                dataObj.phiStart=0;            
                dataObj.phiLength=360;         
                dataObj.thetaStart=0;          
                dataObj.thetaLength=360;       
                dataObj.topRadius=10;          
                dataObj.botRadius=10;          
                dataObj.radSegs=10;                
                dataObj.openEnded=false;       
                dataObj.tubeDiameter=10;       
                dataObj.tubeSegs=10;           
                dataObj.arc=360;               
                dataObj.curve=[];              
                dataObj.curveText='';          
                dataObj.numSegs=1;             
                dataObj.xStart=0;          dataObj.xStop=10;          dataObj.yStart=0;          dataObj.yStop=10;          dataObj.zStart=0;          dataObj.zStop=10;              
                dataObj.xSpacing=1;        dataObj.ySpacing=1;        dataObj.zSpacing=1;            
                dataObj.gridType="XY";         
                dataObj.axisType="X";          
                dataObj.axisStart=0;           
                dataObj.axisStop=10;           
                dataObj.axisInterval=1;        
                dataObj.axisFontSize=32;       
                dataObj.tickLength=3;          
                dataObj.axisColor='000000';    
                dataObj.fontsize=1;            
                dataObj.xDir=1;            dataObj.yDir=1;            dataObj.zDir=1;
                dataObj.length=1;              
                dataObj.arrowHeight=1;             
                dataObj.arrowWidth=1;              
                dataObj.xPosition=0;       dataObj.yPosition=0;       dataObj.zPosition=0;           
                dataObj.xRotation=0;       dataObj.yRotation=0;       dataObj.zRotation=0;           
                dataObj.xTextOffset=0;     dataObj.yTextOffset=0;     dataObj.zTextOffset=0;     
                for (var prop in objProps){ dataObj[prop] = objProps[prop]; } 
            
                return dataObj
            },


            /*
            *
            *   ADDING A DATASET TO THE SURFACE MAP
            *
            */
            addSurfaceDataset : function ( fileID, surfaceObj, worksheetObj )                                             
            {   
                var thisTemplate=new this.surfaceDataPro( docItemFactory.getID('dataSeries', fileID, worksheetObj), 
                                                          surfaceObj.itemid, 
                                                          { Format_plotid : surfaceObj.itemid } );
                thisTemplate['series']=surfaceObj['content']['Surface']['Chart_dataobj'].length;
                surfaceObj['content']['Surface']['Chart_dataobj'].push( thisTemplate );
                console.log('I added a new dataset with an id of '+thisTemplate['Format_id']+' to the plot '+surfaceObj.itemid);
                return surfaceObj
            },




            /*
            *
            *   DELETE A DATASET FROM THE SURFACE MAP
            *
            */
            deleteSurfaceDataset : function (surfaceObj, itemID)                                              
            {   
                var seriesNum="NA";
                for (var a = 0; a < surfaceObj['content']['Surface']['Chart_dataobj'].length; a++)
                {   
                    if ( surfaceObj['content']['Surface']['Chart_dataobj'][a]['Format_id']==itemID )
                    {   
                        seriesNum=surfaceObj['content']['Surface']['Chart_dataobj'][a]['series'];
                        surfaceObj['content']['Surface']['Chart_dataobj'].splice(a, 1);
                    }
                }
                
                for (var a = 0; a < surfaceObj['content']['Surface']['Chart_dataobj'].length; a++)
                {   
                    if (( surfaceObj['content']['Surface']['Chart_dataobj'][a]['series'] >= seriesNum ) && ( seriesNum!="NA" ))
                    {   
                        surfaceObj['content']['Surface']['Chart_dataobj'][a]['series'] = surfaceObj['content']['Surface']['Chart_dataobj'][a]['series']-1;  
                    }   
                }

                return surfaceObj
            },




            /*
            *
            *
            *   SECTION 2 - CALCULATION OF SURFACE MAP DATA
            *
            *
            */

            

            /*
            *
            *
            *   RESET THE SURFACE VERTICES
            *
            */
            setSurfaceVertices : function (dataID, surfaceObj)     
            {   
                console.log('Setting vertices for '+dataID);
                var dataIndex=0;
                surfaceObj['content']['Surface']['Chart_dataobj'].forEach(function(thisItem, thisIndex){   if (thisItem['Format_id']==dataID){ dataIndex=thisIndex; } });
                var key='', xkey='', ykey='', key1='', key2='', xVal=0, yVal=0, zVal=0,index=0, keyMap={}, xoff=0, yoff=0, zoff=0;  
                var xMax=-99999999, xMin=9999999, yMax=-99999999, yMin=9999999, zMax=-99999999, zMin=9999999;   
                var surfaceGeometry=new THREE.Geometry();   
                xoff=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xOffset;  
                yoff=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].yOffset;  
                zoff=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zOffset;  
                
                if ((parseInt(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xLength)==1)||(parseInt(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].yLength)==1))   
                {   
                    surfaceObj.content.Surface.Errors.push('Surfaces and Points Clouds must have multiple rows and columns. The data sent had '+surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xLength+' row and '+surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].yLength+' column'); 
                }                    
                
                for (var a=0; a<parseInt(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xLength); a++)    
                {   
                    xkey='0-'+a;            
                    for (var b=0; b<parseInt(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].yLength); b++)
                    {   
                        ykey='0-'+b;        
                        key=a+'-'+b;        
                        keyMap[key]=index;  
                        if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xData[xkey]===undefined)
                        {
                            xVal=a+xoff; 
                        }else
                        {
                            xVal=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xData[xkey]+xoff;
                        }
                        
                        if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].yData[ykey]===undefined)
                        {   
                            yVal=b+yoff; 
                        }else
                        {   
                            yVal=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].yData[ykey]+yoff;
                        }
                        
                        if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['flat']==1)        
                        {   
                            zVal=zoff;  
                        }else 
                        {   
                            zVal=parseFloat(Big(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zData[key]).plus(zoff));    
                        }
                        surfaceGeometry.vertices.push( new THREE.Vector3( xVal, yVal, zVal ) ); 
                        if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zData[key]>zMax) { zMax=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zData[key]; }
                        if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zData[key]<zMin) { zMin=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zData[key]; }
                        index++;            
                    }
                }                       
                for (var a=0; a<parseInt(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xLength)-1; a++)
                {   
                    for (var b=0; b<parseInt(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].yLength)-1; b++)  
                    {   
                        key=a+'-'+b;        var num1=a+1;   var num2=b+1;               
                        surfaceGeometry.faces.push( new THREE.Face3( keyMap[key], keyMap[a+'-'+num2], keyMap[num1+'-'+b] ) );
                        surfaceGeometry.faces.push( new THREE.Face3( keyMap[a+'-'+num2], keyMap[num1+'-'+num2], keyMap[num1+'-'+b] ) );
                    }   
                }                       
                surfaceGeometry.computeBoundingBox();       
                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['surfaceGeometry']=surfaceGeometry;        
                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xMin=parseFloat(Big(surfaceGeometry.boundingBox.min.x).minus(Big(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['xOffset'])));
                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xMax=parseFloat(Big(surfaceGeometry.boundingBox.max.x).minus(Big(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['xOffset'])));
                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].yMin=parseFloat(Big(surfaceGeometry.boundingBox.min.y).minus(Big(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['yOffset'])));
                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].yMax=parseFloat(Big(surfaceGeometry.boundingBox.max.y).minus(Big(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['yOffset'])));
                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zMin=zMin;                 
                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zMax=zMax;                 
                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['surfaceGeometry']['colorsNeedUpdate']=true;   
                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['surfaceGeometry']['elementsNeedUpdate']=true; 
                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['surfaceGeometry']['groupsNeedUpdate']=true;   
                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['surfaceGeometry']['verticesNeedUpdate']=true; 

                console.log('The geometry for index '+dataIndex+' was set');

                console.log('Ending set vertices');
                return surfaceObj  
            },
        
        


            /*
            *
            *   SET THE SURFACE EXTREMES
            *
            */
            setPlotExtremes : function (surfaceObj)            
            {   
                console.log('Setting Extremes');
                surfaceObj['content']['Surface']['Props']['xMax']=-999999999;       surfaceObj['content']['Surface']['Props']['xMin']=999999999;
                surfaceObj['content']['Surface']['Props']['yMax']=-999999999;       surfaceObj['content']['Surface']['Props']['yMin']=999999999;
                surfaceObj['content']['Surface']['Props']['zMax']=-999999999;       surfaceObj['content']['Surface']['Props']['zMin']=999999999;
                
                for (var dataIndex in surfaceObj['content']['Surface']['Chart_dataobj'])                    
                {   
                    if ((surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['type']=="line")||
                        (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['type']=="surface")||
                        (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['type']=="pointCloud"))
                    {   
                        if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xMin<surfaceObj['content']['Surface']['Props']['xMin'])
                        { 
                            surfaceObj['content']['Surface']['Props']['xMin']=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xMin;
                        } 
                        
                        if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xMax>surfaceObj['content']['Surface']['Props']['xMax'])
                        {   
                            surfaceObj['content']['Surface']['Props']['xMax']=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xMax;
                        } 
                        
                        if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].yMin<surfaceObj['content']['Surface']['Props']['yMin'])
                        {   
                            surfaceObj['content']['Surface']['Props']['yMin']=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].yMin;
                        } 
                        
                        if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].yMax>surfaceObj['content']['Surface']['Props']['yMax'])
                        {   
                            surfaceObj['content']['Surface']['Props']['yMax']=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].yMax;
                        }
                        
                        if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['useColorData']==1)
                        {   
                            if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].cMin<surfaceObj['content']['Surface']['Props']['zMin'])
                            {   
                                surfaceObj['content']['Surface']['Props']['zMin']=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].cMin;
                            }
                            if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].cMax>surfaceObj['content']['Surface']['Props']['zMax'])
                            {   
                                surfaceObj['content']['Surface']['Props']['zMax']=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].cMax;
                            }
                        }else               
                        {   
                            if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zMin<surfaceObj['content']['Surface']['Props']['zMin'])
                            {   
                                console.log('Setting the zMin to '+surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zMin); 
                                surfaceObj['content']['Surface']['Props']['zMin']=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zMin;
                            }
                            
                            if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zMax>surfaceObj['content']['Surface']['Props']['zMax'])
                            {   
                                console.log('Setting the zMax to '+surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zMax); 
                                surfaceObj['content']['Surface']['Props']['zMax']=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zMax;
                            }
                        }                   
                    }
                }           
                
                console.log('Ending plot extremes');
                return surfaceObj                   
            },



            /*
            *
            *   SET THE SURFACE COLORS
            *
            */
            setSurfaceColors : function (dataID, surfaceObj)          
            {   
                console.log('Setting Colors');
                var color, point, face, numberOfSides, vertexIndex, temp, colorData={}, dataPoint=0, dataIndex=0;  
                
                surfaceObj['content']['Surface']['Chart_dataobj'].forEach(function(thisItem, thisIndex)
                {   
                    if (thisItem['Format_id']==dataID){ dataIndex=thisIndex; } 
                });

                surfaceObj.content.Surface.Scene.lut = new THREE.Lut( surfaceObj.content.Surface.Props.Legend.colorMap, surfaceObj.content.Surface.Props.Legend.numberOfColors );   
                surfaceObj.content.Surface.Scene.lut.setMax( surfaceObj.content.Surface.Props.zMax );     
                surfaceObj.content.Surface.Scene.lut.setMin( surfaceObj.content.Surface.Props.zMin ); 
                
                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lut=new THREE.Lut( surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['colorMap'], parseInt(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['numberOfColors']) );
                
                if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['useColorData']==1)        
                {   
                    surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lut.setMax( surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].cMax );       
                    surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lut.setMin( surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].cMin );       
                    colorData=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].cData;       
                }else                       
                {   
                    surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lut.setMax( surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zMax );       
                    surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lut.setMin( surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zMin );       
                    colorData=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zData;       
                }                           
                if (surfaceObj.content.Surface.Props.divideColormap=='0')
                {   
                    for ( var i = 0; i < surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].surfaceGeometry.vertices.length; i++ )    
                    {   
                        var x=Math.floor(i/surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xLength);   
                        var y=i%surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].yLength;   
                        var key=x+'-'+y;    
                        if (colorData[key]===undefined) { dataPoint=0; }else{ dataPoint=colorData[key]; }
                        temp = surfaceObj.content.Surface.Scene.lut.getColor( dataPoint);               
                        color = new THREE.Color( temp.r, temp.g, temp.b );          
                        color.setRGB(temp.r, temp.g, temp.b);
                        surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].surfaceGeometry.colors[i]=color;
                    }                       
                }else                       
                {   
                    for ( var i = 0; i < surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].surfaceGeometry.vertices.length; i++ )    
                    {   
                        var x=Math.floor(i/surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xLength);   
                        var y=i%surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].yLength;   
                        var key=x+'-'+y;    
                        if (colorData[key]===undefined) { dataPoint=0; }else{ dataPoint=colorData[key]; }
                        temp = surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lut.getColor( dataPoint);
                        color = new THREE.Color( temp.r, temp.g, temp.b );          
                        color.setRGB(temp.r, temp.g, temp.b);
                        surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].surfaceGeometry.colors[i]=color;
                    }                       
                }                           
                var faceIndices = [ 'a', 'b', 'c', 'd' ];   
                for ( var i = 0; i < surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].surfaceGeometry.faces.length; i++ )           
                {   
                    face = surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].surfaceGeometry.faces[ i ]; 
                    numberOfSides = ( face instanceof THREE.Face3 ) ? 3 : 4;        
                    surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].surfaceGeometry.faceVertexUvs[i]=new Array(); 
                    for( var j = 0; j < numberOfSides; j++ ) 
                    {   
                        vertexIndex = face[ faceIndices[ j ] ];
                        surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].surfaceGeometry.faces[ i ]['vertexColors'][ j ]=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].surfaceGeometry.colors[vertexIndex];      
                    }                       
                }                           
                if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['showLines']==1) 
                {   
                    surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].surfaceGeometry = this.assignUVs(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].surfaceGeometry); 
                }
                
                console.log('Attempting to set the colors for index '+dataIndex);
                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['surfaceGeometry']['colorsNeedUpdate']=true;   
                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['surfaceGeometry']['elementsNeedUpdate']=true; 
                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['surfaceGeometry']['groupsNeedUpdate']=true;   
                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['surfaceGeometry']['verticesNeedUpdate']=true; 
                
                console.log('Ending colors');
                return surfaceObj                   
            },
        


            

            /*
            *
            *   ASSIGN THE UVS FOR A GEOMETRY
            *
            */
            assignUVs : function( geometry )
            {   
                console.log('In the assign UVs code');
                geometry.computeBoundingBox();
                var max     = geometry.boundingBox.max;     
                var min     = geometry.boundingBox.min;     
                var offset  = new THREE.Vector2(0 - min.x, 0 - min.y);              
                var range   = new THREE.Vector2(max.x - min.x, max.y - min.y);      
                var faces = geometry.faces; 
                geometry.faceVertexUvs[0] = [];
                for (var i = 0; i < geometry.faces.length ; i++) 
                {   var v1 = geometry.vertices[faces[i].a]; 
                    var v2 = geometry.vertices[faces[i].b]; 
                    var v3 = geometry.vertices[faces[i].c]; 
                  geometry.faceVertexUvs[0].push([          
                    new THREE.Vector2( ( v1.x + offset.x ) / range.x , ( v1.y + offset.y ) / range.y ), 
                    new THREE.Vector2( ( v2.x + offset.x ) / range.x , ( v2.y + offset.y ) / range.y ), 
                    new THREE.Vector2( ( v3.x + offset.x ) / range.x , ( v3.y + offset.y ) / range.y )  
                  ]);                       
                }                           
                geometry.uvsNeedUpdate = true;
                console.log('Finished the assign UVs code');
                return geometry
            },

            





            /*
            *
            *   CREATE THE MESH FOR THE SURFACE, POINT CLOUD, ETC
            *
            */
            setMeshes : function( dataID, wireTexture, surfaceObj )                  
            {   
                console.log('Set Meshes');
                var graphMesh={}, dataIndex=0, wireMaterial={};           
                surfaceObj['content']['Surface']['Chart_dataobj'].forEach(function(thisItem, thisIndex)
                {   
                    if (thisItem['Format_id']==dataID){ dataIndex=thisIndex; } 
                });
                if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['type']=="surface")        
                {   
                    if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['sWireFrame']=="Solid")
                    {   
                        if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['showLines']==1)
                        {   
                            wireTexture.wrapS = wireTexture.wrapT = THREE.RepeatWrapping;       
                            wireTexture.repeat.set( parseInt(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xLength), parseInt(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].yLength) );
                            wireMaterial = new THREE.MeshBasicMaterial( { map: wireTexture, vertexColors: THREE.VertexColors, side:THREE.DoubleSide } );
                        }else 
                        {
                            wireMaterial = new THREE.MeshBasicMaterial( {vertexColors: THREE.VertexColors, side:THREE.DoubleSide} );    
                        }
                    
                    }else
                    {  
                        wireMaterial = new THREE.MeshBasicMaterial( {wireframe:true, vertexColors: THREE.VertexColors, side:THREE.DoubleSide } );   
                    }
                    graphMesh = new THREE.Mesh( surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].surfaceGeometry, wireMaterial );   
                    graphMesh.doubleSided = true;           
//                    graphMesh.id = dataID;  
                    graphMesh.name = dataID;
                    surfaceObj.content.Surface.Scene.add(graphMesh);  
                
                }else if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['type']=="pointCloud")   
                {   
                    wireMaterial = new THREE.MeshBasicMaterial( {vertexColors: THREE.VertexColors, side:THREE.DoubleSide } );
                    graphMesh = new THREE.PointCloud( surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].surfaceGeometry, wireMaterial );
//                    graphMesh.id = dataID;  
                    graphMesh.name = dataID;
                    surfaceObj.content.Surface.Scene.add(graphMesh);  
                }             

                return surfaceObj                   
            },
            

            

            /*
            *
            *   CREATE THE GRID LINES
            *
            */
            makeGrids : function(dataID, surfaceObj)               
            {   
                console.log('Make Grids');
                var dataIndex=0;
                surfaceObj = surfaceObj.removeItem( dataID, surfaceObj );
                surfaceObj['content']['Surface']['Chart_dataobj'].forEach(function(thisItem, thisIndex)
                {   
                    if (thisItem['Format_id']==dataID)
                    { 
                        dataIndex=thisIndex; 
                    } 
                });
                var material='', geometry='', thiscolor='', i='', start1=0, stop1=10, step1=1, start2=0, stop2=10, step2=1, num=0;
                var elementsInTheScene = surfaceObj.content.Surface.Scene.children.length;        
                for ( var i = elementsInTheScene-1; i > 0; i-- )                    
                {   
                    if ( surfaceObj.content.Surface.Scene.children[ i ]['name'].match(/^Grid/)) 
                    {   
                        surfaceObj.content.Surface.Scene.remove ( surfaceObj.content.Surface.Scene.children [ i ] ); 
                    } 
                }    
                var thiscolor='0x'+surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['color'];
                var material = new THREE.LineBasicMaterial({    color: thiscolor    });
                var geometry = new THREE.Geometry();        
                if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['gridType']=="XY")     
                {   
                    start1=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['xStart'];      
                    stop1=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['xStop'];            
                    step1=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['xSpacing'];     
                    start2=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['yStart'];      
                    stop2=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['yStop'];            
                    step2=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['ySpacing'];     
                    num=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['zOffset'];            
                    for (a=start1; a<=stop1; a=a+parseFloat(step1))                 
                    {   
                        geometry.vertices.push(new THREE.Vector3(a, start2, num));  
                        geometry.vertices.push(new THREE.Vector3(a, stop2, num));   
                        geometry.vertices.push(new THREE.Vector3(a, start2, num));  
                    }                       
                    geometry.vertices.push(new THREE.Vector3(start1, start2, num)); 
                    for (a=start2; a<=stop2; a=a+parseFloat(step2))                 
                    {   
                        geometry.vertices.push(new THREE.Vector3(start1, a, num));  
                        geometry.vertices.push(new THREE.Vector3(stop1, a, num));   
                        geometry.vertices.push(new THREE.Vector3(start1, a, num));  
                    }                       
                }                           
                if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['gridType']=="YZ")     
                {   
                    start1=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['yStart'];      
                    stop1=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['yStop'];            
                    step1=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['ySpacing'];     
                    start2=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['zStart'];      
                    stop2=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['zStop'];            
                    step2=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['zSpacing'];     
                    num=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['xOffset'];            
                    for (a=start1; a<=stop1; a=a+parseFloat(step1))                 
                    {   
                        geometry.vertices.push(new THREE.Vector3(num, a, start2));  
                        geometry.vertices.push(new THREE.Vector3(num, a, stop2));   
                        geometry.vertices.push(new THREE.Vector3(num, a, start2));  
                    }                       
                    geometry.vertices.push(new THREE.Vector3(num, start1, start2)); 
                    for (a=start2; a<=stop2; a=a+parseFloat(step2))                 
                    {   
                        geometry.vertices.push(new THREE.Vector3(num, start1, a));  
                        geometry.vertices.push(new THREE.Vector3(num, stop1, a));   
                        geometry.vertices.push(new THREE.Vector3(num, start1, a));  
                    }                       
                }                           
                if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['gridType']=="XZ")     
                {   
                    start1=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['xStart'];      
                    stop1=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['xStop'];            
                    step1=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['xSpacing'];     
                    start2=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['zStart'];      
                    stop2=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['zStop'];            
                    step2=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['zSpacing'];     
                    num=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['yOffset'];            
                    for (a=start1; a<=stop1; a=a+parseFloat(step1))                 
                    {   
                        geometry.vertices.push(new THREE.Vector3(a, num, start2));  
                        geometry.vertices.push(new THREE.Vector3(a, num, stop2));   
                        geometry.vertices.push(new THREE.Vector3(a, num, start2));  
                    }                       
                    geometry.vertices.push(new THREE.Vector3(start1, num, start2)); 
                    for (a=start2; a<=stop2; a=a+parseFloat(step2))                 
                    {   
                        geometry.vertices.push(new THREE.Vector3(start1, num, a));  
                        geometry.vertices.push(new THREE.Vector3(stop1, num, a));   
                        geometry.vertices.push(new THREE.Vector3(start1, num, a));  
                    }                       
                }                           
                var line = new THREE.Line(geometry, material);
                line.position.set(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xPosition, surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].yPosition, surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zPosition);  
                line.rotation.set(0.0174532925*surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xRotation, 0.0174532925*surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].yRotation, 0.0174532925*surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zRotation);   
                line.name = "Grid"+dataID;  
                line.id = "Grid"+dataID;    
                surfaceObj.content.Surface.Scene.add(line);                               
                return surfaceObj                   
            },                        

            


            /*
            *
            *   CREATE THE AXES
            *
            */
            makeAxes : function(dataID, surfaceObj)
            {   
                console.log('Making Axes');
                var dataIndex=0;
                surfaceObj['content']['Surface']['Chart_dataobj'].forEach(function(thisItem, thisIndex)
                {   
                    if (thisItem['Format_id']==dataID)
                    {
                        dataIndex=thisIndex; 
                    } 
                });
                var start=0, stop=0, interval=0, xOffset=0, yOffset=0, zOffset=0, tickLength=0; 
                var xOff=0, yOff=0, thisColor='#'+surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['axiscolor'];    
                surfaceObj = surfaceObj.removeItem( dataID, surfaceObj );            
                var material = new THREE.LineBasicMaterial({    color: thisColor        });     
                var geometry = new THREE.Geometry();        
                start=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['axisStart'];            
                stop=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['axisStop'];          
                interval=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['axisInterval'];  
                xOffset=parseFloat(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['xPosition']);      
                yOffset=parseFloat(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['yPosition']);      
                zOffset=parseFloat(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['zPosition']);      
                tickLength=parseFloat(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['tickLength']);  
                var xTextOffset=parseFloat(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['xTextOffset']);
                var yTextOffset=parseFloat(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['yTextOffset']);
                var zTextOffset=parseFloat(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['zTextOffset']);
                if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['axisType']=="X")      
                {   
                    for (var xLoc=start; xLoc<=stop; xLoc=parseFloat(xLoc)+parseFloat(interval))            
                    {   
                        geometry.vertices.push(new THREE.Vector3(xLoc+xOffset, yOffset, zOffset));
                        geometry.vertices.push(new THREE.Vector3(xLoc+xOffset, yOffset+tickLength, zOffset));               
                        geometry.vertices.push(new THREE.Vector3(xLoc+xOffset, yOffset, zOffset));
                        spritey = $scope.makeTextSprite( " " +xLoc+ " ", { fontsize: surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['axisFontSize'] });
                        spritey.position.x = xLoc+xOffset+xTextOffset;              
                        spritey.position.y = yOffset+yTextOffset;                   
                        spritey.position.z = zOffset-3+zTextOffset;                 
                        spritey.name = dataID;
                        surfaceObj.content.Surface.Scene.add( spritey );          
                    }                       
                }                           
                if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['axisType']=="Y")      
                {   
                    for (var xLoc=start; xLoc<=stop; xLoc=parseFloat(xLoc)+parseFloat(interval))            
                    {   
                        geometry.vertices.push(new THREE.Vector3(xOffset, xLoc+yOffset, zOffset));
                        geometry.vertices.push(new THREE.Vector3(xOffset+tickLength, xLoc+yOffset, zOffset));               
                        geometry.vertices.push(new THREE.Vector3(xOffset, xLoc+yOffset, zOffset));
                        spritey = $scope.makeTextSprite( " " +xLoc+ " ", { fontsize: surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['axisFontSize']});
                        spritey.position.x = xOffset+xTextOffset;                   
                        spritey.position.y = xLoc+yOffset+yTextOffset;              
                        spritey.position.z = zOffset-3+zTextOffset;                 
                        spritey.name = dataID;
                        surfaceObj.content.Surface.Scene.add( spritey );          
                    }                       
                }                           
                if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['axisType']=="Z")      
                {   
                    for (var xLoc=start; xLoc<=stop; xLoc=parseFloat(xLoc)+parseFloat(interval))            
                    {   
                        geometry.vertices.push(new THREE.Vector3(xOffset, yOffset, xLoc+zOffset));
                        geometry.vertices.push(new THREE.Vector3(xOffset, yOffset+tickLength, xLoc+zOffset));               
                        geometry.vertices.push(new THREE.Vector3(xOffset, yOffset, xLoc+zOffset));
                        geometry.vertices.push(new THREE.Vector3(xOffset+tickLength, yOffset, xLoc+zOffset));               
                        geometry.vertices.push(new THREE.Vector3(xOffset, yOffset, xLoc+zOffset));
                        spritey = $scope.makeTextSprite( " " +xLoc+ " ",{ fontsize: surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['axisFontSize']}); 
                        spritey.position.x = xOffset+xTextOffset;                   
                        spritey.position.y = yOffset+yTextOffset;                   
                        spritey.position.z = xLoc+zOffset-3+zTextOffset;            
                        spritey.name = dataID;
                        surfaceObj.content.Surface.Scene.add( spritey );          
                    }                       
                }                           
                var line = new THREE.Line(geometry, material);
                line.name = dataID;         
                line.id = dataID;           
                surfaceObj.content.Surface.Scene.add(line);       
                
                return surfaceObj                
            },

            /*
            *
            *   MAKE A TEXT SPRITE
            *
            */
            makeTextSprite : function( message, parameters ) 
            {   
                console.log('Making a text sprites');                         
                if ( parameters === undefined ) parameters = {};                    
                var fontface = parameters.hasOwnProperty("fontface") ? parameters["fontface"] : "Arial";
                var fontsize = parameters.hasOwnProperty("fontsize") ? parameters["fontsize"] : 18;
                var borderThickness = parameters.hasOwnProperty("borderThickness") ? parameters["borderThickness"] : 0;     
                var borderColor = parameters.hasOwnProperty("borderColor") ? parameters["borderColor"] : { r:255, g:255, b:255, a:1.0 };
                var backgroundColor = parameters.hasOwnProperty("backgroundColor") ?parameters["backgroundColor"] : { r:255, g:255, b:255, a:1.0 };
                var textColor = parameters.hasOwnProperty("textColor") ? parameters["textColor"] : { r:0, g:0, b:0, a:1.0 }; 
                var canvas = document.createElement('canvas');
                var context = canvas.getContext('2d');      
                context.font = "Bold " + fontsize + "px " + fontface;               
                var metrics = context.measureText( message );
                var textWidth = metrics.width;
                context.fillStyle   = "rgba(" + backgroundColor.r + "," + backgroundColor.g + "," + backgroundColor.b + "," + backgroundColor.a + ")";
                context.strokeStyle = "rgba(" + borderColor.r + "," + borderColor.g + "," + borderColor.b + "," + borderColor.a + ")";
                context.fillStyle = "rgba("+textColor.r+", "+textColor.g+", "+textColor.b+", 1.0)";
                context.fillText( message, borderThickness, fontsize + borderThickness);        
                var texture = new THREE.Texture(canvas)     
                texture.needsUpdate = true; 
                var spriteMaterial = new THREE.SpriteMaterial( { map: texture, useScreenCoordinates: false } );             
                var sprite = new THREE.Sprite( spriteMaterial );                    
                sprite.scale.set(0.5 * fontsize, 0.25 * fontsize, 0.75 * fontsize); 
                return sprite;              
            },
        
 



            /*
            *
            *
            *   SECTION 3 - INTERACTION WITH THE SURFACE MAP
            *
            *
            */


            
            /*
            *
            *   INITIALIZE A MAP ON RELOAD / CREATE A SURFACE MAP FROM MENU
            *
            */
            initializeSurface : function( surfaceObj, reset )  
            {   
                console.log('Initializing the surface for '+surfaceObj['itemid']);
                if (reset==1)               
                {   
                    // This is not correct and needs to be rewritten
                    surfaceObj.content.Surface=new $scope.surface(plotID);
                    for (var dataIndex in surfaceObj['content']['Surface']['Chart_dataobj'])             
                    {   
                        var dataObj=new this.surfaceDataPro(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['Format_id'], surfaceObj['itemid'], surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]);              
                        surfaceObj.content.Surface.Chart_dataobj[dataIndex]=dataObj;
                    }                       
                }
                surfaceObj.content.Surface.Scene=new THREE.Scene();
                surfaceObj.content.Surface.Camera = new THREE.PerspectiveCamera( surfaceObj.content.Surface.Props.view_angle, surfaceObj.content.Surface.Props.aspect, surfaceObj.content.Surface.Props.near, surfaceObj.content.Surface.Props.far);  
                surfaceObj.content.Surface.Camera.up = new THREE.Vector3( 0, 0, 1 );
                surfaceObj.content.Surface.Camera.name = 'camera';
//                surfaceObj.content.Surface.Keyboard = new THREEx.KeyboardState(); 
                surfaceObj.content.Surface.Clock = new THREE.Clock();
                surfaceObj.content.Surface.Scene.add(surfaceObj.content.Surface.Camera);
 
                if ( Detector.webgl ) 
                {   
                    surfaceObj.content.Surface.Renderer = new THREE.WebGLRenderer( {antialias:true} ); 
                    console.log('The renderer is webgl');
                }else 
                {   
                    surfaceObj.content.Surface.Renderer = new THREE.CanvasRenderer(); 
                    console.log('The renderer is canvas');
                }

                surfaceObj.content.Surface.Renderer.setSize(surfaceObj.content.Surface.Props.screen_width, surfaceObj.content.Surface.Props.screen_height);
                surfaceObj.content.Surface.Renderer.setClearColor( 0xffffff, 1);  
                
                surfaceObj.content.Surface.Controls = new THREE.TrackballControls( surfaceObj.content.Surface.Camera, surfaceObj.content.Surface.Renderer.domElement );   
                return surfaceObj
            },


            
            /*
            *
            *   REMOVE A DATASET FROM THE SCENE
            *
            */
            removeItem : function (dataID, surfaceObj)               
            {   
                console.log('Removing '+dataID);
                var elementsInTheScene = surfaceObj['content']['Surface']['Scene']['children'].length;        
                for ( var i = elementsInTheScene-1; i > 0; i-- )                    
                {   
                    if ( surfaceObj['content']['Surface']['Scene']['children'][ i ]['name'] == dataID) 
                    { 
                        surfaceObj['content']['Surface']['Scene'].remove ( surfaceObj.content.Surface.Scene.children [ i ] ); 
                    } 
                } 
                
                return surfaceObj
            },

            



            /*
            *
            *   SET THE LEGEND
            *
            */
            setLegend : function( surfaceObj )
            {   
                console.log('Set Legend for '+surfaceObj.Format_plotid);
                if (surfaceObj.content.Surface.Props.Legend.onOff=='1') 
                {   

                    var plotID = surfaceObj.content.Surface.Format_plotid;
                    var legendID = surfaceObj.content.Surface.Format_plotid+"Legend"; 
                    var myEl='', Legend={}, legend='', container='';
                    console.log('The legend id is '+legendID);       
                    if (surfaceObj.content.Surface.Props.divideColormap=='0')
                    {   
                        myEl = angular.element( document.querySelector( '#'+legendID ) );
                        myEl.empty();
                        Legend.Scene=new THREE.Scene();
                        Legend.Camera = new THREE.PerspectiveCamera( 45, 8, 0.001, 10000);  
                        Legend.Camera.position.x=0; Legend.Camera.position.y=0;     Legend.Camera.position.z=2; 
                        Legend.Camera.up = new THREE.Vector3( 0, 0, 1 );                    
                        Legend.Camera.name = 'legendcamera';        
                        Legend.Clock = new THREE.Clock();           
                        Legend.Scene.add(Legend.Camera);            
                        if ( Detector.webgl ) 
                        {   
                            Legend.Renderer = new THREE.WebGLRenderer( {antialias:true} ); 
                        } else 
                        {   
                            Legend.Renderer = new THREE.CanvasRenderer(); 
                        }
                        Legend.Renderer.setSize(800, 50);           
                        Legend.Renderer.setClearColor( 0xFFFFFF, 1 );
                        container = document.getElementById(legendID);              
                        container.appendChild( Legend.Renderer.domElement );                
                        Legend.Controls = new THREE.TrackballControls( Legend.Camera, Legend.Renderer.domElement );
                        surfaceObj.content.Surface.Scene.lut = new THREE.Lut( surfaceObj.content.Surface.Props.Legend.colorMap, surfaceObj.content.Surface.Props.Legend.numberOfColors );
                        surfaceObj.content.Surface.Scene.lut.setMax( surfaceObj.content.Surface.Props.zMax );         
                        surfaceObj.content.Surface.Scene.lut.setMin( surfaceObj.content.Surface.Props.zMin );         
                        legend = surfaceObj.content.Surface.Scene.lut.setLegendOn( { 'layout':'horizontal', 'position': { 'x': 0, 'y': 0, 'z': 0 } , 'dimensions': {'width':0.3, 'height':14} } );
                        Legend.Scene.add ( legend );            
                        surfaceObj.Legend = Legend;
                        surfaceObj = this.setTickNumbers( surfaceObj );
                        
/*
                        for ( var i = 0; i < Object.keys( labels[ 'ticks' ] ).length; i++ )         
                        {    Legend.Scene.add ( labels[ 'lines' ][ i ] );}              
                        myEl = angular.element( document.querySelector( '#'+plotID+'LegendTicks' ) );
                        myEl.empty();
                        var width=parseInt(800/surfaceObj.content.Surface.Props.Legend.numTicks, 10);
                        for ( var i = 0; i < surfaceObj.content.Surface.Props.Legend.numTicks; i++ ) 
                        {   var number=surfaceObj.content.Surface.Props.zMin+i*(surfaceObj.content.Surface.Props.zMax-surfaceObj.content.Surface.Props.zMin)/(surfaceObj.content.Surface.Props.Legend.numTicks-1); 
                            var myEl = angular.element( document.querySelector( '#'+plotID+'LegendTicks' ) );
                            myEl.append('<div class="Legend_Tick">'+Math.round(10000*number)/10000+'</div>');
                        }                       
                        document.getElementById(plotID+'LegendTicks').find('.Legend_Tick').css('width',width);            
                        var elem = angular.element( document.querySelector( '#'+plotID+'LegendTicks' ) );
                        angular.element(elem[0].querySelector('.Legend_Tick'));
*/                        

                        surfaceObj.Legend.Renderer.setClearColor( 0xFFFFFF, 1 );
                        surfaceObj.Legend.Renderer.render( Legend.Scene, Legend.Camera ); Legend.Controls.update();
                    }else                           
                    {   for (var dataIndex in surfaceObj['content']['Surface']['Chart_dataobj'])                
                        {   
                            surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend={};                 
                            surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Scene=new THREE.Scene();
                            surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Camera = new THREE.PerspectiveCamera( 45, 8, 0.001, 10000); 
                            surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Camera.position.x=0;    surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Camera.position.y=0;        surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Camera.position.z=2;    
                            surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Camera.up = new THREE.Vector3( 0, 0, 1 );                   
                            surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Camera.name = surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['Format_id']+'legendcamera';     
                            surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Clock = new THREE.Clock();          
                            surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Scene.add(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Camera);          
                            if ( Detector.webgl ) 
                            {   
                                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Renderer = new THREE.WebGLRenderer( {antialias:true} ); 
                            } else 
                            {
                                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Renderer = new THREE.CanvasRenderer(); 
                            }
                            surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Renderer.setSize(800, 50);          
                            surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Renderer.setClearColor( 0xFFFFFF, 1 );
                            legendID=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['Format_id'];
                            document.getElementById(legendID+'Legend').html();                   
                            container = document.getElementById(legendID+'Legend');             
                            console.log('Trying to append the legend to '+legendID+'Legend');
                            container.appendChild( surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Renderer.domElement );               
                            surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Controls = new THREE.TrackballControls( surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Camera, surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Renderer.domElement );
                            var cm=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].colorMap;   
                            surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lut = new THREE.Lut( cm, surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].numberOfColors );
                            surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lut.setMax( surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zMax );   
                            surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lut.setMin( surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zMin );   
                            legend = surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lut.setLegendOn( { 'layout':'horizontal', 'position': { 'x': 0, 'y': 0, 'z': 0 } , 'dimensions': {'width':0.3, 'height':14} } );
                            surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Scene.add ( legend );           
                            var labels = surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lut.setLegendLabels( { 'ticks': surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].legendNumTicks } );  
                            surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Scene.add ( labels['title'] );  
                            surfaceObj.Legend = Legend;
                            surfaceObj = this.setTickNumbers( surfaceObj );
                            

/*
                            for ( var i = 0; i < Object.keys( labels[ 'ticks' ] ).length; i++ ) {    Legend.Scene.add ( labels[ 'lines' ][ i ] );}              
                            document.getElementById(legendID+'LegendTicks').html();                  
                            var width=parseInt(800/surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['legendNumTicks'], 10);
                            for ( var i = 0; i < surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].legendNumTicks; i++ ) 
                            {   var number=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zMin+i*(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zMax-surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zMin)/(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].legendNumTicks-1); 
                                document.getElementById(legendID+'LegendTicks').append('<div class="Legend_Tick">'+Math.round(10000*number)/10000+'</div>');      }
                            document.getElementById(legendID+'LegendTicks').find('.Legend_Tick').css('width',width);          
*/

                            surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Renderer.setClearColor( 0xFFFFFF, 1 );
                            surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Renderer.render( surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Scene, surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Camera ); surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].Legend.Controls.update();
                        }                           
                    }                               
                }
                
                return surfaceObj                   
            },

            


            /*
            *
            *   CALCULATE THE TICK VALUES
            *
            */
            setTickNumbers : function( surfaceObj )
            {   
                surfaceObj.Legend.tickNumbers = [];
                var labels = surfaceObj.content.Surface.Scene.lut.setLegendLabels( { 'ticks': surfaceObj.content.Surface.Props.Legend.numTicks } );   
                surfaceObj.Legend.Scene.add ( labels['title'] );   

                for ( var i = 0; i < Object.keys( labels[ 'ticks' ] ).length; i++ )         
                {    
                    surfaceObj.Legend.Scene.add ( labels[ 'lines' ][ i ] );
                }              

                surfaceObj.Legend.tickWidth = parseInt(825/surfaceObj.content.Surface.Props.Legend.numTicks, 10);
                
                for ( var i = 0; i < surfaceObj.content.Surface.Props.Legend.numTicks; i++ ) 
                {   
                    var number=surfaceObj.content.Surface.Props.zMin+i*(surfaceObj.content.Surface.Props.zMax-surfaceObj.content.Surface.Props.zMin)/(surfaceObj.content.Surface.Props.Legend.numTicks-1); 
                    surfaceObj.Legend.tickNumbers.push( number );
                    console.log('Setting tick number '+number);
                }                       
                
                return surfaceObj

            },


            /*
            *
            *   SET THE POSITIONS FOR THE CAMERA AND THE SCENE
            *
            */
            setPositions : function( surfaceObj )
            {   
                console.log('In Set Positions in the Surface Factory');
                var PlotID=surfaceObj.Format_id;  

                // if ((surfaceObj.content.Surface.Props.xCamPosFlag==0)||(surfaceObj.content.Surface.Props.xCamPosFlag===undefined))
                // {
                //     surfaceObj.content.Surface.Props.xCamPos=surfaceObj.content.Surface.Props.xMax*2;    
                //     surfaceObj.content.Surface.Camera.position.x=surfaceObj.content.Surface.Props.xCamPos;   
                //     surfaceObj.content.Surface.Props.xCamPosFlag=1;   
                // }
                // if ((surfaceObj.content.Surface.Props.yCamPosFlag==0)||(surfaceObj.content.Surface.Props.yCamPosFlag===undefined))
                // {
                //     surfaceObj.content.Surface.Props.yCamPos=surfaceObj.content.Surface.Props.yMax*2;    
                //     surfaceObj.content.Surface.Camera.position.y=surfaceObj.content.Surface.Props.yCamPos;  
                //     surfaceObj.content.Surface.Props.yCamPosFlag=1;   
                // }
                // if ((surfaceObj.content.Surface.Props.zCamPosFlag==0)||(surfaceObj.content.Surface.Props.zCamPosFlag===undefined))
                // {
                //     surfaceObj.content.Surface.Props.zCamPos=surfaceObj.content.Surface.Props.zMax*2;    
                //     surfaceObj.content.Surface.Camera.position.z=surfaceObj.content.Surface.Props.zCamPos;
                //     surfaceObj.content.Surface.Props.zCamPosFlag=1;   
                // }

                surfaceObj.content.Surface.Scene.up={};   
                surfaceObj.content.Surface.Scene.up.x=0;  
                surfaceObj.content.Surface.Scene.up.y=0;  
                surfaceObj.content.Surface.Scene.up.z=1;  
                surfaceObj.content.Surface.Camera.position.set( parseFloat(surfaceObj.content.Surface.Props.xCamPos), parseFloat(surfaceObj.content.Surface.Props.yCamPos), parseFloat(surfaceObj.content.Surface.Props.zCamPos) ); 
                surfaceObj.content.Surface.Controls.target.set( parseFloat(surfaceObj.content.Surface.Props.xPos), parseFloat(surfaceObj.content.Surface.Props.yPos), parseFloat(surfaceObj.content.Surface.Props.zPos) );
                // surfaceObj.content.Surface.Camera.rotation.x=JSON.parse(JSON.stringify(surfaceObj.content.Surface.Props.xRot));         
                // surfaceObj.content.Surface.Camera.rotation.y=JSON.parse(JSON.stringify(surfaceObj.content.Surface.Props.yRot));         
                // surfaceObj.content.Surface.Camera.rotation.z=JSON.parse(JSON.stringify(surfaceObj.content.Surface.Props.zRot));         
                // surfaceObj.content.Surface.Camera.rotation.set(surfaceObj.content.Surface.Props.xRot, surfaceObj.content.Surface.Props.yRot, surfaceObj.content.Surface.Props.zRot);
                var vec=new THREE.Vector3(surfaceObj.content.Surface.Scene.position.x, surfaceObj.content.Surface.Scene.position.y, surfaceObj.content.Surface.Scene.position.z );
                surfaceObj.content.Surface.Camera.lookAt( vec );      
                surfaceObj.content.Surface.Camera.up = new THREE.Vector3( 0, 0, 1 );          

                console.log('At the end of setPositions, the camera is located at positions '+surfaceObj.content.Surface.Props.xCamPos+'-'+surfaceObj.content.Surface.Props.yCamPos+'-'+surfaceObj.content.Surface.Props.zCamPos+' with rotations '+surfaceObj.content.Surface.Camera.rotation.x+'-'+surfaceObj.content.Surface.Camera.rotation.y+'-'+surfaceObj.content.Surface.Camera.rotation.z+' and is pointed at '+surfaceObj.content.Surface.Scene.position.x+'-'+surfaceObj.content.Surface.Scene.position.y+'-'+surfaceObj.content.Surface.Scene.position.z);
                            
                return surfaceObj                  
            },


  



            /*
            *
            *   HANDLE THE FUNCTION CALLS WHEN A CAMERA IS CHANGED
            *
            */
            handleCameraChange : function ( surfaceObj )
            {   
                surfaceObj['content']['Surface']['Props']['xPos']=JSON.parse(JSON.stringify(surfaceObj['content']['Surface']['Scene']['position']['x']));
                surfaceObj['content']['Surface']['Props']['yPos']=JSON.parse(JSON.stringify(surfaceObj['content']['Surface']['Scene']['position']['y']));
                surfaceObj['content']['Surface']['Props']['zPos']=JSON.parse(JSON.stringify(surfaceObj['content']['Surface']['Scene']['position']['z']));
                surfaceObj['content']['Surface']['Props']['xCamPos']=JSON.parse(JSON.stringify(surfaceObj['content']['Surface']['Camera']['position']['x']));
                surfaceObj['content']['Surface']['Props']['yCamPos']=JSON.parse(JSON.stringify(surfaceObj['content']['Surface']['Camera']['position']['y']));
                surfaceObj['content']['Surface']['Props']['zCamPos']=JSON.parse(JSON.stringify(surfaceObj['content']['Surface']['Camera']['position']['z']));
                surfaceObj['content']['Surface']['Props']['xRot']=JSON.parse(JSON.stringify(surfaceObj['content']['Surface']['Camera']['rotation']['x']));
                surfaceObj['content']['Surface']['Props']['yRot']=JSON.parse(JSON.stringify(surfaceObj['content']['Surface']['Camera']['rotation']['y']));
                surfaceObj['content']['Surface']['Props']['zRot']=JSON.parse(JSON.stringify(surfaceObj['content']['Surface']['Camera']['rotation']['z']));
                surfaceObj = this.setPositions( surfaceObj );


                console.log('At the end of handle camera, the camera positions to '+surfaceObj['content']['Surface']['Props']['xPos']+', '+surfaceObj['content']['Surface']['Props']['yPos']+', '+surfaceObj['content']['Surface']['Props']['zPos']+', '+surfaceObj['content']['Surface']['Props']['xCamPos']+', '+surfaceObj['content']['Surface']['Props']['yCamPos']+', '+surfaceObj['content']['Surface']['Props']['zCamPos']+', '+surfaceObj['content']['Surface']['Props']['xRot']+', '+surfaceObj['content']['Surface']['Props']['yRot']+', '+surfaceObj['content']['Surface']['Props']['zRot']);
            
                return surfaceObj
            },







            /*
            *
            *   HANDLE THE FUNCTION CALLS WHEN A STANDARD ITEM IS CHANGED - THIS IS NOT A SURFACE, POINT CLOUD, OR LINE
            *
            */
            handleItemChange : function (surfaceObject, datasetObject)
            {   
                console.log('Handling the surface change for '+datasetObject['type']);
                surfaceObj = this.removeItem(datasetObject['Format_id'], surfaceObj);          
                if ((datasetObject['type']=="Cube")||
                    (datasetObject['type']=="Icosahedron")||
                    (datasetObject['type']=="Tetrahedron")||
                    (datasetObject['type']=="Octahedron")||
                    (datasetObject['type']=="Sphere")||
                    (datasetObject['type']=="Cylinder")||
                    (datasetObject['type']=="Torus")||
                    (datasetObject['type']=="Plane")||
                    (datasetObject['type']=="Arrow"))
                {  
                    surfaceObj = this.createShape(datasetObject['type'], datasetObject['Format_id'], surfaceObj);   
                
                }else if(datasetObject['type']=="Grid")
                {  
                    surfaceObj = this.makeGrids(datasetObject['Format_id'], 1, surfaceObj); 
                
                }else if(datasetObject['type']=="Axis")
                {  
                    surfaceObj = this.makeAxes(datasetObject['Format_id'], 1, surfaceObj); 
                }

                return surfaceObj
            },
          
            








            /*
            *
            *
            *   SECTION 4 - LINE OBJECT
            *
            *
            */


 

            /*
            *
            *   SET THE LINE COLORS
            *
            */
            setLineColors : function (dataID, surfaceObj)         
            {   
                console.log('Setting Line '+dataID);
                var xOff=0, yOff=0, zOff=0, color='', point='', face='', xVal=0, yVal=0, zVal=0, temp='';
                var numberOfSides=3, vertexIndex=[], lineData=[], dataIndex=0;
                var segments=0, tubeRadius=0, radiusSegments=0, colorData={}, wireMaterial={}, graphMesh={};
                surfaceObj['content']['Surface']['Chart_dataobj'].forEach(function(thisItem, thisIndex)
                {   
                    if (thisItem['Format_id']==dataID){ dataIndex=thisIndex; } 
                });
                var faceIndices = [ 'a', 'b', 'c', 'd' ];   
                if ((parseInt(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xLength)!=1)
                    &&(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xLength!==undefined))
                {   
                    $('.plot_errorblock').html('Lines must have one row. The data sent had '+surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xLength+' rows and '+surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].yLength+' columns'); 
                }
                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lineData=[];               
                xOff=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].xOffset;              
                yOff=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].yOffset;              
                zOff=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zOffset;              
                
                if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['lineGeometry']!==undefined)
                {   
                    console.log('The length of the points array is '+surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['lineGeometry']['points'].length);
                    for (var a=0; a<surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['lineGeometry']['points'].length; a++)             
                    {   
                        if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['lineGeometry']['points'][a]['x']===undefined)
                        {       
                            xVal=a+parseFloat(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['xOffset']); 
                        }else 
                        { 
                            xVal=parseFloat(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['lineGeometry']['points'][a]['x'])+parseFloat(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['xOffset']); 
                        }
                        if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['lineGeometry']['points'][a]['y']===undefined)
                        {       
                            yVal=a+parseFloat(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['yOffset']); 
                        }else 
                        { 
                            yVal=parseFloat(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['lineGeometry']['points'][a]['y'])+parseFloat(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['yOffset']); 
                        }
                        if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['flat']==1)            
                        {
                            zVal=a+parseFloat(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['zOffset']); 
                        }else 
                        {
                            zVal=parseFloat(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['lineGeometry']['points'][a]['z'])+parseFloat(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['zOffset']);    
                            console.log('The z value is '+zVal);
                        }
                        surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lineData.push(new THREE.Vector3(xVal, yVal, zVal));                
                    }
                
                    if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['type']=="line")       
                    {   
                        segments=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['lineGeometry']['points'].length-1;
                        tubeRadius=parseInt(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lineRadius);   
                        radiusSegments=parseInt(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lineRadSegs);
                        surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].linePoints=new THREE.SplineCurve3(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lineData);
                        surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['surfaceGeometry'] = new THREE.TubeGeometry(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].linePoints, segments, tubeRadius, radiusSegments, false, false);  
                        surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lut=new THREE.Lut( surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['colorMap'], parseInt(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['numberOfColors']) );       
                        if (surfaceObj.content.Surface.Props.divideColormap=='0')                 
                        {   
                            surfaceObj.content.Surface.Scene.lut = new THREE.Lut( surfaceObj.content.Surface.Props.Legend.colorMap, surfaceObj.content.Surface.Props.Legend.numberOfColors );   
                            surfaceObj.content.Surface.Scene.lut.setMax( surfaceObj.content.Surface.Props.zMax );     surfaceObj.content.Surface.Scene.lut.setMin( surfaceObj.content.Surface.Props.zMin ); 
                            if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['useColorData']==1)
                            {       
                                colorData=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].cData;       
                            }else
                            {
                                colorData=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['lineGeometry']['points']; 
                            }             
                            for ( var seg = 0; seg < surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['lineGeometry']['points'].length; seg=seg+1 ) 
                            {   
                                for ( var rad = 0; rad < surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lineRadSegs; rad=rad+1 )      
                                {   
                                    vertexIndex = rad + seg * radiusSegments;           
                //                  temp = surfaceObj.content.Surface.Scene.lut.getColor( surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['lineGeometry']['points'][seg]['z']);
                                    if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['useColorData']==0)
                                    {
                                        console.log('Using seg '+seg+' the color data '+colorData[seg]['z']);
                                        temp=surfaceObj.content.Surface.Scene.lut.getColor( colorData[seg]['z']);  
                                    }else 
                                    {   
                                        key='0-'+seg;   
                                        temp=surfaceObj.content.Surface.Scene.lut.getColor( colorData[key]);    
                                    }
                                    color = new THREE.Color( temp.r, temp.g, temp.b );  
                                    color.setRGB(temp.r, temp.g, temp.b);               
                                    surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].surfaceGeometry.colors[vertexIndex] = color;       
                                }   
                            }               
                        }else                   
                        {   surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lut = new THREE.Lut( surfaceObj.content.Surface.Props.Legend.colorMap, surfaceObj.content.Surface.Props.Legend.numberOfColors );   
                            if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['useColorData']==1)
                            {   
                                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lut.setMax( surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].cMax );
                                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lut.setMin( surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].cMin );
                                colorData=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].cData;
                            }else               
                            {   
                                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lut.setMax( surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zMax );
                                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lut.setMin( surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].zMin );
                                colorData=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['lineGeometry']['points'];
                            }                   
                            for ( var seg = 0; seg < surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['lineGeometry']['points'].length; seg=seg+1 ) 
                            {   
                                for ( var rad = 0; rad < surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lineRadSegs; rad=rad+1 )      
                                {   
                                    vertexIndex = rad + seg * radiusSegments;           
                                    if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['useColorData']==0)
                                    {
                                        temp=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lut.getColor( colorData[seg]['z']);
                                    }else 
                                    {
                                        temp=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].lut.getColor( colorData['0-'+seg]);
                                    }
                                    if (temp===undefined){ temp={b:0.1, g:0.1, r:0.1}; }
                                    color = new THREE.Color( temp.r, temp.g, temp.b );  
                                    color.setRGB(temp.r, temp.g, temp.b);               
                                    surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].surfaceGeometry.colors[vertexIndex] = color;       
                                }
                            }
                        }

                        for ( var i = 0; i < surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].surfaceGeometry.faces.length; i=i+1 )         
                        {   
                            face = surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].surfaceGeometry.faces[ i ];
                            numberOfSides = ( face instanceof THREE.Face3 ) ? 3 : 4;    
                            for( var j = 0; j < numberOfSides; j=j+1 )                  
                            {   
                                vertexIndex = face[ faceIndices[ j ] ];                 
                                face.vertexColors[ j ] = surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].surfaceGeometry.colors[ vertexIndex ];
                                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].surfaceGeometry.faces[ i ]['vertexColors'][ j ] = surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].surfaceGeometry.colors[ vertexIndex ];  
                            }                   
                        }                       
                        surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['surfaceGeometry']['colorsNeedUpdate']=true;
                        surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['surfaceGeometry']['elementsNeedUpdate']=true;
                        surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['surfaceGeometry']['groupsNeedUpdate']=true;
                        surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['surfaceGeometry']['verticesNeedUpdate']=true;
                        wireMaterial = new THREE.MeshBasicMaterial( { vertexColors: THREE.VertexColors, side:THREE.DoubleSide } );
                        graphMesh = new THREE.Mesh( surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex].surfaceGeometry, wireMaterial );   
                        graphMesh.name = dataID;
                        surfaceObj.content.Surface.Scene.add(graphMesh);  
                    }                               
                }else
                {
                    console.log('The line geometry is not defined');
                }
                
                return surfaceObj                  
            },




            /*
            *
            *   SET THE POINTS FOR A LINE
            *   This code sets the individual data points for each line. This is done by creating a spline curve and 
            *   adding a vector point for each point in the users data. If either the X or Y are not populated, then 
            *   the index for those points is used. 
            *   thisItem - the  main plot item
            *   dataID - the id of the dataset being worked on
            *   axis - the axis that was set 
            *
            */
            // setLinePoints : function (PlotID, DataID, dataObject, axis, Props, callback)         
            setLinePoints : function (thisItem, dataID, axis)         
            {   var xVal=0, yVal=0, zVal=0, cVal=0, lineData=[], xMax=-9999999999, xMin=9999999999, yMax=-9999999999, yMin=9999999999, zMax=-9999999999, zMin=9999999999, dataIndex=0;
                var cMax=-9999999999, cMin=9999999999;
                for (var a=0; a<thisItem['content']['Surface']['Chart_dataobj'].length; a++)
                { 
                    console.log('comparing '+thisItem['content']['Surface']['Chart_dataobj'][a]['Format_id']+' to '+dataID);
                    if (thisItem['content']['Surface']['Chart_dataobj'][a]['Format_id']==dataID){ dataIndex=a; } 
                }    
                if (axis=="X") { var thislength=Object.keys(thisItem['content']['Surface']['Chart_dataobj'][dataIndex]['xData']).length; }
                if (axis=="Y") { var thislength=Object.keys(thisItem['content']['Surface']['Chart_dataobj'][dataIndex]['yData']).length; }
                if (axis=="Z") { var thislength=Object.keys(thisItem['content']['Surface']['Chart_dataobj'][dataIndex]['zData']).length; }
                if (axis=="C") { var thislength=Object.keys(thisItem['content']['Surface']['Chart_dataobj'][dataIndex]['cData']).length; }
                console.log('The lengths of the x, y, z, and c components are '+Object.keys(thisItem['content']['Surface']['Chart_dataobj'][dataIndex]['xData']).length+'-'+Object.keys(thisItem['content']['Surface']['Chart_dataobj'][dataIndex]['yData']).length+'-'+Object.keys(thisItem['content']['Surface']['Chart_dataobj'][dataIndex]['zData']).length+'-'+Object.keys(thisItem['content']['Surface']['Chart_dataobj'][dataIndex]['cData']).length);
                for (var thisDataID in thisItem['content']['Surface']['Chart_dataobj'])
                {   
                    if (thisItem['content']['Surface']['Chart_dataobj'][thisDataID]['type']=="line")
                    {   
                        for (var a=0; a<thislength; a++)
                        {   
                            if (thisItem['content']['Surface']['Chart_dataobj'][thisDataID].xData['0-'+a]===undefined){ xVal=a; }else { xVal=thisItem['content']['Surface']['Chart_dataobj'][thisDataID].xData['0-'+a]; }
                            if (thisItem['content']['Surface']['Chart_dataobj'][thisDataID].yData['0-'+a]===undefined){ yVal=a; }else { yVal=thisItem['content']['Surface']['Chart_dataobj'][thisDataID].yData['0-'+a]; }
                            zVal=thisItem['content']['Surface']['Chart_dataobj'][thisDataID].zData['0-'+a]; 
                            cVal=thisItem['content']['Surface']['Chart_dataobj'][thisDataID].cData['0-'+a]; 
                            console.log('A new three vector is being pushed with values of '+xVal+'-'+yVal+'-'+zVal);
                            lineData.push(new THREE.Vector3(xVal, yVal, zVal));
                            if (xVal>xMax) { thisItem['content']['Surface']['Chart_dataobj'][thisDataID].xMax=xVal; xMax=xVal; }
                            if (xVal<xMin) { thisItem['content']['Surface']['Chart_dataobj'][thisDataID].xMin=xVal; xMin=xVal; }
                            if (yVal>yMax) { thisItem['content']['Surface']['Chart_dataobj'][thisDataID].yMax=yVal; yMax=yVal; }
                            if (yVal<yMin) { thisItem['content']['Surface']['Chart_dataobj'][thisDataID].yMin=yVal; yMin=yVal; }
                            if (zVal>zMax) { thisItem['content']['Surface']['Chart_dataobj'][thisDataID].zMax=zVal; zMax=zVal; }
                            if (zVal<zMin) { thisItem['content']['Surface']['Chart_dataobj'][thisDataID].zMin=zVal; zMin=zVal; }
                            if (cVal>cMax) { thisItem['content']['Surface']['Chart_dataobj'][thisDataID].cMax=cVal; cMax=cVal; }
                            if (cVal<cMin) { thisItem['content']['Surface']['Chart_dataobj'][thisDataID].cMin=cVal; cMin=cVal; }
                }   }   }
                thisItem['content']['Surface']['Props']['xMin']=xMin;    
                thisItem['content']['Surface']['Props']['xMax']=xMax;
                thisItem['content']['Surface']['Props']['yMin']=yMin;    
                thisItem['content']['Surface']['Props']['yMax']=yMax;
                thisItem['content']['Surface']['Props']['zMin']=zMin;    
                thisItem['content']['Surface']['Props']['zMax']=zMax;
                thisItem['content']['Surface']['Chart_dataobj'][dataIndex].lineGeometry=new THREE.SplineCurve3(lineData);
                return thisItem
            },




            /*
            *
            *
            *   SECTION 5 - PREDEFINED SHAPES
            *
            *
            */




            /*
            *
            *   CREATE ONE OF THE SHAPES
            *
            */
            createShape : function( thisShape, dataID, surfaceObj )      
            {   
                console.log('Creating a '+thisShape+' for dataset '+dataID);
                var dataIndex=0, thisData={}, ps=0, pl=0, ts=0, tl=0, pl=0, arc=0;                    
                surfaceObj['content']['Surface']['Chart_dataobj'].forEach(function(thisItem, thisIndex)
                {   if (thisItem['Format_id']==dataID)
                    {   
                        dataIndex=thisIndex; thisData=thisItem; 
                    } 
                });
                var thisColor='#'+thisData['color'].replace(/^\#/,'');              
                var thisWireColor='#'+thisData['wireColor'].replace(/^\#/,'');      
                var darkMaterial = new THREE.MeshBasicMaterial( { color: thisColor } );
                if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['wireFrame']=="Wireframe")
                {   
                    var wireframeMaterial = new THREE.MeshBasicMaterial( { color: thisWireColor, wireframe: true, transparent: true } ); 
                }else
                {   
                    var wireframeMaterial = new THREE.MeshBasicMaterial( { color: thisColor, wireframe: false, transparent: true } );   
                }
                var multiMaterial = [ darkMaterial, wireframeMaterial ];            
                ps=parseFloat(Big(0.0174532925).times(Big(thisData.phiStart)));     
                pl=parseFloat(Big(0.0174532925).times(Big(thisData.phiLength)));    
                ts=parseFloat(Big(0.0174532925).times(Big(thisData.thetaStart)));   
                tl=parseFloat(Big(0.0174532925).times(Big(thisData.thetaLength)));  
                arc=parseFloat(Big(0.0174532925).times(Big(thisData.arc)));         
                if (thisShape=="cube"){         var shape = THREE.SceneUtils.createMultiMaterialObject( new THREE.BoxGeometry(thisData.width, thisData.height, thisData.depth, thisData.widthSegs, thisData.heightSegs, thisData.depthSegs), multiMaterial );}  
                if (thisShape=="sphere"){       var shape = THREE.SceneUtils.createMultiMaterialObject( new THREE.SphereGeometry(thisData.radius, thisData.widthSegs, thisData.heightSegs, ps, pl, ts, tl), multiMaterial );}   
                if (thisShape=="cylinder"){     var shape = THREE.SceneUtils.createMultiMaterialObject( new THREE.CylinderGeometry(parseFloat(thisData.topRadius), parseFloat(thisData.botRadius), thisData.height, thisData.radSegs, thisData.heightSegs, thisData.openEnded, ts, tl), multiMaterial );}   
                if (thisShape=="dodecahedron"){ var shape = THREE.SceneUtils.createMultiMaterialObject( new THREE.DodecahedronGeometry(thisData.radius, thisData.detail), multiMaterial );} 
                if (thisShape=="tetrahedron"){  var shape = THREE.SceneUtils.createMultiMaterialObject( new THREE.TetrahedronGeometry(thisData.radius, thisData.detail), multiMaterial );}  
                if (thisShape=="octahedron"){   var shape = THREE.SceneUtils.createMultiMaterialObject( new THREE.OctahedronGeometry(thisData.radius, thisData.detail), multiMaterial );}
                if (thisShape=="icosahedron"){  var shape = THREE.SceneUtils.createMultiMaterialObject( new THREE.IcosahedronGeometry(thisData.radius, thisData.detail), multiMaterial );}
                if (thisShape=="torus"){        var shape = THREE.SceneUtils.createMultiMaterialObject( new THREE.TorusGeometry(parseFloat(thisData.radius), thisData.tubeDiameter, thisData.radSegs, thisData.tubeSegs, arc), multiMaterial );}
                if (thisShape=="plane"){        var shape = THREE.SceneUtils.createMultiMaterialObject( new THREE.PlaneGeometry(thisData.width, thisData.height, thisData.widthSegs, thisData.heightSegs), multiMaterial );}
                if (thisShape=="lathe"){        var shape = THREE.SceneUtils.createMultiMaterialObject( new THREE.LatheGeometry(thisData.curve, thisData.radSegs, ps, pl), multiMaterial );}
                if (thisShape=="arrow")     
                {   
                    var direct = new THREE.Vector3( parseFloat(thisData.xDir), parseFloat(thisData.yDir), parseFloat(thisData.zDir) );  
                    var orig = new THREE.Vector3( parseFloat(thisData.xPosition), parseFloat(thisData.yPosition), parseFloat(thisData.zPosition) ); 
                    var shape = new THREE.ArrowHelper(direct, orig, thisData.length, '#'+thisData.color, thisData.aHeight, thisData.aWidth );  
                }
                shape.name=dataID;          
                shape.position.set(thisData.xPosition, thisData.yPosition, thisData.zPosition); 
                shape.rotation.set(0.0174532925*thisData.xRotation, 0.0174532925*thisData.yRotation, 0.0174532925*thisData.zRotation);
                surfaceObj['content']['Surface']['Scene'].add(shape);          
                
                return surfaceObj                  
            },





            /*
            *
            *   FORMAT LATHE DATA
            *
            */
            formatLatheData : function ( dataID, surfaceObj )          
            {   console.log('Formatting Lathe Data for '+dataID);
                var dataIndex=0, key='';
                surfaceObj['content']['Surface']['Chart_dataobj'].forEach(function(thisItem, thisIndex)
                {   
                    if (thisItem['Format_id']==dataID){ dataIndex=thisIndex; } 
                });
                surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['curve']=[];               
                var xsize = Object.keys(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['xData']).length;
                var ysize = Object.keys(surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['yData']).length;
                if (xsize>ysize) { var size=xsize; }else { var size=ysize; }        
                for ( var i=0; i<size; i++ ) 
                {   
                    key='0-'+i;             
                    if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['xData'][key]===undefined)
                    { 
                        xVal=i; 
                    }else
                    { 
                        xVal=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['xData'][key]; 
                    }
                    if (surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['yData'][key]===undefined)
                    {   
                        yVal=0; 
                    }else
                    {
                        yVal=surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['yData'][key]; 
                    }
                    surfaceObj['content']['Surface']['Chart_dataobj'][dataIndex]['curve'].push(new THREE.Vector3(xVal, 0, yVal));               
                }        

                return surfaceObject                   
            }

        }
    }

})();
/*
*   This factory takes in an object containing an object of data, the size of that object, and an object 
*   containing the start and end points of the data for each index. The factory looks at the start and
*   stop point for each index and returns a two dimensional array that can be shown as a table. This is
*   used in the datasets and in the documents to take a large multi dimensional object and see parts of
*   it in a table.
*/

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('objectToTableFactory', objectToTableFactory);

    /** @ngInject */
    function objectToTableFactory()
    {
        return {
            
            parseText : function(dataString, parsers) 
            {
                var re4=new RegExp('['+parsers[4]+']');
                var re3=new RegExp('['+parsers[3]+']');
                var re2=new RegExp('['+parsers[2]+']');
                var re1=new RegExp('['+parsers[1]+']');
                var re0=new RegExp('['+parsers[0]+']');
                var textArray=dataString.split(re4);
                for (var a=0; a<textArray.length; a++)
                {   textArray[a]=textArray[a].split(re3); }
                for (var a=0; a<textArray.length; a++)
                {   for (var b=0; b<textArray[a].length; b++)
                    {   textArray[a][b]=textArray[a][b].split(re2);   }
                }
                for (var a=0; a<textArray.length; a++)
                {   for (var b=0; b<textArray[a].length; b++)
                    {   for (var c=0; c<textArray[a][b].length; c++)
                        {   textArray[a][b][c]=textArray[a][b][c].split(re1);     }
                    } 
                }
                for (var a=0; a<textArray.length; a++)
                {   for (var b=0; b<textArray[a].length; b++)
                    {   for (var c=0; c<textArray[a][b].length; c++)
                        {   for (var d=0; d<textArray[a][b][c].length; d++)
                            {   textArray[a][b][c][d]=textArray[a][b][c][d].split(re0);   }
                        } 
                    } 
                }
                //vm.textArray=textArray;
                var thisData={};
                thisData.real={};   
                thisData.imag={};   
                thisData.size='';   
                thisData.myLength=[];
                thisData.myLength[0]=0;
                thisData.myLength[1]=0;
                thisData.myLength[2]=0;
                thisData.myLength[3]=0;
                thisData.myLength[4]=0;
                for (a=0; a<5; a++){ if (textArray.length==1){ textArray=[].concat.apply([], textArray); }else { break } }
                textArray.map(function(num1, index1)
                {   if ((Array.isArray(num1))&&(num1.length>0))
                    {   if (index1>thisData.myLength[0]){ thisData.myLength[0]=index1;   }
                        num1.map(
                            function(num2, index2)
                            {   if ((Array.isArray(num2))&&(num2.length>0))
                                {   if (index2>thisData.myLength[1]){ thisData.myLength[1]=index2;  }
                                    num2.map(
                                        function(num3, index3)
                                        {   if ((Array.isArray(num3))&&(num3.length>0))
                                            {   if (index3>thisData.myLength[2]){ thisData.myLength[2]=index3;  }
                                                num3.map(
                                                    function(num4, index4)
                                                    {   if ((Array.isArray(num4))&&(num4.length>0))
                                                        {   if (index4>thisData.myLength[3]){ thisData.myLength[3]=index4;  }
                                                            num4.map(
                                                                function(num5, index5)
                                                                {   if ((Array.isArray(num5))&&(num5.length>0))
                                                                    {                                                                    
                                                                    }else{ thisData.real[index4+'-'+index5+'-'+index1+'-'+index2+'-'+index3]=num5;  thisData.imag[index4+'-'+index5+'-'+index1+'-'+index2+'-'+index3]=0; if (index5>thisData.myLength[4]){ thisData.myLength[4]=index5;   }}
                                                                })
                                                        }else{ thisData.real[index3+'-'+index4+'-'+index1+'-'+index2]=num4; thisData.imag[index3+'-'+index4+'-'+index1+'-'+index1]=0;    if (index4>thisData.myLength[3]){ thisData.myLength[3]=index4;   }}
                                                    })
                                            }else{ thisData.real[index2+'-'+index3+'-'+index1]=num3; thisData.imag[index2+'-'+index3+'-'+index1]=0;  if (index3>thisData.myLength[2]){ thisData.myLength[2]=index3;   } }
                                        })
                                }else { thisData.real[index1+'-'+index2]=num2;  thisData.imag[index1+'-'+index2]=0;  if (index2>thisData.myLength[1]){ thisData.myLength[1]=index2;   } }
                            });
                    }else{ thisData.real['0-'+index1]=textArray[index1]; thisData.imag['0-'+index1]=0;  if (index1>thisData.myLength[0]){ thisData.myLength[0]=index1;  } }
                });
                if (thisData.myLength[1]>0)
                {       thisData.size=(parseInt(thisData.myLength[0])+1)+'x'+(parseInt(thisData.myLength[1])+1);
                }else{  thisData.size=(parseInt(thisData.myLength[1])+1)+'x'+(parseInt(thisData.myLength[0])+1);  }
                if (thisData.myLength[2]>0){ thisData.size=(parseInt(thisData.myLength[1])+1)+'x'+(parseInt(thisData.myLength[2])+1)+'x'+(parseInt(thisData.myLength[0])+1); }
                if (thisData.myLength[3]>0){ thisData.size=(parseInt(thisData.myLength[2])+1)+'x'+(parseInt(thisData.myLength[3])+1)+'x'+(parseInt(thisData.myLength[0])+1)+'x'+(parseInt(thisData.myLength[1])+1); }
                if (thisData.myLength[4]>0){ thisData.size=(parseInt(thisData.myLength[3])+1)+'x'+(parseInt(thisData.myLength[4])+1)+'x'+(parseInt(thisData.myLength[0])+1)+'x'+(parseInt(thisData.myLength[1])+1)+'x'+(parseInt(thisData.myLength[2])+1); }
                
                return thisData
            },

            getTable : function(dataObject, size, indexObject) 
            {

                console.log('In the table function with a size of '+size);

                var sizes=size.split('x');
                
                // Ensure that each index has a start and stop and populate a full index correctly
                for (var a=0; a<sizes.length; a++)
                {
                    if (indexObject[a]===undefined)
                    {   indexObject[a]={};
                        indexObject[a]['start']=0;
                        indexObject[a]['stop']=0;
                    }
                    if (indexObject[a]['start']===undefined){ indexObject[a]['start']=0; }
                    if (indexObject[a]['stop']===undefined){ indexObject[a]['stop']=0; }

                    if (indexObject[a]['start']==':')
                    {   indexObject[a]['start']=0;
                        indexObject[a]['stop']=sizes[a]-1;
                    }
                    indexObject[a]['index']=indexObject[a]['start'];
                    console.log('At index '+a+', the start is '+indexObject[a]['start']+', and the stop is '+indexObject[a]['stop']);
                }

                // Get the full count of items
                var count=1;
                for (var a=0; a<sizes.length; a++)
                {   count=count*(parseInt(indexObject[a]['stop'])-parseInt(indexObject[a]['start'])+1); }

                console.log('The count is '+count);

                // Create a map of the indexes
                var indexMap=[], index1="NA", index2="NA", length2=0;
                if (sizes.length==2)
                {
                    index1=0;
                    index2=1;
                }
                
                for (var a=0; a<sizes.length; a++)
                {   
                    indexMap[a]=indexObject[a]['start'];
                    
                    if (indexObject[a]['start']-indexObject[a]['stop']!=0)
                    {   
                        length2=indexObject[a]['stop']-indexObject[a]['start']+1;
                        
                        if (index1=="NA")
                        {   
                            index1=a; 
                        }else
                        {
                            index2=a;
                        }
                    }
                }

                
                console.log('The lengths are '+length2);
                // Pull the old data into the new array
                var oldKey='', returnArray=[];
                for (var countNum=0; countNum<count; countNum++)
                {   
                    oldKey='';
                    
                    if (countNum % length2 == 0){ returnArray[countNum]=[]; }
                    
                    for (var indexPos=0; indexPos<indexMap.length; indexPos++)
                    {   oldKey=oldKey+'-'+indexMap[indexPos]; }

                    oldKey=oldKey.replace(/^\-/,'')
                    console.log('The indexes are '+index1+'-'+index2+' and the old key is '+oldKey+' and the value returned is '+dataObject[oldKey]);
                    returnArray[index1][index2]=dataObject[oldKey];

                    if ((countNum % length2 == 0)&&(countNum!=0))
                    {
                        indexMap[index1] = parseInt(indexMap[index1])+1;     
                    
                    }else
                    {
                        indexMap[index2] = parseInt(indexMap[index2])+1;     
                    }

                }

                return returnArray;

            }

        }
    }

})();
/*
*   This factory provides a number of things needed for the items within a document. This is especially relevant to 
*   new items within a document. The prototypes are here for every item, as well as things they need like the 
*   function to get a new and unique ID. There are are also prototypes for things like references.
*   The exception to this are the two-dimensional and three-dimensional charts. These items are in their own factories
*   so that those factories can be shared with the individual pages for 2D and 3D charts.
*/
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('partTreeMemoryFactory', partTreeMemoryFactory);

    /** @ngInject */
    function partTreeMemoryFactory()
    {
        return {

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('newItemFactory', newItemFactory);

    /** @ngInject */
    function newItemFactory()
    {
        return {
            
            // Function called when a new item is added to a workspace.
            setNewItem : function(type) 
            {
                if (type=="document")
                {   var icon="file-outline";
                    var name="New Document";
                    var description="New document - remember to check out before editing";
                }else if (type=="workspace")
                {   var icon="folder-outline";
                    var name="New Workspace";
                    var description="New Workspace";
                }else if (type=="dataset")
                {   var icon="folder-outline";
                    var name="New Dataset";
                    var description="New Dataset";
                }else if (type=="parttree")
                {   var icon="pine-tree";
                    var name="New Part Tree";
                    var description="New Part Tree";
                }else if (type=="image")
                {   var icon="camera";
                    var name="New Image";
                    var description="New Image";
                }else if (type=="workflow")
                {   var icon="";
                    var name="New Workflow";
                    var description="New Workflow";
                }else if (type=="forum")
                {   var icon="forum";
                    var name="New Forum";
                    var description="New Forum";
                }
                
                // call the ajax function to add a new item and return the new ID
                // It should return when the promise is resolved

                var returnData =    
                    {   
                        "id":9,
                        "name": name,
                        "type": type,
                        "typeIcon":icon,
                        "creator": "The Wolf",
                        "modified": "July 8, 2015",
                        "created": "July 8, 2015",
                        "description":description,
                        "rank":1,
                        "status":"1",
                        "statusIcon":"lock-unlocked",
                        "checkOutName":""
                    }

                return returnData;

            },

            // Function called to ensure a potential name meets the criteria
            checkNewName : function(newName)
            {   var re=/[a-zA-Z0-9\s\-\ ]+/;
                var test=re.exec(newName);
                if (test==newName)
                {   return true 
                }else
                {   return false
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject required services
        var $log = angular.injector(['ng']).get('$log'),
            $resource = angular.injector(['ngResource']).get('$resource');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Prepare the resource object
            var resourceObj = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };

            // Assign the resource
            api[key] = $resource(resourceObj.url, resourceObj.paramDefaults, resourceObj.actions, resourceObj.options);
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
/*
*
*   Memory storage for documents. This service retains items in memory for documents between views.
*
*/
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('documentMemoryFactory', documentMemoryFactory);

    /** @ngInject */
    function documentMemoryFactory()
    {
        return {

        }
    }

})();
/*
*   This factory provides a number of functions that are used in the document module. Most of these 
*   functions are related to new items being created or items being deleted. Others are related to
*   actions taken within the document or to solving an equation. There is a separate factory for the 
*	2D charts and for 3D charts.
*
*
*	Functions related to adding or deleting a new item.
*
*   getID	   - gets a unique ID for a new item
*	getNewPos	- get the location for an item to be added   
*   incDepPos   - increment or decrement all item positions past a given point
*	newItem	 - get a template for a new item
*
*
*
*
*   Functions relating to manipulating the document
*
*   changePos   - changes the position of an item and alters the worksheet
*
*
*
*
*   Functions relating to solving an equation
*
*
*
*
*	Prototypes and templates
*
*	eqPro		- prototype for an equation
*	forLoopPro	- prototype for a for loop
*   refPro	  - template for a new reference item
*  
*/


(function ()
{
	'use strict';

	angular
		.module('app.core')
		.factory('docItemFactory', docItemFactory);

	/** @ngInject */
	function docItemFactory()
	{
		return {
			
			/*
			*
			*
			*   FUNCTIONS RELATING TO ADDING AND DELETING ITEMS
			*
			*   
			*
			*/

			// Get an id for the item to be added.
			getID : function(type, fileID, worksheetObject) 
			{
				var flag=0, topFlag=0, id='', testFlag=0, preFix='', file="File"+fileID;   
				if (type=="Equation")					{ preFix='var';				topFlag=1;	
				}else if (type=="Slider")				{ preFix='var';				topFlag=1;	
				}else if (type=="Radio")				{ preFix='var';				topFlag=1;	
				}else if (type=="For Loop")				{ preFix='forLoop';	 		topFlag=1;	
				}else if (type=="While Loop")			{ preFix='whileLoop';		topFlag=1;	
				}else if (type=="If Else")				{ preFix='ifElse';			topFlag=1;	
				}else if (type=="elseIf")				{ preFix='ifElse';			topFlag=1;	
				}else if (type=="else")					{ preFix='ifElse';			topFlag=1;	
				}else if (type=="2D Plot")				{ preFix='plot';			topFlag=1;	
				}else if (type=="3D Chart")				{ preFix='surface';	 		topFlag=1;	
				}else if (type=="Text")					{ preFix='text';			topFlag=1;	
				}else if (type=="Image")				{ preFix='image';			topFlag=1;   
				}else if (type=="Video")				{ preFix='video';			topFlag=1;	
				}else if (type=="Header")				{ preFix='header';			topFlag=1;   
				}else if (type=="Table")				{ preFix='Table';			topFlag=1;	
				}else if (type=="Line Break")			{ preFix='lineBreak';		topFlag=1;	 
				}else if (type=="Card")					{ preFix='Card';			topFlag=1;	
				}else if (type=="Symbolic")				{ preFix='sym';				topFlag=1;	
				}else if (type=="dataSeries")			{ preFix='dataset';	 		topFlag=0;	
				}else if (type=="axis")					{ preFix='axis';			topFlag=0;	
				}else if (type=="band")					{ preFix='Band';			topFlag=0;	
				}else if (type=="line")					{ preFix='Line';			topFlag=0;	
				}else if (type=="plotText")				{ preFix='plotText';		topFlag=0;	
				}else if (type=="ref")					{ preFix='reference';		topFlag=0;	
				}else if (type=="Free Body Diagram")  	{ preFix='freeBodyDiagram';	topFlag=1;
				}else if (type=="Requirement")  		{ preFix='req';				topFlag=1;	}
				if (topFlag==1)
				{   while (flag===0)	
					{   id=file+''+preFix+''+Math.floor((Math.random()*1000000)+1);
						testFlag=0;
						for (var a=0; a<worksheetObject.length; a++)
						{ 
							if (worksheetObject[a]['itemid']==id)
							{ 
								testFlag=1; 
							} 
						}
						if (testFlag==1){ flag=0; }else{ flag=1; }
					}
				}else		  
				{   flag=0;
					while (flag==0)
					{   id=file+''+preFix+''+Math.floor((Math.random()*1000000)+1);
						flag=1;
						for (var a=0; a<worksheetObject; a++)
						{   if (worksheetObject[a]['component_type_id']=='9')
							{   for (dataInd in worksheetObject[a]['content']['Plot']['Chart_dataobj']) 
								{   if (worksheetObject[a]['content']['Plot']['Chart_dataobj'][dataInd]['Format_id']==id) { flag=0; }  } 
								for (axisInd in worksheetObject[a]['content']['Plot']['Chart_xaxesobj']) 
								{   if (worksheetObject[a]['content']['Plot']['Chart_xaxesobj'][axisInd]['Format_id']==id) { flag=0; }  } 
								for (axisInd in worksheetObject[a]['content']['Plot']['Chart_yaxesobj']) 
								{   if (worksheetObject[a]['content']['Plot']['Chart_yaxesobj'][axisInd]['Format_id']==id) { flag=0; }  } 
								for (bandInd in worksheetObject[a]['content']['Plot']['Chart_bandsobj']) 
								{   if (worksheetObject[a]['content']['Plot']['Chart_bandsobj'][bandInd]['Format_id']==id) { flag=0; }  } 
								for (lineInd in worksheetObject[a]['content']['Plot']['Chart_linesobj']) 
								{   if (worksheetObject[a]['content']['Plot']['Chart_linesobj'][lineInd]['Format_id']==id) { flag=0; }  } 
								for (textInd in worksheetObject[a]['content']['Plot']['Chart_textobj']) 
								{   if (worksheetObject[a]['content']['Plot']['Chart_textobj'][textInd]['Format_id']==id) { flag=0; }  } 
								for (refInd in worksheetObject[a]['content']['Plot']['references']) 
								{   if (worksheetObject[a]['content']['Plot']['references'][refInd]['Format_id']==id) { flag=0; }  }						 
							}
						}
					}
				}
				return id;  
			},



			// Function to update old documents with new requirements. 
			// These are typically just parts of the item_data that were added after docs were created
			updateDocProps : function (thisDoc)
			{   
				if ( thisDoc.item_data.copiedDoc === undefined )
				{
					thisDoc.item_data.copiedDoc = [];
				}

				return thisDoc
			},

			// Function to get the location of a new item
			getNewPos : function (thisWorksheet, currentItem, objProps, connFlag, sentLocation)
			{   
				//console.log('in the Get new Pos with connFlag -  '+connFlag+', sentLocation - '+sentLocation);
				if ( parseInt(connFlag) == 1 )
				{
					//console.log('Returning location '+sentLocation+' for a connected item');
					return sentLocation;
				
				}else
				{
					var thisLoc=0;
					if (connFlag===undefined){ connFlag=0; sentLocation=0; }
					if (objProps['parentid']===undefined){  objProps['parentid']="none";   }
					if (objProps['topparentid']===undefined){  objProps['topparentid']="none";   }
					if (currentItem=="top"){ return 0;
					}else
					{   
						for (var a=0; a<thisWorksheet.length; a++)
						{   
							if (thisWorksheet[a]['itemid']==currentItem['itemid'])
							{   
								if (((currentItem['component_type_id']==6)||
									 (currentItem['component_type_id']==7)||
									 (currentItem['component_type_id']==8))&&(objProps['parentid']=="none"))
								{										   
									thisLoc=parseInt(thisWorksheet[a]['content']['Page_lastposition']); 
								
								}else if (objProps['parentid']!="none")
								{	
									thisLoc=this.retrieveLastPosition(thisWorksheet, thisWorksheet[a]['itemid']); 
								}else  
								{   
									thisLoc=parseInt(thisWorksheet[a]['order']); 
								}
					}   }   }

					thisLoc=parseInt(parseInt(thisLoc)+parseInt(1));
					
					return thisLoc;
				}

			},


			// Get the last position of the item sent
			retrieveLastPosition : function (worksheetObj, thisID)
			{   var thisLoc=0;
				worksheetObj.forEach(function(thisItem, index)
				{   
					if ( ( (thisID==thisItem['itemid']) ||
						   (thisID==thisItem['content']['parentid']) ) &&
						 (thisItem['order'] > thisLoc) )
					{ 
						thisLoc = thisItem['order']; 
					}   
				
				});
				
				//console.log('Returning '+thisLoc+' for the last position.');
				return thisLoc;

			},



			/*
			*
			* Get the top parent for an item
			*
			*/
			getTopParent : function (thisObject, originalID, worksheetObj)
			{   var thisParent='none';
				if (thisObject['content']['parentid']=='none')
				{
					if (thisObject['itemid']==originalID)
					{   
						return 'none'
					}else
					{   
						//console.log('This item has a top id of '+thisObject['itemid']);
						return thisObject['itemid']
					}
				}else
				{
					for (var thisItem in worksheetObj)
					{   
						if (thisObject['content']['parentid']==worksheetObj[thisItem]['itemid'])
						{   
							return this.getTopParent(worksheetObj[thisItem], originalID, worksheetObj); 
						}   
					
					}
				}
			},



			// Function to increment/decrement all items after a given location
			incDecPos : function(type, thisLoc, thisWorksheet)
			{
				if ( thisLoc != 0 )
				{
					for (var a=0; a<thisWorksheet.length; a++)
					{   
						if ((thisWorksheet[a]['content']['Page_lastposition']=='')||(thisWorksheet[a]['content']['Page_lastposition']===undefined))
						{   
							thisWorksheet[a]['content']['Page_lastposition']=parseInt(thisWorksheet[a]['order']); 
						}

						if ((thisWorksheet[a]['order']>=thisLoc)&&(type=="increment"))
						{   
							if ( ( thisWorksheet[a]['order'] != 0 ) && ( thisWorksheet[a]['order'] != '0' ) )
							{
								thisWorksheet[a]['order']=parseInt(thisWorksheet[a]['order'])+1; 
								thisWorksheet[a]['content']['Page_lastposition']=parseInt(thisWorksheet[a]['content']['Page_lastposition'])+1; 
							}
						}   

						if ((thisWorksheet[a]['order']>=thisLoc)&&(type=="decrement"))
						{   
							if ( ( thisWorksheet[a]['order'] != 0 ) && ( thisWorksheet[a]['order'] != '0' ) )
							{
								thisWorksheet[a]['order']=parseInt(thisWorksheet[a]['order'])-1; 
								thisWorksheet[a]['content']['Page_lastposition']=parseInt(thisWorksheet[a]['content']['Page_lastposition'])-1; 
							}
						}   
					}
				}

				return thisWorksheet;

			},




			// Create the template for a new item or subitems.
			newItem : function(type, newID, thisLoc, fileID, objProps, worksheetObj) 
			{   
				var templateObj={};
				templateObj['file_id'] = fileID; 
				templateObj['itemid']=newID;
				templateObj['order']=thisLoc;
				templateObj['content']={};
				templateObj['content']['itemid']=newID;
				templateObj['content']['id']=newID;
				templateObj['content']['Name']='';
				templateObj['content']['created']='';
				templateObj['content']['modified']='';
				templateObj['content']['fileid']=fileID;
				templateObj['content']['inputFile']=0;
				templateObj['content']['inputID']='';
				templateObj['content']['Page_lastposition']=thisLoc;
				templateObj['content']['width']='825';
				templateObj['content']['height']='50';
				templateObj['content']['marginbottom']='0';
				templateObj['content']['marginleft']='0';
				templateObj['content']['marginright']='0';
				templateObj['content']['margintop']='0';
				templateObj['content']['alignment']='left';
				templateObj['content']['parentid']='none';
				templateObj['content']['topparentid']='none';
				templateObj['content']['component_type_id']=0;
				templateObj['content']['Values']={};
				templateObj['content']['active']=1;
				templateObj['content']['references']=[];
				templateObj['content']['renderTo']='standard';
				templateObj['content']['isConnectedEquation']=0;
				if (objProps['parentid']!==undefined)
				{
					templateObj['content']['parentid']=objProps['parentid'];
				}
				for (var prop in objProps){ if (templateObj[prop]!==undefined) { templateObj[prop]=objProps[prop]; } }
				templateObj['content']['topparentid']=this.getTopParent(templateObj, newID, worksheetObj);
				
				if (type=="Text")
				{   
					templateObj['content']['text']='<p>Enter text here.</p>';
					templateObj['content']['showEdit']=false;
					templateObj['component_type_id']=1;
				}
				if (type=="Header")
				{   
					templateObj['content']['hClass']='header1';
					templateObj['content']['text']='New Header';
					templateObj['component_type_id']=2;
				}
				if ( type=="Equation")
				{   
					templateObj['name'] = 'newEquation'; 
					templateObj['component_type_id']=3;
					templateObj['content']['alignment']='center';
					templateObj['content']['eqType'] = 'equation';
				}
				if ( type=="Slider" )
				{   
					templateObj['name'] = 'newSlider'; 
					templateObj['component_type_id']=3;
					templateObj['content']['alignment']='center';
					templateObj['content']['eqType'] = 'slider';
					templateObj['content']['slider'] = {};
					templateObj['content']['slider']['status'] = 0;
					templateObj['content']['slider']['discrete'] = 0;
					templateObj['content']['slider']['vertical'] = 0;
					templateObj['content']['slider']['inverted'] = 0;
					templateObj['content']['slider']['step'] = 1;
					templateObj['content']['slider']['min'] = 0;
					templateObj['content']['slider']['max'] = 100;
					templateObj['content']['slider']['units'] = '';
					templateObj['content']['slider']['round'] = 3;
					templateObj['content']['slider']['color'] = '#FF0000';
					templateObj['content']['slider']['showEq'] = 1;
					templateObj['content']['slider']['eqLoc'] = 0;
				}
				if ( type=="Radio" )
				{   
					templateObj['name'] = 'newRadio'; 
					templateObj['component_type_id']=3;
					templateObj['content']['alignment']='center';
					templateObj['content']['eqType'] = 'radio';
					templateObj['content']['radio'] = {};
					templateObj['content']['radio']['vertical'] = 1;
					templateObj['content']['radio']['value'] = 0;
					templateObj['content']['radio']['values'] = [];
					templateObj['content']['radio']['width'] = 200;
					templateObj['content']['radio']['color'] = '#0392d8';
					templateObj['content']['radio']['showBorder'] = 1;
					templateObj['content']['radio']['showLabel'] = 1;
					templateObj['content']['radio']['values'].push({ 'value': '0', 'label':'0', 'color':'#0392d8', 'labelType':'value' })
				}
				if ( type=="Dropdown" )
				{   
					templateObj['name'] = 'newDropdown'; 
					templateObj['component_type_id']=3;
					templateObj['content']['alignment']='center';
					templateObj['content']['eqType'] = 'dropdown';
					templateObj['content']['dropdown'] = {};
					templateObj['content']['dropdown']['width'] = 200;
					templateObj['content']['dropdown']['value'] = 0;
					templateObj['content']['dropdown']['values'] = [];
					templateObj['content']['dropdown']['showBorder'] = 1;
					templateObj['content']['dropdown']['showLabel'] = 1;
					templateObj['content']['dropdown']['values'].push({ 'value': '0', 'label':'0', 'color':'#0392d8', 'labelType':'value' })
				}
				if (type=="Symbolic")
				{   
					templateObj['content']['text']='New Symbolic';
					templateObj['component_type_id']=4;
				}
				if (type=="Table")
				{   
					templateObj['content']['data']=
						[
							[
								{'real':1, 'imag':'', 'equation':'=1', 'units':'', 'Deps':{}, 'needsUpdateFlag':0, 'showEquation':false },
								{'real':2, 'imag':'', 'equation':'=2', 'units':'', 'Deps':{}, 'needsUpdateFlag':0, 'showEquation':false },
								{'real':3, 'imag':'', 'equation':'=3', 'units':'', 'Deps':{}, 'needsUpdateFlag':0, 'showEquation':false }
							],[
								{'real':4, 'imag':'', 'equation':'=4', 'units':'', 'Deps':{}, 'needsUpdateFlag':0, 'showEquation':false }, 
								{'real':5, 'imag':'', 'equation':'=5', 'units':'', 'Deps':{}, 'needsUpdateFlag':0, 'showEquation':false }, 
								{'real':6, 'imag':'', 'equation':'=6', 'units':'', 'Deps':{}, 'needsUpdateFlag':0, 'showEquation':false }
							],[
								{'real':7, 'imag':'', 'equation':'=7', 'units':'', 'Deps':{}, 'needsUpdateFlag':0, 'showEquation':false }, 
								{'real':8, 'imag':'', 'equation':'=8', 'units':'', 'Deps':{}, 'needsUpdateFlag':0, 'showEquation':false }, 
								{'real':9, 'imag':'', 'equation':'=9', 'units':'', 'Deps':{}, 'needsUpdateFlag':0, 'showEquation':false }
							]
						];
					templateObj['content']['caption']="Table Caption";
					templateObj['content']['captionEdit']=false;
					templateObj['content']['captionOn']=true;
					templateObj['content']['rowLabels']=true;
					templateObj['content']['colLabels']=true;
					templateObj['content']['tableHeaders']=true;
					templateObj['content']['borderWidth']=1;
					templateObj['content']['tableAlign']="center";
					templateObj['component_type_id']=5;
				}		 
			 
				if (type=="For Loop")
				{   
					templateObj['content']['forLoop']=new this.forLoopPro({'Format_id':newID }, fileID);  
					templateObj['component_type_id']=6;
					templateObj['content']['type']='forLoop';
					templateObj['content']['updateClass']='itemneedsupdate';
				}
				if (type=="While Loop")
				{   
					templateObj['content']['whileLoop']=new this.whileLoopPro({'Format_id':newID}, fileID);
					templateObj['content']['whileLoop']['statementBlock'][0].push( new this.statementPro() );
					templateObj['component_type_id']=7;
					templateObj['content']['type']='whileLoop';
					templateObj['content']['updateClass']='itemneedsupdate';
					for (var prop in objProps)
					{ 
						if (templateObj['content']['whileLoop'][prop]!==undefined) 
						{
							templateObj['content']['whileLoop'][prop]=objProps[prop]; 
						}
					}
				}
				if ((type=="If Else")||(type=="elseIf")||(type=="else"))
				{   
					templateObj['content']['ifelse']=new this.ifElsePro({'Format_id':newID}, fileID);  
					templateObj['content']['ifelse']['statementBlock'][0].push( new this.statementPro() );
					templateObj['component_type_id']=8;
					templateObj['content']['type']='ifelse';
					if (type=="elseIf"){	templateObj['content']['ifelse']['Statement_Type']="elseif";	 }
					if (type=="else"){	  templateObj['content']['ifelse']['Statement_Type']="else";	 }
					templateObj['content']['updateClass']='itemneedsupdate';
					for (var prop in objProps)
					{
						if (templateObj['content']['ifelse'][prop]!==undefined) 
						{ 
							templateObj['content']['ifelse'][prop]=objProps[prop]; 
						} 
					}
				}
				if (type=="2D Plot")
				{   
					templateObj['component_type_id']=9;
				}
				if (type=="Image")
				{   
					templateObj['content']['height']=250;
					templateObj['content']['src']='default.png';
					templateObj['content']['path']='http://cadwolf.app:3000/Workspaces/Documentation';
					templateObj['content']['thisType']='png';
					templateObj['content']['type']='image/png';
					templateObj['content']['width']=250;
					templateObj['component_type_id']=10;
				}
				if (type=="Line Break")
				{   
					templateObj['component_type_id']=11;
				}
				if (type=="Video")
				{   
					templateObj['content']['autohide']=2;
					templateObj['content']['autoplay']=0;
					templateObj['content']['color']='red';
					templateObj['content']['controls']=1;
					templateObj['content']['disablekb']=0;
					templateObj['content']['loop']=0;
					templateObj['content']['modestbranding']=0;
					templateObj['content']['related']=0;
					templateObj['content']['showinfo']=1;
					templateObj['content']['theme']='dark';
					templateObj['content']['videoHeight']='500';
					templateObj['content']['videoID']='MkdSZhrsxrU';
					templateObj['content']['videoSource']='YouTube';
					templateObj['content']['videoStart']='';
					templateObj['content']['videoStop']='';
					templateObj['content']['videoWidth']=800;
					templateObj['content']['url']="http://www.youtube.com/embed/MkdSZhrsxrU"
					templateObj['component_type_id']=12;
				}
				if (type=="3D Chart")
				{   
					templateObj['component_type_id']=13;
					
				}
				
				if (type=="Card")
				{   
					templateObj['component_type_id']=15;
					templateObj['content']['height']=250;
					templateObj['content']['width']=200;
					templateObj['content']['title']='Variable name';
					templateObj['content']['showTitle']=1;
					templateObj['content']['variable']='TempEq';
					templateObj['content']['showVariable']=2;
					templateObj['content']['description']='<p>Description of what is shown</p>';
					templateObj['content']['showDescription']=1;
					templateObj['content']['index']='0-0';
					templateObj['content']['value']=0;
					templateObj['content']['units']='';
					templateObj['content']['variableID']='';
					templateObj['content']['variableOrder']=0;
					templateObj['content']['showOrder']=1;
					templateObj['content']['backgroundColor']='#eeeeee';
					templateObj['content']['variableColor']='#607D8B';
					templateObj['content']['textColor']='#898989';
					templateObj['content']['variableSize']='32';
					templateObj['component_type_id']=15;
				}

				if (type=="Free Body Diagram")
				{   
					templateObj['component_type_id']=16;
					templateObj['content']['height']=500;
					templateObj['content']['width']=500;
					templateObj['content']['title']="Free Body Diagram";
					templateObj['content']['titleOnOff']=1;
					templateObj['content']['drawing']=[];
					templateObj['content']['moves']=[];
					templateObj['content']['needsUpdateFlag']=0;
					templateObj['component_type_id']=16;

				}


				if (type=="Requirement")
				{   
					templateObj['component_type_id']=17;
					templateObj['content']['text']="The component shall ...";
					templateObj['content']['title']="Requirement Title";
					templateObj['content']['parent']="";
					templateObj['content']['equation']="";
					templateObj['content']['category']="";

					templateObj['content']['reqValueTrueFalse']=false; 			// Whether or not there is a value associated with this requirement
					templateObj['content']['reqValueType']="equal";				// How the value is applied to the requirement - equal, greaterThan, etc
					templateObj['content']['reqValueEq']="";					// The equation whose value is used
					templateObj['content']['reqValue']="";						// The value to be used
					templateObj['content']['reqTolVal']="";						// The value of the tolerance for the requirements (equal only)
					templateObj['content']['reqTolType']="Percentage";			// The type of the tolerance for the requirement - percentage or absolute
					templateObj['content']['reqVariables']=[];					// An array of objects that are equations limited by this requirement
				}

				return templateObj

			},



			/*
			*
			*   FUNCTIONS RELATING TO MANIPULATING THE DOCUMENT
			*
			*   These functions alter the worksheet object in response to things like moving an item
			*
			*/

			changeLoc : function (type, currentItem, worksheetObj)
			{   var newLoc=0;
				var oldLoc=parseInt(currentItem['order']);
				if (type=='up'){	newLoc=oldLoc-1; }
				if (type=='down'){  newLoc=oldLoc+1; }
				if (type=="move"){  newLoc=parseInt(vm.cadwolfNewLoc); }	
				if (newLoc>oldLoc)
				{   
					for (var a=0; a<worksheetObj.length; a++)
					{   
						if ((worksheetObj[a]['order']>oldLoc)&&(worksheetObj[a]['order']<=newLoc))
						{   
							worksheetObj[a]['order']=worksheetObj[a]['order']-1;
							worksheetObj[a]['Page_lastposition']=worksheetObj[a]['Page_lastposition']-1;
							worksheetObj[a]['Page_position']=worksheetObj[a]['Page_position']-1;
						} 
					}
					
					for (var a=0; a<worksheetObj.length; a++)
					{ 
						if (currentItem['itemid']==worksheetObj[a]['itemid'])
						{ 
							worksheetObj[a]['order']=newLoc; 
							worksheetObj[a]['Page_position']=newLoc;
						} 
					}
				
				}else if (oldLoc>newLoc)
				{
					for (var a=0; a<worksheetObj.length; a++)
					{   
						if ((worksheetObj[a]['order']>=newLoc)&&(worksheetObj[a]['order']<oldLoc))
						{  
							worksheetObj[a]['order']=parseInt(worksheetObj[a]['order'])+1; 
							worksheetObj[a]['Page_lastposition']=worksheetObj[a]['Page_lastposition']+1;
							worksheetObj[a]['Page_position']=worksheetObj[a]['Page_position']+1;
						} 
					}
					
					for (var a=0; a<worksheetObj.length; a++)
					{ 
						if (currentItem['itemid']==worksheetObj[a]['itemid'])
						{ 
							worksheetObj[a]['order']=newLoc; 
							worksheetObj[a]['Page_position']=newLoc;
						} 
					}
				}

				return worksheetObj
				// AJAX call to change location on server
			},







			/*
			*
			*	FUNCTIONS RELATING TO SOLVING AN EQUATION
			*
			*	These functions are used to solve an equation. When an equation is solved in a web worker, the entire
			*	worksheet is not sent as this could be a waste. This function goes through the worksheet and places all
			*	of the equations or tables into a separate object that is then sent to the solver. No structures, no 
			*	plots, etc.
			*
			*/


			/*
			*
			*   GET AN ITEM BASED UPON ITS ID
			*
			*/
			getByID : function (thisID, worksheetObj)
			{   
				var returnItem={};
				for (var a=0; a<worksheetObj.length; a++)
				{
					if (worksheetObj[a]['itemid']==thisID) { returnItem=worksheetObj[a]; break }
				}

				return returnItem

			},


			/*
			*
			*   SET THE LAST POSITIONS FOR ALL STRUCTURES
			*
			*/
			getLastPos : function( worksheetObj ) 
			{
				for (var a=0; a<worksheetObj.length; a++)
				{   
					worksheetObj[a]['content']['Page_lastposition']=parseInt(worksheetObj[a]['order']); 
				}

				for (var a=0; a<worksheetObj.length; a++)
				{   
					if (worksheetObj[a]['content']['parentid']!="none")
					{   
						for (var b=0; b<worksheetObj.length; b++)
						{	
							if ( ( worksheetObj[a]['order'] > worksheetObj[b]['content']['Page_lastposition'] ) &&
								( worksheetObj[a]['content']['parentid'] == worksheetObj[b]['itemid'] ) )
							{
								worksheetObj[b]['content']['Page_lastposition'] = parseInt( worksheetObj[a]['order'] );
							}
						}
					}
				}

				for (var a=0; a<worksheetObj.length; a++)
				{
					if (worksheetObj[a]['content']['parentid']!="none")
					{ 
						this.setLastPos(worksheetObj[a]['content']['Page_lastposition'], worksheetObj[a]['content']['parentid'], worksheetObj); 
					}
				}

				return worksheetObj
			},

			setLastPos : function(thisLoc, parentID, worksheetObj) 
			{   
				for (var c=0; c<worksheetObj.length; c++)
				{   
					if (worksheetObj[c]['content']['itemid']==parentID)
					{   
						if (thisLoc > worksheetObj[c]['content']['Page_lastposition'])
						{   
							worksheetObj[c]['content']['Page_lastposition']=parseInt(thisLoc); 
						}
						if (worksheetObj[c]['content']['parentid']!="none") 
						{  
							this.setLastPos(worksheetObj[c]['content']['Page_lastposition'], worksheetObj[c]['content']['parentid'], worksheetObj); 
						}
				   }   
				}
				return worksheetObj

			},


			// Create the object that is to be sent to the solver
			createEqObj : function(eqID, worksheetObj, callback)	
			{	
				var sendObj={}, thisEq={}; 
				worksheetObj.forEach(function(thisItem, index){ if (eqID==thisItem['itemid']){ thisEq=thisItem; }   });
				worksheetObj.forEach(function(item, index)
				{   

					if ( thisEq['content']['Page_lastposition'] < thisEq['order'] )
					{
						thisEq['content']['Page_lastposition']=thisEq['order'];
					}

					if (thisEq['content']['Page_lastposition']===undefined){ thisEq['content']['Page_lastposition']=thisEq['order']; }
					
					if (worksheetObj[index]['content']['type']!==undefined)
					{   var type=worksheetObj[index]['type'];
						if (item['content']['Page_lastposition']===undefined){  item['content']['Page_lastposition']=item['order'];  }
						if (item['content']['Page_lastposition']<item['order']){  item['content']['Page_lastposition']=item['order'];  }
					}
					

					if ((item['component_type_id']=="3")&&(item['order'] <= parseInt(thisEq['content']['Page_lastposition'])))	
					{   sendObj[item['itemid']]={};
						sendObj[item['itemid']]['name']=item['content']['Equation']['Format_name'];
						sendObj[item['itemid']]['type']="equation";
						sendObj[item['itemid']]['component_type_id']=item['component_type_id'];
						sendObj[item['itemid']]['size']=item['content']['Equation']['Format_size'];
						sendObj[item['itemid']]['real']=item['content']['Equation']['Solution_real'];
						sendObj[item['itemid']]['imag']=item['content']['Equation']['Solution_imag'];
						sendObj[item['itemid']]['realdefault']=item['content']['Equation']['Solution_realdefault'];
						sendObj[item['itemid']]['imagdefault']=item['content']['Equation']['Solution_imagdefault'];
						sendObj[item['itemid']]['units']=item['content']['Equation']['Units_units'];
						sendObj[item['itemid']]['numinds']=item['content']['Equation']['Format_numinds'];
						sendObj[item['itemid']]['basearray']=item['content']['Equation']['Units_base_array'];
						sendObj[item['itemid']]['order']=item['order'];
						sendObj[item['itemid']]['Page_lastposition']=item['content']['Page_lastposition'];
						sendObj[item['itemid']]['equation']=item['content']['Equation']['Format_equation'];
						sendObj[item['itemid']]['newEquation']=item['content']['Equation']['newEquation'];
						sendObj[item['itemid']]['active']=item['content']['Equation']['active'];
						sendObj[item['itemid']]['parentid']=item['content']['parentid'];
						sendObj[item['itemid']]['topparentid']=item['content']['topparentid'];
						sendObj[item['itemid']]['ID']=item['itemid'];
						sendObj[item['itemid']]['Format_id']=item['itemid'];
						sendObj[item['itemid']]['fileid']=item['content']['fileid'];
						sendObj[item['itemid']]['component_type_id']=item['component_type_id'];
					}   
					if ((item['component_type_id']=="5")&&(item['order']<=parseInt(thisEq['content']['Page_lastposition'])))	
					{   sendObj[item['itemid']]={}; 
						sendObj[item['itemid']]['type']="table";
						sendObj[item['itemid']]['component_type_id']=item['component_type_id'];
						sendObj[item['itemid']]['order']=item['order'];	
						sendObj[item['itemid']]['Page_lastposition']=item['content']['Page_lastposition'];
						sendObj[item['itemid']]['data']=item['content']['data'];
					}   

					if (((item['component_type_id']=="6")||(item['component_type_id']=="7")||(item['component_type_id']=="8"))&&(item['order']<=parseInt(thisEq['content']['Page_lastposition'])))	
					{   sendObj[item['itemid']]={}; 
						sendObj[item['itemid']]['order']=item['order'];	
						sendObj[item['itemid']]['component_type_id']=item['component_type_id'];
						sendObj[item['itemid']]['Page_lastposition']=item['content']['Page_lastposition'];
						sendObj[item['itemid']]['ID']=item['itemid'];
						sendObj[item['itemid']]['fileid']=item['file_id'];
						sendObj[item['itemid']]['content']={}; 
						sendObj[item['itemid']]['content']['type']=item['content']['type'];
						sendObj[item['itemid']]['content']['topparentid']=item['content']['topparentid']===undefined ? "none" :  item['content']['topparentid'];
						sendObj[item['itemid']]['content']['parentid']=item['content']['parentid']===undefined ? "none" :  item['content']['parentid'];
						if (item['component_type_id']=="6")	{   sendObj[item['itemid']]['content']['forLoop']=item['content']['forLoop']; }   
						if (item['component_type_id']=="7")	{   sendObj[item['itemid']]['content']['whileLoop']=item['content']['whileLoop'];	}   
						if (item['component_type_id']=="8")	{   sendObj[item['itemid']]['content']['ifelse']=item['content']['ifelse'];   }   
						if (item['component_type_id']=="6") {   sendObj[item['itemid']]['type'] = 'forLoop'; }   
						if (item['component_type_id']=="7") {   sendObj[item['itemid']]['type'] = 'whileLoop';	}   
						if (item['component_type_id']=="8") {   sendObj[item['itemid']]['type'] = 'ifelse';   }   
					}


					if (((item['component_type_id']=="9")||(item['component_type_id']=="13"))&&(item['order']==parseInt(thisEq['order'])))
					{	sendObj[item['itemid']]={};	
						sendObj[item['itemid']]['itemid']=item['itemid'];
						sendObj[item['itemid']]['component_type_id']=item['component_type_id'];
						sendObj[item['itemid']]['name']=item['itemid'];
						sendObj[item['itemid']]['type']="plot";		
						sendObj[item['itemid']]['order']=item['order'];	
						sendObj[item['itemid']]['Page_lastposition']=item['content']['Page_lastposition'];
						sendObj[item['itemid']]['active']=1;	
						sendObj[item['itemid']]['topparentid']=item['topparentid']===undefined ? "none" :  item['content']['topparentid'];
						sendObj[item['itemid']]['parentid']=item['parentid']===undefined ? "none" :  item['content']['parentid'];
						sendObj[item['itemid']]['Dependents']={};	
						sendObj[item['itemid']]['ID']=item['Format_id'];	
					}		


				});
			
				
				return sendObj 

			},


			createSolveObj : function (thisItem, eqType, dataID, className)
			{

				var solveObj={
					"cadwolfType":eqType,   
					"eqID":thisItem['itemid'],
					"FileID":thisItem['content']['fileid'],
					"Location":thisItem['order'],
					"eqObj":thisItem['eqObj'],
					"ID":thisItem['itemid'],
					"order":thisItem['order']
				}
				if (eqType=="SolveEquation")
				{   solveObj["showValue"]=thisItem['content']['Equation']['Format_showvalue'] 
					solveObj['Equation']=thisItem['content']['Equation']['newEquation'];
				 
				}else if (eqType=="SolveTableCell")
				{   solveObj['Equation']=thisItem['content']['data'][thisItem['solveRow']][thisItem['solveCol']]['equation'].replace(/\#\./g,'#'+thisItem['itemid']);
					solveObj['tableID']=thisItem['itemid'];
					solveObj['tableRow']=thisItem['solveRow'];
					solveObj['tableCol']=thisItem['solveCol'];
					//console.log('Calling the equation solver for '+eqType+' for row and column '+thisItem['solveRow']+'-'+thisItem['solveCol']);

				}else if (eqType=="SolveTableFill")
				{   solveObj['tableID']=thisItem['itemid'];
					solveObj['tableRow']=thisItem['content']['currentRow'];
					solveObj['tableCol']=thisItem['content']['currentCol'];
					solveObj['fillType']=thisItem['content']['direction'];
					solveObj['numRows']=thisItem['content']['data'].length;
					solveObj['numCols']=thisItem['content']['data'][0].length;
					//console.log('Calling the equation solver for '+eqType+' starting with row and column '+thisItem['content']['currentRow']+'-'+thisItem['content']['currentCol']+' and going '+thisItem['content']['direction']+' for a total of '+thisItem['content']['data'].length+' rows and '+thisItem['content']['data'][0].length+' columns');

				}else if (eqType=="SolveLoopParameters")
				{   
					solveObj['loopObject']=thisItem;	
					solveObj['LoopID']=thisItem['itemid'];
					//console.log('Calling the equation solver for '+eqType+' for the loop '+thisItem['itemid']);			

				}else if (eqType=="SolveIfElseParameters")
				{   
					solveObj['loopObject']=thisItem;	
					solveObj['LoopID']=thisItem['itemid'];
					//console.log('Calling the equation solver for '+eqType+' for the statement '+thisItem['itemid']);   

				}else if (eqType=="SolveWhileLoopParameters")
				{   
					solveObj['loopObject']=thisItem;	
					solveObj['LoopID']=thisItem['itemid'];
					//console.log('Calling the equation solver for '+eqType+' for the loop '+thisItem['itemid']);   

				}else if (eqType=="SolveStructure")
				{   
					solveObj['firstrun']=1;
					//console.log('Calling the equation solver for '+eqType+' for the structure '+thisItem['itemid']);   

				}else if (eqType=="solvePlotData")
				{   solveObj['plotObject']=thisItem['content']['Plot'];
					solveObj['plotID']=thisItem['itemid'];
					solveObj['dataID']=dataID;
					thisItem['content']['Plot']['Chart_dataobj'].forEach(
						function(thisData, index){
							if (thisData['Format_id']==dataID)
							{   
								solveObj['className']=thisData['solveType'];
							}
						}
					);
					//console.log('Calling the equation solver for '+eqType+' for the plot '+thisItem['itemid']);   
				
				}else if ( eqType == "SolveSurfaceData") 
				{
					for (var b=0; b<thisItem['content']['Surface']['Chart_dataobj'].length; b++)
					{   
						if (thisItem['content']['Surface']['Chart_dataobj'][b]['Format_id']==dataID)
						{   
							thisItem['content']['Surface']['Chart_dataobj'][b]['surfaceGeometry']={}; 
//							thisItem['content']['Surface']['Chart_dataobj'][b]['xData']={}; 
//							thisItem['content']['Surface']['Chart_dataobj'][b]['yData']={}; 
//							thisItem['content']['Surface']['Chart_dataobj'][b]['zData']={}; 
							var axis = thisItem['content']['Surface']['Chart_dataobj'][b]['axisType']
							var type = thisItem['content']['Surface']['Chart_dataobj'][b]['type']
						}
					}

					solveObj['dataObject'] = thisItem['content']['Surface']['Chart_dataobj'];
					solveObj['content'] = thisItem['content']['Surface']['content'];
					solveObj['axis'] = axis;
					solveObj['PlotID'] = thisItem['itemid'];
					solveObj['DataID'] = dataID;
					solveObj['type'] = type;

				}   

 
				//console.log('Returning from solveObj creator');
				//console.log(solveObj);
				return solveObj	  
			 
			},



			eqReturn : function(returnObject, worksheetObj)
			{
				
				if (returnObject.messageType=="EquationResult") 
				{   worksheetObj.forEach(function(item, index)
					{   if (returnObject.id==item['itemid'])
						{   
							/* This should ensure that the show units set are retained as long as the quantities are the same */
							if (worksheetObj[index]['content']['Equation']['Units_quantity'] == returnObject.equation['Units_quantity'])
							{
								returnObject.equation['Units_showunits'] = worksheetObj[index]['content']['Equation']['Units_showunits'];
							}

							for (var objProp in returnObject.equation) 
							{
								if ((objProp!='Format_editinuse') &&
								   (objProp!='connected_ids'))
								{
									worksheetObj[index]['content']['Equation'][objProp]=returnObject.equation[objProp]; 
								}
							}
							worksheetObj[index]['content']['needsUpdateFlag']=0;
							worksheetObj[index]['content']['Equation']['inEdit']=0;
							worksheetObj[index]['content']['Name']=returnObject.equation['Format_name'];
							worksheetObj[index]['name']=returnObject.equation['Format_name'];
							worksheetObj[index]['content']['Equation']['Dependents']=returnObject.Deps;

							var sizes=worksheetObj[index]['content']['Equation']['Format_size'].split('x');
							if ((parseFloat(sizes[0])*parseFloat(sizes[1]))<50 && sizes[1]<8)
							{
								worksheetObj[index]['content']['Equation']['Format_showvalue'] = 'value';   								
							}else
							{
								worksheetObj[index]['content']['Equation']['Format_showvalue'] = 'size';   
							}
							/*
							if (worksheetObj[index]['content']['Equation']['Format_size'] == '1x1')
							{
								worksheetObj[index]['content']['Equation']['Format_showvalue'] = 'value';   
							}else{
								worksheetObj[index]['content']['Equation']['Format_showvalue'] = 'size';								   
							}
							*/

						}
					});
				}   
				if (returnObject.messageType=="TableCellResult")		
				{   worksheetObj.forEach(function(item, index)
					{   if (returnObject['Equation']['tableID']==item['itemid'])
						{   item['content']['data'][returnObject['Equation']['tableRow']][returnObject['Equation']['tableCol']]['needsUpdateFlag']=0;
							item['content']['data'][returnObject['Equation']['tableRow']][returnObject['Equation']['tableCol']]['real']=returnObject['Equation']['Solution_real']['0-0'];
							if (returnObject['Equation']['Solution_imag']['0-0']===undefined)
							{	   item['content']['data'][returnObject['Equation']['tableRow']][returnObject['Equation']['tableCol']]['imag']=0;
							}else{  item['content']['data'][returnObject['Equation']['tableRow']][returnObject['Equation']['tableCol']]['imag']=returnObject['Equation']['Solution_imag']['0-0']; }
							item['content']['data'][returnObject['Equation']['tableRow']][returnObject['Equation']['tableCol']]['units']=returnObject['Equation']['Units_units'];
							item['content']['data'][returnObject['Equation']['tableRow']][returnObject['Equation']['tableCol']]['Deps']=returnObject['Deps'];
							var returnID=returnObject['Equation']['tableID']+'.'+String.fromCharCode(65+returnObject['Equation']['tableCol'])+'.'+returnObject['Equation']['tableRow'];
							if (returnObject['Equation']['Errors_flag']==1)
							{   item['content']['data'][returnObject['Equation']['tableRow']][returnObject['Equation']['tableCol']]['real']=returnObject['Equation']['Format_showequation']; }
						}
					});
				}
				if (returnObject.messageType=="FullTable")	  
				{   for (var a=0; a<returnObject.tableData.length; a++)
					{   for (var b=0; b<returnObject.tableData[0].length; b++)
						{   
							//console.log('The solution at '+a+'-'+b+' is '+returnObject.tableData[a][b]['real']);
							if (returnObject.tableData[a][b]['imag']==''){ returnObject.tableData[a][b]['imag']=0; } 
							if (typeof(returnObject.tableData[a][b]['units'])=='object'){ returnObject.tableData[a][b]['units']=''; } 
							if (returnObject.tableData[a][b]['needsUpdateFlag']==1)
							{   returnObject.tableData[a][b]['needsUpdateFlag']=0; 
								worksheetObj = this.setDependentsOn(returnObject.tableID+'.'+String.fromCharCode(65+b)+'.'+a, 0, worksheetObj);
							}
						}
					}
					worksheetObj.forEach(function(item, index)
					{   if (returnObject['tableID']==item['itemid']){   item['content']['data']=returnObject['tableData'];	}
					});
				}
				if (returnObject.messageType=="LoopParametersResult")	   
				{   worksheetObj.forEach(function(item, index)
					{   if (returnObject.ID==item['itemid'])
						{   worksheetObj[index]['content']['needsBlockUpdate']=0;
							worksheetObj[index]['content']['forLoop']['Dependents']=returnObject['loopObject']['Dependents'];
							worksheetObj[index]['content']['forLoop']['start']=returnObject['loopObject']['content']['forLoop']['start'];
							worksheetObj[index]['content']['forLoop']['stop']=returnObject['loopObject']['content']['forLoop']['stop'];
							worksheetObj[index]['content']['forLoop']['increment']=returnObject['loopObject']['content']['forLoop']['increment'];
							worksheetObj[index]['content']['forLoop']['numsteps']=returnObject['loopObject']['content']['forLoop']['numsteps'];
						}
					});
				}
				if (returnObject.messageType=="WhileLoopParametersResult")  
				{   worksheetObj.forEach(function(item, index)
					{   if (returnObject.ID==item['itemid'])
						{   worksheetObj[index]['content']['needsBlockUpdate']=0;
							worksheetObj[index]['content']['whileLoop']['Dependents']=returnObject['loopObject']['content']['whileLoop']['Dependents'];
							worksheetObj[index]['content']['whileLoop']['Loop_Values']=returnObject['loopObject']['content']['whileLoop']['Loop_Values'];
							worksheetObj[index]['content']['whileLoop']['Loop_String']=returnObject['loopObject']['content']['whileLoop']['Loop_String'];
							worksheetObj[index]['content']['whileLoop']['Loop_TFString']=returnObject['loopObject']['content']['whileLoop']['Loop_TFString'];
							worksheetObj[index]['content']['whileLoop']['ValueString']=returnObject['loopObject']['content']['whileLoop']['Loop_ValueString'];
							worksheetObj[index]['content']['whileLoop']['Loop_truefalse']=returnObject['loopObject']['content']['whileLoop']['Loop_truefalse'];   
							for (var a=0; a<worksheetObj[index]['content']['whileLoop']['statementBlock'].length; a++)
							{   for (var b=0; b<worksheetObj[index]['content']['whileLoop']['statementBlock'][a].length; b++)
								{   
									//console.log('The a and b are '+a+' and '+b);
									//console.log('The results are '+worksheetObj[index]['content']['whileLoop']['statementBlock'][a][b]['truefalse']+' and '+returnObject['loopObject']['content']['whileLoop']['statementBlock'][a][b]['truefalse']);
									worksheetObj[index]['content']['whileLoop']['statementBlock'][a][b]['truefalse']=returnObject['loopObject']['content']['whileLoop']['statementBlock'][a][b]['truefalse'];
									worksheetObj[index]['content']['whileLoop']['statementBlock'][a][b]['flagValue']=returnObject['loopObject']['content']['whileLoop']['statementBlock'][a][b]['flagValue'];
									worksheetObj[index]['content']['whileLoop']['statementBlock'][a][b]['dependentValue']=returnObject['loopObject']['content']['whileLoop']['statementBlock'][a][b]['dependentValue'];
									if (worksheetObj[index]['content']['whileLoop']['statementBlock'][a][b]['truefalse']==true)
									{   worksheetObj[index]['content']['whileLoop']['statementBlock'][a][b]['showClass']="truestatements";
									}else
									{   worksheetObj[index]['content']['whileLoop']['statementBlock'][a][b]['showClass']="falsestatements"; }
								}
							}
						}
					});
				}
				if (returnObject.messageType=="IfElseParametersResult")	 
				{   worksheetObj.forEach(function(item, index)
					{   if (returnObject.ID==item['itemid'])
						{   worksheetObj[index]['content']['needsBlockUpdate']=0;
							worksheetObj[index]['content']['ifelse']['Dependents']=returnObject['loopObject']['content']['ifelse']['Dependents'];
							worksheetObj[index]['content']['ifelse']['Statement_Values']=returnObject['loopObject']['content']['ifelse']['Statement_Values'];
							worksheetObj[index]['content']['ifelse']['Statement_String']=returnObject['loopObject']['content']['ifelse']['Statement_String'];
							worksheetObj[index]['content']['ifelse']['Statement_TFString']=returnObject['loopObject']['content']['ifelse']['Statement_TFString'];
							worksheetObj[index]['content']['ifelse']['ValueString']=returnObject['loopObject']['content']['ifelse']['Statement_ValueString'];
							worksheetObj[index]['content']['ifelse']['Statement_truefalse']=returnObject['loopObject']['content']['ifelse']['Statement_truefalse'];   
							for (var a=0; a<worksheetObj[index]['content']['ifelse']['statementBlock'].length; a++)
							{   for (var b=0; b<worksheetObj[index]['content']['ifelse']['statementBlock'][a].length; b++)
								{   worksheetObj[index]['content']['ifelse']['statementBlock'][a][b]['truefalse']=returnObject['loopObject']['content']['ifelse']['statementBlock'][a][b]['truefalse'];
									worksheetObj[index]['content']['ifelse']['statementBlock'][a][b]['flagValue']=returnObject['loopObject']['content']['ifelse']['statementBlock'][a][b]['flagValue'];
									worksheetObj[index]['content']['ifelse']['statementBlock'][a][b]['dependentValue']=returnObject['loopObject']['content']['ifelse']['statementBlock'][a][b]['dependentValue'];
									if (worksheetObj[index]['content']['ifelse']['statementBlock'][a][b]['truefalse']==true)
									{   worksheetObj[index]['content']['ifelse']['statementBlock'][a][b]['showClass']="truestatements";
									}else
									{   worksheetObj[index]['content']['ifelse']['statementBlock'][a][b]['showClass']="falsestatements"; }
								}
							}
							for (var a=0; a<returnObject['loopObject']['content']['ifelse']['Statement_Order'].length; a++)
							{   var thisID=returnObject['loopObject']['content']['ifelse']['Statement_Order'][a]['ID'];
								worksheetObj.forEach(function(thisItem, thisIndex)
								{   if (worksheetObj[thisIndex]['itemid']==thisID)
									{   worksheetObj[thisIndex]['content']['ifelse']['Statement_Execute']=returnObject['loopObject']['content']['ifelse']['Statement_Order'][a]['Execute']; }
								});
							}
						}
					});
				}
				if (returnObject.messageType=="StructureResult")		
				{   
					worksheetObj.forEach(function(item, index)
					{   
						if (returnObject.ID==item['itemid'])
						{   worksheetObj[index]['content']['needsBlockUpdate']=0;
							if ( worksheetObj[index]['component_type_id'] == 6 )
							{
								worksheetObj[index]['content']['forLoop']['needsUpdateFlag']=0; 
							}
							if ( worksheetObj[index]['component_type_id'] == 7 )
							{
								worksheetObj[index]['content']['whileLoop']['needsUpdateFlag']=0; 
							}
							if ( worksheetObj[index]['component_type_id'] == 8 )
							{
								worksheetObj[index]['content']['ifelse']['needsUpdateFlag']=0; 
							}
							worksheetObj[index]['content']['updateClass']='itemcurrent';   
						}
					});
					
					for (var returnItem in returnObject.structure)
					{   
						worksheetObj.forEach(function(item, index)
						{   
							if ( ( returnItem == item['itemid']) && ( parseInt(item['component_type_id'] ) == 3 ) )
							{   
								for (objProp in returnObject['structure'][returnItem]['equationObj']) 
								{   
									// console.log('setting '+objProp+' to '+returnObject['structure'][returnItem]['equationObj'][objProp]);
									item['content']['Equation'][objProp]=returnObject['structure'][returnItem]['equationObj'][objProp]; 
								} 
								item['content']['Equation']['showEdit']=false;
								worksheetObj[index]['content']['Equation']['Dependents']=returnObject['structure'][returnItem]['Deps'];
//									worksheetObj = findDependents(item['itemid']);
								item['name'] = returnObject['structure'][returnItem]['equationObj']['Format_name'];
								item['content']['Name'] = returnObject['structure'][returnItem]['equationObj']['Format_name'];
							}

							if ( ( returnItem == item['itemid']) && ( parseInt(item['component_type_id'] ) == 6 ) )
							{   
								worksheetObj[index]['content']['updateClass']='itemcurrent';   
							}

						});
					}
				}

				if (returnObject.messageType=="PlotDataResults")	
				{   
					if ( returnObject.eventErrorFlag != 1 )
					if (returnObject.className=="all")			  
					{   
						for (var a=0; a<worksheetObj.length; a++)
						{   if (worksheetObj[a]['itemid']==returnObject.plotID)
							{   
								for (var objProp in returnObject.plotObj) 
								{ 
									worksheetObj[a]['content']['Plot'][objProp]=returnObject.plotObj[objProp]; 
								}   
								
								for (var returnDataset in returnObject['Dependents'])
								{
									for (var returnData in returnObject['Dependents'][returnDataset])
									{   
										var thisAxis = returnObject['Dependents'][returnDataset][returnData]['axis'];
										for (var existingDataset in worksheetObj[a]['content']['Plot']['Dependents'])
										{
											if ( returnDataset == existingDataset )
											{
												for (var thisData in worksheetObj[a]['content']['Plot']['Dependents'][existingDataset] )
												{
													if ( worksheetObj[a]['content']['Plot']['Dependents'][existingDataset][thisData]['axis'] == thisAxis )
													{
														delete worksheetObj[a]['content']['Plot']['Dependents'][existingDataset][thisData];
													}
												}
											}
										}

										if ( worksheetObj[a]['content']['Plot']['Dependents'] === undefined )
										{
											worksheetObj[a]['content']['Plot']['Dependents'] = {};
										}
										if ( worksheetObj[a]['content']['Plot']['Dependents'][returnDataset] === undefined )
										{
											worksheetObj[a]['content']['Plot']['Dependents'][returnDataset] = {};
										}
										worksheetObj[a]['content']['Plot']['Dependents'][returnDataset][returnData] = JSON.parse(JSON.stringify(returnObject['Dependents'][returnDataset][returnData]));
									}
								}


								// worksheetObj[a]['content']['Plot']['Dependents']=returnObject.Dependents;
								worksheetObj[a]['content']['Plot']['needsUpdateFlag']=1;
//								for (var datasetIndex in worksheetObj[a]['content']['Plot']['Chart_dataobj'])
//								{   if (worksheetObj[a]['content']['Plot']['Chart_dataobj'][datasetIndex]['Format_id']==$scope.datasetID)
//									{   vm.currentDataset=worksheetObj[a]['content']['Plot']['Chart_dataobj'][datasetIndex]; } }
							}
						}
					}else											   
					{   for (var a=0; a<worksheetObj.length; a++)
						{   if (worksheetObj[a]['itemid']==returnObject.PlotID)
							{   for (var objProp in returnObject.plotObj) { worksheetObj[a]['content']['Plot'][objProp]=returnObject.plotObj[objProp]; }
								if (worksheetObj[a]['content']['Plot']['Dependents']===undefined){ worksheetObj[a]['content']['Plot']['Dependents']={}; }
								for (var DepDataID in returnObject.Dependents)
								{   if (worksheetObj[a]['content']['Plot']['Dependents'][DepDataID]===undefined) { worksheetObj[a]['content']['Plot']['Dependents'][DepDataID]={}; }
									for (var DataID in worksheetObj[a]['content']['Plot']['Dependents'])		   
									{   if (DepDataID==DataID)			  
										{   for (var eqID in returnObject.Dependents[DepDataID]){ var axis=returnObject.Dependents[DepDataID][eqID]['axis']; }  
											for (var eqID in worksheetObj[a]['content']['Plot']['Dependents'][DataID])
											{   if(axis==worksheetObj[a]['content']['Plot']['Dependents'][DataID][eqID]['axis']) { delete worksheetObj[a]['content']['Plot']['Dependents'][DataID][eqID]; } }
											for (var eqID in returnObject.Dependents[DepDataID])	
											{   worksheetObj[a]['content']['Plot']['Dependents'][DataID][eqID]={};	 
												worksheetObj[a]['content']['Plot']['Dependents'][DataID][eqID]['active']=1;			
												worksheetObj[a]['content']['Plot']['Dependents'][DataID][eqID]['axis']=returnObject.Dependents[DepDataID][eqID]['axis']; 
								}   }   }   }							   
								worksheetObj[a]['content']['Plot']['needsUpdateFlag']=1
//								for (var datasetIndex in worksheetObj[a]['content']['Plot']['Chart_dataobj'])
//								{   if (worksheetObj[a]['content']['Plot']['Chart_dataobj'][datasetIndex]['Format_id']==$scope.datasetID)
//									{   vm.currentDataset=worksheetObj[a]['content']['Plot']['Chart_dataobj'][datasetIndex]; } }
							}
						}
					}											   
				}												   

				if (returnObject.messageType=="SurfaceData")	
				{
					var xMax=-99999999, xMin=999999999, yMax=-99999999, yMin=999999999, zMax=-99999999, zMin=999999999, cMax=-99999999, cMin=999999999;	 
					worksheetObj.forEach(function(item, index)
					{   
						if (item.itemid==returnObject['PlotID'])
						{   
							for (var dataIndex=0; dataIndex<returnObject['dataObject'].length; dataIndex++)
							{   
								if (returnObject['dataObject'][dataIndex]['Format_id']==returnObject['DataID'])
								{ 
									var returnIndex=dataIndex; 
								} 
							}
				 
							for (var dataIndex=0; dataIndex<item['content']['Surface']['Chart_dataobj'].length; dataIndex++)
							{   
								if (item['content']['Surface']['Chart_dataobj'][dataIndex]['Format_id']==returnObject['DataID'])
								{   
//									item['content']['Surface']['content']=JSON.parse(JSON.stringify(returnObject['content']));				 
									item['content']['Surface']['Chart_dataobj'][dataIndex]['xMax']=JSON.parse(JSON.stringify(returnObject['dataObject'][returnIndex]['xMax']));
									item['content']['Surface']['Chart_dataobj'][dataIndex]['xMin']=JSON.parse(JSON.stringify(returnObject['dataObject'][returnIndex]['xMin']));
									item['content']['Surface']['Chart_dataobj'][dataIndex]['yMax']=JSON.parse(JSON.stringify(returnObject['dataObject'][returnIndex]['yMax']));
									item['content']['Surface']['Chart_dataobj'][dataIndex]['yMin']=JSON.parse(JSON.stringify(returnObject['dataObject'][returnIndex]['yMin']));
									item['content']['Surface']['Chart_dataobj'][dataIndex]['zMax']=JSON.parse(JSON.stringify(returnObject['dataObject'][returnIndex]['zMax']));
									item['content']['Surface']['Chart_dataobj'][dataIndex]['zMin']=JSON.parse(JSON.stringify(returnObject['dataObject'][returnIndex]['zMin']));
									item['content']['Surface']['Chart_dataobj'][dataIndex]['cMax']=JSON.parse(JSON.stringify(returnObject['dataObject'][returnIndex]['cMax']));
									item['content']['Surface']['Chart_dataobj'][dataIndex]['cMin']=JSON.parse(JSON.stringify(returnObject['dataObject'][returnIndex]['cMin']));
									item['content']['Surface']['Chart_dataobj'][dataIndex]['xData']=JSON.parse(JSON.stringify(returnObject['dataObject'][returnIndex]['xData']));
									item['content']['Surface']['Chart_dataobj'][dataIndex]['yData']=JSON.parse(JSON.stringify(returnObject['dataObject'][returnIndex]['yData']));
									item['content']['Surface']['Chart_dataobj'][dataIndex]['zData']=JSON.parse(JSON.stringify(returnObject['dataObject'][returnIndex]['zData']));
									item['content']['Surface']['Chart_dataobj'][dataIndex]['cData']=JSON.parse(JSON.stringify(returnObject['dataObject'][returnIndex]['cData']));
									if ((returnObject['type']=="Surface")||(returnObject['type']=="PointCloud"))
									{   item['content']['Surface']['Chart_dataobj'][dataIndex]['xLength']=returnObject['dataObject'][returnIndex]['xLength'];
										item['content']['Surface']['Chart_dataobj'][dataIndex]['yLength']=returnObject['dataObject'][returnIndex]['yLength'];

									}else if (returnObject['type']=="Line") 
									{   
										// item['content']['Surface']['Chart_dataobj'][dataIndex]['lineGeometry']=JSON.parse(JSON.stringify(returnObject['dataObject'][returnIndex]['lineGeometry']));

									}else if (returnObject['type']=="Lathe")
									{   
										item['content']['Surface']['Chart_dataobj'][dataIndex]['xLength']=returnObject['dataObject'][returnIndex]['xLength'];
										item['content']['Surface']['Chart_dataobj'][dataIndex]['yLength']=returnObject['dataObject'][returnIndex]['yLength'];
										item['content']['Surface'].formatLatheData(returnObject['PlotID'], returnObject['DataID']);
									}
								}
							}
						}
					});
				}

				return worksheetObj
			},



			// Populate the equations properties with the dependent values shown in the specs view
			populateDeps : function (eqID, worksheetObj) 
			{   worksheetObj.forEach(function(item, index)
				{   if ((eqID==item['itemid'])&&(item['component_type_id']!=5))
					{   worksheetObj[index]['content']['Equation']['DepItem1']=[];
						worksheetObj[index]['content']['Equation']['DepItem2']=[];
						for (var depID in item['content']['Equation']['Dependents']) 
						{   worksheetObj.forEach(function(thisItem, thisIndex)
							{   if (depID==worksheetObj[thisIndex]['itemid'])
								{	worksheetObj[index]['content']['Equation']['DepItem1'].push({name:worksheetObj[thisIndex]['content']['Equation']['Format_name'], id:depID});   }
							});
						}
						worksheetObj.forEach(function(thisItem, thisIndex)
						{   if (thisItem['component_type_id']=='3')
							{   for (var depID in thisItem['content']['Equation']['Dependents']) 
								{   if (depID==worksheetObj[index]['itemid'])
									{	worksheetObj[index]['content']['Equation']['DepItem2'].push({name:worksheetObj[thisIndex]['content']['Equation']['Format_name'], id:depID});   }
								}
							}
						});
					}   
				});
				
				return worksheetObj

			},



			// Set the dependents of an equation to on
			setDependentsOn : function (itemID, startLoc, worksheetObj)	
			{   
				console.log('Turning on the dependents of '+itemID);

				//for (var a=parseInt(startLoc)+1; a<worksheetObj.length; a++)
				// This had to be changed because when the worksheet is solved in the part tree, only the equations and the 
				// tables and loops are downloaded, so the array isn't the same length.
				for (var a=0; a<worksheetObj.length; a++)
				{   
					if (worksheetObj[a]['component_type_id']=='3')
					{   for (var depID in worksheetObj[a]['content']['Equation']['Dependents'])
						{   
							if (depID==itemID) {  worksheetObj[a]['content']['needsUpdateFlag']=1;  
													//console.log('Flagged '+worksheetObj[a]['itemid']+' as a dependent');
												}
						}
					}
					if (worksheetObj[a]['component_type_id']=='5')
					{   for (var b=0; b<worksheetObj[a]['content']['data'].length; b++)
						{   for (var c=0; c<worksheetObj[a]['content']['data'][0].length; c++)
							{   for (var depID in worksheetObj[a]['content']['data'][b][c]['Deps'])
								{   if (depID==itemID) {  worksheetObj[a]['content']['data'][b][c]['needsUpdateFlag']=1;   }
								}
							} 
						}
					}

					if (worksheetObj[a]['component_type_id']=='6')
					{   for (var depID in worksheetObj[a]['content']['forLoop']['Dependents'])
						{   if (depID==itemID) 
							{  
								worksheetObj[a]['content']['needsBlockUpdate']=1;  
								//console.log('Flagged '+worksheetObj[a]['itemid']+' as a dependent');
							}
						}
					}

					if (worksheetObj[a]['component_type_id']=='7')
					{   for (var depID in worksheetObj[a]['content']['whileLoop']['Dependents'])
						{   if (depID==itemID) 
							{  
								worksheetObj[a]['content']['needsBlockUpdate']=1;  
								//console.log('Flagged '+worksheetObj[a]['itemid']+' as a dependent');
							}
						}
					}

					if (worksheetObj[a]['component_type_id']=='8')
					{   for (var depID in worksheetObj[a]['content']['ifelse']['Dependents'])
						{   if (depID==itemID) 
							{  
								worksheetObj[a]['content']['needsBlockUpdate']=1;  
								//console.log('Flagged '+worksheetObj[a]['itemid']+' as a dependent');
							}
						}
					}

					if (worksheetObj[a]['component_type_id']=='9')
					{   for (var thisDataset in worksheetObj[a]['content']['Plot']['Dependents'])
						{   for (var thisDep in worksheetObj[a]['content']['Plot']['Dependents'][thisDataset])
							{   
								if (thisDep==itemID) 
								{   for (var b=0; b<worksheetObj[a]['content']['Plot']['Chart_dataobj'].length; b++)
									{   
										if (worksheetObj[a]['content']['Plot']['Chart_dataobj'][b]['Format_id']==thisDataset)
										{
											worksheetObj[a]['content']['Plot']['Chart_dataobj'][b]['needsUpdateFlag'] = 1; 
											worksheetObj[a]['content']['Plot']['needsUpdateFlag'] = 1;
										} 
									}
								}
							} 
						}
					}
					if (worksheetObj[a]['component_type_id']=='13')
					{   for (var thisDataset in worksheetObj[a]['content']['Surface']['Dependents'])
						{   for (var thisDep in worksheetObj[a]['content']['Surface']['Dependents'][thisDataset])
							{   
								if (thisDep==itemID) 
								{   for (var b=0; b<worksheetObj[a]['content']['Surface']['Chart_dataobj'].length; b++)
									{   if (worksheetObj[a]['content']['Surface']['Chart_dataobj'][b]['Format_id']==thisDataset['Format_id'])
										{ worksheetObj[a]['content']['Surface']['Chart_dataobj'][b]['needsUpdateFlag']=1; } 
									}
								}
							} 
						}
					}
					if (worksheetObj[a]['component_type_id']=='16')
					{   

						// Loop to get name of item whose dependents are being updated
						for (var b=0; b<worksheetObj.length; b++)
						{   
							if ( ( worksheetObj[b]['itemid']==itemID ) && ( worksheetObj[b]['component_type_id']=='3' ) )
							{
								var testName=worksheetObj[b]['name'];

								worksheetObj[a]['content']['drawing'].forEach(
									function(thisDraw, index){

										var re = new RegExp('#'+testName, 'g');
										if ( thisDraw.drawType == 'text' )
										{
											if ( thisDraw.text.match( re ) )
											{
												worksheetObj[a]['content']['needsUpdateFlag']=1;
											}
										}else
										{
											if ( thisDraw.x1+''.match( re ) ||
												 thisDraw.y1+''.match( re ) ||
												 thisDraw.x2+''.match( re ) ||
												 thisDraw.y2+''.match( re ) ||
												 thisDraw.x3+''.match( re ) ||
												 thisDraw.y3+''.match( re ) ||
												 thisDraw.x4+''.match( re ) ||
												 thisDraw.y4+''.match( re ) || 
												 thisDraw.x5+''.match( re ) ||
												 thisDraw.y5+''.match( re ) ||
												 thisDraw.x6+''.match( re ) ||
												 thisDraw.y6+''.match( re ) ||
												 thisDraw.startAngle+''.match( re) ||
												 thisDraw.endAngle+''.match(re) ||
												 thisDraw.arcRadius+''.match(re) ||
												 thisDraw.colorStops+''.match(re) ||
												 thisDraw.arrowHeadHeight+''.match(re) ||
												 thisDraw.arrowHeadWidth+''.match(re))
											{
												worksheetObj[a]['content']['needsUpdateFlag']=1;
											}
										}
									}
								);
							}
						}
					}
				}
				return worksheetObj
			},



			// Find start the process to update dependents
			findDependents : function (itemID, tableFlag, worksheetObj)  
			{   
				//console.log('Finding the dependents of '+itemID);
				var thisLoc=0, thisName='';
				for (var a=0; a<worksheetObj.length; a++)
				{   
					if (itemID==worksheetObj[a]['itemid'])
					{   
						thisLoc=worksheetObj[a]['order'];
						thisName=worksheetObj[a]['content']['Equation']['Format_name'];
					}
				}
				//console.log('Finding the dependents of '+thisName+' at '+thisLoc);
				worksheetObj = this.setDependentsOn(itemID, thisLoc, worksheetObj);
				for (var a=thisLoc; a>=0; a--)
				{   
					if ( worksheetObj[a] !== undefined )
					{
						if ( worksheetObj[a]['component_type_id'] == '3' )
						{   if ( thisName == worksheetObj[a]['content']['Equation']['Format_name'])
							{   
								worksheetObj = this.setDependentsOn(worksheetObj[a]['itemid'], thisLoc, worksheetObj); 
							}
						}
					}
				}
				
				return worksheetObj
			},


			fillTable : function (tableObj, direction)   
			{   //console.log('The tableid is '+tableObj['itemid']+' and the direction is '+direction);
				
				if (tableObj['content']['data'][parseInt(tableObj.content.currentRow)][parseInt(tableObj.content.currentCol)]['equation'].match(/^=/)==null)
				{   
					var thisEquation=tableObj['content']['data'][parseInt(tableObj.content.currentRow)][parseInt(tableObj.content.currentCol)]['equation'];
					var thisReal=tableObj['content']['data'][parseInt(tableObj.content.currentRow)][parseInt(tableObj.content.currentCol)]['real'];
					var thisImag=tableObj['content']['data'][parseInt(tableObj.content.currentRow)][parseInt(tableObj.content.currentCol)]['imag'];
					var thisUnits=tableObj['content']['data'][parseInt(tableObj.content.currentRow)][parseInt(tableObj.content.currentCol)]['units'];
					if (direction=="up")
					{   for (var row=0; row<tableObj.content.currentRow; row++)
						{   tableObj['content']['data'][row][parseInt(tableObj.content.currentCol)]['equation']=thisEquation;  
							tableObj['content']['data'][row][parseInt(tableObj.content.currentCol)]['real']=thisReal;  
							tableObj['content']['data'][row][parseInt(tableObj.content.currentCol)]['imag']=thisImag;  
							tableObj['content']['data'][row][parseInt(tableObj.content.currentCol)]['units']=thisUnits;  
						}	
					}
					if (direction=="down")
					{   for (var row=tableObj.content.currentRow; row<tableObj.content.data.length; row++)
						{   tableObj['content']['data'][row][parseInt(tableObj.content.currentCol)]['equation']=thisEquation;  
							tableObj['content']['data'][row][parseInt(tableObj.content.currentCol)]['real']=thisReal;  
							tableObj['content']['data'][row][parseInt(tableObj.content.currentCol)]['imag']=thisImag;  
							tableObj['content']['data'][row][parseInt(tableObj.content.currentCol)]['units']=thisUnits;  
						}	
					}
					if (direction=="left")
					{   for (var col=0; col<tableObj.content.currentCol; col++)
						{   tableObj['content']['data'][parseInt(tableObj.content.currentRow)][col]['equation']=thisEquation;  
							tableObj['content']['data'][parseInt(tableObj.content.currentRow)][col]['real']=thisReal;  
							tableObj['content']['data'][parseInt(tableObj.content.currentRow)][col]['imag']=thisImag;  
							tableObj['content']['data'][parseInt(tableObj.content.currentRow)][col]['units']=thisUnits;  
						}	
					}
					if (direction=="right")
					{   for (var col=tableObj.content.currentCol; col<tableObj.content.data[0].length; col++)
						{   tableObj['content']['data'][parseInt(tableObj.content.currentRow)][col]['equation']=thisEquation;  
							tableObj['content']['data'][parseInt(tableObj.content.currentRow)][col]['real']=thisReal;  
							tableObj['content']['data'][parseInt(tableObj.content.currentRow)][col]['imag']=thisImag;  
							tableObj['content']['data'][parseInt(tableObj.content.currentRow)][col]['units']=thisUnits;  
						}	
					}
				}

				return tableObj
			},	 


			dynamicSort : function(property) 
			{   var sortOrder = 1;
				if(property[0] === "-") {
					sortOrder = -1;
					property = property.substr(1);
				}
				return function (a,b) 
				{   var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0; 
					return result * sortOrder;
				}
			},


			/*
			*
			*
			*   FUNCTIONS RELATING TO CREATING A SHOW SOLUTION
			*
			*   
			*
			*/

			createShowSolution : function( eqObj, scaleUnits ) 
			{

				var showSolution = '';

				// Molecules was added to the base array late, so we check it here
				if ( eqObj.content.Equation.Units_base_array['molecules'] === undefined )
				{
					eqObj.content.Equation.Units_base_array['molecules']=0;
				}

				if ( eqObj.content.Equation.Errors_flag == 0 )
				{

					/* This is to patch up the old equations that do not have the show object */
					if ( eqObj.content.Equation.Units_showObject === undefined )
					{
						eqObj.content.Equation.Units_showObject={'A':'A', 'K':'K', 's':'s', 'm':'m', 'kg':'kg', 'cd':'cd', 'mol':'mol', 'molecules': 'molecules', 'rad':'rad'}; 
					}

					var scaleFactor=1;
					var numer = '';
					var denom = '';

					/* If the quantity is known to be pressure, force, or Moment/Energy, scale by this single factor */
					if ( eqObj.content.Equation.Units_base_string == '00-211000' || 		// Force
						 eqObj.content.Equation.Units_base_string == '00-221000' || 		// Moment, torque, or energy
						 eqObj.content.Equation.Units_base_string == '00-321000' ||			// Watts
						 eqObj.content.Equation.Units_base_string == '00-2-11000' || 		// Pressure
						 eqObj.content.Equation.Units_base_string == '-10-321000' || 		// Volts
						 eqObj.content.Equation.Units_base_string == '-20-321000' || 		// Ohms
						 eqObj.content.Equation.Units_base_string == '-10-221000' || 		// Weber
						 eqObj.content.Equation.Units_base_string == '204-2-1000' || 		// Farad
						 eqObj.content.Equation.Units_base_string == '10100000' || 			// Coulomb
						 eqObj.content.Equation.Units_base_string == '-10-201000' || 		// Tesla
						 eqObj.content.Equation.Units_base_string == '00-120000') 			// Stokes
					{
						if ( eqObj.content.Equation.Units_units != eqObj.content.Equation.Units_showunits )
						{
							scaleUnits.forEach(function(thisItem, index)
							{
								if (thisItem['unit'] == eqObj.content.Equation.Units_showunits)
								{
									scaleFactor = Big(1).div(Big(thisItem['conv_factor']));
								}
							});
						}
					}



					/* If the quantity is not as complex, scale by each quantity */
					if ( eqObj.content.Equation.Units_base_string != '00-211000' && 		// Force
						 eqObj.content.Equation.Units_base_string != '00-221000' && 		// Moment, torque, or energy
						 eqObj.content.Equation.Units_base_string != '00-321000' && 		// Watts
						 eqObj.content.Equation.Units_base_string != '00-2-11000' &&		// Pressure
						 eqObj.content.Equation.Units_base_string != '-10-321000' && 		// Volts
						 eqObj.content.Equation.Units_base_string != '-20-321000' && 		// Ohms
						 eqObj.content.Equation.Units_base_string != '-10-221000' && 		// Weber
						 eqObj.content.Equation.Units_base_string != '204-2-1000' && 		// Farad
						 eqObj.content.Equation.Units_base_string != '10100000' && 			// Coulomb
						 eqObj.content.Equation.Units_base_string != '-10-201000' && 		// Tesla
						 eqObj.content.Equation.Units_base_string != '00-120000') 			// Stokes
					{
						if ( eqObj.content.Equation.Units_base_array['m'] != 0 )
						{
							scaleUnits.forEach(function(thisItem, index)
							{
								if (thisItem['unit'] == eqObj.content.Equation.Units_showObject.m)
								{
									if ( eqObj.content.Equation.Units_base_array['m'] > 0 )
									{
										//console.log('The conv factor is '+thisItem['conv_factor']+' - '+eqObj.content.Equation.Units_base_array['m']);
										scaleFactor = parseFloat(Big(scaleFactor).div(Big(thisItem['conv_factor']).pow(eqObj.content.Equation.Units_base_array['m'])));
										//console.log('The scale factor is '+scaleFactor);
										if ( eqObj.content.Equation.Units_base_array['m']==1 )
										{
											numer = numer +'\\;'+ thisItem['unit'];
										}else
										{
											numer = numer +'\\;'+ thisItem['unit']+'^{'+eqObj.content.Equation.Units_base_array['m']+'}';										
										}
									}
									if ( eqObj.content.Equation.Units_base_array['m'] < 0 )
									{
										scaleFactor = parseFloat(Big(scaleFactor).div(Big(thisItem['conv_factor']).pow(eqObj.content.Equation.Units_base_array['m'])));
										//console.log('The conv factor is '+thisItem['conv_factor']+' - '+eqObj.content.Equation.Units_base_array['m']);
										//console.log('The -scale factor is '+scaleFactor);
										if ( eqObj.content.Equation.Units_base_array['m']==-1 )
										{
											denom = denom +'\\;'+ thisItem['unit'];
										}else
										{
											denom = denom +'\\;'+ thisItem['unit']+'^{'+eqObj.content.Equation.Units_base_array['m']+'}';										
										}
									}
								}
							});
						}

						if ( eqObj.content.Equation.Units_base_array['s'] != 0 )
						{
							scaleUnits.forEach(function(thisItem, index)
							{
								if (thisItem['unit'] == eqObj.content.Equation.Units_showObject.s)
								{
									if ( eqObj.content.Equation.Units_base_array['s'] > 0 )
									{
										scaleFactor = parseFloat(Big(scaleFactor).div(Big(thisItem['conv_factor']).pow(eqObj.content.Equation.Units_base_array['s'])));
										if ( eqObj.content.Equation.Units_base_array['s']==1 )
										{
											numer = numer +'\\;'+ thisItem['unit'];
										}else
										{
											numer = numer +'\\;'+ thisItem['unit']+'^{'+eqObj.content.Equation.Units_base_array['s']+'}';										
										}
									}
									if ( eqObj.content.Equation.Units_base_array['s'] < 0 )
									{
										scaleFactor = parseFloat(Big(scaleFactor).div(Big(thisItem['conv_factor']).pow(eqObj.content.Equation.Units_base_array['s'])));
										if ( eqObj.content.Equation.Units_base_array['s']==-1 )
										{
											denom = denom +'\\;'+ thisItem['unit'];
										}else
										{
											denom = denom +'\\;'+ thisItem['unit']+'^{'+eqObj.content.Equation.Units_base_array['s']+'}';										
										}
									}
								}
							});
						}

						if ( eqObj.content.Equation.Units_base_array['A'] != 0 )
						{
							scaleUnits.forEach(function(thisItem, index)
							{
								if (thisItem['unit'] == eqObj.content.Equation.Units_showObject.A)
								{
									if ( eqObj.content.Equation.Units_base_array['A'] > 0 )
									{
										scaleFactor = parseFloat(Big(scaleFactor).div(Big(thisItem['conv_factor']).pow(eqObj.content.Equation.Units_base_array['A'])));
										if ( eqObj.content.Equation.Units_base_array['A']==1 )
										{
											numer = numer +'\\;'+ thisItem['unit'];
										}else
										{
											numer = numer +'\\;'+ thisItem['unit']+'^{'+eqObj.content.Equation.Units_base_array['A']+'}';										
										}
									}
									if ( eqObj.content.Equation.Units_base_array['A'] < 0 )
									{
										scaleFactor = parseFloat(Big(scaleFactor).div(Big(thisItem['conv_factor']).pow(eqObj.content.Equation.Units_base_array['A'])));
										if ( eqObj.content.Equation.Units_base_array['A']==-1 )
										{
											denom = denom +'\\;'+ thisItem['unit'];
										}else
										{
											denom = denom +'\\;'+ thisItem['unit']+'^{'+eqObj.content.Equation.Units_base_array['A']+'}';										
										}
									}
								}
							});
						}


						if ( eqObj.content.Equation.Units_base_array['cd'] != 0 )
						{
							scaleUnits.forEach(function(thisItem, index)
							{
								if (thisItem['unit'] == eqObj.content.Equation.Units_showObject.cd)
								{
									if ( eqObj.content.Equation.Units_base_array['cd'] > 0 )
									{
										scaleFactor = parseFloat(Big(scaleFactor).div(Big(thisItem['conv_factor']).pow(eqObj.content.Equation.Units_base_array['cd'])));
										if ( eqObj.content.Equation.Units_base_array['cd']==1 )
										{
											numer = numer +'\\;'+ thisItem['unit'];
										}else
										{
											numer = numer +'\\;'+ thisItem['unit']+'^{'+eqObj.content.Equation.Units_base_array['cd']+'}';										
										}
									}
									if ( eqObj.content.Equation.Units_base_array['cd'] < 0 )
									{
										scaleFactor = parseFloat(Big(scaleFactor).div(Big(thisItem['conv_factor']).pow(eqObj.content.Equation.Units_base_array['cd'])));
										if ( eqObj.content.Equation.Units_base_array['cd']==-1 )
										{
											denom = denom +'\\;'+ thisItem['unit'];
										}else
										{
											denom = denom +'\\;'+ thisItem['unit']+'^{'+eqObj.content.Equation.Units_base_array['cd']+'}';										
										}
									}
								}
							});
						}


						if ( eqObj.content.Equation.Units_base_array['kg'] != 0 )
						{
							scaleUnits.forEach(function(thisItem, index)
							{
								if (thisItem['unit'] == eqObj.content.Equation.Units_showObject.kg)
								{
									if ( eqObj.content.Equation.Units_base_array['kg'] > 0 )
									{
										scaleFactor = parseFloat(Big(scaleFactor).div(Big(thisItem['conv_factor']).pow(eqObj.content.Equation.Units_base_array['kg'])));
										if ( eqObj.content.Equation.Units_base_array['kg']==1 )
										{
											numer = numer +'\\;'+ thisItem['unit'];
										}else
										{
											numer = numer +'\\;'+ thisItem['unit']+'^{'+eqObj.content.Equation.Units_base_array['kg']+'}';										
										}
									}
									if ( eqObj.content.Equation.Units_base_array['kg'] < 0 )
									{
										scaleFactor = parseFloat(Big(scaleFactor).div(Big(thisItem['conv_factor']).pow(eqObj.content.Equation.Units_base_array['kg'])));
										if ( eqObj.content.Equation.Units_base_array['kg']==-1 )
										{
											denom = denom +'\\;'+ thisItem['unit'];
										}else
										{
											denom = denom +'\\;'+ thisItem['unit']+'^{'+eqObj.content.Equation.Units_base_array['kg']+'}';										
										}
									}
								}
							});
						}

						if ( eqObj.content.Equation.Units_base_array['mol'] != 0 )
						{
							scaleUnits.forEach(function(thisItem, index)
							{
								if (thisItem['unit'] == eqObj.content.Equation.Units_showObject.mol)
								{
									if ( eqObj.content.Equation.Units_base_array['mol'] > 0 )
									{
										scaleFactor = parseFloat(Big(scaleFactor).div(Big(thisItem['conv_factor']).pow(eqObj.content.Equation.Units_base_array['mol'])));
										if ( eqObj.content.Equation.Units_base_array['mol']==1 )
										{
											numer = numer +'\\;'+ thisItem['unit'];
										}else
										{
											numer = numer +'\\;'+ thisItem['unit']+'^{'+eqObj.content.Equation.Units_base_array['mol']+'}';										
										}
									}
									if ( eqObj.content.Equation.Units_base_array['mol'] < 0 )
									{
										scaleFactor = parseFloat(Big(scaleFactor).div(Big(thisItem['conv_factor']).pow(eqObj.content.Equation.Units_base_array['mol'])));
										if ( eqObj.content.Equation.Units_base_array['mol']==-1 )
										{
											denom = denom +'\\;'+ thisItem['unit'];
										}else
										{
											denom = denom +'\\;'+ thisItem['unit']+'^{'+eqObj.content.Equation.Units_base_array['mol']+'}';										
										}
									}
								}
							});
						}

						if ( eqObj.content.Equation.Units_base_array['molecules'] != 0 )
						{
							scaleUnits.forEach(function(thisItem, index)
							{
								if (thisItem['unit'] == eqObj.content.Equation.Units_showObject.molecules)
								{
									if ( eqObj.content.Equation.Units_base_array['molecules'] > 0 )
									{
										scaleFactor = parseFloat(Big(scaleFactor).div(Big(thisItem['conv_factor']).pow(eqObj.content.Equation.Units_base_array['molecules'])));
										if ( eqObj.content.Equation.Units_base_array['molecules']==1 )
										{
											numer = numer +'\\;'+ thisItem['unit'];
										}else
										{
											numer = numer +'\\;'+ thisItem['unit']+'^{'+eqObj.content.Equation.Units_base_array['molecules']+'}';										
										}
									}
									if ( eqObj.content.Equation.Units_base_array['molecules'] < 0 )
									{
										scaleFactor = parseFloat(Big(scaleFactor).div(Big(thisItem['conv_factor']).pow(eqObj.content.Equation.Units_base_array['molecules'])));
										if ( eqObj.content.Equation.Units_base_array['molecules']==-1 )
										{
											denom = denom +'\\;'+ thisItem['unit'];
										}else
										{
											denom = denom +'\\;'+ thisItem['unit']+'^{'+eqObj.content.Equation.Units_base_array['molecules']+'}';										
										}
									}
								}
							});
						}


						if ( eqObj.content.Equation.Units_base_array['K'] != 0 )
						{
							if ( eqObj.content.Equation.Units_base_array['K'] > 0 || eqObj.content.Equation.Units_base_array['K'] =='K')
							{
								if ( eqObj.content.Equation.Units_base_array['K']==1 || eqObj.content.Equation.Units_base_array['K'] == 'K' )
								{
									numer = numer + eqObj.content.Equation.Units_showunits;
								}else
								{
									numer = numer + eqObj.content.Equation.Units_showunits+'^{'+eqObj.content.Equation.Units_base_array['K']+'}';										
								}
							}
							if ( eqObj.content.Equation.Units_base_array['K'] < 0 )
							{
								if ( eqObj.content.Equation.Units_base_array['K']==-1 )
								{
									denom = denom + eqObj.content.Equation.Units_showunits;
								}else
								{
									denom = denom + eqObj.content.Equation.Units_showunits+'^{'+eqObj.content.Equation.Units_base_array['K']+'}';										
								}
							}
						}

						if ( eqObj.content.Equation.Units_base_array['A'] == 0 &&
							 eqObj.content.Equation.Units_base_array['K'] == 0 &&
							 eqObj.content.Equation.Units_base_array['cd'] == 0 &&
							 eqObj.content.Equation.Units_base_array['kg'] == 0 &&
							 eqObj.content.Equation.Units_base_array['m'] == 0 &&
							 eqObj.content.Equation.Units_base_array['mol'] == 0 &&
							 eqObj.content.Equation.Units_base_array['s'] == 0 &&
							 eqObj.content.Equation.Units_base_array['molecules'] == 0 &&
							 eqObj.content.Equation.Units_base_array['rad'] == 0 &&
							 eqObj.content.Equation.Units_showObject.rad != 'rad')
						{
							scaleUnits.forEach(function(thisItem, index)
							{
								if (thisItem['unit'] == eqObj.content.Equation.Units_showObject.rad)
								{
									if ( eqObj.content.Equation.Units_base_array['rad'] == 0 )
									{
										scaleFactor = parseFloat(Big(scaleFactor).div(Big(thisItem['conv_factor'])));
									}else
									{
										scaleFactor = parseFloat(Big(scaleFactor).div(Big(thisItem['conv_factor']).pow(eqObj.content.Equation.Units_base_array['rad'])));
									}
									numer = numer +'\\;'+ thisItem['unit'];
								}
							});
						}


						if ( eqObj.content.Equation.Units_base_array['rad'] != 0 )
						{
							scaleUnits.forEach(function(thisItem, index)
							{
								if (thisItem['unit'] == eqObj.content.Equation.Units_showObject.rad)
								{
									if ( eqObj.content.Equation.Units_base_array['rad'] > 0 )
									{
										scaleFactor = parseFloat(Big(scaleFactor).div(Big(thisItem['conv_factor']).pow(eqObj.content.Equation.Units_base_array['rad'])));
										if ( eqObj.content.Equation.Units_base_array['rad']==1 )
										{
											// We only show the rad if there is no other unit
											if ( numer == '' ||  eqObj.content.Equation.Units_showObject.rad != 'rad' )
											{
												numer = numer +'\\;'+ thisItem['unit'];
											}
										}else
										{
											// We only show the rad if there is no other unit
											if ( numer == ''  ||  eqObj.content.Equation.Units_showObject.rad != 'rad' )
											{
												numer = numer +'\\;'+ thisItem['unit']+'^{'+eqObj.content.Equation.Units_base_array['rad']+'}';										
											}
										}
									}
									if ( eqObj.content.Equation.Units_base_array['rad'] < 0 )
									{
										scaleFactor = parseFloat(Big(scaleFactor).div(Big(thisItem['conv_factor']).pow(eqObj.content.Equation.Units_base_array['rad'])));
										if ( eqObj.content.Equation.Units_base_array['rad']==-1 )
										{
											// We only show the rad if there is no other unit
											if ( denom == '' ||  eqObj.content.Equation.Units_showObject.rad != 'rad' )
											{
												denom = denom +'\\;'+ thisItem['unit'];
											}
										}else
										{
											// We only show the rad if there is no other unit
											if ( denom == '' ||  eqObj.content.Equation.Units_showObject.rad != 'rad' )
											{
												denom = denom +'\\;'+ thisItem['unit']+'^{'+eqObj.content.Equation.Units_base_array['rad']+'}';
											}
										}
									}
								}
							});
						}

						if ( scaleFactor == NaN || scaleFactor === undefined )
						{
							scaleFactor = 1;
						}


						/* Use the numerator and denominator to build the new show units */
						if ( denom == '' )
						{
							eqObj.content.Equation.Units_showunits = numer;
						}else
						{
							eqObj.content.Equation.Units_showunits = '\\frac{'+numer+'}{'+denom+'}';						
						}


					}


					var index = '', showSolution = '';
					if ( eqObj.content.Equation.Format_showvalue == 'size' )
					{
						showSolution = eqObj.content.Equation.Format_size;
					
					}else
					{
						if ( eqObj.content.Equation.Format_size.split('x').length > 2 )
						{
							showSolution = "Too many indices to show matrix"
						
						}else
						{
							if ( eqObj.content.Equation.Format_size == "1x1" )
							{
								if ( ( eqObj.content.Equation.Solution_imag['0-0'] != '' ) && 
									 ( eqObj.content.Equation.Solution_imag['0-0'] != 0.0 ) &&
									 ( eqObj.content.Equation.Solution_imag['0-0'] != 0 ) &&
									 ( eqObj.content.Equation.Solution_imag['0-0'] !== undefined ) )
								{
									if ( eqObj.content.Equation.Solution_imag['0-0'] > 0 )
									{
										showSolution = parseFloat(Big(eqObj.content.Equation.Solution_real['0-0']).times(Big(scaleFactor)))+' + '+parseFloat(Big(eqObj.content.Equation.Solution_imag['0-0']).times(Big(scaleFactor)))+'i';
									}else if ( eqObj.content.Equation.Solution_imag['0-0'] < 0 )
									{
										showSolution = parseFloat(Big(eqObj.content.Equation.Solution_real['0-0']).times(Big(scaleFactor)))+' '+parseFloat(Big(eqObj.content.Equation.Solution_imag['0-0']).times(Big(scaleFactor)))+'i';
									}
								}else
								{
									if (parseFloat(eqObj.content.Equation.Solution_real['0-0']==NaN))
									{
										eqObj.content.Equation.Solution_real['0-0']=0;
									}

									// This has to be unique because temperature scaling is not linear
									//console.log('The number and object is '+eqObj.content.Equation.Units_base_array['K']+' - '+eqObj.content.Equation.Units_showunits);
									if ( eqObj.content.Equation.Units_base_array['K'] != 0 )
									{
										//console.log('Got Here');
										if ( eqObj.content.Equation.Units_showunits == 'K' )
										{
											showSolution = parseFloat(Big(eqObj.content.Equation.Solution_real['0-0']));
										}
										if ( eqObj.content.Equation.Units_showunits == 'C' )
										{
											showSolution = parseFloat(Big(eqObj.content.Equation.Solution_real['0-0']).minus(Big(273.15)));
										}
										if ( eqObj.content.Equation.Units_showunits == 'F' )
										{
											showSolution = parseFloat(Big(eqObj.content.Equation.Solution_real['0-0']).times(Big(9).div(Big(5))).minus(459.67));
										}
										if ( eqObj.content.Equation.Units_showunits == 'R' )
										{
											showSolution = parseFloat(Big(eqObj.content.Equation.Solution_real['0-0']).div(Big(0.555555555555)));
										}
										//console.log('Show solution is '+showSolution);
									
									}else
									{
										showSolution = parseFloat(Big(eqObj.content.Equation.Solution_real['0-0']).times(Big(scaleFactor)));
									}
								}
							}else
							{
								showSolution = "\\begin{bmatrix} ";
								var indices = eqObj.content.Equation.Format_size.split('x');
								if ( eqObj.content.Equation.Units_base_array['K'] == 0 )
								{
									for (var a=0; a<indices[0]; a++)
									{   
										for (var b=0; b<indices[1]; b++)
										{
											index = a+'-'+b;
											if ((eqObj.content.Equation.Solution_imag[index]==0) ||
												(eqObj.content.Equation.Solution_imag[index]==0.0) ||
												(eqObj.content.Equation.Solution_imag[index]===undefined))
											{
												if (b==indices[1]-1)
												{
													if ( ( eqObj.content.Equation.Solution_real[index] !== undefined ) && 
														 ( eqObj.content.Equation.Solution_real[index] != ';') &&
														 ( eqObj.content.Equation.Solution_real[index] != ',' ) )
													{
														showSolution = showSolution+' '+parseFloat(Big(eqObj.content.Equation.Solution_real[index]).times(Big(scaleFactor)));
													}
												}else
												{
													if ( ( eqObj.content.Equation.Solution_real[index] !== undefined ) && 
														 ( eqObj.content.Equation.Solution_real[index] != ';') &&
														 ( eqObj.content.Equation.Solution_real[index] != ',' ) )
													{
														showSolution = showSolution+' '+parseFloat(Big(eqObj.content.Equation.Solution_real[index]).times(Big(scaleFactor)))+' & ';
													}
												}
											}else
											{   if (b==indices[1]-1)
												{
													if ( eqObj.content.Equation.Solution_imag[index] > 0 )
													{   
														if ( ( eqObj.content.Equation.Solution_real[index] !== undefined ) && 
															 ( eqObj.content.Equation.Solution_real[index] != ';') &&
															 ( eqObj.content.Equation.Solution_real[index] != ',' ) )
														{
															showSolution = showSolution+''+parseFloat(Big(eqObj.content.Equation.Solution_real[index]).times(Big(scaleFactor)))+' + '+parseFloat(Big(eqObj.content.Equation.Solution_imag[index]).times(Big(scaleFactor)))+'i';
														}
													}else if ( eqObj.content.Equation.Solution_imag[index] < 0 )
													{	
														if ( ( eqObj.content.Equation.Solution_real[index] !== undefined ) && 
															 ( eqObj.content.Equation.Solution_real[index] != ';') &&
															 ( eqObj.content.Equation.Solution_real[index] != ',' ) )
														{
															showSolution = showSolution+''+parseFloat(Big(eqObj.content.Equation.Solution_real[index]).times(Big(scaleFactor)))+' '+parseFloat(Big(eqObj.content.Equation.Solution_imag[index]).times(Big(scaleFactor)))+'i';
														}
													}
												}else
												{
													if ( eqObj.content.Equation.Solution_imag[index] > 0 )
													{   
														if ( ( eqObj.content.Equation.Solution_real[index] !== undefined ) && 
															 ( eqObj.content.Equation.Solution_real[index] != ';') &&
															 ( eqObj.content.Equation.Solution_real[index] != ',' ) )
														{
															showSolution = showSolution+''+parseFloat(Big(eqObj.content.Equation.Solution_real[index]).times(Big(scaleFactor)))+' + '+parseFloat(Big(eqObj.content.Equation.Solution_imag[index]).times(Big(scaleFactor)))+'i'+' & ';
														}
													}else if ( eqObj.content.Equation.Solution_imag[index] < 0 )
													{	
														if ( ( eqObj.content.Equation.Solution_real[index] !== undefined ) && 
															 ( eqObj.content.Equation.Solution_real[index] != ';') &&
															 ( eqObj.content.Equation.Solution_real[index] != ',' ) )
														{
															showSolution = showSolution+''+parseFloat(Big(eqObj.content.Equation.Solution_real[index]).times(Big(scaleFactor)))+' '+parseFloat(Big(eqObj.content.Equation.Solution_imag[index]).times(Big(scaleFactor)))+'i'+' & ';
														}
													}
												}
											}
										}
										if (a!=indices[0]-1)
										{ showSolution = showSolution+" \\\\ "; }
									}
								}else
								{
									for (var a=0; a<indices[0]; a++)
									{   
										for (var b=0; b<indices[1]; b++)
										{
											index = a+'-'+b;
											if ((eqObj.content.Equation.Solution_imag[index]==0) ||
												(eqObj.content.Equation.Solution_imag[index]==0.0) ||
												(eqObj.content.Equation.Solution_imag[index]===undefined))
											{
												if ( eqObj.content.Equation.Units_showunits== 'C' )
												{
													showSolution = parseFloat(Big(eqObj.content.Equation.Solution_real[index]).minus(Big(273.15)));
												}
												if ( eqObj.content.Equation.Units_showunits == 'F' )
												{
													showSolution = parseFloat(Big(eqObj.content.Equation.Solution_real[index]).times(Big(9).div(Big(5))).minus(459.67));
												}
												if ( eqObj.content.Equation.Units_showunits == 'R' )
												{
													showSolution = parseFloat(Big(eqObj.content.Equation.Solution_real[index]).div(Big(0.555555555555)));
												}
												if (b!=indices[1]-1)
												{
													showSolution = showSolution+' & ';
												}
											}else
											{   
												if ( eqObj.content.Equation.Units_showunits == 'C' )
												{
													showReal = parseFloat(Big(eqObj.content.Equation.Solution_real[index]).minus(Big(273.15)));
													showImag = parseFloat(Big(eqObj.content.Equation.Solution_imag[index]).minus(Big(273.15)));
												}
												if ( eqObj.content.Equation.Units_showunits == 'F' )
												{
													showReal = parseFloat(Big(eqObj.content.Equation.Solution_real[index]).times(Big(9).div(Big(5))).minus(459.67));
													showImag = parseFloat(Big(eqObj.content.Equation.Solution_imag[index]).times(Big(9).div(Big(5))).minus(459.67));
												}
												if ( eqObj.content.Equation.Units_showunits == 'R' )
												{
													showReal = parseFloat(Big(eqObj.content.Equation.Solution_real[index]).div(Big(0.555555555555)));
													showImag = parseFloat(Big(eqObj.content.Equation.Solution_imag[index]).div(Big(0.555555555555)));
												}

												if ( eqObj.content.Equation.Solution_imag[index] > 0 )
												{   
													showSolution = showSolution+''+showReal+' + '+showImag+'i';
												
												}else if ( eqObj.content.Equation.Solution_imag[index] < 0 )
												{	
													showSolution = showSolution+''+showReal+' - '+showImag+'i';
												}
												if (b!=indices[1]-1)
												{
													showSolution = showSolution+' & ';
												}
											}
										}
										if (a!=indices[0]-1)
										{ showSolution = showSolution+" \\\\ "; }
									}

								}
								showSolution = showSolution+"\\end{bmatrix}";
							}
						}
					}
				}
				return showSolution
			},



			/*
			*
			*	TEMPLATES AND PROTOTYPES
			*
			*
			*	This section holds all of the templates and prototypes that are used to create
			*	new items. Some are created through the new keyword and some are created as
			*	a template object.
			*
			*/

			// The equation prototype - instantiated with the new keyword
			eqPro : function(objProps, fileID) 
			{
				this.inEdit=0;
				this.Format_id=objProps.Format_id;
				this.Original_id=objProps.Format_id;
				if (objProps.Format_name) { this.Format_name=objProps.Format_name; }else { this.Format_name="TempEq"; }
				this.Format_equation='newEquation=1';
				this.Format_showequation='1';
				this.Format_showsolution='1';
				this.Format_equationinuse='';
				this.Format_editinuse=0;
				this.Format_right='1';
				this.Format_left='newEquation';
				this.Format_size='1x1'; 
				this.Format_numinds=''; 
				this.Format_type=1;	 
				this.Format_showtype="top"; 
				this.Format_showvalue="value";
				this.Solution_convsol='';
				this.Solution_real={};  
				this.Solution_imag={};
				this.Solution_input_array=new Array();
				this.Solution_inputs=new Array();
				this.Solution_variable_array=new Array();
				this.Solution_key_array=new Array();
				this.Solution_unit_array=new Array();
				this.Solution_object_array=new Array();
				this.Solution_temps=new Array();
				this.Solution_PostFix=new Array();
				this.Solution_Post_Units=new Array();
				this.Solution_realdefault=0;
				this.Solution_imagdefault=0;
				this.Units_units='';
				this.Units_showunits='';
				this.Units_conv_units='';
				this.Units_unit_array=new Array();
				this.Units_conv_array=new Array();  
				this.Units_scaled_array=new Array();
				this.Units_base_array=[];   
				this.Units_base_string='00000000';  
				this.Units_multiplier=1;
				this.Units_quantity=''; 
				this.Units_showObject={'A':'A', 'K':'K', 's':'s', 'm':'m', 'kg':'kg', 'cd':'cd', 'mol':'mol', 'molecules':'molecules', 'rad':'rad'}; 
				this.Models_numerical='';
				this.Models_units='';   
				this.Models_dimensions='';  
				this.Models_quantities='';  
				this.Errors_flag=0; 
				this.Errors_errors=new Array(); 
				this.EqObj={};	  
				this.inputURL='';
				this.inputType='';
				this.inputShow=true;
				this.inputName='';  
				this.active=1;  
				this.fileID=fileID;
				this.datasetURL='Enter URL Here';
				this.FaF={};	this.connected_ids={};  
				var unitList=new Array('A', 'K', 's', 'm', 'kg', 'cd', 'mol', 'molecules', 'rad');
				for (var unitindex = 0; unitindex < unitList.length; ++unitindex) {	  this.Units_base_array[unitList[unitindex]]=0;	}   
				for (var item in objProps){ this[item]=JSON.parse(JSON.stringify(objProps[item])); }
				this.newEquation=this.Format_equation;
			},




			forLoopPro : function(objProps, fileID)
			{	
				var thisLoop = {};
				thisLoop.Format_id=objProps['Format_id'];	
				thisLoop.Page_position=0;	
				thisLoop.Page_topparentid='none';	
				thisLoop.Page_parentid='none';	
				thisLoop.counter='a';	
				thisLoop.Loop_counterValue=0;	
				thisLoop.valueid='';	
				thisLoop.startText='0';	
				thisLoop.start=0;	
				thisLoop.stopText='1';
				thisLoop.stop=1;	
				thisLoop.increment=1;
				thisLoop.incrementText='1';	
				thisLoop.numSteps=1;
				thisLoop.status=0;
				thisLoop.Format_haschanged=1;
				thisLoop.firstRun=0;
				thisLoop.limitFactor='<';
				thisLoop.Errors_flag=0;
				thisLoop.Errors_errors=new Array();	
				thisLoop.fileid=fileID;
				thisLoop.startInputEdit=false;
				thisLoop.incrementEdit=false;
				thisLoop.stopInputEdit=false;
				thisLoop.limitInputEdit=false;
				thisLoop.sublineEdit=false;
				thisLoop.needsUpdateFlag=false;
				thisLoop.showNumbers=false;
				thisLoop.fileID=fileID;
				thisLoop.Dependents=[];
				for (var item in objProps){ thisLoop[item]=objProps[item]; }
				return thisLoop
			},



			ifElsePro : function (objProps, fileID)	
			{   
				var thisStat = {};
				thisStat.Format_id=objProps['Format_id'];	
				thisStat.Page_position=0;   
				thisStat.parentStatement=objProps['Format_id'];  
				thisStat.Page_topparentid='none';   
				thisStat.Page_parentid='none';  
				thisStat.Statement_Type="if";
				thisStat.Statement_String='';
				thisStat.Statement_TFString='';
				thisStat.Statement_ValueString='';
				thisStat.Statement_truefalse=false; 
				thisStat.Statement_Execute='0'; 
				thisStat.Statement_Parent=objProps['Format_id']; 
				thisStat.Statement_Order=new Array();
				thisStat.Errors_errors=new Array(); 
				thisStat.Errors_flag=0;
				thisStat.parentStatement=objProps['Format_id'];
				thisStat.statementBlock=[];
				thisStat.statementBlock[0]=[];
				thisStat.firstRun=1;	
				thisStat.sublineEdit=false;
				thisStat.needsUpdateFlag=false;
				thisStat.needsBlockUpdateFlag=false;
				thisStat.Dependents={};
				thisStat.showNumbers=false;
				thisStat.fileID=fileID;
				thisStat.Dependents=[];
				for (var item in objProps){ thisStat[item]=objProps[item]; }
				return thisStat
			},
		


			whileLoopPro : function (objProps, fileID)	 
			{   
				var thisLoop = {};
				thisLoop.Format_id=objProps['Format_id'];	
				thisLoop.Page_position=0;   
				thisLoop.Page_topparentid='none';   
				thisLoop.Page_parentid='none';  
				thisLoop.Loop_numsteps='';	  
				thisLoop.Loop_stepLimit=100;
				thisLoop.Loop_counterValue=0;
				thisLoop.Loop_TFString='';
				thisLoop.Loop_ValueString='';
				thisLoop.Loop_truefalse=false;  
				thisLoop.Errors_errors=new Array(); 
				thisLoop.Errors_flag=0;
				thisLoop.statementBlock=[];
				thisLoop.statementBlock[0]=[];
				thisLoop.firstRun=1;	
				thisLoop.sublineEdit=false;
				thisLoop.needsUpdateFlag=false;
				thisLoop.showNumbers=false;
				thisLoop.fileID=fileID;
				thisLoop.Dependents=[];
				for (var item in objProps){ thisLoop[item]=objProps[item]; }
				return thisLoop
			},



			statementPro : function ()
			{   
				var thisObject={};
				thisObject['blockOption']="||";	// Not used
				thisObject['conditionText']="==";
				thisObject['dependentText']="1";
				thisObject['dependentValue']=1; 
				thisObject['flagText']="flag";
				thisObject['flagValue']=1;
				thisObject['truefalse']=false;
				thisObject['flagInputEdit']=false;
				thisObject['dependentInputEdit']=false;
				thisObject['conditionInputEdit']=false;
				thisObject['showClass']='falsestatements';
				thisObject['showOptions']=false;
				thisObject['needsUpdateFlag']=false;
				thisObject['flagInputEdit']=false;
				return thisObject;
			},


			// Create a new reference.
			newRef : function(refObj) 
			{
				var returnData =	
					{ 
						'refID':'',
						'type':'web',
						'author':'Author',
						'reftext':'',
						'address':'http://www.cadwolf.com',
						'pagetitle':'Page Title',
						'sitetitle':'Site Name', 
						'dateaccessed':'January 1, 2016',
						'booktitle':'Book Title',
						'publisher':'Publisher', 
						'datepublished':'January 1, 2016',
						'articletitle':'Article Title',
						'magpapername':'Magazine Name',   
						'page':'1',
						'entryname':'Entry Name',
						'encname':'Encyclopedia Name',
						'edition':'1',
						'year':'2016',	
						'showEdits':true,
						'refNum':0	 
					};
					for (var refProp in refObj) { returnData[refProp]=refObj[refProp]; }

				return returnData;

			},



			/*
			*
			*
			*   FUNCTIONS RELATING TO TABLES
			*
			*   
			*
			*/

			addTableColumn : function(tableObj, colNum) 
			{
				//console.log('In the add table column function');
				var tempObj = {'real':0, 'imag':'', 'equation':'=0', 'units':'', 'showEquation':false};
				for (var i=0; i<tableObj['content']['data'].length; i++)
				{
					tableObj['content']['data'][i].splice(parseInt(colNum)+1, 0, JSON.parse(JSON.stringify(tempObj)));
				}
				return tableObj
			},

			deleteTableColumn : function(tableObj, colNum) 
			{
				//console.log('In the delete table column function');
				for (var i=0; i<tableObj['content']['data'].length; i++)
				{
					tableObj['content']['data'][i].splice(colNum, 1);
				}
				return tableObj
			},

			addTableRow : function(tableObj, rowNum) 
			{
				//console.log('In the add table row function');
				var tempObj = {'real':0, 'imag':'', 'equation':'=0', 'units':'', 'showEquation':false};
				var tempArray = Array();
				for (var i=0; i<tableObj['content']['data'][0].length; i++)
				{
					tempArray.push(JSON.parse(JSON.stringify(tempObj)));
				}
				tableObj['content']['data'].splice(parseInt(rowNum), 0, tempArray);
				return tableObj
			},

			deleteTableRow : function(tableObj, rowNum) 
			{
				//console.log('In the delete table row function');
				tableObj['content']['data'].splice(rowNum, 1);
				return tableObj
			}

		}

	}

})();
/*
*
*   Memory storage for datasets. This service retains items in memory for datasets between views.
*
*/
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('datasetMemoryFactory', datasetMemoryFactory);

    /** @ngInject */
    function datasetMemoryFactory()
    {
        return {

        }
    }

})();
/*
*   This factory provides the prototype for the 2D charts and a few other functions needed to create 
*   and maintain the chart.
*
*  
*/


(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('chartFactory', chartFactory);

    /** @ngInject */
    function chartFactory(docItemFactory)
    {
        return {
            
            // Chart Prototype
            chartPro : function(objProps, fileID, xAxisObj, yAxisObj) 
            {   
                var chartObj={};
                chartObj.Format_id='';
                chartObj.fileID=fileID;
                chartObj.needsUpdateFlag=1;                                             
                chartObj.Page_parentid="none";                                              
                chartObj.Page_topparentid="none";  
                chartObj.activeType='data';                                         

                chartObj.Chart_type="line"; 
                chartObj.Chart_width="825px";                                               
                chartObj.Chart_height="500px";    
                chartObj.tempChartWidth="825px";                                               
                chartObj.tempChartHeight="500px";    
                chartObj.Chart_marginright=10;                                              
                chartObj.Chart_marginleft=75;                                               
                chartObj.Chart_marginbottom=65;                                             
                chartObj.Chart_margintop=60;                                                
                chartObj.Chart_Name='Chart_'+objProps['itemid'];                                            
                chartObj.Chart_Labels=new Array();                                          
                chartObj.Chart_stack="none";

                chartObj.Title_onoff="1";
                chartObj.Title_text='Chart Title';                                          
                chartObj.Title_xoffset=0;
                chartObj.Title_yoffset=20; 

                chartObj.Subtitle_onoff="0";                                                
                chartObj.Subtitle_text='Chart Subtitle';                                    
                chartObj.Subtitle_xoffset=0;                                                
                chartObj.Subtitle_yoffset=30;                                               

                chartObj.Legend_onoff=true;
                chartObj.Legend_layout="horizontal";                                        
                chartObj.Legend_floating=1;
                chartObj.Legend_xoffset=0; 
                chartObj.Legend_yoffset=0; 
                chartObj.Legend_width=0; 
                chartObj.Legend_align="center";                                             
                chartObj.Legend_verticalalign="bottom";                                      
                chartObj.Legend_rtl="false";                                                
                chartObj.Legend_marginRight=0;                                              
                chartObj.Legend_marginLeft=0;                                               
                chartObj.Legend_marginBottom=0;                                             
                chartObj.Legend_marginTop=0;                                                

                chartObj.Chart_dataobj=[]; 
                chartObj.Chart_yaxesobj=[];
                chartObj.Chart_xaxesobj=[];
                chartObj.Chart_bandsobj=[];
                chartObj.Chart_linesobj=[];
                chartObj.Chart_textobj=[];
                chartObj.Chart_xaxesobj.push(xAxisObj);
                chartObj.Chart_yaxesobj.push(yAxisObj);
            
                for (var item in objProps){ chartObj[item]=JSON.parse(JSON.stringify(objProps[item])); }

                return chartObj
            }, 

            // Chart Data Prototype
            chartDataPro : function(id, plotID, dataObj) 
            {   this.Format_id=id;
                this.Format_plotid=plotID;                                              
                this.Format_type="line";                                                
                this.outlinecolor='';
                this.xaxis=0;     
                this.series=0;    
                this.yaxis=0;     
                this.xdata_plottext='';
                this.xdata_name='';  
                this.xdata_id=''; 
                this.xdata_rawtable='';
                this.ydata_plottext='';
                this.ydata_name='';  
                this.ydata_id=''; 
                this.ydata_rawtable='';
                this.zdata_name='';  
                this.zdata_id=''; 
                this.zdata_rawtable='';
                this.cdata_plottext='';
                this.cdata_name='';  
                this.cdata_id=''; 
                this.cdata_rawtable='';
                this.dataname='New Dataset';  
                this.data_type=1; 
                this.pielabels=new Array();                                             
                this.piedata=new Array();                                               
                this.data_plottext=''; 
                this.data_error=0;
                this.data_datalabels=false;                                             
                this.data_labelSize=12;
                this.data_labelColor='#000000';                                         
                this.data_labelBorderWidth=0;                                           
                this.data_labelBorderColor="";                                          
                this.data_labelBorderRadius=0;                                          
                this.data_labelBorderPadding=0;                                         
                this.data_labelBackgroundColor='';                                      
                this.data_labelRotation=0;                                              
                this.data_labelX='';  
                this.data_labelY='';  
                this.data_labelDistance=30;                                             
                this.data_labelFormat='Normal';                                         
                this.data_pointmarkers=true;                                            
                this.data_markersize='3';
                this.showInLegend=true;
                this.lineWidth='1';  
                this.Chart_Labeltext='';                                                
                this.Chart_startangle='0';                                              
                this.Chart_stopangle='360';                                             
                this.Chart_innersize='0';                                               
                this.Chart_size='100'; 
                this.Chart_location='50%, 50%';                                         
                this.Chart_translations={};                                             
                this.Chart_connectorWidth=1;                                            
                this.Chart_monoColor='';                                                
                this.PointData={};      
                this.needsUpdateFlag=0;     
                for (var item in dataObj){ this[item]=JSON.parse(JSON.stringify(dataObj[item])); }
                return this
            },                 

            // Chart Axis Prototype
            chartAxisPro : function(id, plotID, axisObj) 
            {   var newAxis={};               
                newAxis.Format_id=id;                          
                newAxis.Format_plotid=plotID;      
                newAxis.Axis_num=0;                            
                newAxis.Axis_label="";                         
                newAxis.Axis_lineWidth=0;                      
                newAxis.Axis_linecolor="";                     
                newAxis.Axis_opposite="false";                 
                newAxis.Axis_type="linear";                    
                newAxis.Axis_offset=0;                         
                newAxis.Axis_min="null";                       
                newAxis.Axis_max="null";                       
                newAxis.Axis_tickinterval=0;                   
                newAxis.Axis_gridlinesonoff="true";            
                newAxis.Axis_gridcolor="#C0C0C0";                                          
                newAxis.Axis_minortickinterval=0;              
                newAxis.Axis_minorgridlinesonoff="false";      
                newAxis.Axis_minorgridcolor='#C0C0C0';         
                newAxis.Axis_gridlinewidth=1;                  
                newAxis.Axis_minorgridlinewidth=0;             
                newAxis.Axis_reversed="false"; 
                newAxis.Chart_Labeltext='';
                newAxis.Axis_name='';    
                for (var item in axisObj){ newAxis[item]=JSON.parse(JSON.stringify(axisObj[item])); console.log('Setting '+item+' to '+axisObj[item]);}
                return newAxis
            },

            // Chart Band Prototype
            chartBandPro : function(id, plotID, bandObj) 
            {   var newBand={};
                newBand.Format_id=id;                          
                newBand.Format_plotid=plotID;    
                newBand.Axis_id="";
                newBand.Band_start=0;
                newBand.Band_end=1;  
                newBand.color="#FCFFC5";                       
                newBand.Band_name='';    
                for (var item in bandObj){ newBand[item]=JSON.parse(JSON.stringify(bandObj[item])); }
                return newBand
            },

            // Chart Line Prototype
            chartLinePro : function(id, plotID, lineObj) 
            {   var newLine={};
                newLine.Format_id=id;                          
                newLine.Format_plotid=plotID;                  
                newLine.Axis_id="";    
                newLine.Line_value=1;
                newLine.Line_width=1;                          
                newLine.color="#FCFFC5";                       
                newLine.Line_name='';    
                for (var item in lineObj){ newLine[item]=JSON.parse(JSON.stringify(lineObj[item])); }
                return newLine;
            },

            // Chart Text Prototype
            chartTextPro : function(id, plotID, textObj) 
            {   var newText={};
                newText.Format_id=id;                          
                newText.Format_plotid=plotID;                  
                newText.textRawText='Chart Text'; 
                newText.textFormattedText='';                                              
                newText.textXLoc=10; 
                newText.textYLoc=10; 
                newText.textRotAng=0;
                newText.textSize='14px';
                newText.textColor="000000";                    
                newText.textElement={};    
                newText.Text_name='';    
                for (var item in textObj){ newText[item]=JSON.parse(JSON.stringify(textObj[item])); }
                return newText;
            },

            // Add a chart dataset
            addDataset : function(plotObj, fileID, worksheetObj) 
            {   var tempDataset=new this.chartDataPro(  docItemFactory.getID('dataSeries', fileID, worksheetObj), 
                                                        plotObj['content']['itemid'], 
                                                        { Format_type:plotObj['content']['Plot']['Chart_type'] }
                                                     );
                tempDataset['series']=plotObj['content']['Plot']['Chart_dataobj'].length;
                plotObj['content']['Plot']['Chart_dataobj'].push(tempDataset);
                var thisIndex=parseInt(plotObj['content']['Plot']['Chart_dataobj'].length);
                var colorArray=['#7cb5ec', '#434348', '#90ed7d', '#f7a35c', '#8085e9', '#f15c80', '#e4d354', '#2b908f', '#f45b5b', '#91e8e1'];
                var thisColor=colorArray[thisIndex%10-1];
                plotObj['content']['Plot']['Chart_dataobj'][thisIndex-1]['color']=thisColor;
                plotObj['content']['Plot']['Chart_dataobj'][thisIndex-1]['symbol']="circle";
                plotObj['content']['Plot']['Chart_dataobj'][thisIndex-1]['fillColor']=thisColor;
                plotObj['content']['Plot']['needsUpdateFlag']=1;
                return plotObj
            },

            // Add a chart item that isn't a dataset
            addChartItem : function(thisPlot, itemType, fileID, worksheetObj) 
            {   console.log('In the add chart item with an item type of '+itemType+', and a file ID of '+fileID);

                var itemNum = 0, axisID = '', itemName='', thisTemplate={};
                if (itemType=="plotText")
                {   itemNum=thisPlot['content']['Plot']['Chart_textobj'].length;
                    itemName = 'Text '+itemNum;
                    thisTemplate=new this.chartTextPro( docItemFactory.getID('plotText', fileID, worksheetObj), 
                                                        thisPlot.itemid, 
                                                        { Format_plotid:thisPlot.itemid, Text_name:itemName }
                                                      );    
                    console.log('Pushing a new text with name of '+thisTemplate.Text_name);
                    thisPlot['content']['Plot']['Chart_textobj'].push(thisTemplate);      
                }
  
                if (itemType=="band")
                {   itemNum=thisPlot['content']['Plot']['Chart_bandsobj'].length;
                    itemName = 'Band '+itemNum;
                    thisTemplate=new this.chartBandPro( docItemFactory.getID('band', fileID, worksheetObj), 
                                                        thisPlot.itemid, 
                                                        { Format_plotid:thisPlot.itemid, Band_name:itemName }
                                                    );    
                    thisPlot['content']['Plot']['Chart_bandsobj'].push(thisTemplate);    
                }
  
                if (itemType=="line")
                {   itemNum=thisPlot['content']['Plot']['Chart_linesobj'].length;
                    itemName = 'Line '+itemNum;
                    thisTemplate=new this.chartLinePro( docItemFactory.getID('line', fileID, worksheetObj), 
                                                        thisPlot.itemid, 
                                                        { Format_plotid:thisPlot.itemid, Line_name:itemName }
                                                    ); 
                    thisPlot['content']['Plot']['Chart_linesobj'].push(thisTemplate);    
                }
  
                if (itemType=="xAxis")
                {   itemNum = thisPlot['content']['Plot']['Chart_xaxesobj'].length;
                    itemName = 'Axis '+itemNum;
                    thisTemplate=new this.chartAxisPro( docItemFactory.getID('axis', fileID, worksheetObj), 
                                                        thisPlot.itemid, 
                                                        { Format_plotid:thisPlot.itemid, Axis_num:itemNum, Axis_name:itemName }
                                                    ); 
                    thisPlot['content']['Plot']['Chart_xaxesobj'].push(thisTemplate);  
                }
  
                if (itemType=="yAxis")
                {   itemNum=thisPlot['content']['Plot']['Chart_yaxesobj'].length;
                    itemName = 'Axis '+itemNum;
                    thisTemplate=new this.chartAxisPro( docItemFactory.getID('axis', fileID, worksheetObj), 
                                                        thisPlot.itemid, 
                                                        { Format_plotid:thisPlot.itemid, Axis_num:itemNum, Axis_name:itemName }
                                                    ); 
                    thisPlot['content']['Plot']['Chart_yaxesobj'].push(thisTemplate);  
                }

                thisPlot['content']['Plot']['needsUpdateFlag']=1;
                return thisPlot
            },

            // delete a chart item that isn't a dataset
            deleteChartItem : function(currentItem, chartItem) 
            {   console.log('The current item id is '+currentItem['itemid']);
                console.log('The current plot is '+currentItem['content']['Plot']);
                console.log('The current item is '+chartItem['Format_id']);
                currentItem['content']['Plot']['Chart_dataobj'].forEach(function(item, index)
                {
                    if ( item.Format_id == chartItem.Format_id )
                    {   
                        currentItem.content.Plot.Chart_dataobj.splice( index, 1 );
                    }
                });

                currentItem['content']['Plot']['Chart_xaxesobj'].forEach(function(item, index)
                {
                    if ( item.Format_id == chartItem.Format_id )
                    {   
                        currentItem.content.Plot.Chart_xaxesObj.splice( index, 1 );
                        currentItem.content.Plot.Chart_xaxesObj.forEach(function(secItem, secIndex)
                        {
                            currentItem.content.Plot.Chart_xaxesObj[secIndex]['Axis_name'] = "Axis "+secIndex;
                        });
                    }
                });

                currentItem['content']['Plot']['Chart_yaxesobj'].forEach(function(item, index)
                {
                    if ( item.Format_id == chartItem.Format_id )
                    {   
                        currentItem.content.Plot.Chart_yaxesobj.splice( index, 1 );
                        currentItem.content.Plot.Chart_yaxesobj.forEach(function(secItem, secIndex)
                        {
                            currentItem.content.Plot.Chart_yaxesobj[secIndex]['Axis_name'] = "Axis "+secIndex;
                        });
                    }
                });

                currentItem['content']['Plot']['Chart_bandsobj'].forEach(function(item, index)
                {
                    if ( item.Format_id == chartItem.Format_id )
                    {   
                        currentItem.content.Plot.Chart_bandsobj.splice( index, 1 );
                    }
                });

                currentItem['content']['Plot']['Chart_linesobj'].forEach(function(item, index)
                {
                    if ( item.Format_id == chartItem.Format_id )
                    {   
                        currentItem.content.Plot.Chart_linesobj.splice( index, 1 );
                    }
                });

                currentItem['content']['Plot']['Chart_textobj'].forEach(function(item, index)
                {
                    if ( item.Format_id == chartItem.Format_id )
                    {   
                        currentItem.content.Plot.Chart_textobj.splice( index, 1 );
                    }
                });

                currentItem['content']['Plot']['needsUpdateFlag']=1;
                return currentItem
            },

            // set the mono color
            setMonoColor : function( currentItem , currentDataset) 
            {   console.log('I am in the set mono color function for dataset '+currentDataset['Format_id']+' and a mono of '+currentItem.content.Plot.Chart_monoColor);
                var flag=0;     var base='';
                if ((currentItem.content.Plot.Chart_monoColor=="Blue")||(currentItem.content.Plot.Chart_monoColor=="blue")) { base = "#7cb5ec"; }   
                if ((currentItem.content.Plot.Chart_monoColor=="Green")||(currentItem.content.Plot.Chart_monoColor=="green")) { base = "#AADDAA"; }
                if ((currentItem.content.Plot.Chart_monoColor=="Red")||(currentItem.content.Plot.Chart_monoColor=="red")) { base = "#FF0000"; }
                if ((currentItem.content.Plot.Chart_monoColor=="Yellow")||(currentItem.content.Plot.Chart_monoColor=="yellow")) { base = "#e4d354"; }   
                if (currentItem.content.Plot.Chart_monoColor=="") { flag=1; } 
                if (currentDataset['Format_type']=="pie")
                {   
                    for (var dataIndex=0; dataIndex<currentItem.content.Plot['Chart_dataobj'].length; dataIndex++) 
                    {
                        if ( currentDataset['Format_id'] == currentItem.content.Plot['Chart_dataobj'][dataIndex]['Format_id'] )
                        {
                            if (flag===0){  for (var i in currentItem.content.Plot['Chart_dataobj'][dataIndex]['PointData']){   currentItem.content.Plot['Chart_dataobj'][dataIndex]['PointData'][i]['color']=Highcharts.Color(base).brighten((i - 3) / 7).get(); }
                            }else        {  for (var i in currentItem.content.Plot['Chart_dataobj'][dataIndex]['PointData']){   currentItem.content.Plot['Chart_dataobj'][dataIndex]['PointData'][i]['color']=Highcharts.getOptions().colors[i]; }  }
                        }
                    }
                    currentDataset.Chart_monoColor=monoColor; 
                }else 
                {   if (flag==0)
                    {   var i=0;
                        for (var dataIndex=0; dataIndex<currentItem.content.Plot['Chart_dataobj'].length; dataIndex++) 
                        {   currentItem.content.Plot['Chart_dataobj'][dataIndex]['color']=Highcharts.Color(base).brighten((i - 3) / 7).get(); 
                            currentItem.content.Plot['Chart_dataobj'][dataIndex]['fillColor']=Highcharts.Color(base).brighten((i - 3) / 7).get();
                            i++;
                        }
                    }else   
                    {   var i=0;
                        for (var dataIndex=0; dataIndex<currentItem.content.Plot['Chart_dataobj'].length; dataIndex++) 
                        {   console.log('Setting color for index '+dataIndex+' to '+Highcharts.getOptions().colors[i]);
                            currentItem.content.Plot['Chart_dataobj'][dataIndex]['color']=Highcharts.getOptions().colors[i];
                            currentItem.content.Plot['Chart_dataobj'][dataIndex]['fillColor']=Highcharts.getOptions().colors[i]; 
                            i++;
                        }
                    }
                }
                currentItem['content']['Plot']['needsUpdateFlag']=1;

                return currentItem
            },

            // Format the plot text items for a chart
            formatPlotText : function(thisPlot, worksheetObj) 
            {   var formatted={}, thisLoc=0, thisName='', indexes=[], plotLoc=0; 

                if ( worksheetObj === undefined ){ worksheetObj = []; }

                worksheetObj.forEach(function(eqItem, eqIndex) 
                {   
                    if (eqItem['itemid']==thisPlot['itemid'])  { plotLoc = eqItem['order']; }
                });
                
                for (var a = 0; a < thisPlot['Chart_textobj'].length; a++)
                {   
                    var thisText=thisPlot['Chart_textobj'][a]['textRawText'];
                    var splitText=thisText.match(/#[\[\]0-9a-zA-Z_]+/g);
                    if (splitText===null)  
                    {   
                        thisPlot['Chart_textobj'][a]['textFormattedText']=thisText;
                    }else 
                    {   
                        for (var b=0; b<splitText.length; b++)
                        {   indexes=splitText[b].match(/\[[0-9]+\]/g); 
                            if (indexes===null)
                            {   
                                thisLoc=0; 
                                thisName=splitText[b].replace(/^\#/,'');
                                worksheetObj.forEach(function(eqItem, eqIndex) 
                                {   
                                    if (parseInt(eqItem['component_type_id'])==3)  
                                    {   
                                        if ((eqItem['order']>thisLoc)&&(eqItem['order']<plotLoc)&&(eqItem['content']['Equation']['Format_name']==thisName))
                                        {
                                            formatted[splitText[b]]=eqItem['content']['Equation']['Solution_real']['0-0'];   
                                            thisLoc=eqItem['order'];  
                                        } 
                                    }  
                                }); 
                            }else  
                            {   
                                var thisKey='';  
                                for (var c=0; c<indexes.length; c++) {   thisKey=thisKey+'-'+indexes[c].replace(/[\[\]]+/g,'');    } 
                                thisKey=thisKey.replace(/^\-/,''); 
                                console.log('The key is '+thisKey);
                                thisLoc=0;  
                                thisName=splitText[b].replace(/^\#/,'').replace(/\[[0-9]+\]/g,''); 
                                console.log('The name is '+thisName);
                                worksheetObj.forEach(function(eqItem, eqIndex) 
                                {   
                                    if (parseInt(eqItem['component_type_id'])==3) 
                                    {   
                                        console.log('Comparing '+eqItem['content']['Name']+' to '+thisName);
                                        console.log('Comparing '+eqItem['order']+' to '+thisLoc+' and '+plotLoc);
                                        if ((eqItem['order']>=thisLoc)&&(eqItem['order']<plotLoc)&&(eqItem['content']['Name']==thisName))
                                        {   
                                            console.log('The formatted text is '+eqItem['content']['Equation']['Solution_real'][thisKey]);
                                            formatted[splitText[b]]=eqItem['content']['Equation']['Solution_real'][thisKey];   
                                            thisLoc=eqItem['order'];  
                                        } 
                                    }
                                }); 
                            } 
                        }

                        for (var itemID in formatted)  
                        {   
                            thisText=thisText.replace(itemID, formatted[itemID]); 
                            console.log('thisText is '+thisText.replace(itemID, formatted[itemID]));
                        }
                        thisPlot['Chart_textobj'][a]['textFormattedText']=thisText;
                    } 
                }

                return thisPlot['Chart_textobj']
            },


            // Make the chart from the object
            makeChart : function(plotObj, currentChartItemID, worksheetObj)
            {   
                console.log('The result of the itemid - '+plotObj['itemid']+' - grab is ...');
                console.log(document.getElementById(plotObj['itemid']));
                if ( document.getElementById(plotObj['itemid'])!=null )
                {   var chartData=plotObj.content.Plot;
                    console.log('Make Charts was called with '+plotObj.itemid+' to make a '+chartData.Chart_type);
                    if (chartData.newType==1){ chartData.Chart_dataobj=[]; chartData.newType=0; }
                    var datafinal=new Array();
                    var thischart={}; thischart.chart={}; thischart.series=new Array(); thischart.title={}; thischart.subtitle={};  thischart.xAxis=new Array();
                    thischart.yAxis=new Array();    thischart.legend={};    thischart.yAxis[0]={};  thischart.xAxis[0]={};      thischart.plotOptions={};   
                    if (chartData.Chart_type!="combo") { thischart.chart.type = chartData.Chart_type; }
                    thischart.chart.margin='['+chartData.Chart_margintop+', '+chartData.Chart_marginright+', '+chartData.Chart_marginbottom+', '+chartData.Chart_marginleft+']';
                    thischart.chart.backgroundColor='transparent';
                    thischart.chart.height=chartData.Chart_height.replace(/[a-z]+$/,'');                
                    thischart.chart.width=chartData.Chart_width.replace(/[a-z]+$/,'');
                    if (chartData.Title_onoff===true)       
                    {   thischart.title.margin=15; thischart.title.text=chartData.Title_text;   thischart.title.floating=true;
                    }else { thischart.title.margin=0; thischart.title.text=''; }        
                    if (chartData.Subtitle_onoff===true) { thischart.subtitle.text=chartData.Subtitle_text; }else { thischart.subtitle.text=''; }   
                    thischart.title.x=chartData.Title_xoffset;          thischart.title.y=chartData.Title_yoffset;      
                    thischart.subtitle.x=chartData.Subtitle_xoffset;    thischart.subtitle.y=chartData.Subtitle_yoffset;
                    thischart.chart.marginBottom=chartData.Chart_marginbottom;      thischart.chart.marginTop=chartData.Chart_margintop;            
                    thischart.chart.marginLeft=chartData.Chart_marginleft;          thischart.chart.marginRight=chartData.Chart_marginright;        
                    thischart.tooltip={};   thischart.tooltip.shared=true;  thischart.tooltip.crosshairs=true;
                    thischart.tooltip.formatter= "";
                    if(thischart.chart.type=="heatmap") {       thischart.tooltip.pointFormat='{series.name}: X is {point.x} : Y is {point.y} : the value is {point.value}<br/>';
                    }else if(thischart.chart.type=="pie") { thischart.tooltip.pointFormat='{point.name} - {point.y}<br/>';
                    }else if(thischart.chart.type!="bubble"){   thischart.tooltip.pointFormat='{series.name}: X is {point.x} : Y is {point.y}<br/>';    }
                    thischart.tooltip.headerFormat='';

                    console.log('There is a chart of type '+thischart.chart.type+' being built');

                    if (thischart.chart.type=="heatmap")        
                    {   thischart.colorAxis={};
                        // if (chartData.colorAxis===undefined) { thischart.colorAxis={};  window[plotObj.content.Plot.Format_id].colorAxis={}; }          
                        // if (chartData.colorAxis.min!==undefined) { thischart.colorAxis.min=window[plotObj.content.Plot.Format_id].colorAxis.min; }else{ chartData.colorAxis.min=0; }    
                        // if (chartData.colorAxis.max!==undefined) { thischart.colorAxis.max=window[plotObj.content.Plot.Format_id].colorAxis.max; }  
                        if (chartData.colorAxis===undefined) { thischart.colorAxis={}; chartData.colorAxis={};   }          
                        if (chartData.colorAxis.min!==undefined) { thischart.colorAxis.min = chartData.colorAxis.min; }    
                        if (chartData.colorAxis.max!==undefined) { thischart.colorAxis.max = chartData.colorAxis.max; }  
                        if (chartData.colorAxis.type===undefined) { thischart.colorAxis.type="linear"; chartData.colorAxis.type="linear"; }else { thischart.colorAxis.type=chartData.colorAxis.type; }
                        if (chartData.colorAxis.stops!==undefined) 
                        {   
                            thischart.colorAxis.stops=new Array();
                            for (var a=0; a<chartData.colorAxis.stops.length; a++) 
                            {   
                                thischart.colorAxis.stops[a]=new Array();
                                thischart.colorAxis.stops[a]['0']=chartData.colorAxis.stops[a]['0'];
                                thischart.colorAxis.stops[a]['1']=chartData.colorAxis.stops[a]['1']; 
                            }
                        }else               
                        {   thischart.colorAxis.stops=new Array();
                            thischart.colorAxis.stops['0']=new Array();     thischart.colorAxis.stops['1']=new Array();     thischart.colorAxis.stops['2']=new Array(); 
                            thischart.colorAxis.stops['0']['0']=0;          thischart.colorAxis.stops['0']['1']='#3060cf'; 
                            thischart.colorAxis.stops['1']['0']=0.5;        thischart.colorAxis.stops['1']['1']='#fffbbc'; 
                            thischart.colorAxis.stops['2']['0']=1;          thischart.colorAxis.stops['2']['1']='#c4463a'; 
                            chartData.colorAxis.stops=new Array();
                            chartData.colorAxis.stops['0']=new Array();     chartData.colorAxis.stops['1']=new Array();     chartData.colorAxis.stops['2']=new Array(); 
                            chartData.colorAxis.stops['0']['0']=0;          chartData.colorAxis.stops['0']['1']='#3060cf'; 
                            chartData.colorAxis.stops['1']['0']=0.5;        chartData.colorAxis.stops['1']['1']='#fffbbc'; 
                            chartData.colorAxis.stops['2']['0']=1;          chartData.colorAxis.stops['2']['1']='#c4463a';                 
                        }                   
                    }                       
                    if (thischart.chart.type=="heatmap")        
                    {   thischart.legend.align='center';        
                        thischart.legend.layout='horizontal';   
                        thischart.legend.verticalAlign='bottom';
                        thischart.legend.y=25;
                        thischart.legend.margin=0;  
                    }else{                  
                        thischart.legend.align=chartData['Legend_align'];           
                        if (chartData.Legend_floating==1) { thischart.legend.floating=true; }else { thischart.legend.floating=false; }                  
                        thischart.legend.layout=chartData['Legend_layout'];     
                        if (chartData['Legend_onoff']===false) { thischart.legend.enabled=false;    }else { thischart.legend.enabled=true; }            
                        thischart.legend.rtl=chartData['Legend_rtl'];
                        thischart.legend.verticalAlign=chartData['Legend_verticalalign'];               
                        thischart.legend.x=this.toNum(chartData['Legend_xoffset']);       
                        thischart.legend.y=this.toNum(chartData['Legend_yoffset']);       
                        thischart.legend.itemMarginTop=15;      
                    }                       
                    for (var AxisID in chartData.Chart_yaxesobj)    
                    {   var axisnum=chartData.Chart_yaxesobj[AxisID]['Axis_num'];   
                        thischart.yAxis[axisnum]={};
                        thischart.yAxis[axisnum].id=chartData.Chart_yaxesobj[AxisID]['Format_id'];      
                        thischart.yAxis[axisnum].title={};      
                        thischart.yAxis[axisnum].title.text=chartData['Chart_yaxesobj'][AxisID].Axis_label; 
                        thischart.yAxis[axisnum].type=chartData['Chart_yaxesobj'][AxisID].Axis_type;    
                        var opposite=chartData['Chart_yaxesobj'][AxisID].Axis_opposite; var reversed=chartData['Chart_yaxesobj'][AxisID].Axis_reversed;     
                        if ((opposite=="true")||(opposite===true)){ thischart.yAxis[axisnum].opposite=true;}else{thischart.yAxis[axisnum].opposite=false;}  
                        if ((reversed=="true")||(reversed===true)){ thischart.yAxis[axisnum].reversed=true;}else{thischart.yAxis[axisnum].reversed=false;}  
                        if (chartData['Chart_yaxesobj'][AxisID].Axis_min!="null") { thischart.yAxis[axisnum].min=chartData['Chart_yaxesobj'][AxisID].Axis_min;  }
                        if (chartData['Chart_yaxesobj'][AxisID].Axis_max!="null") { thischart.yAxis[axisnum].max=chartData['Chart_yaxesobj'][AxisID].Axis_max;  }
                        if ((chartData['Chart_yaxesobj'][AxisID].Axis_gridlinesonoff=="true")||(chartData['Chart_yaxesobj'][AxisID].Axis_gridlinesonoff===true))        
                        {   thischart.yAxis[axisnum].gridLineWidth=chartData['Chart_yaxesobj'][AxisID].Axis_gridlinewidth;  
                            thischart.yAxis[axisnum].gridLineColor=chartData['Chart_yaxesobj'][AxisID].Axis_gridcolor;      
                            if ((chartData['Chart_yaxesobj'][AxisID].Axis_tickinterval!==0)&&(chartData['Chart_yaxesobj'][AxisID].Axis_tickinterval!="null"))   
                            {   thischart.yAxis[axisnum].tickInterval=parseFloat(chartData['Chart_yaxesobj'][AxisID].Axis_tickinterval); }          
                        }                   
                        if ((chartData['Chart_yaxesobj'][AxisID].Axis_minorgridlinesonoff=="true")||(chartData['Chart_yaxesobj'][AxisID].Axis_minorgridlinesonoff===true))      
                        {   thischart.yAxis[axisnum].minorGridLineWidth=chartData['Chart_yaxesobj'][AxisID].Axis_minorgridlinewidth;                    
                            thischart.yAxis[axisnum].minorGridLineColor=chartData['Chart_yaxesobj'][AxisID].Axis_minorgridcolor;                        
                            if (chartData['Chart_yaxesobj'][AxisID].Axis_minortickinterval!==0)         
                            {   thischart.yAxis[axisnum].minorTickInterval=parseFloat(chartData['Chart_yaxesobj'][AxisID].Axis_minortickinterval); }    
                        }                   
                        thischart.yAxis[axisnum].plotBands=new Array(); 
                        for (var BandID in chartData['Chart_bandsobj'])         
                        {   if (chartData['Chart_bandsobj'][BandID]['Axis_id']==chartData.Chart_yaxesobj[AxisID]['Format_id'])              
                            {   var temp={};
                                temp.color=chartData['Chart_bandsobj'][BandID]['color'];                
                                temp.from=chartData['Chart_bandsobj'][BandID]['Band_start'];            
                                temp.to=chartData['Chart_bandsobj'][BandID]['Band_end'];                
                                thischart.yAxis[axisnum].plotBands.push(temp);          
                            }               
                        }                   
                        thischart.yAxis[axisnum].plotLines=new Array(); 
                        for (var LineID in chartData['Chart_linesobj'])         
                        {   if (chartData['Chart_linesobj'][LineID]['Axis_id']==chartData.Chart_yaxesobj[AxisID]['Format_id'])              
                            {   var temp={};
                                temp.color=chartData['Chart_linesobj'][LineID]['color'];                
                                temp.value=chartData['Chart_linesobj'][LineID]['Line_value'];           
                                temp.width=chartData['Chart_linesobj'][LineID]['Line_width'];           
                                thischart.yAxis[axisnum].plotLines.push(temp);          
                            }               
                        }                   
                    }                       
                    for (var AxisID in chartData.Chart_xaxesobj)    
                    {   var axisnum=chartData.Chart_xaxesobj[AxisID]['Axis_num'];   
                        thischart.xAxis[axisnum]={};
                        thischart.xAxis[axisnum].id=chartData.Chart_xaxesobj[AxisID]['Format_id'];      
                        thischart.xAxis[axisnum].title={};      
                        if (chartData['Chart_xaxesobj'][AxisID].Chart_Labeltext!==undefined)
                        {   if ((chartData.Chart_type=="column")||(chartData.Chart_type=="bar")||(chartData.Chart_type=="heatmap")) { var temptext=chartData['Chart_xaxesobj'][AxisID].Chart_Labeltext.split(',');      
                            thischart.xAxis[axisnum].categories=temptext;   } }
                        thischart.xAxis[axisnum].title.text=chartData['Chart_xaxesobj'][AxisID].Axis_label; 
                        thischart.xAxis[axisnum].type=chartData['Chart_xaxesobj'][AxisID].Axis_type;    
                        if (chartData['Chart_xaxesobj'][AxisID].Axis_opposite=="true"){ thischart.xAxis[axisnum].opposite=true;}else{thischart.xAxis[axisnum].opposite=false;}  
                        if (chartData['Chart_xaxesobj'][AxisID].Axis_reversed=="true"){ thischart.xAxis[axisnum].reversed=true;}else{thischart.xAxis[axisnum].reversed=false;}  
                        if (chartData['Chart_xaxesobj'][AxisID].Axis_min!="null") { thischart.xAxis[axisnum].min=chartData['Chart_xaxesobj'][AxisID].Axis_min;  }
                        if (chartData['Chart_xaxesobj'][AxisID].Axis_max!="null") { thischart.xAxis[axisnum].max=chartData['Chart_xaxesobj'][AxisID].Axis_max;  }
                        if ((chartData['Chart_xaxesobj'][AxisID].Axis_gridlinesonoff=="true")||(chartData['Chart_xaxesobj'][AxisID].Axis_gridlinesonoff===true))        
                        {   thischart.xAxis[axisnum].gridLineWidth=parseInt(chartData['Chart_xaxesobj'][AxisID]['Axis_gridlinewidth'], 10);             
                            thischart.xAxis[axisnum].gridLineColor=chartData['Chart_xaxesobj'][AxisID].Axis_linecolor;      
                            if ((chartData['Chart_xaxesobj'][AxisID].Axis_tickinterval!==0)&&(chartData['Chart_xaxesobj'][AxisID].Axis_tickinterval!="null"))   
                            {   thischart.xAxis[axisnum]['tickInterval']=parseFloat(chartData['Chart_xaxesobj'][AxisID]['Axis_tickinterval']); }                        
                        }                   
                        if ((chartData['Chart_xaxesobj'][AxisID].Axis_minorgridlinesonoff=="true")||(chartData['Chart_xaxesobj'][AxisID].Axis_minorgridlinesonoff===true))      
                        {   thischart.xAxis[axisnum].minorGridLineWidth=parseInt(chartData['Chart_xaxesobj'][AxisID].Axis_minorgridlinewidth);                  
                            thischart.xAxis[axisnum].minorGridLineColor=chartData['Chart_xaxesobj'][AxisID].Axis_minorgridcolor;                        
                            if (chartData['Chart_xaxesobj'][AxisID].Axis_minortickinterval!==0)         
                            {   thischart.xAxis[axisnum].minorTickInterval=parseFloat(chartData['Chart_xaxesobj'][AxisID].Axis_minortickinterval); }                
                        }                   
                        thischart.xAxis[axisnum].plotBands=new Array(); 
                        for (var BandID in chartData['Chart_bandsobj'])         
                        {   if (chartData['Chart_bandsobj'][BandID]['Axis_id']==chartData.Chart_xaxesobj[AxisID]['Format_id'])              
                            {   var temp={};
                                temp.color=chartData['Chart_bandsobj'][BandID]['color'];                
                                temp.from=chartData['Chart_bandsobj'][BandID]['Band_start'];            
                                temp.to=chartData['Chart_bandsobj'][BandID]['Band_end'];                
                                thischart.xAxis[axisnum].plotBands.push(temp);          
                            }               
                        }                   
                        thischart.xAxis[axisnum].plotLines=new Array(); 
                        for (var LineID in chartData['Chart_linesobj'])         
                        {   if (chartData['Chart_linesobj'][LineID]['Axis_id']==chartData.Chart_xaxesobj[AxisID]['Format_id'])              
                            {   var temp={};
                                temp.color=chartData['Chart_linesobj'][LineID]['color'];                
                                temp.value=chartData['Chart_linesobj'][LineID]['Line_value'];           
                                temp.width=chartData['Chart_linesobj'][LineID]['Line_width'];           
                                thischart.xAxis[axisnum].plotLines.push(temp);          
                            }               
                        }                   
                    }                       
                    for (var dataid in chartData.Chart_dataobj) 
                    {   if (chartData.Chart_type!=="combo"){ chartData.Chart_dataobj[dataid].Format_type=chartData.Chart_type; }
                        if (chartData.Chart_dataobj[dataid]['data_plottext']!==undefined)               
                        {   if (chartData.Chart_dataobj[dataid]['Format_type']=="pie")
                            {   datafinal=new Array();
                                thischart.series[chartData.Chart_dataobj[dataid]['series']]={};     
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].type="pie";
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].startAngle=chartData.Chart_dataobj[dataid]['Chart_startAngle']; 
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].endAngle=chartData.Chart_dataobj[dataid]['Chart_stopAngle'];       
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].center=chartData.Chart_dataobj[dataid]['Chart_location'].split(',');
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].size=parseInt(chartData.Chart_dataobj[dataid]['Chart_size'], 10)+'%';
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].innerSize=parseInt(chartData.Chart_dataobj[dataid]['Chart_innersize'], 10)+'%';
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].fillColor=chartData.Chart_dataobj[dataid]['fillColor'];
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels={};
                                var dataobj=new Array();
                                for (var a=0; a<chartData.Chart_dataobj[dataid]['piedata'].length; a++)
                                {   dataobj[a]={};  
                                    if (chartData.Chart_dataobj[dataid]['pielabels'][a]!==undefined){dataobj[a]['name']=chartData.Chart_dataobj[dataid]['pielabels'][a]; }
                                    dataobj[a]['y']=chartData.Chart_dataobj[dataid]['piedata'][a];      
                                }           
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].data=dataobj;
                                thischart.plotOptions['pie']={};
                                if (chartData.Chart_dataobj[dataid]['showInLegend']===true) {           
                                        thischart.series[chartData.Chart_dataobj[dataid]['series']].showInLegend = true;    
                                }else { thischart.series[chartData.Chart_dataobj[dataid]['series']].showInLegend = false;   }
                                var labelData=chartData.Chart_dataobj[dataid]['Chart_Labeltext'].split(','); 
                                if (chartData.Chart_dataobj[dataid]['PointData']===undefined)
                                {
                                    chartData.Chart_dataobj[dataid]['PointData']={};
                                }
                                for (var a=0; a<labelData.length; a++)
                                {
                                    if (chartData.Chart_dataobj[dataid]['PointData'][a]===undefined)
                                    {
                                        chartData.Chart_dataobj[dataid]['PointData'][a] = {};
                                    }
                                    chartData.Chart_dataobj[dataid]['PointData'][a]['name']=labelData[a];
                                }
                                if ((chartData.Chart_dataobj[dataid]['data_datalabels']=="true")||((chartData.Chart_dataobj[dataid]['data_datalabels']===true)))
                                {   thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels={};  
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels['connectorWidth']=chartData.Chart_dataobj[dataid].Chart_connectorWidth;  
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels['enabled']=true;
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels['softConnector']=false;                      
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels['distance']=parseFloat(chartData.Chart_dataobj[dataid].data_labelDistance);
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels['color']=chartData.Chart_dataobj[dataid].data_labelColor;
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels['style']={ fontFamily: 'Lato' };            
                                    if (chartData.Chart_dataobj[dataid].data_labelFormat=="Percentage")
                                    {   thischart.series[chartData.Chart_dataobj[dataid]['series']]['dataLabels']['formatter']=function() { return Math.round(this.percentage*100)/100 + ' %';}
                                    }else if (chartData.Chart_dataobj[dataid].data_labelFormat=="Value")
                                    {   thischart.series[chartData.Chart_dataobj[dataid]['series']]['dataLabels']['formatter']=function() { return this.y;} }           
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels['borderWidth']=chartData.Chart_dataobj[dataid]['data_labelBorderWidth']; 
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels['borderColor']=chartData.Chart_dataobj[dataid]['data_labelBorderColor']; 
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels['borderRadius']=chartData.Chart_dataobj[dataid]['data_labelBorderRadius'];   
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels['padding']=chartData.Chart_dataobj[dataid]['data_labelBorderPadding'];
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels['backgroundColor']=chartData.Chart_dataobj[dataid]['data_labelBackgroundColor'];
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels['rotation']=chartData.Chart_dataobj[dataid]['data_labelRotation'];
                                    if (chartData.Chart_dataobj[dataid]['data_labelX']!='')
                                    {
                                        thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels['x']=chartData.Chart_dataobj[dataid]['data_labelX'];
                                    }
                                    if (chartData.Chart_dataobj[dataid]['data_labelY']!='')
                                    {
                                        thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels['y']=chartData.Chart_dataobj[dataid]['data_labelY'];
                                    }
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels['style']={ fontFamily: 'Lato' };            
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels['style']['fontSize']=chartData.Chart_dataobj[dataid]['data_labelSize'];  
                                }else { thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels={};
                                        thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels['enabled']=false;    }                   
                                for (var point in chartData.Chart_dataobj[dataid].PointData)            
                                {   
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]={};
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['y']=chartData.Chart_dataobj[dataid].PointData[point]['y']; 
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['name']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['name']=chartData.Chart_dataobj[dataid].PointData[point]['name']; }//\
                                    if ((chartData.Chart_dataobj[dataid].PointData[point].color!==undefined)&&(chartData.Chart_dataobj[dataid].PointData[point].color!==''))
                                    {   thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['color']=chartData.Chart_dataobj[dataid].PointData[point].color;}//\
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['sliced']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['sliced']=eval(chartData.Chart_dataobj[dataid].PointData[point]['sliced']);    }
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels']={};
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['labels']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels'].enabled=eval(chartData.Chart_dataobj[dataid]['PointData'][point]['labels']); }
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelColor']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels'].color=chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelColor']; } 
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelBorderRadius']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels'].borderRadius=chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelBorderRadius']; }
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelBackgroundColor']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels'].backgroundColor=chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelBackgroundColor']; }
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelBorderWidth']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels'].borderWidth=chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelBorderWidth']; }   
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelBorderPadding']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels'].padding=chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelBorderPadding']; }   
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelBorderColor']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels'].borderColor=chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelBorderColor']; }   
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels']['style']={ fontFamily: 'Lato' };         
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelSize']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels']['style']['fontSize']=chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelSize']; }
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelRotation']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels'].rotation=chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelRotation']; }
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelX']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels'].x=chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelX']; }
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelY']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels'].y=chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelY']; }     
                                }           
                            }else           
                            {   thischart.series[chartData.Chart_dataobj[dataid]['series']]={};     
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].type=chartData.Chart_dataobj[dataid]['Format_type'];    
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].turboThreshold=0;   
                    //              thischart.series[chartData.Chart_dataobj[dataid]['series']].data=JSON.parse("["+chartData.Chart_dataobj[dataid]['data_plottext']+"]");  
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].name=chartData.Chart_dataobj[dataid]['dataname'];       
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].yAxis=parseInt(chartData.Chart_dataobj[dataid]['yaxis']);       
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].xAxis=parseInt(chartData.Chart_dataobj[dataid]['xaxis']);       
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].color=chartData.Chart_dataobj[dataid]['color'];     
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].fillColor=chartData.Chart_dataobj[dataid]['fillColor'];
                                if (chartData.Chart_dataobj[dataid]['showInLegend']===true) {           
                                        thischart.series[chartData.Chart_dataobj[dataid]['series']].showInLegend = true;    
                                }else { thischart.series[chartData.Chart_dataobj[dataid]['series']].showInLegend = false;   }
                                if (thischart.chart.type!="heatmap")    
                                {   thischart.series[chartData.Chart_dataobj[dataid]['series']].lineWidth=parseInt(chartData.Chart_dataobj[dataid]['lineWidth'], 10);   }   
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].marker={};  
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].marker['enabled']=eval(chartData.Chart_dataobj[dataid]['data_pointmarkers']);   
                                if ((thischart.chart.type!="line")||(thischart.chart.type!="spline"))    
                                {
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].marker['radius']=parseInt(chartData.Chart_dataobj[dataid]['data_markersize']);    
                                }
                                if ((chartData.Chart_dataobj[dataid]['Format_type']=="bubble")||(chartData.Chart_dataobj[dataid]['Format_type']=="scatter"))
                                {   chartData.Chart_dataobj[dataid]['lineWidth']=0;  }
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].marker.fillColor=chartData.Chart_dataobj[dataid]['fillColor'];  
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].marker.symbol=chartData.Chart_dataobj[dataid]['symbol'];
                                if ((chartData.Chart_dataobj[dataid]['Format_type']=="column")||(chartData.Chart_dataobj[dataid]['Format_type']=="bar"))
                                {   if (chartData.Chart_dataobj[dataid]['Chart_Labeltext']===undefined){    chartData.Chart_dataobj[dataid]['Chart_Labeltext']='';  }
                                    if (chartData.Chart_dataobj[dataid]['Chart_Labeltext'].length>0)
                                    {   thischart.xAxis[0].categories=chartData.Chart_dataobj[dataid]['Chart_Labeltext'].split(',');   }
                                }
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels={};
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels.enabled=eval(chartData.Chart_dataobj[dataid]['data_datalabels']);    
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels.color=chartData.Chart_dataobj[dataid]['data_labelColor'];
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels.borderRadius=chartData.Chart_dataobj[dataid].data_labelBorderRadius;
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels.backgroundColor=chartData.Chart_dataobj[dataid].data_labelBackgroundColor;
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels.borderWidth=chartData.Chart_dataobj[dataid].data_labelBorderWidth;   
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels.padding=chartData.Chart_dataobj[dataid].data_labelBorderPadding; 
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels['style']={ fontFamily: 'Lato' };                
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels['style']['fontSize']=chartData.Chart_dataobj[dataid]['data_labelSize'];
                                if (chartData.Chart_dataobj[dataid].data_labelBorderColor==='')     
                                {   thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels.borderColor=chartData.Chart_dataobj[dataid]['color'];
                                }else { thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels.borderColor=chartData.Chart_dataobj[dataid].data_labelBorderColor; }
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels.rotation=chartData.Chart_dataobj[dataid].data_labelRotation;
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels.x=chartData.Chart_dataobj[dataid].data_labelX;
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].dataLabels.y=chartData.Chart_dataobj[dataid].data_labelY;
                                thischart.series[chartData.Chart_dataobj[dataid]['series']].data=new Array();   
                                var thisIndex=0;
                                for (var point in chartData.Chart_dataobj[dataid].PointData)            
                                {   
                                    var temp=JSON.parse(JSON.stringify(chartData.Chart_dataobj[dataid].PointData[point]['y']));                     
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]={y: temp};      
                                    if (chartData.Chart_dataobj[dataid].PointData[point]['x']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['x']=chartData.Chart_dataobj[dataid].PointData[point]['x']; }  
                                    if (chartData.Chart_dataobj[dataid].PointData[point]['x']===undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['x']=thisIndex; }  
                                    if (chartData.Chart_dataobj[dataid].PointData[point]['z']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['z']=chartData.Chart_dataobj[dataid].PointData[point]['z']; }  
                                    if (chartData.Chart_dataobj[dataid].PointData[point]['value']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['value']=chartData.Chart_dataobj[dataid].PointData[point]['value']; }  
                                    if (chartData.Chart_dataobj[dataid].PointData[point].data_fillColor!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['color']=chartData.Chart_dataobj[dataid].PointData[point].data_fillColor; }  
                                    if (chartData.Chart_dataobj[dataid].PointData[point].data_markersize!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['radius']=chartData.Chart_dataobj[dataid].PointData[point].data_markersize; }   
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['marker']={};   
                                    if (chartData.Chart_dataobj[dataid].PointData[point]['data_pointmarkers']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['marker']['enabled']=chartData.Chart_dataobj[dataid].PointData[point]['data_pointmarkers']; }  
                                    if (chartData.Chart_dataobj[dataid].PointData[point]['symbol']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['marker']['symbol']=chartData.Chart_dataobj[dataid].PointData[point]['symbol']; } 
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels']={};
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['labels']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels'].enabled=eval(chartData.Chart_dataobj[dataid]['PointData'][point]['labels']); }
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelColor']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels'].color=chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelColor']; }
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelBorderRadius']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels'].borderRadius=chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelBorderRadius']; }
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelBackgroundColor']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels'].backgroundColor=chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelBackgroundColor']; }
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelBorderWidth']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels'].borderWidth=chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelBorderWidth']; }   
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelBorderPadding']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels'].padding=chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelBorderPadding']; }   
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelBorderColor']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels'].borderColor=chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelBorderColor']; }   
                                    thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels']['style']={ fontFamily: 'Lato' };             
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelSize']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels']['style']['fontSize']=chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelSize']; }
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelRotation']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels'].rotation=chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelRotation']; }
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelX']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels'].x=chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelX']; }
                                    if (chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelY']!==undefined) { thischart.series[chartData.Chart_dataobj[dataid]['series']].data[point]['dataLabels'].y=chartData.Chart_dataobj[dataid]['PointData'][point]['data_labelY']; }     
                                    thisIndex=thisIndex+1;
                                }

                                thischart.plotOptions.series={};        thischart.plotOptions.series.states={};     thischart.plotOptions.series.states.hover={};       
                                thischart.plotOptions.series.states.hover.enabled=false;
                                if (chartData['Chart_stack']=="none") { thischart.plotOptions.series.stacking=null;
                                }else {     thischart.plotOptions.series.stacking=chartData['Chart_stack']; }   

                            }               
                        }
                    } 

                    console.log('The chart data is ');
                    console.log(chartData);
                    chartData.Chart_textobj = this.formatPlotText( chartData, worksheetObj );
                    console.log('The text object is ');
                    console.log(chartData.Chart_textobj);
                    

                    console.log('The renderTo is '+plotObj.content.renderTo);
                    if (plotObj.content.renderTo=='standard')
                    {
                        console.log('Remaking the chart in the standard window at '+plotObj.itemid);
                        thischart.chart.renderTo=plotObj.itemid;                    
                        window[chartData.Chart_Name]=new Highcharts.Chart( thischart );
                        window[chartData.Chart_Name].container.onclick = null;          
                        window[chartData.Chart_Name].credits.hide();    

                        for (var textID in chartData.Chart_textobj) 
                        {   var thisText=chartData.Chart_textobj[textID]['textFormattedText'];
                            var thisX=chartData.Chart_textobj[textID]['textXLoc'];
                            var thisY=chartData.Chart_textobj[textID]['textYLoc'];
                            var thisColor=chartData.Chart_textobj[textID]['textColor'];
                            var thisSize=chartData.Chart_textobj[textID]['textSize'];
                            var thisRot=chartData.Chart_textobj[textID]['textRotAng'];
                            window[chartData['Chart_Name']].renderer.text(thisText, thisX, thisY).css({color: '#'+thisColor, fontSize: thisSize }).attr({rotation:thisRot, zIndex:9999}).add();
                            // window['plotSpecEdit'].renderer.text(thisText, thisX, thisY).css({color: '#'+thisColor, fontSize: thisSize }).attr({rotation:thisRot, zIndex:9999}).add();
                        }

                    }else
                    {
                        setTimeout(function() {
                            console.log('Remaking the chart in the edit window');
                            thischart.chart.renderTo='plotSpecEdit';

                            if (plotObj.content.renderTo == "fullPlot")
                            {
                                thischart.chart.height=document.body.clientHeight;                
                                thischart.chart.width=document.body.clientWidth;
                            }

                            window[chartData.Chart_Name]=new Highcharts.Chart( thischart );
                            window[chartData.Chart_Name].container.onclick = null;          
                            window[chartData.Chart_Name].credits.hide();    

                            for (var textID in chartData.Chart_textobj) 
                            {   var thisText=chartData.Chart_textobj[textID]['textFormattedText'];
                                var thisX=chartData.Chart_textobj[textID]['textXLoc'];
                                var thisY=chartData.Chart_textobj[textID]['textYLoc'];
                                var thisColor=chartData.Chart_textobj[textID]['textColor'];
                                var thisSize=chartData.Chart_textobj[textID]['textSize'];
                                var thisRot=chartData.Chart_textobj[textID]['textRotAng'];
                                window[chartData['Chart_Name']].renderer.text(thisText, thisX, thisY).css({color: '#'+thisColor, fontSize: thisSize }).attr({rotation:thisRot, zIndex:9999}).add();
                                // window['plotSpecEdit'].renderer.text(thisText, thisX, thisY).css({color: '#'+thisColor, fontSize: thisSize }).attr({rotation:thisRot, zIndex:9999}).add();
                            }
                        }, 500);
                    }


                    return thischart
                }
            },

            // Sets the current chart item to the one given
            resetCurrentItem : function(plotObj, currentChartItem)
            {   
                if (currentChartItem!==undefined)
                {
                    console.log('The current ID is '+currentChartItem);
                    var thisCurrent='';
                    for (var dataid in plotObj.content.Plot.Chart_dataobj)
                    {   if(plotObj.content.Plot.Chart_dataobj[dataid]['Format_id']==currentChartItem) 
                        {   thisCurrent =  plotObj.content.Plot.Chart_dataobj[dataid]; } 
                    } 
                    for (var AxisID in plotObj.content.Plot.Chart_xaxesobj) 
                    {   if(plotObj.content.Plot.Chart_xaxesobj[AxisID]['Format_id']==currentChartItem) 
                        {   thisCurrent =  plotObj.content.Plot.Chart_xaxesobj[AxisID]; } 
                    } 
                    for (var AxisID in plotObj.content.Plot.Chart_yaxesobj) 
                    {   if(plotObj.content.Plot.Chart_yaxesobj[AxisID]['Format_id']==currentChartItem) 
                        {   thisCurrent =  plotObj.content.Plot.Chart_yaxesobj[AxisID]; } 
                    } 
                    for (var bandID in plotObj.content.Plot.Chart_bandsobj) 
                    {   if(plotObj.content.Plot.Chart_bandsobj[bandID]['Format_id']==currentChartItem) 
                        {   thisCurrent =  plotObj.content.Plot.Chart_bandsobj[bandID]; } 
                    } 
                    for (var lineID in plotObj.content.Plot.Chart_linesobj) 
                    {   if(plotObj.content.Plot.Chart_linesobj[lineID]['Format_id']==currentChartItem) 
                        {   thisCurrent =  plotObj.content.Plot.Chart_linesobj[lineID]; } 
                    } 
                    for (var textID in plotObj.content.Plot.Chart_textobj) 
                    {   if(plotObj.content.Plot.Chart_textobj[textID]['Format_id']==currentChartItem) 
                        {   thisCurrent =  plotObj.content.Plot.Chart_linesobj[textID]; } 
                    } 

                    return thisCurrent
                }else
                {
                    return ''
                }
            },



            toNum : function(num)
            {   return parseFloat(parseFloat(num).toFixed(12)); 
            },




            placeResults : function(thisPlot, plotResults)
            {   console.log('In the place results function with an ID of '+plotResults.plotID+', a dataID of '+plotResults.DataID+' with a class name of '+plotResults.className);

                if (plotResults.className=="all")              
                {   
                    for (var objProp in plotResults.plotObj) 
                    {   
                        // thisPlot['content']['Plot'][objProp]=plotResults.plotObj[objProp]; 
                    }   

                    // thisPlot['content']['Plot']['Dependents'] = plotResults.Dependents;
                                
                }                                               
            
                return thisPlot
            }

       
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('surfaceBind', surfaceBindDirective);

// Why is this plot and not surface on line 17, 18???

    /** @ngInject **/
    function surfaceBindDirective(surfaceFactory)
    {   return {
            restrict: 'A',
            controller: ["$scope", "$element", "$attrs", function($scope, $element, $attrs) {
                $scope.$watch($attrs.surfaceBind, function(surfaceObj) 
                {   
                    if (surfaceObj.content !== undefined )
                    {  
                        if (surfaceObj.content.Plot.needsUpdateFlag==1)
                        {  
                            surfaceObj.content.Plot.needsUpdateFlag=0;
                            console.log('This is what is working');
                            if (surfaceObj['Surface']['appended'] === undefined)
                            {
                                var container = window.document.getElementById( newTemplate.itemid );
                                container.appendChild( surfaceObj.Surface.Renderer.domElement );
                                surfaceObj['Surface']['appended'] = 1;
                            }
                        }
                    }
                }, true);
            }],
        }
    };   
})();


(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('showOnParentHover', showOnParentHoverDirective);

    /** @ngInject **/
    function showOnParentHoverDirective()
    {   return {
            restrict: 'A',
            link : function(scope, element, attrs) {
                element.hide();
                element.parent().bind('mouseenter', function() {
                    element.show();
                });
                element.parent().bind('mouseleave', function() {
                     element.hide();
                });
            }
        }
    };   
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('refItem', refItemDirective);

    /** @ngInject **/
    function refItemDirective($templateRequest, $compile)
    {   return {
            restrict: "A",
            link: function(scope, element){
                $templateRequest("app/main/apps/document/worksheet/views/templates/referenceItem.html").then(function(html){
                    var template = angular.element(html);
                    element.append(template);
                    $compile(template)(scope);
                });
            }
        };
    }


})();


(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('refItemBib', refItemBibDirective);

    /** @ngInject **/
    function refItemBibDirective($templateRequest, $compile)
    {   return {
            restrict: "A",
            link: function(scope, element){
                $templateRequest("app/main/apps/document/worksheet/views/templates/referenceItemBib.html").then(function(html){
                    var template = angular.element(html);
                    element.append(template);
                    $compile(template)(scope);
                });
            }
        };
    }


})();


(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('readfile', readfileDirective);

    /** @ngInject **/
    function readfileDirective($parse)
    {   return {
            restrict: 'A',
            scope: false,
            link: function(scope, element, attrs) {

                var fn = $parse(attrs.readfile);
                
                element.on('change', function(onChangeEvent) {
                    var reader = new FileReader();
                    
                    reader.onload = function(onLoadEvent) {
                        scope.$apply(function() {
                            fn(scope, {$fileContent:onLoadEvent.target.result});
                        });
                    };

                    reader.readAsText((onChangeEvent.srcElement || onChangeEvent.target).files[0]);
                });
            }
        };
    };   
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('plotBind', plotBindDirective);

    /** @ngInject **/
    function plotBindDirective(chartFactory)
    {   return {
            restrict: 'A',
            controller: ["$scope", "$element", "$attrs", function($scope, $element, $attrs) {
                $scope.$watch($attrs.plotBind, function(plotObj) 
                {   console.log('Chart remake directive called');
                    if (plotObj.content !== undefined)
                    { 
                        if (plotObj.content.Plot.needsUpdateFlag==1) 
                        {   console.log('I should be remaking the chart');
                            plotObj.content.Plot.needsUpdateFlag=0;
                            chartFactory.makeChart(plotObj, $scope.vm.currentChartItemID, $scope.vm.cadwolf_worksheet);
                            $scope.vm.currentChartItem = chartFactory.resetCurrentItem( plotObj, $scope.vm.currentChartItemID, $scope.vm.cadwolf_worksheet );
                        }
                    }
                }, true);
            }],
        }
    };   
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('onErrorSrc', onErrorSrcDirective);

    /** @ngInject **/
    function onErrorSrcDirective()
    {   return {
            restrict: 'A',
	        link: function(scope, element, attrs) {
	          element.bind('error', function() {
	            if (attrs.src != attrs.onErrorSrc) {
	              attrs.$set('src', attrs.onErrorSrc);
	            }
	          });
	        }
        }
    };   
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('ngEnter', ngEnterDirective);

    /** @ngInject **/
    function ngEnterDirective()
    {   return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.bind("keydown keypress", function(event) {
                if(event.which === 13) {
                        scope.$apply(function(){
                                scope.$eval(attrs.ngEnter);
                        });                 
                    event.preventDefault();
                }
            });
            }
        }
    };   
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('mathjaxBind', mathjaxBindDirective);

    /** @ngInject **/
    function mathjaxBindDirective()
    {   return {
            restrict: 'A',
            controller: ["$scope", "$element", "$attrs", function($scope, $element, $attrs) {
                $scope.$watch($attrs.mathjaxBind, function(value) {
                    $element.text(value == undefined ? "" : '$$'+value+'$$');
                    MathJax.Hub.Queue(["Typeset", MathJax.Hub, $element[0]]);
                });
            }]
        }
    };   
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'EA',
            compile : function (tElement, tAttrs)
            {
                var code;
                //No attribute? code is the content
                if ( !tAttrs.code )
                {
                    code = tElement.html();
                    tElement.empty();
                }

                return function (scope, iElement, iAttrs)
                {
                    if ( iAttrs.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(iAttrs.code);
                    }
                    var shouldInterpolate = scope.$eval(iAttrs.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }

                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );

                            iElement.append(contentParent);

                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {
                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);

                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(iAttrs.language || iAttrs.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('customOnChange', customOnChangeDirective);

    /** @ngInject **/
    function customOnChangeDirective()
    {   return {
            restrict: 'A',
		    link: function (scope, element, attrs) {
      			console.log('I am in the directive with an on change of '+attrs.customOnChange);
                var onChangeHandler = scope.$eval(attrs.customOnChange);
      			element.bind('change', onChangeHandler);
        	}
        }
    };   
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('customOnChangeExcel', customOnChangeExcelDirective);

    /** @ngInject **/
    function customOnChangeExcelDirective()
    {   return {
            restrict: 'A',
            link: function (scope, element, attrs) {
    			var onChangeHandler = scope.$eval(attrs.customOnChangeExcel);
    			element.bind('change', onChangeHandler);
    		}
        }
    };   
})();


(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function() {
  'use strict';

  angular
      .module('app.core')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('app.core')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('app.core')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('app.core')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, $http)
    {
        var vm = this;
        vm.makeTeamCurrent = makeTeamCurrent;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            },
            tr: {
                'title'      : 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code'       : 'tr',
                'flag'       : 'tr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.login = login;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];

            // Set the host for staging or production
            vm.thisHost = window.location.host;

            // Fix the profile image
            if (Spark.state.user!=null)
            {
                Spark.state.user.photo_url = Spark.state.user.photo_url.replace(window.location.origin+'/', '')
            }

        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout()
        {
            window.location.href = window.location.origin+'/logout';

/*
            $http({
              method: 'GET',
              url: 'https://www.cadwolf.com/logout',
            }).then(function successCallback( returnData ) {
                window.location.assign('https://www.cadwolf.com/login');
            }, function errorCallback( returnData ) {
                window.location.assign('https://www.cadwolf.com/login');
            });            
*/
        }



        /**
         * Login Function
         */
        function login()
        {
            window.location.href = window.location.origin+'/login';
        }



        /**
         * Change the current team
         *
         * @param item
         */
        function makeTeamCurrent( team )
        {
            $http({
              method: 'GET',
              url: window.location.origin+'/settings/teams/'+team.id+'/switch'
            }).then(function successCallback( returnData ) {
                console.log('The return data from the makeTeamCurrent is ...');
                console.log(returnData);
                Spark.state.user.current_team_id=team.id;
            }, function errorCallback( returnData ) {
            });            
        } 


        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

/*
        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );
*/
        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = true;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, $window)
    {
        // Data
        $rootScope.Spark = $window.Spark;
        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, $provide, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        // toastr configuration
        toastr.options.timeOut = 3000;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.preventDuplicates = true;
        toastr.options.progressBar = true;

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions)
            {
                taOptions.toolbar = [
                    ['html', 'insertLink', 'bold', 'italics', 'underline', 'ul', 'ol', 'quote', 'p', 'justifyLeft', 'justifyCenter', 'justifyRight', 'indent',  'outdent']
                ];

                taOptions.classes = {
                    focussed           : 'focussed',
                    toolbar            : 'ta-toolbar',
                    toolbarGroup       : 'ta-group',
                    toolbarButton      : 'md-button',
                    toolbarButtonActive: 'active',
                    disabled           : '',
                    textEditor         : 'form-control',
                    htmlEditor         : 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.h1.iconclass = 'icon-format-header-1';
                taTools.h2.iconclass = 'icon-format-header-2';
                taTools.h3.iconclass = 'icon-format-header-3';
                taTools.p.iconclass = 'icon-format-paragraph';
                taTools.undo.iconclass = 'icon-undo';
                taTools.redo.iconclass = 'icon-redo';
                taTools.clear.iconclass = 'icon-format-clear';
                taTools.h1.buttontext = '';
                taTools.h2.buttontext = '';
                taTools.h3.buttontext = '';
                taTools.p.buttontext = '';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.html.iconclass = 'icon-format-unlink';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.indent.iconclass = 'icon-indent';
                taTools.outdent.iconclass = 'icon-outdent';
                                
                return taTools;
            }
        ]);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, userMemoryFactory)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);


        // Make URLs with trailing slashes the same. This also makes all default state URLs end with slash
        $urlRouterProvider.rule(function ($injector, $location) {
            var path = $location.url();

            if (path[path.length - 1] === '/' && path[path.length - 2] === '/') {
                return path.replace(/\/+$/,'/');
            }

            if (path[path.length - 1] === '/' || path.indexOf('/?') > -1) {
                return
            }
            
            if (path.indexOf('?') > -1) {
                return path.replace('?', '/?');
            }

            return path + '/';
        });

        $urlRouterProvider.otherwise('/');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        
        // Set layout to have main nav and toolbar or clean
        var layouts = {
            main      : 'app/core/layouts/vertical-navigation.html',
            toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
            navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
        }
        
        if ((window.location.pathname=="/homepage")||
            (window.location.pathname=="/")||
            (window.location.pathname=="/login")||
            (window.location.pathname=="/login/"))
        {   layouts['main']='app/core/layouts/content-only.html';
            layouts['toolbar']='';
            layouts['navigation']='';
        }

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts['main'],
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts['toolbar'],
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts['navigation'],
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config()
    {
    	MathJax.Hub.Config({
            extensions: ["tex2jax.js"], 
            jax: ["input/TeX","output/HTML-CSS"], 
            skipStartupTypeset: true,
            delayStartupUntil: "configured"
        });
        
        // Put your custom configurations here
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        api.sample = $resource(api.baseUrl + 'sample/sample.json');

        // api.fileManager = {
        //     documents: $resource('/files')
        // };


        return api;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.parttree.setup', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.parttree.setup', {
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/partTree/setup/setup.html',
                    controller : 'PartTreeController as vm'
                }
            },
            bodyClass: 'parttree'

        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/partTree/setup');


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.parttree.parttree', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.parttree.parttree', {
            url      : '/PartTree{path:.*}',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/partTree/partTree/partTree.html',
                    controller : 'PartTreeController as vm'
                }
            },
            bodyClass: 'parttree'

        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/partTree/partTree');


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.document.worksheet', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.document.worksheet', {
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/document/worksheet/worksheet.html',
                    controller : 'DocumentController as vm'
                }
            },
            bodyClass: 'worksheet'

        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/document/worksheet');

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dataset.setup', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.dataset.setup', {
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dataset/setup/setup.html',
                    controller : 'DatasetController as vm'
                }
            },
            bodyClass: 'dataset'

        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/dataset/setup');


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dataset.results', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.dataset.results', {
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dataset/results/results.html',
                    controller : 'DatasetController as vm'
                }
            },
            bodyClass: 'dataset'

        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/dataset/results');


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dataset.parse', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.dataset.parse', {
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dataset/parse/parse.html',
                    controller : 'DatasetController as vm'
                }
            },
            bodyClass: 'dataset'

        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/dataset/parse');


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow', [])
        .config(config);


    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        // State
        $stateProvider.state('app.workflow', {
            url      : '/Workflow{path:.*}',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/workflow/workflow.html',
                    controller : 'WorkflowController as vm'
                }
            },
            bodyClass: 'workflow'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/workflow');

        // Navigation
        msNavigationServiceProvider.saveItem('workflow', {
            title : 'Workflow',
            icon  : 'icon-calendar-text',
            state : 'app.workflow',
            weight: 6
        });
    }

})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=\"container\"><div><acme-navbar creation-date=\"main.creationDate\"></acme-navbar></div><div class=\"jumbotron\">\n<h1>\'Allo, \'Allo!</h1><p class=\"lead\"><img src=\"assets/images/yeoman.png\" alt=\"I\'m Yeoman\"><br>\nAlways a pleasure scaffolding your apps.</p><p class=\"animated infinite\" ng-class=\"main.classAnimation\"><a \nclass=\"btn btn-lg btn-success\" ng-click=\"main.showToastr()\">Splendid Toastr</a></p><p>\nWith ♥ thanks to the contributions of<acme-malarkey extra-values=\"[\'Yeoman\', \'Gulp\', \'Angular\']\"></acme-malarkey></p>\n</div><div class=\"col\" ng-repeat=\"awesomeThing in main.awesomeThings | orderBy:\'rank\'\"><div class=\"thumbnail\"><img \nclass=\"pull-right\" ng-src=\"assets/images/{{ awesomeThing.logo }}\" alt=\"{{ awesomeThing.title }}\"><div class=\"caption\">\n<h3>{{ awesomeThing.title }}</h3><p>{{ awesomeThing.description }}</p><p><a ng-href=\"{{ awesomeThing.url }}\">\n{{ awesomeThing.url }}</a></p></div></div></div></div>");
$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.TODAY\">TODAY</md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.CHAT\">CHAT</md-tab-label><md-tab-body><md-content class=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" ng-controller=\"ChatTabController as vm\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label translate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</md-tab-label><md-tab-body>\n<md-content class=\"activity-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar\"><a href=\"https://github.com/Swiip/generator-gulp-angular\">Gulp Angular</a><ul><li class=\"active\"><a\n ng-href=\"#\">Home</a></li><li><a ng-href=\"#\">About</a></li><li><a ng-href=\"#\">Contact</a></li></ul><ul \nclass=\"acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></nav>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" \nui-view=\"navigation\"></div><div id=\"content-container\" flex layout=\"column\"><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","");
$templateCache.put("app/core/directives/bibliography/bibliography.html","<div id=\"bibliography\" layout-fill ng-if=\"vm.cadwolf_fileInfo.item_data.bibliography.show==\'1\'\"><h1 \nclass=\"marginTop50 borderTop paddingTop10\">References</h1><div layout=\"column\" layout-margin \nlayout-align=\"start start\" flex=\"100\"><div \nng-repeat=\"obj in vm.cadwolf_fileInfo.item_data.references | orderBy:obj.refNum track by obj.refID\" flex=\"100\" \nlayout=\"row\"><div ng-if=\"obj[\'type\']==\'web\'\" layout=\"row\" layout-padding \nng-click=\"vm.thisReference=obj; vm.modalType=\'refEdit\'\" class=\"pointerItem marginTop10\"><div class=\"bibNum\">\n{{obj[\'refNum\']}}</div><div class=\"bibText\">{{obj[\'author\']}}</div><div class=\"bibText\"><a href=\"{{address}}\">\n{{obj[\'webtitle\']}}</a>.</div><div class=\"bibText\"><u>{{obj[\'pagetitle\']}}</u> -</div><div class=\"bibText\">\n{{obj[\'sitetitle\']}}.</div><div class=\"bibText\">Date accessed : {{obj[\'dateaccessed\']}}</div></div><div \nng-if=\"obj[\'type\']==\'book\'\" layout=\"row\" layout-padding ng-click=\"vm.thisReference=obj; vm.modalType=\'refEdit\'\" \nclass=\"pointerItem marginTop10\"><div class=\"bibNum\">{{obj[\'refNum\']}}</div><div class=\"bibText\">{{obj[\'author\']}}</div>\n<div class=\"bibText\"><u>{{obj[\'booktitle\']}}</u>.</div><div class=\"bibText\">{{obj[\'publisher\']}}.</div><div \nclass=\"bibText\">{{obj[\'datepublished\']}}.</div><div class=\"bibText\">Edition - {{obj[\'edition\']}}.</div><div \nclass=\"bibText\">Page - {{obj[\'page\']}}.</div></div><div ng-if=\"obj[\'type\']==\'mag\'\" layout=\"row\" layout-padding \nng-click=\"vm.thisReference=obj; vm.modalType=\'refEdit\'\" class=\"pointerItem marginTop10\"><div class=\"bibNum\">\n{{obj[\'refNum\']}}</div><div class=\"bibText\">{{obj[\'author\']}}</div><div class=\"bibText\">{{obj[\'pagetitle\']}}.</div><div\n class=\"bibText\">{{obj[\'magpapername\']}}.</div><div class=\"bibText\">{{obj[\'datepublished\']}}.</div><div \nclass=\"bibText\">Page - {{obj[\'page\']}}.</div></div><div ng-if=\"obj[\'type\']==\'enc\'\" layout=\"row\" layout-padding \nng-click=\"vm.thisReference=obj; vm.modalType=\'refEdit\'\" class=\"pointerItem marginTop10\"><div class=\"bibNum\">\n{{obj[\'refNum\']}}</div><div class=\"bibText\">{{obj[\'author\']}}</div><div class=\"bibText\">{{obj[\'entryname\']}}.</div><div\n class=\"bibText\">{{obj[\'encname\']}}.</div><div class=\"bibText\">Edition - {{obj[\'edition\']}} {{obj[\'year\']}}.</div><div \nclass=\"bibText\">Page - {{obj[\'page\']}}.</div></div></div></div></div>");
$templateCache.put("app/core/directives/leftMenu/left-menu.html","<div class=\"sidenav\" id=\"left-menu-bot\" ng-if=\"vm.menuSet.menuItems.length>0\" md-component-id=\"sidenav\"><md-toolbar \nclass=\"leftMenuToolbar\"><div class=\"md-toolbar-tools\"><span>{{vm.menuSet.headerOne}}</span> <span flex></span>\n<md-button class=\"md-icon-button\" ng-if=\"vm.showMenuTextTop\" ng-click=\"vm.showMenuTextTop=!vm.showMenuTextTop\" \naria-label=\"Click to view list with icons only\"><md-icon md-font-icon=\"icon-chevron-double-down\" class=\"leftChevron\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-if=\"!vm.showMenuTextTop\" \nng-click=\"vm.showMenuTextTop=!vm.showMenuTextTop\" aria-label=\"Click to view list with text\"><md-icon \nmd-font-icon=\"icon-chevron-double-right\" class=\"leftChevron\"></md-icon></md-button></div></md-toolbar><md-list \nclass=\"md-dense sideList\" flex ng-if=\"vm.showMenuTextTop\"><md-list-item ng-repeat=\"thisItem in vm.menuSet.menuItems\" \nlayout-fill layout=\"row\" class=\"mainList\" flex=\"100\" ng-click=\"vm.leftMenuCaller( $event, thisItem.title, 1 )\" \naria-label=\"{{thisItem.title}}\"><div flex=\"20\" layout=\"row\"><md-icon md-font-icon=\"{{thisItem.icon}}\"></md-icon></div>\n<div flex=\"70\" flex-offset=\"10\" class=\"md-body-1\">{{thisItem.title}}</div></md-list-item></md-list><div><md-grid-list \nflex ng-if=\"!vm.showMenuTextTop\" class=\"md-dense sideGrid\" md-cols=\"3\" md-row-height=\"3:2\"><md-grid-tile \nng-repeat=\"thisItem in vm.menuSet.menuItems\" md-rowspan=\"1\" md-colspan=\"1\"><md-icon md-font-icon=\"{{thisItem.icon}}\" \nng-click=\"vm.leftMenuCaller( $event, thisItem.title, 1 )\"></md-icon><md-tooltip md-direction=\"bottom\">\n{{thisItem.title}}</md-tooltip></md-grid-tile></md-grid-list></div></div><div class=\"sidenav\" id=\"left-menu-bot\" \nng-if=\"vm.menuSet.viewItems.length>0\"><md-toolbar class=\"leftMenuToolbar\"><div class=\"md-toolbar-tools\"><span>\n{{vm.menuSet.headerTwo}}</span> <span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.showMenuTextBot=!vm.showMenuTextBot\" ng-if=\"vm.showMenuTextBot\" aria-label=\"Click to view list with text\">\n<md-icon md-font-icon=\"icon-chevron-double-down\" class=\"leftChevron\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.showMenuTextBot=!vm.showMenuTextBot\" ng-if=\"!vm.showMenuTextBot\" \naria-label=\"Click to view list with icons only\"><md-icon md-font-icon=\"icon-chevron-double-right\" class=\"leftChevron\">\n</md-icon></md-button></div></md-toolbar><md-list class=\"md-dense sideList\" flex ng-if=\"vm.showMenuTextBot\">\n<md-list-item ng-repeat=\"thisItem in vm.menuSet.viewItems\" layout-fill layout=\"row\" class=\"mainList\" flex=\"100\" \nng-click=\"vm.leftMenuCaller( $event, thisItem.title, 0 )\" aria-label=\"{{thisItem.title}}\"><div flex=\"20\" layout=\"row\">\n<md-icon md-font-icon=\"{{thisItem.icon}}\"></md-icon></div><div flex=\"70\" flex-offset=\"10\" class=\"md-body-1\">\n{{thisItem.title}}</div></md-list-item></md-list><div><md-grid-list flex ng-if=\"!vm.showMenuTextBot\" \nclass=\"md-dense sideGrid\" md-cols=\"3\" md-row-height=\"3:2\"><md-grid-tile ng-repeat=\"thisItem in vm.menuSet.viewItems\" \nmd-rowspan=\"1\" md-colspan=\"1\"><md-icon md-font-icon=\"{{thisItem.icon}}\" \nng-click=\"vm.leftMenuCaller( $event, thisItem.title, 0 )\"></md-icon><md-tooltip md-direction=\"bottom\">\n{{thisItem.title}}</md-tooltip></md-grid-tile></md-grid-list></div></div><div class=\"sidenav\" \nng-if=\"vm.menuSet.showSaveFile&&vm.editPerm\"><md-button class=\"md-raised red-background\" ng-click=\"vm.saveFile( 1 )\" \nlayout-fill><md-icon md-font-icon=\"icon-content-save\" class=\"iconWhiteBackground\"></md-icon>&nbsp &nbsp Save File\n</md-button></div><div class=\"sidenav\" ng-if=\"vm.menuSet.showSaveTree&&vm.editPerm\"><md-button \nclass=\"md-raised red-background\" ng-click=\"vm.savePartTree( )\" layout-fill><md-icon md-font-icon=\"icon-content-save\" \nclass=\"iconWhiteBackground\"></md-icon>&nbsp &nbsp Save File</md-button></div><div class=\"sidenav\" \nng-if=\"vm.sendingAutocad&&vm.editPerm\"><md-button class=\"md-raised greenBackground\" ng-click=\"\" layout-fill>\nSending Autocad Data</md-button><div id=\"fusionLinkArea\"></div></div><div class=\"\"><div id=\"fusionLinkArea\"></div>\n</div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Row Color\" md-menu-origin \nng-click=\"$mdOpenMenu($event)\" ng-class=\"selectedColor.class\"><span ng-show=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-show=\"!selectedColor.palette\">Select Color</span>\n</md-button><md-menu-content class=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-if=\"!selectedColor.palette\">Select Color</span>\n<md-button class=\"remove-color-button md-icon-button\" ng-click=\"removeColor()\" aria-label=\"Remove Color\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-if=\"!selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in palettes\" ng-click=\"activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-if=\"selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+selectedPalette+\'-\'+hue+\'-bg\'\" \nng-repeat=\"(hue, values) in selectedHues\" ng-click=\"selectColor(selectedPalette,hue)\" layout=\"row\" \nlayout-align=\"start end\" md-ink-ripple><span class=\"label\">{{hue}} </span><i \nng-if=\"selectedPalette == selectedColor.palette && hue == selectedColor.hue\" class=\"s16 icon-check\"></i></div></div>\n</div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-icon \nid=\"ms-search-bar-collapser\" md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></label><input \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"global.search\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"start center\" flex><div class=\"shortcuts\" layout=\"row\" \nlayout-align=\"start center\" ms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" \nng-sortable=\"MsShortcuts.sortableOptions\"><div ng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" \nng-click=\"MsShortcuts.changeActive(shortcut.title); \" ui-sref=\"{{shortcut.uisref}}\" layout-align=\"start center\"><div \nng-if=\"shortcut.status\" class=\"currentShortcut\" layout=\"row\"><md-button class=\"md-icon-button shortcut\" \naria-label=\"{{shortcut.title}}\"><md-icon ng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" \nclass=\"icon s24 currentShortcutIcon\"></md-icon></md-button><div class=\"md-body-1 shortcutCurrentText\">\n{{shortcut.title}}</div></div><div ng-if=\"!shortcut.status\" class=\"idleShortcut\" layout=\"row\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\"><md-icon ng-if=\"shortcut.icon\" \nmd-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon></md-button><div class=\"md-body-1 shortcutText\">\n{{shortcut.title}}</div></div></div></div></div>");
$templateCache.put("app/core/directives/partTreeLimb/part-tree-limb.html","<div>{{partTreeLimb}}</div>");
$templateCache.put("app/core/directives/table-of-contents/table-of-contents.html","<div id=\"tableOfContents\" class=\"marginBottom50 marginTop50\" \nng-if=\"vm.cadwolf_fileInfo.item_data.tableOfContents.show==\'1\'\" flex=\"90\" flex-offset=\"5\"><h1 class=\"paddingBottom10\">\nTable of contents</h1><div layout=\"column\" ng-if=\"vm.cadwolf_fileInfo.item_data.tableOfContents.showType==\'headers\'\">\n<div layout=\"row\" ng-repeat=\"tocObj in vm.cadwolf_worksheet\" ng-if=\"tocObj.component_type_id==\'2\'\"><h1 class=\"tocH1\" \nng-if=\"tocObj.content.hClass==\'header1\'\">{{tocObj.content.text}}</h1><h2 class=\"tocH2\" \nng-if=\"tocObj.content.hClass==\'header2\'&&\n                (vm.cadwolf_fileInfo.item_data.tableOfContents.showLevel==\'H2\' ||\n                 vm.cadwolf_fileInfo.item_data.tableOfContents.showLevel==\'H3\' ||\n                 vm.cadwolf_fileInfo.item_data.tableOfContents.showLevel==\'H4\' ||\n                 vm.cadwolf_fileInfo.item_data.tableOfContents.showLevel==\'H5\' )\">\n{{tocObj.content.text}}</h2><h3 class=\"tocH3\" \nng-if=\"tocObj.content.hClass==\'header3\'&&\n                 (vm.cadwolf_fileInfo.item_data.tableOfContents.showLevel==\'H3\' ||\n                 vm.cadwolf_fileInfo.item_data.tableOfContents.showLevel==\'H4\' ||\n                 vm.cadwolf_fileInfo.item_data.tableOfContents.showLevel==\'H5\' )\">\n{{tocObj.content.text}}</h3><h4 class=\"tocH4\" \nng-if=\"tocObj.content.hClass==\'header4\'&&\n                 (vm.cadwolf_fileInfo.item_data.tableOfContents.showLevel==\'H4\' ||\n                 vm.cadwolf_fileInfo.item_data.tableOfContents.showLevel==\'H5\') \">\n{{tocObj.content.text}}</h4><h4 class=\"tocH5\" \nng-if=\"tocObj.content.hClass==\'header5\'&&\n                 vm.cadwolf_fileInfo.item_data.tableOfContents.showLevel==\'H5\' \">\n{{tocObj.content.text}}</h4></div></div><div layout=\"column\" \nng-if=\"vm.cadwolf_fileInfo.item_data.tableOfContents.showType==\'types\'\"><div layout=\"row\" layout-fill><div flex=\"10\" \nclass=\"md-body-2\">Location</div><div flex=\"85\" class=\"md-body-2\">Item</div></div><div layout=\"row\" layout-fill \nng-repeat=\"tocObj in vm.cadwolf_worksheet\"><div \nng-if=\"tocObj.component_type_id==\'1\' && vm.cadwolf_fileInfo.item_data.tableOfContents.types.text===true\" layout=\"row\" \nlayout-fill layout-margin><div class=\"md-body-2\" flex=\"5\">{{tocObj.order}}</div><md-icon \nmd-font-icon=\"icon-format-text\" flex=\"5\"></md-icon><div class=\"md-body-1\" flex=\"85\">Text Block</div></div><div \nng-if=\"tocObj.component_type_id==\'2\' && vm.cadwolf_fileInfo.item_data.tableOfContents.types.headers===true\" \nlayout=\"row\" layout-fill layout-margin><div class=\"md-body-2\" flex=\"5\">{{tocObj.order}}</div><md-icon \nmd-font-icon=\"icon-format-header-1\" flex=\"5\"></md-icon><div class=\"md-body-1\" flex=\"85\">{{tocObj.content.text}}</div>\n</div><div \nng-if=\"tocObj.component_type_id==\'3\' && vm.cadwolf_fileInfo.item_data.tableOfContents.types.equations===true\" \nlayout=\"row\" layout-fill layout-margin><div class=\"md-body-2\" flex=\"5\">{{tocObj.order}}</div><md-icon \nmd-font-icon=\"icon-sigma\" flex=\"5\"></md-icon><div class=\"md-body-1\" flex=\"85\">Equation</div></div><div \nng-if=\"tocObj.component_type_id==\'4\' && vm.cadwolf_fileInfo.item_data.tableOfContents.types.symbolics===true\" \nlayout=\"row\" layout-fill layout-margin><div class=\"md-body-2\" flex=\"5\">{{tocObj.order}}</div><md-icon \nmd-font-icon=\"icon-link-variant\" flex=\"5\"></md-icon><div class=\"md-body-1\" flex=\"85\">Symbolic Equation</div></div><div \nng-if=\"tocObj.component_type_id==\'5\' && vm.cadwolf_fileInfo.item_data.tableOfContents.types.tables===true\" \nlayout=\"row\" layout-fill layout-margin><div class=\"md-body-2\" flex=\"5\">{{tocObj.order}}</div><md-icon \nmd-font-icon=\"icon-table\" flex=\"5\"></md-icon><div class=\"md-body-1\" flex=\"85\">Table</div></div><div \nng-if=\"tocObj.component_type_id==\'6\' && vm.cadwolf_fileInfo.item_data.tableOfContents.types.forLoops===true\" \nlayout=\"row\" layout-fill layout-margin><div class=\"md-body-2\" flex=\"5\">{{tocObj.order}}</div><md-icon \nmd-font-icon=\"icon-redo-variant\" flex=\"5\"></md-icon><div class=\"md-body-1\" flex=\"85\">For Loop</div></div><div \nng-if=\"tocObj.component_type_id==\'7\' && vm.cadwolf_fileInfo.item_data.tableOfContents.types.whileLoops===true\" \nlayout=\"row\" layout-fill layout-margin><div class=\"md-body-2\" flex=\"5\">{{tocObj.order}}</div><md-icon \nmd-font-icon=\"icon-refresh\" flex=\"5\"></md-icon><div class=\"md-body-1\" flex=\"85\">While Loop</div></div><div \nng-if=\"tocObj.component_type_id==\'8\' && vm.cadwolf_fileInfo.item_data.tableOfContents.types.ifElseStatements===true\" \nlayout=\"row\" layout-fill layout-margin><div class=\"md-body-2\" flex=\"5\">{{tocObj.order}}</div><md-icon \nmd-font-icon=\"icon-cube-unfolded\" flex=\"5\"></md-icon><div class=\"md-body-1\" flex=\"85\">If Else Statement</div></div><div\n ng-if=\"tocObj.component_type_id==\'9\' && vm.cadwolf_fileInfo.item_data.tableOfContents.types.plots===true\" \nlayout=\"row\" layout-fill layout-margin><div class=\"md-body-2\" flex=\"5\">{{tocObj.order}}</div><md-icon \nmd-font-icon=\"icon-chart-line\" flex=\"5\"></md-icon><div class=\"md-body-1\" flex=\"85\">Plot</div></div><div \nng-if=\"tocObj.component_type_id==\'10\' && vm.cadwolf_fileInfo.item_data.tableOfContents.types.images===true\" \nlayout=\"row\" layout-fill layout-margin><div class=\"md-body-2\" flex=\"5\">{{tocObj.order}}</div><md-icon \nmd-font-icon=\"icon-camera\" flex=\"5\"></md-icon><div class=\"md-body-1\" flex=\"85\">Image</div></div><div \nng-if=\"tocObj.component_type_id==\'12\' && vm.cadwolf_fileInfo.item_data.tableOfContents.types.surfaces===true\" \nlayout=\"row\" layout-fill layout-margin><div class=\"md-body-2\" flex=\"5\">{{tocObj.order}}</div><md-icon \nmd-font-icon=\"icon-cube-outline\" flex=\"5\"></md-icon><div class=\"md-body-1\" flex=\"85\">Surface Map</div></div><div \nng-if=\"tocObj.component_type_id==\'13\' && vm.cadwolf_fileInfo.item_data.tableOfContents.types.videos===true\" \nlayout=\"row\" layout-fill layout-margin><div class=\"md-body-2\" flex=\"5\">{{tocObj.order}}</div><md-icon \nmd-font-icon=\"icon-video\" flex=\"5\"></md-icon><div class=\"md-body-1\" flex=\"85\">Video</div></div></div></div></div>");
$templateCache.put("app/main/apps/bugReport/bugReport.html","<div id=\"bugReport\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"content\" layout=\"row\" \nlayout-fill layout-align=\"start start\"><div class=\"main\" ms-scroll><div class=\"mainColumn\"><div class=\"innerColumn\" \nlayout-margin layout=\"column\"><div class=\"cadwolfBox\" layout=\"column\"><div class=\"cadwolfBoxToolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">Report a Bug</div></div><div layout=\"row\" \nlayout-fill flex=\"100\"><div layout=\"row\" flex=\"90\" flex-offset=\"5\"><div layout=\"column\" layout-margin><div \nclass=\"md-body-1 margnTopBottom20\">\nIf you encountered a problem on this page, please fill out the information below. If the problem occured with an equation, select the appropriate item. Be as descriptive as possible and describe the problem, what actions prompted the problem, and if the problem is repetitive.\n</div><textarea id=\"bugDesc\" rows=\"30\" cols=\"100\">Describe the bug</textarea><md-button class=\"md-raised md-primary\" \nng-click=\"vm.submitBug()\">Submit Bug Info</md-button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/connect/connect.html","<div id=\"connect\" class=\"page-layout left-sidenav simple\"><div class=\"content\" md-background-bg layout=\"row\" \nlayout-fill layout-align=\"start start\"><div class=\"mainView\" ms-scroll><div class=\"mainColumn\"><div \nclass=\"innerColumn\" layout-margin layout=\"column\"><div class=\"cadwolfBox\"><div class=\"cadwolfBoxToolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\" flex=\"90\">Files connected to CAD File</div></div>\n<div class=\"content\"><div flex=\"90\" flex-offset=\"5\" class=\"md-body-1 connectDescription\">\nCADWOLF lets users connect multiple documents to a CAD file and it lets multiple CAD files be connected to a single CADWOLF document. To see a list of CADWOLF files that are attached to a specific Onshape document, enter the id number of the Onshape document below and hit enter. That ID number can be found in the URL of the Onshape file as the first number just after the /document/ section of the URL.\n</div><div flex=\"40\" flex-offset=\"30\" layout-align=\"center center\"><md-input-container class=\"fullWidth\"><input \nng-model=\"vm.cadID\" ng-enter=\"vm.getFiles()\"></md-input-container></div><div layout-fill \nng-if=\"vm.connectFiles.length > 0\" ng-include=\"\'app/main/apps/connect/views/cadList.html\'\"></div><div flex=\"90\" \nflex-offset=\"5\" ng-if=\"vm.connectFiles.length == 0\" class=\"md-body-1 connectDescription\">\nThere are no files connected to the entered Onshape document number.</div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/constant/constant.html","<div id=\"constant\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"content\" layout=\"row\" layout-fill \nlayout-align=\"start start\"><div class=\"main\" ms-scroll><div class=\"mainColumn\"><div class=\"innerColumn\" layout-margin \nlayout=\"column\"><div class=\"cadwolfBox\" layout=\"column\"><div class=\"cadwolfBoxToolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">Constants in CADWOLF</div></div><div layout=\"row\" \nlayout-fill flex=\"100\"><div layout=\"row\" flex=\"90\" flex-offset=\"5\"><div layout=\"column\" layout-margin><div \nclass=\"md-body-1 marginTop20\">\nCADWOLF has a few constants that can be used in equations by entering the appropriate text. These are items like the constant \"pi\" or even constants with units attached. When used in an equation, the results are displayed with the constant\'s known symbol. The table below shows what constants are available, their values, what must be entered to invoke the constant, and what will be shown in the results of that equation. Note that you cannot create a variable with the same name as a constant.\n</div><div class=\"simple-table-container marginTop20\"><table class=\"simple\" ms-responsive-table><thead><tr><th>Name\n</th><th>Value</th><th>Units</th><th>Show Value</th><th>Description</th></tr></thead><tfoot><tr><td></td></tr></tfoot>\n<tbody><tr ng-repeat=\"constant in vm.constantData\"><td>{{constant.name}}</td><td>{{constant.value}}</td><td>\n{{constant.units}}</td><td mathjax-bind=\"constant.showvalue\">{{constant.showvalue}}</td><td>{{constant.Description}}\n</td></tr></tbody></table></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/dataset/dataset.html","<div id=\"dataset\" ng-if=\"vm.showType==\'DatasetEmpty\'\" class=\"page-layout simple left-sidenav\" \nng-include=\"\'app/main/apps/dataset/datasetEmpty.html\'\"></div><div id=\"setup\" ng-if=\"vm.showType==\'DatasetSetup\'\" \nclass=\"page-layout simple left-sidenav inner-sidenav\" ng-include=\"\'app/main/apps/dataset/setup/setup.html\'\"></div><div \nid=\"parse\" ng-if=\"vm.showType==\'DatasetInput\'\" class=\"page-layout simple left-sidenav inner-sidenav\" \nng-include=\"\'app/main/apps/dataset/parse/parse.html\'\"></div><div id=\"results\" ng-if=\"vm.showType==\'DatasetResults\'\" \nclass=\"page-layout simple left-sidenav inner-sidenav\" ng-include=\"\'app/main/apps/dataset/results/results.html\'\"></div>");
$templateCache.put("app/main/apps/dataset/datasetEmpty.html","<div class=\"content\" md-background-bg layout=\"row\" layout-fill layout-align=\"start start\"><div class=\"mainEmpty\" \nms-scroll><div class=\"mainColumn\"><div class=\"innerColumn\" layout-margin layout=\"column\"><div class=\"cadwolfBox\"><div \nclass=\"cadwolfBoxToolbar\" layout=\"row\" layout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">Datasets\n</div></div><div layout=\"row\" layout-fill flex=\"100\"><div layout=\"row\" flex=\"90\" flex-offset=\"5\"><div layout=\"column\" \nlayout-margin><div class=\"md-body-1 marginTop20\">\nDatasets are places where users can take text or excel files and then upload them and parse them into variables to be used in CADWOLF documents. This page shows the most recent datasets that you have visited as well as the datasets that you have favorited.\n</div><div layout=\"column\" class=\"marginTop20\" ng-include=\"\'app/main/apps/dataset/views/emptyList.html\'\"></div></div>\n</div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/document/document.html","<div id=\"worksheet\" ng-if=\"vm.showType==\'Document\'\" ng-class=\"vm.pageClass\" \nng-include=\"\'app/main/apps/document/worksheet/worksheet.html\'\"></div><div id=\"document\" \nng-if=\"vm.showType==\'DocumentEmpty\'\" class=\"page-layout simple left-sidenav inner-sidenav\" \nng-include=\"\'app/main/apps/document/documentEmpty.html\'\"></div>");
$templateCache.put("app/main/apps/document/documentEmpty.html","<div class=\"content\" md-background-bg layout=\"row\" layout-fill layout-align=\"start start\"><div class=\"mainEmpty\" \nms-scroll><div class=\"mainColumn\"><div class=\"innerColumn\" layout-margin layout=\"column\"><div class=\"cadwolfBox\"><div \nclass=\"cadwolfBoxToolbar\" layout=\"row\" layout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">Documents\n</div></div><div layout=\"row\" layout-fill flex=\"100\"><div layout=\"row\" flex=\"90\" flex-offset=\"5\"><div layout=\"column\" \nlayout-margin><div class=\"md-body-1 marginTop20\"><p>\nDocuments are the backbone of CADWOLF. Documents are where users add text, equations, plots, etc. The lists below show the most recent documents that the user has accessed and the documents favorited by you.\n</p></div><div layout=\"column\" class=\"marginTop20\" ng-include=\"\'app/main/apps/document/emptyList.html\'\"></div></div>\n</div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/document/emptyList.html","<div class=\"md-headline marginTop20\" ng-if=\"Spark.state.user == null\">Common Documents</div><md-list \nng-if=\"Spark.state.user == null\" class=\"marginTop20\"><md-list-item layout=\"row\" class=\"borderBottom\"><div flex=\"15\">\n&nbsp</div><div flex=\"30\" translate=\"FM.NAME\" class=\"md-title\">Name</div><div flex=\"55\" hide-xs \ntranslate=\"FM.LOCATION\" class=\"md-title\">Location</div></md-list-item><md-list-item layout=\"row\" class=\"borderBottom\">\n<div flex=\"10\"><md-icon md-font-icon=\"icon-file-outline\" ng-click=\"vm.goToURL(\'/Documentation/What_is_CADWOLF\')\" \nclass=\"hoverMe\"></md-icon></div><div flex=\"30\">What is CADWOLF</div><div flex=\"55\">/Documentation/What_is_CADWOLF</div>\n<div flex=\"5\"></div></md-list-item><md-list-item layout=\"row\" class=\"borderBottom\"><div flex=\"10\"><md-icon \nmd-font-icon=\"icon-file-outline\" ng-click=\"vm.goToURL(\'/Documentation/Users_Guide_-_Workspaces/\')\" class=\"hoverMe\">\n</md-icon></div><div flex=\"30\">Users Guide - Workspaces</div><div flex=\"55\">/Documentation/Users_Guide_-_Workspaces/\n</div><div flex=\"5\"></div></md-list-item><md-list-item layout=\"row\" class=\"borderBottom\"><div flex=\"10\"><md-icon \nmd-font-icon=\"icon-file-outline\" ng-click=\"vm.goToURL(\'/Documentation/Users_Guide_-_Documents/\')\" class=\"hoverMe\">\n</md-icon></div><div flex=\"30\">Users Guide - Documents</div><div flex=\"55\">/Documentation/Users_Guide_-_Documents/\n</div><div flex=\"5\"></div></md-list-item></md-list><div class=\"md-headline marginTop20\" \nng-if=\"Spark.state.user != null\">Favorite Documents</div><md-list \nng-if=\"Spark.state.user.user_info.favDocuments.length>0\" class=\"marginTop20\"><md-list-item layout=\"row\" \nclass=\"borderBottom\"><div flex=\"15\">&nbsp</div><div flex=\"30\" translate=\"FM.NAME\" class=\"md-title\">Name</div><div \nflex=\"55\" hide-xs translate=\"FM.LOCATION\" class=\"md-title\">Location</div></md-list-item><md-list-item \nng-repeat=\"document in Spark.state.user.user_info.favDocuments\" layout=\"row\" class=\"borderBottom\"><div flex=\"5\">\n<md-icon md-font-icon=\"icon-file-outline\" ng-click=\"vm.goToURL(\'/Document/\'+document.location)\" class=\"hoverMe\">\n</md-icon></div><div flex=\"30\">{{document.name}}</div><div flex=\"50\" style=\"word-break:break-all\">{{document.location}}\n</div><div flex=\"5\"><md-icon md-font-icon=\"icon-close-circle-outline\" ng-click=\"vm.removeFavItem( document )\" \nclass=\"hoverMe\"></md-icon></div></md-list-item></md-list><div class=\"md-body-1 marginTop20\" \nng-if=\"Spark.state.user.user_info.favDocuments.length==0\">\nUsers can \"favorite\" documents so that they can be easily accessed. Those documents can be shown here. To favorite a document, clikc the heart icon in the upper right of the document view.\n</div><div class=\"md-headline marginTop20\" ng-if=\"Spark.state.user != null\">Recent Documents</div><md-list \nng-if=\"Spark.state.user.user_info.documents.length > 0\" class=\"marginTop20\"><md-list-item layout=\"row\" \nclass=\"borderBottom\"><div flex=\"15\">&nbsp</div><div flex=\"30\" translate=\"FM.NAME\" class=\"md-title\">Name</div><div \nflex=\"55\" hide-xs translate=\"FM.LOCATION\" class=\"md-title\">Location</div></md-list-item><md-list-item \nng-repeat=\"document in Spark.state.user.user_info.documents\" layout=\"row\" class=\"borderBottom\"><div flex=\"5\"><md-icon \nmd-font-icon=\"icon-file-outline\" ng-click=\"vm.goToURL(\'/Document/\'+document.location)\" class=\"hoverMe\"></md-icon></div>\n<div flex=\"30\">{{document.name}}</div><div flex=\"55\" style=\"word-break:break-all\">{{document.location}}</div>\n</md-list-item></md-list><div class=\"md-body-1 marginTop20\" ng-if=\"Spark.state.user.user_info.documents.length==0\">\nThe list below will show the 10 most recently visited documents.</div>");
$templateCache.put("app/main/apps/forum/forum.html","<div id=\"forum\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"content\" layout=\"row\" layout-fill \nlayout-align=\"start start\"><div class=\"main\" ms-scroll><div class=\"mainColumn\"><div class=\"innerColumn\" layout-margin \nlayout=\"column\"><div class=\"cadwolfBox\" ng-if=\"vm.pageType==\'default\'\" \nng-include=\"\'app/main/apps/forum/views/mainForum.html\'\" layout=\"column\"></div><div class=\"cadwolfBox\" \nng-if=\"vm.pageType==\'forumList\'\" ng-include=\"\'app/main/apps/forum/views/forumList.html\'\" layout=\"column\"></div><div \nclass=\"cadwolfBox\" ng-if=\"vm.pageType==\'forum\'\" ng-include=\"\'app/main/apps/forum/views/viewForum.html\'\" \nlayout=\"column\"></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/partTree/partTree.html","<div id=\"parttree\" ng-if=\"vm.showType==\'PartTreeEmpty\'\" class=\"page-layout simple left-sidenav\" \nng-include=\"\'app/main/apps/partTree/partTreeEmpty.html\'\" layout=\"row\"></div><div id=\"parttree\" \nng-if=\"vm.showType!=\'PartTreeEmpty\'\" class=\"page-layout simple left-sidenav inner-sidenav\" layout=\"row\"><div \nclass=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><left-menu vm=\"vm\" \nng-if=\"vm.cadwolf_fileInfo!==undefined\"></left-menu><div class=\"mainEdit\" ms-scroll><div class=\"mainColumn\"><div \nclass=\"innerColumn\"><div flex=\"100\" layout-fill ng-if=\"vm.showType==\'PartTreeSetup\'\" \nng-include=\"\'app/main/apps/partTree/views/partTreeInfo.html\'\"></div><div flex=\"100\" layout-fill \nng-if=\"vm.showType==\'PartTreeSetup\'\" ng-include=\"\'app/main/apps/partTree/views/partTreeCadType.html\'\"></div><div \nflex=\"100\" layout-fill ng-if=\"vm.showType==\'PartTreeSetup\'\" \nng-include=\"\'app/main/apps/partTree/views/partTreeSetup.html\'\"></div><div flex=\"100\" layout-fill \nng-if=\"vm.showType==\'PartTree\'\" ng-include=\"\'app/main/apps/partTree/views/partTree.html\'\"></div><div flex=\"100\" \nlayout-fill ng-if=\"vm.showType==\'PartTreeDocs\'\" ng-include=\"\'app/main/apps/partTree/views/partTreeDocs.html\'\"></div>\n</div></div></div></div></div>");
$templateCache.put("app/main/apps/partTree/partTreeEmpty.html","<div class=\"content\" md-background-bg layout=\"row\" layout-fill layout-align=\"start start\"><div class=\"mainView\" \nms-scroll><div class=\"mainColumn\"><div class=\"emptyInnerColumn\" layout-margin layout=\"column\"><div class=\"cadwolfBox\">\n<div class=\"cadwolfBoxToolbar\" layout=\"row\" layout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">\nPart Trees</div></div><div layout=\"row\" layout-fill flex=\"100\"><div layout=\"row\" flex=\"90\" flex-offset=\"5\"><div \nlayout=\"column\" layout-margin><div class=\"md-body-1 marginTop20\">\nPart trees separate CADWOLF from other mathematical systems. Part trees let the user build a system out of independent documents that each represent a component. The module lets the user tie those components together to combine things like cost and weight and automatically update to changes.\n</div><div layout=\"column\" class=\"marginTop20\" ng-include=\"\'app/main/apps/partTree/views/emptyList.html\'\"></div></div>\n</div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/plot/plot.html","<div id=\"plot\" class=\"page-layout simple\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><md-content \nclass=\"content\" flex ms-scroll><div flex=\"100\" layout-fill ng-include=\"\'app/main/apps/plot/views/showPlot.html\'\"></div>\n</md-content></div><div ng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpecVer/plotSpec.html\'\" \nlayout=\"row\"></div></div>");
$templateCache.put("app/main/apps/plot/plotEmpty.html","<div id=\"plot\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"content\" md-background-bg \nlayout=\"row\" layout-fill layout-align=\"start start\"><div class=\"mainEmpty\" ms-scroll><div class=\"mainColumn\"><div \nclass=\"innerColumn\" layout-margin layout=\"column\"><div class=\"cadwolfBox\"><div class=\"cadwolfBoxToolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">Plots</div></div><div layout=\"row\" layout-fill \nflex=\"100\"><div layout=\"row\" flex=\"90\" flex-offset=\"5\"><div layout=\"column\" layout-margin><div layout=\"column\" \nlayout-margin><div class=\"md-body-1 marginTop20\">\nCADWOLF provides a wide arrange of two dimensional plots. These plots are embedded in documents and use the data within that document. Occasionally, a user might want to embed a small chart in a document and still allow a reader to see the chart at full screen size or to simply provide a link to a chart instead of a document. This view provides that option.\n</div><div layout=\"column\" class=\"marginTop20\" ng-include=\"\'app/main/apps/plot/views/enterDocument.html\'\"></div><div \nlayout=\"column\" class=\"marginTop20\" ng-include=\"\'app/main/apps/plot/views/emptyList.html\'\"></div></div></div></div>\n</div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/profile/profile.html","<div id=\"profile\" ng-class=\"vm.pageClass\"><div class=\"content\" md-background-bg layout=\"row\" layout-fill \nlayout-align=\"start start\"><left-menu vm=\"vm\" ng-if=\"vm.editPerm\"></left-menu><div ng-class=\"vm.pageMainClass\" \nms-scroll><div class=\"mainColumn\"><div class=\"innerColumn\" layout-margin layout-align=\"center center\" layout=\"column\" \nng-if=\"vm.showType==\'profileProfile\'\"><div layout-fill ng-include=\"\'app/main/apps/profile/views/bio.html\'\"></div></div>\n<div class=\"innerColumn\" layout-margin layout-align=\"center center\" layout=\"column\" \nng-if=\"vm.showType==\'profileOverview\'\"><div layout-fill ng-include=\"\'app/main/apps/profile/views/myWorkspace.html\'\">\n</div><div layout-fill ng-if=\"( Spark.state.user === undefined ) || ( Spark.state.user === null )\" \nng-include=\"\'app/main/apps/profile/views/noUser.html\'\"></div></div><div class=\"innerColumn\" layout-margin \nlayout-align=\"center center\" layout=\"column\" ng-if=\"vm.showType==\'profileMessages\'\"><div layout-fill \nng-include=\"\'app/main/apps/profile/views/messages.html\'\"></div><div layout-fill \nng-if=\"( Spark.state.user === undefined ) || ( Spark.state.user === null )\" \nng-include=\"\'app/main/apps/profile/views/noUser.html\'\"></div></div><div class=\"innerColumn\" layout-margin \nlayout-align=\"center center\" layout=\"column\" ng-if=\"vm.showType==\'profileWorkspaces\'\"><div layout-fill \nng-include=\"\'app/main/apps/profile/views/workspaces.html\'\"></div></div><div class=\"innerColumn\" layout-margin \nlayout-align=\"center center\" layout=\"column\" ng-if=\"vm.showType==\'profileTeams\'\"><div layout-fill \nng-include=\"\'app/main/apps/profile/views/teams.html\'\"></div></div><div class=\"innerColumn\" layout-margin \nlayout-align=\"center center\" layout=\"column\" ng-if=\"vm.showType==\'profileInvitations\'\"><div layout-fill \nng-include=\"\'app/main/apps/profile/views/invitations.html\'\"></div></div><div class=\"innerColumn\" layout-margin \nlayout-align=\"center center\" layout=\"column\" ng-if=\"vm.showType==\'profileNotifications\'\"><div layout-fill \nng-include=\"\'app/main/apps/profile/views/notifications.html\'\"></div></div><div class=\"innerColumn\" layout-margin \nlayout-align=\"center center\" layout=\"column\" ng-if=\"vm.showType==\'profileAnnouncements\'\"><div layout-fill \nng-include=\"\'app/main/apps/profile/views/announcements.html\'\"></div></div><div class=\"innerColumn\" layout-margin \nlayout-align=\"center center\" layout=\"column\" ng-if=\"vm.showType==\'profileMembers\'\"><div layout-fill \nng-include=\"\'app/main/apps/profile/views/members.html\'\"></div></div><div class=\"innerColumn\" layout-margin \nlayout-align=\"center center\" layout=\"column\" ng-if=\"vm.showType==\'profileCAD\'\"><div layout-fill \nng-include=\"\'app/main/apps/profile/views/cadSync.html\'\"></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/surface/surface.html","<div id=\"plot\" class=\"page-layout simple\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><md-content \nclass=\"content\" flex ms-scroll><div flex=\"100\" layout-fill ng-include=\"\'app/main/apps/surface/views/showSurface.html\'\">\n</div></md-content></div><div \nng-include=\"\'app/main/apps/document/worksheet/views/templates/chartSpecHor/chartSpecHor.html\'\"></div><div \nng-include=\"\'app/main/apps/document/worksheet/views/templates/chartSpecVer/chartSpecVer.html\'\"></div></div>");
$templateCache.put("app/main/apps/surface/surfaceEmpty.html","<div id=\"surface\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"content\" md-background-bg \nlayout=\"row\" layout-fill layout-align=\"start start\"><div class=\"mainEmpty\" ms-scroll><div class=\"mainColumn\"><div \nclass=\"innerColumn\" layout-margin layout=\"column\"><div class=\"cadwolfBox\"><div class=\"cadwolfBoxToolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">Surfaces</div></div><div layout=\"row\" layout-fill \nflex=\"100\"><div layout=\"row\" flex=\"90\" flex-offset=\"5\"><div layout=\"column\" layout-margin><div \nclass=\"md-body-1 marginTop20\">\nSurfaces in CADWOLF are embedded in Surfaces. The surface may be a small size in the in the document. This module lets users view a surface in a full size window.\n</div><div layout=\"column\" class=\"marginTop20\" ng-include=\"\'app/main/apps/surface/views/emptyList.html\'\"></div></div>\n</div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/teams/teams.html","<div id=\"teams\" class=\"page-layout simple left-sidenav\" ng-if=\"vm.showType==\'teamList\'\"><div class=\"content\" \nmd-background-bg layout=\"row\" layout-fill layout-align=\"start start\"><div class=\"main\" ms-scroll><div \nclass=\"mainColumn\"><div class=\"innerColumn\" layout-margin layout=\"column\"><div \nng-include=\"\'app/main/apps/teams/views/teamList.html\'\" ng-if=\"vm.showType==\'teamList\'\"></div></div></div></div></div>\n</div><div id=\"teams\" class=\"page-layout simple left-sidenav\" ng-if=\"vm.showType==\'memberList\'\"><div class=\"content\" \nmd-background-bg layout=\"row\" layout-fill layout-align=\"start start\"><div class=\"main\" ms-scroll><div \nclass=\"mainColumn\"><div class=\"innerColumn\" layout-margin layout=\"column\"><div \nng-include=\"\'app/main/apps/teams/views/memberList.html\'\" ng-if=\"vm.showType==\'memberList\'\"></div></div></div></div>\n</div></div>");
$templateCache.put("app/main/apps/unit/unit.html","<div id=\"unit\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"content\" layout=\"row\" layout-fill \nlayout-align=\"start start\"><div class=\"main\" ms-scroll><div class=\"mainColumn\"><div class=\"innerColumn\" layout-margin \nlayout=\"column\"><div class=\"cadwolfBox\" layout=\"column\"><div class=\"cadwolfBoxToolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">Units in CADWOLF</div></div><div layout=\"row\" \nlayout-fill flex=\"100\"><div layout=\"row\" flex=\"90\" flex-offset=\"5\"><div layout=\"column\" layout-margin><div \nclass=\"md-body-1\">\nWhen a user enters a number into a CADWOLF equation, they can follow that number with a unit. CADWOLF will group that number and unit and ensure that the math that follows is sound. For example, an equation of \"num = 2 m + 15 in\" will recognize that the user is attempting to add 2 meters to 15 inches. Since both of those are lengths, CADWOLF will convert the numbers to metric - if needed - and perform the desired operation. If the user attempts to add items of two different quantities - like a length and a force - then the equation will produce an error. However, you can multiply and divide units. Complex units such as forces are recognized as well.\n</div><div class=\"md-body-1\">\nThe table below shows all of the units that CADWOLF will recognize. To use a unit, the abbreviation (in the left column) is simply added after the number. The remainder of the table shows the unit that the item is converted to as well as the conversion factor.\n</div><div class=\"simple-table-container\"><table class=\"simple\" ms-responsive-table><thead><tr><th>Unit</th><th>Name\n</th><th>Conversion Unit</th><th>Conversion Factor</th><th>Quantity</th><th>Class</th></tr></thead><tfoot><tr><td></td>\n</tr></tfoot><tbody><tr ng-repeat=\"unit in vm.unitData\"><td>{{unit.unit}}</td><td>{{unit.name}}</td><td>\n{{unit.conv_unit}}</td><td>{{unit.conv_factor}}</td><td>{{unit.quantity}}</td><td>{{unit.Class}}</td></tr></tbody>\n</table></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/workflow/workflow.html","<div id=\"workflow\" ng-if=\"vm.showType==\'WorkflowEmpty\'\" class=\"page-layout simple left-sidenav\" \nng-include=\"\'app/main/apps/workflow/workflowEmpty.html\'\" layout=\"row\"></div><div id=\"workflow\" \nng-if=\"vm.showType!=\'workflowEmpty\'\" class=\"page-layout simple left-sidenav inner-sidenav\" layout=\"row\"><div \nclass=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><div class=\"mainEdit\" ms-scroll><div \nclass=\"mainColumn\"><div class=\"innerColumn\"><div flex=\"100\" layout-fill \nng-include=\"\'app/main/apps/workflow/views/workflowMain.html\'\"></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/workflow/workflowEmpty.html","<div class=\"content\" md-background-bg layout=\"row\" layout-fill layout-align=\"start start\"><div class=\"mainView\" \nms-scroll><div class=\"mainColumn\"><div class=\"emptyInnerColumn\" layout-margin layout=\"column\"><div class=\"cadwolfBox\">\n<div class=\"cadwolfBoxToolbar\" layout=\"row\" layout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">\nPart Trees</div></div><div layout=\"row\" layout-fill flex=\"100\"><div layout=\"row\" flex=\"90\" flex-offset=\"5\"><div \nlayout=\"column\" layout-margin><div class=\"md-body-1 marginTop20\">Workflows are coming ...</div><div layout=\"column\" \nclass=\"marginTop20\" ng-include=\"\'app/main/apps/workflow/views/emptyList.html\'\"></div></div></div></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/workflow/workflowQuestion.html","I am here");
$templateCache.put("app/main/apps/workspace/workspace.html","<div id=\"workspace\" ng-if=\"vm.noWorkspace\" class=\"page-layout simple left-sidenav\"><div class=\"content\" \nmd-background-bg layout=\"row\" layout-fill layout-align=\"start start\"><div class=\"mainView\" ms-scroll><div \nclass=\"mainColumn text-center\"><div class=\"innerColumn\" layout-margin><div class=\"md-subhead\">\nNo workspace was found at this URL</div></div></div></div></div></div><div id=\"workspace\" \nng-if=\"vm.showType==\'WorkspaceEmpty\'\" class=\"page-layout simple left-sidenav\"><div class=\"content\" md-background-bg \nlayout=\"row\" layout-fill layout-align=\"start start\"><div class=\"mainView\" ms-scroll><div class=\"mainColumn\"><div \nclass=\"innerColumn\" layout-margin><div ng-include=\"\'app/main/apps/workspace/workspaceEmpty.html\'\"></div></div></div>\n</div></div></div><div id=\"workspace\" \nng-if=\"vm.cadwolf_permissions[\'view\']==1 && vm.cadwolf_permissions[\'edit\']==0 && vm.showType==\'Workspace\'\" \nclass=\"page-layout simple left-sidenav\"><div class=\"content\" md-background-bg layout=\"row\" layout-fill \nlayout-align=\"start start\"><div class=\"mainView\" ms-scroll><div class=\"mainColumn\"><div class=\"innerColumn\" \nlayout-margin ng-if=\"vm.cadwolf_fileInfo.item_data.viewType == \'list\'\" layout=\"column\"><div class=\"cadwolfBox\"><div \nclass=\"cadwolfBoxToolbar\" layout=\"row\" layout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\" flex=\"90\">\n{{vm.cadwolf_fileInfo.name}}</div><div layout=\"row\" flex=\"20\" layout-align=\"end end\" \nng-include=\"\'app/main/apps/workspace/views/list/selectUp.html\'\"></div></div><div class=\"content\"><div flex=\"90\" \nflex-offset=\"5\" class=\"md-body-1 workspaceDescription\" ng-bind-html=\"vm.cadwolf_fileInfo.item_data.description\"></div>\n<md-list layout-fill ng-if=\"( vm.cadwolf_files.length > 0 )\" \nng-include=\"\'app/main/apps/workspace/views/list/list-view.html\'\"></md-list><div ng-if=\"vm.cadwolf_files.length==0\"><div\n class=\"md-body-2\">There are no files within this workspace.</div></div></div></div></div><div class=\"innerColumnSlim\" \nlayout-margin ng-if=\"vm.cadwolf_fileInfo.item_data.viewType == \'quilt\'\" layout=\"column\"><div class=\"cadwolfBox\"><div \nclass=\"cadwolfBoxToolbar\" layout=\"row\" layout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\" flex=\"90\">\n{{vm.cadwolf_fileInfo.name}}</div><div layout=\"row\" flex=\"20\" layout-align=\"end end\" \nng-include=\"\'app/main/apps/workspace/views/list/selectUp.html\'\"></div></div><div class=\"content\"><div flex=\"90\" \nflex-offset=\"5\" class=\"md-body-1 workspaceDescription\" ng-bind-html=\"vm.cadwolf_fileInfo.item_data.description\"></div>\n<md-list layout-fill ng-if=\"( vm.cadwolf_files.length > 0 )\" \nng-include=\"\'app/main/apps/workspace/views/list/quilt-view.html\'\"></md-list><div ng-if=\"vm.cadwolf_files.length==0\">\n<div class=\"md-body-2\">There are no files within this workspace.</div></div></div></div></div></div></div></div></div>\n<div id=\"workspace\" ng-if=\"vm.cadwolf_permissions[\'edit\']==1 && vm.showType==\'Workspace\'\" \nclass=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"content\" md-background-bg layout=\"row\" layout-fill \nlayout-align=\"start start\"><left-menu vm=\"vm\"></left-menu><div class=\"mainEdit\" ms-scroll><div class=\"mainColumn\"><div \nclass=\"innerColumn\" layout-margin ng-if=\"vm.cadwolf_fileInfo.item_data.viewType == \'list\'\" layout=\"column\"><div \nclass=\"cadwolfBox\"><div class=\"cadwolfBoxToolbar\" layout=\"row\" flex=\"100\" ng-click=\"vm.select( vm.cadwolf_fileInfo )\" \nng-dblclick=\"vm.showSmallModal(\'\', vm.cadwolf_fileInfo, \'Edit Title\', true)\" \nng-class=\"{\'selected\' : vm.selected === vm.cadwolf_fileInfo}\" layout-align=\"space-between center\"><div \nclass=\"cadwolfToolbarTools\" flex=\"90\">{{vm.cadwolf_fileInfo.name}}</div><div layout=\"row\" flex=\"20\" layout-fill \nlayout-align=\"space-between center\" ng-include=\"\'app/main/apps/workspace/views/list/selectUp.html\'\"></div></div><div \nclass=\"content\"><div flex=\"90\" flex-offset=\"5\" class=\"md-body-1 workspaceDescription\" \nng-bind-html=\"vm.cadwolf_fileInfo.item_data.description\" ng-click=\"vm.select( vm.cadwolf_fileInfo )\" \nng-class=\"{\'selected\' : vm.selected === vm.cadwolf_fileInfo}\" \nng-dblclick=\"vm.showMediumModal(\'\', vm.cadwolf_fileInfo, \'Edit Description\', true)\"></div><md-list layout-fill \nng-if=\"vm.cadwolf_files.length > 0 \" ng-include=\"\'app/main/apps/workspace/views/list/list-edit.html\'\"></md-list><div \nng-if=\"vm.cadwolf_files.length==0\"><div class=\"md-body-2\">There are no files within this workspace.</div></div></div>\n</div></div><div class=\"innerColumnSlim\" layout-margin ng-if=\"vm.cadwolf_fileInfo.item_data.viewType == \'quilt\'\" \nlayout=\"column\"><div class=\"cadwolfBox\"><div class=\"cadwolfBoxToolbar\" layout=\"row\" flex=\"100\" \nng-click=\"vm.select( vm.cadwolf_fileInfo )\" \nng-dblclick=\"vm.showSmallModal(\'\', vm.cadwolf_fileInfo, \'Edit Title\', true)\" \nng-class=\"{\'selected\' : vm.selected === vm.cadwolf_fileInfo}\" layout-align=\"space-between center\"><div \nclass=\"cadwolfToolbarTools\" flex=\"90\">{{vm.cadwolf_fileInfo.name}}</div><div layout=\"row\" flex=\"20\" layout-fill \nlayout-align=\"space-between center\" ng-include=\"\'app/main/apps/workspace/views/list/selectUp.html\'\"></div></div><div \nclass=\"content\"><div flex=\"90\" flex-offset=\"5\" class=\"md-body-1 workspaceDescription\" \nng-bind-html=\"vm.cadwolf_fileInfo.item_data.description\" ng-click=\"vm.select( vm.cadwolf_fileInfo )\" \nng-class=\"{\'selected\' : vm.selected === vm.cadwolf_fileInfo}\" \nng-dblclick=\"vm.showMediumModal(\'\', vm.cadwolf_fileInfo, \'Edit Description\', true)\"></div><md-list layout-fill \nng-if=\"vm.cadwolf_files.length > 0 \" ng-include=\"\'app/main/apps/workspace/views/list/quilt-edit.html\'\"></md-list><div \nng-if=\"vm.cadwolf_files.length==0\"><div class=\"md-body-2\">There are no files within this workspace.</div></div></div>\n</div></div></div></div></div></div>");
$templateCache.put("app/main/apps/workspace/workspaceEmpty.html","<div class=\"cadwolfBox\"><div class=\"cadwolfBoxToolbar\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"cadwolfToolbarTools\">Workspaces</div></div><div layout=\"row\" layout-fill flex=\"100\"><div layout=\"row\" flex=\"90\" \nflex-offset=\"5\"><div layout=\"column\" layout-margin><div class=\"md-body-1 marginTop20\">\nWorkspaces in CADWOLF are a lot like folders - they hold files, images, datasets, part trees, and other workspaces. Each workspace is essentially a subfolder and adds another level to the URL needed to access the workspace. When you are viewing a workspace, you will see its contents and relevant information. If you have permission to edit the workspace, you will be able to add and delete items as well as rename items, copy them, and move them. The tutorial for workspaces is available \n<a href=\"http://www.cadwolf.com/Documents/Documentation/Users_Guide_-_Workspaces\">here</a>\n. If you wish to navigate to a specific workspace, you may enter the workspace name / path in the input box below.\n</div><div class=\"marginTop20\"><md-input-container layout-fill><label>Desired Workspace</label><input \nng-model=\"vm.thisAddress\" ng-enter=\"vm.goToURL( vm.thisAddress );\"></md-input-container></div><div class=\"marginTop20\" \nlayout-margin layout-padding ng-include=\"\'app/main/apps/workspace/views/list/emptyList.html\'\"></div></div></div></div>\n</div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image-wrapper\"><span class=\"logo-image\"></span>\n</span> <span class=\"logo-text\"><a href=\"\">CADWOLF</a></span></div><md-icon class=\"fold-toggle s18\" \nmd-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar>\n<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\">\n<div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> \n<span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list>\n<md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span>\n</md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div \nclass=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider>\n</md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\">\n<h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list>\n<md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader>\n<md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 \ntranslate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" \naria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" \nng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><ms-search-bar>\n</ms-search-bar><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.editor\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\" \nng-if=\"Spark.state.user!=null && ( vm.thisHost == \'www.cadwolf.com\' || vm.thisHost == \'https://www.cadwolf.com\' )\"><img\n md-menu-align-target class=\"avatar\" ng-src=\"{{Spark.state.user.photo_url}}\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"></div><div class=\"avatar-wrapper\" \nng-if=\"Spark.state.user!=null && vm.thisHost == \'cadwolf-staging.herokuapp.com\'\"><img md-menu-align-target \nclass=\"avatar\" ng-src=\"{{Spark.state.user.photo_url}}\" \non-error-src=\"https://cadwolf-staging.s3.amazonaws.com/Profile/default.png\"></div><div class=\"avatar-wrapper\" \nng-if=\"Spark.state.user==null && ( vm.thisHost == \'www.cadwolf.com\' || vm.thisHost == \'https://www.cadwolf.com\' )\"><img\n md-menu-align-target=\"\" class=\"avatar\" src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"></div><div \nclass=\"avatar-wrapper\" ng-if=\"Spark.state.user==null && vm.thisHost == \'cadwolf-staging.herokuapp.com\'\"><img \nmd-menu-align-target=\"\" class=\"avatar\" src=\"https://cadwolf-staging.s3.amazonaws.com/Profile/default.png\"></div><span \nng-if=\"Spark.state.user!=null\" class=\"username\" hide-xs>{{Spark.state.user.name}} </span><span \nng-if=\"Spark.state.user==null\" class=\"username\" hide-xs>Not Logged In</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.profile\" ng-if=\"Spark.state.user!=null\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon>\n<md-button>My Profile</md-button></md-menu-item><md-menu-divider ng-if=\"Spark.state.user!=null\"></md-menu-divider>\n<md-menu-item class=\"md-indent\" ng-if=\"Spark.state.user!=null\" ui-sref=\"app.teams\"><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"icon\"></md-icon><md-button>Teams</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ng-repeat=\"team in Spark.state.user.teams\" ng-if=\"( Spark.state.user!=null )\" \nng-click=\"vm.makeTeamCurrent(team);\"><md-icon ng-if=\"Spark.state.user.current_team_id==team.id\" \nmd-font-icon=\"icon-check-circle\" class=\"icon\"></md-icon><md-icon ng-if=\"Spark.state.user.current_team_id!=team.id\" \nng-click=\"vm.makeTeamCurrent(team);\" md-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"icon\"></md-icon>\n<md-button>{{team.name}}</md-button></md-menu-item><md-menu-divider ng-if=\"Spark.state.user!=null\"></md-menu-divider>\n<md-menu-item class=\"md-indent\" ng-if=\"Spark.state.user!=null\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\">\n</md-icon><md-button ng-click=\"vm.logout(); \">Logout</md-button></md-menu-item><md-menu-item class=\"md-indent\" \nng-if=\"Spark.state.user==null\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.login();\">Login</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/apps/connect/views/cadList.html","<md-list layout=\"column\" flex=\"80\" flex-offset=\"10\"><md-list-item layout=\"row\" layout-align=\"center center\" \nlayout-fill ng-repeat=\"file in vm.connectFiles\" class=\"borderBottom hoverMe greyHoverBack\"><div layout=\"row\" \nlayout-fill ng-click=\"vm.goToURL( file.docPath )\" class=\"paddingLeft10 paddingTopBottom10\"><div flex=\"5\"><md-icon \nmd-font-icon=\"icon-file-outline\"></md-icon></div><div flex=\"95\" class=\"paddingTop3\">{{file.name}}</div></div>\n</md-list-item></md-list>");
$templateCache.put("app/main/apps/dataset/parse/parse.html","<div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><left-menu vm=\"vm\"></left-menu><div \nclass=\"main\" ms-scroll><div class=\"mainColumn\"><div class=\"innerColumn\" layout-margin layout=\"column\"><div \nclass=\"cadwolfBox\" layout=\"column\"><div class=\"cadwolfBoxToolbar\" layout-align=\"space-between center\"><div \nclass=\"cadwolfToolbarTools\">Parse Text</div></div><div class=\"content\" layout=\"column\" layout-margin><div layout=\"row\">\n<div class=\"md-body-1\"><p>\nIn the area below, you can choose to enter data by pasting it into the area below, choosing a text file from your computer, or choosing an excel file from your computer.\n</p><p>\nBefore doing that, you can choose whether or not the current data will be added to the already present data or will overwrite the data already in place.\n</p></div></div><div layout=\"row\"><md-input-container flex=\"90\" flex-offset=\"5\" layout-fill><label>Append or Overwrite\n</label><md-select ng-model=\"vm.appendOverwrite\" ng-change=\"\"><md-option value=\"true\">Append to current data\n</md-option><md-option value=\"false\">Overwrite current data</md-option></md-select></md-input-container></div><md-tabs>\n<md-tab label=\"Paste Text\"><div layout=\"column\" layout-margin><div layout=\"row\" layout-fill><div class=\"md-body-1\">\nPaste whatever text you want to parse into the area below. The option above the tabs will let you determine whether the text pasted below will be added to the current dataset or overwrite the data that is already present.\n</div></div></div></md-tab><md-tab label=\"Upload Text File\"><div layout=\"column\" layout-margin layout-fill><div \nlayout=\"row\" layout-fill><input type=\"file\" id=\"dataset_file\" class=\"textButton marginTopBottom20\" \ncustom-on-change=\"vm.readFile\"></div></div></md-tab><md-tab label=\"Upload Excel File\"><div layout=\"column\" \nlayout-margin layout-fill><div layout=\"row\" layout-fill><input type=\"file\" id=\"dataset_excel\" \nclass=\"textButton marginTopBottom20\" custom-on-change-excel=\"vm.readExcel\"></div></div></md-tab></md-tabs><div \nlayout=\"row\" layout-fill><textarea class=\"textareaBlock\" ng-model=\"vm.cadwolf_fileInfo.item_data.inputString\" \nng-change=\"vm.updateService( \'inputString\' )\" cols=\"100\" rows=\"50\"> \n                                </textarea></div>\n</div></div></div></div></div></div>");
$templateCache.put("app/main/apps/dataset/results/results.html","<div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><left-menu vm=\"vm\"></left-menu><div \nclass=\"main\" ms-scroll><div class=\"mainColumn\"><div class=\"innerColumn\" layout-margin layout=\"column\"><div \nclass=\"cadwolfBox\" layout=\"column\"><div class=\"cadwolfBoxToolbar\" layout=\"row\" layout-align=\"space-between center\"><div\n class=\"cadwolfToolbarTools\">Results</div></div><div class=\"content\" layout=\"column\" layout-margin><div layout=\"row\">\n<div class=\"md-body-1\"><p>\nThe area below shows a two dimensional matrix of the data that was parsed. To show the data, the user must enter a single number for all except for two dimensions. For the remaining two dimensions, the user can enter a colon for all entries or can enter two numbers separated by a colon.\n</p></div></div><div layout=\"row\" class=\"md-body-1\">{{vm.cadwolf_fileInfo.item_data.errorMessage}}</div><div \nlayout=\"row\"><div layout=\"column\" flex=\"20\" layout-margin><div layout=\"row\" \nng-repeat=\"index in vm.cadwolf_fileInfo.item_data.indexes track by $index\" layout-align=\"center center\" layout-fill>\n<div layout=\"column\" ng-class=\"index.class\" layout-margin layout-padding><div layout=\"row\" class=\"md-body-2\">\nIndex : {{$index}}</div><div layout=\"row\" layout-fill layout-align=\"space-around center\"><div layout=\"column\" \nlayout=\"50\"><div layout=\"row\"><md-input-container><label>Start</label><input ng-model=\"index.start\" \nng-enter=\"vm.changeResultIndex()\"></md-input-container></div></div><div layout=\"column\" layout=\"50\"><div layout=\"row\">\n<md-input-container><label>End</label><input ng-model=\"index.end\" ng-enter=\"vm.changeResultIndex()\">\n</md-input-container></div></div></div></div></div></div><div layout=\"column\" flex=\"75\" flex-offset=\"5\"><table \nclass=\"contentTable\"><tbody><tr ng-repeat=\"row in vm.cadwolf_fileInfo.item_data.showArray track by $index\" \nng-if=\"$first\"><th ng-repeat=\"col in row track by $index\">{{$index}}</th></tr><tr \nng-repeat=\"row in vm.cadwolf_fileInfo.item_data.showArray track by $index\"><td ng-repeat=\"col in row track by $index\">\n{{vm.cadwolf_fileInfo.item_data.showArray[$parent.$index][$index]}}</td></tr></tbody></table></div></div></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/apps/dataset/setup/setup.html","<div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><left-menu vm=\"vm\"></left-menu><div \nclass=\"main\" ms-scroll><div class=\"mainColumn\"><div class=\"innerColumn\" layout-margin layout=\"column\"><div \nclass=\"cadwolfBox\" layout=\"column\"><div class=\"cadwolfBoxToolbar\" layout=\"row\" flex=\"100\" \nng-click=\"vm.select( vm.cadwolf_fileInfo )\" \nng-dblclick=\"vm.showSmallModal(\'\', vm.cadwolf_fileInfo, \'Edit Title\', true)\" \nng-class=\"{\'selected\' : vm.selected === vm.cadwolf_fileInfo}\" layout-align=\"space-between center\"><div \nclass=\"cadwolfToolbarTools\" flex=\"90\">{{vm.cadwolf_fileInfo.item_data.title}}</div><div layout=\"row\" flex=\"10\" \nlayout-fill layout-align=\"space-between center\" ng-include=\"\'app/main/apps/dataset/views/subBar.html\'\"></div></div><div\n class=\"content\" layout=\"column\" layout-margin><div class=\"md-body-1\" \nng-bind-html=\"vm.cadwolf_fileInfo.item_data.description\"></div><div class=\"md-title\">Equation Name</div><div \nclass=\"md-body-1\"><p>\nVariables in CADWOLF documents have names, which is how they are identified in equations. This name is the name that will be given to this dataset when it is pulled into a document.\n</p></div><md-input-container><label>Name</label><input ng-model=\"vm.cadwolf_fileInfo.item_data.name\" required \nmd-minlength=\"1\"></md-input-container><div class=\"md-title\">Data</div><div layout=\"row\"><div class=\"md-subhead\" \nflex=\"25\" translate=\"CREATED\">Date Created</div><div class=\"md-body-1\" flex=\"75\">{{vm.cadwolf_fileInfo.created_at}}\n</div></div><div layout=\"row\"><div class=\"md-subhead\" flex=\"25\" translate=\"MODIFIED\">Date Modifed</div><div \nclass=\"md-body-1\" flex=\"75\">{{vm.cadwolf_fileInfo.updated_at}}</div></div><div layout=\"row\"><div class=\"md-subhead\" \nflex=\"25\" translate=\"SIZE\">Dataset Size</div><div class=\"md-body-1\" flex=\"75\">{{vm.cadwolf_fileInfo.item_data.size}}\n</div></div><div class=\"md-title\">Parsers</div><div class=\"md-body-1\">\nParsers are the text that is used to divide up the raw text into rows and columns. Raw text with one parser will be one long row with several columns. Two parsers will produce a table of rows and columns, etc.\n</div><div layout=\"row\" layout-fill><div layout=\"column\" layout-margin flex=\"50\" flex-offset=\"25\" \nlayout-align=\"center center\"><div layout=\"row\" flex=\"100\" \nng-repeat=\"thisParser in vm.cadwolf_fileInfo.item_data.parsers track by $index\" layout-align=\"center center\"><div \nlayout=\"column\"><div layout=\"row\"><md-button class=\"md-icon-button\" \nng-click=\"vm.cadwolf_fileInfo.item_data.parsers.splice($index, 1)\"><md-icon md-font-icon=\"icon-close-circle-outline\" \naria-label=\"Delete this Parser\"></md-icon></md-button></div><div layout=\"row\"><md-button class=\"md-icon-button\" \nng-click=\"vm.cadwolf_fileInfo.item_data.parsers.splice($index, 0, \'#\')\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\" aria-label=\"After parser after\"></md-icon></md-button></div></div><div \nlayout=\"column\"><md-input-container><label>Parser {{$index}}</label><input \nng-model=\"vm.cadwolf_fileInfo.item_data.parsers[$index]\" required md-minlength=\"1\"></md-input-container></div></div>\n</div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/dataset/views/availableText.tmpl.html","<md-dialog aria-label=\"Select From Available Text\" ng-cloak><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nSelect Text</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel();\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"md-dialog-content\"><h2>Select From Available Text</h2><p>\nIf the user has chosen to bring in text from a file, then the text is parsed and the pieces of that file are presented here for the user to choose whether or not they are to be addded to the text. To remove a section from that which will be added to the dataset, simply uncheck the box on the left to remove it. The section can be readded by clicking the check again. A section can be completely removed from consideration by deleting it using the trash can icon on the right. When all selections are made, click the \'Combine Text\' button to combine the remaining checked pieces into the dataset.\n</p><md-list layout=\"column\" flex=\"100\"><md-list-item ng-repeat=\"thisText in vm.availableText track by thisText.id\" \nlayout=\"row\" flex=\"100\"><md-checkbox ng-model=\"thisText.status\"></md-checkbox><p>{{thisText.text}}</p></md-list-item>\n<md-divider></md-divider></md-list></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.cancel();\">Cancel Edit</md-button><md-button ng-click=\"vm.acceptText(vm.availableText);\">Done</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/dataset/views/editDescription.tmpl.html","<md-dialog-content ms-scroll><text-angular ng-model=\"vm.thisItem.newDesc\"></text-angular></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.acceptChanges(vm.thisItem.newDesc); vm.cancel();\" \nclass=\"send-button md-accent md-raised\">DONE</md-button><md-button type=\"submit\" ng-click=\"vm.cancel();\" \nclass=\"send-button md-accent md-raised\">CANCEL</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/dataset/views/editName.tmpl.html","<md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label>New name</label><input name=\"newName\" \naria-label=\"New Name\" type=\"text\" ng-model=\"vm.thisItem.newName\" required ng-pattern=\"/[a-zA-Z0-9\\s\\-]{5,30}$/\" \nminlength=\"5\" maxlength=\"30\"><div ng-messages=\"nameForm.newName.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\">A name is required</div><div ng-message=\"pattern\">\nNames can only have letters, numbers, spaces, and dashes</div><div ng-message=\"minlength\">\nNames must have at least 5 characters</div><div ng-message=\"minlength\">Names can have no more than 30 characters</div>\n</div></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-fill layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vm.acceptName(vm.thisItem.newName); vm.cancel();\" class=\"send-button md-accent md-raised\">SAVE NEW NAME\n</md-button><md-button type=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">CANCEL</md-button>\n</div></md-dialog-actions>");
$templateCache.put("app/main/apps/dataset/views/emptyList.html","<div class=\"md-headline marginTop20\">Favorite Datasets</div><md-list \nng-if=\"Spark.state.user.user_info.favDatasets.length>0\" class=\"marginTop20\"><md-list-item layout=\"row\" \nclass=\"borderBottom\"><div flex=\"15\">&nbsp</div><div flex=\"30\" translate=\"FM.NAME\" class=\"md-title\">Name</div><div \nflex=\"55\" hide-xs translate=\"FM.LOCATION\" class=\"md-title\">Location</div></md-list-item><md-list-item \nng-repeat=\"dataset in Spark.state.user.user_info.favDatasets\" class=\"borderBottom\" layout=\"row\"><div flex=\"10\"><md-icon\n md-font-icon=\"icon-cog\" ng-click=\"vm.goToURL(\'/Dataset/\'+dataset.location)\" class=\"hoverMe\"></md-icon></div><div \nflex=\"30\">{{dataset.name}}</div><div flex=\"55\">{{dataset.location}}</div><div flex=\"5\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\" ng-click=\"vm.removeFavItem( dataset )\" class=\"hoverMe\"></md-icon></div>\n</md-list-item></md-list><div class=\"md-body-1 marginTop20\" ng-if=\"Spark.state.user.user_info.favDatasets.length==0\">\nUsers can \"favorite\" datasets so that they can be easily accessed. Those datasets can be shown here. To favorite a dataset, clikc the heart icon in the upper right of the dataset view.\n</div><div class=\"md-headline marginTop20\">Recent Datasets</div><md-list \nng-if=\"Spark.state.user.user_info.datasets.length>0\" class=\"marginTop20\"><md-list-item layout=\"row\" \nclass=\"borderBottom\"><div flex=\"15\">&nbsp</div><div flex=\"30\" translate=\"FM.NAME\" class=\"md-title\">Name</div><div \nflex=\"55\" hide-xs translate=\"FM.LOCATION\" class=\"md-title\">Location</div></md-list-item><md-list-item \nng-repeat=\"dataset in Spark.state.user.user_info.datasets\" class=\"borderBottom\" layout=\"row\"><div flex=\"10\"><md-icon \nmd-font-icon=\"icon-cog\" ng-click=\"vm.goToURL(\'/Dataset/\'+dataset.location)\" class=\"hoverMe\"></md-icon></div><div \nflex=\"30\">{{dataset.name}}</div><div flex=\"60\">{{dataset.location}}</div></md-list-item></md-list><div \nclass=\"md-body-1 marginTop20\" ng-if=\"Spark.state.user.user_info.datasets.length==0\">\nThe list below will show the 10 most recently visited datasets.</div>");
$templateCache.put("app/main/apps/dataset/views/list-view.html","");
$templateCache.put("app/main/apps/dataset/views/mediumModalTemplates.tmpl.html","<md-dialog class=\"medium-dialog\" aria-label=\"Change File Properties\"><form name=\"contactForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between\"><span class=\"title\" ng-if=\"vm.modalType==\'Edit Description\'\">Description\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-label-outline\" \nng-if=\"vm.modalType==\'Edit Description\'\" class=\"md-avatar avatar contact-avatar huge\"></md-icon><div \nclass=\"contact-name\" ng-if=\"vm.modalType==\'Edit Description\'\">{{vm.thisItem.name}}</div></div></div></md-toolbar><div \nng-if=\"vm.modalType==\'Edit Description\'\" ng-include=\"\'app/main/apps/dataset/views/editDescription.tmpl.html\'\"></div>\n</form></md-dialog>");
$templateCache.put("app/main/apps/dataset/views/smallModalTemplates.tmpl.html","<md-dialog class=\"contact-dialog\" aria-label=\"Change File Properties\"><form name=\"contactForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between\"><span class=\"title\" ng-if=\"vm.modalType==\'Edit Title\'\">Change Name</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-format-text\" \nng-if=\"vm.modalType==\'Edit Title\'\" class=\"md-avatar avatar contact-avatar huge\"></md-icon><div class=\"contact-name\" \nng-if=\"vm.modalType==\'Edit Title\'\">{{vm.thisItem.name}}</div></div></div></md-toolbar><div \nng-if=\"vm.modalType==\'Edit Title\'\" ng-include=\"\'app/main/apps/dataset/views/editName.tmpl.html\'\"></div></form>\n</md-dialog>");
$templateCache.put("app/main/apps/dataset/views/subBar.html","<div flex=\"50\" ng-if=\"!vm.cadwolf_fileInfo.favorite && Spark.state.user!=null\"><md-icon \nmd-font-icon=\"icon-heart-outline\" ng-click=\"vm.favoriteItem();\" class=\"hoverMe iconRedBackground\"><md-tooltip \nmd-direction=\"bottom\">Click to like</md-tooltip></md-icon></div><div flex=\"50\" \nng-if=\"vm.cadwolf_fileInfo.favorite && Spark.state.user!=null\"><md-icon md-font-icon=\"icon-heart\" \nng-click=\"vm.favoriteItem();\" class=\"hoverMe iconRedBackground\"><md-tooltip md-direction=\"bottom\">Click to unlike\n</md-tooltip></md-icon></div>");
$templateCache.put("app/main/apps/document/worksheet/worksheet.html","<div class=\"content\" md-background-bg layout=\"row\" ng-if=\"vm.noDocument\" layout-align=\"center center\"><div \nclass=\"documentMain md-subhead\">There was no document found at this URL</div></div><div class=\"content\" \nmd-background-bg layout=\"row\" ng-if=\"!vm.noDocument\" layout-align=\"start start\"><left-menu vm=\"vm\" \nng-if=\"vm.cadwolf_fileInfo!==undefined\" layout-gt-xs layout=\"column\"></left-menu><div ng-if=\"vm.showType==\'Document\'\" \nng-class=\"vm.mainClass\" ms-scroll><div class=\"documentMain\"><div class=\"innerColumn\" \nng-style=\"{ \'width\' : vm.calcWidth, \n								\'padding-left\' : vm.cadwolf_fileInfo.item_data.docMargin+\'px\',\n								\'padding-right\' : vm.cadwolf_fileInfo.item_data.docMargin+\'px\' }\">\n<div layout=\"row\" layout-fill layout-align=\"end center\"><div ng-if=\"vm.currentItem==\'top\'&&vm.editPerm\" \nid=\"clicktotopenterCurrent\" ng-click=\"vm.currentItem=\'top\'; vm.setCurrent(\'top\');\"><md-icon \nmd-font-icon=\"icon-format-object-top-bottom\" class=\"iconBlueBackground hoverMe\"><md-tooltip md-direction=\"bottom\">\nTop Item is Current</md-tooltip></md-icon></div><div ng-if=\"vm.currentItem!=\'top\'&&vm.editPerm\" \nid=\"clicktotopenterCurrent\" ng-click=\"vm.currentItem=\'top\'; vm.setCurrent(\'top\');\"><md-icon \nmd-font-icon=\"icon-format-object-top-bottom\" class=\"hoverMe\"><md-tooltip md-direction=\"bottom\">\nClick to make top item current</md-tooltip></md-icon></div><div id=\"doMathJax\"><md-icon md-font-icon=\"icon-filter\" \nng-click=\"vm.doMathJax();\" class=\"hoverMe\"><md-tooltip md-direction=\"bottom\">Evaluate MathJax</md-tooltip></md-icon>\n</div><div id=\"favoriteHeart\" ng-if=\"!vm.cadwolf_fileInfo.favorite&&Spark.state.user!=null\"><md-icon \nmd-font-icon=\"icon-heart-outline\" ng-click=\"vm.favoriteItem();\" class=\"hoverMe iconRedBackground\"><md-tooltip \nmd-direction=\"bottom\">Click to like</md-tooltip></md-icon></div><div id=\"favoriteHeart\" \nng-if=\"vm.cadwolf_fileInfo.favorite&&Spark.state.user!=null\"><md-icon md-font-icon=\"icon-heart\" \nng-click=\"vm.favoriteItem();\" class=\"hoverMe iconRedBackground\"><md-tooltip md-direction=\"bottom\">Click to unlike\n</md-tooltip></md-icon></div><div id=\"upFolder\"><md-icon md-font-icon=\"icon-folder-upload\" \nng-click=\"vm.navigateToParent();\" class=\"hoverMe iconGreyBackground\"><md-tooltip md-direction=\"bottom\">\nNavigate to Parent Folder</md-tooltip></md-icon></div></div><div class=\"titleBlock\" \nng-if=\"vm.cadwolf_fileInfo.item_data.showTitle\"><h1 class=\"md-title\">{{vm.cadwolf_fileInfo.item_data.title}}</h1></div>\n<div class=\"subtitleBlock\" ng-if=\"vm.cadwolf_fileInfo.item_data.showSubtitle\"><div class=\"md-body-1\">\n{{vm.cadwolf_fileInfo.item_data.subtitle}}</div></div><table-of-contents></table-of-contents><md-content \nclass=\"content\" flex><div class=\"main_item\" \nng-repeat=\"obj in vm.cadwolf_worksheet | orderBy:\'order\' track by obj.itemid\" ng-switch on=\"obj.component_type_id\" \nng-class=\"obj.content.textClass\" \nng-if=\"(   obj.content.parentid==\'none\') && \n									( ( obj.dependent_file==\'\') || ( obj.dependent_file==null ) )\" \nstyle=\"width: {{obj.content.width}}px; \n									margin-top:{{obj.content.margintop}}px; \n									margin-bottom:{{obj.content.marginbottom}}px; \n									margin-left:{{obj.content.marginleft}}px; \n									margin-right:{{obj.content.marginright}}px;\n									text-align:{{obj.content.alignment}}\" \n;><div ng-switch=\"obj.component_type_id\"><div ng-switch-when=\"1\"><div \nng-include=\"\'app/main/apps/document/worksheet/views/text.html\'\"></div></div><div ng-switch-when=\"2\"><div \nng-include=\"\'app/main/apps/document/worksheet/views/header.html\'\"></div></div><div ng-switch-when=\"3\"><div \nng-include=\"\'app/main/apps/document/worksheet/views/equation.html\'\"></div></div><div ng-switch-when=\"4\"><div \nng-include=\"\'app/main/apps/document/worksheet/views/symbolic.html\'\"></div></div><div ng-switch-when=\"5\"><div \nng-include=\"\'app/main/apps/document/worksheet/views/table.html\'\"></div></div><div ng-switch-when=\"6\"><div \nng-include=\"\'app/main/apps/document/worksheet/views/forLoop.html\'\"></div></div><div ng-switch-when=\"7\"><div \nng-include=\"\'app/main/apps/document/worksheet/views/whileLoop.html\'\"></div></div><div ng-switch-when=\"8\"><div \nng-include=\"\'app/main/apps/document/worksheet/views/ifElse.html\'\"></div></div><div ng-switch-when=\"9\"><div \nng-include=\"\'app/main/apps/document/worksheet/views/plot.html\'\"></div></div><div ng-switch-when=\"10\"><div \nng-include=\"\'app/main/apps/document/worksheet/views/image.html\'\"></div></div><div ng-switch-when=\"11\"><div \nng-include=\"\'app/main/apps/document/worksheet/views/lineBreak.html\'\"></div></div><div ng-switch-when=\"12\"><div \nng-include=\"\'app/main/apps/document/worksheet/views/video.html\'\"></div></div><div ng-switch-when=\"13\"><div \nng-include=\"\'app/main/apps/document/worksheet/views/threeDPlot.html\'\"></div></div><div ng-switch-when=\"15\"><div \nng-include=\"\'app/main/apps/document/worksheet/views/card.html\'\"></div></div><div ng-switch-when=\"16\"><div \nng-include=\"\'app/main/apps/document/worksheet/views/freeBodyDiagram.html\'\"></div></div><div ng-switch-when=\"17\"><div \nng-include=\"\'app/main/apps/document/worksheet/views/requirement.html\'\"></div></div></div></div></md-content>\n<bibliography layout-fill></bibliography></div></div></div><div ng-if=\"vm.showType==\'DocumentEmpty\'\" \nng-class=\"vm.mainClass\" ms-scroll><div ng-include=\"\'app/main/apps/document/documentEmpty.html\'\"></div></div></div>");
$templateCache.put("app/main/apps/forum/views/forumComment.html","<div class=\"forumComment marginLeft40\" ng-repeat=\"obj in comments | orderBy:\'created_at\' track by obj.id\" \nng-if=\"obj.parent_id==id\"><div layout=\"column\" flex=\"100\" class=\"borderBottom paddingBottom10 marginBottom20\"><div \nlayout=\"row\"><div><img class=\"profile-image avatar\" ng-src=\"{{obj.item_data.userData.photo_url}}\" ng-click=\"\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"></div><div class=\"paddingLeft20 marginTop10\">\n{{obj.item_data.userData.name}} - {{obj.item_data.userData.username}}</div><div \nclass=\"paddingLeft20 marginTop10 greyText\">{{obj.created_at_date | date:\'short\'}}</div></div><div \nng-if=\"obj.item_data.editStatus == 0\" data-ng-bind-html=\"obj.item_data.text\"></div><div \nclass=\"borderBottom paddingBottom10 marginBottom20\" \nng-if=\"obj.user_id == spark.state.user.id &&  obj.item_data.editStatus == 1\" flex=\"70\" flex-offset=\"30\"><div \nlayout=\"row\"><text-angular ng-model=\"obj.item_data.text\"></text-angular></div><md-button class=\"md-accent md-raised\" \nng-click=\"callResetStatus()\" type=\"submit\" aria-label=\"Cancel Edit\"><span>Cancel</span></md-button><md-button \nclass=\"md-accent md-raised\" ng-click=\"callDeleteComment( obj.id ); callResetStatus()\" type=\"submit\" \naria-label=\"Delete Comment\"><span>Delete</span></md-button><md-button class=\"md-accent md-raised\" \nng-click=\"callResetStatus(); callUpdateComment( obj.id )\" type=\"submit\" aria-label=\"Save Comment\"><span>Save Comment\n</span></md-button></div><div layout=\"row\" ng-if=\"spark.state.user!=null\"><div \nng-if=\" obj.user_id == spark.state.user.id && obj.item_data.editStatus == 0 \" ng-click=\"callResetStatus(obj.id)\" \nclass=\"marginTop10 marginRight10 hoverMe blueText\">Edit</div><div \nng-click=\"callResetStatus(); callCreateComment( obj.id, 1 ) \" class=\"marginTop10 marginRight10 hoverMe blueText\">\nRespond</div></div></div><div forum-comment layout=\"column\" ng-style=\"\" \nng-repeat=\"thisComment in comments | orderBy:\'date_created\' track by $index\" id=\"$parent.obj.id\" comments=\"comments\" \nspark=\"spark\" ng-if=\"thisComment.parent_id == $parent.obj.id\" create-comment=\"callCreateComment\" \nupdate-comment=\"callUpdateComment\" delete-comment=\"callDeleteComment\" newcomment=\"newcomment\" \nreset-status=\"callResetStatus\"></div></div>");
$templateCache.put("app/main/apps/forum/views/forumList.html","<div class=\"cadwolfBoxToolbar\" layout=\"row\" layout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">\nList of Forums<md-button ng-click=\"vm.showNewForumModal()\" class=\"md-icon-button add-row-button\" \nng-if=\"Spark!=undefined\" aria-label=\"Add\" translate translate-attr-aria-label=\"FORUM.ADD\"><md-icon \nmd-font-icon=\"icon-plus\"><md-tooltip md-direction=\"bottom\">Start a New Discussion</md-tooltip></md-icon></md-button>\n</div></div><div layout=\"row\" layout-fill flex=\"100\"><div layout=\"row\" flex=\"90\" flex-offset=\"5\"><div layout=\"column\" \nlayout-margin><div class=\"forumEntry borderBottom paddingBottom20 marginBottom20\" \nng-repeat=\"obj in vm.cadwolf_files | orderBy:\'created_at\' track by obj.id\"><div layout=\"row\" class=\"hoverMe\" \nng-click=\"vm.goToURL( obj.name )\"><div layout=\"column\" class=\"textCentered\"><div><img class=\"profile-image avatar\" \nng-src=\"{{obj.item_data.userData.photo_url}}\" ng-click=\"\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"><md-tooltip md-direction=\"bottom\">\n{{obj.item_data.userData.name}} - {{obj.item_data.userData.username}}</md-tooltip></div><div class=\"paddingTop20\">\n{{obj.created_at_date | date:\'short\'}}</div></div><div class=\"md-title marginLeft20\">{{obj.name}}</div></div><div \ndata-ng-bind-html=\"obj.item_data.text\"></div><div class=\"greyText\">Comments - {{obj.commentCount}}</div></div></div>\n</div></div>");
$templateCache.put("app/main/apps/forum/views/mainForum.html","<div class=\"cadwolfBoxToolbar\" layout=\"row\" layout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">\nCADWOLF Forums</div></div><div layout=\"row\" layout-fill flex=\"100\"><div layout=\"row\" flex=\"90\" flex-offset=\"5\"><div \nlayout=\"column\" layout-margin><div class=\"md-body-1 marginTop20\">\nSelect one of the topics below to view and participate in relavent discussions. You can also create a new discussion by clicking on the plus sign which will appear in the upper left corner of this box. Any user can comment on the forum or add a new forum in one of the subjects below. You can also add a forum to any workspace where you can carry out conversations with others about anything you desire. Discussions can also be added to a document to discuss issues within the document.\n</div><div class=\"marginTop20 paddingTop10 paddingBottom10 borderBottom hoverMe greyHoverBack\" \nng-click=\"vm.goToURL(\'Forums/Projects/\')\"><div class=\"md-title\">Projects</div><div class=\"md-body-1 marginTop10\">\nThis board holds discussions and questions related to the projects workspace. That workspace holds the open source projects that are being carried out on CADWOLF. Conversations can be carried out here about starting a new project or how to handle existing projects.\n</div></div><div class=\"paddingTop10 paddingBottom10 borderBottom hoverMe greyHoverBack\" \nng-click=\"vm.goToURL(\'Forums/General/\')\"><div class=\"md-title\">General</div><div class=\"md-body-1 marginTop10\">\nThis is the place to ask questions about using CADWOLF. The questions could be about errors you are receiving, the best way to solve a problem, or how to use CADWOLF to handle a solution.\n</div></div><div class=\"paddingTop10 paddingBottom10 borderBottom hoverMe greyHoverBack\" \nng-click=\"vm.goToURL(\'Forums/Parts/\')\"><div class=\"md-title\">Parts</div><div class=\"md-body-1 marginTop10\">\nCADWOLF maintains a list of predesigned parts for users to pull into their own designs. Questions can asked and answered here.\n</div></div></div></div></div>");
$templateCache.put("app/main/apps/forum/views/viewForum.html","<div class=\"cadwolfBoxToolbar\" layout=\"row\" layout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">Forum\n</div></div><div layout=\"row\" layout-fill flex=\"100\"><div layout=\"row\" flex=\"90\" flex-offset=\"5\"><div layout=\"column\" \nflex=\"100\" layout-margin><div layout=\"row\"><div><img class=\"profile-image avatar\" \nng-src=\"{{vm.cadwolf_fileInfo.item_data.userData.photo_url}}\" ng-click=\"\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"></div><div class=\"paddingLeft20 marginTop10\">\n{{vm.cadwolf_fileInfo.item_data.userData.name}} - {{vm.cadwolf_fileInfo.item_data.userData.username}}</div><div \nclass=\"paddingLeft20 marginTop10 greyText\">{{vm.cadwolf_fileInfo.created_at_date | date:\'short\'}}</div></div><div \nclass=\"md-title textCentered marginTop20\">{{vm.cadwolf_fileInfo.name}}</div><div \nclass=\"borderBottom paddingBottom20 paddingTop10 marginBottom20\" \ndata-ng-bind-html=\"vm.cadwolf_fileInfo.item_data.text\"></div><div class=\"paddingBottom10 paddingTop10\" \nng-if=\"vm.editForum\"><text-angular ng-model=\"vm.cadwolf_fileInfo.item_data.text\"></text-angular></div><div \nlayout=\"row\" ng-if=\"vm.editForum\"><div class=\"greyText hoverMe marginTop10 marginBottom20\" ng-click=\"vm.resetStatus()\">\nCancel</div><div><md-button class=\"md-accent md-raised\" ng-click=\"vm.updateForum( ); vm.resetStatus()\" type=\"submit\" \naria-label=\"Update Forum\"><span>Update</span></md-button></div></div><div \nclass=\"paddingBottom10 paddingTop10 greyText hoverMe\" ng-if=\"Spark.state.user.id == vm.cadwolf_fileInfo.user_id\" \nng-click=\"vm.resetStatus(\'forum\')\">Edit Forum Text and Title</div><div \nclass=\"greyText hoverMe marginTop20 marginBottom20\" ng-if=\"!vm.newComment && Spark.state.user != null\" \nng-click=\"vm.resetStatus(0)\">Add New Comment</div><div class=\"borderBottom paddingBottom10 marginBottom20\" \nng-if=\"vm.newComment && Spark.state.user != null\" flex=\"100\"><div layout=\"row\" flex=\"70\" flex-offset=\"30\"><text-angular\n ng-if=\"vm.newComment\" ng-model=\"vm.newCommentText\"></text-angular></div><div layout=\"row\" flex-offset=\"80\"><div \nclass=\"greyText hoverMe marginTop10 marginBottom20\" ng-if=\"vm.newComment && Spark.state.user != null\" \nng-click=\"vm.resetStatus()\">Cancel</div><div><md-button class=\"md-accent md-raised\" \nng-click=\"vm.createComment( 0, 0 ); vm.resetStatus()\" type=\"submit\" aria-label=\"Post Comment\"><span>Post Comment</span>\n</md-button></div></div></div><div class=\"md-title marginTop20 marginBottom20 paddingBottom10 borderBottom\">Comments\n</div><div forum-comment layout=\"column\" ng-style=\"\" id=\"0\" comments=\"vm.comments\" spark=\"Spark\" \ncreate-comment=\"vm.createComment\" update-comment=\"vm.updateComment\" delete-comment=\"vm.deleteComment\" \nnewcomment=\"vm.newComment\" reset-status=\"vm.resetStatus\"></div></div></div></div>");
$templateCache.put("app/main/apps/partTree/partTree/partTree.html","<div id=\"tree\" class=\"page-layout simple left-sidenav\"><div class=\"content\" md-background-bg layout=\"row\" \nlayout-align=\"start start\"><div class=\"main\" ms-scroll><div class=\"mainColumn\"><div class=\"innerColumn\" layout-margin \nlayout=\"column\"><div class=\"md-display-1\">Part Tree</div><div layout=\"column\" layout-fill \nng-repeat=\"obj in vm.partTree.treeStructure[0].systems track by obj.id\"><div layout=\"row\" layout-fill flex=\"100\"><div \nclass=\"md-body-1\">{{obj.name}}</div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/partTree/setup/setup.html","<div id=\"treeSetup\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"content\" md-background-bg \nlayout=\"row\" layout-align=\"start start\"><left-menu></left-menu><div class=\"main\" ms-scroll><div class=\"mainColumn\"><div\n class=\"innerColumn\" layout-margin layout=\"column\"><div class=\"md-display-1\">{{vm.partTree.title}}</div><div \nclass=\"md-title\">Description</div><div class=\"md-body-1\" data-ng-bind-html=\"vm.partTree.description\"></div><div \nlayout-margin ng-include=\"\'app/main/apps/partTree/setup/views/treeStructure.html\'\"></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/partTree/views/editCadLink.tmpl.html","<md-dialog-content ms-scroll><div flex=\"80\" flex-offset=\"10\" layout-padding><div class=\"md-body-1\" class=\"fullWidth\">\nIn the section below, the user can link the item in question to a CAD part or assembly. To do this, select the document, element and then part desired. The mass properties will then be imported from that CAD model. To start, click the button below to populate the select boxes with a list of available CAD documents. Note that only one model can be linked to each item in a part tree.\n</div><div layout=\"row\" flex=\"100\" layout-align=\"center center\" class=\"marginTop20 marginBottom20\"><div>\nSelect item to connect to {{vm.thisItem.treeNameFull}} - {{vm.thisItem.treeNameAbbr}}</div></div><div flex=\"100\" \nlayout-align=\"center center\" class=\"borderMe paddingTop20 paddingBottom20\" \nng-if=\"vm.cadwolf_fileInfo.item_data.cadType==\'onshape\'\"><div layout=\"row\" flex=\"100\" layout-align=\"center center\" \nclass=\"marginTop20 marginBottom20\" ng-if=\"vm.cadwolf_fileInfo.item_data.cadType==\'onshape\'\"><div><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.getOnshapeDocs();\">Get User onShape Documents</md-button></div></div><div \nlayout=\"row\" flex=\"100\" layout-align=\"center center\"><div flex=\"10\" class=\"md-title\"></div><div flex=\"30\" \nclass=\"md-title\">Document</div><div flex=\"50\"><md-input-container class=\"md-block\"><md-select \nng-model=\"vm.thisCAD.document_data.id\" ng-change=\"vm.getCadElements()\"><md-option \nng-repeat=\"item in vm.cadFiles track by item.id\" ng-value=\"item.id\">{{item.name}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-align=\"center center\"><div flex=\"10\" \nclass=\"md-title\"></div><div flex=\"30\" class=\"md-title\">Element</div><div flex=\"50\"><md-input-container \nclass=\"md-block\"><md-select ng-model=\"vm.thisCAD.element_data.id\" ng-change=\"vm.getCadParts()\"><md-option \nng-repeat=\"element in vm.cadElements\" ng-value=\"element.id\">{{element.name}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-align=\"center center\"><div flex=\"10\" \nclass=\"md-title\"></div><div flex=\"30\" class=\"md-title\">Part</div><div flex=\"50\"><md-input-container class=\"md-block\" \nng-if=\"vm.thisCAD.element_data.elementType==\'PARTSTUDIO\'\"><md-select ng-model=\"vm.thisCAD.part_data.partId\" \nng-change=\"vm.setCadProperties()\"><md-option ng-value=\"\">none</md-option><md-option ng-repeat=\"part in vm.cadParts\" \nng-value=\"part.partId\">{{part.name}}</md-option></md-select></md-input-container></div></div></div><div flex=\"100\" \nlayout-align=\"center center\" class=\"borderMe paddingTop20 paddingBottom20\" \nng-if=\"vm.cadwolf_fileInfo.item_data.cadType==\'fusion\'\"><div layout=\"row\" flex=\"100\" layout-align=\"center center\" \nclass=\"marginTop20 marginBottom20\" ng-if=\"vm.cadwolf_fileInfo.item_data.cadType==\'fusion\'\"><div><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.getAutocadHubs();\">Get User Fusion 360 Hubs</md-button></div></div><div \nlayout=\"row\" flex=\"100\" layout-align=\"start start\"><div flex=\"10\" class=\"md-title\"></div><div flex=\"40\" \nclass=\"md-title marginTop20\">Select Hub</div><div flex=\"40\"><md-input-container class=\"md-block\"><md-select \nng-model=\"vm.newCADConnect.hub\" placeholder=\"Select a hub\" ng-change=\"vm.getAutocadProjects(vm.newCADConnect.hub)\">\n<md-option ng-repeat=\"item in vm.autocadHubs\" ng-value=\"item.id\">{{item.attributes.name}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-align=\"start start\"><div flex=\"10\" \nclass=\"md-title\"></div><div flex=\"40\" class=\"md-title marginTop20\">Select Project</div><div flex=\"40\">\n<md-input-container class=\"md-block\"><md-select ng-model=\"vm.newCADConnect.project\" placeholder=\"Select a project\" \nng-change=\"vm.getAutocadFolders(vm.newCADConnect.hub, vm.newCADConnect.project)\"><md-option \nng-repeat=\"project in vm.autocadProjects\" ng-value=\"project.id\">{{project.attributes.name}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-align=\"start start\"><div flex=\"10\" \nclass=\"md-title\"></div><div flex=\"40\" class=\"md-title marginTop20\">Select Root Folder</div><div flex=\"40\">\n<md-input-container class=\"md-block\"><md-select ng-model=\"vm.newCADConnect.rootFolder\" placeholder=\"Select a folder\" \nng-change=\"vm.getAutocadFolderContents(vm.newCADConnect.project, vm.newCADConnect.rootFolder)\"><md-option \nng-repeat=\"folder in vm.autocadFolders\" ng-value=\"folder.id\">{{folder.attributes.displayName}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\" ng-repeat=\"showFolder in vm.newCADConnect.folderData\" flex=\"100\" \nlayout-align=\"start start\"><div flex=\"10\" class=\"md-title\"></div><div flex=\"40\" class=\"md-title marginTop20\">Folder\n</div><div flex=\"40\" class=\"marginTop20 md-body-2\" \nng-click=\"vm.setAutocadItem(showFolder, $index, vm.newCADConnect.project)\">{{showFolder.displayName}}</div></div><div \nlayout=\"row\" flex=\"100\" layout-align=\"start start\" ng-if=\"!vm.autocadFileSelected\"><div flex=\"10\" class=\"md-title\">\n</div><div flex=\"40\" class=\"md-title marginTop20\">Select File or Folder</div><div flex=\"40\"><md-list><md-list-item \nng-repeat=\"autocadItem in vm.autocadContents\" \nng-click=\"vm.setAutocadPullItem(autocadItem, \'add\', vm.newCADConnect.project)\"><div \nng-if=\"autocadItem.type==\'folders\'\">Folder - {{autocadItem.attributes.displayName}}</div><div \nng-if=\"autocadItem.type==\'items\'\">File - {{autocadItem.attributes.displayName}}</div></md-list-item></md-list></div>\n</div><div layout=\"row\" flex=\"100\" layout-align=\"start start\" ng-if=\"vm.autocadFileSelected\"><div flex=\"10\" \nclass=\"md-title\"></div><div flex=\"40\" class=\"md-title marginTop20\">Selected File</div><div flex=\"40\" \nclass=\"marginTop20 md-body-2\">{{vm.newCADConnect.fileData.attributes.displayName}}</div></div><div layout=\"row\" \nflex=\"100\" layout-align=\"start start\" ng-if=\"vm.autocadFileSelected && !vm.autocadBodySelected\"><div flex=\"10\" \nclass=\"md-title\"></div><div flex=\"40\" class=\"md-title marginTop20\">Select Fusion Body</div><div flex=\"40\">\n<md-input-container class=\"md-block\"><md-select ng-model=\"vm.newCADConnect.bodyId\" placeholder=\"Select a body\" \nng-change=\"vm.setFusionPartBodyData()\"><md-option ng-repeat=\"bodyItem in vm.bodyCollection\" \nng-value=\"bodyItem.externalId\" ng-if=\"bodyItem.properties.Mass !== undefined\">\n{{bodyItem.name}} - {{bodyItem.properties.Mass}}</md-option></md-select></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" layout-align=\"start start\" ng-if=\"vm.autocadBodySelected\"><div flex=\"10\" class=\"md-title\">\n</div><div flex=\"40\" class=\"md-title marginTop20\">Selected Body</div><div flex=\"40\"><md-list><md-list-item><div>\n{{vm.newCADConnect.bodyData.name}} - {{vm.newCADConnect.bodyData.properties.Mass}}</div></md-list-item></md-list></div>\n</div><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.autocadLinkSet\" flex=\"80\" flex-offset=\"10\" \nclass=\"marginTop20 marginBottom20\"><div><md-button class=\"md-raised md-accent\" ng-click=\"vm.setFusionProperties();\">\nLink this Fusion File to this Part / Assembly</md-button></div></div></div><div \nng-if=\"vm.cadwolf_fileInfo.item_data.cadType==\'onshape\'\" ng-repeat=\"cadItem in vm.cadwolf_fileInfo.item_data.cad_data\">\n<div flex=\"100\" class=\"paddingBottom10 marginBottom20 borderBottom marginTop40 md-headline\" \nng-if=\"cadItem.document_id==vm.thisItem.id\">Currently Linked CAD</div><div layout=\"row\" flex=\"100\" \nng-if=\"cadItem.document_id==vm.thisItem.id\"><div flex=\"30\"><img \nng-src=\"{{cadItem.element_data.thumbnailInfo.sizes[0][\'href\']}}\" class=\"md-avatar\" ng-style=\"{\'height\':\'200px\'}\" \nalt=\"{{item.info.cad_data.title}}\" onerror=\"\"></div><div flex=\"70\"><div layout=\"row\" flex=\"100\" class=\"marginBottom20\">\n<div flex=\"30\" class=\"md-title\">Document :</div><div flex=\"70\" class=\"marginTop10\">{{cadItem[\'document_data\'][\'name\']}}\n</div></div><div layout=\"row\" flex=\"100\" class=\"marginBottom20\"><div flex=\"30\" class=\"md-title\">Element :</div><div \nflex=\"70\" class=\"marginTop10\">{{cadItem[\'element_data\'][\'name\']}}</div></div><div layout=\"row\" flex=\"100\" \nclass=\"marginBottom20\"><div flex=\"30\" class=\"md-title\">Part :</div><div flex=\"70\" class=\"marginTop10\">\n{{cadItem[\'part_data\'][\'name\']}}</div></div></div></div></div><div \nng-if=\"vm.cadwolf_fileInfo.item_data.cadType==\'fusion\'\" ng-repeat=\"cadItem in vm.cadwolf_fileInfo.item_data.cad_data\">\n<div flex=\"100\" class=\"paddingBottom10 marginBottom20 borderBottom marginTop40 md-headline\" \nng-if=\"cadItem.document_id==vm.thisItem.id\">Currently Linked CAD</div><div layout=\"row\" flex=\"100\" \nng-if=\"cadItem.document_id==vm.thisItem.id\"><div flex=\"30\"><img \nng-src=\"https://s3-us-west-2.amazonaws.com/cadwolf/autocadThumbnails/{{cadItem.picName}}\" class=\"\" \nng-style=\"{\'height\':\'200px\'}\" alt=\"{{item.info.cad_data.title}}\" onerror=\"\"></div><div flex=\"70\"><div layout=\"row\" \nflex=\"100\" class=\"marginBottom20\"><div flex=\"30\" class=\"md-title\">Hub :</div><div flex=\"70\" class=\"marginTop10\">\n{{cadItem[\'hubData\'][\'attributes\'][\'name\']}}</div></div><div layout=\"row\" flex=\"100\" class=\"marginBottom20\"><div \nflex=\"30\" class=\"md-title\">Project :</div><div flex=\"70\" class=\"marginTop10\">\n{{cadItem[\'projectData\'][\'attributes\'][\'name\']}}</div></div><div layout=\"row\" flex=\"100\" class=\"marginBottom20\"><div \nflex=\"30\" class=\"md-title\">File :</div><div flex=\"70\" class=\"marginTop10\">\n{{cadItem[\'fileData\'][\'attributes\'][\'displayName\']}}</div></div></div></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">\nFINISHED EDITING</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/partTree/views/editCadProps.tmpl.html","<md-dialog-content ms-scroll><div flex=\"80\" flex-offset=\"10\" layout-padding layout=\"column\" \nng-if=\"vm.cadwolf_fileInfo.item_data.cadType==\'onshape\'\"><div flex=\"100\" layout=\"row\" layout-align=\"start end\" \nclass=\"smallHeader marginTop30 marginBottom10\"><div class=\"md-title\">Mass</div><div \nclass=\"md-caption greyText paddingBottom5 paddingLeft10\">(numeric then min and max)</div></div><div layout=\"row\" \nflex=\"100\" layout-align=\"center center\"><div flex=\"30\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'mass\'][0]}} kg</div><div flex=\"30\" \nflex-offset=\"5\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'mass\'][1]}} kg</div><div flex=\"30\" \nflex-offset=\"5\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'mass\'][2]}} kg</div></div><div \nflex=\"100\" layout=\"row\" layout-align=\"start end\" class=\"smallHeader marginTop30 marginBottom10\"><div class=\"md-title\">\nVolume</div><div class=\"md-caption greyText paddingBottom5 paddingLeft10\">(numeric then min and max)</div></div><div \nlayout=\"row\" flex=\"100\" layout-align=\"center center\"><div flex=\"30\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'volume\'][0]}} m^3</div><div flex=\"30\" \nflex-offset=\"5\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'volume\'][1]}} m^3</div><div flex=\"30\" \nflex-offset=\"5\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'volume\'][2]}} m^3</div></div><div \nflex=\"100\" layout=\"row\" layout-align=\"start end\" class=\"smallHeader marginTop30 marginBottom10\"><div class=\"md-title\">\nSurface Area</div><div class=\"md-caption greyText paddingBottom5 paddingLeft10\">(numeric then min and max)</div></div>\n<div layout=\"row\" flex=\"100\" layout-align=\"center center\"><div flex=\"30\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'periphery\'][0]}} m^2</div><div \nflex=\"30\" flex-offset=\"5\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'periphery\'][1]}} m^2</div><div \nflex=\"30\" flex-offset=\"5\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'periphery\'][2]}} m^2</div></div><div \nflex=\"100\" layout=\"row\" layout-align=\"start end\" class=\"smallHeader marginTop30 marginBottom10\"><div class=\"md-title\">\nCentroid</div><div class=\"md-caption greyText paddingBottom5 paddingLeft10\">(numeric then min and max)</div></div><div \nlayout=\"row\" flex=\"100\" layout-align=\"center center\"><div flex=\"30\" class=\"md-caption textCentered\">x</div><div \nflex=\"30\" flex-offset=\"5\" class=\"md-caption textCentered\">y</div><div flex=\"30\" flex-offset=\"5\" \nclass=\"md-caption textCentered\">z</div></div><div layout=\"row\" flex=\"100\" layout-align=\"center center\"><div flex=\"30\" \nclass=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'centroid\'][0]}} m</div><div flex=\"30\" \nflex-offset=\"5\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'centroid\'][1]}} m</div><div flex=\"30\" \nflex-offset=\"5\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'centroid\'][2]}} m</div></div><div \nlayout=\"row\" flex=\"100\" layout-align=\"center center\"><div flex=\"30\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'centroid\'][3]}} m</div><div flex=\"30\" \nflex-offset=\"5\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'centroid\'][4]}} m</div><div flex=\"30\" \nflex-offset=\"5\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'centroid\'][5]}} m</div></div><div \nlayout=\"row\" flex=\"100\" layout-align=\"center center\"><div flex=\"30\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'centroid\'][6]}} m</div><div flex=\"30\" \nflex-offset=\"5\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'centroid\'][7]}} m</div><div flex=\"30\" \nflex-offset=\"5\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'centroid\'][8]}} m</div></div><div \nflex=\"100\" layout=\"row\" layout-align=\"start end\" class=\"smallHeader marginTop30 marginBottom10\"><div class=\"md-title\">\nPrincipal Inertia</div><div class=\"md-caption greyText paddingBottom5 paddingLeft10\">(numeric then min and max)</div>\n</div><div layout=\"row\" flex=\"100\" layout-align=\"center center\"><div flex=\"30\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'principalInertia\'][0]}}</div><div \nflex=\"30\" flex-offset=\"5\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'principalInertia\'][1]}}</div><div \nflex=\"30\" flex-offset=\"5\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'principalInertia\'][2]}}</div></div><div\n flex=\"100\" layout=\"row\" layout-align=\"start end\" class=\"smallHeader marginTop30 marginBottom10\"><div class=\"md-title\">\nPrincipal Axes</div><div class=\"md-caption greyText paddingBottom5 paddingLeft10\">(Axes 1, 2, 3)</div></div><div \nlayout=\"row\" flex=\"100\" layout-align=\"center center\"><div flex=\"30\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'principalAxes\'][0][\'x\']}}</div><div \nflex=\"30\" flex-offset=\"5\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'principalAxes\'][0][\'y\']}}</div><div \nflex=\"30\" flex-offset=\"5\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'principalAxes\'][0][\'z\']}}</div></div>\n<div layout=\"row\" flex=\"100\" layout-align=\"center center\"><div flex=\"30\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'principalAxes\'][1][\'x\']}}</div><div \nflex=\"30\" flex-offset=\"5\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'principalAxes\'][1][\'y\']}}</div><div \nflex=\"30\" flex-offset=\"5\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'principalAxes\'][1][\'z\']}}</div></div>\n<div layout=\"row\" flex=\"100\" layout-align=\"center center\"><div flex=\"30\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'principalAxes\'][2][\'x\']}}</div><div \nflex=\"30\" flex-offset=\"5\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'principalAxes\'][2][\'y\']}}</div><div \nflex=\"30\" flex-offset=\"5\" class=\"md-caption textCentered\">\n{{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'principalAxes\'][2][\'z\']}}</div></div>\n<div flex=\"100\" layout=\"row\" layout-align=\"start end\" class=\"smallHeader marginTop30 marginBottom10\"><div \nclass=\"md-title\">Moment of Inertia</div><div class=\"md-caption greyText paddingBottom5 paddingLeft10\">kg m^2</div>\n</div><div layout=\"row\" flex=\"100\" layout-align=\"center center\"><div flex=\"30\" class=\"md-caption textCentered\">\nLxx - {{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'inertia\'][0]}}</div><div \nflex=\"30\" flex-offset=\"5\" class=\"md-caption textCentered\">\nLxy - {{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'inertia\'][1]}}</div><div \nflex=\"30\" flex-offset=\"5\" class=\"md-caption textCentered\">\nLxz - {{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'inertia\'][2]}}</div></div><div \nlayout=\"row\" flex=\"100\" layout-align=\"center center\"><div flex=\"30\" class=\"md-caption textCentered\">\nLyx - {{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'inertia\'][3]}}</div><div \nflex=\"30\" flex-offset=\"5\" class=\"md-caption textCentered\">\nLyy - {{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'inertia\'][4]}}</div><div \nflex=\"30\" flex-offset=\"5\" class=\"md-caption textCentered\">\nLyz - {{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'inertia\'][5]}}</div></div><div \nlayout=\"row\" flex=\"100\" layout-align=\"center center\"><div flex=\"30\" class=\"md-caption textCentered\">\nLzx - {{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'inertia\'][6]}}</div><div \nflex=\"30\" flex-offset=\"5\" class=\"md-caption textCentered\">\nLzy - {{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'inertia\'][7]}}</div><div \nflex=\"30\" flex-offset=\"5\" class=\"md-caption textCentered\">\nLzz - {{vm.thisItem.cad_data.mass_data.bodies[vm.thisItem.cad_data.part_data.partId][\'inertia\'][8]}}</div></div></div>\n<div flex=\"80\" flex-offset=\"10\" layout-padding layout=\"column\" ng-if=\"vm.cadwolf_fileInfo.item_data.cadType==\'fusion\'\">\n<div flex=\"100\" layout=\"row\" layout-align=\"cemter center\"><div flex=\"50\" class=\"md-title\">Mass</div><div flex=\"50\" \nclass=\"md-title\">{{vm.thisItem.cad_data.properties.Mass}}</div></div><div flex=\"100\" layout=\"row\" \nlayout-align=\"cemter center\"><div flex=\"50\" class=\"md-title\">Area</div><div flex=\"50\" class=\"md-title\">\n{{vm.thisItem.cad_data.properties.Area}}</div></div><div flex=\"100\" layout=\"row\" layout-align=\"cemter center\"><div \nflex=\"50\" class=\"md-title\">Volume</div><div flex=\"50\" class=\"md-title\">{{vm.thisItem.cad_data.properties.Volume}}</div>\n</div><div flex=\"100\" layout=\"row\" layout-align=\"cemter center\"><div flex=\"50\" class=\"md-title\">Density</div><div \nflex=\"50\" class=\"md-title\">{{vm.thisItem.cad_data.properties.Density}}</div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">\nFINISHED</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/partTree/views/editDescription.tmpl.html","<md-dialog-content><div class=\"md-dialog-content\"><h2>Change the description</h2><p>\nIn the area below, the user can edit the description for the item. When you are finished editing, you can save the new edit or cancel and return to the original description.\n</p><text-angular ng-model=\"vm.cadwolf_fileInfo.item_data.description\"></text-angular></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.cancel();\">Cancel Edit</md-button><md-button \nng-click=\"vm.acceptChanges(vm.thisDesc);\">Done</md-button></md-dialog-actions>");
$templateCache.put("app/main/apps/partTree/views/editImportPart.tmpl.html","<md-dialog-content ms-scroll><div flex=\"80\" flex-offset=\"10\" layout-padding><div class=\"md-body-1\">\nWhen a part is added to a part tree, a document is created where the design of the part is to be carried out. Instead of redesigning each part, CADWOLF lets users import parts from other documents. This dialog lets users select a document to be copied and used as this part. The copy is independent of the original and parameters can be changed and the design saved. Links to CAD models that existed in the original document are not carried over into the imported part. You will have to add those parts to the model independently and then link them in each document.\n</div><div class=\"md-body-1\">Warning, importing a document will overwrite the contents of the original document.</div>\n<div layout=\"row\" flex=\"100\" layout-align=\"start start\"><div>\nNavigate to the document that will be imported into this document\'s place</div></div><div layout=\"row\"><div \nlayout=\"column\" flex=\"45\"><div class=\"md-title\">Document to import</div><md-input-container class=\"md-block\" \nflex-gt-sm><label>Workspace URL</label><input ng-model=\"vm.inputURL\" \nng-enter=\"vm.getFolderContents( \'\', vm.inputURL )\"></md-input-container><md-list layout=\"column\" layout-fill>\n<md-list-item layout=\"row\" layout-fill flex=\"100\" layout-align=\"start start\" ng-repeat=\"obj in vm.currentContents\" \nng-if=\"(obj.file_type_id==\'Workspace\') ||\n		    			 		(obj.file_type_id==\'Document\') ||\n		    			 		(obj.file_type_id==\'Part Tree\') \" \nclass=\"borderBottom paddingTopBottom5\"><div ng-if=\"obj.file_type_id==\'Workspace\'\" layout=\"row\" layout-fill \nlayout-align=\"start start\" ng-dblclick=\"vm.setNewURL( obj.name )\" class=\"pointerItem\"><div flex=\"10\" flex-offset=\"5\">\n<md-icon md-font-icon=\"icon-folder-outline\"></md-icon></div><div flex=\"85\" class=\"paddingTop3\">{{obj.name}}</div></div>\n<div ng-if=\"obj.file_type_id==\'Part Tree\'\" layout=\"row\" layout-fill layout-align=\"start start\" \nng-dblclick=\"vm.setNewURL( obj.name )\" class=\"pointerItem\"><div flex=\"10\" flex-offset=\"5\"><md-icon \nmd-font-icon=\"icon-sitemap\"></md-icon></div><div flex=\"85\" class=\"paddingTop3\">{{obj.name}}</div></div><div \nng-if=\"obj.file_type_id==\'Document\'\" layout=\"row\" layout-fill layout-align=\"start start\"><div flex=\"10\" \nflex-offset=\"5\"><md-icon md-font-icon=\"icon-file-outline\"></md-icon></div><div flex=\"75\" class=\"paddingTop3\">\n{{obj.name}}</div><div flex=\"10\" class=\"pointerItem\" ng-dblclick=\"vm.setImportDoc( obj, vm.thisItem )\"><md-icon \nmd-font-icon=\"icon-arrange-bring-forward\"><md-tooltip md-direction=\"bottom\">Select this document</md-tooltip></md-icon>\n</div></div></md-list-item></md-list></div><div layout=\"column\" flex=\"45\" flex-offset=\"5\" layout-align=\"center center\">\n<h1>Connected items to import</h1><md-list layout=\"column\" layout-fill><md-list-item layout=\"row\" layout-fill \nflex=\"100\" layout-align=\"center center\" ng-repeat=\"obj in vm.copiedItem[\'item_data\'][\'importedCAD\']\" \nclass=\"borderBottom paddingTopBottom5\"><md-checkbox class=\"no-label md-default-theme\" ng-model=\"obj.includedImport\" \naria-label=\"Item Included\" type=\"checkbox\" role=\"checkbox\"></md-checkbox><div layout=\"row\" layout-fill \nlayout-align=\"start start\" class=\"pointerItem\"><div flex=\"20\" class=\"paddingTop3\"><img \nng-src=\"{{obj.part_data.thumbnailInfo.sizes[3][\'href\']}}\" class=\"md-avatar\" alt=\"\" onerror=\"\"></div><div \nclass=\"md-body-2\">{{obj.document_data.name}}-{{obj.element_data.name}}-{{obj.part_data.name}}</div></div>\n</md-list-item></md-list><h1 class=\"marginTop30\">Destination of CAD files</h1><md-list layout=\"column\" layout-fill>\n<md-list-item layout=\"row\" layout-fill flex=\"100\" layout-align=\"center center\" ng-repeat=\"obj in vm.parentCAD\" \nclass=\"borderBottom paddingTopBottom5\"><md-checkbox class=\"no-label md-default-theme\" ng-model=\"obj.importTo\" \naria-label=\"Item Included\" type=\"checkbox\" role=\"checkbox\"></md-checkbox><div layout=\"row\" layout-fill \nlayout-align=\"start start\" class=\"pointerItem\"><div flex=\"20\" class=\"paddingTop3\"><img \nng-src=\"{{obj.cad_data.element_data.thumbnailInfo.sizes[3][\'href\']}}\" class=\"md-avatar\" alt=\"\" onerror=\"\"></div><div \nclass=\"md-body-2\">\n{{obj.cad_data.document_data.name}}-{{obj.cad_data.element_data.name}}-{{obj.cad_data.part_data.name}}</div></div>\n</md-list-item></md-list><div layout-align=\"center center\"><md-button type=\"submit\" ng-click=\"vm.submitCadImport();\" \nclass=\"send-button md-accent md-raised\">Submit Item for Import</md-button></div></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">\nFINISHED EDITING</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/partTree/views/editName.tmpl.html","<md-dialog-content><div class=\"md-dialog-content\"><h2>Change Name</h2><p>\nEnter the new name of the item in the input below. Remember that names are used in URLs, so the name can contain only letters, numbers, dashes, and spaces.\n</p><md-input-container class=\"md-block\"><label>New name</label><input name=\"newName\" aria-label=\"New Name\" \ntype=\"text\" ng-model=\"vm.newName\" required ng-pattern=\"/[a-zA-Z0-9\\s\\-]{5,30}$/\" minlength=\"5\" maxlength=\"30\"><div \nng-messages=\"nameForm.newName.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\">\nA name is required</div><div ng-message=\"pattern\">Names can only have letters, numbers, spaces, and dashes</div><div \nng-message=\"minlength\">Names must have at least 5 characters</div><div ng-message=\"minlength\">\nNames can have no more than 30 characters</div></div></md-input-container></div></md-dialog-content><div \nid=\"modalFooter\"><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.cancel();\">Cancel Edit</md-button><md-button \nng-show=\"(!nameForm.newName.$error.pattern) && (!nameForm.newName.$error.minlength)\" \nng-click=\"vm.cadwolf_fileInfo.name=vm.newName; vm.cancel();\">Accept New Name</md-button></md-dialog-actions></div>");
$templateCache.put("app/main/apps/partTree/views/editTreeBlock.tmpl.html","<div layout=\"row\" class=\"md-title\">System Details</div><div layout=\"column\" flex=\"100\" \nng-repeat=\"obj in vm.thisItem | orderBy:\'orderNumber\' track by obj.title\" ng-if=\"obj.active == \'true\'\" layout-fill \nlayout-margin><div layout=\"row\" flex=\"100\" layout=\"center center\" layout-fill><div flex=\"30\" class=\"md-body-1\">\nBlock Name</div><md-input-container flex=\"70\" class=\"md-block\"><label>Block Name</label><input ng-model=\"obj.title\">\n</md-input-container></div><div layout=\"row\" flex=\"100\" layout=\"center center\" layout-fill><div flex=\"30\" \nclass=\"md-body-1\">Block Abbreviation</div><md-input-container flex=\"70\" class=\"md-block\"><label>Block Abbreviation\n</label><input ng-model=\"obj.treeRep\"></md-input-container></div><div layout=\"row\" class=\"md-title\">\nOptions for subsystems</div><div layout=\"row\" layout-fill layout-align=\"center center\" ng-click=\"vm.addOption( obj )\">\n<md-button class=\"md-raised md-primary\">Add an option</md-button></div><div layout=\"row\" flex=\"100\" layout-fill \nlayout-align=\"center center\" ng-repeat=\"option in obj.options track by $index\"><div>{{option.name}}</div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteOption( obj, $index )\"><md-icon md-font-icon=\"icon-close-circle-outline\" \naria-label=\"Delete this Block\"></md-icon></md-button></div><div layout=\"row\" flex=\"100\" layout-fill><text-angular \nlayout-fill flex=\"100\" ng-model=\"obj.description\"></text-angular></div></div><md-dialog-actions layout=\"row\"><md-button\n ng-click=\"vm.cancel();\">Finished Editing</md-button></md-dialog-actions>");
$templateCache.put("app/main/apps/partTree/views/editTreeStructure.tmpl.html","<div layout=\"row\" layout-fill flex=\"100\"><div flex=\"20\" layout=\"column\" layout-margin layout-align=\"center center\"><div\n layout=\"column\" flex=\"100\" layout-fill \nng-repeat=\"obj in vm.thisItem | orderBy:\'orderNumber\' track by obj.orderNumber\" layout-align=\"center center\"><div \nlayout=\"row\" layout-fill layout-align=\"center center\" flex=\"100\"><div layout=\"row\" class=\"treeBlock\" layout-fill \nlayout-align=\"center center\" class=\"md-body-1\"><div class=\"md-body-1\">{{obj.title}}</div><md-button \nclass=\"md-icon-button\" ng-if=\"!$last\" ng-click=\"vm.alterStructure( \'delete\', obj.orderNumber )\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\" aria-label=\"Delete this Block\"></md-icon></md-button></div></div><md-icon \nng-if=\"!$last\" md-font-icon=\"icon-dots-vertical\" aria-label=\"\"></md-icon><div layout=\"row\" layout-fill \nlayout-align=\"center center\" ng-if=\"!$last\" flex=\"100\"><md-button class=\"md-icon-button\" \nng-click=\"vm.alterStructure( \'add\', obj.orderNumber )\"><md-icon md-font-icon=\"icon-plus-circle-outline\" \naria-label=\"Add New Block\"></md-icon></md-button></div><md-icon ng-if=\"!$last\" md-font-icon=\"icon-dots-vertical\" \naria-label=\"\"></md-icon></div></div><div layout=\"column\" flex=\"60\" flex-offset=\"10\" layout-margin \nlayout-align=\"start center\"><div class=\"md-title\">Part Tree Structure</div><div class=\"md-body-1\">\nThe structure of the tree determines the way parts and systems are named. The tree starts at the top with the overall structure or project and becomes more specific as you move down the tree. The final component is a unique sequential number. The end result is that someone can look at a part number and know exactly where that part resides on a large structure or project. Each of the entries to the left will be pieced together to form the individual part numbers. Top to bottom will become left to right. You can add options to each level by editing the individual systems. The current part numbering scheme is ...\n</div><div layout=\"row\"><div layout=\"row\" layout-margin \nng-repeat=\"obj in vm.thisItem | orderBy:\'orderNumber\' track by obj.orderNumber\"><div class=\"md-body-1\">{{obj.title}}\n</div><div ng-if=\"!$last\">-</div></div></div></div></div><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.cancel();\">Finished Editing</md-button></md-dialog-actions>");
$templateCache.put("app/main/apps/partTree/views/emptyList.html","<div class=\"md-headline marginTop20\">Favorite Part Trees</div><md-list \nng-if=\"Spark.state.user.user_info.favParttrees.length>0\" class=\"marginTop20\"><md-list-item layout=\"row\" \nclass=\"borderBottom\"><div flex=\"15\">&nbsp</div><div flex=\"30\" translate=\"FM.NAME\" class=\"md-title\">Name</div><div \nflex=\"55\" hide-xs translate=\"FM.LOCATION\" class=\"md-title\">Location</div></md-list-item><md-list-item \nng-repeat=\"parttree in Spark.state.user.user_info.favParttrees\" class=\"borderBottom\" layout=\"row\"><div flex=\"10\">\n<md-icon md-font-icon=\"icon-sitemap\" ng-click=\"$location.path(\'/PartTree/\'+parttree.location)\" class=\"hoverMe\">\n</md-icon></div><div flex=\"30\">{{parttree.name}}</div><div flex=\"55\">{{parttree.location}}</div><div flex=\"5\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\" ng-click=\"vm.removeFavItem( parttree )\" class=\"hoverMe\"></md-icon></div>\n</md-list-item></md-list><div class=\"md-body-1 marginTop20\" ng-if=\"Spark.state.user.user_info.favParttrees.length==0\">\nUsers can \"favorite\" parttrees so that they can be easily accessed. Those parttrees can be shown here. To favorite a parttree, clikc the heart icon in the upper right of the parttree view.\n</div><div class=\"md-headline marginTop20\">Recent Part Trees</div><md-list \nng-if=\"Spark.state.user.user_info.parttrees.length>0\" class=\"marginTop20\"><md-list-item layout=\"row\" \nclass=\"borderBottom\"><div flex=\"15\">&nbsp</div><div flex=\"30\" translate=\"FM.NAME\" class=\"md-title\">Name</div><div \nflex=\"55\" hide-xs translate=\"FM.LOCATION\" class=\"md-title\">Location</div></md-list-item><md-list-item \nng-repeat=\"parttree in Spark.state.user.user_info.parttrees\" class=\"borderBottom\" layout=\"row\"><div flex=\"10\"><md-icon \nmd-font-icon=\"icon-sitemap\" ng-click=\"vm.goToURL(\'/PartTree/\'+parttree.location)\" class=\"hoverMe\"></md-icon></div><div \nflex=\"30\">{{parttree.name}}</div><div flex=\"60\">{{parttree.location}}</div></md-list-item></md-list><div \nclass=\"md-body-1 marginTop20\" ng-if=\"Spark.state.user.user_info.parttrees.length==0\">\nThe list below will show the 10 most recently visited parttrees.</div>");
$templateCache.put("app/main/apps/partTree/views/modalSmallTemplates.tmpl.html","<md-dialog class=\"contact-dialog\" aria-label=\"New System\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between\"><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-sitemap\" \nclass=\"md-avatar avatar contact-avatar huge\"></md-icon><div class=\"contact-name\" ng-if=\"vm.modalType==\'addSystem\'\">\nAdd New System</div><div class=\"contact-name\" ng-if=\"vm.modalType==\'addPart\'\">Add New Part</div><div \nclass=\"contact-name\" ng-if=\"vm.modalType==\'renameSystem\'\">Change System Name</div><div class=\"contact-name\" \nng-if=\"vm.modalType==\'systemCount\'\">System Count</div><div class=\"contact-name\" ng-if=\"vm.modalType==\'moveSystem\'\">\nMove System</div></div></div></md-toolbar><md-dialog-content ms-scroll \nng-if=\"vm.modalType==\'addSystem\' ||\n                                  vm.modalType==\'addPart\' ||\n                                  vm.modalType==\'renameSystem\'\">\n<md-input-container class=\"md-icon-float md-block\"><label>System Name</label><md-icon md-font-icon=\"icon-folder\" \nclass=\"name\"></md-icon><md-select ng-model=\"vm.currentName\"><md-option \nng-repeat=\"option in vm.cadwolf_fileInfo.item_data.segments[vm.segIndex][\'segmentOptions\']\" \nng-value=\"option.optionName\">{{option.optionName}}</md-option></md-select></md-input-container></md-dialog-content>\n<md-dialog-content ms-scroll ng-if=\"vm.modalType==\'moveSystem\'\"><md-input-container class=\"md-icon-float md-block\">\n<label>Move System</label><md-icon md-font-icon=\"icon-folder\" class=\"name\"></md-icon><md-select \nng-model=\"vm.newParent\"><md-option ng-repeat=\"option in vm.partTree\" ng-if=\"option.file_type_id == \'Workspace\'\" \nng-value=\"option.id\">{{option.name}}</md-option></md-select></md-input-container></md-dialog-content><md-dialog-actions\n layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.modalType==\'addSystem\' ||\n                                  vm.modalType==\'addPart\' ||\n                                  vm.modalType==\'moveSystem\' ||\n                                  vm.modalType==\'renameSystem\'\">\n<div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-if=\"vm.modalType==\'addSystem\'\" \nng-click=\"vm.addSystem( \'Workspace\', vm.modalVar, vm.currentName, vm.segIndex ); vm.cancel();\" \nclass=\"send-button md-accent md-raised\">SAVE</md-button><md-button type=\"submit\" ng-if=\"vm.modalType==\'addPart\'\" \nng-click=\"vm.addSystem( \'Document\', vm.modalVar, vm.currentName, vm.segIndex ); vm.cancel();\" \nclass=\"send-button md-accent md-raised\">SAVE</md-button><md-button type=\"submit\" ng-if=\"vm.modalType==\'renameSystem\'\" \nng-click=\"vm.changeSystemName( vm.modalVar, vm.currentName ); vm.cancel();\" class=\"send-button md-accent md-raised\">\nSAVE</md-button><md-button type=\"submit\" ng-if=\"vm.modalType==\'moveSystem\'\" \nng-click=\"vm.moveSystem( vm.modalVar, vm.newParent ); vm.cancel();\" class=\"send-button md-accent md-raised\">Move System\n</md-button></div></md-dialog-actions><md-dialog-content ms-scroll ng-if=\"vm.modalType==\'systemCount\'\">\n<md-input-container class=\"md-icon-float md-block\"><label>System Count</label><md-icon md-font-icon=\"icon-numeric\" \nclass=\"name\"></md-icon><p>The number of this part or system that is included in the parent system.</p><input \nname=\"count\" type=\"text\" ng-model=\"vm.modalVar.item_data.systemCount\" required ng-pattern=\"/[0-9]+/\">\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.modalType==\'systemCount\'\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.updateItem(vm.modalVar); vm.cancel();\">FINISHED</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/partTree/views/modalTemplates.tmpl.html","<md-dialog aria-label=\"\" class=\"large-dialog\" id=\"modalDialog\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2 ng-if=\"vm.modalType==\'Edit Title\'\">Edit Title</h2><h2 \nng-if=\"vm.modalType==\'Edit Description\'\">Edit Description</h2><h2 ng-if=\"vm.modalType==\'CAD Link\'\">\nLink Part or System to CAD</h2><h2 ng-if=\"vm.modalType==\'CAD Props\'\">Properties of CAD Part</h2><h2 \nng-if=\"vm.modalType==\'Permissions\'\">Permissions for this file or folder</h2><h2 ng-if=\"vm.modalType==\'ImportPart\'\">\nImport a Part into this Document</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel();\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-if=\"vm.modalType==\'Edit Title\'\" ng-include=\"\'app/main/apps/partTree/views/editName.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'Edit Description\'\" ng-include=\"\'app/main/apps/partTree/views/editDescription.tmpl.html\'\"></div>\n<div ng-if=\"vm.modalType==\'CAD Link\'\" ng-include=\"\'app/main/apps/partTree/views/editCadLink.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'CAD Props\'\" ng-include=\"\'app/main/apps/partTree/views/editCadProps.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'Permissions\'\" ng-include=\"\'app/main/apps/workspace/views/list/editPermissions.tmpl.html\'\"></div>\n<div ng-if=\"vm.modalType==\'ImportPart\'\" ng-include=\"\'app/main/apps/partTree/views/editImportPart.tmpl.html\'\"></div>\n</md-dialog>");
$templateCache.put("app/main/apps/partTree/views/partTree.html","<div class=\"cadwolfBox\"><div class=\"cadwolfBoxToolbar\" layout=\"row\" flex=\"100\" \nng-if=\"vm.cadwolf_fileInfo.item_data.cadType==\'fusion\'\" layout-align=\"space-between center\"><div \nclass=\"cadwolfToolbarTools\">Part Tree</div><div class=\"marginRight100\"><img \nng-src=\"https://s3-us-west-2.amazonaws.com/cadwolf/stock/Fusion360LogoSmall.png\" height=\"50px\" alt=\"Fusion Logo\" \nonerror=\"\"></div></div><div class=\"cadwolfBoxToolbar\" layout=\"row\" flex=\"100\" \nng-if=\"vm.cadwolf_fileInfo.item_data.cadType==\'onshape\'\" layout-align=\"space-between center\"><div \nclass=\"cadwolfToolbarTools\">Part Tree</div><div class=\"marginRight100\"><img \nng-src=\"https://s3-us-west-2.amazonaws.com/cadwolf/stock/onshapeLogoSmall.png\" height=\"50px\" alt=\"Onshape Logo\" \nonerror=\"\"></div></div><div layout=\"row\" flex=\"90\" flex-offset=\"5\" layout-align=\"space-between center\" \nclass=\"borderBottom marginTopBottom10\"><div flex-offset=\"5\"><md-button class=\"md-raised md-accent marginTop20\" \nng-click=\"vm.showSmallModal(\'\', \'addSystem\', vm.cadwolf_fileInfo, 0)\">Add Top Level System<md-icon \nmd-font-icon=\"icon-plus-circle\" class=\"hoverMe\"></md-icon></md-button></div><div class=\"partInfo\" layout=\"row\"><div \nclass=\"itemValue\"><md-input-container><label>Document Value</label><input placeholder=\"Enter value to sum\" \nng-model=\"vm.showProp\" ng-enter=\"vm.getSumValues( vm.showProp )\"></md-input-container></div><div class=\"itemValue\" \nng-if=\"vm.cadwolf_fileInfo.item_data.cadType==\'onshape\'\"><md-input-container class=\"fullWidth\"><label>CAD Value</label>\n<md-select ng-model=\"vm.cadwolf_fileInfo.item_data.cadShow\"><md-option ng-value=\"\'none\'\">None</md-option><md-option \nng-value=\"\'mass\'\">Mass (kg)</md-option><md-option ng-value=\"\'volume\'\">Volume (m^3)</md-option><md-option \nng-value=\"\'density\'\">Density</md-option><md-option ng-value=\"\'material\'\">Material</md-option><md-option \nng-value=\"\'weightN\'\">Weight (N)</md-option><md-option ng-value=\"\'weightP\'\">Weight (lbs)</md-option></md-select>\n</md-input-container></div><div class=\"itemValue\" ng-if=\"vm.cadwolf_fileInfo.item_data.cadType==\'fusion\'\">\n<md-input-container class=\"fullWidth\"><label>CAD Value</label><md-select \nng-model=\"vm.cadwolf_fileInfo.item_data.cadShow\"><md-option ng-value=\"\'none\'\">None</md-option><md-option \nng-value=\"\'mass\'\">Mass</md-option><md-option ng-value=\"\'area\'\">Area</md-option><md-option ng-value=\"\'volume\'\">Volume\n</md-option><md-option ng-value=\"\'density\'\">Density</md-option><md-option ng-value=\"\'material\'\">Material</md-option>\n<md-option ng-value=\"\'weightN\'\">Weight (N)</md-option><md-option ng-value=\"\'weightP\'\">Weight (lbs)</md-option>\n</md-select></md-input-container></div><div class=\"partSpacer\"></div></div></div><div layout-align=\"end start\" \nflex=\"90\" flex-offset=\"5\" part-tree-system parttree=\"vm.partTree\" solve-status=\"vm.solveStatus\" \nthissystem=\"vm.cadwolf_fileInfo\" spark=\"Spark\" cadshow=\"vm.cadwolf_fileInfo.item_data.cadShow\" \ncadtype=\"vm.cadwolf_fileInfo.item_data.cadType\" systemlevel=\"0\" segments=\"vm.cadwolf_fileInfo.item_data.segments\" \nadd-system=\"vm.addSystem\" add-part=\"vm.addPart\" delete-system=\"vm.deleteSystem\" \nchange-system-name=\"vm.changeSystemName\" show-modal=\"vm.showModal\" navigate-url=\"vm.navigateUrl\" \ncheck-included=\"vm.checkIncluded\" update-material=\"vm.updateMaterial\" update-mass=\"vm.updateMass\" \ncalculate-mass=\"vm.calculateMass\" exclude-children=\"vm.excludeChildren\" include-children=\"vm.includeChildren\" \nshow-small-modal=\"vm.showSmallModal\" update-file=\"vm.updateFile\" remove-cad-conn=\"vm.removeCadConn\" \nupdate-fusion-data=\"vm.updateFusionData\" insolve=\"vm.inSolve\"></div></div>");
$templateCache.put("app/main/apps/partTree/views/partTreeCadType.html","<div class=\"cadwolfBox\"><div class=\"cadwolfBoxToolbar\" layout=\"row\" flex=\"100\" \nng-click=\"vm.select( vm.cadwolf_fileInfo )\" \nng-dblclick=\"vm.showSmallModal(\'\', vm.cadwolf_fileInfo, \'Edit Title\', true)\" \nng-class=\"{\'selected\' : vm.selected === vm.cadwolf_fileInfo}\" layout-align=\"space-between center\"><div \nclass=\"cadwolfToolbarTools\" flex=\"90\">Part Tree CAD Type</div></div><div layout=\"row\" flex=\"80\" flex-offset=\"10\"><div \nlayout=\"column\" layout-margin><div class=\"md-body-1\">\nCADWOLF links with the Onshape CAD platform as well as Autodesk\'s Fusion 360 Platform. Different options are possible for each CAD platform. A part tree represents an entire structure, all of which should be either entirely contained within Onshape or Fusion 360. Select that platform here.\n</div><div layout=\"row\" layout-fill class=\"marginTop20\" layout-align=\"center center\"><div flex=\"25\" flex-offset=\"25\" \nlayout-align=\"center center\" ng-style=\"{\'height\':\'100px\', \'margin\':\'20px\', \'padding\':\'10px\'}\" \nclass=\"borderMe textCentered hoverMe\" ng-if=\"vm.cadwolf_fileInfo.item_data.cadType==\'onshape\'\" \nng-click=\"vm.cadwolf_fileInfo.item_data.cadType=\'onshape\'\"><img \nng-src=\"https://s3-us-west-2.amazonaws.com/cadwolf/stock/onshapeLogo.png\" class=\"md-avatar\" alt=\"Onshape Logo\" \nonerror=\"\"></div><div flex=\"25\" flex-offset=\"25\" layout-align=\"center center\" \nng-style=\"{\'height\':\'100px\', \'margin\':\'20px\', \'padding\':\'10px\'}\" class=\"textCentered hoverMe\" \nng-if=\"vm.cadwolf_fileInfo.item_data.cadType!=\'onshape\'\" ng-click=\"vm.cadwolf_fileInfo.item_data.cadType=\'onshape\'\">\n<img ng-src=\"https://s3-us-west-2.amazonaws.com/cadwolf/stock/onshapeLogo.png\" class=\"md-avatar\" alt=\"Onshape Logo\" \nonerror=\"\"></div><div flex=\"25\" layout-align=\"center center\" \nng-style=\"{\'height\':\'100px\', \'margin\':\'20px\', \'padding\':\'10px\'}\" class=\"borderMe textCentered hoverMe\" \nng-if=\"vm.cadwolf_fileInfo.item_data.cadType==\'fusion\'\" ng-click=\"vm.cadwolf_fileInfo.item_data.cadType=\'fusion\'\"><img \nng-src=\"https://s3-us-west-2.amazonaws.com/cadwolf/stock/Fusion360Logo.png\" class=\"md-avatar marginTop20\" \nalt=\"Fusion Logo\" onerror=\"\"></div><div flex=\"25\" layout-align=\"center center\" \nng-style=\"{\'height\':\'100px\', \'margin\':\'20px\', \'padding\':\'10px\'}\" class=\"textCentered hoverMe\" \nng-if=\"vm.cadwolf_fileInfo.item_data.cadType!=\'fusion\'\" ng-click=\"vm.cadwolf_fileInfo.item_data.cadType=\'fusion\'\"><img \nng-src=\"https://s3-us-west-2.amazonaws.com/cadwolf/stock/Fusion360Logo.png\" class=\"md-avatar marginTop20\" \nalt=\"Fusion Logo\" onerror=\"\"></div><div flex=\"25\"></div></div></div></div></div>");
$templateCache.put("app/main/apps/partTree/views/partTreeDocs.html","<div class=\"cadwolfBox\"><div class=\"cadwolfBoxToolbar\" layout=\"row\" flex=\"100\" layout-align=\"space-between center\"><div\n class=\"cadwolfToolbarTools\">Associated Documents</div></div><div layout=\"column\" flex=\"90\" flex-offset=\"5\" \nlayout-align=\"space-between center\" class=\"marginTopBottom10\"><p>\nThe list below holds documents that have been tagged to this part tree by a user. The documents in some way are related to this tree and the part tree may or may not read variables from them. If you have permission to edit this tree, you can add or remove documents.\n</p><div ng-if=\"vm.editPerm\" layout=\"row\" layout-fill><md-input-container class=\"md-block\" flex-gt-sm><label>\nWorkspace URL</label><input ng-model=\"vm.inputURL\" ng-enter=\"vm.getFolderContents( \'\', vm.inputURL )\">\n</md-input-container></div><div ng-if=\"vm.editPerm\" layout=\"row\" layout-fill><md-list flex=\"80\" flex-offset=\"10\">\n<md-list-item layout=\"row\" layout-align=\"center center\" ng-repeat=\"obj in vm.currentContents\" \nng-if=\"(obj.file_type_id==\'Workspace\') ||\n                            (obj.file_type_id==\'Document\') ||\n                            (obj.file_type_id==\'Part Tree\')\" \nclass=\"borderBottom paddingTopBottom5 pointerItem greyHoverBack\"><div ng-if=\"obj.file_type_id==\'Workspace\'\" \nlayout=\"row\" layout-fill layout-align=\"center center\" ng-click=\"vm.setNewURL( obj.name )\"><div flex=\"5\" \nclass=\"marginTopBottom5\"><md-icon md-font-icon=\"icon-folder-outline\"></md-icon></div><div flex=\"80\" \nclass=\"paddingTopBottom5\">{{obj.name}}</div></div><div ng-if=\"obj.file_type_id==\'Document\'\" layout=\"row\" layout-fill \nlayout-align=\"center center\" ng-click=\"vm.addRelatedDoc( obj )\"><div flex=\"5\"><md-icon \nmd-font-icon=\"icon-file-outline\"></md-icon></div><div flex=\"80\" class=\"paddingTopBottom5\">{{obj.name}}</div></div><div \nng-if=\"obj.file_type_id==\'Part Tree\'\" layout=\"row\" layout-fill layout-align=\"center center\" \nng-click=\"vm.setNewURL( obj.name )\"><div flex=\"5\"><md-icon md-font-icon=\"icon-sitemap\"></md-icon></div><div flex=\"80\" \nclass=\"paddingTopBottom5\">{{obj.name}}</div></div></md-list-item></md-list></div><md-divider md-inset></md-divider>\n<md-list layout-fill><div ng-if=\"vm.cadwolf_fileInfo.item_data.assFiles.length==0\" class=\"md-body-1\">\nThere are no files associated with this part tree.</div><md-list-item layout=\"row\" \nng-if=\"vm.cadwolf_fileInfo.item_data.assFiles.length > 0\" layout-fill><div flex=\"25\" \nclass=\"md-title paddingTopBottom5\">Title</div><div flex=\"70\" class=\"md-title paddingTopBottom5\">URL</div>\n</md-list-item><md-list-item layout=\"row\" layout-fill ng-repeat=\"item in vm.cadwolf_fileInfo.item_data.assFiles\"><div \nflex=\"25\" class=\"md-body-1 paddingTopBottom5\">{{item.name}}</div><div flex=\"70\" class=\"md-body-1 paddingTopBottom5\">\n{{item.docPath}}</div><div flex=\"5\" ng-if=\"vm.editPerm\"><md-icon md-font-icon=\"icon-delete\" \nng-click=\"vm.deleteAssFile(item)\"></md-icon></div></md-list-item></md-list></div></div>");
$templateCache.put("app/main/apps/partTree/views/partTreeInfo.html","<div class=\"cadwolfBox\"><div class=\"cadwolfBoxToolbar\" layout=\"row\" flex=\"100\" \nng-click=\"vm.select( vm.cadwolf_fileInfo )\" \nng-dblclick=\"vm.showSmallModal(\'\', vm.cadwolf_fileInfo, \'Edit Title\', true)\" \nng-class=\"{\'selected\' : vm.selected === vm.cadwolf_fileInfo}\" layout-align=\"space-between center\"><div \nclass=\"cadwolfToolbarTools\" flex=\"90\">{{vm.cadwolf_fileInfo.name}}</div><div flex=\"10\"><div flex=\"50\" \nng-if=\"!vm.cadwolf_fileInfo.favorite && Spark.state.user!=null\"><md-icon md-font-icon=\"icon-heart-outline\" \nng-click=\"vm.favoriteItem();\" class=\"hoverMe iconRedBackground\"><md-tooltip md-direction=\"bottom\">Click to like\n</md-tooltip></md-icon></div><div flex=\"50\" ng-if=\"vm.cadwolf_fileInfo.favorite && Spark.state.user!=null\"><md-icon \nmd-font-icon=\"icon-heart\" ng-click=\"vm.favoriteItem();\" class=\"hoverMe iconRedBackground\"><md-tooltip \nmd-direction=\"bottom\">Click to unlike</md-tooltip></md-icon></div></div></div><div layout=\"row\" flex=\"80\" \nflex-offset=\"10\"><div layout=\"column\" layout-margin><div class=\"md-body-1\" \nng-bind-html=\"vm.cadwolf_fileInfo.item_data.description\"></div></div></div></div>");
$templateCache.put("app/main/apps/partTree/views/partTreeSetup.html","<div class=\"cadwolfBox\"><div class=\"cadwolfBoxToolbar\" layout=\"row\" flex=\"100\" layout-align=\"space-between center\"><div\n class=\"cadwolfToolbarTools\">Part Tree Setup</div></div><div layout=\"row\" layout-fill><div layout=\"column\" flex=\"25\" \nlayout-align=\"start center\"><div><md-icon md-font-icon=\"icon-plus-circle-outline\" ng-if=\"vm.editPerm\" class=\"hoverMe\" \nng-click=\"vm.addSegment( 0 )\"></md-icon></div><div \nng-repeat=\"segment in vm.cadwolf_fileInfo.item_data.segments track by $index\" layout=\"column\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" class=\"treeBlock\" \nng-class=\"{\'selected\' : vm.selected === segment}\" \nng-click=\"vm.cadwolf_fileInfo.item_data.selectedSegment=$index; vm.select( segment )\"><div>{{segment[\'segmentName\']}}\n</div><span></span><div ng-if=\"vm.editPerm\"><md-icon md-font-icon=\"icon-close-circle-outline\" \nng-click=\"vm.deleteSegment( $index )\" class=\"hoverMe\"></md-icon></div></div><div layout=\"row\" class=\"treeBlockLine\">\n<div class=\"treeBlockLeft\"></div><div class=\"treeBlockRight\"></div></div><div><md-icon \nmd-font-icon=\"icon-plus-circle-outline\" ng-if=\"vm.editPerm\" class=\"hoverMe\" ng-click=\"vm.addSegment( $index + 1 )\">\n</md-icon></div><div layout=\"row\" class=\"treeBlockLine\"><div class=\"treeBlockLeft\"></div><div class=\"treeBlockRight\">\n</div></div></div><div layout=\"row\" layout-align=\"start center\" class=\"treeBlock\"><div>Part Number</div></div></div>\n<div flex=\"70\" flex-offset=\"0\" layout-align=\"start start\"><div layout=\"row\" class=\"marginTopBottom20\"><div \nclass=\"md-subhead marginTop20\" flex=\"20\">Segment Name :</div><div ng-if=\"vm.editPerm\" flex=\"70\" class=\"marginTop15\">\n<md-input-container layout-fill><input \nng-model=\"vm.cadwolf_fileInfo.item_data[\'segments\'][vm.cadwolf_fileInfo.item_data.selectedSegment][\'segmentName\']\" \nng-enter=\"vm.checkTreeIntegrity()\" ng-blur=\"vm.checkTreeIntegrity()\"></md-input-container></div><div \nng-if=\"!vm.editPerm\" flex=\"60\" flex-offset=\"5\">\n{{vm.cadwolf_fileInfo.item_data[\'segments\'][vm.cadwolf_fileInfo.item_data.selectedSegment][\'segmentName\']}}</div></div>\n<div layout=\"row\" class=\"marginTop20\"><div class=\"md-subhead\">Segment Options</div><div ng-if=\"vm.editPerm\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\" class=\"hoverMe iconGreenBackground\" \nng-click=\"vm.addOption( vm.cadwolf_fileInfo.item_data.selectedSegment )\"></md-icon></div></div><div \nclass=\"marginBottom20\"><md-list><md-list-item \nng-repeat=\"thisOption in vm.cadwolf_fileInfo.item_data.segments[vm.cadwolf_fileInfo.item_data.selectedSegment][\'segmentOptions\'] track by $index\" \nlayout=\"row\" layout-align=\"center start\" flex=\"100\" class=\"cadwolf-list-item-tall marginTop10\"><div \nng-if=\"!vm.editPerm\">{{thisOption.optionAbbr}} - {{thisOption.optionName}}</div><div ng-if=\"vm.editPerm\" flex=\"5\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"hoverMe iconRedBackground\" \nng-click=\"vm.deleteOption( vm.cadwolf_fileInfo.item_data.selectedSegment, $index )\"></md-icon></div><div \nng-if=\"vm.editPerm\" flex=\"100\"><md-input-container flex=\"50\" layout-fill><label>New name</label><input \nng-model=\"thisOption.optionName\" ng-enter=\"vm.checkTreeIntegrity()\" ng-blur=\"vm.checkTreeIntegrity()\">\n</md-input-container><md-input-container flex=\"50\" layout-fill><label>New Abbreviation</label><input \nng-model=\"thisOption.optionAbbr\" ng-enter=\"vm.checkTreeIntegrity()\" ng-blur=\"vm.checkTreeIntegrity()\">\n</md-input-container></div><md-divider></md-divider></md-list-item></md-list></div><div layout=\"row\" \nclass=\"md-subhead\">Segment Description</div><div class=\"md-body-1\" ng-if=\"!vm.editPerm\" \nng-bind-html=\"vm.cadwolf_fileInfo.item_data.segments[vm.cadwolf_fileInfo.item_data.selectedSegment][\'segmentDescription\']\">\n</div><div ng-if=\"vm.editPerm\"><text-angular layout-fill \nng-model=\"vm.cadwolf_fileInfo.item_data.segments[vm.cadwolf_fileInfo.item_data.selectedSegment][\'segmentDescription\']\">\n</text-angular></div></div></div></div>");
$templateCache.put("app/main/apps/partTree/views/partTreeSystem.html","<div layout-fill ng-repeat=\"system in parttree | orderBy:\'order\' track by $index\" \nng-if=\"system.parent_id==thissystem.id\"><div layout=\"row\" layout-align=\"space-between center\" class=\"mainLine\"><div \nlayout=\"row\" layout-align=\"center center\"><span class=\"marginRight5\" \nng-if=\"system.item_data.systemChildren && (system.item_data.systemLevel != segments.length)\" \nng-click=\"system.item_data.systemChildren=!system.item_data.systemChildren\"><md-icon md-font-icon=\"icon-menu-down\" \nclass=\"iconGreyBackground hoverMe\"></md-icon></span><span class=\"marginRight5\" \nng-if=\"!system.item_data.systemChildren && (system.item_data.systemLevel != segments.length)\" \nng-click=\"system.item_data.systemChildren=!system.item_data.systemChildren\"><md-icon md-font-icon=\"icon-menu-right\" \nclass=\"iconGreyBackground hoverMe\"></md-icon></span><span class=\"marginTop5 marginLeft10\" \nng-if=\"system.item_data.systemLevel < segments.length\">{{system.name}} </span><span class=\"marginTop5 marginLeft10\" \nng-if=\"system.item_data.systemLevel == segments.length\">{{system.treeNameAbbr}}</span><div class=\"partSymbol\" \nng-if=\"cadtype==\'onshape\'\"><img ng-src=\"{{system.cad_data.element_data.thumbnailInfo.sizes[0][\'href\']}}\" \nclass=\"md-avatar\" alt=\"{{item.info.cad_data.title}}\" onerror=\"\"></div><div class=\"partSymbol\" \nng-if=\"cadtype==\'fusion\'\"><img \nng-src=\"https://s3-us-west-2.amazonaws.com/cadwolf/autocadThumbnails/{{system.cad_data.picName}}\" class=\"md-avatar\" \nalt=\"{{item.info.cad_data.title}}\" onerror=\"\"></div><div class=\"marginRight5\" ng-if=\"system.errorFlag\"><md-icon \nmd-font-icon=\"icon-flag-variant\" class=\"iconRedBackground hoverMe\"><md-tooltip md-direction=\"bottom\">\nThis part or systen is out of sync with the part tree scheme</md-tooltip></md-icon></div></div><div class=\"partInfo\" \nlayout=\"row\"><div class=\"itemValue\" ng-if=\"system.itemValue!==NaN\">{{system.itemValue}}</div><div class=\"itemValue\" \nng-if=\"system.itemValue===NaN\">-</div><div class=\"itemValue\" \nng-if=\"( (system.cad_data.element_data.elementType===undefined) && \n				 	 			( cadtype==\'onshape\' ) ) || (cadshow===\'none\')\">\n-</div><div class=\"itemValue\" \nng-if=\"(system.cad_data.element_data.elementType==\'ASSEMBLY\') && \n				 	 		(cadshow==\'mass\') && \n				 	 		system.cad_data.takeFromCAD &&\n				 	 		cadtype==\'onshape\'\">\n{{system.cad_data.mass_data.mass | limitTo : 12}}</div><div class=\"itemValue\" \nng-if=\"(system.cad_data.element_data.elementType==\'ASSEMBLY\') && \n				 	 (cadshow==\'mass\') && \n				 	 !system.cad_data.takeFromCAD &&\n				 	 cadtype==\'onshape\'\">\n{{system.cad_data.mass_data.mass_calc | limitTo : 12}}</div><div class=\"itemValue\" \nng-if=\"(system.cad_data.element_data.elementType==\'PARTSTUDIO\') && \n				 	 (cadshow==\'mass\') &&\n				 	 cadtype==\'onshape\'\">\n{{system.cad_data.mass_data.bodies[system.cad_data.part_data.partId][\'mass\'][1] | limitTo : 12}}</div><div \nclass=\"itemValue\" ng-if=\"(cadshow==\'mass\') && \n				 	 		cadtype==\'fusion\'\">\n{{system.cad_data.bodyData.properties.Mass | limitTo : 12}}</div><div class=\"itemValue\" \nng-if=\"(system.cad_data.element_data.elementType==\'ASSEMBLY\') && (cadshow==\'volume\')\">\n{{system.cad_data.mass_data.volume | limitTo : 12}}</div><div class=\"itemValue\" \nng-if=\"(system.cad_data.element_data.elementType==\'PARTSTUDIO\') && (cadshow==\'volume\')\">\n{{system.cad_data.mass_data.bodies[system.cad_data.part_data.partId][\'volume\'][1] | limitTo : 12}}</div><div \nclass=\"itemValue\" ng-if=\"(cadshow==\'volume\') &&\n				 	 		 cadtype==\'fusion\'\">\n{{system.cad_data.bodyData.properties.Volume | limitTo : 12}}</div><div class=\"itemValue\" \nng-if=\"(system.cad_data.element_data.elementType==\'ASSEMBLY\') && (cadshow==\'material\')\">-</div><div class=\"itemValue\" \nng-if=\"(system.cad_data.element_data.elementType==\'PARTSTUDIO\') && (cadshow==\'material\')\">\n{{system.cad_data.material_data.material.id}}</div><div class=\"itemValue\" \nng-if=\"(cadshow==\'material\') &&\n				 	 		 cadtype==\'fusion\'\">\n{{system.cad_data.bodyData.properties.Material | limitTo : 12}}</div><div class=\"itemValue\" \nng-if=\"(system.cad_data.element_data.elementType==\'ASSEMBLY\') && (cadshow==\'density\')\">-</div><div class=\"itemValue\" \nng-if=\"(system.cad_data.element_data.elementType==\'PARTSTUDIO\') && (cadshow==\'density\')\">\n{{system.cad_data.material_data.material.properties[0][\'value\'] | limitTo : 12}} {{system.cad_data.material_data.material.properties[0][\'units\']}}\n</div><div class=\"itemValue\" ng-if=\"(cadshow==\'density\') &&\n				 	 		 cadtype==\'fusion\'\">\n{{system.cad_data.bodyData.properties.Density | limitTo : 12}}</div><div class=\"itemValue\" \nng-if=\"(system.cad_data.element_data.elementType==\'ASSEMBLY\') && (cadshow==\'weightN\') && system.cad_data.takeFromCAD\">\n{{system.cad_data.mass_data.weight_N | limitTo : 12}}</div><div class=\"itemValue\" \nng-if=\"(system.cad_data.element_data.elementType==\'ASSEMBLY\') && (cadshow==\'weightN\') && !system.cad_data.takeFromCAD\">\n{{system.cad_data.mass_data.weight_N_calc | limitTo : 12}}</div><div class=\"itemValue\" \nng-if=\"(system.cad_data.element_data.elementType==\'PARTSTUDIO\') && (cadshow==\'weightN\')\">\n{{system.cad_data.mass_data.bodies[system.cad_data.part_data.partId][\'weight_N\'] | limitTo : 12}}</div><div \nclass=\"itemValue\" ng-if=\"(cadshow==\'weightN\') &&\n				 	 		 cadtype==\'fusion\'\">\n{{system.cad_data.bodyData.properties.weightN | limitTo : 12}}</div><div class=\"itemValue\" \nng-if=\"(system.cad_data.element_data.elementType==\'ASSEMBLY\') && (cadshow==\'weightP\') && system.cad_data.takeFromCAD\">\n{{system.cad_data.mass_data.weight_P | limitTo : 12}}</div><div class=\"itemValue\" \nng-if=\"(system.cad_data.element_data.elementType==\'ASSEMBLY\') && (cadshow==\'weightP\') && !system.cad_data.takeFromCAD\">\n{{system.cad_data.mass_data.weight_P_calc | limitTo : 12}}</div><div class=\"itemValue\" \nng-if=\"(system.cad_data.element_data.elementType==\'PARTSTUDIO\') && (cadshow==\'weightP\')\">\n{{system.cad_data.mass_data.bodies[system.cad_data.part_data.partId][\'weight_P\'] | limitTo : 12}}</div><div \nclass=\"itemValue\" ng-if=\"(cadshow==\'weightP\') &&\n				 	 		 cadtype==\'fusion\'\">\n{{system.cad_data.bodyData.properties.weightP | limitTo : 12}}</div><div class=\"itemValue\" \nng-if=\"(cadshow==\'area\') &&\n				 	 		 cadtype==\'fusion\'\">{{system.cad_data.bodyData.properties.Area | limitTo : 12}}\n</div><div class=\"partStatus\"></div><div class=\"partCount hoverMe\" \nng-click=\"callShowSmallModal( ev, \'systemCount\', system, system.item_data.systemLevel )\">\n{{system.item_data.systemCount}}<md-tooltip md-direction=\"bottom\">Number in assembly</md-tooltip></div><div \nclass=\"partStatus\" ng-if=\"solveStatus\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"iconLightGreyBackground\"></md-icon><md-tooltip md-direction=\"bottom\">Currently Solving Document</md-tooltip>\n</div><div class=\"partStatus\" ng-if=\"system.needs_update && system.item_data.systemIncluded!=1 && !solveStatus\" \nng-click=\"system.item_data.systemIncluded=1; callIncludeChildren(system.id, parttree); callCheckIncluded(parttree);\">\n<md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"iconRedBackground hoverMe\"></md-icon><md-tooltip \nmd-direction=\"bottom\">Out of date / Not Included</md-tooltip></div><div class=\"partStatus\" \nng-if=\"system.needs_update && system.item_data.systemIncluded==1 && !solveStatus\" \nng-click=\"system.item_data.systemIncluded=0; callExcludeChildren(system.id, parttree); callCheckIncluded(parttree);\">\n<md-icon md-font-icon=\"icon-check-circle\" class=\"iconRedBackground hoverMe\"></md-icon><md-tooltip \nmd-direction=\"bottom\">Out of date / Included</md-tooltip></div><div class=\"partStatus\" \nng-if=\"!system.needs_update && system.item_data.systemIncluded!=1 && !solveStatus\" \nng-click=\"system.item_data.systemIncluded=1; callIncludeChildren(system.id, parttree); callCheckIncluded(parttree);\">\n<md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"iconGreenBackground hoverMe\"></md-icon><md-tooltip \nmd-direction=\"bottom\">Up to date / Not Included</md-tooltip></div><div class=\"partStatus\" \nng-if=\"!system.needs_update && system.item_data.systemIncluded==1 && !solveStatus\" \nng-click=\"system.item_data.systemIncluded=0; callExcludeChildren(system.id, parttree); callCheckIncluded(parttree);\">\n<md-icon md-font-icon=\"icon-check-circle\" class=\"iconGreenBackground hoverMe\"></md-icon><md-tooltip \nmd-direction=\"bottom\">Up to date / Included</md-tooltip></div><div class=\"partSubMenu\" ng-if=\"insolve === 1\"><md-button\n class=\"md-icon-button\" aria-label=\"In Solve\" ng-click=\"\"><md-icon md-font-icon=\"icon-clock\"></md-icon></md-button>\n<md-tooltip md-direction=\"bottom\">Document being updated</md-tooltip></div><div class=\"partSubMenu\" \nng-if=\"insolve !== 1\"><md-menu md-offset=\"0 -7\"><md-button class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content>\n<md-menu-item ng-if=\"system.errorFlag\"><md-button \nng-click=\"callShowSmallModal( ev, \'renameSystem\', system, system.item_data.systemLevel ) \">Change System Name\n</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"callShowSmallModal( ev, \'moveSystem\', system, system.item_data.systemLevel ) \">Move System</md-button>\n</md-menu-item><md-menu-item ng-if=\"system.item_data.systemLevel==segments.length\"><md-button \nng-click=\"callNavigateUrl( system, system.treeNameFull )\">Open Document</md-button></md-menu-item><md-menu-item>\n<md-button ng-if=\"( system.item_data.checkout_id == spark.state.user.id )\" \nng-click=\"solveStatus=true; callUpdateFile( system.id, \'partTreeUpdate\' )\">Update Document</md-button><md-button \nng-if=\"( system.item_data.checkout_id != spark.state.user.id )\">Not Checked Out</md-button></md-menu-item><md-menu-item\n ng-if=\"system.item_data.systemLevel<segments.length-1\"><md-button \nng-click=\"callShowSmallModal( ev, \'addSystem\', system, system.item_data.systemLevel+1 ) \">Add subsystem</md-button>\n</md-menu-item><md-menu-item ng-if=\"system.item_data.systemLevel==segments.length-1\"><md-button \nng-click=\"callAddPart( system, system.item_data.systemLevel+1 ) \">Add Part</md-button></md-menu-item><md-menu-item \nng-if=\"system.item_data.systemLevel==segments.length\"><md-button ng-click=\"callShowModal( system, \'ImportPart\'  )\">\nImport Part</md-button></md-menu-item><md-menu-item ng-if=\"!system.errorFlag\"><md-button \nng-click=\"callShowSmallModal( ev, \'renameSystem\', system, system.item_data.systemLevel )\">Rename this system\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"callShowModal( system, \'CAD Link\'  )\">Link to CAD\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"callRemoveCadConn( system.id )\">Remove CAD Link\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"callShowModal( system, \'Permissions\'  )\">Permissions\n</md-button></md-menu-item><md-menu-item ng-if=\"system.cad_data.document_data.id !== undefined\"><md-button><a \nhref=\"https://cad.onshape.com/documents/{{system.cad_data.document_data.id}}/w/{{system.cad_data.document_data.defaultWorkspace.id}}/e/{{system.cad_data.element_data.id}}\" \ntarget=\"_blank\">Open CAD File</a></md-button></md-menu-item><md-menu-item \nng-if=\"( system.item_data.systemLevel==segments.length ) && ( system.cad_data.part_data.partId !== undefined )\">\n<md-button ng-click=\"callShowModal( system, \'CAD Props\' ) \">CAD Properties</md-button></md-menu-item><md-menu-item \nng-if=\"system.item_data.systemLevel==segments.length && cadtype==\'onshape\'\"><md-button \nng-click=\"callUpdateMaterial( system )\">Update CAD Material</md-button></md-menu-item><md-menu-item \nng-if=\"system.item_data.systemLevel < segments.length && cadtype==\'onshape\'\"><md-button \nng-click=\"callUpdateMass( system )\">Update CAD Mass</md-button></md-menu-item><md-menu-item ng-if=\"cadtype==\'fusion\'\">\n<md-button ng-click=\"callUpdateFusionData( system.cad_data.cleanID, system.cad_data.projectData.id, system.id )\">\nUpdate CAD</md-button></md-menu-item><md-menu-item><md-button ng-click=\"callDeleteSystem( system )\">Delete this system\n</md-button></md-menu-item></md-menu-content></md-menu></div></div></div><div \nng-show=\"system.item_data.systemChildren\" layout-align=\"end start\" flex=\"95\" flex-offset=\"5\" part-tree-system \nng-if=\"system.parent_id==thissystem.id\" parttree=\"parttree\" solve-status=\"solveStatus\" thissystem=\"system\" \nspark=\"spark\" cadshow=\"cadshow\" cadtype=\"cadtype\" systemlevel=\"systemlevel\" segments=\"segments\" \nadd-system=\"callAddSystem\" add-part=\"callAddPart\" delete-system=\"callDeleteSystem\" \nchange-system-name=\"callChangeSystemName\" move-system=\"moveSystem\" show-modal=\"callShowModal\" \nnavigate-url=\"callNavigateUrl\" check-included=\"callCheckIncluded\" update-material=\"callUpdateMaterial\" \nupdate-mass=\"callUpdateMass\" calculate-mass=\"callCalculateMass\" exclude-children=\"callExcludeChildren\" \ninclude-children=\"callIncludeChildren\" show-small-modal=\"callShowSmallModal\" update-file=\"callUpdateFile\" \nremove-cad-conn=\"callRemoveCadConn\" update-fusion-data=\"callUpdateFusionData\" insolve=\"insolve\"></div></div>");
$templateCache.put("app/main/apps/plot/views/emptyList.html","<div class=\"md-headline marginTop20\">Favorite Plots</div><md-list ng-if=\"Spark.state.user.user_info.favPlots.length>0\" \nclass=\"marginTop20\"><md-list-item layout=\"row\" class=\"borderBottom\"><div flex=\"15\">&nbsp</div><div flex=\"30\" \ntranslate=\"FM.NAME\" class=\"md-title\">Name</div><div flex=\"55\" hide-xs translate=\"FM.LOCATION\" class=\"md-title\">Location\n</div></md-list-item><md-list-item ng-repeat=\"plot in Spark.state.user.user_info.favPlots\" class=\"borderBottom\"><div \nflex=\"10\"><md-icon md-font-icon=\"icon-chart-line\" ng-click=\"$location.path(\'/Plot/\'+plot.location)\" class=\"hoverMe\">\n</md-icon></div><div flex=\"30\">{{plot.name}}</div><div flex=\"55\">{{plot.location}}</div><div flex=\"5\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\" ng-click=\"vm.removeFavItem( plot )\" class=\"hoverMe\"></md-icon></div>\n</md-list-item></md-list><div class=\"md-body-1 marginTop20\" ng-if=\"Spark.state.user.user_info.favPlots.length==0\">\nUsers can \"favorite\" Plots so that they can be easily accessed. Those Plots can be shown here. To favorite a plot, clikc the heart icon in the upper right of the plot view.\n</div>");
$templateCache.put("app/main/apps/plot/views/enterDocument.html","<div flex=\"80\" flex-offset=\"10\" layout-fill><p>\nIn the box below, you can enter the URL for a document and a list of the plots in that document will be shown below. Clicking on one of those plots will open the plot.\n</p></div><div flex=\"80\" flex-offset=\"10\" layout-fill><md-input-container class=\"md-block\"><label>\nEnter Document with Plot</label><input ng-model=\"vm.plotURL\" ng-enter=\"vm.getCharts(vm.plotURL)\" layout=\"fill\">\n</md-input-container></div><md-list><md-list-item ng-repeat=\"item in vm.fileCharts\" ng-click=\"vm.goToURL(item.itemid)\">\n<div class=\"md-list-item-text\"><h3>{{item.content.Plot.Title_text}}</h3></div></md-list-item></md-list>");
$templateCache.put("app/main/apps/plot/views/showPlot.html","<div id=\"plot\" class=\"page-layout simple left-sidenav\"><div class=\"content\" md-background-bg layout=\"row\" \nlayout-align=\"start start\"><md-content class=\"content\" flex ms-scroll><div class=\"plot_block\"><div \nid=\"{{vm.currentItem.itemid}}\" class=\"plot_holder\" \nng-style=\"{height:vm.currentItem.Plot.Chart_height, width:vm.currentItem.Plot.Chart_width}\"><div class=\"fullWindow\" \nplot-bind=\"vm.currentItem\"></div></div></div></md-content></div></div>");
$templateCache.put("app/main/apps/profile/views/NoUser.html","<div class=\"cadwolfBox\" layout=\"column\"><div class=\"cadwolfBoxToolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">Not logged in</div></div><div class=\"content\" \nlayout=\"column\" layout-margin><div class=\"md-body-1\"><p>\nYou are not currently logged in. To view the profile of another user, enter the username after the word /Profile/ in the URL. To see your profile, log in and return to this page.\n</p></div></div></div>");
$templateCache.put("app/main/apps/profile/views/announcements.html","<div class=\"cadwolfBox\" layout=\"column\"><div class=\"cadwolfBoxToolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">Announcements</div></div><div class=\"content\" \nlayout=\"column\" layout-margin><md-list><md-list-item ng-repeat=\"announcement in vm.announcements\"><div layout=\"row\" \nclass=\"borderBottom\" flex=\"80\" flex-offset=\"10\"><div flex=\"30\" flex-offset=\"5\" \nclass=\"borderRight marginTop15 font-size-14\">{{announcement.created_at_date | date:\'medium\'}}</div><div flex=\"55\" \nflex-offset=\"10\" class=\"font-size-16\" ng-bind-html=\"announcement.parsed_body\"></div></div></md-list-item></md-list><div\n ng-if=\"vm.announcements.length==0\" layout=\"row\" layout-align=\"center center\"><div class=\"md-body-2\">\nYou currently have no announcements.</div></div></div></div>");
$templateCache.put("app/main/apps/profile/views/bio.html","<div class=\"cadwolfBox\" ng-if=\"vm.noProfile\"><div class=\"cadwolfBoxToolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">Unknown User</div></div><div class=\"content\"><div \nlayout=\"row\" layout-fill><div layout=\"column\" layout-fill layout-margin layout-align=\"center center\"><md-subtitle>\nThere was no user found with the name given in the URL</md-subtitle></div></div></div></div><div class=\"cadwolfBox\" \nng-if=\"!vm.noProfile\"><div class=\"cadwolfBoxToolbarWithButton\" ng-if=\"vm.editPerm\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">My Profile</div><div flex=\"10\"><md-menu \nmd-offset=\"0 0\"><md-button aria-label=\"Options\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-apps\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.showLargeModal(\'\', \'User Profile\');\"><span md-menu-align-target><md-icon md-font-icon=\"icon-account-key\">\n</md-icon>Edit Profile</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div \nclass=\"cadwolfBoxToolbar\" ng-if=\"!vm.editPerm\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"cadwolfToolbarTools\">User Profile</div></div><div class=\"content\"><div layout=\"row\" layout-fill><div \nlayout=\"column\" layout-fill layout-margin><div class=\"md-title textCentered\">What do you want to do first?</div><div \nclass=\"md-subhead\">Learn more about CADWOLF</div><div class=\"md-body-1\">\nThere are a number of ways to learn about the functionality of CADWOLF. You can read the <a \nhref=\"https://www.cadwolf.com/Workspace/Documentation/\">documentation</a>. You can also look at the <a \nhref=\"https://www.cadwolf.com/Tutorials\">tutorials page</a>, or watch the videos on our <a \nhref=\"https://www.youtube.com/channel/UCQJZ2Wcg7LwIZvv_q21PhYQ\" target=\"_blank\">youtube channel</a>.</div><div \nclass=\"md-subhead\">Create a document or other item</div><div class=\"md-body-1\">\nTo create a document or other items, go to your <a href=\"https://www.cadwolf.com/Workspace\">workspace</a>\n. Once there, you will be able to add and then edit any number of documents or other items. Take a look at the aforementioned docs and tutorials if you need some help.\n</div><div class=\"md-subhead\">Browse and join open projects</div><div class=\"md-body-1\">\nYou can always create your own project and invite others to work on it. However, if you want to take a look at the projects going on in the main workspaces, you can find those in the \n<a href=\"https://www.cadwolf.com/Workspace/Projects/\">projects workspace</a>\n. You are welcome to take a look at those items, comment in the forums, and get permission to edit certain docs and other items.\n</div><div class=\"md-subhead\">Get involved with the community</div><div class=\"md-body-1\">\nThere are a number of ways to talk with the small but growing community. You can use our <a \nhref=\"https://www.reddit.com/r/CADWOLF/\" target=\"_blank\">subreddit</a>\n for discussions, the boards on engineering.com, or you can jump into the <a href=\"https://www.cadwolf.com/Forum/\">\nCADWOLF forums</a>\n. If you have ideals about projects you would like the community to work on, please use the reddit forum. You can also email us directly at jfoxworth at cadwolf.com or contact us on \n<a href=\"https://www.facebook.com/cadwolfplatform/\" target=\"_blank\">facebook</a> or <a \nhref=\"https://twitter.com/CADWOLFPlatform\" target=\"_blank\">twitter</a>.</div></div></div><div layout=\"row\" layout-fill>\n<div layout=\"column\" layout-fill layout-margin layout-align=\"center center\"><img \nclass=\"profile-image avatar superhuge\" \nng-if=\"vm.thisHost == \'www.cadwolf.com\' || vm.thisHost == \'https://www.cadwolf.com\'\" \nng-src=\"{{vm.profileData.photo_url}}\" on-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"> <img \nclass=\"profile-image avatar superhuge\" ng-if=\"vm.thisHost == \'cadwolf-staging.herokuapp.com\'\" \nng-src=\"{{vm.profileData.photo_url}}\" on-error-src=\"https://cadwolf-staging.s3.amazonaws.com/Profile/default.png\"> \n<input ng-if=\"vm.editPerm\" type=\"hidden\" name=\"MAX_FILE_SIZE\" value=\"30000\"><div ng-if=\"vm.editPerm\" layout=\"row\">\n<md-icon ng-click=\"vm.uploadImage( )\" md-font-icon=\"icon-upload\" class=\"hoverMe\"><md-tooltip md-direction=\"bottom\">\nClick to upload selected image</md-tooltip></md-icon><input name=\"userimage\" id=\"uploadFile{{Spark.state.user.id}}\" \ntype=\"file\"></div></div></div><div layout=\"row\" flex-offset=\"35\" flex=\"30\" class=\"text-center marginTop20\"><div \nlayout=\"column\" flex=\"100\"><div layout-fill flex=\"100\" layout=\"row\" class=\"marginBottom10\"><div flex=\"50\" \nclass=\"md-subhead\" translate=\"PROFILE.NAME\">Name</div><div flex=\"50\">{{vm.profileData.name}}</div></div><div \nlayout-fill ng-if=\"vm.profileData.email.length>0\" class=\"marginBottom10\" flex=\"100\" layout=\"row\"><div flex=\"50\" \nclass=\"md-subhead\" translate=\"PROFILE.EMAIL\">e-mail</div><div flex=\"50\">{{vm.profileData.email}}</div></div><div \nlayout-fill class=\"marginBottom10\" flex=\"100\" layout=\"row\"><div flex=\"50\" class=\"md-subhead\">User Name</div><div \nflex=\"50\">{{vm.profileData.username}}</div></div><div layout-fill class=\"marginBottom10\" flex=\"100\" layout=\"row\" \nng-if=\"vm.profileData.user_info.gender!=\'\'\"><div flex=\"50\" class=\"md-subhead\" translate=\"PROFILE.GENDER\">Gender</div>\n<div flex=\"50\">{{vm.profileData.user_info.gender}}</div></div><div layout-fill class=\"marginBottom10\" flex=\"100\" \nlayout=\"row\" ng-if=\"vm.profileData.user_info.age!=\'\'\"><div flex=\"50\" class=\"md-subhead\" translate=\"PROFILE.AGE\">Age\n</div><div flex=\"50\">{{vm.profileData.user_info.age}}</div></div><div layout-fill class=\"marginBottom10\" flex=\"100\" \nlayout=\"row\" ng-if=\"vm.profileData.user_info.address!=\'\'\"><div flex=\"50\" class=\"md-subhead\" \ntranslate=\"PROFILE.ADDRESS\">Address</div><div flex=\"50\">{{vm.profileData.user_info.address}}</div></div><div \nlayout=\"column\" class=\"marginBottom10\" layout-fill layout-margin ng-if=\"vm.profileData.user_info.telephones.length>0\">\n<div layout=\"row\" layout-fill flex=\"100\"><div class=\"md-subhead\" flex=\"90\" translate=\"PROFILE.TELEPHONES\">Telephones\n</div></div><md-list layout-fill><md-list-item layout-fill ng-repeat=\"tel in vm.profileData.user_info.telephones\"><div \nflex=\"50\">{{tel.itemTitle}}</div><div flex=\"50\" flex-offset=\"5\" ng-bind-html=\"tel.itemText\"></div></md-list-item>\n</md-list></div><div layout=\"column\" class=\"marginBottom10\" layout-fill layout-margin \nng-if=\"vm.profileData.user_info.websites.length>0\"><div layout=\"row\" layout-fill flex=\"100\"><div class=\"md-subhead\" \nflex=\"90\" translate=\"PROFILE.WEBSITES\">Websites</div></div><md-list layout-fill><md-list-item layout-fill \nng-repeat=\"web in vm.profileData.user_info.websites\"><div flex=\"50\">{{web.itemTitle}}</div><div flex=\"50\" \nflex-offset=\"5\" ng-bind-html=\"web.itemText\"></div></md-list-item></md-list></div><div layout=\"column\" \nclass=\"marginBottom10\" layout-fill layout-margin ng-if=\"vm.profileData.user_info.emails.length>0\"><div layout=\"row\" \nlayout-fill flex=\"100\"><div class=\"md-subhead\" flex=\"90\" translate=\"PROFILE.EMAILS\">Emails</div></div><md-list \nlayout-fill><md-list-item layout-fill ng-repeat=\"email in vm.profileData.user_info.emails\"><div flex=\"50\">\n{{email.itemTitle}}</div><div flex=\"50\" flex-offset=\"5\" ng-bind-html=\"email.itemText\"></div></md-list-item></md-list>\n</div><div layout=\"column\" class=\"marginBottom10\" layout-fill layout-margin \nng-if=\"vm.profileData.user_info.locations.length>0\"><div layout=\"row\" layout-fill flex=\"100\"><div class=\"md-subhead\" \nflex=\"90\" translate=\"PROFILE.LOCATIONS\">Locations</div></div><md-list layout-fill><md-list-item layout-fill \nng-repeat=\"loc in vm.profileData.user_info.locations\"><div flex=\"50\">{{loc.itemTitle}}</div><div flex=\"50\" \nflex-offset=\"5\" ng-bind-html=\"loc.itemText\"></div></md-list-item></md-list></div></div></div><div flex-offset=\"15\" \nflex=\"70\" class=\"marginTop20\"><div class=\"marginBottom10 md-subhead borderBottom\" translate=\"PROFILE.ABOUT_ME\" \nng-if=\"vm.profileData.user_info.about!=\'\'\">About Me</div><div ng-if=\"vm.profileData.user_info.about!=\'\'\" \nng-bind-html=\"vm.profileData.user_info.about\"></div><div class=\"marginBottom10 md-subhead borderBottom marginTop30\" \ntranslate=\"PROFILE.OCCUPATION\" ng-if=\"vm.profileData.user_info.occupation!=\'\'\">Occupation</div><div \nng-if=\"vm.profileData.user_info.occupation!=\'\'\" ng-bind-html=\"vm.profileData.user_info.occupation\"></div><div \nclass=\"marginBottom10 md-subhead borderBottom marginTop30\" translate=\"PROFILE.SKILLS\" \nng-if=\"vm.profileData.user_info.skills!=\'\'\">Skills</div><div ng-if=\"vm.profileData.user_info.skills!=\'\'\" \nng-bind-html=\"vm.profileData.user_info.skills\"></div><div class=\"marginBottom10 md-subhead borderBottom marginTop30\" \ntranslate=\"PROFILE.JOBS\" ng-if=\"vm.profileData.user_info.jobs.length>0\">Jobs</div><md-list><md-list-item \nng-repeat=\"job in vm.profileData.user_info.jobs\"><div flex=\"25\">{{job.itemTitle}}</div><div flex=\"70\" flex-offset=\"5\" \nng-bind-html=\"job.itemText\"></div></md-list-item></md-list></div></div></div>");
$templateCache.put("app/main/apps/profile/views/cadSync.html","<div class=\"cadwolfBox\" layout=\"column\"><div class=\"cadwolfBoxToolbarWithButton\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">CAD Sync</div></div><div class=\"content\" \nlayout=\"column\" layout-margin><div class=\"md-body-1 workspaceDescription\">\nCADWOLF documents and part trees can be synced to two CAD platforms. The first platform is <a \nhref=\"http://www.onshape.com\">Onshape</a>\n and the second is Fusion 360. The directions for syncing to these platforms is given in the sections below. The user can sync some documents and part trees to Onshape files and other documents and part trees to Fusion 360 files. However, a part tree is either synced with Fusion 360 or Onshape.\n</div><h2>Onshape</h2><div class=\"md-body-1 workspaceDescription\">\nOnshape is a completely web based CAD platform. Files are accessed through the web browser and stored online. Syncing you account in Onshape to your account here will let you connect to any of your files in Onshape and equations in CADWOLF will be sent through our servers to the proper files in Onshape\'s server without the need for those files to be opened.\n</div><section layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap><md-button \nclass=\"md-raised md-primary\"><a \nhref=\"https://oauth.onshape.com/oauth/authorize?response_type=code&client_id=JWF64IPEH32MCCUOU3SPZHOWFTE5MNA6EPNSW6A%3D\">\nSync your onShape Account with CADWOLF</a></md-button></section><div \nng-if=\"Spark.state.user.user_info.cadSync!==undefined\" layout=\"row\"><div flex=\"50\" flex-offset=\"25\"><md-card \nmd-theme=\"{{ showDarkTheme ? \'dark-grey\' : \'default\' }}\" md-theme-watch><md-card-title><md-card-title-text><span \nclass=\"md-headline\">{{Spark.state.user.user_info.cadSync.cad_user_info.name}}</span> <span class=\"md-subhead\">onShape\n</span></md-card-title-text><md-card-title-media><div class=\"md-media-lg card-media\"><img \nsrc=\"{{Spark.state.user.user_info.cadSync.cad_user_info.image}}\"></div></md-card-title-media></md-card-title></md-card>\n</div></div><h2>AutoCAD Fusion 360</h2><div class=\"md-body-1 workspaceDescription\">\nFusion 360 is an AutoCAD product that stores files in the cloud, but the user works on files with a PC and Mac based platform. CADWOLF users can link their CADWOLF accounts to Fusion 360 accounts and sync files in the same way as Onshape. The caveat is that for a file to be updated in Fusion 360, it must be opened at the time it is opened.\n</div><div><a \nhref=\"https://developer.api.autodesk.com/authentication/v1/authorize?response_type=code&client_id=wARNBggt78ZJ5BDddAYmI7hcdo4Yoy3Z&redirect_uri=https%3A%2F%2Fwww.cadwolf.com/fusionauth&scope=data:read data:create\">\nClick here to grant access to your data!</a></div><div ng-if=\"Spark.state.user.user_info.cadSyncAutocad!==undefined\" \nlayout=\"row\"><div flex=\"50\" flex-offset=\"25\"><md-card md-theme=\"{{ showDarkTheme ? \'dark-grey\' : \'default\' }}\" \nmd-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">\n{{Spark.state.user.user_info.cadSyncAutocad.cad_user_info.firstName}} {{Spark.state.user.user_info.cadSyncAutocad.cad_user_info.lastName}}\n</span> <span class=\"md-subhead\">{{Spark.state.user.user_info.cadSyncAutocad.cad_user_info.userName}}</span> <span \nclass=\"md-subhead\">Autocad - Fusion 360</span></md-card-title-text><md-card-title-media><div \nclass=\"md-media-lg card-media\"><img \nsrc=\"{{Spark.state.user.user_info.cadSyncAutocad.cad_user_info.profileImages.sizeX240}}\"></div></md-card-title-media>\n</md-card-title></md-card></div></div></div></div>");
$templateCache.put("app/main/apps/profile/views/changeUsername.tmpl.html","<md-dialog-content ms-scroll layout-align=\"center center\"><div layout=\"row\" flex=\"100\" layout-fill \nlayout-align=\"center center\"><div flex=\"90\" flex-offset=\"5\"><md-input-container class=\"md-block\"><input \nname=\"memberName\" aria-label=\"Member Name\" type=\"text\" ng-model=\"vm.newName\" required \nng-pattern=\"/[a-zA-Z0-9\\s\\-]{5,30}$/\" ng-click=\"vm.checkStatus=\'\'\" ng-enter=\"vm.checkUsername( vm.newName )\"><div \nng-messages=\"nameForm.newName.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\">\nA name is required</div><div ng-message=\"pattern\">Names can only have letters, numbers, spaces, and dashes</div><div \nng-message=\"minlength\">Names must have at least 5 characters</div><div ng-message=\"minlength\">\nNames can have no more than 30 characters</div></div></md-input-container></div></div><div \nng-if=\"(!vm.checkStatus)&&(vm.newName!=\'\')&&(vm.checkStatus!=\'\')\" layout=\"row\" layout-fill flex=\"100\"><div flex=\"90\" \nflex-offset=\"5\" class=\"md-body-1\">That name is either invalid or is already taken</div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-if=\"vm.checkStatus\" \nng-click=\"vm.changeUsername( vm.newName ); vm.cancel();\" class=\"send-button md-accent md-raised\">CHANGE USERNAME\n</md-button><md-button type=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">CANCEL</md-button>\n</div></md-dialog-actions>");
$templateCache.put("app/main/apps/profile/views/invitations.html","<div class=\"cadwolfBox\" layout=\"column\"><div class=\"cadwolfBoxToolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">Team Invitations</div></div><div class=\"content\" \nlayout=\"column\" layout-margin><md-list><md-list-item ng-repeat=\"invitation in vm.invitations\"><div layout=\"row\" \nflex=\"50\" flex-offset=\"25\" class=\"paddingBottom10 borderBottom\"><div flex=\"5\" flex-offset=\"5\"><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"iconDarkGreyBackground marginTop10\"></md-icon></div><div flex=\"65\" \nflex-offset=\"5\" class=\"font-size-16 marginTop10\">{{invitation.team.name}}</div><div flex=\"20\" layout=\"row\"><div \nclass=\"selectOptionWrapperGreen\" ng-click=\"vm.acceptInvitation(invitation)\"><md-icon md-font-icon=\"icon-check-circle\" \nclass=\"iconGreenBackground\"></md-icon><md-tooltip md-direction=\"bottom\">Accept Invitation</md-tooltip></div><div \nclass=\"selectOptionWrapperRed\" ng-click=\"vm.rejectInvitation(invitation)\"><md-icon md-font-icon=\"icon-close-circle\" \nclass=\"iconRedBackground\"></md-icon><md-tooltip md-direction=\"bottom\">Decline Invitation</md-tooltip></div></div></div>\n</md-list-item></md-list><div ng-if=\"vm.invitations.length==0\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"md-body-2\">You have no invitations currently pending.</div></div></div></div>");
$templateCache.put("app/main/apps/profile/views/list-view.html","<md-list-item class=\"borderBottom\" layout-fill><div class=\"md-body-2 textCentered\" flex=\"40\">File Name</div><div \nclass=\"md-body-2 textCentered\" flex=\"15\">Status</div><div class=\"md-body-2 textCentered\" flex=\"20\">Created</div><div \nclass=\"md-body-2 textCentered\" flex=\"20\">Modified</div><div class=\"md-body-2 textCentered\" flex=\"5\">Version</div>\n</md-list-item><md-list-item ng-repeat=\"file in vm.cadwolf_files | filter:global.search\" \nng-class=\"{\'selected\' : vm.selected === file}\" layout-margin layout-fill><div flex=\"100\" layout-fill layout=\"row\"><div \nflex=\"5\" class=\"textCentered\" ng-click=\"vm.select( file )\" ng-dblclick=\"vm.select( file ); vm.navigateURL( file )\">\n<md-icon ng-if=\"file.file_type_id==\'Workspace\'\" md-font-icon=\"icon-folder-outline\"></md-icon><md-icon \nng-if=\"file.file_type_id==\'Document\'\" md-font-icon=\"icon-file-outline\"></md-icon><md-icon \nng-if=\"file.file_type_id==\'Dataset\'\" md-font-icon=\"icon-cog\"></md-icon><md-icon ng-if=\"file.file_type_id==\'Part Tree\'\" \nmd-font-icon=\"icon-sitemap\"></md-icon><md-icon ng-if=\"file.file_type_id==\'Image\'\" md-font-icon=\"icon-camera\"></md-icon>\n<md-tooltip md-direction=\"bottom\">{{file.item_data.description}}</md-tooltip></div><div flex=\"35\" \nclass=\"topMarginThree\" ng-click=\"vm.select( file )\" ng-dblclick=\"vm.select( file ); vm.navigateURL( file )\">\n{{file.name}}</div><div ng-if=\"file.file_type_id==\'Document\'\" flex=\"15\" class=\"textCentered\"><md-icon \nng-click=\"vm.select( file )\" ng-dblclick=\"vm.select( file ); vm.checkOutFile( file )\" \nng-if=\"file.item_data.checkout_id==0\" md-font-icon=\"icon-lock-unlocked-outline\"><md-tooltip md-direction=\"bottom\">\nClick to check out</md-tooltip></md-icon><md-icon ng-click=\"vm.select( file )\" \nng-dblclick=\"vm.select( file ); vm.checkInFile( file )\" ng-if=\"file.item_data.checkout_id==Spark.state.user.id\" \nmd-font-icon=\"icon-lock-outline\"><md-tooltip md-direction=\"bottom\">Click to check in</md-tooltip></md-icon><md-icon \nng-click=\"vm.select( file )\" \nng-if=\"file.item_data.checkout_status!=0 && file.item_data.checkout_status!=Spark.state.user.id\" \nmd-font-icon=\"icon-lock-outline\"><md-tooltip md-direction=\"bottom\">Checked Out by {{file.item_data.checkout_name}}\n</md-tooltip></md-icon></div><div ng-if=\"file.file_type_id!=\'Document\'\" ng-click=\"vm.select( file )\" flex=\"15\"></div>\n<div flex=\"20\" class=\"textCentered\" ng-click=\"vm.select( file )\">{{file.created_at}}</div><div flex=\"20\" \nclass=\"textCentered\" ng-click=\"vm.select( file )\">{{file.updated_at}}</div><div flex=\"5\" class=\"textCentered\" \nng-if=\"((file.file_type_id==\'Document\')||\n                        (file.file_type_id==\'Dataset\')||\n                        (file.file_type_id==\'Part Tree\'))\" \nng-click=\"vm.select( file )\">{{file.version}}</div><div flex=\"5\" class=\"textCentered\" \nng-if=\"((file.file_type_id==\'Workspace\')||\n                        (file.file_type_id==\'Image\'))\" \nng-click=\"vm.select( file )\"></div></div></md-list-item>");
$templateCache.put("app/main/apps/profile/views/members.html","<div class=\"cadwolfBox\" layout=\"column\"><div class=\"cadwolfBoxToolbarWithButton\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">{{vm.thisTeam.name}} Members</div><div flex=\"10\">\n<md-menu md-offset=\"0 0\"><md-button aria-label=\"Options\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon\n md-font-icon=\"icon-apps\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"\"><span \nmd-menu-align-target><md-icon md-font-icon=\"icon-account-plus\"></md-icon>Add Member</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div class=\"content\" layout=\"column\" layout-margin><md-list><md-list-item \nng-repeat=\"member in vm.thisTeam.memberList\"><div layout=\"row\" flex=\"100\" layout-fill ng-click=\"vm.select(member);\" \nng-dblclick=\"vm.showSmallModal(\'\', \'Member Profile\', member)\"><div flex=\"10\"><img class=\"avatar small\" \nsrc=\"{{member.photo_url}}\"></div><div flex=\"40\" flex-offset=\"10\">{{member.name}}</div><div flex=\"40\" flex-offset=\"10\">\n{{member.email}}</div></div></md-list-item></md-list><div class=\"md-caption marginTop20\">Your plan allows for 15 teams\n</div></div></div>");
$templateCache.put("app/main/apps/profile/views/messages.html","<div class=\"cadwolfBox\"><div class=\"cadwolfBoxToolbarWithButton\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"cadwolfToolbarTools\" ng-if=\"vm.viewType == \'inbox\'\">Inbox Messages</div><div class=\"cadwolfToolbarTools\" \nng-if=\"vm.viewType == \'drafts\'\">Draft Messages</div><div class=\"cadwolfToolbarTools\" ng-if=\"vm.viewType == \'sent\'\">\nSent Messages</div><div flex=\"15\" layout=\"row\" layout-align=\"space-around center\"><div \nng-click=\"vm.viewType = \'inbox\'; vm.thisMessage=\'\';\"><md-icon md-font-icon=\"icon-inbox\"></md-icon><md-tooltip \nmd-direction=\"bottom\">View Inbox</md-tooltip></div><div ng-click=\"vm.viewType = \'drafts\'; vm.thisMessage=\'\';\"><md-icon \nmd-font-icon=\"icon-label-outline\"></md-icon><md-tooltip md-direction=\"bottom\">View Drafts</md-tooltip></div><div \nng-click=\"vm.viewType = \'sent\'; vm.thisMessage=\'\';\"><md-icon md-font-icon=\"icon-reply\"></md-icon><md-tooltip \nmd-direction=\"bottom\">View Sent Messages</md-tooltip></div><div ng-click=\"vm.newMessage( ); vm.thisMessage=\'\';\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\">Create New Message</md-tooltip></div>\n</div></div><div class=\"\" layout=\"row\" ng-if=\"vm.viewType == \'inbox\'\" \nng-include=\"\'app/main/apps/profile/views/mailLists/receiveList.html\'\"></div><div class=\"\" layout=\"row\" \nng-if=\"vm.viewType == \'drafts\'\" ng-include=\"\'app/main/apps/profile/views/mailLists/draftList.html\'\"></div><div \nclass=\"\" layout=\"row\" ng-if=\"vm.viewType == \'sent\'\" ng-include=\"\'app/main/apps/profile/views/mailLists/sentList.html\'\">\n</div></div>");
$templateCache.put("app/main/apps/profile/views/myWorkspace.html","<div class=\"cadwolfBox\"><div class=\"cadwolfBoxToolbarWithButton\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"cadwolfToolbarTools\">My Files</div><div flex=\"10\"><md-menu md-offset=\"0 0\"><md-button aria-label=\"Options\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-apps\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"vm.navigateURL( vm.cadwolf_fileInfo );\"><span \nmd-menu-align-target><md-icon md-font-icon=\"icon-folder-move\"></md-icon>Workspace View</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.showSmallModal(\'\', \'Change Username\', Spark.state.user );\"><span \nmd-menu-align-target><md-icon md-font-icon=\"icon-account-circle\"></md-icon>Change Username</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div class=\"content\" layout=\"column\" layout-margin><div \nclass=\"md-body-1 workspaceDescription\" ng-if=\"vm.cadwolf_files.length==0\"><p>\nThere are currently no files in your workspace. This is likely because you are new to CADWOLF. To create a file, folder, dataset, or part tree, or to upload an image, simply navigate to your \n<a href=\"\" ng-click=\"vm.navigateURL( vm.cadwolf_fileInfo, \'homeSpace\' );\">home workspace</a>\n and click on the appropriate button in the left navigation pane.</p></div><div class=\"md-body-1 workspaceDescription\">\n<p>\nEach user has a workspace that is accessible through the URL http://www.cadwolf.com/Workspace/\'user name\'. This view shows the contents of that workspace and the user can add content via the prior URL and the link in the upper right. Changing the user name changes the URL for your workspace and all files. This can also be done via a link in the upper right.\n</p></div><md-list layout-fill><md-list-item class=\"borderBottom\" layout-fill><div flex=\"100\" layout=\"row\"><div \nclass=\"md-body-2 textCentered\" flex=\"45\">File Name</div><div class=\"md-body-2 textCentered\" flex=\"10\">Info</div><div \nclass=\"md-body-2 textCentered\" flex=\"20\">Created</div><div class=\"md-body-2 textCentered\" flex=\"20\">Modified</div><div \nclass=\"md-body-2 textCentered\" flex=\"5\">Version</div></div></md-list-item><md-list-item \nng-repeat=\"file in vm.cadwolf_files | filter:global.search\" ng-class=\"{\'selected\' : vm.selected === file}\" \nlayout-margin layout-fill class=\"cadwolf-list-item borderBottom paddingTopBottom10\"><div flex=\"100\" layout-fill \nlayout=\"row\"><div flex=\"5\" class=\"textCentered\" ng-click=\"vm.select( file )\" \nng-dblclick=\"vm.select( file ); vm.navigateURL( file, file.file_type_id )\"><md-icon \nng-if=\"file.file_type_id==\'Workspace\'\" md-font-icon=\"icon-folder-outline\"></md-icon><md-icon \nng-if=\"file.file_type_id==\'Document\'\" md-font-icon=\"icon-file-outline\"></md-icon><md-icon \nng-if=\"file.file_type_id==\'Dataset\'\" md-font-icon=\"icon-cog\"></md-icon><md-icon ng-if=\"file.file_type_id==\'Part Tree\'\" \nmd-font-icon=\"icon-sitemap\"></md-icon><md-icon ng-if=\"file.file_type_id==\'Image\'\" md-font-icon=\"icon-camera\"></md-icon>\n</div><div flex=\"40\" class=\"paddingTop3 md-body-1\" ng-click=\"vm.select( file )\" \nng-dblclick=\"vm.select( file ); vm.navigateURL( file, file.file_type_id )\">{{file.name}}</div><div \nng-if=\"((file.file_type_id==\'Document\') ||\n                                (file.file_type_id==\'Workspace\') ||\n                                (file.file_type_id==\'Dataset\') ||\n                                (file.file_type_id==\'Part Tree\')) \" \nflex=\"10\" class=\"textCentered\"><md-icon ng-click=\"vm.select( file ); vm.showSmallModal( \'\', file, \'Information\', 0 )\" \nmd-font-icon=\"icon-information-outline\"><md-tooltip md-direction=\"bottom\">Click to view information</md-tooltip>\n</md-icon></div><div ng-if=\"(file.file_type_id==\'Image\')\" flex=\"10\" class=\"textCentered\"></div><div flex=\"20\" \nclass=\"textCentered paddingTop3 md-body-1\" ng-click=\"vm.select( file )\">{{file.created_at}}</div><div flex=\"20\" \nclass=\"textCentered paddingTop3 md-body-1\" ng-click=\"vm.select( file )\">{{file.updated_at}}</div><div flex=\"5\" \nclass=\"textCentered paddingTop3 md-body-1\" \nng-if=\"((file.file_type_id==\'Document\')||\n                                (file.file_type_id==\'Dataset\')||\n                                (file.file_type_id==\'Part Tree\'))\" \nng-click=\"vm.select( file )\">{{file.version}}</div><div flex=\"5\" class=\"textCentered\" \nng-if=\"((file.file_type_id==\'Workspace\')||\n                                (file.file_type_id==\'Image\'))\" \nng-click=\"vm.select( file )\"></div></div></md-list-item></md-list></div></div>");
$templateCache.put("app/main/apps/profile/views/notifications.html","<div class=\"cadwolfBox\" layout=\"column\"><div class=\"cadwolfBoxToolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">Notifications</div></div><div class=\"content\" \nlayout=\"column\" layout-margin><md-list><md-list-item ng-repeat=\"notification in vm.notifications\"><div layout=\"row\" \nclass=\"borderBottom\" flex=\"80\" flex-offset=\"10\"><div flex=\"30\" flex-offset=\"5\" \nclass=\"borderRight marginTop15 font-size-14\">{{notification.created_at_date | date:\'medium\'}}</div><div flex=\"55\" \nflex-offset=\"10\" class=\"font-size-16\" ng-bind-html=\"notification.parsed_body\"></div></div></md-list-item></md-list><div\n ng-if=\"vm.notifications.length==0\" layout=\"row\" layout-align=\"center center\"><div class=\"md-body-2\">\nYou currently have no notifications.</div></div></div></div>");
$templateCache.put("app/main/apps/profile/views/teams.html","<div class=\"cadwolfBox\" layout=\"column\"><div class=\"cadwolfBoxToolbarWithButton\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">My Teams</div><div flex=\"10\"><md-menu \nmd-offset=\"0 0\"><md-button aria-label=\"Options\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-apps\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.navigateURL(\'team\',\'team\');\"><span md-menu-align-target><md-icon \nmd-font-icon=\"icon-account-multiple-plus\"></md-icon>Team Page</span></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div><div class=\"content\" layout=\"column\" layout-margin><md-list><md-list-item \nng-repeat=\"team in Spark.state.user.teams\" class=\"\" flex=\"60\" flex-offset=\"20\" \nng-if=\"team.name!=Spark.state.user.username\"><div layout=\"row\" flex=\"100\" \nclass=\"borderBottom paddingBottom5 paddingTop5\"><div flex=\"10\" \nng-if=\"vm.thisHost == \'www.cadwolf.com\' || vm.thisHost == \'https://www.cadwolf.com\'\"><img class=\"avatar\" \nng-src=\"{{team.photo_url}}\" on-error-src=\"http://cadwolf.s3.amazonaws.com/team/default.png\"></div><div flex=\"10\" \nng-if=\"vm.thisHost == \'cadwolf-staging.herokuapp.com\'\"><img class=\"avatar\" ng-src=\"{{team.photo_url}}\" \non-error-src=\"http://cadwolf-staging.s3.amazonaws.com/team/default.png\"></div><div flex=\"40\" \nclass=\"font-size-16 marginTop10\">{{team.name}}</div><div flex=\"20\" flex-offset=\"5\" class=\"font-size-16 marginTop10\" \nng-if=\"team.current_billing_plan!=null\">Pay Plan</div><div flex=\"20\" flex-offset=\"5\" class=\"font-size-16 marginTop10\" \nng-if=\"team.current_billing_plan==null\">Free Plan</div><div flex=\"25\" layout=\"row\" layout-align=\"end end\"><div \nclass=\"selectOptionWrapperGreen\" ng-click=\"vm.navigateURL( team, \'settings\' )\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"iconGreenBackground\"></md-icon><md-tooltip md-direction=\"bottom\">Team Pay Settings</md-tooltip></div><div \nclass=\"selectOptionWrapperBlue\" ng-click=\"vm.navigateURL( team, \'team\' )\"><md-icon md-font-icon=\"icon-account-key\" \nclass=\"iconBlueBackground\"></md-icon><md-tooltip md-direction=\"bottom\">Teams Details</md-tooltip></div></div></div>\n</md-list-item></md-list><div class=\"md-body-1 workspaceDescription\" ng-if=\"Spark.state.user.teams.length==0\">\nThere are no teams currently owned by this account.</div></div></div>");
$templateCache.put("app/main/apps/profile/views/widgets.html","<div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Workspaces</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">\n{{vm.profileData.workspacesOwned.length}}</div><div class=\"h3 secondary-text font-weight-500\">MY WORKSPACES</div></div>\n<div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">Your plan allows for 5</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\nRoot workspaces reside at the top level of the URL just after the phrase \'Workspace\'. The number of root workspaces a user can create depends upon the account type.\n</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Teams</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"orange-fg font-size-72 line-height-72\">{{vm.profileData.owned_teams.length-1}}\n</div><div class=\"h3 secondary-text font-weight-500\">TEAMS I OWN</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">\nYour plan allows for {{vm.profileData.owned_teams.length}} teams</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\nTeams are groups of users that can be given permissions to view or edit an item. They are also used for billing purposes. The number of teams you can create depends on you account type.\n</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Teams</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">{{vm.profileData.teams.length}}\n</div><div class=\"h3 secondary-text font-weight-500\">Teams I am part of</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">Plans do not limit team members</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\nTeams are groups of users that can be given permissions to view or edit an item. You can be added to any given number of teams.\n</div></ms-widget-back></ms-widget></div>");
$templateCache.put("app/main/apps/profile/views/workspaces.html","<div class=\"cadwolfBox\" layout=\"column\"><div class=\"cadwolfBoxToolbarWithButton\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">My Workspaces</div><div flex=\"10\"><md-menu \nmd-offset=\"0 0\"><md-button aria-label=\"Options\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-apps\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"\"><span \nmd-menu-align-target><md-icon md-font-icon=\"icon-folder-plus\"></md-icon>Add Workspace Coming Soon</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div class=\"content\" layout=\"column\" layout-margin><div \nclass=\"md-body-1 workspaceDescription\"><p>\nWorkspaces are like folders at the root level. This is the first name that will appear in the URL after \\Workspaces, \\Documents, and \\Datasets. Subfolders can be created in the workspace view which is accessible by clicking on the workspace below. Every account gets one free workspace. Business accounts have additional workspaces.\n</p></div><md-list><md-divider></md-divider><md-list-item ng-repeat=\"workspace in Spark.state.user.workspacesOwned\" \nclass=\"greyHoverBack\" layout=\"row\" flex=\"100\" layout-fill layout-align=\"start start\" \nng-click=\"vm.navigateURL( workspace );\"><div flex=\"10\"><md-icon md-font-icon=\"icon-folder-outline\"></md-icon></div><div\n flex=\"85\" flex-offset=\"5\">{{workspace.name}}</div><md-divider></md-divider></md-list-item></md-list><div \nclass=\"md-body-1\" ng-if=\"Spark.state.user.workspacesOwned.length==0\">\nThere are no root workspaces currently owned by this account.</div><div class=\"md-caption marginTop20\">\nYour plan allows for 1 workspace at the root level</div></div></div>");
$templateCache.put("app/main/apps/surface/views/emptyList.html","<div class=\"md-headline marginTop20\">Favorite Surfaces</div><md-list \nng-if=\"vm.currentUserInfo.user_info.favSurfaces.length>0\" class=\"marginTop20\"><md-list-item layout=\"row\" \nclass=\"borderBottom\"><div flex=\"15\">&nbsp</div><div flex=\"30\" translate=\"FM.NAME\" class=\"md-title\">Name</div><div \nflex=\"55\" hide-xs translate=\"FM.LOCATION\" class=\"md-title\">Location</div></md-list-item><md-list-item \nng-repeat=\"surface in vm.currentUserInfo.user_info.favSurfaces\" class=\"borderBottom\"><div flex=\"10\"><md-icon \nmd-font-icon=\"icon-cube-outline\" ng-click=\"$location.path(\'/Surface/\'+surface.location)\" class=\"hoverMe\"></md-icon>\n</div><div flex=\"30\">{{surface.name}}</div><div flex=\"55\">{{surface.location}}</div><div flex=\"5\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\" ng-click=\"vm.removeFavItem( surface )\" class=\"hoverMe\"></md-icon></div>\n</md-list-item></md-list><div class=\"md-body-1 marginTop20\" ng-if=\"vm.currentUserInfo.user_info.favSurfaces.length==0\">\nUsers can \"favorite\" Surfaces so that they can be easily accessed. Those Surfaces can be shown here. To favorite a surface, clikc the heart icon in the upper right of the surface view.\n</div><div class=\"md-headline marginTop20\">Recent Surfaces</div><md-list \nng-if=\"vm.currentUserInfo.user_info.surfaces.length>0\" class=\"marginTop20\"><md-list-item layout=\"row\" \nclass=\"borderBottom\"><div flex=\"15\">&nbsp</div><div flex=\"30\" translate=\"FM.NAME\" class=\"md-title\">Name</div><div \nflex=\"55\" hide-xs translate=\"FM.LOCATION\" class=\"md-title\">Location</div></md-list-item><md-list-item \nng-repeat=\"surface in vm.currentUserInfo.user_info.surfaces\" class=\"borderBottom\" layout=\"row\"><div flex=\"10\"><md-icon \nmd-font-icon=\"icon-cube-outline\" ng-click=\"vm.goToURL(\'/Surface/\'+surface.location)\" class=\"hoverMe\"></md-icon></div>\n<div flex=\"30\">{{surface.name}}</div><div flex=\"60\">{{surface.location}}</div></md-list-item></md-list><div \nclass=\"md-body-1 marginTop20\" ng-if=\"vm.currentUserInfo.user_info.surfaces.length==0\">\nThe list below will show the 10 most recently visited Surfaces.</div>");
$templateCache.put("app/main/apps/surface/views/showSurface.html","<div id=\"plot\" class=\"page-layout simple\"><div class=\"content\" md-background-bg layout=\"row\" \nlayout-align=\"start start\"><md-content class=\"content\" flex ms-scroll><div class=\"surface_block\"><div \nclass=\"plot_holder\" ng-style=\"{height:vm.currentItem.Surface.Chart_height, width:vm.currentItem.Surface.Chart_width}\">\n<div id=\"{{vm.currentItem.itemid}}\" style=\"float:left; overflow:auto;}\"></div><div class=\"Legend_Wrapper\" \nng-show=\"vm.currentItem.Surface.Props.Legend.onOff==\'1\'\"><div class=\"Legend\" \nng-if=\"vm.currentItem.Surface.Props.Legend.onOff==\'1\'&&vm.currentItem.Surface.Props.divideColormap==\'0\'\" \nid=\"{{vm.currentItem.itemid}}Legend\"></div><div \nng-show=\"vm.currentItem.Surface.Props.Legend.onOff==\'1\'&&vm.currentItem.Surface.Props.divideColormap==\'0\'\" \nid=\"{{subvm.currentItem.Surface.Format_id}}LegendTicks\" class=\"LegendTicks\"><div \nng-repeat=\"thisTick in vm.currentItem.Legend.tickNumbers track by $index\"><div ng-if=\"( !$first ) && ( !$last )\" \nclass=\"legendTick\" style=\"width:{{vm.currentItem.Legend.tickWidth}}px\">{{thisTick}}</div><div ng-if=\"$first\" \nclass=\"legendTickFirst\" style=\"width:{{vm.currentItem.Legend.tickWidth}}px\">{{thisTick}}</div><div ng-if=\"$last\" \nclass=\"legendTickLast\" style=\"width:{{vm.currentItem.Legend.tickWidth}}px\">{{thisTick}}</div></div></div><div \nng-repeat=\"subObj in vm.currentItem.Surface.Chart_dataobj track by subvm.currentItem.Format_id\"><div \nng-if=\"subvm.currentItem.legendOnOff==\'1\'&&vm.currentItem.Surface.Props.divideColormap==\'1\'\" \nid=\"{{subvm.currentItem.Surface.Format_id}}Legend\"></div><div class=\"LegendTicks\" \nng-show=\"subvm.currentItem.legendOnOff==\'1\'&&vm.currentItem.Surface.Props.divideColormap==\'1\'\" \nid=\"{{subvm.currentItem.Surface.Format_id}}LegendTicks\"><div class=\"Legend_Tick\" \nng-repeat=\"thisTick in vm.currentItem.Legend.tickNumbers track by $index\" \nstyle=\"width:{{vm.currentItem.Legend.tickWidth}}px\">{{thisTick}}</div></div></div></div><surface-bind \nthissurface=\"vm.currentItem.Surface\"></surface-bind></div></div></md-content></div></div>");
$templateCache.put("app/main/apps/teams/views/addMember.tmpl.html","<md-dialog-content ms-scroll layout-align=\"center center\"><div layout=\"row\" flex=\"100\" layout-fill \nlayout-align=\"center center\"><div flex=\"90\" flex-offset=\"5\"><md-input-container class=\"md-block\"><label>\nMember Name, User Name, or email</label><input name=\"memberName\" aria-label=\"Member Name\" type=\"text\" \nng-model=\"vm.newMember.temp\" ng-click=\"vm.checkStatus=\'\'\" ng-enter=\"vm.checkMemberName( vm.newMember.temp )\">\n</md-input-container></div></div><div ng-if=\"(!vm.checkStatus)&&(vm.newMember.temp!=\'\')&&(vm.checkStatus!=\'\')\" \nlayout=\"row\" layout-fill flex=\"100\"><div flex=\"90\" flex-offset=\"5\" class=\"md-body-1\">\nNo user with that information was found</div></div><div ng-if=\"vm.checkStatus\" layout=\"row\" layout-fill flex=\"100\"><div\n flex=\"90\" flex-offset=\"5\" class=\"md-title\">User Identified</div></div><div ng-if=\"vm.checkStatus\" layout=\"row\" \nlayout-fill flex=\"100\"><div flex=\"30\" flex-offset=\"5\" class=\"md-body-2\">Name</div><div flex=\"60\" class=\"md-body-1\">\n{{vm.inviteMember.name}}</div></div><div ng-if=\"vm.checkStatus\" layout=\"row\" layout-fill flex=\"100\"><div flex=\"30\" \nflex-offset=\"5\" class=\"md-body-2\">username</div><div flex=\"60\" class=\"md-body-1\">{{vm.inviteMember.username}}</div>\n</div><div ng-if=\"vm.checkStatus\" layout=\"row\" layout-fill flex=\"100\"><div flex=\"30\" flex-offset=\"5\" class=\"md-body-2\">\nemail</div><div flex=\"60\" class=\"md-body-1\">{{vm.inviteMember.email}}</div></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-primary\" \nng-click=\"vm.inviteUser( vm.inviteMember, vm.teamData );\" ng-if=\"vm.checkStatus\">INVITE USER TO TEAM</md-button></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">\nFINISHED TEAM INVITES</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/teams/views/addTeam.tmpl.html","<md-dialog-content ms-scroll layout-align=\"center center\"><div layout=\"row\" flex=\"100\" layout-fill \nlayout-align=\"center center\"><div flex=\"90\" flex-offset=\"5\"><md-input-container class=\"md-block\"><input \nname=\"teamName\" aria-label=\"Team Name\" type=\"text\" ng-model=\"vm.teamName\" ng-click=\"vm.checkStatus=\'\'\" \nng-enter=\"vm.checkTeamName( vm.teamName )\"></md-input-container></div></div><div \nng-if=\"(!vm.checkStatus)&&(vm.teamName!=\'\')&&(vm.checkStatus!=\'\')\" layout=\"row\" layout-fill flex=\"100\"><div flex=\"90\" \nflex-offset=\"5\" class=\"md-body-1\">That team name was not valid or is already in use</div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-if=\"vm.checkStatus\" \nng-click=\"vm.addTeam( vm.teamName ); vm.cancel();\" class=\"send-button md-accent md-raised\">ADD TEAM</md-button>\n<md-button type=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">FINISHED</md-button></div>\n</md-dialog-actions>");
$templateCache.put("app/main/apps/teams/views/memberList.html","<div class=\"cadwolfBox\" layout=\"column\" ng-if=\"vm.teamData.name!=Spark.state.user.username\"><div \nclass=\"cadwolfBoxToolbarWithButton\" ng-if=\"vm.getTeamPosition(vm.teamData)==\'owner\'\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">{{vm.teamData.name}} - User Team</div></div><div \nlayout-align=\"space-between center\">This team represents the user and cannot be altered</div></div><div \nclass=\"cadwolfBox\" layout=\"column\" ng-if=\"vm.teamData.name!=Spark.state.user.username\"><div \nclass=\"cadwolfBoxToolbarWithButton\" ng-if=\"vm.getTeamPosition(vm.teamData)==\'owner\'\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">{{vm.teamData.name}} - Team Image</div><div \nflex=\"10\"><md-menu md-offset=\"0 0\"><md-button aria-label=\"Options\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-apps\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"vm.showSmallModal(\'\', \'Add Member\', vm.teamData)\"><span md-menu-align-target>\n<md-icon md-font-icon=\"icon-account-plus\"></md-icon></span>Invite New Member</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.showSmallModal(\'\', \'Rename Team\', vm.teamData)\"><span md-menu-align-target><md-icon \nmd-font-icon=\"icon-account-location\"></md-icon></span>Rename Team</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.navigateURL(\'team\', \'team\')\"><span md-menu-align-target><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</span>Team List</md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=\"cadwolfBoxToolbar\" \nng-if=\"vm.getTeamPosition(vm.teamData)!=\'owner\'\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"cadwolfToolbarTools\">{{vm.teamData.name}} - Team Image</div><div flex=\"10\"><md-menu md-offset=\"0 0\"><md-button \naria-label=\"Options\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-apps\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"vm.navigateURL(\'team\', \'team\')\"><span \nmd-menu-align-target><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></span>Team List</md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div class=\"content\" layout=\"column\" layout-margin><div layout=\"row\" \nlayout-fill><div layout=\"column\" layout-fill layout-margin layout-align=\"center center\"><img \nclass=\"profile-image avatar huge\" ng-if=\"vm.thisHost == \'www.cadwolf.com\' || vm.thisHost == \'https://www.cadwolf.com\'\" \nng-src=\"{{vm.teamData.photo_url}}\" on-error-src=\"https://cadwolf.s3.amazonaws.com/team/default.png\"> <img \nclass=\"profile-image avatar huge\" ng-if=\"vm.thisHost == \'cadwolf-staging.herokuapp.com\'\" \nng-src=\"{{vm.teamData.photo_url}}\" on-error-src=\"https://cadwolf-staging.s3.amazonaws.com/team/default.png\"> <input \ntype=\"hidden\" name=\"MAX_FILE_SIZE\" value=\"8000000\"> <input type=\"hidden\" name=\"teamid\" value=\"{{vm.teamData.id}}\"><div \nlayout=\"row\" ng-if=\"vm.getTeamPosition(vm.teamData)==\'owner\'\"><md-icon ng-click=\"vm.uploadTeamImage( )\" \nmd-font-icon=\"icon-upload\" class=\"hoverMe\"><md-tooltip md-direction=\"bottom\">Click to upload selected image\n</md-tooltip></md-icon><input name=\"teamimage\" id=\"uploadFile{{vm.teamData.id}}\" type=\"file\"></div></div></div></div>\n</div><div class=\"cadwolfBox\" layout=\"column\"><div class=\"cadwolfBoxToolbar\" \nng-if=\"vm.getTeamPosition(vm.teamData)==\'owner\'\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"cadwolfToolbarTools\">{{vm.teamData.name}} - Members</div></div><div class=\"content\" layout=\"column\" \nlayout-margin><md-list flex=\"80\" flex-offset=\"10\"><md-list-item class=\"main-list md-white-bg borderBottom\" \nmd-ink-ripple layout-fill flex=\"100\" ng-repeat=\"member in vm.teamData.users track by member.id \"><div flex=\"10\" \nng-if=\"vm.thisHost == \'www.cadwolf.com\' || vm.thisHost == \'https://www.cadwolf.com\'\"><img class=\"avatar\" \nng-src=\"{{member.photo_url}}\" on-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"></div><div flex=\"10\" \nng-if=\"vm.thisHost == \'cadwolf-staging.herokuapp.com\'\"><img class=\"avatar\" ng-src=\"{{member.photo_url}}\" \non-error-src=\"https://cadwolf-staging.s3.amazonaws.com/Profile/default.png\"></div><div flex=\"30\"><p \nclass=\"text-truncate font-weight-600\">{{member.name}}</p></div><div flex=\"30\"><p \nclass=\"email text-truncate hide show-gt-sm\">{{member.email}}</p></div><div flex=\"15\"><p \nclass=\"phone text-truncate hide show-gt-md\">{{member.pivot.role}}</p></div><div flex=\"20\" layout=\"row\" \nng-if=\"vm.getTeamPosition(vm.teamData)==\'owner\'\"><div class=\"selectOptionWrapperGreen\" \nng-if=\"(member.pivot.role!=\'owner\')&&(member.pivot.role!=\'owner\')\" ng-click=\"vm.makeAdmin(member, vm.teamData)\">\n<md-icon md-font-icon=\"icon-account-network\" class=\"iconGreenBackground\"></md-icon><md-tooltip md-direction=\"bottom\">\nGrant Admin Permissions</md-tooltip></div><div class=\"selectOptionWrapperYellow\" \nng-if=\"(vm.getTeamPosition(vm.teamData)==\'owner\')&&(member.pivot.role==\'owner\')\" \nng-click=\"vm.removeAdmin(member, vm.teamData)\"><md-icon md-font-icon=\"icon-account-minus\" class=\"iconYellowBackground\">\n</md-icon><md-tooltip md-direction=\"bottom\">Remove Admin Permissions</md-tooltip></div><div \nclass=\"selectOptionWrapperRed\" ng-if=\"member.pivot.role!=\'owner\'\" ng-click=\"vm.deleteTeamMember(member, vm.teamData)\">\n<md-icon md-font-icon=\"icon-account-remove\" class=\"iconRedBackground\"></md-icon><md-tooltip md-direction=\"bottom\">\nRemove User</md-tooltip></div></div></md-list-item></md-list></div></div><div class=\"cadwolfBox\" layout=\"column\"><div \nclass=\"cadwolfBoxToolbar\" ng-if=\"vm.getTeamPosition(vm.teamData)==\'owner\'\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">{{vm.teamData.name}} - Pending Invitations</div>\n</div><div class=\"content\" layout=\"column\" layout-margin><div class=\"content\" ng-if=\"vm.teamInvites.length==0\" \nlayout=\"column\" layout-margin><div class=\"subtitle\">There are no pending invitations for this team.</div></div><md-list\n flex=\"80\" flex-offset=\"10\" ng-if=\"vm.teamInvites.length>0\"><md-list-item class=\"main-list md-white-bg borderBottom\" \nmd-ink-ripple layout-fill flex=\"100\"><div flex=\"40\" flex-offset=\"5\" class=\"font-weight-600\">Invite email</div><div \nflex=\"40\" class=\"font-weight-600\">Date Invited</div><div flex=\"15\" class=\"font-weight-600\">Role</div></md-list-item>\n<md-list-item class=\"main-list md-white-bg borderBottom\" md-ink-ripple layout-fill flex=\"100\" \nng-repeat=\"invite in vm.teamInvites track by invite.id \"><div flex=\"40\" flex-offset=\"5\"><p \nclass=\"email text-truncate hide show-gt-sm\">{{invite.email}}</p></div><div flex=\"40\"><p \nclass=\"email text-truncate hide show-gt-sm\">{{invite.created_at_date | date:\'medium\'}}</p></div><div flex=\"15\"><p \nclass=\"phone text-truncate hide show-gt-md\">{{invite.role}}</p></div><div flex=\"5\" layout=\"row\" \nng-if=\"vm.getTeamPosition(vm.teamData)==\'owner\'\"><div class=\"selectOptionWrapperRed\" \nng-if=\"vm.getTeamPosition(vm.teamData)==\'owner\'\" ng-click=\"vm.deleteInvitation(invite, vm.teamData)\"><md-icon \nmd-font-icon=\"icon-account-remove\" class=\"iconRedBackground\"></md-icon><md-tooltip md-direction=\"bottom\">\nCancel Invitation</md-tooltip></div></div></md-list-item></md-list></div></div>");
$templateCache.put("app/main/apps/teams/views/pendingInvitations.tmpl.html","<md-dialog-content ms-scroll layout-align=\"center center\"><div flex=\"100\" layout-fill><md-list flex=\"90\" \nflex-offset=\"5\" layout-align=\"center center\"><md-list-item flex=\"100\" class=\"md-title\">Pending Invitations\n</md-list-item><md-divider></md-divider><md-list-item ng-repeat=\"invite in vm.invitations\">{{invite.email}}\n</md-list-item></md-list></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-fill layout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" \nclass=\"send-button md-accent md-raised\">CLOSE</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/teams/views/renameTeam.tmpl.html","<md-dialog-content ms-scroll><div layout=\"row\" flex=\"100\" layout-fill layout-align=\"center center\"><div flex=\"10\" \nclass=\"\" ng-if=\"vm.checkStatus\"><md-icon md-font-icon=\"icon-account-search\" class=\"iconGreenBackground\"></md-icon>\n</div><div flex=\"10\" class=\"\" ng-if=\"!vm.checkStatus\"><md-icon md-font-icon=\"icon-account-search\" \nclass=\"iconRedBackground\"></md-icon></div><md-input-container class=\"md-block\"><label>New name</label><input \nname=\"newName\" aria-label=\"New Name\" type=\"text\" ng-model=\"vm.teamData.newName\" \nng-enter=\"vm.checkTeamName( vm.teamData.newName )\" required ng-pattern=\"/[a-zA-Z0-9\\s\\-]{5,30}$/\" minlength=\"5\" \nmaxlength=\"50\"><div ng-messages=\"nameForm.newName.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\">A name is required</div><div ng-message=\"pattern\">\nNames can only have letters, numbers, spaces, and dashes</div><div ng-message=\"minlength\">\nNames must have at least 5 characters</div><div ng-message=\"minlength\">Names can have no more than 50 characters</div>\n</div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-fill layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vm.saveTeamName( vm.teamData, vm.teamData.newName ); vm.cancel();\" class=\"send-button md-accent md-raised\">\nSAVE NEW NAME</md-button><md-button type=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">\nCANCEL</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/teams/views/smallModalTemplates.html","<md-dialog class=\"contact-dialog\" aria-label=\"Team Properties\"><form name=\"contactForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between\"><span class=\"title\" ng-if=\"vm.modalType==\'Add Member\'\">Invite User to Team\n</span> <span class=\"title\" ng-if=\"vm.modalType==\'Rename Team\'\">Rename Team</span> <span class=\"title\" \nng-if=\"vm.modalType==\'Team Properties\'\">Team Info</span> <span class=\"title\" ng-if=\"vm.modalType==\'Team Properties\'\">\nPending Invitations</span> <span class=\"title\" ng-if=\"vm.modalType==\'Add Team\'\">Add Team</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-account-plus\" \nng-if=\"vm.modalType==\'Add Member\'\" class=\"md-avatar avatar contact-avatar huge\"></md-icon><md-icon \nmd-font-icon=\"icon-account-location\" ng-if=\"vm.modalType==\'Rename Team\'\" class=\"md-avatar avatar contact-avatar huge\">\n</md-icon><md-icon md-font-icon=\"icon-account-search\" ng-if=\"vm.modalType==\'Team Properties\'\" \nclass=\"md-avatar avatar contact-avatar huge\"></md-icon><md-icon md-font-icon=\"icon-email\" \nng-if=\"vm.modalType==\'Pending Invitations\'\" class=\"md-avatar avatar contact-avatar huge\"></md-icon><md-icon \nmd-font-icon=\"icon-account-plus\" ng-if=\"vm.modalType==\'Add Team\'\" class=\"md-avatar avatar contact-avatar huge\">\n</md-icon><div class=\"contact-name\" ng-if=\"vm.modalType==\'Add Member\'\">Enter name, username, or email</div><div \nclass=\"contact-name\" ng-if=\"vm.modalType==\'Rename Team\'\">{{vm.teamData.name}}</div><div class=\"contact-name\" \nng-if=\"vm.modalType==\'Team Properties\'\">{{vm.teamData.name}}</div><div class=\"contact-name\" \nng-if=\"vm.modalType==\'Pending Invitations\'\">{{vm.teamData.name}}</div><div class=\"contact-name\" \nng-if=\"vm.modalType==\'Add Team\'\">Enter new team name</div></div></div></md-toolbar><div \nng-if=\"vm.modalType==\'Add Member\'\" ng-include=\"\'app/main/apps/teams/views/addMember.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'Rename Team\'\" ng-include=\"\'app/main/apps/teams/views/renameTeam.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'Team Properties\'\" ng-include=\"\'app/main/apps/teams/views/teamProperties.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'Pending Invitations\'\" ng-include=\"\'app/main/apps/teams/views/pendingInvitations.tmpl.html\'\">\n</div><div ng-if=\"vm.modalType==\'Add Team\'\" ng-include=\"\'app/main/apps/teams/views/addTeam.tmpl.html\'\"></div></form>\n</md-dialog>");
$templateCache.put("app/main/apps/teams/views/teamList.html","<div class=\"cadwolfBox\" layout=\"column\"><div class=\"cadwolfBoxToolbarWithButton\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"cadwolfToolbarTools\">My Teams</div><div flex=\"10\"><md-menu \nmd-offset=\"0 0\"><md-button aria-label=\"Options\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-apps\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.showSmallModal(\'\', \'Add Team\', \'\')\"><span md-menu-align-target><md-icon \nmd-font-icon=\"icon-account-multiple-plus\"></md-icon></span>Add Team</md-button></md-menu-item></md-menu-content>\n</md-menu></div></div><div class=\"content\" layout=\"column\" layout-margin><md-list><md-list-item \nng-repeat=\"team in Spark.state.user.teams\" class=\"\"><div layout=\"row\" flex=\"90\" flex-offset=\"5\" \nclass=\"borderBottom font-size-16\" layout-align=\"center center\"><div flex=\"5\" \nng-if=\"Spark.state.user.current_team_id==team.id\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Current Team</md-tooltip></div><div flex=\"5\" \nng-if=\"Spark.state.user.current_team_id!=team.id\" ng-click=\"vm.makeTeamCurrent(team)\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to make this the current Team</md-tooltip></div><div flex=\"10\" \nng-if=\"vm.thisHost == \'www.cadwolf.com\' || vm.thisHost == \'https://www.cadwolf.com\'\"><img class=\"avatar\" \nng-src=\"{{team.photo_url}}\" on-error-src=\"http://cadwolf.s3.amazonaws.com/team/default.png\"></div><div flex=\"10\" \nng-if=\"vm.thisHost == \'cadwolf-staging.herokuapp.com\'\"><img class=\"avatar\" ng-src=\"{{team.photo_url}}\" \non-error-src=\"http://cadwolf-staging.s3.amazonaws.com/team/default.png\"></div><div flex=\"25\">{{team.name}}</div><div \nflex=\"10\" class=\"text-capitalized\">{{team.pivot.role}}</div><div flex=\"20\" ng-if=\"team.current_billing_plan!=null\">\nPay Plan</div><div flex=\"20\" ng-if=\"team.current_billing_plan==null\">Free Plan</div><div flex=\"25\" layout=\"row\"><div \nclass=\"selectOptionWrapperGreen\" ng-if=\"team.name!=Spark.state.user.username\" \nng-click=\"vm.navigateURL( team, \'settings\' )\"><md-icon md-font-icon=\"icon-cog\" class=\"iconGreenBackground\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Team Pay Settings</md-tooltip></div><div class=\"selectOptionWrapperGreen\" \nng-if=\"team.name==Spark.state.user.username\" ng-click=\"vm.navigateURL( team, \'userSettings\' )\"><md-icon \nmd-font-icon=\"icon-cog\" class=\"iconGreenBackground\"></md-icon><md-tooltip md-direction=\"bottom\">User Pay Settings\n</md-tooltip></div><div class=\"selectOptionWrapperBlue\" ng-if=\"team.name!=Spark.state.user.username\" \nng-click=\"vm.navigateURL( team, \'team\' )\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"iconBlueBackground\">\n</md-icon><md-tooltip md-direction=\"bottom\">Team Details / Members</md-tooltip></div><div \nclass=\"selectOptionWrapperDarkGrey\" ng-if=\"team.name==Spark.state.user.username\"><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"iconDarkGreyBackground\"></md-icon><md-tooltip md-direction=\"bottom\">\nNo Details View</md-tooltip></div><div class=\"selectOptionWrapperYellow\" ng-if=\"team.name!=Spark.state.user.username\" \nng-click=\"vm.leaveTeam( team )\"><md-icon md-font-icon=\"icon-account-remove\" class=\"iconYellowBackground\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Leave Team</md-tooltip></div><div class=\"selectOptionWrapperDarkGrey\" \nng-if=\"team.name==Spark.state.user.username\"><md-icon md-font-icon=\"icon-account-remove\" \nclass=\"iconDarkGreyBackground\"></md-icon><md-tooltip md-direction=\"bottom\">Cannot Leave This Team</md-tooltip></div>\n<div class=\"selectOptionWrapperRed\" ng-if=\"team.pivot.role==\'owner\' && team.name!=Spark.state.user.username\" \nng-click=\"vm.deleteTeam( team )\"><md-icon md-font-icon=\"icon-close-circle\" class=\"iconRedBackground\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Delete Team</md-tooltip></div><div class=\"selectOptionWrapperDarkGrey\" \nng-if=\"team.name==Spark.state.user.username\"><md-icon md-font-icon=\"icon-close-circle\" class=\"iconDarkGreyBackground\">\n</md-icon><md-tooltip md-direction=\"bottom\">Cannot Delete Team</md-tooltip></div></div></div></md-list-item></md-list>\n</div></div>");
$templateCache.put("app/main/apps/workflow/views/emptyList.html","<div class=\"md-headline marginTop20\">Favorite Workflows</div><md-list \nng-if=\"Spark.state.user.user_info.favWorkflows.length>0\" class=\"marginTop20\"><md-list-item layout=\"row\" \nclass=\"borderBottom\"><div flex=\"15\">&nbsp</div><div flex=\"30\" translate=\"FM.NAME\" class=\"md-title\">Name</div><div \nflex=\"55\" hide-xs translate=\"FM.LOCATION\" class=\"md-title\">Location</div></md-list-item><md-list-item \nng-repeat=\"workflow in Spark.state.user.user_info.favWorkflows\" class=\"borderBottom\" layout=\"row\"><div flex=\"10\">\n<md-icon md-font-icon=\"icon-sitemap\" ng-click=\"$location.path(\'/workflow/\'+workflow.location)\" class=\"hoverMe\">\n</md-icon></div><div flex=\"30\">{{workflow.name}}</div><div flex=\"55\">{{workflow.location}}</div><div flex=\"5\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\" ng-click=\"vm.removeFavItem( workflow )\" class=\"hoverMe\"></md-icon></div>\n</md-list-item></md-list><div class=\"md-body-1 marginTop20\" ng-if=\"Spark.state.user.user_info.favWorkflows.length==0\">\nUsers can \"favorite\" workflows so that they can be easily accessed. Those workflows can be shown here. To favorite a workflow, clikc the heart icon in the upper right of the workflow view.\n</div><div class=\"md-headline marginTop20\">Recent Part Trees</div><md-list \nng-if=\"Spark.state.user.user_info.workflows.length>0\" class=\"marginTop20\"><md-list-item layout=\"row\" \nclass=\"borderBottom\"><div flex=\"15\">&nbsp</div><div flex=\"30\" translate=\"FM.NAME\" class=\"md-title\">Name</div><div \nflex=\"55\" hide-xs translate=\"FM.LOCATION\" class=\"md-title\">Location</div></md-list-item><md-list-item \nng-repeat=\"workflow in Spark.state.user.user_info.workflows\" class=\"borderBottom\" layout=\"row\"><div flex=\"10\"><md-icon \nmd-font-icon=\"icon-sitemap\" ng-click=\"vm.goToURL(\'/Workflow/\'+workflow.location)\" class=\"hoverMe\"></md-icon></div><div \nflex=\"30\">{{workflow.name}}</div><div flex=\"60\">{{workflow.location}}</div></md-list-item></md-list><div \nclass=\"md-body-1 marginTop20\" ng-if=\"Spark.state.user.user_info.workflows.length==0\">\nThe list below will show the 10 most recently visited workflows.</div>");
$templateCache.put("app/main/apps/workflow/views/workflowEvents.html","<div layout=\"row\" ng-repeat=\"thisItem in listItems | orderBy:\'thisItem.item_data.fileData.order\' track by $index\" \nng-style=\"{\'min-width\':vm.totalWidth}\" class=\"workflow-row\" ng-if=\"thisItem.item_data.fileData.id == id\"><div \nng-repeat=\"logItem in thisItem.item_data.logData\" class=\"workflow-event\" \nng-if=\"(logItem.message_type==\'Saved Document\') && \n		 		(settings.views.saves) &&\n		 		(logItem.offset != -1)\" \nng-style=\"{\'left\':logItem.offset}\"><div class=\"logAction\"><md-icon md-font-icon=\"icon-content-save\" class=\"hoverMe\">\n<md-tooltip md-direction=\"bottom\">Item Saved</md-tooltip></md-icon></div></div><div \nng-repeat=\"logItem in thisItem.item_data.logData\" class=\"workflow-event\" \nng-if=\"(logItem.message_type==\'Created Item\') && \n		 		(settings.views.created) &&\n		 		(logItem.offset != -1)\" \nng-style=\"{\'left\':logItem.offset}\"><div class=\"logAction\"><md-icon md-font-icon=\"icon-star\" class=\"hoverMe\"><md-tooltip\n md-direction=\"bottom\">Document or Folder Created</md-tooltip></md-icon></div></div><div \nng-repeat=\"thisEvent in events track by $index\" class=\"workflow-event-all\" \nng-if=\"(thisEvent.item_data.eventApplyAll || thisEvent.item_data.eventVersionChanger) &&\n		 		(thisEvent.item_data.eventOffset != -1)\" \nng-style=\"{\'left\':thisEvent.item_data.eventOffset}\"><div class=\"workflow-event-inner hoverMe\" \nng-click=\"callShowEVModal(thisEvent, signoffs);\" ng-class=\"thisEvent.item_data.eventColor\" \nng-style=\"{\'min-width\' : thisEvent.item_data.eventWidth, \n		 				 \'width\' : thisEvent.item_data.eventWidth }\"><div \nclass=\"workflow-event-title-large\" ng-if=\"thisEvent.item_data.eventWidth > 150 && thisItem.showLabel\">\n{{thisEvent.item_data.eventTitle}}</div><div class=\"workflow-event-title-medium\" \nng-if=\"thisEvent.item_data.eventWidth >= 100 && thisEvent.item_data.eventWidth <= 150 && thisItem.showLabel\">\n{{thisEvent.item_data.eventTitle}}</div><div class=\"workflow-event-title-small\" \nng-if=\"thisEvent.item_data.eventWidth < 100 && thisEvent.item_data.eventWidth > 40 && thisItem.showLabel\">\n{{thisEvent.item_data.eventTitle}}</div></div><div class=\"workflow-event-inner hoverMe\" \nng-if=\"thisEvent.item_data.eventWidth <= 40\" ng-click=\"callShowEVModal(thisEvent, signoffs);\" \nng-class=\"thisEvent.item_data.eventColor\" \nng-style=\"{\'min-width\' : thisEvent.item_data.eventWidth, \n		 				\'width\' : thisEvent.item_data.eventWidth }\">\n<md-tooltip md-direction=\"bottom\">{{thisEvent.item_data.eventTitle}}</md-tooltip></div></div><div \nng-repeat=\"thisEvent in events track by thisEvent.id\" class=\"workflow-event\" \nng-if=\"!thisEvent.item_data.eventApplyAll && \n		 		!thisEvent.item_data.eventVersionChanger &&\n		 		(thisEvent.item_data.eventOffset != -1)\">\n<div ng-repeat=\"thisFile in thisEvent.item_data.eventFiles\" ng-if=\"thisFile.eventDocID == id\" ng-style=\"{}\" \nlayout-align=\"center center\"><div class=\"workflow-event-inner hoverMe\" ng-class=\"thisEvent.item_data.eventColor\" \nng-click=\"callShowEVModal(thisEvent, signoffs);\" \nng-if=\"thisEvent.item_data.eventWidth > 40 && thisEvent.item_data.eventItemHeight[thisItem.doc_id] == 40\" \nlayout-align=\"center center\" \nng-style=\"{\'min-height\' : thisEvent.item_data.eventItemHeight[thisItem.doc_id],\n				  			 \'height\' : thisEvent.item_data.eventItemHeight[thisItem.doc_id],\n				  			 \'min-width\' : thisEvent.item_data.eventWidth, \n			 				 \'width\' : thisEvent.item_data.eventWidth,\n			 				 \'left\':thisEvent.item_data.eventOffset,\n			 				 \'top\' : thisEvent.item_data.eventVertOffset[thisItem.doc_id] }\">\n<div class=\"workflow-event-title-large\" layout-align=\"center center\" ng-if=\"thisEvent.item_data.eventWidth > 150\">\n{{thisEvent.item_data.eventTitle}}</div><div class=\"workflow-event-title-medium\" layout-align=\"center center\" \nng-if=\"thisEvent.item_data.eventWidth > 100 && thisEvent.item_data.eventWidth < 150\">{{thisEvent.item_data.eventTitle}}\n</div><div class=\"workflow-event-title-small\" layout-align=\"center center\" \nng-if=\"thisEvent.item_data.eventWidth < 100 && thisEvent.item_data.eventWidth > 40\">{{thisEvent.item_data.eventTitle}}\n</div></div><div class=\"workflow-event-inner hoverMe\" ng-class=\"thisEvent.item_data.eventColor\" \nng-click=\"callShowEVModal(thisEvent, signoffs);\" \nng-if=\"thisEvent.item_data.eventWidth <= 40 || thisEvent.item_data.eventItemHeight[thisItem.doc_id] != 40\" \nng-style=\"{\'min-height\' : thisEvent.item_data.eventItemHeight[thisItem.doc_id],\n				  			 \'height\' : thisEvent.item_data.eventItemHeight[thisItem.doc_id],\n				  			 \'min-width\' : thisEvent.item_data.eventWidth, \n			 				 \'width\' : thisEvent.item_data.eventWidth,\n			 				 \'left\':thisEvent.item_data.eventOffset,\n			 				 \'top\' : thisEvent.item_data.eventVertOffset[thisItem.doc_id] }\">\n<md-tooltip md-direction=\"bottom\">{{thisEvent.item_data.eventTitle}}</md-tooltip></div></div></div></div><div \nworkflow-events layout=\"column\" ng-style=\"{\'min-width\' : totalWidth}\" ng-repeat=\"myItem in listItems\" \nng-if=\"myItem.item_data.fileData.parent_id == id\" list-items=\"listItems\" events=\"events\" settings=\"settings\" \nspark=\"Spark\" permissions=\"permissions\" id=\"myItem.item_data.fileData.id\" show-e-v-modal=\"callShowEVModal\"></div>");
$templateCache.put("app/main/apps/workflow/views/workflowItem.html","<div class=\"workflow-tree-body borderBottom\" flex=\"100\" layout=\"row\"><div class=\"marginTop5 marginLeft10\" \nng-if=\"(thisSystem.item_data.fileData.file_type_id == \'Workspace\' ||\n	 	  		 thisSystem.item_data.fileData.file_type_id == \'Part Tree\') &&\n	 	  		 thisSystem.item_data.showChildren\" \nng-click=\"thisSystem.item_data.showChildren=!thisSystem.item_data.showChildren\"><md-icon md-font-icon=\"icon-menu-down\" \nng-class=\"{\'iconGreenBackground\' : thisSystem.item_data.permission == true, \n					 			\'iconRedBackground\' : thisSystem.item_data.permission == false }\">\n</md-icon></div><div class=\"marginTop5 marginLeft10\" \nng-if=\"(thisSystem.item_data.fileData.file_type_id == \'Workspace\' ||\n	 	  		 thisSystem.item_data.fileData.file_type_id == \'Part Tree\') &&\n	 	  		 !thisSystem.item_data.showChildren\" \nng-click=\"thisSystem.item_data.showChildren=!thisSystem.item_data.showChildren\"><md-icon \nmd-font-icon=\"icon-menu-right\" \nng-class=\"{\'iconGreenBackground\' : thisSystem.item_data.permission == true,\n					 			 \'iconRedBackground\' : thisSystem.item_data.permission == false }\">\n</md-icon></div><div class=\"marginTop5 marginLeft10\" \nng-if=\"(thisSystem.item_data.fileData.file_type_id == \'Document\')\"><md-icon md-font-icon=\"icon-file-outline\" \nng-class=\"{\'iconGreenBackground\' : thisSystem.item_data.permission == true,\n					 			\'iconRedBackground\' : thisSystem.item_data.permission == false }\">\n</md-icon></div><div class=\"marginTop5 marginLeft10\" ng-if=\"(thisSystem.item_data.fileData.file_type_id == \'Dataset\')\">\n<md-icon md-font-icon=\"icon-cube-unfolded\" \nng-class=\"{\'iconGreenBackground\' : thisSystem.item_data.permission == true,\n					 			\'iconRedBackground\' : thisSystem.item_data.permission == false }\">\n</md-icon></div><div layout-align=\"space-between center\" flex=\"100\" layout=\"row\"><div class=\"workflow-side-header-row\" \nng-if=\"!thisthisSystem.item_data.permission\">{{thisSystem.item_data.fileData.name}}</div><div \nclass=\"workflow-side-header-row\" ng-if=\"thisthisSystem.item_data.permission\">{{thisSystem.item_data.fileData.name}}\n</div><div class=\"smallText\" ng-if=\"thisSystem.item_data.fileData.file_type_id == \'Document\'\">\n{{thisSystem.item_data.fileData.version}}.{{thisSystem.item_data.fileData.revision}}</div></div></div><div \nworkflow-list ng-repeat=\"mySystem in listItems | orderBy:\'order\' track by $index\" layout=\"column\" \nid=\"mySystem.item_data.fileData.id\" list-items=\"listItems\" spark=\"Spark\" permissions=\"permissions\" \nng-if=\"mySystem.item_data.fileData.parent_id == id && thisSystem.item_data.showChildren\" this-system=\"mySystem\" \nshow-children=\"mySystem.item_data.showChildren\" class=\"marginLeft10\"></div>");
$templateCache.put("app/main/apps/workflow/views/workflowItemSignoffs.html","<md-list flex=\"100\" class=\"taskList\"><md-list-item flex=\"100\" class=\"taskItem md-subhead\">\n{{thisItem.item_data.fileData.name}}</md-list-item><md-list-item flex=\"90\" flex-offset=\"10\" \nng-repeat=\"thisSignoff in signoffs\" \nng-if=\"thisSignoff.item_data.signoffDocID == thisItem.item_data.fileData.id &&\n				  		 thisSignoff.item_data.signoffEventID == thisEvent.id\" \nclass=\"taskItem textCentered\"><div flex=\"5\" class=\"display-color-med\" ng-class=\"thisSignoff.item_data.signoffColor\">\n</div><div flex=\"35\" class=\"textCentered\">{{thisSignoff.item_data.signoffTitle}}</div><div flex=\"35\" \nclass=\"textCentered\">{{thisSignoff.item_data.signoffAssigneeRoleTitle}}</div><div flex=\"35\" class=\"textCentered\" \nng-if=\"thisSignoff.item_data.signoffAssigneeType==\'user\'\">{{thisSignoff.item_data.signoffAssigneeUserName}}</div><div \nflex=\"20\" class=\"textCentered\">\n{{thisSignoff.item_data.signoffDueDay}}-{{thisSignoff.item_data.signoffDueMonth}}-{{thisSignoff.item_data.signoffDueYear}}\n</div><div flex=\"5\" class=\"textCentered\" ng-if=\"thisSignoff.item_data.signoffStatus\"><md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"Not Signed\" class=\"iconGreenBackground\"><md-tooltip md-direction=\"bottom\">\nSignoff approved</md-tooltip></md-icon></div><div flex=\"5\" class=\"textCentered\" \nng-if=\"!thisSignoff.item_data.signoffStatus\"><md-icon md-font-icon=\"icon-clock\" aria-label=\"Signed\" \nclass=\"iconRedBackground\"><md-tooltip md-direction=\"bottom\">Signoff not approved yet</md-tooltip></md-icon></div>\n</md-list-item></md-list><div workflow-item-signoffs layout=\"column\" \nng-repeat=\"thisItem in listItems | orderBy:\'order\'\" id=\"thisItem.item_data.fileData.id\" list-items=\"listItems\" \nevents=\"events\" spark=\"Spark\" this-item=\"thisItem\" signoffs=\"signoffs\" this-event=\"thisEvent\" \npermissions=\"permissions\" ng-if=\"id == thisItem.item_data.fileData.parent_id\"></div>");
$templateCache.put("app/main/apps/workflow/views/workflowLogDataStatus.html","<md-list flex=\"100\"><md-list-item flex=\"100\" class=\"borderBottom\"><div layout=\"row\" flex=\"100\"><div flex=\"80\">\n{{thisItem.item_data.fileData.name}}</div><div flex=\"5\"><md-icon md-font-icon=\"icon-border-color\" \naria-label=\"Update Logs\" ng-dblclick=\"callGetLogData( thisItem.item_data.fileData.id );\" class=\"iconGreyBackground\">\n<md-tooltip md-direction=\"bottom\">Update Log Data</md-tooltip></md-icon></div><div flex=\"5\"><md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"Update Status\" \nng-dblclick=\"callCheckUpdateStatus( thisItem.item_data.fileData.id );\" class=\"iconGreyBackground\"><md-tooltip \nmd-direction=\"bottom\">Update File Status</md-tooltip></md-icon></div><div flex=\"5\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\" aria-label=\"Delete Item\" \nng-dblclick=\"callDeleteItem( thisItem.item_data.fileData.id );\" class=\"iconRedBackground\"><md-tooltip \nmd-direction=\"bottom\">Delete Item from Workflow</md-tooltip></md-icon></div></div></md-list-item></md-list><div \nworkflow-log-data-status layout=\"column\" \nng-repeat=\"thisItem in listItems | orderBy:\'thisItem.item_data.fileData.order\' track by $index\" \nid=\"thisItem.item_data.fileData.id\" list-items=\"listItems\" spark=\"Spark\" this-item=\"thisItem\" \npermissions=\"vm.cadwolf_fileInfo.item_data.permissions\" ng-if=\"id == thisItem.item_data.fileData.parent_id\" \ncall-get-log-data=\"callGetLogData\" call-check-update-status=\"callCheckUpdateStatus\" call-delete-item=\"callDeleteItem\" \nclass=\"marginLeft20\"></div>");
$templateCache.put("app/main/apps/workflow/views/workflowMain.html","<div id=\"workflow\" class=\"page-layout carded fullwidth\" \nng-class=\"{\'date-filter-active\':vm.dateFilterActive, \'search-active\': vm.searchActive}\" layout=\"row\"><div \nclass=\"center\" layout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><md-tabs md-dynamic-height \nmd-border-bottom><md-tab label=\"Timeline\"><md-content class=\"content\" flex layout=\"column\"><div \nng-include=\"\'app/main/apps/workflow/views/dialogs/timeline.html\'\"></div></md-content></md-tab><md-tab \nlabel=\"Questions\"><md-content class=\"content\" flex layout=\"column\"><div \nng-include=\"\'app/main/apps/workflow/views/dialogs/questions.html\'\"></div></md-content></md-tab><md-tab label=\"Tasks\">\n<md-content class=\"content\" flex layout=\"column\"><div ng-include=\"\'app/main/apps/workflow/views/dialogs/tasks.html\'\">\n</div></md-content></md-tab><md-tab label=\"Requirements\"><md-content class=\"content\" flex layout=\"column\"><div \nng-include=\"\'app/main/apps/workflow/views/dialogs/requirements.html\'\"></div></md-content></md-tab></md-tabs></div>\n</div></div>");
$templateCache.put("app/main/apps/workflow/views/workflowQuestion.html","<div layout=\"column\" ng-repeat=\"thisItem in listItems | orderBy:\'thisItem.created_at\' track by $index\" ng-style=\"\" \nclass=\"paddingLeft10 borderLeft paddingBottom10 marginBottom10\" ng-if=\"thisItem.id == id\"><div \nng-if=\" thisItem.user_id != Spark.state.user.id || thisItem.item_data.editStatus == 0 \" \nclass=\"md-title paddingBottom10\">{{thisItem.item_data.questionTitle}}</div><div \nng-if=\" thisItem.user_id != spark.state.user.id || thisItem.item_data.editStatus == 0 \" \ndata-ng-bind-html=\"thisItem.item_data.questionBody\"></div><div \nng-if=\" thisItem.user_id == Spark.state.user.id && thisItem.item_data.editStatus == 1 \" \nclass=\"md-title marginTop10 paddingBottom10\"><md-input-container class=\"md-block\" flex=\"100\"><label>Question Title\n</label><input ng-model=\"thisItem.item_data.questionTitle\" ng-enter=\"thisItem.item_data.editStatus=0\">\n</md-input-container></div><div ng-if=\" thisItem.user_id == spark.state.user.id && thisItem.item_data.editStatus == 1\">\n<text-angular ng-model=\"thisItem.item_data.questionBody\"></text-angular></div><div layout=\"row\"><div \nng-if=\" thisItem.user_id == spark.state.user.id && thisItem.item_data.editStatus == 0 \" \nng-click=\" thisItem.item_data.editStatus = 1 \" class=\"marginTop10 marginRight10 hoverMe blueText\">Edit</div><div \nng-if=\" thisItem.user_id == spark.state.user.id && thisItem.item_data.editStatus == 1 \" \nng-click=\" thisItem.item_data.editStatus = 0; vm.updateQuestion( thisItem ) \" \nclass=\"marginTop10 marginRight10 hoverMe blueText\">Done</div><div ng-click=\" vm.addQuestion( thisItem.id ) \" \nclass=\"marginTop10 marginRight10 hoverMe blueText\">Respond</div></div><div workflow-question layout=\"column\" \nng-style=\"\" ng-repeat=\"thisItem in vm.questions | orderBy:\'date_created\' track by $index\" id=\"thisItem.id\" \nlist-items=\"vm.questions\" spark=\"spark\" ng-if=\"thisItem.parent_id==thisItem.id\"></div></div><div workflow-task \nlayout=\"column\" ng-style=\"\" ng-repeat=\"thisItem in listItems | orderBy:\'date_created\' track by $index\" \nid=\"thisItem.id\" list-items=\"listItems\" spark=\"Spark\" ng-if=\"thisItem.parent_id==id\"></div>");
$templateCache.put("app/main/apps/workflow/views/workflowRequirement.html","<div ng-repeat=\"thisItem in listItems | orderBy:\'thisItem.created_at\' track by $index\" ng-style=\"\" \nclass=\"paddingLeft10 borderLeft paddingBottom10 marginBottom10\" ng-if=\"thisItem.id == id\"><div \nclass=\"md-title paddingBottom10\">{{thisItem.content.title}}</div><div data-ng-bind-html=\"thisItem.content.text\"></div>\n</div><div workflow-requirement layout=\"column\" ng-style=\"\" \nng-repeat=\"thisItem in listItems | orderBy:\'date_created\' track by $index\" id=\"thisItem.id\" list-items=\"listItems\" \nspark=\"spark\" ng-if=\"thisItem.depdendent_id==id\"></div>");
$templateCache.put("app/main/apps/workflow/views/workflowShowSignoffs.html","<md-list flex=\"100\" class=\"taskList\"><md-list-item flex=\"100\" class=\"taskItem md-subhead\">\n{{thisItem.item_data.fileData.name}}</md-list-item><md-list-item flex=\"90\" flex-offset=\"10\" \nng-repeat=\"thisSignoff in signoffs\" \nng-if=\"thisSignoff.item_data.signoffDocID == thisItem.item_data.fileData.id &&\n				  		 thisSignoff.item_data.signoffEventID == thisEvent.id\" \nclass=\"taskItem textCentered\"><div flex=\"5\" class=\"display-color-med\" ng-class=\"thisSignoff.item_data.signoffColor\">\n</div><div flex=\"30\" class=\"textCentered\">{{thisSignoff.item_data.signoffTitle}}</div><div flex=\"25\" \nclass=\"textCentered\">{{thisSignoff.item_data.signoffAssigneeRoleTitle}}</div><div flex=\"25\" class=\"textCentered\" \nng-if=\"thisSignoff.item_data.signoffAssigneeType==\'user\'\">{{thisSignoff.item_data.signoffAssigneeUserName}}</div><div \nflex=\"25\" class=\"textCentered\" ng-if=\"thisSignoff.item_data.signoffAssigneeType!=\'user\'\"></div><div flex=\"15\" \nclass=\"textCentered\">\n{{thisSignoff.item_data.signoffDueDay}}-{{thisSignoff.item_data.signoffDueMonth}}-{{thisSignoff.item_data.signoffDueYear}}\n</div><div flex=\"5\" class=\"textCentered\" ng-if=\"thisSignoff.item_data.signoffStatus\"><md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"Not Signed\" class=\"iconGreenBackground\"><md-tooltip md-direction=\"bottom\">\nSignoff approved</md-tooltip></md-icon></div><div flex=\"5\" class=\"textCentered\" \nng-if=\"!thisSignoff.item_data.signoffStatus\"><md-icon md-font-icon=\"icon-clock\" aria-label=\"Signed\" \nclass=\"iconRedBackground\"><md-tooltip md-direction=\"bottom\">Signoff not approved yet</md-tooltip></md-icon></div>\n</md-list-item></md-list><div workflow-show-signoffs layout=\"column\" \nng-repeat=\"thisItem in listItems | orderBy:\'order\' track by $index\" id=\"thisItem.item_data.fileData.id\" \nlist-items=\"listItems\" events=\"events\" spark=\"Spark\" this-item=\"thisItem\" signoffs=\"signoffs\" \npermissions=\"permissions\" this-event=\"thisEvent\" ng-if=\"id == thisItem.item_data.fileData.parent_id\"></div>");
$templateCache.put("app/main/apps/workflow/views/workflowSignoffs.html","<md-list flex=\"100\" class=\"taskList\"><md-list-item flex=\"100\" class=\"taskItem md-subhead\">\n{{thisItem.item_data.fileData.name}}</md-list-item><md-list-item flex=\"90\" flex-offset=\"10\" \nng-repeat=\"thisSignoff in signoffs\" ng-if=\"thisSignoff.item_data.signoffDocID == thisItem.item_data.fileData.id\" \nclass=\"taskItem textCentered\"><div flex=\"5\" class=\"display-color-med\" ng-class=\"thisSignoff.item_data.signoffColor\">\n</div><div flex=\"45\" class=\"textCentered\">{{thisSignoff.item_data.signoffTitle}}</div><div flex=\"45\" \nclass=\"textCentered\">{{thisSignoff.item_data.signoffEventTitle}}</div><div flex=\"5\" class=\"textCentered\" \nng-if=\"thisSignoff.item_data.signoffStatus\"><md-icon md-font-icon=\"icon-check-circle\" aria-label=\"Not Signed\" \nclass=\"iconGreenBackground\"><md-tooltip md-direction=\"bottom\">Signoff approved</md-tooltip></md-icon></div><div \nflex=\"5\" class=\"textCentered\" ng-if=\"!thisSignoff.item_data.signoffStatus\"><md-icon md-font-icon=\"icon-clock\" \naria-label=\"Signed\" class=\"iconRedBackground\"><md-tooltip md-direction=\"bottom\">Signoff not approved yet</md-tooltip>\n</md-icon></div></md-list-item></md-list><div workflow-signoffs layout=\"column\" \nng-repeat=\"thisItem in listItems | orderBy:\'order\'\" id=\"thisItem.item_data.fileData.id\" list-items=\"listItems\" \nspark=\"Spark\" this-item=\"thisItem\" signoffs=\"signoffs\" permissions=\"permissions\" \nng-if=\"id == thisItem.item_data.fileData.parent_id\"></div>");
$templateCache.put("app/main/apps/workflow/views/workflowTask.html","<div layout=\"row\" ng-repeat=\"thisItem in listItems | orderBy:\'thisItem.created_at\' track by $index\" ng-style=\"\" \nclass=\"paddingLeft10 borderLeft paddingBottom10 marginBottom10\" ng-if=\"thisItem.id == id\"><div \nng-if=\" thisItem.user_id != vm.Spark.state.user.id || thisItem.item_data.editStatus == 0 \" \nclass=\"md-title paddingBottom10\">{{thisItem.item_data.taskTitle}}</div><div \nng-if=\" thisItem.user_id != spark.state.user.id || thisItem.item_data.editStatus == 0 \" \ndata-ng-bind-html=\"thisItem.item_data.taskBody\"></div><div \nng-if=\" thisItem.user_id == vm.Spark.state.user.id && thisItem.item_data.editStatus == 1 \" \nclass=\"md-title marginTop10 paddingBottom10\"><md-input-container class=\"md-block\" flex=\"100\"><label>Task Title</label>\n<input ng-model=\"thisItem.item_data.taskTitle\" ng-enter=\"thisItem.item_data.editStatus=0\"></md-input-container></div>\n<div ng-if=\" thisItem.user_id == spark.state.user.id && thisItem.item_data.editStatus == 1\"><text-angular \nng-model=\"thisItem.item_data.taskBody\"></text-angular></div><div layout=\"row\"><div \nng-if=\" thisItem.user_id == spark.state.user.id && thisItem.item_data.editStatus == 0 \" \nng-click=\" thisItem.item_data.editStatus = 1 \" class=\"marginTop10 marginRight10 hoverMe blueText\">Edit</div><div \nng-if=\" thisItem.user_id == spark.state.user.id && thisItem.item_data.editStatus == 1 \" \nng-click=\" thisItem.item_data.editStatus = 0; vm.updateTask( thisItem ) \" \nclass=\"marginTop10 marginRight10 hoverMe blueText\">Done</div><div ng-click=\" vm.addTask( thisItem.id ) \" \nclass=\"marginTop10 marginRight10 hoverMe blueText\">Respond</div></div></div><div workflow-task layout=\"column\" \nng-style=\"\" ng-repeat=\"thisItem in listItems | orderBy:\'date_created\' track by $index\" id=\"thisItem.id\" \nlist-items=\"listItems\" spark=\"spark\" ng-if=\"thisItem.parent_id==id\"></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps\" layout=\"row\" layout-align=\"start center\"><div class=\"step md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{step.stepNumber}} \n</span><span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\">\n</span></div><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/card.html","<div id=\"{{obj.itemid}}\" class=\"switchWrapper worksheetItem\" ng-mouseover=\"obj.content.showIcons=true;\" \nng-mouseout=\"obj.content.showIcons=false\" \nng-if=\"obj.order>=vm.cadwolf_fileInfo.item_data.showStartLoc&&\n            obj.order<=vm.cadwolf_fileInfo.item_data.showEndLoc&&\n            vm.cadwolf_fileInfo.showHeaders\" \nng-class=\"obj.content.showClass\" ng-click=\"vm.setCurrent(obj)\"><div class=\"icon_wrapper\" ng-if=\"vm.editPerm\" \nng-show=\"obj.content.showIcons\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/iconHolder.tmpl.html\'\">\n</div><div ng-click=\"vm.setCurrent(obj)\"><div class=\"cadwolfCard\" \nstyle=\"width : {{obj.content.width}}px; \n                      height : {{obj.content.height}}px\" \nlayout-align=\"space-between center\" layout=\"column\"><div class=\"cardTopLine\" \nng-if=\"( ( obj.content.showVariable == 2 ) || ( obj.content.showOrder == 1 ) )\" layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"cardTopVariable md-caption\" ng-if=\"obj.content.showVariable == 2\">\n{{obj.content.variable}}</div><div class=\"cardTopOrder md-caption\" ng-if=\"obj.content.showOrder == 1\">\n{{obj.content.variableOrder}}</div></div><div layout=\"column\" layout-align=\"center center\"><div class=\"cardNum\" \nstyle=\"font-size : {{obj.content.variableSize}}pt;\n                              color : {{obj.content.variableColor}}\">\n{{obj.content.value}} {{obj.content.units}}</div><div class=\"cardTitle md-title\" ng-if=\"obj.content.showTitle == 1\">\n{{obj.content.title}}</div><div class=\"cardVariable md-caption\" ng-if=\"obj.content.showVariable == 1\">\n{{obj.content.variable}}</div></div><div class=\"cardDescription md-body-1\" ng-if=\"obj.content.showDescription == 1\" \ndata-ng-bind-html=\"obj.content.description\"></div></div></div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/equation.html","<div id=\"{{obj.itemid}}\" class=\"switchWrapper worksheetItem\" ng-mouseover=\"obj.content.showIcons=true;\" \nng-mouseout=\"obj.content.showIcons=false\" \nng-if=\"((obj.content.Equation.inputType!=\'Dataset\')&&\n            (obj.content.Equation.inputType!=\'File\')&&\n            (obj.content.Equation.isConnectedID!=1))&&\n            obj.order>=vm.cadwolf_fileInfo.item_data.showStartLoc&&\n            obj.order<=vm.cadwolf_fileInfo.item_data.showEndLoc&&\n            vm.cadwolf_fileInfo.showEquations&&\n            obj.content.isConnectedEquation!=1\" \nng-class=\"obj.content.showClass\"><div class=\"icon_wrapper\" ng-if=\"vm.editPerm\" ng-show=\"obj.content.showIcons\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/iconHolder.tmpl.html\'\"></div><div \nng-click=\"vm.setCurrent(obj)\"><span \nng-if=\"( ( obj.content.eqType == \'equation\' ) || ( obj.content.eqType === undefined ) )\" \nng-include=\"\'app/main/apps/document/worksheet/views/equationNum.html\'\"></span><span \nng-if=\"( obj.content.eqType == \'slider\' )\" ng-include=\"\'app/main/apps/document/worksheet/views/equationSlider.html\'\">\n</span><span ng-if=\"( obj.content.eqType == \'radio\' )\" \nng-include=\"\'app/main/apps/document/worksheet/views/equationRadio.html\'\"></span><span \nng-if=\"( obj.content.eqType == \'dropdown\' )\" \nng-include=\"\'app/main/apps/document/worksheet/views/equationDropdown.html\'\"></span></div><span \nng-include=\"\'app/main/apps/document/worksheet/views/templates/refNum.html\'\"></span></div>");
$templateCache.put("app/main/apps/document/worksheet/views/equationDropdown.html","<div ng-if=\"( obj.content.eqType == \'dropdown\' )\" ng-class=\"{\'borderMe\' : obj.content.dropdown.showBorder == 1 }\" \nlayout-align=\"center center\"><div ng-if=\"obj.content.dropdown.showLabel==1\" class=\"radioLabel\">Value for {{obj.name}}\n</div><div layout-align=\"center center\" style=\"width: {{obj.content.dropdown.width}}px; margin:auto\">\n<md-input-container style=\"width: {{obj.content.dropdown.width}}px\"><md-select ng-model=\"obj.content.dropdown.value\">\n<md-option ng-repeat=\"eqObj in obj.content.dropdown.values\" class=\"md-primary\" ng-value=\"eqObj[\'value\']\" \nng-click=\"obj.content.dropdown.value=eqObj[\'value\'];\n							   			 obj.content.dropdown.label=eqObj[\'label\'];\n										 obj.content.Equation.newEquation = obj.name+\'=\'+eqObj[\'value\']; \n										 obj.content.needsUpdateFlag=1; \n										 vm.runEquationDigest()\">\n{{eqObj[\'label\']}}</md-option></md-select></md-input-container></div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/equationNum.html","<div \nng-if=\"( !obj.content.showEdit ) && \n                    ( obj.content.Equation.Errors_errors.length == 0 ) &&\n                    ( obj.content.Equation.inEdit != 1 ) &&\n                    ( vm.editPerm && obj.content.Equation.Format_editinuse == 1 ) &&\n                    ( ( obj.content.eqType == \'equation\' ) || ( obj.content.eqType === undefined ) )\" \nclass=\"editEquation\" ng-dblclick=\"obj.content.showEdit=!obj.content.showEdit\"><span \nmathjax-bind=\"obj.content.Equation.Format_left\"></span><span>=</span> <span \nmathjax-bind=\"obj.content.Equation.Format_showequation\"></span><span>=</span> <span \nmathjax-bind=\"obj.content.Equation.Format_showsolution\" ng-if=\"obj.content.Equation.Format_showvalue==\'value\'\"></span> \n<span mathjax-bind=\"obj.content.Equation.Units_showunits\" ng-if=\"obj.content.Equation.Format_showvalue==\'value\'\">\n</span> <span mathjax-bind=\"obj.content.Equation.Format_size\" \nng-if=\"obj.content.Equation.Format_showvalue==\'size\' || obj.content.Equation.Format_showvalue==\'default\'\"></span></div>\n<div \nng-if=\"( !obj.content.showEdit ) && \n                    ( obj.content.Equation.Errors_errors.length == 0 ) &&\n                    ( obj.content.Equation.inEdit != 1 ) &&\n                    ( vm.editPerm && obj.content.Equation.Format_editinuse != 1 ) &&\n                    ( ( obj.content.eqType == \'equation\' ) || ( obj.content.eqType === undefined ) )\" \nclass=\"noEditEquation\" ng-dblclick=\"obj.content.showEdit=!obj.content.showEdit\"><span \nmathjax-bind=\"obj.content.Equation.Format_left\"></span><span>=</span> <span \nmathjax-bind=\"obj.content.Equation.Format_showequation\"></span><span>=</span> <span \nmathjax-bind=\"obj.content.Equation.Format_showsolution\" ng-if=\"obj.content.Equation.Format_showvalue==\'value\'\"></span> \n<span mathjax-bind=\"obj.content.Equation.Units_showunits\" ng-if=\"obj.content.Equation.Format_showvalue==\'value\'\">\n</span> <span mathjax-bind=\"obj.content.Equation.Format_size\" \nng-if=\"obj.content.Equation.Format_showvalue==\'size\' || obj.content.Equation.Format_showvalue==\'default\'\"></span></div>\n<div \nng-if=\"( !obj.content.showEdit ) && \n                    ( obj.content.Equation.Errors_errors.length == 0 ) &&\n                    ( obj.content.Equation.inEdit != 1 ) &&\n                    ( !vm.editPerm && obj.content.Equation.Format_editinuse == 1 ) &&\n                    ( ( obj.content.eqType == \'equation\' ) || ( obj.content.eqType === undefined ) )\" \nclass=\"editEquation\" ng-dblclick=\"obj.content.showEdit=!obj.content.showEdit\"><span \nmathjax-bind=\"obj.content.Equation.Format_left\"></span><span>=</span> <span \nmathjax-bind=\"obj.content.Equation.Format_showequation\"></span><span>=</span> <span \nmathjax-bind=\"obj.content.Equation.Format_showsolution\" ng-if=\"obj.content.Equation.Format_showvalue==\'value\'\"></span> \n<span mathjax-bind=\"obj.content.Equation.Units_showunits\" ng-if=\"obj.content.Equation.Format_showvalue==\'value\'\">\n</span> <span mathjax-bind=\"obj.content.Equation.Format_size\" \nng-if=\"obj.content.Equation.Format_showvalue==\'size\' || obj.content.Equation.Format_showvalue==\'default\'\"></span></div>\n<div \nng-if=\"( !obj.content.showEdit ) && \n                    ( obj.content.Equation.Errors_errors.length == 0 ) &&\n                    ( obj.content.Equation.inEdit != 1 ) &&\n                    ( !vm.editPerm ) &&\n                    ( obj.content.Equation.Format_editinuse != 1 ) &&\n                    ( ( obj.content.eqType == \'equation\' ) || ( obj.content.eqType === undefined ) )\" \nclass=\"noEditEquation\"><span mathjax-bind=\"obj.content.Equation.Format_left\"></span><span>=</span> <span \nmathjax-bind=\"obj.content.Equation.Format_showequation\"></span><span>=</span> <span \nmathjax-bind=\"obj.content.Equation.Format_showsolution\" ng-if=\"obj.content.Equation.Format_showvalue==\'value\'\"></span> \n<span mathjax-bind=\"obj.content.Equation.Units_showunits\" ng-if=\"obj.content.Equation.Format_showvalue==\'value\'\">\n</span> <span mathjax-bind=\"obj.content.Equation.Format_size\" \nng-if=\"obj.content.Equation.Format_showvalue==\'size\' || obj.content.Equation.Format_showvalue==\'default\'\"></span></div>\n<div \nng-if=\"( !obj.content.showEdit ) && \n                    ( obj.content.Equation.Errors_errors.length == 0 ) && \n                    ( obj.content.Equation.inEdit == 1 ) &&\n                    ( ( obj.content.eqType == \'equation\' ) || ( obj.content.eqType === undefined ) )\" \nclass=\"equationInEdit editEquation\"><span mathjax-bind=\"obj.content.Equation.Format_left\"></span><span>=</span> <span \nmathjax-bind=\"obj.content.Equation.Format_showequation\"></span></div><div \nng-if=\"!obj.content.showEdit && \n                    ( obj.content.Equation.Errors_errors.length > 0 ) &&\n                    ( ( obj.content.eqType == \'equation\' ) || ( obj.content.eqType === undefined ) )\" \nng-dblclick=\"obj.content.showEdit=!obj.content.showEdit\" class=\"noEditEquation\"><div class=\"md-body-1 errorText\">\n{{obj.content.Equation.Errors_errors[0]}}</div></div><md-input-container class=\"md-block editEquation\" \nng-if=\"vm.editPerm && \n                                   obj.content.showEdit &&\n                                   ( ( obj.content.eqType == \'equation\' ) || ( obj.content.eqType === undefined ) )\">\n<label>Enter New Equation</label><input ng-model=\"obj.content.Equation.newEquation\" \nng-enter=\"obj.content.showEdit=false; obj.content.needsUpdateFlag=1; vm.runEquationDigest()\" class=\"textCentered\">\n</md-input-container><div layout=\"row\" layout-align=\"center start\" class=\"textCentered editEquation\" \nng-if=\"!vm.editPerm && \n                    (obj.content.Equation.Format_editinuse==1) && \n                    obj.content.showEdit &&\n                    ( ( obj.content.eqType == \'equation\' ) || ( obj.content.eqType === undefined ) )\">\n<span class=\"marginTop20\" mathjax-bind=\"obj.content.Equation.Format_left\"></span> <span class=\"marginTop20\">=</span>\n<md-input-container class=\"md-block\"><label>Enter New Equation (Not new name)</label><input \nng-model=\"obj.content.Equation.Format_right\" \nng-enter=\"obj.content.showEdit=false; obj.content.needsUpdateFlag=1; vm.runEquationDigest()\" class=\"textCentered\">\n</md-input-container></div>");
$templateCache.put("app/main/apps/document/worksheet/views/equationRadio.html","<div ng-if=\"( obj.content.eqType == \'radio\' ) &&\n                    ( obj.content.radio.vertical == 1 )\" \nng-class=\"{\'borderMe\' : obj.content.radio.showBorder == 1 }\" layout-align=\"center center\"><div \nng-if=\"obj.content.radio.showLabel==1\" class=\"radioLabel\">Value for {{obj.name}}</div><div \nlayout-align=\"center center\" style=\"width: {{obj.content.radio.width}}px; margin:auto\"><md-radio-group \nng-model=\"obj.content.radio.value\"><md-radio-button ng-repeat=\"eqObj in obj.content.radio.values\" class=\"md-primary\" \nvalue=\"{{eqObj[\'value\']}}\" \nng-click=\"obj.content.radio.value=eqObj[\'value\'];\n                                         obj.content.Equation.newEquation = obj.name+\'=\'+eqObj[\'value\']; \n                                         obj.content.needsUpdateFlag=1; \n                                         vm.runEquationDigest()\">\n{{eqObj[\'label\']}}</md-radio-button></md-radio-group></div></div><div \nng-if=\"( obj.content.eqType == \'radio\' ) &&\n                    ( obj.content.radio.vertical == 0 )\" \nng-class=\"{\'borderMe\' : obj.content.radio.showBorder == 1 }\" layout-align=\"center center\"><div \nng-if=\"obj.content.radio.showLabel == 1\" class=\"radioLabel\">Value for {{obj.name}}</div><div \nlayout-align=\"center center\" style=\"width: {{obj.content.radio.width}}px; margin:auto\"><md-radio-group \nng-model=\"obj.content.radio.value\" layout=\"row\"><md-radio-button ng-repeat=\"eqObj in obj.content.radio.values\" \nvalue=\"{{eqObj[\'value\']}}\" class=\"md-primary\" \nng-click=\"obj.content.radio.value=eqObj[\'value\'];\n                                         obj.content.Equation.newEquation = obj.name+\'=\'+eqObj[\'value\']; \n                                         obj.content.needsUpdateFlag=1; \n                                         vm.runEquationDigest()\">\n{{eqObj[\'label\']}}</md-radio-button></md-radio-group></div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/equationSlider.html","<div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 0 ) &&\n                    ( obj.content.slider.vertical == 0 ) &&\n                    ( obj.content.slider.discrete == 0 ) &&\n                    ( obj.content.slider.inverted == 0 )\">\n<md-slider-container><span>{{obj.name}}</span><md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmin=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" flex aria-label=\"slider\" id=\"slider_{{obj.itemid}}\" \nstyle=\"height: {{obj.content.height}}px\" ;></md-slider></md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 0 ) &&\n                    ( obj.content.slider.vertical == 0 ) &&\n                    ( obj.content.slider.discrete == 0 ) &&\n                    ( obj.content.slider.inverted == 1 )\">\n<md-slider-container><span>{{obj.name}}</span><md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmd-invert min=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" flex aria-label=\"slider\" \nid=\"slider_{{obj.itemid}}\" style=\"height: {{obj.content.height}}px\" ;></md-slider></md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 0 ) &&\n                    ( obj.content.slider.vertical == 0 ) &&\n                    ( obj.content.slider.discrete == 1 ) &&\n                    ( obj.content.slider.inverted == 0 )\">\n<md-slider-container><span>{{obj.name}}</span><md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmd-discrete min=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" step=\"{{obj.content.slider.step}}\" flex \naria-label=\"slider\" id=\"slider_{{obj.itemid}}\" style=\"height: {{obj.content.height}}px\" ;></md-slider>\n</md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 0 ) &&\n                    ( obj.content.slider.vertical == 0 ) &&\n                    ( obj.content.slider.discrete == 1 ) &&\n                    ( obj.content.slider.inverted == 1 )\">\n<md-slider-container><span>{{obj.name}}</span><md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmd-invert md-discrete min=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" \nstep=\"{{obj.content.slider.step}}\" flex aria-label=\"slider\" id=\"slider_{{obj.itemid}}\" \nstyle=\"height: {{obj.content.height}}px\" ;></md-slider></md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 1 ) &&\n                    ( obj.content.slider.vertical == 0 ) &&\n                    ( obj.content.slider.eqLoc == 0 ) &&\n                    ( obj.content.slider.discrete == 0 ) &&\n                    ( obj.content.slider.inverted == 0 )\">\n<md-slider-container><span>{{obj.name}}</span><md-input-container><input flex type=\"number\" \nng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" aria-label=\"red\" aria-controls=\"red-slider\"></md-input-container>\n<md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmin=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" flex aria-label=\"slider\" id=\"slider_{{obj.itemid}}\" \nstyle=\"height: {{obj.content.height}}px\" ;></md-slider></md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 1 ) &&\n                    ( obj.content.slider.vertical == 0 ) &&\n                    ( obj.content.slider.eqLoc == 0 ) &&\n                    ( obj.content.slider.discrete == 0 ) &&\n                    ( obj.content.slider.inverted == 1 )\">\n<md-slider-container><span>{{obj.name}}</span><md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmd-invert min=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" flex aria-label=\"slider\" \nid=\"slider_{{obj.itemid}}\" style=\"height: {{obj.content.height}}px\" ;></md-slider><md-input-container><input flex \ntype=\"number\" ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" aria-label=\"red\" aria-controls=\"red-slider\">\n</md-input-container></md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 1 ) &&\n                    ( obj.content.slider.vertical == 0 ) &&\n                    ( obj.content.slider.eqLoc == 0 ) &&\n                    ( obj.content.slider.discrete == 1 ) &&\n                    ( obj.content.slider.inverted == 0 )\">\n<md-slider-container><span>{{obj.name}}</span><md-input-container><input flex type=\"number\" \nng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" aria-label=\"red\" aria-controls=\"red-slider\"></md-input-container>\n<md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmd-discrete min=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" step=\"{{obj.content.slider.step}}\" flex \naria-label=\"slider\" id=\"slider_{{obj.itemid}}\" style=\"height: {{obj.content.height}}px\" ;></md-slider>\n</md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 1 ) &&\n                    ( obj.content.slider.vertical == 0 ) &&\n                    ( obj.content.slider.eqLoc == 0 ) &&\n                    ( obj.content.slider.discrete == 1 ) &&\n                    ( obj.content.slider.inverted == 1 )\">\n<md-slider-container><span>{{obj.name}}</span><md-input-container><input flex type=\"number\" \nng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" aria-label=\"red\" aria-controls=\"red-slider\"></md-input-container>\n<md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmd-invert md-discrete min=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" \nstep=\"{{obj.content.slider.step}}\" flex aria-label=\"slider\" id=\"slider_{{obj.itemid}}\" \nstyle=\"height: {{obj.content.height}}px\" ;></md-slider></md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 1 ) &&\n                    ( obj.content.slider.vertical == 0 ) &&\n                    ( obj.content.slider.eqLoc == 1 ) &&\n                    ( obj.content.slider.discrete == 0 ) &&\n                    ( obj.content.slider.inverted == 0 )\">\n<md-slider-container><span>{{obj.name}}</span><md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmin=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" flex aria-label=\"slider\" id=\"slider_{{obj.itemid}}\" \nstyle=\"height: {{obj.content.height}}px\" ;></md-slider><md-input-container><input flex type=\"number\" \nng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" aria-label=\"red\" aria-controls=\"red-slider\"></md-input-container>\n</md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 1 ) &&\n                    ( obj.content.slider.vertical == 0 ) &&\n                    ( obj.content.slider.eqLoc == 1 ) &&\n                    ( obj.content.slider.discrete == 0 ) &&\n                    ( obj.content.slider.inverted == 1 )\">\n<md-slider-container><span>{{obj.name}}</span><md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmd-invert min=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" flex aria-label=\"slider\" \nid=\"slider_{{obj.itemid}}\" style=\"height: {{obj.content.height}}px\" ;></md-slider><md-input-container><input flex \ntype=\"number\" ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" aria-label=\"red\" aria-controls=\"red-slider\">\n</md-input-container></md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 1 ) &&\n                    ( obj.content.slider.vertical == 0 ) &&\n                    ( obj.content.slider.eqLoc == 1 ) &&\n                    ( obj.content.slider.discrete == 1 ) &&\n                    ( obj.content.slider.inverted == 0 )\">\n<md-slider-container><span>{{obj.name}}</span><md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmd-discrete min=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" step=\"{{obj.content.slider.step}}\" flex \naria-label=\"slider\" id=\"slider_{{obj.itemid}}\" style=\"height: {{obj.content.height}}px\" ;></md-slider>\n<md-input-container><input flex type=\"number\" ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" aria-label=\"red\" \naria-controls=\"red-slider\"></md-input-container></md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 1 ) &&\n                    ( obj.content.slider.vertical == 0 ) &&\n                    ( obj.content.slider.eqLoc == 1 ) &&\n                    ( obj.content.slider.discrete == 1 ) &&\n                    ( obj.content.slider.inverted == 1 )\">\n<md-slider-container><span>{{obj.name}}</span><md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmd-invert md-discrete min=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" \nstep=\"{{obj.content.slider.step}}\" flex aria-label=\"slider\" id=\"slider_{{obj.itemid}}\" \nstyle=\"height: {{obj.content.height}}px\" ;></md-slider><md-input-container><input flex type=\"number\" \nng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" aria-label=\"red\" aria-controls=\"red-slider\"></md-input-container>\n</md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 0 ) &&\n                    ( obj.content.slider.vertical == 1 ) &&\n                    ( obj.content.slider.discrete == 0 ) &&\n                    ( obj.content.slider.inverted == 0 )\">\n<md-slider-container><span>{{obj.name}}</span><md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmin=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" flex aria-label=\"slider\" id=\"slider_{{obj.itemid}}\" \nstyle=\"height: {{obj.content.height}}px\" ;></md-slider></md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 0 ) &&\n                    ( obj.content.slider.vertical == 1 ) &&\n                    ( obj.content.slider.discrete == 0 ) &&\n                    ( obj.content.slider.inverted == 1 )\">\n<md-slider-container><span>{{obj.name}}</span><md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmd-invert min=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" flex aria-label=\"slider\" \nid=\"slider_{{obj.itemid}}\" style=\"height: {{obj.content.height}}px\" ;></md-slider></md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 0 ) &&\n                    ( obj.content.slider.vertical == 1 ) &&\n                    ( obj.content.slider.discrete == 1 ) &&\n                    ( obj.content.slider.inverted == 0 )\">\n<md-slider-container><span>{{obj.name}}</span><md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmd-discrete min=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" step=\"{{obj.content.slider.step}}\" flex \naria-label=\"slider\" id=\"slider_{{obj.itemid}}\" style=\"height: {{obj.content.height}}px\" ;></md-slider>\n</md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 0 ) &&\n                    ( obj.content.slider.vertical == 1 ) &&\n                    ( obj.content.slider.discrete == 1 ) &&\n                    ( obj.content.slider.inverted == 1 )\">\n<md-slider-container><span>{{obj.name}}</span><md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmd-invert md-discrete min=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" \nstep=\"{{obj.content.slider.step}}\" flex aria-label=\"slider\" id=\"slider_{{obj.itemid}}\" \nstyle=\"height: {{obj.content.height}}px\" ;></md-slider></md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 1 ) &&\n                    ( obj.content.slider.vertical == 1 ) &&\n                    ( obj.content.slider.eqLoc == 0 ) &&\n                    ( obj.content.slider.discrete == 0 ) &&\n                    ( obj.content.slider.inverted == 0 )\">\n<md-slider-container><span>{{obj.name}}</span><md-input-container><input flex type=\"number\" \nng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" aria-label=\"red\" aria-controls=\"red-slider\"></md-input-container>\n<md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmd-vertical min=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" flex aria-label=\"slider\" \nid=\"slider_{{obj.itemid}}\" style=\"height: {{obj.content.height}}px\" ;></md-slider></md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 1 ) &&\n                    ( obj.content.slider.vertical == 1 ) &&\n                    ( obj.content.slider.eqLoc == 0 ) &&\n                    ( obj.content.slider.discrete == 0 ) &&\n                    ( obj.content.slider.inverted == 1 )\">\n<md-slider-container><span>{{obj.name}}</span><md-input-container><input flex type=\"number\" \nng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" aria-label=\"red\" aria-controls=\"red-slider\"></md-input-container>\n<md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmd-vertical md-invert min=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" flex aria-label=\"slider\" \nid=\"slider_{{obj.itemid}}\" style=\"height: {{obj.content.height}}px\" ;></md-slider></md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 1 ) &&\n                    ( obj.content.slider.vertical == 1 ) &&\n                    ( obj.content.slider.eqLoc == 0 ) &&\n                    ( obj.content.slider.discrete == 1 ) &&\n                    ( obj.content.slider.inverted == 0 )\">\n<md-slider-container><span>{{obj.name}}</span><md-input-container><input flex type=\"number\" \nng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" aria-label=\"red\" aria-controls=\"red-slider\"></md-input-container>\n<md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmd-vertical md-discrete min=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" \nstep=\"{{obj.content.slider.step}}\" flex aria-label=\"slider\" id=\"slider_{{obj.itemid}}\" \nstyle=\"height: {{obj.content.height}}px\" ;></md-slider></md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 1 ) &&\n                    ( obj.content.slider.vertical == 1 ) &&\n                    ( obj.content.slider.eqLoc == 0 ) &&\n                    ( obj.content.slider.discrete == 1 ) &&\n                    ( obj.content.slider.inverted == 1 )\">\n<md-slider-container><span>{{obj.name}}</span><md-input-container><input flex type=\"number\" \nng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" aria-label=\"red\" aria-controls=\"red-slider\"></md-input-container>\n<md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmd-vertical md-discrete md-invert min=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" \nstep=\"{{obj.content.slider.step}}\" flex aria-label=\"slider\" id=\"slider_{{obj.itemid}}\" \nstyle=\"height: {{obj.content.height}}px\" ;></md-slider></md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 1 ) &&\n                    ( obj.content.slider.vertical == 1 ) &&\n                    ( obj.content.slider.eqLoc == 1 ) &&\n                    ( obj.content.slider.discrete == 0 ) &&\n                    ( obj.content.slider.inverted == 0 )\">\n<md-slider-container><span>{{obj.name}}</span><md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmd-vertical min=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" flex aria-label=\"slider\" \nid=\"slider_{{obj.itemid}}\" style=\"height: {{obj.content.height}}px\" ;></md-slider><md-input-container><input flex \ntype=\"number\" ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" aria-label=\"red\" aria-controls=\"red-slider\">\n</md-input-container></md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 1 ) &&\n                    ( obj.content.slider.vertical == 1 ) &&\n                    ( obj.content.slider.eqLoc == 1 ) &&\n                    ( obj.content.slider.discrete == 0 ) &&\n                    ( obj.content.slider.inverted == 1 )\">\n<md-slider-container><span>{{obj.name}}</span><md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmd-vertical md-invert min=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" flex aria-label=\"slider\" \nid=\"slider_{{obj.itemid}}\" style=\"height: {{obj.content.height}}px\" ;></md-slider><md-input-container><input flex \ntype=\"number\" ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" aria-label=\"red\" aria-controls=\"red-slider\">\n</md-input-container></md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 1 ) &&\n                    ( obj.content.slider.vertical == 1 ) &&\n                    ( obj.content.slider.eqLoc == 1 ) &&\n                    ( obj.content.slider.discrete == 1 ) &&\n                    ( obj.content.slider.inverted == 0 )\">\n<md-slider-container><span>{{obj.name}}</span><md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmd-vertical md-discrete min=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" \nstep=\"{{obj.content.slider.step}}\" flex aria-label=\"slider\" id=\"slider_{{obj.itemid}}\" \nstyle=\"height: {{obj.content.height}}px\" ;></md-slider><md-input-container><input flex type=\"number\" \nng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" aria-label=\"red\" aria-controls=\"red-slider\"></md-input-container>\n</md-slider-container></div><div \nng-if=\"( obj.content.eqType == \'slider\' ) &&\n                    ( obj.content.slider.showEq == 1 ) &&\n                    ( obj.content.slider.vertical == 1 ) &&\n                    ( obj.content.slider.eqLoc == 1 ) &&\n                    ( obj.content.slider.discrete == 1 ) &&\n                    ( obj.content.slider.inverted == 1 )\">\n<md-slider-container><span>{{obj.name}}</span><md-slider ng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" \nng-mouseup=\"obj.content.Equation.newEquation = obj.name+\'=\'+obj.content.Equation.Solution_real[\'0-0\']+\' \'+obj.content.slider.units; \n                                   obj.content.needsUpdateFlag=1; \n                                   vm.runEquationDigest()\" \nmd-vertical md-discrete md-invert min=\"{{obj.content.slider.min}}\" max=\"{{obj.content.slider.max}}\" \nstep=\"{{obj.content.slider.step}}\" flex aria-label=\"slider\" id=\"slider_{{obj.itemid}}\" \nstyle=\"height: {{obj.content.height}}px\" ;></md-slider><md-input-container><input flex type=\"number\" \nng-model=\"obj.content.Equation.Solution_real[\'0-0\']\" aria-label=\"red\" aria-controls=\"red-slider\"></md-input-container>\n</md-slider-container></div>");
$templateCache.put("app/main/apps/document/worksheet/views/forLoop.html","<div id=\"{{obj.itemid}}\" class=\"switchWrapper worksheetItem\" ng-mouseover=\"obj.content.showIcons=true;\" \nng-mouseout=\"obj.content.showIcons=false\" \nng-if=\"obj.order>=vm.cadwolf_fileInfo.item_data.showStartLoc&&\n                obj.order<=vm.cadwolf_fileInfo.item_data.showEndLoc&&\n                vm.cadwolf_fileInfo.showForLoops\" \nng-class=\"obj.content.showClass\"><div class=\"icon_wrapper\" ng-if=\"vm.editPerm\" ng-show=\"obj.content.showIcons\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/iconHolder.tmpl.html\'\"></div><div \nng-click=\"vm.setCurrent(obj)\"><for-loop-object struct=\"{{obj.itemid}}\" worksheet=\"vm.cadwolf_worksheet\" \neditperm=\"vm.editPerm\" add-statement=\"vm.addStatement\" add-block=\"vm.addBlock\" delete-statement=\"vm.deleteStatement\" \nrun-equation-digest=\"vm.runEquationDigest\" updateme=\"updateme\"></for-loop-object></div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/forumComments.tmpl.html","");
$templateCache.put("app/main/apps/document/worksheet/views/freeBodyDiagram.html","<div id=\"{{obj.itemid}}\" class=\"switchWrapper worksheetItem\" ng-mouseover=\"obj.content.showIcons=true;\" \nng-mouseout=\"obj.content.showIcons=false\" \nng-if=\"obj.order>=vm.cadwolf_fileInfo.item_data.showStartLoc&&\n			obj.order<=vm.cadwolf_fileInfo.item_data.showEndLoc&&\n			vm.cadwolf_fileInfo.showFreeBodyDiagrams\" \nng-class=\"obj.content.showClass\" ng-click=\"vm.setCurrent(obj)\"><div class=\"icon_wrapper\" ng-if=\"vm.editPerm\" \nng-show=\"obj.content.showIcons\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/iconHolder.tmpl.html\'\">\n</div><canvas id=\"canvas{{obj.itemid}}\" height=\"{{obj.content.height}}\" width=\"{{obj.content.width}}\" \nclass=\"fbd_holder\" ng-style=\"{height:obj.content.height, width:obj.content.width}\"></canvas><span \nng-include=\"\'app/main/apps/document/worksheet/views/templates/refNum.html\'\"></span></div>");
$templateCache.put("app/main/apps/document/worksheet/views/header.html","<div id=\"{{obj.itemid}}\" class=\"switchWrapper worksheetItem\" ng-mouseover=\"obj.content.showIcons=true;\" \nng-mouseout=\"obj.content.showIcons=false\" \nng-if=\"obj.order>=vm.cadwolf_fileInfo.item_data.showStartLoc&&\n            obj.order<=vm.cadwolf_fileInfo.item_data.showEndLoc&&\n            vm.cadwolf_fileInfo.showHeaders\" \nng-class=\"obj.content.showClass\" ng-click=\"vm.setCurrent(obj)\"><div class=\"icon_wrapper\" ng-if=\"vm.editPerm\" \nng-show=\"obj.content.showIcons\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/iconHolder.tmpl.html\'\">\n</div><div ng-dblclick=\"vm.setCurrent(obj); obj.content.showEdit=true\" data-ng-bind-html=\"obj.content.text\" \nng-class=\"obj.content.hClass\"></div><md-input-container class=\"md-block\" flex=\"100\" ng-if=\"vm.editPerm\" \nng-show=\"obj.content.showEdit\"><label>Enter Header Text</label><input ng-model=\"obj.content.text\" \nng-enter=\"obj.content.showEdit=false\"></md-input-container></div>");
$templateCache.put("app/main/apps/document/worksheet/views/ifElse.html","<div id=\"{{obj.itemid}}\" class=\"switchWrapper worksheetItem\" ng-mouseover=\"obj.content.showIcons=true;\" \nng-mouseout=\"obj.content.showIcons=false\" \nng-if=\"obj.order>=vm.cadwolf_fileInfo.item_data.showStartLoc&&\n                obj.order<=vm.cadwolf_fileInfo.item_data.showEndLoc&&\n                vm.cadwolf_fileInfo.showIfElses\" \nng-class=\"obj.content.showClass\"><div class=\"icon_wrapper\" ng-if=\"vm.editPerm\" ng-show=\"obj.content.showIcons\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/iconHolder.tmpl.html\'\"></div><div \nng-click=\"vm.setCurrent(obj)\"><if-else-object struct=\"{{obj.itemid}}\" worksheet=\"vm.cadwolf_worksheet\" \neditperm=\"vm.editPerm\" add-statement=\"vm.addStatement\" add-block=\"vm.addBlock\" delete-statement=\"vm.deleteStatement\" \nrun-equation-digest=\"vm.runEquationDigest\" updateme=\"vm.updateme\"></if-else-object></div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/image.html","<div id=\"{{obj.itemid}}\" class=\"switchWrapper worksheetItem notCurrentItem\" ng-mouseover=\"obj.content.showIcons=true;\" \nng-mouseout=\"obj.content.showIcons=false\" ng-click=\"vm.setCurrent(obj)\" \nng-if=\"obj.order>=vm.cadwolf_fileInfo.item_data.showStartLoc&&\n            obj.order<=vm.cadwolf_fileInfo.item_data.showEndLoc&&\n            vm.cadwolf_fileInfo.showImages\" \nng-class=\"obj.content.showClass\" ng-click=\"vm.setCurrent(obj)\"><div class=\"icon_wrapper\" ng-if=\"vm.editPerm\" \nng-show=\"obj.content.showIcons\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/iconHolder.tmpl.html\'\">\n</div><div><div class=\"image\" ng-if=\"(!obj.content.isCAD) || (obj.content.isCAD===undefined)\"><img \nng-src=\"https://cadwolf.s3.amazonaws.com/{{obj.content.src}}\" width=\"{{obj.content.width}}\" \nheight=\"{{obj.content.height}}\"></div><div class=\"image\" ng-if=\"obj.content.isCAD\"><img ng-src=\"{{obj.content.src}}\" \nwidth=\"{{obj.content.width}}\" height=\"{{obj.content.height}}\"></div></div><span \nng-include=\"\'app/main/apps/document/worksheet/views/templates/refNum.html\'\"></span></div>");
$templateCache.put("app/main/apps/document/worksheet/views/lineBreak.html","<div id=\"{{obj.itemid}}\" class=\"switchWrapper worksheetItem notCurrentItem\" ng-mouseover=\"obj.showIcons=true;\" \nng-mouseout=\"obj.showIcons=false\" \nng-if=\"obj.order>=vm.cadwolf_fileInfo.item_data.showStartLoc&&\n            obj.order<=vm.cadwolf_fileInfo.item_data.showEndLoc&&\n            vm.cadwolf_fileInfo.showLineBreaks\" \nng-class=\"obj.showClass\" ng-click=\"vm.setCurrent(obj)\"><div class=\"icon_wrapper\" ng-if=\"vm.editPerm\" \nng-show=\"obj.showIcons\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/iconHolder.tmpl.html\'\"></div><div\n ng-if=\"vm.editPerm\" class=\"lineBreakEdit\"></div><div ng-if=\"!vm.editPerm\" class=\"lineBreak\"></div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/plot.html","<div class=\"switchWrapper worksheetItemNoPadding\" ng-mouseover=\"obj.content.showIcons=true;\" \nng-mouseout=\"obj.content.showIcons=false\" \nng-if=\"obj.order>=vm.cadwolf_fileInfo.item_data.showStartLoc&&\n            obj.order<=vm.cadwolf_fileInfo.item_data.showEndLoc&&\n            vm.cadwolf_fileInfo.showPlots\" \nng-class=\"obj.content.showClass\" ng-click=\"vm.setCurrent(obj)\"><div class=\"icon_wrapper\" ng-if=\"vm.editPerm\" \nng-show=\"obj.content.showIcons\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/iconHolder.tmpl.html\'\">\n</div><div class=\"plot_block\"><div id=\"{{obj.itemid}}\" class=\"plot_holder\" \nng-style=\"{height:obj.content.Chart_height, width:obj.content.Chart_width}\"><span plot-bind=\"obj\"></span></div></div>\n<span ng-include=\"\'app/main/apps/document/worksheet/views/templates/refNum.html\'\"></span></div>");
$templateCache.put("app/main/apps/document/worksheet/views/requirement.html","<div id=\"{{obj.itemid}}\" class=\"switchWrapper worksheetItem\" ng-mouseover=\"obj.content.showIcons=true;\" \nng-mouseout=\"obj.content.showIcons=false\" \nng-if=\"obj.order>=vm.cadwolf_fileInfo.item_data.showStartLoc&&\n			obj.order<=vm.cadwolf_fileInfo.item_data.showEndLoc&&\n			vm.cadwolf_fileInfo.showRequirements\" \nng-class=\"obj.content.showClass\" ng-click=\"vm.setCurrent(obj)\"><div class=\"icon_wrapper\" ng-if=\"vm.editPerm\" \nng-show=\"obj.content.showIcons\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/iconHolder.tmpl.html\'\">\n</div><div ng-dblclick=\"vm.setCurrent(obj); obj.content.showEdit=true\" class=\"reqBody\"><div class=\"reqTitle\">\n{{obj.content.title}}</div><div class=\"reqText\" data-ng-bind-html=\"obj.content.text\"></div><md-input-container \nclass=\"md-block\" flex=\"100\" ng-if=\"vm.editPerm\" ng-show=\"obj.content.showEdit\"><label>Requirement Title</label><input \nng-model=\"obj.content.title\" ng-enter=\"obj.content.showEdit=false\"></md-input-container><text-angular \nng-if=\"vm.editPerm\" ng-show=\"obj.content.showEdit\" ng-model=\"obj.content.text\" ng-enter=\"obj.content.showEdit=false\">\n</text-angular></div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/symbolic.html","<div id=\"{{obj.itemid}}\" class=\"switchWrapper worksheetItem textCentered\" ng-mouseover=\"obj.content.showIcons=true;\" \nng-mouseout=\"obj.content.showIcons=false\" \nng-if=\"obj.order>=vm.cadwolf_fileInfo.item_data.showStartLoc&&\n            obj.order<=vm.cadwolf_fileInfo.item_data.showEndLoc&&\n            vm.cadwolf_fileInfo.showSymbolics\" \nng-class=\"obj.content.showClass\" ng-click=\"vm.setCurrent(obj)\"><div class=\"icon_wrapper\" ng-if=\"vm.editPerm\" \nng-show=\"obj.content.showIcons\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/iconHolder.tmpl.html\'\">\n</div><div><div ng-dblclick=\"vm.setCurrent(obj); obj.content.showEdit=true\"><span mathjax-bind=\"obj.content.text\">\n</span></div><md-input-container class=\"md-block\" flex=\"100\" ng-if=\"vm.editPerm\" ng-show=\"obj.content.showEdit\"><label>\nEnter Latex here</label><input ng-model=\"obj.content.text\" ng-enter=\"obj.content.showEdit=false\"></md-input-container>\n</div><span ng-include=\"\'app/main/apps/document/worksheet/views/templates/refNum.html\'\"></span></div>");
$templateCache.put("app/main/apps/document/worksheet/views/table.html","<div id=\"{{obj.itemid}}\" class=\"switchWrapper worksheetItemNoPadding\" ng-mouseover=\"obj.content.showIcons=true;\" \nng-mouseout=\"obj.content.showIcons=false\" ng-click=\"vm.setCurrent(obj)\" \nng-if=\"obj.order>=vm.cadwolf_fileInfo.item_data.showStartLoc&&\n            obj.order<=vm.cadwolf_fileInfo.item_data.showEndLoc&&\n            vm.cadwolf_fileInfo.showTables\" \nng-class=\"obj.content.showClass\" ng-click=\"vm.setCurrent(obj)\"><div class=\"icon_wrapper\" ng-if=\"vm.editPerm\" \nng-show=\"obj.content.showIcons\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/iconHolder.tmpl.html\'\">\n</div><span table-object=\"obj\"></span> <span \nng-include=\"\'app/main/apps/document/worksheet/views/templates/refNum.html\'\"></span></div>");
$templateCache.put("app/main/apps/document/worksheet/views/text.html","<div id=\"{{obj.itemid}}\" class=\"switchWrapper worksheetItem\" ng-mouseover=\"obj.content.showIcons=true;\" \nng-mouseout=\"obj.content.showIcons=false\" \nng-if=\"obj.order>=vm.cadwolf_fileInfo.item_data.showStartLoc&&\n            obj.order<=vm.cadwolf_fileInfo.item_data.showEndLoc&&\n            vm.cadwolf_fileInfo.showText\" \nng-class=\"obj.content.showClass\" ng-click=\"vm.setCurrent(obj)\"><div class=\"icon_wrapper\" ng-if=\"vm.editPerm\" \nng-show=\"obj.content.showIcons\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/iconHolder.tmpl.html\'\">\n</div><div ng-if=\"!obj.content.showEdit && vm.editPerm\" ng-dblclick=\"vm.setCurrent(obj); obj.content.showEdit=true\" \ndata-ng-bind-html=\"obj.content.text\"></div><text-angular ng-model=\"obj.content.text\" ng-if=\"obj.content.showEdit\">\n</text-angular><div ng-if=\"!obj.content.showEdit && !vm.editPerm\" data-ng-bind-html=\"obj.content.text\"></div><span \nng-include=\"\'app/main/apps/document/worksheet/views/templates/refNum.html\'\"></span></div>");
$templateCache.put("app/main/apps/document/worksheet/views/threeDPlot.html","<div class=\"switchWrapper worksheetItemNoPadding\" ng-mouseover=\"obj.content.showIcons=true;\" \nng-mouseout=\"obj.content.showIcons=false\" \nng-if=\"obj.order>=vm.cadwolf_fileInfo.item_data.showStartLoc&&\n            obj.order<=vm.cadwolf_fileInfo.item_data.showEndLoc&&\n            vm.cadwolf_fileInfo.showCharts\" \nng-class=\"obj.content.showClass\" ng-click=\"vm.setCurrent(obj)\"><div class=\"icon_wrapper\" ng-if=\"vm.editPerm\" \nng-show=\"obj.content.showIcons\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/iconHolder.tmpl.html\'\">\n</div><div class=\"surface_block\"><div class=\"plot_holder\"><div id=\"{{obj.itemid}}\" style=\"float:left; overflow:auto;}\">\n</div><div class=\"Legend_Wrapper\" ng-show=\"obj.content.Surface.Props.Legend.onOff==\'1\'\"><div class=\"Legend\" \nng-if=\"obj.content.Surface.Props.Legend.onOff==\'1\'&&obj.content.Surface.Props.divideColormap==\'0\'\" \nid=\"{{obj.itemid}}Legend\"></div><div \nng-show=\"obj.content.Surface.Props.Legend.onOff==\'1\'&&obj.content.Surface.Props.divideColormap==\'0\'\" \nid=\"{{subObj.content.Surface.Format_id}}LegendTicks\" class=\"LegendTicks\"><div \nng-repeat=\"thisTick in obj.content.Legend.tickNumbers track by $index\"><div ng-if=\"( !$first ) && ( !$last )\" \nclass=\"legendTick\" style=\"width:{{obj.content.Legend.tickWidth}}px\">{{thisTick}}</div><div ng-if=\"$first\" \nclass=\"legendTickFirst\" style=\"width:{{obj.content.Legend.tickWidth}}px\">{{thisTick}}</div><div ng-if=\"$last\" \nclass=\"legendTickLast\" style=\"width:{{obj.content.Legend.tickWidth}}px\">{{thisTick}}</div></div></div><div \nng-repeat=\"subObj in obj.content.Surface.Chart_dataobj track by subObj.Format_id\"><div \nng-if=\"subObj.legendOnOff==\'1\'&&obj.content.Surface.Props.divideColormap==\'1\'\" id=\"{{subObj.Surface.Format_id}}Legend\">\n</div><div class=\"LegendTicks\" ng-show=\"subObj.legendOnOff==\'1\'&&obj.content.Surface.Props.divideColormap==\'1\'\" \nid=\"{{subObj.Surface.Format_id}}LegendTicks\"><div class=\"Legend_Tick\" \nng-repeat=\"thisTick in obj.content.Legend.tickNumbers track by $index\" \nstyle=\"width:{{obj.content.Legend.tickWidth}}px\">{{thisTick}}</div></div></div></div><surface-bind \nthissurface=\"obj.content.Surface\"></surface-bind></div></div><span \nng-include=\"\'app/main/apps/document/worksheet/views/templates/refNum.html\'\"></span></div>");
$templateCache.put("app/main/apps/document/worksheet/views/video.html","<div id=\"{{obj.itemid}}\" class=\"switchWrapper worksheetItem notCurrentItem\" ng-mouseover=\"obj.content.showIcons=true;\" \nng-mouseout=\"obj.content.showIcons=false\" \nng-if=\"obj.order>=vm.cadwolf_fileInfo.item_data.showStartLoc&&\n            obj.order<=vm.cadwolf_fileInfo.item_data.showEndLoc&&\n            vm.cadwolf_fileInfo.showVideos\" \nng-class=\"obj.content.showClass\" ng-click=\"vm.setCurrent(obj)\"><div class=\"icon_wrapper\" ng-if=\"vm.editPerm\" \nng-show=\"obj.content.showIcons\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/iconHolder.tmpl.html\'\">\n</div><div><iframe width=\"{{obj.content.videoWidth}}\" height=\"{{obj.content.videoHeight}}\" src=\"{{obj.content.url}}\" \nframeborder=\"0\" allowfullscreen></iframe></div><span \nng-include=\"\'app/main/apps/document/worksheet/views/templates/refNum.html\'\"></span></div>");
$templateCache.put("app/main/apps/document/worksheet/views/whileLoop.html","<div id=\"{{obj.itemid}}\" class=\"switchWrapper worksheetItem\" ng-mouseover=\"obj.content.showIcons=true;\" \nng-mouseout=\"obj.content.showIcons=false\" \nng-if=\"obj.order>=vm.cadwolf_fileInfo.item_data.showStartLoc&&\n                obj.order<=vm.cadwolf_fileInfo.item_data.showEndLoc&&\n                vm.cadwolf_fileInfo.showWhileLoops\" \nng-class=\"obj.content.showClass\"><div class=\"icon_wrapper\" ng-if=\"vm.editPerm\" ng-show=\"obj.content.showIcons\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/iconHolder.tmpl.html\'\"></div><div \nng-click=\"vm.setCurrent(obj)\"><while-loop-object struct=\"{{obj.itemid}}\" worksheet=\"vm.cadwolf_worksheet\" \neditperm=\"vm.editPerm\" add-statement=\"vm.addStatement\" add-block=\"vm.addBlock\" delete-statement=\"vm.deleteStatement\" \nrun-equation-digest=\"vm.runEquationDigest\" updateme=\"vm.updateme\"></while-loop-object></div></div>");
$templateCache.put("app/main/apps/forum/views/dialogs/newForum.html","<md-dialog class=\"new-forum-dialog\" aria-label=\"New Forum Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">\nCreate a new Discussion / Forum</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" \naria-label=\"close dialog\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"errorText\" ng-if=\"vm.titleProblem\">\nTitles can only contain letters, numbers, and spaces. It cannot contain underscores, questions marks, or similar items\n</div><md-input-container class=\"md-block\" flex=\"100\"><label>Title of Discussion</label><input \nng-change=\"vm.checkTitle()\" ng-model=\"vm.forumTitle\"></md-input-container><text-angular ng-model=\"vm.forumText\">\n</text-angular></md-dialog-content><md-dialog-actions><md-button class=\"md-accent md-raised\" ng-click=\"vm.cancel()\" \ntype=\"submit\" aria-label=\"Cancel\"><span>Cancel</span></md-button><md-button class=\"md-accent md-raised\" \nng-click=\"vm.hide()\" type=\"submit\" ng-if=\"!vm.titleProblem\" aria-label=\"Create Discussion\"><span>Create Discussion\n</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/partTree/setup/views/treeStructure.html","<div class=\"md-title\">Tree Structure</div><div layout=\"row\" layout-fill flex=\"100\"><div layout=\"column\" layout-fill \nflex=\"20\"><div layout=\"column\" layout-fill flex=\"100\" \nng-repeat=\"obj in vm.partTree.treeStructure | orderBy:\'orderNumber\' track by obj.title\" \nng-click=\"vm.setActive( obj.orderNumber )\"><div layout=\"row\" layout-fill layout-align=\"center center\" flex=\"100\"><div \nclass=\"treeBlockActive\" ng-if=\"obj.active==\'true\'\">{{obj.title}}</div><div class=\"treeBlock\" \nng-if=\"obj.active==\'false\'\">{{obj.title}}</div></div><div layout=\"row\" layout-fill flex=\"100\" ng-if=\"!$last\"><md-icon \nng-if=\"!$last\" md-font-icon=\"icon-dots-vertical\" aria-label=\"\"></md-icon></div></div></div><div layout=\"column\" \nlayout-fill flex=\"80\"><div layout=\"column\" layout-fill layout-margin flex=\"100\" \nng-repeat=\"obj in vm.partTree.treeStructure | orderBy:\'orderNumber\' track by obj.title\" ng-if=\"obj.active==\'true\'\"><div\n layout=\"row\" layout-fill flex=\"100\"><div flex-offset=\"80\" \nng-click=\"vm.showModal($event, vm.partTree.treeStructure, \'editTreeSection\')\" ng-if=\"!$last\" \nclass=\"pointerItem blueText\">Edit</div></div><div layout=\"row\" flex=\"100\" layout-fill><div class=\"md-subhead\" \nflex=\"30\">Title</div><div class=\"md-body-1\" flex=\"70\">{{obj.title}}</div></div><div layout=\"row\" class=\"md-body-2\" \nflex=\"100\" layout-fill>Description</div><div layout=\"row\" flex=\"100\" layout-fill data-ng-bind-html=\"obj.description\">\n</div><div layout=\"row\" flex=\"100\" layout-fill><div class=\"md-subhead\" flex=\"100\" layout-fill>Options</div></div><div \nng-repeat=\"option in obj.options\" layout=\"column\" layout-fill><div class=\"md-body-2\">{{option.name}}</div></div><div \nlayout=\"row\" flex=\"100\" ng-if=\"obj.options.length==0 && !$last\" layout-fill>There are no options yet for this item\n</div></div></div></div>");
$templateCache.put("app/main/apps/profile/tabs/about/about.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"65\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \ntranslate=\"PROFILE.GENERAL_INFORMATION\">General Information</div></header><div class=\"content\"><div class=\"info-line\">\n<div class=\"title\" translate=\"PROFILE.GENDER\">Gender</div><div class=\"info\">{{vm.about.general.gender}}</div></div><div\n class=\"info-line\"><div class=\"title\" translate=\"PROFILE.BIRTHDAY\">Birthday</div><div class=\"info\">\n{{vm.about.general.birthday}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.LOCATIONS\">\nLocations</div><div class=\"info location\" ng-repeat=\"location in vm.about.general.locations\"><span>{{location}}</span>\n<md-icon md-font-icon=\"icon-map-marker\" class=\"s16\"></md-icon></div></div><div class=\"info-line\"><div class=\"title\" \ntranslate=\"PROFILE.ABOUT_ME\">About Me</div><div class=\"info\">{{vm.about.general.about}}</div></div></div></div><div \nclass=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \ntranslate=\"PROFILE.WORK\">Work</div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\" \ntranslate=\"PROFILE.OCCUPATION\">Occupation</div><div class=\"info\">{{vm.about.work.occupation}}</div></div><div \nclass=\"info-line\"><div class=\"title\" translate=\"PROFILE.SKILLS\">Skills</div><div class=\"info\">{{vm.about.work.skills}}\n</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.JOBS\">Jobs</div><table class=\"info jobs\"><tr \nclass=\"job\" ng-repeat=\"job in vm.about.work.jobs\"><td class=\"company\">{{job.company}}</td><td class=\"date\">{{job.date}}\n</td></tr></table></div></div></div><div class=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\"><header\n class=\"md-accent-bg\"><div class=\"title\" translate=\"PROFILE.CONTACT\">Contact</div></header><div class=\"content\"><div \nclass=\"info-line\"><div class=\"title\" translate=\"PROFILE.ADDRESS\">Address</div><div class=\"info\">\n{{vm.about.contact.address}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.TEL\">Tel.</div>\n<div class=\"info\" ng-repeat=\"tel in vm.about.contact.tel\"><span>{{tel}}</span></div></div><div class=\"info-line\"><div \nclass=\"title\" translate=\"PROFILE.WEBSITE\">Website</div><div class=\"info\" \nng-repeat=\"website in vm.about.contact.websites\"><span>{{website}}</span></div></div><div class=\"info-line\"><div \nclass=\"title\" translate=\"PROFILE.EMAILS\">Emails</div><div class=\"info\" ng-repeat=\"email in vm.about.contact.emails\">\n<span>{{email}}</span></div></div></div></div></div><div class=\"about-sidebar\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"35\"><div class=\"profile-box friends md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.FRIENDS\">\nFriends</div><div class=\"more secondary-text\"><span translate=\"PROFILE.SEE\">See</span> <span>454</span> <span \ntranslate=\"PROFILE.MORE\">More</span></div></header><div class=\"content\" layout=\"row\" layout-wrap><div class=\"friend\" \nflex=\"20\" ng-repeat=\"friend in vm.about.friends\"><img ng-src=\"{{friend.avatar}}\"></div></div></div><div \nclass=\"profile-box groups md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.JOINED_GROUPS\">Joined Groups</div><div \nclass=\"more secondary-text\"><span translate=\"PROFILE.SEE\">See</span> <span>6</span> <span translate=\"PROFILE.MORE\">More\n</span></div></header><div class=\"content\"><div class=\"group\" ng-repeat=\"group in vm.about.groups\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{group.logo}}\" \nclass=\"logo\" alt=\"{{group.name}}\"><div><div class=\"name\">{{group.name}}</div><div class=\"category\">{{group.category}}\n</div><div class=\"members\">{{group.members}} people</div></div></div><md-button class=\"md-icon-button\" \naria-label=\"more\" translate translate-attr-aria-label=\"PROFILE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button></div></div></div></div></div>");
$templateCache.put("app/main/apps/profile/tabs/photos-videos/photos-videos.html","<div class=\"photos-videos\"><div class=\"period\" data-ng-repeat=\"period in vm.photosVideos\"><div class=\"period-title\">\n<span class=\"name\">{{period.name}}</span> <span class=\"info\">{{period.info}}</span></div><div class=\"period-media\" \nlayout=\"row\" layout-wrap><div class=\"media\" ng-repeat=\"media in period.media\"><img class=\"preview\" \nng-src=\"{{media.preview}}\" title=\"{{media.title}}\"><div class=\"title\">{{media.title}}</div></div></div></div></div>");
$templateCache.put("app/main/apps/profile/tabs/timeline/timeline.html","<div layout=\"row\" layout-wrap><div class=\"timeline\" layout=\"column\" flex=\"100\" flex-gt-sm=\"55\" flex-gt-md=\"65\" \nflex-order=\"2\" flex-order-gt-sm=\"1\"><div class=\"profile-box add-post md-whiteframe-1dp\"><div class=\"form\" flex>\n<textarea placeholder=\"Write something..\" translate translate-attr-placeholder=\"PROFILE.WRITE_SOMETHING\"></textarea>\n<footer layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" aria-label=\"insert photo\" translate translate-attr-aria-label=\"PROFILE.INSERT_PHOTO\"><md-icon \nmd-font-icon=\"icon-file-image-box\"></md-icon><md-tooltip><span translate=\"PROFILE.INSERT_PHOTO\">insert photo</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"add person\" translate \ntranslate-attr-aria-label=\"PROFILE.ADD_PERSON\"><md-icon md-font-icon=\"icon-person-plus\"></md-icon><md-tooltip><span \ntranslate=\"PROFILE.ADD_PERSON\">add person</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \naria-label=\"add location\" translate translate-attr-aria-label=\"PROFILE.LOCATION\"><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><md-tooltip><span translate=\"PROFILE.LOCATION\">add location</span>\n</md-tooltip></md-button></div><md-button ng-click=\"\" class=\"post-button md-accent md-raised\" aria-label=\"POST\" \ntranslate=\"PROFILE.POST\" translate-attr-aria-label=\"PROFILE.POST\">POST</md-button></footer></div></div><md-divider>\n</md-divider><div class=\"timeline-item md-whiteframe-1dp\" ng-repeat=\"post in vm.posts\"><header layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"user\" layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" \nng-src=\"{{post.user.avatar}}\"><div layout=\"column\"><div class=\"title\"><span class=\"username md-accent-color\">\n{{post.user.name}}</span> <span ng-if=\"post.type == \'post\'\" translate=\"PROFILE.TYPE_POST\">posted on your timeline\n</span> <span ng-if=\"post.type == \'something\'\" translate=\"PROFILE.TYPE_SOMETHING\">shared something with you</span> \n<span ng-if=\"post.type == \'video\'\" translate=\"PROFILE.TYPE_VIDEO\">shared a video with you</span> <span \nng-if=\"post.type == \'article\'\" translate=\"PROFILE.TYPE_ARTICLE\">shared an article with you</span></div><div \nclass=\"time\">{{post.time}}</div></div></div><md-button class=\"md-icon-button\" aria-label=\"more\" translate \ntranslate-attr-aria-label=\"PROFILE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></header><div\n class=\"content\"><div ng-if=\"post.message\" class=\"message\">{{post.message}}</div><div ng-if=\"post.media\" class=\"media\">\n<img ng-if=\"post.media.type === \'image\'\" ng-src=\"{{post.media.preview}}\"><div ng-if=\"post.media.type === \'video\'\" \nng-bind-html=\"post.media.embed | toTrusted\"></div></div><div ng-if=\"post.article\" layout=\"column\" class=\"article\"><div \nclass=\"media\"><img ng-src=\"{{post.article.media.preview}}\"></div><div class=\"title\">{{post.article.title}}</div><div \nclass=\"subtitle\">{{post.article.subtitle}}</div><div class=\"excerpt\">{{post.article.excerpt}}</div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"like-button\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-heart-outline\" class=\"s16\"></md-icon><span translate=\"PROFILE.LIKE\">Like</span>&nbsp;<span>\n({{post.like}})</span></div></md-button><md-button class=\"share-button\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-share\" class=\"s16\"></md-icon><span translate=\"PROFILE.SHARE\">Share</span>&nbsp;<span>\n({{post.share}})</span></div></md-button></div></div><footer class=\"\" layout=\"column\" layout-align=\"start start\"><div \nng-if=\"post.comments\" class=\"comment-count\">{{post.comments.length}} comments<md-icon \nmd-font-icon=\"icon-keyboard_arrow_down\"></md-icon></div><div class=\"comment\" layout=\"row\" layout-fill \nng-repeat=\"comment in post.comments\"><img ng-src=\"{{comment.user.avatar}}\" class=\"avatar\"><div flex layout=\"column\">\n<div layout=\"row\" layout-align=\"start center\"><span class=\"username\">{{comment.user.name}}</span> <span class=\"time\">\n{{comment.time}}</span></div><div class=\"message\">{{comment.message}}</div><div class=\"actions\" layout=\"row\" \nlayout-align=\"space-between center\"><a href=\"#\" class=\"reply-button md-accent-color\" translate=\"PROFILE.REPLY\">Reply\n</a><md-icon flex md-font-icon=\"icon-flag\" class=\"report-button s16\"></md-icon></div></div></div><div class=\"reply\" \nlayout=\"row\" layout-fill><img src=\"assets/images/avatars/profile.jpg\" class=\"avatar\"><form flex><textarea \nplaceholder=\"Add a comment...\" translate translate-attr-placeholder=\"PROFILE.ADD_COMMENT\"></textarea><md-button \nng-click=\"\" class=\"post-comment-button md-accent md-raised\" aria-label=\"Post Comment\" translate=\"PROFILE.POST_COMMENT\" \ntranslate-aria-label=\"PROFILE.POST_COMMENT\">Post Comment</md-button></form></div></footer></div></div><div \nclass=\"timeline-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"45\" flex-gt-md=\"35\" flex-order=\"1\" \nflex-order-gt-sm=\"2\"><div class=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" \ntranslate=\"PROFILE.LATEST_ACTIVITY\">Latest Activity</div><div class=\"more secondary-text\" translate=\"PROFILE.SEE_ALL\">\nSee All</div></header><div class=\"content\" layout=\"row\" layout-wrap><div class=\"activities\"><div class=\"activity\" \nlayout=\"row\" layout-align=\"start start\" ng-repeat=\"activity in vm.activities\"><img ng-src=\"{{activity.user.avatar}}\" \nclass=\"avatar\" alt=\"{{activity.user.name}}\"><div layout=\"column\"><div><span class=\"username md-accent-color\">\n{{activity.user.name}}</span> <span class=\"message\">{{activity.message}}</span></div><span class=\"time secondary-text\">\n{{activity.time}}</span></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/profile/views/dialog/largeModalTemplates.tmpl.html","<md-dialog class=\"large-dialog\" aria-label=\"Change File Properties\"><form name=\"contactForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between\"><span class=\"title\" ng-if=\"vm.modalType==\'User Profile\'\">Edit Bio Properties\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" flex=\"100\" layout-fill><div layout=\"column\" flex=\"20\"><div \nlayout=\"column\" flex=\"100\" layout-fill><md-list><md-list-item ng-click=\"vm.editItem=\'gender\'; vm.editType=\'1\'\">Gender\n</md-list-item><md-divider></md-divider><md-list-item ng-click=\"vm.editItem=\'addresses\'; vm.editType=\'1\'\">Address\n</md-list-item><md-divider></md-divider><md-list-item ng-click=\"vm.editItem=\'age\'; vm.editType=\'1\'\">Age</md-list-item>\n<md-divider></md-divider><md-list-item ng-click=\"vm.editItem=\'telephones\'; vm.editType=\'2\'\">Telephone Numbers\n</md-list-item><md-divider></md-divider><md-list-item ng-click=\"vm.editItem=\'websites\'; vm.editType=\'2\'\">Websites\n</md-list-item><md-divider></md-divider><md-list-item ng-click=\"vm.editItem=\'emails\'; vm.editType=\'2\'\">Emails\n</md-list-item><md-divider></md-divider><md-list-item ng-click=\"vm.editItem=\'locations\'; vm.editType=\'2\'\">Locations\n</md-list-item><md-divider></md-divider><md-list-item ng-click=\"vm.editItem=\'about\'; vm.editType=\'3\'\">About Me\n</md-list-item><md-divider></md-divider><md-list-item ng-click=\"vm.editItem=\'occupation\'; vm.editType=\'3\'\">Occupation\n</md-list-item><md-divider></md-divider><md-list-item ng-click=\"vm.editItem=\'skills\'; vm.editType=\'3\'\">Skills\n</md-list-item><md-divider></md-divider><md-list-item ng-click=\"vm.editItem=\'jobs\'; vm.editType=\'3\'\">Jobs\n</md-list-item></md-list></div></div><div layout=\"column\" flex=\"75\" flex-offset=\"5\"><div layout=\"column\" layout-fill \nlayout-margin ng-if=\"vm.editType==\'1\'\"><div class=\"md-display-1\">Edit {{vm.editItem}}</div><div class=\"md-body-1\">\nIn the area below, you can edit the property selected. HTML items such as links and text formatting are allowed where appropriate.\n</div><div layout=\"row\" layout-fill><md-input-container class=\"md-block\" flex=\"70\" flex-offset=\"15\"><input \nng-model=\"vm.profileData.user_info[vm.editItem]\"></md-input-container></div></div><div layout=\"column\" layout-fill \nlayout-margin ng-if=\"vm.editType==\'2\'\"><div class=\"md-display-1\">Edit {{vm.editItem}}</div><div class=\"md-body-1\">\nIn the area below, you can add items to the array that you are editing and then edit the title and contents of those items.\n</div><div layout-fill layout=\"column\" class=\"editBioBlock\"><div class=\"editBioToolbar\"><div class=\"md-toolbar-tools\">\n<button ng-click=\"vm.profileData.user_info[vm.editItem].push({\'itemTitle\':\'New Item\', \'itemText\':\'Item Description\'})\">\nAdd Item<md-icon md-font-icon=\"icon-plus\" aria-label=\"Add Item\"></md-icon></button></div></div><div layout=\"row\" \nlayout-fill><div flex=\"25\"><md-list><md-list-item ng-repeat=\"thisItem in vm.profileData.user_info[vm.editItem]\" \nng-click=\"vm.currentEditItem=thisItem\"><md-input-container ng-click=\"vm.currentEditItem=thisItem\"><input \nng-model=\"thisItem.itemTitle\"></md-input-container></md-list-item></md-list></div><div flex=\"70\" flex-offset=\"5\">\n<text-angular ng-model=\"vm.currentEditItem.itemText\"></text-angular></div></div></div></div><div layout=\"column\" \nlayout-fill layout-margin ng-if=\"vm.editType==\'3\'\"><div class=\"md-display-1\">Edit {{vm.editItem}}</div><div \nclass=\"md-body-1\">\nIn the area below, you can edit the property selected. HTML items such as links and text formatting are allowed where appropriate.\n</div><text-angular ng-model=\"vm.profileData.user_info[vm.editItem]\"></text-angular></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.acceptChanges(vm.editItem); vm.cancel();\" \nclass=\"send-button md-accent md-raised\">ACCEPT EDIT</md-button><md-button type=\"submit\" ng-click=\"vm.cancel();\" \nclass=\"send-button md-accent md-raised\">CANCEL EDIT</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/profile/views/dialog/mediumModalTemplates.tmpl.html","<md-dialog class=\"medium-dialog\" aria-label=\"Change File Properties\"><form name=\"contactForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between\"><span class=\"title\" ng-if=\"vm.modalType==\'Edit Description\'\">Description\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-label-outline\" \nng-if=\"vm.modalType==\'Edit Description\'\" class=\"md-avatar avatar contact-avatar huge\"></md-icon><div \nclass=\"contact-name\" ng-if=\"vm.modalType==\'Edit Description\'\">{{vm.thisItem.name}}</div></div></div></md-toolbar><div \nng-if=\"vm.modalType==\'Edit Description\'\" ng-include=\"\'app/main/apps/dataset/views/editDescription.tmpl.html\'\"></div>\n</form></md-dialog>");
$templateCache.put("app/main/apps/profile/views/dialog/smallModalTemplates.tmpl.html","<md-dialog class=\"contact-dialog\" aria-label=\"Change File Properties\"><form name=\"contactForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between\"><span class=\"title\" ng-if=\"vm.modalType==\'User Profile\'\">User Profile</span> \n<span class=\"title\" ng-if=\"vm.modalType==\'Change Username\'\">Change Username</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-account\" ng-if=\"vm.modalType==\'User Profile\'\" class=\"md-avatar avatar contact-avatar huge\">\n</md-icon><md-icon md-font-icon=\"icon-account\" ng-if=\"vm.modalType==\'Change Username\'\" \nclass=\"md-avatar avatar contact-avatar huge\"></md-icon><md-icon md-font-icon=\"icon-information-outline\" \nng-if=\"vm.modalType==\'Information\'\" class=\"md-avatar avatar contact-avatar huge\"></md-icon><div class=\"contact-name\" \nng-if=\"vm.modalType==\'User Profile\'\">{{vm.thisItem.name}}</div><div class=\"contact-name\" \nng-if=\"vm.modalType==\'Change Username\'\">{{vm.thisItem.username}}</div><div class=\"contact-name\" \nng-if=\"vm.modalType==\'Information\'\">Info - {{vm.thisItem.name}}</div></div></div></md-toolbar><div \nng-if=\"vm.modalType==\'User Profile\'\" ng-include=\"\'app/main/apps/profile/views/list/dialog/userProfile.tmpl.html\'\">\n</div><div ng-if=\"vm.modalType==\'Change Username\'\" ng-include=\"\'app/main/apps/profile/views/changeUsername.tmpl.html\'\">\n</div><div ng-if=\"vm.modalType==\'Change Username\'\" \nng-include=\"\'app/main/apps/workspace/views/list/showInfo.tmpl.html\'\"></div></form></md-dialog>");
$templateCache.put("app/main/apps/profile/views/mailLists/draftList.html","<div flex=\"40\" class=\"borderRight\"><div ng-repeat=\"thisMess in vm.cadwolf_drafts\" \nclass=\"borderBottom paddingLeft20 paddingRight20\" ng-class=\"{\'selected\' : vm.thisMessage === thisMess }\" \nng-click=\"vm.thisMessage = thisMess;\" layout=\"column\"><div flex=\"100\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"marginTop20 marginBottom20\">Date Created</div><div>{{thisMess.created_at_date | date:\'short\'}}</div></div>\n<div flex=\"100\" class=\"md-body-1 marginBottom20 marginLeft20\">{{thisMess.content.title}}</div><div flex=\"100\" \nclass=\"md-body-1 marginBottom20 marginLeft20\">Recepients :</div><div layout=\"row\" \nclass=\"paddingLeft20 paddingRight20 paddingBottom20\"><div ng-repeat=\"thisUser in thisMess.userList\" \nng-dblclick=\"vm.removeRecepient( vm.thisMessage, thisUser )\" class=\"\"><img class=\"profile-image avatar\" \nng-src=\"{{thisUser.userData.photo_url}}\" on-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\">\n<md-tooltip md-direction=\"bottom\">{{thisUser.userData.name}}</md-tooltip></div></div><div layout=\"row\">\n<md-input-container class=\"md-block\" layout-fill><label>Member Name, User Name, or email</label><input \nname=\"memberName\" aria-label=\"Member Name\" type=\"text\" ng-model=\"vm.newMember\" ng-click=\"vm.checkStatus=\'\'\" \nng-enter=\"vm.checkMemberName( vm.newMember )\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.foundUser !== undefined\"><img class=\"profile-image avatar\" ng-src=\"{{vm.foundUser.photo_url}}\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"><div class=\"md-body-2 marginTop5 marginLeft5\">\n{{vm.foundUser.name}} - {{vm.foundUser.username}}</div><div ng-click=\"vm.addRecepient( thisMess, vm.foundUser );\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"bottom\">Add Recepient</md-tooltip></div></div>\n</div></div><div flex=\"50\" flex-offset=\"5\" ng-if=\"vm.thisMessage !== undefined && vm.thisMessage !=\'\'\"><div flex=\"100\" \nlayout=\"row\" layout-align=\"space-between center\" class=\"marginTop20 marginBottom20\"><md-button type=\"submit\" \nng-click=\"vm.sendMessage( vm.thisMessage );\" class=\"send-button md-accent md-raised\">Send Message</md-button><div \nclass=\"marginTop20\">{{vm.thisMessage.created_at_date | date:\'short\'}}</div></div><div flex=\"100\" layout=\"row\"><div \nlayout=\"row\" class=\"marginTop20 marginBottom20\" ng-repeat=\"thisRecep in vm.thisMessage.userData\"><img \nclass=\"profile-image avatar\" ng-src=\"{{vm.thisMessage.userData.photo_url}}\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"><div class=\"md-headline marginTop5 marginLeft5\">\n{{thisRecep.name}}</div></div></div><div flex=\"100\" class=\"md-body-2\"><md-input-container class=\"md-block\"><label>\nMessage Title</label><input ng-model=\"vm.thisMessage.content.title\" ng-enter=\"vm.updateMessage( vm.thisMessage )\">\n</md-input-container></div><text-angular ng-model=\"vm.thisMessage.content.messageText\" \nng-model-options=\"{ debounce: 1000 }\" ng-change=\"vm.updateMessage( vm.thisMessage )\"></text-angular></div><div \nflex=\"50\" flex-offset=\"5\" class=\"textCentered marginTop20 marginBottom20\" \nng-if=\"vm.thisMessage === undefined || vm.thisMessage ==\'\'\">Select a message to edit it</div>");
$templateCache.put("app/main/apps/profile/views/mailLists/receiveList.html","<div flex=\"40\" class=\"borderRight\"><div ng-repeat=\"thisMess in vm.cadwolf_messages\" \nclass=\"borderBottom paddingLeft20 paddingRight20\" ng-class=\"{\'selected\' : vm.thisMessage === thisMess }\" \nng-click=\"vm.thisMessage = thisMess;\" layout=\"column\"><div flex=\"100\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" class=\"marginTop20 marginBottom20\"><img class=\"profile-image avatar\" \nng-src=\"{{thisMess.userData.photo_url}}\" on-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"><div \nclass=\"md-body-2 marginTop5 marginLeft5\">{{thisMess.userData.name}}</div></div><div>\n{{thisMess.created_at_date | date:\'short\'}}</div></div><div flex=\"100\" class=\"md-body-1 marginBottom20 marginLeft20\">\n{{thisMess.messageData.content.title}}</div></div></div><div flex=\"50\" flex-offset=\"5\" \nng-if=\"vm.thisMessage !== undefined && vm.thisMessage !=\'\'\"><div flex=\"100\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" class=\"marginTop20 marginBottom20\"><img \nclass=\"profile-image avatar\" ng-src=\"{{vm.thisMessage.userData.photo_url}}\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"><div class=\"md-headline marginTop5 marginLeft5\">\n{{vm.thisMessage.userData.name}}</div></div><div class=\"marginTop20\">{{vm.thisMessage.sentDate | date:\'short\'}}</div>\n</div><div flex=\"100\" class=\"md-body-2\">{{vm.thisMessage.messageData.content.title}}</div><div \nng-bind-html=\"vm.thisMessage.messageData.content.messageText\"></div></div><div flex=\"50\" flex-offset=\"5\" \nclass=\"textCentered marginTop20 marginBottom20\" ng-if=\"vm.thisMessage === undefined  || vm.thisMessage ==\'\'\">\nSelect a message to view it</div>");
$templateCache.put("app/main/apps/profile/views/mailLists/sentList.html","<div flex=\"40\" class=\"borderRight\"><div ng-repeat=\"thisMess in vm.cadwolf_sent\" \nclass=\"borderBottom paddingLeft20 paddingRight20\" ng-class=\"{\'selected\' : vm.thisMessage === thisMess }\" \nng-click=\"vm.thisMessage = thisMess;\" layout=\"column\"><div flex=\"100\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"marginTop20 marginBottom20\">Date Sent</div><div>{{thisMess.sentDate | date:\'short\'}}</div></div><div \nflex=\"100\" class=\"md-body-1 marginBottom20 marginLeft20\">{{thisMess.content.title}}</div><div flex=\"100\" \nclass=\"md-body-1 marginBottom20 marginLeft20\">Recepients :</div><div layout=\"row\" \nclass=\"paddingLeft20 paddingRight20 paddingBottom20\"><div ng-repeat=\"thisUser in thisMess.userList\" class=\"\"><img \nclass=\"profile-image avatar\" ng-src=\"{{thisUser.userData.photo_url}}\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"><md-tooltip md-direction=\"bottom\">\n{{thisUser.userData.name}}</md-tooltip></div></div></div></div><div flex=\"50\" flex-offset=\"5\" \nng-if=\"vm.thisMessage !== undefined && vm.thisMessage !=\'\'\"><div flex=\"100\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" class=\"marginTop20 marginBottom20\"><div \nng-repeat=\"thisUser in vm.thisMessage.userData\" class=\"paddingLeft20 paddingRight20\"><img class=\"profile-image avatar\" \nng-src=\"{{thisUser.photo_url}}\" on-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"><div \nclass=\"md-body-2 marginTop5 marginLeft5\">{{thisUser.name}}</div></div></div><div class=\"marginTop20\">\n{{vm.thisMessage.created_at_date | date:\'short\'}}</div></div><div flex=\"100\" class=\"md-body-2\">\n{{vm.thisMessage.content.title}}</div><div ng-bind-html=\"vm.thisMessage.content.messageText\"></div></div><div \nflex=\"50\" flex-offset=\"5\" class=\"textCentered marginTop20 marginBottom20\" \nng-if=\"vm.thisMessage === undefined || vm.thisMessage ==\'\'\">Select a message to view it</div>");
$templateCache.put("app/main/apps/workflow/views/dialogs/event-dialog.html","<md-dialog class=\"workflow-edit-dialog\" aria-label=\"Event Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">Add or Edit Event</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-tabs md-dynamic-height><md-tab><md-tab-label><span translate=\"WORKFLOW.EDIT_SETTINGS\">Settings</span>\n</md-tab-label><md-tab-body><div \nng-if=\"vm.editPerm || parseInt(vm.thisEvent.user_id) == parseInt(Spark.state.user.id)\" \nng-include=\"\'app/main/apps/workflow/views/dialogs/event-settings-view.html\'\"></div><div \nng-if=\"!vm.editPerm &&  parseInt(vm.thisEvent.user_id) != Spark.state.user.id\" \nng-include=\"\'app/main/apps/workflow/views/showDialogs/event-settings-view.html\'\"></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"WORKFLOW.ASSIGN_EVENT\">Assign Event to Items</span></md-tab-label><md-tab-body><div \nng-if=\"vm.editPerm || parseInt(vm.thisEvent.user_id) == parseInt(Spark.state.user.id)\" \nng-include=\"\'app/main/apps/workflow/views/dialogs/event-rows-view.html\'\"></div><div \nng-if=\"!vm.editPerm && parseInt(vm.thisEvent.user_id) != Spark.state.user.id\" \nng-include=\"\'app/main/apps/workflow/views/showDialogs/event-rows-view.html\'\"></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"WORKFLOW.EVENT_SIGNOFF\">Event Signoffs</span></md-tab-label><md-tab-body><div \nng-if=\"vm.editPerm || parseInt(vm.thisEvent.user_id) == parseInt(Spark.state.user.id)\" \nng-include=\"\'app/main/apps/workflow/views/dialogs/event-signoffs-view.html\'\"></div><div \nng-if=\"!vm.editPerm && (parseInt(vm.thisEvent.user_id) != Spark.state.user.id)\" \nng-include=\"\'app/main/apps/workflow/views/showDialogs/event-signoffs-view.html\'\"></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"WORKFLOW.EVENT_NOTES\">Event Notes</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/apps/workflow/views/dialogs/event-notes-view.html\'\"></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.thisEvent.item_data.eventType != \'Signoff Activity\'\"><md-tab-label><span \ntranslate=\"WORKFLOW.EVENT_PARTICIPANTS\">Event Participants</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/apps/workflow/views/dialogs/event-participants-view.html\'\"></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.thisEvent.item_data.eventType == \'Signoff Activity\'\"><md-tab-label><span \ntranslate=\"WORKFLOW.EVENT_SIGNOFF_ACTIVITY\">Signoff Activity</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/apps/workflow/views/dialogs/event-signoff-activity-view.html\'\"></div></md-tab-body></md-tab>\n</md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/workflow/views/dialogs/event-notes-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\"><div layout=\"row\"><div \nlayout=\"column\" class=\"edit-item-left\"><div class=\"edit-item-select paddingBottom20\" layout=\"row\" \nng-if=\"vm.editPerm || vm.conditionalEdit\"><md-icon md-font-icon=\"icon-plus\" ng-click=\"vm.addEvent()\"><md-tooltip \nmd-direction=\"bottom\">Add New Event</md-tooltip></md-icon></div><div class=\"edit-item-select\" layout=\"row\" \nng-repeat=\"thisEvent in vm.cadwolf_fileInfo.events track by thisEvent.id\" \nng-click=\"vm.thisEvent = thisEvent;  vm.popEventItems();\" ng-class=\"{\'selected\' : vm.thisEvent === thisEvent}\"><div \nclass=\"edit-item-select-color\" ng-class=\"thisEvent.item_data.eventColor\"></div><div class=\"edit-item-select-title\" \nng-click=\"thisEvent.item_data.eventShowDelete=false\">{{thisEvent.item_data.eventTitle}}</div><div \nclass=\"edit-item-showdelete\" \nng-if=\"!thisEvent.item_data.eventShowDelete && (vm.editPerm || parseInt(vm.thisEvent.user_id)==Spark.state.user.id)\" \nng-click=\"thisEvent.item_data.eventShowDelete=!thisEvent.item_data.eventShowDelete\"><md-icon \nmd-font-icon=\"icon-close-circle\" aria-label=\"Delete\" class=\"iconLightGreyBackground\"><md-tooltip md-direction=\"bottom\">\nShow Delete Event</md-tooltip></md-icon></div><div class=\"edit-item-delete\" \nng-if=\"thisEvent.item_data.eventShowDelete && (vm.editPerm || parseInt(vm.thisEvent.user_id)==Spark.state.user.id)\" \nng-click=\"vm.deleteEvent(thisEvent.id)\"><md-icon md-font-icon=\"icon-close-circle\" aria-label=\"Delete\" \nclass=\"iconWhiteBackground\"><md-tooltip md-direction=\"bottom\">Delete Event</md-tooltip></md-icon></div></div></div><div\n layout=\"column\" flex=\"60\" flex-offset=\"10\" class=\"edit-item-right\" \nng-if=\"vm.thisEvent.item_data.eventID === undefined\"><div class=\"marginTop20 marginBottom20\"><div class=\"md-title\">\nSelect event to edit properties</div></div></div><div layout=\"column\" flex=\"60\" flex-offset=\"10\" \nclass=\"edit-item-right\" ng-if=\"vm.thisEvent.item_data.eventID !== undefined\"><div \nclass=\"md-title marginTop20 marginBottom20\">Event Notes</div><div flex=\"100\" layout-align=\"center center\"><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.addNote( vm.thisEvent );\" \nng-if=\"vm.editPerm || parseInt(vm.thisEvent.user_id)==Spark.state.user.id\" type=\"submit\" \naria-label=\"Add Note Comments\"><span>Add Note Comments</span></md-button></div><md-list \nng-if=\"vm.thisEvent.item_data.eventNotes.length > 0\"><md-list-item><div flex=\"100\" layout=\"row\"><div flex=\"5\" \nclass=\"textCentered taskTitle\">Num</div><div flex=\"15\" class=\"textCentered taskTitle\">Date</div><div flex=\"80\" \nclass=\"textCentered taskTitle\">Notes</div></div></md-list-item><md-list-item \nng-repeat=\"thisNote in vm.thisEvent.item_data.eventNotes track by $index\" \nng-click=\"vm.thisNote=thisNote; vm.checkNoteDates( vm.thisEvent );\" layout=\"row\"><div flex=\"5\">{{$index+1}}</div><div \nflex=\"15\">{{thisNote.day}} - {{thisNote.month}} - {{thisNote.year}}</div><div flex=\"80\" \ndata-ng-bind-html=\"thisNote.noteContent\"></div></md-list-item></md-list><div \nng-if=\"vm.thisNote.inTime && ( Spark.state.user.id == parseInt(vm.thisNote.noteCreatorID) )\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"input-block\"><text-angular ng-model=\"vm.thisNote.noteContent\"></text-angular></div>\n</div><div ng-if=\"!vm.thisNote.inTime || ( Spark.state.user.id != parseInt(vm.thisNote.noteCreatorID) )\"><div \nlayout=\"row\" data-ng-bind-html=\"vm.thisNote.noteContent\"></div></div></div></div></div><md-dialog-actions><md-button \nclass=\"md-accent md-raised\" \nng-click=\"vm.populateDates();\n					   			 vm.calcEventDays();\n					   			 vm.calcLogDays();\n					   			 vm.calcWidths();\n					   			 vm.runEventDigest();\n					   			 vm.hide();\" \ntype=\"submit\" aria-label=\"Finished Editing Event\"><span>Finished Editing</span></md-button></md-dialog-actions></form>\n</div>");
$templateCache.put("app/main/apps/workflow/views/dialogs/event-participants-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\"><div layout=\"row\"><div \nlayout=\"column\" class=\"edit-item-left\"><div class=\"edit-item-select paddingBottom20\" layout=\"row\" \nng-if=\"vm.editPerm || vm.conditionalEdit\"><md-icon md-font-icon=\"icon-plus\" ng-click=\"vm.addEvent()\"><md-tooltip \nmd-direction=\"bottom\">Add New Event</md-tooltip></md-icon></div><div class=\"edit-item-select\" layout=\"row\" \nng-repeat=\"thisEvent in vm.cadwolf_fileInfo.events track by thisEvent.id\" \nng-click=\"vm.thisEvent = thisEvent;  vm.popEventItems();\" ng-class=\"{\'selected\' : vm.thisEvent === thisEvent}\"><div \nclass=\"edit-item-select-color\" ng-class=\"thisEvent.item_data.eventColor\"></div><div class=\"edit-item-select-title\" \nng-click=\"thisEvent.item_data.eventShowDelete=false\">{{thisEvent.item_data.eventTitle}}</div><div \nclass=\"edit-item-showdelete\" \nng-if=\"!thisEvent.item_data.eventShowDelete && (vm.editPerm || parseInt(vm.thisEvent.user_id)==Spark.state.user.id)\" \nng-click=\"thisEvent.item_data.eventShowDelete=!thisEvent.item_data.eventShowDelete\"><md-icon \nmd-font-icon=\"icon-close-circle\" aria-label=\"Delete\" class=\"iconLightGreyBackground\"><md-tooltip md-direction=\"bottom\">\nShow Delete Event</md-tooltip></md-icon></div><div class=\"edit-item-delete\" \nng-if=\"thisEvent.item_data.eventShowDelete && (vm.editPerm || parseInt(vm.thisEvent.user_id)==Spark.state.user.id)\" \nng-click=\"vm.deleteEvent(thisEvent.id)\"><md-icon md-font-icon=\"icon-close-circle\" aria-label=\"Delete\" \nclass=\"iconWhiteBackground\"><md-tooltip md-direction=\"bottom\">Delete Event</md-tooltip></md-icon></div></div></div><div\n layout=\"column\" flex=\"60\" flex-offset=\"10\" class=\"edit-item-right\" \nng-if=\"vm.thisEvent.item_data.eventID === undefined\"><div class=\"marginTop20 marginBottom20\"><div class=\"md-title\">\nSelect event to edit properties</div></div></div><div layout=\"column\" flex=\"60\" flex-offset=\"10\" \nclass=\"edit-item-right\" ng-if=\"vm.thisEvent.item_data.eventID !== undefined\"><div \nclass=\"md-title marginTop20 marginBottom20\">Event Participants</div><div layout-margin><div class=\"md-title\">\nEnter Name or email to add user</div></div><div layout-margin><div flex class=\"input-block\"><md-input-container flex \nclass=\"task-name\"><label>Enter User Name</label><input ng-model=\"vm.proposedUser\" md-autofocus \nng-enter=\"vm.checkMemberName( vm.proposedUser );\"></md-input-container></div></div><md-list layout-margin flex=\"80\" \nflex-offset=\"10\"><md-list-item flex=\"100\" ng-if=\"vm.foundUser !== undefined\"><div flex=\"10\"><img \nclass=\"profile-image avatar\" ng-src=\"{{vm.foundUser.photo_url}}\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/team/default.png\"></div><div flex=\"40\" class=\"marginTop10\">\n{{vm.foundUser.username}}</div><div flex=\"40\" class=\"marginTop10\">{{vm.foundUser.name}}</div><div flex=\"5\" \nflex-offset=\"5\"><md-icon md-font-icon=\"icon-plus\" ng-dblclick=\"vm.addEventParticipant( vm.foundUser, vm.thisEvent );\">\n<md-tooltip md-direction=\"bottom\">Add User</md-tooltip></md-icon></div></md-list-item></md-list><div layout-margin><div\n class=\"md-title\">Users Tagged in this Meeting</div></div><md-list layout-margin flex=\"80\" flex-offset=\"10\">\n<md-list-item flex=\"100\" ng-repeat=\"thisPart in vm.thisEvent.item_data.eventParticipants\"><div flex=\"10\"><img \nclass=\"profile-image avatar\" ng-src=\"{{thisPart.partUserPhoto}}\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/team/default.png\"></div><div flex=\"40\" class=\"marginTop10\">\n{{thisPart.partUserName}}</div><div flex=\"40\" class=\"marginTop10\">{{thisPart.partName}}</div><div flex=\"5\" \nflex-offset=\"5\"><md-icon md-font-icon=\"icon-minus\" ng-dblclick=\"vm.removeMeetingParticipant( thisPart );\"><md-tooltip \nmd-direction=\"bottom\">Remove User from Meeting</md-tooltip></md-icon></div></md-list-item></md-list></div></div></div>\n<md-dialog-actions><md-button class=\"md-accent md-raised\" \nng-click=\"vm.populateDates();\n					   			 vm.calcEventDays();\n					   			 vm.calcLogDays();\n					   			 vm.calcWidths();\n					   			 vm.runEventDigest();\n					   			 vm.hide();\" \ntype=\"submit\" aria-label=\"Finished Editing Event\"><span>Finished Editing</span></md-button></md-dialog-actions></form>\n</div>");
$templateCache.put("app/main/apps/workflow/views/dialogs/event-rows-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\"><div layout=\"row\"><div \nlayout=\"column\" class=\"edit-item-left\"><div class=\"edit-item-select paddingBottom20\" layout=\"row\" \nng-if=\"vm.editPerm || vm.conditionalEdit\"><md-icon md-font-icon=\"icon-plus\" ng-click=\"vm.addEvent()\"><md-tooltip \nmd-direction=\"bottom\">Add New Event</md-tooltip></md-icon></div><div class=\"edit-item-select\" layout=\"row\" \nng-repeat=\"thisEvent in vm.cadwolf_fileInfo.events track by thisEvent.id\" \nng-click=\"vm.thisEvent = thisEvent; vm.popEventItems();\" ng-class=\"{\'selected\' : vm.thisEvent === thisEvent}\"><div \nclass=\"edit-item-select-color\" ng-class=\"thisEvent.item_data.eventColor\"></div><div class=\"edit-item-select-title\" \nng-click=\"thisEvent.item_data.eventShowDelete=false\">{{thisEvent.item_data.eventTitle}}</div><div \nclass=\"edit-item-showdelete\" \nng-if=\"!thisEvent.item_data.eventShowDelete && (vm.editPerm || parseInt(vm.thisEvent.user_id)==Spark.state.user.id)\" \nng-click=\"thisEvent.item_data.eventShowDelete=!thisEvent.item_data.eventShowDelete\"><md-icon \nmd-font-icon=\"icon-close-circle\" aria-label=\"Delete\" class=\"iconLightGreyBackground\"><md-tooltip md-direction=\"bottom\">\nShow Delete Event</md-tooltip></md-icon></div><div class=\"edit-item-delete\" \nng-if=\"thisEvent.item_data.eventShowDelete && (vm.editPerm || parseInt(vm.thisEvent.user_id)==Spark.state.user.id)\" \nng-click=\"vm.deleteEvent(thisEvent.id)\"><md-icon md-font-icon=\"icon-close-circle\" aria-label=\"Delete\" \nclass=\"iconWhiteBackground\"><md-tooltip md-direction=\"bottom\">Delete Event</md-tooltip></md-icon></div></div></div><div\n layout=\"column\" flex=\"60\" flex-offset=\"10\" class=\"edit-item-right\" \nng-if=\"vm.thisEvent.item_data.eventID === undefined\"><div layout=\"row\" layout-padding><div class=\"md-title\">\nSelect event to add items</div></div></div><div layout=\"column\" flex=\"60\" flex-offset=\"10\" class=\"edit-item-right\" \nng-if=\"vm.thisEvent.item_data.eventID !== undefined && vm.thisEvent.item_data.eventVersionChanger\"><div \nclass=\"marginTop40 marginBottom20\"><div class=\"\">\nThis event rolls all items from one version to the next and thus applies to all items.</div></div></div><div \nlayout=\"column\" flex=\"60\" flex-offset=\"10\" class=\"edit-item-right\" \nng-if=\"vm.thisEvent.item_data.eventID !== undefined && !vm.thisEvent.item_data.eventVersionChanger\"><div \nclass=\"marginTop40 marginBottom20\"><div class=\"md-title\">Apply event to items (rows)</div></div><div \nlayout-align=\"start start\"><md-input-container layout-fill><md-checkbox \nng-model=\"vm.thisEvent.item_data.eventApplyAll\" ng-change=\"vm.updateEvent(vm.thisEvent)\" aria-label=\"Apply to All\">\n</md-checkbox>Apply to all</md-input-container></div><div ng-if=\"!vm.thisEvent.item_data.eventApplyAll\"><div \nclass=\"md-title marginTop40 marginBottom20\">Select Docs to Apply</div><md-list layout-margin flex=\"80\" \nflex-offset=\"10\" class=\"borderMe\" ng-if=\"vm.cadwolf_fileInfo.items.length > 0\"><md-list-item flex=\"100\" borderbottom \nng-repeat=\"thisDoc in vm.cadwolf_fileInfo.items\"><div flex=\"80\" class=\"\">{{thisDoc.item_data.fileData.name}}</div><div \nflex=\"5\" flex-offset=\"5\"><md-icon md-font-icon=\"icon-plus\" \nng-dblclick=\"vm.addDocEvent( vm.thisEvent, thisDoc ); vm.updateEvent(vm.thisEvent.id)\"><md-tooltip \nmd-direction=\"bottom\">Add Document to Event</md-tooltip></md-icon></div></md-list-item></md-list><div \nclass=\"md-title marginTop40 marginBottom20\">Assigned Documents</div><md-list layout-margin flex=\"80\" flex-offset=\"10\" \nclass=\"borderMe\" ng-if=\"vm.thisEvent.item_data.eventFiles.length > 0\"><md-list-item flex=\"100\" borderbottom \nng-repeat=\"thisDoc in vm.thisEvent.item_data.eventFiles\"><div flex=\"80\" class=\"\">{{thisDoc.eventDocName}}</div><div \nflex=\"5\" flex-offset=\"5\"><md-icon md-font-icon=\"icon-minus\" \nng-dblclick=\"vm.removeDocEvent( vm.thisEvent, thisDoc.eventDocID ); vm.updateEvent(vm.thisEvent.id)\"><md-tooltip \nmd-direction=\"bottom\">Remove Document from Event</md-tooltip></md-icon></div></md-list-item></md-list></div></div>\n</div></div><md-dialog-actions><md-button class=\"md-accent md-raised\" \nng-click=\"vm.populateDates();\n					   			 vm.calcEventDays();\n					   			 vm.calcLogDays();\n					   			 vm.calcWidths();\n					   			 vm.runEventDigest();\n					   			 vm.hide();\" \ntype=\"submit\" aria-label=\"Finished Editing Event\"><span>Finished Editing</span></md-button></md-dialog-actions></form>\n</div>");
$templateCache.put("app/main/apps/workflow/views/dialogs/event-settings-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\"><div layout=\"row\"><div \nlayout=\"column\" class=\"edit-item-left\"><div class=\"edit-item-select paddingBottom20\" layout=\"row\" \nng-if=\"vm.editPerm || vm.conditionalEdit\"><md-icon md-font-icon=\"icon-plus\" ng-click=\"vm.addEvent()\"><md-tooltip \nmd-direction=\"bottom\">Add New Event</md-tooltip></md-icon></div><div class=\"edit-item-select\" layout=\"row\" \nng-repeat=\"thisEvent in vm.cadwolf_fileInfo.events track by thisEvent.id\" \nng-click=\"vm.thisEvent = thisEvent;  vm.popEventItems();\" ng-class=\"{\'selected\' : vm.thisEvent === thisEvent}\"><div \nclass=\"edit-item-select-color\" ng-class=\"thisEvent.item_data.eventColor\"></div><div class=\"edit-item-select-title\" \nng-click=\"thisEvent.item_data.eventShowDelete=false\">{{thisEvent.item_data.eventTitle}}</div><div \nclass=\"edit-item-showdelete\" \nng-if=\"!thisEvent.item_data.eventShowDelete && (vm.editPerm || parseInt(vm.thisEvent.user_id)==Spark.state.user.id)\" \nng-click=\"thisEvent.item_data.eventShowDelete=!thisEvent.item_data.eventShowDelete\"><md-icon \nmd-font-icon=\"icon-close-circle\" aria-label=\"Delete\" class=\"iconLightGreyBackground\"><md-tooltip md-direction=\"bottom\">\nShow Delete Event</md-tooltip></md-icon></div><div class=\"edit-item-delete\" \nng-if=\"thisEvent.item_data.eventShowDelete && (vm.editPerm || parseInt(vm.thisEvent.user_id)==Spark.state.user.id)\" \nng-click=\"vm.deleteEvent(thisEvent.id)\"><md-icon md-font-icon=\"icon-close-circle\" aria-label=\"Delete\" \nclass=\"iconWhiteBackground\"><md-tooltip md-direction=\"bottom\">Delete Event</md-tooltip></md-icon></div></div></div><div\n layout=\"column\" flex=\"60\" flex-offset=\"10\" class=\"edit-item-right\" \nng-if=\"vm.thisEvent.item_data.eventID === undefined\"><div layout=\"row\" layout-padding><div class=\"md-title\">\nSelect event to edit properties</div></div></div><div layout=\"column\" flex=\"60\" flex-offset=\"10\" \nclass=\"edit-item-right\" ng-if=\"vm.thisEvent.item_data.eventID !== undefined\"><div \nclass=\"md-title marginTop20 marginBottom20\">Event Properties</div><div flex class=\"input-block\"><md-input-container \nflex class=\"task-name\"><label>Event Name</label><input name=\"name\" ng-model=\"vm.thisEvent.item_data.eventTitle\" \nng-enter=\"vm.updateEvent(vm.thisEvent.id)\" required md-autofocus></md-input-container></div><div flex \nclass=\"input-block\"><md-input-container layout-fill><label>Event Type</label><md-select \nng-model=\"vm.thisEvent.item_data.eventType\" ng-change=\"vm.updateEvent(vm.thisEvent.id)\"><md-option \nng-repeat=\"thisType in vm.eventTypes track by $index\" value=\"{{thisType}}\">{{thisType}}</md-option></md-select>\n</md-input-container></div><div flex class=\"input-block\" ng-if=\"vm.thisEvent.item_data.eventType==\'Other\'\">\n<md-input-container flex class=\"task-name\"><label>Alternate Event Type</label><input name=\"name\" \nng-model=\"vm.thisEvent.item_data.eventTypeAlt\" ng-enter=\"vm.updateEvent(vm.thisEvent.id)\" required md-autofocus>\n</md-input-container></div><div class=\"md-secondary-container\" layout=\"row\" layout-align=\"space-around center\" \nclass=\"marginTop20\" \nng-if=\"vm.thisEvent.item_data.eventType != \'Signoff Activity\' &&\n						 		vm.thisEvent.item_data.eventType != \'Note\' &&\n						 		!vm.thisEvent.item_data.eventDisallowed\">\n<label>Version Change with Event</label><md-switch \nclass=\"ng-valid ng-scope md-default-theme ng-dirty ng-valid-parse md-checked ng-not-empty ng-touched\" \nng-model=\"vm.thisEvent.item_data.eventVersionChanger\" aria-label=\"Version Control Event\" translate=\"\" \ntranslate-attr-aria-label=\"FM.TOOGLE_OFFLINE\" tabindex=\"0\" type=\"checkbox\" role=\"checkbox\" aria-invalid=\"false\" \nstyle=\"\" ng-change=\"vm.runEventDigest();\"><div class=\"md-container\" style=\"touch-action: pan-x\"><div class=\"md-bar\">\n</div><div class=\"md-thumb-container\"><div class=\"md-thumb md-ink-ripple\" md-ink-ripple=\"\" md-ink-ripple-checkbox=\"\">\n<div class=\"md-ripple-container\"></div></div></div></div><div class=\"md-label\"></div></md-switch></div><div \nlayout-gt-sm=\"row\" layout-align=\"start start\" \nng-if=\"vm.thisEvent.item_data.eventType!=\'Note\' &&\n						 		vm.thisEvent.item_data.eventType!=\'Signoff Activity\'\"><div \nclass=\"input-block\" flex layout=\"row\" layout-align=\"space-between center\" layout-margin><label>From:</label>\n<md-datepicker name=\"fromDate\" ms-datepicker-fix ng-model=\"vm.thisEvent.item_data.eventStart\" \nng-change=\"vm.thisEvent.addStartDay=true; vm.updateEvent(vm.thisEvent.id)\" md-placeholder=\"Select Date\" ng-required>\n</md-datepicker></div><div class=\"input-block\" flex layout=\"row\" layout-align=\"space-between center\" layout-margin>\n<label>To:</label><md-datepicker name=\"toDate\" ms-datepicker-fix ng-model=\"vm.thisEvent.item_data.eventEnd\" \nng-change=\"vm.thisEvent.addEndDay=true; vm.updateEvent(vm.thisEvent.id)\" md-placeholder=\"Select Date\" ng-required>\n</md-datepicker></div></div><div layout-gt-sm=\"row\" layout-align=\"start start\" \nng-if=\"vm.thisEvent.item_data.eventType == \'Note\' ||\n						 		vm.thisEvent.item_data.eventType == \'Signoff Activity\'\">\n<div class=\"input-block\" flex layout=\"row\" layout-align=\"center center\" layout-margin><label>Date of Activity :</label>\n<md-datepicker name=\"ActivityDate\" ms-datepicker-fix ng-model=\"vm.thisEvent.item_data.eventStart\" \nng-change=\"vm.updateEvent(vm.thisEvent.id)\" md-placeholder=\"Select Date\" ng-required></md-datepicker></div></div><div \nlayout=\"row\"><div class=\"input-block\" flex layout=\"row\" flex=\"50\" layout-align=\"space-around center\"><label>\nEvent Color:</label><ms-material-color-picker ng-model=\"vm.thisEvent.item_data.eventColor\" \nng-change=\"vm.updateEvent(vm.thisEvent.id)\"></ms-material-color-picker></div></div><div \nclass=\"md-title marginTop20 marginBottom20\">Event Creator</div><div layout=\"row\"><div flex=\"25\" flex-offset=\"25\" \nclass=\"avatar-wrapper ng-scope\"><img md-menu-align-target=\"\" class=\"avatar huge\" \nng-src=\"{{vm.thisEvent.item_data.eventCreatorPhoto}}\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"></div><div layout=\"column\" flex=\"50\"><div \nlayout=\"row\" class=\"marginBottom10\"><div class=\"marginRight20\">Name :</div><div>\n{{vm.thisEvent.item_data.eventCreatorName}}</div></div><div layout=\"row\" class=\"marginBottom10\"><div \nclass=\"marginRight20\">User Name</div><div>{{vm.thisEvent.item_data.eventCreatorUserName}}</div></div><div layout=\"row\" \nclass=\"marginBottom10\"><div class=\"marginRight20\">Date Created</div><div>{{vm.thisEvent.item_data.eventCreateDate}}\n</div></div></div></div><div class=\"md-title marginTop20 marginBottom20\">Event Description</div><div layout=\"row\" \nlayout-align=\"start center\" class=\"input-block\"><text-angular ng-model=\"vm.thisEvent.item_data.eventDescription\" \nng-blur=\"vm.updateEvent(vm.thisEvent.id)\"></text-angular></div></div></div></div><md-dialog-actions><md-button \nclass=\"md-accent md-raised\" \nng-click=\"vm.populateDates();\n					   			 vm.calcEventDays();\n					   			 vm.calcLogDays();\n					   			 vm.calcWidths();\n					   			 vm.runEventDigest();\n					   			 vm.hide();\" \ntype=\"submit\" aria-label=\"Finished Editing Event\"><span>Finished Editing</span></md-button></md-dialog-actions></form>\n</div>");
$templateCache.put("app/main/apps/workflow/views/dialogs/event-signoff-activity-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\"><div layout=\"row\"><div \nlayout=\"column\" class=\"edit-item-left\"><div class=\"edit-item-select paddingBottom20\" layout=\"row\" \nng-if=\"vm.editPerm || vm.conditionalEdit\"><md-icon md-font-icon=\"icon-plus\" ng-click=\"vm.addEvent()\"><md-tooltip \nmd-direction=\"bottom\">Add New Event</md-tooltip></md-icon></div><div class=\"edit-item-select\" layout=\"row\" \nng-repeat=\"thisEvent in vm.cadwolf_fileInfo.events track by thisEvent.id\" \nng-click=\"vm.thisEvent = thisEvent;  vm.popEventItems();\" ng-class=\"{\'selected\' : vm.thisEvent === thisEvent}\"><div \nclass=\"edit-item-select-color\" ng-class=\"thisEvent.item_data.eventColor\"></div><div class=\"edit-item-select-title\" \nng-click=\"thisEvent.item_data.eventShowDelete=false\">{{thisEvent.item_data.eventTitle}}</div><div \nclass=\"edit-item-showdelete\" \nng-if=\"!thisEvent.item_data.eventShowDelete && (vm.editPerm || parseInt(vm.thisEvent.user_id)==Spark.state.user.id)\" \nng-click=\"thisEvent.item_data.eventShowDelete=!thisEvent.item_data.eventShowDelete\"><md-icon \nmd-font-icon=\"icon-close-circle\" aria-label=\"Delete\" class=\"iconLightGreyBackground\"><md-tooltip md-direction=\"bottom\">\nShow Delete Event</md-tooltip></md-icon></div><div class=\"edit-item-delete\" \nng-if=\"thisEvent.item_data.eventShowDelete && (vm.editPerm || parseInt(vm.thisEvent.user_id)==Spark.state.user.id)\" \nng-click=\"vm.deleteEvent(thisEvent.id)\"><md-icon md-font-icon=\"icon-close-circle\" aria-label=\"Delete\" \nclass=\"iconWhiteBackground\"><md-tooltip md-direction=\"bottom\">Delete Event</md-tooltip></md-icon></div></div></div><div\n layout=\"column\" flex=\"60\" flex-offset=\"10\" class=\"edit-item-right\" \nng-if=\"vm.thisEvent.item_data.eventID === undefined || vm.thisEvent.item_data.eventType != \'Signoff Activity\'\"><div \nclass=\"marginTop20 marginBottom20\"><div class=\"md-title\">Select event to edit properties</div></div></div><div \nlayout=\"column\" flex=\"60\" flex-offset=\"10\" class=\"edit-item-right\" \nng-if=\"vm.thisEvent.item_data.eventID !== undefined\"><div class=\"md-title marginTop20 marginBottom20\"></div><div \nflex=\"100\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" \nng-click=\"vm.getDocContent( vm.thisEvent );\" type=\"submit\" aria-label=\"Get File Components\"><span>Get File Components\n</span></md-button></div><div class=\"marginTop20 marginBottom20\" \nng-if=\"vm.eventComponents.length = 0 || vm.eventComponents === undefined \">\nClick the button above to see the components for the file in question</div><md-list><md-list-item><div flex=\"100\" \nlayout=\"row\"><div flex=\"5\" class=\"textCentered taskTitle\">Num</div><div flex=\"15\" class=\"textCentered taskTitle\">Date\n</div><div flex=\"80\" class=\"textCentered taskTitle\">Notes</div></div></md-list-item><md-list-item \nng-repeat=\"noteComp in vm.thisEvent.item_data.eventSignoffNotes track by $index\" \nng-click=\"vm.thisNote=thisNote; vm.checkNoteDates( vm.thisEvent );\" layout=\"row\"><div flex=\"5\">{{$index+1}}</div><div \nflex=\"15\">{{thisNote.day}} - {{thisNote.month}} - {{thisNote.year}}</div><div flex=\"80\" \ndata-ng-bind-html=\"thisNote.noteContent\"></div></md-list-item></md-list><div \nng-if=\"vm.thisNote.inTime && ( Spark.state.user.id == parseInt(vm.thisNote.noteCreatorID) )\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"input-block\"><text-angular ng-model=\"vm.thisNote.noteContent\"></text-angular></div>\n</div><div class=\"marginTop20 marginBottom20\" ng-if=\"vm.eventComponents.length > 0\">Select the component to comment on\n</div><md-list><md-list-item flex=\"100\"><div class=\"taskTitle\" flex=\"10\">Location</div><div class=\"taskTitle\" \nflex=\"20\">Type</div><div class=\"taskTitle\" flex=\"70\">Content</div></md-list-item><md-list-item flex=\"100\" \nng-repeat=\"thisComp in vm.eventComponents track by thisComp.id\" \nng-dblclick=\"vm.addSignoffNote( vm.thisEvent, thisComp )\" class=\"hoverMe greyHoverBack\"><div flex=\"10\">thisComp.order\n</div><div class=\"taskTitle\" flex=\"20\">vm.varType[thisComp.component_type_id]</div><div class=\"\" \nng-if=\"component_type_id == 1\" data-ng-bind-html=\"thisComp.content.text.substring(0,150)\" flex=\"70\"></div><div \nclass=\"\" ng-if=\"component_type_id == 2\" flex=\"70\">{{thisComp.content.text}}</div><div class=\"\" \nng-if=\"component_type_id == 3\" flex=\"70\"><span mathjax-bind=\"thisComp.content.Equation.Format_left\"></span><span>=\n</span> <span mathjax-bind=\"thisComp.content.Equation.Format_showequation\"></span><span>=</span> <span \nmathjax-bind=\"thisComp.content.Equation.Format_showsolution\" \nng-if=\"thisComp.content.Equation.Format_showvalue==\'value\'\"></span> <span \nmathjax-bind=\"thisComp.content.Equation.Units_showunits\" ng-if=\"thisComp.content.Equation.Format_showvalue==\'value\'\">\n</span> <span mathjax-bind=\"thisComp.content.Equation.Format_size\" \nng-if=\"thisComp.content.Equation.Format_showvalue==\'size\' || thisComp.content.Equation.Format_showvalue==\'default\'\">\n</span></div><div class=\"\" ng-if=\"component_type_id == 4\" flex=\"70\">{{thisComp.content.text}}</div><div class=\"\" \nng-if=\"component_type_id == 9\" flex=\"70\">\nThis is a {{thisComp.content.plot.Chart_type}} chart and its title is \'{{thisComp.content.plot.Title_text}}\'</div><div \nclass=\"\" ng-if=\"component_type_id == 10\" flex=\"70\"><div class=\"image\" \nng-if=\"(!thisComp.content.isCAD) || (thisComp.content.isCAD===undefined)\"><img \nng-src=\"https://cadwolf.s3.amazonaws.com/{{thisComp.content.src}}\" width=\"{{thisComp.content.width}}\" \nheight=\"{{thisComp.content.height}}\"></div><div class=\"image\" ng-if=\"thisComp.content.isCAD\"><img \nng-src=\"{{thisComp.content.src}}\" width=\"{{thisComp.content.width}}\" height=\"{{thisComp.content.height}}\"></div></div>\n<div class=\"\" ng-if=\"component_type_id == 12\" flex=\"70\"><div><iframe width=\"{{thisComp.content.videoWidth}}\" \nheight=\"{{thisComp.content.videoHeight}}\" src=\"{{thisComp.content.url}}\" frameborder=\"0\" allowfullscreen></iframe>\n</div></div></md-list-item></md-list></div></div></div><md-dialog-actions><md-button class=\"md-accent md-raised\" \nng-click=\"vm.populateDates();\n					   			 vm.calcEventDays();\n					   			 vm.calcLogDays();\n					   			 vm.calcWidths();\n					   			 vm.runEventDigest();\n					   			 vm.hide();\" \ntype=\"submit\" aria-label=\"Finished Editing Event\"><span>Finished Editing</span></md-button></md-dialog-actions></form>\n</div>");
$templateCache.put("app/main/apps/workflow/views/dialogs/event-signoffs-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\"><div layout=\"row\"><div \nlayout=\"column\" class=\"edit-item-left\"><div class=\"edit-item-select paddingBottom20\" layout=\"row\" \nng-if=\"vm.editPerm || vm.conditionalEdit\"><md-icon md-font-icon=\"icon-plus\" ng-click=\"vm.addEvent()\"><md-tooltip \nmd-direction=\"bottom\">Add New Event</md-tooltip></md-icon></div><div class=\"edit-item-select\" layout=\"row\" \nng-repeat=\"thisEvent in vm.cadwolf_fileInfo.events track by thisEvent.id\" \nng-click=\"vm.thisEvent = thisEvent;  vm.popEventItems();\" ng-class=\"{\'selected\' : vm.thisEvent === thisEvent}\"><div \nclass=\"edit-item-select-color\" ng-class=\"thisEvent.item_data.eventColor\"></div><div class=\"edit-item-select-title\" \nng-click=\"thisEvent.item_data.eventShowDelete=false\">{{thisEvent.item_data.eventTitle}}</div><div \nclass=\"edit-item-showdelete\" \nng-if=\"!thisEvent.item_data.eventShowDelete && (vm.editPerm || parseInt(vm.thisEvent.user_id)==Spark.state.user.id)\" \nng-click=\"thisEvent.item_data.eventShowDelete=!thisEvent.item_data.eventShowDelete\"><md-icon \nmd-font-icon=\"icon-close-circle\" aria-label=\"Delete\" class=\"iconLightGreyBackground\"><md-tooltip md-direction=\"bottom\">\nShow Delete Event</md-tooltip></md-icon></div><div class=\"edit-item-delete\" \nng-if=\"thisEvent.item_data.eventShowDelete && (vm.editPerm || parseInt(vm.thisEvent.user_id)==Spark.state.user.id)\" \nng-click=\"vm.deleteEvent(thisEvent.id)\"><md-icon md-font-icon=\"icon-close-circle\" aria-label=\"Delete\" \nclass=\"iconWhiteBackground\"><md-tooltip md-direction=\"bottom\">Delete Event</md-tooltip></md-icon></div></div></div><div\n layout=\"column\" flex=\"60\" flex-offset=\"10\" class=\"edit-item-right\" \nng-if=\"vm.thisEvent.item_data.eventID !== undefined\"><div layout-align=\"center center\" \nng-if=\"vm.thisEvent.item_data.eventSignoffStatus\"><md-button class=\"md-accent md-raised\" \nng-click=\"vm.rollVersions( vm.thisEvent )\" aria-label=\"Roll to next version\"><span>Roll to next Version</span>\n</md-button></div><div layout=\"column\"><md-list flex=\"100\" class=\"taskList\"><md-list-item flex=\"90\" flex-offset=\"10\" \nclass=\"taskTitle\"><div flex=\"5\"></div><div flex=\"25\" class=\"textCentered\">Signoff Name</div><div flex=\"25\" \nclass=\"textCentered\">Role</div><div flex=\"25\" class=\"textCentered\">User</div><div flex=\"15\" class=\"textCentered\">\nDue Date</div><div flex=\"5\" class=\"textCentered\">Status</div></md-list-item></md-list><div workflow-item-signoffs \nlayout=\"column\" ng-repeat=\"thisItem in vm.cadwolf_fileInfo.items | orderBy:\'order\' track by $index\" \nid=\"thisItem.item_data.fileData.id\" list-items=\"vm.cadwolf_fileInfo.items\" events=\"vm.cadwolf_fileInfo.events\" \nspark=\"Spark\" this-item=\"thisItem\" signoffs=\"vm.cadwolf_fileInfo.signoffs\" this-event=\"vm.thisEvent\" \npermissions=\"vm.cadwolf_fileInfo.item_data.permissions\" ng-if=\"thisItem.item_data.topItem\"></div></div></div></div>\n</div><md-dialog-actions><md-button class=\"md-accent md-raised\" ng-click=\"vm.hide()\" type=\"submit\" \naria-label=\"Finished Editing Event\"><span>Finished Editing</span></md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/apps/workflow/views/dialogs/item-delete-view.html","<div class=\"row\" layout=\"column\"><form name=\"rowForm\" ng-submit=\"vm.dialogType === \'add\'?vm.addNewRow():vm.saveRow();\">\n<div class=\"form-content\"><div ng-repeat=\"file in vm.cadwolf_fileInfo.items\" layout=\"row\" layout-margin \nclass=\"borderBottom\" ng-dblclick=\"vm.deleteItem( file )\"><div class=\"marginTop10\" flex=\"85\">\n{{ file.item_data.fileData.name }}</div><div ng-dblclick=\"vm.deleteItem( file.id )\" flex=\"5\" flex-offset=\"5\" \nclass=\"hoverMe\"><md-icon md-font-icon=\"icon-cancel\"></md-icon></div></div></div><md-dialog-actions><md-button \ntype=\"submit\" ng-click=\"vm.hide()\" class=\"md-accent md-raised\" aria-label=\"Finished\"><span>Finished</span></md-button>\n</md-dialog-actions></form></div>");
$templateCache.put("app/main/apps/workflow/views/dialogs/item-dialog.html","<md-dialog class=\"workflow-add-dialog\" aria-label=\"Add Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">Add Item or Event</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-tabs md-dynamic-height><md-tab><md-tab-label><span translate=\"WORKFLOW.ADD_ITEM\">Add Item (Row)</span>\n</md-tab-label><md-tab-body><div ng-include=\"\'app/main/apps/workflow/views/dialogs/item-form-view.html\'\"></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"WORKFLOW.DELETE_ITEM\">Delete Item (Row)</span>\n</md-tab-label><md-tab-body><div ng-include=\"\'app/main/apps/workflow/views/dialogs/item-delete-view.html\'\"></div>\n</md-tab-body></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/workflow/views/dialogs/item-form-view.html","<div class=\"row\" layout=\"column\"><form name=\"rowForm\" ng-submit=\"vm.dialogType === \'add\'?vm.addNewRow():vm.saveRow();\">\n<div class=\"form-content\"><div layout=\"row\"><div flex class=\"input-block\"><md-input-container flex class=\"row-name\">\n<label>Enter parent URL to get files</label><input name=\"name\" ng-model=\"vm.getFilesURL\" \nng-enter=\"vm.getFiles( vm.getFilesURL )\" required md-autofocus></md-input-container></div></div><div \nng-repeat=\"file in vm.currentFiles\" layout=\"row\" layout-margin class=\"borderBottom\" \nng-if=\"file.file_type_id==\'Workspace\' || \n				 		file.file_type_id==\'Part Tree\' || \n				 		file.file_type_id==\'Document\'\">\n<div ng-if=\"file.file_type_id==\'Workspace\'\" ng-dblclick=\"vm.getFiles( vm.getFilesURL, file.name )\" flex=\"5\" \nflex-offset=\"5\"><md-icon md-font-icon=\"icon-folder-outline\"></md-icon></div><div \nng-if=\"file.file_type_id==\'Workspace\'\" ng-dblclick=\"vm.getFiles( vm.getFilesURL, file.name )\" class=\"marginTop10\" \nflex=\"75\">{{ file.name }}</div><div ng-if=\"file.file_type_id==\'Workspace\'\" ng-dblclick=\"vm.addItem( file );\" flex=\"5\">\n<md-icon md-font-icon=\"icon-upload\" class=\"hoverMe\"><md-tooltip md-direction=\"bottom\">Import Workspace</md-tooltip>\n</md-icon></div><div ng-if=\"file.file_type_id==\'Document\'\" ng-dblclick=\"vm.getFiles( vm.getFilesURL, file.name )\" \nflex=\"5\" flex-offset=\"5\"><md-icon md-font-icon=\"icon-file-outline\"></md-icon></div><div \nng-if=\"file.file_type_id==\'Document\'\" ng-dblclick=\"vm.getFiles( vm.getFilesURL, file.name )\" class=\"marginTop10\" \nflex=\"75\">{{ file.name }}</div><div ng-if=\"file.file_type_id==\'Document\'\" ng-dblclick=\"vm.addItem( file );\" flex=\"5\">\n<md-icon md-font-icon=\"icon-upload\" class=\"hoverMe\"><md-tooltip md-direction=\"bottom\">Import Document</md-tooltip>\n</md-icon></div><div ng-if=\"file.file_type_id==\'Part Tree\'\" ng-dblclick=\"vm.getFiles( vm.getFilesURL, file.name )\" \nflex=\"5\" flex-offset=\"5\"><md-icon md-font-icon=\"icon-sitemap\"></md-icon></div><div \nng-if=\"file.file_type_id==\'Part Tree\'\" ng-dblclick=\"vm.getFiles( vm.getFilesURL, file.name )\" class=\"marginTop10\" \nflex=\"75\">{{ file.name }}</div><div ng-if=\"file.file_type_id==\'Part Tree\'\" ng-dblclick=\"vm.addItem( file );\" flex=\"5\">\n<md-icon md-font-icon=\"icon-upload\" class=\"hoverMe\"><md-tooltip md-direction=\"bottom\">Import Part Tree</md-tooltip>\n</md-icon></div></div></div><md-dialog-actions><md-button type=\"submit\" ng-click=\"vm.hide()\" \nclass=\"md-accent md-raised\" aria-label=\"Finished\"><span>Finished</span></md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/apps/workflow/views/dialogs/questions.html","<div layout=\"column\" flex=\"90\" flex-offset=\"5\"><div layout=\"row\" layout-align=\"center center\" class=\"marginTop20\"><div \nclass=\"md-title\">Workflow Questions</div></div><div layout=\"row\" layout-align=\"center center\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"marginTop20\"><md-button class=\"md-accent md-raised\" ng-click=\"vm.addQuestion()\" \ntype=\"submit\" aria-label=\"Add New Question\"><span>Add New Question</span></md-button></div></div><div \nclass=\"body-1 marginTop20 marginBottom20\">\nThis view lets users set up a list of questions that need to be solved in order to complete the project managed by this workflow.\n</div><div class=\"borderBottom marginBottom20\" \nng-repeat=\"thisItem in vm.questions | orderBy:\'thisItem.created_at\' track by $index\" ng-if=\"thisItem.parent_id==0\"><div\n ng-if=\" thisItem.user_id != Spark.state.user.id || thisItem.item_data.editStatus == 0 \" \nclass=\"md-title paddingBottom10\">{{thisItem.item_data.questionTitle}}</div><div \nng-if=\" thisItem.user_id != Spark.state.user.id || thisItem.item_data.editStatus == 0 \" \ndata-ng-bind-html=\"thisItem.item_data.questionBody\"></div><div \nng-if=\" thisItem.user_id == Spark.state.user.id && thisItem.item_data.editStatus == 1 \" \nclass=\"md-title marginTop10 paddingBottom10\"><md-input-container class=\"md-block\" flex=\"100\"><label>Question Title\n</label><input ng-model=\"thisItem.item_data.questionTitle\" ng-enter=\"thisItem.item_data.editStatus=0\">\n</md-input-container></div><div ng-if=\" thisItem.user_id == Spark.state.user.id && thisItem.item_data.editStatus == 1\">\n<text-angular ng-model=\"thisItem.item_data.questionBody\"></text-angular></div><div layout=\"row\"><div \nng-if=\" thisItem.user_id == Spark.state.user.id && thisItem.item_data.editStatus == 0 \" \nng-click=\" thisItem.item_data.editStatus = 1 \" class=\"marginTop10 marginRight10 hoverMe blueText\">Edit</div><div \nng-if=\" thisItem.user_id == Spark.state.user.id && thisItem.item_data.editStatus == 1 \" \nng-click=\" thisItem.item_data.editStatus = 0; vm.updateQuestion( thisItem ) \" \nclass=\"marginTop10 marginRight10 hoverMe blueText\">Done</div><div ng-if=\" thisItem.user_id == Spark.state.user.id \" \nng-click=\" vm.deleteQuestion( thisItem.id ) \" class=\"marginTop10 marginRight10 hoverMe blueText\">Delete</div><div \nng-click=\" vm.addQuestion( thisItem.id ) \" class=\"marginTop10 marginRight10 hoverMe blueText\">Respond</div></div><div \nworkflow-question layout=\"column\" class=\"marginBottom0 paddingBottom10 marginTop20 marginLeft10\" ng-style=\"\" \nng-repeat=\"newItem in vm.questions | orderBy:\'date_created\' track by $index\" id=\"newItem.id\" list-items=\"vm.questions\" \nspark=\"Spark\" ng-if=\"newItem.parent_id==$parent.thisItem.id\"></div></div></div>");
$templateCache.put("app/main/apps/workflow/views/dialogs/requirements.html","<div layout=\"column\" flex=\"90\" flex-offset=\"5\"><div layout=\"row\" layout-align=\"center center\" class=\"marginTop20\"><div \nclass=\"md-title\">Workflow Requirements</div></div><div layout=\"row\" layout-align=\"center center\" class=\"marginTop20\">\n<md-button class=\"md-accent md-raised\" ng-click=\"vm.getRequirements()\" type=\"submit\" aria-label=\"Get Requirements\">\n<span>Update Requirements</span></md-button></div><div class=\"body-1 marginTop20 marginBottom20\">\nThe requirements below are established within the documents contained in the workflow. This page provides an interface to track those requirements and see how they break down through the documents and how they are met. Click the button above to refresh the requirements.\n</div><div class=\"borderBottom marginBottom20\" \nng-repeat=\"thisItem in vm.requirements | orderBy:\'thisItem.created_at\' track by $index\" \nng-if=\"thisItem.dependent_id == null\"><div class=\"md-title paddingBottom10\">{{thisItem.content.title}}</div><div \ndata-ng-bind-html=\"thisItem.content.text\"></div><div workflow-requirement layout=\"column\" \nclass=\"marginBottom0 paddingBottom10 marginTop20 marginLeft10\" ng-style=\"\" \nng-repeat=\"newItem in vm.requirements | orderBy:\'date_created\' track by $index\" id=\"newItem.id\" \nlist-items=\"vm.requirements\" ng-if=\"newItem.dependent_id==$parent.thisItem.itemid\"></div></div></div>");
$templateCache.put("app/main/apps/workflow/views/dialogs/role-dialog.html","<md-dialog class=\"workflow-edit-dialog\" aria-label=\"Event Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">Add or Edit Roles</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-tabs md-dynamic-height><md-tab><md-tab-label><span translate=\"WORKFLOW.ROLE_PROPERTIES\">Role Properties\n</span></md-tab-label><md-tab-body><div ng-if=\"vm.editPerm\" \nng-include=\"\'app/main/apps/workflow/views/dialogs/role-settings-view.html\'\"></div><div ng-if=\"!vm.editPerm\" \nng-include=\"\'app/main/apps/workflow/views/showDialogs/role-settings-view.html\'\"></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"WORKFLOW.ROLE_USERS\">Users with Role</span></md-tab-label><md-tab-body><div \nng-if=\"vm.editPerm\" ng-include=\"\'app/main/apps/workflow/views/dialogs/role-users-view.html\'\"></div><div \nng-if=\"!vm.editPerm\" ng-include=\"\'app/main/apps/workflow/views/showDialogs/role-users-view.html\'\"></div></md-tab-body>\n</md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/workflow/views/dialogs/role-settings-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\"><div layout=\"row\"><div \nlayout=\"column\" class=\"edit-item-left\"><div class=\"edit-item-select paddingBottom20\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-plus\" ng-click=\"vm.addRole()\"><md-tooltip md-direction=\"bottom\">Add New Role</md-tooltip></md-icon>\n</div><div class=\"edit-item-select\" layout=\"row\" ng-repeat=\"thisRole in vm.cadwolf_fileInfo.item_data.roles\" \nng-click=\"vm.thisRole = thisRole\" ng-class=\"{\'selected\' : vm.thisRole === thisRole}\"><div \nclass=\"edit-item-select-color\" ng-class=\"thisRole.roleColor\"></div><div class=\"edit-item-select-title\">\n{{thisRole.roleTitle}}</div></div></div><div layout=\"column\" flex=\"60\" flex-offset=\"10\" class=\"edit-item-right\" \nng-if=\"vm.thisRole.roleID === undefined\"><div layout=\"row\" layout-padding><div class=\"md-title\">\nSelect Role to edit properties</div></div></div><div layout=\"column\" flex=\"60\" flex-offset=\"10\" \nclass=\"edit-item-right\" ng-if=\"vm.thisRole.roleID !== undefined\"><div layout=\"row\"><div flex class=\"input-block\">\n<md-input-container flex class=\"task-name\"><label>Role Title</label><input name=\"name\" \nng-model=\"vm.thisRole.roleTitle\" required md-autofocus></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"input-block\" flex layout=\"row\" flex=\"50\" layout-align=\"space-between center\">\n<label>Role Color:</label><ms-material-color-picker ng-model=\"vm.thisRole.roleColor\"></ms-material-color-picker></div>\n</div><div layout=\"row\" layout-align=\"start center\" class=\"input-block\"><text-angular \nng-model=\"vm.thisRole.roleDescription\"></text-angular></div></div></div></div><md-dialog-actions><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.hide();\" type=\"submit\" aria-label=\"Finished Editing Role\"><span>\nFinished Editing</span></md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/apps/workflow/views/dialogs/role-users-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\"><div layout=\"row\"><div \nlayout=\"column\" class=\"edit-item-left\"><div class=\"edit-item-select\" layout=\"row\" \nng-repeat=\"thisRole in vm.cadwolf_fileInfo.item_data.roles\" ng-click=\"vm.thisRole = thisRole\" \nng-class=\"{\'selected\' : vm.thisRole === thisRole}\"><div class=\"edit-item-select-color\" ng-class=\"thisRole.roleColor\">\n</div><div class=\"edit-item-select-title\">{{thisRole.roleTitle}}</div></div></div><div layout=\"column\" flex=\"60\" \nflex-offset=\"10\" class=\"edit-item-right\" ng-if=\"vm.thisRole.roleID === undefined\"><div layout-margin><div \nclass=\"md-title\">Select Role to edit users</div></div></div><div layout=\"column\" flex=\"60\" flex-offset=\"10\" \nclass=\"edit-item-right\" ng-if=\"vm.thisRole.roleID !== undefined\"><div layout-margin><div class=\"md-title\">\nEnter Name or email to assign user</div></div><div layout-margin><div flex class=\"input-block\"><md-input-container \nflex class=\"task-name\"><label>Enter User Name</label><input ng-model=\"vm.proposedUser\" md-autofocus \nng-enter=\"vm.checkMemberName( vm.proposedUser );\"></md-input-container></div></div><md-list layout-margin flex=\"80\" \nflex-offset=\"10\"><md-list-item flex=\"100\" ng-if=\"vm.foundUser !== undefined && vm.thisRole !== undefined\"><div \nflex=\"10\"><img class=\"profile-image avatar\" ng-src=\"{{vm.foundUser.photo_url}}\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/team/default.png\"></div><div flex=\"40\" class=\"marginTop10\">\n{{vm.foundUser.username}}</div><div flex=\"40\" class=\"marginTop10\">{{vm.foundUser.name}}</div><div flex=\"5\" \nflex-offset=\"5\"><md-icon md-font-icon=\"icon-plus\" ng-dblclick=\"vm.addUserRole( vm.foundUser, vm.thisRole );\">\n<md-tooltip md-direction=\"bottom\">Add Role to User</md-tooltip></md-icon></div></md-list-item></md-list><div \nlayout-margin><div class=\"md-title\">Users assigned to \"{{vm.thisRole.roleTitle}}\"</div></div><md-list layout-margin \nflex=\"80\" flex-offset=\"10\"><md-list-item flex=\"100\" \nng-repeat=\"thisUserRole in vm.cadwolf_fileInfo.item_data.userRoles\" ng-if=\"thisUserRole.roleID == vm.thisRole.roleID\">\n<div flex=\"10\"><img class=\"profile-image avatar\" ng-src=\"{{thisUserRole.userPhoto}}\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/team/default.png\"></div><div flex=\"40\" class=\"marginTop10\">\n{{thisUserRole.userUserName}}</div><div flex=\"40\" class=\"marginTop10\">{{thisUserRole.userName}}</div><div flex=\"5\" \nflex-offset=\"5\"><md-icon md-font-icon=\"icon-minus\" ng-dblclick=\"vm.removeUserRole( thisUserRole.roleID );\"><md-tooltip \nmd-direction=\"bottom\">Remove User from Role</md-tooltip></md-icon></div></md-list-item></md-list></div></div></div>\n<md-dialog-actions><md-button class=\"md-accent md-raised\" ng-click=\"vm.hide()\" type=\"submit\" \naria-label=\"Finished Editing Role\"><span>Finished Editing</span></md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/apps/workflow/views/dialogs/settings-dialog.html","<md-dialog class=\"workflow-edit-dialog\" aria-label=\"Edit Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">\nView Settings for Workflow</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" \naria-label=\"close dialog\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-tabs md-dynamic-height><md-tab><md-tab-label><span \ntranslate=\"WORKFLOW.EDIT_ITEMS\">Edit Items</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/apps/workflow/views/dialogs/settings-items-view.html\'\"></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"WORKFLOW.EDIT_VIEWABLE\">Viewable Items</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/apps/workflow/views/dialogs/settings-viewable-view.html\'\"></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"WORKFLOW.PERMISSIONS\">Permissions</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/apps/workflow/views/dialogs/settings-permissions-view.html\'\"></div></md-tab-body></md-tab>\n</md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/workflow/views/dialogs/settings-items-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\" flex=\"80\" flex-offset=\"10\"><div \nlayout=\"row\"><div flex=\"100\"><div layout-margin class=\"md-title\">Log Data and Status</div><div \nworkflow-log-data-status layout=\"column\" \nng-repeat=\"thisItem in vm.cadwolf_fileInfo.items | orderBy:\'thisItem.item_data.fileData.order\' track by $index\" \nid=\"thisItem.item_data.fileData.id\" list-items=\"vm.cadwolf_fileInfo.items\" spark=\"Spark\" this-item=\"thisItem\" \npermissions=\"vm.cadwolf_fileInfo.item_data.permissions\" call-get-log-data=\"vm.getLogData\" \ncall-check-update-status=\"vm.checkUpdateStatus\" call-delete-item=\"vm.deleteItem\" ng-if=\"thisItem.item_data.topItem\">\n</div></div></div></div><md-dialog-actions><md-button class=\"md-accent md-raised\" ng-click=\"vm.hide();\" type=\"submit\" \naria-label=\"Finished Editing\"><span>Finished Editing</span></md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/apps/workflow/views/dialogs/settings-permissions-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\" flex=\"80\" flex-offset=\"10\"><div \nlayout=\"row\"><div flex=\"100\"><div class=\"md-title marginTop20 marginBottom20\">My Permissions</div><md-list flex=\"80\" \nflex-offset=\"10\"><md-list-item ng-if=\"vm.editPerm\"><div layout=\"row\" flex=\"100\"><div flex=\"10\"><md-icon \nclass=\"iconGreenBackground\" md-font-icon=\"icon-check-circle\"></md-icon></div><div flex=\"90\">\nYou have full permission to edit this workflow and to add or remove permissions for other users</div></div>\n</md-list-item></md-list><md-list flex=\"80\" flex-offset=\"10\" class=\"marginTop20\"><md-list-item \nclass=\"taskTitle paddingBottom10\"><div layout=\"row\" flex=\"100\"><div flex=\"40\" flex-offset=\"10\" class=\"padding5\">\nDocument</div><div flex=\"50\" class=\"padding5\">Permission</div></div></md-list-item><md-list-item ng-if=\"!vm.editPerm\" \nclass=\"borderBottom paddingTop10 paddingBottom10\"><div layout=\"row\" flex=\"100\"><div flex=\"10\"><md-icon \nclass=\"iconRedBackground paddingTop10 paddingBottom10\" md-font-icon=\"icon-close-circle-outline\"></md-icon></div><div \nflex=\"40\" class=\"paddingTop10 paddingBottom10\">{{thisPerm.permDocTitle}}</div><div flex=\"50\" \nclass=\"paddingTop10 paddingBottom10\">\nYou do not have full permission to edit this workflow and cannot add or remove permissions for other users</div></div>\n</md-list-item><md-list-item class=\"borderBottom paddingTop10 paddingBottom10\" \nng-repeat=\"thisPerm in vm.cadwolf_fileInfo.item_data.permissions\" \nng-if=\"parseInt(thisPerm.permAssigneeID) == parseInt(Spark.state.user.id)\"><div layout=\"row\" flex=\"100\"><div flex=\"10\">\n<md-icon class=\"iconGreenBackground\" md-font-icon=\"icon-check-circle\"></md-icon></div><div flex=\"40\" class=\"padding5\">\n{{thisPerm.permDocTitle}}</div><div flex=\"50\" class=\"padding5\">\nYou have permission to add events and signoffs for the document {{thisPerm.permDocTitle}}</div></div></md-list-item>\n</md-list><div class=\"md-title marginBottom20 marginTop40\" ng-if=\"vm.editPerm\">Add Permission</div><div flex \nclass=\"input-block\" ng-if=\"vm.editPerm\"><md-input-container flex class=\"task-name\"><label>Enter User Name</label><input\n ng-model=\"vm.proposedUser\" md-autofocus ng-enter=\"vm.checkMemberName( vm.proposedUser );\"></md-input-container></div>\n<div layout=\"row\" ng-if=\"vm.editPerm\"><div flex=\"50\" class=\"input-block\"><md-input-container layout-fill><label>\nPermission Item</label><md-select ng-model=\"vm.permFileID\"><md-option \nng-repeat=\"thisItem in vm.cadwolf_fileInfo.items\" value=\"{{thisItem.item_data.fileData.id}}\" \nng-if=\"thisItem.item_data.fileData.file_type_id==\'Document\'\">{{thisItem.item_data.fileData.name}}</md-option>\n</md-select></md-input-container></div><div flex=\"50\" layout=\"row\"><div flex=\"10\"><img class=\"profile-image avatar\" \nng-src=\"{{vm.foundUser.photo_url}}\" on-error-src=\"https://cadwolf.s3.amazonaws.com/team/default.png\"></div><div \nflex=\"40\" class=\"marginTop10\">{{vm.foundUser.username}}</div><div flex=\"40\" class=\"marginTop10\">{{vm.foundUser.name}}\n</div><div flex=\"5\" flex-offset=\"5\"><md-icon md-font-icon=\"icon-plus\" \nng-if=\"vm.foundUser!==undefined && vm.permFileID!==undefined\" \nng-dblclick=\"vm.addPermission( vm.foundUser, vm.permFileID );\"><md-tooltip md-direction=\"bottom\">Add this Permission\n</md-tooltip></md-icon></div></div></div><div class=\"md-title marginTop40 marginBottom20\">Existing Permissions</div>\n<div flex=\"100\" class=\"\" ng-repeat=\"thisItem in vm.cadwolf_fileInfo.items\"><div \nclass=\"paddingTop10 paddingBottom10 borderBottom md-subhead\">{{thisItem.item_data.fileData.name}}</div><div flex=\"80\" \nflex-offset=\"20\" class=\"borderBottom textRight paddingTop10 paddingBottom10\" \nng-repeat=\"thisPerm in vm.cadwolf_fileInfo.item_data.permissions\" \nng-if=\"thisPerm.permDocID==thisItem.item_data.fileData.id && !vm.editPerm\">\n{{thisPerm.permAssigneeUserName}} - {{thisPerm.permAssigneeName}} - {{thisPerm.permAssigneeEmail}}</div><div flex=\"80\" \nflex-offset=\"20\" class=\"borderBottom textRight paddingTop10 paddingBottom10\" \nng-repeat=\"thisPerm in vm.cadwolf_fileInfo.item_data.permissions\" \nng-if=\"thisPerm.permDocID==thisItem.item_data.fileData.id && vm.editPerm\">\n{{thisPerm.permAssigneeUserName}} - {{thisPerm.permAssigneeName}} - {{thisPerm.permAssigneeEmail}}<md-icon \nclass=\"marginLeft5 hoverMe iconRedBackground\" ng-click=\"vm.deletePerm( thisPerm )\" md-font-icon=\"icon-cancel\">\n</md-icon></div></div></div></div></div><md-dialog-actions><md-button class=\"md-accent md-raised\" \nng-click=\"vm.hide();\" type=\"submit\" aria-label=\"Finished Editing\"><span>Finished Editing</span></md-button>\n</md-dialog-actions></form></div>");
$templateCache.put("app/main/apps/workflow/views/dialogs/settings-viewable-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\"><div layout=\"row\"><div \nlayout=\"column\" flex=\"80\" flex-offset=\"10\"><div layout=\"row\" class=\"md-title md-margin md-padding\">Log Items</div><div \nlayout=\"row\" layout-align=\"start start\"><md-input-container layout-fill><md-checkbox \nng-model=\"vm.cadwolf_fileInfo.item_data.settings.views.created\" aria-label=\"Event Item\"></md-checkbox>\nView when item was created</md-input-container></div><div layout=\"row\" layout-align=\"start start\"><md-input-container \nlayout-fill><md-checkbox ng-model=\"vm.cadwolf_fileInfo.item_data.settings.views.saves\" aria-label=\"Event Item\">\n</md-checkbox>View when item was saved</md-input-container></div><div layout=\"row\" layout-align=\"start start\">\n<md-input-container layout-fill><md-checkbox ng-model=\"vm.cadwolf_fileInfo.item_data.settings.views.versions\" \naria-label=\"Event Item\"></md-checkbox>View when new version was created</md-input-container></div></div></div></div>\n<md-dialog-actions><md-button class=\"md-accent md-raised\" ng-click=\"vm.hide()\" type=\"submit\" \naria-label=\"Finished Editing Event\"><span>Finished Editing</span></md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/apps/workflow/views/dialogs/signoff-dialog.html","<md-dialog class=\"workflow-edit-dialog\" aria-label=\"Event Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">Add or Edit Signoffs\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"close dialog\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-tabs md-dynamic-height><md-tab><md-tab-label><span translate=\"WORKFLOW.SIGNOFF_PROPERTIES\">\nSignoff Properties</span></md-tab-label><md-tab-body><div \nng-if=\"vm.editPerm || vm.thisSignoff.user_id == Spark.state.user.id\" \nng-include=\"\'app/main/apps/workflow/views/dialogs/signoff-properties-view.html\'\"></div><div \nng-if=\"!vm.editPerm && vm.thisSignoff.user_id != Spark.state.user.id\" \nng-include=\"\'app/main/apps/workflow/views/showDialogs/signoff-properties-view.html\'\"></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span translate=\"WORKFLOW.SIGNOFF_ITEMS\">Signoff Items</span></md-tab-label><md-tab-body><div \nng-if=\"vm.editPerm || vm.thisSignoff.user_id == Spark.state.user.id\" \nng-include=\"\'app/main/apps/workflow/views/dialogs/signoff-items-view.html\'\"></div><div \nng-if=\"!vm.editPerm && vm.thisSignoff.user_id != Spark.state.user.id\" \nng-include=\"\'app/main/apps/workflow/views/showDialogs/signoff-items-view.html\'\"></div></md-tab-body></md-tab></md-tabs>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/workflow/views/dialogs/signoff-items-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\"><div layout=\"row\"><div \nlayout=\"column\" class=\"edit-item-left\"><div class=\"edit-item-select\" layout=\"row\" \nng-repeat=\"thisSignoff in vm.cadwolf_fileInfo.signoffs track by thisSignoff.id\" \nng-click=\"vm.thisSignoff = thisSignoff\" ng-class=\"{\'selected\' : vm.thisSignoff === thisSignoff}\"><div \nclass=\"edit-item-select-color\" ng-class=\"thisSignoff.item_data.signoffColor\"></div><div class=\"edit-item-select-title\" \nng-click=\"thisSignoff.item_data.signoffShowDelete = false\">{{thisSignoff.item_data.signoffTitle}}</div><div \nclass=\"edit-item-showdelete\" \nng-if=\"!thisSignoff.item_data.signoffShowDelete && (vm.editPerm || parseInt(vm.thisSignoff.user_id)==Spark.state.user.id)\" \nng-click=\"thisSignoff.item_data.signoffShowDelete=!thisSignoff.item_data.signoffShowDelete\"><md-icon \nmd-font-icon=\"icon-close-circle\" aria-label=\"Delete\" class=\"iconLightGreyBackground\"><md-tooltip md-direction=\"bottom\">\nShow Delete Signoff</md-tooltip></md-icon></div><div class=\"edit-item-delete\" \nng-if=\"thisSignoff.item_data.signoffShowDelete && (vm.editPerm || parseInt(vm.thisSignoff.user_id)==Spark.state.user.id)\" \nng-click=\"vm.deleteSignoff(thisSignoff.id)\"><md-icon md-font-icon=\"icon-close-circle\" aria-label=\"Delete\" \nclass=\"iconWhiteBackground\"><md-tooltip md-direction=\"bottom\">Delete Signoff</md-tooltip></md-icon></div></div></div>\n<div layout=\"column\" flex=\"65\" class=\"edit-item-right\" flex-offset=\"10\"><md-list class=\"taskList\"><md-list-item \nflex=\"90\" flex-offset=\"10\" class=\"taskTitle\"><div flex=\"5\"></div><div flex=\"45\" class=\"textCentered\">Signoff Name</div>\n<div flex=\"45\" class=\"textCentered\">Event</div><div flex=\"5\" class=\"textCentered\">Status</div></md-list-item></md-list>\n<div workflow-signoffs layout=\"column\" \nng-repeat=\"thisItem in vm.cadwolf_fileInfo.items | orderBy:\'order\' track by $index\" \nid=\"thisItem.item_data.fileData.id\" list-items=\"vm.cadwolf_fileInfo.items\" events=\"vm.cadwolf_fileInfo.events\" \nspark=\"Spark\" this-item=\"thisItem\" signoffs=\"vm.cadwolf_fileInfo.signoffs\" \npermissions=\"vm.cadwolf_fileInfo.item_data.permissions\" ng-if=\"thisItem.item_data.topItem\"></div></div></div></div>\n<md-dialog-actions><md-button class=\"md-accent md-raised\" ng-click=\"vm.hide()\" type=\"submit\" \naria-label=\"Finished Editing Role\"><span>Finished Editing</span></md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/apps/workflow/views/dialogs/signoff-properties-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\"><div layout=\"row\"><div \nlayout=\"column\" class=\"edit-item-left\"><div class=\"edit-item-select paddingBottom20\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-plus\" ng-click=\"vm.addSignoff()\"><md-tooltip md-direction=\"bottom\">Add New Signoff</md-tooltip>\n</md-icon></div><div class=\"edit-item-select\" layout=\"row\" \nng-repeat=\"thisSignoff in vm.cadwolf_fileInfo.signoffs track by thisSignoff.id\" \nng-click=\"vm.thisSignoff = thisSignoff\" ng-class=\"{\'selected\' : vm.thisSignoff === thisSignoff}\"><div \nclass=\"edit-item-select-color\" ng-class=\"thisSignoff.item_data.signoffColor\"></div><div class=\"edit-item-select-title\" \nng-click=\"thisSignoff.item_data.signoffShowDelete = false\">{{thisSignoff.item_data.signoffTitle}}</div><div \nclass=\"edit-item-showdelete\" \nng-if=\"!thisSignoff.item_data.signoffShowDelete && (vm.editPerm || parseInt(vm.thisSignoff.user_id)==Spark.state.user.id)\" \nng-click=\"thisSignoff.item_data.signoffShowDelete=!thisSignoff.item_data.signoffShowDelete\"><md-icon \nmd-font-icon=\"icon-close-circle\" aria-label=\"Delete\" class=\"iconLightGreyBackground\"><md-tooltip md-direction=\"bottom\">\nShow Delete Signoff</md-tooltip></md-icon></div><div class=\"edit-item-delete\" \nng-if=\"thisSignoff.item_data.signoffShowDelete && (vm.editPerm || parseInt(vm.thisSignoff.user_id)==Spark.state.user.id)\" \nng-click=\"vm.deleteSignoff(thisSignoff.id)\"><md-icon md-font-icon=\"icon-close-circle\" aria-label=\"Delete\" \nclass=\"iconWhiteBackground\"><md-tooltip md-direction=\"bottom\">Delete Signoff</md-tooltip></md-icon></div></div></div>\n<div layout=\"column\" flex=\"60\" flex-offset=\"10\" class=\"edit-item-right\" \nng-if=\"vm.thisSignoff.item_data.signoffID === undefined\"><div layout=\"row\" layout-padding><div class=\"md-title\">\nSelect Signoff to edit</div></div></div><div layout=\"column\" flex=\"60\" flex-offset=\"10\" class=\"edit-item-right\" \nng-if=\"vm.thisSignoff.item_data.signoffID !== undefined\"><div flex class=\"input-block\"><md-input-container flex \nclass=\"task-name\"><label>Signoff Name</label><input name=\"name\" ng-model=\"vm.thisSignoff.item_data.signoffTitle\" \nng-enter=\"vm.updateSignoff( vm.thisSignoff.id )\" required md-autofocus></md-input-container></div><div \nclass=\"input-block\" layout-align=\"start center\"><div class=\"input-block\" flex layout=\"row\" flex=\"50\" \nlayout-align=\"space-between center\"><label>Signoff Color:</label><ms-material-color-picker \nng-model=\"vm.thisSignoff.item_data.signoffColor\" ng-change=\"vm.updateSignoff( vm.thisSignoff.id )\">\n</ms-material-color-picker></div></div><div class=\"input-block\" flex layout=\"row\" layout-align=\"space-between center\">\n<label>Signoff Due Date:</label><md-datepicker name=\"toDate\" ms-datepicker-fix \nng-model=\"vm.thisSignoff.item_data.signoffDueDate\" ng-change=\"vm.updateSignoff( vm.thisSignoff.id )\" \nmd-placeholder=\"Select Due Date\" ng-required></md-datepicker></div><div flex class=\"input-block\"><md-input-container \nlayout-fill><label>Signoff Type:</label><md-select ng-model=\"vm.thisSignoff.item_data.signoffAssigneeType\" \nng-change=\"vm.updateSignoff(vm.thisSignoff.id);\"><md-option value=\"user\">User</md-option><md-option value=\"role\">Role\n</md-option></md-select></md-input-container></div><div flex class=\"input-block\"><md-input-container layout-fill>\n<label>Signoff Role:</label><md-select ng-model=\"vm.thisSignoff.item_data.signoffAssigneeRoleID\" \nng-change=\"vm.updateSignoff( vm.thisSignoff.id )\"><md-option \nng-repeat=\"thisRole in vm.cadwolf_fileInfo.item_data.roles\" value=\"{{thisRole.roleID}}\"><div layout=\"row\"><div \nclass=\"display-color-small\" ng-class=\"thisRole.roleColor\"></div><div class=\"marginLeft10\">{{thisRole.roleTitle}}</div>\n</div></md-option></md-select></md-input-container></div><div \nng-if=\"vm.thisSignoff.item_data.signoffAssigneeType==\'user\'\"><div flex class=\"input-block\"><md-input-container \nlayout-fill><label>Signoff User :</label><md-select ng-model=\"vm.thisSignoff.item_data.signoffAssigneeID\" \nng-change=\"vm.setSigneeData(); vm.updateSignoff(vm.thisSignoff.id);\"><md-option \nng-repeat=\"thisUserRole in vm.cadwolf_fileInfo.item_data.userRoles\" value=\"{{thisUserRole.userID}}\" \nng-if=\"thisUserRole.roleID==vm.thisSignoff.item_data.signoffAssigneeRoleID\"><div layout=\"row\"><div><img \nclass=\"profile-image avatar\" ng-src=\"{{thisUserRole.userPhoto}}\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/team/default.png\"></div><div class=\"marginLeft10\">\n{{thisUserRole.userUserName}}</div><div class=\"marginLeft10\">{{thisUserRole.userName}}</div></div></md-option>\n</md-select></md-input-container></div></div><div flex class=\"input-block\"><md-input-container layout-fill><label>\nSignoff Event :</label><md-select ng-model=\"vm.thisSignoff.item_data.signoffEventID\" \nng-change=\"vm.runEventDigest(); vm.updateSignoff(vm.thisSignoff.id);\"><md-option \nng-repeat=\"thisEvent in vm.cadwolf_fileInfo.events\" value=\"{{thisEvent.id}}\"><div layout=\"row\"><div \nclass=\"display-color-small\" ng-class=\"thisEvent.item_data.eventColor\"></div><div class=\"marginLeft10\">\n{{thisEvent.item_data.eventTitle}}</div></div></md-option></md-select></md-input-container></div><div flex \nclass=\"input-block\" ng-repeat=\"thisEvent in vm.cadwolf_fileInfo.events\" \nng-if=\"thisEvent.id == vm.thisSignoff.item_data.signoffEventID\"><md-input-container layout-fill \nng-if=\"!thisEvent.item_data.eventApplyAll\"><label>Signoff Document:</label><md-select \nng-model=\"vm.thisSignoff.item_data.signoffDocID\" ng-change=\"vm.runEventDigest(); vm.updateSignoff(vm.thisSignoff.id);\">\n<md-option ng-repeat=\"thisItem in thisEvent.item_data.eventFiles\" value=\"{{thisItem.eventDocID}}\">\n{{thisItem.eventDocName}}</md-option></md-select></md-input-container><md-input-container layout-fill \nng-if=\"thisEvent.item_data.eventApplyAll\"><label>Signoff Document:</label><md-select \nng-model=\"vm.thisSignoff.item_data.signoffDocID\" ng-change=\"vm.runEventDigest(); vm.updateSignoff(vm.thisSignoff.id);\">\n<md-option ng-repeat=\"thisItem in vm.cadwolf_fileInfo.items\" value=\"{{thisItem.item_data.fileData.id}}\">\n{{thisItem.item_data.fileData.name}}</md-option></md-select></md-input-container></div></div></div></div>\n<md-dialog-actions><md-button class=\"md-accent md-raised\" ng-click=\"vm.hide()\" type=\"submit\" \naria-label=\"Finished Editing Role\"><span>Finished Editing</span></md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/apps/workflow/views/dialogs/tasks.html","<div layout=\"column\" flex=\"90\" flex-offset=\"5\"><div layout=\"row\" layout-align=\"center center\" class=\"marginTop20\"><div \nclass=\"md-title\">Workflow Tasks</div></div><div layout=\"row\" layout-align=\"center center\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"marginTop20\"><md-button class=\"md-accent md-raised\" ng-click=\"vm.addTask()\" \ntype=\"submit\" aria-label=\"Add New Task\"><span>Add New Task</span></md-button></div></div><div \nclass=\"body-1 marginTop20 marginBottom20\">\nThis view lets users create and then assign tasks that need to be carried out in an effort to complete the project managed by the workflow. Creating tasks lets users see what needs to be done and whether or not they have the ability to contribute. Assigning tasks lets the project get managed in an efficient manner.\n</div><div class=\"borderBottom marginBottom20\" \nng-repeat=\"thisItem in vm.tasks | orderBy:\'thisItem.created_at\' track by $index\" ng-if=\"thisItem.parent_id==0\"><div \nng-if=\" thisItem.user_id != Spark.state.user.id || thisItem.item_data.editStatus == 0 \" \nclass=\"md-title paddingBottom10\">{{thisItem.item_data.taskTitle}}</div><div \nng-if=\" thisItem.user_id != Spark.state.user.id || thisItem.item_data.editStatus == 0 \" \ndata-ng-bind-html=\"thisItem.item_data.taskBody\"></div><div \nng-if=\" thisItem.user_id == Spark.state.user.id && thisItem.item_data.editStatus == 1 \" \nclass=\"md-title marginTop10 paddingBottom10\"><md-input-container class=\"md-block\" flex=\"100\"><label>Task Title</label>\n<input ng-model=\"thisItem.item_data.taskTitle\" ng-enter=\"thisItem.item_data.editStatus=0\"></md-input-container></div>\n<div ng-if=\" thisItem.user_id == Spark.state.user.id && thisItem.item_data.editStatus == 1\"><text-angular \nng-model=\"thisItem.item_data.taskBody\"></text-angular></div><div layout=\"row\"><div \nng-if=\" thisItem.user_id == Spark.state.user.id && thisItem.item_data.editStatus == 0 \" \nng-click=\" thisItem.item_data.editStatus = 1 \" class=\"marginTop10 marginRight10 hoverMe blueText\">Edit</div><div \nng-if=\" thisItem.user_id == Spark.state.user.id && thisItem.item_data.editStatus == 1 \" \nng-click=\" thisItem.item_data.editStatus = 0; vm.updateTask( thisItem ) \" \nclass=\"marginTop10 marginRight10 hoverMe blueText\">Done</div><div ng-if=\" thisItem.user_id == Spark.state.user.id \" \nng-click=\" vm.deleteTask( thisItem.id ) \" class=\"marginTop10 marginRight10 hoverMe blueText\">Delete</div><div \nng-click=\" vm.addTask( thisItem.id ) \" class=\"marginTop10 marginRight10 hoverMe blueText\">Respond</div></div><div \nworkflow-task layout=\"column\" class=\"marginBottom0 paddingBottom10 marginTop20 marginLeft10\" ng-style=\"\" \nng-repeat=\"newItem in vm.tasks | orderBy:\'date_created\' track by $index\" id=\"newItem.id\" list-items=\"vm.tasks\" \nspark=\"Spark\" ng-if=\"newItem.parent_id==$parent.thisItem.id\"></div></div></div>");
$templateCache.put("app/main/apps/workflow/views/dialogs/timeline.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button ng-click=\"vm.showAddModal($event)\" class=\"md-icon-button add-row-button\" ng-if=\"vm.editPerm\" \naria-label=\"Add\" translate translate-attr-aria-label=\"WORKFLOW.ADD\"><md-icon md-font-icon=\"icon-plus\"><md-tooltip \nmd-direction=\"bottom\">Add / Delete Rows in Workflow</md-tooltip></md-icon></md-button><md-button \nng-click=\"vm.showEventModal($event)\" class=\"md-icon-button add-row-button\" aria-label=\"Events\" translate \ntranslate-attr-aria-label=\"WORKFLOW.EVENTS\"><md-icon md-font-icon=\"icon-calendar-select\"><md-tooltip \nmd-direction=\"bottom\">Add and Edit Events</md-tooltip></md-icon></md-button><md-button \nng-click=\"vm.showRoleModal($event)\" class=\"md-icon-button add-row-button\" aria-label=\"Roles\" translate \nng-if=\"vm.editPerm\" translate-attr-aria-label=\"WORKFLOW.ROLES\"><md-icon md-font-icon=\"icon-account\"><md-tooltip \nmd-direction=\"bottom\">Add and Edit Roles</md-tooltip></md-icon></md-button><md-button \nng-click=\"vm.showSignoffModal($event)\" class=\"md-icon-button add-row-button\" aria-label=\"Tasks\" translate \ntranslate-attr-aria-label=\"WORKFLOW.SIGNOFF\"><md-icon md-font-icon=\"icon-clipboard-check\"><md-tooltip \nmd-direction=\"bottom\">Add and Edit Signoffs</md-tooltip></md-icon></md-button><md-button \nng-click=\"vm.showEditModal($event)\" class=\"md-icon-button add-row-button\" aria-label=\"Edit Settings\" translate \ntranslate-attr-aria-label=\"WORKFLOW.EDIT\"><md-icon md-font-icon=\"icon-cog\"><md-tooltip md-direction=\"bottom\">\nEdit Settings and Update Data</md-tooltip></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\">\n<div class=\"zoom\" layout=\"row\" layout-align=\"end center\"><div class=\"input-block\" flex layout=\"row\" layout-margin \nlayout-align=\"space-between center\"><md-datepicker name=\"fromDate\" ms-datepicker-fix \nng-model=\"vm.cadwolf_fileInfo.item_data.settings.dates.startDate\" \nng-change=\"vm.getEndDates(); \n																  vm.calcLogDays();  \n																  vm.populateDates(); \n																  vm.calcEventDays(); \n																  vm.calcWidths();\n																  vm.updateWorkflow();\n																  vm.updateEvents();\n																  vm.updateItems();\" \nmd-placeholder=\"Start Date\" ng-required></md-datepicker></div><div class=\"input-block\" flex layout=\"row\" layout-margin \nlayout-align=\"space-between center\"><md-datepicker name=\"toDate\" ms-datepicker-fix \nng-model=\"vm.cadwolf_fileInfo.item_data.settings.dates.endDate\" \nng-change=\"vm.getEndDates(); \n																  vm.calcLogDays();  \n																  vm.populateDates(); \n																  vm.calcEventDays(); \n																  vm.calcWidths();\n																  vm.updateWorkflow();\n																  vm.updateEvents();\n																  vm.updateItems();\" \nmd-placeholder=\"End Date\" ng-required></md-datepicker></div><span class=\"label\">Pixels per Day :</span><div \nclass=\"input-wrapper\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" aria-label=\"minus\" \nng-click=\"vm.dayColWidth  = vm.dayColWidth - 1; vm.calcWidths();\"><md-icon md-font-icon=\"icon-minus\"></md-icon>\n</md-button><input type=\"number\" ng-model=\"vm.dayColWidth\" \nng-change=\"vm.getEndDates(); \n																  vm.calcLogDays();  \n																  vm.populateDates(); \n																  vm.calcEventDays(); \n																  vm.calcWidths();\n																  vm.updateWorkflow();\n																  vm.updateEvents();\n																  vm.updateItems(); \" \nstep=\"1\" min=\"3\" max=\"40\"><md-button class=\"md-icon-button\" aria-label=\"plus\" \nng-click=\"vm.dayColWidth = vm.dayColWidth + 1; vm.calcWidths();\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div></div></div></div><div class=\"workflow\" ng-style=\"{\'height\':\'100%\'}\" layout=\"row\"><div \nclass=\"workflow-side\"><div class=\"workflow-side\"><div class=\"workflow-tree-header-row\"><span \nclass=\"workflow-label-text\">Name</span></div></div><div workflow-list \nng-repeat=\"system in vm.cadwolf_fileInfo.items | orderBy:\'order\' track by $index\" id=\"system.item_data.fileData.id\" \nlist-items=\"vm.cadwolf_fileInfo.items\" spark=\"Spark\" permissions=\"vm.cadwolf_fileInfo.item_data.permissions\" \nng-if=\"system.item_data.topItem\" show-children=\"system.item_data.showChildren\" this-system=\"system\"></div></div><div \nclass=\"workflow-task\"><div layout=\"column\" class=\"marginBottom10\"><div layout=\"row\" class=\"date-line\"><div \nclass=\"workflow-year\" ng-repeat=\"thisYear in vm.yearArray track by $index\" ng-style=\"{\'min-width\':thisYear.width}\">\n{{thisYear.name}}</div></div><div layout=\"row\" class=\"date-line\"><div class=\"workflow-month\" \nng-repeat=\"thisMonth in vm.monthArray track by $index\" ng-style=\"{\'min-width\':thisMonth.width}\"><span \nng-if=\"thisMonth.width>=40\">{{thisMonth.name}}</span></div></div><div layout=\"row\" class=\"day-line\" \nng-if=\"vm.dayColWidth >= 15\"><div class=\"workflow-day\" ng-repeat=\"thisDay in vm.dayArray track by $index\" \nng-style=\"{\'min-width\':vm.dayColWidth}\">{{thisDay}}</div></div><div layout=\"row\" class=\"day-line-small\" \nng-if=\"vm.dayColWidth < 15 && vm.dayColWidth >= 10\"><div class=\"workflow-day\" \nng-repeat=\"thisDay in vm.dayArray track by $index\" ng-style=\"{\'min-width\':vm.dayColWidth}\">{{thisDay}}</div></div><div \nlayout=\"row\" class=\"day-line-small\" ng-if=\"vm.dayColWidth < 10 && vm.dayColWidth > 3\"><div class=\"workflow-day\" \nng-repeat=\"thisDay in vm.dayArray track by $index\" ng-style=\"{\'min-width\':vm.dayColWidth}\"></div></div></div><div \nlayout=\"column\"><div class=\"workflow-tree-body\"><div workflow-events layout=\"column\" \nng-style=\"{\'min-width\':vm.totalWidth}\" \nng-repeat=\"thisItem in vm.cadwolf_fileInfo.items | orderBy:\'order\' track by $index\" \nid=\"thisItem.item_data.fileData.id\" list-items=\"vm.cadwolf_fileInfo.items\" events=\"vm.cadwolf_fileInfo.events\" \nsettings=\"vm.cadwolf_fileInfo.item_data.settings\" spark=\"Spark\" \npermissions=\"vm.cadwolf_fileInfo.item_data.permissions\" show-e-v-modal=\"vm.showEVModal\" \nng-if=\"thisItem.item_data.topItem\" total-width=\"vm.totalWidth\"></div></div></div></div></div>");
$templateCache.put("app/main/apps/workflow/views/dialogs/view-event-dialog.html","<md-dialog class=\"workflow-edit-dialog\" aria-label=\"Event Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">\nEvent - {{vm.thisEvent.item_data.eventTitle}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\" aria-label=\"close dialog\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-tabs md-dynamic-height><md-tab><md-tab-label>\n<span translate=\"WORKFLOW.OVERVIEW\">Overview</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/apps/workflow/views/dialogs/view-event-overview.html\'\"></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"WORKFLOW.ITEMS_AND_SIGNOFFS\">Items and Signoffs</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/apps/workflow/views/dialogs/view-event-signoffs.html\'\"></div></md-tab-body></md-tab></md-tabs>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/workflow/views/dialogs/view-event-overview.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\"><div layout=\"row\"><div \nlayout=\"column\" flex=\"60\" flex-offset=\"20\"><div class=\"md-title layout-margin\">Event Properties</div><div \nclass=\"layout-margin\"><div layout=\"row\" flex=\"100\" class=\"taskTitle\"><div flex=\"50\">Event Title</div><div flex=\"25\">\nStart Date</div><div flex=\"25\">End Date</div></div></div><div class=\"layout-margin\"><div layout=\"row\" flex=\"100\"><div \nflex=\"5\" class=\"display-color-med\" ng-class=\"vm.thisEvent.item_data.eventColor\"></div><div flex=\"45\" \nclass=\"marginLeft10 marginTop5\">{{vm.thisEvent.item_data.eventTitle}}</div><div flex=\"25\" class=\"marginTop5\">\n{{vm.thisEvent.item_data.eventStartShowMonth}} {{vm.thisEvent.item_data.eventStartDay}}, {{vm.thisEvent.item_data.eventStartYear}}\n</div><div flex=\"25\" class=\"marginTop5\">\n{{vm.thisEvent.item_data.eventEndShowMonth}} {{vm.thisEvent.item_data.eventEndDay}}, {{vm.thisEvent.item_data.eventEndYear}}\n</div></div></div><div class=\"md-title\" layout-margin>Event Creator</div><div><div layout=\"row\"><div flex=\"25\" \nflex-offset=\"25\" class=\"avatar-wrapper ng-scope\"><img md-menu-align-target=\"\" class=\"avatar huge\" \nng-src=\"{{vm.thisEvent.item_data.eventCreatorPhoto}}\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"></div><div layout=\"column\" flex=\"50\"><div \nlayout=\"row\" class=\"marginBottom10\"><div class=\"marginRight20\">Name :</div><div>\n{{vm.thisEvent.item_data.eventCreatorName}}</div></div><div layout=\"row\" class=\"marginBottom10\"><div \nclass=\"marginRight20\">User Name</div><div>{{vm.thisEvent.item_data.eventCreatorUserName}}</div></div><div layout=\"row\" \nclass=\"marginBottom10\"><div class=\"marginRight20\">Date Created</div><div>{{vm.thisEvent.item_data.eventCreateDate}}\n</div></div></div></div></div><div class=\"md-title layout-margin\">Event Description</div><div flex=\"100\" \ndata-ng-bind-html=\"vm.thisEvent.item_data.eventDescription\"></div></div></div></div><md-dialog-actions><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.calcEventDays();\n					   			 vm.calcWidths();\n					   			 vm.hide()\" \ntype=\"submit\" aria-label=\"Finished Editing Event\"><span>Finished Editing</span></md-button></md-dialog-actions></form>\n</div>");
$templateCache.put("app/main/apps/workflow/views/dialogs/view-event-signoffs.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\"><div layout=\"row\"><div \nlayout=\"column\" flex=\"80\" flex-offset=\"10\"><div layout=\"column\"><md-list flex=\"100\" class=\"taskList\"><md-list-item \nflex=\"90\" flex-offset=\"10\" class=\"taskTitle\"><div flex=\"5\"></div><div flex=\"30\" class=\"textCentered\">Signoff Name</div>\n<div flex=\"25\" class=\"textCentered\">Role</div><div flex=\"25\" class=\"textCentered\">User</div><div flex=\"15\" \nclass=\"textCentered\">Due Date</div><div flex=\"5\" class=\"textCentered\">Status</div></md-list-item></md-list><div \nworkflow-show-signoffs layout=\"column\" \nng-repeat=\"thisItem in vm.cadwolf_fileInfo.items | orderBy:\'order\' track by $index\" \nid=\"thisItem.item_data.fileData.id\" list-items=\"vm.cadwolf_fileInfo.items\" events=\"vm.cadwolf_fileInfo.events\" \nspark=\"Spark\" this-item=\"thisItem\" signoffs=\"vm.cadwolf_fileInfo.signoffs\" \npermissions=\"vm.cadwolf_fileInfo.item_data.permissions\" this-event=\"vm.thisEvent\" ng-if=\"thisItem.item_data.topItem\">\n</div></div></div></div></div><md-dialog-actions><md-button class=\"md-accent md-raised\" ng-click=\"vm.hide()\" \ntype=\"submit\" aria-label=\"Close\"><span>Close</span></md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/apps/workflow/views/showDialogs/event-rows-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\"><div layout=\"row\"><div \nlayout=\"column\" class=\"edit-item-left\"><div class=\"edit-item-select\" layout=\"row\" \nng-repeat=\"thisEvent in vm.cadwolf_fileInfo.events track by $index\" \nng-click=\"vm.thisEvent = thisEvent; vm.popEventItems();\" ng-class=\"{\'selected\' : vm.thisEvent === thisEvent}\"><div \nclass=\"edit-item-select-color\" ng-class=\"thisEvent.item_data.eventColor\"></div><div class=\"edit-item-select-title\">\n{{thisEvent.item_data.eventTitle}}</div></div></div><div layout=\"column\" flex=\"60\" flex-offset=\"10\" \nclass=\"edit-item-right\" ng-if=\"vm.thisEvent.item_data.eventID === undefined\"><div layout=\"row\" layout-padding><div \nclass=\"md-title\">Select event to see items</div></div></div><div layout=\"column\" flex=\"60\" flex-offset=\"10\" \nclass=\"edit-item-right\" ng-if=\"vm.thisEvent.item_data.eventID !== undefined\"><div class=\"md-title\">Assigned Documents\n</div><md-list layout-margin flex=\"80\" flex-offset=\"10\" class=\"borderMe\" \nng-if=\"vm.thisEvent.item_data.eventFiles.length > 0\"><md-list-item flex=\"100\" borderbottom \nng-repeat=\"thisDoc in vm.thisEvent.item_data.eventFiles\"><div flex=\"80\" class=\"\">{{thisDoc.eventDocName}}</div>\n</md-list-item></md-list></div></div></div></form></div><md-dialog-actions><md-button class=\"md-accent md-raised\" \nng-click=\"vm.hide();\" type=\"submit\" aria-label=\"Finished Editing Event\"><span>Finished Editing</span></md-button>\n</md-dialog-actions>");
$templateCache.put("app/main/apps/workflow/views/showDialogs/event-settings-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\"><div layout=\"row\"><div \nlayout=\"column\" class=\"edit-item-left\"><div class=\"edit-item-select paddingBottom20\" layout=\"row\" \nng-if=\"vm.conditionalEdit\"><md-icon md-font-icon=\"icon-plus\" ng-click=\"vm.addEvent()\"><md-tooltip \nmd-direction=\"bottom\">Add New Event</md-tooltip></md-icon></div><div class=\"edit-item-select\" layout=\"row\" \nng-repeat=\"thisEvent in vm.cadwolf_fileInfo.events track by $index\" \nng-click=\"vm.thisEvent = thisEvent;  vm.popEventItems();\" ng-class=\"{\'selected\' : vm.thisEvent === thisEvent}\"><div \nclass=\"edit-item-select-color\" ng-class=\"thisEvent.item_data.eventColor\"></div><div class=\"edit-item-select-title\">\n{{thisEvent.item_data.eventTitle}}</div></div></div><div layout=\"column\" flex=\"60\" flex-offset=\"10\" \nclass=\"edit-item-right\" ng-if=\"vm.thisEvent.item_data.eventID === undefined\"><div layout=\"row\" layout-padding><div \nclass=\"md-title\">Select event to edit properties</div></div></div><div layout=\"column\" flex=\"60\" flex-offset=\"10\" \nclass=\"edit-item-right\" ng-if=\"vm.thisEvent.item_data.eventID !== undefined\"><div \nclass=\"md-title marginTop40 marginBottom20\">Event Properties</div><div class=\"layout-margin\"><div layout=\"row\" \nflex=\"100\" class=\"taskTitle\"><div flex=\"35\">Event Title</div><div flex=\"25\">Event Type</div><div flex=\"20\">Start Date\n</div><div flex=\"20\">End Date</div></div></div><div class=\"layout-margin\"><div layout=\"row\" flex=\"100\"><div flex=\"5\" \nclass=\"display-color-med\" ng-class=\"vm.thisEvent.item_data.eventColor\"></div><div flex=\"30\" \nclass=\"marginLeft10 marginTop5\">{{vm.thisEvent.item_data.eventTitle}}</div><div flex=\"25\" \nclass=\"marginLeft10 marginTop5\" ng-if=\"vm.thisEvent.item_data.eventType != \'Other\'\">\n{{vm.thisEvent.item_data.eventType}}</div><div flex=\"25\" class=\"marginLeft10 marginTop5\" \nng-if=\"vm.thisEvent.item_data.eventType == \'Other\'\">{{vm.thisEvent.item_data.eventTypeAlt}}</div><div flex=\"20\" \nclass=\"marginTop5\">\n{{vm.thisEvent.item_data.eventStartShowMonth}}, {{vm.thisEvent.item_data.eventStartDay}} {{vm.thisEvent.item_data.eventStartYear}}\n</div><div flex=\"20\" class=\"marginTop5\">\n{{vm.thisEvent.item_data.eventEndShowMonth}}, {{vm.thisEvent.item_data.eventEndDay}} {{vm.thisEvent.item_data.eventEndYear}}\n</div></div></div><div class=\"md-title marginTop40 marginBottom20\">Event Creator</div><div><div layout=\"row\"><div \nflex=\"25\" flex-offset=\"25\" class=\"avatar-wrapper ng-scope\"><img md-menu-align-target=\"\" class=\"avatar huge\" \nng-src=\"{{vm.thisEvent.item_data.eventCreatorPhoto}}\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"></div><div layout=\"column\" flex=\"50\"><div \nlayout=\"row\" class=\"marginBottom10\"><div class=\"marginRight20\">Name :</div><div>\n{{vm.thisEvent.item_data.eventCreatorName}}</div></div><div layout=\"row\" class=\"marginBottom10\"><div \nclass=\"marginRight20\">User Name</div><div>{{vm.thisEvent.item_data.eventCreatorUserName}}</div></div><div layout=\"row\" \nclass=\"marginBottom10\"><div class=\"marginRight20\">Date Created</div><div>{{vm.thisEvent.item_data.eventCreateDate}}\n</div></div></div></div></div><div class=\"md-title marginTop40 marginBottom20\">Event Description</div><div flex=\"100\" \ndata-ng-bind-html=\"vm.thisEvent.item_data.eventDescription\"></div></div></div></div><md-dialog-actions><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.hide();\" type=\"submit\" aria-label=\"Finished Editing Event\"><span>\nFinished Editing</span></md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/apps/workflow/views/showDialogs/event-signoffs-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\"><div layout=\"row\"><div \nlayout=\"column\" class=\"edit-item-left\"><div class=\"edit-item-select\" layout=\"row\" \nng-repeat=\"thisEvent in vm.cadwolf_fileInfo.events track by $index\" \nng-click=\"vm.thisEvent = thisEvent;  vm.popEventItems();\" ng-class=\"{\'selected\' : vm.thisEvent === thisEvent}\"><div \nclass=\"edit-item-select-color\" ng-class=\"thisEvent.item_data.eventColor\"></div><div class=\"edit-item-select-title\">\n{{thisEvent.item_data.eventTitle}}</div></div></div><div layout=\"column\" flex=\"60\" flex-offset=\"10\" \nclass=\"edit-item-right\" ng-if=\"vm.thisEvent.item_data.eventID !== undefined\"><div layout=\"column\"><md-list flex=\"100\" \nclass=\"taskList\"><md-list-item flex=\"90\" flex-offset=\"10\" class=\"taskTitle\"><div flex=\"5\"></div><div flex=\"25\" \nclass=\"textCentered\">Signoff Name</div><div flex=\"25\" class=\"textCentered\">Role</div><div flex=\"25\" \nclass=\"textCentered\">User</div><div flex=\"15\" class=\"textCentered\">Due Date</div><div flex=\"5\" class=\"textCentered\">\nStatus</div></md-list-item></md-list><md-list flex=\"100\" class=\"taskList\" \nng-repeat=\"thisItem in vm.cadwolf_fileInfo.items\"><md-list-item flex=\"100\" class=\"taskItem md-subhead\">\n{{thisItem.item_data.fileData.name}}</md-list-item><md-list-item flex=\"90\" flex-offset=\"10\" \nng-repeat=\"thisSignoff in vm.cadwolf_fileInfo.signoffs\" \nng-if=\"thisSignoff.item_data.signoffDocID == thisItem.item_data.fileData.id &&\n										  		 thisSignoff.item_data.signoffEventID == vm.thisEvent.id\" \nclass=\"taskItem textCentered\"><div flex=\"5\" class=\"display-color-med\" ng-class=\"thisSignoff.item_data.signoffColor\">\n</div><div flex=\"25\" class=\"textCentered\">{{thisSignoff.item_data.signoffTitle}}</div><div flex=\"25\" \nclass=\"textCentered\">{{thisSignoff.item_data.signoffAssigneeRoleTitle}}</div><div flex=\"25\" class=\"textCentered\" \nng-if=\"thisSignoff.item_data.signoffAssigneeType==\'user\'\">{{thisSignoff.item_data.signoffAssigneeUserName}}</div><div \nflex=\"15\" class=\"textCentered\">\n{{thisSignoff.item_data.signoffDueDay}}-{{thisSignoff.item_data.signoffDueMonth}}-{{thisSignoff.item_data.signoffDueYear}}\n</div><div flex=\"5\" class=\"textCentered\" ng-if=\"thisSignoff.item_data.signoffStatus\"><md-icon \nmd-font-icon=\"icon-check-circle\" aria-label=\"Not Signed\" class=\"iconGreenBackground\"><md-tooltip md-direction=\"bottom\">\nSignoff approved</md-tooltip></md-icon></div><div flex=\"5\" class=\"textCentered\" \nng-if=\"!thisSignoff.item_data.signoffStatus\"><md-icon md-font-icon=\"icon-clock\" aria-label=\"Signed\" \nclass=\"iconRedBackground\"><md-tooltip md-direction=\"bottom\">Signoff not approved yet</md-tooltip></md-icon></div>\n</md-list-item></md-list></div></div></div></div><md-dialog-actions><md-button class=\"md-accent md-raised\" \nng-click=\"vm.hide()\" type=\"submit\" aria-label=\"Finished Editing Event\"><span>Finished Editing</span></md-button>\n</md-dialog-actions></form></div>");
$templateCache.put("app/main/apps/workflow/views/showDialogs/role-settings-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\"><div layout=\"row\"><div \nlayout=\"column\" class=\"edit-item-left\"><div class=\"edit-item-select\" layout=\"row\" \nng-repeat=\"thisRole in vm.cadwolf_fileInfo.item_data.roles\" ng-click=\"vm.thisRole = thisRole\" \nng-class=\"{\'selected\' : vm.thisRole === thisRole}\"><div class=\"edit-item-select-color\" ng-class=\"thisRole.roleColor\">\n</div><div class=\"edit-item-select-title\">{{thisRole.roleTitle}}</div></div></div><div layout=\"column\" flex=\"60\" \nflex-offset=\"10\" class=\"edit-item-right\" ng-if=\"vm.thisRole.roleID === undefined\"><div layout=\"row\" layout-padding><div\n class=\"md-title\">Select Role to edit properties</div></div></div><div layout=\"column\" flex=\"50\" flex-offset=\"15\" \nclass=\"edit-item-right\" ng-if=\"vm.thisRole.roleID !== undefined\"><div layout-margin><div layout=\"row\"><div \nclass=\"display-color-med\" ng-class=\"vm.thisRole.roleColor\"></div><div class=\"marginLeft10\">{{vm.thisRole.roleTitle}}\n</div></div><div data-ng-bind-html=\"vm.thisRole.roleDescription\"></div></div></div></div></div><md-dialog-actions>\n<md-button class=\"md-accent md-raised\" ng-click=\"vm.hide()\" type=\"submit\" aria-label=\"Finished\"><span>Finished Editing\n</span></md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/apps/workflow/views/showDialogs/role-users-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\"><div layout=\"row\"><div \nlayout=\"column\" class=\"edit-item-left\"><div class=\"edit-item-select\" layout=\"row\" \nng-repeat=\"thisRole in vm.cadwolf_fileInfo.item_data.roles\" ng-click=\"vm.thisRole = thisRole\" \nng-class=\"{\'selected\' : vm.thisRole === thisRole}\"><div class=\"edit-item-select-color\" ng-class=\"thisRole.roleColor\">\n</div><div class=\"edit-item-select-title\">{{thisRole.roleTitle}}</div></div></div><div layout=\"column\" flex=\"60\" \nflex-offset=\"10\" class=\"edit-item-right\" ng-if=\"vm.thisRole.roleID === undefined\"><div layout-margin><div \nclass=\"md-title\">Select Role to see users</div></div></div><div layout=\"column\" flex=\"60\" flex-offset=\"10\" \nclass=\"edit-item-right\" ng-if=\"vm.thisRole.roleID !== undefined\"><div layout-margin><div class=\"md-title\">\nUsers assigned to \"{{vm.thisRole.roleTitle}}\"</div></div><md-list layout-margin flex=\"80\" flex-offset=\"10\">\n<md-list-item flex=\"100\" ng-repeat=\"thisUserRole in vm.cadwolf_fileInfo.item_data.userRoles\" \nng-if=\"thisUserRole.roleID == vm.thisRole.roleID\"><div flex=\"10\"><img class=\"profile-image avatar\" \nng-src=\"{{thisUserRole.userPhoto}}\" on-error-src=\"https://cadwolf.s3.amazonaws.com/team/default.png\"></div><div \nflex=\"40\" class=\"marginTop10\">{{thisUserRole.userUserName}}</div><div flex=\"40\" class=\"marginTop10\">\n{{thisUserRole.userName}}</div></md-list-item></md-list></div></div></div><md-dialog-actions><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.hide()\" type=\"submit\" aria-label=\"Finished\"><span>Finished Editing</span>\n</md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/apps/workflow/views/showDialogs/signoff-items-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\"><div layout=\"row\"><div \nlayout=\"column\" class=\"edit-item-left\"><div class=\"edit-item-select\" layout=\"row\" \nng-repeat=\"thisSignoff in vm.cadwolf_fileInfo.signoffs\" ng-click=\"vm.thisSignoff = thisSignoff\" \nng-class=\"{\'selected\' : vm.thisSignoff === thisSignoff}\"><div class=\"edit-item-select-color\" \nng-class=\"thisSignoff.item_data.signoffColor\"></div><div class=\"edit-item-select-title\">\n{{thisSignoff.item_data.signoffTitle}}</div></div></div><div class=\"md-title\">\nSignoffs for Event - {{vm.thisEvent.item_data.eventTitle}}</div><div layout=\"column\" flex=\"65\" class=\"edit-item-right\" \nflex-offset=\"10\"><div workflow-item-signoffs layout=\"column\" \nng-repeat=\"thisItem in vm.cadwolf_fileInfo.items track by $index\" id=\"thisItem.item_data.fileData.id\" \nlist-items=\"vm.cadwolf_fileInfo.items\" events=\"vm.cadwolf_fileInfo.events\" signoffs=\"vm.cadwolf_fileInfo.signoffs\" \nspark=\"Spark\" currentsignoff=\"vm.thisSignoff.item_data.signoffID\" this-system=\"thisItem\" \nng-if=\"thisItem.item_data.topItem\" class=\"borderBottom paddingTop15 paddingBottom10\"></div></div></div></div>\n<md-dialog-actions><md-button class=\"md-accent md-raised\" ng-click=\"vm.hide()\" type=\"submit\" \naria-label=\"Finished Editing Role\"><span>Finished Editing</span></md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/apps/workflow/views/showDialogs/signoff-properties-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\"><div class=\"form-content\"><div layout=\"row\"><div \nlayout=\"column\" class=\"edit-item-left\"><div class=\"edit-item-select paddingBottom20\" layout=\"row\" \nng-if=\"vm.conditionalEdit\"><md-icon md-font-icon=\"icon-plus\" ng-click=\"vm.addSignoff()\"><md-tooltip \nmd-direction=\"bottom\">Add New Signoff</md-tooltip></md-icon></div><div class=\"edit-item-select\" layout=\"row\" \nng-repeat=\"thisSignoff in vm.cadwolf_fileInfo.signoffs\" ng-click=\"vm.thisSignoff = thisSignoff\" \nng-class=\"{\'selected\' : vm.thisSignoff === thisSignoff}\"><div class=\"edit-item-select-color\" \nng-class=\"thisSignoff.item_data.signoffColor\"></div><div class=\"edit-item-select-title\">\n{{thisSignoff.item_data.signoffTitle}}</div></div></div><div layout=\"column\" flex=\"60\" flex-offset=\"10\" \nclass=\"edit-item-right\" ng-if=\"vm.thisSignoff.item_data.signoffID === undefined\"><div layout=\"row\" layout-padding><div \nclass=\"md-title\">Select Signoff</div></div></div><div layout=\"column\" flex=\"50\" flex-offset=\"10\" \nclass=\"edit-item-right\" ng-if=\"vm.thisSignoff.item_data.signoffID !== undefined\"><div layout=\"margin\"><div><div \nlayout=\"row\"><div class=\"taskTitle\">Signoff Name</div><div class=\"display-color-small marginLeft10\" \nng-class=\"vm.thisSignoff.item_data.signoffColor\"></div><div class=\"marginLeft10\">\n{{vm.thisSignoff.item_data.signoffTitle}}</div></div></div><div><div layout=\"row\"><div class=\"taskTitle\">Due Date</div>\n<div class=\"marginLeft10\">{{vm.thisSignoff.item_data.signoffDueDate}}</div></div></div><div><div layout=\"row\"><div \nclass=\"taskTitle\">Signoff Type</div><div class=\"marginLeft10\">{{vm.thisSignoff.item_data.signoffAssigneeType}}</div>\n</div></div><div><div layout=\"row\"><div class=\"taskTitle\">Signoff Role</div><div class=\"marginLeft10\">\n{{vm.thisSignoff.item_data.signoffAssigneeRoleTitle}}</div></div></div><div><div layout=\"row\"><div class=\"taskTitle\">\nSignoff User</div><div class=\"marginLeft10\">\n{{vm.thisSignoff.item_data.signoffAssigneeName}} - {{vm.thisSignoff.item_data.signoffAssigneeUserName}}</div></div>\n</div><div><div layout=\"row\"><div class=\"taskTitle\">Signoff Event</div><div class=\"marginLeft10\">\n{{vm.thisSignoff.item_data.signoffEventTitle}}</div></div></div><div><div layout=\"row\"><div class=\"taskTitle\">\nSignoff Document</div><div class=\"marginLeft10\">{{vm.thisSignoff.item_data.signoffDocTitle}}</div></div></div></div>\n</div></div></div><md-dialog-actions><md-button class=\"md-accent md-raised\" ng-click=\"vm.hide()\" type=\"submit\" \naria-label=\"Finished Editing Role\"><span>Finished Editing</span></md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/apps/workspace/views/list/editCopy.tmpl.html","<md-dialog-content ms-scroll><div layout=\"column\" layout-margin><div ng-if=\"vm.thisItem.file_type_id == \'Workspace\'\">\n<p>CADWOLF currently does not yet support copying full workspaces</p></div><div \nng-if=\"vm.thisItem.file_type_id != \'Workspace\'\" class=\"marginBottom20\"><p>\nTo copy this item, enter the workspace that will house the copy and the name of the new copy into the inputs below. Remember that names are used in URLs, so the name can contain only letters, numbers, dashes, and spaces.\n</p><p>When you have entered the desired destination workspace, hit enter.</p></div><div \nng-if=\"vm.thisItem.file_type_id != \'Workspace\'\"><md-input-container class=\"md-block\" flex=\"70\" flex-offset=\"15\"><label>\nLocation</label><input aria-label=\"Copy Location\" type=\"text\" ng-model=\"vm.thisLoc\" \nng-enter=\"vm.checkWorkspace( vm.thisLoc )\"></md-input-container></div><div \nng-if=\"vm.thisItem.file_type_id != \'Workspace\'\"><md-input-container class=\"md-block\" flex=\"70\" flex-offset=\"15\"><label>\nNew copy name</label><input name=\"newName\" aria-label=\"New Name\" type=\"text\" ng-model=\"vm.thisItem.newName\" required \nng-pattern=\"/[a-zA-Z0-9\\s\\-]{5,30}$/\" minlength=\"5\" maxlength=\"30\"><div ng-messages=\"copyForm.newName.error\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\">A name is required</div><div ng-message=\"pattern\">\nNames can only have letters, numbers, spaces, and dashes</div><div ng-message=\"minlength\">\nNames must have at least 5 characters</div><div ng-message=\"minlength\">Names can have no more than 30 characters</div>\n</div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-fill layout-align=\"end center\"><md-button \nng-if=\"vm.thisItem.file_type_id != \'Workspace\' && vm.validWorkspace\" \nng-click=\"vm.acceptCopy(vm.thisItem, vm.thisLoc);\" class=\"send-button md-accent md-raised\">Copy Item</md-button>\n<md-button ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">Cancel Copy</md-button></div>\n</md-dialog-actions>");
$templateCache.put("app/main/apps/workspace/views/list/editDelete.tmpl.html","<md-dialog-content ms-scroll><p>\nYou have chosen to delete \'{{vm.thisItem.name}}\'. Are you sure that you want to permanently delete this item?</p>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button ng-click=\"vm.acceptDelete(vm.thisItem);\" class=\"send-button md-accent md-raised\">\nDELETE ITEM</md-button><md-button ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">CANCEL</md-button>\n</div></md-dialog-actions>");
$templateCache.put("app/main/apps/workspace/views/list/editDescription.tmpl.html","<md-dialog-content ms-scroll><text-angular ng-model=\"vm.thisItem.newDesc\"></text-angular></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.acceptChanges(vm.thisItem.newDesc); vm.cancel();\" \nclass=\"send-button md-accent md-raised\">DONE</md-button><md-button type=\"submit\" ng-click=\"vm.cancel();\" \nclass=\"send-button md-accent md-raised\">CANCEL</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/workspace/views/list/editMove.tmpl.html","<md-dialog-content ms-scroll><p>\nTo move an item, enter the URL of the parent folder in the space below. If the location is valid and you have permission to add an item to that workspace then you can accept the move.\n</p><div layout=\"column\" flex=\"90\" flex-offset=\"5\"><md-input-container class=\"md-block\"><label>Location</label><input \naria-label=\"Move Location\" type=\"text\" ng-model=\"vm.thisLoc\" ng-enter=\"vm.getFiles( vm.thisLoc )\"></md-input-container>\n<div ng-repeat=\"file in vm.moveFiles\" layout=\"row\"><div ng-if=\"file.file_type_id==\'Workspace\'\" \nng-dblclick=\"vm.getFiles( vm.thisLoc, file.name )\" flex=\"5\"><md-icon md-font-icon=\"icon-folder-outline\"></md-icon>\n</div><div ng-if=\"file.file_type_id==\'Workspace\'\" ng-dblclick=\"vm.getFiles( vm.thisLoc, file.name )\" flex=\"80\">\n{{ file.name }}</div><div ng-if=\"file.file_type_id==\'Workspace\'\" \nng-dblclick=\"vm.acceptMove( { item : vm.thisItem, newParent : file.id, oldParent : vm.fileInfo.id } );\" flex=\"15\">\n<md-icon md-font-icon=\"icon-refresh\" class=\"hoverMe\"><md-tooltip md-direction=\"bottom\">Move here</md-tooltip></md-icon>\n</div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-fill layout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" \nclass=\"send-button md-accent md-raised\">CANCEL MOVE</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/workspace/views/list/editName.tmpl.html","<md-dialog-content ms-scroll><md-input-container class=\"md-block\" ng-if=\"vm.thisItem.parent_id!=null\"><label>New name\n</label><input name=\"newName\" aria-label=\"New Name\" type=\"text\" ng-model=\"vm.thisItem.newName\" required \nng-pattern=\"/^[a-zA-Z][a-zA-Z0-9\\s\\-\\,]{3,100}$/\" minlength=\"3\" maxlength=\"100\" ng-enter=\"\"><div \nng-messages=\"nameForm.newName.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\">\nA name is required</div><div ng-message=\"pattern\">Names can only have letters, numbers, spaces, commas, and dashes\n</div><div ng-message=\"minlength\">Names must have at least 3 characters</div><div ng-message=\"maxlength\">\nNames can have no more than 100 characters</div></div></md-input-container><div class=\"md-body-1\" \nng-if=\"vm.thisItem.parent_id==null\">The names of root workspaces can only be changed on the profile page.</div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.acceptName(vm.thisItem.newName); vm.cancel();\" \nclass=\"send-button md-accent md-raised\">SAVE NEW NAME</md-button><md-button type=\"submit\" ng-click=\"vm.cancel();\" \nclass=\"send-button md-accent md-raised\">CANCEL</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/workspace/views/list/editPermissions.tmpl.html","<md-dialog-content ms-scroll><div><div layout=\"row\" layout-fill layout-align=\"center center\" \nclass=\"md-title marginTopBottom20\">Permissions for {{vm.thisItem.name}}</div><md-divider></md-divider><div flex=\"90\" \nflex-offset=\"5\"><p>\nThere are three types of permission settings or workspaces, documents, and datasets. The types are view, edit, and admin. Users can set the view permissions so that everyone can view the item, that only those expressly given permission can view it, or so that the permissions are inherited from the parent folder. Edit and admin permissions can only be set to those on a list or to inherit.\n</p><p>\nHaving permission to view an item means that a user can see the document, see the workspace, or see the dataset. Having permission to edit the items means that you can add, remove, or change the content. Having admin permission means that you can also adjust the permission settings of other users.\n</p></div><div layout-fill><div layout=\"row\" layout-fill flex layout-align=\"center center\"><div flex=\"80\" \nflex-offset=\"10\" layout=\"row\"><div flex=\"25\" class=\"md-title marginTop15\">View Permissions</div><md-radio-group \nlayout=\"row\" ng-model=\"vm.thisItem.item_data.viewPerm\" flex=\"75\"><md-radio-button class=\"md-primary\" flex=\"35\" \nng-click=\"vm.thisItem.item_data.viewPerm = \'everyone\';\n  			 						 		   vm.handlePermissions(vm.thisItem, \'view\')\" \nvalue=\"everyone\">Everyone</md-radio-button><md-radio-button class=\"md-primary\" flex=\"35\" \nng-click=\"vm.thisItem.item_data.viewPerm = \'list\';\n  			 						 		   vm.handlePermissions(vm.thisItem, \'view\')\" \nvalue=\"list\">List of Users</md-radio-button><md-radio-button class=\"md-primary\" flex=\"30\" \nng-click=\"vm.thisItem.item_data.listPerm = \'inherit\';\n  			 						 		   vm.handlePermissions(vm.thisItem, \'view\')\" \nvalue=\"inherit\">Inherit from Parent</md-radio-button></md-radio-group></div></div><div layout=\"row\" layout-fill flex \nlayout-align=\"center center\"><div flex=\"80\" flex-offset=\"10\" layout=\"row\"><div flex=\"25\" class=\"md-title marginTop15\">\nEdit Permissions</div><md-radio-group layout=\"row\" ng-model=\"vm.thisItem.item_data.editPerm\" flex=\"75\"><div flex=\"35\">\n</div><md-radio-button class=\"md-primary\" flex=\"35\" \nng-click=\"vm.thisItem.item_data.editPerm = \'list\';\n  			 						 		   vm.handlePermissions(vm.thisItem, \'edit\')\" \nvalue=\"list\">List of Users</md-radio-button><md-radio-button class=\"md-primary\" flex=\"30\" \nng-click=\"vm.thisItem.item_data.editPerm = \'inherit\';\n  			 						 		   vm.handlePermissions(vm.thisItem, \'edit\')\" \nvalue=\"inherit\">Inherit from Parent</md-radio-button></md-radio-group></div></div><div layout=\"row\" layout-fill flex \nlayout-align=\"center start\"><div flex=\"80\" flex-offset=\"10\" layout=\"row\"><div flex=\"25\" class=\"md-title marginTop15\">\nAdmin Permissions</div><md-radio-group layout=\"row\" ng-model=\"vm.thisItem.item_data.adminPerm\" flex=\"75\"><div \nflex=\"35\"></div><md-radio-button class=\"md-primary\" flex=\"35\" \nng-click=\"vm.thisItem.item_data.adminPerm = \'list\';\n  			 						 		   vm.handlePermissions(vm.thisItem, \'admin\')\" \nvalue=\"list\">List of Users</md-radio-button><md-radio-button class=\"md-primary\" flex=\"30\" \nng-click=\"vm.thisItem.item_data.adminPerm = \'inherit\';\n  			 						 		   vm.handlePermissions(vm.thisItem, \'admin\')\" \nvalue=\"inherit\">Inherit from Parent</md-radio-button></md-radio-group></div></div><md-divider></md-divider><div \nflex=\"90\" flex-offset=\"5\"><p>\nEnter a user name and press enter to add that user to the list of approved users. If the user or team name is found, that person or team will be given the set permissions. Click the permission icons to change the permissins of any user.\n</p><p ng-if=\"vm.currentListPermError==\'noUser\'\">No user was found with that username</p></div><div layout=\"row\" \nlayout-align=\"center center\" flex=\"80\" flex-offset=\"10\" class=\"marginTopBottom20\"><md-input-container flex=\"40\" \nflex-offset=\"5\" layout-fill class=\"marginTop25\"><label>User Name</label><input ng-model=\"vm.potentialUser\" \nng-enter=\"vm.addPermUser( vm.thisItem );\"></md-input-container><md-input-container flex=\"25\" layout-fill \nflex-offset=\"5\"><label>User Type</label><md-select ng-model=\"vm.userType\"><md-option value=\"user\">User</md-option>\n<md-option value=\"team\">Team</md-option></md-select></md-input-container><md-input-container flex=\"25\" layout-fill \nflex-offset=\"5\"><label>Permissions Type</label><md-select ng-model=\"vm.permType\"><md-option value=\"view\">View\n</md-option><md-option value=\"edit\">Edit</md-option><md-option value=\"admin\">Admin</md-option></md-select>\n</md-input-container></div><md-divider></md-divider><div layout=\"row\" flex=\"80\" flex-offset=\"10\" \nlayout-align=\"center center\"><md-list class=\"innerList marginTopBottom20\"><md-list_item \nng-repeat=\"thisPerm in vm.thisItem.item_data.permList\"><div layout=\"row\" class=\"borderBottom\" \nlayout-align=\"space-between space-between\"><md-icon flex=\"5\" md-font-icon=\"icon-account\" \nng-if=\"thisPerm.user_type==\'user\'\" aria-label=\"User Permission\"></md-icon><md-icon flex=\"5\" \nmd-font-icon=\"icon-account-multiple\" ng-if=\"thisPerm.user_type==\'team\'\" aria-label=\"User Permission\"></md-icon><div \nflex=\"50\" ng-if=\"thisPerm.user_type==\'user\'\">User - {{thisPerm.user_name}}</div><div flex=\"50\" \nng-if=\"thisPerm.user_type==\'team\'\">Team - {{thisPerm.user_name}}</div><div layout=\"row\" flex=\"15\"><md-icon \nmd-font-icon=\"icon-eye\" class=\"greenIcon\" \nng-click=\"vm.changeUserPerm( vm.thisItem, thisPerm.user_id, thisPerm.user_type, \'view\')\" \naria-label=\"Change Permissions\"><md-tooltip md-direction=\"bottom\">Remove Permissions</md-tooltip></md-icon><md-icon \nmd-font-icon=\"icon-pencil\" ng-if=\"thisPerm.perm_type==\'view\'\" class=\"redIcon\" \nng-click=\"vm.changeUserPerm( vm.thisItem, thisPerm.user_id, thisPerm.user_type, \'edit\')\" \naria-label=\"Change Permissions\"><md-tooltip md-direction=\"bottom\">Add Edit Permissions</md-tooltip></md-icon><md-icon \nmd-font-icon=\"icon-pencil\" ng-if=\"thisPerm.perm_type==\'edit\' || thisPerm.perm_type==\'admin\'\" class=\"greenIcon\" \nng-click=\"vm.changeUserPerm( vm.thisItem, thisPerm.user_id, thisPerm.user_type, \'edit\')\" \naria-label=\"Change Permissions\"><md-tooltip md-direction=\"bottom\">Remove Edit Permissions</md-tooltip></md-icon>\n<md-icon md-font-icon=\"icon-verified\" ng-if=\"thisPerm.perm_type==\'view\'||thisPerm.perm_type==\'edit\'\" class=\"redIcon\" \nng-click=\"vm.changeUserPerm( vm.thisItem, thisPerm.user_id, thisPerm.user_type, \'admin\')\" \naria-label=\"Change Permissions\"><md-tooltip md-direction=\"bottom\">Add Admin Permissions</md-tooltip></md-icon><md-icon \nmd-font-icon=\"icon-verified\" ng-if=\"thisPerm.perm_type==\'admin\'\" class=\"greenIcon\" \nng-click=\"vm.changeUserPerm( vm.thisItem, thisPerm.user_id, thisPerm.user_type, \'admin\')\" \naria-label=\"Change Permissions\"><md-tooltip md-direction=\"bottom\">Remove Admin Permissions</md-tooltip></md-icon></div>\n<span flex></span><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"hoverMe\" \nng-click=\"vm.deletePermUser( vm.thisItem, thisPerm.user_id, thisPerm.user_type )\" aria-label=\"Delete User Permission\">\n<md-tooltip md-direction=\"bottom\">Delete this Permission</md-tooltip></md-icon></div></md-list_item></md-list></div>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-fill layout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" \nclass=\"send-button md-accent md-raised\">FINISHED CHANGES</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/workspace/views/list/editProperties.tmpl.html","<md-dialog-content ms-scroll><div class=\"md-title marginTop20 marginBottom20\">Edit the Title</div><md-input-container \nclass=\"md-block\" ng-if=\"vm.thisItem.parent_id!=null\"><label>New name</label><input name=\"newName\" \naria-label=\"New Name\" type=\"text\" ng-model=\"vm.thisItem.newName\" required \nng-pattern=\"/^[a-zA-Z][a-zA-Z0-9\\s\\-\\,]{3,100}$/\" minlength=\"3\" maxlength=\"100\" ng-enter=\"\"><div \nng-messages=\"nameForm.newName.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\">\nA name is required</div><div ng-message=\"pattern\">Names can only have letters, numbers, spaces, commas, and dashes\n</div><div ng-message=\"minlength\">Names must have at least 3 characters</div><div ng-message=\"maxlength\">\nNames can have no more than 100 characters</div></div></md-input-container><div class=\"md-body-1\" \nng-if=\"vm.thisItem.parent_id==null\">The names of root workspaces can only be changed on the profile page.</div><div \nclass=\"md-title marginTop20 marginBottom20\">Edit the Description</div><text-angular ng-model=\"vm.thisItem.newDesc\">\n</text-angular><div class=\"md-title marginTop20 marginBottom20\">Edit the Associated CAD Files</div><div layout=\"row\" \nlayout-fill layout-align=\"center center\"><md-button type=\"submit\" ng-click=\"vm.addCADFile( );\" \nclass=\"send-button md-accent md-raised\">Add CAD File</md-button></div><div flex=\"100\" layout=\"row\" \nng-if=\"vm.thisItem.item_data.CADFiles.length > 0\"><div flex=\"30\">Name of CAD FIle</div><div flex=\"70\">URL of CAD FIle\n</div></div><md-list class=\"marginTop20\" ng-if=\"vm.thisItem.item_data.CADFiles.length != 0\"><md-list-item \nclass=\"borderBottom\" layout-margin layout-fill layout=\"row\" flex=\"100\" \nng-repeat=\"thisCAD in vm.thisItem.item_data.CADFiles track by index\"><div flex=\"30\"><md-input-container \nclass=\"md-block\"><label>CAD name</label><input name=\"CADName\" aria-label=\"CAD Name\" type=\"text\" \nng-model=\"thisCAD.CADName\"></md-input-container></div><div flex=\"65\"><md-input-container class=\"md-block\"><label>\nCAD URL</label><input name=\"CADAddress\" aria-label=\"CAD URL\" type=\"text\" ng-model=\"thisCAD.CADAddress\">\n</md-input-container></div><div flex=\"5\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Delete CAD\" \nng-click=\"vm.removeCADFile($index)\"></md-icon></div></md-list-item></md-list><div \nng-if=\"vm.thisItem.item_data.CADFiles.length == 0\">No CAD files are linked to date</div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.acceptProps(vm.thisItem); vm.cancel();\" \nclass=\"send-button md-accent md-raised\">DONE</md-button><md-button type=\"submit\" ng-click=\"vm.cancel();\" \nclass=\"send-button md-accent md-raised\">CANCEL</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/workspace/views/list/emptyList.html","<div class=\"md-headline marginTop20\" ng-if=\"( Spark.state.user === null ) || ( Spark.state.user === undefined )\">\nCommon Workspaces</div><md-list ng-if=\"( Spark.state.user === null ) || ( Spark.state.user === undefined )\" \nclass=\"marginTop20\"><md-list-item layout=\"row\" class=\"borderBottom\"><div flex=\"15\">&nbsp</div><div flex=\"30\" \ntranslate=\"FM.NAME\" class=\"md-title\">Name</div><div flex=\"55\" hide-xs translate=\"FM.LOCATION\" class=\"md-title\">Location\n</div></md-list-item><md-list-item class=\"borderBottom\" layout=\"row\"><div flex=\"10\"><md-icon \nmd-font-icon=\"icon-folder-outline\" ng-click=\"vm.goToURL(\'/Workspace/Documentation/\')\" class=\"hoverMe\"></md-icon></div>\n<div flex=\"30\">Documentation</div><div flex=\"55\">/Workspace/Documentation</div><div flex=\"5\"></div></md-list-item>\n<md-list-item class=\"borderBottom\" layout=\"row\"><div flex=\"10\"><md-icon md-font-icon=\"icon-folder-outline\" \nng-click=\"vm.goToURL(\'/Workspace/Examples/\')\" class=\"hoverMe\"></md-icon></div><div flex=\"30\">Examples</div><div \nflex=\"55\">/Workspace/Examples</div><div flex=\"5\"></div></md-list-item><md-list-item class=\"borderBottom\" layout=\"row\">\n<div flex=\"10\"><md-icon md-font-icon=\"icon-folder-outline\" ng-click=\"vm.goToURL(\'/Workspace/Analysis/\')\" \nclass=\"hoverMe\"></md-icon></div><div flex=\"30\">Analysis</div><div flex=\"55\">/Workspace/Analysis</div><div flex=\"5\">\n</div></md-list-item></md-list><div class=\"md-headline marginTop20\" ng-if=\"Spark.state.user != null\">\nFavorite Workspaces</div><md-list ng-if=\"Spark.state.user.user_info.favWorkspaces.length>0\" class=\"marginTop20\">\n<md-list-item layout=\"row\" class=\"borderBottom\"><div flex=\"15\">&nbsp</div><div flex=\"30\" translate=\"FM.NAME\" \nclass=\"md-title\">Name</div><div flex=\"55\" hide-xs translate=\"FM.LOCATION\" class=\"md-title\">Location</div>\n</md-list-item><md-list-item ng-repeat=\"workspace in Spark.state.user.user_info.favWorkspaces\" class=\"borderBottom\" \nlayout=\"row\"><div flex=\"10\"><md-icon md-font-icon=\"icon-folder-outline\" \nng-click=\"vm.goToURL(\'/Workspace/\'+workspace.location)\" class=\"hoverMe\"></md-icon></div><div flex=\"30\">\n{{workspace.name}}</div><div flex=\"55\">{{workspace.location}}</div><div flex=\"5\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\" ng-click=\"vm.removeFavItem( workspace )\" class=\"hoverMe\"></md-icon></div>\n</md-list-item></md-list><div class=\"md-body-1 marginTop20\" ng-if=\"Spark.state.user.user_info.favWorkspaces.length==0\">\nUsers can \"favorite\" workspaces so that they can be easily accessed. Those workspaces can be shown here. To favorite a workspace, clikc the heart icon in the upper right of the workspace view.\n</div><div class=\"md-headline marginTop20\" ng-if=\"Spark.state.user.user_info.workspaces.length>0\" flex=\"100\">\nRecent Workspaces</div><md-list ng-if=\"Spark.state.user.user_info.workspaces.length>0\" class=\"marginTop20\">\n<md-list-item layout=\"row\" class=\"borderBottom\"><div flex=\"15\">&nbsp</div><div flex=\"30\" translate=\"FM.NAME\" \nclass=\"md-title\">Name</div><div flex=\"55\" hide-xs translate=\"FM.LOCATION\" class=\"md-title\">Location</div>\n</md-list-item><md-list-item ng-repeat=\"workspace in Spark.state.user.user_info.workspaces\" layout=\"row\" \nclass=\"borderBottom\"><div flex=\"10\"><md-icon md-font-icon=\"icon-folder-outline\" \nng-click=\"vm.goToURL(\'/Workspace/\'+workspace.location)\" class=\"hoverMe\"></md-icon></div><div flex=\"30\">\n{{workspace.name}}</div><div flex=\"60\">{{workspace.location}}</div></md-list-item></md-list><div \nclass=\"md-body-1 marginTop20\" flex=\"80\" flex-offset=\"10\" ng-if=\"Spark.state.user.user_info.workspaces.length==0\">\nThe list below will show the 10 most recently visited workspaces.</div>");
$templateCache.put("app/main/apps/workspace/views/list/fabAddItem.html","<div flex=\"100\" class=\"fabOutside\"><div class=\"fabWrapper\"><md-fab-toolbar md-direction=\"right\"><md-fab-trigger>\n<md-button class=\"add-file-button md-fab md-warn\" aria-label=\"Add ...\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></md-fab-trigger><md-toolbar><md-fab-actions class=\"md-toolbar-tools\"><md-button aria-label=\"Add Document\" \nclass=\"md-icon-button\" ng-mouseover=\"vm.itemToAdd=\'Add Document\'\" ng-mouseout=\"vm.itemToAdd=\'\'\" \nng-click=\"vm.addItem(\'document\')\"><md-icon md-font-icon=\"icon-file-outline\"></md-icon></md-button><md-button \naria-label=\"Add Workspace\" class=\"md-icon-button\" ng-mouseover=\"vm.itemToAdd=\'Add Workspace\'\" \nng-mouseout=\"vm.itemToAdd=\'\'\" ng-click=\"vm.addItem(\'workspace\')\"><md-icon md-font-icon=\"icon-folder-outline\"></md-icon>\n</md-button><md-button aria-label=\"Add Dataset\" class=\"md-icon-button\" ng-mouseover=\"vm.itemToAdd=\'Add Dataset\'\" \nng-mouseout=\"vm.itemToAdd=\'\'\" ng-click=\"vm.addItem(\'dataset\')\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button>\n<md-button aria-label=\"Add Part Tree\" class=\"md-icon-button\" ng-mouseover=\"vm.itemToAdd=\'Add Part Tree\'\" \nng-mouseout=\"vm.itemToAdd=\'\'\" ng-click=\"vm.addItem(\'parttree\')\"><md-icon md-font-icon=\"icon-pine-tree\"></md-icon>\n</md-button><md-button aria-label=\"Add Image\" class=\"md-icon-button\" ng-mouseover=\"vm.itemToAdd=\'Add Image\'\" \nng-mouseout=\"vm.itemToAdd=\'\'\" ng-click=\"vm.addItem(\'image\')\"><md-icon md-font-icon=\"icon-camera\"></md-icon></md-button>\n<md-body-1>{{vm.itemToAdd}}</md-body-1></md-fab-actions></md-toolbar></md-fab-toolbar></div></div>");
$templateCache.put("app/main/apps/workspace/views/list/largeModalTemplates.tmpl.html","<md-dialog class=\"large-dialog\" aria-label=\"Change Permissions\"><form name=\"contactForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between\"><span class=\"title\" ng-if=\"vm.modalType==\'Edit Permissions\'\">Permissions\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><div ng-if=\"vm.modalType==\'Edit Permissions\'\" \nng-include=\"\'app/main/apps/workspace/views/list/editPermissions.tmpl.html\'\"></div></form></md-dialog>");
$templateCache.put("app/main/apps/workspace/views/list/list-edit.html","<md-list-item class=\"borderBottom\" layout-margin layout-fill><div flex=\"100\" layout=\"row\"><div \nclass=\"md-body-2 textCentered\" flex=\"35\">File Name</div><div class=\"md-body-2 textCentered\" flex=\"5\">Info</div><div \nclass=\"md-body-2 textCentered\" flex=\"10\">Status</div><div class=\"md-body-2 textCentered\" flex=\"15\">Created</div><div \nclass=\"md-body-2 textCentered\" flex=\"15\">Modified</div><div class=\"md-body-2 textCentered\" flex=\"10\">Version</div><div \nclass=\"md-body-2 textCentered\" flex=\"5\">Order</div></div></md-list-item><md-list-item \nng-repeat=\"file in vm.cadwolf_files | orderBy:\'order\'\" \nng-class=\"{\'selected\' : vm.selected === file, \'listBorderBottom\':true }\" layout-margin layout-fill \nclass=\"cadwolf-list-item\"><div flex=\"100\" layout=\"row\"><div flex=\"5\" class=\"textCentered paddingTop5\"><md-icon \nng-if=\"file.file_type_id==\'Workspace\'\" ng-click=\"vm.select( file )\" \nng-dblclick=\"vm.select( file ); vm.navigateURL( file )\" md-font-icon=\"icon-folder-outline\"></md-icon><md-icon \nng-if=\"file.file_type_id==\'Document\'\" ng-click=\"vm.select( file )\" \nng-dblclick=\"vm.select( file ); vm.navigateURL( file )\" md-font-icon=\"icon-file-outline\"></md-icon><md-icon \nng-if=\"file.file_type_id==\'Dataset\'\" ng-click=\"vm.select( file )\" \nng-dblclick=\"vm.select( file ); vm.navigateURL( file )\" md-font-icon=\"icon-cog\"></md-icon><md-icon \nng-if=\"file.file_type_id==\'Part Tree\'\" ng-click=\"vm.select( file )\" \nng-dblclick=\"vm.select( file ); vm.navigateURL( file )\" md-font-icon=\"icon-sitemap\"></md-icon><md-icon \nng-if=\"file.file_type_id==\'Image\'\" md-font-icon=\"icon-camera\" \nng-click=\"vm.select( file ); file.showUpload=!file.showUpload;\"></md-icon><md-icon \nng-if=\"file.file_type_id==\'Workflow\'\" ng-click=\"vm.select( file )\" \nng-dblclick=\"vm.select( file ); vm.navigateURL( file )\" md-font-icon=\"icon-calendar-text\"></md-icon><md-icon \nng-if=\"file.file_type_id==\'Forum\'\" ng-click=\"vm.select( file )\" \nng-dblclick=\"vm.select( file ); vm.navigateURL( file )\" md-font-icon=\"icon-forum\"></md-icon></div><div flex=\"30\" \nng-if=\"file.file_type_id==\'Image\' && !file.item_data.showUpload\" class=\"paddingTop8 md-body-1 list-text\" \nng-click=\"vm.select( file );\" ng-dblclick=\"vm.select( file ); file.item_data.showUpload=!file.item_data.showUpload;\">\n{{file.name}}</div><div flex=\"30\" ng-if=\"file.file_type_id==\'Image\' && file.item_data.showUpload\" \nclass=\"topMarginThree paddingTop5\"><div layout=\"row\"><input type=\"hidden\" name=\"MAX_FILE_SIZE\" value=\"30000\"> <input \nname=\"userimage\" id=\"uploadFile{{file.id}}\" type=\"file\"><md-icon ng-click=\"vm.uploadImage( file )\" \nmd-font-icon=\"icon-upload\" class=\"hoverMe\"></md-icon></div></div><div flex=\"30\" ng-if=\"file.file_type_id!=\'Image\'\" \nclass=\"paddingTop8 md-body-1 list-text\" ng-click=\"vm.select( file )\" \nng-dblclick=\"vm.select( file ); vm.navigateURL( file )\">{{file.name}}</div><div \nng-if=\"((file.file_type_id==\'Document\') ||\n					(file.file_type_id==\'Workspace\') ||\n					(file.file_type_id==\'Dataset\') ||\n					(file.file_type_id==\'Workflow\') ||\n					(file.file_type_id==\'Part Tree\') ||\n					(file.file_type_id==\'Forum\')) \" \nflex=\"5\" class=\"textCentered paddingTop5\"><md-icon \nng-click=\"vm.select( file ); vm.showSmallModal( \'\', file, \'Information\', 0 )\" md-font-icon=\"icon-information-outline\">\n<md-tooltip md-direction=\"bottom\">Click to view information</md-tooltip></md-icon></div><div \nng-if=\"(file.file_type_id==\'Image\')\" flex=\"5\" class=\"textCentered\"></div><div ng-if=\"file.file_type_id==\'Document\'\" \nflex=\"5\" class=\"textCentered paddingTop5\"><md-icon ng-click=\"vm.select( file )\" \nng-dblclick=\"vm.select( file ); vm.checkOutFile( file )\" ng-if=\"file.item_data.checkout_id==0\" \nmd-font-icon=\"icon-lock-unlocked-outline\"><md-tooltip md-direction=\"bottom\">Double-Click to check out</md-tooltip>\n</md-icon><md-icon ng-click=\"vm.select( file )\" ng-dblclick=\"vm.select( file ); vm.checkInFile( file )\" \nng-if=\"file.item_data.checkout_id==Spark.state.user.id\" md-font-icon=\"icon-lock-outline\"><md-tooltip \nmd-direction=\"bottom\">Double-Click to check in</md-tooltip></md-icon><md-icon ng-click=\"vm.select( file )\" \nng-if=\"file.item_data.checkout_id!=0 && file.item_data.checkout_id!=Spark.state.user.id\" \nmd-font-icon=\"icon-lock-outline\"><md-tooltip md-direction=\"bottom\">Checked Out by {{file.item_data.checkout_name}}\n</md-tooltip></md-icon></div><div ng-if=\"file.file_type_id==\'Image\'\" flex=\"5\" class=\"textCentered\"><md-icon \nng-click=\"vm.select( file ); vm.showImage(\'\', file);\" class=\"hoverMe paddingTop5\" md-font-icon=\"icon-picture\">\n<md-tooltip md-direction=\"bottom\">Click to see image</md-tooltip></md-icon></div><div \nng-if=\"file.file_type_id!=\'Document\' && file.file_type_id!=\'Image\'\" flex=\"5\" ng-click=\"vm.select( file )\"></div><div \nflex=\"5\" \nng-if=\"file.needs_update && ( file.file_type_id == \'Document\' ) && ( file.item_data.checkout_id == Spark.state.user.id )\" \nclass=\"textCentered\"><md-icon ng-click=\"vm.updateFile( file.id, \'workspace\' )\" \nmd-font-icon=\"icon-checkbox-marked-circle-outline\" class=\"redIcon hoverMe paddingTop5\"><md-tooltip \nmd-direction=\"bottom\">Click to Update</md-tooltip></md-icon></div><div flex=\"5\" \nng-if=\"file.needs_update && ( file.file_type_id == \'Document\' ) && ( file.item_data.checkout_id != Spark.state.user.id )\" \nclass=\"textCentered\"><md-icon md-font-icon=\"icon-checkbox-marked-circle-outline\" class=\"redIcon hoverMe paddingTop5\">\n<md-tooltip md-direction=\"bottom\">Check out document to update it</md-tooltip></md-icon></div><div flex=\"5\" \nng-if=\"!file.needs_update && file.file_type_id==\'Document\'\" class=\"textCentered\"><md-icon ng-click=\"\" \nmd-font-icon=\"icon-checkbox-marked-circle-outline\" class=\"greenIcon hoverMe paddingTop5\"><md-tooltip \nmd-direction=\"bottom\">Item Up to Date</md-tooltip></md-icon></div><div flex=\"5\" ng-if=\"file.file_type_id!=\'Document\'\" \nclass=\"textCentered\"></div><div flex=\"15\" class=\"textCentered paddingTop10 md-body-1 list-text\" \nng-click=\"vm.select( file )\">{{file.created_at_date | date:\'short\'}}</div><div flex=\"15\" \nclass=\"textCentered paddingTop10 md-body-1 list-text\" ng-click=\"vm.select( file )\">\n{{file.updated_at_date | date:\'short\'}}</div><div flex=\"10\" class=\"textCentered paddingTop3 md-body-1\" \nng-if=\"(file.file_type_id==\'Document\')\" ng-click=\"vm.select( file )\">{{file.version}}.{{file.revision}}</div><div \nflex=\"10\" class=\"textCentered paddingTop3 md-body-1\" \nng-if=\"((file.file_type_id==\'Dataset\')||\n					(file.file_type_id==\'Part Tree\')||\n					(file.file_type_id==\'Workspace\')||\n					(file.file_type_id==\'Workflow\')||\n					(file.file_type_id==\'Image\') ||\n					(file.file_type_id==\'Forum\'))\" \nng-click=\"vm.select( file )\"></div><div flex=\"10\" ng-click=\"vm.select( file )\"><md-input-container><md-select \nng-model=\"file.order\" aria-label=\"Select the order of the file\" ng-change=\"vm.changeOrder( file );\"><md-option \nng-repeat=\"i in vm.getNumber(vm.cadwolf_files.length) track by $index\" ng-value=\"$index\">{{$index}}</md-option>\n</md-select></md-input-container></div></div></md-list-item>");
$templateCache.put("app/main/apps/workspace/views/list/list-view.html","<md-list-item class=\"borderBottom\" layout-margin layout-fill><div flex=\"100\" layout=\"row\"><div \nclass=\"md-body-2 textCentered\" flex=\"50\">File Name</div><div class=\"md-body-2 textCentered\" flex=\"10\">Info</div><div \nclass=\"md-body-2 textCentered\" flex=\"15\">Created</div><div class=\"md-body-2 textCentered\" flex=\"15\">Modified</div><div \nclass=\"md-body-2 textCentered\" flex=\"10\">Version</div></div></md-list-item><md-list-item \nng-repeat=\"file in vm.cadwolf_files | orderBy:\'order\'\" \nng-class=\"{\'selected\' : vm.selected === file, \'listBorderBottom\':true }\" layout-margin layout-fill \nclass=\"cadwolf-list-item\"><div flex=\"100\" layout=\"row\"><div flex=\"5\" class=\"textCentered paddingTop5\" \nng-click=\"vm.select( file )\" ng-dblclick=\"vm.select( file ); vm.navigateURL( file )\"><md-icon \nng-if=\"file.file_type_id==\'Workspace\'\" md-font-icon=\"icon-folder-outline\"></md-icon><md-icon \nng-if=\"file.file_type_id==\'Document\'\" md-font-icon=\"icon-file-outline\"></md-icon><md-icon \nng-if=\"file.file_type_id==\'Dataset\'\" md-font-icon=\"icon-cog\"></md-icon><md-icon ng-if=\"file.file_type_id==\'Part Tree\'\" \nmd-font-icon=\"icon-sitemap\"></md-icon><md-icon ng-if=\"file.file_type_id==\'Workflow\'\" md-font-icon=\"icon-calendar\">\n</md-icon><md-icon ng-if=\"file.file_type_id==\'Image\'\" md-font-icon=\"icon-camera\"></md-icon><md-icon \nng-if=\"file.file_type_id==\'Forum\'\" md-font-icon=\"icon-forum\"></md-icon></div><div flex=\"45\" \nclass=\"paddingTop8 md-body-1 list-text\" ng-click=\"vm.select( file )\" \nng-dblclick=\"vm.select( file ); vm.navigateURL( file )\">{{file.name}}</div><div flex=\"10\" \nclass=\"textCentered paddingTop5\" \nng-if=\"((file.file_type_id==\'Document\')||\n                    (file.file_type_id==\'Workspace\')||\n                    (file.file_type_id==\'Dataset\')||\n                    (file.file_type_id==\'Workflow\')||\n                    (file.file_type_id==\'Part Tree\')||\n                    (file.file_type_id==\'Forum\'))\" \nng-click=\"vm.select( file ); vm.showSmallModal( \'\', file, \'Information\', 0 );\"><md-icon \nmd-font-icon=\"icon-information-outline\"></md-icon></div><div ng-if=\"file.file_type_id==\'Image\'\" flex=\"10\" \nclass=\"textCentered\"><md-icon ng-click=\"vm.select( file ); vm.showImage(\'\', file);\" class=\"hoverMe paddingTop5\" \nmd-font-icon=\"icon-picture\"><md-tooltip md-direction=\"bottom\">Click to see image</md-tooltip></md-icon></div><div \nflex=\"15\" class=\"textCentered paddingTop10 md-body-1 list-text\" ng-click=\"vm.select( file )\">\n{{file.created_at_date | date:\'short\'}}</div><div flex=\"15\" class=\"textCentered paddingTop10 md-body-1 list-text\" \nng-click=\"vm.select( file )\">{{file.updated_at_date | date:\'short\'}}</div><div flex=\"10\" \nclass=\"textCentered paddingTop10 md-body-1 list-text\" ng-if=\"(file.file_type_id==\'Document\')\" \nng-click=\"vm.select( file )\">{{file.version}}.{{file.revision}}</div><div flex=\"10\" class=\"textCentered\" \nng-if=\"((file.file_type_id==\'Dataset\')||\n                    (file.file_type_id==\'Part Tree\')||\n                    (file.file_type_id==\'Workspace\')||\n                    (file.file_type_id==\'Workflow\')||\n                    (file.file_type_id==\'Image\')||\n                    (file.file_type_id==\'Forum\'))\" \nng-click=\"vm.select( file )\"></div></div></md-list-item>");
$templateCache.put("app/main/apps/workspace/views/list/mediumModalTemplates.tmpl.html","<md-dialog class=\"medium-dialog\" aria-label=\"Change File Properties\"><form name=\"contactForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title\" ng-if=\"vm.modalType==\'View Item Log\'\">Item History</span> <span \nclass=\"title\" ng-if=\"vm.modalType==\'Edit Description\'\">Description</span> <span class=\"title\" \nng-if=\"vm.modalType==\'Edit Permissions\'\">Permissions</span> <span class=\"title\" \nng-if=\"vm.modalType==\'Edit Properties\'\">Edit Properties</span> <span class=\"title\" \nng-if=\"vm.modalType==\'Send Message\'\">Send Message</span> <span class=\"title\" ng-if=\"vm.modalType==\'Move Item\'\">\nMove Item</span> <span class=\"title\" ng-if=\"vm.modalType==\'Copy Item\'\">Copy Item</span> <span class=\"title\" \nng-if=\"vm.modalType==\'Set Image\'\">Edit Image for File</span> <span class=\"title\" ng-if=\"vm.modalType==\'Perm Message\'\">\nSend Message asking for permission</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-information-outline\" ng-if=\"vm.modalType==\'View Item Log\'\" \nclass=\"md-avatar avatar contact-avatar huge\"></md-icon><md-icon md-font-icon=\"icon-rotate-3d\" \nng-if=\"vm.modalType==\'Move Item\'\" class=\"md-avatar avatar contact-avatar huge\"></md-icon><md-icon \nmd-font-icon=\"icon-content-copy\" ng-if=\"vm.modalType==\'Copy Item\'\" class=\"md-avatar avatar contact-avatar huge\">\n</md-icon><md-icon md-font-icon=\"icon-label-outline\" ng-if=\"vm.modalType==\'Edit Description\'\" \nclass=\"md-avatar avatar contact-avatar huge\"></md-icon><md-icon md-font-icon=\"icon-cog\" \nng-if=\"vm.modalType==\'Edit Properties\'\" class=\"md-avatar avatar contact-avatar huge\"></md-icon><md-icon \nmd-font-icon=\"icon-key\" ng-if=\"vm.modalType==\'Edit Permissions\'\" class=\"md-avatar avatar contact-avatar huge\">\n</md-icon><div class=\"contact-name\" ng-if=\"vm.modalType==\'View Item Log\'\">{{vm.thisItem.name}}</div><div \nclass=\"contact-name\" ng-if=\"vm.modalType==\'Edit Description\'\">{{vm.thisItem.name}}</div><div class=\"contact-name\" \nng-if=\"vm.modalType==\'Send Message\'\">Send Message</div><div class=\"contact-name\" \nng-if=\"vm.modalType==\'Edit Permissions\'\">{{vm.thisItem.name}}</div><div class=\"contact-name\" \nng-if=\"vm.modalType==\'Edit Properties\'\">{{vm.thisItem.name}}</div><div class=\"contact-name\" \nng-if=\"vm.modalType==\'Move Item\'\">Move - {{vm.thisItem.name}}</div><div class=\"contact-name\" \nng-if=\"vm.modalType==\'Copy Item\'\">Copy - {{vm.thisItem.name}}</div><div class=\"contact-name\" \nng-if=\"vm.modalType==\'Set Image\'\">Select Image for - {{vm.thisItem.name}}</div><div class=\"contact-name\" \nng-if=\"vm.modalType==\'Perm Message\'\">Permissions message for - {{vm.thisItem.file.name}}</div></div></div></md-toolbar>\n<div ng-if=\"vm.modalType==\'View Item Log\'\" ng-include=\"\'app/main/apps/workspace/views/list/showLogs.tmpl.html\'\"></div>\n<div ng-if=\"vm.modalType==\'Edit Description\'\" \nng-include=\"\'app/main/apps/workspace/views/list/editDescription.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'Edit Properties\'\" ng-include=\"\'app/main/apps/workspace/views/list/editProperties.tmpl.html\'\">\n</div><div ng-if=\"vm.modalType==\'Edit Permissions\'\" \nng-include=\"\'app/main/apps/workspace/views/list/editPermissions.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'Move Item\'\" ng-include=\"\'app/main/apps/workspace/views/list/editMove.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'Copy Item\'\" ng-include=\"\'app/main/apps/workspace/views/list/editCopy.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'Set Image\'\" ng-include=\"\'app/main/apps/workspace/views/list/setImage.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'Send Message\'\" ng-include=\"\'app/main/apps/workspace/views/list/sendMessage.tmpl.html\'\"></div>\n</form></md-dialog>");
$templateCache.put("app/main/apps/workspace/views/list/newVersion.tmpl.html","<md-dialog-content ms-scroll><div flex=\"90\" flex-offset=\"5\" class=\"textCentered\" \nng-if=\"vm.thisItem.item_data.checkout_status==1\">\nItems must be checked in before the version can be rolled to a new version.</div><div flex=\"90\" flex-offset=\"5\" \nclass=\"textCentered\" \nng-if=\"(((vm.thisItem.file_type_id==\'Workspace\')||\n				(vm.thisItem.file_type_id==\'Part Tree\')||\n				(vm.thisItem.file_type_id==\'Dataset\')||\n				(vm.thisItem.file_type_id==\'Image\'))&&\n				(vm.thisItem.item_data.checkout_status==0))\">\nWorkspaces, Part Trees, Workflows, and images do not have versions.</div><div flex=\"90\" flex-offset=\"5\" \nclass=\"textCentered\" \nng-if=\"(((vm.thisItem.file_type_id==\'Document\')&&\n				(vm.thisItem.item_data.checkout_status==0))\">\nClick the button below to create a new version of this item based upon the old one. From there, you can edit that item without altering the old version.\n</div><div flex=\"100\" layout-align=\"center center\"><md-button type=\"submit\" \nng-click=\"vm.newVersion(vm.thisItem); vm.cancel();\" ng-if=\"((vm.thisItem.file_type_id==\'Document\'))\" \nclass=\"send-button md-accent md-raised\">CREATE NEW VERSION</md-button></div><div flex=\"100\" \nlayout-align=\"center center\"><md-button type=\"submit\" ng-click=\"vm.newRevision(vm.thisItem); vm.cancel();\" \nng-if=\"((vm.thisItem.file_type_id==\'Document\'))\" class=\"send-button md-accent md-raised\">CREATE NEW REVISION\n</md-button></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-fill layout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" \nclass=\"send-button md-accent md-raised\">CANCEL</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/workspace/views/list/quilt-edit.html","<md-list-item ng-repeat=\"file in vm.cadwolf_files | orderBy:\'order\'\" \nng-class=\"{\'selected\' : vm.selected === file, \'listDarkBorderBottom\':true }\" layout-margin flex=\"100\" \nclass=\"cadwolf-quilt-item\"><div flex=\"100\" ng-click=\"vm.select( file )\" layout=\"row\"><div flex=\"20\" \nng-if=\"file.file_type_id==\'Image\' || !file.item_data.showUpload\" class=\"quiltImageBox\" \nng-dblclick=\"vm.navigateURL( file )\"><img src=\"https://cadwolf.s3.amazonaws.com/{{file[\'item_data\'][\'fileImage\']}}\" \nwidth=\"200px\"></div><div flex=\"20\" ng-if=\"file.file_type_id==\'Image\' && file.item_data.showUpload\" \nclass=\"topMarginThree paddingTop5\"><div layout=\"row\"><input type=\"hidden\" name=\"MAX_FILE_SIZE\" value=\"30000\"> <input \nname=\"userimage\" id=\"uploadFile{{file.id}}\" type=\"file\"></div><div layout=\"row\"><md-icon \nng-click=\"vm.uploadImage( file )\" md-font-icon=\"icon-upload\" class=\"hoverMe\"></md-icon></div></div><div flex=\"25\" \nflex-offset=\"5\" layout=\"column\" class=\"cadwolf-dataSection\"><div layout=\"row\"><div class=\"paddingTop5 marginRight10\">\n<md-icon ng-if=\"file.file_type_id==\'Workspace\'\" md-font-icon=\"icon-folder-outline\"></md-icon><md-icon \nng-if=\"file.file_type_id==\'Document\'\" md-font-icon=\"icon-file-outline\"></md-icon><md-icon \nng-if=\"file.file_type_id==\'Dataset\'\" md-font-icon=\"icon-cog\"></md-icon><md-icon ng-if=\"file.file_type_id==\'Part Tree\'\" \nmd-font-icon=\"icon-sitemap\"></md-icon><md-icon ng-if=\"file.file_type_id==\'Workflow\'\" md-font-icon=\"icon-calendar\">\n</md-icon><md-icon ng-if=\"file.file_type_id==\'Image\'\" md-font-icon=\"icon-camera\"></md-icon><md-icon \nng-if=\"file.file_type_id==\'Forum\'\" md-font-icon=\"icon-forum\"></md-icon></div><div \nclass=\"paddingTop8 md-body-1 list-text\">{{file.name}}</div></div><div layout=\"row\"><div \nng-if=\"file.file_type_id==\'Document\'\" class=\"textCentered paddingTop5\"><md-icon ng-click=\"vm.select( file )\" \nng-dblclick=\"vm.select( file ); vm.checkOutFile( file )\" ng-if=\"file.item_data.checkout_id==0\" \nmd-font-icon=\"icon-lock-unlocked-outline\"><md-tooltip md-direction=\"bottom\">Double-Click to check out</md-tooltip>\n</md-icon><md-icon ng-click=\"vm.select( file )\" ng-dblclick=\"vm.select( file ); vm.checkInFile( file )\" \nng-if=\"file.item_data.checkout_id==Spark.state.user.id\" md-font-icon=\"icon-lock-outline\"><md-tooltip \nmd-direction=\"bottom\">Double-Click to check in</md-tooltip></md-icon><md-icon ng-click=\"vm.select( file )\" \nng-if=\"file.item_data.checkout_id!=0 && file.item_data.checkout_id!=Spark.state.user.id\" \nmd-font-icon=\"icon-lock-outline\"><md-tooltip md-direction=\"bottom\">Checked Out by {{file.item_data.checkout_name}}\n</md-tooltip></md-icon></div><div \nng-if=\"file.needs_update && ( file.file_type_id == \'Document\' ) && ( file.item_data.checkout_id == Spark.state.user.id )\" \nclass=\"textCentered\"><md-icon ng-click=\"vm.updateFile( file.id, \'workspace\' )\" \nmd-font-icon=\"icon-checkbox-marked-circle-outline\" class=\"redIcon hoverMe paddingTop5\"><md-tooltip \nmd-direction=\"bottom\">Click to Update</md-tooltip></md-icon></div><div \nng-if=\"file.needs_update && ( file.file_type_id == \'Document\' ) && ( file.item_data.checkout_id != Spark.state.user.id )\" \nclass=\"textCentered\"><md-icon md-font-icon=\"icon-checkbox-marked-circle-outline\" class=\"redIcon hoverMe paddingTop5\">\n<md-tooltip md-direction=\"bottom\">Check out document to update it</md-tooltip></md-icon></div><div \nng-if=\"!file.needs_update && file.file_type_id==\'Document\'\" class=\"textCentered\"><md-icon ng-click=\"\" \nmd-font-icon=\"icon-checkbox-marked-circle-outline\" class=\"greenIcon hoverMe paddingTop5\"><md-tooltip \nmd-direction=\"bottom\">Item Up to Date</md-tooltip></md-icon></div><div><md-input-container><md-select \nng-model=\"file.order\" aria-label=\"Select the order of the file\" ng-change=\"vm.changeOrder( file );\"><md-option \nng-repeat=\"i in vm.getNumber(vm.cadwolf_files.length) track by $index\" ng-value=\"$index\">{{$index}}</md-option>\n</md-select></md-input-container></div><div ng-if=\"!file.needs_update && file.file_type_id==\'Forum\'\" \nclass=\"textCentered marginTop10\">Comments - {{file.commentCount}}</div></div><div \nclass=\"paddingTop10 md-body-1 list-text\">Created : {{file.created_at_date | date:\'short\'}}</div><div \nclass=\"paddingTop10 md-body-1 list-text\">Modified : {{file.updated_at_date | date:\'short\'}}</div><div \nclass=\"paddingTop10 md-body-1 list-text\" ng-if=\"(file.file_type_id==\'Document\')\">\nVersion : {{file.version}}.{{file.revision}}</div></div><div flex=\"50\"><div class=\"descBlock\"><div class=\"boldFont\">\nDescription :</div><div ng-bind-html=\"file.item_data.description\"></div></div><div layout=\"row\" class=\"ownerRow\" \nng-if=\"file.file_type_id != \'Image\'\"><div ng-repeat=\"thisPerm in file.item_data.permList\"><img \nclass=\"profile-image avatar\" ng-src=\"{{thisPerm.userData.photo_url}}\" ng-click=\"vm.sendPermMessage(file, thisPerm);\" \nng-if=\"thisPerm.perm_type == \'admin\'\" on-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"><md-tooltip \nmd-direction=\"bottom\">{{thisPerm.userData.name}} - {{thisPerm.userData.username}} - Send message asking to join\n</md-tooltip></div><div ng-repeat=\"thisPerm in file.item_data.permList\"><img class=\"profile-image avatar\" \nng-src=\"{{thisPerm.userData.photo_url}}\" ng-click=\"\" ng-if=\"thisPerm.perm_type != \'admin\'\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"><md-tooltip md-direction=\"bottom\">\n{{thisPerm.userData.name}} - {{thisPerm.userData.username}} - View Perm</md-tooltip></div><div \nng-repeat=\"thisCAD in file.item_data.CADFiles\"><a target=\"_blank\" rel=\"noopener noreferrer\" \nhref=\"{{thisCAD.CADAddress}}\"><img class=\"profile-image avatar\" \nng-src=\"https://cadwolf.s3.amazonaws.com/stock/onshapeIcon.png\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/stock/onshapeIcon.png\"><md-tooltip md-direction=\"bottom\">\nOpen this CAD FIle - {{thisCAD.CADName}}</md-tooltip></a></div></div></div></div></md-list-item>");
$templateCache.put("app/main/apps/workspace/views/list/quilt-view.html","<md-list-item ng-repeat=\"file in vm.cadwolf_files | orderBy:\'order\'\" \nng-class=\"{\'selected\' : vm.selected === file, \'listDarkBorderBottom\':true }\" layout-margin flex=\"100\" \nclass=\"cadwolf-quilt-item\"><div flex=\"100\" ng-click=\"vm.select( file )\" layout=\"row\"><div flex=\"20\" \nclass=\"quiltImageBox\" ng-dblclick=\"vm.navigateURL( file )\"><img \nsrc=\"https://cadwolf.s3.amazonaws.com/{{file[\'item_data\'][\'fileImage\']}}\" width=\"200px\"></div><div flex=\"25\" \nflex-offset=\"5\" layout=\"column\" class=\"cadwolf-dataSection\"><div layout=\"row\"><div class=\"paddingTop5 marginRight10\">\n<md-icon ng-if=\"file.file_type_id==\'Workspace\'\" md-font-icon=\"icon-folder-outline\"></md-icon><md-icon \nng-if=\"file.file_type_id==\'Document\'\" md-font-icon=\"icon-file-outline\"></md-icon><md-icon \nng-if=\"file.file_type_id==\'Dataset\'\" md-font-icon=\"icon-cog\"></md-icon><md-icon ng-if=\"file.file_type_id==\'Part Tree\'\" \nmd-font-icon=\"icon-sitemap\"></md-icon><md-icon ng-if=\"file.file_type_id==\'Workflow\'\" md-font-icon=\"icon-calendar\">\n</md-icon><md-icon ng-if=\"file.file_type_id==\'Image\'\" md-font-icon=\"icon-camera\"></md-icon></div><div \nclass=\"paddingTop8 md-body-1 list-text\">{{file.name}}</div></div><div layout=\"row\"><div \nng-if=\"file.file_type_id==\'Document\'\" class=\"textCentered paddingTop5\"><md-icon ng-click=\"vm.select( file )\" \nng-dblclick=\"vm.select( file ); vm.checkOutFile( file )\" ng-if=\"file.item_data.checkout_id==0\" \nmd-font-icon=\"icon-lock-unlocked-outline\"><md-tooltip md-direction=\"bottom\">Double-Click to check out</md-tooltip>\n</md-icon><md-icon ng-click=\"vm.select( file )\" ng-dblclick=\"vm.select( file ); vm.checkInFile( file )\" \nng-if=\"file.item_data.checkout_id==Spark.state.user.id\" md-font-icon=\"icon-lock-outline\"><md-tooltip \nmd-direction=\"bottom\">Double-Click to check in</md-tooltip></md-icon><md-icon ng-click=\"vm.select( file )\" \nng-if=\"file.item_data.checkout_id!=0 && file.item_data.checkout_id!=Spark.state.user.id\" \nmd-font-icon=\"icon-lock-outline\"><md-tooltip md-direction=\"bottom\">Checked Out by {{file.item_data.checkout_name}}\n</md-tooltip></md-icon></div><div \nng-if=\"file.needs_update && ( file.file_type_id == \'Document\' ) && ( file.item_data.checkout_id == Spark.state.user.id )\" \nclass=\"textCentered\"><md-icon ng-click=\"vm.updateFile( file.id, \'workspace\' )\" \nmd-font-icon=\"icon-checkbox-marked-circle-outline\" class=\"redIcon hoverMe paddingTop5\"><md-tooltip \nmd-direction=\"bottom\">Click to Update</md-tooltip></md-icon></div><div \nng-if=\"file.needs_update && ( file.file_type_id == \'Document\' ) && ( file.item_data.checkout_id != Spark.state.user.id )\" \nclass=\"textCentered\"><md-icon md-font-icon=\"icon-checkbox-marked-circle-outline\" class=\"redIcon hoverMe paddingTop5\">\n<md-tooltip md-direction=\"bottom\">Check out document to update it</md-tooltip></md-icon></div><div \nng-if=\"!file.needs_update && file.file_type_id==\'Document\'\" class=\"textCentered\"><md-icon ng-click=\"\" \nmd-font-icon=\"icon-checkbox-marked-circle-outline\" class=\"greenIcon hoverMe paddingTop5\"><md-tooltip \nmd-direction=\"bottom\">Item Up to Date</md-tooltip></md-icon></div><div \nng-if=\"!file.needs_update && file.file_type_id==\'Forum\'\" class=\"textCentered marginTop10\">\nComments - {{file.commentCount}}</div></div><div class=\"paddingTop10 md-body-1 list-text\">\nCreated : {{file.created_at_date | date:\'short\'}}</div><div class=\"paddingTop10 md-body-1 list-text\">\nModified : {{file.updated_at_date | date:\'short\'}}</div><div class=\"paddingTop10 md-body-1 list-text\" \nng-if=\"(file.file_type_id==\'Document\')\">Version : {{file.version}}.{{file.revision}}</div></div><div flex=\"50\"><div \nclass=\"descBlock\"><div class=\"boldFont\">Description :</div><div ng-bind-html=\"file.item_data.description\"></div></div>\n<div layout=\"row\" class=\"ownerRow\" ng-if=\"file.file_type_id != \'Image\'\"><div \nng-repeat=\"thisPerm in file.item_data.permList\"><img class=\"profile-image avatar\" \nng-src=\"{{thisPerm.userData.photo_url}}\" ng-click=\"vm.sendPermMessage(file, thisPerm);\" \nng-if=\"thisPerm.perm_type == \'admin\'\" on-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"><md-tooltip \nmd-direction=\"bottom\">{{thisPerm.userData.name}} - {{thisPerm.userData.username}} - Send message asking to join\n</md-tooltip></div><div ng-repeat=\"thisPerm in file.item_data.permList\"><img class=\"profile-image avatar\" \nng-src=\"{{thisPerm.userData.photo_url}}\" ng-click=\"\" ng-if=\"thisPerm.perm_type != \'admin\'\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"><md-tooltip md-direction=\"bottom\">\n{{thisPerm.userData.name}} - {{thisPerm.userData.username}} - View Perm</md-tooltip></div><div \nng-repeat=\"thisCAD in file.item_data.CADFiles\"><a target=\"_blank\" rel=\"noopener noreferrer\" \nhref=\"{{thisCAD.CADAddress}}\"><img class=\"profile-image avatar\" \nng-src=\"https://cadwolf.s3.amazonaws.com/stock/onshapeIcon.png\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/stock/onshapeIcon.png\"><md-tooltip md-direction=\"bottom\">\nOpen this CAD FIle - {{thisCAD.CADName}}</md-tooltip></a></div></div></div></div></md-list-item>");
$templateCache.put("app/main/apps/workspace/views/list/receiveList.html","<div flex=\"40\" class=\"borderRight paddingLeft20 paddingRight20\"><div ng-repeat=\"thisMess in vm.cadwolf_messages\" \nng-if=\"( thisMess.status == 1 || thisMess.status == 2 )\" class=\"borderBottom\" \nng-class=\"{\'selected\' : vm.thisMessage === thisMess }\" ng-click=\"vm.thisMessage = thisMess;\" layout=\"column\"><div \nflex=\"100\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" class=\"marginTop20 marginBottom20\"><img \nclass=\"profile-image avatar\" ng-src=\"{{thisMess.userData.photo_url}}\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"><div class=\"md-body-2 marginTop5 marginLeft5\">\n{{thisMess.userData.name}}</div></div><div>{{thisMess.created_at_date | date:\'short\'}}</div></div><div flex=\"100\" \nclass=\"md-body-1 marginBottom20 marginLeft20\">{{thisMess.content.title}}</div></div><div flex=\"50\" flex-offset=\"5\"><div\n flex=\"100\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" class=\"marginTop20 marginBottom20\"><img \nclass=\"profile-image avatar\" ng-src=\"{{vm.thisMessage.userData.photo_url}}\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"><div class=\"md-headline marginTop5 marginLeft5\">\n{{vm.thisMessage.userData.name}}</div></div><div class=\"marginTop20\">{{vm.thisMessage.created_at_date | date:\'short\'}}\n</div></div><div flex=\"100\" class=\"md-body-2\">{{vm.thisMessage.content.title}}</div><div \nng-bind-html=\"vm.thisMessage.content.messageText\"></div></div></div>");
$templateCache.put("app/main/apps/workspace/views/list/selectUp.html","<div flex=\"25\" ng-if=\"( vm.cadwolf_fileInfo.item_data.viewType == \'list\' )\"><md-icon md-font-icon=\"icon-view-list\" \nng-click=\"\" class=\"hoverMe iconBlueBackground\"><md-tooltip md-direction=\"bottom\">You are Viewing the List View\n</md-tooltip></md-icon></div><div flex=\"25\" ng-if=\"( vm.cadwolf_fileInfo.item_data.viewType != \'list\' )\"><md-icon \nmd-font-icon=\"icon-view-list\" ng-click=\"vm.cadwolf_fileInfo.item_data.viewType = \'list\';\" \nclass=\"hoverMe iconGreyBackground\"><md-tooltip md-direction=\"bottom\">List View</md-tooltip></md-icon></div><div \nflex=\"25\" ng-if=\"( vm.cadwolf_fileInfo.item_data.viewType == \'quilt\' )\"><md-icon md-font-icon=\"icon-view-quilt\" \nng-click=\"\" class=\"hoverMe iconBlueBackground\"><md-tooltip md-direction=\"bottom\">You are Viewing the Quilt View\n</md-tooltip></md-icon></div><div flex=\"25\" ng-if=\"( vm.cadwolf_fileInfo.item_data.viewType != \'quilt\' )\"><md-icon \nmd-font-icon=\"icon-view-quilt\" ng-click=\"vm.cadwolf_fileInfo.item_data.viewType = \'quilt\';\" \nclass=\"hoverMe iconGreyBackground\"><md-tooltip md-direction=\"bottom\">Quilt View</md-tooltip></md-icon></div><div \nflex=\"25\" ng-if=\"(!vm.cadwolf_fileInfo.favorite)&&(Spark.state.user!=null)\"><md-icon md-font-icon=\"icon-heart-outline\" \nng-click=\"vm.favoriteItem();\" class=\"hoverMe iconRedBackground\"><md-tooltip md-direction=\"bottom\">Click to like\n</md-tooltip></md-icon></div><div flex=\"25\" ng-if=\"(vm.cadwolf_fileInfo.favorite)&&(Spark.state.user!=null)\"><md-icon \nmd-font-icon=\"icon-heart\" ng-click=\"vm.favoriteItem();\" class=\"hoverMe iconRedBackground\"><md-tooltip \nmd-direction=\"bottom\">Click to unlike</md-tooltip></md-icon></div><div flex=\"25\"><md-icon \nmd-font-icon=\"icon-arrow-up-bold-circle-outline\" ng-click=\"vm.upOne()\" class=\"hoverMe\"></md-icon></div>");
$templateCache.put("app/main/apps/workspace/views/list/sendMessage.tmpl.html","<md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label>Message Title</label><input \nname=\"messageTitle\" aria-label=\"Message Title\" type=\"text\" ng-model=\"vm.messageTitle\" ng-enter=\"\"></md-input-container>\n<text-angular ng-model=\"vm.messageText\"></text-angular></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-fill layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vm.acceptMessage( vm.messageTitle, vm.messageText ); vm.cancel();\" class=\"send-button md-accent md-raised\">\nSend Message</md-button><md-button type=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">CANCEL\n</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/workspace/views/list/setImage.tmpl.html","<md-dialog-content ms-scroll><p>\nThe image selected below will be used as the icon for the file or folder in question. Enter a directory and then navigate from there.\n</p><div layout=\"column\" flex=\"90\" flex-offset=\"5\"><div><img \nsrc=\"https://cadwolf.s3.amazonaws.com/{{vm.thisItem.item_data.fileImage}}\" width=\"200px\"></div><md-input-container \nclass=\"md-block\"><label>Location</label><input aria-label=\"Select Image\" type=\"text\" ng-model=\"vm.thisLoc\" \nng-enter=\"vm.getFiles( vm.thisLoc )\"></md-input-container><div ng-repeat=\"file in vm.moveFiles\" \nclass=\"borderBottom marginTop10 marginBottom10\" ng-if=\"file.file_type_id==\'Workspace\' || file.file_type_id==\'Image\'\" \nlayout=\"row\"><div ng-if=\"file.file_type_id==\'Workspace\'\" ng-dblclick=\"vm.getFiles( vm.thisLoc, file.name )\" flex=\"5\">\n<md-icon md-font-icon=\"icon-folder-outline\"></md-icon></div><div ng-if=\"file.file_type_id==\'Workspace\'\" \nng-dblclick=\"vm.getFiles( vm.thisLoc, file.name )\" flex=\"80\">{{ file.name }}</div><div \nng-if=\"file.file_type_id==\'Image\'\" ng-dblclick=\"vm.thisItem.item_data.fileImage = file.item_data.imageSource; \"><img \nsrc=\"https://cadwolf.s3.amazonaws.com/{{file.item_data.imageSource}}\" width=\"50px\"></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.acceptChanges(); vm.cancel();\" \nclass=\"send-button md-accent md-raised\">Finished Selecting</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/workspace/views/list/showImage.tmpl.html","<md-dialog aria-label=\"View Image\" class=\"large-dialog\" id=\"modalDialog\" ng-cloak><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\"><span \nclass=\"title\">View Image</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><img \nsrc=\"https://cadwolf.s3.amazonaws.com/{{vm.currentImage[\'item_data\'][\'imageSource\']}}\"></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">\nCLOSE</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/workspace/views/list/showInfo.tmpl.html","<md-dialog-content ms-scroll><div data-ng-bind-html=\"vm.thisItem.item_data.description\"></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button ng-click=\"vm.cancel( );\" class=\"send-button md-accent md-raised\">CLOSE</md-button>\n</div></md-dialog-actions>");
$templateCache.put("app/main/apps/workspace/views/list/showLogs.tmpl.html","<md-dialog-content ms-scroll><div><md-list flex=\"80\" flex-offset=\"10\" layout-fill><md-list-item layout=\"row\" \nlayout-fill><div flex=\"25\">User</div><div flex=\"25\">Date-Time</div><div flex=\"20\">Log Type</div><div flex=\"30\">Details\n</div></md-list-item><md-divider></md-divider><md-list-item ng-repeat=\"log in vm.logData\" layout=\"row\"><div flex=\"25\">\n{{log.log_name}}</div><div flex=\"25\">{{log.created_at}}</div><div flex=\"20\">{{log.message_type}}</div><div flex=\"30\" \nng-if=\"log.message_type==\'Created Item\'\">Item Created</div><div flex=\"30\" ng-if=\"log.message_type==\'Updated Item\'\" \nlayout=\"column\"><div ng-if=\"log.message_text.oldName!=log.message_text.newName\">\n{{log.message_text.oldName}} -> {{log.message_text.newName}}</div><div \nng-if=\"log.message_text.oldName==log.message_text.newName\">\n{{log.message_text.oldDescription}} -> {{log.message_text.newDescription}}</div></div><div flex=\"30\" \nng-if=\"log.message_type==\'Uploaded New Image\'\">New Image - {{log.message_text.imageName}}</div><div flex=\"30\" \nng-if=\"log.message_type==\'Moved Item\'\">{{log.message_text.oldParentName}} -> {{log.message_text.newParentName}}</div>\n</md-list-item><md-divider></md-divider></md-list></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-fill layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">CLOSE LOGS</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/workspace/views/list/smallModalTemplates.tmpl.html","<md-dialog class=\"contact-dialog\" aria-label=\"Change File Properties\"><form name=\"contactForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between\"><span class=\"title\" ng-if=\"vm.modalType==\'Edit Title\'\">Change Name</span> \n<span class=\"title\" ng-if=\"vm.modalType==\'Create New Version\'\">Version Control</span> <span class=\"title\" \nng-if=\"vm.modalType==\'Delete Item\'\">Delete Item</span> <span class=\"title\" ng-if=\"vm.modalType==\'Information\'\">\nItem Information</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-format-text\" \nng-if=\"vm.modalType==\'Edit Title\'\" class=\"md-avatar avatar contact-avatar huge\"></md-icon><md-icon \nmd-font-icon=\"icon-content-duplicate\" ng-if=\"vm.modalType==\'Create New Version\'\" \nclass=\"md-avatar avatar contact-avatar huge\"></md-icon><md-icon md-font-icon=\"icon-close-circle-outline\" \nng-if=\"vm.modalType==\'Delete Item\'\" class=\"md-avatar avatar contact-avatar huge\"></md-icon><md-icon \nmd-font-icon=\"icon-information-outline\" ng-if=\"vm.modalType==\'Information\'\" \nclass=\"md-avatar avatar contact-avatar huge\"></md-icon><div class=\"contact-name\" ng-if=\"vm.modalType==\'Edit Title\'\">\n{{vm.thisItem.name}}</div><div class=\"contact-name\" ng-if=\"vm.modalType==\'Create New Version\'\">\nNew Version - {{vm.thisItem.name}}</div><div class=\"contact-name\" ng-if=\"vm.modalType==\'Delete Item\'\">\nDelete - {{vm.thisItem.name}}</div><div class=\"contact-name\" ng-if=\"vm.modalType==\'Information\'\">\nInformation - {{vm.thisItem.name}}</div></div></div></md-toolbar><div ng-if=\"vm.modalType==\'Edit Title\'\" \nng-include=\"\'app/main/apps/workspace/views/list/editName.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'Create New Version\'\" ng-include=\"\'app/main/apps/workspace/views/list/newVersion.tmpl.html\'\">\n</div><div ng-if=\"vm.modalType==\'Delete Item\'\" ng-include=\"\'app/main/apps/workspace/views/list/editDelete.tmpl.html\'\">\n</div><div ng-if=\"vm.modalType==\'Information\'\" ng-include=\"\'app/main/apps/workspace/views/list/showInfo.tmpl.html\'\">\n</div></form></md-dialog>");
$templateCache.put("app/main/apps/document/worksheet/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"center center\" \nflex=\"100\"><div flex=\"10\" flex-offset=\"5\"><md-icon md-font-icon=\"icon-plus-circle\"></md-icon></div><div flex=\"50\" \nflex-offset=\"15\"><span class=\"font-weight-500 font-size-14\">Add an Item</span></div></div></div><md-divider>\n</md-divider><div ms-scroll class=\"content\"><div layout=\"column\" layout-margin layout-align=\"space between center\">\n<md-button aria-label=\"Text\" layout=\"row\" layout-fill ng-click=\"vm.addItem(\'text\', {})\"><div flex=\"25\"><md-icon \nmd-font-icon=\"icon-format-text\"></md-icon></div><div flex=\"75\" class=\"md-body-1\">Text</div></md-button><md-button \naria-label=\"Header\" layout=\"row\" layout-fill ng-click=\"vm.addItem(\'header\', {})\"><div flex=\"25\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\"></md-icon></div><div flex=\"75\" class=\"md-body-1\">Header</div></md-button>\n<md-button aria-label=\"Equation\" layout=\"row\" layout-fill ng-click=\"vm.addItem(\'equation\', {})\"><div flex=\"25\"><md-icon\n md-font-icon=\"icon-sigma\"></md-icon></div><div flex=\"75\" class=\"md-body-1\">Equation</div></md-button><md-button \naria-label=\"Symbolic\" layout=\"row\" layout-fill ng-click=\"vm.addItem(\'symbolic\', {})\"><div flex=\"25\"><md-icon \nmd-font-icon=\"icon-link-variant\"></md-icon></div><div flex=\"75\" class=\"md-body-1\">Symbolic</div></md-button><md-button \naria-label=\"Table\" layout=\"row\" layout-fill ng-click=\"vm.addItem(\'table\', {})\"><div flex=\"25\"><md-icon \nmd-font-icon=\"icon-table\"></md-icon></div><div flex=\"75\" class=\"md-body-1\">Table</div></md-button><md-button \naria-label=\"For Loop\" layout=\"row\" layout-fill ng-click=\"vm.addItem(\'forLoop\', {}); vm.showSpecs=\'forLoopHor\'\"><div \nflex=\"25\"><md-icon md-font-icon=\"icon-redo-variant\"></md-icon></div><div flex=\"75\" class=\"md-body-1\">For Loop</div>\n</md-button><md-button aria-label=\"While Loop\" layout=\"row\" layout-fill \nng-click=\"vm.addItem(\'whileLoop\', {}); vm.showSpecs=\'whileLoopHor\'\"><div flex=\"25\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon></div><div flex=\"75\" class=\"md-body-1\">While Loop</div></md-button><md-button \naria-label=\"If Else\" layout=\"row\" layout-fill ng-click=\"vm.addItem(\'ifElse\', {}); vm.showSpecs=\'ifElseHor\'\"><div \nflex=\"25\"><md-icon md-font-icon=\"icon-cube-unfolded\"></md-icon></div><div flex=\"75\" class=\"md-body-1\">If Else</div>\n</md-button><md-button aria-label=\"2D Plot\" layout=\"row\" layout-fill \nng-click=\"vm.addItem(\'plot\', {}); vm.showSpecs=\'chartHor\'\"><div flex=\"25\"><md-icon md-font-icon=\"icon-chart-line\">\n</md-icon></div><div flex=\"75\" class=\"md-body-1\">2D Plot</div></md-button><md-button aria-label=\"3D Chart\" \nlayout=\"row\" layout-fill ng-click=\"vm.addItem(\'chart\', {}); vm.showSpecs=\'3DchartHor\';\"><div flex=\"25\"><md-icon \nmd-font-icon=\"icon-cube-outline\"></md-icon></div><div flex=\"75\" class=\"md-body-1\">3D Chart</div></md-button><md-button \naria-label=\"Image\" layout=\"row\" layout-fill ng-click=\"vm.addItem(\'image\', {})\"><div flex=\"25\"><md-icon \nmd-font-icon=\"icon-camera\"></md-icon></div><div flex=\"75\" class=\"md-body-1\">Image</div></md-button><md-button \naria-label=\"Video\" layout=\"row\" layout-fill ng-click=\"vm.addItem(\'video\', {})\"><div flex=\"25\"><md-icon \nmd-font-icon=\"icon-video\"></md-icon></div><div flex=\"75\" class=\"md-body-1\">Video</div></md-button><md-button \naria-label=\"Line Break\" layout=\"row\" layout-fill ng-click=\"vm.addItem(\'lineBreak\', {})\"><div flex=\"25\"><md-icon \nmd-font-icon=\"icon-border-horizontal\"></md-icon></div><div flex=\"75\" class=\"md-body-1\">Line Break</div></md-button>\n<md-input-container flex=\"90\" flex-offset=\"5\"><md-checkbox ng-model=\"vm.showMenuText\" aria-label=\"Menu Text\">\nShow Menu Text</md-checkbox></md-input-container></div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/bibliography.tmpl.html","<md-dialog-content ms-scroll><div><div layout=\"row\" flex=\"100\"><div flex=\"50\" class=\"md-body-2\">\nShow / Hide Bibliography</div><md-input-container flex=\"50\"><label>Show / Hide</label><md-select \nng-model=\"vm.thisItem.fileInfo.item_data.bibliography.show\"><md-option value=\"1\">Show</md-option><md-option value=\"0\">\nHide</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.editPerm\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.addReference()\">Add a Reference</md-button>\n</div><div layout=\"column\" layout-align=\"start start\" layout-margin flex=\"100\"><div \nng-repeat=\"obj in vm.thisItem.fileInfo.item_data.references | orderBy:obj.refNum track by obj.refID\" flex=\"100\" \nlayout=\"row\"><div ng-if=\"obj[\'type\']==\'web\'\" layout=\"row\" layout-padding \nng-click=\"vm.thisReference=obj; vm.modalType=\'refEdit\'\" class=\"pointerItem marginTop10\"><div class=\"bibNum\">\n{{obj[\'refNum\']}}</div><div class=\"bibText\">{{obj[\'author\']}}</div><div class=\"bibText\"><a href=\"{{address}}\">\n{{obj[\'webtitle\']}}</a>.</div><div class=\"bibText\"><u>{{obj[\'pagetitle\']}}</u></div>-<div class=\"bibText\">\n{{obj[\'sitetitle\']}}.</div><div class=\"bibText\">Date accessed : {{obj[\'dateaccessed\']}}</div><md-icon \nmd-font-icon=\"icon-delete\" ng-click=\"vm.deleteReference( obj.refID )\"></md-icon></div><div ng-if=\"obj[\'type\']==\'book\'\" \nlayout=\"row\" layout-padding ng-click=\"vm.thisReference=obj; vm.modalType=\'refEdit\'\" class=\"pointerItem marginTop10\">\n<div class=\"bibNum\">{{obj[\'refNum\']}}</div><div class=\"bibText\">{{obj[\'author\']}}</div><div class=\"bibText\"><u>\n{{obj[\'booktitle\']}}</u>.</div><div class=\"bibText\">{{obj[\'publisher\']}}.</div><div class=\"bibText\">\n{{obj[\'datepublished\']}}.</div>Edition -<div class=\"bibText\">{{obj[\'edition\']}}.</div><div class=\"bibText\">\nPage - {{obj[\'page\']}}.</div><md-icon md-font-icon=\"icon-delete\" ng-click=\"vm.deleteReference( obj.refID )\"></md-icon>\n</div><div ng-if=\"obj[\'type\']==\'mag\'\" layout=\"row\" layout-padding \nng-click=\"vm.thisReference=obj; vm.modalType=\'refEdit\'\" class=\"pointerItem marginTop10\"><div class=\"bibNum\">\n{{obj[\'refNum\']}}</div><div class=\"bibText\">{{obj[\'author\']}}</div><div class=\"bibText\">{{obj[\'pagetitle\']}}.</div><div\n class=\"bibText\">{{obj[\'magpapername\']}}.</div><div class=\"bibText\">{{obj[\'datepublished\']}}.</div><div \nclass=\"bibText\">Page - {{obj[\'page\']}}.</div><md-icon md-font-icon=\"icon-delete\" \nng-click=\"vm.deleteReference( obj.refID )\"></md-icon></div><div ng-if=\"obj[\'type\']==\'enc\'\" layout=\"row\" layout-padding \nng-click=\"vm.thisReference=obj; vm.modalType=\'refEdit\'\" class=\"pointerItem marginTop10\"><div class=\"bibNum\">\n{{obj[\'refNum\']}}</div><div class=\"bibText\">{{obj[\'author\']}}</div><div class=\"bibText\">{{obj[\'entryname\']}}.</div><div\n class=\"bibText\">{{obj[\'encname\']}}.</div><div class=\"bibText\">Edition - {{obj[\'edition\']}} {{obj[\'year\']}}.</div><div \nclass=\"bibText\">Page - {{obj[\'page\']}}.</div><md-icon md-font-icon=\"icon-delete\" \nng-click=\"vm.deleteReference( obj.refID )\"></md-icon></div></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill layout-align=\"end center\"><md-button \ntype=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">FINISHED EDITING</md-button></div>\n</md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/cadLink.tmpl.html","<md-dialog-content><div><div flex=\"80\" flex-offset=\"10\" class=\"md-body-1\">\nThis window lets users link this document to CAD platforms. In the first tab, you can set up CAD files to which the variables in this document can be exported. When a part is imported into a part tree, it is these connected files that can be imported as well. In the second tab, the user can set up CAD files whose properties can be imported into this document.\n</div><div layout=\"row\" flex=\"100\" class=\"fullWidth\"><div class=\"fullWidth\" ng-cloak><md-content><md-tabs \nmd-dynamic-height md-border-bottom><md-tab label=\"Onshape\"><md-content class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.editPerm\" flex=\"80\" flex-offset=\"10\" class=\"marginTop20 marginBottom20\"><div>\n<md-button class=\"md-raised md-primary\" ng-click=\"vm.getOnshapeDocs();\">Get User onShape Documents</md-button></div>\n</div><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Export Variables to Onshape\"><md-content \nclass=\"md-padding\"><div class=\"md-body-1 marginTop30 marginBottom30\">\nIn the drop boxes below, the user can select a document they own and then the element within that document to which to link variables from this document. Once selected, press the plus sign to add the element and then a new entry will appear in the list below and the user can then add equations to be sent.\n</div><div class=\"marginTop20 paddingTop40 marginBottom20 paddingBottom20 borderMe\" ng-if=\"vm.editPerm\"><div \nlayout=\"row\" flex=\"100\" layout-align=\"start start\"><div flex=\"10\" class=\"md-title\"></div><div flex=\"40\" \nclass=\"md-title\">CAD File Name</div><div flex=\"40\"><md-input-container class=\"md-block\"><md-select \nng-model=\"vm.thisCAD.document_data.id\" placeholder=\"CAD File\" ng-change=\"vm.getCadElements()\"><md-option \nng-repeat=\"item in vm.cadFiles\" ng-value=\"item.id\">{{item.name}}</md-option></md-select></md-input-container></div>\n</div><div layout=\"row\" flex=\"100\" layout-align=\"start start\"><div flex=\"10\" class=\"md-title\"></div><div flex=\"40\" \nclass=\"md-title\">Element Name</div><div flex=\"40\"><md-input-container class=\"md-block\"><md-select \nng-model=\"vm.thisCAD.element_data.id\" placeholder=\"Element Name\"><md-option ng-repeat=\"element in vm.cadElements\" \nng-value=\"element.id\">{{element.name}}</md-option></md-select></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"center center\" flex=\"80\" flex-offset=\"10\" class=\"marginTop20 marginBottom20\"><div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.addConnected();\">Add this file as Connected</md-button></div></div></div>\n<md-list layout-fill><div ng-if=\"vm.connectedFiles.length==0\" class=\"md-body-1\">\nThere are no CAD files linked to this document yet.</div><md-list-item layout=\"column\" layout-fill layout-padding \nng-repeat=\"item in vm.connectedFiles\" ng-if=\"item.cad_type==\'onShape\' || item.cad_type==\'onshape\'\"><div layout=\"row\" \nlayout-fill layout-align=\"center center\"><div flex=\"10\"><img ng-src=\"{{item.info.cad_data.element_thumbnailImage}}\" \nclass=\"md-avatar\" alt=\"{{item.info.cad_data.title}}\" onerror=\"\"></div><div flex=\"30\" layout-align=\"start start\">\n{{ item.info.cad_data.name }}</div><div flex=\"30\" flex-offset=\"5\" layout-align=\"start start\">\n{{ item.info.cad_data.element_name }}</div><div flex=\"5\" flex-offset=\"5\" ng-if=\"vm.editPerm\"><md-icon \nng-click=\"vm.removeConnected( vm.file_id, item.cad_id )\" md-font-icon=\"icon-cancel\" class=\"redIcon hoverMe\"><md-tooltip\n md-direction=\"bottom\">Remove File</md-tooltip></md-icon></div><div flex=\"5\"><md-icon \nng-click=\"item.info.showEqs=!item.info.showEqs;\" md-font-icon=\"icon-calculator\" class=\"\"><md-tooltip \nmd-direction=\"bottom\">Show/Hide Equations</md-tooltip></md-icon></div><div flex=\"5\" ng-if=\"vm.editPerm\"><md-icon \nng-click=\"vm.pushToOnshape( vm.file_id, item.cad_id, item.id )\" md-font-icon=\"icon-arrow-right-bold-circle-outline\" \nclass=\"\"><md-tooltip md-direction=\"bottom\">Push to Onshape</md-tooltip></md-icon></div><div flex=\"5\" \nng-if=\"vm.editPerm\"><md-icon ng-click=\"vm.updateElements( vm.file_id, item.cad_id, item )\" md-font-icon=\"icon-repeat\" \nclass=\"\"><md-tooltip md-direction=\"bottom\">Update Element List</md-tooltip></md-icon></div></div><div \nng-if=\"item.info.showEqs===true\" layout-fill layout-padding layout=\"column\"><div flex=\"40\" flex-offset=\"60\" \nlayout-align=\"center center\" layout=\"row\" ng-if=\"vm.editPerm\"><div layout-align=\"center center\" layout=\"row\"><md-button\n class=\"md-raised md-primary\" ng-click=\"vm.addConnEq( item, vm.file_id, \'onshape\' )\">Add Equation</md-button></div>\n</div><md-list ng-if=\"!vm.editPerm\"><md-list-item ng-repeat=\"eq in item.info.equations\" layout=\"row\" \nlayout-align=\"start start\" flex=\"40\" flex-offset=\"60\"><div flex=\"90\">{{eq.eq_name}} - {{eq.eq_size}}</div>\n</md-list-item></md-list><md-list ng-if=\"vm.editPerm\"><md-list-item ng-repeat=\"eq in item.info.equations\" layout=\"row\" \nlayout-align=\"start start\" flex=\"40\" flex-offset=\"60\"><div flex=\"90\" ng-if=\"eq.showVal==1\" ng-click=\"eq.showVal=0\">\n{{eq.eq_name}} - {{eq.eq_size}}</div><div flex=\"90\" ng-if=\"eq.showVal!=1\"><md-input-container layout-fill><md-select \nng-model=\"eq.temp_eq\" placeholder=\"Select variable\" \nng-change=\"eq.showVal=1;vm.setConnEq( item, vm.file_id, eq.conn_id, \'equation\', eq.temp_eq );\"><md-option \nng-repeat=\"thisEq in vm.worksheet\" ng-value=\"thisEq.id\" ng-if=\"(thisEq.component_type_id==3) && (thisEq.order>0)\">\n{{thisEq.name}} - {{thisEq.content.Equation.Format_size}}</md-option></md-select></md-input-container></div><div \nflex=\"5\" ng-if=\"vm.editPerm\"><md-icon ng-click=\"vm.removeConnEq( item, vm.file_id, item.cad_id, eq.conn_id );\" \nmd-font-icon=\"icon-close-circle-outline\" class=\"redIcon hoverMe\"></md-icon></div><md-divider ng-if=\"!$last\">\n</md-divider></md-list-item></md-list></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list>\n</md-content></md-tab><md-tab label=\"Import Part Data from Onshape\"><md-content class=\"md-padding\"><div \nclass=\"md-body-1\">\nUsing the drop boxes below, the user can select an onShape document they own, an element in that document, and then a part in that element. Once that is done, the user can add the part to the document by clicking on the plus sign. Once this is done, all of the properties are then accessible within this document.\n</div><div class=\"marginTop20 paddingTop40 marginBottom20 paddingBottom20 borderMe\" ng-if=\"vm.editPerm\"><div \nlayout=\"row\" flex=\"100\"><div flex=\"10\" class=\"md-title\"></div><div flex=\"40\" class=\"md-title\">Document</div><div \nflex=\"40\"><md-input-container class=\"md-block\"><md-select ng-model=\"vm.thisCAD.document_data.id\" \nplaceholder=\"Select Document\" ng-change=\"vm.getCadElements()\"><md-option ng-repeat=\"item in vm.cadFiles\" \nng-value=\"item.id\">{{item.name}}</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\">\n<div flex=\"10\" class=\"md-title\"></div><div flex=\"40\" class=\"md-title\">Element</div><div flex=\"40\"><md-input-container \nclass=\"md-block\"><md-select ng-model=\"vm.thisCAD.element_data.id\" placeholder=\"Select a parts\" \nng-change=\"vm.getCadParts()\"><md-option ng-repeat=\"element in vm.cadElements\" ng-value=\"element.id\">{{element.name}}\n</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\"><div flex=\"10\" class=\"md-title\">\n</div><div flex=\"40\" class=\"md-title\">Part</div><div flex=\"40\"><md-input-container class=\"md-block\" \nng-if=\"vm.thisCAD.element_data.elementType==\'PARTSTUDIO\'\"><md-select ng-model=\"vm.thisCAD.part_data.partId\" \nplaceholder=\"Select part\"><md-option ng-value=\"\">none</md-option><md-option ng-repeat=\"part in vm.cadParts\" \nng-value=\"part.partId\">{{part.name}}</md-option></md-select></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"center center\" flex=\"80\" flex-offset=\"10\" class=\"marginTop20 marginBottom20\"><div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.setCadProperties()\">Add Connected File</md-button></div></div></div>\n<md-divider class=\"marginTop20 marginBottom20\"></md-divider><div layout=\"row\" flex=\"100\" layout-align=\"start center\">\n<div flex=\"10\"></div><div flex=\"20\" class=\"md-title\">Document</div><div flex=\"20\" class=\"md-title\">Element</div><div \nflex=\"20\" class=\"md-title\">Part</div><div flex=\"20\" class=\"md-title\">Equation Name</div></div><md-list flex>\n<md-list-item ng-repeat=\"item in vm.fileInfo.item_data.importedCAD\"><div flex=\"10\"><img \nng-src=\"{{item.element_data.thumbnailInfo.sizes[0][\'href\']}}\" class=\"md-avatar\" alt=\"{{item.title}}\" onerror=\"\"></div>\n<div flex=\"20\">{{item.document_data.name}}</div><div flex=\"20\">{{item.element_data.name}}</div><div flex=\"20\">\n{{item.part_data.name}}</div><div flex=\"20\" ng-if=\"vm.editPerm\"><md-input-container><input ng-model=\"item.eqname\">\n</md-input-container></div><div flex=\"20\" ng-if=\"!vm.editPerm\">{{item.eqname}}</div><div flex=\"5\"><md-icon \nng-click=\"vm.updateCadMaterial( item )\" md-font-icon=\"icon-repeat\" class=\"\"><md-tooltip md-direction=\"bottom\">\nUpdate Properties</md-tooltip></md-icon></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list><div \nng-if=\"( vm.fileInfo.item_data.importedCAD.length==0 )\"><p>There are currently no CAD files imported to this document.\n</p></div></md-content></md-tab></md-tabs></md-content></md-tab><md-tab label=\"Fusion 360\"><md-content \nclass=\"md-padding\"><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.editPerm\" flex=\"80\" flex-offset=\"10\" \nclass=\"marginTop20 marginBottom20\"><div><md-button class=\"md-raised md-primary\" ng-click=\"vm.getAutocadHubs();\">\nGet User Fusion 360 Hubs</md-button></div></div><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel=\"Export Variables to Fusion 360\"><md-content class=\"md-padding\"><div class=\"md-body-1\" ng-if=\"vm.editPerm\">\nTo push data from this page to a Fusion 360 file, first select the hub where the file is located and then the project, the workspace, and the file. Once that file is selected, the user can add any number of equations. Those equations are sent to the Fusion 360 files whenever the user pushes the appropriate button below or when this file is saved. That file must be open in Fusion 360 at the time.\n</div><div class=\"md-body-1\" ng-if=\"!vm.editPerm\">\nIf there are Fusion 360 files connected to this document, they will be shown here.</div><div \nclass=\"marginTop20 paddingTop20 marginBottom20 paddingBottom20 borderMe\" ng-if=\"vm.editPerm\"><div layout=\"row\" \nflex=\"100\" layout-align=\"start start\"><div flex=\"10\" class=\"md-title\"></div><div flex=\"40\" \nclass=\"md-title marginTop20\">Select Hub</div><div flex=\"40\"><md-input-container class=\"md-block\"><md-select \nng-model=\"vm.newCADConnect.hub\" placeholder=\"Select a hub\" ng-change=\"vm.getAutocadProjects(vm.newCADConnect.hub)\">\n<md-option ng-repeat=\"item in vm.autocadHubs\" ng-value=\"item.id\">{{item.attributes.name}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-align=\"start start\"><div flex=\"10\" \nclass=\"md-title\"></div><div flex=\"40\" class=\"md-title marginTop20\">Select Project</div><div flex=\"40\">\n<md-input-container class=\"md-block\"><md-select ng-model=\"vm.newCADConnect.project\" placeholder=\"Select a project\" \nng-change=\"vm.getAutocadFolders(vm.newCADConnect.hub, vm.newCADConnect.project)\"><md-option \nng-repeat=\"project in vm.autocadProjects\" ng-value=\"project.id\">{{project.attributes.name}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-align=\"start start\"><div flex=\"10\" \nclass=\"md-title\"></div><div flex=\"40\" class=\"md-title marginTop20\">Select Root Folder</div><div flex=\"40\">\n<md-input-container class=\"md-block\"><md-select ng-model=\"vm.newCADConnect.rootFolder\" placeholder=\"Select a folder\" \nng-change=\"vm.getAutocadFolderContents(vm.newCADConnect.project, vm.newCADConnect.rootFolder)\"><md-option \nng-repeat=\"folder in vm.autocadFolders\" ng-value=\"folder.id\">{{folder.attributes.displayName}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\" ng-repeat=\"showFolder in vm.newCADConnect.folderData\" flex=\"100\" \nlayout-align=\"start start\"><div flex=\"10\" class=\"md-title\"></div><div flex=\"40\" class=\"md-title marginTop20\">Folder\n</div><div flex=\"40\" class=\"marginTop20 md-body-2\" \nng-click=\"vm.setAutocadItem(showFolder, $index, vm.newCADConnect.project)\">{{showFolder.displayName}}</div></div><div \nlayout=\"row\" flex=\"100\" layout-align=\"start start\" ng-if=\"!vm.autocadFileSelected\"><div flex=\"10\" class=\"md-title\">\n</div><div flex=\"40\" class=\"md-title marginTop20\">Select File or Folder</div><div flex=\"40\"><md-list><md-list-item \nng-repeat=\"autocadItem in vm.autocadContents\" \nng-click=\"vm.setAutocadItem(autocadItem, \'add\', vm.newCADConnect.project)\"><div ng-if=\"autocadItem.type==\'folders\'\">\nFolder - {{autocadItem.attributes.displayName}}</div><div ng-if=\"autocadItem.type==\'items\'\">\nFile - {{autocadItem.attributes.displayName}}</div></md-list-item></md-list></div></div><div layout=\"row\" flex=\"100\" \nlayout-align=\"start start\" ng-if=\"vm.autocadFileSelected\"><div flex=\"10\" class=\"md-title\"></div><div flex=\"40\" \nclass=\"md-title marginTop20\">Selected File</div><div flex=\"40\" class=\"marginTop20 md-body-2\" \nng-click=\"vm.setAutocadItem(showFolder, $index, vm.newCADConnect.project)\">\n{{vm.newCADConnect.fileData.attributes.displayName}}</div></div><div layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.autocadFileSelected\" flex=\"80\" flex-offset=\"10\" class=\"marginTop20 marginBottom20\"><div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.addConnectedToo();\">Add this file as Connected</md-button></div></div></div>\n<md-list layout-fill><div ng-if=\"vm.connectedFiles.length==0\" class=\"md-body-1\">\nThere are no CAD files linked to this document yet.</div><md-list-item layout=\"column\" layout-fill layout-padding \nng-repeat=\"item in vm.connectedFiles\" ng-if=\"item.cad_type==\'fusion\'\"><div layout=\"row\" layout-fill \nlayout-align=\"center center\"><div flex=\"10\"><img \nng-src=\"https://s3-us-west-2.amazonaws.com/cadwolf/autocadThumbnails/{{item.info.cad_data.picName}}\" class=\"md-avatar\" \nalt=\"Thumbnail\" onerror=\"\"></div><div flex=\"30\" layout-align=\"start start\">\nProject - {{ item.info.cad_data.projectData.attributes.name }}</div><div flex=\"30\" layout-align=\"start start\">\nFile - {{ item.info.cad_data.fileData.attributes.displayName }}</div><div flex=\"5\" flex-offset=\"5\" ng-if=\"vm.editPerm\">\n<md-icon ng-click=\"vm.removeConnected( vm.file_id, item.cad_id )\" md-font-icon=\"icon-cancel\" class=\"redIcon hoverMe\">\n<md-tooltip md-direction=\"bottom\">Remove File</md-tooltip></md-icon></div><div flex=\"5\"><md-icon \nng-click=\"item.info.showEqs=!item.info.showEqs;\" md-font-icon=\"icon-calculator\" class=\"\"><md-tooltip \nmd-direction=\"bottom\">Show/Hide Equations</md-tooltip></md-icon></div><div flex=\"5\" ng-if=\"vm.editPerm\" \nid=\"fusion{{item.id}}\"><md-icon ng-click=\"vm.pushToFusion( item.id )\" \nmd-font-icon=\"icon-arrow-right-bold-circle-outline\" class=\"\"><md-tooltip md-direction=\"bottom\">Push to Fusion 360\n</md-tooltip></md-icon></div><div flex=\"5\" ng-if=\"vm.editPerm\"><md-icon \nng-click=\"vm.updateFusionData( item.info.cad_data.cleanID, item.info.cad_data.projectData.id )\" \nmd-font-icon=\"icon-repeat\" class=\"\"><md-tooltip md-direction=\"bottom\">Update Thumbnail</md-tooltip></md-icon></div>\n</div><div ng-if=\"item.info.showEqs===true\" layout-fill layout-padding layout=\"column\"><div flex=\"40\" flex-offset=\"60\" \nlayout-align=\"center center\" layout=\"row\" ng-if=\"vm.editPerm\"><div layout-align=\"center center\" layout=\"row\"><md-button\n class=\"md-raised md-primary\" ng-click=\"vm.addConnEq( item, vm.file_id, \'fusion\' )\">Add Equation</md-button></div>\n</div><md-list ng-if=\"!vm.editPerm\"><md-list-item ng-repeat=\"eq in item.info.equations\" layout=\"row\" \nlayout-align=\"start start\" flex=\"40\" flex-offset=\"60\"><div flex=\"90\">{{eq.eq_name}} - {{eq.eq_size}}</div>\n</md-list-item></md-list><md-list ng-if=\"vm.editPerm\"><md-list-item ng-repeat=\"eq in item.info.equations\" layout=\"row\" \nlayout-align=\"start start\" flex=\"40\" flex-offset=\"60\"><div flex=\"90\" ng-if=\"eq.showVal==1\" ng-click=\"eq.showVal=0\">\n{{eq.eq_name}} - {{eq.eq_size}}</div><div flex=\"90\" ng-if=\"eq.showVal!=1\"><md-input-container layout-fill><md-select \nng-model=\"eq.temp_eq\" placeholder=\"Select an equation\" \nng-change=\"eq.showVal=1;vm.setConnEq( item, vm.file_id, eq.conn_id, \'equation\', eq.temp_eq );\"><md-option \nng-repeat=\"thisEq in vm.worksheet | orderBy:\'order\' track by thisEq.itemid\" ng-value=\"thisEq.id\" \nng-if=\"(thisEq.component_type_id==3) && (thisEq.order>0)\">{{thisEq.name}} - {{thisEq.content.Equation.Format_size}}\n</md-option></md-select></md-input-container></div><div flex=\"5\" ng-if=\"vm.editPerm\"><md-icon \nng-click=\"vm.removeConnEq( item, vm.file_id, item.cad_id, eq.conn_id );\" md-font-icon=\"icon-close-circle-outline\" \nclass=\"redIcon hoverMe\"></md-icon></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></div>\n<md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></md-content></md-tab><md-tab \nlabel=\"Import CAD FILE Part Data\"><md-content class=\"md-padding\"><div class=\"md-body-1\">\nTo pull data from a Fusion 360 file to CADWOLF, first select the hub where the file is located and then the project, the workspace, and the file. Once that file is selected, the user can add any number of equations.\n</div><div class=\"marginTop20 paddingTop20 marginBottom20 paddingBottom20 borderMe\" ng-if=\"vm.editPerm\"><div \nlayout=\"row\" flex=\"100\" layout-align=\"start start\"><div flex=\"10\" class=\"md-title\"></div><div flex=\"40\" \nclass=\"md-title marginTop20\">Select Hub</div><div flex=\"40\"><md-input-container class=\"md-block\"><md-select \nng-model=\"vm.newCADConnect.hub\" placeholder=\"Select a hub\" ng-change=\"vm.getAutocadProjects(vm.newCADConnect.hub)\">\n<md-option ng-repeat=\"item in vm.autocadHubs\" ng-value=\"item.id\">{{item.attributes.name}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-align=\"start start\"><div flex=\"10\" \nclass=\"md-title\"></div><div flex=\"40\" class=\"md-title marginTop20\">Select Project</div><div flex=\"40\">\n<md-input-container class=\"md-block\"><md-select ng-model=\"vm.newCADConnect.project\" placeholder=\"Select a project\" \nng-change=\"vm.getAutocadFolders(vm.newCADConnect.hub, vm.newCADConnect.project)\"><md-option \nng-repeat=\"project in vm.autocadProjects\" ng-value=\"project.id\">{{project.attributes.name}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-align=\"start start\"><div flex=\"10\" \nclass=\"md-title\"></div><div flex=\"40\" class=\"md-title marginTop20\">Select Root Folder</div><div flex=\"40\">\n<md-input-container class=\"md-block\"><md-select ng-model=\"vm.newCADConnect.rootFolder\" placeholder=\"Select a folder\" \nng-change=\"vm.getAutocadFolderContents(vm.newCADConnect.project, vm.newCADConnect.rootFolder)\"><md-option \nng-repeat=\"folder in vm.autocadFolders\" ng-value=\"folder.id\">{{folder.attributes.displayName}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\" ng-repeat=\"showFolder in vm.newCADConnect.folderData\" flex=\"100\" \nlayout-align=\"start start\"><div flex=\"10\" class=\"md-title\"></div><div flex=\"40\" class=\"md-title marginTop20\">Folder\n</div><div flex=\"40\" class=\"marginTop20 md-body-2\" \nng-click=\"vm.setAutocadItem(showFolder, $index, vm.newCADConnect.project)\">{{showFolder.displayName}}</div></div><div \nlayout=\"row\" flex=\"100\" layout-align=\"start start\" ng-if=\"!vm.autocadFileSelected\"><div flex=\"10\" class=\"md-title\">\n</div><div flex=\"40\" class=\"md-title marginTop20\">Select File or Folder</div><div flex=\"40\"><md-list><md-list-item \nng-repeat=\"autocadItem in vm.autocadContents\" \nng-click=\"vm.setAutocadPullItem(autocadItem, \'add\', vm.newCADConnect.project)\"><div \nng-if=\"autocadItem.type==\'folders\'\">Folder - {{autocadItem.attributes.displayName}}</div><div \nng-if=\"autocadItem.type==\'items\'\">File - {{autocadItem.attributes.displayName}}</div></md-list-item></md-list></div>\n</div><div layout=\"row\" flex=\"100\" layout-align=\"start start\" ng-if=\"vm.autocadFileSelected\"><div flex=\"10\" \nclass=\"md-title\"></div><div flex=\"40\" class=\"md-title marginTop20\">Selected File</div><div flex=\"40\"><md-list>\n<md-list-item><div>{{vm.newCADConnect.fileData.attributes.displayName}}</div></md-list-item></md-list></div></div><div \nlayout-align=\"center center\" ng-if=\"vm.showFusionProps\" flex=\"80\" flex-offset=\"10\" class=\"marginTop20 marginBottom20\">\n<div layout=\"row\" flex=\"75\" flex-offset=\"25\"><div flex=\"30\" class=\"md-head\">Body In Fusion Model</div><div flex=\"30\" \nclass=\"md-head\">Property</div><div flex=\"30\" class=\"md-head\">Value</div></div><div \nng-repeat=\"cadItem in vm.fusionPropItems\" layout=\"row\" flex=\"75\" flex-offset=\"25\"><md-list \nng-if=\"cadItem.properties.Mass !== undefined\" flex=\"100\" class=\"greyHoverBack hoverMe\" \nng-click=\"vm.setFusionProperties(cadItem)\"><md-list-item flex=\"100\" layout=\"row\"><div flex=\"100\" layout=\"row\"><div \nflex=\"30\">{{cadItem.properties.Name}}</div><div flex=\"30\">Area</div><div flex=\"30\">{{cadItem.properties.Area}}</div>\n</div></md-list-item><md-list-item flex=\"100\" layout=\"row\"><div flex=\"100\" layout=\"row\"><div flex=\"30\">\n{{cadItem.properties.Name}}</div><div flex=\"30\">Density</div><div flex=\"30\">{{cadItem.properties.Density}}</div></div>\n</md-list-item><md-list-item flex=\"100\" layout=\"row\"><div flex=\"100\" layout=\"row\"><div flex=\"30\">\n{{cadItem.properties.Name}}</div><div flex=\"30\">Mass</div><div flex=\"30\">{{cadItem.properties.Mass}}</div></div>\n</md-list-item><md-list-item flex=\"100\" layout=\"row\"><div flex=\"100\" layout=\"row\"><div flex=\"30\">\n{{cadItem.properties.Name}}</div><div flex=\"30\">Volume</div><div flex=\"30\">{{cadItem.properties.Volume}}</div></div>\n</md-list-item></md-list></div></div></div><md-divider class=\"marginTop20 marginBottom20\"></md-divider><div \nlayout=\"row\" flex=\"100\" layout-align=\"start center\"><div flex=\"10\"></div><div flex=\"20\" class=\"md-title\">Project</div>\n<div flex=\"20\" class=\"md-title\">File</div><div flex=\"20\" class=\"md-title\">Body</div><div flex=\"20\" class=\"md-title\">\nEquation Name</div></div><md-list flex><md-list-item ng-repeat=\"item in vm.fileInfo.item_data.importedCAD\" \nng-if=\"item.type==\'fusion\'\"><div flex=\"10\"><img \nng-src=\"https://s3-us-west-2.amazonaws.com/cadwolf/autocadThumbnails/{{item.picName}}\" class=\"md-avatar\" \nalt=\"Thumbnail\" onerror=\"\"></div><div flex=\"20\">{{item.projectData.attributes.name}}</div><div flex=\"20\">\n{{item.fileData.attributes.displayName}}</div><div flex=\"20\">{{item.name}}</div><div flex=\"20\" ng-if=\"vm.editPerm\">\n<md-input-container><input class=\"marginTop10\" ng-model=\"item.eqname\"></md-input-container></div><div flex=\"20\" \nng-if=\"!vm.editPerm\">{{item.eqname}}</div><div flex=\"5\"><md-icon \nng-click=\"vm.updateFusionData( item.cleanID, item.projectData.id )\" md-font-icon=\"icon-repeat\" class=\"\"><md-tooltip \nmd-direction=\"bottom\">Update Properties</md-tooltip></md-icon></div><md-divider ng-if=\"!$last\"></md-divider>\n</md-list-item></md-list><div ng-if=\"( vm.fileInfo.item_data.importedCAD.length==0 )\"><p>\nThere are currently no CAD files imported to this document.</p></div></md-content></md-tab></md-tabs></md-content>\n</md-tab></md-tabs></md-content></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-fill layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vm.acceptChanges();\" class=\"send-button md-accent md-raised\">FINISHED</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/checkStatus.html","<div layout-fill><div layout=\"row\" ng-if=\"vm.fileInfo.item_data.checkout_id!=0\"><div flex=\"50\" class=\"md-body-1\">\nFile is checked out by :</div><div flex=\"50\" class=\"md-body-1\">{{vm.fileInfo.item_data.checkout_name}}</div></div><div \nlayout=\"row\" layout-align=\"center center\" \nng-if=\"(( vm.fileInfo.item_data.checkout_id == 0 ) && \n                ( vm.permissions.edit != 1 ))\"><div flex=\"50\" \nclass=\"md-body-1\">Document is not checked out</div></div><div layout=\"row\" layout-align=\"center center\" \nng-if=\"( ( vm.permissions.edit==1 ) && \n                (   vm.fileInfo.item_data.checkout_id==0 ) )\"><md-button \ntype=\"submit\" ng-click=\"vm.checkOutFile();\" class=\"send-button md-accent md-raised\">CHECK OUT DOCUMENT</md-button>\n</div><div layout=\"row\" layout-align=\"center center\" ng-if=\"(vm.fileInfo.item_data.checkout_id==Spark.state.user.id )\">\n<md-button type=\"submit\" ng-click=\"vm.checkInFile();\" class=\"send-button md-accent md-raised\">CHECK IN DOCUMENT\n</md-button></div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/datasetInputs.tmpl.html","<md-dialog-content ms-scroll><div><div layout=\"row\" class=\"md-body-1\" layout-fill>\nDatasets are places where users can input and store large amounts of data. This is the view where users bring those datasets into the document to be used as variables. If you have edit permissions, you will be able to add an input and then navigate to the desired dataset. If not, you will see a list of dataset inputs already present.\n</div><div class=\"md-headline marginTopBottom20\" layout-fill>Dataset Inputs</div><div layout=\"column\" flex=\"100\" \nlayout-fill class=\"marginTopBottom20\"><md-list><md-list-item flex=\"60\" flex-offset=\"20\" class=\"borderBottom\"><div \nflex=\"60\">Equation Name</div><div flex=\"30\">Size</div></md-list-item><md-list-item \nng-repeat=\"obj in vm.cadwolf_worksheet\" ng-if=\"obj.content.Equation.inputType==\'Dataset\'\" class=\"borderBottom\" \nflex=\"60\" flex-offset=\"20\"><div flex=\"60\">{{obj.content.Equation.Format_name}}</div><div flex=\"30\">\n{{obj.content.Equation.Format_size}}</div><div flex=\"5\"><md-icon md-font-icon=\"icon-delete\" \nng-click=\"vm.deleteInput( obj )\"></md-icon></div></md-list-item></md-list></div><div \nclass=\"md-headline marginTopBottom20\" layout-fill ng-if=\"vm.editPerm\">Add Datasets</div><div ng-if=\"vm.editPerm\" \nlayout=\"row\" class=\"md-body-1 marginTopBottom20\" flex=\"80\" flex-margin=\"10\">\nEnter a URL for a desired dataset in the box below. If there is a dataset at that URL, the dataset will be added to the document as the name given in the dataset.\n</div><div layout=\"row\" flex=\"100\" ng-if=\"vm.editPerm\"><md-input-container class=\"md-block\" flex=\"60\" flex-offset=\"20\">\n<label>Dataset URL</label><input ng-model=\"vm.inputURL\" ng-enter=\"vm.getFolderContents( \'\', vm.inputURL )\">\n</md-input-container></div><div id=\"imageSelect\"><md-list><md-list-item flex=\"60\" flex-offset=\"20\" \nng-repeat=\"thisDataset in vm.currentContents\" \nng-if=\"(thisDataset.file_type_id==\'Dataset\')||(thisDataset.file_type_id==\'Workspace\')\"><div class=\"md-list-item-text\" \nlayout=\"row\" ng-if=\"thisDataset.file_type_id==\'Dataset\'\" flex=\"100\"><div flex=\"15\" flex-offset=\"5\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon></div><div flex=\"40\" flex-offset=\"5\">{{thisDataset.name}}</div><div layout=\"row\" \nlayout-align=\"center center\" flex=\"25\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.addDataset( thisDataset )\">\nAdd Dataset</md-button></div></div><div class=\"md-list-item-text pointerItem\" layout=\"row\" \nng-if=\"thisDataset.file_type_id==\'Workspace\'\" flex=\"100\" \nng-click=\"vm.thisItem.content.path=vm.thisItem.content.path+\'/\'+thisDataset.name;\n		    			 		   vm.getFolderContents( vm.thisItem, vm.thisItem.content.path ) \">\n<div flex=\"15\" flex-offset=\"5\" ng-if=\"thisDataset.file_type_id==\'Workspace\'\"><md-icon \nmd-font-icon=\"icon-folder-outline\"></md-icon></div><div flex=\"75\" flex-offset=\"5\">{{thisDataset.name}}</div></div>\n<md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill layout-align=\"end center\"><md-button \ntype=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">FINISHED EDITING</md-button></div>\n</md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/depFiles.tmpl.html","<md-dialog-content ms-scroll><div><div layout=\"row\" layout-align=\"center center\"><div><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.getDepFiles();\">Get Dependent Files</md-button></div></div><div layout=\"row\" \nflex=\"100\" class=\"fullWidth\"><div class=\"fullWidth\" ng-cloak><md-content><md-tabs md-dynamic-height md-border-bottom>\n<md-tab label=\"Files that Depend Upon this File\"><md-content class=\"md-padding\"><p>\nThe files below are dependent upon one or more variables in this file. The icons denote whether or not those files need to be updated. Users can update these files by simply clicking on the icon.\n</p><div layout=\"row\" flex=\"100\" layout-align=\"start start\"><div flex=\"25\" class=\"md-title\">File Name</div><div \nflex=\"55\" flex-offset=\"5\" class=\"md-title\">URL</div><div flex=\"10\" flex-offset=\"5\" class=\"md-title textCentered\">Status\n</div></div><md-list layout-fill><div ng-if=\"vm.depFiles.length==0\" class=\"md-body-1\">\nThere are no files that depend upon this document.</div><md-list-item layout=\"column\" layout-fill \nng-repeat=\"item in vm.depFiles\"><div layout=\"row\" layout-fill layout-align=\"center center\"><div flex=\"25\" \nlayout-align=\"start start\">{{ item.name }}</div><div flex=\"55\" flex-offset=\"5\" layout-align=\"start start\">\n{{ item.path }}</div><div flex=\"10\" flex-offset=\"5\" ng-if=\"item.update\" class=\"textCentered\"><md-icon \nng-click=\"vm.updateFile( item.id, \'documentUpdate\' )\" md-font-icon=\"icon-checkbox-marked-circle-outline\" \nclass=\"redIcon hoverMe\"><md-tooltip md-direction=\"bottom\">Click to Update</md-tooltip></md-icon></div><div flex=\"10\" \nflex-offset=\"5\" ng-if=\"!item.update\" class=\"textCentered\"><md-icon ng-click=\"\" \nmd-font-icon=\"icon-checkbox-marked-circle-outline\" class=\"greenIcon hoverMe\"><md-tooltip md-direction=\"bottom\">\nItem Up to Date</md-tooltip></md-icon></div></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list>\n</md-content></md-tab><md-tab label=\"Files that this Document depends upon\"><md-content class=\"md-padding\"><p>\nThis tab simply displays a list of documents from which this document pulls equations.</p><div layout=\"row\" flex=\"100\" \nlayout-align=\"start center\"><div flex=\"30\" class=\"md-title\">File Name</div><div flex=\"50\" flex-offset=\"5\" \nclass=\"md-title\">URL</div><div flex=\"10\" flex-offset=\"5\" class=\"md-title\">Variable</div></div><md-list flex>\n<md-list-item ng-repeat=\"item in vm.controlFiles\"><div flex=\"30\">{{item.name}}</div><div flex=\"50\" flex-offset=\"5\">\n{{item.path}}</div><div flex=\"10\" flex-offset=\"5\">{{item.varname}}</div><md-divider ng-if=\"!$last\"></md-divider>\n</md-list-item></md-list><div ng-if=\"( vm.controlFiles.length==0 )\"><p>\nThere are currently no files dependent upon this document.</p></div></md-content></md-tab></md-tabs></md-content></div>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-fill layout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" \nclass=\"send-button md-accent md-raised\">FINISHED</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/editCard.tmpl.html","<md-dialog-content ms-scroll><div flex=\"100\" layout-align=\"center center\" layout=\"row\"><div \nclass=\"md-title marginTop20\">Card Value Properties</div></div><div layout=\"row\" flex=\"100\" class=\"fullWidth\"><div \nflex=\"70\" flex-offset=\"5\" layout=\"row\"><div flex=\"25\" class=\"md-body-1\">Variable Name</div><div \nclass=\"md-caption greyText marginTop3\" flex-offset=\"5\">The name of the variable whose value is shown</div></div><div \nflex=\"20\" layout-align=\"center center\"><md-input-container class=\"fullWidth\"><md-select \nng-model=\"vm.thisItem.content.variableID\" ng-change=\"vm.getCardValue( vm.thisItem )\"><md-option \nng-repeat=\"obj in vm.worksheet | orderBy:\'order\' track by obj.itemid\" \nng-if=\"( obj.order != 0 ) && ( obj.component_type_id == 3 )\" ng-value=\"obj.itemid\">{{obj.name}} - {{obj.order}}\n</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"70\" \nflex-offset=\"5\" layout=\"row\"><div flex=\"25\" class=\"md-body-1\">Variable Index</div><div \nclass=\"md-caption greyText marginTop3\" flex-offset=\"5\">The index of the variable (0-0) for single numbers</div></div>\n<div flex=\"20\" layout-align=\"center center\"><md-input-container class=\"fullWidth\"><input \nng-model=\"vm.thisItem.content.index\" ng-enter=\"vm.getCardValue( vm.thisItem )\"></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"70\" flex-offset=\"5\" layout=\"row\"><div flex=\"25\" class=\"md-body-1\">\nColor</div><div class=\"md-caption greyText marginTop3\" flex-offset=\"5\">The color of the variable value</div></div><div \nflex=\"20\" layout-align=\"center center\"><md-input-container class=\"fullWidth\"><input \nng-model=\"vm.thisItem.content.variableColor\"></md-input-container></div></div><div flex=\"100\" \nlayout-align=\"center center\" layout=\"row\"><div class=\"md-title marginTop20\">Card Appearance</div></div><div \nlayout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"70\" flex-offset=\"5\" layout=\"row\"><div flex=\"25\" class=\"md-body-1\">\nWidth</div><div class=\"md-caption greyText marginTop3\" flex-offset=\"5\">The width of the card</div></div><div flex=\"20\" \nlayout-align=\"center center\"><md-input-container class=\"fullWidth\"><input ng-model=\"vm.thisItem.content.width\">\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"70\" flex-offset=\"5\" \nlayout=\"row\"><div flex=\"25\" class=\"md-body-1\">Height</div><div class=\"md-caption greyText marginTop3\" flex-offset=\"5\">\nThe height of the card</div></div><div flex=\"20\" layout-align=\"center center\"><md-input-container class=\"fullWidth\">\n<input ng-model=\"vm.thisItem.content.height\"></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nclass=\"fullWidth\"><div flex=\"70\" flex-offset=\"5\" layout=\"row\"><div flex=\"25\" class=\"md-body-1\">Title</div><div \nclass=\"md-caption greyText marginTop3\" flex-offset=\"5\">The title associated with the card</div></div><div flex=\"20\" \nlayout-align=\"center center\"><md-input-container class=\"fullWidth\"><input ng-model=\"vm.thisItem.content.title\">\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"70\" flex-offset=\"5\" \nlayout=\"row\"><div flex=\"25\" class=\"md-body-1\">Show / Hide Title</div><div class=\"md-caption greyText marginTop3\" \nflex-offset=\"5\">Show or hide the title</div></div><div flex=\"20\" layout-align=\"center center\"><md-input-container \nlayout-fill><md-select ng-model=\"vm.thisItem.content.showTitle\"><md-option value=\"0\">Hide</md-option><md-option \nvalue=\"1\">Show</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" class=\"fullWidth\">\n<div flex=\"70\" flex-offset=\"5\" layout=\"row\"><div flex=\"25\" class=\"md-body-1\">Show / Place Name</div><div \nclass=\"md-caption greyText marginTop3\" flex-offset=\"5\">\nThe name of the variable can be shown beneath the title or top left</div></div><div flex=\"20\" \nlayout-align=\"center center\"><md-input-container layout-fill><md-select ng-model=\"vm.thisItem.content.showVariable\">\n<md-option value=\"0\">Hide</md-option><md-option value=\"1\">Beneath Title</md-option><md-option value=\"2\">Top Left\n</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"70\" \nflex-offset=\"5\" layout=\"row\"><div flex=\"25\" class=\"md-body-1\">Show / Hide the Order</div><div \nclass=\"md-caption greyText marginTop3\" flex-offset=\"5\">Show or hide the location of the variable in the document</div>\n</div><div flex=\"20\" layout-align=\"center center\"><md-input-container layout-fill><md-select \nng-model=\"vm.thisItem.content.showOrder\"><md-option value=\"0\">Hide</md-option><md-option value=\"1\">Show</md-option>\n</md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"70\" \nflex-offset=\"5\" layout=\"row\"><div flex=\"25\" class=\"md-body-1\">Show / Hide Description</div><div \nclass=\"md-caption greyText marginTop3\" flex-offset=\"5\">Show or hide the bottom description</div></div><div flex=\"20\" \nlayout-align=\"center center\"><md-input-container layout-fill><md-select ng-model=\"vm.thisItem.content.showDescription\">\n<md-option value=\"0\">Hide</md-option><md-option value=\"1\">Show</md-option></md-select></md-input-container></div></div>\n<div flex=\"100\" layout-align=\"center center\" layout=\"row\"><div class=\"md-title marginTop20\">Description</div></div>\n<text-angular ng-model=\"vm.thisItem.content.description\"></text-angular></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill layout-align=\"end center\"><md-button \ntype=\"submit\" ng-click=\"vm.acceptChanges(vm.thisItem);\" class=\"send-button md-accent md-raised\">FINISHED</md-button>\n</div></md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/editChart.tmpl.html","<md-dialog aria-label=\"\" class=\"dialogItem\" id=\"chartDialog\" ng-cloak><form name=\"chartForm\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Edit Chart</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel();\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" flex=\"100\" class=\"fullWidth\" layout-align=\"center start\"><div \nflex=\"15\" class=\"borderRight\"><div layout=\"column\" layout=\"start center\" class=\"fullWidth\"><span \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpec/leftColumn.html\'\"></span></div></div><div \nflex=\"25\" class=\"borderRight\"><div layout=\"column\" layout=\"start center\" class=\"fullWidth\"><span \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpec/dataSection.html\'\"></span></div></div><div \nflex=\"60\"><div layout=\"column\" layout=\"start center\" class=\"fullWidth\"><h2>Chart will be here</h2></div></div></div>\n</md-dialog-content><div id=\"modalFooter\"><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.cancel();\">\nFinished Editing</md-button></md-dialog-actions></div></form></md-dialog>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/editDropdown.tmpl.html","<md-dialog-content ms-scroll><div class=\"md-body-1\">\nThe parameters below let the user set the properties of the dropdown. The user can also set the items to be selected within the dropdown. You can add as many inputs as you like and edit each input independently.\n</div><div flex=\"100\" layout-align=\"center center\" layout=\"row\"><div class=\"md-title marginTop20\">\nProperties of the Dropdown</div></div><div layout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"70\" flex-offset=\"5\" \nlayout=\"row\"><div flex=\"20\" class=\"md-body-1\">Dropdown Name</div><div class=\"md-caption greyText marginTop3\" \nflex-offset=\"5\">Used in later equations to access the value</div></div><div flex=\"20\" layout-align=\"center center\">\n<md-input-container class=\"fullWidth\"><input ng-model=\"vm.thisItem.name\" \nng-enter=\"vm.thisItem.content.Equation.Format_name = vm.thisItem.name\"></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"70\" flex-offset=\"5\" layout=\"row\"><div flex=\"20\" class=\"md-body-1\">\nLabel</div><div class=\"md-caption greyText marginTop3\" flex-offset=\"5\">Show or hide the equation name</div></div><div \nflex=\"20\" layout-align=\"center center\"><md-input-container layout-fill><md-select \nng-model=\"vm.thisItem.content.dropdown.showLabel\"><md-option value=\"0\">Hide</md-option><md-option value=\"1\">Show\n</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"70\" \nflex-offset=\"5\" layout=\"row\"><div flex=\"20\" class=\"md-body-1\">Border</div><div class=\"md-caption greyText marginTop3\" \nflex-offset=\"5\">Show or hide the border</div></div><div flex=\"20\" layout-align=\"center center\"><md-input-container \nlayout-fill><md-select ng-model=\"vm.thisItem.content.dropdown.showBorder\"><md-option value=\"0\">Hide</md-option>\n<md-option value=\"1\">Show</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nclass=\"fullWidth\"><div flex=\"70\" flex-offset=\"5\" layout=\"row\"><div flex=\"20\" class=\"md-body-1\">Width</div><div \nclass=\"md-caption greyText marginTop3\" flex-offset=\"5\">The width of the dropdown - not the block</div></div><div \nflex=\"20\" layout-align=\"center center\"><md-input-container class=\"fullWidth\"><input \nng-model=\"vm.thisItem.content.dropdown.width\"></md-input-container></div></div><div flex=\"100\" \nlayout-align=\"center center\" layout=\"row\"><div class=\"md-title marginTop20\">Contents of the Dropdown</div></div><div \nflex=\"100\" layout-align=\"center center\" layout=\"row\"><div flex=\"50\" layout-align=\"center center\"><md-list \nclass=\"md-dense\" flex><md-list-item><div flex=\"45\">Value</div><div flex=\"45\">Label</div></md-list-item><md-list-item \nclass=\"md-3-line\" ng-repeat=\"eqObj in vm.thisItem.content.dropdown.values\"><div flex=\"45\"><md-input-container \nclass=\"md-block\"><label>Option Value</label><input ng-model=\"eqObj.value\"></md-input-container></div><div flex=\"45\">\n<md-input-container class=\"md-block\"><label>Option Label</label><input ng-model=\"eqObj.label\"></md-input-container>\n</div><div flex=\"10\" class=\"topPaddedText hoverMe\"><md-icon md-font-icon=\"icon-close-circle-outline\" \nng-click=\"vm.thisItem.content.dropdown.values.splice( $index, 1);\"></md-icon></div></md-list-item></md-list></div>\n</div><div flex=\"100\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-primary\" \nng-click=\"vm.thisItem.content.dropdown.values.push({ \'value\': \'0\', \'label\':\'0\', \'color\':\'#0392d8\', \'labelType\':\'value\' })\">\nAdd Dropdown Option</md-button></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-fill layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vm.acceptChanges(vm.thisItem);\" class=\"send-button md-accent md-raised\">FINISHED</md-button></div>\n</md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/editEquation.tmpl.html","<md-dialog-content ms-scroll><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Properties\"><md-content \nclass=\"md-padding\" layout=\"column\" layout-align=\"start center\"><div class=\"md-body-1\">\nThis tab provides the user with an inteface to view and edit the equation\'s properties. The first input block shows the current equation and lets the user edit the equation as desired. The remaining blocks let the user determine how the equation is displayed and how other users interact with the equation.\n</div><div layout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"20\" flex-offset=\"5\"><div class=\"md-body-1\">\nEquation as entered</div></div><div flex=\"70\" layout-align=\"center center\"><md-input-container class=\"fullWidth\">\n<label>Equation as Entered</label><input ng-model=\"vm.thisItem.content.Equation.Format_equation\"></md-input-container>\n</div></div><div layout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"20\" flex-offset=\"5\"><div class=\"md-body-1\">\nResulting Equation</div></div><div flex=\"70\" layout-align=\"center center\"><div flex=\"100\" layout=\"row\" \nclass=\"fullWidth\" layout-align=\"center center\"><span mathjax-bind=\"vm.thisItem.content.Equation.Format_left\"></span> \n<span>=</span> <span mathjax-bind=\"vm.thisItem.content.Equation.Format_showequation\"></span></div></div></div><div \nlayout=\"row\" flex=\"100\" class=\"fullWidth\"><table class=\"simple fullWidth\" ms-responsive-table><thead><tr><th>Name</th>\n<th>Value</th><th>Units</th><th>Quantity</th><th>Display</th><th>Errors</th><th>Edit in Use</th></tr></thead><tbody>\n<tr><td>{{vm.thisItem.content.Equation.Format_name}}</td><td ng-if=\"vm.thisItem.content.Equation.Format_size!=\'1x1\'\">\n{{vm.thisItem.content.Equation.Format_size}}</td><td ng-if=\"vm.thisItem.content.Equation.Format_size==\'1x1\'\">\n{{vm.thisItem.content.Equation.Solution_real[\'0-0\']}}</td><td ng-if=\"vm.thisItem.content.Equation.Units_units!=\'\'\">\n{{vm.thisItem.content.Equation.Units_units}}</td><td ng-if=\"vm.thisItem.content.Equation.Units_units==\'\'\">No Units</td>\n<td ng-if=\"vm.thisItem.content.Equation.Units_units!=\'\'\">{{vm.thisItem.content.Equation.Units_quantity}}</td><td \nng-if=\"vm.thisItem.content.Equation.Units_units==\'\'\">No Quantity</td><td><md-select class=\"tableSelect\" \nng-model=\"vm.thisItem.content.Equation.Format_showvalue\" ng-change=\"vm.createShowSolution( vm.thisItem );\"><md-option \nvalue=\"size\">Display Size</md-option><md-option value=\"value\">Display Result</md-option></md-select></td><td>\n{{vm.thisItem.content.Equation.Errors_errors.length}}</td><td><md-select class=\"tableSelect\" \nng-model=\"vm.thisItem.content.Equation.Format_editinuse\"><md-option ng-value=\"1\">True</md-option><md-option \nng-value=\"0\">False</md-option></md-select></td></tr></tbody></table></div><div layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" class=\"fullWidth\" \nng-if=\"vm.thisItem.content.Equation.Units_base_string==\'00-211000\' ||\n		 		 		vm.thisItem.content.Equation.Units_base_string==\'00-221000\' ||\n		 		 		vm.thisItem.content.Equation.Units_base_string==\'00-321000\' ||\n		 		 		vm.thisItem.content.Equation.Units_base_string==\'00-2-11000\' ||\n		 		 		vm.thisItem.content.Equation.Units_base_string==\'-10-321000\' ||\n		 		 		vm.thisItem.content.Equation.Units_base_string==\'-20-321000\' ||\n		 		 		vm.thisItem.content.Equation.Units_base_string==\'-10-221000\' ||\n		 		 		vm.thisItem.content.Equation.Units_base_string==\'204-2-1000\' ||\n		 		 		vm.thisItem.content.Equation.Units_base_string==\'10100000\' ||\n		 		 		vm.thisItem.content.Equation.Units_base_string==\'00-120000\' \">\n<div flex=\"100\" class=\"md-margin md-title textCentered\">Choose how this quantity is to be displayed</div><div \nflex=\"100\" layout=\"row\"><div flex=\"50\" layout=\"row\" flex-offset=\"25\"><div><md-select class=\"tableSelect\" \nng-model=\"vm.thisItem.content.Equation.Units_showunits\" ng-change=\"vm.createShowSolution( vm.thisItem );\"><md-option \nng-repeat=\"item in vm.cadwolfScaleUnits\" value=\"{{item.unit}}\" \nng-if=\"item.basestring==vm.thisItem.content.Equation.Units_base_string\">{{item.unit}}</md-option></md-select></div>\n</div></div></div><div layout=\"column\" flex=\"100\" class=\"fullWidth\" \nng-if=\"vm.thisItem.content.Equation.Units_base_string!=\'00-211000\' && \n		 		 		vm.thisItem.content.Equation.Units_base_string!=\'00-221000\' &&\n		 		 		vm.thisItem.content.Equation.Units_base_string!=\'00-321000\' &&\n		 		 		vm.thisItem.content.Equation.Units_base_string!=\'00-2-11000\' && \n		 		 		vm.thisItem.content.Equation.Units_base_string!=\'-10-321000\' &&\n		 		 		vm.thisItem.content.Equation.Units_base_string!=\'-20-321000\' &&\n		 		 		vm.thisItem.content.Equation.Units_base_string!=\'-10-221000\' &&\n		 		 		vm.thisItem.content.Equation.Units_base_string!=\'204-2-1000\' &&\n		 		 		vm.thisItem.content.Equation.Units_base_string!=\'10100000\' &&\n		 		 		vm.thisItem.content.Equation.Units_base_string!=\'00-120000\' \">\n<div flex=\"100\" class=\"md-margin md-title textCentered\">Choose units to be displayed for each quantity</div><div \nflex=\"100\" layout=\"row\"><div flex=\"50\" layout=\"row\" flex-offset=\"25\" \nng-if=\"(vm.thisItem.content.Equation.Units_base_array[\'A\']==0 &&\n			 			 		vm.thisItem.content.Equation.Units_base_array[\'K\']==0 &&\n			 			 		vm.thisItem.content.Equation.Units_base_array[\'cd\']==0 &&\n			 			 		vm.thisItem.content.Equation.Units_base_array[\'kg\']==0 &&\n			 			 		vm.thisItem.content.Equation.Units_base_array[\'m\']==0 &&\n			 			 		vm.thisItem.content.Equation.Units_base_array[\'molecules\']==0 &&\n			 			 		vm.thisItem.content.Equation.Units_base_array[\'mol\']==0 &&\n			 			 		vm.thisItem.content.Equation.Units_base_array[\'s\']==0) ||\n			 			 		vm.thisItem.content.Equation.Units_base_array[\'rad\']!=0\">\n<div flex=\"50\" class=\"marginTop25 textCentered\">Unscaled Items (Radians, etc)</div><div flex=\"50\"><md-select \nclass=\"tableSelect\" ng-model=\"vm.thisItem.content.Equation.Units_showObject.rad\" \nng-change=\"vm.thisItem.content.Equation.Units_showunits=\'\'; vm.createShowSolution( vm.thisItem );\"><md-option \nng-repeat=\"item in vm.cadwolfScaleUnits\" value=\"{{item.unit}}\" ng-if=\"item.quantity==\'Angle\'\">{{item.unit}}</md-option>\n</md-select></div></div></div><div flex=\"100\" layout=\"row\"><div flex=\"50\" layout=\"row\" flex-offset=\"25\" \nng-if=\"vm.thisItem.content.Equation.Units_base_array[\'m\']!=0\"><div flex=\"50\" class=\"marginTop25 textCentered\">Length\n</div><div flex=\"50\"><md-select class=\"tableSelect\" ng-model=\"vm.thisItem.content.Equation.Units_showObject.m\" \nng-change=\"vm.thisItem.content.Equation.Units_showunits=\'\'; vm.createShowSolution( vm.thisItem );\"><md-option \nng-repeat=\"item in vm.cadwolfScaleUnits\" value=\"{{item.unit}}\" ng-if=\"item.quantity==\'length\'\">{{item.unit}}\n</md-option></md-select></div></div></div><div flex=\"100\" layout=\"row\"><div flex=\"50\" layout=\"row\" flex-offset=\"25\" \nng-if=\"vm.thisItem.content.Equation.Units_base_array[\'s\']!=0\"><div flex=\"50\" class=\"marginTop25 textCentered\">Time\n</div><div flex=\"50\"><md-select class=\"tableSelect\" ng-model=\"vm.thisItem.content.Equation.Units_showObject.s\" \nng-change=\"vm.thisItem.content.Equation.Units_showunits=\'\'; vm.createShowSolution( vm.thisItem );\"><md-option \nng-repeat=\"item in vm.cadwolfScaleUnits\" value=\"{{item.unit}}\" ng-if=\"item.quantity==\'time\'\">{{item.unit}}</md-option>\n</md-select></div></div></div><div flex=\"100\" layout=\"row\"><div flex=\"50\" layout=\"row\" flex-offset=\"25\" \nng-if=\"vm.thisItem.content.Equation.Units_base_array[\'kg\']!=0\"><div flex=\"50\" class=\"marginTop25 textCentered\">Mass\n</div><div flex=\"50\"><md-select class=\"tableSelect\" ng-model=\"vm.thisItem.content.Equation.Units_showObject.kg\" \nng-change=\"vm.thisItem.content.Equation.Units_showunits=\'\'; vm.createShowSolution( vm.thisItem );\"><md-option \nng-repeat=\"item in vm.cadwolfScaleUnits\" value=\"{{item.unit}}\" ng-if=\"item.quantity==\'mass\'\">{{item.unit}}</md-option>\n</md-select></div></div></div><div flex=\"100\" layout=\"row\"><div flex=\"50\" layout=\"row\" flex-offset=\"25\" \nng-if=\"vm.thisItem.content.Equation.Units_base_array[\'A\']!=0\"><div flex=\"50\" class=\"marginTop25 textCentered\">\nElectric Current</div><div flex=\"50\"><md-select class=\"tableSelect\" \nng-model=\"vm.thisItem.content.Equation.Units_showObject.A\" \nng-change=\"vm.thisItem.content.Equation.Units_showunits=\'\'; vm.createShowSolution( vm.thisItem );\"><md-option \nng-repeat=\"item in vm.cadwolfScaleUnits\" value=\"{{item.unit}}\" ng-if=\"item.quantity==\'Electric Current\'\">{{item.unit}}\n</md-option></md-select></div></div></div><div flex=\"100\" layout=\"row\"><div flex=\"50\" layout=\"row\" flex-offset=\"25\" \nng-if=\"vm.thisItem.content.Equation.Units_base_array[\'K\']!=0\"><div flex=\"50\" class=\"marginTop25 textCentered\">\nTemperature</div><div flex=\"50\"><md-select class=\"tableSelect\" \nng-model=\"vm.thisItem.content.Equation.Units_showObject.K\" \nng-change=\"vm.thisItem.content.Equation.Units_showunits=\'\'; vm.createShowSolution( vm.thisItem );\"><md-option \nng-repeat=\"item in vm.cadwolfScaleUnits\" value=\"{{item.unit}}\" ng-if=\"item.quantity==\'Temperature\'\">{{item.unit}}\n</md-option></md-select></div></div></div><div flex=\"100\" layout=\"row\"><div flex=\"50\" layout=\"row\" flex-offset=\"25\" \nng-if=\"vm.thisItem.content.Equation.Units_base_array[\'cd\']!=0\"><div flex=\"50\" class=\"marginTop25 textCentered\">Candela\n</div><div flex=\"50\"><md-select class=\"tableSelect\" ng-model=\"vm.thisItem.content.Equation.Units_showObject.cd\" \nng-change=\"vm.thisItem.content.Equation.Units_showunits=\'\'; vm.createShowSolution( vm.thisItem );\"><md-option \nng-repeat=\"item in vm.cadwolfScaleUnits\" value=\"{{item.unit}}\" ng-if=\"item.quantity==\'luminous intensity\'\">\n{{item.unit}}</md-option></md-select></div></div></div></div></md-content></md-tab><md-tab label=\"Models\"><md-content \nclass=\"md-padding\"><div class=\"md-body-1\">\nWhen an equation is solved, four models are created to help the user identify problems and understand how CADWOLF solved the problem. These models replace the entered items with the numbers, units, sizes, quantities, and dimensions seen by CADWOLF. If an equation is producing an error or not resulting in the size or units expected, these models can help resolve that problem.\n</div><div flex=\"100\" layout=\"column\" class=\"fullWidth\"><div flex=\"100\" layout=\"row\" class=\"fullWidth\"><div flex=\"20\" \nflex-offset=\"5\">Numerical Model</div><div flex=\"20\" flex-offset=\"5\">\n$${{vm.thisItem.content.Equation.Models_numerical}}$$</div></div><md-divider></md-divider><div flex=\"100\" layout=\"row\" \nclass=\"fullWidth\"><div flex=\"20\" flex-offset=\"5\">Units Model</div><div flex=\"70\" flex-offset=\"5\"><span \nmathjax-bind=\"vm.thisItem.content.Equation.Models_units\"></span></div></div><md-divider></md-divider><div flex=\"100\" \nlayout=\"row\" class=\"fullWidth\"><div flex=\"20\" flex-offset=\"5\">Quantity Model</div><div flex=\"70\" flex-offset=\"5\"><span \nmathjax-bind=\"vm.thisItem.content.Equation.Models_quantities\"></span></div></div><md-divider></md-divider><div \nflex=\"100\" layout=\"row\" class=\"fullWidth\"><div flex=\"20\" flex-offset=\"5\">Dimensional Model</div><div flex=\"70\" \nflex-offset=\"5\"><span mathjax-bind=\"vm.thisItem.content.Equation.Models_dimensions\"></span></div></div></div>\n</md-content></md-tab><md-tab label=\"Dependents\"><md-content class=\"md-padding\"><div class=\"md-body-1\">\nJust like in a program, CADWOLF equations are built on previous equations. This tab shows which equations this one depends upon and which later equations depend upon this one.\n</div></md-content></md-tab><md-tab label=\"Errors\"><md-content class=\"md-padding\"><div class=\"md-body-1\">\nWhen an equation is entered incorrectly or a function does not receive the expected inputs, an error is returned. This tab shows the user those errors.\n</div><div ng-if=\"vm.thisItem.content.Equation.Errors_flag==0\" class=\"md-body-1\">\nThere were no errors produced by this equation.</div><div \nng-repeat=\"errorObj in vm.thisItem.content.Equation.Errors_errors\"><div class=\"md-body-1\">{{errorObj}}</div><md-divider\n ng-if=\"!$last\"></md-divider></div></md-content></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-fill layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vm.acceptChanges(vm.thisItem);\" class=\"send-button md-accent md-raised\">ACCEPT CHANGES</md-button><md-button \ntype=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">CANCEL</md-button></div>\n</md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/editImage.tmpl.html","<md-dialog-content ms-scroll><div layout=\"row\" flex=\"100\"><div layout=\"row\" flex=\"100\"><div layout-fill ng-cloak>\n<md-content><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Place Image from a Workspace\"><md-content \nclass=\"md-padding\"><div layout=\"row\"><div flex=\"60\"><div class=\"image\"><img \nng-src=\"https://cadwolf.s3.amazonaws.com/{{vm.thisItem.content.src}}\" width=\"{{vm.thisItem.content.item_data.width}}\" \nheight=\"{{vm.thisItem.content.item_data.height}}\"></div></div><div flex=\"30\" flex-offset=\"10\"><h2>\nSelect the workspace and image</h2><md-input-container class=\"md-block\"><label>Workspace Address</label><input \nng-model=\"vm.thisItem.content.path\" ng-enter=\"vm.getFolderContents( vm.thisItem, vm.thisItem.content.path )\">\n</md-input-container><div id=\"imageSelect\"><md-list><md-list-item flex=\"100\" \nng-repeat=\"thisImage in vm.currentContents | orderBy:\'order\'\" \nng-if=\"(thisImage.file_type_id==\'Image\')||(thisImage.file_type_id==\'Workspace\')\"><div \nclass=\"md-list-item-text pointerItem\" layout=\"row\" ng-if=\"thisImage.file_type_id==\'Image\'\" flex=\"100\" \nng-dblclick=\"vm.thisItem.content.src = thisImage.item_data.imageSource;\"><div flex=\"15\" flex-offset=\"5\" \nng-if=\"thisImage.file_type_id==\'Image\'\"><md-icon md-font-icon=\"icon-camera\"></md-icon></div><div flex=\"75\" \nflex-offset=\"5\">{{thisImage.name}}</div></div><div class=\"md-list-item-text pointerItem\" layout=\"row\" \nng-if=\"thisImage.file_type_id==\'Workspace\'\" flex=\"100\" \nng-dblclick=\"vm.thisItem.content.path=vm.thisItem.content.path+\'/\'+thisImage.name;\n										    			 		   vm.getFolderContents( vm.thisItem, vm.thisItem.content.path ) \">\n<div flex=\"15\" flex-offset=\"5\" ng-if=\"thisImage.file_type_id==\'Workspace\'\"><md-icon md-font-icon=\"icon-folder-outline\">\n</md-icon></div><div flex=\"75\" flex-offset=\"5\">{{thisImage.name}}</div></div><md-divider ng-if=\"!$last\"></md-divider>\n</md-list-item></md-list></div><h2>Set the image properties</h2><md-input-container class=\"md-block\"><label>Height\n</label><input ng-model=\"vm.thisItem.content.height\"></md-input-container><md-input-container class=\"md-block\"><label>\nWidth</label><input ng-model=\"vm.thisItem.content.width\"></md-input-container></div></div></md-content></md-tab><md-tab\n label=\"Place Image from a CAD File\"><md-content class=\"md-padding\"><div><div layout=\"row\" layout-align=\"start start\">\n<div flex=\"10\" class=\"md-title\"></div><div flex=\"30\" class=\"md-title\">CAD File Name</div><div flex=\"30\" \nflex-offset=\"5\" class=\"md-title\">Element Name</div><div flex=\"30\" flex-offset=\"5\" class=\"md-title\">Image Size</div>\n</div><div layout=\"row\" layout-align=\"start start\"><div flex=\"10\" class=\"md-title\"></div><div flex=\"30\">\n<md-input-container class=\"md-block\"><md-select ng-model=\"vm.thisCAD.document_data.id\" ng-change=\"vm.getCadElements()\">\n<md-option ng-repeat=\"item in vm.cadFiles\" ng-value=\"item.id\">{{item.name}}</md-option></md-select>\n</md-input-container></div><div flex=\"30\" flex-offset=\"5\"><md-input-container class=\"md-block\"><md-select \nng-model=\"vm.thisCAD.element_data.id\" ng-change=\"vm.setCadElement()\"><md-option ng-repeat=\"element in vm.cadElements\" \nng-value=\"element.id\">{{element.name}}</md-option></md-select></md-input-container></div><div flex=\"30\" \nflex-offset=\"5\"><md-input-container class=\"md-block\"><md-select ng-model=\"vm.thisCAD.imageSize\"><md-option \nng-repeat=\"image in vm.thisCAD.element_data.thumbnailInfo.sizes\" ng-value=\"image.size\">{{image.size}}</md-option>\n</md-select></md-input-container></div><div flex=\"5\" flex-offset=\"5\"><md-icon \nng-click=\"vm.setThumbnail( vm.thisItem, vm.thisCAD );\" md-font-icon=\"icon-plus\" class=\"greenIcon hoverMe\"><md-tooltip \nmd-direction=\"bottom\">Select Image</md-tooltip></md-icon></div></div></div></md-content></md-tab></md-tabs>\n</md-content></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-fill layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vm.acceptImage(vm.thisItem);\" class=\"send-button md-accent md-raised\">FINISHED EDITING</md-button></div>\n</md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/editMargins.tmpl.html","<md-dialog-content ms-scroll><div class=\"md-body-1\" class=\"fullWidth\">\nThis window lets the user edit the width of an item and set the margins on all four sides. By editing these properties, the user can control the layout of the document. The \"Line Break\" item should be used to establish a new and equal line.\n</div><div layout=\"column\" flex=\"100\" id=\"marginOuter\" class=\"fullWidth\"><div layout=\"row\" flex=\"100\" \nlayout=\"center center\" class=\"fullWidth\"><div flex=\"30\" flex-offset=\"35\"><md-input-container class=\"md-block\"><label>\nTop Margin</label><input ng-model=\"vm.thisItem.content.margintop\"></md-input-container></div></div><div layout=\"row\" \nflex=\"100\" layout=\"center center\" class=\"fullWidth\"><div flex=\"30\" ng-if=\"vm.thisItem.component_type_id!=\'2\'\"><div \nflex=\"80\" flex-offset=\"10\"><md-input-container class=\"md-block\"><label>Left Margin</label><input \nng-model=\"vm.thisItem.content.marginleft\"></md-input-container></div></div><div flex=\"40\" id=\"itemOuter\" \nclass=\"fullWidth\" layout=\"column\"><div flex=\"50\" flex-offset=\"5\" ng-if=\"vm.thisItem.component_type_id!=\'2\'\">\n<md-input-container class=\"md-block\" class=\"fullWidth\"><label>Width</label><input ng-model=\"vm.thisItem.content.width\">\n</md-input-container></div><div flex=\"50\" flex-offset=\"5\" \nng-if=\"( vm.thisItem.component_type_id!=\'2\' ) &&\n                      ( vm.thisItem.content.slider.status == 1 )\">\n<md-input-container class=\"md-block\" class=\"fullWidth\"><label>Height</label><input \nng-model=\"vm.thisItem.content.height\"></md-input-container></div><div flex=\"50\" flex-offset=\"5\" \nng-if=\"( vm.thisItem.component_type_id!=\'2\' ) &&\n                      ( vm.thisItem.content.slider.status != \'1\' )\">\n<md-input-container class=\"md-block\" class=\"fullWidth\"><label>Alignment</label><md-select \nng-model=\"vm.thisItem.content.alignment\"><md-option value=\"center\">Center</md-option><md-option value=\"left\">Left\n</md-option><md-option value=\"right\">Right</md-option></md-select></md-input-container></div></div><div flex=\"30\" \nng-if=\"vm.thisItem.component_type_id!=\'2\'\"><div flex=\"80\" flex-offset=\"10\"><md-input-container class=\"md-block\"><label>\nRight Margin</label><input ng-model=\"vm.thisItem.content.marginright\"></md-input-container></div></div></div><div \nlayout=\"row\" flex=\"100\" layout=\"center center\" class=\"fullWidth\"><div flex=\"30\" flex-offset=\"35\"><md-input-container \nclass=\"md-block\"><label>Bottom Margin</label><input ng-model=\"vm.thisItem.content.marginbottom\"></md-input-container>\n</div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-fill layout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" \nclass=\"send-button md-accent md-raised\">FINISHED EDITING</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/editRadio.tmpl.html","<md-dialog-content ms-scroll><div class=\"md-body-1\">\nThe parameters below let the user set the properties of the radio group. The user can also set the parameters for the group. You can add as many inputs as you like and edit each input independently.\n</div><div flex=\"100\" layout-align=\"center center\" layout=\"row\"><div class=\"md-title marginTop20\">\nProperties of the Radio Group</div></div><div layout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"70\" flex-offset=\"5\" \nlayout=\"row\"><div flex=\"20\" class=\"md-body-1\">Radio Group Name</div><div class=\"md-caption greyText marginTop3\" \nflex-offset=\"5\">Used in later equations to access the value</div></div><div flex=\"20\" layout-align=\"center center\">\n<md-input-container class=\"fullWidth\"><input ng-model=\"vm.thisItem.name\" \nng-enter=\"vm.thisItem.content.Equation.Format_name = vm.thisItem.name\"></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"70\" flex-offset=\"5\" layout=\"row\"><div flex=\"20\" class=\"md-body-1\">\nRadio Format</div><div class=\"md-caption greyText marginTop3\" flex-offset=\"5\">\nWhether the radio group is vertical or horizontal</div></div><div flex=\"20\" layout-align=\"center center\">\n<md-input-container layout-fill><md-select ng-model=\"vm.thisItem.content.radio.vertical\"><md-option value=\"0\">\nHorizontal</md-option><md-option value=\"1\">Vertical</md-option></md-select></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"70\" flex-offset=\"5\" layout=\"row\"><div flex=\"20\" class=\"md-body-1\">\nLabel</div><div class=\"md-caption greyText marginTop3\" flex-offset=\"5\">Show or hide the equation name</div></div><div \nflex=\"20\" layout-align=\"center center\"><md-input-container layout-fill><md-select \nng-model=\"vm.thisItem.content.radio.showLabel\"><md-option value=\"0\">Hide</md-option><md-option value=\"1\">Show\n</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"70\" \nflex-offset=\"5\" layout=\"row\"><div flex=\"20\" class=\"md-body-1\">Border</div><div class=\"md-caption greyText marginTop3\" \nflex-offset=\"5\">Show or hide the border</div></div><div flex=\"20\" layout-align=\"center center\"><md-input-container \nlayout-fill><md-select ng-model=\"vm.thisItem.content.radio.showBorder\"><md-option value=\"0\">Hide</md-option><md-option \nvalue=\"1\">Show</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" class=\"fullWidth\">\n<div flex=\"70\" flex-offset=\"5\" layout=\"row\"><div flex=\"20\" class=\"md-body-1\">Width</div><div \nclass=\"md-caption greyText marginTop3\" flex-offset=\"5\">The width of the radio group - not the block</div></div><div \nflex=\"20\" layout-align=\"center center\"><md-input-container class=\"fullWidth\"><input \nng-model=\"vm.thisItem.content.radio.width\"></md-input-container></div></div><div flex=\"100\" \nlayout-align=\"center center\" layout=\"row\"><div class=\"md-title marginTop20\">Contents of the Radio Group</div></div><div\n flex=\"100\" layout-align=\"center center\" layout=\"row\"><div flex=\"50\" layout-align=\"center center\"><md-list \nclass=\"md-dense\" flex><md-list-item><div flex=\"45\">Value</div><div flex=\"45\">Label</div></md-list-item><md-list-item \nclass=\"md-3-line\" ng-repeat=\"eqObj in vm.thisItem.content.radio.values\"><div flex=\"45\"><md-input-container \nclass=\"md-block\"><label>Option Value</label><input ng-model=\"eqObj.value\"></md-input-container></div><div flex=\"45\">\n<md-input-container class=\"md-block\"><label>Option Label</label><input ng-model=\"eqObj.label\"></md-input-container>\n</div><div flex=\"10\" class=\"topPaddedText hoverMe\"><md-icon md-font-icon=\"icon-close-circle-outline\" \nng-click=\"vm.thisItem.content.radio.values.splice( $index, 1);\"></md-icon></div></md-list-item></md-list></div></div>\n<div flex=\"100\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-primary\" \nng-click=\"vm.thisItem.content.radio.values.push({ \'value\': \'0\', \'label\':\'0\', \'color\':\'#0392d8\', \'labelType\':\'value\' })\">\nAdd Radio Option</md-button></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-fill layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vm.acceptChanges(vm.thisItem);\" class=\"send-button md-accent md-raised\">FINISHED</md-button></div>\n</md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/editReference.tmpl.html","<md-dialog-content ms-scroll><h2>Edit a Reference</h2><p>\nIn the area below, the user can edit the description for the item. When you are finished editing, you can save the new edit or cancel and return to the original description.\n</p><div layout=\"row\" layout-margin layout-align=\"center center\"><md-button class=\"md-raised md-primary\" \nng-click=\"vm.modalType=\'Bibliography\'\">Return to Bibliography</md-button></div><div layout=\"row\" flex=\"100\" \nlayout=\"fill\" layout-align=\"space-around center\"><md-radio-group flex=\"100\" layout=\"fill\" \nng-model=\"vm.thisReference[\'type\']\"><md-radio-button flex=\"25\" value=\"web\" class=\"md-primary\">Website</md-radio-button>\n<md-radio-button flex=\"25\" value=\"book\">Book</md-radio-button><md-radio-button flex=\"25\" value=\"mag\">Magazine\n</md-radio-button><md-radio-button flex=\"25\" value=\"enc\">Encyclopedia</md-radio-button></md-radio-group></div><div \nlayout=\"column\" flex=\"100\" layout-fill layout-align=\"center center\" ng-if=\"vm.thisReference[\'type\']==\'web\'\"><div \nflex=\"80\" flex-offset=\"10\" layout-fill><md-input-container class=\"md-block\"><label>Author</label><input \nng-model=\"vm.thisReference[\'author\']\" layout=\"fill\"></md-input-container></div><div flex=\"80\" flex-offset=\"10\" \nlayout-fill><md-input-container class=\"md-block\"><label>Address</label><input ng-model=\"vm.thisReference[\'address\']\" \nlayout=\"fill\"></md-input-container></div><div flex=\"80\" flex-offset=\"10\" layout-fill><md-input-container \nclass=\"md-block\"><label>Page Title</label><input ng-model=\"vm.thisReference[\'pagetitle\']\" layout=\"fill\">\n</md-input-container></div><div flex=\"80\" flex-offset=\"10\" layout-fill><md-input-container class=\"md-block\"><label>\nWebsite Name</label><input ng-model=\"vm.thisReference[\'sitetitle\']\" layout=\"fill\"></md-input-container></div><div \nflex=\"80\" flex-offset=\"10\" layout-fill><md-input-container class=\"md-block\"><label>Date Accessed</label><input \nng-model=\"vm.thisReference[\'dateaccessed\']\" layout=\"fill\"></md-input-container></div></div><div layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.thisReference[\'type\']==\'book\'\"><div flex=\"80\" flex-offset=\"10\" layout-fill>\n<md-input-container class=\"md-block\"><label>Book Title</label><input ng-model=\"vm.thisReference[\'booktitle\']\">\n</md-input-container></div><div flex=\"80\" flex-offset=\"10\" layout-fill><md-input-container class=\"md-block\"><label>\nAuthor(s)</label><input ng-model=\"vm.thisReference[\'author\']\"></md-input-container></div><div flex=\"80\" \nflex-offset=\"10\" layout-fill><md-input-container class=\"md-block\"><label>Page Number</label><input \nng-model=\"vm.thisReference[\'page\']\"></md-input-container></div><div flex=\"80\" flex-offset=\"10\" layout-fill>\n<md-input-container class=\"md-block\"><label>Publisher</label><input ng-model=\"vm.thisReference[\'publisher\']\">\n</md-input-container></div><div flex=\"80\" flex-offset=\"10\" layout-fill><md-input-container class=\"md-block\"><label>\nDate Published</label><input ng-model=\"vm.thisReference[\'datepublished\']\"></md-input-container></div><div flex=\"80\" \nflex-offset=\"10\" layout-fill><md-input-container class=\"md-block\"><label>Edition</label><input \nng-model=\"vm.thisReference[\'edition\']\"></md-input-container></div></div><div layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.thisReference[\'type\']==\'mag\'\"><div flex=\"80\" flex-offset=\"10\" layout-fill>\n<md-input-container class=\"md-block\"><label>Article Title</label><input ng-model=\"vm.thisReference[\'articletitle\']\">\n</md-input-container></div><div flex=\"80\" flex-offset=\"10\" layout-fill><md-input-container class=\"md-block\"><label>\nMag or Paper Name</label><input ng-model=\"vm.thisReference[\'magpapername\']\"></md-input-container></div><div flex=\"80\" \nflex-offset=\"10\" layout-fill><md-input-container class=\"md-block\"><label>Date Published</label><input \nng-model=\"vm.thisReference[\'datepublished\']\"></md-input-container></div><div flex=\"80\" flex-offset=\"10\" layout-fill>\n<md-input-container class=\"md-block\"><label>Page</label><input ng-model=\"vm.thisReference[\'page\']\">\n</md-input-container></div></div><div layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.thisReference[\'type\']==\'enc\'\"><div flex=\"80\" flex-offset=\"10\" layout-fill><md-input-container \nclass=\"md-block\"><label>Entry Name</label><input ng-model=\"vm.thisReference[\'entryname\']\"></md-input-container></div>\n<div flex=\"80\" flex-offset=\"10\" layout-fill><md-input-container class=\"md-block\"><label>Encyclopedia Name</label><input\n ng-model=\"vm.thisReference[\'encname\']\"></md-input-container></div><div flex=\"80\" flex-offset=\"10\" layout-fill>\n<md-input-container class=\"md-block\"><label>Edition</label><input ng-model=\"vm.thisReference[\'edition\']\">\n</md-input-container></div><div flex=\"80\" flex-offset=\"10\" layout-fill><md-input-container class=\"md-block\"><label>Year\n</label><input ng-model=\"vm.thisReference[\'year\']\"></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">\nFINISHED EDITING</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/editRequirement.tmpl.html","<md-dialog-content ms-scroll><md-content><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Settings\">\n<md-content class=\"md-padding\"><div ng-if=\"vm.editPerm\" layout=\"row\" class=\"md-body-1 marginTopBottom20\" flex=\"80\" \nflex-margin=\"10\">\nThe options below can be used to set the values of this requirement. To do this, simply set the value of the requirement, the tolerance around this value, and then the equation to which this requirement is to be placed. For the requirement to be fulfilled, the value of the assigned equation must be within the tolerance given.\n</div><div layout=\"row\" flex=\"100\"><div flex=\"20\" flex-offset=\"10\" class=\"marginTop20\">\nDoes the requirement have a value:</div><div flex=\"10\"><md-input-container class=\"\"><md-checkbox \nng-model=\"vm.currentItem.content.reqValueTrueFalse\"></md-checkbox></md-input-container></div></div><div layout=\"row\" \nflex=\"100\" ng-if=\"vm.currentItem.content.reqValueTrueFalse\"><div flex=\"20\">Requirement must be :</div><div flex=\"20\">\n<md-input-container layout-fill class=\"\"><md-select ng-model=\"vm.currentItem.content.reqValueType\"><md-option \nng-value=\"equal\">Equal to</md-option><md-option ng-value=\"lessThan\">Less Than</md-option><md-option \nng-value=\"lessThanEqual\">Less than or equal to</md-option><md-option ng-value=\"greaterThan\">greater than</md-option>\n<md-option ng-value=\"greaterThanEqual\">greater than or equal to</md-option></md-select></md-input-container></div><div \nflex=\"20\"><md-input-container layout-fill class=\"\"><md-select ng-model=\"vm.currentItem.content.reqValueEq\"><md-option \nng-repeat=\"obj in vm.worksheet | orderBy:\'order\' track by obj.itemid\" \nng-if=\"( obj.order != 0 ) && (obj.order<=vm.currentItem.order) && ( obj.component_type_id == 3 )\" \nng-value=\"obj.itemid\">{{obj.name}}</md-option></md-select></md-input-container></div><div flex=\"20\"><md-input-container\n layout-fill class=\"md-block\" flex-gt-sm><label>Tolerance</label><input ng-model=\"vm.currentItem.content.reqTolVal\" \nng-enter=\"\"></md-input-container></div><div flex=\"20\"><md-input-container layout-fill class=\"\"><md-select \nng-model=\"vm.currentItem.content.reqTolType\"><md-option ng-value=\"Percentage\">Percentage</md-option><md-option \nng-value=\"Value\">Absolute Value</md-option></md-select></md-input-container></div></div><div ng-if=\"!vm.editPerm\" \nlayout=\"row\" class=\"md-body-1 marginTopBottom20\" flex=\"80\" flex-margin=\"10\">\nThe settings below establish the values of this requirement and set the equation to which this requirement applies.\n</div></md-content></md-tab><md-tab label=\"Requirement Parent\"><md-content class=\"md-padding\"><div><div \nng-if=\"vm.editPerm\" layout=\"row\" class=\"md-body-1 marginTopBottom20\" flex=\"80\" flex-margin=\"10\">\nNavigate to the file containing the parent requirement and then select the desired requirement from the list.</div><div\n ng-if=\"vm.editPerm\" layout=\"row\" flex=\"80\" flex-margin=\"10\"><md-input-container class=\"md-block\" flex-gt-sm><label>\nWorkspace URL</label><input ng-model=\"vm.inputURL\" ng-enter=\"vm.getFolderContents( \'\', vm.inputURL )\">\n</md-input-container></div><div ng-if=\"vm.editPerm\" layout=\"row\" flex=\"100\" layout-align=\"center center\"><div \nflex=\"50\" layout=\"column\" layout-align=\"center center\"><div class=\"md-caption\">Select the desired file or folder</div>\n</div><div flex=\"50\" layout=\"column\" layout-align=\"center center\"><div class=\"md-caption\">Select the parent requirement\n</div></div></div><div ng-if=\"vm.editPerm\" layout=\"row\" flex=\"90\" flex-margin=\"5\"><md-list layout=\"column\" flex=\"50\" \nlayout-fill><md-list-item layout=\"row\" layout-fill flex=\"100\" layout-align=\"center center\" \nng-repeat=\"obj in vm.currentContents\" \nng-if=\"(obj.file_type_id==\'Workspace\') ||\n									 		(obj.file_type_id==\'Document\') ||\n									 		(obj.file_type_id==\'Part Tree\')\" \nclass=\"borderBottom paddingTopBottom5 pointerItem\"><div ng-if=\"obj.file_type_id==\'Workspace\'\" layout=\"row\" layout-fill \nlayout-align=\"center center\" ng-click=\"vm.setNewURL( obj.name )\"><div flex=\"10\" flex-offset=\"5\"><md-icon \nmd-font-icon=\"icon-folder-outline\"></md-icon></div><div flex=\"80\" class=\"paddingTop3\">{{obj.name}}</div></div><div \nng-if=\"obj.file_type_id==\'Document\'\" layout=\"row\" layout-fill layout-align=\"center center\" \nng-click=\"vm.setDocEqs( obj )\"><div flex=\"10\" flex-offset=\"5\"><md-icon md-font-icon=\"icon-file-outline\"></md-icon>\n</div><div flex=\"80\" class=\"paddingTop3\">{{obj.name}}</div></div><div ng-if=\"obj.file_type_id==\'Part Tree\'\" \nlayout=\"row\" layout-fill layout-align=\"center center\" ng-click=\"vm.setNewURL( obj.name )\"><div flex=\"10\" \nflex-offset=\"5\"><md-icon md-font-icon=\"icon-sitemap\"></md-icon></div><div flex=\"80\" class=\"paddingTop3\">{{obj.name}}\n</div></div></md-list-item></md-list><md-list layout=\"column\" flex=\"50\" layout-fill><md-list-item layout=\"row\" \nlayout-fill flex=\"100\" layout-align=\"center center\" ng-repeat=\"obj in vm.inputEquations\" \nng-if=\"obj.component_type_id==17\" ng-dblclick=\"vm.setReqParent( obj )\" \nclass=\"borderBottom paddingTopBottom5 pointerItem\"><div flex=\"10\" flex-offset=\"5\"><md-icon \nmd-font-icon=\"icon-lightbulb-outline\"></md-icon></div><div flex=\"90\" class=\"paddingTop3\">{{obj.content.title}}</div>\n</md-list-item></md-list></div></div></md-content></md-tab></md-tabs></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">\nFINISHED EDITING</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/editSlider.tmpl.html","<md-dialog-content ms-scroll><div class=\"md-body-1\">\nThe parameters below let the user set the properties of the slider and determine its appearance. The user can also choose to display or hide an input box equal to the slider value. The name of the variable that the slider represents is always shown on the document. It is this name that is used in later equations to pull in the value of the slider.\n</div><div layout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"70\" flex-offset=\"5\" layout=\"row\"><div flex=\"20\" \nclass=\"md-body-1\">Slider Name</div><div class=\"md-caption greyText marginTop3\" flex-offset=\"5\">\nUsed in later equations to access the value</div></div><div flex=\"20\" layout-align=\"center center\"><md-input-container \nclass=\"fullWidth\"><input ng-model=\"vm.thisItem.name\" \nng-enter=\"vm.thisItem.content.Equation.Format_name = vm.thisItem.name\"></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"70\" flex-offset=\"5\" layout=\"row\"><div flex=\"20\" class=\"md-body-1\">\nSlider Format</div><div class=\"md-caption greyText marginTop3\" flex-offset=\"5\">\nWhether the slider is vertical or horizontal</div></div><div flex=\"20\" layout-align=\"center center\"><md-input-container\n layout-fill><md-select ng-model=\"vm.thisItem.content.slider.vertical\"><md-option value=\"0\">Horizontal</md-option>\n<md-option value=\"1\">Vertical</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nclass=\"fullWidth\"><div flex=\"70\" flex-offset=\"5\" layout=\"row\"><div flex=\"20\" class=\"md-body-1\">Show Value</div><div \nclass=\"md-caption greyText marginTop3\" flex-offset=\"5\">Show or hide an input box along with slider</div></div><div \nflex=\"20\" layout-align=\"center center\"><md-input-container layout-fill><md-select \nng-model=\"vm.thisItem.content.slider.showEq\"><md-option value=\"0\">Hide</md-option><md-option value=\"1\">Show</md-option>\n</md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" class=\"fullWidth\" \nng-if=\"(vm.thisItem.content.slider.vertical==1)&&(vm.thisItem.content.slider.showEq==1)\"><div flex=\"70\" \nflex-offset=\"5\" layout=\"row\"><div flex=\"20\" class=\"md-body-1\">Value Location</div><div \nclass=\"md-caption greyText marginTop3\" flex-offset=\"5\">Where to display the value along with the slider</div></div><div\n flex=\"20\" layout-align=\"center center\"><md-input-container layout-fill><md-select \nng-model=\"vm.thisItem.content.slider.eqLoc\"><md-option value=\"0\">Top</md-option><md-option value=\"1\">Bottom</md-option>\n</md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" class=\"fullWidth\" \nng-if=\"(vm.thisItem.content.slider.vertical==0)&&(vm.thisItem.content.slider.showEq==1)\"><div flex=\"70\" \nflex-offset=\"5\" layout=\"row\"><div flex=\"20\" class=\"md-body-1\">Value Location</div><div \nclass=\"md-caption greyText marginTop3\" flex-offset=\"5\">Where to display the value along with the slider</div></div><div\n flex=\"20\" layout-align=\"center center\"><md-input-container layout-fill><md-select \nng-model=\"vm.thisItem.content.slider.eqLoc\"><md-option value=\"0\">Left</md-option><md-option value=\"1\">Right</md-option>\n</md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"70\" \nflex-offset=\"5\" layout=\"row\"><div flex=\"20\" class=\"md-body-1\">Minimum</div><div class=\"md-caption greyText marginTop3\" \nflex-offset=\"5\">Lowest value allowed for the slider</div></div><div flex=\"20\" layout-align=\"center center\">\n<md-input-container class=\"fullWidth\"><input ng-model=\"vm.thisItem.content.slider.min\"></md-input-container></div>\n</div><div layout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"70\" flex-offset=\"5\" layout=\"row\"><div flex=\"20\" \nclass=\"md-body-1\">Maximum</div><div class=\"md-caption greyText marginTop3\" flex-offset=\"5\">\nHighest value allowed for the slider</div></div><div flex=\"20\" layout-align=\"center center\"><md-input-container \nclass=\"fullWidth\"><input ng-model=\"vm.thisItem.content.slider.max\"></md-input-container></div></div><div layout=\"row\" \nflex=\"100\" class=\"fullWidth\"><div flex=\"70\" flex-offset=\"5\" layout=\"row\"><div flex=\"20\" class=\"md-body-1\">Units</div>\n<div class=\"md-caption greyText marginTop3\" flex-offset=\"5\">The units assigned to the slider</div></div><div flex=\"20\" \nlayout-align=\"center center\"><md-input-container class=\"fullWidth\"><input ng-model=\"vm.thisItem.content.slider.units\">\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"70\" flex-offset=\"5\" \nlayout=\"row\"><div flex=\"20\" class=\"md-body-1\">Step</div><div class=\"md-caption greyText marginTop3\" flex-offset=\"5\">\nAmount between selectable values on the slider</div></div><div flex=\"20\" layout-align=\"center center\">\n<md-input-container class=\"fullWidth\"><input ng-model=\"vm.thisItem.content.slider.step\"></md-input-container></div>\n</div><div layout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"70\" flex-offset=\"5\" layout=\"row\"><div flex=\"20\" \nclass=\"md-body-1\">Resolution</div><div class=\"md-caption greyText marginTop3\" flex-offset=\"5\">\nNumber of digits to the right of 0 that the slider will resolve</div></div><div flex=\"20\" layout-align=\"center center\">\n<md-input-container class=\"fullWidth\"><input ng-model=\"vm.thisItem.content.slider.round\"></md-input-container></div>\n</div><div layout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"70\" flex-offset=\"5\" layout=\"row\"><div flex=\"20\" \nclass=\"md-body-1\">Discrete Mode</div><div class=\"md-caption greyText marginTop3\" flex-offset=\"5\">\nWhether the slider is in regular or discrete mode</div></div><div flex=\"20\" layout-align=\"center center\">\n<md-input-container layout-fill><md-select ng-model=\"vm.thisItem.content.slider.discrete\"><md-option value=\"0\">Normal\n</md-option><md-option value=\"1\">Discrete</md-option></md-select></md-input-container></div></div><div layout=\"row\" \nflex=\"100\" class=\"fullWidth\"><div flex=\"70\" flex-offset=\"5\" layout=\"row\"><div flex=\"20\" class=\"md-body-1\">Inverted\n</div><div class=\"md-caption greyText marginTop3\" flex-offset=\"5\">Whether the slider is regular or inverted</div></div>\n<div flex=\"20\" layout-align=\"center center\"><md-input-container layout-fill><md-select \nng-model=\"vm.thisItem.content.slider.inverted\"><md-option value=\"0\">Normal</md-option><md-option value=\"1\">Inverted\n</md-option></md-select></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-fill layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vm.acceptChanges(vm.thisItem);\" class=\"send-button md-accent md-raised\">FINISHED</md-button></div>\n</md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/editTable.tmpl.html","<md-dialog-content ms-scroll><div layout=\"column\" layout-fill layout-align=\"center center\"><div layout=\"row\" \nlayout-fill layout-align=\"center center\"><div layout=\"column\" flex=\"100\" layout-fill layout-margin \nlayout-align=\"center center\"><div layout=\"row\" flex=\"60\" flex-offset=\"20\" layout-align=\"center center\" layout-fill><div\n flex=\"50\" class=\"md-body-2\">Table ID</div><div flex=\"50\" class=\"md-body-2\">{{ vm.currentItem[\'itemid\'] }}</div></div>\n<div layout=\"row\" flex=\"60\" flex-offset=\"20\" layout-align=\"center center\" layout-fill><md-checkbox \nng-model=\"vm.currentItem[\'content\'][\'captionOn\']\" flex=\"50\" aria-label=\"Show Title\">Show Title</md-checkbox>\n<md-input-container flex=\"50\"><label>Title</label><input ng-model=\"vm.currentItem[\'content\'][\'caption\']\">\n</md-input-container></div><div layout=\"row\" flex=\"60\" flex-offset=\"20\" layout-align=\"center center\" layout-fill>\n<md-checkbox ng-model=\"vm.currentItem[\'content\'][\'rowLabels\']\" aria-label=\"Show Row Labels\" flex=\"50\">Row Labels\n</md-checkbox><md-checkbox ng-model=\"vm.currentItem[\'content\'][\'colLabels\']\" aria-label=\"Show Column Labels\" flex=\"50\">\nColumn Labels</md-checkbox></div><div layout=\"row\" flex=\"60\" flex-offset=\"20\" layout-align=\"start start\" layout-fill>\n<md-input-container flex=\"50\"><label>Border Width</label><input ng-model=\"vm.currentItem[\'content\'][\'borderWidth\']\">\n</md-input-container><md-input-container flex=\"50\"><label>Text Align</label><md-select \nng-model=\"vm.currentItem[\'content\'][\'tableAlign\']\"><md-option value=\"left\">Left</md-option><md-option value=\"right\">\nRight</md-option><md-option value=\"center\">Center</md-option><md-option value=\"justify\">Justify</md-option></md-select>\n</md-input-container></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-fill layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">FINISHED EDITING</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/editVideo.tmpl.html","<md-dialog-content ms-scroll><div class=\"md-body-1\" class=\"fullWidth\">\nThis window lets users change the source for the video. Simply paste the code for the youtube video in the appropriate input and the video will appear here.\n</div><div layout=\"row\" flex=\"100\" class=\"fullWidth\"><div flex=\"40\"><img class=\"youtube-thumb\" \nng-src=\"//i.ytimg.com/vi/{{vm.thisItem.content.videoID}}/hqdefault.jpg\" width=\"{{vm.thisItem.content.videoWidth}}\" \nheight=\"{{vm.thisItem.content.videoHeight}}\"></div><div flex=\"50\" flex-offset=\"10\" layout=\"column\"><md-input-container \nclass=\"md-block\"><label>Video Code</label><input ng-model=\"vm.thisItem.content.videoID\" ng-enter=\"vm.setVideoURL()\">\n</md-input-container><md-input-container class=\"md-block\"><label>Height</label><input \nng-model=\"vm.thisItem.content.videoHeight\"></md-input-container><md-input-container class=\"md-block\"><label>Width\n</label><input ng-model=\"vm.thisItem.content.videoWidth\"></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">\nFINISHED EDITING</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/fafInput.html","<div class=\"md-title cadwolfSubtitle\" flex=\"100\">Inputs for file as a function</div><div class=\"md-body-1\">\nThe inputs given to this function and how they are interpreted are set here. The sheet is called by its name and with the set number of inputs below in the form FunctionName(Input1, Input2, ... Input N). You can add or delete inputs and assign them the name they will be used as in the function. For example, if the one input is set and given the name \"X\", then the sheet will be solved used whatever value of \"X\" sent.\n</div><div ng-if=\"vm.editPerm\" layout=\"row\" layout-align=\"center center\" class=\"marginTopBottom20\"><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.addFafItem(\'input\');\">Add File Input</md-button></div><div layout=\"row\" \nflex=\"100\" layout-fill layout-align=\"center center\"><div ng-if=\"vm.editPerm\" layout=\"column\" layout-fill><div \nng-repeat=\"obj in vm.fileInfo.item_data.fileAsFunction.inputs | orderBy:obj.number track by $index\" layout=\"row\" \nflex=\"80\" flex-offset=\"10\"><div flex=\"15\" class=\"md-body-1 topPaddedText\">Input Number : {{$index}}</div><div \nlayout=\"row\" flex=\"55\" flex-offset=\"10\"><md-input-container flex=\"100\"><label>Select Input Variable</label><md-select \nng-model=\"obj.itemid\" ng-change=\"vm.setFafItem( obj )\"><md-option ng-repeat=\"variable in vm.cadwolf_worksheet\" \nvalue=\"{{variable.itemid}}\" ng-if=\"variable.component_type_id==3\">{{variable.name}}</md-option></md-select>\n</md-input-container></div><div flex=\"10\" class=\"topPaddedText hoverMe\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\" ng-click=\"vm.deleteFafItem(\'input\', $index);\"></md-icon></div></div></div>\n</div><div layout=\"row\" flex=\"100\" layout-fill layout-align=\"center center\"><div ng-if=\"!vm.editPerm\" layout=\"column\" \nlayout-fill layout-margin><div \nng-repeat=\"obj in vm.fileInfo.item_data.fileAsFunction.inputs | orderBy:obj.number track by $index\" layout=\"row\" \nflex=\"80\" flex-offset=\"10\"><div flex=\"15\" class=\"md-body-1\">Input Number : {{$index}}</div><div layout=\"row\" flex=\"85\">\n{{obj.name}}</div></div></div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/fafName.html","<div class=\"md-title cadwolfSubtitle\" flex=\"100\">Name of file as a function</div><div class=\"md-body-1\" flex=\"100\">\nEach page can be used as a function that is called from another sheet. The user can set the name used to call this file as a function. For example, if the users sets this name as \"FunctionName\" then this file would be called within an equation using the statement \"FunctionName(\"Input1, Input1).\" This name cannot be the same as a built in function such as sin or cos. CAD Wolf will search through this file\\\'s parent folders, and then the folders listed in the creator\\\'s path to find a file with the appropriate name.\n</div><div layout=\"row\" flex=\"100\" class=\"fullRow\"><div class=\"md-body-2 topPaddedText\" flex=\"30\">\nName of the file as a function :</div><div ng-if=\"vm.editPerm\" layout=\"row\" flex=\"70\"><md-input-container \nclass=\"md-block\" flex=\"100\"><label>Function Name</label><input \nng-model=\"vm.fileInfo.item_data.fileAsFunction.fileFunName\" flex=\"100\" ng-enter=\"\"></md-input-container></div><div \nng-if=\"!vm.editPerm\" flex=\"70\">{{vm.fileInfo.item_data.fileAsFunction.fileFunName}}</div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/fafOutput.html","<div class=\"md-title cadwolfSubtitle\" flex=\"100\">Outputs for file as a function</div><div class=\"md-body-1\">\nWhen the page is called as a function, it will return the values set here. This is done by calling the function in the following format [Output1, Output2]=FunctionName(Input1, Input2).\n</div><div ng-if=\"vm.editPerm\" layout=\"row\" layout-align=\"center center\" class=\"marginTopBottom20\"><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.addFafItem(\'output\'); vm.updateService()\">Add File Output</md-button></div>\n<div layout=\"row\" flex=\"100\" layout-fill layout-align=\"center center\"><div ng-if=\"vm.editPerm\" layout=\"column\" \nlayout-fill><div ng-repeat=\"obj in vm.fileInfo.item_data.fileAsFunction.outputs | orderBy:obj.number track by $index\" \nlayout=\"row\" flex=\"80\" flex-offset=\"10\"><div flex=\"15\" class=\"md-body-1 topPaddedText\">Output Number : {{$index}}</div>\n<div layout=\"row\" flex=\"55\" flex-offset=\"10\"><md-input-container flex=\"100\"><label>Select Output Variable</label>\n<md-select ng-model=\"obj.itemid\" ng-change=\"vm.setFafItem( obj )\"><md-option \nng-repeat=\"variable in vm.cadwolf_worksheet\" value=\"{{variable.itemid}}\" ng-if=\"variable.component_type_id==3\">\n{{variable.name}}</md-option></md-select></md-input-container></div><div flex=\"10\" class=\"topPaddedText hoverMe\">\n<md-icon md-font-icon=\"icon-close-circle-outline\" ng-click=\"vm.deleteFafItem(\'output\', $index);\"></md-icon></div></div>\n</div></div><div layout=\"row\" flex=\"100\" layout-fill layout-align=\"center center\"><div ng-if=\"!vm.editPerm\" \nlayout=\"column\" layout-fill><div \nng-repeat=\"obj in vm.fileInfo.item_data.fileAsFunction.outputs | orderBy:obj.number track by $index\" layout=\"row\" \nflex=\"80\" flex-offset=\"10\"><div flex=\"15\" class=\"md-body-1\">Output Number : {{$index}}</div><div layout=\"row\" \nflex=\"85\">{{obj.name}}</div></div></div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/failureMessage.tmpl.html","<md-dialog class=\"contact-dialog\" id=\"messageDialog\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"errorBackground md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between\"><span class=\"title\">Failure</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"md-avatar avatar contact-avatar huge\"></md-icon><div class=\"contact-name\">\n{{vm.messageObj.messageTitle}}</div></div></div></md-toolbar><md-dialog-content ms-scroll layout-align=\"center center\">\n<div layout=\"row\" flex=\"100\" layout-fill layout-align=\"center center\">{{vm.messageObj.messageText}}</div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" \nclass=\"send-button errorBackground md-raised\">OK</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/fileAsFunction.tmpl.html","<md-dialog-content ms-scroll><div><div layout-fill flex=\"100\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/fafName.html\'\"></div><div layout-fill flex=\"100\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/fafInput.html\'\"></div><div layout-fill flex=\"100\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/fafOutput.html\'\"></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">\nFINISHED EDITING</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/fileInputs.tmpl.html","<md-dialog-content ms-scroll><div><div layout=\"row\" class=\"md-body-1\" layout-fill>\nVariables from other CADWOLF documents can be brought into this document and used in equations. This view lets the user choose the file and variable desired. You cannot select a variable from another file whose name is already in use in this file as that will cause confusion in the document.\n</div><div class=\"md-headline marginTopBottom20\" layout-fill>Current Inputs</div><div layout=\"column\" flex=\"100\" \nlayout-fill class=\"marginTopBottom20\"><div layout=\"row\" flex=\"80\" layout-fill class=\"borderBottom\"><div \nclass=\"md-body-2\" flex=\"50\">Name</div><div class=\"md-body-2\" flex=\"20\">Value</div><div class=\"md-body-2\" flex=\"20\">\nUnits</div><div class=\"md-body-2\" flex=\"5\"></div></div><div ng-repeat=\"obj in vm.cadwolf_worksheet\" layout=\"column\" \nlayout-fill flex=\"60\"><div ng-if=\"(obj.content.Equation.inputType==\'File\')\" layout=\"row\" class=\"borderBottom\"><div \nclass=\"md-body-1\" flex=\"50\">{{obj.content.Equation.Format_name}}</div><div class=\"md-body-1\" flex=\"20\" \nng-if=\"obj.content.Equation.Format_size!=\'1x1\'\">{{obj.content.Equation.Format_size}}</div><div class=\"md-body-1\" \nflex=\"20\" ng-if=\"obj.content.Equation.Format_size==\'1x1\'\">{{obj[\'content\'][\'Equation\'][\'Solution_real\'][\'0-0\']}}</div>\n<div class=\"md-body-1\" flex=\"20\">{{obj.content.Equation.Units_units}}</div><div class=\"md-body-1\" flex=\"5\" \nng-if=\"vm.editPerm\"><md-icon md-font-icon=\"icon-delete\" ng-click=\"vm.deleteInput(obj)\"></md-icon></div></div></div>\n</div><div ng-if=\"vm.editPerm\" class=\"md-headline marginTopBottom20\" layout-fill>Add Inputs</div><div \nng-if=\"vm.editPerm\" layout=\"row\" class=\"md-body-1 marginTopBottom20\" flex=\"80\" flex-margin=\"10\">\nEnter a URL for a desired workspace in the box below. The box on the left will populate with the workpsaces and documents in that workspace. Selecting one of those subfolders will in turn populate the left with that item\'s contents. Selecting a document will populate the right side with equations from that document. Choosing one of those equations will make that item an input.\n</div><div ng-if=\"vm.editPerm\" layout=\"row\" flex=\"80\" flex-margin=\"10\"><md-input-container class=\"md-block\" flex-gt-sm>\n<label>Workspace URL</label><input ng-model=\"vm.inputURL\" ng-enter=\"vm.getFolderContents( \'\', vm.inputURL )\">\n</md-input-container></div><div ng-if=\"vm.editPerm\" layout=\"row\" flex=\"100\" layout-align=\"center center\"><div \nflex=\"50\" layout=\"column\" layout-align=\"center center\"><div class=\"md-caption\">Select the desired file or folder</div>\n</div><div flex=\"50\" layout=\"column\" layout-align=\"center center\"><div class=\"md-caption\">\nSelect the desired equation to be an input</div></div></div><div ng-if=\"vm.editPerm\" layout=\"row\" flex=\"90\" \nflex-margin=\"5\"><md-list layout=\"column\" flex=\"50\" layout-fill><md-list-item layout=\"row\" layout-fill flex=\"100\" \nlayout-align=\"center center\" ng-repeat=\"obj in vm.currentContents\" \nng-if=\"(obj.file_type_id==\'Workspace\') ||\n	    			 		(obj.file_type_id==\'Document\') ||\n	    			 		(obj.file_type_id==\'Part Tree\')\" \nclass=\"borderBottom paddingTopBottom5 pointerItem\"><div ng-if=\"obj.file_type_id==\'Workspace\'\" layout=\"row\" layout-fill \nlayout-align=\"center center\" ng-click=\"vm.setNewURL( obj.name )\"><div flex=\"10\" flex-offset=\"5\"><md-icon \nmd-font-icon=\"icon-folder-outline\"></md-icon></div><div flex=\"80\" class=\"paddingTop3\">{{obj.name}}</div></div><div \nng-if=\"obj.file_type_id==\'Document\'\" layout=\"row\" layout-fill layout-align=\"center center\" \nng-click=\"vm.setDocEqs( obj )\"><div flex=\"10\" flex-offset=\"5\"><md-icon md-font-icon=\"icon-file-outline\"></md-icon>\n</div><div flex=\"80\" class=\"paddingTop3\">{{obj.name}}</div></div><div ng-if=\"obj.file_type_id==\'Part Tree\'\" \nlayout=\"row\" layout-fill layout-align=\"center center\" ng-click=\"vm.setNewURL( obj.name )\"><div flex=\"10\" \nflex-offset=\"5\"><md-icon md-font-icon=\"icon-sitemap\"></md-icon></div><div flex=\"80\" class=\"paddingTop3\">{{obj.name}}\n</div></div></md-list-item></md-list><md-list layout=\"column\" flex=\"50\" layout-fill><md-list-item layout=\"row\" \nlayout-fill flex=\"100\" layout-align=\"center center\" ng-repeat=\"obj in vm.inputEquations | orderBy:\'order\'\" \nng-if=\"obj.component_type_id==3 &&\n	    			 		obj.content.Equation.inputType != \'File\' &&\n	    			 		obj.content.Equation.inputType != \'Dataset\'\" \nng-click=\"vm.addFileInput( obj )\" class=\"borderBottom paddingTopBottom5 pointerItem\"><div flex=\"10\" flex-offset=\"5\">\n<md-icon md-font-icon=\"icon-sigma\"></md-icon></div><div flex=\"50\" class=\"paddingTop3\">\n{{obj.content.Equation.Format_name}}</div><div flex=\"30\" ng-if=\"obj.content.Equation.Format_size==\'1x1\'\" \nclass=\"paddingTop3\">{{obj[\'content\'][\'Equation\'][\'Solution_real\'][\'0-0\']}}</div><div flex=\"30\" \nng-if=\"obj.content.Equation.Format_size!=\'1x1\'\" class=\"paddingTop3\">{{obj.content.Equation.Format_size}}</div>\n</md-list-item></md-list></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-fill layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">FINISHED EDITING</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/forLoopObject.html","<div flex=\"95\" flex-offset=\"5\" layout-fill><div flex=\"100\" layout=\"row\" layout-fill><div \nclass=\"bordered marginRight10\" layout=\"row\"><div class=\"md-subhead paddingLeft10\">for</div><div \nclass=\"md-subhead paddingLeft10\">{{thisStruct.content.forLoop.counter}}</div><div class=\"md-subhead paddingLeft10\">=\n</div><div layout=\"row\"><div class=\"md-subhead paddingSide10\" ng-show=\"!thisStruct.content.startInputEdit\" \nng-dblclick=\"thisStruct.content.startInputEdit=true\">{{thisStruct.content.forLoop.startText}}</div><div \nclass=\"md-subhead paddingSide10\" ng-show=\"thisStruct.content.startInputEdit\"><input type=\"text\" \nng-model=\"thisStruct.content.forLoop.startText\" \nng-enter=\"thisStruct.content.startInputEdit=false; \n                                      thisStruct.content.needsBlockUpdate=1; \n                                      thisStruct.content.updateClass=\'itemneedsupdate\'; \n                                      callRunEquationDigest();\" \nclass=\"forloopinput\"></div></div></div><div class=\"bordered marginRight10\" layout=\"row\"><div \nclass=\"md-subhead paddingLeft10\">While</div><div class=\"md-subhead paddingLeft10\">\n{{thisStruct.content.forLoop.counter}}</div><div><div class=\"md-subhead paddingLeft10\" \nng-show=\"!thisStruct.content.limitInputEdit\" ng-dblclick=\"thisStruct.content.limitInputEdit=true\">\n{{thisStruct.content.forLoop.limitFactor}}</div><select class=\"md-subhead paddingLeft10\" \nng-show=\"thisStruct.content.limitInputEdit\" \nng-change=\" thisStruct.content.limitInputEdit=false; \n                                    thisStruct.content.updateClass=\'itemneedsupdate\';\" \nng-blur=\"thisStruct.content.limitInputEdit=false\" ng-model=\"thisStruct.content.forLoop.limitFactor\"><option value=\">\">\n&gt;</option><option value=\"<\">&lt;</option><option value=\">=\">&gt;=</option><option value=\"<=\">&lt;=</option></select>\n</div><div layout=\"row\"><div class=\"md-subhead paddingSide10\" ng-show=\"!thisStruct.content.endInputEdit\" \nng-dblclick=\"thisStruct.content.endInputEdit=true\">{{thisStruct.content.forLoop.stopText}}</div><div \nclass=\"md-subhead paddingSide10\" ng-show=\"thisStruct.content.endInputEdit\"><input type=\"text\" \nng-model=\"thisStruct.content.forLoop.stopText\" \nng-enter=\"thisStruct.content.endInputEdit=false; \n                                     thisStruct.content.needsBlockUpdate=1; \n                                     thisStruct.content.updateClass=\'itemneedsupdate\'; \n                                     callRunEquationDigest();\">\n</div></div></div><div class=\"bordered\" layout=\"row\"><div class=\"md-subhead paddingLeft10\">Increment by</div><div><div \nclass=\"md-subhead paddingSide10\" ng-show=\"!thisStruct.content.incrementInputEdit\" \nng-dblclick=\"thisStruct.content.incrementInputEdit=true\">{{thisStruct.content.forLoop.incrementText}}</div><div \nclass=\"md-subhead paddingSide10\" ng-show=\"thisStruct.content.incrementInputEdit\"><input type=\"text\" \nng-model=\"thisStruct.content.forLoop.incrementText\" \nng-enter=\"thisStruct.content.incrementInputEdit=false; \n                                     thisStruct.content.needsBlockUpdate=1; \n                                     thisStruct.content.updateClass=\'itemneedsupdate\'; \n                                     callRunEquationDigest();\">\n</div></div></div></div><md-content class=\"content\" ng-class=\"thisStruct.content.updateClass\" flex ms-scroll><div \nclass=\"main_item\" ng-repeat=\"subObj in worksheet | orderBy:\'order\' track by subObj.itemid\" ng-switch \non=\"subObj.component_type_id\" ng-if=\"subObj.content.parentid==thisStruct.content.itemid\" style=\"width:100%\"><div \nstyle=\"margin-top:{{subObj.margintop}}px; \n                        margin-bottom:{{subObj.marginbottom}}px; \n                        margin-left:{{subObj.marginleft}}px; \n                        margin-right:{{subObj.marginright}}px\">\n<div class=\"switchWrapper\" ng-switch-when=\"3\"><div class=\"equationblock\"><div class=\"eqshow\" id=\"{{subObj.itemid}}\">\n{{subObj.content.Equation.newEquation}}</div></div></div><div class=\"switchWrapper\" ng-switch-when=\"6\"><for-loop-object\n struct=\"{{subObj.itemid}}\" worksheet=\"worksheet\" editperm=\"editperm\" add-statement=\"callAddStatement\" \nadd-block=\"callAddBlock\" delete-statement=\"callDeleteStatement\" run-equation-digest=\"callRunEquationDigest\" \nupdateme=\"updateme\"></for-loop-object></div><div class=\"switchWrapper\" ng-switch-when=\"7\"><while-loop-object \nstruct=\"{{subObj.itemid}}\" worksheet=\"worksheet\" editperm=\"editPerm\" add-statement=\"callAddStatement\" \nadd-block=\"callAddBlock\" delete-statement=\"callDeleteStatement\" run-equation-digest=\"callRunEquationDigest\" \nupdateme=\"updateme\"></while-loop-object></div><div class=\"switchWrapper\" ng-switch-when=\"8\"><if-else-object \nstruct=\"{{subObj.itemid}}\" worksheet=\"worksheet\" editperm=\"editperm\" add-statement=\"callAddStatement\" \nadd-block=\"callAddBlock\" delete-statement=\"callDeleteStatement\" run-equation-digest=\"callRunEquationDigest\" \nupdateme=\"updateme\"></if-else-object></div></div></div></md-content></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/forums.tmpl.html","<md-dialog-content ms-scroll><div layout=\"row\"><div class=\"leftSelect\" layout=\"column\"><div \nclass=\"leftSpace textCentered\"><md-button type=\"submit\" ng-click=\"vm.addForum();\" \nclass=\"send-button md-accent md-raised\">New Forum</md-button></div><div class=\"leftItem\" \nng-class=\"{ \'selected\' : obj == vm.currentForum }\" ng-repeat=\"obj in vm.forums | orderBy:\'created_at\' track by obj.id\">\n<div layout=\"row\" class=\"hoverMe\" ng-click=\"vm.currentForum=obj\"><div layout=\"column\" class=\"textCentered\"><div><img \nclass=\"profile-image avatar\" ng-src=\"{{obj.item_data.userData.photo_url}}\" ng-click=\"\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"><md-tooltip md-direction=\"bottom\">\n{{obj.item_data.userData.name}} - {{obj.item_data.userData.username}}</md-tooltip></div><div class=\"paddingTop20\">\n{{obj.created_at_date | date:\'short\'}}</div></div><div class=\"md-body-1 marginLeft20\">{{obj.name}}</div></div></div>\n</div><div class=\"mainSpace\" flex=\"70\" flex-offset=\"10\" ng-if=\"vm.currentForum !== undefined\"><div layout=\"row\"><div \nlayout=\"column\" class=\"textCentered\"><div><img class=\"profile-image avatar\" \nng-src=\"{{vm.currentForum.item_data.userData.photo_url}}\" ng-click=\"\" \non-error-src=\"https://cadwolf.s3.amazonaws.com/Profile/default.png\"><md-tooltip md-direction=\"bottom\">\n{{vm.currentForum.item_data.userData.name}} - {{vm.currentForum.item_data.userData.username}}</md-tooltip></div><div \nclass=\"paddingTop20\">{{vm.currentForum.created_at_date | date:\'short\'}}</div></div><div class=\"errorText\" \nng-if=\"vm.titleProblem\">\nTitles can only contain letters, numbers, and spaces. It cannot contain underscores, questions marks, or similar items\n</div><div ng-if=\"!vm.editForum\" class=\"md-title marginLeft20\">{{vm.currentForum.name}}</div><div ng-if=\"vm.editForum\" \nclass=\"marginLeft20\" flex=\"80\"><md-input-container class=\"md-block\" flex=\"100\"><label>Title of Discussion</label><input\n ng-change=\"vm.checkTitle()\" ng-model=\"vm.currentForum.name\"></md-input-container></div></div><div \nclass=\"marginBottom20\" ng-if=\"!vm.editForum\" data-ng-bind-html=\"vm.currentForum.item_data.text\"></div><div \nclass=\"paddingBottom10 paddingTop10\" ng-if=\"vm.editForum\"><text-angular ng-model=\"vm.currentForum.item_data.text\">\n</text-angular></div><div layout=\"row\" ng-if=\"vm.editForum\"><div class=\"greyText hoverMe marginTop10 marginBottom20\" \nng-click=\"vm.resetStatus()\">Cancel</div><div><md-button class=\"md-accent md-raised\" \nng-click=\"vm.updateForum(  ); vm.resetStatus()\" type=\"submit\" aria-label=\"Update Forum\"><span>Update</span></md-button>\n</div></div><div class=\"paddingBottom10 paddingTop10 greyText hoverMe\" \nng-if=\"vm.Spark.state.user.id == vm.currentForum.user_id\" ng-click=\"vm.resetStatus(\'forum\')\">Edit Forum Text and Title\n</div><div class=\"greyText hoverMe marginTop20 marginBottom20\" ng-if=\"!vm.newComment && vm.Spark.state.user != null\" \nng-click=\"vm.resetStatus(0)\">Add New Comment</div><div class=\"borderBottom paddingBottom10 marginBottom20\" \nng-if=\"vm.newComment && vm.Spark.state.user != null\" flex=\"100\"><div layout=\"row\" flex=\"70\" flex-offset=\"30\">\n<text-angular ng-if=\"vm.newComment\" ng-model=\"vm.newCommentText\"></text-angular></div><div layout=\"row\" \nflex-offset=\"80\"><div class=\"greyText hoverMe marginTop10 marginBottom20\" \nng-if=\"vm.newComment && vm.Spark.state.user != null\" ng-click=\"vm.resetStatus()\">Cancel</div><div><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.createComment( 0, 0 ); vm.resetStatus()\" type=\"submit\" \naria-label=\"Post Comment\"><span>Post Comment</span></md-button></div></div></div><div \nclass=\"md-title marginTop20 marginBottom20 paddingBottom10 borderBottom\">Comments</div><div forum-comment \nlayout=\"column\" ng-style=\"\" id=\"0\" comments=\"vm.comments\" spark=\"vm.Spark\" create-comment=\"vm.createComment\" \nupdate-comment=\"vm.updateComment\" delete-comment=\"vm.deleteComment\" newcomment=\"vm.newComment\" \nreset-status=\"vm.resetStatus\"></div></div><div class=\"mainSpace md-body-1 textCentered topMargin20\" flex=\"100\" \nng-if=\"vm.currentForum === undefined\">\nSelect a forum on the left to see the text of the forum and the comments related to it.</div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">\nFINISHED</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/freeBodyDiagram.tmpl.html","<md-dialog-content ms-scroll><div layout=\"row\" flex=\"100\"><div layout=\"row\" flex=\"100\"><div layout-fill ng-cloak>\n<md-content><div layout=\"row\"><div flex=\"60\"><canvas id=\"fbdTest\" height=\"{{vm.thisItem.content.height}}\" \nwidth=\"{{vm.thisItem.content.width}}\" ng-style=\"{height:vm.thisItem.content.height, width:vm.thisItem.content.width}\">\n</canvas></div><div flex=\"35\" flex-offset=\"5\"><h2>Add and Edit Drawing Items</h2><p>\nAdd an item to the drawing using the button below and then edit the item to be the desired action of a line, square, arc, etc.\n</p><div layout=\"center center\" flex=\"100\"><md-button type=\"submit\" ng-click=\"vm.addFBDItem(vm.thisItem);\" \nclass=\"send-button md-accent md-raised\">Add Item to Drawing</md-button></div><div id=\"fbdSelect\" layout-margin>\n<md-list><md-list-item flex=\"100\" ng-repeat=\"thisDraw in vm.thisItem.content.drawing\" \nng-class=\"{\'selected\' : vm.currentDraw === thisDraw}\"><div flex=\"70\" class=\"hoverMe\" \nng-click=\"vm.currentDraw=thisDraw\">{{$index+1}} - {{thisDraw.drawType}}</div><div flex=\"10\" flex-offset=\"0\" \nng-click=\"vm.currentDraw=thisDraw; vm.moveFBD(0, vm.thisItem, $index); vm.reDrawFBD( vm.thisItem );\"><md-icon \nmd-font-icon=\"icon-arrow-up-bold\" class=\"hoverMe\"></md-icon></div><div flex=\"10\" flex-offset=\"0\" \nng-click=\"vm.currentDraw=thisDraw; vm.moveFBD(1, vm.thisItem, $index); vm.reDrawFBD( vm.thisItem );\"><md-icon \nmd-font-icon=\"icon-arrow-down-bold\" class=\"hoverMe\"></md-icon></div><div flex=\"10\" flex-offset=\"0\" \nng-click=\"vm.currentDraw=thisDraw; vm.deleteFBD(vm.thisItem, $index); vm.reDrawFBD( vm.thisItem );\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"hoverMe\"></md-icon></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item>\n</md-list></div><div id=\"fbdOptions\" layout-margin><div layout=\"row\"><div flex=\"90\" flex-offset=\"5\"><md-input-container\n class=\"md-block\"><md-select ng-model=\"vm.currentDraw.drawType\"><md-option value=\"line\">Line</md-option><md-option \nvalue=\"rectangle\">Rectangle</md-option><md-option value=\"triangle\">Triangle</md-option><md-option value=\"arc1\">\nArc Type 1</md-option><md-option value=\"arc2\">Arc Type 2</md-option><md-option value=\"quadratic\">Quadratic Curve\n</md-option><md-option value=\"bezier\">Bezier Curve</md-option><md-option value=\"linearGrad\">Linear Gradient</md-option>\n<md-option value=\"radialGrad\">Radial Gradient</md-option><md-option value=\"text\">Text</md-option><md-option \nvalue=\"image\">Image</md-option><md-option value=\"arrow\">Arrow</md-option></md-select></md-input-container></div></div>\n<div layout=\"row\" ng-if=\"vm.currentDraw.drawType==\'line\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>\nTransparency</label><input ng-model=\"vm.currentDraw.transparency\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\">\n</md-input-container><div flex=\"45\" flex-offset=\"5\"><md-input-container class=\"md-block\"><label>Fill Color</label>\n<input ng-model=\"vm.currentDraw.fillColor\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div></div>\n<div layout=\"row\" ng-if=\"vm.currentDraw.drawType==\'line\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Start X\n</label><input ng-model=\"vm.currentDraw.x1\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container>\n<md-input-container flex=\"45\" flex-offset=\"5\"><label>Start Y</label><input ng-model=\"vm.currentDraw.y1\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'line\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>End X</label><input \nng-model=\"vm.currentDraw.x2\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"45\" flex-offset=\"5\"><label>End Y</label><input ng-model=\"vm.currentDraw.y2\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'line\'\"><md-input-container flex=\"25\" flex-offset=\"5\"><md-checkbox \nng-model=\"vm.currentDraw.dashed\" ng-change=\"vm.reDrawFBD( vm.thisItem );\" aria-label=\"Whether the line is dashed\">\nLine Dashed</md-checkbox></md-input-container><md-input-container flex=\"30\" flex-offset=\"5\"><label>Dash Props</label>\n<input ng-model=\"vm.currentDraw.lineDash\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container>\n<md-input-container flex=\"30\" flex-offset=\"5\"><label>Dash Offset</label><input ng-model=\"vm.currentDraw.dashOffset\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'line\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Line Width</label><input \nng-model=\"vm.currentDraw.lineWidth\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"45\" flex-offset=\"5\"><label>Line Cap</label><md-select ng-model=\"vm.currentDraw.lineCap\"><md-option value=\"butt\">\nButt</md-option><md-option value=\"round\">Round</md-option><md-option value=\"square\">Square</md-option></md-select>\n</md-input-container></div><div layout=\"row\" ng-if=\"vm.currentDraw.drawType==\'rectangle\'\"><md-input-container \nflex=\"45\" flex-offset=\"5\"><label>Transparency</label><input ng-model=\"vm.currentDraw.transparency\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><div flex=\"45\" flex-offset=\"5\"><md-input-container \nclass=\"md-block\"><label>Fill Color</label><input ng-model=\"vm.currentDraw.fillColor\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'rectangle\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Start X</label><input\n ng-model=\"vm.currentDraw.x1\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"45\" flex-offset=\"5\"><label>Start Y</label><input ng-model=\"vm.currentDraw.y1\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'rectangle\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Width</label><input \nng-model=\"vm.currentDraw.x2\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"45\" flex-offset=\"5\"><label>Height</label><input ng-model=\"vm.currentDraw.y2\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'rectangle\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><md-checkbox \nng-model=\"vm.currentDraw.filled\" ng-change=\"vm.reDrawFBD( vm.thisItem );\" aria-label=\"Whether the rectangle is filled\">\nFilled</md-checkbox></md-input-container><md-input-container flex=\"45\" flex-offset=\"5\"><md-checkbox \nng-model=\"vm.currentDraw.cleared\" ng-change=\"vm.reDrawFBD( vm.thisItem );\" aria-label=\"Draw rectangle or clear it\">\nClear Space</md-checkbox></md-input-container></div><div layout=\"row\" ng-if=\"vm.currentDraw.drawType==\'triangle\'\">\n<md-input-container flex=\"45\" flex-offset=\"5\"><label>Transparency</label><input ng-model=\"vm.currentDraw.transparency\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><div flex=\"45\" flex-offset=\"5\"><md-input-container \nclass=\"md-block\"><label>Fill Color</label><input ng-model=\"vm.currentDraw.fillColor\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'triangle\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>First X</label><input \nng-model=\"vm.currentDraw.x1\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"45\" flex-offset=\"5\"><label>First Y</label><input ng-model=\"vm.currentDraw.y1\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'triangle\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Second X</label><input\n ng-model=\"vm.currentDraw.x2\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"45\" flex-offset=\"5\"><label>Second Y</label><input ng-model=\"vm.currentDraw.y2\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'triangle\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Third X</label><input \nng-model=\"vm.currentDraw.x3\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"45\" flex-offset=\"5\"><label>Third Y</label><input ng-model=\"vm.currentDraw.y3\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'triangle\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><md-checkbox \nng-model=\"vm.currentDraw.filled\" ng-change=\"vm.reDrawFBD( vm.thisItem );\" aria-label=\"Whether the triangle is filled\">\nFilled</md-checkbox></md-input-container></div><div layout=\"row\" ng-if=\"vm.currentDraw.drawType==\'arc1\'\">\n<md-input-container flex=\"45\" flex-offset=\"5\"><label>Transparency</label><input ng-model=\"vm.currentDraw.transparency\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><div flex=\"45\" flex-offset=\"5\"><md-input-container \nclass=\"md-block\"><label>Fill Color</label><input ng-model=\"vm.currentDraw.fillColor\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'arc1\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>X</label><input \nng-model=\"vm.currentDraw.x1\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"45\" flex-offset=\"5\"><label>Y</label><input ng-model=\"vm.currentDraw.y1\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\">\n</md-input-container></div><div layout=\"row\" ng-if=\"vm.currentDraw.drawType==\'arc1\'\"><md-input-container flex=\"45\" \nflex-offset=\"5\"><label>Start Angle</label><input ng-model=\"vm.currentDraw.startAngle\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container flex=\"45\" flex-offset=\"5\"><label>\nEnd Angle</label><input ng-model=\"vm.currentDraw.endAngle\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\">\n</md-input-container></div><div layout=\"row\" ng-if=\"vm.currentDraw.drawType==\'arc1\'\"><md-input-container flex=\"45\" \nflex-offset=\"5\"><label>Arc Radius</label><input ng-model=\"vm.currentDraw.arcRadius\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container flex=\"45\" flex-offset=\"5\"><md-checkbox\n ng-model=\"vm.currentDraw.clockwise\" ng-change=\"vm.reDrawFBD( vm.thisItem );\" \naria-label=\"Whether the rectangle is filled\">Clockwise</md-checkbox></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'arc1\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Line Width</label><input \nng-model=\"vm.currentDraw.lineWidth\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"45\" flex-offset=\"5\"><md-checkbox ng-model=\"vm.currentDraw.filled\" ng-change=\"vm.reDrawFBD( vm.thisItem );\" \naria-label=\"Whether the arc is filled\">Filled</md-checkbox></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'arc2\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Transparency</label><input\n ng-model=\"vm.currentDraw.transparency\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><div flex=\"45\" \nflex-offset=\"5\"><md-input-container class=\"md-block\"><label>Fill Color</label><input \nng-model=\"vm.currentDraw.fillColor\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div></div><div \nlayout=\"row\" ng-if=\"vm.currentDraw.drawType==\'arc2\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Start X\n</label><input ng-model=\"vm.currentDraw.x1\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container>\n<md-input-container flex=\"45\" flex-offset=\"5\"><label>Start Y</label><input ng-model=\"vm.currentDraw.y1\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'arc2\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Control Point 1 X</label>\n<input ng-model=\"vm.currentDraw.x2\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"45\" flex-offset=\"5\"><label>Control Point 1 Y</label><input ng-model=\"vm.currentDraw.y2\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'arc2\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Control Point 2 X</label>\n<input ng-model=\"vm.currentDraw.x3\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"45\" flex-offset=\"5\"><label>Control Point 2 Y</label><input ng-model=\"vm.currentDraw.y3\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'arc2\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Arc Radius</label><input \nng-model=\"vm.currentDraw.arcRadius\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"45\" flex-offset=\"5\"><md-checkbox ng-model=\"vm.currentDraw.filled\" ng-change=\"vm.reDrawFBD( vm.thisItem );\" \naria-label=\"Whether the arc is filled\">Filled</md-checkbox></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'arc2\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Line Width</label><input \nng-model=\"vm.currentDraw.lineWidth\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div \nlayout=\"row\" ng-if=\"vm.currentDraw.drawType==\'quadratic\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>\nTransparency</label><input ng-model=\"vm.currentDraw.transparency\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\">\n</md-input-container><div flex=\"45\" flex-offset=\"5\"><md-input-container class=\"md-block\"><label>Fill Color</label>\n<input ng-model=\"vm.currentDraw.fillColor\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div></div>\n<div layout=\"row\" ng-if=\"vm.currentDraw.drawType==\'quadratic\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>\nStart X</label><input ng-model=\"vm.currentDraw.x1\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container>\n<md-input-container flex=\"45\" flex-offset=\"5\"><label>Start Y</label><input ng-model=\"vm.currentDraw.y1\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'quadratic\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Control Point X\n</label><input ng-model=\"vm.currentDraw.x2\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container>\n<md-input-container flex=\"45\" flex-offset=\"5\"><label>Control Point Y</label><input ng-model=\"vm.currentDraw.y2\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'quadratic\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>End X</label><input \nng-model=\"vm.currentDraw.x3\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"45\" flex-offset=\"5\"><label>End Y</label><input ng-model=\"vm.currentDraw.y3\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'quadratic\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><md-checkbox \nng-model=\"vm.currentDraw.filled\" ng-change=\"vm.reDrawFBD( vm.thisItem );\" aria-label=\"Whether the arc is filled\">Filled\n</md-checkbox></md-input-container></div><div layout=\"row\" ng-if=\"vm.currentDraw.drawType==\'bezier\'\">\n<md-input-container flex=\"45\" flex-offset=\"5\"><label>Transparency</label><input ng-model=\"vm.currentDraw.transparency\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><div flex=\"45\" flex-offset=\"5\"><md-input-container \nclass=\"md-block\"><label>Fill Color</label><input ng-model=\"vm.currentDraw.fillColor\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'bezier\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Start X</label><input \nng-model=\"vm.currentDraw.x1\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"45\" flex-offset=\"5\"><label>Start Y</label><input ng-model=\"vm.currentDraw.y1\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'bezier\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Control Point 1 X\n</label><input ng-model=\"vm.currentDraw.x2\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container>\n<md-input-container flex=\"45\" flex-offset=\"5\"><label>Control Point 1 Y</label><input ng-model=\"vm.currentDraw.y2\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'bezier\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Control Point 2 X\n</label><input ng-model=\"vm.currentDraw.x3\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container>\n<md-input-container flex=\"45\" flex-offset=\"5\"><label>Control Point 2 Y</label><input ng-model=\"vm.currentDraw.y3\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'bezier\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>End X</label><input \nng-model=\"vm.currentDraw.x4\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"45\" flex-offset=\"5\"><label>End Y</label><input ng-model=\"vm.currentDraw.y4\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'bezier\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><md-checkbox \nng-model=\"vm.currentDraw.filled\" ng-change=\"vm.reDrawFBD( vm.thisItem );\" aria-label=\"Whether the arc is filled\">Filled\n</md-checkbox></md-input-container></div><div layout=\"row\" ng-if=\"vm.currentDraw.drawType==\'linearGrad\'\">\n<md-input-container flex=\"45\" flex-offset=\"5\"><label>Transparency</label><input ng-model=\"vm.currentDraw.transparency\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'linearGrad\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Gradient X1</label>\n<input ng-model=\"vm.currentDraw.x1\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"45\" flex-offset=\"5\"><label>Gradient Y1</label><input ng-model=\"vm.currentDraw.y1\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'linearGrad\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Gradient X2</label>\n<input ng-model=\"vm.currentDraw.x2\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"45\" flex-offset=\"5\"><label>Gradient Y2</label><input ng-model=\"vm.currentDraw.y2\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'linearGrad\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Background X1\n</label><input ng-model=\"vm.currentDraw.x3\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container>\n<md-input-container flex=\"45\" flex-offset=\"5\"><label>Background Y1</label><input ng-model=\"vm.currentDraw.y3\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'linearGrad\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Background X2\n</label><input ng-model=\"vm.currentDraw.x4\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container>\n<md-input-container flex=\"45\" flex-offset=\"5\"><label>Background Y2</label><input ng-model=\"vm.currentDraw.y4\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'linearGrad\'\"><md-input-container flex=\"95\" flex-offset=\"5\"><label>Color Stops</label>\n<input ng-model=\"vm.currentDraw.colorStops\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div \nlayout=\"row\" ng-if=\"vm.currentDraw.drawType==\'linearGrad\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><md-checkbox \nng-model=\"vm.currentDraw.filled\" ng-change=\"vm.reDrawFBD( vm.thisItem );\" aria-label=\"Whether the arc is filled\">Filled\n</md-checkbox></md-input-container></div><div layout=\"row\" ng-if=\"vm.currentDraw.drawType==\'radialGrad\'\">\n<md-input-container flex=\"45\" flex-offset=\"5\"><label>Transparency</label><input ng-model=\"vm.currentDraw.transparency\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'radialGrad\'\"><md-input-container flex=\"25\" flex-offset=\"5\"><label>X1</label><input \nng-model=\"vm.currentDraw.x1\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"30\" flex-offset=\"5\"><label>Y1</label><input ng-model=\"vm.currentDraw.y1\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\">\n</md-input-container><md-input-container flex=\"30\" flex-offset=\"5\"><label>R1</label><input \nng-model=\"vm.currentDraw.x3\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'radialGrad\'\"><md-input-container flex=\"25\" flex-offset=\"5\"><label>X2</label><input \nng-model=\"vm.currentDraw.x2\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"30\" flex-offset=\"5\"><label>Y2</label><input ng-model=\"vm.currentDraw.y2\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\">\n</md-input-container><md-input-container flex=\"30\" flex-offset=\"5\"><label>R2</label><input \nng-model=\"vm.currentDraw.y3\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'radialGrad\'\"><md-input-container flex=\"95\" flex-offset=\"5\"><label>Color Stops</label>\n<input ng-model=\"vm.currentDraw.colorStops\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div \nlayout=\"row\" ng-if=\"vm.currentDraw.drawType==\'text\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Transparency\n</label><input ng-model=\"vm.currentDraw.transparency\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><div\n flex=\"45\" flex-offset=\"5\"><md-input-container class=\"md-block\"><label>Fill Color</label><input \nng-model=\"vm.currentDraw.fillColor\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div></div><div \nlayout=\"row\" ng-if=\"vm.currentDraw.drawType==\'text\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>X</label>\n<input ng-model=\"vm.currentDraw.x1\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"45\" flex-offset=\"5\"><label>Y</label><input ng-model=\"vm.currentDraw.y1\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\">\n</md-input-container></div><div layout=\"row\" ng-if=\"vm.currentDraw.drawType==\'text\'\"><md-input-container flex=\"45\" \nflex-offset=\"5\"><label>Text</label><input ng-model=\"vm.currentDraw.text\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\">\n</md-input-container><md-input-container flex=\"45\" flex-offset=\"5\"><label>Size</label><input \nng-model=\"vm.currentDraw.fontSize\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div \nlayout=\"row\" ng-if=\"vm.currentDraw.drawType==\'text\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Font Family\n</label><md-select ng-model=\"vm.currentDraw.fontFamily\"><md-option value=\"serif\">Serif</md-option><md-option \nvalue=\"arial\">Arial</md-option></md-select></md-input-container><md-input-container flex=\"45\" flex-offset=\"5\"><label>\nFont Style</label><md-select ng-model=\"vm.currentDraw.fontStyle\"><md-option value=\"normal\">Normal</md-option><md-option\n value=\"italic\">Italic</md-option></md-select></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'text\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><md-checkbox \nng-model=\"vm.currentDraw.filled\" ng-change=\"vm.reDrawFBD( vm.thisItem );\" aria-label=\"Whether the text is filled\">\nFilled</md-checkbox></md-input-container></div><div layout=\"row\" ng-if=\"vm.currentDraw.drawType==\'image\'\">\n<md-input-container flex=\"95\" flex-offset=\"5\"><label>Image URL</label><input ng-model=\"vm.currentDraw.imageURL\" \nng-enter=\"vm.getFolderContents( vm.thisItem, vm.currentDraw.imageURL )\"></md-input-container></div><div \nid=\"imageSelect\" ng-if=\"vm.currentDraw.drawType==\'image\'\"><md-list><md-list-item flex=\"100\" \nng-repeat=\"thisImage in vm.currentContents\" \nng-if=\"(thisImage.file_type_id==\'Image\')||(thisImage.file_type_id==\'Workspace\')\"><div \nclass=\"md-list-item-text pointerItem\" layout=\"row\" ng-if=\"thisImage.file_type_id==\'Image\'\" flex=\"100\" \nng-click=\"vm.currentDraw.src = thisImage.item_data.imageSource; \n								    			 		   vm.reDrawFBD( vm.thisItem );\">\n<div flex=\"15\" flex-offset=\"5\" ng-if=\"thisImage.file_type_id==\'Image\'\"><md-icon md-font-icon=\"icon-camera\"></md-icon>\n</div><div flex=\"75\" flex-offset=\"5\">{{thisImage.name}}</div></div><div class=\"md-list-item-text pointerItem\" \nlayout=\"row\" ng-if=\"thisImage.file_type_id==\'Workspace\'\" flex=\"100\" \nng-click=\"vm.currentDraw.imageURL=vm.currentDraw.imageURL+\'/\'+thisImage.name;\n								    			 		   vm.getFolderContents( vm.thisItem, vm.currentDraw.imageURL );\">\n<div flex=\"15\" flex-offset=\"5\" ng-if=\"thisImage.file_type_id==\'Workspace\'\"><md-icon md-font-icon=\"icon-folder-outline\">\n</md-icon></div><div flex=\"75\" flex-offset=\"5\">{{thisImage.name}}</div></div><md-divider ng-if=\"!$last\"></md-divider>\n</md-list-item></md-list></div><div layout=\"row\" ng-if=\"vm.currentDraw.drawType==\'image\'\"><md-input-container \nflex=\"45\" flex-offset=\"5\"><label>X</label><input ng-model=\"vm.currentDraw.x1\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\">\n</md-input-container><md-input-container flex=\"45\" flex-offset=\"5\"><label>Y</label><input ng-model=\"vm.currentDraw.y1\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'image\'\"><md-input-container flex=\"25\" flex-offset=\"5\"><md-checkbox \nng-model=\"vm.currentDraw.imageScaled\" ng-change=\"vm.reDrawFBD( vm.thisItem );\" \naria-label=\"Whether the image is scaled\">Scaled</md-checkbox></md-input-container><md-input-container flex=\"30\" \nflex-offset=\"5\"><label>Scaled Width</label><input ng-model=\"vm.currentDraw.x2\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\">\n</md-input-container><md-input-container flex=\"30\" flex-offset=\"5\"><label>Scaled Height</label><input \nng-model=\"vm.currentDraw.y2\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'image\'\"><md-input-container flex=\"25\" flex-offset=\"5\"><md-checkbox \nng-model=\"vm.currentDraw.imageSliced\" ng-change=\"vm.reDrawFBD( vm.thisItem );\" \naria-label=\"Whether the image is sliced\">Sliced</md-checkbox></md-input-container><md-input-container flex=\"30\" \nflex-offset=\"5\"><label>X into Image</label><input ng-model=\"vm.currentDraw.x3\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\">\n</md-input-container><md-input-container flex=\"30\" flex-offset=\"5\"><label>Y Into Image</label><input \nng-model=\"vm.currentDraw.y3\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'image\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Width in Image</label>\n<input ng-model=\"vm.currentDraw.x4\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"45\" flex-offset=\"5\"><label>Height Into Image</label><input ng-model=\"vm.currentDraw.y4\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'image\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Width on Canvas</label>\n<input ng-model=\"vm.currentDraw.x2\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"45\" flex-offset=\"5\"><label>Heigth on Canvas</label><input ng-model=\"vm.currentDraw.y2\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'image\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Transparency</label>\n<input ng-model=\"vm.currentDraw.transparency\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div \nlayout=\"row\" ng-if=\"vm.currentDraw.drawType==\'arrow\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Transparency\n</label><input ng-model=\"vm.currentDraw.transparency\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><div\n flex=\"45\" flex-offset=\"5\"><md-input-container class=\"md-block\"><label>Fill Color</label><input \nng-model=\"vm.currentDraw.fillColor\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div></div><div \nlayout=\"row\" ng-if=\"vm.currentDraw.drawType==\'arrow\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Start X\n</label><input ng-model=\"vm.currentDraw.x1\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container>\n<md-input-container flex=\"45\" flex-offset=\"5\"><label>Start Y</label><input ng-model=\"vm.currentDraw.y1\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'arrow\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>End X</label><input \nng-model=\"vm.currentDraw.x2\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container><md-input-container \nflex=\"45\" flex-offset=\"5\"><label>End Y</label><input ng-model=\"vm.currentDraw.y2\" \nng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.currentDraw.drawType==\'arrow\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Arrow Head Height</label>\n<input ng-model=\"vm.currentDraw.arrowHeadHeight\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container>\n<md-input-container flex=\"45\" flex-offset=\"5\"><label>Arrow Head Width</label><input \nng-model=\"vm.currentDraw.arrowHeadWidth\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container></div><div \nlayout=\"row\" ng-if=\"vm.currentDraw.drawType==\'arrow\'\"><md-input-container flex=\"45\" flex-offset=\"5\"><label>Line Width\n</label><input ng-model=\"vm.currentDraw.lineWidth\" ng-enter=\"vm.reDrawFBD( vm.thisItem );\"></md-input-container>\n<md-input-container flex=\"45\" flex-offset=\"5\"><label>Arrow Type</label><md-select ng-model=\"vm.currentDraw.arrowType\" \nng-change=\"vm.reDrawFBD( vm.thisItem );\"><md-option value=\"curved\">Curved</md-option><md-option value=\"straight\">\nStraight</md-option></md-select></md-input-container></div><div layout=\"row\" ng-if=\"vm.currentDraw.drawType==\'arrow\'\">\n<md-input-container flex=\"45\" flex-offset=\"5\"><md-checkbox ng-model=\"vm.currentDraw.filled\" \nng-change=\"vm.reDrawFBD( vm.thisItem );\" aria-label=\"Whether the text is filled\">Filled</md-checkbox>\n</md-input-container></div></div><h2>Set the diagram size</h2><div layout=\"row\"><md-input-container flex=\"45\" \nflex-offset=\"5\" class=\"md-block\"><label>Height</label><input ng-change=\"vm.reDrawFBD( vm.thisItem );\" \nng-model=\"vm.thisItem.content.height\"></md-input-container><md-input-container flex=\"45\" flex-offset=\"5\" \nclass=\"md-block\"><label>Width</label><input ng-change=\"vm.reDrawFBD( vm.thisItem );\" \nng-model=\"vm.thisItem.content.width\"></md-input-container></div></div></div></md-content></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.acceptChanges( vm.thisItem );\" \nclass=\"send-button md-accent md-raised\">FINISHED EDITING</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/fullPlot.html","<div id=\"plotSpecEdit\" ng-style=\"{height:document.body.clientHeight, width:document.body.clientWidth}\"><span \nplot-bind=\"vm.currentItem\"></span></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/fullPlotDialog.tmpl.html","<md-dialog aria-label=\"\" class=\"dialogItem\" id=\"fullPlotDialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nFull Size Plot</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancelPlot();\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nng-include=\"\'app/main/apps/document/worksheet/views/templates/fullPlot.html\'\"></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/fullSurfaceDialog.tmpl.html","<md-dialog aria-label=\"\" class=\"dialogItem\" id=\"fullSurfaceDialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nFull Size Surface Map</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancelSurface();\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nid=\"fullSurfaceBlock\"></div></md-dialog>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/functions.tmpl.html","<md-dialog-content ms-scroll><div layout=\"column\" layout-margin layout-fill flex=\"none\"><div layout=\"row\" \nclass=\"md-body-1\" layout-fill>\nCADWOLF documents can be used as functions within other files. To do this, the inputs and outputs for each file are setup in the properties view of the file.\n</div><div class=\"md-headline marginTopBottom20\" layout-fill>Current Functions</div><div layout=\"column\" flex=\"100\" \nlayout-fill class=\"marginTopBottom20\"><div layout=\"row\" flex=\"100\" layout-fill class=\"borderBottom\"><div \nclass=\"md-body-2\" flex=\"20\">Function Name</div><div class=\"md-body-2\" flex=\"35\">Inputs</div><div class=\"md-body-2\" \nflex=\"35\">Outputs</div></div><div ng-repeat=\"obj in vm.thisItem.worksheet\" layout=\"column\" layout-fill><div \nng-if=\"obj.Equation.inputType==\'Dataset\'\" layout=\"row\" class=\"borderBottom\"><div class=\"md-body-1\" flex=\"20\">\n{{obj.Equation.Format_name}}</div><div class=\"md-body-1\" flex=\"35\">{{obj.Equation.inputs}}</div><div class=\"md-body-1\" \nflex=\"30\">{{obj.Equation.outputs}}</div><div class=\"md-body-1\" flex=\"5\" ng-if=\"vm.editPerm\"><md-icon \nmd-font-icon=\"icon-delete\" ng-click=\"vm.deleteItem(obj)\"></md-icon></div></div></div></div><div class=\"md-headline\" \nlayout-fill class=\"marginTopBottom20\" ng-if=\"vm.editPerm\">Add a File as a Function</div><div ng-if=\"vm.editPerm\" \nlayout=\"row\" class=\"md-body-1 marginTopBottom20\" flex=\"80\" flex-margin=\"10\">\nEnter a URL for a desired file to be used as a function in the box below. The file at that location will then be pulled into this document to be used as a function.\n</div><div ng-if=\"vm.editPerm\" layout=\"row\" flex=\"80\" flex-margin=\"10\"><md-input-container class=\"md-block\" flex-gt-sm>\n<label>File URL</label><input ng-model=\"vm.inputURL\" ng-enter=\"\"></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">\nFINISHED EDITING</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/hideshow.tmpl.html","<md-dialog-content ms-scroll><div><div class=\"md-title cadwolfSubtitle\">Show and Hide Items</div><div \nclass=\"md-body-1\"><p>\nYou can hide any type of item you want. You can hide everything but the equations if you just want to see the math, or hide everything but text, etc. This does not change anything in the document, it simply hides those items while the appropriate box is unchecked below.\n</p></div><div layout=\"row\" flex=\"80\" flex-offset=\"10\"><div layout=\"row\" flex=\"15\" flex-offset=\"5\" \nlayout-align=\"space-around center\"><div class=\"md-body-1 marginBottom10\">Headers</div><md-input-container \nclass=\"md-block\"><md-checkbox ng-model=\"vm.fileInfo.showHeaders\"></md-checkbox></md-input-container></div><div \nlayout=\"row\" flex=\"15\" flex-offset=\"5\" layout-align=\"space-around center\"><div class=\"md-body-1 marginBottom10\">Text\n</div><md-input-container class=\"md-block\"><md-checkbox ng-model=\"vm.fileInfo.showText\"></md-checkbox>\n</md-input-container></div><div layout=\"row\" flex=\"15\" flex-offset=\"5\" layout-align=\"space-around center\"><div \nclass=\"md-body-1 marginBottom10\">Equations</div><md-input-container class=\"md-block\"><md-checkbox \nng-model=\"vm.fileInfo.showEquations\"></md-checkbox></md-input-container></div><div layout=\"row\" flex=\"15\" \nflex-offset=\"5\" layout-align=\"space-around center\"><div class=\"md-body-1 marginBottom10\">Symbolics</div>\n<md-input-container class=\"md-block\"><md-checkbox ng-model=\"vm.fileInfo.showSymbolics\"></md-checkbox>\n</md-input-container></div><div layout=\"row\" flex=\"15\" flex-offset=\"5\" layout-align=\"space-around center\"><div \nclass=\"md-body-1 marginBottom10\">Table</div><md-input-container class=\"md-block\"><md-checkbox \nng-model=\"vm.fileInfo.showTables\"></md-checkbox></md-input-container></div></div><div layout=\"row\" flex=\"80\" \nflex-offset=\"10\"><div layout=\"row\" flex=\"15\" flex-offset=\"5\" layout-align=\"space-around center\"><div \nclass=\"md-body-1 marginBottom10\">For Loops</div><md-input-container class=\"md-block\"><md-checkbox \nng-model=\"vm.fileInfo.showForLoops\"></md-checkbox></md-input-container></div><div layout=\"row\" flex=\"15\" \nflex-offset=\"5\" layout-align=\"space-around center\"><div class=\"md-body-1 marginBottom10\">While Loops</div>\n<md-input-container class=\"md-block\"><md-checkbox ng-model=\"vm.fileInfo.showWhileLoops\"></md-checkbox>\n</md-input-container></div><div layout=\"row\" flex=\"15\" flex-offset=\"5\" layout-align=\"space-around center\"><div \nclass=\"md-body-1 marginBottom10\">If Else</div><md-input-container class=\"md-block\"><md-checkbox \nng-model=\"vm.fileInfo.showIfElses\"></md-checkbox></md-input-container></div><div layout=\"row\" flex=\"15\" \nflex-offset=\"5\" layout-align=\"space-around center\"><div class=\"md-body-1 marginBottom10\">Plots</div><md-input-container\n class=\"md-block\"><md-checkbox ng-model=\"vm.fileInfo.showPlots\"></md-checkbox></md-input-container></div><div \nlayout=\"row\" flex=\"15\" flex-offset=\"5\" layout-align=\"space-around center\"><div class=\"md-body-1 marginBottom10\">\n3D Charts</div><md-input-container class=\"md-block\"><md-checkbox ng-model=\"vm.fileInfo.showCharts\"></md-checkbox>\n</md-input-container></div></div><div layout=\"row\" flex=\"80\" flex-offset=\"10\"><div layout=\"row\" flex=\"15\" \nflex-offset=\"5\" layout-align=\"space-around center\"><div class=\"md-body-1 marginBottom10\">Images</div>\n<md-input-container class=\"md-block\"><md-checkbox ng-model=\"vm.fileInfo.showImages\"></md-checkbox></md-input-container>\n</div><div layout=\"row\" flex=\"15\" flex-offset=\"5\" layout-align=\"space-around center\"><div \nclass=\"md-body-1 marginBottom10\">Videos</div><md-input-container class=\"md-block\"><md-checkbox \nng-model=\"vm.fileInfo.showVideos\"></md-checkbox></md-input-container></div><div layout=\"row\" flex=\"15\" flex-offset=\"5\" \nlayout-align=\"space-around center\"><div class=\"md-body-1 marginBottom10\">Line Breaks</div><md-input-container \nclass=\"md-block\"><md-checkbox ng-model=\"vm.fileInfo.showLineBreaks\"></md-checkbox></md-input-container></div></div>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-fill layout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" \nclass=\"send-button md-accent md-raised\">FINISHED</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/iconHolder.tmpl.html","<div class=\"icon_holder\"><md-menu md-offset=\"0 -7\"><md-button aria-label=\"Options\" class=\"md-icon-button\" \nng-click=\"vm.setCurrent(obj); $mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item ng-if=\"obj.component_type_id==\'1\'\"><md-button \nng-click=\"vm.showModal($event, obj, \'textBackground\')\"><span md-menu-align-target><md-icon \nmd-font-icon=\"icon-format-color\"></md-icon>Format Background</span></md-button></md-menu-item><md-menu-item \nng-if=\"( obj.component_type_id == \'3\' ) &&\n								 ( ( obj.content.eqType == \'\' ) || \n								 ( obj.content.eqType === undefined ) || \n								 ( obj.content.eqType == \'equation\' ) )\">\n<md-button ng-click=\"vm.showModal( $event, obj, \'equation\' )\" layout=\"row\"><span md-menu-align-target><md-icon \nmd-font-icon=\"icon-cog\"></md-icon>Options / Specifics</span></md-button></md-menu-item><md-menu-item \nng-if=\"( obj.component_type_id == \'3\' ) &&\n								 ( obj.content.eqType == \'slider\' )\"><md-button \nng-click=\"vm.showModal( $event, obj, \'slider\' )\" layout=\"row\"><span md-menu-align-target><md-icon \nmd-font-icon=\"icon-cog\"></md-icon>Slider Options</span></md-button></md-menu-item><md-menu-item \nng-if=\"( obj.component_type_id == \'3\' ) &&\n								 ( obj.content.eqType == \'radio\' )\"><md-button \nng-click=\"vm.showModal( $event, obj, \'radio\' )\" layout=\"row\"><span md-menu-align-target><md-icon \nmd-font-icon=\"icon-cog\"></md-icon>Radio Options</span></md-button></md-menu-item><md-menu-item \nng-if=\"( obj.component_type_id == \'3\' ) &&\n								 ( obj.content.eqType == \'dropdown\' )\"><md-button \nng-click=\"vm.showModal( $event, obj, \'dropdown\' )\" layout=\"row\"><span md-menu-align-target><md-icon \nmd-font-icon=\"icon-cog\"></md-icon>Dropdown Options</span></md-button></md-menu-item><md-menu-item \nng-if=\"obj.component_type_id==\'5\'\"><md-button ng-click=\"vm.showModal( $event, obj, \'table\' )\"><span \nmd-menu-align-target><md-icon md-font-icon=\"icon-table-edit\"></md-icon>Table Options</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"obj.component_type_id==\'6\'\"><md-button \nng-click=\"vm.currentSubItem={}; \n									 vm.currentSubItem[\'itemid\']=obj.itemid; \n									 vm.currentSubItem[\'showNumbers\']=false; \n									 vm.showStructure( $event )\">\n<span md-menu-align-target><md-icon md-font-icon=\"icon-redo-variant\"></md-icon>Loop Dialog</span></md-button>\n</md-menu-item><md-menu-item ng-if=\"obj.component_type_id==\'7\'\"><md-button \nng-click=\"vm.currentSubItem={}; \n									 vm.currentSubItem[\'itemid\']=obj.itemid; \n									 vm.currentSubItem[\'showNumbers\']=false; \n									 vm.showStructure( $event )\">\n<span md-menu-align-target><md-icon md-font-icon=\"icon-refresh\"></md-icon>Loop Dialog</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"obj.component_type_id==\'8\'\"><md-button \nng-click=\"vm.currentSubItem={}; \n									 vm.currentSubItem[\'itemid\']=obj.itemid; \n									 vm.currentSubItem[\'showNumbers\']=false; \n									 vm.showStructure( $event );\">\n<span md-menu-align-target><md-icon md-font-icon=\"icon-cube-unfolded\"></md-icon>If / Else Dialog</span></md-button>\n</md-menu-item><md-menu-item ng-if=\"obj.component_type_id == \'15\'\"><md-button \nng-click=\"vm.showModal( $event, obj, \'card\' )\" layout=\"row\"><span md-menu-align-target><md-icon \nmd-font-icon=\"icon-cog\"></md-icon>Card Options</span></md-button></md-menu-item><md-menu-item \nng-if=\"obj.component_type_id==\'6\'\"><md-button \nng-click=\"obj.content.forLoop.needsUpdateFlag=1; vm.runEquationDigest();\"><span md-menu-align-target><md-icon \nmd-font-icon=\"icon-rocket\"></md-icon>Run For Loop</span></md-button></md-menu-item><md-menu-item \nng-if=\"obj.component_type_id==\'7\'\"><md-button \nng-click=\"obj.content.whileLoop.needsUpdateFlag=1; vm.runEquationDigest();\"><span md-menu-align-target><md-icon \nmd-font-icon=\"icon-rocket\"></md-icon>Run While Loop</span></md-button></md-menu-item><md-menu-item \nng-if=\"obj.component_type_id==\'8\'\"><md-button ng-click=\"obj.content.ifelse.needsUpdateFlag=1; vm.runEquationDigest();\">\n<span md-menu-align-target><md-icon md-font-icon=\"icon-rocket\"></md-icon>Run Statement</span></md-button>\n</md-menu-item><md-menu-item ng-if=\"obj.component_type_id==\'9\'\"><md-button \nng-click=\"vm.currentItem.content.renderTo = \'edit\'; vm.showPlotEdit( $event, \'Plot\' )\"><span md-menu-align-target>\n<md-icon md-font-icon=\"icon-chart-line\"></md-icon>Chart Options</span></md-button></md-menu-item><md-menu-item \nng-if=\"obj.component_type_id==\'9\'\"><md-button \nng-click=\"vm.showFullChart( $event, obj ); vm.currentItem.content.renderTo = \'fullPlot\'; vm.currentItem.content.Plot.needsUpdateFlag=1;  \">\n<span md-menu-align-target><md-icon md-font-icon=\"icon-arrow-expand\"></md-icon>Full Size Chart</span></md-button>\n</md-menu-item><md-menu-item ng-if=\"obj.component_type_id==\'10\'\"><md-button \nng-click=\"vm.showModal( $event, obj, \'images\' )\"><span md-menu-align-target><md-icon md-font-icon=\"icon-cog\"></md-icon>\nImage Options</span></md-button></md-menu-item><md-menu-item ng-if=\"obj.component_type_id==\'12\'\"><md-button \nng-click=\"vm.showModal( $event, obj, \'video\' )\"><span md-menu-align-target><md-icon md-font-icon=\"icon-cog\"></md-icon>\nVideo Options</span></md-button></md-menu-item><md-menu-item ng-if=\"obj.component_type_id==\'13\'\"><md-button \nng-click=\"vm.currentItem.content.renderTo = \'edit\'; \n									 vm.showPlotEdit( $event, \'Surface\' );\n									 vm.renderSurface( vm.currentItem );\">\n<span md-menu-align-target><md-icon md-font-icon=\"icon-cube-outline\"></md-icon>Chart Options</span></md-button>\n</md-menu-item><md-menu-item ng-if=\"obj.component_type_id==\'13\'\"><md-button \nng-click=\"vm.currentItem.content.renderTo = \'fullSurface\';\n									 vm.showFullSurface( $event, obj );\n									 vm.renderSurface( vm.currentItem );\">\n<span md-menu-align-target><md-icon md-font-icon=\"icon-arrow-expand\"></md-icon>Full Size Surface Map</span></md-button>\n</md-menu-item><md-menu-item \nng-if=\"obj.component_type_id==\'1\'||\n								 obj.component_type_id==\'3\'||\n								 obj.component_type_id==\'4\'||\n								 obj.component_type_id==\'5\'||\n								 obj.component_type_id==\'10\'||\n								 obj.component_type_id==\'12\'||\n								 obj.component_type_id==\'13\'\">\n<md-button \nng-click=\"vm.showModal($event, {parentObj : obj, references:vm.cadwolf_fileInfo.item_data.references}, \'selectReference\')\">\n<span md-menu-align-target><md-icon md-font-icon=\"icon-school\"></md-icon>References</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"obj.component_type_id==\'2\'\"><md-button aria-label=\"Header 4\" \nng-click=\"obj.content.hClass=\'header4\'\"><span md-menu-align-target><md-icon md-font-icon=\"icon-format-header-4\">\n</md-icon>Header 4</span></md-button></md-menu-item><md-menu-item ng-if=\"obj.component_type_id==\'2\'\"><md-button \naria-label=\"Header 3\" ng-click=\"obj.content.hClass=\'header3\'\"><span md-menu-align-target><md-icon \nmd-font-icon=\"icon-format-header-3\"></md-icon>Header 3</span></md-button></md-menu-item><md-menu-item \nng-if=\"obj.component_type_id==\'2\'\"><md-button aria-label=\"Header 2\" ng-click=\"obj.content.hClass=\'header2\'\"><span \nmd-menu-align-target><md-icon md-font-icon=\"icon-format-header-2\"></md-icon>Header 2</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"obj.component_type_id==\'2\'\"><md-button aria-label=\"Header 1\" \nng-click=\"obj.content.hClass=\'header1\'\"><span md-menu-align-target><md-icon md-font-icon=\"icon-format-header-1\">\n</md-icon>Header 1</span></md-button></md-menu-item><md-menu-item ng-if=\"obj.component_type_id==\'16\'\"><md-button \nng-click=\"vm.showModal($event, obj, \'freeBodyDiagram\')\"><span md-menu-align-target><md-icon md-font-icon=\"icon-cog\">\n</md-icon>Edit Diagram</span></md-button></md-menu-item><md-menu-item ng-if=\"obj.component_type_id==\'17\'\"><md-button \nng-click=\"vm.showModal($event, obj, \'requirement\')\"><span md-menu-align-target><md-icon md-font-icon=\"icon-rocket\">\n</md-icon>Set Parent</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.changeLoc(\'up\')\"><span \nmd-menu-align-target><md-icon md-font-icon=\"icon-arrow-up-bold-circle-outline\"></md-icon>Move Up One</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.changeLoc(\'down\')\"><span md-menu-align-target><md-icon \nmd-font-icon=\"icon-arrow-down-bold-circle-outline\"></md-icon>Move Down One</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"obj.component_type_id!=\'11\'\"><md-button ng-click=\"vm.showModal($event, obj, \'margins\')\"><span \nmd-menu-align-target><md-icon md-font-icon=\"icon-fullscreen\"></md-icon>Width / Margins</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.deleteItem(obj, 0)\"><span md-menu-align-target><md-icon \nmd-font-icon=\"icon-close-circle\"></md-icon>Delete Item</span></md-button></md-menu-item></md-menu-content></md-menu>\n</div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/ifElseObject.html","<div flex=\"95\" flex-offset=\"5\" layout-fill><div flex=\"100\" layout=\"row\" layout-fill><div class=\"marginRight10\" \nlayout=\"row\"><div class=\"md-subhead marginTopRight10\">If</div><div \nng-repeat=\"blockSec in thisStruct.content.ifelse.statementBlock track by $index\" layout=\"row\"><div ng-show=\"$index>0\" \nlayout=\"row\" class=\"marginLeft10\"><div ng-show=\"!thisStruct.content.ifelse.statementBlock[$index][\'showOptions\']\" \nng-click=\"thisStruct.content.ifelse.statementBlock[$index][\'showOptions\']=true\" class=\"marginTopLeft10\">\n{{thisStruct.content.ifelse.statementBlock[$index][0][\'blockOption\']}}</div><div class=\"ifelseandorvalue\" \nng-show=\"thisStruct.content.ifelse.statementBlock[$index][\'showOptions\']\"><select class=\"ifelseconditionselect\" \nng-change=\" thisStruct.content.ifelse.statementBlock[$index][\'showOptions\']=false; \n                                            thisStruct.content.needsBlockUpdate=1; \n                                            thisStruct.content.updateClass=\'itemneedsupdate\'; \n                                            updateme.update=!updateme.update;\n                                            callRunEquationDigest();\" \nng-blur=\"thisStruct.content.ifelse.statementBlock[$index][\'showOptions\']=false\" \nng-model=\"thisStruct.content.ifelse.statementBlock[$index][0][\'blockOption\']\"><option value=\"||\">||</option><option \nvalue=\"&&\">&&</option></select></div></div><div layout=\"row\" class=\"bordered marginLeft10\"><div \nng-repeat=\"statementSec in blockSec track by $index\" layout=\"row\" class=\"marginLeft10\"><div class=\"statementOption\" \nng-show=\"!thisStruct.content.ifelse.statementBlock[$parent.$index][$index][\'showOptions\']&&$index>0\" \nng-click=\"thisStruct.content.ifelse.statementBlock[$parent.$index][$index][\'showOptions\']=true\">\n{{thisStruct.content.ifelse.statementBlock[$parent.$index][$index][\'blockOption\']}}</div><div \nng-show=\"thisStruct.content.ifelse.statementBlock[$parent.$index][$index][\'showOptions\']&&$index>0\"><select \nng-change=\" thisStruct.content.ifelse.statementBlock[$parent.$index][$index][\'showOptions\']=false; \n                                                thisStruct.content.needsBlockUpdate=1; \n                                                thisStruct.content.updateClass=\'itemneedsupdate\'; \n                                                updateme.update=!updateme.update;\n                                                callRunEquationDigest();\" \nng-blur=\"thisStruct.content.ifelse.statementBlock[$parent.$index][$index][\'showOptions\']=false\" \nng-model=\"thisStruct.content.ifelse.statementBlock[$parent.$index][$index][\'blockOption\']\"><option value=\"||\">||\n</option><option value=\"&&\">&&</option></select></div><div class=\"bordered marginRight10\" layout=\"row\" \nng-class=\"thisStruct.content.ifelse.statementBlock[$parent.$index][$index].showClass\"><md-icon \nclass=\"marginRight10 pointerItem iconRedBackground\" ng-show=\"editperm\" \nng-click=\"callDeleteStatement(thisStruct.content.itemid, \'ifelse\', $parent.$index, $index); updateme.update=!updateme.update;\" \nmd-font-icon=\"icon-cancel\"></md-icon><div class=\"marginRight10\" layout=\"row\"><div layout=\"row\"><div \nng-show=\"!thisStruct.content.ifelse.statementBlock[$parent.$index][$index][\'flagInputEdit\']\" \nng-dblclick=\"thisStruct.content.ifelse.statementBlock[$parent.$index][$index][\'flagInputEdit\']=true\">\n{{thisStruct.content.ifelse.statementBlock[$parent.$index][$index].flagText}}</div><input type=\"text\" \nng-show=\"thisStruct.content.ifelse.statementBlock[$parent.$index][$index].flagInputEdit\" \nng-model=\"thisStruct.content.ifelse.statementBlock[$parent.$index][$index].flagText\" \nng-enter=\"thisStruct.content.ifelse.statementBlock[$parent.$index][$index][\'flagInputEdit\']=false;\n                                                  thisStruct.content.updateClass=\'itemneedsupdate\'; \n                                                  thisStruct.content.needsBlockUpdate=1; \n                                                  updateme.update=!updateme.update;\n                                                  callRunEquationDigest();\">\n</div></div><div class=\"marginRight10\"><div class=\"ifelseconditionvalue\" \nng-show=\"!thisStruct.content.ifelse.statementBlock[$parent.$index][$index].conditionInputEdit\" \nng-dblclick=\"thisStruct.content.ifelse.statementBlock[$parent.$index][$index].conditionInputEdit=true\">\n{{thisStruct.content.ifelse.statementBlock[$parent.$index][$index].conditionText}}</div><select \nclass=\"ifelseconditionselect\" \nng-show=\"thisStruct.content.ifelse.statementBlock[$parent.$index][$index].conditionInputEdit\" \nng-change=\"thisStruct.content.ifelse.statementBlock[$parent.$index][$index].conditionInputEdit=false;   \n                                                   thisStruct.content.needsBlockUpdate=1; \n                                                   thisStruct.content.updateClass=\'itemneedsupdate\'; \n                                                   updateme.update=!updateme.update;\n                                                   callRunEquationDigest();\" \nng-blur=\"thisStruct.content.ifelse.statementBlock[$parent.$index][$index].conditionInputEdit=false\" \nng-model=\"thisStruct.content.ifelse.statementBlock[$parent.$index][$index].conditionText\"><option value=\"==\">==\n</option><option value=\"!=\">!=</option><option value=\"<\">&lt;</option><option value=\"<=\">&lt;=</option><option \nvalue=\">\">&gt;</option><option value=\">=\">&gt;=</option></select></div><div class=\"marginRight10\"><div \nclass=\"ifelsevaluewrapper\"><div class=\"ifelsevalue\" \nng-show=\"!thisStruct.content.ifelse.statementBlock[$parent.$index][$index].dependentInputEdit\" \nng-dblclick=\"thisStruct.content.ifelse.statementBlock[$parent.$index][$index].dependentInputEdit=true\">\n{{thisStruct.content.ifelse.statementBlock[$parent.$index][$index].dependentText}}</div><input type=\"text\" \nclass=\"ifelseinput\" ng-model=\"thisStruct.content.ifelse.statementBlock[$parent.$index][$index].dependentText\" \nng-show=\"thisStruct.content.ifelse.statementBlock[$parent.$index][$index].dependentInputEdit\" \nng-enter=\"thisStruct.content.ifelse.statementBlock[$parent.$index][$index].dependentInputEdit=false; \n                                                     thisStruct.content.needsBlockUpdate=1; \n                                                     thisStruct.content.updateClass=\'itemneedsupdate\'; \n                                                     updateme.update=!updateme.update;\n                                                     callRunEquationDigest();\">\n</div></div></div><md-icon class=\"marginTopRight5 pointerItem iconGreenBackground\" ng-show=\"editperm\" \nng-click=\"callAddStatement(thisStruct.content.itemid, \'ifelse\', $parent.$index, $index); updateme.update=!updateme.update;\" \nmd-font-icon=\"icon-plus-circle-outline\"></md-icon></div></div><md-icon \nclass=\"marginLeft5 pointerItem iconGreenBackground\" ng-show=\"editperm\" \nng-click=\"callAddBlock(thisStruct.content.itemid, \'ifelse\', $index); updateme.update=!updateme.update;\" \nmd-font-icon=\"icon-plus-box\"></md-icon></div></div></div><md-content class=\"content\" \nng-class=\"thisStruct.content.updateClass\" flex ms-scroll><div class=\"main_item\" \nng-repeat=\"subObj in worksheet | orderBy:\'order\' track by subObj.itemid\" ng-switch on=\"subObj.component_type_id\" \nng-if=\"subObj.content.parentid==thisStruct.content.itemid\" style=\"width:100%\"><div \nstyle=\"margin-top:{{subObj.margintop}}px; \n                        margin-bottom:{{subObj.marginbottom}}px; \n                        margin-left:{{subObj.marginleft}}px; \n                        margin-right:{{subObj.marginright}}px\">\n<div class=\"switchWrapper\" ng-switch-when=\"3\"><div class=\"equationblock\"><div class=\"eqshow\" id=\"{{subObj.itemid}}\">\n{{subObj.content.Equation.newEquation}}</div></div></div><div class=\"switchWrapper\" ng-switch-when=\"6\"><for-loop-object\n struct=\"{{subObj.itemid}}\" worksheet=\"worksheet\" editperm=\"editperm\" add-statement=\"callAddStatement\" \nadd-block=\"callAddBlock\" delete-statement=\"callDeleteStatement\" run-equation-digest=\"callRunEquationDigest\" \nupdateme=\"updateme\"></for-loop-object></div><div class=\"switchWrapper\" ng-switch-when=\"7\"><while-loop-object \nstruct=\"{{subObj.itemid}}\" worksheet=\"worksheet\" editperm=\"editPerm\" add-statement=\"callAddStatement\" \nadd-block=\"callAddBlock\" delete-statement=\"callDeleteStatement\" run-equation-digest=\"callRunEquationDigest\" \nupdateme=\"updateme\"></while-loop-object></div><div class=\"switchWrapper\" ng-switch-when=\"8\"><if-else-object \nstruct=\"{{subObj.itemid}}\" worksheet=\"worksheet\" editperm=\"editperm\" add-statement=\"callAddStatement\" \nadd-block=\"callAddBlock\" delete-statement=\"callDeleteStatement\" run-equation-digest=\"callRunEquationDigest\" \nupdateme=\"updateme\"></if-else-object></div></div></div></md-content></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/importedFunctions.tmpl.html","<md-dialog-content ms-scroll><div><div class=\"md-headline marginTopBottom20\">Imported Files as Functions</div><div \nlayout=\"row\" class=\"md-body-1\" layout-fill>\nFiles can be brought into other files and used as functions. This dialog shows the user which files are currently available and the names used to call those functions. If you have edit permission, this dialog also lets the user add documents to this document to be used as a function.\n</div><div class=\"md-title cadwolfSubtitle\">Currently Imported Files</div><div layout=\"row\" flex><div layout=\"row\" \nflex=\"80\" flex-offset=\"10\" layout-align=\"center center\"><div layout=\"column\" flex=\"100\" layout-fill \nlayout-align=\"start center\" class=\"marginTopBottom20\"><div layout=\"row\" \nng-if=\"vm.fileInfo.item_data.impFunctions.length>0\" flex=\"80\" flex-offset=\"10\" layout-fill class=\"borderBottom\"><div \nclass=\"md-body-2\" flex=\"25\">File Name</div><div class=\"md-body-2\" flex=\"20\">Function Name</div><div class=\"md-body-2\" \nflex=\"35\">File Location</div><div class=\"md-body-2\" flex=\"10\"></div><div class=\"md-body-2\" flex=\"10\"></div></div><div \nng-repeat=\"obj in vm.fileInfo.item_data.impFunctions\" layout=\"column\" layout-fill flex=\"80\" flex-offset=\"10\"><div \nlayout=\"row\" class=\"marginTop8\"><div flex=\"25\">{{obj.fileName}}</div><div flex=\"20\">{{obj.functionName}}</div><div \nflex=\"35\">{{obj.parentLocation}}</div><div flex=\"10\" ng-if=\"obj.showContents\"><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"hoverMe\" ng-click=\"obj.showContents=!obj.showContents\"></md-icon></div><div \nflex=\"10\" ng-if=\"!obj.showContents\"><md-icon md-font-icon=\"icon-chevron-right\" class=\"hoverMe\" \nng-click=\"obj.showContents=!obj.showContents\"></md-icon></div><div flex=\"10\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\" class=\"hoverMe\" ng-click=\"vm.deleteFAF(obj)\"></md-icon></div></div><md-list \nlayout-fill ng-if=\"obj.showContents\"><md-list-item ng-repeat=\"fileItem in obj.fileItems\" layout=\"row\" layout-fill><div \nlayout=\"row\" class=\"marginTop8\" ng-if=\"fileItem.component_type_id==3\"><div flex=\"20\">Equation</div><div flex=\"80\">\n{{fileItem.content.Equation.Format_left}}</div></div><div layout=\"row\" class=\"marginTop8\" \nng-if=\"fileItem.component_type_id==5\"><div flex=\"20\">Table</div><div flex=\"80\"></div></div><div layout=\"row\" \nclass=\"marginTop8\" ng-if=\"fileItem.component_type_id==6\"><div flex=\"20\">For Loop</div><div flex=\"80\"></div></div><div \nlayout=\"row\" class=\"marginTop8\" ng-if=\"fileItem.component_type_id==7\"><div flex=\"20\">While Loop</div><div flex=\"80\">\n</div></div><div layout=\"row\" class=\"marginTop8\" ng-if=\"fileItem.component_type_id==8\"><div flex=\"20\">If Else Statement\n</div><div flex=\"80\"></div></div></md-list-item></md-list></div><div \nng-if=\"vm.fileInfo.item_data.impFunctions.length==0\"><div>There are no functions currently imported into this document.\n</div></div></div></div></div><div class=\"md-title cadwolfSubtitle\" layout-fill>Add Imported Files</div><div \nlayout=\"row\" flex><div layout=\"row\" flex=\"80\" flex-offset=\"10\" layout-align=\"center center\"><div layout=\"column\" \nflex=\"100\" layout-fill layout-align=\"start center\"><md-input-container layout-fill><label>URL of parent folder</label>\n<input ng-model=\"vm.inputURL\" ng-enter=\"vm.getFolderContents( \'\', vm.inputURL )\"></md-input-container><div \nng-if=\"vm.currentContents.length==0\"><div class=\"md-body-2\">There are no files in that directory</div></div><div \nlayout=\"row\" layout-fill ng-if=\"vm.currentContents.length>0\" class=\"borderBottom\"><div class=\"md-body-2\" flex=\"50\">\nFile Name</div><div class=\"md-body-2\" flex=\"40\">Function Name</div><div class=\"md-body-2\" flex=\"10\"></div></div><div \nng-repeat=\"fileObj in vm.currentContents\" layout=\"column\" layout-fill><div layout=\"row\" class=\"marginTop8\" \nng-if=\"fileObj.file_type_id==\'Document\'\"><div flex=\"50\">{{fileObj.name}}</div><div flex=\"40\" \nng-if=\"fileObj.item_data.fileAsFunction.fileFunName.length>0\">{{fileObj.item_data.fileAsFunction.fileFunName}}</div>\n<div flex=\"40\" ng-if=\"fileObj.item_data.fileAsFunction.fileFunName.length==0\">No function name</div><div flex=\"10\">\n<md-icon class=\"hoverMe\" md-font-icon=\"icon-plus-circle-outline\" ng-click=\"vm.addFAF( fileObj )\"></md-icon></div></div>\n<div layout=\"row\" ng-if=\"fileObj.file_type_id==\'Dataset\'\"><div flex=\"50\">{{fileObj.name}}</div><div flex=\"40\">\nThis is a dataset</div><div flex=\"10\"></div></div><div layout=\"row\" ng-if=\"fileObj.file_type_id==\'Workspace\'\"><div \nflex=\"50\">{{fileObj.name}}</div><div flex=\"40\">This is a workspace</div><div flex=\"10\"></div></div><div layout=\"row\" \nng-if=\"fileObj.file_type_id==\'PartTree\'\"><div flex=\"50\">{{fileObj.name}}</div><div flex=\"40\">This is a part tree</div>\n<div flex=\"10\"></div></div><md-divider></md-divider></div></div></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">\nFINISHED EDITING</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/message.tmpl.html","<md-dialog-content ms-scroll><div class=\"md-headline\">{{vm.currentItem.title}}</div><div class=\"md-body-1\" \nclass=\"fullWidth\">{{vm.currentItem.text}}</div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-fill layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">CLOSE MESSAGE</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/modalTemplates.html","<md-dialog aria-label=\"\" class=\"large-dialog\" id=\"modalDialog\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\"><h2 \nng-if=\"vm.modalType==\'margins\'\" class=\"title\">Edit Margins</h2><h2 ng-if=\"vm.modalType==\'images\'\" class=\"title\">\nEdit Image</h2><h2 ng-if=\"vm.modalType==\'video\'\" class=\"title\">Edit Video</h2><h2 ng-if=\"vm.modalType==\'bibEdit\'\" \nclass=\"title\">Edit Bibliography</h2><h2 ng-if=\"vm.modalType==\'refEdit\'\" class=\"title\">Edit Reference</h2><h2 \nng-if=\"vm.modalType==\'freeBodyDiagram\'\" class=\"title\">Edit Free Body Diagram</h2><h2 \nng-if=\"vm.modalType==\'Table of Contents\'\" class=\"title\">Table of Contents Properties</h2><h2 \nng-if=\"vm.modalType==\'Bibliography\'\" class=\"title\">Edit the Bibliography</h2><h2 ng-if=\"vm.modalType==\'equation\'\" \nclass=\"title\">Edit Equation</h2><h2 ng-if=\"vm.modalType==\'slider\'\" class=\"title\">Edit Slider</h2><h2 \nng-if=\"vm.modalType==\'radio\'\" class=\"title\">Edit Radio Group</h2><h2 ng-if=\"vm.modalType==\'dropdown\'\" class=\"title\">\nEdit Dropdown Select</h2><h2 ng-if=\"vm.modalType==\'table\'\" class=\"title\">Edit Table</h2><h2 \nng-if=\"vm.modalType==\'forLoop\'\" class=\"title\">Loop Properties</h2><h2 ng-if=\"vm.modalType==\'whileLoop\'\" class=\"title\">\nLoop Properties</h2><h2 ng-if=\"vm.modalType==\'ifElse\'\" class=\"title\">If / Else Properties</h2><h2 \nng-if=\"vm.modalType==\'File Inputs\'\" class=\"title\">Inputs from Documents</h2><h2 ng-if=\"vm.modalType==\'Dataset Inputs\'\" \nclass=\"title\">Inputs from Datasets</h2><h2 ng-if=\"vm.modalType==\'Functions\'\" class=\"title\">Imported Functions</h2><h2 \nng-if=\"vm.modalType==\'selectReference\'\" class=\"title\">Select References</h2><h2 ng-if=\"vm.modalType==\'Properties\'\" \nclass=\"title\">Document Properties</h2><h2 ng-if=\"vm.modalType==\'File as a Function\'\" class=\"title\">File as a Function\n</h2><h2 ng-if=\"vm.modalType==\'Imported Functions\'\" class=\"title\">Imported Functions</h2><h2 \nng-if=\"vm.modalType==\'Message\'\" class=\"title\">Message</h2><h2 ng-if=\"vm.modalType==\'Hide/Show Items\'\" class=\"title\">\nShow and Hide Items</h2><h2 ng-if=\"vm.modalType==\'card\'\" class=\"title\">Edit Card Properties</h2><h2 \nng-if=\"vm.modalType==\'Link to CAD\'\" class=\"title\">Link Document to CAD</h2><h2 ng-if=\"vm.modalType==\'Dependent Files\'\" \nclass=\"title\">Dependent Files</h2><h2 ng-if=\"vm.modalType==\'textBackground\'\" class=\"title\">Format Text Background</h2>\n<h2 ng-if=\"vm.modalType==\'requirement\'\" class=\"title\">Requirements</h2><h2 ng-if=\"vm.modalType==\'Forums\'\" \nclass=\"title\">Forums</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel();\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-if=\"vm.modalType==\'margins\'\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/editMargins.tmpl.html\'\">\n</div><div ng-if=\"vm.modalType==\'images\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/editImage.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'video\'\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/editVideo.tmpl.html\'\">\n</div><div ng-if=\"vm.modalType==\'bibEdit\'\" \nng-include=\"\'app/main/apps/document/bibliography/views/editReference.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'refEdit\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/editReference.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'Table of Contents\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/tableOfContents.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'Bibliography\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/bibliography.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'equation\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/editEquation.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'slider\'\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/editSlider.tmpl.html\'\">\n</div><div ng-if=\"vm.modalType==\'radio\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/editRadio.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'dropdown\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/editDropdown.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'table\'\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/editTable.tmpl.html\'\">\n</div><div ng-if=\"vm.modalType==\'forLoop\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/editForLoop.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'whileLoop\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/editWhileLoop.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'ifElse\'\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/editIfElse.tmpl.html\'\">\n</div><div ng-if=\"vm.modalType==\'File Inputs\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/fileInputs.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'Dataset Inputs\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/datasetInputs.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'Functions\'\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/functions.tmpl.html\'\">\n</div><div ng-if=\"vm.modalType==\'selectReference\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/selectReference.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'Properties\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/properties.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'File as a Function\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/fileAsFunction.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'Imported Functions\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/importedFunctions.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'Message\'\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/message.tmpl.html\'\">\n</div><div ng-if=\"vm.modalType==\'Hide/Show Items\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/hideshow.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'card\'\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/editCard.tmpl.html\'\"></div>\n<div ng-if=\"vm.modalType==\'Link to CAD\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/cadLink.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'Dependent Files\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/depFiles.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'freeBodyDiagram\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/freeBodyDiagram.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'textBackground\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/textBackground.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'requirement\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/editRequirement.tmpl.html\'\"></div><div \nng-if=\"vm.modalType==\'Forums\'\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/forums.tmpl.html\'\"></div>\n</md-dialog>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/plotDialog.tmpl.html","<md-dialog aria-label=\"\" class=\"large-dialog\" id=\"plotDialog\"><form name=\"contactForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between\"><h2 class=\"title\">Edit Plot</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancelPlot();\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"dialogItem\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpecVer/plotSpec.html\'\"></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/properties.tmpl.html","<md-dialog-content ms-scroll><div><div class=\"md-title cadwolfSubtitle\">Title and Subtitle</div><div layout-fill \nng-include=\"\'app/main/apps/document/worksheet/views/templates/propertyTitles.html\'\"></div><div \nclass=\"md-title cadwolfSubtitle\">Where the equations are solved</div><div layout-fill \nng-include=\"\'app/main/apps/document/worksheet/views/templates/solver.html\'\"></div><div \nclass=\"md-title cadwolfSubtitle\">Version</div><div layout-fill \nng-include=\"\'app/main/apps/document/worksheet/views/templates/version.html\'\"></div><div \nclass=\"md-title cadwolfSubtitle\">Checkout Status</div><div layout-fill \nng-include=\"\'app/main/apps/document/worksheet/views/templates/checkStatus.html\'\"></div><div \nclass=\"md-title cadwolfSubtitle\">Dates and Permissions</div><div layout=\"row\" layout-fill><div layout-fill flex=\"50\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/propertyDates.html\'\"></div><div flex=\"45\" \nflex-offset=\"5\" ng-include=\"\'app/main/apps/document/worksheet/views/templates/propertyPermissions.html\'\"></div></div>\n<div class=\"md-title cadwolfSubtitle\">Description</div><div layout-fill \nng-include=\"\'app/main/apps/document/worksheet/views/templates/propertyDesc.html\'\"></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">\nFINISHED EDITING</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/propertyDates.html","<div class=\"propertySubsection\" layout-align=\"center center\"><div layout=\"row\" flex=\"100\" class=\"marginTopBottom5\" \nlayout-fill><div flex=\"40\" flex-offset=\"5\" class=\"md-body-1\">Date Created</div><div flex=\"50\" class=\"md-body-1\">\n{{vm.fileInfo.created_at}}</div></div><div layout=\"row\" flex=\"100\" class=\"marginTopBottom5\" layout-fill><div flex=\"40\" \nflex-offset=\"5\" class=\"md-body-1\">Date Last Modified</div><div flex=\"50\" class=\"md-body-1\">{{vm.fileInfo.updated_at}}\n</div></div><div layout=\"row\" flex=\"100\" class=\"marginTopBottom5\" layout-fill><div flex=\"40\" flex-offset=\"5\" \nclass=\"md-body-1\">Checkout Status</div><div ng-if=\"vm.fileInfo.item_data.checkout_id!=0\" flex=\"50\" class=\"md-body-1\">\nChecked out by {{vm.fileInfo.item_data.checkout_name}}</div><div ng-if=\"vm.fileInfo.item_data.checkout_id==0\" \nflex=\"50\" class=\"md-body-1\">File not checked out</div></div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/propertyDesc.html","<text-angular ng-model=\"vm.fileInfo.item_data.description\" ng-if=\"vm.editPerm\"></text-angular><div \nng-if=\"!vm.editPerm\" data-ng-bind-html=\"vm.fileInfo.item_data.description\"></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/propertyPermissions.html","<div class=\"propertySubsection\" layout-align=\"center center\"><div layout=\"row\" flex=\"100\" class=\"marginTopBottom5\" \nlayout-fill><div ng-if=\"vm.viewPerm\" flex=\"90\" flex-offset=\"5\" class=\"md-body-1\">You have permission to view this file\n</div><div ng-if=\"!vm.viewPerm\" flex=\"90\" flex-offset=\"5\" class=\"md-body-1\">\nYou do not have permission to view this file</div></div><div layout=\"row\" flex=\"100\" class=\"marginTopBottom5\" \nlayout-fill><div ng-if=\"vm.editPerm\" flex=\"90\" flex-offset=\"5\" class=\"md-body-1\">You have permission to edit this file\n</div><div ng-if=\"!vm.editPerm\" flex=\"90\" flex-offset=\"5\" class=\"md-body-1\">\nYou do not have permission to edit this file</div></div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/propertySection.html","<div><sub-item-buttons currentsubitem=\"vm.currentSubItem\" worksheet=\"vm.cadwolf_worksheet\"></sub-item-buttons></div>\n<div layout=\"column\" flex=\"100\"><div ng-repeat=\"thisItem in vm.cadwolf_worksheet track by $index\" layout=\"row\"><div \nlayout=\"column\" flex=\"100\" layout-margin \nng-if=\"( thisItem[\'component_type_id\'] == \'3\' ) && ( vm.currentSubItem[\'itemid\'] == thisItem[\'itemid\'] )\"><h2>\nProperties</h2><div layout=\"row\" layout-fill flex=\"100\" layout-margin><div layout=\"row\" flex=\"45\" flex-offset=\"5\" \nclass=\"md-subhead\">Solution</div><div layout=\"row\" flex=\"45\" flex-offset=\"5\" class=\"md-subhead\">\n{{thisItem.content.Equation.Solution_real[\'0-0\']}}</div></div><div layout=\"row\" layout-fill flex=\"100\" layout-margin>\n<div layout=\"row\" flex=\"45\" flex-offset=\"5\" class=\"md-subhead\">Size</div><div layout=\"row\" flex=\"45\" flex-offset=\"5\" \nclass=\"md-subhead\">{{thisItem.content.Equation.Format_size}}</div></div><div layout=\"row\" layout-fill flex=\"100\" \nlayout-margin><div layout=\"row\" flex=\"45\" flex-offset=\"5\" class=\"md-subhead\">Units</div><div layout=\"row\" flex=\"45\" \nflex-offset=\"5\" class=\"md-subhead\">{{thisItem.content.Equation.Units_units}}</div></div></div><div layout=\"column\" \nflex=\"100\" layout-margin \nng-if=\"( thisItem[\'component_type_id\'] == \'6\' ) && ( vm.currentSubItem[\'itemid\'] == thisItem[\'itemid\'] )\"><h2>\nProperties</h2><div layout=\"row\" layout-fill flex=\"100\" layout-margin><div layout=\"row\" flex=\"60\" flex-offset=\"5\" \nclass=\"md-subhead\">Start Value</div><div layout=\"row\" flex=\"30\" flex-offset=\"5\" class=\"md-subhead\">\n{{thisItem.content.forLoop.start}}</div></div><div layout=\"row\" layout-fill flex=\"100\" layout-margin><div layout=\"row\" \nflex=\"60\" flex-offset=\"5\" class=\"md-subhead\">Stop Value</div><div layout=\"row\" flex=\"30\" flex-offset=\"5\" \nclass=\"md-subhead\">{{thisItem.content.forLoop.stop}}</div></div><div layout=\"row\" layout-fill flex=\"100\" layout-margin>\n<div layout=\"row\" flex=\"60\" flex-offset=\"5\" class=\"md-subhead\">Stop Value</div><div layout=\"row\" flex=\"30\" \nflex-offset=\"5\" class=\"md-subhead\">{{thisItem.content.forLoop.increment}}</div></div><div layout=\"row\" layout-fill \nflex=\"100\" layout-margin><div layout=\"row\" flex=\"60\" flex-offset=\"5\" class=\"md-subhead\">Number of Steps</div><div \nlayout=\"row\" flex=\"30\" flex-offset=\"5\" class=\"md-subhead\">{{thisItem.content.forLoop.numSteps}}</div></div></div><div \nlayout=\"column\" flex=\"100\" layout-margin \nng-if=\"( thisItem[\'component_type_id\'] == \'7\' ) && ( vm.currentSubItem[\'itemid\'] == thisItem[\'itemid\'] )\"><h2>\nProperties</h2><div layout=\"row\" layout-fill flex=\"100\" layout-margin><div layout=\"row\" flex=\"70\" flex-offset=\"5\" \nclass=\"md-subhead\">Number of Iterations</div><div layout=\"row\" flex=\"20\" flex-offset=\"5\" class=\"md-subhead\">\n{{thisItem.content.whileLoop.Loop_numsteps}}</div></div><div layout=\"row\" layout-fill flex=\"100\" layout-margin><div \nlayout=\"row\" flex=\"70\" flex-offset=\"5\" class=\"md-subhead\">Iteration Limit</div><div ng-if=\"!vm.editPerm\" flex=\"20\" \nflex-offset=\"5\" class=\"md-subhead\">{{thisItem.content.whileLoop.Loop_stepLimit}}</div><div ng-if=\"vm.editPerm\" \nflex=\"20\" flex-offset=\"5\" class=\"md-subhead\"><input type=\"text\" layout-fill \nng-model=\"thisItem.content.whileLoop.Loop_stepLimit\"></div></div></div><div layout=\"column\" flex=\"100\" layout-margin \nng-if=\"( thisItem[\'component_type_id\'] == \'8\' ) && ( vm.currentSubItem[\'itemid\'] == thisItem[\'itemid\'] )\"><h2>\nProperties</h2><div layout=\"row\" layout-fill flex=\"100\" layout-margin><div layout=\"row\" flex=\"70\" flex-offset=\"5\" \nclass=\"md-subhead\">Statement Result</div><div layout=\"row\" flex=\"20\" flex-offset=\"5\" class=\"md-subhead\">\n{{thisItem.content.ifelse.Statement_truefalse}}</div></div></div></div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/propertyTitles.html","<div ng-if=\"vm.editPerm\" layout=\"row\" flex=\"100\" layout-fill><md-checkbox ng-model=\"vm.fileInfo.item_data.showTitle\" \nflex=\"5\" ng-change=\"vm.updateService()\"></md-checkbox><md-input-container class=\"md-block\" flex=\"90\" flex-offset=\"5\">\n<label>Title</label><input ng-model=\"vm.fileInfo.item_data.title\" ng-change=\"vm.updateService()\"></md-input-container>\n</div><div ng-if=\"!vm.editPerm\" layout=\"row\" flex=\"100\" layout-fill><div flex=\"20\" class=\"md-subhead\">Title</div><div \nflex=\"70\" class=\"md-body-2\">{{vm.fileInfo.item_data.title}}</div></div><div ng-if=\"vm.editPerm\" layout=\"row\" \nflex=\"100\" layout-fill><md-checkbox ng-model=\"vm.fileInfo.item_data.showSubtitle\" flex=\"5\" \nng-change=\"vm.updateService()\"></md-checkbox><md-input-container class=\"md-block\" flex=\"90\" flex-offset=\"5\"><label>\nSubtitle</label><input ng-model=\"vm.fileInfo.item_data.subtitle\" ng-change=\"vm.updateService()\"></md-input-container>\n</div><div ng-if=\"!vm.editPerm\" layout=\"row\" flex=\"100\" layout-fill><div flex=\"20\" class=\"md-subhead leftTitle\">\nSubtitle</div><div flex=\"70\" class=\"md-body-2\">{{vm.fileInfo.item_data.subtitle}}</div></div><div \nclass=\"md-title cadwolfSubtitle\">Width and Side Margins</div><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-around center\"><div ng-if=\"vm.editPerm\" flex=\"30\"><md-input-container class=\"md-block\"><label>\nDocument Width</label><input ng-model=\"vm.fileInfo.item_data.docWidth\"></md-input-container></div><div \nng-if=\"!vm.editPerm\" flex=\"30\"><div class=\"md-body-1\">Document Width</div><div class=\"md-body-1\">\n{{vm.fileInfo.item_data.docWidth}}</div></div><div ng-if=\"vm.editPerm\" flex=\"30\"><md-input-container class=\"md-block\">\n<label>Document Side Margin</label><input ng-model=\"vm.fileInfo.item_data.docMargin\" \nng-enter=\"vm.calcWidth = vm.fileInfo.item_data.docWidth+(2*vm.fileInfo.item_data.docMargin)\"></md-input-container>\n</div><div ng-if=\"!vm.editPerm\" flex=\"30\"><div class=\"md-body-1\">Document Side Margin</div><div class=\"md-body-1\">\n{{vm.fileInfo.item_data.docMargin}}</div></div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/refNum.html","<div class=\"refNumbers\" layout-fill><div \nng-repeat=\"testRef in vm.cadwolf_fileInfo.item_data.references | orderBy:testRef.refNum track by testRef.refID\"><div \nng-repeat=\"thisRef in obj.content.references\"><div class=\"refNum\" ng-if=\"testRef.refID==thisRef\">{{testRef.refNum}}\n</div></div></div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/selectReference.tmpl.html","<md-dialog-content ms-scroll><div layout=\"column\" layout-margin><div class=\"md-subhead\" layout-align=\"center center\">\nSelect item references</div><div class=\"md-body-1\" layout-align=\"center center\">\nThe list below shows all of the references that are avaialble for this file. Check the box next to any reference that you wish to apply to this item.\n</div><div layout=\"column\" layout-align=\"center center\" flex=\"100\"><div \nng-repeat=\"obj in vm.thisItem.references | orderBy:obj.refNum track by obj.refID\" layout-fill flex=\"100\" layout=\"row\">\n<div ng-if=\"obj[\'type\']==\'web\'\" layout=\"row\" layout-fill layout-padding flex=\"80\" flex-offset=\"10\" \nng-click=\"vm.changeRef( obj.refID, vm.thisItem.parentObj )\" class=\"pointerItem marginTop10\"><div layout=\"row\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-outline\" ng-if=\"vm.thisItem.parentObj.content.references.indexOf(obj.refID)!=-1\">\n</md-icon><md-icon md-font-icon=\"icon-checkbox-blank-outline\" \nng-if=\"vm.thisItem.parentObj.content.references.indexOf(obj.refID)==-1\"></md-icon><div class=\"bibNum\">{{obj[\'refNum\']}}\n</div><div class=\"bibText\">{{obj[\'author\']}}</div><div class=\"bibText\"><a href=\"{{address}}\">{{obj[\'webtitle\']}}</a>.\n</div><div class=\"bibText\"><u>{{obj[\'pagetitle\']}}</u> -</div><div class=\"bibText\">{{obj[\'sitetitle\']}}.</div><div \nclass=\"bibText\">Date accessed : {{obj[\'dateaccessed\']}}</div></div></div><div ng-if=\"obj[\'type\']==\'book\'\" layout=\"row\" \nlayout-fill layout-padding flex=\"80\" flex-offset=\"10\" ng-click=\"vm.changeRef( obj.refID, vm.thisItem.parentObj )\" \nclass=\"pointerItem marginTop10\"><div layout=\"row\"><md-icon md-font-icon=\"icon-checkbox-marked-outline\" \nng-if=\"vm.thisItem.parentObj.content.references.indexOf(obj.refID)!=-1\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.thisItem.parentObj.content.references.indexOf(obj.refID)==-1\">\n</md-icon><div class=\"bibNum\">{{obj[\'refNum\']}}</div><div class=\"bibText\">{{obj[\'author\']}}</div><div class=\"bibText\">\n<u>{{obj[\'booktitle\']}}</u>.</div><div class=\"bibText\">{{obj[\'publisher\']}}.</div><div class=\"bibText\">\n{{obj[\'datepublished\']}}. Edition - {{obj[\'edition\']}}.</div><div class=\"bibText\">Page - {{obj[\'page\']}}.</div></div>\n</div><div ng-if=\"obj[\'type\']==\'mag\'\" layout=\"row\" layout-fill layout-padding flex=\"80\" flex-offset=\"10\" \nng-click=\"vm.changeRef( obj.refID, vm.thisItem.parentObj )\" class=\"pointerItem marginTop10\"><div layout=\"row\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-outline\" ng-if=\"vm.thisItem.parentObj.content.references.indexOf(obj.refID)!=-1\">\n</md-icon><md-icon md-font-icon=\"icon-checkbox-blank-outline\" \nng-if=\"vm.thisItem.parentObj.content.references.indexOf(obj.refID)==-1\"></md-icon><div class=\"bibNum\">{{obj[\'refNum\']}}\n</div><div class=\"bibText\">{{obj[\'author\']}}</div><div class=\"bibText\">{{obj[\'pagetitle\']}}.</div><div class=\"bibText\">\n{{obj[\'magpapername\']}}.</div><div class=\"bibText\">{{obj[\'datepublished\']}}.</div><div class=\"bibText\">\nPage - {{obj[\'page\']}}.</div></div></div><div ng-if=\"obj[\'type\']==\'enc\'\" layout=\"row\" layout-fill layout-padding \nflex=\"80\" flex-offset=\"10\" ng-click=\"vm.changeRef( obj.refID, vm.thisItem.parentObj )\" class=\"pointerItem marginTop10\">\n<div layout=\"row\"><md-icon md-font-icon=\"icon-checkbox-marked-outline\" \nng-if=\"vm.thisItem.parentObj.content.references.indexOf(obj.refID)!=-1\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.thisItem.parentObj.content.references.indexOf(obj.refID)==-1\">\n</md-icon><div class=\"bibNum\">{{obj[\'refNum\']}}</div><div class=\"bibText\">{{obj[\'author\']}}</div><div class=\"bibText\">\n{{obj[\'entryname\']}}.</div><div class=\"bibText\">{{obj[\'encname\']}}.</div><div class=\"bibText\">\nEdition - {{obj[\'edition\']}} {{obj[\'year\']}}.</div><div class=\"bibText\">Page - {{obj[\'page\']}}.</div></div></div></div>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-fill layout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" \nclass=\"send-button md-accent md-raised\">FINISHED EDITING</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/solver.html","<div flex=\"80\" flex-offset=\"10\" layout=\"row\"><md-list layout-fill><md-list-item layout=\"row\" flex=\"80\" \nflex-offset=\"10\" class=\"\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"greenIcon\" flex=\"10\"></md-icon>\n<div flex=\"90\">Solve in the browser with javascript</div></md-list-item><md-list-item layout=\"row\" flex=\"80\" \nflex-offset=\"10\" class=\"\" ng-click=\"vm.checkPython()\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nng-if=\"vm.cadwolf_usePython\" class=\"greenIcon\" flex=\"10\"></md-icon><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nng-if=\"!vm.cadwolf_usePython\" class=\"redIcon\" flex=\"10\"></md-icon><div flex=\"90\" ng-if=\"vm.cadwolf_usePython\">\nSolve on my computer with python - Version {{vm.pythonVersion}}</div><div flex=\"90\" ng-if=\"!vm.cadwolf_usePython\">\nSolve on my computer with python</div></md-list-item><md-list-item layout=\"row\" flex=\"80\" flex-offset=\"10\" class=\"\">\n<md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"redIcon\" flex=\"10\"></md-icon><div flex=\"90\">\nSolve on our server with Python (coming soon)</div></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/structureDialogs.html","<md-dialog aria-label=\"\" class=\"large-dialog\" id=\"modalDialog\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\"><h2 class=\"title\">\nEdit Structure</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel();\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div layout=\"row\" layout-fill flex=\"100\"><div layout=\"column\" flex=\"70\"><structure-content \nstruct=\"{{vm.currentItem}}\" worksheet=\"vm.cadwolf_worksheet\" currentsubitem=\"vm.currentSubItem\" editperm=\"vm.editPerm\">\n</structure-content></div><div layout=\"column\" flex=\"30\" layout-fill class=\"editRightSection\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/propertySection.html\'\"></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">\nFINISHED EDITING</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/successMessage.tmpl.html","<md-dialog class=\"contact-dialog\" id=\"messageDialog\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"successBackground md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between\"><span class=\"title\">Success</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"md-avatar avatar contact-avatar huge\"></md-icon><div \nclass=\"contact-name\">{{vm.messageObj.messageTitle}}</div></div></div></md-toolbar><md-dialog-content ms-scroll \nlayout-align=\"center center\"><div layout=\"row\" flex=\"100\" layout-fill layout-align=\"center center\">\n{{vm.messageObj.messageText}}</div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-fill layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vm.cancel();\" class=\"send-button successBackground md-raised\">OK</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/surfaceDialog.tmpl.html","<md-dialog aria-label=\"\" class=\"large-dialog dialogItem\" id=\"surfaceDialog\"><form name=\"contactForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\"><h2 class=\"title\">Edit Surface\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\" vm.cancelSurface();\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nng-include=\"\'app/main/apps/document/worksheet/views/templates/chartSpecVer/chartSpecVer.html\'\"></md-dialog-content>\n</form></md-dialog>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/tableObject.html","<div class=\"filler_holder\"><div class=\"filler_void\"></div><div class=\"filler_up\" ng-dblclick=\"vm.fillTable(obj, \'up\')\">\n</div><div class=\"filler_void\"></div><div class=\"filler_left\" ng-dblclick=\"vm.fillTable(obj, \'left\')\"></div><div \nclass=\"filler_void\"></div><div class=\"filler_right\" ng-dblclick=\"vm.fillTable(obj, \'right\')\"></div><div \nclass=\"filler_void\"></div><div class=\"filler_down\" ng-dblclick=\"vm.fillTable(obj, \'down\')\"></div><div \nclass=\"filler_void\"></div></div><div class=\"tableblock\" ng-if=\"vm.editPerm\"><table class=\"contentTable\" \nstyle=\"width: {{obj.width}}px; text-align:{{obj.content.tableAlign}}\"><caption ng-show=\"obj.content.captionOn\"><span \nng-show=\"!obj.content.captionEdit\" ng-dblclick=\"obj.content.captionEdit=true\">{{obj.content.caption}}</span> <span \nng-show=\"obj.content.captionEdit\"><input class=\"tableinput\" ng-enter=\"obj.content.captionEdit=false\" \nng-model=\"obj.content.caption\"></span></caption><tbody><tr><td class=\"empty\" width=\"15px\">&nbsp</td><td class=\"empty\" \nwidth=\"15px\">&nbsp</td><td ng-if=\"obj.content.rowLabels\" class=\"empty\" width=\"25px\">&nbsp</td><td \nng-repeat=\"thisEl in obj.content.data[0] track by $index\" class=\"empty\"><md-icon \nclass=\"iconDarkBlueBackground hoverMe\" md-font-icon=\"icon-minus-circle-outline\" \nng-dblclick=\"vm.deleteTableColumn( obj, $index );\"></md-icon><md-icon class=\"iconDarkBlueBackground hoverMe\" \nmd-font-icon=\"icon-plus-circle-outline\" ng-dblclick=\"vm.addTableColumn( obj, $index );\"></md-icon></td></tr><tr \ntable-show-col-headers numcols=\"obj.content.data[0].length\" tableid=\"obj.itemid\" showlabels=\"obj.content.colLabels\" \nng-if=\"obj.content.colLabels\"></tr><tr ng-repeat=\"row in obj.content.data track by $index\" class=\"normalrow\" \nng-init=\"row.showEdits=false\" ng-mouseover=\"row.showEdits=true\" ng-mouseout=\"row.showEdits=false\"><td class=\"empty\">\n<md-icon class=\"iconDarkBlueBackground hoverMe\" md-font-icon=\"icon-minus-circle-outline\" \nng-dblclick=\"vm.deleteTableRow( obj, $index );\"></md-icon></td><td class=\"empty\"><md-icon \nclass=\"iconDarkBlueBackground hoverMe\" md-font-icon=\"icon-plus-circle-outline\" \nng-dblclick=\"vm.addTableRow( obj, $index );\"></md-icon></td><td class=\"label\" ng-if=\"obj.content.rowLabels\" \nstyle=\"border:{{obj.content.borderWidth}}px solid #000\">{{$index}}</td><td toggle-table-data \nng-repeat=\"col in row track by $index\" style=\"border:{{obj.content.borderWidth}}px solid #000\"><div class=\"tableShow\" \nng-show=\"!obj.content.data[$parent.$index][$index][\'showEquation\']\" \nng-click=\"obj.content.currentRow=$parent.$index; obj.content.currentCol=$index;\" \nng-dblclick=\"obj.content.data[$parent.$index][$index][\'showEquation\']=true\"><span>\n{{obj[\'content\'][\'data\'][$parent.$index][$index][\'real\']}}</span> <span \nng-if=\"obj[\'content\'][\'data\'][$parent.$index][$index][\'imag\']!=0 &&\n                                     obj[\'content\'][\'data\'][$parent.$index][$index][\'imag\']!=\'\'\">\n+{{obj[\'content\'][\'data\'][$parent.$index][$index][\'imag\']}}i </span><span \nng-if=\"obj[\'content\'][\'data\'][$parent.$index][$index][\'units\']!=\'\'\">\n{{obj[\'content\'][\'data\'][$parent.$index][$index][\'units\']}}</span></div><div class=\"tableEquation\" \nng-show=\"obj.content.data[$parent.$index][$index][\'showEquation\']\" \nng-click=\"obj.content.currentRow=$parent.$index; obj.content.currentCol=$index;\"><input class=\"tableinput\" \nng-model=\"obj[\'content\'][\'data\'][$parent.$index][$index][\'equation\']\" \nng-enter=\"obj[\'content\'][\'data\'][$parent.$index][$index][\'showEquation\']=false;\n                                          obj[\'content\'][\'data\'][$parent.$index][$index][\'needsUpdateFlag\']=1; \n                                          obj.solveCol=$parent.$index; \n                                          obj.solveRow=$index; \n                                          vm.runEquationDigest();\">\n</div></td></tr></tbody></table></div><div class=\"tableblock\" ng-if=\"!vm.editPerm\"><table class=\"contenttable\" \nstyle=\"width: {{obj.width}}px; text-align:{{obj.content.tableAlign}}\"><caption ng-show=\"obj.content.captionOn\"><span \nng-show=\"!obj.content.captionEdit\">{{obj.content.caption}}</span></caption><tbody><tr table-show-col-headers \nnumcols=\"obj.content.data[0].length\" tableid=\"obj.itemid\" showlabels=\"obj.content.colLabels\" \nng-if=\"obj.content.colLabels\"></tr><tr ng-repeat=\"row in obj.content.data track by $index\" class=\"normalrow\" \nng-init=\"row.showEdits=false\"><td class=\"empty\"><div ng-show=\"false\" class=\"trdelete\">&nbsp</div></td><td \nclass=\"empty\"><div ng-show=\"false\" class=\"tradd\"></div></td><td class=\"label\" ng-if=\"obj.content.rowLabels\" \nstyle=\"border:{{obj.content.borderWidth}}px solid #000\">{{$index}}</td><td toggle-table-data \nng-repeat=\"col in row track by $index\" style=\"border:{{obj.content.borderWidth}}px solid #000\"><div class=\"tableShow\">\n<span>{{obj[\'content\'][\'data\'][$parent.$index][$index][\'equation\']}}</span></div></td></tr></tbody></table></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/tableOfContents.tmpl.html","<md-dialog-content ms-scroll><div><div layout=\"row\" flex=\"100\"><div flex=\"50\" class=\"md-body-2\">\nShow / Hide Table of Contents</div><md-input-container flex=\"50\"><label>Show / Hide</label><md-select \nng-model=\"vm.thisItem.fileInfo.item_data.tableOfContents.show\"><md-option value=\"1\">Show</md-option><md-option \nvalue=\"0\">Hide</md-option></md-select></md-input-container></div><div layout=\"row\" flex=\"100\"><div flex=\"50\" \nclass=\"md-body-2\">Items in table of contents</div><md-input-container flex=\"50\"><label>List type</label><md-select \nng-model=\"vm.thisItem.fileInfo.item_data.tableOfContents.showType\"><md-option value=\"headers\">Headers Only</md-option>\n<md-option value=\"types\">Selected Types</md-option><md-option value=\"select\">Selected Items</md-option></md-select>\n</md-input-container></div><div layout=\"row\" flex=\"100\" \nng-if=\"vm.thisItem.fileInfo.item_data.tableOfContents.showType==\'headers\'\"><div flex=\"50\" class=\"md-body-2\">\nLowest header to show</div><md-input-container flex=\"50\"><label>Lowest Header</label><md-select \nng-model=\"vm.thisItem.fileInfo.item_data.tableOfContents.showLevel\"><md-option value=\"H1\">H1</md-option><md-option \nvalue=\"H2\">H2</md-option><md-option value=\"H3\">H3</md-option><md-option value=\"H4\">H4</md-option><md-option value=\"H5\">\nH5</md-option></md-select></md-input-container></div><div layout=\"row\" flex=\"100\" \nng-if=\"vm.thisItem.fileInfo.item_data.tableOfContents.showType==\'types\'\"><div flex=\"90\" flex-offset=\"5\" \nlayout=\"column\" layout-fill layout-margin><div class=\"md-subtitle\" layout-fill>\nChoose the types of items to show in the table of contents</div><div flex=\"100\" layout-fill><md-input-container \nflex=\"30\" flex-offset=\"0\" layout-fill><md-checkbox \nng-model=\"vm.thisItem.fileInfo.item_data.tableOfContents.types.text\" aria-label=\"Text Items\"></md-checkbox>Text Items\n</md-input-container><md-input-container flex=\"30\" flex-offset=\"5\" layout-fill><md-checkbox \nng-model=\"vm.thisItem.fileInfo.item_data.tableOfContents.types.headers\" aria-label=\"Headers\"></md-checkbox>Headers\n</md-input-container><md-input-container flex=\"30\" flex-offset=\"5\" layout-fill><md-checkbox \nng-model=\"vm.thisItem.fileInfo.item_data.tableOfContents.types.equations\" aria-label=\"Equations\"></md-checkbox>\nEquations</md-input-container></div><div flex=\"100\" layout-fill><md-input-container flex=\"30\" flex-offset=\"0\" \nlayout-fill><md-checkbox ng-model=\"vm.thisItem.fileInfo.item_data.tableOfContents.types.symbolics\" \naria-label=\"Symbolic Equations\"></md-checkbox>Symbolic Equations</md-input-container><md-input-container flex=\"30\" \nflex-offset=\"5\" layout-fill><md-checkbox ng-model=\"vm.thisItem.fileInfo.item_data.tableOfContents.types.tables\" \naria-label=\"Tables\"></md-checkbox>Tables</md-input-container><md-input-container flex=\"30\" flex-offset=\"5\" layout-fill>\n<md-checkbox ng-model=\"vm.thisItem.fileInfo.item_data.tableOfContents.types.forLoops\" aria-label=\"For Loops\">\n</md-checkbox>For Loops</md-input-container></div><div flex=\"100\" layout-fill><md-input-container flex=\"30\" \nflex-offset=\"0\" layout-fill><md-checkbox ng-model=\"vm.thisItem.fileInfo.item_data.tableOfContents.types.whileLoops\" \naria-label=\"While Loops\"></md-checkbox>While Loops</md-input-container><md-input-container flex=\"30\" flex-offset=\"5\" \nlayout-fill><md-checkbox ng-model=\"vm.thisItem.fileInfo.item_data.tableOfContents.types.ifElseStatements\" \naria-label=\"If Else Statements\"></md-checkbox>If Else Statements</md-input-container><md-input-container flex=\"30\" \nflex-offset=\"5\" layout-fill><md-checkbox ng-model=\"vm.thisItem.fileInfo.item_data.tableOfContents.types.plots\" \naria-label=\"Plots\"></md-checkbox>Plots</md-input-container></div><div flex=\"100\" layout-fill><md-input-container \nflex=\"30\" flex-offset=\"0\" layout-fill><md-checkbox \nng-model=\"vm.thisItem.fileInfo.item_data.tableOfContents.types.surfaces\" aria-label=\"Surfaces\"></md-checkbox>Surfaces\n</md-input-container><md-input-container flex=\"30\" flex-offset=\"5\" layout-fill><md-checkbox \nng-model=\"vm.thisItem.fileInfo.item_data.tableOfContents.types.images\" aria-label=\"Images\"></md-checkbox>Images\n</md-input-container><md-input-container flex=\"30\" flex-offset=\"5\" layout-fill><md-checkbox \nng-model=\"vm.thisItem.fileInfo.item_data.tableOfContents.types.videos\" aria-label=\"Videos\"></md-checkbox>Videos\n</md-input-container></div></div></div><div layout=\"row\" flex=\"100\" \nng-if=\"vm.thisItem.fileInfo.item_data.tableOfContents.showType==\'select\'\"><div flex=\"90\" flex-offset=\"5\" \nlayout=\"column\" layout-fill layout-margin><div class=\"md-subtitle\" layout-fill>Select the items to appear in the TOC\n</div><div flex=\"100\" ng-repeat=\"thisObj in vm.thisItem.worksheet | orderBy:\'location\' track by thisObj.itemid\">\n<md-input-container flex=\"100\" layout-fill><md-checkbox ng-model=\"thisObj.showInTOC\" aria-label=\"thisObj.showInTOC\">\n</md-checkbox>{{thisObj.itemid}}</md-input-container></div></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill layout-align=\"end center\"><md-button \ntype=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">FINISHED EDITING</md-button></div>\n</md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/textBackground.tmpl.html","<md-dialog-content ms-scroll><div class=\"md-body-1\" class=\"fullWidth\">\nThe user can change the background color and font color of a text block to a number of various settings. Choose one of those settings from the drop down below and the text will appear as formatted below.\n</div><div layout=\"row\" flex=\"100\" layout=\"center center\" class=\"fullWidth\"><div layout=\"row\" flex=\"50\" \nflex-offset=\"25\"><md-input-container class=\"md-block\" class=\"fullWidth\"><label>Text Class</label><md-select \nng-model=\"vm.thisItem.content.textClass\"><md-option value=\"alert-primary\">Primary</md-option><md-option \nvalue=\"alert-secondary\">Secondary</md-option><md-option value=\"alert-success\">Success</md-option><md-option \nvalue=\"alert-danger\">Danger</md-option><md-option value=\"alert-warning\">Warning</md-option><md-option \nvalue=\"alert-info\">Info</md-option><md-option value=\"alert-light\">Light</md-option><md-option value=\"alert-dark\">Dark\n</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout=\"center center\" \nclass=\"fullWidth\"><div \nstyle=\"width: {{vm.thisItem.content.width}}px; \n					margin-top:{{vm.thisItem.content.margintop}}px; \n					margin-bottom:{{vm.thisItem.content.marginbottom}}px; \n					margin-left:{{vm.thisItem.content.marginleft}}px; \n					margin-right:{{vm.thisItem.content.marginright}}px;\n					text-align:{{vm.thisItem.content.alignment}}\" \n; ng-class=\"vm.thisItem.content.textClass\"><div data-ng-bind-html=\"vm.thisItem.content.text\"></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-fill \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.cancel();\" class=\"send-button md-accent md-raised\">\nFINISHED EDITING</md-button></div></md-dialog-actions>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/version.html","<div flex=\"80\" flex-offset=\"10\" layout=\"row\" ng-if=\"vm.editPerm\" layout-align=\"space-around center\"><md-button \ntype=\"submit\" ng-click=\"vm.newRevision( );\" class=\"send-button md-accent md-raised\">Create New Revision</md-button>\n<md-button type=\"submit\" ng-click=\"vm.newVersion( );\" class=\"send-button md-accent md-raised\">Create New Version\n</md-button></div><div flex=\"100\" layout=\"row\"><md-list layout-fill><md-list-item flex=\"80\" flex-offset=\"10\" \nclass=\"borderBottom\"><div flex=\"15\" class=\"md-title textCentered\">Version</div><div flex=\"15\" \nclass=\"md-title textCentered\">Revision</div><div flex=\"70\" class=\"md-title textCentered\">Name of Document</div>\n</md-list-item><div flex=\"80\" flex-offset=\"10\" class=\"\" \nng-repeat=\"version in vm.arrayFromNum(vm.versions[\'maxVersion\']) track by $index\"><md-list-item flex=\"100\" \nlayout=\"row\" class=\"hoverMe greyHoverBack borderBottom\" ng-repeat=\"revision in vm.versions[$index+1] track by $index\" \nng-class=\"{\'lightYellowBackground\' : $parent.$index+1 == vm.fileInfo.version && $index+1 == vm.fileInfo.revision }\" \nng-dblclick=\"vm.loadVersion( $parent.$index+1, $index+1 )\"><div flex=\"15\" class=\"textCentered\">{{$parent.$index+1}}\n</div><div flex=\"15\" class=\"textCentered\">{{$index+1}}</div><div flex=\"70\" class=\"textCentered\">\n{{vm.versions[$parent.$index+1][$index+1][\'name\']}}</div></md-list-item></div></md-list></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/whileLoopObject.html","<div flex=\"95\" flex-offset=\"5\" layout-fill><div flex=\"100\" layout=\"row\" layout-fill><div class=\"marginRight10\" \nlayout=\"row\"><div class=\"md-subhead marginTopRight10\">While</div><div \nng-repeat=\"blockSec in thisStruct.content.whileLoop.statementBlock track by $index\" layout=\"row\"><div \nng-show=\"$index>0\" layout=\"row\"><div ng-show=\"!thisStruct.content.whileLoop.statementBlock[$index][\'showOptions\']\" \nclass=\"marginTopRight10\" ng-click=\"thisStruct.content.whileLoop.statementBlock[$index][\'showOptions\']=true\">\n{{thisStruct.content.whileLoop.statementBlock[$index][\'blockOption\']}}</div><div class=\"whileloopandorvalue\" \nng-show=\"thisStruct.content.whileLoop.statementBlock[$index][\'showOptions\']\"><select class=\"whileloopconditionselect\" \nng-change=\" thisStruct.content.whileLoop.statementBlock[$index][\'showOptions\']=false; \n                                            thisStruct.content.needsBlockUpdate=1; \n                                            thisStruct.content.updateClass=\'itemneedsupdate\'; \n                                            thisStruct.content.whileLoop.statementBlock[$index][\'showOptions\']=false;\n                                            updateme.update=!updateme.update;\n                                            callRunEquationDigest();\" \nng-blur=\"thisStruct.content.whileLoop.statementBlock[$index][\'showOptions\']=false\" \nng-model=\"thisStruct.content.whileLoop.statementBlock[$index][\'blockOption\']\"><option value=\"||\">||</option><option \nvalue=\"&&\">&&</option></select></div></div><div layout=\"row\" class=\"bordered\"><div \nng-repeat=\"statementSec in blockSec track by $index\" layout=\"row\" class=\"marginLeft10\"><div class=\"statementOption\" \nng-show=\"!thisStruct.content.whileLoop.statementBlock[$parent.$index][$index][\'showOptions\']&&$index>0\" \nng-click=\"thisStruct.content.whileLoop.statementBlock[$parent.$index][$index][\'showOptions\']=true\">\n{{thisStruct.content.whileLoop.statementBlock[$parent.$index][$index][\'blockOption\']}}</div><div \nng-show=\"thisStruct.content.whileLoop.statementBlock[$parent.$index][$index][\'showOptions\']&&$index>0\"><select \nng-change=\" thisStruct.content.whileLoop.statementBlock[$parent.$index][$index][\'showOptions\']=false; \n                                                thisStruct.content.needsBlockUpdate=1; \n                                                thisStruct.content.updateClass=\'itemneedsupdate\';\n                                                thisStruct.content.whileLoop.statementBlock[$parent.$index][$index][\'showOptions\']=false; \n                                                updateme.update=!updateme.update;\n                                                callRunEquationDigest();\" \nng-blur=\"thisStruct.content.whileLoop.statementBlock[$parent.$index][$index][\'showOptions\']=false\" \nng-model=\"thisStruct.content.whileLoop.statementBlock[$parent.$index][$index][\'blockOption\']\"><option value=\"||\">||\n</option><option value=\"&&\">&&</option></select></div><div class=\"bordered marginRight10\" layout=\"row\" \nng-class=\"thisStruct.content.whileLoop.statementBlock[$parent.$index][$index].showClass\"><md-icon \nclass=\"marginRight10 pointerItem iconRedBackground\" ng-show=\"editperm\" \nng-click=\"callDeleteStatement(thisStruct.content.itemid, \'whileLoop\', $parent.$index, $index);  updateme.update=!updateme.update;\" \nmd-font-icon=\"icon-cancel\"></md-icon><div class=\"marginRight10\" layout=\"row\"><div layout=\"row\"><div \nng-show=\"!thisStruct.content.whileLoop.statementBlock[$parent.$index][$index][\'flagInputEdit\']\" \nng-dblclick=\"thisStruct.content.whileLoop.statementBlock[$parent.$index][$index][\'flagInputEdit\']=true\">\n{{thisStruct.content.whileLoop.statementBlock[$parent.$index][$index].flagText}}</div><input type=\"text\" \nng-show=\"thisStruct.content.whileLoop.statementBlock[$parent.$index][$index].flagInputEdit\" \nng-model=\"thisStruct.content.whileLoop.statementBlock[$parent.$index][$index].flagText\" \nng-enter=\"thisStruct.content.whileLoop.statementBlock[$parent.$index][$index][\'flagInputEdit\']=false;\n                                                  thisStruct.content.updateClass=\'itemneedsupdate\'; \n                                                  thisStruct.content.needsBlockUpdate=1; \n                                                  callRunEquationDigest();\">\n</div></div><div class=\"marginRight10\"><div class=\"whileloopconditionvalue\" \nng-show=\"!thisStruct.content.whileLoop.statementBlock[$parent.$index][$index].conditionInputEdit\" \nng-dblclick=\"thisStruct.content.whileLoop.statementBlock[$parent.$index][$index].conditionInputEdit=true\">\n{{thisStruct.content.whileLoop.statementBlock[$parent.$index][$index].conditionText}}</div><select \nclass=\"whileloopconditionselect\" \nng-show=\"thisStruct.content.whileLoop.statementBlock[$parent.$index][$index].conditionInputEdit\" \nng-change=\"thisStruct.content.whileLoop.statementBlock[$parent.$index][$index].conditionInputEdit=false;\n                                                   thisStruct.content.needsBlockUpdate=1; \n                                                   thisStruct.content.updateClass=\'itemneedsupdate\'; \n                                                   thisStruct.content.whileLoop.statementBlock[$parent.$index][$index][\'conditionInputEdit\']=false \n                                                   updateme.update=!updateme.update;\n                                                   callRunEquationDigest();\" \nng-blur=\"thisStruct.content.whileLoop.statementBlock[$parent.$index][$index].conditionInputEdit=false\" \nng-model=\"thisStruct.content.whileLoop.statementBlock[$parent.$index][$index].conditionText\"><option value=\"==\">==\n</option><option value=\"!=\">!=</option><option value=\"<\">&lt;</option><option value=\"<=\">&lt;=</option><option \nvalue=\">\">&gt;</option><option value=\">=\">&gt;=</option></select></div><div class=\"marginRight10\"><div \nclass=\"whileloopvaluewrapper\"><div class=\"whileloopvalue\" \nng-show=\"!thisStruct.content.whileLoop.statementBlock[$parent.$index][$index].dependentInputEdit\" \nng-dblclick=\"thisStruct.content.whileLoop.statementBlock[$parent.$index][$index].dependentInputEdit=true\">\n{{thisStruct.content.whileLoop.statementBlock[$parent.$index][$index].dependentText}}</div><input type=\"text\" \nclass=\"whileloopinput\" ng-model=\"thisStruct.content.whileLoop.statementBlock[$parent.$index][$index].dependentText\" \nng-show=\"thisStruct.content.whileLoop.statementBlock[$parent.$index][$index].dependentInputEdit\" \nng-enter=\"thisStruct.content.whileLoop.statementBlock[$parent.$index][$index].dependentInputEdit=false; \n                                                     thisStruct.content.needsBlockUpdate=1; \n                                                     thisStruct.content.updateClass=\'itemneedsupdate\'; \n                                                     callRunEquationDigest();\">\n</div></div></div><md-icon class=\"marginTop5Right5 pointerItem iconGreenBackground\" ng-show=\"editperm\" \nng-click=\"callAddStatement(thisStruct.content.itemid, \'whileLoop\', $parent.$index, $index); updateme.update=!updateme.update;\" \nmd-font-icon=\"icon-plus-circle-outline\"></md-icon></div></div><md-icon \nclass=\"marginLeft5 pointerItem iconGreenBackground\" ng-show=\"editperm\" \nng-click=\"callAddBlock(thisStruct.content.itemid, \'whileLoop\', $index); updateme.update=!updateme.update;\" \nmd-font-icon=\"icon-plus-box\"></md-icon></div></div></div><md-content class=\"content\" \nng-class=\"thisStruct.content.updateClass\" flex ms-scroll><div class=\"main_item\" \nng-repeat=\"subObj in worksheet | orderBy:\'order\' track by subObj.itemid\" ng-switch on=\"subObj.component_type_id\" \nng-if=\"subObj.content.parentid==thisStruct.content.itemid\" style=\"width:100%\"><div \nstyle=\"margin-top:{{subObj.margintop}}px; \n                        margin-bottom:{{subObj.marginbottom}}px; \n                        margin-left:{{subObj.marginleft}}px; \n                        margin-right:{{subObj.marginright}}px\">\n<div class=\"switchWrapper\" ng-switch-when=\"3\"><div class=\"equationblock\"><div class=\"eqshow\" id=\"{{subObj.itemid}}\">\n{{subObj.content.Equation.newEquation}}</div></div></div><div class=\"switchWrapper\" ng-switch-when=\"6\"><for-loop-object\n struct=\"{{subObj.itemid}}\" worksheet=\"worksheet\" editperm=\"editperm\" add-statement=\"callAddStatement\" \nadd-block=\"callAddBlock\" delete-statement=\"callDeleteStatement\" run-equation-digest=\"callRunEquationDigest\" \nupdateme=\"updateme\"></for-loop-object></div><div class=\"switchWrapper\" ng-switch-when=\"7\"><while-loop-object \nstruct=\"{{subObj.itemid}}\" worksheet=\"worksheet\" editperm=\"editPerm\" add-statement=\"callAddStatement\" \nadd-block=\"callAddBlock\" delete-statement=\"callDeleteStatement\" run-equation-digest=\"callRunEquationDigest\" \nupdateme=\"updateme\"></while-loop-object></div><div class=\"switchWrapper\" ng-switch-when=\"8\"><if-else-object \nstruct=\"{{subObj.itemid}}\" worksheet=\"worksheet\" editperm=\"editperm\" add-statement=\"callAddStatement\" \nadd-block=\"callAddBlock\" delete-statement=\"callDeleteStatement\" run-equation-digest=\"callRunEquationDigest\" \nupdateme=\"updateme\"></if-else-object></div></div></div></md-content></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/chartSpecVer/cameraSection.html","<md-list layout-align=\"space-between center\"><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>\nView X Position</label><input ng-model=\"vm.currentItem[\'content\'][\'Surface\'][\'Scene\'][\'position\'][\'x\']\" \nng-enter=\"vm.handleCameraChange()\"></md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" \nflex-offset=\"5\"><label>View Y Position</label><input \nng-model=\"vm.currentItem[\'content\'][\'Surface\'][\'Scene\'][\'position\'][\'y\']\" ng-enter=\"vm.handleCameraChange()\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>View Z Position\n</label><input ng-model=\"vm.currentItem[\'content\'][\'Surface\'][\'Scene\'][\'position\'][\'z\']\" \nng-enter=\"vm.handleCameraChange()\"></md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" \nflex-offset=\"5\"><label>Camera X Position</label><input \nng-model=\"vm.currentItem[\'content\'][\'Surface\'][\'Camera\'][\'position\'][\'x\']\" ng-enter=\"vm.handleCameraChange()\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>\nCamera Y Position</label><input ng-model=\"vm.currentItem[\'content\'][\'Surface\'][\'Camera\'][\'position\'][\'y\']\" \nng-enter=\"vm.handleCameraChange()\"></md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" \nflex-offset=\"5\"><label>Camera Z Position</label><input \nng-model=\"vm.currentItem[\'content\'][\'Surface\'][\'Camera\'][\'position\'][\'z\']\" ng-enter=\"vm.handleCameraChange()\">\n</md-input-container></md-list-item></md-list>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData.html","<md-content layout-fill ng-show=\"vm.currentItem.content.Surface.activeType==\'chartData\'\"><md-list layout-fill \nlayout-align=\"space-around center\" \nng-if=\"vm.currentChartItem[\'type\']==\'surface\' || \n				 vm.currentChartItem[\'type\']==\'pointCloud\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/surfaceData.html\'\"></md-list>\n<md-list layout-fill layout-align=\"space-around center\" ng-if=\"vm.currentChartItem[\'type\']==\'line\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/lineData.html\'\"></md-list><md-list\n layout-fill layout-align=\"space-around center\" ng-if=\"vm.currentChartItem[\'type\']==\'cube\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/cubeData.html\'\"></md-list><md-list\n layout-fill layout-align=\"space-around center\" \nng-if=\"vm.currentChartItem[\'type\'] == \'dodecahedron\' || \n				 vm.currentChartItem[\'type\'] == \'tetrahedron\' ||\n				 vm.currentChartItem[\'type\'] == \'octahedron\' ||\n				 vm.currentChartItem[\'type\'] == \'icosahedron\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/generalShapeData.html\'\"></md-list>\n<md-list layout-fill layout-align=\"space-around center\" ng-if=\"vm.currentChartItem[\'type\']==\'sphere\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/sphereData.html\'\"></md-list>\n<md-list layout-fill layout-align=\"space-around center\" ng-if=\"vm.currentChartItem[\'type\']==\'cylinder\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/cylinderData.html\'\"></md-list>\n<md-list layout-fill layout-align=\"space-around center\" ng-if=\"vm.currentChartItem[\'type\']==\'torus\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/torusData.html\'\"></md-list>\n<md-list layout-fill layout-align=\"space-around center\" ng-if=\"vm.currentChartItem[\'type\']==\'lathe\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/latheData.html\'\"></md-list>\n<md-list layout-fill layout-align=\"space-around center\" ng-if=\"vm.currentChartItem[\'type\']==\'plane\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/planeData.html\'\"></md-list>\n<md-list layout-fill layout-align=\"space-around center\" ng-if=\"vm.currentChartItem[\'type\']==\'grid\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/gridData.html\'\"></md-list><md-list\n layout-fill layout-align=\"space-around center\" ng-if=\"vm.currentChartItem[\'type\']==\'axis\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/axisData.html\'\"></md-list><md-list\n layout-fill layout-align=\"space-around center\" ng-if=\"vm.currentChartItem[\'type\']==\'arrow\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/arrowData.html\'\"></md-list>\n</md-content>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/chartSpecVer/chartSpecVer.html","<div id=\"chartEdit\" ng-style=\"{height:vm.currentItem.Surface.Chart_height, width:vm.currentItem.Surface.Chart_width}\">\n</div><div id=\"chartSpecVer\" layout=\"column\"><form name=\"chartForm\"><md-content><div layout=\"row\" flex=\"100\" \nlayout-margin class=\"borderBottom\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/chartSpecVer/editOption.html\'\"></div><div layout=\"row\" \nflex=\"100\" layout-margin layout-align=\"center start\" class=\"borderBottom\" \nng-if=\"vm.currentItem.content.Surface.activeType == \'chartData\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/chartSpecVer/dataSection.html\'\"></div><div layout=\"row\" \nflex=\"100\" layout-align=\"center start\" class=\"borderBottom\" \nng-if=\"vm.currentItem.content.Surface.activeType == \'chartData\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData.html\'\"></div><div layout=\"row\" \nflex=\"100\" layout-align=\"center start\" ng-if=\"vm.currentItem.content.Surface.activeType == \'chartCamera\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/chartSpecVer/cameraSection.html\'\"></div><div \nlayout=\"row\" flex=\"100\" layout-align=\"center start\" ng-if=\"vm.currentItem.content.Surface.activeType == \'chartLegend\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/chartSpecVer/legendSection.html\'\"></div></md-content>\n</form></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/chartSpecVer/dataSection.html","<div id=\"dataSection\" class=\"fullWidth\" layout=\"column\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.addSurfaceItem(\'dataSeries\')\">Add Dataset</md-button><md-list ng-cloak layout-fill class=\"listSection\">\n<md-list-item ng-repeat=\"obj in vm.currentItem[\'content\'][\'Surface\'][\'Chart_dataobj\'] track by obj.Format_id\" \nflex=\"100\" ng-class=\"{\'selected\' : vm.currentChartItem === obj}\"><div flex=\"90\" \nng-click=\"vm.currentChartItem=obj; vm.currentChartItemID=obj.Format_id\"><p>{{ obj.dataname}}</p></div><div flex=\"10\" \nng-click=\"vm.currentItem = vm.deleteSurfaceItem(vm.currentItem, obj.Format_id)\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\" aria-label=\"Delete Dataset\"></md-icon></div><md-divider ng-if=\"!$last\">\n</md-divider></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/chartSpecVer/editOption.html","<md-content layout-fill><md-list><md-list-item layout-fill><md-input-container flex=\"90\" flex-offset=\"5\"><label>\nEdit Type</label><md-select ng-model=\"vm.currentItem.content.Surface.activeType\"><md-option value=\"chartData\"><md-icon \nclass=\"marginRight10\" md-font-icon=\"icon-data\" aria-label=\"Chart Data\"></md-icon>Data</md-option><md-option \nvalue=\"chartCamera\"><md-icon class=\"marginRight10\" md-font-icon=\"icon-camcorder\" aria-label=\"Chart Camera\"></md-icon>\nCamera</md-option><md-option value=\"chartLegend\"><md-icon class=\"marginRight10\" md-font-icon=\"icon-key\" \naria-label=\"Chart Legend\"></md-icon>Legend</md-option></md-select></md-input-container></md-list-item></md-list>\n</md-content>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/chartSpecVer/legendSection.html","<md-list layout-align=\"space-between center\" layout-fill><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\">\n<label>Show Legend</label><md-select ng-model=\"vm.currentItem[\'content\'][\'Surface\'][\'Props\'][\'Legend\'][\'onOff\']\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n									   vm.currentItem.content.Surface\n									   vm.runEquationDigest();\">\n<md-option value=\"1\">True</md-option><md-option value=\"0\">False</md-option></md-select></md-input-container>\n</md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Colormap</label><md-select \nng-model=\"vm.currentItem[\'content\'][\'Surface\'][\'Props\'][\'Legend\'][\'colorMap\']\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n									   vm.runEquationDigest();\"><md-option value=\"rainbow\">\nRainbow</md-option><md-option value=\"cooltowarm\">Cool to Warm</md-option><md-option value=\"blackbody\">Black Body\n</md-option><md-option value=\"grayscale\">Grayscale</md-option></md-select></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Number of Colors</label><md-select \nng-model=\"vm.currentItem[\'content\'][\'Surface\'][\'Props\'][\'Legend\'][\'numberOfColors\']\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n									   vm.runEquationDigest();\"><md-option value=\"8\">8\n</md-option><md-option value=\"16\">16</md-option><md-option value=\"32\">32</md-option><md-option value=\"64\">64\n</md-option><md-option value=\"128\">128</md-option><md-option value=\"256\">256</md-option><md-option value=\"512\">512\n</md-option><md-option value=\"1024\">1024</md-option></md-select></md-input-container></md-list-item><md-list-item>\n<md-input-container flex=\"90\" flex-offset=\"5\"><label>Colormaps</label><md-select \nng-model=\"vm.currentItem[\'content\'][\'Surface\'][\'Props\'][\'divideColormap\']\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n									   vm.runEquationDigest();\"><md-option value=\"combined\">\nCombined</md-option><md-option value=\"separate\">Separate</md-option></md-select></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Number of Ticks</label><md-select \nng-model=\"vm.currentItem[\'content\'][\'Surface\'][\'Props\'][\'Legend\'][\'numTicks\']\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n									   vm.runEquationDigest();\"><md-option value=\"3\">3\n</md-option><md-option value=\"5\">5</md-option><md-option value=\"9\">9</md-option><md-option value=\"11\">11</md-option>\n<md-option value=\"13\">13</md-option><md-option value=\"15\">15</md-option><md-option value=\"17\">17</md-option>\n</md-select></md-input-container></md-list-item></md-list>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/multSpec/equationList.html","<div layout=\"row\" flex=\"100\" layout-fill ng-class=\"{\'selected\' : eqObj.itemid === currentsubitem.itemid }\"><div \nflex=\"5\"><md-icon md-font-icon=\"icon-sigma\" aria-label=\"Equation\"></md-icon></div><div flex=\"95\" layout=\"row\"><div \nclass=\"md-subhead paddingLeft10\" ng-if=\"!editperm\">{{eqObj[\'content\'][\'Equation\'][\'newEquation\']}}</div><div \nclass=\"md-subhead paddingLeft10\" ng-show=\"!eqObj.content.showEdit\" ng-if=\"editperm\" \nng-dblclick=\"eqObj.content.showEdit=!eqObj.content.showEdit\">{{eqObj[\'content\'][\'Equation\'][\'newEquation\']}}</div>\n<input type=\"text\" flex=\"100\" ng-if=\"editperm\" ng-show=\"eqObj.content.showEdit\" \nng-model=\"eqObj.content.Equation.newEquation\" \nng-enter=\"eqObj.content.Equation.Format_equation = eqObj.content.Equation.newEquation; \n                             eqObj.content.showEdit=false;\">\n</div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/multSpec/forLoopList.html","<div layout=\"row\" class=\"marginTopLeft10\" ng-class=\"{\'selected\' : structObj.itemid === currentsubitem.itemid }\"><div \nflex=\"5\"><md-icon md-font-icon=\"icon-redo-variant\" aria-label=\"For Loop\"></md-icon></div><div layout=\"row\" \nclass=\"pointerItem\" layout-align=\"start center\" ng-if=\"!currentsubitem.showNumbers\"><div layout=\"row\"><div \nclass=\"md-subhead marginLeft10\">for</div><div class=\"md-subhead marginLeft10\">\n{{structObj[\'content\'][\'forLoop\'][\'counter\']}}</div><div class=\"md-subhead marginLeft10\">=</div><div \nclass=\"md-subhead marginLeft10\">{{structObj[\'content\'][\'forLoop\'][\'startText\']}}</div></div><div layout=\"row\"><div \nclass=\"md-subhead marginLeft10\">While</div><div class=\"md-subhead marginLeft10\">\n{{structObj[\'content\'][\'forLoop\'][\'counter\']}}</div><div class=\"md-subhead marginLeft10\">\n{{structObj[\'content\'][\'forLoop\'][\'limitFactor\']}}</div><div class=\"md-subhead marginLeft10\">\n{{structObj[\'content\'][\'forLoop\'][\'stopText\']}}</div></div><div layout=\"row\"><div class=\"md-subhead marginLeft10\">\nIncrement by</div><div class=\"md-subhead marginLeft10\">{{structObj[\'content\'][\'forLoop\'][\'incrementText\']}}</div></div>\n</div><div layout=\"row\" class=\"pointerItem\" layout-align=\"start center\" ng-if=\"currentsubitem.showNumbers\"><div \nlayout=\"row\"><div class=\"md-subhead marginLeft10\">for</div><div class=\"md-subhead marginLeft10\">\n{{structObj[\'content\'][\'forLoop\'][\'counter\']}}</div><div class=\"md-subhead marginLeft10\">=</div><div \nclass=\"md-subhead marginLeft10\">{{structObj[\'content\'][\'forLoop\'][\'start\']}}</div></div><div layout=\"row\"><div \nclass=\"md-subhead marginLeft10\">While</div><div class=\"md-subhead marginLeft10\">\n{{structObj[\'content\'][\'forLoop\'][\'counter\']}}</div><div class=\"md-subhead marginLeft10\">\n{{structObj[\'content\'][\'forLoop\'][\'limitFactor\']}}</div><div class=\"md-subhead marginLeft10\">\n{{structObj[\'content\'][\'forLoop\'][\'stop\']}}</div></div><div layout=\"row\"><div class=\"md-subhead marginLeft10\">\nIncrement by</div><div class=\"md-subhead marginLeft10\">{{structObj[\'content\'][\'forLoop\'][\'increment\']}}</div></div>\n</div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/multSpec/ifElseList.html","<div class=\"marginTopLeft10\" layout=\"row\" ng-class=\"{\'selected\' : structObj.itemid === currentsubitem.itemid }\"><div \nflex=\"5\" class=\"marginTop5\"><md-icon md-font-icon=\"icon-refresh\" aria-label=\"If Else\"></md-icon></div><div \nlayout=\"row\" ng-if=\"!currentsubitem.showNumbers\"><div class=\"md-subhead paddingLeft10 marginTop5 marginRight10\">If\n</div><div ng-repeat=\"blockSec in structObj.content.ifelse.statementBlock track by $index\" layout=\"row\"><div \nclass=\"marginTopLeft10\" ng-show=\"$index > 0\">{{structObj.content.ifelse.statementBlock[$index][0][\'blockOption\']}}\n</div><div layout=\"row\" class=\"bordered marginLeft10\"><div ng-repeat=\"statementSec in blockSec track by $index\" \nlayout=\"row\" class=\"marginLeft10\"><div class=\"marginRight10\" ng-show=\"$index > 0\">\n{{structObj.content.ifelse.statementBlock[$parent.$index][$index][\'blockOption\']}}</div><div class=\"marginRight10\">\n{{structObj.content.ifelse.statementBlock[$parent.$index][$index].flagText}}</div><div class=\"marginRight10\">\n{{structObj.content.ifelse.statementBlock[$parent.$index][$index].conditionText}}</div><div class=\"marginRight10\">\n{{structObj.content.ifelse.statementBlock[$parent.$index][$index].dependentText}}</div></div></div></div></div><div \nlayout=\"row\" ng-if=\"currentsubitem.showNumbers\"><div class=\"md-subhead paddingLeft10 marginTopRight10\">If</div><div \nng-repeat=\"blockSec in structObj.content.ifelse.statementBlock track by $index\" layout=\"row\"><div \nclass=\"marginTopLeft10\" ng-show=\"$index > 0\">{{structObj.content.ifelse.statementBlock[$index][0][\'blockOption\']}}\n</div><div layout=\"row\" class=\"bordered marginLeft10\"><div ng-repeat=\"statementSec in blockSec track by $index\" \nlayout=\"row\" class=\"marginLeft10\"><div class=\"marginRight10\" ng-show=\"$index > 0\">\n{{structObj.content.ifelse.statementBlock[$parent.$index][$index][\'blockOption\']}}</div><div class=\"marginRight10\">\n{{structObj.content.ifelse.statementBlock[$parent.$index][$index].flagValue}}</div><div class=\"marginRight10\">\n{{structObj.content.ifelse.statementBlock[$parent.$index][$index].conditionText}}</div><div class=\"marginRight10\">\n{{structObj.content.ifelse.statementBlock[$parent.$index][$index].dependentValue}}</div></div></div></div></div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/multSpec/structureContentSection.html","<div layout=\"column\" flex=\"100\"><div class=\"md-3-line\" ng-if=\"structObj.component_type_id==\'6\'\" \nng-click=\"currentsubitem.itemid=structObj.itemid;\" layout=\"row\"><for-loop-list struct=\"structObj\" \nworksheet=\"worksheet\" currentsubitem=\"currentsubitem\" editperm=\"editperm\" layout-fill></for-loop-list></div><div \nclass=\"md-3-line\" ng-if=\"structObj.component_type_id==\'7\'\" ng-click=\"currentsubitem.itemid=structObj.itemid;\" \nlayout=\"row\"><while-loop-list struct=\"structObj\" worksheet=\"worksheet\" currentsubitem=\"currentsubitem\" \neditperm=\"editperm\" layout-fill></while-loop-list></div><div class=\"md-3-line\" \nng-if=\"structObj.component_type_id==\'8\'\" ng-click=\"currentsubitem.itemid=structObj.itemid; \" layout=\"row\"><if-else-list\n struct=\"structObj\" worksheet=\"worksheet\" currentsubitem=\"currentsubitem\" editperm=\"editperm\" layout-fill>\n</if-else-list></div><div layout=\"column\" ng-repeat=\"thisObj in worksheet | orderBy:\'order\' track by thisObj.itemid\" \nng-switch on=\"thisObj.component_type_id\" ng-if=\"thisObj.content.parentid==structObj.itemid\" class=\"subSection\"><div \nng-switch-when=\"3\" ng-click=\"currentsubitem.itemid=thisObj.itemid\" class=\"marginTop10\"><equation-list \neqobject=\"thisObj\" editperm=\"editperm\"></equation-list></div><div ng-switch-when=\"6\" class=\"marginTop10\">\n<structure-content struct=\"{{thisObj}}\" worksheet=\"worksheet\" editperm=\"editperm\" currentsubitem=\"currentsubitem\">\n</structure-content></div><div ng-switch-when=\"7\" class=\"marginTop10\"><structure-content struct=\"{{thisObj}}\" \nworksheet=\"worksheet\" editperm=\"editperm\" currentsubitem=\"currentsubitem\"></structure-content></div><div \nng-switch-when=\"8\" class=\"marginTop10\"><structure-content struct=\"{{thisObj}}\" worksheet=\"worksheet\" \neditperm=\"editperm\" currentsubitem=\"currentsubitem\"></structure-content></div></div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/multSpec/subItemButtons.html","<div layout=\"row\" flex=\"100\" class=\"borderBottom\"><div ng-repeat=\"thisItem in vm.cadwolf_worksheet track by $index\" \nlayout=\"row\"><md-button ng-if=\"thisItem[\'itemid\']==vm.currentSubItem.itemid\" class=\"md-icon-button\" \naria-label=\"Switch Number / String View\" ng-click=\"vm.currentSubItem.showNumbers=!vm.currentSubItem.showNumbers;\">\n<md-icon md-font-icon=\"icon-monitor-multiple\"></md-icon><md-tooltip md-direction=\"bottom\">Switch Number / String View\n</md-tooltip></md-button><md-button ng-if=\"thisItem[\'itemid\']==vm.currentSubItem.itemid\" class=\"md-icon-button\" \naria-label=\"Add Equation\" \nng-click=\"vm.addItem(\'Equation\', { parentid:(thisItem[\'component_type_id\']==3) ? thisItem[\'content\'][\'parentid\']:thisItem[\'itemid\']  } )\">\n<md-icon md-font-icon=\"icon-sigma\"></md-icon><md-tooltip md-direction=\"bottom\">Add Equation</md-tooltip></md-button>\n<md-button ng-if=\"thisItem[\'itemid\']==vm.currentSubItem.itemid\" class=\"md-icon-button\" aria-label=\"Add For Loop\" \nng-click=\"vm.addItem(\'For Loop\', { parentid:(thisItem[\'component_type_id\']==3) ? thisItem[\'content\'][\'parentid\']:thisItem[\'itemid\']  } )\">\n<md-icon md-font-icon=\"icon-redo-variant\"></md-icon><md-tooltip md-direction=\"bottom\">Add For Loop</md-tooltip>\n</md-button><md-button ng-if=\"thisItem[\'itemid\']==vm.currentSubItem.itemid\" class=\"md-icon-button\" \naria-label=\"Add While Loop\" \nng-click=\"vm.addItem(\'While Loop\', { parentid:(thisItem[\'component_type_id\']==3) ? thisItem[\'content\'][\'parentid\']:thisItem[\'itemid\']  } )\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-direction=\"bottom\">Add While Loop</md-tooltip>\n</md-button><md-button ng-if=\"thisItem[\'itemid\']==vm.currentSubItem.itemid\" class=\"md-icon-button\" \naria-label=\"Add If Else\" \nng-click=\"vm.addItem(\'If Else\', { parentid:(thisItem[\'component_type_id\']==3) ? thisItem[\'content\'][\'parentid\']:thisItem[\'itemid\']  } )\">\n<md-icon md-font-icon=\"icon-cube-unfolded\"></md-icon><md-tooltip md-direction=\"bottom\">Add If Else</md-tooltip>\n</md-button><md-button ng-if=\"thisItem[\'itemid\']==vm.currentSubItem.itemid\" class=\"md-icon-button\" \naria-label=\"Delete Item\" ng-click=\"vm.deleteItem( thisItem )\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip \nmd-direction=\"bottom\">Delete Item</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/multSpec/whileLoopList.html","<div class=\"marginTopLeft10\" layout=\"row\" ng-class=\"{\'selected\' : structObj.itemid === currentsubitem.itemid }\"><div \nflex=\"5\"><md-icon md-font-icon=\"icon-refresh\" aria-label=\"While Loop\"></md-icon></div><div layout=\"row\" \nng-if=\"!currentsubitem.showNumbers\"><div class=\"md-subhead marginLeft10\">While</div><div \nng-repeat=\"blockSec in structObj.content.whileLoop.statementBlock track by $index\" layout=\"row\" class=\"marginLeft10\">\n<div class=\"md-subhead marginTopRight10\" ng-show=\"$index>0\">\n{{structObj.content.whileLoop.statementBlock[$index][0][\'blockOption\']}}</div><div layout=\"row\" class=\"bordered\"><div \nng-repeat=\"statementSec in blockSec track by $index\" layout=\"row\" class=\"marginLeft10 md-subhead\"><div \nng-show=\"$index>0\" class=\"md-subhead marginTopRight10\">\n{{structObj.content.whileLoop.statementBlock[$parent.$index][$index][\'blockOption\']}}</div><div layout=\"row\" \nclass=\"bordered\"><div class=\"marginLeft10 md-subhead\">\n{{structObj.content.whileLoop.statementBlock[$parent.$index][$index].flagText}}</div><div \nclass=\"marginLeft10 md-subhead\">{{structObj.content.whileLoop.statementBlock[$parent.$index][$index].conditionText}}\n</div><div class=\"marginLeft10 md-subhead\">\n{{structObj.content.whileLoop.statementBlock[$parent.$index][$index].dependentText}}</div></div></div></div></div>\n</div><div layout=\"row\" ng-if=\"currentsubitem.showNumbers\"><div class=\"md-subhead marginTopLeft10\">While</div><div \nng-repeat=\"blockSec in structObj.content.whileLoop.statementBlock track by $index\" layout=\"row\" class=\"marginLeft10\">\n<div class=\"md-subhead marginTopRight10\" ng-show=\"$index>0\">\n{{structObj.content.whileLoop.statementBlock[$index][0][\'blockOption\']}}</div><div layout=\"row\" class=\"bordered\"><div \nng-repeat=\"statementSec in blockSec track by $index\" layout=\"row\" class=\"marginLeft10 md-subhead\"><div \nng-show=\"$index>0\" class=\"md-subhead marginTopRight10\">\n{{structObj.content.whileLoop.statementBlock[$parent.$index][$index][\'blockOption\']}}</div><div layout=\"row\" \nclass=\"bordered\"><div class=\"marginLeft10 md-subhead\">\n{{structObj.content.whileLoop.statementBlock[$parent.$index][$index].flagValue}}</div><div \nclass=\"marginLeft10 md-subhead\">{{structObj.content.whileLoop.statementBlock[$parent.$index][$index].conditionText}}\n</div><div class=\"marginLeft10 md-subhead\">\n{{structObj.content.whileLoop.statementBlock[$parent.$index][$index].dependentValue}}</div></div></div></div></div>\n</div></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/plotSpecVer/areaData.html","<md-tabs layout-fill><md-tab label=\"Data\"><md-content layout-fill><md-list layout-margin><md-list-item layout-fill>\n<md-input-container><label>Area Name</label><input ng-model=\"vm.currentChartItem.dataname\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item ng-if=\"vm.currentItem.content.Plot.errorFlag==1\"><div \nclass=\"md-caption errorText\">{{vm.currentItem.content.Plot.errors[0]}}</div></md-list-item><md-list-item layout-fill>\n<md-input-container><label>X Data</label><input ng-model=\"vm.currentChartItem.xdata_name\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item layout-fill><md-input-container><label>Y Data</label><input \nng-model=\"vm.currentChartItem.ydata_name\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item layout-fill><md-input-container layout-fill><label>X Axis</label>\n<md-select ng-model=\"vm.currentChartItem.xaxis\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                   vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                   vm.runEquationDigest();\">\n<md-option ng-repeat=\"axisOption in vm.currentItem[\'content\'][\'Plot\'][\'Chart_xaxesobj\']\" \nvalue=\"{{axisOption.Axis_num}}\">{{axisOption.Axis_name}}</md-option></md-select></md-input-container></md-list-item>\n<md-list-item layout-fill><md-input-container layout-fill><label>Y Axis</label><md-select \nng-model=\"vm.currentChartItem.yaxis\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                   vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                   vm.runEquationDigest();\">\n<md-option ng-repeat=\"axisOption in vm.currentItem[\'content\'][\'Plot\'][\'Chart_yaxesobj\']\" \nvalue=\"{{axisOption.Axis_num}}\">{{axisOption.Axis_name}}</md-option></md-select></md-input-container></md-list-item>\n<md-list-item layout-fill><md-input-container layout-fill><label>Stacking</label><md-select \nng-model=\"vm.currentItem[\'content\'][\'Plot\'][\'Chart_stack\']\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                     vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                     vm.runEquationDigest();\">\n<md-option value=\"none\">None</md-option><md-option value=\"normal\">Normal</md-option><md-option value=\"percent\">Percent\n</md-option></md-select></md-input-container></md-list-item></md-list></md-content></md-tab><md-tab label=\"Appearance\">\n<md-content layout-fill><md-list layout-margin><md-list-item layout-fill><md-input-container><md-checkbox \nng-model=\"vm.currentChartItem.data_datalabels\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                      vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                      vm.runEquationDigest();\" \naria-label=\"Data Labels\">Data Labels</md-checkbox></md-input-container></md-list-item><md-list-item layout-fill>\n<md-input-container><label>Label Color</label><input ng-model=\"vm.currentChartItem.data_labelColor\" \nng-enter=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item layout-fill><md-input-container><label>Line Color</label><input \nng-model=\"vm.currentChartItem.color\" \nng-enter=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item layout-fill><md-input-container><label>Line Width</label><input \nng-model=\"vm.currentChartItem.lineWidth\" \nng-enter=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item layout-fill><md-input-container><md-checkbox \nng-model=\"vm.currentChartItem.data_pointmarkers\" aria-label=\"Point Markers\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                      vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                      vm.runEquationDigest();\">\nPoint Markers</md-checkbox></md-input-container></md-list-item><md-list-item layout-fill><md-input-container><label>\nFill Color</label><input ng-model=\"currentDataset.fillColor\" \nng-enter=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item layout-fill><md-input-container layout-fill><label>Data Symbol\n</label><md-select ng-model=\"vm.currentChartItem.symbol\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                     vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                     vm.runEquationDigest();\">\n<md-option value=\"circle\">Circle</md-option><md-option value=\"square\">Square</md-option><md-option value=\"triangle\">\nTriangle</md-option><md-option value=\"triangle-down\">Triangle-Down</md-option><md-option value=\"diamond\">Diamond\n</md-option></md-select></md-input-container></md-list-item><md-list-item layout-fill><md-input-container><label>\nSymbol Size</label><input ng-model=\"vm.currentChartItem.data_markersize\" \nng-enter=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Size</label><input \nng-model=\"vm.currentChartItem.data_labelSize\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Color</label><input \nng-model=\"vm.currentChartItem.data_labelColor\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Distance</label><input \nng-model=\"vm.currentChartItem.data_labelDistance\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Border</label><input \nng-model=\"vm.currentChartItem.data_labelBorderWidth\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Border Color</label><input \nng-model=\"vm.currentChartItem.data_labelBorderColor\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>BG Color</label><input \nng-model=\"vm.currentChartItem.data_labelBackgroundColor\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Border Radius</label><input \nng-model=\"vm.currentChartItem.data_labelBorderRadius\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Border Padding</label><input \nng-model=\"vm.currentChartItem.data_labelBorderPadding\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Rotation</label><input \nng-model=\"vm.currentChartItem.data_labelRotation\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label X</label><input \nng-model=\"vm.currentChartItem.data_labelX\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Y</label><input \nng-model=\"vm.currentChartItem.data_labelY\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><md-checkbox \nng-model=\"vm.currentChartItem.showInLegend\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                  vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                  vm.runEquationDigest();\" \naria-label=\"Show in Legend\">Show in Legend</md-checkbox></md-input-container></md-list-item></md-list></md-content>\n</md-tab></md-tabs>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/plotSpecVer/bandEdit.html","<md-content class=\"chartEditSection\"><md-list layout-margin><md-list-item><md-input-container layout-fill><label>\nStart Location</label><input ng-model=\"vm.currentChartItem.Band_start\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1; vm.runEquationDigest();\"></md-input-container></md-list-item>\n<md-list-item><md-input-container layout-fill><label>End Location</label><input \nng-model=\"vm.currentChartItem.Band_end\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1; vm.runEquationDigest();\"></md-input-container></md-list-item>\n<md-list-item><md-input-container layout-fill><label>X Axis</label><md-select ng-model=\"vm.currentChartItem.Axis_id\" \nng-change=\"vm.currentDataset.needsUpdateFlag=1; \n                                       vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                       vm.runEquationDigest();\">\n<md-option ng-repeat=\"axisOption in vm.currentItem[\'content\'][\'Plot\'][\'Chart_xaxesobj\']\" \nvalue=\"{{axisOption.Format_id}}\">{{axisOption.Axis_name}}</md-option></md-select></md-input-container></md-list-item>\n<md-list-item><md-input-container layout-fill><label>Y Axis</label><md-select ng-model=\"vm.currentChartItem.Axis_id\" \nng-change=\"vm.currentDataset.needsUpdateFlag=1; \n                                       vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                       vm.runEquationDigest();\">\n<md-option ng-repeat=\"axisOption in vm.currentItem[\'content\'][\'Plot\'][\'Chart_yaxesobj\']\" \nvalue=\"{{axisOption.Format_id}}\">{{axisOption.Axis_name}}</md-option></md-select></md-input-container></md-list-item>\n<md-list-item><md-input-container layout-fill><label>Color</label><input ng-model=\"vm.currentChartItem.color\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1; vm.runEquationDigest();\"></md-input-container></md-list-item>\n</md-list></md-content>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/plotSpecVer/bandSection.html","<div id=\"dataSection\" class=\"fullWidth\" layout=\"column\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.addChartItem(obj, \'band\')\">Add Band</md-button><md-list ng-cloak layout-fill class=\"listSection\">\n<md-list-item ng-repeat=\"obj in vm.currentItem[\'content\'][\'Plot\'][\'Chart_bandsobj\'] track by obj.Format_id\" flex=\"100\" \nng-class=\"{\'selected\' : vm.currentChartItem === obj}\"><div flex=\"90\" \nng-click=\"vm.currentChartItem=obj; vm.currentChartItemID=obj.Format_id\"><p>{{ obj.Band_name}}</p></div><div flex=\"10\" \nng-click=\"vm.deleteChartItem(vm.currentItem, obj)\"><md-icon md-font-icon=\"icon-close-circle-outline\" \naria-label=\"Delete Band\"></md-icon></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/plotSpecVer/bubbleData.html","<md-tabs layout-fill><md-tab label=\"Data\"><md-content layout-fill><md-list layout-margin><md-list-item>\n<md-input-container layout-fill><label>Name</label><input ng-model=\"vm.currentChartItem.dataname\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item ng-if=\"vm.currentItem.content.Plot.errorFlag==1\"><div \nclass=\"md-caption errorText\">{{vm.currentItem.content.Plot.errors[0]}}</div></md-list-item><md-list-item>\n<md-input-container layout-fill><label>X Data</label><input ng-model=\"vm.currentChartItem.xdata_name\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Y Data</label><input \nng-model=\"vm.currentChartItem.ydata_name\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Z Data</label><input \nng-model=\"vm.currentChartItem.zdata_name\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>X Axis</label><md-select \nng-model=\"vm.currentChartItem.xaxis\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                   vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                   vm.runEquationDigest();\">\n<md-option ng-repeat=\"axisOption in vm.currentItem[\'content\'][\'Plot\'][\'Chart_xaxesobj\']\" \nvalue=\"{{axisOption.Axis_num}}\">{{axisOption.Axis_name}}</md-option></md-select></md-input-container></md-list-item>\n<md-list-item><md-input-container layout-fill><label>Y Axis</label><md-select ng-model=\"vm.currentChartItem.yaxis\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                   vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                   vm.runEquationDigest();\">\n<md-option ng-repeat=\"axisOption in vm.currentItem[\'content\'][\'Plot\'][\'Chart_yaxesobj\']\" \nvalue=\"{{axisOption.Axis_num}}\">{{axisOption.Axis_name}}</md-option></md-select></md-input-container></md-list-item>\n</md-list></md-content></md-tab><md-tab label=\"Appearance\"><md-content layout-fill><md-list layout-margin>\n<md-list-item><md-input-container layout-fill><md-checkbox ng-model=\"vm.currentChartItem.data_datalabels\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                      vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                      vm.runEquationDigest();\" \naria-label=\"Data Labels\">Data Labels</md-checkbox></md-input-container></md-list-item><md-list-item \nclass=\"marginTop20\"><md-input-container layout-fill><label>Label Color</label><input \nng-model=\"vm.currentChartItem.data_labelColor\" \nng-enter=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Fill Color</label><input \nng-model=\"currentDataset.fillColor\" \nng-enter=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Size</label><input \nng-model=\"vm.currentChartItem.data_labelSize\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Color</label><input \nng-model=\"vm.currentChartItem.data_labelColor\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Distance</label><input \nng-model=\"vm.currentChartItem.data_labelDistance\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Border</label><input \nng-model=\"vm.currentChartItem.data_labelBorderWidth\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Border Color</label><input \nng-model=\"vm.currentChartItem.data_labelBorderColor\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>BG Color</label><input \nng-model=\"vm.currentChartItem.data_labelBackgroundColor\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Border Radius</label><input \nng-model=\"vm.currentChartItem.data_labelBorderRadius\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Border Padding</label><input \nng-model=\"vm.currentChartItem.data_labelBorderPadding\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Rotation</label><input \nng-model=\"vm.currentChartItem.data_labelRotation\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label X</label><input \nng-model=\"vm.currentChartItem.data_labelX\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Y</label><input \nng-model=\"vm.currentChartItem.data_labelY\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><md-checkbox \nng-model=\"vm.currentChartItem.showInLegend\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                  vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                  vm.runEquationDigest();\" \naria-label=\"Show in Legend\">Show in Legend</md-checkbox></md-input-container></md-list-item></md-list></md-content>\n</md-tab></md-tabs>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/plotSpecVer/columnData.html","<md-tabs layout-fill><md-tab label=\"Data\"><md-content layout-fill><md-list layout-margin><md-list-item>\n<md-input-container layout-fill><label>Name</label><input ng-model=\"vm.currentChartItem.dataname\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Labels</label><input \nng-model=\"vm.currentChartItem.Chart_Labeltext\" \nng-enter=\"vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item ng-if=\"vm.currentItem.content.Plot.errorFlag==1\"><div \nclass=\"md-caption errorText\">{{vm.currentItem.content.Plot.errors[0]}}</div></md-list-item><md-list-item>\n<md-input-container layout-fill><label>X Data</label><input ng-model=\"vm.currentChartItem.xdata_name\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Y Data</label><input \nng-model=\"vm.currentChartItem.ydata_name\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Y Axis</label><md-select \nng-model=\"vm.currentChartItem.yaxis\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                   vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                   vm.runEquationDigest();\">\n<md-option ng-repeat=\"axisOption in vm.currentItem[\'content\'][\'Plot\'][\'Chart_yaxesobj\']\" \nvalue=\"{{axisOption.Axis_num}}\">{{axisOption.Axis_name}}</md-option></md-select></md-input-container></md-list-item>\n<md-list-item><md-input-container layout-fill><label>Stacking</label><md-select \nng-model=\"vm.currentItem[\'content\'][\'Plot\'][\'Chart_stack\']\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                     vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                     vm.runEquationDigest();\">\n<md-option value=\"none\">None</md-option><md-option value=\"normal\">Normal</md-option><md-option value=\"percent\">Percent\n</md-option></md-select></md-input-container></md-list-item></md-list></md-content></md-tab><md-tab label=\"Appearance\">\n<md-content layout-fill><md-list layout-margin><md-list-item><md-input-container layout-fill><md-checkbox \nng-model=\"vm.currentChartItem.data_datalabels\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                      vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                      vm.runEquationDigest();\" \naria-label=\"Data Labels\">Data Labels</md-checkbox></md-input-container></md-list-item><md-list-item \nclass=\"marginTop20\"><md-input-container layout-fill><label>Label Color</label><input \nng-model=\"vm.currentChartItem.data_labelColor\" \nng-enter=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Fill Color</label><input \nng-model=\"vm.currentChartItem.color\" \nng-enter=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Mono Color</label><input \nng-model=\"vm.currentItem.content.Plot.Chart_monoColor\" ng-enter=\"vm.setMonoColor();\"></md-input-container>\n</md-list-item><md-list-item><md-input-container layout-fill><label>Label Size</label><input \nng-model=\"vm.currentChartItem.data_labelSize\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Border</label><input \nng-model=\"vm.currentChartItem.data_labelBorderWidth\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Border Color</label><input \nng-model=\"vm.currentChartItem.data_labelBorderColor\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>BG Color</label><input \nng-model=\"vm.currentChartItem.data_labelBackgroundColor\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Border Radius</label><input \nng-model=\"vm.currentChartItem.data_labelBorderRadius\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Border Padding</label><input \nng-model=\"vm.currentChartItem.data_labelBorderPadding\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Rotation</label><input \nng-model=\"vm.currentChartItem.data_labelRotation\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label X</label><input \nng-model=\"vm.currentChartItem.data_labelX\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Y</label><input \nng-model=\"vm.currentChartItem.data_labelY\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><md-checkbox \nng-model=\"vm.currentChartItem.showInLegend\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                  vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                  vm.runEquationDigest();\" \naria-label=\"Show in Legend\">Show in Legend</md-checkbox></md-input-container></md-list-item></md-list></md-content>\n</md-tab></md-tabs>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/plotSpecVer/dataSection.html","<div id=\"dataSection\" class=\"fullWidth\" layout=\"column\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.addChartItem(obj, \'dataSeries\')\">Add Dataset</md-button><md-list ng-cloak layout-fill class=\"listSection\">\n<md-list-item ng-repeat=\"obj in vm.currentItem[\'content\'][\'Plot\'][\'Chart_dataobj\'] track by obj.Format_id\" flex=\"100\" \nng-class=\"{\'selected\' : vm.currentChartItem === obj}\"><div flex=\"90\" \nng-click=\"vm.currentChartItem=obj; vm.currentChartItemID=obj.Format_id\"><p>{{ obj.dataname}}</p></div><div flex=\"10\" \nng-click=\"vm.deleteChartItem(vm.currentItem, obj)\"><md-icon md-font-icon=\"icon-close-circle-outline\" \naria-label=\"Delete Dataset\"></md-icon></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/plotSpecVer/formatSection.html","<md-list layout-align=\"space-around center\"><md-list-item layout-align=\"end stretch\"><md-input-container layout-fill>\n<md-checkbox ng-model=\"vm.currentItem.content.Plot.Title_onoff\" \nng-change=\"vm.currentItem.content.Plot.needsUpdateFlag=1; vm.runEquationDigest();\" aria-label=\"Plot Title\">Title\n</md-checkbox></md-input-container></md-list-item><md-list-item layout-align=\"end stretch\" class=\"marginTop20\">\n<md-input-container layout-fill><label>Title Text</label><input ng-model=\"vm.currentItem.content.Plot.Title_text\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1; vm.runEquationDigest();\"></md-input-container></md-list-item>\n<md-list-item layout-align=\"end stretch\"><md-input-container layout-fill><md-checkbox \nng-model=\"vm.currentItem.content.Plot.Subtitle_onoff\" \nng-change=\"vm.currentItem.content.Plot.needsUpdateFlag=1; vm.runEquationDigest();\" aria-label=\"Plot Subtitle\">Subtitle\n</md-checkbox></md-input-container></md-list-item><md-list-item layout-align=\"end stretch\" class=\"marginTop20\">\n<md-input-container layout-fill><label>Subtitle Text</label><input \nng-model=\"vm.currentItem.content.Plot.Subtitle_text\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1; vm.runEquationDigest();\"></md-input-container></md-list-item>\n<md-list-item layout-align=\"end stretch\"><md-input-container layout-fill><label>Plot Width</label><input \nng-model=\"vm.currentItem.content.Plot.Chart_width\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1; vm.runEquationDigest();\"></md-input-container></md-list-item>\n<md-list-item layout-align=\"end stretch\"><md-input-container layout-fill><label>Plot Height</label><input \nng-model=\"vm.currentItem.content.Plot.Chart_height\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1; vm.runEquationDigest();\"></md-input-container></md-list-item>\n<md-list-item layout-align=\"end stretch\"><md-input-container layout-fill><label>Margin Left</label><input \nng-model=\"vm.currentItem.content.Plot.Chart_marginleft\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1; vm.runEquationDigest();\"></md-input-container></md-list-item>\n<md-list-item layout-align=\"end stretch\"><md-input-container layout-fill><label>Margin Right</label><input \nng-model=\"vm.currentItem.content.Plot.Chart_marginright\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1; vm.runEquationDigest();\"></md-input-container></md-list-item>\n<md-list-item layout-align=\"end stretch\"><md-input-container layout-fill><label>Margin Top</label><input \nng-model=\"vm.currentItem.content.Plot.Chart_margintop\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1; vm.runEquationDigest();\"></md-input-container></md-list-item>\n<md-list-item layout-align=\"end stretch\"><md-input-container layout-fill><label>Margin Bottom</label><input \nng-model=\"vm.currentItem.content.Plot.Chart_marginbottom\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1; vm.runEquationDigest();\"></md-input-container></md-list-item>\n<md-list-item layout-align=\"end stretch\"><md-input-container layout-fill><md-checkbox \nng-model=\"vm.currentItem.content.Plot.Legend_onoff\" \nng-change=\"vm.currentItem.content.Plot.needsUpdateFlag=1; vm.runEquationDigest();\" aria-label=\"Plot Title\">\nLegend On/Off</md-checkbox></md-input-container></md-list-item><md-list-item layout-align=\"end stretch\" \nclass=\"marginTop20\"><md-input-container layout-fill><label>Legend Layout</label><md-select \nng-model=\"vm.currentItem.content.Plot.Legend_layout\" \nng-change=\"vm.currentItem.content.Plot.needsUpdateFlag=1; vm.runEquationDigest();\"><md-option value=\"vertical\">Vertical\n</md-option><md-option value=\"horizontal\">Horizontal</md-option></md-select></md-input-container></md-list-item>\n<md-list-item layout-align=\"end stretch\"><md-input-container layout-fill><label>Legend Alignment</label><md-select \nng-model=\"vm.currentItem.content.Plot.Legend_align\" \nng-change=\"vm.currentItem.content.Plot.needsUpdateFlag=1; vm.runEquationDigest();\"><md-option value=\"left\">Left\n</md-option><md-option value=\"right\">Right</md-option><md-option value=\"center\">Center</md-option></md-select>\n</md-input-container></md-list-item><md-list-item layout-align=\"end stretch\"><md-input-container layout-fill><label>\nLegend Vertical Alignment</label><md-select ng-model=\"vm.currentItem.content.Plot.Legend_verticalalign\" \nng-change=\"vm.currentItem.content.Plot.needsUpdateFlag=1; vm.runEquationDigest();\"><md-option value=\"top\">Top\n</md-option><md-option value=\"middle\">Center</md-option><md-option value=\"bottom\">Bottom</md-option></md-select>\n</md-input-container></md-list-item><md-list-item layout-align=\"end stretch\"><md-input-container layout-fill><label>\nX Offset</label><input ng-model=\"vm.currentItem.content.Plot.Legend_xoffset\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1; vm.runEquationDigest();\"></md-input-container></md-list-item>\n<md-list-item layout-align=\"end stretch\"><md-input-container layout-fill><label>Y Offset</label><input \nng-model=\"vm.currentItem.content.Plot.Legend_yoffset\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1; vm.runEquationDigest();\"></md-input-container></md-list-item>\n</md-list>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/plotSpecVer/heatmapData.html","<md-tabs layout-fill><md-tab label=\"Data\"><md-content layout-fill><md-list layout-align=\"space-around center\">\n<md-list-item><md-input-container layout-fill><label>Name</label><input ng-model=\"vm.currentChartItem.dataname\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item ng-if=\"vm.currentItem.content.Plot.errorFlag==1\"><div \nclass=\"md-caption errorText\">{{vm.currentItem.content.Plot.errors[0]}}</div></md-list-item><md-list-item>\n<md-input-container layout-fill><label>Data</label><input ng-model=\"vm.currentChartItem.zdata_name\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.currentChartItem.needsUpdateFlag=1; \n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item></md-list></md-content></md-tab><md-tab label=\"Appearance\"><md-content layout-fill>\n<md-list layout-margin><md-list-item><md-input-container layout-fill><md-checkbox \nng-model=\"vm.currentChartItem.data_datalabels\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                      vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                      vm.runEquationDigest();\" \naria-label=\"Data Labels\" flex=\"40\" flex-offset=\"10\">Data Labels</md-checkbox></md-input-container></md-list-item>\n<md-list-item><md-input-container layout-fill><label>Label Color</label><input \nng-model=\"vm.currentChartItem.data_labelColor\" \nng-enter=\"vm.currentChartItem.needsUpdateFlag=1; \n                                                vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                                vm.runEquationDigest();\">\n</md-input-container></md-list-item></md-list></md-content></md-tab></md-tabs>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/plotSpecVer/leftColumn.html","<md-list layout-margin><md-list-item><md-input-container flex=\"100\"><label>Chart Type</label><md-select \nng-model=\"vm.currentItem.content.Plot.Chart_type\" flex=\"100\" \nng-change=\"vm.currentDataset.needsUpdateFlag=1; \n								   vm.currentItem.content.Plot.needsUpdateFlag=1;\n								   vm.runEquationDigest();\">\n<md-option value=\"bar\">Bar Chart</md-option><md-option value=\"column\">Column Chart</md-option><md-option value=\"pie\">\nPie Chart</md-option><md-option value=\"line\">Line Chart</md-option><md-option value=\"spline\">Spline Chart</md-option>\n<md-option value=\"scatter\">Scatter Chart</md-option><md-option value=\"area\">Area Chart</md-option><md-option \nvalue=\"bubble\">Bubble Chart</md-option><md-option value=\"heatmap\">Heat Map</md-option><md-option value=\"combo\">\nCombo Chart</md-option></md-select></md-input-container></md-list-item><md-list-item><md-input-container flex=\"100\">\n<label>Item to Edit</label><md-select ng-model=\"vm.currentItem.content.Plot.activeType\" flex=\"100\"><md-option \nvalue=\"data\">Chart Data</md-option><md-option value=\"format\">Chart Format</md-option><md-option value=\"xAxis\">X Axis\n</md-option><md-option value=\"yAxis\">Y Axis</md-option><md-option value=\"band\">Chart Bands</md-option><md-option \nvalue=\"line\">Chart Lines</md-option><md-option value=\"text\">Chart Text</md-option></md-select></md-input-container>\n</md-list-item><md-list-item \nng-if=\"vm.currentItem.content.Plot.Chart_type==\'combo\' &&\n						 vm.currentItem.content.Plot.activeType==\'data\'\">\n<md-input-container flex=\"100\"><label>Dataset Type</label><md-select ng-model=\"vm.currentChartItem.Format_type\" \nflex=\"100\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n								   vm.currentItem.content.Plot.needsUpdateFlag=1;\n								   vm.runEquationDigest();\">\n<md-option value=\"bar\">Bar Chart</md-option><md-option value=\"column\">Column Chart</md-option><md-option value=\"pie\">\nPie Chart</md-option><md-option value=\"line\">Line Chart</md-option><md-option value=\"spline\">Spline Chart</md-option>\n<md-option value=\"scatter\">Scatter Chart</md-option><md-option value=\"area\">Area Chart</md-option></md-select>\n</md-input-container></md-list-item></md-list>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/plotSpecVer/lineData.html","<md-tabs layout-fill><md-tab label=\"Data\"><md-content layout-fill><md-list layout-align=\"space-around center\">\n<md-list-item><md-input-container layout-fill><label>Name</label><input ng-model=\"vm.currentChartItem.dataname\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											 vm.currentItem.content.Plot.needsUpdateFlag=1;\n											 vm.currentChartItem.needsUpdateFlag=1; \n											 vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item ng-if=\"vm.currentItem.content.Plot.errorFlag==1\"><div \nclass=\"md-caption errorText\">{{vm.currentItem.content.Plot.errors[0]}}</div></md-list-item><md-list-item>\n<md-input-container layout-fill><label>X Data</label><input ng-model=\"vm.currentChartItem.xdata_name\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Y Data</label><input \nng-model=\"vm.currentChartItem.ydata_name\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>X Axis</label><md-select \nng-model=\"vm.currentChartItem.xaxis\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n												   vm.currentItem.content.Plot.needsUpdateFlag=1;\n												   vm.runEquationDigest();\">\n<md-option ng-repeat=\"axisOption in vm.currentItem[\'content\'][\'Plot\'][\'Chart_xaxesobj\']\" \nvalue=\"{{axisOption.Axis_num}}\">{{axisOption.Axis_name}}</md-option></md-select></md-input-container></md-list-item>\n<md-list-item><md-input-container layout-fill><label>Y Axis</label><md-select ng-model=\"vm.currentChartItem.yaxis\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n												   vm.currentItem.content.Plot.needsUpdateFlag=1;\n												   vm.runEquationDigest();\">\n<md-option ng-repeat=\"axisOption in vm.currentItem[\'content\'][\'Plot\'][\'Chart_yaxesobj\']\" \nvalue=\"{{axisOption.Axis_num}}\">{{axisOption.Axis_name}}</md-option></md-select></md-input-container></md-list-item>\n</md-list></md-content></md-tab><md-tab label=\"Appearance\"><md-content layout-fill><md-list \nlayout-align=\"space-around center\"><md-list-item><md-input-container layout-fill><md-checkbox \nng-model=\"vm.currentChartItem.data_datalabels\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n										 			  vm.currentItem.content.Plot.needsUpdateFlag=1;\n										 			  vm.runEquationDigest();\" \naria-label=\"Data Labels\"></md-checkbox>Data Labels</md-input-container></md-list-item><md-list-item \nclass=\"marginTop20\"><md-input-container layout-fill><label>Label Color</label><input \nng-model=\"vm.currentChartItem.data_labelColor\" \nng-enter=\"vm.currentChartItem.needsUpdateFlag=1; \n												vm.currentItem.content.Plot.needsUpdateFlag=1;\n												vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Line Color</label><input \nng-model=\"vm.currentChartItem.color\" \nng-enter=\"vm.currentChartItem.needsUpdateFlag=1; \n												vm.currentItem.content.Plot.needsUpdateFlag=1;\n												vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Line Width</label><input \nng-model=\"vm.currentChartItem.lineWidth\" \nng-enter=\"vm.currentChartItem.needsUpdateFlag=1; \n												vm.currentItem.content.Plot.needsUpdateFlag=1;\n												vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Mono Color</label><input \nng-model=\"vm.currentItem.content.Plot.Chart_monoColor\" ng-enter=\"vm.setMonoColor();\"></md-input-container>\n</md-list-item><md-list-item><md-input-container layout-fill><md-checkbox \nng-model=\"vm.currentChartItem.data_pointmarkers\" aria-label=\"Point Markers\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n										 			  vm.currentItem.content.Plot.needsUpdateFlag=1;\n										 			  vm.runEquationDigest();\">\n</md-checkbox>Point Markers</md-input-container></md-list-item><md-list-item class=\"marginTop20\"><md-input-container \nlayout-fill><label>Fill Color</label><input ng-model=\"vm.currentChartItem.fillColor\" \nng-enter=\"vm.currentChartItem.needsUpdateFlag=1; \n												vm.currentItem.content.Plot.needsUpdateFlag=1;\n												vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Data Symbol</label><md-select \nng-model=\"vm.currentChartItem.symbol\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n													 vm.currentItem.content.Plot.needsUpdateFlag=1;\n													 vm.runEquationDigest();\">\n<md-option value=\"circle\">Circle</md-option><md-option value=\"square\">Square</md-option><md-option value=\"triangle\">\nTriangle</md-option><md-option value=\"triangle-down\">Triangle-Down</md-option><md-option value=\"diamond\">Diamond\n</md-option></md-select></md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>\nSymbol Size</label><input ng-model=\"vm.currentChartItem.data_markersize\" \nng-enter=\"vm.currentChartItem.needsUpdateFlag=1; \n												vm.currentItem.content.Plot.needsUpdateFlag=1;\n												vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Size</label><input \nng-model=\"vm.currentChartItem.data_labelSize\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Color</label><input \nng-model=\"vm.currentChartItem.data_labelColor\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Distance</label><input \nng-model=\"vm.currentChartItem.data_labelDistance\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Border</label><input \nng-model=\"vm.currentChartItem.data_labelBorderWidth\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Border Color</label><input \nng-model=\"vm.currentChartItem.data_labelBorderColor\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>BG Color</label><input \nng-model=\"vm.currentChartItem.data_labelBackgroundColor\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Border Radius</label><input \nng-model=\"vm.currentChartItem.data_labelBorderRadius\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Border Padding</label><input \nng-model=\"vm.currentChartItem.data_labelBorderPadding\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Rotation</label><input \nng-model=\"vm.currentChartItem.data_labelRotation\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label X</label><input \nng-model=\"vm.currentChartItem.data_labelX\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Y</label><input \nng-model=\"vm.currentChartItem.data_labelY\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><md-checkbox \nng-model=\"vm.currentChartItem.showInLegend\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n									 			  vm.currentItem.content.Plot.needsUpdateFlag=1;\n									 			  vm.runEquationDigest();\" \naria-label=\"Show in Legend\">Show in Legend</md-checkbox></md-input-container></md-list-item></md-list></md-content>\n</md-tab></md-tabs>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/plotSpecVer/lineEdit.html","<md-content class=\"chartEditSection\"><md-list layout-margin><md-list-item><md-input-container layout-fill><label>\nLine Value</label><input ng-model=\"vm.currentChartItem.Line_value\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                    vm.currentChartItem.needsUpdateFlag=1; \n                                    vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Line Width</label><input \nng-model=\"vm.currentChartItem.Line_width\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1; \n                                    vm.currentChartItem.needsUpdateFlag=1; \n                                    vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>X Axis</label><md-select \nng-model=\"vm.currentChartItem.Axis_id\" \nng-change=\"vm.currentDataset.needsUpdateFlag=1; \n                                       vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                       vm.runEquationDigest();\">\n<md-option ng-repeat=\"axisOption in vm.currentItem[\'content\'][\'Plot\'][\'Chart_xaxesobj\']\" \nvalue=\"{{axisOption.Format_id}}\">{{axisOption.Axis_name}}</md-option></md-select></md-input-container></md-list-item>\n<md-list-item><md-input-container layout-fill><label>Y Axis</label><md-select ng-model=\"vm.currentChartItem.Axis_id\" \nng-change=\"vm.currentDataset.needsUpdateFlag=1; \n                                       vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                       vm.runEquationDigest();\">\n<md-option ng-repeat=\"axisOption in vm.currentItem[\'content\'][\'Plot\'][\'Chart_yaxesobj\']\" \nvalue=\"{{axisOption.Format_id}}\">{{axisOption.Axis_name}}</md-option></md-select></md-input-container></md-list-item>\n<md-list-item><md-input-container layout-fill><label>Color</label><input ng-model=\"vm.currentChartItem.color\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1; vm.runEquationDigest();\"></md-input-container></md-list-item>\n</md-list></md-content>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/plotSpecVer/lineSection.html","<div id=\"dataSection\" class=\"fullWidth\" layout=\"column\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.addChartItem(obj, \'line\')\">Add Line</md-button><md-list ng-cloak layout-fill class=\"listSection\">\n<md-list-item ng-repeat=\"obj in vm.currentItem[\'content\'][\'Plot\'][\'Chart_linesobj\'] track by obj.Format_id\" flex=\"100\" \nng-class=\"{\'selected\' : vm.currentChartItem === obj}\"><div flex=\"90\" \nng-click=\"vm.currentChartItem=obj; vm.currentChartItemID=obj.Format_id\"><p>{{ obj.Line_name}}</p></div><div flex=\"10\" \nng-click=\"vm.deleteChartItem(vm.currentItem, obj)\"><md-icon md-font-icon=\"icon-close-circle-outline\" \naria-label=\"Delete Line\"></md-icon></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/plotSpecVer/pieData.html","<md-tabs layout-fill><md-tab label=\"Data\"><md-content layout-fill><md-list layout-align=\"space-around center\">\n<md-list-item><md-input-container layout-fill><label>Name</label><input ng-model=\"vm.currentChartItem.dataname\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Labels</label><input \nng-model=\"vm.currentChartItem.Chart_Labeltext\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item ng-if=\"vm.currentItem.content.Plot.errorFlag==1\"><div \nclass=\"md-caption errorText\">{{vm.currentItem.content.Plot.errors[0]}}</div></md-list-item><md-list-item>\n<md-input-container layout-fill><label>Data</label><input ng-model=\"vm.currentChartItem.ydata_name\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item></md-list></md-content></md-tab><md-tab label=\"Series\"><md-content layout-fill>\n<md-list layout-align=\"space-around center\"><md-list-item><md-input-container layout-fill><md-checkbox \nng-model=\"vm.currentChartItem.data_datalabels\" \nng-change=\"vm.currentChartItem.solveType=\'all\'; \n									 			  vm.currentItem.content.Plot.needsUpdateFlag=1;\n									 			  vm.currentChartItem.needsUpdateFlag=1; \n									 			  vm.runEquationDigest();\" \naria-label=\"Show in Legend\">Data Labels</md-checkbox></md-input-container></md-list-item><md-list-item>\n<md-input-container layout-fill><label>Line Width</label><input ng-model=\"vm.currentChartItem.Chart_connectorWidth\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Format</label><md-select\n ng-model=\"vm.currentChartItem.data_labelFormat\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n                                        			 vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                        			 vm.runEquationDigest();\">\n<md-option value=\"Normal\">Normal</md-option><md-option value=\"Percentage\">Percentage</md-option><md-option \nvalue=\"Value\">Value</md-option></md-select></md-input-container></md-list-item><md-list-item><md-input-container \nlayout-fill><label>Start Angle</label><input ng-model=\"vm.currentChartItem.Chart_startAngle\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>End Angle</label><input \nng-model=\"vm.currentChartItem.Chart_stopAngle\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Location (x,y)</label><input \nng-model=\"vm.currentChartItem.Chart_location\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Inner Radius</label><input \nng-model=\"vm.currentChartItem.Chart_innersize\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Size (%)</label><input \nng-model=\"vm.currentChartItem.Chart_size\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Mono Color</label><input \nng-model=\"vm.currentItem.content.Plot.Chart_monoColor\" ng-enter=\"vm.setMonoColor();\"></md-input-container>\n</md-list-item><md-list-item><md-input-container layout-fill><label>Label Size</label><input \nng-model=\"vm.currentChartItem.data_labelSize\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Color</label><input \nng-model=\"vm.currentChartItem.data_labelColor\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Distance</label><input \nng-model=\"vm.currentChartItem.data_labelDistance\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Border</label><input \nng-model=\"vm.currentChartItem.data_labelBorderWidth\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Border Color</label><input \nng-model=\"vm.currentChartItem.data_labelBorderColor\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>BG Color</label><input \nng-model=\"vm.currentChartItem.data_labelBackgroundColor\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Border Radius</label><input \nng-model=\"vm.currentChartItem.data_labelBorderRadius\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Border Padding</label><input \nng-model=\"vm.currentChartItem.data_labelBorderPadding\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Rotation</label><input \nng-model=\"vm.currentChartItem.data_labelRotation\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label X</label><input \nng-model=\"vm.currentChartItem.data_labelX\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Y</label><input \nng-model=\"vm.currentChartItem.data_labelY\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentChartItem.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><md-checkbox \nng-model=\"vm.currentChartItem.showInLegend\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n									 			  vm.currentItem.content.Plot.needsUpdateFlag=1;\n									 			  vm.runEquationDigest();\" \naria-label=\"Show in Legend\">Show in Legend</md-checkbox></md-input-container></md-list-item></md-list></md-content>\n</md-tab><md-tab label=\"Point\"><md-content layout-fill><md-list layout-align=\"space-around center\"><md-list-item>\n<md-input-container layout-fill><label>Point Index</label><input ng-model=\"vm.pointIndex\" \nng-enter=\"vm.currentPoint=vm.currentChartItem[\'PointData\'][vm.pointIndex]\"></md-input-container></md-list-item>\n<md-list-item><md-input-container layout-fill><md-checkbox ng-model=\"vm.currentPoint[\'sliced\']\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n									 			  vm.currentItem.content.Plot.needsUpdateFlag=1;\n									 			  vm.runEquationDigest();\" \naria-label=\"Sliced\">Sliced</md-checkbox></md-input-container></md-list-item><md-list-item><md-input-container \nlayout-fill><label>Slice Color</label><input ng-model=\"vm.currentPoint[\'color\']\" \nng-enter=\"vm.currentChartItem.needsUpdateFlag=1; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><md-checkbox \nng-model=\"vm.currentPoint.labels\" \nng-change=\"vm.currentPoint.solveType=\'all\'; \n									 			  vm.currentItem.content.Plot.needsUpdateFlag=1;\n									 			  vm.currentPoint.needsUpdateFlag=1; \n									 			  vm.runEquationDigest();\" \naria-label=\"Data Label\">Data Label</md-checkbox></md-input-container></md-list-item><md-list-item><md-input-container \nlayout-fill><label>Line Width</label><input ng-model=\"vm.currentPoint.Chart_connectorWidth\" \nng-enter=\"vm.currentPoint.solveType=\'all\'; \n											  vm.currentPoint.needsUpdateFlag=1; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Size</label><input \nng-model=\"vm.currentPoint.data_labelSize\" \nng-enter=\"vm.currentPoint.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentPoint.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Color</label><input \nng-model=\"vm.currentPoint.data_labelColor\" \nng-enter=\"vm.currentPoint.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentPoint.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Distance</label><input \nng-model=\"vm.currentPoint.data_labelDistance\" \nng-enter=\"vm.currentPoint.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentPoint.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Border</label><input \nng-model=\"vm.currentPoint.data_labelBorderWidth\" \nng-enter=\"vm.currentPoint.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentPoint.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Border Color</label><input \nng-model=\"vm.currentPoint.data_labelBorderColor\" \nng-enter=\"vm.currentPoint.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentPoint.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>BG Color</label><input \nng-model=\"vm.currentPoint.data_labelBackgroundColor\" \nng-enter=\"vm.currentPoint.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentPoint.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Border Radius</label><input \nng-model=\"vm.currentPoint.data_labelBorderRadius\" \nng-enter=\"vm.currentPoint.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentPoint.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Border Padding</label><input \nng-model=\"vm.currentPoint.data_labelBorderPadding\" \nng-enter=\"vm.currentPoint.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentPoint.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Rotation</label><input \nng-model=\"vm.currentPoint.data_labelRotation\" \nng-enter=\"vm.currentPoint.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentPoint.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label X</label><input \nng-model=\"vm.currentPoint.data_labelX\" \nng-enter=\"vm.currentPoint.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentPoint.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Label Y</label><input \nng-model=\"vm.currentPoint.data_labelY\" \nng-enter=\"vm.currentPoint.solveType=\'all\'; \n											  vm.currentItem.content.Plot.needsUpdateFlag=1;\n											  vm.currentPoint.needsUpdateFlag=1; \n											  vm.runEquationDigest();\">\n</md-input-container></md-list-item></md-list></md-content></md-tab></md-tabs>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/plotSpecVer/plotSpec.html","<div id=\"plotEdit\" \nng-style=\"{height:vm.currentItem.content.Plot.Chart_height, width:vm.currentItem.content.Plot.Chart_width}\"><div \nclass=\"plot_block\"><div id=\"plotSpecEdit\" class=\"plot_holder\" \nng-style=\"{height:vm.currentItem.content.Plot.Chart_height, width:vm.currentItem.content.Plot.Chart_width}\"><span \nplot-bind=\"vm.currentItem\"></span></div></div></div><div id=\"plotSpecVer\" layout=\"column\" layout-fill flex=\"100\">\n<md-content layout-fill flex=\"100\"><div \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpecVer/leftColumn.html\'\"></div><div \nng-if=\"vm.currentItem.content.Plot.activeType==\'data\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpecVer/dataSection.html\'\"></div><div \nng-if=\"vm.currentItem.content.Plot.activeType==\'text\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpecVer/textSection.html\'\"></div><div \nng-if=\"vm.currentItem.content.Plot.activeType==\'xAxis\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpecVer/xAxisSection.html\'\"></div><div \nng-if=\"vm.currentItem.content.Plot.activeType==\'yAxis\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpecVer/yAxisSection.html\'\"></div><div \nng-if=\"vm.currentItem.content.Plot.activeType==\'band\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpecVer/bandSection.html\'\"></div><div \nng-if=\"vm.currentItem.content.Plot.activeType==\'line\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpecVer/lineSection.html\'\"></div><div \nng-if=\"vm.currentItem.content.Plot.activeType==\'data\' && \n                        ((vm.currentItem.content.Plot.Chart_type==\'line\')||\n                        (vm.currentItem.content.Plot.Chart_type==\'spline\')||\n                        (vm.currentItem.content.Plot.Chart_type==\'scatter\')||\n                        ((vm.currentItem.content.Plot.Chart_type==\'combo\')&&\n                        (vm.currentChartItem.Format_type==\'line\'))||\n                        ((vm.currentItem.content.Plot.Chart_type==\'combo\')&&\n                        (vm.currentChartItem.Format_type==\'scatter\'))||\n                        ((vm.currentItem.content.Plot.Chart_type==\'combo\')&&\n                        (vm.currentChartItem.Format_type==\'spline\')))\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpecVer/lineData.html\'\"></div><div \nng-if=\"vm.currentItem.content.Plot.activeType==\'data\' && \n                        ((vm.currentItem.content.Plot.Chart_type==\'column\')||\n                         (vm.currentItem.content.Plot.Chart_type==\'bar\')||\n                        ((vm.currentItem.content.Plot.Chart_type==\'combo\')&&\n                        (vm.currentChartItem.Format_type==\'column\')))\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpecVer/columnData.html\'\"></div><div \nng-if=\"vm.currentItem.content.Plot.activeType==\'data\' && \n                        ((vm.currentItem.content.Plot.Chart_type==\'area\')||\n                        ((vm.currentItem.content.Plot.Chart_type==\'combo\')&&\n                        (vm.currentChartItem.Format_type==\'area\')))\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpecVer/areaData.html\'\"></div><div \nng-if=\"vm.currentItem.content.Plot.activeType==\'data\' && \n                        ((vm.currentItem.content.Plot.Chart_type==\'bubble\')||\n                        ((vm.currentItem.content.Plot.Chart_type==\'combo\')&&\n                        (vm.currentChartItem.Format_type==\'bubble\')))\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpecVer/bubbleData.html\'\"></div><div \nng-if=\"vm.currentItem.content.Plot.activeType==\'data\' && \n                        vm.currentItem.content.Plot.Chart_type==\'heatmap\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpecVer/heatmapData.html\'\"></div><div \nng-if=\"vm.currentItem.content.Plot.activeType==\'data\' && \n                        ((vm.currentItem.content.Plot.Chart_type==\'pie\')||\n                        ((vm.currentItem.content.Plot.Chart_type==\'combo\')&&\n                        (vm.currentChartItem.Format_type==\'pie\')))\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpecVer/pieData.html\'\"></div><div \nng-if=\"vm.currentItem.content.Plot.activeType==\'text\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpecVer/textEdit.html\'\"></div><div \nng-if=\"vm.currentItem.content.Plot.activeType==\'band\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpecVer/bandEdit.html\'\"></div><div \nng-if=\"vm.currentItem.content.Plot.activeType==\'line\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpecVer/lineEdit.html\'\"></div><div \nng-if=\"vm.currentItem.content.Plot.activeType==\'xAxis\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpecVer/xAxisEdit.html\'\"></div><div \nng-if=\"vm.currentItem.content.Plot.activeType==\'yAxis\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpecVer/yAxisEdit.html\'\"></div><div \nid=\"formatSection\" ng-if=\"vm.currentItem.content.Plot.activeType==\'format\'\" \nng-include=\"\'app/main/apps/document/worksheet/views/templates/plotSpecVer/formatSection.html\'\"></div></md-content>\n</div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/plotSpecVer/textEdit.html","<md-content class=\"chartEditSection\"><md-list layout-margin><md-list-item><md-input-container layout-fill><label>\nTitle Text</label><input ng-model=\"vm.currentChartItem.textRawText\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1; \n                                    vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                    vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>X Location</label><input \nng-model=\"vm.currentChartItem.textXLoc\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1; \n                                    vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                    vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Y Location</label><input \nng-model=\"vm.currentChartItem.textYLoc\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1; \n                                    vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                    vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Color</label><input \nng-model=\"vm.currentChartItem.textColor\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1; \n                                    vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                    vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Angle</label><input \nng-model=\"vm.currentChartItem.textRotAng\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1; \n                                    vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                    vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Size</label><input \nng-model=\"vm.currentChartItem.textSize\" \nng-enter=\"vm.currentItem.content.Plot.needsUpdateFlag=1; \n                                    vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                    vm.runEquationDigest();\">\n</md-input-container></md-list-item></md-list></md-content>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/plotSpecVer/textSection.html","<div id=\"dataSection\" class=\"fullWidth\" layout=\"column\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.addChartItem(obj, \'plotText\')\">Add Text</md-button><md-list ng-cloak layout-fill class=\"listSection\">\n<md-list-item ng-repeat=\"obj in vm.currentItem[\'content\'][\'Plot\'][\'Chart_textobj\'] track by obj.Format_id\" flex=\"100\" \nng-class=\"{\'selected\' : vm.currentChartItem === obj}\"><div flex=\"90\" \nng-click=\"vm.currentChartItem=obj; vm.currentChartItemID=obj.Format_id\"><p>{{ obj.Text_name}}</p></div><div flex=\"10\" \nng-click=\"vm.deleteChartItem(vm.currentItem, obj)\"><md-icon md-font-icon=\"icon-close-circle-outline\" \naria-label=\"Delete Text\"></md-icon></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/plotSpecVer/xAxisEdit.html","<md-tabs ng-show=\"vm.currentItem.content.Plot.activeType==\'xAxis\'\"><md-tab label=\"Setup\"><md-content \nclass=\"chartEditSection\"><md-list layout-margin><md-list-item><md-input-container layout-fill><label>Axis Label</label>\n<input ng-model=\"vm.currentChartItem.Axis_label\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                             vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                             vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Minimum</label><input \nng-model=\"vm.currentChartItem.Axis_min\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Maximum</label><input \nng-model=\"vm.currentChartItem.Axis_max\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Axis Type</label><md-select \nng-model=\"vm.currentChartItem.Axis_type\" \nng-change=\"vm.currentPlot.needsUpdateFlag=1; \n                                                     vm.currentItem.content.Plot.needsUpdateFlag=1; \n                                                     vm.runEquationDigest();\">\n<md-option value=\"linear\">Linear</md-option><md-option value=\"datetime\">Date-Time</md-option><md-option \nvalue=\"logarithmic\">Logarithmic</md-option></md-select></md-input-container></md-list-item><md-list-item>\n<md-input-container layout-fill><label>Axis Reversed</label><md-select ng-model=\"vm.currentChartItem.Axis_reversed\" \nng-change=\"vm.currentPlot.needsUpdateFlag=1; \n                                                     vm.currentItem.content.Plot.needsUpdateFlag=1; \n                                                     vm.runEquationDigest();\">\n<md-option value=\"true\">True</md-option><md-option value=\"false\">False</md-option></md-select></md-input-container>\n</md-list-item></md-list></md-content></md-tab><md-tab label=\"Appearance\"><md-content class=\"chartEditSection\">\n<md-list><md-list-item><md-input-container layout-fill><label>Axis Opposite</label><md-select \nng-model=\"vm.currentChartItem.Axis_opposite\" \nng-change=\"vm.currentPlot.needsUpdateFlag=1; \n                                                     vm.currentItem.content.Plot.needsUpdateFlag=1; \n                                                     vm.runEquationDigest();\">\n<md-option value=\"true\">True</md-option><md-option value=\"false\">False</md-option></md-select></md-input-container>\n</md-list-item><md-list-item><md-input-container layout-fill><label>Axis Offset</label><input \nng-model=\"vm.currentChartItem.Axis_offset\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Line Width</label><input \nng-model=\"vm.currentChartItem.Axis_lineWidth\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Line Color</label><input \nng-model=\"vm.currentChartItem.Axis_lineColor\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item></md-list></md-content></md-tab><md-tab label=\"Ticks\"><md-content \nclass=\"chartEditSection\"><md-list><md-list-item><md-input-container layout-fill><md-checkbox \nng-model=\"vm.currentChartItem.Axis_gridlinesonoff\" \nng-change=\"vm.currentPlot.needsUpdateFlag=1; \n                                                      vm.currentItem.content.Plot.needsUpdateFlag=1; \n                                                      vm.runEquationDigest();\" \naria-label=\"Data Labels\">Major Grid Lines</md-checkbox></md-input-container></md-list-item><md-list-item \nclass=\"marginTop20\"><md-input-container layout-fill><label>Major Tick Interval</label><input \nng-model=\"vm.currentChartItem.Axis_tickinterval\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Grid Line Width</label><input \nng-model=\"vm.currentChartItem.Axis_gridlinewidth\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Grid Line Color</label><input \nng-model=\"vm.currentChartItem.Axis_gridcolor\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><md-checkbox \nng-model=\"vm.currentChartItem.Axis_minorgridlinesonoff\" \nng-change=\"vm.currentPlot.needsUpdateFlag=1; \n                                                      vm.currentItem.content.Plot.needsUpdateFlag=1; \n                                                      vm.runEquationDigest();\" \naria-label=\"Data Labels\">Minor Grid Lines</md-checkbox></md-input-container></md-list-item><md-list-item \nclass=\"marginTop20\"><md-input-container layout-fill><label>Minor Tick Interval</label><input \nng-model=\"vm.currentChartItem.Axis_minortickinterval\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Minor Grid Line Width</label>\n<input ng-model=\"vm.currentChartItem.Axis_minorgridlinewidth\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Minor Grid Line Color</label>\n<input ng-model=\"vm.currentChartItem.Axis_minorgridcolor\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item></md-list></md-content></md-tab></md-tabs>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/plotSpecVer/xAxisSection.html","<div id=\"dataSection\" class=\"fullWidth\" layout=\"column\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.addChartItem(obj, \'xAxis\')\">Add X Axis</md-button><md-list ng-cloak layout-fill class=\"listSection\">\n<md-list-item ng-repeat=\"obj in vm.currentItem[\'content\'][\'Plot\'][\'Chart_xaxesobj\'] track by obj.Format_id\" flex=\"100\" \nng-class=\"{\'selected\' : vm.currentChartItem === obj}\"><div flex=\"90\" \nng-click=\"vm.currentChartItem=obj; vm.currentChartItemID=obj.Format_id\"><p>{{ obj.Axis_name}}</p></div><div flex=\"10\" \nng-click=\"vm.deleteChartItem(vm.currentItem, obj)\"><md-icon md-font-icon=\"icon-close-circle-outline\" \naria-label=\"Delete Text\"></md-icon></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/plotSpecVer/yAxisEdit.html","<md-tabs ng-show=\"vm.currentItem.content.Plot.activeType==\'yAxis\'\"><md-tab label=\"Setup\"><md-content \nclass=\"chartEditSection\"><md-list layout-margin><md-list-item><md-input-container layout-fill><label>Axis Label</label>\n<input ng-model=\"vm.currentChartItem.Axis_label\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                             vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                             vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Minimum</label><input \nng-model=\"vm.currentChartItem.Axis_min\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Maximum</label><input \nng-model=\"vm.currentChartItem.Axis_max\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Axis Type</label><md-select \nng-model=\"vm.currentChartItem.Axis_type\" \nng-change=\"vm.currentPlot.needsUpdateFlag=1; \n                                                      vm.currentItem.content.Plot.needsUpdateFlag=1; \n                                                      vm.runEquationDigest();\">\n<md-option value=\"linear\">Linear</md-option><md-option value=\"datetime\">Date-Time</md-option><md-option \nvalue=\"logarithmic\">Logarithmic</md-option></md-select></md-input-container></md-list-item><md-list-item>\n<md-input-container layout-fill><label>Axis Reversed</label><md-select ng-model=\"vm.currentChartItem.Axis_reversed\" \nng-change=\"vm.currentPlot.needsUpdateFlag=1; \n                                                      vm.currentItem.content.Plot.needsUpdateFlag=1; \n                                                      vm.runEquationDigest();\">\n<md-option value=\"true\">True</md-option><md-option value=\"false\">False</md-option></md-select></md-input-container>\n</md-list-item></md-list></md-content></md-tab><md-tab label=\"Appearance\"><md-content class=\"chartEditSection\"><md-list\n layout-margin><md-list-item><md-input-container layout-fill><label>Axis Opposite</label><md-select \nng-model=\"vm.currentChartItem.Axis_opposite\" \nng-change=\"vm.currentPlot.needsUpdateFlag=1; \n                                                      vm.currentItem.content.Plot.needsUpdateFlag=1; \n                                                      vm.runEquationDigest();\">\n<md-option value=\"true\">True</md-option><md-option value=\"false\">False</md-option></md-select></md-input-container>\n</md-list-item><md-list-item><md-input-container layout-fill><label>Axis Offset</label><input \nng-model=\"vm.currentChartItem.Axis_offset\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Line Width</label><input \nng-model=\"vm.currentChartItem.Axis_lineWidth\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Line Color</label><input \nng-model=\"vm.currentChartItem.Axis_lineColor\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item></md-list></md-content></md-tab><md-tab label=\"Ticks\"><md-content \nclass=\"chartEditSection\"><md-list layout-margin><md-list-item><md-input-container layout-fill><md-checkbox \nng-model=\"vm.currentChartItem.Axis_gridlinesonoff\" \nng-change=\"vm.currentPlot.needsUpdateFlag=1; \n                                                      vm.currentItem.content.Plot.needsUpdateFlag=1; \n                                                      vm.runEquationDigest();\" \naria-label=\"Data Labels\">Major Grid Lines</md-checkbox></md-input-container></md-list-item><md-list-item \nclass=\"marginTop20\"><md-input-container layout-fill><label>Major Tick Interval</label><input \nng-model=\"vm.currentChartItem.Axis_tickinterval\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Grid Line Width</label><input \nng-model=\"vm.currentChartItem.Axis_gridlinewidth\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Grid Line Color</label><input \nng-model=\"vm.currentChartItem.Axis_gridcolor\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><md-checkbox \nng-model=\"vm.currentChartItem.Axis_minorgridlinesonoff\" \nng-change=\"vm.currentPlot.needsUpdateFlag=1; \n                                                      vm.currentItem.content.Plot.needsUpdateFlag=1; \n                                                      vm.runEquationDigest();\" \naria-label=\"Data Labels\">Minor Grid Lines</md-checkbox></md-input-container></md-list-item><md-list-item \nclass=\"marginTop20\"><md-input-container layout-fill><label>Minor Tick Interval</label><input \nng-model=\"vm.currentChartItem.Axis_minortickinterval\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Minor Grid Line Width</label>\n<input ng-model=\"vm.currentChartItem.Axis_minorgridlinewidth\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container layout-fill><label>Minor Grid Line Color</label>\n<input ng-model=\"vm.currentChartItem.Axis_minorgridcolor\" \nng-enter=\"vm.currentPlot.needsUpdateFlag=1; \n                                              vm.currentItem.content.Plot.needsUpdateFlag=1;\n                                              vm.runEquationDigest();\">\n</md-input-container></md-list-item></md-list></md-content></md-tab></md-tabs>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/plotSpecVer/yAxisSection.html","<div id=\"dataSection\" class=\"fullWidth\" layout=\"column\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.addChartItem(obj, \'yAxis\')\">Add Y Axis</md-button><md-list ng-cloak layout-fill class=\"listSection\">\n<md-list-item ng-repeat=\"obj in vm.currentItem[\'content\'][\'Plot\'][\'Chart_yaxesobj\'] track by obj.Format_id\" flex=\"100\" \nng-class=\"{\'selected\' : vm.currentChartItem === obj}\"><div flex=\"90\" \nng-click=\"vm.currentChartItem=obj; vm.currentChartItemID=obj.Format_id\"><p>{{ obj.Axis_name}}</p></div><div flex=\"10\" \nng-click=\"vm.deleteChartItem(vm.currentItem, obj)\"><md-icon md-font-icon=\"icon-close-circle-outline\" \naria-label=\"Delete Text\"></md-icon></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/arrowData.html","<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Data Type</label><md-select \nng-model=\"vm.currentChartItem[\'type\']\" ng-change=\"vm.reDrawItem( vm.currentItem, \'all\', 1 );\"><md-option \nvalue=\"surface\">Surface</md-option><md-option value=\"pointCloud\">Point Cloud</md-option><md-option value=\"line\">Line\n</md-option><md-option value=\"cube\">Cube</md-option><md-option value=\"icosahedron\">Icosahedron</md-option><md-option \nvalue=\"dodecahedron\">Dodecahedron</md-option><md-option value=\"tetrahedron\">Tetrahedron</md-option><md-option \nvalue=\"octahedron\">Octahedron</md-option><md-option value=\"sphere\">Sphere</md-option><md-option value=\"cylinder\">\nCylinder</md-option><md-option value=\"torus\">Torus</md-option><md-option value=\"plane\">Plane</md-option><md-option \nvalue=\"lathe\">Lathe</md-option><md-option value=\"grid\">Grid</md-option><md-option value=\"axis\">Axis</md-option>\n<md-option value=\"arrow\">Arrow</md-option></md-select></md-input-container></md-list-item><md-list-item>\n<md-input-container flex=\"90\" flex-offset=\"5\"><label>Name</label><input ng-model=\"vm.currentChartItem.dataname\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Direction\n</label><input ng-model=\"vm.currentChartItem.xDir\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Direction</label><input \nng-model=\"vm.currentChartItem.yDir\" ng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Direction\n</label><input ng-model=\"vm.currentChartItem.zDir\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Length</label><input \nng-model=\"vm.currentChartItem.length\" ng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Color</label>\n<input ng-model=\"vm.currentChartItem.color\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Arrow Width</label><input \nng-model=\"vm.currentChartItem.arrowWidth\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Arrow Height</label><input \nng-model=\"vm.currentChartItem.arrowHeight\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Position</label><input \nng-model=\"vm.currentChartItem.xPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Position</label><input \nng-model=\"vm.currentChartItem.yPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Position</label><input \nng-model=\"vm.currentChartItem.zPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/axisData.html","<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Data Type</label><md-select \nng-model=\"vm.currentChartItem[\'type\']\" ng-change=\"vm.reDrawItem( vm.currentItem, \'all\', 1 );\"><md-option \nvalue=\"surface\">Surface</md-option><md-option value=\"pointCloud\">Point Cloud</md-option><md-option value=\"line\">Line\n</md-option><md-option value=\"cube\">Cube</md-option><md-option value=\"icosahedron\">Icosahedron</md-option><md-option \nvalue=\"dodecahedron\">Dodecahedron</md-option><md-option value=\"tetrahedron\">Tetrahedron</md-option><md-option \nvalue=\"octahedron\">Octahedron</md-option><md-option value=\"sphere\">Sphere</md-option><md-option value=\"cylinder\">\nCylinder</md-option><md-option value=\"torus\">Torus</md-option><md-option value=\"plane\">Plane</md-option><md-option \nvalue=\"lathe\">Lathe</md-option><md-option value=\"grid\">Grid</md-option><md-option value=\"axis\">Axis</md-option>\n<md-option value=\"arrow\">Arrow</md-option></md-select></md-input-container></md-list-item><md-list-item>\n<md-input-container flex=\"90\" flex-offset=\"5\"><label>Name</label><input ng-model=\"vm.currentChartItem.dataname\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Axis Type\n</label><md-select ng-model=\"vm.currentChartItem[\'axisType\']\" ng-change=\"vm.reDrawItem( vm.currentItem, \'all\', 1 );\">\n<md-option value=\"X\">X</md-option><md-option value=\"Y\">Y</md-option><md-option value=\"Z\">Z</md-option></md-select>\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Axis Start\n</label><input ng-model=\"vm.currentChartItem.axisStart\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Axis Stop</label><input \nng-model=\"vm.currentChartItem.axisStop\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Axis Interval</label><input \nng-model=\"vm.currentChartItem.axisInterval\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Tick Length</label><input \nng-model=\"vm.currentChartItem.tickLength\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Interval</label><input \nng-model=\"vm.currentChartItem.axisInterval\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Label Size</label><input \nng-model=\"vm.currentChartItem.labelSize\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Offset</label><input \nng-model=\"vm.currentChartItem.xOffset\" ng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Offset</label>\n<input ng-model=\"vm.currentChartItem.yOffset\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Offset</label><input \nng-model=\"vm.currentChartItem.zOffset\" ng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Text Offset\n</label><input ng-model=\"vm.currentChartItem.xTextOffset\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Text Offset</label><input \nng-model=\"vm.currentChartItem.yTextOffset\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Text Offset</label><input \nng-model=\"vm.currentChartItem.zTextOffset\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/cubeData.html","<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Data Type</label><md-select \nng-model=\"vm.currentChartItem[\'type\']\" ng-change=\"vm.reDrawItem( vm.currentItem, \'all\', 1 );\"><md-option \nvalue=\"surface\">Surface</md-option><md-option value=\"pointCloud\">Point Cloud</md-option><md-option value=\"line\">Line\n</md-option><md-option value=\"cube\">Cube</md-option><md-option value=\"icosahedron\">Icosahedron</md-option><md-option \nvalue=\"dodecahedron\">Dodecahedron</md-option><md-option value=\"tetrahedron\">Tetrahedron</md-option><md-option \nvalue=\"octahedron\">Octahedron</md-option><md-option value=\"sphere\">Sphere</md-option><md-option value=\"cylinder\">\nCylinder</md-option><md-option value=\"torus\">Torus</md-option><md-option value=\"plane\">Plane</md-option><md-option \nvalue=\"lathe\">Lathe</md-option><md-option value=\"grid\">Grid</md-option><md-option value=\"axis\">Axis</md-option>\n<md-option value=\"arrow\">Arrow</md-option></md-select></md-input-container></md-list-item><md-list-item>\n<md-input-container flex=\"30\" flex-offset=\"5\"><label>Name</label><input ng-model=\"vm.currentChartItem.dataname\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Cube Width\n</label><input ng-model=\"vm.currentChartItem.width\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Cube Height</label><input \nng-model=\"vm.currentChartItem.height\" ng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Cube Depth\n</label><input ng-model=\"vm.currentChartItem.depth\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Width Segments</label><input \nng-model=\"vm.currentChartItem.widthSegs\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Height Segments</label><input \nng-model=\"vm.currentChartItem.heightSegs\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Depth Segments</label><input \nng-model=\"vm.currentChartItem.depthSegs\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Color</label><input \nng-model=\"vm.currentChartItem.color\" ng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Wire Color\n</label><input ng-model=\"vm.currentChartItem.wireColor\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Solid / Wireframe</label><md-select \nng-model=\"vm.currentChartItem[\'wireFrame\']\" ng-change=\"vm.reDrawItem( vm.currentItem, \'all\', 1 );\"><md-option \nvalue=\"Solid\">Solid</md-option><md-option value=\"Wireframe\">Wireframe</md-option></md-select></md-input-container>\n</md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Position</label><input \nng-model=\"vm.currentChartItem.xPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Position</label><input \nng-model=\"vm.currentChartItem.yPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Position</label><input \nng-model=\"vm.currentChartItem.zPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Rotation</label><input \nng-model=\"vm.currentChartItem.xRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Rotation</label><input \nng-model=\"vm.currentChartItem.yRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Rotation</label><input \nng-model=\"vm.currentChartItem.zRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/cylinderData.html","<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Data Type</label><md-select \nng-model=\"vm.currentChartItem[\'type\']\" ng-change=\"vm.reDrawItem( vm.currentItem, \'all\', 1 );\"><md-option \nvalue=\"surface\">Surface</md-option><md-option value=\"pointCloud\">Point Cloud</md-option><md-option value=\"line\">Line\n</md-option><md-option value=\"cube\">Cube</md-option><md-option value=\"icosahedron\">Icosahedron</md-option><md-option \nvalue=\"dodecahedron\">Dodecahedron</md-option><md-option value=\"tetrahedron\">Tetrahedron</md-option><md-option \nvalue=\"octahedron\">Octahedron</md-option><md-option value=\"sphere\">Sphere</md-option><md-option value=\"cylinder\">\nCylinder</md-option><md-option value=\"torus\">Torus</md-option><md-option value=\"plane\">Plane</md-option><md-option \nvalue=\"lathe\">Lathe</md-option><md-option value=\"grid\">Grid</md-option><md-option value=\"axis\">Axis</md-option>\n<md-option value=\"arrow\">Arrow</md-option></md-select></md-input-container></md-list-item><md-list-item>\n<md-input-container flex=\"90\" flex-offset=\"5\"><label>Name</label><input ng-model=\"vm.currentChartItem.dataname\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Top Radius\n</label><input ng-model=\"vm.currentChartItem.topRadius\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Bottom Radius</label><input \nng-model=\"vm.currentChartItem.botRadius\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Height</label><input \nng-model=\"vm.currentChartItem.height\" ng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Radial Segments\n</label><input ng-model=\"vm.currentChartItem.radSegs\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Height Segments</label><input \nng-model=\"vm.currentChartItem.heightSegs\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Theta Start</label><input \nng-model=\"vm.currentChartItem.thetaStart\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Theta Length</label><input \nng-model=\"vm.currentChartItem.thetaLength\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Color</label><input \nng-model=\"vm.currentChartItem.color\" ng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Wire Color\n</label><input ng-model=\"vm.currentChartItem.wireColor\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Solid / Wireframe</label><md-select \nng-model=\"vm.currentChartItem[\'wireFrame\']\" ng-change=\"vm.reDrawItem( vm.currentItem, \'all\', 1 );\"><md-option \nvalue=\"Solid\">Solid</md-option><md-option value=\"Wireframe\">Wireframe</md-option></md-select></md-input-container>\n</md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Position</label><input \nng-model=\"vm.currentChartItem.xPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Position</label><input \nng-model=\"vm.currentChartItem.yPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Position</label><input \nng-model=\"vm.currentChartItem.zPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Rotation</label><input \nng-model=\"vm.currentChartItem.xRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Rotation</label><input \nng-model=\"vm.currentChartItem.yRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Rotation</label><input \nng-model=\"vm.currentChartItem.zRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/generalShapeData.html","<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Data Type</label><md-select \nng-model=\"vm.currentChartItem[\'type\']\" ng-change=\"vm.reDrawItem( vm.currentItem, \'all\', 1 );\"><md-option \nvalue=\"surface\">Surface</md-option><md-option value=\"pointCloud\">Point Cloud</md-option><md-option value=\"line\">Line\n</md-option><md-option value=\"cube\">Cube</md-option><md-option value=\"icosahedron\">Icosahedron</md-option><md-option \nvalue=\"dodecahedron\">Dodecahedron</md-option><md-option value=\"tetrahedron\">Tetrahedron</md-option><md-option \nvalue=\"octahedron\">Octahedron</md-option><md-option value=\"sphere\">Sphere</md-option><md-option value=\"cylinder\">\nCylinder</md-option><md-option value=\"torus\">Torus</md-option><md-option value=\"plane\">Plane</md-option><md-option \nvalue=\"lathe\">Lathe</md-option><md-option value=\"grid\">Grid</md-option><md-option value=\"axis\">Axis</md-option>\n<md-option value=\"arrow\">Arrow</md-option></md-select></md-input-container></md-list-item><md-list-item>\n<md-input-container flex=\"90\" flex-offset=\"5\"><label>Name</label><input ng-model=\"vm.currentChartItem.dataname\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Radius</label>\n<input ng-model=\"vm.currentChartItem.radius\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Detail</label><input \nng-model=\"vm.currentChartItem.detail\" ng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Color</label>\n<input ng-model=\"vm.currentChartItem.color\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Wire Color</label><input \nng-model=\"vm.currentChartItem.wireColor\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Solid / Wireframe</label><md-select \nng-model=\"vm.currentChartItem[\'wireFrame\']\" ng-change=\"vm.reDrawItem( vm.currentItem, \'all\', 1 );\"><md-option \nvalue=\"Solid\">Solid</md-option><md-option value=\"Wireframe\">Wireframe</md-option></md-select></md-input-container>\n</md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Position</label><input \nng-model=\"vm.currentChartItem.xPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Position</label><input \nng-model=\"vm.currentChartItem.yPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Position</label><input \nng-model=\"vm.currentChartItem.zPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Rotation</label><input \nng-model=\"vm.currentChartItem.xRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Rotation</label><input \nng-model=\"vm.currentChartItem.yRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Rotation</label><input \nng-model=\"vm.currentChartItem.zRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/gridData.html","<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Data Type</label><md-select \nng-model=\"vm.currentChartItem[\'type\']\" ng-change=\"vm.reDrawItem( vm.currentItem, \'all\', 1 );\"><md-option \nvalue=\"surface\">Surface</md-option><md-option value=\"pointCloud\">Point Cloud</md-option><md-option value=\"line\">Line\n</md-option><md-option value=\"cube\">Cube</md-option><md-option value=\"icosahedron\">Icosahedron</md-option><md-option \nvalue=\"dodecahedron\">Dodecahedron</md-option><md-option value=\"tetrahedron\">Tetrahedron</md-option><md-option \nvalue=\"octahedron\">Octahedron</md-option><md-option value=\"sphere\">Sphere</md-option><md-option value=\"cylinder\">\nCylinder</md-option><md-option value=\"torus\">Torus</md-option><md-option value=\"plane\">Plane</md-option><md-option \nvalue=\"lathe\">Lathe</md-option><md-option value=\"grid\">Grid</md-option><md-option value=\"axis\">Axis</md-option>\n<md-option value=\"arrow\">Arrow</md-option></md-select></md-input-container></md-list-item><md-list-item>\n<md-input-container flex=\"90\" flex-offset=\"5\"><label>Name</label><input ng-model=\"vm.currentChartItem.dataname\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Grid Type\n</label><md-select ng-model=\"vm.currentChartItem[\'type\']\" ng-change=\"vm.reDrawItem( vm.currentItem, \'all\', 1 );\">\n<md-option value=\"XY\">XY</md-option><md-option value=\"XZ\">XZ</md-option><md-option value=\"YZ\">YZ</md-option>\n</md-select></md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>\nColor</label><input ng-model=\"vm.currentChartItem.color\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Width</label><input \nng-model=\"vm.currentChartItem.width\" ng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Height</label>\n<input ng-model=\"vm.currentChartItem.height\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Start</label><input \nng-model=\"vm.currentChartItem.xStart\" ng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Stop</label>\n<input ng-model=\"vm.currentChartItem.xStop\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Spacing</label><input \nng-model=\"vm.currentChartItem.xSpacing\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Start</label><input \nng-model=\"vm.currentChartItem.yStart\" ng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Stop</label>\n<input ng-model=\"vm.currentChartItem.yStop\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Spacing</label><input \nng-model=\"vm.currentChartItem.ySpacing\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Start</label><input \nng-model=\"vm.currentChartItem.zStart\" ng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Stop</label>\n<input ng-model=\"vm.currentChartItem.zStop\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Spacing</label><input \nng-model=\"vm.currentChartItem.zSpacing\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Position</label><input \nng-model=\"vm.currentChartItem.xPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Position</label><input \nng-model=\"vm.currentChartItem.yPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Position</label><input \nng-model=\"vm.currentChartItem.zPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Rotation</label><input \nng-model=\"vm.currentChartItem.xRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Rotation</label><input \nng-model=\"vm.currentChartItem.yRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Rotation</label><input \nng-model=\"vm.currentChartItem.zRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/latheData.html","<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Data Type</label><md-select \nng-model=\"vm.currentChartItem[\'type\']\" ng-change=\"vm.reDrawItem( vm.currentItem, \'all\', 1 );\"><md-option \nvalue=\"surface\">Surface</md-option><md-option value=\"pointCloud\">Point Cloud</md-option><md-option value=\"line\">Line\n</md-option><md-option value=\"cube\">Cube</md-option><md-option value=\"icosahedron\">Icosahedron</md-option><md-option \nvalue=\"dodecahedron\">Dodecahedron</md-option><md-option value=\"tetrahedron\">Tetrahedron</md-option><md-option \nvalue=\"octahedron\">Octahedron</md-option><md-option value=\"sphere\">Sphere</md-option><md-option value=\"cylinder\">\nCylinder</md-option><md-option value=\"torus\">Torus</md-option><md-option value=\"plane\">Plane</md-option><md-option \nvalue=\"lathe\">Lathe</md-option><md-option value=\"grid\">Grid</md-option><md-option value=\"axis\">Axis</md-option>\n<md-option value=\"arrow\">Arrow</md-option></md-select></md-input-container></md-list-item><md-list-item>\n<md-input-container flex=\"90\" flex-offset=\"5\"><label>Name</label><input ng-model=\"vm.currentChartItem.dataname\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Data</label>\n<input ng-model=\"vm.currentChartItem.xDataRaw\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Data</label><input \nng-model=\"vm.currentChartItem.yDataRaw\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Segments</label><input \nng-model=\"vm.currentChartItem.tubeSegs\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Phi Start</label><input \nng-model=\"vm.currentChartItem.phiStart\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Phi Length</label><input \nng-model=\"vm.currentChartItem.phiLength\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Color</label><input \nng-model=\"vm.currentChartItem.color\" ng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Wire Color\n</label><input ng-model=\"vm.currentChartItem.wireColor\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Solid / Wireframe</label><md-select \nng-model=\"vm.currentChartItem[\'wireFrame\']\" ng-change=\"vm.reDrawItem( vm.currentItem, \'all\', 1 );\"><md-option \nvalue=\"Solid\">Solid</md-option><md-option value=\"Wireframe\">Wireframe</md-option></md-select></md-input-container>\n</md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Position</label><input \nng-model=\"vm.currentChartItem.xPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Position</label><input \nng-model=\"vm.currentChartItem.yPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Position</label><input \nng-model=\"vm.currentChartItem.zPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Rotation</label><input \nng-model=\"vm.currentChartItem.xRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Rotation</label><input \nng-model=\"vm.currentChartItem.yRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Rotation</label><input \nng-model=\"vm.currentChartItem.zRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/lineData.html","<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Data Type</label><md-select \nng-model=\"vm.currentChartItem[\'type\']\" ng-change=\"vm.reDrawItem( vm.currentItem, \'all\', 1 );\"><md-option \nvalue=\"surface\">Surface</md-option><md-option value=\"pointCloud\">Point Cloud</md-option><md-option value=\"line\">Line\n</md-option><md-option value=\"cube\">Cube</md-option><md-option value=\"icosahedron\">Icosahedron</md-option><md-option \nvalue=\"dodecahedron\">Dodecahedron</md-option><md-option value=\"tetrahedron\">Tetrahedron</md-option><md-option \nvalue=\"octahedron\">Octahedron</md-option><md-option value=\"sphere\">Sphere</md-option><md-option value=\"cylinder\">\nCylinder</md-option><md-option value=\"torus\">Torus</md-option><md-option value=\"plane\">Plane</md-option><md-option \nvalue=\"lathe\">Lathe</md-option><md-option value=\"grid\">Grid</md-option><md-option value=\"axis\">Axis</md-option>\n<md-option value=\"arrow\">Arrow</md-option></md-select></md-input-container></md-list-item><md-list-item>\n<md-input-container flex=\"90\" flex-offset=\"5\"><label>Name</label><input ng-model=\"vm.currentChartItem.dataname\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Surface Level\n</label><md-select ng-model=\"vm.currentChartItem[\'flat\']\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n									   vm.runEquationDigest();\"><md-option value=\"zValues\">\nZ Values</md-option><md-option value=\"flat\">Flat</md-option></md-select></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Data</label><input \nng-model=\"vm.currentChartItem.xDataRaw\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n								  vm.currentChartItem.axisType=\'X\'; \n								  vm.currentChartItem.needsUpdateFlag=1; \n								  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Data</label>\n<input ng-model=\"vm.currentChartItem.yDataRaw\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n								  vm.currentChartItem.axisType=\'Y\'; \n								  vm.currentChartItem.needsUpdateFlag=1; \n								  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Data</label>\n<input ng-model=\"vm.currentChartItem.zDataRaw\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n								  vm.currentChartItem.axisType=\'Z\'; \n								  vm.currentChartItem.needsUpdateFlag=1; \n								  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Radius</label>\n<input ng-model=\"vm.currentChartItem[\'lineRadius\']\" ng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem ); \">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Radial Segments\n</label><input ng-model=\"vm.currentChartItem[\'lineRadSegs\']\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem ); \"></md-input-container></md-list-item><md-list-item>\n<md-input-container flex=\"90\" flex-offset=\"5\"><label>X Offset</label><input ng-model=\"vm.currentChartItem.xOffset\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n								  vm.currentChartItem.needsUpdateFlag=1; \n								  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Offset</label>\n<input ng-model=\"vm.currentChartItem.yOffset\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n								  vm.currentChartItem.needsUpdateFlag=1; \n								  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Offset</label>\n<input ng-model=\"vm.currentChartItem.zOffset\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n								  vm.currentChartItem.needsUpdateFlag=1; \n								  vm.runEquationDigest();\">\n</md-input-container></md-list-item>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/planeData.html","<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Data Type</label><md-select \nng-model=\"vm.currentChartItem[\'type\']\" ng-change=\"vm.reDrawItem( vm.currentItem, \'all\', 1 );\"><md-option \nvalue=\"surface\">Surface</md-option><md-option value=\"pointCloud\">Point Cloud</md-option><md-option value=\"line\">Line\n</md-option><md-option value=\"cube\">Cube</md-option><md-option value=\"icosahedron\">Icosahedron</md-option><md-option \nvalue=\"Dodecahedron\">Dodecahedron</md-option><md-option value=\"tetrahedron\">Tetrahedron</md-option><md-option \nvalue=\"octahedron\">Octahedron</md-option><md-option value=\"sphere\">Sphere</md-option><md-option value=\"cylinder\">\nCylinder</md-option><md-option value=\"torus\">Torus</md-option><md-option value=\"plane\">Plane</md-option><md-option \nvalue=\"lathe\">Lathe</md-option><md-option value=\"grid\">Grid</md-option><md-option value=\"axis\">Axis</md-option>\n<md-option value=\"arrow\">Arrow</md-option></md-select></md-input-container></md-list-item><md-list-item>\n<md-input-container flex=\"90\" flex-offset=\"5\"><label>Name</label><input ng-model=\"vm.currentChartItem.dataname\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Width</label>\n<input ng-model=\"vm.currentChartItem.width\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Height</label><input \nng-model=\"vm.currentChartItem.height\" ng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Width Segments\n</label><input ng-model=\"vm.currentChartItem.widthSegs\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Height Segments</label><input \nng-model=\"vm.currentChartItem.heightSegs\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Color</label><input \nng-model=\"vm.currentChartItem.color\" ng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Wire Color\n</label><input ng-model=\"vm.currentChartItem.wireColor\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Solid / Wireframe</label><md-select \nng-model=\"vm.currentChartItem[\'wireFrame\']\" ng-change=\"vm.reDrawItem( vm.currentItem, \'all\', 1 );\"><md-option \nvalue=\"Solid\">Solid</md-option><md-option value=\"Wireframe\">Wireframe</md-option></md-select></md-input-container>\n</md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Position</label><input \nng-model=\"vm.currentChartItem.xPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Position</label><input \nng-model=\"vm.currentChartItem.yPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Position</label><input \nng-model=\"vm.currentChartItem.zPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Rotation</label><input \nng-model=\"vm.currentChartItem.xRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Rotation</label><input \nng-model=\"vm.currentChartItem.yRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Rotation</label><input \nng-model=\"vm.currentChartItem.zRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/sphereData.html","<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Data Type</label><md-select \nng-model=\"vm.currentChartItem[\'type\']\" ng-change=\"vm.reDrawItem( vm.currentItem, \'all\', 1 );\"><md-option \nvalue=\"surface\">Surface</md-option><md-option value=\"pointCloud\">Point Cloud</md-option><md-option value=\"line\">Line\n</md-option><md-option value=\"cube\">Cube</md-option><md-option value=\"icosahedron\">Icosahedron</md-option><md-option \nvalue=\"Dodecahedron\">Dodecahedron</md-option><md-option value=\"tetrahedron\">Tetrahedron</md-option><md-option \nvalue=\"octahedron\">Octahedron</md-option><md-option value=\"sphere\">Sphere</md-option><md-option value=\"cylinder\">\nCylinder</md-option><md-option value=\"torus\">Torus</md-option><md-option value=\"plane\">Plane</md-option><md-option \nvalue=\"lathe\">Lathe</md-option><md-option value=\"grid\">Grid</md-option><md-option value=\"axis\">Axis</md-option>\n<md-option value=\"arrow\">Arrow</md-option></md-select></md-input-container></md-list-item><md-list-item>\n<md-input-container flex=\"90\" flex-offset=\"5\"><label>Name</label><input ng-model=\"vm.currentChartItem.dataname\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Radius</label>\n<input ng-model=\"vm.currentChartItem.radius\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Width Segments</label><input \nng-model=\"vm.currentChartItem.widthSegs\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Height Segments</label><input \nng-model=\"vm.currentChartItem.heightSegs\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Phi Start</label><input \nng-model=\"vm.currentChartItem.phiStart\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Phi Length</label><input \nng-model=\"vm.currentChartItem.phiLength\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Theta Start</label><input \nng-model=\"vm.currentChartItem.thetaStart\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Theta Length</label><input \nng-model=\"vm.currentChartItem.thetaLength\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Color</label><input \nng-model=\"vm.currentChartItem.color\" ng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Wire Color\n</label><input ng-model=\"vm.currentChartItem.wireColor\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Solid / Wireframe</label><md-select \nng-model=\"vm.currentChartItem[\'wireFrame\']\" ng-change=\"vm.reDrawItem( vm.currentItem, \'all\', 1 );\"><md-option \nvalue=\"Solid\">Solid</md-option><md-option value=\"Wireframe\">Wireframe</md-option></md-select></md-input-container>\n</md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Position</label><input \nng-model=\"vm.currentChartItem.xPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Position</label><input \nng-model=\"vm.currentChartItem.yPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Position</label><input \nng-model=\"vm.currentChartItem.zPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Rotation</label><input \nng-model=\"vm.currentChartItem.xRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Rotation</label><input \nng-model=\"vm.currentChartItem.yRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Rotation</label><input \nng-model=\"vm.currentChartItem.zRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/surfaceData.html","<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Data Type</label><md-select \nng-model=\"vm.currentChartItem[\'type\']\" ng-change=\"vm.reDrawItem( vm.currentItem, \'all\', 1 );\"><md-option \nvalue=\"surface\">Surface</md-option><md-option value=\"pointCloud\">Point Cloud</md-option><md-option value=\"line\">Line\n</md-option><md-option value=\"cube\">Cube</md-option><md-option value=\"icosahedron\">Icosahedron</md-option><md-option \nvalue=\"dodecahedron\">Dodecahedron</md-option><md-option value=\"tetrahedron\">Tetrahedron</md-option><md-option \nvalue=\"octahedron\">Octahedron</md-option><md-option value=\"sphere\">Sphere</md-option><md-option value=\"cylinder\">\nCylinder</md-option><md-option value=\"torus\">Torus</md-option><md-option value=\"plane\">Plane</md-option><md-option \nvalue=\"lathe\">Lathe</md-option><md-option value=\"grid\">Grid</md-option><md-option value=\"axis\">Axis</md-option>\n<md-option value=\"arrow\">Arrow</md-option></md-select></md-input-container></md-list-item><md-list-item>\n<md-input-container flex=\"90\" flex-offset=\"5\"><label>Name</label><input ng-model=\"vm.currentChartItem.dataname\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Surface Level\n</label><md-select ng-model=\"vm.currentChartItem[\'flat\']\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n									   vm.runEquationDigest();\"><md-option value=\"zValues\">\nZ Values</md-option><md-option value=\"flat\">Flat</md-option></md-select></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Data</label><input \nng-model=\"vm.currentChartItem.xDataRaw\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n								  vm.currentChartItem.axisType=\'X\'; \n								  vm.currentChartItem.needsUpdateFlag=1; \n								  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Data</label>\n<input ng-model=\"vm.currentChartItem.yDataRaw\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n								  vm.currentChartItem.axisType=\'Y\'; \n								  vm.currentChartItem.needsUpdateFlag=1; \n								  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Data</label>\n<input ng-model=\"vm.currentChartItem.zDataRaw\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n								  vm.currentChartItem.axisType=\'Z\'; \n								  vm.currentChartItem.needsUpdateFlag=1; \n								  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Color Data\n</label><input ng-model=\"vm.currentChartItem[\'cDataRaw\']\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n								  vm.currentChartItem.needsUpdateFlag=1; \n								  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Colors</label>\n<md-select ng-model=\"vm.currentChartItem[\'useColorData\']\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n									   vm.runEquationDigest();\"><md-option value=\"zValues\">\nZ Values</md-option><md-option value=\"colorValues\">Color Values</md-option></md-select></md-input-container>\n</md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Surface Lines</label><md-select \nng-model=\"vm.currentChartItem.showLines\" \nng-change=\"vm.currentChartItem.needsUpdateFlag=1; \n									   vm.runEquationDigest();\"><md-option value=\"true\">On\n</md-option><md-option value=\"false\">Off</md-option></md-select></md-input-container></md-list-item><md-list-item>\n<md-input-container flex=\"90\" flex-offset=\"5\"><label>X Offset</label><input ng-model=\"vm.currentChartItem.xOffset\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n								  vm.currentChartItem.needsUpdateFlag=1; \n								  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Offset</label>\n<input ng-model=\"vm.currentChartItem.yOffset\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n								  vm.currentChartItem.needsUpdateFlag=1; \n								  vm.runEquationDigest();\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Offset</label>\n<input ng-model=\"vm.currentChartItem.zOffset\" \nng-enter=\"vm.currentChartItem.solveType=\'all\'; \n								  vm.currentChartItem.needsUpdateFlag=1; \n								  vm.runEquationDigest();\">\n</md-input-container></md-list-item>");
$templateCache.put("app/main/apps/document/worksheet/views/templates/chartSpecVer/chartData/torusData.html","<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Data Type</label><md-select \nng-model=\"vm.currentChartItem[\'type\']\" ng-change=\"vm.reDrawItem( vm.currentItem, \'all\', 1 );\"><md-option \nvalue=\"surface\">Surface</md-option><md-option value=\"pointCloud\">Point Cloud</md-option><md-option value=\"line\">Line\n</md-option><md-option value=\"cube\">Cube</md-option><md-option value=\"icosahedron\">Icosahedron</md-option><md-option \nvalue=\"Dodecahedron\">Dodecahedron</md-option><md-option value=\"tetrahedron\">Tetrahedron</md-option><md-option \nvalue=\"octahedron\">Octahedron</md-option><md-option value=\"sphere\">Sphere</md-option><md-option value=\"cylinder\">\nCylinder</md-option><md-option value=\"torus\">Torus</md-option><md-option value=\"plane\">Plane</md-option><md-option \nvalue=\"lathe\">Lathe</md-option><md-option value=\"grid\">Grid</md-option><md-option value=\"axis\">Axis</md-option>\n<md-option value=\"arrow\">Arrow</md-option></md-select></md-input-container></md-list-item><md-list-item>\n<md-input-container flex=\"90\" flex-offset=\"5\"><label>Name</label><input ng-model=\"vm.currentChartItem.dataname\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Torus Radius\n</label><input ng-model=\"vm.currentChartItem.radius\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Tubular Diameter</label><input \nng-model=\"vm.currentChartItem.tubeDiameter\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Radial Segments</label><input \nng-model=\"vm.currentChartItem.radSegs\" ng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Tubular Segments\n</label><input ng-model=\"vm.currentChartItem.tubeSegs\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Arc</label><input \nng-model=\"vm.currentChartItem.arc\" ng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\">\n</md-input-container></md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Color</label>\n<input ng-model=\"vm.currentChartItem.color\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Wire Color</label><input \nng-model=\"vm.currentChartItem.wireColor\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Solid / Wireframe</label><md-select \nng-model=\"vm.currentChartItem[\'wireFrame\']\" ng-change=\"vm.reDrawItem( vm.currentItem, \'all\', 1 );\"><md-option \nvalue=\"Solid\">Solid</md-option><md-option value=\"Wireframe\">Wireframe</md-option></md-select></md-input-container>\n</md-list-item><md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Position</label><input \nng-model=\"vm.currentChartItem.xPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Position</label><input \nng-model=\"vm.currentChartItem.yPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Position</label><input \nng-model=\"vm.currentChartItem.zPosition\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>X Rotation</label><input \nng-model=\"vm.currentChartItem.xRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Y Rotation</label><input \nng-model=\"vm.currentChartItem.yRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>\n<md-list-item><md-input-container flex=\"90\" flex-offset=\"5\"><label>Z Rotation</label><input \nng-model=\"vm.currentChartItem.zRotation\" \nng-enter=\"vm.reDrawItem( vm.currentItem, vm.currentChartItem[\'Format_id\'], 1 )\"></md-input-container></md-list-item>");}]);